import { a as __require, r as __export, s as __toESM, t as __commonJSMin } from "./rolldown-runtime-Bg48TavK.es.js";
import { a as init_dist$1, i as global, n as init_dist, r as process$1$1 } from "./jszip-C49i9kUs.es.js";
import { t as require_lib } from "./xml-js-CqGKpaft.es.js";
import { n as v4_default, t as v5_default } from "./uuid-B2wVPhPi.es.js";
import { A as pointsToTwips$1, B as twipsToPt, C as inchesToTwips, D as objToPolygon, E as normalizeHexColor, F as rgbToHex$1, G as UrlValidationConstants, H as getFallbackImageNameFromDataUri, I as rotToDegrees, L as twipsToInches, M as ptToTwips, N as resolveOpcTargetPath, O as pixelsToEmu, P as resolveShadingFillColor, R as twipsToLines, T as linesToTwips, U as sanitizeDocxMediaName, V as getDataUriMetadata, W as tryDecodeDataUriText, X as sanitizeHref, Y as isValidImageDataUrl, a as HEADER_RELATIONSHIP_TYPE$1, c as computeCrc32Hex, d as degreesToRot, f as deobfuscateFont, g as getArrayBufferFromUrl, h as emuToPixels, i as FOOTER_RELATIONSHIP_TYPE$1, j as polygonToObj, k as pixelsToTwips$1, m as eighthPointsToPixels, n as COMMENT_RELATIONSHIP_TYPES, o as HYPERLINK_RELATIONSHIP_TYPE, r as DEFAULT_XML_DECLARATION, s as base64ToUint8Array, t as COMMENT_FILE_BASENAMES, u as dataUriToArrayBuffer, v as getDocxHighlightKeywordFromHex, w as isValidHexColor, x as halfPointToPoints, y as getHexColorFromDocxSystem, z as twipsToPixels$2 } from "./constants-D9qj59G2.es.js";
import { t as Buffer } from "./dist-B8HfvhaK.es.js";
import { t as unified } from "./unified-Dsuw2be5.es.js";
import { r as stringifyPosition } from "./lib-CYqLdG4z.es.js";
import { s as toString } from "./lib-DEff_P2k.es.js";
import { n as decodeNumericCharacterReference, r as decodeNamedCharacterReference, t as decodeString } from "./micromark-util-decode-string-CHF-vL9A.es.js";
import { a as normalizeIdentifier, c as splice, i as factorySpace, n as blankLine, o as combineExtensions, r as resolveAll, s as push, t as remarkGfm } from "./remark-gfm-BhnWr3yf.es.js";
import { c as asciiAlphanumeric, d as asciiDigit, f as asciiHexDigit, g as markdownSpace, h as markdownLineEndingOrSpace, l as asciiAtext, m as markdownLineEnding, o as classifyCharacter, p as asciiPunctuation, s as asciiAlpha, u as asciiControl } from "./handle-DaMysrzA.es.js";
function getExtensionConfigField(extension$1, field, context = { name: "" }) {
	const fieldValue = extension$1.config[field];
	if (typeof fieldValue === "function") return fieldValue.bind({ ...context });
	return fieldValue;
}
function callOrGet(value, context = null, ...props) {
	if (typeof value === "function") {
		const fn = value;
		if (context) return fn.bind(context)(...props);
		return fn(...props);
	}
	return value;
}
function isEmptyObject(value = {}) {
	return Object.keys(value).length === 0 && value.constructor === Object;
}
const isRegExp = (value) => {
	return Object.prototype.toString.call(value) === "[object RegExp]";
};
function objectIncludes(obj1, obj2, options = { strict: true }) {
	const keys$1 = Object.keys(obj2);
	if (!keys$1.length) return true;
	return keys$1.every((key) => {
		if (options.strict) return obj2[key] === obj1[key];
		if (isRegExp(obj2[key])) return obj2[key].test(obj1[key]);
		return obj2[key] === obj1[key];
	});
}
function minMax(value = 0, min = 0, max = 0) {
	return Math.min(Math.max(value, min), max);
}
function OrderedMap(content$2) {
	this.content = content$2;
}
OrderedMap.prototype = {
	constructor: OrderedMap,
	find: function(key) {
		for (var i$1 = 0; i$1 < this.content.length; i$1 += 2) if (this.content[i$1] === key) return i$1;
		return -1;
	},
	get: function(key) {
		var found$1 = this.find(key);
		return found$1 == -1 ? void 0 : this.content[found$1 + 1];
	},
	update: function(key, value, newKey) {
		var self$1 = newKey && newKey != key ? this.remove(newKey) : this;
		var found$1 = self$1.find(key), content$2 = self$1.content.slice();
		if (found$1 == -1) content$2.push(newKey || key, value);
		else {
			content$2[found$1 + 1] = value;
			if (newKey) content$2[found$1] = newKey;
		}
		return new OrderedMap(content$2);
	},
	remove: function(key) {
		var found$1 = this.find(key);
		if (found$1 == -1) return this;
		var content$2 = this.content.slice();
		content$2.splice(found$1, 2);
		return new OrderedMap(content$2);
	},
	addToStart: function(key, value) {
		return new OrderedMap([key, value].concat(this.remove(key).content));
	},
	addToEnd: function(key, value) {
		var content$2 = this.remove(key).content.slice();
		content$2.push(key, value);
		return new OrderedMap(content$2);
	},
	addBefore: function(place, key, value) {
		var without = this.remove(key), content$2 = without.content.slice();
		var found$1 = without.find(place);
		content$2.splice(found$1 == -1 ? content$2.length : found$1, 0, key, value);
		return new OrderedMap(content$2);
	},
	forEach: function(f) {
		for (var i$1 = 0; i$1 < this.content.length; i$1 += 2) f(this.content[i$1], this.content[i$1 + 1]);
	},
	prepend: function(map) {
		map = OrderedMap.from(map);
		if (!map.size) return this;
		return new OrderedMap(map.content.concat(this.subtract(map).content));
	},
	append: function(map) {
		map = OrderedMap.from(map);
		if (!map.size) return this;
		return new OrderedMap(this.subtract(map).content.concat(map.content));
	},
	subtract: function(map) {
		var result = this;
		map = OrderedMap.from(map);
		for (var i$1 = 0; i$1 < map.content.length; i$1 += 2) result = result.remove(map.content[i$1]);
		return result;
	},
	toObject: function() {
		var result = {};
		this.forEach(function(key, value) {
			result[key] = value;
		});
		return result;
	},
	get size() {
		return this.content.length >> 1;
	}
};
OrderedMap.from = function(value) {
	if (value instanceof OrderedMap) return value;
	var content$2 = [];
	if (value) for (var prop in value) content$2.push(prop, value[prop]);
	return new OrderedMap(content$2);
};
var dist_default$1 = OrderedMap;
function findDiffStart(a, b, pos) {
	for (let i$1 = 0;; i$1++) {
		if (i$1 == a.childCount || i$1 == b.childCount) return a.childCount == b.childCount ? null : pos;
		let childA = a.child(i$1), childB = b.child(i$1);
		if (childA == childB) {
			pos += childA.nodeSize;
			continue;
		}
		if (!childA.sameMarkup(childB)) return pos;
		if (childA.isText && childA.text != childB.text) {
			for (let j = 0; childA.text[j] == childB.text[j]; j++) pos++;
			return pos;
		}
		if (childA.content.size || childB.content.size) {
			let inner = findDiffStart(childA.content, childB.content, pos + 1);
			if (inner != null) return inner;
		}
		pos += childA.nodeSize;
	}
}
function findDiffEnd(a, b, posA, posB) {
	for (let iA = a.childCount, iB = b.childCount;;) {
		if (iA == 0 || iB == 0) return iA == iB ? null : {
			a: posA,
			b: posB
		};
		let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
		if (childA == childB) {
			posA -= size;
			posB -= size;
			continue;
		}
		if (!childA.sameMarkup(childB)) return {
			a: posA,
			b: posB
		};
		if (childA.isText && childA.text != childB.text) {
			let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
			while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
				same++;
				posA--;
				posB--;
			}
			return {
				a: posA,
				b: posB
			};
		}
		if (childA.content.size || childB.content.size) {
			let inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
			if (inner) return inner;
		}
		posA -= size;
		posB -= size;
	}
}
var Fragment = class Fragment {
	constructor(content$2, size) {
		this.content = content$2;
		this.size = size || 0;
		if (size == null) for (let i$1 = 0; i$1 < content$2.length; i$1++) this.size += content$2[i$1].nodeSize;
	}
	nodesBetween(from, to, f, nodeStart = 0, parent) {
		for (let i$1 = 0, pos = 0; pos < to; i$1++) {
			let child = this.content[i$1], end = pos + child.nodeSize;
			if (end > from && f(child, nodeStart + pos, parent || null, i$1) !== false && child.content.size) {
				let start = pos + 1;
				child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
			}
			pos = end;
		}
	}
	descendants(f) {
		this.nodesBetween(0, this.size, f);
	}
	textBetween(from, to, blockSeparator, leafText) {
		let text$2 = "", first = true;
		this.nodesBetween(from, to, (node, pos) => {
			let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
			if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) if (first) first = false;
			else text$2 += blockSeparator;
			text$2 += nodeText;
		}, 0);
		return text$2;
	}
	append(other) {
		if (!other.size) return this;
		if (!this.size) return other;
		let last = this.lastChild, first = other.firstChild, content$2 = this.content.slice(), i$1 = 0;
		if (last.isText && last.sameMarkup(first)) {
			content$2[content$2.length - 1] = last.withText(last.text + first.text);
			i$1 = 1;
		}
		for (; i$1 < other.content.length; i$1++) content$2.push(other.content[i$1]);
		return new Fragment(content$2, this.size + other.size);
	}
	cut(from, to = this.size) {
		if (from == 0 && to == this.size) return this;
		let result = [], size = 0;
		if (to > from) for (let i$1 = 0, pos = 0; pos < to; i$1++) {
			let child = this.content[i$1], end = pos + child.nodeSize;
			if (end > from) {
				if (pos < from || end > to) if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
				else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
				result.push(child);
				size += child.nodeSize;
			}
			pos = end;
		}
		return new Fragment(result, size);
	}
	cutByIndex(from, to) {
		if (from == to) return Fragment.empty;
		if (from == 0 && to == this.content.length) return this;
		return new Fragment(this.content.slice(from, to));
	}
	replaceChild(index, node) {
		let current = this.content[index];
		if (current == node) return this;
		let copy$1 = this.content.slice();
		let size = this.size + node.nodeSize - current.nodeSize;
		copy$1[index] = node;
		return new Fragment(copy$1, size);
	}
	addToStart(node) {
		return new Fragment([node].concat(this.content), this.size + node.nodeSize);
	}
	addToEnd(node) {
		return new Fragment(this.content.concat(node), this.size + node.nodeSize);
	}
	eq(other) {
		if (this.content.length != other.content.length) return false;
		for (let i$1 = 0; i$1 < this.content.length; i$1++) if (!this.content[i$1].eq(other.content[i$1])) return false;
		return true;
	}
	get firstChild() {
		return this.content.length ? this.content[0] : null;
	}
	get lastChild() {
		return this.content.length ? this.content[this.content.length - 1] : null;
	}
	get childCount() {
		return this.content.length;
	}
	child(index) {
		let found$1 = this.content[index];
		if (!found$1) throw new RangeError("Index " + index + " out of range for " + this);
		return found$1;
	}
	maybeChild(index) {
		return this.content[index] || null;
	}
	forEach(f) {
		for (let i$1 = 0, p = 0; i$1 < this.content.length; i$1++) {
			let child = this.content[i$1];
			f(child, p, i$1);
			p += child.nodeSize;
		}
	}
	findDiffStart(other, pos = 0) {
		return findDiffStart(this, other, pos);
	}
	findDiffEnd(other, pos = this.size, otherPos = other.size) {
		return findDiffEnd(this, other, pos, otherPos);
	}
	findIndex(pos) {
		if (pos == 0) return retIndex(0, pos);
		if (pos == this.size) return retIndex(this.content.length, pos);
		if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
		for (let i$1 = 0, curPos = 0;; i$1++) {
			let cur = this.child(i$1), end = curPos + cur.nodeSize;
			if (end >= pos) {
				if (end == pos) return retIndex(i$1 + 1, end);
				return retIndex(i$1, curPos);
			}
			curPos = end;
		}
	}
	toString() {
		return "<" + this.toStringInner() + ">";
	}
	toStringInner() {
		return this.content.join(", ");
	}
	toJSON() {
		return this.content.length ? this.content.map((n) => n.toJSON()) : null;
	}
	static fromJSON(schema, value) {
		if (!value) return Fragment.empty;
		if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
		return new Fragment(value.map(schema.nodeFromJSON));
	}
	static fromArray(array) {
		if (!array.length) return Fragment.empty;
		let joined, size = 0;
		for (let i$1 = 0; i$1 < array.length; i$1++) {
			let node = array[i$1];
			size += node.nodeSize;
			if (i$1 && node.isText && array[i$1 - 1].sameMarkup(node)) {
				if (!joined) joined = array.slice(0, i$1);
				joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
			} else if (joined) joined.push(node);
		}
		return new Fragment(joined || array, size);
	}
	static from(nodes) {
		if (!nodes) return Fragment.empty;
		if (nodes instanceof Fragment) return nodes;
		if (Array.isArray(nodes)) return this.fromArray(nodes);
		if (nodes.attrs) return new Fragment([nodes], nodes.nodeSize);
		throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
	}
};
Fragment.empty = new Fragment([], 0);
var found = {
	index: 0,
	offset: 0
};
function retIndex(index, offset) {
	found.index = index;
	found.offset = offset;
	return found;
}
function compareDeep(a, b) {
	if (a === b) return true;
	if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
	let array = Array.isArray(a);
	if (Array.isArray(b) != array) return false;
	if (array) {
		if (a.length != b.length) return false;
		for (let i$1 = 0; i$1 < a.length; i$1++) if (!compareDeep(a[i$1], b[i$1])) return false;
	} else {
		for (let p in a) if (!(p in b) || !compareDeep(a[p], b[p])) return false;
		for (let p in b) if (!(p in a)) return false;
	}
	return true;
}
var Mark = class Mark {
	constructor(type, attrs) {
		this.type = type;
		this.attrs = attrs;
	}
	addToSet(set) {
		let copy$1, placed = false;
		for (let i$1 = 0; i$1 < set.length; i$1++) {
			let other = set[i$1];
			if (this.eq(other)) return set;
			if (this.type.excludes(other.type)) {
				if (!copy$1) copy$1 = set.slice(0, i$1);
			} else if (other.type.excludes(this.type)) return set;
			else {
				if (!placed && other.type.rank > this.type.rank) {
					if (!copy$1) copy$1 = set.slice(0, i$1);
					copy$1.push(this);
					placed = true;
				}
				if (copy$1) copy$1.push(other);
			}
		}
		if (!copy$1) copy$1 = set.slice();
		if (!placed) copy$1.push(this);
		return copy$1;
	}
	removeFromSet(set) {
		for (let i$1 = 0; i$1 < set.length; i$1++) if (this.eq(set[i$1])) return set.slice(0, i$1).concat(set.slice(i$1 + 1));
		return set;
	}
	isInSet(set) {
		for (let i$1 = 0; i$1 < set.length; i$1++) if (this.eq(set[i$1])) return true;
		return false;
	}
	eq(other) {
		return this == other || this.type == other.type && compareDeep(this.attrs, other.attrs);
	}
	toJSON() {
		let obj = { type: this.type.name };
		for (let _ in this.attrs) {
			obj.attrs = this.attrs;
			break;
		}
		return obj;
	}
	static fromJSON(schema, json) {
		if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
		let type = schema.marks[json.type];
		if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
		let mark = type.create(json.attrs);
		type.checkAttrs(mark.attrs);
		return mark;
	}
	static sameSet(a, b) {
		if (a == b) return true;
		if (a.length != b.length) return false;
		for (let i$1 = 0; i$1 < a.length; i$1++) if (!a[i$1].eq(b[i$1])) return false;
		return true;
	}
	static setFrom(marks) {
		if (!marks || Array.isArray(marks) && marks.length == 0) return Mark.none;
		if (marks instanceof Mark) return [marks];
		let copy$1 = marks.slice();
		copy$1.sort((a, b) => a.type.rank - b.type.rank);
		return copy$1;
	}
};
Mark.none = [];
var ReplaceError = class extends Error {};
var Slice = class Slice {
	constructor(content$2, openStart, openEnd) {
		this.content = content$2;
		this.openStart = openStart;
		this.openEnd = openEnd;
	}
	get size() {
		return this.content.size - this.openStart - this.openEnd;
	}
	insertAt(pos, fragment) {
		let content$2 = insertInto(this.content, pos + this.openStart, fragment);
		return content$2 && new Slice(content$2, this.openStart, this.openEnd);
	}
	removeBetween(from, to) {
		return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
	}
	eq(other) {
		return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
	}
	toString() {
		return this.content + "(" + this.openStart + "," + this.openEnd + ")";
	}
	toJSON() {
		if (!this.content.size) return null;
		let json = { content: this.content.toJSON() };
		if (this.openStart > 0) json.openStart = this.openStart;
		if (this.openEnd > 0) json.openEnd = this.openEnd;
		return json;
	}
	static fromJSON(schema, json) {
		if (!json) return Slice.empty;
		let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
		if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
		return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd);
	}
	static maxOpen(fragment, openIsolating = true) {
		let openStart = 0, openEnd = 0;
		for (let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) openStart++;
		for (let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild) openEnd++;
		return new Slice(fragment, openStart, openEnd);
	}
};
Slice.empty = new Slice(Fragment.empty, 0, 0);
function removeRange(content$2, from, to) {
	let { index, offset } = content$2.findIndex(from), child = content$2.maybeChild(index);
	let { index: indexTo, offset: offsetTo } = content$2.findIndex(to);
	if (offset == from || child.isText) {
		if (offsetTo != to && !content$2.child(indexTo).isText) throw new RangeError("Removing non-flat range");
		return content$2.cut(0, from).append(content$2.cut(to));
	}
	if (index != indexTo) throw new RangeError("Removing non-flat range");
	return content$2.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function insertInto(content$2, dist, insert, parent) {
	let { index, offset } = content$2.findIndex(dist), child = content$2.maybeChild(index);
	if (offset == dist || child.isText) {
		if (parent && !parent.canReplace(index, index, insert)) return null;
		return content$2.cut(0, dist).append(insert).append(content$2.cut(dist));
	}
	let inner = insertInto(child.content, dist - offset - 1, insert, child);
	return inner && content$2.replaceChild(index, child.copy(inner));
}
function replace($from, $to, slice) {
	if (slice.openStart > $from.depth) throw new ReplaceError("Inserted content deeper than insertion position");
	if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new ReplaceError("Inconsistent open depths");
	return replaceOuter($from, $to, slice, 0);
}
function replaceOuter($from, $to, slice, depth) {
	let index = $from.index(depth), node = $from.node(depth);
	if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
		let inner = replaceOuter($from, $to, slice, depth + 1);
		return node.copy(node.content.replaceChild(index, inner));
	} else if (!slice.content.size) return close(node, replaceTwoWay($from, $to, depth));
	else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
		let parent = $from.parent, content$2 = parent.content;
		return close(parent, content$2.cut(0, $from.parentOffset).append(slice.content).append(content$2.cut($to.parentOffset)));
	} else {
		let { start, end } = prepareSliceForReplace(slice, $from);
		return close(node, replaceThreeWay($from, start, end, $to, depth));
	}
}
function checkJoin(main, sub) {
	if (!sub.type.compatibleContent(main.type)) throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function joinable$1($before, $after, depth) {
	let node = $before.node(depth);
	checkJoin(node, $after.node(depth));
	return node;
}
function addNode(child, target) {
	let last = target.length - 1;
	if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
	else target.push(child);
}
function addRange($start, $end, depth, target) {
	let node = ($end || $start).node(depth);
	let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
	if ($start) {
		startIndex = $start.index(depth);
		if ($start.depth > depth) startIndex++;
		else if ($start.textOffset) {
			addNode($start.nodeAfter, target);
			startIndex++;
		}
	}
	for (let i$1 = startIndex; i$1 < endIndex; i$1++) addNode(node.child(i$1), target);
	if ($end && $end.depth == depth && $end.textOffset) addNode($end.nodeBefore, target);
}
function close(node, content$2) {
	node.type.checkContent(content$2);
	return node.copy(content$2);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
	let openStart = $from.depth > depth && joinable$1($from, $start, depth + 1);
	let openEnd = $to.depth > depth && joinable$1($end, $to, depth + 1);
	let content$2 = [];
	addRange(null, $from, depth, content$2);
	if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
		checkJoin(openStart, openEnd);
		addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content$2);
	} else {
		if (openStart) addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content$2);
		addRange($start, $end, depth, content$2);
		if (openEnd) addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content$2);
	}
	addRange($to, null, depth, content$2);
	return new Fragment(content$2);
}
function replaceTwoWay($from, $to, depth) {
	let content$2 = [];
	addRange(null, $from, depth, content$2);
	if ($from.depth > depth) addNode(close(joinable$1($from, $to, depth + 1), replaceTwoWay($from, $to, depth + 1)), content$2);
	addRange($to, null, depth, content$2);
	return new Fragment(content$2);
}
function prepareSliceForReplace(slice, $along) {
	let extra = $along.depth - slice.openStart;
	let node = $along.node(extra).copy(slice.content);
	for (let i$1 = extra - 1; i$1 >= 0; i$1--) node = $along.node(i$1).copy(Fragment.from(node));
	return {
		start: node.resolveNoCache(slice.openStart + extra),
		end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
	};
}
var ResolvedPos = class ResolvedPos {
	constructor(pos, path, parentOffset) {
		this.pos = pos;
		this.path = path;
		this.parentOffset = parentOffset;
		this.depth = path.length / 3 - 1;
	}
	resolveDepth(val) {
		if (val == null) return this.depth;
		if (val < 0) return this.depth + val;
		return val;
	}
	get parent() {
		return this.node(this.depth);
	}
	get doc() {
		return this.node(0);
	}
	node(depth) {
		return this.path[this.resolveDepth(depth) * 3];
	}
	index(depth) {
		return this.path[this.resolveDepth(depth) * 3 + 1];
	}
	indexAfter(depth) {
		depth = this.resolveDepth(depth);
		return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
	}
	start(depth) {
		depth = this.resolveDepth(depth);
		return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
	}
	end(depth) {
		depth = this.resolveDepth(depth);
		return this.start(depth) + this.node(depth).content.size;
	}
	before(depth) {
		depth = this.resolveDepth(depth);
		if (!depth) throw new RangeError("There is no position before the top-level node");
		return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
	}
	after(depth) {
		depth = this.resolveDepth(depth);
		if (!depth) throw new RangeError("There is no position after the top-level node");
		return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
	}
	get textOffset() {
		return this.pos - this.path[this.path.length - 1];
	}
	get nodeAfter() {
		let parent = this.parent, index = this.index(this.depth);
		if (index == parent.childCount) return null;
		let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
		return dOff ? parent.child(index).cut(dOff) : child;
	}
	get nodeBefore() {
		let index = this.index(this.depth);
		let dOff = this.pos - this.path[this.path.length - 1];
		if (dOff) return this.parent.child(index).cut(0, dOff);
		return index == 0 ? null : this.parent.child(index - 1);
	}
	posAtIndex(index, depth) {
		depth = this.resolveDepth(depth);
		let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
		for (let i$1 = 0; i$1 < index; i$1++) pos += node.child(i$1).nodeSize;
		return pos;
	}
	marks() {
		let parent = this.parent, index = this.index();
		if (parent.content.size == 0) return Mark.none;
		if (this.textOffset) return parent.child(index).marks;
		let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
		if (!main) {
			let tmp = main;
			main = other;
			other = tmp;
		}
		let marks = main.marks;
		for (var i$1 = 0; i$1 < marks.length; i$1++) if (marks[i$1].type.spec.inclusive === false && (!other || !marks[i$1].isInSet(other.marks))) marks = marks[i$1--].removeFromSet(marks);
		return marks;
	}
	marksAcross($end) {
		let after = this.parent.maybeChild(this.index());
		if (!after || !after.isInline) return null;
		let marks = after.marks, next = $end.parent.maybeChild($end.index());
		for (var i$1 = 0; i$1 < marks.length; i$1++) if (marks[i$1].type.spec.inclusive === false && (!next || !marks[i$1].isInSet(next.marks))) marks = marks[i$1--].removeFromSet(marks);
		return marks;
	}
	sharedDepth(pos) {
		for (let depth = this.depth; depth > 0; depth--) if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
		return 0;
	}
	blockRange(other = this, pred) {
		if (other.pos < this.pos) return other.blockRange(this);
		for (let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--) if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new NodeRange(this, other, d);
		return null;
	}
	sameParent(other) {
		return this.pos - this.parentOffset == other.pos - other.parentOffset;
	}
	max(other) {
		return other.pos > this.pos ? other : this;
	}
	min(other) {
		return other.pos < this.pos ? other : this;
	}
	toString() {
		let str = "";
		for (let i$1 = 1; i$1 <= this.depth; i$1++) str += (str ? "/" : "") + this.node(i$1).type.name + "_" + this.index(i$1 - 1);
		return str + ":" + this.parentOffset;
	}
	static resolve(doc$2, pos) {
		if (!(pos >= 0 && pos <= doc$2.content.size)) throw new RangeError("Position " + pos + " out of range");
		let path = [];
		let start = 0, parentOffset = pos;
		for (let node = doc$2;;) {
			let { index, offset } = node.content.findIndex(parentOffset);
			let rem = parentOffset - offset;
			path.push(node, index, start + offset);
			if (!rem) break;
			node = node.child(index);
			if (node.isText) break;
			parentOffset = rem - 1;
			start += offset + 1;
		}
		return new ResolvedPos(pos, path, parentOffset);
	}
	static resolveCached(doc$2, pos) {
		let cache = resolveCache.get(doc$2);
		if (cache) for (let i$1 = 0; i$1 < cache.elts.length; i$1++) {
			let elt = cache.elts[i$1];
			if (elt.pos == pos) return elt;
		}
		else resolveCache.set(doc$2, cache = new ResolveCache());
		let result = cache.elts[cache.i] = ResolvedPos.resolve(doc$2, pos);
		cache.i = (cache.i + 1) % resolveCacheSize;
		return result;
	}
};
var ResolveCache = class {
	constructor() {
		this.elts = [];
		this.i = 0;
	}
};
var resolveCacheSize = 12, resolveCache = /* @__PURE__ */ new WeakMap();
var NodeRange = class {
	constructor($from, $to, depth) {
		this.$from = $from;
		this.$to = $to;
		this.depth = depth;
	}
	get start() {
		return this.$from.before(this.depth + 1);
	}
	get end() {
		return this.$to.after(this.depth + 1);
	}
	get parent() {
		return this.$from.node(this.depth);
	}
	get startIndex() {
		return this.$from.index(this.depth);
	}
	get endIndex() {
		return this.$to.indexAfter(this.depth);
	}
};
var emptyAttrs = Object.create(null);
var Node$1 = class Node$1 {
	constructor(type, attrs, content$2, marks = Mark.none) {
		this.type = type;
		this.attrs = attrs;
		this.marks = marks;
		this.content = content$2 || Fragment.empty;
	}
	get children() {
		return this.content.content;
	}
	get nodeSize() {
		return this.isLeaf ? 1 : 2 + this.content.size;
	}
	get childCount() {
		return this.content.childCount;
	}
	child(index) {
		return this.content.child(index);
	}
	maybeChild(index) {
		return this.content.maybeChild(index);
	}
	forEach(f) {
		this.content.forEach(f);
	}
	nodesBetween(from, to, f, startPos = 0) {
		this.content.nodesBetween(from, to, f, startPos, this);
	}
	descendants(f) {
		this.nodesBetween(0, this.content.size, f);
	}
	get textContent() {
		return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
	}
	textBetween(from, to, blockSeparator, leafText) {
		return this.content.textBetween(from, to, blockSeparator, leafText);
	}
	get firstChild() {
		return this.content.firstChild;
	}
	get lastChild() {
		return this.content.lastChild;
	}
	eq(other) {
		return this == other || this.sameMarkup(other) && this.content.eq(other.content);
	}
	sameMarkup(other) {
		return this.hasMarkup(other.type, other.attrs, other.marks);
	}
	hasMarkup(type, attrs, marks) {
		return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark.sameSet(this.marks, marks || Mark.none);
	}
	copy(content$2 = null) {
		if (content$2 == this.content) return this;
		return new Node$1(this.type, this.attrs, content$2, this.marks);
	}
	mark(marks) {
		return marks == this.marks ? this : new Node$1(this.type, this.attrs, this.content, marks);
	}
	cut(from, to = this.content.size) {
		if (from == 0 && to == this.content.size) return this;
		return this.copy(this.content.cut(from, to));
	}
	slice(from, to = this.content.size, includeParents = false) {
		if (from == to) return Slice.empty;
		let $from = this.resolve(from), $to = this.resolve(to);
		let depth = includeParents ? 0 : $from.sharedDepth(to);
		let start = $from.start(depth);
		return new Slice($from.node(depth).content.cut($from.pos - start, $to.pos - start), $from.depth - depth, $to.depth - depth);
	}
	replace(from, to, slice) {
		return replace(this.resolve(from), this.resolve(to), slice);
	}
	nodeAt(pos) {
		for (let node = this;;) {
			let { index, offset } = node.content.findIndex(pos);
			node = node.maybeChild(index);
			if (!node) return null;
			if (offset == pos || node.isText) return node;
			pos -= offset + 1;
		}
	}
	childAfter(pos) {
		let { index, offset } = this.content.findIndex(pos);
		return {
			node: this.content.maybeChild(index),
			index,
			offset
		};
	}
	childBefore(pos) {
		if (pos == 0) return {
			node: null,
			index: 0,
			offset: 0
		};
		let { index, offset } = this.content.findIndex(pos);
		if (offset < pos) return {
			node: this.content.child(index),
			index,
			offset
		};
		let node = this.content.child(index - 1);
		return {
			node,
			index: index - 1,
			offset: offset - node.nodeSize
		};
	}
	resolve(pos) {
		return ResolvedPos.resolveCached(this, pos);
	}
	resolveNoCache(pos) {
		return ResolvedPos.resolve(this, pos);
	}
	rangeHasMark(from, to, type) {
		let found$1 = false;
		if (to > from) this.nodesBetween(from, to, (node) => {
			if (type.isInSet(node.marks)) found$1 = true;
			return !found$1;
		});
		return found$1;
	}
	get isBlock() {
		return this.type.isBlock;
	}
	get isTextblock() {
		return this.type.isTextblock;
	}
	get inlineContent() {
		return this.type.inlineContent;
	}
	get isInline() {
		return this.type.isInline;
	}
	get isText() {
		return this.type.isText;
	}
	get isLeaf() {
		return this.type.isLeaf;
	}
	get isAtom() {
		return this.type.isAtom;
	}
	toString() {
		if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
		let name = this.type.name;
		if (this.content.size) name += "(" + this.content.toStringInner() + ")";
		return wrapMarks(this.marks, name);
	}
	contentMatchAt(index) {
		let match = this.type.contentMatch.matchFragment(this.content, 0, index);
		if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
		return match;
	}
	canReplace(from, to, replacement = Fragment.empty, start = 0, end = replacement.childCount) {
		let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
		let two = one && one.matchFragment(this.content, to);
		if (!two || !two.validEnd) return false;
		for (let i$1 = start; i$1 < end; i$1++) if (!this.type.allowsMarks(replacement.child(i$1).marks)) return false;
		return true;
	}
	canReplaceWith(from, to, type, marks) {
		if (marks && !this.type.allowsMarks(marks)) return false;
		let start = this.contentMatchAt(from).matchType(type);
		let end = start && start.matchFragment(this.content, to);
		return end ? end.validEnd : false;
	}
	canAppend(other) {
		if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
		else return this.type.compatibleContent(other.type);
	}
	check() {
		this.type.checkContent(this.content);
		this.type.checkAttrs(this.attrs);
		let copy$1 = Mark.none;
		for (let i$1 = 0; i$1 < this.marks.length; i$1++) {
			let mark = this.marks[i$1];
			mark.type.checkAttrs(mark.attrs);
			copy$1 = mark.addToSet(copy$1);
		}
		if (!Mark.sameSet(copy$1, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m) => m.type.name)}`);
		this.content.forEach((node) => node.check());
	}
	toJSON() {
		let obj = { type: this.type.name };
		for (let _ in this.attrs) {
			obj.attrs = this.attrs;
			break;
		}
		if (this.content.size) obj.content = this.content.toJSON();
		if (this.marks.length) obj.marks = this.marks.map((n) => n.toJSON());
		return obj;
	}
	static fromJSON(schema, json) {
		if (!json) throw new RangeError("Invalid input for Node.fromJSON");
		let marks = void 0;
		if (json.marks) {
			if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
			marks = json.marks.map(schema.markFromJSON);
		}
		if (json.type == "text") {
			if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
			return schema.text(json.text, marks);
		}
		let content$2 = Fragment.fromJSON(schema, json.content);
		let node = schema.nodeType(json.type).create(json.attrs, content$2, marks);
		node.type.checkAttrs(node.attrs);
		return node;
	}
};
Node$1.prototype.text = void 0;
var TextNode = class TextNode extends Node$1 {
	constructor(type, attrs, content$2, marks) {
		super(type, attrs, null, marks);
		if (!content$2) throw new RangeError("Empty text nodes are not allowed");
		this.text = content$2;
	}
	toString() {
		if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
		return wrapMarks(this.marks, JSON.stringify(this.text));
	}
	get textContent() {
		return this.text;
	}
	textBetween(from, to) {
		return this.text.slice(from, to);
	}
	get nodeSize() {
		return this.text.length;
	}
	mark(marks) {
		return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
	}
	withText(text$2) {
		if (text$2 == this.text) return this;
		return new TextNode(this.type, this.attrs, text$2, this.marks);
	}
	cut(from = 0, to = this.text.length) {
		if (from == 0 && to == this.text.length) return this;
		return this.withText(this.text.slice(from, to));
	}
	eq(other) {
		return this.sameMarkup(other) && this.text == other.text;
	}
	toJSON() {
		let base$1 = super.toJSON();
		base$1.text = this.text;
		return base$1;
	}
};
function wrapMarks(marks, str) {
	for (let i$1 = marks.length - 1; i$1 >= 0; i$1--) str = marks[i$1].type.name + "(" + str + ")";
	return str;
}
var ContentMatch = class ContentMatch {
	constructor(validEnd) {
		this.validEnd = validEnd;
		this.next = [];
		this.wrapCache = [];
	}
	static parse(string$2, nodeTypes) {
		let stream = new TokenStream(string$2, nodeTypes);
		if (stream.next == null) return ContentMatch.empty;
		let expr = parseExpr(stream);
		if (stream.next) stream.err("Unexpected trailing text");
		let match = dfa(nfa(expr));
		checkForDeadEnds(match, stream);
		return match;
	}
	matchType(type) {
		for (let i$1 = 0; i$1 < this.next.length; i$1++) if (this.next[i$1].type == type) return this.next[i$1].next;
		return null;
	}
	matchFragment(frag, start = 0, end = frag.childCount) {
		let cur = this;
		for (let i$1 = start; cur && i$1 < end; i$1++) cur = cur.matchType(frag.child(i$1).type);
		return cur;
	}
	get inlineContent() {
		return this.next.length != 0 && this.next[0].type.isInline;
	}
	get defaultType() {
		for (let i$1 = 0; i$1 < this.next.length; i$1++) {
			let { type } = this.next[i$1];
			if (!(type.isText || type.hasRequiredAttrs())) return type;
		}
		return null;
	}
	compatible(other) {
		for (let i$1 = 0; i$1 < this.next.length; i$1++) for (let j = 0; j < other.next.length; j++) if (this.next[i$1].type == other.next[j].type) return true;
		return false;
	}
	fillBefore(after, toEnd = false, startIndex = 0) {
		let seen = [this];
		function search$1(match, types) {
			let finished = match.matchFragment(after, startIndex);
			if (finished && (!toEnd || finished.validEnd)) return Fragment.from(types.map((tp) => tp.createAndFill()));
			for (let i$1 = 0; i$1 < match.next.length; i$1++) {
				let { type, next } = match.next[i$1];
				if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
					seen.push(next);
					let found$1 = search$1(next, types.concat(type));
					if (found$1) return found$1;
				}
			}
			return null;
		}
		return search$1(this, []);
	}
	findWrapping(target) {
		for (let i$1 = 0; i$1 < this.wrapCache.length; i$1 += 2) if (this.wrapCache[i$1] == target) return this.wrapCache[i$1 + 1];
		let computed = this.computeWrapping(target);
		this.wrapCache.push(target, computed);
		return computed;
	}
	computeWrapping(target) {
		let seen = Object.create(null), active = [{
			match: this,
			type: null,
			via: null
		}];
		while (active.length) {
			let current = active.shift(), match = current.match;
			if (match.matchType(target)) {
				let result = [];
				for (let obj = current; obj.type; obj = obj.via) result.push(obj.type);
				return result.reverse();
			}
			for (let i$1 = 0; i$1 < match.next.length; i$1++) {
				let { type, next } = match.next[i$1];
				if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
					active.push({
						match: type.contentMatch,
						type,
						via: current
					});
					seen[type.name] = true;
				}
			}
		}
		return null;
	}
	get edgeCount() {
		return this.next.length;
	}
	edge(n) {
		if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
		return this.next[n];
	}
	toString() {
		let seen = [];
		function scan(m) {
			seen.push(m);
			for (let i$1 = 0; i$1 < m.next.length; i$1++) if (seen.indexOf(m.next[i$1].next) == -1) scan(m.next[i$1].next);
		}
		scan(this);
		return seen.map((m, i$1) => {
			let out = i$1 + (m.validEnd ? "*" : " ") + " ";
			for (let i$2 = 0; i$2 < m.next.length; i$2++) out += (i$2 ? ", " : "") + m.next[i$2].type.name + "->" + seen.indexOf(m.next[i$2].next);
			return out;
		}).join("\n");
	}
};
ContentMatch.empty = new ContentMatch(true);
var TokenStream = class {
	constructor(string$2, nodeTypes) {
		this.string = string$2;
		this.nodeTypes = nodeTypes;
		this.inline = null;
		this.pos = 0;
		this.tokens = string$2.split(/\s*(?=\b|\W|$)/);
		if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
		if (this.tokens[0] == "") this.tokens.shift();
	}
	get next() {
		return this.tokens[this.pos];
	}
	eat(tok) {
		return this.next == tok && (this.pos++ || true);
	}
	err(str) {
		throw new SyntaxError(str + " (in content expression '" + this.string + "')");
	}
};
function parseExpr(stream) {
	let exprs = [];
	do
		exprs.push(parseExprSeq(stream));
	while (stream.eat("|"));
	return exprs.length == 1 ? exprs[0] : {
		type: "choice",
		exprs
	};
}
function parseExprSeq(stream) {
	let exprs = [];
	do
		exprs.push(parseExprSubscript(stream));
	while (stream.next && stream.next != ")" && stream.next != "|");
	return exprs.length == 1 ? exprs[0] : {
		type: "seq",
		exprs
	};
}
function parseExprSubscript(stream) {
	let expr = parseExprAtom(stream);
	for (;;) if (stream.eat("+")) expr = {
		type: "plus",
		expr
	};
	else if (stream.eat("*")) expr = {
		type: "star",
		expr
	};
	else if (stream.eat("?")) expr = {
		type: "opt",
		expr
	};
	else if (stream.eat("{")) expr = parseExprRange(stream, expr);
	else break;
	return expr;
}
function parseNum(stream) {
	if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
	let result = Number(stream.next);
	stream.pos++;
	return result;
}
function parseExprRange(stream, expr) {
	let min = parseNum(stream), max = min;
	if (stream.eat(",")) if (stream.next != "}") max = parseNum(stream);
	else max = -1;
	if (!stream.eat("}")) stream.err("Unclosed braced range");
	return {
		type: "range",
		min,
		max,
		expr
	};
}
function resolveName(stream, name) {
	let types = stream.nodeTypes, type = types[name];
	if (type) return [type];
	let result = [];
	for (let typeName in types) {
		let type$1 = types[typeName];
		if (type$1.isInGroup(name)) result.push(type$1);
	}
	if (result.length == 0) stream.err("No node type or group '" + name + "' found");
	return result;
}
function parseExprAtom(stream) {
	if (stream.eat("(")) {
		let expr = parseExpr(stream);
		if (!stream.eat(")")) stream.err("Missing closing paren");
		return expr;
	} else if (!/\W/.test(stream.next)) {
		let exprs = resolveName(stream, stream.next).map((type) => {
			if (stream.inline == null) stream.inline = type.isInline;
			else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
			return {
				type: "name",
				value: type
			};
		});
		stream.pos++;
		return exprs.length == 1 ? exprs[0] : {
			type: "choice",
			exprs
		};
	} else stream.err("Unexpected token '" + stream.next + "'");
}
function nfa(expr) {
	let nfa$1 = [[]];
	connect(compile(expr, 0), node());
	return nfa$1;
	function node() {
		return nfa$1.push([]) - 1;
	}
	function edge(from, to, term) {
		let edge$1 = {
			term,
			to
		};
		nfa$1[from].push(edge$1);
		return edge$1;
	}
	function connect(edges, to) {
		edges.forEach((edge$1) => edge$1.to = to);
	}
	function compile(expr$1, from) {
		if (expr$1.type == "choice") return expr$1.exprs.reduce((out, expr$2) => out.concat(compile(expr$2, from)), []);
		else if (expr$1.type == "seq") for (let i$1 = 0;; i$1++) {
			let next = compile(expr$1.exprs[i$1], from);
			if (i$1 == expr$1.exprs.length - 1) return next;
			connect(next, from = node());
		}
		else if (expr$1.type == "star") {
			let loop = node();
			edge(from, loop);
			connect(compile(expr$1.expr, loop), loop);
			return [edge(loop)];
		} else if (expr$1.type == "plus") {
			let loop = node();
			connect(compile(expr$1.expr, from), loop);
			connect(compile(expr$1.expr, loop), loop);
			return [edge(loop)];
		} else if (expr$1.type == "opt") return [edge(from)].concat(compile(expr$1.expr, from));
		else if (expr$1.type == "range") {
			let cur = from;
			for (let i$1 = 0; i$1 < expr$1.min; i$1++) {
				let next = node();
				connect(compile(expr$1.expr, cur), next);
				cur = next;
			}
			if (expr$1.max == -1) connect(compile(expr$1.expr, cur), cur);
			else for (let i$1 = expr$1.min; i$1 < expr$1.max; i$1++) {
				let next = node();
				edge(cur, next);
				connect(compile(expr$1.expr, cur), next);
				cur = next;
			}
			return [edge(cur)];
		} else if (expr$1.type == "name") return [edge(from, void 0, expr$1.value)];
		else throw new Error("Unknown expr type");
	}
}
function cmp(a, b) {
	return b - a;
}
function nullFrom(nfa$1, node) {
	let result = [];
	scan(node);
	return result.sort(cmp);
	function scan(node$1) {
		let edges = nfa$1[node$1];
		if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
		result.push(node$1);
		for (let i$1 = 0; i$1 < edges.length; i$1++) {
			let { term, to } = edges[i$1];
			if (!term && result.indexOf(to) == -1) scan(to);
		}
	}
}
function dfa(nfa$1) {
	let labeled = Object.create(null);
	return explore(nullFrom(nfa$1, 0));
	function explore(states) {
		let out = [];
		states.forEach((node) => {
			nfa$1[node].forEach(({ term, to }) => {
				if (!term) return;
				let set;
				for (let i$1 = 0; i$1 < out.length; i$1++) if (out[i$1][0] == term) set = out[i$1][1];
				nullFrom(nfa$1, to).forEach((node$1) => {
					if (!set) out.push([term, set = []]);
					if (set.indexOf(node$1) == -1) set.push(node$1);
				});
			});
		});
		let state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa$1.length - 1) > -1);
		for (let i$1 = 0; i$1 < out.length; i$1++) {
			let states$1 = out[i$1][1].sort(cmp);
			state.next.push({
				type: out[i$1][0],
				next: labeled[states$1.join(",")] || explore(states$1)
			});
		}
		return state;
	}
}
function checkForDeadEnds(match, stream) {
	for (let i$1 = 0, work = [match]; i$1 < work.length; i$1++) {
		let state = work[i$1], dead = !state.validEnd, nodes = [];
		for (let j = 0; j < state.next.length; j++) {
			let { type, next } = state.next[j];
			nodes.push(type.name);
			if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
			if (work.indexOf(next) == -1) work.push(next);
		}
		if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
	}
}
function defaultAttrs(attrs) {
	let defaults = Object.create(null);
	for (let attrName in attrs) {
		let attr = attrs[attrName];
		if (!attr.hasDefault) return null;
		defaults[attrName] = attr.default;
	}
	return defaults;
}
function computeAttrs(attrs, value) {
	let built = Object.create(null);
	for (let name in attrs) {
		let given = value && value[name];
		if (given === void 0) {
			let attr = attrs[name];
			if (attr.hasDefault) given = attr.default;
			else throw new RangeError("No value supplied for attribute " + name);
		}
		built[name] = given;
	}
	return built;
}
function checkAttrs(attrs, values, type, name) {
	for (let name$1 in values) if (!(name$1 in attrs)) throw new RangeError(`Unsupported attribute ${name$1} for ${type} of type ${name$1}`);
	for (let name$1 in attrs) {
		let attr = attrs[name$1];
		if (attr.validate) attr.validate(values[name$1]);
	}
}
function initAttrs(typeName, attrs) {
	let result = Object.create(null);
	if (attrs) for (let name in attrs) result[name] = new Attribute(typeName, name, attrs[name]);
	return result;
}
var NodeType$1 = class NodeType$1 {
	constructor(name, schema, spec) {
		this.name = name;
		this.schema = schema;
		this.spec = spec;
		this.markSet = null;
		this.groups = spec.group ? spec.group.split(" ") : [];
		this.attrs = initAttrs(name, spec.attrs);
		this.defaultAttrs = defaultAttrs(this.attrs);
		this.contentMatch = null;
		this.inlineContent = null;
		this.isBlock = !(spec.inline || name == "text");
		this.isText = name == "text";
	}
	get isInline() {
		return !this.isBlock;
	}
	get isTextblock() {
		return this.isBlock && this.inlineContent;
	}
	get isLeaf() {
		return this.contentMatch == ContentMatch.empty;
	}
	get isAtom() {
		return this.isLeaf || !!this.spec.atom;
	}
	isInGroup(group) {
		return this.groups.indexOf(group) > -1;
	}
	get whitespace() {
		return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
	}
	hasRequiredAttrs() {
		for (let n in this.attrs) if (this.attrs[n].isRequired) return true;
		return false;
	}
	compatibleContent(other) {
		return this == other || this.contentMatch.compatible(other.contentMatch);
	}
	computeAttrs(attrs) {
		if (!attrs && this.defaultAttrs) return this.defaultAttrs;
		else return computeAttrs(this.attrs, attrs);
	}
	create(attrs = null, content$2, marks) {
		if (this.isText) throw new Error("NodeType.create can't construct text nodes");
		return new Node$1(this, this.computeAttrs(attrs), Fragment.from(content$2), Mark.setFrom(marks));
	}
	createChecked(attrs = null, content$2, marks) {
		content$2 = Fragment.from(content$2);
		this.checkContent(content$2);
		return new Node$1(this, this.computeAttrs(attrs), content$2, Mark.setFrom(marks));
	}
	createAndFill(attrs = null, content$2, marks) {
		attrs = this.computeAttrs(attrs);
		content$2 = Fragment.from(content$2);
		if (content$2.size) {
			let before = this.contentMatch.fillBefore(content$2);
			if (!before) return null;
			content$2 = before.append(content$2);
		}
		let matched = this.contentMatch.matchFragment(content$2);
		let after = matched && matched.fillBefore(Fragment.empty, true);
		if (!after) return null;
		return new Node$1(this, attrs, content$2.append(after), Mark.setFrom(marks));
	}
	validContent(content$2) {
		let result = this.contentMatch.matchFragment(content$2);
		if (!result || !result.validEnd) return false;
		for (let i$1 = 0; i$1 < content$2.childCount; i$1++) if (!this.allowsMarks(content$2.child(i$1).marks)) return false;
		return true;
	}
	checkContent(content$2) {
		if (!this.validContent(content$2)) throw new RangeError(`Invalid content for node ${this.name}: ${content$2.toString().slice(0, 50)}`);
	}
	checkAttrs(attrs) {
		checkAttrs(this.attrs, attrs, "node", this.name);
	}
	allowsMarkType(markType) {
		return this.markSet == null || this.markSet.indexOf(markType) > -1;
	}
	allowsMarks(marks) {
		if (this.markSet == null) return true;
		for (let i$1 = 0; i$1 < marks.length; i$1++) if (!this.allowsMarkType(marks[i$1].type)) return false;
		return true;
	}
	allowedMarks(marks) {
		if (this.markSet == null) return marks;
		let copy$1;
		for (let i$1 = 0; i$1 < marks.length; i$1++) if (!this.allowsMarkType(marks[i$1].type)) {
			if (!copy$1) copy$1 = marks.slice(0, i$1);
		} else if (copy$1) copy$1.push(marks[i$1]);
		return !copy$1 ? marks : copy$1.length ? copy$1 : Mark.none;
	}
	static compile(nodes, schema) {
		let result = Object.create(null);
		nodes.forEach((name, spec) => result[name] = new NodeType$1(name, schema, spec));
		let topType = schema.spec.topNode || "doc";
		if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
		if (!result.text) throw new RangeError("Every schema needs a 'text' type");
		for (let _ in result.text.attrs) throw new RangeError("The text node type should not have attributes");
		return result;
	}
};
function validateType(typeName, attrName, type) {
	let types = type.split("|");
	return (value) => {
		let name = value === null ? "null" : typeof value;
		if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
	};
}
var Attribute = class {
	constructor(typeName, attrName, options) {
		this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
		this.default = options.default;
		this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
	}
	get isRequired() {
		return !this.hasDefault;
	}
};
var MarkType = class MarkType {
	constructor(name, rank$1, schema, spec) {
		this.name = name;
		this.rank = rank$1;
		this.schema = schema;
		this.spec = spec;
		this.attrs = initAttrs(name, spec.attrs);
		this.excluded = null;
		let defaults = defaultAttrs(this.attrs);
		this.instance = defaults ? new Mark(this, defaults) : null;
	}
	create(attrs = null) {
		if (!attrs && this.instance) return this.instance;
		return new Mark(this, computeAttrs(this.attrs, attrs));
	}
	static compile(marks, schema) {
		let result = Object.create(null), rank$1 = 0;
		marks.forEach((name, spec) => result[name] = new MarkType(name, rank$1++, schema, spec));
		return result;
	}
	removeFromSet(set) {
		for (var i$1 = 0; i$1 < set.length; i$1++) if (set[i$1].type == this) {
			set = set.slice(0, i$1).concat(set.slice(i$1 + 1));
			i$1--;
		}
		return set;
	}
	isInSet(set) {
		for (let i$1 = 0; i$1 < set.length; i$1++) if (set[i$1].type == this) return set[i$1];
	}
	checkAttrs(attrs) {
		checkAttrs(this.attrs, attrs, "mark", this.name);
	}
	excludes(other) {
		return this.excluded.indexOf(other) > -1;
	}
};
var Schema = class {
	constructor(spec) {
		this.linebreakReplacement = null;
		this.cached = Object.create(null);
		let instanceSpec = this.spec = {};
		for (let prop in spec) instanceSpec[prop] = spec[prop];
		instanceSpec.nodes = dist_default$1.from(spec.nodes), instanceSpec.marks = dist_default$1.from(spec.marks || {}), this.nodes = NodeType$1.compile(this.spec.nodes, this);
		this.marks = MarkType.compile(this.spec.marks, this);
		let contentExprCache = Object.create(null);
		for (let prop in this.nodes) {
			if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
			let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
			type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
			type.inlineContent = type.contentMatch.inlineContent;
			if (type.spec.linebreakReplacement) {
				if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
				if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
				this.linebreakReplacement = type;
			}
			type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
		}
		for (let prop in this.marks) {
			let type = this.marks[prop], excl = type.spec.excludes;
			type.excluded = excl == null ? [type] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
		}
		this.nodeFromJSON = (json) => Node$1.fromJSON(this, json);
		this.markFromJSON = (json) => Mark.fromJSON(this, json);
		this.topNodeType = this.nodes[this.spec.topNode || "doc"];
		this.cached.wrappings = Object.create(null);
	}
	node(type, attrs = null, content$2, marks) {
		if (typeof type == "string") type = this.nodeType(type);
		else if (!(type instanceof NodeType$1)) throw new RangeError("Invalid node type: " + type);
		else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
		return type.createChecked(attrs, content$2, marks);
	}
	text(text$2, marks) {
		let type = this.nodes.text;
		return new TextNode(type, type.defaultAttrs, text$2, Mark.setFrom(marks));
	}
	mark(type, attrs) {
		if (typeof type == "string") type = this.marks[type];
		return type.create(attrs);
	}
	nodeType(name) {
		let found$1 = this.nodes[name];
		if (!found$1) throw new RangeError("Unknown node type: " + name);
		return found$1;
	}
};
function gatherMarks(schema, marks) {
	let found$1 = [];
	for (let i$1 = 0; i$1 < marks.length; i$1++) {
		let name = marks[i$1], mark = schema.marks[name], ok = mark;
		if (mark) found$1.push(mark);
		else for (let prop in schema.marks) {
			let mark$1 = schema.marks[prop];
			if (name == "_" || mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1) found$1.push(ok = mark$1);
		}
		if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i$1] + "'");
	}
	return found$1;
}
function isTagRule(rule) {
	return rule.tag != null;
}
function isStyleRule(rule) {
	return rule.style != null;
}
var DOMParser$1 = class DOMParser$1 {
	constructor(schema, rules) {
		this.schema = schema;
		this.rules = rules;
		this.tags = [];
		this.styles = [];
		let matchedStyles = this.matchedStyles = [];
		rules.forEach((rule) => {
			if (isTagRule(rule)) this.tags.push(rule);
			else if (isStyleRule(rule)) {
				let prop = /[^=]*/.exec(rule.style)[0];
				if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
				this.styles.push(rule);
			}
		});
		this.normalizeLists = !this.tags.some((r) => {
			if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
			let node = schema.nodes[r.node];
			return node.contentMatch.matchType(node);
		});
	}
	parse(dom, options = {}) {
		let context = new ParseContext(this, options, false);
		context.addAll(dom, Mark.none, options.from, options.to);
		return context.finish();
	}
	parseSlice(dom, options = {}) {
		let context = new ParseContext(this, options, true);
		context.addAll(dom, Mark.none, options.from, options.to);
		return Slice.maxOpen(context.finish());
	}
	matchTag(dom, context, after) {
		for (let i$1 = after ? this.tags.indexOf(after) + 1 : 0; i$1 < this.tags.length; i$1++) {
			let rule = this.tags[i$1];
			if (matches(dom, rule.tag) && (rule.namespace === void 0 || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
				if (rule.getAttrs) {
					let result = rule.getAttrs(dom);
					if (result === false) continue;
					rule.attrs = result || void 0;
				}
				return rule;
			}
		}
	}
	matchStyle(prop, value, context, after) {
		for (let i$1 = after ? this.styles.indexOf(after) + 1 : 0; i$1 < this.styles.length; i$1++) {
			let rule = this.styles[i$1], style = rule.style;
			if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
			if (rule.getAttrs) {
				let result = rule.getAttrs(value);
				if (result === false) continue;
				rule.attrs = result || void 0;
			}
			return rule;
		}
	}
	static schemaRules(schema) {
		let result = [];
		function insert(rule) {
			let priority = rule.priority == null ? 50 : rule.priority, i$1 = 0;
			for (; i$1 < result.length; i$1++) {
				let next = result[i$1];
				if ((next.priority == null ? 50 : next.priority) < priority) break;
			}
			result.splice(i$1, 0, rule);
		}
		for (let name in schema.marks) {
			let rules = schema.marks[name].spec.parseDOM;
			if (rules) rules.forEach((rule) => {
				insert(rule = copy(rule));
				if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
			});
		}
		for (let name in schema.nodes) {
			let rules = schema.nodes[name].spec.parseDOM;
			if (rules) rules.forEach((rule) => {
				insert(rule = copy(rule));
				if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
			});
		}
		return result;
	}
	static fromSchema(schema) {
		return schema.cached.domParser || (schema.cached.domParser = new DOMParser$1(schema, DOMParser$1.schemaRules(schema)));
	}
};
var blockTags = {
	address: true,
	article: true,
	aside: true,
	blockquote: true,
	canvas: true,
	dd: true,
	div: true,
	dl: true,
	fieldset: true,
	figcaption: true,
	figure: true,
	footer: true,
	form: true,
	h1: true,
	h2: true,
	h3: true,
	h4: true,
	h5: true,
	h6: true,
	header: true,
	hgroup: true,
	hr: true,
	li: true,
	noscript: true,
	ol: true,
	output: true,
	p: true,
	pre: true,
	section: true,
	table: true,
	tfoot: true,
	ul: true
};
var ignoreTags = {
	head: true,
	noscript: true,
	object: true,
	script: true,
	style: true,
	title: true
};
var listTags = {
	ol: true,
	ul: true
};
var OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base$1) {
	if (preserveWhitespace != null) return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
	return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base$1 & ~OPT_OPEN_LEFT;
}
var NodeContext = class {
	constructor(type, attrs, marks, solid, match, options) {
		this.type = type;
		this.attrs = attrs;
		this.marks = marks;
		this.solid = solid;
		this.options = options;
		this.content = [];
		this.activeMarks = Mark.none;
		this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
	}
	findWrapping(node) {
		if (!this.match) {
			if (!this.type) return [];
			let fill = this.type.contentMatch.fillBefore(Fragment.from(node));
			if (fill) this.match = this.type.contentMatch.matchFragment(fill);
			else {
				let start = this.type.contentMatch, wrap$1;
				if (wrap$1 = start.findWrapping(node.type)) {
					this.match = start;
					return wrap$1;
				} else return null;
			}
		}
		return this.match.findWrapping(node.type);
	}
	finish(openEnd) {
		if (!(this.options & OPT_PRESERVE_WS)) {
			let last = this.content[this.content.length - 1], m;
			if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
				let text$2 = last;
				if (last.text.length == m[0].length) this.content.pop();
				else this.content[this.content.length - 1] = text$2.withText(text$2.text.slice(0, text$2.text.length - m[0].length));
			}
		}
		let content$2 = Fragment.from(this.content);
		if (!openEnd && this.match) content$2 = content$2.append(this.match.fillBefore(Fragment.empty, true));
		return this.type ? this.type.create(this.attrs, content$2, this.marks) : content$2;
	}
	inlineContext(node) {
		if (this.type) return this.type.inlineContent;
		if (this.content.length) return this.content[0].isInline;
		return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
	}
};
var ParseContext = class {
	constructor(parser, options, isOpen) {
		this.parser = parser;
		this.options = options;
		this.isOpen = isOpen;
		this.open = 0;
		this.localPreserveWS = false;
		let topNode = options.topNode, topContext;
		let topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
		if (topNode) topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
		else if (isOpen) topContext = new NodeContext(null, null, Mark.none, true, null, topOptions);
		else topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions);
		this.nodes = [topContext];
		this.find = options.findPositions;
		this.needsBlock = false;
	}
	get top() {
		return this.nodes[this.open];
	}
	addDOM(dom, marks) {
		if (dom.nodeType == 3) this.addTextNode(dom, marks);
		else if (dom.nodeType == 1) this.addElement(dom, marks);
	}
	addTextNode(dom, marks) {
		let value = dom.nodeValue;
		let top = this.top, preserveWS = top.options & OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & OPT_PRESERVE_WS) > 0;
		let { schema } = this.parser;
		if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
			if (!preserveWS) {
				value = value.replace(/[ \t\r\n\u000c]+/g, " ");
				if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
					let nodeBefore = top.content[top.content.length - 1];
					let domNodeBefore = dom.previousSibling;
					if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
				}
			} else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
			else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
				let lines = value.split(/\r?\n|\r/);
				for (let i$1 = 0; i$1 < lines.length; i$1++) {
					if (i$1) this.insertNode(schema.linebreakReplacement.create(), marks, true);
					if (lines[i$1]) this.insertNode(schema.text(lines[i$1]), marks, !/\S/.test(lines[i$1]));
				}
				value = "";
			} else value = value.replace(/\r?\n|\r/g, " ");
			if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
			this.findInText(dom);
		} else this.findInside(dom);
	}
	addElement(dom, marks, matchAfter) {
		let outerWS = this.localPreserveWS, top = this.top;
		if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
		let name = dom.nodeName.toLowerCase(), ruleID;
		if (listTags.hasOwnProperty(name) && this.parser.normalizeLists) normalizeList(dom);
		let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
		out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
			this.findInside(dom);
			this.ignoreFallback(dom, marks);
		} else if (!rule || rule.skip || rule.closeParent) {
			if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
			else if (rule && rule.skip.nodeType) dom = rule.skip;
			let sync, oldNeedsBlock = this.needsBlock;
			if (blockTags.hasOwnProperty(name)) {
				if (top.content.length && top.content[0].isInline && this.open) {
					this.open--;
					top = this.top;
				}
				sync = true;
				if (!top.type) this.needsBlock = true;
			} else if (!dom.firstChild) {
				this.leafFallback(dom, marks);
				break out;
			}
			let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
			if (innerMarks) this.addAll(dom, innerMarks);
			if (sync) this.sync(top);
			this.needsBlock = oldNeedsBlock;
		} else {
			let innerMarks = this.readStyles(dom, marks);
			if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : void 0);
		}
		this.localPreserveWS = outerWS;
	}
	leafFallback(dom, marks) {
		if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
	}
	ignoreFallback(dom, marks) {
		if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
	}
	readStyles(dom, marks) {
		let styles = dom.style;
		if (styles && styles.length) for (let i$1 = 0; i$1 < this.parser.matchedStyles.length; i$1++) {
			let name = this.parser.matchedStyles[i$1], value = styles.getPropertyValue(name);
			if (value) for (let after = void 0;;) {
				let rule = this.parser.matchStyle(name, value, this, after);
				if (!rule) break;
				if (rule.ignore) return null;
				if (rule.clearMark) marks = marks.filter((m) => !rule.clearMark(m));
				else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
				if (rule.consuming === false) after = rule;
				else break;
			}
		}
		return marks;
	}
	addElementByRule(dom, rule, marks, continueAfter) {
		let sync, nodeType;
		if (rule.node) {
			nodeType = this.parser.schema.nodes[rule.node];
			if (!nodeType.isLeaf) {
				let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
				if (inner) {
					sync = true;
					marks = inner;
				}
			} else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
		} else {
			let markType = this.parser.schema.marks[rule.mark];
			marks = marks.concat(markType.create(rule.attrs));
		}
		let startIn = this.top;
		if (nodeType && nodeType.isLeaf) this.findInside(dom);
		else if (continueAfter) this.addElement(dom, marks, continueAfter);
		else if (rule.getContent) {
			this.findInside(dom);
			rule.getContent(dom, this.parser.schema).forEach((node) => this.insertNode(node, marks, false));
		} else {
			let contentDOM = dom;
			if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
			else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
			else if (rule.contentElement) contentDOM = rule.contentElement;
			this.findAround(dom, contentDOM, true);
			this.addAll(contentDOM, marks);
			this.findAround(dom, contentDOM, false);
		}
		if (sync && this.sync(startIn)) this.open--;
	}
	addAll(parent, marks, startIndex, endIndex) {
		let index = startIndex || 0;
		for (let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index) {
			this.findAtPoint(parent, index);
			this.addDOM(dom, marks);
		}
		this.findAtPoint(parent, index);
	}
	findPlace(node, marks, cautious) {
		let route, sync;
		for (let depth = this.open, penalty = 0; depth >= 0; depth--) {
			let cx = this.nodes[depth];
			let found$1 = cx.findWrapping(node);
			if (found$1 && (!route || route.length > found$1.length + penalty)) {
				route = found$1;
				sync = cx;
				if (!found$1.length) break;
			}
			if (cx.solid) {
				if (cautious) break;
				penalty += 2;
			}
		}
		if (!route) return null;
		this.sync(sync);
		for (let i$1 = 0; i$1 < route.length; i$1++) marks = this.enterInner(route[i$1], null, marks, false);
		return marks;
	}
	insertNode(node, marks, cautious) {
		if (node.isInline && this.needsBlock && !this.top.type) {
			let block = this.textblockFromContext();
			if (block) marks = this.enterInner(block, null, marks);
		}
		let innerMarks = this.findPlace(node, marks, cautious);
		if (innerMarks) {
			this.closeExtra();
			let top = this.top;
			if (top.match) top.match = top.match.matchType(node.type);
			let nodeMarks = Mark.none;
			for (let m of innerMarks.concat(node.marks)) if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
			top.content.push(node.mark(nodeMarks));
			return true;
		}
		return false;
	}
	enter(type, attrs, marks, preserveWS) {
		let innerMarks = this.findPlace(type.create(attrs), marks, false);
		if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
		return innerMarks;
	}
	enterInner(type, attrs, marks, solid = false, preserveWS) {
		this.closeExtra();
		let top = this.top;
		top.match = top.match && top.match.matchType(type);
		let options = wsOptionsFor(type, preserveWS, top.options);
		if (top.options & OPT_OPEN_LEFT && top.content.length == 0) options |= OPT_OPEN_LEFT;
		let applyMarks = Mark.none;
		marks = marks.filter((m) => {
			if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, type)) {
				applyMarks = m.addToSet(applyMarks);
				return false;
			}
			return true;
		});
		this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
		this.open++;
		return marks;
	}
	closeExtra(openEnd = false) {
		let i$1 = this.nodes.length - 1;
		if (i$1 > this.open) {
			for (; i$1 > this.open; i$1--) this.nodes[i$1 - 1].content.push(this.nodes[i$1].finish(openEnd));
			this.nodes.length = this.open + 1;
		}
	}
	finish() {
		this.open = 0;
		this.closeExtra(this.isOpen);
		return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
	}
	sync(to) {
		for (let i$1 = this.open; i$1 >= 0; i$1--) if (this.nodes[i$1] == to) {
			this.open = i$1;
			return true;
		} else if (this.localPreserveWS) this.nodes[i$1].options |= OPT_PRESERVE_WS;
		return false;
	}
	get currentPos() {
		this.closeExtra();
		let pos = 0;
		for (let i$1 = this.open; i$1 >= 0; i$1--) {
			let content$2 = this.nodes[i$1].content;
			for (let j = content$2.length - 1; j >= 0; j--) pos += content$2[j].nodeSize;
			if (i$1) pos++;
		}
		return pos;
	}
	findAtPoint(parent, offset) {
		if (this.find) {
			for (let i$1 = 0; i$1 < this.find.length; i$1++) if (this.find[i$1].node == parent && this.find[i$1].offset == offset) this.find[i$1].pos = this.currentPos;
		}
	}
	findInside(parent) {
		if (this.find) {
			for (let i$1 = 0; i$1 < this.find.length; i$1++) if (this.find[i$1].pos == null && parent.nodeType == 1 && parent.contains(this.find[i$1].node)) this.find[i$1].pos = this.currentPos;
		}
	}
	findAround(parent, content$2, before) {
		if (parent != content$2 && this.find) {
			for (let i$1 = 0; i$1 < this.find.length; i$1++) if (this.find[i$1].pos == null && parent.nodeType == 1 && parent.contains(this.find[i$1].node)) {
				if (content$2.compareDocumentPosition(this.find[i$1].node) & (before ? 2 : 4)) this.find[i$1].pos = this.currentPos;
			}
		}
	}
	findInText(textNode) {
		if (this.find) {
			for (let i$1 = 0; i$1 < this.find.length; i$1++) if (this.find[i$1].node == textNode) this.find[i$1].pos = this.currentPos - (textNode.nodeValue.length - this.find[i$1].offset);
		}
	}
	matchesContext(context) {
		if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
		let parts = context.split("/");
		let option = this.options.context;
		let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
		let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
		let match = (i$1, depth) => {
			for (; i$1 >= 0; i$1--) {
				let part = parts[i$1];
				if (part == "") {
					if (i$1 == parts.length - 1 || i$1 == 0) continue;
					for (; depth >= minDepth; depth--) if (match(i$1 - 1, depth)) return true;
					return false;
				} else {
					let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
					if (!next || next.name != part && !next.isInGroup(part)) return false;
					depth--;
				}
			}
			return true;
		};
		return match(parts.length - 1, this.open);
	}
	textblockFromContext() {
		let $context = this.options.context;
		if ($context) for (let d = $context.depth; d >= 0; d--) {
			let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
			if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
		}
		for (let name in this.parser.schema.nodes) {
			let type = this.parser.schema.nodes[name];
			if (type.isTextblock && type.defaultAttrs) return type;
		}
	}
};
function normalizeList(dom) {
	for (let child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
		let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
		if (name && listTags.hasOwnProperty(name) && prevItem) {
			prevItem.appendChild(child);
			child = prevItem;
		} else if (name == "li") prevItem = child;
		else if (name) prevItem = null;
	}
}
function matches(dom, selector) {
	return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function copy(obj) {
	let copy$1 = {};
	for (let prop in obj) copy$1[prop] = obj[prop];
	return copy$1;
}
function markMayApply(markType, nodeType) {
	let nodes = nodeType.schema.nodes;
	for (let name in nodes) {
		let parent = nodes[name];
		if (!parent.allowsMarkType(markType)) continue;
		let seen = [], scan = (match) => {
			seen.push(match);
			for (let i$1 = 0; i$1 < match.edgeCount; i$1++) {
				let { type, next } = match.edge(i$1);
				if (type == nodeType) return true;
				if (seen.indexOf(next) < 0 && scan(next)) return true;
			}
		};
		if (scan(parent.contentMatch)) return true;
	}
}
var DOMSerializer = class DOMSerializer {
	constructor(nodes, marks) {
		this.nodes = nodes;
		this.marks = marks;
	}
	serializeFragment(fragment, options = {}, target) {
		if (!target) target = doc$1(options).createDocumentFragment();
		let top = target, active = [];
		fragment.forEach((node) => {
			if (active.length || node.marks.length) {
				let keep = 0, rendered = 0;
				while (keep < active.length && rendered < node.marks.length) {
					let next = node.marks[rendered];
					if (!this.marks[next.type.name]) {
						rendered++;
						continue;
					}
					if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
					keep++;
					rendered++;
				}
				while (keep < active.length) top = active.pop()[1];
				while (rendered < node.marks.length) {
					let add = node.marks[rendered++];
					let markDOM = this.serializeMark(add, node.isInline, options);
					if (markDOM) {
						active.push([add, top]);
						top.appendChild(markDOM.dom);
						top = markDOM.contentDOM || markDOM.dom;
					}
				}
			}
			top.appendChild(this.serializeNodeInner(node, options));
		});
		return target;
	}
	serializeNodeInner(node, options) {
		let { dom, contentDOM } = renderSpec(doc$1(options), this.nodes[node.type.name](node), null, node.attrs);
		if (contentDOM) {
			if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
			this.serializeFragment(node.content, options, contentDOM);
		}
		return dom;
	}
	serializeNode(node, options = {}) {
		let dom = this.serializeNodeInner(node, options);
		for (let i$1 = node.marks.length - 1; i$1 >= 0; i$1--) {
			let wrap$1 = this.serializeMark(node.marks[i$1], node.isInline, options);
			if (wrap$1) {
				(wrap$1.contentDOM || wrap$1.dom).appendChild(dom);
				dom = wrap$1.dom;
			}
		}
		return dom;
	}
	serializeMark(mark, inline, options = {}) {
		let toDOM = this.marks[mark.type.name];
		return toDOM && renderSpec(doc$1(options), toDOM(mark, inline), null, mark.attrs);
	}
	static renderSpec(doc$2, structure, xmlNS = null, blockArraysIn) {
		return renderSpec(doc$2, structure, xmlNS, blockArraysIn);
	}
	static fromSchema(schema) {
		return schema.cached.domSerializer || (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
	}
	static nodesFromSchema(schema) {
		let result = gatherToDOM(schema.nodes);
		if (!result.text) result.text = (node) => node.text;
		return result;
	}
	static marksFromSchema(schema) {
		return gatherToDOM(schema.marks);
	}
};
function gatherToDOM(obj) {
	let result = {};
	for (let name in obj) {
		let toDOM = obj[name].spec.toDOM;
		if (toDOM) result[name] = toDOM;
	}
	return result;
}
function doc$1(options) {
	return options.document || window.document;
}
var suspiciousAttributeCache = /* @__PURE__ */ new WeakMap();
function suspiciousAttributes(attrs) {
	let value = suspiciousAttributeCache.get(attrs);
	if (value === void 0) suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
	return value;
}
function suspiciousAttributesInner(attrs) {
	let result = null;
	function scan(value) {
		if (value && typeof value == "object") if (Array.isArray(value)) if (typeof value[0] == "string") {
			if (!result) result = [];
			result.push(value);
		} else for (let i$1 = 0; i$1 < value.length; i$1++) scan(value[i$1]);
		else for (let prop in value) scan(value[prop]);
	}
	scan(attrs);
	return result;
}
function renderSpec(doc$2, structure, xmlNS, blockArraysIn) {
	if (typeof structure == "string") return { dom: doc$2.createTextNode(structure) };
	if (structure.nodeType != null) return { dom: structure };
	if (structure.dom && structure.dom.nodeType != null) return structure;
	let tagName = structure[0], suspicious;
	if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
	if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
	let space = tagName.indexOf(" ");
	if (space > 0) {
		xmlNS = tagName.slice(0, space);
		tagName = tagName.slice(space + 1);
	}
	let contentDOM;
	let dom = xmlNS ? doc$2.createElementNS(xmlNS, tagName) : doc$2.createElement(tagName);
	let attrs = structure[1], start = 1;
	if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
		start = 2;
		for (let name in attrs) if (attrs[name] != null) {
			let space$1 = name.indexOf(" ");
			if (space$1 > 0) dom.setAttributeNS(name.slice(0, space$1), name.slice(space$1 + 1), attrs[name]);
			else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
			else dom.setAttribute(name, attrs[name]);
		}
	}
	for (let i$1 = start; i$1 < structure.length; i$1++) {
		let child = structure[i$1];
		if (child === 0) {
			if (i$1 < structure.length - 1 || i$1 > start) throw new RangeError("Content hole must be the only child of its parent node");
			return {
				dom,
				contentDOM: dom
			};
		} else {
			let { dom: inner, contentDOM: innerContent } = renderSpec(doc$2, child, xmlNS, blockArraysIn);
			dom.appendChild(inner);
			if (innerContent) {
				if (contentDOM) throw new RangeError("Multiple content holes");
				contentDOM = innerContent;
			}
		}
	}
	return {
		dom,
		contentDOM
	};
}
const simpleStringHash = (str) => {
	let hash = 0;
	for (let i$1 = 0; i$1 < str.length; i$1++) {
		const char = str.charCodeAt(i$1);
		hash = (hash << 5) - hash + char;
		hash = hash & hash;
	}
	return Math.abs(hash).toString();
};
const stableHexHash = (input) => {
	let hash = 2166136261;
	for (let i$1 = 0; i$1 < input.length; i$1++) {
		hash ^= input.charCodeAt(i$1);
		hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
};
const DEFAULT_DOCX_DEFS = {
	"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
	"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
	"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
	"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
	"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
	"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
	"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
	"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
	"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
	"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
	"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
	"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
	"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
	"xmlns:o": "urn:schemas-microsoft-com:office:office",
	"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
	"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
	"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
	"xmlns:v": "urn:schemas-microsoft-com:vml",
	"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
	"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
	"xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main",
	"xmlns:pic": "http://schemas.openxmlformats.org/drawingml/2006/picture",
	"xmlns:c": "http://schemas.openxmlformats.org/drawingml/2006/chart",
	"xmlns:dgm": "http://schemas.openxmlformats.org/drawingml/2006/diagram",
	"xmlns:lc": "http://schemas.openxmlformats.org/drawingml/2006/lockedCanvas",
	"xmlns:w10": "urn:schemas-microsoft-com:office:word",
	"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
	"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
	"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
	"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
	"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
	"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
	"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
	"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
	"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
	"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
	"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
	"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
	"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
	"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
	"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
};
const DEFAULT_CUSTOM_XML = { elements: [{
	type: "element",
	name: "Properties",
	attributes: {
		xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
		"xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
	},
	elements: []
}] };
const COMMENT_REF = {
	type: "element",
	name: "w:r",
	elements: [{
		type: "element",
		name: "w:rPr",
		elements: [{
			type: "element",
			name: "w:rStyle",
			attributes: { "w:val": "CommentReference" }
		}]
	}, {
		type: "element",
		name: "w:annotationRef"
	}]
};
const DEFAULT_LINKED_STYLES = {
	Normal: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:default": "1",
			"w:styleId": "Normal"
		},
		elements: [{
			type: "element",
			name: "w:name",
			attributes: { "w:val": "Normal" }
		}, {
			type: "element",
			name: "w:qFormat"
		}]
	},
	Title: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:styleId": "Title"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "Title" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:next",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:link",
				attributes: { "w:val": "TitleChar" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "10" }
			},
			{
				type: "element",
				name: "w:qFormat"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00B72667" }
			},
			{
				type: "element",
				name: "w:pPr",
				elements: [{
					type: "element",
					name: "w:spacing",
					attributes: { "w:after": "80" }
				}, {
					type: "element",
					name: "w:contextualSpacing"
				}]
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [
					{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:asciiTheme": "majorHAnsi",
							"w:eastAsiaTheme": "majorEastAsia",
							"w:hAnsiTheme": "majorHAnsi",
							"w:cstheme": "majorBidi"
						}
					},
					{
						type: "element",
						name: "w:spacing",
						attributes: { "w:val": "-10" }
					},
					{
						type: "element",
						name: "w:kern",
						attributes: { "w:val": "28" }
					},
					{
						type: "element",
						name: "w:sz",
						attributes: { "w:val": "56" }
					},
					{
						type: "element",
						name: "w:szCs",
						attributes: { "w:val": "56" }
					}
				]
			}
		]
	},
	Subtitle: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:styleId": "Subtitle"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "Subtitle" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:next",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:link",
				attributes: { "w:val": "SubtitleChar" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "11" }
			},
			{
				type: "element",
				name: "w:qFormat"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00B72667" }
			},
			{
				type: "element",
				name: "w:pPr",
				elements: [{
					type: "element",
					name: "w:numPr",
					elements: [{
						type: "element",
						name: "w:ilvl",
						attributes: { "w:val": "1" }
					}]
				}, {
					type: "element",
					name: "w:spacing",
					attributes: { "w:after": "160" }
				}]
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [
					{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:asciiTheme": "minorHAnsi",
							"w:eastAsiaTheme": "majorEastAsia",
							"w:hAnsiTheme": "minorHAnsi",
							"w:cstheme": "majorBidi"
						}
					},
					{
						type: "element",
						name: "w:color",
						attributes: {
							"w:val": "595959",
							"w:themeColor": "text1",
							"w:themeTint": "A6"
						}
					},
					{
						type: "element",
						name: "w:spacing",
						attributes: { "w:val": "15" }
					},
					{
						type: "element",
						name: "w:sz",
						attributes: { "w:val": "28" }
					},
					{
						type: "element",
						name: "w:szCs",
						attributes: { "w:val": "28" }
					}
				]
			}
		]
	},
	Heading1: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:styleId": "Heading1"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "heading 1" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:next",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:link",
				attributes: { "w:val": "Heading1Char" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "9" }
			},
			{
				type: "element",
				name: "w:qFormat"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00233D7B" }
			},
			{
				type: "element",
				name: "w:pPr",
				elements: [
					{
						type: "element",
						name: "w:keepNext"
					},
					{
						type: "element",
						name: "w:keepLines"
					},
					{
						type: "element",
						name: "w:spacing",
						attributes: {
							"w:before": "360",
							"w:after": "80"
						}
					},
					{
						type: "element",
						name: "w:outlineLvl",
						attributes: { "w:val": "0" }
					}
				]
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [
					{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:asciiTheme": "majorHAnsi",
							"w:eastAsiaTheme": "majorEastAsia",
							"w:hAnsiTheme": "majorHAnsi",
							"w:cstheme": "majorBidi"
						}
					},
					{
						type: "element",
						name: "w:color",
						attributes: {
							"w:val": "0F4761",
							"w:themeColor": "accent1",
							"w:themeShade": "BF"
						}
					},
					{
						type: "element",
						name: "w:sz",
						attributes: { "w:val": "40" }
					},
					{
						type: "element",
						name: "w:szCs",
						attributes: { "w:val": "40" }
					}
				]
			}
		]
	},
	Heading2: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:styleId": "Heading2"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "heading 2" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:next",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:link",
				attributes: { "w:val": "Heading2Char" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "9" }
			},
			{
				type: "element",
				name: "w:semiHidden"
			},
			{
				type: "element",
				name: "w:unhideWhenUsed"
			},
			{
				type: "element",
				name: "w:qFormat"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00233D7B" }
			},
			{
				type: "element",
				name: "w:pPr",
				elements: [
					{
						type: "element",
						name: "w:keepNext"
					},
					{
						type: "element",
						name: "w:keepLines"
					},
					{
						type: "element",
						name: "w:spacing",
						attributes: {
							"w:before": "160",
							"w:after": "80"
						}
					},
					{
						type: "element",
						name: "w:outlineLvl",
						attributes: { "w:val": "1" }
					}
				]
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [
					{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:asciiTheme": "majorHAnsi",
							"w:eastAsiaTheme": "majorEastAsia",
							"w:hAnsiTheme": "majorHAnsi",
							"w:cstheme": "majorBidi"
						}
					},
					{
						type: "element",
						name: "w:color",
						attributes: {
							"w:val": "0F4761",
							"w:themeColor": "accent1",
							"w:themeShade": "BF"
						}
					},
					{
						type: "element",
						name: "w:sz",
						attributes: { "w:val": "32" }
					},
					{
						type: "element",
						name: "w:szCs",
						attributes: { "w:val": "32" }
					}
				]
			}
		]
	},
	Heading3: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:type": "paragraph",
			"w:styleId": "Heading3"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "heading 3" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:next",
				attributes: { "w:val": "Normal" }
			},
			{
				type: "element",
				name: "w:link",
				attributes: { "w:val": "Heading3Char" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "9" }
			},
			{
				type: "element",
				name: "w:semiHidden"
			},
			{
				type: "element",
				name: "w:unhideWhenUsed"
			},
			{
				type: "element",
				name: "w:qFormat"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00233D7B" }
			},
			{
				type: "element",
				name: "w:pPr",
				elements: [
					{
						type: "element",
						name: "w:keepNext"
					},
					{
						type: "element",
						name: "w:keepLines"
					},
					{
						type: "element",
						name: "w:spacing",
						attributes: {
							"w:before": "160",
							"w:after": "80"
						}
					},
					{
						type: "element",
						name: "w:outlineLvl",
						attributes: { "w:val": "2" }
					}
				]
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [
					{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:eastAsiaTheme": "majorEastAsia",
							"w:cstheme": "majorBidi"
						}
					},
					{
						type: "element",
						name: "w:color",
						attributes: {
							"w:val": "0F4761",
							"w:themeColor": "accent1",
							"w:themeShade": "BF"
						}
					},
					{
						type: "element",
						name: "w:sz",
						attributes: { "w:val": "28" }
					},
					{
						type: "element",
						name: "w:szCs",
						attributes: { "w:val": "28" }
					}
				]
			}
		]
	},
	Hyperlink: {
		type: "element",
		name: "w:style",
		attributes: {
			"w:styleId": "Hyperlink",
			"w:type": "character"
		},
		elements: [
			{
				type: "element",
				name: "w:name",
				attributes: { "w:val": "Hyperlink" }
			},
			{
				type: "element",
				name: "w:basedOn",
				attributes: { "w:val": "DefaultParagraphFont" }
			},
			{
				type: "element",
				name: "w:uiPriority",
				attributes: { "w:val": "99" }
			},
			{
				type: "element",
				name: "w:unhideWhenUsed"
			},
			{
				type: "element",
				name: "w:rsid",
				attributes: { "w:val": "00D87CC4" }
			},
			{
				type: "element",
				name: "w:rPr",
				elements: [{
					type: "element",
					name: "w:color",
					attributes: {
						"w:themeColor": "hyperlink",
						"w:val": "467886"
					}
				}, {
					type: "element",
					name: "w:u",
					attributes: { "w:val": "single" }
				}]
			}
		]
	}
};
const COMMENTS_XML_DEF = {
	declaration: { attributes: {
		version: "1.0",
		encoding: "UTF-8",
		standalone: "yes"
	} },
	elements: [{
		type: "element",
		name: "w:comments",
		attributes: {
			"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
			"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
			"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
			"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
			"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
			"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
			"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
			"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
			"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
			"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
			"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
			"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
			"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
			"xmlns:o": "urn:schemas-microsoft-com:office:office",
			"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
			"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
			"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
			"xmlns:v": "urn:schemas-microsoft-com:vml",
			"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
			"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
			"xmlns:w10": "urn:schemas-microsoft-com:office:word",
			"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
			"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
			"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
			"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
			"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
			"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
			"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
			"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
			"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
			"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
			"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
			"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
			"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
			"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
			"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
		},
		elements: []
	}]
};
const FOOTNOTES_XML_DEF = {
	declaration: { attributes: {
		version: "1.0",
		encoding: "UTF-8",
		standalone: "yes"
	} },
	elements: [{
		type: "element",
		name: "w:footnotes",
		attributes: {
			"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
			"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
			"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
			"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
			"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
			"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
			"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
			"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
			"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
			"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
			"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
			"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
			"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
			"xmlns:o": "urn:schemas-microsoft-com:office:office",
			"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
			"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
			"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
			"xmlns:v": "urn:schemas-microsoft-com:vml",
			"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
			"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
			"xmlns:w10": "urn:schemas-microsoft-com:office:word",
			"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
			"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
			"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
			"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
			"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
			"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
			"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
			"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
			"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
			"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
			"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
			"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
			"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
			"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
			"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
		},
		elements: []
	}]
};
const COMMENTS_XML_DEFINITIONS = {
	COMMENTS_XML_DEF,
	COMMENTS_EXTENDED_XML_DEF: {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: "w15:commentsEx",
			attributes: {
				"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
				"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
				"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
				"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
				"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
				"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
				"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
				"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
				"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
				"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
				"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
				"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
				"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
				"xmlns:o": "urn:schemas-microsoft-com:office:office",
				"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
				"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
				"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
				"xmlns:v": "urn:schemas-microsoft-com:vml",
				"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
				"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
				"xmlns:w10": "urn:schemas-microsoft-com:office:word",
				"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
				"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
				"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
				"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
				"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
				"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
				"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
				"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
				"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
				"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
				"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
				"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
				"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
				"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
				"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
			},
			elements: []
		}]
	},
	COMMENTS_EXTENSIBLE_XML_DEF: {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: "w16cex:commentsExtensible",
			attributes: {
				"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
				"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
				"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
				"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
				"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
				"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
				"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
				"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
				"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
				"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
				"xmlns:cr": "http://schemas.microsoft.com/office/comments/2020/reactions",
				"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
				"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
				"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
				"xmlns:o": "urn:schemas-microsoft-com:office:office",
				"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
				"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
				"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
				"xmlns:v": "urn:schemas-microsoft-com:vml",
				"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
				"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
				"xmlns:w10": "urn:schemas-microsoft-com:office:word",
				"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
				"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
				"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
				"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
				"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
				"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
				"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
				"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
				"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
				"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
				"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
				"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
				"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
				"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
				"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl cr w16du wp14"
			},
			elements: []
		}]
	},
	COMMENTS_IDS_XML_DEF: {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: "w16cid:commentsIds",
			attributes: {
				"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
				"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
				"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
				"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
				"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
				"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
				"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
				"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
				"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
				"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
				"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
				"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
				"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
				"xmlns:o": "urn:schemas-microsoft-com:office:office",
				"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
				"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
				"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
				"xmlns:v": "urn:schemas-microsoft-com:vml",
				"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
				"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
				"xmlns:w10": "urn:schemas-microsoft-com:office:word",
				"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
				"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
				"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
				"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
				"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
				"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
				"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
				"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
				"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
				"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
				"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
				"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
				"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
				"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
				"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
			},
			elements: []
		}]
	},
	DOCUMENT_RELS_XML_DEF: {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: "Relationships",
			attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
			elements: [
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId8",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable",
						Target: "fontTable.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId3",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings",
						Target: "webSettings.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId7",
						Type: "http://schemas.microsoft.com/office/2018/08/relationships/commentsExtensible",
						Target: "commentsExtensible.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId2",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings",
						Target: "settings.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId1",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
						Target: "styles.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId6",
						Type: "http://schemas.microsoft.com/office/2016/09/relationships/commentsIds",
						Target: "commentsIds.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId5",
						Type: "http://schemas.microsoft.com/office/2011/relationships/commentsExtended",
						Target: "commentsExtended.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId10",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
						Target: "theme/theme1.xml"
					}
				},
				{
					type: "element",
					name: "Relationship",
					attributes: {
						Id: "rId4",
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
						Target: "comments.xml"
					}
				}
			]
		}]
	},
	PEOPLE_XML_DEF: {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: "w15:people",
			attributes: {
				"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
				"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
				"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
				"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
				"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
				"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
				"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
				"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
				"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
				"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
				"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
				"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
				"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
				"xmlns:o": "urn:schemas-microsoft-com:office:office",
				"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
				"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
				"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
				"xmlns:v": "urn:schemas-microsoft-com:vml",
				"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
				"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
				"xmlns:w10": "urn:schemas-microsoft-com:office:word",
				"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
				"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
				"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
				"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
				"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
				"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
				"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
				"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
				"xmlns:w16sdtfl": "http://schemas.microsoft.com/office/word/2024/wordml/sdtformatlock",
				"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
				"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
				"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
				"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
				"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
				"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16sdtfl w16du wp14"
			},
			elements: [{
				type: "element",
				name: "w15:person",
				attributes: { "w15:author": "Nick Bernal" },
				elements: []
			}]
		}]
	}
};
function translateChildNodes(params) {
	const { content: nodes } = params.node;
	if (!nodes) return [];
	const translatedNodes = [];
	const hyperlinkGroup = [];
	let index = 0;
	while (index < nodes.length) {
		const node = nodes[index];
		const linkMark = _isLinkNode(node);
		if (linkMark) {
			hyperlinkGroup.push(node);
			if (_isLinkNode(index + 1 < nodes.length ? nodes[index + 1] : null, linkMark)) {
				index++;
				continue;
			} else {
				let translatedLinkGroup = exportSchemaToJson({
					...params,
					node: hyperlinkGroup[0],
					extraParams: {
						...params.extraParams || {},
						hyperlinkGroup: hyperlinkGroup.slice()
					}
				});
				if (translatedLinkGroup instanceof Array) translatedNodes.push(...translatedLinkGroup);
				else translatedNodes.push(translatedLinkGroup);
				hyperlinkGroup.length = 0;
				index++;
				continue;
			}
		}
		let translatedNode = exportSchemaToJson({
			...params,
			node
		});
		if (translatedNode instanceof Array) translatedNodes.push(...translatedNode);
		else translatedNodes.push(translatedNode);
		index++;
	}
	return translatedNodes.filter((n) => n);
}
function _isLinkNode(node, referenceMark = null) {
	if (!node || !node.marks && !node.attrs?.marksAsAttrs) return null;
	const linkMark = (node.marks || node.attrs.marksAsAttrs).find((mark) => mark.type === "link");
	if (!linkMark) return null;
	if (referenceMark) return _isSameLinkMark(linkMark.attrs, referenceMark.attrs) ? linkMark : null;
	return linkMark;
}
function _isSameLinkMark(attrsA, attrsB) {
	for (let key of [
		"anchor",
		"docLocation",
		"history",
		"href",
		"rId",
		"target"
	]) if (attrsA[key] != attrsB[key]) return false;
	return true;
}
const baseNumbering = {
	declaration: { attributes: {
		version: "1.0",
		encoding: "UTF-8",
		standalone: "yes"
	} },
	elements: [{
		type: "element",
		name: "w:numbering",
		attributes: {
			"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
			"xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
			"xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
			"xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
			"xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
			"xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
			"xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
			"xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
			"xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
			"xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
			"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
			"xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
			"xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
			"xmlns:o": "urn:schemas-microsoft-com:office:office",
			"xmlns:oel": "http://schemas.microsoft.com/office/2019/extlst",
			"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
			"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
			"xmlns:v": "urn:schemas-microsoft-com:vml",
			"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
			"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
			"xmlns:w10": "urn:schemas-microsoft-com:office:word",
			"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
			"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
			"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
			"xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
			"xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
			"xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
			"xmlns:w16du": "http://schemas.microsoft.com/office/word/2023/wordml/word16du",
			"xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
			"xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
			"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
			"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
			"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
			"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
			"mc:Ignorable": "w14 w15 w16se w16cid w16 w16cex w16sdtdh w16du wp14"
		},
		elements: [
			{
				type: "element",
				name: "w:abstractNum",
				attributes: {
					"w:abstractNumId": "0",
					"w15:restartNumberingAfterBreak": "0"
				},
				elements: [
					{
						type: "element",
						name: "w:nsid",
						attributes: { "w:val": "16126B07" }
					},
					{
						type: "element",
						name: "w:multiLevelType",
						attributes: { "w:val": "hybridMultilevel" }
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "0",
							"w:tplc": "04090001"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "720",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Symbol",
										"w:hAnsi": "Symbol",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "1",
							"w:tplc": "04090003",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "o" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "1440",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Courier New",
										"w:hAnsi": "Courier New",
										"w:cs": "Courier New",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "2",
							"w:tplc": "04090005",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "2160",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Wingdings",
										"w:hAnsi": "Wingdings",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "3",
							"w:tplc": "04090001",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "2880",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Symbol",
										"w:hAnsi": "Symbol",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "4",
							"w:tplc": "04090003",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "o" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "3600",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Courier New",
										"w:hAnsi": "Courier New",
										"w:cs": "Courier New",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "5",
							"w:tplc": "04090005",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "4320",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Wingdings",
										"w:hAnsi": "Wingdings",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "6",
							"w:tplc": "04090001",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "5040",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Symbol",
										"w:hAnsi": "Symbol",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "7",
							"w:tplc": "04090003",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "o" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "5760",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Courier New",
										"w:hAnsi": "Courier New",
										"w:cs": "Courier New",
										"w:hint": "default"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "8",
							"w:tplc": "04090005",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "bullet" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "" }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "6480",
										"w:hanging": "360"
									}
								}]
							},
							{
								type: "element",
								name: "w:rPr",
								elements: [{
									type: "element",
									name: "w:rFonts",
									attributes: {
										"w:ascii": "Wingdings",
										"w:hAnsi": "Wingdings",
										"w:hint": "default"
									}
								}]
							}
						]
					}
				]
			},
			{
				type: "element",
				name: "w:abstractNum",
				attributes: {
					"w:abstractNumId": "1",
					"w15:restartNumberingAfterBreak": "0"
				},
				elements: [
					{
						type: "element",
						name: "w:nsid",
						attributes: { "w:val": "587013BA" }
					},
					{
						type: "element",
						name: "w:multiLevelType",
						attributes: { "w:val": "hybridMultilevel" }
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "0",
							"w:tplc": "0409000F"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "decimal" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%1." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "720",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "1",
							"w:tplc": "04090019",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerLetter" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%2." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "1440",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "2",
							"w:tplc": "0409001B",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerRoman" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%3." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "right" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "2160",
										"w:hanging": "180"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "3",
							"w:tplc": "0409000F",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "decimal" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%4." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "2880",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "4",
							"w:tplc": "04090019",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerLetter" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%5." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "3600",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "5",
							"w:tplc": "0409001B",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerRoman" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%6." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "right" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "4320",
										"w:hanging": "180"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "6",
							"w:tplc": "0409000F",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "decimal" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%7." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "5040",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "7",
							"w:tplc": "04090019",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerLetter" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%8." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "left" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "5760",
										"w:hanging": "360"
									}
								}]
							}
						]
					},
					{
						type: "element",
						name: "w:lvl",
						attributes: {
							"w:ilvl": "8",
							"w:tplc": "0409001B",
							"w:tentative": "1"
						},
						elements: [
							{
								type: "element",
								name: "w:start",
								attributes: { "w:val": "1" }
							},
							{
								type: "element",
								name: "w:numFmt",
								attributes: { "w:val": "lowerRoman" }
							},
							{
								type: "element",
								name: "w:lvlText",
								attributes: { "w:val": "%9." }
							},
							{
								type: "element",
								name: "w:lvlJc",
								attributes: { "w:val": "right" }
							},
							{
								type: "element",
								name: "w:pPr",
								elements: [{
									type: "element",
									name: "w:ind",
									attributes: {
										"w:left": "6480",
										"w:hanging": "180"
									}
								}]
							}
						]
					}
				]
			},
			{
				type: "element",
				name: "w:num",
				attributes: {
					"w:numId": "1",
					"w16cid:durableId": "100147962"
				},
				elements: [{
					type: "element",
					name: "w:abstractNumId",
					attributes: { "w:val": "0" }
				}]
			},
			{
				type: "element",
				name: "w:num",
				attributes: {
					"w:numId": "2",
					"w16cid:durableId": "485517411"
				},
				elements: [{
					type: "element",
					name: "w:abstractNumId",
					attributes: { "w:val": "1" }
				}]
			}
		]
	}]
};
const TranslatorTypes = Object.freeze({
	NODE: "node",
	ATTRIBUTE: "attribute"
});
var NodeTranslator = class NodeTranslator {
	xmlName;
	sdNodeOrKeyName;
	priority;
	encodeFn;
	decodeFn;
	matchesEncode;
	matchesDecode;
	static translatorTypes = TranslatorTypes;
	attributes;
	constructor(xmlName, sdNodeOrKeyName, encode$82, decode$84, priority, matchesEncode, matchesDecode, attributes) {
		this.xmlName = xmlName;
		this.sdNodeOrKeyName = sdNodeOrKeyName;
		this.encodeFn = encode$82;
		this.decodeFn = decode$84;
		this.attributes = attributes || [];
		this.priority = typeof priority === "number" ? priority : 0;
		this.matchesEncode = typeof matchesEncode === "function" ? matchesEncode : () => true;
		this.matchesDecode = typeof matchesDecode === "function" ? matchesDecode : () => true;
	}
	encodeAttributes(params) {
		const { nodes = [] } = params || {};
		const { attributes = {} } = nodes[0] || {};
		const encodedAttrs = {};
		this.attributes.forEach(({ sdName, encode: encode$82 }) => {
			if (!encode$82) return;
			const encodedAttr = encode$82(attributes);
			if (encodedAttr !== void 0 && encodedAttr !== null) encodedAttrs[sdName] = encodedAttr;
		});
		return encodedAttrs;
	}
	decodeAttributes(params) {
		const { node } = params || {};
		const { attrs = {} } = node || {};
		const decodedAttrs = {};
		this.attributes.forEach(({ xmlName, decode: decode$84 }) => {
			if (!decode$84) return;
			const decodedAttr = decode$84(attrs);
			if (decodedAttr !== void 0 && decodedAttr !== null) decodedAttrs[xmlName] = decodedAttr;
		});
		return decodedAttrs;
	}
	decode(params) {
		const decodedAttrs = this.decodeAttributes(params);
		return this.decodeFn ? this.decodeFn.call(this, params, decodedAttrs) : void 0;
	}
	encode(params) {
		const encodedAttrs = this.encodeAttributes(params);
		return this.encodeFn ? this.encodeFn.call(this, params, encodedAttrs) : void 0;
	}
	static from(config$43) {
		const { xmlName, sdNodeOrKeyName, encode: encode$82, decode: decode$84, priority = 0, matchesEncode, matchesDecode, attributes } = config$43;
		if (typeof encode$82 !== "function" || !!decode$84 && typeof decode$84 !== "function") throw new TypeError(`${xmlName}: encode/decode must be functions`);
		const inst = new NodeTranslator(xmlName, sdNodeOrKeyName, encode$82, decode$84, priority, matchesEncode, matchesDecode, attributes);
		return Object.freeze(inst);
	}
	toString() {
		return `NodeTranslator(${this.xmlName}, priority=${this.priority})`;
	}
};
const encode$81 = (attributes) => {
	return attributes["w:type"];
};
const decode$83 = (attrs) => {
	const { lineBreakType } = attrs;
	return lineBreakType;
};
const attrConfig$38 = Object.freeze({
	xmlName: "w:type",
	sdName: "lineBreakType",
	encode: encode$81,
	decode: decode$83
});
const encode$80 = (attributes) => {
	return attributes["w:clear"];
};
const decode$82 = (attrs) => {
	const { clear } = attrs;
	return clear;
};
var attributes_default$9 = [attrConfig$38, Object.freeze({
	xmlName: "w:clear",
	sdName: "clear",
	encode: encode$80,
	decode: decode$82
})];
var XML_NODE_NAME$43 = "w:br";
var SD_NODE_NAME$37 = "lineBreak";
var encode$79 = (_, encodedAttrs) => {
	const translated = { type: encodedAttrs?.lineBreakType === "page" ? "hardBreak" : "lineBreak" };
	if (encodedAttrs) translated.attrs = { ...encodedAttrs };
	return translated;
};
var decode$81 = (params, decodedAttrs) => {
	const { node } = params;
	if (!node) return;
	const wBreak = { name: "w:br" };
	if (decodedAttrs) wBreak.attributes = { ...decodedAttrs };
	if (node.type === "hardBreak" && (!wBreak.attributes || !wBreak.attributes["w:type"])) wBreak.attributes = {
		...wBreak.attributes,
		"w:type": "page"
	};
	return {
		name: "w:r",
		elements: [wBreak]
	};
};
const config$42 = {
	xmlName: XML_NODE_NAME$43,
	sdNodeOrKeyName: SD_NODE_NAME$37,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$79,
	decode: decode$81,
	attributes: attributes_default$9
};
const translator$1 = NodeTranslator.from(config$42);
const encode$78 = (attributes) => attributes?.["w:val"];
const decode$80 = (attrs) => attrs?.highlight;
var attributes_default$8 = [Object.freeze({
	xmlName: "w:val",
	sdName: "highlight",
	encode: encode$78,
	decode: decode$80
})];
var XML_NODE_NAME$42 = "w:highlight";
var SD_ATTR_KEY$4 = "highlight";
var DISABLED_TOKENS = new Set([
	"transparent",
	"none",
	"inherit"
]);
var encode$77 = (params, encodedAttrs = {}) => {
	const { nodes } = params;
	const node = nodes?.[0];
	const value = encodedAttrs.highlight ?? node?.attributes?.["w:val"];
	return {
		type: "attr",
		xmlName: XML_NODE_NAME$42,
		sdNodeOrKeyName: SD_ATTR_KEY$4,
		attributes: { "w:val": value ?? null }
	};
};
var decode$79 = (params) => {
	const attrs = params?.node?.attrs || {};
	const highlightValue = attrs.highlight?.["w:val"] ?? attrs.highlight ?? attrs.color ?? null;
	if (!highlightValue) return void 0;
	const normalizedValue = String(highlightValue).trim().toLowerCase();
	if (!normalizedValue) return void 0;
	if (DISABLED_TOKENS.has(normalizedValue)) return {
		name: XML_NODE_NAME$42,
		attributes: { "w:val": "none" }
	};
	const keyword = getDocxHighlightKeywordFromHex(highlightValue);
	if (keyword) return {
		name: XML_NODE_NAME$42,
		attributes: { "w:val": keyword }
	};
	const fill = normalizeHexColor(highlightValue);
	if (!fill) return void 0;
	return {
		name: "w:shd",
		attributes: {
			"w:color": "auto",
			"w:val": "clear",
			"w:fill": fill
		}
	};
};
const config$41 = {
	xmlName: XML_NODE_NAME$42,
	sdNodeOrKeyName: SD_ATTR_KEY$4,
	type: NodeTranslator.translatorTypes.ATTRIBUTE,
	encode: encode$77,
	decode: decode$79,
	attributes: attributes_default$8
};
const translator$2 = NodeTranslator.from(config$41);
const encode$76 = (attributes) => {
	return attributes["w:val"];
};
const decode$78 = (attrs) => {
	const { tabType } = attrs || {};
	return tabType;
};
const attrConfig$34 = Object.freeze({
	xmlName: "w:val",
	sdName: "tabType",
	encode: encode$76,
	decode: decode$78
});
const encode$75 = (attributes) => {
	return attributes["w:leader"];
};
const decode$77 = (attrs) => {
	const { leader } = attrs || {};
	return leader;
};
const attrConfig$35 = Object.freeze({
	xmlName: "w:leader",
	sdName: "leader",
	encode: encode$75,
	decode: decode$77
});
const encode$74 = (attributes) => {
	if (attributes["w:pos"] != null) return parseInt(attributes["w:pos"]);
	return null;
};
const decode$76 = (attrs) => {
	const { pos } = attrs || {};
	return pos?.toString();
};
var attributes_default$6 = [
	attrConfig$34,
	Object.freeze({
		xmlName: "w:pos",
		sdName: "pos",
		encode: encode$74,
		decode: decode$76
	}),
	attrConfig$35
];
var DocumentApiValidationError = class DocumentApiValidationError extends Error {
	constructor(code$1, message, details) {
		super(message);
		this.name = "DocumentApiValidationError";
		this.code = code$1;
		this.details = details;
		Object.setPrototypeOf(this, DocumentApiValidationError.prototype);
	}
};
const NODE_KINDS = ["block", "inline"];
const NODE_TYPES = [
	"paragraph",
	"heading",
	"listItem",
	"table",
	"tableRow",
	"tableCell",
	"tableOfContents",
	"image",
	"sdt",
	"run",
	"bookmark",
	"comment",
	"hyperlink",
	"footnoteRef",
	"endnoteRef",
	"crossRef",
	"indexEntry",
	"citation",
	"authorityEntry",
	"sequenceField",
	"tab",
	"lineBreak"
];
const BLOCK_NODE_TYPES = [
	"paragraph",
	"heading",
	"listItem",
	"table",
	"tableRow",
	"tableCell",
	"tableOfContents",
	"image",
	"sdt"
];
const DELETABLE_BLOCK_NODE_TYPES = [
	"paragraph",
	"heading",
	"listItem",
	"table",
	"sdt"
];
const INLINE_NODE_TYPES = [
	"run",
	"bookmark",
	"comment",
	"hyperlink",
	"sdt",
	"image",
	"footnoteRef",
	"endnoteRef",
	"crossRef",
	"indexEntry",
	"citation",
	"authorityEntry",
	"sequenceField",
	"tab",
	"lineBreak"
];
const SELECTION_EDGE_NODE_TYPES = [
	"paragraph",
	"heading",
	"table",
	"tableOfContents",
	"sdt",
	"image"
];
const MARK_KEYS = [
	"bold",
	"italic",
	"underline",
	"strike"
];
const INLINE_DIRECTIVES = [
	"on",
	"off",
	"clear"
];
const MAX_PLAN_STEPS = 200;
const MAX_PLAN_RESOLVED_TARGETS = 500;
const SNIPPET_MAX_LENGTH = 500;
const SNIPPET_CONTEXT_CHARS = 100;
function buildResolvedHandle(ref$1, refStability, targetKind) {
	return {
		ref: ref$1,
		refStability,
		targetKind
	};
}
function buildDiscoveryItem(id, handle, domain) {
	return {
		id,
		handle,
		...domain
	};
}
function buildDiscoveryResult(params) {
	if (params.page.returned !== params.items.length) throw new Error(`DiscoveryResult invariant violated: page.returned (${params.page.returned}) !== items.length (${params.items.length})`);
	const result = {
		evaluatedRevision: params.evaluatedRevision,
		total: params.total,
		items: params.items,
		page: params.page
	};
	if (params.meta !== void 0) result.meta = params.meta;
	return result;
}
const SD_CONTENT_NODE_KINDS = [
	"paragraph",
	"heading",
	"list",
	"table",
	"toc",
	"index",
	"bibliography",
	"tableOfAuthorities",
	"break",
	"sectionBreak",
	"sectPr",
	"image",
	"drawing",
	"sdt",
	"customXml",
	"altChunk",
	"math",
	"field"
];
const SD_INLINE_NODE_KINDS = [
	"run",
	"hyperlink",
	"crossRef",
	"indexEntry",
	"sequenceField",
	"citation",
	"authorityEntry",
	"tocEntry",
	"image",
	"drawing",
	"sdt",
	"customXml",
	"math",
	"field",
	"tab",
	"lineBreak",
	"footnoteRef",
	"endnoteRef"
];
const PLACEMENT_VALUES = new Set([
	"before",
	"after",
	"insideStart",
	"insideEnd"
]);
const DEFAULT_PLACEMENT = "after";
const TABLE_NESTING_POLICY_VALUES = new Set(["forbid", "allow"]);
const DEFAULT_NESTING_POLICY = Object.freeze({ tables: "forbid" });
const STORY_TYPES = [
	"body",
	"headerFooterSlot",
	"headerFooterPart",
	"footnote",
	"endnote"
];
const STORY_HEADER_FOOTER_KINDS = ["header", "footer"];
const STORY_HEADER_FOOTER_VARIANTS = [
	"default",
	"first",
	"even"
];
const STORY_HEADER_FOOTER_RESOLUTIONS = ["effective", "explicit"];
const STORY_HEADER_FOOTER_ON_WRITE_VALUES = [
	"materializeIfInherited",
	"editResolvedPart",
	"error"
];
function isStoryLocator(value) {
	if (!isObjectRecord$1(value) || value.kind !== "story" || !isStringEnumMember(value.storyType, STORY_TYPES)) return false;
	switch (value.storyType) {
		case "body": return true;
		case "headerFooterSlot": return isSectionAddress(value.section) && isStringEnumMember(value.headerFooterKind, STORY_HEADER_FOOTER_KINDS) && isStringEnumMember(value.variant, STORY_HEADER_FOOTER_VARIANTS) && isOptionalStringEnumMember(value.resolution, STORY_HEADER_FOOTER_RESOLUTIONS) && isOptionalStringEnumMember(value.onWrite, STORY_HEADER_FOOTER_ON_WRITE_VALUES);
		case "headerFooterPart": return isNonEmptyString$2(value.refId);
		case "footnote":
		case "endnote": return isNonEmptyString$2(value.noteId);
	}
}
function getStoryHeaderFooterResolution(locator) {
	return locator.resolution ?? "effective";
}
function getStoryHeaderFooterOnWrite(locator) {
	return locator.onWrite ?? "materializeIfInherited";
}
function storyLocatorToKey(locator) {
	switch (locator.storyType) {
		case "body": return "story:body";
		case "headerFooterSlot": return [
			"story:headerFooterSlot",
			locator.section.sectionId,
			locator.headerFooterKind,
			locator.variant,
			getStoryHeaderFooterResolution(locator),
			getStoryHeaderFooterOnWrite(locator)
		].join(":");
		case "headerFooterPart": return `story:headerFooterPart:${locator.refId}`;
		case "footnote": return `story:footnote:${locator.noteId}`;
		case "endnote": return `story:endnote:${locator.noteId}`;
	}
}
function isObjectRecord$1(value) {
	return typeof value === "object" && value !== null;
}
function isNonEmptyString$2(value) {
	return typeof value === "string" && value.length > 0;
}
function isStringEnumMember(value, allowed) {
	return typeof value === "string" && allowed.includes(value);
}
function isOptionalStringEnumMember(value, allowed) {
	return value === void 0 || isStringEnumMember(value, allowed);
}
function isSectionAddress(value) {
	return isObjectRecord$1(value) && value.kind === "section" && typeof value.sectionId === "string" && value.sectionId.length > 0;
}
function assertTargetPresent(target, operationName) {
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target.`);
}
function isRecord(value) {
	return typeof value === "object" && value != null && !Array.isArray(value);
}
function isInteger(value) {
	return typeof value === "number" && Number.isInteger(value);
}
function isTextAddress(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "text") return false;
	if (typeof value.blockId !== "string") return false;
	const range = value.range;
	if (!isRecord(range)) return false;
	if (!isInteger(range.start) || !isInteger(range.end)) return false;
	return range.start <= range.end;
}
function isTextTarget(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "text") return false;
	const segments = value.segments;
	if (!Array.isArray(segments) || segments.length === 0) return false;
	for (const seg of segments) {
		if (!isRecord(seg)) return false;
		if (typeof seg.blockId !== "string") return false;
		const range = seg.range;
		if (!isRecord(range)) return false;
		if (!isInteger(range.start) || !isInteger(range.end)) return false;
		if (range.start > range.end) return false;
	}
	return true;
}
var BLOCK_NODE_TYPES_SET = new Set(BLOCK_NODE_TYPES);
function isBlockNodeAddress(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "block") return false;
	if (typeof value.nodeType !== "string" || !BLOCK_NODE_TYPES_SET.has(value.nodeType)) return false;
	if (typeof value.nodeId !== "string") return false;
	return true;
}
function assertNoUnknownFields(input, allowlist, operationName) {
	for (const key of Object.keys(input)) if (!allowlist.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${key}" on ${operationName} input. Allowed fields: ${[...allowlist].join(", ")}.`, { field: key });
}
var NESTING_POLICY_ALLOWED_KEYS = new Set(["tables"]);
function validateNestingPolicyValue(value) {
	if (value === void 0) return;
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_INPUT", `nestingPolicy must be an object, got ${typeof value}.`, {
		field: "nestingPolicy",
		value
	});
	for (const key of Object.keys(value)) if (!NESTING_POLICY_ALLOWED_KEYS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${key}" on nestingPolicy. Allowed fields: ${[...NESTING_POLICY_ALLOWED_KEYS].join(", ")}.`, { field: `nestingPolicy.${key}` });
	if (value.tables !== void 0 && (typeof value.tables !== "string" || !TABLE_NESTING_POLICY_VALUES.has(value.tables))) throw new DocumentApiValidationError("INVALID_INPUT", `nestingPolicy.tables must be one of: forbid, allow. Got "${String(value.tables)}".`, {
		field: "nestingPolicy.tables",
		value: value.tables
	});
}
var schemaBooleanOrNull = () => ({ oneOf: [{ type: "boolean" }, { type: "null" }] });
var schemaStringOrNull = () => ({ oneOf: [{
	type: "string",
	minLength: 1
}, { type: "null" }] });
var schemaNumberOrNull = () => ({ oneOf: [{ type: "number" }, { type: "null" }] });
var schemaObjectOrNull = (properties) => ({ oneOf: [{
	type: "object",
	properties,
	additionalProperties: false,
	minProperties: 1
}, { type: "null" }] });
var UNDERLINE_OBJECT_SCHEMA = {
	type: "object",
	properties: {
		style: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		color: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		themeColor: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] }
	},
	additionalProperties: false,
	minProperties: 1
};
var STYLISTIC_SET_ITEM_SCHEMA = {
	type: "object",
	properties: {
		id: { type: "number" },
		val: { type: "boolean" }
	},
	required: ["id"],
	additionalProperties: false
};
var schemaUnderlinePatch = () => ({ oneOf: [
	{ type: "boolean" },
	{ type: "null" },
	UNDERLINE_OBJECT_SCHEMA
] });
var schemaStylisticSets = () => ({ oneOf: [{
	type: "array",
	items: STYLISTIC_SET_ITEM_SCHEMA,
	minItems: 1
}, { type: "null" }] });
function markCarrier(markName, textStyleAttr) {
	return {
		storage: "mark",
		markName,
		textStyleAttr
	};
}
function runAttributeCarrier(runPropertyKey) {
	return {
		storage: "runAttribute",
		nodeName: "run",
		runPropertyKey
	};
}
var markBoolean = (key, ooxmlElement, markName) => ({
	key,
	type: "boolean",
	ooxmlElement,
	storage: "mark",
	tracked: true,
	carrier: markCarrier(markName),
	schema: schemaBooleanOrNull()
});
var markTextStyleValue = (key, type, ooxmlElement, schema, textStyleAttr) => ({
	key,
	type,
	ooxmlElement,
	storage: "mark",
	tracked: true,
	carrier: markCarrier("textStyle", textStyleAttr ?? key),
	schema
});
var runAttribute = (key, type, ooxmlElement, schema, runPropertyKey) => ({
	key,
	type,
	ooxmlElement,
	storage: "runAttribute",
	tracked: false,
	carrier: runAttributeCarrier(runPropertyKey ?? key),
	schema
});
const INLINE_PROPERTY_REGISTRY = [
	markBoolean("bold", "w:b", "bold"),
	markBoolean("italic", "w:i", "italic"),
	markBoolean("strike", "w:strike", "strike"),
	{
		key: "underline",
		type: "object",
		ooxmlElement: "w:u",
		storage: "mark",
		tracked: true,
		carrier: markCarrier("underline"),
		schema: schemaUnderlinePatch()
	},
	{
		key: "highlight",
		type: "string",
		ooxmlElement: "w:highlight",
		storage: "mark",
		tracked: true,
		carrier: markCarrier("highlight"),
		schema: schemaStringOrNull()
	},
	markTextStyleValue("color", "string", "w:color", schemaStringOrNull()),
	markTextStyleValue("fontSize", "number", "w:sz", schemaNumberOrNull()),
	markTextStyleValue("fontFamily", "string", "w:rFonts", schemaStringOrNull()),
	markTextStyleValue("letterSpacing", "number", "w:spacing", schemaNumberOrNull()),
	markTextStyleValue("vertAlign", "string", "w:vertAlign", { oneOf: [{ enum: [
		"superscript",
		"subscript",
		"baseline"
	] }, { type: "null" }] }),
	markTextStyleValue("position", "number", "w:position", schemaNumberOrNull()),
	runAttribute("dstrike", "boolean", "w:dstrike", schemaBooleanOrNull()),
	runAttribute("smallCaps", "boolean", "w:smallCaps", schemaBooleanOrNull()),
	markTextStyleValue("caps", "boolean", "w:caps", schemaBooleanOrNull(), "textTransform"),
	runAttribute("shading", "object", "w:shd", schemaObjectOrNull({
		fill: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		color: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		val: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] }
	})),
	runAttribute("border", "object", "w:bdr", schemaObjectOrNull({
		val: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		sz: { oneOf: [{ type: "number" }, { type: "null" }] },
		color: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		space: { oneOf: [{ type: "number" }, { type: "null" }] }
	}), "borders"),
	runAttribute("outline", "boolean", "w:outline", schemaBooleanOrNull()),
	runAttribute("shadow", "boolean", "w:shadow", schemaBooleanOrNull()),
	runAttribute("emboss", "boolean", "w:emboss", schemaBooleanOrNull()),
	runAttribute("imprint", "boolean", "w:imprint", schemaBooleanOrNull()),
	runAttribute("charScale", "number", "w:w", schemaNumberOrNull(), "w"),
	runAttribute("kerning", "number", "w:kern", schemaNumberOrNull(), "kern"),
	runAttribute("vanish", "boolean", "w:vanish", schemaBooleanOrNull()),
	runAttribute("webHidden", "boolean", "w:webHidden", schemaBooleanOrNull()),
	runAttribute("specVanish", "boolean", "w:specVanish", schemaBooleanOrNull()),
	runAttribute("rtl", "boolean", "w:rtl", schemaBooleanOrNull()),
	runAttribute("cs", "boolean", "w:cs", schemaBooleanOrNull()),
	runAttribute("bCs", "boolean", "w:bCs", schemaBooleanOrNull(), "boldCs"),
	runAttribute("iCs", "boolean", "w:iCs", schemaBooleanOrNull(), "italicCs"),
	runAttribute("eastAsianLayout", "object", "w:eastAsianLayout", schemaObjectOrNull({
		id: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		combine: { oneOf: [{ type: "boolean" }, { type: "null" }] },
		combineBrackets: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		vert: { oneOf: [{ type: "boolean" }, { type: "null" }] },
		vertCompress: { oneOf: [{ type: "boolean" }, { type: "null" }] }
	})),
	runAttribute("em", "string", "w:em", schemaStringOrNull()),
	runAttribute("fitText", "object", "w:fitText", schemaObjectOrNull({
		val: { oneOf: [{ type: "number" }, { type: "null" }] },
		id: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] }
	})),
	runAttribute("snapToGrid", "boolean", "w:snapToGrid", schemaBooleanOrNull()),
	runAttribute("lang", "object", "w:lang", schemaObjectOrNull({
		val: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		eastAsia: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		bidi: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] }
	})),
	runAttribute("oMath", "boolean", "w:oMath", schemaBooleanOrNull()),
	runAttribute("rStyle", "string", "w:rStyle", schemaStringOrNull(), "styleId"),
	runAttribute("rFonts", "object", "w:rFonts", schemaObjectOrNull({
		ascii: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		hAnsi: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		eastAsia: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		cs: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		asciiTheme: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		hAnsiTheme: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		eastAsiaTheme: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		csTheme: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] },
		hint: { oneOf: [{
			type: "string",
			minLength: 1
		}, { type: "null" }] }
	}), "fontFamily"),
	runAttribute("fontSizeCs", "number", "w:szCs", schemaNumberOrNull()),
	runAttribute("ligatures", "string", "w14:ligatures", schemaStringOrNull()),
	runAttribute("numForm", "string", "w14:numForm", schemaStringOrNull()),
	runAttribute("numSpacing", "string", "w14:numSpacing", schemaStringOrNull()),
	runAttribute("stylisticSets", "array", "w14:stylisticSets", schemaStylisticSets()),
	runAttribute("contextualAlternates", "boolean", "w14:cntxtAlts", schemaBooleanOrNull())
];
const INLINE_PROPERTY_KEY_SET = new Set(INLINE_PROPERTY_REGISTRY.map((entry) => entry.key));
const INLINE_PROPERTY_BY_KEY = Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => [entry.key, entry]));
INLINE_PROPERTY_REGISTRY.filter((entry) => entry.storage === "mark").map((entry) => entry.key), INLINE_PROPERTY_REGISTRY.filter((entry) => entry.storage === "runAttribute").map((entry) => entry.key);
var UNDERLINE_OBJECT_ALLOWED_KEYS = new Set([
	"style",
	"color",
	"themeColor"
]);
var SHADING_ALLOWED_KEYS = new Set([
	"fill",
	"color",
	"val"
]);
var BORDER_ALLOWED_KEYS = new Set([
	"val",
	"sz",
	"color",
	"space"
]);
var FIT_TEXT_ALLOWED_KEYS = new Set(["val", "id"]);
var LANG_ALLOWED_KEYS = new Set([
	"val",
	"eastAsia",
	"bidi"
]);
var RFONTS_ALLOWED_KEYS = new Set([
	"ascii",
	"hAnsi",
	"eastAsia",
	"cs",
	"asciiTheme",
	"hAnsiTheme",
	"eastAsiaTheme",
	"csTheme",
	"hint"
]);
var EAST_ASIAN_LAYOUT_ALLOWED_KEYS = new Set([
	"id",
	"combine",
	"combineBrackets",
	"vert",
	"vertCompress"
]);
var STYLISTIC_SET_ALLOWED_KEYS = new Set(["id", "val"]);
var VERT_ALIGN_VALUES = new Set([
	"superscript",
	"subscript",
	"baseline"
]);
function isObjectPatch(value) {
	return isRecord(value) && !Array.isArray(value);
}
function assertNonEmptyObject(value, propertyKey) {
	if (Object.keys(value).length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `inline.${propertyKey} object must not be empty.`, { field: `inline.${propertyKey}` });
}
function assertAllowedObjectKeys(objectValue, allowedKeys, propertyKey) {
	for (const key of Object.keys(objectValue)) if (!allowedKeys.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown inline.${propertyKey} key "${key}".`, { field: `inline.${propertyKey}.${key}` });
}
function assertStringOrNull(value, field) {
	if (value === null || value === void 0) return;
	if (typeof value !== "string" || value.trim().length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a non-empty string or null.`, {
		field,
		value
	});
}
function assertBooleanOrNull(value, field) {
	if (value === null || value === void 0) return;
	if (typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be boolean or null.`, {
		field,
		value
	});
}
function assertNumberOrNull(value, field) {
	if (value === null || value === void 0) return;
	if (typeof value !== "number" || !Number.isFinite(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a finite number or null.`, {
		field,
		value
	});
}
function assertVertAlignOrNull(value, field) {
	if (value === null || value === void 0) return;
	if (typeof value !== "string" || !VERT_ALIGN_VALUES.has(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be one of superscript, subscript, baseline, or null.`, {
		field,
		value
	});
}
function validateUnderlinePatch(value) {
	if (value === null || typeof value === "boolean") return;
	if (!isObjectPatch(value)) throw new DocumentApiValidationError("INVALID_INPUT", "inline.underline must be true/false/null or an object patch.", {
		field: "inline.underline",
		value
	});
	assertNonEmptyObject(value, "underline");
	assertAllowedObjectKeys(value, UNDERLINE_OBJECT_ALLOWED_KEYS, "underline");
	assertStringOrNull(value.style, "inline.underline.style");
	assertStringOrNull(value.color, "inline.underline.color");
	assertStringOrNull(value.themeColor, "inline.underline.themeColor");
}
function validateObjectPatch(value, propertyKey, allowedKeys, validators) {
	if (value === null) return;
	if (!isObjectPatch(value)) throw new DocumentApiValidationError("INVALID_INPUT", `inline.${propertyKey} must be an object or null.`, {
		field: `inline.${propertyKey}`,
		value
	});
	assertNonEmptyObject(value, propertyKey);
	assertAllowedObjectKeys(value, allowedKeys, propertyKey);
	for (const key of Object.keys(value)) {
		const validator = validators[key];
		if (validator) validator(value[key], `inline.${propertyKey}.${key}`);
	}
}
function validateStylisticSets(value) {
	if (value === null) return;
	if (!Array.isArray(value)) throw new DocumentApiValidationError("INVALID_INPUT", "inline.stylisticSets must be an array or null.", {
		field: "inline.stylisticSets",
		value
	});
	if (value.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "inline.stylisticSets array must not be empty.", { field: "inline.stylisticSets" });
	value.forEach((item, index) => {
		if (!isObjectPatch(item)) throw new DocumentApiValidationError("INVALID_INPUT", `inline.stylisticSets[${index}] must be an object with id/val fields.`, {
			field: `inline.stylisticSets[${index}]`,
			value: item
		});
		assertAllowedObjectKeys(item, STYLISTIC_SET_ALLOWED_KEYS, `stylisticSets[${index}]`);
		if (typeof item.id !== "number" || !Number.isFinite(item.id)) throw new DocumentApiValidationError("INVALID_INPUT", `inline.stylisticSets[${index}].id must be a number.`, {
			field: `inline.stylisticSets[${index}].id`,
			value: item.id
		});
		if (item.val !== void 0 && typeof item.val !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `inline.stylisticSets[${index}].val must be boolean when provided.`, {
			field: `inline.stylisticSets[${index}].val`,
			value: item.val
		});
	});
}
var PROPERTY_VALIDATOR_MAP = {
	bold: assertBooleanOrNull,
	italic: assertBooleanOrNull,
	strike: assertBooleanOrNull,
	dstrike: assertBooleanOrNull,
	smallCaps: assertBooleanOrNull,
	caps: assertBooleanOrNull,
	outline: assertBooleanOrNull,
	shadow: assertBooleanOrNull,
	emboss: assertBooleanOrNull,
	imprint: assertBooleanOrNull,
	rtl: assertBooleanOrNull,
	cs: assertBooleanOrNull,
	bCs: assertBooleanOrNull,
	iCs: assertBooleanOrNull,
	vanish: assertBooleanOrNull,
	webHidden: assertBooleanOrNull,
	specVanish: assertBooleanOrNull,
	snapToGrid: assertBooleanOrNull,
	oMath: assertBooleanOrNull,
	contextualAlternates: assertBooleanOrNull,
	underline: (value) => validateUnderlinePatch(value),
	highlight: assertStringOrNull,
	color: assertStringOrNull,
	fontFamily: assertStringOrNull,
	rStyle: assertStringOrNull,
	em: assertStringOrNull,
	ligatures: assertStringOrNull,
	numForm: assertStringOrNull,
	numSpacing: assertStringOrNull,
	fontSize: assertNumberOrNull,
	fontSizeCs: assertNumberOrNull,
	letterSpacing: assertNumberOrNull,
	charScale: assertNumberOrNull,
	kerning: assertNumberOrNull,
	position: assertNumberOrNull,
	vertAlign: assertVertAlignOrNull,
	shading: (value) => validateObjectPatch(value, "shading", SHADING_ALLOWED_KEYS, {
		fill: assertStringOrNull,
		color: assertStringOrNull,
		val: assertStringOrNull
	}),
	border: (value) => validateObjectPatch(value, "border", BORDER_ALLOWED_KEYS, {
		val: assertStringOrNull,
		color: assertStringOrNull,
		sz: assertNumberOrNull,
		space: assertNumberOrNull
	}),
	fitText: (value) => validateObjectPatch(value, "fitText", FIT_TEXT_ALLOWED_KEYS, {
		val: assertNumberOrNull,
		id: assertStringOrNull
	}),
	lang: (value) => validateObjectPatch(value, "lang", LANG_ALLOWED_KEYS, {
		val: assertStringOrNull,
		eastAsia: assertStringOrNull,
		bidi: assertStringOrNull
	}),
	rFonts: (value) => validateObjectPatch(value, "rFonts", RFONTS_ALLOWED_KEYS, {
		ascii: assertStringOrNull,
		hAnsi: assertStringOrNull,
		eastAsia: assertStringOrNull,
		cs: assertStringOrNull,
		asciiTheme: assertStringOrNull,
		hAnsiTheme: assertStringOrNull,
		eastAsiaTheme: assertStringOrNull,
		csTheme: assertStringOrNull,
		hint: assertStringOrNull
	}),
	eastAsianLayout: (value) => validateObjectPatch(value, "eastAsianLayout", EAST_ASIAN_LAYOUT_ALLOWED_KEYS, {
		id: assertStringOrNull,
		combine: assertBooleanOrNull,
		combineBrackets: assertStringOrNull,
		vert: assertBooleanOrNull,
		vertCompress: assertBooleanOrNull
	}),
	stylisticSets: (value) => validateStylisticSets(value)
};
function validateInlineProperty(key, value) {
	if (!Object.prototype.hasOwnProperty.call(PROPERTY_VALIDATOR_MAP, key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown inline property: "${key}".`, { field: key });
	const validator = PROPERTY_VALIDATOR_MAP[key];
	validator(value, `inline.${key}`);
}
function validateInlineRunPatch(patch) {
	if (!isObjectPatch(patch)) throw new DocumentApiValidationError("INVALID_INPUT", "inline must be a non-null object.", {
		field: "inline",
		value: patch
	});
	const keys$1 = Object.keys(patch);
	if (keys$1.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "inline must include at least one known key.");
	for (const key of keys$1) validateInlineProperty(key, patch[key]);
}
function buildInlineRunPatchSchema() {
	return {
		type: "object",
		properties: Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => [entry.key, entry.schema])),
		additionalProperties: false,
		minProperties: 1
	};
}
var NONE_FAILURES = [];
var NONE_THROWS = [];
function readOperation(options = {}) {
	return {
		mutates: false,
		idempotency: options.idempotency ?? "idempotent",
		supportsDryRun: false,
		supportsTrackedMode: false,
		possibleFailureCodes: options.possibleFailureCodes ?? NONE_FAILURES,
		throws: {
			preApply: options.throws ?? NONE_THROWS,
			postApplyForbidden: true
		},
		deterministicTargetResolution: options.deterministicTargetResolution ?? true,
		remediationHints: options.remediationHints
	};
}
function mutationOperation(options) {
	return {
		mutates: true,
		idempotency: options.idempotency,
		supportsDryRun: options.supportsDryRun,
		supportsTrackedMode: options.supportsTrackedMode,
		possibleFailureCodes: options.possibleFailureCodes,
		throws: {
			preApply: options.throws,
			postApplyForbidden: true
		},
		deterministicTargetResolution: options.deterministicTargetResolution ?? true,
		remediationHints: options.remediationHints,
		historyUnsafe: options.historyUnsafe,
		returnsPromise: options.returnsPromise
	};
}
var T_NOT_FOUND = ["TARGET_NOT_FOUND"];
var T_NOT_FOUND_CAPABLE = ["TARGET_NOT_FOUND", "CAPABILITY_UNAVAILABLE"];
var T_PLAN_ENGINE = [
	"REVISION_MISMATCH",
	"MATCH_NOT_FOUND",
	"AMBIGUOUS_MATCH",
	"STYLE_CONFLICT",
	"PRECONDITION_FAILED",
	"INVALID_INPUT",
	"CROSS_BLOCK_MATCH",
	"SPAN_FRAGMENTED",
	"TARGET_MOVED",
	"PLAN_CONFLICT_OVERLAP",
	"INVALID_STEP_COMBINATION",
	"REVISION_CHANGED_SINCE_COMPILE",
	"INVALID_INSERTION_CONTEXT",
	"DOCUMENT_IDENTITY_CONFLICT",
	"CAPABILITY_UNAVAILABLE"
];
var T_NOT_FOUND_COMMAND = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"CAPABILITY_UNAVAILABLE"
];
var T_IMAGE_COMMAND = [
	"TARGET_NOT_FOUND",
	"AMBIGUOUS_TARGET",
	"INVALID_TARGET",
	"CAPABILITY_UNAVAILABLE"
];
var T_CC_READ = [
	"TARGET_NOT_FOUND",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE"
];
var T_CC_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"AMBIGUOUS_TARGET",
	"INVALID_INPUT",
	"LOCK_VIOLATION",
	"REVISION_MISMATCH",
	"CAPABILITY_UNAVAILABLE"
];
var T_CC_TYPED = [...T_CC_MUTATION, "TYPE_MISMATCH"];
var T_CC_TYPED_READ = [...T_CC_READ, "TYPE_MISMATCH"];
var T_CC_RAW = [
	"TARGET_NOT_FOUND",
	"INVALID_INPUT",
	"REVISION_MISMATCH",
	"CAPABILITY_UNAVAILABLE"
];
var T_QUERY_MATCH = [
	"MATCH_NOT_FOUND",
	"AMBIGUOUS_MATCH",
	"INVALID_INPUT",
	"INTERNAL_ERROR"
];
var T_SECTION_CREATE = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"AMBIGUOUS_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE",
	"INTERNAL_ERROR"
];
var T_SECTION_READ = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE"
];
var T_PARAGRAPH_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"CAPABILITY_UNAVAILABLE"
];
var T_SECTION_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE",
	"INTERNAL_ERROR"
];
var T_SECTION_SETTINGS_MUTATION = [
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE",
	"INTERNAL_ERROR"
];
var T_HEADER_FOOTER_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE",
	"INTERNAL_ERROR"
];
var T_STORY = [
	"STORY_NOT_FOUND",
	"STORY_MISMATCH",
	"STORY_NOT_SUPPORTED",
	"CROSS_STORY_PLAN",
	"MATERIALIZATION_FAILED"
];
var T_REF_READ_LIST = ["CAPABILITY_UNAVAILABLE", "INVALID_INPUT"];
var T_REF_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE"
];
var T_REF_MUTATION_REMOVE = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"CAPABILITY_UNAVAILABLE"
];
var T_REF_INSERT = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE"
];
var T_PROTECTION_READ = ["CAPABILITY_UNAVAILABLE"];
var T_PROTECTION_MUTATION = ["INVALID_INPUT", "CAPABILITY_UNAVAILABLE"];
var T_PERM_RANGE_READ = ["TARGET_NOT_FOUND", "CAPABILITY_UNAVAILABLE"];
var T_PERM_RANGE_MUTATION = [
	"TARGET_NOT_FOUND",
	"INVALID_TARGET",
	"INVALID_INPUT",
	"CAPABILITY_UNAVAILABLE"
];
function camelToKebab(value) {
	return value.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
}
function formatInlineAliasDescription(key) {
	if (key === "rtl") return "Set or clear the `rtl` inline run property on the target text range. This does not change paragraph direction; use `format.paragraph.setDirection` for paragraph-level RTL.";
	return `Set or clear the \`${key}\` inline run property on the target text range.`;
}
function formatInlineAliasExpectedResult(key) {
	if (key === "rtl") return "Returns a TextMutationReceipt confirming only the inline run property patch was applied to the target range; paragraph direction is unchanged.";
	return "Returns a TextMutationReceipt confirming the inline run property patch was applied to the target range.";
}
var FORMAT_INLINE_ALIAS_OPERATION_DEFINITIONS = Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => {
	const operationId = `format.${entry.key}`;
	return [operationId, {
		memberPath: operationId,
		description: formatInlineAliasDescription(entry.key),
		expectedResult: formatInlineAliasExpectedResult(entry.key),
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: entry.tracked,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				...T_STORY
			]
		}),
		referenceDocPath: `format/${camelToKebab(entry.key)}.mdx`,
		referenceGroup: "format",
		skipAsATool: true
	}];
}));
const OPERATION_DEFINITIONS = {
	get: {
		memberPath: "get",
		description: "Read the full document as an SDDocument structure.",
		expectedResult: "Returns an SDDocument with body content projected into SDM/1 canonical shapes.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "get.mdx",
		referenceGroup: "core"
	},
	find: {
		memberPath: "find",
		description: "Search the document for text or node matches using SDM/1 selectors. Returns discovery-grade results: for mutation targeting, use query.match instead.",
		expectedResult: "Returns an SDFindResult envelope ({ total, limit, offset, items }). Each item is an SDNodeResult ({ node, address }).",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"CAPABILITY_UNAVAILABLE",
				"INVALID_INPUT",
				"ADDRESS_STALE",
				...T_STORY
			],
			deterministicTargetResolution: false
		}),
		referenceDocPath: "find.mdx",
		referenceGroup: "core",
		skipAsATool: true
	},
	getNode: {
		memberPath: "getNode",
		description: "Retrieve a single node by target position.",
		expectedResult: "Returns an SDNodeResult envelope with the projected SDM/1 node and canonical address.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [...T_NOT_FOUND, "ADDRESS_STALE"]
		}),
		referenceDocPath: "get-node.mdx",
		referenceGroup: "core"
	},
	getNodeById: {
		memberPath: "getNodeById",
		description: "Retrieve a single node by its unique ID.",
		expectedResult: "Returns an SDNodeResult envelope with the projected SDM/1 node and canonical address.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "get-node-by-id.mdx",
		referenceGroup: "core"
	},
	getText: {
		memberPath: "getText",
		description: "Extract the plain-text content of the document.",
		expectedResult: "Returns the full plain-text content of the document as a string.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: [...T_STORY] }),
		referenceDocPath: "get-text.mdx",
		referenceGroup: "core",
		intentGroup: "get_content",
		intentAction: "text"
	},
	getMarkdown: {
		memberPath: "getMarkdown",
		description: "Extract the document content as a Markdown string.",
		expectedResult: "Returns the full document content as a Markdown-formatted string.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: [...T_STORY] }),
		referenceDocPath: "get-markdown.mdx",
		referenceGroup: "core",
		intentGroup: "get_content",
		intentAction: "markdown"
	},
	getHtml: {
		memberPath: "getHtml",
		description: "Extract the document content as an HTML string.",
		expectedResult: "Returns the full document content as an HTML-formatted string.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: [...T_STORY] }),
		referenceDocPath: "get-html.mdx",
		referenceGroup: "core",
		intentGroup: "get_content",
		intentAction: "html"
	},
	markdownToFragment: {
		memberPath: "markdownToFragment",
		description: "Convert a Markdown string into an SDM/1 structural fragment.",
		expectedResult: "Returns an SDMarkdownToFragmentResult with the converted fragment, lossy flag, and diagnostics.",
		requiresDocumentContext: true,
		metadata: readOperation(),
		referenceDocPath: "markdown-to-fragment.mdx",
		referenceGroup: "core"
	},
	info: {
		memberPath: "info",
		description: "Return document summary info including word, character, paragraph, heading, table, image, comment, tracked-change, SDT-field, list, and page counts, plus outline and capabilities.",
		expectedResult: "Returns a DocumentInfo object with counts (words, characters, paragraphs, headings, tables, images, comments, trackedChanges, sdtFields, lists, and optionally pages when pagination is active), document outline, capability flags, and revision.",
		requiresDocumentContext: true,
		metadata: readOperation(),
		referenceDocPath: "info.mdx",
		referenceGroup: "core",
		intentGroup: "get_content",
		intentAction: "info"
	},
	extract: {
		memberPath: "extract",
		description: "Extract all document content with stable IDs for RAG pipelines. Returns blocks with full text, comments, and tracked changes: each with an ID compatible with scrollToElement().",
		expectedResult: "Returns an ExtractResult with blocks (nodeId, type, text, headingLevel), comments (entityId, text, anchoredText, blockId, status, author), tracked changes (entityId, type, excerpt, author, date), and revision.",
		requiresDocumentContext: true,
		metadata: readOperation(),
		referenceDocPath: "extract.mdx",
		referenceGroup: "core",
		intentGroup: "get_content",
		intentAction: "extract"
	},
	clearContent: {
		memberPath: "clearContent",
		description: "Clear all document body content, leaving a single empty paragraph.",
		expectedResult: "Returns a Receipt with success status; reports NO_OP if the document is already empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: ["CAPABILITY_UNAVAILABLE"]
		}),
		referenceDocPath: "clear-content.mdx",
		referenceGroup: "core"
	},
	insert: {
		memberPath: "insert",
		description: "Insert content into the document. Two input shapes: text-based (value + type) inserts inline content at a SelectionTarget or ref position within an existing block; structural SDFragment (content) inserts one or more blocks as siblings relative to a BlockNodeAddress target. When target/ref is omitted, content appends at the end of the document. Text mode supports text (default), markdown, and html content types via the `type` field. Structural mode uses `placement` (before/after/insideStart/insideEnd) to position relative to the target block.",
		expectedResult: "Returns an SDMutationReceipt with applied status; resolution reports the inserted TextAddress for text insertion or a BlockNodeAddress for structural insertion. Receipt reports NO_OP if the insertion point is invalid or content is empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"NO_OP",
				"CAPABILITY_UNAVAILABLE",
				"UNSUPPORTED_ENVIRONMENT",
				"INVALID_NESTING",
				"INVALID_PLACEMENT",
				"INVALID_PAYLOAD",
				"CAPABILITY_UNSUPPORTED",
				"ADDRESS_STALE",
				"DUPLICATE_ID",
				"INVALID_CONTEXT",
				"RAW_MODE_REQUIRED",
				"PRESERVE_ONLY_VIOLATION",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				"ADDRESS_STALE",
				"DUPLICATE_ID",
				"RAW_MODE_REQUIRED",
				"PRESERVE_ONLY_VIOLATION",
				"CAPABILITY_UNSUPPORTED",
				...T_STORY
			]
		}),
		referenceDocPath: "insert.mdx",
		referenceGroup: "core",
		intentGroup: "edit",
		intentAction: "insert"
	},
	replace: {
		memberPath: "replace",
		description: "Replace content at a contiguous document selection. Text path accepts a SelectionTarget or ref plus replacement text. Structural path accepts a BlockNodeAddress (replaces whole block), SelectionTarget (expands to full covered block boundaries), or ref plus SDFragment content.",
		expectedResult: "Returns an SDMutationReceipt with applied status; receipt reports NO_OP if the target range already contains identical content.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"NO_OP",
				"INVALID_NESTING",
				"INVALID_PLACEMENT",
				"INVALID_PAYLOAD",
				"CAPABILITY_UNSUPPORTED",
				"ADDRESS_STALE",
				"DUPLICATE_ID",
				"INVALID_CONTEXT",
				"RAW_MODE_REQUIRED",
				"PRESERVE_ONLY_VIOLATION",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				"ADDRESS_STALE",
				"DUPLICATE_ID",
				"RAW_MODE_REQUIRED",
				"PRESERVE_ONLY_VIOLATION",
				"CAPABILITY_UNSUPPORTED",
				...T_STORY
			]
		}),
		referenceDocPath: "replace.mdx",
		referenceGroup: "core",
		intentGroup: "edit",
		intentAction: "replace"
	},
	delete: {
		memberPath: "delete",
		description: "Delete content at a contiguous document selection. Accepts a SelectionTarget or mutation-ready ref. Supports cross-block deletion and optional block-edge expansion via behavior mode.",
		expectedResult: "Returns a TextMutationReceipt with applied status; receipt reports NO_OP if the target range is collapsed or empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				...T_STORY
			]
		}),
		referenceDocPath: "delete.mdx",
		referenceGroup: "core",
		intentGroup: "edit",
		intentAction: "delete"
	},
	formatRange: {
		memberPath: "formatRange",
		description: "Legacy root-level alias for inline range formatting. Routes to `format.apply` for compatibility with older callers.",
		expectedResult: "Returns a TextMutationReceipt confirming inline styles were applied to the target range.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				...T_STORY
			]
		}),
		referenceDocPath: "format/apply.mdx",
		referenceGroup: "format",
		skipAsATool: true
	},
	"blocks.list": {
		memberPath: "blocks.list",
		description: "List top-level blocks in document order with IDs, types, text previews, and optional full text when includeText:true. Supports pagination via offset/limit and optional nodeType filtering.",
		expectedResult: "Returns a BlocksListResult with total block count, an ordered array of block entries (ordinal, nodeId, nodeType, textPreview, optional text, isEmpty), and the current document revision.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: ["INVALID_INPUT"] }),
		referenceDocPath: "blocks/list.mdx",
		referenceGroup: "blocks",
		intentGroup: "get_content",
		intentAction: "blocks"
	},
	"blocks.delete": {
		memberPath: "blocks.delete",
		description: "Delete an entire block node (paragraph, heading, list item, table, image, or sdt) deterministically.",
		expectedResult: "Returns a BlocksDeleteResult receipt confirming the block was removed, including a deletedBlock summary with ordinal, nodeType, and textPreview.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: [
				"TARGET_NOT_FOUND",
				"AMBIGUOUS_TARGET",
				"CAPABILITY_UNAVAILABLE",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"INTERNAL_ERROR"
			]
		}),
		referenceDocPath: "blocks/delete.mdx",
		referenceGroup: "blocks"
	},
	"blocks.deleteRange": {
		memberPath: "blocks.deleteRange",
		description: "Delete a contiguous range of top-level blocks between two endpoints (inclusive). Both endpoints must be direct children of the document node. Supports dry-run preview.",
		expectedResult: "Returns a BlocksDeleteRangeResult with deletedCount, deletedBlocks array (each with ordinal, nodeId, nodeType, textPreview), before/after revision, and dryRun flag.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: [
				"TARGET_NOT_FOUND",
				"AMBIGUOUS_TARGET",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE",
				"INTERNAL_ERROR"
			]
		}),
		referenceDocPath: "blocks/delete-range.mdx",
		referenceGroup: "blocks"
	},
	"format.apply": {
		memberPath: "format.apply",
		description: "Apply inline run-property patch changes to the target range with explicit set/clear semantics.",
		expectedResult: "Returns a TextMutationReceipt confirming inline styles were applied to the target range.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT",
				...T_STORY
			]
		}),
		referenceDocPath: "format/apply.mdx",
		referenceGroup: "format",
		intentGroup: "format",
		intentAction: "inline"
	},
	...FORMAT_INLINE_ALIAS_OPERATION_DEFINITIONS,
	"styles.apply": {
		memberPath: "styles.apply",
		description: "Apply document-level default style changes to the stylesheet (word/styles.xml). Targets docDefaults run and paragraph channels with set-style patch semantics.",
		expectedResult: "Returns a StylesApplyReceipt with per-channel success/failure details for each property change.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: [
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE",
				"REVISION_MISMATCH"
			],
			historyUnsafe: true
		}),
		referenceDocPath: "styles/apply.mdx",
		referenceGroup: "styles"
	},
	"templates.apply": {
		memberPath: "templates.apply",
		description: "Apply detected DOCX template/substrate (styles, numbering, settings, theme, font table, web settings, headers/footers, section defaults) from a source package onto the current document, preserving body content. Scopes are auto-detected from source package evidence.",
		expectedResult: "Returns a TemplatesApplyReceipt with detected/applied/skipped scopes, unsupported items, changed parts, id mappings, and warnings.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"UNSUPPORTED_SOURCE",
				"INVALID_PACKAGE",
				"CAPABILITY_UNAVAILABLE",
				"UNSUPPORTED_TEMPLATE_CONTENT"
			],
			throws: [
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE",
				"REVISION_MISMATCH"
			],
			historyUnsafe: true,
			returnsPromise: true
		}),
		referenceDocPath: "templates/apply.mdx",
		referenceGroup: "templates"
	},
	"create.paragraph": {
		memberPath: "create.paragraph",
		description: "Create a standalone paragraph at the target position. To add a list item, use lists.insert instead.",
		expectedResult: "Returns a CreateParagraphResult with the new paragraph block ID and address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"AMBIGUOUS_TARGET",
				...T_STORY
			]
		}),
		referenceDocPath: "create/paragraph.mdx",
		referenceGroup: "create",
		intentGroup: "create",
		intentAction: "paragraph"
	},
	"create.heading": {
		memberPath: "create.heading",
		description: "Create a new heading at the target position.",
		expectedResult: "Returns a CreateHeadingResult with the new heading block ID and address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"AMBIGUOUS_TARGET",
				...T_STORY
			]
		}),
		referenceDocPath: "create/heading.mdx",
		referenceGroup: "create",
		intentGroup: "create",
		intentAction: "heading"
	},
	"create.sectionBreak": {
		memberPath: "create.sectionBreak",
		description: "Create a section break at the target location with optional initial section properties.",
		expectedResult: "Returns a CreateSectionBreakResult with the new section break position and section address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "CAPABILITY_UNAVAILABLE"],
			throws: T_SECTION_CREATE
		}),
		referenceDocPath: "create/section-break.mdx",
		referenceGroup: "create"
	},
	"sections.list": {
		memberPath: "sections.list",
		description: "List sections in deterministic order with section-target handles.",
		expectedResult: "Returns a SectionsListResult with an ordered array of section summaries and their target handles.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["INVALID_INPUT", "CAPABILITY_UNAVAILABLE"]
		}),
		referenceDocPath: "sections/list.mdx",
		referenceGroup: "sections"
	},
	"sections.get": {
		memberPath: "sections.get",
		description: "Retrieve full section information by section address.",
		expectedResult: "Returns a SectionInfo object with full section properties including margins, columns, and header/footer refs.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_SECTION_READ
		}),
		referenceDocPath: "sections/get.mdx",
		referenceGroup: "sections"
	},
	"sections.setBreakType": {
		memberPath: "sections.setBreakType",
		description: "Set the section break type.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if the section already has the requested break type.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-break-type.mdx",
		referenceGroup: "sections"
	},
	"sections.setPageMargins": {
		memberPath: "sections.setPageMargins",
		description: "Set page-edge margins for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if margins already match the requested values.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-page-margins.mdx",
		referenceGroup: "sections"
	},
	"sections.setHeaderFooterMargins": {
		memberPath: "sections.setHeaderFooterMargins",
		description: "Set header/footer margin distances for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if header/footer margins already match the requested values.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-header-footer-margins.mdx",
		referenceGroup: "sections"
	},
	"sections.setPageSetup": {
		memberPath: "sections.setPageSetup",
		description: "Set page size/orientation properties for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if page size and orientation already match the requested values.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-page-setup.mdx",
		referenceGroup: "sections"
	},
	"sections.setColumns": {
		memberPath: "sections.setColumns",
		description: "Set column configuration for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if column configuration already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-columns.mdx",
		referenceGroup: "sections"
	},
	"sections.setLineNumbering": {
		memberPath: "sections.setLineNumbering",
		description: "Enable or configure line numbering for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if line numbering settings already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-line-numbering.mdx",
		referenceGroup: "sections"
	},
	"sections.setPageNumbering": {
		memberPath: "sections.setPageNumbering",
		description: "Set page numbering format/start and chapter numbering settings for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if page numbering settings already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-page-numbering.mdx",
		referenceGroup: "sections"
	},
	"sections.setTitlePage": {
		memberPath: "sections.setTitlePage",
		description: "Enable or disable title-page behavior for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if the title-page setting already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-title-page.mdx",
		referenceGroup: "sections"
	},
	"sections.setOddEvenHeadersFooters": {
		memberPath: "sections.setOddEvenHeadersFooters",
		description: "Enable or disable odd/even header-footer mode in document settings.",
		expectedResult: "Returns a DocumentMutationResult (not SectionMutationResult) because odd/even headers-footers is a document-level setting, not per-section. Reports NO_OP if the setting already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP", "CAPABILITY_UNAVAILABLE"],
			throws: T_SECTION_SETTINGS_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-odd-even-headers-footers.mdx",
		referenceGroup: "sections"
	},
	"sections.setVerticalAlign": {
		memberPath: "sections.setVerticalAlign",
		description: "Set vertical page alignment for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if vertical alignment already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-vertical-align.mdx",
		referenceGroup: "sections"
	},
	"sections.setSectionDirection": {
		memberPath: "sections.setSectionDirection",
		description: "Set section text flow direction (LTR/RTL).",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if text direction already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-section-direction.mdx",
		referenceGroup: "sections"
	},
	"sections.setHeaderFooterRef": {
		memberPath: "sections.setHeaderFooterRef",
		description: "Set or replace a section header/footer reference for a variant.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if the header/footer reference already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-header-footer-ref.mdx",
		referenceGroup: "sections"
	},
	"sections.clearHeaderFooterRef": {
		memberPath: "sections.clearHeaderFooterRef",
		description: "Clear a section header/footer reference for a specific variant.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if no reference exists for the specified variant.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/clear-header-footer-ref.mdx",
		referenceGroup: "sections"
	},
	"sections.setLinkToPrevious": {
		memberPath: "sections.setLinkToPrevious",
		description: "Set or clear link-to-previous behavior for a header/footer variant.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if link-to-previous already matches the requested value.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-link-to-previous.mdx",
		referenceGroup: "sections"
	},
	"sections.setPageBorders": {
		memberPath: "sections.setPageBorders",
		description: "Set page border configuration for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if page border configuration already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/set-page-borders.mdx",
		referenceGroup: "sections"
	},
	"sections.clearPageBorders": {
		memberPath: "sections.clearPageBorders",
		description: "Clear page border configuration for a section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if no page borders are configured on the section.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_SECTION_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "sections/clear-page-borders.mdx",
		referenceGroup: "sections"
	},
	"styles.paragraph.setStyle": {
		memberPath: "styles.paragraph.setStyle",
		description: "Apply a paragraph style (w:pStyle) to a paragraph-like block, clearing direct run formatting while preserving character-style references.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the style already matches. When the style changes, direct run formatting is cleared while character-style references are preserved.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "styles/paragraph/set-style.mdx",
		referenceGroup: "styles.paragraph",
		intentGroup: "format",
		intentAction: "set_style"
	},
	"styles.paragraph.clearStyle": {
		memberPath: "styles.paragraph.clearStyle",
		description: "Remove the paragraph style reference from a paragraph-like block.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no style is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "styles/paragraph/clear-style.mdx",
		referenceGroup: "styles.paragraph"
	},
	"format.paragraph.resetDirectFormatting": {
		memberPath: "format.paragraph.resetDirectFormatting",
		description: "Strip all direct paragraph formatting while preserving style reference, numbering, and section metadata.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no direct formatting is present.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/reset-direct-formatting.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setAlignment": {
		memberPath: "format.paragraph.setAlignment",
		description: "Set visual paragraph alignment on a paragraph-like block. For RTL paragraphs, left/right are translated to Word-compatible stored justification values.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the alignment already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-alignment.mdx",
		referenceGroup: "format.paragraph",
		intentGroup: "format",
		intentAction: "set_alignment"
	},
	"format.paragraph.clearAlignment": {
		memberPath: "format.paragraph.clearAlignment",
		description: "Remove direct paragraph alignment, reverting to style-defined or default alignment.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no direct alignment is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-alignment.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setIndentation": {
		memberPath: "format.paragraph.setIndentation",
		description: "Set paragraph indentation properties (left, right, firstLine, hanging) in twips.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if indentation already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-indentation.mdx",
		referenceGroup: "format.paragraph",
		intentGroup: "format",
		intentAction: "set_indentation"
	},
	"format.paragraph.clearIndentation": {
		memberPath: "format.paragraph.clearIndentation",
		description: "Remove all direct paragraph indentation.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no direct indentation is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-indentation.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setSpacing": {
		memberPath: "format.paragraph.setSpacing",
		description: "Set paragraph spacing properties (before, after, line, lineRule) in twips.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if spacing already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-spacing.mdx",
		referenceGroup: "format.paragraph",
		intentGroup: "format",
		intentAction: "set_spacing"
	},
	"format.paragraph.clearSpacing": {
		memberPath: "format.paragraph.clearSpacing",
		description: "Remove all direct paragraph spacing.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no direct spacing is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-spacing.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setKeepOptions": {
		memberPath: "format.paragraph.setKeepOptions",
		description: "Set keep-with-next, keep-lines-together, and widow/orphan control flags.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if all flags already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-keep-options.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setOutlineLevel": {
		memberPath: "format.paragraph.setOutlineLevel",
		description: "Set the paragraph outline level (0–9) or null to clear.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if outline level already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-outline-level.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setFlowOptions": {
		memberPath: "format.paragraph.setFlowOptions",
		description: "Set contextual spacing, page-break-before, and suppress-auto-hyphens flags.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if all flags already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-flow-options.mdx",
		referenceGroup: "format.paragraph",
		intentGroup: "format",
		intentAction: "set_flow_options"
	},
	"format.paragraph.setTabStop": {
		memberPath: "format.paragraph.setTabStop",
		description: "Add or replace a tab stop at a given position.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if an identical tab stop already exists.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-tab-stop.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.clearTabStop": {
		memberPath: "format.paragraph.clearTabStop",
		description: "Remove a tab stop at a given position.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no tab stop exists at that position.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-tab-stop.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.clearAllTabStops": {
		memberPath: "format.paragraph.clearAllTabStops",
		description: "Remove all tab stops from a paragraph.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no tab stops exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-all-tab-stops.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setBorder": {
		memberPath: "format.paragraph.setBorder",
		description: "Set border properties for a specific side of a paragraph.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the border already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-border.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.clearBorder": {
		memberPath: "format.paragraph.clearBorder",
		description: "Remove border for a specific side or all sides of a paragraph.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the border is already absent.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-border.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setShading": {
		memberPath: "format.paragraph.setShading",
		description: "Set paragraph shading (background fill, pattern color, pattern type).",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the shading already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-shading.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.clearShading": {
		memberPath: "format.paragraph.clearShading",
		description: "Remove all paragraph shading.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no shading is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-shading.mdx",
		referenceGroup: "format.paragraph"
	},
	"format.paragraph.setDirection": {
		memberPath: "format.paragraph.setDirection",
		description: "Set paragraph base direction (LTR or RTL via w:bidi). Optionally align text to match.",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if the direction already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/set-direction.mdx",
		referenceGroup: "format.paragraph",
		intentGroup: "format",
		intentAction: "set_direction"
	},
	"format.paragraph.clearDirection": {
		memberPath: "format.paragraph.clearDirection",
		description: "Remove explicit paragraph direction, reverting to inherited or default (LTR).",
		expectedResult: "Returns a ParagraphMutationResult; reports NO_OP if no direction is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PARAGRAPH_MUTATION
		}),
		referenceDocPath: "format/paragraph/clear-direction.mdx",
		referenceGroup: "format.paragraph"
	},
	"lists.list": {
		memberPath: "lists.list",
		description: "List all list nodes in the document, optionally filtered by scope.",
		expectedResult: "Returns a ListsListResult with an array of list item summaries and total count.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/list.mdx",
		referenceGroup: "lists"
	},
	"lists.get": {
		memberPath: "lists.get",
		description: "Retrieve a specific list node by target.",
		expectedResult: "Returns a ListItemInfo object with the item kind, level, marker, and address.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "lists/get.mdx",
		referenceGroup: "lists"
	},
	"lists.insert": {
		memberPath: "lists.insert",
		description: "Insert a new list item before or after an existing list item. The new item inherits the target list context.",
		expectedResult: "Returns a ListsInsertResult with the new list item address and block ID.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/insert.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "insert"
	},
	"lists.create": {
		memberPath: "lists.create",
		description: "Create a new list from one or more paragraphs. Supports optional preset or style for new sequences. When sequence.mode is \"continuePrevious\", preset and style are not allowed: the new items inherit formatting from the previous sequence.",
		expectedResult: "Returns a ListsCreateResult with the new listId and the first item address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"INVALID_INPUT",
				"NO_COMPATIBLE_PREVIOUS"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/create.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "create"
	},
	"lists.attach": {
		memberPath: "lists.attach",
		description: "Convert non-list paragraphs to list items under an existing list sequence.",
		expectedResult: "Returns a ListsMutateItemResult confirming attachment.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/attach.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "attach"
	},
	"lists.detach": {
		memberPath: "lists.detach",
		description: "Remove numbering properties from list items, converting them to plain paragraphs.",
		expectedResult: "Returns a ListsDetachResult confirming the item was converted to a plain paragraph.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/detach.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "detach"
	},
	"lists.delete": {
		memberPath: "lists.delete",
		description: "Delete the entire list that contains the targeted list item. Removes ALL items in the same numbered sequence (the contiguous run of list items sharing the target's numbering) AND their text content from the document. Pass any single list item from the list as `target`; the op walks adjacent siblings to find the full list. Use this for \"remove the list\" / \"delete this list\" intents and for the cleanup step of a list-to-table conversion.",
		expectedResult: "Returns a ListsDeleteResult with `deletedCount` (number of items removed). Reports failure (INVALID_TARGET) if the target is not a list item.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/delete.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "delete"
	},
	"lists.indent": {
		memberPath: "lists.indent",
		description: "Increase the indentation level of a list item.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the item is already at maximum indent level.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/indent.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "indent"
	},
	"lists.outdent": {
		memberPath: "lists.outdent",
		description: "Decrease the indentation level of a list item.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the item is already at the root level.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/outdent.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "outdent"
	},
	"lists.join": {
		memberPath: "lists.join",
		description: "Merge two adjacent list sequences into one.",
		expectedResult: "Returns a ListsJoinResult with the resulting listId of the merged sequence.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"NO_ADJACENT_SEQUENCE",
				"INCOMPATIBLE_DEFINITIONS",
				"ALREADY_SAME_SEQUENCE"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/join.mdx",
		referenceGroup: "lists"
	},
	"lists.canJoin": {
		memberPath: "lists.canJoin",
		description: "Check whether two adjacent list sequences can be joined.",
		expectedResult: "Returns a ListsCanJoinResult indicating feasibility and reason if not possible.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/can-join.mdx",
		referenceGroup: "lists"
	},
	"lists.separate": {
		memberPath: "lists.separate",
		description: "Split a list sequence at the target item, creating a new sequence from that point forward.",
		expectedResult: "Returns a ListsSeparateResult with the new listId and numId.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/separate.mdx",
		referenceGroup: "lists"
	},
	"lists.merge": {
		memberPath: "lists.merge",
		description: "Compound: merge two adjacent list sequences into one. Reassigns numId on the absorbed sequence (no strict abstractNumId check: absorbed items adopt the absorbing definition) and deletes empty paragraphs between the two sequences. Use this instead of lists.join for the user-facing \"merge these lists\" intent.",
		expectedResult: "Returns a ListsMergeResult with the merged listId, absorbedCount, and removedEmptyBlocks count.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"NO_ADJACENT_SEQUENCE",
				"NO_OP"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/merge.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "merge"
	},
	"lists.split": {
		memberPath: "lists.split",
		description: "Compound: split a list sequence at the target item into two independent sequences. Runs lists.separate then (by default) lists.setValue(1) so the new half starts numbering fresh at 1. Pass restartNumbering:false for raw separate semantics (new half continues the previous count).",
		expectedResult: "Returns a ListsSplitResult with the new listId, numId, and the restart value applied (or null).",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/split.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "split"
	},
	"lists.setLevel": {
		memberPath: "lists.setLevel",
		description: "Set the absolute nesting level (0..8) of a list item.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if already at the target level.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"NO_OP"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "set_level"
	},
	"lists.setValue": {
		memberPath: "lists.setValue",
		description: "Set an explicit numbering value at the target item. Mid-sequence targets are atomically separated first.",
		expectedResult: "Returns a ListsMutateItemResult receipt.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-value.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "set_value"
	},
	"lists.continuePrevious": {
		memberPath: "lists.continuePrevious",
		description: "Continue numbering from the nearest compatible previous list sequence.",
		expectedResult: "Returns a ListsMutateItemResult receipt.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"INVALID_TARGET",
				"NO_COMPATIBLE_PREVIOUS",
				"ALREADY_CONTINUOUS"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/continue-previous.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "continue_previous"
	},
	"lists.canContinuePrevious": {
		memberPath: "lists.canContinuePrevious",
		description: "Check whether the target sequence can continue numbering from a previous compatible sequence.",
		expectedResult: "Returns a ListsCanContinuePreviousResult indicating feasibility.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/can-continue-previous.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelRestart": {
		memberPath: "lists.setLevelRestart",
		description: "Set the restart behavior for a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "LEVEL_OUT_OF_RANGE"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-restart.mdx",
		referenceGroup: "lists"
	},
	"lists.convertToText": {
		memberPath: "lists.convertToText",
		description: "Convert list items to plain paragraphs, optionally prepending the rendered marker text.",
		expectedResult: "Returns a ListsConvertToTextResult confirming the conversion.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/convert-to-text.mdx",
		referenceGroup: "lists"
	},
	"lists.applyTemplate": {
		memberPath: "lists.applyTemplate",
		description: "Advanced alias for lists.applyStyle. Apply a captured ListTemplate to the target list (abstract-scoped, no clone-on-write).",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if all levels already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/apply-template.mdx",
		referenceGroup: "lists"
	},
	"lists.applyPreset": {
		memberPath: "lists.applyPreset",
		description: "Apply a built-in list formatting preset to the target list.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if all levels already match the preset.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/apply-preset.mdx",
		referenceGroup: "lists"
	},
	"lists.setType": {
		memberPath: "lists.setType",
		description: "Convert a list to ordered or bullet and merge adjacent compatible sequences to preserve continuous numbering.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the list is already the requested kind and no sequences were merged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/set-type.mdx",
		referenceGroup: "lists",
		intentGroup: "list",
		intentAction: "set_type"
	},
	"lists.captureTemplate": {
		memberPath: "lists.captureTemplate",
		description: "Advanced alias for lists.getStyle. Capture list formatting from the abstract definition only (does not merge lvlOverride formatting).",
		expectedResult: "Returns a ListsCaptureTemplateResult containing the captured template.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			possibleFailureCodes: [
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE"
			]
		}),
		referenceDocPath: "lists/capture-template.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelNumbering": {
		memberPath: "lists.setLevelNumbering",
		description: "Advanced alias for lists.setLevelNumberStyle/setLevelText/setLevelStart. Set format, pattern, and start in one call (abstract-scoped, no clone-on-write).",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the level already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-numbering.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelBullet": {
		memberPath: "lists.setLevelBullet",
		description: "Set the bullet marker text for a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the marker already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-bullet.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelPictureBullet": {
		memberPath: "lists.setLevelPictureBullet",
		description: "Set a picture bullet for a specific list level by its OOXML lvlPicBulletId.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the picture bullet already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "lists/set-level-picture-bullet.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelAlignment": {
		memberPath: "lists.setLevelAlignment",
		description: "Set the marker alignment (left, center, right) for a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the alignment already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-alignment.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelIndents": {
		memberPath: "lists.setLevelIndents",
		description: "Set the paragraph indentation values (left, hanging, firstLine) for a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if all indent values already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/set-level-indents.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelTrailingCharacter": {
		memberPath: "lists.setLevelTrailingCharacter",
		description: "Set the trailing character (tab, space, nothing) after the marker for a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the trailing character already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-trailing-character.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelMarkerFont": {
		memberPath: "lists.setLevelMarkerFont",
		description: "Set the font family used for the marker character at a specific list level.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the font already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-marker-font.mdx",
		referenceGroup: "lists"
	},
	"lists.clearLevelOverrides": {
		memberPath: "lists.clearLevelOverrides",
		description: "Remove instance-level overrides for a specific list level, restoring abstract definition values.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if no override exists.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"LEVEL_OUT_OF_RANGE"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/clear-level-overrides.mdx",
		referenceGroup: "lists"
	},
	"lists.getStyle": {
		memberPath: "lists.getStyle",
		description: "Read the effective reusable style of a list, including instance-level overrides. Returns a ListStyle that can be applied to other lists via lists.applyStyle.",
		expectedResult: "Returns a ListsGetStyleResult containing the captured style.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			possibleFailureCodes: [
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE"
			]
		}),
		referenceDocPath: "lists/get-style.mdx",
		referenceGroup: "lists"
	},
	"lists.applyStyle": {
		memberPath: "lists.applyStyle",
		description: "Apply a reusable list style to the target list. Sequence-local: if the abstract definition is shared with other lists, it is cloned first to avoid affecting them.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if all levels already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/apply-style.mdx",
		referenceGroup: "lists"
	},
	"lists.restartAt": {
		memberPath: "lists.restartAt",
		description: "Restart numbering at the target list item with a specific value. If the item is mid-sequence, it is separated first.",
		expectedResult: "Returns a ListsMutateItemResult receipt.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/restart-at.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelNumberStyle": {
		memberPath: "lists.setLevelNumberStyle",
		description: "Set the numbering style (e.g. decimal, lowerLetter, upperRoman) for a specific list level. Rejects \"bullet\": use setLevelBullet instead. Sequence-local: clones shared definitions.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the value already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/set-level-number-style.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelText": {
		memberPath: "lists.setLevelText",
		description: "Set the level text pattern (e.g. \"%1.\", \"(%1)\") for a specific list level. Uses OOXML level-placeholder syntax. Sequence-local: clones shared definitions.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the value already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "lists/set-level-text.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelStart": {
		memberPath: "lists.setLevelStart",
		description: "Set the start value for a specific list level. Rejects bullet levels and non-positive values. Sequence-local: clones shared definitions.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if the value already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/set-level-start.mdx",
		referenceGroup: "lists"
	},
	"lists.setLevelLayout": {
		memberPath: "lists.setLevelLayout",
		description: "Set the layout properties (alignment, indentation, trailing character, tab stop) for a specific list level. Accepts partial updates: omitted fields are left unchanged. Sequence-local: clones shared definitions.",
		expectedResult: "Returns a ListsMutateItemResult receipt; reports NO_OP if all values already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"LEVEL_OUT_OF_RANGE",
				"LEVEL_NOT_FOUND"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "lists/set-level-layout.mdx",
		referenceGroup: "lists"
	},
	"comments.create": {
		memberPath: "comments.create",
		description: "Create a new comment thread (or reply when parentCommentId is given).",
		expectedResult: "Returns a Receipt confirming the comment was created, including the new comment id; reports NO_OP if the anchor target is invalid.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_CAPABLE, "INVALID_TARGET"]
		}),
		referenceDocPath: "comments/create.mdx",
		referenceGroup: "comments",
		intentGroup: "comment",
		intentAction: "create"
	},
	"comments.patch": {
		memberPath: "comments.patch",
		description: "Patch fields on an existing comment (text, target, status, or isInternal).",
		expectedResult: "Returns a Receipt confirming the comment was updated; reports NO_OP if no fields changed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "comments/patch.mdx",
		referenceGroup: "comments",
		intentGroup: "comment",
		intentAction: "update"
	},
	"comments.delete": {
		memberPath: "comments.delete",
		description: "Remove a comment or reply by ID.",
		expectedResult: "Returns a Receipt confirming the comment was removed; reports NO_OP if the comment was already deleted.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_NOT_FOUND_CAPABLE
		}),
		referenceDocPath: "comments/delete.mdx",
		referenceGroup: "comments",
		intentGroup: "comment",
		intentAction: "delete"
	},
	"comments.get": {
		memberPath: "comments.get",
		description: "Retrieve a single comment thread by ID.",
		expectedResult: "Returns a CommentInfo object with the comment text, author, date, and thread metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "comments/get.mdx",
		referenceGroup: "comments",
		intentGroup: "comment",
		intentAction: "get"
	},
	"comments.list": {
		memberPath: "comments.list",
		description: "List all comment threads in the document.",
		expectedResult: "Returns a CommentsListResult with an array of comment threads and total count.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["INVALID_INPUT"]
		}),
		referenceDocPath: "comments/list.mdx",
		referenceGroup: "comments",
		intentGroup: "comment",
		intentAction: "list"
	},
	"trackChanges.list": {
		memberPath: "trackChanges.list",
		description: "List all tracked changes in the document.",
		expectedResult: "Returns a TrackChangesListResult with tracked change entries (`insert`, `delete`, `replacement`, `format`), total count, and raw imported Word OOXML revision IDs (`w:id`) when available. Whole-table tracked insertions and deletions are surfaced through the legacy `insert` / `delete` types.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["INVALID_INPUT"]
		}),
		referenceDocPath: "track-changes/list.mdx",
		referenceGroup: "trackChanges",
		intentGroup: "track_changes",
		intentAction: "list"
	},
	"trackChanges.get": {
		memberPath: "trackChanges.get",
		description: "Retrieve a single tracked change by ID.",
		expectedResult: "Returns a TrackChangeInfo object with the change type (`insert`, `delete`, `replacement`, `format`), author, date, affected content, and raw imported Word OOXML revision IDs (`w:id`) when available. Whole-table tracked insertions and deletions are surfaced through the legacy `insert` / `delete` types.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "track-changes/get.mdx",
		referenceGroup: "trackChanges"
	},
	"trackChanges.decide": {
		memberPath: "trackChanges.decide",
		description: "Accept or reject tracked changes by ID, range, or scope: all (optionally filtered by story).",
		expectedResult: "Returns a Receipt confirming the decision was applied; reports NO_OP if the change was already resolved and typed failures for unsupported or denied tracked-change decisions.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_INPUT",
				"INVALID_TARGET",
				"TARGET_NOT_FOUND",
				"CAPABILITY_UNAVAILABLE",
				"PERMISSION_DENIED",
				"PRECONDITION_FAILED",
				"COMMENT_CASCADE_PARTIAL"
			],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_INPUT",
				"INVALID_TARGET"
			]
		}),
		referenceDocPath: "track-changes/decide.mdx",
		referenceGroup: "trackChanges",
		intentGroup: "track_changes",
		intentAction: "decide"
	},
	"query.match": {
		memberPath: "query.match",
		description: "Deterministic selector-based search returning mutation-grade addresses and text ranges. Use this to discover targets before any mutation.",
		expectedResult: "Returns a QueryMatchOutput with the resolved target address and cardinality metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [...T_QUERY_MATCH, ...T_STORY],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "query/match.mdx",
		referenceGroup: "query",
		intentGroup: "search",
		intentAction: "match"
	},
	"ranges.resolve": {
		memberPath: "ranges.resolve",
		description: "Resolve two explicit anchors into a contiguous document range. Returns a transparent SelectionTarget, a mutation-ready ref, and preview metadata. Stateless and deterministic.",
		expectedResult: "Returns a ResolveRangeOutput with evaluatedRevision, handle.ref, target (SelectionTarget), and preview metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [
				"INVALID_INPUT",
				"INVALID_TARGET",
				"TARGET_NOT_FOUND",
				"INVALID_CONTEXT",
				"REVISION_MISMATCH"
			],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "ranges/resolve.mdx",
		referenceGroup: "ranges"
	},
	"selection.current": {
		memberPath: "selection.current",
		description: "Read the editor's current selection as a portable SelectionInfo with a text-anchored TextTarget. Primitive for building custom comments UIs, floating toolbars, and other selection-driven components without reaching into ProseMirror internals.",
		expectedResult: "Returns a SelectionInfo with `empty`, `target` (TextTarget or null), `activeMarks`, and optionally `text` when `includeText: true`.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["INVALID_INPUT", "INVALID_CONTEXT"],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "selection/current.mdx",
		referenceGroup: "selection"
	},
	"mutations.preview": {
		memberPath: "mutations.preview",
		description: "Dry-run a mutation plan, returning resolved targets without applying changes.",
		expectedResult: "Returns a MutationsPreviewOutput with resolved targets and step details without applying changes.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: [...T_PLAN_ENGINE, ...T_STORY],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "mutations/preview.mdx",
		referenceGroup: "mutations",
		intentGroup: "mutations",
		intentAction: "preview"
	},
	"mutations.apply": {
		memberPath: "mutations.apply",
		description: "Execute a mutation plan atomically against the document.",
		expectedResult: "Returns a PlanReceipt with per-step results for the atomically applied mutation plan.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: false,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_CONTEXT"],
			throws: [
				...T_PLAN_ENGINE,
				"DUPLICATE_ID",
				"RAW_MODE_REQUIRED",
				"PRESERVE_ONLY_VIOLATION",
				"CAPABILITY_UNSUPPORTED",
				...T_STORY
			],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "mutations/apply.mdx",
		referenceGroup: "mutations",
		intentGroup: "mutations",
		intentAction: "apply"
	},
	"capabilities.get": {
		memberPath: "capabilities",
		description: "Query runtime capabilities supported by the current document engine.",
		expectedResult: "Returns a DocumentApiCapabilities object describing supported features of the current engine.",
		requiresDocumentContext: false,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: NONE_THROWS
		}),
		referenceDocPath: "capabilities/get.mdx",
		referenceGroup: "capabilities"
	},
	"create.table": {
		memberPath: "create.table",
		description: "Create a new table at the target position.",
		expectedResult: "Returns a CreateTableResult with the new table block ID and address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				...T_NOT_FOUND_COMMAND,
				"INVALID_TARGET",
				"AMBIGUOUS_TARGET"
			]
		}),
		referenceDocPath: "create/table.mdx",
		referenceGroup: "create",
		intentGroup: "create",
		intentAction: "table"
	},
	"tables.convertFromText": {
		memberPath: "tables.convertFromText",
		description: "Convert a text range into a table.",
		expectedResult: "Returns a TableMutationResult receipt confirming text was converted into a table.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/convert-from-text.mdx",
		referenceGroup: "tables"
	},
	"tables.delete": {
		memberPath: "tables.delete",
		description: "Delete the target table from the document.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the table was already removed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/delete.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "delete"
	},
	"tables.clearContents": {
		memberPath: "tables.clearContents",
		description: "Clear the contents of the target table or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the target cells are already empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/clear-contents.mdx",
		referenceGroup: "tables"
	},
	"tables.move": {
		memberPath: "tables.move",
		description: "Move a table to a new position in the document.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the table is already at the target position.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/move.mdx",
		referenceGroup: "tables"
	},
	"tables.split": {
		memberPath: "tables.split",
		description: "Split a table into two tables at the target row.",
		expectedResult: "Returns a TableMutationResult receipt confirming the table was split at the target row.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/split.mdx",
		referenceGroup: "tables"
	},
	"tables.convertToText": {
		memberPath: "tables.convertToText",
		description: "Convert a table back to plain text.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the table has no content to convert.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/convert-to-text.mdx",
		referenceGroup: "tables"
	},
	"tables.setLayout": {
		memberPath: "tables.setLayout",
		description: "Set the layout mode of the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the table already uses the requested layout mode.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-layout.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_layout"
	},
	"tables.insertRow": {
		memberPath: "tables.insertRow",
		description: "Insert a new row into the target table. The new row is cloned from an adjacent row, so it inherits the existing cell shading, borders, alignment, and padding. No follow-up styling call is needed unless the new row should look different from the rest of the table.",
		expectedResult: "Returns a TableMutationResult receipt confirming a row was inserted.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/insert-row.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "insert_row"
	},
	"tables.deleteRow": {
		memberPath: "tables.deleteRow",
		description: "Delete a row from the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the target row does not exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/delete-row.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "delete_row"
	},
	"tables.setRowHeight": {
		memberPath: "tables.setRowHeight",
		description: "Set the height of a table row.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the row height already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-row-height.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_row"
	},
	"tables.distributeRows": {
		memberPath: "tables.distributeRows",
		description: "Distribute row heights evenly across the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if row heights are already equal.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/distribute-rows.mdx",
		referenceGroup: "tables"
	},
	"tables.setRowOptions": {
		memberPath: "tables.setRowOptions",
		description: "Set options on a table row such as header repeat or page break.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if row options already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-row-options.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_row_options"
	},
	"tables.insertColumn": {
		memberPath: "tables.insertColumn",
		description: "Insert a new column into the target table. The new column is cloned from an adjacent column, so it inherits the existing cell shading, borders, alignment, and width. No follow-up styling call is needed unless the new column should look different from the rest of the table.",
		expectedResult: "Returns a TableMutationResult receipt confirming a column was inserted.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/insert-column.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "insert_column"
	},
	"tables.deleteColumn": {
		memberPath: "tables.deleteColumn",
		description: "Delete a column from the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the target column does not exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: true,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/delete-column.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "delete_column"
	},
	"tables.setColumnWidth": {
		memberPath: "tables.setColumnWidth",
		description: "Set the width of a table column.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the column width already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-column-width.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_column"
	},
	"tables.distributeColumns": {
		memberPath: "tables.distributeColumns",
		description: "Distribute column widths evenly across the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if column widths are already equal.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/distribute-columns.mdx",
		referenceGroup: "tables"
	},
	"tables.insertCell": {
		memberPath: "tables.insertCell",
		description: "Insert a new cell into a table row.",
		expectedResult: "Returns a TableMutationResult receipt confirming a cell was inserted.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/insert-cell.mdx",
		referenceGroup: "tables"
	},
	"tables.deleteCell": {
		memberPath: "tables.deleteCell",
		description: "Delete a cell from a table row.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the target cell does not exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: [...T_NOT_FOUND_COMMAND, "INVALID_TARGET"]
		}),
		referenceDocPath: "tables/delete-cell.mdx",
		referenceGroup: "tables"
	},
	"tables.mergeCells": {
		memberPath: "tables.mergeCells",
		description: "Merge a range of table cells into one.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the cells are already merged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/merge-cells.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "merge_cells"
	},
	"tables.unmergeCells": {
		memberPath: "tables.unmergeCells",
		description: "Unmerge a previously merged table cell.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the cell is not merged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/unmerge-cells.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "unmerge_cells"
	},
	"tables.splitCell": {
		memberPath: "tables.splitCell",
		description: "Split a table cell into multiple cells.",
		expectedResult: "Returns a TableMutationResult receipt confirming the cell was split.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/split-cell.mdx",
		referenceGroup: "tables"
	},
	"tables.setCellProperties": {
		memberPath: "tables.setCellProperties",
		description: "Set non-text properties on a single table cell: vertical alignment, text wrapping, fit-text, or preferred width. Requires a cell-level target (a tableCell block address with kind, nodeType, nodeId). Does NOT accept a table target with rowIndex/columnIndex. To set the text content of a cell, use action \"set_cell_text\" instead.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if cell properties already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-cell-properties.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_cell"
	},
	"tables.setCellText": {
		memberPath: "tables.setCellText",
		description: "Replace the text content of a single table cell with plain text (one paragraph). Accepts either a direct cell locator (a tableCell block address with kind, nodeType, nodeId) OR a table target with rowIndex + columnIndex. Cell properties (vertical alignment, shading, borders, colspan/rowspan) are preserved. Use this for filling cells with values, replacing cell text, or populating empty tables. Much simpler than walking paragraphs and runs through superdoc_edit.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the cell already contains exactly this text.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-cell-text.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_cell_text"
	},
	"tables.sort": {
		memberPath: "tables.sort",
		description: "Sort table rows by a column value.",
		expectedResult: "Returns a TableMutationResult receipt confirming rows were reordered.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/sort.mdx",
		referenceGroup: "tables"
	},
	"tables.setAltText": {
		memberPath: "tables.setAltText",
		description: "Set the alternative text description for a table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if alt text already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-alt-text.mdx",
		referenceGroup: "tables"
	},
	"tables.setStyle": {
		memberPath: "tables.setStyle",
		description: "Apply a named table style to the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the table already uses the requested style.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-style.mdx",
		referenceGroup: "tables"
	},
	"tables.clearStyle": {
		memberPath: "tables.clearStyle",
		description: "Remove the applied table style, reverting to defaults.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if no table style is applied.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/clear-style.mdx",
		referenceGroup: "tables"
	},
	"tables.setStyleOption": {
		memberPath: "tables.setStyleOption",
		description: "Toggle a conditional style option such as banded rows or first column.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the style option already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-style-option.mdx",
		referenceGroup: "tables"
	},
	"tables.setBorder": {
		memberPath: "tables.setBorder",
		description: "Set border properties on a table or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if border properties already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-border.mdx",
		referenceGroup: "tables"
	},
	"tables.clearBorder": {
		memberPath: "tables.clearBorder",
		description: "Remove border formatting from a table or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if no borders are set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/clear-border.mdx",
		referenceGroup: "tables"
	},
	"tables.applyBorderPreset": {
		memberPath: "tables.applyBorderPreset",
		description: "Apply a border preset (e.g. all borders, outside only) to a table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the preset is already applied.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/apply-border-preset.mdx",
		referenceGroup: "tables"
	},
	"tables.setShading": {
		memberPath: "tables.setShading",
		description: "Set the background shading color on a table or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if shading already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-shading.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_shading"
	},
	"tables.clearShading": {
		memberPath: "tables.clearShading",
		description: "Remove shading from a table or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if no shading is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/clear-shading.mdx",
		referenceGroup: "tables"
	},
	"tables.setTablePadding": {
		memberPath: "tables.setTablePadding",
		description: "Set default cell padding for the entire table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if table padding already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-table-padding.mdx",
		referenceGroup: "tables"
	},
	"tables.setCellPadding": {
		memberPath: "tables.setCellPadding",
		description: "Set padding on a specific table cell or cell range.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if cell padding already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-cell-padding.mdx",
		referenceGroup: "tables"
	},
	"tables.setCellSpacing": {
		memberPath: "tables.setCellSpacing",
		description: "Set the cell spacing for the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if cell spacing already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-cell-spacing.mdx",
		referenceGroup: "tables"
	},
	"tables.clearCellSpacing": {
		memberPath: "tables.clearCellSpacing",
		description: "Remove custom cell spacing from the target table.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if no custom cell spacing is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/clear-cell-spacing.mdx",
		referenceGroup: "tables"
	},
	"tables.applyStyle": {
		memberPath: "tables.applyStyle",
		description: "Toggle conditional-format flags (header row, banded rows/columns, first/last column, last row) on a table. Pass `styleOptions` with the flags you want to set or clear (omitted flags stay unchanged). For \"format the first row as a header\" use `styleOptions: { headerRow: true }`. Optional `styleId` applies a named table style. Leave it unset unless you have a styleId from `superdoc_get_content` (no need to invent one).",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the style and all provided options already match.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/apply-style.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_style_options"
	},
	"tables.setBorders": {
		memberPath: "tables.setBorders",
		description: "Set borders on a table using a target set or per-edge patch.",
		expectedResult: "Returns a TableMutationResult receipt. Does not perform NO_OP detection.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "INVALID_INPUT"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-borders.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_borders"
	},
	"tables.setTableOptions": {
		memberPath: "tables.setTableOptions",
		description: "Set table-level default cell margins and/or cell spacing.",
		expectedResult: "Returns a TableMutationResult receipt; reports NO_OP if the provided values already match current direct formatting.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/set-table-options.mdx",
		referenceGroup: "tables",
		intentGroup: "table",
		intentAction: "set_options"
	},
	"tables.applyPreset": {
		memberPath: "tables.applyPreset",
		description: "Apply a named visual preset to a table. Presets: \"grid\" (1pt black borders all around), \"minimal\" (no outer borders, hairline grey row separators + thicker bottom), \"striped\" (banded rows on, 0.5pt grey borders), \"accent\" (filled header row + thick accent top/bottom; defaults to dark blue, override with `accentColor`). Composes set_borders + set_style_options + header-row shading in one call. Available via the document API and `superdoc_mutations` (intentionally NOT exposed as a top-level action on `superdoc_table`. Agents should compose explicit set_borders / set_shading / set_style_options calls so they always pick concrete colors that match the document context).",
		expectedResult: "Returns a TableMutationResult receipt.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_NOT_FOUND_COMMAND
		}),
		referenceDocPath: "tables/apply-preset.mdx",
		referenceGroup: "tables"
	},
	"tables.get": {
		memberPath: "tables.get",
		description: "Retrieve table structure and dimensions by locator.",
		expectedResult: "Returns a TablesGetOutput with the table row count, column count, and structural metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "tables/get.mdx",
		referenceGroup: "tables"
	},
	"tables.getCells": {
		memberPath: "tables.getCells",
		description: "Retrieve cell information for a table, optionally filtered by row or column.",
		expectedResult: "Returns a TablesGetCellsOutput with cell information for the requested rows and columns.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "tables/get-cells.mdx",
		referenceGroup: "tables"
	},
	"tables.getProperties": {
		memberPath: "tables.getProperties",
		description: "Retrieve layout and style properties of a table.",
		expectedResult: "Returns a TablesGetPropertiesOutput with direct table layout and style state, including style options, borders, default cell margins, and cell spacing when explicitly set.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "tables/get-properties.mdx",
		referenceGroup: "tables"
	},
	"tables.getStyles": {
		memberPath: "tables.getStyles",
		description: "List all table styles and the document-level default table style setting.",
		expectedResult: "Returns a TablesGetStylesOutput with the style catalog, explicit default, and effective default.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "tables/get-styles.mdx",
		referenceGroup: "tables"
	},
	"tables.setDefaultStyle": {
		memberPath: "tables.setDefaultStyle",
		description: "Set the document-level default table style (w:defaultTableStyle in settings.xml).",
		expectedResult: "Returns a DocumentMutationResult; reports NO_OP if the default already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP", "INVALID_INPUT"],
			throws: ["CAPABILITY_UNAVAILABLE", "INVALID_INPUT"],
			historyUnsafe: true
		}),
		referenceDocPath: "tables/set-default-style.mdx",
		referenceGroup: "tables"
	},
	"tables.clearDefaultStyle": {
		memberPath: "tables.clearDefaultStyle",
		description: "Remove the document-level default table style setting.",
		expectedResult: "Returns a DocumentMutationResult; reports NO_OP if no default is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: ["CAPABILITY_UNAVAILABLE"],
			historyUnsafe: true
		}),
		referenceDocPath: "tables/clear-default-style.mdx",
		referenceGroup: "tables"
	},
	"create.tableOfContents": {
		memberPath: "create.tableOfContents",
		description: "Insert a new table of contents at the target position.",
		expectedResult: "Returns a CreateTableOfContentsResult with the new TOC block address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP", "INVALID_INSERTION_CONTEXT"],
			throws: [
				"INVALID_TARGET",
				"TARGET_NOT_FOUND",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "create/table-of-contents.mdx",
		referenceGroup: "create"
	},
	"toc.list": {
		memberPath: "toc.list",
		description: "List all tables of contents in the document.",
		expectedResult: "Returns a TocListResult with an array of TOC discovery items and pagination metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "toc/list.mdx",
		referenceGroup: "toc"
	},
	"toc.get": {
		memberPath: "toc.get",
		description: "Retrieve details of a specific table of contents.",
		expectedResult: "Returns a TocInfo object with the instruction, source/display configuration, and entry count.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "toc/get.mdx",
		referenceGroup: "toc"
	},
	"toc.configure": {
		memberPath: "toc.configure",
		description: "Update the configuration switches of a table of contents.",
		expectedResult: "Returns a TocMutationResult with the updated TOC address on success, or a failure code on no-op.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/configure.mdx",
		referenceGroup: "toc"
	},
	"toc.update": {
		memberPath: "toc.update",
		description: "Rebuild or refresh the materialized content of a table of contents.",
		expectedResult: "Returns a TocMutationResult with the TOC address on success, or a failure code if content is unchanged or page numbers cannot be resolved.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"PAGE_NUMBERS_NOT_MATERIALIZED",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/update.mdx",
		referenceGroup: "toc"
	},
	"toc.remove": {
		memberPath: "toc.remove",
		description: "Remove a table of contents from the document.",
		expectedResult: "Returns a TocMutationResult with the removed TOC address on success, or a failure code on no-op.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/remove.mdx",
		referenceGroup: "toc"
	},
	"toc.markEntry": {
		memberPath: "toc.markEntry",
		description: "Insert a TC (table of contents entry) field at the target paragraph.",
		expectedResult: "Returns a TocEntryMutationResult with the created entry address on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP", "INVALID_INSERTION_CONTEXT"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/mark-entry.mdx",
		referenceGroup: "toc"
	},
	"toc.unmarkEntry": {
		memberPath: "toc.unmarkEntry",
		description: "Remove a TC (table of contents entry) field from the document.",
		expectedResult: "Returns a TocEntryMutationResult with the removed entry address on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/unmark-entry.mdx",
		referenceGroup: "toc"
	},
	"toc.listEntries": {
		memberPath: "toc.listEntries",
		description: "List all TC (table of contents entry) fields in the document body.",
		expectedResult: "Returns a TocListEntriesResult with an array of TC entry discovery items and pagination metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "toc/list-entries.mdx",
		referenceGroup: "toc"
	},
	"toc.getEntry": {
		memberPath: "toc.getEntry",
		description: "Retrieve details of a specific TC (table of contents entry) field.",
		expectedResult: "Returns a TocEntryInfo object with the instruction, text, level, and switch configuration.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_NOT_FOUND
		}),
		referenceDocPath: "toc/get-entry.mdx",
		referenceGroup: "toc"
	},
	"toc.editEntry": {
		memberPath: "toc.editEntry",
		description: "Update the properties of a TC (table of contents entry) field.",
		expectedResult: "Returns a TocEntryMutationResult with the updated entry address on success, or NO_OP if no change.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE"
			]
		}),
		referenceDocPath: "toc/edit-entry.mdx",
		referenceGroup: "toc"
	},
	"history.get": {
		memberPath: "history.get",
		description: "Query the current undo/redo history state of the document.",
		expectedResult: "Returns a HistoryState object with undoDepth, redoDepth, canUndo, canRedo, and a list of history-unsafe operations.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "history/get.mdx",
		referenceGroup: "history"
	},
	"history.undo": {
		memberPath: "history.undo",
		description: "Undo the most recent history-safe mutation in the document.",
		expectedResult: "Returns a HistoryActionResult with noop flag, reason (EMPTY_UNDO_STACK | NO_EFFECT when noop), and revision before/after.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: ["CAPABILITY_UNAVAILABLE"]
		}),
		referenceDocPath: "history/undo.mdx",
		referenceGroup: "history",
		intentGroup: "edit",
		intentAction: "undo"
	},
	"history.redo": {
		memberPath: "history.redo",
		description: "Redo the most recently undone action in the document.",
		expectedResult: "Returns a HistoryActionResult with noop flag, reason (EMPTY_REDO_STACK | NO_EFFECT when noop), and revision before/after.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: false,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: ["CAPABILITY_UNAVAILABLE"]
		}),
		referenceDocPath: "history/redo.mdx",
		referenceGroup: "history",
		intentGroup: "edit",
		intentAction: "redo"
	},
	"create.image": {
		memberPath: "create.image",
		description: "Insert a new image at the target position.",
		expectedResult: "Returns a CreateImageResult with the new image address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "INVALID_INPUT"],
			throws: [
				...T_NOT_FOUND_COMMAND,
				"INVALID_INPUT",
				...T_STORY
			]
		}),
		referenceDocPath: "create/image.mdx",
		referenceGroup: "create"
	},
	"images.list": {
		memberPath: "images.list",
		description: "List all images in the document.",
		expectedResult: "Returns an ImagesListResult with total count and image summaries.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			deterministicTargetResolution: true
		}),
		referenceDocPath: "images/list.mdx",
		referenceGroup: "images"
	},
	"images.get": {
		memberPath: "images.get",
		description: "Get details for a specific image by its stable ID.",
		expectedResult: "Returns an ImageSummary with full image properties.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["TARGET_NOT_FOUND", "AMBIGUOUS_TARGET"],
			deterministicTargetResolution: true
		}),
		referenceDocPath: "images/get.mdx",
		referenceGroup: "images"
	},
	"images.delete": {
		memberPath: "images.delete",
		description: "Delete an image from the document.",
		expectedResult: "Returns an ImagesMutationResult indicating success or failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/delete.mdx",
		referenceGroup: "images"
	},
	"images.move": {
		memberPath: "images.move",
		description: "Move an image to a new location in the document.",
		expectedResult: "Returns an ImagesMutationResult indicating success or failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/move.mdx",
		referenceGroup: "images"
	},
	"images.convertToInline": {
		memberPath: "images.convertToInline",
		description: "Convert a floating image to inline placement.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already inline.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/convert-to-inline.mdx",
		referenceGroup: "images"
	},
	"images.convertToFloating": {
		memberPath: "images.convertToFloating",
		description: "Convert an inline image to floating placement.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already floating.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/convert-to-floating.mdx",
		referenceGroup: "images"
	},
	"images.setSize": {
		memberPath: "images.setSize",
		description: "Set explicit width/height for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if the size already matches.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-size.mdx",
		referenceGroup: "images"
	},
	"images.setWrapType": {
		memberPath: "images.setWrapType",
		description: "Set the text wrapping type for a floating image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-wrap-type.mdx",
		referenceGroup: "images"
	},
	"images.setWrapSide": {
		memberPath: "images.setWrapSide",
		description: "Set which side(s) text wraps around a floating image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-wrap-side.mdx",
		referenceGroup: "images"
	},
	"images.setWrapDistances": {
		memberPath: "images.setWrapDistances",
		description: "Set the text-wrap distance margins for a floating image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-wrap-distances.mdx",
		referenceGroup: "images"
	},
	"images.setPosition": {
		memberPath: "images.setPosition",
		description: "Set the anchor position for a floating image.",
		expectedResult: "Returns an ImagesMutationResult.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-position.mdx",
		referenceGroup: "images"
	},
	"images.setAnchorOptions": {
		memberPath: "images.setAnchorOptions",
		description: "Set anchor behavior options for a floating image.",
		expectedResult: "Returns an ImagesMutationResult.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-anchor-options.mdx",
		referenceGroup: "images"
	},
	"images.setZOrder": {
		memberPath: "images.setZOrder",
		description: "Set the z-order (relativeHeight) for a floating image.",
		expectedResult: "Returns an ImagesMutationResult.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/set-z-order.mdx",
		referenceGroup: "images"
	},
	"images.scale": {
		memberPath: "images.scale",
		description: "Scale an image by a uniform factor applied to both dimensions.",
		expectedResult: "Returns an ImagesMutationResult with the updated image address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/scale.mdx",
		referenceGroup: "images"
	},
	"images.setLockAspectRatio": {
		memberPath: "images.setLockAspectRatio",
		description: "Lock or unlock the aspect ratio for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-lock-aspect-ratio.mdx",
		referenceGroup: "images"
	},
	"images.rotate": {
		memberPath: "images.rotate",
		description: "Set the absolute rotation angle for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/rotate.mdx",
		referenceGroup: "images"
	},
	"images.flip": {
		memberPath: "images.flip",
		description: "Set horizontal and/or vertical flip state for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if already set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/flip.mdx",
		referenceGroup: "images"
	},
	"images.crop": {
		memberPath: "images.crop",
		description: "Apply rectangular edge-percentage crop to an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/crop.mdx",
		referenceGroup: "images"
	},
	"images.resetCrop": {
		memberPath: "images.resetCrop",
		description: "Remove all cropping from an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if no crop is set.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/reset-crop.mdx",
		referenceGroup: "images"
	},
	"images.replaceSource": {
		memberPath: "images.replaceSource",
		description: "Replace the image source while preserving identity and placement.",
		expectedResult: "Returns an ImagesMutationResult with the updated image address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/replace-source.mdx",
		referenceGroup: "images"
	},
	"images.setAltText": {
		memberPath: "images.setAltText",
		description: "Set the accessibility description (alt text) for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-alt-text.mdx",
		referenceGroup: "images"
	},
	"images.setDecorative": {
		memberPath: "images.setDecorative",
		description: "Mark or unmark an image as decorative.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-decorative.mdx",
		referenceGroup: "images"
	},
	"images.setName": {
		memberPath: "images.setName",
		description: "Set the object name for an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-name.mdx",
		referenceGroup: "images"
	},
	"images.setHyperlink": {
		memberPath: "images.setHyperlink",
		description: "Set or remove the hyperlink attached to an image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/set-hyperlink.mdx",
		referenceGroup: "images"
	},
	"images.insertCaption": {
		memberPath: "images.insertCaption",
		description: "Insert a caption paragraph below the image.",
		expectedResult: "Returns an ImagesMutationResult with the image address.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/insert-caption.mdx",
		referenceGroup: "images"
	},
	"images.updateCaption": {
		memberPath: "images.updateCaption",
		description: "Update the text of an existing caption paragraph.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if text unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: [...T_IMAGE_COMMAND, "INVALID_INPUT"]
		}),
		referenceDocPath: "images/update-caption.mdx",
		referenceGroup: "images"
	},
	"images.removeCaption": {
		memberPath: "images.removeCaption",
		description: "Remove the caption paragraph from below the image.",
		expectedResult: "Returns an ImagesMutationResult; reports NO_OP if no caption exists.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_IMAGE_COMMAND
		}),
		referenceDocPath: "images/remove-caption.mdx",
		referenceGroup: "images"
	},
	"hyperlinks.list": {
		memberPath: "hyperlinks.list",
		description: "List all hyperlinks in the document, with optional filtering by href, anchor, or display text.",
		expectedResult: "Returns a HyperlinksListResult with an array of hyperlink discovery items and pagination metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "hyperlinks/list.mdx",
		referenceGroup: "hyperlinks"
	},
	"hyperlinks.get": {
		memberPath: "hyperlinks.get",
		description: "Retrieve details of a specific hyperlink by its inline address.",
		expectedResult: "Returns a HyperlinkInfo object with the address, destination properties, and display text.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["TARGET_NOT_FOUND", "INVALID_TARGET"]
		}),
		referenceDocPath: "hyperlinks/get.mdx",
		referenceGroup: "hyperlinks"
	},
	"hyperlinks.wrap": {
		memberPath: "hyperlinks.wrap",
		description: "Wrap an existing text range with a hyperlink.",
		expectedResult: "Returns a HyperlinkMutationResult with the created hyperlink address on success, or a failure code on no-op.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			deterministicTargetResolution: true,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "hyperlinks/wrap.mdx",
		referenceGroup: "hyperlinks"
	},
	"hyperlinks.insert": {
		memberPath: "hyperlinks.insert",
		description: "Insert new linked text at a target position.",
		expectedResult: "Returns a HyperlinkMutationResult with the created hyperlink address on success, or a failure code.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			deterministicTargetResolution: true,
			possibleFailureCodes: ["NO_OP", "INVALID_TARGET"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "hyperlinks/insert.mdx",
		referenceGroup: "hyperlinks"
	},
	"hyperlinks.patch": {
		memberPath: "hyperlinks.patch",
		description: "Update hyperlink metadata (destination, tooltip, target, rel) without changing display text.",
		expectedResult: "Returns a HyperlinkMutationResult with the updated hyperlink address on success, or NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			deterministicTargetResolution: true,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "hyperlinks/patch.mdx",
		referenceGroup: "hyperlinks"
	},
	"hyperlinks.remove": {
		memberPath: "hyperlinks.remove",
		description: "Remove a hyperlink. Mode 'unwrap' preserves display text; 'deleteText' removes the linked content entirely.",
		expectedResult: "Returns a HyperlinkMutationResult with the removed hyperlink address on success, or a failure code on no-op.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			deterministicTargetResolution: true,
			possibleFailureCodes: ["NO_OP"],
			throws: [
				...T_NOT_FOUND_CAPABLE,
				"INVALID_TARGET",
				"INVALID_INPUT"
			]
		}),
		referenceDocPath: "hyperlinks/remove.mdx",
		referenceGroup: "hyperlinks"
	},
	"headerFooters.list": {
		memberPath: "headerFooters.list",
		description: "List header/footer slot entries across sections.",
		expectedResult: "Returns a paginated DiscoveryOutput of HeaderFooterSlotEntry items.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: ["INVALID_INPUT", "INVALID_TARGET"] }),
		referenceDocPath: "header-footers/list.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.get": {
		memberPath: "headerFooters.get",
		description: "Get a single header/footer slot entry by address.",
		expectedResult: "Returns a HeaderFooterSlotEntry for the targeted section slot.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: [
			"TARGET_NOT_FOUND",
			"INVALID_TARGET",
			"INVALID_INPUT"
		] }),
		referenceDocPath: "header-footers/get.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.resolve": {
		memberPath: "headerFooters.resolve",
		description: "Resolve the effective header/footer reference for a slot, walking the section inheritance chain.",
		expectedResult: "Returns a HeaderFooterResolveResult indicating explicit, inherited, or none status with the resolved refId.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: [
			"TARGET_NOT_FOUND",
			"INVALID_TARGET",
			"INVALID_INPUT"
		] }),
		referenceDocPath: "header-footers/resolve.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.refs.set": {
		memberPath: "headerFooters.refs.set",
		description: "Set an explicit header/footer reference on a section slot.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if the reference already matches, INVALID_TARGET if the relationship does not exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_HEADER_FOOTER_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "header-footers/refs/set.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.refs.clear": {
		memberPath: "headerFooters.refs.clear",
		description: "Clear an explicit header/footer reference from a section slot.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if no explicit reference existed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_HEADER_FOOTER_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "header-footers/refs/clear.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.refs.setLinkedToPrevious": {
		memberPath: "headerFooters.refs.setLinkedToPrevious",
		description: "Link or unlink a header/footer slot to/from the previous section.",
		expectedResult: "Returns a SectionMutationResult receipt; reports NO_OP if the link state already matches, INVALID_TARGET for the first section.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"NO_OP",
				"INVALID_TARGET",
				"CAPABILITY_UNAVAILABLE"
			],
			throws: T_HEADER_FOOTER_MUTATION,
			historyUnsafe: true
		}),
		referenceDocPath: "header-footers/refs/set-linked-to-previous.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.parts.list": {
		memberPath: "headerFooters.parts.list",
		description: "List unique header/footer part records from document relationships.",
		expectedResult: "Returns a paginated DiscoveryOutput of HeaderFooterPartEntry items.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: ["CAPABILITY_UNAVAILABLE", "INVALID_INPUT"] }),
		referenceDocPath: "header-footers/parts/list.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.parts.create": {
		memberPath: "headerFooters.parts.create",
		description: "Create a new independent header/footer part, optionally cloned from an existing part.",
		expectedResult: "Returns a HeaderFooterPartsMutationResult with the new refId/partPath on success, INVALID_TARGET failure when sourceRefId is invalid or mismatched.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE",
				"INTERNAL_ERROR"
			],
			historyUnsafe: true
		}),
		referenceDocPath: "header-footers/parts/create.mdx",
		referenceGroup: "headerFooters"
	},
	"headerFooters.parts.delete": {
		memberPath: "headerFooters.parts.delete",
		description: "Delete a header/footer part and its associated relationship when no section slots reference it.",
		expectedResult: "Returns a HeaderFooterPartsMutationResult on success; INVALID_TARGET failure if sections still reference the part.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET"],
			throws: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT",
				"CAPABILITY_UNAVAILABLE",
				"INTERNAL_ERROR"
			],
			historyUnsafe: true
		}),
		referenceDocPath: "header-footers/parts/delete.mdx",
		referenceGroup: "headerFooters"
	},
	"create.contentControl": {
		memberPath: "create.contentControl",
		description: "Create a new content control (SDT) in the document.",
		expectedResult: "Returns a ContentControlMutationResult with the created content control target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_TARGET", "NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/create.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.list": {
		memberPath: "contentControls.list",
		description: "List all content controls in the document with optional type/tag filtering.",
		expectedResult: "Returns a ContentControlsListResult with items and total count.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/list.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.get": {
		memberPath: "contentControls.get",
		description: "Retrieve a single content control by target.",
		expectedResult: "Returns a ContentControlInfo with full properties.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/get.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.listInRange": {
		memberPath: "contentControls.listInRange",
		description: "List content controls within a block range.",
		expectedResult: "Returns a ContentControlsListResult scoped to the range.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/list-in-range.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.selectByTag": {
		memberPath: "contentControls.selectByTag",
		description: "Select content controls matching a specific tag value.",
		expectedResult: "Returns a ContentControlsListResult with matching items.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/select-by-tag.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.selectByTitle": {
		memberPath: "contentControls.selectByTitle",
		description: "Select content controls matching a specific title (alias) value.",
		expectedResult: "Returns a ContentControlsListResult with matching items.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/select-by-title.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.listChildren": {
		memberPath: "contentControls.listChildren",
		description: "List direct child content controls nested inside the target.",
		expectedResult: "Returns a ContentControlsListResult with child items.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/list-children.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.getParent": {
		memberPath: "contentControls.getParent",
		description: "Get the parent content control of the target, if any.",
		expectedResult: "Returns a ContentControlInfo for the parent, or null if no parent SDT exists.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/get-parent.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.wrap": {
		memberPath: "contentControls.wrap",
		description: "Wrap existing content with a new content control.",
		expectedResult: "Returns a ContentControlMutationResult with the wrapper target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/wrap.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.unwrap": {
		memberPath: "contentControls.unwrap",
		description: "Remove the content control wrapper, preserving its content in place.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already unwrapped.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/unwrap.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.delete": {
		memberPath: "contentControls.delete",
		description: "Delete a content control and its content from the document.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already removed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/delete.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.copy": {
		memberPath: "contentControls.copy",
		description: "Copy a content control to a destination position. Copied SDTs receive new IDs.",
		expectedResult: "Returns a ContentControlMutationResult with the copied content control target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/copy.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.move": {
		memberPath: "contentControls.move",
		description: "Move a content control to a new position. Preserves original IDs.",
		expectedResult: "Returns a ContentControlMutationResult with the updated target position.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/move.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.patch": {
		memberPath: "contentControls.patch",
		description: "Patch metadata properties on a content control (tag, alias, appearance, color, etc.).",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if no fields changed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/patch.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.setLockMode": {
		memberPath: "contentControls.setLockMode",
		description: "Set the lock mode on a content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if lock mode unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/set-lock-mode.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.setType": {
		memberPath: "contentControls.setType",
		description: "Transition a content control to a different semantic type. Metadata-only; no implicit content rewrite.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if type unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/set-type.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.getContent": {
		memberPath: "contentControls.getContent",
		description: "Get the text content of a content control.",
		expectedResult: "Returns a ContentControlsGetContentResult with the content string and format.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/get-content.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.replaceContent": {
		memberPath: "contentControls.replaceContent",
		description: "Replace the entire content of a content control.",
		expectedResult: "Returns a ContentControlMutationResult with the updated target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/replace-content.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.clearContent": {
		memberPath: "contentControls.clearContent",
		description: "Clear all content inside a content control, leaving it empty.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/clear-content.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.appendContent": {
		memberPath: "contentControls.appendContent",
		description: "Append content to the end of a content control.",
		expectedResult: "Returns a ContentControlMutationResult with the updated target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/append-content.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.prependContent": {
		memberPath: "contentControls.prependContent",
		description: "Prepend content to the beginning of a content control.",
		expectedResult: "Returns a ContentControlMutationResult with the updated target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/prepend-content.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.insertBefore": {
		memberPath: "contentControls.insertBefore",
		description: "Insert content immediately before a content control.",
		expectedResult: "Returns a ContentControlMutationResult with the target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/insert-before.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.insertAfter": {
		memberPath: "contentControls.insertAfter",
		description: "Insert content immediately after a content control.",
		expectedResult: "Returns a ContentControlMutationResult with the target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/insert-after.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.getBinding": {
		memberPath: "contentControls.getBinding",
		description: "Get the data binding metadata (w:dataBinding) of a content control.",
		expectedResult: "Returns the ContentControlBinding or null if no binding is set.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/get-binding.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.setBinding": {
		memberPath: "contentControls.setBinding",
		description: "Set data binding metadata on a content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if binding unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/set-binding.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.clearBinding": {
		memberPath: "contentControls.clearBinding",
		description: "Remove data binding metadata from a content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if no binding existed.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/clear-binding.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.getRawProperties": {
		memberPath: "contentControls.getRawProperties",
		description: "Get the raw sdtPr properties of a content control as a passthrough hash.",
		expectedResult: "Returns a ContentControlsGetRawPropertiesResult with the raw properties.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/get-raw-properties.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.patchRawProperties": {
		memberPath: "contentControls.patchRawProperties",
		description: "Apply raw XML-level patches to the sdtPr subtree of a content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if no effective changes.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_RAW
		}),
		referenceDocPath: "content-controls/patch-raw-properties.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.validateWordCompatibility": {
		memberPath: "contentControls.validateWordCompatibility",
		description: "Validate a content control for Word compatibility issues.",
		expectedResult: "Returns a compatibility result with diagnostics.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_READ }),
		referenceDocPath: "content-controls/validate-word-compatibility.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.normalizeWordCompatibility": {
		memberPath: "contentControls.normalizeWordCompatibility",
		description: "Normalize a content control to resolve Word compatibility issues.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already compatible.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_RAW
		}),
		referenceDocPath: "content-controls/normalize-word-compatibility.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.normalizeTagPayload": {
		memberPath: "contentControls.normalizeTagPayload",
		description: "Normalize a content control tag between plain-string and JSON-encoded formats.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already normalized.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_RAW
		}),
		referenceDocPath: "content-controls/normalize-tag-payload.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.text.setMultiline": {
		memberPath: "contentControls.text.setMultiline",
		description: "Set or clear the multiline attribute on a plain-text content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/text/set-multiline.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.text.setValue": {
		memberPath: "contentControls.text.setValue",
		description: "Set the text value of a plain-text content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/text/set-value.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.text.clearValue": {
		memberPath: "contentControls.text.clearValue",
		description: "Clear the text value of a plain-text content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/text/clear-value.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.setValue": {
		memberPath: "contentControls.date.setValue",
		description: "Set the date value of a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/set-value.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.clearValue": {
		memberPath: "contentControls.date.clearValue",
		description: "Clear the date value of a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if already empty.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/clear-value.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.setDisplayFormat": {
		memberPath: "contentControls.date.setDisplayFormat",
		description: "Set the display format string for a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/set-display-format.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.setDisplayLocale": {
		memberPath: "contentControls.date.setDisplayLocale",
		description: "Set the display locale for a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/set-display-locale.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.setStorageFormat": {
		memberPath: "contentControls.date.setStorageFormat",
		description: "Set the XML storage format for a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/set-storage-format.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.date.setCalendar": {
		memberPath: "contentControls.date.setCalendar",
		description: "Set the calendar type for a date content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/date/set-calendar.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.checkbox.getState": {
		memberPath: "contentControls.checkbox.getState",
		description: "Get the checked state of a checkbox content control.",
		expectedResult: "Returns a CheckboxGetStateResult with the checked boolean.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_TYPED_READ }),
		referenceDocPath: "content-controls/checkbox/get-state.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.checkbox.setState": {
		memberPath: "contentControls.checkbox.setState",
		description: "Set the checked state of a checkbox content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/checkbox/set-state.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.checkbox.toggle": {
		memberPath: "contentControls.checkbox.toggle",
		description: "Toggle the checked state of a checkbox content control.",
		expectedResult: "Returns a ContentControlMutationResult with the updated state.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/checkbox/toggle.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.checkbox.setSymbolPair": {
		memberPath: "contentControls.checkbox.setSymbolPair",
		description: "Set the checked and unchecked symbol glyphs for a checkbox content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if symbols unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/checkbox/set-symbol-pair.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.choiceList.getItems": {
		memberPath: "contentControls.choiceList.getItems",
		description: "Get the list items and selected value of a comboBox or dropDownList content control.",
		expectedResult: "Returns a ChoiceListGetItemsResult with items and selectedValue.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_TYPED_READ }),
		referenceDocPath: "content-controls/choice-list/get-items.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.choiceList.setItems": {
		memberPath: "contentControls.choiceList.setItems",
		description: "Replace the list items of a comboBox or dropDownList content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if items unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/choice-list/set-items.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.choiceList.setSelected": {
		memberPath: "contentControls.choiceList.setSelected",
		description: "Set the selected value of a comboBox or dropDownList content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if selection unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/choice-list/set-selected.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.listItems": {
		memberPath: "contentControls.repeatingSection.listItems",
		description: "List the repeating section items inside a repeating section content control.",
		expectedResult: "Returns a RepeatingSectionListItemsResult with child item info.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_CC_TYPED_READ }),
		referenceDocPath: "content-controls/repeating-section/list-items.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.insertItemBefore": {
		memberPath: "contentControls.repeatingSection.insertItemBefore",
		description: "Insert a new item before a specific index in a repeating section.",
		expectedResult: "Returns a ContentControlMutationResult with the new item target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/repeating-section/insert-item-before.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.insertItemAfter": {
		memberPath: "contentControls.repeatingSection.insertItemAfter",
		description: "Insert a new item after a specific index in a repeating section.",
		expectedResult: "Returns a ContentControlMutationResult with the new item target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/repeating-section/insert-item-after.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.cloneItem": {
		memberPath: "contentControls.repeatingSection.cloneItem",
		description: "Clone a repeating section item at the given index. Cloned SDTs receive new IDs.",
		expectedResult: "Returns a ContentControlMutationResult with the cloned item target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/repeating-section/clone-item.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.deleteItem": {
		memberPath: "contentControls.repeatingSection.deleteItem",
		description: "Delete a repeating section item at the given index.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if item does not exist.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/repeating-section/delete-item.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.repeatingSection.setAllowInsertDelete": {
		memberPath: "contentControls.repeatingSection.setAllowInsertDelete",
		description: "Set the allowInsertDelete flag on a repeating section.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if unchanged.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/repeating-section/set-allow-insert-delete.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.group.wrap": {
		memberPath: "contentControls.group.wrap",
		description: "Wrap a content control inside a new group content control. Always nests; not idempotent.",
		expectedResult: "Returns a ContentControlMutationResult with the new group wrapper target.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [],
			throws: T_CC_MUTATION
		}),
		referenceDocPath: "content-controls/group/wrap.mdx",
		referenceGroup: "contentControls"
	},
	"contentControls.group.ungroup": {
		memberPath: "contentControls.group.ungroup",
		description: "Remove the group designation from a group content control.",
		expectedResult: "Returns a ContentControlMutationResult; reports NO_OP if not a group.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_CC_TYPED
		}),
		referenceDocPath: "content-controls/group/ungroup.mdx",
		referenceGroup: "contentControls"
	},
	"bookmarks.list": {
		memberPath: "bookmarks.list",
		description: "List all bookmarks in the document.",
		expectedResult: "Returns a BookmarksListResult containing discovered bookmarks with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "bookmarks/list.mdx",
		referenceGroup: "bookmarks"
	},
	"bookmarks.get": {
		memberPath: "bookmarks.get",
		description: "Get detailed information about a specific bookmark.",
		expectedResult: "Returns a BookmarkInfo object with the bookmark's name, range, and optional table-column data.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "bookmarks/get.mdx",
		referenceGroup: "bookmarks"
	},
	"bookmarks.insert": {
		memberPath: "bookmarks.insert",
		description: "Insert a new named bookmark at a target location.",
		expectedResult: "Returns a BookmarkMutationResult indicating success with the bookmark address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "bookmarks/insert.mdx",
		referenceGroup: "bookmarks"
	},
	"bookmarks.rename": {
		memberPath: "bookmarks.rename",
		description: "Rename an existing bookmark.",
		expectedResult: "Returns a BookmarkMutationResult indicating success with the updated bookmark address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "bookmarks/rename.mdx",
		referenceGroup: "bookmarks"
	},
	"bookmarks.remove": {
		memberPath: "bookmarks.remove",
		description: "Remove a bookmark from the document.",
		expectedResult: "Returns a BookmarkMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "bookmarks/remove.mdx",
		referenceGroup: "bookmarks"
	},
	"footnotes.list": {
		memberPath: "footnotes.list",
		description: "List all footnotes and endnotes in the document.",
		expectedResult: "Returns a FootnotesListResult containing discovered footnotes with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "footnotes/list.mdx",
		referenceGroup: "footnotes"
	},
	"footnotes.get": {
		memberPath: "footnotes.get",
		description: "Get detailed information about a specific footnote or endnote.",
		expectedResult: "Returns a FootnoteInfo object with the note's type, display number, and content.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "footnotes/get.mdx",
		referenceGroup: "footnotes"
	},
	"footnotes.insert": {
		memberPath: "footnotes.insert",
		description: "Insert a new footnote or endnote at a target location.",
		expectedResult: "Returns a FootnoteMutationResult indicating success with the footnote address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "footnotes/insert.mdx",
		referenceGroup: "footnotes"
	},
	"footnotes.update": {
		memberPath: "footnotes.update",
		description: "Update the content of an existing footnote or endnote.",
		expectedResult: "Returns a FootnoteMutationResult indicating success with the updated footnote address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "footnotes/update.mdx",
		referenceGroup: "footnotes"
	},
	"footnotes.remove": {
		memberPath: "footnotes.remove",
		description: "Remove a footnote or endnote from the document.",
		expectedResult: "Returns a FootnoteMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "footnotes/remove.mdx",
		referenceGroup: "footnotes"
	},
	"footnotes.configure": {
		memberPath: "footnotes.configure",
		description: "Configure numbering and placement for footnotes or endnotes.",
		expectedResult: "Returns a FootnoteConfigResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "footnotes/configure.mdx",
		referenceGroup: "footnotes"
	},
	"crossRefs.list": {
		memberPath: "crossRefs.list",
		description: "List all cross-reference fields in the document.",
		expectedResult: "Returns a CrossRefsListResult containing discovered cross-references with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "cross-refs/list.mdx",
		referenceGroup: "crossRefs"
	},
	"crossRefs.get": {
		memberPath: "crossRefs.get",
		description: "Get detailed information about a specific cross-reference field.",
		expectedResult: "Returns a CrossRefInfo object with the cross-reference's target, display, and resolved text.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "cross-refs/get.mdx",
		referenceGroup: "crossRefs"
	},
	"crossRefs.insert": {
		memberPath: "crossRefs.insert",
		description: "Insert a new cross-reference field at a target location.",
		expectedResult: "Returns a CrossRefMutationResult indicating success with the cross-reference address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "cross-refs/insert.mdx",
		referenceGroup: "crossRefs"
	},
	"crossRefs.rebuild": {
		memberPath: "crossRefs.rebuild",
		description: "Rebuild (recalculate) a cross-reference field.",
		expectedResult: "Returns a CrossRefMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "cross-refs/rebuild.mdx",
		referenceGroup: "crossRefs"
	},
	"crossRefs.remove": {
		memberPath: "crossRefs.remove",
		description: "Remove a cross-reference field from the document.",
		expectedResult: "Returns a CrossRefMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "cross-refs/remove.mdx",
		referenceGroup: "crossRefs"
	},
	"index.list": {
		memberPath: "index.list",
		description: "List all index blocks in the document.",
		expectedResult: "Returns an IndexListResult containing discovered index blocks with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "index/list.mdx",
		referenceGroup: "index"
	},
	"index.get": {
		memberPath: "index.get",
		description: "Get detailed information about a specific index block.",
		expectedResult: "Returns an IndexInfo object with the index's instruction, configuration, and entry count.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "index/get.mdx",
		referenceGroup: "index"
	},
	"index.insert": {
		memberPath: "index.insert",
		description: "Insert a new index block at a target location.",
		expectedResult: "Returns an IndexMutationResult indicating success with the index address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "index/insert.mdx",
		referenceGroup: "index"
	},
	"index.configure": {
		memberPath: "index.configure",
		description: "Update the configuration of an existing index block.",
		expectedResult: "Returns an IndexMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "index/configure.mdx",
		referenceGroup: "index"
	},
	"index.rebuild": {
		memberPath: "index.rebuild",
		description: "Rebuild (regenerate) an index block from its entries.",
		expectedResult: "Returns an IndexMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "index/rebuild.mdx",
		referenceGroup: "index"
	},
	"index.remove": {
		memberPath: "index.remove",
		description: "Remove an index block from the document.",
		expectedResult: "Returns an IndexMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "index/remove.mdx",
		referenceGroup: "index"
	},
	"index.entries.list": {
		memberPath: "index.entries.list",
		description: "List all XE (index entry) fields in the document.",
		expectedResult: "Returns an IndexEntryListResult containing discovered index entries with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "index/entries-list.mdx",
		referenceGroup: "index"
	},
	"index.entries.get": {
		memberPath: "index.entries.get",
		description: "Get detailed information about a specific XE index entry.",
		expectedResult: "Returns an IndexEntryInfo object with the entry's text, sub-entry, formatting, and instruction.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "index/entries-get.mdx",
		referenceGroup: "index"
	},
	"index.entries.insert": {
		memberPath: "index.entries.insert",
		description: "Insert a new XE index entry field at a target location.",
		expectedResult: "Returns an IndexEntryMutationResult indicating success with the entry address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "index/entries-insert.mdx",
		referenceGroup: "index"
	},
	"index.entries.update": {
		memberPath: "index.entries.update",
		description: "Update the properties of an existing XE index entry.",
		expectedResult: "Returns an IndexEntryMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "index/entries-update.mdx",
		referenceGroup: "index"
	},
	"index.entries.remove": {
		memberPath: "index.entries.remove",
		description: "Remove an XE index entry field from the document.",
		expectedResult: "Returns an IndexEntryMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "index/entries-remove.mdx",
		referenceGroup: "index"
	},
	"captions.list": {
		memberPath: "captions.list",
		description: "List all caption paragraphs in the document.",
		expectedResult: "Returns a CaptionsListResult containing discovered captions with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "captions/list.mdx",
		referenceGroup: "captions"
	},
	"captions.get": {
		memberPath: "captions.get",
		description: "Get detailed information about a specific caption paragraph.",
		expectedResult: "Returns a CaptionInfo object with the caption's label, number, text, and instruction.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "captions/get.mdx",
		referenceGroup: "captions"
	},
	"captions.insert": {
		memberPath: "captions.insert",
		description: "Insert a new caption paragraph adjacent to a target block.",
		expectedResult: "Returns a CaptionMutationResult indicating success with the caption address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "captions/insert.mdx",
		referenceGroup: "captions"
	},
	"captions.update": {
		memberPath: "captions.update",
		description: "Update the text of an existing caption paragraph.",
		expectedResult: "Returns a CaptionMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "captions/update.mdx",
		referenceGroup: "captions"
	},
	"captions.remove": {
		memberPath: "captions.remove",
		description: "Remove a caption paragraph from the document.",
		expectedResult: "Returns a CaptionMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "captions/remove.mdx",
		referenceGroup: "captions"
	},
	"captions.configure": {
		memberPath: "captions.configure",
		description: "Configure numbering format for a caption label.",
		expectedResult: "Returns a CaptionConfigResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "captions/configure.mdx",
		referenceGroup: "captions"
	},
	"fields.list": {
		memberPath: "fields.list",
		description: "List all fields in the document.",
		expectedResult: "Returns a FieldsListResult containing discovered fields with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "fields/list.mdx",
		referenceGroup: "fields"
	},
	"fields.get": {
		memberPath: "fields.get",
		description: "Get detailed information about a specific field.",
		expectedResult: "Returns a FieldInfo object with the field's instruction, result text, and nesting data.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "fields/get.mdx",
		referenceGroup: "fields"
	},
	"fields.insert": {
		memberPath: "fields.insert",
		description: "Insert a raw field code at a target location.",
		expectedResult: "Returns a FieldMutationResult indicating success with the field address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "fields/insert.mdx",
		referenceGroup: "fields"
	},
	"fields.rebuild": {
		memberPath: "fields.rebuild",
		description: "Rebuild (recalculate) a field.",
		expectedResult: "Returns a FieldMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "fields/rebuild.mdx",
		referenceGroup: "fields"
	},
	"fields.remove": {
		memberPath: "fields.remove",
		description: "Remove a field from the document.",
		expectedResult: "Returns a FieldMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "fields/remove.mdx",
		referenceGroup: "fields"
	},
	"citations.list": {
		memberPath: "citations.list",
		description: "List all citation marks in the document.",
		expectedResult: "Returns a CitationsListResult containing discovered citation marks with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "citations/list.mdx",
		referenceGroup: "citations"
	},
	"citations.get": {
		memberPath: "citations.get",
		description: "Get detailed information about a specific citation mark.",
		expectedResult: "Returns a CitationInfo object with the citation's source references and display text.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "citations/get.mdx",
		referenceGroup: "citations"
	},
	"citations.insert": {
		memberPath: "citations.insert",
		description: "Insert a new citation mark at a target location.",
		expectedResult: "Returns a CitationMutationResult indicating success with the citation address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "citations/insert.mdx",
		referenceGroup: "citations"
	},
	"citations.update": {
		memberPath: "citations.update",
		description: "Update an existing citation mark's source references.",
		expectedResult: "Returns a CitationMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "citations/update.mdx",
		referenceGroup: "citations"
	},
	"citations.remove": {
		memberPath: "citations.remove",
		description: "Remove a citation mark from the document.",
		expectedResult: "Returns a CitationMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "citations/remove.mdx",
		referenceGroup: "citations"
	},
	"citations.sources.list": {
		memberPath: "citations.sources.list",
		description: "List all citation sources in the document store.",
		expectedResult: "Returns a CitationSourcesListResult containing discovered sources with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "citations/sources-list.mdx",
		referenceGroup: "citations"
	},
	"citations.sources.get": {
		memberPath: "citations.sources.get",
		description: "Get detailed information about a specific citation source.",
		expectedResult: "Returns a CitationSourceInfo object with the source's type, fields, and metadata.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "citations/sources-get.mdx",
		referenceGroup: "citations"
	},
	"citations.sources.insert": {
		memberPath: "citations.sources.insert",
		description: "Register a new citation source in the document store.",
		expectedResult: "Returns a CitationSourceMutationResult indicating success with the source address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "citations/sources-insert.mdx",
		referenceGroup: "citations"
	},
	"citations.sources.update": {
		memberPath: "citations.sources.update",
		description: "Update the fields of an existing citation source.",
		expectedResult: "Returns a CitationSourceMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "citations/sources-update.mdx",
		referenceGroup: "citations"
	},
	"citations.sources.remove": {
		memberPath: "citations.sources.remove",
		description: "Remove a citation source from the document store.",
		expectedResult: "Returns a CitationSourceMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "citations/sources-remove.mdx",
		referenceGroup: "citations"
	},
	"citations.bibliography.get": {
		memberPath: "citations.bibliography.get",
		description: "Get information about the bibliography block.",
		expectedResult: "Returns a BibliographyInfo object with the bibliography's address and configuration.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "citations/bibliography-get.mdx",
		referenceGroup: "citations"
	},
	"citations.bibliography.insert": {
		memberPath: "citations.bibliography.insert",
		description: "Insert a bibliography block at a target location.",
		expectedResult: "Returns a BibliographyMutationResult indicating success with the bibliography address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "citations/bibliography-insert.mdx",
		referenceGroup: "citations"
	},
	"citations.bibliography.rebuild": {
		memberPath: "citations.bibliography.rebuild",
		description: "Rebuild the bibliography from current sources.",
		expectedResult: "Returns a BibliographyMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "citations/bibliography-rebuild.mdx",
		referenceGroup: "citations"
	},
	"citations.bibliography.configure": {
		memberPath: "citations.bibliography.configure",
		description: "Configure the bibliography style.",
		expectedResult: "Returns a BibliographyMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "citations/bibliography-configure.mdx",
		referenceGroup: "citations"
	},
	"citations.bibliography.remove": {
		memberPath: "citations.bibliography.remove",
		description: "Remove the bibliography block from the document.",
		expectedResult: "Returns a BibliographyMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "citations/bibliography-remove.mdx",
		referenceGroup: "citations"
	},
	"authorities.list": {
		memberPath: "authorities.list",
		description: "List all table-of-authorities blocks in the document.",
		expectedResult: "Returns an AuthoritiesListResult containing discovered TOA blocks with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "authorities/list.mdx",
		referenceGroup: "authorities"
	},
	"authorities.get": {
		memberPath: "authorities.get",
		description: "Get detailed information about a specific table-of-authorities block.",
		expectedResult: "Returns an AuthoritiesInfo object with the TOA's category filter and configuration.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "authorities/get.mdx",
		referenceGroup: "authorities"
	},
	"authorities.insert": {
		memberPath: "authorities.insert",
		description: "Insert a new table-of-authorities block at a target location.",
		expectedResult: "Returns an AuthoritiesMutationResult indicating success with the TOA address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "authorities/insert.mdx",
		referenceGroup: "authorities"
	},
	"authorities.configure": {
		memberPath: "authorities.configure",
		description: "Update the configuration of an existing table-of-authorities block.",
		expectedResult: "Returns an AuthoritiesMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "authorities/configure.mdx",
		referenceGroup: "authorities"
	},
	"authorities.rebuild": {
		memberPath: "authorities.rebuild",
		description: "Rebuild a table-of-authorities block from its entries.",
		expectedResult: "Returns an AuthoritiesMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "authorities/rebuild.mdx",
		referenceGroup: "authorities"
	},
	"authorities.remove": {
		memberPath: "authorities.remove",
		description: "Remove a table-of-authorities block from the document.",
		expectedResult: "Returns an AuthoritiesMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "authorities/remove.mdx",
		referenceGroup: "authorities"
	},
	"authorities.entries.list": {
		memberPath: "authorities.entries.list",
		description: "List all TA (authority entry) fields in the document.",
		expectedResult: "Returns an AuthorityEntryListResult containing discovered entries with address and domain data.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "authorities/entries-list.mdx",
		referenceGroup: "authorities"
	},
	"authorities.entries.get": {
		memberPath: "authorities.entries.get",
		description: "Get detailed information about a specific TA authority entry.",
		expectedResult: "Returns an AuthorityEntryInfo object with the entry's citations and category.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "authorities/entries-get.mdx",
		referenceGroup: "authorities"
	},
	"authorities.entries.insert": {
		memberPath: "authorities.entries.insert",
		description: "Insert a new TA authority entry field at a target location.",
		expectedResult: "Returns an AuthorityEntryMutationResult indicating success with the entry address or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_INSERT
		}),
		referenceDocPath: "authorities/entries-insert.mdx",
		referenceGroup: "authorities"
	},
	"authorities.entries.update": {
		memberPath: "authorities.entries.update",
		description: "Update the properties of an existing TA authority entry.",
		expectedResult: "Returns an AuthorityEntryMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "authorities/entries-update.mdx",
		referenceGroup: "authorities"
	},
	"authorities.entries.remove": {
		memberPath: "authorities.entries.remove",
		description: "Remove a TA authority entry field from the document.",
		expectedResult: "Returns an AuthorityEntryMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "authorities/entries-remove.mdx",
		referenceGroup: "authorities"
	},
	"diff.capture": {
		memberPath: "diff.capture",
		description: "Capture the current document's diffable state as a versioned snapshot. v1 covers body, comments, styles, and numbering. Header/footer content is not included.",
		expectedResult: "Returns a DiffSnapshot with a fingerprint and opaque payload.",
		requiresDocumentContext: true,
		metadata: readOperation({ idempotency: "idempotent" }),
		referenceDocPath: "diff/capture.mdx",
		referenceGroup: "diff",
		skipAsATool: true
	},
	"diff.compare": {
		memberPath: "diff.compare",
		description: "Compare the current document (base) against a previously captured target snapshot. Returns a versioned diff payload describing the changes from base to target.",
		expectedResult: "Returns a DiffPayload with a summary and opaque payload.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: ["INVALID_INPUT", "CAPABILITY_UNSUPPORTED"]
		}),
		referenceDocPath: "diff/compare.mdx",
		referenceGroup: "diff",
		skipAsATool: true
	},
	"diff.apply": {
		memberPath: "diff.apply",
		description: "Apply a previously computed diff payload to the current document. The document fingerprint must match the diff base fingerprint. Tracked mode governs body content only; styles, numbering, and comments are always applied directly.",
		expectedResult: "Returns a DiffApplyResult with applied operation count and diagnostics.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "conditional",
			supportsDryRun: false,
			supportsTrackedMode: true,
			possibleFailureCodes: NONE_FAILURES,
			throws: [
				"INVALID_INPUT",
				"CAPABILITY_UNSUPPORTED",
				"PRECONDITION_FAILED",
				"CAPABILITY_UNAVAILABLE"
			],
			historyUnsafe: true
		}),
		referenceDocPath: "diff/apply.mdx",
		referenceGroup: "diff",
		skipAsATool: true
	},
	"protection.get": {
		memberPath: "protection.get",
		description: "Read the current document protection state including editing restrictions, write protection, and read-only recommendation.",
		expectedResult: "Returns a DocumentProtectionState with editingRestriction, writeProtection, and readOnlyRecommended fields.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_PROTECTION_READ }),
		referenceDocPath: "protection/get.mdx",
		referenceGroup: "protection",
		skipAsATool: true
	},
	"protection.setEditingRestriction": {
		memberPath: "protection.setEditingRestriction",
		description: "Enable Word-style editing restriction on the document. Only readOnly mode is supported in v1.",
		expectedResult: "Returns a ProtectionMutationResult with the updated protection state on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PROTECTION_MUTATION
		}),
		referenceDocPath: "protection/set-editing-restriction.mdx",
		referenceGroup: "protection",
		skipAsATool: true
	},
	"protection.clearEditingRestriction": {
		memberPath: "protection.clearEditingRestriction",
		description: "Disable document-level editing restriction by setting enforcement to off. Preserves the protection element and its metadata for round-trip fidelity.",
		expectedResult: "Returns a ProtectionMutationResult with the updated protection state on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["NO_OP"],
			throws: T_PROTECTION_MUTATION
		}),
		referenceDocPath: "protection/clear-editing-restriction.mdx",
		referenceGroup: "protection",
		skipAsATool: true
	},
	"permissionRanges.list": {
		memberPath: "permissionRanges.list",
		description: "List all permission ranges in the document. Returns only complete paired ranges (both start and end markers present).",
		expectedResult: "Returns a PermissionRangesListResult containing discovered permission ranges with principal and position data.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_PERM_RANGE_READ }),
		referenceDocPath: "permission-ranges/list.mdx",
		referenceGroup: "permissionRanges",
		skipAsATool: true
	},
	"permissionRanges.get": {
		memberPath: "permissionRanges.get",
		description: "Get detailed information about a specific permission range by ID.",
		expectedResult: "Returns a PermissionRangeInfo object with the range principal, kind, and positions.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_PERM_RANGE_READ }),
		referenceDocPath: "permission-ranges/get.mdx",
		referenceGroup: "permissionRanges",
		skipAsATool: true
	},
	"permissionRanges.create": {
		memberPath: "permissionRanges.create",
		description: "Create a permission range exception region in the document. Inserts matched permStart/permEnd markers at the target.",
		expectedResult: "Returns a PermissionRangeMutationResult with the created range info on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_PERM_RANGE_MUTATION
		}),
		referenceDocPath: "permission-ranges/create.mdx",
		referenceGroup: "permissionRanges",
		skipAsATool: true
	},
	"permissionRanges.remove": {
		memberPath: "permissionRanges.remove",
		description: "Remove a permission range by ID. Removes whichever markers exist for the given ID (start, end, or both).",
		expectedResult: "Returns a PermissionRangeRemoveResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_PERM_RANGE_MUTATION
		}),
		referenceDocPath: "permission-ranges/remove.mdx",
		referenceGroup: "permissionRanges",
		skipAsATool: true
	},
	"permissionRanges.updatePrincipal": {
		memberPath: "permissionRanges.updatePrincipal",
		description: "Change which principal is allowed to edit a permission range. Updates the principal fields on the start marker.",
		expectedResult: "Returns a PermissionRangeMutationResult with the updated range info on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: NONE_FAILURES,
			throws: T_PERM_RANGE_MUTATION
		}),
		referenceDocPath: "permission-ranges/update-principal.mdx",
		referenceGroup: "permissionRanges",
		skipAsATool: true
	},
	"customXml.parts.list": {
		memberPath: "customXml.parts.list",
		description: "List Custom XML Data Storage Parts in the document, optionally filtered by root namespace or schema reference.",
		expectedResult: "Returns a CustomXmlPartsListResult with summary entries (no content); fetch content via get.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "custom-xml/parts/list.mdx",
		referenceGroup: "customXml"
	},
	"customXml.parts.get": {
		memberPath: "customXml.parts.get",
		description: "Get a single Custom XML Data Storage Part by itemID or package part name, including its full content. v1 partName targeting is limited to Word-style customXml/itemN.xml paths.",
		expectedResult: "Returns a CustomXmlPartInfo with id, partName, namespaces, schemaRefs, and content; or null if not found.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "custom-xml/parts/get.mdx",
		referenceGroup: "customXml"
	},
	"customXml.parts.create": {
		memberPath: "customXml.parts.create",
		description: "Add a new Custom XML Data Storage Part to the document. Generates a fresh itemID GUID and emits the Properties Part.",
		expectedResult: "Returns a CustomXmlPartsCreateResult with the generated id and package part names on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["INVALID_INPUT"],
			throws: T_REF_INSERT
		}),
		referenceDocPath: "custom-xml/parts/create.mdx",
		referenceGroup: "customXml"
	},
	"customXml.parts.patch": {
		memberPath: "customXml.parts.patch",
		description: "Replace the content and/or schemaRefs of an existing Custom XML Data Storage Part. At least one of content or schemaRefs is required. v1 partName targeting is limited to Word-style customXml/itemN.xml paths.",
		expectedResult: "Returns a CustomXmlPartsMutationResult indicating success with the resolved target or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["TARGET_NOT_FOUND", "INVALID_INPUT"],
			throws: T_REF_MUTATION
		}),
		referenceDocPath: "custom-xml/parts/patch.mdx",
		referenceGroup: "customXml"
	},
	"customXml.parts.remove": {
		memberPath: "customXml.parts.remove",
		description: "Remove a Custom XML Data Storage Part and clean up all linked package files (item, props, rels, content-types entry). v1 partName targeting is limited to Word-style customXml/itemN.xml paths.",
		expectedResult: "Returns a CustomXmlPartsMutationResult indicating success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["TARGET_NOT_FOUND"],
			throws: T_REF_MUTATION_REMOVE
		}),
		referenceDocPath: "custom-xml/parts/remove.mdx",
		referenceGroup: "customXml"
	},
	"metadata.attach": {
		memberPath: "metadata.attach",
		description: "Anchor a JSON metadata payload to a span of text. Wraps the target range in a hidden inline content control whose w:tag carries a stable id, and stores the payload in a namespaced Custom XML Data Storage Part. v1 supports text-range anchors only.",
		expectedResult: "Returns an AnchoredMetadataAttachResult with the assigned id and the backing Storage Part name on success.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: [
				"TARGET_NOT_FOUND",
				"INVALID_TARGET",
				"INVALID_INPUT"
			],
			throws: [...T_REF_INSERT, "REVISION_MISMATCH"]
		}),
		referenceDocPath: "metadata/attach.mdx",
		referenceGroup: "metadata"
	},
	"metadata.list": {
		memberPath: "metadata.list",
		description: "List anchored-metadata entries in the document, optionally filtered by consumer namespace and/or a `within` selection (returns only entries whose anchor overlaps `within`).",
		expectedResult: "Returns an AnchoredMetadataListResult with summary entries (no payload); fetch payload via get.",
		requiresDocumentContext: true,
		metadata: readOperation({
			idempotency: "idempotent",
			throws: T_REF_READ_LIST
		}),
		referenceDocPath: "metadata/list.mdx",
		referenceGroup: "metadata"
	},
	"metadata.get": {
		memberPath: "metadata.get",
		description: "Get a single anchored-metadata entry by id, including its JSON payload.",
		expectedResult: "Returns an AnchoredMetadataInfo with id, namespace, partName, and payload; or null if not found.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "metadata/get.mdx",
		referenceGroup: "metadata"
	},
	"metadata.update": {
		memberPath: "metadata.update",
		description: "Replace the JSON payload of an existing anchored-metadata entry. Replace semantics; no merge. The anchor is left untouched.",
		expectedResult: "Returns an AnchoredMetadataMutationResult with the entry id on success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["TARGET_NOT_FOUND", "INVALID_INPUT"],
			throws: [...T_REF_MUTATION, "REVISION_MISMATCH"]
		}),
		referenceDocPath: "metadata/update.mdx",
		referenceGroup: "metadata"
	},
	"metadata.remove": {
		memberPath: "metadata.remove",
		description: "Remove an anchored-metadata entry. Strips the anchor content-control wrapper (its content stays in the document) and deletes the payload entry from the Storage Part. In v1 these writes are sequenced, not transactional: the adapter resolves the target up-front so missing-target failures land before any state change, but a crash strictly between the two writes can leave a dangling payload. When the backing part has no remaining entries, the part itself is removed.",
		expectedResult: "Returns an AnchoredMetadataMutationResult with the removed entry id on success or a failure.",
		requiresDocumentContext: true,
		metadata: mutationOperation({
			idempotency: "non-idempotent",
			supportsDryRun: true,
			supportsTrackedMode: false,
			possibleFailureCodes: ["TARGET_NOT_FOUND"],
			throws: [...T_REF_MUTATION_REMOVE, "REVISION_MISMATCH"]
		}),
		referenceDocPath: "metadata/remove.mdx",
		referenceGroup: "metadata"
	},
	"metadata.resolve": {
		memberPath: "metadata.resolve",
		description: "Find where an anchored-metadata entry is anchored in the document. Returns the SelectionTarget covering the anchor content.",
		expectedResult: "Returns an AnchoredMetadataResolveInfo with id and target SelectionTarget; or null if the anchor is no longer present.",
		requiresDocumentContext: true,
		metadata: readOperation({ throws: T_NOT_FOUND_CAPABLE }),
		referenceDocPath: "metadata/resolve.mdx",
		referenceGroup: "metadata"
	}
};
const OPERATION_IDS = Object.freeze(Object.keys(OPERATION_DEFINITIONS));
Object.freeze(OPERATION_IDS.filter((id) => !id.includes(".")));
Object.freeze(OPERATION_IDS.filter((id) => id.includes(".")));
function projectFromDefinitions(fn) {
	return Object.fromEntries(OPERATION_IDS.map((id) => [id, fn(id, OPERATION_DEFINITIONS[id])]));
}
const COMMAND_CATALOG = projectFromDefinitions((_id, entry) => entry.metadata);
OPERATION_IDS.filter((operationId) => COMMAND_CATALOG[operationId].mutates);
projectFromDefinitions((_id, entry) => entry.description);
projectFromDefinitions((_id, entry) => entry.requiresDocumentContext);
projectFromDefinitions((_id, entry) => entry.expectedResult);
const TABLE_COLOR_PATTERN_SOURCE = "^(#?([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})|auto)$";
const TABLE_COLOR_PATTERN = new RegExp(TABLE_COLOR_PATTERN_SOURCE, "u");
function normalizeMutationOptions(options) {
	return {
		expectedRevision: options?.expectedRevision,
		changeMode: options?.changeMode ?? "direct",
		dryRun: options?.dryRun ?? false
	};
}
function executeWrite(adapter, request, options) {
	return adapter.write(request, normalizeMutationOptions(options));
}
const PARAGRAPH_ALIGNMENTS = [
	"left",
	"center",
	"right",
	"justify"
];
const TAB_STOP_ALIGNMENTS = [
	"left",
	"center",
	"right",
	"decimal",
	"bar"
];
const TAB_STOP_LEADERS = [
	"none",
	"dot",
	"hyphen",
	"underscore",
	"heavy",
	"middleDot"
];
const BORDER_SIDES = [
	"top",
	"bottom",
	"left",
	"right",
	"between",
	"bar"
];
const CLEAR_BORDER_SIDES = [
	"top",
	"bottom",
	"left",
	"right",
	"between",
	"bar",
	"all"
];
const LINE_RULES = [
	"auto",
	"exact",
	"atLeast"
];
const PARAGRAPH_DIRECTIONS = ["ltr", "rtl"];
const ALIGNMENT_POLICIES = ["preserve", "matchDirection"];
var PARAGRAPH_BLOCK_TYPES = new Set([
	"paragraph",
	"heading",
	"listItem"
]);
function assertParagraphTarget(input, operation) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} input must be a non-null object.`);
	const { target } = input;
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operation} requires a target.`);
	if (!isRecord(target)) throw new DocumentApiValidationError("INVALID_TARGET", `${operation} target must be an object.`, { field: "target" });
	if (target.kind !== "block") throw new DocumentApiValidationError("INVALID_TARGET", `${operation} target.kind must be 'block'.`, {
		field: "target.kind",
		value: target.kind
	});
	if (typeof target.nodeType !== "string" || !PARAGRAPH_BLOCK_TYPES.has(target.nodeType)) throw new DocumentApiValidationError("INVALID_TARGET", `${operation} target.nodeType must be 'paragraph', 'heading', or 'listItem'.`, {
		field: "target.nodeType",
		value: target.nodeType
	});
	if (typeof target.nodeId !== "string" || target.nodeId.length === 0) throw new DocumentApiValidationError("INVALID_TARGET", `${operation} target.nodeId must be a non-empty string.`, {
		field: "target.nodeId",
		value: target.nodeId
	});
}
function assertStrictBoolean(value, fieldName, operation) {
	if (value !== true && value !== false) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} ${fieldName} must be true or false, got ${JSON.stringify(value)}.`, {
		field: fieldName,
		value
	});
}
function assertNonNegativeInteger(value, fieldName, operation) {
	if (typeof value !== "number" || !Number.isInteger(value) || value < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} ${fieldName} must be a non-negative integer, got ${JSON.stringify(value)}.`, {
		field: fieldName,
		value
	});
}
function assertPositiveInteger$1(value, fieldName, operation) {
	if (typeof value !== "number" || !Number.isInteger(value) || value <= 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} ${fieldName} must be a positive integer, got ${JSON.stringify(value)}.`, {
		field: fieldName,
		value
	});
}
function assertOneOf$2(value, fieldName, allowed, operation) {
	if (typeof value !== "string" || !allowed.includes(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} ${fieldName} must be one of: ${allowed.join(", ")}. Got ${JSON.stringify(value)}.`, {
		field: fieldName,
		value
	});
}
function assertNonEmptyString$2(value, fieldName, operation) {
	if (typeof value !== "string" || value.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} ${fieldName} must be a non-empty string, got ${JSON.stringify(value)}.`, {
		field: fieldName,
		value
	});
}
function assertNotEmptyPatch(input, patchKeys, operation) {
	if (!patchKeys.some((key) => input[key] !== void 0)) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} requires at least one of: ${patchKeys.join(", ")}.`);
}
var SET_STYLE_KEYS = new Set(["target", "styleId"]);
var CLEAR_STYLE_KEYS = new Set(["target"]);
var RESET_DIRECT_FORMATTING_KEYS = new Set(["target"]);
var SET_ALIGNMENT_KEYS = new Set(["target", "alignment"]);
var CLEAR_ALIGNMENT_KEYS = new Set(["target"]);
var SET_INDENTATION_KEYS = new Set([
	"target",
	"left",
	"right",
	"firstLine",
	"hanging"
]);
var CLEAR_INDENTATION_KEYS = new Set(["target"]);
var SET_SPACING_KEYS = new Set([
	"target",
	"before",
	"after",
	"line",
	"lineRule"
]);
var CLEAR_SPACING_KEYS = new Set(["target"]);
var SET_KEEP_OPTIONS_KEYS = new Set([
	"target",
	"keepNext",
	"keepLines",
	"widowControl"
]);
var SET_OUTLINE_LEVEL_KEYS = new Set(["target", "outlineLevel"]);
var SET_FLOW_OPTIONS_KEYS = new Set([
	"target",
	"contextualSpacing",
	"pageBreakBefore",
	"suppressAutoHyphens"
]);
var SET_TAB_STOP_KEYS = new Set([
	"target",
	"position",
	"alignment",
	"leader"
]);
var CLEAR_TAB_STOP_KEYS = new Set(["target", "position"]);
var CLEAR_ALL_TAB_STOPS_KEYS = new Set(["target"]);
var SET_BORDER_KEYS = new Set([
	"target",
	"side",
	"style",
	"color",
	"size",
	"space"
]);
var CLEAR_BORDER_KEYS = new Set(["target", "side"]);
var SET_SHADING_KEYS = new Set([
	"target",
	"fill",
	"color",
	"pattern"
]);
var CLEAR_SHADING_KEYS = new Set(["target"]);
var SET_DIRECTION_KEYS = new Set([
	"target",
	"direction",
	"alignmentPolicy"
]);
var CLEAR_DIRECTION_KEYS = new Set(["target"]);
function validateSetStyle(input) {
	assertParagraphTarget(input, "styles.paragraph.setStyle");
	assertNoUnknownFields(input, SET_STYLE_KEYS, "styles.paragraph.setStyle");
	assertNonEmptyString$2(input.styleId, "styleId", "styles.paragraph.setStyle");
}
function validateClearStyle(input) {
	assertParagraphTarget(input, "styles.paragraph.clearStyle");
	assertNoUnknownFields(input, CLEAR_STYLE_KEYS, "styles.paragraph.clearStyle");
}
function validateResetDirectFormatting(input) {
	assertParagraphTarget(input, "format.paragraph.resetDirectFormatting");
	assertNoUnknownFields(input, RESET_DIRECT_FORMATTING_KEYS, "format.paragraph.resetDirectFormatting");
}
function validateSetAlignment(input) {
	assertParagraphTarget(input, "format.paragraph.setAlignment");
	assertNoUnknownFields(input, SET_ALIGNMENT_KEYS, "format.paragraph.setAlignment");
	const rec = input;
	if (rec.alignment === void 0) throw new DocumentApiValidationError("INVALID_INPUT", "format.paragraph.setAlignment requires an alignment field.");
	assertOneOf$2(rec.alignment, "alignment", PARAGRAPH_ALIGNMENTS, "format.paragraph.setAlignment");
}
function validateClearAlignment(input) {
	assertParagraphTarget(input, "format.paragraph.clearAlignment");
	assertNoUnknownFields(input, CLEAR_ALIGNMENT_KEYS, "format.paragraph.clearAlignment");
}
function validateSetIndentation(input) {
	const op = "format.paragraph.setIndentation";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_INDENTATION_KEYS, op);
	const rec = input;
	assertNotEmptyPatch(rec, [
		"left",
		"right",
		"firstLine",
		"hanging"
	], op);
	if (rec.left !== void 0) assertNonNegativeInteger(rec.left, "left", op);
	if (rec.right !== void 0) assertNonNegativeInteger(rec.right, "right", op);
	if (rec.firstLine !== void 0) assertNonNegativeInteger(rec.firstLine, "firstLine", op);
	if (rec.hanging !== void 0) assertNonNegativeInteger(rec.hanging, "hanging", op);
	if (rec.firstLine !== void 0 && rec.hanging !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op}: firstLine and hanging are mutually exclusive.`, { field: "firstLine,hanging" });
}
function validateClearIndentation(input) {
	assertParagraphTarget(input, "format.paragraph.clearIndentation");
	assertNoUnknownFields(input, CLEAR_INDENTATION_KEYS, "format.paragraph.clearIndentation");
}
function validateSetSpacing(input) {
	const op = "format.paragraph.setSpacing";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_SPACING_KEYS, op);
	const rec = input;
	assertNotEmptyPatch(rec, [
		"before",
		"after",
		"line",
		"lineRule"
	], op);
	if (rec.before !== void 0) assertNonNegativeInteger(rec.before, "before", op);
	if (rec.after !== void 0) assertNonNegativeInteger(rec.after, "after", op);
	if (rec.line !== void 0) {
		assertPositiveInteger$1(rec.line, "line", op);
		if (rec.lineRule === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op}: lineRule is required when line is provided.`);
	}
	if (rec.lineRule !== void 0) assertOneOf$2(rec.lineRule, "lineRule", LINE_RULES, op);
}
function validateClearSpacing(input) {
	assertParagraphTarget(input, "format.paragraph.clearSpacing");
	assertNoUnknownFields(input, CLEAR_SPACING_KEYS, "format.paragraph.clearSpacing");
}
function validateSetKeepOptions(input) {
	const op = "format.paragraph.setKeepOptions";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_KEEP_OPTIONS_KEYS, op);
	const rec = input;
	assertNotEmptyPatch(rec, [
		"keepNext",
		"keepLines",
		"widowControl"
	], op);
	if (rec.keepNext !== void 0) assertStrictBoolean(rec.keepNext, "keepNext", op);
	if (rec.keepLines !== void 0) assertStrictBoolean(rec.keepLines, "keepLines", op);
	if (rec.widowControl !== void 0) assertStrictBoolean(rec.widowControl, "widowControl", op);
}
function validateSetOutlineLevel(input) {
	const op = "format.paragraph.setOutlineLevel";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_OUTLINE_LEVEL_KEYS, op);
	const rec = input;
	if (rec.outlineLevel === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires an outlineLevel field.`);
	if (rec.outlineLevel !== null) {
		if (typeof rec.outlineLevel !== "number" || !Number.isInteger(rec.outlineLevel) || rec.outlineLevel < 0 || rec.outlineLevel > 9) throw new DocumentApiValidationError("INVALID_INPUT", `${op} outlineLevel must be an integer 0–9, or null. Got ${JSON.stringify(rec.outlineLevel)}.`, {
			field: "outlineLevel",
			value: rec.outlineLevel
		});
	}
}
function validateSetFlowOptions(input) {
	const op = "format.paragraph.setFlowOptions";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_FLOW_OPTIONS_KEYS, op);
	const rec = input;
	assertNotEmptyPatch(rec, [
		"contextualSpacing",
		"pageBreakBefore",
		"suppressAutoHyphens"
	], op);
	if (rec.contextualSpacing !== void 0) assertStrictBoolean(rec.contextualSpacing, "contextualSpacing", op);
	if (rec.pageBreakBefore !== void 0) assertStrictBoolean(rec.pageBreakBefore, "pageBreakBefore", op);
	if (rec.suppressAutoHyphens !== void 0) assertStrictBoolean(rec.suppressAutoHyphens, "suppressAutoHyphens", op);
}
function validateSetTabStop(input) {
	const op = "format.paragraph.setTabStop";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_TAB_STOP_KEYS, op);
	const rec = input;
	if (rec.position === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a position field.`);
	assertNonNegativeInteger(rec.position, "position", op);
	if (rec.alignment === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires an alignment field.`);
	assertOneOf$2(rec.alignment, "alignment", TAB_STOP_ALIGNMENTS, op);
	if (rec.leader !== void 0) assertOneOf$2(rec.leader, "leader", TAB_STOP_LEADERS, op);
}
function validateClearTabStop(input) {
	const op = "format.paragraph.clearTabStop";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, CLEAR_TAB_STOP_KEYS, op);
	const rec = input;
	if (rec.position === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a position field.`);
	assertNonNegativeInteger(rec.position, "position", op);
}
function validateClearAllTabStops(input) {
	assertParagraphTarget(input, "format.paragraph.clearAllTabStops");
	assertNoUnknownFields(input, CLEAR_ALL_TAB_STOPS_KEYS, "format.paragraph.clearAllTabStops");
}
function validateSetBorder(input) {
	const op = "format.paragraph.setBorder";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_BORDER_KEYS, op);
	const rec = input;
	if (rec.side === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a side field.`);
	assertOneOf$2(rec.side, "side", BORDER_SIDES, op);
	if (rec.style === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a style field.`);
	assertNonEmptyString$2(rec.style, "style", op);
	if (rec.color !== void 0) assertNonEmptyString$2(rec.color, "color", op);
	if (rec.size !== void 0) assertNonNegativeInteger(rec.size, "size", op);
	if (rec.space !== void 0) assertNonNegativeInteger(rec.space, "space", op);
}
function validateClearBorder(input) {
	const op = "format.paragraph.clearBorder";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, CLEAR_BORDER_KEYS, op);
	const rec = input;
	if (rec.side === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a side field.`);
	assertOneOf$2(rec.side, "side", CLEAR_BORDER_SIDES, op);
}
function validateSetShading(input) {
	const op = "format.paragraph.setShading";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_SHADING_KEYS, op);
	const rec = input;
	assertNotEmptyPatch(rec, [
		"fill",
		"color",
		"pattern"
	], op);
	if (rec.fill !== void 0) assertNonEmptyString$2(rec.fill, "fill", op);
	if (rec.color !== void 0) assertNonEmptyString$2(rec.color, "color", op);
	if (rec.pattern !== void 0) assertNonEmptyString$2(rec.pattern, "pattern", op);
}
function validateClearShading(input) {
	assertParagraphTarget(input, "format.paragraph.clearShading");
	assertNoUnknownFields(input, CLEAR_SHADING_KEYS, "format.paragraph.clearShading");
}
function validateSetDirection(input) {
	const op = "format.paragraph.setDirection";
	assertParagraphTarget(input, op);
	assertNoUnknownFields(input, SET_DIRECTION_KEYS, op);
	const rec = input;
	if (rec.direction === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} requires a direction field.`);
	assertOneOf$2(rec.direction, "direction", PARAGRAPH_DIRECTIONS, op);
	if (rec.alignmentPolicy !== void 0) assertOneOf$2(rec.alignmentPolicy, "alignmentPolicy", ALIGNMENT_POLICIES, op);
}
function validateClearDirection(input) {
	assertParagraphTarget(input, "format.paragraph.clearDirection");
	assertNoUnknownFields(input, CLEAR_DIRECTION_KEYS, "format.paragraph.clearDirection");
}
function executeParagraphsSetStyle(adapter, input, options) {
	validateSetStyle(input);
	return adapter.setStyle(input, normalizeMutationOptions(options));
}
function executeParagraphsClearStyle(adapter, input, options) {
	validateClearStyle(input);
	return adapter.clearStyle(input, normalizeMutationOptions(options));
}
function executeParagraphsResetDirectFormatting(adapter, input, options) {
	validateResetDirectFormatting(input);
	return adapter.resetDirectFormatting(input, normalizeMutationOptions(options));
}
function executeParagraphsSetAlignment(adapter, input, options) {
	validateSetAlignment(input);
	return adapter.setAlignment(input, normalizeMutationOptions(options));
}
function executeParagraphsClearAlignment(adapter, input, options) {
	validateClearAlignment(input);
	return adapter.clearAlignment(input, normalizeMutationOptions(options));
}
function executeParagraphsSetIndentation(adapter, input, options) {
	validateSetIndentation(input);
	return adapter.setIndentation(input, normalizeMutationOptions(options));
}
function executeParagraphsClearIndentation(adapter, input, options) {
	validateClearIndentation(input);
	return adapter.clearIndentation(input, normalizeMutationOptions(options));
}
function executeParagraphsSetSpacing(adapter, input, options) {
	validateSetSpacing(input);
	return adapter.setSpacing(input, normalizeMutationOptions(options));
}
function executeParagraphsClearSpacing(adapter, input, options) {
	validateClearSpacing(input);
	return adapter.clearSpacing(input, normalizeMutationOptions(options));
}
function executeParagraphsSetKeepOptions(adapter, input, options) {
	validateSetKeepOptions(input);
	return adapter.setKeepOptions(input, normalizeMutationOptions(options));
}
function executeParagraphsSetOutlineLevel(adapter, input, options) {
	validateSetOutlineLevel(input);
	return adapter.setOutlineLevel(input, normalizeMutationOptions(options));
}
function executeParagraphsSetFlowOptions(adapter, input, options) {
	validateSetFlowOptions(input);
	return adapter.setFlowOptions(input, normalizeMutationOptions(options));
}
function executeParagraphsSetTabStop(adapter, input, options) {
	validateSetTabStop(input);
	return adapter.setTabStop(input, normalizeMutationOptions(options));
}
function executeParagraphsClearTabStop(adapter, input, options) {
	validateClearTabStop(input);
	return adapter.clearTabStop(input, normalizeMutationOptions(options));
}
function executeParagraphsClearAllTabStops(adapter, input, options) {
	validateClearAllTabStops(input);
	return adapter.clearAllTabStops(input, normalizeMutationOptions(options));
}
function executeParagraphsSetBorder(adapter, input, options) {
	validateSetBorder(input);
	return adapter.setBorder(input, normalizeMutationOptions(options));
}
function executeParagraphsClearBorder(adapter, input, options) {
	validateClearBorder(input);
	return adapter.clearBorder(input, normalizeMutationOptions(options));
}
function executeParagraphsSetShading(adapter, input, options) {
	validateSetShading(input);
	return adapter.setShading(input, normalizeMutationOptions(options));
}
function executeParagraphsClearShading(adapter, input, options) {
	validateClearShading(input);
	return adapter.clearShading(input, normalizeMutationOptions(options));
}
function executeParagraphsSetDirection(adapter, input, options) {
	validateSetDirection(input);
	return adapter.setDirection(input, normalizeMutationOptions(options));
}
function executeParagraphsClearDirection(adapter, input, options) {
	validateClearDirection(input);
	return adapter.clearDirection(input, normalizeMutationOptions(options));
}
const ST_ON_OFF_ON_VALUES = new Set([
	"true",
	"1",
	"on"
]);
const ST_ON_OFF_OFF_VALUES = new Set([
	"false",
	"0",
	"off"
]);
const ST_UNDERLINE_VALUES = [
	"single",
	"double",
	"thick",
	"dotted",
	"dottedHeavy",
	"dash",
	"dashedHeavy",
	"dashLong",
	"dashLongHeavy",
	"dotDash",
	"dashDotHeavy",
	"dotDotDash",
	"dashDotDotHeavy",
	"wave",
	"wavyHeavy",
	"wavyDouble",
	"words",
	"none"
];
const ST_UNDERLINE_VALUE_SET = new Set(ST_UNDERLINE_VALUES);
const ST_VERTICAL_ALIGN_RUN = [
	"superscript",
	"subscript",
	"baseline"
];
const ST_EM = [
	"none",
	"dot",
	"comma",
	"circle",
	"sesame"
];
const ST_TEXT_ALIGNMENT = [
	"top",
	"center",
	"baseline",
	"bottom",
	"auto"
];
const ST_TEXT_DIRECTION = [
	"lrTb",
	"tbRl",
	"btLr",
	"lrTbV",
	"tbRlV",
	"tbLrV"
];
const ST_TEXTBOX_TIGHT_WRAP = [
	"none",
	"allLines",
	"firstAndLastLine",
	"firstLineOnly",
	"lastLineOnly"
];
const ST_TEXT_TRANSFORM = ["uppercase", "none"];
const ST_JUSTIFICATION = [
	"left",
	"center",
	"right",
	"justify",
	"distribute"
];
var FONT_FAMILY_SCHEMA = {
	kind: "object",
	children: {
		hint: { kind: "string" },
		ascii: { kind: "string" },
		hAnsi: { kind: "string" },
		eastAsia: { kind: "string" },
		cs: { kind: "string" },
		val: { kind: "string" },
		asciiTheme: { kind: "string" },
		hAnsiTheme: { kind: "string" },
		eastAsiaTheme: { kind: "string" },
		cstheme: { kind: "string" }
	}
};
var COLOR_SCHEMA = {
	kind: "object",
	children: {
		val: { kind: "string" },
		themeColor: { kind: "string" },
		themeTint: { kind: "string" },
		themeShade: { kind: "string" }
	}
};
var SPACING_SCHEMA = {
	kind: "object",
	children: {
		after: { kind: "integer" },
		afterAutospacing: { kind: "boolean" },
		afterLines: { kind: "integer" },
		before: { kind: "integer" },
		beforeAutospacing: { kind: "boolean" },
		beforeLines: { kind: "integer" },
		line: { kind: "integer" },
		lineRule: {
			kind: "enum",
			values: [
				"auto",
				"exact",
				"atLeast"
			]
		}
	}
};
var INDENT_SCHEMA = {
	kind: "object",
	children: {
		end: { kind: "integer" },
		endChars: { kind: "integer" },
		firstLine: { kind: "integer" },
		firstLineChars: { kind: "integer" },
		hanging: { kind: "integer" },
		hangingChars: { kind: "integer" },
		left: { kind: "integer" },
		leftChars: { kind: "integer" },
		right: { kind: "integer" },
		rightChars: { kind: "integer" },
		start: { kind: "integer" },
		startChars: { kind: "integer" }
	}
};
var UNDERLINE_SCHEMA = {
	kind: "object",
	children: {
		val: {
			kind: "enum",
			values: [...ST_UNDERLINE_VALUES]
		},
		color: { kind: "string" },
		themeColor: { kind: "string" },
		themeTint: { kind: "string" },
		themeShade: { kind: "string" }
	}
};
var BORDER_PROPERTIES_SCHEMA = {
	kind: "object",
	children: {
		val: { kind: "string" },
		color: { kind: "string" },
		themeColor: { kind: "string" },
		themeTint: { kind: "string" },
		themeShade: { kind: "string" },
		size: { kind: "integer" },
		space: { kind: "integer" },
		shadow: { kind: "boolean" },
		frame: { kind: "boolean" }
	}
};
var SHADING_SCHEMA = {
	kind: "object",
	children: {
		color: { kind: "string" },
		fill: { kind: "string" },
		themeColor: { kind: "string" },
		themeFill: { kind: "string" },
		themeFillShade: { kind: "string" },
		themeFillTint: { kind: "string" },
		themeShade: { kind: "string" },
		themeTint: { kind: "string" },
		val: { kind: "string" }
	}
};
var LANG_SCHEMA = {
	kind: "object",
	children: {
		val: { kind: "string" },
		eastAsia: { kind: "string" },
		bidi: { kind: "string" }
	}
};
var EAST_ASIAN_LAYOUT_SCHEMA = {
	kind: "object",
	children: {
		id: { kind: "integer" },
		combine: { kind: "boolean" },
		combineBrackets: { kind: "string" },
		vert: { kind: "boolean" },
		vertCompress: { kind: "boolean" }
	}
};
var FIT_TEXT_SCHEMA = {
	kind: "object",
	children: {
		val: { kind: "integer" },
		id: { kind: "integer" }
	}
};
var NUMBERING_PROPERTIES_SCHEMA = {
	kind: "object",
	children: {
		ilvl: { kind: "integer" },
		numId: { kind: "integer" }
	}
};
var FRAME_PR_SCHEMA = {
	kind: "object",
	children: {
		anchorLock: { kind: "boolean" },
		dropCap: { kind: "string" },
		h: { kind: "integer" },
		hAnchor: { kind: "string" },
		hRule: { kind: "string" },
		hSpace: { kind: "integer" },
		lines: { kind: "integer" },
		vAnchor: { kind: "string" },
		vSpace: { kind: "integer" },
		w: { kind: "integer" },
		wrap: { kind: "string" },
		x: { kind: "integer" },
		xAlign: { kind: "string" },
		y: { kind: "integer" },
		yAlign: { kind: "string" }
	}
};
var PARAGRAPH_BORDERS_SCHEMA = {
	kind: "object",
	children: {
		top: BORDER_PROPERTIES_SCHEMA,
		bottom: BORDER_PROPERTIES_SCHEMA,
		left: BORDER_PROPERTIES_SCHEMA,
		right: BORDER_PROPERTIES_SCHEMA,
		between: BORDER_PROPERTIES_SCHEMA,
		bar: BORDER_PROPERTIES_SCHEMA
	}
};
var TAB_STOP_SCHEMA = {
	kind: "array",
	item: {
		kind: "object",
		children: { tab: {
			kind: "object",
			children: {
				tabType: { kind: "string" },
				pos: { kind: "integer" },
				leader: { kind: "string" }
			}
		} }
	}
};
const PROPERTY_REGISTRY = [
	{
		key: "bold",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "boldCs",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "italic",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "iCs",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "smallCaps",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "strike",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "dstrike",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "emboss",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "imprint",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "outline",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "shadow",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "vanish",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "webHidden",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "specVanish",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "snapToGrid",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "noProof",
		channel: "run",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "fontSize",
		channel: "run",
		schema: { kind: "integer" },
		mergeStrategy: "replace"
	},
	{
		key: "fontSizeCs",
		channel: "run",
		schema: { kind: "integer" },
		mergeStrategy: "replace"
	},
	{
		key: "letterSpacing",
		channel: "run",
		schema: { kind: "integer" },
		mergeStrategy: "replace"
	},
	{
		key: "kern",
		channel: "run",
		schema: { kind: "integer" },
		mergeStrategy: "replace"
	},
	{
		key: "position",
		channel: "run",
		schema: { kind: "integer" },
		mergeStrategy: "replace"
	},
	{
		key: "w",
		channel: "run",
		schema: {
			kind: "integer",
			min: 1,
			max: 600
		},
		mergeStrategy: "replace"
	},
	{
		key: "textTransform",
		channel: "run",
		schema: {
			kind: "enum",
			values: [...ST_TEXT_TRANSFORM]
		},
		mergeStrategy: "replace"
	},
	{
		key: "vertAlign",
		channel: "run",
		schema: {
			kind: "enum",
			values: [...ST_VERTICAL_ALIGN_RUN]
		},
		mergeStrategy: "replace"
	},
	{
		key: "em",
		channel: "run",
		schema: {
			kind: "enum",
			values: [...ST_EM]
		},
		mergeStrategy: "replace"
	},
	{
		key: "effect",
		channel: "run",
		schema: { kind: "string" },
		mergeStrategy: "replace"
	},
	{
		key: "fontFamily",
		channel: "run",
		schema: FONT_FAMILY_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "color",
		channel: "run",
		schema: COLOR_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "underline",
		channel: "run",
		schema: UNDERLINE_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "borders",
		channel: "run",
		schema: BORDER_PROPERTIES_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "shading",
		channel: "run",
		schema: SHADING_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "lang",
		channel: "run",
		schema: LANG_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "eastAsianLayout",
		channel: "run",
		schema: EAST_ASIAN_LAYOUT_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "fitText",
		channel: "run",
		schema: FIT_TEXT_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "keepLines",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "keepNext",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "widowControl",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "contextualSpacing",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "pageBreakBefore",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "suppressAutoHyphens",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "suppressLineNumbers",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "suppressOverlap",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "mirrorIndents",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "wordWrap",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "kinsoku",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "overflowPunct",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "topLinePunct",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "autoSpaceDE",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "autoSpaceDN",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "adjustRightInd",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "rightToLeft",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "snapToGrid",
		channel: "paragraph",
		schema: { kind: "boolean" },
		mergeStrategy: "replace"
	},
	{
		key: "outlineLvl",
		channel: "paragraph",
		schema: {
			kind: "integer",
			min: 0,
			max: 9
		},
		mergeStrategy: "replace"
	},
	{
		key: "justification",
		channel: "paragraph",
		schema: {
			kind: "enum",
			values: [...ST_JUSTIFICATION]
		},
		mergeStrategy: "replace"
	},
	{
		key: "textAlignment",
		channel: "paragraph",
		schema: {
			kind: "enum",
			values: [...ST_TEXT_ALIGNMENT]
		},
		mergeStrategy: "replace"
	},
	{
		key: "textDirection",
		channel: "paragraph",
		schema: {
			kind: "enum",
			values: [...ST_TEXT_DIRECTION]
		},
		mergeStrategy: "replace"
	},
	{
		key: "textboxTightWrap",
		channel: "paragraph",
		schema: {
			kind: "enum",
			values: [...ST_TEXTBOX_TIGHT_WRAP]
		},
		mergeStrategy: "replace"
	},
	{
		key: "spacing",
		channel: "paragraph",
		schema: SPACING_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "indent",
		channel: "paragraph",
		schema: INDENT_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "shading",
		channel: "paragraph",
		schema: SHADING_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "numberingProperties",
		channel: "paragraph",
		schema: NUMBERING_PROPERTIES_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "framePr",
		channel: "paragraph",
		schema: FRAME_PR_SCHEMA,
		mergeStrategy: "shallowMerge"
	},
	{
		key: "borders",
		channel: "paragraph",
		schema: PARAGRAPH_BORDERS_SCHEMA,
		mergeStrategy: "edgeMerge"
	},
	{
		key: "tabStops",
		channel: "paragraph",
		schema: TAB_STOP_SCHEMA,
		mergeStrategy: "replace"
	}
];
const ALLOWED_KEYS_BY_CHANNEL = {
	run: new Set(PROPERTY_REGISTRY.filter((d) => d.channel === "run").map((d) => d.key)),
	paragraph: new Set(PROPERTY_REGISTRY.filter((d) => d.channel === "paragraph").map((d) => d.key))
};
var PROPERTY_INDEX = new Map(PROPERTY_REGISTRY.map((d) => [`${d.channel}:${d.key}`, d]));
function getPropertyDefinition(key, channel) {
	return PROPERTY_INDEX.get(`${channel}:${key}`);
}
const EXCLUDED_KEYS = {
	run: new Map([
		["cs", "w:cs"],
		["highlight", "w:highlight"],
		["oMath", "w:oMath"],
		["rPrChange", "w:rPrChange"],
		["rStyle", "w:rStyle"],
		["rtl", "w:rtl"]
	]),
	paragraph: new Map([
		["cnfStyle", "w:cnfStyle"],
		["divId", "w:divId"],
		["pPrChange", "w:pPrChange"],
		["pStyle", "w:pStyle"],
		["runProperties", "w:pPr/w:rPr"],
		["sectPr", "w:sectPr"]
	])
};
function toJsonSchema(schema) {
	switch (schema.kind) {
		case "boolean": return { type: "boolean" };
		case "integer": {
			const s = { type: "integer" };
			if (schema.min !== void 0) s.minimum = schema.min;
			if (schema.max !== void 0) s.maximum = schema.max;
			return s;
		}
		case "enum": return { enum: [...schema.values] };
		case "string": return {
			type: "string",
			minLength: 1
		};
		case "object": {
			const properties = {};
			for (const [key, childSchema] of Object.entries(schema.children)) properties[key] = toJsonSchema(childSchema);
			return {
				type: "object",
				properties,
				additionalProperties: false,
				minProperties: 1
			};
		}
		case "array": return {
			type: "array",
			items: toJsonSchema(schema.item)
		};
	}
}
function buildPatchSchema(channel) {
	const properties = {};
	for (const def of PROPERTY_REGISTRY) {
		if (def.channel !== channel) continue;
		properties[def.key] = toJsonSchema(def.schema);
	}
	return {
		type: "object",
		properties,
		additionalProperties: false,
		minProperties: 1
	};
}
function buildStateSchema() {
	const properties = {};
	for (const def of PROPERTY_REGISTRY) switch (def.schema.kind) {
		case "boolean":
			properties[def.key] = { enum: [
				"on",
				"off",
				"inherit"
			] };
			break;
		case "integer":
			properties[def.key] = { oneOf: [{ type: "number" }, { const: "inherit" }] };
			break;
		case "enum":
		case "string":
			properties[def.key] = { oneOf: [{ type: "string" }, { const: "inherit" }] };
			break;
		case "object":
			properties[def.key] = { oneOf: [{ type: "object" }, { const: "inherit" }] };
			break;
		case "array":
			properties[def.key] = { oneOf: [{ type: "array" }, { const: "inherit" }] };
			break;
	}
	return {
		type: "object",
		properties,
		additionalProperties: false
	};
}
function validateValue(path, value, schema) {
	switch (schema.kind) {
		case "boolean":
			if (typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be a boolean, got ${typeof value}.`, {
				field: path,
				value
			});
			return;
		case "integer":
			if (typeof value !== "number" || !Number.isFinite(value) || !Number.isInteger(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be a finite integer, got ${JSON.stringify(value)}.`, {
				field: path,
				value
			});
			if (schema.min !== void 0 && value < schema.min) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be >= ${schema.min}, got ${value}.`, {
				field: path,
				value
			});
			if (schema.max !== void 0 && value > schema.max) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be <= ${schema.max}, got ${value}.`, {
				field: path,
				value
			});
			return;
		case "enum":
			if (typeof value !== "string" || !schema.values.includes(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be one of: ${schema.values.join(", ")}. Got ${JSON.stringify(value)}.`, {
				field: path,
				value
			});
			return;
		case "string":
			if (typeof value !== "string" || value.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be a non-empty string, got ${JSON.stringify(value)}.`, {
				field: path,
				value
			});
			return;
		case "object":
			validateObjectValue(path, value, schema.children);
			return;
		case "array":
			validateArrayValue(path, value, schema.item);
			return;
	}
}
function validateObjectValue(path, value, children) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be a non-null object, got ${typeof value}.`, {
		field: path,
		value
	});
	const allowedKeys = new Set(Object.keys(children));
	const keys$1 = Object.keys(value);
	if (keys$1.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must include at least one property.`, { field: path });
	for (const key of keys$1) {
		if (!allowedKeys.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown key "${key}" on ${path}. Allowed keys: ${[...allowedKeys].join(", ")}.`, {
			field: path,
			key
		});
		validateValue(`${path}.${key}`, value[key], children[key]);
	}
}
function validateArrayValue(path, value, itemSchema) {
	if (!Array.isArray(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${path} must be an array, got ${typeof value}.`, {
		field: path,
		value
	});
	for (let i$1 = 0; i$1 < value.length; i$1++) validateValue(`${path}[${i$1}]`, value[i$1], itemSchema);
}
var INPUT_ALLOWED_KEYS = new Set(["target", "patch"]);
var TARGET_ALLOWED_KEYS = new Set(["scope", "channel"]);
var OPTIONS_ALLOWED_KEYS = new Set(["dryRun", "expectedRevision"]);
var VALID_CHANNELS = new Set(["run", "paragraph"]);
function validateStylesApplyInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "styles.apply input must be a non-null object.");
	assertNoUnknownFields$1(input, INPUT_ALLOWED_KEYS);
	const { target, patch } = input;
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", "styles.apply requires a target object.");
	if (!isRecord(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a non-null object.", {
		field: "target",
		value: target
	});
	assertNoUnknownFields$1(target, TARGET_ALLOWED_KEYS, "target");
	if (target.scope !== "docDefaults") throw new DocumentApiValidationError("INVALID_TARGET", `target.scope must be "docDefaults", got ${JSON.stringify(target.scope)}.`, {
		field: "target.scope",
		value: target.scope
	});
	if (!VALID_CHANNELS.has(target.channel)) throw new DocumentApiValidationError("INVALID_TARGET", `target.channel must be "run" or "paragraph", got ${JSON.stringify(target.channel)}.`, {
		field: "target.channel",
		value: target.channel
	});
	const channel = target.channel;
	if (patch === void 0 || patch === null) throw new DocumentApiValidationError("INVALID_INPUT", "styles.apply requires a patch object.");
	if (!isRecord(patch)) throw new DocumentApiValidationError("INVALID_INPUT", "patch must be a non-null object.", {
		field: "patch",
		value: patch
	});
	const patchKeys = Object.keys(patch);
	if (patchKeys.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "patch must include at least one property.");
	const allowedKeys = ALLOWED_KEYS_BY_CHANNEL[channel];
	for (const key of patchKeys) {
		const classification = classifyPatchKey(key, channel);
		switch (classification.status) {
			case "valid": break;
			case "excluded": throw new DocumentApiValidationError("INVALID_INPUT", `patch key '${key}' is not valid in Word docDefaults (${classification.reason}). This is an intentional restriction per MS-OI29500.`, {
				field: "patch",
				key,
				reason: "excluded_docdefaults_key"
			});
			case "cross_channel": throw new DocumentApiValidationError("INVALID_INPUT", `Unknown patch key "${key}" for channel "${channel}". "${key}" is a ${classification.ownerChannel}-channel property. Allowed keys: ${[...allowedKeys].join(", ")}.`, {
				field: "patch",
				key
			});
			case "unknown": throw new DocumentApiValidationError("INVALID_INPUT", `Unknown patch key "${key}" for channel "${channel}". Allowed keys: ${[...allowedKeys].join(", ")}.`, {
				field: "patch",
				key
			});
		}
		const def = getPropertyDefinition(key, channel);
		if (def) validateValue(`patch.${key}`, patch[key], def.schema);
	}
}
function validateStylesApplyOptions(options) {
	if (options === void 0 || options === null) return;
	if (!isRecord(options)) throw new DocumentApiValidationError("INVALID_INPUT", "styles.apply options must be a non-null object.");
	for (const key of Object.keys(options)) if (!OPTIONS_ALLOWED_KEYS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown options key "${key}". Allowed keys: ${[...OPTIONS_ALLOWED_KEYS].join(", ")}.`, {
		field: "options",
		key
	});
	if (options.dryRun !== void 0 && typeof options.dryRun !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "options.dryRun must be a boolean.", {
		field: "options.dryRun",
		value: options.dryRun
	});
	if (options.expectedRevision !== void 0 && typeof options.expectedRevision !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "options.expectedRevision must be a string.", {
		field: "options.expectedRevision",
		value: options.expectedRevision
	});
}
function classifyPatchKey(key, channel) {
	const excludedReason = EXCLUDED_KEYS[channel].get(key);
	if (excludedReason !== void 0) return {
		status: "excluded",
		reason: excludedReason
	};
	if (ALLOWED_KEYS_BY_CHANNEL[channel].has(key)) return { status: "valid" };
	const otherChannel = channel === "run" ? "paragraph" : "run";
	if (ALLOWED_KEYS_BY_CHANNEL[otherChannel].has(key)) return {
		status: "cross_channel",
		ownerChannel: otherChannel
	};
	const otherExcludedReason = EXCLUDED_KEYS[otherChannel].get(key);
	if (otherExcludedReason !== void 0) return {
		status: "excluded",
		reason: otherExcludedReason
	};
	return { status: "unknown" };
}
function assertNoUnknownFields$1(obj, allowlist, prefix) {
	for (const key of Object.keys(obj)) if (!allowlist.has(key)) {
		const location = prefix ? `${prefix}.${key}` : key;
		throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${location}" on styles.apply input. Allowed fields: ${[...allowlist].join(", ")}.`, { field: location });
	}
}
function normalizeOptions$1(options) {
	return {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision
	};
}
function executeStylesApply(adapter, input, options) {
	validateStylesApplyInput(input);
	validateStylesApplyOptions(options);
	return adapter.apply(input, normalizeOptions$1(options));
}
const Z_ORDER_RELATIVE_HEIGHT_MAX = 4294967295;
function isUnsignedInt32(value) {
	return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 4294967295;
}
var trackChangeTypeValues = [
	"insert",
	"delete",
	"replacement",
	"format"
];
function objectSchema(properties, required = []) {
	const schema = {
		type: "object",
		properties,
		additionalProperties: false
	};
	if (required.length > 0) schema.required = [...required];
	return schema;
}
function arraySchema(items) {
	return {
		type: "array",
		items
	};
}
function ref(name) {
	return { $ref: `#/$defs/${name}` };
}
function targetLocatorWithPayload(payloadProperties, payloadRequired = []) {
	return { oneOf: [objectSchema({
		target: {
			...ref("SelectionTarget"),
			description: "Selection target: {kind:'selection', start:{kind:'text', blockId, offset}, end:{kind:'text', blockId, offset}}. Use 'ref' instead when you have a search result handle."
		},
		...payloadProperties
	}, ["target", ...payloadRequired]), objectSchema({
		ref: {
			type: "string",
			description: "Handle ref string from a superdoc_search result. Pass the handle.ref value directly (e.g. 'text:eyJ...'). Preferred over 'target' for inline formatting."
		},
		...payloadProperties
	}, ["ref", ...payloadRequired])] };
}
function optionalTargetLocatorWithPayload(payloadProperties, payloadRequired = []) {
	return { oneOf: [
		objectSchema({
			target: {
				...ref("SelectionTarget"),
				description: "Selection target: {kind:'selection', start:{kind:'text', blockId, offset}, end:{kind:'text', blockId, offset}}."
			},
			...payloadProperties
		}, ["target", ...payloadRequired]),
		objectSchema({
			ref: {
				type: "string",
				description: "Handle ref from superdoc_search result (pass handle.ref value directly). Preferred over building a target object."
			},
			...payloadProperties
		}, ["ref", ...payloadRequired]),
		objectSchema({ ...payloadProperties }, [...payloadRequired])
	] };
}
function imagesMutationSchemaSet(inputSchema) {
	return {
		input: inputSchema,
		output: objectSchema({
			success: { type: "boolean" },
			image: { type: "object" },
			failure: { type: "object" }
		}),
		success: objectSchema({
			success: { const: true },
			image: { type: "object" }
		}, ["success", "image"]),
		failure: objectSchema({
			success: { const: false },
			failure: objectSchema({
				code: { type: "string" },
				message: { type: "string" }
			}, ["code", "message"])
		}, ["success", "failure"])
	};
}
var nodeTypeValues = NODE_TYPES;
var blockNodeTypeValues = BLOCK_NODE_TYPES;
var deletableBlockNodeTypeValues = DELETABLE_BLOCK_NODE_TYPES;
var inlineNodeTypeValues = INLINE_NODE_TYPES;
objectSchema({
	start: { type: "integer" },
	end: { type: "integer" }
}, ["start", "end"]), objectSchema({
	blockId: { type: "string" },
	offset: { type: "integer" }
}, ["blockId", "offset"]), objectSchema({
	start: ref("Position"),
	end: ref("Position")
}, ["start", "end"]), objectSchema({
	kind: { const: "text" },
	blockId: { type: "string" },
	range: ref("Range")
}, [
	"kind",
	"blockId",
	"range"
]), objectSchema({
	blockId: { type: "string" },
	range: ref("Range")
}, ["blockId", "range"]), objectSchema({
	kind: { const: "text" },
	segments: {
		type: "array",
		items: ref("TextSegment"),
		minItems: 1
	},
	story: ref("StoryLocator")
}, ["kind", "segments"]), objectSchema({
	kind: { const: "block" },
	nodeType: { enum: [...SELECTION_EDGE_NODE_TYPES] },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "text" },
	blockId: { type: "string" },
	offset: {
		type: "integer",
		minimum: 0
	}
}, [
	"kind",
	"blockId",
	"offset"
]), objectSchema({
	kind: { const: "nodeEdge" },
	node: ref("SelectionEdgeNodeAddress"),
	edge: { enum: ["before", "after"] }
}, [
	"kind",
	"node",
	"edge"
]), objectSchema({
	kind: { const: "selection" },
	start: ref("SelectionPoint"),
	end: ref("SelectionPoint")
}, [
	"kind",
	"start",
	"end"
]), objectSchema({
	kind: { const: "trackedChange" },
	trackedChangeId: { type: "string" },
	story: ref("StoryLocator")
}, ["trackedChangeId"]), objectSchema({
	trackedChange: { const: true },
	trackedChangeType: { enum: [...trackChangeTypeValues] },
	trackedChangeDisplayType: { type: ["string", "null"] },
	trackedChangeStory: { oneOf: [ref("StoryLocator"), { type: "null" }] },
	trackedChangeAnchorKey: { type: ["string", "null"] },
	trackedChangeText: { type: ["string", "null"] },
	deletedText: { type: ["string", "null"] }
}), objectSchema({ target: ref("SelectionTarget") }, ["target"]), objectSchema({ ref: { type: "string" } }, ["ref"]), objectSchema({
	kind: { const: "block" },
	nodeType: { enum: [...blockNodeTypeValues] },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { enum: [...deletableBlockNodeTypeValues] },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "table" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "tableRow" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "tableCell" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { enum: ["table", "tableRow"] },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { enum: ["table", "tableCell"] },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "paragraph" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "heading" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "listItem" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	kind: { const: "section" },
	sectionId: { type: "string" }
}, ["kind", "sectionId"]), objectSchema({
	kind: { const: "inline" },
	nodeType: { enum: [...inlineNodeTypeValues] },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]), ref("BlockNodeAddress"), ref("InlineNodeAddress"), objectSchema({
	kind: { const: "entity" },
	entityType: { const: "comment" },
	entityId: { type: "string" }
}, [
	"kind",
	"entityType",
	"entityId"
]), objectSchema({
	kind: { const: "entity" },
	entityType: { const: "trackedChange" },
	entityId: { type: "string" },
	story: ref("StoryLocator")
}, [
	"kind",
	"entityType",
	"entityId"
]), ref("CommentAddress"), ref("TrackedChangeAddress"), objectSchema({
	ref: { type: "string" },
	refStability: { enum: ["stable", "ephemeral"] },
	targetKind: ref("TargetKind")
}, [
	"ref",
	"refStability",
	"targetKind"
]), objectSchema({
	limit: {
		type: "integer",
		minimum: 0
	},
	offset: {
		type: "integer",
		minimum: 0
	},
	returned: {
		type: "integer",
		minimum: 0
	}
}, [
	"limit",
	"offset",
	"returned"
]), objectSchema({
	success: { const: true },
	inserted: arraySchema(ref("EntityAddress")),
	updated: arraySchema(ref("EntityAddress")),
	removed: arraySchema(ref("EntityAddress"))
}, ["success"]), objectSchema({
	success: { const: true },
	id: { type: "string" },
	inserted: arraySchema(ref("EntityAddress")),
	updated: arraySchema(ref("EntityAddress")),
	removed: arraySchema(ref("EntityAddress"))
}, ["success", "id"]), objectSchema({
	code: { type: "string" },
	message: { type: "string" },
	details: {}
}, ["code", "message"]), objectSchema({
	from: { type: "integer" },
	to: { type: "integer" }
}, ["from", "to"]), objectSchema({
	requestedTarget: ref("TextAddress"),
	target: ref("TextAddress"),
	range: ref("TextMutationRange"),
	text: { type: "string" },
	selectionTarget: ref("SelectionTarget")
}, [
	"target",
	"range",
	"text"
]), objectSchema({
	success: { const: true },
	resolution: ref("TextMutationResolution"),
	inserted: arraySchema(ref("EntityAddress")),
	updated: arraySchema(ref("EntityAddress")),
	removed: arraySchema(ref("EntityAddress"))
}, ["success", "resolution"]), objectSchema({
	range: ref("Range"),
	text: { type: "string" },
	styleId: { type: "string" },
	styles: objectSchema({
		direct: objectSchema({
			bold: { enum: [...INLINE_DIRECTIVES] },
			italic: { enum: [...INLINE_DIRECTIVES] },
			underline: { enum: [...INLINE_DIRECTIVES] },
			strike: { enum: [...INLINE_DIRECTIVES] }
		}, [
			"bold",
			"italic",
			"underline",
			"strike"
		]),
		effective: objectSchema({
			bold: { type: "boolean" },
			italic: { type: "boolean" },
			underline: { type: "boolean" },
			strike: { type: "boolean" }
		}, [
			"bold",
			"italic",
			"underline",
			"strike"
		]),
		color: { type: "string" },
		highlight: { type: "string" },
		fontFamily: { type: "string" },
		fontSizePt: { type: "number" }
	}, ["direct", "effective"]),
	ref: { type: "string" }
}, [
	"range",
	"text",
	"styles",
	"ref"
]), objectSchema({
	blockId: { type: "string" },
	nodeType: { type: "string" },
	range: ref("Range"),
	text: { type: "string" },
	paragraphStyle: objectSchema({
		styleId: { type: "string" },
		isListItem: { type: "boolean" },
		listLevel: {
			type: "integer",
			minimum: 0
		}
	}),
	ref: { type: "string" },
	runs: arraySchema(ref("MatchRun"))
}, [
	"blockId",
	"nodeType",
	"range",
	"text",
	"ref",
	"runs"
]), objectSchema({
	kind: { const: "block" },
	nodeType: { const: "paragraph" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]), objectSchema({
	from: ref("BlockAddress"),
	to: ref("BlockAddress")
}, ["from", "to"]), ref("BlockAddress"), ref("BlockRange"), objectSchema({
	kind: { const: "story" },
	storyType: { const: "body" }
}, ["kind", "storyType"]), objectSchema({
	kind: { const: "story" },
	storyType: { const: "headerFooterSlot" },
	section: ref("SectionAddress"),
	headerFooterKind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] },
	resolution: { enum: ["effective", "explicit"] },
	onWrite: { enum: [
		"materializeIfInherited",
		"editResolvedPart",
		"error"
	] }
}, [
	"kind",
	"storyType",
	"section",
	"headerFooterKind",
	"variant"
]), objectSchema({
	kind: { const: "story" },
	storyType: { const: "headerFooterPart" },
	refId: { type: "string" }
}, [
	"kind",
	"storyType",
	"refId"
]), objectSchema({
	kind: { const: "story" },
	storyType: { const: "footnote" },
	noteId: { type: "string" }
}, [
	"kind",
	"storyType",
	"noteId"
]), objectSchema({
	kind: { const: "story" },
	storyType: { const: "endnote" },
	noteId: { type: "string" }
}, [
	"kind",
	"storyType",
	"noteId"
]);
var rangeSchema = ref("Range");
ref("Position");
ref("InlineAnchor");
ref("TargetKind");
var textAddressSchema = ref("TextAddress");
var textTargetSchema = ref("TextTarget");
var commentTrackedChangeTargetSchema = ref("CommentTrackedChangeTarget");
var blockNodeAddressSchema = ref("BlockNodeAddress");
var deletableBlockNodeAddressSchema = ref("DeletableBlockNodeAddress");
var tableAddressSchema = ref("TableAddress");
var tableRowAddressSchema = ref("TableRowAddress");
var tableCellAddressSchema = ref("TableCellAddress");
var tableOrCellAddressSchema = ref("TableOrCellAddress");
var paragraphAddressSchema = ref("ParagraphAddress");
var headingAddressSchema = ref("HeadingAddress");
var listItemAddressSchema = ref("ListItemAddress");
var paragraphTargetSchema = { oneOf: [
	paragraphAddressSchema,
	headingAddressSchema,
	listItemAddressSchema
] };
var sectionAddressSchema = ref("SectionAddress");
ref("InlineNodeAddress");
var nodeAddressSchema = ref("NodeAddress");
var commentAddressSchema = ref("CommentAddress");
var trackedChangeAddressSchema = ref("TrackedChangeAddress");
var entityAddressSchema = ref("EntityAddress");
var selectionTargetSchema = ref("SelectionTarget");
var commentTrackedChangeLinkSchema = ref("CommentTrackedChangeLink");
ref("TargetLocator");
var deleteBehaviorSchema = ref("DeleteBehavior");
var resolvedHandleSchema = ref("ResolvedHandle");
var pageInfoSchema = ref("PageInfo");
var receiptSuccessSchema = ref("ReceiptSuccess");
var commentsCreateSuccessSchema = ref("CommentsCreateSuccess");
var textMutationRangeSchema = ref("TextMutationRange");
var textMutationResolutionSchema = ref("TextMutationResolution");
var textMutationSuccessSchema = ref("TextMutationSuccess");
ref("MatchRun");
var matchBlockSchema = ref("MatchBlock");
var storyLocatorSchema = ref("StoryLocator");
function discoveryResultSchema(itemSchema, metaSchema) {
	const properties = {
		evaluatedRevision: { type: "string" },
		total: {
			type: "integer",
			minimum: 0
		},
		items: arraySchema(itemSchema),
		page: pageInfoSchema
	};
	const required = [
		"evaluatedRevision",
		"total",
		"items",
		"page"
	];
	if (metaSchema) {
		properties.meta = metaSchema;
		required.push("meta");
	}
	return objectSchema(properties, required);
}
function discoveryItemSchema(domainProperties, domainRequired = []) {
	return objectSchema({
		id: { type: "string" },
		handle: resolvedHandleSchema,
		...domainProperties
	}, [
		"id",
		"handle",
		...domainRequired
	]);
}
function possibleFailureCodes(operationId) {
	return [...COMMAND_CATALOG[operationId].possibleFailureCodes];
}
function preApplyThrowCodes(operationId) {
	return [...COMMAND_CATALOG[operationId].throws.preApply];
}
function receiptFailureSchemaFor(operationId) {
	const codes = possibleFailureCodes(operationId);
	if (codes.length === 0) throw new Error(`Operation "${operationId}" does not declare non-applied failure codes.`);
	return objectSchema({
		code: { enum: codes },
		message: { type: "string" },
		details: {}
	}, ["code", "message"]);
}
function preApplyFailureSchemaFor(operationId) {
	const codes = preApplyThrowCodes(operationId);
	if (codes.length === 0) throw new Error(`Operation "${operationId}" does not declare pre-apply throw codes.`);
	return objectSchema({
		code: { enum: codes },
		message: { type: "string" },
		details: {}
	}, ["code", "message"]);
}
function receiptFailureResultSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function preApplyFailureResultSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: preApplyFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function receiptResultSchemaFor(operationId) {
	return { oneOf: [receiptSuccessSchema, receiptFailureResultSchemaFor(operationId)] };
}
function commentsCreateResultSchemaFor(operationId) {
	return { oneOf: [commentsCreateSuccessSchema, receiptFailureResultSchemaFor(operationId)] };
}
function textMutationFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId),
		resolution: textMutationResolutionSchema
	}, [
		"success",
		"failure",
		"resolution"
	]);
}
function textMutationResultSchemaFor(operationId) {
	return { oneOf: [textMutationSuccessSchema, textMutationFailureSchemaFor(operationId)] };
}
var trackChangeRefSchema = trackedChangeAddressSchema;
var createParagraphSuccessSchema = objectSchema({
	success: { const: true },
	paragraph: paragraphAddressSchema,
	insertionPoint: textAddressSchema,
	trackedChangeRefs: arraySchema(trackChangeRefSchema),
	ref: {
		type: "string",
		description: "Ref handle for the created block. Pass directly to superdoc_format or superdoc_edit ref param without searching."
	}
}, [
	"success",
	"paragraph",
	"insertionPoint"
]);
function createParagraphFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function createParagraphResultSchemaFor(operationId) {
	return { oneOf: [createParagraphSuccessSchema, createParagraphFailureSchemaFor(operationId)] };
}
var createHeadingSuccessSchema = objectSchema({
	success: { const: true },
	heading: headingAddressSchema,
	insertionPoint: textAddressSchema,
	trackedChangeRefs: arraySchema(trackChangeRefSchema),
	ref: {
		type: "string",
		description: "Ref handle for the created block. Pass directly to superdoc_format or superdoc_edit ref param without searching."
	}
}, [
	"success",
	"heading",
	"insertionPoint"
]);
function createHeadingFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function createHeadingResultSchemaFor(operationId) {
	return { oneOf: [createHeadingSuccessSchema, createHeadingFailureSchemaFor(operationId)] };
}
var headingLevelSchema = {
	type: "integer",
	minimum: 1,
	maximum: 6
};
var listsInsertSuccessSchema = objectSchema({
	success: { const: true },
	item: listItemAddressSchema,
	insertionPoint: textAddressSchema,
	trackedChangeRefs: arraySchema(trackChangeRefSchema)
}, [
	"success",
	"item",
	"insertionPoint"
]);
var listsMutateItemSuccessSchema = objectSchema({
	success: { const: true },
	item: listItemAddressSchema
}, ["success", "item"]);
objectSchema({
	success: { const: true },
	paragraph: paragraphAddressSchema
}, ["success", "paragraph"]);
function listsFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function listsInsertResultSchemaFor(operationId) {
	return { oneOf: [listsInsertSuccessSchema, listsFailureSchemaFor(operationId)] };
}
function listsMutateItemResultSchemaFor(operationId) {
	return { oneOf: [listsMutateItemSuccessSchema, listsFailureSchemaFor(operationId)] };
}
objectSchema({
	label: { type: "string" },
	text: { type: "string" }
});
[...nodeTypeValues], arraySchema({ type: "object" }), arraySchema({ type: "object" });
objectSchema({
	address: nodeAddressSchema,
	snippet: { type: "string" },
	highlightRange: rangeSchema,
	textRanges: arraySchema(textAddressSchema),
	target: selectionTargetSchema
}, [
	"address",
	"snippet",
	"highlightRange"
]);
objectSchema({
	message: { type: "string" },
	address: nodeAddressSchema,
	hint: { type: "string" }
}, ["message"]);
var textSelectorSchema = objectSchema({
	type: {
		const: "text",
		description: "Must be 'text' for text pattern search."
	},
	pattern: {
		type: "string",
		description: "Text or regex pattern to match."
	},
	mode: {
		enum: ["contains", "regex"],
		description: "Match mode: 'contains' (substring) or 'regex'."
	},
	caseSensitive: {
		type: "boolean",
		description: "Case-sensitive matching. Default: false."
	}
}, ["type", "pattern"]);
var nodeSelectorSchema = objectSchema({
	type: {
		const: "node",
		description: "Must be 'node' for node type search."
	},
	nodeType: {
		enum: [...nodeTypeValues],
		description: "Block type to match (paragraph, heading, table, listItem, etc.)."
	},
	kind: {
		enum: ["block", "inline"],
		description: "Filter: 'block' or 'inline'."
	}
}, ["type"]);
objectSchema({ nodeType: { enum: [...nodeTypeValues] } }, ["nodeType"]);
objectSchema({
	in: storyLocatorSchema,
	select: { oneOf: [objectSchema({
		type: { const: "text" },
		pattern: { type: "string" },
		mode: { enum: ["contains", "regex"] },
		caseSensitive: { type: "boolean" }
	}, ["type", "pattern"]), objectSchema({
		type: { const: "node" },
		kind: { enum: ["block", "inline"] },
		nodeType: { type: "string" }
	}, ["type"])] },
	within: blockNodeAddressSchema,
	limit: { type: "integer" },
	offset: { type: "integer" },
	options: objectSchema({
		includeResolved: { type: "boolean" },
		includeProvenance: { type: "boolean" },
		includeContext: { type: "boolean" }
	})
}, ["select"]);
objectSchema({
	total: {
		type: "integer",
		minimum: 0
	},
	limit: {
		type: "integer",
		minimum: 0
	},
	offset: {
		type: "integer",
		minimum: 0
	},
	items: arraySchema(objectSchema({
		node: { type: "object" },
		address: nodeAddressSchema,
		context: { type: "object" }
	}, ["node", "address"]))
}, [
	"total",
	"limit",
	"offset",
	"items"
]);
var sdMutationResolutionSchema = objectSchema({
	target: { oneOf: [textAddressSchema, blockNodeAddressSchema] },
	range: textMutationRangeSchema,
	selectionTarget: selectionTargetSchema
}, ["target", "range"]);
var sdMutationSuccessSchema = objectSchema({
	success: { const: true },
	resolution: sdMutationResolutionSchema,
	evaluatedRevision: objectSchema({
		before: { type: "string" },
		after: { type: "string" }
	}, ["before", "after"])
}, ["success"]);
function sdMutationFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId),
		resolution: sdMutationResolutionSchema,
		evaluatedRevision: objectSchema({
			before: { type: "string" },
			after: { type: "string" }
		}, ["before", "after"])
	}, ["success", "failure"]);
}
function sdMutationResultSchemaFor(operationId) {
	return { oneOf: [sdMutationSuccessSchema, sdMutationFailureSchemaFor(operationId)] };
}
var documentInfoCountsSchema = objectSchema({
	words: { type: "integer" },
	characters: { type: "integer" },
	paragraphs: { type: "integer" },
	headings: { type: "integer" },
	tables: { type: "integer" },
	images: { type: "integer" },
	comments: { type: "integer" },
	trackedChanges: { type: "integer" },
	sdtFields: { type: "integer" },
	lists: { type: "integer" },
	pages: { type: "integer" }
}, [
	"words",
	"characters",
	"paragraphs",
	"headings",
	"tables",
	"images",
	"comments",
	"trackedChanges",
	"sdtFields",
	"lists"
]);
var documentInfoOutlineItemSchema = objectSchema({
	level: { type: "integer" },
	text: { type: "string" },
	nodeId: { type: "string" }
}, [
	"level",
	"text",
	"nodeId"
]);
var documentInfoCapabilitiesSchema = objectSchema({
	canFind: { type: "boolean" },
	canGetNode: { type: "boolean" },
	canComment: { type: "boolean" },
	canReplace: { type: "boolean" }
}, [
	"canFind",
	"canGetNode",
	"canComment",
	"canReplace"
]);
var documentStylesSchema = objectSchema({ paragraphStyles: {
	...arraySchema(objectSchema({
		styleId: {
			type: "string",
			description: "Style identifier (e.g. 'Normal', 'Heading1', 'BodyText')."
		},
		count: {
			type: "integer",
			description: "Number of paragraphs using this style."
		},
		fontFamily: {
			type: "string",
			description: "Font family used by text in this style."
		},
		fontSize: {
			type: "number",
			description: "Font size in half-points used by text in this style."
		}
	}, ["styleId", "count"])),
	description: "Paragraph styles in use, sorted by frequency (most common first)."
} }, ["paragraphStyles"]);
var documentDefaultsSchema = objectSchema({
	fontFamily: {
		type: "string",
		description: "Most common body text font family."
	},
	fontSize: {
		type: "number",
		description: "Most common body text font size in half-points."
	},
	styleId: {
		type: "string",
		description: "Most common body paragraph style ID."
	}
}, []);
objectSchema({
	counts: documentInfoCountsSchema,
	outline: arraySchema(documentInfoOutlineItemSchema),
	capabilities: documentInfoCapabilitiesSchema,
	revision: { type: "string" },
	styles: {
		...documentStylesSchema,
		description: "Styles currently in use in the document."
	},
	defaults: {
		...documentDefaultsSchema,
		description: "Document's default body text formatting. Use these values when creating new content to match existing style."
	}
}, [
	"counts",
	"outline",
	"capabilities",
	"revision"
]);
var listKindSchema = { enum: ["ordered", "bullet"] };
var listInsertPositionSchema = { enum: ["before", "after"] };
objectSchema({
	address: listItemAddressSchema,
	listId: { type: "string" },
	marker: { type: "string" },
	ordinal: { type: "integer" },
	path: arraySchema({ type: "integer" }),
	level: { type: "integer" },
	kind: listKindSchema,
	text: { type: "string" }
}, ["address", "listId"]);
discoveryResultSchema(discoveryItemSchema({
	address: listItemAddressSchema,
	listId: { type: "string" },
	marker: { type: "string" },
	ordinal: { type: "integer" },
	path: arraySchema({ type: "integer" }),
	level: { type: "integer" },
	kind: listKindSchema,
	text: { type: "string" }
}, ["address", "listId"]));
var sectionBreakTypeSchema = { enum: [
	"continuous",
	"nextPage",
	"evenPage",
	"oddPage"
] };
var sectionOrientationSchema = { enum: ["portrait", "landscape"] };
var sectionVerticalAlignSchema = { enum: [
	"top",
	"center",
	"bottom",
	"both"
] };
var sectionDirectionSchema = { enum: ["ltr", "rtl"] };
var sectionHeaderFooterKindSchema = { enum: ["header", "footer"] };
var sectionHeaderFooterVariantSchema = { enum: [
	"default",
	"first",
	"even"
] };
var sectionLineNumberRestartSchema = { enum: [
	"continuous",
	"newPage",
	"newSection"
] };
var sectionPageNumberFormatSchema = { enum: [
	"decimal",
	"lowerLetter",
	"upperLetter",
	"lowerRoman",
	"upperRoman",
	"numberInDash"
] };
var sectionRangeDomainSchema = objectSchema({
	startParagraphIndex: {
		type: "integer",
		minimum: 0
	},
	endParagraphIndex: {
		type: "integer",
		minimum: 0
	}
}, ["startParagraphIndex", "endParagraphIndex"]);
var sectionPageMarginsSchema = objectSchema({
	top: {
		type: "number",
		minimum: 0
	},
	right: {
		type: "number",
		minimum: 0
	},
	bottom: {
		type: "number",
		minimum: 0
	},
	left: {
		type: "number",
		minimum: 0
	},
	gutter: {
		type: "number",
		minimum: 0
	}
});
var sectionHeaderFooterMarginsSchema = objectSchema({
	header: {
		type: "number",
		minimum: 0
	},
	footer: {
		type: "number",
		minimum: 0
	}
});
var sectionPageSetupSchema = objectSchema({
	width: {
		type: "number",
		minimum: 0
	},
	height: {
		type: "number",
		minimum: 0
	},
	orientation: sectionOrientationSchema,
	paperSize: { type: "string" }
});
var sectionColumnsSchema = objectSchema({
	count: {
		type: "integer",
		minimum: 1
	},
	gap: {
		type: "number",
		minimum: 0
	},
	equalWidth: { type: "boolean" }
});
var sectionLineNumberingSchema = objectSchema({
	enabled: { type: "boolean" },
	countBy: {
		type: "integer",
		minimum: 1
	},
	start: {
		type: "integer",
		minimum: 1
	},
	distance: {
		type: "number",
		minimum: 0
	},
	restart: sectionLineNumberRestartSchema
}, ["enabled"]);
var sectionPageNumberingSchema = objectSchema({
	start: {
		type: "integer",
		minimum: 1
	},
	format: sectionPageNumberFormatSchema,
	chapterStyle: {
		type: "integer",
		minimum: 1
	},
	chapterSeparator: {
		type: "string",
		enum: [
			"hyphen",
			"period",
			"colon",
			"emDash",
			"enDash"
		]
	}
});
var sectionHeaderFooterRefsSchema = objectSchema({
	default: { type: "string" },
	first: { type: "string" },
	even: { type: "string" }
});
var sectionBorderSpecSchema = objectSchema({
	style: { type: "string" },
	size: {
		type: "number",
		minimum: 0
	},
	space: {
		type: "number",
		minimum: 0
	},
	color: { type: "string" },
	shadow: { type: "boolean" },
	frame: { type: "boolean" }
});
sectionBorderSpecSchema.oneOf = [
	{ required: ["style"] },
	{ required: ["size"] },
	{ required: ["space"] },
	{ required: ["color"] },
	{ required: ["shadow"] },
	{ required: ["frame"] }
];
var sectionPageBordersSchema = objectSchema({
	display: { enum: [
		"allPages",
		"firstPage",
		"notFirstPage"
	] },
	offsetFrom: { enum: ["page", "text"] },
	zOrder: { enum: ["front", "back"] },
	top: sectionBorderSpecSchema,
	right: sectionBorderSpecSchema,
	bottom: sectionBorderSpecSchema,
	left: sectionBorderSpecSchema
});
sectionPageBordersSchema.oneOf = [
	{ required: ["display"] },
	{ required: ["offsetFrom"] },
	{ required: ["zOrder"] },
	{ required: ["top"] },
	{ required: ["right"] },
	{ required: ["bottom"] },
	{ required: ["left"] }
];
objectSchema({
	address: sectionAddressSchema,
	index: {
		type: "integer",
		minimum: 0
	},
	range: sectionRangeDomainSchema,
	breakType: sectionBreakTypeSchema,
	pageSetup: sectionPageSetupSchema,
	margins: sectionPageMarginsSchema,
	headerFooterMargins: sectionHeaderFooterMarginsSchema,
	columns: sectionColumnsSchema,
	lineNumbering: sectionLineNumberingSchema,
	pageNumbering: sectionPageNumberingSchema,
	titlePage: { type: "boolean" },
	oddEvenHeadersFooters: { type: "boolean" },
	verticalAlign: sectionVerticalAlignSchema,
	sectionDirection: sectionDirectionSchema,
	headerRefs: sectionHeaderFooterRefsSchema,
	footerRefs: sectionHeaderFooterRefsSchema,
	pageBorders: sectionPageBordersSchema
}, [
	"address",
	"index",
	"range"
]);
discoveryResultSchema(objectSchema({
	id: { type: "string" },
	handle: objectSchema({
		ref: { type: "string" },
		refStability: { const: "ephemeral" },
		targetKind: { const: "section" }
	}, [
		"ref",
		"refStability",
		"targetKind"
	]),
	address: sectionAddressSchema,
	index: {
		type: "integer",
		minimum: 0
	},
	range: sectionRangeDomainSchema,
	breakType: sectionBreakTypeSchema,
	pageSetup: sectionPageSetupSchema,
	margins: sectionPageMarginsSchema,
	headerFooterMargins: sectionHeaderFooterMarginsSchema,
	columns: sectionColumnsSchema,
	lineNumbering: sectionLineNumberingSchema,
	pageNumbering: sectionPageNumberingSchema,
	titlePage: { type: "boolean" },
	oddEvenHeadersFooters: { type: "boolean" },
	verticalAlign: sectionVerticalAlignSchema,
	sectionDirection: sectionDirectionSchema,
	headerRefs: sectionHeaderFooterRefsSchema,
	footerRefs: sectionHeaderFooterRefsSchema,
	pageBorders: sectionPageBordersSchema
}, [
	"id",
	"handle",
	"address",
	"index",
	"range"
]));
var sectionMutationSuccessSchema = objectSchema({
	success: { const: true },
	section: sectionAddressSchema
}, ["success", "section"]);
function sectionMutationFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function sectionMutationResultSchemaFor(operationId) {
	return { oneOf: [sectionMutationSuccessSchema, sectionMutationFailureSchemaFor(operationId)] };
}
var documentMutationSuccessSchema = objectSchema({ success: { const: true } }, ["success"]);
function documentMutationResultSchemaFor(operationId) {
	return { oneOf: [documentMutationSuccessSchema, sectionMutationFailureSchemaFor(operationId)] };
}
var paragraphMutationTargetSchema = objectSchema({ target: paragraphTargetSchema }, ["target"]);
var paragraphMutationSuccessSchema = objectSchema({
	success: { const: true },
	target: paragraphTargetSchema,
	resolution: paragraphMutationTargetSchema
}, [
	"success",
	"target",
	"resolution"
]);
function paragraphMutationFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId),
		resolution: paragraphMutationTargetSchema
	}, ["success", "failure"]);
}
function paragraphMutationResultSchemaFor(operationId) {
	return { oneOf: [paragraphMutationSuccessSchema, paragraphMutationFailureSchemaFor(operationId)] };
}
var createSectionBreakSuccessSchema = objectSchema({
	success: { const: true },
	section: sectionAddressSchema,
	breakParagraph: blockNodeAddressSchema
}, ["success", "section"]);
function createSectionBreakFailureSchemaFor(operationId) {
	return objectSchema({
		success: { const: false },
		failure: receiptFailureSchemaFor(operationId)
	}, ["success", "failure"]);
}
function createSectionBreakResultSchemaFor(operationId) {
	return { oneOf: [createSectionBreakSuccessSchema, createSectionBreakFailureSchemaFor(operationId)] };
}
objectSchema({
	address: commentAddressSchema,
	commentId: { type: "string" },
	importedId: { type: "string" },
	parentCommentId: { type: "string" },
	text: { type: "string" },
	isInternal: { type: "boolean" },
	status: { enum: ["open", "resolved"] },
	target: textTargetSchema,
	anchoredText: { type: "string" },
	createdTime: { type: "number" },
	creatorName: { type: "string" },
	creatorEmail: { type: "string" },
	trackedChange: { type: "boolean" },
	trackedChangeType: { enum: [...trackChangeTypeValues] },
	trackedChangeDisplayType: { type: ["string", "null"] },
	trackedChangeStory: { oneOf: [storyLocatorSchema, { type: "null" }] },
	trackedChangeAnchorKey: { type: ["string", "null"] },
	trackedChangeText: { type: ["string", "null"] },
	deletedText: { type: ["string", "null"] },
	trackedChangeLink: { oneOf: [commentTrackedChangeLinkSchema, { type: "null" }] }
}, [
	"address",
	"commentId",
	"status"
]);
discoveryResultSchema(discoveryItemSchema({
	address: commentAddressSchema,
	importedId: { type: "string" },
	parentCommentId: { type: "string" },
	text: { type: "string" },
	isInternal: { type: "boolean" },
	status: { enum: ["open", "resolved"] },
	target: textTargetSchema,
	anchoredText: { type: "string" },
	createdTime: { type: "number" },
	creatorName: { type: "string" },
	creatorEmail: { type: "string" },
	trackedChange: { type: "boolean" },
	trackedChangeType: { enum: [...trackChangeTypeValues] },
	trackedChangeDisplayType: { type: ["string", "null"] },
	trackedChangeStory: { oneOf: [storyLocatorSchema, { type: "null" }] },
	trackedChangeAnchorKey: { type: ["string", "null"] },
	trackedChangeText: { type: ["string", "null"] },
	deletedText: { type: ["string", "null"] },
	trackedChangeLink: { oneOf: [commentTrackedChangeLinkSchema, { type: "null" }] }
}, ["address", "status"]));
var trackChangeWordRevisionIdsSchema = {
	...objectSchema({
		insert: {
			type: "string",
			description: "Raw imported Word OOXML revision ID (`w:id`) from a `<w:ins>` element when this logical change includes an insertion."
		},
		delete: {
			type: "string",
			description: "Raw imported Word OOXML revision ID (`w:id`) from a `<w:del>` element when this logical change includes a deletion."
		},
		format: {
			type: "string",
			description: "Raw imported Word OOXML revision ID (`w:id`) from a `<w:rPrChange>` element when this logical change includes a formatting revision."
		}
	}),
	description: "Raw imported Word OOXML revision IDs (`w:id`) from the source document when available. This is provenance metadata, not the canonical SuperDoc tracked-change ID. Replacements may include both `insert` and `delete` IDs."
};
objectSchema({
	address: trackedChangeAddressSchema,
	id: { type: "string" },
	type: { enum: [...trackChangeTypeValues] },
	grouping: { enum: [
		"standalone",
		"replacement-pair",
		"unknown"
	] },
	pairedWithChangeId: { type: ["string", "null"] },
	wordRevisionIds: trackChangeWordRevisionIdsSchema,
	author: { type: "string" },
	authorEmail: { type: "string" },
	authorImage: { type: "string" },
	date: { type: "string" },
	excerpt: { type: "string" },
	insertedText: { type: "string" },
	deletedText: { type: "string" }
}, [
	"address",
	"id",
	"type"
]);
discoveryResultSchema(discoveryItemSchema({
	address: trackedChangeAddressSchema,
	type: { enum: [...trackChangeTypeValues] },
	grouping: { enum: [
		"standalone",
		"replacement-pair",
		"unknown"
	] },
	pairedWithChangeId: { type: ["string", "null"] },
	wordRevisionIds: trackChangeWordRevisionIdsSchema,
	author: { type: "string" },
	authorEmail: { type: "string" },
	authorImage: { type: "string" },
	date: { type: "string" },
	excerpt: { type: "string" },
	insertedText: { type: "string" },
	deletedText: { type: "string" }
}, ["address", "type"]));
var capabilityReasonsSchema = arraySchema({ enum: [
	"COMMAND_UNAVAILABLE",
	"HELPER_UNAVAILABLE",
	"OPERATION_UNAVAILABLE",
	"TRACKED_MODE_UNAVAILABLE",
	"DRY_RUN_UNAVAILABLE",
	"NAMESPACE_UNAVAILABLE",
	"STYLES_PART_MISSING",
	"COLLABORATION_ACTIVE"
] });
var capabilityFlagSchema = objectSchema({
	enabled: { type: "boolean" },
	reasons: capabilityReasonsSchema
}, ["enabled"]);
var operationRuntimeCapabilitySchema = objectSchema({
	available: { type: "boolean" },
	tracked: { type: "boolean" },
	dryRun: { type: "boolean" },
	reasons: capabilityReasonsSchema
}, [
	"available",
	"tracked",
	"dryRun"
]);
var operationCapabilitiesSchema = objectSchema(Object.fromEntries(OPERATION_IDS.map((operationId) => [operationId, operationRuntimeCapabilitySchema])), OPERATION_IDS);
var inlinePropertyCapabilitySchema = objectSchema({
	available: { type: "boolean" },
	tracked: { type: "boolean" },
	type: { enum: [
		"boolean",
		"string",
		"number",
		"object",
		"array"
	] },
	storage: { enum: ["mark", "runAttribute"] }
}, [
	"available",
	"tracked",
	"type",
	"storage"
]);
var formatCapabilitiesSchema = objectSchema({ supportedInlineProperties: objectSchema(Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => [entry.key, inlinePropertyCapabilitySchema])), INLINE_PROPERTY_REGISTRY.map((entry) => entry.key)) }, ["supportedInlineProperties"]);
var planEngineCapabilitiesSchema = objectSchema({
	supportedStepOps: arraySchema({ type: "string" }),
	supportedNonUniformStrategies: arraySchema({ type: "string" }),
	supportedSetMarks: arraySchema({ type: "string" }),
	regex: objectSchema({ maxPatternLength: { type: "integer" } }, ["maxPatternLength"])
}, [
	"supportedStepOps",
	"supportedNonUniformStrategies",
	"supportedSetMarks",
	"regex"
]);
objectSchema({
	global: objectSchema({
		trackChanges: capabilityFlagSchema,
		comments: capabilityFlagSchema,
		lists: capabilityFlagSchema,
		dryRun: capabilityFlagSchema,
		history: capabilityFlagSchema
	}, [
		"trackChanges",
		"comments",
		"lists",
		"dryRun",
		"history"
	]),
	format: formatCapabilitiesSchema,
	operations: operationCapabilitiesSchema,
	planEngine: planEngineCapabilitiesSchema
}, [
	"global",
	"format",
	"operations",
	"planEngine"
]);
objectSchema({});
var tableBorderColorPattern = TABLE_COLOR_PATTERN_SOURCE;
var nullableTableBorderSpecSchema = { oneOf: [objectSchema({
	lineStyle: { type: "string" },
	lineWeightPt: {
		type: "number",
		exclusiveMinimum: 0
	},
	color: {
		type: "string",
		pattern: tableBorderColorPattern
	}
}, [
	"lineStyle",
	"lineWeightPt",
	"color"
]), { type: "null" }] };
var sdFragmentSchema = { oneOf: [{ type: "object" }, {
	type: "array",
	items: { type: "object" }
}] };
var placementSchema = { enum: [
	"before",
	"after",
	"insideStart",
	"insideEnd"
] };
var nestingPolicySchema = {
	...objectSchema({ tables: { enum: ["forbid", "allow"] } }),
	description: "Controls nesting behavior. tables: 'allow' permits inserting tables inside other tables."
};
optionalTargetLocatorWithPayload({
	in: storyLocatorSchema,
	value: {
		type: "string",
		description: "Text content to insert."
	},
	type: {
		type: "string",
		enum: [
			"text",
			"markdown",
			"html"
		],
		description: "Content format: 'text' (default), 'markdown', or 'html'."
	}
}, ["value"]), objectSchema({
	in: storyLocatorSchema,
	target: {
		...blockNodeAddressSchema,
		description: "Block address for structural insertion: {kind:'block', nodeType:'...', nodeId:'...'}."
	},
	content: {
		...sdFragmentSchema,
		description: "Document fragment to insert (structured content)."
	},
	placement: {
		...placementSchema,
		description: "Where to place content relative to target: 'before', 'after', 'insideStart', or 'insideEnd'."
	},
	nestingPolicy: nestingPolicySchema
}, ["content"]);
({ ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" }
}) });
({ ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" }
}) }), objectSchema({
	target: tableAddressSchema,
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	columnIndex: {
		type: "integer",
		minimum: 0
	}
}, [
	"target",
	"rowIndex",
	"columnIndex"
]), objectSchema({
	nodeId: { type: "string" },
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	columnIndex: {
		type: "integer",
		minimum: 0
	}
}, [
	"nodeId",
	"rowIndex",
	"columnIndex"
]);
({ ...objectSchema({
	target: tableOrCellAddressSchema,
	nodeId: { type: "string" }
}) });
function rowOperationInputSchema(extraProperties, required = []) {
	return { oneOf: [
		objectSchema({
			target: tableRowAddressSchema,
			...extraProperties
		}, ["target", ...required]),
		objectSchema({
			target: tableAddressSchema,
			rowIndex: {
				type: "integer",
				minimum: 0
			},
			...extraProperties
		}, [
			"target",
			"rowIndex",
			...required
		]),
		objectSchema({
			nodeId: { type: "string" },
			rowIndex: {
				type: "integer",
				minimum: 0
			},
			...extraProperties
		}, [
			"nodeId",
			"rowIndex",
			...required
		])
	] };
}
({ ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	start: objectSchema({
		rowIndex: {
			type: "integer",
			minimum: 0
		},
		columnIndex: {
			type: "integer",
			minimum: 0
		}
	}, ["rowIndex", "columnIndex"]),
	end: objectSchema({
		rowIndex: {
			type: "integer",
			minimum: 0
		},
		columnIndex: {
			type: "integer",
			minimum: 0
		}
	}, ["rowIndex", "columnIndex"])
}, ["start", "end"]) });
var tableCreateLocationSchema = { oneOf: [
	objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
	objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
	objectSchema({
		kind: { const: "before" },
		target: blockNodeAddressSchema
	}, ["kind", "target"]),
	objectSchema({
		kind: { const: "after" },
		target: blockNodeAddressSchema
	}, ["kind", "target"]),
	objectSchema({
		kind: { const: "before" },
		nodeId: { type: "string" }
	}, ["kind", "nodeId"]),
	objectSchema({
		kind: { const: "after" },
		nodeId: { type: "string" }
	}, ["kind", "nodeId"])
] };
objectSchema({
	success: { const: true },
	table: tableAddressSchema,
	trackedChangeRefs: arraySchema(entityAddressSchema)
}, ["success"]);
objectSchema({
	success: { const: true },
	table: tableAddressSchema,
	trackedChangeRefs: arraySchema(entityAddressSchema)
}, ["success", "table"]);
objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: [...[
			"NO_OP",
			"INVALID_TARGET",
			"TARGET_NOT_FOUND",
			"CAPABILITY_UNAVAILABLE"
		]] },
		message: { type: "string" },
		details: {}
	}, ["code", "message"])
}, ["success", "failure"]);
objectSchema({
	noop: { type: "boolean" },
	revision: objectSchema({
		before: { type: "string" },
		after: { type: "string" }
	}, ["before", "after"])
}, ["noop", "revision"]);
objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: ["CAPABILITY_UNAVAILABLE"] },
		message: { type: "string" },
		details: {}
	}, ["code", "message"])
}, ["success", "failure"]);
function supportsImplicitTrueValue(operationId) {
	const key = operationId.slice(7);
	const entry = INLINE_PROPERTY_REGISTRY.find((candidate) => candidate.key === key);
	if (!entry) return false;
	return entry.type === "boolean" || key === "underline";
}
var formatInlineAliasOperationSchemas = Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => {
	const operationId = `format.${entry.key}`;
	const requiredFields = supportsImplicitTrueValue(operationId) ? [] : ["value"];
	return [operationId, {
		input: { ...targetLocatorWithPayload({ value: entry.schema }, requiredFields) },
		output: textMutationResultSchemaFor(operationId),
		success: textMutationSuccessSchema,
		failure: textMutationFailureSchemaFor(operationId)
	}];
}));
function tocAddressSchema() {
	return objectSchema({
		kind: { const: "block" },
		nodeType: { const: "tableOfContents" },
		nodeId: { type: "string" }
	}, [
		"kind",
		"nodeType",
		"nodeId"
	]);
}
var tocMutationFailureSchema = objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: [...[
			"NO_OP",
			"INVALID_TARGET",
			"TARGET_NOT_FOUND",
			"CAPABILITY_UNAVAILABLE",
			"INVALID_INSERTION_CONTEXT",
			"PAGE_NUMBERS_NOT_MATERIALIZED"
		]] },
		message: { type: "string" },
		details: {}
	}, ["code", "message"])
}, ["success", "failure"]);
var tocMutationSuccessSchema = objectSchema({
	success: { const: true },
	toc: tocAddressSchema()
}, ["success", "toc"]);
function tocMutationResultSchema() {
	return { oneOf: [tocMutationSuccessSchema, tocMutationFailureSchema] };
}
function tocEntryAddressSchema() {
	return objectSchema({
		kind: { const: "inline" },
		nodeType: { const: "tableOfContentsEntry" },
		nodeId: { type: "string" }
	}, [
		"kind",
		"nodeType",
		"nodeId"
	]);
}
function tocEntryInsertionTargetSchema() {
	return objectSchema({
		kind: { const: "inline-insert" },
		anchor: objectSchema({
			nodeType: { const: "paragraph" },
			nodeId: { type: "string" }
		}, ["nodeType", "nodeId"]),
		position: { enum: ["start", "end"] }
	}, ["kind", "anchor"]);
}
var tocEntryMutationFailureSchema = objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: [...[
			"NO_OP",
			"INVALID_TARGET",
			"TARGET_NOT_FOUND",
			"CAPABILITY_UNAVAILABLE",
			"INVALID_INSERTION_CONTEXT",
			"INVALID_INPUT"
		]] },
		message: { type: "string" },
		details: {}
	}, ["code", "message"])
}, ["success", "failure"]);
var tocEntryMutationSuccessSchema = objectSchema({
	success: { const: true },
	entry: tocEntryAddressSchema()
}, ["success", "entry"]);
function tocEntryMutationResultSchema() {
	return { oneOf: [tocEntryMutationSuccessSchema, tocEntryMutationFailureSchema] };
}
var hyperlinkTargetSchema = objectSchema({
	kind: { const: "inline" },
	nodeType: { const: "hyperlink" },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]);
var hyperlinkReadPropertiesSchema = objectSchema({
	href: { type: "string" },
	anchor: { type: "string" },
	docLocation: { type: "string" },
	tooltip: { type: "string" },
	target: { type: "string" },
	rel: { type: "string" }
});
var hyperlinkSpecSchema = objectSchema({
	destination: objectSchema({
		href: { type: "string" },
		anchor: { type: "string" },
		docLocation: { type: "string" }
	}),
	tooltip: { type: "string" },
	target: { type: "string" },
	rel: { type: "string" }
}, ["destination"]);
var hyperlinkPatchSchema = objectSchema({
	href: { oneOf: [{ type: "string" }, { type: "null" }] },
	anchor: { oneOf: [{ type: "string" }, { type: "null" }] },
	docLocation: { oneOf: [{ type: "string" }, { type: "null" }] },
	tooltip: { oneOf: [{ type: "string" }, { type: "null" }] },
	target: { oneOf: [{ type: "string" }, { type: "null" }] },
	rel: { oneOf: [{ type: "string" }, { type: "null" }] }
});
var hyperlinkDomainSchema = objectSchema({
	address: hyperlinkTargetSchema,
	properties: hyperlinkReadPropertiesSchema,
	text: { type: "string" }
}, ["address", "properties"]);
var hyperlinkMutationSuccessSchema = objectSchema({
	success: { const: true },
	hyperlink: hyperlinkTargetSchema
}, ["success", "hyperlink"]);
var hyperlinkMutationFailureSchema = objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: [...[
			"NO_OP",
			"INVALID_TARGET",
			"TARGET_NOT_FOUND",
			"CAPABILITY_UNAVAILABLE"
		]] },
		message: { type: "string" },
		details: { type: "object" }
	}, ["code", "message"])
}, ["success", "failure"]);
function hyperlinkMutationResultSchema() {
	return { oneOf: [hyperlinkMutationSuccessSchema, hyperlinkMutationFailureSchema] };
}
objectSchema({
	address: hyperlinkTargetSchema,
	properties: hyperlinkReadPropertiesSchema,
	text: { type: "string" }
}, ["address", "properties"]);
var contentControlTargetSchema = objectSchema({
	kind: { enum: ["block", "inline"] },
	nodeType: { const: "sdt" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]);
var contentControlMutationSuccessSchema = objectSchema({
	success: { const: true },
	contentControl: contentControlTargetSchema,
	updatedRef: contentControlTargetSchema
}, ["success", "contentControl"]);
var contentControlMutationFailureSchema = objectSchema({
	success: { const: false },
	failure: { $ref: "#/$defs/ReceiptFailure" }
}, ["success", "failure"]);
function ccMutationResultSchema() {
	return { oneOf: [contentControlMutationSuccessSchema, contentControlMutationFailureSchema] };
}
var ccListResultSchema = objectSchema({
	items: {
		type: "array",
		items: { type: "object" }
	},
	total: { type: "integer" }
}, ["items", "total"]);
var ccInfoSchema = {
	type: "object",
	description: "ContentControlInfo"
};
function ccTargetInput() {
	return objectSchema({ target: contentControlTargetSchema }, ["target"]);
}
function buildContentControlSchemas() {
	const targetOnlyMutation = {
		input: ccTargetInput(),
		output: ccMutationResultSchema(),
		success: contentControlMutationSuccessSchema,
		failure: contentControlMutationFailureSchema
	};
	const targetOnlyRead = {
		input: ccTargetInput(),
		output: ccInfoSchema
	};
	const ccContentMutation = {
		input: objectSchema({
			target: contentControlTargetSchema,
			content: { type: "string" },
			format: { enum: ["text", "html"] }
		}, ["target", "content"]),
		output: ccMutationResultSchema(),
		success: contentControlMutationSuccessSchema,
		failure: contentControlMutationFailureSchema
	};
	return {
		"create.contentControl": {
			input: objectSchema({
				kind: { enum: ["block", "inline"] },
				controlType: { type: "string" },
				target: contentControlTargetSchema,
				at: selectionTargetSchema,
				tag: { type: "string" },
				alias: { type: "string" },
				lockMode: { enum: [
					"unlocked",
					"sdtLocked",
					"contentLocked",
					"sdtContentLocked"
				] },
				content: { type: "string" }
			}, ["kind"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.list": {
			input: objectSchema({
				controlType: { type: "string" },
				tag: { type: "string" },
				offset: { type: "integer" },
				limit: { type: "integer" }
			}),
			output: ccListResultSchema
		},
		"contentControls.get": targetOnlyRead,
		"contentControls.listInRange": {
			input: objectSchema({
				startBlockId: { type: "string" },
				endBlockId: { type: "string" },
				offset: { type: "integer" },
				limit: { type: "integer" }
			}, ["startBlockId", "endBlockId"]),
			output: ccListResultSchema
		},
		"contentControls.selectByTag": {
			input: objectSchema({
				tag: { type: "string" },
				offset: { type: "integer" },
				limit: { type: "integer" }
			}, ["tag"]),
			output: ccListResultSchema
		},
		"contentControls.selectByTitle": {
			input: objectSchema({
				title: { type: "string" },
				offset: { type: "integer" },
				limit: { type: "integer" }
			}, ["title"]),
			output: ccListResultSchema
		},
		"contentControls.listChildren": {
			input: objectSchema({
				target: contentControlTargetSchema,
				offset: { type: "integer" },
				limit: { type: "integer" }
			}, ["target"]),
			output: ccListResultSchema
		},
		"contentControls.getParent": {
			input: ccTargetInput(),
			output: { oneOf: [ccInfoSchema, { type: "null" }] }
		},
		"contentControls.wrap": {
			input: objectSchema({
				kind: { enum: ["block", "inline"] },
				target: contentControlTargetSchema,
				tag: { type: "string" },
				alias: { type: "string" },
				lockMode: { enum: [
					"unlocked",
					"sdtLocked",
					"contentLocked",
					"sdtContentLocked"
				] }
			}, ["kind", "target"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.unwrap": targetOnlyMutation,
		"contentControls.delete": targetOnlyMutation,
		"contentControls.copy": {
			input: objectSchema({
				target: contentControlTargetSchema,
				destination: contentControlTargetSchema
			}, ["target", "destination"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.move": {
			input: objectSchema({
				target: contentControlTargetSchema,
				destination: contentControlTargetSchema
			}, ["target", "destination"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.patch": {
			input: objectSchema({
				target: contentControlTargetSchema,
				alias: {},
				tag: {},
				appearance: { enum: [
					"boundingBox",
					"tags",
					"hidden"
				] },
				color: { type: "string" },
				placeholder: { type: "string" },
				showingPlaceholder: { type: "boolean" },
				temporary: { type: "boolean" },
				tabIndex: { type: "integer" }
			}, ["target"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.setLockMode": {
			input: objectSchema({
				target: contentControlTargetSchema,
				lockMode: { enum: [
					"unlocked",
					"sdtLocked",
					"contentLocked",
					"sdtContentLocked"
				] }
			}, ["target", "lockMode"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.setType": {
			input: objectSchema({
				target: contentControlTargetSchema,
				controlType: { type: "string" }
			}, ["target", "controlType"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.getContent": {
			input: ccTargetInput(),
			output: objectSchema({
				content: { type: "string" },
				format: { enum: ["text", "html"] }
			}, ["content", "format"])
		},
		"contentControls.replaceContent": ccContentMutation,
		"contentControls.clearContent": targetOnlyMutation,
		"contentControls.appendContent": ccContentMutation,
		"contentControls.prependContent": ccContentMutation,
		"contentControls.insertBefore": ccContentMutation,
		"contentControls.insertAfter": ccContentMutation,
		"contentControls.getBinding": {
			input: ccTargetInput(),
			output: { oneOf: [objectSchema({
				storeItemId: { type: "string" },
				xpath: { type: "string" },
				prefixMappings: { type: "string" }
			}, ["storeItemId", "xpath"]), { type: "null" }] }
		},
		"contentControls.setBinding": {
			input: objectSchema({
				target: contentControlTargetSchema,
				storeItemId: { type: "string" },
				xpath: { type: "string" },
				prefixMappings: { type: "string" }
			}, [
				"target",
				"storeItemId",
				"xpath"
			]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.clearBinding": targetOnlyMutation,
		"contentControls.getRawProperties": {
			input: ccTargetInput(),
			output: objectSchema({ properties: { type: "object" } }, ["properties"])
		},
		"contentControls.patchRawProperties": {
			input: objectSchema({
				target: contentControlTargetSchema,
				patches: {
					type: "array",
					items: { type: "object" }
				}
			}, ["target", "patches"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.validateWordCompatibility": {
			input: ccTargetInput(),
			output: objectSchema({
				compatible: { type: "boolean" },
				diagnostics: {
					type: "array",
					items: { type: "object" }
				}
			}, ["compatible", "diagnostics"])
		},
		"contentControls.normalizeWordCompatibility": targetOnlyMutation,
		"contentControls.normalizeTagPayload": targetOnlyMutation,
		"contentControls.text.setMultiline": {
			input: objectSchema({
				target: contentControlTargetSchema,
				multiline: { type: "boolean" }
			}, ["target", "multiline"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.text.setValue": {
			input: objectSchema({
				target: contentControlTargetSchema,
				value: { type: "string" }
			}, ["target", "value"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.text.clearValue": targetOnlyMutation,
		"contentControls.date.setValue": {
			input: objectSchema({
				target: contentControlTargetSchema,
				value: { type: "string" }
			}, ["target", "value"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.date.clearValue": targetOnlyMutation,
		"contentControls.date.setDisplayFormat": {
			input: objectSchema({
				target: contentControlTargetSchema,
				format: { type: "string" }
			}, ["target", "format"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.date.setDisplayLocale": {
			input: objectSchema({
				target: contentControlTargetSchema,
				locale: { type: "string" }
			}, ["target", "locale"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.date.setStorageFormat": {
			input: objectSchema({
				target: contentControlTargetSchema,
				format: { type: "string" }
			}, ["target", "format"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.date.setCalendar": {
			input: objectSchema({
				target: contentControlTargetSchema,
				calendar: { type: "string" }
			}, ["target", "calendar"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.checkbox.getState": {
			input: ccTargetInput(),
			output: objectSchema({ checked: { type: "boolean" } }, ["checked"])
		},
		"contentControls.checkbox.setState": {
			input: objectSchema({
				target: contentControlTargetSchema,
				checked: { type: "boolean" }
			}, ["target", "checked"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.checkbox.toggle": targetOnlyMutation,
		"contentControls.checkbox.setSymbolPair": {
			input: objectSchema({
				target: contentControlTargetSchema,
				checkedSymbol: { type: "object" },
				uncheckedSymbol: { type: "object" }
			}, [
				"target",
				"checkedSymbol",
				"uncheckedSymbol"
			]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.choiceList.getItems": {
			input: ccTargetInput(),
			output: objectSchema({
				items: {
					type: "array",
					items: { type: "object" }
				},
				selectedValue: { type: "string" }
			}, ["items"])
		},
		"contentControls.choiceList.setItems": {
			input: objectSchema({
				target: contentControlTargetSchema,
				items: {
					type: "array",
					items: { type: "object" }
				}
			}, ["target", "items"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.choiceList.setSelected": {
			input: objectSchema({
				target: contentControlTargetSchema,
				value: { type: "string" }
			}, ["target", "value"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.repeatingSection.listItems": {
			input: ccTargetInput(),
			output: ccListResultSchema
		},
		"contentControls.repeatingSection.insertItemBefore": {
			input: objectSchema({
				target: contentControlTargetSchema,
				index: { type: "integer" }
			}, ["target", "index"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.repeatingSection.insertItemAfter": {
			input: objectSchema({
				target: contentControlTargetSchema,
				index: { type: "integer" }
			}, ["target", "index"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.repeatingSection.cloneItem": {
			input: objectSchema({
				target: contentControlTargetSchema,
				index: { type: "integer" }
			}, ["target", "index"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.repeatingSection.deleteItem": {
			input: objectSchema({
				target: contentControlTargetSchema,
				index: { type: "integer" }
			}, ["target", "index"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.repeatingSection.setAllowInsertDelete": {
			input: objectSchema({
				target: contentControlTargetSchema,
				allow: { type: "boolean" }
			}, ["target", "allow"]),
			output: ccMutationResultSchema(),
			success: contentControlMutationSuccessSchema,
			failure: contentControlMutationFailureSchema
		},
		"contentControls.group.wrap": targetOnlyMutation,
		"contentControls.group.ungroup": targetOnlyMutation
	};
}
var refListQueryProperties = {
	limit: {
		type: "integer",
		minimum: 1
	},
	offset: {
		type: "integer",
		minimum: 0
	}
};
objectSchema(refListQueryProperties);
var refFailureSchema = objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" },
		details: {}
	}, ["code", "message"])
}, ["success", "failure"]);
function refMutationSchemas(successProperties, requiredSuccess) {
	const success = objectSchema({
		success: { const: true },
		...successProperties
	}, ["success", ...requiredSuccess]);
	return {
		output: { oneOf: [success, refFailureSchema] },
		success,
		failure: refFailureSchema
	};
}
function refConfigSchemas() {
	const success = objectSchema({ success: { const: true } }, ["success"]);
	return {
		output: { oneOf: [success, refFailureSchema] },
		success,
		failure: refFailureSchema
	};
}
var bookmarkAddressSchema = objectSchema({
	kind: { const: "entity" },
	entityType: { const: "bookmark" },
	name: { type: "string" },
	story: ref("StoryLocator")
}, [
	"kind",
	"entityType",
	"name"
]);
var bookmarkMutation = refMutationSchemas({ bookmark: bookmarkAddressSchema }, ["bookmark"]);
var customXmlPartTargetSchema = { oneOf: [objectSchema({ id: {
	type: "string",
	minLength: 1
} }, ["id"]), objectSchema({ partName: {
	type: "string",
	minLength: 1
} }, ["partName"])] };
var customXmlPartMutation = refMutationSchemas({
	target: customXmlPartTargetSchema,
	id: {
		type: "string",
		minLength: 1
	}
}, ["target"]);
var customXmlPartCreateMutation = refMutationSchemas({
	id: { type: "string" },
	partName: { type: "string" },
	propsPartName: { type: "string" }
}, [
	"id",
	"partName",
	"propsPartName"
]);
var anchoredMetadataAttachMutation = refMutationSchemas({
	id: {
		type: "string",
		minLength: 1
	},
	namespace: {
		type: "string",
		minLength: 1
	},
	partName: {
		type: "string",
		minLength: 1
	}
}, [
	"id",
	"namespace",
	"partName"
]);
var anchoredMetadataMutation = refMutationSchemas({ id: {
	type: "string",
	minLength: 1
} }, ["id"]);
var footnoteAddressSchema = objectSchema({
	kind: { const: "entity" },
	entityType: { const: "footnote" },
	noteId: { type: "string" }
}, [
	"kind",
	"entityType",
	"noteId"
]);
var footnoteConfigScopeSchema = { oneOf: [objectSchema({ kind: { const: "document" } }, ["kind"]), objectSchema({
	kind: { const: "section" },
	sectionId: { type: "string" }
}, ["kind", "sectionId"])] };
var footnoteNumberingSchema = objectSchema({
	format: { enum: [
		"decimal",
		"lowerRoman",
		"upperRoman",
		"lowerLetter",
		"upperLetter",
		"symbol"
	] },
	start: { type: "integer" },
	restartPolicy: { enum: [
		"continuous",
		"eachSection",
		"eachPage"
	] },
	position: { enum: [
		"pageBottom",
		"beneathText",
		"sectionEnd",
		"documentEnd"
	] }
});
var footnoteMutation = refMutationSchemas({ footnote: footnoteAddressSchema }, ["footnote"]);
var footnoteConfig = refConfigSchemas();
var crossRefAddressSchema = objectSchema({
	kind: { const: "inline" },
	nodeType: { const: "crossRef" },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]);
var crossRefTargetSchema = { oneOf: [
	objectSchema({
		kind: { const: "bookmark" },
		name: { type: "string" }
	}, ["kind", "name"]),
	objectSchema({
		kind: { const: "heading" },
		nodeId: { type: "string" }
	}, ["kind", "nodeId"]),
	objectSchema({
		kind: { const: "note" },
		noteId: { type: "string" }
	}, ["kind", "noteId"]),
	objectSchema({
		kind: { const: "caption" },
		nodeId: { type: "string" }
	}, ["kind", "nodeId"]),
	objectSchema({
		kind: { const: "numberedItem" },
		nodeId: { type: "string" }
	}, ["kind", "nodeId"]),
	objectSchema({
		kind: { const: "styledParagraph" },
		styleName: { type: "string" },
		direction: { enum: ["before", "after"] }
	}, ["kind", "styleName"])
] };
var crossRefDisplaySchema = { enum: [
	"content",
	"pageNumber",
	"noteNumber",
	"labelAndNumber",
	"aboveBelow",
	"numberOnly",
	"numberFullContext",
	"styledContent",
	"styledPageNumber"
] };
var crossRefMutation = refMutationSchemas({ crossRef: crossRefAddressSchema }, ["crossRef"]);
var indexAddressSchema = objectSchema({
	kind: { const: "block" },
	nodeType: { const: "index" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]);
var indexEntryAddressSchema = objectSchema({
	kind: { const: "inline" },
	nodeType: { const: "indexEntry" },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]);
var indexConfigSchema = objectSchema({
	headingSeparator: { type: "string" },
	entryPageSeparator: { type: "string" },
	pageRangeSeparator: { type: "string" },
	sequenceId: { type: "string" },
	columns: { type: "integer" },
	entryTypeFilter: { type: "string" },
	pageRangeBookmark: { type: "string" },
	letterRange: objectSchema({
		from: { type: "string" },
		to: { type: "string" }
	}, ["from", "to"]),
	runIn: { type: "boolean" },
	accentedSorting: { type: "boolean" }
});
var indexEntryDataSchema = objectSchema({
	text: { type: "string" },
	subEntry: { type: "string" },
	bold: { type: "boolean" },
	italic: { type: "boolean" },
	crossReference: { type: "string" },
	pageRangeBookmark: { type: "string" },
	entryType: { type: "string" },
	yomi: { type: "string" }
}, ["text"]);
var indexEntryPatchSchema = objectSchema({
	text: { type: "string" },
	subEntry: { type: "string" },
	bold: { type: "boolean" },
	italic: { type: "boolean" },
	crossReference: { type: "string" },
	pageRangeBookmark: { type: "string" },
	entryType: { type: "string" },
	yomi: { type: "string" }
});
var indexMutation = refMutationSchemas({ index: indexAddressSchema }, ["index"]);
var indexEntryMutation = refMutationSchemas({ entry: indexEntryAddressSchema }, ["entry"]);
var captionAddressSchema = objectSchema({
	kind: { const: "block" },
	nodeType: { const: "paragraph" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]);
var captionMutation = refMutationSchemas({ caption: captionAddressSchema }, ["caption"]);
var captionConfig = refConfigSchemas();
var fieldAddressSchema = objectSchema({
	kind: { const: "field" },
	blockId: { type: "string" },
	occurrenceIndex: { type: "integer" },
	nestingDepth: { type: "integer" }
}, [
	"kind",
	"blockId",
	"occurrenceIndex"
]);
var fieldMutation = refMutationSchemas({ field: fieldAddressSchema }, ["field"]);
var citationAddressSchema = objectSchema({
	kind: { const: "inline" },
	nodeType: { const: "citation" },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]);
var citationSourceAddressSchema = objectSchema({
	kind: { const: "entity" },
	entityType: { const: "citationSource" },
	sourceId: { type: "string" }
}, [
	"kind",
	"entityType",
	"sourceId"
]);
var bibliographyAddressSchema = objectSchema({
	kind: { const: "block" },
	nodeType: { const: "bibliography" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]);
var citationMutation = refMutationSchemas({ citation: citationAddressSchema }, ["citation"]);
var citationSourceMutation = refMutationSchemas({ source: citationSourceAddressSchema }, ["source"]);
var bibliographyMutation = refMutationSchemas({ bibliography: bibliographyAddressSchema }, ["bibliography"]);
var citationPersonSchema = objectSchema({
	first: { type: "string" },
	middle: { type: "string" },
	last: { type: "string" }
}, ["last"]);
var citationSourceFieldsSchema = objectSchema({
	title: { type: "string" },
	authors: arraySchema(citationPersonSchema),
	year: { type: "string" },
	publisher: { type: "string" },
	city: { type: "string" },
	journalName: { type: "string" },
	volume: { type: "string" },
	issue: { type: "string" },
	pages: { type: "string" },
	url: { type: "string" },
	doi: { type: "string" },
	edition: { type: "string" },
	editor: arraySchema(citationPersonSchema),
	translator: arraySchema(citationPersonSchema),
	medium: { type: "string" },
	shortTitle: { type: "string" },
	standardNumber: { type: "string" }
});
var tocCreateLocationSchema = { oneOf: [
	objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
	objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
	objectSchema({
		kind: { const: "before" },
		target: blockNodeAddressSchema
	}, ["kind", "target"]),
	objectSchema({
		kind: { const: "after" },
		target: blockNodeAddressSchema
	}, ["kind", "target"])
] };
var authoritiesAddressSchema = objectSchema({
	kind: { const: "block" },
	nodeType: { const: "tableOfAuthorities" },
	nodeId: { type: "string" }
}, [
	"kind",
	"nodeType",
	"nodeId"
]);
var authorityEntryAddressSchema = objectSchema({
	kind: { const: "inline" },
	nodeType: { const: "authorityEntry" },
	anchor: ref("InlineAnchor")
}, [
	"kind",
	"nodeType",
	"anchor"
]);
var authoritiesConfigSchema = objectSchema({
	category: { type: "integer" },
	entryPageSeparator: { type: "string" },
	usePassim: { type: "boolean" },
	includeHeadings: { type: "boolean" },
	tabLeader: { type: "string" },
	pageRangeSeparator: { type: "string" }
});
var authorityEntryDataSchema = objectSchema({
	longCitation: { type: "string" },
	shortCitation: { type: "string" },
	category: { oneOf: [{ type: "string" }, { type: "integer" }] },
	bold: { type: "boolean" },
	italic: { type: "boolean" }
}, ["longCitation", "category"]);
var authorityEntryPatchSchema = objectSchema({
	longCitation: { type: "string" },
	shortCitation: { type: "string" },
	category: { oneOf: [{ type: "string" }, { type: "integer" }] },
	bold: { type: "boolean" },
	italic: { type: "boolean" }
});
var authoritiesMutation = refMutationSchemas({ authorities: authoritiesAddressSchema }, ["authorities"]);
var authorityEntryMutation = refMutationSchemas({ entry: authorityEntryAddressSchema }, ["entry"]);
var diffCoverageSchema = objectSchema({
	body: {
		type: "boolean",
		const: true
	},
	comments: { type: "boolean" },
	styles: { type: "boolean" },
	numbering: { type: "boolean" },
	headerFooters: { type: "boolean" }
}, [
	"body",
	"comments",
	"styles",
	"numbering",
	"headerFooters"
]);
var diffSummarySchema = objectSchema({
	hasChanges: { type: "boolean" },
	changedComponents: {
		type: "array",
		items: {
			type: "string",
			enum: [
				"body",
				"comments",
				"styles",
				"numbering",
				"headerFooters",
				"parts"
			]
		}
	},
	body: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"]),
	comments: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"]),
	styles: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"]),
	numbering: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"]),
	headerFooters: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"]),
	parts: objectSchema({ hasChanges: { type: "boolean" } }, ["hasChanges"])
}, [
	"hasChanges",
	"changedComponents",
	"body",
	"comments",
	"styles",
	"numbering",
	"headerFooters",
	"parts"
]);
var diffSnapshotSchema = objectSchema({
	version: {
		type: "string",
		enum: ["sd-diff-snapshot/v1", "sd-diff-snapshot/v2"]
	},
	engine: {
		type: "string",
		enum: ["super-editor"]
	},
	fingerprint: { type: "string" },
	coverage: diffCoverageSchema,
	payload: {
		type: "object",
		description: "Opaque engine-owned snapshot data."
	}
}, [
	"version",
	"engine",
	"fingerprint",
	"coverage",
	"payload"
]);
var diffPayloadSchema = objectSchema({
	version: {
		type: "string",
		enum: ["sd-diff-payload/v1", "sd-diff-payload/v2"]
	},
	engine: {
		type: "string",
		enum: ["super-editor"]
	},
	baseFingerprint: { type: "string" },
	targetFingerprint: { type: "string" },
	coverage: diffCoverageSchema,
	summary: diffSummarySchema,
	payload: {
		type: "object",
		description: "Opaque engine-owned diff data."
	}
}, [
	"version",
	"engine",
	"baseFingerprint",
	"targetFingerprint",
	"coverage",
	"summary",
	"payload"
]);
objectSchema({
	appliedOperations: { type: "integer" },
	baseFingerprint: { type: "string" },
	targetFingerprint: { type: "string" },
	coverage: diffCoverageSchema,
	summary: diffSummarySchema,
	diagnostics: {
		type: "array",
		items: { type: "string" }
	}
}, [
	"appliedOperations",
	"baseFingerprint",
	"targetFingerprint",
	"coverage",
	"summary",
	"diagnostics"
]);
objectSchema({ options: objectSchema({
	includeResolved: { type: "boolean" },
	includeProvenance: { type: "boolean" },
	includeContext: { type: "boolean" }
}) }), objectSchema({
	modelVersion: { const: "sdm/1" },
	body: { type: "array" }
}, ["modelVersion", "body"]), objectSchema({
	nodeId: { type: "string" },
	nodeType: { enum: [...blockNodeTypeValues] }
}, ["nodeId"]), objectSchema({ in: storyLocatorSchema }), objectSchema({ in: storyLocatorSchema }), objectSchema({
	in: storyLocatorSchema,
	unflattenLists: {
		type: "boolean",
		description: "When true, flattens nested list structures in output. Default: false."
	}
}), objectSchema({ markdown: { type: "string" } }, ["markdown"]), objectSchema({
	fragment: {},
	lossy: { type: "boolean" },
	diagnostics: arraySchema(objectSchema({
		code: { type: "string" },
		severity: {
			type: "string",
			enum: [
				"error",
				"warning",
				"info"
			]
		},
		message: { type: "string" },
		path: arraySchema({ type: "string" })
	}, [
		"code",
		"severity",
		"message"
	]))
}, [
	"fragment",
	"lossy",
	"diagnostics"
]), objectSchema({
	blocks: {
		type: "array",
		items: objectSchema({
			nodeId: {
				type: "string",
				description: "Stable block ID: pass to scrollToElement() for navigation."
			},
			type: {
				type: "string",
				description: "Block type: paragraph, heading, listItem, image, tableOfContents."
			},
			text: {
				type: "string",
				description: "Full plain text content of the block."
			},
			textSpans: {
				type: "array",
				description: "Block text broken into runs with tracked-change marks preserved per run. Present only when the block contains at least one tracked change. Concatenating span text yields `text`.",
				items: objectSchema({
					text: {
						type: "string",
						description: "Raw text of the run."
					},
					trackedChanges: {
						type: "array",
						description: "Tracked-change marks applied to this run.",
						items: objectSchema({
							entityId: {
								type: "string",
								description: "Tracked change entity ID matching an entry in trackedChanges[]."
							},
							type: {
								type: "string",
								enum: [
									"insert",
									"delete",
									"format"
								]
							}
						}, ["entityId", "type"])
					}
				}, ["text"])
			},
			headingLevel: {
				type: "integer",
				description: "Heading level (1-6). Only present for headings."
			},
			tableContext: objectSchema({
				tableOrdinal: {
					type: "integer",
					description: "0-based table ordinal, unique within one extract() result."
				},
				parentTableOrdinal: {
					type: "integer",
					description: "Ordinal of the parent table when the containing table is nested."
				},
				parentRowIndex: {
					type: "integer",
					description: "Row index in the parent table. Set with parentTableOrdinal."
				},
				parentColumnIndex: {
					type: "integer",
					description: "Column index in the parent table. Set with parentTableOrdinal."
				},
				rowIndex: {
					type: "integer",
					description: "0-based row index of the containing cell."
				},
				columnIndex: {
					type: "integer",
					description: "0-based logical grid column, not the row child order."
				},
				rowspan: {
					type: "integer",
					description: "Number of rows the cell spans."
				},
				colspan: {
					type: "integer",
					description: "Number of columns the cell spans."
				}
			}, [
				"tableOrdinal",
				"rowIndex",
				"columnIndex",
				"rowspan",
				"colspan"
			])
		}, [
			"nodeId",
			"type",
			"text"
		])
	},
	comments: {
		type: "array",
		items: objectSchema({
			entityId: {
				type: "string",
				description: "Comment entity ID: pass to scrollToElement() for navigation."
			},
			text: {
				type: "string",
				description: "Comment body text."
			},
			anchoredText: {
				type: "string",
				description: "The document text the comment is anchored to."
			},
			blockId: {
				type: "string",
				description: "Block ID the comment is anchored to."
			},
			status: {
				type: "string",
				enum: ["open", "resolved"]
			},
			author: {
				type: "string",
				description: "Comment author name."
			}
		}, ["entityId", "status"])
	},
	trackedChanges: {
		type: "array",
		items: objectSchema({
			entityId: {
				type: "string",
				description: "Tracked change entity ID. Pass to scrollToElement() for navigation."
			},
			type: {
				type: "string",
				enum: [...trackChangeTypeValues],
				description: "Entity-level type. In paired replacement mode, a delete+insert pair shares one entity with type 'replacement'; per-half type lives on block.textSpans[].trackedChanges[]."
			},
			blockIds: {
				type: "array",
				description: "Block IDs whose textSpans carry this change.",
				items: { type: "string" }
			},
			wordRevisionIds: objectSchema({
				insert: {
					type: "string",
					description: "Original OOXML w:id from a w:ins mark."
				},
				delete: {
					type: "string",
					description: "Original OOXML w:id from a w:del mark."
				},
				format: {
					type: "string",
					description: "Original OOXML w:id from a w:rPrChange mark."
				}
			}, []),
			excerpt: {
				type: "string",
				description: "Short text excerpt of the changed content. Omitted for paired replacements; read block.textSpans for the per-half text."
			},
			author: {
				type: "string",
				description: "Change author name."
			},
			date: {
				type: "string",
				description: "Change date (ISO string)."
			}
		}, ["entityId", "type"])
	},
	revision: {
		type: "string",
		description: "Document revision at the time of extraction."
	}
}, [
	"blocks",
	"comments",
	"trackedChanges",
	"revision"
]), receiptResultSchemaFor("clearContent"), receiptFailureResultSchemaFor("clearContent"), sdMutationResultSchemaFor("insert"), sdMutationFailureSchemaFor("insert"), { ...targetLocatorWithPayload({
	in: storyLocatorSchema,
	text: {
		type: "string",
		description: "Replacement text content."
	}
}, ["text"]) }, objectSchema({
	in: storyLocatorSchema,
	target: {
		oneOf: [blockNodeAddressSchema, selectionTargetSchema],
		description: "Target block or selection to replace."
	},
	content: {
		...sdFragmentSchema,
		description: "Document fragment to replace with (structured content)."
	},
	nestingPolicy: nestingPolicySchema
}, ["target", "content"]), objectSchema({
	in: storyLocatorSchema,
	ref: {
		type: "string",
		description: "Reference handle from a previous search result."
	},
	content: {
		...sdFragmentSchema,
		description: "Document fragment to replace with (structured content)."
	},
	nestingPolicy: nestingPolicySchema
}, ["ref", "content"]), sdMutationResultSchemaFor("replace"), sdMutationFailureSchemaFor("replace"), { ...targetLocatorWithPayload({
	in: storyLocatorSchema,
	behavior: {
		...deleteBehaviorSchema,
		description: "Delete behavior: 'selection' (default) or 'exact'."
	}
}) }, textMutationResultSchemaFor("delete"), textMutationFailureSchemaFor("delete"), { ...targetLocatorWithPayload({
	in: storyLocatorSchema,
	properties: {
		...buildInlineRunPatchSchema(),
		description: "Inline formatting properties to apply. Set a property to apply it, use null to clear it. Example: {bold: true, italic: true} or {bold: null} to remove bold."
	},
	changeMode: {
		enum: ["direct", "tracked"],
		description: "Edit mode: 'direct' applies changes immediately, 'tracked' records tracked formatting."
	},
	dryRun: {
		type: "boolean",
		description: "Preview the result without mutating the document."
	},
	expectedRevision: {
		type: "string",
		description: "Document revision for optimistic concurrency. Mutation fails if document was modified since this revision."
	}
}, ["properties"]) }, textMutationResultSchemaFor("formatRange"), textMutationFailureSchemaFor("formatRange"), { ...targetLocatorWithPayload({
	in: storyLocatorSchema,
	inline: {
		...buildInlineRunPatchSchema(),
		description: "Inline formatting properties to apply. Set a property to apply it, use null to clear it. Example: {bold: true, italic: true} or {bold: null} to remove bold."
	}
}, ["inline"]) }, textMutationResultSchemaFor("format.apply"), textMutationFailureSchemaFor("format.apply"), { ...formatInlineAliasOperationSchemas }, objectSchema({
	offset: {
		type: "number",
		minimum: 0,
		description: "Number of blocks to skip. Default: 0."
	},
	limit: {
		type: "number",
		minimum: 1,
		description: "Maximum blocks to return. Omit for all blocks."
	},
	nodeTypes: {
		type: "array",
		items: { enum: [...blockNodeTypeValues] },
		description: "Filter by block types (e.g. ['paragraph', 'heading']). Omit for all types."
	},
	includeText: {
		type: "boolean",
		description: "When true, includes the full flattened block text in each block entry."
	}
}), objectSchema({
	total: { type: "number" },
	blocks: {
		type: "array",
		items: objectSchema({
			ordinal: { type: "number" },
			nodeId: {
				type: "string",
				description: "Block ID for targeting with other tools."
			},
			nodeType: { enum: [...blockNodeTypeValues] },
			textPreview: { oneOf: [{ type: "string" }, { type: "null" }] },
			text: {
				oneOf: [{ type: "string" }, { type: "null" }],
				description: "Full flattened block text when requested with includeText."
			},
			isEmpty: { type: "boolean" },
			styleId: {
				oneOf: [{ type: "string" }, { type: "null" }],
				description: "Named paragraph style."
			},
			fontFamily: {
				type: "string",
				description: "Font family from first text run."
			},
			fontSize: {
				type: "number",
				description: "Font size from first text run."
			},
			bold: {
				type: "boolean",
				description: "True if text is bold."
			},
			color: {
				type: "string",
				description: "Text color when explicitly set (e.g. '#000000')."
			},
			alignment: {
				type: "string",
				description: "Paragraph alignment."
			},
			headingLevel: {
				type: "number",
				description: "Heading level (1-6)."
			},
			ref: {
				type: "string",
				description: "Ref handle for this block. Pass directly to superdoc_format or superdoc_edit ref param. Only present for non-empty blocks."
			}
		}, [
			"ordinal",
			"nodeId",
			"nodeType"
		])
	},
	revision: { type: "string" }
}, [
	"total",
	"blocks",
	"revision"
]), objectSchema({ target: deletableBlockNodeAddressSchema }, ["target"]), objectSchema({
	success: { const: true },
	deleted: deletableBlockNodeAddressSchema,
	deletedBlock: objectSchema({
		ordinal: { type: "number" },
		nodeId: { type: "string" },
		nodeType: { type: "string" },
		textPreview: { oneOf: [{ type: "string" }, { type: "null" }] }
	})
}, ["success", "deleted"]), objectSchema({
	success: { const: true },
	deleted: deletableBlockNodeAddressSchema,
	deletedBlock: objectSchema({
		ordinal: { type: "number" },
		nodeId: { type: "string" },
		nodeType: { type: "string" },
		textPreview: { oneOf: [{ type: "string" }, { type: "null" }] }
	})
}, ["success", "deleted"]), preApplyFailureResultSchemaFor("blocks.delete"), objectSchema({
	start: blockNodeAddressSchema,
	end: blockNodeAddressSchema
}, ["start", "end"]), objectSchema({
	success: { const: true },
	deletedCount: { type: "number" },
	deletedBlocks: {
		type: "array",
		items: objectSchema({
			ordinal: { type: "number" },
			nodeId: { type: "string" },
			nodeType: { type: "string" },
			textPreview: { oneOf: [{ type: "string" }, { type: "null" }] }
		}, [
			"ordinal",
			"nodeId",
			"nodeType",
			"textPreview"
		])
	},
	revision: objectSchema({
		before: { type: "string" },
		after: { type: "string" }
	}, ["before", "after"]),
	dryRun: { type: "boolean" }
}, [
	"success",
	"deletedCount",
	"deletedBlocks",
	"revision",
	"dryRun"
]), objectSchema({
	success: { const: true },
	deletedCount: { type: "number" },
	deletedBlocks: { type: "array" },
	revision: objectSchema({
		before: { type: "string" },
		after: { type: "string" }
	}, ["before", "after"]),
	dryRun: { type: "boolean" }
}, [
	"success",
	"deletedCount",
	"deletedBlocks",
	"revision",
	"dryRun"
]), preApplyFailureResultSchemaFor("blocks.deleteRange"), objectSchema({
	target: paragraphTargetSchema,
	styleId: {
		type: "string",
		minLength: 1,
		description: "Named paragraph style ID (e.g. 'Normal', 'Heading1', 'BodyText'). Use superdoc_search to find a nearby paragraph, then inspect its style to determine the correct styleId."
	}
}, ["target", "styleId"]), paragraphMutationResultSchemaFor("styles.paragraph.setStyle"), paragraphMutationFailureSchemaFor("styles.paragraph.setStyle"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("styles.paragraph.clearStyle"), paragraphMutationFailureSchemaFor("styles.paragraph.clearStyle"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.resetDirectFormatting"), paragraphMutationFailureSchemaFor("format.paragraph.resetDirectFormatting"), objectSchema({
	target: paragraphTargetSchema,
	alignment: {
		enum: [...PARAGRAPH_ALIGNMENTS],
		description: "Visual paragraph alignment. In RTL paragraphs, 'left' stores w:jc='right' and 'right' stores w:jc='left' so Word displays the requested side."
	}
}, ["target", "alignment"]), paragraphMutationResultSchemaFor("format.paragraph.setAlignment"), paragraphMutationFailureSchemaFor("format.paragraph.setAlignment"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearAlignment"), paragraphMutationFailureSchemaFor("format.paragraph.clearAlignment"), { ...objectSchema({
	target: paragraphTargetSchema,
	left: {
		type: "integer",
		minimum: 0,
		description: "Left indentation in twips (1440 = 1 inch)."
	},
	right: {
		type: "integer",
		minimum: 0,
		description: "Right indentation in twips (1440 = 1 inch)."
	},
	firstLine: {
		type: "integer",
		minimum: 0,
		description: "First line indent in twips. Cannot be combined with hanging."
	},
	hanging: {
		type: "integer",
		minimum: 0,
		description: "Hanging indent in twips. Cannot be combined with firstLine."
	}
}, ["target"]) }, paragraphMutationResultSchemaFor("format.paragraph.setIndentation"), paragraphMutationFailureSchemaFor("format.paragraph.setIndentation"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearIndentation"), paragraphMutationFailureSchemaFor("format.paragraph.clearIndentation"), { ...objectSchema({
	target: paragraphTargetSchema,
	before: {
		type: "integer",
		minimum: 0,
		description: "Space before paragraph in twips (20 twips = 1pt)."
	},
	after: {
		type: "integer",
		minimum: 0,
		description: "Space after paragraph in twips (20 twips = 1pt)."
	},
	line: {
		type: "integer",
		minimum: 1,
		description: "Line spacing value. Meaning depends on lineRule. Must be provided together with lineRule."
	},
	lineRule: {
		enum: [...LINE_RULES],
		description: "Line spacing rule. Required when 'line' is set."
	}
}, ["target"]) }, paragraphMutationResultSchemaFor("format.paragraph.setSpacing"), paragraphMutationFailureSchemaFor("format.paragraph.setSpacing"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearSpacing"), paragraphMutationFailureSchemaFor("format.paragraph.clearSpacing"), { ...objectSchema({
	target: paragraphTargetSchema,
	keepNext: { type: "boolean" },
	keepLines: { type: "boolean" },
	widowControl: { type: "boolean" }
}, ["target"]) }, paragraphMutationResultSchemaFor("format.paragraph.setKeepOptions"), paragraphMutationFailureSchemaFor("format.paragraph.setKeepOptions"), objectSchema({
	target: paragraphTargetSchema,
	outlineLevel: { oneOf: [{
		type: "integer",
		minimum: 0,
		maximum: 9
	}, { type: "null" }] }
}, ["target", "outlineLevel"]), paragraphMutationResultSchemaFor("format.paragraph.setOutlineLevel"), paragraphMutationFailureSchemaFor("format.paragraph.setOutlineLevel"), { ...objectSchema({
	target: paragraphTargetSchema,
	contextualSpacing: { type: "boolean" },
	pageBreakBefore: { type: "boolean" },
	suppressAutoHyphens: { type: "boolean" }
}, ["target"]) }, paragraphMutationResultSchemaFor("format.paragraph.setFlowOptions"), paragraphMutationFailureSchemaFor("format.paragraph.setFlowOptions"), objectSchema({
	target: paragraphTargetSchema,
	position: {
		type: "integer",
		minimum: 0
	},
	alignment: { enum: [...TAB_STOP_ALIGNMENTS] },
	leader: { enum: [...TAB_STOP_LEADERS] }
}, [
	"target",
	"position",
	"alignment"
]), paragraphMutationResultSchemaFor("format.paragraph.setTabStop"), paragraphMutationFailureSchemaFor("format.paragraph.setTabStop"), objectSchema({
	target: paragraphTargetSchema,
	position: {
		type: "integer",
		minimum: 0
	}
}, ["target", "position"]), paragraphMutationResultSchemaFor("format.paragraph.clearTabStop"), paragraphMutationFailureSchemaFor("format.paragraph.clearTabStop"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearAllTabStops"), paragraphMutationFailureSchemaFor("format.paragraph.clearAllTabStops"), objectSchema({
	target: paragraphTargetSchema,
	side: { enum: [...BORDER_SIDES] },
	style: {
		type: "string",
		minLength: 1
	},
	color: {
		type: "string",
		minLength: 1
	},
	size: {
		type: "integer",
		minimum: 0
	},
	space: {
		type: "integer",
		minimum: 0
	}
}, [
	"target",
	"side",
	"style"
]), paragraphMutationResultSchemaFor("format.paragraph.setBorder"), paragraphMutationFailureSchemaFor("format.paragraph.setBorder"), objectSchema({
	target: paragraphTargetSchema,
	side: { enum: [...CLEAR_BORDER_SIDES] }
}, ["target", "side"]), paragraphMutationResultSchemaFor("format.paragraph.clearBorder"), paragraphMutationFailureSchemaFor("format.paragraph.clearBorder"), { ...objectSchema({
	target: paragraphTargetSchema,
	fill: {
		type: "string",
		minLength: 1
	},
	color: {
		type: "string",
		minLength: 1
	},
	pattern: {
		type: "string",
		minLength: 1
	}
}, ["target"]) }, paragraphMutationResultSchemaFor("format.paragraph.setShading"), paragraphMutationFailureSchemaFor("format.paragraph.setShading"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearShading"), paragraphMutationFailureSchemaFor("format.paragraph.clearShading"), objectSchema({
	target: paragraphTargetSchema,
	direction: {
		type: "string",
		enum: ["ltr", "rtl"]
	},
	alignmentPolicy: {
		type: "string",
		enum: ["preserve", "matchDirection"]
	}
}, ["target", "direction"]), paragraphMutationResultSchemaFor("format.paragraph.setDirection"), paragraphMutationFailureSchemaFor("format.paragraph.setDirection"), objectSchema({ target: paragraphTargetSchema }, ["target"]), paragraphMutationResultSchemaFor("format.paragraph.clearDirection"), paragraphMutationFailureSchemaFor("format.paragraph.clearDirection"), (() => {
	const runInputSchema = objectSchema({
		target: objectSchema({
			scope: { const: "docDefaults" },
			channel: { const: "run" }
		}, ["scope", "channel"]),
		patch: buildPatchSchema("run")
	}, ["target", "patch"]);
	const paragraphInputSchema = objectSchema({
		target: objectSchema({
			scope: { const: "docDefaults" },
			channel: { const: "paragraph" }
		}, ["scope", "channel"]),
		patch: buildPatchSchema("paragraph")
	}, ["target", "patch"]);
	const stylesTargetResolutionSchema = objectSchema({
		scope: { const: "docDefaults" },
		channel: { enum: ["run", "paragraph"] },
		xmlPart: { const: "word/styles.xml" },
		xmlPath: { enum: ["w:styles/w:docDefaults/w:rPrDefault/w:rPr", "w:styles/w:docDefaults/w:pPrDefault/w:pPr"] }
	}, [
		"scope",
		"channel",
		"xmlPart",
		"xmlPath"
	]);
	const stylesStateSchema = buildStateSchema();
	const stylesSuccessSchema = objectSchema({
		success: { const: true },
		changed: { type: "boolean" },
		resolution: stylesTargetResolutionSchema,
		dryRun: { type: "boolean" },
		before: stylesStateSchema,
		after: stylesStateSchema
	}, [
		"success",
		"changed",
		"resolution",
		"dryRun",
		"before",
		"after"
	]);
	const stylesFailureSchema = objectSchema({
		success: { const: false },
		resolution: stylesTargetResolutionSchema,
		failure: objectSchema({
			code: { type: "string" },
			message: { type: "string" },
			details: {}
		}, ["code", "message"])
	}, [
		"success",
		"resolution",
		"failure"
	]);
	return {
		input: { oneOf: [runInputSchema, paragraphInputSchema] },
		output: { oneOf: [stylesSuccessSchema, stylesFailureSchema] },
		success: stylesSuccessSchema,
		failure: stylesFailureSchema
	};
})(), (() => {
	const templatesReceiptFailureCodes = [...COMMAND_CATALOG["templates.apply"].possibleFailureCodes];
	const inputSchema = objectSchema({
		source: { oneOf: [objectSchema({
			kind: { const: "path" },
			path: { type: "string" }
		}, ["kind", "path"]), objectSchema({
			kind: { const: "base64" },
			data: { type: "string" },
			filename: { type: "string" }
		}, ["kind", "data"])] },
		bodyPolicy: { const: "preserve" }
	}, ["source"]);
	const scopeReportSchema = objectSchema({
		scope: { enum: [
			"styles",
			"numbering",
			"settings",
			"theme",
			"fontTable",
			"webSettings",
			"headersFooters",
			"sectionDefaults"
		] },
		part: { type: "string" },
		detail: { type: "string" }
	}, ["scope", "part"]);
	const scopeSkipSchema = objectSchema({
		scope: { type: "string" },
		part: { type: "string" },
		reason: { enum: [
			"NOT_PRESENT_IN_SOURCE",
			"OUT_OF_SCOPE",
			"NO_CHANGE",
			"CAPABILITY_UNAVAILABLE"
		] },
		message: { type: "string" }
	}, [
		"scope",
		"reason",
		"message"
	]);
	const unsupportedItemSchema = objectSchema({
		part: { type: "string" },
		category: { type: "string" },
		reason: { type: "string" }
	}, [
		"part",
		"category",
		"reason"
	]);
	const changedPartSchema = objectSchema({
		part: { type: "string" },
		scope: { enum: [
			"styles",
			"numbering",
			"settings",
			"theme",
			"fontTable",
			"webSettings",
			"headersFooters",
			"sectionDefaults",
			"package"
		] },
		change: { enum: [
			"created",
			"replaced",
			"merged",
			"imported"
		] }
	}, [
		"part",
		"scope",
		"change"
	]);
	const idMappingSchema = objectSchema({
		kind: { enum: [
			"style",
			"numbering",
			"relationship"
		] },
		from: { type: "string" },
		to: { type: "string" }
	}, [
		"kind",
		"from",
		"to"
	]);
	const sourceInfoSchema = objectSchema({
		kind: { enum: ["path", "base64"] },
		fingerprint: { type: "string" },
		partCount: { type: "integer" }
	}, [
		"kind",
		"fingerprint",
		"partCount"
	]);
	const warningSchema = objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"]);
	const templatesSuccessSchema = objectSchema({
		success: { const: true },
		changed: { type: "boolean" },
		dryRun: { type: "boolean" },
		bodyPolicy: { const: "preserve" },
		source: sourceInfoSchema,
		detectedScopes: arraySchema(scopeReportSchema),
		appliedScopes: arraySchema(scopeReportSchema),
		skippedScopes: arraySchema(scopeSkipSchema),
		unsupportedItems: arraySchema(unsupportedItemSchema),
		changedParts: arraySchema(changedPartSchema),
		idMappings: objectSchema({
			styles: arraySchema(idMappingSchema),
			numbering: arraySchema(idMappingSchema),
			relationships: arraySchema(idMappingSchema)
		}),
		warnings: arraySchema(warningSchema)
	}, [
		"success",
		"changed",
		"dryRun",
		"bodyPolicy",
		"source",
		"detectedScopes",
		"appliedScopes",
		"skippedScopes",
		"unsupportedItems",
		"changedParts",
		"idMappings",
		"warnings"
	]);
	const templatesFailureSchema = objectSchema({
		success: { const: false },
		failure: objectSchema({
			code: { enum: templatesReceiptFailureCodes },
			message: { type: "string" }
		}, ["code", "message"])
	}, ["success", "failure"]);
	return {
		input: inputSchema,
		output: { oneOf: [templatesSuccessSchema, templatesFailureSchema] },
		success: templatesSuccessSchema,
		failure: templatesFailureSchema
	};
})(), objectSchema({
	in: storyLocatorSchema,
	at: {
		description: "Position: {kind:'documentEnd'} to append, {kind:'documentStart'} to prepend, or {kind:'before'|'after', target:{kind:'block', nodeType:'...', nodeId:'...'}} for relative placement.",
		oneOf: [
			objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
			objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
			objectSchema({
				kind: { const: "before" },
				target: blockNodeAddressSchema
			}, ["kind", "target"]),
			objectSchema({
				kind: { const: "after" },
				target: blockNodeAddressSchema
			}, ["kind", "target"])
		]
	},
	text: {
		type: "string",
		description: "Paragraph text content. Each call creates ONE paragraph. For multiple items (e.g. list items), call superdoc_create separately for each item: do NOT use newlines to put multiple items in one paragraph."
	}
}), createParagraphResultSchemaFor("create.paragraph"), createParagraphFailureSchemaFor("create.paragraph"), objectSchema({
	in: storyLocatorSchema,
	level: {
		...headingLevelSchema,
		description: "Heading level (1-6)."
	},
	at: {
		description: "Position: {kind:'documentEnd'} to append, {kind:'documentStart'} to prepend, or {kind:'before'|'after', target:{kind:'block', nodeType:'...', nodeId:'...'}} for relative placement.",
		oneOf: [
			objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
			objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
			objectSchema({
				kind: { const: "before" },
				target: blockNodeAddressSchema
			}, ["kind", "target"]),
			objectSchema({
				kind: { const: "after" },
				target: blockNodeAddressSchema
			}, ["kind", "target"])
		]
	},
	text: {
		type: "string",
		description: "Heading text content."
	}
}, ["level"]), createHeadingResultSchemaFor("create.heading"), createHeadingFailureSchemaFor("create.heading"), objectSchema({
	at: { oneOf: [
		objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
		objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
		objectSchema({
			kind: { const: "before" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "after" },
			target: blockNodeAddressSchema
		}, ["kind", "target"])
	] },
	breakType: sectionBreakTypeSchema,
	pageMargins: sectionPageMarginsSchema,
	headerFooterMargins: sectionHeaderFooterMarginsSchema
}), createSectionBreakResultSchemaFor("create.sectionBreak"), createSectionBreakFailureSchemaFor("create.sectionBreak"), objectSchema({
	limit: {
		type: "integer",
		minimum: 1
	},
	offset: {
		type: "integer",
		minimum: 0
	}
}), objectSchema({ address: sectionAddressSchema }, ["address"]), objectSchema({
	target: sectionAddressSchema,
	breakType: sectionBreakTypeSchema
}, ["target", "breakType"]), sectionMutationResultSchemaFor("sections.setBreakType"), sectionMutationFailureSchemaFor("sections.setBreakType"), { ...objectSchema({
	target: sectionAddressSchema,
	top: {
		type: "number",
		minimum: 0
	},
	right: {
		type: "number",
		minimum: 0
	},
	bottom: {
		type: "number",
		minimum: 0
	},
	left: {
		type: "number",
		minimum: 0
	},
	gutter: {
		type: "number",
		minimum: 0
	}
}, ["target"]) }, sectionMutationResultSchemaFor("sections.setPageMargins"), sectionMutationFailureSchemaFor("sections.setPageMargins"), { ...objectSchema({
	target: sectionAddressSchema,
	header: {
		type: "number",
		minimum: 0
	},
	footer: {
		type: "number",
		minimum: 0
	}
}, ["target"]) }, sectionMutationResultSchemaFor("sections.setHeaderFooterMargins"), sectionMutationFailureSchemaFor("sections.setHeaderFooterMargins"), { ...objectSchema({
	target: sectionAddressSchema,
	width: {
		type: "number",
		minimum: 0
	},
	height: {
		type: "number",
		minimum: 0
	},
	orientation: sectionOrientationSchema,
	paperSize: {
		type: "string",
		minLength: 1
	}
}, ["target"]) }, sectionMutationResultSchemaFor("sections.setPageSetup"), sectionMutationFailureSchemaFor("sections.setPageSetup"), { ...objectSchema({
	target: sectionAddressSchema,
	count: {
		type: "integer",
		minimum: 1
	},
	gap: {
		type: "number",
		minimum: 0
	},
	equalWidth: { type: "boolean" }
}, ["target"]) }, sectionMutationResultSchemaFor("sections.setColumns"), sectionMutationFailureSchemaFor("sections.setColumns"), objectSchema({
	target: sectionAddressSchema,
	enabled: { type: "boolean" },
	countBy: {
		type: "integer",
		minimum: 1
	},
	start: {
		type: "integer",
		minimum: 1
	},
	distance: {
		type: "number",
		minimum: 0
	},
	restart: sectionLineNumberRestartSchema
}, ["target", "enabled"]), sectionMutationResultSchemaFor("sections.setLineNumbering"), sectionMutationFailureSchemaFor("sections.setLineNumbering"), { ...objectSchema({
	target: sectionAddressSchema,
	start: {
		type: "integer",
		minimum: 1
	},
	format: sectionPageNumberFormatSchema,
	chapterStyle: {
		type: "integer",
		minimum: 1
	},
	chapterSeparator: {
		type: "string",
		enum: [
			"hyphen",
			"period",
			"colon",
			"emDash",
			"enDash"
		]
	}
}, ["target"]) }, sectionMutationResultSchemaFor("sections.setPageNumbering"), sectionMutationFailureSchemaFor("sections.setPageNumbering"), objectSchema({
	target: sectionAddressSchema,
	enabled: { type: "boolean" }
}, ["target", "enabled"]), sectionMutationResultSchemaFor("sections.setTitlePage"), sectionMutationFailureSchemaFor("sections.setTitlePage"), objectSchema({ enabled: { type: "boolean" } }, ["enabled"]), documentMutationResultSchemaFor("sections.setOddEvenHeadersFooters"), sectionMutationFailureSchemaFor("sections.setOddEvenHeadersFooters"), objectSchema({
	target: sectionAddressSchema,
	value: sectionVerticalAlignSchema
}, ["target", "value"]), sectionMutationResultSchemaFor("sections.setVerticalAlign"), sectionMutationFailureSchemaFor("sections.setVerticalAlign"), objectSchema({
	target: sectionAddressSchema,
	direction: sectionDirectionSchema
}, ["target", "direction"]), sectionMutationResultSchemaFor("sections.setSectionDirection"), sectionMutationFailureSchemaFor("sections.setSectionDirection"), objectSchema({
	target: sectionAddressSchema,
	kind: sectionHeaderFooterKindSchema,
	variant: sectionHeaderFooterVariantSchema,
	refId: {
		type: "string",
		minLength: 1
	}
}, [
	"target",
	"kind",
	"variant",
	"refId"
]), sectionMutationResultSchemaFor("sections.setHeaderFooterRef"), sectionMutationFailureSchemaFor("sections.setHeaderFooterRef"), objectSchema({
	target: sectionAddressSchema,
	kind: sectionHeaderFooterKindSchema,
	variant: sectionHeaderFooterVariantSchema
}, [
	"target",
	"kind",
	"variant"
]), sectionMutationResultSchemaFor("sections.clearHeaderFooterRef"), sectionMutationFailureSchemaFor("sections.clearHeaderFooterRef"), objectSchema({
	target: sectionAddressSchema,
	kind: sectionHeaderFooterKindSchema,
	variant: sectionHeaderFooterVariantSchema,
	linked: { type: "boolean" }
}, [
	"target",
	"kind",
	"variant",
	"linked"
]), sectionMutationResultSchemaFor("sections.setLinkToPrevious"), sectionMutationFailureSchemaFor("sections.setLinkToPrevious"), objectSchema({
	target: sectionAddressSchema,
	borders: sectionPageBordersSchema
}, ["target", "borders"]), sectionMutationResultSchemaFor("sections.setPageBorders"), sectionMutationFailureSchemaFor("sections.setPageBorders"), objectSchema({ target: sectionAddressSchema }, ["target"]), sectionMutationResultSchemaFor("sections.clearPageBorders"), sectionMutationFailureSchemaFor("sections.clearPageBorders"), objectSchema({
	within: blockNodeAddressSchema,
	limit: { type: "integer" },
	offset: { type: "integer" },
	kind: listKindSchema,
	level: { type: "integer" },
	ordinal: { type: "integer" }
}), objectSchema({ address: listItemAddressSchema }, ["address"]), objectSchema({
	target: {
		...listItemAddressSchema,
		description: "The target list item. For 'insert': the item to insert relative to. For 'create' with mode 'fromParagraphs': use nodeType 'paragraph' instead. Format: {kind:'block', nodeType:'listItem', nodeId:'<id>'}."
	},
	position: {
		...listInsertPositionSchema,
		description: "Required. Insert position relative to target: 'before' or 'after'."
	},
	text: {
		type: "string",
		description: "Text content for the new list item."
	}
}, ["target", "position"]), listsInsertResultSchemaFor("lists.insert"), listsFailureSchemaFor("lists.insert"), { ...ref("BlockAddress") }, { ...ref("BlockAddressOrRange") }, { ...listKindSchema }, objectSchema({
	version: { const: 1 },
	levels: arraySchema(objectSchema({
		level: {
			type: "integer",
			minimum: 0,
			maximum: 8
		},
		numFmt: { type: "string" },
		lvlText: { type: "string" },
		start: { type: "integer" },
		alignment: { enum: [
			"left",
			"center",
			"right"
		] },
		indents: objectSchema({
			left: { type: "integer" },
			hanging: { type: "integer" },
			firstLine: { type: "integer" }
		}),
		trailingCharacter: { enum: [
			"tab",
			"space",
			"nothing"
		] },
		markerFont: { type: "string" },
		pictureBulletId: { type: "integer" },
		tabStopAt: { type: ["integer", "null"] }
	}, ["level"]))
}, ["version", "levels"]), objectSchema({
	mode: { const: "new" },
	startAt: {
		type: "integer",
		minimum: 1
	}
}, ["mode"]), objectSchema({ mode: { const: "continuePrevious" } }, ["mode"]), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	item: listItemAddressSchema
}, [
	"success",
	"listId",
	"item"
]), listsFailureSchemaFor("lists.create"), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	item: listItemAddressSchema
}, [
	"success",
	"listId",
	"item"
]), listsFailureSchemaFor("lists.create"), objectSchema({
	target: ref("BlockAddressOrRange"),
	attachTo: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	}
}, ["target", "attachTo"]), listsMutateItemResultSchemaFor("lists.attach"), listsFailureSchemaFor("lists.attach"), objectSchema({ target: listItemAddressSchema }, ["target"]), objectSchema({
	success: { const: true },
	paragraph: ref("ParagraphAddress")
}, ["success", "paragraph"]), listsFailureSchemaFor("lists.detach"), objectSchema({
	success: { const: true },
	paragraph: ref("ParagraphAddress")
}, ["success", "paragraph"]), listsFailureSchemaFor("lists.detach"), objectSchema({ target: listItemAddressSchema }, ["target"]), objectSchema({
	success: { const: true },
	deletedCount: {
		type: "integer",
		minimum: 0
	}
}, ["success", "deletedCount"]), listsFailureSchemaFor("lists.delete"), objectSchema({
	success: { const: true },
	deletedCount: {
		type: "integer",
		minimum: 0
	}
}, ["success", "deletedCount"]), listsFailureSchemaFor("lists.delete"), objectSchema({ target: listItemAddressSchema }, ["target"]), listsMutateItemResultSchemaFor("lists.indent"), listsFailureSchemaFor("lists.indent"), objectSchema({ target: listItemAddressSchema }, ["target"]), listsMutateItemResultSchemaFor("lists.outdent"), listsFailureSchemaFor("lists.outdent"), objectSchema({
	target: listItemAddressSchema,
	direction: { enum: ["withPrevious", "withNext"] }
}, ["target", "direction"]), objectSchema({
	success: { const: true },
	listId: { type: "string" }
}, ["success", "listId"]), listsFailureSchemaFor("lists.join"), objectSchema({
	success: { const: true },
	listId: { type: "string" }
}, ["success", "listId"]), listsFailureSchemaFor("lists.join"), objectSchema({
	target: listItemAddressSchema,
	direction: { enum: ["withPrevious", "withNext"] }
}, ["target", "direction"]), objectSchema({
	canJoin: { type: "boolean" },
	reason: { enum: [
		"NO_ADJACENT_SEQUENCE",
		"INCOMPATIBLE_DEFINITIONS",
		"ALREADY_SAME_SEQUENCE"
	] },
	adjacentListId: { type: "string" }
}, ["canJoin"]), objectSchema({
	target: listItemAddressSchema,
	copyOverrides: { type: "boolean" }
}, ["target"]), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	numId: { type: "integer" }
}, [
	"success",
	"listId",
	"numId"
]), listsFailureSchemaFor("lists.separate"), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	numId: { type: "integer" }
}, [
	"success",
	"listId",
	"numId"
]), listsFailureSchemaFor("lists.separate"), objectSchema({
	target: listItemAddressSchema,
	direction: { enum: ["withPrevious", "withNext"] }
}, ["target", "direction"]), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	absorbedCount: { type: "integer" },
	removedEmptyBlocks: { type: "integer" }
}, [
	"success",
	"listId",
	"absorbedCount",
	"removedEmptyBlocks"
]), listsFailureSchemaFor("lists.merge"), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	absorbedCount: { type: "integer" },
	removedEmptyBlocks: { type: "integer" }
}, [
	"success",
	"listId",
	"absorbedCount",
	"removedEmptyBlocks"
]), listsFailureSchemaFor("lists.merge"), objectSchema({
	target: listItemAddressSchema,
	restartNumbering: { type: "boolean" }
}, ["target"]), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	numId: { type: "integer" },
	restartedAt: { type: ["integer", "null"] }
}, [
	"success",
	"listId",
	"numId",
	"restartedAt"
]), listsFailureSchemaFor("lists.split"), objectSchema({
	success: { const: true },
	listId: { type: "string" },
	numId: { type: "integer" },
	restartedAt: { type: ["integer", "null"] }
}, [
	"success",
	"listId",
	"numId",
	"restartedAt"
]), listsFailureSchemaFor("lists.split"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	}
}, ["target", "level"]), listsMutateItemResultSchemaFor("lists.setLevel"), listsFailureSchemaFor("lists.setLevel"), objectSchema({
	target: listItemAddressSchema,
	value: { type: ["integer", "null"] }
}, ["target", "value"]), listsMutateItemResultSchemaFor("lists.setValue"), listsFailureSchemaFor("lists.setValue"), objectSchema({ target: listItemAddressSchema }, ["target"]), listsMutateItemResultSchemaFor("lists.continuePrevious"), listsFailureSchemaFor("lists.continuePrevious"), objectSchema({ target: listItemAddressSchema }, ["target"]), objectSchema({
	canContinue: { type: "boolean" },
	reason: { enum: [
		"NO_PREVIOUS_LIST",
		"INCOMPATIBLE_DEFINITIONS",
		"ALREADY_CONTINUOUS"
	] },
	previousListId: { type: "string" }
}, ["canContinue"]), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	restartAfterLevel: { type: ["integer", "null"] },
	scope: { enum: ["definition", "instance"] }
}, [
	"target",
	"level",
	"restartAfterLevel"
]), listsMutateItemResultSchemaFor("lists.setLevelRestart"), listsFailureSchemaFor("lists.setLevelRestart"), objectSchema({
	target: listItemAddressSchema,
	includeMarker: { type: "boolean" }
}, ["target"]), objectSchema({
	success: { const: true },
	paragraph: ref("ParagraphAddress")
}, ["success", "paragraph"]), listsFailureSchemaFor("lists.convertToText"), objectSchema({
	success: { const: true },
	paragraph: ref("ParagraphAddress")
}, ["success", "paragraph"]), listsFailureSchemaFor("lists.convertToText"), objectSchema({
	target: listItemAddressSchema,
	template: objectSchema({
		version: { const: 1 },
		levels: arraySchema(objectSchema({
			level: {
				type: "integer",
				minimum: 0,
				maximum: 8
			},
			numFmt: { type: "string" },
			lvlText: { type: "string" },
			start: { type: "integer" },
			alignment: { enum: [
				"left",
				"center",
				"right"
			] },
			indents: objectSchema({
				left: { type: "integer" },
				hanging: { type: "integer" },
				firstLine: { type: "integer" }
			}),
			trailingCharacter: { enum: [
				"tab",
				"space",
				"nothing"
			] },
			markerFont: { type: "string" },
			pictureBulletId: { type: "integer" }
		}, ["level"]))
	}, ["version", "levels"]),
	levels: arraySchema({
		type: "integer",
		minimum: 0,
		maximum: 8
	})
}, ["target", "template"]), listsMutateItemResultSchemaFor("lists.applyTemplate"), listsFailureSchemaFor("lists.applyTemplate"), objectSchema({
	target: listItemAddressSchema,
	preset: { enum: [
		"decimal",
		"decimalParenthesis",
		"lowerLetter",
		"upperLetter",
		"lowerRoman",
		"upperRoman",
		"disc",
		"circle",
		"square",
		"dash"
	] },
	levels: arraySchema({
		type: "integer",
		minimum: 0,
		maximum: 8
	})
}, ["target", "preset"]), listsMutateItemResultSchemaFor("lists.applyPreset"), listsFailureSchemaFor("lists.applyPreset"), objectSchema({
	target: listItemAddressSchema,
	kind: { enum: ["ordered", "bullet"] },
	continuity: {
		enum: ["preserve", "none"],
		description: "Numbering continuity: 'preserve' keeps numbering; 'none' restarts."
	}
}, ["target", "kind"]), listsMutateItemResultSchemaFor("lists.setType"), listsFailureSchemaFor("lists.setType"), (() => {
	const successSchema = objectSchema({
		success: { const: true },
		template: objectSchema({
			version: { const: 1 },
			levels: arraySchema(objectSchema({
				level: {
					type: "integer",
					minimum: 0,
					maximum: 8
				},
				numFmt: { type: "string" },
				lvlText: { type: "string" },
				start: { type: "integer" },
				alignment: { enum: [
					"left",
					"center",
					"right"
				] },
				indents: objectSchema({
					left: { type: "integer" },
					hanging: { type: "integer" },
					firstLine: { type: "integer" }
				}),
				trailingCharacter: { enum: [
					"tab",
					"space",
					"nothing"
				] },
				markerFont: { type: "string" },
				pictureBulletId: { type: "integer" }
			}, ["level"]))
		}, ["version", "levels"])
	}, ["success", "template"]);
	return {
		input: objectSchema({
			target: listItemAddressSchema,
			levels: arraySchema({
				type: "integer",
				minimum: 0,
				maximum: 8
			})
		}, ["target"]),
		output: { oneOf: [successSchema, listsFailureSchemaFor("lists.captureTemplate")] },
		success: successSchema,
		failure: listsFailureSchemaFor("lists.captureTemplate")
	};
})(), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	numFmt: { type: "string" },
	lvlText: { type: "string" },
	start: { type: "integer" }
}, [
	"target",
	"level",
	"numFmt",
	"lvlText"
]), listsMutateItemResultSchemaFor("lists.setLevelNumbering"), listsFailureSchemaFor("lists.setLevelNumbering"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	markerText: { type: "string" }
}, [
	"target",
	"level",
	"markerText"
]), listsMutateItemResultSchemaFor("lists.setLevelBullet"), listsFailureSchemaFor("lists.setLevelBullet"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	pictureBulletId: { type: "integer" }
}, [
	"target",
	"level",
	"pictureBulletId"
]), listsMutateItemResultSchemaFor("lists.setLevelPictureBullet"), listsFailureSchemaFor("lists.setLevelPictureBullet"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	alignment: { enum: [
		"left",
		"center",
		"right"
	] }
}, [
	"target",
	"level",
	"alignment"
]), listsMutateItemResultSchemaFor("lists.setLevelAlignment"), listsFailureSchemaFor("lists.setLevelAlignment"), listsMutateItemResultSchemaFor("lists.setLevelIndents"), listsFailureSchemaFor("lists.setLevelIndents"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	trailingCharacter: { enum: [
		"tab",
		"space",
		"nothing"
	] }
}, [
	"target",
	"level",
	"trailingCharacter"
]), listsMutateItemResultSchemaFor("lists.setLevelTrailingCharacter"), listsFailureSchemaFor("lists.setLevelTrailingCharacter"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	fontFamily: { type: "string" }
}, [
	"target",
	"level",
	"fontFamily"
]), listsMutateItemResultSchemaFor("lists.setLevelMarkerFont"), listsFailureSchemaFor("lists.setLevelMarkerFont"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	}
}, ["target", "level"]), listsMutateItemResultSchemaFor("lists.clearLevelOverrides"), listsFailureSchemaFor("lists.clearLevelOverrides"), (() => {
	const successSchema = objectSchema({
		success: { const: true },
		style: objectSchema({
			version: { const: 1 },
			levels: arraySchema(objectSchema({
				level: {
					type: "integer",
					minimum: 0,
					maximum: 8
				},
				numFmt: { type: "string" },
				lvlText: { type: "string" },
				start: { type: "integer" },
				alignment: { enum: [
					"left",
					"center",
					"right"
				] },
				indents: objectSchema({
					left: { type: "integer" },
					hanging: { type: "integer" },
					firstLine: { type: "integer" }
				}),
				trailingCharacter: { enum: [
					"tab",
					"space",
					"nothing"
				] },
				markerFont: { type: "string" },
				pictureBulletId: { type: "integer" },
				tabStopAt: { type: ["integer", "null"] }
			}, ["level"]))
		}, ["version", "levels"])
	}, ["success", "style"]);
	return {
		input: objectSchema({
			target: listItemAddressSchema,
			levels: arraySchema({
				type: "integer",
				minimum: 0,
				maximum: 8
			})
		}, ["target"]),
		output: { oneOf: [successSchema, listsFailureSchemaFor("lists.getStyle")] },
		success: successSchema,
		failure: listsFailureSchemaFor("lists.getStyle")
	};
})(), objectSchema({
	target: listItemAddressSchema,
	style: objectSchema({
		version: { const: 1 },
		levels: arraySchema(objectSchema({
			level: {
				type: "integer",
				minimum: 0,
				maximum: 8
			},
			numFmt: { type: "string" },
			lvlText: { type: "string" },
			start: { type: "integer" },
			alignment: { enum: [
				"left",
				"center",
				"right"
			] },
			indents: objectSchema({
				left: { type: "integer" },
				hanging: { type: "integer" },
				firstLine: { type: "integer" }
			}),
			trailingCharacter: { enum: [
				"tab",
				"space",
				"nothing"
			] },
			markerFont: { type: "string" },
			pictureBulletId: { type: "integer" },
			tabStopAt: { type: ["integer", "null"] }
		}, ["level"]))
	}, ["version", "levels"]),
	levels: arraySchema({
		type: "integer",
		minimum: 0,
		maximum: 8
	})
}, ["target", "style"]), listsMutateItemResultSchemaFor("lists.applyStyle"), listsFailureSchemaFor("lists.applyStyle"), objectSchema({
	target: listItemAddressSchema,
	startAt: {
		type: "integer",
		minimum: 1
	}
}, ["target", "startAt"]), listsMutateItemResultSchemaFor("lists.restartAt"), listsFailureSchemaFor("lists.restartAt"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	numberStyle: { type: "string" }
}, [
	"target",
	"level",
	"numberStyle"
]), listsMutateItemResultSchemaFor("lists.setLevelNumberStyle"), listsFailureSchemaFor("lists.setLevelNumberStyle"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	text: { type: "string" }
}, [
	"target",
	"level",
	"text"
]), listsMutateItemResultSchemaFor("lists.setLevelText"), listsFailureSchemaFor("lists.setLevelText"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	startAt: {
		type: "integer",
		minimum: 1
	}
}, [
	"target",
	"level",
	"startAt"
]), listsMutateItemResultSchemaFor("lists.setLevelStart"), listsFailureSchemaFor("lists.setLevelStart"), objectSchema({
	target: listItemAddressSchema,
	level: {
		type: "integer",
		minimum: 0,
		maximum: 8
	},
	layout: objectSchema({
		alignment: { enum: [
			"left",
			"center",
			"right"
		] },
		alignedAt: { type: "integer" },
		textIndentAt: { type: "integer" },
		followCharacter: { enum: [
			"tab",
			"space",
			"nothing"
		] },
		tabStopAt: { type: ["integer", "null"] }
	})
}, [
	"target",
	"level",
	"layout"
]), listsMutateItemResultSchemaFor("lists.setLevelLayout"), listsFailureSchemaFor("lists.setLevelLayout"), objectSchema({
	text: {
		type: "string",
		description: "Comment text content."
	},
	target: {
		oneOf: [
			textAddressSchema,
			textTargetSchema,
			selectionTargetSchema,
			commentTrackedChangeTargetSchema
		],
		description: "Comment target. Accepts a TextAddress, TextTarget, SelectionTarget, or {trackedChangeId, kind?:'trackedChange'} to anchor directly on tracked content."
	},
	parentCommentId: {
		type: "string",
		description: "Parent comment ID for creating a threaded reply."
	}
}, ["text"]), commentsCreateResultSchemaFor("comments.create"), receiptFailureResultSchemaFor("comments.create"), objectSchema({
	commentId: { type: "string" },
	text: {
		type: "string",
		description: "Updated comment text."
	},
	target: { oneOf: [
		textAddressSchema,
		textTargetSchema,
		selectionTargetSchema,
		commentTrackedChangeTargetSchema
	] },
	status: {
		enum: ["resolved", "active"],
		description: "Set comment status. Use 'resolved' to resolve a comment, or 'active' to reopen a previously resolved comment (lifecycle inverse)."
	},
	isInternal: {
		type: "boolean",
		description: "When true, marks the comment as internal (hidden from external collaborators)."
	}
}, ["commentId"]), receiptResultSchemaFor("comments.patch"), receiptFailureResultSchemaFor("comments.patch"), objectSchema({ commentId: { type: "string" } }, ["commentId"]), receiptResultSchemaFor("comments.delete"), receiptFailureResultSchemaFor("comments.delete"), objectSchema({ commentId: { type: "string" } }, ["commentId"]), objectSchema({
	includeResolved: {
		type: "boolean",
		description: "When true, includes resolved comments in results. Default: false."
	},
	limit: {
		type: "integer",
		description: "Maximum number of comments to return."
	},
	offset: {
		type: "integer",
		description: "Number of comments to skip for pagination."
	}
}), objectSchema({
	limit: {
		type: "integer",
		description: "Maximum number of tracked changes to return."
	},
	offset: {
		type: "integer",
		description: "Number of tracked changes to skip for pagination."
	},
	type: {
		enum: [...trackChangeTypeValues],
		description: "Filter by change type: 'insert', 'delete', 'replacement', or 'format'."
	},
	in: {
		oneOf: [storyLocatorSchema, { const: "all" }],
		description: "Story scope. Omit for body only, pass a StoryLocator for a single story, or 'all' for body + every revision-capable non-body story."
	}
}), objectSchema({
	id: { type: "string" },
	story: storyLocatorSchema
}, ["id"]), objectSchema({
	id: { type: "string" },
	story: storyLocatorSchema,
	range: {
		type: "object",
		description: "Partial-range qualifier on an id target. Rejected with INVALID_INPUT for indivisible (e.g. structural) revisions."
	}
}, ["id"]), objectSchema({
	kind: { const: "range" },
	range: textTargetSchema,
	story: storyLocatorSchema,
	part: {
		type: "string",
		description: "Optional part discriminator for the range target."
	}
}, ["kind", "range"]), objectSchema({
	scope: { enum: ["all"] },
	story: {
		oneOf: [storyLocatorSchema, { const: "all" }],
		description: "Optional explicit bulk filter. Omit or pass 'all' to target every revision-capable story, or pass a StoryLocator to scope the decision to one story."
	}
}, ["scope"]), receiptResultSchemaFor("trackChanges.decide"), receiptFailureResultSchemaFor("trackChanges.decide"), objectSchema({
	in: storyLocatorSchema,
	select: {
		description: "Search selector. Use {type:'text', pattern:'...'} for text search or {type:'node', nodeType:'paragraph'|'heading'|...} for node search.",
		oneOf: [textSelectorSchema, nodeSelectorSchema]
	},
	within: {
		...blockNodeAddressSchema,
		description: "Limit search scope to within a specific block: {kind:'block', nodeType:'...', nodeId:'...'}."
	},
	require: {
		enum: [
			"any",
			"first",
			"exactlyOne",
			"all"
		],
		description: "Match cardinality: 'any' (all matches), 'first' (only first), 'exactlyOne' (fail if != 1), 'all' (fail if 0)."
	},
	mode: {
		enum: ["strict", "candidates"],
		description: "Search mode: 'strict' (default, exact matching) or 'candidates' (returns scored potential matches)."
	},
	includeNodes: {
		type: "boolean",
		description: "When true, includes full node data in results. Default: false."
	},
	limit: {
		type: "integer",
		minimum: 1,
		description: "Maximum number of matches to return."
	},
	offset: {
		type: "integer",
		minimum: 0,
		description: "Number of matches to skip for pagination."
	}
}, ["select"]), (() => {
	const textMatchItemSchema = discoveryItemSchema({
		matchKind: { const: "text" },
		address: blockNodeAddressSchema,
		target: selectionTargetSchema,
		snippet: { type: "string" },
		highlightRange: rangeSchema,
		blocks: {
			type: "array",
			items: matchBlockSchema,
			minItems: 1
		}
	}, [
		"matchKind",
		"address",
		"target",
		"snippet",
		"highlightRange",
		"blocks"
	]);
	const nodeMatchItemSchema = discoveryItemSchema({
		matchKind: { const: "node" },
		address: nodeAddressSchema,
		blocks: {
			type: "array",
			items: matchBlockSchema,
			maxItems: 0
		}
	}, [
		"matchKind",
		"address",
		"blocks"
	]);
	const queryMatchMetaSchema = objectSchema({ effectiveResolved: { type: "boolean" } }, ["effectiveResolved"]);
	return discoveryResultSchema({ oneOf: [textMatchItemSchema, nodeMatchItemSchema] }, queryMatchMetaSchema);
})(), { ...(() => {
	const selectWhereSchema = objectSchema({
		by: {
			const: "select",
			type: "string"
		},
		select: { oneOf: [textSelectorSchema, nodeSelectorSchema] },
		within: blockNodeAddressSchema,
		require: { enum: [
			"first",
			"exactlyOne",
			"all"
		] }
	}, [
		"by",
		"select",
		"require"
	]);
	const refWhereSchema = objectSchema({
		by: {
			const: "ref",
			type: "string"
		},
		ref: { type: "string" },
		within: blockNodeAddressSchema
	}, ["by", "ref"]);
	const targetWhereSchema = objectSchema({
		by: {
			const: "target",
			type: "string"
		},
		target: selectionTargetSchema
	}, ["by", "target"]);
	const blockWhereSchema = objectSchema({
		by: {
			const: "block",
			type: "string"
		},
		nodeType: { enum: [...blockNodeTypeValues] },
		nodeId: { type: "string" }
	}, [
		"by",
		"nodeType",
		"nodeId"
	]);
	const stepWhereSchema = { oneOf: [
		selectWhereSchema,
		refWhereSchema,
		targetWhereSchema,
		blockWhereSchema
	] };
	const insertWhereSchema = { oneOf: [
		objectSchema({
			by: {
				const: "select",
				type: "string"
			},
			select: { oneOf: [textSelectorSchema, nodeSelectorSchema] },
			within: blockNodeAddressSchema,
			require: { enum: ["first", "exactlyOne"] }
		}, [
			"by",
			"select",
			"require"
		]),
		refWhereSchema,
		targetWhereSchema,
		blockWhereSchema
	] };
	const assertWhereSchema = objectSchema({
		by: {
			const: "select",
			type: "string"
		},
		select: { oneOf: [textSelectorSchema, nodeSelectorSchema] },
		within: blockNodeAddressSchema
	}, ["by", "select"]);
	const replacementBlockSchema = objectSchema({ text: { type: "string" } }, ["text"]);
	const replacementPayloadSchema = { oneOf: [objectSchema({ text: { type: "string" } }, ["text"]), objectSchema({ blocks: arraySchema(replacementBlockSchema) }, ["blocks"])] };
	const inlineDirectiveSchema = { enum: [...INLINE_DIRECTIVES] };
	const setMarksSchema = objectSchema({
		bold: inlineDirectiveSchema,
		italic: inlineDirectiveSchema,
		underline: inlineDirectiveSchema,
		strike: inlineDirectiveSchema
	});
	const stylePolicySchema = objectSchema({
		inline: objectSchema({
			mode: {
				enum: [
					"preserve",
					"set",
					"clear",
					"merge"
				],
				type: "string"
			},
			requireUniform: { type: "boolean" },
			onNonUniform: { enum: [
				"error",
				"useLeadingRun",
				"majority",
				"union"
			] },
			setMarks: setMarksSchema
		}, ["mode"]),
		paragraph: objectSchema({ mode: {
			enum: [
				"preserve",
				"set",
				"clear"
			],
			type: "string"
		} }, ["mode"])
	}, ["inline"]);
	const insertStylePolicySchema = objectSchema({ inline: objectSchema({
		mode: {
			enum: [
				"inherit",
				"set",
				"clear"
			],
			type: "string"
		},
		setMarks: setMarksSchema
	}, ["mode"]) }, ["inline"]);
	const mutationsInputSchema = objectSchema({
		in: storyLocatorSchema,
		expectedRevision: {
			type: "string",
			description: "Document revision for optimistic concurrency. Mutation fails if document was modified since this revision."
		},
		atomic: {
			const: true,
			type: "boolean",
			description: "Must be true. All steps execute as one atomic transaction."
		},
		changeMode: {
			enum: ["direct", "tracked"],
			description: "Required. Use 'direct' for immediate edits or 'tracked' for suggestions. Must always be provided."
		},
		steps: {
			...arraySchema({ oneOf: [
				objectSchema({
					id: { type: "string" },
					op: {
						const: "text.rewrite",
						type: "string"
					},
					where: stepWhereSchema,
					args: objectSchema({
						replacement: replacementPayloadSchema,
						style: stylePolicySchema
					}, ["replacement"])
				}, [
					"id",
					"op",
					"where",
					"args"
				]),
				objectSchema({
					id: { type: "string" },
					op: {
						const: "text.insert",
						type: "string"
					},
					where: insertWhereSchema,
					args: objectSchema({
						position: { enum: ["before", "after"] },
						content: objectSchema({ text: { type: "string" } }, ["text"]),
						style: insertStylePolicySchema
					}, ["position", "content"])
				}, [
					"id",
					"op",
					"where",
					"args"
				]),
				objectSchema({
					id: { type: "string" },
					op: {
						const: "text.delete",
						type: "string"
					},
					where: stepWhereSchema,
					args: objectSchema({ behavior: deleteBehaviorSchema })
				}, [
					"id",
					"op",
					"where",
					"args"
				]),
				objectSchema({
					id: { type: "string" },
					op: {
						const: "format.apply",
						type: "string"
					},
					where: stepWhereSchema,
					args: {
						...objectSchema({
							inline: buildInlineRunPatchSchema(),
							alignment: {
								type: "string",
								enum: [
									"left",
									"center",
									"right",
									"justify"
								],
								description: "Set paragraph alignment on the target block(s). Can be combined with inline formatting in the same step."
							},
							scope: {
								type: "string",
								enum: ["match", "block"],
								description: "When \"block\", inline formatting expands to cover the entire parent paragraph(s), not just the matched text. Use \"block\" after markdown inserts to format whole paragraphs with a short identifying pattern. Default: \"match\"."
							}
						}, []),
						minProperties: 1
					}
				}, [
					"id",
					"op",
					"where",
					"args"
				]),
				objectSchema({
					id: { type: "string" },
					op: {
						const: "assert",
						type: "string"
					},
					where: assertWhereSchema,
					args: objectSchema({ expectCount: { type: "number" } }, ["expectCount"])
				}, [
					"id",
					"op",
					"where",
					"args"
				])
			] }),
			description: "Ordered array of mutation steps. Each step needs 'op' (text.rewrite, text.insert, text.delete, format.apply, or assert) and a 'where' targeting clause."
		}
	}, [
		"atomic",
		"changeMode",
		"steps"
	]);
	const rangeAnchorSchema = { oneOf: [
		objectSchema({
			kind: { const: "document" },
			edge: { enum: ["start", "end"] }
		}, ["kind", "edge"]),
		objectSchema({
			kind: { const: "point" },
			point: ref("SelectionPoint")
		}, ["kind", "point"]),
		objectSchema({
			kind: { const: "ref" },
			ref: {
				type: "string",
				minLength: 1
			},
			boundary: { enum: ["start", "end"] }
		}, [
			"kind",
			"ref",
			"boundary"
		])
	] };
	const rangePreviewSchema = objectSchema({
		text: { type: "string" },
		truncated: { type: "boolean" },
		blocks: arraySchema(objectSchema({
			nodeId: { type: "string" },
			nodeType: { enum: [...blockNodeTypeValues] },
			textPreview: { type: "string" }
		}, [
			"nodeId",
			"nodeType",
			"textPreview"
		]))
	}, [
		"text",
		"truncated",
		"blocks"
	]);
	const resolveRangeOutputSchema = objectSchema({
		evaluatedRevision: { type: "string" },
		handle: objectSchema({
			ref: { oneOf: [{ type: "string" }, { type: "null" }] },
			refStability: { const: "ephemeral" },
			coversFullTarget: { type: "boolean" }
		}, [
			"ref",
			"refStability",
			"coversFullTarget"
		]),
		target: selectionTargetSchema,
		preview: rangePreviewSchema
	}, [
		"evaluatedRevision",
		"handle",
		"target",
		"preview"
	]);
	return {
		"ranges.resolve": {
			input: objectSchema({
				start: rangeAnchorSchema,
				end: rangeAnchorSchema,
				expectedRevision: { type: "string" }
			}, ["start", "end"]),
			output: resolveRangeOutputSchema
		},
		"selection.current": {
			input: objectSchema({ includeText: { type: "boolean" } }, []),
			output: objectSchema({
				empty: { type: "boolean" },
				target: { oneOf: [textTargetSchema, { type: "null" }] },
				activeMarks: arraySchema({ type: "string" }),
				activeCommentIds: arraySchema({ type: "string" }),
				activeChangeIds: arraySchema({ type: "string" }),
				text: { type: "string" }
			}, [
				"empty",
				"target",
				"activeMarks",
				"activeCommentIds",
				"activeChangeIds"
			])
		},
		"mutations.preview": {
			input: mutationsInputSchema,
			output: objectSchema({
				evaluatedRevision: { type: "string" },
				steps: arraySchema({ type: "object" }),
				valid: { type: "boolean" },
				failures: arraySchema({ type: "object" })
			}, [
				"evaluatedRevision",
				"steps",
				"valid"
			])
		},
		"mutations.apply": {
			input: mutationsInputSchema,
			output: objectSchema({
				success: { const: true },
				revision: objectSchema({
					before: { type: "string" },
					after: { type: "string" }
				}, ["before", "after"]),
				steps: arraySchema({ type: "object" }),
				trackedChanges: arraySchema({ type: "object" }),
				timing: objectSchema({ totalMs: { type: "number" } }, ["totalMs"])
			}, [
				"success",
				"revision",
				"steps",
				"timing"
			]),
			success: objectSchema({
				success: { const: true },
				revision: objectSchema({
					before: { type: "string" },
					after: { type: "string" }
				}, ["before", "after"]),
				steps: arraySchema({ type: "object" }),
				timing: objectSchema({ totalMs: { type: "number" } }, ["totalMs"])
			}, [
				"success",
				"revision",
				"steps",
				"timing"
			]),
			failure: preApplyFailureResultSchemaFor("mutations.apply")
		}
	};
})() }, objectSchema({
	rows: {
		type: "integer",
		minimum: 1
	},
	columns: {
		type: "integer",
		minimum: 1
	},
	at: tableCreateLocationSchema
}, ["rows", "columns"]), { ...objectSchema({
	target: blockNodeAddressSchema,
	nodeId: { type: "string" },
	delimiter: { oneOf: [{ enum: [
		"tab",
		"comma",
		"paragraph"
	] }, objectSchema({ custom: {
		type: "string",
		minLength: 1,
		maxLength: 1
	} }, ["custom"])] },
	columns: {
		type: "integer",
		minimum: 1
	},
	inferColumns: { type: "boolean" }
}) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	destination: tableCreateLocationSchema
}, ["destination"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	rowIndex: {
		type: "integer",
		minimum: 1
	}
}, ["rowIndex"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	delimiter: { enum: [
		"tab",
		"comma",
		"paragraph"
	] }
}) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	preferredWidth: { type: "number" },
	alignment: { enum: [
		"left",
		"center",
		"right"
	] },
	leftIndentPt: { type: "number" },
	autoFitMode: { enum: [
		"fixedWidth",
		"fitContents",
		"fitWindow"
	] },
	tableDirection: { enum: ["ltr", "rtl"] }
}) }, objectSchema({
	target: tableRowAddressSchema,
	position: { enum: ["above", "below"] },
	count: {
		type: "integer",
		minimum: 1
	}
}, ["target", "position"]), objectSchema({
	target: tableAddressSchema,
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	position: { enum: ["above", "below"] },
	count: {
		type: "integer",
		minimum: 1
	}
}, [
	"target",
	"rowIndex",
	"position"
]), objectSchema({
	nodeId: { type: "string" },
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	position: { enum: ["above", "below"] },
	count: {
		type: "integer",
		minimum: 1
	}
}, [
	"nodeId",
	"rowIndex",
	"position"
]), { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	count: {
		type: "integer",
		minimum: 1
	}
}, []) }, rowOperationInputSchema({}), rowOperationInputSchema({
	heightPt: {
		type: "number",
		exclusiveMinimum: 0
	},
	rule: { enum: [
		"atLeast",
		"exact",
		"auto"
	] }
}, ["heightPt", "rule"]), rowOperationInputSchema({
	allowBreakAcrossPages: { type: "boolean" },
	repeatHeader: { type: "boolean" }
}), { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	columnIndex: {
		type: "integer",
		minimum: 0
	},
	position: { enum: [
		"left",
		"right",
		"first",
		"last"
	] },
	count: {
		type: "integer",
		minimum: 1
	}
}, ["position"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	columnIndex: {
		type: "integer",
		minimum: 0
	}
}, ["columnIndex"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	columnIndex: {
		type: "integer",
		minimum: 0
	},
	widthPt: {
		type: "number",
		exclusiveMinimum: 0
	}
}, ["columnIndex", "widthPt"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	columnRange: objectSchema({
		start: {
			type: "integer",
			minimum: 0
		},
		end: {
			type: "integer",
			minimum: 0
		}
	}, ["start", "end"])
}) }, { ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" },
	mode: { enum: ["shiftRight", "shiftDown"] }
}, ["mode"]) }, { ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" },
	mode: { enum: ["shiftLeft", "shiftUp"] }
}, ["mode"]) }, { ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" },
	rows: {
		type: "integer",
		minimum: 1
	},
	columns: {
		type: "integer",
		minimum: 1
	}
}, ["rows", "columns"]) }, { ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" },
	preferredWidthPt: { type: "number" },
	verticalAlign: { enum: [
		"top",
		"center",
		"bottom"
	] },
	wrapText: { type: "boolean" },
	fitText: { type: "boolean" }
}) }, objectSchema({
	target: tableCellAddressSchema,
	text: { type: "string" }
}, ["target", "text"]), objectSchema({
	nodeId: { type: "string" },
	text: { type: "string" }
}, ["nodeId", "text"]), objectSchema({
	target: tableAddressSchema,
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	columnIndex: {
		type: "integer",
		minimum: 0
	},
	text: { type: "string" }
}, [
	"target",
	"rowIndex",
	"columnIndex",
	"text"
]), objectSchema({
	nodeId: { type: "string" },
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	columnIndex: {
		type: "integer",
		minimum: 0
	},
	text: { type: "string" }
}, [
	"nodeId",
	"rowIndex",
	"columnIndex",
	"text"
]), { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	keys: arraySchema(objectSchema({
		columnIndex: {
			type: "integer",
			minimum: 0
		},
		direction: { enum: ["ascending", "descending"] },
		type: { enum: [
			"text",
			"number",
			"date"
		] }
	}, [
		"columnIndex",
		"direction",
		"type"
	]))
}, ["keys"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	title: { type: "string" },
	description: { type: "string" }
}) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	styleId: { type: "string" }
}, ["styleId"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	flag: { enum: [
		"headerRow",
		"lastRow",
		"totalRow",
		"firstColumn",
		"lastColumn",
		"bandedRows",
		"bandedColumns"
	] },
	enabled: { type: "boolean" }
}, ["flag", "enabled"]) }, { ...objectSchema({
	target: tableOrCellAddressSchema,
	nodeId: { type: "string" },
	edge: { enum: [
		"top",
		"bottom",
		"left",
		"right",
		"insideH",
		"insideV",
		"diagonalDown",
		"diagonalUp"
	] },
	lineStyle: { type: "string" },
	lineWeightPt: {
		type: "number",
		exclusiveMinimum: 0
	},
	color: {
		type: "string",
		pattern: tableBorderColorPattern
	}
}, [
	"edge",
	"lineStyle",
	"lineWeightPt",
	"color"
]) }, { ...objectSchema({
	target: tableOrCellAddressSchema,
	nodeId: { type: "string" },
	edge: { enum: [
		"top",
		"bottom",
		"left",
		"right",
		"insideH",
		"insideV",
		"diagonalDown",
		"diagonalUp"
	] }
}, ["edge"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	preset: { enum: [
		"box",
		"all",
		"none",
		"grid",
		"custom"
	] }
}, ["preset"]) }, { ...objectSchema({
	target: tableOrCellAddressSchema,
	nodeId: { type: "string" },
	color: { oneOf: [{
		type: "string",
		pattern: tableBorderColorPattern
	}, { type: "null" }] }
}, ["color"]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	topPt: {
		type: "number",
		minimum: 0
	},
	rightPt: {
		type: "number",
		minimum: 0
	},
	bottomPt: {
		type: "number",
		minimum: 0
	},
	leftPt: {
		type: "number",
		minimum: 0
	}
}, [
	"topPt",
	"rightPt",
	"bottomPt",
	"leftPt"
]) }, { ...objectSchema({
	target: tableCellAddressSchema,
	nodeId: { type: "string" },
	topPt: {
		type: "number",
		minimum: 0
	},
	rightPt: {
		type: "number",
		minimum: 0
	},
	bottomPt: {
		type: "number",
		minimum: 0
	},
	leftPt: {
		type: "number",
		minimum: 0
	}
}, [
	"topPt",
	"rightPt",
	"bottomPt",
	"leftPt"
]) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	spacingPt: {
		type: "number",
		minimum: 0
	}
}, ["spacingPt"]) }, { ...objectSchema({
	target: blockNodeAddressSchema,
	nodeId: { type: "string" },
	styleId: { type: "string" },
	styleOptions: objectSchema({
		headerRow: { type: "boolean" },
		lastRow: { type: "boolean" },
		totalRow: { type: "boolean" },
		firstColumn: { type: "boolean" },
		lastColumn: { type: "boolean" },
		bandedRows: { type: "boolean" },
		bandedColumns: { type: "boolean" }
	})
}) }, { ...objectSchema({
	target: blockNodeAddressSchema,
	nodeId: { type: "string" },
	mode: { const: "applyTo" },
	applyTo: { enum: [
		"all",
		"outside",
		"inside",
		"top",
		"bottom",
		"left",
		"right",
		"insideH",
		"insideV"
	] },
	border: nullableTableBorderSpecSchema
}, [
	"mode",
	"applyTo",
	"border"
]) }, { ...objectSchema({
	target: blockNodeAddressSchema,
	nodeId: { type: "string" },
	mode: { const: "edges" },
	edges: objectSchema({
		top: nullableTableBorderSpecSchema,
		bottom: nullableTableBorderSpecSchema,
		left: nullableTableBorderSpecSchema,
		right: nullableTableBorderSpecSchema,
		insideH: nullableTableBorderSpecSchema,
		insideV: nullableTableBorderSpecSchema
	})
}, ["mode", "edges"]) }, { ...objectSchema({
	target: blockNodeAddressSchema,
	nodeId: { type: "string" },
	defaultCellMargins: objectSchema({
		topPt: {
			type: "number",
			minimum: 0
		},
		rightPt: {
			type: "number",
			minimum: 0
		},
		bottomPt: {
			type: "number",
			minimum: 0
		},
		leftPt: {
			type: "number",
			minimum: 0
		}
	}, [
		"topPt",
		"rightPt",
		"bottomPt",
		"leftPt"
	]),
	cellSpacingPt: { oneOf: [{
		type: "number",
		minimum: 0
	}, { type: "null" }] }
}) }, { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	preset: { enum: [
		"grid",
		"minimal",
		"striped",
		"accent"
	] },
	accentColor: {
		type: "string",
		pattern: tableBorderColorPattern
	}
}, ["preset"]) }, objectSchema({
	nodeId: { type: "string" },
	address: tableAddressSchema,
	rows: {
		type: "integer",
		minimum: 0
	},
	columns: {
		type: "integer",
		minimum: 0
	}
}, [
	"nodeId",
	"address",
	"rows",
	"columns"
]), { ...objectSchema({
	target: tableAddressSchema,
	nodeId: { type: "string" },
	rowIndex: {
		type: "integer",
		minimum: 0
	},
	columnIndex: {
		type: "integer",
		minimum: 0
	}
}) }, objectSchema({
	nodeId: { type: "string" },
	address: tableAddressSchema,
	cells: {
		type: "array",
		items: objectSchema({
			nodeId: { type: "string" },
			address: tableCellAddressSchema,
			rowIndex: {
				type: "integer",
				minimum: 0
			},
			columnIndex: {
				type: "integer",
				minimum: 0
			},
			colspan: {
				type: "integer",
				minimum: 1
			},
			rowspan: {
				type: "integer",
				minimum: 1
			}
		}, [
			"nodeId",
			"address",
			"rowIndex",
			"columnIndex",
			"colspan",
			"rowspan"
		])
	}
}, [
	"nodeId",
	"address",
	"cells"
]), objectSchema({
	nodeId: { type: "string" },
	address: tableAddressSchema,
	styleId: { type: "string" },
	alignment: { enum: [
		"left",
		"center",
		"right"
	] },
	direction: { enum: ["ltr", "rtl"] },
	preferredWidth: { type: "number" },
	autoFitMode: { enum: [
		"fixedWidth",
		"fitContents",
		"fitWindow"
	] },
	styleOptions: objectSchema({
		headerRow: { type: "boolean" },
		lastRow: { type: "boolean" },
		firstColumn: { type: "boolean" },
		lastColumn: { type: "boolean" },
		bandedRows: { type: "boolean" },
		bandedColumns: { type: "boolean" }
	}),
	borders: objectSchema({
		top: nullableTableBorderSpecSchema,
		bottom: nullableTableBorderSpecSchema,
		left: nullableTableBorderSpecSchema,
		right: nullableTableBorderSpecSchema,
		insideH: nullableTableBorderSpecSchema,
		insideV: nullableTableBorderSpecSchema
	}),
	defaultCellMargins: objectSchema({
		topPt: { type: "number" },
		rightPt: { type: "number" },
		bottomPt: { type: "number" },
		leftPt: { type: "number" }
	}),
	cellSpacingPt: { type: "number" }
}, ["nodeId", "address"]), objectSchema({
	explicitDefaultStyleId: { type: ["string", "null"] },
	effectiveDefaultStyleId: { type: ["string", "null"] },
	effectiveDefaultSource: { type: "string" },
	styles: arraySchema(objectSchema({
		id: { type: "string" },
		name: { type: ["string", "null"] },
		basedOn: { type: ["string", "null"] },
		isDefault: { type: "boolean" },
		isCustom: { type: "boolean" },
		uiPriority: { type: ["integer", "null"] },
		hidden: { type: "boolean" },
		quickFormat: { type: "boolean" },
		conditionalRegions: arraySchema({ type: "string" })
	}, [
		"id",
		"name",
		"basedOn",
		"isDefault",
		"isCustom",
		"uiPriority",
		"hidden",
		"quickFormat",
		"conditionalRegions"
	]))
}, [
	"explicitDefaultStyleId",
	"effectiveDefaultStyleId",
	"effectiveDefaultSource",
	"styles"
]), objectSchema({ styleId: { type: "string" } }, ["styleId"]), documentMutationResultSchemaFor("tables.setDefaultStyle"), sectionMutationFailureSchemaFor("tables.setDefaultStyle"), documentMutationResultSchemaFor("tables.clearDefaultStyle"), sectionMutationFailureSchemaFor("tables.clearDefaultStyle"), objectSchema({
	undoDepth: {
		type: "integer",
		minimum: 0
	},
	redoDepth: {
		type: "integer",
		minimum: 0
	},
	canUndo: { type: "boolean" },
	canRedo: { type: "boolean" },
	historyUnsafeOperations: {
		type: "array",
		items: { type: "string" }
	}
}, [
	"undoDepth",
	"redoDepth",
	"canUndo",
	"canRedo",
	"historyUnsafeOperations"
]), objectSchema({
	at: { oneOf: [
		objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
		objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
		objectSchema({
			kind: { const: "before" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "after" },
			target: blockNodeAddressSchema
		}, ["kind", "target"])
	] },
	config: objectSchema({
		outlineLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		useAppliedOutlineLevel: { type: "boolean" },
		tcFieldIdentifier: { type: "string" },
		tcFieldLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		hyperlinks: { type: "boolean" },
		hideInWebView: { type: "boolean" },
		omitPageNumberLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		separator: { type: "string" },
		includePageNumbers: { type: "boolean" },
		tabLeader: { enum: [
			"none",
			"dot",
			"hyphen",
			"underscore",
			"middleDot"
		] },
		rightAlignPageNumbers: { type: "boolean" }
	})
}), tocMutationResultSchema(), objectSchema({
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({
	evaluatedRevision: { type: "string" },
	total: { type: "integer" },
	items: arraySchema(objectSchema({
		id: { type: "string" },
		handle: ref("ResolvedHandle"),
		address: tocAddressSchema(),
		instruction: { type: "string" },
		sourceConfig: { type: "object" },
		displayConfig: { type: "object" },
		preserved: { type: "object" },
		entryCount: { type: "integer" }
	}, [
		"id",
		"handle",
		"address",
		"instruction",
		"entryCount"
	])),
	page: ref("PageInfo")
}, [
	"evaluatedRevision",
	"total",
	"items",
	"page"
]), objectSchema({ target: tocAddressSchema() }, ["target"]), objectSchema({
	nodeType: { const: "tableOfContents" },
	kind: { const: "block" },
	properties: objectSchema({
		instruction: { type: "string" },
		sourceConfig: { type: "object" },
		displayConfig: { type: "object" },
		preservedSwitches: { type: "object" },
		entryCount: { type: "integer" }
	}, ["instruction", "entryCount"])
}, [
	"nodeType",
	"kind",
	"properties"
]), objectSchema({
	target: tocAddressSchema(),
	patch: objectSchema({
		outlineLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		useAppliedOutlineLevel: { type: "boolean" },
		tcFieldIdentifier: { type: "string" },
		tcFieldLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		hyperlinks: { type: "boolean" },
		hideInWebView: { type: "boolean" },
		omitPageNumberLevels: objectSchema({
			from: { type: "integer" },
			to: { type: "integer" }
		}, ["from", "to"]),
		separator: { type: "string" },
		includePageNumbers: { type: "boolean" },
		tabLeader: { enum: [
			"none",
			"dot",
			"hyphen",
			"underscore",
			"middleDot"
		] },
		rightAlignPageNumbers: { type: "boolean" }
	})
}, ["target", "patch"]), tocMutationResultSchema(), objectSchema({
	target: tocAddressSchema(),
	mode: { enum: ["all", "pageNumbers"] }
}, ["target"]), tocMutationResultSchema(), objectSchema({ target: tocAddressSchema() }, ["target"]), tocMutationResultSchema(), objectSchema({
	target: tocEntryInsertionTargetSchema(),
	text: { type: "string" },
	level: {
		type: "integer",
		minimum: 1,
		maximum: 9
	},
	tableIdentifier: { type: "string" },
	omitPageNumber: { type: "boolean" }
}, ["target", "text"]), tocEntryMutationResultSchema(), objectSchema({ target: tocEntryAddressSchema() }, ["target"]), tocEntryMutationResultSchema(), objectSchema({
	tableIdentifier: { type: "string" },
	levelRange: objectSchema({
		from: { type: "integer" },
		to: { type: "integer" }
	}, ["from", "to"]),
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({
	evaluatedRevision: { type: "string" },
	total: { type: "integer" },
	items: arraySchema(objectSchema({
		id: { type: "string" },
		handle: ref("ResolvedHandle"),
		address: tocEntryAddressSchema(),
		instruction: { type: "string" },
		text: { type: "string" },
		level: { type: "integer" },
		tableIdentifier: { type: "string" },
		omitPageNumber: { type: "boolean" }
	}, [
		"id",
		"handle",
		"address",
		"instruction",
		"text",
		"level",
		"omitPageNumber"
	])),
	page: ref("PageInfo")
}, [
	"evaluatedRevision",
	"total",
	"items",
	"page"
]), objectSchema({ target: tocEntryAddressSchema() }, ["target"]), objectSchema({
	nodeType: { const: "tableOfContentsEntry" },
	kind: { const: "inline" },
	properties: objectSchema({
		instruction: { type: "string" },
		text: { type: "string" },
		level: { type: "integer" },
		tableIdentifier: { type: "string" },
		omitPageNumber: { type: "boolean" }
	}, [
		"instruction",
		"text",
		"level",
		"omitPageNumber"
	])
}, [
	"nodeType",
	"kind",
	"properties"
]), objectSchema({
	target: tocEntryAddressSchema(),
	patch: objectSchema({
		text: { type: "string" },
		level: {
			type: "integer",
			minimum: 1,
			maximum: 9
		},
		tableIdentifier: { type: "string" },
		omitPageNumber: { type: "boolean" }
	})
}, ["target", "patch"]), tocEntryMutationResultSchema(), objectSchema({
	in: storyLocatorSchema,
	src: { type: "string" },
	alt: { type: "string" },
	title: { type: "string" },
	size: objectSchema({
		width: { type: "number" },
		height: { type: "number" }
	}),
	at: { oneOf: [
		objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
		objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
		objectSchema({
			kind: { const: "before" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "after" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "inParagraph" },
			target: blockNodeAddressSchema,
			offset: { type: "integer" }
		}, ["kind", "target"])
	] }
}, ["src"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { enum: ["INVALID_TARGET", "INVALID_INPUT"] },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	offset: { type: "integer" },
	limit: { type: "integer" }
}), objectSchema({
	total: { type: "integer" },
	items: arraySchema({ type: "object" })
}, ["total", "items"]), objectSchema({ imageId: { type: "string" } }, ["imageId"]), objectSchema({ imageId: { type: "string" } }, ["imageId"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	to: { oneOf: [
		objectSchema({ kind: { const: "documentStart" } }, ["kind"]),
		objectSchema({ kind: { const: "documentEnd" } }, ["kind"]),
		objectSchema({
			kind: { const: "before" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "after" },
			target: blockNodeAddressSchema
		}, ["kind", "target"]),
		objectSchema({
			kind: { const: "inParagraph" },
			target: blockNodeAddressSchema,
			offset: { type: "integer" }
		}, ["kind", "target"])
	] }
}, ["imageId", "to"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({ imageId: { type: "string" } }, ["imageId"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({ imageId: { type: "string" } }, ["imageId"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	size: objectSchema({
		width: {
			type: "number",
			exclusiveMinimum: 0
		},
		height: {
			type: "number",
			exclusiveMinimum: 0
		},
		unit: {
			type: "string",
			enum: [
				"px",
				"pt",
				"twip"
			]
		}
	}, ["width", "height"])
}, ["imageId", "size"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	type: {
		type: "string",
		enum: [
			"None",
			"Square",
			"Through",
			"Tight",
			"TopAndBottom",
			"Inline"
		]
	}
}, ["imageId", "type"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	side: {
		type: "string",
		enum: [
			"bothSides",
			"left",
			"right",
			"largest"
		]
	}
}, ["imageId", "side"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	distances: objectSchema({
		distTop: { type: "number" },
		distBottom: { type: "number" },
		distLeft: { type: "number" },
		distRight: { type: "number" }
	})
}, ["imageId", "distances"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	position: objectSchema({
		hRelativeFrom: { type: "string" },
		vRelativeFrom: { type: "string" },
		alignH: { type: "string" },
		alignV: { type: "string" },
		marginOffset: objectSchema({
			horizontal: { type: "number" },
			top: { type: "number" }
		})
	})
}, ["imageId", "position"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), objectSchema({
	imageId: { type: "string" },
	options: objectSchema({
		behindDoc: { type: "boolean" },
		allowOverlap: { type: "boolean" },
		layoutInCell: { type: "boolean" },
		lockAnchor: { type: "boolean" },
		simplePos: { type: "boolean" }
	})
}, ["imageId", "options"]), objectSchema({
	success: { type: "boolean" },
	image: { type: "object" },
	failure: { type: "object" }
}), objectSchema({
	success: { const: true },
	image: { type: "object" }
}, ["success", "image"]), objectSchema({
	success: { const: false },
	failure: objectSchema({
		code: { type: "string" },
		message: { type: "string" }
	}, ["code", "message"])
}, ["success", "failure"]), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	zOrder: objectSchema({ relativeHeight: {
		type: "integer",
		minimum: 0,
		maximum: Z_ORDER_RELATIVE_HEIGHT_MAX
	} }, ["relativeHeight"])
}, ["imageId", "zOrder"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	factor: {
		type: "number",
		exclusiveMinimum: 0
	}
}, ["imageId", "factor"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	locked: { type: "boolean" }
}, ["imageId", "locked"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	angle: {
		type: "number",
		minimum: 0,
		maximum: 360
	}
}, ["imageId", "angle"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	horizontal: { type: "boolean" },
	vertical: { type: "boolean" }
}, ["imageId"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	crop: objectSchema({
		left: {
			type: "number",
			minimum: 0,
			maximum: 100
		},
		top: {
			type: "number",
			minimum: 0,
			maximum: 100
		},
		right: {
			type: "number",
			minimum: 0,
			maximum: 100
		},
		bottom: {
			type: "number",
			minimum: 0,
			maximum: 100
		}
	}, [])
}, ["imageId", "crop"])), imagesMutationSchemaSet(objectSchema({ imageId: { type: "string" } }, ["imageId"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	src: { type: "string" },
	resetSize: { type: "boolean" }
}, ["imageId", "src"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	description: { type: "string" }
}, ["imageId", "description"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	decorative: { type: "boolean" }
}, ["imageId", "decorative"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	name: { type: "string" }
}, ["imageId", "name"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	url: { type: ["string", "null"] },
	tooltip: { type: "string" }
}, ["imageId", "url"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	text: { type: "string" }
}, ["imageId", "text"])), imagesMutationSchemaSet(objectSchema({
	imageId: { type: "string" },
	text: { type: "string" }
}, ["imageId", "text"])), imagesMutationSchemaSet(objectSchema({ imageId: { type: "string" } }, ["imageId"])), objectSchema({
	within: blockNodeAddressSchema,
	hrefPattern: { type: "string" },
	anchor: { type: "string" },
	textPattern: { type: "string" },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), discoveryResultSchema(hyperlinkDomainSchema), objectSchema({ target: hyperlinkTargetSchema }, ["target"]), objectSchema({
	target: textAddressSchema,
	link: hyperlinkSpecSchema
}, ["target", "link"]), hyperlinkMutationResultSchema(), objectSchema({
	target: textAddressSchema,
	text: { type: "string" },
	link: hyperlinkSpecSchema
}, ["text", "link"]), hyperlinkMutationResultSchema(), objectSchema({
	target: hyperlinkTargetSchema,
	patch: hyperlinkPatchSchema
}, ["target", "patch"]), hyperlinkMutationResultSchema(), objectSchema({
	target: hyperlinkTargetSchema,
	mode: { enum: ["unwrap", "deleteText"] }
}, ["target"]), hyperlinkMutationResultSchema(), objectSchema({
	kind: { enum: ["header", "footer"] },
	section: sectionAddressSchema,
	limit: {
		type: "integer",
		minimum: 1
	},
	offset: {
		type: "integer",
		minimum: 0
	}
}), discoveryResultSchema(discoveryItemSchema({
	section: sectionAddressSchema,
	sectionIndex: {
		type: "integer",
		minimum: 0
	},
	kind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] },
	refId: { type: ["string", "null"] },
	isExplicit: { type: "boolean" }
}, [
	"section",
	"sectionIndex",
	"kind",
	"variant",
	"isExplicit"
])), objectSchema({ target: objectSchema({
	kind: { const: "headerFooterSlot" },
	section: sectionAddressSchema,
	headerFooterKind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] }
}, [
	"kind",
	"section",
	"headerFooterKind",
	"variant"
]) }, ["target"]), objectSchema({
	section: sectionAddressSchema,
	sectionIndex: {
		type: "integer",
		minimum: 0
	},
	kind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] },
	refId: { type: ["string", "null"] },
	isExplicit: { type: "boolean" }
}, [
	"section",
	"sectionIndex",
	"kind",
	"variant",
	"isExplicit"
]), objectSchema({ target: objectSchema({
	kind: { const: "headerFooterSlot" },
	section: sectionAddressSchema,
	headerFooterKind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] }
}, [
	"kind",
	"section",
	"headerFooterKind",
	"variant"
]) }, ["target"]), objectSchema({
	status: { const: "explicit" },
	refId: { type: "string" },
	section: sectionAddressSchema
}, [
	"status",
	"refId",
	"section"
]), objectSchema({
	status: { const: "inherited" },
	refId: { type: "string" },
	resolvedFromSection: sectionAddressSchema,
	resolvedVariant: { enum: [
		"default",
		"first",
		"even"
	] }
}, [
	"status",
	"refId",
	"resolvedFromSection",
	"resolvedVariant"
]), objectSchema({ status: { const: "none" } }, ["status"]), objectSchema({
	target: objectSchema({
		kind: { const: "headerFooterSlot" },
		section: sectionAddressSchema,
		headerFooterKind: { enum: ["header", "footer"] },
		variant: { enum: [
			"default",
			"first",
			"even"
		] }
	}, [
		"kind",
		"section",
		"headerFooterKind",
		"variant"
	]),
	refId: {
		type: "string",
		minLength: 1
	}
}, ["target", "refId"]), sectionMutationResultSchemaFor("headerFooters.refs.set"), sectionMutationFailureSchemaFor("headerFooters.refs.set"), objectSchema({ target: objectSchema({
	kind: { const: "headerFooterSlot" },
	section: sectionAddressSchema,
	headerFooterKind: { enum: ["header", "footer"] },
	variant: { enum: [
		"default",
		"first",
		"even"
	] }
}, [
	"kind",
	"section",
	"headerFooterKind",
	"variant"
]) }, ["target"]), sectionMutationResultSchemaFor("headerFooters.refs.clear"), sectionMutationFailureSchemaFor("headerFooters.refs.clear"), objectSchema({
	target: objectSchema({
		kind: { const: "headerFooterSlot" },
		section: sectionAddressSchema,
		headerFooterKind: { enum: ["header", "footer"] },
		variant: { enum: [
			"default",
			"first",
			"even"
		] }
	}, [
		"kind",
		"section",
		"headerFooterKind",
		"variant"
	]),
	linked: { type: "boolean" }
}, ["target", "linked"]), sectionMutationResultSchemaFor("headerFooters.refs.setLinkedToPrevious"), sectionMutationFailureSchemaFor("headerFooters.refs.setLinkedToPrevious"), objectSchema({
	kind: { enum: ["header", "footer"] },
	limit: {
		type: "integer",
		minimum: 1
	},
	offset: {
		type: "integer",
		minimum: 0
	}
}), discoveryResultSchema(discoveryItemSchema({
	refId: { type: "string" },
	kind: { enum: ["header", "footer"] },
	partPath: { type: "string" },
	referencedBySections: arraySchema(sectionAddressSchema)
}, [
	"refId",
	"kind",
	"partPath",
	"referencedBySections"
])), objectSchema({
	kind: { enum: ["header", "footer"] },
	sourceRefId: {
		type: "string",
		minLength: 1
	}
}, ["kind"]), objectSchema({
	success: { const: true },
	refId: { type: "string" },
	partPath: { type: "string" }
}, [
	"success",
	"refId",
	"partPath"
]), objectSchema({
	success: { const: false },
	failure: receiptFailureSchemaFor("headerFooters.parts.create")
}, ["success", "failure"]), objectSchema({
	success: { const: true },
	refId: { type: "string" },
	partPath: { type: "string" }
}, [
	"success",
	"refId",
	"partPath"
]), objectSchema({
	success: { const: false },
	failure: receiptFailureSchemaFor("headerFooters.parts.create")
}, ["success", "failure"]), objectSchema({ target: objectSchema({
	kind: { const: "headerFooterPart" },
	refId: {
		type: "string",
		minLength: 1
	}
}, ["kind", "refId"]) }, ["target"]), objectSchema({
	success: { const: true },
	refId: { type: "string" },
	partPath: { type: "string" }
}, [
	"success",
	"refId",
	"partPath"
]), objectSchema({
	success: { const: false },
	failure: receiptFailureSchemaFor("headerFooters.parts.delete")
}, ["success", "failure"]), objectSchema({
	success: { const: true },
	refId: { type: "string" },
	partPath: { type: "string" }
}, [
	"success",
	"refId",
	"partPath"
]), objectSchema({
	success: { const: false },
	failure: receiptFailureSchemaFor("headerFooters.parts.delete")
}, ["success", "failure"]), { ...buildContentControlSchemas() }, objectSchema({
	...refListQueryProperties,
	in: storyLocatorSchema
}), objectSchema({ target: bookmarkAddressSchema }, ["target"]), objectSchema({
	name: { type: "string" },
	at: textTargetSchema,
	tableColumn: objectSchema({
		colFirst: { type: "integer" },
		colLast: { type: "integer" }
	}, ["colFirst", "colLast"])
}, ["name", "at"]), { ...bookmarkMutation }, objectSchema({
	target: bookmarkAddressSchema,
	newName: { type: "string" }
}, ["target", "newName"]), { ...bookmarkMutation }, objectSchema({ target: bookmarkAddressSchema }, ["target"]), { ...bookmarkMutation }, objectSchema({
	type: { enum: ["footnote", "endnote"] },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({ target: footnoteAddressSchema }, ["target"]), objectSchema({
	at: textTargetSchema,
	type: { enum: ["footnote", "endnote"] },
	content: { type: "string" }
}, [
	"at",
	"type",
	"content"
]), { ...footnoteMutation }, objectSchema({
	target: footnoteAddressSchema,
	patch: objectSchema({ content: { type: "string" } })
}, ["target", "patch"]), { ...footnoteMutation }, objectSchema({ target: footnoteAddressSchema }, ["target"]), { ...footnoteMutation }, objectSchema({
	type: { enum: ["footnote", "endnote"] },
	scope: footnoteConfigScopeSchema,
	numbering: footnoteNumberingSchema
}, ["type", "scope"]), { ...footnoteConfig }, objectSchema({ target: crossRefAddressSchema }, ["target"]), objectSchema({
	at: textTargetSchema,
	target: crossRefTargetSchema,
	display: crossRefDisplaySchema
}, [
	"at",
	"target",
	"display"
]), { ...crossRefMutation }, objectSchema({ target: crossRefAddressSchema }, ["target"]), { ...crossRefMutation }, objectSchema({ target: crossRefAddressSchema }, ["target"]), { ...crossRefMutation }, objectSchema({ target: indexAddressSchema }, ["target"]), objectSchema({
	at: tocCreateLocationSchema,
	config: indexConfigSchema
}, ["at"]), { ...indexMutation }, objectSchema({
	target: indexAddressSchema,
	patch: indexConfigSchema
}, ["target", "patch"]), { ...indexMutation }, objectSchema({ target: indexAddressSchema }, ["target"]), { ...indexMutation }, objectSchema({ target: indexAddressSchema }, ["target"]), { ...indexMutation }, objectSchema({
	entryType: { type: "string" },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({ target: indexEntryAddressSchema }, ["target"]), objectSchema({
	at: textTargetSchema,
	entry: indexEntryDataSchema
}, ["at", "entry"]), { ...indexEntryMutation }, objectSchema({
	target: indexEntryAddressSchema,
	patch: indexEntryPatchSchema
}, ["target", "patch"]), { ...indexEntryMutation }, objectSchema({ target: indexEntryAddressSchema }, ["target"]), { ...indexEntryMutation }, objectSchema({
	label: { type: "string" },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({ target: captionAddressSchema }, ["target"]), objectSchema({
	adjacentTo: blockNodeAddressSchema,
	position: { enum: ["above", "below"] },
	label: { type: "string" },
	text: { type: "string" }
}, [
	"adjacentTo",
	"position",
	"label"
]), { ...captionMutation }, objectSchema({
	target: captionAddressSchema,
	patch: objectSchema({ text: { type: "string" } })
}, ["target", "patch"]), { ...captionMutation }, objectSchema({ target: captionAddressSchema }, ["target"]), { ...captionMutation }, objectSchema({
	label: { type: "string" },
	format: { enum: [
		"decimal",
		"lowerRoman",
		"upperRoman",
		"lowerLetter",
		"upperLetter"
	] },
	includeChapter: { type: "boolean" },
	chapterStyle: { type: "string" }
}, ["label"]), { ...captionConfig }, objectSchema({ target: fieldAddressSchema }, ["target"]), objectSchema({
	mode: { const: "raw" },
	at: textTargetSchema,
	instruction: { type: "string" }
}, [
	"mode",
	"at",
	"instruction"
]), { ...fieldMutation }, objectSchema({ target: fieldAddressSchema }, ["target"]), { ...fieldMutation }, objectSchema({
	mode: { const: "raw" },
	target: fieldAddressSchema
}, ["mode", "target"]), { ...fieldMutation }, objectSchema({ target: citationAddressSchema }, ["target"]), objectSchema({
	at: textTargetSchema,
	sourceIds: {
		type: "array",
		items: { type: "string" }
	}
}, ["at", "sourceIds"]), { ...citationMutation }, objectSchema({
	target: citationAddressSchema,
	patch: objectSchema({ sourceIds: {
		type: "array",
		items: { type: "string" }
	} })
}, ["target", "patch"]), { ...citationMutation }, objectSchema({ target: citationAddressSchema }, ["target"]), { ...citationMutation }, objectSchema({
	type: { type: "string" },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({ target: citationSourceAddressSchema }, ["target"]), objectSchema({
	type: { enum: [
		"book",
		"journalArticle",
		"conferenceProceedings",
		"report",
		"website",
		"patent",
		"case",
		"statute",
		"thesis",
		"film",
		"interview",
		"misc"
	] },
	fields: citationSourceFieldsSchema
}, ["type", "fields"]), { ...citationSourceMutation }, objectSchema({
	target: citationSourceAddressSchema,
	patch: citationSourceFieldsSchema
}, ["target", "patch"]), { ...citationSourceMutation }, objectSchema({ target: citationSourceAddressSchema }, ["target"]), { ...citationSourceMutation }, objectSchema({ target: bibliographyAddressSchema }, ["target"]), objectSchema({
	at: tocCreateLocationSchema,
	style: { type: "string" }
}, ["at"]), { ...bibliographyMutation }, objectSchema({ target: bibliographyAddressSchema }, ["target"]), { ...bibliographyMutation }, objectSchema({
	target: bibliographyAddressSchema,
	style: { type: "string" }
}, ["target", "style"]), { ...bibliographyMutation }, objectSchema({ target: bibliographyAddressSchema }, ["target"]), { ...bibliographyMutation }, objectSchema({ target: authoritiesAddressSchema }, ["target"]), objectSchema({
	at: tocCreateLocationSchema,
	config: authoritiesConfigSchema
}, ["at"]), { ...authoritiesMutation }, objectSchema({
	target: authoritiesAddressSchema,
	patch: authoritiesConfigSchema
}, ["target", "patch"]), { ...authoritiesMutation }, objectSchema({ target: authoritiesAddressSchema }, ["target"]), { ...authoritiesMutation }, objectSchema({ target: authoritiesAddressSchema }, ["target"]), { ...authoritiesMutation }, objectSchema({
	category: { oneOf: [{ type: "string" }, { type: "integer" }] },
	limit: { type: "integer" },
	offset: { type: "integer" }
}), objectSchema({ target: authorityEntryAddressSchema }, ["target"]), objectSchema({
	at: textTargetSchema,
	entry: authorityEntryDataSchema
}, ["at", "entry"]), { ...authorityEntryMutation }, objectSchema({
	target: authorityEntryAddressSchema,
	patch: authorityEntryPatchSchema
}, ["target", "patch"]), { ...authorityEntryMutation }, objectSchema({ target: authorityEntryAddressSchema }, ["target"]), { ...authorityEntryMutation }, objectSchema({}), objectSchema({ targetSnapshot: diffSnapshotSchema }, ["targetSnapshot"]), objectSchema({ diff: diffPayloadSchema }, ["diff"]), objectSchema({}), objectSchema({
	editingRestriction: objectSchema({
		mode: {
			type: "string",
			enum: [
				"none",
				"readOnly",
				"comments",
				"trackedChanges",
				"forms"
			]
		},
		enforced: { type: "boolean" },
		runtimeEnforced: { type: "boolean" },
		passwordProtected: { type: "boolean" },
		formattingRestricted: { type: "boolean" }
	}, [
		"mode",
		"enforced",
		"runtimeEnforced",
		"passwordProtected",
		"formattingRestricted"
	]),
	writeProtection: objectSchema({
		enabled: { type: "boolean" },
		passwordProtected: { type: "boolean" }
	}, ["enabled", "passwordProtected"]),
	readOnlyRecommended: { type: "boolean" }
}, [
	"editingRestriction",
	"writeProtection",
	"readOnlyRecommended"
]), objectSchema({
	mode: {
		type: "string",
		enum: ["readOnly"]
	},
	formattingRestricted: { type: "boolean" }
}, ["mode"]), objectSchema({}), objectSchema({ id: { type: "string" } }, ["id"]), objectSchema({
	target: selectionTargetSchema,
	principal: objectSchema({
		kind: {
			type: "string",
			enum: ["everyone", "editor"]
		},
		id: { type: "string" }
	}, ["kind"]),
	id: { type: "string" }
}, ["target", "principal"]), objectSchema({ id: { type: "string" } }, ["id"]), objectSchema({
	id: { type: "string" },
	principal: objectSchema({
		kind: {
			type: "string",
			enum: ["everyone", "editor"]
		},
		id: { type: "string" }
	}, ["kind"])
}, ["id", "principal"]), objectSchema({
	...refListQueryProperties,
	rootNamespace: { type: "string" },
	schemaRef: { type: "string" }
}), objectSchema({ target: customXmlPartTargetSchema }, ["target"]), objectSchema({
	content: {
		type: "string",
		minLength: 1
	},
	schemaRefs: {
		type: "array",
		items: {
			type: "string",
			minLength: 1
		}
	}
}, ["content"]), { ...customXmlPartCreateMutation }, { ...customXmlPartMutation }, objectSchema({ target: customXmlPartTargetSchema }, ["target"]), { ...customXmlPartMutation }, objectSchema({
	target: selectionTargetSchema,
	namespace: {
		type: "string",
		minLength: 1
	},
	payload: {},
	id: {
		type: "string",
		minLength: 1
	}
}, [
	"target",
	"namespace",
	"payload"
]), { ...anchoredMetadataAttachMutation }, objectSchema({
	...refListQueryProperties,
	namespace: { type: "string" },
	within: selectionTargetSchema
}), objectSchema({ id: {
	type: "string",
	minLength: 1
} }, ["id"]), objectSchema({
	id: {
		type: "string",
		minLength: 1
	},
	payload: {}
}, ["id", "payload"]), { ...anchoredMetadataMutation }, objectSchema({ id: {
	type: "string",
	minLength: 1
} }, ["id"]), { ...anchoredMetadataMutation }, objectSchema({ id: {
	type: "string",
	minLength: 1
} }, ["id"]);
projectFromDefinitions((_id, entry) => entry.memberPath);
[...new Set(OPERATION_IDS.map((id) => OPERATION_DEFINITIONS[id].memberPath))];
projectFromDefinitions((_id, entry) => entry.referenceDocPath);
var GROUP_METADATA = {
	core: {
		title: "Core",
		description: "Primary read and write operations.",
		pagePath: "core/index.mdx"
	},
	blocks: {
		title: "Blocks",
		description: "Block-level structural operations.",
		pagePath: "blocks/index.mdx"
	},
	capabilities: {
		title: "Capabilities",
		description: "Runtime support discovery for capability-aware branching.",
		pagePath: "capabilities/index.mdx"
	},
	create: {
		title: "Create",
		description: "Structured creation helpers.",
		pagePath: "create/index.mdx"
	},
	sections: {
		title: "Sections",
		description: "Section structure and page-setup operations.",
		pagePath: "sections/index.mdx"
	},
	format: {
		title: "Format",
		description: "Canonical formatting mutation with directive semantics ('on', 'off', 'clear').",
		pagePath: "format/index.mdx"
	},
	styles: {
		title: "Styles",
		description: "Document-level stylesheet mutations (docDefaults, style definitions).",
		pagePath: "styles/index.mdx"
	},
	templates: {
		title: "Templates",
		description: "Apply detected DOCX template/substrate from a source package, preserving body content.",
		pagePath: "templates/index.mdx"
	},
	lists: {
		title: "Lists",
		description: "List inspection and list mutations.",
		pagePath: "lists/index.mdx"
	},
	comments: {
		title: "Comments",
		description: "Comment authoring and thread lifecycle operations.",
		pagePath: "comments/index.mdx"
	},
	trackChanges: {
		title: "Track Changes",
		description: "Tracked-change inspection and review operations.",
		pagePath: "track-changes/index.mdx"
	},
	query: {
		title: "Query",
		description: "Deterministic selector-based queries for mutation targeting.",
		pagePath: "query/index.mdx"
	},
	mutations: {
		title: "Mutations",
		description: "Atomic mutation plan preview and execution.",
		pagePath: "mutations/index.mdx"
	},
	"format.paragraph": {
		title: "Paragraph Formatting",
		description: "Paragraph-level direct formatting: alignment, indentation, spacing, borders, shading, and more.",
		pagePath: "format/paragraph/index.mdx"
	},
	"styles.paragraph": {
		title: "Paragraph Styles",
		description: "Paragraph style reference operations (set/clear w:pStyle).",
		pagePath: "styles/paragraph/index.mdx"
	},
	tables: {
		title: "Tables",
		description: "Table structure, layout, styling, and cell operations.",
		pagePath: "tables/index.mdx"
	},
	history: {
		title: "History",
		description: "Undo/redo history state and navigation.",
		pagePath: "history/index.mdx"
	},
	toc: {
		title: "Table of Contents",
		description: "Table of contents lifecycle and configuration.",
		pagePath: "toc/index.mdx"
	},
	images: {
		title: "Images",
		description: "Image lifecycle, placement, and wrap configuration.",
		pagePath: "images/index.mdx"
	},
	hyperlinks: {
		title: "Hyperlinks",
		description: "Hyperlink discovery, creation, and metadata management.",
		pagePath: "hyperlinks/index.mdx"
	},
	headerFooters: {
		title: "Headers & Footers",
		description: "Structure, references, and part lifecycle for document headers and footers.",
		pagePath: "header-footers/index.mdx"
	},
	contentControls: {
		title: "Content Controls",
		description: "Content control (SDT) discovery, mutation, typed controls, and Word compatibility.",
		pagePath: "content-controls/index.mdx"
	},
	bookmarks: {
		title: "Bookmarks",
		description: "Named bookmark inspection, insertion, renaming, and removal.",
		pagePath: "bookmarks/index.mdx"
	},
	footnotes: {
		title: "Footnotes",
		description: "Footnote and endnote lifecycle and numbering configuration.",
		pagePath: "footnotes/index.mdx"
	},
	crossRefs: {
		title: "Cross-References",
		description: "Cross-reference field inspection, insertion, rebuild, and removal.",
		pagePath: "cross-refs/index.mdx"
	},
	index: {
		title: "Index",
		description: "Index (TABLE OF AUTHORITIES / INDEX field) lifecycle and XE entry operations.",
		pagePath: "index/index.mdx"
	},
	captions: {
		title: "Captions",
		description: "Caption (SEQ field) inspection, insertion, update, removal, and numbering configuration.",
		pagePath: "captions/index.mdx"
	},
	fields: {
		title: "Fields",
		description: "Raw field code inspection, insertion, rebuild, and removal.",
		pagePath: "fields/index.mdx"
	},
	citations: {
		title: "Citations",
		description: "Citation, source, and bibliography lifecycle operations.",
		pagePath: "citations/index.mdx"
	},
	authorities: {
		title: "Table of Authorities",
		description: "Table of authorities lifecycle and TA entry operations.",
		pagePath: "authorities/index.mdx"
	},
	ranges: {
		title: "Ranges",
		description: "Deterministic range construction from explicit document anchors.",
		pagePath: "ranges/index.mdx"
	},
	selection: {
		title: "Selection",
		description: "Read the editor's current selection as a portable, addressable target.",
		pagePath: "selection/index.mdx"
	},
	diff: {
		title: "Diff",
		description: "Snapshot-based document comparison and replay.",
		pagePath: "diff/index.mdx"
	},
	protection: {
		title: "Protection",
		description: "Document-level protection state and editing restriction operations.",
		pagePath: "protection/index.mdx"
	},
	permissionRanges: {
		title: "Permission Ranges",
		description: "Permission range exception operations for protected documents.",
		pagePath: "permission-ranges/index.mdx"
	},
	customXml: {
		title: "Custom XML",
		description: "Custom XML Data Storage Part operations (ECMA-376 §15.2.5, §15.2.6). Raw read and write of custom XML parts in the OOXML package.",
		pagePath: "custom-xml/index.mdx"
	},
	metadata: {
		title: "Anchored Metadata",
		description: "Attach a JSON payload to a span of text and read it back across DOCX round-trips. Backed by hidden inline content controls and namespaced Custom XML Data Storage Parts; consumers see one operation set.",
		pagePath: "metadata/index.mdx"
	}
};
Object.keys(GROUP_METADATA).map((key) => ({
	key,
	...GROUP_METADATA[key],
	operations: OPERATION_IDS.filter((id) => OPERATION_DEFINITIONS[id].referenceGroup === key)
}));
function step(opId, domain, description, options = {}) {
	return {
		opId,
		domain,
		surface: options.surface ?? "public",
		description,
		...options.referenceOperationId ? { referenceOperationId: options.referenceOperationId } : {}
	};
}
var STEP_OP_CATALOG_UNFROZEN = [
	step("assert", "assert", "Assert selector cardinality after mutation steps complete."),
	step("text.rewrite", "text", "Rewrite matched text ranges with replacement content.", { referenceOperationId: "replace" }),
	step("text.insert", "text", "Insert text before or after a matched range.", { referenceOperationId: "insert" }),
	step("text.delete", "text", "Delete matched text ranges.", { referenceOperationId: "delete" }),
	step("format.apply", "format", "Apply inline formatting patch changes to matched text ranges.", { referenceOperationId: "format.apply" }),
	step("create.paragraph", "create", "Create a paragraph adjacent to the matched block.", { referenceOperationId: "create.paragraph" }),
	step("create.heading", "create", "Create a heading adjacent to the matched block.", { referenceOperationId: "create.heading" }),
	step("create.table", "create", "Create a table at the requested location.", { referenceOperationId: "create.table" }),
	step("tables.delete", "tables", "Delete the target table from the document.", { referenceOperationId: "tables.delete" }),
	step("tables.clearContents", "tables", "Clear contents from a target table or cell range.", { referenceOperationId: "tables.clearContents" }),
	step("tables.move", "tables", "Move a table to a new position.", { referenceOperationId: "tables.move" }),
	step("tables.split", "tables", "Split a table into two tables at a target row.", { referenceOperationId: "tables.split" }),
	step("tables.convertFromText", "tables", "Convert a text range into a table.", { referenceOperationId: "tables.convertFromText" }),
	step("tables.convertToText", "tables", "Convert a table to plain text.", { referenceOperationId: "tables.convertToText" }),
	step("tables.setLayout", "tables", "Set table layout mode.", { referenceOperationId: "tables.setLayout" }),
	step("tables.insertRow", "tables", "Insert a row into the target table.", { referenceOperationId: "tables.insertRow" }),
	step("tables.deleteRow", "tables", "Delete a row from the target table.", { referenceOperationId: "tables.deleteRow" }),
	step("tables.setRowHeight", "tables", "Set row height in the target table.", { referenceOperationId: "tables.setRowHeight" }),
	step("tables.distributeRows", "tables", "Distribute row heights evenly.", { referenceOperationId: "tables.distributeRows" }),
	step("tables.setRowOptions", "tables", "Set row-level options (header repeat, page break, etc.).", { referenceOperationId: "tables.setRowOptions" }),
	step("tables.insertColumn", "tables", "Insert a column into the target table.", { referenceOperationId: "tables.insertColumn" }),
	step("tables.deleteColumn", "tables", "Delete a column from the target table.", { referenceOperationId: "tables.deleteColumn" }),
	step("tables.setColumnWidth", "tables", "Set column width in the target table.", { referenceOperationId: "tables.setColumnWidth" }),
	step("tables.distributeColumns", "tables", "Distribute column widths evenly.", { referenceOperationId: "tables.distributeColumns" }),
	step("tables.insertCell", "tables", "Insert a cell into a table row.", { referenceOperationId: "tables.insertCell" }),
	step("tables.deleteCell", "tables", "Delete a cell from a table row.", { referenceOperationId: "tables.deleteCell" }),
	step("tables.mergeCells", "tables", "Merge a range of table cells.", { referenceOperationId: "tables.mergeCells" }),
	step("tables.unmergeCells", "tables", "Unmerge a merged table cell.", { referenceOperationId: "tables.unmergeCells" }),
	step("tables.splitCell", "tables", "Split a table cell into multiple cells.", { referenceOperationId: "tables.splitCell" }),
	step("tables.setCellProperties", "tables", "Set properties on target table cells.", { referenceOperationId: "tables.setCellProperties" }),
	step("tables.sort", "tables", "Sort table rows by a column value.", { referenceOperationId: "tables.sort" }),
	step("tables.setAltText", "tables", "Set table alt text properties.", { referenceOperationId: "tables.setAltText" }),
	step("tables.setStyle", "tables", "Set table style identifier.", { referenceOperationId: "tables.setStyle" }),
	step("tables.clearStyle", "tables", "Clear direct table style assignment.", { referenceOperationId: "tables.clearStyle" }),
	step("tables.setStyleOption", "tables", "Set table style option flags.", { referenceOperationId: "tables.setStyleOption" }),
	step("tables.setBorder", "tables", "Set table border properties.", { referenceOperationId: "tables.setBorder" }),
	step("tables.clearBorder", "tables", "Clear table border properties.", { referenceOperationId: "tables.clearBorder" }),
	step("tables.applyBorderPreset", "tables", "Apply a border preset to a table.", { referenceOperationId: "tables.applyBorderPreset" }),
	step("tables.setShading", "tables", "Set table shading properties.", { referenceOperationId: "tables.setShading" }),
	step("tables.clearShading", "tables", "Clear table shading properties.", { referenceOperationId: "tables.clearShading" }),
	step("tables.setTablePadding", "tables", "Set table-level cell padding.", { referenceOperationId: "tables.setTablePadding" }),
	step("tables.setCellPadding", "tables", "Set cell padding for target cells.", { referenceOperationId: "tables.setCellPadding" }),
	step("tables.setCellSpacing", "tables", "Set table cell spacing.", { referenceOperationId: "tables.setCellSpacing" }),
	step("tables.clearCellSpacing", "tables", "Clear table cell spacing.", { referenceOperationId: "tables.clearCellSpacing" }),
	step("structural.insert", "structural", "Insert structural content (SDFragment) at a target position.", { referenceOperationId: "insert" }),
	step("structural.replace", "structural", "Replace content at a target range with structural content (SDFragment).", { referenceOperationId: "replace" }),
	step("domain.command", "internal", "Internal wrapper bridge op. Not a user-authored step.", { surface: "internal" })
];
Object.freeze(STEP_OP_CATALOG_UNFROZEN.map((entry) => Object.freeze(entry)));
var PUBLIC_STEP_OP_CATALOG_UNFROZEN = STEP_OP_CATALOG_UNFROZEN.filter((entry) => entry.surface === "public");
Object.freeze(PUBLIC_STEP_OP_CATALOG_UNFROZEN.map((entry) => Object.freeze(entry)));
Object.freeze(STEP_OP_CATALOG_UNFROZEN.map((entry) => entry.opId));
const PUBLIC_MUTATION_STEP_OP_IDS = Object.freeze(PUBLIC_STEP_OP_CATALOG_UNFROZEN.map((entry) => entry.opId));
var PUBLIC_MUTATION_STEP_OP_SET = new Set(PUBLIC_MUTATION_STEP_OP_IDS);
function isPublicMutationStepOp(opId) {
	return PUBLIC_MUTATION_STEP_OP_SET.has(opId);
}
const CAPABILITY_REASON_CODES = [
	"COMMAND_UNAVAILABLE",
	"HELPER_UNAVAILABLE",
	"OPERATION_UNAVAILABLE",
	"TRACKED_MODE_UNAVAILABLE",
	"DRY_RUN_UNAVAILABLE",
	"NAMESPACE_UNAVAILABLE",
	"STYLES_PART_MISSING",
	"COLLABORATION_ACTIVE"
];
function executeCapabilities(adapter) {
	return adapter.get();
}
function derivePropertyStateFromDirect(direct) {
	switch (direct) {
		case "on": return {
			direct,
			effective: true,
			provenance: "direct-on"
		};
		case "off": return {
			direct,
			effective: false,
			provenance: "direct-off"
		};
		case "clear": return {
			direct,
			effective: false,
			provenance: "unresolved"
		};
	}
}
var VALID_EDGE_VALUES = new Set(["before", "after"]);
var VALID_EDGE_NODE_TYPES = new Set(SELECTION_EDGE_NODE_TYPES);
function isSelectionEdgeNodeAddress(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "block") return false;
	if (typeof value.nodeType !== "string" || !VALID_EDGE_NODE_TYPES.has(value.nodeType)) return false;
	if (typeof value.nodeId !== "string" || value.nodeId === "") return false;
	return true;
}
function isSelectionPoint(value) {
	if (!isRecord(value)) return false;
	if (value.kind === "text") return typeof value.blockId === "string" && value.blockId !== "" && isInteger(value.offset) && value.offset >= 0;
	if (value.kind === "nodeEdge") return isSelectionEdgeNodeAddress(value.node) && typeof value.edge === "string" && VALID_EDGE_VALUES.has(value.edge);
	return false;
}
function isSelectionTarget(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "selection") return false;
	return isSelectionPoint(value.start) && isSelectionPoint(value.end);
}
function validateStoryLocator(value, field) {
	if (value === void 0 || value === null) return;
	if (!isStoryLocator(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a valid StoryLocator ({ kind: 'story', storyType: ... }).`, {
		field,
		value
	});
}
var VALID_DOCUMENT_EDGES = new Set(["start", "end"]);
var VALID_REF_BOUNDARIES = new Set(["start", "end"]);
var VALID_ANCHOR_KINDS = new Set([
	"document",
	"point",
	"ref"
]);
function validateAnchor(value, fieldName) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a non-null object.`, { field: fieldName });
	if (typeof value.kind !== "string" || !VALID_ANCHOR_KINDS.has(value.kind)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName}.kind must be "document", "point", or "ref", got ${JSON.stringify(value.kind)}.`, {
		field: `${fieldName}.kind`,
		value: value.kind
	});
	switch (value.kind) {
		case "document":
			if (typeof value.edge !== "string" || !VALID_DOCUMENT_EDGES.has(value.edge)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName}.edge must be "start" or "end", got ${JSON.stringify(value.edge)}.`, {
				field: `${fieldName}.edge`,
				value: value.edge
			});
			break;
		case "point":
			if (!isSelectionPoint(value.point)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName}.point must be a valid SelectionPoint.`, {
				field: `${fieldName}.point`,
				value: value.point
			});
			break;
		case "ref":
			if (typeof value.ref !== "string" || value.ref === "") throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName}.ref must be a non-empty string.`, {
				field: `${fieldName}.ref`,
				value: value.ref
			});
			if (typeof value.boundary !== "string" || !VALID_REF_BOUNDARIES.has(value.boundary)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName}.boundary must be "start" or "end", got ${JSON.stringify(value.boundary)}.`, {
				field: `${fieldName}.boundary`,
				value: value.boundary
			});
			break;
	}
}
var RESOLVE_RANGE_ALLOWED_KEYS = new Set([
	"start",
	"end",
	"expectedRevision",
	"in"
]);
function validateResolveRangeInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "ranges.resolve input must be a non-null object.");
	assertNoUnknownFields(input, RESOLVE_RANGE_ALLOWED_KEYS, "ranges.resolve");
	if (input.start === void 0) throw new DocumentApiValidationError("INVALID_INPUT", "ranges.resolve input must provide \"start\".", { field: "start" });
	if (input.end === void 0) throw new DocumentApiValidationError("INVALID_INPUT", "ranges.resolve input must provide \"end\".", { field: "end" });
	validateAnchor(input.start, "start");
	validateAnchor(input.end, "end");
	if (input.expectedRevision !== void 0 && typeof input.expectedRevision !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `expectedRevision must be a string, got ${typeof input.expectedRevision}.`, {
		field: "expectedRevision",
		value: input.expectedRevision
	});
	validateStoryLocator(input.in, "in");
}
function executeResolveRange(adapter, input) {
	validateResolveRangeInput(input);
	return adapter.resolve(input);
}
var SELECTION_CURRENT_ALLOWED_KEYS = new Set(["includeText"]);
function validateSelectionCurrentInput(input) {
	if (input === void 0) return;
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "selection.current input must be a non-null object.");
	assertNoUnknownFields(input, SELECTION_CURRENT_ALLOWED_KEYS, "selection.current");
	if (input.includeText !== void 0 && typeof input.includeText !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `includeText must be a boolean, got ${typeof input.includeText}.`, {
		field: "includeText",
		value: input.includeText
	});
}
function executeSelectionCurrent(adapter, input) {
	validateSelectionCurrentInput(input);
	return adapter.current(input ?? {});
}
function executeMarkdownToFragment(adapter, input) {
	return adapter.markdownToFragment(input);
}
var CREATE_COMMENT_ALLOWED_KEYS = new Set([
	"target",
	"text",
	"parentCommentId"
]);
function isTrackedChangeCommentTarget(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== void 0 && value.kind !== "trackedChange") return false;
	return typeof value.trackedChangeId === "string" && value.trackedChangeId.length > 0;
}
function validateCommentTarget(target, operationName) {
	if (isTextAddress(target) || isTextTarget(target) || isSelectionTarget(target)) return;
	if (isTrackedChangeCommentTarget(target)) {
		validateStoryLocator(target.story, "target.story");
		return;
	}
	throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a TextAddress, TextTarget, SelectionTarget, or tracked-change target.`, {
		field: "target",
		value: target
	});
}
function validateCreateCommentInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "comments.create input must be a non-null object.");
	assertNoUnknownFields(input, CREATE_COMMENT_ALLOWED_KEYS, "comments.create");
	const { target, text: text$2, parentCommentId } = input;
	const hasTarget = target !== void 0;
	const isReply = parentCommentId !== void 0;
	if (typeof text$2 !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `text must be a string, got ${typeof text$2}.`, {
		field: "text",
		value: text$2
	});
	if (isReply) {
		if (typeof parentCommentId !== "string" || parentCommentId.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "parentCommentId must be a non-empty string.", {
			field: "parentCommentId",
			value: parentCommentId
		});
		if (hasTarget) throw new DocumentApiValidationError("INVALID_INPUT", "Cannot combine parentCommentId with target. Replies do not take a target.", { fields: ["parentCommentId", "target"] });
		return;
	}
	if (!hasTarget) throw new DocumentApiValidationError("INVALID_TARGET", "comments.create requires a target for root comments.", { field: "target" });
	validateCommentTarget(target, "comments.create");
}
var PATCH_COMMENT_ALLOWED_KEYS = new Set([
	"commentId",
	"target",
	"text",
	"status",
	"isInternal"
]);
function validatePatchCommentInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "comments.patch input must be a non-null object.");
	assertNoUnknownFields(input, PATCH_COMMENT_ALLOWED_KEYS, "comments.patch");
	const { commentId, target } = input;
	const hasTarget = target !== void 0;
	if (typeof commentId !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `commentId must be a string, got ${typeof commentId}.`, {
		field: "commentId",
		value: commentId
	});
	const mutationFields = [
		"text",
		"target",
		"status",
		"isInternal"
	];
	const providedFields = mutationFields.filter((f) => input[f] !== void 0);
	if (providedFields.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "comments.patch requires exactly one mutation field (text, target, status, or isInternal).", { allowedFields: [...mutationFields] });
	if (providedFields.length > 1) throw new DocumentApiValidationError("INVALID_INPUT", `comments.patch accepts exactly one mutation field per call, got ${providedFields.length}: ${providedFields.join(", ")}.`, { providedFields: [...providedFields] });
	const { text: text$2, status, isInternal } = input;
	if (text$2 !== void 0 && typeof text$2 !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `text must be a string, got ${typeof text$2}.`, {
		field: "text",
		value: text$2
	});
	if (status !== void 0 && status !== "resolved" && status !== "active") throw new DocumentApiValidationError("INVALID_INPUT", `status must be "resolved" or "active", got "${String(status)}".`, {
		field: "status",
		value: status
	});
	if (isInternal !== void 0 && typeof isInternal !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `isInternal must be a boolean, got ${typeof isInternal}.`, {
		field: "isInternal",
		value: isInternal
	});
	if (hasTarget) validateCommentTarget(target, "comments.patch");
}
function executeCommentsCreate(adapter, input, options) {
	validateCreateCommentInput(input);
	if (input.parentCommentId !== void 0) return adapter.reply({
		parentCommentId: input.parentCommentId,
		text: input.text
	}, options);
	return adapter.add(input, options);
}
function executeCommentsPatch(adapter, input, options) {
	validatePatchCommentInput(input);
	if (input.text !== void 0) return adapter.edit({
		commentId: input.commentId,
		text: input.text
	}, options);
	if (input.target !== void 0) return adapter.move({
		commentId: input.commentId,
		target: input.target
	}, options);
	if (input.status === "resolved") return adapter.resolve({ commentId: input.commentId }, options);
	if (input.status === "active") return adapter.reopen({ commentId: input.commentId }, options);
	if (input.isInternal !== void 0) return adapter.setInternal({
		commentId: input.commentId,
		isInternal: input.isInternal
	}, options);
	throw new DocumentApiValidationError("INTERNAL_ERROR", "comments.patch: no mutation field matched after validation. This is a bug.");
}
function validateCommentIdInput(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} input must be a non-null object.`);
	if (typeof input.commentId !== "string" || input.commentId.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} commentId must be a non-empty string.`, {
		field: "commentId",
		value: input.commentId
	});
}
function executeCommentsDelete(adapter, input, options) {
	validateCommentIdInput(input, "comments.delete");
	return adapter.remove({ commentId: input.commentId }, options);
}
function executeGetComment(adapter, input) {
	validateCommentIdInput(input, "comments.get");
	return adapter.get(input);
}
function executeListComments(adapter, query) {
	if (query !== void 0 && !isRecord(query)) throw new DocumentApiValidationError("INVALID_INPUT", "comments.list query must be an object if provided.");
	return adapter.list(query);
}
function executeFind(adapter, input) {
	return adapter.find(input);
}
function validateTargetLocator$1(input, operation) {
	const hasTarget = input.target !== void 0;
	const hasRef = input.ref !== void 0;
	if (hasTarget && hasRef) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} input must provide either "target" or "ref", not both.`, { fields: ["target", "ref"] });
	if (!hasTarget && !hasRef) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} input must provide either "target" or "ref".`, { fields: ["target", "ref"] });
	if (hasTarget && !isSelectionTarget(input.target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a SelectionTarget object.", {
		field: "target",
		value: input.target
	});
	if (hasRef && (typeof input.ref !== "string" || input.ref === "")) throw new DocumentApiValidationError("INVALID_TARGET", "ref must be a non-empty string.", {
		field: "ref",
		value: input.ref
	});
}
var STYLE_APPLY_INPUT_ALLOWED_KEYS = new Set([
	"target",
	"ref",
	"inline",
	"in"
]);
function validateStyleApplyInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "format.apply input must be a non-null object.");
	assertNoUnknownFields(input, STYLE_APPLY_INPUT_ALLOWED_KEYS, "format.apply");
	validateStoryLocator(input.in, "in");
	validateTargetLocator$1(input, "format.apply");
	if (input.inline === void 0 || input.inline === null) throw new DocumentApiValidationError("INVALID_INPUT", "format.apply requires an inline object.");
	validateInlineRunPatch(input.inline);
}
function executeStyleApply(adapter, input, options) {
	validateStyleApplyInput(input);
	const request = input.target ? {
		kind: "format",
		target: input.target,
		inline: input.inline,
		in: input.in
	} : {
		kind: "format",
		ref: input.ref,
		inline: input.inline,
		in: input.in
	};
	return adapter.execute(request, normalizeMutationOptions(options));
}
var INLINE_ALIAS_INPUT_ALLOWED_KEYS = new Set([
	"target",
	"ref",
	"value",
	"in"
]);
function acceptsImplicitTrue(key) {
	return INLINE_PROPERTY_BY_KEY[key].type === "boolean" || key === "underline";
}
function normalizeInlineAliasValue(key, value) {
	if (value !== void 0) return value;
	if (acceptsImplicitTrue(key)) return true;
	throw new DocumentApiValidationError("INVALID_INPUT", `format.${key} requires a value field.`);
}
function validateInlineAliasInput(key, input) {
	const operation = `format.${key}`;
	const candidate = isRecord(input) ? input : {};
	assertNoUnknownFields(candidate, INLINE_ALIAS_INPUT_ALLOWED_KEYS, operation);
	validateStoryLocator(candidate.in, "in");
	validateTargetLocator$1(candidate, operation);
}
function executeInlineAlias(adapter, key, input, options) {
	validateInlineAliasInput(key, input);
	const value = normalizeInlineAliasValue(key, input.value);
	const inline = { [key]: value };
	validateInlineRunPatch(inline);
	const request = input.target ? {
		kind: "format",
		target: input.target,
		inline,
		in: input.in
	} : {
		kind: "format",
		ref: input.ref,
		inline,
		in: input.in
	};
	return adapter.execute(request, normalizeMutationOptions(options));
}
function normalizeOptions(options) {
	return {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision === void 0 ? void 0 : String(options.expectedRevision)
	};
}
function validateTemplatesApplyInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "templates.apply input must be a non-null object.");
	const allowedKeys = new Set(["source", "bodyPolicy"]);
	for (const key of Object.keys(input)) if (!allowedKeys.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${key}" on templates.apply input. Allowed fields: ${[...allowedKeys].join(", ")}.`, { field: key });
	const { source, bodyPolicy } = input;
	if (!isRecord(source)) throw new DocumentApiValidationError("INVALID_INPUT", "templates.apply requires a source object.", {
		field: "source",
		value: source
	});
	if (source.kind === "path") {
		const sourceKeys = new Set(["kind", "path"]);
		for (const key of Object.keys(source)) if (!sourceKeys.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "source.${key}". Allowed fields: ${[...sourceKeys].join(", ")}.`, { field: `source.${key}` });
		if (typeof source.path !== "string" || source.path.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "source.path must be a non-empty string.", {
			field: "source.path",
			value: source.path
		});
	} else if (source.kind === "base64") {
		const sourceKeys = new Set([
			"kind",
			"data",
			"filename"
		]);
		for (const key of Object.keys(source)) if (!sourceKeys.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "source.${key}". Allowed fields: ${[...sourceKeys].join(", ")}.`, { field: `source.${key}` });
		if (typeof source.data !== "string" || source.data.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "source.data must be a non-empty string.", {
			field: "source.data",
			value: source.data
		});
		if (source.filename !== void 0 && typeof source.filename !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "source.filename must be a string when present.", {
			field: "source.filename",
			value: source.filename
		});
	} else throw new DocumentApiValidationError("INVALID_INPUT", `source.kind must be "path" or "base64", got ${JSON.stringify(source.kind)}.`, {
		field: "source.kind",
		value: source.kind
	});
	if (bodyPolicy !== void 0 && bodyPolicy !== "preserve") throw new DocumentApiValidationError("INVALID_INPUT", `bodyPolicy must be "preserve" when present, got ${JSON.stringify(bodyPolicy)}.`, {
		field: "bodyPolicy",
		value: bodyPolicy
	});
}
function executeTemplatesApply(adapter, input, options) {
	validateTemplatesApplyInput(input);
	return adapter.apply(input, normalizeOptions(options));
}
function executeGetNode(adapter, address) {
	return adapter.getNode(address);
}
function executeGetNodeById(adapter, input) {
	return adapter.getNodeById(input);
}
function executeGet(adapter, input) {
	return adapter.get(input);
}
function executeGetText(adapter, input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "getText input must be a non-null object.");
	validateStoryLocator(input.in, "in");
	return adapter.getText(input);
}
function executeGetMarkdown(adapter, input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "getMarkdown input must be a non-null object.");
	validateStoryLocator(input.in, "in");
	return adapter.getMarkdown(input);
}
function executeGetHtml(adapter, input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "getHtml input must be a non-null object.");
	validateStoryLocator(input.in, "in");
	return adapter.getHtml(input);
}
function executeInfo(adapter, input) {
	return adapter.info(input);
}
function executeExtract(adapter, input) {
	return adapter.extract(input);
}
function executeClearContent(adapter, input, options) {
	return adapter.clearContent(input, options);
}
var DELETE_INPUT_ALLOWED_KEYS = new Set([
	"target",
	"ref",
	"behavior",
	"in"
]);
var VALID_BEHAVIORS = new Set(["selection", "exact"]);
function validateDeleteInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", "Delete input must be a non-null object.");
	assertNoUnknownFields(input, DELETE_INPUT_ALLOWED_KEYS, "delete");
	validateStoryLocator(input.in, "in");
	const { target, ref: ref$1, behavior } = input;
	const hasTarget = target !== void 0;
	const hasRef = ref$1 !== void 0;
	if (hasTarget && hasRef) throw new DocumentApiValidationError("INVALID_INPUT", "Delete input must provide either \"target\" or \"ref\", not both.", { fields: ["target", "ref"] });
	if (!hasTarget && !hasRef) throw new DocumentApiValidationError("INVALID_INPUT", "Delete input must provide either \"target\" or \"ref\".", { fields: ["target", "ref"] });
	if (hasTarget && !isSelectionTarget(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a SelectionTarget object.", {
		field: "target",
		value: target
	});
	if (hasRef && (typeof ref$1 !== "string" || ref$1 === "")) throw new DocumentApiValidationError("INVALID_TARGET", "ref must be a non-empty string.", {
		field: "ref",
		value: ref$1
	});
	if (behavior !== void 0 && !VALID_BEHAVIORS.has(behavior)) throw new DocumentApiValidationError("INVALID_INPUT", `behavior must be "selection" or "exact", got "${String(behavior)}".`, {
		field: "behavior",
		value: behavior
	});
}
function executeDelete$1(adapter, input, options) {
	validateDeleteInput(input);
	const request = input.target ? {
		kind: "delete",
		target: input.target,
		behavior: input.behavior ?? "selection",
		in: input.in
	} : {
		kind: "delete",
		ref: input.ref,
		behavior: input.behavior ?? "selection",
		in: input.in
	};
	return adapter.execute(request, normalizeMutationOptions(options));
}
var CONTENT_KIND_SET = new Set(SD_CONTENT_NODE_KINDS);
var INLINE_KIND_SET = new Set(SD_INLINE_NODE_KINDS);
var LEGACY_TOP_LEVEL_TYPES = new Set([
	"paragraph",
	"heading",
	"table",
	"image",
	"list",
	"sectionBreak",
	"tableOfContents",
	"sdt"
]);
function validateSDFragment(fragment) {
	const nodes = normalizeToNodeArray(fragment, "INVALID_PAYLOAD");
	const seenIds = /* @__PURE__ */ new Set();
	for (const node of nodes) validateContentNode(node, seenIds);
}
function validateDocumentFragment(fragment) {
	if (fragment === null || fragment === void 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Fragment must not be null or undefined.");
	const nodes = Array.isArray(fragment) ? fragment : [fragment];
	if (nodes.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Fragment must contain at least one node.");
	const first = nodes[0];
	if (isRecord(first) && typeof first.kind === "string") {
		validateSDFragment(fragment);
		return;
	}
	for (const node of nodes) validateLegacyTopLevelNode(node);
}
function normalizeToNodeArray(fragment, errorCode) {
	if (fragment === null || fragment === void 0) throw new DocumentApiValidationError(errorCode, "Fragment must not be null or undefined.");
	const nodes = Array.isArray(fragment) ? fragment : [fragment];
	if (nodes.length === 0) throw new DocumentApiValidationError(errorCode, "Fragment must contain at least one node.");
	return nodes;
}
function validateContentNode(node, seenIds) {
	assertPlainObject(node);
	const rec = node;
	const kind = assertKindField(rec);
	if (!CONTENT_KIND_SET.has(kind) && !kind.startsWith("ext.")) throw new DocumentApiValidationError("INVALID_PAYLOAD", `"${kind}" is not a valid content node kind.`, { kind });
	validatePayloadKeyMatchesKind(rec, kind);
	collectAndCheckId(rec, seenIds);
	validateContentByKind(rec, kind, seenIds);
}
function assertPlainObject(node) {
	if (!isRecord(node)) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Each node in a fragment must be a plain object.");
}
function assertKindField(rec) {
	if (typeof rec.kind !== "string" || rec.kind.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Each content node must have a non-empty string \"kind\" field.");
	return rec.kind;
}
function validatePayloadKeyMatchesKind(rec, kind) {
	if (kind.startsWith("ext.")) return;
	if (new Set([
		"break",
		"sectionBreak",
		"tab",
		"lineBreak",
		"footnoteRef",
		"endnoteRef"
	]).has(kind)) return;
	if (!(kind in rec)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `Node with kind "${kind}" must have a "${kind}" payload key.`, { kind });
	if (rec[kind] !== void 0 && !isRecord(rec[kind])) throw new DocumentApiValidationError("INVALID_PAYLOAD", `"${kind}" payload must be an object.`, { kind });
}
function collectAndCheckId(rec, seenIds) {
	const id = rec.id;
	if (typeof id !== "string") return;
	if (seenIds.has(id)) throw new DocumentApiValidationError("DUPLICATE_ID", `Duplicate node ID "${id}" in fragment.`, { id });
	seenIds.add(id);
}
function validateContentByKind(rec, kind, seenIds) {
	switch (kind) {
		case "paragraph":
			validateParagraphPayload(rec, seenIds);
			break;
		case "heading":
			validateHeadingPayload(rec, seenIds);
			break;
		case "table":
			validateTablePayload(rec, seenIds);
			break;
		case "list":
			validateListPayload(rec, seenIds);
			break;
		case "image":
			validateImagePayload(rec);
			break;
		case "sdt":
		case "customXml":
			validateSdtPayload(rec, kind, seenIds);
			break;
		case "toc":
			validateTocPayload(rec);
			break;
		case "sectionBreak":
			validateSectionBreakPayload(rec);
			break;
	}
}
function validateParagraphPayload(rec, seenIds) {
	const payload = rec.paragraph;
	if (!payload) return;
	if (payload.numbering != null && isRecord(payload.numbering)) {
		const numbering = payload.numbering;
		if (typeof numbering.level === "number") {
			const level = numbering.level;
			if (!Number.isInteger(level) || level < 0 || level > 8) throw new DocumentApiValidationError("INVALID_PAYLOAD", `paragraph.numbering.level must be an integer 0–8, got ${level}.`, { field: "numbering.level" });
		}
	}
	if (Array.isArray(payload.tabs)) {
		for (const tab of payload.tabs) if (isRecord(tab)) {
			const pos = tab.position;
			if (typeof pos === "number" && pos <= 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", `paragraph.tabs position must be positive, got ${pos}.`, { field: "tabs.position" });
		}
	}
	if (payload.inlines !== void 0) validateInlinesArray(payload.inlines, "paragraph", seenIds);
}
function validateHeadingPayload(rec, seenIds) {
	const payload = rec.heading;
	if (!payload) throw new DocumentApiValidationError("INVALID_PAYLOAD", "heading payload must be an object.");
	const level = payload.level;
	if (typeof level !== "number" || !Number.isInteger(level) || level < 1 || level > 6) throw new DocumentApiValidationError("INVALID_PAYLOAD", `Heading level must be an integer between 1 and 6, got ${JSON.stringify(level)}.`, { field: "level" });
	if (payload.inlines !== void 0) validateInlinesArray(payload.inlines, "heading", seenIds);
}
function validateTablePayload(rec, seenIds) {
	const payload = rec.table;
	if (!payload) throw new DocumentApiValidationError("INVALID_PAYLOAD", "table payload must be an object.");
	if (!Array.isArray(payload.rows) || payload.rows.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Table must have at least one row.", { field: "rows" });
	for (const row of payload.rows) {
		assertPlainObject(row);
		const rowRec = row;
		collectAndCheckId(rowRec, seenIds);
		if (!Array.isArray(rowRec.cells) || rowRec.cells.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Table row must have at least one cell.", { field: "cells" });
		for (const cell of rowRec.cells) {
			assertPlainObject(cell);
			const cellRec = cell;
			collectAndCheckId(cellRec, seenIds);
			validatePositiveInt(cellRec, "rowSpan");
			validatePositiveInt(cellRec, "colSpan");
			if (Array.isArray(cellRec.content)) for (const child of cellRec.content) validateContentNode(child, seenIds);
		}
	}
}
function validatePositiveInt(rec, field) {
	const val = rec[field];
	if (val === void 0) return;
	if (typeof val !== "number" || !Number.isInteger(val) || val < 1) throw new DocumentApiValidationError("INVALID_PAYLOAD", `${field} must be a positive integer, got ${JSON.stringify(val)}.`, { field });
}
function validateListPayload(rec, seenIds) {
	const payload = rec.list;
	if (!payload) throw new DocumentApiValidationError("INVALID_PAYLOAD", "list payload must be an object.");
	if (!Array.isArray(payload.items) || payload.items.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "List must have at least one item.", { field: "items" });
	for (const item of payload.items) {
		assertPlainObject(item);
		const itemRec = item;
		collectAndCheckId(itemRec, seenIds);
		if (itemRec.inlines !== void 0) validateInlinesArray(itemRec.inlines, "listItem", seenIds);
		if (Array.isArray(itemRec.content)) for (const child of itemRec.content) {
			validateContentNode(child, seenIds);
			rejectNumberingInsideListItem(child);
		}
	}
}
function rejectNumberingInsideListItem(node) {
	if (!isRecord(node)) return;
	const rec = node;
	const kind = rec.kind;
	if (kind === "paragraph" || kind === "heading") {
		const payload = rec[kind];
		if (!payload) return;
		if (payload.props?.numbering != null) throw new DocumentApiValidationError("INVALID_PAYLOAD", `${kind}.props.numbering conflicts with SDList context. Use SDList levels to define numbering; paragraph-level numbering is read-only fidelity data.`, {
			field: "numbering",
			kind
		});
	}
}
function validateImagePayload(rec) {
	const payload = rec.image;
	if (!payload) throw new DocumentApiValidationError("INVALID_PAYLOAD", "image payload must be an object.");
	if (typeof payload.src !== "string" || payload.src.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Image node requires a non-empty \"src\" string.", { field: "src" });
}
function validateSdtPayload(rec, kind, seenIds) {
	const payload = rec[kind];
	if (!payload) return;
	const hasInlines = payload.inlines !== void 0;
	const hasContent = payload.content !== void 0;
	if (hasInlines && hasContent) throw new DocumentApiValidationError("INVALID_PAYLOAD", `${kind} must provide either "inlines" or "content", not both.`, { kind });
	if (hasInlines) validateInlinesArray(payload.inlines, kind, seenIds);
	if (hasContent && Array.isArray(payload.content)) for (const child of payload.content) validateContentNode(child, seenIds);
}
function validateTocPayload(rec) {
	const payload = rec.toc;
	if (!payload) return;
	const sourceConfig = isRecord(payload.sourceConfig) ? payload.sourceConfig : void 0;
	const displayConfig = isRecord(payload.displayConfig) ? payload.displayConfig : void 0;
	if (sourceConfig && isRecord(sourceConfig.outlineLevels)) {
		const range = sourceConfig.outlineLevels;
		const from = range.from;
		const to = range.to;
		if (typeof from === "number" && (from < 1 || from > 9)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.outlineLevels.from must be 1–9, got ${from}.`);
		if (typeof to === "number" && (to < 1 || to > 9)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.outlineLevels.to must be 1–9, got ${to}.`);
		if (typeof from === "number" && typeof to === "number" && from > to) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.outlineLevels.from (${from}) must be <= to (${to}).`);
	}
	if (sourceConfig && isRecord(sourceConfig.tcFieldLevels)) {
		const range = sourceConfig.tcFieldLevels;
		const from = range.from;
		const to = range.to;
		if (typeof from === "number" && (from < 1 || from > 9)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.tcFieldLevels.from must be 1–9, got ${from}.`);
		if (typeof to === "number" && (to < 1 || to > 9)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.tcFieldLevels.to must be 1–9, got ${to}.`);
		if (typeof from === "number" && typeof to === "number" && from > to) throw new DocumentApiValidationError("INVALID_PAYLOAD", `TOC sourceConfig.tcFieldLevels.from (${from}) must be <= to (${to}).`);
	}
	if (displayConfig) {
		if (displayConfig.includePageNumbers === false && isRecord(displayConfig.omitPageNumberLevels)) throw new DocumentApiValidationError("INVALID_PAYLOAD", "TOC cannot set displayConfig.includePageNumbers=false and also provide displayConfig.omitPageNumberLevels.");
		if (displayConfig.tabLeader !== void 0 && displayConfig.separator !== void 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "TOC cannot set both displayConfig.tabLeader and displayConfig.separator.");
	}
}
function validateSectionBreakPayload(rec) {
	const payload = rec.sectionBreak;
	if (!payload) return;
	if (payload.targetSectionId !== void 0) {
		if (typeof payload.targetSectionId !== "string" || payload.targetSectionId.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "sectionBreak.targetSectionId must be a non-empty string when provided.", { field: "targetSectionId" });
	}
}
function validateInlinesArray(inlines, parentKind, seenIds) {
	if (!Array.isArray(inlines)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `${parentKind} inlines must be an array.`, { field: "inlines" });
	for (const item of inlines) validateInlineNode(item, parentKind, seenIds, false);
}
function validateInlineNode(node, parentKind, seenIds, insideHyperlink) {
	assertPlainObject(node);
	const rec = node;
	if (typeof rec.kind !== "string") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Each inline node in ${parentKind} must have a string "kind" field.`);
	const kind = rec.kind;
	if (!INLINE_KIND_SET.has(kind) && !kind.startsWith("ext.")) throw new DocumentApiValidationError("INVALID_PAYLOAD", `"${kind}" is not a valid inline node kind in ${parentKind}.`, { kind });
	collectAndCheckId(rec, seenIds);
	if (kind === "hyperlink") {
		if (insideHyperlink) throw new DocumentApiValidationError("INVALID_NESTING", "Hyperlinks cannot be nested inside other hyperlinks.");
		const hPayload = rec.hyperlink;
		if (hPayload && Array.isArray(hPayload.inlines)) for (const child of hPayload.inlines) validateInlineNode(child, "hyperlink", seenIds, true);
	}
}
function validateLegacyTopLevelNode(node) {
	assertLegacyNodeShape(node);
	const rec = node;
	const type = rec.type;
	if (!LEGACY_TOP_LEVEL_TYPES.has(type)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `"${type}" is not valid at the top level. Valid types: ${[...LEGACY_TOP_LEVEL_TYPES].join(", ")}.`, { nodeType: type });
	validateLegacyNodeContent(rec, type);
}
function assertLegacyNodeShape(node) {
	if (!isRecord(node)) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Each node in a fragment must be a plain object.");
	const rec = node;
	if (typeof rec.kind !== "string" && typeof rec.type !== "string") throw new DocumentApiValidationError("INVALID_PAYLOAD", "Each node must have a string \"kind\" (SDM/1) or \"type\" (legacy) field.");
}
function validateLegacyNodeContent(node, type) {
	switch (type) {
		case "paragraph":
			if (node.content !== void 0) validateLegacyInlineArray(node.content, "paragraph");
			break;
		case "heading":
			validateLegacyHeading(node);
			break;
		case "table":
			validateLegacyTable(node);
			break;
		case "list":
			validateLegacyList(node);
			break;
		case "sdt":
			validateLegacySdt(node);
			break;
		case "image":
			validateLegacyImage(node);
			break;
	}
}
function validateLegacyHeading(node) {
	const level = node.level;
	if (typeof level !== "number" || level < 1 || level > 6 || !Number.isInteger(level)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `Heading level must be an integer between 1 and 6, got ${JSON.stringify(level)}.`, { field: "level" });
	if (node.content !== void 0) validateLegacyInlineArray(node.content, "heading");
}
function validateLegacyTable(node) {
	if (!Array.isArray(node.rows) || node.rows.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Table must have at least one row.", { field: "rows" });
	for (const row of node.rows) {
		assertLegacyNodeShape(row);
		const rowRec = row;
		if (rowRec.type !== "tableRow") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Table rows must have type "tableRow", got "${String(rowRec.type)}".`);
		if (!Array.isArray(rowRec.cells) || rowRec.cells.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Table row must have at least one cell.", { field: "cells" });
		for (const cell of rowRec.cells) {
			assertLegacyNodeShape(cell);
			const cellRec = cell;
			if (cellRec.type !== "tableCell") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Table cells must have type "tableCell", got "${String(cellRec.type)}".`);
			if (cellRec.content !== void 0) {
				if (!Array.isArray(cellRec.content)) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Table cell content must be an array.");
				for (const child of cellRec.content) {
					assertLegacyNodeShape(child);
					const childType = child.type;
					if (childType !== "paragraph" && childType !== "heading") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Table cell content must be paragraphs or headings, got "${String(childType)}".`);
				}
			}
		}
	}
}
function validateLegacyList(node) {
	if (!Array.isArray(node.items) || node.items.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "List must have at least one item.", { field: "items" });
	for (const item of node.items) {
		assertLegacyNodeShape(item);
		const itemRec = item;
		if (itemRec.type !== "listItem") throw new DocumentApiValidationError("INVALID_PAYLOAD", `List items must have type "listItem", got "${String(itemRec.type)}".`);
		if (itemRec.content !== void 0) validateLegacyInlineArray(itemRec.content, "listItem");
	}
}
function validateLegacySdt(node) {
	if (node.content !== void 0) {
		if (!Array.isArray(node.content)) throw new DocumentApiValidationError("INVALID_PAYLOAD", "SDT content must be an array.");
		for (const child of node.content) {
			assertLegacyNodeShape(child);
			const childType = child.type;
			if (childType !== "paragraph" && childType !== "heading") throw new DocumentApiValidationError("INVALID_PAYLOAD", `SDT content must be paragraphs or headings, got "${String(childType)}".`);
		}
	}
}
function validateLegacyImage(node) {
	if (typeof node.src !== "string" || node.src.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", "Image node requires a non-empty \"src\" string.", { field: "src" });
}
function validateLegacyInlineArray(content$2, parentType) {
	if (!Array.isArray(content$2)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `${parentType} content must be an array of inline content.`, { field: "content" });
	for (const item of content$2) validateLegacyInlineContent(item, parentType);
}
function validateLegacyInlineContent(item, parentType) {
	if (!isRecord(item)) throw new DocumentApiValidationError("INVALID_PAYLOAD", `Each inline content item in ${parentType} must be a plain object.`);
	const itemType = item.type;
	if (itemType !== "text" && itemType !== "image") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Inline content type must be "text" or "image", got "${String(itemType)}".`, { field: "type" });
	if (itemType === "text") {
		if (typeof item.text !== "string") throw new DocumentApiValidationError("INVALID_PAYLOAD", `Inline text content in ${parentType} requires a "text" string field.`, { field: "text" });
	} else if (itemType === "image") {
		const src = item.src;
		if (typeof src !== "string" || src.length === 0) throw new DocumentApiValidationError("INVALID_PAYLOAD", `Inline image content in ${parentType} requires a non-empty "src" string field.`, { field: "src" });
	}
}
function buildResolution(resolution) {
	return {
		target: resolution.target,
		range: resolution.range,
		...resolution.selectionTarget ? { selectionTarget: resolution.selectionTarget } : {}
	};
}
function textReceiptToSDReceipt(receipt) {
	if (receipt.success) return {
		success: true,
		resolution: receipt.resolution ? buildResolution(receipt.resolution) : void 0
	};
	const failure = {
		code: "INTERNAL_ERROR",
		message: receipt.failure.message,
		...receipt.failure.details != null ? { details: receipt.failure.details } : {}
	};
	failure.code = {
		INVALID_TARGET: "INVALID_TARGET",
		TARGET_NOT_FOUND: "TARGET_NOT_FOUND",
		NO_OP: "NO_OP",
		UNSUPPORTED_ENVIRONMENT: "UNSUPPORTED_ENVIRONMENT",
		INVALID_NESTING: "INVALID_NESTING",
		INVALID_PLACEMENT: "INVALID_PLACEMENT",
		INVALID_PAYLOAD: "INVALID_PAYLOAD",
		CAPABILITY_UNAVAILABLE: "CAPABILITY_UNSUPPORTED",
		CAPABILITY_UNSUPPORTED: "CAPABILITY_UNSUPPORTED",
		REVISION_MISMATCH: "REVISION_MISMATCH",
		INTERNAL_ERROR: "INTERNAL_ERROR"
	}[receipt.failure.code] ?? "INTERNAL_ERROR";
	return {
		success: false,
		failure,
		resolution: receipt.resolution ? buildResolution(receipt.resolution) : void 0
	};
}
function buildStructuralReceipt(success, params, failure) {
	const resolution = {
		target: params.target,
		range: params.range,
		...params.selectionTarget ? { selectionTarget: params.selectionTarget } : {}
	};
	if (success) return {
		success: true,
		resolution
	};
	return {
		success: false,
		failure: {
			code: failure?.code ?? "INTERNAL_ERROR",
			message: failure?.message ?? ""
		},
		resolution
	};
}
var TEXT_INSERT_ALLOWED_KEYS = new Set([
	"value",
	"type",
	"target",
	"ref",
	"in",
	"placement"
]);
var STRUCTURAL_INSERT_ALLOWED_KEYS = new Set([
	"content",
	"target",
	"placement",
	"nestingPolicy",
	"in"
]);
var VALID_INSERT_TYPES = new Set([
	"text",
	"markdown",
	"html"
]);
function isStructuralInsertInput(input) {
	return "content" in input && input.content !== void 0;
}
function validateInsertInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", "Insert input must be a non-null object.");
	const hasValue = "value" in input && input.value !== void 0;
	const hasContent = "content" in input && input.content !== void 0;
	if (hasValue && hasContent) throw new DocumentApiValidationError("INVALID_INPUT", "Insert input must provide either \"value\" (text) or \"content\" (structural), not both.", { fields: ["value", "content"] });
	if (!hasValue && !hasContent) throw new DocumentApiValidationError("INVALID_INPUT", "Insert input must provide either \"value\" (text string) or \"content\" (SDFragment).", { fields: ["value", "content"] });
	validateStoryLocator(input.in, "in");
	if (hasContent) validateStructuralInsertInput(input);
	else validateTextInsertInput(input);
}
function validateTextInsertInput(input) {
	const contentType = typeof input.type === "string" ? input.type : "text";
	const isRichContent = contentType === "markdown" || contentType === "html";
	if ("placement" in input && input.placement !== void 0 && !isRichContent) throw new DocumentApiValidationError("INVALID_INPUT", "\"placement\" is only valid with structural content input or markdown/html inserts, not with plain \"value\".", { field: "placement" });
	if ("nestingPolicy" in input && input.nestingPolicy !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", "\"nestingPolicy\" is only valid with structural content input, not with \"value\".", { field: "nestingPolicy" });
	assertNoUnknownFields(input, TEXT_INSERT_ALLOWED_KEYS, "insert");
	if (isRichContent && "placement" in input && input.placement !== void 0) {
		if (typeof input.placement !== "string" || !PLACEMENT_VALUES.has(input.placement)) throw new DocumentApiValidationError("INVALID_INPUT", `placement must be one of: before, after, insideStart, insideEnd. Got "${String(input.placement)}".`, {
			field: "placement",
			value: input.placement
		});
	}
	const { target, ref: ref$1, value, type } = input;
	if (target !== void 0 && ref$1 !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", "Insert input must provide either \"target\" or \"ref\", not both.", { fields: ["target", "ref"] });
	if (target !== void 0) {
		if (isRichContent) {
			if (!isSelectionTarget(target) && !isBlockNodeAddress(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a SelectionTarget or BlockNodeAddress for markdown/html inserts.", {
				field: "target",
				value: target
			});
		} else if (!isSelectionTarget(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a SelectionTarget object.", {
			field: "target",
			value: target
		});
	}
	if (ref$1 !== void 0 && (typeof ref$1 !== "string" || ref$1 === "")) throw new DocumentApiValidationError("INVALID_TARGET", "ref must be a non-empty string.", {
		field: "ref",
		value: ref$1
	});
	if (typeof value !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `value must be a string, got ${typeof value}.`, {
		field: "value",
		value
	});
	if (type !== void 0 && (typeof type !== "string" || !VALID_INSERT_TYPES.has(type))) throw new DocumentApiValidationError("INVALID_TARGET", `type must be one of: text, markdown, html. Got "${type}".`, {
		field: "type",
		value: type
	});
}
function validateStructuralInsertInput(input) {
	if ("type" in input && input.type !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", "\"type\" field is only valid with legacy string input (\"value\"), not with structural \"content\".", { field: "type" });
	assertNoUnknownFields(input, STRUCTURAL_INSERT_ALLOWED_KEYS, "insert");
	const { target, content: content$2, placement, nestingPolicy } = input;
	if (target !== void 0 && !isBlockNodeAddress(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a BlockNodeAddress ({ kind: \"block\", nodeType, nodeId }).", {
		field: "target",
		value: target
	});
	if (placement !== void 0 && (typeof placement !== "string" || !PLACEMENT_VALUES.has(placement))) throw new DocumentApiValidationError("INVALID_INPUT", `placement must be one of: before, after, insideStart, insideEnd. Got "${String(placement)}".`, {
		field: "placement",
		value: placement
	});
	validateNestingPolicyValue(nestingPolicy);
	validateDocumentFragment(content$2);
}
function executeInsert(selectionAdapter, writeAdapter, input, options) {
	validateInsertInput(input);
	if (isStructuralInsertInput(input)) return writeAdapter.insertStructured(input, normalizeMutationOptions(options));
	const { target, ref: ref$1, value } = input;
	if ((input.type ?? "text") !== "text") return writeAdapter.insertStructured(input, normalizeMutationOptions(options));
	const storyIn = input.in;
	if (target || ref$1) {
		const request = target ? {
			kind: "insert",
			target,
			text: value,
			...storyIn ? { in: storyIn } : {}
		} : {
			kind: "insert",
			ref: ref$1,
			text: value,
			...storyIn ? { in: storyIn } : {}
		};
		return textReceiptToSDReceipt(selectionAdapter.execute(request, normalizeMutationOptions(options)));
	}
	return textReceiptToSDReceipt(executeWrite(writeAdapter, {
		kind: "insert",
		text: value,
		...storyIn ? { in: storyIn } : {}
	}, options));
}
const LIST_KINDS = ["ordered", "bullet"];
const LIST_INSERT_POSITIONS = ["before", "after"];
const JOIN_DIRECTIONS = ["withPrevious", "withNext"];
const MUTATION_SCOPES = ["definition", "instance"];
const LEVEL_ALIGNMENTS = [
	"left",
	"center",
	"right"
];
const TRAILING_CHARACTERS = [
	"tab",
	"space",
	"nothing"
];
const LIST_PRESET_IDS = [
	"decimal",
	"decimalParenthesis",
	"lowerLetter",
	"upperLetter",
	"lowerRoman",
	"upperRoman",
	"disc",
	"circle",
	"square",
	"dash"
];
var VALID_BLOCK_NODE_TYPES$1 = new Set(BLOCK_NODE_TYPES);
var VALID_LIST_KINDS = new Set(LIST_KINDS);
var VALID_INSERT_POSITIONS = new Set(LIST_INSERT_POSITIONS);
var VALID_JOIN_DIRECTIONS = new Set(JOIN_DIRECTIONS);
var VALID_MUTATION_SCOPES = new Set(MUTATION_SCOPES);
var VALID_LEVEL_ALIGNMENTS = new Set(LEVEL_ALIGNMENTS);
var VALID_TRAILING_CHARACTERS = new Set(TRAILING_CHARACTERS);
var VALID_LIST_PRESETS = new Set(LIST_PRESET_IDS);
var VALID_CONTINUITY_VALUES = new Set(["preserve", "none"]);
function validateListInput(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} input must be a non-null object.`);
}
function validateListItemAddress(value, field, operationName) {
	if (value === void 0 || value === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a ${field}.`);
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field} must be an object.`, {
		field,
		value
	});
	const t = value;
	if (t.kind !== "block") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.kind must be 'block', got "${String(t.kind)}".`, {
		field: `${field}.kind`,
		value: t.kind
	});
	if (t.nodeType !== "listItem") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.nodeType must be 'listItem', got "${String(t.nodeType)}".`, {
		field: `${field}.nodeType`,
		value: t.nodeType
	});
	if (typeof t.nodeId !== "string" || t.nodeId === "") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.nodeId must be a non-empty string.`, {
		field: `${field}.nodeId`,
		value: t.nodeId
	});
}
function validateListItemTarget(input, operationName) {
	validateListItemAddress(input.target, "target", operationName);
}
function validateBlockAddress(value, field, operationName) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field} must be an object.`, {
		field,
		value
	});
	const v = value;
	if (v.kind !== "block") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.kind must be 'block', got "${String(v.kind)}".`, {
		field: `${field}.kind`,
		value: v.kind
	});
	if (v.nodeType !== "paragraph") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.nodeType must be 'paragraph', got "${String(v.nodeType)}".`, {
		field: `${field}.nodeType`,
		value: v.nodeType
	});
	if (typeof v.nodeId !== "string" || v.nodeId === "") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field}.nodeId must be a non-empty string.`, {
		field: `${field}.nodeId`,
		value: v.nodeId
	});
}
function validateBlockAddressOrRange(value, field, operationName) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} ${field} must be an object.`, {
		field,
		value
	});
	const v = value;
	if (v.from !== void 0) {
		validateBlockAddress(v.from, `${field}.from`, operationName);
		validateBlockAddress(v.to, `${field}.to`, operationName);
	} else validateBlockAddress(value, field, operationName);
}
function requireLevel(value, operationName) {
	if (!isInteger(value) || value < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} level must be a non-negative integer, got ${JSON.stringify(value)}.`, {
		field: "level",
		value
	});
}
function requireEnum(value, field, validSet, operationName) {
	if (!validSet.has(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be one of: ${[...validSet].join(", ")}. Got ${JSON.stringify(value)}.`, {
		field,
		value
	});
}
function optionalBoolean(value, field, operationName) {
	if (value !== void 0 && typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be a boolean if provided, got ${typeof value}.`, {
		field,
		value
	});
}
function optionalNumber(value, field, operationName) {
	if (value !== void 0 && (typeof value !== "number" || !Number.isFinite(value))) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be a number if provided, got ${typeof value}.`, {
		field,
		value
	});
}
function optionalInteger(value, field, operationName) {
	if (value !== void 0 && !isInteger(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be an integer if provided, got ${JSON.stringify(value)}.`, {
		field,
		value
	});
}
function optionalLevelsArray(value, field, operationName) {
	if (value === void 0) return;
	if (!Array.isArray(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be an array if provided.`, {
		field,
		value
	});
	for (let i$1 = 0; i$1 < value.length; i$1++) if (!isInteger(value[i$1]) || value[i$1] < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field}[${i$1}] must be a non-negative integer.`, {
		field: `${field}[${i$1}]`,
		value: value[i$1]
	});
}
function validateListLevelTemplate(entry, path, operationName) {
	if (!isRecord(entry)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path} must be an object.`, {
		field: path,
		value: entry
	});
	const e = entry;
	if (!isInteger(e.level) || e.level < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path}.level must be a non-negative integer.`, {
		field: `${path}.level`,
		value: e.level
	});
	if (e.numFmt !== void 0 && typeof e.numFmt !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path}.numFmt must be a string.`, {
		field: `${path}.numFmt`,
		value: e.numFmt
	});
	if (e.lvlText !== void 0 && typeof e.lvlText !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path}.lvlText must be a string.`, {
		field: `${path}.lvlText`,
		value: e.lvlText
	});
	optionalInteger(e.start, `${path}.start`, operationName);
	if (e.alignment !== void 0) requireEnum(e.alignment, `${path}.alignment`, VALID_LEVEL_ALIGNMENTS, operationName);
	if (e.trailingCharacter !== void 0) requireEnum(e.trailingCharacter, `${path}.trailingCharacter`, VALID_TRAILING_CHARACTERS, operationName);
	if (e.markerFont !== void 0 && typeof e.markerFont !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path}.markerFont must be a string.`, {
		field: `${path}.markerFont`,
		value: e.markerFont
	});
	optionalInteger(e.pictureBulletId, `${path}.pictureBulletId`, operationName);
	if (e.tabStopAt !== void 0 && e.tabStopAt !== null) optionalNumber(e.tabStopAt, `${path}.tabStopAt`, operationName);
	if (e.indents !== void 0) {
		if (!isRecord(e.indents)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${path}.indents must be an object.`, {
			field: `${path}.indents`,
			value: e.indents
		});
		const ind = e.indents;
		optionalNumber(ind.left, `${path}.indents.left`, operationName);
		optionalNumber(ind.hanging, `${path}.indents.hanging`, operationName);
		optionalNumber(ind.firstLine, `${path}.indents.firstLine`, operationName);
	}
}
function validateListTemplate(value, field, operationName) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be an object.`, {
		field,
		value
	});
	const t = value;
	if (t.version !== 1) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field}.version must be 1, got ${JSON.stringify(t.version)}.`, {
		field: `${field}.version`,
		value: t.version
	});
	if (!Array.isArray(t.levels)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field}.levels must be an array.`, {
		field: `${field}.levels`,
		value: t.levels
	});
	for (let i$1 = 0; i$1 < t.levels.length; i$1++) validateListLevelTemplate(t.levels[i$1], `${field}.levels[${i$1}]`, operationName);
}
var VALID_SEQUENCE_MODES = new Set(["new", "continuePrevious"]);
function validateListsCreateFields(raw) {
	const op = "lists.create";
	if (raw.kind !== void 0) requireEnum(raw.kind, "kind", VALID_LIST_KINDS, op);
	if (raw.level !== void 0) {
		if (!isInteger(raw.level) || raw.level < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} level must be a non-negative integer, got ${JSON.stringify(raw.level)}.`, {
			field: "level",
			value: raw.level
		});
	}
	if (raw.sequence !== void 0) {
		if (!isRecord(raw.sequence)) throw new DocumentApiValidationError("INVALID_INPUT", `${op} sequence must be an object.`, {
			field: "sequence",
			value: raw.sequence
		});
		const seq = raw.sequence;
		requireEnum(seq.mode, "sequence.mode", VALID_SEQUENCE_MODES, op);
		if (seq.mode === "continuePrevious") {
			if (raw.preset !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} preset must not be provided when sequence.mode is 'continuePrevious'.`, { field: "preset" });
			if (raw.style !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} style must not be provided when sequence.mode is 'continuePrevious'.`, { field: "style" });
			if (seq.startAt !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${op} sequence.startAt must not be provided when sequence.mode is 'continuePrevious'.`, { field: "sequence.startAt" });
		}
		if (seq.mode === "new") optionalInteger(seq.startAt, "sequence.startAt", op);
	}
	if (raw.preset !== void 0) requireEnum(raw.preset, "preset", VALID_LIST_PRESETS, op);
	if (raw.style !== void 0) validateListTemplate(raw.style, "style", op);
}
function executeListsList(adapter, query) {
	if (query !== void 0) {
		if (!isRecord(query)) throw new DocumentApiValidationError("INVALID_INPUT", "lists.list query must be an object if provided.");
		const q$1 = query;
		if (q$1.kind !== void 0) requireEnum(q$1.kind, "kind", VALID_LIST_KINDS, "lists.list");
		optionalInteger(q$1.level, "level", "lists.list");
		optionalInteger(q$1.limit, "limit", "lists.list");
		optionalInteger(q$1.offset, "offset", "lists.list");
		optionalInteger(q$1.ordinal, "ordinal", "lists.list");
		if (q$1.within !== void 0) {
			if (!isRecord(q$1.within)) throw new DocumentApiValidationError("INVALID_INPUT", "lists.list within must be an object.", {
				field: "within",
				value: q$1.within
			});
			const w = q$1.within;
			if (w.kind !== "block") throw new DocumentApiValidationError("INVALID_INPUT", `lists.list within.kind must be 'block', got "${String(w.kind)}".`, {
				field: "within.kind",
				value: w.kind
			});
			if (!VALID_BLOCK_NODE_TYPES$1.has(w.nodeType)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.list within.nodeType must be a valid BlockNodeType, got ${JSON.stringify(w.nodeType)}.`, {
				field: "within.nodeType",
				value: w.nodeType
			});
			if (typeof w.nodeId !== "string" || w.nodeId === "") throw new DocumentApiValidationError("INVALID_INPUT", "lists.list within.nodeId must be a non-empty string.", {
				field: "within.nodeId",
				value: w.nodeId
			});
		}
	}
	return adapter.list(query);
}
function executeListsGet(adapter, input) {
	validateListInput(input, "lists.get");
	validateListItemAddress(input.address, "address", "lists.get");
	return adapter.get(input);
}
function executeListsInsert(adapter, input, options) {
	validateListItemTarget(input, "lists.insert");
	requireEnum(input.position, "position", VALID_INSERT_POSITIONS, "lists.insert");
	if (input.text !== void 0 && typeof input.text !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `lists.insert text must be a string if provided, got ${typeof input.text}.`, {
		field: "text",
		value: input.text
	});
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeListsIndent(adapter, input, options) {
	validateListItemTarget(input, "lists.indent");
	return adapter.indent(input, normalizeMutationOptions(options));
}
function executeListsOutdent(adapter, input, options) {
	validateListItemTarget(input, "lists.outdent");
	return adapter.outdent(input, normalizeMutationOptions(options));
}
var VALID_LIST_CREATE_MODES = new Set(["empty", "fromParagraphs"]);
function executeListsCreate(adapter, input, options) {
	validateListInput(input, "lists.create");
	const raw = input;
	if (!VALID_LIST_CREATE_MODES.has(raw.mode)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.create mode must be "empty" or "fromParagraphs", got ${JSON.stringify(raw.mode)}.`, {
		field: "mode",
		value: raw.mode
	});
	if (raw.mode === "empty") validateBlockAddress(raw.at, "at", "lists.create");
	if (raw.mode === "fromParagraphs") {
		if (raw.target === void 0 || raw.target === null) throw new DocumentApiValidationError("INVALID_TARGET", "lists.create with mode \"fromParagraphs\" requires a target.", { field: "target" });
		validateBlockAddressOrRange(raw.target, "target", "lists.create");
	}
	validateListsCreateFields(raw);
	return adapter.create(input, normalizeMutationOptions(options));
}
function executeListsAttach(adapter, input, options) {
	validateListInput(input, "lists.attach");
	validateBlockAddressOrRange(input.target, "target", "lists.attach");
	validateListItemAddress(input.attachTo, "attachTo", "lists.attach");
	optionalInteger(input.level, "level", "lists.attach");
	return adapter.attach(input, normalizeMutationOptions(options));
}
function executeListsDetach(adapter, input, options) {
	validateListItemTarget(input, "lists.detach");
	return adapter.detach(input, normalizeMutationOptions(options));
}
function executeListsDelete(adapter, input, options) {
	validateListItemTarget(input, "lists.delete");
	return adapter.delete(input, normalizeMutationOptions(options));
}
function executeListsJoin(adapter, input, options) {
	validateListItemTarget(input, "lists.join");
	requireEnum(input.direction, "direction", VALID_JOIN_DIRECTIONS, "lists.join");
	return adapter.join(input, normalizeMutationOptions(options));
}
function executeListsCanJoin(adapter, input) {
	validateListItemTarget(input, "lists.canJoin");
	requireEnum(input.direction, "direction", VALID_JOIN_DIRECTIONS, "lists.canJoin");
	return adapter.canJoin(input);
}
function executeListsSeparate(adapter, input, options) {
	validateListItemTarget(input, "lists.separate");
	optionalBoolean(input.copyOverrides, "copyOverrides", "lists.separate");
	return adapter.separate(input, normalizeMutationOptions(options));
}
function executeListsMerge(adapter, input, options) {
	validateListItemTarget(input, "lists.merge");
	requireEnum(input.direction, "direction", VALID_JOIN_DIRECTIONS, "lists.merge");
	return adapter.merge(input, normalizeMutationOptions(options));
}
function executeListsSplit(adapter, input, options) {
	validateListItemTarget(input, "lists.split");
	optionalBoolean(input.restartNumbering, "restartNumbering", "lists.split");
	return adapter.split(input, normalizeMutationOptions(options));
}
function executeListsSetLevel(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevel");
	requireLevel(input.level, "lists.setLevel");
	return adapter.setLevel(input, normalizeMutationOptions(options));
}
function executeListsSetValue(adapter, input, options) {
	validateListItemTarget(input, "lists.setValue");
	if (input.value !== null && !isInteger(input.value)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.setValue value must be an integer or null, got ${JSON.stringify(input.value)}.`, {
		field: "value",
		value: input.value
	});
	return adapter.setValue(input, normalizeMutationOptions(options));
}
function executeListsContinuePrevious(adapter, input, options) {
	validateListItemTarget(input, "lists.continuePrevious");
	return adapter.continuePrevious(input, normalizeMutationOptions(options));
}
function executeListsCanContinuePrevious(adapter, input) {
	validateListItemTarget(input, "lists.canContinuePrevious");
	return adapter.canContinuePrevious(input);
}
function executeListsSetLevelRestart(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelRestart");
	requireLevel(input.level, "lists.setLevelRestart");
	if (input.restartAfterLevel !== null && !isInteger(input.restartAfterLevel)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.setLevelRestart restartAfterLevel must be an integer or null.`, {
		field: "restartAfterLevel",
		value: input.restartAfterLevel
	});
	if (input.scope !== void 0) requireEnum(input.scope, "scope", VALID_MUTATION_SCOPES, "lists.setLevelRestart");
	return adapter.setLevelRestart(input, normalizeMutationOptions(options));
}
function executeListsConvertToText(adapter, input, options) {
	validateListItemTarget(input, "lists.convertToText");
	optionalBoolean(input.includeMarker, "includeMarker", "lists.convertToText");
	return adapter.convertToText(input, normalizeMutationOptions(options));
}
function executeListsApplyTemplate(adapter, input, options) {
	validateListItemTarget(input, "lists.applyTemplate");
	validateListTemplate(input.template, "template", "lists.applyTemplate");
	optionalLevelsArray(input.levels, "levels", "lists.applyTemplate");
	return adapter.applyTemplate(input, normalizeMutationOptions(options));
}
function executeListsApplyPreset(adapter, input, options) {
	validateListItemTarget(input, "lists.applyPreset");
	requireEnum(input.preset, "preset", VALID_LIST_PRESETS, "lists.applyPreset");
	optionalLevelsArray(input.levels, "levels", "lists.applyPreset");
	return adapter.applyPreset(input, normalizeMutationOptions(options));
}
function executeListsCaptureTemplate(adapter, input) {
	validateListItemTarget(input, "lists.captureTemplate");
	optionalLevelsArray(input.levels, "levels", "lists.captureTemplate");
	return adapter.captureTemplate(input);
}
function executeListsSetLevelNumbering(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelNumbering");
	requireLevel(input.level, "lists.setLevelNumbering");
	if (typeof input.numFmt !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelNumbering numFmt must be a string.", {
		field: "numFmt",
		value: input.numFmt
	});
	if (typeof input.lvlText !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelNumbering lvlText must be a string.", {
		field: "lvlText",
		value: input.lvlText
	});
	optionalInteger(input.start, "start", "lists.setLevelNumbering");
	return adapter.setLevelNumbering(input, normalizeMutationOptions(options));
}
function executeListsSetLevelBullet(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelBullet");
	requireLevel(input.level, "lists.setLevelBullet");
	if (typeof input.markerText !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelBullet markerText must be a string.", {
		field: "markerText",
		value: input.markerText
	});
	return adapter.setLevelBullet(input, normalizeMutationOptions(options));
}
function executeListsSetLevelPictureBullet(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelPictureBullet");
	requireLevel(input.level, "lists.setLevelPictureBullet");
	if (!isInteger(input.pictureBulletId)) throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelPictureBullet pictureBulletId must be an integer.", {
		field: "pictureBulletId",
		value: input.pictureBulletId
	});
	return adapter.setLevelPictureBullet(input, normalizeMutationOptions(options));
}
function executeListsSetLevelAlignment(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelAlignment");
	requireLevel(input.level, "lists.setLevelAlignment");
	requireEnum(input.alignment, "alignment", VALID_LEVEL_ALIGNMENTS, "lists.setLevelAlignment");
	return adapter.setLevelAlignment(input, normalizeMutationOptions(options));
}
function executeListsSetLevelIndents(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelIndents");
	requireLevel(input.level, "lists.setLevelIndents");
	optionalNumber(input.left, "left", "lists.setLevelIndents");
	optionalNumber(input.hanging, "hanging", "lists.setLevelIndents");
	optionalNumber(input.firstLine, "firstLine", "lists.setLevelIndents");
	return adapter.setLevelIndents(input, normalizeMutationOptions(options));
}
function executeListsSetLevelTrailingCharacter(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelTrailingCharacter");
	requireLevel(input.level, "lists.setLevelTrailingCharacter");
	requireEnum(input.trailingCharacter, "trailingCharacter", VALID_TRAILING_CHARACTERS, "lists.setLevelTrailingCharacter");
	return adapter.setLevelTrailingCharacter(input, normalizeMutationOptions(options));
}
function executeListsSetLevelMarkerFont(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelMarkerFont");
	requireLevel(input.level, "lists.setLevelMarkerFont");
	if (typeof input.fontFamily !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelMarkerFont fontFamily must be a string.", {
		field: "fontFamily",
		value: input.fontFamily
	});
	return adapter.setLevelMarkerFont(input, normalizeMutationOptions(options));
}
function executeListsClearLevelOverrides(adapter, input, options) {
	validateListItemTarget(input, "lists.clearLevelOverrides");
	requireLevel(input.level, "lists.clearLevelOverrides");
	return adapter.clearLevelOverrides(input, normalizeMutationOptions(options));
}
function executeListsSetType(adapter, input, options) {
	validateListItemTarget(input, "lists.setType");
	requireEnum(input.kind, "kind", VALID_LIST_KINDS, "lists.setType");
	if (input.continuity !== void 0) requireEnum(input.continuity, "continuity", VALID_CONTINUITY_VALUES, "lists.setType");
	return adapter.setType(input, normalizeMutationOptions(options));
}
function executeListsGetStyle(adapter, input) {
	validateListItemTarget(input, "lists.getStyle");
	optionalLevelsArray(input.levels, "levels", "lists.getStyle");
	return adapter.getStyle(input);
}
function executeListsApplyStyle(adapter, input, options) {
	validateListItemTarget(input, "lists.applyStyle");
	validateListTemplate(input.style, "style", "lists.applyStyle");
	optionalLevelsArray(input.levels, "levels", "lists.applyStyle");
	return adapter.applyStyle(input, normalizeMutationOptions(options));
}
function executeListsRestartAt(adapter, input, options) {
	validateListItemTarget(input, "lists.restartAt");
	if (!isInteger(input.startAt)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.restartAt startAt must be an integer, got ${JSON.stringify(input.startAt)}.`, {
		field: "startAt",
		value: input.startAt
	});
	return adapter.restartAt(input, normalizeMutationOptions(options));
}
function executeListsSetLevelNumberStyle(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelNumberStyle");
	requireLevel(input.level, "lists.setLevelNumberStyle");
	if (typeof input.numberStyle !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelNumberStyle numberStyle must be a string.", {
		field: "numberStyle",
		value: input.numberStyle
	});
	return adapter.setLevelNumberStyle(input, normalizeMutationOptions(options));
}
function executeListsSetLevelText(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelText");
	requireLevel(input.level, "lists.setLevelText");
	if (typeof input.text !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelText text must be a string.", {
		field: "text",
		value: input.text
	});
	return adapter.setLevelText(input, normalizeMutationOptions(options));
}
function executeListsSetLevelStart(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelStart");
	requireLevel(input.level, "lists.setLevelStart");
	if (!isInteger(input.startAt)) throw new DocumentApiValidationError("INVALID_INPUT", `lists.setLevelStart startAt must be an integer, got ${JSON.stringify(input.startAt)}.`, {
		field: "startAt",
		value: input.startAt
	});
	return adapter.setLevelStart(input, normalizeMutationOptions(options));
}
function executeListsSetLevelLayout(adapter, input, options) {
	validateListItemTarget(input, "lists.setLevelLayout");
	requireLevel(input.level, "lists.setLevelLayout");
	if (!isRecord(input.layout)) throw new DocumentApiValidationError("INVALID_INPUT", "lists.setLevelLayout layout must be an object.", {
		field: "layout",
		value: input.layout
	});
	const layout = input.layout;
	if (layout.alignment !== void 0) requireEnum(layout.alignment, "layout.alignment", VALID_LEVEL_ALIGNMENTS, "lists.setLevelLayout");
	if (layout.followCharacter !== void 0) requireEnum(layout.followCharacter, "layout.followCharacter", VALID_TRAILING_CHARACTERS, "lists.setLevelLayout");
	optionalNumber(layout.alignedAt, "layout.alignedAt", "lists.setLevelLayout");
	optionalNumber(layout.textIndentAt, "layout.textIndentAt", "lists.setLevelLayout");
	if (layout.tabStopAt !== void 0 && layout.tabStopAt !== null) optionalNumber(layout.tabStopAt, "layout.tabStopAt", "lists.setLevelLayout");
	return adapter.setLevelLayout(input, normalizeMutationOptions(options));
}
var TEXT_REPLACE_ALLOWED_KEYS = new Set([
	"text",
	"target",
	"ref",
	"in"
]);
var STRUCTURAL_REPLACE_ALLOWED_KEYS = new Set([
	"content",
	"target",
	"ref",
	"nestingPolicy",
	"in"
]);
function isStructuralReplaceInput(input) {
	return "content" in input && input.content !== void 0;
}
function validateTargetLocator(input, operation) {
	const hasTarget = input.target !== void 0;
	const hasRef = input.ref !== void 0;
	if (hasTarget && hasRef) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} input must provide either "target" or "ref", not both.`, { fields: ["target", "ref"] });
	if (!hasTarget && !hasRef) throw new DocumentApiValidationError("INVALID_INPUT", `${operation} requires a target or ref.`, { fields: ["target", "ref"] });
	if (hasTarget && !isSelectionTarget(input.target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a SelectionTarget object.", {
		field: "target",
		value: input.target
	});
	if (hasRef && (typeof input.ref !== "string" || input.ref === "")) throw new DocumentApiValidationError("INVALID_TARGET", "ref must be a non-empty string.", {
		field: "ref",
		value: input.ref
	});
}
function validateReplaceInput(input) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", "Replace input must be a non-null object.");
	const hasText = "text" in input && input.text !== void 0;
	const hasContent = "content" in input && input.content !== void 0;
	if (hasText && hasContent) throw new DocumentApiValidationError("INVALID_INPUT", "Replace input must provide either \"text\" or \"content\", not both.", { fields: ["text", "content"] });
	if (!hasText && !hasContent) throw new DocumentApiValidationError("INVALID_INPUT", "Replace input must provide either \"text\" or \"content\".", { fields: ["text", "content"] });
	validateStoryLocator(input.in, "in");
	if (hasContent) validateStructuralReplaceInput(input);
	else validateTextReplaceInput(input);
}
function validateTextReplaceInput(input) {
	if ("nestingPolicy" in input && input.nestingPolicy !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", "\"nestingPolicy\" is only valid with structural content input, not with \"text\".", { field: "nestingPolicy" });
	assertNoUnknownFields(input, TEXT_REPLACE_ALLOWED_KEYS, "replace");
	validateTargetLocator(input, "replace");
	if (typeof input.text !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `text must be a string, got ${typeof input.text}.`, {
		field: "text",
		value: input.text
	});
}
function validateStructuralReplaceInput(input) {
	assertNoUnknownFields(input, STRUCTURAL_REPLACE_ALLOWED_KEYS, "replace");
	const { target, ref: refValue, content: content$2, nestingPolicy } = input;
	const hasTarget = target !== void 0;
	const hasRef = refValue !== void 0;
	if (hasTarget && hasRef) throw new DocumentApiValidationError("INVALID_INPUT", "Structural replace must provide either \"target\" or \"ref\", not both.", { fields: ["target", "ref"] });
	if (!hasTarget && !hasRef) throw new DocumentApiValidationError("INVALID_TARGET", "Structural replace requires a target or ref.", { fields: ["target", "ref"] });
	if (hasTarget && !isBlockNodeAddress(target) && !isSelectionTarget(target)) throw new DocumentApiValidationError("INVALID_TARGET", "target must be a BlockNodeAddress or SelectionTarget.", {
		field: "target",
		value: target
	});
	if (hasRef && typeof refValue !== "string") throw new DocumentApiValidationError("INVALID_TARGET", "ref must be a string.", {
		field: "ref",
		value: refValue
	});
	validateNestingPolicyValue(nestingPolicy);
	validateDocumentFragment(content$2);
}
function executeReplace(selectionAdapter, writeAdapter, input, options) {
	validateReplaceInput(input);
	if (isStructuralReplaceInput(input)) return writeAdapter.replaceStructured(input, normalizeMutationOptions(options));
	const textInput = input;
	const request = textInput.target ? {
		kind: "replace",
		target: textInput.target,
		text: textInput.text,
		in: textInput.in
	} : {
		kind: "replace",
		ref: textInput.ref,
		text: textInput.text,
		in: textInput.in
	};
	return textReceiptToSDReceipt(selectionAdapter.execute(request, normalizeMutationOptions(options)));
}
var VALID_HEADING_LEVELS = new Set([
	1,
	2,
	3,
	4,
	5,
	6
]);
function validateTargetOnlyCreateLocation(at, operationName) {
	if (at.kind !== "before" && at.kind !== "after") return;
	const loc = at;
	if (loc.nodeId !== void 0) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} does not support at.nodeId. Use at.target for before/after placement.`, { field: "at.nodeId" });
	if (loc.target === void 0) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} with at.kind="${at.kind}" requires at.target.`, { field: "at.target" });
}
function validateTargetOrNodeIdCreateLocation(at, operationName) {
	if (at.kind !== "before" && at.kind !== "after") return;
	const loc = at;
	const hasTarget = loc.target !== void 0;
	const hasNodeId = loc.nodeId !== void 0;
	if (hasTarget && hasNodeId) throw new DocumentApiValidationError("INVALID_TARGET", `Cannot combine at.target and at.nodeId for ${operationName}. Use exactly one locator mode.`, { fields: ["at.target", "at.nodeId"] });
	if (!hasTarget && !hasNodeId) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} with at.kind="${at.kind}" requires at.target or at.nodeId.`, { fields: ["at.target", "at.nodeId"] });
}
function normalizeCreateLocation(location, validate) {
	const normalized = location ?? { kind: "documentEnd" };
	validate(normalized);
	return normalized;
}
var SECTION_BREAK_TYPES$1 = [
	"continuous",
	"nextPage",
	"evenPage",
	"oddPage"
];
function validateMarginValue(field, value) {
	if (typeof value !== "number" || !Number.isFinite(value) || value < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a non-negative number.`, {
		field,
		value
	});
}
function validateCreateSectionBreakInput(input) {
	if (input.breakType !== void 0 && !SECTION_BREAK_TYPES$1.includes(input.breakType)) throw new DocumentApiValidationError("INVALID_INPUT", `create.sectionBreak breakType must be one of: ${SECTION_BREAK_TYPES$1.join(", ")}.`, {
		field: "breakType",
		value: input.breakType
	});
	if (input.pageMargins) {
		const { top, right, bottom, left, gutter } = input.pageMargins;
		if (top !== void 0) validateMarginValue("pageMargins.top", top);
		if (right !== void 0) validateMarginValue("pageMargins.right", right);
		if (bottom !== void 0) validateMarginValue("pageMargins.bottom", bottom);
		if (left !== void 0) validateMarginValue("pageMargins.left", left);
		if (gutter !== void 0) validateMarginValue("pageMargins.gutter", gutter);
	}
	if (input.headerFooterMargins) {
		const { header, footer } = input.headerFooterMargins;
		if (header !== void 0) validateMarginValue("headerFooterMargins.header", header);
		if (footer !== void 0) validateMarginValue("headerFooterMargins.footer", footer);
	}
}
function executeCreateParagraph(adapter, input, options) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "create.paragraph input must be a non-null object.");
	validateStoryLocator(input.in, "in");
	const normalized = {
		at: normalizeCreateLocation(input.at, (loc) => validateTargetOnlyCreateLocation(loc, "create.paragraph")),
		text: input.text ?? ""
	};
	return adapter.paragraph(normalized, normalizeMutationOptions(options));
}
function executeCreateHeading(adapter, input, options) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "create.heading input must be a non-null object.");
	validateStoryLocator(input.in, "in");
	if (!isInteger(input.level) || !VALID_HEADING_LEVELS.has(input.level)) throw new DocumentApiValidationError("INVALID_INPUT", `create.heading level must be an integer 1–6, got ${JSON.stringify(input.level)}.`, {
		field: "level",
		value: input.level
	});
	const at = normalizeCreateLocation(input.at, (loc) => validateTargetOnlyCreateLocation(loc, "create.heading"));
	const normalized = {
		level: input.level,
		at,
		text: input.text ?? ""
	};
	return adapter.heading(normalized, normalizeMutationOptions(options));
}
function executeCreateTable(adapter, input, options) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", "create.table input must be a non-null object.");
	if (!isInteger(input.rows) || input.rows < 1) throw new DocumentApiValidationError("INVALID_INPUT", `create.table rows must be a positive integer, got ${JSON.stringify(input.rows)}.`, {
		field: "rows",
		value: input.rows
	});
	if (!isInteger(input.columns) || input.columns < 1) throw new DocumentApiValidationError("INVALID_INPUT", `create.table columns must be a positive integer, got ${JSON.stringify(input.columns)}.`, {
		field: "columns",
		value: input.columns
	});
	const at = normalizeCreateLocation(input.at, (loc) => validateTargetOrNodeIdCreateLocation(loc, "create.table"));
	const normalized = {
		rows: input.rows,
		columns: input.columns,
		at
	};
	return adapter.table(normalized, normalizeMutationOptions(options));
}
function executeCreateSectionBreak(adapter, input, options) {
	const normalized = {
		at: normalizeCreateLocation(input.at, (loc) => validateTargetOnlyCreateLocation(loc, "create.sectionBreak")),
		breakType: input.breakType,
		pageMargins: input.pageMargins,
		headerFooterMargins: input.headerFooterMargins
	};
	validateCreateSectionBreakInput(normalized);
	return adapter.sectionBreak(normalized, normalizeMutationOptions(options));
}
function executeCreateTableOfContents(adapter, input, options) {
	const normalized = {
		at: normalizeCreateLocation(input.at, (loc) => {
			if ((loc.kind === "before" || loc.kind === "after") && "nodeId" in loc) throw new DocumentApiValidationError("INVALID_TARGET", "create.tableOfContents requires at.target for before/after positioning. The nodeId form is not supported.", { fields: ["at.nodeId"] });
			validateTargetOnlyCreateLocation(loc, "create.tableOfContents");
		}),
		config: input.config
	};
	return adapter.tableOfContents(normalized, normalizeMutationOptions(options));
}
var SUPPORTED_DELETE_NODE_TYPES = new Set(DELETABLE_BLOCK_NODE_TYPES);
var REJECTED_DELETE_NODE_TYPES = new Set(["tableRow", "tableCell"]);
var VALID_BLOCK_NODE_TYPES = new Set(BLOCK_NODE_TYPES);
function normalizeBlocksListInput(input) {
	if (!input) return input;
	if (input.limit != null && input.limit === 0) {
		const { limit: _, ...rest } = input;
		input = Object.keys(rest).length > 0 ? rest : void 0;
		if (!input) return input;
	}
	if (Array.isArray(input.nodeTypes) && input.nodeTypes.length === 0) {
		const { nodeTypes: _, ...rest } = input;
		input = Object.keys(rest).length > 0 ? rest : void 0;
		if (!input) return input;
	}
	return input;
}
function validateBlocksListInput(input) {
	if (!input) return;
	if (input.offset != null && (typeof input.offset !== "number" || input.offset < 0)) throw new DocumentApiValidationError("INVALID_INPUT", "blocks.list offset must be a non-negative number.", { fields: ["offset"] });
	if (input.limit != null && (typeof input.limit !== "number" || input.limit < 1)) throw new DocumentApiValidationError("INVALID_INPUT", "blocks.list limit must be a positive number.", { fields: ["limit"] });
	if (input.nodeTypes != null) {
		if (!Array.isArray(input.nodeTypes) || input.nodeTypes.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "blocks.list nodeTypes must be a non-empty array.", { fields: ["nodeTypes"] });
		for (const nt of input.nodeTypes) if (!VALID_BLOCK_NODE_TYPES.has(nt)) throw new DocumentApiValidationError("INVALID_INPUT", `blocks.list nodeTypes contains unknown type "${nt}".`, {
			fields: ["nodeTypes"],
			nodeType: nt
		});
	}
	if (input.includeText != null && typeof input.includeText !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "blocks.list includeText must be a boolean.", { fields: ["includeText"] });
}
function validateBlocksDeleteInput(input) {
	if (!input || typeof input !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "blocks.delete requires an input object.", { fields: ["input"] });
	if (!input.target) throw new DocumentApiValidationError("INVALID_INPUT", "blocks.delete requires a target.", { fields: ["target"] });
	if (input.target.kind !== "block") throw new DocumentApiValidationError("INVALID_INPUT", "blocks.delete target must have kind \"block\".", { fields: ["target.kind"] });
	if (!input.target.nodeId || typeof input.target.nodeId !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "blocks.delete target requires a nodeId string.", { fields: ["target.nodeId"] });
	const { nodeType } = input.target;
	if (REJECTED_DELETE_NODE_TYPES.has(nodeType)) throw new DocumentApiValidationError("INVALID_TARGET", `blocks.delete does not support "${nodeType}" targets. Table row/column operations are out of scope.`, {
		fields: ["target.nodeType"],
		nodeType
	});
	if (!SUPPORTED_DELETE_NODE_TYPES.has(nodeType)) throw new DocumentApiValidationError("INVALID_TARGET", `blocks.delete does not support "${nodeType}" targets.`, {
		fields: ["target.nodeType"],
		nodeType
	});
}
function validateBlockNodeAddress(address, label) {
	if (!address || typeof address !== "object") throw new DocumentApiValidationError("INVALID_INPUT", `blocks.deleteRange requires a ${label} address.`, { fields: [label] });
	const addr = address;
	if (addr.kind !== "block") throw new DocumentApiValidationError("INVALID_INPUT", `blocks.deleteRange ${label} must have kind "block".`, { fields: [`${label}.kind`] });
	if (!addr.nodeId || typeof addr.nodeId !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `blocks.deleteRange ${label} requires a nodeId string.`, { fields: [`${label}.nodeId`] });
	if (!addr.nodeType || typeof addr.nodeType !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `blocks.deleteRange ${label} requires a nodeType string.`, { fields: [`${label}.nodeType`] });
}
function validateBlocksDeleteRangeInput(input) {
	if (!input || typeof input !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "blocks.deleteRange requires an input object.", { fields: ["input"] });
	validateBlockNodeAddress(input.start, "start");
	validateBlockNodeAddress(input.end, "end");
}
function executeBlocksList(adapter, input) {
	const normalized = normalizeBlocksListInput(input);
	validateBlocksListInput(normalized);
	return adapter.list(normalized);
}
function executeBlocksDelete(adapter, input, options) {
	validateBlocksDeleteInput(input);
	return adapter.delete(input, normalizeMutationOptions(options));
}
function executeBlocksDeleteRange(adapter, input, options) {
	validateBlocksDeleteRangeInput(input);
	return adapter.deleteRange(input, normalizeMutationOptions(options));
}
function executeTrackChangesList(adapter, input) {
	return adapter.list(input);
}
function executeTrackChangesGet(adapter, input) {
	const raw = input;
	if (typeof raw !== "object" || raw == null) throw new DocumentApiValidationError("INVALID_INPUT", "trackChanges.get input must be a non-null object.", { value: raw });
	const { id } = raw;
	if (typeof id !== "string" || id.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "trackChanges.get id must be a non-empty string.", {
		field: "id",
		value: id
	});
	return adapter.get(input);
}
function executeTrackChangesDecide(adapter, rawInput, options) {
	const raw = rawInput;
	if (typeof raw !== "object" || raw == null) throw new DocumentApiValidationError("INVALID_INPUT", "trackChanges.decide input must be a non-null object.", { value: raw });
	const input = raw;
	if (input.decision !== "accept" && input.decision !== "reject") throw new DocumentApiValidationError("INVALID_INPUT", `trackChanges.decide decision must be "accept" or "reject", got "${String(input.decision)}".`, {
		field: "decision",
		value: input.decision
	});
	if (typeof input.target !== "object" || input.target == null) throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide target must be an object with { id }, { kind: \"range\", range }, or { scope: \"all\" }.", {
		field: "target",
		value: input.target
	});
	const target = input.target;
	const decision = input.decision;
	const rawStory = target.story;
	if (rawStory !== void 0 && rawStory !== "all") validateStoryLocator(rawStory, "target.story");
	const story = rawStory;
	const bulkStory = rawStory;
	if ((target.scope === "all" || target.kind === "all") && (target.id !== void 0 || target.kind === "id")) throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide target must specify exactly one of { id }, { kind: \"range\", range }, or { scope: \"all\" }.", {
		field: "target",
		value: input.target
	});
	if (target.kind === "range") {
		if (target.id !== void 0 || target.scope !== void 0) throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide range targets must not include id or scope fields.", {
			field: "target",
			value: input.target
		});
		if (rawStory === "all") throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide range targets do not support story: \"all\".", {
			field: "target.story",
			value: rawStory
		});
		if (typeof adapter.decideRange !== "function") return {
			success: false,
			failure: {
				code: "CAPABILITY_UNAVAILABLE",
				message: "trackChanges.decide range targets are not supported by the active adapter.",
				details: { target: input.target }
			}
		};
		const range = target.range;
		if (!range || typeof range !== "object" || range.kind !== "text" || !Array.isArray(range.segments) || range.segments.length === 0) throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide target.kind = \"range\" requires a non-empty TextTarget range.", {
			field: "target.range",
			value: target.range
		});
		return adapter.decideRange({
			decision,
			range,
			...story ? { story } : {}
		}, options);
	}
	if (target.scope === "all" || target.kind === "all") {
		if (decision === "accept") return adapter.acceptAll({ ...bulkStory ? { story: bulkStory } : {} }, options);
		return adapter.rejectAll({ ...bulkStory ? { story: bulkStory } : {} }, options);
	}
	if (target.kind === "id" || target.id !== void 0) {
		if (rawStory === "all") throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide id targets do not support story: \"all\".", {
			field: "target.story",
			value: rawStory
		});
		if (target.range !== void 0) return {
			success: false,
			failure: {
				code: "INVALID_INPUT",
				message: "trackChanges.decide does not support a partial range on an id target; the change is not safely divisible.",
				details: { target: input.target }
			}
		};
		if (typeof target.id !== "string" || target.id.length === 0) throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide id targets require a non-empty id.", {
			field: "target",
			value: input.target
		});
		if (decision === "accept") return adapter.accept({
			id: target.id,
			...story ? { story } : {}
		}, options);
		return adapter.reject({
			id: target.id,
			...story ? { story } : {}
		}, options);
	}
	throw new DocumentApiValidationError("INVALID_TARGET", "trackChanges.decide target must have { id }, { kind: \"range\", range }, or { scope: \"all\" }.", {
		field: "target",
		value: input.target
	});
}
function buildFormatInlineAliasDispatch(api) {
	return Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => {
		return [`format.${entry.key}`, (input, options) => api.format[entry.key](input, options)];
	}));
}
function buildDispatchTable(api) {
	const formatInlineAliasDispatch = buildFormatInlineAliasDispatch(api);
	return {
		get: (input) => api.get(input),
		find: (input) => api.find(input),
		getNode: (input) => api.getNode(input),
		getNodeById: (input) => api.getNodeById(input),
		getText: (input) => api.getText(input),
		getMarkdown: (input) => api.getMarkdown(input),
		getHtml: (input) => api.getHtml(input),
		markdownToFragment: (input) => api.markdownToFragment(input),
		info: (input) => api.info(input),
		extract: (input) => api.extract(input),
		clearContent: (input, options) => api.clearContent(input, options),
		insert: (input, options) => api.insert(input, options),
		replace: (input, options) => api.replace(input, options),
		delete: (input, options) => api.delete(input, options),
		formatRange: (input, options) => api.formatRange(input, options),
		"blocks.list": (input) => api.blocks.list(input),
		"blocks.delete": (input, options) => api.blocks.delete(input, options),
		"blocks.deleteRange": (input, options) => api.blocks.deleteRange(input, options),
		"format.apply": (input, options) => api.format.apply(input, options),
		...formatInlineAliasDispatch,
		"styles.paragraph.setStyle": (input, options) => api.styles.paragraph.setStyle(input, options),
		"styles.paragraph.clearStyle": (input, options) => api.styles.paragraph.clearStyle(input, options),
		"format.paragraph.resetDirectFormatting": (input, options) => api.format.paragraph.resetDirectFormatting(input, options),
		"format.paragraph.setAlignment": (input, options) => api.format.paragraph.setAlignment(input, options),
		"format.paragraph.clearAlignment": (input, options) => api.format.paragraph.clearAlignment(input, options),
		"format.paragraph.setIndentation": (input, options) => api.format.paragraph.setIndentation(input, options),
		"format.paragraph.clearIndentation": (input, options) => api.format.paragraph.clearIndentation(input, options),
		"format.paragraph.setSpacing": (input, options) => api.format.paragraph.setSpacing(input, options),
		"format.paragraph.clearSpacing": (input, options) => api.format.paragraph.clearSpacing(input, options),
		"format.paragraph.setKeepOptions": (input, options) => api.format.paragraph.setKeepOptions(input, options),
		"format.paragraph.setOutlineLevel": (input, options) => api.format.paragraph.setOutlineLevel(input, options),
		"format.paragraph.setFlowOptions": (input, options) => api.format.paragraph.setFlowOptions(input, options),
		"format.paragraph.setTabStop": (input, options) => api.format.paragraph.setTabStop(input, options),
		"format.paragraph.clearTabStop": (input, options) => api.format.paragraph.clearTabStop(input, options),
		"format.paragraph.clearAllTabStops": (input, options) => api.format.paragraph.clearAllTabStops(input, options),
		"format.paragraph.setBorder": (input, options) => api.format.paragraph.setBorder(input, options),
		"format.paragraph.clearBorder": (input, options) => api.format.paragraph.clearBorder(input, options),
		"format.paragraph.setShading": (input, options) => api.format.paragraph.setShading(input, options),
		"format.paragraph.clearShading": (input, options) => api.format.paragraph.clearShading(input, options),
		"format.paragraph.setDirection": (input, options) => api.format.paragraph.setDirection(input, options),
		"format.paragraph.clearDirection": (input, options) => api.format.paragraph.clearDirection(input, options),
		"styles.apply": (input, options) => api.styles.apply(input, options),
		"templates.apply": (input, options) => api.templates.apply(input, options),
		"create.paragraph": (input, options) => api.create.paragraph(input, options),
		"create.heading": (input, options) => api.create.heading(input, options),
		"create.sectionBreak": (input, options) => api.create.sectionBreak(input, options),
		"lists.list": (input) => api.lists.list(input),
		"lists.get": (input) => api.lists.get(input),
		"lists.insert": (input, options) => api.lists.insert(input, options),
		"lists.create": (input, options) => api.lists.create(input, options),
		"lists.attach": (input, options) => api.lists.attach(input, options),
		"lists.detach": (input, options) => api.lists.detach(input, options),
		"lists.delete": (input, options) => api.lists.delete(input, options),
		"lists.indent": (input, options) => api.lists.indent(input, options),
		"lists.outdent": (input, options) => api.lists.outdent(input, options),
		"lists.join": (input, options) => api.lists.join(input, options),
		"lists.canJoin": (input) => api.lists.canJoin(input),
		"lists.separate": (input, options) => api.lists.separate(input, options),
		"lists.merge": (input, options) => api.lists.merge(input, options),
		"lists.split": (input, options) => api.lists.split(input, options),
		"lists.setLevel": (input, options) => api.lists.setLevel(input, options),
		"lists.setValue": (input, options) => api.lists.setValue(input, options),
		"lists.continuePrevious": (input, options) => api.lists.continuePrevious(input, options),
		"lists.canContinuePrevious": (input) => api.lists.canContinuePrevious(input),
		"lists.setLevelRestart": (input, options) => api.lists.setLevelRestart(input, options),
		"lists.convertToText": (input, options) => api.lists.convertToText(input, options),
		"lists.applyTemplate": (input, options) => api.lists.applyTemplate(input, options),
		"lists.applyPreset": (input, options) => api.lists.applyPreset(input, options),
		"lists.setType": (input, options) => api.lists.setType(input, options),
		"lists.captureTemplate": (input) => api.lists.captureTemplate(input),
		"lists.setLevelNumbering": (input, options) => api.lists.setLevelNumbering(input, options),
		"lists.setLevelBullet": (input, options) => api.lists.setLevelBullet(input, options),
		"lists.setLevelPictureBullet": (input, options) => api.lists.setLevelPictureBullet(input, options),
		"lists.setLevelAlignment": (input, options) => api.lists.setLevelAlignment(input, options),
		"lists.setLevelIndents": (input, options) => api.lists.setLevelIndents(input, options),
		"lists.setLevelTrailingCharacter": (input, options) => api.lists.setLevelTrailingCharacter(input, options),
		"lists.setLevelMarkerFont": (input, options) => api.lists.setLevelMarkerFont(input, options),
		"lists.clearLevelOverrides": (input, options) => api.lists.clearLevelOverrides(input, options),
		"lists.getStyle": (input) => api.lists.getStyle(input),
		"lists.applyStyle": (input, options) => api.lists.applyStyle(input, options),
		"lists.restartAt": (input, options) => api.lists.restartAt(input, options),
		"lists.setLevelNumberStyle": (input, options) => api.lists.setLevelNumberStyle(input, options),
		"lists.setLevelText": (input, options) => api.lists.setLevelText(input, options),
		"lists.setLevelStart": (input, options) => api.lists.setLevelStart(input, options),
		"lists.setLevelLayout": (input, options) => api.lists.setLevelLayout(input, options),
		"sections.list": (input) => api.sections.list(input),
		"sections.get": (input) => api.sections.get(input),
		"sections.setBreakType": (input, options) => api.sections.setBreakType(input, options),
		"sections.setPageMargins": (input, options) => api.sections.setPageMargins(input, options),
		"sections.setHeaderFooterMargins": (input, options) => api.sections.setHeaderFooterMargins(input, options),
		"sections.setPageSetup": (input, options) => api.sections.setPageSetup(input, options),
		"sections.setColumns": (input, options) => api.sections.setColumns(input, options),
		"sections.setLineNumbering": (input, options) => api.sections.setLineNumbering(input, options),
		"sections.setPageNumbering": (input, options) => api.sections.setPageNumbering(input, options),
		"sections.setTitlePage": (input, options) => api.sections.setTitlePage(input, options),
		"sections.setOddEvenHeadersFooters": (input, options) => api.sections.setOddEvenHeadersFooters(input, options),
		"sections.setVerticalAlign": (input, options) => api.sections.setVerticalAlign(input, options),
		"sections.setSectionDirection": (input, options) => api.sections.setSectionDirection(input, options),
		"sections.setHeaderFooterRef": (input, options) => api.sections.setHeaderFooterRef(input, options),
		"sections.clearHeaderFooterRef": (input, options) => api.sections.clearHeaderFooterRef(input, options),
		"sections.setLinkToPrevious": (input, options) => api.sections.setLinkToPrevious(input, options),
		"sections.setPageBorders": (input, options) => api.sections.setPageBorders(input, options),
		"sections.clearPageBorders": (input, options) => api.sections.clearPageBorders(input, options),
		"comments.create": (input, options) => api.comments.create(input, options),
		"comments.patch": (input, options) => api.comments.patch(input, options),
		"comments.delete": (input, options) => api.comments.delete(input, options),
		"comments.get": (input) => api.comments.get(input),
		"comments.list": (input) => api.comments.list(input),
		"trackChanges.list": (input) => api.trackChanges.list(input),
		"trackChanges.get": (input) => api.trackChanges.get(input),
		"trackChanges.decide": (input, options) => api.trackChanges.decide(input, options),
		"query.match": (input) => api.query.match(input),
		"ranges.resolve": (input) => api.ranges.resolve(input),
		"selection.current": (input) => api.selection.current(input),
		"mutations.preview": (input) => api.mutations.preview(input),
		"mutations.apply": (input) => api.mutations.apply(input),
		"capabilities.get": () => api.capabilities(),
		"history.get": () => api.history.get(),
		"history.undo": () => api.history.undo(),
		"history.redo": () => api.history.redo(),
		"create.table": (input, options) => api.create.table(input, options),
		"tables.convertFromText": (input, options) => api.tables.convertFromText(input, options),
		"tables.delete": (input, options) => api.tables.delete(input, options),
		"tables.clearContents": (input, options) => api.tables.clearContents(input, options),
		"tables.move": (input, options) => api.tables.move(input, options),
		"tables.split": (input, options) => api.tables.split(input, options),
		"tables.convertToText": (input, options) => api.tables.convertToText(input, options),
		"tables.setLayout": (input, options) => api.tables.setLayout(input, options),
		"tables.insertRow": (input, options) => api.tables.insertRow(input, options),
		"tables.deleteRow": (input, options) => api.tables.deleteRow(input, options),
		"tables.setRowHeight": (input, options) => api.tables.setRowHeight(input, options),
		"tables.distributeRows": (input, options) => api.tables.distributeRows(input, options),
		"tables.setRowOptions": (input, options) => api.tables.setRowOptions(input, options),
		"tables.insertColumn": (input, options) => api.tables.insertColumn(input, options),
		"tables.deleteColumn": (input, options) => api.tables.deleteColumn(input, options),
		"tables.setColumnWidth": (input, options) => api.tables.setColumnWidth(input, options),
		"tables.distributeColumns": (input, options) => api.tables.distributeColumns(input, options),
		"tables.insertCell": (input, options) => api.tables.insertCell(input, options),
		"tables.deleteCell": (input, options) => api.tables.deleteCell(input, options),
		"tables.mergeCells": (input, options) => api.tables.mergeCells(input, options),
		"tables.unmergeCells": (input, options) => api.tables.unmergeCells(input, options),
		"tables.splitCell": (input, options) => api.tables.splitCell(input, options),
		"tables.setCellProperties": (input, options) => api.tables.setCellProperties(input, options),
		"tables.setCellText": (input, options) => api.tables.setCellText(input, options),
		"tables.sort": (input, options) => api.tables.sort(input, options),
		"tables.setAltText": (input, options) => api.tables.setAltText(input, options),
		"tables.setStyle": (input, options) => api.tables.setStyle(input, options),
		"tables.clearStyle": (input, options) => api.tables.clearStyle(input, options),
		"tables.setStyleOption": (input, options) => api.tables.setStyleOption(input, options),
		"tables.setBorder": (input, options) => api.tables.setBorder(input, options),
		"tables.clearBorder": (input, options) => api.tables.clearBorder(input, options),
		"tables.applyBorderPreset": (input, options) => api.tables.applyBorderPreset(input, options),
		"tables.setShading": (input, options) => api.tables.setShading(input, options),
		"tables.clearShading": (input, options) => api.tables.clearShading(input, options),
		"tables.setTablePadding": (input, options) => api.tables.setTablePadding(input, options),
		"tables.setCellPadding": (input, options) => api.tables.setCellPadding(input, options),
		"tables.setCellSpacing": (input, options) => api.tables.setCellSpacing(input, options),
		"tables.clearCellSpacing": (input, options) => api.tables.clearCellSpacing(input, options),
		"tables.applyStyle": (input, options) => api.tables.applyStyle(input, options),
		"tables.setBorders": (input, options) => api.tables.setBorders(input, options),
		"tables.setTableOptions": (input, options) => api.tables.setTableOptions(input, options),
		"tables.applyPreset": (input, options) => api.tables.applyPreset(input, options),
		"tables.get": (input) => api.tables.get(input),
		"tables.getCells": (input) => api.tables.getCells(input),
		"tables.getProperties": (input) => api.tables.getProperties(input),
		"tables.getStyles": (input) => api.tables.getStyles(input),
		"tables.setDefaultStyle": (input, options) => api.tables.setDefaultStyle(input, options),
		"tables.clearDefaultStyle": (input, options) => api.tables.clearDefaultStyle(input, options),
		"create.tableOfContents": (input, options) => api.create.tableOfContents(input, options),
		"toc.list": (input) => api.toc.list(input),
		"toc.get": (input) => api.toc.get(input),
		"toc.configure": (input, options) => api.toc.configure(input, options),
		"toc.update": (input, options) => api.toc.update(input, options),
		"toc.remove": (input, options) => api.toc.remove(input, options),
		"toc.markEntry": (input, options) => api.toc.markEntry(input, options),
		"toc.unmarkEntry": (input, options) => api.toc.unmarkEntry(input, options),
		"toc.listEntries": (input) => api.toc.listEntries(input),
		"toc.getEntry": (input) => api.toc.getEntry(input),
		"toc.editEntry": (input, options) => api.toc.editEntry(input, options),
		"create.image": (input, options) => api.create.image(input, options),
		"images.list": (input) => api.images.list(input),
		"images.get": (input) => api.images.get(input),
		"images.delete": (input, options) => api.images.delete(input, options),
		"images.move": (input, options) => api.images.move(input, options),
		"images.convertToInline": (input, options) => api.images.convertToInline(input, options),
		"images.convertToFloating": (input, options) => api.images.convertToFloating(input, options),
		"images.setSize": (input, options) => api.images.setSize(input, options),
		"images.setWrapType": (input, options) => api.images.setWrapType(input, options),
		"images.setWrapSide": (input, options) => api.images.setWrapSide(input, options),
		"images.setWrapDistances": (input, options) => api.images.setWrapDistances(input, options),
		"images.setPosition": (input, options) => api.images.setPosition(input, options),
		"images.setAnchorOptions": (input, options) => api.images.setAnchorOptions(input, options),
		"images.setZOrder": (input, options) => api.images.setZOrder(input, options),
		"images.scale": (input, options) => api.images.scale(input, options),
		"images.setLockAspectRatio": (input, options) => api.images.setLockAspectRatio(input, options),
		"images.rotate": (input, options) => api.images.rotate(input, options),
		"images.flip": (input, options) => api.images.flip(input, options),
		"images.crop": (input, options) => api.images.crop(input, options),
		"images.resetCrop": (input, options) => api.images.resetCrop(input, options),
		"images.replaceSource": (input, options) => api.images.replaceSource(input, options),
		"images.setAltText": (input, options) => api.images.setAltText(input, options),
		"images.setDecorative": (input, options) => api.images.setDecorative(input, options),
		"images.setName": (input, options) => api.images.setName(input, options),
		"images.setHyperlink": (input, options) => api.images.setHyperlink(input, options),
		"images.insertCaption": (input, options) => api.images.insertCaption(input, options),
		"images.updateCaption": (input, options) => api.images.updateCaption(input, options),
		"images.removeCaption": (input, options) => api.images.removeCaption(input, options),
		"hyperlinks.list": (input) => api.hyperlinks.list(input),
		"hyperlinks.get": (input) => api.hyperlinks.get(input),
		"hyperlinks.wrap": (input, options) => api.hyperlinks.wrap(input, options),
		"hyperlinks.insert": (input, options) => api.hyperlinks.insert(input, options),
		"hyperlinks.patch": (input, options) => api.hyperlinks.patch(input, options),
		"hyperlinks.remove": (input, options) => api.hyperlinks.remove(input, options),
		"headerFooters.list": (input) => api.headerFooters.list(input),
		"headerFooters.get": (input) => api.headerFooters.get(input),
		"headerFooters.resolve": (input) => api.headerFooters.resolve(input),
		"headerFooters.refs.set": (input, options) => api.headerFooters.refs.set(input, options),
		"headerFooters.refs.clear": (input, options) => api.headerFooters.refs.clear(input, options),
		"headerFooters.refs.setLinkedToPrevious": (input, options) => api.headerFooters.refs.setLinkedToPrevious(input, options),
		"headerFooters.parts.list": (input) => api.headerFooters.parts.list(input),
		"headerFooters.parts.create": (input, options) => api.headerFooters.parts.create(input, options),
		"headerFooters.parts.delete": (input, options) => api.headerFooters.parts.delete(input, options),
		"create.contentControl": (input, options) => api.create.contentControl(input, options),
		"contentControls.list": (input) => api.contentControls.list(input),
		"contentControls.get": (input) => api.contentControls.get(input),
		"contentControls.listInRange": (input) => api.contentControls.listInRange(input),
		"contentControls.selectByTag": (input) => api.contentControls.selectByTag(input),
		"contentControls.selectByTitle": (input) => api.contentControls.selectByTitle(input),
		"contentControls.listChildren": (input) => api.contentControls.listChildren(input),
		"contentControls.getParent": (input) => api.contentControls.getParent(input),
		"contentControls.wrap": (input, options) => api.contentControls.wrap(input, options),
		"contentControls.unwrap": (input, options) => api.contentControls.unwrap(input, options),
		"contentControls.delete": (input, options) => api.contentControls.delete(input, options),
		"contentControls.copy": (input, options) => api.contentControls.copy(input, options),
		"contentControls.move": (input, options) => api.contentControls.move(input, options),
		"contentControls.patch": (input, options) => api.contentControls.patch(input, options),
		"contentControls.setLockMode": (input, options) => api.contentControls.setLockMode(input, options),
		"contentControls.setType": (input, options) => api.contentControls.setType(input, options),
		"contentControls.getContent": (input) => api.contentControls.getContent(input),
		"contentControls.replaceContent": (input, options) => api.contentControls.replaceContent(input, options),
		"contentControls.clearContent": (input, options) => api.contentControls.clearContent(input, options),
		"contentControls.appendContent": (input, options) => api.contentControls.appendContent(input, options),
		"contentControls.prependContent": (input, options) => api.contentControls.prependContent(input, options),
		"contentControls.insertBefore": (input, options) => api.contentControls.insertBefore(input, options),
		"contentControls.insertAfter": (input, options) => api.contentControls.insertAfter(input, options),
		"contentControls.getBinding": (input) => api.contentControls.getBinding(input),
		"contentControls.setBinding": (input, options) => api.contentControls.setBinding(input, options),
		"contentControls.clearBinding": (input, options) => api.contentControls.clearBinding(input, options),
		"contentControls.getRawProperties": (input) => api.contentControls.getRawProperties(input),
		"contentControls.patchRawProperties": (input, options) => api.contentControls.patchRawProperties(input, options),
		"contentControls.validateWordCompatibility": (input) => api.contentControls.validateWordCompatibility(input),
		"contentControls.normalizeWordCompatibility": (input, options) => api.contentControls.normalizeWordCompatibility(input, options),
		"contentControls.normalizeTagPayload": (input, options) => api.contentControls.normalizeTagPayload(input, options),
		"contentControls.text.setMultiline": (input, options) => api.contentControls.text.setMultiline(input, options),
		"contentControls.text.setValue": (input, options) => api.contentControls.text.setValue(input, options),
		"contentControls.text.clearValue": (input, options) => api.contentControls.text.clearValue(input, options),
		"contentControls.date.setValue": (input, options) => api.contentControls.date.setValue(input, options),
		"contentControls.date.clearValue": (input, options) => api.contentControls.date.clearValue(input, options),
		"contentControls.date.setDisplayFormat": (input, options) => api.contentControls.date.setDisplayFormat(input, options),
		"contentControls.date.setDisplayLocale": (input, options) => api.contentControls.date.setDisplayLocale(input, options),
		"contentControls.date.setStorageFormat": (input, options) => api.contentControls.date.setStorageFormat(input, options),
		"contentControls.date.setCalendar": (input, options) => api.contentControls.date.setCalendar(input, options),
		"contentControls.checkbox.getState": (input) => api.contentControls.checkbox.getState(input),
		"contentControls.checkbox.setState": (input, options) => api.contentControls.checkbox.setState(input, options),
		"contentControls.checkbox.toggle": (input, options) => api.contentControls.checkbox.toggle(input, options),
		"contentControls.checkbox.setSymbolPair": (input, options) => api.contentControls.checkbox.setSymbolPair(input, options),
		"contentControls.choiceList.getItems": (input) => api.contentControls.choiceList.getItems(input),
		"contentControls.choiceList.setItems": (input, options) => api.contentControls.choiceList.setItems(input, options),
		"contentControls.choiceList.setSelected": (input, options) => api.contentControls.choiceList.setSelected(input, options),
		"contentControls.repeatingSection.listItems": (input) => api.contentControls.repeatingSection.listItems(input),
		"contentControls.repeatingSection.insertItemBefore": (input, options) => api.contentControls.repeatingSection.insertItemBefore(input, options),
		"contentControls.repeatingSection.insertItemAfter": (input, options) => api.contentControls.repeatingSection.insertItemAfter(input, options),
		"contentControls.repeatingSection.cloneItem": (input, options) => api.contentControls.repeatingSection.cloneItem(input, options),
		"contentControls.repeatingSection.deleteItem": (input, options) => api.contentControls.repeatingSection.deleteItem(input, options),
		"contentControls.repeatingSection.setAllowInsertDelete": (input, options) => api.contentControls.repeatingSection.setAllowInsertDelete(input, options),
		"contentControls.group.wrap": (input, options) => api.contentControls.group.wrap(input, options),
		"contentControls.group.ungroup": (input, options) => api.contentControls.group.ungroup(input, options),
		"bookmarks.list": (input) => api.bookmarks.list(input),
		"bookmarks.get": (input) => api.bookmarks.get(input),
		"bookmarks.insert": (input, options) => api.bookmarks.insert(input, options),
		"bookmarks.rename": (input, options) => api.bookmarks.rename(input, options),
		"bookmarks.remove": (input, options) => api.bookmarks.remove(input, options),
		"footnotes.list": (input) => api.footnotes.list(input),
		"footnotes.get": (input) => api.footnotes.get(input),
		"footnotes.insert": (input, options) => api.footnotes.insert(input, options),
		"footnotes.update": (input, options) => api.footnotes.update(input, options),
		"footnotes.remove": (input, options) => api.footnotes.remove(input, options),
		"footnotes.configure": (input, options) => api.footnotes.configure(input, options),
		"crossRefs.list": (input) => api.crossRefs.list(input),
		"crossRefs.get": (input) => api.crossRefs.get(input),
		"crossRefs.insert": (input, options) => api.crossRefs.insert(input, options),
		"crossRefs.rebuild": (input, options) => api.crossRefs.rebuild(input, options),
		"crossRefs.remove": (input, options) => api.crossRefs.remove(input, options),
		"index.list": (input) => api.index.list(input),
		"index.get": (input) => api.index.get(input),
		"index.insert": (input, options) => api.index.insert(input, options),
		"index.configure": (input, options) => api.index.configure(input, options),
		"index.rebuild": (input, options) => api.index.rebuild(input, options),
		"index.remove": (input, options) => api.index.remove(input, options),
		"index.entries.list": (input) => api.index.entries.list(input),
		"index.entries.get": (input) => api.index.entries.get(input),
		"index.entries.insert": (input, options) => api.index.entries.insert(input, options),
		"index.entries.update": (input, options) => api.index.entries.update(input, options),
		"index.entries.remove": (input, options) => api.index.entries.remove(input, options),
		"captions.list": (input) => api.captions.list(input),
		"captions.get": (input) => api.captions.get(input),
		"captions.insert": (input, options) => api.captions.insert(input, options),
		"captions.update": (input, options) => api.captions.update(input, options),
		"captions.remove": (input, options) => api.captions.remove(input, options),
		"captions.configure": (input, options) => api.captions.configure(input, options),
		"fields.list": (input) => api.fields.list(input),
		"fields.get": (input) => api.fields.get(input),
		"fields.insert": (input, options) => api.fields.insert(input, options),
		"fields.rebuild": (input, options) => api.fields.rebuild(input, options),
		"fields.remove": (input, options) => api.fields.remove(input, options),
		"citations.list": (input) => api.citations.list(input),
		"citations.get": (input) => api.citations.get(input),
		"citations.insert": (input, options) => api.citations.insert(input, options),
		"citations.update": (input, options) => api.citations.update(input, options),
		"citations.remove": (input, options) => api.citations.remove(input, options),
		"citations.sources.list": (input) => api.citations.sources.list(input),
		"citations.sources.get": (input) => api.citations.sources.get(input),
		"citations.sources.insert": (input, options) => api.citations.sources.insert(input, options),
		"citations.sources.update": (input, options) => api.citations.sources.update(input, options),
		"citations.sources.remove": (input, options) => api.citations.sources.remove(input, options),
		"citations.bibliography.get": (input) => api.citations.bibliography.get(input),
		"citations.bibliography.insert": (input, options) => api.citations.bibliography.insert(input, options),
		"citations.bibliography.rebuild": (input, options) => api.citations.bibliography.rebuild(input, options),
		"citations.bibliography.configure": (input, options) => api.citations.bibliography.configure(input, options),
		"citations.bibliography.remove": (input, options) => api.citations.bibliography.remove(input, options),
		"authorities.list": (input) => api.authorities.list(input),
		"authorities.get": (input) => api.authorities.get(input),
		"authorities.insert": (input, options) => api.authorities.insert(input, options),
		"authorities.configure": (input, options) => api.authorities.configure(input, options),
		"authorities.rebuild": (input, options) => api.authorities.rebuild(input, options),
		"authorities.remove": (input, options) => api.authorities.remove(input, options),
		"authorities.entries.list": (input) => api.authorities.entries.list(input),
		"authorities.entries.get": (input) => api.authorities.entries.get(input),
		"authorities.entries.insert": (input, options) => api.authorities.entries.insert(input, options),
		"authorities.entries.update": (input, options) => api.authorities.entries.update(input, options),
		"authorities.entries.remove": (input, options) => api.authorities.entries.remove(input, options),
		"diff.capture": () => api.diff.capture(),
		"diff.compare": (input) => api.diff.compare(input),
		"diff.apply": (input, options) => api.diff.apply(input, options),
		"protection.get": (input) => api.protection.get(input),
		"protection.setEditingRestriction": (input, options) => api.protection.setEditingRestriction(input, options),
		"protection.clearEditingRestriction": (input, options) => api.protection.clearEditingRestriction(input, options),
		"permissionRanges.list": (input) => api.permissionRanges.list(input),
		"permissionRanges.get": (input) => api.permissionRanges.get(input),
		"permissionRanges.create": (input, options) => api.permissionRanges.create(input, options),
		"permissionRanges.remove": (input, options) => api.permissionRanges.remove(input, options),
		"permissionRanges.updatePrincipal": (input, options) => api.permissionRanges.updatePrincipal(input, options),
		"customXml.parts.list": (input) => api.customXml.parts.list(input),
		"customXml.parts.get": (input) => api.customXml.parts.get(input),
		"customXml.parts.create": (input, options) => api.customXml.parts.create(input, options),
		"customXml.parts.patch": (input, options) => api.customXml.parts.patch(input, options),
		"customXml.parts.remove": (input, options) => api.customXml.parts.remove(input, options),
		"metadata.attach": (input, options) => api.metadata.attach(input, options),
		"metadata.list": (input) => api.metadata.list(input),
		"metadata.get": (input) => api.metadata.get(input),
		"metadata.update": (input, options) => api.metadata.update(input, options),
		"metadata.remove": (input, options) => api.metadata.remove(input, options),
		"metadata.resolve": (input) => api.metadata.resolve(input)
	};
}
function executeHistoryGet(adapter) {
	return adapter.get();
}
function executeHistoryUndo(adapter) {
	return adapter.undo();
}
function executeHistoryRedo(adapter) {
	return adapter.redo();
}
var SNAPSHOT_VERSIONS = new Set(["sd-diff-snapshot/v1", "sd-diff-snapshot/v2"]);
var PAYLOAD_VERSIONS = new Set(["sd-diff-payload/v1", "sd-diff-payload/v2"]);
function isRecord$1(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
function validateSnapshotWrapper(snapshot) {
	if (!isRecord$1(snapshot)) throw new DocumentApiValidationError("INVALID_INPUT", "targetSnapshot must be a DiffSnapshot object.");
	if (!SNAPSHOT_VERSIONS.has(String(snapshot.version))) throw new DocumentApiValidationError("CAPABILITY_UNSUPPORTED", `Unsupported snapshot version "${String(snapshot.version)}". Expected one of "${[...SNAPSHOT_VERSIONS].join("\", \"")}".`);
	if (typeof snapshot.engine !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "targetSnapshot.engine must be a string.");
	if (typeof snapshot.fingerprint !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "targetSnapshot.fingerprint must be a string.");
	if (!isRecord$1(snapshot.coverage)) throw new DocumentApiValidationError("INVALID_INPUT", "targetSnapshot.coverage must be an object.");
	if (!isRecord$1(snapshot.payload)) throw new DocumentApiValidationError("INVALID_INPUT", "targetSnapshot.payload must be an object.");
}
function validateDiffPayloadWrapper(diff) {
	if (!isRecord$1(diff)) throw new DocumentApiValidationError("INVALID_INPUT", "diff must be a DiffPayload object.");
	if (!PAYLOAD_VERSIONS.has(String(diff.version))) throw new DocumentApiValidationError("CAPABILITY_UNSUPPORTED", `Unsupported diff version "${String(diff.version)}". Expected one of "${[...PAYLOAD_VERSIONS].join("\", \"")}".`);
	if (typeof diff.engine !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "diff.engine must be a string.");
	if (typeof diff.baseFingerprint !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "diff.baseFingerprint must be a string.");
	if (typeof diff.targetFingerprint !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "diff.targetFingerprint must be a string.");
	if (!isRecord$1(diff.coverage)) throw new DocumentApiValidationError("INVALID_INPUT", "diff.coverage must be an object.");
	if (!isRecord$1(diff.summary)) throw new DocumentApiValidationError("INVALID_INPUT", "diff.summary must be an object.");
	if (!isRecord$1(diff.payload)) throw new DocumentApiValidationError("INVALID_INPUT", "diff.payload must be an object.");
}
function executeDiffCapture(adapter) {
	return adapter.capture();
}
function executeDiffCompare(adapter, input) {
	validateSnapshotWrapper(input?.targetSnapshot);
	return adapter.compare(input);
}
function executeDiffApply(adapter, input, options) {
	validateDiffPayloadWrapper(input?.diff);
	return adapter.apply(input, options);
}
function isObjectRecord(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
function validateTableLocator(input, operationName) {
	const hasTarget = input.target !== void 0;
	const hasNodeId = input.nodeId !== void 0;
	if (hasTarget && hasNodeId) throw new DocumentApiValidationError("INVALID_TARGET", `Cannot combine target with nodeId on ${operationName} request. Use exactly one locator mode.`, { fields: ["target", "nodeId"] });
	if (!hasTarget && !hasNodeId) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target. Provide either target or nodeId.`);
	if (hasNodeId && typeof input.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `nodeId must be a string, got ${typeof input.nodeId}.`, {
		field: "nodeId",
		value: input.nodeId
	});
}
function validateRowLocator(input, operationName, options = {}) {
	validateTableLocator(input, operationName);
	const hasPosition = input.position != null;
	const hasRowIndex = input.rowIndex != null;
	const isAppendShorthand = !!options.allowAppendShorthand && !hasRowIndex && !hasPosition;
	if (input.nodeId != null) {
		if (!hasRowIndex && !isAppendShorthand) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: rowIndex is required when using nodeId for row operations. Use target to address a row directly, or pass nodeId + rowIndex to address a row within a table.`);
		return;
	}
	if (!isObjectRecord(input.target) || input.target.kind !== "block") return;
	if (input.target.nodeType === "table" && !hasRowIndex && !isAppendShorthand) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: rowIndex is required when target is a table.`);
	if (input.target.nodeType === "tableRow" && hasRowIndex) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: rowIndex must not be provided when target is a row node. Either pass a table target with rowIndex, or pass a row target without rowIndex.`);
}
function hasTableScopedCellCoordinates(input) {
	return input.rowIndex != null && input.columnIndex != null;
}
function validateCellOrTableScopedCellLocator(input, operationName) {
	validateTableLocator(input, operationName);
	if (input.rowIndex != null !== (input.columnIndex != null)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: both rowIndex and columnIndex are required when using table-scoped cell targeting. Provide both or neither.`, { fields: ["rowIndex", "columnIndex"] });
	const hasCoordinates = hasTableScopedCellCoordinates(input);
	if (isObjectRecord(input.target) && input.target.kind === "block") {
		if (input.target.nodeType === "tableCell" && hasCoordinates) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: rowIndex/columnIndex must not be provided when target is a cell node. Either pass a table target with coordinates, or pass a cell target without coordinates.`, { fields: ["rowIndex", "columnIndex"] });
		if (input.target.nodeType === "table" && !hasCoordinates) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}: rowIndex and columnIndex are required when target is a table.`, { fields: ["rowIndex", "columnIndex"] });
	}
}
function normalizeTablesSplitInput(input) {
	const legacy = input.atRowIndex;
	if (legacy === void 0) return input;
	if (input.rowIndex !== void 0 && input.rowIndex !== legacy) throw new DocumentApiValidationError("INVALID_TARGET", "tables.split: cannot provide both rowIndex and atRowIndex with different values.", { fields: ["rowIndex", "atRowIndex"] });
	const { atRowIndex: _legacy, ...rest } = input;
	return {
		...rest,
		rowIndex: legacy
	};
}
function executeTableLocatorOp(operationName, adapter, input, options) {
	validateTableLocator(input, operationName);
	return adapter(input, normalizeMutationOptions(options));
}
function executeRowLocatorOp(operationName, adapter, input, options, rowLocatorOptions) {
	validateRowLocator(input, operationName, rowLocatorOptions);
	return adapter(input, normalizeMutationOptions(options));
}
function executeCellOrTableScopedCellLocatorOp(operationName, adapter, input, options) {
	validateCellOrTableScopedCellLocator(input, operationName);
	return adapter(input, normalizeMutationOptions(options));
}
function executeDocumentLevelTableOp(adapter, input, options) {
	return adapter(input, normalizeMutationOptions(options));
}
var VALID_STYLE_OPTION_FLAGS = new Set([
	"headerRow",
	"lastRow",
	"totalRow",
	"firstColumn",
	"lastColumn",
	"bandedRows",
	"bandedColumns"
]);
function validateStyleOptionsPatch(options, operationName) {
	const keys$1 = Object.keys(options);
	for (const key of keys$1) {
		if (!VALID_STYLE_OPTION_FLAGS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: unrecognized style option flag "${key}".`, {
			field: "styleOptions",
			value: key
		});
		if (typeof options[key] !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: style option "${key}" must be a boolean.`, { field: `styleOptions.${key}` });
	}
}
function validateBorderSpec$1(spec, fieldPath, operationName) {
	if (typeof spec !== "object" || spec === null) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: ${fieldPath} must be a border spec object.`);
	if (typeof spec.lineStyle !== "string" || spec.lineStyle.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: ${fieldPath}.lineStyle must be a non-empty string.`, { field: `${fieldPath}.lineStyle` });
	if (typeof spec.lineWeightPt !== "number" || !Number.isFinite(spec.lineWeightPt) || spec.lineWeightPt <= 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: ${fieldPath}.lineWeightPt must be a positive number.`, { field: `${fieldPath}.lineWeightPt` });
	if (typeof spec.color !== "string" || spec.color.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: ${fieldPath}.color must be a non-empty string.`, { field: `${fieldPath}.color` });
	if (!TABLE_COLOR_PATTERN.test(spec.color)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: ${fieldPath}.color must be a 6-digit hex color without "#" or "auto".`, { field: `${fieldPath}.color` });
}
function validateBorderPatchEdge(value, edgeName, operationName) {
	if (value === void 0 || value === null) return;
	validateBorderSpec$1(value, `edges.${edgeName}`, operationName);
}
var VALID_APPLY_TO_VALUES = new Set([
	"all",
	"outside",
	"inside",
	"top",
	"bottom",
	"left",
	"right",
	"insideH",
	"insideV"
]);
var VALID_BORDER_EDGE_KEYS = new Set([
	"top",
	"bottom",
	"left",
	"right",
	"insideH",
	"insideV"
]);
function executeTablesApplyStyle(operationName, adapter, input, options) {
	validateTableLocator(input, operationName);
	const hasStyleId = input.styleId !== void 0;
	const hasOptions = input.styleOptions !== void 0;
	if (!hasStyleId && !hasOptions) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires at least one of styleId or styleOptions.`);
	if (hasStyleId && typeof input.styleId !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: styleId must be a string.`, { field: "styleId" });
	if (hasStyleId && input.styleId === "") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: styleId must be a non-empty string. Use tables.clearStyle to remove a style.`, { field: "styleId" });
	if (hasOptions) {
		if (typeof input.styleOptions !== "object" || input.styleOptions === null || Array.isArray(input.styleOptions)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: styleOptions must be a plain object.`, { field: "styleOptions" });
		const optionKeys = Object.keys(input.styleOptions);
		if (!hasStyleId && optionKeys.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: styleOptions must contain at least one flag when styleId is absent.`, { field: "styleOptions" });
		if (optionKeys.length > 0) validateStyleOptionsPatch(input.styleOptions, operationName);
	}
	return adapter(input, normalizeMutationOptions(options));
}
function executeTablesSetBorders(operationName, adapter, input, options) {
	validateTableLocator(input, operationName);
	if (!("mode" in input) || input.mode !== "applyTo" && input.mode !== "edges") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: mode must be "applyTo" or "edges".`, { field: "mode" });
	if (input.mode === "applyTo") {
		if (!VALID_APPLY_TO_VALUES.has(input.applyTo)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: applyTo must be one of: ${[...VALID_APPLY_TO_VALUES].join(", ")}.`, { field: "applyTo" });
		if (input.border === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: border is required when mode is "applyTo".`, { field: "border" });
		if (input.border !== null) validateBorderSpec$1(input.border, "border", operationName);
	}
	if (input.mode === "edges") {
		if (!input.edges || typeof input.edges !== "object") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: edges is required when mode is "edges".`, { field: "edges" });
		const edgeKeys = Object.keys(input.edges);
		if (edgeKeys.filter((k) => VALID_BORDER_EDGE_KEYS.has(k) && input.edges[k] !== void 0).length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: edges must contain at least one defined edge.`, { field: "edges" });
		for (const key of edgeKeys) {
			if (!VALID_BORDER_EDGE_KEYS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: unrecognized edge "${key}".`, { field: `edges.${key}` });
			validateBorderPatchEdge(input.edges[key], key, operationName);
		}
	}
	return adapter(input, normalizeMutationOptions(options));
}
function executeTablesSetTableOptions(operationName, adapter, input, options) {
	validateTableLocator(input, operationName);
	const hasMargins = input.defaultCellMargins !== void 0;
	const hasSpacing = input.cellSpacingPt !== void 0;
	if (!hasMargins && !hasSpacing) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires at least one of defaultCellMargins or cellSpacingPt.`);
	if (hasMargins) {
		if (typeof input.defaultCellMargins !== "object" || input.defaultCellMargins === null || Array.isArray(input.defaultCellMargins)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: defaultCellMargins must be a plain object with topPt, rightPt, bottomPt, leftPt.`, { field: "defaultCellMargins" });
		const m = input.defaultCellMargins;
		for (const side of [
			"topPt",
			"rightPt",
			"bottomPt",
			"leftPt"
		]) if (typeof m[side] !== "number" || !Number.isFinite(m[side]) || m[side] < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: defaultCellMargins.${side} must be a non-negative number.`, { field: `defaultCellMargins.${side}` });
	}
	if (hasSpacing && input.cellSpacingPt !== null) {
		if (typeof input.cellSpacingPt !== "number" || !Number.isFinite(input.cellSpacingPt) || input.cellSpacingPt < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName}: cellSpacingPt must be a non-negative number or null.`, { field: "cellSpacingPt" });
	}
	return adapter(input, normalizeMutationOptions(options));
}
var HEADER_FOOTER_KINDS$1 = ["header", "footer"];
var HEADER_FOOTER_VARIANTS$1 = [
	"default",
	"first",
	"even"
];
function assertOneOf$1(value, fieldName, allowed) {
	if (typeof value !== "string" || !allowed.includes(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be one of: ${allowed.join(", ")}.`, {
		field: fieldName,
		value,
		allowed
	});
}
function assertNonEmptyString$1(value, fieldName) {
	if (typeof value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a string.`, {
		field: fieldName,
		value
	});
	if (value.trim().length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a non-empty string.`, {
		field: fieldName,
		value
	});
}
function assertBoolean$1(value, fieldName) {
	if (typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a boolean.`, {
		field: fieldName,
		value
	});
}
function assertSectionAddress$1(value, fieldName) {
	if (!isRecord(value) || value.kind !== "section" || typeof value.sectionId !== "string" || value.sectionId.length === 0) throw new DocumentApiValidationError("INVALID_TARGET", `${fieldName} must be a section address.`, {
		field: fieldName,
		value
	});
}
function assertHeaderFooterSlotTarget(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} input must be an object.`);
	const target = input.target;
	if (!isRecord(target) || target.kind !== "headerFooterSlot") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}.target must be a headerFooterSlot address.`, {
		field: `${operationName}.target`,
		value: target
	});
	assertSectionAddress$1(target.section, `${operationName}.target.section`);
	assertOneOf$1(target.headerFooterKind, `${operationName}.target.headerFooterKind`, HEADER_FOOTER_KINDS$1);
	assertOneOf$1(target.variant, `${operationName}.target.variant`, HEADER_FOOTER_VARIANTS$1);
}
function assertHeaderFooterPartTarget(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} input must be an object.`);
	const target = input.target;
	if (!isRecord(target) || target.kind !== "headerFooterPart") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName}.target must be a headerFooterPart address.`, {
		field: `${operationName}.target`,
		value: target
	});
	assertNonEmptyString$1(target.refId, `${operationName}.target.refId`);
}
function executeHeaderFootersList(adapter, query) {
	if (query?.kind !== void 0) assertOneOf$1(query.kind, "headerFooters.list.kind", HEADER_FOOTER_KINDS$1);
	if (query?.section !== void 0) assertSectionAddress$1(query.section, "headerFooters.list.section");
	return adapter.list(query);
}
function executeHeaderFootersGet(adapter, input) {
	assertHeaderFooterSlotTarget(input, "headerFooters.get");
	return adapter.get(input);
}
function executeHeaderFootersResolve(adapter, input) {
	assertHeaderFooterSlotTarget(input, "headerFooters.resolve");
	return adapter.resolve(input);
}
function executeHeaderFootersRefsSet(adapter, input, options) {
	assertHeaderFooterSlotTarget(input, "headerFooters.refs.set");
	assertNonEmptyString$1(input.refId, "headerFooters.refs.set.refId");
	return adapter.refs.set(input, normalizeMutationOptions(options));
}
function executeHeaderFootersRefsClear(adapter, input, options) {
	assertHeaderFooterSlotTarget(input, "headerFooters.refs.clear");
	return adapter.refs.clear(input, normalizeMutationOptions(options));
}
function executeHeaderFootersRefsSetLinkedToPrevious(adapter, input, options) {
	assertHeaderFooterSlotTarget(input, "headerFooters.refs.setLinkedToPrevious");
	assertBoolean$1(input.linked, "headerFooters.refs.setLinkedToPrevious.linked");
	return adapter.refs.setLinkedToPrevious(input, normalizeMutationOptions(options));
}
function executeHeaderFootersPartsList(adapter, query) {
	if (query?.kind !== void 0) assertOneOf$1(query.kind, "headerFooters.parts.list.kind", HEADER_FOOTER_KINDS$1);
	return adapter.parts.list(query);
}
function executeHeaderFootersPartsCreate(adapter, input, options) {
	assertOneOf$1(input?.kind, "headerFooters.parts.create.kind", HEADER_FOOTER_KINDS$1);
	if (input.sourceRefId !== void 0) assertNonEmptyString$1(input.sourceRefId, "headerFooters.parts.create.sourceRefId");
	return adapter.parts.create(input, normalizeMutationOptions(options));
}
function executeHeaderFootersPartsDelete(adapter, input, options) {
	assertHeaderFooterPartTarget(input, "headerFooters.parts.delete");
	return adapter.parts.delete(input, normalizeMutationOptions(options));
}
var DEFAULT_SECTIONS_LIST_LIMIT = 250;
var SECTION_BREAK_TYPES = [
	"continuous",
	"nextPage",
	"evenPage",
	"oddPage"
];
var SECTION_ORIENTATIONS = ["portrait", "landscape"];
var SECTION_VERTICAL_ALIGNS = [
	"top",
	"center",
	"bottom",
	"both"
];
var SECTION_DIRECTIONS = ["ltr", "rtl"];
var HEADER_FOOTER_KINDS = ["header", "footer"];
var HEADER_FOOTER_VARIANTS = [
	"default",
	"first",
	"even"
];
var LINE_NUMBER_RESTARTS = [
	"continuous",
	"newPage",
	"newSection"
];
var PAGE_NUMBER_FORMATS = [
	"decimal",
	"lowerLetter",
	"upperLetter",
	"lowerRoman",
	"upperRoman",
	"numberInDash"
];
var PAGE_NUMBER_CHAPTER_SEPARATORS = [
	"hyphen",
	"period",
	"colon",
	"emDash",
	"enDash"
];
var PAGE_BORDER_DISPLAYS = [
	"allPages",
	"firstPage",
	"notFirstPage"
];
var PAGE_BORDER_OFFSET_FROM_VALUES = ["page", "text"];
var PAGE_BORDER_Z_ORDER_VALUES = ["front", "back"];
function assertSectionAddress(value, fieldName) {
	if (!isRecord(value) || value.kind !== "section" || typeof value.sectionId !== "string" || value.sectionId.length === 0) throw new DocumentApiValidationError("INVALID_TARGET", `${fieldName} must be a section address.`, {
		field: fieldName,
		value
	});
}
function assertSectionTarget(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} input must be an object.`);
	assertSectionAddress(input.target, `${operationName}.target`);
}
function assertBoolean(value, fieldName) {
	if (typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a boolean.`, {
		field: fieldName,
		value
	});
}
function assertString(value, fieldName) {
	if (typeof value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a string.`, {
		field: fieldName,
		value
	});
}
function assertNonEmptyString(value, fieldName) {
	assertString(value, fieldName);
	if (value.trim().length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a non-empty string.`, {
		field: fieldName,
		value
	});
}
function assertPositiveInteger(value, fieldName) {
	if (!Number.isInteger(value) || Number(value) <= 0) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a positive integer.`, {
		field: fieldName,
		value
	});
}
function assertNonNegativeNumber(value, fieldName) {
	if (typeof value !== "number" || !Number.isFinite(value) || value < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be a non-negative number.`, {
		field: fieldName,
		value
	});
}
function assertOneOf(value, fieldName, allowed) {
	if (typeof value !== "string" || !allowed.includes(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be one of: ${allowed.join(", ")}.`, {
		field: fieldName,
		value,
		allowed
	});
}
function hasAnyDefined(value, keys$1) {
	return keys$1.some((key) => value[key] !== void 0);
}
function assertObject(value, fieldName) {
	if (!isRecord(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must be an object.`, {
		field: fieldName,
		value
	});
}
function validateBorderSpec(value, fieldName) {
	assertObject(value, fieldName);
	if (!hasAnyDefined(value, [
		"style",
		"size",
		"space",
		"color",
		"shadow",
		"frame"
	])) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} must include at least one of style, size, space, color, shadow, or frame.`, {
		field: fieldName,
		value
	});
	if (value.style !== void 0) assertString(value.style, `${fieldName}.style`);
	if (value.size !== void 0) assertNonNegativeNumber(value.size, `${fieldName}.size`);
	if (value.space !== void 0) assertNonNegativeNumber(value.space, `${fieldName}.space`);
	if (value.color !== void 0) assertString(value.color, `${fieldName}.color`);
	if (value.shadow !== void 0) assertBoolean(value.shadow, `${fieldName}.shadow`);
	if (value.frame !== void 0) assertBoolean(value.frame, `${fieldName}.frame`);
}
function validatePageBorders(value, fieldName) {
	assertObject(value, fieldName);
	if (!hasAnyDefined(value, [
		"display",
		"offsetFrom",
		"zOrder",
		"top",
		"right",
		"bottom",
		"left"
	])) throw new DocumentApiValidationError("INVALID_INPUT", `${fieldName} requires at least one border field.`, {
		field: fieldName,
		value
	});
	if (value.display !== void 0) assertOneOf(value.display, `${fieldName}.display`, PAGE_BORDER_DISPLAYS);
	if (value.offsetFrom !== void 0) assertOneOf(value.offsetFrom, `${fieldName}.offsetFrom`, PAGE_BORDER_OFFSET_FROM_VALUES);
	if (value.zOrder !== void 0) assertOneOf(value.zOrder, `${fieldName}.zOrder`, PAGE_BORDER_Z_ORDER_VALUES);
	if (value.top !== void 0) validateBorderSpec(value.top, `${fieldName}.top`);
	if (value.right !== void 0) validateBorderSpec(value.right, `${fieldName}.right`);
	if (value.bottom !== void 0) validateBorderSpec(value.bottom, `${fieldName}.bottom`);
	if (value.left !== void 0) validateBorderSpec(value.left, `${fieldName}.left`);
}
function normalizeSectionsListQuery(query) {
	const limit = query?.limit ?? DEFAULT_SECTIONS_LIST_LIMIT;
	const offset = query?.offset ?? 0;
	if (!Number.isInteger(limit) || Number(limit) <= 0) throw new DocumentApiValidationError("INVALID_INPUT", "sections.list limit must be a positive integer.", {
		field: "limit",
		value: limit
	});
	if (!Number.isInteger(offset) || Number(offset) < 0) throw new DocumentApiValidationError("INVALID_INPUT", "sections.list offset must be a non-negative integer.", {
		field: "offset",
		value: offset
	});
	return {
		limit: Number(limit),
		offset: Number(offset)
	};
}
function validateHeaderFooterRefParams(operationName, kind, variant) {
	assertOneOf(kind, `${operationName}.kind`, HEADER_FOOTER_KINDS);
	assertOneOf(variant, `${operationName}.variant`, HEADER_FOOTER_VARIANTS);
}
function executeSectionsList(adapter, query) {
	return adapter.list(normalizeSectionsListQuery(query));
}
function executeSectionsGet(adapter, input) {
	assertSectionAddress(input?.address, "sections.get.address");
	return adapter.get(input);
}
function executeSectionsSetBreakType(adapter, input, options) {
	assertSectionTarget(input, "sections.setBreakType");
	assertOneOf(input.breakType, "sections.setBreakType.breakType", SECTION_BREAK_TYPES);
	return adapter.setBreakType(input, normalizeMutationOptions(options));
}
function executeSectionsSetPageMargins(adapter, input, options) {
	assertSectionTarget(input, "sections.setPageMargins");
	if (!hasAnyDefined(input, [
		"top",
		"right",
		"bottom",
		"left",
		"gutter"
	])) throw new DocumentApiValidationError("INVALID_INPUT", "sections.setPageMargins requires at least one margin field.");
	if (input.top !== void 0) assertNonNegativeNumber(input.top, "sections.setPageMargins.top");
	if (input.right !== void 0) assertNonNegativeNumber(input.right, "sections.setPageMargins.right");
	if (input.bottom !== void 0) assertNonNegativeNumber(input.bottom, "sections.setPageMargins.bottom");
	if (input.left !== void 0) assertNonNegativeNumber(input.left, "sections.setPageMargins.left");
	if (input.gutter !== void 0) assertNonNegativeNumber(input.gutter, "sections.setPageMargins.gutter");
	return adapter.setPageMargins(input, normalizeMutationOptions(options));
}
function executeSectionsSetHeaderFooterMargins(adapter, input, options) {
	assertSectionTarget(input, "sections.setHeaderFooterMargins");
	if (!hasAnyDefined(input, ["header", "footer"])) throw new DocumentApiValidationError("INVALID_INPUT", "sections.setHeaderFooterMargins requires at least one margin field.");
	if (input.header !== void 0) assertNonNegativeNumber(input.header, "sections.setHeaderFooterMargins.header");
	if (input.footer !== void 0) assertNonNegativeNumber(input.footer, "sections.setHeaderFooterMargins.footer");
	return adapter.setHeaderFooterMargins(input, normalizeMutationOptions(options));
}
function executeSectionsSetPageSetup(adapter, input, options) {
	assertSectionTarget(input, "sections.setPageSetup");
	if (!hasAnyDefined(input, [
		"width",
		"height",
		"orientation",
		"paperSize"
	])) throw new DocumentApiValidationError("INVALID_INPUT", "sections.setPageSetup requires at least one setup field.");
	if (input.width !== void 0) assertNonNegativeNumber(input.width, "sections.setPageSetup.width");
	if (input.height !== void 0) assertNonNegativeNumber(input.height, "sections.setPageSetup.height");
	if (input.orientation !== void 0) assertOneOf(input.orientation, "sections.setPageSetup.orientation", SECTION_ORIENTATIONS);
	if (input.paperSize !== void 0) assertNonEmptyString(input.paperSize, "sections.setPageSetup.paperSize");
	return adapter.setPageSetup(input, normalizeMutationOptions(options));
}
function executeSectionsSetColumns(adapter, input, options) {
	assertSectionTarget(input, "sections.setColumns");
	if (!hasAnyDefined(input, [
		"count",
		"gap",
		"equalWidth"
	])) throw new DocumentApiValidationError("INVALID_INPUT", "sections.setColumns requires at least one columns field.");
	if (input.count !== void 0) assertPositiveInteger(input.count, "sections.setColumns.count");
	if (input.gap !== void 0) assertNonNegativeNumber(input.gap, "sections.setColumns.gap");
	if (input.equalWidth !== void 0) assertBoolean(input.equalWidth, "sections.setColumns.equalWidth");
	return adapter.setColumns(input, normalizeMutationOptions(options));
}
function executeSectionsSetLineNumbering(adapter, input, options) {
	assertSectionTarget(input, "sections.setLineNumbering");
	assertBoolean(input.enabled, "sections.setLineNumbering.enabled");
	if (input.countBy !== void 0) assertPositiveInteger(input.countBy, "sections.setLineNumbering.countBy");
	if (input.start !== void 0) assertPositiveInteger(input.start, "sections.setLineNumbering.start");
	if (input.distance !== void 0) assertNonNegativeNumber(input.distance, "sections.setLineNumbering.distance");
	if (input.restart !== void 0) assertOneOf(input.restart, "sections.setLineNumbering.restart", LINE_NUMBER_RESTARTS);
	return adapter.setLineNumbering(input, normalizeMutationOptions(options));
}
function executeSectionsSetPageNumbering(adapter, input, options) {
	assertSectionTarget(input, "sections.setPageNumbering");
	if (!hasAnyDefined(input, [
		"start",
		"format",
		"chapterStyle",
		"chapterSeparator"
	])) throw new DocumentApiValidationError("INVALID_INPUT", "sections.setPageNumbering requires at least one of start, format, chapterStyle, or chapterSeparator.");
	if (input.start !== void 0) assertPositiveInteger(input.start, "sections.setPageNumbering.start");
	if (input.format !== void 0) assertOneOf(input.format, "sections.setPageNumbering.format", PAGE_NUMBER_FORMATS);
	if (input.chapterStyle !== void 0) assertPositiveInteger(input.chapterStyle, "sections.setPageNumbering.chapterStyle");
	if (input.chapterSeparator !== void 0) assertOneOf(input.chapterSeparator, "sections.setPageNumbering.chapterSeparator", PAGE_NUMBER_CHAPTER_SEPARATORS);
	return adapter.setPageNumbering(input, normalizeMutationOptions(options));
}
function executeSectionsSetTitlePage(adapter, input, options) {
	assertSectionTarget(input, "sections.setTitlePage");
	assertBoolean(input.enabled, "sections.setTitlePage.enabled");
	return adapter.setTitlePage(input, normalizeMutationOptions(options));
}
function executeSectionsSetOddEvenHeadersFooters(adapter, input, options) {
	assertBoolean(input?.enabled, "sections.setOddEvenHeadersFooters.enabled");
	return adapter.setOddEvenHeadersFooters(input, normalizeMutationOptions(options));
}
function executeSectionsSetVerticalAlign(adapter, input, options) {
	assertSectionTarget(input, "sections.setVerticalAlign");
	assertOneOf(input.value, "sections.setVerticalAlign.value", SECTION_VERTICAL_ALIGNS);
	return adapter.setVerticalAlign(input, normalizeMutationOptions(options));
}
function executeSectionsSetSectionDirection(adapter, input, options) {
	assertSectionTarget(input, "sections.setSectionDirection");
	assertOneOf(input.direction, "sections.setSectionDirection.direction", SECTION_DIRECTIONS);
	return adapter.setSectionDirection(input, normalizeMutationOptions(options));
}
function executeSectionsSetHeaderFooterRef(adapter, input, options) {
	assertSectionTarget(input, "sections.setHeaderFooterRef");
	validateHeaderFooterRefParams("sections.setHeaderFooterRef", input.kind, input.variant);
	assertNonEmptyString(input.refId, "sections.setHeaderFooterRef.refId");
	return adapter.setHeaderFooterRef(input, normalizeMutationOptions(options));
}
function executeSectionsClearHeaderFooterRef(adapter, input, options) {
	assertSectionTarget(input, "sections.clearHeaderFooterRef");
	validateHeaderFooterRefParams("sections.clearHeaderFooterRef", input.kind, input.variant);
	return adapter.clearHeaderFooterRef(input, normalizeMutationOptions(options));
}
function executeSectionsSetLinkToPrevious(adapter, input, options) {
	assertSectionTarget(input, "sections.setLinkToPrevious");
	validateHeaderFooterRefParams("sections.setLinkToPrevious", input.kind, input.variant);
	assertBoolean(input.linked, "sections.setLinkToPrevious.linked");
	return adapter.setLinkToPrevious(input, normalizeMutationOptions(options));
}
function executeSectionsSetPageBorders(adapter, input, options) {
	assertSectionTarget(input, "sections.setPageBorders");
	validatePageBorders(input.borders, "sections.setPageBorders.borders");
	return adapter.setPageBorders(input, normalizeMutationOptions(options));
}
function executeSectionsClearPageBorders(adapter, input, options) {
	assertSectionTarget(input, "sections.clearPageBorders");
	return adapter.clearPageBorders(input, normalizeMutationOptions(options));
}
var VALID_WRAP_TYPES = new Set([
	"Inline",
	"None",
	"Square",
	"Tight",
	"Through",
	"TopAndBottom"
]);
var VALID_WRAP_SIDES = new Set([
	"bothSides",
	"left",
	"right",
	"largest"
]);
var VALID_IMAGE_SIZE_UNITS = new Set([
	"px",
	"pt",
	"twip"
]);
function requireString$1(value, field) {
	if (typeof value !== "string" || value.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a non-empty string.`, { field });
}
function requireImageId(input) {
	requireString$1(input?.imageId, "imageId");
}
function requireFinitePositiveNumber(value, field) {
	if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be a finite positive number.`, {
		field,
		value
	});
}
function requireUnsignedInt32(value, field) {
	if (!isUnsignedInt32(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${field} must be an unsigned 32-bit integer (0..${Z_ORDER_RELATIVE_HEIGHT_MAX}).`, {
		field,
		value,
		minimum: 0,
		maximum: Z_ORDER_RELATIVE_HEIGHT_MAX
	});
}
function executeImagesList(adapter, input) {
	return adapter.list(input ?? {});
}
function executeImagesGet(adapter, input) {
	requireImageId(input);
	return adapter.get(input);
}
function executeImagesDelete(adapter, input, options) {
	requireImageId(input);
	return adapter.delete(input, options);
}
function executeImagesMove(adapter, input, options) {
	requireImageId(input);
	if (!input.to) throw new DocumentApiValidationError("INVALID_INPUT", "images.move requires a \"to\" location.", { field: "to" });
	return adapter.move(input, options);
}
function executeImagesConvertToInline(adapter, input, options) {
	requireImageId(input);
	return adapter.convertToInline(input, options);
}
function executeImagesConvertToFloating(adapter, input, options) {
	requireImageId(input);
	return adapter.convertToFloating(input, options);
}
function executeImagesSetSize(adapter, input, options) {
	requireImageId(input);
	if (!input.size || typeof input.size !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.setSize requires a \"size\" object.", { field: "size" });
	requireFinitePositiveNumber(input.size.width, "size.width");
	requireFinitePositiveNumber(input.size.height, "size.height");
	if (input.size.unit !== void 0 && !VALID_IMAGE_SIZE_UNITS.has(input.size.unit)) throw new DocumentApiValidationError("INVALID_INPUT", "size.unit must be one of: px, pt, twip.", {
		field: "size.unit",
		allowed: [...VALID_IMAGE_SIZE_UNITS]
	});
	return adapter.setSize(input, options);
}
function executeImagesSetWrapType(adapter, input, options) {
	requireImageId(input);
	if (!VALID_WRAP_TYPES.has(input.type)) throw new DocumentApiValidationError("INVALID_INPUT", `Invalid wrap type: "${input.type}".`, {
		field: "type",
		allowed: [...VALID_WRAP_TYPES]
	});
	return adapter.setWrapType(input, options);
}
function executeImagesSetWrapSide(adapter, input, options) {
	requireImageId(input);
	if (!VALID_WRAP_SIDES.has(input.side)) throw new DocumentApiValidationError("INVALID_INPUT", `Invalid wrap side: "${input.side}".`, {
		field: "side",
		allowed: [...VALID_WRAP_SIDES]
	});
	return adapter.setWrapSide(input, options);
}
function executeImagesSetWrapDistances(adapter, input, options) {
	requireImageId(input);
	if (!input.distances || typeof input.distances !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.setWrapDistances requires a \"distances\" object.", { field: "distances" });
	return adapter.setWrapDistances(input, options);
}
function executeImagesSetPosition(adapter, input, options) {
	requireImageId(input);
	if (!input.position || typeof input.position !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.setPosition requires a \"position\" object.", { field: "position" });
	return adapter.setPosition(input, options);
}
function executeImagesSetAnchorOptions(adapter, input, options) {
	requireImageId(input);
	if (!input.options || typeof input.options !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.setAnchorOptions requires an \"options\" object.", { field: "options" });
	return adapter.setAnchorOptions(input, options);
}
function executeImagesSetZOrder(adapter, input, options) {
	requireImageId(input);
	if (!input.zOrder || typeof input.zOrder !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.setZOrder requires a \"zOrder\" object.", { field: "zOrder" });
	requireUnsignedInt32(input.zOrder.relativeHeight, "zOrder.relativeHeight");
	return adapter.setZOrder(input, options);
}
function executeImagesScale(adapter, input, options) {
	requireImageId(input);
	if (typeof input.factor !== "number" || !Number.isFinite(input.factor) || input.factor <= 0) throw new DocumentApiValidationError("INVALID_INPUT", "images.scale requires factor as a finite positive number.", {
		field: "factor",
		value: input.factor
	});
	return adapter.scale(input, options);
}
function executeImagesSetLockAspectRatio(adapter, input, options) {
	requireImageId(input);
	if (typeof input.locked !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "images.setLockAspectRatio requires locked as a boolean.", { field: "locked" });
	return adapter.setLockAspectRatio(input, options);
}
function executeImagesRotate(adapter, input, options) {
	requireImageId(input);
	if (typeof input.angle !== "number" || !Number.isFinite(input.angle) || input.angle < 0 || input.angle > 360) throw new DocumentApiValidationError("INVALID_INPUT", "images.rotate requires angle as a number in [0, 360].", {
		field: "angle",
		value: input.angle
	});
	return adapter.rotate(input, options);
}
function executeImagesFlip(adapter, input, options) {
	requireImageId(input);
	if (input.horizontal === void 0 && input.vertical === void 0) throw new DocumentApiValidationError("INVALID_INPUT", "images.flip requires at least one of horizontal or vertical.", { field: "horizontal|vertical" });
	if (input.horizontal !== void 0 && typeof input.horizontal !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "images.flip horizontal must be a boolean.", { field: "horizontal" });
	if (input.vertical !== void 0 && typeof input.vertical !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "images.flip vertical must be a boolean.", { field: "vertical" });
	return adapter.flip(input, options);
}
function executeImagesCrop(adapter, input, options) {
	requireImageId(input);
	if (!input.crop || typeof input.crop !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "images.crop requires a crop object.", { field: "crop" });
	const { left = 0, top = 0, right = 0, bottom = 0 } = input.crop;
	for (const [name, value] of Object.entries({
		left,
		top,
		right,
		bottom
	})) if (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > 100) throw new DocumentApiValidationError("INVALID_INPUT", `crop.${name} must be a number in [0, 100].`, {
		field: `crop.${name}`,
		value
	});
	if (left + right >= 100) throw new DocumentApiValidationError("INVALID_INPUT", "crop.left + crop.right must be less than 100.", { field: "crop" });
	if (top + bottom >= 100) throw new DocumentApiValidationError("INVALID_INPUT", "crop.top + crop.bottom must be less than 100.", { field: "crop" });
	return adapter.crop(input, options);
}
function executeImagesResetCrop(adapter, input, options) {
	requireImageId(input);
	return adapter.resetCrop(input, options);
}
function executeImagesReplaceSource(adapter, input, options) {
	requireImageId(input);
	requireString$1(input.src, "src");
	return adapter.replaceSource(input, options);
}
function executeImagesSetAltText(adapter, input, options) {
	requireImageId(input);
	if (typeof input.description !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "images.setAltText requires description as a string.", { field: "description" });
	return adapter.setAltText(input, options);
}
function executeImagesSetDecorative(adapter, input, options) {
	requireImageId(input);
	if (typeof input.decorative !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", "images.setDecorative requires decorative as a boolean.", { field: "decorative" });
	return adapter.setDecorative(input, options);
}
function executeImagesSetName(adapter, input, options) {
	requireImageId(input);
	if (typeof input.name !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "images.setName requires name as a string.", { field: "name" });
	return adapter.setName(input, options);
}
function executeImagesSetHyperlink(adapter, input, options) {
	requireImageId(input);
	if (input.url !== null && typeof input.url !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "images.setHyperlink requires url as a string or null.", { field: "url" });
	if (input.tooltip !== void 0 && typeof input.tooltip !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "images.setHyperlink tooltip must be a string.", { field: "tooltip" });
	return adapter.setHyperlink(input, options);
}
function executeImagesInsertCaption(adapter, input, options) {
	requireImageId(input);
	requireString$1(input.text, "text");
	return adapter.insertCaption(input, options);
}
function executeImagesUpdateCaption(adapter, input, options) {
	requireImageId(input);
	requireString$1(input.text, "text");
	return adapter.updateCaption(input, options);
}
function executeImagesRemoveCaption(adapter, input, options) {
	requireImageId(input);
	return adapter.removeCaption(input, options);
}
function executeCreateImage(adapter, input, options) {
	requireString$1(input?.src, "src");
	validateStoryLocator(input?.in, "in");
	return adapter.image(input, options);
}
function validateTocTarget(target, operationName) {
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target.`);
	const t = target;
	if (t.kind !== "block" || t.nodeType !== "tableOfContents" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a TocAddress with kind 'block', nodeType 'tableOfContents', and a string nodeId.`, { target });
}
function validateTocEntryTarget(target, operationName) {
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target.`);
	const t = target;
	if (t.kind !== "inline" || t.nodeType !== "tableOfContentsEntry" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a TocEntryAddress with kind 'inline', nodeType 'tableOfContentsEntry', and a string nodeId.`, { target });
}
function validateInsertionTarget(target, operationName) {
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target.`);
	const t = target;
	if (t.kind !== "inline-insert") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must have kind 'inline-insert'.`, { target });
	const anchor = t.anchor;
	if (!anchor || anchor.nodeType !== "paragraph" || typeof anchor.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target.anchor must have nodeType 'paragraph' and a string nodeId.`, { target });
}
function validateTocInput(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} input must be a non-null object.`);
}
function executeTocList(adapter, query) {
	return adapter.list(query);
}
function executeTocGet(adapter, input) {
	validateTocInput(input, "toc.get");
	validateTocTarget(input.target, "toc.get");
	return adapter.get(input);
}
function executeTocConfigure(adapter, input, options) {
	validateTocInput(input, "toc.configure");
	validateTocTarget(input.target, "toc.configure");
	return adapter.configure(input, normalizeMutationOptions(options));
}
var VALID_TOC_UPDATE_MODES = new Set(["all", "pageNumbers"]);
function executeTocUpdate(adapter, input, options) {
	validateTocInput(input, "toc.update");
	validateTocTarget(input.target, "toc.update");
	if (input.mode !== void 0 && !VALID_TOC_UPDATE_MODES.has(input.mode)) throw new DocumentApiValidationError("INVALID_INPUT", `toc.update mode must be "all" or "pageNumbers", got "${String(input.mode)}".`, {
		field: "mode",
		value: input.mode
	});
	return adapter.update(input, normalizeMutationOptions(options));
}
function executeTocRemove(adapter, input, options) {
	validateTocInput(input, "toc.remove");
	validateTocTarget(input.target, "toc.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeTocMarkEntry(adapter, input, options) {
	validateTocInput(input, "toc.markEntry");
	validateInsertionTarget(input.target, "toc.markEntry");
	if (!input.text || typeof input.text !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "toc.markEntry requires a non-empty text string.");
	return adapter.markEntry(input, normalizeMutationOptions(options));
}
function executeTocUnmarkEntry(adapter, input, options) {
	validateTocInput(input, "toc.unmarkEntry");
	validateTocEntryTarget(input.target, "toc.unmarkEntry");
	return adapter.unmarkEntry(input, normalizeMutationOptions(options));
}
function executeTocListEntries(adapter, query) {
	return adapter.listEntries(query);
}
function executeTocGetEntry(adapter, input) {
	validateTocInput(input, "toc.getEntry");
	validateTocEntryTarget(input.target, "toc.getEntry");
	return adapter.getEntry(input);
}
var EDIT_ENTRY_PATCH_ALLOWED_KEYS = new Set([
	"text",
	"level",
	"tableIdentifier",
	"omitPageNumber"
]);
function validateTocEditEntryPatch(patch, operationName) {
	if (!isRecord(patch)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch must be a non-null object.`, {
		field: "patch",
		value: patch
	});
	for (const key of Object.keys(patch)) if (!EDIT_ENTRY_PATCH_ALLOWED_KEYS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${key}" on ${operationName} patch. Allowed fields: ${[...EDIT_ENTRY_PATCH_ALLOWED_KEYS].join(", ")}.`, { field: `patch.${key}` });
	if (patch.text !== void 0 && typeof patch.text !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch.text must be a string.`, {
		field: "patch.text",
		value: patch.text
	});
	if (patch.level !== void 0) {
		if (typeof patch.level !== "number" || !Number.isInteger(patch.level) || patch.level < 1) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch.level must be a positive integer.`, {
			field: "patch.level",
			value: patch.level
		});
	}
	if (patch.tableIdentifier !== void 0 && typeof patch.tableIdentifier !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch.tableIdentifier must be a string.`, {
		field: "patch.tableIdentifier",
		value: patch.tableIdentifier
	});
	if (patch.omitPageNumber !== void 0 && typeof patch.omitPageNumber !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch.omitPageNumber must be a boolean.`, {
		field: "patch.omitPageNumber",
		value: patch.omitPageNumber
	});
}
function executeTocEditEntry(adapter, input, options) {
	validateTocInput(input, "toc.editEntry");
	validateTocEntryTarget(input.target, "toc.editEntry");
	validateTocEditEntryPatch(input.patch, "toc.editEntry");
	return adapter.editEntry(input, normalizeMutationOptions(options));
}
function isHyperlinkTarget(value) {
	if (!isRecord(value)) return false;
	if (value.kind !== "inline" || value.nodeType !== "hyperlink") return false;
	const anchor = value.anchor;
	if (!isRecord(anchor)) return false;
	const start = anchor.start;
	const end = anchor.end;
	if (!isRecord(start) || !isRecord(end)) return false;
	return typeof start.blockId === "string" && typeof start.offset === "number" && typeof end.blockId === "string" && typeof end.offset === "number";
}
function validateHyperlinkTarget(target, operationName) {
	if (target === void 0 || target === null) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target.`);
	if (!isHyperlinkTarget(target)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a HyperlinkTarget with kind 'inline', nodeType 'hyperlink', and a valid anchor.`, { target });
}
function validateDestination(destination, operationName) {
	if (!isRecord(destination)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a destination object.`);
	const hasHref = typeof destination.href === "string" && destination.href.length > 0;
	const hasAnchor = typeof destination.anchor === "string" && destination.anchor.length > 0;
	if (!hasHref && !hasAnchor) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} destination must have at least one of 'href' or 'anchor'.`);
}
function validateHyperlinkSpec(link, operationName) {
	if (!isRecord(link)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a link specification object.`);
	validateDestination(link.destination, operationName);
}
var PATCH_FIELDS = new Set([
	"href",
	"anchor",
	"docLocation",
	"tooltip",
	"target",
	"rel"
]);
function validatePatch(patch, operationName) {
	if (!isRecord(patch)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a patch object.`);
	for (const key of Object.keys(patch)) if (!PATCH_FIELDS.has(key)) throw new DocumentApiValidationError("INVALID_INPUT", `Unknown field "${key}" on ${operationName} patch. Allowed: ${[...PATCH_FIELDS].join(", ")}.`, { field: key });
	if (!Object.keys(patch).some((k) => patch[k] !== void 0)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch must set at least one field.`);
	for (const key of PATCH_FIELDS) {
		const val = patch[key];
		if (val !== void 0 && val !== null && typeof val !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} patch.${key} must be a string, null, or omitted.`);
	}
}
function executeHyperlinksList(adapter, query) {
	return adapter.list(query);
}
function executeHyperlinksGet(adapter, input) {
	validateHyperlinkTarget(input.target, "hyperlinks.get");
	return adapter.get(input);
}
function executeHyperlinksWrap(adapter, input, options) {
	if (!isTextAddress(input.target)) throw new DocumentApiValidationError("INVALID_TARGET", "hyperlinks.wrap requires a valid TextAddress target with kind 'text', blockId, and range.");
	if (input.target.range.start === input.target.range.end) throw new DocumentApiValidationError("INVALID_TARGET", "hyperlinks.wrap requires a non-collapsed range (start !== end).");
	validateHyperlinkSpec(input.link, "hyperlinks.wrap");
	return adapter.wrap(input, normalizeMutationOptions(options));
}
function executeHyperlinksInsert(adapter, input, options) {
	if (typeof input.text !== "string" || input.text.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "hyperlinks.insert requires a non-empty text string.");
	if (input.target !== void 0) {
		if (!isTextAddress(input.target)) throw new DocumentApiValidationError("INVALID_TARGET", "hyperlinks.insert target (if provided) must be a valid TextAddress with kind 'text', blockId, and range.");
		if (input.target.range.start !== input.target.range.end) throw new DocumentApiValidationError("INVALID_TARGET", "hyperlinks.insert target must be a collapsed range (start === end) indicating the insertion point.");
	}
	validateHyperlinkSpec(input.link, "hyperlinks.insert");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeHyperlinksPatch(adapter, input, options) {
	validateHyperlinkTarget(input.target, "hyperlinks.patch");
	validatePatch(input.patch, "hyperlinks.patch");
	return adapter.patch(input, normalizeMutationOptions(options));
}
function executeHyperlinksRemove(adapter, input, options) {
	validateHyperlinkTarget(input.target, "hyperlinks.remove");
	if (input.mode !== void 0 && input.mode !== "unwrap" && input.mode !== "deleteText") throw new DocumentApiValidationError("INVALID_INPUT", `hyperlinks.remove mode must be 'unwrap' or 'deleteText', got '${String(input.mode)}'.`);
	return adapter.remove(input, normalizeMutationOptions(options));
}
const CONTENT_CONTROL_TYPES = [
	"text",
	"richText",
	"date",
	"checkbox",
	"comboBox",
	"dropDownList",
	"repeatingSection",
	"repeatingSectionItem",
	"group",
	"unknown"
];
const LOCK_MODES = [
	"unlocked",
	"sdtLocked",
	"contentLocked",
	"sdtContentLocked"
];
const CONTENT_CONTROL_APPEARANCES = [
	"boundingBox",
	"tags",
	"hidden"
];
var VALID_NODE_KINDS = new Set(NODE_KINDS);
var VALID_LOCK_MODES$1 = new Set(LOCK_MODES);
var VALID_CC_TYPES = new Set(CONTENT_CONTROL_TYPES);
var VALID_CC_APPEARANCES = new Set(CONTENT_CONTROL_APPEARANCES);
var VALID_CONTENT_FORMATS = new Set(["text", "html"]);
function validateCCInput(input, operationName) {
	if (!isRecord(input)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} input must be a non-null object.`);
}
function validateCCTarget(target, operationName) {
	if (!isRecord(target)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a valid target with { kind, nodeType: 'sdt', nodeId }.`, {
		field: "target",
		value: target
	});
	if (!VALID_NODE_KINDS.has(target.kind)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target.kind must be 'block' or 'inline', got "${String(target.kind)}".`, {
		field: "target.kind",
		value: target.kind
	});
	if (target.nodeType !== "sdt") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target.nodeType must be 'sdt', got "${String(target.nodeType)}".`, {
		field: "target.nodeType",
		value: target.nodeType
	});
	if (typeof target.nodeId !== "string" || target.nodeId === "") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target.nodeId must be a non-empty string.`, {
		field: "target.nodeId",
		value: target.nodeId
	});
}
function requireString(value, field, operationName) {
	if (typeof value !== "string" || value.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be a non-empty string.`, {
		field,
		value
	});
}
function requireBoolean(value, field, operationName) {
	if (typeof value !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be a boolean, got ${typeof value}.`, {
		field,
		value
	});
}
function requireIndex(value, field, operationName) {
	if (!isInteger(value) || value < 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be a non-negative integer.`, {
		field,
		value
	});
}
function requireNodeKind(value, field, operationName) {
	if (!VALID_NODE_KINDS.has(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be 'block' or 'inline', got "${String(value)}".`, {
		field,
		value
	});
}
function validateContentFormat(value, field, operationName) {
	if (value !== void 0 && !VALID_CONTENT_FORMATS.has(value)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be 'text' or 'html', got "${String(value)}".`, {
		field,
		value
	});
}
function validateContentPayload(input, operationName) {
	if (typeof input.content !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} content must be a string.`, {
		field: "content",
		value: input.content
	});
	validateContentFormat(input.format, "format", operationName);
}
function validateSymbol(value, field, operationName) {
	if (!isRecord(value) || typeof value.font !== "string" || typeof value.char !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} ${field} must be { font: string, char: string }.`, {
		field,
		value
	});
}
function executeContentControlsList(adapter, query) {
	if (query !== void 0 && !isRecord(query)) throw new DocumentApiValidationError("INVALID_INPUT", "contentControls.list query must be an object if provided.");
	return adapter.list(query);
}
function executeContentControlsGet(adapter, input) {
	validateCCInput(input, "contentControls.get");
	validateCCTarget(input.target, "contentControls.get");
	return adapter.get(input);
}
function executeContentControlsListInRange(adapter, input) {
	validateCCInput(input, "contentControls.listInRange");
	requireString(input.startBlockId, "startBlockId", "contentControls.listInRange");
	requireString(input.endBlockId, "endBlockId", "contentControls.listInRange");
	return adapter.listInRange(input);
}
function executeContentControlsSelectByTag(adapter, input) {
	validateCCInput(input, "contentControls.selectByTag");
	requireString(input.tag, "tag", "contentControls.selectByTag");
	return adapter.selectByTag(input);
}
function executeContentControlsSelectByTitle(adapter, input) {
	validateCCInput(input, "contentControls.selectByTitle");
	requireString(input.title, "title", "contentControls.selectByTitle");
	return adapter.selectByTitle(input);
}
function executeContentControlsListChildren(adapter, input) {
	validateCCInput(input, "contentControls.listChildren");
	validateCCTarget(input.target, "contentControls.listChildren");
	return adapter.listChildren(input);
}
function executeContentControlsGetParent(adapter, input) {
	validateCCInput(input, "contentControls.getParent");
	validateCCTarget(input.target, "contentControls.getParent");
	return adapter.getParent(input);
}
function executeContentControlsWrap(adapter, input, options) {
	validateCCInput(input, "contentControls.wrap");
	requireNodeKind(input.kind, "kind", "contentControls.wrap");
	validateCCTarget(input.target, "contentControls.wrap");
	return adapter.wrap(input, options);
}
function executeContentControlsUnwrap(adapter, input, options) {
	validateCCInput(input, "contentControls.unwrap");
	validateCCTarget(input.target, "contentControls.unwrap");
	return adapter.unwrap(input, options);
}
function executeContentControlsDelete(adapter, input, options) {
	validateCCInput(input, "contentControls.delete");
	validateCCTarget(input.target, "contentControls.delete");
	return adapter.delete(input, options);
}
function executeContentControlsCopy(adapter, input, options) {
	validateCCInput(input, "contentControls.copy");
	validateCCTarget(input.target, "contentControls.copy");
	validateCCTarget(input.destination, "contentControls.copy (destination)");
	return adapter.copy(input, options);
}
function executeContentControlsMove(adapter, input, options) {
	validateCCInput(input, "contentControls.move");
	validateCCTarget(input.target, "contentControls.move");
	validateCCTarget(input.destination, "contentControls.move (destination)");
	return adapter.move(input, options);
}
function executeContentControlsPatch(adapter, input, options) {
	validateCCInput(input, "contentControls.patch");
	validateCCTarget(input.target, "contentControls.patch");
	if (input.appearance !== void 0 && input.appearance !== null && !VALID_CC_APPEARANCES.has(input.appearance)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patch appearance must be one of: ${[...VALID_CC_APPEARANCES].join(", ")}.`, {
		field: "appearance",
		value: input.appearance
	});
	if (input.showingPlaceholder !== void 0 && typeof input.showingPlaceholder !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patch showingPlaceholder must be a boolean, got ${typeof input.showingPlaceholder}.`, {
		field: "showingPlaceholder",
		value: input.showingPlaceholder
	});
	if (input.temporary !== void 0 && typeof input.temporary !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patch temporary must be a boolean, got ${typeof input.temporary}.`, {
		field: "temporary",
		value: input.temporary
	});
	if (input.tabIndex !== void 0 && input.tabIndex !== null && !isInteger(input.tabIndex)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patch tabIndex must be an integer or null, got ${typeof input.tabIndex}.`, {
		field: "tabIndex",
		value: input.tabIndex
	});
	return adapter.patch(input, options);
}
function executeContentControlsSetLockMode(adapter, input, options) {
	validateCCInput(input, "contentControls.setLockMode");
	validateCCTarget(input.target, "contentControls.setLockMode");
	if (!VALID_LOCK_MODES$1.has(input.lockMode)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.setLockMode lockMode must be one of: ${[...VALID_LOCK_MODES$1].join(", ")}.`, {
		field: "lockMode",
		value: input.lockMode
	});
	return adapter.setLockMode(input, options);
}
function executeContentControlsSetType(adapter, input, options) {
	validateCCInput(input, "contentControls.setType");
	validateCCTarget(input.target, "contentControls.setType");
	if (!VALID_CC_TYPES.has(input.controlType)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.setType controlType must be one of: ${[...VALID_CC_TYPES].join(", ")}.`, {
		field: "controlType",
		value: input.controlType
	});
	return adapter.setType(input, options);
}
function executeContentControlsGetContent(adapter, input) {
	validateCCInput(input, "contentControls.getContent");
	validateCCTarget(input.target, "contentControls.getContent");
	return adapter.getContent(input);
}
function executeContentControlsReplaceContent(adapter, input, options) {
	validateCCInput(input, "contentControls.replaceContent");
	validateCCTarget(input.target, "contentControls.replaceContent");
	validateContentPayload(input, "contentControls.replaceContent");
	return adapter.replaceContent(input, options);
}
function executeContentControlsClearContent(adapter, input, options) {
	validateCCInput(input, "contentControls.clearContent");
	validateCCTarget(input.target, "contentControls.clearContent");
	return adapter.clearContent(input, options);
}
function executeContentControlsAppendContent(adapter, input, options) {
	validateCCInput(input, "contentControls.appendContent");
	validateCCTarget(input.target, "contentControls.appendContent");
	validateContentPayload(input, "contentControls.appendContent");
	return adapter.appendContent(input, options);
}
function executeContentControlsPrependContent(adapter, input, options) {
	validateCCInput(input, "contentControls.prependContent");
	validateCCTarget(input.target, "contentControls.prependContent");
	validateContentPayload(input, "contentControls.prependContent");
	return adapter.prependContent(input, options);
}
function executeContentControlsInsertBefore(adapter, input, options) {
	validateCCInput(input, "contentControls.insertBefore");
	validateCCTarget(input.target, "contentControls.insertBefore");
	validateContentPayload(input, "contentControls.insertBefore");
	return adapter.insertBefore(input, options);
}
function executeContentControlsInsertAfter(adapter, input, options) {
	validateCCInput(input, "contentControls.insertAfter");
	validateCCTarget(input.target, "contentControls.insertAfter");
	validateContentPayload(input, "contentControls.insertAfter");
	return adapter.insertAfter(input, options);
}
function executeContentControlsGetBinding(adapter, input) {
	validateCCInput(input, "contentControls.getBinding");
	validateCCTarget(input.target, "contentControls.getBinding");
	return adapter.getBinding(input);
}
function executeContentControlsSetBinding(adapter, input, options) {
	validateCCInput(input, "contentControls.setBinding");
	validateCCTarget(input.target, "contentControls.setBinding");
	requireString(input.storeItemId, "storeItemId", "contentControls.setBinding");
	requireString(input.xpath, "xpath", "contentControls.setBinding");
	return adapter.setBinding(input, options);
}
function executeContentControlsClearBinding(adapter, input, options) {
	validateCCInput(input, "contentControls.clearBinding");
	validateCCTarget(input.target, "contentControls.clearBinding");
	return adapter.clearBinding(input, options);
}
function executeContentControlsGetRawProperties(adapter, input) {
	validateCCInput(input, "contentControls.getRawProperties");
	validateCCTarget(input.target, "contentControls.getRawProperties");
	return adapter.getRawProperties(input);
}
var VALID_RAW_PATCH_OPS = new Set([
	"set",
	"remove",
	"setAttr",
	"removeAttr"
]);
function executeContentControlsPatchRawProperties(adapter, input, options) {
	validateCCInput(input, "contentControls.patchRawProperties");
	validateCCTarget(input.target, "contentControls.patchRawProperties");
	if (!Array.isArray(input.patches)) throw new DocumentApiValidationError("INVALID_INPUT", "contentControls.patchRawProperties patches must be an array.", {
		field: "patches",
		value: input.patches
	});
	for (let i$1 = 0; i$1 < input.patches.length; i$1++) {
		const patch = input.patches[i$1];
		if (!isRecord(patch)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patchRawProperties patches[${i$1}] must be an object.`, {
			field: `patches[${i$1}]`,
			value: patch
		});
		if (!VALID_RAW_PATCH_OPS.has(patch.op)) throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patchRawProperties patches[${i$1}].op must be one of: ${[...VALID_RAW_PATCH_OPS].join(", ")}.`, {
			field: `patches[${i$1}].op`,
			value: patch.op
		});
		if (typeof patch.name !== "string" || patch.name === "") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.patchRawProperties patches[${i$1}].name must be a non-empty string.`, {
			field: `patches[${i$1}].name`,
			value: patch.name
		});
	}
	return adapter.patchRawProperties(input, options);
}
function executeContentControlsValidateWordCompatibility(adapter, input) {
	validateCCInput(input, "contentControls.validateWordCompatibility");
	validateCCTarget(input.target, "contentControls.validateWordCompatibility");
	return adapter.validateWordCompatibility(input);
}
function executeContentControlsNormalizeWordCompatibility(adapter, input, options) {
	validateCCInput(input, "contentControls.normalizeWordCompatibility");
	validateCCTarget(input.target, "contentControls.normalizeWordCompatibility");
	return adapter.normalizeWordCompatibility(input, options);
}
function executeContentControlsNormalizeTagPayload(adapter, input, options) {
	validateCCInput(input, "contentControls.normalizeTagPayload");
	validateCCTarget(input.target, "contentControls.normalizeTagPayload");
	return adapter.normalizeTagPayload(input, options);
}
function executeContentControlsTextSetMultiline(adapter, input, options) {
	validateCCInput(input, "contentControls.text.setMultiline");
	validateCCTarget(input.target, "contentControls.text.setMultiline");
	requireBoolean(input.multiline, "multiline", "contentControls.text.setMultiline");
	return adapter.text.setMultiline(input, options);
}
function executeContentControlsTextSetValue(adapter, input, options) {
	validateCCInput(input, "contentControls.text.setValue");
	validateCCTarget(input.target, "contentControls.text.setValue");
	if (typeof input.value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.text.setValue value must be a string.`, {
		field: "value",
		value: input.value
	});
	return adapter.text.setValue(input, options);
}
function executeContentControlsTextClearValue(adapter, input, options) {
	validateCCInput(input, "contentControls.text.clearValue");
	validateCCTarget(input.target, "contentControls.text.clearValue");
	return adapter.text.clearValue(input, options);
}
function executeContentControlsDateSetValue(adapter, input, options) {
	validateCCInput(input, "contentControls.date.setValue");
	validateCCTarget(input.target, "contentControls.date.setValue");
	if (typeof input.value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.date.setValue value must be a string.`, {
		field: "value",
		value: input.value
	});
	return adapter.date.setValue(input, options);
}
function executeContentControlsDateClearValue(adapter, input, options) {
	validateCCInput(input, "contentControls.date.clearValue");
	validateCCTarget(input.target, "contentControls.date.clearValue");
	return adapter.date.clearValue(input, options);
}
function executeContentControlsDateSetDisplayFormat(adapter, input, options) {
	validateCCInput(input, "contentControls.date.setDisplayFormat");
	validateCCTarget(input.target, "contentControls.date.setDisplayFormat");
	requireString(input.format, "format", "contentControls.date.setDisplayFormat");
	return adapter.date.setDisplayFormat(input, options);
}
function executeContentControlsDateSetDisplayLocale(adapter, input, options) {
	validateCCInput(input, "contentControls.date.setDisplayLocale");
	validateCCTarget(input.target, "contentControls.date.setDisplayLocale");
	requireString(input.locale, "locale", "contentControls.date.setDisplayLocale");
	return adapter.date.setDisplayLocale(input, options);
}
function executeContentControlsDateSetStorageFormat(adapter, input, options) {
	validateCCInput(input, "contentControls.date.setStorageFormat");
	validateCCTarget(input.target, "contentControls.date.setStorageFormat");
	requireString(input.format, "format", "contentControls.date.setStorageFormat");
	return adapter.date.setStorageFormat(input, options);
}
function executeContentControlsDateSetCalendar(adapter, input, options) {
	validateCCInput(input, "contentControls.date.setCalendar");
	validateCCTarget(input.target, "contentControls.date.setCalendar");
	requireString(input.calendar, "calendar", "contentControls.date.setCalendar");
	return adapter.date.setCalendar(input, options);
}
function executeContentControlsCheckboxGetState(adapter, input) {
	validateCCInput(input, "contentControls.checkbox.getState");
	validateCCTarget(input.target, "contentControls.checkbox.getState");
	return adapter.checkbox.getState(input);
}
function executeContentControlsCheckboxSetState(adapter, input, options) {
	validateCCInput(input, "contentControls.checkbox.setState");
	validateCCTarget(input.target, "contentControls.checkbox.setState");
	requireBoolean(input.checked, "checked", "contentControls.checkbox.setState");
	return adapter.checkbox.setState(input, options);
}
function executeContentControlsCheckboxToggle(adapter, input, options) {
	validateCCInput(input, "contentControls.checkbox.toggle");
	validateCCTarget(input.target, "contentControls.checkbox.toggle");
	return adapter.checkbox.toggle(input, options);
}
function executeContentControlsCheckboxSetSymbolPair(adapter, input, options) {
	validateCCInput(input, "contentControls.checkbox.setSymbolPair");
	validateCCTarget(input.target, "contentControls.checkbox.setSymbolPair");
	validateSymbol(input.checkedSymbol, "checkedSymbol", "contentControls.checkbox.setSymbolPair");
	validateSymbol(input.uncheckedSymbol, "uncheckedSymbol", "contentControls.checkbox.setSymbolPair");
	return adapter.checkbox.setSymbolPair(input, options);
}
function executeContentControlsChoiceListGetItems(adapter, input) {
	validateCCInput(input, "contentControls.choiceList.getItems");
	validateCCTarget(input.target, "contentControls.choiceList.getItems");
	return adapter.choiceList.getItems(input);
}
function executeContentControlsChoiceListSetItems(adapter, input, options) {
	validateCCInput(input, "contentControls.choiceList.setItems");
	validateCCTarget(input.target, "contentControls.choiceList.setItems");
	if (!Array.isArray(input.items)) throw new DocumentApiValidationError("INVALID_INPUT", "contentControls.choiceList.setItems items must be an array.", {
		field: "items",
		value: input.items
	});
	for (let i$1 = 0; i$1 < input.items.length; i$1++) {
		const item = input.items[i$1];
		if (!isRecord(item) || typeof item.displayText !== "string" || typeof item.value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `contentControls.choiceList.setItems items[${i$1}] must be { displayText: string, value: string }.`, {
			field: `items[${i$1}]`,
			value: item
		});
	}
	return adapter.choiceList.setItems(input, options);
}
function executeContentControlsChoiceListSetSelected(adapter, input, options) {
	validateCCInput(input, "contentControls.choiceList.setSelected");
	validateCCTarget(input.target, "contentControls.choiceList.setSelected");
	if (typeof input.value !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "contentControls.choiceList.setSelected value must be a string.", {
		field: "value",
		value: input.value
	});
	return adapter.choiceList.setSelected(input, options);
}
function executeContentControlsRepeatingSectionListItems(adapter, input) {
	validateCCInput(input, "contentControls.repeatingSection.listItems");
	validateCCTarget(input.target, "contentControls.repeatingSection.listItems");
	return adapter.repeatingSection.listItems(input);
}
function executeContentControlsRepeatingSectionInsertItemBefore(adapter, input, options) {
	validateCCInput(input, "contentControls.repeatingSection.insertItemBefore");
	validateCCTarget(input.target, "contentControls.repeatingSection.insertItemBefore");
	requireIndex(input.index, "index", "contentControls.repeatingSection.insertItemBefore");
	return adapter.repeatingSection.insertItemBefore(input, options);
}
function executeContentControlsRepeatingSectionInsertItemAfter(adapter, input, options) {
	validateCCInput(input, "contentControls.repeatingSection.insertItemAfter");
	validateCCTarget(input.target, "contentControls.repeatingSection.insertItemAfter");
	requireIndex(input.index, "index", "contentControls.repeatingSection.insertItemAfter");
	return adapter.repeatingSection.insertItemAfter(input, options);
}
function executeContentControlsRepeatingSectionCloneItem(adapter, input, options) {
	validateCCInput(input, "contentControls.repeatingSection.cloneItem");
	validateCCTarget(input.target, "contentControls.repeatingSection.cloneItem");
	requireIndex(input.index, "index", "contentControls.repeatingSection.cloneItem");
	return adapter.repeatingSection.cloneItem(input, options);
}
function executeContentControlsRepeatingSectionDeleteItem(adapter, input, options) {
	validateCCInput(input, "contentControls.repeatingSection.deleteItem");
	validateCCTarget(input.target, "contentControls.repeatingSection.deleteItem");
	requireIndex(input.index, "index", "contentControls.repeatingSection.deleteItem");
	return adapter.repeatingSection.deleteItem(input, options);
}
function executeContentControlsRepeatingSectionSetAllowInsertDelete(adapter, input, options) {
	validateCCInput(input, "contentControls.repeatingSection.setAllowInsertDelete");
	validateCCTarget(input.target, "contentControls.repeatingSection.setAllowInsertDelete");
	requireBoolean(input.allow, "allow", "contentControls.repeatingSection.setAllowInsertDelete");
	return adapter.repeatingSection.setAllowInsertDelete(input, options);
}
function executeContentControlsGroupWrap(adapter, input, options) {
	validateCCInput(input, "contentControls.group.wrap");
	validateCCTarget(input.target, "contentControls.group.wrap");
	return adapter.group.wrap(input, options);
}
function executeContentControlsGroupUngroup(adapter, input, options) {
	validateCCInput(input, "contentControls.group.ungroup");
	validateCCTarget(input.target, "contentControls.group.ungroup");
	return adapter.group.ungroup(input, options);
}
function executeCreateContentControl(adapter, input, options) {
	validateCCInput(input, "create.contentControl");
	requireNodeKind(input.kind, "kind", "create.contentControl");
	if (input.controlType !== void 0 && !VALID_CC_TYPES.has(input.controlType)) throw new DocumentApiValidationError("INVALID_INPUT", `create.contentControl controlType must be one of: ${[...VALID_CC_TYPES].join(", ")}.`, {
		field: "controlType",
		value: input.controlType
	});
	if (input.lockMode !== void 0 && !VALID_LOCK_MODES$1.has(input.lockMode)) throw new DocumentApiValidationError("INVALID_INPUT", `create.contentControl lockMode must be one of: ${[...VALID_LOCK_MODES$1].join(", ")}.`, {
		field: "lockMode",
		value: input.lockMode
	});
	if (input.at !== void 0 && input.target !== void 0) throw new DocumentApiValidationError("INVALID_INPUT", `create.contentControl: "at" and "target" are mutually exclusive: provide one or neither.`, { field: "at" });
	if (input.target !== void 0) validateCCTarget(input.target, "create.contentControl");
	if (input.at !== void 0 && !isSelectionTarget(input.at)) throw new DocumentApiValidationError("INVALID_INPUT", `create.contentControl: "at" must be a valid SelectionTarget with kind "selection", start, and end.`, {
		field: "at",
		value: input.at
	});
	if (input.content !== void 0 && typeof input.content !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `create.contentControl content must be a string, got ${typeof input.content}.`, {
		field: "content",
		value: input.content
	});
	return adapter.create(input, options);
}
function validateBookmarkTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "entity" || t.entityType !== "bookmark" || typeof t.name !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a BookmarkAddress with kind 'entity', entityType 'bookmark', and a string name.`, { target });
	if (t.story !== void 0) validateStoryLocator(t.story, `${operationName}.target.story`);
}
function executeBookmarksList(adapter, query) {
	if (query?.in !== void 0) validateStoryLocator(query.in, "bookmarks.list.in");
	return adapter.list(query);
}
function executeBookmarksGet(adapter, input) {
	validateBookmarkTarget(input.target, "bookmarks.get");
	return adapter.get(input);
}
function executeBookmarksInsert(adapter, input, options) {
	if (!input.name || typeof input.name !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "bookmarks.insert requires a non-empty name string.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeBookmarksRename(adapter, input, options) {
	validateBookmarkTarget(input.target, "bookmarks.rename");
	if (!input.newName || typeof input.newName !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "bookmarks.rename requires a non-empty newName string.");
	return adapter.rename(input, normalizeMutationOptions(options));
}
function executeBookmarksRemove(adapter, input, options) {
	validateBookmarkTarget(input.target, "bookmarks.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function validateTarget(target, operationName) {
	if (!target || typeof target !== "object") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a target with either { id } or { partName }.`, { target });
	const t = target;
	const hasId = typeof t.id === "string" && t.id.length > 0;
	const hasPartName = typeof t.partName === "string" && t.partName.length > 0;
	if (!hasId && !hasPartName) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must have a non-empty 'id' or 'partName'.`, { target });
	if (hasId && hasPartName) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must not provide both 'id' and 'partName'; choose one.`, { target });
}
function validateContent(content$2, operationName) {
	if (typeof content$2 !== "string" || content$2.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a non-empty 'content' string of well-formed XML.`, { contentType: typeof content$2 });
	if (!/<\s*[A-Za-z_]/.test(content$2)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'content' does not contain a root XML element.`);
}
function validateSchemaRefs(schemaRefs, operationName) {
	if (!Array.isArray(schemaRefs)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'schemaRefs' must be an array of strings.`);
	for (const [i$1, entry] of schemaRefs.entries()) if (typeof entry !== "string" || entry.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'schemaRefs[${i$1}]' must be a non-empty string.`);
}
function executeCustomXmlPartsList(adapter, query) {
	if (query?.rootNamespace !== void 0 && typeof query.rootNamespace !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `customXml.parts.list 'rootNamespace' must be a string when provided.`);
	if (query?.schemaRef !== void 0 && typeof query.schemaRef !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `customXml.parts.list 'schemaRef' must be a string when provided.`);
	return adapter.list(query);
}
function executeCustomXmlPartsGet(adapter, input) {
	validateTarget(input.target, "customXml.parts.get");
	return adapter.get(input);
}
function executeCustomXmlPartsCreate(adapter, input, options) {
	validateContent(input.content, "customXml.parts.create");
	if (input.schemaRefs !== void 0) validateSchemaRefs(input.schemaRefs, "customXml.parts.create");
	return adapter.create(input, normalizeMutationOptions(options));
}
function executeCustomXmlPartsPatch(adapter, input, options) {
	validateTarget(input.target, "customXml.parts.patch");
	if (input.content === void 0 && input.schemaRefs === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `customXml.parts.patch requires at least one of 'content' or 'schemaRefs'.`);
	if (input.content !== void 0) validateContent(input.content, "customXml.parts.patch");
	if (input.schemaRefs !== void 0) validateSchemaRefs(input.schemaRefs, "customXml.parts.patch");
	return adapter.patch(input, normalizeMutationOptions(options));
}
function executeCustomXmlPartsRemove(adapter, input, options) {
	validateTarget(input.target, "customXml.parts.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function validateId(id, operationName) {
	if (typeof id !== "string" || id.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a non-empty 'id' string.`, { idType: typeof id });
}
function validateNamespace(namespace, operationName) {
	if (typeof namespace !== "string" || namespace.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a non-empty 'namespace' string.`, { namespaceType: typeof namespace });
}
function validatePayload(payload, operationName) {
	let serialized;
	try {
		serialized = JSON.stringify(payload);
	} catch (err$1) {
		throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'payload' must be JSON-serializable (no cycles, no BigInt).`, { error: err$1 instanceof Error ? err$1.message : String(err$1) });
	}
	if (serialized === void 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'payload' must be a JSON-serializable value (was undefined / function / symbol).`);
}
function validateAnchorTarget(target, operationName) {
	if (!isSelectionTarget(target)) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a 'target' SelectionTarget describing the anchor range.`, { target });
	if (target.start.kind !== "text" || target.end.kind !== "text") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires a text-range target. v1 does not support nodeEdge anchors.`, {
		startKind: target.start.kind,
		endKind: target.end.kind
	});
	if (target.start.blockId !== target.end.blockId) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must stay within a single paragraph. v1 anchors are hidden inline SDTs and cannot span block boundaries.`, {
		startBlockId: target.start.blockId,
		endBlockId: target.end.blockId
	});
}
function validateWithin(within, operationName) {
	if (!isSelectionTarget(within)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'within' must be a SelectionTarget when provided.`, { within });
	if (within.start.kind !== "text" || within.end.kind !== "text") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'within' must be a text-range target (no nodeEdge endpoints).`, {
		startKind: within.start.kind,
		endKind: within.end.kind
	});
	if (within.start.blockId !== within.end.blockId) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} 'within' must stay within a single paragraph in v1.`, {
		startBlockId: within.start.blockId,
		endBlockId: within.end.blockId
	});
}
function executeAnchoredMetadataAttach(adapter, input, options) {
	validateAnchorTarget(input.target, "metadata.attach");
	validateNamespace(input.namespace, "metadata.attach");
	validatePayload(input.payload, "metadata.attach");
	if (input.id !== void 0) validateId(input.id, "metadata.attach");
	return adapter.attach(input, normalizeMutationOptions(options));
}
function executeAnchoredMetadataList(adapter, query) {
	if (query?.namespace !== void 0 && typeof query.namespace !== "string") throw new DocumentApiValidationError("INVALID_INPUT", `metadata.list 'namespace' must be a string when provided.`);
	if (query?.within !== void 0) validateWithin(query.within, "metadata.list");
	if (query?.resolvedOnly !== void 0 && typeof query.resolvedOnly !== "boolean") throw new DocumentApiValidationError("INVALID_INPUT", `metadata.list 'resolvedOnly' must be a boolean when provided.`);
	return adapter.list(query);
}
function executeAnchoredMetadataGet(adapter, input) {
	validateId(input.id, "metadata.get");
	return adapter.get(input);
}
function executeAnchoredMetadataUpdate(adapter, input, options) {
	validateId(input.id, "metadata.update");
	validatePayload(input.payload, "metadata.update");
	return adapter.update(input, normalizeMutationOptions(options));
}
function executeAnchoredMetadataRemove(adapter, input, options) {
	validateId(input.id, "metadata.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeAnchoredMetadataResolve(adapter, input) {
	validateId(input.id, "metadata.resolve");
	return adapter.resolve(input);
}
var VALID_SET_MODES = new Set(["readOnly"]);
function validateSetEditingRestrictionInput(input) {
	if (!input || typeof input !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "protection.setEditingRestriction requires an object with a mode property.");
	const { mode } = input;
	if (!VALID_SET_MODES.has(mode)) throw new DocumentApiValidationError("INVALID_INPUT", `protection.setEditingRestriction mode must be 'readOnly'. Received: '${String(mode)}'.`);
}
function executeProtectionGet(adapter, _input) {
	return adapter.get();
}
function executeSetEditingRestriction(adapter, input, options) {
	validateSetEditingRestrictionInput(input);
	return adapter.setEditingRestriction(input, normalizeMutationOptions(options));
}
function executeClearEditingRestriction(adapter, _input, options) {
	return adapter.clearEditingRestriction(void 0, normalizeMutationOptions(options));
}
function validatePrincipal(principal, operationName) {
	if (!principal || typeof principal !== "object") throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a principal object with a 'kind' property.`);
	const p = principal;
	if (p.kind === "everyone") return;
	if (p.kind === "editor") {
		if (typeof p.id !== "string" || p.id.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} editor principal requires a non-empty id string.`);
		return;
	}
	throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} principal kind must be 'everyone' or 'editor'. Received: '${String(p.kind)}'.`);
}
function requireNonEmptyId(id, operationName) {
	if (typeof id !== "string" || id.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires a non-empty id string.`);
}
function executePermissionRangesList(adapter, input) {
	return adapter.list(input);
}
function executePermissionRangesGet(adapter, input) {
	requireNonEmptyId(input?.id, "permissionRanges.get");
	return adapter.get(input);
}
function executePermissionRangesCreate(adapter, input, options) {
	if (!input || typeof input !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "permissionRanges.create requires an input object.");
	const { target, principal } = input;
	if (!target || typeof target !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "permissionRanges.create target must be a SelectionTarget object.");
	if (target.kind !== "selection" || !target.start || !target.end) throw new DocumentApiValidationError("INVALID_INPUT", "permissionRanges.create target must have kind 'selection' with start and end points.");
	validatePrincipal(principal, "permissionRanges.create");
	if (input.id !== void 0) requireNonEmptyId(input.id, "permissionRanges.create");
	return adapter.create(input, normalizeMutationOptions(options));
}
function executePermissionRangesRemove(adapter, input, options) {
	requireNonEmptyId(input?.id, "permissionRanges.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executePermissionRangesUpdatePrincipal(adapter, input, options) {
	requireNonEmptyId(input?.id, "permissionRanges.updatePrincipal");
	validatePrincipal(input?.principal, "permissionRanges.updatePrincipal");
	return adapter.updatePrincipal(input, normalizeMutationOptions(options));
}
function validateFootnoteTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "entity" || t.entityType !== "footnote" || typeof t.noteId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a FootnoteAddress with kind 'entity', entityType 'footnote', and a string noteId.`, { target });
}
function executeFootnotesList(adapter, query) {
	return adapter.list(query);
}
function executeFootnotesGet(adapter, input) {
	validateFootnoteTarget(input.target, "footnotes.get");
	return adapter.get(input);
}
function executeFootnotesInsert(adapter, input, options) {
	if (!input.type || input.type !== "footnote" && input.type !== "endnote") throw new DocumentApiValidationError("INVALID_INPUT", "footnotes.insert requires a type of 'footnote' or 'endnote'.");
	if (typeof input.content !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "footnotes.insert requires a content string.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeFootnotesUpdate(adapter, input, options) {
	validateFootnoteTarget(input.target, "footnotes.update");
	return adapter.update(input, normalizeMutationOptions(options));
}
function executeFootnotesRemove(adapter, input, options) {
	validateFootnoteTarget(input.target, "footnotes.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeFootnotesConfigure(adapter, input, options) {
	if (!input.type || input.type !== "footnote" && input.type !== "endnote") throw new DocumentApiValidationError("INVALID_INPUT", "footnotes.configure requires a type of 'footnote' or 'endnote'.");
	return adapter.configure(input, normalizeMutationOptions(options));
}
function validateCrossRefTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "inline" || t.nodeType !== "crossRef") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a CrossRefAddress with kind 'inline' and nodeType 'crossRef'.`, { target });
}
function executeCrossRefsList(adapter, query) {
	return adapter.list(query);
}
function executeCrossRefsGet(adapter, input) {
	validateCrossRefTarget(input.target, "crossRefs.get");
	return adapter.get(input);
}
function executeCrossRefsInsert(adapter, input, options) {
	if (!input.target || typeof input.target.kind !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "crossRefs.insert requires a valid target.");
	if (!input.display) throw new DocumentApiValidationError("INVALID_INPUT", "crossRefs.insert requires a display value.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeCrossRefsRebuild(adapter, input, options) {
	validateCrossRefTarget(input.target, "crossRefs.rebuild");
	return adapter.rebuild(input, normalizeMutationOptions(options));
}
function executeCrossRefsRemove(adapter, input, options) {
	validateCrossRefTarget(input.target, "crossRefs.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
var VALID_CREATE_LOCATION_KINDS = new Set([
	"documentStart",
	"documentEnd",
	"before",
	"after"
]);
function validateTargetOnlyTocCreateLocation(at, operationName) {
	if (!at || typeof at !== "object" || !("kind" in at)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} requires an 'at' create-location with a valid 'kind' property.`, {
		field: "at",
		value: at
	});
	if (!VALID_CREATE_LOCATION_KINDS.has(at.kind)) throw new DocumentApiValidationError("INVALID_INPUT", `${operationName} received an unsupported at.kind "${at.kind}". Valid values are: ${[...VALID_CREATE_LOCATION_KINDS].join(", ")}.`, {
		field: "at.kind",
		value: at.kind
	});
	if (at.kind !== "before" && at.kind !== "after") return;
	const loc = at;
	if (loc.nodeId !== void 0) throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} requires at.target for before/after positioning. The nodeId form is not supported.`, { field: "at.nodeId" });
	const target = loc.target;
	if (!target || target.kind !== "block" || typeof target.nodeType !== "string" || typeof target.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} with at.kind="${at.kind}" requires at.target to be a BlockNodeAddress.`, {
		field: "at.target",
		value: loc.target
	});
}
function validateIndexTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "block" || t.nodeType !== "index" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be an IndexAddress with kind 'block', nodeType 'index', and a string nodeId.`, { target });
}
function validateIndexEntryTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "inline" || t.nodeType !== "indexEntry") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be an IndexEntryAddress with kind 'inline', nodeType 'indexEntry', and an anchor with start/end.`, { target });
	const anchor = t.anchor;
	if (!anchor || typeof anchor.start !== "object" || typeof anchor.end !== "object") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target.anchor must have start and end positions.`, { target });
}
function executeIndexList(adapter, input) {
	return adapter.list(input);
}
function executeIndexGet(adapter, input) {
	validateIndexTarget(input.target, "index.get");
	return adapter.get(input);
}
function executeIndexInsert(adapter, input, options) {
	validateTargetOnlyTocCreateLocation(input.at, "index.insert");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeIndexConfigure(adapter, input, options) {
	validateIndexTarget(input.target, "index.configure");
	return adapter.configure(input, normalizeMutationOptions(options));
}
function executeIndexRebuild(adapter, input, options) {
	validateIndexTarget(input.target, "index.rebuild");
	return adapter.rebuild(input, normalizeMutationOptions(options));
}
function executeIndexRemove(adapter, input, options) {
	validateIndexTarget(input.target, "index.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeIndexEntryList(adapter, input) {
	return adapter.entries.list(input);
}
function executeIndexEntryGet(adapter, input) {
	validateIndexEntryTarget(input.target, "index.entries.get");
	return adapter.entries.get(input);
}
function executeIndexEntryInsert(adapter, input, options) {
	if (!input.entry || typeof input.entry.text !== "string" || !input.entry.text) throw new DocumentApiValidationError("INVALID_INPUT", "index.entries.insert requires a non-empty entry.text string.");
	return adapter.entries.insert(input, normalizeMutationOptions(options));
}
function executeIndexEntryUpdate(adapter, input, options) {
	validateIndexEntryTarget(input.target, "index.entries.update");
	return adapter.entries.update(input, normalizeMutationOptions(options));
}
function executeIndexEntryRemove(adapter, input, options) {
	validateIndexEntryTarget(input.target, "index.entries.remove");
	return adapter.entries.remove(input, normalizeMutationOptions(options));
}
function validateCaptionTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "block" || t.nodeType !== "paragraph" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a CaptionAddress with kind 'block', nodeType 'paragraph', and a string nodeId.`, { target });
}
function executeCaptionsList(adapter, input) {
	return adapter.list(input);
}
function executeCaptionsGet(adapter, input) {
	validateCaptionTarget(input.target, "captions.get");
	return adapter.get(input);
}
function executeCaptionsInsert(adapter, input, options) {
	if (!input.label || typeof input.label !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "captions.insert requires a non-empty label string.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeCaptionsUpdate(adapter, input, options) {
	validateCaptionTarget(input.target, "captions.update");
	return adapter.update(input, normalizeMutationOptions(options));
}
function executeCaptionsRemove(adapter, input, options) {
	validateCaptionTarget(input.target, "captions.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeCaptionsConfigure(adapter, input, options) {
	if (!input.label || typeof input.label !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "captions.configure requires a non-empty label string.");
	return adapter.configure(input, normalizeMutationOptions(options));
}
function validateFieldTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "field" || typeof t.blockId !== "string" || typeof t.occurrenceIndex !== "number") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a FieldAddress with kind 'field', string blockId, and numeric occurrenceIndex.`, { target });
}
function executeFieldsList(adapter, query) {
	return adapter.list(query);
}
function executeFieldsGet(adapter, input) {
	validateFieldTarget(input.target, "fields.get");
	return adapter.get(input);
}
function executeFieldsInsert(adapter, input, options) {
	if (input.mode !== "raw") throw new DocumentApiValidationError("INVALID_INPUT", "fields.insert requires mode: 'raw'. Raw field manipulation can break document validity.");
	if (!input.instruction || typeof input.instruction !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "fields.insert requires a non-empty instruction string.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeFieldsRebuild(adapter, input, options) {
	validateFieldTarget(input.target, "fields.rebuild");
	return adapter.rebuild(input, normalizeMutationOptions(options));
}
function executeFieldsRemove(adapter, input, options) {
	if (input.mode !== "raw") throw new DocumentApiValidationError("INVALID_INPUT", "fields.remove requires mode: 'raw'. Raw field manipulation can break document validity.");
	validateFieldTarget(input.target, "fields.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function validateCitationTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "inline" || t.nodeType !== "citation") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a CitationAddress with kind 'inline' and nodeType 'citation'.`, { target });
}
function validateCitationSourceTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "entity" || t.entityType !== "citationSource" || typeof t.sourceId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a CitationSourceAddress with kind 'entity', entityType 'citationSource', and a string sourceId.`, { target });
}
function validateBibliographyTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "block" || t.nodeType !== "bibliography" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be a BibliographyAddress with kind 'block', nodeType 'bibliography', and a string nodeId.`, { target });
}
function executeCitationsList(adapter, query) {
	return adapter.list(query);
}
function executeCitationsGet(adapter, input) {
	validateCitationTarget(input.target, "citations.get");
	return adapter.get(input);
}
function executeCitationsInsert(adapter, input, options) {
	if (!Array.isArray(input.sourceIds) || input.sourceIds.length === 0) throw new DocumentApiValidationError("INVALID_INPUT", "citations.insert requires a non-empty sourceIds array.");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeCitationsUpdate(adapter, input, options) {
	validateCitationTarget(input.target, "citations.update");
	return adapter.update(input, normalizeMutationOptions(options));
}
function executeCitationsRemove(adapter, input, options) {
	validateCitationTarget(input.target, "citations.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeCitationSourcesList(adapter, query) {
	return adapter.sources.list(query);
}
function executeCitationSourcesGet(adapter, input) {
	validateCitationSourceTarget(input.target, "citations.sources.get");
	return adapter.sources.get(input);
}
function executeCitationSourcesInsert(adapter, input, options) {
	if (!input.type) throw new DocumentApiValidationError("INVALID_INPUT", "citations.sources.insert requires a type.");
	return adapter.sources.insert(input, normalizeMutationOptions(options));
}
function executeCitationSourcesUpdate(adapter, input, options) {
	validateCitationSourceTarget(input.target, "citations.sources.update");
	return adapter.sources.update(input, normalizeMutationOptions(options));
}
function executeCitationSourcesRemove(adapter, input, options) {
	validateCitationSourceTarget(input.target, "citations.sources.remove");
	return adapter.sources.remove(input, normalizeMutationOptions(options));
}
function executeBibliographyGet(adapter, input) {
	validateBibliographyTarget(input.target, "citations.bibliography.get");
	return adapter.bibliography.get(input);
}
function executeBibliographyInsert(adapter, input, options) {
	validateTargetOnlyTocCreateLocation(input.at, "citations.bibliography.insert");
	if (input.style !== void 0 && typeof input.style !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "citations.bibliography.insert style must be a string when provided.");
	return adapter.bibliography.insert(input, normalizeMutationOptions(options));
}
function executeBibliographyRebuild(adapter, input, options) {
	validateBibliographyTarget(input.target, "citations.bibliography.rebuild");
	return adapter.bibliography.rebuild(input, normalizeMutationOptions(options));
}
function executeBibliographyConfigure(adapter, input, options) {
	validateBibliographyTarget(input.target, "citations.bibliography.configure");
	if (!input.style || typeof input.style !== "string") throw new DocumentApiValidationError("INVALID_INPUT", "citations.bibliography.configure requires a non-empty style string.");
	return adapter.bibliography.configure(input, normalizeMutationOptions(options));
}
function executeBibliographyRemove(adapter, input, options) {
	validateBibliographyTarget(input.target, "citations.bibliography.remove");
	return adapter.bibliography.remove(input, normalizeMutationOptions(options));
}
function validateAuthoritiesTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "block" || t.nodeType !== "tableOfAuthorities" || typeof t.nodeId !== "string") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be an AuthoritiesAddress with kind 'block', nodeType 'tableOfAuthorities', and a string nodeId.`, { target });
}
function validateAuthorityEntryTarget(target, operationName) {
	assertTargetPresent(target, operationName);
	const t = target;
	if (t.kind !== "inline" || t.nodeType !== "authorityEntry") throw new DocumentApiValidationError("INVALID_TARGET", `${operationName} target must be an AuthorityEntryAddress with kind 'inline' and nodeType 'authorityEntry'.`, { target });
}
function executeAuthoritiesList(adapter, query) {
	return adapter.list(query);
}
function executeAuthoritiesGet(adapter, input) {
	validateAuthoritiesTarget(input.target, "authorities.get");
	return adapter.get(input);
}
function executeAuthoritiesInsert(adapter, input, options) {
	validateTargetOnlyTocCreateLocation(input.at, "authorities.insert");
	return adapter.insert(input, normalizeMutationOptions(options));
}
function executeAuthoritiesConfigure(adapter, input, options) {
	validateAuthoritiesTarget(input.target, "authorities.configure");
	return adapter.configure(input, normalizeMutationOptions(options));
}
function executeAuthoritiesRebuild(adapter, input, options) {
	validateAuthoritiesTarget(input.target, "authorities.rebuild");
	return adapter.rebuild(input, normalizeMutationOptions(options));
}
function executeAuthoritiesRemove(adapter, input, options) {
	validateAuthoritiesTarget(input.target, "authorities.remove");
	return adapter.remove(input, normalizeMutationOptions(options));
}
function executeAuthorityEntriesList(adapter, query) {
	return adapter.entries.list(query);
}
function executeAuthorityEntriesGet(adapter, input) {
	validateAuthorityEntryTarget(input.target, "authorities.entries.get");
	return adapter.entries.get(input);
}
function executeAuthorityEntriesInsert(adapter, input, options) {
	if (!input.entry || !input.entry.longCitation) throw new DocumentApiValidationError("INVALID_INPUT", "authorities.entries.insert requires an entry with a non-empty longCitation.");
	return adapter.entries.insert(input, normalizeMutationOptions(options));
}
function executeAuthorityEntriesUpdate(adapter, input, options) {
	validateAuthorityEntryTarget(input.target, "authorities.entries.update");
	return adapter.entries.update(input, normalizeMutationOptions(options));
}
function executeAuthorityEntriesRemove(adapter, input, options) {
	validateAuthorityEntryTarget(input.target, "authorities.entries.remove");
	return adapter.entries.remove(input, normalizeMutationOptions(options));
}
const DEFAULT_PROTECTION_STATE = {
	editingRestriction: {
		mode: "none",
		enforced: false,
		runtimeEnforced: false,
		passwordProtected: false,
		formattingRestricted: false
	},
	writeProtection: {
		enabled: false,
		passwordProtected: false
	},
	readOnlyRecommended: false
};
function executeQueryMatch(adapter, input) {
	if (!input || typeof input !== "object") throw new DocumentApiValidationError("INVALID_INPUT", "query.match requires a QueryMatchInput or selector object.", { value: input });
	const rawInput = input;
	const isFlatNodeShorthand = rawInput.type === "node" || rawInput.type === void 0 && (rawInput.nodeType !== void 0 || rawInput.kind !== void 0);
	const normalized = "select" in input ? input : rawInput.type === "text" ? {
		select: {
			type: "text",
			pattern: rawInput.pattern,
			...rawInput.mode !== void 0 ? { mode: rawInput.mode } : {},
			...rawInput.caseSensitive !== void 0 ? { caseSensitive: rawInput.caseSensitive } : {}
		},
		...rawInput.within !== void 0 ? { within: rawInput.within } : {},
		...rawInput.in !== void 0 ? { in: rawInput.in } : {},
		...rawInput.require !== void 0 ? { require: rawInput.require } : {},
		...rawInput.includeNodes !== void 0 ? { includeNodes: rawInput.includeNodes } : {},
		...rawInput.limit !== void 0 ? { limit: rawInput.limit } : {},
		...rawInput.offset !== void 0 ? { offset: rawInput.offset } : {}
	} : isFlatNodeShorthand ? {
		select: {
			type: "node",
			...rawInput.nodeType !== void 0 ? { nodeType: rawInput.nodeType } : {},
			...rawInput.kind !== void 0 ? { kind: rawInput.kind } : {}
		},
		...rawInput.within !== void 0 ? { within: rawInput.within } : {},
		...rawInput.in !== void 0 ? { in: rawInput.in } : {},
		...rawInput.require !== void 0 ? { require: rawInput.require } : {},
		...rawInput.mode !== void 0 ? { mode: rawInput.mode } : {},
		...rawInput.includeNodes !== void 0 ? { includeNodes: rawInput.includeNodes } : {},
		...rawInput.limit !== void 0 ? { limit: rawInput.limit } : {},
		...rawInput.offset !== void 0 ? { offset: rawInput.offset } : {}
	} : { select: input };
	validateStoryLocator(normalized.in, "in");
	return adapter.match(normalized);
}
function requireAdapter(adapter, namespace) {
	if (!adapter) throw new DocumentApiValidationError("CAPABILITY_UNAVAILABLE", `The '${namespace}' namespace is not available. The host engine has not provided an adapter for this capability.`);
	return adapter;
}
function buildFormatInlineAliasApi(adapter) {
	return Object.fromEntries(INLINE_PROPERTY_REGISTRY.map((entry) => {
		const key = entry.key;
		const handler$1 = (input, options) => executeInlineAlias(adapter, key, input, options);
		return [key, handler$1];
	}));
}
var ADAPTER_GATED_PREFIXES = [
	"bookmarks",
	"footnotes",
	"crossRefs",
	"index",
	"captions",
	"fields",
	"citations",
	"authorities"
];
function createDocumentApi(adapters) {
	const rawCapFn = () => executeCapabilities(adapters.capabilities);
	const capFn = () => {
		const caps = rawCapFn();
		for (const ns of ADAPTER_GATED_PREFIXES) {
			if (adapters[ns]) continue;
			const prefix = `${ns}.`;
			for (const opId of Object.keys(caps.operations)) {
				if (!opId.startsWith(prefix)) continue;
				const cap = caps.operations[opId];
				cap.available = false;
				cap.reasons = [...cap.reasons ?? [], "NAMESPACE_UNAVAILABLE"];
			}
		}
		return caps;
	};
	const capabilities = Object.assign(capFn, { get: capFn });
	const api = {
		get(input) {
			return executeGet(adapters.get, input);
		},
		find(input) {
			return executeFind(adapters.find, input);
		},
		getNode(address) {
			return executeGetNode(adapters.getNode, address);
		},
		getNodeById(input) {
			return executeGetNodeById(adapters.getNode, input);
		},
		getText(input) {
			return executeGetText(adapters.getText, input);
		},
		getMarkdown(input) {
			return executeGetMarkdown(adapters.getMarkdown, input);
		},
		getHtml(input) {
			return executeGetHtml(adapters.getHtml, input);
		},
		markdownToFragment(input) {
			return executeMarkdownToFragment(adapters.markdownToFragment, input);
		},
		info(input) {
			return executeInfo(adapters.info, input);
		},
		extract(input) {
			return executeExtract(adapters.extract, input);
		},
		clearContent(input, options) {
			return executeClearContent(adapters.clearContent, input, options);
		},
		comments: {
			create(input, options) {
				return executeCommentsCreate(adapters.comments, input, options);
			},
			patch(input, options) {
				return executeCommentsPatch(adapters.comments, input, options);
			},
			delete(input, options) {
				return executeCommentsDelete(adapters.comments, input, options);
			},
			get(input) {
				return executeGetComment(adapters.comments, input);
			},
			list(query) {
				return executeListComments(adapters.comments, query);
			}
		},
		insert(input, options) {
			return executeInsert(adapters.selectionMutation, adapters.write, input, options);
		},
		replace(input, options) {
			return executeReplace(adapters.selectionMutation, adapters.write, input, options);
		},
		delete(input, options) {
			return executeDelete$1(adapters.selectionMutation, input, options);
		},
		formatRange(input, options) {
			const raw = input;
			if (!raw || typeof raw !== "object") return executeStyleApply(adapters.selectionMutation, raw, options);
			const { properties, changeMode, dryRun, expectedRevision, ...rest } = raw;
			const styleInput = typeof rest.ref === "string" ? {
				ref: rest.ref,
				inline: properties,
				...rest.in ? { in: rest.in } : {}
			} : {
				target: rest.target,
				inline: properties,
				...rest.in ? { in: rest.in } : {}
			};
			return executeStyleApply(adapters.selectionMutation, styleInput, {
				expectedRevision: expectedRevision ?? options?.expectedRevision,
				changeMode: changeMode ?? options?.changeMode,
				dryRun: dryRun ?? options?.dryRun
			});
		},
		format: {
			...buildFormatInlineAliasApi(adapters.selectionMutation),
			strikethrough(input, options) {
				return executeInlineAlias(adapters.selectionMutation, "strike", {
					...input,
					value: true
				}, options);
			},
			apply(input, options) {
				return executeStyleApply(adapters.selectionMutation, input, options);
			},
			paragraph: {
				resetDirectFormatting(input, options) {
					return executeParagraphsResetDirectFormatting(adapters.paragraphs, input, options);
				},
				setAlignment(input, options) {
					return executeParagraphsSetAlignment(adapters.paragraphs, input, options);
				},
				clearAlignment(input, options) {
					return executeParagraphsClearAlignment(adapters.paragraphs, input, options);
				},
				setIndentation(input, options) {
					return executeParagraphsSetIndentation(adapters.paragraphs, input, options);
				},
				clearIndentation(input, options) {
					return executeParagraphsClearIndentation(adapters.paragraphs, input, options);
				},
				setSpacing(input, options) {
					return executeParagraphsSetSpacing(adapters.paragraphs, input, options);
				},
				clearSpacing(input, options) {
					return executeParagraphsClearSpacing(adapters.paragraphs, input, options);
				},
				setKeepOptions(input, options) {
					return executeParagraphsSetKeepOptions(adapters.paragraphs, input, options);
				},
				setOutlineLevel(input, options) {
					return executeParagraphsSetOutlineLevel(adapters.paragraphs, input, options);
				},
				setFlowOptions(input, options) {
					return executeParagraphsSetFlowOptions(adapters.paragraphs, input, options);
				},
				setTabStop(input, options) {
					return executeParagraphsSetTabStop(adapters.paragraphs, input, options);
				},
				clearTabStop(input, options) {
					return executeParagraphsClearTabStop(adapters.paragraphs, input, options);
				},
				clearAllTabStops(input, options) {
					return executeParagraphsClearAllTabStops(adapters.paragraphs, input, options);
				},
				setBorder(input, options) {
					return executeParagraphsSetBorder(adapters.paragraphs, input, options);
				},
				clearBorder(input, options) {
					return executeParagraphsClearBorder(adapters.paragraphs, input, options);
				},
				setShading(input, options) {
					return executeParagraphsSetShading(adapters.paragraphs, input, options);
				},
				clearShading(input, options) {
					return executeParagraphsClearShading(adapters.paragraphs, input, options);
				},
				setDirection(input, options) {
					return executeParagraphsSetDirection(adapters.paragraphs, input, options);
				},
				clearDirection(input, options) {
					return executeParagraphsClearDirection(adapters.paragraphs, input, options);
				}
			}
		},
		styles: {
			apply(input, options) {
				return executeStylesApply(adapters.styles, input, options);
			},
			paragraph: {
				setStyle(input, options) {
					return executeParagraphsSetStyle(adapters.paragraphs, input, options);
				},
				clearStyle(input, options) {
					return executeParagraphsClearStyle(adapters.paragraphs, input, options);
				}
			}
		},
		templates: { apply(input, options) {
			return executeTemplatesApply(adapters.templates, input, options);
		} },
		trackChanges: {
			list(input) {
				return executeTrackChangesList(adapters.trackChanges, input);
			},
			get(input) {
				return executeTrackChangesGet(adapters.trackChanges, input);
			},
			decide(input, options) {
				return executeTrackChangesDecide(adapters.trackChanges, input, options);
			}
		},
		blocks: {
			list(input) {
				return executeBlocksList(adapters.blocks, input);
			},
			delete(input, options) {
				return executeBlocksDelete(adapters.blocks, input, options);
			},
			deleteRange(input, options) {
				return executeBlocksDeleteRange(adapters.blocks, input, options);
			}
		},
		create: {
			paragraph(input, options) {
				return executeCreateParagraph(adapters.create, input, options);
			},
			heading(input, options) {
				return executeCreateHeading(adapters.create, input, options);
			},
			table(input, options) {
				return executeCreateTable(adapters.create, input, options);
			},
			sectionBreak(input, options) {
				return executeCreateSectionBreak(adapters.create, input, options);
			},
			tableOfContents(input, options) {
				return executeCreateTableOfContents(adapters.create, input, options);
			},
			image(input, options) {
				return executeCreateImage(adapters.images, input, options);
			},
			contentControl(input, options) {
				return executeCreateContentControl(adapters.contentControls, input, options);
			}
		},
		capabilities,
		images: {
			list(input) {
				return executeImagesList(adapters.images, input);
			},
			get(input) {
				return executeImagesGet(adapters.images, input);
			},
			delete(input, options) {
				return executeImagesDelete(adapters.images, input, options);
			},
			move(input, options) {
				return executeImagesMove(adapters.images, input, options);
			},
			convertToInline(input, options) {
				return executeImagesConvertToInline(adapters.images, input, options);
			},
			convertToFloating(input, options) {
				return executeImagesConvertToFloating(adapters.images, input, options);
			},
			setSize(input, options) {
				return executeImagesSetSize(adapters.images, input, options);
			},
			setWrapType(input, options) {
				return executeImagesSetWrapType(adapters.images, input, options);
			},
			setWrapSide(input, options) {
				return executeImagesSetWrapSide(adapters.images, input, options);
			},
			setWrapDistances(input, options) {
				return executeImagesSetWrapDistances(adapters.images, input, options);
			},
			setPosition(input, options) {
				return executeImagesSetPosition(adapters.images, input, options);
			},
			setAnchorOptions(input, options) {
				return executeImagesSetAnchorOptions(adapters.images, input, options);
			},
			setZOrder(input, options) {
				return executeImagesSetZOrder(adapters.images, input, options);
			},
			scale(input, options) {
				return executeImagesScale(adapters.images, input, options);
			},
			setLockAspectRatio(input, options) {
				return executeImagesSetLockAspectRatio(adapters.images, input, options);
			},
			rotate(input, options) {
				return executeImagesRotate(adapters.images, input, options);
			},
			flip(input, options) {
				return executeImagesFlip(adapters.images, input, options);
			},
			crop(input, options) {
				return executeImagesCrop(adapters.images, input, options);
			},
			resetCrop(input, options) {
				return executeImagesResetCrop(adapters.images, input, options);
			},
			replaceSource(input, options) {
				return executeImagesReplaceSource(adapters.images, input, options);
			},
			setAltText(input, options) {
				return executeImagesSetAltText(adapters.images, input, options);
			},
			setDecorative(input, options) {
				return executeImagesSetDecorative(adapters.images, input, options);
			},
			setName(input, options) {
				return executeImagesSetName(adapters.images, input, options);
			},
			setHyperlink(input, options) {
				return executeImagesSetHyperlink(adapters.images, input, options);
			},
			insertCaption(input, options) {
				return executeImagesInsertCaption(adapters.images, input, options);
			},
			updateCaption(input, options) {
				return executeImagesUpdateCaption(adapters.images, input, options);
			},
			removeCaption(input, options) {
				return executeImagesRemoveCaption(adapters.images, input, options);
			}
		},
		lists: {
			list(query) {
				return executeListsList(adapters.lists, query);
			},
			get(input) {
				return executeListsGet(adapters.lists, input);
			},
			insert(input, options) {
				return executeListsInsert(adapters.lists, input, options);
			},
			create(input, options) {
				return executeListsCreate(adapters.lists, input, options);
			},
			attach(input, options) {
				return executeListsAttach(adapters.lists, input, options);
			},
			detach(input, options) {
				return executeListsDetach(adapters.lists, input, options);
			},
			delete(input, options) {
				return executeListsDelete(adapters.lists, input, options);
			},
			indent(input, options) {
				return executeListsIndent(adapters.lists, input, options);
			},
			outdent(input, options) {
				return executeListsOutdent(adapters.lists, input, options);
			},
			join(input, options) {
				return executeListsJoin(adapters.lists, input, options);
			},
			canJoin(input) {
				return executeListsCanJoin(adapters.lists, input);
			},
			separate(input, options) {
				return executeListsSeparate(adapters.lists, input, options);
			},
			merge(input, options) {
				return executeListsMerge(adapters.lists, input, options);
			},
			split(input, options) {
				return executeListsSplit(adapters.lists, input, options);
			},
			setLevel(input, options) {
				return executeListsSetLevel(adapters.lists, input, options);
			},
			setValue(input, options) {
				return executeListsSetValue(adapters.lists, input, options);
			},
			continuePrevious(input, options) {
				return executeListsContinuePrevious(adapters.lists, input, options);
			},
			canContinuePrevious(input) {
				return executeListsCanContinuePrevious(adapters.lists, input);
			},
			setLevelRestart(input, options) {
				return executeListsSetLevelRestart(adapters.lists, input, options);
			},
			convertToText(input, options) {
				return executeListsConvertToText(adapters.lists, input, options);
			},
			applyTemplate(input, options) {
				return executeListsApplyTemplate(adapters.lists, input, options);
			},
			applyPreset(input, options) {
				return executeListsApplyPreset(adapters.lists, input, options);
			},
			captureTemplate(input) {
				return executeListsCaptureTemplate(adapters.lists, input);
			},
			setLevelNumbering(input, options) {
				return executeListsSetLevelNumbering(adapters.lists, input, options);
			},
			setLevelBullet(input, options) {
				return executeListsSetLevelBullet(adapters.lists, input, options);
			},
			setLevelPictureBullet(input, options) {
				return executeListsSetLevelPictureBullet(adapters.lists, input, options);
			},
			setLevelAlignment(input, options) {
				return executeListsSetLevelAlignment(adapters.lists, input, options);
			},
			setLevelIndents(input, options) {
				return executeListsSetLevelIndents(adapters.lists, input, options);
			},
			setLevelTrailingCharacter(input, options) {
				return executeListsSetLevelTrailingCharacter(adapters.lists, input, options);
			},
			setLevelMarkerFont(input, options) {
				return executeListsSetLevelMarkerFont(adapters.lists, input, options);
			},
			clearLevelOverrides(input, options) {
				return executeListsClearLevelOverrides(adapters.lists, input, options);
			},
			setType(input, options) {
				return executeListsSetType(adapters.lists, input, options);
			},
			getStyle(input) {
				return executeListsGetStyle(adapters.lists, input);
			},
			applyStyle(input, options) {
				return executeListsApplyStyle(adapters.lists, input, options);
			},
			restartAt(input, options) {
				return executeListsRestartAt(adapters.lists, input, options);
			},
			setLevelNumberStyle(input, options) {
				return executeListsSetLevelNumberStyle(adapters.lists, input, options);
			},
			setLevelText(input, options) {
				return executeListsSetLevelText(adapters.lists, input, options);
			},
			setLevelStart(input, options) {
				return executeListsSetLevelStart(adapters.lists, input, options);
			},
			setLevelLayout(input, options) {
				return executeListsSetLevelLayout(adapters.lists, input, options);
			}
		},
		sections: {
			list(query) {
				return executeSectionsList(adapters.sections, query);
			},
			get(input) {
				return executeSectionsGet(adapters.sections, input);
			},
			setBreakType(input, options) {
				return executeSectionsSetBreakType(adapters.sections, input, options);
			},
			setPageMargins(input, options) {
				return executeSectionsSetPageMargins(adapters.sections, input, options);
			},
			setHeaderFooterMargins(input, options) {
				return executeSectionsSetHeaderFooterMargins(adapters.sections, input, options);
			},
			setPageSetup(input, options) {
				return executeSectionsSetPageSetup(adapters.sections, input, options);
			},
			setColumns(input, options) {
				return executeSectionsSetColumns(adapters.sections, input, options);
			},
			setLineNumbering(input, options) {
				return executeSectionsSetLineNumbering(adapters.sections, input, options);
			},
			setPageNumbering(input, options) {
				return executeSectionsSetPageNumbering(adapters.sections, input, options);
			},
			setTitlePage(input, options) {
				return executeSectionsSetTitlePage(adapters.sections, input, options);
			},
			setOddEvenHeadersFooters(input, options) {
				return executeSectionsSetOddEvenHeadersFooters(adapters.sections, input, options);
			},
			setVerticalAlign(input, options) {
				return executeSectionsSetVerticalAlign(adapters.sections, input, options);
			},
			setSectionDirection(input, options) {
				return executeSectionsSetSectionDirection(adapters.sections, input, options);
			},
			setHeaderFooterRef(input, options) {
				return executeSectionsSetHeaderFooterRef(adapters.sections, input, options);
			},
			clearHeaderFooterRef(input, options) {
				return executeSectionsClearHeaderFooterRef(adapters.sections, input, options);
			},
			setLinkToPrevious(input, options) {
				return executeSectionsSetLinkToPrevious(adapters.sections, input, options);
			},
			setPageBorders(input, options) {
				return executeSectionsSetPageBorders(adapters.sections, input, options);
			},
			clearPageBorders(input, options) {
				return executeSectionsClearPageBorders(adapters.sections, input, options);
			}
		},
		tables: {
			convertFromText(input, options) {
				return executeTableLocatorOp("tables.convertFromText", adapters.tables.convertFromText.bind(adapters.tables), input, options);
			},
			delete(input, options) {
				return executeTableLocatorOp("tables.delete", adapters.tables.delete.bind(adapters.tables), input, options);
			},
			clearContents(input, options) {
				return executeTableLocatorOp("tables.clearContents", adapters.tables.clearContents.bind(adapters.tables), input, options);
			},
			move(input, options) {
				return executeTableLocatorOp("tables.move", adapters.tables.move.bind(adapters.tables), input, options);
			},
			split(input, options) {
				const normalized = normalizeTablesSplitInput(input);
				return executeRowLocatorOp("tables.split", adapters.tables.split.bind(adapters.tables), normalized, options);
			},
			convertToText(input, options) {
				return executeTableLocatorOp("tables.convertToText", adapters.tables.convertToText.bind(adapters.tables), input, options);
			},
			setLayout(input, options) {
				return executeTableLocatorOp("tables.setLayout", adapters.tables.setLayout.bind(adapters.tables), input, options);
			},
			insertRow(input, options) {
				return executeRowLocatorOp("tables.insertRow", adapters.tables.insertRow.bind(adapters.tables), input, options, { allowAppendShorthand: true });
			},
			deleteRow(input, options) {
				return executeRowLocatorOp("tables.deleteRow", adapters.tables.deleteRow.bind(adapters.tables), input, options);
			},
			setRowHeight(input, options) {
				return executeRowLocatorOp("tables.setRowHeight", adapters.tables.setRowHeight.bind(adapters.tables), input, options);
			},
			distributeRows(input, options) {
				return executeTableLocatorOp("tables.distributeRows", adapters.tables.distributeRows.bind(adapters.tables), input, options);
			},
			setRowOptions(input, options) {
				return executeRowLocatorOp("tables.setRowOptions", adapters.tables.setRowOptions.bind(adapters.tables), input, options);
			},
			insertColumn(input, options) {
				return executeTableLocatorOp("tables.insertColumn", adapters.tables.insertColumn.bind(adapters.tables), input, options);
			},
			deleteColumn(input, options) {
				return executeTableLocatorOp("tables.deleteColumn", adapters.tables.deleteColumn.bind(adapters.tables), input, options);
			},
			setColumnWidth(input, options) {
				return executeTableLocatorOp("tables.setColumnWidth", adapters.tables.setColumnWidth.bind(adapters.tables), input, options);
			},
			distributeColumns(input, options) {
				return executeTableLocatorOp("tables.distributeColumns", adapters.tables.distributeColumns.bind(adapters.tables), input, options);
			},
			insertCell(input, options) {
				return executeTableLocatorOp("tables.insertCell", adapters.tables.insertCell.bind(adapters.tables), input, options);
			},
			deleteCell(input, options) {
				return executeTableLocatorOp("tables.deleteCell", adapters.tables.deleteCell.bind(adapters.tables), input, options);
			},
			mergeCells(input, options) {
				return executeTableLocatorOp("tables.mergeCells", adapters.tables.mergeCells.bind(adapters.tables), input, options);
			},
			unmergeCells(input, options) {
				return executeCellOrTableScopedCellLocatorOp("tables.unmergeCells", adapters.tables.unmergeCells.bind(adapters.tables), input, options);
			},
			splitCell(input, options) {
				return executeTableLocatorOp("tables.splitCell", adapters.tables.splitCell.bind(adapters.tables), input, options);
			},
			setCellProperties(input, options) {
				return executeTableLocatorOp("tables.setCellProperties", adapters.tables.setCellProperties.bind(adapters.tables), input, options);
			},
			setCellText(input, options) {
				return executeCellOrTableScopedCellLocatorOp("tables.setCellText", adapters.tables.setCellText.bind(adapters.tables), input, options);
			},
			sort(input, options) {
				return executeTableLocatorOp("tables.sort", adapters.tables.sort.bind(adapters.tables), input, options);
			},
			setAltText(input, options) {
				return executeTableLocatorOp("tables.setAltText", adapters.tables.setAltText.bind(adapters.tables), input, options);
			},
			setStyle(input, options) {
				return executeTableLocatorOp("tables.setStyle", adapters.tables.setStyle.bind(adapters.tables), input, options);
			},
			clearStyle(input, options) {
				return executeTableLocatorOp("tables.clearStyle", adapters.tables.clearStyle.bind(adapters.tables), input, options);
			},
			setStyleOption(input, options) {
				return executeTableLocatorOp("tables.setStyleOption", adapters.tables.setStyleOption.bind(adapters.tables), input, options);
			},
			setBorder(input, options) {
				return executeTableLocatorOp("tables.setBorder", adapters.tables.setBorder.bind(adapters.tables), input, options);
			},
			clearBorder(input, options) {
				return executeTableLocatorOp("tables.clearBorder", adapters.tables.clearBorder.bind(adapters.tables), input, options);
			},
			applyBorderPreset(input, options) {
				return executeTableLocatorOp("tables.applyBorderPreset", adapters.tables.applyBorderPreset.bind(adapters.tables), input, options);
			},
			setShading(input, options) {
				return executeTableLocatorOp("tables.setShading", adapters.tables.setShading.bind(adapters.tables), input, options);
			},
			clearShading(input, options) {
				return executeTableLocatorOp("tables.clearShading", adapters.tables.clearShading.bind(adapters.tables), input, options);
			},
			setTablePadding(input, options) {
				return executeTableLocatorOp("tables.setTablePadding", adapters.tables.setTablePadding.bind(adapters.tables), input, options);
			},
			setCellPadding(input, options) {
				return executeTableLocatorOp("tables.setCellPadding", adapters.tables.setCellPadding.bind(adapters.tables), input, options);
			},
			setCellSpacing(input, options) {
				return executeTableLocatorOp("tables.setCellSpacing", adapters.tables.setCellSpacing.bind(adapters.tables), input, options);
			},
			clearCellSpacing(input, options) {
				return executeTableLocatorOp("tables.clearCellSpacing", adapters.tables.clearCellSpacing.bind(adapters.tables), input, options);
			},
			applyStyle(input, options) {
				return executeTablesApplyStyle("tables.applyStyle", adapters.tables.applyStyle.bind(adapters.tables), input, options);
			},
			setBorders(input, options) {
				return executeTablesSetBorders("tables.setBorders", adapters.tables.setBorders.bind(adapters.tables), input, options);
			},
			setTableOptions(input, options) {
				return executeTablesSetTableOptions("tables.setTableOptions", adapters.tables.setTableOptions.bind(adapters.tables), input, options);
			},
			applyPreset(input, options) {
				return executeTableLocatorOp("tables.applyPreset", adapters.tables.applyPreset.bind(adapters.tables), input, options);
			},
			get(input) {
				return adapters.tables.get(input);
			},
			getCells(input) {
				return adapters.tables.getCells(input);
			},
			getProperties(input) {
				return adapters.tables.getProperties(input);
			},
			getStyles(input) {
				return adapters.tables.getStyles(input);
			},
			setDefaultStyle(input, options) {
				return executeDocumentLevelTableOp(adapters.tables.setDefaultStyle.bind(adapters.tables), input, options);
			},
			clearDefaultStyle(input, options) {
				return executeDocumentLevelTableOp(adapters.tables.clearDefaultStyle.bind(adapters.tables), input, options);
			}
		},
		toc: {
			list(query) {
				return executeTocList(adapters.toc, query);
			},
			get(input) {
				return executeTocGet(adapters.toc, input);
			},
			configure(input, options) {
				return executeTocConfigure(adapters.toc, input, options);
			},
			update(input, options) {
				return executeTocUpdate(adapters.toc, input, options);
			},
			remove(input, options) {
				return executeTocRemove(adapters.toc, input, options);
			},
			markEntry(input, options) {
				return executeTocMarkEntry(adapters.toc, input, options);
			},
			unmarkEntry(input, options) {
				return executeTocUnmarkEntry(adapters.toc, input, options);
			},
			listEntries(query) {
				return executeTocListEntries(adapters.toc, query);
			},
			getEntry(input) {
				return executeTocGetEntry(adapters.toc, input);
			},
			editEntry(input, options) {
				return executeTocEditEntry(adapters.toc, input, options);
			}
		},
		hyperlinks: {
			list(query) {
				return executeHyperlinksList(adapters.hyperlinks, query);
			},
			get(input) {
				return executeHyperlinksGet(adapters.hyperlinks, input);
			},
			wrap(input, options) {
				return executeHyperlinksWrap(adapters.hyperlinks, input, options);
			},
			insert(input, options) {
				return executeHyperlinksInsert(adapters.hyperlinks, input, options);
			},
			patch(input, options) {
				return executeHyperlinksPatch(adapters.hyperlinks, input, options);
			},
			remove(input, options) {
				return executeHyperlinksRemove(adapters.hyperlinks, input, options);
			}
		},
		headerFooters: {
			list(query) {
				return executeHeaderFootersList(adapters.headerFooters, query);
			},
			get(input) {
				return executeHeaderFootersGet(adapters.headerFooters, input);
			},
			resolve(input) {
				return executeHeaderFootersResolve(adapters.headerFooters, input);
			},
			refs: {
				set(input, options) {
					return executeHeaderFootersRefsSet(adapters.headerFooters, input, options);
				},
				clear(input, options) {
					return executeHeaderFootersRefsClear(adapters.headerFooters, input, options);
				},
				setLinkedToPrevious(input, options) {
					return executeHeaderFootersRefsSetLinkedToPrevious(adapters.headerFooters, input, options);
				}
			},
			parts: {
				list(query) {
					return executeHeaderFootersPartsList(adapters.headerFooters, query);
				},
				create(input, options) {
					return executeHeaderFootersPartsCreate(adapters.headerFooters, input, options);
				},
				delete(input, options) {
					return executeHeaderFootersPartsDelete(adapters.headerFooters, input, options);
				}
			}
		},
		contentControls: {
			list(query) {
				return executeContentControlsList(adapters.contentControls, query);
			},
			get(input) {
				return executeContentControlsGet(adapters.contentControls, input);
			},
			listInRange(input) {
				return executeContentControlsListInRange(adapters.contentControls, input);
			},
			selectByTag(input) {
				return executeContentControlsSelectByTag(adapters.contentControls, input);
			},
			selectByTitle(input) {
				return executeContentControlsSelectByTitle(adapters.contentControls, input);
			},
			listChildren(input) {
				return executeContentControlsListChildren(adapters.contentControls, input);
			},
			getParent(input) {
				return executeContentControlsGetParent(adapters.contentControls, input);
			},
			wrap(input, options) {
				return executeContentControlsWrap(adapters.contentControls, input, options);
			},
			unwrap(input, options) {
				return executeContentControlsUnwrap(adapters.contentControls, input, options);
			},
			delete(input, options) {
				return executeContentControlsDelete(adapters.contentControls, input, options);
			},
			copy(input, options) {
				return executeContentControlsCopy(adapters.contentControls, input, options);
			},
			move(input, options) {
				return executeContentControlsMove(adapters.contentControls, input, options);
			},
			patch(input, options) {
				return executeContentControlsPatch(adapters.contentControls, input, options);
			},
			setLockMode(input, options) {
				return executeContentControlsSetLockMode(adapters.contentControls, input, options);
			},
			setType(input, options) {
				return executeContentControlsSetType(adapters.contentControls, input, options);
			},
			getContent(input) {
				return executeContentControlsGetContent(adapters.contentControls, input);
			},
			replaceContent(input, options) {
				return executeContentControlsReplaceContent(adapters.contentControls, input, options);
			},
			clearContent(input, options) {
				return executeContentControlsClearContent(adapters.contentControls, input, options);
			},
			appendContent(input, options) {
				return executeContentControlsAppendContent(adapters.contentControls, input, options);
			},
			prependContent(input, options) {
				return executeContentControlsPrependContent(adapters.contentControls, input, options);
			},
			insertBefore(input, options) {
				return executeContentControlsInsertBefore(adapters.contentControls, input, options);
			},
			insertAfter(input, options) {
				return executeContentControlsInsertAfter(adapters.contentControls, input, options);
			},
			getBinding(input) {
				return executeContentControlsGetBinding(adapters.contentControls, input);
			},
			setBinding(input, options) {
				return executeContentControlsSetBinding(adapters.contentControls, input, options);
			},
			clearBinding(input, options) {
				return executeContentControlsClearBinding(adapters.contentControls, input, options);
			},
			getRawProperties(input) {
				return executeContentControlsGetRawProperties(adapters.contentControls, input);
			},
			patchRawProperties(input, options) {
				return executeContentControlsPatchRawProperties(adapters.contentControls, input, options);
			},
			validateWordCompatibility(input) {
				return executeContentControlsValidateWordCompatibility(adapters.contentControls, input);
			},
			normalizeWordCompatibility(input, options) {
				return executeContentControlsNormalizeWordCompatibility(adapters.contentControls, input, options);
			},
			normalizeTagPayload(input, options) {
				return executeContentControlsNormalizeTagPayload(adapters.contentControls, input, options);
			},
			text: {
				setMultiline(input, options) {
					return executeContentControlsTextSetMultiline(adapters.contentControls, input, options);
				},
				setValue(input, options) {
					return executeContentControlsTextSetValue(adapters.contentControls, input, options);
				},
				clearValue(input, options) {
					return executeContentControlsTextClearValue(adapters.contentControls, input, options);
				}
			},
			date: {
				setValue(input, options) {
					return executeContentControlsDateSetValue(adapters.contentControls, input, options);
				},
				clearValue(input, options) {
					return executeContentControlsDateClearValue(adapters.contentControls, input, options);
				},
				setDisplayFormat(input, options) {
					return executeContentControlsDateSetDisplayFormat(adapters.contentControls, input, options);
				},
				setDisplayLocale(input, options) {
					return executeContentControlsDateSetDisplayLocale(adapters.contentControls, input, options);
				},
				setStorageFormat(input, options) {
					return executeContentControlsDateSetStorageFormat(adapters.contentControls, input, options);
				},
				setCalendar(input, options) {
					return executeContentControlsDateSetCalendar(adapters.contentControls, input, options);
				}
			},
			checkbox: {
				getState(input) {
					return executeContentControlsCheckboxGetState(adapters.contentControls, input);
				},
				setState(input, options) {
					return executeContentControlsCheckboxSetState(adapters.contentControls, input, options);
				},
				toggle(input, options) {
					return executeContentControlsCheckboxToggle(adapters.contentControls, input, options);
				},
				setSymbolPair(input, options) {
					return executeContentControlsCheckboxSetSymbolPair(adapters.contentControls, input, options);
				}
			},
			choiceList: {
				getItems(input) {
					return executeContentControlsChoiceListGetItems(adapters.contentControls, input);
				},
				setItems(input, options) {
					return executeContentControlsChoiceListSetItems(adapters.contentControls, input, options);
				},
				setSelected(input, options) {
					return executeContentControlsChoiceListSetSelected(adapters.contentControls, input, options);
				}
			},
			repeatingSection: {
				listItems(input) {
					return executeContentControlsRepeatingSectionListItems(adapters.contentControls, input);
				},
				insertItemBefore(input, options) {
					return executeContentControlsRepeatingSectionInsertItemBefore(adapters.contentControls, input, options);
				},
				insertItemAfter(input, options) {
					return executeContentControlsRepeatingSectionInsertItemAfter(adapters.contentControls, input, options);
				},
				cloneItem(input, options) {
					return executeContentControlsRepeatingSectionCloneItem(adapters.contentControls, input, options);
				},
				deleteItem(input, options) {
					return executeContentControlsRepeatingSectionDeleteItem(adapters.contentControls, input, options);
				},
				setAllowInsertDelete(input, options) {
					return executeContentControlsRepeatingSectionSetAllowInsertDelete(adapters.contentControls, input, options);
				}
			},
			group: {
				wrap(input, options) {
					return executeContentControlsGroupWrap(adapters.contentControls, input, options);
				},
				ungroup(input, options) {
					return executeContentControlsGroupUngroup(adapters.contentControls, input, options);
				}
			}
		},
		bookmarks: {
			list(query) {
				return executeBookmarksList(requireAdapter(adapters.bookmarks, "bookmarks"), query);
			},
			get(input) {
				return executeBookmarksGet(requireAdapter(adapters.bookmarks, "bookmarks"), input);
			},
			insert(input, options) {
				return executeBookmarksInsert(requireAdapter(adapters.bookmarks, "bookmarks"), input, options);
			},
			rename(input, options) {
				return executeBookmarksRename(requireAdapter(adapters.bookmarks, "bookmarks"), input, options);
			},
			remove(input, options) {
				return executeBookmarksRemove(requireAdapter(adapters.bookmarks, "bookmarks"), input, options);
			}
		},
		footnotes: {
			list(query) {
				return executeFootnotesList(requireAdapter(adapters.footnotes, "footnotes"), query);
			},
			get(input) {
				return executeFootnotesGet(requireAdapter(adapters.footnotes, "footnotes"), input);
			},
			insert(input, options) {
				return executeFootnotesInsert(requireAdapter(adapters.footnotes, "footnotes"), input, options);
			},
			update(input, options) {
				return executeFootnotesUpdate(requireAdapter(adapters.footnotes, "footnotes"), input, options);
			},
			remove(input, options) {
				return executeFootnotesRemove(requireAdapter(adapters.footnotes, "footnotes"), input, options);
			},
			configure(input, options) {
				return executeFootnotesConfigure(requireAdapter(adapters.footnotes, "footnotes"), input, options);
			}
		},
		crossRefs: {
			list(query) {
				return executeCrossRefsList(requireAdapter(adapters.crossRefs, "crossRefs"), query);
			},
			get(input) {
				return executeCrossRefsGet(requireAdapter(adapters.crossRefs, "crossRefs"), input);
			},
			insert(input, options) {
				return executeCrossRefsInsert(requireAdapter(adapters.crossRefs, "crossRefs"), input, options);
			},
			rebuild(input, options) {
				return executeCrossRefsRebuild(requireAdapter(adapters.crossRefs, "crossRefs"), input, options);
			},
			remove(input, options) {
				return executeCrossRefsRemove(requireAdapter(adapters.crossRefs, "crossRefs"), input, options);
			}
		},
		index: {
			list(input) {
				return executeIndexList(requireAdapter(adapters.index, "index"), input);
			},
			get(input) {
				return executeIndexGet(requireAdapter(adapters.index, "index"), input);
			},
			insert(input, options) {
				return executeIndexInsert(requireAdapter(adapters.index, "index"), input, options);
			},
			configure(input, options) {
				return executeIndexConfigure(requireAdapter(adapters.index, "index"), input, options);
			},
			rebuild(input, options) {
				return executeIndexRebuild(requireAdapter(adapters.index, "index"), input, options);
			},
			remove(input, options) {
				return executeIndexRemove(requireAdapter(adapters.index, "index"), input, options);
			},
			entries: {
				list(input) {
					return executeIndexEntryList(requireAdapter(adapters.index, "index"), input);
				},
				get(input) {
					return executeIndexEntryGet(requireAdapter(adapters.index, "index"), input);
				},
				insert(input, options) {
					return executeIndexEntryInsert(requireAdapter(adapters.index, "index"), input, options);
				},
				update(input, options) {
					return executeIndexEntryUpdate(requireAdapter(adapters.index, "index"), input, options);
				},
				remove(input, options) {
					return executeIndexEntryRemove(requireAdapter(adapters.index, "index"), input, options);
				}
			}
		},
		captions: {
			list(input) {
				return executeCaptionsList(requireAdapter(adapters.captions, "captions"), input);
			},
			get(input) {
				return executeCaptionsGet(requireAdapter(adapters.captions, "captions"), input);
			},
			insert(input, options) {
				return executeCaptionsInsert(requireAdapter(adapters.captions, "captions"), input, options);
			},
			update(input, options) {
				return executeCaptionsUpdate(requireAdapter(adapters.captions, "captions"), input, options);
			},
			remove(input, options) {
				return executeCaptionsRemove(requireAdapter(adapters.captions, "captions"), input, options);
			},
			configure(input, options) {
				return executeCaptionsConfigure(requireAdapter(adapters.captions, "captions"), input, options);
			}
		},
		fields: {
			list(query) {
				return executeFieldsList(requireAdapter(adapters.fields, "fields"), query);
			},
			get(input) {
				return executeFieldsGet(requireAdapter(adapters.fields, "fields"), input);
			},
			insert(input, options) {
				return executeFieldsInsert(requireAdapter(adapters.fields, "fields"), input, options);
			},
			rebuild(input, options) {
				return executeFieldsRebuild(requireAdapter(adapters.fields, "fields"), input, options);
			},
			remove(input, options) {
				return executeFieldsRemove(requireAdapter(adapters.fields, "fields"), input, options);
			}
		},
		citations: {
			list(query) {
				return executeCitationsList(requireAdapter(adapters.citations, "citations"), query);
			},
			get(input) {
				return executeCitationsGet(requireAdapter(adapters.citations, "citations"), input);
			},
			insert(input, options) {
				return executeCitationsInsert(requireAdapter(adapters.citations, "citations"), input, options);
			},
			update(input, options) {
				return executeCitationsUpdate(requireAdapter(adapters.citations, "citations"), input, options);
			},
			remove(input, options) {
				return executeCitationsRemove(requireAdapter(adapters.citations, "citations"), input, options);
			},
			sources: {
				list(query) {
					return executeCitationSourcesList(requireAdapter(adapters.citations, "citations"), query);
				},
				get(input) {
					return executeCitationSourcesGet(requireAdapter(adapters.citations, "citations"), input);
				},
				insert(input, options) {
					return executeCitationSourcesInsert(requireAdapter(adapters.citations, "citations"), input, options);
				},
				update(input, options) {
					return executeCitationSourcesUpdate(requireAdapter(adapters.citations, "citations"), input, options);
				},
				remove(input, options) {
					return executeCitationSourcesRemove(requireAdapter(adapters.citations, "citations"), input, options);
				}
			},
			bibliography: {
				get(input) {
					return executeBibliographyGet(requireAdapter(adapters.citations, "citations"), input);
				},
				insert(input, options) {
					return executeBibliographyInsert(requireAdapter(adapters.citations, "citations"), input, options);
				},
				rebuild(input, options) {
					return executeBibliographyRebuild(requireAdapter(adapters.citations, "citations"), input, options);
				},
				configure(input, options) {
					return executeBibliographyConfigure(requireAdapter(adapters.citations, "citations"), input, options);
				},
				remove(input, options) {
					return executeBibliographyRemove(requireAdapter(adapters.citations, "citations"), input, options);
				}
			}
		},
		authorities: {
			list(query) {
				return executeAuthoritiesList(requireAdapter(adapters.authorities, "authorities"), query);
			},
			get(input) {
				return executeAuthoritiesGet(requireAdapter(adapters.authorities, "authorities"), input);
			},
			insert(input, options) {
				return executeAuthoritiesInsert(requireAdapter(adapters.authorities, "authorities"), input, options);
			},
			configure(input, options) {
				return executeAuthoritiesConfigure(requireAdapter(adapters.authorities, "authorities"), input, options);
			},
			rebuild(input, options) {
				return executeAuthoritiesRebuild(requireAdapter(adapters.authorities, "authorities"), input, options);
			},
			remove(input, options) {
				return executeAuthoritiesRemove(requireAdapter(adapters.authorities, "authorities"), input, options);
			},
			entries: {
				list(query) {
					return executeAuthorityEntriesList(requireAdapter(adapters.authorities, "authorities"), query);
				},
				get(input) {
					return executeAuthorityEntriesGet(requireAdapter(adapters.authorities, "authorities"), input);
				},
				insert(input, options) {
					return executeAuthorityEntriesInsert(requireAdapter(adapters.authorities, "authorities"), input, options);
				},
				update(input, options) {
					return executeAuthorityEntriesUpdate(requireAdapter(adapters.authorities, "authorities"), input, options);
				},
				remove(input, options) {
					return executeAuthorityEntriesRemove(requireAdapter(adapters.authorities, "authorities"), input, options);
				}
			}
		},
		query: { match(input) {
			return executeQueryMatch(adapters.query, input);
		} },
		ranges: { resolve(input) {
			return executeResolveRange(adapters.ranges, input);
		} },
		selection: { current(input) {
			const adapter = adapters.selection;
			if (!adapter) throw new DocumentApiValidationError("SELECTION_ADAPTER_UNAVAILABLE", "No selection adapter was registered. Pass `selection` in DocumentApiAdapters to call selection.current().");
			return executeSelectionCurrent(adapter, input);
		} },
		mutations: {
			preview(input) {
				return adapters.mutations.preview(input);
			},
			apply(input) {
				return adapters.mutations.apply(input);
			}
		},
		diff: {
			capture() {
				return executeDiffCapture(adapters.diff);
			},
			compare(input) {
				return executeDiffCompare(adapters.diff, input);
			},
			apply(input, options) {
				return executeDiffApply(adapters.diff, input, options);
			}
		},
		history: {
			get() {
				return executeHistoryGet(adapters.history);
			},
			undo() {
				return executeHistoryUndo(adapters.history);
			},
			redo() {
				return executeHistoryRedo(adapters.history);
			}
		},
		protection: {
			get(input) {
				return executeProtectionGet(adapters.protection, input);
			},
			setEditingRestriction(input, options) {
				return executeSetEditingRestriction(adapters.protection, input, options);
			},
			clearEditingRestriction(input, options) {
				return executeClearEditingRestriction(adapters.protection, input, options);
			}
		},
		permissionRanges: {
			list(input) {
				return executePermissionRangesList(adapters.permissionRanges, input);
			},
			get(input) {
				return executePermissionRangesGet(adapters.permissionRanges, input);
			},
			create(input, options) {
				return executePermissionRangesCreate(adapters.permissionRanges, input, options);
			},
			remove(input, options) {
				return executePermissionRangesRemove(adapters.permissionRanges, input, options);
			},
			updatePrincipal(input, options) {
				return executePermissionRangesUpdatePrincipal(adapters.permissionRanges, input, options);
			}
		},
		customXml: { parts: {
			list(input) {
				return executeCustomXmlPartsList(requireAdapter(adapters.customXml, "customXml").parts, input);
			},
			get(input) {
				return executeCustomXmlPartsGet(requireAdapter(adapters.customXml, "customXml").parts, input);
			},
			create(input, options) {
				return executeCustomXmlPartsCreate(requireAdapter(adapters.customXml, "customXml").parts, input, options);
			},
			patch(input, options) {
				return executeCustomXmlPartsPatch(requireAdapter(adapters.customXml, "customXml").parts, input, options);
			},
			remove(input, options) {
				return executeCustomXmlPartsRemove(requireAdapter(adapters.customXml, "customXml").parts, input, options);
			}
		} },
		metadata: {
			attach(input, options) {
				return executeAnchoredMetadataAttach(requireAdapter(adapters.metadata, "metadata"), input, options);
			},
			list(input) {
				return executeAnchoredMetadataList(requireAdapter(adapters.metadata, "metadata"), input);
			},
			get(input) {
				return executeAnchoredMetadataGet(requireAdapter(adapters.metadata, "metadata"), input);
			},
			update(input, options) {
				return executeAnchoredMetadataUpdate(requireAdapter(adapters.metadata, "metadata"), input, options);
			},
			remove(input, options) {
				return executeAnchoredMetadataRemove(requireAdapter(adapters.metadata, "metadata"), input, options);
			},
			resolve(input) {
				return executeAnchoredMetadataResolve(requireAdapter(adapters.metadata, "metadata"), input);
			}
		},
		invoke(request) {
			if (!Object.prototype.hasOwnProperty.call(dispatch, request.operationId)) throw new Error(`Unknown operationId: "${request.operationId}"`);
			const handler$1 = dispatch[request.operationId];
			return handler$1(request.input, request.options);
		}
	};
	const dispatch = buildDispatchTable(api);
	return api;
}
var _buffers = /* @__PURE__ */ new Map();
var _defaultCollectionId = null;
var _nextCollectionId = 1;
function startCollection(collectionId) {
	const id = typeof collectionId === "number" ? collectionId : _nextCollectionId++;
	_buffers.set(id, []);
	_defaultCollectionId = id;
	return id;
}
function resolveCollectionId(collectionId) {
	if (typeof collectionId === "number") return collectionId;
	return _defaultCollectionId;
}
function pushDiagnostic(diagnostic, collectionId) {
	const id = resolveCollectionId(collectionId);
	if (id == null) return;
	const buffer = _buffers.get(id);
	if (!buffer) return;
	buffer.push(diagnostic);
}
function drainDiagnostics(collectionId) {
	const id = resolveCollectionId(collectionId);
	if (id == null) return [];
	const result = _buffers.get(id) ?? [];
	_buffers.delete(id);
	if (_defaultCollectionId === id) _defaultCollectionId = null;
	return result;
}
const generateV2HandlerEntity = (handlerName, translator$220) => ({
	handlerName,
	handler: (params) => {
		const { nodes } = params;
		if (!translator$220 || !translator$220.xmlName) return {
			nodes: [],
			consumed: 0
		};
		if (nodes.length === 0 || nodes[0].name !== translator$220.xmlName) return {
			nodes: [],
			consumed: 0
		};
		const result = translator$220.encode(params);
		if (!result) return {
			nodes: [],
			consumed: 0
		};
		return {
			nodes: Array.isArray(result) ? result : [result],
			consumed: 1
		};
	}
});
function createSingleAttrPropertyHandler(xmlName, sdName = null, attrName = "w:val", transformEncode = null, transformDecode = null) {
	if (!sdName) sdName = xmlName.split(":")[1];
	if (!transformEncode) transformEncode = (v) => v;
	if (!transformDecode) transformDecode = (v) => v;
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		encode: ({ nodes }) => {
			return transformEncode(nodes[0]?.attributes?.[attrName]) ?? void 0;
		},
		decode: ({ node }) => {
			const value = node.attrs?.[sdName] != null ? transformDecode(node.attrs[sdName]) : void 0;
			return value != null ? {
				name: xmlName,
				attributes: { [attrName]: value }
			} : void 0;
		}
	};
}
function createSingleBooleanPropertyHandler(xmlName, sdName = null) {
	if (!sdName) sdName = xmlName.split(":")[1];
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		encode: ({ nodes }) => parseBoolean(nodes[0].attributes?.["w:val"] ?? "1"),
		decode: ({ node }) => {
			if (node.attrs[sdName] == null) return void 0;
			return node.attrs[sdName] ? { attributes: {} } : { attributes: { "w:val": "0" } };
		}
	};
}
function parseStrictStOnOff(val, property, xmlName, importDiagnosticsCollectionId) {
	if (val == null) return true;
	const str = String(val);
	if (ST_ON_OFF_ON_VALUES.has(str)) return true;
	if (ST_ON_OFF_OFF_VALUES.has(str)) return false;
	if (property) pushDiagnostic({
		code: "INVALID_INLINE_TOKEN",
		property,
		attribute: "val",
		token: str,
		xpath: `${xmlName ?? `w:${property}`}/@w:val`
	}, importDiagnosticsCollectionId);
}
function createStrictTogglePropertyHandler(xmlName, sdName = null) {
	if (!sdName) sdName = xmlName.split(":")[1];
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		encode: ({ nodes, extraParams }) => {
			const val = nodes[0]?.attributes?.["w:val"];
			const importDiagnosticsCollectionId = extraParams?.importDiagnosticsCollectionId;
			return parseStrictStOnOff(val, sdName, xmlName, importDiagnosticsCollectionId);
		},
		decode: ({ node }) => {
			const val = node.attrs[sdName];
			if (val == null) return void 0;
			if (val === false || val === "0") return { attributes: { "w:val": "0" } };
			return { attributes: {} };
		}
	};
}
const createSingleIntegerPropertyHandler = (xmlName, sdName = null) => createSingleAttrPropertyHandler(xmlName, sdName, "w:val", parseInteger$1, integerToString);
var UNSUPPORTED_TABLE_IDENTITY_ATTRS = ["w14:paraId", "w14:textId"];
function stripUnsupportedTableIdentityAttributes(attrs) {
	if (!attrs || typeof attrs !== "object") return {};
	const filteredAttrs = { ...attrs };
	for (const attrName of UNSUPPORTED_TABLE_IDENTITY_ATTRS) delete filteredAttrs[attrName];
	return filteredAttrs;
}
const parseMeasurementValue = (value, type) => {
	if (value == null) return void 0;
	const strValue = String(value);
	if (type === "pct" && strValue.includes("%")) {
		const percent = parseFloat(strValue);
		if (!isNaN(percent)) return Math.round(percent * 50);
	}
	const intValue = parseInt(strValue, 10);
	return isNaN(intValue) ? void 0 : intValue;
};
function createMeasurementPropertyHandler(xmlName, sdName = null) {
	if (!sdName) sdName = xmlName.split(":")[1];
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		attributes: [createAttributeHandler("w:w", "value", (v) => v, integerToString), createAttributeHandler("w:type")],
		encode: (params, encodedAttrs) => {
			const rawValue = encodedAttrs["value"];
			const type = encodedAttrs["type"];
			const parsedValue = parseMeasurementValue(rawValue, type);
			if (parsedValue == null) return void 0;
			return {
				...encodedAttrs,
				value: parsedValue
			};
		},
		decode: function({ node }) {
			const decodedAttrs = this.decodeAttributes({ node: {
				...node,
				attrs: node.attrs[sdName] || {}
			} });
			return decodedAttrs["w:w"] != null ? { attributes: decodedAttrs } : void 0;
		}
	};
}
function createBorderPropertyHandler(xmlName, sdName = null) {
	if (!sdName) sdName = xmlName.split(":")[1];
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		attributes: [
			createAttributeHandler("w:val", "val", (v) => v === "nil" ? "none" : v, (v) => v === "none" ? "nil" : v),
			createAttributeHandler("w:color", "color", (v) => {
				if (v === "auto") return "auto";
				else if (v) return `#${v}`;
				else return;
			}, (v) => {
				if (v) return v.replace("#", "");
				else return;
			}),
			createAttributeHandler("w:themeColor"),
			createAttributeHandler("w:themeTint"),
			createAttributeHandler("w:themeShade"),
			createAttributeHandler("w:sz", "size", parseInteger$1, integerToString),
			createAttributeHandler("w:space", null, parseInteger$1, integerToString),
			createAttributeHandler("w:shadow", null, parseBoolean, booleanToString),
			createAttributeHandler("w:frame", null, parseBoolean, booleanToString)
		],
		encode: (params, encodedAttrs) => {
			return Object.keys(encodedAttrs).length > 0 ? encodedAttrs : void 0;
		},
		decode: function({ node }, context) {
			const decodedAttrs = this.decodeAttributes({ node: {
				...node,
				attrs: node.attrs[sdName] || {}
			} });
			return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
		}
	};
}
const createAttributeHandler = (xmlName, sdName = null, transformEncode = null, transformDecode = null) => {
	if (!transformEncode) transformEncode = (v) => v;
	if (!transformDecode) transformDecode = (v) => v;
	if (!sdName) sdName = xmlName.split(":")[1];
	return {
		xmlName,
		sdName,
		encode: (attributes) => transformEncode(attributes[xmlName]),
		decode: (attributes) => transformDecode(attributes[sdName])
	};
};
const createIntegerAttributeHandler = (xmlName, sdName = null) => createAttributeHandler(xmlName, sdName, parseInteger$1, integerToString);
const createBooleanAttributeHandler = (xmlName, sdName = null) => createAttributeHandler(xmlName, sdName, parseBoolean, booleanToString);
function encodeProperties(params, translatorsByXmlName, asArray = false) {
	const node = params.nodes[0];
	if (!node?.elements || node.elements.length === 0) return asArray ? [] : {};
	const attributes = asArray ? [] : {};
	node.elements.forEach((el) => {
		const translator$220 = translatorsByXmlName[el.name];
		if (translator$220) {
			let encodedAttr = translator$220.encode({
				...params,
				nodes: [el]
			});
			if (encodedAttr != null) {
				if (typeof encodedAttr === "object") {
					if ("attrs" in encodedAttr) encodedAttr = encodedAttr.attrs;
					else if ("attributes" in encodedAttr) encodedAttr = encodedAttr.attributes;
				}
				if (asArray) attributes.push({ [translator$220.sdNodeOrKeyName]: encodedAttr });
				else attributes[translator$220.sdNodeOrKeyName] = encodedAttr;
			}
		}
	});
	return attributes;
}
function decodeProperties(params, translatorsBySdName, properties) {
	if (!properties || typeof properties !== "object") return [];
	const elements = [];
	Object.keys(properties).forEach((key) => {
		const translator$220 = translatorsBySdName[key];
		if (translator$220) {
			const result = translator$220.decode({
				...params,
				node: { attrs: { [key]: properties[key] } }
			});
			if (result != null) {
				if (result.name == null) result.name = translator$220.xmlName;
				elements.push(result);
			}
		}
	});
	return elements;
}
function encodePropertiesByKey(xmlName, sdName, translator$220, params, node, keyAttr) {
	const result = {};
	const elements = node.elements?.filter((el) => el.name === xmlName) || [];
	if (elements.length > 0) {
		const items = elements.map((el) => translator$220.encode({
			...params,
			nodes: [el]
		})).filter(Boolean);
		if (items.length > 0) result[sdName] = items.reduce((acc, item) => {
			if (item[keyAttr] != null) acc[item[keyAttr]] = item;
			return acc;
		}, {});
	}
	return result;
}
function decodePropertiesByKey(xmlName, sdName, translator$220, params, attrs) {
	const elements = [];
	if (attrs[sdName] != null) Object.values(attrs[sdName]).forEach((item) => {
		const decoded = translator$220.decode({
			...params,
			node: { attrs: { [translator$220.sdNodeOrKeyName]: item } }
		});
		if (decoded) elements.push(decoded);
	});
	return elements;
}
function createNestedPropertiesTranslator(xmlName, sdName, propertyTranslators$17, defaultEncodedAttrs = {}, attributeHandlers$4 = []) {
	const propertyTranslatorsByXmlName$3 = {};
	const propertyTranslatorsBySdName$3 = {};
	propertyTranslators$17.forEach((translator$220) => {
		if (!translator$220) return;
		propertyTranslatorsByXmlName$3[translator$220.xmlName] = translator$220;
		propertyTranslatorsBySdName$3[translator$220.sdNodeOrKeyName] = translator$220;
	});
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		type: NodeTranslator.translatorTypes.NODE,
		attributes: attributeHandlers$4,
		encode: (params, encodedAttrs) => {
			const { nodes } = params;
			const node = nodes[0];
			const attributes = {
				...defaultEncodedAttrs,
				...encodedAttrs,
				...encodeProperties({
					...params,
					nodes: [node]
				}, propertyTranslatorsByXmlName$3)
			};
			return Object.keys(attributes).length > 0 ? attributes : void 0;
		},
		decode: function(params) {
			const decodedAttrs = this.decodeAttributes({ node: {
				...params.node,
				attrs: params.node.attrs[sdName] || {}
			} });
			const currentValue = params.node.attrs?.[sdName];
			const elements = decodeProperties(params, propertyTranslatorsBySdName$3, currentValue);
			if (elements.length === 0) return;
			return {
				name: xmlName,
				type: "element",
				attributes: decodedAttrs,
				elements
			};
		}
	};
}
function createNestedArrayPropertyHandler(xmlName, sdName = null, propertyTranslators$17, extraParamsForDecode = {}) {
	if (!sdName) sdName = xmlName.split(":")[1];
	const propertyTranslatorsByXmlName$3 = {};
	const propertyTranslatorsBySdName$3 = {};
	propertyTranslators$17.forEach((translator$220) => {
		propertyTranslatorsByXmlName$3[translator$220.xmlName] = translator$220;
		propertyTranslatorsBySdName$3[translator$220.sdNodeOrKeyName] = translator$220;
	});
	return {
		xmlName,
		sdNodeOrKeyName: sdName,
		attributes: [],
		encode: (params) => {
			const { nodes } = params;
			const node = nodes[0];
			return encodeProperties({
				...params,
				nodes: [node]
			}, propertyTranslatorsByXmlName$3, true);
		},
		decode: (params) => {
			const arrayContainer = params.node.attrs?.[sdName] || [];
			if (!Array.isArray(arrayContainer) || arrayContainer.length === 0) return;
			const elements = [];
			arrayContainer.forEach((item) => {
				const sdKey = Object.keys(item)[0];
				const childTranslator = propertyTranslatorsBySdName$3[sdKey];
				if (childTranslator) {
					const result = childTranslator.decode({
						...params,
						node: {
							type: sdKey,
							attrs: { [sdKey]: item[sdKey] }
						},
						extraParams: {
							...params.extraParams,
							...extraParamsForDecode
						}
					});
					if (result != null) elements.push(result);
				}
			});
			return {
				name: xmlName,
				attributes: {},
				elements: elements.flat()
			};
		}
	};
}
const parseBoolean = (value) => value != null ? [
	"1",
	"true",
	"on",
	1,
	true
].includes(value) : void 0;
const booleanToString = (value) => value != null ? value ? "1" : "0" : void 0;
const parseInteger$1 = (value) => {
	if (value == null) return void 0;
	const intValue = parseInt(value, 10);
	return isNaN(intValue) ? void 0 : intValue;
};
const integerToString = (value) => {
	const intValue = parseInteger$1(value);
	return intValue != void 0 ? String(intValue) : void 0;
};
const translator$46 = NodeTranslator.from(createStrictTogglePropertyHandler("w:b", "bold"));
const translator$50 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:bCs", "boldCs"));
const translator$48 = NodeTranslator.from(createBorderPropertyHandler("w:bdr", "borders"));
const translator$79 = NodeTranslator.from(createStrictTogglePropertyHandler("w:i", "italic"));
const encode$73 = (attributes) => attributes?.["w:val"];
const decode$75 = (attrs) => attrs?.underline;
const attrConfig$29 = Object.freeze({
	xmlName: "w:val",
	sdName: "underline",
	encode: encode$73,
	decode: decode$75
});
const encode$72 = (attributes) => attributes?.["w:color"];
const decode$74 = (attrs) => attrs?.color;
const attrConfig$30 = Object.freeze({
	xmlName: "w:color",
	sdName: "color",
	encode: encode$72,
	decode: decode$74
});
const encode$71 = (attributes) => attributes?.["w:themeColor"];
const decode$73 = (attrs) => attrs?.themeColor;
const attrConfig$31 = Object.freeze({
	xmlName: "w:themeColor",
	sdName: "themeColor",
	encode: encode$71,
	decode: decode$73
});
const encode$70 = (attributes) => attributes?.["w:themeTint"];
const decode$72 = (attrs) => attrs?.themeTint;
const attrConfig$32 = Object.freeze({
	xmlName: "w:themeTint",
	sdName: "themeTint",
	encode: encode$70,
	decode: decode$72
});
const encode$69 = (attributes) => attributes?.["w:themeShade"];
const decode$71 = (attrs) => attrs?.themeShade;
var attributes_default$7 = [
	attrConfig$29,
	attrConfig$30,
	attrConfig$31,
	attrConfig$32,
	Object.freeze({
		xmlName: "w:themeShade",
		sdName: "themeShade",
		encode: encode$69,
		decode: decode$71
	})
];
var XML_NODE_NAME$41 = "w:u";
var SD_ATTR_KEY$3 = "underline";
var encode$68 = (params, encodedAttrs = {}) => {
	const { nodes } = params;
	const sourceAttrs = (nodes?.[0])?.attributes || {};
	const importDiagnosticsCollectionId = params?.extraParams?.importDiagnosticsCollectionId;
	const rawVal = encodedAttrs.underline ?? sourceAttrs["w:val"];
	let underlineType;
	if (rawVal === void 0 || rawVal === null) underlineType = null;
	else if (typeof rawVal === "string" && ST_UNDERLINE_VALUE_SET.has(rawVal)) underlineType = rawVal;
	else {
		pushDiagnostic({
			code: "INVALID_INLINE_TOKEN",
			property: "underline",
			attribute: "val",
			token: String(rawVal),
			xpath: "w:u/@w:val"
		}, importDiagnosticsCollectionId);
		return;
	}
	const color = encodedAttrs.color ?? sourceAttrs["w:color"];
	const themeColor = encodedAttrs.themeColor ?? sourceAttrs["w:themeColor"];
	const themeTint = encodedAttrs.themeTint ?? sourceAttrs["w:themeTint"];
	const themeShade = encodedAttrs.themeShade ?? sourceAttrs["w:themeShade"];
	const attributes = { "w:val": underlineType };
	if (underlineType !== "none") {
		if (color !== void 0 && color !== null) attributes["w:color"] = color;
		if (themeColor !== void 0 && themeColor !== null) attributes["w:themeColor"] = themeColor;
		if (themeTint !== void 0 && themeTint !== null) attributes["w:themeTint"] = themeTint;
		if (themeShade !== void 0 && themeShade !== null) attributes["w:themeShade"] = themeShade;
	}
	return {
		type: "attr",
		xmlName: XML_NODE_NAME$41,
		sdNodeOrKeyName: SD_ATTR_KEY$3,
		attributes
	};
};
var decode$70 = (params) => {
	const attrs = params?.node?.attrs?.underline || params?.node?.attrs || {};
	const underlineType = attrs.underlineType ?? attrs.underline ?? attrs["w:val"] ?? null;
	const color = attrs.underlineColor ?? attrs.color ?? attrs["w:color"] ?? null;
	const themeColor = attrs.underlineThemeColor ?? attrs.themeColor ?? attrs["w:themeColor"] ?? null;
	const themeTint = attrs.underlineThemeTint ?? attrs.themeTint ?? attrs["w:themeTint"] ?? null;
	const themeShade = attrs.underlineThemeShade ?? attrs.themeShade ?? attrs["w:themeShade"] ?? null;
	if (!underlineType && !color && !themeColor) return void 0;
	const attributes = {};
	if (underlineType) attributes["w:val"] = underlineType;
	if (underlineType === "none") return {
		name: XML_NODE_NAME$41,
		attributes
	};
	if (color) {
		const normalized = normalizeHexColor(color);
		if (normalized) attributes["w:color"] = normalized;
	}
	if (themeColor) attributes["w:themeColor"] = themeColor;
	if (themeTint) attributes["w:themeTint"] = themeTint;
	if (themeShade) attributes["w:themeShade"] = themeShade;
	return {
		name: XML_NODE_NAME$41,
		attributes
	};
};
const config$40 = {
	xmlName: XML_NODE_NAME$41,
	sdNodeOrKeyName: SD_ATTR_KEY$3,
	type: NodeTranslator.translatorTypes.ATTRIBUTE,
	encode: encode$68,
	decode: decode$70,
	attributes: attributes_default$7
};
const translator$11 = NodeTranslator.from(config$40);
const translator$145 = NodeTranslator.from(createStrictTogglePropertyHandler("w:strike"));
const translator$62 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:dstrike"));
const translator$56 = NodeTranslator.from({
	xmlName: "w:color",
	sdNodeOrKeyName: "color",
	attributes: [
		createAttributeHandler("w:val"),
		createAttributeHandler("w:themeColor"),
		createAttributeHandler("w:themeTint"),
		createAttributeHandler("w:themeShade")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["color"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$132 = NodeTranslator.from({
	xmlName: "w:rFonts",
	sdNodeOrKeyName: "fontFamily",
	attributes: [
		createAttributeHandler("w:hint"),
		createAttributeHandler("w:ascii"),
		createAttributeHandler("w:hAnsi"),
		createAttributeHandler("w:eastAsia"),
		createAttributeHandler("w:cs"),
		createAttributeHandler("w:val"),
		createAttributeHandler("w:asciiTheme"),
		createAttributeHandler("w:hAnsiTheme"),
		createAttributeHandler("w:eastAsiaTheme"),
		createAttributeHandler("w:cstheme")
	],
	encode: (params, encodedAttrs) => {
		if (params.inlineDocumentFonts) {
			const font = encodedAttrs["ascii"];
			if (font) {
				if (!params.inlineDocumentFonts.includes(font)) params.inlineDocumentFonts.push(font);
			}
		}
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["fontFamily"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$134 = NodeTranslator.from(createSingleAttrPropertyHandler("w:rStyle", "styleId"));
const translator$153 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:sz", "fontSize"));
const translator$154 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:szCs", "fontSizeCs"));
const translator$54 = NodeTranslator.from({
	xmlName: "w:caps",
	sdNodeOrKeyName: "textTransform",
	encode: ({ nodes }) => parseBoolean(nodes[0].attributes?.["w:val"] ?? "1") ? "uppercase" : "none",
	decode: ({ node }) => node.attrs["textTransform"] != null ? {
		name: "w:caps",
		attributes: { "w:val": booleanToString(node.attrs["textTransform"] === "uppercase") }
	} : void 0
});
const translator$140 = NodeTranslator.from({
	xmlName: "w:shd",
	sdNodeOrKeyName: "shading",
	attributes: [
		"w:color",
		"w:fill",
		"w:themeColor",
		"w:themeFill",
		"w:themeFillShade",
		"w:themeFillTint",
		"w:themeShade",
		"w:themeTint",
		"w:val"
	].map((attr) => createAttributeHandler(attr)),
	encode: (params, encodedAttrs) => {
		return Object.keys(encodedAttrs).length > 0 ? encodedAttrs : void 0;
	},
	decode: function({ node }, context) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs.shading || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$93 = NodeTranslator.from({
	xmlName: "w:lang",
	sdNodeOrKeyName: "lang",
	attributes: [
		createAttributeHandler("w:val"),
		createAttributeHandler("w:eastAsia"),
		createAttributeHandler("w:bidi")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["lang"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$214 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:spacing", "letterSpacing"));
const translator$183 = NodeTranslator.from(createSingleAttrPropertyHandler("w:vertAlign"));
const translator$141 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:smallCaps"));
const translator$142 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:snapToGrid"));
const translator$66 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:emboss"));
const translator$82 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:imprint"));
const translator$110 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:noProof"));
const translator$119 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:oMath"));
const translator$120 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:outline"));
const translator$139 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:shadow"));
const translator$197 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:vanish"));
const translator$184 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:specVanish"));
const translator$64 = NodeTranslator.from(createSingleAttrPropertyHandler("w:effect"));
const translator$65 = NodeTranslator.from(createSingleAttrPropertyHandler("w:em"));
const translator$178 = NodeTranslator.from(createSingleAttrPropertyHandler("w:w"));
const translator$91 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:kern"));
const translator$128 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:position"));
const translator$69 = NodeTranslator.from({
	xmlName: "w:fitText",
	sdNodeOrKeyName: "fitText",
	attributes: [createIntegerAttributeHandler("w:val"), createIntegerAttributeHandler("w:id")],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["fitText"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$63 = NodeTranslator.from({
	xmlName: "w:eastAsianLayout",
	sdNodeOrKeyName: "eastAsianLayout",
	attributes: [
		createIntegerAttributeHandler("w:id"),
		createBooleanAttributeHandler("w:combine"),
		createAttributeHandler("w:combineBrackets"),
		createBooleanAttributeHandler("w:vert"),
		createBooleanAttributeHandler("w:vertCompress")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["eastAsianLayout"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$136 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:rtl"));
const translator$58 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:cs"));
const translator$80 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:iCs", "italicCs"));
const translator$198 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:webHidden"));
var XML_NAME$4 = "w14:ligatures";
var SD_KEY$4 = "ligatures";
function readVal$3(node) {
	return node?.attributes?.["w14:val"] ?? node?.attributes?.["w:val"];
}
const translator$215 = NodeTranslator.from({
	xmlName: XML_NAME$4,
	sdNodeOrKeyName: SD_KEY$4,
	encode: ({ nodes }) => {
		return readVal$3(nodes?.[0]) ?? void 0;
	},
	decode: ({ node }) => {
		const value = node?.attrs?.[SD_KEY$4];
		if (value == null) return void 0;
		return { attributes: { "w14:val": String(value) } };
	}
});
var XML_NAME$3 = "w14:numForm";
var SD_KEY$3 = "numForm";
function readVal$2(node) {
	return node?.attributes?.["w14:val"] ?? node?.attributes?.["w:val"];
}
const translator$216 = NodeTranslator.from({
	xmlName: XML_NAME$3,
	sdNodeOrKeyName: SD_KEY$3,
	encode: ({ nodes }) => {
		return readVal$2(nodes?.[0]) ?? void 0;
	},
	decode: ({ node }) => {
		const value = node?.attrs?.[SD_KEY$3];
		if (value == null) return void 0;
		return { attributes: { "w14:val": String(value) } };
	}
});
var XML_NAME$2 = "w14:numSpacing";
var SD_KEY$2 = "numSpacing";
function readVal$1(node) {
	return node?.attributes?.["w14:val"] ?? node?.attributes?.["w:val"];
}
const translator$217 = NodeTranslator.from({
	xmlName: XML_NAME$2,
	sdNodeOrKeyName: SD_KEY$2,
	encode: ({ nodes }) => {
		return readVal$1(nodes?.[0]) ?? void 0;
	},
	decode: ({ node }) => {
		const value = node?.attrs?.[SD_KEY$2];
		if (value == null) return void 0;
		return { attributes: { "w14:val": String(value) } };
	}
});
var XML_NAME$1 = "w14:stylisticSets";
var SD_KEY$1 = "stylisticSets";
var STYLISTIC_SET_CHILD_XML_NAME = "w14:ss";
function readAttr(attributes, key) {
	return attributes?.[`w14:${key}`] ?? attributes?.[`w:${key}`];
}
function encodeStylisticSet(node) {
	const id = parseInteger$1(readAttr(node?.attributes, "id"));
	if (id == null) return void 0;
	const valRaw = readAttr(node?.attributes, "val");
	const val = valRaw == null ? void 0 : parseBoolean(valRaw);
	return {
		id,
		...val === void 0 ? {} : { val }
	};
}
const translator$218 = NodeTranslator.from({
	xmlName: XML_NAME$1,
	sdNodeOrKeyName: SD_KEY$1,
	encode: ({ nodes }) => {
		const stylisticSetsNode = nodes?.[0];
		const encoded = (Array.isArray(stylisticSetsNode?.elements) ? stylisticSetsNode.elements : []).filter((child) => child?.name === STYLISTIC_SET_CHILD_XML_NAME).map(encodeStylisticSet).filter(Boolean);
		return encoded.length > 0 ? encoded : void 0;
	},
	decode: ({ node }) => {
		const values = node?.attrs?.[SD_KEY$1];
		if (!Array.isArray(values) || values.length === 0) return void 0;
		const elements = values.filter((entry) => Number.isFinite(entry?.id)).map((entry) => {
			const attributes = { "w14:id": String(entry.id) };
			if (entry.val !== void 0) attributes["w14:val"] = entry.val ? "1" : "0";
			return {
				name: STYLISTIC_SET_CHILD_XML_NAME,
				attributes
			};
		});
		if (elements.length === 0) return void 0;
		return {
			name: XML_NAME$1,
			attributes: {},
			elements
		};
	}
});
var XML_NAME = "w14:cntxtAlts";
var SD_KEY = "contextualAlternates";
function readVal(node) {
	return node?.attributes?.["w14:val"] ?? node?.attributes?.["w:val"];
}
const translator$219 = NodeTranslator.from({
	xmlName: XML_NAME,
	sdNodeOrKeyName: SD_KEY,
	encode: ({ nodes }) => {
		const rawValue = readVal(nodes?.[0]);
		if (rawValue == null) return true;
		return parseBoolean(rawValue);
	},
	decode: ({ node }) => {
		const value = node?.attrs?.[SD_KEY];
		if (value == null) return void 0;
		if (value === true) return { attributes: {} };
		return { attributes: { "w14:val": "0" } };
	}
});
const createTrackChangeRunPropertyTranslator = (xmlName, sdNodeOrKeyName) => NodeTranslator.from({
	xmlName,
	sdNodeOrKeyName,
	attributes: [
		createAttributeHandler("w:id", "id"),
		createAttributeHandler("w:author", "author"),
		createAttributeHandler("w:authorEmail", "authorEmail"),
		createAttributeHandler("w:date", "date")
	],
	encode: (_params, encodedAttrs = {}) => {
		return Object.keys(encodedAttrs).length ? encodedAttrs : void 0;
	},
	decode: function({ node }) {
		const source = node?.attrs?.[sdNodeOrKeyName];
		if (!source || typeof source !== "object") return;
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: source
		} });
		return Object.keys(decodedAttrs).length ? { attributes: decodedAttrs } : void 0;
	}
});
const propertyTranslators$16 = [
	translator$50,
	translator$46,
	translator$48,
	translator$54,
	translator$56,
	translator$58,
	translator$62,
	translator$63,
	translator$64,
	translator$65,
	translator$66,
	translator$69,
	translator$132,
	translator$154,
	translator$153,
	translator$2,
	translator$82,
	translator$79,
	translator$80,
	translator$91,
	translator$93,
	translator$214,
	translator$110,
	translator$119,
	translator$120,
	translator$128,
	translator$136,
	translator$134,
	translator$139,
	translator$140,
	translator$141,
	translator$142,
	translator$184,
	translator$145,
	translator$11,
	translator$197,
	translator$183,
	translator$215,
	translator$216,
	translator$217,
	translator$218,
	translator$219,
	createTrackChangeRunPropertyTranslator("w:ins", "trackInsert"),
	createTrackChangeRunPropertyTranslator("w:del", "trackDelete"),
	translator$198,
	translator$178
];
const translator$133 = NodeTranslator.from(createNestedPropertiesTranslator("w:rPr", "runProperties", propertyTranslators$16));
var XML_NODE_NAME$40 = "w:tab";
var SD_NODE_NAME$36 = "tab";
var encode$67 = (_, encodedAttrs = {}) => {
	const translated = { type: "tab" };
	if (encodedAttrs) translated.attrs = { ...encodedAttrs };
	return translated;
};
function decode$69(params, decodedAttrs = {}) {
	const { node } = params || {};
	if (!node) return;
	const wTab = {
		name: "w:tab",
		elements: []
	};
	if (node.attrs?.["tab"]) decodedAttrs = this.decodeAttributes({
		...params,
		node: {
			...node,
			attrs: node.attrs["tab"]
		}
	}, decodedAttrs);
	wTab.attributes = { ...decodedAttrs };
	if (params.extraParams?.skipRun) return wTab;
	const translated = {
		name: "w:r",
		elements: [wTab]
	};
	const { marks: nodeMarks = [] } = node;
	const markRunProperties = decodeRunPropertiesFromMarks$1(nodeMarks);
	const mergedRunProperties = mergeRunProperties$1(params.extraParams?.runProperties || {}, markRunProperties);
	const rPrNode = translator$133.decode({ node: {
		type: "runProperties",
		attrs: { runProperties: mergedRunProperties }
	} });
	if (rPrNode) translated.elements.unshift(rPrNode);
	return translated;
}
function mergeRunProperties$1(base$1 = {}, override = {}) {
	const merged = { ...base$1 };
	for (const [key, value] of Object.entries(override)) {
		if (value && typeof value === "object" && !Array.isArray(value) && base$1[key] && typeof base$1[key] === "object") {
			merged[key] = {
				...base$1[key],
				...value
			};
			continue;
		}
		merged[key] = value;
	}
	return merged;
}
function decodeRunPropertiesFromMarks$1(marks = []) {
	const runProperties = {};
	for (const mark of marks) {
		const type = mark?.type?.name ?? mark?.type;
		const attrs = mark?.attrs ?? {};
		switch (type) {
			case "bold":
			case "italic":
			case "strike":
				runProperties[type] = attrs.value !== "0" && attrs.value !== false;
				break;
			case "underline": {
				const underlineAttrs = {};
				if (attrs.underlineType) underlineAttrs["w:val"] = attrs.underlineType;
				if (attrs.underlineColor) underlineAttrs["w:color"] = String(attrs.underlineColor).replace("#", "");
				if (Object.keys(underlineAttrs).length > 0) runProperties.underline = underlineAttrs;
				break;
			}
			case "highlight":
				if (attrs.color) runProperties.highlight = String(attrs.color).toLowerCase() === "transparent" ? { "w:val": "none" } : { "w:val": attrs.color };
				break;
			case "link":
				runProperties.styleId = "Hyperlink";
				break;
			case "styleId":
				if (attrs.styleId != null) runProperties.styleId = attrs.styleId;
				break;
			case "textStyle":
				if (attrs.styleId != null) runProperties.styleId = attrs.styleId;
				if (attrs.textTransform != null) runProperties.textTransform = attrs.textTransform;
				if (attrs.color != null) runProperties.color = { val: String(attrs.color).replace("#", "") };
				if (attrs.fontSize != null) {
					const points = Number.parseFloat(String(attrs.fontSize));
					if (!Number.isNaN(points)) runProperties.fontSize = points * 2;
				}
				if (attrs.letterSpacing != null) {
					const ptValue = Number.parseFloat(String(attrs.letterSpacing));
					if (!Number.isNaN(ptValue)) runProperties.letterSpacing = ptValue * 20;
				}
				if (attrs.fontFamily != null) {
					const cleanValue = String(attrs.fontFamily).split(",")[0].trim();
					runProperties.fontFamily = {
						ascii: cleanValue,
						eastAsia: cleanValue,
						hAnsi: cleanValue,
						cs: cleanValue
					};
				}
				if (attrs.vertAlign != null) runProperties.vertAlign = attrs.vertAlign;
				if (attrs.position != null) {
					const numeric = Number.parseFloat(String(attrs.position));
					if (!Number.isNaN(numeric)) runProperties.position = numeric * 2;
				}
				break;
		}
	}
	return runProperties;
}
const config$39 = {
	xmlName: XML_NODE_NAME$40,
	sdNodeOrKeyName: SD_NODE_NAME$36,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$67,
	decode: decode$69,
	attributes: attributes_default$6
};
const translator$3 = NodeTranslator.from(config$39);
function generateDocxRandomId(length = 8) {
	return Math.floor(Math.random() * 2147483648).toString(16).toUpperCase().padStart(length, "0").slice(0, length);
}
function generateRandomSigned32BitIntStrId() {
	return Math.floor(Math.random() * 2147483647).toString();
}
var XML_NODE_NAME$39 = "w:hyperlink";
var SD_NODE_NAME$35 = "link";
var _createAttributeHandler$1 = (xmlName, sdName) => ({
	xmlName,
	sdName,
	encode: (attributes) => attributes[xmlName],
	decode: (attributes) => attributes[sdName]
});
var validXmlAttributes$13 = [
	_createAttributeHandler$1("w:anchor", "anchor"),
	_createAttributeHandler$1("w:docLocation", "docLocation"),
	{
		xmlName: "w:history",
		sdName: "history",
		encode: (attributes) => attributes["w:history"] == null ? null : attributes["w:history"] === "1" || attributes["w:history"] === "true",
		decode: (attributes) => attributes["history"] == null ? null : attributes["history"] ? "1" : "0"
	},
	_createAttributeHandler$1("w:tooltip", "tooltip"),
	_createAttributeHandler$1("r:id", "rId"),
	_createAttributeHandler$1("w:tgtFrame", "target")
];
var encode$66 = (params, encodedAttrs) => {
	const { nodes, docx, nodeListHandler } = params;
	const node = nodes[0];
	let href = _resolveHref(docx, encodedAttrs, params.filename);
	const linkMark = {
		type: "link",
		attrs: {
			...encodedAttrs,
			href
		}
	};
	const referenceNodeTypes = [
		"sd:pageReference",
		"sd:autoPageNumber",
		"sd:totalPageNumber"
	];
	const contentNodes = node.elements.filter((el) => el.name === "w:r" || referenceNodeTypes.includes(el.name));
	contentNodes.forEach((contentNode) => {
		contentNode.marks = [...(Array.isArray(contentNode.marks) ? contentNode.marks : []).filter((mark) => mark?.type !== "link"), linkMark];
	});
	return nodeListHandler.handler({
		...params,
		nodes: contentNodes,
		path: [...params.path || [], node]
	});
};
var _resolveHref = (docx, encodedAttrs, filename) => {
	let rels = docx?.[`word/_rels/${filename || "document.xml"}.rels`];
	if (!rels) rels = docx?.["word/_rels/document.xml.rels"];
	const elements = (rels?.elements?.find((el) => el.name === "Relationships"))?.elements || [];
	const { rId, anchor } = encodedAttrs;
	let href;
	if (!rId && anchor) href = `#${anchor}`;
	else if (rId) {
		const { attributes: relAttributes = {} } = elements.find((el) => el.attributes?.["Id"] === rId) || {};
		href = relAttributes["Target"];
	}
	return href;
};
function decode$68(params) {
	const { hyperlinkGroup = [params.node] } = params.extraParams || {};
	const linkMark = hyperlinkGroup[0].marks.find((m) => m.type === "link");
	const linkAttrs = this.decodeAttributes({
		...params,
		node: linkMark
	});
	let { href: link, anchor } = linkMark.attrs;
	if (!linkAttrs["r:id"] && !anchor) linkAttrs["r:id"] = _addNewLinkRelationship(params, link);
	let contentNodes = [];
	hyperlinkGroup.forEach((linkNode) => {
		if ("marks" in linkNode) linkNode.marks = linkNode.marks.filter((m) => m.type !== "link");
		else linkNode.attrs.marksAsAttrs = linkNode.attrs.marksAsAttrs.filter((m) => m.type !== "link");
		const outputNode = exportSchemaToJson({
			...params,
			node: linkNode
		});
		if (outputNode) if (outputNode instanceof Array) contentNodes.push(...outputNode);
		else contentNodes.push(outputNode);
	});
	return {
		name: "w:hyperlink",
		type: "element",
		attributes: { ...linkAttrs },
		elements: contentNodes
	};
}
function _addNewLinkRelationship(params, link) {
	let id = generateDocxRandomId();
	if (!params.relationships || !Array.isArray(params.relationships)) params.relationships = [];
	params.relationships.push({
		type: "element",
		name: "Relationship",
		attributes: {
			Id: `rId${id}`,
			Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
			Target: link,
			TargetMode: "External"
		}
	});
	return `rId${id}`;
}
const config$38 = {
	xmlName: XML_NODE_NAME$39,
	sdNodeOrKeyName: SD_NODE_NAME$35,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$66,
	decode: decode$68,
	attributes: validXmlAttributes$13
};
const translator$78 = NodeTranslator.from(config$38);
function createImportTrackingContext(options = {}) {
	const partPath = typeof options.partPath === "string" && options.partPath.length > 0 ? options.partPath : "word/document.xml";
	const replacements = options.replacements === "independent" ? "independent" : "paired";
	const stack = [];
	const diagnostics = Array.isArray(options.diagnostics) ? options.diagnostics : [];
	const knownLogicalIds = options.knownLogicalIds instanceof Map ? options.knownLogicalIds : /* @__PURE__ */ new Map();
	const reportDiagnostic = (d) => {
		if (!d || typeof d !== "object" || !d.code) return;
		diagnostics.push({
			...d,
			partPath: d.partPath || partPath
		});
	};
	return {
		partPath,
		replacements,
		parentStack: () => stack.slice(),
		currentParent: () => stack.length > 0 ? stack[stack.length - 1] : null,
		pushParent: (frame) => {
			if (!frame || typeof frame !== "object" || !frame.logicalId) return;
			stack.push({
				logicalId: String(frame.logicalId),
				side: frame.side,
				sourceId: typeof frame.sourceId === "string" ? frame.sourceId : "",
				author: typeof frame.author === "string" ? frame.author : "",
				date: typeof frame.date === "string" ? frame.date : ""
			});
		},
		popParent: () => (stack.length > 0 ? stack.pop() : null) ?? null,
		reportDiagnostic,
		diagnostics: () => diagnostics.slice(),
		recordLogicalId: (id, source) => {
			if (!id) return;
			const prior = knownLogicalIds.get(id);
			if (prior) {
				const priorSides = prior.sides instanceof Set ? prior.sides : new Set(prior.side ? [prior.side] : []);
				if (source?.side && priorSides.has(source.side)) reportDiagnostic({
					code: "IMPORT_DUPLICATE_LOGICAL_ID",
					partPath,
					logicalId: id,
					side: source.side
				});
				if (source?.side) priorSides.add(source.side);
				knownLogicalIds.set(id, {
					sourceId: prior.sourceId || source?.sourceId,
					side: prior.side || source?.side,
					sides: priorSides
				});
				return;
			}
			knownLogicalIds.set(id, {
				sourceId: source?.sourceId,
				side: source?.side,
				sides: source?.side ? new Set([source.side]) : /* @__PURE__ */ new Set()
			});
		},
		hasLogicalId: (id) => Boolean(id) && knownLogicalIds.has(id),
		forNestedPart: (nestedPartPath) => createImportTrackingContext({
			partPath: nestedPartPath,
			replacements,
			diagnostics,
			knownLogicalIds
		})
	};
}
function withParentFrame(ctx, frame, body) {
	ctx.pushParent(frame);
	try {
		return body();
	} finally {
		ctx.popParent();
	}
}
var contextsByConverter = /* @__PURE__ */ new WeakMap();
function resolveTrackedChangePartPath(params = {}) {
	const currentPartPath = params.currentPartPath;
	if (typeof currentPartPath === "string" && currentPartPath.length > 0) return currentPartPath;
	const filename = params.filename;
	if (typeof filename === "string" && filename.length > 0) return filename.startsWith("word/") ? filename : `word/${filename}`;
	return "word/document.xml";
}
function getTrackedChangeIdMapForPart(params = {}, partPath = resolveTrackedChangePartPath(params)) {
	const converter = params.converter;
	if (!converter || typeof converter !== "object") return null;
	return converter.trackedChangeIdMapsByPart?.get?.(partPath) ?? converter.trackedChangeIdMap ?? null;
}
function getTrackedChangeSourceIdForPart(params = {}, partPath = resolveTrackedChangePartPath(params), wordId = "") {
	const converter = params.converter;
	if (!converter || typeof converter !== "object") return null;
	const restored = converter.trackedChangeSourceIdMapByPart?.get?.(partPath)?.get?.(wordId);
	return typeof restored === "string" && restored.length > 0 ? restored : null;
}
function resolveTrackedChangeImportIds(params = {}, sourceId = "") {
	const partPath = resolveTrackedChangePartPath(params);
	const id = typeof sourceId === "string" ? sourceId : String(sourceId || "");
	const restoredSourceId = getTrackedChangeSourceIdForPart(params, partPath, id) ?? id;
	const trackedChangeIdMap = getTrackedChangeIdMapForPart(params, partPath);
	return {
		partPath,
		sourceId: restoredSourceId,
		logicalId: id && trackedChangeIdMap?.has(id) ? trackedChangeIdMap.get(id) ?? id : id
	};
}
function getOrCreateImportTrackingContext(params = {}, partPath = resolveTrackedChangePartPath(params)) {
	const supplied = params.importTrackingContext;
	if (supplied?.forNestedPart) return supplied.partPath === partPath ? supplied : supplied.forNestedPart(partPath);
	const converter = params.converter;
	const trackedChangesOptions = converter && typeof converter === "object" && converter.trackedChangesOptions ? converter.trackedChangesOptions : null;
	if (!converter || typeof converter !== "object") return createImportTrackingContext({
		partPath,
		replacements: trackedChangesOptions?.replacements ?? "paired"
	});
	let contextsByPart = contextsByConverter.get(converter);
	if (!contextsByPart) {
		contextsByPart = /* @__PURE__ */ new Map();
		contextsByConverter.set(converter, contextsByPart);
	}
	let context = contextsByPart.get(partPath);
	if (!context) {
		context = createImportTrackingContext({
			partPath,
			replacements: trackedChangesOptions?.replacements ?? "paired"
		});
		contextsByPart.set(partPath, context);
	}
	return context;
}
function stampImportTrackingAttrs(input) {
	const { params = {}, attrs, side, sourceId = "", partPath = resolveTrackedChangePartPath(params) } = input;
	const context = getOrCreateImportTrackingContext(params, partPath);
	if (!context) return {
		context: null,
		frame: null
	};
	const logicalId = typeof attrs.id === "string" ? attrs.id : String(attrs.id || "");
	const parent = context.currentParent();
	if (parent?.logicalId) attrs.overlapParentId = parent.logicalId;
	if (logicalId) context.recordLogicalId(logicalId, {
		sourceId,
		side
	});
	return {
		context,
		frame: logicalId ? {
			logicalId,
			side,
			sourceId,
			author: typeof attrs.author === "string" ? attrs.author : "",
			date: typeof attrs.date === "string" ? attrs.date : ""
		} : null
	};
}
var XML_NODE_NAME$38 = "w:ins";
var SD_ATTR_KEY$2 = "trackInsert";
var validXmlAttributes$12 = [
	createAttributeHandler("w:id", "id"),
	createAttributeHandler("w:date", "date"),
	createAttributeHandler("w:author", "author"),
	createAttributeHandler("w:authorEmail", "authorEmail")
];
var encode$65 = (params, encodedAttrs = {}) => {
	const { nodeListHandler, extraParams = {} } = params;
	const { node } = extraParams;
	const { partPath, sourceId, logicalId } = resolveTrackedChangeImportIds(params, encodedAttrs.id);
	encodedAttrs.id = logicalId;
	encodedAttrs.sourceId = sourceId;
	const { context, frame } = stampImportTrackingAttrs({
		params,
		attrs: encodedAttrs,
		side: "insertion",
		sourceId,
		partPath
	});
	const childParams = {
		...params,
		insideTrackChange: true,
		importTrackingContext: context ?? params.importTrackingContext,
		nodes: node.elements,
		path: [...params.path || [], node]
	};
	const subs = context && frame ? withParentFrame(context, frame, () => nodeListHandler.handler(childParams)) : nodeListHandler.handler(childParams);
	encodedAttrs.importedAuthor = `${encodedAttrs.author} (imported)`;
	const converter = params.converter;
	if (converter?.documentOrigin) encodedAttrs.origin = converter.documentOrigin;
	subs.forEach((subElement) => {
		subElement.marks = [];
		if (subElement?.content?.[0]) {
			if (subElement.content[0].marks === void 0) subElement.content[0].marks = [];
			if (subElement.content[0].type === "text") subElement.content[0].marks.push({
				type: "trackInsert",
				attrs: encodedAttrs
			});
		}
	});
	return subs;
};
function decode$67(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	const marks = Array.isArray(node.marks) ? node.marks : [];
	const trackedMark = marks.find((m) => m.type === "trackInsert");
	if (!trackedMark) return null;
	node.marks = marks.filter((m) => m.type !== "trackInsert");
	const translatedTextNode = exportSchemaToJson({
		...params,
		node
	});
	if (params.isFinalDoc) return translatedTextNode;
	return {
		name: "w:ins",
		attributes: {
			"w:id": resolveExportWordId$1(params, trackedMark.attrs),
			"w:author": trackedMark.attrs.author,
			"w:authorEmail": trackedMark.attrs.authorEmail,
			"w:date": trackedMark.attrs.date
		},
		elements: [translatedTextNode]
	};
}
function resolveExportWordId$1(params, attrs) {
	const sourceId = attrs?.sourceId;
	let exportSourceId;
	if (typeof sourceId === "string" || typeof sourceId === "number") exportSourceId = sourceId;
	else if (sourceId === null) exportSourceId = null;
	else if (sourceId === void 0) exportSourceId = void 0;
	else exportSourceId = String(sourceId);
	const logicalId = typeof attrs?.id === "string" ? attrs.id : "";
	const exportParams = params;
	const allocator = exportParams?.converter?.wordIdAllocator;
	const partPath = exportParams?.currentPartPath || (typeof exportParams?.filename === "string" && exportParams.filename.length > 0 ? `word/${exportParams.filename}` : "word/document.xml");
	if (allocator) return allocator.allocate({
		partPath,
		sourceId: exportSourceId,
		logicalId
	});
	return sourceId || logicalId;
}
const config$37 = {
	xmlName: XML_NODE_NAME$38,
	sdNodeOrKeyName: SD_ATTR_KEY$2,
	type: NodeTranslator.translatorTypes.ATTRIBUTE,
	encode: encode$65,
	decode: decode$67,
	attributes: validXmlAttributes$12
};
const translator$84 = NodeTranslator.from(config$37);
var XML_NODE_NAME$37 = "w:del";
var SD_ATTR_KEY$1 = "trackDelete";
var validXmlAttributes$11 = [
	createAttributeHandler("w:id", "id"),
	createAttributeHandler("w:date", "date"),
	createAttributeHandler("w:author", "author"),
	createAttributeHandler("w:authorEmail", "authorEmail")
];
var encode$64 = (params, encodedAttrs = {}) => {
	const { nodeListHandler, extraParams = {} } = params;
	const { node } = extraParams;
	const { partPath, sourceId, logicalId } = resolveTrackedChangeImportIds(params, encodedAttrs.id);
	encodedAttrs.id = logicalId;
	encodedAttrs.sourceId = sourceId;
	const { context, frame } = stampImportTrackingAttrs({
		params,
		attrs: encodedAttrs,
		side: "deletion",
		sourceId,
		partPath
	});
	const childParams = {
		...params,
		insideTrackChange: true,
		importTrackingContext: context ?? params.importTrackingContext,
		nodes: node.elements,
		path: [...params.path || [], node]
	};
	const subs = context && frame ? withParentFrame(context, frame, () => nodeListHandler.handler(childParams)) : nodeListHandler.handler(childParams);
	encodedAttrs.importedAuthor = `${encodedAttrs.author} (imported)`;
	const converter = params.converter;
	if (converter?.documentOrigin) encodedAttrs.origin = converter.documentOrigin;
	subs.forEach((subElement) => {
		subElement.marks = [];
		if (subElement?.content?.[0]) {
			if (subElement.content[0].marks === void 0) subElement.content[0].marks = [];
			if (subElement.content[0].type === "text") subElement.content[0].marks.push({
				type: "trackDelete",
				attrs: encodedAttrs
			});
		}
	});
	return subs;
};
function decode$66(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	const marks = Array.isArray(node.marks) ? node.marks : [];
	const trackedMark = marks.find((m) => m.type === "trackDelete");
	if (!trackedMark) return null;
	node.marks = marks.filter((m) => m.type !== "trackDelete");
	const translatedTextNode = exportSchemaToJson({
		...params,
		node
	});
	if (params.isFinalDoc) return null;
	(translatedTextNode.elements || []).filter((n) => n.name === "w:t").forEach((n) => {
		n.name = "w:delText";
	});
	return {
		name: "w:del",
		attributes: {
			"w:id": resolveExportWordId(params, trackedMark.attrs),
			"w:author": trackedMark.attrs.author,
			"w:authorEmail": trackedMark.attrs.authorEmail,
			"w:date": trackedMark.attrs.date
		},
		elements: [translatedTextNode]
	};
}
function resolveExportWordId(params, attrs) {
	const sourceId = attrs?.sourceId;
	let exportSourceId;
	if (typeof sourceId === "string" || typeof sourceId === "number") exportSourceId = sourceId;
	else if (sourceId === null) exportSourceId = null;
	else if (sourceId === void 0) exportSourceId = void 0;
	else exportSourceId = String(sourceId);
	const logicalId = typeof attrs?.id === "string" ? attrs.id : "";
	const exportParams = params;
	const allocator = exportParams?.converter?.wordIdAllocator;
	const partPath = exportParams?.currentPartPath || (typeof exportParams?.filename === "string" && exportParams.filename.length > 0 ? `word/${exportParams.filename}` : "word/document.xml");
	if (allocator) return allocator.allocate({
		partPath,
		sourceId: exportSourceId,
		logicalId
	});
	return sourceId || logicalId;
}
const config$36 = {
	xmlName: XML_NODE_NAME$37,
	sdNodeOrKeyName: SD_ATTR_KEY$1,
	type: NodeTranslator.translatorTypes.ATTRIBUTE,
	encode: encode$64,
	decode: decode$66,
	attributes: validXmlAttributes$11
};
const translator$59 = NodeTranslator.from(config$36);
var XML_NODE_NAME$36 = "w:noBreakHyphen";
var SD_NODE_NAME$34 = "noBreakHyphen";
var encode$63 = (_, encodedAttrs = {}) => {
	const translated = { type: SD_NODE_NAME$34 };
	if (encodedAttrs && Object.keys(encodedAttrs).length > 0) translated.attrs = { ...encodedAttrs };
	return translated;
};
function decode$65(params, decodedAttrs = {}) {
	const { node } = params || {};
	if (!node) return;
	const trackedMark = node.marks?.find((m) => {
		const t = m?.type?.name ?? m?.type;
		return t === "trackInsert" || t === "trackDelete";
	});
	if (trackedMark) return ((trackedMark.type?.name ?? trackedMark.type) === "trackInsert" ? translator$84 : translator$59).decode(params);
	if (node.marks?.some((m) => (m?.type?.name ?? m?.type) === "link") && !params.extraParams?.linkProcessed) return translator$78.decode(params);
	const wNoBreakHyphen = {
		name: "w:noBreakHyphen",
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length > 0) wNoBreakHyphen.attributes = { ...decodedAttrs };
	if (params.extraParams?.skipRun) return wNoBreakHyphen;
	const translated = {
		name: "w:r",
		elements: [wNoBreakHyphen]
	};
	const { marks: nodeMarks = [] } = node;
	const markRunProperties = decodeRunPropertiesFromMarks(nodeMarks);
	const mergedRunProperties = mergeRunProperties(params.extraParams?.runProperties || {}, markRunProperties);
	const rPrNode = translator$133.decode({ node: {
		type: "runProperties",
		attrs: { runProperties: mergedRunProperties }
	} });
	if (rPrNode) translated.elements.unshift(rPrNode);
	return translated;
}
function mergeRunProperties(base$1 = {}, override = {}) {
	const merged = { ...base$1 };
	for (const [key, value] of Object.entries(override)) {
		if (value && typeof value === "object" && !Array.isArray(value) && base$1[key] && typeof base$1[key] === "object") {
			merged[key] = {
				...base$1[key],
				...value
			};
			continue;
		}
		merged[key] = value;
	}
	return merged;
}
function decodeRunPropertiesFromMarks(marks = []) {
	const runProperties = {};
	for (const mark of marks) {
		const type = mark?.type?.name ?? mark?.type;
		const attrs = mark?.attrs ?? {};
		switch (type) {
			case "bold":
			case "italic":
			case "strike":
				runProperties[type] = attrs.value !== "0" && attrs.value !== false;
				break;
			case "underline": {
				const underlineAttrs = {};
				if (attrs.underlineType) underlineAttrs["w:val"] = attrs.underlineType;
				if (attrs.underlineColor) underlineAttrs["w:color"] = String(attrs.underlineColor).replace("#", "");
				if (Object.keys(underlineAttrs).length > 0) runProperties.underline = underlineAttrs;
				break;
			}
			case "highlight":
				if (attrs.color) runProperties.highlight = String(attrs.color).toLowerCase() === "transparent" ? { "w:val": "none" } : { "w:val": attrs.color };
				break;
			case "link":
				runProperties.styleId = "Hyperlink";
				break;
			case "styleId":
				if (attrs.styleId != null) runProperties.styleId = attrs.styleId;
				break;
			case "textStyle":
				if (attrs.styleId != null) runProperties.styleId = attrs.styleId;
				if (attrs.textTransform != null) runProperties.textTransform = attrs.textTransform;
				if (attrs.color != null) runProperties.color = { val: String(attrs.color).replace("#", "") };
				if (attrs.fontSize != null) {
					const points = Number.parseFloat(String(attrs.fontSize));
					if (!Number.isNaN(points)) runProperties.fontSize = points * 2;
				}
				if (attrs.letterSpacing != null) {
					const ptValue = Number.parseFloat(String(attrs.letterSpacing));
					if (!Number.isNaN(ptValue)) runProperties.letterSpacing = ptValue * 20;
				}
				if (attrs.fontFamily != null) {
					const cleanValue = String(attrs.fontFamily).split(",")[0].trim();
					runProperties.fontFamily = {
						ascii: cleanValue,
						eastAsia: cleanValue,
						hAnsi: cleanValue,
						cs: cleanValue
					};
				}
				if (attrs.vertAlign != null) runProperties.vertAlign = attrs.vertAlign;
				if (attrs.position != null) {
					const numeric = Number.parseFloat(String(attrs.position));
					if (!Number.isNaN(numeric)) runProperties.position = numeric * 2;
				}
				break;
		}
	}
	return runProperties;
}
const config$35 = {
	xmlName: XML_NODE_NAME$36,
	sdNodeOrKeyName: SD_NODE_NAME$34,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$63,
	decode: decode$65,
	attributes: []
};
const translator$4 = NodeTranslator.from(config$35);
const EAST_ASIAN_CHARACTER_REGEX = /[\u1100-\u11FF\u2E80-\u2EFF\u2F00-\u2FDF\u3040-\u30FF\u3100-\u312F\u3130-\u318F\u31A0-\u31BF\u3400-\u4DBF\u4E00-\u9FFF\uA960-\uA97F\uAC00-\uD7AF\uF900-\uFAFF\uFF00-\uFFEF]/u;
var containsEastAsianCharacters = (text$2) => EAST_ASIAN_CHARACTER_REGEX.test(text$2);
const resolveFontFamily$1 = (textStyleAttrs, text$2) => {
	if (!text$2) return textStyleAttrs;
	const eastAsiaFont = textStyleAttrs?.eastAsiaFontFamily;
	if (!(eastAsiaFont || textStyleAttrs?.csFontFamily)) return textStyleAttrs;
	const normalized = { ...textStyleAttrs };
	delete normalized.eastAsiaFontFamily;
	delete normalized.csFontFamily;
	if (!(typeof text$2 === "string" && containsEastAsianCharacters(text$2))) return normalized;
	return {
		...normalized,
		fontFamily: eastAsiaFont
	};
};
const cloneMark = (mark) => {
	if (!mark || typeof mark !== "object") return mark;
	const cloned = { ...mark };
	if (mark.attrs && typeof mark.attrs === "object") {
		cloned.attrs = { ...mark.attrs };
		if (Array.isArray(mark.attrs.runProperties)) cloned.attrs.runProperties = mark.attrs.runProperties.map((entry) => ({
			xmlName: entry?.xmlName,
			attributes: { ...entry?.attributes || {} }
		}));
	}
	return cloned;
};
const cloneXmlNode = (nodeLike) => {
	if (!nodeLike || typeof nodeLike !== "object") return nodeLike;
	return {
		name: nodeLike.name,
		type: nodeLike.type,
		attributes: nodeLike.attributes ? { ...nodeLike.attributes } : void 0,
		elements: Array.isArray(nodeLike.elements) ? nodeLike.elements.map((el) => cloneXmlNode(el)) : void 0,
		text: nodeLike.text
	};
};
const applyRunPropertiesTemplate = (runNode, runPropertiesTemplate) => {
	if (!runNode || !runPropertiesTemplate) return;
	if (!Array.isArray(runNode.elements)) runNode.elements = [];
	let runProps = runNode.elements.find((el) => el?.name === "w:rPr");
	if (!runProps) {
		runProps = {
			name: "w:rPr",
			elements: []
		};
		runNode.elements.unshift(runProps);
	}
	if (!Array.isArray(runProps.elements)) runProps.elements = [];
	if (runPropertiesTemplate.attributes) runProps.attributes = {
		...runProps.attributes || {},
		...runPropertiesTemplate.attributes
	};
	const isValidRunPropName = (name) => typeof name === "string" && name.includes(":");
	runProps.elements = runProps.elements.filter((entry) => isValidRunPropName(entry?.name));
	const existingNames = new Set(runProps.elements.map((el) => el?.name));
	(runPropertiesTemplate.elements || []).forEach((entry) => {
		if (!isValidRunPropName(entry?.name) || existingNames.has(entry.name)) return;
		runProps.elements.push(cloneXmlNode(entry));
		existingNames.add(entry.name);
	});
};
var XML_NODE_NAME$35 = "w:smartTag";
var SD_NODE_NAME$33 = "smartTag";
var _createAttributeHandler = (xmlName, sdName) => ({
	xmlName,
	sdName,
	encode: (attributes) => attributes[xmlName],
	decode: (attributes) => attributes[sdName]
});
var validXmlAttributes$10 = [_createAttributeHandler("w:element", "element"), _createAttributeHandler("w:uri", "uri")];
function encode$62(params, encodedAttrs = {}) {
	const { nodes, nodeListHandler } = params;
	const node = nodes[0];
	const elements = Array.isArray(node?.elements) ? node.elements : [];
	let smartTagPr = null;
	const visibleChildren = [];
	for (const child of elements) {
		if (child?.name === "w:smartTagPr") {
			smartTagPr = cloneXmlNode(child);
			continue;
		}
		visibleChildren.push(child);
	}
	return {
		type: SD_NODE_NAME$33,
		content: visibleChildren.length > 0 ? nodeListHandler.handler({
			...params,
			nodes: visibleChildren,
			path: [...params.path || [], node]
		}) || [] : [],
		attrs: {
			element: encodedAttrs.element ?? null,
			uri: encodedAttrs.uri ?? null,
			smartTagPr
		}
	};
}
function decode$64(params, decodedAttrs = {}) {
	const { node } = params || {};
	if (!node) return null;
	const childContent = translateChildNodes({
		...params,
		node
	});
	const childElements = Array.isArray(childContent) ? childContent : childContent ? [childContent] : [];
	const elements = [];
	const smartTagPr = node.attrs?.smartTagPr;
	if (smartTagPr) elements.push(cloneXmlNode(smartTagPr));
	elements.push(...childElements);
	return {
		name: "w:smartTag",
		attributes: { ...decodedAttrs },
		elements
	};
}
const config$1 = {
	xmlName: XML_NODE_NAME$35,
	sdNodeOrKeyName: SD_NODE_NAME$33,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$62,
	decode: decode$64,
	attributes: validXmlAttributes$10
};
const translator$5 = NodeTranslator.from(config$1);
const carbonCopy = (obj) => {
	if (!obj) return void 0;
	try {
		return JSON.parse(JSON.stringify(obj));
	} catch (e) {
		console.error("Error in carbonCopy", obj, e);
		return;
	}
};
const mergeTextNodes = (nodes) => {
	if (!nodes || !Array.isArray(nodes)) return nodes;
	let mergedNodes = [];
	let prevTextNode = null;
	for (let node of nodes) if (node.type === "text") if (prevTextNode && canMergeTextNodes(prevTextNode, node)) prevTextNode = {
		...prevTextNode,
		text: prevTextNode.text += node.text
	};
	else {
		if (prevTextNode) mergedNodes.push(prevTextNode);
		prevTextNode = { ...node };
	}
	else {
		if (prevTextNode) {
			mergedNodes.push(prevTextNode);
			prevTextNode = null;
		}
		mergedNodes.push(node);
	}
	if (prevTextNode) mergedNodes.push(prevTextNode);
	return mergedNodes;
};
var canMergeTextNodes = (nodeA, nodeB) => {
	if (!nodeA || !nodeB) return false;
	let marksA = nodeA.marks ?? [];
	let marksB = nodeB.marks ?? [];
	if (marksA.length !== marksB.length) return false;
	for (let i$1 = 0; i$1 < marksA.length; i$1++) {
		if (!marksA[i$1].attrs) marksA[i$1].attrs = {};
		if (!marksB[i$1].attrs) marksB[i$1].attrs = {};
		if (marksA[i$1].type !== marksB[i$1].type || Object.keys(marksA[i$1].attrs).length !== Object.keys(marksB[i$1].attrs).length || !areAttrsEqual(marksA[i$1].attrs, marksB[i$1].attrs)) return false;
	}
	return true;
};
var areAttrsEqual = (attrsA = {}, attrsB = {}) => {
	return objectIncludes(attrsA, attrsB);
};
const TrackInsertMarkName = "trackInsert";
const TrackDeleteMarkName = "trackDelete";
const TrackFormatMarkName = "trackFormat";
const TrackedFormatMarkNames = [
	"bold",
	"italic",
	"strike",
	"underline",
	"textStyle",
	"highlight",
	"link"
];
function getUnderlineCssString({ type = "single", color = null, thickness = null, approximate = true } = {}) {
	const parts = [];
	const add = (k, v) => {
		if (!v) return;
		parts.push(`${k}: ${v}`);
	};
	const lower = String(type || "single").toLowerCase();
	if (lower === "none" || lower === "0") {
		add("text-decoration", "none");
		return parts.join("; ");
	}
	add("text-decoration-line", "underline");
	const HEAVY = thickness || "0.2em";
	const THICK = thickness || "0.15em";
	switch (lower) {
		case "single": break;
		case "double":
			add("text-decoration-style", "double");
			break;
		case "thick":
			add("text-decoration-thickness", THICK);
			break;
		case "dotted":
			add("text-decoration-style", "dotted");
			break;
		case "dash":
		case "dashed":
			add("text-decoration-style", "dashed");
			break;
		case "dotdash":
		case "dotdotdash":
		case "dashlong":
		case "dashlongheavy":
			if (approximate) {
				add("text-decoration-style", "dashed");
				if (lower.includes("heavy")) add("text-decoration-thickness", HEAVY);
			}
			break;
		case "dottedheavy":
			add("text-decoration-style", "dotted");
			add("text-decoration-thickness", HEAVY);
			break;
		case "dashedheavy":
			add("text-decoration-style", "dashed");
			add("text-decoration-thickness", HEAVY);
			break;
		case "wavy":
			add("text-decoration-style", "wavy");
			break;
		case "wavyheavy":
			add("text-decoration-style", "wavy");
			add("text-decoration-thickness", HEAVY);
			break;
		case "wavydouble":
			if (approximate) {
				add("text-decoration-style", "wavy");
				add("text-decoration-thickness", HEAVY);
			}
			break;
		case "words": break;
		default: break;
	}
	if (color) add("text-decoration-color", color);
	return parts.join("; ");
}
var TAB_POSITION_TOLERANCE_TWIPS = 20;
function computeTabStops(context) {
	const { explicitStops, defaultTabInterval, paragraphIndent, rawParagraphIndent } = context;
	const leftIndent = paragraphIndent.left ?? 0;
	const hanging = paragraphIndent.hanging ?? 0;
	const rawLeftIndent = rawParagraphIndent?.left ?? leftIndent;
	const rawHanging = rawParagraphIndent?.hanging ?? hanging;
	const effectiveMinIndent = Math.max(0, leftIndent - hanging);
	const clearPositions = explicitStops.filter((stop) => stop.val === "clear").map((stop) => stop.pos);
	const filteredExplicitStops = explicitStops.filter((stop) => stop.val !== "clear").filter((stop) => stop.pos >= effectiveMinIndent).map((stop) => ({
		...stop,
		source: "explicit"
	}));
	const maxExplicit = filteredExplicitStops.reduce((max, stop) => Math.max(max, stop.pos), 0);
	const stops = [...filteredExplicitStops];
	const hasStartAlignedExplicit = filteredExplicitStops.some((stop) => stop.val === "start");
	const hasExplicitStops = filteredExplicitStops.length > 0;
	const hasClearAtPosition = (position) => clearPositions.some((clearPos) => Math.abs(clearPos - position) < TAB_POSITION_TOLERANCE_TWIPS);
	const hasClearAtLeftIndent = clearPositions.some((clearPos) => Math.abs(clearPos - leftIndent) < TAB_POSITION_TOLERANCE_TWIPS);
	if (!hasExplicitStops && !hasClearAtLeftIndent && hanging > 0 && leftIndent > effectiveMinIndent) stops.push({
		val: "start",
		pos: leftIndent,
		leader: "none",
		source: "default"
	});
	const firstLineOrigin = rawLeftIndent - rawHanging;
	if (firstLineOrigin < 0 && !hasClearAtPosition(0) && !stops.some((stop) => Math.abs(stop.pos) < TAB_POSITION_TOLERANCE_TWIPS)) stops.push({
		val: "start",
		pos: 0,
		leader: "none",
		source: "default"
	});
	const leftIndentStop = Math.abs(rawLeftIndent);
	if (rawHanging > 0 && leftIndentStop > 0 && firstLineOrigin < leftIndentStop && !hasClearAtPosition(leftIndentStop) && !stops.some((stop) => Math.abs(stop.pos - leftIndentStop) < TAB_POSITION_TOLERANCE_TWIPS)) stops.push({
		val: "start",
		pos: leftIndentStop,
		leader: "none",
		source: "default"
	});
	const defaultStart = !hasStartAlignedExplicit ? 0 : Math.max(maxExplicit, leftIndent);
	let pos = defaultStart;
	const targetLimit = Math.max(defaultStart, leftIndent, maxExplicit) + 14400;
	while (pos < targetLimit) {
		pos += defaultTabInterval;
		const hasExistingStop = stops.some((s) => Math.abs(s.pos - pos) < TAB_POSITION_TOLERANCE_TWIPS);
		const hasClearStop = clearPositions.some((clearPos) => Math.abs(clearPos - pos) < TAB_POSITION_TOLERANCE_TWIPS);
		if (!hasExistingStop && !hasClearStop && pos >= leftIndent) stops.push({
			val: "start",
			pos,
			leader: "none",
			source: "default"
		});
	}
	return stops.sort((a, b) => a.pos - b.pos);
}
function layoutWithTabs(runs, stops, lineWidth, options = {}) {
	const result = [];
	let currentX = 0;
	let currentStopIndex = 0;
	let pendingDecimalStop;
	let pendingCenterStop;
	let pendingEndStop;
	const decimalSeparator = options.decimalSeparator ?? ".";
	for (const entry of runs) {
		const { run: run$1, width, isTab } = entry;
		if (isTab) {
			while (currentStopIndex < stops.length && stops[currentStopIndex].pos <= currentX) currentStopIndex++;
			if (currentStopIndex < stops.length) {
				const stop = stops[currentStopIndex];
				result.push({
					run: run$1,
					x: currentX,
					width: 0,
					tabStop: stop
				});
				currentX = stop.pos;
				pendingDecimalStop = stop.val === "decimal" ? stop : void 0;
				pendingCenterStop = stop.val === "center" ? stop : void 0;
				pendingEndStop = stop.val === "end" ? stop : void 0;
				currentStopIndex++;
			} else {
				result.push({
					run: run$1,
					x: currentX,
					width
				});
				currentX += width;
				pendingDecimalStop = void 0;
				pendingCenterStop = void 0;
				pendingEndStop = void 0;
			}
		} else {
			if (pendingDecimalStop) {
				currentX = computeDecimalAlignedX(entry, pendingDecimalStop, options, decimalSeparator);
				pendingDecimalStop = void 0;
			} else if (pendingCenterStop) {
				currentX = computeCenterAlignedX(entry, pendingCenterStop);
				pendingCenterStop = void 0;
			} else if (pendingEndStop) {
				currentX = computeEndAlignedX(entry, pendingEndStop);
				pendingEndStop = void 0;
			}
			result.push({
				run: run$1,
				x: currentX,
				width
			});
			currentX += width;
		}
	}
	return result;
}
function computeDecimalAlignedX(entry, stop, options, separator) {
	const text$2 = entry.text ?? "";
	const decimalIndex = text$2.indexOf(separator);
	if (decimalIndex <= 0) return stop.pos;
	const beforeText = text$2.slice(0, decimalIndex);
	let beforeWidth;
	if (options.measureTextWidth) beforeWidth = options.measureTextWidth(entry.run, beforeText);
	else if (text$2.length > 0) beforeWidth = entry.width * decimalIndex / text$2.length;
	else beforeWidth = 0;
	const targetX = stop.pos - beforeWidth;
	return targetX < 0 ? 0 : targetX;
}
function computeCenterAlignedX(entry, stop) {
	const width = entry.width;
	const targetX = stop.pos - width / 2;
	return targetX < 0 ? 0 : targetX;
}
function computeEndAlignedX(entry, stop) {
	const width = entry.width;
	const targetX = stop.pos - width;
	return targetX < 0 ? 0 : targetX;
}
function calculateTabWidth(params) {
	const { currentX, tabStops, paragraphWidth, defaultTabDistance, defaultLineLength, followingText = "", measureText, decimalSeparator = "." } = params;
	const nextStop = tabStops.find((stop) => stop.val !== "clear" && stop.pos > currentX);
	const fallbackWidth = () => {
		let tabWidth = defaultTabDistance - currentX % defaultLineLength % defaultTabDistance;
		if (tabWidth <= 0) tabWidth = defaultTabDistance;
		return {
			width: tabWidth,
			alignment: "default",
			tabStopPosUsed: "default"
		};
	};
	if (!nextStop) return fallbackWidth();
	let width = Math.min(nextStop.pos, paragraphWidth) - currentX;
	const alignment = nextStop.val;
	if (alignment === "bar") return {
		width: 0,
		leader: nextStop.leader,
		alignment,
		tabStopPosUsed: nextStop.pos
	};
	if (alignment === "center" || alignment === "end") {
		const textWidth = measureText ? measureText(followingText) : 0;
		if (alignment === "center") width -= textWidth / 2;
		else width -= textWidth;
	} else if (alignment === "decimal") {
		const decimalIndex = followingText.indexOf(decimalSeparator);
		if (decimalIndex >= 0) {
			const before = followingText.slice(0, decimalIndex);
			const beforeWidth = measureText ? measureText(before) : 0;
			width -= beforeWidth;
		}
	}
	if (width < 1) return fallbackWidth();
	return {
		width,
		leader: nextStop.leader,
		alignment,
		tabStopPosUsed: nextStop.pos
	};
}
function getParagraphInlineDirection(attrs) {
	const fromContext = attrs?.directionContext?.inlineDirection;
	if (fromContext != null) return fromContext;
	const ppRtl = attrs?.paragraphProperties?.rightToLeft;
	if (ppRtl === true) return "rtl";
	if (ppRtl === false) return "ltr";
}
function getTableVisualDirection(attrs) {
	const fromContext = attrs?.tableDirectionContext?.visualDirection;
	if (fromContext != null) return fromContext;
	const tp = attrs?.tableProperties;
	if (tp?.rightToLeft === true || tp?.bidiVisual === true) return "rtl";
	if (tp?.rightToLeft === false || tp?.bidiVisual === false) return "ltr";
}
const OOXML_PCT_DIVISOR = 5e3;
function resolveTableWidthAttr(value) {
	if (!value || typeof value !== "object") return null;
	const measurement = value;
	const width = measurement.width ?? measurement.value;
	if (typeof width !== "number" || !Number.isFinite(width) || width <= 0) return null;
	return {
		width,
		type: measurement.type
	};
}
function resolveColumnWidths(columns, availableWidth) {
	const width = availableWidth / columns.length;
	return columns.map(() => width);
}
function measureRowHeights(cells, _columnWidths) {
	return cells.map(() => 20);
}
function effectiveTableCellSpacing(spacing, isBoundary, padding) {
	if (typeof spacing !== "number" || spacing <= 0) return 0;
	return isBoundary ? Math.max(0, spacing - padding) : spacing;
}
function selectHeaderFooterVariantForPage({ documentPageNumber, sectionPageNumber, titlePg, alternateHeaders }) {
	if (!Number.isFinite(documentPageNumber) || !Number.isFinite(sectionPageNumber)) return null;
	if (sectionPageNumber < 1) return null;
	if (sectionPageNumber === 1 && titlePg === true) return "first";
	if (alternateHeaders === true) return documentPageNumber % 2 === 0 ? "even" : "odd";
	return "default";
}
function candidateVariantsFor(variant) {
	return variant === "odd" ? ["odd", "default"] : [variant];
}
function sectionRefsFor(section, kind) {
	return kind === "header" ? section?.headerRefs : section?.footerRefs;
}
function resolveEffectiveHeaderFooterRef({ sections, sectionIndex, kind, variant }) {
	if (sectionIndex < 0) return null;
	const sectionsByIndex = /* @__PURE__ */ new Map();
	for (const section of sections) sectionsByIndex.set(section.sectionIndex, section);
	const candidates = candidateVariantsFor(variant);
	for (let currentIndex = sectionIndex; currentIndex >= 0; currentIndex -= 1) {
		const refs = sectionRefsFor(sectionsByIndex.get(currentIndex), kind);
		if (!refs) continue;
		for (const candidate of candidates) {
			const refId = refs[candidate];
			if (refId) return {
				refId,
				matchedSectionIndex: currentIndex,
				matchedVariant: candidate
			};
		}
	}
	return null;
}
function rescaleColumnWidths(measureColumnWidths, measureTotalWidth, fragmentWidth) {
	if (!measureColumnWidths || measureColumnWidths.length === 0 || measureTotalWidth <= fragmentWidth || measureTotalWidth <= 0) return;
	const scale = fragmentWidth / measureTotalWidth;
	const scaled = measureColumnWidths.map((w) => Math.max(1, Math.round(w * scale)));
	const scaledSum = scaled.reduce((a, b) => a + b, 0);
	const target = Math.round(fragmentWidth);
	if (scaledSum !== target && scaled.length > 0) scaled[scaled.length - 1] = Math.max(1, scaled[scaled.length - 1] + (target - scaledSum));
	return scaled;
}
var TWIPS_PER_PX = 15;
function getCellSpacingPx(cellSpacing) {
	if (cellSpacing == null) return 0;
	if (typeof cellSpacing === "number") return Math.max(0, cellSpacing);
	const v = cellSpacing.value;
	if (typeof v !== "number" || !Number.isFinite(v)) return 0;
	const asPx = (cellSpacing.type ?? "").toLowerCase() === "dxa" && v >= 20 ? v / TWIPS_PER_PX : v;
	return Math.max(0, asPx);
}
const isPlainObject$3 = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const OOXML_Z_INDEX_BASE = 251658240;
function coerceRelativeHeight(raw) {
	if (typeof raw === "number" && Number.isFinite(raw)) return raw;
	if (typeof raw === "string" && raw.trim() !== "") {
		const n = Number(raw);
		if (Number.isFinite(n)) return n;
	}
}
function normalizeZIndex(originalAttributes) {
	if (!isPlainObject$3(originalAttributes)) return void 0;
	const relativeHeight = coerceRelativeHeight(originalAttributes.relativeHeight);
	if (relativeHeight === void 0) return void 0;
	return Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE);
}
function resolveFloatingZIndex(behindDoc, raw, fallback = 1) {
	if (behindDoc) return 0;
	if (raw === void 0) return Math.max(1, fallback);
	return Math.max(1, raw);
}
function getFragmentZIndex(block) {
	const attrs = block.attrs;
	const raw = typeof block.zIndex === "number" ? block.zIndex : normalizeZIndex(attrs?.originalAttributes);
	return resolveFloatingZIndex(block.anchor?.behindDoc === true, raw);
}
const SPACE_CHARS = new Set([" ", "\xA0"]);
function shouldApplyJustify(params) {
	const { alignment, hasExplicitPositioning, hasExplicitTabStops, isLastLineOfParagraph, paragraphEndsWithLineBreak, skipJustifyOverride } = params;
	const lineHasExplicitTabStops = hasExplicitTabStops ?? hasExplicitPositioning ?? false;
	if (alignment !== "justify" && alignment !== "both") return false;
	if (skipJustifyOverride === true) return false;
	if (lineHasExplicitTabStops) return false;
	if (isLastLineOfParagraph && !paragraphEndsWithLineBreak) return false;
	return true;
}
function getFirstLineIndentOffset(indent, suppressFirstLineIndent) {
	if (suppressFirstLineIndent) return 0;
	return (indent?.firstLine ?? 0) - (indent?.hanging ?? 0);
}
function adjustAvailableWidthForTextIndent(availableWidth, textIndentOffset, lineMaxWidth) {
	if (textIndentOffset !== 0 && (textIndentOffset < 0 || lineMaxWidth == null)) return Math.max(0, availableWidth - textIndentOffset);
	return availableWidth;
}
function calculateJustifySpacing(params) {
	const { lineWidth, availableWidth, spaceCount, shouldJustify } = params;
	if (!shouldJustify) return 0;
	if (spaceCount <= 0) return 0;
	return (availableWidth - lineWidth) / spaceCount;
}
function parseInsetClipPathForScale(clipPath) {
	const m = clipPath.trim().match(/^inset\(\s*(\d+(?:\.\d+)?|\.\d+)%\s+(\d+(?:\.\d+)?|\.\d+)%\s+(\d+(?:\.\d+)?|\.\d+)%\s+(\d+(?:\.\d+)?|\.\d+)%\s*\)$/);
	if (!m) return null;
	const top = Number(m[1]);
	const right = Number(m[2]);
	const bottom = Number(m[3]);
	const left = Number(m[4]);
	if (![
		top,
		right,
		bottom,
		left
	].every(Number.isFinite)) return null;
	const visibleW = 100 - left - right;
	const visibleH = 100 - top - bottom;
	if (visibleW <= 0 || visibleH <= 0) return null;
	const scaleX = 100 / visibleW;
	const scaleY = 100 / visibleH;
	return {
		scaleX,
		scaleY,
		translateX: -left * scaleX,
		translateY: -top * scaleY
	};
}
function formatInsetClipPathTransform(clipPath) {
	const scale = parseInsetClipPathForScale(clipPath);
	if (!scale) return void 0;
	return `transform-origin: 0 0; transform: translate(${scale.translateX}%, ${scale.translateY}%) scale(${scale.scaleX}, ${scale.scaleY});`;
}
const SUBSCRIPT_SUPERSCRIPT_SCALE = .65;
var BASELINE_SHIFT_EPSILON = 1e-6;
function normalizeBaselineShift(baselineShift) {
	if (!Number.isFinite(baselineShift)) return;
	const normalizedShift = baselineShift;
	return Math.abs(normalizedShift) <= BASELINE_SHIFT_EPSILON ? void 0 : normalizedShift;
}
function hasExplicitBaselineShift(baselineShift) {
	return normalizeBaselineShift(baselineShift) != null;
}
function isSuperscriptOrSubscript(vertAlign) {
	return vertAlign === "superscript" || vertAlign === "subscript";
}
function usesDefaultScriptLayout(formatting) {
	return isSuperscriptOrSubscript(formatting.vertAlign) && !hasExplicitBaselineShift(formatting.baselineShift);
}
function scaleFontSizeForVerticalText(fontSize, formatting) {
	if (!Number.isFinite(fontSize)) return fontSize;
	return usesDefaultScriptLayout(formatting) ? fontSize * SUBSCRIPT_SUPERSCRIPT_SCALE : fontSize;
}
function resolveBaseFontSizeForVerticalText(fontSize, formatting) {
	if (!Number.isFinite(fontSize)) return fontSize;
	return usesDefaultScriptLayout(formatting) ? fontSize / SUBSCRIPT_SUPERSCRIPT_SCALE : fontSize;
}
function isEmptySdtPlaceholderRun(run$1) {
	return (run$1.kind === "text" || run$1.kind === void 0) && "text" in run$1 && (run$1.visualPlaceholder === "emptyInlineSdt" || run$1.visualPlaceholder === "emptyBlockSdt");
}
function isEmptyInlineSdtPlaceholderRun(run$1) {
	return isEmptySdtPlaceholderRun(run$1) && run$1.visualPlaceholder === "emptyInlineSdt";
}
function expandRunsForInlineNewlines(runs) {
	const result = [];
	for (const run$1 of runs) {
		const textRun = run$1;
		if ("text" in run$1 && typeof textRun.text === "string" && textRun.text.includes("\n")) {
			const segments = textRun.text.split("\n");
			let cursor = textRun.pmStart ?? 0;
			segments.forEach((segment, idx) => {
				if (segment.length > 0) {
					result.push({
						...textRun,
						text: segment,
						pmStart: cursor,
						pmEnd: cursor + segment.length
					});
					cursor += segment.length;
				}
				if (idx !== segments.length - 1) {
					result.push({
						kind: "break",
						breakType: "line",
						pmStart: cursor,
						pmEnd: cursor + 1,
						sdt: textRun.sdt,
						trackedChange: textRun.trackedChange
					});
					cursor += 1;
				}
			});
		} else result.push(run$1);
	}
	return result;
}
function sliceRunsForLine(block, line) {
	const result = [];
	if (block.kind !== "paragraph") return result;
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const run$1 = block.runs[runIndex];
		if (!run$1) continue;
		if (run$1.kind === "tab") {
			result.push(run$1);
			continue;
		}
		if ("src" in run$1 || run$1.kind === "lineBreak" || run$1.kind === "break" || run$1.kind === "fieldAnnotation" || run$1.kind === "math") {
			result.push(run$1);
			continue;
		}
		const text$2 = run$1.text ?? "";
		if (isEmptySdtPlaceholderRun(run$1)) {
			result.push(run$1);
			continue;
		}
		const isFirstRun = runIndex === line.fromRun;
		const isLastRun = runIndex === line.toRun;
		if (isFirstRun || isLastRun) {
			const start = isFirstRun ? line.fromChar : 0;
			const end = isLastRun ? line.toChar : text$2.length;
			const slice = text$2.slice(start, end);
			if (!slice) continue;
			const pmStart = run$1.pmStart != null ? run$1.pmStart + start : run$1.pmEnd != null ? run$1.pmEnd - (text$2.length - start) : void 0;
			const pmEnd = run$1.pmStart != null ? run$1.pmStart + end : run$1.pmEnd != null ? run$1.pmEnd - (text$2.length - end) : void 0;
			result.push({
				...run$1,
				text: slice,
				pmStart,
				pmEnd
			});
		} else result.push(run$1);
	}
	return result;
}
var isAtomicRunKind = (kind) => kind === "image" || kind === "lineBreak" || kind === "break" || kind === "tab" || kind === "fieldAnnotation";
var isImageLikeRun = (run$1) => {
	if (!run$1 || typeof run$1 !== "object") return false;
	return typeof run$1.src === "string";
};
var coerceRunText = (run$1) => {
	if (!run$1 || typeof run$1 !== "object") return "";
	const candidate = run$1.text;
	return typeof candidate === "string" ? candidate : "";
};
var coercePmStart = (run$1) => {
	if (!run$1 || typeof run$1 !== "object") return void 0;
	const candidate = run$1.pmStart;
	return typeof candidate === "number" ? candidate : void 0;
};
var coercePmEnd = (run$1) => {
	if (!run$1 || typeof run$1 !== "object") return void 0;
	const candidate = run$1.pmEnd;
	return typeof candidate === "number" ? candidate : void 0;
};
function computeLinePmRange(block, line) {
	if (!line) return {};
	if (block.kind !== "paragraph") return {};
	let pmStart;
	let pmEnd;
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const run$1 = block.runs[runIndex];
		if (!run$1) continue;
		const runPmStart = coercePmStart(run$1);
		if (runPmStart == null) continue;
		if (isEmptySdtPlaceholderRun(run$1)) {
			const runPmEnd = coercePmEnd(run$1) ?? runPmStart;
			if (pmStart == null) pmStart = runPmStart;
			pmEnd = runPmEnd;
			continue;
		}
		if (isAtomicRunKind(run$1.kind) || isImageLikeRun(run$1)) {
			const runPmEnd = coercePmEnd(run$1) ?? runPmStart + 1;
			if (pmStart == null) pmStart = runPmStart;
			pmEnd = runPmEnd;
			continue;
		}
		const runLength = coerceRunText(run$1).length;
		const isFirstRun = runIndex === line.fromRun;
		const isLastRun = runIndex === line.toRun;
		const startOffset = isFirstRun ? line.fromChar : 0;
		const endOffset = isLastRun ? line.toChar : runLength;
		const sliceStart = runPmStart + startOffset;
		const sliceEnd = runPmStart + endOffset;
		if (pmStart == null) pmStart = sliceStart;
		pmEnd = sliceEnd;
	}
	return {
		pmStart,
		pmEnd
	};
}
function computeFragmentPmRange(block, lines, fromLine, toLine) {
	let pmStart;
	let pmEnd;
	for (let index = fromLine; index < toLine; index += 1) {
		const line = lines[index];
		if (!line) continue;
		const range = computeLinePmRange(block, line);
		if (range.pmStart != null && pmStart == null) pmStart = range.pmStart;
		if (range.pmEnd != null) pmEnd = range.pmEnd;
	}
	return {
		pmStart,
		pmEnd
	};
}
function widthsEqual(a, b) {
	if (!a && !b) return true;
	if (!a || !b) return false;
	if (a.length !== b.length) return false;
	for (let i$1 = 0; i$1 < a.length; i$1 += 1) if (a[i$1] !== b[i$1]) return false;
	return true;
}
function usableExplicitWidths(input) {
	if (!input || input.equalWidth !== false || !Array.isArray(input.widths)) return [];
	return input.widths.filter((width) => typeof width === "number" && Number.isFinite(width) && width > 0);
}
function resolveColumnMode(input) {
	return usableExplicitWidths(input).length > 0 ? "explicit" : "equal";
}
function resolveColumnCount(input) {
	const rawCount = input && Number.isFinite(input.count) ? Math.max(1, Math.floor(input.count)) : 1;
	const explicit = usableExplicitWidths(input);
	return explicit.length > 0 ? Math.min(rawCount, explicit.length) : rawCount;
}
function cloneColumnLayout(columns) {
	return columns ? {
		count: columns.count,
		gap: columns.gap,
		...Array.isArray(columns.widths) ? { widths: [...columns.widths] } : {},
		...Array.isArray(columns.gaps) ? { gaps: [...columns.gaps] } : {},
		...columns.equalWidth !== void 0 ? { equalWidth: columns.equalWidth } : {},
		...columns.withSeparator !== void 0 ? { withSeparator: columns.withSeparator } : {}
	} : {
		count: 1,
		gap: 0
	};
}
function resolveColumnLayout(input) {
	const count = resolveColumnCount(input);
	const resolved = cloneColumnLayout(input);
	resolved.count = count;
	if (resolveColumnMode(input) === "explicit") {
		if (Array.isArray(resolved.widths)) {
			const rawGaps = Array.isArray(resolved.gaps) ? resolved.gaps : [];
			const usable = resolved.widths.map((width, i$1) => ({
				width,
				gapAfter: rawGaps[i$1]
			})).filter((record) => typeof record.width === "number" && Number.isFinite(record.width) && record.width > 0).slice(0, count);
			resolved.widths = usable.map((record) => record.width);
			if (Array.isArray(resolved.gaps)) resolved.gaps = usable.slice(0, Math.max(0, count - 1)).map((record) => record.gapAfter ?? 0);
		}
	} else {
		delete resolved.widths;
		delete resolved.gaps;
	}
	return resolved;
}
function buildColumnGeometry(widths, gap, withSeparator, gaps) {
	const geometry = [];
	let x = 0;
	for (let i$1 = 0; i$1 < widths.length; i$1 += 1) {
		const width = widths[i$1];
		const isLast = i$1 === widths.length - 1;
		const gapAfter = isLast ? 0 : gaps?.[i$1] ?? gap;
		const col = {
			index: i$1,
			x,
			width,
			gapAfter
		};
		if (withSeparator && !isLast) col.separatorX = x + width + gapAfter / 2;
		geometry.push(col);
		x += width + gapAfter;
	}
	return geometry;
}
function normalizeColumnLayout(input, contentWidth, epsilon = 1e-4) {
	const count = resolveColumnCount(input);
	const gap = Math.max(0, input?.gap ?? 0);
	const explicitWidths = usableExplicitWidths(input);
	const availableWidth = contentWidth - gap * (count - 1);
	let widths = explicitWidths.length > 0 ? explicitWidths.slice(0, count) : Array.from({ length: count }, () => availableWidth > 0 ? availableWidth / count : contentWidth);
	if (widths.length < count) {
		const remaining = Math.max(0, availableWidth - widths.reduce((sum, width$1) => sum + width$1, 0));
		const fallbackWidth = count - widths.length > 0 ? remaining / (count - widths.length) : 0;
		widths.push(...Array.from({ length: count - widths.length }, () => fallbackWidth));
	}
	if (availableWidth > 0) widths = widths.map((value) => Math.max(1, value));
	const gaps = explicitWidths.length > 0 && Array.isArray(input?.gaps) ? input.gaps.slice(0, Math.max(0, count - 1)) : void 0;
	const width = widths.reduce((max, value) => Math.max(max, value), 0);
	if (!Number.isFinite(width) || width <= epsilon) return {
		count: 1,
		gap: 0,
		width: Math.max(0, contentWidth),
		...input?.withSeparator !== void 0 ? { withSeparator: input.withSeparator } : {}
	};
	return {
		count,
		gap,
		...widths.length > 0 ? { widths } : {},
		...gaps && gaps.length > 0 ? { gaps } : {},
		...input?.equalWidth !== void 0 ? { equalWidth: input.equalWidth } : {},
		...input?.withSeparator !== void 0 ? { withSeparator: input.withSeparator } : {},
		width
	};
}
function getColumnGeometry(normalized) {
	const count = Number.isFinite(normalized.count) ? Math.max(1, Math.floor(normalized.count)) : 1;
	return buildColumnGeometry(Array.isArray(normalized.widths) && normalized.widths.length > 0 ? normalized.widths : new Array(count).fill(normalized.width), normalized.gap, Boolean(normalized.withSeparator), normalized.gaps);
}
function clampColumnIndex(geometry, index) {
	if (geometry.length === 0) return 0;
	return Math.max(0, Math.min(index, geometry.length - 1));
}
function getColumnWidth(geometry, index) {
	return geometry[clampColumnIndex(geometry, index)]?.width ?? 0;
}
function getColumnX(geometry, index, originX = 0) {
	return originX + (geometry[clampColumnIndex(geometry, index)]?.x ?? 0);
}
function getColumnSeparatorPositions(geometry, originX = 0) {
	return geometry.filter((col) => typeof col.separatorX === "number").map((col) => originX + col.separatorX);
}
function getColumnAtX(geometry, x, originX = 0) {
	if (geometry.length === 0) return 0;
	const cx = x - originX;
	let result = 0;
	for (const col of geometry) if (cx >= col.x) result = col.index;
	else break;
	return result;
}
function columnRenderLayoutsEqual(a, b) {
	if (!a && !b) return true;
	if (!a || !b) return false;
	const mode = resolveColumnMode(a);
	if (mode !== resolveColumnMode(b)) return false;
	if (resolveColumnCount(a) !== resolveColumnCount(b)) return false;
	if ((a.gap ?? 0) !== (b.gap ?? 0)) return false;
	if (Boolean(a.withSeparator) !== Boolean(b.withSeparator)) return false;
	if (mode === "explicit") {
		const ra = resolveColumnLayout(a);
		const rb = resolveColumnLayout(b);
		if (!widthsEqual(ra.widths, rb.widths)) return false;
	}
	return true;
}
function resolveAnchoredGraphicY(input) {
	const { anchor, objectHeight, contentTop, contentBottom, pageBottomMargin = 0, anchorParagraphY = contentTop, firstLineHeight = 0, preRegisteredFallbackToContentTop = false } = input;
	const offsetV = anchor?.offsetV ?? 0;
	const vRelativeFrom = anchor?.vRelativeFrom;
	const alignV = anchor?.alignV;
	const contentHeight = Math.max(0, contentBottom - contentTop);
	if (vRelativeFrom === "margin") {
		if (alignV === "bottom") return contentBottom - objectHeight + offsetV;
		if (alignV === "center") return contentTop + (contentHeight - objectHeight) / 2 + offsetV;
		return contentTop + offsetV;
	}
	if (vRelativeFrom === "page") {
		const pageHeight = contentBottom + pageBottomMargin;
		if (alignV === "bottom") return pageHeight - objectHeight + offsetV;
		if (alignV === "center") return (pageHeight - objectHeight) / 2 + offsetV;
		return offsetV;
	}
	if (vRelativeFrom === "paragraph") {
		if (preRegisteredFallbackToContentTop) return contentTop + offsetV;
		const baseAnchorY = anchorParagraphY;
		if (alignV === "bottom") return baseAnchorY + firstLineHeight - objectHeight + offsetV;
		if (alignV === "center") return baseAnchorY + (firstLineHeight - objectHeight) / 2 + offsetV;
		return baseAnchorY + offsetV;
	}
	if (preRegisteredFallbackToContentTop) return contentTop + offsetV;
	return anchorParagraphY + offsetV;
}
function resolveAnchoredGraphicX(anchor, columnIndex, columns, objectWidth, margins, pageWidth) {
	const alignH = anchor.alignH ?? "left";
	const offsetH = anchor.offsetH ?? 0;
	const marginLeft = Math.max(0, margins?.left ?? 0);
	const marginRight = Math.max(0, margins?.right ?? 0);
	const contentWidth = pageWidth != null ? Math.max(1, pageWidth - (marginLeft + marginRight)) : columns.width;
	const contentLeft = marginLeft;
	const geometry = getColumnGeometry(columns);
	const relativeFrom = anchor.hRelativeFrom ?? "column";
	let baseX;
	let availableWidth;
	if (relativeFrom === "page") {
		baseX = 0;
		availableWidth = pageWidth != null ? pageWidth : contentWidth + marginLeft + marginRight;
	} else if (relativeFrom === "margin") {
		baseX = contentLeft;
		availableWidth = contentWidth;
	} else {
		baseX = getColumnX(geometry, columnIndex, contentLeft);
		availableWidth = columns.width;
	}
	if (alignH === "left") return baseX + offsetH;
	if (alignH === "right") return baseX + availableWidth - objectWidth - offsetH;
	if (alignH === "center") return baseX + (availableWidth - objectWidth) / 2 + offsetH;
	return baseX;
}
const LAYOUT_BOUNDARY_SCHEMA = "layout-identity/1";
const bodyStoryLocator = () => ({ kind: "body" });
const namedStoryLocator = (kind, id) => id ? {
	kind,
	id
} : { kind: "unknown" };
const computeLayoutFragmentId = (input) => {
	const story = input.story ?? bodyStoryLocator();
	const storySegment = story.kind === "body" ? "body" : `${story.kind}:${story.id ?? ""}`;
	let variant;
	if (input.kind === "para") variant = `para:${input.fromLine ?? 0}:${input.toLine ?? ""}`;
	else if (input.kind === "list-item") variant = `list-item:${input.itemId ?? ""}:${input.fromLine ?? 0}:${input.toLine ?? ""}`;
	else if (input.kind === "table") {
		const partialKey = input.partialRow ? `:${input.partialRow.rowIndex ?? ""}:${input.partialRow.fromLineByCell?.join(",") ?? ""}-${input.partialRow.toLineByCell?.join(",") ?? ""}` : "";
		variant = `table:${input.fromRow ?? 0}:${input.toRow ?? ""}${partialKey}`;
	} else if (input.kind === "image" || input.kind === "drawing") variant = `${input.kind}:${input.x ?? ""}:${input.y ?? ""}`;
	else variant = input.kind;
	return `${storySegment}|${input.blockId}|${variant}`;
};
const buildLayoutSourceIdentity = (input) => ({
	schema: LAYOUT_BOUNDARY_SCHEMA,
	story: input.story ?? bodyStoryLocator(),
	blockRef: input.blockId,
	fragmentId: computeLayoutFragmentId(input),
	sourceAnchor: input.sourceAnchor
});
var sameStoryLocator = (left, right) => left.kind === right.kind && (left.id ?? "") === (right.id ?? "");
var shouldKeepExistingIdentity = (existing, story) => {
	if (!story) return true;
	if (sameStoryLocator(existing.story, story)) return true;
	return story.kind === "body" && existing.story.kind !== "body";
};
const buildLayoutSourceIdentityForFragment = (fragment, story) => {
	const existing = fragment.layoutSourceIdentity;
	if (existing && shouldKeepExistingIdentity(existing, story)) return existing;
	return buildLayoutSourceIdentity({
		blockId: fragment.blockId,
		story: story ?? existing?.story,
		kind: fragment.kind,
		fromLine: fragment.kind === "para" || fragment.kind === "list-item" ? fragment.fromLine : void 0,
		toLine: fragment.kind === "para" || fragment.kind === "list-item" ? fragment.toLine : void 0,
		fromRow: fragment.kind === "table" ? fragment.fromRow : void 0,
		toRow: fragment.kind === "table" ? fragment.toRow : void 0,
		itemId: fragment.kind === "list-item" ? fragment.itemId : void 0,
		x: fragment.kind === "image" || fragment.kind === "drawing" ? fragment.x : void 0,
		y: fragment.kind === "image" || fragment.kind === "drawing" ? fragment.y : void 0,
		partialRow: fragment.kind === "table" ? fragment.partialRow : void 0,
		sourceAnchor: fragment.sourceAnchor ?? existing?.sourceAnchor
	});
};
var FALLBACK_PALETTE = [
	"#1f6feb",
	"#d1242f",
	"#8250df",
	"#bf3989",
	"#1a7f37",
	"#9a6700",
	"#bc4c00",
	"#0969da",
	"#cf222e",
	"#6639ba",
	"#116329",
	"#7d4e00"
];
const authorIdentityKey = (author) => {
	if (!author) return "";
	return `${typeof author.name === "string" ? author.name : ""} ${typeof author.email === "string" ? author.email : ""}`;
};
var hashString = (value) => {
	let hash = 2166136261;
	for (let i$1 = 0; i$1 < value.length; i$1 += 1) {
		hash ^= value.charCodeAt(i$1);
		hash = Math.imul(hash, 16777619);
	}
	return hash >>> 0;
};
const fallbackAuthorColor = (author) => {
	return FALLBACK_PALETTE[hashString(authorIdentityKey(author)) % FALLBACK_PALETTE.length];
};
var isNonEmptyString$1 = (value) => typeof value === "string" && value.length > 0;
const composeAuthorColorResolver = (config$43) => {
	if (!config$43 || config$43.enabled === false) return void 0;
	const overrides = config$43.overrides && typeof config$43.overrides === "object" ? config$43.overrides : void 0;
	const resolve = typeof config$43.resolve === "function" ? config$43.resolve : void 0;
	return (author) => {
		const safeAuthor = author ?? {};
		if (overrides) {
			if (isNonEmptyString$1(safeAuthor.email) && isNonEmptyString$1(overrides[safeAuthor.email])) return overrides[safeAuthor.email];
			if (isNonEmptyString$1(safeAuthor.name) && isNonEmptyString$1(overrides[safeAuthor.name])) return overrides[safeAuthor.name];
		}
		if (resolve) try {
			const resolved = resolve(safeAuthor);
			if (isNonEmptyString$1(resolved)) return resolved;
		} catch {}
		return fallbackAuthorColor(safeAuthor);
	};
};
const authorFromTrackedChangeMeta = (meta) => ({
	name: meta.author,
	email: meta.authorEmail,
	image: meta.authorImage
});
var applyColorToLayer = (meta, resolve) => {
	const color = resolve?.(authorFromTrackedChangeMeta(meta));
	if (isNonEmptyString$1(color)) {
		meta.color = color;
		return;
	}
	delete meta.color;
};
var stampRunTrackedChangeColors = (run$1, resolve) => {
	if (Array.isArray(run$1.trackedChanges)) for (const layer of run$1.trackedChanges) applyColorToLayer(layer, resolve);
	if (run$1.trackedChange) applyColorToLayer(run$1.trackedChange, resolve);
};
var stampBlockTrackedChangeColors = (block, resolve) => {
	if (!block) return;
	switch (block.kind) {
		case "paragraph":
			for (const run$1 of block.runs) stampRunTrackedChangeColors(run$1, resolve);
			break;
		case "list":
			for (const item of block.items) stampBlockTrackedChangeColors(item.paragraph, resolve);
			break;
		case "table":
			for (const row of block.rows) {
				if (row.attrs?.trackedChange) applyColorToLayer(row.attrs.trackedChange, resolve);
				for (const cell of row.cells) {
					stampBlockTrackedChangeColors(cell.paragraph, resolve);
					if (Array.isArray(cell.blocks)) for (const nested of cell.blocks) stampBlockTrackedChangeColors(nested, resolve);
				}
			}
			break;
		default: break;
	}
};
const stampTrackedChangeColors = (blocks, resolve) => {
	for (const block of blocks) stampBlockTrackedChangeColors(block, resolve);
};
var idlessSdtContainerKeys = /* @__PURE__ */ new WeakMap();
var nextIdlessSdtContainerKey = 0;
function getIdlessSdtContainerKey(metadata) {
	const existingKey = idlessSdtContainerKeys.get(metadata);
	if (existingKey) return existingKey;
	const key = `idlessSdt:${++nextIdlessSdtContainerKey}`;
	idlessSdtContainerKeys.set(metadata, key);
	return key;
}
function isSdtContainerMetadata(sdt) {
	if (!sdt) return false;
	if (sdt.type === "documentSection") return true;
	if (sdt.type === "structuredContent" && sdt.scope === "block") return true;
	return false;
}
function getSdtContainerMetadata(sdt, containerSdt) {
	if (isSdtContainerMetadata(sdt)) return sdt ?? null;
	if (isSdtContainerMetadata(containerSdt)) return containerSdt ?? null;
	return null;
}
function getSdtContainerKey(sdt, containerSdt) {
	const metadata = getSdtContainerMetadata(sdt, containerSdt);
	if (!metadata) return null;
	if (metadata.type === "structuredContent") {
		if (metadata.scope !== "block") return null;
		if (metadata.id) return `structuredContent:${metadata.id}`;
		return getIdlessSdtContainerKey(metadata);
	}
	if (metadata.type === "documentSection") {
		const sectionId = metadata.id ?? metadata.sdBlockId;
		if (sectionId) return `documentSection:${sectionId}`;
		return getIdlessSdtContainerKey(metadata);
	}
	return null;
}
function hasExplicitSdtContainerKey(sdt, containerSdt) {
	const metadata = getSdtContainerMetadata(sdt, containerSdt);
	if (!metadata) return false;
	if (metadata.type === "structuredContent") return metadata.scope === "block" && Boolean(metadata.id);
	if (metadata.type === "documentSection") return Boolean(metadata.id ?? metadata.sdBlockId);
	return false;
}
function getSdtContainerKeyForBlock(block) {
	if (!block) return null;
	return getSdtContainerKey(block.attrs?.sdt, block.attrs?.containerSdt);
}
function toUpperRoman$1(value) {
	if (value < 1 || value > 3999) return String(value);
	const values = [
		1e3,
		900,
		500,
		400,
		100,
		90,
		50,
		40,
		10,
		9,
		5,
		4,
		1
	];
	const numerals = [
		"M",
		"CM",
		"D",
		"CD",
		"C",
		"XC",
		"L",
		"XL",
		"X",
		"IX",
		"V",
		"IV",
		"I"
	];
	let remaining = value;
	let result = "";
	for (let i$1 = 0; i$1 < values.length; i$1 += 1) while (remaining >= values[i$1]) {
		result += numerals[i$1];
		remaining -= values[i$1];
	}
	return result;
}
function toUpperLetter$1(value) {
	const normalized = Math.max(1, value);
	const index = (normalized - 1) % 26;
	const repeatCount = Math.floor((normalized - 1) / 26) + 1;
	return String.fromCharCode(65 + index).repeat(repeatCount);
}
function toOrdinal(value) {
	const remainder = value % 100;
	if (remainder >= 11 && remainder <= 13) return `${value}th`;
	switch (value % 10) {
		case 1: return `${value}st`;
		case 2: return `${value}nd`;
		case 3: return `${value}rd`;
		default: return `${value}th`;
	}
}
function formatPageNumber(pageNumber, format) {
	const value = Math.max(1, Math.trunc(Number.isFinite(pageNumber) ? pageNumber : 1));
	switch (format) {
		case "upperRoman": return toUpperRoman$1(value);
		case "lowerRoman": return toUpperRoman$1(value).toLowerCase();
		case "upperLetter": return toUpperLetter$1(value);
		case "lowerLetter": return toUpperLetter$1(value).toLowerCase();
		case "numberInDash": return `- ${value} -`;
		case "ordinal": return toOrdinal(value);
		case "decimal":
		default: return String(value);
	}
}
function formatPageNumberFieldValue(pageNumber, fieldFormat) {
	if (fieldFormat?.numericPicture) return formatIntegerWithNumericPicture(Math.max(1, Math.trunc(Number.isFinite(pageNumber) ? pageNumber : 1)), fieldFormat.numericPicture);
	const format = fieldFormat?.format ?? "decimal";
	const formatted = formatPageNumber(pageNumber, format);
	return fieldFormat?.zeroPadding && format === "decimal" ? formatted.padStart(fieldFormat.zeroPadding, "0") : formatted;
}
function formatChapterPageNumberText(args) {
	if (!args.chapterNumberText) return args.pageComponent;
	const separator = (() => {
		switch (args.chapterSeparator ?? "hyphen") {
			case "period": return ".";
			case "colon": return ":";
			case "emDash": return "—";
			case "enDash": return "–";
			case "hyphen":
			default: return "‑";
		}
	})();
	return `${args.chapterNumberText}${separator}${args.pageComponent}`;
}
function formatSectionPageNumberText(args) {
	return formatChapterPageNumberText({
		pageComponent: formatPageNumber(args.displayNumber, args.pageFormat),
		chapterNumberText: args.chapterNumberText,
		chapterSeparator: args.chapterSeparator
	});
}
function formatIntegerWithNumericPicture(value, picture) {
	const integerValue = Math.trunc(Number.isFinite(value) ? value : 0);
	const sections = splitPictureSections(typeof picture === "string" && picture.length > 0 ? picture : "0");
	const hasExplicitNegativeSection = integerValue < 0 && sections[1] != null;
	const section = integerValue > 0 ? sections[0] : integerValue < 0 ? sections[1] ?? sections[0] : sections[2] ?? sections[0];
	return formatNumericPictureSection(Math.abs(integerValue), integerValue < 0, section ?? "0", hasExplicitNegativeSection);
}
function splitPictureSections(picture) {
	const sections = [];
	let current = "";
	let inQuote = false;
	for (let index = 0; index < picture.length; index += 1) {
		const char = picture[index];
		if (char === "'") {
			inQuote = !inQuote;
			current += char;
			continue;
		}
		if (char === ";" && !inQuote) {
			sections.push(current);
			current = "";
			continue;
		}
		current += char;
	}
	sections.push(current);
	return sections;
}
function tokenizePicture(section) {
	const tokens = [];
	for (let index = 0; index < section.length; index += 1) {
		const char = section[index];
		if (char === "'") {
			let literal = "";
			index += 1;
			while (index < section.length && section[index] !== "'") {
				literal += section[index];
				index += 1;
			}
			tokens.push({
				kind: "literal",
				value: literal
			});
			continue;
		}
		if (char === "0" || char === "#" || char === "x" || char === "," || char === "." || char === "+" || char === "-") tokens.push({
			kind: "placeholder",
			value: char
		});
		else tokens.push({
			kind: "literal",
			value: char
		});
	}
	return tokens;
}
function formatNumericPictureSection(value, isNegative, section, suppressDefaultNegative = false) {
	const tokens = tokenizePicture(section);
	const decimalIndex = tokens.findIndex((token) => token.kind === "placeholder" && token.value === ".");
	const integerTokens = decimalIndex >= 0 ? tokens.slice(0, decimalIndex) : tokens;
	const fractionalTokens = decimalIndex >= 0 ? tokens.slice(decimalIndex + 1) : [];
	const integerPart = formatIntegerPictureTokens(value, isNegative, integerTokens, suppressDefaultNegative);
	const fractionalPart = formatFractionalPictureTokens(fractionalTokens);
	return fractionalTokens.length > 0 ? `${integerPart}.${fractionalPart}` : integerPart;
}
function formatIntegerPictureTokens(value, isNegative, tokens, suppressDefaultNegative) {
	let xIndex = -1;
	for (let index = tokens.length - 1; index >= 0; index -= 1) {
		const token = tokens[index];
		if (token.kind === "placeholder" && token.value === "x") {
			xIndex = index;
			break;
		}
	}
	const activeTokens = xIndex >= 0 ? tokens.slice(xIndex + 1) : tokens;
	const placeholderCount = activeTokens.filter((token) => token.kind === "placeholder" && (token.value === "0" || token.value === "#")).length;
	const rawDigits = String(value);
	const digits = xIndex >= 0 && placeholderCount > 0 ? rawDigits.slice(-placeholderCount) : rawDigits;
	let digitIndex = digits.length - 1;
	let output = "";
	let signSlot = null;
	const hasGrouping = activeTokens.some((token) => token.kind === "placeholder" && token.value === ",");
	for (let index = activeTokens.length - 1; index >= 0; index -= 1) {
		const token = activeTokens[index];
		if (token.kind === "literal") {
			output = token.value + output;
			continue;
		}
		switch (token.value) {
			case "0":
				output = (digitIndex >= 0 ? digits[digitIndex] : "0") + output;
				digitIndex -= 1;
				break;
			case "#":
				if (digitIndex >= 0) {
					output = digits[digitIndex] + output;
					digitIndex -= 1;
				}
				break;
			case "+":
			case "-":
				signSlot = token.value;
				break;
			case ",":
			case "x":
			case ".": break;
		}
	}
	if (placeholderCount > 0 && xIndex < 0 && digitIndex >= 0) output = digits.slice(0, digitIndex + 1) + output;
	if (hasGrouping) output = applyGrouping(output);
	if (signSlot === "+") output = `${isNegative ? "-" : "+"}${output}`;
	else if (signSlot === "-") output = `${isNegative ? "-" : " "}${output}`;
	else if (isNegative && !suppressDefaultNegative) output = `-${output}`;
	return output;
}
function formatFractionalPictureTokens(tokens) {
	let output = "";
	for (const token of tokens) {
		if (token.kind === "literal") {
			output += token.value;
			continue;
		}
		if (token.value === "0") output += "0";
		else if (token.value !== "#") output += token.value;
	}
	return output;
}
function applyGrouping(value) {
	const match = value.match(/^([^0-9]*)([0-9]+)(.*)$/);
	if (!match) return value;
	return `${match[1]}${match[2].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${match[3]}`;
}
var MAX_BOOKMARK_MARKER_LEAD_DISTANCE = 3;
function buildPageRefAnchorMap(bookmarks, layout, blocks = [], measures = []) {
	const anchors = /* @__PURE__ */ new Map();
	if (bookmarks.size === 0) return anchors;
	const blockById = /* @__PURE__ */ new Map();
	const measureById = /* @__PURE__ */ new Map();
	for (const block of blocks) blockById.set(block.id, block);
	for (let index = 0; index < blocks.length; index += 1) {
		const block = blocks[index];
		const measure = measures[index];
		if (block && measure) measureById.set(block.id, measure);
	}
	for (const [bookmarkName, pmPosition] of bookmarks) {
		const location = findPageRefLocation(pmPosition, layout, blockById, measureById);
		if (location) anchors.set(bookmarkName, {
			...location,
			pmPosition
		});
	}
	return anchors;
}
function findPageRefLocation(pmPosition, layout, blockById, measureById) {
	let nextLocation = null;
	let nextDistance = Number.POSITIVE_INFINITY;
	let hasPriorVisibleRange = false;
	for (const page of layout.pages) for (const fragment of page.fragments) {
		if (fragmentContainsPosition(fragment, pmPosition)) return pageRefLocationFromPage(page, pmPosition);
		const block = blockById.get(fragment.blockId);
		if (fragment.kind === "para" && block?.kind === "paragraph" && blockContainsPosition(block, pmPosition)) return pageRefLocationFromPage(page, pmPosition);
		if (fragment.kind === "table" && block?.kind === "table" && tableContainsPosition(block, fragment, pmPosition, measureById.get(fragment.blockId))) return pageRefLocationFromPage(page, pmPosition);
		if (fragment.kind === "list-item" && block?.kind === "list" && listItemContainsPosition(block, fragment.itemId, pmPosition)) return pageRefLocationFromPage(page, pmPosition);
		const fragmentRange = fragmentPositionRange(fragment, block);
		if (fragmentRange?.end != null && fragmentRange.end <= pmPosition) hasPriorVisibleRange = true;
		const fragmentStart = fragmentRange?.start ?? null;
		if (fragmentStart != null && fragmentStart > pmPosition) {
			const distance = fragmentStart - pmPosition;
			if ((!hasPriorVisibleRange || distance <= MAX_BOOKMARK_MARKER_LEAD_DISTANCE) && distance < nextDistance) {
				nextDistance = distance;
				nextLocation = pageRefLocationFromPage(page, pmPosition);
			}
		}
	}
	return nextLocation;
}
function pageRefLocationFromPage(page, pmPosition) {
	const displayNumber = Math.max(1, page.displayNumber ?? page.effectivePageNumber ?? page.number);
	return {
		physicalPage: page.number,
		displayNumber,
		displayText: page.numberText ?? String(displayNumber),
		pageFormat: page.pageNumberFormat,
		chapterNumberText: page.pageNumberChapterText,
		chapterSeparator: page.pageNumberChapterSeparator,
		sectionIndex: page.sectionIndex,
		pmPosition
	};
}
function fragmentContainsPosition(fragment, pmPosition) {
	const range = fragment;
	return range.pmStart != null && range.pmEnd != null && pmPosition >= range.pmStart && pmPosition < range.pmEnd;
}
function blockContainsPosition(block, pmPosition) {
	const range = runRange(block.runs);
	return range != null && pmPosition >= range.start && pmPosition < range.end;
}
function tableContainsPosition(block, fragment, pmPosition, measure) {
	const fromRow = Math.max(0, fragment.fromRow);
	const toRow = Math.min(block.rows.length, fragment.toRow);
	const tableMeasure = measure?.kind === "table" ? measure : void 0;
	for (let rowIndex = fromRow; rowIndex < toRow; rowIndex += 1) {
		const row = block.rows[rowIndex];
		if (!row) continue;
		const isPartialRow = fragment.partialRow?.rowIndex === rowIndex;
		for (let cellIndex = 0; cellIndex < row.cells.length; cellIndex += 1) {
			const cell = row.cells[cellIndex];
			if (!cell) continue;
			if (isPartialRow && tableMeasure) {
				const cellMeasure = tableMeasure.rows[rowIndex]?.cells[cellIndex];
				if (cellContainsPositionInLineRange(cell, cellMeasure, fragment.partialRow, cellIndex, pmPosition)) return true;
				continue;
			}
			const blocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
			for (const childBlock of blocks) {
				if (childBlock.kind === "paragraph" && blockContainsPosition(childBlock, pmPosition)) return true;
				if (childBlock.kind === "table" && tableBlockContainsPosition(childBlock, pmPosition)) return true;
			}
		}
	}
	return false;
}
function cellContainsPositionInLineRange(cell, cellMeasure, partialRow, cellIndex, pmPosition) {
	if (!cellMeasure) return false;
	const totalLines = getCellTotalLines(cellMeasure);
	const rawFromLine = partialRow.fromLineByCell[cellIndex];
	const rawToLine = partialRow.toLineByCell[cellIndex];
	const fromLine = typeof rawFromLine === "number" && rawFromLine >= 0 ? Math.min(rawFromLine, totalLines) : 0;
	const toLine = typeof rawToLine === "number" ? Math.max(0, Math.min(rawToLine === -1 ? totalLines : rawToLine, totalLines)) : totalLines;
	const range = computeCellLineRange(cell, cellMeasure, fromLine, Math.max(fromLine, toLine));
	return range != null && pmPosition >= range.start && pmPosition < range.end;
}
function computeCellLineRange(cell, cellMeasure, fromLine, toLine) {
	let start = Number.POSITIVE_INFINITY;
	let end = Number.NEGATIVE_INFINITY;
	const blocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
	const measures = cellMeasure.blocks ?? (cellMeasure.paragraph ? [cellMeasure.paragraph] : []);
	const blockCount = Math.min(blocks.length, measures.length);
	let lineOffset = 0;
	for (let blockIndex = 0; blockIndex < blockCount; blockIndex += 1) {
		const childBlock = blocks[blockIndex];
		const childMeasure = measures[blockIndex];
		const lineCount = getBlockLineCount(childMeasure);
		const blockFromLine = Math.max(fromLine, lineOffset) - lineOffset;
		const blockToLine = Math.min(toLine, lineOffset + lineCount) - lineOffset;
		if (childBlock?.kind === "paragraph" && childMeasure?.kind === "paragraph" && blockFromLine < blockToLine) {
			const range = computeFragmentPmRange(childBlock, childMeasure.lines, blockFromLine, blockToLine);
			if (range.pmStart != null) start = Math.min(start, range.pmStart);
			if (range.pmEnd != null) end = Math.max(end, range.pmEnd);
		}
		lineOffset += lineCount;
	}
	return Number.isFinite(start) && Number.isFinite(end) && start < end ? {
		start,
		end
	} : null;
}
function getCellTotalLines(cellMeasure) {
	return (cellMeasure.blocks ?? (cellMeasure.paragraph ? [cellMeasure.paragraph] : [])).reduce((total, measure) => total + getBlockLineCount(measure), 0);
}
function getBlockLineCount(measure) {
	if (!measure) return 0;
	if (measure.kind === "paragraph") return measure.lines.length;
	if (measure.kind === "table") return measure.rows.length;
	return 1;
}
function tableBlockContainsPosition(block, pmPosition) {
	for (const row of block.rows) for (const cell of row.cells) {
		const blocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
		for (const childBlock of blocks) {
			if (childBlock.kind === "paragraph" && blockContainsPosition(childBlock, pmPosition)) return true;
			if (childBlock.kind === "table" && tableBlockContainsPosition(childBlock, pmPosition)) return true;
		}
	}
	return false;
}
function fragmentPositionRange(fragment, block) {
	const fullRange = fragment;
	if (fullRange.pmStart != null && fullRange.pmEnd != null) return {
		start: fullRange.pmStart,
		end: fullRange.pmEnd
	};
	if (block?.kind === "paragraph") return runRange(block.runs);
	if (block?.kind === "table") return tableRunRange(block);
	if (fragment.kind === "list-item" && block?.kind === "list") return listItemRunRange(block, fragment.itemId);
	return null;
}
function listItemContainsPosition(block, itemId, pmPosition) {
	const range = listItemRunRange(block, itemId);
	return range != null && pmPosition >= range.start && pmPosition < range.end;
}
function listItemRunRange(block, itemId) {
	const item = block.items.find((candidate) => candidate.id === itemId);
	return item ? runRange(item.paragraph.runs) : null;
}
function tableRunRange(block) {
	let start = Number.POSITIVE_INFINITY;
	let end = Number.NEGATIVE_INFINITY;
	for (const row of block.rows) for (const cell of row.cells) {
		const blocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
		for (const childBlock of blocks) {
			const range = childBlock.kind === "paragraph" ? runRange(childBlock.runs) : childBlock.kind === "table" ? tableRunRange(childBlock) : null;
			if (!range) continue;
			start = Math.min(start, range.start);
			end = Math.max(end, range.end);
		}
	}
	return Number.isFinite(start) && Number.isFinite(end) && start < end ? {
		start,
		end
	} : null;
}
function runRange(runs) {
	let start = Number.POSITIVE_INFINITY;
	let end = Number.NEGATIVE_INFINITY;
	for (const run$1 of runs) {
		const range = run$1;
		if (range.pmStart != null) start = Math.min(start, range.pmStart);
		if (range.pmEnd != null) end = Math.max(end, range.pmEnd);
	}
	return Number.isFinite(start) && Number.isFinite(end) && start < end ? {
		start,
		end
	} : null;
}
function resolveSpacingIndent(style, numbering) {
	const spacing = {
		before: style.spacing?.before ?? 0,
		after: style.spacing?.after ?? 0,
		line: style.spacing?.line ?? 12,
		lineRule: style.spacing?.lineRule ?? "auto"
	};
	let indent = {
		left: style.indent?.left ?? 0,
		right: style.indent?.right ?? 0,
		firstLine: style.indent?.firstLine ?? 0,
		hanging: style.indent?.hanging ?? 0
	};
	if (numbering?.indent) indent = {
		...indent,
		left: numbering.indent.left ?? indent.left,
		hanging: numbering.indent.hanging ?? indent.hanging
	};
	return {
		spacing,
		indent
	};
}
function formatListLabel(level, indices) {
	const { format, text: template, start } = level;
	if (format === "bullet" || format === "custom") return {
		text: template,
		width: estimateTextWidth(template)
	};
	let result = template;
	for (let i$1 = 0; i$1 < indices.length; i$1++) {
		const placeholder = `%${i$1 + 1}`;
		if (result.includes(placeholder)) {
			const formattedNum = formatNumber(indices[i$1] + start - 1, format);
			result = result.replace(placeholder, formattedNum);
		}
	}
	return {
		text: result,
		width: estimateTextWidth(result)
	};
}
function computeListIndent(level) {
	const { indent } = level;
	return {
		labelWidth: Math.abs(indent.hanging),
		hangingIndent: indent.hanging,
		firstLineIndent: indent.left - Math.abs(indent.hanging)
	};
}
function formatNumber(num, format) {
	switch (format) {
		case "decimal": return num.toString();
		case "lowerLetter": return toLetter(num, false);
		case "upperLetter": return toLetter(num, true);
		case "lowerRoman": return toRoman(num).toLowerCase();
		case "upperRoman": return toRoman(num);
		default: return num.toString();
	}
}
function toLetter(num, uppercase) {
	let result = "";
	let n = num;
	while (n > 0) {
		const remainder = (n - 1) % 26;
		result = String.fromCharCode((uppercase ? 65 : 97) + remainder) + result;
		n = Math.floor((n - 1) / 26);
	}
	return result || (uppercase ? "A" : "a");
}
function toRoman(num) {
	const lookup = [
		[1e3, "M"],
		[900, "CM"],
		[500, "D"],
		[400, "CD"],
		[100, "C"],
		[90, "XC"],
		[50, "L"],
		[40, "XL"],
		[10, "X"],
		[9, "IX"],
		[5, "V"],
		[4, "IV"],
		[1, "I"]
	];
	let result = "";
	let remaining = num;
	for (const [value, numeral] of lookup) while (remaining >= value) {
		result += numeral;
		remaining -= value;
	}
	return result;
}
function estimateTextWidth(text$2) {
	return text$2.length * 7;
}
function scaleWrapPolygon(ooxml, imageRect) {
	if (!ooxml || ooxml.length === 0) return [];
	let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
	for (const [x, y] of ooxml) {
		minX = Math.min(minX, x);
		minY = Math.min(minY, y);
		maxX = Math.max(maxX, x);
		maxY = Math.max(maxY, y);
	}
	const ooxmlWidth = maxX - minX;
	const ooxmlHeight = maxY - minY;
	if (ooxmlWidth === 0 || ooxmlHeight === 0) return [];
	const scaleX = imageRect.width / ooxmlWidth;
	const scaleY = imageRect.height / ooxmlHeight;
	return ooxml.map(([x, y]) => [imageRect.x + (x - minX) * scaleX, imageRect.y + (y - minY) * scaleY]);
}
function computeWrapExclusion(image, lineY, lineHeight) {
	const { rect, wrap: wrap$1 } = image;
	const top = rect.y - (wrap$1.distTop ?? 0);
	const bottom = rect.y + rect.height + (wrap$1.distBottom ?? 0);
	const left = rect.x - (wrap$1.distLeft ?? 0);
	const right = rect.x + rect.width + (wrap$1.distRight ?? 0);
	if (lineY + lineHeight <= top || lineY >= bottom) return null;
	switch (wrap$1.type) {
		case "None": return null;
		case "TopAndBottom": return null;
		case "Square": return {
			left,
			right
		};
		case "Tight":
		case "Through": {
			if (!wrap$1.polygon || wrap$1.polygon.length === 0) return {
				left,
				right
			};
			const polygon = wrap$1.polygon;
			const midY = lineY + lineHeight / 2;
			let polyLeft = Infinity;
			let polyRight = -Infinity;
			for (let i$1 = 0; i$1 < polygon.length; i$1++) {
				const [x1, y1] = polygon[i$1];
				const [x2, y2] = polygon[(i$1 + 1) % polygon.length];
				if (midY >= Math.min(y1, y2) && midY <= Math.max(y1, y2)) {
					const x = x1 + (midY - y1) / (y2 - y1) * (x2 - x1);
					polyLeft = Math.min(polyLeft, x);
					polyRight = Math.max(polyRight, x);
				}
			}
			if (polyLeft === Infinity || polyRight === -Infinity) return null;
			return {
				left: polyLeft - (wrap$1.distLeft ?? 0),
				right: polyRight + (wrap$1.distRight ?? 0)
			};
		}
		default: return null;
	}
}
var engines_exports = /* @__PURE__ */ __export({
	OOXML_PCT_DIVISOR: () => OOXML_PCT_DIVISOR,
	calculateTabWidth: () => calculateTabWidth,
	computeListIndent: () => computeListIndent,
	computeTabStops: () => computeTabStops,
	computeWrapExclusion: () => computeWrapExclusion,
	formatListLabel: () => formatListLabel,
	layoutWithTabs: () => layoutWithTabs,
	measureRowHeights: () => measureRowHeights,
	resolveColumnWidths: () => resolveColumnWidths,
	resolveSpacingIndent: () => resolveSpacingIndent,
	resolveTableWidthAttr: () => resolveTableWidthAttr,
	scaleWrapPolygon: () => scaleWrapPolygon
}, 1);
const EMPTY_SDT_PLACEHOLDER_TEXT = "Click or tap here to enter text";
function combineProperties(propertiesArray, options = {}) {
	const { fullOverrideProps = [], specialHandling = {} } = options;
	if (!propertiesArray || propertiesArray.length === 0) return {};
	const merge = (target, source) => {
		const output = { ...target };
		if (isObject(target) && isObject(source)) {
			for (const key in source) if (Object.prototype.hasOwnProperty.call(source, key)) {
				const handler$1 = specialHandling[key];
				if (handler$1 && typeof handler$1 === "function") output[key] = handler$1(output, source);
				else if (!fullOverrideProps.includes(key) && isObject(source[key])) if (key in target && isObject(target[key])) output[key] = merge(target[key], source[key]);
				else output[key] = source[key];
				else output[key] = source[key];
			}
		}
		return output;
	};
	return propertiesArray.reduce((acc, current) => merge(acc, current ?? {}), {});
}
function isObject(item) {
	return item != null && typeof item === "object" && !Array.isArray(item);
}
const FONT_SLOT_THEME_PAIRS = [
	["ascii", "asciiTheme"],
	["hAnsi", "hAnsiTheme"],
	["eastAsia", "eastAsiaTheme"],
	["cs", "cstheme"]
];
function dropConflictingFontSlots(target, source) {
	const result = { ...target };
	for (const [concreteKey, themeKey] of FONT_SLOT_THEME_PAIRS) if (source[themeKey] != null) {
		delete result[concreteKey];
		delete result[themeKey];
	} else if (source[concreteKey] != null) delete result[themeKey];
	return result;
}
function combineRunProperties(propertiesArray) {
	return combineProperties(propertiesArray, {
		fullOverrideProps: ["color"],
		specialHandling: { fontFamily: (target, source) => {
			const fontFamilySource = { ...source.fontFamily };
			return {
				...dropConflictingFontSlots(target.fontFamily ?? {}, fontFamilySource),
				...fontFamilySource
			};
		} }
	});
}
function combineIndentProperties(indentChain) {
	return combineProperties(indentChain.map((props) => props.indent != null ? { indent: props.indent } : {}), { specialHandling: {
		firstLine: (target, source) => {
			if (target.hanging != null && source.firstLine != null) delete target.hanging;
			return source.firstLine;
		},
		hanging: (target, source) => {
			if (target.firstLine != null && source.hanging != null) delete target.firstLine;
			return source.hanging;
		}
	} });
}
const TABLE_STYLE_ID_TABLE_GRID = "TableGrid";
const TABLE_FALLBACK_BORDER = {
	val: "single",
	size: 4,
	color: "#000000"
};
const TABLE_FALLBACK_BORDERS = {
	top: { ...TABLE_FALLBACK_BORDER },
	left: { ...TABLE_FALLBACK_BORDER },
	bottom: { ...TABLE_FALLBACK_BORDER },
	right: { ...TABLE_FALLBACK_BORDER },
	insideH: { ...TABLE_FALLBACK_BORDER },
	insideV: { ...TABLE_FALLBACK_BORDER }
};
const TABLE_FALLBACK_CELL_PADDING = {
	top: 0,
	bottom: 0,
	left: 108,
	right: 108
};
function isKnownTableStyleId(styleId, translatedLinkedStyles) {
	if (!styleId || !translatedLinkedStyles?.styles) return false;
	const def = translatedLinkedStyles.styles[styleId];
	return def != null && def.type === "table";
}
function findTypeDefaultTableStyleId(translatedLinkedStyles) {
	if (!translatedLinkedStyles?.styles) return null;
	for (const [styleId, def] of Object.entries(translatedLinkedStyles.styles)) if (def.type === "table" && def.default === true) return styleId;
	return null;
}
function resolveExistingTableEffectiveStyleId(explicitTableStyleId, translatedLinkedStyles) {
	if (explicitTableStyleId && isKnownTableStyleId(explicitTableStyleId, translatedLinkedStyles)) return {
		styleId: explicitTableStyleId,
		source: "explicit"
	};
	const typeDefault = findTypeDefaultTableStyleId(translatedLinkedStyles);
	if (typeDefault) return {
		styleId: typeDefault,
		source: "type-default"
	};
	return {
		styleId: null,
		source: "none"
	};
}
function resolvePreferredNewTableStyleId(settingsDefaultTableStyleId, translatedLinkedStyles) {
	if (settingsDefaultTableStyleId && isKnownTableStyleId(settingsDefaultTableStyleId, translatedLinkedStyles)) return {
		styleId: settingsDefaultTableStyleId,
		source: "settings-default"
	};
	const typeDefault = findTypeDefaultTableStyleId(translatedLinkedStyles);
	if (typeDefault && typeDefault !== "TableNormal") return {
		styleId: typeDefault,
		source: "type-default"
	};
	if (isKnownTableStyleId("TableGrid", translatedLinkedStyles)) return {
		styleId: TABLE_STYLE_ID_TABLE_GRID,
		source: "builtin-fallback"
	};
	return {
		styleId: null,
		source: "none"
	};
}
const DEFAULT_TBL_LOOK = {
	firstRow: true,
	lastRow: false,
	firstColumn: true,
	lastColumn: false,
	noHBand: false,
	noVBand: true
};
function resolveRunProperties(params, inlineRpr, resolvedPpr, tableInfo = null, isListNumber = false, numberingDefinedInline = false) {
	if (!params.translatedLinkedStyles?.styles) return inlineRpr ?? {};
	inlineRpr = inlineRpr ? { ...inlineRpr } : {};
	const paragraphStyleId = resolvedPpr?.styleId;
	const paragraphStyleProps = resolveStyleChain("runProperties", params, paragraphStyleId);
	const defaultProps = params.translatedLinkedStyles.docDefaults?.runProperties ?? {};
	const normalProps = params.translatedLinkedStyles.styles["Normal"]?.runProperties ?? {};
	const tableStyleProps = tableInfo?.tableProperties?.tableStyleId ? resolveStyleChain("runProperties", params, tableInfo?.tableProperties?.tableStyleId) : {};
	const cellStyleProps = resolveCellStyles("runProperties", tableInfo, params.translatedLinkedStyles);
	let runStyleProps = {};
	if (!paragraphStyleId?.startsWith("TOC")) runStyleProps = inlineRpr?.styleId ? resolveStyleChain("runProperties", params, inlineRpr.styleId) : {};
	let defaultsChain;
	if (!paragraphStyleId) defaultsChain = [defaultProps, normalProps];
	else defaultsChain = [defaultProps];
	let styleChain;
	if (isListNumber) {
		const numberingProperties = resolvedPpr?.numberingProperties;
		const numId = resolvedPpr?.numberingProperties?.numId;
		let numberingProps = {};
		if (numId != null && numId !== 0) numberingProps = getNumberingProperties$1("runProperties", params, numberingProperties?.ilvl ?? 0, numId);
		if (!numberingDefinedInline) inlineRpr = {};
		if (inlineRpr?.underline) delete inlineRpr.underline;
		if (inlineRpr?.vanish) delete inlineRpr.vanish;
		if (inlineRpr?.specVanish) delete inlineRpr.specVanish;
		styleChain = [
			...defaultsChain,
			tableStyleProps,
			...cellStyleProps,
			paragraphStyleProps,
			runStyleProps,
			inlineRpr,
			numberingProps
		];
	} else styleChain = [
		...defaultsChain,
		tableStyleProps,
		...cellStyleProps,
		paragraphStyleProps,
		runStyleProps,
		inlineRpr
	];
	return combineRunProperties(styleChain);
}
function resolveParagraphProperties(params, inlineProps, tableInfo) {
	inlineProps = inlineProps ? { ...inlineProps } : {};
	if (!params.translatedLinkedStyles?.styles) return inlineProps;
	const defaultProps = params.translatedLinkedStyles.docDefaults?.paragraphProperties ?? {};
	const normalProps = params.translatedLinkedStyles.styles["Normal"]?.paragraphProperties ?? {};
	let styleId = inlineProps.styleId;
	let styleProps = inlineProps.styleId ? resolveStyleChain("paragraphProperties", params, inlineProps.styleId) : {};
	let numberingProps = {};
	const ilvl = inlineProps?.numberingProperties?.ilvl ?? styleProps?.numberingProperties?.ilvl;
	const numId = inlineProps?.numberingProperties?.numId ?? styleProps?.numberingProperties?.numId;
	let numberingDefinedInline = inlineProps?.numberingProperties?.numId != null;
	const isList$2 = numId != null && numId !== 0;
	if (isList$2) {
		numberingProps = getNumberingProperties$1("paragraphProperties", params, ilvl != null ? ilvl : 0, numId);
		if (numberingProps.styleId) {
			styleId = numberingProps.styleId;
			styleProps = resolveStyleChain("paragraphProperties", params, styleId);
			inlineProps.styleId = styleId;
			const inlineNumProps = inlineProps.numberingProperties;
			if (styleProps.numberingProperties?.ilvl === inlineNumProps?.ilvl && styleProps.numberingProperties?.numId === inlineNumProps?.numId) {
				delete inlineProps.numberingProperties;
				numberingDefinedInline = false;
			}
		}
	}
	const tableProps = tableInfo?.tableProperties?.tableStyleId ? resolveStyleChain("paragraphProperties", params, tableInfo?.tableProperties?.tableStyleId) : {};
	const cellStyleProps = resolveCellStyles("paragraphProperties", tableInfo, params.translatedLinkedStyles);
	let defaultsChain;
	if (!styleId) defaultsChain = [defaultProps, normalProps];
	else defaultsChain = [defaultProps];
	const propsChain = [
		...defaultsChain,
		tableProps,
		...cellStyleProps,
		numberingProps,
		styleProps,
		inlineProps
	];
	let indentChain;
	if (isList$2) if (numberingDefinedInline) indentChain = [
		...defaultsChain,
		styleProps,
		numberingProps,
		inlineProps
	];
	else {
		styleProps = resolveStyleChain("paragraphProperties", params, styleId, false);
		indentChain = [
			...defaultsChain,
			numberingProps,
			styleProps,
			inlineProps
		];
	}
	else indentChain = [
		...defaultsChain,
		styleProps,
		inlineProps
	];
	const finalProps = combineProperties(propsChain, { specialHandling: { tabStops: (target, source) => {
		if (target.tabStops != null && source.tabStops != null) {
			const sourceArr = source.tabStops;
			const clearPositions = /* @__PURE__ */ new Set();
			for (const ts of sourceArr) if (ts.tab?.tabType === "clear" && ts.tab.pos != null) clearPositions.add(ts.tab.pos);
			const merged = target.tabStops.filter((ts) => !(ts.tab?.pos != null && clearPositions.has(ts.tab.pos)));
			for (const ts of sourceArr) if (ts.tab?.tabType !== "clear") merged.push(ts);
			return merged;
		}
		return source.tabStops;
	} } });
	finalProps.indent = combineIndentProperties(indentChain).indent;
	return finalProps;
}
function resolveStyleChain(propertyType, params, styleId, followBasedOnChain = true) {
	if (!styleId) return {};
	const styleDef = params.translatedLinkedStyles?.styles?.[styleId];
	if (!styleDef) return {};
	const styleProps = styleDef[propertyType] ?? {};
	const basedOn = styleDef.basedOn;
	let styleChain = [styleProps];
	const seenStyles = new Set([styleId]);
	let nextBasedOn = basedOn;
	while (followBasedOnChain && nextBasedOn) {
		if (seenStyles.has(nextBasedOn)) break;
		seenStyles.add(nextBasedOn);
		const basedOnStyleDef = params.translatedLinkedStyles?.styles?.[nextBasedOn];
		const basedOnProps = basedOnStyleDef?.[propertyType];
		if (basedOnProps && Object.keys(basedOnProps).length) styleChain.push(basedOnProps);
		nextBasedOn = basedOnStyleDef?.basedOn;
	}
	styleChain = styleChain.reverse();
	return combineProperties(styleChain);
}
function getNumberingProperties$1(propertyType, params, ilvl, numId, tries = 0) {
	const numbering = params.translatedNumbering;
	if (!numbering) return {};
	const { definitions, abstracts } = numbering;
	if (!definitions || !abstracts) return {};
	const propertiesChain = [];
	const numDefinition = definitions[String(numId)];
	if (!numDefinition) return {};
	const overrideProps = (numDefinition.lvlOverrides?.[String(ilvl)])?.[propertyType];
	if (overrideProps) propertiesChain.push(overrideProps);
	const abstractNumId = numDefinition.abstractNumId;
	const listDefinitionForThisNumId = abstracts[String(abstractNumId)];
	if (!listDefinitionForThisNumId) return {};
	const numStyleLinkId = listDefinitionForThisNumId.numStyleLink ?? listDefinitionForThisNumId.styleLink;
	if (numStyleLinkId && tries < 1) {
		const numIdFromStyle = ((params.translatedLinkedStyles?.styles?.[numStyleLinkId])?.paragraphProperties)?.numberingProperties?.numId;
		if (numIdFromStyle) return getNumberingProperties$1(propertyType, params, ilvl, numIdFromStyle, tries + 1);
	}
	const levelDefinition = listDefinitionForThisNumId.levels?.[String(ilvl)];
	if (!levelDefinition) return {};
	const abstractProps = levelDefinition[propertyType];
	if (abstractProps != null) {
		if (levelDefinition?.styleId) abstractProps.styleId = levelDefinition?.styleId;
		propertiesChain.push(abstractProps);
	}
	propertiesChain.reverse();
	return combineProperties(propertiesChain);
}
function resolveTableProperties(tableStyleId, translatedLinkedStyles) {
	if (!tableStyleId || !translatedLinkedStyles?.styles) return {};
	return resolveStyleChain("tableProperties", {
		translatedLinkedStyles,
		translatedNumbering: null
	}, tableStyleId);
}
function resolveDocxFontFamily(attributes, docx, toCssFontFamily$1) {
	if (!attributes || typeof attributes !== "object") return null;
	const ascii = attributes["w:ascii"] ?? attributes["ascii"] ?? attributes["eastAsia"];
	let themeAscii = attributes["w:asciiTheme"] ?? attributes["asciiTheme"];
	if (!ascii && attributes.hint === "default" || !ascii && !themeAscii) themeAscii = "major";
	let resolved = ascii;
	if (docx && themeAscii) {
		const themeElements = docx["word/theme/theme1.xml"]?.elements;
		if (themeElements?.length) {
			const fontSchemeElements = ((((themeElements[0]?.elements)?.find((el) => el.name === "a:themeElements"))?.elements)?.find((el) => el.name === "a:fontScheme"))?.elements;
			const prefix = themeAscii.startsWith("minor") ? "minor" : "major";
			resolved = ((((fontSchemeElements?.find((el) => el.name === `a:${prefix}Font`))?.elements)?.find((el) => el.name === "a:latin"))?.attributes)?.typeface || resolved;
		}
	}
	if (!resolved) return null;
	if (toCssFontFamily$1) return toCssFontFamily$1(resolved, docx ?? void 0);
	return resolved;
}
function resolveEffectiveBandSizes(styleId, translatedLinkedStyles) {
	const seen = /* @__PURE__ */ new Set();
	let currentId = styleId;
	let rowBandSize;
	let colBandSize;
	while (currentId && !seen.has(currentId)) {
		seen.add(currentId);
		const def = translatedLinkedStyles.styles?.[currentId];
		const tblProps = def?.tableProperties;
		if (rowBandSize == null && tblProps?.tableStyleRowBandSize != null) rowBandSize = tblProps.tableStyleRowBandSize;
		if (colBandSize == null && tblProps?.tableStyleColBandSize != null) colBandSize = tblProps.tableStyleColBandSize;
		if (rowBandSize != null && colBandSize != null) break;
		currentId = def?.basedOn;
	}
	return {
		rowBandSize: rowBandSize ?? 1,
		colBandSize: colBandSize ?? 1
	};
}
function resolveConditionalProps(propertyType, styleType, styleId, translatedLinkedStyles) {
	const chain = [];
	const seen = /* @__PURE__ */ new Set();
	let currentId = styleId;
	while (currentId && !seen.has(currentId)) {
		seen.add(currentId);
		const def = translatedLinkedStyles.styles?.[currentId];
		const props = def?.tableStyleProperties?.[styleType]?.[propertyType];
		if (props) chain.push(props);
		currentId = def?.basedOn;
	}
	if (chain.length === 0) return void 0;
	chain.reverse();
	return combineProperties(chain);
}
function resolveCellStyles(propertyType, tableInfo, translatedLinkedStyles) {
	if (tableInfo == null || !tableInfo.tableProperties?.tableStyleId) return [];
	const cellStyleProps = [];
	const tableStyleId = tableInfo.tableProperties.tableStyleId;
	const { rowBandSize, colBandSize } = resolveEffectiveBandSizes(tableStyleId, translatedLinkedStyles);
	determineCellStyleTypes(tableInfo.tableProperties?.tblLook ?? DEFAULT_TBL_LOOK, tableInfo.rowIndex, tableInfo.cellIndex, tableInfo.numRows, tableInfo.numCells, rowBandSize, colBandSize, tableInfo.rowCnfStyle, tableInfo.cellCnfStyle).forEach((styleType) => {
		const typeProps = resolveConditionalProps(propertyType, styleType, tableStyleId, translatedLinkedStyles);
		if (typeProps) cellStyleProps.push(typeProps);
	});
	return cellStyleProps;
}
function resolveTableCellProperties(inlineProps, tableInfo, translatedLinkedStyles) {
	if (!translatedLinkedStyles) return inlineProps ?? {};
	const cellStyleProps = resolveCellStyles("tableCellProperties", tableInfo, translatedLinkedStyles);
	if (cellStyleProps.length === 0) return inlineProps ?? {};
	const chain = [...cellStyleProps];
	if (inlineProps && Object.keys(inlineProps).length > 0) chain.push(inlineProps);
	return combineProperties(chain, { fullOverrideProps: ["shading"] });
}
var CNF_STYLE_MAP = [
	["oddHBand", "band1Horz"],
	["evenHBand", "band2Horz"],
	["oddVBand", "band1Vert"],
	["evenVBand", "band2Vert"],
	["firstRow", "firstRow"],
	["firstColumn", "firstCol"],
	["lastRow", "lastRow"],
	["lastColumn", "lastCol"],
	["firstRowFirstColumn", "nwCell"],
	["firstRowLastColumn", "neCell"],
	["lastRowFirstColumn", "swCell"],
	["lastRowLastColumn", "seCell"]
];
var TABLE_STYLE_PRECEDENCE = [
	"wholeTable",
	"band1Horz",
	"band2Horz",
	"band1Vert",
	"band2Vert",
	"firstCol",
	"lastCol",
	"firstRow",
	"lastRow",
	"nwCell",
	"neCell",
	"swCell",
	"seCell"
];
function determineCellStyleTypes(tblLook, rowIndex, cellIndex, numRows, numCells, rowBandSize = 1, colBandSize = 1, rowCnfStyle, cellCnfStyle) {
	const applicable = new Set(["wholeTable"]);
	const normalizedRowBandSize = rowBandSize > 0 ? rowBandSize : 1;
	const normalizedColBandSize = colBandSize > 0 ? colBandSize : 1;
	const bandRowIndex = Math.max(0, rowIndex - (tblLook?.firstRow ? 1 : 0));
	const bandColIndex = Math.max(0, cellIndex - (tblLook?.firstColumn ? 1 : 0));
	const rowGroup = Math.floor(bandRowIndex / normalizedRowBandSize);
	const colGroup = Math.floor(bandColIndex / normalizedColBandSize);
	if (!tblLook?.noHBand) applicable.add(rowGroup % 2 === 0 ? "band1Horz" : "band2Horz");
	if (!tblLook?.noVBand) applicable.add(colGroup % 2 === 0 ? "band1Vert" : "band2Vert");
	const isFirstRow = !!tblLook?.firstRow && rowIndex === 0;
	const isLastRow = !!tblLook?.lastRow && numRows != null && numRows > 0 && rowIndex === numRows - 1;
	const isFirstCol = !!tblLook?.firstColumn && cellIndex === 0;
	const isLastCol = !!tblLook?.lastColumn && numCells != null && numCells > 0 && cellIndex === numCells - 1;
	if (isFirstRow) applicable.add("firstRow");
	if (isFirstCol) applicable.add("firstCol");
	if (isLastRow) applicable.add("lastRow");
	if (isLastCol) applicable.add("lastCol");
	if (isFirstRow && isFirstCol) applicable.add("nwCell");
	if (isFirstRow && isLastCol) applicable.add("neCell");
	if (isLastRow && isFirstCol) applicable.add("swCell");
	if (isLastRow && isLastCol) applicable.add("seCell");
	if (rowCnfStyle || cellCnfStyle) for (const [flag, styleType] of CNF_STYLE_MAP) {
		const rowFlag = rowCnfStyle?.[flag];
		const cellFlag = cellCnfStyle?.[flag];
		if (rowFlag === true || cellFlag === true) applicable.add(styleType);
	}
	return TABLE_STYLE_PRECEDENCE.filter((t) => applicable.has(t));
}
var getToCssFontFamily = () => {
	return SuperConverter.toCssFontFamily;
};
function encodeMarksFromRPr(runProperties, docx) {
	if (!runProperties || typeof runProperties !== "object") return [];
	const marks = [];
	const textStyleAttrs = {};
	let highlightAttrs = null;
	let hasHighlightTag = false;
	Object.keys(runProperties).forEach((key) => {
		const value = runProperties[key];
		switch (key) {
			case "strike":
			case "italic":
			case "bold":
				marks.push({
					type: key,
					attrs: { value }
				});
				break;
			case "textTransform":
				textStyleAttrs[key] = value;
				break;
			case "color":
				if (!value.val) textStyleAttrs[key] = null;
				else if (value.val.toLowerCase() === "auto") textStyleAttrs[key] = value.val;
				else textStyleAttrs[key] = `#${value["val"].replace("#", "").toUpperCase()}`;
				break;
			case "underline":
				let underlineType = value["w:val"];
				let underlineColor = value["w:color"];
				if (underlineColor && underlineColor.toLowerCase() !== "auto" && !underlineColor.startsWith("#")) underlineColor = `#${underlineColor}`;
				const underlineThemeColor = value["w:themeColor"];
				const underlineThemeTint = value["w:themeTint"];
				const underlineThemeShade = value["w:themeShade"];
				if (!underlineType && !underlineColor && !underlineThemeColor && !underlineThemeTint && !underlineThemeShade) break;
				marks.push({
					type: key,
					attrs: {
						underlineType,
						underlineColor,
						underlineThemeColor,
						underlineThemeTint,
						underlineThemeShade
					}
				});
				break;
			case "styleId":
				if (value != null) textStyleAttrs[key] = value;
				break;
			case "fontSize":
				textStyleAttrs[key] = `${halfPointToPoints(value)}pt`;
				break;
			case "letterSpacing":
				textStyleAttrs[key] = `${twipsToPt(value)}pt`;
				break;
			case "fontFamily":
				const fontFamily = resolveDocxFontFamily(value, docx, getToCssFontFamily());
				textStyleAttrs[key] = fontFamily;
				if (typeof value === "object" && value !== null) {
					const eastAsiaFamily = value["eastAsia"];
					if (eastAsiaFamily) {
						const eastAsiaCss = getFontFamilyValue$1({ "w:ascii": eastAsiaFamily }, docx);
						if (!fontFamily || eastAsiaCss !== textStyleAttrs.fontFamily) textStyleAttrs.eastAsiaFontFamily = eastAsiaCss;
					}
					const csFamily = value["cs"];
					if (csFamily) {
						const csCss = getFontFamilyValue$1({ "w:ascii": csFamily }, docx);
						if (!fontFamily || csCss !== textStyleAttrs.fontFamily) textStyleAttrs.csFontFamily = csCss;
					}
				}
				break;
			case "highlight":
				const color = getHighLightValue$1(value);
				if (color) {
					hasHighlightTag = true;
					highlightAttrs = { color };
					if (color.toLowerCase() === "transparent" && String(value?.["w:val"]).toLowerCase() === "none") highlightAttrs.ooxmlHighlightClear = true;
				}
				break;
			case "shading": {
				if (hasHighlightTag) break;
				const fill = value["fill"];
				const shdVal = value["val"];
				if (fill && String(fill).toLowerCase() !== "auto") highlightAttrs = { color: `#${String(fill).replace("#", "")}` };
				else if (typeof shdVal === "string") {
					const normalized = shdVal.toLowerCase();
					if (normalized === "clear" || normalized === "nil" || normalized === "none") highlightAttrs = { color: "transparent" };
				}
				break;
			}
			case "vertAlign":
				if (value) textStyleAttrs.vertAlign = value;
				break;
			case "position":
				if (value != null && Number.isFinite(value)) {
					const points = halfPointToPoints(value);
					if (Number.isFinite(points)) textStyleAttrs.position = `${points}pt`;
				}
				break;
		}
	});
	if (Object.keys(textStyleAttrs).length) marks.push({
		type: "textStyle",
		attrs: textStyleAttrs
	});
	if (highlightAttrs) marks.push({
		type: "highlight",
		attrs: highlightAttrs
	});
	return marks;
}
function encodeCSSFromPPr(paragraphProperties, hasPreviousParagraph, nextParagraphProps) {
	if (!paragraphProperties || typeof paragraphProperties !== "object") return {};
	let css = {};
	const { spacing, indent, borders, justification } = paragraphProperties;
	const nextStyleId = nextParagraphProps?.styleId;
	if (spacing) {
		const getEffectiveBefore = (nextSpacing, isListItem$1) => {
			if (!nextSpacing) return 0;
			if (nextSpacing.beforeAutospacing && isListItem$1) return 0;
			return nextSpacing.before || 0;
		};
		const isDropCap = Boolean(paragraphProperties.framePr?.dropCap);
		const spacingCopy = { ...spacing };
		if (hasPreviousParagraph) delete spacingCopy.before;
		if (isDropCap) {
			spacingCopy.line = linesToTwips(1);
			spacingCopy.lineRule = "auto";
			delete spacingCopy.after;
		} else {
			const nextBefore = getEffectiveBefore(nextParagraphProps?.spacing, Boolean(nextParagraphProps?.numberingProperties));
			spacingCopy.after = Math.max(spacingCopy.after || 0, nextBefore);
			if (paragraphProperties.contextualSpacing && nextStyleId != null && nextStyleId === paragraphProperties.styleId) spacingCopy.after -= paragraphProperties.spacing?.after || 0;
			if (nextParagraphProps?.contextualSpacing && nextStyleId != null && nextStyleId === paragraphProperties.styleId) spacingCopy.after -= nextBefore;
			spacingCopy.after = Math.max(spacingCopy.after, 0);
		}
		const spacingStyle = getSpacingStyle(spacingCopy, Boolean(paragraphProperties.numberingProperties));
		css = {
			...css,
			...spacingStyle
		};
	}
	if (indent && typeof indent === "object") {
		if (Object.values(indent).some((value) => value != null && Number(value) !== 0)) {
			const { left, right, firstLine, hanging } = indent;
			if (left != null) css["margin-left"] = `${twipsToPixels$2(left)}px`;
			if (right != null) css["margin-right"] = `${twipsToPixels$2(right)}px`;
			if (firstLine != null && !hanging) css["text-indent"] = `${twipsToPixels$2(firstLine)}px`;
			if (firstLine != null && hanging != null) css["text-indent"] = `${twipsToPixels$2(firstLine - hanging)}px`;
			if (firstLine == null && hanging != null) css["text-indent"] = `${twipsToPixels$2(-hanging)}px`;
		}
	}
	if (borders && typeof borders === "object") {
		const sideOrder = [
			"top",
			"right",
			"bottom",
			"left"
		];
		const valToCss = {
			single: "solid",
			dashed: "dashed",
			dotted: "dotted",
			double: "double"
		};
		sideOrder.forEach((side) => {
			const b = borders[side];
			if (!b) return;
			if ([
				"nil",
				"none",
				void 0,
				null
			].includes(b.val)) {
				css[`border-${side}`] = "none";
				return;
			}
			const width = b.size != null ? `${eighthPointsToPixels(b.size)}px` : "1px";
			const cssStyle = valToCss[b.val] || "solid";
			const color = !b.color || b.color === "auto" ? "#000000" : `#${b.color}`;
			css[`border-${side}`] = `${width} ${cssStyle} ${color}`;
			if (b.space != null && side === "bottom") css[`padding-bottom`] = `${eighthPointsToPixels(b.space)}px`;
		});
	}
	if (justification) if (justification === "both") css["text-align"] = "justify";
	else css["text-align"] = justification;
	return css;
}
function encodeCSSFromRPr(runProperties, docx) {
	if (!runProperties || typeof runProperties !== "object") return {};
	const css = {};
	const textDecorationLines = /* @__PURE__ */ new Set();
	let hasTextDecorationNone = false;
	let highlightColor = null;
	let hasHighlightTag = false;
	let verticalAlignValue;
	let fontSizeOverride;
	const normalizedPositionPoints = runProperties.position != null && Number.isFinite(runProperties.position) ? normalizeBaselineShift(halfPointToPoints(runProperties.position)) : void 0;
	Object.keys(runProperties).forEach((key) => {
		const value = runProperties[key];
		switch (key) {
			case "bold": {
				const normalized = normalizeToggleValue(value);
				if (normalized === true) css["font-weight"] = "bold";
				else if (normalized === false) css["font-weight"] = "normal";
				break;
			}
			case "italic": {
				const normalized = normalizeToggleValue(value);
				if (normalized === true) css["font-style"] = "italic";
				else if (normalized === false) css["font-style"] = "normal";
				break;
			}
			case "strike": {
				const normalized = normalizeToggleValue(value);
				if (normalized === true) addTextDecorationEntries(textDecorationLines, "line-through");
				else if (normalized === false) {
					css["text-decoration"] = "none";
					hasTextDecorationNone = true;
				}
				break;
			}
			case "textTransform":
				if (value != null) css["text-transform"] = value;
				break;
			case "color": {
				const colorVal = value?.val;
				if (colorVal == null || colorVal === "") break;
				if (String(colorVal).toLowerCase() === "auto") css["color"] = "auto";
				else css["color"] = `#${String(colorVal).replace("#", "").toUpperCase()}`;
				break;
			}
			case "underline": {
				const underlineType = value?.["w:val"];
				if (!underlineType) break;
				let underlineColor = value?.["w:color"];
				if (underlineColor && typeof underlineColor === "string" && underlineColor.toLowerCase() !== "auto" && !underlineColor.startsWith("#")) underlineColor = `#${underlineColor}`;
				const underlineCss = parseCssDeclarations(getUnderlineCssString({
					type: underlineType,
					color: underlineColor
				}));
				Object.entries(underlineCss).forEach(([prop, propValue]) => {
					if (!propValue) return;
					if (prop === "text-decoration") {
						css[prop] = propValue;
						if (propValue === "none") hasTextDecorationNone = true;
						return;
					}
					if (prop === "text-decoration-line") {
						addTextDecorationEntries(textDecorationLines, propValue);
						return;
					}
					css[prop] = propValue;
				});
				break;
			}
			case "fontSize": {
				if (value == null) break;
				const points = halfPointToPoints(value);
				if (Number.isFinite(points)) css["font-size"] = `${points}pt`;
				break;
			}
			case "letterSpacing": {
				if (value == null) break;
				const spacing = twipsToPt(value);
				if (Number.isFinite(spacing)) css["letter-spacing"] = `${spacing}pt`;
				break;
			}
			case "fontFamily": {
				if (!value) break;
				const fontFamily = resolveDocxFontFamily(value, docx, getToCssFontFamily());
				if (fontFamily) css["font-family"] = fontFamily;
				const eastAsiaFamily = typeof value === "object" && value !== null ? value["eastAsia"] : void 0;
				if (eastAsiaFamily) {
					const eastAsiaCss = getFontFamilyValue$1({ "w:ascii": eastAsiaFamily }, docx);
					if (eastAsiaCss && (!fontFamily || eastAsiaCss !== fontFamily)) css["font-family"] = css["font-family"] || eastAsiaCss;
				}
				break;
			}
			case "highlight": {
				const color = getHighLightValue$1(value);
				if (color) {
					hasHighlightTag = true;
					highlightColor = color;
				}
				break;
			}
			case "shading": {
				if (hasHighlightTag) break;
				const fill = value?.["fill"];
				const shdVal = value?.["val"];
				if (fill && String(fill).toLowerCase() !== "auto") highlightColor = `#${String(fill).replace("#", "")}`;
				else if (typeof shdVal === "string") {
					const normalized = shdVal.toLowerCase();
					if (normalized === "clear" || normalized === "nil" || normalized === "none") highlightColor = "transparent";
				}
				break;
			}
			case "vertAlign":
				if (normalizedPositionPoints != null) break;
				if (value === "superscript" || value === "subscript") {
					verticalAlignValue = value === "superscript" ? "super" : "sub";
					if (runProperties.fontSize != null && Number.isFinite(runProperties.fontSize)) {
						const scaledPoints = halfPointToPoints(runProperties.fontSize * SUBSCRIPT_SUPERSCRIPT_SCALE);
						if (Number.isFinite(scaledPoints)) fontSizeOverride = `${scaledPoints}pt`;
					} else fontSizeOverride = `${SUBSCRIPT_SUPERSCRIPT_SCALE * 100}%`;
				} else if (value === "baseline") verticalAlignValue = "baseline";
				break;
			case "position":
				if (normalizedPositionPoints != null) {
					verticalAlignValue = `${normalizedPositionPoints}pt`;
					fontSizeOverride = void 0;
				}
				break;
			default: break;
		}
	});
	if (!hasTextDecorationNone && textDecorationLines.size) {
		const combined = /* @__PURE__ */ new Set();
		addTextDecorationEntries(combined, css["text-decoration-line"]);
		textDecorationLines.forEach((entry) => combined.add(entry));
		css["text-decoration-line"] = Array.from(combined).join(" ");
	}
	if (highlightColor) {
		css["background-color"] = highlightColor;
		if (!("color" in css)) css["color"] = "inherit";
	}
	if (fontSizeOverride) css["font-size"] = fontSizeOverride;
	if (verticalAlignValue) css["vertical-align"] = verticalAlignValue;
	return css;
}
function decodeRPrFromMarks(marks) {
	const runProperties = {};
	if (!marks) return runProperties;
	marks.forEach((mark) => {
		const type = mark.type.name ?? mark.type;
		switch (type) {
			case "strike":
			case "italic":
			case "bold":
				runProperties[type] = mark.attrs.value !== "0" && mark.attrs.value !== false;
				break;
			case "underline": {
				const { underlineType, underlineColor, underlineThemeColor, underlineThemeTint, underlineThemeShade } = mark.attrs;
				const underlineAttrs = {};
				if (underlineType) underlineAttrs["w:val"] = underlineType;
				if (underlineColor) underlineAttrs["w:color"] = underlineColor.replace("#", "");
				if (underlineThemeColor) underlineAttrs["w:themeColor"] = underlineThemeColor;
				if (underlineThemeTint) underlineAttrs["w:themeTint"] = underlineThemeTint;
				if (underlineThemeShade) underlineAttrs["w:themeShade"] = underlineThemeShade;
				if (Object.keys(underlineAttrs).length > 0) runProperties.underline = underlineAttrs;
				break;
			}
			case "highlight":
				if (!mark.attrs.color) break;
				if (mark.attrs.color.toLowerCase() === "transparent") {
					if (mark.attrs.ooxmlHighlightClear) runProperties.highlight = { "w:val": "none" };
				} else runProperties.highlight = { "w:val": mark.attrs.color };
				break;
			case "link":
				runProperties.styleId = "Hyperlink";
				break;
			case "textStyle":
				Object.keys(mark.attrs).forEach((attr) => {
					const value = mark.attrs[attr];
					switch (attr) {
						case "textTransform":
							if (value != null) runProperties[attr] = value;
							break;
						case "color":
							if (value != null) runProperties.color = { val: value.replace("#", "") };
							break;
						case "fontSize": {
							const points = parseFloat(value);
							if (!isNaN(points)) {
								const halfPoints = points * 2;
								runProperties.fontSize = halfPoints;
								runProperties.fontSizeCs = halfPoints;
							}
							break;
						}
						case "letterSpacing": {
							const ptValue = parseFloat(value);
							if (!isNaN(ptValue)) runProperties.letterSpacing = ptToTwips(ptValue);
							break;
						}
						case "fontFamily":
							if (value != null) {
								const cleanValue = value.split(",")[0].trim();
								const result = {};
								[
									"ascii",
									"eastAsia",
									"hAnsi",
									"cs"
								].forEach((attr$1) => {
									result[attr$1] = cleanValue;
								});
								runProperties.fontFamily = result;
							}
							break;
						case "eastAsiaFontFamily":
							if (value != null && runProperties.fontFamily) runProperties.fontFamily.eastAsia = value.split(",")[0].trim();
							break;
						case "csFontFamily":
							if (value != null && runProperties.fontFamily) runProperties.fontFamily.cs = value.split(",")[0].trim();
							break;
						case "vertAlign":
							if (value != null) runProperties.vertAlign = value;
							break;
						case "position":
							if (value != null) {
								const numeric = parseFloat(value);
								if (!isNaN(numeric)) runProperties.position = numeric * 2;
							}
							break;
						case "styleId":
							if (value != null) runProperties.styleId = value;
							break;
					}
				});
				break;
		}
	});
	return runProperties;
}
function getFontFamilyValue$1(attributes, docx) {
	const ascii = attributes["w:ascii"] ?? attributes["ascii"];
	const themeAscii = attributes["w:asciiTheme"] ?? attributes["asciiTheme"];
	let resolved = ascii;
	if (docx && themeAscii) {
		const theme = docx["word/theme/theme1.xml"];
		if (theme?.elements?.length) {
			const { elements: topElements } = theme;
			const { elements } = topElements[0] || {};
			const fontScheme = (elements?.find((el) => el.name === "a:themeElements"))?.elements?.find((el) => el.name === "a:fontScheme");
			const prefix = themeAscii.startsWith("minor") ? "minor" : "major";
			resolved = ((fontScheme?.elements?.find((el) => el.name === `a:${prefix}Font`))?.elements?.find((el) => el.name === "a:latin"))?.attributes?.typeface || resolved;
		}
	}
	if (!resolved) return null;
	return SuperConverter.toCssFontFamily(resolved, docx);
}
function getHighLightValue$1(attributes) {
	const fill = normalizeHighlightHex(attributes?.["w:fill"]);
	if (fill) return `#${fill}`;
	const value = attributes?.["w:val"];
	if (value === "none") return "transparent";
	const normalizedValue = normalizeHighlightHex(value);
	if (normalizedValue) return `#${normalizedValue}`;
	return getHexColorFromDocxSystem(value) || null;
}
function normalizeHighlightHex(rawValue) {
	if (typeof rawValue !== "string") return null;
	const trimmedValue = rawValue.trim();
	if (!trimmedValue || trimmedValue.toLowerCase() === "auto") return null;
	const normalizedValue = normalizeHexColor(trimmedValue);
	if (!normalizedValue || !isValidHexColor(normalizedValue)) return null;
	return normalizedValue;
}
function normalizeToggleValue(value) {
	if (value == null) return null;
	if (typeof value === "boolean") return value;
	if (typeof value === "number") return value !== 0;
	if (typeof value === "string") {
		const normalized = value.toLowerCase();
		if (normalized === "0" || normalized === "false" || normalized === "off") return false;
		if (normalized === "1" || normalized === "true" || normalized === "on") return true;
	}
	return Boolean(value);
}
function parseCssDeclarations(cssString) {
	if (!cssString || typeof cssString !== "string") return {};
	return cssString.split(";").map((chunk) => chunk.trim()).filter(Boolean).reduce((acc, declaration) => {
		const separatorIndex = declaration.indexOf(":");
		if (separatorIndex === -1) return acc;
		const property = declaration.slice(0, separatorIndex).trim();
		const value = declaration.slice(separatorIndex + 1).trim();
		if (!property || !value) return acc;
		acc[property] = value;
		return acc;
	}, {});
}
function addTextDecorationEntries(targetSet, value) {
	if (!value) return;
	if (value instanceof Set) {
		value.forEach((entry) => addTextDecorationEntries(targetSet, entry));
		return;
	}
	String(value).split(/\s+/).map((entry) => entry.trim()).filter(Boolean).forEach((entry) => targetSet.add(entry));
}
const getSpacingStyle = (spacing, isListItem$1) => {
	let { before, after, line, lineRule, beforeAutospacing, afterAutospacing } = spacing;
	line = twipsToLines(line);
	if (line != null && line < 1) line = 1;
	if (lineRule === "exact" && line) line = String(line);
	before = twipsToPixels$2(before);
	if (beforeAutospacing) {
		if (isListItem$1) before = 0;
	}
	after = twipsToPixels$2(after);
	if (afterAutospacing) {
		if (isListItem$1) after = 0;
	}
	const css = {};
	if (before) css["margin-top"] = `${before}px`;
	if (after) css["margin-bottom"] = `${after}px`;
	if (line) {
		if (lineRule !== "atLeast" || line >= 1) {
			line = Math.max(line, 1);
			css["line-height"] = String(line);
		}
	}
	return css;
};
const ParagraphSplitSnapshotType = "paragraphSplit";
var getMarkType$1 = (mark) => mark?.type?.name ?? mark?.type ?? null;
var getSnapshotType = (snapshot) => snapshot?.type?.name ?? snapshot?.type ?? null;
var isDecimalString = (value) => typeof value === "string" && /^\d+$/.test(value);
var toRunPropertyElements = (marks = []) => processOutputMarks(marks).filter((element) => element && typeof element === "object" && element.name);
var hashStringToDecimalId = (value) => {
	const source = String(value || "0");
	let hash = 0;
	for (let i$1 = 0; i$1 < source.length; i$1++) hash = hash * 31 + source.charCodeAt(i$1) >>> 0;
	return String(hash || 1);
};
var getTrackFormatChangeWordId = (trackFormatMark, options = {}) => {
	const allocator = options?.wordIdAllocator || null;
	const partPath = options?.partPath || "word/document.xml";
	const sourceId = trackFormatMark.attrs?.sourceId == null ? "" : String(trackFormatMark.attrs.sourceId);
	const logicalId = trackFormatMark.attrs?.id == null ? "" : String(trackFormatMark.attrs.id);
	if (allocator) return allocator.allocate({
		partPath,
		sourceId,
		logicalId
	});
	if (isDecimalString(sourceId)) return sourceId;
	if (isDecimalString(logicalId)) return logicalId;
	return hashStringToDecimalId(sourceId || logicalId);
};
var getTrackChangeAuthor = (trackFormatMark) => {
	const author = trackFormatMark.attrs?.author;
	return author == null ? "" : String(author);
};
const findTrackFormatMark = (marks = []) => marks.find((mark) => getMarkType$1(mark) === "trackFormat") ?? null;
const findSnapshotByType = (snapshots = [], type) => Array.isArray(snapshots) ? snapshots.find((snapshot) => getSnapshotType(snapshot) === type) ?? null : null;
const findParagraphSplitSnapshot = (trackFormatMark) => {
	if (!trackFormatMark) return null;
	return findSnapshotByType(trackFormatMark.attrs?.before, "paragraphSplit") || findSnapshotByType(trackFormatMark.attrs?.after, "paragraphSplit");
};
const isParagraphSplitTrackFormatMark = (mark) => getMarkType$1(mark) === "trackFormat" && Boolean(findParagraphSplitSnapshot(mark));
const createParagraphSplitInsertionElement = (trackFormatMark, options = {}) => {
	if (!findParagraphSplitSnapshot(trackFormatMark)) return void 0;
	return {
		type: "element",
		name: "w:ins",
		attributes: {
			"w:id": getTrackFormatChangeWordId(trackFormatMark, options),
			"w:author": getTrackChangeAuthor(trackFormatMark),
			"w:date": trackFormatMark.attrs?.date
		}
	};
};
const createRunPropertiesChangeElement = (trackFormatMark, options = {}) => {
	if (!trackFormatMark) return void 0;
	const previousRunProperties = {
		type: "element",
		name: "w:rPr",
		elements: toRunPropertyElements(Array.isArray(trackFormatMark.attrs?.before) ? trackFormatMark.attrs.before : [])
	};
	const wordId = getTrackFormatChangeWordId(trackFormatMark, options);
	return {
		type: "element",
		name: "w:rPrChange",
		attributes: {
			"w:id": wordId,
			"w:author": getTrackChangeAuthor(trackFormatMark),
			"w:date": trackFormatMark.attrs?.date
		},
		elements: [previousRunProperties]
	};
};
const appendTrackFormatChangeToRunProperties = (runPropertiesNode, marks = [], options = {}) => {
	if (!runPropertiesNode) return runPropertiesNode;
	const trackFormatMark = findTrackFormatMark(marks);
	if (!trackFormatMark) return runPropertiesNode;
	if (!Array.isArray(runPropertiesNode.elements)) runPropertiesNode.elements = [];
	if (runPropertiesNode.elements.some((element) => element?.name === "w:rPrChange")) return runPropertiesNode;
	const changeElement = createRunPropertiesChangeElement(trackFormatMark, options);
	if (changeElement) runPropertiesNode.elements.push(changeElement);
	return runPropertiesNode;
};
function getInlineParagraphMarkInsertion(params) {
	return params?.extraParams?.inlineParagraphProperties?.runProperties?.trackInsert || null;
}
function isMatchingParagraphMarkInsertion(trackInsert, ids) {
	if (!trackInsert || typeof trackInsert !== "object") return false;
	const insertionId = trackInsert.id;
	if (insertionId == null) return false;
	return ids.some((id) => id != null && String(id) === String(insertionId));
}
function createParagraphSplitSnapshots() {
	const snapshot = {
		type: ParagraphSplitSnapshotType,
		attrs: { anchor: "source" }
	};
	return {
		before: [snapshot],
		after: [{
			...snapshot,
			attrs: { ...snapshot.attrs }
		}]
	};
}
function parseMarks(property, unknownMarks = [], docx = null) {
	const marks = [];
	const seen = /* @__PURE__ */ new Set();
	property?.elements?.forEach((element) => {
		const marksForType = SuperConverter.markTypes.filter((mark) => mark.name === element.name);
		if (!marksForType.length) {
			if ([
				"w:shd",
				"w:rStyle",
				"w:pStyle",
				"w:numPr",
				"w:outlineLvl",
				"w:bdr",
				"w:noProof",
				"w:contextualSpacing",
				"w:keepNext",
				"w:tabs",
				"w:keepLines"
			].includes(element.name)) unknownMarks.push(element.name);
		}
		let filteredMarksForType = marksForType;
		if (element.name === "w:spacing") {
			const hasLetterSpacing = (element.attributes || {})["w:val"];
			filteredMarksForType = marksForType.filter((m) => {
				if (hasLetterSpacing) return m.type === "letterSpacing";
				return m.type === "lineHeight";
			});
		}
		filteredMarksForType.forEach((m) => {
			if (!m || seen.has(m.type)) return;
			seen.add(m.type);
			const { attributes = {} } = element;
			const newMark = { type: m.type };
			if ((attributes["w:val"] === "0" || attributes["w:val"] === "none") && ![
				"w:b",
				"w:caps",
				"w:strike",
				"w:dstrike"
			].includes(m.name)) return;
			if (["w:u"].includes(m.name) && !attributes["w:val"]) return;
			if (m.mark) newMark.type = m.mark;
			if (m.name === "w:caps") {
				newMark.attrs = {};
				if (attributes["w:val"] === "0") newMark.attrs[m.property] = "none";
				else newMark.attrs[m.property] = "uppercase";
				marks.push(newMark);
				return;
			}
			if (Object.keys(attributes).length) {
				const value = getMarkValue(m.type, attributes, docx);
				if (value === null || value === void 0) return;
				newMark.attrs = {};
				newMark.attrs[m.property] = value;
			}
			marks.push(newMark);
		});
	});
	return createImportMarks(marks);
}
function handleStyleChangeMarksV2(rPrChange, currentMarks, params) {
	if (!rPrChange) return [];
	const attributes = rPrChange.attributes || {};
	const { partPath, sourceId, logicalId } = resolveTrackedChangeImportIds(params, attributes["w:id"]);
	const mappedAttributes = {
		id: logicalId,
		sourceId,
		date: attributes["w:date"],
		author: attributes["w:author"],
		authorEmail: attributes["w:authorEmail"]
	};
	stampImportTrackingAttrs({
		params,
		attrs: mappedAttributes,
		side: "formatting",
		sourceId,
		partPath
	});
	let submarks = [];
	const rPr = rPrChange.elements?.find((el) => el.name === "w:rPr");
	if (rPr) submarks = encodeMarksFromRPr(translator$133.encode({
		...params,
		nodes: [rPr]
	}) || {}, params?.docx);
	if (isMatchingParagraphMarkInsertion(getInlineParagraphMarkInsertion(params), [
		attributes["w:id"],
		sourceId,
		logicalId
	])) {
		const snapshots = createParagraphSplitSnapshots();
		return [{
			type: TrackFormatMarkName,
			attrs: {
				...mappedAttributes,
				...snapshots
			}
		}];
	}
	return [{
		type: TrackFormatMarkName,
		attrs: {
			...mappedAttributes,
			before: submarks,
			after: [...currentMarks]
		}
	}];
}
function handleStyleChangeMarks(rPr, currentMarks) {
	const styleChangeMark = rPr.elements?.find((el) => el.name === "w:rPrChange");
	if (!styleChangeMark) return [];
	const { attributes } = styleChangeMark;
	const mappedAttributes = {
		id: attributes["w:id"],
		sourceId: attributes["w:id"],
		date: attributes["w:date"],
		author: attributes["w:author"],
		authorEmail: attributes["w:authorEmail"]
	};
	const submarks = parseMarks(styleChangeMark);
	return [{
		type: TrackFormatMarkName,
		attrs: {
			...mappedAttributes,
			before: submarks,
			after: [...currentMarks]
		}
	}];
}
function createImportMarks(marks) {
	const textStyleMarksToCombine = marks.filter((mark) => mark.type === "textStyle");
	const remainingMarks = marks.filter((mark) => mark.type !== "textStyle");
	const combinedTextAttrs = {};
	if (textStyleMarksToCombine.length) textStyleMarksToCombine.forEach((mark) => {
		const { attrs = {} } = mark;
		Object.keys(attrs).forEach((attr) => {
			combinedTextAttrs[attr] = attrs[attr];
		});
	});
	return [...remainingMarks, {
		type: "textStyle",
		attrs: combinedTextAttrs
	}];
}
function getMarkValue(markType, attributes, docx) {
	if (markType === "tabs") markType = "textIndent";
	const markValueMapper = {
		color: () => `#${attributes["w:val"]}`,
		fontSize: () => `${attributes["w:val"] / 2}pt`,
		textIndent: () => getIndentValue(attributes),
		fontFamily: () => getFontFamilyValue(attributes, docx),
		lineHeight: () => getLineHeightValue(attributes),
		letterSpacing: () => `${twipsToPt(attributes["w:val"])}pt`,
		textAlign: () => attributes["w:val"],
		link: () => attributes["href"],
		underline: () => attributes["w:val"],
		bold: () => attributes?.["w:val"] || null,
		italic: () => attributes?.["w:val"] || null,
		highlight: () => getHighLightValue(attributes),
		strike: () => getStrikeValue(attributes)
	};
	if (!(markType in markValueMapper)) {}
	if (markType in markValueMapper) return markValueMapper[markType]();
}
function getFontFamilyValue(attributes, docx) {
	const ascii = attributes["w:ascii"] ?? attributes["ascii"];
	const themeAscii = attributes["w:asciiTheme"] ?? attributes["asciiTheme"];
	let resolved = ascii;
	if (docx && themeAscii) {
		const theme = docx["word/theme/theme1.xml"];
		if (theme?.elements?.length) {
			const { elements: topElements } = theme;
			const { elements } = topElements[0] || {};
			const fontScheme = (elements?.find((el) => el.name === "a:themeElements"))?.elements?.find((el) => el.name === "a:fontScheme");
			const prefix = themeAscii.startsWith("minor") ? "minor" : "major";
			resolved = ((fontScheme?.elements?.find((el) => el.name === `a:${prefix}Font`))?.elements?.find((el) => el.name === "a:latin"))?.attributes?.typeface || resolved;
		}
	}
	if (!resolved) return null;
	return SuperConverter.toCssFontFamily(resolved, docx);
}
function getIndentValue(attributes) {
	let value = attributes["w:left"];
	if (!value) return null;
	return `${twipsToInches(value)}in`;
}
function getLineHeightValue(attributes) {
	const value = attributes["w:line"];
	const lineRule = attributes["w:lineRule"];
	if (!value || value === "0") return null;
	if (lineRule === "exact") return `${twipsToPt(value)}pt`;
	return `${twipsToLines(value)}`;
}
function getHighLightValue(attributes) {
	const fill = attributes["w:fill"];
	if (fill && fill !== "auto") return `#${fill}`;
	if (isValidHexColor(attributes?.["w:val"])) return `#${attributes["w:val"]}`;
	return getHexColorFromDocxSystem(attributes?.["w:val"]) || null;
}
function getStrikeValue(attributes) {
	const raw = attributes?.["w:val"];
	if (raw === void 0 || raw === null) return "1";
	const value = String(raw).trim().toLowerCase();
	if (value === "1" || value === "true" || value === "on") return "1";
	if (value === "0" || value === "false" || value === "off") return "0";
	return "1";
}
function parseProperties(node) {
	const marks = [];
	const unknownMarks = [];
	const { attributes = {}, elements = [] } = node;
	const { nodes, paragraphProperties = {}, runProperties = {} } = splitElementsAndProperties(elements);
	if (elements.find((element) => element.name === "w:r")) paragraphProperties.elements = paragraphProperties?.elements?.filter((el) => el.name !== "w:rPr");
	if (runProperties && runProperties?.elements?.length) marks.push(...parseMarks(runProperties, unknownMarks));
	if (paragraphProperties && paragraphProperties.elements?.length) {
		const disallowedParagraphProperties = ["w:u"];
		const filteredParagraphProperties = {
			...paragraphProperties,
			elements: paragraphProperties.elements?.filter((el) => !disallowedParagraphProperties.includes(el.name))
		};
		marks.push(...parseMarks(filteredParagraphProperties, unknownMarks));
	}
	marks.push(...handleStyleChangeMarks(runProperties, marks));
	if (paragraphProperties && paragraphProperties.elements?.length) attributes["paragraphProperties"] = paragraphProperties;
	if (marks && node.name === "w:p") marks.forEach((mark) => {
		const attrValue = Object.keys(mark.attrs ?? {})[0];
		if (attrValue) attributes[attrValue] = mark.attrs[attrValue];
	});
	return {
		elements: nodes,
		attributes,
		marks,
		unknownMarks
	};
}
function splitElementsAndProperties(elements) {
	const pPr = elements.find((el) => el.name === "w:pPr");
	const rPr = elements.find((el) => el.name === "w:rPr");
	const sectPr = elements.find((el) => el.name === "w:sectPr");
	return {
		nodes: elements.filter((el) => el.name !== "w:pPr" && el.name !== "w:rPr" && el.name !== "w:sectPr"),
		paragraphProperties: pPr,
		runProperties: rPr,
		sectionProperties: sectPr
	};
}
const SUPPORTED_ALTERNATE_CONTENT_REQUIRES = new Set([
	"wps",
	"wpg",
	"wp14",
	"w14",
	"w15",
	"w16",
	"w16cex",
	"w16cid",
	"w16du",
	"w16sdtdh",
	"w16sdtfl",
	"w16se"
]);
var XML_NODE_NAME$34 = "mc:AlternateContent";
var SD_NODE_NAME$32 = [];
var validXmlAttributes$9 = [];
function encode$61(params) {
	const { nodeListHandler } = params;
	const { node } = params.extraParams;
	if (!node || !node.type) return null;
	const { branch, elements } = selectAlternateContentElements(node);
	if (!elements) return null;
	return nodeListHandler.handler({
		...params,
		nodes: elements,
		path: buildPath(params.path, node, branch)
	});
}
function decode$63(params) {
	const { node } = params;
	const { drawingContent } = node.attrs;
	if (!hasValidDrawingContent(drawingContent)) return null;
	const drawing = {
		name: "w:drawing",
		elements: [...drawingContent ? [...drawingContent.elements || []] : []]
	};
	return {
		name: "mc:AlternateContent",
		elements: [{
			name: "mc:Choice",
			attributes: { Requires: "wps" },
			elements: [drawing]
		}, {
			name: "mc:Fallback",
			elements: [{
				name: "w:drawing",
				elements: carbonCopy(drawing.elements || [])
			}]
		}]
	};
}
const config$34 = {
	xmlName: XML_NODE_NAME$34,
	sdNodeOrKeyName: SD_NODE_NAME$32,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$61,
	decode: decode$63,
	attributes: validXmlAttributes$9
};
function selectAlternateContentElements(node) {
	if (!node?.elements?.length) return {
		branch: null,
		elements: null
	};
	const choices = node.elements.filter((el) => el?.name === "mc:Choice");
	const fallback = node.elements.find((el) => el?.name === "mc:Fallback");
	const branch = choices.find((choice) => {
		const requiresAttr = choice?.attributes?.Requires || choice?.attributes?.requires;
		if (!requiresAttr) return false;
		const requiredNamespaces = requiresAttr.split(/\s+/).filter(Boolean);
		if (requiredNamespaces.length === 0) return false;
		return requiredNamespaces.every((namespace) => SUPPORTED_ALTERNATE_CONTENT_REQUIRES.has(namespace));
	}) || fallback || choices[0] || null;
	const selectedElements = branch?.elements;
	if (!selectedElements) return {
		branch,
		elements: null
	};
	return {
		branch,
		elements: carbonCopy(selectedElements)
	};
}
const translator$34 = NodeTranslator.from(config$34);
function buildPath(existingPath = [], node, branch) {
	const path = [...existingPath];
	if (node) path.push(node);
	if (branch) path.push(branch);
	return path;
}
function hasValidDrawingContent(drawingContent) {
	const drawingChildren = drawingContent?.elements;
	if (!Array.isArray(drawingChildren) || drawingChildren.length === 0) return false;
	return drawingChildren.some((child) => child && typeof child === "object" && (child.name === "wp:inline" || child.name === "wp:anchor"));
}
const translator$41 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:adjustRightInd"));
const translator$43 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:autoSpaceDE"));
const translator$44 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:autoSpaceDN"));
const translator$212 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:bidi", "rightToLeft"));
const translator$55 = NodeTranslator.from({
	xmlName: "w:cnfStyle",
	sdNodeOrKeyName: "cnfStyle",
	attributes: [
		"w:evenHBand",
		"w:evenVBand",
		"w:firstColumn",
		"w:firstRow",
		"w:firstRowFirstColumn",
		"w:firstRowLastColumn",
		"w:lastColumn",
		"w:lastRow",
		"w:lastRowFirstColumn",
		"w:lastRowLastColumn",
		"w:oddHBand",
		"w:oddVBand"
	].map((attr) => createAttributeHandler(attr, null, parseBoolean, booleanToString)).concat([createAttributeHandler("w:val")]),
	encode: (_, encodedAttrs) => {
		return Object.keys(encodedAttrs).length > 0 ? encodedAttrs : void 0;
	},
	decode: function({ node }) {
		if (!node.attrs?.cnfStyle) return;
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs.cnfStyle || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$57 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:contextualSpacing"));
const translator$60 = NodeTranslator.from(createSingleAttrPropertyHandler("w:divId"));
const translator$68 = NodeTranslator.from({
	xmlName: "w:framePr",
	sdNodeOrKeyName: "framePr",
	attributes: [
		createBooleanAttributeHandler("w:anchorLock"),
		createAttributeHandler("w:dropCap"),
		createIntegerAttributeHandler("w:h"),
		createAttributeHandler("w:hAnchor"),
		createAttributeHandler("w:hRule"),
		createIntegerAttributeHandler("w:hSpace"),
		createIntegerAttributeHandler("w:lines"),
		createAttributeHandler("w:vAnchor"),
		createIntegerAttributeHandler("w:vSpace"),
		createIntegerAttributeHandler("w:w"),
		createAttributeHandler("w:wrap"),
		createIntegerAttributeHandler("w:x"),
		createAttributeHandler("w:xAlign"),
		createIntegerAttributeHandler("w:y"),
		createAttributeHandler("w:yAlign")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["framePr"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$83 = NodeTranslator.from({
	xmlName: "w:ind",
	sdNodeOrKeyName: "indent",
	attributes: [
		createIntegerAttributeHandler("w:end"),
		createIntegerAttributeHandler("w:endChars"),
		createIntegerAttributeHandler("w:firstLine"),
		createIntegerAttributeHandler("w:firstLineChars"),
		createIntegerAttributeHandler("w:hanging"),
		createIntegerAttributeHandler("w:hangingChars"),
		createIntegerAttributeHandler("w:left"),
		createIntegerAttributeHandler("w:leftChars"),
		createIntegerAttributeHandler("w:right"),
		createIntegerAttributeHandler("w:rightChars"),
		createIntegerAttributeHandler("w:start"),
		createIntegerAttributeHandler("w:startChars")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["indent"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$88 = NodeTranslator.from(createSingleAttrPropertyHandler("w:jc", "justification", "w:val", (v) => v === "both" ? "justify" : v, (v) => v === "justify" ? "both" : v));
const translator$89 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:keepLines"));
const translator$90 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:keepNext"));
const translator$92 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:kinsoku"));
const translator$105 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:mirrorIndents"));
const translator$81 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:ilvl"));
const translator$114 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:numId"));
var propertyTranslators$15 = [
	translator$34,
	translator$81,
	translator$114
];
const translator$116 = NodeTranslator.from(createNestedPropertiesTranslator("w:numPr", "numberingProperties", propertyTranslators$15));
const translator$121 = NodeTranslator.from(createSingleAttrPropertyHandler("w:outlineLvl", "outlineLvl", "w:val", parseInteger$1, integerToString));
const translator$122 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:overflowPunct"));
const translator$49 = NodeTranslator.from(createBorderPropertyHandler("w:bar"));
const translator$213 = NodeTranslator.from(createBorderPropertyHandler("w:between"));
const translator$52 = NodeTranslator.from(createBorderPropertyHandler("w:bottom"));
const translator$205 = NodeTranslator.from(createMeasurementPropertyHandler("w:bottom", "marginBottom"));
const translator$106 = NodeTranslator.from(createBorderPropertyHandler("w:left"));
const translator$207 = NodeTranslator.from(createMeasurementPropertyHandler("w:left", "marginLeft"));
const translator$137 = NodeTranslator.from(createBorderPropertyHandler("w:right"));
const translator$208 = NodeTranslator.from(createMeasurementPropertyHandler("w:right", "marginRight"));
const translator$173 = NodeTranslator.from(createBorderPropertyHandler("w:top"));
const translator$210 = NodeTranslator.from(createMeasurementPropertyHandler("w:top", "marginTop"));
var propertyTranslators$14 = [
	translator$34,
	translator$49,
	translator$213,
	translator$52,
	translator$106,
	translator$137,
	translator$173
];
const translator$124 = NodeTranslator.from(createNestedPropertiesTranslator("w:pBdr", "borders", propertyTranslators$14));
const translator$131 = NodeTranslator.from(createSingleAttrPropertyHandler("w:pStyle", "styleId"));
const translator$123 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:pageBreakBefore"));
const translator$148 = NodeTranslator.from({
	xmlName: "w:spacing",
	sdNodeOrKeyName: "spacing",
	attributes: [
		createIntegerAttributeHandler("w:after"),
		createBooleanAttributeHandler("w:afterAutospacing"),
		createIntegerAttributeHandler("w:afterLines"),
		createIntegerAttributeHandler("w:before"),
		createBooleanAttributeHandler("w:beforeAutospacing"),
		createIntegerAttributeHandler("w:beforeLines"),
		createIntegerAttributeHandler("w:line"),
		createAttributeHandler("w:lineRule")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["spacing"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$149 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:suppressAutoHyphens"));
const translator$150 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:suppressLineNumbers"));
const translator$151 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:suppressOverlap"));
var propertyTranslators$13 = [translator$34, translator$3];
const translator$155 = NodeTranslator.from(createNestedArrayPropertyHandler("w:tabs", "tabStops", propertyTranslators$13, { skipRun: true }));
const translator$194 = NodeTranslator.from(createSingleAttrPropertyHandler("w:textAlignment"));
const translator$187 = NodeTranslator.from(createSingleAttrPropertyHandler("w:textDirection"));
const translator$195 = NodeTranslator.from(createSingleAttrPropertyHandler("w:textboxTightWrap"));
const translator$196 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:topLinePunct"));
const translator$199 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:widowControl"));
const translator$200 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:wordWrap"));
const basePropertyTranslators = [
	translator$34,
	translator$41,
	translator$43,
	translator$44,
	translator$212,
	translator$55,
	translator$57,
	translator$60,
	translator$68,
	translator$83,
	translator$88,
	translator$89,
	translator$90,
	translator$92,
	translator$105,
	translator$116,
	translator$121,
	translator$122,
	translator$124,
	translator$131,
	translator$123,
	translator$140,
	translator$142,
	translator$148,
	translator$149,
	translator$150,
	translator$151,
	translator$155,
	translator$194,
	translator$187,
	translator$195,
	translator$196,
	translator$199,
	translator$200,
	translator$133
];
var pPrTranslator = NodeTranslator.from(createNestedPropertiesTranslator("w:pPr", "paragraphProperties", basePropertyTranslators));
var ATTRIBUTE_HANDLERS = [
	createAttributeHandler("w:id"),
	createAttributeHandler("w:author"),
	createAttributeHandler("w:date")
];
function getSectPr(pPrNode) {
	const sectPr = pPrNode?.elements?.find((el) => el.name === "w:sectPr");
	return sectPr ? carbonCopy(sectPr) : void 0;
}
const translator$130 = NodeTranslator.from({
	xmlName: "w:pPrChange",
	sdNodeOrKeyName: "change",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: ATTRIBUTE_HANDLERS,
	encode: (params, encodedAttrs = {}) => {
		const pPrNode = params.nodes[0]?.elements?.find((el) => el.name === "w:pPr");
		let paragraphProperties = pPrNode ? pPrTranslator.encode({
			...params,
			nodes: [pPrNode]
		}) ?? {} : void 0;
		const sectPr = getSectPr(pPrNode);
		if (sectPr) paragraphProperties = {
			...paragraphProperties || {},
			sectPr
		};
		const result = {
			...encodedAttrs,
			...paragraphProperties ? { paragraphProperties } : {}
		};
		return Object.keys(result).length ? result : void 0;
	},
	decode: function(params) {
		const change = params.node?.attrs?.change;
		if (!change || typeof change !== "object") return void 0;
		const decodedAttrs = this.decodeAttributes({ node: {
			...params.node,
			attrs: change
		} });
		const hasParagraphProperties$1 = Object.prototype.hasOwnProperty.call(change, "paragraphProperties");
		const paragraphProperties = hasParagraphProperties$1 ? change.paragraphProperties : void 0;
		let pPrNode = paragraphProperties && typeof paragraphProperties === "object" ? pPrTranslator.decode({
			...params,
			node: {
				...params.node,
				attrs: { paragraphProperties }
			}
		}) : void 0;
		const sectPr = paragraphProperties?.sectPr ? carbonCopy(paragraphProperties.sectPr) : void 0;
		if (sectPr) {
			if (!pPrNode) pPrNode = {
				name: "w:pPr",
				type: "element",
				attributes: {},
				elements: []
			};
			pPrNode.elements = [...pPrNode.elements || [], sectPr];
		}
		if (!pPrNode && hasParagraphProperties$1) pPrNode = {
			name: "w:pPr",
			type: "element",
			attributes: {},
			elements: []
		};
		if (!pPrNode && !Object.keys(decodedAttrs).length) return void 0;
		return {
			name: "w:pPrChange",
			type: "element",
			attributes: decodedAttrs,
			elements: pPrNode ? [pPrNode] : []
		};
	}
});
var propertyTranslators$12 = [...basePropertyTranslators, translator$130];
const translator$129 = NodeTranslator.from(createNestedPropertiesTranslator("w:pPr", "paragraphProperties", propertyTranslators$12));
var INLINE_FALLBACK_TYPES = new Set([
	"text",
	"run",
	"bookmarkStart",
	"bookmarkEnd",
	"tab",
	"lineBreak",
	"hardBreak",
	"commentRangeStart",
	"commentRangeEnd",
	"commentReference",
	"permStart",
	"permEnd",
	"footnoteReference",
	"endnoteReference",
	"fieldAnnotation",
	"structuredContent",
	"image",
	"mathInline",
	"passthroughInline",
	"page-number",
	"total-page-number",
	"section-page-count",
	"pageReference",
	"crossReference",
	"citation",
	"authorityEntry",
	"sequenceField",
	"indexEntry",
	"tableOfContentsEntry"
]);
function isInlineNode(node, schema) {
	if (!node || typeof node !== "object" || typeof node.type !== "string") return false;
	const nodeType = schema?.nodes?.[node.type];
	if (nodeType) {
		if (typeof nodeType.isInline === "boolean") return nodeType.isInline;
		if (nodeType.spec?.group && typeof nodeType.spec.group === "string") return nodeType.spec.group.split(" ").includes("inline");
	}
	return INLINE_FALLBACK_TYPES.has(node.type);
}
function getTableStyleId(path) {
	const tbl = path.find((ancestor) => ancestor.name === "w:tbl");
	if (!tbl) return;
	const tblPr = tbl.elements?.find((child) => child.name === "w:tblPr");
	if (!tblPr) return;
	const tblStyle = tblPr.elements?.find((child) => child.name === "w:tblStyle");
	if (!tblStyle) return;
	return tblStyle.attributes?.["w:val"];
}
function cloneParagraphAttrsForFragment(attrs, { keepSectPr = false } = {}) {
	if (!attrs) return {};
	const nextAttrs = { ...attrs };
	if (attrs.paragraphProperties && typeof attrs.paragraphProperties === "object") {
		nextAttrs.paragraphProperties = { ...attrs.paragraphProperties };
		if (!keepSectPr) delete nextAttrs.paragraphProperties.sectPr;
	}
	if (!keepSectPr) delete nextAttrs.pageBreakSource;
	return nextAttrs;
}
function hasSectionBreakAttrs(attrs) {
	return Boolean(attrs?.paragraphProperties?.sectPr);
}
function cloneWrapperParagraphAttrs(attrs) {
	return cloneParagraphAttrsForFragment(attrs, { keepSectPr: true });
}
function normalizeParagraphChildren(children, schema, textblockAttrs) {
	const normalized = [];
	let pendingInline = [];
	const flushInline = () => {
		if (!pendingInline.length) return;
		normalized.push({
			type: "paragraph",
			attrs: null,
			content: pendingInline,
			marks: []
		});
		pendingInline = [];
	};
	for (const child of children || []) {
		if (isInlineNode(child, schema)) {
			pendingInline.push(child);
			continue;
		}
		flushInline();
		if (child != null) normalized.push(child);
	}
	flushInline();
	const lastNodeIndex = normalized.length - 1;
	const isSingleBlockResult = normalized.length === 1 && normalized[0] != null && normalized[0]?.type !== "paragraph";
	const paragraphIndexes = normalized.reduce((indexes, node, index) => {
		if (node?.type === "paragraph") indexes.push(index);
		return indexes;
	}, []);
	const lastParagraphIndex = paragraphIndexes.length ? paragraphIndexes[paragraphIndexes.length - 1] : -1;
	const shouldAttachWrapperParagraph = isSingleBlockResult || hasSectionBreakAttrs(textblockAttrs) && lastNodeIndex !== lastParagraphIndex;
	paragraphIndexes.forEach((index) => {
		normalized[index] = {
			...normalized[index],
			attrs: cloneParagraphAttrsForFragment(textblockAttrs, { keepSectPr: !shouldAttachWrapperParagraph && index === lastParagraphIndex })
		};
	});
	if (shouldAttachWrapperParagraph) {
		const lastNode = normalized[lastNodeIndex];
		normalized[lastNodeIndex] = {
			...lastNode,
			attrs: {
				...lastNode?.attrs || {},
				wrapperParagraph: cloneWrapperParagraphAttrs(textblockAttrs)
			}
		};
	}
	return normalized;
}
const handleParagraphNode$2 = (params) => {
	const { nodes, nodeListHandler, filename, editor } = params;
	const node = carbonCopy(nodes[0]);
	let schemaNode;
	const pPr = node.elements?.find((el) => el.name === "w:pPr");
	let inlineParagraphProperties = {};
	if (pPr) {
		inlineParagraphProperties = translator$129.encode({
			...params,
			nodes: [pPr]
		}) || {};
		if (inlineParagraphProperties.runProperties && typeof inlineParagraphProperties.runProperties === "object") inlineParagraphProperties.runPropertiesInlineKeys = Object.keys(inlineParagraphProperties.runProperties);
	}
	const tableStyleId = getTableStyleId(params.path || []);
	const resolvedParagraphProperties = resolveParagraphProperties(params, inlineParagraphProperties, { tableStyleId });
	const { elements = [], attributes = {}, marks = [] } = parseProperties(node, params.docx);
	const childContent = [];
	if (elements.length) {
		const updatedElements = elements.map((el) => {
			if (!el.marks) el.marks = [];
			el.marks.push(...marks);
			return el;
		});
		const childParams = {
			...params,
			nodes: updatedElements,
			extraParams: {
				...params.extraParams,
				paragraphProperties: resolvedParagraphProperties,
				inlineParagraphProperties,
				numberingDefinedInline: Boolean(inlineParagraphProperties.numberingProperties)
			},
			path: [...params.path || [], node]
		};
		const translatedChildren = nodeListHandler.handler(childParams);
		childContent.push(...translatedChildren);
	}
	schemaNode = {
		type: "paragraph",
		content: childContent,
		attrs: { ...attributes },
		marks: []
	};
	schemaNode.type = "paragraph";
	schemaNode.attrs.paragraphProperties = inlineParagraphProperties;
	schemaNode.attrs.rsidRDefault = node.attributes?.["w:rsidRDefault"];
	schemaNode.attrs.filename = filename;
	const sectPr = pPr?.elements?.find((el) => el.name === "w:sectPr");
	if (sectPr) {
		schemaNode.attrs.paragraphProperties.sectPr = sectPr;
		schemaNode.attrs.pageBreakSource = "sectPr";
	}
	const normalizedNodes = normalizeParagraphChildren(schemaNode.content, editor?.schema, schemaNode.attrs).map((node$1) => {
		if (node$1?.type !== "paragraph" || !Array.isArray(node$1.content)) return node$1;
		return {
			...node$1,
			content: mergeTextNodes(node$1.content)
		};
	});
	if (!normalizedNodes.length) return {
		...schemaNode,
		content: mergeTextNodes(schemaNode.content || [])
	};
	if (normalizedNodes.length === 1 && normalizedNodes[0]?.type === "paragraph") return normalizedNodes[0];
	return normalizedNodes;
};
function resolveExportPartPath$1(params = {}) {
	if (typeof params.currentPartPath === "string" && params.currentPartPath.length > 0) return params.currentPartPath;
	if (typeof params.filename === "string" && params.filename.length > 0) return params.filename.startsWith("word/") ? params.filename : `word/${params.filename}`;
	return "word/document.xml";
}
function findParagraphSplitTrackFormatMark(node) {
	if (!node || typeof node !== "object") return null;
	const directMark = (Array.isArray(node.marks) ? node.marks : []).find((mark) => isParagraphSplitTrackFormatMark(mark));
	if (directMark) return directMark;
	if (typeof node.descendants === "function") {
		let found$1 = null;
		node.descendants((child) => {
			if (found$1) return false;
			const match = (Array.isArray(child?.marks) ? child.marks : []).find((mark) => isParagraphSplitTrackFormatMark(mark));
			if (match) found$1 = match;
			return !found$1;
		});
		if (found$1) return found$1;
	}
	const content$2 = Array.isArray(node.content) ? node.content : [];
	for (const child of content$2) {
		const childMark = findParagraphSplitTrackFormatMark(child);
		if (childMark) return childMark;
	}
	return null;
}
function ensureParagraphPropertiesNode(pPr) {
	return pPr || {
		type: "element",
		name: "w:pPr",
		elements: []
	};
}
function insertRunPropertiesInOrder(pPr, runProperties) {
	const terminalIdx = pPr.elements.findIndex((element) => element?.name === "w:sectPr" || element?.name === "w:pPrChange");
	if (terminalIdx === -1) pPr.elements.push(runProperties);
	else pPr.elements.splice(terminalIdx, 0, runProperties);
}
function prependParagraphSplitInsertion(pPr, insertionElement) {
	if (!pPr || !insertionElement) return pPr;
	if (!Array.isArray(pPr.elements)) pPr.elements = [];
	const existingRunProperties = pPr.elements.find((element) => element?.name === "w:rPr");
	const runProperties = existingRunProperties || {
		type: "element",
		name: "w:rPr",
		elements: []
	};
	if (!Array.isArray(runProperties.elements)) runProperties.elements = [];
	if (!runProperties.elements.some((element) => element?.name === "w:ins")) runProperties.elements.unshift(insertionElement);
	if (!existingRunProperties) insertRunPropertiesInOrder(pPr, runProperties);
	return pPr;
}
function generateParagraphProperties(params) {
	const { node } = params;
	const { attrs = {} } = node;
	const paragraphProperties = carbonCopy(attrs.paragraphProperties || {});
	const inlineKeys = paragraphProperties.runPropertiesInlineKeys;
	delete paragraphProperties.runPropertiesInlineKeys;
	if (Array.isArray(inlineKeys) && inlineKeys.length === 0) delete paragraphProperties.runProperties;
	else if (Array.isArray(inlineKeys) && paragraphProperties.runProperties) {
		const filtered = Object.fromEntries(inlineKeys.filter((k) => k in paragraphProperties.runProperties).map((k) => [k, paragraphProperties.runProperties[k]]));
		if (Object.keys(filtered).length > 0) paragraphProperties.runProperties = filtered;
		else delete paragraphProperties.runProperties;
	}
	const paragraphSplitTrackFormatMark = findParagraphSplitTrackFormatMark(node);
	const paragraphSplitWordIdOptions = paragraphSplitTrackFormatMark ? {
		wordIdAllocator: params?.converter?.wordIdAllocator || null,
		partPath: resolveExportPartPath$1(params)
	} : null;
	let pPr = translator$129.decode({ node: {
		...node,
		attrs: { paragraphProperties }
	} });
	if (!params?.isFinalDoc && paragraphSplitTrackFormatMark) {
		const insertionElement = createParagraphSplitInsertionElement(paragraphSplitTrackFormatMark, paragraphSplitWordIdOptions);
		if (insertionElement) pPr = prependParagraphSplitInsertion(ensureParagraphPropertiesNode(pPr), insertionElement);
	}
	const sectPr = node.attrs?.paragraphProperties?.sectPr;
	if (sectPr) {
		if (!pPr) pPr = {
			type: "element",
			name: "w:pPr",
			elements: []
		};
		const pPrChangeIdx = pPr.elements.findIndex((el) => el.name === "w:pPrChange");
		if (pPrChangeIdx === -1) pPr.elements.push(sectPr);
		else pPr.elements.splice(pPrChangeIdx, 0, sectPr);
	}
	return pPr;
}
var isTrackedChangeWrapper = (el) => el?.name === "w:ins" || el?.name === "w:del";
var stableStringify$1 = (value) => JSON.stringify(value ?? null);
var getMergeableTextRunParts = (element) => {
	if (element?.name !== "w:r" || !Array.isArray(element.elements) || element.elements.length === 0) return null;
	const [first, second, ...rest] = element.elements;
	if (rest.length > 0) return null;
	const runProperties = first?.name === "w:rPr" ? first : null;
	const textNode = runProperties ? second : first;
	if (textNode?.name !== "w:t" || !Array.isArray(textNode.elements) || textNode.elements.length !== 1) return null;
	const textChild = textNode.elements[0];
	if (typeof textChild?.text !== "string") return null;
	return {
		runProperties,
		textNode,
		textChild
	};
};
function mergeAdjacentFinalTextRuns(elements) {
	if (!Array.isArray(elements) || elements.length < 2) return elements;
	const result = [];
	elements.forEach((element) => {
		const previous$1 = result[result.length - 1];
		const previousParts = getMergeableTextRunParts(previous$1);
		const currentParts = getMergeableTextRunParts(element);
		if (!(previousParts && currentParts && stableStringify$1(previous$1?.attributes) === stableStringify$1(element?.attributes) && stableStringify$1(previousParts.runProperties) === stableStringify$1(currentParts.runProperties) && stableStringify$1(previousParts.textNode?.attributes) === stableStringify$1(currentParts.textNode?.attributes))) {
			result.push(element);
			return;
		}
		previousParts.textChild.text += currentParts.textChild.text;
	});
	return result;
}
var getCommentReferenceNode = (el) => {
	if (el?.name !== "w:r" || !Array.isArray(el.elements)) return null;
	return el.elements.find((child) => child?.name === "w:commentReference") ?? null;
};
var isCommentMarker = (el) => {
	if (!el) return false;
	if (el.name === "w:commentRangeStart" || el.name === "w:commentRangeEnd") return true;
	return getCommentReferenceNode(el) != null;
};
var getCommentMarkerId = (el) => {
	if (!el) return null;
	if ((el.name === "w:commentRangeStart" || el.name === "w:commentRangeEnd") && el.attributes?.["w:id"] != null) return String(el.attributes["w:id"]);
	const referenceNode = getCommentReferenceNode(el);
	if (referenceNode?.attributes?.["w:id"] != null) return String(referenceNode.attributes["w:id"]);
	return null;
};
var collectLeadingCommentStartIds = (elements = []) => {
	const startedIds = /* @__PURE__ */ new Set();
	for (const element of elements) {
		if (element?.name !== "w:commentRangeStart") break;
		const id = getCommentMarkerId(element);
		if (id) startedIds.add(id);
	}
	return startedIds;
};
var shouldAbsorbTrailingMarkersIntoWrapper = (pendingComments = [], startedInsideWrapper = /* @__PURE__ */ new Set()) => {
	if (!pendingComments.length || !startedInsideWrapper.size) return false;
	return pendingComments.every((marker) => {
		const markerId = getCommentMarkerId(marker);
		return markerId != null && startedInsideWrapper.has(markerId);
	});
};
function foldLeadingCommentStartsIntoTrackedChanges(elements) {
	const result = [];
	let i$1 = 0;
	while (i$1 < elements.length) {
		if (elements[i$1]?.name !== "w:commentRangeStart") {
			result.push(elements[i$1]);
			i$1++;
			continue;
		}
		const leadingStarts = [];
		while (i$1 < elements.length && elements[i$1]?.name === "w:commentRangeStart") {
			leadingStarts.push(elements[i$1]);
			i$1++;
		}
		const next = elements[i$1];
		if (isTrackedChangeWrapper(next)) {
			result.push({
				...next,
				elements: [...leadingStarts, ...next.elements || []]
			});
			i$1++;
		} else result.push(...leadingStarts);
	}
	return result;
}
function mergeConsecutiveTrackedChanges(elements) {
	if (!Array.isArray(elements) || elements.length === 0) return elements;
	elements = foldLeadingCommentStartsIntoTrackedChanges(elements);
	const result = [];
	let i$1 = 0;
	while (i$1 < elements.length) {
		const current = elements[i$1];
		if (isTrackedChangeWrapper(current)) {
			const tcId = current.attributes?.["w:id"];
			const tcName = current.name;
			const mergedElements = [...current.elements || []];
			const pendingComments = [];
			let didMerge = false;
			let j = i$1 + 1;
			while (j < elements.length) {
				const next = elements[j];
				if (isCommentMarker(next)) {
					pendingComments.push(next);
					j++;
					continue;
				}
				if (next?.name === tcName && next.attributes?.["w:id"] === tcId) {
					mergedElements.push(...pendingComments, ...next.elements || []);
					pendingComments.length = 0;
					didMerge = true;
					j++;
					continue;
				}
				break;
			}
			const absorbTrailingMarkers = shouldAbsorbTrailingMarkersIntoWrapper(pendingComments, collectLeadingCommentStartIds(mergedElements));
			if (absorbTrailingMarkers) {
				mergedElements.push(...pendingComments);
				pendingComments.length = 0;
			}
			if (didMerge) {
				result.push({
					name: tcName,
					attributes: { ...current.attributes },
					elements: mergedElements
				});
				result.push(...pendingComments);
			} else {
				result.push(absorbTrailingMarkers ? {
					name: tcName,
					attributes: { ...current.attributes },
					elements: mergedElements
				} : current);
				result.push(...pendingComments);
			}
			i$1 = j;
		} else {
			result.push(current);
			i$1++;
		}
	}
	return result;
}
function translateParagraphNode(params) {
	let elements = translateChildNodes({
		...params,
		extraParams: {
			...params.extraParams,
			paragraphProperties: params.node?.attrs?.paragraphProperties
		}
	});
	elements = mergeConsecutiveTrackedChanges(elements);
	if (params.isFinalDoc) elements = mergeAdjacentFinalTextRuns(elements);
	const htmlAnnotationChild = elements.find((element) => element.name === "htmlAnnotation");
	if (htmlAnnotationChild) return htmlAnnotationChild.elements;
	const pPr = generateParagraphProperties(params);
	if (pPr) elements.unshift(pPr);
	let attributes = {};
	if (params.node.attrs?.rsidRDefault) attributes["w:rsidRDefault"] = params.node.attrs.rsidRDefault;
	return {
		name: "w:p",
		elements,
		attributes
	};
}
const encode$60 = (attributes) => {
	return attributes["w:rsidDel"];
};
const decode$62 = (attrs) => {
	return attrs.rsidDel;
};
const attrConfig$22 = Object.freeze({
	xmlName: "w:rsidDel",
	sdName: "rsidDel",
	encode: encode$60,
	decode: decode$62
});
const encode$59 = (attributes) => {
	return attributes["w:rsidP"];
};
const decode$61 = (attrs) => {
	return attrs.rsidP;
};
const attrConfig$23 = Object.freeze({
	xmlName: "w:rsidP",
	sdName: "rsidP",
	encode: encode$59,
	decode: decode$61
});
const encode$58 = (attributes) => {
	return attributes["w:rsidR"];
};
const decode$60 = (attrs) => {
	return attrs.rsidR;
};
const attrConfig$24 = Object.freeze({
	xmlName: "w:rsidR",
	sdName: "rsidR",
	encode: encode$58,
	decode: decode$60
});
const encode$57 = (attributes) => {
	return attributes["w:rsidRPr"];
};
const decode$59 = (attrs) => {
	return attrs.rsidRPr;
};
const attrConfig$25 = Object.freeze({
	xmlName: "w:rsidRPr",
	sdName: "rsidRPr",
	encode: encode$57,
	decode: decode$59
});
const encode$56 = (attributes) => {
	return attributes["w:rsidRDefault"];
};
const decode$58 = (attrs) => {
	return attrs.rsidRDefault;
};
const attrConfig$26 = Object.freeze({
	xmlName: "w:rsidRDefault",
	sdName: "rsidRDefault",
	encode: encode$56,
	decode: decode$58
});
const encode$55 = (attributes) => {
	return attributes["w14:paraId"];
};
const decode$57 = (attrs) => {
	return attrs.paraId;
};
const attrConfig$27 = Object.freeze({
	xmlName: "w14:paraId",
	sdName: "paraId",
	encode: encode$55,
	decode: decode$57
});
const encode$54 = (attributes) => {
	return attributes["w14:textId"];
};
const decode$56 = (attrs) => {
	return attrs.textId;
};
var attributes_default$5 = [
	attrConfig$27,
	Object.freeze({
		xmlName: "w14:textId",
		sdName: "textId",
		encode: encode$54,
		decode: decode$56
	}),
	attrConfig$24,
	attrConfig$26,
	attrConfig$23,
	attrConfig$25,
	attrConfig$22
];
var XML_NODE_NAME$33 = "w:p";
var SD_NODE_NAME$31 = "paragraph";
var IDENTITY_ATTR_NAMES = new Set(["paraId", "textId"]);
function partitionEncodedParagraphAttrs(encodedAttrs = {}) {
	const identityAttrs = {};
	const shareableAttrs = {};
	Object.entries(encodedAttrs).forEach(([key, value]) => {
		if (IDENTITY_ATTR_NAMES.has(key)) {
			identityAttrs[key] = value;
			return;
		}
		shareableAttrs[key] = value;
	});
	return {
		identityAttrs,
		shareableAttrs
	};
}
var encode$53 = (params, encodedAttrs = {}) => {
	const node = handleParagraphNode$2(params);
	if (!node) return void 0;
	if (encodedAttrs && Object.keys(encodedAttrs).length) {
		if (Array.isArray(node)) {
			const { identityAttrs, shareableAttrs } = partitionEncodedParagraphAttrs(encodedAttrs);
			let appliedIdentityAttrs = false;
			return node.map((child) => {
				if (child?.type !== "paragraph") return child;
				const attrs = {
					...child.attrs || {},
					...shareableAttrs
				};
				if (!appliedIdentityAttrs) {
					Object.assign(attrs, identityAttrs);
					appliedIdentityAttrs = true;
				}
				return {
					...child,
					attrs
				};
			});
		}
		node.attrs = {
			...node.attrs,
			...encodedAttrs
		};
	}
	return node;
};
var decode$55 = (params, decodedAttrs = {}) => {
	const translated = translateParagraphNode(params);
	if (!translated) return void 0;
	if (decodedAttrs && Object.keys(decodedAttrs).length) translated.attributes = {
		...translated.attributes || {},
		...decodedAttrs
	};
	return translated;
};
const config$33 = {
	xmlName: XML_NODE_NAME$33,
	sdNodeOrKeyName: SD_NODE_NAME$31,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$53,
	decode: decode$55,
	attributes: attributes_default$5
};
const translator = NodeTranslator.from(config$33);
var cloneMark$1 = (mark) => {
	if (!mark) return mark;
	return {
		...mark,
		attrs: mark.attrs ? { ...mark.attrs } : void 0
	};
};
var cloneNode = (node) => {
	if (!node || typeof node !== "object") return node;
	const cloned = { ...node };
	if (node.marks) cloned.marks = node.marks.map((mark) => cloneMark$1(mark));
	if (node.content) cloned.content = node.content.map((child) => cloneNode(child));
	if (node.elements) cloned.elements = node.elements.map((el) => cloneNode(el));
	if (node.attributes) cloned.attributes = { ...node.attributes };
	return cloned;
};
var cloneRuns = (runs = []) => runs.map((run$1) => cloneNode(run$1));
const prepareRunTrackingContext = (node = {}) => {
	const marks = Array.isArray(node.marks) ? node.marks : [];
	const trackingMarks = marks.filter((mark) => mark?.type === "trackInsert" || mark?.type === "trackDelete");
	if (!trackingMarks.length) return {
		runNode: node,
		trackingMarksByType: /* @__PURE__ */ new Map()
	};
	const trackingMarksByType = /* @__PURE__ */ new Map();
	trackingMarks.forEach((mark) => {
		if (mark?.type) trackingMarksByType.set(mark.type, cloneMark$1(mark));
	});
	const preservedMarks = marks.filter((mark) => mark?.type !== "trackInsert" && mark?.type !== "trackDelete").map((mark) => cloneMark$1(mark));
	const clonedContent = Array.isArray(node.content) ? node.content.map((child) => {
		const childClone = cloneNode(child);
		const childMarks = Array.isArray(childClone.marks) ? childClone.marks.slice() : [];
		trackingMarks.forEach((mark) => {
			childMarks.push(cloneMark$1(mark));
		});
		childClone.marks = childMarks;
		return childClone;
	}) : [];
	return {
		runNode: {
			...cloneNode(node),
			marks: preservedMarks,
			content: clonedContent
		},
		trackingMarksByType
	};
};
var mapTrackingAttrs = (mark, attrMap) => {
	const source = mark?.attrs || {};
	const mapped = {};
	attrMap.forEach((targetKey, sourceKey) => {
		if (source[sourceKey] != null) mapped[targetKey] = source[sourceKey];
	});
	return mapped;
};
var renameTextElementsForDeletion = (node) => {
	if (!node || typeof node !== "object") return;
	if (node.name === "w:t") node.name = "w:delText";
	if (Array.isArray(node.elements)) node.elements.forEach(renameTextElementsForDeletion);
};
const ensureTrackedWrapper = (runs, trackingMarksByType = /* @__PURE__ */ new Map(), options = {}) => {
	if (!Array.isArray(runs) || !runs.length) return runs;
	const { isFinalDoc = false } = options;
	const firstRun = runs[0];
	if (firstRun?.name === "w:ins" || firstRun?.name === "w:del") return runs;
	if (!trackingMarksByType.size) return runs;
	if (trackingMarksByType.has("trackInsert")) {
		if (isFinalDoc) return runs;
		const mark = trackingMarksByType.get(TrackInsertMarkName);
		const clonedRuns = cloneRuns(runs);
		return [{
			name: "w:ins",
			attributes: mapTrackingAttrs(mark, new Map([
				["id", "w:id"],
				["author", "w:author"],
				["authorEmail", "w:authorEmail"],
				["date", "w:date"]
			])),
			elements: clonedRuns
		}];
	}
	if (trackingMarksByType.has("trackDelete")) {
		if (isFinalDoc) return [];
		const mark = trackingMarksByType.get(TrackDeleteMarkName);
		const clonedRuns = cloneRuns(runs);
		clonedRuns.forEach(renameTextElementsForDeletion);
		return [{
			name: "w:del",
			attributes: mapTrackingAttrs(mark, new Map([["id", "w:id"]])),
			elements: clonedRuns
		}];
	}
	return runs;
};
const encode$52 = (attributes) => {
	return attributes["w:rsidR"];
};
const decode$54 = (attrs) => {
	return attrs.rsidR;
};
const attrConfig$19 = Object.freeze({
	xmlName: "w:rsidR",
	sdName: "rsidR",
	encode: encode$52,
	decode: decode$54
});
const encode$51 = (attributes) => {
	return attributes["w:rsidRPr"];
};
const decode$53 = (attrs) => {
	return attrs.rsidRPr;
};
const attrConfig$20 = Object.freeze({
	xmlName: "w:rsidRPr",
	sdName: "rsidRPr",
	encode: encode$51,
	decode: decode$53
});
const encode$50 = (attributes) => {
	return attributes["w:rsidDel"];
};
const decode$52 = (attrs) => {
	return attrs.rsidDel;
};
var attributes_default$4 = [
	attrConfig$19,
	attrConfig$20,
	Object.freeze({
		xmlName: "w:rsidDel",
		sdName: "rsidDel",
		encode: encode$50,
		decode: decode$52
	})
];
var STYLES_KEY = "word/styles.xml";
function getParagraphStyleRunPropertiesFromStylesXml(docx, styleId, params) {
	const stylesPart = docx?.[STYLES_KEY];
	if (!stylesPart?.elements?.[0]?.elements) return {};
	const styleElements = stylesPart.elements[0].elements.filter((el) => el.name === "w:style");
	const styleById = new Map(styleElements.map((el) => [el.attributes?.["w:styleId"], el]));
	const chain = [];
	let currentId = styleId;
	const seen = /* @__PURE__ */ new Set();
	while (currentId && !seen.has(currentId)) {
		seen.add(currentId);
		const styleTag = styleById.get(currentId);
		if (!styleTag) break;
		const rPr = styleTag.elements?.find((el) => el.name === "w:rPr");
		if (rPr?.elements?.length) chain.push(rPr);
		currentId = (styleTag.elements?.find((el) => el.name === "w:basedOn"))?.attributes?.["w:val"];
	}
	if (chain.length === 0) return {};
	const byName = {};
	chain.reverse().forEach((rPr) => {
		(rPr.elements || []).forEach((el) => {
			if (el?.name) byName[el.name] = el;
		});
	});
	const mergedRPr = {
		name: "w:rPr",
		elements: Object.values(byName)
	};
	const encodeParams = {
		...params,
		docx: params.docx ?? docx,
		nodes: [mergedRPr]
	};
	return translator$133.encode(encodeParams) ?? {};
}
var XML_NODE_NAME$32 = "w:r";
var SD_KEY_NAME = "run";
var REFERENCE_RUN_STYLE_BY_XML_NAME = {
	"w:footnoteReference": "FootnoteReference",
	"w:endnoteReference": "EndnoteReference"
};
var BLOCK_HOIST_TYPES = new Set(["shapeContainer"]);
var hasXmlNodeNamed = (node, targetName) => {
	if (!node || typeof node !== "object") return false;
	if (node.name === targetName) return true;
	if (!Array.isArray(node.elements)) return false;
	return node.elements.some((child) => hasXmlNodeNamed(child, targetName));
};
var COMPLEX_SCRIPT_CODEPOINT_RANGES = [
	[1424, 2303],
	[2304, 4255],
	[6016, 6319],
	[7376, 7423],
	[43008, 43263],
	[43616, 43647]
];
var textHasComplexScript = (text$2) => {
	for (const char of text$2) {
		const codePoint = char.codePointAt(0);
		if (COMPLEX_SCRIPT_CODEPOINT_RANGES.some(([start, end]) => codePoint >= start && codePoint <= end)) return true;
	}
	return false;
};
var hasComplexScriptText = (node) => {
	if (!node || typeof node !== "object") return false;
	if (typeof node.text === "string" && textHasComplexScript(node.text)) return true;
	if (!Array.isArray(node.content)) return false;
	return node.content.some((child) => hasComplexScriptText(child));
};
var getRunPropertiesNode = (runNode) => {
	if (!runNode) return null;
	if (!Array.isArray(runNode.elements)) runNode.elements = [];
	let runPropertiesNode = runNode.elements.find((element) => element?.name === "w:rPr");
	if (!runPropertiesNode) {
		runPropertiesNode = {
			type: "element",
			name: "w:rPr",
			elements: []
		};
		runNode.elements.unshift(runPropertiesNode);
	}
	if (!Array.isArray(runPropertiesNode.elements)) runPropertiesNode.elements = [];
	return runPropertiesNode;
};
var collectRunPropertyChanges = (runNode) => {
	const runPropertiesNode = runNode?.elements?.find((element) => element?.name === "w:rPr");
	if (!Array.isArray(runPropertiesNode?.elements)) return [];
	return runPropertiesNode.elements.filter((element) => element?.name === "w:rPrChange").map((element) => cloneXmlNode(element));
};
var restoreRunPropertyChanges = (runNode, runPropertyChanges = []) => {
	if (!runPropertyChanges.length) return;
	const runPropertiesNode = getRunPropertiesNode(runNode);
	const existingNames = new Set(runPropertiesNode.elements.map((element) => element?.name));
	runPropertyChanges.forEach((changeElement) => {
		if (!changeElement?.name || existingNames.has(changeElement.name)) return;
		runPropertiesNode.elements.push(changeElement);
		existingNames.add(changeElement.name);
	});
};
var ensureReferenceRunFormatting = (runNode, referenceXmlName) => {
	const styleId = REFERENCE_RUN_STYLE_BY_XML_NAME[referenceXmlName];
	if (!styleId) return;
	if (!Array.isArray(runNode.elements)) runNode.elements = [];
	let runProps = runNode.elements.find((el) => el?.name === "w:rPr");
	if (!runProps) {
		runProps = {
			name: "w:rPr",
			elements: []
		};
		runNode.elements.unshift(runProps);
	}
	if (!Array.isArray(runProps.elements)) runProps.elements = [];
	if (!runProps.elements.some((el) => el?.name === "w:rStyle")) runProps.elements.push({
		name: "w:rStyle",
		attributes: { "w:val": styleId }
	});
	if (!runProps.elements.some((el) => el?.name === "w:vertAlign")) runProps.elements.push({
		name: "w:vertAlign",
		attributes: { "w:val": "superscript" }
	});
};
var createRunNodeWithContent = (content$2, encodedAttrs, runLevelMarks, resolvedRunProperties, inlineKeysFromCombine, runPropertiesStyleKeys = null, runPropertiesOverrideKeys = null) => {
	const node = {
		type: SD_KEY_NAME,
		content: content$2,
		attrs: {
			...encodedAttrs,
			runProperties: resolvedRunProperties,
			runPropertiesInlineKeys: inlineKeysFromCombine,
			runPropertiesStyleKeys: runPropertiesStyleKeys?.length ? runPropertiesStyleKeys : null,
			runPropertiesOverrideKeys: runPropertiesOverrideKeys?.length ? runPropertiesOverrideKeys : null
		}
	};
	if (runLevelMarks.length) node.marks = runLevelMarks.map((mark) => cloneMark(mark));
	return node;
};
var encode$49 = (params, encodedAttrs = {}) => {
	const { nodes = [], nodeListHandler } = params || {};
	const runNode = nodes[0];
	if (!runNode) return void 0;
	const elements = Array.isArray(runNode.elements) ? runNode.elements : [];
	const rPrNode = elements.find((child) => child?.name === "w:rPr");
	const encodedRunProperties = (rPrNode ? translator$133.encode({
		...params,
		nodes: [rPrNode]
	}) : void 0) ?? {};
	const runPropertiesInlineKeysFromCombine = Object.keys(encodedRunProperties);
	const paragraphProperties = params?.extraParams?.paragraphProperties || {};
	let tableInfo = null;
	if (params?.extraParams?.rowIndex != null && params?.extraParams?.columnIndex != null && params?.extraParams?.tableProperties != null && params?.extraParams?.totalColumns != null && params?.extraParams?.totalRows != null) tableInfo = {
		rowIndex: params.extraParams.rowIndex,
		cellIndex: params.extraParams.columnIndex,
		tableProperties: params.extraParams.tableProperties,
		numCells: params.extraParams.totalColumns,
		numRows: params.extraParams.totalRows
	};
	const resolvedRunProperties = resolveRunProperties(params, encodedRunProperties, paragraphProperties, tableInfo, false, params?.extraParams?.numberingDefinedInline);
	const marksResult = encodeMarksFromRPr(resolvedRunProperties, params?.docx);
	const marks = Array.isArray(marksResult) ? marksResult : [];
	const rPrChange = rPrNode?.elements?.find((el) => el.name === "w:rPrChange");
	const styleChangeMarks = handleStyleChangeMarksV2(rPrChange, marks, params) || [];
	let runLevelMarks = Array.isArray(runNode.marks) ? runNode.marks.map((mark) => cloneMark(mark)) : [];
	if (styleChangeMarks?.length) runLevelMarks = [...runLevelMarks, ...styleChangeMarks.map((mark) => cloneMark(mark))];
	const contentElements = rPrNode ? elements.filter((el) => el !== rPrNode) : elements;
	const childParams = {
		...params,
		nodes: contentElements
	};
	const content$2 = nodeListHandler?.handler(childParams) || [];
	if (Array.isArray(content$2) && content$2.length > 0 && content$2.every((child) => BLOCK_HOIST_TYPES.has(child?.type))) return content$2.filter(Boolean).map((child) => ({
		...child,
		marks: Array.isArray(child?.marks) ? child.marks : []
	}));
	const filtered = (Array.isArray(content$2) ? content$2 : []).map((child) => {
		if (!child || typeof child !== "object") return child;
		if (child.type === "passthroughInline") return {
			...child,
			marks: []
		};
		const baseMarks = Array.isArray(child.marks) ? child.marks : [];
		let childMarks = [
			...marks,
			...baseMarks,
			...runLevelMarks
		].map((mark) => cloneMark(mark));
		const seenTypes = /* @__PURE__ */ new Set();
		let textStyleMark;
		childMarks = childMarks.filter((mark) => {
			if (!mark || !mark.type) return false;
			if (seenTypes.has(mark.type)) {
				if (mark.type === "textStyle") {
					textStyleMark.attrs = {
						...textStyleMark.attrs || {},
						...mark.attrs || {}
					};
					textStyleMark.attrs = resolveFontFamily$1(textStyleMark.attrs, child?.text);
				}
				return false;
			}
			if (mark.type === "textStyle") textStyleMark = mark;
			seenTypes.add(mark.type);
			return true;
		});
		return {
			...child,
			marks: childMarks
		};
	}).filter(Boolean);
	let runPropertiesStyleKeys = null;
	if (encodedRunProperties?.styleId && params?.docx) {
		const styleRPr = getParagraphStyleRunPropertiesFromStylesXml(params.docx, encodedRunProperties.styleId, params);
		if (styleRPr && Object.keys(styleRPr).length > 0) runPropertiesStyleKeys = Object.keys(styleRPr);
	}
	const runPropertiesOverrideKeys = runPropertiesStyleKeys?.length && runPropertiesInlineKeysFromCombine?.length ? runPropertiesInlineKeysFromCombine.filter((k) => runPropertiesStyleKeys.includes(k)) : null;
	if (!filtered.some((child) => child?.type === "lineBreak")) return createRunNodeWithContent(filtered, encodedAttrs, runLevelMarks, resolvedRunProperties, runPropertiesInlineKeysFromCombine, runPropertiesStyleKeys, runPropertiesOverrideKeys);
	const splitRuns = [];
	let currentChunk = [];
	const finalizeTextChunk = () => {
		if (!currentChunk.length) return;
		const chunkNode = createRunNodeWithContent(currentChunk, encodedAttrs, runLevelMarks, resolvedRunProperties, runPropertiesInlineKeysFromCombine, runPropertiesStyleKeys, runPropertiesOverrideKeys);
		if (chunkNode) splitRuns.push(chunkNode);
		currentChunk = [];
	};
	filtered.forEach((child) => {
		if (child?.type === "lineBreak") {
			finalizeTextChunk();
			const breakNode = createRunNodeWithContent([child], encodedAttrs, runLevelMarks, resolvedRunProperties, runPropertiesInlineKeysFromCombine, runPropertiesStyleKeys, runPropertiesOverrideKeys);
			if (breakNode) splitRuns.push(breakNode);
		} else currentChunk.push(child);
	});
	finalizeTextChunk();
	return splitRuns;
};
var decode$51 = (params, decodedAttrs = {}) => {
	const { node } = params || {};
	if (!node) return void 0;
	if (node.marks?.some((m) => m.type === "link")) {
		const extraParams = {
			...params.extraParams,
			linkProcessed: true
		};
		return translator$78.decode({
			...params,
			extraParams
		});
	}
	const { runNode: runNodeForExport, trackingMarksByType } = prepareRunTrackingContext(node);
	const runTrackFormatMark = findTrackFormatMark(runNodeForExport.marks);
	const runAttrs = runNodeForExport.attrs || {};
	const rawRunProperties = runAttrs.runProperties || {};
	const runProperties = rawRunProperties?.italicCs == null && rawRunProperties?.iCs != null ? {
		...rawRunProperties,
		italicCs: rawRunProperties.iCs
	} : rawRunProperties;
	const inlineKeys = runAttrs.runPropertiesInlineKeys;
	const styleKeys = runAttrs.runPropertiesStyleKeys;
	const overrideKeys = runAttrs.runPropertiesOverrideKeys;
	const candidateKeys = inlineKeys != null ? [...new Set([...inlineKeys || [], ...overrideKeys || []])] : Object.keys(runProperties);
	if (candidateKeys.includes("iCs") && !candidateKeys.includes("italicCs")) candidateKeys.push("italicCs");
	const shouldExport = (key) => key in (runProperties || {}) && (!(Array.isArray(styleKeys) && styleKeys.includes(key)) || Array.isArray(overrideKeys) && overrideKeys.includes(key));
	const exportKeys = candidateKeys.filter(shouldExport);
	const runPropertiesToExport = exportKeys.length > 0 ? Object.fromEntries(exportKeys.map((k) => [k, runProperties[k]])) : {};
	if (hasComplexScriptText(runNodeForExport)) {
		if ("bold" in runPropertiesToExport && !("boldCs" in runPropertiesToExport)) runPropertiesToExport.boldCs = runPropertiesToExport.bold;
		if ("italic" in runPropertiesToExport && !("italicCs" in runPropertiesToExport)) runPropertiesToExport.italicCs = runPropertiesToExport.italic;
	}
	const exportParams = {
		...params,
		node: runNodeForExport,
		extraParams: {
			...params?.extraParams,
			runProperties
		}
	};
	if (!exportParams.editor) exportParams.editor = { extensionService: { extensions: [] } };
	const childElements = translateChildNodes(exportParams) || [];
	let runPropertiesElement = Object.keys(runPropertiesToExport).length > 0 ? translator$133.decode({
		...params,
		node: { attrs: { runProperties: runPropertiesToExport } }
	}) : null;
	const runPropsTemplate = runPropertiesElement ? cloneXmlNode(runPropertiesElement) : null;
	const applyBaseRunProps = (runNode) => applyRunPropertiesTemplate(runNode, runPropsTemplate);
	const replaceRunProps = (runNode) => {
		const existingRunPropertyChanges = collectRunPropertyChanges(runNode);
		if (Array.isArray(runNode.elements)) runNode.elements = runNode.elements.filter((el) => el?.name !== "w:rPr");
		else runNode.elements = [];
		if (runPropsTemplate) runNode.elements.unshift(cloneXmlNode(runPropsTemplate));
		restoreRunPropertyChanges(runNode, existingRunPropertyChanges);
		if (!existingRunPropertyChanges.length && runTrackFormatMark) appendTrackFormatChangeToRunProperties(getRunPropertiesNode(runNode), [runTrackFormatMark], {
			wordIdAllocator: params?.converter?.wordIdAllocator || null,
			partPath: params?.currentPartPath || "word/document.xml"
		});
	};
	const runs = [];
	childElements.forEach((child) => {
		if (!child) return;
		if (child.name === "w:r") {
			const clonedRun = cloneXmlNode(child);
			replaceRunProps(clonedRun);
			if (hasXmlNodeNamed(clonedRun, "w:footnoteReference")) ensureReferenceRunFormatting(clonedRun, "w:footnoteReference");
			else if (hasXmlNodeNamed(clonedRun, "w:endnoteReference")) ensureReferenceRunFormatting(clonedRun, "w:endnoteReference");
			runs.push(clonedRun);
			return;
		}
		if (child.name === "w:hyperlink") {
			const hyperlinkClone = cloneXmlNode(child);
			if (Array.isArray(hyperlinkClone.elements)) hyperlinkClone.elements.forEach((run$1) => applyBaseRunProps(run$1));
			runs.push(hyperlinkClone);
			return;
		}
		if (child.name === "w:ins" || child.name === "w:del") {
			const trackedClone = cloneXmlNode(child);
			if (Array.isArray(trackedClone.elements)) trackedClone.elements.forEach((element) => {
				if (element?.name === "w:r") replaceRunProps(element);
			});
			runs.push(trackedClone);
			return;
		}
		if (child.name === "w:commentRangeStart" || child.name === "w:commentRangeEnd") {
			const commentRangeClone = cloneXmlNode(child);
			runs.push(commentRangeClone);
			return;
		}
		if (child.name === "w:sdt") {
			const sdtClone = cloneXmlNode(child);
			runs.push(sdtClone);
			return;
		}
		const runWrapper = {
			name: XML_NODE_NAME$32,
			elements: []
		};
		applyBaseRunProps(runWrapper);
		if (!Array.isArray(runWrapper.elements)) runWrapper.elements = [];
		if (child.name === "w:footnoteReference" || child.name === "w:endnoteReference") ensureReferenceRunFormatting(runWrapper, child.name);
		runWrapper.elements.push(cloneXmlNode(child));
		runs.push(runWrapper);
	});
	const trackedRuns = ensureTrackedWrapper(runs, trackingMarksByType, { isFinalDoc: Boolean(params?.isFinalDoc) });
	if (!trackedRuns.length) {
		if (params?.isFinalDoc) return trackedRuns;
		const emptyRun = {
			name: XML_NODE_NAME$32,
			elements: []
		};
		applyBaseRunProps(emptyRun);
		trackedRuns.push(emptyRun);
	}
	if (decodedAttrs && Object.keys(decodedAttrs).length) trackedRuns.forEach((run$1) => {
		run$1.attributes = {
			...run$1.attributes || {},
			...decodedAttrs
		};
	});
	if (trackedRuns.length === 1) return trackedRuns[0];
	return trackedRuns;
};
const config$32 = {
	xmlName: XML_NODE_NAME$32,
	sdNodeOrKeyName: SD_KEY_NAME,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$49,
	decode: decode$51,
	attributes: attributes_default$4
};
const translator$6 = NodeTranslator.from(config$32);
const translator$186 = NodeTranslator.from(createMeasurementPropertyHandler("w:tcW", "cellWidth"));
const translator$73 = NodeTranslator.from(createSingleAttrPropertyHandler("w:gridSpan", null, "w:val", (v) => parseInteger$1(v) ?? void 0, (v) => integerToString(v)));
const translator$181 = NodeTranslator.from(createSingleAttrPropertyHandler("w:vMerge", null, "w:val", (val) => !val ? "continue" : val));
const translator$67 = NodeTranslator.from(createBorderPropertyHandler("w:end"));
const translator$206 = NodeTranslator.from(createMeasurementPropertyHandler("w:end", "marginEnd"));
const translator$85 = NodeTranslator.from(createBorderPropertyHandler("w:insideH"));
const translator$86 = NodeTranslator.from(createBorderPropertyHandler("w:insideV"));
const translator$143 = NodeTranslator.from(createBorderPropertyHandler("w:start"));
const translator$209 = NodeTranslator.from(createMeasurementPropertyHandler("w:start", "marginStart"));
const translator$102 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:start"));
const translator$188 = NodeTranslator.from(createBorderPropertyHandler("w:tl2br"));
const translator$190 = NodeTranslator.from(createBorderPropertyHandler("w:tr2bl"));
var propertyTranslators$11 = [
	translator$173,
	translator$143,
	translator$106,
	translator$52,
	translator$67,
	translator$137,
	translator$85,
	translator$86,
	translator$188,
	translator$190
];
const translator$191 = NodeTranslator.from(createNestedPropertiesTranslator("w:tcBorders", "borders", propertyTranslators$11));
const translator$111 = NodeTranslator.from(createSingleAttrPropertyHandler("w:noWrap", null, "w:val", (v) => parseBoolean(v ?? "true"), (v) => booleanToString(v)));
var propertyTranslators$10 = [
	translator$205,
	translator$206,
	translator$207,
	translator$208,
	translator$209,
	translator$210
];
const CT_TC_MAR_CHILD_ORDER = [
	"w:top",
	"w:start",
	"w:left",
	"w:bottom",
	"w:end",
	"w:right"
];
var baseConfig$1 = createNestedPropertiesTranslator("w:tcMar", "cellMargins", propertyTranslators$10);
var orderedConfig$1 = {
	...baseConfig$1,
	decode: function(params) {
		const result = baseConfig$1.decode.call(this, params);
		if (!result || !Array.isArray(result.elements)) return result;
		const rank$1 = (name) => {
			const i$1 = CT_TC_MAR_CHILD_ORDER.indexOf(name);
			return i$1 === -1 ? CT_TC_MAR_CHILD_ORDER.length : i$1;
		};
		return {
			...result,
			elements: [...result.elements].sort((a, b) => rank$1(a.name) - rank$1(b.name))
		};
	}
};
const translator$192 = NodeTranslator.from(orderedConfig$1);
const translator$185 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tcFitText", null, "w:val", (v) => parseBoolean(v ?? "true"), (v) => booleanToString(v)));
const translator$182 = NodeTranslator.from(createSingleAttrPropertyHandler("w:vAlign"));
const translator$77 = NodeTranslator.from(createSingleAttrPropertyHandler("w:hideMark", null, "w:val", (v) => parseBoolean(v ?? "true"), (v) => booleanToString(v)));
const translator$74 = NodeTranslator.from(createSingleAttrPropertyHandler("w:header"));
const translator$75 = NodeTranslator.from(createNestedArrayPropertyHandler("w:headers", "headers", [translator$74]));
var propertyTranslators$9 = [
	translator$55,
	translator$186,
	translator$73,
	translator$181,
	translator$191,
	translator$140,
	translator$111,
	translator$192,
	translator$187,
	translator$185,
	translator$182,
	translator$77,
	translator$75
];
const translator$193 = NodeTranslator.from(createNestedPropertiesTranslator("w:tcPr", "tableCellProperties", propertyTranslators$9));
const normalizeRowCellChildren = (row) => {
	const out = [];
	const children = Array.isArray(row?.elements) ? row.elements : [];
	for (const child of children) {
		if (!child || typeof child.name !== "string") continue;
		if (child.name === "w:tc") {
			out.push({
				node: child,
				cellSdt: null
			});
			continue;
		}
		if (child.name === "w:sdt") {
			const sdtPr = child.elements?.find((el) => el?.name === "w:sdtPr") ?? null;
			const sdtEndPr = child.elements?.find((el) => el?.name === "w:sdtEndPr") ?? null;
			const innerCells = (child.elements?.find((el) => el?.name === "w:sdtContent"))?.elements?.filter((el) => el?.name === "w:tc") ?? [];
			if (innerCells.length === 1 && sdtPr) out.push({
				node: innerCells[0],
				cellSdt: {
					scope: "cell",
					sdtPr,
					sdtEndPr
				}
			});
			else for (const innerTc of innerCells) out.push({
				node: innerTc,
				cellSdt: null
			});
		}
	}
	return out;
};
function handleTableCellNode({ params, node, table, row, tableProperties, columnIndex, columnWidth = null, allColumnWidths = [], preferTableGridWidths = false, _referencedStyles }) {
	const { nodeListHandler } = params;
	const attributes = {};
	const referencedStyles = _referencedStyles ?? {
		fontSize: null,
		fonts: {},
		cellMargins: {}
	};
	const tcPr = node.elements.find((el) => el.name === "w:tcPr");
	const tableCellProperties = tcPr ? translator$193.encode({
		...params,
		nodes: [tcPr]
	}) ?? {} : {};
	attributes["tableCellProperties"] = tableCellProperties;
	attributes["tableCellPropertiesInlineKeys"] = Object.keys(tableCellProperties);
	const colspan = parseInt(tableCellProperties.gridSpan || 1, 10);
	if (colspan > 1) attributes["colspan"] = colspan;
	let width = null;
	const widthType = tableCellProperties.cellWidth?.type;
	if (!preferTableGridWidths) {
		if (widthType !== "pct") width = tableCellProperties.cellWidth?.value ? twipsToPixels$2(tableCellProperties.cellWidth?.value) : null;
	}
	if (widthType) attributes["widthType"] = widthType;
	const cellOwnWidth = width;
	if (!width && columnWidth) width = columnWidth;
	if (width) {
		attributes["colwidth"] = [width];
		attributes["widthUnit"] = "px";
		const defaultColWidths = allColumnWidths;
		const hasDefaultColWidths = allColumnWidths && allColumnWidths.length > 0;
		if (colspan > 1 && hasDefaultColWidths) {
			let colwidth = [];
			const gridSpanTotal = defaultColWidths.slice(columnIndex, columnIndex + colspan).reduce((sum, w) => sum + (w || 0), 0);
			const shouldScale = cellOwnWidth && gridSpanTotal > 0 && cellOwnWidth > gridSpanTotal + 1;
			for (let i$1 = 0; i$1 < colspan; i$1++) {
				let colwidthValue = defaultColWidths[columnIndex + i$1];
				let defaultColwidth = 100;
				if (typeof colwidthValue !== "undefined") colwidth.push(shouldScale ? Math.round(colwidthValue * (cellOwnWidth / gridSpanTotal) * 1e3) / 1e3 : colwidthValue);
				else colwidth.push(defaultColwidth);
			}
			if (colwidth.length) attributes["colwidth"] = [...colwidth];
		}
	}
	const background = { color: resolveShadingFillColor(tableCellProperties.shading) ?? resolveShadingFillColor(tableProperties?.shading) };
	if (background.color) attributes["background"] = background;
	const verticalAlign = tableCellProperties.vAlign;
	if (verticalAlign) attributes["verticalAlign"] = verticalAlign;
	attributes.cellMargins = getTableCellMargins(tableCellProperties.cellMargins, referencedStyles);
	const { fontSize, fonts = {} } = referencedStyles;
	const fontFamily = fonts["ascii"];
	if (fontSize) attributes["fontSize"] = fontSize;
	if (fontFamily) attributes["fontFamily"] = fontFamily;
	if (tableCellProperties.vMerge === "restart") {
		const rows = table.elements.filter((el) => el.name === "w:tr");
		const currentRowIndex = rows.findIndex((r) => r === row);
		const remainingRows = rows.slice(currentRowIndex + 1);
		let rowspan = 1;
		const startColumn = Number.isFinite(columnIndex) ? columnIndex : 0;
		for (let remainingRow of remainingRows) {
			const cellAtColumn = findTableCellAtColumn(remainingRow, startColumn);
			if (!cellAtColumn) break;
			const vMerge = getTableCellVMerge(cellAtColumn);
			if (!vMerge || vMerge === "restart") break;
			rowspan++;
			markTableCellAsVMergeConsumed(cellAtColumn);
		}
		attributes["rowspan"] = rowspan;
	}
	return {
		type: "tableCell",
		content: normalizeTableCellContent(nodeListHandler.handler({
			...params,
			nodes: node.elements,
			path: [...params.path || [], node]
		}), params.editor),
		attrs: attributes
	};
}
function normalizeTableCellContent(content$2, editor) {
	if (!Array.isArray(content$2) || content$2.length === 0) return content$2;
	const normalized = [];
	const pendingForNextBlock = [];
	const cloneBlock = (node) => {
		if (!node) return node;
		const cloned = { ...node };
		if (Array.isArray(node.content)) cloned.content = [...node.content];
		else if (!("content" in node)) {}
		return cloned;
	};
	const ensureArray = (node) => {
		if (!Array.isArray(node.content)) node.content = [];
		return node.content;
	};
	for (const node of content$2) {
		if (!node || typeof node.type !== "string") {
			normalized.push(node);
			continue;
		}
		if (!isInlineNode(node, editor?.schema)) {
			const blockNode = cloneBlock(node);
			if (pendingForNextBlock.length) {
				const blockContent = ensureArray(blockNode);
				blockNode.content = [...pendingForNextBlock.splice(0), ...blockContent];
			} else if (Array.isArray(blockNode.content)) blockNode.content = [...blockNode.content];
			normalized.push(blockNode);
			continue;
		}
		if (node.type === "bookmarkStart" || normalized.length === 0) pendingForNextBlock.push(node);
		else {
			const lastNode = normalized[normalized.length - 1];
			if (!lastNode || typeof lastNode.type !== "string" || isInlineNode(lastNode, editor?.schema)) {
				pendingForNextBlock.push(node);
				continue;
			}
			const blockContent = ensureArray(lastNode);
			if (pendingForNextBlock.length) blockContent.push(...pendingForNextBlock.splice(0));
			blockContent.push(node);
		}
	}
	if (pendingForNextBlock.length) {
		if (normalized.length) {
			const lastNode = normalized[normalized.length - 1];
			if (lastNode && typeof lastNode.type === "string" && !isInlineNode(lastNode, editor?.schema)) {
				ensureArray(lastNode).push(...pendingForNextBlock);
				pendingForNextBlock.length = 0;
			}
		}
		if (pendingForNextBlock.length) {
			normalized.push({
				type: "paragraph",
				attrs: {},
				content: [...pendingForNextBlock]
			});
			pendingForNextBlock.length = 0;
		}
	}
	return normalized;
}
var getTableCellVMerge = (node) => {
	const vMerge = node.elements.find((el) => el.name === "w:tcPr")?.elements?.find((el) => el.name === "w:vMerge");
	if (!vMerge) return null;
	return vMerge.attributes?.["w:val"] || "continue";
};
var getGridBefore = (row) => {
	const raw = ((row.elements?.find((el) => el.name === "w:trPr"))?.elements?.find((el) => el.name === "w:gridBefore"))?.attributes?.["w:val"];
	const value = typeof raw === "string" ? parseInt(raw, 10) : raw;
	return Number.isFinite(value) && value > 0 ? value : 0;
};
var getTableCellGridSpan = (node) => {
	if (!node || node.name !== "w:tc") return 1;
	const raw = ((node.elements?.find((el) => el.name === "w:tcPr"))?.elements?.find((el) => el.name === "w:gridSpan"))?.attributes?.["w:val"];
	const value = typeof raw === "string" ? parseInt(raw, 10) : raw;
	return Number.isFinite(value) && value > 0 ? value : 1;
};
var findTableCellAtColumn = (row, targetColumn) => {
	const cells = normalizeRowCellChildren(row).map((entry) => entry.node);
	let currentColumn = getGridBefore(row);
	for (const cell of cells) {
		const colSpan = getTableCellGridSpan(cell);
		if (targetColumn >= currentColumn && targetColumn < currentColumn + colSpan) return cell._vMergeConsumed ? null : cell;
		currentColumn += colSpan;
	}
	return null;
};
var markTableCellAsVMergeConsumed = (node) => {
	if (node?.name === "w:tc") node._vMergeConsumed = true;
};
var getTableCellMargins = (inlineMargins, referencedStyles) => {
	const { cellMargins = {} } = referencedStyles;
	const readMargin = (source, key) => {
		if (!source) return null;
		const v = source[key];
		if (v == null) return null;
		if (typeof v === "number") return v;
		if (typeof v === "object" && typeof v.value === "number") return v.value;
		return null;
	};
	const sides = [
		{
			physical: "top",
			physicalKey: "marginTop",
			logicalKey: null
		},
		{
			physical: "bottom",
			physicalKey: "marginBottom",
			logicalKey: null
		},
		{
			physical: "left",
			physicalKey: "marginLeft",
			logicalKey: "marginStart"
		},
		{
			physical: "right",
			physicalKey: "marginRight",
			logicalKey: "marginEnd"
		}
	];
	const result = {};
	for (const { physical, physicalKey, logicalKey } of sides) {
		const inlinePhysical = readMargin(inlineMargins, physicalKey);
		const inlineLogical = logicalKey ? readMargin(inlineMargins, logicalKey) : null;
		if (inlinePhysical != null) {
			result[physical] = twipsToPixels$2(inlinePhysical);
			continue;
		}
		if (inlineLogical != null) {
			result[physical] = twipsToPixels$2(inlineLogical);
			continue;
		}
		const stylePhysical = readMargin(cellMargins, physicalKey);
		const styleLogical = logicalKey ? readMargin(cellMargins, logicalKey) : null;
		if (stylePhysical != null) result[physical] = twipsToPixels$2(stylePhysical);
		else if (styleLogical != null) result[physical] = twipsToPixels$2(styleLogical);
		else result[physical] = void 0;
	}
	return result;
};
var PX_PER_PT$2 = 96 / 72;
var pxToEighthPoints = (px) => Math.round(px / PX_PER_PT$2 * 8);
var SIDES = [
	"top",
	"right",
	"bottom",
	"left"
];
function isLegacySchemaDefaultBorders(borders) {
	if (!borders || typeof borders !== "object") return false;
	return SIDES.every((side) => {
		const b = borders[side];
		if (!b || typeof b !== "object") return false;
		return !("val" in b) && b.size === .66665 && b.color === "#000000";
	});
}
function convertBordersToOoxmlFormat(borders) {
	const result = {};
	for (const side of SIDES) {
		const b = borders[side];
		if (!b || typeof b !== "object") continue;
		result[side] = {
			val: b.val || "single",
			size: typeof b.size === "number" ? pxToEighthPoints(b.size) : 4,
			space: b.space || 0,
			color: b.color === "#000000" ? "auto" : b.color || "auto"
		};
	}
	return result;
}
function translateTableCell(params) {
	const elements = translateChildNodes({
		...params,
		tableCell: params.node
	});
	const cellProps = generateTableCellProperties(params.node);
	elements.unshift(cellProps);
	return {
		name: "w:tc",
		elements
	};
}
function generateTableCellProperties(node) {
	let tableCellProperties = { ...node.attrs?.tableCellProperties || {} };
	const inlineKeys = node.attrs?.tableCellPropertiesInlineKeys;
	const { attrs } = node;
	const { colwidth: rawColwidth, widthUnit = "px" } = attrs;
	const resolvedWidthType = attrs.cellWidthType ?? (attrs.widthType !== "auto" ? attrs.widthType : void 0) ?? tableCellProperties.cellWidth?.type ?? "dxa";
	const colwidth = Array.isArray(rawColwidth) ? rawColwidth.filter((v) => Number.isFinite(v)) : [];
	if (colwidth.length > 0 && resolvedWidthType !== "pct") {
		const colwidthSum = colwidth.reduce((acc, curr) => acc + curr, 0);
		if (twipsToPixels$2(tableCellProperties.cellWidth?.value) !== colwidthSum) tableCellProperties["cellWidth"] = {
			value: widthUnit === "px" ? pixelsToTwips$1(colwidthSum) : inchesToTwips(colwidthSum),
			type: resolvedWidthType
		};
	}
	const { colspan } = attrs;
	if (colspan > 1 && tableCellProperties.gridSpan !== colspan) tableCellProperties["gridSpan"] = colspan;
	else if (!colspan || colspan <= 1) delete tableCellProperties.gridSpan;
	const { background = {} } = attrs;
	if (background?.color && tableCellProperties.shading?.fill !== background?.color) tableCellProperties["shading"] = { fill: background.color };
	else if (!background?.color && tableCellProperties?.shading?.fill) delete tableCellProperties.shading;
	const { cellMargins } = attrs;
	if (cellMargins && (!Array.isArray(inlineKeys) || inlineKeys.includes("cellMargins"))) {
		if (!tableCellProperties.cellMargins) tableCellProperties["cellMargins"] = {};
		const propMargins = tableCellProperties.cellMargins;
		["top", "bottom"].forEach((side) => {
			const key = `margin${side.charAt(0).toUpperCase() + side.slice(1)}`;
			if (cellMargins[side] != null) {
				if (twipsToPixels$2(propMargins[key]?.value) !== cellMargins[side]) propMargins[key] = {
					value: pixelsToTwips$1(cellMargins[side]),
					type: "dxa"
				};
			} else if (propMargins[key]) delete propMargins[key];
		});
		[{
			side: "left",
			physicalKey: "marginLeft",
			logicalKey: "marginStart"
		}, {
			side: "right",
			physicalKey: "marginRight",
			logicalKey: "marginEnd"
		}].forEach(({ side, physicalKey, logicalKey }) => {
			const value = cellMargins[side];
			const hasPhysical = propMargins[physicalKey] != null;
			const hasLogical = propMargins[logicalKey] != null;
			const physicalTwips = propMargins[physicalKey]?.value;
			const logicalTwips = propMargins[logicalKey]?.value;
			if (value == null) {
				if (hasPhysical) delete propMargins[physicalKey];
				if (hasLogical) delete propMargins[logicalKey];
				return;
			}
			const newTwips = pixelsToTwips$1(value);
			if (hasPhysical && hasLogical) {
				if (twipsToPixels$2(physicalTwips) === value) return;
				propMargins[physicalKey] = {
					value: newTwips,
					type: "dxa"
				};
				delete propMargins[logicalKey];
				return;
			}
			if (hasLogical) {
				if (logicalTwips !== newTwips) propMargins[logicalKey] = {
					value: newTwips,
					type: "dxa"
				};
				return;
			}
			if (physicalTwips !== newTwips) propMargins[physicalKey] = {
				value: newTwips,
				type: "dxa"
			};
		});
	}
	const { verticalAlign } = attrs;
	if (verticalAlign && verticalAlign !== tableCellProperties.vAlign) tableCellProperties["vAlign"] = verticalAlign;
	else if (!verticalAlign && tableCellProperties?.vAlign) delete tableCellProperties.vAlign;
	const { rowspan } = attrs;
	if (rowspan && rowspan > 1) tableCellProperties["vMerge"] = "restart";
	else if (attrs.continueMerge) tableCellProperties["vMerge"] = "continue";
	else delete tableCellProperties.vMerge;
	if (!tableCellProperties?.borders && attrs.borders != null) {
		if (!isLegacySchemaDefaultBorders(attrs.borders)) tableCellProperties = {
			...tableCellProperties ?? {},
			borders: convertBordersToOoxmlFormat(attrs.borders)
		};
	}
	return translator$193.decode({ node: {
		...node,
		attrs: {
			...node.attrs,
			tableCellProperties
		}
	} });
}
var XML_NODE_NAME$31 = "w:tc";
var SD_NODE_NAME$30 = "tableCell";
var validXmlAttributes$8 = ["w14:paraId", "w14:textId"].map((xmlName) => createAttributeHandler(xmlName));
function encode$48(params, encodedAttrs) {
	const { node, table, row, tableProperties, columnIndex, columnWidth, columnWidths: allColumnWidths, preferTableGridWidths, _referencedStyles } = params.extraParams;
	const schemaNode = handleTableCellNode({
		params,
		node,
		table,
		row,
		tableProperties,
		columnIndex,
		columnWidth,
		allColumnWidths,
		preferTableGridWidths,
		_referencedStyles
	});
	if (encodedAttrs && Object.keys(encodedAttrs).length) schemaNode.attrs = {
		...schemaNode.attrs,
		...encodedAttrs
	};
	return schemaNode;
}
function decode$50(params, decodedAttrs) {
	const translated = translateTableCell(params);
	const filteredDecodedAttrs = stripUnsupportedTableIdentityAttributes(decodedAttrs);
	if (Object.keys(filteredDecodedAttrs).length) translated.attributes = {
		...translated.attributes || {},
		...filteredDecodedAttrs
	};
	return translated;
}
const config$31 = {
	xmlName: XML_NODE_NAME$31,
	sdNodeOrKeyName: SD_NODE_NAME$30,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$48,
	decode: decode$50,
	attributes: validXmlAttributes$8
};
const translator$7 = NodeTranslator.from(config$31);
var propertyTranslators$8 = [
	translator$52,
	translator$67,
	translator$85,
	translator$86,
	translator$106,
	translator$137,
	translator$143,
	translator$173
];
const translator$156 = NodeTranslator.from(createNestedPropertiesTranslator("w:tblBorders", "borders", propertyTranslators$8));
const translator$53 = NodeTranslator.from({
	xmlName: "w:cantSplit",
	sdNodeOrKeyName: "cantSplit",
	encode: ({ nodes }) => ["1", "true"].includes(nodes[0].attributes?.["w:val"] ?? "1"),
	decode: ({ node }) => node.attrs?.cantSplit ? { attributes: {} } : void 0
});
const translator$70 = NodeTranslator.from(createSingleAttrPropertyHandler("w:gridAfter", null, "w:val", (v) => parseInteger$1(v) ?? void 0, (v) => integerToString(v)));
const translator$71 = NodeTranslator.from(createSingleAttrPropertyHandler("w:gridBefore", null, "w:val", (v) => parseInteger$1(v) ?? void 0, (v) => integerToString(v)));
const translator$76 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:hidden"));
const translator$159 = NodeTranslator.from(createMeasurementPropertyHandler("w:tblCellSpacing", "tableCellSpacing"));
const translator$162 = NodeTranslator.from({
	xmlName: "w:tblHeader",
	sdNodeOrKeyName: "repeatHeader",
	encode: ({ nodes }) => parseBoolean(nodes[0].attributes?.["w:val"] ?? "1"),
	decode: ({ node }) => node.attrs.repeatHeader ? { attributes: {} } : void 0
});
const translator$174 = NodeTranslator.from({
	xmlName: "w:trHeight",
	sdNodeOrKeyName: "rowHeight",
	encode: ({ nodes }) => {
		const heightAttrs = {};
		const val = nodes[0].attributes["w:val"];
		if (val) heightAttrs["value"] = parseInt(val, 10);
		const rule = nodes[0].attributes["w:hRule"];
		if (rule) heightAttrs["rule"] = rule;
		return Object.keys(heightAttrs).length > 0 ? heightAttrs : void 0;
	},
	decode: ({ node }) => {
		if (!node.attrs?.rowHeight) return;
		const heightAttrs = {};
		if (typeof node.attrs.rowHeight.value === "number" && !isNaN(node.attrs.rowHeight.value)) heightAttrs["w:val"] = String(node.attrs.rowHeight.value);
		if (node.attrs.rowHeight.rule) heightAttrs["w:hRule"] = node.attrs.rowHeight.rule;
		return Object.keys(heightAttrs).length > 0 ? { attributes: heightAttrs } : void 0;
	}
});
const translator$179 = NodeTranslator.from(createMeasurementPropertyHandler("w:wAfter"));
const translator$180 = NodeTranslator.from(createMeasurementPropertyHandler("w:wBefore"));
var propertyTranslators$7 = [
	translator$53,
	translator$55,
	translator$60,
	translator$70,
	translator$71,
	translator$76,
	translator$88,
	translator$159,
	translator$162,
	translator$174,
	translator$179,
	translator$180
];
const translator$175 = NodeTranslator.from(createNestedPropertiesTranslator("w:trPr", "tableRowProperties", propertyTranslators$7, {
	cantSplit: false,
	hidden: false,
	repeatHeader: false
}));
const createPlaceholderCell = (gridWidth, reason) => {
	const safeWidth = Number.isFinite(gridWidth) ? gridWidth : 0;
	const noBorder = {
		val: "none",
		size: 0
	};
	return {
		type: "tableCell",
		attrs: {
			colspan: 1,
			rowspan: 1,
			colwidth: [safeWidth],
			__placeholder: reason,
			borders: {
				top: { ...noBorder },
				right: { ...noBorder },
				bottom: { ...noBorder },
				left: { ...noBorder }
			}
		},
		content: [{
			type: "paragraph",
			content: []
		}]
	};
};
const advancePastRowSpans = (pendingRowSpans, startIndex, totalColumns) => {
	let index = startIndex;
	while (index < totalColumns && pendingRowSpans[index] > 0) {
		pendingRowSpans[index] -= 1;
		index += 1;
	}
	return index;
};
const fillPlaceholderColumns = ({ content: content$2, pendingRowSpans, currentIndex, targetIndex, totalColumns, gridColumnWidths, reason }) => {
	let index = currentIndex;
	while (index < targetIndex && index < totalColumns) {
		if (pendingRowSpans[index] > 0) {
			pendingRowSpans[index] -= 1;
			index += 1;
			continue;
		}
		const width = Array.isArray(gridColumnWidths) ? gridColumnWidths[index] ?? 0 : 0;
		content$2.push(createPlaceholderCell(width, reason));
		index += 1;
	}
	return index;
};
const isPlaceholderCell = (cell) => {
	if (!cell) return false;
	if (cell.attrs?.__placeholder) return true;
	const widths = cell.attrs?.colwidth;
	if (Array.isArray(widths) && widths.length > 0) {
		if (!widths.some((value) => typeof value === "number" && Number.isFinite(value) && Math.abs(value) > 1)) return true;
	}
	return false;
};
function readRowTrackChange(trPr, params = {}) {
	const marker = trPr?.elements?.find((el) => el.name === "w:ins" || el.name === "w:del");
	if (!marker) return null;
	const side = marker.name === "w:ins" ? "insertion" : "deletion";
	const attributes = marker.attributes || {};
	const { sourceId, logicalId } = resolveTrackedChangeImportIds(params, attributes["w:id"]);
	const trackChange = {
		type: side === "insertion" ? "rowInsert" : "rowDelete",
		id: logicalId,
		sourceId,
		author: attributes["w:author"] || "",
		authorEmail: attributes["w:authorEmail"] || "",
		date: attributes["w:date"] || "",
		importedAuthor: `${attributes["w:author"] || ""} (imported)`
	};
	stampImportTrackingAttrs({
		params,
		attrs: trackChange,
		side,
		sourceId
	});
	return trackChange;
}
function buildRowTrackChangeElement(trackChange, params = {}) {
	if (!trackChange || trackChange.type !== "rowInsert" && trackChange.type !== "rowDelete") return null;
	const name = trackChange.type === "rowInsert" ? "w:ins" : "w:del";
	const wId = resolveExportRowWordId(params, trackChange);
	const attributes = { "w:id": wId };
	if (trackChange.author) attributes["w:author"] = trackChange.author;
	if (trackChange.authorEmail) attributes["w:authorEmail"] = trackChange.authorEmail;
	if (trackChange.date) attributes["w:date"] = trackChange.date;
	return {
		name,
		attributes
	};
}
function resolveExportRowWordId(params, trackChange) {
	const sourceId = trackChange.sourceId;
	const logicalId = typeof trackChange.id === "string" ? trackChange.id : "";
	const exportParams = params;
	const allocator = exportParams?.converter?.wordIdAllocator;
	const partPath = exportParams?.currentPartPath || (typeof exportParams?.filename === "string" && exportParams.filename.length > 0 ? `word/${exportParams.filename}` : "word/document.xml");
	if (allocator) return allocator.allocate({
		partPath,
		sourceId: sourceId === void 0 ? void 0 : sourceId === null ? null : String(sourceId),
		logicalId
	});
	return String(sourceId || logicalId || "");
}
var XML_NODE_NAME$30 = "w:tr";
var SD_NODE_NAME$29 = "tableRow";
var validXmlAttributes$7 = [
	"w:rsidDel",
	"w:rsidR",
	"w:rsidRPr",
	"w:rsidTr",
	"w14:paraId",
	"w14:textId"
].map((xmlName) => createAttributeHandler(xmlName));
var getColspan$1 = (cell) => {
	const rawColspan = cell?.attrs?.colspan;
	const numericColspan = typeof rawColspan === "string" ? parseInt(rawColspan, 10) : rawColspan;
	return Number.isFinite(numericColspan) && numericColspan > 0 ? numericColspan : 1;
};
var encode$47 = (params, encodedAttrs) => {
	const { row } = params.extraParams;
	let tableRowProperties = {};
	const tPr = row.elements.find((el) => el.name === "w:trPr");
	if (tPr) tableRowProperties = translator$175.encode({
		...params,
		nodes: [tPr]
	});
	const trackChange = readRowTrackChange(tPr, params);
	if (trackChange) encodedAttrs["trackChange"] = trackChange;
	const gridBeforeRaw = tableRowProperties?.["gridBefore"];
	const safeGridBefore = typeof gridBeforeRaw === "number" && Number.isFinite(gridBeforeRaw) && gridBeforeRaw > 0 ? gridBeforeRaw : 0;
	const tblPrExBorders = (row.elements?.find((el) => el.name === "w:tblPrEx"))?.elements?.find((el) => el.name === "w:tblBorders");
	if (tblPrExBorders) {
		const parsed = translator$156.encode({
			...params,
			nodes: [tblPrExBorders]
		});
		if (parsed && Object.keys(parsed).length > 0) tableRowProperties = {
			...tableRowProperties,
			tblPrExBorders: parsed
		};
	}
	encodedAttrs["tableRowProperties"] = Object.freeze(tableRowProperties);
	encodedAttrs["rowHeight"] = twipsToPixels$2(tableRowProperties["rowHeight"]?.value);
	encodedAttrs["cantSplit"] = tableRowProperties["cantSplit"];
	const { columnWidths: gridColumnWidths, activeRowSpans = [] } = params.extraParams;
	const totalColumns = Array.isArray(gridColumnWidths) ? gridColumnWidths.length : 0;
	const pendingRowSpans = Array.isArray(activeRowSpans) ? activeRowSpans.slice() : [];
	while (pendingRowSpans.length < totalColumns) pendingRowSpans.push(0);
	const cellEntries = normalizeRowCellChildren(row);
	const content$2 = [];
	let currentColumnIndex = 0;
	const fillUntil = (target, reason) => {
		currentColumnIndex = fillPlaceholderColumns({
			content: content$2,
			pendingRowSpans,
			currentIndex: currentColumnIndex,
			targetIndex: target,
			totalColumns,
			gridColumnWidths,
			reason
		});
	};
	const skipOccupiedColumns = () => {
		currentColumnIndex = advancePastRowSpans(pendingRowSpans, currentColumnIndex, totalColumns);
	};
	fillUntil(safeGridBefore, "gridBefore");
	skipOccupiedColumns();
	cellEntries.forEach(({ node, cellSdt }) => {
		skipOccupiedColumns();
		const startColumn = currentColumnIndex;
		if (node._vMergeConsumed) return;
		const columnWidth = gridColumnWidths?.[startColumn] || null;
		const result = translator$7.encode({
			...params,
			nodes: [node],
			path: [...params.path || [], node],
			extraParams: {
				...params.extraParams,
				node,
				columnIndex: startColumn,
				columnWidth
			}
		});
		if (result && cellSdt) result.attrs = {
			...result.attrs || {},
			cellSdt
		};
		if (result) {
			content$2.push(result);
			const colspan = Math.max(1, result.attrs?.colspan || 1);
			const rowspan = Math.max(1, result.attrs?.rowspan || 1);
			if (rowspan > 1) for (let offset = 0; offset < colspan; offset += 1) {
				const target = startColumn + offset;
				if (target < pendingRowSpans.length) pendingRowSpans[target] = Math.max(pendingRowSpans[target], rowspan - 1);
			}
			currentColumnIndex = startColumn + colspan;
		}
	});
	skipOccupiedColumns();
	fillUntil(totalColumns, "gridAfter");
	return {
		type: "tableRow",
		content: content$2,
		attrs: encodedAttrs
	};
};
var decode$49 = (params, decodedAttrs) => {
	const { node } = params;
	const cells = node.content || [];
	let leadingPlaceholders = 0;
	while (leadingPlaceholders < cells.length && isPlaceholderCell(cells[leadingPlaceholders])) leadingPlaceholders += 1;
	let trailingPlaceholders = 0;
	while (trailingPlaceholders < cells.length - leadingPlaceholders && isPlaceholderCell(cells[cells.length - 1 - trailingPlaceholders])) trailingPlaceholders += 1;
	const trimmedSlice = cells.slice(leadingPlaceholders, cells.length - trailingPlaceholders);
	let trimmedContent = trimmedSlice.map((cell) => {
		if (cell?.attrs && "__placeholder" in cell.attrs) {
			const { __placeholder, ...rest } = cell.attrs;
			return {
				...cell,
				attrs: rest
			};
		}
		return cell;
	}).filter((_, index) => !isPlaceholderCell(trimmedSlice[index]));
	const preferTableGrid = params.extraParams?.preferTableGrid === true;
	const totalColumns = params.extraParams?.totalColumns;
	if (preferTableGrid && typeof totalColumns === "number" && Number.isFinite(totalColumns) && totalColumns > 0) {
		const rawGridBefore = node.attrs?.tableRowProperties?.gridBefore;
		const numericGridBefore = typeof rawGridBefore === "string" ? parseInt(rawGridBefore, 10) : rawGridBefore;
		const effectiveGridBefore = leadingPlaceholders > 0 ? leadingPlaceholders : Number.isFinite(numericGridBefore) && numericGridBefore > 0 ? numericGridBefore : 0;
		const availableColumns = Math.max(totalColumns - effectiveGridBefore, 0);
		let usedColumns = 0;
		const constrainedCells = [];
		for (const cell of trimmedContent) {
			const colspan = getColspan$1(cell);
			if (usedColumns + colspan > availableColumns) break;
			constrainedCells.push(cell);
			usedColumns += colspan;
		}
		trimmedContent = constrainedCells;
	}
	const elements = translateChildNodes({
		...params,
		node: {
			...node,
			content: trimmedContent
		}
	});
	let cellCursor = 0;
	for (let i$1 = 0; i$1 < elements.length; i$1 += 1) {
		const exportedEl = elements[i$1];
		if (!exportedEl || exportedEl.name !== "w:tc") continue;
		const sourceCell = trimmedContent[cellCursor];
		cellCursor += 1;
		const cellSdt = sourceCell?.attrs?.cellSdt;
		if (!cellSdt || cellSdt.scope !== "cell" || !cellSdt.sdtPr) continue;
		const sdtChildren = [cellSdt.sdtPr];
		if (cellSdt.sdtEndPr) sdtChildren.push(cellSdt.sdtEndPr);
		sdtChildren.push({
			name: "w:sdtContent",
			elements: [exportedEl]
		});
		elements[i$1] = {
			name: "w:sdt",
			elements: sdtChildren
		};
	}
	if (node.attrs?.tableRowProperties) {
		const tableRowProperties = { ...node.attrs.tableRowProperties };
		if (leadingPlaceholders > 0) tableRowProperties.gridBefore = leadingPlaceholders;
		if (trailingPlaceholders > 0) tableRowProperties.gridAfter = trailingPlaceholders;
		if (node.attrs.rowHeight != null) {
			if (twipsToPixels$2(node.attrs.tableRowProperties["rowHeight"]?.value) !== node.attrs.rowHeight) tableRowProperties["rowHeight"] = { value: String(pixelsToTwips$1(node.attrs["rowHeight"])) };
		}
		tableRowProperties["cantSplit"] = node.attrs["cantSplit"];
		const { tblPrExBorders, ...trPrProperties } = tableRowProperties;
		if (tblPrExBorders && typeof tblPrExBorders === "object" && Object.keys(tblPrExBorders).length > 0) {
			const bordersXml = translator$156.decode({
				...params,
				node: {
					type: "tableRow",
					attrs: { borders: tblPrExBorders }
				}
			});
			if (bordersXml) elements.unshift({
				name: "w:tblPrEx",
				elements: [bordersXml]
			});
		}
		const trPr = translator$175.decode({
			...params,
			node: {
				...node,
				attrs: {
					...node.attrs,
					tableRowProperties: trPrProperties
				}
			}
		});
		if (trPr) elements.unshift(trPr);
	}
	applyRowTrackChangeOnDecode({
		node,
		elements,
		params
	});
	return {
		name: "w:tr",
		attributes: decodedAttrs || {},
		elements
	};
};
var applyRowTrackChangeOnDecode = ({ node, elements, params }) => {
	const marker = buildRowTrackChangeElement(node.attrs?.trackChange, params);
	if (!marker) return;
	let trPr = elements.find((el) => el && el.name === "w:trPr");
	if (!trPr) {
		trPr = {
			name: "w:trPr",
			elements: []
		};
		elements.unshift(trPr);
	}
	if (!Array.isArray(trPr.elements)) trPr.elements = [];
	const trPrChangeIndex = trPr.elements.findIndex((el) => el && el.name === "w:trPrChange");
	if (trPrChangeIndex === -1) trPr.elements.push(marker);
	else trPr.elements.splice(trPrChangeIndex, 0, marker);
	applyCellContentTrackChange({
		elements,
		markerName: marker.name,
		markerAttributes: marker.attributes
	});
};
var applyCellContentTrackChange = ({ elements, markerName, markerAttributes }) => {
	if (markerName !== "w:ins" && markerName !== "w:del") return;
	const isDelete = markerName === "w:del";
	const makeMarker = (children) => ({
		name: markerName,
		attributes: { ...markerAttributes },
		elements: children
	});
	const RUN_CONTAINERS = new Set([
		"w:hyperlink",
		"w:smartTag",
		"w:sdt",
		"w:sdtContent",
		"w:dir",
		"w:bdo"
	]);
	const wrapRuns = (content$2) => (Array.isArray(content$2) ? content$2 : []).map((el) => {
		if (!el || typeof el !== "object") return el;
		if (el.name === "w:r") {
			if (isDelete && Array.isArray(el.elements)) el.elements = el.elements.map((child) => child?.name === "w:t" ? {
				...child,
				name: "w:delText"
			} : child);
			return makeMarker([el]);
		}
		if (RUN_CONTAINERS.has(el.name) && Array.isArray(el.elements)) return {
			...el,
			elements: wrapRuns(el.elements)
		};
		return el;
	});
	for (const tc of elements) {
		if (tc?.name !== "w:tc" || !Array.isArray(tc.elements)) continue;
		for (const paragraph of tc.elements) {
			if (paragraph?.name !== "w:p") continue;
			if (!Array.isArray(paragraph.elements)) paragraph.elements = [];
			let pPr = paragraph.elements.find((el) => el?.name === "w:pPr");
			if (!pPr) {
				pPr = {
					name: "w:pPr",
					elements: []
				};
				paragraph.elements.unshift(pPr);
			}
			if (!Array.isArray(pPr.elements)) pPr.elements = [];
			let rPr = pPr.elements.find((el) => el?.name === "w:rPr");
			if (!rPr) {
				rPr = {
					name: "w:rPr",
					elements: []
				};
				const terminalIdx = pPr.elements.findIndex((el) => el?.name === "w:sectPr" || el?.name === "w:pPrChange");
				if (terminalIdx === -1) pPr.elements.push(rPr);
				else pPr.elements.splice(terminalIdx, 0, rPr);
			}
			if (!Array.isArray(rPr.elements)) rPr.elements = [];
			if (!rPr.elements.some((el) => el?.name === "w:ins" || el?.name === "w:del")) rPr.elements.unshift({
				name: markerName,
				attributes: { ...markerAttributes }
			});
			paragraph.elements = wrapRuns(paragraph.elements);
		}
	}
};
const config$30 = {
	xmlName: XML_NODE_NAME$30,
	sdNodeOrKeyName: SD_NODE_NAME$29,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$47,
	decode: decode$49,
	attributes: validXmlAttributes$7
};
const translator$8 = NodeTranslator.from(config$30);
function parseTagValueJSON(json) {
	if (typeof json !== "string") return {};
	const trimmed = json.trim();
	if (!trimmed) return {};
	try {
		return JSON.parse(trimmed);
	} catch {
		return {};
	}
}
function handleAnnotationNode(params) {
	const { nodes } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:sdt") return null;
	const node = nodes[0];
	const sdtPr = node.elements.find((el) => el.name === "w:sdtPr");
	const sdtContent = node.elements.find((el) => el.name === "w:sdtContent");
	const sdtId = sdtPr?.elements?.find((el) => el.name === "w:id");
	const alias = sdtPr?.elements.find((el) => el.name === "w:alias");
	const tag = sdtPr?.elements.find((el) => el.name === "w:tag");
	const tagValue = tag?.attributes["w:val"];
	const shouldProcessAsJson = tagValue?.startsWith("{") && tagValue?.endsWith("}");
	let attrs = {};
	const aliasLabel = getSafeString(alias?.attributes?.["w:val"]);
	if (shouldProcessAsJson) {
		const parsedAttrs = parseTagValueJSON(tagValue);
		attrs = {
			type: parsedAttrs.fieldTypeShort,
			fieldId: parsedAttrs.fieldId,
			displayLabel: parsedAttrs.displayLabel,
			defaultDisplayLabel: parsedAttrs.defaultDisplayLabel,
			fieldType: parsedAttrs.fieldType,
			fieldColor: parsedAttrs.fieldColor,
			multipleImage: parsedAttrs.fieldMultipleImage,
			fontFamily: parsedAttrs.fieldFontFamily,
			fontSize: parsedAttrs.fieldFontSize,
			textColor: parsedAttrs.fieldTextColor,
			textHighlight: parsedAttrs.fieldTextHighlight,
			hash: parsedAttrs.hash
		};
	} else attrs = getAttrsFromElements({
		sdtPr,
		tag,
		alias,
		sdtId
	});
	const initialDisplayLabel = getSafeString(attrs.displayLabel);
	const extractedContent = getTextFromSdtContent(sdtContent);
	if (!attrs.defaultDisplayLabel) {
		if (initialDisplayLabel) attrs.defaultDisplayLabel = initialDisplayLabel;
		else if (aliasLabel) attrs.defaultDisplayLabel = aliasLabel;
	}
	const placeholderLabel = getPlaceholderLabel(attrs, aliasLabel);
	const placeholderText = ensurePlaceholderFormat(placeholderLabel);
	const isAnnotationsEnabled = Boolean(params.editor?.options?.annotations);
	const contentIsDistinct = shouldUseSdtContent(extractedContent, placeholderText);
	const shouldUseContent = !isAnnotationsEnabled && contentIsDistinct && (hasMoustache(extractedContent) || !placeholderText);
	if (contentIsDistinct) attrs.displayLabel = extractedContent;
	else if (!attrs.displayLabel && placeholderLabel) attrs.displayLabel = placeholderLabel;
	const { attrs: marksAsAttrs, marks } = parseAnnotationMarks(sdtContent);
	const allAttrs = {
		...attrs,
		...marksAsAttrs,
		...sdtPr && { sdtPr }
	};
	if (!allAttrs.hash) allAttrs.hash = generateDocxRandomId(4);
	if (!attrs.fieldId || !attrs.type) return null;
	let result = {
		type: "text",
		text: shouldUseContent ? extractedContent : placeholderText,
		attrs: allAttrs,
		marks
	};
	if (isAnnotationsEnabled) result = {
		type: "fieldAnnotation",
		attrs: allAttrs
	};
	return result;
}
const parseAnnotationMarks = (content$2 = {}) => {
	const rPr = (content$2.elements?.find((el) => el.name === "w:r"))?.elements?.find((el) => el.name === "w:rPr");
	if (!rPr) return {};
	const marks = parseMarks(rPr, []) || [];
	const marksWithFlatFontStyles = [];
	marks.forEach((mark) => {
		const { type } = mark;
		if (type === "textStyle") {
			const { attrs: attrs$1 } = mark;
			Object.keys(attrs$1).forEach((key) => {
				marksWithFlatFontStyles.push({
					type: key,
					attrs: attrs$1[key]
				});
			});
		} else marksWithFlatFontStyles.push(mark);
	});
	const attrs = {};
	marksWithFlatFontStyles?.forEach((mark) => {
		const { type } = mark;
		attrs[type] = mark.attrs || true;
	});
	return {
		attrs,
		marks
	};
};
function getAttrsFromElements({ sdtPr, tag, alias, sdtId }) {
	const type = sdtPr?.elements.find((el) => el.name === "w:fieldTypeShort")?.attributes["w:val"];
	const fieldType = sdtPr?.elements.find((el) => el.name === "w:fieldType")?.attributes["w:val"];
	const fieldColor = sdtPr?.elements.find((el) => el.name === "w:fieldColor")?.attributes["w:val"];
	const isMultipleImage = sdtPr?.elements.find((el) => el.name === "w:fieldMultipleImage")?.attributes["w:val"];
	const fontFamily = sdtPr?.elements.find((el) => el.name === "w:fieldFontFamily")?.attributes["w:val"];
	const fontSize = sdtPr?.elements.find((el) => el.name === "w:fieldFontSize")?.attributes["w:val"];
	const textColor = sdtPr?.elements.find((el) => el.name === "w:fieldTextColor")?.attributes["w:val"];
	const textHighlight = sdtPr?.elements.find((el) => el.name === "w:fieldTextHighlight")?.attributes["w:val"];
	return {
		type,
		fieldId: tag?.attributes["w:val"],
		displayLabel: alias?.attributes["w:val"],
		fieldType,
		fieldColor,
		multipleImage: isMultipleImage === "true",
		fontFamily: fontFamily !== "null" ? fontFamily : null,
		fontSize: fontSize !== "null" ? fontSize : null,
		textColor: textColor !== "null" ? textColor : null,
		textHighlight: textHighlight !== "null" ? textHighlight : null,
		sdtId: sdtId?.attributes["w:val"]
	};
}
function getTextFromSdtContent(sdtContent) {
	if (!sdtContent?.elements?.length) return "";
	const chunks = [];
	collectTextChunks(sdtContent.elements, chunks);
	if (chunks.length && chunks[chunks.length - 1] === "\n") chunks.pop();
	return chunks.join("").replace(/\u00a0/g, " ");
}
function getPlaceholderLabel(attrs, aliasValue) {
	const displayLabel = trimSafeString(attrs.displayLabel);
	if (displayLabel) return displayLabel;
	const defaultLabel = trimSafeString(attrs.defaultDisplayLabel);
	if (defaultLabel) return defaultLabel;
	return trimSafeString(aliasValue);
}
function shouldUseSdtContent(extractedContent, placeholderText) {
	const normalizedContent = normalizePlaceholderText(extractedContent);
	if (!normalizedContent) return false;
	return normalizedContent !== normalizePlaceholderText(placeholderText);
}
function ensurePlaceholderFormat(label) {
	const trimmed = trimSafeString(label);
	if (!trimmed) return "";
	if (trimmed.startsWith("{{") && trimmed.endsWith("}}")) return trimmed;
	return `{{${trimmed}}}`;
}
function normalizePlaceholderText(value = "") {
	const trimmed = trimSafeString(value);
	if (!trimmed) return "";
	return stripPlaceholderBraces(trimmed).toLowerCase();
}
function stripPlaceholderBraces(value = "") {
	if (value.startsWith("{{") && value.endsWith("}}")) return trimSafeString(value.slice(2, -2));
	return value;
}
function hasMoustache(value = "") {
	return /\{\{\s*.+?\s*\}\}/.test(getSafeString(value));
}
function collectTextChunks(elements, chunks) {
	if (!elements) return;
	elements.forEach((element) => {
		if (!element) return;
		if (element.type === "text") {
			chunks.push(element.text || "");
			return;
		}
		if (element.name === "w:tab") {
			chunks.push("	");
			return;
		}
		if (element.name === "w:br") {
			chunks.push("\n");
			return;
		}
		const isParagraph = element.name === "w:p";
		const initialLength = chunks.length;
		if (element.elements?.length) collectTextChunks(element.elements, chunks);
		if (isParagraph && chunks.length > initialLength) chunks.push("\n");
	});
}
function getSafeString(value) {
	if (typeof value !== "string") return "";
	return value;
}
function trimSafeString(value) {
	return getSafeString(value).replace(/\u00a0/g, " ").trim();
}
function handleDocPartObj(params) {
	const { nodes } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:sdt") return null;
	const node = nodes[0];
	const sdtPr = node.elements.find((el) => el.name === "w:sdtPr");
	const docPartGalleryType = ((sdtPr?.elements.find((el) => el.name === "w:docPartObj"))?.elements.find((el) => el.name === "w:docPartGallery"))?.attributes?.["w:val"] ?? null;
	const content$2 = node?.elements.find((el) => el.name === "w:sdtContent");
	const isInsideParagraph = (params.path || []).some((p) => p?.name === "w:p");
	const hasBlockChild = !!content$2?.elements?.some((el) => el?.name === "w:p" || el?.name === "w:tbl");
	if (isInsideParagraph && !hasBlockChild) return inlineDocPartHandler({
		...params,
		nodes: [content$2],
		extraParams: {
			...params.extraParams || {},
			sdtPr,
			docPartGalleryType
		}
	});
	return (validGalleryTypeMap[docPartGalleryType] || genericDocPartHandler)({
		...params,
		nodes: [content$2],
		extraParams: {
			...params.extraParams || {},
			sdtPr,
			docPartGalleryType
		}
	});
}
var inlineDocPartHandler = (params) => {
	const node = params.nodes[0];
	const translatedContent = params.nodeListHandler.handler({
		...params,
		nodes: node?.elements || [],
		path: [...params.path || [], node]
	});
	const sdtPr = params.extraParams.sdtPr;
	const docPartGalleryType = params.extraParams.docPartGalleryType;
	const id = sdtPr?.elements?.find((el) => el.name === "w:id")?.attributes?.["w:val"] || null;
	const docPartObj = sdtPr?.elements.find((el) => el.name === "w:docPartObj");
	return {
		type: "structuredContent",
		content: translatedContent,
		attrs: {
			id,
			docPartGallery: docPartGalleryType ?? docPartObj?.elements?.find((el) => el.name === "w:docPartGallery")?.attributes?.["w:val"] ?? null,
			docPartUnique: docPartObj?.elements?.some((el) => el.name === "w:docPartUnique") ?? false,
			sdtPr
		}
	};
};
const tableOfContentsHandler = (params) => {
	const node = params.nodes[0];
	const normalizedContent = normalizeDocPartContent(translateTocSdtContent(node, params));
	const sdtPr = params.extraParams.sdtPr;
	return {
		type: "documentPartObject",
		content: normalizedContent,
		attrs: {
			id: sdtPr.elements?.find((el) => el.name === "w:id")?.attributes["w:val"] || "",
			docPartGallery: "Table of Contents",
			docPartUnique: (sdtPr?.elements.find((el) => el.name === "w:docPartObj"))?.elements.some((el) => el.name === "w:docPartUnique") ?? false,
			sdtPr
		}
	};
};
const genericDocPartHandler = (params) => {
	const node = params.nodes[0];
	const translatedContent = params.nodeListHandler.handler({
		...params,
		nodes: node.elements,
		path: [...params.path || [], node]
	});
	const sdtPr = params.extraParams.sdtPr;
	const docPartGalleryType = params.extraParams.docPartGalleryType;
	const id = sdtPr?.elements?.find((el) => el.name === "w:id")?.attributes["w:val"] || "";
	const docPartObj = sdtPr?.elements.find((el) => el.name === "w:docPartObj");
	const docPartGallery = docPartGalleryType ?? docPartObj?.elements?.find((el) => el.name === "w:docPartGallery")?.attributes?.["w:val"] ?? null;
	const docPartUnique = docPartObj?.elements.some((el) => el.name === "w:docPartUnique") ?? false;
	return {
		type: "documentPartObject",
		content: normalizeDocPartContent(translatedContent),
		attrs: {
			id,
			docPartGallery,
			docPartUnique,
			sdtPr
		}
	};
};
var validGalleryTypeMap = { "Table of Contents": tableOfContentsHandler };
var inlineNodeTypes = new Set([
	"bookmarkStart",
	"bookmarkEnd",
	"commentRangeStart",
	"commentRangeEnd",
	"permStart",
	"permEnd"
]);
var SD_TOC_XML_NAME = "sd:tableOfContents";
var PARAGRAPH_XML_NAME = "w:p";
var PARAGRAPH_PROPERTIES_XML_NAME$1 = "w:pPr";
var wrapInlineNode = (node) => ({
	type: "paragraph",
	content: [node]
});
var hasMeaningfulParagraphContent$1 = (elements = []) => elements.some((element) => element?.name && element.name !== PARAGRAPH_PROPERTIES_XML_NAME$1);
var translateNodes = (params, nodes, pathTail = []) => params.nodeListHandler.handler({
	...params,
	nodes,
	path: [...params.path || [], ...pathTail]
});
var translateTocSdtContent = (sdtContent, params) => {
	const translatedContent = [];
	const parentPath = [sdtContent];
	(sdtContent?.elements || []).forEach((child) => {
		const childElements = Array.isArray(child?.elements) ? child.elements : [];
		const tocElements = child?.name === PARAGRAPH_XML_NAME ? childElements.filter((el) => el?.name === SD_TOC_XML_NAME) : [];
		if (tocElements.length === 0) {
			translatedContent.push(...translateNodes(params, [child], parentPath));
			return;
		}
		const remainingElements = childElements.filter((el) => el?.name !== SD_TOC_XML_NAME);
		if (hasMeaningfulParagraphContent$1(remainingElements)) translatedContent.push(...translateNodes(params, [{
			...child,
			elements: remainingElements
		}], parentPath));
		tocElements.forEach((tocElement) => {
			translatedContent.push(...translateNodes(params, [tocElement], [...parentPath, child]));
		});
	});
	return translatedContent;
};
const normalizeDocPartContent = (nodes = []) => {
	const normalized = [];
	nodes.forEach((node) => {
		if (inlineNodeTypes.has(node?.type)) normalized.push(wrapInlineNode(node));
		else normalized.push(node);
	});
	return normalized;
};
function handleDocumentSectionNode$1(params) {
	const { nodes, nodeListHandler } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:sdt") return null;
	const node = nodes[0];
	const sdtPr = node.elements.find((el) => el.name === "w:sdtPr");
	const tag = sdtPr?.elements.find((el) => el.name === "w:tag");
	const tagValue = parseTagValueJSON(tag?.attributes?.["w:val"]);
	const id = (sdtPr?.elements.find((el) => el.name === "w:id"))?.attributes?.["w:val"] || tagValue.id || null;
	const title = (sdtPr?.elements.find((el) => el.name === "w:alias"))?.attributes?.["w:val"] || tagValue.title || null;
	const { description } = tagValue;
	const isLocked = (sdtPr?.elements.find((el) => el.name === "w:lock"))?.attributes?.["w:val"] === "sdtContentLocked";
	const sdtContent = node.elements.find((el) => el.name === "w:sdtContent");
	return {
		type: "documentSection",
		content: nodeListHandler.handler({
			...params,
			nodes: sdtContent?.elements,
			path: [...params.path || [], node]
		}),
		attrs: {
			id,
			title,
			description,
			isLocked,
			...sdtPr && { sdtPr }
		}
	};
}
const BLOCK_FIELD_XML_NAMES = new Set([
	"sd:tableOfContents",
	"sd:index",
	"sd:bibliography",
	"sd:tableOfAuthorities"
]);
var INLINE_CONTEXT_XML_NAMES = new Set([
	"w:p",
	"w:r",
	"w:hyperlink",
	"w:smartTag"
]);
function hasDirectBlockSignal(sdtContent) {
	return Boolean(sdtContent?.elements?.some((el) => el?.name === "w:p" || el?.name === "w:tbl" || BLOCK_FIELD_XML_NAMES.has(el?.name)));
}
function canEmitInlineStructuredContent(path = []) {
	return path.some((entry) => INLINE_CONTEXT_XML_NAMES.has(entry?.name) || entry?.name === "w:sdtContent");
}
function hasTranslatedBlockContent(content$2 = [], schema) {
	return content$2.some((node) => node?.type && !isInlineNode(node, schema));
}
function wrapInlineRunsAsParagraphs(content$2 = [], schema) {
	const normalized = [];
	let pendingInline = [];
	const flushInline = () => {
		if (!pendingInline.length) return;
		normalized.push({
			type: "paragraph",
			attrs: null,
			content: pendingInline,
			marks: []
		});
		pendingInline = [];
	};
	for (const node of content$2) {
		if (!node) continue;
		if (isInlineNode(node, schema)) {
			pendingInline.push(node);
			continue;
		}
		flushInline();
		normalized.push(node);
	}
	flushInline();
	return normalized;
}
function detectControlType(sdtPr) {
	if (!sdtPr?.elements) return "richText";
	const names = sdtPr.elements.map((el) => el.name);
	if (names.includes("w:text")) return "text";
	if (names.includes("w:richText")) return "richText";
	if (names.includes("w:date")) return "date";
	if (names.includes("w14:checkbox") || names.includes("w:checkbox")) return "checkbox";
	if (names.includes("w:comboBox")) return "comboBox";
	if (names.includes("w:dropDownList")) return "dropDownList";
	if (names.includes("w15:repeatingSection") || names.includes("w:repeatingSection")) return "repeatingSection";
	if (names.includes("w15:repeatingSectionItem") || names.includes("w:repeatingSectionItem")) return "repeatingSectionItem";
	if (names.includes("w:group")) return "group";
	const TYPE_CHILD_NAMES = new Set([
		"w:equation",
		"w:picture",
		"w:citation",
		"w:bibliography",
		"w:docPartList"
	]);
	if (names.some((n) => TYPE_CHILD_NAMES.has(n))) return null;
	return "richText";
}
function extractAppearance(sdtPr) {
	const el = sdtPr?.elements?.find((e) => e.name === "w:appearance" || e.name === "w15:appearance");
	const val = el?.attributes?.["w:val"] ?? el?.attributes?.["w15:val"];
	return [
		"boundingBox",
		"tags",
		"hidden"
	].includes(val) ? val : null;
}
function extractPlaceholder(sdtPr) {
	return ((sdtPr?.elements?.find((e) => e.name === "w:placeholder"))?.elements?.find((e) => e.name === "w:docPart"))?.attributes?.["w:val"] ?? null;
}
function extractTemporary(sdtPr) {
	const el = sdtPr?.elements?.find((e) => e.name === "w:temporary");
	if (!el) return void 0;
	return parseStrictStOnOff(el.attributes?.["w:val"], "temporary", "w:temporary");
}
function handleStructuredContentNode(params) {
	const { nodes, nodeListHandler } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:sdt") return null;
	const node = nodes[0];
	const sdtPr = node.elements.find((el) => el.name === "w:sdtPr");
	const sdtContent = node.elements.find((el) => el.name === "w:sdtContent");
	const id = sdtPr?.elements?.find((el) => el.name === "w:id");
	const tag = sdtPr?.elements?.find((el) => el.name === "w:tag");
	const alias = sdtPr?.elements?.find((el) => el.name === "w:alias");
	const lockValue = (sdtPr?.elements?.find((el) => el.name === "w:lock"))?.attributes?.["w:val"];
	const lockMode = [
		"unlocked",
		"sdtLocked",
		"contentLocked",
		"sdtContentLocked"
	].includes(lockValue) ? lockValue : "unlocked";
	const controlType = detectControlType(sdtPr);
	const appearance = extractAppearance(sdtPr);
	const placeholder = extractPlaceholder(sdtPr);
	const temporary = extractTemporary(sdtPr);
	if (!sdtContent) return null;
	const { marks } = parseAnnotationMarks(sdtContent);
	const translatedContent = nodeListHandler.handler({
		...params,
		nodes: sdtContent.elements,
		path: [...params.path || [], sdtContent]
	});
	const schema = params.editor?.schema;
	const content$2 = Array.isArray(translatedContent) ? translatedContent : [];
	const isBlockNode$1 = hasTranslatedBlockContent(content$2, schema) || hasDirectBlockSignal(sdtContent) || !canEmitInlineStructuredContent(params.path);
	return {
		type: isBlockNode$1 ? "structuredContentBlock" : "structuredContent",
		content: isBlockNode$1 ? wrapInlineRunsAsParagraphs(content$2, schema) : content$2,
		marks,
		attrs: {
			id: id?.attributes?.["w:val"] || null,
			tag: tag?.attributes?.["w:val"] || null,
			alias: alias?.attributes?.["w:val"] || null,
			lockMode,
			controlType,
			type: controlType,
			appearance,
			placeholder,
			...temporary !== void 0 ? { temporary } : {},
			sdtPr
		}
	};
}
function sdtNodeTypeStrategy(node) {
	const sdtContent = node.elements.find((el) => el.name === "w:sdtContent");
	const sdtPr = node.elements.find((el) => el.name === "w:sdtPr");
	const tagValue = (sdtPr?.elements.find((el) => el.name === "w:tag"))?.attributes?.["w:val"];
	if (sdtPr?.elements.find((el) => el.name === "w:docPartObj")) return {
		type: "docPartObj",
		handler: handleDocPartObj
	};
	if (tagValue) if (tagValue.startsWith("{") && tagValue.endsWith("}")) {
		const parsedTag = parseTagValueJSON(tagValue);
		if (parsedTag.type === "documentSection") return {
			type: "documentSection",
			handler: handleDocumentSectionNode$1
		};
		if (parsedTag.fieldId && parsedTag.fieldTypeShort) return {
			type: "fieldAnnotation",
			handler: handleAnnotationNode
		};
	} else {
		const fieldTypeShortValue = sdtPr.elements.find((el) => el.name === "w:fieldTypeShort")?.attributes["w:val"];
		if (tagValue && fieldTypeShortValue) return {
			type: "fieldAnnotation",
			handler: handleAnnotationNode
		};
	}
	if (sdtContent) return {
		type: "structuredContent",
		handler: handleStructuredContentNode
	};
	return {
		type: "unknown",
		handler: null
	};
}
var lower16 = 65535;
var factor16 = Math.pow(2, 16);
function makeRecover(index, offset) {
	return index + offset * factor16;
}
function recoverIndex(value) {
	return value & lower16;
}
function recoverOffset(value) {
	return (value - (value & lower16)) / factor16;
}
var DEL_BEFORE = 1, DEL_AFTER = 2, DEL_ACROSS = 4, DEL_SIDE = 8;
var MapResult = class {
	constructor(pos, delInfo, recover) {
		this.pos = pos;
		this.delInfo = delInfo;
		this.recover = recover;
	}
	get deleted() {
		return (this.delInfo & DEL_SIDE) > 0;
	}
	get deletedBefore() {
		return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0;
	}
	get deletedAfter() {
		return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0;
	}
	get deletedAcross() {
		return (this.delInfo & DEL_ACROSS) > 0;
	}
};
var StepMap = class StepMap {
	constructor(ranges, inverted = false) {
		this.ranges = ranges;
		this.inverted = inverted;
		if (!ranges.length && StepMap.empty) return StepMap.empty;
	}
	recover(value) {
		let diff = 0, index = recoverIndex(value);
		if (!this.inverted) for (let i$1 = 0; i$1 < index; i$1++) diff += this.ranges[i$1 * 3 + 2] - this.ranges[i$1 * 3 + 1];
		return this.ranges[index * 3] + diff + recoverOffset(value);
	}
	mapResult(pos, assoc = 1) {
		return this._map(pos, assoc, false);
	}
	map(pos, assoc = 1) {
		return this._map(pos, assoc, true);
	}
	_map(pos, assoc, simple) {
		let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
		for (let i$1 = 0; i$1 < this.ranges.length; i$1 += 3) {
			let start = this.ranges[i$1] - (this.inverted ? diff : 0);
			if (start > pos) break;
			let oldSize = this.ranges[i$1 + oldIndex], newSize = this.ranges[i$1 + newIndex], end = start + oldSize;
			if (pos <= end) {
				let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
				let result = start + diff + (side < 0 ? 0 : newSize);
				if (simple) return result;
				let recover = pos == (assoc < 0 ? start : end) ? null : makeRecover(i$1 / 3, pos - start);
				let del = pos == start ? DEL_AFTER : pos == end ? DEL_BEFORE : DEL_ACROSS;
				if (assoc < 0 ? pos != start : pos != end) del |= DEL_SIDE;
				return new MapResult(result, del, recover);
			}
			diff += newSize - oldSize;
		}
		return simple ? pos + diff : new MapResult(pos + diff, 0, null);
	}
	touches(pos, recover) {
		let diff = 0, index = recoverIndex(recover);
		let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
		for (let i$1 = 0; i$1 < this.ranges.length; i$1 += 3) {
			let start = this.ranges[i$1] - (this.inverted ? diff : 0);
			if (start > pos) break;
			let oldSize = this.ranges[i$1 + oldIndex];
			if (pos <= start + oldSize && i$1 == index * 3) return true;
			diff += this.ranges[i$1 + newIndex] - oldSize;
		}
		return false;
	}
	forEach(f) {
		let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
		for (let i$1 = 0, diff = 0; i$1 < this.ranges.length; i$1 += 3) {
			let start = this.ranges[i$1], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
			let oldSize = this.ranges[i$1 + oldIndex], newSize = this.ranges[i$1 + newIndex];
			f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
			diff += newSize - oldSize;
		}
	}
	invert() {
		return new StepMap(this.ranges, !this.inverted);
	}
	toString() {
		return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
	}
	static offset(n) {
		return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [
			0,
			-n,
			0
		] : [
			0,
			0,
			n
		]);
	}
};
StepMap.empty = new StepMap([]);
var Mapping = class Mapping {
	constructor(maps, mirror, from = 0, to = maps ? maps.length : 0) {
		this.mirror = mirror;
		this.from = from;
		this.to = to;
		this._maps = maps || [];
		this.ownData = !(maps || mirror);
	}
	get maps() {
		return this._maps;
	}
	slice(from = 0, to = this.maps.length) {
		return new Mapping(this._maps, this.mirror, from, to);
	}
	appendMap(map, mirrors) {
		if (!this.ownData) {
			this._maps = this._maps.slice();
			this.mirror = this.mirror && this.mirror.slice();
			this.ownData = true;
		}
		this.to = this._maps.push(map);
		if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
	}
	appendMapping(mapping) {
		for (let i$1 = 0, startSize = this._maps.length; i$1 < mapping._maps.length; i$1++) {
			let mirr = mapping.getMirror(i$1);
			this.appendMap(mapping._maps[i$1], mirr != null && mirr < i$1 ? startSize + mirr : void 0);
		}
	}
	getMirror(n) {
		if (this.mirror) {
			for (let i$1 = 0; i$1 < this.mirror.length; i$1++) if (this.mirror[i$1] == n) return this.mirror[i$1 + (i$1 % 2 ? -1 : 1)];
		}
	}
	setMirror(n, m) {
		if (!this.mirror) this.mirror = [];
		this.mirror.push(n, m);
	}
	appendMappingInverted(mapping) {
		for (let i$1 = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i$1 >= 0; i$1--) {
			let mirr = mapping.getMirror(i$1);
			this.appendMap(mapping._maps[i$1].invert(), mirr != null && mirr > i$1 ? totalSize - mirr - 1 : void 0);
		}
	}
	invert() {
		let inverse = new Mapping();
		inverse.appendMappingInverted(this);
		return inverse;
	}
	map(pos, assoc = 1) {
		if (this.mirror) return this._map(pos, assoc, true);
		for (let i$1 = this.from; i$1 < this.to; i$1++) pos = this._maps[i$1].map(pos, assoc);
		return pos;
	}
	mapResult(pos, assoc = 1) {
		return this._map(pos, assoc, false);
	}
	_map(pos, assoc, simple) {
		let delInfo = 0;
		for (let i$1 = this.from; i$1 < this.to; i$1++) {
			let result = this._maps[i$1].mapResult(pos, assoc);
			if (result.recover != null) {
				let corr = this.getMirror(i$1);
				if (corr != null && corr > i$1 && corr < this.to) {
					i$1 = corr;
					pos = this._maps[corr].recover(result.recover);
					continue;
				}
			}
			delInfo |= result.delInfo;
			pos = result.pos;
		}
		return simple ? pos : new MapResult(pos, delInfo, null);
	}
};
var stepsByID = Object.create(null);
var Step = class {
	getMap() {
		return StepMap.empty;
	}
	merge(other) {
		return null;
	}
	static fromJSON(schema, json) {
		if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
		let type = stepsByID[json.stepType];
		if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
		return type.fromJSON(schema, json);
	}
	static jsonID(id, stepClass) {
		if (id in stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
		stepsByID[id] = stepClass;
		stepClass.prototype.jsonID = id;
		return stepClass;
	}
};
var StepResult = class StepResult {
	constructor(doc$2, failed) {
		this.doc = doc$2;
		this.failed = failed;
	}
	static ok(doc$2) {
		return new StepResult(doc$2, null);
	}
	static fail(message) {
		return new StepResult(null, message);
	}
	static fromReplace(doc$2, from, to, slice) {
		try {
			return StepResult.ok(doc$2.replace(from, to, slice));
		} catch (e) {
			if (e instanceof ReplaceError) return StepResult.fail(e.message);
			throw e;
		}
	}
};
function mapFragment(fragment, f, parent) {
	let mapped = [];
	for (let i$1 = 0; i$1 < fragment.childCount; i$1++) {
		let child = fragment.child(i$1);
		if (child.content.size) child = child.copy(mapFragment(child.content, f, child));
		if (child.isInline) child = f(child, parent, i$1);
		mapped.push(child);
	}
	return Fragment.fromArray(mapped);
}
var AddMarkStep = class AddMarkStep extends Step {
	constructor(from, to, mark) {
		super();
		this.from = from;
		this.to = to;
		this.mark = mark;
	}
	apply(doc$2) {
		let oldSlice = doc$2.slice(this.from, this.to), $from = doc$2.resolve(this.from);
		let parent = $from.node($from.sharedDepth(this.to));
		let slice = new Slice(mapFragment(oldSlice.content, (node, parent$1) => {
			if (!node.isAtom || !parent$1.type.allowsMarkType(this.mark.type)) return node;
			return node.mark(this.mark.addToSet(node.marks));
		}, parent), oldSlice.openStart, oldSlice.openEnd);
		return StepResult.fromReplace(doc$2, this.from, this.to, slice);
	}
	invert() {
		return new RemoveMarkStep(this.from, this.to, this.mark);
	}
	map(mapping) {
		let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
		if (from.deleted && to.deleted || from.pos >= to.pos) return null;
		return new AddMarkStep(from.pos, to.pos, this.mark);
	}
	merge(other) {
		if (other instanceof AddMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
		return null;
	}
	toJSON() {
		return {
			stepType: "addMark",
			mark: this.mark.toJSON(),
			from: this.from,
			to: this.to
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
		return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
	}
};
Step.jsonID("addMark", AddMarkStep);
var RemoveMarkStep = class RemoveMarkStep extends Step {
	constructor(from, to, mark) {
		super();
		this.from = from;
		this.to = to;
		this.mark = mark;
	}
	apply(doc$2) {
		let oldSlice = doc$2.slice(this.from, this.to);
		let slice = new Slice(mapFragment(oldSlice.content, (node) => {
			return node.mark(this.mark.removeFromSet(node.marks));
		}, doc$2), oldSlice.openStart, oldSlice.openEnd);
		return StepResult.fromReplace(doc$2, this.from, this.to, slice);
	}
	invert() {
		return new AddMarkStep(this.from, this.to, this.mark);
	}
	map(mapping) {
		let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
		if (from.deleted && to.deleted || from.pos >= to.pos) return null;
		return new RemoveMarkStep(from.pos, to.pos, this.mark);
	}
	merge(other) {
		if (other instanceof RemoveMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
		return null;
	}
	toJSON() {
		return {
			stepType: "removeMark",
			mark: this.mark.toJSON(),
			from: this.from,
			to: this.to
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
		return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
	}
};
Step.jsonID("removeMark", RemoveMarkStep);
var AddNodeMarkStep = class AddNodeMarkStep extends Step {
	constructor(pos, mark) {
		super();
		this.pos = pos;
		this.mark = mark;
	}
	apply(doc$2) {
		let node = doc$2.nodeAt(this.pos);
		if (!node) return StepResult.fail("No node at mark step's position");
		let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
		return StepResult.fromReplace(doc$2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
	}
	invert(doc$2) {
		let node = doc$2.nodeAt(this.pos);
		if (node) {
			let newSet = this.mark.addToSet(node.marks);
			if (newSet.length == node.marks.length) {
				for (let i$1 = 0; i$1 < node.marks.length; i$1++) if (!node.marks[i$1].isInSet(newSet)) return new AddNodeMarkStep(this.pos, node.marks[i$1]);
				return new AddNodeMarkStep(this.pos, this.mark);
			}
		}
		return new RemoveNodeMarkStep(this.pos, this.mark);
	}
	map(mapping) {
		let pos = mapping.mapResult(this.pos, 1);
		return pos.deletedAfter ? null : new AddNodeMarkStep(pos.pos, this.mark);
	}
	toJSON() {
		return {
			stepType: "addNodeMark",
			pos: this.pos,
			mark: this.mark.toJSON()
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
		return new AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
	}
};
Step.jsonID("addNodeMark", AddNodeMarkStep);
var RemoveNodeMarkStep = class RemoveNodeMarkStep extends Step {
	constructor(pos, mark) {
		super();
		this.pos = pos;
		this.mark = mark;
	}
	apply(doc$2) {
		let node = doc$2.nodeAt(this.pos);
		if (!node) return StepResult.fail("No node at mark step's position");
		let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
		return StepResult.fromReplace(doc$2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
	}
	invert(doc$2) {
		let node = doc$2.nodeAt(this.pos);
		if (!node || !this.mark.isInSet(node.marks)) return this;
		return new AddNodeMarkStep(this.pos, this.mark);
	}
	map(mapping) {
		let pos = mapping.mapResult(this.pos, 1);
		return pos.deletedAfter ? null : new RemoveNodeMarkStep(pos.pos, this.mark);
	}
	toJSON() {
		return {
			stepType: "removeNodeMark",
			pos: this.pos,
			mark: this.mark.toJSON()
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
		return new RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
	}
};
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);
var ReplaceStep = class ReplaceStep extends Step {
	constructor(from, to, slice, structure = false) {
		super();
		this.from = from;
		this.to = to;
		this.slice = slice;
		this.structure = structure;
	}
	apply(doc$2) {
		if (this.structure && contentBetween(doc$2, this.from, this.to)) return StepResult.fail("Structure replace would overwrite content");
		return StepResult.fromReplace(doc$2, this.from, this.to, this.slice);
	}
	getMap() {
		return new StepMap([
			this.from,
			this.to - this.from,
			this.slice.size
		]);
	}
	invert(doc$2) {
		return new ReplaceStep(this.from, this.from + this.slice.size, doc$2.slice(this.from, this.to));
	}
	map(mapping) {
		let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
		if (from.deletedAcross && to.deletedAcross) return null;
		return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
	}
	merge(other) {
		if (!(other instanceof ReplaceStep) || other.structure || this.structure) return null;
		if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
			let slice = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
			return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure);
		} else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
			let slice = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
			return new ReplaceStep(other.from, this.to, slice, this.structure);
		} else return null;
	}
	toJSON() {
		let json = {
			stepType: "replace",
			from: this.from,
			to: this.to
		};
		if (this.slice.size) json.slice = this.slice.toJSON();
		if (this.structure) json.structure = true;
		return json;
	}
	static fromJSON(schema, json) {
		if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
		return new ReplaceStep(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure);
	}
};
Step.jsonID("replace", ReplaceStep);
var ReplaceAroundStep = class ReplaceAroundStep extends Step {
	constructor(from, to, gapFrom, gapTo, slice, insert, structure = false) {
		super();
		this.from = from;
		this.to = to;
		this.gapFrom = gapFrom;
		this.gapTo = gapTo;
		this.slice = slice;
		this.insert = insert;
		this.structure = structure;
	}
	apply(doc$2) {
		if (this.structure && (contentBetween(doc$2, this.from, this.gapFrom) || contentBetween(doc$2, this.gapTo, this.to))) return StepResult.fail("Structure gap-replace would overwrite content");
		let gap = doc$2.slice(this.gapFrom, this.gapTo);
		if (gap.openStart || gap.openEnd) return StepResult.fail("Gap is not a flat range");
		let inserted = this.slice.insertAt(this.insert, gap.content);
		if (!inserted) return StepResult.fail("Content does not fit in gap");
		return StepResult.fromReplace(doc$2, this.from, this.to, inserted);
	}
	getMap() {
		return new StepMap([
			this.from,
			this.gapFrom - this.from,
			this.insert,
			this.gapTo,
			this.to - this.gapTo,
			this.slice.size - this.insert
		]);
	}
	invert(doc$2) {
		let gap = this.gapTo - this.gapFrom;
		return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc$2.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
	}
	map(mapping) {
		let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
		let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
		let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
		if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
		return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
	}
	toJSON() {
		let json = {
			stepType: "replaceAround",
			from: this.from,
			to: this.to,
			gapFrom: this.gapFrom,
			gapTo: this.gapTo,
			insert: this.insert
		};
		if (this.slice.size) json.slice = this.slice.toJSON();
		if (this.structure) json.structure = true;
		return json;
	}
	static fromJSON(schema, json) {
		if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
		return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
	}
};
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc$2, from, to) {
	let $from = doc$2.resolve(from), dist = to - from, depth = $from.depth;
	while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
		depth--;
		dist--;
	}
	if (dist > 0) {
		let next = $from.node(depth).maybeChild($from.indexAfter(depth));
		while (dist > 0) {
			if (!next || next.isLeaf) return true;
			next = next.firstChild;
			dist--;
		}
	}
	return false;
}
function addMark(tr, from, to, mark) {
	let removed = [], added = [];
	let removing, adding;
	tr.doc.nodesBetween(from, to, (node, pos, parent) => {
		if (!node.isInline) return;
		let marks = node.marks;
		if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
			let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
			let newSet = mark.addToSet(marks);
			for (let i$1 = 0; i$1 < marks.length; i$1++) if (!marks[i$1].isInSet(newSet)) if (removing && removing.to == start && removing.mark.eq(marks[i$1])) removing.to = end;
			else removed.push(removing = new RemoveMarkStep(start, end, marks[i$1]));
			if (adding && adding.to == start) adding.to = end;
			else added.push(adding = new AddMarkStep(start, end, mark));
		}
	});
	removed.forEach((s) => tr.step(s));
	added.forEach((s) => tr.step(s));
}
function removeMark(tr, from, to, mark) {
	let matched = [], step$1 = 0;
	tr.doc.nodesBetween(from, to, (node, pos) => {
		if (!node.isInline) return;
		step$1++;
		let toRemove = null;
		if (mark instanceof MarkType) {
			let set = node.marks, found$1;
			while (found$1 = mark.isInSet(set)) {
				(toRemove || (toRemove = [])).push(found$1);
				set = found$1.removeFromSet(set);
			}
		} else if (mark) {
			if (mark.isInSet(node.marks)) toRemove = [mark];
		} else toRemove = node.marks;
		if (toRemove && toRemove.length) {
			let end = Math.min(pos + node.nodeSize, to);
			for (let i$1 = 0; i$1 < toRemove.length; i$1++) {
				let style = toRemove[i$1], found$1;
				for (let j = 0; j < matched.length; j++) {
					let m = matched[j];
					if (m.step == step$1 - 1 && style.eq(matched[j].style)) found$1 = m;
				}
				if (found$1) {
					found$1.to = end;
					found$1.step = step$1;
				} else matched.push({
					style,
					from: Math.max(pos, from),
					to: end,
					step: step$1
				});
			}
		}
	});
	matched.forEach((m) => tr.step(new RemoveMarkStep(m.from, m.to, m.style)));
}
function clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
	let node = tr.doc.nodeAt(pos);
	let replSteps = [], cur = pos + 1;
	for (let i$1 = 0; i$1 < node.childCount; i$1++) {
		let child = node.child(i$1), end = cur + child.nodeSize;
		let allowed = match.matchType(child.type);
		if (!allowed) replSteps.push(new ReplaceStep(cur, end, Slice.empty));
		else {
			match = allowed;
			for (let j = 0; j < child.marks.length; j++) if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new RemoveMarkStep(cur, end, child.marks[j]));
			if (clearNewlines && child.isText && parentType.whitespace != "pre") {
				let m, newline = /\r?\n|\r/g, slice;
				while (m = newline.exec(child.text)) {
					if (!slice) slice = new Slice(Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
					replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice));
				}
			}
		}
		cur = end;
	}
	if (!match.validEnd) {
		let fill = match.fillBefore(Fragment.empty, true);
		tr.replace(cur, cur, new Slice(fill, 0, 0));
	}
	for (let i$1 = replSteps.length - 1; i$1 >= 0; i$1--) tr.step(replSteps[i$1]);
}
function canCut(node, start, end) {
	return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
function liftTarget(range) {
	let content$2 = range.parent.content.cutByIndex(range.startIndex, range.endIndex);
	for (let depth = range.depth, contentBefore = 0, contentAfter = 0;; --depth) {
		let node = range.$from.node(depth);
		let index = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
		if (depth < range.depth && node.canReplace(index, endIndex, content$2)) return depth;
		if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) break;
		if (index) contentBefore = 1;
		if (endIndex < node.childCount) contentAfter = 1;
	}
	return null;
}
function lift(tr, range, target) {
	let { $from, $to, depth } = range;
	let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
	let start = gapStart, end = gapEnd;
	let before = Fragment.empty, openStart = 0;
	for (let d = depth, splitting = false; d > target; d--) if (splitting || $from.index(d) > 0) {
		splitting = true;
		before = Fragment.from($from.node(d).copy(before));
		openStart++;
	} else start--;
	let after = Fragment.empty, openEnd = 0;
	for (let d = depth, splitting = false; d > target; d--) if (splitting || $to.after(d + 1) < $to.end(d)) {
		splitting = true;
		after = Fragment.from($to.node(d).copy(after));
		openEnd++;
	} else end++;
	tr.step(new ReplaceAroundStep(start, end, gapStart, gapEnd, new Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
function wrap(tr, range, wrappers) {
	let content$2 = Fragment.empty;
	for (let i$1 = wrappers.length - 1; i$1 >= 0; i$1--) {
		if (content$2.size) {
			let match = wrappers[i$1].type.contentMatch.matchFragment(content$2);
			if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
		}
		content$2 = Fragment.from(wrappers[i$1].type.create(wrappers[i$1].attrs, content$2));
	}
	let start = range.start, end = range.end;
	tr.step(new ReplaceAroundStep(start, end, start, end, new Slice(content$2, 0, 0), wrappers.length, true));
}
function setBlockType(tr, from, to, type, attrs) {
	if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
	let mapFrom = tr.steps.length;
	tr.doc.nodesBetween(from, to, (node, pos) => {
		let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
		if (node.isTextblock && !node.hasMarkup(type, attrsHere) && canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
			let convertNewlines = null;
			if (type.schema.linebreakReplacement) {
				let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
				if (pre && !supportLinebreak) convertNewlines = false;
				else if (!pre && supportLinebreak) convertNewlines = true;
			}
			if (convertNewlines === false) replaceLinebreaks(tr, node, pos, mapFrom);
			clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, void 0, convertNewlines === null);
			let mapping = tr.mapping.slice(mapFrom);
			let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
			tr.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new Slice(Fragment.from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
			if (convertNewlines === true) replaceNewlines(tr, node, pos, mapFrom);
			return false;
		}
	});
}
function replaceNewlines(tr, node, pos, mapFrom) {
	node.forEach((child, offset) => {
		if (child.isText) {
			let m, newline = /\r?\n|\r/g;
			while (m = newline.exec(child.text)) {
				let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
				tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
			}
		}
	});
}
function replaceLinebreaks(tr, node, pos, mapFrom) {
	node.forEach((child, offset) => {
		if (child.type == child.type.schema.linebreakReplacement) {
			let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
			tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
		}
	});
}
function canChangeType(doc$2, pos, type) {
	let $pos = doc$2.resolve(pos), index = $pos.index();
	return $pos.parent.canReplaceWith(index, index + 1, type);
}
function setNodeMarkup(tr, pos, type, attrs, marks) {
	let node = tr.doc.nodeAt(pos);
	if (!node) throw new RangeError("No node at given position");
	if (!type) type = node.type;
	let newNode = type.create(attrs, null, marks || node.marks);
	if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
	if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
	tr.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new Slice(Fragment.from(newNode), 0, 0), 1, true));
}
function canSplit(doc$2, pos, depth = 1, typesAfter) {
	let $pos = doc$2.resolve(pos), base$1 = $pos.depth - depth;
	let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
	if (base$1 < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
	for (let d = $pos.depth - 1, i$1 = depth - 2; d > base$1; d--, i$1--) {
		let node = $pos.node(d), index$1 = $pos.index(d);
		if (node.type.spec.isolating) return false;
		let rest = node.content.cutByIndex(index$1, node.childCount);
		let overrideChild = typesAfter && typesAfter[i$1 + 1];
		if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
		let after = typesAfter && typesAfter[i$1] || node;
		if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest)) return false;
	}
	let index = $pos.indexAfter(base$1);
	let baseType = typesAfter && typesAfter[0];
	return $pos.node(base$1).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base$1 + 1).type);
}
function split(tr, pos, depth = 1, typesAfter) {
	let $pos = tr.doc.resolve(pos), before = Fragment.empty, after = Fragment.empty;
	for (let d = $pos.depth, e = $pos.depth - depth, i$1 = depth - 1; d > e; d--, i$1--) {
		before = Fragment.from($pos.node(d).copy(before));
		let typeAfter = typesAfter && typesAfter[i$1];
		after = Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
	}
	tr.step(new ReplaceStep(pos, pos, new Slice(before.append(after), depth, depth), true));
}
function canJoin(doc$2, pos) {
	let $pos = doc$2.resolve(pos), index = $pos.index();
	return joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function canAppendWithSubstitutedLinebreaks(a, b) {
	if (!b.content.size) a.type.compatibleContent(b.type);
	let match = a.contentMatchAt(a.childCount);
	let { linebreakReplacement } = a.type.schema;
	for (let i$1 = 0; i$1 < b.childCount; i$1++) {
		let child = b.child(i$1);
		let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
		match = match.matchType(type);
		if (!match) return false;
		if (!a.type.allowsMarks(child.marks)) return false;
	}
	return match.validEnd;
}
function joinable(a, b) {
	return !!(a && b && !a.isLeaf && canAppendWithSubstitutedLinebreaks(a, b));
}
function joinPoint(doc$2, pos, dir = -1) {
	let $pos = doc$2.resolve(pos);
	for (let d = $pos.depth;; d--) {
		let before, after, index = $pos.index(d);
		if (d == $pos.depth) {
			before = $pos.nodeBefore;
			after = $pos.nodeAfter;
		} else if (dir > 0) {
			before = $pos.node(d + 1);
			index++;
			after = $pos.node(d).maybeChild(index);
		} else {
			before = $pos.node(d).maybeChild(index - 1);
			after = $pos.node(d + 1);
		}
		if (before && !before.isTextblock && joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
		if (d == 0) break;
		pos = dir < 0 ? $pos.before(d) : $pos.after(d);
	}
}
function join(tr, pos, depth) {
	let convertNewlines = null;
	let { linebreakReplacement } = tr.doc.type.schema;
	let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
	if (linebreakReplacement && beforeType.inlineContent) {
		let pre = beforeType.whitespace == "pre";
		let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
		if (pre && !supportLinebreak) convertNewlines = false;
		else if (!pre && supportLinebreak) convertNewlines = true;
	}
	let mapFrom = tr.steps.length;
	if (convertNewlines === false) {
		let $after = tr.doc.resolve(pos + depth);
		replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
	}
	if (beforeType.inlineContent) clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
	let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
	tr.step(new ReplaceStep(start, mapping.map(pos + depth, -1), Slice.empty, true));
	if (convertNewlines === true) {
		let $full = tr.doc.resolve(start);
		replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
	}
	return tr;
}
function insertPoint(doc$2, pos, nodeType) {
	let $pos = doc$2.resolve(pos);
	if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
	if ($pos.parentOffset == 0) for (let d = $pos.depth - 1; d >= 0; d--) {
		let index = $pos.index(d);
		if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
		if (index > 0) return null;
	}
	if ($pos.parentOffset == $pos.parent.content.size) for (let d = $pos.depth - 1; d >= 0; d--) {
		let index = $pos.indexAfter(d);
		if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
		if (index < $pos.node(d).childCount) return null;
	}
	return null;
}
function dropPoint(doc$2, pos, slice) {
	let $pos = doc$2.resolve(pos);
	if (!slice.content.size) return pos;
	let content$2 = slice.content;
	for (let i$1 = 0; i$1 < slice.openStart; i$1++) content$2 = content$2.firstChild.content;
	for (let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) for (let d = $pos.depth; d >= 0; d--) {
		let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
		let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
		let parent = $pos.node(d), fits = false;
		if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content$2);
		else {
			let wrapping = parent.contentMatchAt(insertPos).findWrapping(content$2.firstChild.type);
			fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
		}
		if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
	}
	return null;
}
function replaceStep(doc$2, from, to = from, slice = Slice.empty) {
	if (from == to && !slice.size) return null;
	let $from = doc$2.resolve(from), $to = doc$2.resolve(to);
	if (fitsTrivially($from, $to, slice)) return new ReplaceStep(from, to, slice);
	return new Fitter($from, $to, slice).fit();
}
function fitsTrivially($from, $to, slice) {
	return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
var Fitter = class {
	constructor($from, $to, unplaced) {
		this.$from = $from;
		this.$to = $to;
		this.unplaced = unplaced;
		this.frontier = [];
		this.placed = Fragment.empty;
		for (let i$1 = 0; i$1 <= $from.depth; i$1++) {
			let node = $from.node(i$1);
			this.frontier.push({
				type: node.type,
				match: node.contentMatchAt($from.indexAfter(i$1))
			});
		}
		for (let i$1 = $from.depth; i$1 > 0; i$1--) this.placed = Fragment.from($from.node(i$1).copy(this.placed));
	}
	get depth() {
		return this.frontier.length - 1;
	}
	fit() {
		while (this.unplaced.size) {
			let fit = this.findFittable();
			if (fit) this.placeNodes(fit);
			else this.openMore() || this.dropNode();
		}
		let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
		let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
		if (!$to) return null;
		let content$2 = this.placed, openStart = $from.depth, openEnd = $to.depth;
		while (openStart && openEnd && content$2.childCount == 1) {
			content$2 = content$2.firstChild.content;
			openStart--;
			openEnd--;
		}
		let slice = new Slice(content$2, openStart, openEnd);
		if (moveInline > -1) return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
		if (slice.size || $from.pos != this.$to.pos) return new ReplaceStep($from.pos, $to.pos, slice);
		return null;
	}
	findFittable() {
		let startDepth = this.unplaced.openStart;
		for (let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++) {
			let node = cur.firstChild;
			if (cur.childCount > 1) openEnd = 0;
			if (node.type.spec.isolating && openEnd <= d) {
				startDepth = d;
				break;
			}
			cur = node.content;
		}
		for (let pass = 1; pass <= 2; pass++) for (let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
			let fragment, parent = null;
			if (sliceDepth) {
				parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
				fragment = parent.content;
			} else fragment = this.unplaced.content;
			let first = fragment.firstChild;
			for (let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
				let { type, match } = this.frontier[frontierDepth], wrap$1, inject = null;
				if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(Fragment.from(first), false)) : parent && type.compatibleContent(parent.type))) return {
					sliceDepth,
					frontierDepth,
					parent,
					inject
				};
				else if (pass == 2 && first && (wrap$1 = match.findWrapping(first.type))) return {
					sliceDepth,
					frontierDepth,
					parent,
					wrap: wrap$1
				};
				if (parent && match.matchType(parent.type)) break;
			}
		}
	}
	openMore() {
		let { content: content$2, openStart, openEnd } = this.unplaced;
		let inner = contentAt(content$2, openStart);
		if (!inner.childCount || inner.firstChild.isLeaf) return false;
		this.unplaced = new Slice(content$2, openStart + 1, Math.max(openEnd, inner.size + openStart >= content$2.size - openEnd ? openStart + 1 : 0));
		return true;
	}
	dropNode() {
		let { content: content$2, openStart, openEnd } = this.unplaced;
		let inner = contentAt(content$2, openStart);
		if (inner.childCount <= 1 && openStart > 0) {
			let openAtEnd = content$2.size - openStart <= openStart + inner.size;
			this.unplaced = new Slice(dropFromFragment(content$2, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
		} else this.unplaced = new Slice(dropFromFragment(content$2, openStart, 1), openStart, openEnd);
	}
	placeNodes({ sliceDepth, frontierDepth, parent, inject, wrap: wrap$1 }) {
		while (this.depth > frontierDepth) this.closeFrontierNode();
		if (wrap$1) for (let i$1 = 0; i$1 < wrap$1.length; i$1++) this.openFrontierNode(wrap$1[i$1]);
		let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
		let openStart = slice.openStart - sliceDepth;
		let taken = 0, add = [];
		let { match, type } = this.frontier[frontierDepth];
		if (inject) {
			for (let i$1 = 0; i$1 < inject.childCount; i$1++) add.push(inject.child(i$1));
			match = match.matchFragment(inject);
		}
		let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
		while (taken < fragment.childCount) {
			let next = fragment.child(taken), matches$1 = match.matchType(next.type);
			if (!matches$1) break;
			taken++;
			if (taken > 1 || openStart == 0 || next.content.size) {
				match = matches$1;
				add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
			}
		}
		let toEnd = taken == fragment.childCount;
		if (!toEnd) openEndCount = -1;
		this.placed = addToFragment(this.placed, frontierDepth, Fragment.from(add));
		this.frontier[frontierDepth].match = match;
		if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
		for (let i$1 = 0, cur = fragment; i$1 < openEndCount; i$1++) {
			let node = cur.lastChild;
			this.frontier.push({
				type: node.type,
				match: node.contentMatchAt(node.childCount)
			});
			cur = node.content;
		}
		this.unplaced = !toEnd ? new Slice(dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? Slice.empty : new Slice(dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
	}
	mustMoveInline() {
		if (!this.$to.parent.isTextblock) return -1;
		let top = this.frontier[this.depth], level;
		if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
		let { depth } = this.$to, after = this.$to.after(depth);
		while (depth > 1 && after == this.$to.end(--depth)) ++after;
		return after;
	}
	findCloseLevel($to) {
		scan: for (let i$1 = Math.min(this.depth, $to.depth); i$1 >= 0; i$1--) {
			let { match, type } = this.frontier[i$1];
			let dropInner = i$1 < $to.depth && $to.end(i$1 + 1) == $to.pos + ($to.depth - (i$1 + 1));
			let fit = contentAfterFits($to, i$1, type, match, dropInner);
			if (!fit) continue;
			for (let d = i$1 - 1; d >= 0; d--) {
				let { match: match$1, type: type$1 } = this.frontier[d];
				let matches$1 = contentAfterFits($to, d, type$1, match$1, true);
				if (!matches$1 || matches$1.childCount) continue scan;
			}
			return {
				depth: i$1,
				fit,
				move: dropInner ? $to.doc.resolve($to.after(i$1 + 1)) : $to
			};
		}
	}
	close($to) {
		let close$1 = this.findCloseLevel($to);
		if (!close$1) return null;
		while (this.depth > close$1.depth) this.closeFrontierNode();
		if (close$1.fit.childCount) this.placed = addToFragment(this.placed, close$1.depth, close$1.fit);
		$to = close$1.move;
		for (let d = close$1.depth + 1; d <= $to.depth; d++) {
			let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
			this.openFrontierNode(node.type, node.attrs, add);
		}
		return $to;
	}
	openFrontierNode(type, attrs = null, content$2) {
		let top = this.frontier[this.depth];
		top.match = top.match.matchType(type);
		this.placed = addToFragment(this.placed, this.depth, Fragment.from(type.create(attrs, content$2)));
		this.frontier.push({
			type,
			match: type.contentMatch
		});
	}
	closeFrontierNode() {
		let add = this.frontier.pop().match.fillBefore(Fragment.empty, true);
		if (add.childCount) this.placed = addToFragment(this.placed, this.frontier.length, add);
	}
};
function dropFromFragment(fragment, depth, count) {
	if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
	return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function addToFragment(fragment, depth, content$2) {
	if (depth == 0) return fragment.append(content$2);
	return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content$2)));
}
function contentAt(fragment, depth) {
	for (let i$1 = 0; i$1 < depth; i$1++) fragment = fragment.firstChild.content;
	return fragment;
}
function closeNodeStart(node, openStart, openEnd) {
	if (openStart <= 0) return node;
	let frag = node.content;
	if (openStart > 1) frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
	if (openStart > 0) {
		frag = node.type.contentMatch.fillBefore(frag).append(frag);
		if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(Fragment.empty, true));
	}
	return node.copy(frag);
}
function contentAfterFits($to, depth, type, match, open) {
	let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
	if (index == node.childCount && !type.compatibleContent(node.type)) return null;
	let fit = match.fillBefore(node.content, true, index);
	return fit && !invalidMarks(type, node.content, index) ? fit : null;
}
function invalidMarks(type, fragment, start) {
	for (let i$1 = start; i$1 < fragment.childCount; i$1++) if (!type.allowsMarks(fragment.child(i$1).marks)) return true;
	return false;
}
function definesContent(type) {
	return type.spec.defining || type.spec.definingForContent;
}
function replaceRange(tr, from, to, slice) {
	if (!slice.size) return tr.deleteRange(from, to);
	let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
	if (fitsTrivially($from, $to, slice)) return tr.step(new ReplaceStep(from, to, slice));
	let targetDepths = coveredDepths($from, $to);
	if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
	let preferredTarget = -($from.depth + 1);
	targetDepths.unshift(preferredTarget);
	for (let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
		let spec = $from.node(d).type.spec;
		if (spec.defining || spec.definingAsContext || spec.isolating) break;
		if (targetDepths.indexOf(d) > -1) preferredTarget = d;
		else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
	}
	let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
	let leftNodes = [], preferredDepth = slice.openStart;
	for (let content$2 = slice.content, i$1 = 0;; i$1++) {
		let node = content$2.firstChild;
		leftNodes.push(node);
		if (i$1 == slice.openStart) break;
		content$2 = node.content;
	}
	for (let d = preferredDepth - 1; d >= 0; d--) {
		let leftNode = leftNodes[d], def = definesContent(leftNode.type);
		if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
		else if (def || !leftNode.type.isTextblock) break;
	}
	for (let j = slice.openStart; j >= 0; j--) {
		let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
		let insert = leftNodes[openDepth];
		if (!insert) continue;
		for (let i$1 = 0; i$1 < targetDepths.length; i$1++) {
			let targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
			if (targetDepth < 0) {
				expand = false;
				targetDepth = -targetDepth;
			}
			let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
			if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new Slice(closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
		}
	}
	let startSteps = tr.steps.length;
	for (let i$1 = targetDepths.length - 1; i$1 >= 0; i$1--) {
		tr.replace(from, to, slice);
		if (tr.steps.length > startSteps) break;
		let depth = targetDepths[i$1];
		if (depth < 0) continue;
		from = $from.before(depth);
		to = $to.after(depth);
	}
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
	if (depth < oldOpen) {
		let first = fragment.firstChild;
		fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
	}
	if (depth > newOpen) {
		let match = parent.contentMatchAt(0);
		let start = match.fillBefore(fragment).append(fragment);
		fragment = start.append(match.matchFragment(start).fillBefore(Fragment.empty, true));
	}
	return fragment;
}
function replaceRangeWith(tr, from, to, node) {
	if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
		let point$1 = insertPoint(tr.doc, from, node.type);
		if (point$1 != null) from = to = point$1;
	}
	tr.replaceRange(from, to, new Slice(Fragment.from(node), 0, 0));
}
function deleteRange(tr, from, to) {
	let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
	let covered = coveredDepths($from, $to);
	for (let i$1 = 0; i$1 < covered.length; i$1++) {
		let depth = covered[i$1], last = i$1 == covered.length - 1;
		if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
		if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
	}
	for (let d = 1; d <= $from.depth && d <= $to.depth; d++) if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
	tr.delete(from, to);
}
function coveredDepths($from, $to) {
	let result = [], minDepth = Math.min($from.depth, $to.depth);
	for (let d = minDepth; d >= 0; d--) {
		let start = $from.start(d);
		if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
		if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
	}
	return result;
}
var AttrStep = class AttrStep extends Step {
	constructor(pos, attr, value) {
		super();
		this.pos = pos;
		this.attr = attr;
		this.value = value;
	}
	apply(doc$2) {
		let node = doc$2.nodeAt(this.pos);
		if (!node) return StepResult.fail("No node at attribute step's position");
		let attrs = Object.create(null);
		for (let name in node.attrs) attrs[name] = node.attrs[name];
		attrs[this.attr] = this.value;
		let updated = node.type.create(attrs, null, node.marks);
		return StepResult.fromReplace(doc$2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
	}
	getMap() {
		return StepMap.empty;
	}
	invert(doc$2) {
		return new AttrStep(this.pos, this.attr, doc$2.nodeAt(this.pos).attrs[this.attr]);
	}
	map(mapping) {
		let pos = mapping.mapResult(this.pos, 1);
		return pos.deletedAfter ? null : new AttrStep(pos.pos, this.attr, this.value);
	}
	toJSON() {
		return {
			stepType: "attr",
			pos: this.pos,
			attr: this.attr,
			value: this.value
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
		return new AttrStep(json.pos, json.attr, json.value);
	}
};
Step.jsonID("attr", AttrStep);
var DocAttrStep = class DocAttrStep extends Step {
	constructor(attr, value) {
		super();
		this.attr = attr;
		this.value = value;
	}
	apply(doc$2) {
		let attrs = Object.create(null);
		for (let name in doc$2.attrs) attrs[name] = doc$2.attrs[name];
		attrs[this.attr] = this.value;
		let updated = doc$2.type.create(attrs, doc$2.content, doc$2.marks);
		return StepResult.ok(updated);
	}
	getMap() {
		return StepMap.empty;
	}
	invert(doc$2) {
		return new DocAttrStep(this.attr, doc$2.attrs[this.attr]);
	}
	map(mapping) {
		return this;
	}
	toJSON() {
		return {
			stepType: "docAttr",
			attr: this.attr,
			value: this.value
		};
	}
	static fromJSON(schema, json) {
		if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
		return new DocAttrStep(json.attr, json.value);
	}
};
Step.jsonID("docAttr", DocAttrStep);
var TransformError = class extends Error {};
TransformError = function TransformError$1(message) {
	let err$1 = Error.call(this, message);
	err$1.__proto__ = TransformError$1.prototype;
	return err$1;
};
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
var Transform = class {
	constructor(doc$2) {
		this.doc = doc$2;
		this.steps = [];
		this.docs = [];
		this.mapping = new Mapping();
	}
	get before() {
		return this.docs.length ? this.docs[0] : this.doc;
	}
	step(step$1) {
		let result = this.maybeStep(step$1);
		if (result.failed) throw new TransformError(result.failed);
		return this;
	}
	maybeStep(step$1) {
		let result = step$1.apply(this.doc);
		if (!result.failed) this.addStep(step$1, result.doc);
		return result;
	}
	get docChanged() {
		return this.steps.length > 0;
	}
	changedRange() {
		let from = 1e9, to = -1e9;
		for (let i$1 = 0; i$1 < this.mapping.maps.length; i$1++) {
			let map = this.mapping.maps[i$1];
			if (i$1) {
				from = map.map(from, 1);
				to = map.map(to, -1);
			}
			map.forEach((_f, _t, fromB, toB) => {
				from = Math.min(from, fromB);
				to = Math.max(to, toB);
			});
		}
		return from == 1e9 ? null : {
			from,
			to
		};
	}
	addStep(step$1, doc$2) {
		this.docs.push(this.doc);
		this.steps.push(step$1);
		this.mapping.appendMap(step$1.getMap());
		this.doc = doc$2;
	}
	replace(from, to = from, slice = Slice.empty) {
		let step$1 = replaceStep(this.doc, from, to, slice);
		if (step$1) this.step(step$1);
		return this;
	}
	replaceWith(from, to, content$2) {
		return this.replace(from, to, new Slice(Fragment.from(content$2), 0, 0));
	}
	delete(from, to) {
		return this.replace(from, to, Slice.empty);
	}
	insert(pos, content$2) {
		return this.replaceWith(pos, pos, content$2);
	}
	replaceRange(from, to, slice) {
		replaceRange(this, from, to, slice);
		return this;
	}
	replaceRangeWith(from, to, node) {
		replaceRangeWith(this, from, to, node);
		return this;
	}
	deleteRange(from, to) {
		deleteRange(this, from, to);
		return this;
	}
	lift(range, target) {
		lift(this, range, target);
		return this;
	}
	join(pos, depth = 1) {
		join(this, pos, depth);
		return this;
	}
	wrap(range, wrappers) {
		wrap(this, range, wrappers);
		return this;
	}
	setBlockType(from, to = from, type, attrs = null) {
		setBlockType(this, from, to, type, attrs);
		return this;
	}
	setNodeMarkup(pos, type, attrs = null, marks) {
		setNodeMarkup(this, pos, type, attrs, marks);
		return this;
	}
	setNodeAttribute(pos, attr, value) {
		this.step(new AttrStep(pos, attr, value));
		return this;
	}
	setDocAttribute(attr, value) {
		this.step(new DocAttrStep(attr, value));
		return this;
	}
	addNodeMark(pos, mark) {
		this.step(new AddNodeMarkStep(pos, mark));
		return this;
	}
	removeNodeMark(pos, mark) {
		let node = this.doc.nodeAt(pos);
		if (!node) throw new RangeError("No node at position " + pos);
		if (mark instanceof Mark) {
			if (mark.isInSet(node.marks)) this.step(new RemoveNodeMarkStep(pos, mark));
		} else {
			let set = node.marks, found$1, steps = [];
			while (found$1 = mark.isInSet(set)) {
				steps.push(new RemoveNodeMarkStep(pos, found$1));
				set = found$1.removeFromSet(set);
			}
			for (let i$1 = steps.length - 1; i$1 >= 0; i$1--) this.step(steps[i$1]);
		}
		return this;
	}
	split(pos, depth = 1, typesAfter) {
		split(this, pos, depth, typesAfter);
		return this;
	}
	addMark(from, to, mark) {
		addMark(this, from, to, mark);
		return this;
	}
	removeMark(from, to, mark) {
		removeMark(this, from, to, mark);
		return this;
	}
	clearIncompatible(pos, parentType, match) {
		clearIncompatible(this, pos, parentType, match);
		return this;
	}
};
var classesById = Object.create(null);
var Selection = class {
	constructor($anchor, $head, ranges) {
		this.$anchor = $anchor;
		this.$head = $head;
		this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
	}
	get anchor() {
		return this.$anchor.pos;
	}
	get head() {
		return this.$head.pos;
	}
	get from() {
		return this.$from.pos;
	}
	get to() {
		return this.$to.pos;
	}
	get $from() {
		return this.ranges[0].$from;
	}
	get $to() {
		return this.ranges[0].$to;
	}
	get empty() {
		let ranges = this.ranges;
		for (let i$1 = 0; i$1 < ranges.length; i$1++) if (ranges[i$1].$from.pos != ranges[i$1].$to.pos) return false;
		return true;
	}
	content() {
		return this.$from.doc.slice(this.from, this.to, true);
	}
	replace(tr, content$2 = Slice.empty) {
		let lastNode = content$2.content.lastChild, lastParent = null;
		for (let i$1 = 0; i$1 < content$2.openEnd; i$1++) {
			lastParent = lastNode;
			lastNode = lastNode.lastChild;
		}
		let mapFrom = tr.steps.length, ranges = this.ranges;
		for (let i$1 = 0; i$1 < ranges.length; i$1++) {
			let { $from, $to } = ranges[i$1], mapping = tr.mapping.slice(mapFrom);
			tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? Slice.empty : content$2);
			if (i$1 == 0) selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
		}
	}
	replaceWith(tr, node) {
		let mapFrom = tr.steps.length, ranges = this.ranges;
		for (let i$1 = 0; i$1 < ranges.length; i$1++) {
			let { $from, $to } = ranges[i$1], mapping = tr.mapping.slice(mapFrom);
			let from = mapping.map($from.pos), to = mapping.map($to.pos);
			if (i$1) tr.deleteRange(from, to);
			else {
				tr.replaceRangeWith(from, to, node);
				selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
			}
		}
	}
	static findFrom($pos, dir, textOnly = false) {
		let inner = $pos.parent.inlineContent ? new TextSelection($pos) : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
		if (inner) return inner;
		for (let depth = $pos.depth - 1; depth >= 0; depth--) {
			let found$1 = dir < 0 ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
			if (found$1) return found$1;
		}
		return null;
	}
	static near($pos, bias = 1) {
		return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
	}
	static atStart(doc$2) {
		return findSelectionIn(doc$2, doc$2, 0, 0, 1) || new AllSelection(doc$2);
	}
	static atEnd(doc$2) {
		return findSelectionIn(doc$2, doc$2, doc$2.content.size, doc$2.childCount, -1) || new AllSelection(doc$2);
	}
	static fromJSON(doc$2, json) {
		if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
		let cls = classesById[json.type];
		if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
		return cls.fromJSON(doc$2, json);
	}
	static jsonID(id, selectionClass) {
		if (id in classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
		classesById[id] = selectionClass;
		selectionClass.prototype.jsonID = id;
		return selectionClass;
	}
	getBookmark() {
		return TextSelection.between(this.$anchor, this.$head).getBookmark();
	}
};
Selection.prototype.visible = true;
var SelectionRange = class {
	constructor($from, $to) {
		this.$from = $from;
		this.$to = $to;
	}
};
var warnedAboutTextSelection = false;
function checkTextSelection($pos) {
	if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
		warnedAboutTextSelection = true;
		console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
	}
}
var TextSelection = class TextSelection extends Selection {
	constructor($anchor, $head = $anchor) {
		checkTextSelection($anchor);
		checkTextSelection($head);
		super($anchor, $head);
	}
	get $cursor() {
		return this.$anchor.pos == this.$head.pos ? this.$head : null;
	}
	map(doc$2, mapping) {
		let $head = doc$2.resolve(mapping.map(this.head));
		if (!$head.parent.inlineContent) return Selection.near($head);
		let $anchor = doc$2.resolve(mapping.map(this.anchor));
		return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
	}
	replace(tr, content$2 = Slice.empty) {
		super.replace(tr, content$2);
		if (content$2 == Slice.empty) {
			let marks = this.$from.marksAcross(this.$to);
			if (marks) tr.ensureMarks(marks);
		}
	}
	eq(other) {
		return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head;
	}
	getBookmark() {
		return new TextBookmark(this.anchor, this.head);
	}
	toJSON() {
		return {
			type: "text",
			anchor: this.anchor,
			head: this.head
		};
	}
	static fromJSON(doc$2, json) {
		if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
		return new TextSelection(doc$2.resolve(json.anchor), doc$2.resolve(json.head));
	}
	static create(doc$2, anchor, head = anchor) {
		let $anchor = doc$2.resolve(anchor);
		return new this($anchor, head == anchor ? $anchor : doc$2.resolve(head));
	}
	static between($anchor, $head, bias) {
		let dPos = $anchor.pos - $head.pos;
		if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
		if (!$head.parent.inlineContent) {
			let found$1 = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
			if (found$1) $head = found$1.$head;
			else return Selection.near($head, bias);
		}
		if (!$anchor.parent.inlineContent) if (dPos == 0) $anchor = $head;
		else {
			$anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
			if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
		}
		return new TextSelection($anchor, $head);
	}
};
Selection.jsonID("text", TextSelection);
var TextBookmark = class TextBookmark {
	constructor(anchor, head) {
		this.anchor = anchor;
		this.head = head;
	}
	map(mapping) {
		return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
	}
	resolve(doc$2) {
		return TextSelection.between(doc$2.resolve(this.anchor), doc$2.resolve(this.head));
	}
};
var NodeSelection = class NodeSelection extends Selection {
	constructor($pos) {
		let node = $pos.nodeAfter;
		let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
		super($pos, $end);
		this.node = node;
	}
	map(doc$2, mapping) {
		let { deleted, pos } = mapping.mapResult(this.anchor);
		let $pos = doc$2.resolve(pos);
		if (deleted) return Selection.near($pos);
		return new NodeSelection($pos);
	}
	content() {
		return new Slice(Fragment.from(this.node), 0, 0);
	}
	eq(other) {
		return other instanceof NodeSelection && other.anchor == this.anchor;
	}
	toJSON() {
		return {
			type: "node",
			anchor: this.anchor
		};
	}
	getBookmark() {
		return new NodeBookmark(this.anchor);
	}
	static fromJSON(doc$2, json) {
		if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
		return new NodeSelection(doc$2.resolve(json.anchor));
	}
	static create(doc$2, from) {
		return new NodeSelection(doc$2.resolve(from));
	}
	static isSelectable(node) {
		return !node.isText && node.type.spec.selectable !== false;
	}
};
NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);
var NodeBookmark = class NodeBookmark {
	constructor(anchor) {
		this.anchor = anchor;
	}
	map(mapping) {
		let { deleted, pos } = mapping.mapResult(this.anchor);
		return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
	}
	resolve(doc$2) {
		let $pos = doc$2.resolve(this.anchor), node = $pos.nodeAfter;
		if (node && NodeSelection.isSelectable(node)) return new NodeSelection($pos);
		return Selection.near($pos);
	}
};
var AllSelection = class AllSelection extends Selection {
	constructor(doc$2) {
		super(doc$2.resolve(0), doc$2.resolve(doc$2.content.size));
	}
	replace(tr, content$2 = Slice.empty) {
		if (content$2 == Slice.empty) {
			tr.delete(0, tr.doc.content.size);
			let sel = Selection.atStart(tr.doc);
			if (!sel.eq(tr.selection)) tr.setSelection(sel);
		} else super.replace(tr, content$2);
	}
	toJSON() {
		return { type: "all" };
	}
	static fromJSON(doc$2) {
		return new AllSelection(doc$2);
	}
	map(doc$2) {
		return new AllSelection(doc$2);
	}
	eq(other) {
		return other instanceof AllSelection;
	}
	getBookmark() {
		return AllBookmark;
	}
};
Selection.jsonID("all", AllSelection);
var AllBookmark = {
	map() {
		return this;
	},
	resolve(doc$2) {
		return new AllSelection(doc$2);
	}
};
function findSelectionIn(doc$2, node, pos, index, dir, text$2 = false) {
	if (node.inlineContent) return TextSelection.create(doc$2, pos);
	for (let i$1 = index - (dir > 0 ? 0 : 1); dir > 0 ? i$1 < node.childCount : i$1 >= 0; i$1 += dir) {
		let child = node.child(i$1);
		if (!child.isAtom) {
			let inner = findSelectionIn(doc$2, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text$2);
			if (inner) return inner;
		} else if (!text$2 && NodeSelection.isSelectable(child)) return NodeSelection.create(doc$2, pos - (dir < 0 ? child.nodeSize : 0));
		pos += child.nodeSize * dir;
	}
	return null;
}
function selectionToInsertionEnd(tr, startLen, bias) {
	let last = tr.steps.length - 1;
	if (last < startLen) return;
	let step$1 = tr.steps[last];
	if (!(step$1 instanceof ReplaceStep || step$1 instanceof ReplaceAroundStep)) return;
	let map = tr.mapping.maps[last], end;
	map.forEach((_from, _to, _newFrom, newTo) => {
		if (end == null) end = newTo;
	});
	tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}
var UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
var Transaction = class extends Transform {
	constructor(state) {
		super(state.doc);
		this.curSelectionFor = 0;
		this.updated = 0;
		this.meta = Object.create(null);
		this.time = Date.now();
		this.curSelection = state.selection;
		this.storedMarks = state.storedMarks;
	}
	get selection() {
		if (this.curSelectionFor < this.steps.length) {
			this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
			this.curSelectionFor = this.steps.length;
		}
		return this.curSelection;
	}
	setSelection(selection) {
		if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
		this.curSelection = selection;
		this.curSelectionFor = this.steps.length;
		this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
		this.storedMarks = null;
		return this;
	}
	get selectionSet() {
		return (this.updated & UPDATED_SEL) > 0;
	}
	setStoredMarks(marks) {
		this.storedMarks = marks;
		this.updated |= UPDATED_MARKS;
		return this;
	}
	ensureMarks(marks) {
		if (!Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
		return this;
	}
	addStoredMark(mark) {
		return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
	}
	removeStoredMark(mark) {
		return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
	}
	get storedMarksSet() {
		return (this.updated & UPDATED_MARKS) > 0;
	}
	addStep(step$1, doc$2) {
		super.addStep(step$1, doc$2);
		this.updated = this.updated & ~UPDATED_MARKS;
		this.storedMarks = null;
	}
	setTime(time) {
		this.time = time;
		return this;
	}
	replaceSelection(slice) {
		this.selection.replace(this, slice);
		return this;
	}
	replaceSelectionWith(node, inheritMarks = true) {
		let selection = this.selection;
		if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || Mark.none));
		selection.replaceWith(this, node);
		return this;
	}
	deleteSelection() {
		this.selection.replace(this);
		return this;
	}
	insertText(text$2, from, to) {
		let schema = this.doc.type.schema;
		if (from == null) {
			if (!text$2) return this.deleteSelection();
			return this.replaceSelectionWith(schema.text(text$2), true);
		} else {
			if (to == null) to = from;
			if (!text$2) return this.deleteRange(from, to);
			let marks = this.storedMarks;
			if (!marks) {
				let $from = this.doc.resolve(from);
				marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
			}
			this.replaceRangeWith(from, to, schema.text(text$2, marks));
			if (!this.selection.empty && this.selection.to == from + text$2.length) this.setSelection(Selection.near(this.selection.$to));
			return this;
		}
	}
	setMeta(key, value) {
		this.meta[typeof key == "string" ? key : key.key] = value;
		return this;
	}
	getMeta(key) {
		return this.meta[typeof key == "string" ? key : key.key];
	}
	get isGeneric() {
		for (let _ in this.meta) return false;
		return true;
	}
	scrollIntoView() {
		this.updated |= UPDATED_SCROLL;
		return this;
	}
	get scrolledIntoView() {
		return (this.updated & UPDATED_SCROLL) > 0;
	}
};
function bind(f, self$1) {
	return !self$1 || !f ? f : f.bind(self$1);
}
var FieldDesc = class {
	constructor(name, desc, self$1) {
		this.name = name;
		this.init = bind(desc.init, self$1);
		this.apply = bind(desc.apply, self$1);
	}
};
var baseFields = [
	new FieldDesc("doc", {
		init(config$43) {
			return config$43.doc || config$43.schema.topNodeType.createAndFill();
		},
		apply(tr) {
			return tr.doc;
		}
	}),
	new FieldDesc("selection", {
		init(config$43, instance) {
			return config$43.selection || Selection.atStart(instance.doc);
		},
		apply(tr) {
			return tr.selection;
		}
	}),
	new FieldDesc("storedMarks", {
		init(config$43) {
			return config$43.storedMarks || null;
		},
		apply(tr, _marks, _old, state) {
			return state.selection.$cursor ? tr.storedMarks : null;
		}
	}),
	new FieldDesc("scrollToSelection", {
		init() {
			return 0;
		},
		apply(tr, prev) {
			return tr.scrolledIntoView ? prev + 1 : prev;
		}
	})
];
var Configuration = class {
	constructor(schema, plugins) {
		this.schema = schema;
		this.plugins = [];
		this.pluginsByKey = Object.create(null);
		this.fields = baseFields.slice();
		if (plugins) plugins.forEach((plugin) => {
			if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
			this.plugins.push(plugin);
			this.pluginsByKey[plugin.key] = plugin;
			if (plugin.spec.state) this.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
		});
	}
};
var EditorState = class EditorState {
	constructor(config$43) {
		this.config = config$43;
	}
	get schema() {
		return this.config.schema;
	}
	get plugins() {
		return this.config.plugins;
	}
	apply(tr) {
		return this.applyTransaction(tr).state;
	}
	filterTransaction(tr, ignore = -1) {
		for (let i$1 = 0; i$1 < this.config.plugins.length; i$1++) if (i$1 != ignore) {
			let plugin = this.config.plugins[i$1];
			if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
		}
		return true;
	}
	applyTransaction(rootTr) {
		if (!this.filterTransaction(rootTr)) return {
			state: this,
			transactions: []
		};
		let trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
		for (;;) {
			let haveNew = false;
			for (let i$1 = 0; i$1 < this.config.plugins.length; i$1++) {
				let plugin = this.config.plugins[i$1];
				if (plugin.spec.appendTransaction) {
					let n = seen ? seen[i$1].n : 0, oldState = seen ? seen[i$1].state : this;
					let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
					if (tr && newState.filterTransaction(tr, i$1)) {
						tr.setMeta("appendedTransaction", rootTr);
						if (!seen) {
							seen = [];
							for (let j = 0; j < this.config.plugins.length; j++) seen.push(j < i$1 ? {
								state: newState,
								n: trs.length
							} : {
								state: this,
								n: 0
							});
						}
						trs.push(tr);
						newState = newState.applyInner(tr);
						haveNew = true;
					}
					if (seen) seen[i$1] = {
						state: newState,
						n: trs.length
					};
				}
			}
			if (!haveNew) return {
				state: newState,
				transactions: trs
			};
		}
	}
	applyInner(tr) {
		if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
		let newInstance = new EditorState(this.config), fields = this.config.fields;
		for (let i$1 = 0; i$1 < fields.length; i$1++) {
			let field = fields[i$1];
			newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
		}
		return newInstance;
	}
	get tr() {
		return new Transaction(this);
	}
	static create(config$43) {
		let $config = new Configuration(config$43.doc ? config$43.doc.type.schema : config$43.schema, config$43.plugins);
		let instance = new EditorState($config);
		for (let i$1 = 0; i$1 < $config.fields.length; i$1++) instance[$config.fields[i$1].name] = $config.fields[i$1].init(config$43, instance);
		return instance;
	}
	reconfigure(config$43) {
		let $config = new Configuration(this.schema, config$43.plugins);
		let fields = $config.fields, instance = new EditorState($config);
		for (let i$1 = 0; i$1 < fields.length; i$1++) {
			let name = fields[i$1].name;
			instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i$1].init(config$43, instance);
		}
		return instance;
	}
	toJSON(pluginFields) {
		let result = {
			doc: this.doc.toJSON(),
			selection: this.selection.toJSON()
		};
		if (this.storedMarks) result.storedMarks = this.storedMarks.map((m) => m.toJSON());
		if (pluginFields && typeof pluginFields == "object") for (let prop in pluginFields) {
			if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
			let plugin = pluginFields[prop], state = plugin.spec.state;
			if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
		}
		return result;
	}
	static fromJSON(config$43, json, pluginFields) {
		if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
		if (!config$43.schema) throw new RangeError("Required config field 'schema' missing");
		let $config = new Configuration(config$43.schema, config$43.plugins);
		let instance = new EditorState($config);
		$config.fields.forEach((field) => {
			if (field.name == "doc") instance.doc = Node$1.fromJSON(config$43.schema, json.doc);
			else if (field.name == "selection") instance.selection = Selection.fromJSON(instance.doc, json.selection);
			else if (field.name == "storedMarks") {
				if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config$43.schema.markFromJSON);
			} else {
				if (pluginFields) for (let prop in pluginFields) {
					let plugin = pluginFields[prop], state = plugin.spec.state;
					if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
						instance[field.name] = state.fromJSON.call(plugin, config$43, json[prop], instance);
						return;
					}
				}
				instance[field.name] = field.init(config$43, instance);
			}
		});
		return instance;
	}
};
function bindProps(obj, self$1, target) {
	for (let prop in obj) {
		let val = obj[prop];
		if (val instanceof Function) val = val.bind(self$1);
		else if (prop == "handleDOMEvents") val = bindProps(val, self$1, {});
		target[prop] = val;
	}
	return target;
}
var Plugin = class {
	constructor(spec) {
		this.spec = spec;
		this.props = {};
		if (spec.props) bindProps(spec.props, this, this.props);
		this.key = spec.key ? spec.key.key : createKey("plugin");
	}
	getState(state) {
		return state[this.key];
	}
};
var keys = Object.create(null);
function createKey(name) {
	if (name in keys) return name + "$" + ++keys[name];
	keys[name] = 0;
	return name + "$";
}
var PluginKey = class {
	constructor(name = "key") {
		this.key = createKey(name);
	}
	get(state) {
		return state.config.pluginsByKey[this.key];
	}
	getState(state) {
		return state[this.key];
	}
};
const getLocalName$1 = (name) => {
	if (typeof name !== "string") return "";
	const parts = name.split(":");
	return parts.length ? parts[parts.length - 1] : name;
};
const hasLocalName = (node, localName) => {
	if (!node || typeof node !== "object") return false;
	return getLocalName$1(node.name) === localName;
};
const findChildByLocalName = (elements, localName) => {
	if (!Array.isArray(elements)) return void 0;
	return elements.find((el) => hasLocalName(el, localName));
};
const filterChildrenByLocalName = (elements, localName) => {
	if (!Array.isArray(elements)) return [];
	return elements.filter((el) => hasLocalName(el, localName));
};
const someChildHasLocalName = (elements, localName) => {
	if (!Array.isArray(elements)) return false;
	return elements.some((el) => hasLocalName(el, localName));
};
function getPresetColor(name) {
	return {
		aliceBlue: "#f0f8ff",
		antiqueWhite: "#faebd7",
		aqua: "#00ffff",
		aquamarine: "#7fffd4",
		azure: "#f0ffff",
		beige: "#f5f5dc",
		bisque: "#ffe4c4",
		black: "#000000",
		blanchedAlmond: "#ffebcd",
		blue: "#0000ff",
		blueViolet: "#8a2be2",
		brown: "#a52a2a",
		burlyWood: "#deb887",
		cadetBlue: "#5f9ea0",
		chartreuse: "#7fff00",
		chocolate: "#d2691e",
		coral: "#ff7f50",
		cornflowerBlue: "#6495ed",
		cornsilk: "#fff8dc",
		crimson: "#dc143c",
		cyan: "#00ffff",
		dkBlue: "#00008b",
		dkCyan: "#008b8b",
		dkGoldenrod: "#b8860b",
		dkGray: "#a9a9a9",
		dkGreen: "#006400",
		dkKhaki: "#bdb76b",
		dkMagenta: "#8b008b",
		dkOliveGreen: "#556b2f",
		dkOrange: "#ff8c00",
		dkOrchid: "#9932cc",
		dkRed: "#8b0000",
		dkSalmon: "#e9967a",
		dkSeaGreen: "#8fbc8f",
		dkSlateBlue: "#483d8b",
		dkSlateGray: "#2f4f4f",
		dkTurquoise: "#00ced1",
		dkViolet: "#9400d3",
		deepPink: "#ff1493",
		deepSkyBlue: "#00bfff",
		dimGray: "#696969",
		dodgerBlue: "#1e90ff",
		firebrick: "#b22222",
		floralWhite: "#fffaf0",
		forestGreen: "#228b22",
		fuchsia: "#ff00ff",
		gainsboro: "#dcdcdc",
		ghostWhite: "#f8f8ff",
		gold: "#ffd700",
		goldenrod: "#daa520",
		gray: "#808080",
		green: "#008000",
		greenYellow: "#adff2f",
		honeydew: "#f0fff0",
		hotPink: "#ff69b4",
		indianRed: "#cd5c5c",
		indigo: "#4b0082",
		ivory: "#fffff0",
		khaki: "#f0e68c",
		lavender: "#e6e6fa",
		lavenderBlush: "#fff0f5",
		lawnGreen: "#7cfc00",
		lemonChiffon: "#fffacd",
		ltBlue: "#add8e6",
		ltCoral: "#f08080",
		ltCyan: "#e0ffff",
		ltGoldenrodYellow: "#fafad2",
		ltGray: "#d3d3d3",
		ltGreen: "#90ee90",
		ltPink: "#ffb6c1",
		ltSalmon: "#ffa07a",
		ltSeaGreen: "#20b2aa",
		ltSkyBlue: "#87cefa",
		ltSlateGray: "#778899",
		ltSteelBlue: "#b0c4de",
		ltYellow: "#ffffe0",
		lime: "#00ff00",
		limeGreen: "#32cd32",
		linen: "#faf0e6",
		magenta: "#ff00ff",
		maroon: "#800000",
		medAquamarine: "#66cdaa",
		medBlue: "#0000cd",
		medOrchid: "#ba55d3",
		medPurple: "#9370db",
		medSeaGreen: "#3cb371",
		medSlateBlue: "#7b68ee",
		medSpringGreen: "#00fa9a",
		medTurquoise: "#48d1cc",
		medVioletRed: "#c71585",
		midnightBlue: "#191970",
		mintCream: "#f5fffa",
		mistyRose: "#ffe4e1",
		moccasin: "#ffe4b5",
		navajoWhite: "#ffdead",
		navy: "#000080",
		oldLace: "#fdf5e6",
		olive: "#808000",
		oliveDrab: "#6b8e23",
		orange: "#ffa500",
		orangeRed: "#ff4500",
		orchid: "#da70d6",
		paleGoldenrod: "#eee8aa",
		paleGreen: "#98fb98",
		paleTurquoise: "#afeeee",
		paleVioletRed: "#db7093",
		papayaWhip: "#ffefd5",
		peachPuff: "#ffdab9",
		peru: "#cd853f",
		pink: "#ffc0cb",
		plum: "#dda0dd",
		powderBlue: "#b0e0e6",
		purple: "#800080",
		red: "#ff0000",
		rosyBrown: "#bc8f8f",
		royalBlue: "#4169e1",
		saddleBrown: "#8b4513",
		salmon: "#fa8072",
		sandyBrown: "#f4a460",
		seaGreen: "#2e8b57",
		seaShell: "#fff5ee",
		sienna: "#a0522d",
		silver: "#c0c0c0",
		skyBlue: "#87ceeb",
		slateBlue: "#6a5acd",
		slateGray: "#708090",
		snow: "#fffafa",
		springGreen: "#00ff7f",
		steelBlue: "#4682b4",
		tan: "#d2b48c",
		teal: "#008080",
		thistle: "#d8bfd8",
		tomato: "#ff6347",
		turquoise: "#40e0d0",
		violet: "#ee82ee",
		wheat: "#f5deb3",
		white: "#ffffff",
		whiteSmoke: "#f5f5f5",
		yellow: "#ffff00",
		yellowGreen: "#9acd32"
	}[name] ?? null;
}
function applyModifiersAndAlpha(color, elements) {
	let alpha = null;
	(elements || []).forEach((mod) => {
		if (hasLocalName(mod, "shade")) color = applyColorModifier(color, "shade", mod.attributes["val"]);
		else if (hasLocalName(mod, "tint")) color = applyColorModifier(color, "tint", mod.attributes["val"]);
		else if (hasLocalName(mod, "lumMod")) color = applyColorModifier(color, "lumMod", mod.attributes["val"]);
		else if (hasLocalName(mod, "lumOff")) color = applyColorModifier(color, "lumOff", mod.attributes["val"]);
		else if (hasLocalName(mod, "alpha")) alpha = parseInt(mod.attributes["val"]) / 1e5;
	});
	return {
		color,
		alpha
	};
}
function extractColorFromElement(element) {
	if (!element?.elements) return null;
	const schemeClr = findChildByLocalName(element.elements, "schemeClr");
	if (schemeClr) {
		const themeName = schemeClr.attributes?.["val"];
		return applyModifiersAndAlpha(getThemeColor(themeName), schemeClr.elements);
	}
	const srgbClr = findChildByLocalName(element.elements, "srgbClr");
	if (srgbClr) return applyModifiersAndAlpha("#" + srgbClr.attributes?.["val"], srgbClr.elements);
	const prstClr = findChildByLocalName(element.elements, "prstClr");
	if (prstClr) {
		const presetName = prstClr.attributes?.["val"];
		const baseColor = getPresetColor(presetName);
		if (!baseColor) return null;
		return applyModifiersAndAlpha(baseColor, prstClr.elements);
	}
	return null;
}
function getThemeColor(name) {
	return {
		accent1: "#5b9bd5",
		accent2: "#ed7d31",
		accent3: "#a5a5a5",
		accent4: "#ffc000",
		accent5: "#4472c4",
		accent6: "#70ad47",
		dk1: "#000000",
		lt1: "#ffffff",
		dk2: "#1f497d",
		lt2: "#eeece1",
		text1: "#000000",
		text2: "#1f497d",
		background1: "#ffffff",
		background2: "#eeece1",
		bg1: "#ffffff",
		bg2: "#eeece1"
	}[name] ?? "#000000";
}
function applyColorModifier(hexColor, modifier, value) {
	const r = parseInt(hexColor.slice(1, 3), 16);
	const g = parseInt(hexColor.slice(3, 5), 16);
	const b = parseInt(hexColor.slice(5, 7), 16);
	const percent = parseInt(value) / 1e5;
	let newR, newG, newB;
	if (modifier === "shade" || modifier === "lumMod") {
		newR = r * percent;
		newG = g * percent;
		newB = b * percent;
	} else if (modifier === "tint") {
		newR = r + (255 - r) * percent;
		newG = g + (255 - g) * percent;
		newB = b + (255 - b) * percent;
	} else if (modifier === "lumOff") {
		const offset = 255 * percent;
		newR = r + offset;
		newG = g + offset;
		newB = b + offset;
	} else return hexColor;
	const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
	const toHex = (n) => n.toString(16).padStart(2, "0");
	newR = clamp(newR);
	newG = clamp(newG);
	newB = clamp(newB);
	return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}
function extractStrokeWidth(spPr) {
	const ln = findChildByLocalName(spPr?.elements, "ln");
	if (!ln) return 1;
	const w = ln.attributes?.["w"];
	if (w == null) return 1;
	const emu = typeof w === "string" ? parseFloat(w) : w;
	if (emu === 0) return .75;
	return emu * 72 / 914400;
}
function extractLineEnds(spPr) {
	const ln = findChildByLocalName(spPr?.elements, "ln");
	if (!ln?.elements) return null;
	const parseEnd = (localName) => {
		const end = findChildByLocalName(ln.elements, localName);
		if (!end?.attributes) return null;
		const type = end.attributes?.["type"];
		if (!type || type === "none") return null;
		return {
			type,
			width: end.attributes?.["w"],
			length: end.attributes?.["len"]
		};
	};
	const headConfig = parseEnd("headEnd");
	const tailConfig = parseEnd("tailEnd");
	if (!headConfig && !tailConfig) return null;
	return {
		head: headConfig ?? void 0,
		tail: tailConfig ?? void 0
	};
}
function extractStrokeColor(spPr, style) {
	const ln = findChildByLocalName(spPr?.elements, "ln");
	if (ln) {
		if (findChildByLocalName(ln.elements, "noFill")) return null;
		const solidFill = findChildByLocalName(ln.elements, "solidFill");
		if (solidFill) {
			const result = extractColorFromElement(solidFill);
			if (result) return result.color;
		}
	}
	if (!style) return null;
	const lnRef = findChildByLocalName(style.elements, "lnRef");
	if (!lnRef) return null;
	if (lnRef.attributes?.["idx"] === "0") return null;
	const lnRefResult = extractColorFromElement(lnRef);
	if (lnRefResult) return lnRefResult.color;
	return null;
}
function extractFillColor(spPr, style) {
	if (findChildByLocalName(spPr?.elements, "noFill")) return null;
	const solidFill = findChildByLocalName(spPr?.elements, "solidFill");
	if (solidFill) {
		const result = extractColorFromElement(solidFill);
		if (result) {
			if (result.alpha !== null && result.alpha < 1) return {
				type: "solidWithAlpha",
				color: result.color,
				alpha: result.alpha
			};
			return result.color;
		}
	}
	const gradFill = findChildByLocalName(spPr?.elements, "gradFill");
	if (gradFill) return extractGradientFill(gradFill);
	if (findChildByLocalName(spPr?.elements, "blipFill")) return "#cccccc";
	if (!style) return null;
	const fillRef = findChildByLocalName(style.elements, "fillRef");
	if (!fillRef) return null;
	if (fillRef.attributes?.["idx"] === "0") return null;
	const fillRefResult = extractColorFromElement(fillRef);
	if (fillRefResult) {
		if (fillRefResult.alpha !== null && fillRefResult.alpha < 1) return {
			type: "solidWithAlpha",
			color: fillRefResult.color,
			alpha: fillRefResult.alpha
		};
		return fillRefResult.color;
	}
	return null;
}
function extractCustomGeometry(spPr) {
	const custGeom = findChildByLocalName(spPr?.elements, "custGeom");
	if (!custGeom) return null;
	const pathLst = findChildByLocalName(custGeom.elements, "pathLst");
	if (!pathLst?.elements) return null;
	const paths = pathLst.elements.filter((el) => hasLocalName(el, "path")).map((pathEl) => {
		const w = parseInt(pathEl.attributes?.["w"] || "0", 10);
		const h = parseInt(pathEl.attributes?.["h"] || "0", 10);
		return {
			d: convertDrawingMLPathToSvg(pathEl),
			w,
			h
		};
	}).filter((p) => p.d);
	if (paths.length === 0) return null;
	return { paths };
}
function convertDrawingMLPathToSvg(pathEl) {
	if (!pathEl?.elements) return "";
	const parts = [];
	for (const cmd of pathEl.elements) switch (getLocalName$1(cmd.name)) {
		case "moveTo": {
			const pt = findChildByLocalName(cmd.elements, "pt");
			if (pt) parts.push(`M ${pt.attributes?.["x"] || 0} ${pt.attributes?.["y"] || 0}`);
			break;
		}
		case "lnTo": {
			const pt = findChildByLocalName(cmd.elements, "pt");
			if (pt) parts.push(`L ${pt.attributes?.["x"] || 0} ${pt.attributes?.["y"] || 0}`);
			break;
		}
		case "cubicBezTo": {
			const pts = filterChildrenByLocalName(cmd.elements, "pt") || [];
			if (pts.length === 3) parts.push(`C ${pts[0].attributes?.["x"] || 0} ${pts[0].attributes?.["y"] || 0} ${pts[1].attributes?.["x"] || 0} ${pts[1].attributes?.["y"] || 0} ${pts[2].attributes?.["x"] || 0} ${pts[2].attributes?.["y"] || 0}`);
			break;
		}
		case "quadBezTo": {
			const pts = filterChildrenByLocalName(cmd.elements, "pt") || [];
			if (pts.length === 2) parts.push(`Q ${pts[0].attributes?.["x"] || 0} ${pts[0].attributes?.["y"] || 0} ${pts[1].attributes?.["x"] || 0} ${pts[1].attributes?.["y"] || 0}`);
			break;
		}
		case "close":
			parts.push("Z");
			break;
		default: break;
	}
	return parts.join(" ");
}
function extractGradientFill(gradFill) {
	const gradient = {
		type: "gradient",
		stops: [],
		angle: 0
	};
	const gsLst = findChildByLocalName(gradFill.elements, "gsLst");
	if (gsLst) gradient.stops = (filterChildrenByLocalName(gsLst.elements, "gs") || []).map((stop) => {
		const pos = parseInt(stop.attributes?.["pos"] || "0", 10) / 1e5;
		const srgbClr = findChildByLocalName(stop.elements, "srgbClr");
		let color = "#000000";
		let alpha = 1;
		if (srgbClr) {
			color = "#" + srgbClr.attributes?.["val"];
			const alphaEl = findChildByLocalName(srgbClr.elements, "alpha");
			if (alphaEl) alpha = parseInt(alphaEl.attributes?.["val"] || "100000", 10) / 1e5;
		}
		return {
			position: pos,
			color,
			alpha
		};
	});
	const lin = findChildByLocalName(gradFill.elements, "lin");
	if (lin) gradient.angle = parseInt(lin.attributes?.["ang"] || "0", 10) / 6e4;
	const path = findChildByLocalName(gradFill.elements, "path");
	if (path) {
		gradient.gradientType = "radial";
		gradient.path = path.attributes?.["path"] || "circle";
	} else gradient.gradientType = "linear";
	return gradient;
}
var SVGFilters = class {
	flood(filter, resultId, color, opacity, _settings) {
		const floodElement = document.createElementNS("http://www.w3.org/2000/svg", "feFlood");
		if (resultId) floodElement.setAttribute("id", resultId);
		floodElement.setAttribute("flood-color", color);
		floodElement.setAttribute("flood-opacity", opacity.toString());
		filter.appendChild(floodElement);
	}
	composite(filter, resultId, in1, in2, _k1, _k2, _k3, _k4, _settings) {
		const compositeElement = document.createElementNS("http://www.w3.org/2000/svg", "feComposite");
		if (resultId) compositeElement.setAttribute("id", resultId);
		compositeElement.setAttribute("in", in1);
		compositeElement.setAttribute("in2", in2);
		filter.appendChild(compositeElement);
	}
};
var SVGPathBuilder = class {
	constructor() {
		this._path = "";
	}
	move(x, y) {
		this._path += ` M ${x} ${y}`;
	}
	path() {
		return this._path.substr(1);
	}
	line(pts) {
		pts.forEach((point$1) => {
			this._path += ` L ${point$1[0]} ${point$1[1]}`;
		});
	}
	curveC(x1, y1, x2, y2, x, y) {
		this._path += ` C ${x1} ${y1}, ${x2} ${y2}, ${x} ${y}`;
	}
	close() {
		this._path += ` Z`;
	}
};
var SVG = class {
	constructor(svg) {
		this.filters = new SVGFilters();
		this._defs = void 0;
		this._svg = svg;
	}
	svg(parent, x, y, width, height, settings) {
		const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		svgElement.setAttribute("x", x.toString());
		svgElement.setAttribute("y", y.toString());
		svgElement.setAttribute("width", width.toString());
		svgElement.setAttribute("height", height.toString());
		this._appendSettings(settings, svgElement);
		if (parent != null) parent.appendChild(svgElement);
		else this._svg.appendChild(svgElement);
		return svgElement;
	}
	image(parent, x, y, width, height, url, settings) {
		const imageElement = document.createElementNS("http://www.w3.org/2000/svg", "image");
		imageElement.setAttribute("x", x.toString());
		imageElement.setAttribute("y", y.toString());
		imageElement.setAttribute("width", width.toString());
		imageElement.setAttribute("height", height.toString());
		imageElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", url);
		this._appendSettings(settings, imageElement);
		parent.appendChild(imageElement);
		return imageElement;
	}
	rect(parent, x, y, width, height, rx, ry, settings) {
		const rectElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
		rectElement.setAttribute("x", x.toString());
		rectElement.setAttribute("y", y.toString());
		rectElement.setAttribute("width", width.toString());
		rectElement.setAttribute("height", height.toString());
		if (rx !== void 0) {
			if (rx instanceof Number) rectElement.setAttribute("rx", rx.toString());
			else if (rx instanceof Object) this._appendSettings(rx, rectElement);
		}
		if (ry !== void 0) rectElement.setAttribute("ry", ry.toString());
		this._appendSettings(settings, rectElement);
		parent.appendChild(rectElement);
		return rectElement;
	}
	line(parent, x1, y1, x2, y2, settings) {
		const lineElement = document.createElementNS("http://www.w3.org/2000/svg", "line");
		lineElement.setAttribute("x1", x1.toString());
		lineElement.setAttribute("y1", y1.toString());
		lineElement.setAttribute("x2", x2.toString());
		lineElement.setAttribute("y2", y2.toString());
		this._appendSettings(settings, lineElement);
		parent.appendChild(lineElement);
		return lineElement;
	}
	polygon(parent, points, settings) {
		const polygonElement = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
		polygonElement.setAttribute("points", points.map((point$1) => point$1.join(",")).join(" "));
		this._appendSettings(settings, polygonElement);
		parent.appendChild(polygonElement);
		return polygonElement;
	}
	polyline(parent, points, settings) {
		const polylineElement = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
		polylineElement.setAttribute("points", points.map((point$1) => point$1.join(",")).join(" "));
		this._appendSettings(settings, polylineElement);
		parent.appendChild(polylineElement);
		return polylineElement;
	}
	ellipse(parent, cx, cy, rx, ry, settings) {
		const ellipseElement = document.createElementNS("http://www.w3.org/2000/svg", "ellipse");
		ellipseElement.setAttribute("cx", cx.toString());
		ellipseElement.setAttribute("cy", cy.toString());
		ellipseElement.setAttribute("rx", rx.toString());
		ellipseElement.setAttribute("ry", ry.toString());
		this._appendSettings(settings, ellipseElement);
		parent.appendChild(ellipseElement);
		return ellipseElement;
	}
	path(parent, builder, settings) {
		const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
		pathElement.setAttribute("d", builder.path());
		this._appendSettings(settings, pathElement);
		parent.appendChild(pathElement);
		return pathElement;
	}
	text(parent, x, y, value, settings) {
		const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
		textElement.setAttribute("x", x.toString());
		textElement.setAttribute("y", y.toString());
		this._appendSettings(settings, textElement);
		const textNode = document.createTextNode(value);
		textElement.appendChild(textNode);
		parent.appendChild(textElement);
		return textElement;
	}
	filter(parent, id, x, y, width, height, settings) {
		const filterElement = document.createElementNS("http://www.w3.org/2000/svg", "filter");
		filterElement.setAttribute("x", x.toString());
		filterElement.setAttribute("y", y.toString());
		filterElement.setAttribute("width", width.toString());
		filterElement.setAttribute("height", height.toString());
		this._appendSettings(settings, filterElement);
		parent.appendChild(filterElement);
		return filterElement;
	}
	pattern(parent, resultId, x, y, width, height, settings) {
		const patternElement = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
		if (resultId) patternElement.setAttribute("id", resultId);
		patternElement.setAttribute("x", x.toString());
		patternElement.setAttribute("y", y.toString());
		patternElement.setAttribute("width", width.toString());
		patternElement.setAttribute("height", height.toString());
		this._appendSettings(settings, patternElement);
		parent.appendChild(patternElement);
		return patternElement;
	}
	defs() {
		if (this._defs === void 0) {
			const defsElement = document.createElementNS("http://www.w3.org/2000/svg", "defs");
			this._svg.appendChild(defsElement);
			this._defs = defsElement;
		}
		return this._defs;
	}
	clipPath(parent, resultId, units, settings) {
		const clipElement = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
		if (resultId) clipElement.setAttribute("id", resultId);
		if (units === void 0) units = "userSpaceOnUse";
		clipElement.setAttribute("clipPathUnits", units);
		this._appendSettings(settings, clipElement);
		parent.appendChild(clipElement);
		return clipElement;
	}
	createPath() {
		return new SVGPathBuilder();
	}
	_appendSettings(settings, element) {
		if (settings !== void 0) Object.keys(settings).forEach((key) => {
			element.setAttribute(key, settings[key]);
		});
	}
};
var EMFJSError = class extends Error {
	constructor(message) {
		super(message);
		Object.setPrototypeOf(this, new.target.prototype);
	}
};
var isLoggingEnabled$1 = true;
function loggingEnabled$1(enabled) {
	isLoggingEnabled$1 = enabled;
}
var Helper$1 = class {
	static {
		this.GDI = {
			FormatSignature: {
				ENHMETA_SIGNATURE: 1179469088,
				EPS_SIGNATURE: 1179865157
			},
			BITMAPINFOHEADER_SIZE: 40,
			BITMAPCOREHEADER_SIZE: 12,
			RecordType: {
				EMR_POLYBEZIER: 2,
				EMR_POLYGON: 3,
				EMR_POLYLINE: 4,
				EMR_POLYBEZIERTO: 5,
				EMR_POLYLINETO: 6,
				EMR_POLYPOLYLINE: 7,
				EMR_POLYPOLYGON: 8,
				EMR_SETWINDOWEXTEX: 9,
				EMR_SETWINDOWORGEX: 10,
				EMR_SETVIEWPORTEXTEX: 11,
				EMR_SETVIEWPORTORGEX: 12,
				EMR_SETBRUSHORGEX: 13,
				EMR_EOF: 14,
				EMR_SETPIXELV: 15,
				EMR_SETMAPPERFLAGS: 16,
				EMR_SETMAPMODE: 17,
				EMR_SETBKMODE: 18,
				EMR_SETPOLYFILLMODE: 19,
				EMR_SETROP2: 20,
				EMR_SETSTRETCHBLTMODE: 21,
				EMR_SETTEXTALIGN: 22,
				EMR_SETCOLORADJUSTMENT: 23,
				EMR_SETTEXTCOLOR: 24,
				EMR_SETBKCOLOR: 25,
				EMR_OFFSETCLIPRGN: 26,
				EMR_MOVETOEX: 27,
				EMR_SETMETARGN: 28,
				EMR_EXCLUDECLIPRECT: 29,
				EMR_INTERSECTCLIPRECT: 30,
				EMR_SCALEVIEWPORTEXTEX: 31,
				EMR_SCALEWINDOWEXTEX: 32,
				EMR_SAVEDC: 33,
				EMR_RESTOREDC: 34,
				EMR_SETWORLDTRANSFORM: 35,
				EMR_MODIFYWORLDTRANSFORM: 36,
				EMR_SELECTOBJECT: 37,
				EMR_CREATEPEN: 38,
				EMR_CREATEBRUSHINDIRECT: 39,
				EMR_DELETEOBJECT: 40,
				EMR_ANGLEARC: 41,
				EMR_ELLIPSE: 42,
				EMR_RECTANGLE: 43,
				EMR_ROUNDRECT: 44,
				EMR_ARC: 45,
				EMR_CHORD: 46,
				EMR_PIE: 47,
				EMR_SELECTPALETTE: 48,
				EMR_CREATEPALETTE: 49,
				EMR_SETPALETTEENTRIES: 50,
				EMR_RESIZEPALETTE: 51,
				EMR_REALIZEPALETTE: 52,
				EMR_EXTFLOODFILL: 53,
				EMR_LINETO: 54,
				EMR_ARCTO: 55,
				EMR_POLYDRAW: 56,
				EMR_SETARCDIRECTION: 57,
				EMR_SETMITERLIMIT: 58,
				EMR_BEGINPATH: 59,
				EMR_ENDPATH: 60,
				EMR_CLOSEFIGURE: 61,
				EMR_FILLPATH: 62,
				EMR_STROKEANDFILLPATH: 63,
				EMR_STROKEPATH: 64,
				EMR_FLATTENPATH: 65,
				EMR_WIDENPATH: 66,
				EMR_SELECTCLIPPATH: 67,
				EMR_ABORTPATH: 68,
				EMR_COMMENT: 70,
				EMR_FILLRGN: 71,
				EMR_FRAMERGN: 72,
				EMR_INVERTRGN: 73,
				EMR_PAINTRGN: 74,
				EMR_EXTSELECTCLIPRGN: 75,
				EMR_BITBLT: 76,
				EMR_STRETCHBLT: 77,
				EMR_MASKBLT: 78,
				EMR_PLGBLT: 79,
				EMR_SETDIBITSTODEVICE: 80,
				EMR_STRETCHDIBITS: 81,
				EMR_EXTCREATEFONTINDIRECTW: 82,
				EMR_EXTTEXTOUTA: 83,
				EMR_EXTTEXTOUTW: 84,
				EMR_POLYBEZIER16: 85,
				EMR_POLYGON16: 86,
				EMR_POLYLINE16: 87,
				EMR_POLYBEZIERTO16: 88,
				EMR_POLYLINETO16: 89,
				EMR_POLYPOLYLINE16: 90,
				EMR_POLYPOLYGON16: 91,
				EMR_POLYDRAW16: 92,
				EMR_CREATEMONOBRUSH: 93,
				EMR_CREATEDIBPATTERNBRUSHPT: 94,
				EMR_EXTCREATEPEN: 95,
				EMR_POLYTEXTOUTA: 96,
				EMR_POLYTEXTOUTW: 97,
				EMR_SETICMMODE: 98,
				EMR_CREATECOLORSPACE: 99,
				EMR_SETCOLORSPACE: 100,
				EMR_DELETECOLORSPACE: 101,
				EMR_GLSRECORD: 102,
				EMR_GLSBOUNDEDRECORD: 103,
				EMR_PIXELFORMAT: 104,
				EMR_DRAWESCAPE: 105,
				EMR_EXTESCAPE: 106,
				EMR_SMALLTEXTOUT: 108,
				EMR_FORCEUFIMAPPING: 109,
				EMR_NAMEDESCAPE: 110,
				EMR_COLORCORRECTPALETTE: 111,
				EMR_SETICMPROFILEA: 112,
				EMR_SETICMPROFILEW: 113,
				EMR_ALPHABLEND: 114,
				EMR_SETLAYOUT: 115,
				EMR_TRANSPARENTBLT: 116,
				EMR_GRADIENTFILL: 118,
				EMR_SETLINKEDUFIS: 119,
				EMR_SETTEXTJUSTIFICATION: 120,
				EMR_COLORMATCHTOTARGETW: 121,
				EMR_CREATECOLORSPACEW: 122
			},
			MetafileEscapes: {
				NEWFRAME: 1,
				ABORTDOC: 2,
				NEXTBAND: 3,
				SETCOLORTABLE: 4,
				GETCOLORTABLE: 5,
				FLUSHOUT: 6,
				DRAFTMODE: 7,
				QUERYESCSUPPORT: 8,
				SETABORTPROC: 9,
				STARTDOC: 10,
				ENDDOC: 11,
				GETPHYSPAGESIZE: 12,
				GETPRINTINGOFFSET: 13,
				GETSCALINGFACTOR: 14,
				META_ESCAPE_ENHANCED_METAFILE: 15,
				SETPENWIDTH: 16,
				SETCOPYCOUNT: 17,
				SETPAPERSOURCE: 18,
				PASSTHROUGH: 19,
				GETTECHNOLOGY: 20,
				SETLINECAP: 21,
				SETLINEJOIN: 22,
				SETMITERLIMIT: 23,
				BANDINFO: 24,
				DRAWPATTERNRECT: 25,
				GETVECTORPENSIZE: 26,
				GETVECTORBRUSHSIZE: 27,
				ENABLEDUPLEX: 28,
				GETSETPAPERBINS: 29,
				GETSETPRINTORIENT: 30,
				ENUMPAPERBINS: 31,
				SETDIBSCALING: 32,
				EPSPRINTING: 33,
				ENUMPAPERMETRICS: 34,
				GETSETPAPERMETRICS: 35,
				POSTSCRIPT_DATA: 37,
				POSTSCRIPT_IGNORE: 38,
				GETDEVICEUNITS: 42,
				GETEXTENDEDTEXTMETRICS: 256,
				GETPAIRKERNTABLE: 258,
				EXTTEXTOUT: 512,
				GETFACENAME: 513,
				DOWNLOADFACE: 514,
				METAFILE_DRIVER: 2049,
				QUERYDIBSUPPORT: 3073,
				BEGIN_PATH: 4096,
				CLIP_TO_PATH: 4097,
				END_PATH: 4098,
				OPEN_CHANNEL: 4110,
				DOWNLOADHEADER: 4111,
				CLOSE_CHANNEL: 4112,
				POSTSCRIPT_PASSTHROUGH: 4115,
				ENCAPSULATED_POSTSCRIPT: 4116,
				POSTSCRIPT_IDENTIFY: 4117,
				POSTSCRIPT_INJECTION: 4118,
				CHECKJPEGFORMAT: 4119,
				CHECKPNGFORMAT: 4120,
				GET_PS_FEATURESETTING: 4121,
				MXDC_ESCAPE: 4122,
				SPCLPASSTHROUGH2: 4568
			},
			MapMode: {
				MM_TEXT: 1,
				MM_LOMETRIC: 2,
				MM_HIMETRIC: 3,
				MM_LOENGLISH: 4,
				MM_HIENGLISH: 5,
				MM_TWIPS: 6,
				MM_ISOTROPIC: 7,
				MM_ANISOTROPIC: 8
			},
			StretchMode: {
				BLACKONWHITE: 1,
				WHITEONBLACK: 2,
				COLORONCOLOR: 3,
				HALFTONE: 4
			},
			MixMode: {
				TRANSPARENT: 1,
				OPAQUE: 2
			},
			BrushStyle: {
				BS_SOLID: 0,
				BS_NULL: 1,
				BS_HATCHED: 2,
				BS_PATTERN: 3,
				BS_INDEXED: 4,
				BS_DIBPATTERN: 5,
				BS_DIBPATTERNPT: 6,
				BS_PATTERN8X8: 7,
				BS_DIBPATTERN8X8: 8,
				BS_MONOPATTERN: 9
			},
			PenStyle: {
				PS_COSMETIC: 0,
				PS_ENDCAP_ROUND: 0,
				PS_JOIN_ROUND: 0,
				PS_SOLID: 0,
				PS_DASH: 1,
				PS_DOT: 2,
				PS_DASHDOT: 3,
				PS_DASHDOTDOT: 4,
				PS_NULL: 5,
				PS_INSIDEFRAME: 6,
				PS_USERSTYLE: 7,
				PS_ALTERNATE: 8,
				PS_ENDCAP_SQUARE: 256,
				PS_ENDCAP_FLAT: 512,
				PS_JOIN_BEVEL: 4096,
				PS_JOIN_MITER: 8192,
				PS_GEOMETRIC: 65536
			},
			PolygonFillMode: {
				ALTERNATE: 1,
				WINDING: 2
			},
			BitmapCompression: {
				BI_RGB: 0,
				BI_RLE8: 1,
				BI_RLE4: 2,
				BI_BITFIELDS: 3,
				BI_JPEG: 4,
				BI_PNG: 5
			},
			RegionMode: {
				RGN_AND: 1,
				RGN_OR: 2,
				RGN_XOR: 3,
				RGN_DIFF: 4,
				RGN_COPY: 5
			},
			StockObject: {
				WHITE_BRUSH: 2147483648,
				LTGRAY_BRUSH: 2147483649,
				GRAY_BRUSH: 2147483650,
				DKGRAY_BRUSH: 2147483651,
				BLACK_BRUSH: 2147483652,
				NULL_BRUSH: 2147483653,
				WHITE_PEN: 2147483654,
				BLACK_PEN: 2147483655,
				NULL_PEN: 2147483656,
				OEM_FIXED_FONT: 2147483658,
				ANSI_FIXED_FONT: 2147483659,
				ANSI_VAR_FONT: 2147483660,
				SYSTEM_FONT: 2147483661,
				DEVICE_DEFAULT_FONT: 2147483662,
				DEFAULT_PALETTE: 2147483663,
				SYSTEM_FIXED_FONT: 2147483664,
				DEFAULT_GUI_FONT: 2147483665,
				DC_BRUSH: 2147483666,
				DC_PEN: 2147483667
			}
		};
	}
	static {
		this._uniqueId = 0;
	}
	static log(message) {
		if (isLoggingEnabled$1) console.log(message);
	}
	static _makeUniqueId(prefix) {
		return "EMFJS_" + prefix + this._uniqueId++;
	}
	static _writeUint32Val(uint8arr, pos, val) {
		uint8arr[pos++] = val & 255;
		uint8arr[pos++] = val >>> 8 & 255;
		uint8arr[pos++] = val >>> 16 & 255;
		uint8arr[pos++] = val >>> 24 & 255;
	}
	static _blobToBinary(blob) {
		let ret = "";
		const len = blob.length;
		for (let i$1 = 0; i$1 < len; i$1++) ret += String.fromCharCode(blob[i$1]);
		return ret;
	}
};
var Blob$2 = class Blob$2 {
	constructor(blob, offset) {
		if (blob instanceof Blob$2) {
			this.blob = blob.blob;
			this.data = blob.data;
			this.pos = offset || blob.pos;
		} else {
			this.blob = blob;
			this.data = new Uint8Array(blob);
			this.pos = offset || 0;
		}
	}
	eof() {
		return this.pos >= this.data.length;
	}
	seek(newpos) {
		if (newpos < 0 || newpos > this.data.length) throw new EMFJSError("Invalid seek position");
		this.pos = newpos;
	}
	skip(cnt) {
		const newPos = this.pos + cnt;
		if (newPos > this.data.length) throw new EMFJSError("Unexpected end of file");
		this.pos = newPos;
	}
	readBinary(cnt) {
		if (this.pos + cnt > this.data.length) throw new EMFJSError("Unexpected end of file");
		let ret = "";
		while (cnt-- > 0) ret += String.fromCharCode(this.data[this.pos++]);
		return ret;
	}
	readInt8() {
		if (this.pos + 1 > this.data.length) throw new EMFJSError("Unexpected end of file");
		return this.data[this.pos++];
	}
	readUint8() {
		return this.readInt8() >>> 0;
	}
	readInt32() {
		if (this.pos + 4 > this.data.length) throw new EMFJSError("Unexpected end of file");
		let val = this.data[this.pos++];
		val |= this.data[this.pos++] << 8;
		val |= this.data[this.pos++] << 16;
		val |= this.data[this.pos++] << 24;
		return val;
	}
	readUint32() {
		return this.readInt32() >>> 0;
	}
	readUint16() {
		if (this.pos + 2 > this.data.length) throw new EMFJSError("Unexpected end of file");
		let val = this.data[this.pos++];
		val |= this.data[this.pos++] << 8;
		return val;
	}
	readInt16() {
		let val = this.readUint16();
		if (val > 32767) val -= 65536;
		return val;
	}
	readString(length) {
		if (this.pos + length > this.data.length) throw new EMFJSError("Unexpected end of file");
		let ret = "";
		for (let i$1 = 0; i$1 < length; i$1++) ret += String.fromCharCode(this.data[this.pos++] >>> 0);
		return ret;
	}
	readNullTermString(maxSize) {
		let ret = "";
		if (maxSize > 0) {
			maxSize--;
			for (let i$1 = 0; i$1 < maxSize; i$1++) {
				if (this.pos + i$1 + 1 > this.data.length) throw new EMFJSError("Unexpected end of file");
				const byte = this.data[this.pos + i$1] >>> 0;
				if (byte === 0) break;
				ret += String.fromCharCode(byte);
			}
		}
		return ret;
	}
	readFixedSizeUnicodeString(fixedSizeChars) {
		let ret = "";
		for (let i$1 = 0; i$1 < fixedSizeChars; i$1++) {
			const charCode = this.readUint16();
			if (charCode === 0) {
				if (++i$1 < fixedSizeChars) this.skip((fixedSizeChars - i$1) * 2);
				break;
			}
			ret += String.fromCharCode(charCode);
		}
		return ret;
	}
};
var BitmapCoreHeader$1 = class {
	constructor(reader, skipsize) {
		if (skipsize) reader.skip(4);
		this.width = reader.readUint16();
		this.height = reader.readUint16();
		this.planes = reader.readUint16();
		this.bitcount = reader.readUint16();
	}
	colors() {
		return this.bitcount <= 8 ? 1 << this.bitcount : 0;
	}
};
var BitmapInfoHeader$1 = class {
	constructor(reader, skipsize) {
		if (skipsize) reader.skip(4);
		this.width = reader.readInt32();
		this.height = reader.readInt32();
		this.planes = reader.readUint16();
		this.bitcount = reader.readUint16();
		this.compression = reader.readUint32();
		this.sizeimage = reader.readUint32();
		this.xpelspermeter = reader.readInt32();
		this.ypelspermeter = reader.readInt32();
		this.clrused = reader.readUint32();
		this.clrimportant = reader.readUint32();
	}
	colors() {
		if (this.clrused !== 0) return this.clrused < 256 ? this.clrused : 256;
		else return this.bitcount > 8 ? 0 : 1 << this.bitcount;
	}
};
var BitmapInfo$1 = class {
	constructor(reader, usergb) {
		this._usergb = usergb;
		const hdrsize = reader.readUint32();
		this._infosize = hdrsize;
		if (hdrsize === Helper$1.GDI.BITMAPCOREHEADER_SIZE) {
			this._header = new BitmapCoreHeader$1(reader, false);
			this._infosize += this._header.colors() * (usergb ? 3 : 2);
		} else {
			this._header = new BitmapInfoHeader$1(reader, false);
			const masks = this._header.compression === Helper$1.GDI.BitmapCompression.BI_BITFIELDS ? 3 : 0;
			if (hdrsize <= Helper$1.GDI.BITMAPINFOHEADER_SIZE + masks * 4) this._infosize = Helper$1.GDI.BITMAPINFOHEADER_SIZE + masks * 4;
			this._infosize += this._header.colors() * (usergb ? 4 : 2);
		}
	}
	getWidth() {
		return this._header.width;
	}
	getHeight() {
		return Math.abs(this._header.height);
	}
	infosize() {
		return this._infosize;
	}
	header() {
		return this._header;
	}
};
var DIBitmap$1 = class {
	constructor(reader, bitmapInfo) {
		this._reader = reader;
		this._offset = reader.pos;
		this._location = bitmapInfo;
		this._info = new BitmapInfo$1(reader, true);
	}
	getWidth() {
		return this._info.getWidth();
	}
	getHeight() {
		return this._info.getHeight();
	}
	totalSize() {
		return this._location.header.size + this._location.data.size;
	}
	makeBitmapFileHeader() {
		const buf = /* @__PURE__ */ new ArrayBuffer(14);
		const view = new Uint8Array(buf);
		view[0] = 66;
		view[1] = 77;
		Helper$1._writeUint32Val(view, 2, this.totalSize() + 14);
		Helper$1._writeUint32Val(view, 10, this._info.infosize() + 14);
		return Helper$1._blobToBinary(view);
	}
	convertToPNG(bitmapData, width, height, hasAlpha) {
		const canvas = document.createElement("canvas");
		canvas.width = width;
		canvas.height = Math.abs(height);
		const ctx = canvas.getContext("2d");
		if (!ctx) throw new Error("Unable to get canvas context for PNG conversion");
		const imageData = ctx.createImageData(width, Math.abs(height));
		const pixels = imageData.data;
		const rowSize = width * 32 + 31 >>> 5 << 2;
		const absHeight = Math.abs(height);
		const topDown = height < 0;
		let alphaUsed = false;
		if (hasAlpha) for (let y = 0; y < absHeight && !alphaUsed; y++) {
			const srcY = topDown ? y : absHeight - 1 - y;
			for (let x = 0; x < width && !alphaUsed; x++) if (bitmapData[srcY * rowSize + x * 4 + 3] > 0) alphaUsed = true;
		}
		for (let y = 0; y < absHeight; y++) {
			const srcY = topDown ? y : absHeight - 1 - y;
			for (let x = 0; x < width; x++) {
				const srcOffset = srcY * rowSize + x * 4;
				const dstOffset = (y * width + x) * 4;
				pixels[dstOffset] = bitmapData[srcOffset + 2];
				pixels[dstOffset + 1] = bitmapData[srcOffset + 1];
				pixels[dstOffset + 2] = bitmapData[srcOffset];
				pixels[dstOffset + 3] = alphaUsed ? bitmapData[srcOffset + 3] : 255;
			}
		}
		ctx.putImageData(imageData, 0, 0);
		return canvas.toDataURL("image/png");
	}
	base64ref() {
		const prevpos = this._reader.pos;
		this._reader.seek(this._offset);
		const header = this._info.header();
		if (header instanceof BitmapInfoHeader$1 && header.compression != null) switch (header.compression) {
			case Helper$1.GDI.BitmapCompression.BI_JPEG:
				this._reader.seek(this._location.data.off);
				const jpegData = "data:image/jpeg;base64," + btoa(this._reader.readBinary(this._location.data.size));
				this._reader.seek(prevpos);
				return jpegData;
			case Helper$1.GDI.BitmapCompression.BI_PNG:
				this._reader.seek(this._location.data.off);
				const pngData = "data:image/png;base64," + btoa(this._reader.readBinary(this._location.data.size));
				this._reader.seek(prevpos);
				return pngData;
		}
		if (header instanceof BitmapInfoHeader$1 && header.bitcount === 32) {
			this._reader.seek(this._location.data.off);
			const bitmapBytes = new Uint8Array(this._location.data.size);
			const bitmapData = this._reader.readBinary(this._location.data.size);
			for (let i$1 = 0; i$1 < this._location.data.size; i$1++) bitmapBytes[i$1] = bitmapData.charCodeAt(i$1);
			const pngDataUrl = this.convertToPNG(bitmapBytes, header.width, header.height, true);
			this._reader.seek(prevpos);
			return pngDataUrl;
		}
		let data = this.makeBitmapFileHeader();
		this._reader.seek(this._location.header.off);
		data += this._reader.readBinary(this._location.header.size);
		this._reader.seek(this._location.data.off);
		data += this._reader.readBinary(this._location.data.size);
		const ref$1 = "data:image/bmp;base64," + btoa(data);
		this._reader.seek(prevpos);
		return ref$1;
	}
};
var PointS$1 = class PointS$1 {
	constructor(reader, x, y) {
		if (reader != null) {
			this.x = reader.readInt16();
			this.y = reader.readInt16();
		} else {
			this.x = x;
			this.y = y;
		}
	}
	clone() {
		return new PointS$1(null, this.x, this.y);
	}
	toString() {
		return "{x: " + this.x + ", y: " + this.y + "}";
	}
};
var PointL = class PointL {
	constructor(reader, x, y) {
		if (reader != null) {
			this.x = reader.readInt32();
			this.y = reader.readInt32();
		} else {
			this.x = x;
			this.y = y;
		}
	}
	clone() {
		return new PointL(null, this.x, this.y);
	}
	toString() {
		return "{x: " + this.x + ", y: " + this.y + "}";
	}
};
var RectL = class RectL {
	constructor(reader, left, top, right, bottom) {
		if (reader != null) {
			this.left = reader.readInt32();
			this.top = reader.readInt32();
			this.right = reader.readInt32();
			this.bottom = reader.readInt32();
		} else {
			this.bottom = bottom;
			this.right = right;
			this.top = top;
			this.left = left;
		}
	}
	clone() {
		return new RectL(null, this.left, this.top, this.right, this.bottom);
	}
	toString() {
		return "{left: " + this.left + ", top: " + this.top + ", right: " + this.right + ", bottom: " + this.bottom + "}";
	}
	empty() {
		return this.left >= this.right || this.top >= this.bottom;
	}
	intersect(rectL) {
		if (this.empty() || rectL.empty()) return null;
		if (this.left >= rectL.right || this.top >= rectL.bottom || this.right <= rectL.left || this.bottom <= rectL.top) return null;
		return new RectL(null, Math.max(this.left, rectL.left), Math.max(this.top, rectL.top), Math.min(this.right, rectL.right), Math.min(this.bottom, rectL.bottom));
	}
};
var SizeL = class SizeL {
	constructor(reader, cx, cy) {
		if (reader != null) {
			this.cx = reader.readUint32();
			this.cy = reader.readUint32();
		} else {
			this.cx = cx;
			this.cy = cy;
		}
	}
	clone() {
		return new SizeL(null, this.cx, this.cy);
	}
	toString() {
		return "{cx: " + this.cx + ", cy: " + this.cy + "}";
	}
};
var Obj$1 = class {
	constructor(type) {
		this.type = type;
	}
	clone() {
		throw new EMFJSError("clone not implemented");
	}
	toString() {
		throw new EMFJSError("toString not implemented");
	}
};
var Region$1 = class Region$1 extends Obj$1 {
	constructor(reader, copy$1) {
		super("region");
		if (reader != null) {
			if (reader.readUint32() !== 32) throw new EMFJSError("Invalid region header");
			reader.skip(4);
			const rectCnt = reader.readUint32();
			const rgnSize = reader.readUint32();
			if (rectCnt * 16 !== rgnSize) throw new EMFJSError("Invalid region data");
			this.bounds = new RectL(reader);
			this.scans = [];
			let scanLine;
			for (let i$1 = 0; i$1 < rectCnt; i$1++) {
				const r = new RectL(reader);
				if (!!scanLine || scanLine.top !== r.top || scanLine.bottom !== r.bottom) {
					scanLine = new Scan$1(r);
					this.scans.push(scanLine);
				} else scanLine.append(r);
			}
			this._updateComplexity();
		} else if (copy$1 != null) {
			this.bounds = copy$1.bounds != null ? copy$1.bounds.clone() : null;
			if (copy$1.scans != null) {
				this.scans = [];
				for (let i$1 = 0; i$1 < copy$1.scans.length; i$1++) this.scans.push(copy$1.scans[i$1].clone());
			} else this.scans = null;
			this.complexity = copy$1.complexity;
		} else {
			this.bounds = null;
			this.scans = null;
			this.complexity = 0;
		}
	}
	clone() {
		return new Region$1(null, this);
	}
	toString() {
		return "{complexity: " + [
			"null",
			"simple",
			"complex"
		][this.complexity] + " bounds: " + (this.bounds != null ? this.bounds.toString() : "[none]") + " #scans: " + (this.scans != null ? this.scans.length : "[none]") + "}";
	}
	_updateComplexity() {
		if (this.bounds == null) {
			this.complexity = 0;
			this.scans = null;
		} else if (this.bounds.empty()) {
			this.complexity = 0;
			this.scans = null;
			this.bounds = null;
		} else if (this.scans == null) this.complexity = 1;
		else {
			this.complexity = 2;
			if (this.scans.length === 1) {
				const scan = this.scans[0];
				if (scan.top === this.bounds.top && scan.bottom === this.bounds.bottom && scan.scanlines.length === 1) {
					const scanline = scan.scanlines[0];
					if (scanline.left === this.bounds.left && scanline.right === this.bounds.right) {
						this.scans = null;
						this.complexity = 1;
					}
				}
			}
		}
	}
	subtract(rect) {
		Helper$1.log("[emf] Region " + this.toString() + " subtract " + rect.toString());
		if (this.bounds != null) {
			if (this.bounds.intersect(rect) != null) {
				if (this.scans == null) {
					this.scans = [];
					this.scans.push(new Scan$1(new RectL(null, this.bounds.left, this.bounds.top, this.bounds.right, this.bounds.bottom)));
					this.complexity = 2;
				}
				let si = 0;
				while (si < this.scans.length) {
					const scan = this.scans[si];
					if (scan.bottom >= rect.top) {
						const cloned = scan.clone();
						scan.bottom = rect.top - 1;
						cloned.top = rect.top;
						if (scan.top >= scan.bottom) this.scans[si] = cloned;
						else {
							Helper$1.log("[emf] Region split top scan " + si + " for substraction");
							this.scans.splice(++si, 0, cloned);
						}
						break;
					}
					si++;
				}
				const first = si;
				while (si < this.scans.length) {
					const scan = this.scans[si];
					if (scan.top > rect.bottom) break;
					if (scan.bottom > rect.bottom) {
						const cloned = scan.clone();
						scan.bottom = rect.bottom;
						cloned.top = rect.bottom + 1;
						if (scan.top >= scan.bottom) this.scans[si] = cloned;
						else {
							Helper$1.log("[emf] Region split bottom scan " + si + " for substraction");
							this.scans.splice(++si, 0, cloned);
						}
						break;
					}
					si++;
				}
				if (first < this.scans.length) {
					let last = si;
					si = first;
					while (si < last) {
						if (!this.scans[si].subtract(rect.left, rect.right)) {
							Helper$1.log("[emf] Region remove now empty scan " + si + " due to subtraction");
							this.scans.splice(si, 1);
							last--;
							continue;
						}
						si++;
					}
				}
				if (this.scans != null) {
					let left;
					let top;
					let right;
					let bottom;
					const len = this.scans.length;
					for (let i$1 = 0; i$1 < len; i$1++) {
						const scan = this.scans[i$1];
						if (i$1 === 0) top = scan.top;
						if (i$1 === len - 1) bottom = scan.bottom;
						const slen = scan.scanlines.length;
						if (slen > 0) {
							let scanline = scan.scanlines[0];
							if (left == null || scanline.left < left) left = scanline.left;
							scanline = scan.scanlines[slen - 1];
							if (right == null || scanline.right > right) right = scanline.right;
						}
					}
					if (left != null && top != null && right != null && bottom != null) {
						this.bounds = new RectL(null, left, top, right, bottom);
						this._updateComplexity();
					} else {
						this.bounds = null;
						this.scans = null;
						this.complexity = 0;
					}
				} else this._updateComplexity();
			}
		}
		Helper$1.log("[emf] Region subtraction -> " + this.toString());
	}
	intersect(rect) {
		Helper$1.log("[emf] Region " + this.toString() + " intersect with " + rect.toString());
		if (this.bounds != null) {
			this.bounds = this.bounds.intersect(rect);
			if (this.bounds != null) {
				if (this.scans != null) {
					let si = 0;
					while (si < this.scans.length) if (this.scans[si].bottom < this.bounds.top) si++;
					else break;
					if (si > 0) {
						Helper$1.log("[emf] Region remove " + si + " scans from top");
						this.scans.splice(0, si);
						if (this.scans.length > 0) this.scans[0].top = this.bounds.top;
					}
					si = 0;
					while (si < this.scans.length) {
						const scan = this.scans[si];
						if (scan.top > this.bounds.bottom) {
							Helper$1.log("[emf] Region remove " + (this.scans.length - si) + " scans from bottom");
							this.scans.splice(si, this.scans.length - si);
							break;
						}
						if (!scan.intersect(this.bounds.left, this.bounds.right)) {
							Helper$1.log("[emf] Region remove now empty scan " + si + " due to intersection");
							this.scans.splice(si, 1);
							continue;
						}
						si++;
					}
					if (this.scans.length > 0) this.scans[this.scans.length - 1].bottom = this.bounds.bottom;
					this._updateComplexity();
				}
			} else {
				this.scans = null;
				this.complexity = 0;
			}
		}
		Helper$1.log("[emf] Region intersection -> " + this.toString());
	}
	offset(offX, offY) {
		if (this.bounds != null) {
			this.bounds.left += offX;
			this.bounds.top += offY;
			this.bounds.right += offX;
			this.bounds.bottom += offY;
		}
		if (this.scans != null) {
			const slen = this.scans.length;
			for (let si = 0; si < slen; si++) {
				const scan = this.scans[si];
				scan.top += offY;
				scan.bottom += offY;
				const len = scan.scanlines.length;
				for (let i$1 = 0; i$1 < len; i$1++) {
					const scanline = scan.scanlines[i$1];
					scanline.left += offX;
					scanline.right += offX;
				}
			}
		}
	}
};
function CreateSimpleRegion$1(left, top, right, bottom) {
	const rgn = new Region$1(null, null);
	rgn.bounds = new RectL(null, left, top, right, bottom);
	rgn._updateComplexity();
	return rgn;
}
var Scan$1 = class Scan$1 {
	constructor(r, copy$1) {
		if (r != null) {
			this.top = r.top;
			this.bottom = r.bottom;
			this.scanlines = [{
				left: r.left,
				right: r.right
			}];
		} else if (copy$1 != null) {
			this.top = copy$1.top;
			this.bottom = copy$1.bottom;
			this.scanlines = [];
			for (let i$1 = 0; i$1 < copy$1.scanlines.length; i$1++) {
				const scanline = copy$1.scanlines[i$1];
				this.scanlines.push({
					left: scanline.left,
					right: scanline.right
				});
			}
		}
	}
	clone() {
		return new Scan$1(null, this);
	}
	append(r) {
		this.scanlines.push({
			left: r.left,
			right: r.right
		});
	}
	subtract(left, right) {
		let i$1 = 0;
		while (i$1 < this.scanlines.length) {
			const scanline = this.scanlines[i$1];
			if (scanline.left <= left) {
				if (scanline.right >= left) {
					scanline.right = left - 1;
					if (scanline.left >= scanline.right) {
						this.scanlines.splice(i$1, 1);
						continue;
					}
				}
				i$1++;
			} else break;
		}
		const first = i$1;
		let cnt = 0;
		while (i$1 < this.scanlines.length) {
			const scanline = this.scanlines[i$1];
			if (scanline.right > right) {
				scanline.left = right;
				cnt = i$1 - first;
				if (scanline.left >= scanline.right) cnt++;
				break;
			}
			i$1++;
		}
		if (cnt > 0 && first < this.scanlines.length) this.scanlines.splice(first, cnt);
		return this.scanlines.length > 0;
	}
	intersect(left, right) {
		for (let i$1 = 0; i$1 < this.scanlines.length; i$1++) {
			const scanline = this.scanlines[i$1];
			if (scanline.left >= left || scanline.right >= left) {
				if (i$1 > 0) this.scanlines.splice(0, i$1);
				break;
			}
		}
		if (this.scanlines.length > 0) {
			let scanline = this.scanlines[0];
			if (scanline.left < left) scanline.left = left;
			for (let i$1 = 0; i$1 < this.scanlines.length; i$1++) {
				scanline = this.scanlines[i$1];
				if (scanline.left > right) {
					this.scanlines.splice(i$1, this.scanlines.length - i$1);
					break;
				}
			}
			if (this.scanlines.length > 0) {
				scanline = this.scanlines[this.scanlines.length - 1];
				if (scanline.right > right) scanline.right = right;
			}
		}
		return this.scanlines.length > 0;
	}
};
var ColorRef$1 = class ColorRef$1 {
	constructor(reader, r, g, b) {
		if (reader != null) {
			this.r = reader.readUint8();
			this.g = reader.readUint8();
			this.b = reader.readUint8();
			reader.skip(1);
		} else {
			this.r = r;
			this.g = g;
			this.b = b;
		}
	}
	clone() {
		return new ColorRef$1(null, this.r, this.g, this.b);
	}
	toHex() {
		return (16777216 + (this.r << 16 | this.g << 8 | this.b)).toString(16).slice(1);
	}
	toString() {
		return "{r: " + this.r + ", g: " + this.g + ", b: " + this.b + "}";
	}
};
var Font$1 = class Font$1 extends Obj$1 {
	constructor(reader, copy$1) {
		super("font");
		if (reader != null) {
			this.height = reader.readInt32();
			this.width = reader.readInt32();
			this.escapement = reader.readInt32();
			this.orientation = reader.readInt32();
			this.weight = reader.readInt32();
			this.italic = reader.readUint8();
			this.underline = reader.readUint8();
			this.strikeout = reader.readUint8();
			this.charset = reader.readUint8();
			this.outprecision = reader.readUint8();
			this.clipprecision = reader.readUint8();
			this.quality = reader.readUint8();
			const pitchAndFamily = reader.readUint8();
			this.pitch = pitchAndFamily & 15;
			this.family = pitchAndFamily >> 6 & 3;
			const dataLength = copy$1;
			const start = reader.pos;
			this.facename = reader.readFixedSizeUnicodeString(Math.min(dataLength - (reader.pos - start), 32));
		} else if (copy$1 != null) {
			copy$1 = copy$1;
			this.height = copy$1.height;
			this.width = copy$1.width;
			this.escapement = copy$1.escapement;
			this.orientation = copy$1.orientation;
			this.weight = copy$1.weight;
			this.italic = copy$1.italic;
			this.underline = copy$1.underline;
			this.strikeout = copy$1.strikeout;
			this.charset = copy$1.charset;
			this.outprecision = copy$1.outprecision;
			this.clipprecision = copy$1.clipprecision;
			this.quality = copy$1.quality;
			this.pitch = copy$1.pitch;
			this.family = copy$1.family;
			this.facename = copy$1.facename;
		} else {
			this.height = -80;
			this.width = 0;
			this.escapement = 0;
			this.orientation = 0;
			this.weight = 400;
			this.italic = 0;
			this.underline = 0;
			this.strikeout = 0;
			this.charset = 0;
			this.outprecision = 0;
			this.clipprecision = 0;
			this.quality = 0;
			this.pitch = 0;
			this.family = 0;
			this.facename = "Helvetica";
		}
	}
	clone() {
		return new Font$1(null, this);
	}
	toString() {
		return JSON.stringify(this);
	}
};
var Brush$1 = class Brush$1 extends Obj$1 {
	constructor(reader, copy$1) {
		super("brush");
		if (reader != null) {
			const start = reader.pos;
			this.style = reader.readUint32();
			switch (this.style) {
				case Helper$1.GDI.BrushStyle.BS_SOLID:
					this.color = new ColorRef$1(reader);
					break;
				case Helper$1.GDI.BrushStyle.BS_PATTERN:
					this.pattern = new DIBitmap$1(reader);
					break;
				case Helper$1.GDI.BrushStyle.BS_DIBPATTERNPT:
					this.dibpatternpt = new DIBitmap$1(reader);
					break;
				case Helper$1.GDI.BrushStyle.BS_HATCHED:
					this.color = new ColorRef$1(reader);
					this.hatchstyle = reader.readUint32();
					break;
			}
			reader.seek(start + 12);
		} else {
			this.style = copy$1.style;
			switch (this.style) {
				case Helper$1.GDI.BrushStyle.BS_SOLID:
					this.color = copy$1.color.clone();
					break;
				case Helper$1.GDI.BrushStyle.BS_PATTERN:
					this.pattern = copy$1.pattern;
					break;
				case Helper$1.GDI.BrushStyle.BS_DIBPATTERNPT:
					this.dibpatternpt = copy$1.dibpatternpt;
					break;
				case Helper$1.GDI.BrushStyle.BS_HATCHED:
					this.color = copy$1.color.clone();
					this.hatchstyle = copy$1.hatchstyle;
					break;
			}
		}
	}
	clone() {
		return new Brush$1(null, this);
	}
	toString() {
		let ret = "{style: " + this.style;
		switch (this.style) {
			case Helper$1.GDI.BrushStyle.BS_SOLID:
				ret += ", color: " + this.color.toString();
				break;
			case Helper$1.GDI.BrushStyle.BS_HATCHED:
				ret += ", color: " + this.color.toString() + ", hatchstyle: " + this.hatchstyle;
				break;
		}
		return ret + "}";
	}
};
var Pen$1 = class Pen$1 extends Obj$1 {
	constructor(reader, style, width, color, brush) {
		super("pen");
		if (reader != null) if (style != null) {
			this.style = reader.readUint32() & 255;
			this.width = reader.readUint32();
			this.brush = new Brush$1(reader);
			this.color = this.brush.color != null ? this.brush.color.clone() : new ColorRef$1(null, 0, 0, 0);
		} else {
			this.style = reader.readUint32() & 255;
			this.width = new PointL(reader).x;
			this.color = new ColorRef$1(reader);
		}
		else {
			this.style = style;
			this.width = width;
			if (color != null) this.color = color;
			if (brush != null) this.brush = brush;
		}
	}
	clone() {
		return new Pen$1(null, this.style, this.width, this.color != null ? this.color.clone() : null, this.brush != null ? this.brush.clone() : null);
	}
	toString() {
		return "{style: " + this.style + ", width: " + this.width + ", color: " + (this.color != null ? this.color.toString() : "none") + "}";
	}
};
var EmfHeader = class {
	constructor(reader, headerSize) {
		const recordStart = reader.pos - 8;
		this.size = headerSize;
		this.bounds = new RectL(reader);
		this.frame = new RectL(reader);
		if (reader.readUint32() !== Helper$1.GDI.FormatSignature.ENHMETA_SIGNATURE) throw new EMFJSError("Invalid header signature");
		reader.skip(4);
		reader.skip(4);
		reader.skip(4);
		reader.skip(2);
		reader.skip(2);
		const descriptionLen = reader.readUint32();
		const descriptionOff = reader.readUint32();
		this.nPalEntries = reader.readUint32();
		this.refDevCx = reader.readUint32();
		this.refDevCy = reader.readUint32();
		this.refDevCxMm = reader.readUint32();
		this.refDevCyMm = reader.readUint32();
		let hdrSize = headerSize;
		if (descriptionLen > 0) {
			if (descriptionOff < 88) throw new EMFJSError("Invalid header description offset");
			hdrSize = descriptionOff + descriptionLen * 2;
			if (hdrSize > headerSize) throw new EMFJSError("Invalid header description length");
			const prevPos = reader.pos;
			reader.seek(recordStart + descriptionOff);
			this.description = reader.readFixedSizeUnicodeString(descriptionLen);
			reader.seek(prevPos);
		} else this.description = "";
		if (hdrSize >= 100) {
			const pixelFormatSize = reader.readUint32();
			const pixelFormatOff = reader.readUint32();
			if (reader.readUint32() !== 0) throw new EMFJSError("OpenGL records are not yet supported");
			if (pixelFormatOff !== 0) {
				if (pixelFormatOff < 100 || pixelFormatOff < hdrSize) throw new EMFJSError("Invalid pixel format offset");
				hdrSize = pixelFormatOff + pixelFormatSize;
				if (hdrSize > headerSize) throw new EMFJSError("Invalid pixel format size");
			}
			if (hdrSize >= 108) {
				this.displayDevCxUm = reader.readUint32();
				this.displayDevCyUm = reader.readUint32();
			}
		}
	}
	getBounds() {
		return this.bounds;
	}
	toString() {
		return "{bounds: " + this.bounds.toString() + ", frame: " + this.frame.toString() + ", description: " + this.description + "}";
	}
};
var EMFRecords = class {
	constructor(reader, first) {
		this._records = [];
		this._header = new EmfHeader(reader, first);
		let all = false;
		let curpos = first;
		main_loop: while (!all) {
			reader.seek(curpos);
			const type = reader.readUint32();
			const size = reader.readUint32();
			if (size < 8) throw new EMFJSError("Invalid record size");
			switch (type) {
				case Helper$1.GDI.RecordType.EMR_EOF:
					all = true;
					break main_loop;
				case Helper$1.GDI.RecordType.EMR_SETMAPMODE: {
					const mapMode = reader.readInt32();
					this._records.push((gdi) => {
						gdi.setMapMode(mapMode);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETWINDOWORGEX: {
					const x = reader.readInt32();
					const y = reader.readInt32();
					this._records.push((gdi) => {
						gdi.setWindowOrgEx(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETWINDOWEXTEX: {
					const x = reader.readUint32();
					const y = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setWindowExtEx(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETVIEWPORTORGEX: {
					const x = reader.readInt32();
					const y = reader.readInt32();
					this._records.push((gdi) => {
						gdi.setViewportOrgEx(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETVIEWPORTEXTEX: {
					const x = reader.readUint32();
					const y = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setViewportExtEx(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SAVEDC:
					this._records.push((gdi) => {
						gdi.saveDC();
					});
					break;
				case Helper$1.GDI.RecordType.EMR_RESTOREDC: {
					const saved = reader.readInt32();
					this._records.push((gdi) => {
						gdi.restoreDC(saved);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETBKMODE: {
					const bkMode = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setBkMode(bkMode);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETBKCOLOR: {
					const bkColor = new ColorRef$1(reader);
					this._records.push((gdi) => {
						gdi.setBkColor(bkColor);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_CREATEBRUSHINDIRECT: {
					const index = reader.readUint32();
					const brush = new Brush$1(reader);
					this._records.push((gdi) => {
						gdi.createBrush(index, brush);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_CREATEPEN: {
					const index = reader.readUint32();
					const pen = new Pen$1(reader, null);
					this._records.push((gdi) => {
						gdi.createPen(index, pen);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_EXTCREATEPEN: {
					const index = reader.readUint32();
					const offBmi = reader.readUint32();
					const cbBmi = reader.readUint32();
					const offBits = reader.readUint32();
					const cbBits = reader.readUint32();
					const pen = new Pen$1(reader, {
						header: {
							off: curpos + offBmi,
							size: cbBmi
						},
						data: {
							off: curpos + offBits,
							size: cbBits
						}
					});
					this._records.push((gdi) => {
						gdi.createPen(index, pen);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SELECTOBJECT: {
					const idx = reader.readUint32();
					this._records.push((gdi) => {
						gdi.selectObject(idx, null);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_DELETEOBJECT: {
					const idx = reader.readUint32();
					this._records.push((gdi) => {
						gdi.deleteObject(idx);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_RECTANGLE: {
					const rect = new RectL(reader);
					this._records.push((gdi) => {
						gdi.rectangle(rect, 0, 0);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_ROUNDRECT: {
					const rect = new RectL(reader);
					const corner = new SizeL(reader);
					this._records.push((gdi) => {
						gdi.rectangle(rect, corner.cx, corner.cy);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_LINETO: {
					const x = reader.readInt32();
					const y = reader.readInt32();
					this._records.push((gdi) => {
						gdi.lineTo(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_MOVETOEX: {
					const x = reader.readInt32();
					const y = reader.readInt32();
					this._records.push((gdi) => {
						gdi.moveToEx(x, y);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYGON:
				case Helper$1.GDI.RecordType.EMR_POLYGON16: {
					const isSmall = type === Helper$1.GDI.RecordType.EMR_POLYGON16;
					const bounds = new RectL(reader);
					let cnt = reader.readUint32();
					const points = [];
					while (cnt > 0) {
						points.push(isSmall ? new PointS$1(reader) : new PointL(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polygon(points, bounds, true);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYPOLYGON:
				case Helper$1.GDI.RecordType.EMR_POLYPOLYGON16: {
					const isSmall = type === Helper$1.GDI.RecordType.EMR_POLYPOLYGON16;
					const bounds = new RectL(reader);
					const polyCnt = reader.readUint32();
					reader.skip(4);
					const polygonsPtCnts = [];
					for (let i$1 = 0; i$1 < polyCnt; i$1++) polygonsPtCnts.push(reader.readUint32());
					const polygons = [];
					for (let i$1 = 0; i$1 < polyCnt; i$1++) {
						const ptCnt = polygonsPtCnts[i$1];
						const p = [];
						for (let ip = 0; ip < ptCnt; ip++) p.push(isSmall ? new PointS$1(reader) : new PointL(reader));
						polygons.push(p);
					}
					this._records.push((gdi) => {
						gdi.polyPolygon(polygons, bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETPOLYFILLMODE: {
					const polyfillmode = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setPolyFillMode(polyfillmode);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYLINE16:
				case Helper$1.GDI.RecordType.EMR_POLYLINETO16: {
					const isLineTo = type === Helper$1.GDI.RecordType.EMR_POLYLINETO16;
					const bounds = new RectL(reader);
					let cnt = reader.readUint32();
					const points = [];
					while (cnt > 0) {
						points.push(new PointS$1(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polyline(isLineTo, points, bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYBEZIER:
				case Helper$1.GDI.RecordType.EMR_POLYBEZIERTO: {
					const isPolyBezierTo = type === Helper$1.GDI.RecordType.EMR_POLYBEZIERTO;
					const bounds = new RectL(reader);
					let cnt = reader.readUint32();
					const points = [];
					while (cnt > 0) {
						points.push(new PointL(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polybezier(isPolyBezierTo, points, bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYBEZIER16: {
					const bounds = new RectL(reader);
					const start = new PointL(reader);
					let cnt = reader.readUint32();
					const points = [start];
					while (cnt > 0) {
						points.push(new PointS$1(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polybezier(false, points, bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYBEZIERTO16: {
					const bounds = new RectL(reader);
					let cnt = reader.readUint32();
					const points = [];
					while (cnt > 0) {
						points.push(new PointS$1(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polybezier(true, points, bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETTEXTALIGN: {
					const textAlign = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setTextAlign(textAlign);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETSTRETCHBLTMODE: {
					const stretchMode = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setStretchBltMode(stretchMode);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETBRUSHORGEX: {
					const origin = new PointL(reader);
					this._records.push((gdi) => {
						gdi.setBrushOrgEx(origin);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_BEGINPATH:
					this._records.push((gdi) => {
						gdi.beginPath();
					});
					break;
				case Helper$1.GDI.RecordType.EMR_ENDPATH:
					this._records.push((gdi) => {
						gdi.endPath();
					});
					break;
				case Helper$1.GDI.RecordType.EMR_ABORTPATH:
					this._records.push((gdi) => {
						gdi.abortPath();
					});
					break;
				case Helper$1.GDI.RecordType.EMR_CLOSEFIGURE:
					this._records.push((gdi) => {
						gdi.closeFigure();
					});
					break;
				case Helper$1.GDI.RecordType.EMR_FILLPATH: {
					const bounds = new RectL(reader);
					this._records.push((gdi) => {
						gdi.fillPath(bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_STROKEPATH: {
					const bounds = new RectL(reader);
					this._records.push((gdi) => {
						gdi.strokePath(bounds);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SELECTCLIPPATH: {
					const rgnMode = reader.readUint32();
					this._records.push((gdi) => {
						gdi.selectClipPath(rgnMode);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_EXTSELECTCLIPRGN: {
					reader.skip(4);
					const rgnMode = reader.readUint32();
					const region = rgnMode !== Helper$1.GDI.RegionMode.RGN_COPY ? new Region$1(reader) : null;
					this._records.push((gdi) => {
						gdi.selectClipRgn(rgnMode, region);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_OFFSETCLIPRGN: {
					const offset = new PointL(reader);
					this._records.push((gdi) => {
						gdi.offsetClipRgn(offset);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_SETMITERLIMIT: {
					const miterLimit = reader.readUint32();
					this._records.push((gdi) => {
						gdi.setMiterLimit(miterLimit);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_STRETCHDIBITS: {
					new RectL(reader);
					const xDest = reader.readInt32();
					const yDest = reader.readInt32();
					const xSrc = reader.readInt32();
					const ySrc = reader.readInt32();
					const cxSrc = reader.readInt32();
					const cySrc = reader.readInt32();
					const offBmiSrc = reader.readUint32();
					const cbBmiSrc = reader.readUint32();
					const offBitsSrc = reader.readUint32();
					const cbBitsSrc = reader.readUint32();
					const iUsageSrc = reader.readUint32();
					const dwRop = reader.readUint32();
					const cxDest = reader.readInt32();
					const cyDest = reader.readInt32();
					const dib = new DIBitmap$1(reader, {
						header: {
							off: curpos + offBmiSrc,
							size: cbBmiSrc
						},
						data: {
							off: curpos + offBitsSrc,
							size: cbBitsSrc
						}
					});
					this._records.push((gdi) => {
						gdi.stretchDibBits(xSrc, ySrc, cxSrc, cySrc, xDest, yDest, cxDest, cyDest, dwRop, iUsageSrc, dib);
					});
					break;
				}
				case Helper$1.GDI.RecordType.EMR_POLYLINE:
				case Helper$1.GDI.RecordType.EMR_POLYLINETO:
				case Helper$1.GDI.RecordType.EMR_POLYPOLYLINE:
				case Helper$1.GDI.RecordType.EMR_SETPIXELV:
				case Helper$1.GDI.RecordType.EMR_SETMAPPERFLAGS:
				case Helper$1.GDI.RecordType.EMR_SETROP2:
				case Helper$1.GDI.RecordType.EMR_SETCOLORADJUSTMENT:
				case Helper$1.GDI.RecordType.EMR_SETTEXTCOLOR:
				case Helper$1.GDI.RecordType.EMR_SETMETARGN:
				case Helper$1.GDI.RecordType.EMR_EXCLUDECLIPRECT:
				case Helper$1.GDI.RecordType.EMR_INTERSECTCLIPRECT:
				case Helper$1.GDI.RecordType.EMR_SCALEVIEWPORTEXTEX:
				case Helper$1.GDI.RecordType.EMR_SCALEWINDOWEXTEX:
				case Helper$1.GDI.RecordType.EMR_SETWORLDTRANSFORM:
				case Helper$1.GDI.RecordType.EMR_MODIFYWORLDTRANSFORM:
				case Helper$1.GDI.RecordType.EMR_ANGLEARC:
				case Helper$1.GDI.RecordType.EMR_ELLIPSE:
				case Helper$1.GDI.RecordType.EMR_ARC:
				case Helper$1.GDI.RecordType.EMR_CHORD:
				case Helper$1.GDI.RecordType.EMR_PIE:
				case Helper$1.GDI.RecordType.EMR_SELECTPALETTE:
				case Helper$1.GDI.RecordType.EMR_CREATEPALETTE:
				case Helper$1.GDI.RecordType.EMR_SETPALETTEENTRIES:
				case Helper$1.GDI.RecordType.EMR_RESIZEPALETTE:
				case Helper$1.GDI.RecordType.EMR_REALIZEPALETTE:
				case Helper$1.GDI.RecordType.EMR_EXTFLOODFILL:
				case Helper$1.GDI.RecordType.EMR_ARCTO:
				case Helper$1.GDI.RecordType.EMR_POLYDRAW:
				case Helper$1.GDI.RecordType.EMR_SETARCDIRECTION:
				case Helper$1.GDI.RecordType.EMR_STROKEANDFILLPATH:
				case Helper$1.GDI.RecordType.EMR_FLATTENPATH:
				case Helper$1.GDI.RecordType.EMR_WIDENPATH:
				case Helper$1.GDI.RecordType.EMR_COMMENT:
				case Helper$1.GDI.RecordType.EMR_FILLRGN:
				case Helper$1.GDI.RecordType.EMR_FRAMERGN:
				case Helper$1.GDI.RecordType.EMR_INVERTRGN:
				case Helper$1.GDI.RecordType.EMR_PAINTRGN:
				case Helper$1.GDI.RecordType.EMR_BITBLT:
				case Helper$1.GDI.RecordType.EMR_STRETCHBLT:
				case Helper$1.GDI.RecordType.EMR_MASKBLT:
				case Helper$1.GDI.RecordType.EMR_PLGBLT:
				case Helper$1.GDI.RecordType.EMR_SETDIBITSTODEVICE:
				case Helper$1.GDI.RecordType.EMR_EXTCREATEFONTINDIRECTW:
				case Helper$1.GDI.RecordType.EMR_EXTTEXTOUTA:
				case Helper$1.GDI.RecordType.EMR_EXTTEXTOUTW:
				case Helper$1.GDI.RecordType.EMR_POLYPOLYLINE16:
				case Helper$1.GDI.RecordType.EMR_POLYDRAW16:
				case Helper$1.GDI.RecordType.EMR_CREATEMONOBRUSH:
				case Helper$1.GDI.RecordType.EMR_CREATEDIBPATTERNBRUSHPT:
				case Helper$1.GDI.RecordType.EMR_POLYTEXTOUTA:
				case Helper$1.GDI.RecordType.EMR_POLYTEXTOUTW:
				case Helper$1.GDI.RecordType.EMR_SETICMMODE:
				case Helper$1.GDI.RecordType.EMR_CREATECOLORSPACE:
				case Helper$1.GDI.RecordType.EMR_SETCOLORSPACE:
				case Helper$1.GDI.RecordType.EMR_DELETECOLORSPACE:
				case Helper$1.GDI.RecordType.EMR_GLSRECORD:
				case Helper$1.GDI.RecordType.EMR_GLSBOUNDEDRECORD:
				case Helper$1.GDI.RecordType.EMR_PIXELFORMAT:
				case Helper$1.GDI.RecordType.EMR_DRAWESCAPE:
				case Helper$1.GDI.RecordType.EMR_EXTESCAPE:
				case Helper$1.GDI.RecordType.EMR_SMALLTEXTOUT:
				case Helper$1.GDI.RecordType.EMR_FORCEUFIMAPPING:
				case Helper$1.GDI.RecordType.EMR_NAMEDESCAPE:
				case Helper$1.GDI.RecordType.EMR_COLORCORRECTPALETTE:
				case Helper$1.GDI.RecordType.EMR_SETICMPROFILEA:
				case Helper$1.GDI.RecordType.EMR_SETICMPROFILEW:
				case Helper$1.GDI.RecordType.EMR_ALPHABLEND:
				case Helper$1.GDI.RecordType.EMR_SETLAYOUT:
				case Helper$1.GDI.RecordType.EMR_TRANSPARENTBLT:
				case Helper$1.GDI.RecordType.EMR_GRADIENTFILL:
				case Helper$1.GDI.RecordType.EMR_SETLINKEDUFIS:
				case Helper$1.GDI.RecordType.EMR_SETTEXTJUSTIFICATION:
				case Helper$1.GDI.RecordType.EMR_COLORMATCHTOTARGETW:
				case Helper$1.GDI.RecordType.EMR_CREATECOLORSPACEW:
				default: {
					let recordName = "UNKNOWN";
					for (const name in Helper$1.GDI.RecordType) if (Helper$1.GDI.RecordType[name] === type) {
						recordName = name;
						break;
					}
					Helper$1.log("[EMF] " + recordName + " record (0x" + type.toString(16) + ") at offset 0x" + curpos.toString(16) + " with " + size + " bytes");
					break;
				}
			}
			curpos += size;
		}
		if (!all) throw new EMFJSError("Could not read all records");
	}
	getBounds() {
		return this._header.getBounds();
	}
	play(gdi) {
		const len = this._records.length;
		for (let i$1 = 0; i$1 < len; i$1++) this._records[i$1](gdi);
	}
};
var Path = class Path extends Obj$1 {
	constructor(svgPath, copy$1) {
		super("path");
		if (svgPath != null) this.svgPath = svgPath;
		else this.svgPath = copy$1.svgPath;
	}
	clone() {
		return new Path(null, this);
	}
	toString() {
		return "{[path]}";
	}
};
function createStockObjects() {
	const createSolidBrush = (r, g, b) => {
		return new Brush$1(null, {
			style: Helper$1.GDI.BrushStyle.BS_SOLID,
			color: new ColorRef$1(null, r, g, b)
		});
	};
	const createSolidPen = (r, g, b) => {
		return new Pen$1(null, Helper$1.GDI.PenStyle.PS_SOLID, 1, new ColorRef$1(null, r, g, b), null);
	};
	const stockObjs = {
		WHITE_BRUSH: createSolidBrush(255, 255, 255),
		LTGRAY_BRUSH: createSolidBrush(212, 208, 200),
		GRAY_BRUSH: createSolidBrush(128, 128, 128),
		DKGRAY_BRUSH: createSolidBrush(64, 64, 64),
		BLACK_BRUSH: createSolidBrush(0, 0, 0),
		NULL_BRUSH: new Brush$1(null, { style: Helper$1.GDI.BrushStyle.BS_NULL }),
		WHITE_PEN: createSolidPen(255, 255, 255),
		BLACK_PEN: createSolidPen(0, 0, 0),
		NULL_PEN: new Pen$1(null, Helper$1.GDI.PenStyle.PS_NULL, 0, null, null),
		OEM_FIXED_FONT: null,
		ANSI_FIXED_FONT: null,
		ANSI_VAR_FONT: null,
		SYSTEM_FONT: null,
		DEVICE_DEFAULT_FONT: null,
		DEFAULT_PALETTE: null,
		SYSTEM_FIXED_FONT: null,
		DEFAULT_GUI_FONT: null
	};
	const objs = {};
	for (const t in stockObjs) {
		const idx = Helper$1.GDI.StockObject[t] - 2147483648;
		objs[idx.toString()] = stockObjs[t];
	}
	return objs;
}
var _StockObjects = createStockObjects();
var GDIContextState$1 = class {
	constructor(copy$1, defObjects) {
		if (copy$1 != null) {
			this._svggroup = copy$1._svggroup;
			this._svgclipChanged = copy$1._svgclipChanged;
			this._svgtextbkfilter = copy$1._svgtextbkfilter;
			this.mapmode = copy$1.mapmode;
			this.stretchmode = copy$1.stretchmode;
			this.textalign = copy$1.textalign;
			this.bkmode = copy$1.bkmode;
			this.textcolor = copy$1.textcolor.clone();
			this.bkcolor = copy$1.bkcolor.clone();
			this.polyfillmode = copy$1.polyfillmode;
			this.miterlimit = copy$1.miterlimit;
			this.wx = copy$1.wx;
			this.wy = copy$1.wy;
			this.ww = copy$1.ww;
			this.wh = copy$1.wh;
			this.vx = copy$1.vx;
			this.vy = copy$1.vy;
			this.vw = copy$1.vw;
			this.vh = copy$1.vh;
			this.x = copy$1.x;
			this.y = copy$1.y;
			this.nextbrx = copy$1.nextbrx;
			this.nextbry = copy$1.nextbry;
			this.brx = copy$1.brx;
			this.bry = copy$1.bry;
			this.clip = copy$1.clip;
			this.ownclip = false;
			this.selected = {};
			for (const type in copy$1.selected) this.selected[type] = copy$1.selected[type];
		} else {
			this._svggroup = null;
			this._svgclipChanged = false;
			this._svgtextbkfilter = null;
			this.mapmode = Helper$1.GDI.MapMode.MM_ANISOTROPIC;
			this.stretchmode = Helper$1.GDI.StretchMode.COLORONCOLOR;
			this.textalign = 0;
			this.bkmode = Helper$1.GDI.MixMode.OPAQUE;
			this.textcolor = new ColorRef$1(null, 0, 0, 0);
			this.bkcolor = new ColorRef$1(null, 255, 255, 255);
			this.polyfillmode = Helper$1.GDI.PolygonFillMode.ALTERNATE;
			this.miterlimit = 10;
			this.wx = 0;
			this.wy = 0;
			this.ww = 0;
			this.wh = 0;
			this.vx = 0;
			this.vy = 0;
			this.vw = 0;
			this.vh = 0;
			this.x = 0;
			this.y = 0;
			this.nextbrx = 0;
			this.nextbry = 0;
			this.brx = 0;
			this.bry = 0;
			this.clip = null;
			this.ownclip = false;
			this.selected = {};
			for (const type in defObjects) {
				const defObj = defObjects[type];
				this.selected[type] = defObj != null ? defObj.clone() : null;
			}
		}
	}
};
var GDIContext$1 = class {
	constructor(svg) {
		this._svg = svg;
		this._svgdefs = null;
		this._svgPatterns = {};
		this._svgClipPaths = {};
		this._svgPath = null;
		this.defObjects = {
			brush: new Brush$1(null, {
				style: Helper$1.GDI.BrushStyle.BS_SOLID,
				color: new ColorRef$1(null, 0, 0, 0)
			}),
			pen: new Pen$1(null, Helper$1.GDI.PenStyle.PS_SOLID, 1, new ColorRef$1(null, 0, 0, 0), null),
			font: new Font$1(null, null),
			palette: null,
			region: null
		};
		this.state = new GDIContextState$1(null, this.defObjects);
		this.statestack = [this.state];
		this.objects = {};
	}
	setMapMode(mode) {
		Helper$1.log("[gdi] setMapMode: mode=" + mode);
		this.state.mapmode = mode;
		this.state._svggroup = null;
	}
	getMapMode() {
		return this.state.mapmode;
	}
	setWindowOrgEx(x, y) {
		Helper$1.log("[gdi] setWindowOrgEx: x=" + x + " y=" + y);
		this.state.wx = x;
		this.state.wy = y;
		this.state._svggroup = null;
	}
	setWindowExtEx(x, y) {
		Helper$1.log("[gdi] setWindowExtEx: x=" + x + " y=" + y);
		this.state.ww = x;
		this.state.wh = y;
		this.state._svggroup = null;
	}
	setViewportOrgEx(x, y) {
		Helper$1.log("[gdi] setViewportOrgEx: x=" + x + " y=" + y);
		this.state.vx = x;
		this.state.vy = y;
		this.state._svggroup = null;
	}
	setViewportExtEx(x, y) {
		Helper$1.log("[gdi] setViewportExtEx: x=" + x + " y=" + y);
		this.state.vw = x;
		this.state.vh = y;
		this.state._svggroup = null;
	}
	setBrushOrgEx(origin) {
		Helper$1.log("[gdi] setBrushOrgEx: x=" + origin.x + " y=" + origin.y);
		this.state.nextbrx = origin.x;
		this.state.nextbry = origin.y;
	}
	saveDC() {
		Helper$1.log("[gdi] saveDC");
		const prevstate = this.state;
		this.state = new GDIContextState$1(this.state);
		this.statestack.push(prevstate);
		this.state._svggroup = null;
	}
	restoreDC(saved) {
		Helper$1.log("[gdi] restoreDC: saved=" + saved);
		if (this.statestack.length > 1) {
			if (saved === -1) this.state = this.statestack.pop();
			else if (saved < -1) throw new EMFJSError("restoreDC: relative restore not implemented");
			else if (saved > 1) throw new EMFJSError("restoreDC: absolute restore not implemented");
		} else throw new EMFJSError("No saved contexts");
		this.state._svggroup = null;
	}
	setStretchBltMode(stretchMode) {
		Helper$1.log("[gdi] setStretchBltMode: stretchMode=" + stretchMode);
	}
	stretchDibBits(srcX, srcY, srcW, srcH, dstX, dstY, dstW, dstH, rasterOp, colorUsage, dib) {
		Helper$1.log("[gdi] stretchDibBits: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16));
		srcX = this._todevX(srcX);
		srcY = this._todevY(srcY);
		srcW = this._todevW(srcW);
		srcH = this._todevH(srcH);
		dstX = this._todevX(dstX);
		dstY = this._todevY(dstY);
		dstW = this._todevW(dstW);
		dstH = this._todevH(dstH);
		Helper$1.log("[gdi] stretchDibBits: TRANSLATED: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16));
		this._pushGroup();
		this._svg.image(this.state._svggroup, dstX, dstY, dstW, dstH, dib.base64ref());
	}
	rectangle(rect, rw, rh) {
		Helper$1.log("[gdi] rectangle: rect=" + rect.toString() + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const bottom = this._todevY(rect.bottom);
		const right = this._todevX(rect.right);
		const top = this._todevY(rect.top);
		const left = this._todevX(rect.left);
		rw = this._todevH(rw);
		rh = this._todevH(rh);
		Helper$1.log("[gdi] rectangle: TRANSLATED: bottom=" + bottom + " right=" + right + " top=" + top + " left=" + left + " rh=" + rh + " rw=" + rw);
		this._pushGroup();
		const opts = this._applyOpts(null, true, true, false);
		this._svg.rect(this.state._svggroup, left, top, right - left, bottom - top, rw / 2, rh / 2, opts);
	}
	lineTo(x, y) {
		Helper$1.log("[gdi] lineTo: x=" + x + " y=" + y + " with pen " + this.state.selected.pen.toString());
		const toX = this._todevX(x);
		const toY = this._todevY(y);
		const fromX = this._todevX(this.state.x);
		const fromY = this._todevY(this.state.y);
		this.state.x = x;
		this.state.y = y;
		Helper$1.log("[gdi] lineTo: TRANSLATED: toX=" + toX + " toY=" + toY + " fromX=" + fromX + " fromY=" + fromY);
		this._pushGroup();
		const opts = this._applyOpts(null, true, false, false);
		this._svg.line(this.state._svggroup, fromX, fromY, toX, toY, opts);
	}
	moveToEx(x, y) {
		Helper$1.log("[gdi] moveToEx: x=" + x + " y=" + y);
		this.state.x = x;
		this.state.y = y;
		if (this._svgPath != null) {
			this._svgPath.move(this.state.x, this.state.y);
			Helper$1.log("[gdi] new path: " + this._svgPath.path());
		}
	}
	polygon(points, bounds, first) {
		Helper$1.log("[gdi] polygon: points=" + points + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const pts = [];
		for (let i$1 = 0; i$1 < points.length; i$1++) {
			const point$1 = points[i$1];
			pts.push([this._todevX(point$1.x), this._todevY(point$1.y)]);
		}
		if (first) this._pushGroup();
		const opts = { "fill-rule": this.state.polyfillmode === Helper$1.GDI.PolygonFillMode.ALTERNATE ? "evenodd" : "nonzero" };
		this._applyOpts(opts, true, true, false);
		this._svg.polygon(this.state._svggroup, pts, opts);
	}
	polyPolygon(polygons, bounds) {
		Helper$1.log("[gdi] polyPolygon: polygons.length=" + polygons.length + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const cnt = polygons.length;
		for (let i$1 = 0; i$1 < cnt; i$1++) this.polygon(polygons[i$1], bounds, i$1 === 0);
	}
	polyline(isLineTo, points, bounds) {
		Helper$1.log("[gdi] polyline: isLineTo=" + isLineTo.toString() + ", points=" + points + ", bounds=" + bounds.toString() + " with pen " + this.state.selected.pen.toString());
		const pts = [];
		for (let i$1 = 0; i$1 < points.length; i$1++) {
			const point$1 = points[i$1];
			pts.push([this._todevX(point$1.x), this._todevY(point$1.y)]);
		}
		if (this._svgPath != null) {
			if (!isLineTo || pts.length === 0) this._svgPath.move(this._todevX(this.state.x), this._todevY(this.state.y));
			else {
				const firstPts = pts[0];
				this._svgPath.move(firstPts[0], firstPts[1]);
			}
			this._svgPath.line(pts);
			Helper$1.log("[gdi] new path: " + this._svgPath.path());
		} else {
			this._pushGroup();
			const opts = this._applyOpts(null, true, false, false);
			if (isLineTo && points.length > 0) {
				const firstPt = points[0];
				if (firstPt.x !== this.state.x || firstPt.y !== this.state.y) pts.unshift([this._todevX(this.state.x), this._todevY(this.state.y)]);
			}
			this._svg.polyline(this.state._svggroup, pts, opts);
		}
		if (points.length > 0) {
			const lastPt = points[points.length - 1];
			this.state.x = lastPt.x;
			this.state.y = lastPt.y;
		}
	}
	polybezier(isPolyBezierTo, points, bounds) {
		Helper$1.log("[gdi] polybezier: isPolyBezierTo=" + isPolyBezierTo.toString() + ", points=" + points + ", bounds=" + bounds.toString() + " with pen " + this.state.selected.pen.toString());
		const pts = [];
		for (let i$1 = 0; i$1 < points.length; i$1++) {
			const point$1 = points[i$1];
			pts.push({
				x: this._todevX(point$1.x),
				y: this._todevY(point$1.y)
			});
		}
		if (this._svgPath != null) {
			if (isPolyBezierTo && pts.length > 0) {
				const firstPts = pts[0];
				this._svgPath.move(firstPts.x, firstPts.y);
			} else this._svgPath.move(this._todevX(this.state.x), this._todevY(this.state.y));
			if (pts.length < (isPolyBezierTo ? 3 : 4)) throw new EMFJSError("Not enough points to draw bezier");
			for (let i$1 = isPolyBezierTo ? 1 : 0; i$1 + 3 <= pts.length; i$1 += 3) {
				const cp1 = pts[i$1];
				const cp2 = pts[i$1 + 1];
				const ep = pts[i$1 + 2];
				this._svgPath.curveC(cp1.x, cp1.y, cp2.x, cp2.y, ep.x, ep.y);
			}
			Helper$1.log("[gdi] new path: " + this._svgPath.path());
		} else throw new EMFJSError("polybezier not implemented (not a path)");
		if (points.length > 0) {
			const lastPt = points[points.length - 1];
			this.state.x = lastPt.x;
			this.state.y = lastPt.y;
		}
	}
	selectClipPath(rgnMode) {
		Helper$1.log("[gdi] selectClipPath: rgnMode=0x" + rgnMode.toString(16));
	}
	selectClipRgn(rgnMode, region) {
		Helper$1.log("[gdi] selectClipRgn: rgnMode=0x" + rgnMode.toString(16));
		if (rgnMode === Helper$1.GDI.RegionMode.RGN_COPY) {
			this.state.selected.region = region;
			this.state.clip = null;
			this.state.ownclip = false;
		} else {
			if (region == null) throw new EMFJSError("No clip region to select");
			throw new EMFJSError("Not implemented: rgnMode=0x" + rgnMode.toString(16));
		}
		this.state._svgclipChanged = true;
	}
	offsetClipRgn(offset) {
		Helper$1.log("[gdi] offsetClipRgn: offset=" + offset.toString());
		this._getClipRgn().offset(offset.x, offset.y);
	}
	setTextAlign(textAlignmentMode) {
		Helper$1.log("[gdi] setTextAlign: textAlignmentMode=0x" + textAlignmentMode.toString(16));
		this.state.textalign = textAlignmentMode;
	}
	setMiterLimit(miterLimit) {
		Helper$1.log("[gdi] setMiterLimit: miterLimit=" + miterLimit);
		this.state.miterlimit = miterLimit;
	}
	setBkMode(bkMode) {
		Helper$1.log("[gdi] setBkMode: bkMode=0x" + bkMode.toString(16));
		this.state.bkmode = bkMode;
	}
	setBkColor(bkColor) {
		Helper$1.log("[gdi] setBkColor: bkColor=" + bkColor.toString());
		this.state.bkcolor = bkColor;
		this.state._svgtextbkfilter = null;
	}
	setPolyFillMode(polyFillMode) {
		Helper$1.log("[gdi] setPolyFillMode: polyFillMode=" + polyFillMode);
		this.state.polyfillmode = polyFillMode;
	}
	createBrush(index, brush) {
		const idx = this._storeObject(brush, index);
		Helper$1.log("[gdi] createBrush: brush=" + brush.toString() + " with handle " + idx);
	}
	createPen(index, pen) {
		const idx = this._storeObject(pen, index);
		Helper$1.log("[gdi] createPen: pen=" + pen.toString() + " width handle " + idx);
	}
	createPenEx(index, pen) {
		const idx = this._storeObject(pen, index);
		Helper$1.log("[gdi] createPenEx: pen=" + pen.toString() + " width handle " + idx);
	}
	selectObject(objIdx, checkType) {
		const obj = this._getObject(objIdx);
		if (obj != null && (checkType == null || obj.type === checkType)) {
			this._selectObject(obj);
			Helper$1.log("[gdi] selectObject: objIdx=" + objIdx + (obj ? " selected " + obj.type + ": " + obj.toString() : "[invalid index]"));
		} else Helper$1.log("[gdi] selectObject: objIdx=" + objIdx + (obj ? " invalid object type: " + obj.type : "[invalid index]"));
	}
	abortPath() {
		Helper$1.log("[gdi] abortPath");
		if (this._svgPath != null) this._svgPath = null;
	}
	beginPath() {
		Helper$1.log("[gdi] beginPath");
		if (this._svgPath != null) this._svgPath = null;
		this._svgPath = this._svg.createPath();
	}
	closeFigure() {
		Helper$1.log("[gdi] closeFigure");
		if (this._svgPath == null) throw new EMFJSError("No path bracket: cannot close figure");
		this._svgPath.close();
	}
	fillPath(bounds) {
		Helper$1.log("[gdi] fillPath");
		if (this.state.selected.path == null) throw new EMFJSError("No path selected");
		const selPath = this.state.selected.path;
		const opts = this._applyOpts(null, true, true, false);
		this._svg.path(this.state._svggroup, selPath.svgPath, opts);
		this._pushGroup();
		this.state.selected.path = null;
	}
	strokePath(bounds) {
		Helper$1.log("[gdi] strokePath");
		if (this.state.selected.path == null) throw new EMFJSError("No path selected");
		const selPath = this.state.selected.path;
		const opts = this._applyOpts({ fill: "none" }, true, false, false);
		this._svg.path(this.state._svggroup, selPath.svgPath, opts);
		this._pushGroup();
		this.state.selected.path = null;
	}
	endPath() {
		Helper$1.log("[gdi] endPath");
		if (this._svgPath == null) throw new EMFJSError("No path bracket: cannot end path");
		this._pushGroup();
		this._selectObject(new Path(this._svgPath));
		this._svgPath = null;
	}
	deleteObject(objIdx) {
		const ret = this._deleteObject(objIdx);
		Helper$1.log("[gdi] deleteObject: objIdx=" + objIdx + (ret ? " deleted object" : "[invalid index]"));
	}
	_pushGroup() {
		if (this.state._svggroup == null || this.state._svgclipChanged) {
			this.state._svgclipChanged = false;
			this.state._svgtextbkfilter = null;
			const settings = {
				viewBox: [
					this.state.vx,
					this.state.vy,
					this.state.vw,
					this.state.vh
				].join(" "),
				preserveAspectRatio: "none"
			};
			if (this.state.clip != null) {
				Helper$1.log("[gdi] new svg x=" + this.state.vx + " y=" + this.state.vy + " width=" + this.state.vw + " height=" + this.state.vh + " with clipping");
				settings["clip-path"] = "url(#" + this._getSvgClipPathForRegion(this.state.clip) + ")";
			} else Helper$1.log("[gdi] new svg x=" + this.state.vx + " y=" + this.state.vy + " width=" + this.state.vw + " height=" + this.state.vh + " without clipping");
			this.state._svggroup = this._svg.svg(this.state._svggroup, this.state.vx, this.state.vy, this.state.vw, this.state.vh, settings);
		}
	}
	_getStockObject(idx) {
		if (idx >= 2147483648 && idx <= 2147483665) return _StockObjects[(idx - 2147483648).toString()];
		else if (idx === Helper$1.GDI.StockObject.DC_BRUSH) return this.state.selected.brush;
		else if (idx === Helper$1.GDI.StockObject.DC_PEN) return this.state.selected.pen;
		return null;
	}
	_storeObject(obj, idx) {
		if (!idx) {
			idx = 0;
			while (this.objects[idx.toString()] != null && idx <= 65535) idx++;
			if (idx > 65535) {
				Helper$1.log("[gdi] Too many objects!");
				return -1;
			}
		}
		this.objects[idx.toString()] = obj;
		return idx;
	}
	_getObject(objIdx) {
		let obj = this.objects[objIdx.toString()];
		if (obj == null) {
			obj = this._getStockObject(objIdx);
			if (obj == null) Helper$1.log("[gdi] No object with handle " + objIdx);
		}
		return obj;
	}
	_getSvgDef() {
		if (this._svgdefs == null) this._svgdefs = this._svg.defs();
		return this._svgdefs;
	}
	_getSvgClipPathForRegion(region) {
		for (const existingId in this._svgClipPaths) if (this._svgClipPaths[existingId] === region) return existingId;
		const id = Helper$1._makeUniqueId("c");
		const sclip = this._svg.clipPath(this._getSvgDef(), id, "userSpaceOnUse");
		switch (region.complexity) {
			case 1:
				this._svg.rect(sclip, this._todevX(region.bounds.left), this._todevY(region.bounds.top), this._todevW(region.bounds.right - region.bounds.left), this._todevH(region.bounds.bottom - region.bounds.top), {
					fill: "black",
					"stroke-width": 0
				});
				break;
			case 2:
				for (let i$1 = 0; i$1 < region.scans.length; i$1++) {
					const scan = region.scans[i$1];
					for (let j = 0; j < scan.scanlines.length; j++) {
						const scanline = scan.scanlines[j];
						this._svg.rect(sclip, this._todevX(scanline.left), this._todevY(scan.top), this._todevW(scanline.right - scanline.left), this._todevH(scan.bottom - scan.top), {
							fill: "black",
							"stroke-width": 0
						});
					}
				}
				break;
		}
		this._svgClipPaths[id] = region;
		return id;
	}
	_getSvgPatternForBrush(brush) {
		for (const existingId in this._svgPatterns) if (this._svgPatterns[existingId] === brush) return existingId;
		let width;
		let height;
		let img;
		switch (brush.style) {
			case Helper$1.GDI.BrushStyle.BS_PATTERN:
				width = brush.pattern.getWidth();
				height = brush.pattern.getHeight();
				break;
			case Helper$1.GDI.BrushStyle.BS_DIBPATTERNPT:
				width = brush.dibpatternpt.getWidth();
				height = brush.dibpatternpt.getHeight();
				img = brush.dibpatternpt.base64ref();
				break;
			default: throw new EMFJSError("Invalid brush style");
		}
		const id = Helper$1._makeUniqueId("p");
		const spat = this._svg.pattern(this._getSvgDef(), id, this.state.brx, this.state.bry, width, height, { patternUnits: "userSpaceOnUse" });
		this._svg.image(spat, 0, 0, width, height, img);
		this._svgPatterns[id] = brush;
		return id;
	}
	_selectObject(obj) {
		this.state.selected[obj.type] = obj;
		switch (obj.type) {
			case "region":
				this.state._svgclipChanged = true;
				break;
			case "brush":
				this.state.brx = this.state.nextbrx;
				this.state.bry = this.state.nextbry;
				break;
		}
	}
	_deleteObject(objIdx) {
		const obj = this.objects[objIdx.toString()];
		if (obj != null) {
			for (let i$1 = 0; i$1 < this.statestack.length; i$1++) {
				const state = this.statestack[i$1];
				if (state.selected[obj.type] === obj) state.selected[obj.type] = this.defObjects[obj.type].clone();
			}
			delete this.objects[objIdx.toString()];
			return true;
		}
		Helper$1.log("[gdi] Cannot delete object with invalid handle " + objIdx);
		return false;
	}
	_getClipRgn() {
		if (this.state.clip != null) {
			if (!this.state.ownclip) this.state.clip = this.state.clip.clone();
		} else if (this.state.selected.region != null) this.state.clip = this.state.selected.region.clone();
		else this.state.clip = CreateSimpleRegion$1(this.state.wx, this.state.wy, this.state.wx + this.state.ww, this.state.wy + this.state.wh);
		this.state.ownclip = true;
		return this.state.clip;
	}
	_todevX(val) {
		return Math.floor((val - this.state.wx) * (this.state.vw / this.state.ww)) + this.state.vx;
	}
	_todevY(val) {
		return Math.floor((val - this.state.wy) * (this.state.vh / this.state.wh)) + this.state.vy;
	}
	_todevW(val) {
		return Math.floor(val * (this.state.vw / this.state.ww)) + this.state.vx;
	}
	_todevH(val) {
		return Math.floor(val * (this.state.vh / this.state.wh)) + this.state.vy;
	}
	_tologicalX(val) {
		return Math.floor((val - this.state.vx) / (this.state.vw / this.state.ww)) + this.state.wx;
	}
	_tologicalY(val) {
		return Math.floor((val - this.state.vy) / (this.state.vh / this.state.wh)) + this.state.wy;
	}
	_tologicalW(val) {
		return Math.floor(val / (this.state.vw / this.state.ww)) + this.state.wx;
	}
	_tologicalH(val) {
		return Math.floor(val / (this.state.vh / this.state.wh)) + this.state.wy;
	}
	_applyOpts(opts, usePen, useBrush, useFont) {
		if (opts == null) opts = {};
		if (usePen) {
			const pen = this.state.selected.pen;
			if (pen.style !== Helper$1.GDI.PenStyle.PS_NULL) {
				opts.stroke = "#" + pen.color.toHex();
				opts["stroke-width"] = pen.width;
				opts["stroke-miterlimit"] = this.state.miterlimit;
				opts["stroke-linecap"] = "round";
				const dotWidth = 1;
				opts["stroke-linejoin"] = "round";
				const dashWidth = opts["stroke-width"] * 4;
				const dotSpacing = opts["stroke-width"] * 2;
				switch (pen.style) {
					case Helper$1.GDI.PenStyle.PS_DASH:
						opts["stroke-dasharray"] = [dashWidth, dotSpacing].toString();
						break;
					case Helper$1.GDI.PenStyle.PS_DOT:
						opts["stroke-dasharray"] = [dotWidth, dotSpacing].toString();
						break;
					case Helper$1.GDI.PenStyle.PS_DASHDOT:
						opts["stroke-dasharray"] = [
							dashWidth,
							dotSpacing,
							dotWidth,
							dotSpacing
						].toString();
						break;
					case Helper$1.GDI.PenStyle.PS_DASHDOTDOT:
						opts["stroke-dasharray"] = [
							dashWidth,
							dotSpacing,
							dotWidth,
							dotSpacing,
							dotWidth,
							dotSpacing
						].toString();
						break;
				}
			}
		}
		if (useBrush) {
			const brush = this.state.selected.brush;
			switch (brush.style) {
				case Helper$1.GDI.BrushStyle.BS_SOLID:
					opts.fill = "#" + brush.color.toHex();
					break;
				case Helper$1.GDI.BrushStyle.BS_PATTERN:
				case Helper$1.GDI.BrushStyle.BS_DIBPATTERNPT:
					opts.fill = "url(#" + this._getSvgPatternForBrush(brush) + ")";
					break;
				case Helper$1.GDI.BrushStyle.BS_NULL:
					opts.fill = "none";
					break;
				default:
					Helper$1.log("[gdi] unsupported brush style: " + brush.style);
					opts.fill = "none";
					break;
			}
		}
		if (useFont) {
			const font = this.state.selected.font;
			opts["font-family"] = font.facename;
			opts["font-size"] = Math.abs(font.height);
			opts.fill = "#" + this.state.textcolor.toHex();
		}
		return opts;
	}
};
var Renderer$1 = class {
	constructor(blob) {
		this.parse(blob);
		Helper$1.log("EMFJS.Renderer instantiated");
	}
	render(info) {
		const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		const emfBounds = this._img.getBounds();
		const gdi = this._render(new SVG(svgElement), info.mapMode, emfBounds.width, emfBounds.height, emfBounds.width, emfBounds.height);
		svgElement.setAttribute("viewBox", [
			0,
			0,
			emfBounds.width,
			emfBounds.height
		].join(" "));
		const preserveAspectRatio = gdi.getMapMode() === Helper$1.GDI.MapMode.MM_ANISOTROPIC ? "none" : "xMidYMid meet";
		svgElement.setAttribute("preserveAspectRatio", preserveAspectRatio);
		svgElement.setAttribute("width", info.width);
		svgElement.setAttribute("height", info.height);
		return svgElement;
	}
	parse(blob) {
		this._img = null;
		const reader = new Blob$2(blob);
		if (reader.readUint32() !== 1) throw new EMFJSError("Not an EMF file");
		const size = reader.readUint32();
		if (size % 4 !== 0) throw new EMFJSError("Not an EMF file");
		this._img = new EMF(reader, size);
		if (this._img == null) throw new EMFJSError("Format not recognized");
	}
	_render(svg, mapMode, w, h, xExt, yExt) {
		const gdi = new GDIContext$1(svg);
		gdi.setWindowExtEx(w, h);
		gdi.setViewportExtEx(xExt, yExt);
		gdi.setMapMode(mapMode);
		Helper$1.log("[EMF] BEGIN RENDERING --->");
		this._img.render(gdi);
		Helper$1.log("[EMF] <--- DONE RENDERING");
		return gdi;
	}
};
var EMF = class {
	constructor(reader, hdrsize) {
		this._hdrsize = hdrsize;
		this._records = new EMFRecords(reader, this._hdrsize);
	}
	render(gdi) {
		this._records.play(gdi);
	}
	getBounds() {
		const bounds = this._records.getBounds();
		return {
			width: bounds.right - bounds.left,
			height: bounds.bottom - bounds.top
		};
	}
};
var WMFJSError = class extends Error {
	constructor(message) {
		super(message);
		Object.setPrototypeOf(this, new.target.prototype);
	}
};
var isLoggingEnabled = true;
function loggingEnabled(enabled) {
	isLoggingEnabled = enabled;
}
var Helper = class {
	static {
		this.GDI = {
			METAHEADER_SIZE: 18,
			BITMAPINFOHEADER_SIZE: 40,
			BITMAPCOREHEADER_SIZE: 12,
			MetafileType: {
				MEMORYMETAFILE: 1,
				DISKMETAFILE: 2
			},
			MetafileVersion: {
				METAVERSION100: 256,
				METAVERSION300: 768
			},
			RecordType: {
				META_EOF: 0,
				META_REALIZEPALETTE: 53,
				META_SETPALENTRIES: 55,
				META_SETBKMODE: 258,
				META_SETMAPMODE: 259,
				META_SETROP2: 260,
				META_SETRELABS: 261,
				META_SETPOLYFILLMODE: 262,
				META_SETSTRETCHBLTMODE: 263,
				META_SETTEXTCHAREXTRA: 264,
				META_RESTOREDC: 295,
				META_RESIZEPALETTE: 313,
				META_DIBCREATEPATTERNBRUSH: 322,
				META_SETLAYOUT: 329,
				META_SETBKCOLOR: 513,
				META_SETTEXTCOLOR: 521,
				META_OFFSETVIEWPORTORG: 529,
				META_LINETO: 531,
				META_MOVETO: 532,
				META_OFFSETCLIPRGN: 544,
				META_FILLREGION: 552,
				META_SETMAPPERFLAGS: 561,
				META_SELECTPALETTE: 564,
				META_POLYGON: 804,
				META_POLYLINE: 805,
				META_SETTEXTJUSTIFICATION: 522,
				META_SETWINDOWORG: 523,
				META_SETWINDOWEXT: 524,
				META_SETVIEWPORTORG: 525,
				META_SETVIEWPORTEXT: 526,
				META_OFFSETWINDOWORG: 527,
				META_SCALEWINDOWEXT: 1040,
				META_SCALEVIEWPORTEXT: 1042,
				META_EXCLUDECLIPRECT: 1045,
				META_INTERSECTCLIPRECT: 1046,
				META_ELLIPSE: 1048,
				META_FLOODFILL: 1049,
				META_FRAMEREGION: 1065,
				META_ANIMATEPALETTE: 1078,
				META_TEXTOUT: 1313,
				META_POLYPOLYGON: 1336,
				META_EXTFLOODFILL: 1352,
				META_RECTANGLE: 1051,
				META_SETPIXEL: 1055,
				META_ROUNDRECT: 1564,
				META_PATBLT: 1565,
				META_SAVEDC: 30,
				META_PIE: 2074,
				META_STRETCHBLT: 2851,
				META_ESCAPE: 1574,
				META_INVERTREGION: 298,
				META_PAINTREGION: 299,
				META_SELECTCLIPREGION: 300,
				META_SELECTOBJECT: 301,
				META_SETTEXTALIGN: 302,
				META_ARC: 2071,
				META_CHORD: 2096,
				META_BITBLT: 2338,
				META_EXTTEXTOUT: 2610,
				META_SETDIBTODEV: 3379,
				META_DIBBITBLT: 2368,
				META_DIBSTRETCHBLT: 2881,
				META_STRETCHDIB: 3907,
				META_DELETEOBJECT: 496,
				META_CREATEPALETTE: 247,
				META_CREATEPATTERNBRUSH: 505,
				META_CREATEPENINDIRECT: 762,
				META_CREATEFONTINDIRECT: 763,
				META_CREATEBRUSHINDIRECT: 764,
				META_CREATEREGION: 1791
			},
			MetafileEscapes: {
				NEWFRAME: 1,
				ABORTDOC: 2,
				NEXTBAND: 3,
				SETCOLORTABLE: 4,
				GETCOLORTABLE: 5,
				FLUSHOUT: 6,
				DRAFTMODE: 7,
				QUERYESCSUPPORT: 8,
				SETABORTPROC: 9,
				STARTDOC: 10,
				ENDDOC: 11,
				GETPHYSPAGESIZE: 12,
				GETPRINTINGOFFSET: 13,
				GETSCALINGFACTOR: 14,
				META_ESCAPE_ENHANCED_METAFILE: 15,
				SETPENWIDTH: 16,
				SETCOPYCOUNT: 17,
				SETPAPERSOURCE: 18,
				PASSTHROUGH: 19,
				GETTECHNOLOGY: 20,
				SETLINECAP: 21,
				SETLINEJOIN: 22,
				SETMITERLIMIT: 23,
				BANDINFO: 24,
				DRAWPATTERNRECT: 25,
				GETVECTORPENSIZE: 26,
				GETVECTORBRUSHSIZE: 27,
				ENABLEDUPLEX: 28,
				GETSETPAPERBINS: 29,
				GETSETPRINTORIENT: 30,
				ENUMPAPERBINS: 31,
				SETDIBSCALING: 32,
				EPSPRINTING: 33,
				ENUMPAPERMETRICS: 34,
				GETSETPAPERMETRICS: 35,
				POSTSCRIPT_DATA: 37,
				POSTSCRIPT_IGNORE: 38,
				GETDEVICEUNITS: 42,
				GETEXTENDEDTEXTMETRICS: 256,
				GETPAIRKERNTABLE: 258,
				EXTTEXTOUT: 512,
				GETFACENAME: 513,
				DOWNLOADFACE: 514,
				METAFILE_DRIVER: 2049,
				QUERYDIBSUPPORT: 3073,
				BEGIN_PATH: 4096,
				CLIP_TO_PATH: 4097,
				END_PATH: 4098,
				OPEN_CHANNEL: 4110,
				DOWNLOADHEADER: 4111,
				CLOSE_CHANNEL: 4112,
				POSTSCRIPT_PASSTHROUGH: 4115,
				ENCAPSULATED_POSTSCRIPT: 4116,
				POSTSCRIPT_IDENTIFY: 4117,
				POSTSCRIPT_INJECTION: 4118,
				CHECKJPEGFORMAT: 4119,
				CHECKPNGFORMAT: 4120,
				GET_PS_FEATURESETTING: 4121,
				MXDC_ESCAPE: 4122,
				SPCLPASSTHROUGH2: 4568
			},
			MapMode: {
				MM_TEXT: 1,
				MM_LOMETRIC: 2,
				MM_HIMETRIC: 3,
				MM_LOENGLISH: 4,
				MM_HIENGLISH: 5,
				MM_TWIPS: 6,
				MM_ISOTROPIC: 7,
				MM_ANISOTROPIC: 8
			},
			StretchMode: {
				BLACKONWHITE: 1,
				WHITEONBLACK: 2,
				COLORONCOLOR: 3,
				HALFTONE: 4
			},
			TextAlignmentMode: {
				TA_UPDATECP: 1,
				TA_RIGHT: 2,
				TA_CENTER: 6,
				TA_BOTTOM: 8,
				TA_BASELINE: 24,
				TA_RTLREADING: 256
			},
			MixMode: {
				TRANSPARENT: 1,
				OPAQUE: 2
			},
			VerticalTextAlignmentMode: {
				VTA_BOTTOM: 2,
				VTA_CENTER: 6,
				VTA_LEFT: 8,
				VTA_BASELINE: 24
			},
			BrushStyle: {
				BS_SOLID: 0,
				BS_NULL: 1,
				BS_HATCHED: 2,
				BS_PATTERN: 3,
				BS_INDEXED: 4,
				BS_DIBPATTERN: 5,
				BS_DIBPATTERNPT: 6,
				BS_PATTERN8X8: 7,
				BS_DIBPATTERN8X8: 8,
				BS_MONOPATTERN: 9
			},
			PenStyle: {
				PS_SOLID: 0,
				PS_DASH: 1,
				PS_DOT: 2,
				PS_DASHDOT: 3,
				PS_DASHDOTDOT: 4,
				PS_NULL: 5,
				PS_INSIDEFRAME: 6,
				PS_USERSTYLE: 7,
				PS_ALTERNATE: 8,
				PS_ENDCAP_SQUARE: 256,
				PS_ENDCAP_FLAT: 512,
				PS_JOIN_BEVEL: 4096,
				PS_JOIN_MITER: 8192
			},
			PolyFillMode: {
				ALTERNATE: 1,
				WINDING: 2
			},
			ColorUsage: {
				DIB_RGB_COLORS: 0,
				DIB_PAL_COLORS: 1,
				DIB_PAL_INDICES: 2
			},
			PaletteEntryFlag: {
				PC_RESERVED: 1,
				PC_EXPLICIT: 2,
				PC_NOCOLLAPSE: 4
			},
			BitmapCompression: {
				BI_RGB: 0,
				BI_RLE8: 1,
				BI_RLE4: 2,
				BI_BITFIELDS: 3,
				BI_JPEG: 4,
				BI_PNG: 5
			}
		};
	}
	static {
		this._uniqueId = 0;
	}
	static log(message) {
		if (isLoggingEnabled) console.log(message);
	}
	static _makeUniqueId(prefix) {
		return "wmfjs_" + prefix + this._uniqueId++;
	}
	static _writeUint32Val(uint8arr, pos, val) {
		uint8arr[pos++] = val & 255;
		uint8arr[pos++] = val >>> 8 & 255;
		uint8arr[pos++] = val >>> 16 & 255;
		uint8arr[pos++] = val >>> 24 & 255;
	}
	static _blobToBinary(blob) {
		let ret = "";
		const len = blob.length;
		for (let i$1 = 0; i$1 < len; i$1++) ret += String.fromCharCode(blob[i$1]);
		return ret;
	}
};
var Blob$1 = class Blob$1 {
	constructor(blob, offset) {
		if (blob instanceof Blob$1) {
			this.blob = blob.blob;
			this.data = blob.data;
			this.pos = offset || blob.pos;
		} else {
			this.blob = blob;
			this.data = new Uint8Array(blob);
			this.pos = offset || 0;
		}
	}
	eof() {
		return this.pos >= this.data.length;
	}
	seek(newpos) {
		if (newpos < 0 || newpos > this.data.length) throw new WMFJSError("Invalid seek position");
		this.pos = newpos;
	}
	skip(cnt) {
		const newPos = this.pos + cnt;
		if (newPos > this.data.length) throw new WMFJSError("Unexpected end of file");
		this.pos = newPos;
	}
	readBinary(cnt) {
		if (this.pos + cnt > this.data.length) throw new WMFJSError("Unexpected end of file");
		let ret = "";
		while (cnt-- > 0) ret += String.fromCharCode(this.data[this.pos++]);
		return ret;
	}
	readInt8() {
		if (this.pos + 1 > this.data.length) throw new WMFJSError("Unexpected end of file");
		return this.data[this.pos++];
	}
	readUint8() {
		return this.readInt8() >>> 0;
	}
	readInt32() {
		if (this.pos + 4 > this.data.length) throw new WMFJSError("Unexpected end of file");
		let val = this.data[this.pos++];
		val |= this.data[this.pos++] << 8;
		val |= this.data[this.pos++] << 16;
		val |= this.data[this.pos++] << 24;
		return val;
	}
	readUint32() {
		return this.readInt32() >>> 0;
	}
	readUint16() {
		if (this.pos + 2 > this.data.length) throw new WMFJSError("Unexpected end of file");
		let val = this.data[this.pos++];
		val |= this.data[this.pos++] << 8;
		return val;
	}
	readInt16() {
		let val = this.readUint16();
		if (val > 32767) val -= 65536;
		return val;
	}
	readString(length) {
		if (this.pos + length > this.data.length) throw new WMFJSError("Unexpected end of file");
		let ret = "";
		for (let i$1 = 0; i$1 < length; i$1++) ret += String.fromCharCode(this.data[this.pos++] >>> 0);
		return ret;
	}
	readNullTermString(maxSize) {
		let ret = "";
		if (maxSize > 0) {
			maxSize--;
			for (let i$1 = 0; i$1 < maxSize; i$1++) {
				if (this.pos + i$1 + 1 > this.data.length) throw new WMFJSError("Unexpected end of file");
				const byte = this.data[this.pos + i$1] >>> 0;
				if (byte === 0) break;
				ret += String.fromCharCode(byte);
			}
		}
		return ret;
	}
};
var PointS = class PointS {
	constructor(reader, x, y) {
		if (reader != null) {
			this.x = reader.readInt16();
			this.y = reader.readInt16();
		} else {
			this.x = x;
			this.y = y;
		}
	}
	clone() {
		return new PointS(null, this.x, this.y);
	}
	toString() {
		return "{x: " + this.x + ", y: " + this.y + "}";
	}
};
var Rect = class Rect {
	constructor(reader, left, top, right, bottom) {
		if (reader != null) {
			this.bottom = reader.readInt16();
			this.right = reader.readInt16();
			this.top = reader.readInt16();
			this.left = reader.readInt16();
		} else {
			this.bottom = bottom;
			this.right = right;
			this.top = top;
			this.left = left;
		}
	}
	clone() {
		return new Rect(null, this.left, this.top, this.right, this.bottom);
	}
	toString() {
		return "{left: " + this.left + ", top: " + this.top + ", right: " + this.right + ", bottom: " + this.bottom + "}";
	}
	empty() {
		return this.left >= this.right || this.top >= this.bottom;
	}
	intersect(rect) {
		if (this.empty() || rect.empty()) return null;
		if (this.left >= rect.right || this.top >= rect.bottom || this.right <= rect.left || this.bottom <= rect.top) return null;
		return new Rect(null, Math.max(this.left, rect.left), Math.max(this.top, rect.top), Math.min(this.right, rect.right), Math.min(this.bottom, rect.bottom));
	}
};
var Obj = class {
	constructor(type) {
		this.type = type;
	}
	clone() {
		throw new WMFJSError("clone not implemented");
	}
	toString() {
		throw new WMFJSError("toString not implemented");
	}
};
var Region = class Region extends Obj {
	constructor(reader, copy$1) {
		super("region");
		if (reader != null) {
			reader.skip(2);
			if (reader.readInt16() !== 6) throw new WMFJSError("Invalid region identifier");
			reader.skip(2);
			reader.readInt16();
			const scanCnt = reader.readInt16();
			reader.skip(2);
			this.bounds = new Rect(null, reader.readInt16(), reader.readInt16(), reader.readInt16(), reader.readInt16());
			this.scans = [];
			for (let i$1 = 0; i$1 < scanCnt; i$1++) this.scans.push(new Scan(reader));
			this._updateComplexity();
		} else if (copy$1 != null) {
			this.bounds = copy$1.bounds != null ? copy$1.bounds.clone() : null;
			if (copy$1.scans != null) {
				this.scans = [];
				for (let i$1 = 0; i$1 < copy$1.scans.length; i$1++) this.scans.push(copy$1.scans[i$1].clone());
			} else this.scans = null;
			this.complexity = copy$1.complexity;
		} else {
			this.bounds = null;
			this.scans = null;
			this.complexity = 0;
		}
	}
	clone() {
		return new Region(null, this);
	}
	toString() {
		return "{complexity: " + [
			"null",
			"simple",
			"complex"
		][this.complexity] + " bounds: " + (this.bounds != null ? this.bounds.toString() : "[none]") + " #scans: " + (this.scans != null ? this.scans.length : "[none]") + "}";
	}
	_updateComplexity() {
		if (this.bounds == null) {
			this.complexity = 0;
			this.scans = null;
		} else if (this.bounds.empty()) {
			this.complexity = 0;
			this.scans = null;
			this.bounds = null;
		} else if (this.scans == null) this.complexity = 1;
		else {
			this.complexity = 2;
			if (this.scans.length === 1) {
				const scan = this.scans[0];
				if (scan.top === this.bounds.top && scan.bottom === this.bounds.bottom && scan.scanlines.length === 1) {
					const scanline = scan.scanlines[0];
					if (scanline.left === this.bounds.left && scanline.right === this.bounds.right) {
						this.scans = null;
						this.complexity = 1;
					}
				}
			}
		}
	}
	subtract(rect) {
		Helper.log("[wmf] Region " + this.toString() + " subtract " + rect.toString());
		if (this.bounds != null) {
			if (this.bounds.intersect(rect) != null) {
				if (this.scans == null) {
					this.scans = [];
					this.scans.push(new Scan(null, null, this.bounds.top, this.bounds.bottom, [{
						left: this.bounds.left,
						right: this.bounds.right
					}]));
					this.complexity = 2;
				}
				let si = 0;
				while (si < this.scans.length) {
					const scan = this.scans[si];
					if (scan.bottom >= rect.top) {
						const cloned = scan.clone();
						scan.bottom = rect.top - 1;
						cloned.top = rect.top;
						if (scan.top >= scan.bottom) this.scans[si] = cloned;
						else {
							Helper.log("[wmf] Region split top scan " + si + " for substraction");
							this.scans.splice(++si, 0, cloned);
						}
						break;
					}
					si++;
				}
				const first = si;
				while (si < this.scans.length) {
					const scan = this.scans[si];
					if (scan.top > rect.bottom) break;
					if (scan.bottom > rect.bottom) {
						const cloned = scan.clone();
						scan.bottom = rect.bottom;
						cloned.top = rect.bottom + 1;
						if (scan.top >= scan.bottom) this.scans[si] = cloned;
						else {
							Helper.log("[wmf] Region split bottom scan " + si + " for substraction");
							this.scans.splice(++si, 0, cloned);
						}
						break;
					}
					si++;
				}
				if (first < this.scans.length) {
					let last = si;
					si = first;
					while (si < last) {
						if (!this.scans[si].subtract(rect.left, rect.right)) {
							Helper.log("[wmf] Region remove now empty scan " + si + " due to subtraction");
							this.scans.splice(si, 1);
							last--;
							continue;
						}
						si++;
					}
				}
				if (this.scans != null) {
					let left;
					let top;
					let right;
					let bottom;
					const len = this.scans.length;
					for (let i$1 = 0; i$1 < len; i$1++) {
						const scan = this.scans[i$1];
						if (i$1 === 0) top = scan.top;
						if (i$1 === len - 1) bottom = scan.bottom;
						const slen = scan.scanlines.length;
						if (slen > 0) {
							let scanline = scan.scanlines[0];
							if (left == null || scanline.left < left) left = scanline.left;
							scanline = scan.scanlines[slen - 1];
							if (right == null || scanline.right > right) right = scanline.right;
						}
					}
					if (left != null && top != null && right != null && bottom != null) {
						this.bounds = new Rect(null, left, top, right, bottom);
						this._updateComplexity();
					} else {
						this.bounds = null;
						this.scans = null;
						this.complexity = 0;
					}
				} else this._updateComplexity();
			}
		}
		Helper.log("[wmf] Region subtraction -> " + this.toString());
	}
	intersect(rect) {
		Helper.log("[wmf] Region " + this.toString() + " intersect with " + rect.toString());
		if (this.bounds != null) {
			this.bounds = this.bounds.intersect(rect);
			if (this.bounds != null) {
				if (this.scans != null) {
					let si = 0;
					while (si < this.scans.length) if (this.scans[si].bottom < this.bounds.top) si++;
					else break;
					if (si > 0) {
						Helper.log("[wmf] Region remove " + si + " scans from top");
						this.scans.splice(0, si);
						if (this.scans.length > 0) this.scans[0].top = this.bounds.top;
					}
					si = 0;
					while (si < this.scans.length) {
						const scan = this.scans[si];
						if (scan.top > this.bounds.bottom) {
							Helper.log("[wmf] Region remove " + (this.scans.length - si) + " scans from bottom");
							this.scans.splice(si, this.scans.length - si);
							break;
						}
						if (!scan.intersect(this.bounds.left, this.bounds.right)) {
							Helper.log("[wmf] Region remove now empty scan " + si + " due to intersection");
							this.scans.splice(si, 1);
							continue;
						}
						si++;
					}
					if (this.scans.length > 0) this.scans[this.scans.length - 1].bottom = this.bounds.bottom;
					this._updateComplexity();
				}
			} else {
				this.scans = null;
				this.complexity = 0;
			}
		}
		Helper.log("[wmf] Region intersection -> " + this.toString());
	}
	offset(offX, offY) {
		if (this.bounds != null) {
			this.bounds.left += offX;
			this.bounds.top += offY;
			this.bounds.right += offX;
			this.bounds.bottom += offY;
		}
		if (this.scans != null) {
			const slen = this.scans.length;
			for (let si = 0; si < slen; si++) {
				const scan = this.scans[si];
				scan.top += offY;
				scan.bottom += offY;
				const len = scan.scanlines.length;
				for (let i$1 = 0; i$1 < len; i$1++) {
					const scanline = scan.scanlines[i$1];
					scanline.left += offX;
					scanline.right += offX;
				}
			}
		}
	}
};
function CreateSimpleRegion(left, top, right, bottom) {
	const rgn = new Region(null, null);
	rgn.bounds = new Rect(null, left, top, right, bottom);
	rgn._updateComplexity();
	return rgn;
}
var Scan = class Scan {
	constructor(reader, copy$1, top, bottom, scanlines) {
		if (reader != null) {
			const cnt = reader.readUint16();
			this.top = reader.readUint16();
			this.bottom = reader.readUint16();
			this.scanlines = [];
			for (let i$1 = 0; i$1 < cnt; i$1++) {
				const left = reader.readUint16();
				const right = reader.readUint16();
				this.scanlines.push({
					left,
					right
				});
			}
			reader.skip(2);
		} else if (copy$1 != null) {
			this.top = copy$1.top;
			this.bottom = copy$1.bottom;
			this.scanlines = [];
			for (let i$1 = 0; i$1 < copy$1.scanlines.length; i$1++) {
				const scanline = copy$1.scanlines[i$1];
				this.scanlines.push({
					left: scanline.left,
					right: scanline.right
				});
			}
		} else {
			this.top = top;
			this.bottom = bottom;
			this.scanlines = scanlines;
		}
	}
	clone() {
		return new Scan(null, this);
	}
	subtract(left, right) {
		let i$1 = 0;
		while (i$1 < this.scanlines.length) {
			const scanline = this.scanlines[i$1];
			if (scanline.left <= left) {
				if (scanline.right >= left) {
					scanline.right = left - 1;
					if (scanline.left >= scanline.right) {
						this.scanlines.splice(i$1, 1);
						continue;
					}
				}
				i$1++;
			} else break;
		}
		const first = i$1;
		let cnt = 0;
		while (i$1 < this.scanlines.length) {
			const scanline = this.scanlines[i$1];
			if (scanline.right > right) {
				scanline.left = right;
				cnt = i$1 - first;
				if (scanline.left >= scanline.right) cnt++;
				break;
			}
			i$1++;
		}
		if (cnt > 0 && first < this.scanlines.length) this.scanlines.splice(first, cnt);
		return this.scanlines.length > 0;
	}
	intersect(left, right) {
		for (let i$1 = 0; i$1 < this.scanlines.length; i$1++) {
			const scanline = this.scanlines[i$1];
			if (scanline.left >= left || scanline.right >= left) {
				if (i$1 > 0) this.scanlines.splice(0, i$1);
				break;
			}
		}
		if (this.scanlines.length > 0) {
			let scanline = this.scanlines[0];
			if (scanline.left < left) scanline.left = left;
			for (let i$1 = 0; i$1 < this.scanlines.length; i$1++) {
				scanline = this.scanlines[i$1];
				if (scanline.left > right) {
					this.scanlines.splice(i$1, this.scanlines.length - i$1);
					break;
				}
			}
			if (this.scanlines.length > 0) {
				scanline = this.scanlines[this.scanlines.length - 1];
				if (scanline.right > right) scanline.right = right;
			}
		}
		return this.scanlines.length > 0;
	}
	toString() {
		return "{ #scanlines: " + this.scanlines.length + "}";
	}
};
var BitmapCoreHeader = class {
	constructor(reader, skipsize) {
		if (skipsize) reader.skip(4);
		this.width = reader.readUint16();
		this.height = reader.readUint16();
		this.planes = reader.readUint16();
		this.bitcount = reader.readUint16();
	}
	colors() {
		return this.bitcount <= 8 ? 1 << this.bitcount : 0;
	}
};
var BitmapInfoHeader = class {
	constructor(reader, skipsize) {
		if (skipsize) reader.skip(4);
		this.width = reader.readInt32();
		this.height = reader.readInt32();
		this.planes = reader.readUint16();
		this.bitcount = reader.readUint16();
		this.compression = reader.readUint32();
		this.sizeimage = reader.readUint32();
		this.xpelspermeter = reader.readInt32();
		this.ypelspermeter = reader.readInt32();
		this.clrused = reader.readUint32();
		this.clrimportant = reader.readUint32();
	}
	colors() {
		if (this.clrused !== 0) return this.clrused < 256 ? this.clrused : 256;
		else return this.bitcount > 8 ? 0 : 1 << this.bitcount;
	}
};
var BitmapInfo = class {
	constructor(reader, usergb) {
		this._reader = reader;
		this._offset = reader.pos;
		this._usergb = usergb;
		const hdrsize = reader.readUint32();
		this._infosize = hdrsize;
		if (hdrsize === Helper.GDI.BITMAPCOREHEADER_SIZE) {
			this._header = new BitmapCoreHeader(reader, false);
			this._infosize += this._header.colors() * (usergb ? 3 : 2);
		} else {
			this._header = new BitmapInfoHeader(reader, false);
			const masks = this._header.compression === Helper.GDI.BitmapCompression.BI_BITFIELDS ? 3 : 0;
			if (hdrsize <= Helper.GDI.BITMAPINFOHEADER_SIZE + masks * 4) this._infosize = Helper.GDI.BITMAPINFOHEADER_SIZE + masks * 4;
			this._infosize += this._header.colors() * (usergb ? 4 : 2);
		}
	}
	getWidth() {
		return this._header.width;
	}
	getHeight() {
		return Math.abs(this._header.height);
	}
	infosize() {
		return this._infosize;
	}
	header() {
		return this._header;
	}
};
var DIBitmap = class {
	constructor(reader, size) {
		this._reader = reader;
		this._offset = reader.pos;
		this._size = size;
		this._info = new BitmapInfo(reader, true);
	}
	getWidth() {
		return this._info.getWidth();
	}
	getHeight() {
		return this._info.getHeight();
	}
	base64ref() {
		const prevpos = this._reader.pos;
		this._reader.seek(this._offset);
		let mime = "image/bmp";
		const header = this._info.header();
		let data;
		if (header instanceof BitmapInfoHeader && header.compression != null) switch (header.compression) {
			case Helper.GDI.BitmapCompression.BI_JPEG:
				mime = "data:image/jpeg";
				break;
			case Helper.GDI.BitmapCompression.BI_PNG:
				mime = "data:image/png";
				break;
			default:
				data = this.makeBitmapFileHeader();
				break;
		}
		else data = this.makeBitmapFileHeader();
		if (data != null) data += this._reader.readBinary(this._size);
		else data = this._reader.readBinary(this._size);
		const ref$1 = "data:" + mime + ";base64," + btoa(data);
		this._reader.seek(prevpos);
		return ref$1;
	}
	makeBitmapFileHeader() {
		const buf = /* @__PURE__ */ new ArrayBuffer(14);
		const view = new Uint8Array(buf);
		view[0] = 66;
		view[1] = 77;
		Helper._writeUint32Val(view, 2, this._size + 14);
		Helper._writeUint32Val(view, 10, this._info.infosize() + 14);
		return Helper._blobToBinary(view);
	}
};
var Bitmap16 = class Bitmap16 {
	constructor(reader, size) {
		if (reader != null) {
			size = size;
			this._reader = reader;
			this._offset = reader.pos;
			this._size = size;
			this.type = reader.readInt16();
			this.width = reader.readInt16();
			this.height = reader.readInt16();
			this.widthBytes = reader.readInt16();
			this.planes = reader.readUint8();
			this.bitsPixel = reader.readUint8();
			this.bitsOffset = reader.pos;
			this.bitsSize = (this.width * this.bitsPixel + 15 >> 4 << 1) * this.height;
			if (this.bitsSize > size - 10) throw new WMFJSError("Bitmap should have " + this.bitsSize + " bytes, but has " + (size - 10));
		} else {
			const copy$1 = size;
			this._reader = copy$1._reader;
			this._offset = copy$1._offset;
			this._size = copy$1._size;
			this.type = copy$1.type;
			this.width = copy$1.width;
			this.height = copy$1.height;
			this.widthBytes = copy$1.widthBytes;
			this.planes = copy$1.planes;
			this.bitsPixel = copy$1.bitsPixel;
			this.bitsOffset = copy$1.bitsOffset;
			this.bitsSize = copy$1.bitsSize;
		}
	}
	getWidth() {
		return this.width;
	}
	getHeight() {
		return this.height;
	}
	clone() {
		return new Bitmap16(null, this);
	}
};
var PatternBitmap16 = class PatternBitmap16 extends Bitmap16 {
	constructor(reader, size) {
		super(reader, size);
		if (reader != null) this.bitsOffset += 22;
	}
	clone() {
		return new PatternBitmap16(null, this);
	}
};
var ColorRef = class ColorRef {
	constructor(reader, r, g, b) {
		if (reader != null) {
			this.r = reader.readUint8();
			this.g = reader.readUint8();
			this.b = reader.readUint8();
			reader.skip(1);
		} else {
			this.r = r;
			this.g = g;
			this.b = b;
		}
	}
	clone() {
		return new ColorRef(null, this.r, this.g, this.b);
	}
	toHex() {
		return (16777216 + (this.r << 16 | this.g << 8 | this.b)).toString(16).slice(1);
	}
	toString() {
		return "{r: " + this.r + ", g: " + this.g + ", b: " + this.b + "}";
	}
};
var Font = class Font extends Obj {
	constructor(reader, copy$1) {
		super("font");
		if (reader != null) {
			this.height = reader.readInt16();
			this.width = reader.readInt16();
			this.escapement = reader.readInt16();
			this.orientation = reader.readInt16();
			this.weight = reader.readInt16();
			this.italic = reader.readUint8();
			this.underline = reader.readUint8();
			this.strikeout = reader.readUint8();
			this.charset = reader.readUint8();
			this.outprecision = reader.readUint8();
			this.clipprecision = reader.readUint8();
			this.quality = reader.readUint8();
			const pitchAndFamily = reader.readUint8();
			this.pitch = pitchAndFamily & 15;
			this.family = pitchAndFamily >> 6 & 3;
			const dataLength = copy$1;
			const start = reader.pos;
			this.facename = reader.readNullTermString(Math.min(dataLength - (reader.pos - start), 32));
		} else if (copy$1 != null) {
			copy$1 = copy$1;
			this.height = copy$1.height;
			this.width = copy$1.width;
			this.escapement = copy$1.escapement;
			this.orientation = copy$1.orientation;
			this.weight = copy$1.weight;
			this.italic = copy$1.italic;
			this.underline = copy$1.underline;
			this.strikeout = copy$1.strikeout;
			this.charset = copy$1.charset;
			this.outprecision = copy$1.outprecision;
			this.clipprecision = copy$1.clipprecision;
			this.quality = copy$1.quality;
			this.pitch = copy$1.pitch;
			this.family = copy$1.family;
			this.facename = copy$1.facename;
		} else {
			this.height = -80;
			this.width = 0;
			this.escapement = 0;
			this.orientation = 0;
			this.weight = 400;
			this.italic = 0;
			this.underline = 0;
			this.strikeout = 0;
			this.charset = 0;
			this.outprecision = 0;
			this.clipprecision = 0;
			this.quality = 0;
			this.pitch = 0;
			this.family = 0;
			this.facename = "Helvetica";
		}
	}
	clone() {
		return new Font(null, this);
	}
	toString() {
		return JSON.stringify(this);
	}
};
var Brush = class Brush extends Obj {
	constructor(reader, copy$1, forceDibPattern) {
		super("brush");
		if (reader != null) {
			const dataLength = copy$1;
			const start = reader.pos;
			if (forceDibPattern === true || forceDibPattern === false) {
				this.style = reader.readUint16();
				if (forceDibPattern && this.style !== Helper.GDI.BrushStyle.BS_PATTERN) this.style = Helper.GDI.BrushStyle.BS_DIBPATTERNPT;
				switch (this.style) {
					case Helper.GDI.BrushStyle.BS_SOLID:
						this.color = new ColorRef(reader);
						break;
					case Helper.GDI.BrushStyle.BS_PATTERN:
						reader.skip(forceDibPattern ? 2 : 6);
						this.pattern = new Bitmap16(reader, dataLength - (reader.pos - start));
						break;
					case Helper.GDI.BrushStyle.BS_DIBPATTERNPT:
						this.colorusage = forceDibPattern ? reader.readUint16() : reader.readUint32();
						if (!forceDibPattern) reader.skip(2);
						this.dibpatternpt = new DIBitmap(reader, dataLength - (reader.pos - start));
						break;
					case Helper.GDI.BrushStyle.BS_HATCHED:
						this.color = new ColorRef(reader);
						this.hatchstyle = reader.readUint16();
						break;
				}
			} else if (forceDibPattern instanceof PatternBitmap16) {
				this.style = Helper.GDI.BrushStyle.BS_PATTERN;
				this.pattern = forceDibPattern;
			}
		} else if (copy$1 != null) {
			copy$1 = copy$1;
			this.style = copy$1.style;
			switch (this.style) {
				case Helper.GDI.BrushStyle.BS_SOLID:
					this.color = copy$1.color.clone();
					break;
				case Helper.GDI.BrushStyle.BS_PATTERN:
					this.pattern = copy$1.pattern.clone();
					break;
				case Helper.GDI.BrushStyle.BS_DIBPATTERNPT:
					this.colorusage = copy$1.colorusage;
					this.dibpatternpt = copy$1.dibpatternpt;
					break;
				case Helper.GDI.BrushStyle.BS_HATCHED:
					this.color = copy$1.color.clone();
					this.hatchstyle = copy$1.hatchstyle;
					break;
			}
		}
	}
	clone() {
		return new Brush(null, this);
	}
	toString() {
		let ret = "{style: " + this.style;
		switch (this.style) {
			case Helper.GDI.BrushStyle.BS_SOLID:
				ret += ", color: " + this.color.toString();
				break;
			case Helper.GDI.BrushStyle.BS_DIBPATTERNPT:
				ret += ", colorusage: " + this.colorusage;
				break;
			case Helper.GDI.BrushStyle.BS_HATCHED:
				ret += ", color: " + this.color.toString() + ", hatchstyle: " + this.hatchstyle;
				break;
		}
		return ret + "}";
	}
};
var Pen = class Pen extends Obj {
	constructor(reader, style, width, color, linecap, join$1) {
		super("pen");
		if (reader != null) {
			style = reader.readUint16();
			this.style = style & 255;
			this.width = new PointS(reader);
			this.color = new ColorRef(reader);
			this.linecap = style & (Helper.GDI.PenStyle.PS_ENDCAP_SQUARE | Helper.GDI.PenStyle.PS_ENDCAP_FLAT);
			this.join = style & (Helper.GDI.PenStyle.PS_JOIN_BEVEL | Helper.GDI.PenStyle.PS_JOIN_MITER);
		} else {
			this.style = style;
			this.width = width;
			this.color = color;
			this.linecap = linecap;
			this.join = join$1;
		}
	}
	clone() {
		return new Pen(null, this.style, this.width.clone(), this.color.clone(), this.linecap, this.join);
	}
	toString() {
		return "{style: " + this.style + ", width: " + this.width.toString() + ", color: " + this.color.toString() + ", linecap: " + this.linecap + ", join: " + this.join + "}";
	}
};
var PaletteEntry = class PaletteEntry {
	constructor(reader, copy$1) {
		if (reader != null) {
			this.flag = reader.readUint8();
			this.b = reader.readUint8();
			this.g = reader.readUint8();
			this.r = reader.readUint8();
		} else {
			this.flag = copy$1.flag;
			this.b = copy$1.b;
			this.g = copy$1.g;
			this.r = copy$1.r;
		}
	}
	clone() {
		return new PaletteEntry(null, this);
	}
};
var Palette = class Palette extends Obj {
	constructor(reader, copy$1) {
		super("palette");
		if (reader != null) {
			this.start = reader.readUint16();
			let cnt = reader.readUint16();
			this.entries = [];
			while (cnt > 0) {
				this.entries.push(new PaletteEntry(reader));
				cnt--;
			}
		} else {
			this.start = copy$1.start;
			this.entries = [];
			const len = copy$1.entries.length;
			for (let i$1 = 0; i$1 < len; i$1++) this.entries.push(copy$1.entries[i$1]);
		}
	}
	clone() {
		return new Palette(null, this);
	}
	toString() {
		return "{ #entries: " + this.entries.length + "}";
	}
};
var GDIContextState = class {
	constructor(copy$1, defObjects) {
		if (copy$1 != null) {
			this._svggroup = copy$1._svggroup;
			this._svgclipChanged = copy$1._svgclipChanged;
			this._svgtextbkfilter = copy$1._svgtextbkfilter;
			this.mapmode = copy$1.mapmode;
			this.stretchmode = copy$1.stretchmode;
			this.textalign = copy$1.textalign;
			this.bkmode = copy$1.bkmode;
			this.textcolor = copy$1.textcolor.clone();
			this.bkcolor = copy$1.bkcolor.clone();
			this.polyfillmode = copy$1.polyfillmode;
			this.wx = copy$1.wx;
			this.wy = copy$1.wy;
			this.ww = copy$1.ww;
			this.wh = copy$1.wh;
			this.vx = copy$1.vx;
			this.vy = copy$1.vy;
			this.vw = copy$1.vw;
			this.vh = copy$1.vh;
			this.x = copy$1.x;
			this.y = copy$1.y;
			this.clip = copy$1.clip;
			this.ownclip = false;
			this.selected = {};
			for (const type in copy$1.selected) this.selected[type] = copy$1.selected[type];
		} else {
			this._svggroup = null;
			this._svgclipChanged = false;
			this._svgtextbkfilter = null;
			this.mapmode = Helper.GDI.MapMode.MM_ANISOTROPIC;
			this.stretchmode = Helper.GDI.StretchMode.COLORONCOLOR;
			this.textalign = 0;
			this.bkmode = Helper.GDI.MixMode.OPAQUE;
			this.textcolor = new ColorRef(null, 0, 0, 0);
			this.bkcolor = new ColorRef(null, 255, 255, 255);
			this.polyfillmode = Helper.GDI.PolyFillMode.ALTERNATE;
			this.wx = 0;
			this.wy = 0;
			this.ww = 0;
			this.wh = 0;
			this.vx = 0;
			this.vy = 0;
			this.vw = 0;
			this.vh = 0;
			this.x = 0;
			this.y = 0;
			this.clip = null;
			this.ownclip = false;
			this.selected = {};
			for (const type in defObjects) {
				const defObj = defObjects[type];
				this.selected[type] = defObj != null ? defObj.clone() : null;
			}
		}
	}
};
var GDIContext = class {
	constructor(svg) {
		this._svg = svg;
		this._svgdefs = null;
		this._svgPatterns = {};
		this._svgClipPaths = {};
		this.defObjects = {
			brush: new Brush(null, null),
			pen: new Pen(null, Helper.GDI.PenStyle.PS_SOLID, new PointS(null, 1, 1), new ColorRef(null, 0, 0, 0), 0, 0),
			font: new Font(null, null),
			palette: null,
			region: null
		};
		this.state = new GDIContextState(null, this.defObjects);
		this.statestack = [this.state];
		this.objects = {};
	}
	setMapMode(mode) {
		Helper.log("[gdi] setMapMode: mode=" + mode);
		this.state.mapmode = mode;
		this.state._svggroup = null;
	}
	setWindowOrg(x, y) {
		Helper.log("[gdi] setWindowOrg: x=" + x + " y=" + y);
		this.state.wx = x;
		this.state.wy = y;
		this.state._svggroup = null;
	}
	setWindowExt(x, y) {
		Helper.log("[gdi] setWindowExt: x=" + x + " y=" + y);
		this.state.ww = x;
		this.state.wh = y;
		this.state._svggroup = null;
	}
	offsetWindowOrg(offX, offY) {
		Helper.log("[gdi] offsetWindowOrg: offX=" + offX + " offY=" + offY);
		this.state.wx += offX;
		this.state.wy += offY;
		this.state._svggroup = null;
	}
	setViewportOrg(x, y) {
		Helper.log("[gdi] setViewportOrg: x=" + x + " y=" + y);
		this.state.vx = x;
		this.state.vy = y;
		this.state._svggroup = null;
	}
	setViewportExt(x, y) {
		Helper.log("[gdi] setViewportExt: x=" + x + " y=" + y);
		this.state.vw = x;
		this.state.vh = y;
		this.state._svggroup = null;
	}
	offsetViewportOrg(offX, offY) {
		Helper.log("[gdi] offsetViewportOrg: offX=" + offX + " offY=" + offY);
		this.state.vx += offX;
		this.state.vy += offY;
		this.state._svggroup = null;
	}
	saveDC() {
		Helper.log("[gdi] saveDC");
		const prevstate = this.state;
		this.state = new GDIContextState(this.state);
		this.statestack.push(prevstate);
		this.state._svggroup = null;
	}
	restoreDC(saved) {
		Helper.log("[gdi] restoreDC: saved=" + saved);
		if (this.statestack.length > 1) {
			if (saved === -1) this.state = this.statestack.pop();
			else if (saved < -1) throw new WMFJSError("restoreDC: relative restore not implemented");
			else if (saved > 1) throw new WMFJSError("restoreDC: absolute restore not implemented");
		} else throw new WMFJSError("No saved contexts");
		this.state._svggroup = null;
	}
	escape(func, blob, offset, count) {
		Helper.log("[gdi] escape: func=" + func + " offset=" + offset + " count=" + count);
	}
	setStretchBltMode(stretchMode) {
		Helper.log("[gdi] setStretchBltMode: stretchMode=" + stretchMode);
	}
	stretchDib(srcX, srcY, srcW, srcH, dstX, dstY, dstW, dstH, rasterOp, colorUsage, dib) {
		Helper.log("[gdi] stretchDib: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16));
		srcX = this._todevX(srcX);
		srcY = this._todevY(srcY);
		srcW = this._todevW(srcW);
		srcH = this._todevH(srcH);
		dstX = this._todevX(dstX);
		dstY = this._todevY(dstY);
		dstW = this._todevW(dstW);
		dstH = this._todevH(dstH);
		Helper.log("[gdi] stretchDib: TRANSLATED: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16) + " colorUsage=0x" + colorUsage.toString(16));
		this._pushGroup();
		this._svg.image(this.state._svggroup, dstX, dstY, dstW, dstH, dib.base64ref());
	}
	dibBits(srcX, srcY, dstX, dstY, width, height, rasterOp, dib) {
		Helper.log("[gdi] stretchDibBits: srcX=" + srcX + " srcY=" + srcY + " dstX=" + dstX + " dstY=" + dstY + " width=" + width + " height=" + height + " rasterOp=0x" + rasterOp.toString(16));
		srcX = this._todevX(srcX);
		srcY = this._todevY(srcY);
		dstX = this._todevX(dstX);
		dstY = this._todevY(dstY);
		width = this._todevW(width);
		height = this._todevH(height);
		Helper.log("[gdi] dibBits: TRANSLATED: srcX=" + srcX + " srcY=" + srcY + NaN + dstX + " dstY=" + dstY + " width=" + width + " height=" + height + " rasterOp=0x" + rasterOp.toString(16));
		this._pushGroup();
		this._svg.image(this.state._svggroup, dstX, dstY, width, height, dib.base64ref());
	}
	stretchDibBits(srcX, srcY, srcW, srcH, dstX, dstY, dstW, dstH, rasterOp, dib) {
		Helper.log("[gdi] stretchDibBits: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16));
		srcX = this._todevX(srcX);
		srcY = this._todevY(srcY);
		srcW = this._todevW(srcW);
		srcH = this._todevH(srcH);
		dstX = this._todevX(dstX);
		dstY = this._todevY(dstY);
		dstW = this._todevW(dstW);
		dstH = this._todevH(dstH);
		Helper.log("[gdi] stretchDibBits: TRANSLATED: srcX=" + srcX + " srcY=" + srcY + " srcW=" + srcW + " srcH=" + srcH + " dstX=" + dstX + " dstY=" + dstY + " dstW=" + dstW + " dstH=" + dstH + " rasterOp=0x" + rasterOp.toString(16));
		this._pushGroup();
		this._svg.image(this.state._svggroup, dstX, dstY, dstW, dstH, dib.base64ref());
	}
	rectangle(rect, rw, rh) {
		Helper.log("[gdi] rectangle: rect=" + rect.toString() + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const bottom = this._todevY(rect.bottom);
		const right = this._todevX(rect.right);
		const top = this._todevY(rect.top);
		const left = this._todevX(rect.left);
		rw = this._todevH(rw);
		rh = this._todevH(rh);
		Helper.log("[gdi] rectangle: TRANSLATED: bottom=" + bottom + " right=" + right + " top=" + top + " left=" + left + " rh=" + rh + " rw=" + rw);
		this._pushGroup();
		const opts = this._applyOpts(null, true, true, false);
		this._svg.rect(this.state._svggroup, left, top, right - left, bottom - top, rw / 2, rh / 2, opts);
	}
	textOut(x, y, text$2) {
		Helper.log("[gdi] textOut: x=" + x + " y=" + y + " text=" + text$2 + " with font " + this.state.selected.font.toString());
		x = this._todevX(x);
		y = this._todevY(y);
		Helper.log("[gdi] textOut: TRANSLATED: x=" + x + " y=" + y);
		this._pushGroup();
		const opts = this._applyOpts(null, false, false, true);
		if (this.state.selected.font.escapement !== 0) {
			opts.transform = "rotate(" + [
				-this.state.selected.font.escapement / 10,
				x,
				y
			] + ")";
			opts.style = "dominant-baseline: middle; text-anchor: start;";
		}
		if (this.state.bkmode === Helper.GDI.MixMode.OPAQUE) {
			if (this.state._svgtextbkfilter == null) {
				const filterId = Helper._makeUniqueId("f");
				const filter = this._svg.filter(this._getSvgDef(), filterId, 0, 0, 1, 1);
				this._svg.filters.flood(filter, null, "#" + this.state.bkcolor.toHex(), 1);
				this._svg.filters.composite(filter, null, null, "SourceGraphic");
				this.state._svgtextbkfilter = filter;
			}
			opts.filter = "url(#" + this.state._svgtextbkfilter.id + ")";
		}
		this._svg.text(this.state._svggroup, x, y, text$2, opts);
	}
	extTextOut(x, y, text$2, fwOpts, rect, dx) {
		Helper.log("[gdi] extTextOut: x=" + x + " y=" + y + " text=" + text$2 + " with font " + this.state.selected.font.toString());
		x = this._todevX(x);
		y = this._todevY(y);
		Helper.log("[gdi] extTextOut: TRANSLATED: x=" + x + " y=" + y);
		this._pushGroup();
		const opts = this._applyOpts(null, false, false, true);
		if (this.state.selected.font.escapement !== 0) {
			opts.transform = "rotate(" + [
				-this.state.selected.font.escapement / 10,
				x,
				y
			] + ")";
			opts.style = "dominant-baseline: middle; text-anchor: start;";
		}
		if (this.state.bkmode === Helper.GDI.MixMode.OPAQUE) {
			if (this.state._svgtextbkfilter == null) {
				const filterId = Helper._makeUniqueId("f");
				const filter = this._svg.filter(this._getSvgDef(), filterId, 0, 0, 1, 1);
				this._svg.filters.flood(filter, null, "#" + this.state.bkcolor.toHex(), 1);
				this._svg.filters.composite(filter, null, null, "SourceGraphic");
				this.state._svgtextbkfilter = filter;
			}
			opts.filter = "url(#" + this.state._svgtextbkfilter.id + ")";
		}
		this._svg.text(this.state._svggroup, x, y, text$2, opts);
	}
	lineTo(x, y) {
		Helper.log("[gdi] lineTo: x=" + x + " y=" + y + " with pen " + this.state.selected.pen.toString());
		const toX = this._todevX(x);
		const toY = this._todevY(y);
		const fromX = this._todevX(this.state.x);
		const fromY = this._todevY(this.state.y);
		this.state.x = x;
		this.state.y = y;
		Helper.log("[gdi] lineTo: TRANSLATED: toX=" + toX + " toY=" + toY + " fromX=" + fromX + " fromY=" + fromY);
		this._pushGroup();
		const opts = this._applyOpts(null, true, false, false);
		this._svg.line(this.state._svggroup, fromX, fromY, toX, toY, opts);
	}
	moveTo(x, y) {
		Helper.log("[gdi] moveTo: x=" + x + " y=" + y);
		this.state.x = x;
		this.state.y = y;
	}
	polygon(points, first) {
		Helper.log("[gdi] polygon: points=" + points + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const pts = [];
		for (let i$1 = 0; i$1 < points.length; i$1++) {
			const point$1 = points[i$1];
			pts.push([this._todevX(point$1.x), this._todevY(point$1.y)]);
		}
		Helper.log("[gdi] polygon: TRANSLATED: pts=" + pts);
		if (first) this._pushGroup();
		const opts = { "fill-rule": this.state.polyfillmode === Helper.GDI.PolyFillMode.ALTERNATE ? "evenodd" : "nonzero" };
		this._applyOpts(opts, true, true, false);
		this._svg.polygon(this.state._svggroup, pts, opts);
	}
	polyPolygon(polygons) {
		Helper.log("[gdi] polyPolygon: polygons.length=" + polygons.length + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const cnt = polygons.length;
		for (let i$1 = 0; i$1 < cnt; i$1++) this.polygon(polygons[i$1], i$1 === 0);
	}
	polyline(points) {
		Helper.log("[gdi] polyline: points=" + points + " with pen " + this.state.selected.pen.toString());
		const pts = [];
		for (let i$1 = 0; i$1 < points.length; i$1++) {
			const point$1 = points[i$1];
			pts.push([this._todevX(point$1.x), this._todevY(point$1.y)]);
		}
		Helper.log("[gdi] polyline: TRANSLATED: pts=" + pts);
		this._pushGroup();
		const opts = this._applyOpts({ fill: "none" }, true, false, false);
		this._svg.polyline(this.state._svggroup, pts, opts);
	}
	ellipse(rect) {
		Helper.log("[gdi] ellipse: rect=" + rect.toString() + " with pen " + this.state.selected.pen.toString() + " and brush " + this.state.selected.brush.toString());
		const bottom = this._todevY(rect.bottom);
		const right = this._todevX(rect.right);
		const top = this._todevY(rect.top);
		const left = this._todevX(rect.left);
		Helper.log("[gdi] ellipse: TRANSLATED: bottom=" + bottom + " right=" + right + " top=" + top + " left=" + left);
		this._pushGroup();
		const width2 = (right - left) / 2;
		const height2 = (bottom - top) / 2;
		const opts = this._applyOpts(null, true, true, false);
		this._svg.ellipse(this.state._svggroup, left + width2, top + height2, width2, height2, opts);
	}
	excludeClipRect(rect) {
		Helper.log("[gdi] excludeClipRect: rect=" + rect.toString());
		this._getClipRgn().subtract(rect);
	}
	intersectClipRect(rect) {
		Helper.log("[gdi] intersectClipRect: rect=" + rect.toString());
		this._getClipRgn().intersect(rect);
	}
	offsetClipRgn(offX, offY) {
		Helper.log("[gdi] offsetClipRgn: offX=" + offX + " offY=" + offY);
		this._getClipRgn().offset(offX, offY);
	}
	setTextAlign(textAlignmentMode) {
		Helper.log("[gdi] setTextAlign: textAlignmentMode=0x" + textAlignmentMode.toString(16));
		this.state.textalign = textAlignmentMode;
	}
	setBkMode(bkMode) {
		Helper.log("[gdi] setBkMode: bkMode=0x" + bkMode.toString(16));
		this.state.bkmode = bkMode;
	}
	setTextColor(textColor) {
		Helper.log("[gdi] setTextColor: textColor=" + textColor.toString());
		this.state.textcolor = textColor;
	}
	setBkColor(bkColor) {
		Helper.log("[gdi] setBkColor: bkColor=" + bkColor.toString());
		this.state.bkcolor = bkColor;
		this.state._svgtextbkfilter = null;
	}
	setPolyFillMode(polyFillMode) {
		Helper.log("[gdi] setPolyFillMode: polyFillMode=" + polyFillMode);
		this.state.polyfillmode = polyFillMode;
	}
	createBrush(brush) {
		const idx = this._storeObject(brush);
		Helper.log("[gdi] createBrush: brush=" + brush.toString() + " with handle " + idx);
	}
	createFont(font) {
		const idx = this._storeObject(font);
		Helper.log("[gdi] createFont: font=" + font.toString() + " with handle " + idx);
	}
	createPen(pen) {
		const idx = this._storeObject(pen);
		Helper.log("[gdi] createPen: pen=" + pen.toString() + " width handle " + idx);
	}
	createPalette(palette) {
		const idx = this._storeObject(palette);
		Helper.log("[gdi] createPalette: palette=" + palette.toString() + " width handle " + idx);
	}
	createRegion(region) {
		const idx = this._storeObject(region);
		Helper.log("[gdi] createRegion: region=" + region.toString() + " width handle " + idx);
	}
	createPatternBrush(patternBrush) {
		const idx = this._storeObject(patternBrush);
		Helper.log("[gdi] createRegion: region=" + patternBrush.toString() + " width handle " + idx);
	}
	selectObject(objIdx, checkType) {
		const obj = this._getObject(objIdx);
		if (obj != null && (checkType == null || obj.type === checkType)) {
			this._selectObject(obj);
			Helper.log("[gdi] selectObject: objIdx=" + objIdx + (obj ? " selected " + obj.type + ": " + obj.toString() : "[invalid index]"));
		} else Helper.log("[gdi] selectObject: objIdx=" + objIdx + (obj ? " invalid object type: " + obj.type : "[invalid index]"));
	}
	deleteObject(objIdx) {
		const ret = this._deleteObject(objIdx);
		Helper.log("[gdi] deleteObject: objIdx=" + objIdx + (ret ? " deleted object" : "[invalid index]"));
	}
	_pushGroup() {
		if (this.state._svggroup == null || this.state._svgclipChanged) {
			this.state._svgclipChanged = false;
			this.state._svgtextbkfilter = null;
			const settings = {
				viewBox: [
					this.state.vx,
					this.state.vy,
					this.state.vw,
					this.state.vh
				].join(" "),
				preserveAspectRatio: "none"
			};
			if (this.state.clip != null) {
				Helper.log("[gdi] new svg x=" + this.state.vx + " y=" + this.state.vy + " width=" + this.state.vw + " height=" + this.state.vh + " with clipping");
				settings["clip-path"] = "url(#" + this._getSvgClipPathForRegion(this.state.clip) + ")";
			} else Helper.log("[gdi] new svg x=" + this.state.vx + " y=" + this.state.vy + " width=" + this.state.vw + " height=" + this.state.vh + " without clipping");
			this.state._svggroup = this._svg.svg(this.state._svggroup, this.state.vx, this.state.vy, this.state.vw, this.state.vh, settings);
		}
	}
	_storeObject(obj) {
		let i$1 = 0;
		while (this.objects[i$1.toString()] != null && i$1 <= 65535) i$1++;
		if (i$1 > 65535) {
			Helper.log("[gdi] Too many objects!");
			return -1;
		}
		this.objects[i$1.toString()] = obj;
		return i$1;
	}
	_getObject(objIdx) {
		const obj = this.objects[objIdx.toString()];
		if (obj == null) Helper.log("[gdi] No object with handle " + objIdx);
		return obj;
	}
	_getSvgDef() {
		if (this._svgdefs == null) this._svgdefs = this._svg.defs();
		return this._svgdefs;
	}
	_getSvgClipPathForRegion(region) {
		for (const existingId in this._svgClipPaths) if (this._svgClipPaths[existingId] === region) return existingId;
		const id = Helper._makeUniqueId("c");
		const sclip = this._svg.clipPath(this._getSvgDef(), id, "userSpaceOnUse");
		switch (region.complexity) {
			case 1:
				this._svg.rect(sclip, this._todevX(region.bounds.left), this._todevY(region.bounds.top), this._todevW(region.bounds.right - region.bounds.left), this._todevH(region.bounds.bottom - region.bounds.top), {
					fill: "black",
					"stroke-width": 0
				});
				break;
			case 2:
				for (let i$1 = 0; i$1 < region.scans.length; i$1++) {
					const scan = region.scans[i$1];
					for (let j = 0; j < scan.scanlines.length; j++) {
						const scanline = scan.scanlines[j];
						this._svg.rect(sclip, this._todevX(scanline.left), this._todevY(scan.top), this._todevW(scanline.right - scanline.left), this._todevH(scan.bottom - scan.top), {
							fill: "black",
							"stroke-width": 0
						});
					}
				}
				break;
		}
		this._svgClipPaths[id] = region;
		return id;
	}
	_getSvgPatternForBrush(brush) {
		for (const existingId in this._svgPatterns) if (this._svgPatterns[existingId] === brush) return existingId;
		let width;
		let height;
		let img;
		switch (brush.style) {
			case Helper.GDI.BrushStyle.BS_PATTERN:
				width = brush.pattern.getWidth();
				height = brush.pattern.getHeight();
				break;
			case Helper.GDI.BrushStyle.BS_DIBPATTERNPT:
				width = brush.dibpatternpt.getWidth();
				height = brush.dibpatternpt.getHeight();
				img = brush.dibpatternpt.base64ref();
				break;
			default: throw new WMFJSError("Invalid brush style");
		}
		const id = Helper._makeUniqueId("p");
		const spat = this._svg.pattern(this._getSvgDef(), id, 0, 0, width, height, { patternUnits: "userSpaceOnUse" });
		this._svg.image(spat, 0, 0, width, height, img);
		this._svgPatterns[id] = brush;
		return id;
	}
	_selectObject(obj) {
		this.state.selected[obj.type] = obj;
		if (obj.type === "region") this.state._svgclipChanged = true;
	}
	_deleteObject(objIdx) {
		const obj = this.objects[objIdx.toString()];
		if (obj != null) {
			for (let i$1 = 0; i$1 < this.statestack.length; i$1++) {
				const state = this.statestack[i$1];
				if (state.selected[obj.type] === obj) state.selected[obj.type] = this.defObjects[obj.type].clone();
			}
			delete this.objects[objIdx.toString()];
			return true;
		}
		Helper.log("[gdi] Cannot delete object with invalid handle " + objIdx);
		return false;
	}
	_getClipRgn() {
		if (this.state.clip != null) {
			if (!this.state.ownclip) this.state.clip = this.state.clip.clone();
		} else if (this.state.selected.region != null) this.state.clip = this.state.selected.region.clone();
		else this.state.clip = CreateSimpleRegion(this.state.wx, this.state.wy, this.state.wx + this.state.ww, this.state.wy + this.state.wh);
		this.state.ownclip = true;
		return this.state.clip;
	}
	_todevX(val) {
		return Math.floor((val - this.state.wx) * (this.state.vw / this.state.ww)) + this.state.vx;
	}
	_todevY(val) {
		return Math.floor((val - this.state.wy) * (this.state.vh / this.state.wh)) + this.state.vy;
	}
	_todevW(val) {
		return Math.floor(val * (this.state.vw / this.state.ww)) + this.state.vx;
	}
	_todevH(val) {
		return Math.floor(val * (this.state.vh / this.state.wh)) + this.state.vy;
	}
	_tologicalX(val) {
		return Math.floor((val - this.state.vx) / (this.state.vw / this.state.ww)) + this.state.wx;
	}
	_tologicalY(val) {
		return Math.floor((val - this.state.vy) / (this.state.vh / this.state.wh)) + this.state.wy;
	}
	_tologicalW(val) {
		return Math.floor(val / (this.state.vw / this.state.ww)) + this.state.wx;
	}
	_tologicalH(val) {
		return Math.floor(val / (this.state.vh / this.state.wh)) + this.state.wy;
	}
	_applyOpts(opts, usePen, useBrush, useFont) {
		if (opts == null) opts = {};
		if (usePen) {
			const pen = this.state.selected.pen;
			if (pen.style !== Helper.GDI.PenStyle.PS_NULL) {
				opts.stroke = "#" + pen.color.toHex();
				opts["stroke-width"] = this._todevW(pen.width.x);
				let dotWidth;
				if ((pen.linecap & Helper.GDI.PenStyle.PS_ENDCAP_SQUARE) !== 0) {
					opts["stroke-linecap"] = "square";
					dotWidth = 1;
				} else if ((pen.linecap & Helper.GDI.PenStyle.PS_ENDCAP_FLAT) !== 0) {
					opts["stroke-linecap"] = "butt";
					dotWidth = opts["stroke-width"];
				} else {
					opts["stroke-linecap"] = "round";
					dotWidth = 1;
				}
				if ((pen.join & Helper.GDI.PenStyle.PS_JOIN_BEVEL) !== 0) opts["stroke-linejoin"] = "bevel";
				else if ((pen.join & Helper.GDI.PenStyle.PS_JOIN_MITER) !== 0) opts["stroke-linejoin"] = "miter";
				else opts["stroke-linejoin"] = "round";
				const dashWidth = opts["stroke-width"] * 4;
				const dotSpacing = opts["stroke-width"] * 2;
				switch (pen.style) {
					case Helper.GDI.PenStyle.PS_DASH:
						opts["stroke-dasharray"] = [dashWidth, dotSpacing].toString();
						break;
					case Helper.GDI.PenStyle.PS_DOT:
						opts["stroke-dasharray"] = [dotWidth, dotSpacing].toString();
						break;
					case Helper.GDI.PenStyle.PS_DASHDOT:
						opts["stroke-dasharray"] = [
							dashWidth,
							dotSpacing,
							dotWidth,
							dotSpacing
						].toString();
						break;
					case Helper.GDI.PenStyle.PS_DASHDOTDOT:
						opts["stroke-dasharray"] = [
							dashWidth,
							dotSpacing,
							dotWidth,
							dotSpacing,
							dotWidth,
							dotSpacing
						].toString();
						break;
				}
			}
		}
		if (useBrush) {
			const brush = this.state.selected.brush;
			switch (brush.style) {
				case Helper.GDI.BrushStyle.BS_SOLID:
					opts.fill = "#" + brush.color.toHex();
					break;
				case Helper.GDI.BrushStyle.BS_PATTERN:
				case Helper.GDI.BrushStyle.BS_DIBPATTERNPT:
					opts.fill = "url(#" + this._getSvgPatternForBrush(brush) + ")";
					break;
				case Helper.GDI.BrushStyle.BS_NULL:
					opts.fill = "none";
					break;
				default:
					Helper.log("[gdi] unsupported brush style: " + brush.style);
					opts.fill = "none";
					break;
			}
		}
		if (useFont) {
			const font = this.state.selected.font;
			opts["font-family"] = font.facename;
			opts["font-size"] = this._todevH(Math.abs(font.height));
			opts.fill = "#" + this.state.textcolor.toHex();
		}
		return opts;
	}
};
var WMFRecords = class {
	constructor(reader, first) {
		this._records = [];
		let all = false;
		let curpos = first;
		main_loop: while (!all) {
			reader.seek(curpos);
			const size = reader.readUint32();
			if (size < 3) throw new WMFJSError("Invalid record size");
			const type = reader.readUint16();
			switch (type) {
				case Helper.GDI.RecordType.META_EOF:
					all = true;
					break main_loop;
				case Helper.GDI.RecordType.META_SETMAPMODE: {
					const mapMode = reader.readUint16();
					this._records.push((gdi) => {
						gdi.setMapMode(mapMode);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETWINDOWORG: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.setWindowOrg(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETWINDOWEXT: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.setWindowExt(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_OFFSETWINDOWORG: {
					const offY = reader.readInt16();
					const offX = reader.readInt16();
					this._records.push((gdi) => {
						gdi.offsetWindowOrg(offX, offY);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETVIEWPORTORG: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.setViewportOrg(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETVIEWPORTEXT: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.setViewportExt(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_OFFSETVIEWPORTORG: {
					const offY = reader.readInt16();
					const offX = reader.readInt16();
					this._records.push((gdi) => {
						gdi.offsetViewportOrg(offX, offY);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SAVEDC:
					this._records.push((gdi) => {
						gdi.saveDC();
					});
					break;
				case Helper.GDI.RecordType.META_RESTOREDC: {
					const saved = reader.readInt16();
					this._records.push((gdi) => {
						gdi.restoreDC(saved);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETSTRETCHBLTMODE: {
					const stretchMode = reader.readUint16();
					this._records.push((gdi) => {
						gdi.setStretchBltMode(stretchMode);
					});
					break;
				}
				case Helper.GDI.RecordType.META_DIBBITBLT: {
					const haveSrcDib = (type >> 8) + 3 !== size;
					const rasterOp = reader.readUint16() | reader.readUint16() << 16;
					const srcY = reader.readInt16();
					const srcX = reader.readInt16();
					if (!haveSrcDib) reader.skip(2);
					const height = reader.readInt16();
					const width = reader.readInt16();
					const destY = reader.readInt16();
					const destX = reader.readInt16();
					if (haveSrcDib) {
						const dib = new DIBitmap(reader, size * 2 - (reader.pos - curpos));
						this._records.push((gdi) => {
							gdi.dibBits(srcX, srcY, destX, destY, width, height, rasterOp, dib);
						});
					}
					break;
				}
				case Helper.GDI.RecordType.META_DIBSTRETCHBLT: {
					(type >> 8) + 3;
					const rasterOp = reader.readUint16() | reader.readUint16() << 16;
					const srcH = reader.readInt16();
					const srcW = reader.readInt16();
					const srcY = reader.readInt16();
					const srcX = reader.readInt16();
					const destH = reader.readInt16();
					const destW = reader.readInt16();
					const destY = reader.readInt16();
					const destX = reader.readInt16();
					const dib = new DIBitmap(reader, size * 2 - (reader.pos - curpos));
					this._records.push((gdi) => {
						gdi.stretchDibBits(srcX, srcY, srcW, srcH, destX, destY, destW, destH, rasterOp, dib);
					});
					break;
				}
				case Helper.GDI.RecordType.META_STRETCHDIB: {
					const rasterOp = reader.readUint16() | reader.readUint16() << 16;
					const colorUsage = reader.readInt16();
					const srcH = reader.readInt16();
					const srcW = reader.readInt16();
					const srcY = reader.readInt16();
					const srcX = reader.readInt16();
					const destH = reader.readInt16();
					const destW = reader.readInt16();
					const destY = reader.readInt16();
					const destX = reader.readInt16();
					const dib = new DIBitmap(reader, size * 2 - (reader.pos - curpos));
					this._records.push((gdi) => {
						gdi.stretchDib(srcX, srcY, srcW, srcH, destX, destY, destW, destH, rasterOp, colorUsage, dib);
					});
					break;
				}
				case Helper.GDI.RecordType.META_ESCAPE: {
					const func = reader.readUint16();
					const count = reader.readUint16();
					const offset = reader.pos;
					const blob = new Blob$1(reader, offset);
					this._records.push((gdi) => {
						gdi.escape(func, blob, offset, count);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETTEXTALIGN: {
					const textAlign = reader.readUint16();
					this._records.push((gdi) => {
						gdi.setTextAlign(textAlign);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETBKMODE: {
					const bkMode = reader.readUint16();
					this._records.push((gdi) => {
						gdi.setBkMode(bkMode);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETTEXTCOLOR: {
					const textColor = new ColorRef(reader);
					this._records.push((gdi) => {
						gdi.setTextColor(textColor);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETBKCOLOR: {
					const bkColor = new ColorRef(reader);
					this._records.push((gdi) => {
						gdi.setBkColor(bkColor);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEBRUSHINDIRECT: {
					const brush = new Brush(reader, size * 2 - (reader.pos - curpos), false);
					this._records.push((gdi) => {
						gdi.createBrush(brush);
					});
					break;
				}
				case Helper.GDI.RecordType.META_DIBCREATEPATTERNBRUSH: {
					const brush = new Brush(reader, size * 2 - (reader.pos - curpos), true);
					this._records.push((gdi) => {
						gdi.createBrush(brush);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEPENINDIRECT: {
					const pen = new Pen(reader);
					this._records.push((gdi) => {
						gdi.createPen(pen);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEFONTINDIRECT: {
					const font = new Font(reader, size * 2 - (reader.pos - curpos));
					this._records.push((gdi) => {
						gdi.createFont(font);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SELECTOBJECT: {
					const idx = reader.readUint16();
					this._records.push((gdi) => {
						gdi.selectObject(idx, null);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SELECTPALETTE: {
					const idx = reader.readUint16();
					this._records.push((gdi) => {
						gdi.selectObject(idx, "palette");
					});
					break;
				}
				case Helper.GDI.RecordType.META_SELECTCLIPREGION: {
					const idx = reader.readUint16();
					this._records.push((gdi) => {
						gdi.selectObject(idx, "region");
					});
					break;
				}
				case Helper.GDI.RecordType.META_DELETEOBJECT: {
					const idx = reader.readUint16();
					this._records.push((gdi) => {
						gdi.deleteObject(idx);
					});
					break;
				}
				case Helper.GDI.RecordType.META_RECTANGLE: {
					const rect = new Rect(reader);
					this._records.push((gdi) => {
						gdi.rectangle(rect, 0, 0);
					});
					break;
				}
				case Helper.GDI.RecordType.META_ROUNDRECT: {
					const rh = reader.readInt16();
					const rw = reader.readInt16();
					const rect = new Rect(reader);
					this._records.push((gdi) => {
						gdi.rectangle(rect, rw, rh);
					});
					break;
				}
				case Helper.GDI.RecordType.META_LINETO: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.lineTo(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_MOVETO: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					this._records.push((gdi) => {
						gdi.moveTo(x, y);
					});
					break;
				}
				case Helper.GDI.RecordType.META_TEXTOUT: {
					const len = reader.readInt16();
					if (len > 0) {
						const text$2 = reader.readString(len);
						reader.skip(len % 2);
						const y = reader.readInt16();
						const x = reader.readInt16();
						this._records.push((gdi) => {
							gdi.textOut(x, y, text$2);
						});
					}
					break;
				}
				case Helper.GDI.RecordType.META_EXTTEXTOUT: {
					const y = reader.readInt16();
					const x = reader.readInt16();
					const len = reader.readInt16();
					const fwOpts = reader.readUint16();
					let hasRect = null;
					let hasDx = null;
					if (size * 2 === 14 + len + len % 2) {
						hasRect = false;
						hasDx = false;
					}
					if (size * 2 === 22 + len + len % 2) {
						hasRect = true;
						hasDx = false;
					}
					if (size * 2 === 14 + len + len % 2 + len * 2) {
						hasRect = false;
						hasDx = true;
					}
					if (size * 2 === 22 + len + len % 2 + len * 2) {
						hasRect = true;
						hasDx = true;
					}
					const rect = hasRect ? new Rect(reader) : null;
					if (len > 0) {
						const text$2 = reader.readString(len);
						reader.skip(len % 2);
						const dx = [];
						if (hasDx) for (let i$1 = 0; i$1 < text$2.length; i$1++) dx.push(reader.readInt16());
						this._records.push((gdi) => {
							gdi.extTextOut(x, y, text$2, fwOpts, rect, dx);
						});
					}
					break;
				}
				case Helper.GDI.RecordType.META_EXCLUDECLIPRECT: {
					const rect = new Rect(reader);
					this._records.push((gdi) => {
						gdi.excludeClipRect(rect);
					});
					break;
				}
				case Helper.GDI.RecordType.META_INTERSECTCLIPRECT: {
					const rect = new Rect(reader);
					this._records.push((gdi) => {
						gdi.intersectClipRect(rect);
					});
					break;
				}
				case Helper.GDI.RecordType.META_POLYGON: {
					let cnt = reader.readInt16();
					const points = [];
					while (cnt > 0) {
						points.push(new PointS(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polygon(points, true);
					});
					break;
				}
				case Helper.GDI.RecordType.META_SETPOLYFILLMODE: {
					const polyfillmode = reader.readUint16();
					this._records.push((gdi) => {
						gdi.setPolyFillMode(polyfillmode);
					});
					break;
				}
				case Helper.GDI.RecordType.META_POLYPOLYGON: {
					const cnt = reader.readUint16();
					const polygonsPtCnts = [];
					for (let i$1 = 0; i$1 < cnt; i$1++) polygonsPtCnts.push(reader.readUint16());
					const polygons = [];
					for (let i$1 = 0; i$1 < cnt; i$1++) {
						const ptCnt = polygonsPtCnts[i$1];
						const p = [];
						for (let ip = 0; ip < ptCnt; ip++) p.push(new PointS(reader));
						polygons.push(p);
					}
					this._records.push((gdi) => {
						gdi.polyPolygon(polygons);
					});
					break;
				}
				case Helper.GDI.RecordType.META_POLYLINE: {
					let cnt = reader.readInt16();
					const points = [];
					while (cnt > 0) {
						points.push(new PointS(reader));
						cnt--;
					}
					this._records.push((gdi) => {
						gdi.polyline(points);
					});
					break;
				}
				case Helper.GDI.RecordType.META_ELLIPSE: {
					const rect = new Rect(reader);
					this._records.push((gdi) => {
						gdi.ellipse(rect);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEPALETTE: {
					const palette = new Palette(reader);
					this._records.push((gdi) => {
						gdi.createPalette(palette);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEREGION: {
					const region = new Region(reader);
					this._records.push((gdi) => {
						gdi.createRegion(region);
					});
					break;
				}
				case Helper.GDI.RecordType.META_CREATEPATTERNBRUSH: {
					const datalength = size * 2 - (reader.pos - curpos);
					const brush = new Brush(reader, datalength, new PatternBitmap16(reader, datalength));
					this._records.push((gdi) => {
						gdi.createPatternBrush(brush);
					});
					break;
				}
				case Helper.GDI.RecordType.META_OFFSETCLIPRGN: {
					const offY = reader.readInt16();
					const offX = reader.readInt16();
					this._records.push((gdi) => {
						gdi.offsetClipRgn(offX, offY);
					});
					break;
				}
				case Helper.GDI.RecordType.META_REALIZEPALETTE:
				case Helper.GDI.RecordType.META_SETPALENTRIES:
				case Helper.GDI.RecordType.META_SETROP2:
				case Helper.GDI.RecordType.META_SETRELABS:
				case Helper.GDI.RecordType.META_SETTEXTCHAREXTRA:
				case Helper.GDI.RecordType.META_RESIZEPALETTE:
				case Helper.GDI.RecordType.META_SETLAYOUT:
				case Helper.GDI.RecordType.META_FILLREGION:
				case Helper.GDI.RecordType.META_SETMAPPERFLAGS:
				case Helper.GDI.RecordType.META_SETTEXTJUSTIFICATION:
				case Helper.GDI.RecordType.META_SCALEWINDOWEXT:
				case Helper.GDI.RecordType.META_SCALEVIEWPORTEXT:
				case Helper.GDI.RecordType.META_FLOODFILL:
				case Helper.GDI.RecordType.META_FRAMEREGION:
				case Helper.GDI.RecordType.META_ANIMATEPALETTE:
				case Helper.GDI.RecordType.META_EXTFLOODFILL:
				case Helper.GDI.RecordType.META_SETPIXEL:
				case Helper.GDI.RecordType.META_PATBLT:
				case Helper.GDI.RecordType.META_PIE:
				case Helper.GDI.RecordType.META_STRETCHBLT:
				case Helper.GDI.RecordType.META_INVERTREGION:
				case Helper.GDI.RecordType.META_PAINTREGION:
				case Helper.GDI.RecordType.META_ARC:
				case Helper.GDI.RecordType.META_CHORD:
				case Helper.GDI.RecordType.META_BITBLT:
				case Helper.GDI.RecordType.META_SETDIBTODEV:
				default: {
					let recordName = "UNKNOWN";
					for (const name in Helper.GDI.RecordType) if (Helper.GDI.RecordType[name] === type) {
						recordName = name;
						break;
					}
					Helper.log("[WMF] " + recordName + " record (0x" + type.toString(16) + ") at offset 0x" + curpos.toString(16) + " with " + size * 2 + " bytes");
					break;
				}
			}
			curpos += size * 2;
		}
		if (!all) throw new WMFJSError("Could not read all records");
	}
	play(gdi) {
		const len = this._records.length;
		for (let i$1 = 0; i$1 < len; i$1++) this._records[i$1](gdi);
	}
};
var Renderer = class {
	constructor(blob) {
		this.parse(blob);
		Helper.log("WMFJS.Renderer instantiated");
	}
	render(info) {
		const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		this._render(new SVG(svgElement), info.mapMode, info.xExt, info.yExt);
		svgElement.setAttribute("viewBox", [
			0,
			0,
			info.xExt,
			info.yExt
		].join(" "));
		svgElement.setAttribute("preserveAspectRatio", "none");
		svgElement.setAttribute("width", info.width);
		svgElement.setAttribute("height", info.height);
		return svgElement;
	}
	parse(blob) {
		this._img = null;
		const reader = new Blob$1(blob);
		let type;
		let size;
		let placable;
		let headerstart;
		const key = reader.readUint32();
		if (key === 2596720087) {
			placable = new WMFPlacable(reader);
			headerstart = reader.pos;
			type = reader.readUint16();
			size = reader.readUint16();
		} else {
			headerstart = 0;
			type = key & 65535;
			size = key >>> 16 & 65535;
		}
		switch (type) {
			case Helper.GDI.MetafileType.MEMORYMETAFILE:
			case Helper.GDI.MetafileType.DISKMETAFILE:
				if (size === Helper.GDI.METAHEADER_SIZE / 2) {
					const version = reader.readUint16();
					switch (version) {
						case Helper.GDI.MetafileVersion.METAVERSION100:
						case Helper.GDI.MetafileVersion.METAVERSION300:
							this._img = new WMF(reader, placable, version, headerstart + size * 2);
							break;
					}
				}
				break;
		}
		if (this._img == null) throw new WMFJSError("Format not recognized");
	}
	_render(svg, mapMode, xExt, yExt) {
		const gdi = new GDIContext(svg);
		gdi.setViewportExt(xExt, yExt);
		gdi.setMapMode(mapMode);
		Helper.log("[WMF] BEGIN RENDERING --->");
		this._img.render(gdi);
		Helper.log("[WMF] <--- DONE RENDERING");
	}
};
var WMFRect16 = class {
	constructor(reader) {
		this.left = reader.readInt16();
		this.top = reader.readInt16();
		this.right = reader.readInt16();
		this.bottom = reader.readInt16();
	}
	toString() {
		return "{left: " + this.left + ", top: " + this.top + ", right: " + this.right + ", bottom: " + this.bottom + "}";
	}
};
var WMFPlacable = class {
	constructor(reader) {
		reader.skip(2);
		this.boundingBox = new WMFRect16(reader);
		this.unitsPerInch = reader.readInt16();
		reader.skip(4);
		reader.skip(2);
		Helper.log("Got bounding box " + this.boundingBox + " and " + this.unitsPerInch + " units/inch");
	}
};
var WMF = class {
	constructor(reader, placable, version, hdrsize) {
		this._version = version;
		this._hdrsize = hdrsize;
		this._placable = placable;
		this._records = new WMFRecords(reader, this._hdrsize);
	}
	render(gdi) {
		this._records.play(gdi);
	}
};
loggingEnabled$1(false);
loggingEnabled(false);
var domEnvironment$1 = null;
const setMetafileDomEnvironment = (env) => {
	domEnvironment$1 = env || null;
};
function ensureDomEnvironment() {
	if (typeof document !== "undefined" && typeof XMLSerializer !== "undefined") return true;
	const env = domEnvironment$1 || {};
	const win = env.window || env.mockWindow || null;
	const doc$2 = env.document || env.mockDocument || win?.document || null;
	if (win && doc$2) {
		if (typeof globalThis.window === "undefined") globalThis.window = win;
		if (typeof globalThis.document === "undefined") globalThis.document = doc$2;
		if (win.XMLSerializer && typeof globalThis.XMLSerializer === "undefined") globalThis.XMLSerializer = win.XMLSerializer;
		if (win.Node && typeof globalThis.Node === "undefined") globalThis.Node = win.Node;
		if (typeof globalThis.atob === "undefined" && typeof win.atob === "function") globalThis.atob = win.atob.bind(win);
		if (typeof globalThis.btoa === "undefined" && typeof win.btoa === "function") globalThis.btoa = win.btoa.bind(win);
	}
	return typeof document !== "undefined" && typeof XMLSerializer !== "undefined";
}
var MM_ANISOTROPIC = 8;
var EMF_SIGNATURE = 1179469088;
var EMF_PLUS_SIGNATURE = 726027589;
var EMR_COMMENT = 70;
var EMF_PLUS_OBJECT = 16392;
var EMF_PLUS_OBJECT_TYPE_IMAGE = 5;
var EMF_PLUS_IMAGE_TYPE_BITMAP = 1;
var EMF_PLUS_BITMAP_TYPE_PIXEL = 0;
var EMF_PLUS_BITMAP_TYPE_COMPRESSED = 1;
var EMF_PLUS_PIXEL_FORMAT_INDEXED_FLAG = 65536;
var EMF_PLUS_PIXEL_FORMAT_24BPP_RGB = 137224;
var EMF_PLUS_PIXEL_FORMAT_32BPP_RGB = 139273;
var EMF_PLUS_PIXEL_FORMAT_32BPP_ARGB = 2498570;
var EMF_PLUS_PIXEL_FORMAT_32BPP_PARGB = 925707;
var MAX_PIXEL_BITMAP_PIXELS = 1e8;
var base64ToArrayBuffer = dataUriToArrayBuffer;
function uint8ToBase64(bytes) {
	const chunkSize = 32768;
	let binary = "";
	for (let i$1 = 0; i$1 < bytes.length; i$1 += chunkSize) {
		const chunk = bytes.subarray(i$1, i$1 + chunkSize);
		binary += String.fromCharCode.apply(null, chunk);
	}
	return btoa(binary);
}
function detectCompressedImageFormat(bytes) {
	if (!bytes || bytes.length < 4) return null;
	if (bytes.length >= 8 && bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71 && bytes[4] === 13 && bytes[5] === 10 && bytes[6] === 26 && bytes[7] === 10) return {
		mime: "image/png",
		format: "png"
	};
	if (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255) return {
		mime: "image/jpeg",
		format: "jpeg"
	};
	if (bytes[0] === 71 && bytes[1] === 73 && bytes[2] === 70 && bytes[3] === 56) return {
		mime: "image/gif",
		format: "gif"
	};
	return null;
}
function concatBytes(parts) {
	let totalLength = 0;
	for (const part of parts) totalLength += part.byteLength;
	const result = new Uint8Array(totalLength);
	let offset = 0;
	for (const part of parts) {
		result.set(part, offset);
		offset += part.byteLength;
	}
	return result;
}
function createCanvasFromEnv() {
	const env = domEnvironment$1 || {};
	const doc$2 = env.document || env.mockDocument || env.window?.document || env.mockWindow?.document || null;
	if (doc$2) return doc$2.createElement("canvas");
	if (typeof document !== "undefined") return document.createElement("canvas");
	return null;
}
function convertEmfPlusPixelRow(src, srcOffset, dst, dstOffset, width, pixelFormat) {
	if (srcOffset + width * (pixelFormat === EMF_PLUS_PIXEL_FORMAT_24BPP_RGB ? 3 : 4) > src.byteLength) return false;
	let s = srcOffset;
	let d = dstOffset;
	for (let x = 0; x < width; x++) {
		const b = src[s];
		const g = src[s + 1];
		const r = src[s + 2];
		if (pixelFormat === EMF_PLUS_PIXEL_FORMAT_24BPP_RGB) {
			dst[d] = r;
			dst[d + 1] = g;
			dst[d + 2] = b;
			dst[d + 3] = 255;
			s += 3;
		} else if (pixelFormat === EMF_PLUS_PIXEL_FORMAT_32BPP_PARGB) {
			const a = src[s + 3];
			if (a === 0) {
				dst[d] = 0;
				dst[d + 1] = 0;
				dst[d + 2] = 0;
				dst[d + 3] = 0;
			} else {
				const scale = 255 / a;
				dst[d] = r * scale;
				dst[d + 1] = g * scale;
				dst[d + 2] = b * scale;
				dst[d + 3] = a;
			}
			s += 4;
		} else {
			dst[d] = r;
			dst[d + 1] = g;
			dst[d + 2] = b;
			dst[d + 3] = pixelFormat === EMF_PLUS_PIXEL_FORMAT_32BPP_ARGB ? src[s + 3] : 255;
			s += 4;
		}
		d += 4;
	}
	return true;
}
function renderEmfPlusPixelBitmap({ width, height, stride, pixelFormat, pixels }) {
	if (width <= 0 || height === 0) return null;
	const absHeight = Math.abs(height);
	const absStride = Math.abs(stride);
	if (absStride === 0) return null;
	if (width * absHeight > MAX_PIXEL_BITMAP_PIXELS) return null;
	if ((pixelFormat & EMF_PLUS_PIXEL_FORMAT_INDEXED_FLAG) !== 0) return null;
	if (pixelFormat !== EMF_PLUS_PIXEL_FORMAT_24BPP_RGB && pixelFormat !== EMF_PLUS_PIXEL_FORMAT_32BPP_RGB && pixelFormat !== EMF_PLUS_PIXEL_FORMAT_32BPP_ARGB && pixelFormat !== EMF_PLUS_PIXEL_FORMAT_32BPP_PARGB) return null;
	if (absStride * absHeight > pixels.byteLength) return null;
	const rgba = new Uint8ClampedArray(width * absHeight * 4);
	for (let y = 0; y < absHeight; y++) if (!convertEmfPlusPixelRow(pixels, y * absStride, rgba, y * width * 4, width, pixelFormat)) return null;
	const canvas = createCanvasFromEnv();
	if (!canvas) return null;
	canvas.width = width;
	canvas.height = absHeight;
	const ctx = canvas.getContext("2d");
	if (!ctx) return null;
	const imageData = ctx.createImageData(width, absHeight);
	imageData.data.set(rgba);
	ctx.putImageData(imageData, 0, 0);
	const dataUri = canvas.toDataURL("image/png");
	if (!dataUri || dataUri === "data:,") return null;
	return {
		dataUri,
		format: "png"
	};
}
function parseEmfPlusImageObject(bytes) {
	if (!bytes || bytes.byteLength < 28) return null;
	const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	if (view.getUint32(4, true) !== EMF_PLUS_IMAGE_TYPE_BITMAP) return null;
	const bitmapType = view.getUint32(24, true);
	if (bitmapType === EMF_PLUS_BITMAP_TYPE_COMPRESSED) {
		const compressed = bytes.subarray(28);
		const formatInfo = detectCompressedImageFormat(compressed);
		if (!formatInfo) return null;
		return {
			dataUri: `data:${formatInfo.mime};base64,${uint8ToBase64(compressed)}`,
			format: formatInfo.format
		};
	}
	if (bitmapType === EMF_PLUS_BITMAP_TYPE_PIXEL) return renderEmfPlusPixelBitmap({
		width: view.getInt32(8, true),
		height: view.getInt32(12, true),
		stride: view.getInt32(16, true),
		pixelFormat: view.getUint32(20, true),
		pixels: bytes.subarray(28)
	});
	return null;
}
function extractBitmapFromEmfPlus(buffer) {
	const view = new DataView(buffer);
	if (view.byteLength < 108) return null;
	const type = view.getUint32(0, true);
	const headerSize = view.getUint32(4, true);
	const signature = view.getUint32(40, true);
	if (type !== 1 || signature !== EMF_SIGNATURE) return null;
	if (headerSize <= 0 || headerSize >= view.byteLength) return null;
	const pendingByObjectId = /* @__PURE__ */ new Map();
	let offset = headerSize;
	while (offset + 8 <= view.byteLength) {
		const recordType = view.getUint32(offset, true);
		const recordSize = view.getUint32(offset + 4, true);
		if (recordSize < 8 || offset + recordSize > view.byteLength) break;
		if (recordType === EMR_COMMENT && recordSize >= 20) {
			const dataSize = view.getUint32(offset + 8, true);
			if (dataSize >= 4 && dataSize <= recordSize - 12) {
				if (view.getUint32(offset + 12, true) === EMF_PLUS_SIGNATURE) {
					const emfPlusStart = offset + 16;
					const emfPlusEnd = offset + 12 + dataSize;
					let pos = emfPlusStart;
					while (pos + 12 <= emfPlusEnd) {
						const epType = view.getUint16(pos, true);
						const epFlags = view.getUint16(pos + 2, true);
						const epSize = view.getUint32(pos + 4, true);
						if (epSize < 12 || pos + epSize > emfPlusEnd) break;
						if (epType === EMF_PLUS_OBJECT) {
							const objectId = epFlags & 255;
							const objectType = epFlags >> 8 & 127;
							const continueBit = (epFlags & 32768) !== 0;
							const headerBytes = continueBit ? 16 : 12;
							if (epSize < headerBytes) break;
							const totalObjectSize = continueBit ? view.getUint32(pos + 8, true) : 0;
							const dataSize$1 = view.getUint32(pos + (continueBit ? 12 : 8), true);
							const dataStart = pos + headerBytes;
							if (dataSize$1 > epSize - headerBytes || dataStart + dataSize$1 > emfPlusEnd) break;
							if (objectType === EMF_PLUS_OBJECT_TYPE_IMAGE) {
								let result = null;
								if (continueBit) {
									let entry = pendingByObjectId.get(objectId);
									if (!entry) {
										entry = {
											totalSize: totalObjectSize,
											parts: [],
											collected: 0
										};
										pendingByObjectId.set(objectId, entry);
									} else if (entry.totalSize === 0 && totalObjectSize > 0) entry.totalSize = totalObjectSize;
									const chunk = new Uint8Array(buffer, dataStart, dataSize$1);
									entry.parts.push(chunk);
									entry.collected += chunk.byteLength;
									if (entry.totalSize > 0 && entry.collected >= entry.totalSize) {
										result = parseEmfPlusImageObject(concatBytes(entry.parts).subarray(0, entry.totalSize));
										pendingByObjectId.delete(objectId);
									}
								} else {
									const pending = pendingByObjectId.get(objectId);
									if (pending) {
										pending.parts.push(new Uint8Array(buffer, dataStart, dataSize$1));
										const combined = concatBytes(pending.parts);
										result = parseEmfPlusImageObject(pending.totalSize > 0 ? combined.subarray(0, pending.totalSize) : combined);
										pendingByObjectId.delete(objectId);
									} else result = parseEmfPlusImageObject(new Uint8Array(buffer, dataStart, dataSize$1));
								}
								if (result) return result;
							}
						}
						pos += epSize;
					}
				}
			}
		}
		offset += recordSize;
	}
	return null;
}
function extractBitmapFromEmf(buffer) {
	const view = new DataView(buffer);
	if (view.byteLength < 120) return null;
	const type = view.getUint32(0, true);
	const headerSize = view.getUint32(4, true);
	if (type !== 1 || headerSize <= 0 || headerSize + 80 > view.byteLength) return null;
	const recordOffset = headerSize;
	if (view.getUint32(recordOffset, true) !== 81) return null;
	if (recordOffset + view.getUint32(recordOffset + 4, true) > view.byteLength) return null;
	const offBmi = view.getUint32(recordOffset + 48, true);
	const cbBmi = view.getUint32(recordOffset + 52, true);
	const offBits = view.getUint32(recordOffset + 56, true);
	const cbBits = view.getUint32(recordOffset + 60, true);
	if (!cbBmi || !cbBits) return null;
	const bmiStart = recordOffset + offBmi;
	const bitsStart = recordOffset + offBits;
	if (bitsStart + cbBits > view.byteLength || bmiStart + cbBmi > view.byteLength) return null;
	const bmpSize = 14 + cbBmi + cbBits;
	const bmpBytes = new Uint8Array(bmpSize);
	const bmpView = new DataView(bmpBytes.buffer);
	bmpView.setUint8(0, 66);
	bmpView.setUint8(1, 77);
	bmpView.setUint32(2, bmpSize, true);
	bmpView.setUint32(10, 14 + cbBmi, true);
	bmpBytes.set(new Uint8Array(buffer, bmiStart, cbBmi), 14);
	bmpBytes.set(new Uint8Array(buffer, bitsStart, cbBits), 14 + cbBmi);
	return {
		dataUri: `data:image/bmp;base64,${uint8ToBase64(bmpBytes)}`,
		format: "bmp"
	};
}
function svgToDataUri(svgElement) {
	const svgString = new XMLSerializer().serializeToString(svgElement);
	return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`;
}
function getEmfDimensions(buffer) {
	const view = new DataView(buffer);
	const frameLeft = view.getInt32(24, true);
	const frameTop = view.getInt32(28, true);
	const frameRight = view.getInt32(32, true);
	const frameBottom = view.getInt32(36, true);
	const frameWidth = frameRight - frameLeft;
	const frameHeight = frameBottom - frameTop;
	const DPI = 96;
	const width = Math.round(frameWidth * DPI / 2540);
	const height = Math.round(frameHeight * DPI / 2540);
	const deviceWidth = view.getInt32(72, true);
	const deviceHeight = view.getInt32(76, true);
	return {
		width: width || 800,
		height: height || 600,
		xExt: frameWidth || deviceWidth || 800,
		yExt: frameHeight || deviceHeight || 600,
		wExt: frameWidth || deviceWidth || 800,
		hExt: frameHeight || deviceHeight || 600
	};
}
function isEmfPlus(buffer) {
	const view = new DataView(buffer);
	if (view.byteLength < 108) return false;
	const type = view.getUint32(0, true);
	const headerSize = view.getUint32(4, true);
	const signature = view.getUint32(40, true);
	if (type !== 1 || signature !== EMF_SIGNATURE || headerSize <= 0 || headerSize >= view.byteLength) return false;
	let offset = headerSize;
	for (let i$1 = 0; i$1 < 10; i$1++) {
		if (offset + 8 > view.byteLength) break;
		const recordType = view.getUint32(offset, true);
		const recordSize = view.getUint32(offset + 4, true);
		if (recordSize < 8 || offset + recordSize > view.byteLength) break;
		if (recordType === EMR_COMMENT && recordSize >= 20) {
			if (view.getUint32(offset + 12, true) === EMF_PLUS_SIGNATURE) return true;
		}
		offset += recordSize;
	}
	return false;
}
function isEmfHeader(buffer) {
	if (buffer.byteLength < 48) return false;
	const view = new DataView(buffer);
	const type = view.getUint32(0, true);
	const signature = view.getUint32(40, true);
	return type === 1 && signature === EMF_SIGNATURE;
}
function createPlaceholder(params) {
	const width = Math.max(1, Math.round(params.width || 400));
	const height = Math.max(1, Math.round(params.height || 300));
	const label = params.label || "Unable to render image";
	const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" role="img" aria-label="${label}"><rect width="100%" height="100%" fill="#ffffff" stroke="#d9d9d9" stroke-width="1"/><text x="50%" y="50%" fill="#595959" font-family="sans-serif" font-size="${Math.max(8, Math.min(12, Math.floor(width / 30)))}" text-anchor="middle" dominant-baseline="middle">${label}</text></svg>`;
	return {
		dataUri: `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`,
		format: "svg"
	};
}
function getWmfDimensions(buffer) {
	const view = new DataView(buffer);
	if (view.getUint32(0, true) === 2596720087) {
		const left = view.getInt16(6, true);
		const top = view.getInt16(8, true);
		const right = view.getInt16(10, true);
		const bottom = view.getInt16(12, true);
		const unitsPerInch = view.getInt16(14, true) || 1440;
		const width = right - left;
		const height = bottom - top;
		const pixelWidth = Math.round(width * 96 / unitsPerInch);
		const pixelHeight = Math.round(height * 96 / unitsPerInch);
		return {
			width: pixelWidth || 400,
			height: pixelHeight || 400,
			xExt: width || 400,
			yExt: height || 400
		};
	}
	return {
		width: 400,
		height: 400,
		xExt: 400,
		yExt: 400
	};
}
function convertEmfToSvg(data, size = {}) {
	try {
		if (!ensureDomEnvironment()) {
			console.warn("EMF conversion requires browser environment with DOM support");
			return null;
		}
		const buffer = base64ToArrayBuffer(data);
		const bitmapResult = extractBitmapFromEmf(buffer);
		if (bitmapResult) return bitmapResult;
		const dimensions = getEmfDimensions(buffer);
		if (isEmfPlus(buffer)) {
			const embedded = extractBitmapFromEmfPlus(buffer);
			if (embedded) return embedded;
			return createPlaceholder({
				width: size.width || dimensions.width,
				height: size.height || dimensions.height,
				label: "Unable to render EMF+ image"
			});
		}
		const renderer = new Renderer$1(buffer);
		const renderSettings = {
			width: String(size.width || dimensions.width) + "px",
			height: String(size.height || dimensions.height) + "px",
			wExt: dimensions.wExt,
			hExt: dimensions.hExt,
			xExt: dimensions.xExt,
			yExt: dimensions.yExt,
			mapMode: MM_ANISOTROPIC
		};
		const svgElement = renderer.render(renderSettings);
		if (!svgElement?.childNodes?.length) return null;
		return {
			dataUri: svgToDataUri(svgElement),
			format: "svg"
		};
	} catch (error) {
		console.warn("Failed to convert EMF to SVG:", error.message);
		return null;
	}
}
function convertWmfToSvg(data, size = {}) {
	try {
		if (!ensureDomEnvironment()) {
			console.warn("WMF conversion requires browser environment with DOM support");
			return null;
		}
		const buffer = base64ToArrayBuffer(data);
		if (isEmfHeader(buffer)) return convertEmfToSvg(data, size);
		const dimensions = getWmfDimensions(buffer);
		const renderer = new Renderer(buffer);
		const renderSettings = {
			width: String(size.width || dimensions.width) + "px",
			height: String(size.height || dimensions.height) + "px",
			xExt: dimensions.xExt,
			yExt: dimensions.yExt,
			mapMode: MM_ANISOTROPIC
		};
		const svgElement = renderer.render(renderSettings);
		if (!svgElement || !svgElement.childNodes?.length) return null;
		return {
			dataUri: svgToDataUri(svgElement),
			format: "svg"
		};
	} catch (error) {
		console.warn("Failed to convert WMF to SVG:", error.message);
		return null;
	}
}
function convertMetafileToSvg(dataUri, extension$1, size = {}) {
	const ext = extension$1?.toLowerCase();
	if (ext === "emf") return convertEmfToSvg(dataUri, size);
	if (ext === "wmf") return convertWmfToSvg(dataUri, size);
	console.warn(`Unsupported metafile extension: ${extension$1}`);
	return null;
}
function isMetafileExtension(extension$1) {
	const ext = extension$1?.toLowerCase();
	return ext === "emf" || ext === "wmf";
}
var require_common = /* @__PURE__ */ __commonJSMin(((exports) => {
	var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
	function _has(obj, key) {
		return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.assign = function(obj) {
		var sources = Array.prototype.slice.call(arguments, 1);
		while (sources.length) {
			var source = sources.shift();
			if (!source) continue;
			if (typeof source !== "object") throw new TypeError(source + "must be non-object");
			for (var p in source) if (_has(source, p)) obj[p] = source[p];
		}
		return obj;
	};
	exports.shrinkBuf = function(buf, size) {
		if (buf.length === size) return buf;
		if (buf.subarray) return buf.subarray(0, size);
		buf.length = size;
		return buf;
	};
	var fnTyped = {
		arraySet: function(dest, src, src_offs, len, dest_offs) {
			if (src.subarray && dest.subarray) {
				dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
				return;
			}
			for (var i$1 = 0; i$1 < len; i$1++) dest[dest_offs + i$1] = src[src_offs + i$1];
		},
		flattenChunks: function(chunks) {
			var i$1, l, len = 0, pos, chunk, result;
			for (i$1 = 0, l = chunks.length; i$1 < l; i$1++) len += chunks[i$1].length;
			result = new Uint8Array(len);
			pos = 0;
			for (i$1 = 0, l = chunks.length; i$1 < l; i$1++) {
				chunk = chunks[i$1];
				result.set(chunk, pos);
				pos += chunk.length;
			}
			return result;
		}
	};
	var fnUntyped = {
		arraySet: function(dest, src, src_offs, len, dest_offs) {
			for (var i$1 = 0; i$1 < len; i$1++) dest[dest_offs + i$1] = src[src_offs + i$1];
		},
		flattenChunks: function(chunks) {
			return [].concat.apply([], chunks);
		}
	};
	exports.setTyped = function(on) {
		if (on) {
			exports.Buf8 = Uint8Array;
			exports.Buf16 = Uint16Array;
			exports.Buf32 = Int32Array;
			exports.assign(exports, fnTyped);
		} else {
			exports.Buf8 = Array;
			exports.Buf16 = Array;
			exports.Buf32 = Array;
			exports.assign(exports, fnUntyped);
		}
	};
	exports.setTyped(TYPED_OK);
}));
var require_trees = /* @__PURE__ */ __commonJSMin(((exports) => {
	var utils$6 = require_common();
	var Z_FIXED$1 = 4;
	var Z_BINARY = 0;
	var Z_TEXT = 1;
	var Z_UNKNOWN$1 = 2;
	function zero$1(buf) {
		var len = buf.length;
		while (--len >= 0) buf[len] = 0;
	}
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES = 2;
	var MIN_MATCH$1 = 3;
	var MAX_MATCH$1 = 258;
	var LENGTH_CODES = 29;
	var LITERALS = 256;
	var L_CODES$1 = LITERALS + 1 + LENGTH_CODES;
	var D_CODES$1 = 30;
	var BL_CODES$1 = 19;
	var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
	var MAX_BITS$1 = 15;
	var Buf_size = 16;
	var MAX_BL_BITS = 7;
	var END_BLOCK = 256;
	var REP_3_6 = 16;
	var REPZ_3_10 = 17;
	var REPZ_11_138 = 18;
	var extra_lbits = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		3,
		3,
		3,
		3,
		4,
		4,
		4,
		4,
		5,
		5,
		5,
		5,
		0
	];
	var extra_dbits = [
		0,
		0,
		0,
		0,
		1,
		1,
		2,
		2,
		3,
		3,
		4,
		4,
		5,
		5,
		6,
		6,
		7,
		7,
		8,
		8,
		9,
		9,
		10,
		10,
		11,
		11,
		12,
		12,
		13,
		13
	];
	var extra_blbits = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		2,
		3,
		7
	];
	var bl_order = [
		16,
		17,
		18,
		0,
		8,
		7,
		9,
		6,
		10,
		5,
		11,
		4,
		12,
		3,
		13,
		2,
		14,
		1,
		15
	];
	var DIST_CODE_LEN = 512;
	var static_ltree = new Array((L_CODES$1 + 2) * 2);
	zero$1(static_ltree);
	var static_dtree = new Array(D_CODES$1 * 2);
	zero$1(static_dtree);
	var _dist_code = new Array(DIST_CODE_LEN);
	zero$1(_dist_code);
	var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
	zero$1(_length_code);
	var base_length = new Array(LENGTH_CODES);
	zero$1(base_length);
	var base_dist = new Array(D_CODES$1);
	zero$1(base_dist);
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
		this.static_tree = static_tree;
		this.extra_bits = extra_bits;
		this.extra_base = extra_base;
		this.elems = elems;
		this.max_length = max_length;
		this.has_stree = static_tree && static_tree.length;
	}
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	function TreeDesc(dyn_tree, stat_desc) {
		this.dyn_tree = dyn_tree;
		this.max_code = 0;
		this.stat_desc = stat_desc;
	}
	function d_code(dist) {
		return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	function put_short(s, w) {
		s.pending_buf[s.pending++] = w & 255;
		s.pending_buf[s.pending++] = w >>> 8 & 255;
	}
	function send_bits(s, value, length) {
		if (s.bi_valid > Buf_size - length) {
			s.bi_buf |= value << s.bi_valid & 65535;
			put_short(s, s.bi_buf);
			s.bi_buf = value >> Buf_size - s.bi_valid;
			s.bi_valid += length - Buf_size;
		} else {
			s.bi_buf |= value << s.bi_valid & 65535;
			s.bi_valid += length;
		}
	}
	function send_code(s, c$1, tree) {
		send_bits(s, tree[c$1 * 2], tree[c$1 * 2 + 1]);
	}
	function bi_reverse(code$1, len) {
		var res = 0;
		do {
			res |= code$1 & 1;
			code$1 >>>= 1;
			res <<= 1;
		} while (--len > 0);
		return res >>> 1;
	}
	function bi_flush(s) {
		if (s.bi_valid === 16) {
			put_short(s, s.bi_buf);
			s.bi_buf = 0;
			s.bi_valid = 0;
		} else if (s.bi_valid >= 8) {
			s.pending_buf[s.pending++] = s.bi_buf & 255;
			s.bi_buf >>= 8;
			s.bi_valid -= 8;
		}
	}
	function gen_bitlen(s, desc) {
		var tree = desc.dyn_tree;
		var max_code = desc.max_code;
		var stree = desc.stat_desc.static_tree;
		var has_stree = desc.stat_desc.has_stree;
		var extra = desc.stat_desc.extra_bits;
		var base$1 = desc.stat_desc.extra_base;
		var max_length = desc.stat_desc.max_length;
		var h;
		var n, m;
		var bits;
		var xbits;
		var f;
		var overflow = 0;
		for (bits = 0; bits <= MAX_BITS$1; bits++) s.bl_count[bits] = 0;
		tree[s.heap[s.heap_max] * 2 + 1] = 0;
		for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
			n = s.heap[h];
			bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
			if (bits > max_length) {
				bits = max_length;
				overflow++;
			}
			tree[n * 2 + 1] = bits;
			if (n > max_code) continue;
			s.bl_count[bits]++;
			xbits = 0;
			if (n >= base$1) xbits = extra[n - base$1];
			f = tree[n * 2];
			s.opt_len += f * (bits + xbits);
			if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
		}
		if (overflow === 0) return;
		do {
			bits = max_length - 1;
			while (s.bl_count[bits] === 0) bits--;
			s.bl_count[bits]--;
			s.bl_count[bits + 1] += 2;
			s.bl_count[max_length]--;
			overflow -= 2;
		} while (overflow > 0);
		for (bits = max_length; bits !== 0; bits--) {
			n = s.bl_count[bits];
			while (n !== 0) {
				m = s.heap[--h];
				if (m > max_code) continue;
				if (tree[m * 2 + 1] !== bits) {
					s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
					tree[m * 2 + 1] = bits;
				}
				n--;
			}
		}
	}
	function gen_codes(tree, max_code, bl_count) {
		var next_code = new Array(MAX_BITS$1 + 1);
		var code$1 = 0;
		var bits;
		var n;
		for (bits = 1; bits <= MAX_BITS$1; bits++) next_code[bits] = code$1 = code$1 + bl_count[bits - 1] << 1;
		for (n = 0; n <= max_code; n++) {
			var len = tree[n * 2 + 1];
			if (len === 0) continue;
			tree[n * 2] = bi_reverse(next_code[len]++, len);
		}
	}
	function tr_static_init() {
		var n;
		var bits;
		var length;
		var code$1;
		var dist;
		var bl_count = new Array(MAX_BITS$1 + 1);
		length = 0;
		for (code$1 = 0; code$1 < LENGTH_CODES - 1; code$1++) {
			base_length[code$1] = length;
			for (n = 0; n < 1 << extra_lbits[code$1]; n++) _length_code[length++] = code$1;
		}
		_length_code[length - 1] = code$1;
		dist = 0;
		for (code$1 = 0; code$1 < 16; code$1++) {
			base_dist[code$1] = dist;
			for (n = 0; n < 1 << extra_dbits[code$1]; n++) _dist_code[dist++] = code$1;
		}
		dist >>= 7;
		for (; code$1 < D_CODES$1; code$1++) {
			base_dist[code$1] = dist << 7;
			for (n = 0; n < 1 << extra_dbits[code$1] - 7; n++) _dist_code[256 + dist++] = code$1;
		}
		for (bits = 0; bits <= MAX_BITS$1; bits++) bl_count[bits] = 0;
		n = 0;
		while (n <= 143) {
			static_ltree[n * 2 + 1] = 8;
			n++;
			bl_count[8]++;
		}
		while (n <= 255) {
			static_ltree[n * 2 + 1] = 9;
			n++;
			bl_count[9]++;
		}
		while (n <= 279) {
			static_ltree[n * 2 + 1] = 7;
			n++;
			bl_count[7]++;
		}
		while (n <= 287) {
			static_ltree[n * 2 + 1] = 8;
			n++;
			bl_count[8]++;
		}
		gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
		for (n = 0; n < D_CODES$1; n++) {
			static_dtree[n * 2 + 1] = 5;
			static_dtree[n * 2] = bi_reverse(n, 5);
		}
		static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES$1, MAX_BITS$1);
		static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
		static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
	}
	function init_block(s) {
		var n;
		for (n = 0; n < L_CODES$1; n++) s.dyn_ltree[n * 2] = 0;
		for (n = 0; n < D_CODES$1; n++) s.dyn_dtree[n * 2] = 0;
		for (n = 0; n < BL_CODES$1; n++) s.bl_tree[n * 2] = 0;
		s.dyn_ltree[END_BLOCK * 2] = 1;
		s.opt_len = s.static_len = 0;
		s.last_lit = s.matches = 0;
	}
	function bi_windup(s) {
		if (s.bi_valid > 8) put_short(s, s.bi_buf);
		else if (s.bi_valid > 0) s.pending_buf[s.pending++] = s.bi_buf;
		s.bi_buf = 0;
		s.bi_valid = 0;
	}
	function copy_block(s, buf, len, header) {
		bi_windup(s);
		if (header) {
			put_short(s, len);
			put_short(s, ~len);
		}
		utils$6.arraySet(s.pending_buf, s.window, buf, len, s.pending);
		s.pending += len;
	}
	function smaller(tree, n, m, depth) {
		var _n2 = n * 2;
		var _m2 = m * 2;
		return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
	}
	function pqdownheap(s, tree, k) {
		var v = s.heap[k];
		var j = k << 1;
		while (j <= s.heap_len) {
			if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
			if (smaller(tree, v, s.heap[j], s.depth)) break;
			s.heap[k] = s.heap[j];
			k = j;
			j <<= 1;
		}
		s.heap[k] = v;
	}
	function compress_block(s, ltree, dtree) {
		var dist;
		var lc;
		var lx = 0;
		var code$1;
		var extra;
		if (s.last_lit !== 0) do {
			dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
			lc = s.pending_buf[s.l_buf + lx];
			lx++;
			if (dist === 0) send_code(s, lc, ltree);
			else {
				code$1 = _length_code[lc];
				send_code(s, code$1 + LITERALS + 1, ltree);
				extra = extra_lbits[code$1];
				if (extra !== 0) {
					lc -= base_length[code$1];
					send_bits(s, lc, extra);
				}
				dist--;
				code$1 = d_code(dist);
				send_code(s, code$1, dtree);
				extra = extra_dbits[code$1];
				if (extra !== 0) {
					dist -= base_dist[code$1];
					send_bits(s, dist, extra);
				}
			}
		} while (lx < s.last_lit);
		send_code(s, END_BLOCK, ltree);
	}
	function build_tree(s, desc) {
		var tree = desc.dyn_tree;
		var stree = desc.stat_desc.static_tree;
		var has_stree = desc.stat_desc.has_stree;
		var elems = desc.stat_desc.elems;
		var n, m;
		var max_code = -1;
		var node;
		s.heap_len = 0;
		s.heap_max = HEAP_SIZE$1;
		for (n = 0; n < elems; n++) if (tree[n * 2] !== 0) {
			s.heap[++s.heap_len] = max_code = n;
			s.depth[n] = 0;
		} else tree[n * 2 + 1] = 0;
		while (s.heap_len < 2) {
			node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
			tree[node * 2] = 1;
			s.depth[node] = 0;
			s.opt_len--;
			if (has_stree) s.static_len -= stree[node * 2 + 1];
		}
		desc.max_code = max_code;
		for (n = s.heap_len >> 1; n >= 1; n--) pqdownheap(s, tree, n);
		node = elems;
		do {
			n = s.heap[1];
			s.heap[1] = s.heap[s.heap_len--];
			pqdownheap(s, tree, 1);
			m = s.heap[1];
			s.heap[--s.heap_max] = n;
			s.heap[--s.heap_max] = m;
			tree[node * 2] = tree[n * 2] + tree[m * 2];
			s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
			tree[n * 2 + 1] = tree[m * 2 + 1] = node;
			s.heap[1] = node++;
			pqdownheap(s, tree, 1);
		} while (s.heap_len >= 2);
		s.heap[--s.heap_max] = s.heap[1];
		gen_bitlen(s, desc);
		gen_codes(tree, max_code, s.bl_count);
	}
	function scan_tree(s, tree, max_code) {
		var n;
		var prevlen = -1;
		var curlen;
		var nextlen = tree[1];
		var count = 0;
		var max_count = 7;
		var min_count = 4;
		if (nextlen === 0) {
			max_count = 138;
			min_count = 3;
		}
		tree[(max_code + 1) * 2 + 1] = 65535;
		for (n = 0; n <= max_code; n++) {
			curlen = nextlen;
			nextlen = tree[(n + 1) * 2 + 1];
			if (++count < max_count && curlen === nextlen) continue;
			else if (count < min_count) s.bl_tree[curlen * 2] += count;
			else if (curlen !== 0) {
				if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
				s.bl_tree[REP_3_6 * 2]++;
			} else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
			else s.bl_tree[REPZ_11_138 * 2]++;
			count = 0;
			prevlen = curlen;
			if (nextlen === 0) {
				max_count = 138;
				min_count = 3;
			} else if (curlen === nextlen) {
				max_count = 6;
				min_count = 3;
			} else {
				max_count = 7;
				min_count = 4;
			}
		}
	}
	function send_tree(s, tree, max_code) {
		var n;
		var prevlen = -1;
		var curlen;
		var nextlen = tree[1];
		var count = 0;
		var max_count = 7;
		var min_count = 4;
		if (nextlen === 0) {
			max_count = 138;
			min_count = 3;
		}
		for (n = 0; n <= max_code; n++) {
			curlen = nextlen;
			nextlen = tree[(n + 1) * 2 + 1];
			if (++count < max_count && curlen === nextlen) continue;
			else if (count < min_count) do
				send_code(s, curlen, s.bl_tree);
			while (--count !== 0);
			else if (curlen !== 0) {
				if (curlen !== prevlen) {
					send_code(s, curlen, s.bl_tree);
					count--;
				}
				send_code(s, REP_3_6, s.bl_tree);
				send_bits(s, count - 3, 2);
			} else if (count <= 10) {
				send_code(s, REPZ_3_10, s.bl_tree);
				send_bits(s, count - 3, 3);
			} else {
				send_code(s, REPZ_11_138, s.bl_tree);
				send_bits(s, count - 11, 7);
			}
			count = 0;
			prevlen = curlen;
			if (nextlen === 0) {
				max_count = 138;
				min_count = 3;
			} else if (curlen === nextlen) {
				max_count = 6;
				min_count = 3;
			} else {
				max_count = 7;
				min_count = 4;
			}
		}
	}
	function build_bl_tree(s) {
		var max_blindex;
		scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
		scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
		build_tree(s, s.bl_desc);
		for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
		s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
		return max_blindex;
	}
	function send_all_trees(s, lcodes, dcodes, blcodes) {
		var rank$1;
		send_bits(s, lcodes - 257, 5);
		send_bits(s, dcodes - 1, 5);
		send_bits(s, blcodes - 4, 4);
		for (rank$1 = 0; rank$1 < blcodes; rank$1++) send_bits(s, s.bl_tree[bl_order[rank$1] * 2 + 1], 3);
		send_tree(s, s.dyn_ltree, lcodes - 1);
		send_tree(s, s.dyn_dtree, dcodes - 1);
	}
	function detect_data_type(s) {
		var black_mask = 4093624447;
		var n;
		for (n = 0; n <= 31; n++, black_mask >>>= 1) if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
		if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
		for (n = 32; n < LITERALS; n++) if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
		return Z_BINARY;
	}
	var static_init_done = false;
	function _tr_init(s) {
		if (!static_init_done) {
			tr_static_init();
			static_init_done = true;
		}
		s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
		s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
		s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
		s.bi_buf = 0;
		s.bi_valid = 0;
		init_block(s);
	}
	function _tr_stored_block(s, buf, stored_len, last) {
		send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
		copy_block(s, buf, stored_len, true);
	}
	function _tr_align(s) {
		send_bits(s, STATIC_TREES << 1, 3);
		send_code(s, END_BLOCK, static_ltree);
		bi_flush(s);
	}
	function _tr_flush_block(s, buf, stored_len, last) {
		var opt_lenb, static_lenb;
		var max_blindex = 0;
		if (s.level > 0) {
			if (s.strm.data_type === Z_UNKNOWN$1) s.strm.data_type = detect_data_type(s);
			build_tree(s, s.l_desc);
			build_tree(s, s.d_desc);
			max_blindex = build_bl_tree(s);
			opt_lenb = s.opt_len + 3 + 7 >>> 3;
			static_lenb = s.static_len + 3 + 7 >>> 3;
			if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
		} else opt_lenb = static_lenb = stored_len + 5;
		if (stored_len + 4 <= opt_lenb && buf !== -1) _tr_stored_block(s, buf, stored_len, last);
		else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
			send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
			compress_block(s, static_ltree, static_dtree);
		} else {
			send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
			send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
			compress_block(s, s.dyn_ltree, s.dyn_dtree);
		}
		init_block(s);
		if (last) bi_windup(s);
	}
	function _tr_tally(s, dist, lc) {
		s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 255;
		s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 255;
		s.pending_buf[s.l_buf + s.last_lit] = lc & 255;
		s.last_lit++;
		if (dist === 0) s.dyn_ltree[lc * 2]++;
		else {
			s.matches++;
			dist--;
			s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
			s.dyn_dtree[d_code(dist) * 2]++;
		}
		return s.last_lit === s.lit_bufsize - 1;
	}
	exports._tr_init = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
}));
var require_adler32 = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function adler32$2(adler, buf, len, pos) {
		var s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n = 0;
		while (len !== 0) {
			n = len > 2e3 ? 2e3 : len;
			len -= n;
			do {
				s1 = s1 + buf[pos++] | 0;
				s2 = s2 + s1 | 0;
			} while (--n);
			s1 %= 65521;
			s2 %= 65521;
		}
		return s1 | s2 << 16 | 0;
	}
	module.exports = adler32$2;
}));
var require_crc32 = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function makeTable() {
		var c$1, table = [];
		for (var n = 0; n < 256; n++) {
			c$1 = n;
			for (var k = 0; k < 8; k++) c$1 = c$1 & 1 ? 3988292384 ^ c$1 >>> 1 : c$1 >>> 1;
			table[n] = c$1;
		}
		return table;
	}
	var crcTable = makeTable();
	function crc32$2(crc, buf, len, pos) {
		var t = crcTable, end = pos + len;
		crc ^= -1;
		for (var i$1 = pos; i$1 < end; i$1++) crc = crc >>> 8 ^ t[(crc ^ buf[i$1]) & 255];
		return crc ^ -1;
	}
	module.exports = crc32$2;
}));
var require_messages = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = {
		2: "need dictionary",
		1: "stream end",
		0: "",
		"-1": "file error",
		"-2": "stream error",
		"-3": "data error",
		"-4": "insufficient memory",
		"-5": "buffer error",
		"-6": "incompatible version"
	};
}));
var require_deflate$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	var utils$5 = require_common();
	var trees = require_trees();
	var adler32$1 = require_adler32();
	var crc32$1 = require_crc32();
	var msg$2 = require_messages();
	var Z_NO_FLUSH$1 = 0;
	var Z_PARTIAL_FLUSH = 1;
	var Z_FULL_FLUSH = 3;
	var Z_FINISH$2 = 4;
	var Z_BLOCK$1 = 5;
	var Z_OK$2 = 0;
	var Z_STREAM_END$2 = 1;
	var Z_STREAM_ERROR$1 = -2;
	var Z_DATA_ERROR$1 = -3;
	var Z_BUF_ERROR$1 = -5;
	var Z_DEFAULT_COMPRESSION$1 = -1;
	var Z_FILTERED = 1;
	var Z_HUFFMAN_ONLY = 2;
	var Z_RLE = 3;
	var Z_FIXED = 4;
	var Z_DEFAULT_STRATEGY$1 = 0;
	var Z_UNKNOWN = 2;
	var Z_DEFLATED$2 = 8;
	var MAX_MEM_LEVEL = 9;
	var MAX_WBITS = 15;
	var DEF_MEM_LEVEL = 8;
	var L_CODES = 286;
	var D_CODES = 30;
	var BL_CODES = 19;
	var HEAP_SIZE = 2 * L_CODES + 1;
	var MAX_BITS = 15;
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
	var PRESET_DICT = 32;
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	var BS_NEED_MORE = 1;
	var BS_BLOCK_DONE = 2;
	var BS_FINISH_STARTED = 3;
	var BS_FINISH_DONE = 4;
	var OS_CODE = 3;
	function err(strm, errorCode) {
		strm.msg = msg$2[errorCode];
		return errorCode;
	}
	function rank(f) {
		return (f << 1) - (f > 4 ? 9 : 0);
	}
	function zero(buf) {
		var len = buf.length;
		while (--len >= 0) buf[len] = 0;
	}
	function flush_pending(strm) {
		var s = strm.state;
		var len = s.pending;
		if (len > strm.avail_out) len = strm.avail_out;
		if (len === 0) return;
		utils$5.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
		strm.next_out += len;
		s.pending_out += len;
		strm.total_out += len;
		strm.avail_out -= len;
		s.pending -= len;
		if (s.pending === 0) s.pending_out = 0;
	}
	function flush_block_only(s, last) {
		trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
		s.block_start = s.strstart;
		flush_pending(s.strm);
	}
	function put_byte(s, b) {
		s.pending_buf[s.pending++] = b;
	}
	function putShortMSB(s, b) {
		s.pending_buf[s.pending++] = b >>> 8 & 255;
		s.pending_buf[s.pending++] = b & 255;
	}
	function read_buf(strm, buf, start, size) {
		var len = strm.avail_in;
		if (len > size) len = size;
		if (len === 0) return 0;
		strm.avail_in -= len;
		utils$5.arraySet(buf, strm.input, strm.next_in, len, start);
		if (strm.state.wrap === 1) strm.adler = adler32$1(strm.adler, buf, len, start);
		else if (strm.state.wrap === 2) strm.adler = crc32$1(strm.adler, buf, len, start);
		strm.next_in += len;
		strm.total_in += len;
		return len;
	}
	function longest_match(s, cur_match) {
		var chain_length = s.max_chain_length;
		var scan = s.strstart;
		var match;
		var len;
		var best_len = s.prev_length;
		var nice_match = s.nice_match;
		var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
		var _win = s.window;
		var wmask = s.w_mask;
		var prev = s.prev;
		var strend = s.strstart + MAX_MATCH;
		var scan_end1 = _win[scan + best_len - 1];
		var scan_end = _win[scan + best_len];
		if (s.prev_length >= s.good_match) chain_length >>= 2;
		if (nice_match > s.lookahead) nice_match = s.lookahead;
		do {
			match = cur_match;
			if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
			scan += 2;
			match++;
			do			;
while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
			len = MAX_MATCH - (strend - scan);
			scan = strend - MAX_MATCH;
			if (len > best_len) {
				s.match_start = cur_match;
				best_len = len;
				if (len >= nice_match) break;
				scan_end1 = _win[scan + best_len - 1];
				scan_end = _win[scan + best_len];
			}
		} while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
		if (best_len <= s.lookahead) return best_len;
		return s.lookahead;
	}
	function fill_window(s) {
		var _w_size = s.w_size;
		var p, n, m, more, str;
		do {
			more = s.window_size - s.lookahead - s.strstart;
			if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
				utils$5.arraySet(s.window, s.window, _w_size, _w_size, 0);
				s.match_start -= _w_size;
				s.strstart -= _w_size;
				s.block_start -= _w_size;
				n = s.hash_size;
				p = n;
				do {
					m = s.head[--p];
					s.head[p] = m >= _w_size ? m - _w_size : 0;
				} while (--n);
				n = _w_size;
				p = n;
				do {
					m = s.prev[--p];
					s.prev[p] = m >= _w_size ? m - _w_size : 0;
				} while (--n);
				more += _w_size;
			}
			if (s.strm.avail_in === 0) break;
			n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
			s.lookahead += n;
			if (s.lookahead + s.insert >= MIN_MATCH) {
				str = s.strstart - s.insert;
				s.ins_h = s.window[str];
				s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
				while (s.insert) {
					s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
					s.prev[str & s.w_mask] = s.head[s.ins_h];
					s.head[s.ins_h] = str;
					str++;
					s.insert--;
					if (s.lookahead + s.insert < MIN_MATCH) break;
				}
			}
		} while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	}
	function deflate_stored(s, flush) {
		var max_block_size = 65535;
		if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
		for (;;) {
			if (s.lookahead <= 1) {
				fill_window(s);
				if (s.lookahead === 0 && flush === Z_NO_FLUSH$1) return BS_NEED_MORE;
				if (s.lookahead === 0) break;
			}
			s.strstart += s.lookahead;
			s.lookahead = 0;
			var max_start = s.block_start + max_block_size;
			if (s.strstart === 0 || s.strstart >= max_start) {
				s.lookahead = s.strstart - max_start;
				s.strstart = max_start;
				flush_block_only(s, false);
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			}
			if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
				flush_block_only(s, false);
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			}
		}
		s.insert = 0;
		if (flush === Z_FINISH$2) {
			flush_block_only(s, true);
			if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
			return BS_FINISH_DONE;
		}
		if (s.strstart > s.block_start) {
			flush_block_only(s, false);
			if (s.strm.avail_out === 0) return BS_NEED_MORE;
		}
		return BS_NEED_MORE;
	}
	function deflate_fast(s, flush) {
		var hash_head;
		var bflush;
		for (;;) {
			if (s.lookahead < MIN_LOOKAHEAD) {
				fill_window(s);
				if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) return BS_NEED_MORE;
				if (s.lookahead === 0) break;
			}
			hash_head = 0;
			if (s.lookahead >= MIN_MATCH) {
				s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
				hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
				s.head[s.ins_h] = s.strstart;
			}
			if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) s.match_length = longest_match(s, hash_head);
			if (s.match_length >= MIN_MATCH) {
				bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
				s.lookahead -= s.match_length;
				if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH) {
					s.match_length--;
					do {
						s.strstart++;
						s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
						hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
						s.head[s.ins_h] = s.strstart;
					} while (--s.match_length !== 0);
					s.strstart++;
				} else {
					s.strstart += s.match_length;
					s.match_length = 0;
					s.ins_h = s.window[s.strstart];
					s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
				}
			} else {
				bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
				s.lookahead--;
				s.strstart++;
			}
			if (bflush) {
				flush_block_only(s, false);
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			}
		}
		s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
		if (flush === Z_FINISH$2) {
			flush_block_only(s, true);
			if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
			return BS_FINISH_DONE;
		}
		if (s.last_lit) {
			flush_block_only(s, false);
			if (s.strm.avail_out === 0) return BS_NEED_MORE;
		}
		return BS_BLOCK_DONE;
	}
	function deflate_slow(s, flush) {
		var hash_head;
		var bflush;
		var max_insert;
		for (;;) {
			if (s.lookahead < MIN_LOOKAHEAD) {
				fill_window(s);
				if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) return BS_NEED_MORE;
				if (s.lookahead === 0) break;
			}
			hash_head = 0;
			if (s.lookahead >= MIN_MATCH) {
				s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
				hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
				s.head[s.ins_h] = s.strstart;
			}
			s.prev_length = s.match_length;
			s.prev_match = s.match_start;
			s.match_length = MIN_MATCH - 1;
			if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
				s.match_length = longest_match(s, hash_head);
				if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096)) s.match_length = MIN_MATCH - 1;
			}
			if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
				max_insert = s.strstart + s.lookahead - MIN_MATCH;
				bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
				s.lookahead -= s.prev_length - 1;
				s.prev_length -= 2;
				do
					if (++s.strstart <= max_insert) {
						s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
						hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
						s.head[s.ins_h] = s.strstart;
					}
				while (--s.prev_length !== 0);
				s.match_available = 0;
				s.match_length = MIN_MATCH - 1;
				s.strstart++;
				if (bflush) {
					flush_block_only(s, false);
					if (s.strm.avail_out === 0) return BS_NEED_MORE;
				}
			} else if (s.match_available) {
				bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
				if (bflush) flush_block_only(s, false);
				s.strstart++;
				s.lookahead--;
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			} else {
				s.match_available = 1;
				s.strstart++;
				s.lookahead--;
			}
		}
		if (s.match_available) {
			bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
			s.match_available = 0;
		}
		s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
		if (flush === Z_FINISH$2) {
			flush_block_only(s, true);
			if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
			return BS_FINISH_DONE;
		}
		if (s.last_lit) {
			flush_block_only(s, false);
			if (s.strm.avail_out === 0) return BS_NEED_MORE;
		}
		return BS_BLOCK_DONE;
	}
	function deflate_rle(s, flush) {
		var bflush;
		var prev;
		var scan, strend;
		var _win = s.window;
		for (;;) {
			if (s.lookahead <= MAX_MATCH) {
				fill_window(s);
				if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$1) return BS_NEED_MORE;
				if (s.lookahead === 0) break;
			}
			s.match_length = 0;
			if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
				scan = s.strstart - 1;
				prev = _win[scan];
				if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
					strend = s.strstart + MAX_MATCH;
					do					;
while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
					s.match_length = MAX_MATCH - (strend - scan);
					if (s.match_length > s.lookahead) s.match_length = s.lookahead;
				}
			}
			if (s.match_length >= MIN_MATCH) {
				bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
				s.lookahead -= s.match_length;
				s.strstart += s.match_length;
				s.match_length = 0;
			} else {
				bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
				s.lookahead--;
				s.strstart++;
			}
			if (bflush) {
				flush_block_only(s, false);
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			}
		}
		s.insert = 0;
		if (flush === Z_FINISH$2) {
			flush_block_only(s, true);
			if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
			return BS_FINISH_DONE;
		}
		if (s.last_lit) {
			flush_block_only(s, false);
			if (s.strm.avail_out === 0) return BS_NEED_MORE;
		}
		return BS_BLOCK_DONE;
	}
	function deflate_huff(s, flush) {
		var bflush;
		for (;;) {
			if (s.lookahead === 0) {
				fill_window(s);
				if (s.lookahead === 0) {
					if (flush === Z_NO_FLUSH$1) return BS_NEED_MORE;
					break;
				}
			}
			s.match_length = 0;
			bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
			s.lookahead--;
			s.strstart++;
			if (bflush) {
				flush_block_only(s, false);
				if (s.strm.avail_out === 0) return BS_NEED_MORE;
			}
		}
		s.insert = 0;
		if (flush === Z_FINISH$2) {
			flush_block_only(s, true);
			if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
			return BS_FINISH_DONE;
		}
		if (s.last_lit) {
			flush_block_only(s, false);
			if (s.strm.avail_out === 0) return BS_NEED_MORE;
		}
		return BS_BLOCK_DONE;
	}
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
		this.good_length = good_length;
		this.max_lazy = max_lazy;
		this.nice_length = nice_length;
		this.max_chain = max_chain;
		this.func = func;
	}
	var configuration_table = [
		new Config(0, 0, 0, 0, deflate_stored),
		new Config(4, 4, 8, 4, deflate_fast),
		new Config(4, 5, 16, 8, deflate_fast),
		new Config(4, 6, 32, 32, deflate_fast),
		new Config(4, 4, 16, 16, deflate_slow),
		new Config(8, 16, 32, 32, deflate_slow),
		new Config(8, 16, 128, 128, deflate_slow),
		new Config(8, 32, 128, 256, deflate_slow),
		new Config(32, 128, 258, 1024, deflate_slow),
		new Config(32, 258, 258, 4096, deflate_slow)
	];
	function lm_init(s) {
		s.window_size = 2 * s.w_size;
		zero(s.head);
		s.max_lazy_match = configuration_table[s.level].max_lazy;
		s.good_match = configuration_table[s.level].good_length;
		s.nice_match = configuration_table[s.level].nice_length;
		s.max_chain_length = configuration_table[s.level].max_chain;
		s.strstart = 0;
		s.block_start = 0;
		s.lookahead = 0;
		s.insert = 0;
		s.match_length = s.prev_length = MIN_MATCH - 1;
		s.match_available = 0;
		s.ins_h = 0;
	}
	function DeflateState() {
		this.strm = null;
		this.status = 0;
		this.pending_buf = null;
		this.pending_buf_size = 0;
		this.pending_out = 0;
		this.pending = 0;
		this.wrap = 0;
		this.gzhead = null;
		this.gzindex = 0;
		this.method = Z_DEFLATED$2;
		this.last_flush = -1;
		this.w_size = 0;
		this.w_bits = 0;
		this.w_mask = 0;
		this.window = null;
		this.window_size = 0;
		this.prev = null;
		this.head = null;
		this.ins_h = 0;
		this.hash_size = 0;
		this.hash_bits = 0;
		this.hash_mask = 0;
		this.hash_shift = 0;
		this.block_start = 0;
		this.match_length = 0;
		this.prev_match = 0;
		this.match_available = 0;
		this.strstart = 0;
		this.match_start = 0;
		this.lookahead = 0;
		this.prev_length = 0;
		this.max_chain_length = 0;
		this.max_lazy_match = 0;
		this.level = 0;
		this.strategy = 0;
		this.good_match = 0;
		this.nice_match = 0;
		this.dyn_ltree = new utils$5.Buf16(HEAP_SIZE * 2);
		this.dyn_dtree = new utils$5.Buf16((2 * D_CODES + 1) * 2);
		this.bl_tree = new utils$5.Buf16((2 * BL_CODES + 1) * 2);
		zero(this.dyn_ltree);
		zero(this.dyn_dtree);
		zero(this.bl_tree);
		this.l_desc = null;
		this.d_desc = null;
		this.bl_desc = null;
		this.bl_count = new utils$5.Buf16(MAX_BITS + 1);
		this.heap = new utils$5.Buf16(2 * L_CODES + 1);
		zero(this.heap);
		this.heap_len = 0;
		this.heap_max = 0;
		this.depth = new utils$5.Buf16(2 * L_CODES + 1);
		zero(this.depth);
		this.l_buf = 0;
		this.lit_bufsize = 0;
		this.last_lit = 0;
		this.d_buf = 0;
		this.opt_len = 0;
		this.static_len = 0;
		this.matches = 0;
		this.insert = 0;
		this.bi_buf = 0;
		this.bi_valid = 0;
	}
	function deflateResetKeep(strm) {
		var s;
		if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR$1);
		strm.total_in = strm.total_out = 0;
		strm.data_type = Z_UNKNOWN;
		s = strm.state;
		s.pending = 0;
		s.pending_out = 0;
		if (s.wrap < 0) s.wrap = -s.wrap;
		s.status = s.wrap ? INIT_STATE : BUSY_STATE;
		strm.adler = s.wrap === 2 ? 0 : 1;
		s.last_flush = Z_NO_FLUSH$1;
		trees._tr_init(s);
		return Z_OK$2;
	}
	function deflateReset(strm) {
		var ret = deflateResetKeep(strm);
		if (ret === Z_OK$2) lm_init(strm.state);
		return ret;
	}
	function deflateSetHeader(strm, head) {
		if (!strm || !strm.state) return Z_STREAM_ERROR$1;
		if (strm.state.wrap !== 2) return Z_STREAM_ERROR$1;
		strm.state.gzhead = head;
		return Z_OK$2;
	}
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
		if (!strm) return Z_STREAM_ERROR$1;
		var wrap$1 = 1;
		if (level === Z_DEFAULT_COMPRESSION$1) level = 6;
		if (windowBits < 0) {
			wrap$1 = 0;
			windowBits = -windowBits;
		} else if (windowBits > 15) {
			wrap$1 = 2;
			windowBits -= 16;
		}
		if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR$1);
		if (windowBits === 8) windowBits = 9;
		var s = new DeflateState();
		strm.state = s;
		s.strm = strm;
		s.wrap = wrap$1;
		s.gzhead = null;
		s.w_bits = windowBits;
		s.w_size = 1 << s.w_bits;
		s.w_mask = s.w_size - 1;
		s.hash_bits = memLevel + 7;
		s.hash_size = 1 << s.hash_bits;
		s.hash_mask = s.hash_size - 1;
		s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
		s.window = new utils$5.Buf8(s.w_size * 2);
		s.head = new utils$5.Buf16(s.hash_size);
		s.prev = new utils$5.Buf16(s.w_size);
		s.lit_bufsize = 1 << memLevel + 6;
		s.pending_buf_size = s.lit_bufsize * 4;
		s.pending_buf = new utils$5.Buf8(s.pending_buf_size);
		s.d_buf = 1 * s.lit_bufsize;
		s.l_buf = 3 * s.lit_bufsize;
		s.level = level;
		s.strategy = strategy;
		s.method = method;
		return deflateReset(strm);
	}
	function deflateInit(strm, level) {
		return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
	}
	function deflate$2(strm, flush) {
		var old_flush, s;
		var beg, val;
		if (!strm || !strm.state || flush > Z_BLOCK$1 || flush < 0) return strm ? err(strm, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
		s = strm.state;
		if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH$2) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
		s.strm = strm;
		old_flush = s.last_flush;
		s.last_flush = flush;
		if (s.status === INIT_STATE) if (s.wrap === 2) {
			strm.adler = 0;
			put_byte(s, 31);
			put_byte(s, 139);
			put_byte(s, 8);
			if (!s.gzhead) {
				put_byte(s, 0);
				put_byte(s, 0);
				put_byte(s, 0);
				put_byte(s, 0);
				put_byte(s, 0);
				put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
				put_byte(s, OS_CODE);
				s.status = BUSY_STATE;
			} else {
				put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
				put_byte(s, s.gzhead.time & 255);
				put_byte(s, s.gzhead.time >> 8 & 255);
				put_byte(s, s.gzhead.time >> 16 & 255);
				put_byte(s, s.gzhead.time >> 24 & 255);
				put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
				put_byte(s, s.gzhead.os & 255);
				if (s.gzhead.extra && s.gzhead.extra.length) {
					put_byte(s, s.gzhead.extra.length & 255);
					put_byte(s, s.gzhead.extra.length >> 8 & 255);
				}
				if (s.gzhead.hcrc) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending, 0);
				s.gzindex = 0;
				s.status = EXTRA_STATE;
			}
		} else {
			var header = Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
			var level_flags = -1;
			if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
			else if (s.level < 6) level_flags = 1;
			else if (s.level === 6) level_flags = 2;
			else level_flags = 3;
			header |= level_flags << 6;
			if (s.strstart !== 0) header |= PRESET_DICT;
			header += 31 - header % 31;
			s.status = BUSY_STATE;
			putShortMSB(s, header);
			if (s.strstart !== 0) {
				putShortMSB(s, strm.adler >>> 16);
				putShortMSB(s, strm.adler & 65535);
			}
			strm.adler = 1;
		}
		if (s.status === EXTRA_STATE) if (s.gzhead.extra) {
			beg = s.pending;
			while (s.gzindex < (s.gzhead.extra.length & 65535)) {
				if (s.pending === s.pending_buf_size) {
					if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
					flush_pending(strm);
					beg = s.pending;
					if (s.pending === s.pending_buf_size) break;
				}
				put_byte(s, s.gzhead.extra[s.gzindex] & 255);
				s.gzindex++;
			}
			if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
			if (s.gzindex === s.gzhead.extra.length) {
				s.gzindex = 0;
				s.status = NAME_STATE;
			}
		} else s.status = NAME_STATE;
		if (s.status === NAME_STATE) if (s.gzhead.name) {
			beg = s.pending;
			do {
				if (s.pending === s.pending_buf_size) {
					if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
					flush_pending(strm);
					beg = s.pending;
					if (s.pending === s.pending_buf_size) {
						val = 1;
						break;
					}
				}
				if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 255;
				else val = 0;
				put_byte(s, val);
			} while (val !== 0);
			if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
			if (val === 0) {
				s.gzindex = 0;
				s.status = COMMENT_STATE;
			}
		} else s.status = COMMENT_STATE;
		if (s.status === COMMENT_STATE) if (s.gzhead.comment) {
			beg = s.pending;
			do {
				if (s.pending === s.pending_buf_size) {
					if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
					flush_pending(strm);
					beg = s.pending;
					if (s.pending === s.pending_buf_size) {
						val = 1;
						break;
					}
				}
				if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 255;
				else val = 0;
				put_byte(s, val);
			} while (val !== 0);
			if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
			if (val === 0) s.status = HCRC_STATE;
		} else s.status = HCRC_STATE;
		if (s.status === HCRC_STATE) if (s.gzhead.hcrc) {
			if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
			if (s.pending + 2 <= s.pending_buf_size) {
				put_byte(s, strm.adler & 255);
				put_byte(s, strm.adler >> 8 & 255);
				strm.adler = 0;
				s.status = BUSY_STATE;
			}
		} else s.status = BUSY_STATE;
		if (s.pending !== 0) {
			flush_pending(strm);
			if (strm.avail_out === 0) {
				s.last_flush = -1;
				return Z_OK$2;
			}
		} else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$2) return err(strm, Z_BUF_ERROR$1);
		if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR$1);
		if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH$1 && s.status !== FINISH_STATE) {
			var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
			if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
			if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
				if (strm.avail_out === 0) s.last_flush = -1;
				return Z_OK$2;
			}
			if (bstate === BS_BLOCK_DONE) {
				if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
				else if (flush !== Z_BLOCK$1) {
					trees._tr_stored_block(s, 0, 0, false);
					if (flush === Z_FULL_FLUSH) {
						zero(s.head);
						if (s.lookahead === 0) {
							s.strstart = 0;
							s.block_start = 0;
							s.insert = 0;
						}
					}
				}
				flush_pending(strm);
				if (strm.avail_out === 0) {
					s.last_flush = -1;
					return Z_OK$2;
				}
			}
		}
		if (flush !== Z_FINISH$2) return Z_OK$2;
		if (s.wrap <= 0) return Z_STREAM_END$2;
		if (s.wrap === 2) {
			put_byte(s, strm.adler & 255);
			put_byte(s, strm.adler >> 8 & 255);
			put_byte(s, strm.adler >> 16 & 255);
			put_byte(s, strm.adler >> 24 & 255);
			put_byte(s, strm.total_in & 255);
			put_byte(s, strm.total_in >> 8 & 255);
			put_byte(s, strm.total_in >> 16 & 255);
			put_byte(s, strm.total_in >> 24 & 255);
		} else {
			putShortMSB(s, strm.adler >>> 16);
			putShortMSB(s, strm.adler & 65535);
		}
		flush_pending(strm);
		if (s.wrap > 0) s.wrap = -s.wrap;
		return s.pending !== 0 ? Z_OK$2 : Z_STREAM_END$2;
	}
	function deflateEnd(strm) {
		var status;
		if (!strm || !strm.state) return Z_STREAM_ERROR$1;
		status = strm.state.status;
		if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR$1);
		strm.state = null;
		return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$1) : Z_OK$2;
	}
	function deflateSetDictionary(strm, dictionary) {
		var dictLength = dictionary.length;
		var s;
		var str, n;
		var wrap$1;
		var avail;
		var next;
		var input;
		var tmpDict;
		if (!strm || !strm.state) return Z_STREAM_ERROR$1;
		s = strm.state;
		wrap$1 = s.wrap;
		if (wrap$1 === 2 || wrap$1 === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR$1;
		if (wrap$1 === 1) strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
		s.wrap = 0;
		if (dictLength >= s.w_size) {
			if (wrap$1 === 0) {
				zero(s.head);
				s.strstart = 0;
				s.block_start = 0;
				s.insert = 0;
			}
			tmpDict = new utils$5.Buf8(s.w_size);
			utils$5.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
			dictionary = tmpDict;
			dictLength = s.w_size;
		}
		avail = strm.avail_in;
		next = strm.next_in;
		input = strm.input;
		strm.avail_in = dictLength;
		strm.next_in = 0;
		strm.input = dictionary;
		fill_window(s);
		while (s.lookahead >= MIN_MATCH) {
			str = s.strstart;
			n = s.lookahead - (MIN_MATCH - 1);
			do {
				s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
				s.prev[str & s.w_mask] = s.head[s.ins_h];
				s.head[s.ins_h] = str;
				str++;
			} while (--n);
			s.strstart = str;
			s.lookahead = MIN_MATCH - 1;
			fill_window(s);
		}
		s.strstart += s.lookahead;
		s.block_start = s.strstart;
		s.insert = s.lookahead;
		s.lookahead = 0;
		s.match_length = s.prev_length = MIN_MATCH - 1;
		s.match_available = 0;
		strm.next_in = next;
		strm.input = input;
		strm.avail_in = avail;
		s.wrap = wrap$1;
		return Z_OK$2;
	}
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate$2;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = "pako deflate (from Nodeca project)";
}));
var require_strings = /* @__PURE__ */ __commonJSMin(((exports) => {
	var utils$4 = require_common();
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	try {
		String.fromCharCode.apply(null, [0]);
	} catch (__) {
		STR_APPLY_OK = false;
	}
	try {
		String.fromCharCode.apply(null, new Uint8Array(1));
	} catch (__) {
		STR_APPLY_UIA_OK = false;
	}
	var _utf8len = new utils$4.Buf8(256);
	for (var q = 0; q < 256; q++) _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
	_utf8len[254] = _utf8len[254] = 1;
	exports.string2buf = function(str) {
		var buf, c$1, c2, m_pos, i$1, str_len = str.length, buf_len = 0;
		for (m_pos = 0; m_pos < str_len; m_pos++) {
			c$1 = str.charCodeAt(m_pos);
			if ((c$1 & 64512) === 55296 && m_pos + 1 < str_len) {
				c2 = str.charCodeAt(m_pos + 1);
				if ((c2 & 64512) === 56320) {
					c$1 = 65536 + (c$1 - 55296 << 10) + (c2 - 56320);
					m_pos++;
				}
			}
			buf_len += c$1 < 128 ? 1 : c$1 < 2048 ? 2 : c$1 < 65536 ? 3 : 4;
		}
		buf = new utils$4.Buf8(buf_len);
		for (i$1 = 0, m_pos = 0; i$1 < buf_len; m_pos++) {
			c$1 = str.charCodeAt(m_pos);
			if ((c$1 & 64512) === 55296 && m_pos + 1 < str_len) {
				c2 = str.charCodeAt(m_pos + 1);
				if ((c2 & 64512) === 56320) {
					c$1 = 65536 + (c$1 - 55296 << 10) + (c2 - 56320);
					m_pos++;
				}
			}
			if (c$1 < 128) buf[i$1++] = c$1;
			else if (c$1 < 2048) {
				buf[i$1++] = 192 | c$1 >>> 6;
				buf[i$1++] = 128 | c$1 & 63;
			} else if (c$1 < 65536) {
				buf[i$1++] = 224 | c$1 >>> 12;
				buf[i$1++] = 128 | c$1 >>> 6 & 63;
				buf[i$1++] = 128 | c$1 & 63;
			} else {
				buf[i$1++] = 240 | c$1 >>> 18;
				buf[i$1++] = 128 | c$1 >>> 12 & 63;
				buf[i$1++] = 128 | c$1 >>> 6 & 63;
				buf[i$1++] = 128 | c$1 & 63;
			}
		}
		return buf;
	};
	function buf2binstring(buf, len) {
		if (len < 65534) {
			if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) return String.fromCharCode.apply(null, utils$4.shrinkBuf(buf, len));
		}
		var result = "";
		for (var i$1 = 0; i$1 < len; i$1++) result += String.fromCharCode(buf[i$1]);
		return result;
	}
	exports.buf2binstring = function(buf) {
		return buf2binstring(buf, buf.length);
	};
	exports.binstring2buf = function(str) {
		var buf = new utils$4.Buf8(str.length);
		for (var i$1 = 0, len = buf.length; i$1 < len; i$1++) buf[i$1] = str.charCodeAt(i$1);
		return buf;
	};
	exports.buf2string = function(buf, max) {
		var i$1, out, c$1, c_len;
		var len = max || buf.length;
		var utf16buf = new Array(len * 2);
		for (out = 0, i$1 = 0; i$1 < len;) {
			c$1 = buf[i$1++];
			if (c$1 < 128) {
				utf16buf[out++] = c$1;
				continue;
			}
			c_len = _utf8len[c$1];
			if (c_len > 4) {
				utf16buf[out++] = 65533;
				i$1 += c_len - 1;
				continue;
			}
			c$1 &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7;
			while (c_len > 1 && i$1 < len) {
				c$1 = c$1 << 6 | buf[i$1++] & 63;
				c_len--;
			}
			if (c_len > 1) {
				utf16buf[out++] = 65533;
				continue;
			}
			if (c$1 < 65536) utf16buf[out++] = c$1;
			else {
				c$1 -= 65536;
				utf16buf[out++] = 55296 | c$1 >> 10 & 1023;
				utf16buf[out++] = 56320 | c$1 & 1023;
			}
		}
		return buf2binstring(utf16buf, out);
	};
	exports.utf8border = function(buf, max) {
		var pos;
		max = max || buf.length;
		if (max > buf.length) max = buf.length;
		pos = max - 1;
		while (pos >= 0 && (buf[pos] & 192) === 128) pos--;
		if (pos < 0) return max;
		if (pos === 0) return max;
		return pos + _utf8len[buf[pos]] > max ? pos : max;
	};
}));
var require_zstream = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function ZStream$2() {
		this.input = null;
		this.next_in = 0;
		this.avail_in = 0;
		this.total_in = 0;
		this.output = null;
		this.next_out = 0;
		this.avail_out = 0;
		this.total_out = 0;
		this.msg = "";
		this.state = null;
		this.data_type = 2;
		this.adler = 0;
	}
	module.exports = ZStream$2;
}));
var require_deflate = /* @__PURE__ */ __commonJSMin(((exports) => {
	var zlib_deflate = require_deflate$1();
	var utils$3 = require_common();
	var strings$1 = require_strings();
	var msg$1 = require_messages();
	var ZStream$1 = require_zstream();
	var toString$2 = Object.prototype.toString;
	var Z_NO_FLUSH = 0;
	var Z_FINISH$1 = 4;
	var Z_OK$1 = 0;
	var Z_STREAM_END$1 = 1;
	var Z_SYNC_FLUSH = 2;
	var Z_DEFAULT_COMPRESSION = -1;
	var Z_DEFAULT_STRATEGY = 0;
	var Z_DEFLATED$1 = 8;
	function Deflate(options) {
		if (!(this instanceof Deflate)) return new Deflate(options);
		this.options = utils$3.assign({
			level: Z_DEFAULT_COMPRESSION,
			method: Z_DEFLATED$1,
			chunkSize: 16384,
			windowBits: 15,
			memLevel: 8,
			strategy: Z_DEFAULT_STRATEGY,
			to: ""
		}, options || {});
		var opt = this.options;
		if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
		else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
		this.err = 0;
		this.msg = "";
		this.ended = false;
		this.chunks = [];
		this.strm = new ZStream$1();
		this.strm.avail_out = 0;
		var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
		if (status !== Z_OK$1) throw new Error(msg$1[status]);
		if (opt.header) zlib_deflate.deflateSetHeader(this.strm, opt.header);
		if (opt.dictionary) {
			var dict;
			if (typeof opt.dictionary === "string") dict = strings$1.string2buf(opt.dictionary);
			else if (toString$2.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
			else dict = opt.dictionary;
			status = zlib_deflate.deflateSetDictionary(this.strm, dict);
			if (status !== Z_OK$1) throw new Error(msg$1[status]);
			this._dict_set = true;
		}
	}
	Deflate.prototype.push = function(data, mode) {
		var strm = this.strm;
		var chunkSize = this.options.chunkSize;
		var status, _mode;
		if (this.ended) return false;
		_mode = mode === ~~mode ? mode : mode === true ? Z_FINISH$1 : Z_NO_FLUSH;
		if (typeof data === "string") strm.input = strings$1.string2buf(data);
		else if (toString$2.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
		else strm.input = data;
		strm.next_in = 0;
		strm.avail_in = strm.input.length;
		do {
			if (strm.avail_out === 0) {
				strm.output = new utils$3.Buf8(chunkSize);
				strm.next_out = 0;
				strm.avail_out = chunkSize;
			}
			status = zlib_deflate.deflate(strm, _mode);
			if (status !== Z_STREAM_END$1 && status !== Z_OK$1) {
				this.onEnd(status);
				this.ended = true;
				return false;
			}
			if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH$1 || _mode === Z_SYNC_FLUSH)) if (this.options.to === "string") this.onData(strings$1.buf2binstring(utils$3.shrinkBuf(strm.output, strm.next_out)));
			else this.onData(utils$3.shrinkBuf(strm.output, strm.next_out));
		} while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END$1);
		if (_mode === Z_FINISH$1) {
			status = zlib_deflate.deflateEnd(this.strm);
			this.onEnd(status);
			this.ended = true;
			return status === Z_OK$1;
		}
		if (_mode === Z_SYNC_FLUSH) {
			this.onEnd(Z_OK$1);
			strm.avail_out = 0;
			return true;
		}
		return true;
	};
	Deflate.prototype.onData = function(chunk) {
		this.chunks.push(chunk);
	};
	Deflate.prototype.onEnd = function(status) {
		if (status === Z_OK$1) if (this.options.to === "string") this.result = this.chunks.join("");
		else this.result = utils$3.flattenChunks(this.chunks);
		this.chunks = [];
		this.err = status;
		this.msg = this.strm.msg;
	};
	function deflate$1(input, options) {
		var deflator = new Deflate(options);
		deflator.push(input, true);
		if (deflator.err) throw deflator.msg || msg$1[deflator.err];
		return deflator.result;
	}
	function deflateRaw(input, options) {
		options = options || {};
		options.raw = true;
		return deflate$1(input, options);
	}
	function gzip(input, options) {
		options = options || {};
		options.gzip = true;
		return deflate$1(input, options);
	}
	exports.Deflate = Deflate;
	exports.deflate = deflate$1;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
}));
var require_inffast = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var BAD$1 = 30;
	var TYPE$1 = 12;
	module.exports = function inflate_fast$1(strm, start) {
		var state;
		var _in;
		var last;
		var _out;
		var beg;
		var end;
		var dmax;
		var wsize;
		var whave;
		var wnext;
		var s_window;
		var hold;
		var bits;
		var lcode;
		var dcode;
		var lmask;
		var dmask;
		var here;
		var op;
		var len;
		var dist;
		var from;
		var from_source;
		var input, output;
		state = strm.state;
		_in = strm.next_in;
		input = strm.input;
		last = _in + (strm.avail_in - 5);
		_out = strm.next_out;
		output = strm.output;
		beg = _out - (start - strm.avail_out);
		end = _out + (strm.avail_out - 257);
		dmax = state.dmax;
		wsize = state.wsize;
		whave = state.whave;
		wnext = state.wnext;
		s_window = state.window;
		hold = state.hold;
		bits = state.bits;
		lcode = state.lencode;
		dcode = state.distcode;
		lmask = (1 << state.lenbits) - 1;
		dmask = (1 << state.distbits) - 1;
		top: do {
			if (bits < 15) {
				hold += input[_in++] << bits;
				bits += 8;
				hold += input[_in++] << bits;
				bits += 8;
			}
			here = lcode[hold & lmask];
			dolen: for (;;) {
				op = here >>> 24;
				hold >>>= op;
				bits -= op;
				op = here >>> 16 & 255;
				if (op === 0) output[_out++] = here & 65535;
				else if (op & 16) {
					len = here & 65535;
					op &= 15;
					if (op) {
						if (bits < op) {
							hold += input[_in++] << bits;
							bits += 8;
						}
						len += hold & (1 << op) - 1;
						hold >>>= op;
						bits -= op;
					}
					if (bits < 15) {
						hold += input[_in++] << bits;
						bits += 8;
						hold += input[_in++] << bits;
						bits += 8;
					}
					here = dcode[hold & dmask];
					dodist: for (;;) {
						op = here >>> 24;
						hold >>>= op;
						bits -= op;
						op = here >>> 16 & 255;
						if (op & 16) {
							dist = here & 65535;
							op &= 15;
							if (bits < op) {
								hold += input[_in++] << bits;
								bits += 8;
								if (bits < op) {
									hold += input[_in++] << bits;
									bits += 8;
								}
							}
							dist += hold & (1 << op) - 1;
							if (dist > dmax) {
								strm.msg = "invalid distance too far back";
								state.mode = BAD$1;
								break top;
							}
							hold >>>= op;
							bits -= op;
							op = _out - beg;
							if (dist > op) {
								op = dist - op;
								if (op > whave) {
									if (state.sane) {
										strm.msg = "invalid distance too far back";
										state.mode = BAD$1;
										break top;
									}
								}
								from = 0;
								from_source = s_window;
								if (wnext === 0) {
									from += wsize - op;
									if (op < len) {
										len -= op;
										do
											output[_out++] = s_window[from++];
										while (--op);
										from = _out - dist;
										from_source = output;
									}
								} else if (wnext < op) {
									from += wsize + wnext - op;
									op -= wnext;
									if (op < len) {
										len -= op;
										do
											output[_out++] = s_window[from++];
										while (--op);
										from = 0;
										if (wnext < len) {
											op = wnext;
											len -= op;
											do
												output[_out++] = s_window[from++];
											while (--op);
											from = _out - dist;
											from_source = output;
										}
									}
								} else {
									from += wnext - op;
									if (op < len) {
										len -= op;
										do
											output[_out++] = s_window[from++];
										while (--op);
										from = _out - dist;
										from_source = output;
									}
								}
								while (len > 2) {
									output[_out++] = from_source[from++];
									output[_out++] = from_source[from++];
									output[_out++] = from_source[from++];
									len -= 3;
								}
								if (len) {
									output[_out++] = from_source[from++];
									if (len > 1) output[_out++] = from_source[from++];
								}
							} else {
								from = _out - dist;
								do {
									output[_out++] = output[from++];
									output[_out++] = output[from++];
									output[_out++] = output[from++];
									len -= 3;
								} while (len > 2);
								if (len) {
									output[_out++] = output[from++];
									if (len > 1) output[_out++] = output[from++];
								}
							}
						} else if ((op & 64) === 0) {
							here = dcode[(here & 65535) + (hold & (1 << op) - 1)];
							continue dodist;
						} else {
							strm.msg = "invalid distance code";
							state.mode = BAD$1;
							break top;
						}
						break;
					}
				} else if ((op & 64) === 0) {
					here = lcode[(here & 65535) + (hold & (1 << op) - 1)];
					continue dolen;
				} else if (op & 32) {
					state.mode = TYPE$1;
					break top;
				} else {
					strm.msg = "invalid literal/length code";
					state.mode = BAD$1;
					break top;
				}
				break;
			}
		} while (_in < last && _out < end);
		len = bits >> 3;
		_in -= len;
		bits -= len << 3;
		hold &= (1 << bits) - 1;
		strm.next_in = _in;
		strm.next_out = _out;
		strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
		strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
		state.hold = hold;
		state.bits = bits;
	};
}));
var require_inftrees = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var utils$2 = require_common();
	var MAXBITS = 15;
	var ENOUGH_LENS$1 = 852;
	var ENOUGH_DISTS$1 = 592;
	var CODES$1 = 0;
	var LENS$1 = 1;
	var DISTS$1 = 2;
	var lbase = [
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		13,
		15,
		17,
		19,
		23,
		27,
		31,
		35,
		43,
		51,
		59,
		67,
		83,
		99,
		115,
		131,
		163,
		195,
		227,
		258,
		0,
		0
	];
	var lext = [
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		17,
		17,
		17,
		17,
		18,
		18,
		18,
		18,
		19,
		19,
		19,
		19,
		20,
		20,
		20,
		20,
		21,
		21,
		21,
		21,
		16,
		72,
		78
	];
	var dbase = [
		1,
		2,
		3,
		4,
		5,
		7,
		9,
		13,
		17,
		25,
		33,
		49,
		65,
		97,
		129,
		193,
		257,
		385,
		513,
		769,
		1025,
		1537,
		2049,
		3073,
		4097,
		6145,
		8193,
		12289,
		16385,
		24577,
		0,
		0
	];
	var dext = [
		16,
		16,
		16,
		16,
		17,
		17,
		18,
		18,
		19,
		19,
		20,
		20,
		21,
		21,
		22,
		22,
		23,
		23,
		24,
		24,
		25,
		25,
		26,
		26,
		27,
		27,
		28,
		28,
		29,
		29,
		64,
		64
	];
	module.exports = function inflate_table$1(type, lens, lens_index, codes, table, table_index, work, opts) {
		var bits = opts.bits;
		var len = 0;
		var sym = 0;
		var min = 0, max = 0;
		var root = 0;
		var curr = 0;
		var drop = 0;
		var left = 0;
		var used = 0;
		var huff = 0;
		var incr;
		var fill;
		var low;
		var mask;
		var next;
		var base$1 = null;
		var base_index = 0;
		var end;
		var count = new utils$2.Buf16(MAXBITS + 1);
		var offs = new utils$2.Buf16(MAXBITS + 1);
		var extra = null;
		var extra_index = 0;
		var here_bits, here_op, here_val;
		for (len = 0; len <= MAXBITS; len++) count[len] = 0;
		for (sym = 0; sym < codes; sym++) count[lens[lens_index + sym]]++;
		root = bits;
		for (max = MAXBITS; max >= 1; max--) if (count[max] !== 0) break;
		if (root > max) root = max;
		if (max === 0) {
			table[table_index++] = 20971520;
			table[table_index++] = 20971520;
			opts.bits = 1;
			return 0;
		}
		for (min = 1; min < max; min++) if (count[min] !== 0) break;
		if (root < min) root = min;
		left = 1;
		for (len = 1; len <= MAXBITS; len++) {
			left <<= 1;
			left -= count[len];
			if (left < 0) return -1;
		}
		if (left > 0 && (type === CODES$1 || max !== 1)) return -1;
		offs[1] = 0;
		for (len = 1; len < MAXBITS; len++) offs[len + 1] = offs[len] + count[len];
		for (sym = 0; sym < codes; sym++) if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
		if (type === CODES$1) {
			base$1 = extra = work;
			end = 19;
		} else if (type === LENS$1) {
			base$1 = lbase;
			base_index -= 257;
			extra = lext;
			extra_index -= 257;
			end = 256;
		} else {
			base$1 = dbase;
			extra = dext;
			end = -1;
		}
		huff = 0;
		sym = 0;
		len = min;
		next = table_index;
		curr = root;
		drop = 0;
		low = -1;
		used = 1 << root;
		mask = used - 1;
		if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
		for (;;) {
			here_bits = len - drop;
			if (work[sym] < end) {
				here_op = 0;
				here_val = work[sym];
			} else if (work[sym] > end) {
				here_op = extra[extra_index + work[sym]];
				here_val = base$1[base_index + work[sym]];
			} else {
				here_op = 96;
				here_val = 0;
			}
			incr = 1 << len - drop;
			fill = 1 << curr;
			min = fill;
			do {
				fill -= incr;
				table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
			} while (fill !== 0);
			incr = 1 << len - 1;
			while (huff & incr) incr >>= 1;
			if (incr !== 0) {
				huff &= incr - 1;
				huff += incr;
			} else huff = 0;
			sym++;
			if (--count[len] === 0) {
				if (len === max) break;
				len = lens[lens_index + work[sym]];
			}
			if (len > root && (huff & mask) !== low) {
				if (drop === 0) drop = root;
				next += min;
				curr = len - drop;
				left = 1 << curr;
				while (curr + drop < max) {
					left -= count[curr + drop];
					if (left <= 0) break;
					curr++;
					left <<= 1;
				}
				used += 1 << curr;
				if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
				low = huff & mask;
				table[low] = root << 24 | curr << 16 | next - table_index | 0;
			}
		}
		if (huff !== 0) table[next + huff] = len - drop << 24 | 4194304;
		opts.bits = root;
		return 0;
	};
}));
var require_inflate$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	var utils$1 = require_common();
	var adler32 = require_adler32();
	var crc32 = require_crc32();
	var inflate_fast = require_inffast();
	var inflate_table = require_inftrees();
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	var Z_FINISH = 4;
	var Z_BLOCK = 5;
	var Z_TREES = 6;
	var Z_OK = 0;
	var Z_STREAM_END = 1;
	var Z_NEED_DICT = 2;
	var Z_STREAM_ERROR = -2;
	var Z_DATA_ERROR = -3;
	var Z_MEM_ERROR = -4;
	var Z_BUF_ERROR = -5;
	var Z_DEFLATED = 8;
	var HEAD = 1;
	var FLAGS = 2;
	var TIME = 3;
	var OS = 4;
	var EXLEN = 5;
	var EXTRA = 6;
	var NAME = 7;
	var COMMENT = 8;
	var HCRC = 9;
	var DICTID = 10;
	var DICT = 11;
	var TYPE = 12;
	var TYPEDO = 13;
	var STORED = 14;
	var COPY_ = 15;
	var COPY = 16;
	var TABLE = 17;
	var LENLENS = 18;
	var CODELENS = 19;
	var LEN_ = 20;
	var LEN = 21;
	var LENEXT = 22;
	var DIST = 23;
	var DISTEXT = 24;
	var MATCH = 25;
	var LIT = 26;
	var CHECK = 27;
	var LENGTH = 28;
	var DONE = 29;
	var BAD = 30;
	var MEM = 31;
	var SYNC = 32;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	var DEF_WBITS = 15;
	function zswap32(q$1) {
		return (q$1 >>> 24 & 255) + (q$1 >>> 8 & 65280) + ((q$1 & 65280) << 8) + ((q$1 & 255) << 24);
	}
	function InflateState() {
		this.mode = 0;
		this.last = false;
		this.wrap = 0;
		this.havedict = false;
		this.flags = 0;
		this.dmax = 0;
		this.check = 0;
		this.total = 0;
		this.head = null;
		this.wbits = 0;
		this.wsize = 0;
		this.whave = 0;
		this.wnext = 0;
		this.window = null;
		this.hold = 0;
		this.bits = 0;
		this.length = 0;
		this.offset = 0;
		this.extra = 0;
		this.lencode = null;
		this.distcode = null;
		this.lenbits = 0;
		this.distbits = 0;
		this.ncode = 0;
		this.nlen = 0;
		this.ndist = 0;
		this.have = 0;
		this.next = null;
		this.lens = new utils$1.Buf16(320);
		this.work = new utils$1.Buf16(288);
		this.lendyn = null;
		this.distdyn = null;
		this.sane = 0;
		this.back = 0;
		this.was = 0;
	}
	function inflateResetKeep(strm) {
		var state;
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		state = strm.state;
		strm.total_in = strm.total_out = state.total = 0;
		strm.msg = "";
		if (state.wrap) strm.adler = state.wrap & 1;
		state.mode = HEAD;
		state.last = 0;
		state.havedict = 0;
		state.dmax = 32768;
		state.head = null;
		state.hold = 0;
		state.bits = 0;
		state.lencode = state.lendyn = new utils$1.Buf32(ENOUGH_LENS);
		state.distcode = state.distdyn = new utils$1.Buf32(ENOUGH_DISTS);
		state.sane = 1;
		state.back = -1;
		return Z_OK;
	}
	function inflateReset(strm) {
		var state;
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		state = strm.state;
		state.wsize = 0;
		state.whave = 0;
		state.wnext = 0;
		return inflateResetKeep(strm);
	}
	function inflateReset2(strm, windowBits) {
		var wrap$1;
		var state;
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		state = strm.state;
		if (windowBits < 0) {
			wrap$1 = 0;
			windowBits = -windowBits;
		} else {
			wrap$1 = (windowBits >> 4) + 1;
			if (windowBits < 48) windowBits &= 15;
		}
		if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
		if (state.window !== null && state.wbits !== windowBits) state.window = null;
		state.wrap = wrap$1;
		state.wbits = windowBits;
		return inflateReset(strm);
	}
	function inflateInit2(strm, windowBits) {
		var ret;
		var state;
		if (!strm) return Z_STREAM_ERROR;
		state = new InflateState();
		strm.state = state;
		state.window = null;
		ret = inflateReset2(strm, windowBits);
		if (ret !== Z_OK) strm.state = null;
		return ret;
	}
	function inflateInit(strm) {
		return inflateInit2(strm, DEF_WBITS);
	}
	var virgin = true;
	var lenfix, distfix;
	function fixedtables(state) {
		if (virgin) {
			var sym;
			lenfix = new utils$1.Buf32(512);
			distfix = new utils$1.Buf32(32);
			sym = 0;
			while (sym < 144) state.lens[sym++] = 8;
			while (sym < 256) state.lens[sym++] = 9;
			while (sym < 280) state.lens[sym++] = 7;
			while (sym < 288) state.lens[sym++] = 8;
			inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 });
			sym = 0;
			while (sym < 32) state.lens[sym++] = 5;
			inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 });
			virgin = false;
		}
		state.lencode = lenfix;
		state.lenbits = 9;
		state.distcode = distfix;
		state.distbits = 5;
	}
	function updatewindow(strm, src, end, copy$1) {
		var dist;
		var state = strm.state;
		if (state.window === null) {
			state.wsize = 1 << state.wbits;
			state.wnext = 0;
			state.whave = 0;
			state.window = new utils$1.Buf8(state.wsize);
		}
		if (copy$1 >= state.wsize) {
			utils$1.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
			state.wnext = 0;
			state.whave = state.wsize;
		} else {
			dist = state.wsize - state.wnext;
			if (dist > copy$1) dist = copy$1;
			utils$1.arraySet(state.window, src, end - copy$1, dist, state.wnext);
			copy$1 -= dist;
			if (copy$1) {
				utils$1.arraySet(state.window, src, end - copy$1, copy$1, 0);
				state.wnext = copy$1;
				state.whave = state.wsize;
			} else {
				state.wnext += dist;
				if (state.wnext === state.wsize) state.wnext = 0;
				if (state.whave < state.wsize) state.whave += dist;
			}
		}
		return 0;
	}
	function inflate$2(strm, flush) {
		var state;
		var input, output;
		var next;
		var put;
		var have, left;
		var hold;
		var bits;
		var _in, _out;
		var copy$1;
		var from;
		var from_source;
		var here = 0;
		var here_bits, here_op, here_val;
		var last_bits, last_op, last_val;
		var len;
		var ret;
		var hbuf = new utils$1.Buf8(4);
		var opts;
		var n;
		var order = [
			16,
			17,
			18,
			0,
			8,
			7,
			9,
			6,
			10,
			5,
			11,
			4,
			12,
			3,
			13,
			2,
			14,
			1,
			15
		];
		if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
		state = strm.state;
		if (state.mode === TYPE) state.mode = TYPEDO;
		put = strm.next_out;
		output = strm.output;
		left = strm.avail_out;
		next = strm.next_in;
		input = strm.input;
		have = strm.avail_in;
		hold = state.hold;
		bits = state.bits;
		_in = have;
		_out = left;
		ret = Z_OK;
		inf_leave: for (;;) switch (state.mode) {
			case HEAD:
				if (state.wrap === 0) {
					state.mode = TYPEDO;
					break;
				}
				while (bits < 16) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if (state.wrap & 2 && hold === 35615) {
					state.check = 0;
					hbuf[0] = hold & 255;
					hbuf[1] = hold >>> 8 & 255;
					state.check = crc32(state.check, hbuf, 2, 0);
					hold = 0;
					bits = 0;
					state.mode = FLAGS;
					break;
				}
				state.flags = 0;
				if (state.head) state.head.done = false;
				if (!(state.wrap & 1) || (((hold & 255) << 8) + (hold >> 8)) % 31) {
					strm.msg = "incorrect header check";
					state.mode = BAD;
					break;
				}
				if ((hold & 15) !== Z_DEFLATED) {
					strm.msg = "unknown compression method";
					state.mode = BAD;
					break;
				}
				hold >>>= 4;
				bits -= 4;
				len = (hold & 15) + 8;
				if (state.wbits === 0) state.wbits = len;
				else if (len > state.wbits) {
					strm.msg = "invalid window size";
					state.mode = BAD;
					break;
				}
				state.dmax = 1 << len;
				strm.adler = state.check = 1;
				state.mode = hold & 512 ? DICTID : TYPE;
				hold = 0;
				bits = 0;
				break;
			case FLAGS:
				while (bits < 16) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				state.flags = hold;
				if ((state.flags & 255) !== Z_DEFLATED) {
					strm.msg = "unknown compression method";
					state.mode = BAD;
					break;
				}
				if (state.flags & 57344) {
					strm.msg = "unknown header flags set";
					state.mode = BAD;
					break;
				}
				if (state.head) state.head.text = hold >> 8 & 1;
				if (state.flags & 512) {
					hbuf[0] = hold & 255;
					hbuf[1] = hold >>> 8 & 255;
					state.check = crc32(state.check, hbuf, 2, 0);
				}
				hold = 0;
				bits = 0;
				state.mode = TIME;
			case TIME:
				while (bits < 32) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if (state.head) state.head.time = hold;
				if (state.flags & 512) {
					hbuf[0] = hold & 255;
					hbuf[1] = hold >>> 8 & 255;
					hbuf[2] = hold >>> 16 & 255;
					hbuf[3] = hold >>> 24 & 255;
					state.check = crc32(state.check, hbuf, 4, 0);
				}
				hold = 0;
				bits = 0;
				state.mode = OS;
			case OS:
				while (bits < 16) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if (state.head) {
					state.head.xflags = hold & 255;
					state.head.os = hold >> 8;
				}
				if (state.flags & 512) {
					hbuf[0] = hold & 255;
					hbuf[1] = hold >>> 8 & 255;
					state.check = crc32(state.check, hbuf, 2, 0);
				}
				hold = 0;
				bits = 0;
				state.mode = EXLEN;
			case EXLEN:
				if (state.flags & 1024) {
					while (bits < 16) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					state.length = hold;
					if (state.head) state.head.extra_len = hold;
					if (state.flags & 512) {
						hbuf[0] = hold & 255;
						hbuf[1] = hold >>> 8 & 255;
						state.check = crc32(state.check, hbuf, 2, 0);
					}
					hold = 0;
					bits = 0;
				} else if (state.head) state.head.extra = null;
				state.mode = EXTRA;
			case EXTRA:
				if (state.flags & 1024) {
					copy$1 = state.length;
					if (copy$1 > have) copy$1 = have;
					if (copy$1) {
						if (state.head) {
							len = state.head.extra_len - state.length;
							if (!state.head.extra) state.head.extra = new Array(state.head.extra_len);
							utils$1.arraySet(state.head.extra, input, next, copy$1, len);
						}
						if (state.flags & 512) state.check = crc32(state.check, input, copy$1, next);
						have -= copy$1;
						next += copy$1;
						state.length -= copy$1;
					}
					if (state.length) break inf_leave;
				}
				state.length = 0;
				state.mode = NAME;
			case NAME:
				if (state.flags & 2048) {
					if (have === 0) break inf_leave;
					copy$1 = 0;
					do {
						len = input[next + copy$1++];
						if (state.head && len && state.length < 65536) state.head.name += String.fromCharCode(len);
					} while (len && copy$1 < have);
					if (state.flags & 512) state.check = crc32(state.check, input, copy$1, next);
					have -= copy$1;
					next += copy$1;
					if (len) break inf_leave;
				} else if (state.head) state.head.name = null;
				state.length = 0;
				state.mode = COMMENT;
			case COMMENT:
				if (state.flags & 4096) {
					if (have === 0) break inf_leave;
					copy$1 = 0;
					do {
						len = input[next + copy$1++];
						if (state.head && len && state.length < 65536) state.head.comment += String.fromCharCode(len);
					} while (len && copy$1 < have);
					if (state.flags & 512) state.check = crc32(state.check, input, copy$1, next);
					have -= copy$1;
					next += copy$1;
					if (len) break inf_leave;
				} else if (state.head) state.head.comment = null;
				state.mode = HCRC;
			case HCRC:
				if (state.flags & 512) {
					while (bits < 16) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					if (hold !== (state.check & 65535)) {
						strm.msg = "header crc mismatch";
						state.mode = BAD;
						break;
					}
					hold = 0;
					bits = 0;
				}
				if (state.head) {
					state.head.hcrc = state.flags >> 9 & 1;
					state.head.done = true;
				}
				strm.adler = state.check = 0;
				state.mode = TYPE;
				break;
			case DICTID:
				while (bits < 32) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				strm.adler = state.check = zswap32(hold);
				hold = 0;
				bits = 0;
				state.mode = DICT;
			case DICT:
				if (state.havedict === 0) {
					strm.next_out = put;
					strm.avail_out = left;
					strm.next_in = next;
					strm.avail_in = have;
					state.hold = hold;
					state.bits = bits;
					return Z_NEED_DICT;
				}
				strm.adler = state.check = 1;
				state.mode = TYPE;
			case TYPE: if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
			case TYPEDO:
				if (state.last) {
					hold >>>= bits & 7;
					bits -= bits & 7;
					state.mode = CHECK;
					break;
				}
				while (bits < 3) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				state.last = hold & 1;
				hold >>>= 1;
				bits -= 1;
				switch (hold & 3) {
					case 0:
						state.mode = STORED;
						break;
					case 1:
						fixedtables(state);
						state.mode = LEN_;
						if (flush === Z_TREES) {
							hold >>>= 2;
							bits -= 2;
							break inf_leave;
						}
						break;
					case 2:
						state.mode = TABLE;
						break;
					case 3:
						strm.msg = "invalid block type";
						state.mode = BAD;
				}
				hold >>>= 2;
				bits -= 2;
				break;
			case STORED:
				hold >>>= bits & 7;
				bits -= bits & 7;
				while (bits < 32) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if ((hold & 65535) !== (hold >>> 16 ^ 65535)) {
					strm.msg = "invalid stored block lengths";
					state.mode = BAD;
					break;
				}
				state.length = hold & 65535;
				hold = 0;
				bits = 0;
				state.mode = COPY_;
				if (flush === Z_TREES) break inf_leave;
			case COPY_: state.mode = COPY;
			case COPY:
				copy$1 = state.length;
				if (copy$1) {
					if (copy$1 > have) copy$1 = have;
					if (copy$1 > left) copy$1 = left;
					if (copy$1 === 0) break inf_leave;
					utils$1.arraySet(output, input, next, copy$1, put);
					have -= copy$1;
					next += copy$1;
					left -= copy$1;
					put += copy$1;
					state.length -= copy$1;
					break;
				}
				state.mode = TYPE;
				break;
			case TABLE:
				while (bits < 14) {
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				state.nlen = (hold & 31) + 257;
				hold >>>= 5;
				bits -= 5;
				state.ndist = (hold & 31) + 1;
				hold >>>= 5;
				bits -= 5;
				state.ncode = (hold & 15) + 4;
				hold >>>= 4;
				bits -= 4;
				if (state.nlen > 286 || state.ndist > 30) {
					strm.msg = "too many length or distance symbols";
					state.mode = BAD;
					break;
				}
				state.have = 0;
				state.mode = LENLENS;
			case LENLENS:
				while (state.have < state.ncode) {
					while (bits < 3) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					state.lens[order[state.have++]] = hold & 7;
					hold >>>= 3;
					bits -= 3;
				}
				while (state.have < 19) state.lens[order[state.have++]] = 0;
				state.lencode = state.lendyn;
				state.lenbits = 7;
				opts = { bits: state.lenbits };
				ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
				state.lenbits = opts.bits;
				if (ret) {
					strm.msg = "invalid code lengths set";
					state.mode = BAD;
					break;
				}
				state.have = 0;
				state.mode = CODELENS;
			case CODELENS:
				while (state.have < state.nlen + state.ndist) {
					for (;;) {
						here = state.lencode[hold & (1 << state.lenbits) - 1];
						here_bits = here >>> 24;
						here_op = here >>> 16 & 255;
						here_val = here & 65535;
						if (here_bits <= bits) break;
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					if (here_val < 16) {
						hold >>>= here_bits;
						bits -= here_bits;
						state.lens[state.have++] = here_val;
					} else {
						if (here_val === 16) {
							n = here_bits + 2;
							while (bits < n) {
								if (have === 0) break inf_leave;
								have--;
								hold += input[next++] << bits;
								bits += 8;
							}
							hold >>>= here_bits;
							bits -= here_bits;
							if (state.have === 0) {
								strm.msg = "invalid bit length repeat";
								state.mode = BAD;
								break;
							}
							len = state.lens[state.have - 1];
							copy$1 = 3 + (hold & 3);
							hold >>>= 2;
							bits -= 2;
						} else if (here_val === 17) {
							n = here_bits + 3;
							while (bits < n) {
								if (have === 0) break inf_leave;
								have--;
								hold += input[next++] << bits;
								bits += 8;
							}
							hold >>>= here_bits;
							bits -= here_bits;
							len = 0;
							copy$1 = 3 + (hold & 7);
							hold >>>= 3;
							bits -= 3;
						} else {
							n = here_bits + 7;
							while (bits < n) {
								if (have === 0) break inf_leave;
								have--;
								hold += input[next++] << bits;
								bits += 8;
							}
							hold >>>= here_bits;
							bits -= here_bits;
							len = 0;
							copy$1 = 11 + (hold & 127);
							hold >>>= 7;
							bits -= 7;
						}
						if (state.have + copy$1 > state.nlen + state.ndist) {
							strm.msg = "invalid bit length repeat";
							state.mode = BAD;
							break;
						}
						while (copy$1--) state.lens[state.have++] = len;
					}
				}
				if (state.mode === BAD) break;
				if (state.lens[256] === 0) {
					strm.msg = "invalid code -- missing end-of-block";
					state.mode = BAD;
					break;
				}
				state.lenbits = 9;
				opts = { bits: state.lenbits };
				ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
				state.lenbits = opts.bits;
				if (ret) {
					strm.msg = "invalid literal/lengths set";
					state.mode = BAD;
					break;
				}
				state.distbits = 6;
				state.distcode = state.distdyn;
				opts = { bits: state.distbits };
				ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
				state.distbits = opts.bits;
				if (ret) {
					strm.msg = "invalid distances set";
					state.mode = BAD;
					break;
				}
				state.mode = LEN_;
				if (flush === Z_TREES) break inf_leave;
			case LEN_: state.mode = LEN;
			case LEN:
				if (have >= 6 && left >= 258) {
					strm.next_out = put;
					strm.avail_out = left;
					strm.next_in = next;
					strm.avail_in = have;
					state.hold = hold;
					state.bits = bits;
					inflate_fast(strm, _out);
					put = strm.next_out;
					output = strm.output;
					left = strm.avail_out;
					next = strm.next_in;
					input = strm.input;
					have = strm.avail_in;
					hold = state.hold;
					bits = state.bits;
					if (state.mode === TYPE) state.back = -1;
					break;
				}
				state.back = 0;
				for (;;) {
					here = state.lencode[hold & (1 << state.lenbits) - 1];
					here_bits = here >>> 24;
					here_op = here >>> 16 & 255;
					here_val = here & 65535;
					if (here_bits <= bits) break;
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if (here_op && (here_op & 240) === 0) {
					last_bits = here_bits;
					last_op = here_op;
					last_val = here_val;
					for (;;) {
						here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
						here_bits = here >>> 24;
						here_op = here >>> 16 & 255;
						here_val = here & 65535;
						if (last_bits + here_bits <= bits) break;
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					hold >>>= last_bits;
					bits -= last_bits;
					state.back += last_bits;
				}
				hold >>>= here_bits;
				bits -= here_bits;
				state.back += here_bits;
				state.length = here_val;
				if (here_op === 0) {
					state.mode = LIT;
					break;
				}
				if (here_op & 32) {
					state.back = -1;
					state.mode = TYPE;
					break;
				}
				if (here_op & 64) {
					strm.msg = "invalid literal/length code";
					state.mode = BAD;
					break;
				}
				state.extra = here_op & 15;
				state.mode = LENEXT;
			case LENEXT:
				if (state.extra) {
					n = state.extra;
					while (bits < n) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					state.length += hold & (1 << state.extra) - 1;
					hold >>>= state.extra;
					bits -= state.extra;
					state.back += state.extra;
				}
				state.was = state.length;
				state.mode = DIST;
			case DIST:
				for (;;) {
					here = state.distcode[hold & (1 << state.distbits) - 1];
					here_bits = here >>> 24;
					here_op = here >>> 16 & 255;
					here_val = here & 65535;
					if (here_bits <= bits) break;
					if (have === 0) break inf_leave;
					have--;
					hold += input[next++] << bits;
					bits += 8;
				}
				if ((here_op & 240) === 0) {
					last_bits = here_bits;
					last_op = here_op;
					last_val = here_val;
					for (;;) {
						here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
						here_bits = here >>> 24;
						here_op = here >>> 16 & 255;
						here_val = here & 65535;
						if (last_bits + here_bits <= bits) break;
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					hold >>>= last_bits;
					bits -= last_bits;
					state.back += last_bits;
				}
				hold >>>= here_bits;
				bits -= here_bits;
				state.back += here_bits;
				if (here_op & 64) {
					strm.msg = "invalid distance code";
					state.mode = BAD;
					break;
				}
				state.offset = here_val;
				state.extra = here_op & 15;
				state.mode = DISTEXT;
			case DISTEXT:
				if (state.extra) {
					n = state.extra;
					while (bits < n) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					state.offset += hold & (1 << state.extra) - 1;
					hold >>>= state.extra;
					bits -= state.extra;
					state.back += state.extra;
				}
				if (state.offset > state.dmax) {
					strm.msg = "invalid distance too far back";
					state.mode = BAD;
					break;
				}
				state.mode = MATCH;
			case MATCH:
				if (left === 0) break inf_leave;
				copy$1 = _out - left;
				if (state.offset > copy$1) {
					copy$1 = state.offset - copy$1;
					if (copy$1 > state.whave) {
						if (state.sane) {
							strm.msg = "invalid distance too far back";
							state.mode = BAD;
							break;
						}
					}
					if (copy$1 > state.wnext) {
						copy$1 -= state.wnext;
						from = state.wsize - copy$1;
					} else from = state.wnext - copy$1;
					if (copy$1 > state.length) copy$1 = state.length;
					from_source = state.window;
				} else {
					from_source = output;
					from = put - state.offset;
					copy$1 = state.length;
				}
				if (copy$1 > left) copy$1 = left;
				left -= copy$1;
				state.length -= copy$1;
				do
					output[put++] = from_source[from++];
				while (--copy$1);
				if (state.length === 0) state.mode = LEN;
				break;
			case LIT:
				if (left === 0) break inf_leave;
				output[put++] = state.length;
				left--;
				state.mode = LEN;
				break;
			case CHECK:
				if (state.wrap) {
					while (bits < 32) {
						if (have === 0) break inf_leave;
						have--;
						hold |= input[next++] << bits;
						bits += 8;
					}
					_out -= left;
					strm.total_out += _out;
					state.total += _out;
					if (_out) strm.adler = state.check = state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
					_out = left;
					if ((state.flags ? hold : zswap32(hold)) !== state.check) {
						strm.msg = "incorrect data check";
						state.mode = BAD;
						break;
					}
					hold = 0;
					bits = 0;
				}
				state.mode = LENGTH;
			case LENGTH:
				if (state.wrap && state.flags) {
					while (bits < 32) {
						if (have === 0) break inf_leave;
						have--;
						hold += input[next++] << bits;
						bits += 8;
					}
					if (hold !== (state.total & 4294967295)) {
						strm.msg = "incorrect length check";
						state.mode = BAD;
						break;
					}
					hold = 0;
					bits = 0;
				}
				state.mode = DONE;
			case DONE:
				ret = Z_STREAM_END;
				break inf_leave;
			case BAD:
				ret = Z_DATA_ERROR;
				break inf_leave;
			case MEM: return Z_MEM_ERROR;
			case SYNC:
			default: return Z_STREAM_ERROR;
		}
		strm.next_out = put;
		strm.avail_out = left;
		strm.next_in = next;
		strm.avail_in = have;
		state.hold = hold;
		state.bits = bits;
		if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
			if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
				state.mode = MEM;
				return Z_MEM_ERROR;
			}
		}
		_in -= strm.avail_in;
		_out -= strm.avail_out;
		strm.total_in += _in;
		strm.total_out += _out;
		state.total += _out;
		if (state.wrap && _out) strm.adler = state.check = state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
		strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
		if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
		return ret;
	}
	function inflateEnd(strm) {
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		var state = strm.state;
		if (state.window) state.window = null;
		strm.state = null;
		return Z_OK;
	}
	function inflateGetHeader(strm, head) {
		var state;
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		state = strm.state;
		if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
		state.head = head;
		head.done = false;
		return Z_OK;
	}
	function inflateSetDictionary(strm, dictionary) {
		var dictLength = dictionary.length;
		var state;
		var dictid;
		var ret;
		if (!strm || !strm.state) return Z_STREAM_ERROR;
		state = strm.state;
		if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
		if (state.mode === DICT) {
			dictid = 1;
			dictid = adler32(dictid, dictionary, dictLength, 0);
			if (dictid !== state.check) return Z_DATA_ERROR;
		}
		ret = updatewindow(strm, dictionary, dictLength, dictLength);
		if (ret) {
			state.mode = MEM;
			return Z_MEM_ERROR;
		}
		state.havedict = 1;
		return Z_OK;
	}
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate$2;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = "pako inflate (from Nodeca project)";
}));
var require_constants = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = {
		Z_NO_FLUSH: 0,
		Z_PARTIAL_FLUSH: 1,
		Z_SYNC_FLUSH: 2,
		Z_FULL_FLUSH: 3,
		Z_FINISH: 4,
		Z_BLOCK: 5,
		Z_TREES: 6,
		Z_OK: 0,
		Z_STREAM_END: 1,
		Z_NEED_DICT: 2,
		Z_ERRNO: -1,
		Z_STREAM_ERROR: -2,
		Z_DATA_ERROR: -3,
		Z_BUF_ERROR: -5,
		Z_NO_COMPRESSION: 0,
		Z_BEST_SPEED: 1,
		Z_BEST_COMPRESSION: 9,
		Z_DEFAULT_COMPRESSION: -1,
		Z_FILTERED: 1,
		Z_HUFFMAN_ONLY: 2,
		Z_RLE: 3,
		Z_FIXED: 4,
		Z_DEFAULT_STRATEGY: 0,
		Z_BINARY: 0,
		Z_TEXT: 1,
		Z_UNKNOWN: 2,
		Z_DEFLATED: 8
	};
}));
var require_gzheader = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function GZheader$1() {
		this.text = 0;
		this.time = 0;
		this.xflags = 0;
		this.os = 0;
		this.extra = null;
		this.extra_len = 0;
		this.name = "";
		this.comment = "";
		this.hcrc = 0;
		this.done = false;
	}
	module.exports = GZheader$1;
}));
var require_inflate = /* @__PURE__ */ __commonJSMin(((exports) => {
	var zlib_inflate = require_inflate$1();
	var utils = require_common();
	var strings = require_strings();
	var c = require_constants();
	var msg = require_messages();
	var ZStream = require_zstream();
	var GZheader = require_gzheader();
	var toString$1 = Object.prototype.toString;
	function Inflate(options) {
		if (!(this instanceof Inflate)) return new Inflate(options);
		this.options = utils.assign({
			chunkSize: 16384,
			windowBits: 0,
			to: ""
		}, options || {});
		var opt = this.options;
		if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
			opt.windowBits = -opt.windowBits;
			if (opt.windowBits === 0) opt.windowBits = -15;
		}
		if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
		if (opt.windowBits > 15 && opt.windowBits < 48) {
			if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
		}
		this.err = 0;
		this.msg = "";
		this.ended = false;
		this.chunks = [];
		this.strm = new ZStream();
		this.strm.avail_out = 0;
		var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
		if (status !== c.Z_OK) throw new Error(msg[status]);
		this.header = new GZheader();
		zlib_inflate.inflateGetHeader(this.strm, this.header);
		if (opt.dictionary) {
			if (typeof opt.dictionary === "string") opt.dictionary = strings.string2buf(opt.dictionary);
			else if (toString$1.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
			if (opt.raw) {
				status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
				if (status !== c.Z_OK) throw new Error(msg[status]);
			}
		}
	}
	Inflate.prototype.push = function(data, mode) {
		var strm = this.strm;
		var chunkSize = this.options.chunkSize;
		var dictionary = this.options.dictionary;
		var status, _mode;
		var next_out_utf8, tail, utf8str;
		var allowBufError = false;
		if (this.ended) return false;
		_mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;
		if (typeof data === "string") strm.input = strings.binstring2buf(data);
		else if (toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
		else strm.input = data;
		strm.next_in = 0;
		strm.avail_in = strm.input.length;
		do {
			if (strm.avail_out === 0) {
				strm.output = new utils.Buf8(chunkSize);
				strm.next_out = 0;
				strm.avail_out = chunkSize;
			}
			status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);
			if (status === c.Z_NEED_DICT && dictionary) status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
			if (status === c.Z_BUF_ERROR && allowBufError === true) {
				status = c.Z_OK;
				allowBufError = false;
			}
			if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
				this.onEnd(status);
				this.ended = true;
				return false;
			}
			if (strm.next_out) {
				if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH)) if (this.options.to === "string") {
					next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
					tail = strm.next_out - next_out_utf8;
					utf8str = strings.buf2string(strm.output, next_out_utf8);
					strm.next_out = tail;
					strm.avail_out = chunkSize - tail;
					if (tail) utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
					this.onData(utf8str);
				} else this.onData(utils.shrinkBuf(strm.output, strm.next_out));
			}
			if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
		} while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
		if (status === c.Z_STREAM_END) _mode = c.Z_FINISH;
		if (_mode === c.Z_FINISH) {
			status = zlib_inflate.inflateEnd(this.strm);
			this.onEnd(status);
			this.ended = true;
			return status === c.Z_OK;
		}
		if (_mode === c.Z_SYNC_FLUSH) {
			this.onEnd(c.Z_OK);
			strm.avail_out = 0;
			return true;
		}
		return true;
	};
	Inflate.prototype.onData = function(chunk) {
		this.chunks.push(chunk);
	};
	Inflate.prototype.onEnd = function(status) {
		if (status === c.Z_OK) if (this.options.to === "string") this.result = this.chunks.join("");
		else this.result = utils.flattenChunks(this.chunks);
		this.chunks = [];
		this.err = status;
		this.msg = this.strm.msg;
	};
	function inflate$1(input, options) {
		var inflator = new Inflate(options);
		inflator.push(input, true);
		if (inflator.err) throw inflator.msg || msg[inflator.err];
		return inflator.result;
	}
	function inflateRaw(input, options) {
		options = options || {};
		options.raw = true;
		return inflate$1(input, options);
	}
	exports.Inflate = Inflate;
	exports.inflate = inflate$1;
	exports.inflateRaw = inflateRaw;
	exports.ungzip = inflate$1;
}));
var require_pako = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assign = require_common().assign;
	var deflate = require_deflate();
	var inflate = require_inflate();
	var constants = require_constants();
	var pako = {};
	assign(pako, deflate, inflate, constants);
	module.exports = pako;
}));
var import_UTIF = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist();
	(function() {
		var UTIF = {};
		if (typeof module == "object") module.exports = UTIF;
		else self.UTIF = UTIF;
		var pako$1 = typeof __require === "function" ? require_pako() : self.pako;
		function log() {
			if (typeof process$1$1 == "undefined" || process$1$1.env.NODE_ENV == "development") console.log.apply(console, arguments);
		}
		(function(UTIF$1, pako$2) {
			(function() {
				"use strict";
				var W = function a1() {
					function W$1(p) {
						this.message = "JPEG error: " + p;
					}
					W$1.prototype = /* @__PURE__ */ new Error();
					W$1.prototype.name = "JpegError";
					W$1.constructor = W$1;
					return W$1;
				}(), ak = function ag() {
					var p = new Uint8Array([
						0,
						1,
						8,
						16,
						9,
						2,
						3,
						10,
						17,
						24,
						32,
						25,
						18,
						11,
						4,
						5,
						12,
						19,
						26,
						33,
						40,
						48,
						41,
						34,
						27,
						20,
						13,
						6,
						7,
						14,
						21,
						28,
						35,
						42,
						49,
						56,
						57,
						50,
						43,
						36,
						29,
						22,
						15,
						23,
						30,
						37,
						44,
						51,
						58,
						59,
						52,
						45,
						38,
						31,
						39,
						46,
						53,
						60,
						61,
						54,
						47,
						55,
						62,
						63
					]), t = 4017, ac = 799, ah = 3406, ao = 2276, ar = 1567, ai = 3784, s = 5793, ad = 2896;
					function ak$1(Q) {
						if (Q == null) Q = {};
						if (Q.w == null) Q.w = -1;
						this.V = Q.n;
						this.N = Q.w;
					}
					function a5(Q, h) {
						var f = 0, G = [], n, E, a = 16, F;
						while (a > 0 && !Q[a - 1]) a--;
						G.push({
							children: [],
							index: 0
						});
						var C = G[0];
						for (n = 0; n < a; n++) {
							for (E = 0; E < Q[n]; E++) {
								C = G.pop();
								C.children[C.index] = h[f];
								while (C.index > 0) C = G.pop();
								C.index++;
								G.push(C);
								while (G.length <= n) {
									G.push(F = {
										children: [],
										index: 0
									});
									C.children[C.index] = F.children;
									C = F;
								}
								f++;
							}
							if (n + 1 < a) {
								G.push(F = {
									children: [],
									index: 0
								});
								C.children[C.index] = F.children;
								C = F;
							}
						}
						return G[0].children;
					}
					function a2(Q, h, f) {
						return 64 * ((Q.P + 1) * h + f);
					}
					function a7(Q, h, f, G, n, E, a, C, F, d) {
						if (d == null) d = !1;
						var T = f.m, U = f.Z, z = h, J = 0, V = 0, r = 0, D = 0, a8, q$1 = 0, X, O, _, N, e, K, x = 0, k, g, R, c$1;
						function Y() {
							if (V > 0) {
								V--;
								return J >> V & 1;
							}
							J = Q[h++];
							if (J === 255) {
								var I = Q[h++];
								if (I) {
									if (I === 220 && d) {
										h += 2;
										var l = Z(Q, h);
										h += 2;
										if (l > 0 && l !== f.s) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", l);
									} else if (I === 217) {
										if (d) {
											var M = q$1 * 8;
											if (M > 0 && M < f.s / 10) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", M);
										}
										throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
									}
									throw new W("unexpected marker");
								}
							}
							V = 7;
							return J >>> 7;
						}
						function u(I) {
							var l = I;
							while (!0) {
								l = l[Y()];
								switch (typeof l) {
									case "number": return l;
									case "object": continue;
								}
								throw new W("invalid huffman sequence");
							}
						}
						function m(I) {
							var e$1 = 0;
							while (I > 0) {
								e$1 = e$1 << 1 | Y();
								I--;
							}
							return e$1;
						}
						function j(I) {
							if (I === 1) return Y() === 1 ? 1 : -1;
							var e$1 = m(I);
							if (e$1 >= 1 << I - 1) return e$1;
							return e$1 + (-1 << I) + 1;
						}
						function v(X$1, I) {
							var l = u(X$1.J), M = l === 0 ? 0 : j(l), N$1 = 1;
							X$1.D[I] = X$1.Q += M;
							while (N$1 < 64) {
								var S = u(X$1.i), i$1 = S & 15, A = S >> 4;
								if (i$1 === 0) {
									if (A < 15) break;
									N$1 += 16;
									continue;
								}
								N$1 += A;
								var o = p[N$1];
								X$1.D[I + o] = j(i$1);
								N$1++;
							}
						}
						function $(X$1, I) {
							var l = u(X$1.J), M = l === 0 ? 0 : j(l) << F;
							X$1.D[I] = X$1.Q += M;
						}
						function b(X$1, I) {
							X$1.D[I] |= Y() << F;
						}
						function P(X$1, I) {
							if (r > 0) {
								r--;
								return;
							}
							var N$1 = E, l = a;
							while (N$1 <= l) {
								var M = u(X$1.i), S = M & 15, i$1 = M >> 4;
								if (S === 0) {
									if (i$1 < 15) {
										r = m(i$1) + (1 << i$1) - 1;
										break;
									}
									N$1 += 16;
									continue;
								}
								N$1 += i$1;
								var A = p[N$1];
								X$1.D[I + A] = j(S) * (1 << F);
								N$1++;
							}
						}
						function a4(X$1, I) {
							var N$1 = E, l = a, M = 0, S, i$1;
							while (N$1 <= l) {
								var A = I + p[N$1], o = X$1.D[A] < 0 ? -1 : 1;
								switch (D) {
									case 0:
										i$1 = u(X$1.i);
										S = i$1 & 15;
										M = i$1 >> 4;
										if (S === 0) if (M < 15) {
											r = m(M) + (1 << M);
											D = 4;
										} else {
											M = 16;
											D = 1;
										}
										else {
											if (S !== 1) throw new W("invalid ACn encoding");
											a8 = j(S);
											D = M ? 2 : 3;
										}
										continue;
									case 1:
									case 2:
										if (X$1.D[A]) X$1.D[A] += o * (Y() << F);
										else {
											M--;
											if (M === 0) D = D === 2 ? 3 : 0;
										}
										break;
									case 3:
										if (X$1.D[A]) X$1.D[A] += o * (Y() << F);
										else {
											X$1.D[A] = a8 << F;
											D = 0;
										}
										break;
									case 4:
										if (X$1.D[A]) X$1.D[A] += o * (Y() << F);
										break;
								}
								N$1++;
							}
							if (D === 4) {
								r--;
								if (r === 0) D = 0;
							}
						}
						function H(X$1, I, x$1, l, M) {
							var S = x$1 / T | 0, i$1 = x$1 % T;
							q$1 = S * X$1.A + l;
							var A = i$1 * X$1.h + M;
							I(X$1, a2(X$1, q$1, A));
						}
						function w(X$1, I, x$1) {
							q$1 = x$1 / X$1.P | 0;
							var l = x$1 % X$1.P;
							I(X$1, a2(X$1, q$1, l));
						}
						var y = G.length;
						if (U) if (E === 0) K = C === 0 ? $ : b;
						else K = C === 0 ? P : a4;
						else K = v;
						if (y === 1) g = G[0].P * G[0].c;
						else g = T * f.R;
						while (x <= g) {
							var L = n ? Math.min(g - x, n) : g;
							if (L > 0) {
								for (O = 0; O < y; O++) G[O].Q = 0;
								r = 0;
								if (y === 1) {
									X = G[0];
									for (e = 0; e < L; e++) {
										w(X, K, x);
										x++;
									}
								} else for (e = 0; e < L; e++) {
									for (O = 0; O < y; O++) {
										X = G[O];
										R = X.h;
										c$1 = X.A;
										for (_ = 0; _ < c$1; _++) for (N = 0; N < R; N++) H(X, K, x, _, N);
									}
									x++;
								}
							}
							V = 0;
							k = an(Q, h);
							if (!k) break;
							if (k.u) h = k.offset;
							if (k.M >= 65488 && k.M <= 65495) h += 2;
							else break;
						}
						return h - z;
					}
					function al(Q, h, f) {
						var G = Q.$, n = Q.D, E, a, C, F, d, T, U, z, J, V, Y, u, m, j, v, $, b;
						if (!G) throw new W("missing required Quantization Table.");
						for (var r = 0; r < 64; r += 8) {
							J = n[h + r];
							V = n[h + r + 1];
							Y = n[h + r + 2];
							u = n[h + r + 3];
							m = n[h + r + 4];
							j = n[h + r + 5];
							v = n[h + r + 6];
							$ = n[h + r + 7];
							J *= G[r];
							if ((V | Y | u | m | j | v | $) === 0) {
								b = s * J + 512 >> 10;
								f[r] = b;
								f[r + 1] = b;
								f[r + 2] = b;
								f[r + 3] = b;
								f[r + 4] = b;
								f[r + 5] = b;
								f[r + 6] = b;
								f[r + 7] = b;
								continue;
							}
							V *= G[r + 1];
							Y *= G[r + 2];
							u *= G[r + 3];
							m *= G[r + 4];
							j *= G[r + 5];
							v *= G[r + 6];
							$ *= G[r + 7];
							E = s * J + 128 >> 8;
							a = s * m + 128 >> 8;
							C = Y;
							F = v;
							d = ad * (V - $) + 128 >> 8;
							z = ad * (V + $) + 128 >> 8;
							T = u << 4;
							U = j << 4;
							E = E + a + 1 >> 1;
							a = E - a;
							b = C * ai + F * ar + 128 >> 8;
							C = C * ar - F * ai + 128 >> 8;
							F = b;
							d = d + U + 1 >> 1;
							U = d - U;
							z = z + T + 1 >> 1;
							T = z - T;
							E = E + F + 1 >> 1;
							F = E - F;
							a = a + C + 1 >> 1;
							C = a - C;
							b = d * ao + z * ah + 2048 >> 12;
							d = d * ah - z * ao + 2048 >> 12;
							z = b;
							b = T * ac + U * t + 2048 >> 12;
							T = T * t - U * ac + 2048 >> 12;
							U = b;
							f[r] = E + z;
							f[r + 7] = E - z;
							f[r + 1] = a + U;
							f[r + 6] = a - U;
							f[r + 2] = C + T;
							f[r + 5] = C - T;
							f[r + 3] = F + d;
							f[r + 4] = F - d;
						}
						for (var P = 0; P < 8; ++P) {
							J = f[P];
							V = f[P + 8];
							Y = f[P + 16];
							u = f[P + 24];
							m = f[P + 32];
							j = f[P + 40];
							v = f[P + 48];
							$ = f[P + 56];
							if ((V | Y | u | m | j | v | $) === 0) {
								b = s * J + 8192 >> 14;
								if (b < -2040) b = 0;
								else if (b >= 2024) b = 255;
								else b = b + 2056 >> 4;
								n[h + P] = b;
								n[h + P + 8] = b;
								n[h + P + 16] = b;
								n[h + P + 24] = b;
								n[h + P + 32] = b;
								n[h + P + 40] = b;
								n[h + P + 48] = b;
								n[h + P + 56] = b;
								continue;
							}
							E = s * J + 2048 >> 12;
							a = s * m + 2048 >> 12;
							C = Y;
							F = v;
							d = ad * (V - $) + 2048 >> 12;
							z = ad * (V + $) + 2048 >> 12;
							T = u;
							U = j;
							E = (E + a + 1 >> 1) + 4112;
							a = E - a;
							b = C * ai + F * ar + 2048 >> 12;
							C = C * ar - F * ai + 2048 >> 12;
							F = b;
							d = d + U + 1 >> 1;
							U = d - U;
							z = z + T + 1 >> 1;
							T = z - T;
							E = E + F + 1 >> 1;
							F = E - F;
							a = a + C + 1 >> 1;
							C = a - C;
							b = d * ao + z * ah + 2048 >> 12;
							d = d * ah - z * ao + 2048 >> 12;
							z = b;
							b = T * ac + U * t + 2048 >> 12;
							T = T * t - U * ac + 2048 >> 12;
							U = b;
							J = E + z;
							$ = E - z;
							V = a + U;
							v = a - U;
							Y = C + T;
							j = C - T;
							u = F + d;
							m = F - d;
							if (J < 16) J = 0;
							else if (J >= 4080) J = 255;
							else J >>= 4;
							if (V < 16) V = 0;
							else if (V >= 4080) V = 255;
							else V >>= 4;
							if (Y < 16) Y = 0;
							else if (Y >= 4080) Y = 255;
							else Y >>= 4;
							if (u < 16) u = 0;
							else if (u >= 4080) u = 255;
							else u >>= 4;
							if (m < 16) m = 0;
							else if (m >= 4080) m = 255;
							else m >>= 4;
							if (j < 16) j = 0;
							else if (j >= 4080) j = 255;
							else j >>= 4;
							if (v < 16) v = 0;
							else if (v >= 4080) v = 255;
							else v >>= 4;
							if ($ < 16) $ = 0;
							else if ($ >= 4080) $ = 255;
							else $ >>= 4;
							n[h + P] = J;
							n[h + P + 8] = V;
							n[h + P + 16] = Y;
							n[h + P + 24] = u;
							n[h + P + 32] = m;
							n[h + P + 40] = j;
							n[h + P + 48] = v;
							n[h + P + 56] = $;
						}
					}
					function a0(Q, h) {
						var f = h.P, G = h.c, n = new Int16Array(64);
						for (var E = 0; E < G; E++) for (var a = 0; a < f; a++) al(h, a2(h, E, a), n);
						return h.D;
					}
					function an(Q, h, f) {
						if (f == null) f = h;
						var G = Q.length - 1, n = f < h ? f : h;
						if (h >= G) return null;
						var E = Z(Q, h);
						if (E >= 65472 && E <= 65534) return {
							u: null,
							M: E,
							offset: h
						};
						var a = Z(Q, n);
						while (!(a >= 65472 && a <= 65534)) {
							if (++n >= G) return null;
							a = Z(Q, n);
						}
						return {
							u: E.toString(16),
							M: a,
							offset: n
						};
					}
					ak$1.prototype = {
						parse(Q, h) {
							if (h == null) h = {};
							var f = h.F, E = 0, a = null, C = null, F, d, T = 0;
							function G() {
								var o = Z(Q, E);
								E += 2;
								var B = E + o - 2, V$1 = an(Q, B, E);
								if (V$1 && V$1.u) B = V$1.offset;
								var ab = Q.subarray(E, B);
								E += ab.length;
								return ab;
							}
							function n(F$1) {
								var o = Math.ceil(F$1.o / 8 / F$1.X), B = Math.ceil(F$1.s / 8 / F$1.B);
								for (var Y$1 = 0; Y$1 < F$1.W.length; Y$1++) {
									R = F$1.W[Y$1];
									var ab = Math.ceil(Math.ceil(F$1.o / 8) * R.h / F$1.X), af = Math.ceil(Math.ceil(F$1.s / 8) * R.A / F$1.B), ap = o * R.h, ae = 64 * (B * R.A) * (ap + 1);
									R.D = new Int16Array(ae);
									R.P = ab;
									R.c = af;
								}
								F$1.m = o;
								F$1.R = B;
							}
							var U = [], z = [], J = [], V = Z(Q, E);
							E += 2;
							if (V !== 65496) throw new W("SOI not found");
							V = Z(Q, E);
							E += 2;
							markerLoop: while (V !== 65497) {
								var Y, u, m;
								switch (V) {
									case 65504:
									case 65505:
									case 65506:
									case 65507:
									case 65508:
									case 65509:
									case 65510:
									case 65511:
									case 65512:
									case 65513:
									case 65514:
									case 65515:
									case 65516:
									case 65517:
									case 65518:
									case 65519:
									case 65534:
										var j = G();
										if (V === 65504) {
											if (j[0] === 74 && j[1] === 70 && j[2] === 73 && j[3] === 70 && j[4] === 0) a = {
												version: {
													d: j[5],
													T: j[6]
												},
												K: j[7],
												j: j[8] << 8 | j[9],
												H: j[10] << 8 | j[11],
												S: j[12],
												I: j[13],
												C: j.subarray(14, 14 + 3 * j[12] * j[13])
											};
										}
										if (V === 65518) {
											if (j[0] === 65 && j[1] === 100 && j[2] === 111 && j[3] === 98 && j[4] === 101) C = {
												version: j[5] << 8 | j[6],
												k: j[7] << 8 | j[8],
												q: j[9] << 8 | j[10],
												a: j[11]
											};
										}
										break;
									case 65499:
										var v = Z(Q, E), b;
										E += 2;
										var $ = v + E - 2;
										while (E < $) {
											var r = Q[E++], P = new Uint16Array(64);
											if (r >> 4 === 0) for (u = 0; u < 64; u++) {
												b = p[u];
												P[b] = Q[E++];
											}
											else if (r >> 4 === 1) for (u = 0; u < 64; u++) {
												b = p[u];
												P[b] = Z(Q, E);
												E += 2;
											}
											else throw new W("DQT - invalid table spec");
											U[r & 15] = P;
										}
										break;
									case 65472:
									case 65473:
									case 65474:
										if (F) throw new W("Only single frame JPEGs supported");
										E += 2;
										F = {};
										F.G = V === 65473;
										F.Z = V === 65474;
										F.precision = Q[E++];
										var D = Z(Q, E), a4, q$1 = 0, H = 0;
										E += 2;
										F.s = f || D;
										F.o = Z(Q, E);
										E += 2;
										F.W = [];
										F._ = {};
										var a8 = Q[E++];
										for (Y = 0; Y < a8; Y++) {
											a4 = Q[E];
											var w = Q[E + 1] >> 4, y = Q[E + 1] & 15;
											if (q$1 < w) q$1 = w;
											if (H < y) H = y;
											var X = Q[E + 2];
											m = F.W.push({
												h: w,
												A: y,
												L: X,
												$: null
											});
											F._[a4] = m - 1;
											E += 3;
										}
										F.X = q$1;
										F.B = H;
										n(F);
										break;
									case 65476:
										var O = Z(Q, E);
										E += 2;
										for (Y = 2; Y < O;) {
											var _ = Q[E++], N = new Uint8Array(16), e = 0;
											for (u = 0; u < 16; u++, E++) e += N[u] = Q[E];
											var K = new Uint8Array(e);
											for (u = 0; u < e; u++, E++) K[u] = Q[E];
											Y += 17 + e;
											(_ >> 4 === 0 ? J : z)[_ & 15] = a5(N, K);
										}
										break;
									case 65501:
										E += 2;
										d = Z(Q, E);
										E += 2;
										break;
									case 65498:
										var x = ++T === 1 && !f, R;
										E += 2;
										var k = Q[E++], g = [];
										for (Y = 0; Y < k; Y++) {
											var c$1 = Q[E++], L = F._[c$1];
											R = F.W[L];
											R.index = c$1;
											var a6 = Q[E++];
											R.J = J[a6 >> 4];
											R.i = z[a6 & 15];
											g.push(R);
										}
										var I = Q[E++], l = Q[E++], M = Q[E++];
										try {
											var S = a7(Q, E, F, g, d, I, l, M >> 4, M & 15, x);
											E += S;
										} catch (ex) {
											if (ex instanceof DNLMarkerError) return this.parse(Q, { F: ex.s });
											else if (ex instanceof EOIMarkerError) break markerLoop;
											throw ex;
										}
										break;
									case 65500:
										E += 4;
										break;
									case 65535:
										if (Q[E] !== 255) E--;
										break;
									default:
										var i$1 = an(Q, E - 2, E - 3);
										if (i$1 && i$1.u) {
											E = i$1.offset;
											break;
										}
										if (E >= Q.length - 1) break markerLoop;
										throw new W("JpegImage.parse - unknown marker: " + V.toString(16));
								}
								V = Z(Q, E);
								E += 2;
							}
							this.width = F.o;
							this.height = F.s;
							this.g = a;
							this.b = C;
							this.W = [];
							for (Y = 0; Y < F.W.length; Y++) {
								R = F.W[Y];
								var A = U[R.L];
								if (A) R.$ = A;
								this.W.push({
									index: R.index,
									e: a0(F, R),
									l: R.h / F.X,
									t: R.A / F.B,
									P: R.P,
									c: R.c
								});
							}
							this.p = this.W.length;
						},
						Y(Q, h, f) {
							if (f == null) f = !1;
							var G = this.width / Q, n = this.height / h, E, a, C, F, d, T, U, z, J, V, Y = 0, u, m = this.W.length, j = Q * h * m, v = new Uint8ClampedArray(j), $ = new Uint32Array(Q), b = 4294967288, r;
							for (U = 0; U < m; U++) {
								E = this.W[U];
								a = E.l * G;
								C = E.t * n;
								Y = U;
								u = E.e;
								F = E.P + 1 << 3;
								if (a !== r) {
									for (d = 0; d < Q; d++) {
										z = 0 | d * a;
										$[d] = (z & b) << 3 | z & 7;
									}
									r = a;
								}
								for (T = 0; T < h; T++) {
									z = 0 | T * C;
									V = F * (z & b) | (z & 7) << 3;
									for (d = 0; d < Q; d++) {
										v[Y] = u[V + $[d]];
										Y += m;
									}
								}
							}
							var P = this.V;
							if (!f && m === 4 && !P) P = new Int32Array([
								-256,
								255,
								-256,
								255,
								-256,
								255,
								-256,
								255
							]);
							if (P) for (U = 0; U < j;) for (z = 0, J = 0; z < m; z++, U++, J += 2) v[U] = (v[U] * P[J] >> 8) + P[J + 1];
							return v;
						},
						get f() {
							if (this.b) return !!this.b.a;
							if (this.p === 3) {
								if (this.N === 0) return !1;
								else if (this.W[0].index === 82 && this.W[1].index === 71 && this.W[2].index === 66) return !1;
								return !0;
							}
							if (this.N === 1) return !0;
							return !1;
						},
						z: function aj(Q) {
							var h, f, G;
							for (var n = 0, E = Q.length; n < E; n += 3) {
								h = Q[n];
								f = Q[n + 1];
								G = Q[n + 2];
								Q[n] = h - 179.456 + 1.402 * G;
								Q[n + 1] = h + 135.459 - .344 * f - .714 * G;
								Q[n + 2] = h - 226.816 + 1.772 * f;
							}
							return Q;
						},
						O: function aa(Q) {
							var h, f, G, n, E = 0;
							for (var a = 0, C = Q.length; a < C; a += 4) {
								h = Q[a];
								f = Q[a + 1];
								G = Q[a + 2];
								n = Q[a + 3];
								Q[E++] = -122.67195406894 + f * (-660635669420364e-19 * f + .000437130475926232 * G - 54080610064599e-18 * h + .00048449797120281 * n - .154362151871126) + G * (-.000957964378445773 * G + .000817076911346625 * h - .00477271405408747 * n + 1.53380253221734) + h * (.000961250184130688 * h - .00266257332283933 * n + .48357088451265) + n * (-.000336197177618394 * n + .484791561490776);
								Q[E++] = 107.268039397724 + f * (219927104525741e-19 * f - .000640992018297945 * G + .000659397001245577 * h + .000426105652938837 * n - .176491792462875) + G * (-.000778269941513683 * G + .00130872261408275 * h + .000770482631801132 * n - .151051492775562) + h * (.00126935368114843 * h - .00265090189010898 * n + .25802910206845) + n * (-.000318913117588328 * n - .213742400323665);
								Q[E++] = -20.810012546947 + f * (-.000570115196973677 * f - 263409051004589e-19 * G + .0020741088115012 * h - .00288260236853442 * n + .814272968359295) + G * (-153496057440975e-19 * G - .000132689043961446 * h + .000560833691242812 * n - .195152027534049) + h * (.00174418132927582 * h - .00255243321439347 * n + .116935020465145) + n * (-.000343531996510555 * n + .24165260232407);
							}
							return Q.subarray(0, E);
						},
						r: function a3(Q) {
							var h, f, G;
							for (var n = 0, E = Q.length; n < E; n += 4) {
								h = Q[n];
								f = Q[n + 1];
								G = Q[n + 2];
								Q[n] = 434.456 - h - 1.402 * G;
								Q[n + 1] = 119.541 - h + .344 * f + .714 * G;
								Q[n + 2] = 481.816 - h - 1.772 * f;
							}
							return Q;
						},
						U: function as(Q) {
							var h, f, G, n, E = 0;
							for (var a = 0, C = Q.length; a < C; a += 4) {
								h = Q[a];
								f = Q[a + 1];
								G = Q[a + 2];
								n = Q[a + 3];
								Q[E++] = 255 + h * (-6747147073602441e-20 * h + .0008379262121013727 * f + .0002894718188643294 * G + .003264231057537806 * n - 1.1185611867203937) + f * (26374107616089405e-21 * f - 8626949158638572e-20 * G - .0002748769067499491 * n - .02155688794978967) + G * (-3878099212869363e-20 * G - .0003267808279485286 * n + .0686742238595345) - n * (.0003361971776183937 * n + .7430659151342254);
								Q[E++] = 255 + h * (.00013596372813588848 * h + .000924537132573585 * f + .00010567359618683593 * G + .0004791864687436512 * n - .3109689587515875) + f * (-.00023545346108370344 * f + .0002702845253534714 * G + .0020200308977307156 * n - .7488052167015494) + G * (6834815998235662e-20 * G + .00015168452363460973 * n - .09751927774728933) - n * (.0003189131175883281 * n + .7364883807733168);
								Q[E++] = 255 + h * (13598650411385307e-21 * h + .00012423956175490851 * f + .0004751985097583589 * G - 36729317476630422e-22 * n - .05562186980264034) + f * (.00016141380598724676 * f + .0009692239130725186 * G + .0007782692450036253 * n - .44015232367526463) + G * (5.068882914068769e-7 * G + .0017778369011375071 * n - .7591454649749609) - n * (.0003435319965105553 * n + .7063770186160144);
							}
							return Q.subarray(0, E);
						},
						getData: function(Q) {
							var h = Q.width, f = Q.height, G = Q.forceRGB, n = Q.isSourcePDF;
							if (this.p > 4) throw new W("Unsupported color mode");
							var E = this.Y(h, f, n);
							if (this.p === 1 && G) {
								var a = E.length, C = new Uint8ClampedArray(a * 3), F = 0;
								for (var d = 0; d < a; d++) {
									var T = E[d];
									C[F++] = T;
									C[F++] = T;
									C[F++] = T;
								}
								return C;
							} else if (this.p === 3 && this.f) return this.z(E);
							else if (this.p === 4) {
								if (this.f) {
									if (G) return this.O(E);
									return this.r(E);
								} else if (G) return this.U(E);
							}
							return E;
						}
					};
					return ak$1;
				}();
				function Z(p, t) {
					return p[t] << 8 | p[t + 1];
				}
				UTIF$1.JpegDecoder = ak;
			})();
			UTIF$1.encodeImage = function(rgba, w, h, metadata) {
				var idf = {
					"t256": [w],
					"t257": [h],
					"t258": [
						8,
						8,
						8,
						8
					],
					"t259": [1],
					"t262": [2],
					"t273": [1e3],
					"t277": [4],
					"t278": [h],
					"t279": [w * h * 4],
					"t282": [[72, 1]],
					"t283": [[72, 1]],
					"t284": [1],
					"t286": [[0, 1]],
					"t287": [[0, 1]],
					"t296": [1],
					"t305": ["Photopea (UTIF.js)"],
					"t338": [1]
				};
				if (metadata) for (var i$1 in metadata) idf[i$1] = metadata[i$1];
				var prfx = new Uint8Array(UTIF$1.encode([idf]));
				var img = new Uint8Array(rgba);
				var data = new Uint8Array(1e3 + w * h * 4);
				for (var i$1 = 0; i$1 < prfx.length; i$1++) data[i$1] = prfx[i$1];
				for (var i$1 = 0; i$1 < img.length; i$1++) data[1e3 + i$1] = img[i$1];
				return data.buffer;
			};
			UTIF$1.encode = function(ifds) {
				var LE = false;
				var data = new Uint8Array(2e4), offset = 4, bin = LE ? UTIF$1._binLE : UTIF$1._binBE;
				data[0] = data[1] = LE ? 73 : 77;
				bin.writeUshort(data, 2, 42);
				var ifdo = 8;
				bin.writeUint(data, offset, ifdo);
				offset += 4;
				for (var i$1 = 0; i$1 < ifds.length; i$1++) {
					var noffs = UTIF$1._writeIFD(bin, UTIF$1._types.basic, data, ifdo, ifds[i$1]);
					ifdo = noffs[1];
					if (i$1 < ifds.length - 1) {
						if ((ifdo & 3) != 0) ifdo += 4 - (ifdo & 3);
						bin.writeUint(data, noffs[0], ifdo);
					}
				}
				return data.slice(0, ifdo).buffer;
			};
			UTIF$1.decode = function(buff, prm) {
				if (prm == null) prm = {
					parseMN: true,
					debug: false
				};
				var data = new Uint8Array(buff), offset = 0;
				var id = UTIF$1._binBE.readASCII(data, offset, 2);
				offset += 2;
				var bin = id == "II" ? UTIF$1._binLE : UTIF$1._binBE;
				bin.readUshort(data, offset);
				offset += 2;
				var ifdo = bin.readUint(data, offset);
				offset += 4;
				var ifds = [];
				while (true) {
					var cnt = bin.readUshort(data, ifdo), typ = bin.readUshort(data, ifdo + 4);
					if (cnt != 0) {
						if (typ < 1 || 13 < typ) {
							log("error in TIFF");
							break;
						}
					}
					UTIF$1._readIFD(bin, data, ifdo, ifds, 0, prm);
					ifdo = bin.readUint(data, ifdo + 2 + cnt * 12);
					if (ifdo == 0) break;
				}
				return ifds;
			};
			UTIF$1.decodeImage = function(buff, img, ifds) {
				if (img.data) return;
				var data = new Uint8Array(buff);
				var id = UTIF$1._binBE.readASCII(data, 0, 2);
				if (img["t256"] == null) return;
				img.isLE = id == "II";
				img.width = img["t256"][0];
				img.height = img["t257"][0];
				var cmpr = img["t259"] ? img["t259"][0] : 1;
				var fo = img["t266"] ? img["t266"][0] : 1;
				if (img["t284"] && img["t284"][0] == 2) log("PlanarConfiguration 2 should not be used!");
				if (cmpr == 7 && img["t258"] && img["t258"].length > 3) img["t258"] = img["t258"].slice(0, 3);
				var spp = img["t277"] ? img["t277"][0] : 1;
				var bipp = (img["t258"] ? img["t258"][0] : 1) * spp;
				if (cmpr == 1 && img["t279"] != null && img["t278"] && img["t262"][0] == 32803) bipp = Math.round(img["t279"][0] * 8 / (img.width * img["t278"][0]));
				if (img["t50885"] && img["t50885"][0] == 4) bipp = img["t258"][0] * 3;
				var bipl = Math.ceil(img.width * bipp / 8) * 8;
				var soff = img["t273"];
				if (soff == null || img["t322"]) soff = img["t324"];
				var bcnt = img["t279"];
				if (cmpr == 1 && soff.length == 1) bcnt = [img.height * (bipl >>> 3)];
				if (bcnt == null || img["t322"]) bcnt = img["t325"];
				var bytes = new Uint8Array(img.height * (bipl >>> 3)), bilen = 0;
				if (img["t322"] != null) {
					var tw = img["t322"][0], th = img["t323"][0];
					var tx = Math.floor((img.width + tw - 1) / tw);
					var ty = Math.floor((img.height + th - 1) / th);
					var tbuff = new Uint8Array(Math.ceil(tw * th * bipp / 8) | 0);
					console.log("====", tx, ty);
					for (var y = 0; y < ty; y++) for (var x = 0; x < tx; x++) {
						var i$1 = y * tx + x;
						tbuff.fill(0);
						UTIF$1.decode._decompress(img, ifds, data, soff[i$1], bcnt[i$1], cmpr, tbuff, 0, fo, tw, th);
						if (cmpr == 6) bytes = tbuff;
						else UTIF$1._copyTile(tbuff, Math.ceil(tw * bipp / 8) | 0, th, bytes, Math.ceil(img.width * bipp / 8) | 0, img.height, Math.ceil(x * tw * bipp / 8) | 0, y * th);
					}
					bilen = bytes.length * 8;
				} else {
					if (soff == null) return;
					var rps = img["t278"] ? img["t278"][0] : img.height;
					rps = Math.min(rps, img.height);
					for (var i$1 = 0; i$1 < soff.length; i$1++) {
						UTIF$1.decode._decompress(img, ifds, data, soff[i$1], bcnt[i$1], cmpr, bytes, Math.ceil(bilen / 8) | 0, fo, img.width, rps);
						bilen += bipl * rps;
					}
					bilen = Math.min(bilen, bytes.length * 8);
				}
				img.data = new Uint8Array(bytes.buffer, 0, Math.ceil(bilen / 8) | 0);
			};
			UTIF$1.decode._decompress = function(img, ifds, data, off, len, cmpr, tgt, toff, fo, w, h) {
				if (img["t271"] && img["t271"][0] == "Panasonic" && img["t45"] && img["t45"][0] == 6) cmpr = 34316;
				if (cmpr == 1) for (var j = 0; j < len; j++) tgt[toff + j] = data[off + j];
				else if (cmpr == 2) UTIF$1.decode._decodeG2(data, off, len, tgt, toff, w, fo);
				else if (cmpr == 3) UTIF$1.decode._decodeG3(data, off, len, tgt, toff, w, fo, img["t292"] ? (img["t292"][0] & 1) == 1 : false);
				else if (cmpr == 4) UTIF$1.decode._decodeG4(data, off, len, tgt, toff, w, fo);
				else if (cmpr == 5) UTIF$1.decode._decodeLZW(data, off, len, tgt, toff, 8);
				else if (cmpr == 6) UTIF$1.decode._decodeOldJPEG(img, data, off, len, tgt, toff);
				else if (cmpr == 7 || cmpr == 34892) UTIF$1.decode._decodeNewJPEG(img, data, off, len, tgt, toff);
				else if (cmpr == 8 || cmpr == 32946) {
					var src = new Uint8Array(data.buffer, off + 2, len - 6);
					var bin = pako$2["inflateRaw"](src);
					if (toff + bin.length <= tgt.length) tgt.set(bin, toff);
				} else if (cmpr == 9) UTIF$1.decode._decodeVC5(data, off, len, tgt, toff, img["t33422"]);
				else if (cmpr == 32767) UTIF$1.decode._decodeARW(img, data, off, len, tgt, toff);
				else if (cmpr == 32773) UTIF$1.decode._decodePackBits(data, off, len, tgt, toff);
				else if (cmpr == 32809) UTIF$1.decode._decodeThunder(data, off, len, tgt, toff);
				else if (cmpr == 34316) UTIF$1.decode._decodePanasonic(img, data, off, len, tgt, toff);
				else if (cmpr == 34713) UTIF$1.decode._decodeNikon(img, ifds, data, off, len, tgt, toff);
				else if (cmpr == 34676) UTIF$1.decode._decodeLogLuv32(img, data, off, len, tgt, toff);
				else log("Unknown compression", cmpr);
				var bps = img["t258"] ? Math.min(32, img["t258"][0]) : 1;
				var noc = img["t277"] ? img["t277"][0] : 1, bpp = bps * noc >>> 3, bpl = Math.ceil(bps * noc * w / 8);
				if (bps == 16 && !img.isLE && img["t33422"] == null) for (var y = 0; y < h; y++) {
					var roff = toff + y * bpl;
					for (var x = 1; x < bpl; x += 2) {
						var t = tgt[roff + x];
						tgt[roff + x] = tgt[roff + x - 1];
						tgt[roff + x - 1] = t;
					}
				}
				if (img["t317"] && img["t317"][0] == 2) for (var y = 0; y < h; y++) {
					var ntoff = toff + y * bpl;
					if (bps == 16) for (var j = bpp; j < bpl; j += 2) {
						var nv = (tgt[ntoff + j + 1] << 8 | tgt[ntoff + j]) + (tgt[ntoff + j - bpp + 1] << 8 | tgt[ntoff + j - bpp]);
						tgt[ntoff + j] = nv & 255;
						tgt[ntoff + j + 1] = nv >>> 8 & 255;
					}
					else if (noc == 3) for (var j = 3; j < bpl; j += 3) {
						tgt[ntoff + j] = tgt[ntoff + j] + tgt[ntoff + j - 3] & 255;
						tgt[ntoff + j + 1] = tgt[ntoff + j + 1] + tgt[ntoff + j - 2] & 255;
						tgt[ntoff + j + 2] = tgt[ntoff + j + 2] + tgt[ntoff + j - 1] & 255;
					}
					else for (var j = bpp; j < bpl; j++) tgt[ntoff + j] = tgt[ntoff + j] + tgt[ntoff + j - bpp] & 255;
				}
			};
			UTIF$1.decode._decodePanasonic = function(img, data, off, len, tgt, toff) {
				var img_buffer = data.buffer;
				var rawWidth = img["t2"][0];
				var rawHeight = img["t3"][0];
				var bitsPerSample = img["t10"][0];
				var RW2_Format = img["t45"][0];
				var bidx = 0;
				var imageIndex = 0;
				var vpos = 0;
				var byte = 0;
				var bytes = RW2_Format == 6 ? new Uint32Array(18) : new Uint8Array(16);
				var i$1, j, sh, pred = [0, 0], nonz = [0, 0], isOdd, idx = 0, pixel_base;
				var row, col, crow;
				var buffer = new Uint8Array(16384);
				var result = new Uint16Array(tgt.buffer);
				function getDataRaw(bits) {
					if (vpos == 0) {
						var arr_a = new Uint8Array(img_buffer, off + imageIndex + 8184, 8200);
						var arr_b = new Uint8Array(img_buffer, off + imageIndex, 8184);
						buffer.set(arr_a);
						buffer.set(arr_b, arr_a.length);
						imageIndex += 16384;
					}
					if (RW2_Format == 5) for (i$1 = 0; i$1 < 16; i$1++) {
						bytes[i$1] = buffer[vpos++];
						vpos &= 16383;
					}
					else {
						vpos = vpos - bits & 131071;
						byte = vpos >> 3 ^ 16368;
						return (buffer[byte] | buffer[byte + 1] << 8) >> (vpos & 7) & ~(-1 << bits);
					}
				}
				function getBufferDataRW6(i$2) {
					return buffer[vpos + 15 - i$2];
				}
				function readPageRW6() {
					bytes[0] = getBufferDataRW6(0) << 6 | getBufferDataRW6(1) >> 2;
					bytes[1] = ((getBufferDataRW6(1) & 3) << 12 | getBufferDataRW6(2) << 4 | getBufferDataRW6(3) >> 4) & 16383;
					bytes[2] = getBufferDataRW6(3) >> 2 & 3;
					bytes[3] = (getBufferDataRW6(3) & 3) << 8 | getBufferDataRW6(4);
					bytes[4] = getBufferDataRW6(5) << 2 | getBufferDataRW6(6) >> 6;
					bytes[5] = (getBufferDataRW6(6) & 63) << 4 | getBufferDataRW6(7) >> 4;
					bytes[6] = getBufferDataRW6(7) >> 2 & 3;
					bytes[7] = (getBufferDataRW6(7) & 3) << 8 | getBufferDataRW6(8);
					bytes[8] = getBufferDataRW6(9) << 2 & 1020 | getBufferDataRW6(10) >> 6;
					bytes[9] = (getBufferDataRW6(10) << 4 | getBufferDataRW6(11) >> 4) & 1023;
					bytes[10] = getBufferDataRW6(11) >> 2 & 3;
					bytes[11] = (getBufferDataRW6(11) & 3) << 8 | getBufferDataRW6(12);
					bytes[12] = (getBufferDataRW6(13) << 2 & 1020 | getBufferDataRW6(14) >> 6) & 1023;
					bytes[13] = (getBufferDataRW6(14) << 4 | getBufferDataRW6(15) >> 4) & 1023;
					vpos += 16;
					byte = 0;
				}
				function readPageRw6_bps12() {
					bytes[0] = getBufferDataRW6(0) << 4 | getBufferDataRW6(1) >> 4;
					bytes[1] = ((getBufferDataRW6(1) & 15) << 8 | getBufferDataRW6(2)) & 4095;
					bytes[2] = getBufferDataRW6(3) >> 6 & 3;
					bytes[3] = (getBufferDataRW6(3) & 63) << 2 | getBufferDataRW6(4) >> 6;
					bytes[4] = (getBufferDataRW6(4) & 63) << 2 | getBufferDataRW6(5) >> 6;
					bytes[5] = (getBufferDataRW6(5) & 63) << 2 | getBufferDataRW6(6) >> 6;
					bytes[6] = getBufferDataRW6(6) >> 4 & 3;
					bytes[7] = (getBufferDataRW6(6) & 15) << 4 | getBufferDataRW6(7) >> 4;
					bytes[8] = (getBufferDataRW6(7) & 15) << 4 | getBufferDataRW6(8) >> 4;
					bytes[9] = (getBufferDataRW6(8) & 15) << 4 | getBufferDataRW6(9) >> 4;
					bytes[10] = getBufferDataRW6(9) >> 2 & 3;
					bytes[11] = (getBufferDataRW6(9) & 3) << 6 | getBufferDataRW6(10) >> 2;
					bytes[12] = (getBufferDataRW6(10) & 3) << 6 | getBufferDataRW6(11) >> 2;
					bytes[13] = (getBufferDataRW6(11) & 3) << 6 | getBufferDataRW6(12) >> 2;
					bytes[14] = getBufferDataRW6(12) & 3;
					bytes[15] = getBufferDataRW6(13);
					bytes[16] = getBufferDataRW6(14);
					bytes[17] = getBufferDataRW6(15);
					vpos += 16;
					byte = 0;
				}
				function resetPredNonzeros() {
					pred[0] = 0;
					pred[1] = 0;
					nonz[0] = 0;
					nonz[1] = 0;
				}
				if (RW2_Format == 7) throw RW2_Format;
				else if (RW2_Format == 6) {
					var is12bit = bitsPerSample == 12, readPageRw6Fn = is12bit ? readPageRw6_bps12 : readPageRW6, pixelsPerBlock = is12bit ? 14 : 11, pixelbase0 = is12bit ? 128 : 512, pixelbase_compare = is12bit ? 2048 : 8192, spix_compare = is12bit ? 16383 : 65535, pixel_mask = is12bit ? 4095 : 16383, blocksperrow = rawWidth / pixelsPerBlock, rowbytes = blocksperrow * 16, bufferSize = is12bit ? 18 : 14;
					for (row = 0; row < rawHeight - 15; row += 16) {
						var rowstoread = Math.min(16, rawHeight - row);
						var readlen = rowbytes * rowstoread;
						buffer = new Uint8Array(img_buffer, off + bidx, readlen);
						vpos = 0;
						bidx += readlen;
						for (crow = 0, col = 0; crow < rowstoread; crow++, col = 0) {
							idx = (row + crow) * rawWidth;
							for (var rblock = 0; rblock < blocksperrow; rblock++) {
								readPageRw6Fn();
								resetPredNonzeros();
								sh = 0;
								pixel_base = 0;
								for (i$1 = 0; i$1 < pixelsPerBlock; i$1++) {
									isOdd = i$1 & 1;
									if (i$1 % 3 == 2) {
										var base$1 = byte < bufferSize ? bytes[byte++] : 0;
										if (base$1 == 3) base$1 = 4;
										pixel_base = pixelbase0 << base$1;
										sh = 1 << base$1;
									}
									var epixel = byte < bufferSize ? bytes[byte++] : 0;
									if (pred[isOdd]) {
										epixel *= sh;
										if (pixel_base < pixelbase_compare && nonz[isOdd] > pixel_base) epixel += nonz[isOdd] - pixel_base;
										nonz[isOdd] = epixel;
									} else {
										pred[isOdd] = epixel;
										if (epixel) nonz[isOdd] = epixel;
										else epixel = nonz[isOdd];
									}
									result[idx + col++] = epixel - 15 <= spix_compare ? epixel - 15 & spix_compare : epixel + 2147483633 >> 31 & pixel_mask;
								}
							}
						}
					}
				} else if (RW2_Format == 5) {
					var blockSize = bitsPerSample == 12 ? 10 : 9;
					for (row = 0; row < rawHeight; row++) for (col = 0; col < rawWidth; col += blockSize) {
						getDataRaw(0);
						if (bitsPerSample == 12) {
							result[idx++] = ((bytes[1] & 15) << 8) + bytes[0];
							result[idx++] = 16 * bytes[2] + (bytes[1] >> 4);
							result[idx++] = ((bytes[4] & 15) << 8) + bytes[3];
							result[idx++] = 16 * bytes[5] + (bytes[4] >> 4);
							result[idx++] = ((bytes[7] & 15) << 8) + bytes[6];
							result[idx++] = 16 * bytes[8] + (bytes[7] >> 4);
							result[idx++] = ((bytes[10] & 15) << 8) + bytes[9];
							result[idx++] = 16 * bytes[11] + (bytes[10] >> 4);
							result[idx++] = ((bytes[13] & 15) << 8) + bytes[12];
							result[idx++] = 16 * bytes[14] + (bytes[13] >> 4);
						} else if (bitsPerSample == 14) {
							result[idx++] = bytes[0] + ((bytes[1] & 63) << 8);
							result[idx++] = (bytes[1] >> 6) + 4 * bytes[2] + ((bytes[3] & 15) << 10);
							result[idx++] = (bytes[3] >> 4) + 16 * bytes[4] + ((bytes[5] & 3) << 12);
							result[idx++] = ((bytes[5] & 252) >> 2) + (bytes[6] << 6);
							result[idx++] = bytes[7] + ((bytes[8] & 63) << 8);
							result[idx++] = (bytes[8] >> 6) + 4 * bytes[9] + ((bytes[10] & 15) << 10);
							result[idx++] = (bytes[10] >> 4) + 16 * bytes[11] + ((bytes[12] & 3) << 12);
							result[idx++] = ((bytes[12] & 252) >> 2) + (bytes[13] << 6);
							result[idx++] = bytes[14] + ((bytes[15] & 63) << 8);
						}
					}
				} else if (RW2_Format == 4) for (row = 0; row < rawHeight; row++) for (col = 0; col < rawWidth; col++) {
					i$1 = col % 14;
					isOdd = i$1 & 1;
					if (i$1 == 0) resetPredNonzeros();
					if (i$1 % 3 == 2) sh = 4 >> 3 - getDataRaw(2);
					if (nonz[isOdd]) {
						j = getDataRaw(8);
						if (j != 0) {
							pred[isOdd] -= 128 << sh;
							if (pred[isOdd] < 0 || sh == 4) pred[isOdd] &= ~(-1 << sh);
							pred[isOdd] += j << sh;
						}
					} else {
						nonz[isOdd] = getDataRaw(8);
						if (nonz[isOdd] || i$1 > 11) pred[isOdd] = nonz[isOdd] << 4 | getDataRaw(4);
					}
					result[idx++] = pred[col & 1];
				}
				else throw RW2_Format;
			};
			UTIF$1.decode._decodeVC5 = function() {
				var x = [
					1,
					0,
					1,
					0,
					2,
					2,
					1,
					1,
					3,
					7,
					1,
					2,
					5,
					25,
					1,
					3,
					6,
					48,
					1,
					4,
					6,
					54,
					1,
					5,
					7,
					111,
					1,
					8,
					7,
					99,
					1,
					6,
					7,
					105,
					12,
					0,
					7,
					107,
					1,
					7,
					8,
					209,
					20,
					0,
					8,
					212,
					1,
					9,
					8,
					220,
					1,
					10,
					9,
					393,
					1,
					11,
					9,
					394,
					32,
					0,
					9,
					416,
					1,
					12,
					9,
					427,
					1,
					13,
					10,
					887,
					1,
					18,
					10,
					784,
					1,
					14,
					10,
					790,
					1,
					15,
					10,
					835,
					60,
					0,
					10,
					852,
					1,
					16,
					10,
					885,
					1,
					17,
					11,
					1571,
					1,
					19,
					11,
					1668,
					1,
					20,
					11,
					1669,
					100,
					0,
					11,
					1707,
					1,
					21,
					11,
					1772,
					1,
					22,
					12,
					3547,
					1,
					29,
					12,
					3164,
					1,
					24,
					12,
					3166,
					1,
					25,
					12,
					3140,
					1,
					23,
					12,
					3413,
					1,
					26,
					12,
					3537,
					1,
					27,
					12,
					3539,
					1,
					28,
					13,
					7093,
					1,
					35,
					13,
					6283,
					1,
					30,
					13,
					6331,
					1,
					31,
					13,
					6335,
					180,
					0,
					13,
					6824,
					1,
					32,
					13,
					7072,
					1,
					33,
					13,
					7077,
					320,
					0,
					13,
					7076,
					1,
					34,
					14,
					12565,
					1,
					36,
					14,
					12661,
					1,
					37,
					14,
					12669,
					1,
					38,
					14,
					13651,
					1,
					39,
					14,
					14184,
					1,
					40,
					15,
					28295,
					1,
					46,
					15,
					28371,
					1,
					47,
					15,
					25320,
					1,
					42,
					15,
					25336,
					1,
					43,
					15,
					25128,
					1,
					41,
					15,
					27300,
					1,
					44,
					15,
					28293,
					1,
					45,
					16,
					50259,
					1,
					48,
					16,
					50643,
					1,
					49,
					16,
					50675,
					1,
					50,
					16,
					56740,
					1,
					53,
					16,
					56584,
					1,
					51,
					16,
					56588,
					1,
					52,
					17,
					113483,
					1,
					61,
					17,
					113482,
					1,
					60,
					17,
					101285,
					1,
					55,
					17,
					101349,
					1,
					56,
					17,
					109205,
					1,
					57,
					17,
					109207,
					1,
					58,
					17,
					100516,
					1,
					54,
					17,
					113171,
					1,
					59,
					18,
					202568,
					1,
					62,
					18,
					202696,
					1,
					63,
					18,
					218408,
					1,
					64,
					18,
					218412,
					1,
					65,
					18,
					226340,
					1,
					66,
					18,
					226356,
					1,
					67,
					18,
					226358,
					1,
					68,
					19,
					402068,
					1,
					69,
					19,
					405138,
					1,
					70,
					19,
					405394,
					1,
					71,
					19,
					436818,
					1,
					72,
					19,
					436826,
					1,
					73,
					19,
					452714,
					1,
					75,
					19,
					452718,
					1,
					76,
					19,
					452682,
					1,
					74,
					20,
					804138,
					1,
					77,
					20,
					810279,
					1,
					78,
					20,
					810790,
					1,
					79,
					20,
					873638,
					1,
					80,
					20,
					873654,
					1,
					81,
					20,
					905366,
					1,
					82,
					20,
					905430,
					1,
					83,
					20,
					905438,
					1,
					84,
					21,
					1608278,
					1,
					85,
					21,
					1620557,
					1,
					86,
					21,
					1621582,
					1,
					87,
					21,
					1621583,
					1,
					88,
					21,
					1747310,
					1,
					89,
					21,
					1810734,
					1,
					90,
					21,
					1810735,
					1,
					91,
					21,
					1810863,
					1,
					92,
					21,
					1810879,
					1,
					93,
					22,
					3621725,
					1,
					99,
					22,
					3621757,
					1,
					100,
					22,
					3241112,
					1,
					94,
					22,
					3494556,
					1,
					95,
					22,
					3494557,
					1,
					96,
					22,
					3494622,
					1,
					97,
					22,
					3494623,
					1,
					98,
					23,
					6482227,
					1,
					102,
					23,
					6433117,
					1,
					101,
					23,
					6989117,
					1,
					103,
					23,
					6989119,
					1,
					105,
					23,
					6989118,
					1,
					104,
					23,
					7243449,
					1,
					106,
					23,
					7243512,
					1,
					107,
					24,
					13978233,
					1,
					111,
					24,
					12964453,
					1,
					109,
					24,
					12866232,
					1,
					108,
					24,
					14486897,
					1,
					113,
					24,
					13978232,
					1,
					110,
					24,
					14486896,
					1,
					112,
					24,
					14487026,
					1,
					114,
					24,
					14487027,
					1,
					115,
					25,
					25732598,
					1,
					225,
					25,
					25732597,
					1,
					189,
					25,
					25732596,
					1,
					188,
					25,
					25732595,
					1,
					203,
					25,
					25732594,
					1,
					202,
					25,
					25732593,
					1,
					197,
					25,
					25732592,
					1,
					207,
					25,
					25732591,
					1,
					169,
					25,
					25732590,
					1,
					223,
					25,
					25732589,
					1,
					159,
					25,
					25732522,
					1,
					235,
					25,
					25732579,
					1,
					152,
					25,
					25732575,
					1,
					192,
					25,
					25732489,
					1,
					179,
					25,
					25732573,
					1,
					201,
					25,
					25732472,
					1,
					172,
					25,
					25732576,
					1,
					149,
					25,
					25732488,
					1,
					178,
					25,
					25732566,
					1,
					120,
					25,
					25732571,
					1,
					219,
					25,
					25732577,
					1,
					150,
					25,
					25732487,
					1,
					127,
					25,
					25732506,
					1,
					211,
					25,
					25732548,
					1,
					125,
					25,
					25732588,
					1,
					158,
					25,
					25732486,
					1,
					247,
					25,
					25732467,
					1,
					238,
					25,
					25732508,
					1,
					163,
					25,
					25732552,
					1,
					228,
					25,
					25732603,
					1,
					183,
					25,
					25732513,
					1,
					217,
					25,
					25732587,
					1,
					168,
					25,
					25732520,
					1,
					122,
					25,
					25732484,
					1,
					128,
					25,
					25732562,
					1,
					249,
					25,
					25732505,
					1,
					187,
					25,
					25732504,
					1,
					186,
					25,
					25732483,
					1,
					136,
					25,
					25928905,
					1,
					181,
					25,
					25732560,
					1,
					255,
					25,
					25732500,
					1,
					230,
					25,
					25732482,
					1,
					135,
					25,
					25732555,
					1,
					233,
					25,
					25732568,
					1,
					222,
					25,
					25732583,
					1,
					145,
					25,
					25732481,
					1,
					134,
					25,
					25732586,
					1,
					167,
					25,
					25732521,
					1,
					248,
					25,
					25732518,
					1,
					209,
					25,
					25732480,
					1,
					243,
					25,
					25732512,
					1,
					216,
					25,
					25732509,
					1,
					164,
					25,
					25732547,
					1,
					140,
					25,
					25732479,
					1,
					157,
					25,
					25732544,
					1,
					239,
					25,
					25732574,
					1,
					191,
					25,
					25732564,
					1,
					251,
					25,
					25732478,
					1,
					156,
					25,
					25732546,
					1,
					139,
					25,
					25732498,
					1,
					242,
					25,
					25732557,
					1,
					133,
					25,
					25732477,
					1,
					162,
					25,
					25732515,
					1,
					213,
					25,
					25732584,
					1,
					165,
					25,
					25732514,
					1,
					212,
					25,
					25732476,
					1,
					227,
					25,
					25732494,
					1,
					198,
					25,
					25732531,
					1,
					236,
					25,
					25732530,
					1,
					234,
					25,
					25732529,
					1,
					117,
					25,
					25732528,
					1,
					215,
					25,
					25732527,
					1,
					124,
					25,
					25732526,
					1,
					123,
					25,
					25732525,
					1,
					254,
					25,
					25732524,
					1,
					253,
					25,
					25732523,
					1,
					148,
					25,
					25732570,
					1,
					218,
					25,
					25732580,
					1,
					146,
					25,
					25732581,
					1,
					147,
					25,
					25732569,
					1,
					224,
					25,
					25732533,
					1,
					143,
					25,
					25732540,
					1,
					184,
					25,
					25732541,
					1,
					185,
					25,
					25732585,
					1,
					166,
					25,
					25732556,
					1,
					132,
					25,
					25732485,
					1,
					129,
					25,
					25732563,
					1,
					250,
					25,
					25732578,
					1,
					151,
					25,
					25732501,
					1,
					119,
					25,
					25732502,
					1,
					193,
					25,
					25732536,
					1,
					176,
					25,
					25732496,
					1,
					245,
					25,
					25732553,
					1,
					229,
					25,
					25732516,
					1,
					206,
					25,
					25732582,
					1,
					144,
					25,
					25732517,
					1,
					208,
					25,
					25732558,
					1,
					137,
					25,
					25732543,
					1,
					241,
					25,
					25732466,
					1,
					237,
					25,
					25732507,
					1,
					190,
					25,
					25732542,
					1,
					240,
					25,
					25732551,
					1,
					131,
					25,
					25732554,
					1,
					232,
					25,
					25732565,
					1,
					252,
					25,
					25732475,
					1,
					171,
					25,
					25732493,
					1,
					205,
					25,
					25732492,
					1,
					204,
					25,
					25732491,
					1,
					118,
					25,
					25732490,
					1,
					214,
					25,
					25928904,
					1,
					180,
					25,
					25732549,
					1,
					126,
					25,
					25732602,
					1,
					182,
					25,
					25732539,
					1,
					175,
					25,
					25732545,
					1,
					141,
					25,
					25732559,
					1,
					138,
					25,
					25732537,
					1,
					177,
					25,
					25732534,
					1,
					153,
					25,
					25732503,
					1,
					194,
					25,
					25732606,
					1,
					160,
					25,
					25732567,
					1,
					121,
					25,
					25732538,
					1,
					174,
					25,
					25732497,
					1,
					246,
					25,
					25732550,
					1,
					130,
					25,
					25732572,
					1,
					200,
					25,
					25732474,
					1,
					170,
					25,
					25732511,
					1,
					221,
					25,
					25732601,
					1,
					196,
					25,
					25732532,
					1,
					142,
					25,
					25732519,
					1,
					210,
					25,
					25732495,
					1,
					199,
					25,
					25732605,
					1,
					155,
					25,
					25732535,
					1,
					154,
					25,
					25732499,
					1,
					244,
					25,
					25732510,
					1,
					220,
					25,
					25732600,
					1,
					195,
					25,
					25732607,
					1,
					161,
					25,
					25732604,
					1,
					231,
					25,
					25732473,
					1,
					173,
					25,
					25732599,
					1,
					226,
					26,
					51465122,
					1,
					116,
					26,
					51465123,
					0,
					1
				], o, C, k, P = [
					3,
					3,
					3,
					3,
					2,
					2,
					2,
					1,
					1,
					1
				], V = 24576, ar = 16384, H = 8192, az = ar | H;
				function d(t) {
					var E = t[1], h = t[0][E >>> 3] >>> 7 - (E & 7) & 1;
					t[1]++;
					return h;
				}
				function ag(t, E) {
					if (o == null) {
						o = {};
						for (var h = 0; h < x.length; h += 4) o[x[h + 1]] = x.slice(h, h + 4);
					}
					var L = d(t), g = o[L];
					while (g == null) {
						L = L << 1 | d(t);
						g = o[L];
					}
					var n = g[3];
					if (n != 0) n = d(t) == 0 ? n : -n;
					E[0] = g[2];
					E[1] = n;
				}
				function m(t, E) {
					for (var h = 0; h < E; h++) {
						if ((t & 1) == 1) t++;
						t = t >>> 1;
					}
					return t;
				}
				function A(t, E) {
					return t >> E;
				}
				function O(t, E, h, L, g, n) {
					E[h] = A(A(11 * t[g] - 4 * t[g + n] + t[g + n + n] + 4, 3) + t[L], 1);
					E[h + n] = A(A(5 * t[g] + 4 * t[g + n] - t[g + n + n] + 4, 3) - t[L], 1);
				}
				function J(t, E, h, L, g, n) {
					var W = t[g - n] - t[g + n], j = t[g], $ = t[L];
					E[h] = A(A(W + 4, 3) + j + $, 1);
					E[h + n] = A(A(-W + 4, 3) + j - $, 1);
				}
				function y(t, E, h, L, g, n) {
					E[h] = A(A(5 * t[g] + 4 * t[g - n] - t[g - n - n] + 4, 3) + t[L], 1);
					E[h + n] = A(A(11 * t[g] - 4 * t[g - n] + t[g - n - n] + 4, 3) - t[L], 1);
				}
				function q$1(t) {
					t = t < 0 ? 0 : t > 4095 ? 4095 : t;
					t = k[t] >>> 2;
					return t;
				}
				function av(t, E, h, L, g, n) {
					L = new Uint16Array(L.buffer);
					var W = Date.now(), j = UTIF$1._binBE, $ = E + h, r, u, X, I, ax, R, aa, i$1, T, B;
					E += 4;
					var a5 = n[0] == 1;
					while (E < $) {
						var S = j.readShort(t, E), s = j.readUshort(t, E + 2);
						E += 4;
						if (S == 12) r = s;
						else if (S == 20) u = s;
						else if (S == 21) X = s;
						else if (S == 48) I = s;
						else if (S == 53) ax = s;
						else if (S == 35);
						else if (S == 62) R = s;
						else if (S == 101);
						else if (S == 109) aa = s;
						else if (S == 84);
						else if (S == 106);
						else if (S == 107);
						else if (S == 108);
						else if (S == 102);
						else if (S == 104) i$1 = s;
						else if (S == 105);
						else {
							var F = S < 0 ? -S : S, D = F & 65280, _ = 0;
							if (F & az) if (F & H) {
								_ = s & 65535;
								_ += (F & 255) << 16;
							} else _ = s & 65535;
							if ((F & V) == V) {
								if (T == null) {
									T = [];
									for (var M = 0; M < 4; M++) T[M] = new Int16Array((u >>> 1) * (X >>> 1));
									B = new Int16Array((u >>> 1) * (X >>> 1));
									C = new Int16Array(1024);
									for (var M = 0; M < 1024; M++) {
										var aG = M - 512, p = Math.abs(aG), r = Math.floor(768 * p * p * p / (65025 * 255)) + p;
										C[M] = Math.sign(aG) * r;
									}
									k = new Uint16Array(4096);
									var aA = 65535;
									for (var M = 0; M < 4096; M++) {
										var at = M, a1 = aA * (Math.pow(113, at / 4095) - 1) / 112;
										k[M] = Math.min(a1, aA);
									}
								}
								var w = T[R], v = m(u, 1 + P[I]), N = m(X, 1 + P[I]);
								if (I == 0) for (var b = 0; b < N; b++) for (var G = 0; G < v; G++) {
									var c$1 = E + (b * v + G) * 2;
									w[b * (u >>> 1) + G] = t[c$1] << 8 | t[c$1 + 1];
								}
								else {
									var a7 = [t, E * 8], a4 = [], ay = 0, aw = v * N, f = [0, 0], Q = 0, s = 0;
									while (ay < aw) {
										ag(a7, f);
										Q = f[0];
										s = f[1];
										while (Q > 0) {
											a4[ay++] = s;
											Q--;
										}
									}
									var l = (I - 1) % 3, aF = l != 1 ? v : 0, a2 = l != 0 ? N : 0;
									for (var b = 0; b < N; b++) {
										var af = (b + a2) * (u >>> 1) + aF, au = b * v;
										for (var G = 0; G < v; G++) w[af + G] = C[a4[au + G] + 512] * ax;
									}
									if (l == 2) {
										var i$1 = u >>> 1, an = v * 2, a9 = N * 2;
										for (var b = 0; b < N; b++) for (var G = 0; G < an; G++) {
											var M = b * 2 * i$1 + G, a = b * i$1 + G, e = N * i$1 + a;
											if (b == 0) O(w, B, M, e, a, i$1);
											else if (b == N - 1) y(w, B, M, e, a, i$1);
											else J(w, B, M, e, a, i$1);
										}
										var Z = w;
										w = B;
										B = Z;
										for (var b = 0; b < a9; b++) for (var G = 0; G < v; G++) {
											var M = b * i$1 + 2 * G, a = b * i$1 + G, e = v + a;
											if (G == 0) O(w, B, M, e, a, 1);
											else if (G == v - 1) y(w, B, M, e, a, 1);
											else J(w, B, M, e, a, 1);
										}
										var Z = w;
										w = B;
										B = Z;
										var aC = [], aB = 2 - ~~((I - 1) / 3);
										for (var K = 0; K < 3; K++) aC[K] = aa >> 14 - K * 2 & 3;
										var a6 = aC[aB];
										if (a6 != 0) for (var b = 0; b < a9; b++) for (var G = 0; G < an; G++) {
											var M = b * i$1 + G;
											w[M] = w[M] << a6;
										}
									}
								}
								if (I == 9 && R == 3) {
									var a8 = T[0], ab = T[1], aq = T[2], as = T[3];
									for (var b = 0; b < X; b += 2) for (var G = 0; G < u; G += 2) {
										var U = b * u + G, c$1 = (b >>> 1) * (u >>> 1) + (G >>> 1), z = a8[c$1], ao = ab[c$1] - 2048, ak = aq[c$1] - 2048, ad = as[c$1] - 2048, aj = (ao << 1) + z, a0 = (ak << 1) + z, aH = z + ad, am = z - ad;
										if (a5) {
											L[U] = q$1(aH);
											L[U + 1] = q$1(a0);
											L[U + u] = q$1(aj);
											L[U + u + 1] = q$1(am);
										} else {
											L[U] = q$1(aj);
											L[U + 1] = q$1(aH);
											L[U + u] = q$1(am);
											L[U + u + 1] = q$1(a0);
										}
									}
								}
								E += _ * 4;
							} else if (F == 16388) E += _ * 4;
							else if (D == 8192 || D == 8448 || D == 9216) {} else throw F.toString(16);
						}
					}
					console.log(Date.now() - W);
				}
				return av;
			}();
			UTIF$1.decode._decodeLogLuv32 = function(img, data, off, len, tgt, toff) {
				var w = img.width, qw = w * 4;
				var io = 0, out = new Uint8Array(qw);
				while (io < len) {
					var oo = 0;
					while (oo < qw) {
						var c$1 = data[off + io];
						io++;
						if (c$1 < 128) {
							for (var j = 0; j < c$1; j++) out[oo + j] = data[off + io + j];
							oo += c$1;
							io += c$1;
						} else {
							c$1 = c$1 - 126;
							for (var j = 0; j < c$1; j++) out[oo + j] = data[off + io];
							oo += c$1;
							io++;
						}
					}
					for (var x = 0; x < w; x++) {
						tgt[toff + 0] = out[x];
						tgt[toff + 1] = out[x + w];
						tgt[toff + 2] = out[x + w * 2];
						tgt[toff + 4] = out[x + w * 3];
						toff += 6;
					}
				}
			};
			UTIF$1.decode._ljpeg_diff = function(data, prm, huff) {
				var getbithuff = UTIF$1.decode._getbithuff;
				var len = getbithuff(data, prm, huff[0], huff), diff = getbithuff(data, prm, len, 0);
				if ((diff & 1 << len - 1) == 0) diff -= (1 << len) - 1;
				return diff;
			};
			UTIF$1.decode._decodeARW = function(img, inp, off, src_length, tgt, toff) {
				var raw_width = img["t256"][0], height = img["t257"][0], tiff_bps = img["t258"][0];
				var bin = img.isLE ? UTIF$1._binLE : UTIF$1._binBE;
				if (!(raw_width * height == src_length || raw_width * height * 1.5 == src_length)) {
					height += 8;
					var prm = [
						off,
						0,
						0,
						0
					];
					var huff = new Uint16Array(32770);
					var tab = [
						3857,
						3856,
						3599,
						3342,
						3085,
						2828,
						2571,
						2314,
						2057,
						1800,
						1543,
						1286,
						1029,
						772,
						771,
						768,
						514,
						513
					];
					var i$1, c$1, n, col, row, sum = 0;
					var ljpeg_diff = UTIF$1.decode._ljpeg_diff;
					huff[0] = 15;
					for (n = i$1 = 0; i$1 < 18; i$1++) {
						var lim = 32768 >>> (tab[i$1] >>> 8);
						for (var c$1 = 0; c$1 < lim; c$1++) huff[++n] = tab[i$1];
					}
					for (col = raw_width; col--;) for (row = 0; row < height + 1; row += 2) {
						if (row == height) row = 1;
						sum += ljpeg_diff(inp, prm, huff);
						if (row < height) {
							var clr = sum & 4095;
							UTIF$1.decode._putsF(tgt, (row * raw_width + col) * tiff_bps, clr << 16 - tiff_bps);
						}
					}
					return;
				}
				if (raw_width * height * 1.5 == src_length) {
					for (var i$1 = 0; i$1 < src_length; i$1 += 3) {
						var b0 = inp[off + i$1 + 0], b1 = inp[off + i$1 + 1], b2 = inp[off + i$1 + 2];
						tgt[toff + i$1] = b1 << 4 | b0 >>> 4;
						tgt[toff + i$1 + 1] = b0 << 4 | b2 >>> 4;
						tgt[toff + i$1 + 2] = b2 << 4 | b1 >>> 4;
					}
					return;
				}
				var pix = new Uint16Array(16);
				var row, col, val, max, min, imax, imin, sh, bit, i$1, dp;
				var data = new Uint8Array(raw_width + 1);
				for (row = 0; row < height; row++) {
					for (var j = 0; j < raw_width; j++) data[j] = inp[off++];
					for (dp = 0, col = 0; col < raw_width - 30; dp += 16) {
						max = 2047 & (val = bin.readUint(data, dp));
						min = 2047 & val >>> 11;
						imax = 15 & val >>> 22;
						imin = 15 & val >>> 26;
						for (sh = 0; sh < 4 && 128 << sh <= max - min; sh++);
						for (bit = 30, i$1 = 0; i$1 < 16; i$1++) if (i$1 == imax) pix[i$1] = max;
						else if (i$1 == imin) pix[i$1] = min;
						else {
							pix[i$1] = ((bin.readUshort(data, dp + (bit >> 3)) >>> (bit & 7) & 127) << sh) + min;
							if (pix[i$1] > 2047) pix[i$1] = 2047;
							bit += 7;
						}
						for (i$1 = 0; i$1 < 16; i$1++, col += 2) {
							var clr = pix[i$1] << 1;
							UTIF$1.decode._putsF(tgt, (row * raw_width + col) * tiff_bps, clr << 16 - tiff_bps);
						}
						col -= col & 1 ? 1 : 31;
					}
				}
			};
			UTIF$1.decode._decodeNikon = function(img, imgs, data, off, src_length, tgt, toff) {
				var nikon_tree = [
					[
						0,
						0,
						1,
						5,
						1,
						1,
						1,
						1,
						1,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						5,
						4,
						3,
						6,
						2,
						7,
						1,
						0,
						8,
						9,
						11,
						10,
						12
					],
					[
						0,
						0,
						1,
						5,
						1,
						1,
						1,
						1,
						1,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						57,
						90,
						56,
						39,
						22,
						5,
						4,
						3,
						2,
						1,
						0,
						11,
						12,
						12
					],
					[
						0,
						0,
						1,
						4,
						2,
						3,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						5,
						4,
						6,
						3,
						7,
						2,
						8,
						1,
						9,
						0,
						10,
						11,
						12
					],
					[
						0,
						0,
						1,
						4,
						3,
						1,
						1,
						1,
						1,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						5,
						6,
						4,
						7,
						8,
						3,
						9,
						2,
						1,
						0,
						10,
						11,
						12,
						13,
						14
					],
					[
						0,
						0,
						1,
						5,
						1,
						1,
						1,
						1,
						1,
						1,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						8,
						92,
						75,
						58,
						41,
						7,
						6,
						5,
						4,
						3,
						2,
						1,
						0,
						13,
						14
					],
					[
						0,
						0,
						1,
						4,
						2,
						2,
						3,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						7,
						6,
						8,
						5,
						9,
						4,
						10,
						3,
						11,
						12,
						2,
						0,
						1,
						13,
						14
					]
				];
				var raw_width = img["t256"][0], height = img["t257"][0], tiff_bps = img["t258"][0];
				var tree = 0, split$1 = 0;
				var make_decoder = UTIF$1.decode._make_decoder;
				var getbithuff = UTIF$1.decode._getbithuff;
				var mn = imgs[0].exifIFD.makerNote, md = mn["t150"] ? mn["t150"] : mn["t140"], mdo = 0;
				var ver0 = md[mdo++], ver1 = md[mdo++];
				if (ver0 == 73 || ver1 == 88) mdo += 2110;
				if (ver0 == 70) tree = 2;
				if (tiff_bps == 14) tree += 3;
				var vpred = [[0, 0], [0, 0]], bin = img.isLE ? UTIF$1._binLE : UTIF$1._binBE;
				for (var i$1 = 0; i$1 < 2; i$1++) for (var j = 0; j < 2; j++) {
					vpred[i$1][j] = bin.readShort(md, mdo);
					mdo += 2;
				}
				var max = 1 << tiff_bps & 32767, step$1 = 0;
				var csize = bin.readShort(md, mdo);
				mdo += 2;
				if (csize > 1) step$1 = Math.floor(max / (csize - 1));
				if (ver0 == 68 && ver1 == 32 && step$1 > 0) split$1 = bin.readShort(md, 562);
				var i$1;
				var row, col;
				var len, shl, diff;
				var hpred = [0, 0];
				var huff = make_decoder(nikon_tree[tree]);
				var prm = [
					off,
					0,
					0,
					0
				];
				for (row = 0; row < height; row++) {
					if (split$1 && row == split$1) huff = make_decoder(nikon_tree[tree + 1]);
					for (col = 0; col < raw_width; col++) {
						i$1 = getbithuff(data, prm, huff[0], huff);
						len = i$1 & 15;
						shl = i$1 >>> 4;
						diff = (getbithuff(data, prm, len - shl, 0) << 1) + 1 << shl >>> 1;
						if ((diff & 1 << len - 1) == 0) diff -= (1 << len) - (shl == 0 ? 1 : 0);
						if (col < 2) hpred[col] = vpred[row & 1][col] += diff;
						else hpred[col & 1] += diff;
						var clr = Math.min(Math.max(hpred[col & 1], 0), (1 << tiff_bps) - 1);
						var bti = (row * raw_width + col) * tiff_bps;
						UTIF$1.decode._putsF(tgt, bti, clr << 16 - tiff_bps);
					}
				}
			};
			UTIF$1.decode._putsF = function(dt, pos, val) {
				val = val << 8 - (pos & 7);
				var o = pos >>> 3;
				dt[o] |= val >>> 16;
				dt[o + 1] |= val >>> 8;
				dt[o + 2] |= val;
			};
			UTIF$1.decode._getbithuff = function(data, prm, nbits, huff) {
				var zero_after_ff = 0;
				UTIF$1.decode._get_byte;
				var c$1;
				var off = prm[0], bitbuf = prm[1], vbits = prm[2], reset = prm[3];
				if (nbits == 0 || vbits < 0) return 0;
				while (!reset && vbits < nbits && (c$1 = data[off++]) != -1 && !(reset = zero_after_ff && c$1 == 255 && data[off++])) {
					bitbuf = (bitbuf << 8) + c$1;
					vbits += 8;
				}
				c$1 = bitbuf << 32 - vbits >>> 32 - nbits;
				if (huff) {
					vbits -= huff[c$1 + 1] >>> 8;
					c$1 = huff[c$1 + 1] & 255;
				} else vbits -= nbits;
				if (vbits < 0) throw "e";
				prm[0] = off;
				prm[1] = bitbuf;
				prm[2] = vbits;
				prm[3] = reset;
				return c$1;
			};
			UTIF$1.decode._make_decoder = function(source) {
				var max, len, h, i$1, j;
				var huff = [];
				for (max = 16; max != 0 && !source[max]; max--);
				var si = 17;
				huff[0] = max;
				for (h = len = 1; len <= max; len++) for (i$1 = 0; i$1 < source[len]; i$1++, ++si) for (j = 0; j < 1 << max - len; j++) if (h <= 1 << max) huff[h++] = len << 8 | source[si];
				return huff;
			};
			UTIF$1.decode._decodeNewJPEG = function(img, data, off, len, tgt, toff) {
				len = Math.min(len, data.length - off);
				var tables = img["t347"], tlen = tables ? tables.length : 0, buff = new Uint8Array(tlen + len);
				if (tables) {
					var SOI = 216, EOI$1 = 217, boff = 0;
					for (var i$1 = 0; i$1 < tlen - 1; i$1++) {
						if (tables[i$1] == 255 && tables[i$1 + 1] == EOI$1) break;
						buff[boff++] = tables[i$1];
					}
					var byte1 = data[off], byte2 = data[off + 1];
					if (byte1 != 255 || byte2 != SOI) {
						buff[boff++] = byte1;
						buff[boff++] = byte2;
					}
					for (var i$1 = 2; i$1 < len; i$1++) buff[boff++] = data[off + i$1];
				} else for (var i$1 = 0; i$1 < len; i$1++) buff[i$1] = data[off + i$1];
				if (img["t262"][0] == 32803 || img["t259"][0] == 7 && img["t262"][0] == 34892) {
					var bps = img["t258"][0];
					var out = UTIF$1.LosslessJpegDecode(buff), olen = out.length;
					if (bps == 16) if (img.isLE) for (var i$1 = 0; i$1 < olen; i$1++) {
						tgt[toff + (i$1 << 1)] = out[i$1] & 255;
						tgt[toff + (i$1 << 1) + 1] = out[i$1] >>> 8;
					}
					else for (var i$1 = 0; i$1 < olen; i$1++) {
						tgt[toff + (i$1 << 1)] = out[i$1] >>> 8;
						tgt[toff + (i$1 << 1) + 1] = out[i$1] & 255;
					}
					else if (bps == 14 || bps == 12 || bps == 10) {
						var rst = 16 - bps;
						for (var i$1 = 0; i$1 < olen; i$1++) UTIF$1.decode._putsF(tgt, i$1 * bps, out[i$1] << rst);
					} else if (bps == 8) for (var i$1 = 0; i$1 < olen; i$1++) tgt[toff + i$1] = out[i$1];
					else throw new Error("unsupported bit depth " + bps);
				} else {
					var parser = new UTIF$1.JpegDecoder();
					parser.parse(buff);
					var decoded = parser.getData({
						"width": parser.width,
						"height": parser.height,
						"forceRGB": true,
						"isSourcePDF": false
					});
					for (var i$1 = 0; i$1 < decoded.length; i$1++) tgt[toff + i$1] = decoded[i$1];
				}
				if (img["t262"][0] == 6) img["t262"][0] = 2;
			};
			UTIF$1.decode._decodeOldJPEGInit = function(img, data, off, len) {
				var SOI = 216, DQT = 219, DHT = 196, DRI = 221, SOF0 = 192, SOS$1 = 218;
				var joff = 0, soff = 0, tables, sosMarker$1, isTiled = false, i$1, j, k;
				var jpgIchgFmt = img["t513"], jifoff = jpgIchgFmt ? jpgIchgFmt[0] : 0;
				var jpgIchgFmtLen = img["t514"], jiflen = jpgIchgFmtLen ? jpgIchgFmtLen[0] : 0;
				var soffTag = img["t324"] || img["t273"] || jpgIchgFmt;
				var ycbcrss = img["t530"], ssx = 0, ssy = 0;
				var spp = img["t277"] ? img["t277"][0] : 1;
				var jpgresint = img["t515"];
				if (soffTag) {
					soff = soffTag[0];
					isTiled = soffTag.length > 1;
				}
				if (!isTiled) {
					if (data[off] == 255 && data[off + 1] == SOI) return { jpegOffset: off };
					if (jpgIchgFmt != null) {
						if (data[off + jifoff] == 255 && data[off + jifoff + 1] == SOI) joff = off + jifoff;
						else log("JPEGInterchangeFormat does not point to SOI");
						if (jpgIchgFmtLen == null) log("JPEGInterchangeFormatLength field is missing");
						else if (jifoff >= soff || jifoff + jiflen <= soff) log("JPEGInterchangeFormatLength field value is invalid");
						if (joff != null) return { jpegOffset: joff };
					}
				}
				if (ycbcrss != null) {
					ssx = ycbcrss[0];
					ssy = ycbcrss[1];
				}
				if (jpgIchgFmt != null) {
					if (jpgIchgFmtLen != null) if (jiflen >= 2 && jifoff + jiflen <= soff) {
						if (data[off + jifoff + jiflen - 2] == 255 && data[off + jifoff + jiflen - 1] == SOI) tables = new Uint8Array(jiflen - 2);
						else tables = new Uint8Array(jiflen);
						for (i$1 = 0; i$1 < tables.length; i$1++) tables[i$1] = data[off + jifoff + i$1];
						log("Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables");
					} else log("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");
				}
				if (tables == null) {
					var ooff = 0, out = [];
					out[ooff++] = 255;
					out[ooff++] = SOI;
					var qtables = img["t519"];
					if (qtables == null) throw new Error("JPEGQTables tag is missing");
					for (i$1 = 0; i$1 < qtables.length; i$1++) {
						out[ooff++] = 255;
						out[ooff++] = DQT;
						out[ooff++] = 0;
						out[ooff++] = 67;
						out[ooff++] = i$1;
						for (j = 0; j < 64; j++) out[ooff++] = data[off + qtables[i$1] + j];
					}
					for (k = 0; k < 2; k++) {
						var htables = img[k == 0 ? "t520" : "t521"];
						if (htables == null) throw new Error((k == 0 ? "JPEGDCTables" : "JPEGACTables") + " tag is missing");
						for (i$1 = 0; i$1 < htables.length; i$1++) {
							out[ooff++] = 255;
							out[ooff++] = DHT;
							var nc = 19;
							for (j = 0; j < 16; j++) nc += data[off + htables[i$1] + j];
							out[ooff++] = nc >>> 8;
							out[ooff++] = nc & 255;
							out[ooff++] = i$1 | k << 4;
							for (j = 0; j < 16; j++) out[ooff++] = data[off + htables[i$1] + j];
							for (j = 0; j < nc; j++) out[ooff++] = data[off + htables[i$1] + 16 + j];
						}
					}
					out[ooff++] = 255;
					out[ooff++] = SOF0;
					out[ooff++] = 0;
					out[ooff++] = 8 + 3 * spp;
					out[ooff++] = 8;
					out[ooff++] = img.height >>> 8 & 255;
					out[ooff++] = img.height & 255;
					out[ooff++] = img.width >>> 8 & 255;
					out[ooff++] = img.width & 255;
					out[ooff++] = spp;
					if (spp == 1) {
						out[ooff++] = 1;
						out[ooff++] = 17;
						out[ooff++] = 0;
					} else for (i$1 = 0; i$1 < 3; i$1++) {
						out[ooff++] = i$1 + 1;
						out[ooff++] = i$1 != 0 ? 17 : (ssx & 15) << 4 | ssy & 15;
						out[ooff++] = i$1;
					}
					if (jpgresint != null && jpgresint[0] != 0) {
						out[ooff++] = 255;
						out[ooff++] = DRI;
						out[ooff++] = 0;
						out[ooff++] = 4;
						out[ooff++] = jpgresint[0] >>> 8 & 255;
						out[ooff++] = jpgresint[0] & 255;
					}
					tables = new Uint8Array(out);
				}
				var sofpos = -1;
				i$1 = 0;
				while (i$1 < tables.length - 1) {
					if (tables[i$1] == 255 && tables[i$1 + 1] == SOF0) {
						sofpos = i$1;
						break;
					}
					i$1++;
				}
				if (sofpos == -1) {
					var tmptab = new Uint8Array(tables.length + 10 + 3 * spp);
					tmptab.set(tables);
					var tmpoff = tables.length;
					sofpos = tables.length;
					tables = tmptab;
					tables[tmpoff++] = 255;
					tables[tmpoff++] = SOF0;
					tables[tmpoff++] = 0;
					tables[tmpoff++] = 8 + 3 * spp;
					tables[tmpoff++] = 8;
					tables[tmpoff++] = img.height >>> 8 & 255;
					tables[tmpoff++] = img.height & 255;
					tables[tmpoff++] = img.width >>> 8 & 255;
					tables[tmpoff++] = img.width & 255;
					tables[tmpoff++] = spp;
					if (spp == 1) {
						tables[tmpoff++] = 1;
						tables[tmpoff++] = 17;
						tables[tmpoff++] = 0;
					} else for (i$1 = 0; i$1 < 3; i$1++) {
						tables[tmpoff++] = i$1 + 1;
						tables[tmpoff++] = i$1 != 0 ? 17 : (ssx & 15) << 4 | ssy & 15;
						tables[tmpoff++] = i$1;
					}
				}
				if (data[soff] == 255 && data[soff + 1] == SOS$1) {
					var soslen = data[soff + 2] << 8 | data[soff + 3];
					sosMarker$1 = new Uint8Array(soslen + 2);
					sosMarker$1[0] = data[soff];
					sosMarker$1[1] = data[soff + 1];
					sosMarker$1[2] = data[soff + 2];
					sosMarker$1[3] = data[soff + 3];
					for (i$1 = 0; i$1 < soslen - 2; i$1++) sosMarker$1[i$1 + 4] = data[soff + i$1 + 4];
				} else {
					sosMarker$1 = new Uint8Array(8 + 2 * spp);
					var sosoff = 0;
					sosMarker$1[sosoff++] = 255;
					sosMarker$1[sosoff++] = SOS$1;
					sosMarker$1[sosoff++] = 0;
					sosMarker$1[sosoff++] = 6 + 2 * spp;
					sosMarker$1[sosoff++] = spp;
					if (spp == 1) {
						sosMarker$1[sosoff++] = 1;
						sosMarker$1[sosoff++] = 0;
					} else for (i$1 = 0; i$1 < 3; i$1++) {
						sosMarker$1[sosoff++] = i$1 + 1;
						sosMarker$1[sosoff++] = i$1 << 4 | i$1;
					}
					sosMarker$1[sosoff++] = 0;
					sosMarker$1[sosoff++] = 63;
					sosMarker$1[sosoff++] = 0;
				}
				return {
					jpegOffset: off,
					tables,
					sosMarker: sosMarker$1,
					sofPosition: sofpos
				};
			};
			UTIF$1.decode._decodeOldJPEG = function(img, data, off, len, tgt, toff) {
				var i$1, dlen, tlen, buff, buffoff;
				var jpegData = UTIF$1.decode._decodeOldJPEGInit(img, data, off, len);
				if (jpegData.jpegOffset != null) {
					dlen = off + len - jpegData.jpegOffset;
					buff = new Uint8Array(dlen);
					for (i$1 = 0; i$1 < dlen; i$1++) buff[i$1] = data[jpegData.jpegOffset + i$1];
				} else {
					tlen = jpegData.tables.length;
					buff = new Uint8Array(tlen + jpegData.sosMarker.length + len + 2);
					buff.set(jpegData.tables);
					buffoff = tlen;
					buff[jpegData.sofPosition + 5] = img.height >>> 8 & 255;
					buff[jpegData.sofPosition + 6] = img.height & 255;
					buff[jpegData.sofPosition + 7] = img.width >>> 8 & 255;
					buff[jpegData.sofPosition + 8] = img.width & 255;
					if (data[off] != 255 || data[off + 1] != SOS) {
						buff.set(jpegData.sosMarker, buffoff);
						buffoff += sosMarker.length;
					}
					for (i$1 = 0; i$1 < len; i$1++) buff[buffoff++] = data[off + i$1];
					buff[buffoff++] = 255;
					buff[buffoff++] = EOI;
				}
				var parser = new UTIF$1.JpegDecoder();
				parser.parse(buff);
				var decoded = parser.getData({
					"width": parser.width,
					"height": parser.height,
					"forceRGB": true,
					"isSourcePDF": false
				});
				for (var i$1 = 0; i$1 < decoded.length; i$1++) tgt[toff + i$1] = decoded[i$1];
				if (img["t262"] && img["t262"][0] == 6) img["t262"][0] = 2;
			};
			UTIF$1.decode._decodePackBits = function(data, off, len, tgt, toff) {
				var sa = new Int8Array(data.buffer), ta = new Int8Array(tgt.buffer), lim = off + len;
				while (off < lim) {
					var n = sa[off];
					off++;
					if (n >= 0 && n < 128) for (var i$1 = 0; i$1 < n + 1; i$1++) {
						ta[toff] = sa[off];
						toff++;
						off++;
					}
					if (n >= -127 && n < 0) {
						for (var i$1 = 0; i$1 < -n + 1; i$1++) {
							ta[toff] = sa[off];
							toff++;
						}
						off++;
					}
				}
				return toff;
			};
			UTIF$1.decode._decodeThunder = function(data, off, len, tgt, toff) {
				var d2 = [
					0,
					1,
					0,
					-1
				], d3 = [
					0,
					1,
					2,
					3,
					0,
					-3,
					-2,
					-1
				];
				var lim = off + len, qoff = toff * 2, px = 0;
				while (off < lim) {
					var b = data[off], msk = b >>> 6, n = b & 63;
					off++;
					if (msk == 3) {
						px = n & 15;
						tgt[qoff >>> 1] |= px << 4 * (1 - qoff & 1);
						qoff++;
					}
					if (msk == 0) for (var i$1 = 0; i$1 < n; i$1++) {
						tgt[qoff >>> 1] |= px << 4 * (1 - qoff & 1);
						qoff++;
					}
					if (msk == 2) for (var i$1 = 0; i$1 < 2; i$1++) {
						var d = n >>> 3 * (1 - i$1) & 7;
						if (d != 4) {
							px += d3[d];
							tgt[qoff >>> 1] |= px << 4 * (1 - qoff & 1);
							qoff++;
						}
					}
					if (msk == 1) for (var i$1 = 0; i$1 < 3; i$1++) {
						var d = n >>> 2 * (2 - i$1) & 3;
						if (d != 2) {
							px += d2[d];
							tgt[qoff >>> 1] |= px << 4 * (1 - qoff & 1);
							qoff++;
						}
					}
				}
			};
			UTIF$1.decode._dmap = {
				"1": 0,
				"011": 1,
				"000011": 2,
				"0000011": 3,
				"010": -1,
				"000010": -2,
				"0000010": -3
			};
			UTIF$1.decode._lens = (function() {
				var addKeys = function(lens, arr, i0, inc) {
					for (var i$1 = 0; i$1 < arr.length; i$1++) lens[arr[i$1]] = i0 + i$1 * inc;
				};
				var termW = "00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100";
				var termB = "0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111";
				var makeW = "11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011";
				var makeB = "0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101";
				var makeA = "00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";
				termW = termW.split(",");
				termB = termB.split(",");
				makeW = makeW.split(",");
				makeB = makeB.split(",");
				makeA = makeA.split(",");
				var lensW = {}, lensB = {};
				addKeys(lensW, termW, 0, 1);
				addKeys(lensW, makeW, 64, 64);
				addKeys(lensW, makeA, 1792, 64);
				addKeys(lensB, termB, 0, 1);
				addKeys(lensB, makeB, 64, 64);
				addKeys(lensB, makeA, 1792, 64);
				return [lensW, lensB];
			})();
			UTIF$1.decode._decodeG4 = function(data, off, slen, tgt, toff, w, fo) {
				var U = UTIF$1.decode, boff = off << 3, len = 0, wrd = "";
				var line = [], pline = [];
				for (var i$1 = 0; i$1 < w; i$1++) pline.push(0);
				pline = U._makeDiff(pline);
				var a0 = 0, a1 = 0, b1 = 0, b2 = 0, clr = 0;
				var y = 0, mode = "", toRead = 0;
				var bipl = Math.ceil(w / 8) * 8;
				while (boff >>> 3 < off + slen) {
					b1 = U._findDiff(pline, a0 + (a0 == 0 ? 0 : 1), 1 - clr), b2 = U._findDiff(pline, b1, clr);
					var bit = 0;
					if (fo == 1) bit = data[boff >>> 3] >>> 7 - (boff & 7) & 1;
					if (fo == 2) bit = data[boff >>> 3] >>> (boff & 7) & 1;
					boff++;
					wrd += bit;
					if (mode == "H") {
						if (U._lens[clr][wrd] != null) {
							var dl = U._lens[clr][wrd];
							wrd = "";
							len += dl;
							if (dl < 64) {
								U._addNtimes(line, len, clr);
								a0 += len;
								clr = 1 - clr;
								len = 0;
								toRead--;
								if (toRead == 0) mode = "";
							}
						}
					} else {
						if (wrd == "0001") {
							wrd = "";
							U._addNtimes(line, b2 - a0, clr);
							a0 = b2;
						}
						if (wrd == "001") {
							wrd = "";
							mode = "H";
							toRead = 2;
						}
						if (U._dmap[wrd] != null) {
							a1 = b1 + U._dmap[wrd];
							U._addNtimes(line, a1 - a0, clr);
							a0 = a1;
							wrd = "";
							clr = 1 - clr;
						}
					}
					if (line.length == w && mode == "") {
						U._writeBits(line, tgt, toff * 8 + y * bipl);
						clr = 0;
						y++;
						a0 = 0;
						pline = U._makeDiff(line);
						line = [];
					}
				}
			};
			UTIF$1.decode._findDiff = function(line, x, clr) {
				for (var i$1 = 0; i$1 < line.length; i$1 += 2) if (line[i$1] >= x && line[i$1 + 1] == clr) return line[i$1];
			};
			UTIF$1.decode._makeDiff = function(line) {
				var out = [];
				if (line[0] == 1) out.push(0, 1);
				for (var i$1 = 1; i$1 < line.length; i$1++) if (line[i$1 - 1] != line[i$1]) out.push(i$1, line[i$1]);
				out.push(line.length, 0, line.length, 1);
				return out;
			};
			UTIF$1.decode._decodeG2 = function(data, off, slen, tgt, toff, w, fo) {
				var U = UTIF$1.decode, boff = off << 3, len = 0, wrd = "";
				var line = [];
				var clr = 0;
				var y = 0;
				var bipl = Math.ceil(w / 8) * 8;
				while (boff >>> 3 < off + slen) {
					var bit = 0;
					if (fo == 1) bit = data[boff >>> 3] >>> 7 - (boff & 7) & 1;
					if (fo == 2) bit = data[boff >>> 3] >>> (boff & 7) & 1;
					boff++;
					wrd += bit;
					len = U._lens[clr][wrd];
					if (len != null) {
						U._addNtimes(line, len, clr);
						wrd = "";
						if (len < 64) clr = 1 - clr;
						if (line.length == w) {
							U._writeBits(line, tgt, toff * 8 + y * bipl);
							line = [];
							y++;
							clr = 0;
							if ((boff & 7) != 0) boff += 8 - (boff & 7);
							if (len >= 64) boff += 8;
						}
					}
				}
			};
			UTIF$1.decode._decodeG3 = function(data, off, slen, tgt, toff, w, fo, twoDim) {
				var U = UTIF$1.decode, boff = off << 3, len = 0, wrd = "";
				var line = [], pline = [];
				for (var i$1 = 0; i$1 < w; i$1++) line.push(0);
				var a0 = 0, a1 = 0, b1 = 0, b2 = 0, clr = 0;
				var y = -1, mode = "", toRead = 0, is1D = true;
				var bipl = Math.ceil(w / 8) * 8;
				while (boff >>> 3 < off + slen) {
					b1 = U._findDiff(pline, a0 + (a0 == 0 ? 0 : 1), 1 - clr), b2 = U._findDiff(pline, b1, clr);
					var bit = 0;
					if (fo == 1) bit = data[boff >>> 3] >>> 7 - (boff & 7) & 1;
					if (fo == 2) bit = data[boff >>> 3] >>> (boff & 7) & 1;
					boff++;
					wrd += bit;
					if (is1D) {
						if (U._lens[clr][wrd] != null) {
							var dl = U._lens[clr][wrd];
							wrd = "";
							len += dl;
							if (dl < 64) {
								U._addNtimes(line, len, clr);
								clr = 1 - clr;
								len = 0;
							}
						}
					} else if (mode == "H") {
						if (U._lens[clr][wrd] != null) {
							var dl = U._lens[clr][wrd];
							wrd = "";
							len += dl;
							if (dl < 64) {
								U._addNtimes(line, len, clr);
								a0 += len;
								clr = 1 - clr;
								len = 0;
								toRead--;
								if (toRead == 0) mode = "";
							}
						}
					} else {
						if (wrd == "0001") {
							wrd = "";
							U._addNtimes(line, b2 - a0, clr);
							a0 = b2;
						}
						if (wrd == "001") {
							wrd = "";
							mode = "H";
							toRead = 2;
						}
						if (U._dmap[wrd] != null) {
							a1 = b1 + U._dmap[wrd];
							U._addNtimes(line, a1 - a0, clr);
							a0 = a1;
							wrd = "";
							clr = 1 - clr;
						}
					}
					if (wrd.endsWith("000000000001")) {
						if (y >= 0) U._writeBits(line, tgt, toff * 8 + y * bipl);
						if (twoDim) {
							if (fo == 1) is1D = (data[boff >>> 3] >>> 7 - (boff & 7) & 1) == 1;
							if (fo == 2) is1D = (data[boff >>> 3] >>> (boff & 7) & 1) == 1;
							boff++;
						}
						wrd = "";
						clr = 0;
						y++;
						a0 = 0;
						pline = U._makeDiff(line);
						line = [];
					}
				}
				if (line.length == w) U._writeBits(line, tgt, toff * 8 + y * bipl);
			};
			UTIF$1.decode._addNtimes = function(arr, n, val) {
				for (var i$1 = 0; i$1 < n; i$1++) arr.push(val);
			};
			UTIF$1.decode._writeBits = function(bits, tgt, boff) {
				for (var i$1 = 0; i$1 < bits.length; i$1++) tgt[boff + i$1 >>> 3] |= bits[i$1] << 7 - (boff + i$1 & 7);
			};
			UTIF$1.decode._decodeLZW = UTIF$1.decode._decodeLZW = function() {
				var e, U, Z, u, K = 0, V = 0, g = 0, N = 0, O = function() {
					var S = e >>> 3, j = (U[S] << 16 | U[S + 1] << 8 | U[S + 2]) >>> 24 - (e & 7) - V & (1 << V) - 1;
					e += V;
					return j;
				}, h = new Uint32Array(4096 * 4), w = 0, m = function(S) {
					if (S == w) return;
					w = S;
					g = 1 << S;
					N = g + 1;
					for (var A = 0; A < N + 1; A++) {
						h[4 * A] = h[4 * A + 3] = A;
						h[4 * A + 1] = 65535;
						h[4 * A + 2] = 1;
					}
				}, i$1 = function(S) {
					V = S + 1;
					K = N + 1;
				}, D = function(S) {
					var A = S << 2, j = h[A + 2], a = u + j - 1;
					while (A != 65535) {
						Z[a--] = h[A];
						A = h[A + 1];
					}
					u += j;
				}, L = function(S, A) {
					var j = K << 2, a = S << 2;
					h[j] = h[(A << 2) + 3];
					h[j + 1] = a;
					h[j + 2] = h[a + 2] + 1;
					h[j + 3] = h[a + 3];
					K++;
					if (K + 1 == 1 << V && V != 12) V++;
				}, T = function(S, A, j, a, n, q$1) {
					e = A << 3;
					U = S;
					Z = a;
					u = n;
					var B = A + j << 3, _ = 0, t = 0;
					m(q$1);
					i$1(q$1);
					while (e < B && (_ = O()) != N) {
						if (_ == g) {
							i$1(q$1);
							_ = O();
							if (_ == N) break;
							D(_);
						} else if (_ < K) {
							D(_);
							L(t, _);
						} else {
							L(t, t);
							D(K - 1);
						}
						t = _;
					}
					return u;
				};
				return T;
			}();
			UTIF$1.tags = {};
			UTIF$1._types = function() {
				var main = new Array(250);
				main.fill(0);
				main = main.concat([
					0,
					0,
					0,
					0,
					4,
					3,
					3,
					3,
					3,
					3,
					0,
					0,
					3,
					0,
					0,
					0,
					3,
					0,
					0,
					2,
					2,
					2,
					2,
					4,
					3,
					0,
					0,
					3,
					4,
					4,
					3,
					3,
					5,
					5,
					3,
					2,
					5,
					5,
					0,
					0,
					0,
					0,
					4,
					4,
					0,
					0,
					3,
					3,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					2,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					2,
					3,
					5,
					5,
					3,
					0,
					3,
					3,
					4,
					4,
					4,
					3,
					4,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					3,
					3,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					7,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					4,
					4,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					3,
					3,
					5,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					7,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]);
				return {
					basic: {
						main,
						rest: {
							33432: 2,
							33434: 5,
							33437: 5,
							34665: 4,
							34850: 3,
							34853: 4,
							34855: 3,
							34864: 3,
							34866: 4,
							36864: 7,
							36867: 2,
							36868: 2,
							37121: 7,
							37377: 10,
							37378: 5,
							37380: 10,
							37381: 5,
							37383: 3,
							37384: 3,
							37385: 3,
							37386: 5,
							37510: 7,
							37520: 2,
							37521: 2,
							37522: 2,
							40960: 7,
							40961: 3,
							40962: 4,
							40963: 4,
							40965: 4,
							41486: 5,
							41487: 5,
							41488: 3,
							41985: 3,
							41986: 3,
							41987: 3,
							41988: 5,
							41989: 3,
							41990: 3,
							41993: 3,
							41994: 3,
							41995: 7,
							41996: 3,
							42032: 2,
							42033: 2,
							42034: 5,
							42036: 2,
							42037: 2,
							59932: 7
						}
					},
					gps: {
						main: [
							1,
							2,
							5,
							2,
							5,
							1,
							5,
							5,
							0,
							9
						],
						rest: {
							18: 2,
							29: 2
						}
					}
				};
			}();
			UTIF$1._readIFD = function(bin, data, offset, ifds, depth, prm) {
				var cnt = bin.readUshort(data, offset);
				offset += 2;
				var ifd = {};
				if (prm.debug) log("   ".repeat(depth), ifds.length - 1, ">>>----------------");
				for (var i$1 = 0; i$1 < cnt; i$1++) {
					var tag = bin.readUshort(data, offset);
					offset += 2;
					var type = bin.readUshort(data, offset);
					offset += 2;
					var num = bin.readUint(data, offset);
					offset += 4;
					var voff = bin.readUint(data, offset);
					offset += 4;
					var arr = [];
					if (type == 1 || type == 7) {
						var no = num < 5 ? offset - 4 : voff;
						if (no + num > data.buffer.byteLength) num = data.buffer.byteLength - no;
						arr = new Uint8Array(data.buffer, no, num);
					}
					if (type == 2) {
						var o0 = num < 5 ? offset - 4 : voff, c$1 = data[o0], len = Math.max(0, Math.min(num - 1, data.length - o0));
						if (c$1 < 128 || len == 0) arr.push(bin.readASCII(data, o0, len));
						else arr = new Uint8Array(data.buffer, o0, len);
					}
					if (type == 3) for (var j = 0; j < num; j++) arr.push(bin.readUshort(data, (num < 3 ? offset - 4 : voff) + 2 * j));
					if (type == 4 || type == 13) for (var j = 0; j < num; j++) arr.push(bin.readUint(data, (num < 2 ? offset - 4 : voff) + 4 * j));
					if (type == 5 || type == 10) {
						var ri = type == 5 ? bin.readUint : bin.readInt;
						for (var j = 0; j < num; j++) arr.push([ri(data, voff + j * 8), ri(data, voff + j * 8 + 4)]);
					}
					if (type == 8) for (var j = 0; j < num; j++) arr.push(bin.readShort(data, (num < 3 ? offset - 4 : voff) + 2 * j));
					if (type == 9) for (var j = 0; j < num; j++) arr.push(bin.readInt(data, (num < 2 ? offset - 4 : voff) + 4 * j));
					if (type == 11) for (var j = 0; j < num; j++) arr.push(bin.readFloat(data, voff + j * 4));
					if (type == 12) for (var j = 0; j < num; j++) arr.push(bin.readDouble(data, voff + j * 8));
					if (num != 0 && arr.length == 0) {
						log(tag, "unknown TIFF tag type: ", type, "num:", num);
						if (i$1 == 0) return;
						continue;
					}
					if (prm.debug) log("   ".repeat(depth), tag, type, UTIF$1.tags[tag], arr);
					ifd["t" + tag] = arr;
					if (tag == 330 && ifd["t272"] && ifd["t272"][0] == "DSLR-A100") {} else if (tag == 330 || tag == 34665 || tag == 34853 || tag == 50740 && bin.readUshort(data, bin.readUint(arr, 0)) < 300 || tag == 61440) {
						var oarr = tag == 50740 ? [bin.readUint(arr, 0)] : arr;
						var subfd = [];
						for (var j = 0; j < oarr.length; j++) UTIF$1._readIFD(bin, data, oarr[j], subfd, depth + 1, prm);
						if (tag == 330) ifd.subIFD = subfd;
						if (tag == 34665) ifd.exifIFD = subfd[0];
						if (tag == 34853) ifd.gpsiIFD = subfd[0];
						if (tag == 50740) ifd.dngPrvt = subfd[0];
						if (tag == 61440) ifd.fujiIFD = subfd[0];
					}
					if (tag == 37500 && prm.parseMN) {
						var mn = arr;
						if (bin.readASCII(mn, 0, 5) == "Nikon") ifd.makerNote = UTIF$1["decode"](mn.slice(10).buffer)[0];
						else if (bin.readASCII(mn, 0, 5) == "OLYMP" || bin.readASCII(mn, 0, 9) == "OM SYSTEM") {
							var inds = [
								8208,
								8224,
								8240,
								8256,
								8272
							];
							var subsub = [];
							UTIF$1._readIFD(bin, mn, mn[1] == 77 ? 16 : mn[5] == 85 ? 12 : 8, subsub, depth + 1, prm);
							var obj = ifd.makerNote = subsub.pop();
							for (var j = 0; j < inds.length; j++) {
								var k = "t" + inds[j];
								if (obj[k] == null) continue;
								UTIF$1._readIFD(bin, mn, obj[k][0], subsub, depth + 1, prm);
								obj[k] = subsub.pop();
							}
							if (obj["t12288"]) {
								UTIF$1._readIFD(bin, obj["t12288"], 0, subsub, depth + 1, prm);
								obj["t12288"] = subsub.pop();
							}
						} else if (bin.readUshort(data, voff) < 300 && bin.readUshort(data, voff + 4) <= 12) {
							var subsub = [];
							UTIF$1._readIFD(bin, data, voff, subsub, depth + 1, prm);
							ifd.makerNote = subsub[0];
						}
					}
				}
				ifds.push(ifd);
				if (prm.debug) log("   ".repeat(depth), "<<<---------------");
				return offset;
			};
			UTIF$1._writeIFD = function(bin, types, data, offset, ifd) {
				var keys$1 = Object.keys(ifd), knum = keys$1.length;
				if (ifd["exifIFD"]) knum--;
				if (ifd["gpsiIFD"]) knum--;
				bin.writeUshort(data, offset, knum);
				offset += 2;
				var eoff = offset + knum * 12 + 4;
				for (var ki = 0; ki < keys$1.length; ki++) {
					var key = keys$1[ki];
					if (key == "t34665" || key == "t34853") continue;
					if (key == "exifIFD") key = "t34665";
					if (key == "gpsiIFD") key = "t34853";
					var tag = parseInt(key.slice(1)), type = types.main[tag];
					if (type == null) type = types.rest[tag];
					if (type == null || type == 0) throw new Error("unknown type of tag: " + tag);
					var val = ifd[key];
					if (tag == 34665) {
						var outp = UTIF$1._writeIFD(bin, types, data, eoff, ifd["exifIFD"]);
						val = [eoff];
						eoff = outp[1];
					}
					if (tag == 34853) {
						var outp = UTIF$1._writeIFD(bin, UTIF$1._types.gps, data, eoff, ifd["gpsiIFD"]);
						val = [eoff];
						eoff = outp[1];
					}
					if (type == 2) val = val[0] + "\0";
					var num = val.length;
					bin.writeUshort(data, offset, tag);
					offset += 2;
					bin.writeUshort(data, offset, type);
					offset += 2;
					bin.writeUint(data, offset, num);
					offset += 4;
					var dlen = [
						-1,
						1,
						1,
						2,
						4,
						8,
						0,
						1,
						0,
						4,
						8,
						0,
						8
					][type] * num;
					var toff = offset;
					if (dlen > 4) {
						bin.writeUint(data, offset, eoff);
						toff = eoff;
					}
					if (type == 1 || type == 7) for (var i$1 = 0; i$1 < num; i$1++) data[toff + i$1] = val[i$1];
					else if (type == 2) bin.writeASCII(data, toff, val);
					else if (type == 3) for (var i$1 = 0; i$1 < num; i$1++) bin.writeUshort(data, toff + 2 * i$1, val[i$1]);
					else if (type == 4) for (var i$1 = 0; i$1 < num; i$1++) bin.writeUint(data, toff + 4 * i$1, val[i$1]);
					else if (type == 5 || type == 10) {
						var wr = type == 5 ? bin.writeUint : bin.writeInt;
						for (var i$1 = 0; i$1 < num; i$1++) {
							var v = val[i$1], nu = v[0], de = v[1];
							if (nu == null) throw "e";
							wr(data, toff + 8 * i$1, nu);
							wr(data, toff + 8 * i$1 + 4, de);
						}
					} else if (type == 9) for (var i$1 = 0; i$1 < num; i$1++) bin.writeInt(data, toff + 4 * i$1, val[i$1]);
					else if (type == 12) for (var i$1 = 0; i$1 < num; i$1++) bin.writeDouble(data, toff + 8 * i$1, val[i$1]);
					else throw type;
					if (dlen > 4) {
						dlen += dlen & 1;
						eoff += dlen;
					}
					offset += 4;
				}
				return [offset, eoff];
			};
			UTIF$1.toRGBA8 = function(out, scl) {
				function gamma(x$1) {
					return x$1 < .0031308 ? 12.92 * x$1 : 1.055 * Math.pow(x$1, 1 / 2.4) - .055;
				}
				var w = out.width, h = out.height, area = w * h;
				area * 4;
				var data = out.data;
				var img = new Uint8Array(area * 4);
				var intp = out["t262"] ? out["t262"][0] : 2, bps = out["t258"] ? Math.min(32, out["t258"][0]) : 1;
				if (out["t262"] == null && bps == 1) intp = 0;
				var smpls = out["t277"] ? out["t277"][0] : out["t258"] ? out["t258"].length : [
					1,
					1,
					3,
					1,
					1,
					4,
					3
				][intp];
				var sfmt = out["t339"] ? out["t339"][0] : null;
				if (intp == 1 && bps == 32 && sfmt != 3) throw "e";
				var bpl = Math.ceil(smpls * bps * w / 8);
				if (intp == 0) {
					scl = 1 / 256;
					for (var y = 0; y < h; y++) {
						var off = y * bpl, io = y * w;
						if (bps == 1) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + (i$1 >> 3)] >> 7 - (i$1 & 7) & 1;
							img[qi] = img[qi + 1] = img[qi + 2] = (1 - px) * 255;
							img[qi + 3] = 255;
						}
						if (bps == 4) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + (i$1 >> 1)] >> 4 - 4 * (i$1 & 1) & 15;
							img[qi] = img[qi + 1] = img[qi + 2] = (15 - px) * 17;
							img[qi + 3] = 255;
						}
						if (bps == 8) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + i$1];
							img[qi] = img[qi + 1] = img[qi + 2] = 255 - px;
							img[qi + 3] = 255;
						}
						if (bps == 16) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, o = off + 2 * i$1, px = data[o + 1] << 8 | data[o];
							img[qi] = img[qi + 1] = img[qi + 2] = Math.min(255, 255 - ~~(px * scl));
							img[qi + 3] = 255;
						}
					}
				} else if (intp == 1) {
					if (scl == null) scl = 1 / 256;
					var f32 = (data.length & 3) == 0 ? new Float32Array(data.buffer) : null;
					for (var y = 0; y < h; y++) {
						var off = y * bpl, io = y * w;
						if (bps == 1) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + (i$1 >> 3)] >> 7 - (i$1 & 7) & 1;
							img[qi] = img[qi + 1] = img[qi + 2] = px * 255;
							img[qi + 3] = 255;
						}
						if (bps == 2) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + (i$1 >> 2)] >> 6 - 2 * (i$1 & 3) & 3;
							img[qi] = img[qi + 1] = img[qi + 2] = px * 85;
							img[qi + 3] = 255;
						}
						if (bps == 8) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, px = data[off + i$1 * smpls];
							img[qi] = img[qi + 1] = img[qi + 2] = px;
							img[qi + 3] = 255;
						}
						if (bps == 16) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, o = off + 2 * i$1, px = data[o + 1] << 8 | data[o];
							img[qi] = img[qi + 1] = img[qi + 2] = Math.min(255, ~~(px * scl));
							img[qi + 3] = 255;
						}
						if (bps == 32) for (var i$1 = 0; i$1 < w; i$1++) {
							var qi = io + i$1 << 2, o = (off >>> 2) + i$1, px = f32[o];
							img[qi] = img[qi + 1] = img[qi + 2] = ~~(.5 + 255 * px);
							img[qi + 3] = 255;
						}
					}
				} else if (intp == 2) if (bps == 8) {
					if (smpls == 1) for (var i$1 = 0; i$1 < area; i$1++) {
						img[4 * i$1] = img[4 * i$1 + 1] = img[4 * i$1 + 2] = data[i$1];
						img[4 * i$1 + 3] = 255;
					}
					if (smpls == 3) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * 3;
						img[qi] = data[ti];
						img[qi + 1] = data[ti + 1];
						img[qi + 2] = data[ti + 2];
						img[qi + 3] = 255;
					}
					if (smpls >= 4) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * smpls;
						img[qi] = data[ti];
						img[qi + 1] = data[ti + 1];
						img[qi + 2] = data[ti + 2];
						img[qi + 3] = data[ti + 3];
					}
				} else if (bps == 16) {
					if (smpls == 4) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * 8 + 1;
						img[qi] = data[ti];
						img[qi + 1] = data[ti + 2];
						img[qi + 2] = data[ti + 4];
						img[qi + 3] = data[ti + 6];
					}
					if (smpls == 3) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * 6 + 1;
						img[qi] = data[ti];
						img[qi + 1] = data[ti + 2];
						img[qi + 2] = data[ti + 4];
						img[qi + 3] = 255;
					}
				} else if (bps == 32) {
					var ndt = new Float32Array(data.buffer);
					var min = 0;
					for (var i$1 = 0; i$1 < ndt.length; i$1++) min = Math.min(min, ndt[i$1]);
					if (min < 0) for (var i$1 = 0; i$1 < data.length; i$1 += 4) {
						var t = data[i$1];
						data[i$1] = data[i$1 + 3];
						data[i$1 + 3] = t;
						t = data[i$1 + 1];
						data[i$1 + 1] = data[i$1 + 2];
						data[i$1 + 2] = t;
					}
					var pmap = [];
					for (var i$1 = 0; i$1 < 65536; i$1++) pmap.push(gamma(i$1 / 65535));
					for (var i$1 = 0; i$1 < ndt.length; i$1++) ndt[i$1] = pmap[~~(.5 + Math.max(0, Math.min(1, ndt[i$1])) * 65535)];
					if (smpls == 3) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * 3;
						img[qi] = ~~(.5 + ndt[ti] * 255);
						img[qi + 1] = ~~(.5 + ndt[ti + 1] * 255);
						img[qi + 2] = ~~(.5 + ndt[ti + 2] * 255);
						img[qi + 3] = 255;
					}
					else if (smpls == 4) for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, ti = i$1 * 4;
						img[qi] = ~~(.5 + ndt[ti] * 255);
						img[qi + 1] = ~~(.5 + ndt[ti + 1] * 255);
						img[qi + 2] = ~~(.5 + ndt[ti + 2] * 255);
						img[qi + 3] = ~~(.5 + ndt[ti + 3] * 255);
					}
					else throw smpls;
				} else throw bps;
				else if (intp == 3) {
					var map = out["t320"];
					var cn = 1 << bps;
					var nexta = bps == 8 && smpls > 1 && out["t338"] && out["t338"][0] != 0;
					for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
						var i$1 = y * w + x;
						var qi = i$1 << 2, mi = 0;
						var dof = y * bpl;
						if (bps == 1) mi = data[dof + (x >>> 3)] >>> 7 - (x & 7) & 1;
						else if (bps == 2) mi = data[dof + (x >>> 2)] >>> 6 - 2 * (x & 3) & 3;
						else if (bps == 4) mi = data[dof + (x >>> 1)] >>> 4 - 4 * (x & 1) & 15;
						else if (bps == 8) mi = data[dof + x * smpls];
						else throw bps;
						img[qi] = map[mi] >> 8;
						img[qi + 1] = map[cn + mi] >> 8;
						img[qi + 2] = map[cn + cn + mi] >> 8;
						img[qi + 3] = nexta ? data[dof + x * smpls + 1] : 255;
					}
				} else if (intp == 5) {
					var gotAlpha = smpls > 4 ? 1 : 0;
					for (var i$1 = 0; i$1 < area; i$1++) {
						var qi = i$1 << 2, si = i$1 * smpls;
						if (window.UDOC) {
							var C = data[si], M = data[si + 1], Y = data[si + 2], K = data[si + 3];
							var c$1 = UDOC.C.cmykToRgb([
								C * (1 / 255),
								M * (1 / 255),
								Y * (1 / 255),
								K * (1 / 255)
							]);
							img[qi] = ~~(.5 + 255 * c$1[0]);
							img[qi + 1] = ~~(.5 + 255 * c$1[1]);
							img[qi + 2] = ~~(.5 + 255 * c$1[2]);
						} else {
							var C = 255 - data[si], M = 255 - data[si + 1], Y = 255 - data[si + 2], K = (255 - data[si + 3]) * (1 / 255);
							img[qi] = ~~(C * K + .5);
							img[qi + 1] = ~~(M * K + .5);
							img[qi + 2] = ~~(Y * K + .5);
						}
						img[qi + 3] = 255 * (1 - gotAlpha) + data[si + 4] * gotAlpha;
					}
				} else if (intp == 6 && out["t278"]) {
					var rps = out["t278"][0];
					for (var y = 0; y < h; y += rps) {
						var i$1 = y * w, len = rps * w;
						for (var j = 0; j < len; j++) {
							var qi = 4 * (i$1 + j), si = 3 * i$1 + 4 * (j >>> 1);
							var Y = data[si + (j & 1)], Cb = data[si + 2] - 128, Cr = data[si + 3] - 128;
							var r = Y + ((Cr >> 2) + (Cr >> 3) + (Cr >> 5));
							var g = Y - ((Cb >> 2) + (Cb >> 4) + (Cb >> 5)) - ((Cr >> 1) + (Cr >> 3) + (Cr >> 4) + (Cr >> 5));
							var b = Y + (Cb + (Cb >> 1) + (Cb >> 2) + (Cb >> 6));
							img[qi] = Math.max(0, Math.min(255, r));
							img[qi + 1] = Math.max(0, Math.min(255, g));
							img[qi + 2] = Math.max(0, Math.min(255, b));
							img[qi + 3] = 255;
						}
					}
				} else if (intp == 32845) for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
					var si = (y * w + x) * 6, qi = (y * w + x) * 4;
					var L = data[si + 1] << 8 | data[si];
					var L = Math.pow(2, (L + .5) / 256 - 64);
					var u = (data[si + 3] + .5) / 410;
					var v = (data[si + 5] + .5) / 410;
					var sX = 9 * u / (6 * u - 16 * v + 12);
					var sY = 4 * v / (6 * u - 16 * v + 12);
					var bY = L;
					var X = sX * bY / sY, Y = bY, Z = (1 - sX - sY) * bY / sY;
					var r = 2.69 * X - 1.276 * Y - .414 * Z;
					var g = -1.022 * X + 1.978 * Y + .044 * Z;
					var b = .061 * X - .224 * Y + 1.163 * Z;
					img[qi] = gamma(Math.min(r, 1)) * 255;
					img[qi + 1] = gamma(Math.min(g, 1)) * 255;
					img[qi + 2] = gamma(Math.min(b, 1)) * 255;
					img[qi + 3] = 255;
				}
				else log("Unknown Photometric interpretation: " + intp);
				return img;
			};
			UTIF$1.replaceIMG = function(imgs) {
				if (imgs == null) imgs = document.getElementsByTagName("img");
				var sufs = [
					"tif",
					"tiff",
					"dng",
					"cr2",
					"nef"
				];
				for (var i$1 = 0; i$1 < imgs.length; i$1++) {
					var img = imgs[i$1], src = img.getAttribute("src");
					if (src == null) continue;
					var suff = src.split(".").pop().toLowerCase();
					if (sufs.indexOf(suff) == -1) continue;
					var xhr = new XMLHttpRequest();
					UTIF$1._xhrs.push(xhr);
					UTIF$1._imgs.push(img);
					xhr.open("GET", src);
					xhr.responseType = "arraybuffer";
					xhr.onload = UTIF$1._imgLoaded;
					xhr.send();
				}
			};
			UTIF$1._xhrs = [];
			UTIF$1._imgs = [];
			UTIF$1._imgLoaded = function(e) {
				var ind = UTIF$1._xhrs.indexOf(e.target), img = UTIF$1._imgs[ind];
				UTIF$1._xhrs.splice(ind, 1);
				UTIF$1._imgs.splice(ind, 1);
				img.setAttribute("src", UTIF$1.bufferToURI(e.target.response));
			};
			UTIF$1.bufferToURI = function(buff) {
				var ifds = UTIF$1.decode(buff);
				var vsns = ifds, ma = 0, page = vsns[0];
				if (ifds[0].subIFD) vsns = vsns.concat(ifds[0].subIFD);
				for (var i$1 = 0; i$1 < vsns.length; i$1++) {
					var img = vsns[i$1];
					if (img["t258"] == null || img["t258"].length < 3) continue;
					var ar = img["t256"] * img["t257"];
					if (ar > ma) {
						ma = ar;
						page = img;
					}
				}
				UTIF$1.decodeImage(buff, page, ifds);
				var rgba = UTIF$1.toRGBA8(page), w = page.width, h = page.height;
				var cnv = document.createElement("canvas");
				cnv.width = w;
				cnv.height = h;
				var ctx = cnv.getContext("2d");
				var imgd = new ImageData(new Uint8ClampedArray(rgba.buffer), w, h);
				ctx.putImageData(imgd, 0, 0);
				return cnv.toDataURL();
			};
			UTIF$1._binBE = {
				nextZero: function(data, o) {
					while (data[o] != 0) o++;
					return o;
				},
				readUshort: function(buff, p) {
					return buff[p] << 8 | buff[p + 1];
				},
				readShort: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 1];
					a[1] = buff[p + 0];
					return UTIF$1._binBE.i16[0];
				},
				readInt: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 3];
					a[1] = buff[p + 2];
					a[2] = buff[p + 1];
					a[3] = buff[p + 0];
					return UTIF$1._binBE.i32[0];
				},
				readUint: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 3];
					a[1] = buff[p + 2];
					a[2] = buff[p + 1];
					a[3] = buff[p + 0];
					return UTIF$1._binBE.ui32[0];
				},
				readASCII: function(buff, p, l) {
					var s = "";
					for (var i$1 = 0; i$1 < l; i$1++) s += String.fromCharCode(buff[p + i$1]);
					return s;
				},
				readFloat: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					for (var i$1 = 0; i$1 < 4; i$1++) a[i$1] = buff[p + 3 - i$1];
					return UTIF$1._binBE.fl32[0];
				},
				readDouble: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					for (var i$1 = 0; i$1 < 8; i$1++) a[i$1] = buff[p + 7 - i$1];
					return UTIF$1._binBE.fl64[0];
				},
				writeUshort: function(buff, p, n) {
					buff[p] = n >> 8 & 255;
					buff[p + 1] = n & 255;
				},
				writeInt: function(buff, p, n) {
					var a = UTIF$1._binBE.ui8;
					UTIF$1._binBE.i32[0] = n;
					buff[p + 3] = a[0];
					buff[p + 2] = a[1];
					buff[p + 1] = a[2];
					buff[p + 0] = a[3];
				},
				writeUint: function(buff, p, n) {
					buff[p] = n >> 24 & 255;
					buff[p + 1] = n >> 16 & 255;
					buff[p + 2] = n >> 8 & 255;
					buff[p + 3] = n >> 0 & 255;
				},
				writeASCII: function(buff, p, s) {
					for (var i$1 = 0; i$1 < s.length; i$1++) buff[p + i$1] = s.charCodeAt(i$1);
				},
				writeDouble: function(buff, p, n) {
					UTIF$1._binBE.fl64[0] = n;
					for (var i$1 = 0; i$1 < 8; i$1++) buff[p + i$1] = UTIF$1._binBE.ui8[7 - i$1];
				}
			};
			UTIF$1._binBE.ui8 = new Uint8Array(8);
			UTIF$1._binBE.i16 = new Int16Array(UTIF$1._binBE.ui8.buffer);
			UTIF$1._binBE.i32 = new Int32Array(UTIF$1._binBE.ui8.buffer);
			UTIF$1._binBE.ui32 = new Uint32Array(UTIF$1._binBE.ui8.buffer);
			UTIF$1._binBE.fl32 = new Float32Array(UTIF$1._binBE.ui8.buffer);
			UTIF$1._binBE.fl64 = new Float64Array(UTIF$1._binBE.ui8.buffer);
			UTIF$1._binLE = {
				nextZero: UTIF$1._binBE.nextZero,
				readUshort: function(buff, p) {
					return buff[p + 1] << 8 | buff[p];
				},
				readShort: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 0];
					a[1] = buff[p + 1];
					return UTIF$1._binBE.i16[0];
				},
				readInt: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 0];
					a[1] = buff[p + 1];
					a[2] = buff[p + 2];
					a[3] = buff[p + 3];
					return UTIF$1._binBE.i32[0];
				},
				readUint: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					a[0] = buff[p + 0];
					a[1] = buff[p + 1];
					a[2] = buff[p + 2];
					a[3] = buff[p + 3];
					return UTIF$1._binBE.ui32[0];
				},
				readASCII: UTIF$1._binBE.readASCII,
				readFloat: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					for (var i$1 = 0; i$1 < 4; i$1++) a[i$1] = buff[p + i$1];
					return UTIF$1._binBE.fl32[0];
				},
				readDouble: function(buff, p) {
					var a = UTIF$1._binBE.ui8;
					for (var i$1 = 0; i$1 < 8; i$1++) a[i$1] = buff[p + i$1];
					return UTIF$1._binBE.fl64[0];
				},
				writeUshort: function(buff, p, n) {
					buff[p] = n & 255;
					buff[p + 1] = n >> 8 & 255;
				},
				writeInt: function(buff, p, n) {
					var a = UTIF$1._binBE.ui8;
					UTIF$1._binBE.i32[0] = n;
					buff[p + 0] = a[0];
					buff[p + 1] = a[1];
					buff[p + 2] = a[2];
					buff[p + 3] = a[3];
				},
				writeUint: function(buff, p, n) {
					buff[p] = n >>> 0 & 255;
					buff[p + 1] = n >>> 8 & 255;
					buff[p + 2] = n >>> 16 & 255;
					buff[p + 3] = n >>> 24 & 255;
				},
				writeASCII: UTIF$1._binBE.writeASCII
			};
			UTIF$1._copyTile = function(tb, tw, th, b, w, h, xoff, yoff) {
				var xlim = Math.min(tw, w - xoff);
				var ylim = Math.min(th, h - yoff);
				for (var y = 0; y < ylim; y++) {
					var tof = (yoff + y) * w + xoff;
					var sof = y * tw;
					for (var x = 0; x < xlim; x++) b[tof + x] = tb[sof + x];
				}
			};
			UTIF$1.LosslessJpegDecode = function() {
				var b, O;
				function l() {
					return b[O++];
				}
				function m() {
					return b[O++] << 8 | b[O++];
				}
				function a0(h) {
					var V = l(), I = [
						0,
						0,
						0,
						255
					], f = [], G = 8;
					for (var w = 0; w < 16; w++) f[w] = l();
					for (var w = 0; w < 16; w++) for (var x = 0; x < f[w]; x++) {
						var T = z(I, 0, w + 1, 1);
						I[T + 3] = l();
					}
					var E = new Uint8Array(1 << G);
					h[V] = [new Uint8Array(I), E];
					for (var w = 0; w < 1 << G; w++) {
						var s = G, _ = w, Y = 0, F = 0;
						while (I[Y + 3] == 255 && s != 0) {
							F = _ >> --s & 1;
							Y = I[Y + F];
						}
						E[w] = Y;
					}
				}
				function z(h, V, I, f) {
					if (h[V + 3] != 255) return 0;
					if (I == 0) return V;
					for (var w = 0; w < 2; w++) {
						if (h[V + w] == 0) {
							h[V + w] = h.length;
							h.push(0, 0, f, 255);
						}
						var x = z(h, h[V + w], I - 1, f + 1);
						if (x != 0) return x;
					}
					return 0;
				}
				function i$1(h) {
					var V = h.b, I = h.f;
					while (V < 25 && h.a < h.d) {
						var f = h.data[h.a++];
						if (f == 255 && !h.c) h.a++;
						I = I << 8 | f;
						V += 8;
					}
					if (V < 0) throw "e";
					h.b = V;
					h.f = I;
				}
				function H(h, V) {
					if (V.b < h) i$1(V);
					return V.f >> (V.b -= h) & 65535 >> 16 - h;
				}
				function g(h, V) {
					var I = h[0], f = 0, w = 255, x = 0;
					if (V.b < 16) i$1(V);
					var T = V.f >> V.b - 8 & 255;
					f = h[1][T];
					w = I[f + 3];
					V.b -= I[f + 2];
					while (w == 255) {
						x = V.f >> --V.b & 1;
						f = I[f + x];
						w = I[f + 3];
					}
					return w;
				}
				function P(h, V) {
					if (h < 32768 >> 16 - V) h += -(1 << V) + 1;
					return h;
				}
				function a2(h, V) {
					var I = g(h, V);
					if (I == 0) return 0;
					if (I == 16) return -32768;
					return P(H(I, V), I);
				}
				function X(h, V, I, f, w, x) {
					var T = 0;
					for (var G = 0; G < x; G++) {
						var s = G * V;
						for (var _ = 0; _ < V; _ += w) {
							T++;
							for (var Y = 0; Y < w; Y++) h[s + _ + Y] = a2(f[Y], I);
						}
						if (I.e != 0 && T % I.e == 0 && G != 0) {
							var F = I.a, t = I.data;
							while (t[F] != 255 || !(208 <= t[F + 1] && t[F + 1] <= 215)) F--;
							I.a = F + 2;
							I.f = 0;
							I.b = 0;
						}
					}
				}
				function o(h, V) {
					return P(H(h, V), h);
				}
				function a1(h, V, I, f, w) {
					var x = b.length - O;
					for (var T = 0; T < x; T += 4) {
						var G = b[O + T];
						b[O + T] = b[O + T + 3];
						b[O + T + 3] = G;
						var G = b[O + T + 1];
						b[O + T + 1] = b[O + T + 2];
						b[O + T + 2] = G;
					}
					for (var E = 0; E < w; E++) {
						var s = 32768, _ = 32768;
						for (var Y = 0; Y < V; Y += 2) {
							var F = g(f, I), t = g(f, I);
							if (F != 0) s += o(F, I);
							if (t != 0) _ += o(t, I);
							h[E * V + Y] = s & 65535;
							h[E * V + Y + 1] = _ & 65535;
						}
					}
				}
				function C(h) {
					b = h;
					O = 0;
					if (m() != 65496) throw "e";
					var V = [], I = 0, f = 0, w = 0, x = [], T = [], G = [], E = 0, s = 0, _ = 0;
					while (!0) {
						var Y = m();
						if (Y == 65535) {
							O--;
							continue;
						}
						var F = m();
						if (Y == 65475) {
							f = l();
							s = m();
							_ = m();
							E = l();
							for (var t = 0; t < E; t++) {
								var a = l(), J = l();
								if (l() != 0) throw "e";
								V[a] = [
									t,
									J >> 4,
									J & 15
								];
							}
						} else if (Y == 65476) {
							var a3 = O + F - 2;
							while (O < a3) a0(T);
						} else if (Y == 65498) {
							O++;
							for (var t = 0; t < E; t++) {
								var v = V[l()];
								G[v[0]] = T[l() >>> 4];
								x[v[0]] = v.slice(1);
							}
							I = l();
							O += 2;
							break;
						} else if (Y == 65501) w = m();
						else O += F - 2;
					}
					var $ = new (f > 8 ? Uint16Array : Uint8Array)(s * _ * E), M = {
						b: 0,
						f: 0,
						c: I == 8,
						a: O,
						data: b,
						d: b.length,
						e: w
					};
					if (M.c) a1($, _ * E, M, G[0], s);
					else {
						var c$1 = [], p = 0, D = 0;
						for (var t = 0; t < E; t++) {
							var N = x[t], S = N[0], K = N[1];
							if (S > p) p = S;
							if (K > D) D = K;
							c$1.push(S * K);
						}
						if (p != 1 || D != 1) {
							if (E != 3 || c$1[1] != 1 || c$1[2] != 1) throw "e";
							if (p != 2 || D != 1 && D != 2) throw "e";
							var u = [], Z = 0;
							for (var t = 0; t < E; t++) {
								for (var R = 0; R < c$1[t]; R++) u.push(G[t]);
								Z += c$1[t];
							}
							var B = _ / p, e = s / D, d = B * e;
							X($, B * Z, M, u, Z, e);
							j($, I, B, e, Z - 2, Z, Z, f);
							var A = new Uint16Array(d * c$1[0]);
							if (p == 2 && D == 2) {
								for (var t = 0; t < d; t++) {
									A[4 * t] = $[6 * t];
									A[4 * t + 1] = $[6 * t + 1];
									A[4 * t + 2] = $[6 * t + 2];
									A[4 * t + 3] = $[6 * t + 3];
								}
								j(A, I, B * 4, e, 0, 1, 1, f);
								for (var t = 0; t < d; t++) {
									$[6 * t] = A[4 * t];
									$[6 * t + 1] = A[4 * t + 1];
									$[6 * t + 2] = A[4 * t + 2];
									$[6 * t + 3] = A[4 * t + 3];
								}
							}
							if (p == 2 && D == 1) {
								for (var t = 0; t < d; t++) {
									A[2 * t] = $[4 * t];
									A[2 * t + 1] = $[4 * t + 1];
								}
								j(A, I, B * 2, e, 0, 1, 1, f);
								for (var t = 0; t < d; t++) {
									$[4 * t] = A[2 * t];
									$[4 * t + 1] = A[2 * t + 1];
								}
							}
							var n = $.slice(0);
							for (var K = 0; K < s; K++) if (D == 2) for (var S = 0; S < _; S++) {
								var q$1 = (K * _ + S) * E, k = ((K >>> 1) * B + (S >>> 1)) * Z, y = (K & 1) * 2 + (S & 1);
								$[q$1] = n[k + y];
								$[q$1 + 1] = n[k + 4];
								$[q$1 + 2] = n[k + 5];
							}
							else for (var S = 0; S < _; S++) {
								var q$1 = (K * _ + S) * E, k = (K * B + (S >>> 1)) * Z, y = S & 1;
								$[q$1] = n[k + y];
								$[q$1 + 1] = n[k + 2];
								$[q$1 + 2] = n[k + 3];
							}
						} else {
							X($, _ * E, M, G, E, s);
							if (w == 0) j($, I, _, s, 0, E, E, f);
							else {
								var U = Math.floor(w / _);
								for (var K = 0; K < s; K += U) {
									var L = $.slice(K * _ * E, (K + U) * _ * E);
									j(L, I, _, U, 0, E, E, f);
									$.set(L, K * _ * E);
								}
							}
						}
					}
					return $;
				}
				function j(h, V, I, f, w, x, G, E) {
					var s = I * G;
					for (var _ = w; _ < x; _++) h[_] += 1 << E - 1;
					for (var Y = G; Y < s; Y += G) for (var _ = w; _ < x; _++) h[Y + _] += h[Y + _ - G];
					for (var F = 1; F < f; F++) {
						var t = F * s;
						for (var _ = w; _ < x; _++) h[t + _] += h[t + _ - s];
						for (var Y = G; Y < s; Y += G) for (var _ = w; _ < x; _++) {
							var a = t + Y + _, J = a - s, r = h[a - G], Q = 0;
							if (V == 0) Q = 0;
							else if (V == 1) Q = r;
							else if (V == 2) Q = h[J];
							else if (V == 3) Q = h[J - G];
							else if (V == 4) Q = r + (h[J] - h[J - G]);
							else if (V == 5) Q = r + (h[J] - h[J - G] >>> 1);
							else if (V == 6) Q = h[J] + (r - h[J - G] >>> 1);
							else if (V == 7) Q = r + h[J] >>> 1;
							else throw V;
							h[a] += Q;
						}
					}
				}
				return C;
			}();
			(function() {
				var G = 0, F = 1, i$1 = 2, b = 3, J = 4, N = 5, E = 6, s = 7, c$1 = 8, T = 9, a3 = 10, f = 11, q$1 = 12, M = 13, m = 14, x = 15, L = 16, $ = 17, p = 18;
				function a5(t) {
					var Z = UTIF$1._binBE.readUshort, u = {
						b: Z(t, 0),
						i: t[2],
						C: t[3],
						u: t[4],
						q: Z(t, 5),
						k: Z(t, 7),
						e: Z(t, 9),
						l: Z(t, 11),
						s: t[13],
						d: Z(t, 14)
					};
					if (u.b != 18771 || u.i > 1 || u.q < 6 || u.q % 6 || u.e < 768 || u.e % 24 || u.l != 768 || u.k < u.l || u.k % u.l || u.k - u.e >= u.l || u.s > 16 || u.s != u.k / u.l || u.s != Math.ceil(u.e / u.l) || u.d != u.q / 6 || u.u != 12 && u.u != 14 && u.u != 16 || u.C != 16 && u.C != 0) throw "Invalid data";
					if (u.i == 0) throw "Not implemented. We need this file!";
					u.h = u.C == 16;
					u.m = (u.h ? u.l * 2 / 3 : u.l >>> 1) | 0;
					u.A = u.m + 2;
					u.f = 64;
					u.g = (1 << u.u) - 1;
					u.n = 4 * u.u;
					return u;
				}
				function a7(t, Z) {
					var u = new Array(Z.s), e = 4 * Z.s, Q = 16 + e;
					if (e & 12) Q += 16 - (e & 12);
					for (var V = 0, O = 16; V < Z.s; O += 4) {
						var o = UTIF$1._binBE.readUint(t, O);
						u[V] = t.slice(Q, Q + o);
						u[V].j = 0;
						u[V].a = 0;
						Q += o;
						V++;
					}
					if (Q != t.length) throw "Invalid data";
					return u;
				}
				function a6(t, Z) {
					for (var u = -Z[4], e = 0; u <= Z[4]; e++, u++) t[e] = u <= -Z[3] ? -4 : u <= -Z[2] ? -3 : u <= -Z[1] ? -2 : u < -Z[0] ? -1 : u <= Z[0] ? 0 : u < Z[1] ? 1 : u < Z[2] ? 2 : u < Z[3] ? 3 : 4;
				}
				function a1(t, Z, u) {
					var e = [
						Z,
						3 * Z + 18,
						5 * Z + 67,
						7 * Z + 276,
						u
					];
					t.o = Z;
					t.w = (e[4] + 2 * Z) / (2 * Z + 1) + 1 | 0;
					t.v = Math.ceil(Math.log2(t.w));
					t.t = 9;
					a6(t.c, e);
				}
				function a2(t) {
					var Z = { c: new Int8Array(2 << t.u) };
					a1(Z, 0, t.g);
					return Z;
				}
				function D(t) {
					var Z = [
						[],
						[],
						[]
					], u = Math.max(2, t.w + 32 >>> 6);
					for (var e = 0; e < 3; e++) for (var Q = 0; Q < 41; Q++) Z[e][Q] = [u, 1];
					return Z;
				}
				function a4(t) {
					for (var Z = -1, u = 0; !u; Z++) {
						u = t[t.j] >>> 7 - t.a & 1;
						t.a++;
						t.a &= 7;
						if (!t.a) t.j++;
					}
					return Z;
				}
				function K(t, Z) {
					var u = 0, e = 8 - t.a;
					t.j;
					t.a;
					if (Z) {
						if (Z >= e) do {
							u <<= e;
							Z -= e;
							u |= t[t.j] & (1 << e) - 1;
							t.j++;
							e = 8;
						} while (Z >= 8);
						if (Z) {
							u <<= Z;
							e -= Z;
							u |= t[t.j] >>> e & (1 << Z) - 1;
						}
						t.a = 8 - e;
					}
					return u;
				}
				function a0(t, Z) {
					var u = 0;
					if (Z < t) while (u <= 14 && Z << ++u < t);
					return u;
				}
				function r(t, Z, u, e, Q, V, O, o) {
					if (o == null) o = 0;
					var X = V + 1, k = X % 2, a = 0, l, R, w = e[Q], S = e[Q - 1], H = e[Q - 2][X], g = S[X - 1], Y = S[X], P = S[X + 1], A = w[X - 1], v = w[X + 1], y = Math.abs, d, C, n, h;
					if (k) {
						d = y(P - Y);
						C = y(H - Y);
						n = y(g - Y);
					}
					if (k) {
						h = d > n && C < d ? H + g : d < n && C < n ? H + P : P + g;
						h = h + 2 * Y >>> 2;
						if (o) {
							w[X] = h;
							return;
						}
						l = Z.t * Z.c[t.g + Y - H] + Z.c[t.g + g - Y];
					} else {
						h = Y > g && Y > P || Y < g && Y < P ? v + A + 2 * Y >>> 2 : A + v >>> 1;
						l = Z.t * Z.c[t.g + Y - g] + Z.c[t.g + g - A];
					}
					R = y(l);
					var W = a4(u);
					if (W < t.n - Z.v - 1) {
						var z = a0(O[R][0], O[R][1]);
						a = K(u, z) + (W << z);
					} else a = K(u, Z.v) + 1;
					a = a & 1 ? -1 - (a >>> 1) : a >>> 1;
					O[R][0] += y(a);
					if (O[R][1] == t.f) {
						O[R][0] >>>= 1;
						O[R][1] >>>= 1;
					}
					O[R][1]++;
					h = l < 0 ? h - a : h + a;
					if (t.i) {
						if (h < 0) h += Z.w;
						else if (h > t.g) h -= Z.w;
					}
					w[X] = h >= 0 ? Math.min(h, t.g) : 0;
				}
				function U(t, Z, u) {
					var e = t[0].length;
					for (var Q = Z; Q <= u; Q++) {
						t[Q][0] = t[Q - 1][1];
						t[Q][e - 1] = t[Q - 1][e - 2];
					}
				}
				function B(t) {
					U(t, s, q$1);
					U(t, i$1, J);
					U(t, x, $);
				}
				function _(t, Z, u, e, Q, V, O, o, X, k, j, I, a) {
					var l = 0, R = 1, w = Q < M && Q > J;
					while (R < t.m) {
						if (l < t.m) {
							r(t, Z, u, e, Q, l, O[X], t.h && (w && k || !w && (j || (l & I) == a)));
							r(t, Z, u, e, V, l, O[X], t.h && (!w && k || w && (j || (l & I) == a)));
							l += 2;
						}
						if (l > 8) {
							r(t, Z, u, e, Q, R, o[X]);
							r(t, Z, u, e, V, R, o[X]);
							R += 2;
						}
					}
					B(e);
				}
				function a8(t, Z, u, e, Q, V) {
					_(t, Z, u, e, i$1, s, Q, V, 0, 0, 1, 0, 8);
					_(t, Z, u, e, c$1, x, Q, V, 1, 0, 1, 0, 8);
					_(t, Z, u, e, b, T, Q, V, 2, 1, 0, 3, 0);
					_(t, Z, u, e, a3, L, Q, V, 0, 0, 0, 3, 2);
					_(t, Z, u, e, J, f, Q, V, 1, 0, 0, 3, 2);
					_(t, Z, u, e, q$1, $, Q, V, 2, 1, 0, 3, 0);
				}
				function a9(t, Z, u, e, Q, V) {
					var O = V.length, o = t.l;
					if (Q + 1 == t.s) o = t.e - Q * t.l;
					var X = 6 * t.e * e + Q * t.l;
					for (var k = 0; k < 6; k++) {
						for (var j = 0; j < o; j++) {
							var I = V[k % O][j % O], a;
							if (I == 0) a = i$1 + (k >>> 1);
							else if (I == 2) a = x + (k >>> 1);
							else a = s + k;
							var l = t.h ? (j * 2 / 3 & 2147483646 | j % 3 & 1) + (j % 3 >>> 1) : j >>> 1;
							Z[X + j] = u[a][l + 1];
						}
						X += t.e;
					}
				}
				UTIF$1._decompressRAF = function(t, Z) {
					var u = a5(t), e = a7(t, u), Q = a2(u), V = new Int16Array(u.e * u.q);
					if (Z == null) Z = u.h ? [
						[
							1,
							1,
							0,
							1,
							1,
							2
						],
						[
							1,
							1,
							2,
							1,
							1,
							0
						],
						[
							2,
							0,
							1,
							0,
							2,
							1
						],
						[
							1,
							1,
							2,
							1,
							1,
							0
						],
						[
							1,
							1,
							0,
							1,
							1,
							2
						],
						[
							0,
							2,
							1,
							2,
							0,
							1
						]
					] : [[0, 1], [3, 2]];
					var O = [
						[G, b],
						[F, J],
						[N, f],
						[E, q$1],
						[M, L],
						[m, $]
					], o = [];
					for (var X = 0; X < p; X++) o[X] = new Uint16Array(u.A);
					for (var k = 0; k < u.s; k++) {
						var j = D(Q), I = D(Q);
						for (var X = 0; X < p; X++) for (var a = 0; a < u.A; a++) o[X][a] = 0;
						for (var l = 0; l < u.d; l++) {
							a8(u, Q, e[k], o, j, I);
							for (var X = 0; X < 6; X++) for (var a = 0; a < u.A; a++) o[O[X][0]][a] = o[O[X][1]][a];
							a9(u, V, o, l, k, Z);
							for (var X = i$1; X < p; X++) if ([
								N,
								E,
								M,
								m
							].indexOf(X) == -1) for (var a = 0; a < u.A; a++) o[X][a] = 0;
							B(o);
						}
					}
					return V;
				};
			})();
		})(UTIF, pako$1);
	})();
})))(), 1);
var domEnvironment = null;
var MAX_PIXEL_COUNT = 1e8;
const setTiffDomEnvironment = (env) => {
	domEnvironment = env || null;
};
function isTiffExtension(extension$1) {
	const ext = extension$1?.toLowerCase();
	return ext === "tiff" || ext === "tif";
}
function createCanvas() {
	const env = domEnvironment || {};
	const doc$2 = env.document || env.mockDocument || env.window?.document || env.mockWindow?.document || null;
	if (doc$2) return doc$2.createElement("canvas");
	if (typeof document !== "undefined") return document.createElement("canvas");
	return null;
}
function convertTiffToPng(data) {
	try {
		if (typeof data !== "string") return null;
		const buffer = dataUriToArrayBuffer(data);
		const ifds = import_UTIF.decode(buffer);
		if (!ifds || ifds.length === 0) return null;
		const ifdWidth = ifds[0].t256?.[0];
		const ifdHeight = ifds[0].t257?.[0];
		if (!ifdWidth || !ifdHeight || ifdWidth * ifdHeight > MAX_PIXEL_COUNT) return null;
		import_UTIF.decodeImage(buffer, ifds[0]);
		const rgba = import_UTIF.toRGBA8(ifds[0]);
		if (!rgba || rgba.length === 0) return null;
		const { width, height } = ifds[0];
		const canvas = createCanvas();
		if (!canvas) {
			console.warn("TIFF conversion requires a DOM environment with canvas support");
			return null;
		}
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext("2d");
		if (!ctx) return null;
		const imageData = ctx.createImageData(width, height);
		imageData.data.set(new Uint8Array(rgba.buffer, rgba.byteOffset, rgba.byteLength));
		ctx.putImageData(imageData, 0, 0);
		const dataUri = canvas.toDataURL("image/png");
		if (!dataUri || dataUri === "data:,") return null;
		return {
			dataUri,
			format: "png"
		};
	} catch (error) {
		console.warn("Failed to convert TIFF to PNG:", error.message);
		return null;
	}
}
const GENERAL_FORMATS = new Map([
	["Arabic", "decimal"],
	["roman", "lowerRoman"],
	["Roman", "upperRoman"],
	["ROMAN", "upperRoman"],
	["alphabetic", "lowerLetter"],
	["ALPHABETIC", "upperLetter"],
	["ArabicDash", "numberInDash"],
	["Ordinal", "ordinal"]
]);
const CASE_INSENSITIVE_GENERAL_FORMATS = new Map([["arabic", "decimal"], ["arabicdash", "numberInDash"]]);
function parsePageNumberFieldSwitches(instruction, fieldType) {
	const switchInstruction = typeof instruction === "string" ? instruction.trim() : fieldType;
	const normalizedInstruction = normalizeInstructionWhitespace(switchInstruction);
	const result = {};
	if (normalizedInstruction && normalizedInstruction !== fieldType) result.instruction = normalizedInstruction;
	for (const match of switchInstruction.matchAll(/\\\*\s+("[^"]+"|\S+)/g)) {
		const rawValue = unquote(match[1]);
		const mapped = GENERAL_FORMATS.get(rawValue) ?? CASE_INSENSITIVE_GENERAL_FORMATS.get(rawValue.toLowerCase());
		if (mapped) {
			result.pageNumberFormat = mapped;
			break;
		}
	}
	for (const match of switchInstruction.matchAll(/\\#\s+("[^"]+"|\S+)/g)) {
		const picture = unquote(match[1]);
		if (!picture) continue;
		if (/^0+$/.test(picture)) {
			result.pageNumberFormat ??= "decimal";
			result.pageNumberZeroPadding = picture.length;
		} else result.pageNumberNumericPicture = picture;
		break;
	}
	return result;
}
function formatPageNumberFieldValue$1(pageNumber, attrs = {}) {
	return formatPageNumberFieldValue(pageNumber, {
		format: attrs.pageNumberFormat || "decimal",
		zeroPadding: attrs.pageNumberZeroPadding ?? void 0,
		numericPicture: attrs.pageNumberNumericPicture ?? void 0
	});
}
function unquote(value) {
	return value.startsWith("\"") && value.endsWith("\"") ? value.slice(1, -1) : value;
}
function normalizeInstructionWhitespace(instruction) {
	let normalized = "";
	let inQuote = false;
	let pendingSpace = false;
	for (const char of instruction) {
		if (char === "\"") {
			if (pendingSpace && normalized.length > 0) {
				normalized += " ";
				pendingSpace = false;
			}
			normalized += char;
			inQuote = !inQuote;
			continue;
		}
		if (!inQuote && /\s/.test(char)) {
			pendingSpace = true;
			continue;
		}
		if (pendingSpace && normalized.length > 0) {
			normalized += " ";
			pendingSpace = false;
		}
		normalized += char;
	}
	return normalized;
}
function preProcessPageInstruction(nodesToCombine, instrText = "PAGE", options = {}) {
	const fieldRunRPr = options.fieldRunRPr ?? null;
	const normalizedInstruction = typeof instrText === "string" && instrText.trim() ? instrText.trim().replace(/\s+/g, " ") : "PAGE";
	const pageNumNode = {
		name: "sd:autoPageNumber",
		type: "element",
		attributes: {
			instruction: normalizedInstruction,
			...parsePageNumberFieldSwitches(normalizedInstruction, "PAGE")
		}
	};
	let foundContentRPr = false;
	nodesToCombine.forEach((n) => {
		const rPrNode = n.elements?.find((el) => el.name === "w:rPr");
		if (rPrNode) {
			pageNumNode.elements = [rPrNode];
			foundContentRPr = true;
		}
	});
	if (!foundContentRPr && fieldRunRPr && fieldRunRPr.name === "w:rPr") pageNumNode.elements = [fieldRunRPr];
	return [pageNumNode];
}
function preProcessNumPagesInstruction(nodesToCombine, instrText = "NUMPAGES", options = {}) {
	const fieldRunRPr = options.fieldRunRPr ?? null;
	const totalPageNumNode = {
		name: "sd:totalPageNumber",
		type: "element",
		attributes: { ...parsePageNumberFieldSwitches(instrText, "NUMPAGES") }
	};
	const cachedText = extractCachedText$2(nodesToCombine);
	if (cachedText) totalPageNumNode.attributes.importedCachedText = cachedText;
	let foundContentRPr = false;
	nodesToCombine.forEach((n) => {
		const rPrNode = n.elements?.find((el) => el.name === "w:rPr");
		if (rPrNode) {
			totalPageNumNode.elements = [rPrNode];
			foundContentRPr = true;
		}
	});
	if (!foundContentRPr && fieldRunRPr && fieldRunRPr.name === "w:rPr") totalPageNumNode.elements = [fieldRunRPr];
	return [totalPageNumNode];
}
function extractCachedText$2(nodes) {
	const texts = [];
	for (const node of nodes) {
		const textEl = node.elements?.find((el) => el.name === "w:t");
		if (textEl) {
			const text$2 = textEl.elements?.[0]?.text ?? "";
			if (text$2) texts.push(text$2);
		}
	}
	return texts.join("");
}
function preProcessSectionPagesInstruction(nodesToCombine, instrText = "", options = null, _instructionTokens, fieldRunRPr = null) {
	const effectiveFieldRunRPr = fieldRunRPr ?? options?.fieldRunRPr ?? (options?.name === "w:rPr" ? options : null);
	const normalizedInstruction = typeof instrText === "string" && instrText.trim() ? instrText.trim().replace(/\s+/g, " ") : "SECTIONPAGES";
	const parsedInstruction = parsePageNumberFieldSwitches(normalizedInstruction, "SECTIONPAGES");
	const sectionPageCountNode = {
		name: "sd:sectionPageCount",
		type: "element",
		attributes: {
			instruction: normalizedInstruction,
			...parsedInstruction.pageNumberFormat ? { pageNumberFormat: parsedInstruction.pageNumberFormat } : {},
			...parsedInstruction.pageNumberZeroPadding != null ? { pageNumberZeroPadding: parsedInstruction.pageNumberZeroPadding } : {}
		}
	};
	const cachedText = extractCachedText$1(nodesToCombine);
	if (cachedText) sectionPageCountNode.attributes.importedCachedText = cachedText;
	let foundContentRPr = false;
	nodesToCombine.forEach((n) => {
		const rPrNode = n.elements?.find((el) => el.name === "w:rPr");
		if (rPrNode) {
			sectionPageCountNode.elements = [rPrNode];
			foundContentRPr = true;
		}
	});
	if (!foundContentRPr && effectiveFieldRunRPr && effectiveFieldRunRPr.name === "w:rPr") sectionPageCountNode.elements = [effectiveFieldRunRPr];
	return [sectionPageCountNode];
}
function extractCachedText$1(nodes) {
	const texts = [];
	for (const node of nodes) {
		const textEl = node.elements?.find((el) => el.name === "w:t");
		if (textEl) {
			const text$2 = textEl.elements?.[0]?.text ?? "";
			if (text$2) texts.push(text$2);
		}
	}
	return texts.join("");
}
var TOKEN_PATTERN$1 = /"((?:[^"\\]|\\.)*)"|'((?:[^'\\]|\\.)*)'|\\[#*]|\\[^\s]+|[^\s]+/g;
function parsePageRefInstruction(instruction) {
	const rawInstruction = typeof instruction === "string" ? instruction.trim() : "";
	const tokens = tokenizeInstruction$1(rawInstruction);
	const result = {
		instruction: rawInstruction,
		bookmarkId: "",
		hasHyperlinkSwitch: false,
		hasRelativePositionSwitch: false,
		rawSwitches: []
	};
	if (!tokens.length || !/^PAGEREF$/i.test(tokens[0].value)) return result;
	for (let index = 1; index < tokens.length; index += 1) {
		const token = tokens[index].value;
		if (!token) continue;
		if (token.startsWith("\\")) {
			const normalized = token.toLowerCase();
			if (normalized === "\\h") {
				result.hasHyperlinkSwitch = true;
				result.rawSwitches.push({ switch: token });
				continue;
			}
			if (normalized === "\\p") {
				result.hasRelativePositionSwitch = true;
				result.rawSwitches.push({ switch: token });
				continue;
			}
			if (token === "\\*") {
				const value = tokens[index + 1]?.value;
				if (value != null) {
					result.rawSwitches.push({
						switch: token,
						value
					});
					applyGeneralFormat$1(result, value);
					index += 1;
				} else result.rawSwitches.push({ switch: token });
				continue;
			}
			if (token === "\\#") {
				const value = tokens[index + 1]?.value;
				if (value != null) {
					result.rawSwitches.push({
						switch: token,
						value
					});
					result.numericPictureFormat = { picture: value };
					if (/^0+$/.test(value)) result.pageNumberFieldFormat = {
						...result.pageNumberFieldFormat ?? {},
						zeroPadding: value.length
					};
					index += 1;
				} else result.rawSwitches.push({ switch: token });
				continue;
			}
			result.rawSwitches.push({ switch: token });
			continue;
		}
		if (!result.bookmarkId) result.bookmarkId = token;
	}
	return result;
}
function tokenizeInstruction$1(instruction) {
	const tokens = [];
	for (const match of instruction.matchAll(TOKEN_PATTERN$1)) tokens.push({ value: unescapeQuotedToken$1(match[1] ?? match[2] ?? match[0]) });
	return tokens;
}
function unescapeQuotedToken$1(value) {
	return value.replace(/\\(["'\\])/g, "$1");
}
function applyGeneralFormat$1(result, value) {
	const normalized = value.toLowerCase();
	if (normalized === "charformat") {
		result.fieldResultFormat = "charformat";
		return;
	}
	if (normalized === "mergeformat") {
		result.fieldResultFormat = "mergeformat";
		return;
	}
	const mapped = GENERAL_FORMATS.get(value) ?? CASE_INSENSITIVE_GENERAL_FORMATS.get(normalized);
	if (mapped) result.pageNumberFieldFormat = {
		...result.pageNumberFieldFormat ?? {},
		format: mapped
	};
	else result.unsupportedGeneralFormat = value;
}
function preProcessPageRefInstruction(nodesToCombine, instrText, options = {}) {
	const parsed = parsePageRefInstruction(instrText);
	const instructionTokens = options.instructionTokens ?? null;
	const firstInstrTextRunRPr = options.firstInstrTextRunRPr ?? null;
	const fieldRunProperties = parsed.fieldResultFormat === "charformat" && firstInstrTextRunRPr ? translator$133.encode({
		...options.docx ? { docx: options.docx } : {},
		nodes: [firstInstrTextRunRPr]
	}) : null;
	return [{
		name: "sd:pageReference",
		type: "element",
		attributes: {
			instruction: parsed.instruction,
			...instructionTokens?.length ? { instructionTokens } : {},
			...parsed.bookmarkId ? { bookmarkId: parsed.bookmarkId } : {},
			...parsed.hasHyperlinkSwitch ? { hasHyperlinkSwitch: true } : {},
			...parsed.hasRelativePositionSwitch ? { hasRelativePositionSwitch: true } : {},
			...parsed.pageNumberFieldFormat ? { pageNumberFieldFormat: parsed.pageNumberFieldFormat } : {},
			...parsed.numericPictureFormat ? { numericPictureFormat: parsed.numericPictureFormat } : {},
			...parsed.fieldResultFormat ? { fieldResultFormat: parsed.fieldResultFormat } : {},
			...fieldRunProperties ? { fieldRunProperties } : {}
		},
		elements: nodesToCombine
	}];
}
function resolveHyperlinkAttributes(instruction, docx) {
	const urlMatch = instruction.match(/^\s*HYPERLINK\s+"([^"]+)"/i);
	if (urlMatch && urlMatch.length >= 2) {
		const url = urlMatch[1];
		const relationships = (docx?.["word/_rels/document.xml.rels"])?.elements?.find((el) => el.name === "Relationships");
		if (relationships) {
			const rId = "rId" + generateDocxRandomId();
			relationships.elements.push({
				type: "element",
				name: "Relationship",
				attributes: {
					Id: rId,
					Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
					Target: url,
					TargetMode: "External"
				}
			});
			return { "r:id": rId };
		}
		return { "w:anchor": url };
	}
	const availableSwitches = {
		"w:anchor": /(?:\\)?l "(?<value>[^"]+)"/,
		new_window: /(?:\\n|\n)/,
		"w:tgtFrame": /(?:\\t|\t) "(?<value>[^"]+)"/,
		"w:tooltip": /(?:\\)?o "(?<value>[^"]+)"/
	};
	const parsedSwitches = {};
	for (const [key, pattern] of Object.entries(availableSwitches)) {
		const match = instruction.match(pattern);
		if (match) parsedSwitches[key] = match.groups?.value || true;
	}
	if (parsedSwitches.new_window) {
		parsedSwitches["w:tgtFrame"] = "_blank";
		delete parsedSwitches.new_window;
	}
	if (Object.keys(parsedSwitches).length === 0) return null;
	return { ...parsedSwitches };
}
function preProcessHyperlinkInstruction(nodesToCombine, instruction, options = {}) {
	const docx = options.docx;
	return [{
		name: "w:hyperlink",
		type: "element",
		attributes: resolveHyperlinkAttributes(instruction, docx) ?? {},
		elements: nodesToCombine
	}];
}
function preProcessTocInstruction(nodesToCombine, instrText, options = {}) {
	return [{
		name: "sd:tableOfContents",
		type: "element",
		attributes: { instruction: instrText },
		elements: nodesToCombine
	}];
}
function normalizeFieldContentToParagraphs(nodes) {
	const input = Array.isArray(nodes) ? nodes : [];
	if (input.length === 0) return [{
		name: "w:p",
		type: "element",
		elements: []
	}];
	const out = [];
	let buffer = null;
	const flushBuffer = () => {
		if (buffer) {
			out.push({
				name: "w:p",
				type: "element",
				elements: buffer
			});
			buffer = null;
		}
	};
	for (const node of input) if (node?.name === "w:p") {
		flushBuffer();
		out.push(node);
	} else {
		if (!buffer) buffer = [];
		buffer.push(node);
	}
	flushBuffer();
	return out;
}
function buildBlockFieldNode(xmlName, nodesToCombine, instrText, instructionTokens = null) {
	return [{
		name: xmlName,
		type: "element",
		attributes: {
			instruction: instrText,
			...instructionTokens ? { instructionTokens } : {}
		},
		elements: normalizeFieldContentToParagraphs(nodesToCombine)
	}];
}
function preProcessIndexInstruction(nodesToCombine, instrText, options = {}, legacyInstructionTokens = null) {
	return buildBlockFieldNode("sd:index", nodesToCombine, instrText, options?.instructionTokens ?? legacyInstructionTokens);
}
function preProcessXeInstruction(nodesToCombine, instrText, options = {}) {
	const instructionTokens = options.instructionTokens ?? null;
	return [{
		name: "sd:indexEntry",
		type: "element",
		attributes: {
			instruction: instrText,
			...instructionTokens ? { instructionTokens } : {}
		},
		elements: nodesToCombine
	}];
}
function preProcessTcInstruction(nodesToCombine, instrText, options = {}) {
	const before = [];
	const after = [];
	const entryElements = [];
	const instructionTokens = options.instructionTokens ?? null;
	let seenContent = false;
	for (const node of nodesToCombine) if (node?.name === "w:bookmarkStart" || node?.name === "w:bookmarkEnd") (seenContent ? after : before).push(node);
	else {
		seenContent = true;
		entryElements.push(node);
	}
	return [
		...before,
		{
			name: "sd:tableOfContentsEntry",
			type: "element",
			attributes: {
				instruction: instrText,
				...instructionTokens ? { instructionTokens } : {}
			},
			elements: entryElements
		},
		...after
	];
}
function preProcessRefInstruction(nodesToCombine, instrText, options = {}) {
	return [{
		name: "sd:crossReference",
		type: "element",
		attributes: {
			instruction: instrText,
			fieldType: "REF"
		},
		elements: nodesToCombine
	}];
}
function preProcessNoterefInstruction(nodesToCombine, instrText, options = {}) {
	return [{
		name: "sd:crossReference",
		type: "element",
		attributes: {
			instruction: instrText,
			fieldType: "NOTEREF"
		},
		elements: nodesToCombine
	}];
}
function preProcessStylerefInstruction(nodesToCombine, instrText, options = {}) {
	return [{
		name: "sd:crossReference",
		type: "element",
		attributes: {
			instruction: instrText,
			fieldType: "STYLEREF"
		},
		elements: nodesToCombine
	}];
}
function preProcessSeqInstruction(nodesToCombine, instrText, options = {}) {
	const instructionTokens = options.instructionTokens ?? null;
	return [{
		name: "sd:sequenceField",
		type: "element",
		attributes: {
			instruction: instrText,
			...instructionTokens ? { instructionTokens } : {}
		},
		elements: nodesToCombine
	}];
}
function preProcessCitationInstruction(nodesToCombine, instrText, options = {}) {
	const instructionTokens = options.instructionTokens ?? null;
	return [{
		name: "sd:citation",
		type: "element",
		attributes: {
			instruction: instrText,
			...instructionTokens ? { instructionTokens } : {}
		},
		elements: nodesToCombine
	}];
}
function preProcessBibliographyInstruction(nodesToCombine, instrText, options = {}, legacyInstructionTokens = null) {
	return buildBlockFieldNode("sd:bibliography", nodesToCombine, instrText, options?.instructionTokens ?? legacyInstructionTokens);
}
function preProcessTaInstruction(nodesToCombine, instrText, options = {}) {
	const instructionTokens = options.instructionTokens ?? null;
	return [{
		name: "sd:authorityEntry",
		type: "element",
		attributes: {
			instruction: instrText,
			...instructionTokens ? { instructionTokens } : {}
		},
		elements: nodesToCombine
	}];
}
function preProcessToaInstruction(nodesToCombine, instrText, options = {}, legacyInstructionTokens = null) {
	return buildBlockFieldNode("sd:tableOfAuthorities", nodesToCombine, instrText, options?.instructionTokens ?? legacyInstructionTokens);
}
function preProcessDocumentStatInstruction(nodesToCombine, instrText, options = {}) {
	const fieldRunRPr = options.fieldRunRPr ?? null;
	const statFieldNode = {
		name: "sd:documentStatField",
		type: "element",
		attributes: { instruction: instrText },
		elements: [...nodesToCombine]
	};
	let foundContentRPr = false;
	nodesToCombine.forEach((n) => {
		const rPrNode = n.elements?.find((el) => el.name === "w:rPr");
		if (rPrNode) {
			if (!statFieldNode.elements) statFieldNode.elements = [];
			statFieldNode.elements = [rPrNode, ...nodesToCombine];
			foundContentRPr = true;
		}
	});
	if (!foundContentRPr && fieldRunRPr && fieldRunRPr.name === "w:rPr") statFieldNode.elements = [fieldRunRPr, ...nodesToCombine];
	return [statFieldNode];
}
function extractFieldKeyword(instruction) {
	return String(instruction ?? "").trim().split(/\s+/)[0].toUpperCase();
}
const getInstructionPreProcessor = (instruction) => {
	switch (extractFieldKeyword(instruction)) {
		case "PAGE": return preProcessPageInstruction;
		case "NUMPAGES": return preProcessNumPagesInstruction;
		case "SECTIONPAGES": return preProcessSectionPagesInstruction;
		case "NUMWORDS":
		case "NUMCHARS": return preProcessDocumentStatInstruction;
		case "PAGEREF": return preProcessPageRefInstruction;
		case "HYPERLINK": return preProcessHyperlinkInstruction;
		case "TOC": return preProcessTocInstruction;
		case "INDEX": return preProcessIndexInstruction;
		case "XE": return preProcessXeInstruction;
		case "TC": return preProcessTcInstruction;
		case "REF": return preProcessRefInstruction;
		case "NOTEREF": return preProcessNoterefInstruction;
		case "STYLEREF": return preProcessStylerefInstruction;
		case "SEQ": return preProcessSeqInstruction;
		case "CITATION": return preProcessCitationInstruction;
		case "BIBLIOGRAPHY": return preProcessBibliographyInstruction;
		case "TA": return preProcessTaInstruction;
		case "TOA": return preProcessToaInstruction;
		default: return null;
	}
};
var TRACK_CHANGE_ELEMENT_NAMES = new Set([
	"w:del",
	"w:ins",
	"w:moveFrom",
	"w:moveTo"
]);
var TRANSLATED_TRACK_CHANGE_ELEMENT_NAMES = new Set(["w:del", "w:ins"]);
var CONSTRUCTIVE_TRACK_CHANGE_ELEMENT_NAMES = new Set(["w:ins", "w:moveTo"]);
const isTrackChangeElement = (node) => TRACK_CHANGE_ELEMENT_NAMES.has(node?.name);
const isTranslatedTrackChangeElement = (node) => TRANSLATED_TRACK_CHANGE_ELEMENT_NAMES.has(node?.name);
const isConstructiveTrackChangeElement = (node) => CONSTRUCTIVE_TRACK_CHANGE_ELEMENT_NAMES.has(node?.name);
var SKIP_FIELD_PROCESSING_NODE_NAMES$1 = new Set(["w:drawing", "w:pict"]);
var shouldSkipFieldProcessing$1 = (node) => SKIP_FIELD_PROCESSING_NODE_NAMES$1.has(node?.name);
const preProcessNodesForFldChar = (nodes = [], docx) => {
	const processedNodes = [];
	let collectedNodesStack = [];
	let rawCollectedNodesStack = [];
	let fieldRunRPrStack = [];
	let firstInstrTextRunRPrStack = [];
	let firstInstrTextRunSeenStack = [];
	let currentFieldStack = [];
	let unpairedEnd = null;
	let unpairedEndPreserveRaw = null;
	let collecting = false;
	const rawNodeSourceTokens = /* @__PURE__ */ new WeakMap();
	const finalizeField = () => {
		if (collecting) {
			const collectedNodes = collectedNodesStack.pop().filter((n) => n !== null);
			const rawCollectedNodes = rawCollectedNodesStack.pop().filter((n) => n !== null);
			const fieldRunRPr = fieldRunRPrStack.pop() ?? null;
			const firstInstrTextRunRPr = firstInstrTextRunRPrStack.pop() ?? null;
			firstInstrTextRunSeenStack.pop();
			const currentField = currentFieldStack.pop();
			let outputNodes = rawCollectedNodes;
			if (!currentField.preserveRaw) {
				const combinedResult = _processCombinedNodesForFldChar(collectedNodes, currentField.instrText.trim(), docx, currentField.instructionTokens, fieldRunRPr, firstInstrTextRunRPr);
				outputNodes = combinedResult.handled ? combinedResult.nodes : rawCollectedNodes;
			} else if (currentField.preserveRawConstructive) applyConstructiveFieldInterpretation(outputNodes, currentField.instrText.trim(), docx);
			if (collectedNodesStack.length === 0) processedNodes.push(...outputNodes);
			else {
				collectedNodesStack[collectedNodesStack.length - 1].push(...outputNodes);
				rawCollectedNodesStack[rawCollectedNodesStack.length - 1].push(...outputNodes);
			}
		} else unpairedEnd = true;
	};
	const captureRawNodeForCurrentField = (rawNode, capturedRawNodes, rawSourceToken) => {
		if (rawCollectedNodesStack.length === 0) return;
		if (capturedRawNodes.has(rawNode)) return;
		const currentRawStack = rawCollectedNodesStack[rawCollectedNodesStack.length - 1];
		const lastRawNode = currentRawStack[currentRawStack.length - 1];
		if (lastRawNode?.name === "w:r" && rawNode?.name === "w:r" && rawNodeSourceTokens.get(lastRawNode) === rawSourceToken && Array.isArray(lastRawNode.elements) && Array.isArray(rawNode.elements)) lastRawNode.elements.push(...carbonCopy(rawNode.elements));
		else {
			currentRawStack.push(rawNode);
			rawNodeSourceTokens.set(rawNode, rawSourceToken);
		}
		capturedRawNodes.add(rawNode);
	};
	const processNode = (node, rawNode, capturedRawNodes, rawSourceToken) => {
		collecting = collectedNodesStack.length > 0;
		if (shouldSkipFieldProcessing$1(node)) {
			if (collecting) {
				collectedNodesStack[collectedNodesStack.length - 1].push(node);
				captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
			} else processedNodes.push(node);
			return;
		}
		const fldType = (node.elements?.find((el) => el.name === "w:fldChar"))?.attributes?.["w:fldCharType"];
		const instrTextEl = node.elements?.find((el) => el.name === "w:instrText");
		if (node.name === "w:fldSimple") {
			const instr = node.attributes?.["w:instr"];
			if (typeof instr === "string") {
				const instructionPreProcessor = getInstructionPreProcessor(instr);
				if (instructionPreProcessor) {
					const processed = instructionPreProcessor(node.elements ?? [], instr, { docx });
					if (collecting) {
						collectedNodesStack[collectedNodesStack.length - 1].push(...processed);
						rawCollectedNodesStack[rawCollectedNodesStack.length - 1].push(...processed);
					} else processedNodes.push(...processed);
					return;
				}
			}
		}
		if (fldType === "begin") {
			collectedNodesStack.push([]);
			const rawStack = [rawNode];
			rawCollectedNodesStack.push(rawStack);
			rawNodeSourceTokens.set(rawNode, rawSourceToken);
			capturedRawNodes.add(rawNode);
			fieldRunRPrStack.push(extractFieldRunRPr(node));
			firstInstrTextRunRPrStack.push(null);
			firstInstrTextRunSeenStack.push(false);
			currentFieldStack.push({
				instrText: "",
				instructionTokens: [],
				afterSeparate: false
			});
			return;
		}
		if (collecting && currentFieldStack.length > 0) {
			const currentField = currentFieldStack[currentFieldStack.length - 1];
			if (!currentField.afterSeparate) {
				const instructionTokens = extractInstructionTokensFromNode(node);
				if (instructionTokens.length > 0) {
					captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
					const fieldRunRPr = extractFieldRunRPr(node);
					if (fieldRunRPr) fieldRunRPrStack[fieldRunRPrStack.length - 1] = fieldRunRPr;
					if (instrTextEl && !firstInstrTextRunSeenStack[firstInstrTextRunSeenStack.length - 1]) {
						firstInstrTextRunSeenStack[firstInstrTextRunSeenStack.length - 1] = true;
						firstInstrTextRunRPrStack[firstInstrTextRunRPrStack.length - 1] = fieldRunRPr;
					}
					currentField.instructionTokens.push(...instructionTokens);
					const instrTextValue = instrTextEl?.elements?.[0]?.text;
					if (instrTextValue != null) currentField.instrText += `${instrTextValue}`;
					if (instructionTokens.some((token) => token.type === "tab")) currentField.instrText += "	";
					return;
				}
			}
		}
		if (fldType === "end") {
			if (collecting) captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
			finalizeField();
			return;
		} else if (fldType === "separate") {
			if (collecting) {
				captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
				const fieldRunRPr = extractFieldRunRPr(node);
				if (fieldRunRPr) fieldRunRPrStack[fieldRunRPrStack.length - 1] = fieldRunRPr;
				const currentField = currentFieldStack[currentFieldStack.length - 1];
				if (currentField) currentField.afterSeparate = true;
			}
			return;
		}
		if (Array.isArray(node.elements)) {
			const childResult = preProcessNodesForFldChar(node.elements, docx);
			node.elements = childResult.processedNodes;
			if (childResult.unpairedBegin) childResult.unpairedBegin.forEach((pendingField) => {
				const fieldInfo = { ...pendingField.fieldInfo };
				if (fieldInfo.preserveRaw || isTrackChangeElement(node)) fieldInfo.preserveRaw = true;
				if (isConstructiveTrackChangeElement(node)) fieldInfo.preserveRawConstructive = true;
				currentFieldStack.push(fieldInfo);
				collectedNodesStack.push([node]);
				const rawStack = [rawNode];
				rawCollectedNodesStack.push(rawStack);
				rawNodeSourceTokens.set(rawNode, rawSourceToken);
				capturedRawNodes.add(rawNode);
			});
			else if (childResult.unpairedEnd) {
				const shouldPreserveRaw = childResult.unpairedEndPreserveRaw || isTrackChangeElement(node);
				if (collectedNodesStack.length === 0) {
					processedNodes.push(shouldPreserveRaw ? rawNode : node);
					unpairedEnd = true;
					if (shouldPreserveRaw) unpairedEndPreserveRaw = true;
					return;
				}
				if (shouldPreserveRaw) currentFieldStack[currentFieldStack.length - 1].preserveRaw = true;
				if (isConstructiveTrackChangeElement(node)) currentFieldStack[currentFieldStack.length - 1].preserveRawConstructive = true;
				collectedNodesStack[collectedNodesStack.length - 1].push(node);
				captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
				finalizeField();
			} else if (collecting) {
				collectedNodesStack[collectedNodesStack.length - 1].push(node);
				captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
			} else processedNodes.push(node);
		} else if (collecting) {
			collectedNodesStack[collectedNodesStack.length - 1].push(node);
			captureRawNodeForCurrentField(rawNode, capturedRawNodes, rawSourceToken);
		} else processedNodes.push(node);
	};
	for (const node of nodes) {
		const rawNode = carbonCopy(node);
		const logicalNodes = expandNodeForFieldProcessing(node);
		const rawLogicalNodes = expandNodeForFieldProcessing(rawNode);
		const capturedRawNodes = /* @__PURE__ */ new Set();
		const rawSourceToken = {};
		logicalNodes.forEach((logicalNode, index) => {
			processNode(logicalNode, rawLogicalNodes[index] ?? rawNode, capturedRawNodes, rawSourceToken);
		});
	}
	let unpairedBegin = null;
	if (collectedNodesStack.length > 0) {
		unpairedBegin = [];
		for (let i$1 = 0; i$1 < collectedNodesStack.length; i$1++) {
			processedNodes.push(...collectedNodesStack[i$1].filter((n) => n !== null));
			unpairedBegin.push({
				nodes: collectedNodesStack[i$1],
				fieldInfo: currentFieldStack[i$1]
			});
		}
	}
	return {
		processedNodes,
		unpairedBegin,
		unpairedEnd,
		unpairedEndPreserveRaw
	};
};
var _processCombinedNodesForFldChar = (nodesToCombine = [], instrText, docx, instructionTokens, fieldRunRPr, firstInstrTextRunRPr) => {
	const instructionPreProcessor = getInstructionPreProcessor(instrText);
	if (instructionPreProcessor) return {
		nodes: instructionPreProcessor(nodesToCombine, instrText, {
			docx,
			instructionTokens,
			fieldRunRPr,
			firstInstrTextRunRPr
		}),
		handled: true
	};
	return {
		nodes: nodesToCombine,
		handled: false
	};
};
var applyConstructiveFieldInterpretation = (rawNodes, instrText, docx) => {
	if (extractFieldKeyword(instrText) !== "HYPERLINK") return;
	const linkAttributes = resolveHyperlinkAttributes(instrText, docx);
	if (!linkAttributes) return;
	let visible = false;
	const walk = (parent) => {
		if (!parent || !Array.isArray(parent.elements)) return;
		const next = [];
		let pendingHyperlinkRuns = null;
		const flushHyperlink = () => {
			if (!pendingHyperlinkRuns || pendingHyperlinkRuns.length === 0) {
				pendingHyperlinkRuns = null;
				return;
			}
			next.push({
				type: "element",
				name: "w:hyperlink",
				attributes: linkAttributes,
				elements: pendingHyperlinkRuns
			});
			pendingHyperlinkRuns = null;
		};
		for (const child of parent.elements) {
			if (!child) continue;
			if (child.name === "w:p" || child.name === "w:ins" || child.name === "w:moveTo") {
				flushHyperlink();
				walk(child);
				next.push(child);
				continue;
			}
			if (child.name === "w:r") {
				const fldType = (child.elements?.find((el) => el?.name === "w:fldChar"))?.attributes?.["w:fldCharType"];
				if (fldType === "separate") {
					flushHyperlink();
					visible = true;
					next.push(child);
					continue;
				}
				if (fldType === "end") {
					flushHyperlink();
					visible = false;
					next.push(child);
					continue;
				}
				if (fldType === "begin") {
					flushHyperlink();
					next.push(child);
					continue;
				}
				if (child.elements?.some((el) => el?.name === "w:instrText")) {
					flushHyperlink();
					next.push(child);
					continue;
				}
				if (visible) {
					if (!pendingHyperlinkRuns) pendingHyperlinkRuns = [];
					pendingHyperlinkRuns.push(child);
					continue;
				}
				next.push(child);
				continue;
			}
			flushHyperlink();
			next.push(child);
		}
		flushHyperlink();
		parent.elements = next;
	};
	rawNodes.forEach(walk);
};
var extractFieldRunRPr = (node) => {
	const rPrNode = node?.elements?.find((el) => el.name === "w:rPr");
	if (!rPrNode?.elements?.length) return null;
	return rPrNode;
};
var extractInstructionTokensFromNode = (node) => {
	const elements = Array.isArray(node?.elements) ? node.elements : [];
	const tokens = [];
	elements.forEach((el) => {
		if (el?.name === "w:instrText") {
			const text$2 = (el.elements || []).map((child) => typeof child?.text === "string" ? child.text : "").join("");
			tokens.push({
				type: "text",
				text: text$2
			});
		}
		if (el?.name === "w:tab") tokens.push({ type: "tab" });
	});
	return tokens;
};
var FIELD_CONTROL_ELEMENT_NAMES = new Set(["w:fldChar"]);
var INSTRUCTION_ELEMENT_NAMES = new Set(["w:instrText", "w:tab"]);
var cloneNodeWithElements = (node, elements) => ({
	...node,
	elements: carbonCopy(elements)
});
var expandNodeForFieldProcessing = (node) => {
	const elements = Array.isArray(node?.elements) ? node.elements : null;
	if (node?.name !== "w:r" || !elements || elements.length === 0) return [node];
	const runProperties = elements.filter((el) => el?.name === "w:rPr");
	const contentElements = elements.filter((el) => el?.name !== "w:rPr");
	const logicalNodes = [];
	let currentKind = null;
	let currentElements = [];
	const flushCurrentGroup = () => {
		if (currentElements.length === 0) return;
		logicalNodes.push(cloneNodeWithElements(node, [...runProperties, ...currentElements]));
		currentElements = [];
		currentKind = null;
	};
	contentElements.forEach((element) => {
		if (!element?.name) {
			if (currentKind !== "content") {
				flushCurrentGroup();
				currentKind = "content";
			}
			currentElements.push(element);
			return;
		}
		if (FIELD_CONTROL_ELEMENT_NAMES.has(element.name)) {
			flushCurrentGroup();
			logicalNodes.push(cloneNodeWithElements(node, [...runProperties, element]));
			return;
		}
		if (INSTRUCTION_ELEMENT_NAMES.has(element.name)) {
			if (currentKind !== "instruction") {
				flushCurrentGroup();
				currentKind = "instruction";
			}
			currentElements.push(element);
			return;
		}
		if (currentKind !== "content") {
			flushCurrentGroup();
			currentKind = "content";
		}
		currentElements.push(element);
	});
	flushCurrentGroup();
	return logicalNodes.length > 1 ? logicalNodes : [node];
};
var SKIP_FIELD_PROCESSING_NODE_NAMES = new Set(["w:drawing", "w:pict"]);
var shouldSkipFieldProcessing = (node) => SKIP_FIELD_PROCESSING_NODE_NAMES.has(node?.name);
const preProcessPageFieldsOnly = (nodes = [], depth = 0) => {
	const processedNodes = [];
	let i$1 = 0;
	while (i$1 < nodes.length) {
		const node = nodes[i$1];
		if (shouldSkipFieldProcessing(node)) {
			processedNodes.push(node);
			i$1++;
			continue;
		}
		const fldType = (node.elements?.find((el) => el.name === "w:fldChar"))?.attributes?.["w:fldCharType"];
		if (node.name === "w:fldSimple") {
			const instrAttr = node.attributes?.["w:instr"] || "";
			const fldSimplePreprocessor = getHeaderFooterFieldPreprocessor(extractFieldKeyword(instrAttr));
			if (fldSimplePreprocessor) {
				const contentNodes = node.elements || [];
				let fieldRunRPr = null;
				for (const child of contentNodes) {
					const rPr = child.elements?.find((el) => el.name === "w:rPr");
					if (rPr) {
						fieldRunRPr = rPr;
						break;
					}
				}
				const processedField = fldSimplePreprocessor(contentNodes, instrAttr.trim(), { fieldRunRPr });
				processedNodes.push(...processedField);
				i$1++;
				continue;
			}
			const childElements = node.elements || [];
			if (childElements.length > 0) {
				for (const child of childElements) {
					if (Array.isArray(child.elements)) child.elements = preProcessPageFieldsOnly(child.elements, depth + 1).processedNodes;
					processedNodes.push(child);
				}
				i$1++;
				continue;
			}
		}
		if (fldType === "begin") {
			const fieldInfo = scanFieldSequence(nodes, i$1);
			const complexFieldPreprocessor = fieldInfo ? getHeaderFooterFieldPreprocessor(fieldInfo.fieldType) : null;
			if (fieldInfo && complexFieldPreprocessor) {
				const preprocessor = complexFieldPreprocessor;
				const contentNodes = fieldInfo.contentNodes;
				const processedField = preprocessor(contentNodes, fieldInfo.instrText, { fieldRunRPr: fieldInfo.fieldRunRPr });
				processedNodes.push(...processedField);
				i$1 = fieldInfo.endIndex + 1;
				continue;
			} else if (fieldInfo) {
				for (let j = i$1; j <= fieldInfo.endIndex; j++) {
					const passNode = nodes[j];
					if (Array.isArray(passNode.elements)) passNode.elements = preProcessPageFieldsOnly(passNode.elements, depth + 1).processedNodes;
					processedNodes.push(passNode);
				}
				i$1 = fieldInfo.endIndex + 1;
				continue;
			}
		}
		if (node.name === "w:r" && node.elements?.some((el) => el.name === "w:pgNum")) {
			const processedField = preProcessPageInstruction([], "", { fieldRunRPr: node.elements.find((el) => el.name === "w:rPr") || null });
			processedNodes.push(...processedField);
			i$1++;
			continue;
		}
		if (Array.isArray(node.elements)) node.elements = preProcessPageFieldsOnly(node.elements, depth + 1).processedNodes;
		processedNodes.push(node);
		i$1++;
	}
	return { processedNodes };
};
function scanFieldSequence(nodes, beginIndex) {
	let instrText = "";
	let separateIndex = -1;
	let endIndex = -1;
	const contentNodes = [];
	let fieldRunRPr = null;
	const beginRPr = nodes[beginIndex].elements?.find((el) => el.name === "w:rPr");
	if (beginRPr && hasSignificantStyling(beginRPr)) fieldRunRPr = beginRPr;
	for (let i$1 = beginIndex + 1; i$1 < nodes.length; i$1++) {
		const node = nodes[i$1];
		const fldType = (node.elements?.find((el) => el.name === "w:fldChar"))?.attributes?.["w:fldCharType"];
		const instrTextEl = node.elements?.find((el) => el.name === "w:instrText");
		if (instrTextEl) {
			const fragment = instrTextEl.elements?.[0]?.text || "";
			instrText += shouldInsertSwitchBoundarySpace(instrText, fragment) ? ` ${fragment}` : fragment;
		}
		if (!fieldRunRPr || separateIndex === -1 && fldType !== "end") {
			const rPrNode = node.elements?.find((el) => el.name === "w:rPr");
			if (rPrNode && hasSignificantStyling(rPrNode)) fieldRunRPr = rPrNode;
		}
		if (fldType === "separate") separateIndex = i$1;
		else if (fldType === "end") {
			endIndex = i$1;
			break;
		} else if (separateIndex !== -1 && fldType !== "begin") contentNodes.push(node);
	}
	if (endIndex === -1) return null;
	return {
		fieldType: extractFieldKeyword(instrText),
		instrText: instrText.trim(),
		contentNodes,
		fieldRunRPr,
		endIndex
	};
}
function shouldInsertSwitchBoundarySpace(existingInstruction, nextFragment) {
	return /\w$/.test(existingInstruction) && /^\\/.test(nextFragment) || /(^|\s)\\[#*]$/.test(existingInstruction) && /^\S/.test(nextFragment);
}
function getHeaderFooterFieldPreprocessor(fieldType) {
	switch (fieldType) {
		case "PAGE": return preProcessPageInstruction;
		case "NUMPAGES": return preProcessNumPagesInstruction;
		case "SECTIONPAGES": return preProcessSectionPagesInstruction;
		case "NUMWORDS":
		case "NUMCHARS": return preProcessDocumentStatInstruction;
		default: return null;
	}
}
function hasSignificantStyling(rPrNode) {
	if (!rPrNode?.elements?.length) return false;
	const significantElements = [
		"w:rStyle",
		"w:rFonts",
		"w:sz",
		"w:szCs",
		"w:b",
		"w:bCs",
		"w:i",
		"w:iCs",
		"w:u",
		"w:color",
		"w:highlight",
		"w:strike",
		"w:dstrike",
		"w:caps",
		"w:smallCaps"
	];
	return rPrNode.elements.some((el) => significantElements.includes(el.name));
}
var HEADER_FOOTER_FILENAME_PATTERN = /^(header|footer)\d*\.xml$/i;
var DEFAULT_TAB_INTERVAL_TWIPS$1 = 720;
function collectTextBoxParagraphs(nodes, paragraphs = []) {
	if (!Array.isArray(nodes)) return paragraphs;
	nodes.forEach((node) => {
		if (!node) return;
		if (node.name === "w:p") {
			paragraphs.push(node);
			return;
		}
		if (node.name === "w:tbl") {
			paragraphs.push(...flattenTextBoxTableToParagraphs(node));
			return;
		}
		if (Array.isArray(node.elements)) collectTextBoxParagraphs(node.elements, paragraphs);
	});
	return paragraphs;
}
function flattenTextBoxTableToParagraphs(table) {
	const rows = table.elements?.filter((node) => node?.name === "w:tr") || [];
	if (!rows.length) return [];
	const gridWidths = extractTableGridWidths(table);
	const paragraphs = [];
	rows.forEach((row) => {
		const cells = row.elements?.filter((node) => node?.name === "w:tc") || [];
		if (!cells.length) return;
		const columnStarts = buildColumnStarts(cells, gridWidths);
		const cellLines = cells.map((cell) => collectTextBoxTableCellLines(cell));
		const maxLineCount = cellLines.reduce((max, lines) => Math.max(max, lines.length), 0);
		for (let lineIndex = 0; lineIndex < maxLineCount; lineIndex += 1) {
			const lineParts = cellLines.map((lines) => lines[lineIndex] || null);
			if (!lineParts.some((line) => line && hasRenderableLineContent(line.elements))) continue;
			paragraphs.push(buildTableVisualLineParagraph(lineParts, columnStarts));
		}
	});
	return paragraphs;
}
function extractTableGridWidths(table) {
	return (table.elements?.find((node) => node?.name === "w:tblGrid"))?.elements?.filter((node) => node?.name === "w:gridCol").map((node) => toFiniteNumber$3(node.attributes?.["w:w"] ?? node.attributes?.w)).filter((value) => value != null && value > 0) || [];
}
function buildColumnStarts(cells, gridWidths) {
	const starts = [];
	let cursor = 0;
	let gridIndex = 0;
	cells.forEach((cell) => {
		starts.push(cursor);
		const gridSpan = resolveCellGridSpan(cell);
		cursor += resolveCellWidth(cell, gridWidths, gridIndex, gridSpan);
		gridIndex += gridSpan;
	});
	return starts;
}
function resolveCellGridSpan(cell) {
	const gridSpan = (cell.elements?.find((node) => node?.name === "w:tcPr"))?.elements?.find((node) => node?.name === "w:gridSpan");
	const value = toFiniteNumber$3(gridSpan?.attributes?.["w:val"] ?? gridSpan?.attributes?.val);
	return value && value > 0 ? Math.max(1, Math.floor(value)) : 1;
}
function resolveCellWidth(cell, gridWidths, gridIndex, gridSpan) {
	const gridWidth = sumGridWidths(gridWidths, gridIndex, gridSpan);
	if (gridWidth > 0) return gridWidth;
	const tcW = (cell.elements?.find((node) => node?.name === "w:tcPr"))?.elements?.find((node) => node?.name === "w:tcW");
	const width = toFiniteNumber$3(tcW?.attributes?.["w:w"] ?? tcW?.attributes?.w);
	return width && width > 0 ? width : 0;
}
function sumGridWidths(gridWidths, gridIndex, gridSpan) {
	if (!Array.isArray(gridWidths) || gridWidths.length === 0) return 0;
	let width = 0;
	for (let offset = 0; offset < gridSpan; offset += 1) {
		const gridWidth = gridWidths[gridIndex + offset];
		if (gridWidth != null && gridWidth > 0) width += gridWidth;
	}
	return width;
}
function collectTextBoxTableCellLines(cell) {
	const paragraphNodes = [];
	collectTextBoxParagraphsSkippingTables(cell.elements || [], paragraphNodes);
	return paragraphNodes.flatMap((paragraph) => splitTextBoxParagraphIntoVisualLines(paragraph));
}
function collectTextBoxParagraphsSkippingTables(nodes, paragraphs) {
	if (!Array.isArray(nodes)) return;
	nodes.forEach((node) => {
		if (!node) return;
		if (node.name === "w:p") {
			paragraphs.push(node);
			return;
		}
		if (node.name === "w:tbl") return;
		if (Array.isArray(node.elements)) collectTextBoxParagraphsSkippingTables(node.elements, paragraphs);
	});
}
function splitTextBoxParagraphIntoVisualLines(paragraph) {
	const pPr = paragraph.elements?.find((node) => node?.name === "w:pPr") || null;
	const lines = [{
		pPr,
		elements: []
	}];
	const appendToCurrentLine = (element) => {
		lines[lines.length - 1].elements.push(element);
	};
	for (const element of paragraph.elements || []) {
		if (!element || element.name === "w:pPr") continue;
		if (element.name !== "w:r" || !Array.isArray(element.elements)) {
			appendToCurrentLine(carbonCopy(element));
			continue;
		}
		splitRunAroundBreaks(element, appendToCurrentLine, () => {
			lines.push({
				pPr,
				elements: []
			});
		});
	}
	while (lines.length > 1 && !hasRenderableLineContent(lines[lines.length - 1].elements)) lines.pop();
	return lines;
}
function splitRunAroundBreaks(run$1, appendRun, startNewLine) {
	let runElements = [];
	const runProperties = run$1.elements?.filter((node) => node?.name === "w:rPr").map((node) => carbonCopy(node)) || [];
	const flushRun = () => {
		if (!runElements.filter((node) => node?.name !== "w:rPr").length) {
			runElements = runProperties.map((node) => carbonCopy(node));
			return;
		}
		appendRun({
			...carbonCopy(run$1),
			elements: runElements
		});
		runElements = runProperties.map((node) => carbonCopy(node));
	};
	run$1.elements.forEach((child) => {
		if (child?.name === "w:br") {
			flushRun();
			startNewLine();
			return;
		}
		runElements.push(carbonCopy(child));
	});
	flushRun();
}
function buildTableVisualLineParagraph(lineParts, columnStarts) {
	const pPr = buildVisualLineParagraphProperties((lineParts.find((line) => line?.pPr) || lineParts.find(Boolean))?.pPr, lineParts, columnStarts);
	const elements = pPr ? [pPr] : [];
	lineParts.forEach((line, index) => {
		if (!line || !hasRenderableLineContent(line.elements)) return;
		if (index > 0) elements.push(createTabRun());
		elements.push(...line.elements.map((element) => carbonCopy(element)));
	});
	return {
		name: "w:p",
		elements
	};
}
function buildVisualLineParagraphProperties(basePPr, lineParts, columnStarts) {
	const pPr = basePPr ? carbonCopy(basePPr) : {
		name: "w:pPr",
		elements: []
	};
	pPr.elements = (pPr.elements || []).filter((node) => node?.name !== "w:tabs");
	const tabStops = [];
	lineParts.forEach((line, index) => {
		const columnStart = columnStarts[index] || 0;
		if (index > 0 && columnStart > 0 && line && hasRenderableLineContent(line.elements)) tabStops.push(createTabStop(columnStart));
		const sourceTabs = extractTabs(line?.pPr);
		let positionedSourceTabCount = 0;
		sourceTabs.forEach((tab) => {
			const pos = toFiniteNumber$3(tab.attributes?.["w:pos"] ?? tab.attributes?.pos);
			if (pos == null) return;
			positionedSourceTabCount += 1;
			tabStops.push(createTabStop(columnStart + pos, tab.attributes));
		});
		const tabRunCount = countTabRuns(line?.elements);
		for (let tabIndex = positionedSourceTabCount; tabIndex < tabRunCount; tabIndex += 1) tabStops.push(createTabStop(resolveDefaultInternalTabPos(columnStart, tabIndex)));
	});
	if (tabStops.length > 0) pPr.elements.push({
		name: "w:tabs",
		elements: dedupeTabStops(tabStops)
	});
	return pPr.elements.length > 0 ? pPr : null;
}
function extractTabs(pPr) {
	return (pPr?.elements?.find((node) => node?.name === "w:tabs"))?.elements?.filter((node) => node?.name === "w:tab") || [];
}
function countTabRuns(elements = []) {
	return elements.reduce((count, element) => {
		if (element?.name === "w:tab") return count + 1;
		if (Array.isArray(element?.elements)) return count + countTabRuns(element.elements);
		return count;
	}, 0);
}
function resolveDefaultInternalTabPos(columnStart, tabIndex) {
	return columnStart + DEFAULT_TAB_INTERVAL_TWIPS$1 * (tabIndex + 1);
}
function createTabRun() {
	return {
		name: "w:r",
		elements: [{ name: "w:tab" }]
	};
}
function createTabStop(pos, sourceAttributes = {}) {
	return {
		name: "w:tab",
		attributes: {
			...sourceAttributes,
			"w:val": sourceAttributes["w:val"] || sourceAttributes.val || "left",
			"w:pos": String(pos)
		}
	};
}
function dedupeTabStops(tabStops) {
	const seen = /* @__PURE__ */ new Set();
	return tabStops.filter((tab) => {
		const key = `${tab.attributes?.["w:val"] || ""}:${tab.attributes?.["w:pos"] || ""}`;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	}).sort((a, b) => Number(a.attributes?.["w:pos"] || 0) - Number(b.attributes?.["w:pos"] || 0));
}
function hasRenderableLineContent(elements) {
	return elements.some((element) => {
		if (element?.name === "w:tab") return true;
		if (element?.name === "w:t") return true;
		return Array.isArray(element?.elements) && hasRenderableLineContent(element.elements);
	});
}
function toFiniteNumber$3(value) {
	const number = Number(value);
	return Number.isFinite(number) ? number : null;
}
function preProcessTextBoxContent(textBoxContent, params = {}) {
	if (!textBoxContent?.elements) return textBoxContent;
	const clone = carbonCopy(textBoxContent);
	const filename = typeof params.filename === "string" ? params.filename : "";
	if (HEADER_FOOTER_FILENAME_PATTERN.test(filename)) {
		const { processedNodes: processedNodes$1 } = preProcessPageFieldsOnly(clone.elements);
		clone.elements = processedNodes$1;
		return clone;
	}
	const { processedNodes } = preProcessNodesForFldChar(clone.elements, params.docx);
	clone.elements = processedNodes;
	return clone;
}
function halfPointsToPixels(halfPoints) {
	if (halfPoints == null) return void 0;
	const numeric = Number(halfPoints);
	if (!Number.isFinite(numeric)) return void 0;
	const points = numeric / 2;
	return Math.round(points * 96 / 72 * 1e3) / 1e3;
}
function resolveFontFamilyForTextBox(fontFamily, docx) {
	if (!fontFamily) return void 0;
	if (typeof fontFamily === "string") return SuperConverter.toCssFontFamily(fontFamily, docx);
	return resolveDocxFontFamily(fontFamily, docx, SuperConverter.toCssFontFamily);
}
function resolveParagraphPropertiesForTextBox(paragraph, params) {
	const pPr = paragraph.elements?.find((el) => el.name === "w:pPr");
	return resolveParagraphProperties(params, pPr ? translator$129.encode({
		...params,
		nodes: [pPr]
	}) || {} : {}, false, false, null);
}
function extractRunFormatting(rPr, paragraphProperties, params) {
	const resolvedRunProperties = resolveRunProperties(params, rPr ? translator$133.encode({
		...params,
		nodes: [rPr]
	}) || {} : {}, paragraphProperties || {});
	const formatting = {};
	if (resolvedRunProperties.bold) formatting.bold = true;
	if (resolvedRunProperties.italic) formatting.italic = true;
	const colorValue = resolvedRunProperties.color?.val ?? resolvedRunProperties.color?.["w:val"] ?? resolvedRunProperties.color?.["val"];
	if (colorValue && String(colorValue).toLowerCase() !== "auto") formatting.color = String(colorValue).replace("#", "");
	const fontSizePx = halfPointsToPixels(resolvedRunProperties.fontSize);
	if (fontSizePx) formatting.fontSize = fontSizePx;
	const fontFamily = resolveFontFamilyForTextBox(resolvedRunProperties.fontFamily, params.docx);
	if (fontFamily) formatting.fontFamily = fontFamily;
	if (resolvedRunProperties.letterSpacing != null) {
		const letterSpacingPx = Number(twipsToPixels$2(resolvedRunProperties.letterSpacing));
		if (Number.isFinite(letterSpacingPx) && letterSpacingPx !== 0) formatting.letterSpacing = letterSpacingPx;
	}
	return formatting;
}
function extractParagraphAlignment(paragraph) {
	const jc = (paragraph.elements?.find((el) => el.name === "w:pPr"))?.elements?.find((el) => el.name === "w:jc");
	if (!jc) return null;
	const jcVal = jc.attributes?.["val"] || jc.attributes?.["w:val"];
	if (jcVal === "left" || jcVal === "start") return "left";
	if (jcVal === "right" || jcVal === "end") return "right";
	if (jcVal === "center") return "center";
	return null;
}
function extractBodyPrProperties(bodyPr) {
	const bodyPrAttrs = bodyPr?.attributes || {};
	let verticalAlign = "top";
	const anchorAttr = bodyPrAttrs["anchor"];
	if (anchorAttr === "t") verticalAlign = "top";
	else if (anchorAttr === "ctr") verticalAlign = "center";
	else if (anchorAttr === "b") verticalAlign = "bottom";
	const EMU_TO_PX = 96 / 914400;
	const DEFAULT_HORIZONTAL_INSET_EMU = 91440;
	const DEFAULT_VERTICAL_INSET_EMU = 45720;
	const lIns = bodyPrAttrs["lIns"] != null ? parseFloat(bodyPrAttrs["lIns"]) : DEFAULT_HORIZONTAL_INSET_EMU;
	const tIns = bodyPrAttrs["tIns"] != null ? parseFloat(bodyPrAttrs["tIns"]) : DEFAULT_VERTICAL_INSET_EMU;
	const rIns = bodyPrAttrs["rIns"] != null ? parseFloat(bodyPrAttrs["rIns"]) : DEFAULT_HORIZONTAL_INSET_EMU;
	const bIns = bodyPrAttrs["bIns"] != null ? parseFloat(bodyPrAttrs["bIns"]) : DEFAULT_VERTICAL_INSET_EMU;
	const insets = {
		top: tIns * EMU_TO_PX,
		right: rIns * EMU_TO_PX,
		bottom: bIns * EMU_TO_PX,
		left: lIns * EMU_TO_PX
	};
	const wrap$1 = bodyPrAttrs["wrap"] || "square";
	return {
		verticalAlign,
		insets,
		wrap: wrap$1
	};
}
function isValidRelativeHeight(value) {
	return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 4294967295;
}
function parseRelativeHeight(value) {
	if (isValidRelativeHeight(value)) return value;
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	if (!/^\d+$/.test(trimmed)) return null;
	const parsed = Number.parseInt(trimmed, 10);
	if (!Number.isFinite(parsed)) return null;
	if (!Number.isSafeInteger(parsed)) return null;
	return isValidRelativeHeight(parsed) ? parsed : null;
}
var CHART_TYPE_MAP = {
	"c:barChart": "barChart",
	"c:bar3DChart": "barChart",
	"c:lineChart": "lineChart",
	"c:line3DChart": "lineChart",
	"c:pieChart": "pieChart",
	"c:pie3DChart": "pieChart",
	"c:ofPieChart": "ofPieChart",
	"c:areaChart": "areaChart",
	"c:area3DChart": "areaChart",
	"c:scatterChart": "scatterChart",
	"c:bubbleChart": "bubbleChart",
	"c:bubble3DChart": "bubbleChart",
	"c:doughnutChart": "doughnutChart",
	"c:radarChart": "radarChart",
	"c:stockChart": "stockChart",
	"c:surfaceChart": "surfaceChart",
	"c:surface3DChart": "surfaceChart"
};
var CHART_TYPE_NAMES = new Set(Object.keys(CHART_TYPE_MAP));
var findChild$1 = (node, name) => node?.elements?.find((el) => el.name === name);
var findChildren$2 = (node, name) => node?.elements?.filter((el) => el.name === name) ?? [];
var getAttr = (node, attr) => node?.attributes?.[attr];
function normalizeChartTarget(target) {
	let cleaned = target;
	if (cleaned.startsWith("/")) cleaned = cleaned.slice(1);
	if (cleaned.startsWith("./")) cleaned = cleaned.slice(2);
	while (cleaned.startsWith("../")) cleaned = cleaned.slice(3);
	if (!cleaned.startsWith("word/")) cleaned = `word/${cleaned}`;
	return cleaned;
}
function resolveChartPart(docx, chartRelId, filename) {
	if (!chartRelId || !docx) return null;
	const chartRel = findChild$1(docx[`word/_rels/${filename || "document.xml"}.rels`] || docx["word/_rels/document.xml.rels"], "Relationships")?.elements?.find((el) => getAttr(el, "Id") === chartRelId);
	if (!chartRel) return null;
	const target = getAttr(chartRel, "Target");
	if (!target) return null;
	return {
		chartPartPath: normalizeChartTarget(target),
		chartRel
	};
}
function parseChartXml(chartXml) {
	const chartSpace = chartXml?.name === "c:chartSpace" ? chartXml : findChild$1(chartXml, "c:chartSpace");
	const chart = findChild$1(chartSpace, "c:chart");
	if (!chart) return null;
	const plotArea = findChild$1(chart, "c:plotArea");
	if (!plotArea) return null;
	const chartTypeEntry = findChartTypeElement(plotArea);
	if (!chartTypeEntry) return null;
	const { element: chartTypeEl, chartType } = chartTypeEntry;
	const subType = extractGrouping(chartTypeEl);
	const barDirection = extractBarDirection(chartTypeEl);
	const series = parseSeries(chartTypeEl, chartType);
	const categoryAxis = parseAxis(plotArea, "c:catAx");
	const valueAxis = parseAxis(plotArea, "c:valAx");
	const legendPosition = parseLegendPosition(chart);
	const styleId = parseStyleId(chartSpace);
	return {
		chartType,
		...subType && { subType },
		...barDirection && { barDirection },
		series,
		...categoryAxis && { categoryAxis },
		...valueAxis && { valueAxis },
		...legendPosition && { legendPosition },
		...styleId != null && { styleId }
	};
}
function findChartTypeElement(plotArea) {
	for (const el of plotArea.elements || []) if (CHART_TYPE_NAMES.has(el.name)) return {
		element: el,
		chartType: CHART_TYPE_MAP[el.name]
	};
	for (const el of plotArea.elements || []) if (el.name?.startsWith("c:") && el.name.endsWith("Chart")) return {
		element: el,
		chartType: el.name.replace("c:", "")
	};
	return null;
}
function extractGrouping(chartTypeEl) {
	return getAttr(findChild$1(chartTypeEl, "c:grouping"), "val") || void 0;
}
function extractBarDirection(chartTypeEl) {
	const val = getAttr(findChild$1(chartTypeEl, "c:barDir"), "val");
	return val === "col" || val === "bar" ? val : void 0;
}
function parseSeries(chartTypeEl, chartType) {
	return findChildren$2(chartTypeEl, "c:ser").map((seriesEl) => parseOneSeries(seriesEl, chartType));
}
function parseOneSeries(serEl, chartType) {
	const name = extractSeriesName(serEl);
	const categories = extractCachedStrings(findChild$1(serEl, "c:cat"));
	const values = extractCachedNumbers(findChild$1(serEl, "c:val"));
	const xValues = extractCachedNumbers(findChild$1(serEl, "c:xVal"));
	const yValues = extractCachedNumbers(findChild$1(serEl, "c:yVal"));
	const bubbleSizes = extractCachedNumbers(findChild$1(serEl, "c:bubbleSize"));
	if (chartType === "scatterChart" || chartType === "bubbleChart") {
		const parsedCategoryValues = categories.map((value) => Number(value));
		const numericCategoryValues = parsedCategoryValues.every((value) => Number.isFinite(value)) ? parsedCategoryValues : [];
		const seriesXValues = xValues.length ? xValues : numericCategoryValues;
		const seriesYValues = yValues.length ? yValues : values;
		return {
			name,
			categories: categories.length ? categories : seriesXValues.map((value, index) => formatChartLabel(value, index + 1)),
			values: seriesYValues,
			...seriesXValues.length ? { xValues: seriesXValues } : {},
			...chartType === "bubbleChart" && bubbleSizes.length ? { bubbleSizes } : {}
		};
	}
	return {
		name,
		categories,
		values
	};
}
function formatChartLabel(value, fallbackIndex) {
	if (!Number.isFinite(value)) return `Category ${fallbackIndex}`;
	if (Number.isInteger(value)) return String(value);
	return String(Number(value.toFixed(3)));
}
function extractSeriesName(serEl) {
	return findChild$1(findChild$1(findChild$1(findChild$1(findChild$1(serEl, "c:tx"), "c:strRef"), "c:strCache"), "c:pt"), "c:v")?.elements?.[0]?.text ?? `Series ${getAttr(findChild$1(serEl, "c:idx"), "val") ?? ""}`.trim();
}
function extractCachedStrings(parentEl) {
	if (!parentEl) return [];
	const strCache = findChild$1(findChild$1(parentEl, "c:strRef"), "c:strCache");
	const numCache = findChild$1(findChild$1(parentEl, "c:numRef"), "c:numCache");
	const cache = strCache || numCache;
	if (!cache) return [];
	return findChildren$2(cache, "c:pt").sort((a, b) => (Number(getAttr(a, "idx")) || 0) - (Number(getAttr(b, "idx")) || 0)).map((pt) => findChild$1(pt, "c:v")?.elements?.[0]?.text ?? "");
}
function extractCachedNumbers(parentEl) {
	if (!parentEl) return [];
	const numCache = findChild$1(findChild$1(parentEl, "c:numRef"), "c:numCache");
	if (!numCache) return [];
	return findChildren$2(numCache, "c:pt").sort((a, b) => (Number(getAttr(a, "idx")) || 0) - (Number(getAttr(b, "idx")) || 0)).map((pt) => {
		const text$2 = findChild$1(pt, "c:v")?.elements?.[0]?.text;
		const num = Number(text$2);
		return Number.isFinite(num) ? num : 0;
	});
}
function parseAxis(plotArea, axisName) {
	const axis = findChild$1(plotArea, axisName);
	if (!axis) return void 0;
	const title = extractAxisTitle(findChild$1(axis, "c:title"));
	const orientation = getAttr(findChild$1(findChild$1(axis, "c:scaling"), "c:orientation"), "val");
	const config$43 = {};
	if (title) config$43.title = title;
	if (orientation === "minMax" || orientation === "maxMin") config$43.orientation = orientation;
	return Object.keys(config$43).length > 0 ? config$43 : void 0;
}
function extractAxisTitle(titleEl) {
	if (!titleEl) return void 0;
	return findChild$1(findChild$1(findChild$1(findChild$1(findChild$1(titleEl, "c:tx"), "c:rich"), "a:p"), "a:r"), "a:t")?.elements?.[0]?.text || void 0;
}
function parseLegendPosition(chart) {
	const legend = findChild$1(chart, "c:legend");
	if (!legend) return void 0;
	return getAttr(findChild$1(legend, "c:legendPos"), "val") || void 0;
}
function parseStyleId(chartSpace) {
	const altContent = findChild$1(chartSpace, "mc:AlternateContent");
	if (altContent) {
		const val$1 = getAttr(findChild$1(findChild$1(altContent, "mc:Choice"), "c14:style"), "val");
		if (val$1 != null) return Number(val$1);
		const fallbackVal = getAttr(findChild$1(findChild$1(altContent, "mc:Fallback"), "c:style"), "val");
		if (fallbackVal != null) return Number(fallbackVal);
	}
	const val = getAttr(findChild$1(chartSpace, "c:style"), "val");
	return val != null ? Number(val) : void 0;
}
var PARAGRAPH_PROPERTIES_XML_NAME = "w:pPr";
var hasMeaningfulParagraphContent = (elements = []) => elements.some((element) => element?.name && element.name !== PARAGRAPH_PROPERTIES_XML_NAME);
var findParagraphProperties = (elements = []) => elements.find((element) => element?.name === PARAGRAPH_PROPERTIES_XML_NAME) ?? null;
var hasParagraphProperties = (elements = []) => elements.some((element) => element?.name === PARAGRAPH_PROPERTIES_XML_NAME);
var cloneParagraphPropertiesForRenderedResult = (paragraphProperties) => {
	const elements = (paragraphProperties.elements || []).filter((element) => element?.name !== "w:sectPr").map((element) => carbonCopy(element));
	if (elements.length === 0) return null;
	return {
		...carbonCopy(paragraphProperties),
		elements
	};
};
var inheritWrapperParagraphProperties = (blockFieldElement, paragraphProperties) => {
	if (!paragraphProperties) return blockFieldElement;
	const fieldElements = Array.isArray(blockFieldElement?.elements) ? blockFieldElement.elements : [];
	const firstParagraphIndex = fieldElements.findIndex((element) => element?.name === "w:p");
	if (firstParagraphIndex < 0) return blockFieldElement;
	const firstParagraph = fieldElements[firstParagraphIndex];
	const firstParagraphElements = Array.isArray(firstParagraph.elements) ? firstParagraph.elements : [];
	if (hasParagraphProperties(firstParagraphElements)) return blockFieldElement;
	const renderedParagraphProperties = cloneParagraphPropertiesForRenderedResult(paragraphProperties);
	const inheritedFirstParagraph = {
		...firstParagraph,
		elements: renderedParagraphProperties ? [renderedParagraphProperties, ...firstParagraphElements] : firstParagraphElements
	};
	return {
		...blockFieldElement,
		attributes: {
			...blockFieldElement.attributes || {},
			wrapperParagraphProperties: carbonCopy(paragraphProperties)
		},
		elements: fieldElements.map((element, index) => index === firstParagraphIndex ? inheritedFirstParagraph : element)
	};
};
var hoistBlockFieldNodes = (params, paragraphNode) => {
	const paragraphElements = Array.isArray(paragraphNode?.elements) ? paragraphNode.elements : [];
	const blockFieldElements = paragraphElements.filter((element) => BLOCK_FIELD_XML_NAMES.has(element?.name));
	if (blockFieldElements.length === 0) return null;
	const nodes = [];
	const remainingElements = paragraphElements.filter((element) => !BLOCK_FIELD_XML_NAMES.has(element?.name));
	const wrapperParagraphProperties = findParagraphProperties(remainingElements);
	const shouldTransferWrapperProperties = !hasMeaningfulParagraphContent(remainingElements);
	if (hasMeaningfulParagraphContent(remainingElements)) {
		const paragraph = translator.encode({
			...params,
			nodes: [{
				...paragraphNode,
				elements: remainingElements
			}]
		});
		if (paragraph) nodes.push(paragraph);
	}
	blockFieldElements.forEach((blockFieldElement) => {
		const fieldElement = shouldTransferWrapperProperties ? inheritWrapperParagraphProperties(blockFieldElement, wrapperParagraphProperties) : blockFieldElement;
		nodes.push(...params.nodeListHandler.handler({
			...params,
			nodes: [fieldElement],
			path: [...params.path || [], paragraphNode]
		}));
	});
	return nodes;
};
const handleParagraphNode$1 = (params) => {
	const { nodes } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:p") return {
		nodes: [],
		consumed: 0
	};
	const hoistedNodes = hoistBlockFieldNodes(params, nodes[0]);
	if (hoistedNodes) return {
		nodes: hoistedNodes,
		consumed: 1
	};
	const schemaNode = translator.encode(params);
	return {
		nodes: Array.isArray(schemaNode) ? schemaNode : schemaNode ? [schemaNode] : [],
		consumed: 1
	};
};
const paragraphNodeHandlerEntity = {
	handlerName: "paragraphNodeHandler",
	handler: handleParagraphNode$1
};
function stripRunNodeMarks(nodes) {
	if (!Array.isArray(nodes)) return nodes;
	return nodes.map((node) => {
		if (!node || typeof node !== "object") return node;
		const stripped = node.type === "run" && Array.isArray(node.marks) && node.marks.length > 0 ? {
			...node,
			marks: []
		} : node;
		if (Array.isArray(stripped.content)) return {
			...stripped,
			content: stripRunNodeMarks(stripped.content)
		};
		return stripped;
	});
}
function importDrawingMLTextbox({ params, drawingNode, textBoxContent, bodyPr, baseAttrs = {}, paragraphImporter }) {
	if (!textBoxContent) return null;
	const textboxParagraphs = collectTextBoxParagraphs(preProcessTextBoxContent(textBoxContent, params)?.elements || []);
	const importParagraph = typeof paragraphImporter === "function" ? paragraphImporter : (paragraph) => {
		return handleParagraphNode$1({
			...params,
			nodes: [paragraph]
		})?.nodes || [];
	};
	const contentNodes = stripRunNodeMarks(textboxParagraphs.flatMap((paragraph) => {
		const imported = importParagraph(paragraph);
		return Array.isArray(imported) ? imported : imported ? [imported] : [];
	}));
	const { verticalAlign, insets } = extractBodyPrProperties(bodyPr);
	return {
		type: "shapeContainer",
		attrs: {
			...baseAttrs,
			drawingContent: drawingNode
		},
		content: [{
			type: "shapeTextbox",
			attrs: {
				textInsets: {
					top: insets.top,
					right: insets.right,
					bottom: insets.bottom,
					left: insets.left
				},
				textVerticalAlign: verticalAlign,
				attributes: {}
			},
			content: contentNodes
		}]
	};
}
var DRAWING_XML_TAG = "w:drawing";
var SHAPE_URI = "http://schemas.microsoft.com/office/word/2010/wordprocessingShape";
var GROUP_URI = "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup";
var SD_IMAGE_ID_NAMESPACE = "7c9e6679-7425-40de-944b-e07fc1f90ae7";
var normalizeTargetPath$1 = (targetPath = "") => {
	if (!targetPath) return targetPath;
	const trimmed = targetPath.replace(/^\/+/, "");
	if (trimmed.startsWith("word/")) return trimmed;
	if (trimmed.startsWith("media/")) return `word/${trimmed}`;
	return `word/${trimmed}`;
};
var DEFAULT_SHAPE_WIDTH = 100;
var DEFAULT_SHAPE_HEIGHT = 100;
var isDocPrHidden = (docPr) => {
	const hidden = docPr?.attributes?.hidden;
	if (hidden === true || hidden === 1) return true;
	if (hidden == null) return false;
	const normalized = String(hidden).toLowerCase();
	return normalized === "1" || normalized === "true";
};
var extractEffectExtent = (node) => {
	const effectExtent = node?.elements?.find((el) => el.name === "wp:effectExtent");
	if (!effectExtent?.attributes) return null;
	const sanitizeEmuValue = (value) => {
		if (value === null || value === void 0) return 0;
		const numeric = Number(value);
		return Number.isFinite(numeric) ? numeric : 0;
	};
	const left = emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["l"]));
	const top = emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["t"]));
	const right = emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["r"]));
	const bottom = emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["b"]));
	if (!left && !top && !right && !bottom) return null;
	return {
		left,
		top,
		right,
		bottom
	};
};
var buildClipPathFromSrcRect = (srcRectAttrs = {}) => {
	const edges = {
		left: srcRectAttrs.l,
		top: srcRectAttrs.t,
		right: srcRectAttrs.r,
		bottom: srcRectAttrs.b
	};
	let hasValue = false;
	let hasPositive = false;
	const percentEdges = {};
	for (const [edge, value] of Object.entries(edges)) {
		if (value == null) continue;
		const numeric = Number(value);
		if (!Number.isFinite(numeric)) continue;
		hasValue = true;
		if (numeric < 0) return null;
		const percent = Math.max(0, Math.min(100, numeric / 1e3));
		if (percent > 0) hasPositive = true;
		percentEdges[edge] = percent;
	}
	if (!hasValue || !hasPositive) return null;
	return `inset(${percentEdges.top ?? 0}% ${percentEdges.right ?? 0}% ${percentEdges.bottom ?? 0}% ${percentEdges.left ?? 0}%)`;
};
var extractAlphaModFix = (blip) => {
	const alphaModFix = findChildByLocalName(blip?.elements, "alphaModFix");
	const amt = Number(alphaModFix?.attributes?.amt);
	return Number.isFinite(amt) ? { amt } : void 0;
};
var mergeAnchorPaddingIntoWrapDistances = (wrap$1, padding) => {
	if (!wrap$1?.attrs || !padding) return;
	const type = wrap$1.type;
	const mergeVertical = type === "Square" || type === "TopAndBottom";
	const mergeHorizontal = type === "Square" || type === "Tight" || type === "Through";
	if (mergeVertical && wrap$1.attrs.distTop == null && Number.isFinite(padding.top) && padding.top !== 0) wrap$1.attrs.distTop = padding.top;
	if (mergeVertical && wrap$1.attrs.distBottom == null && Number.isFinite(padding.bottom) && padding.bottom !== 0) wrap$1.attrs.distBottom = padding.bottom;
	if (mergeHorizontal && wrap$1.attrs.distLeft == null && Number.isFinite(padding.left) && padding.left !== 0) wrap$1.attrs.distLeft = padding.left;
	if (mergeHorizontal && wrap$1.attrs.distRight == null && Number.isFinite(padding.right) && padding.right !== 0) wrap$1.attrs.distRight = padding.right;
};
function handleImageNode$1(node, params, isAnchor) {
	if (!node) return null;
	const { docx, filename, converter } = params;
	const attributes = node?.attributes || {};
	const { order, originalChildren } = collectPreservedDrawingChildren(node);
	const padding = {
		top: emuToPixels(attributes?.["distT"]),
		bottom: emuToPixels(attributes?.["distB"]),
		left: emuToPixels(attributes?.["distL"]),
		right: emuToPixels(attributes?.["distR"])
	};
	const extent = node?.elements?.find((el) => el.name === "wp:extent");
	const size = {
		width: emuToPixels(extent?.attributes?.cx),
		height: emuToPixels(extent?.attributes?.cy)
	};
	let transformData = {};
	const effectExtent = node?.elements?.find((el) => el.name === "wp:effectExtent");
	if (effectExtent) {
		const sanitizeEmuValue = (value) => {
			if (value === null || value === void 0) return 0;
			const numeric = Number(value);
			return Number.isFinite(numeric) ? numeric : 0;
		};
		transformData.sizeExtension = {
			left: emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["l"])),
			top: emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["t"])),
			right: emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["r"])),
			bottom: emuToPixels(sanitizeEmuValue(effectExtent.attributes?.["b"]))
		};
	}
	const positionHTag = node?.elements?.find((el) => el.name === "wp:positionH");
	const positionH = positionHTag?.elements?.find((el) => el.name === "wp:posOffset");
	const positionHValue = emuToPixels(positionH?.elements[0]?.text);
	const hRelativeFrom = positionHTag?.attributes?.relativeFrom;
	const alignH = positionHTag?.elements?.find((el) => el.name === "wp:align")?.elements?.[0]?.text;
	const positionVTag = node?.elements?.find((el) => el.name === "wp:positionV");
	const positionV = positionVTag?.elements?.find((el) => el.name === "wp:posOffset");
	const positionVValue = emuToPixels(positionV?.elements[0]?.text);
	const vRelativeFrom = positionVTag?.attributes?.relativeFrom;
	const alignV = positionVTag?.elements?.find((el) => el.name === "wp:align")?.elements?.[0]?.text;
	const marginOffset = {
		horizontal: positionHValue,
		top: positionVValue
	};
	const useSimplePos = attributes["simplePos"] === "1" || attributes["simplePos"] === 1 || attributes["simplePos"] === true;
	const simplePosNode = node?.elements?.find((el) => el.name === "wp:simplePos");
	const wrapNode = isAnchor ? node?.elements?.find((el) => [
		"wp:wrapNone",
		"wp:wrapSquare",
		"wp:wrapThrough",
		"wp:wrapTight",
		"wp:wrapTopAndBottom"
	].includes(el.name)) : null;
	const wrap$1 = isAnchor ? {
		type: wrapNode?.name.slice(7) || "None",
		attrs: {}
	} : { type: "Inline" };
	const hasBehindDocAttribute = isAnchor && attributes.behindDoc != null;
	const isBehindDoc = attributes.behindDoc === "1" || attributes.behindDoc === 1 || attributes.behindDoc === true;
	switch (wrap$1.type) {
		case "Square":
			if (wrapNode?.attributes?.wrapText) wrap$1.attrs.wrapText = wrapNode.attributes.wrapText;
			if ("distB" in (wrapNode?.attributes || {})) wrap$1.attrs.distBottom = emuToPixels(wrapNode.attributes.distB);
			if ("distL" in (wrapNode?.attributes || {})) wrap$1.attrs.distLeft = emuToPixels(wrapNode.attributes.distL);
			if ("distR" in (wrapNode?.attributes || {})) wrap$1.attrs.distRight = emuToPixels(wrapNode.attributes.distR);
			if ("distT" in (wrapNode?.attributes || {})) wrap$1.attrs.distTop = emuToPixels(wrapNode.attributes.distT);
			break;
		case "Tight":
		case "Through": {
			if ("distL" in (wrapNode?.attributes || {})) wrap$1.attrs.distLeft = emuToPixels(wrapNode.attributes.distL);
			if ("distR" in (wrapNode?.attributes || {})) wrap$1.attrs.distRight = emuToPixels(wrapNode.attributes.distR);
			if ("distT" in (wrapNode?.attributes || {})) wrap$1.attrs.distTop = emuToPixels(wrapNode.attributes.distT);
			if ("distB" in (wrapNode?.attributes || {})) wrap$1.attrs.distBottom = emuToPixels(wrapNode.attributes.distB);
			if ("wrapText" in (wrapNode?.attributes || {})) wrap$1.attrs.wrapText = wrapNode.attributes.wrapText;
			const polygon = wrapNode?.elements?.find((el) => el.name === "wp:wrapPolygon");
			if (polygon) {
				wrap$1.attrs.polygon = polygonToObj(polygon);
				if (polygon.attributes?.edited !== void 0) wrap$1.attrs.polygonEdited = polygon.attributes.edited;
			}
			break;
		}
		case "TopAndBottom":
			if ("distB" in (wrapNode?.attributes || {})) wrap$1.attrs.distBottom = emuToPixels(wrapNode.attributes.distB);
			if ("distT" in (wrapNode?.attributes || {})) wrap$1.attrs.distTop = emuToPixels(wrapNode.attributes.distT);
			break;
		case "None":
			wrap$1.attrs.behindDoc = isBehindDoc;
			break;
		case "Inline": break;
		default: break;
	}
	if (wrap$1.type === "Square" || wrap$1.type === "Tight" || wrap$1.type === "Through" || wrap$1.type === "TopAndBottom") mergeAnchorPaddingIntoWrapDistances(wrap$1, padding);
	if (hasBehindDocAttribute && wrap$1.attrs) wrap$1.attrs.behindDoc = isBehindDoc;
	const docPr = node.elements.find((el) => el.name === "wp:docPr");
	const isHidden = isDocPrHidden(docPr);
	let anchorData = null;
	if (hRelativeFrom || alignH || vRelativeFrom || alignV) anchorData = {
		hRelativeFrom,
		vRelativeFrom,
		alignH,
		alignV
	};
	const graphicData = findChildByLocalName(findChildByLocalName(node.elements, "graphic")?.elements, "graphicData");
	const { uri } = graphicData?.attributes || {};
	if (!graphicData) return null;
	if (uri === SHAPE_URI) return handleShapeDrawing(params, node, graphicData, size, padding, {
		left: positionHValue,
		horizontal: positionHValue,
		top: positionVValue
	}, anchorData, wrap$1, isAnchor, isHidden);
	if (uri === GROUP_URI) return handleShapeGroup(params, node, graphicData, size, padding, {
		left: positionHValue,
		horizontal: positionHValue,
		top: positionVValue
	}, anchorData, wrap$1, isHidden);
	if (uri === "http://schemas.openxmlformats.org/drawingml/2006/chart") return handleChartDrawing(params, node, graphicData, size, padding, marginOffset, anchorData, wrap$1, isAnchor);
	const picture = graphicData?.elements.find((el) => el.name === "pic:pic");
	if (!picture || !picture.elements) return null;
	const blipFill = picture.elements.find((el) => el.name === "pic:blipFill");
	const blip = findChildByLocalName(blipFill?.elements, "blip");
	if (!blip) return null;
	const hasGrayscale = someChildHasLocalName(blip.elements, "grayscl");
	const lumEl = findChildByLocalName(blip.elements, "lum");
	const rawBright = Number(lumEl?.attributes?.bright);
	const rawContrast = Number(lumEl?.attributes?.contrast);
	const lum = Number.isFinite(rawBright) || Number.isFinite(rawContrast) ? {
		...Number.isFinite(rawBright) ? { bright: rawBright } : {},
		...Number.isFinite(rawContrast) ? { contrast: rawContrast } : {}
	} : void 0;
	const alphaModFix = extractAlphaModFix(blip);
	const stretch = findChildByLocalName(blipFill?.elements, "stretch");
	const fillRect = findChildByLocalName(stretch?.elements, "fillRect");
	const srcRect = findChildByLocalName(blipFill?.elements, "srcRect");
	const srcRectAttrs = srcRect?.attributes || {};
	const clipPath = buildClipPathFromSrcRect(srcRectAttrs);
	const srcRectHasNegativeValues = [
		"l",
		"t",
		"r",
		"b"
	].some((attr) => {
		const val = srcRectAttrs[attr];
		return val != null && parseFloat(val) < 0;
	});
	const shouldStretch = Boolean(stretch && fillRect);
	const shouldCover = shouldStretch && !srcRectHasNegativeValues && !clipPath;
	const shouldFillClippedStretch = shouldStretch && !srcRectHasNegativeValues && Boolean(clipPath);
	const spPr = picture.elements.find((el) => el.name === "pic:spPr");
	if (spPr) {
		const xfrm = findChildByLocalName(spPr.elements, "xfrm");
		if (xfrm?.attributes) transformData = {
			...transformData,
			rotation: rotToDegrees(xfrm.attributes["rot"]),
			verticalFlip: xfrm.attributes["flipV"] === "1",
			horizontalFlip: xfrm.attributes["flipH"] === "1"
		};
	}
	const nvPicPr = picture.elements.find((el) => el.name === "pic:nvPicPr");
	const cNvPicPr = nvPicPr?.elements?.find((el) => el.name === "pic:cNvPicPr");
	const picLocks = findChildByLocalName(cNvPicPr?.elements, "picLocks");
	const lockAspectRatio = picLocks ? picLocks.attributes?.["noChangeAspect"] === "1" || picLocks.attributes?.["noChangeAspect"] === 1 : false;
	const cNvPr = nvPicPr?.elements?.find((el) => el.name === "pic:cNvPr");
	const hlinkClick = findChildByLocalName(cNvPr?.elements, "hlinkClick") || findChildByLocalName(docPr?.elements, "hlinkClick");
	let hyperlink = null;
	if (hlinkClick?.attributes?.["r:id"]) {
		const hlinkRId = hlinkClick.attributes["r:id"];
		let hlinkRels = docx[`word/_rels/${filename || "document.xml"}.rels`];
		if (!hlinkRels) hlinkRels = docx[`word/_rels/document.xml.rels`];
		const hlinkRel = (hlinkRels?.elements?.find((el) => el.name === "Relationships"))?.elements?.find((el) => el.attributes?.["Id"] === hlinkRId);
		if (hlinkRel?.attributes?.["Target"]) {
			hyperlink = { url: hlinkRel.attributes["Target"] };
			if (hlinkClick.attributes?.["tooltip"]) hyperlink.tooltip = hlinkClick.attributes["tooltip"];
		}
	}
	let decorative = false;
	const docPrExtLst = findChildByLocalName(docPr?.elements, "extLst");
	if (docPrExtLst) for (const ext of docPrExtLst.elements || []) {
		if (!hasLocalName(ext, "ext")) continue;
		const decEl = findChildByLocalName(ext.elements, "decorative");
		if (decEl && (decEl.attributes?.["val"] === "1" || decEl.attributes?.["val"] === 1)) {
			decorative = true;
			break;
		}
	}
	const { attributes: blipAttributes = {} } = blip;
	const rEmbed = blipAttributes["r:embed"];
	if (!rEmbed) return null;
	const currentFile = filename || "document.xml";
	let rels = docx[`word/_rels/${currentFile}.rels`];
	if (!rels) rels = docx[`word/_rels/document.xml.rels`];
	const { elements } = rels?.elements.find((el) => el.name === "Relationships") || [];
	const rel = elements?.find((el) => el.attributes["Id"] === rEmbed);
	if (!rel) return null;
	const { attributes: relAttributes } = rel;
	const targetPath = relAttributes["Target"];
	const path = normalizeTargetPath$1(targetPath);
	const extension$1 = path.substring(path.lastIndexOf(".") + 1);
	let finalSrc = path;
	let finalExtension = extension$1;
	let wasConverted = false;
	if (isMetafileExtension(extension$1)) {
		const mediaData = converter?.media?.[path];
		if (mediaData) {
			if (converter?.domEnvironment) setMetafileDomEnvironment(converter.domEnvironment);
			const conversionResult = convertMetafileToSvg(mediaData, extension$1, size);
			if (conversionResult?.dataUri) {
				finalSrc = conversionResult.dataUri;
				finalExtension = conversionResult.format || "svg";
				wasConverted = true;
			}
		}
	}
	if (!wasConverted && isTiffExtension(extension$1)) {
		const mediaData = converter?.media?.[path];
		if (mediaData) {
			if (converter?.domEnvironment) setTiffDomEnvironment(converter.domEnvironment);
			const conversionResult = convertTiffToPng(mediaData);
			if (conversionResult?.dataUri) {
				finalSrc = conversionResult.dataUri;
				finalExtension = conversionResult.format || "png";
				wasConverted = true;
			}
		}
	}
	const wrapValue = wrap$1;
	const relativeHeight = isAnchor ? parseRelativeHeight(attributes["relativeHeight"]) : null;
	return {
		type: "image",
		attrs: {
			sdImageId: v5_default(`${currentFile}:${rEmbed}:${docPr?.attributes?.id ?? ""}`, SD_IMAGE_ID_NAMESPACE),
			relativeHeight,
			src: finalSrc,
			alt: (isMetafileExtension(extension$1) || isTiffExtension(extension$1)) && !wasConverted ? "Unable to render image" : docPr?.attributes?.name || "Image",
			extension: finalExtension,
			...wasConverted && {
				originalSrc: path,
				originalExtension: extension$1
			},
			id: docPr?.attributes?.id || "",
			title: docPr?.attributes?.descr || "Image",
			...isHidden ? { hidden: true } : {},
			inline: true,
			padding,
			marginOffset,
			size,
			anchorData,
			isAnchor,
			transformData,
			...useSimplePos && { simplePos: {
				x: simplePosNode.attributes?.x,
				y: simplePosNode.attributes?.y
			} },
			wrap: wrapValue,
			...wrap$1.type === "Square" && wrap$1.attrs.wrapText ? { wrapText: wrap$1.attrs.wrapText } : {},
			wrapTopAndBottom: wrap$1.type === "TopAndBottom",
			shouldCover,
			...shouldFillClippedStretch ? { objectFit: "fill" } : {},
			...clipPath ? { clipPath } : {},
			rawSrcRect: srcRect,
			originalPadding: {
				distT: attributes["distT"],
				distB: attributes["distB"],
				distL: attributes["distL"],
				distR: attributes["distR"]
			},
			originalAttributes: node.attributes,
			rId: relAttributes["Id"],
			lockAspectRatio,
			decorative,
			hyperlink,
			...order.length ? { drawingChildOrder: order } : {},
			...originalChildren.length ? { originalDrawingChildren: originalChildren } : {},
			...hasGrayscale ? { grayscale: true } : {},
			...lum ? { lum } : {},
			...alphaModFix ? { alphaModFix } : {}
		}
	};
}
var handleShapeDrawing = (params, node, graphicData, size, padding, marginOffset, anchorData, wrap$1, isAnchor, isHidden) => {
	const wsp = graphicData.elements.find((el) => el.name === "wps:wsp");
	const textBoxContent = wsp.elements.find((el) => el.name === "wps:txbx")?.elements?.find((el) => el.name === "w:txbxContent");
	const spPr = wsp.elements.find((el) => el.name === "wps:spPr");
	const shapeType = findChildByLocalName(spPr?.elements, "prstGeom")?.attributes["prst"];
	const custGeom = !shapeType ? extractCustomGeometry(spPr) : null;
	if (shapeType || custGeom) {
		const result = getVectorShape({
			params,
			node,
			graphicData,
			size,
			marginOffset,
			anchorData,
			wrap: wrap$1,
			isAnchor,
			customGeometry: custGeom
		});
		if (result?.attrs && isHidden) result.attrs.hidden = true;
		if (result) return result;
	}
	if ((wsp.elements?.find((el) => el.name === "wps:cNvSpPr"))?.attributes?.["txBox"] === "1" && textBoxContent) {
		const bodyPr = wsp.elements?.find((el) => el.name === "wps:bodyPr");
		const drawingNode = params.nodes?.[0];
		const result = importDrawingMLTextbox({
			params,
			drawingNode: drawingNode?.name === "w:drawing" ? drawingNode : null,
			textBoxContent,
			bodyPr,
			baseAttrs: {
				width: size?.width,
				height: size?.height,
				marginOffset,
				anchorData,
				wrap: wrap$1,
				isAnchor,
				isTextBox: true,
				originalAttributes: node?.attributes,
				...params.nodes?.[0]?.name === "w:drawing" ? { drawingContent: params.nodes[0] } : {}
			},
			paragraphImporter: params?.nodeListHandler != null ? void 0 : (paragraph) => {
				const imported = paragraphToPmParagraph(paragraph, params);
				return Array.isArray(imported) ? imported : imported ? [imported] : [];
			}
		});
		if (result?.attrs && isHidden) result.attrs.hidden = true;
		if (result) return result;
	}
	const placeholder = buildShapePlaceholder(node, size, padding, marginOffset, textBoxContent ? "textbox" : "drawing");
	if (placeholder?.attrs && isHidden) placeholder.attrs.hidden = true;
	return placeholder;
};
function collectPreservedDrawingChildren(node) {
	const order = [];
	const original = [];
	if (!Array.isArray(node?.elements)) return {
		order,
		originalChildren: original
	};
	node.elements.forEach((child, index) => {
		if (!child) return;
		const name = child.name ?? null;
		order.push(name);
		original.push({
			index,
			xml: carbonCopy(child)
		});
	});
	return {
		order,
		originalChildren: original
	};
}
var handleShapeGroup = (params, node, graphicData, size, padding, marginOffset, anchorData, wrap$1, isHidden) => {
	const wgp = graphicData.elements.find((el) => el.name === "wpg:wgp");
	if (!wgp) {
		const placeholder = buildShapePlaceholder(node, size, padding, marginOffset, "group");
		if (placeholder?.attrs && isHidden) placeholder.attrs.hidden = true;
		return placeholder;
	}
	const xfrm = findChildByLocalName(wgp.elements.find((el) => el.name === "wpg:grpSpPr")?.elements, "xfrm");
	const groupTransform = {};
	if (xfrm) {
		const off = findChildByLocalName(xfrm.elements, "off");
		const ext = findChildByLocalName(xfrm.elements, "ext");
		const chOff = findChildByLocalName(xfrm.elements, "chOff");
		const chExt = findChildByLocalName(xfrm.elements, "chExt");
		if (off) {
			groupTransform.x = emuToPixels(off.attributes?.["x"] || 0);
			groupTransform.y = emuToPixels(off.attributes?.["y"] || 0);
		}
		if (ext) {
			groupTransform.width = emuToPixels(ext.attributes?.["cx"] || 0);
			groupTransform.height = emuToPixels(ext.attributes?.["cy"] || 0);
		}
		if (chOff) {
			groupTransform.childX = emuToPixels(chOff.attributes?.["x"] || 0);
			groupTransform.childY = emuToPixels(chOff.attributes?.["y"] || 0);
			groupTransform.childOriginXEmu = parseFloat(chOff.attributes?.["x"] || 0);
			groupTransform.childOriginYEmu = parseFloat(chOff.attributes?.["y"] || 0);
		}
		if (chExt) {
			groupTransform.childWidth = emuToPixels(chExt.attributes?.["cx"] || 0);
			groupTransform.childHeight = emuToPixels(chExt.attributes?.["cy"] || 0);
		}
	}
	const childShapes = wgp.elements.filter((el) => el.name === "wps:wsp");
	const childPictures = wgp.elements.filter((el) => el.name === "pic:pic");
	const shapes = childShapes.map((wsp) => {
		const spPr = wsp.elements?.find((el) => el.name === "wps:spPr");
		if (!spPr) return null;
		const shapeKind = findChildByLocalName(spPr.elements, "prstGeom")?.attributes?.["prst"];
		const customGeom = !shapeKind ? extractCustomGeometry(spPr) : null;
		const shapeXfrm = findChildByLocalName(spPr.elements, "xfrm");
		const shapeOff = findChildByLocalName(shapeXfrm?.elements, "off");
		const shapeExt = findChildByLocalName(shapeXfrm?.elements, "ext");
		const rawX = shapeOff?.attributes?.["x"] ? parseFloat(shapeOff.attributes["x"]) : 0;
		const rawY = shapeOff?.attributes?.["y"] ? parseFloat(shapeOff.attributes["y"]) : 0;
		const rawWidth = shapeExt?.attributes?.["cx"] ? parseFloat(shapeExt.attributes["cx"]) : 914400;
		const rawHeight = shapeExt?.attributes?.["cy"] ? parseFloat(shapeExt.attributes["cy"]) : 914400;
		let x, y, width, height;
		if (groupTransform.childWidth && groupTransform.childHeight) {
			const scaleX = groupTransform.width / groupTransform.childWidth;
			const scaleY = groupTransform.height / groupTransform.childHeight;
			const childOriginX = groupTransform.childOriginXEmu || 0;
			const childOriginY = groupTransform.childOriginYEmu || 0;
			x = groupTransform.x + emuToPixels((rawX - childOriginX) * scaleX);
			y = groupTransform.y + emuToPixels((rawY - childOriginY) * scaleY);
			width = emuToPixels(rawWidth * scaleX);
			height = emuToPixels(rawHeight * scaleY);
		} else {
			x = emuToPixels(rawX);
			y = emuToPixels(rawY);
			width = emuToPixels(rawWidth);
			height = emuToPixels(rawHeight);
		}
		const rotation = shapeXfrm?.attributes?.["rot"] ? rotToDegrees(shapeXfrm.attributes["rot"]) : 0;
		const flipH = shapeXfrm?.attributes?.["flipH"] === "1";
		const flipV = shapeXfrm?.attributes?.["flipV"] === "1";
		const style = wsp.elements?.find((el) => el.name === "wps:style");
		const fillColor = extractFillColor(spPr, style);
		const strokeColor = extractStrokeColor(spPr, style);
		const strokeWidth = extractStrokeWidth(spPr);
		const lineEnds = extractLineEnds(spPr);
		const cNvPr = wsp.elements?.find((el) => el.name === "wps:cNvPr");
		const shapeId = cNvPr?.attributes?.["id"];
		const shapeName = cNvPr?.attributes?.["name"];
		const textBoxContent = (wsp.elements?.find((el) => el.name === "wps:txbx"))?.elements?.find((el) => el.name === "w:txbxContent");
		const bodyPr = wsp.elements?.find((el) => el.name === "wps:bodyPr");
		let textContent = null;
		if (textBoxContent) textContent = extractTextFromTextBox(textBoxContent, bodyPr, params);
		const textAlign = textContent?.horizontalAlign || "left";
		return {
			shapeType: "vectorShape",
			attrs: {
				kind: shapeKind,
				customGeometry: customGeom || void 0,
				x,
				y,
				width,
				height,
				rotation,
				flipH,
				flipV,
				fillColor,
				strokeColor,
				strokeWidth,
				lineEnds,
				shapeId,
				shapeName,
				textContent,
				textAlign,
				textVerticalAlign: textContent?.verticalAlign,
				textInsets: textContent?.insets
			}
		};
	}).filter(Boolean);
	const allShapes = [...childPictures.map((pic) => {
		const spPr = pic.elements?.find((el) => el.name === "pic:spPr");
		if (!spPr) return null;
		const xfrm$1 = findChildByLocalName(spPr.elements, "xfrm");
		const off = findChildByLocalName(xfrm$1?.elements, "off");
		const ext = findChildByLocalName(xfrm$1?.elements, "ext");
		const rawX = off?.attributes?.["x"] ? parseFloat(off.attributes["x"]) : 0;
		const rawY = off?.attributes?.["y"] ? parseFloat(off.attributes["y"]) : 0;
		const rawWidth = ext?.attributes?.["cx"] ? parseFloat(ext.attributes["cx"]) : 914400;
		const rawHeight = ext?.attributes?.["cy"] ? parseFloat(ext.attributes["cy"]) : 914400;
		let x, y, width, height;
		if (groupTransform.childWidth && groupTransform.childHeight) {
			const scaleX = groupTransform.width / groupTransform.childWidth;
			const scaleY = groupTransform.height / groupTransform.childHeight;
			const childOriginX = groupTransform.childOriginXEmu || 0;
			const childOriginY = groupTransform.childOriginYEmu || 0;
			x = groupTransform.x + emuToPixels((rawX - childOriginX) * scaleX);
			y = groupTransform.y + emuToPixels((rawY - childOriginY) * scaleY);
			width = emuToPixels(rawWidth * scaleX);
			height = emuToPixels(rawHeight * scaleY);
		} else {
			x = emuToPixels(rawX);
			y = emuToPixels(rawY);
			width = emuToPixels(rawWidth);
			height = emuToPixels(rawHeight);
		}
		const blipFill = pic.elements?.find((el) => el.name === "pic:blipFill");
		const blip = findChildByLocalName(blipFill?.elements, "blip");
		if (!blip) return null;
		const alphaModFix = extractAlphaModFix(blip);
		const rEmbed = blip.attributes?.["r:embed"];
		if (!rEmbed) return null;
		const currentFile = params.filename || "document.xml";
		let rels = params.docx[`word/_rels/${currentFile}.rels`];
		if (!rels) rels = params.docx[`word/_rels/document.xml.rels`];
		const { elements } = rels?.elements.find((el) => el.name === "Relationships") || [];
		const rel = elements?.find((el) => el.attributes["Id"] === rEmbed);
		if (!rel) return null;
		const path = normalizeTargetPath$1(rel.attributes?.["Target"]);
		const cNvPr = (pic.elements?.find((el) => el.name === "pic:nvPicPr"))?.elements?.find((el) => el.name === "pic:cNvPr");
		const picId = cNvPr?.attributes?.["id"];
		const picName = cNvPr?.attributes?.["name"];
		return {
			shapeType: "image",
			attrs: {
				x,
				y,
				width,
				height,
				src: path,
				imageId: picId,
				imageName: picName,
				...alphaModFix ? { alphaModFix } : {}
			}
		};
	}).filter(Boolean), ...shapes];
	const schemaAttrs = {};
	const drawingNode = params.nodes?.[0];
	if (drawingNode?.name === DRAWING_XML_TAG) schemaAttrs.drawingContent = drawingNode;
	return {
		type: "shapeGroup",
		attrs: {
			...schemaAttrs,
			...isHidden ? { hidden: true } : {},
			groupTransform,
			shapes: allShapes,
			size,
			padding,
			marginOffset,
			anchorData,
			wrap: wrap$1,
			originalAttributes: node?.attributes
		}
	};
};
var handleChartDrawing = (params, node, graphicData, size, padding, marginOffset, anchorData, wrap$1, isAnchor) => {
	const chartRelId = (graphicData?.elements?.find((el) => el.name === "c:chart"))?.attributes?.["r:id"];
	if (!chartRelId) return null;
	const { docx, filename } = params;
	const resolved = resolveChartPart(docx, chartRelId, filename);
	if (!resolved) return null;
	const { chartPartPath } = resolved;
	const chartXml = docx[chartPartPath];
	const chartData = chartXml ? parseChartXml(chartXml) : null;
	const drawingNode = params.nodes?.[0];
	const { order, originalChildren } = collectPreservedDrawingChildren(node);
	return {
		type: "chart",
		attrs: {
			width: size.width || 400,
			height: size.height || 300,
			chartData,
			chartRelId,
			chartPartPath,
			isAnchor,
			anchorData,
			wrap: wrap$1,
			padding,
			marginOffset,
			originalAttributes: node?.attributes,
			originalChildren,
			originalChildOrder: order,
			originalXml: drawingNode ? carbonCopy(drawingNode) : null,
			drawingContent: drawingNode || null
		}
	};
};
function extractTextFromTextBox(textBoxContent, bodyPr, params = {}) {
	if (!textBoxContent || !textBoxContent.elements) return null;
	const paragraphs = collectTextBoxParagraphs(preProcessTextBoxContent(textBoxContent, params)?.elements || []);
	const textParts = [];
	let horizontalAlign = null;
	const appendFieldPart = (fieldType, node, paragraphProperties) => {
		const rPr = node?.elements?.find((el) => el.name === "w:rPr");
		const formatting = extractRunFormatting(rPr, paragraphProperties, params);
		const cachedText = fieldType === "SECTIONPAGES" ? node?.attributes?.resolvedText ?? node?.attributes?.importedCachedText ?? "" : "";
		textParts.push({
			text: cachedText,
			formatting,
			fieldType,
			...node?.attributes?.pageNumberFormat ? { pageNumberFormat: node.attributes.pageNumberFormat } : {}
		});
	};
	const handleRun = (run$1, paragraphProperties) => {
		if (!run$1?.elements) return false;
		const formatting = extractRunFormatting(run$1.elements.find((el) => el.name === "w:rPr"), paragraphProperties, params);
		let hasText = false;
		run$1.elements.forEach((el) => {
			if (el.name === "w:t" || el.name === "w:delText") {
				const textNode = el.elements?.find((n) => n.type === "text");
				if (textNode) {
					hasText = true;
					const cleanedText = typeof textNode.text === "string" ? textNode.text.replace(/\[\[sdspace\]\]/g, " ") : textNode.text;
					textParts.push({
						text: cleanedText,
						formatting
					});
				}
			} else if (el.name === "w:tab") {
				hasText = true;
				textParts.push({
					text: "	",
					formatting
				});
			} else if (el.name === "w:br") {
				hasText = true;
				textParts.push({
					text: "\n",
					formatting: {},
					isLineBreak: true
				});
			} else if (el.name === "sd:autoPageNumber") {
				hasText = true;
				appendFieldPart("PAGE", el, paragraphProperties);
			} else if (el.name === "sd:totalPageNumber") {
				hasText = true;
				appendFieldPart("NUMPAGES", el, paragraphProperties);
			} else if (el.name === "sd:sectionPageCount") {
				hasText = true;
				appendFieldPart("SECTIONPAGES", el, paragraphProperties);
			} else if (el.name === "w:drawing") {
				const inline = el.elements?.find((child) => child?.name === "wp:inline");
				if (inline) {
					const imagePm = handleImageNode$1(inline, {
						...params,
						nodes: [el]
					}, false);
					if (imagePm?.attrs?.src && imagePm.attrs.hidden !== true) {
						hasText = true;
						const sizeAttr = imagePm.attrs.size || imagePm.attrs;
						textParts.push({
							text: "",
							formatting,
							kind: "image",
							src: imagePm.attrs.src,
							extension: imagePm.attrs.extension,
							rId: imagePm.attrs.rId,
							width: typeof sizeAttr?.width === "number" ? sizeAttr.width : void 0,
							height: typeof sizeAttr?.height === "number" ? sizeAttr.height : void 0,
							alt: imagePm.attrs.alt || ""
						});
					}
				}
			}
		});
		return hasText;
	};
	const handleParagraphElement = (el, paragraphProperties) => {
		if (!el) return false;
		if (el.name === "w:r") return handleRun(el, paragraphProperties);
		if (el.name === "sd:autoPageNumber") {
			appendFieldPart("PAGE", el, paragraphProperties);
			return true;
		}
		if (el.name === "sd:totalPageNumber") {
			appendFieldPart("NUMPAGES", el, paragraphProperties);
			return true;
		}
		if (el.name === "sd:sectionPageCount") {
			appendFieldPart("SECTIONPAGES", el, paragraphProperties);
			return true;
		}
		if ((el.name === "w:hyperlink" || el.name === "sd:pageReference") && Array.isArray(el.elements)) {
			let hasText = false;
			el.elements.forEach((child) => {
				if (handleParagraphElement(child, paragraphProperties)) hasText = true;
			});
			return hasText;
		}
		return false;
	};
	paragraphs.forEach((paragraph, paragraphIndex) => {
		const paragraphProperties = resolveParagraphPropertiesForTextBox(paragraph, params);
		if (!horizontalAlign) horizontalAlign = extractParagraphAlignment(paragraph);
		let paragraphHasText = false;
		(paragraph.elements || []).forEach((el) => {
			if (handleParagraphElement(el, paragraphProperties)) paragraphHasText = true;
		});
		if (paragraphIndex < paragraphs.length - 1) textParts.push({
			text: "\n",
			formatting: {},
			isLineBreak: true,
			isEmptyParagraph: !paragraphHasText
		});
	});
	if (textParts.length === 0) return null;
	const { verticalAlign, insets, wrap: wrap$1 } = extractBodyPrProperties(bodyPr);
	return {
		parts: textParts,
		horizontalAlign: horizontalAlign || "left",
		verticalAlign,
		insets,
		wrap: wrap$1
	};
}
var buildShapePlaceholder = (node, size, padding, marginOffset, shapeType) => {
	const attrs = {
		drawingContent: {
			name: DRAWING_XML_TAG,
			elements: [carbonCopy(node)]
		},
		attributes: { "data-shape-type": shapeType }
	};
	if (size && (Number.isFinite(size.width) || Number.isFinite(size.height))) attrs.size = {
		...Number.isFinite(size.width) ? { width: size.width } : {},
		...Number.isFinite(size.height) ? { height: size.height } : {}
	};
	if (padding) {
		const paddingData = {};
		if (Number.isFinite(padding.top)) paddingData["data-padding-top"] = padding.top;
		if (Number.isFinite(padding.right)) paddingData["data-padding-right"] = padding.right;
		if (Number.isFinite(padding.bottom)) paddingData["data-padding-bottom"] = padding.bottom;
		if (Number.isFinite(padding.left)) paddingData["data-padding-left"] = padding.left;
		if (Object.keys(paddingData).length) attrs.attributes = {
			...attrs.attributes,
			...paddingData
		};
	}
	if (marginOffset) {
		const offsetData = {};
		const horizontal = Number.isFinite(marginOffset.horizontal) ? marginOffset.horizontal : Number.isFinite(marginOffset.left) ? marginOffset.left : void 0;
		if (Number.isFinite(horizontal)) offsetData["data-offset-x"] = horizontal;
		if (Number.isFinite(marginOffset.top)) offsetData["data-offset-y"] = marginOffset.top;
		if (Object.keys(offsetData).length) attrs.attributes = {
			...attrs.attributes,
			...offsetData
		};
	}
	return {
		type: "contentBlock",
		attrs
	};
};
function extractFieldInlineNodes(node) {
	if (node?.name === "sd:autoPageNumber") return [{
		type: "page-number",
		attrs: {
			marksAsAttrs: [],
			instruction: "PAGE"
		}
	}];
	if (node?.name === "sd:totalPageNumber") return [{
		type: "total-page-number",
		attrs: {
			marksAsAttrs: [],
			instruction: "NUMPAGES"
		}
	}];
	if (node?.name === "sd:sectionPageCount") {
		const cachedText = node?.attributes?.resolvedText ?? node?.attributes?.importedCachedText ?? "";
		if (!cachedText) return [];
		return [{
			type: "text",
			text: cachedText
		}];
	}
	return [];
}
function extractInlineNodesFromRun(run$1, params) {
	if (!run$1?.elements) return [];
	const nodes = [];
	run$1.elements.forEach((el) => {
		if (el.name === "w:t" || el.name === "w:delText") {
			const textNode = el.elements?.find((n) => n.type === "text");
			if (!textNode || typeof textNode.text !== "string") return;
			const cleanedText = textNode.text.replace(/\[\[sdspace\]\]/g, " ");
			if (cleanedText.length > 0) nodes.push({
				type: "text",
				text: cleanedText
			});
		} else if (el.name === "w:tab") nodes.push({
			type: "text",
			text: "	"
		});
		else if (el.name === "w:br") nodes.push({
			type: "lineBreak",
			attrs: {}
		});
		else if (el.name === "sd:autoPageNumber" || el.name === "sd:totalPageNumber" || el.name === "sd:sectionPageCount") nodes.push(...extractFieldInlineNodes(el));
		else if (el.name === "w:drawing") {
			const inline = el.elements?.find((child) => child?.name === "wp:inline");
			if (!inline) return;
			const imagePm = handleImageNode$1(inline, {
				...params,
				nodes: [el]
			}, false);
			if (imagePm?.type === "image" && imagePm.attrs?.hidden !== true) nodes.push(imagePm);
		}
	});
	return nodes;
}
function paragraphToPmParagraph(paragraph, params) {
	const paragraphNode = collectTextBoxParagraphs([paragraph])[0];
	if (!paragraphNode) return null;
	const paragraphProperties = resolveParagraphPropertiesForTextBox(paragraphNode, params);
	const alignment = extractParagraphAlignment(paragraphNode) || "left";
	const content$2 = [];
	let pendingRunContent = [];
	const flushPendingRun = () => {
		if (pendingRunContent.length === 0) return;
		content$2.push({
			type: "run",
			attrs: {},
			content: pendingRunContent
		});
		pendingRunContent = [];
	};
	(paragraphNode.elements || []).forEach((element) => {
		if (element?.name === "w:r") {
			extractInlineNodesFromRun(element, params).forEach((part) => {
				if (part?.type === "image") {
					flushPendingRun();
					content$2.push(part);
					return;
				}
				pendingRunContent.push(part);
			});
			return;
		}
		if (element?.name?.startsWith("sd:")) {
			const runContent = extractFieldInlineNodes(element);
			if (runContent.length > 0) pendingRunContent.push(...runContent);
		}
	});
	flushPendingRun();
	return {
		type: "paragraph",
		attrs: {
			paragraphProperties,
			textAlign: alignment
		},
		content: content$2,
		marks: []
	};
}
function getVectorShape({ params, node, graphicData, size, marginOffset, anchorData, wrap: wrap$1, isAnchor, customGeometry }) {
	const schemaAttrs = {};
	const drawingNode = params.nodes?.[0];
	if (drawingNode?.name === "w:drawing") schemaAttrs.drawingContent = drawingNode;
	const wsp = graphicData.elements?.find((el) => el.name === "wps:wsp");
	if (!wsp) return null;
	const spPr = wsp.elements?.find((el) => el.name === "wps:spPr");
	if (!spPr) return null;
	const shapeKind = findChildByLocalName(spPr.elements, "prstGeom")?.attributes?.["prst"];
	schemaAttrs.kind = shapeKind;
	if (customGeometry) schemaAttrs.customGeometry = customGeometry;
	else if (!shapeKind) {
		const extracted = extractCustomGeometry(spPr);
		if (extracted) schemaAttrs.customGeometry = extracted;
	}
	const width = size?.width ?? DEFAULT_SHAPE_WIDTH;
	const height = size?.height ?? DEFAULT_SHAPE_HEIGHT;
	const xfrm = findChildByLocalName(spPr.elements, "xfrm");
	const rotation = xfrm?.attributes?.["rot"] ? rotToDegrees(xfrm.attributes["rot"]) : 0;
	const flipH = xfrm?.attributes?.["flipH"] === "1";
	const flipV = xfrm?.attributes?.["flipV"] === "1";
	const style = wsp.elements?.find((el) => el.name === "wps:style");
	const fillColor = extractFillColor(spPr, style);
	const strokeColor = extractStrokeColor(spPr, style);
	const strokeWidth = extractStrokeWidth(spPr);
	const lineEnds = extractLineEnds(spPr);
	const effectExtent = extractEffectExtent(node);
	const textBoxContent = (wsp.elements?.find((el) => el.name === "wps:txbx"))?.elements?.find((el) => el.name === "w:txbxContent");
	const bodyPr = wsp.elements?.find((el) => el.name === "wps:bodyPr");
	const nonVisualShapeProps = wsp.elements?.find((el) => el.name === "wps:cNvSpPr");
	const isWordArt = bodyPr?.attributes?.["fromWordArt"] === "1";
	const isTextBox = nonVisualShapeProps?.attributes?.["txBox"] === "1";
	if (isTextBox && textBoxContent) return importDrawingMLTextbox({
		params,
		drawingNode: drawingNode?.name === "w:drawing" ? drawingNode : null,
		textBoxContent,
		bodyPr,
		baseAttrs: {
			...schemaAttrs,
			width,
			height,
			rotation,
			flipH,
			flipV,
			fillColor,
			strokeColor,
			strokeWidth,
			lineEnds,
			effectExtent,
			marginOffset,
			anchorData,
			wrap: wrap$1,
			isAnchor,
			isWordArt,
			isTextBox,
			originalAttributes: node?.attributes
		},
		paragraphImporter: params?.nodeListHandler != null ? void 0 : (paragraph) => {
			const imported = paragraphToPmParagraph(paragraph, params);
			return Array.isArray(imported) ? imported : imported ? [imported] : [];
		}
	});
	let textContent = null;
	let textAlign = "left";
	if (textBoxContent) {
		textContent = extractTextFromTextBox(textBoxContent, bodyPr, params);
		textAlign = textContent?.horizontalAlign || "left";
	}
	return {
		type: "vectorShape",
		attrs: {
			...schemaAttrs,
			width,
			height,
			rotation,
			flipH,
			flipV,
			fillColor,
			strokeColor,
			strokeWidth,
			lineEnds,
			effectExtent,
			marginOffset,
			anchorData,
			wrap: wrap$1,
			isAnchor,
			textContent,
			textAlign,
			textVerticalAlign: textContent?.verticalAlign,
			textInsets: textContent?.insets,
			isWordArt,
			isTextBox,
			originalAttributes: node?.attributes
		}
	};
}
function handleAnchorNode(params) {
	const { node } = params.extraParams;
	if (node.name !== "wp:anchor") return null;
	return handleImageNode$1(node, params, true);
}
function createDocument(converter, schema, editor, { check = false } = {}) {
	const documentData = converter.getSchema(editor);
	if (documentData) {
		const documentNode = schema.nodeFromJSON(documentData);
		if (check) documentNode.check();
		return documentNode;
	}
	return schema.topNodeType.createAndFill();
}
function getSchemaTypeByName(name, schema) {
	return schema.nodes[name] || schema.marks[name] || null;
}
function cleanSchemaItem(schemaItem) {
	const entries = Object.entries(schemaItem).filter(([key, value]) => {
		if (key === "attrs" && isEmptyObject(value)) return false;
		return value !== null && value !== void 0;
	});
	return Object.fromEntries(entries);
}
function chainableEditorState(transaction, state) {
	let { selection, doc: doc$2, storedMarks } = transaction;
	return {
		...state,
		apply: state.apply.bind(state),
		applyTransaction: state.applyTransaction.bind(state),
		plugins: state.plugins,
		schema: state.schema,
		reconfigure: state.reconfigure.bind(state),
		toJSON: state.toJSON.bind(state),
		get storedMarks() {
			return storedMarks;
		},
		get selection() {
			return selection;
		},
		get doc() {
			return doc$2;
		},
		get tr() {
			selection = transaction.selection;
			doc$2 = transaction.doc;
			storedMarks = transaction.storedMarks;
			return transaction;
		}
	};
}
function getNodeType(nameOrType, schema) {
	if (typeof nameOrType === "string") {
		if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}' in schema.`);
		return schema.nodes[nameOrType];
	}
	return nameOrType;
}
function getMarkType(nameOrType, schema) {
	if (typeof nameOrType === "string") {
		if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}' in schema.`);
		return schema.marks[nameOrType];
	}
	return nameOrType;
}
function defaultBlockAt(match) {
	for (let i$1 = 0; i$1 < match.edgeCount; i$1++) {
		const { type } = match.edge(i$1);
		if (type.isTextblock && !type.hasRequiredAttrs()) return type;
	}
	return null;
}
const findParentNodeClosestToPos = ($pos, predicate) => {
	for (let i$1 = $pos.depth; i$1 > 0; i$1--) {
		const node = $pos.node(i$1);
		if (predicate(node)) return {
			pos: i$1 > 0 ? $pos.before(i$1) : 0,
			start: $pos.start(i$1),
			depth: i$1,
			node
		};
	}
};
const findParentNode = (predicate) => {
	return ({ $from }) => findParentNodeClosestToPos($from, predicate);
};
const isList$1 = (name, extensions) => {
	const extension$1 = extensions.filter((e) => e.type === "node").find((i$1) => i$1.name === name);
	if (!extension$1) return false;
	const group = callOrGet(getExtensionConfigField(extension$1, "group", {
		name: extension$1.name,
		options: extension$1.options,
		storage: extension$1.storage
	}));
	if (typeof group !== "string") return false;
	return group.split(" ").includes("list");
};
function generateDocxListAttributes(listType) {
	const listTypesMap = {
		bulletList: 1,
		orderedList: 2
	};
	return { attributes: { parentAttributes: {
		"w14:paraId": generateDocxRandomId(),
		"w14:textId": generateDocxRandomId(),
		"w:rsidR": generateDocxRandomId(),
		"w:rsidRDefault": generateDocxRandomId(),
		"w:rsidP": generateDocxRandomId(),
		paragraphProperties: {
			type: "element",
			name: "w:pPr",
			elements: [{
				type: "element",
				name: "w:pStyle",
				attributes: { "w:val": "ListParagraph" }
			}, {
				type: "element",
				name: "w:numPr",
				elements: [{
					type: "element",
					name: "w:ilvl",
					attributes: { "w:val": "0" }
				}, {
					type: "element",
					name: "w:numId",
					attributes: { "w:val": listTypesMap[listType] || 0 }
				}]
			}]
		}
	} } };
}
const isTextSelection = (value) => {
	return value instanceof TextSelection;
};
function findMarkInSet(marks, type, attrs = {}) {
	return marks.find((item) => {
		return item.type === type && objectIncludes(item.attrs, attrs);
	});
}
function isMarkInSet(marks, type, attrs = {}) {
	return !!findMarkInSet(marks, type, attrs);
}
function getMarkRange($pos, type, attrs = {}) {
	if (!$pos || !type) return;
	let start = $pos.parent.childAfter($pos.parentOffset);
	if ($pos.parentOffset === start.offset && start.offset !== 0) start = $pos.parent.childBefore($pos.parentOffset);
	if (!start.node) return;
	const mark = findMarkInSet([...start.node.marks], type, attrs);
	if (!mark) return;
	let startIndex = start.index;
	let startPos = $pos.start() + start.offset;
	let endIndex = startIndex + 1;
	let endPos = startPos + start.node.nodeSize;
	findMarkInSet([...start.node.marks], type, attrs);
	while (startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)) {
		startIndex -= 1;
		startPos -= $pos.parent.child(startIndex).nodeSize;
	}
	while (endIndex < $pos.parent.childCount && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attrs)) {
		endPos += $pos.parent.child(endIndex).nodeSize;
		endIndex += 1;
	}
	return {
		from: startPos,
		to: endPos
	};
}
function isMarkActive(state, typeOrName, attrs = {}) {
	const { empty: empty$1, ranges } = state.selection;
	const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
	if (empty$1) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark) => {
		if (!type) return true;
		return type.name === mark.type.name;
	}).find((mark) => objectIncludes(mark.attrs, attrs, { strict: false }));
	let selectionRange = 0;
	const markRanges = [];
	ranges.forEach(({ $from, $to }) => {
		const from = $from.pos;
		const to = $to.pos;
		state.doc.nodesBetween(from, to, (node, pos) => {
			if (!node.isText && !node.marks.length) return;
			const relativeFrom = Math.max(from, pos);
			const relativeTo = Math.min(to, pos + node.nodeSize);
			const range = relativeTo - relativeFrom;
			selectionRange += range;
			markRanges.push(...node.marks.map((mark) => ({
				mark,
				from: relativeFrom,
				to: relativeTo
			})));
		});
	});
	if (selectionRange === 0) return false;
	const matchedRange = markRanges.filter((markRange) => {
		if (!type) return true;
		return type.name === markRange.mark.type.name;
	}).filter((markRange) => objectIncludes(markRange.mark.attrs, attrs, { strict: false })).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
	const excludedRange = markRanges.filter((markRange) => {
		if (!type) return true;
		return markRange.mark.type !== type && markRange.mark.type.excludes(type);
	}).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
	return (matchedRange > 0 ? matchedRange + excludedRange : matchedRange) >= selectionRange;
}
function getMarksBetween(from, to, doc$2) {
	const marks = [];
	if (from === to) doc$2.resolve(from).marks().forEach((mark) => {
		const range = getMarkRange(doc$2.resolve(from - 1), mark.type);
		if (!range) return;
		marks.push({
			mark,
			...range
		});
	});
	else doc$2.nodesBetween(from, to, (node, pos) => {
		if (!node || node?.nodeSize === void 0) return;
		marks.push(...node.marks.map((mark) => ({
			from: pos,
			to: pos + node.nodeSize,
			mark
		})));
	});
	return marks;
}
function getSchemaTypeNameByName(name, schema) {
	if (schema.nodes[name]) return "node";
	if (schema.marks[name]) return "mark";
	return null;
}
function isNodeActive(state, typeOrName, attrs = {}) {
	const { from, to, empty: empty$1 } = state.selection;
	const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
	const nodeRanges = [];
	state.doc.nodesBetween(from, to, (node, pos) => {
		if (node.isText) return;
		const relativeFrom = Math.max(from, pos);
		const relativeTo = Math.min(to, pos + node.nodeSize);
		nodeRanges.push({
			node,
			from: relativeFrom,
			to: relativeTo
		});
	});
	const selectionRange = to - from;
	const matchedNodeRanges = nodeRanges.filter((nodeRange) => {
		if (!type) return true;
		return type.name === nodeRange.node.type.name;
	}).filter((nodeRange) => objectIncludes(nodeRange.node.attrs, attrs, { strict: false }));
	if (empty$1) return !!matchedNodeRanges.length;
	return matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0) >= selectionRange;
}
function isActive(state, name, attrs = {}) {
	if (!name) return isNodeActive(state, null, attrs) || isMarkActive(state, null, attrs);
	const schemaType = getSchemaTypeNameByName(name, state.schema);
	if (schemaType === "node") return isNodeActive(state, name, attrs);
	if (schemaType === "mark") return isMarkActive(state, name, attrs);
	return false;
}
var domIndex = function(node) {
	for (var index = 0;; index++) {
		node = node.previousSibling;
		if (!node) return index;
	}
};
var parentNode = function(node) {
	let parent = node.assignedSlot || node.parentNode;
	return parent && parent.nodeType == 11 ? parent.host : parent;
};
var reusedRange = null;
var textRange = function(node, from, to) {
	let range = reusedRange || (reusedRange = document.createRange());
	range.setEnd(node, to == null ? node.nodeValue.length : to);
	range.setStart(node, from || 0);
	return range;
};
var clearReusedRange = function() {
	reusedRange = null;
};
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
	return targetNode && (scanFor(node, off, targetNode, targetOff, -1) || scanFor(node, off, targetNode, targetOff, 1));
};
var atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node, off, targetNode, targetOff, dir) {
	var _a;
	for (;;) {
		if (node == targetNode && off == targetOff) return true;
		if (off == (dir < 0 ? 0 : nodeSize(node))) {
			let parent = node.parentNode;
			if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
			off = domIndex(node) + (dir < 0 ? 0 : 1);
			node = parent;
		} else if (node.nodeType == 1) {
			let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
			if (child.nodeType == 1 && child.contentEditable == "false") if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
			else return false;
			else {
				node = child;
				off = dir < 0 ? nodeSize(node) : 0;
			}
		} else return false;
	}
}
function nodeSize(node) {
	return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function textNodeBefore$1(node, offset) {
	for (;;) {
		if (node.nodeType == 3 && offset) return node;
		if (node.nodeType == 1 && offset > 0) {
			if (node.contentEditable == "false") return null;
			node = node.childNodes[offset - 1];
			offset = nodeSize(node);
		} else if (node.parentNode && !hasBlockDesc(node)) {
			offset = domIndex(node);
			node = node.parentNode;
		} else return null;
	}
}
function textNodeAfter$1(node, offset) {
	for (;;) {
		if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
		if (node.nodeType == 1 && offset < node.childNodes.length) {
			if (node.contentEditable == "false") return null;
			node = node.childNodes[offset];
			offset = 0;
		} else if (node.parentNode && !hasBlockDesc(node)) {
			offset = domIndex(node) + 1;
			node = node.parentNode;
		} else return null;
	}
}
function isOnEdge(node, offset, parent) {
	for (let atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
		if (node == parent) return true;
		let index = domIndex(node);
		node = node.parentNode;
		if (!node) return false;
		atStart = atStart && index == 0;
		atEnd = atEnd && index == nodeSize(node);
	}
}
function hasBlockDesc(dom) {
	let desc;
	for (let cur = dom; cur; cur = cur.parentNode) if (desc = cur.pmViewDesc) break;
	return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
var selectionCollapsed = function(domSel) {
	return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key) {
	let event = document.createEvent("Event");
	event.initEvent("keydown", true, true);
	event.keyCode = keyCode;
	event.key = event.code = key;
	return event;
}
function deepActiveElement(doc$2) {
	let elt = doc$2.activeElement;
	while (elt && elt.shadowRoot) elt = elt.shadowRoot.activeElement;
	return elt;
}
function caretFromPoint(doc$2, x, y) {
	if (doc$2.caretPositionFromPoint) try {
		let pos = doc$2.caretPositionFromPoint(x, y);
		if (pos) return {
			node: pos.offsetNode,
			offset: Math.min(nodeSize(pos.offsetNode), pos.offset)
		};
	} catch (_) {}
	if (doc$2.caretRangeFromPoint) {
		let range = doc$2.caretRangeFromPoint(x, y);
		if (range) return {
			node: range.startContainer,
			offset: Math.min(nodeSize(range.startContainer), range.startOffset)
		};
	}
}
var nav = typeof navigator != "undefined" ? navigator : null;
var doc = typeof document != "undefined" ? document : null;
var agent = nav && nav.userAgent || "";
var ie_edge = /Edge\/(\d+)/.exec(agent);
var ie_upto10 = /MSIE \d/.exec(agent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
var ie$1 = !!(ie_upto10 || ie_11up || ie_edge);
var ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
var gecko = !ie$1 && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
var _chrome = !ie$1 && /Chrome\/(\d+)/.exec(agent);
var chrome = !!_chrome;
var chrome_version = _chrome ? +_chrome[1] : 0;
var safari = !ie$1 && !!nav && /Apple Computer/.test(nav.vendor);
var ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
var mac$2 = ios || (nav ? /Mac/.test(nav.platform) : false);
var windows$1 = nav ? /Win/.test(nav.platform) : false;
var android = /Android \d/.test(agent);
var webkit = !!doc && "webkitFontSmoothing" in doc.documentElement.style;
var webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function windowRect(doc$2) {
	let vp = doc$2.defaultView && doc$2.defaultView.visualViewport;
	if (vp) return {
		left: 0,
		right: vp.width,
		top: 0,
		bottom: vp.height
	};
	return {
		left: 0,
		right: doc$2.documentElement.clientWidth,
		top: 0,
		bottom: doc$2.documentElement.clientHeight
	};
}
function getSide(value, side) {
	return typeof value == "number" ? value : value[side];
}
function clientRect(node) {
	let rect = node.getBoundingClientRect();
	let scaleX = rect.width / node.offsetWidth || 1;
	let scaleY = rect.height / node.offsetHeight || 1;
	return {
		left: rect.left,
		right: rect.left + node.clientWidth * scaleX,
		top: rect.top,
		bottom: rect.top + node.clientHeight * scaleY
	};
}
function scrollRectIntoView(view, rect, startDOM) {
	let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
	let doc$2 = view.dom.ownerDocument;
	for (let parent = startDOM || view.dom;;) {
		if (!parent) break;
		if (parent.nodeType != 1) {
			parent = parentNode(parent);
			continue;
		}
		let elt = parent;
		let atTop = elt == doc$2.body;
		let bounding = atTop ? windowRect(doc$2) : clientRect(elt);
		let moveX = 0, moveY = 0;
		if (rect.top < bounding.top + getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
		else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
		if (rect.left < bounding.left + getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
		else if (rect.right > bounding.right - getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
		if (moveX || moveY) if (atTop) doc$2.defaultView.scrollBy(moveX, moveY);
		else {
			let startX = elt.scrollLeft, startY = elt.scrollTop;
			if (moveY) elt.scrollTop += moveY;
			if (moveX) elt.scrollLeft += moveX;
			let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
			rect = {
				left: rect.left - dX,
				top: rect.top - dY,
				right: rect.right - dX,
				bottom: rect.bottom - dY
			};
		}
		let pos = atTop ? "fixed" : getComputedStyle(parent).position;
		if (/^(fixed|sticky)$/.test(pos)) break;
		parent = pos == "absolute" ? parent.offsetParent : parentNode(parent);
	}
}
function storeScrollPos(view) {
	let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
	let refDOM, refTop;
	for (let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
		let dom = view.root.elementFromPoint(x, y);
		if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
		let localRect = dom.getBoundingClientRect();
		if (localRect.top >= startY - 20) {
			refDOM = dom;
			refTop = localRect.top;
			break;
		}
	}
	return {
		refDOM,
		refTop,
		stack: scrollStack(view.dom)
	};
}
function scrollStack(dom) {
	let stack = [], doc$2 = dom.ownerDocument;
	for (let cur = dom; cur; cur = parentNode(cur)) {
		stack.push({
			dom: cur,
			top: cur.scrollTop,
			left: cur.scrollLeft
		});
		if (dom == doc$2) break;
	}
	return stack;
}
function resetScrollPos({ refDOM, refTop, stack }) {
	let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
	restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
	for (let i$1 = 0; i$1 < stack.length; i$1++) {
		let { dom, top, left } = stack[i$1];
		if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
		if (dom.scrollLeft != left) dom.scrollLeft = left;
	}
}
var preventScrollSupported = null;
function focusPreventScroll(dom) {
	if (dom.setActive) return dom.setActive();
	if (preventScrollSupported) return dom.focus(preventScrollSupported);
	let stored = scrollStack(dom);
	dom.focus(preventScrollSupported == null ? { get preventScroll() {
		preventScrollSupported = { preventScroll: true };
		return true;
	} } : void 0);
	if (!preventScrollSupported) {
		preventScrollSupported = false;
		restoreScrollStack(stored, 0);
	}
}
function findOffsetInNode(node, coords) {
	let closest, dxClosest = 2e8, coordsClosest, offset = 0;
	let rowBot = coords.top, rowTop = coords.top;
	let firstBelow, coordsBelow;
	for (let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
		let rects;
		if (child.nodeType == 1) rects = child.getClientRects();
		else if (child.nodeType == 3) rects = textRange(child).getClientRects();
		else continue;
		for (let i$1 = 0; i$1 < rects.length; i$1++) {
			let rect = rects[i$1];
			if (rect.top <= rowBot && rect.bottom >= rowTop) {
				rowBot = Math.max(rect.bottom, rowBot);
				rowTop = Math.min(rect.top, rowTop);
				let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
				if (dx < dxClosest) {
					closest = child;
					dxClosest = dx;
					coordsClosest = dx && closest.nodeType == 3 ? {
						left: rect.right < coords.left ? rect.right : rect.left,
						top: coords.top
					} : coords;
					if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
					continue;
				}
			} else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
				firstBelow = child;
				coordsBelow = {
					left: Math.max(rect.left, Math.min(rect.right, coords.left)),
					top: rect.top
				};
			}
			if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
		}
	}
	if (!closest && firstBelow) {
		closest = firstBelow;
		coordsClosest = coordsBelow;
		dxClosest = 0;
	}
	if (closest && closest.nodeType == 3) return findOffsetInText(closest, coordsClosest);
	if (!closest || dxClosest && closest.nodeType == 1) return {
		node,
		offset
	};
	return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node, coords) {
	let len = node.nodeValue.length;
	let range = document.createRange(), result;
	for (let i$1 = 0; i$1 < len; i$1++) {
		range.setEnd(node, i$1 + 1);
		range.setStart(node, i$1);
		let rect = singleRect(range, 1);
		if (rect.top == rect.bottom) continue;
		if (inRect(coords, rect)) {
			result = {
				node,
				offset: i$1 + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
			};
			break;
		}
	}
	range.detach();
	return result || {
		node,
		offset: 0
	};
}
function inRect(coords, rect) {
	return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
	let parent = dom.parentNode;
	if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
	return dom;
}
function posFromElement(view, elt, coords) {
	let { node, offset } = findOffsetInNode(elt, coords), bias = -1;
	if (node.nodeType == 1 && !node.firstChild) {
		let rect = node.getBoundingClientRect();
		bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
	}
	return view.docView.posFromDOM(node, offset, bias);
}
function posFromCaret(view, node, offset, coords) {
	let outsideBlock = -1;
	for (let cur = node, sawBlock = false;;) {
		if (cur == view.dom) break;
		let desc = view.docView.nearestDesc(cur, true), rect;
		if (!desc) return null;
		if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
			if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
				if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
				else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
				sawBlock = true;
			}
			if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) return (desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2) ? desc.posBefore : desc.posAfter;
		}
		cur = desc.dom.parentNode;
	}
	return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function elementFromPoint(element, coords, box) {
	let len = element.childNodes.length;
	if (len && box.top < box.bottom) for (let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i$1 = startI;;) {
		let child = element.childNodes[i$1];
		if (child.nodeType == 1) {
			let rects = child.getClientRects();
			for (let j = 0; j < rects.length; j++) {
				let rect = rects[j];
				if (inRect(coords, rect)) return elementFromPoint(child, coords, rect);
			}
		}
		if ((i$1 = (i$1 + 1) % len) == startI) break;
	}
	return element;
}
function posAtCoords(view, coords) {
	let doc$2 = view.dom.ownerDocument, node, offset = 0;
	let caret = caretFromPoint(doc$2, coords.left, coords.top);
	if (caret) ({node, offset} = caret);
	let elt = (view.root.elementFromPoint ? view.root : doc$2).elementFromPoint(coords.left, coords.top);
	let pos;
	if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
		let box = view.dom.getBoundingClientRect();
		if (!inRect(coords, box)) return null;
		elt = elementFromPoint(view.dom, coords, box);
		if (!elt) return null;
	}
	if (safari) {
		for (let p = elt; node && p; p = parentNode(p)) if (p.draggable) node = void 0;
	}
	elt = targetKludge(elt, coords);
	if (node) {
		if (gecko && node.nodeType == 1) {
			offset = Math.min(offset, node.childNodes.length);
			if (offset < node.childNodes.length) {
				let next = node.childNodes[offset], box;
				if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
			}
		}
		let prev;
		if (webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
		if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
		else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = posFromCaret(view, node, offset, coords);
	}
	if (pos == null) pos = posFromElement(view, elt, coords);
	let desc = view.docView.nearestDesc(elt, true);
	return {
		pos,
		inside: desc ? desc.posAtStart - desc.border : -1
	};
}
function nonZero(rect) {
	return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
	let rects = target.getClientRects();
	if (rects.length) {
		let first = rects[bias < 0 ? 0 : rects.length - 1];
		if (nonZero(first)) return first;
	}
	return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
var BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function coordsAtPos(view, pos, side) {
	let { node, offset, atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
	let supportEmptyRange = webkit || gecko;
	if (node.nodeType == 3) if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
		let rect = singleRect(textRange(node, offset, offset), side);
		if (gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
			let rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
			if (rectBefore.top == rect.top) {
				let rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
				if (rectAfter.top != rect.top) return flattenV(rectAfter, rectAfter.left < rectBefore.left);
			}
		}
		return rect;
	} else {
		let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
		if (side < 0 && !offset) {
			to++;
			takeSide = -1;
		} else if (side >= 0 && offset == node.nodeValue.length) {
			from--;
			takeSide = 1;
		} else if (side < 0) from--;
		else to++;
		return flattenV(singleRect(textRange(node, from, to), takeSide), takeSide < 0);
	}
	if (!view.state.doc.resolve(pos - (atom || 0)).parent.inlineContent) {
		if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
			let before = node.childNodes[offset - 1];
			if (before.nodeType == 1) return flattenH(before.getBoundingClientRect(), false);
		}
		if (atom == null && offset < nodeSize(node)) {
			let after = node.childNodes[offset];
			if (after.nodeType == 1) return flattenH(after.getBoundingClientRect(), true);
		}
		return flattenH(node.getBoundingClientRect(), side >= 0);
	}
	if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
		let before = node.childNodes[offset - 1];
		let target = before.nodeType == 3 ? textRange(before, nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
		if (target) return flattenV(singleRect(target, 1), false);
	}
	if (atom == null && offset < nodeSize(node)) {
		let after = node.childNodes[offset];
		while (after.pmViewDesc && after.pmViewDesc.ignoreForCoords) after = after.nextSibling;
		let target = !after ? null : after.nodeType == 3 ? textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
		if (target) return flattenV(singleRect(target, -1), true);
	}
	return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0);
}
function flattenV(rect, left) {
	if (rect.width == 0) return rect;
	let x = left ? rect.left : rect.right;
	return {
		top: rect.top,
		bottom: rect.bottom,
		left: x,
		right: x
	};
}
function flattenH(rect, top) {
	if (rect.height == 0) return rect;
	let y = top ? rect.top : rect.bottom;
	return {
		top: y,
		bottom: y,
		left: rect.left,
		right: rect.right
	};
}
function withFlushedState(view, state, f) {
	let viewState = view.state, active = view.root.activeElement;
	if (viewState != state) view.updateState(state);
	if (active != view.dom) view.focus();
	try {
		return f();
	} finally {
		if (viewState != state) view.updateState(viewState);
		if (active != view.dom && active) active.focus();
	}
}
function endOfTextblockVertical(view, state, dir) {
	let sel = state.selection;
	let $pos = dir == "up" ? sel.$from : sel.$to;
	return withFlushedState(view, state, () => {
		let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
		for (;;) {
			let nearest = view.docView.nearestDesc(dom, true);
			if (!nearest) break;
			if (nearest.node.isBlock) {
				dom = nearest.contentDOM || nearest.dom;
				break;
			}
			dom = nearest.dom.parentNode;
		}
		let coords = coordsAtPos(view, $pos.pos, 1);
		for (let child = dom.firstChild; child; child = child.nextSibling) {
			let boxes;
			if (child.nodeType == 1) boxes = child.getClientRects();
			else if (child.nodeType == 3) boxes = textRange(child, 0, child.nodeValue.length).getClientRects();
			else continue;
			for (let i$1 = 0; i$1 < boxes.length; i$1++) {
				let box = boxes[i$1];
				if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
			}
		}
		return true;
	});
}
var maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
	let { $head } = state.selection;
	if (!$head.parent.isTextblock) return false;
	let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
	let sel = view.domSelection();
	if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
	if (!maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
	return withFlushedState(view, state, () => {
		let { focusNode: oldNode, focusOffset: oldOff, anchorNode, anchorOffset } = view.domSelectionRange();
		let oldBidiLevel = sel.caretBidiLevel;
		sel.modify("move", dir, "character");
		let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
		let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
		let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
		try {
			sel.collapse(anchorNode, anchorOffset);
			if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
		} catch (_) {}
		if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
		return result;
	});
}
var cachedState = null;
var cachedDir = null;
var cachedResult = false;
function endOfTextblock(view, state, dir) {
	if (cachedState == state && cachedDir == dir) return cachedResult;
	cachedState = state;
	cachedDir = dir;
	return cachedResult = dir == "up" || dir == "down" ? endOfTextblockVertical(view, state, dir) : endOfTextblockHorizontal(view, state, dir);
}
var NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;
var ViewDesc = class {
	constructor(parent, children, dom, contentDOM) {
		this.parent = parent;
		this.children = children;
		this.dom = dom;
		this.contentDOM = contentDOM;
		this.dirty = NOT_DIRTY;
		dom.pmViewDesc = this;
	}
	matchesWidget(widget) {
		return false;
	}
	matchesMark(mark) {
		return false;
	}
	matchesNode(node, outerDeco, innerDeco) {
		return false;
	}
	matchesHack(nodeName) {
		return false;
	}
	parseRule() {
		return null;
	}
	stopEvent(event) {
		return false;
	}
	get size() {
		let size = 0;
		for (let i$1 = 0; i$1 < this.children.length; i$1++) size += this.children[i$1].size;
		return size;
	}
	get border() {
		return 0;
	}
	destroy() {
		this.parent = void 0;
		if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = void 0;
		for (let i$1 = 0; i$1 < this.children.length; i$1++) this.children[i$1].destroy();
	}
	posBeforeChild(child) {
		for (let i$1 = 0, pos = this.posAtStart;; i$1++) {
			let cur = this.children[i$1];
			if (cur == child) return pos;
			pos += cur.size;
		}
	}
	get posBefore() {
		return this.parent.posBeforeChild(this);
	}
	get posAtStart() {
		return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
	}
	get posAfter() {
		return this.posBefore + this.size;
	}
	get posAtEnd() {
		return this.posAtStart + this.size - 2 * this.border;
	}
	localPosFromDOM(dom, offset, bias) {
		if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) if (bias < 0) {
			let domBefore, desc;
			if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
			else {
				while (dom.parentNode != this.contentDOM) dom = dom.parentNode;
				domBefore = dom.previousSibling;
			}
			while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) domBefore = domBefore.previousSibling;
			return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
		} else {
			let domAfter, desc;
			if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
			else {
				while (dom.parentNode != this.contentDOM) dom = dom.parentNode;
				domAfter = dom.nextSibling;
			}
			while (domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this)) domAfter = domAfter.nextSibling;
			return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
		}
		let atEnd;
		if (dom == this.dom && this.contentDOM) atEnd = offset > domIndex(this.contentDOM);
		else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
		else if (this.dom.firstChild) {
			if (offset == 0) for (let search$1 = dom;; search$1 = search$1.parentNode) {
				if (search$1 == this.dom) {
					atEnd = false;
					break;
				}
				if (search$1.previousSibling) break;
			}
			if (atEnd == null && offset == dom.childNodes.length) for (let search$1 = dom;; search$1 = search$1.parentNode) {
				if (search$1 == this.dom) {
					atEnd = true;
					break;
				}
				if (search$1.nextSibling) break;
			}
		}
		return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
	}
	nearestDesc(dom, onlyNodes = false) {
		for (let first = true, cur = dom; cur; cur = cur.parentNode) {
			let desc = this.getDesc(cur), nodeDOM;
			if (desc && (!onlyNodes || desc.node)) if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
			else return desc;
		}
	}
	getDesc(dom) {
		let desc = dom.pmViewDesc;
		for (let cur = desc; cur; cur = cur.parent) if (cur == this) return desc;
	}
	posFromDOM(dom, offset, bias) {
		for (let scan = dom; scan; scan = scan.parentNode) {
			let desc = this.getDesc(scan);
			if (desc) return desc.localPosFromDOM(dom, offset, bias);
		}
		return -1;
	}
	descAt(pos) {
		for (let i$1 = 0, offset = 0; i$1 < this.children.length; i$1++) {
			let child = this.children[i$1], end = offset + child.size;
			if (offset == pos && end != offset) {
				while (!child.border && child.children.length) for (let i$2 = 0; i$2 < child.children.length; i$2++) {
					let inner = child.children[i$2];
					if (inner.size) {
						child = inner;
						break;
					}
				}
				return child;
			}
			if (pos < end) return child.descAt(pos - offset - child.border);
			offset = end;
		}
	}
	domFromPos(pos, side) {
		if (!this.contentDOM) return {
			node: this.dom,
			offset: 0,
			atom: pos + 1
		};
		let i$1 = 0, offset = 0;
		for (let curPos = 0; i$1 < this.children.length; i$1++) {
			let child = this.children[i$1], end = curPos + child.size;
			if (end > pos || child instanceof TrailingHackViewDesc) {
				offset = pos - curPos;
				break;
			}
			curPos = end;
		}
		if (offset) return this.children[i$1].domFromPos(offset - this.children[i$1].border, side);
		for (let prev; i$1 && !(prev = this.children[i$1 - 1]).size && prev instanceof WidgetViewDesc && prev.side >= 0; i$1--);
		if (side <= 0) {
			let prev, enter = true;
			for (;; i$1--, enter = false) {
				prev = i$1 ? this.children[i$1 - 1] : null;
				if (!prev || prev.dom.parentNode == this.contentDOM) break;
			}
			if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
			return {
				node: this.contentDOM,
				offset: prev ? domIndex(prev.dom) + 1 : 0
			};
		} else {
			let next, enter = true;
			for (;; i$1++, enter = false) {
				next = i$1 < this.children.length ? this.children[i$1] : null;
				if (!next || next.dom.parentNode == this.contentDOM) break;
			}
			if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
			return {
				node: this.contentDOM,
				offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length
			};
		}
	}
	parseRange(from, to, base$1 = 0) {
		if (this.children.length == 0) return {
			node: this.contentDOM,
			from,
			to,
			fromOffset: 0,
			toOffset: this.contentDOM.childNodes.length
		};
		let fromOffset = -1, toOffset = -1;
		for (let offset = base$1, i$1 = 0;; i$1++) {
			let child = this.children[i$1], end = offset + child.size;
			if (fromOffset == -1 && from <= end) {
				let childBase = offset + child.border;
				if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
				from = offset;
				for (let j = i$1; j > 0; j--) {
					let prev = this.children[j - 1];
					if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
						fromOffset = domIndex(prev.dom) + 1;
						break;
					}
					from -= prev.size;
				}
				if (fromOffset == -1) fromOffset = 0;
			}
			if (fromOffset > -1 && (end > to || i$1 == this.children.length - 1)) {
				to = end;
				for (let j = i$1 + 1; j < this.children.length; j++) {
					let next = this.children[j];
					if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
						toOffset = domIndex(next.dom);
						break;
					}
					to += next.size;
				}
				if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
				break;
			}
			offset = end;
		}
		return {
			node: this.contentDOM,
			from,
			to,
			fromOffset,
			toOffset
		};
	}
	emptyChildAt(side) {
		if (this.border || !this.contentDOM || !this.children.length) return false;
		let child = this.children[side < 0 ? 0 : this.children.length - 1];
		return child.size == 0 || child.emptyChildAt(side);
	}
	domAfterPos(pos) {
		let { node, offset } = this.domFromPos(pos, 0);
		if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
		return node.childNodes[offset];
	}
	setSelection(anchor, head, view, force = false) {
		let from = Math.min(anchor, head), to = Math.max(anchor, head);
		for (let i$1 = 0, offset = 0; i$1 < this.children.length; i$1++) {
			let child = this.children[i$1], end = offset + child.size;
			if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
			offset = end;
		}
		let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
		let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
		let domSel = view.root.getSelection();
		let selRange = view.domSelectionRange();
		let brKludge = false;
		if ((gecko || safari) && anchor == head) {
			let { node, offset } = anchorDOM;
			if (node.nodeType == 3) {
				brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
				if (brKludge && offset == node.nodeValue.length) for (let scan = node, after; scan; scan = scan.parentNode) {
					if (after = scan.nextSibling) {
						if (after.nodeName == "BR") anchorDOM = headDOM = {
							node: after.parentNode,
							offset: domIndex(after) + 1
						};
						break;
					}
					let desc = scan.pmViewDesc;
					if (desc && desc.node && desc.node.isBlock) break;
				}
			} else {
				let prev = node.childNodes[offset - 1];
				brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
			}
		}
		if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
			let after = selRange.focusNode.childNodes[selRange.focusOffset];
			if (after && after.contentEditable == "false") force = true;
		}
		if (!(force || brKludge && safari) && isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
		let domSelExtended = false;
		if ((domSel.extend || anchor == head) && !(brKludge && gecko)) {
			domSel.collapse(anchorDOM.node, anchorDOM.offset);
			try {
				if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
				domSelExtended = true;
			} catch (_) {}
		}
		if (!domSelExtended) {
			if (anchor > head) {
				let tmp = anchorDOM;
				anchorDOM = headDOM;
				headDOM = tmp;
			}
			let range = document.createRange();
			range.setEnd(headDOM.node, headDOM.offset);
			range.setStart(anchorDOM.node, anchorDOM.offset);
			domSel.removeAllRanges();
			domSel.addRange(range);
		}
	}
	ignoreMutation(mutation) {
		return !this.contentDOM && mutation.type != "selection";
	}
	get contentLost() {
		return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
	}
	markDirty(from, to) {
		for (let offset = 0, i$1 = 0; i$1 < this.children.length; i$1++) {
			let child = this.children[i$1], end = offset + child.size;
			if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
				let startInside = offset + child.border, endInside = end - child.border;
				if (from >= startInside && to <= endInside) {
					this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
					if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = NODE_DIRTY;
					else child.markDirty(from - startInside, to - startInside);
					return;
				} else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? CONTENT_DIRTY : NODE_DIRTY;
			}
			offset = end;
		}
		this.dirty = CONTENT_DIRTY;
	}
	markParentsDirty() {
		let level = 1;
		for (let node = this.parent; node; node = node.parent, level++) {
			let dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
			if (node.dirty < dirty) node.dirty = dirty;
		}
	}
	get domAtom() {
		return false;
	}
	get ignoreForCoords() {
		return false;
	}
	get ignoreForSelection() {
		return false;
	}
	isText(text$2) {
		return false;
	}
};
var WidgetViewDesc = class extends ViewDesc {
	constructor(parent, widget, view, pos) {
		let self$1, dom = widget.type.toDOM;
		if (typeof dom == "function") dom = dom(view, () => {
			if (!self$1) return pos;
			if (self$1.parent) return self$1.parent.posBeforeChild(self$1);
		});
		if (!widget.type.spec.raw) {
			if (dom.nodeType != 1) {
				let wrap$1 = document.createElement("span");
				wrap$1.appendChild(dom);
				dom = wrap$1;
			}
			dom.contentEditable = "false";
			dom.classList.add("ProseMirror-widget");
		}
		super(parent, [], dom, null);
		this.widget = widget;
		this.widget = widget;
		self$1 = this;
	}
	matchesWidget(widget) {
		return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
	}
	parseRule() {
		return { ignore: true };
	}
	stopEvent(event) {
		let stop = this.widget.spec.stopEvent;
		return stop ? stop(event) : false;
	}
	ignoreMutation(mutation) {
		return mutation.type != "selection" || this.widget.spec.ignoreSelection;
	}
	destroy() {
		this.widget.type.destroy(this.dom);
		super.destroy();
	}
	get domAtom() {
		return true;
	}
	get ignoreForSelection() {
		return !!this.widget.type.spec.relaxedSide;
	}
	get side() {
		return this.widget.type.side;
	}
};
var CompositionViewDesc = class extends ViewDesc {
	constructor(parent, dom, textDOM, text$2) {
		super(parent, [], dom, null);
		this.textDOM = textDOM;
		this.text = text$2;
	}
	get size() {
		return this.text.length;
	}
	localPosFromDOM(dom, offset) {
		if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
		return this.posAtStart + offset;
	}
	domFromPos(pos) {
		return {
			node: this.textDOM,
			offset: pos
		};
	}
	ignoreMutation(mut) {
		return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
	}
};
var MarkViewDesc = class MarkViewDesc extends ViewDesc {
	constructor(parent, mark, dom, contentDOM, spec) {
		super(parent, [], dom, contentDOM);
		this.mark = mark;
		this.spec = spec;
	}
	static create(parent, mark, inline, view) {
		let custom = view.nodeViews[mark.type.name];
		let spec = custom && custom(mark, view, inline);
		if (!spec || !spec.dom) spec = DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
		return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
	}
	parseRule() {
		if (this.dirty & NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
		return {
			mark: this.mark.type.name,
			attrs: this.mark.attrs,
			contentElement: this.contentDOM
		};
	}
	matchesMark(mark) {
		return this.dirty != NODE_DIRTY && this.mark.eq(mark);
	}
	markDirty(from, to) {
		super.markDirty(from, to);
		if (this.dirty != NOT_DIRTY) {
			let parent = this.parent;
			while (!parent.node) parent = parent.parent;
			if (parent.dirty < this.dirty) parent.dirty = this.dirty;
			this.dirty = NOT_DIRTY;
		}
	}
	slice(from, to, view) {
		let copy$1 = MarkViewDesc.create(this.parent, this.mark, true, view);
		let nodes = this.children, size = this.size;
		if (to < size) nodes = replaceNodes(nodes, to, size, view);
		if (from > 0) nodes = replaceNodes(nodes, 0, from, view);
		for (let i$1 = 0; i$1 < nodes.length; i$1++) nodes[i$1].parent = copy$1;
		copy$1.children = nodes;
		return copy$1;
	}
	ignoreMutation(mutation) {
		return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
	}
	destroy() {
		if (this.spec.destroy) this.spec.destroy();
		super.destroy();
	}
};
var NodeViewDesc = class NodeViewDesc extends ViewDesc {
	constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
		super(parent, [], dom, contentDOM);
		this.node = node;
		this.outerDeco = outerDeco;
		this.innerDeco = innerDeco;
		this.nodeDOM = nodeDOM;
	}
	static create(parent, node, outerDeco, innerDeco, view, pos) {
		let custom = view.nodeViews[node.type.name], descObj;
		let spec = custom && custom(node, view, () => {
			if (!descObj) return pos;
			if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
		}, outerDeco, innerDeco);
		let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
		if (node.isText) {
			if (!dom) dom = document.createTextNode(node.text);
			else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
		} else if (!dom) {
			let spec$1 = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
			({dom, contentDOM} = spec$1);
		}
		if (!contentDOM && !node.isText && dom.nodeName != "BR") {
			if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
			if (node.type.spec.draggable) dom.draggable = true;
		}
		let nodeDOM = dom;
		dom = applyOuterDeco(dom, outerDeco, node);
		if (spec) return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
		else if (node.isText) return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
		else return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
	}
	parseRule() {
		if (this.node.type.spec.reparseInView) return null;
		let rule = {
			node: this.node.type.name,
			attrs: this.node.attrs
		};
		if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
		if (!this.contentDOM) rule.getContent = () => this.node.content;
		else if (!this.contentLost) rule.contentElement = this.contentDOM;
		else {
			for (let i$1 = this.children.length - 1; i$1 >= 0; i$1--) {
				let child = this.children[i$1];
				if (this.dom.contains(child.dom.parentNode)) {
					rule.contentElement = child.dom.parentNode;
					break;
				}
			}
			if (!rule.contentElement) rule.getContent = () => Fragment.empty;
		}
		return rule;
	}
	matchesNode(node, outerDeco, innerDeco) {
		return this.dirty == NOT_DIRTY && node.eq(this.node) && sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
	}
	get size() {
		return this.node.nodeSize;
	}
	get border() {
		return this.node.isLeaf ? 0 : 1;
	}
	updateChildren(view, pos) {
		let inline = this.node.inlineContent, off = pos;
		let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
		let localComposition = composition && composition.pos > -1 ? composition : null;
		let compositionInChild = composition && composition.pos < 0;
		let updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
		iterDeco(this.node, this.innerDeco, (widget, i$1, insideNode) => {
			if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view, i$1);
			else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i$1 == this.node.childCount ? Mark.none : this.node.child(i$1).marks, inline, view, i$1);
			updater.placeWidget(widget, view, off);
		}, (child, outerDeco, innerDeco, i$1) => {
			updater.syncToMarks(child.marks, inline, view, i$1);
			let compIndex;
			if (updater.findNodeMatch(child, outerDeco, innerDeco, i$1));
			else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view));
			else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i$1, off));
			else updater.addNode(child, outerDeco, innerDeco, view, off);
			off += child.nodeSize;
		});
		updater.syncToMarks([], inline, view, 0);
		if (this.node.isTextblock) updater.addTextblockHacks();
		updater.destroyRest();
		if (updater.changed || this.dirty == CONTENT_DIRTY) {
			if (localComposition) this.protectLocalComposition(view, localComposition);
			renderDescs(this.contentDOM, this.children, view);
			if (ios) iosHacks(this.dom);
		}
	}
	localCompositionInfo(view, pos) {
		let { from, to } = view.state.selection;
		if (!(view.state.selection instanceof TextSelection) || from < pos || to > pos + this.node.content.size) return null;
		let textNode = view.input.compositionNode;
		if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
		if (this.node.inlineContent) {
			let text$2 = textNode.nodeValue;
			let textPos = findTextInFragment(this.node.content, text$2, from - pos, to - pos);
			return textPos < 0 ? null : {
				node: textNode,
				pos: textPos,
				text: text$2
			};
		} else return {
			node: textNode,
			pos: -1,
			text: ""
		};
	}
	protectLocalComposition(view, { node, pos, text: text$2 }) {
		if (this.getDesc(node)) return;
		let topNode = node;
		for (;; topNode = topNode.parentNode) {
			if (topNode.parentNode == this.contentDOM) break;
			while (topNode.previousSibling) topNode.parentNode.removeChild(topNode.previousSibling);
			while (topNode.nextSibling) topNode.parentNode.removeChild(topNode.nextSibling);
			if (topNode.pmViewDesc) topNode.pmViewDesc = void 0;
		}
		let desc = new CompositionViewDesc(this, topNode, node, text$2);
		view.input.compositionNodes.push(desc);
		this.children = replaceNodes(this.children, pos, pos + text$2.length, view, desc);
	}
	update(node, outerDeco, innerDeco, view) {
		if (this.dirty == NODE_DIRTY || !node.sameMarkup(this.node)) return false;
		this.updateInner(node, outerDeco, innerDeco, view);
		return true;
	}
	updateInner(node, outerDeco, innerDeco, view) {
		this.updateOuterDeco(outerDeco);
		this.node = node;
		this.innerDeco = innerDeco;
		if (this.contentDOM) this.updateChildren(view, this.posAtStart);
		this.dirty = NOT_DIRTY;
	}
	updateOuterDeco(outerDeco) {
		if (sameOuterDeco(outerDeco, this.outerDeco)) return;
		let needsWrap = this.nodeDOM.nodeType != 1;
		let oldDOM = this.dom;
		this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
		if (this.dom != oldDOM) {
			oldDOM.pmViewDesc = void 0;
			this.dom.pmViewDesc = this;
		}
		this.outerDeco = outerDeco;
	}
	selectNode() {
		if (this.nodeDOM.nodeType == 1) {
			this.nodeDOM.classList.add("ProseMirror-selectednode");
			if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.draggable = true;
		}
	}
	deselectNode() {
		if (this.nodeDOM.nodeType == 1) {
			this.nodeDOM.classList.remove("ProseMirror-selectednode");
			if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.removeAttribute("draggable");
		}
	}
	get domAtom() {
		return this.node.isAtom;
	}
};
function docViewDesc(doc$2, outerDeco, innerDeco, dom, view) {
	applyOuterDeco(dom, outerDeco, doc$2);
	let docView = new NodeViewDesc(void 0, doc$2, outerDeco, innerDeco, dom, dom, dom, view, 0);
	if (docView.contentDOM) docView.updateChildren(view, 0);
	return docView;
}
var TextViewDesc = class TextViewDesc extends NodeViewDesc {
	constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
		super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
	}
	parseRule() {
		let skip = this.nodeDOM.parentNode;
		while (skip && skip != this.dom && !skip.pmIsDeco) skip = skip.parentNode;
		return { skip: skip || true };
	}
	update(node, outerDeco, innerDeco, view) {
		if (this.dirty == NODE_DIRTY || this.dirty != NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
		this.updateOuterDeco(outerDeco);
		if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
			this.nodeDOM.nodeValue = node.text;
			if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
		}
		this.node = node;
		this.dirty = NOT_DIRTY;
		return true;
	}
	inParent() {
		let parentDOM = this.parent.contentDOM;
		for (let n = this.nodeDOM; n; n = n.parentNode) if (n == parentDOM) return true;
		return false;
	}
	domFromPos(pos) {
		return {
			node: this.nodeDOM,
			offset: pos
		};
	}
	localPosFromDOM(dom, offset, bias) {
		if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
		return super.localPosFromDOM(dom, offset, bias);
	}
	ignoreMutation(mutation) {
		return mutation.type != "characterData" && mutation.type != "selection";
	}
	slice(from, to, view) {
		let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
		return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
	}
	markDirty(from, to) {
		super.markDirty(from, to);
		if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = NODE_DIRTY;
	}
	get domAtom() {
		return false;
	}
	isText(text$2) {
		return this.node.text == text$2;
	}
};
var TrailingHackViewDesc = class extends ViewDesc {
	parseRule() {
		return { ignore: true };
	}
	matchesHack(nodeName) {
		return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName;
	}
	get domAtom() {
		return true;
	}
	get ignoreForCoords() {
		return this.dom.nodeName == "IMG";
	}
};
var CustomNodeViewDesc = class extends NodeViewDesc {
	constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
		super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
		this.spec = spec;
	}
	update(node, outerDeco, innerDeco, view) {
		if (this.dirty == NODE_DIRTY) return false;
		if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
			let result = this.spec.update(node, outerDeco, innerDeco);
			if (result) this.updateInner(node, outerDeco, innerDeco, view);
			return result;
		} else if (!this.contentDOM && !node.isLeaf) return false;
		else return super.update(node, outerDeco, innerDeco, view);
	}
	selectNode() {
		this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
	}
	deselectNode() {
		this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
	}
	setSelection(anchor, head, view, force) {
		this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
	}
	destroy() {
		if (this.spec.destroy) this.spec.destroy();
		super.destroy();
	}
	stopEvent(event) {
		return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
	}
	ignoreMutation(mutation) {
		return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
	}
};
function renderDescs(parentDOM, descs, view) {
	let dom = parentDOM.firstChild, written = false;
	for (let i$1 = 0; i$1 < descs.length; i$1++) {
		let desc = descs[i$1], childDOM = desc.dom;
		if (childDOM.parentNode == parentDOM) {
			while (childDOM != dom) {
				dom = rm(dom);
				written = true;
			}
			dom = dom.nextSibling;
		} else {
			written = true;
			parentDOM.insertBefore(childDOM, dom);
		}
		if (desc instanceof MarkViewDesc) {
			let pos = dom ? dom.previousSibling : parentDOM.lastChild;
			renderDescs(desc.contentDOM, desc.children, view);
			dom = pos ? pos.nextSibling : parentDOM.firstChild;
		}
	}
	while (dom) {
		dom = rm(dom);
		written = true;
	}
	if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
var OuterDecoLevel = function(nodeName) {
	if (nodeName) this.nodeName = nodeName;
};
OuterDecoLevel.prototype = Object.create(null);
var noDeco = [new OuterDecoLevel()];
function computeOuterDeco(outerDeco, node, needsWrap) {
	if (outerDeco.length == 0) return noDeco;
	let top = needsWrap ? noDeco[0] : new OuterDecoLevel(), result = [top];
	for (let i$1 = 0; i$1 < outerDeco.length; i$1++) {
		let attrs = outerDeco[i$1].type.attrs;
		if (!attrs) continue;
		if (attrs.nodeName) result.push(top = new OuterDecoLevel(attrs.nodeName));
		for (let name in attrs) {
			let val = attrs[name];
			if (val == null) continue;
			if (needsWrap && result.length == 1) result.push(top = new OuterDecoLevel(node.isInline ? "span" : "div"));
			if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
			else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
			else if (name != "nodeName") top[name] = val;
		}
	}
	return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
	if (prevComputed == noDeco && curComputed == noDeco) return nodeDOM;
	let curDOM = nodeDOM;
	for (let i$1 = 0; i$1 < curComputed.length; i$1++) {
		let deco = curComputed[i$1], prev = prevComputed[i$1];
		if (i$1) {
			let parent;
			if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
			else {
				parent = document.createElement(deco.nodeName);
				parent.pmIsDeco = true;
				parent.appendChild(curDOM);
				prev = noDeco[0];
				curDOM = parent;
			}
		}
		patchAttributes(curDOM, prev || noDeco[0], deco);
	}
	return curDOM;
}
function patchAttributes(dom, prev, cur) {
	for (let name in prev) if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
	for (let name in cur) if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
	if (prev.class != cur.class) {
		let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
		let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
		for (let i$1 = 0; i$1 < prevList.length; i$1++) if (curList.indexOf(prevList[i$1]) == -1) dom.classList.remove(prevList[i$1]);
		for (let i$1 = 0; i$1 < curList.length; i$1++) if (prevList.indexOf(curList[i$1]) == -1) dom.classList.add(curList[i$1]);
		if (dom.classList.length == 0) dom.removeAttribute("class");
	}
	if (prev.style != cur.style) {
		if (prev.style) {
			let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
			while (m = prop.exec(prev.style)) dom.style.removeProperty(m[1]);
		}
		if (cur.style) dom.style.cssText += cur.style;
	}
}
function applyOuterDeco(dom, deco, node) {
	return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
	if (a.length != b.length) return false;
	for (let i$1 = 0; i$1 < a.length; i$1++) if (!a[i$1].type.eq(b[i$1].type)) return false;
	return true;
}
function rm(dom) {
	let next = dom.nextSibling;
	dom.parentNode.removeChild(dom);
	return next;
}
var ViewTreeUpdater = class {
	constructor(top, lock, view) {
		this.lock = lock;
		this.view = view;
		this.index = 0;
		this.stack = [];
		this.changed = false;
		this.top = top;
		this.preMatch = preMatch(top.node.content, top);
	}
	destroyBetween(start, end) {
		if (start == end) return;
		for (let i$1 = start; i$1 < end; i$1++) this.top.children[i$1].destroy();
		this.top.children.splice(start, end - start);
		this.changed = true;
	}
	destroyRest() {
		this.destroyBetween(this.index, this.top.children.length);
	}
	syncToMarks(marks, inline, view, parentIndex) {
		let keep = 0, depth = this.stack.length >> 1;
		let maxKeep = Math.min(depth, marks.length);
		while (keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false) keep++;
		while (keep < depth) {
			this.destroyRest();
			this.top.dirty = NOT_DIRTY;
			this.index = this.stack.pop();
			this.top = this.stack.pop();
			depth--;
		}
		while (depth < marks.length) {
			this.stack.push(this.top, this.index + 1);
			let found$1 = -1, scanTo = this.top.children.length;
			if (parentIndex < this.preMatch.index) scanTo = Math.min(this.index + 3, scanTo);
			for (let i$1 = this.index; i$1 < scanTo; i$1++) {
				let next = this.top.children[i$1];
				if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
					found$1 = i$1;
					break;
				}
			}
			if (found$1 > -1) {
				if (found$1 > this.index) {
					this.changed = true;
					this.destroyBetween(this.index, found$1);
				}
				this.top = this.top.children[this.index];
			} else {
				let markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
				this.top.children.splice(this.index, 0, markDesc);
				this.top = markDesc;
				this.changed = true;
			}
			this.index = 0;
			depth++;
		}
	}
	findNodeMatch(node, outerDeco, innerDeco, index) {
		let found$1 = -1, targetDesc;
		if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found$1 = this.top.children.indexOf(targetDesc, this.index);
		else for (let i$1 = this.index, e = Math.min(this.top.children.length, i$1 + 5); i$1 < e; i$1++) {
			let child = this.top.children[i$1];
			if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
				found$1 = i$1;
				break;
			}
		}
		if (found$1 < 0) return false;
		this.destroyBetween(this.index, found$1);
		this.index++;
		return true;
	}
	updateNodeAt(node, outerDeco, innerDeco, index, view) {
		let child = this.top.children[index];
		if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM) child.dirty = CONTENT_DIRTY;
		if (!child.update(node, outerDeco, innerDeco, view)) return false;
		this.destroyBetween(this.index, index);
		this.index++;
		return true;
	}
	findIndexWithChild(domNode) {
		for (;;) {
			let parent = domNode.parentNode;
			if (!parent) return -1;
			if (parent == this.top.contentDOM) {
				let desc = domNode.pmViewDesc;
				if (desc) {
					for (let i$1 = this.index; i$1 < this.top.children.length; i$1++) if (this.top.children[i$1] == desc) return i$1;
				}
				return -1;
			}
			domNode = parent;
		}
	}
	updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
		for (let i$1 = this.index; i$1 < this.top.children.length; i$1++) {
			let next = this.top.children[i$1];
			if (next instanceof NodeViewDesc) {
				let preMatch$1 = this.preMatch.matched.get(next);
				if (preMatch$1 != null && preMatch$1 != index) return false;
				let nextDOM = next.dom, updated;
				let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
				if (!locked && next.update(node, outerDeco, innerDeco, view)) {
					this.destroyBetween(this.index, i$1);
					if (next.dom != nextDOM) this.changed = true;
					this.index++;
					return true;
				} else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
					this.destroyBetween(this.index, i$1);
					this.top.children[this.index] = updated;
					if (updated.contentDOM) {
						updated.dirty = CONTENT_DIRTY;
						updated.updateChildren(view, pos + 1);
						updated.dirty = NOT_DIRTY;
					}
					this.changed = true;
					this.index++;
					return true;
				}
				break;
			}
		}
		return false;
	}
	recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
		if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
		let wrapper = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
		if (wrapper.contentDOM) {
			wrapper.children = next.children;
			next.children = [];
			for (let ch of wrapper.children) ch.parent = wrapper;
		}
		next.destroy();
		return wrapper;
	}
	addNode(node, outerDeco, innerDeco, view, pos) {
		let desc = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
		if (desc.contentDOM) desc.updateChildren(view, pos + 1);
		this.top.children.splice(this.index++, 0, desc);
		this.changed = true;
	}
	placeWidget(widget, view, pos) {
		let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
		if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
		else {
			let desc = new WidgetViewDesc(this.top, widget, view, pos);
			this.top.children.splice(this.index++, 0, desc);
			this.changed = true;
		}
	}
	addTextblockHacks() {
		let lastChild = this.top.children[this.index - 1], parent = this.top;
		while (lastChild instanceof MarkViewDesc) {
			parent = lastChild;
			lastChild = parent.children[parent.children.length - 1];
		}
		if (!lastChild || !(lastChild instanceof TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
			if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
			this.addHackNode("BR", this.top);
		}
	}
	addHackNode(nodeName, parent) {
		if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
		else {
			let dom = document.createElement(nodeName);
			if (nodeName == "IMG") {
				dom.className = "ProseMirror-separator";
				dom.alt = "";
			}
			if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
			let hack = new TrailingHackViewDesc(this.top, [], dom, null);
			if (parent != this.top) parent.children.push(hack);
			else parent.children.splice(this.index++, 0, hack);
			this.changed = true;
		}
	}
	isLocked(node) {
		return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
	}
};
function preMatch(frag, parentDesc) {
	let curDesc = parentDesc, descI = curDesc.children.length;
	let fI = frag.childCount, matched = /* @__PURE__ */ new Map(), matches$1 = [];
	outer: while (fI > 0) {
		let desc;
		for (;;) if (descI) {
			let next = curDesc.children[descI - 1];
			if (next instanceof MarkViewDesc) {
				curDesc = next;
				descI = next.children.length;
			} else {
				desc = next;
				descI--;
				break;
			}
		} else if (curDesc == parentDesc) break outer;
		else {
			descI = curDesc.parent.children.indexOf(curDesc);
			curDesc = curDesc.parent;
		}
		let node = desc.node;
		if (!node) continue;
		if (node != frag.child(fI - 1)) break;
		--fI;
		matched.set(desc, fI);
		matches$1.push(desc);
	}
	return {
		index: fI,
		matched,
		matches: matches$1.reverse()
	};
}
function compareSide(a, b) {
	return a.type.side - b.type.side;
}
function iterDeco(parent, deco, onWidget, onNode) {
	let locals = deco.locals(parent), offset = 0;
	if (locals.length == 0) {
		for (let i$1 = 0; i$1 < parent.childCount; i$1++) {
			let child = parent.child(i$1);
			onNode(child, locals, deco.forChild(offset, child), i$1);
			offset += child.nodeSize;
		}
		return;
	}
	let decoIndex = 0, active = [], restNode = null;
	for (let parentIndex = 0;;) {
		let widget, widgets;
		while (decoIndex < locals.length && locals[decoIndex].to == offset) {
			let next = locals[decoIndex++];
			if (next.widget) if (!widget) widget = next;
			else (widgets || (widgets = [widget])).push(next);
		}
		if (widget) if (widgets) {
			widgets.sort(compareSide);
			for (let i$1 = 0; i$1 < widgets.length; i$1++) onWidget(widgets[i$1], parentIndex, !!restNode);
		} else onWidget(widget, parentIndex, !!restNode);
		let child, index;
		if (restNode) {
			index = -1;
			child = restNode;
			restNode = null;
		} else if (parentIndex < parent.childCount) {
			index = parentIndex;
			child = parent.child(parentIndex++);
		} else break;
		for (let i$1 = 0; i$1 < active.length; i$1++) if (active[i$1].to <= offset) active.splice(i$1--, 1);
		while (decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset) active.push(locals[decoIndex++]);
		let end = offset + child.nodeSize;
		if (child.isText) {
			let cutAt = end;
			if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
			for (let i$1 = 0; i$1 < active.length; i$1++) if (active[i$1].to < cutAt) cutAt = active[i$1].to;
			if (cutAt < end) {
				restNode = child.cut(cutAt - offset);
				child = child.cut(0, cutAt - offset);
				end = cutAt;
				index = -1;
			}
		} else while (decoIndex < locals.length && locals[decoIndex].to < end) decoIndex++;
		let outerDeco = child.isInline && !child.isLeaf ? active.filter((d) => !d.inline) : active.slice();
		onNode(child, outerDeco, deco.forChild(offset, child), index);
		offset = end;
	}
}
function iosHacks(dom) {
	if (dom.nodeName == "UL" || dom.nodeName == "OL") {
		let oldCSS = dom.style.cssText;
		dom.style.cssText = oldCSS + "; list-style: square !important";
		window.getComputedStyle(dom).listStyle;
		dom.style.cssText = oldCSS;
	}
}
function findTextInFragment(frag, text$2, from, to) {
	for (let i$1 = 0, pos = 0; i$1 < frag.childCount && pos <= to;) {
		let child = frag.child(i$1++), childStart = pos;
		pos += child.nodeSize;
		if (!child.isText) continue;
		let str = child.text;
		while (i$1 < frag.childCount) {
			let next = frag.child(i$1++);
			pos += next.nodeSize;
			if (!next.isText) break;
			str += next.text;
		}
		if (pos >= from) {
			if (pos >= to && str.slice(to - text$2.length - childStart, to - childStart) == text$2) return to - text$2.length;
			let found$1 = childStart < to ? str.lastIndexOf(text$2, to - childStart - 1) : -1;
			if (found$1 >= 0 && found$1 + text$2.length + childStart >= from) return childStart + found$1;
			if (from == to && str.length >= to + text$2.length - childStart && str.slice(to - childStart, to - childStart + text$2.length) == text$2) return to;
		}
	}
	return -1;
}
function replaceNodes(nodes, from, to, view, replacement) {
	let result = [];
	for (let i$1 = 0, off = 0; i$1 < nodes.length; i$1++) {
		let child = nodes[i$1], start = off, end = off += child.size;
		if (start >= to || end <= from) result.push(child);
		else {
			if (start < from) result.push(child.slice(0, from - start, view));
			if (replacement) {
				result.push(replacement);
				replacement = void 0;
			}
			if (end > to) result.push(child.slice(to - start, child.size, view));
		}
	}
	return result;
}
function selectionFromDOM(view, origin = null) {
	let domSel = view.domSelectionRange(), doc$2 = view.state.doc;
	if (!domSel.focusNode) return null;
	let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
	let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
	if (head < 0) return null;
	let $head = doc$2.resolve(head), anchor, selection;
	if (selectionCollapsed(domSel)) {
		anchor = head;
		while (nearestDesc && !nearestDesc.node) nearestDesc = nearestDesc.parent;
		let nearestDescNode = nearestDesc.node;
		if (nearestDesc && nearestDescNode.isAtom && NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
			let pos = nearestDesc.posBefore;
			selection = new NodeSelection(head == pos ? $head : doc$2.resolve(pos));
		}
	} else {
		if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
			let min = head, max = head;
			for (let i$1 = 0; i$1 < domSel.rangeCount; i$1++) {
				let range = domSel.getRangeAt(i$1);
				min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
				max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
			}
			if (min < 0) return null;
			[anchor, head] = max == view.state.selection.anchor ? [max, min] : [min, max];
			$head = doc$2.resolve(head);
		} else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
		if (anchor < 0) return null;
	}
	let $anchor = doc$2.resolve(anchor);
	if (!selection) {
		let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
		selection = selectionBetween(view, $anchor, $head, bias);
	}
	return selection;
}
function editorOwnsSelection(view) {
	return view.editable ? view.hasFocus() : hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force = false) {
	let sel = view.state.selection;
	syncNodeSelection(view, sel);
	if (!editorOwnsSelection(view)) return;
	if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && chrome) {
		let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
		if (domSel.anchorNode && curSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
			view.input.mouseDown.delayedSelectionSync = true;
			view.domObserver.setCurSelection();
			return;
		}
	}
	view.domObserver.disconnectSelection();
	if (view.cursorWrapper) selectCursorWrapper(view);
	else {
		let { anchor, head } = sel, resetEditableFrom, resetEditableTo;
		if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
			if (!sel.$from.parent.inlineContent) resetEditableFrom = temporarilyEditableNear(view, sel.from);
			if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = temporarilyEditableNear(view, sel.to);
		}
		view.docView.setSelection(anchor, head, view, force);
		if (brokenSelectBetweenUneditable) {
			if (resetEditableFrom) resetEditable(resetEditableFrom);
			if (resetEditableTo) resetEditable(resetEditableTo);
		}
		if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
		else {
			view.dom.classList.add("ProseMirror-hideselection");
			if ("onselectionchange" in document) removeClassOnSelectionChange(view);
		}
	}
	view.domObserver.setCurSelection();
	view.domObserver.connectSelection();
}
var brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
	let { node, offset } = view.docView.domFromPos(pos, 0);
	let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
	let before = offset ? node.childNodes[offset - 1] : null;
	if (safari && after && after.contentEditable == "false") return setEditable(after);
	if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
		if (after) return setEditable(after);
		else if (before) return setEditable(before);
	}
}
function setEditable(element) {
	element.contentEditable = "true";
	if (safari && element.draggable) {
		element.draggable = false;
		element.wasDraggable = true;
	}
	return element;
}
function resetEditable(element) {
	element.contentEditable = "false";
	if (element.wasDraggable) {
		element.draggable = true;
		element.wasDraggable = null;
	}
}
function removeClassOnSelectionChange(view) {
	let doc$2 = view.dom.ownerDocument;
	doc$2.removeEventListener("selectionchange", view.input.hideSelectionGuard);
	let domSel = view.domSelectionRange();
	let node = domSel.anchorNode, offset = domSel.anchorOffset;
	doc$2.addEventListener("selectionchange", view.input.hideSelectionGuard = () => {
		if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
			doc$2.removeEventListener("selectionchange", view.input.hideSelectionGuard);
			setTimeout(() => {
				if (!editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
			}, 20);
		}
	});
}
function selectCursorWrapper(view) {
	let domSel = view.domSelection();
	if (!domSel) return;
	let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
	if (img) domSel.collapse(node.parentNode, domIndex(node) + 1);
	else domSel.collapse(node, 0);
	if (!img && !view.state.selection.visible && ie$1 && ie_version <= 11) {
		node.disabled = true;
		node.disabled = false;
	}
}
function syncNodeSelection(view, sel) {
	if (sel instanceof NodeSelection) {
		let desc = view.docView.descAt(sel.from);
		if (desc != view.lastSelectedViewDesc) {
			clearNodeSelection(view);
			if (desc) desc.selectNode();
			view.lastSelectedViewDesc = desc;
		}
	} else clearNodeSelection(view);
}
function clearNodeSelection(view) {
	if (view.lastSelectedViewDesc) {
		if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
		view.lastSelectedViewDesc = void 0;
	}
}
function selectionBetween(view, $anchor, $head, bias) {
	return view.someProp("createSelectionBetween", (f) => f(view, $anchor, $head)) || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
	if (view.editable && !view.hasFocus()) return false;
	return hasSelection(view);
}
function hasSelection(view) {
	let sel = view.domSelectionRange();
	if (!sel.anchorNode) return false;
	try {
		return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
	} catch (_) {
		return false;
	}
}
function anchorInRightPlace(view) {
	let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
	let domSel = view.domSelectionRange();
	return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function moveSelectionBlock(state, dir) {
	let { $anchor, $head } = state.selection;
	let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
	let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
	return $start && Selection.findFrom($start, dir);
}
function apply(view, sel) {
	view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
	return true;
}
function selectHorizontally(view, dir, mods) {
	let sel = view.state.selection;
	if (sel instanceof TextSelection) {
		if (mods.indexOf("s") > -1) {
			let { $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
			if (!node || node.isText || !node.isLeaf) return false;
			let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
			return apply(view, new TextSelection(sel.$anchor, $newHead));
		} else if (!sel.empty) return false;
		else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
			let next = moveSelectionBlock(view.state, dir);
			if (next && next instanceof NodeSelection) return apply(view, next);
			return false;
		} else if (!(mac$2 && mods.indexOf("m") > -1)) {
			let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
			if (!node || node.isText) return false;
			let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
			if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
			if (NodeSelection.isSelectable(node)) return apply(view, new NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
			else if (webkit) return apply(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
			else return false;
		}
	} else if (sel instanceof NodeSelection && sel.node.isInline) return apply(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
	else {
		let next = moveSelectionBlock(view.state, dir);
		if (next) return apply(view, next);
		return false;
	}
}
function nodeLen(node) {
	return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function isIgnorable(dom, dir) {
	let desc = dom.pmViewDesc;
	return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
	return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
function skipIgnoredNodesBefore(view) {
	let sel = view.domSelectionRange();
	let node = sel.focusNode, offset = sel.focusOffset;
	if (!node) return;
	let moveNode, moveOffset, force = false;
	if (gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset], -1)) force = true;
	for (;;) if (offset > 0) if (node.nodeType != 1) break;
	else {
		let before = node.childNodes[offset - 1];
		if (isIgnorable(before, -1)) {
			moveNode = node;
			moveOffset = --offset;
		} else if (before.nodeType == 3) {
			node = before;
			offset = node.nodeValue.length;
		} else break;
	}
	else if (isBlockNode(node)) break;
	else {
		let prev = node.previousSibling;
		while (prev && isIgnorable(prev, -1)) {
			moveNode = node.parentNode;
			moveOffset = domIndex(prev);
			prev = prev.previousSibling;
		}
		if (!prev) {
			node = node.parentNode;
			if (node == view.dom) break;
			offset = 0;
		} else {
			node = prev;
			offset = nodeLen(node);
		}
	}
	if (force) setSelFocus(view, node, offset);
	else if (moveNode) setSelFocus(view, moveNode, moveOffset);
}
function skipIgnoredNodesAfter(view) {
	let sel = view.domSelectionRange();
	let node = sel.focusNode, offset = sel.focusOffset;
	if (!node) return;
	let len = nodeLen(node);
	let moveNode, moveOffset;
	for (;;) if (offset < len) {
		if (node.nodeType != 1) break;
		let after = node.childNodes[offset];
		if (isIgnorable(after, 1)) {
			moveNode = node;
			moveOffset = ++offset;
		} else break;
	} else if (isBlockNode(node)) break;
	else {
		let next = node.nextSibling;
		while (next && isIgnorable(next, 1)) {
			moveNode = next.parentNode;
			moveOffset = domIndex(next) + 1;
			next = next.nextSibling;
		}
		if (!next) {
			node = node.parentNode;
			if (node == view.dom) break;
			offset = len = 0;
		} else {
			node = next;
			offset = 0;
			len = nodeLen(node);
		}
	}
	if (moveNode) setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
	let desc = dom.pmViewDesc;
	return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node, offset) {
	while (node && offset == node.childNodes.length && !hasBlockDesc(node)) {
		offset = domIndex(node) + 1;
		node = node.parentNode;
	}
	while (node && offset < node.childNodes.length) {
		let next = node.childNodes[offset];
		if (next.nodeType == 3) return next;
		if (next.nodeType == 1 && next.contentEditable == "false") break;
		node = next;
		offset = 0;
	}
}
function textNodeBefore(node, offset) {
	while (node && !offset && !hasBlockDesc(node)) {
		offset = domIndex(node);
		node = node.parentNode;
	}
	while (node && offset) {
		let next = node.childNodes[offset - 1];
		if (next.nodeType == 3) return next;
		if (next.nodeType == 1 && next.contentEditable == "false") break;
		node = next;
		offset = node.childNodes.length;
	}
}
function setSelFocus(view, node, offset) {
	if (node.nodeType != 3) {
		let before, after;
		if (after = textNodeAfter(node, offset)) {
			node = after;
			offset = 0;
		} else if (before = textNodeBefore(node, offset)) {
			node = before;
			offset = before.nodeValue.length;
		}
	}
	let sel = view.domSelection();
	if (!sel) return;
	if (selectionCollapsed(sel)) {
		let range = document.createRange();
		range.setEnd(node, offset);
		range.setStart(node, offset);
		sel.removeAllRanges();
		sel.addRange(range);
	} else if (sel.extend) sel.extend(node, offset);
	view.domObserver.setCurSelection();
	let { state } = view;
	setTimeout(() => {
		if (view.state == state) selectionToDOM(view);
	}, 50);
}
function findDirection(view, pos) {
	let $pos = view.state.doc.resolve(pos);
	if (!(chrome || windows$1) && $pos.parent.inlineContent) {
		let coords = view.coordsAtPos(pos);
		if (pos > $pos.start()) {
			let before = view.coordsAtPos(pos - 1);
			let mid = (before.top + before.bottom) / 2;
			if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
		}
		if (pos < $pos.end()) {
			let after = view.coordsAtPos(pos + 1);
			let mid = (after.top + after.bottom) / 2;
			if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
		}
	}
	return getComputedStyle(view.dom).direction == "rtl" ? "rtl" : "ltr";
}
function selectVertically(view, dir, mods) {
	let sel = view.state.selection;
	if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1) return false;
	if (mac$2 && mods.indexOf("m") > -1) return false;
	let { $from, $to } = sel;
	if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
		let next = moveSelectionBlock(view.state, dir);
		if (next && next instanceof NodeSelection) return apply(view, next);
	}
	if (!$from.parent.inlineContent) {
		let side = dir < 0 ? $from : $to;
		let beyond = sel instanceof AllSelection ? Selection.near(side, dir) : Selection.findFrom(side, dir);
		return beyond ? apply(view, beyond) : false;
	}
	return false;
}
function stopNativeHorizontalDelete(view, dir) {
	if (!(view.state.selection instanceof TextSelection)) return true;
	let { $head, $anchor, empty: empty$1 } = view.state.selection;
	if (!$head.sameParent($anchor)) return true;
	if (!empty$1) return false;
	if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
	let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
	if (nextNode && !nextNode.isText) {
		let tr = view.state.tr;
		if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
		else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
		view.dispatch(tr);
		return true;
	}
	return false;
}
function switchEditable(view, node, state) {
	view.domObserver.stop();
	node.contentEditable = state;
	view.domObserver.start();
}
function safariDownArrowBug(view) {
	if (!safari || view.state.selection.$head.parentOffset > 0) return false;
	let { focusNode, focusOffset } = view.domSelectionRange();
	if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
		let child = focusNode.firstChild;
		switchEditable(view, child, "true");
		setTimeout(() => switchEditable(view, child, "false"), 20);
	}
	return false;
}
function getMods(event) {
	let result = "";
	if (event.ctrlKey) result += "c";
	if (event.metaKey) result += "m";
	if (event.altKey) result += "a";
	if (event.shiftKey) result += "s";
	return result;
}
function captureKeyDown(view, event) {
	let code$1 = event.keyCode, mods = getMods(event);
	if (code$1 == 8 || mac$2 && code$1 == 72 && mods == "c") return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
	else if (code$1 == 46 && !event.shiftKey || mac$2 && code$1 == 68 && mods == "c") return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
	else if (code$1 == 13 || code$1 == 27) return true;
	else if (code$1 == 37 || mac$2 && code$1 == 66 && mods == "c") {
		let dir = code$1 == 37 ? findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
		return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
	} else if (code$1 == 39 || mac$2 && code$1 == 70 && mods == "c") {
		let dir = code$1 == 39 ? findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
		return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
	} else if (code$1 == 38 || mac$2 && code$1 == 80 && mods == "c") return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
	else if (code$1 == 40 || mac$2 && code$1 == 78 && mods == "c") return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
	else if (mods == (mac$2 ? "m" : "c") && (code$1 == 66 || code$1 == 73 || code$1 == 89 || code$1 == 90)) return true;
	return false;
}
function serializeForClipboard(view, slice) {
	view.someProp("transformCopied", (f) => {
		slice = f(slice, view);
	});
	let context = [], { content: content$2, openStart, openEnd } = slice;
	while (openStart > 1 && openEnd > 1 && content$2.childCount == 1 && content$2.firstChild.childCount == 1) {
		openStart--;
		openEnd--;
		let node = content$2.firstChild;
		context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
		content$2 = node.content;
	}
	let serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
	let doc$2 = detachedDoc(), wrap$1 = doc$2.createElement("div");
	wrap$1.appendChild(serializer.serializeFragment(content$2, { document: doc$2 }));
	let firstChild = wrap$1.firstChild, needsWrap, wrappers = 0;
	while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
		for (let i$1 = needsWrap.length - 1; i$1 >= 0; i$1--) {
			let wrapper = doc$2.createElement(needsWrap[i$1]);
			while (wrap$1.firstChild) wrapper.appendChild(wrap$1.firstChild);
			wrap$1.appendChild(wrapper);
			wrappers++;
		}
		firstChild = wrap$1.firstChild;
	}
	if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
	return {
		dom: wrap$1,
		text: view.someProp("clipboardTextSerializer", (f) => f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n"),
		slice
	};
}
function parseFromClipboard(view, text$2, html, plainText, $context) {
	let inCode = $context.parent.type.spec.code;
	let dom, slice;
	if (!html && !text$2) return null;
	let asText = !!text$2 && (plainText || inCode || !html);
	if (asText) {
		view.someProp("transformPastedText", (f) => {
			text$2 = f(text$2, inCode || plainText, view);
		});
		if (inCode) {
			slice = new Slice(Fragment.from(view.state.schema.text(text$2.replace(/\r\n?/g, "\n"))), 0, 0);
			view.someProp("transformPasted", (f) => {
				slice = f(slice, view, true);
			});
			return slice;
		}
		let parsed = view.someProp("clipboardTextParser", (f) => f(text$2, $context, plainText, view));
		if (parsed) slice = parsed;
		else {
			let marks = $context.marks();
			let { schema } = view.state, serializer = DOMSerializer.fromSchema(schema);
			dom = document.createElement("div");
			text$2.split(/(?:\r\n?|\n)+/).forEach((block) => {
				let p = dom.appendChild(document.createElement("p"));
				if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
			});
		}
	} else {
		view.someProp("transformPastedHTML", (f) => {
			html = f(html, view);
		});
		dom = readHTML(html);
		if (webkit) restoreReplacedSpaces(dom);
	}
	let contextNode = dom && dom.querySelector("[data-pm-slice]");
	let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
	if (sliceData && sliceData[3]) for (let i$1 = +sliceData[3]; i$1 > 0; i$1--) {
		let child = dom.firstChild;
		while (child && child.nodeType != 1) child = child.nextSibling;
		if (!child) break;
		dom = child;
	}
	if (!slice) slice = (view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser$1.fromSchema(view.state.schema)).parseSlice(dom, {
		preserveWhitespace: !!(asText || sliceData),
		context: $context,
		ruleFromNode(dom$1) {
			if (dom$1.nodeName == "BR" && !dom$1.nextSibling && dom$1.parentNode && !inlineParents.test(dom$1.parentNode.nodeName)) return { ignore: true };
			return null;
		}
	});
	if (sliceData) slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
	else {
		slice = Slice.maxOpen(normalizeSiblings(slice.content, $context), true);
		if (slice.openStart || slice.openEnd) {
			let openStart = 0, openEnd = 0;
			for (let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
			for (let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
			slice = closeSlice(slice, openStart, openEnd);
		}
	}
	view.someProp("transformPasted", (f) => {
		slice = f(slice, view, asText);
	});
	return slice;
}
var inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function normalizeSiblings(fragment, $context) {
	if (fragment.childCount < 2) return fragment;
	for (let d = $context.depth; d >= 0; d--) {
		let match = $context.node(d).contentMatchAt($context.index(d));
		let lastWrap, result = [];
		fragment.forEach((node) => {
			if (!result) return;
			let wrap$1 = match.findWrapping(node.type), inLast;
			if (!wrap$1) return result = null;
			if (inLast = result.length && lastWrap.length && addToSibling(wrap$1, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
			else {
				if (result.length) result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
				let wrapped = withWrappers(node, wrap$1);
				result.push(wrapped);
				match = match.matchType(wrapped.type);
				lastWrap = wrap$1;
			}
		});
		if (result) return Fragment.from(result);
	}
	return fragment;
}
function withWrappers(node, wrap$1, from = 0) {
	for (let i$1 = wrap$1.length - 1; i$1 >= from; i$1--) node = wrap$1[i$1].create(null, Fragment.from(node));
	return node;
}
function addToSibling(wrap$1, lastWrap, node, sibling, depth) {
	if (depth < wrap$1.length && depth < lastWrap.length && wrap$1[depth] == lastWrap[depth]) {
		let inner = addToSibling(wrap$1, lastWrap, node, sibling.lastChild, depth + 1);
		if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
		if (sibling.contentMatchAt(sibling.childCount).matchType(depth == wrap$1.length - 1 ? node.type : wrap$1[depth + 1])) return sibling.copy(sibling.content.append(Fragment.from(withWrappers(node, wrap$1, depth + 1))));
	}
}
function closeRight(node, depth) {
	if (depth == 0) return node;
	let fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
	let fill = node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true);
	return node.copy(fragment.append(fill));
}
function closeRange(fragment, side, from, to, depth, openEnd) {
	let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
	if (fragment.childCount > 1) openEnd = 0;
	if (depth < to - 1) inner = closeRange(inner, side, from, to, depth + 1, openEnd);
	if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true));
	return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function closeSlice(slice, openStart, openEnd) {
	if (openStart < slice.openStart) slice = new Slice(closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
	if (openEnd < slice.openEnd) slice = new Slice(closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
	return slice;
}
var wrapMap = {
	thead: ["table"],
	tbody: ["table"],
	tfoot: ["table"],
	caption: ["table"],
	colgroup: ["table"],
	col: ["table", "colgroup"],
	tr: ["table", "tbody"],
	td: [
		"table",
		"tbody",
		"tr"
	],
	th: [
		"table",
		"tbody",
		"tr"
	]
};
var _detachedDoc = null;
function detachedDoc() {
	return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
var _policy = null;
function maybeWrapTrusted(html) {
	let trustedTypes = window.trustedTypes;
	if (!trustedTypes) return html;
	if (!_policy) _policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", { createHTML: (s) => s });
	return _policy.createHTML(html);
}
function readHTML(html) {
	let metas = /^(\s*<meta [^>]*>)*/.exec(html);
	if (metas) html = html.slice(metas[0].length);
	let elt = detachedDoc().createElement("div");
	let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap$1;
	if (wrap$1 = firstTag && wrapMap[firstTag[1].toLowerCase()]) html = wrap$1.map((n) => "<" + n + ">").join("") + html + wrap$1.map((n) => "</" + n + ">").reverse().join("");
	elt.innerHTML = maybeWrapTrusted(html);
	if (wrap$1) for (let i$1 = 0; i$1 < wrap$1.length; i$1++) elt = elt.querySelector(wrap$1[i$1]) || elt;
	return elt;
}
function restoreReplacedSpaces(dom) {
	let nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
	for (let i$1 = 0; i$1 < nodes.length; i$1++) {
		let node = nodes[i$1];
		if (node.childNodes.length == 1 && node.textContent == "\xA0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
	}
}
function addContext(slice, context) {
	if (!slice.size) return slice;
	let schema = slice.content.firstChild.type.schema, array;
	try {
		array = JSON.parse(context);
	} catch (e) {
		return slice;
	}
	let { content: content$2, openStart, openEnd } = slice;
	for (let i$1 = array.length - 2; i$1 >= 0; i$1 -= 2) {
		let type = schema.nodes[array[i$1]];
		if (!type || type.hasRequiredAttrs()) break;
		content$2 = Fragment.from(type.create(array[i$1 + 1], content$2));
		openStart++;
		openEnd++;
	}
	return new Slice(content$2, openStart, openEnd);
}
var handlers$1 = {};
var editHandlers = {};
var passiveHandlers = {
	touchstart: true,
	touchmove: true
};
var InputState = class {
	constructor() {
		this.shiftKey = false;
		this.mouseDown = null;
		this.lastKeyCode = null;
		this.lastKeyCodeTime = 0;
		this.lastClick = {
			time: 0,
			x: 0,
			y: 0,
			type: "",
			button: 0
		};
		this.lastSelectionOrigin = null;
		this.lastSelectionTime = 0;
		this.lastIOSEnter = 0;
		this.lastIOSEnterFallbackTimeout = -1;
		this.lastFocus = 0;
		this.lastTouch = 0;
		this.lastChromeDelete = 0;
		this.composing = false;
		this.compositionNode = null;
		this.composingTimeout = -1;
		this.compositionNodes = [];
		this.compositionEndedAt = -2e8;
		this.compositionID = 1;
		this.badSafariComposition = false;
		this.compositionPendingChanges = 0;
		this.domChangeCount = 0;
		this.eventHandlers = Object.create(null);
		this.hideSelectionGuard = null;
	}
};
function initInput(view) {
	for (let event in handlers$1) {
		let handler$1 = handlers$1[event];
		view.dom.addEventListener(event, view.input.eventHandlers[event] = (event$1) => {
			if (eventBelongsToView(view, event$1) && !runCustomHandler(view, event$1) && (view.editable || !(event$1.type in editHandlers))) handler$1(view, event$1);
		}, passiveHandlers[event] ? { passive: true } : void 0);
	}
	if (safari) view.dom.addEventListener("input", () => null);
	ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
	view.input.lastSelectionOrigin = origin;
	view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
	view.domObserver.stop();
	for (let type in view.input.eventHandlers) view.dom.removeEventListener(type, view.input.eventHandlers[type]);
	clearTimeout(view.input.composingTimeout);
	clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
	view.someProp("handleDOMEvents", (currentHandlers) => {
		for (let type in currentHandlers) if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event) => runCustomHandler(view, event));
	});
}
function runCustomHandler(view, event) {
	return view.someProp("handleDOMEvents", (handlers$2) => {
		let handler$1 = handlers$2[event.type];
		return handler$1 ? handler$1(view, event) || event.defaultPrevented : false;
	});
}
function eventBelongsToView(view, event) {
	if (!event.bubbles) return true;
	if (event.defaultPrevented) return false;
	for (let node = event.target; node != view.dom; node = node.parentNode) if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
	return true;
}
function dispatchEvent(view, event) {
	if (!runCustomHandler(view, event) && handlers$1[event.type] && (view.editable || !(event.type in editHandlers))) handlers$1[event.type](view, event);
}
editHandlers.keydown = (view, _event) => {
	let event = _event;
	view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
	if (inOrNearComposition(view, event)) return;
	view.input.lastKeyCode = event.keyCode;
	view.input.lastKeyCodeTime = Date.now();
	if (android && chrome && event.keyCode == 13) return;
	if (event.keyCode != 229) view.domObserver.forceFlush();
	if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
		let now = Date.now();
		view.input.lastIOSEnter = now;
		view.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
			if (view.input.lastIOSEnter == now) {
				view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")));
				view.input.lastIOSEnter = 0;
			}
		}, 200);
	} else if (view.someProp("handleKeyDown", (f) => f(view, event)) || captureKeyDown(view, event)) event.preventDefault();
	else setSelectionOrigin(view, "key");
};
editHandlers.keyup = (view, event) => {
	if (event.keyCode == 16) view.input.shiftKey = false;
};
editHandlers.keypress = (view, _event) => {
	let event = _event;
	if (inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || mac$2 && event.metaKey) return;
	if (view.someProp("handleKeyPress", (f) => f(view, event))) {
		event.preventDefault();
		return;
	}
	let sel = view.state.selection;
	if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
		let text$2 = String.fromCharCode(event.charCode);
		let deflt = () => view.state.tr.insertText(text$2).scrollIntoView();
		if (!/[\r\n]/.test(text$2) && !view.someProp("handleTextInput", (f) => f(view, sel.$from.pos, sel.$to.pos, text$2, deflt))) view.dispatch(deflt());
		event.preventDefault();
	}
};
function eventCoords(event) {
	return {
		left: event.clientX,
		top: event.clientY
	};
}
function isNear(event, click) {
	let dx = click.x - event.clientX, dy = click.y - event.clientY;
	return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
	if (inside == -1) return false;
	let $pos = view.state.doc.resolve(inside);
	for (let i$1 = $pos.depth + 1; i$1 > 0; i$1--) if (view.someProp(propName, (f) => i$1 > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i$1), event, true) : f(view, pos, $pos.node(i$1), $pos.before(i$1), event, false))) return true;
	return false;
}
function updateSelection(view, selection, origin) {
	if (!view.focused) view.focus();
	if (view.state.selection.eq(selection)) return;
	let tr = view.state.tr.setSelection(selection);
	if (origin == "pointer") tr.setMeta("pointer", true);
	view.dispatch(tr);
}
function selectClickedLeaf(view, inside) {
	if (inside == -1) return false;
	let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
	if (node && node.isAtom && NodeSelection.isSelectable(node)) {
		updateSelection(view, new NodeSelection($pos), "pointer");
		return true;
	}
	return false;
}
function selectClickedNode(view, inside) {
	if (inside == -1) return false;
	let sel = view.state.selection, selectedNode, selectAt;
	if (sel instanceof NodeSelection) selectedNode = sel.node;
	let $pos = view.state.doc.resolve(inside);
	for (let i$1 = $pos.depth + 1; i$1 > 0; i$1--) {
		let node = i$1 > $pos.depth ? $pos.nodeAfter : $pos.node(i$1);
		if (NodeSelection.isSelectable(node)) {
			if (selectedNode && sel.$from.depth > 0 && i$1 >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
			else selectAt = $pos.before(i$1);
			break;
		}
	}
	if (selectAt != null) {
		updateSelection(view, NodeSelection.create(view.state.doc, selectAt), "pointer");
		return true;
	} else return false;
}
function handleSingleClick(view, pos, inside, event, selectNode) {
	return runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f) => f(view, pos, event)) || (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
	return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f) => f(view, pos, event));
}
function handleTripleClick$1(view, pos, inside, event) {
	return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f) => f(view, pos, event)) || defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
	if (event.button != 0) return false;
	let doc$2 = view.state.doc;
	if (inside == -1) {
		if (doc$2.inlineContent) {
			updateSelection(view, TextSelection.create(doc$2, 0, doc$2.content.size), "pointer");
			return true;
		}
		return false;
	}
	let $pos = doc$2.resolve(inside);
	for (let i$1 = $pos.depth + 1; i$1 > 0; i$1--) {
		let node = i$1 > $pos.depth ? $pos.nodeAfter : $pos.node(i$1);
		let nodePos = $pos.before(i$1);
		if (node.inlineContent) updateSelection(view, TextSelection.create(doc$2, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
		else if (NodeSelection.isSelectable(node)) updateSelection(view, NodeSelection.create(doc$2, nodePos), "pointer");
		else continue;
		return true;
	}
}
function forceDOMFlush(view) {
	return endComposition(view);
}
var selectNodeModifier = mac$2 ? "metaKey" : "ctrlKey";
handlers$1.mousedown = (view, _event) => {
	let event = _event;
	view.input.shiftKey = event.shiftKey;
	let flushed = forceDOMFlush(view);
	let now = Date.now(), type = "singleClick";
	if (now - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier] && view.input.lastClick.button == event.button) {
		if (view.input.lastClick.type == "singleClick") type = "doubleClick";
		else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
	}
	view.input.lastClick = {
		time: now,
		x: event.clientX,
		y: event.clientY,
		type,
		button: event.button
	};
	let pos = view.posAtCoords(eventCoords(event));
	if (!pos) return;
	if (type == "singleClick") {
		if (view.input.mouseDown) view.input.mouseDown.done();
		view.input.mouseDown = new MouseDown(view, pos, event, !!flushed);
	} else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick$1)(view, pos.pos, pos.inside, event)) event.preventDefault();
	else setSelectionOrigin(view, "pointer");
};
var MouseDown = class {
	constructor(view, pos, event, flushed) {
		this.view = view;
		this.pos = pos;
		this.event = event;
		this.flushed = flushed;
		this.delayedSelectionSync = false;
		this.mightDrag = null;
		this.startDoc = view.state.doc;
		this.selectNode = !!event[selectNodeModifier];
		this.allowDefault = event.shiftKey;
		let targetNode, targetPos;
		if (pos.inside > -1) {
			targetNode = view.state.doc.nodeAt(pos.inside);
			targetPos = pos.inside;
		} else {
			let $pos = view.state.doc.resolve(pos.pos);
			targetNode = $pos.parent;
			targetPos = $pos.depth ? $pos.before() : 0;
		}
		const target = flushed ? null : event.target;
		const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
		this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
		let { selection } = view.state;
		if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof NodeSelection && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
			node: targetNode,
			pos: targetPos,
			addAttr: !!(this.target && !this.target.draggable),
			setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
		};
		if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
			this.view.domObserver.stop();
			if (this.mightDrag.addAttr) this.target.draggable = true;
			if (this.mightDrag.setUneditable) setTimeout(() => {
				if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
			}, 20);
			this.view.domObserver.start();
		}
		view.root.addEventListener("mouseup", this.up = this.up.bind(this));
		view.root.addEventListener("mousemove", this.move = this.move.bind(this));
		setSelectionOrigin(view, "pointer");
	}
	done() {
		this.view.root.removeEventListener("mouseup", this.up);
		this.view.root.removeEventListener("mousemove", this.move);
		if (this.mightDrag && this.target) {
			this.view.domObserver.stop();
			if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
			if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
			this.view.domObserver.start();
		}
		if (this.delayedSelectionSync) setTimeout(() => selectionToDOM(this.view));
		this.view.input.mouseDown = null;
	}
	up(event) {
		this.done();
		if (!this.view.dom.contains(event.target)) return;
		let pos = this.pos;
		if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords(eventCoords(event));
		this.updateAllowDefault(event);
		if (this.allowDefault || !pos) setSelectionOrigin(this.view, "pointer");
		else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
		else if (event.button == 0 && (this.flushed || safari && this.mightDrag && !this.mightDrag.node.isAtom || chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
			updateSelection(this.view, Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
			event.preventDefault();
		} else setSelectionOrigin(this.view, "pointer");
	}
	move(event) {
		this.updateAllowDefault(event);
		setSelectionOrigin(this.view, "pointer");
		if (event.buttons == 0) this.done();
	}
	updateAllowDefault(event) {
		if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
	}
};
handlers$1.touchstart = (view) => {
	view.input.lastTouch = Date.now();
	forceDOMFlush(view);
	setSelectionOrigin(view, "pointer");
};
handlers$1.touchmove = (view) => {
	view.input.lastTouch = Date.now();
	setSelectionOrigin(view, "pointer");
};
handlers$1.contextmenu = (view) => forceDOMFlush(view);
function inOrNearComposition(view, event) {
	if (view.composing) return true;
	if (safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
		view.input.compositionEndedAt = -2e8;
		return true;
	}
	return false;
}
var timeoutComposition = android ? 5e3 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = (view) => {
	if (!view.composing) {
		view.domObserver.flush();
		let { state } = view, $pos = state.selection.$to;
		if (state.selection instanceof TextSelection && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m) => m.type.spec.inclusive === false) || chrome && windows$1 && selectionBeforeUneditable(view))) {
			view.markCursor = view.state.storedMarks || $pos.marks();
			endComposition(view, true);
			view.markCursor = null;
		} else {
			endComposition(view, !state.selection.empty);
			if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
				let sel = view.domSelectionRange();
				for (let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
					let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
					if (!before) break;
					if (before.nodeType == 3) {
						let sel$1 = view.domSelection();
						if (sel$1) sel$1.collapse(before, before.nodeValue.length);
						break;
					} else {
						node = before;
						offset = -1;
					}
				}
			}
		}
		view.input.composing = true;
	}
	scheduleComposeEnd(view, timeoutComposition);
};
function selectionBeforeUneditable(view) {
	let { focusNode, focusOffset } = view.domSelectionRange();
	if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length) return false;
	let next = focusNode.childNodes[focusOffset];
	return next.nodeType == 1 && next.contentEditable == "false";
}
editHandlers.compositionend = (view, event) => {
	if (view.composing) {
		view.input.composing = false;
		view.input.compositionEndedAt = event.timeStamp;
		view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
		view.input.compositionNode = null;
		if (view.input.badSafariComposition) view.domObserver.forceFlush();
		else if (view.input.compositionPendingChanges) Promise.resolve().then(() => view.domObserver.flush());
		view.input.compositionID++;
		scheduleComposeEnd(view, 20);
	}
};
function scheduleComposeEnd(view, delay) {
	clearTimeout(view.input.composingTimeout);
	if (delay > -1) view.input.composingTimeout = setTimeout(() => endComposition(view), delay);
}
function clearComposition(view) {
	if (view.composing) {
		view.input.composing = false;
		view.input.compositionEndedAt = timestampFromCustomEvent();
	}
	while (view.input.compositionNodes.length > 0) view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
	let sel = view.domSelectionRange();
	if (!sel.focusNode) return null;
	let textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
	let textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
	if (textBefore && textAfter && textBefore != textAfter) {
		let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
		if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
		if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
		else if (view.input.compositionNode == textAfter) {
			let descBefore = textBefore.pmViewDesc;
			if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
		}
	}
	return textBefore || textAfter;
}
function timestampFromCustomEvent() {
	let event = document.createEvent("Event");
	event.initEvent("event", true, true);
	return event.timeStamp;
}
function endComposition(view, restarting = false) {
	if (android && view.domObserver.flushingSoon >= 0) return;
	view.domObserver.forceFlush();
	clearComposition(view);
	if (restarting || view.docView && view.docView.dirty) {
		let sel = selectionFromDOM(view), cur = view.state.selection;
		if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
		else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
		else view.updateState(view.state);
		return true;
	}
	return false;
}
function captureCopy(view, dom) {
	if (!view.dom.parentNode) return;
	let wrap$1 = view.dom.parentNode.appendChild(document.createElement("div"));
	wrap$1.appendChild(dom);
	wrap$1.style.cssText = "position: fixed; left: -10000px; top: 10px";
	let sel = getSelection(), range = document.createRange();
	range.selectNodeContents(dom);
	view.dom.blur();
	sel.removeAllRanges();
	sel.addRange(range);
	setTimeout(() => {
		if (wrap$1.parentNode) wrap$1.parentNode.removeChild(wrap$1);
		view.focus();
	}, 50);
}
var brokenClipboardAPI = ie$1 && ie_version < 15 || ios && webkit_version < 604;
handlers$1.copy = editHandlers.cut = (view, _event) => {
	let event = _event;
	let sel = view.state.selection, cut = event.type == "cut";
	if (sel.empty) return;
	let data = brokenClipboardAPI ? null : event.clipboardData;
	let { dom, text: text$2 } = serializeForClipboard(view, sel.content());
	if (data) {
		event.preventDefault();
		data.clearData();
		data.setData("text/html", dom.innerHTML);
		data.setData("text/plain", text$2);
	} else captureCopy(view, dom);
	if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice) {
	return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function capturePaste(view, event) {
	if (!view.dom.parentNode) return;
	let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
	let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
	if (!plainText) target.contentEditable = "true";
	target.style.cssText = "position: fixed; left: -10000px; top: 10px";
	target.focus();
	let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
	setTimeout(() => {
		view.focus();
		if (target.parentNode) target.parentNode.removeChild(target);
		if (plainText) doPaste(view, target.value, null, plain, event);
		else doPaste(view, target.textContent, target.innerHTML, plain, event);
	}, 50);
}
function doPaste(view, text$2, html, preferPlain, event) {
	let slice = parseFromClipboard(view, text$2, html, preferPlain, view.state.selection.$from);
	if (view.someProp("handlePaste", (f) => f(view, event, slice || Slice.empty))) return true;
	if (!slice) return false;
	let singleNode = sliceSingleNode(slice);
	let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
	view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
	return true;
}
function getText(clipboardData) {
	let text$2 = clipboardData.getData("text/plain") || clipboardData.getData("Text");
	if (text$2) return text$2;
	let uris = clipboardData.getData("text/uri-list");
	return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = (view, _event) => {
	let event = _event;
	if (view.composing && !android) return;
	let data = brokenClipboardAPI ? null : event.clipboardData;
	let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
	if (data && doPaste(view, getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
	else capturePaste(view, event);
};
var Dragging = class {
	constructor(slice, move, node) {
		this.slice = slice;
		this.move = move;
		this.node = node;
	}
};
var dragCopyModifier = mac$2 ? "altKey" : "ctrlKey";
function dragMoves(view, event) {
	let moves = view.someProp("dragCopies", (test) => !test(event));
	return moves != null ? moves : !event[dragCopyModifier];
}
handlers$1.dragstart = (view, _event) => {
	let event = _event;
	let mouseDown = view.input.mouseDown;
	if (mouseDown) mouseDown.done();
	if (!event.dataTransfer) return;
	let sel = view.state.selection;
	let pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
	let node;
	if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof NodeSelection ? sel.to - 1 : sel.to));
	else if (mouseDown && mouseDown.mightDrag) node = NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
	else if (event.target && event.target.nodeType == 1) {
		let desc = view.docView.nearestDesc(event.target, true);
		if (desc && desc.node.type.spec.draggable && desc != view.docView) node = NodeSelection.create(view.state.doc, desc.posBefore);
	}
	let { dom, text: text$2, slice } = serializeForClipboard(view, (node || view.state.selection).content());
	if (!event.dataTransfer.files.length || !chrome || chrome_version > 120) event.dataTransfer.clearData();
	event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
	event.dataTransfer.effectAllowed = "copyMove";
	if (!brokenClipboardAPI) event.dataTransfer.setData("text/plain", text$2);
	view.dragging = new Dragging(slice, dragMoves(view, event), node);
};
handlers$1.dragend = (view) => {
	let dragging = view.dragging;
	window.setTimeout(() => {
		if (view.dragging == dragging) view.dragging = null;
	}, 50);
};
editHandlers.dragover = editHandlers.dragenter = (_, e) => e.preventDefault();
editHandlers.drop = (view, event) => {
	try {
		handleDrop(view, event, view.dragging);
	} finally {
		view.dragging = null;
	}
};
function handleDrop(view, event, dragging) {
	if (!event.dataTransfer) return;
	let eventPos = view.posAtCoords(eventCoords(event));
	if (!eventPos) return;
	let $mouse = view.state.doc.resolve(eventPos.pos);
	let slice = dragging && dragging.slice;
	if (slice) view.someProp("transformPasted", (f) => {
		slice = f(slice, view, false);
	});
	else slice = parseFromClipboard(view, getText(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
	let move = !!(dragging && dragMoves(view, event));
	if (view.someProp("handleDrop", (f) => f(view, event, slice || Slice.empty, move))) {
		event.preventDefault();
		return;
	}
	if (!slice) return;
	event.preventDefault();
	let insertPos = slice ? dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
	if (insertPos == null) insertPos = $mouse.pos;
	let tr = view.state.tr;
	if (move) {
		let { node } = dragging;
		if (node) node.replace(tr);
		else tr.deleteSelection();
	}
	let pos = tr.mapping.map(insertPos);
	let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
	let beforeInsert = tr.doc;
	if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
	else tr.replaceRange(pos, pos, slice);
	if (tr.doc.eq(beforeInsert)) return;
	let $pos = tr.doc.resolve(pos);
	if (isNode && NodeSelection.isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new NodeSelection($pos));
	else {
		let end = tr.mapping.map(insertPos);
		tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo) => end = newTo);
		tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end)));
	}
	view.focus();
	view.dispatch(tr.setMeta("uiEvent", "drop"));
}
handlers$1.focus = (view) => {
	view.input.lastFocus = Date.now();
	if (!view.focused) {
		view.domObserver.stop();
		view.dom.classList.add("ProseMirror-focused");
		view.domObserver.start();
		view.focused = true;
		setTimeout(() => {
			if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) selectionToDOM(view);
		}, 20);
	}
};
handlers$1.blur = (view, _event) => {
	let event = _event;
	if (view.focused) {
		view.domObserver.stop();
		view.dom.classList.remove("ProseMirror-focused");
		view.domObserver.start();
		if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
		view.focused = false;
	}
};
handlers$1.beforeinput = (view, _event) => {
	if (chrome && android && _event.inputType == "deleteContentBackward") {
		view.domObserver.flushSoon();
		let { domChangeCount } = view.input;
		setTimeout(() => {
			if (view.input.domChangeCount != domChangeCount) return;
			view.dom.blur();
			view.focus();
			if (view.someProp("handleKeyDown", (f) => f(view, keyEvent(8, "Backspace")))) return;
			let { $cursor } = view.state.selection;
			if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
		}, 50);
	}
};
for (let prop in editHandlers) handlers$1[prop] = editHandlers[prop];
function compareObjs(a, b) {
	if (a == b) return true;
	for (let p in a) if (a[p] !== b[p]) return false;
	for (let p in b) if (!(p in a)) return false;
	return true;
}
var WidgetType = class WidgetType {
	constructor(toDOM, spec) {
		this.toDOM = toDOM;
		this.spec = spec || noSpec;
		this.side = this.spec.side || 0;
	}
	map(mapping, span, offset, oldOffset) {
		let { pos, deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
		return deleted ? null : new Decoration(pos - offset, pos - offset, this);
	}
	valid() {
		return true;
	}
	eq(other) {
		return this == other || other instanceof WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && compareObjs(this.spec, other.spec));
	}
	destroy(node) {
		if (this.spec.destroy) this.spec.destroy(node);
	}
};
var InlineType = class InlineType {
	constructor(attrs, spec) {
		this.attrs = attrs;
		this.spec = spec || noSpec;
	}
	map(mapping, span, offset, oldOffset) {
		let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
		let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
		return from >= to ? null : new Decoration(from, to, this);
	}
	valid(_, span) {
		return span.from < span.to;
	}
	eq(other) {
		return this == other || other instanceof InlineType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
	}
	static is(span) {
		return span.type instanceof InlineType;
	}
	destroy() {}
};
var NodeType = class NodeType {
	constructor(attrs, spec) {
		this.attrs = attrs;
		this.spec = spec || noSpec;
	}
	map(mapping, span, offset, oldOffset) {
		let from = mapping.mapResult(span.from + oldOffset, 1);
		if (from.deleted) return null;
		let to = mapping.mapResult(span.to + oldOffset, -1);
		if (to.deleted || to.pos <= from.pos) return null;
		return new Decoration(from.pos - offset, to.pos - offset, this);
	}
	valid(node, span) {
		let { index, offset } = node.content.findIndex(span.from), child;
		return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
	}
	eq(other) {
		return this == other || other instanceof NodeType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
	}
	destroy() {}
};
var Decoration = class Decoration {
	constructor(from, to, type) {
		this.from = from;
		this.to = to;
		this.type = type;
	}
	copy(from, to) {
		return new Decoration(from, to, this.type);
	}
	eq(other, offset = 0) {
		return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
	}
	map(mapping, offset, oldOffset) {
		return this.type.map(mapping, this, offset, oldOffset);
	}
	static widget(pos, toDOM, spec) {
		return new Decoration(pos, pos, new WidgetType(toDOM, spec));
	}
	static inline(from, to, attrs, spec) {
		return new Decoration(from, to, new InlineType(attrs, spec));
	}
	static node(from, to, attrs, spec) {
		return new Decoration(from, to, new NodeType(attrs, spec));
	}
	get spec() {
		return this.type.spec;
	}
	get inline() {
		return this.type instanceof InlineType;
	}
	get widget() {
		return this.type instanceof WidgetType;
	}
};
var none = [], noSpec = {};
var DecorationSet = class DecorationSet {
	constructor(local, children) {
		this.local = local.length ? local : none;
		this.children = children.length ? children : none;
	}
	static create(doc$2, decorations) {
		return decorations.length ? buildTree(decorations, doc$2, 0, noSpec) : empty;
	}
	find(start, end, predicate) {
		let result = [];
		this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
		return result;
	}
	findInner(start, end, result, offset, predicate) {
		for (let i$1 = 0; i$1 < this.local.length; i$1++) {
			let span = this.local[i$1];
			if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
		}
		for (let i$1 = 0; i$1 < this.children.length; i$1 += 3) if (this.children[i$1] < end && this.children[i$1 + 1] > start) {
			let childOff = this.children[i$1] + 1;
			this.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
		}
	}
	map(mapping, doc$2, options) {
		if (this == empty || mapping.maps.length == 0) return this;
		return this.mapInner(mapping, doc$2, 0, 0, options || noSpec);
	}
	mapInner(mapping, node, offset, oldOffset, options) {
		let newLocal;
		for (let i$1 = 0; i$1 < this.local.length; i$1++) {
			let mapped = this.local[i$1].map(mapping, offset, oldOffset);
			if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
			else if (options.onRemove) options.onRemove(this.local[i$1].spec);
		}
		if (this.children.length) return mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
		else return newLocal ? new DecorationSet(newLocal.sort(byPos), none) : empty;
	}
	add(doc$2, decorations) {
		if (!decorations.length) return this;
		if (this == empty) return DecorationSet.create(doc$2, decorations);
		return this.addInner(doc$2, decorations, 0);
	}
	addInner(doc$2, decorations, offset) {
		let children, childIndex = 0;
		doc$2.forEach((childNode, childOffset) => {
			let baseOffset = childOffset + offset, found$1;
			if (!(found$1 = takeSpansForNode(decorations, childNode, baseOffset))) return;
			if (!children) children = this.children.slice();
			while (childIndex < children.length && children[childIndex] < childOffset) childIndex += 3;
			if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found$1, baseOffset + 1);
			else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found$1, childNode, baseOffset + 1, noSpec));
			childIndex += 3;
		});
		let local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
		for (let i$1 = 0; i$1 < local.length; i$1++) if (!local[i$1].type.valid(doc$2, local[i$1])) local.splice(i$1--, 1);
		return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
	}
	remove(decorations) {
		if (decorations.length == 0 || this == empty) return this;
		return this.removeInner(decorations, 0);
	}
	removeInner(decorations, offset) {
		let children = this.children, local = this.local;
		for (let i$1 = 0; i$1 < children.length; i$1 += 3) {
			let found$1;
			let from = children[i$1] + offset, to = children[i$1 + 1] + offset;
			for (let j = 0, span; j < decorations.length; j++) if (span = decorations[j]) {
				if (span.from > from && span.to < to) {
					decorations[j] = null;
					(found$1 || (found$1 = [])).push(span);
				}
			}
			if (!found$1) continue;
			if (children == this.children) children = this.children.slice();
			let removed = children[i$1 + 2].removeInner(found$1, from + 1);
			if (removed != empty) children[i$1 + 2] = removed;
			else {
				children.splice(i$1, 3);
				i$1 -= 3;
			}
		}
		if (local.length) {
			for (let i$1 = 0, span; i$1 < decorations.length; i$1++) if (span = decorations[i$1]) {
				for (let j = 0; j < local.length; j++) if (local[j].eq(span, offset)) {
					if (local == this.local) local = this.local.slice();
					local.splice(j--, 1);
				}
			}
		}
		if (children == this.children && local == this.local) return this;
		return local.length || children.length ? new DecorationSet(local, children) : empty;
	}
	forChild(offset, node) {
		if (this == empty) return this;
		if (node.isLeaf) return DecorationSet.empty;
		let child, local;
		for (let i$1 = 0; i$1 < this.children.length; i$1 += 3) if (this.children[i$1] >= offset) {
			if (this.children[i$1] == offset) child = this.children[i$1 + 2];
			break;
		}
		let start = offset + 1, end = start + node.content.size;
		for (let i$1 = 0; i$1 < this.local.length; i$1++) {
			let dec = this.local[i$1];
			if (dec.from < end && dec.to > start && dec.type instanceof InlineType) {
				let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
				if (from < to) (local || (local = [])).push(dec.copy(from, to));
			}
		}
		if (local) {
			let localSet = new DecorationSet(local.sort(byPos), none);
			return child ? new DecorationGroup([localSet, child]) : localSet;
		}
		return child || empty;
	}
	eq(other) {
		if (this == other) return true;
		if (!(other instanceof DecorationSet) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
		for (let i$1 = 0; i$1 < this.local.length; i$1++) if (!this.local[i$1].eq(other.local[i$1])) return false;
		for (let i$1 = 0; i$1 < this.children.length; i$1 += 3) if (this.children[i$1] != other.children[i$1] || this.children[i$1 + 1] != other.children[i$1 + 1] || !this.children[i$1 + 2].eq(other.children[i$1 + 2])) return false;
		return true;
	}
	locals(node) {
		return removeOverlap(this.localsInner(node));
	}
	localsInner(node) {
		if (this == empty) return none;
		if (node.inlineContent || !this.local.some(InlineType.is)) return this.local;
		let result = [];
		for (let i$1 = 0; i$1 < this.local.length; i$1++) if (!(this.local[i$1].type instanceof InlineType)) result.push(this.local[i$1]);
		return result;
	}
	forEachSet(f) {
		f(this);
	}
};
DecorationSet.empty = new DecorationSet([], []);
DecorationSet.removeOverlap = removeOverlap;
var empty = DecorationSet.empty;
var DecorationGroup = class DecorationGroup {
	constructor(members) {
		this.members = members;
	}
	map(mapping, doc$2) {
		const mappedDecos = this.members.map((member) => member.map(mapping, doc$2, noSpec));
		return DecorationGroup.from(mappedDecos);
	}
	forChild(offset, child) {
		if (child.isLeaf) return DecorationSet.empty;
		let found$1 = [];
		for (let i$1 = 0; i$1 < this.members.length; i$1++) {
			let result = this.members[i$1].forChild(offset, child);
			if (result == empty) continue;
			if (result instanceof DecorationGroup) found$1 = found$1.concat(result.members);
			else found$1.push(result);
		}
		return DecorationGroup.from(found$1);
	}
	eq(other) {
		if (!(other instanceof DecorationGroup) || other.members.length != this.members.length) return false;
		for (let i$1 = 0; i$1 < this.members.length; i$1++) if (!this.members[i$1].eq(other.members[i$1])) return false;
		return true;
	}
	locals(node) {
		let result, sorted = true;
		for (let i$1 = 0; i$1 < this.members.length; i$1++) {
			let locals = this.members[i$1].localsInner(node);
			if (!locals.length) continue;
			if (!result) result = locals;
			else {
				if (sorted) {
					result = result.slice();
					sorted = false;
				}
				for (let j = 0; j < locals.length; j++) result.push(locals[j]);
			}
		}
		return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
	}
	static from(members) {
		switch (members.length) {
			case 0: return empty;
			case 1: return members[0];
			default: return new DecorationGroup(members.every((m) => m instanceof DecorationSet) ? members : members.reduce((r, m) => r.concat(m instanceof DecorationSet ? m : m.members), []));
		}
	}
	forEachSet(f) {
		for (let i$1 = 0; i$1 < this.members.length; i$1++) this.members[i$1].forEachSet(f);
	}
};
function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
	let children = oldChildren.slice();
	for (let i$1 = 0, baseOffset = oldOffset; i$1 < mapping.maps.length; i$1++) {
		let moved = 0;
		mapping.maps[i$1].forEach((oldStart, oldEnd, newStart, newEnd) => {
			let dSize = newEnd - newStart - (oldEnd - oldStart);
			for (let i$2 = 0; i$2 < children.length; i$2 += 3) {
				let end = children[i$2 + 1];
				if (end < 0 || oldStart > end + baseOffset - moved) continue;
				let start = children[i$2] + baseOffset - moved;
				if (oldEnd >= start) children[i$2 + 1] = oldStart <= start ? -2 : -1;
				else if (oldStart >= baseOffset && dSize) {
					children[i$2] += dSize;
					children[i$2 + 1] += dSize;
				}
			}
			moved += dSize;
		});
		baseOffset = mapping.maps[i$1].map(baseOffset, -1);
	}
	let mustRebuild = false;
	for (let i$1 = 0; i$1 < children.length; i$1 += 3) if (children[i$1 + 1] < 0) {
		if (children[i$1 + 1] == -2) {
			mustRebuild = true;
			children[i$1 + 1] = -1;
			continue;
		}
		let from = mapping.map(oldChildren[i$1] + oldOffset), fromLocal = from - offset;
		if (fromLocal < 0 || fromLocal >= node.content.size) {
			mustRebuild = true;
			continue;
		}
		let toLocal = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1) - offset;
		let { index, offset: childOffset } = node.content.findIndex(fromLocal);
		let childNode = node.maybeChild(index);
		if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
			let mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, oldChildren[i$1] + oldOffset + 1, options);
			if (mapped != empty) {
				children[i$1] = fromLocal;
				children[i$1 + 1] = toLocal;
				children[i$1 + 2] = mapped;
			} else {
				children[i$1 + 1] = -2;
				mustRebuild = true;
			}
		} else mustRebuild = true;
	}
	if (mustRebuild) {
		let built = buildTree(mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options), node, 0, options);
		newLocal = built.local;
		for (let i$1 = 0; i$1 < children.length; i$1 += 3) if (children[i$1 + 1] < 0) {
			children.splice(i$1, 3);
			i$1 -= 3;
		}
		for (let i$1 = 0, j = 0; i$1 < built.children.length; i$1 += 3) {
			let from = built.children[i$1];
			while (j < children.length && children[j] < from) j += 3;
			children.splice(j, 0, built.children[i$1], built.children[i$1 + 1], built.children[i$1 + 2]);
		}
	}
	return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset) {
	if (!offset || !spans.length) return spans;
	let result = [];
	for (let i$1 = 0; i$1 < spans.length; i$1++) {
		let span = spans[i$1];
		result.push(new Decoration(span.from + offset, span.to + offset, span.type));
	}
	return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
	function gather(set, oldOffset$1) {
		for (let i$1 = 0; i$1 < set.local.length; i$1++) {
			let mapped = set.local[i$1].map(mapping, offset, oldOffset$1);
			if (mapped) decorations.push(mapped);
			else if (options.onRemove) options.onRemove(set.local[i$1].spec);
		}
		for (let i$1 = 0; i$1 < set.children.length; i$1 += 3) gather(set.children[i$1 + 2], set.children[i$1] + oldOffset$1 + 1);
	}
	for (let i$1 = 0; i$1 < children.length; i$1 += 3) if (children[i$1 + 1] == -1) gather(children[i$1 + 2], oldChildren[i$1] + oldOffset + 1);
	return decorations;
}
function takeSpansForNode(spans, node, offset) {
	if (node.isLeaf) return null;
	let end = offset + node.nodeSize, found$1 = null;
	for (let i$1 = 0, span; i$1 < spans.length; i$1++) if ((span = spans[i$1]) && span.from > offset && span.to < end) {
		(found$1 || (found$1 = [])).push(span);
		spans[i$1] = null;
	}
	return found$1;
}
function withoutNulls(array) {
	let result = [];
	for (let i$1 = 0; i$1 < array.length; i$1++) if (array[i$1] != null) result.push(array[i$1]);
	return result;
}
function buildTree(spans, node, offset, options) {
	let children = [], hasNulls = false;
	node.forEach((childNode, localStart) => {
		let found$1 = takeSpansForNode(spans, childNode, localStart + offset);
		if (found$1) {
			hasNulls = true;
			let subtree = buildTree(found$1, childNode, offset + localStart + 1, options);
			if (subtree != empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
		}
	});
	let locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
	for (let i$1 = 0; i$1 < locals.length; i$1++) if (!locals[i$1].type.valid(node, locals[i$1])) {
		if (options.onRemove) options.onRemove(locals[i$1].spec);
		locals.splice(i$1--, 1);
	}
	return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
function byPos(a, b) {
	return a.from - b.from || a.to - b.to;
}
function removeOverlap(spans) {
	let working = spans;
	for (let i$1 = 0; i$1 < working.length - 1; i$1++) {
		let span = working[i$1];
		if (span.from != span.to) for (let j = i$1 + 1; j < working.length; j++) {
			let next = working[j];
			if (next.from == span.from) {
				if (next.to != span.to) {
					if (working == spans) working = spans.slice();
					working[j] = next.copy(next.from, span.to);
					insertAhead(working, j + 1, next.copy(span.to, next.to));
				}
				continue;
			} else {
				if (next.from < span.to) {
					if (working == spans) working = spans.slice();
					working[i$1] = span.copy(span.from, next.from);
					insertAhead(working, j, span.copy(next.from, span.to));
				}
				break;
			}
		}
	}
	return working;
}
function insertAhead(array, i$1, deco) {
	while (i$1 < array.length && byPos(deco, array[i$1]) > 0) i$1++;
	array.splice(i$1, 0, deco);
}
function viewDecorations(view) {
	let found$1 = [];
	view.someProp("decorations", (f) => {
		let result = f(view.state);
		if (result && result != empty) found$1.push(result);
	});
	if (view.cursorWrapper) found$1.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
	return DecorationGroup.from(found$1);
}
var observeOptions = {
	childList: true,
	characterData: true,
	characterDataOldValue: true,
	attributes: true,
	attributeOldValue: true,
	subtree: true
};
var useCharData = ie$1 && ie_version <= 11;
var SelectionState = class {
	constructor() {
		this.anchorNode = null;
		this.anchorOffset = 0;
		this.focusNode = null;
		this.focusOffset = 0;
	}
	set(sel) {
		this.anchorNode = sel.anchorNode;
		this.anchorOffset = sel.anchorOffset;
		this.focusNode = sel.focusNode;
		this.focusOffset = sel.focusOffset;
	}
	clear() {
		this.anchorNode = this.focusNode = null;
	}
	eq(sel) {
		return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
	}
};
var DOMObserver = class {
	constructor(view, handleDOMChange) {
		this.view = view;
		this.handleDOMChange = handleDOMChange;
		this.queue = [];
		this.flushingSoon = -1;
		this.observer = null;
		this.currentSelection = new SelectionState();
		this.onCharData = null;
		this.suppressingSelectionUpdates = false;
		this.lastChangedTextNode = null;
		this.observer = window.MutationObserver && new window.MutationObserver((mutations) => {
			for (let i$1 = 0; i$1 < mutations.length; i$1++) this.queue.push(mutations[i$1]);
			if (ie$1 && ie_version <= 11 && mutations.some((m) => m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
			else if (safari && view.composing && mutations.some((m) => m.type == "childList" && m.target.nodeName == "TR")) {
				view.input.badSafariComposition = true;
				this.flushSoon();
			} else this.flush();
		});
		if (useCharData) this.onCharData = (e) => {
			this.queue.push({
				target: e.target,
				type: "characterData",
				oldValue: e.prevValue
			});
			this.flushSoon();
		};
		this.onSelectionChange = this.onSelectionChange.bind(this);
	}
	flushSoon() {
		if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(() => {
			this.flushingSoon = -1;
			this.flush();
		}, 20);
	}
	forceFlush() {
		if (this.flushingSoon > -1) {
			window.clearTimeout(this.flushingSoon);
			this.flushingSoon = -1;
			this.flush();
		}
	}
	start() {
		if (this.observer) {
			this.observer.takeRecords();
			this.observer.observe(this.view.dom, observeOptions);
		}
		if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
		this.connectSelection();
	}
	stop() {
		if (this.observer) {
			let take = this.observer.takeRecords();
			if (take.length) {
				for (let i$1 = 0; i$1 < take.length; i$1++) this.queue.push(take[i$1]);
				window.setTimeout(() => this.flush(), 20);
			}
			this.observer.disconnect();
		}
		if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
		this.disconnectSelection();
	}
	connectSelection() {
		this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
	}
	disconnectSelection() {
		this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
	}
	suppressSelectionUpdates() {
		this.suppressingSelectionUpdates = true;
		setTimeout(() => this.suppressingSelectionUpdates = false, 50);
	}
	onSelectionChange() {
		if (!hasFocusAndSelection(this.view)) return;
		if (this.suppressingSelectionUpdates) return selectionToDOM(this.view);
		if (ie$1 && ie_version <= 11 && !this.view.state.selection.empty) {
			let sel = this.view.domSelectionRange();
			if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
		}
		this.flush();
	}
	setCurSelection() {
		this.currentSelection.set(this.view.domSelectionRange());
	}
	ignoreSelectionChange(sel) {
		if (!sel.focusNode) return true;
		let ancestors = /* @__PURE__ */ new Set(), container;
		for (let scan = sel.focusNode; scan; scan = parentNode(scan)) ancestors.add(scan);
		for (let scan = sel.anchorNode; scan; scan = parentNode(scan)) if (ancestors.has(scan)) {
			container = scan;
			break;
		}
		let desc = container && this.view.docView.nearestDesc(container);
		if (desc && desc.ignoreMutation({
			type: "selection",
			target: container.nodeType == 3 ? container.parentNode : container
		})) {
			this.setCurSelection();
			return true;
		}
	}
	pendingRecords() {
		if (this.observer) for (let mut of this.observer.takeRecords()) this.queue.push(mut);
		return this.queue;
	}
	flush() {
		let { view } = this;
		if (!view.docView || this.flushingSoon > -1) return;
		let mutations = this.pendingRecords();
		if (mutations.length) this.queue = [];
		let sel = view.domSelectionRange();
		let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
		let from = -1, to = -1, typeOver = false, added = [];
		if (view.editable) for (let i$1 = 0; i$1 < mutations.length; i$1++) {
			let result = this.registerMutation(mutations[i$1], added);
			if (result) {
				from = from < 0 ? result.from : Math.min(result.from, from);
				to = to < 0 ? result.to : Math.max(result.to, to);
				if (result.typeOver) typeOver = true;
			}
		}
		if (added.some((n) => n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
			for (let node of added) if (node.nodeName == "BR" && node.parentNode) {
				let after = node.nextSibling;
				while (after && after.nodeType == 1) {
					if (after.contentEditable == "false") {
						node.parentNode.removeChild(node);
						break;
					}
					after = after.firstChild;
				}
			}
		} else if (gecko && added.length) {
			let brs = added.filter((n) => n.nodeName == "BR");
			if (brs.length == 2) {
				let [a, b] = brs;
				if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
				else a.remove();
			} else {
				let { focusNode } = this.currentSelection;
				for (let br of brs) {
					let parent = br.parentNode;
					if (parent && parent.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent)) br.remove();
				}
			}
		}
		let readSel = null;
		if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) && readSel.eq(Selection.near(view.state.doc.resolve(0), 1))) {
			view.input.lastFocus = 0;
			selectionToDOM(view);
			this.currentSelection.set(sel);
			view.scrollToSelection();
		} else if (from > -1 || newSel) {
			if (from > -1) {
				view.docView.markDirty(from, to);
				checkCSS(view);
			}
			if (view.input.badSafariComposition) {
				view.input.badSafariComposition = false;
				fixUpBadSafariComposition(view, added);
			}
			this.handleDOMChange(from, to, typeOver, added);
			if (view.docView && view.docView.dirty) view.updateState(view.state);
			else if (!this.currentSelection.eq(sel)) selectionToDOM(view);
			this.currentSelection.set(sel);
		}
	}
	registerMutation(mut, added) {
		if (added.indexOf(mut.target) > -1) return null;
		let desc = this.view.docView.nearestDesc(mut.target);
		if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
		if (!desc || desc.ignoreMutation(mut)) return null;
		if (mut.type == "childList") {
			for (let i$1 = 0; i$1 < mut.addedNodes.length; i$1++) {
				let node = mut.addedNodes[i$1];
				added.push(node);
				if (node.nodeType == 3) this.lastChangedTextNode = node;
			}
			if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
				from: desc.posBefore,
				to: desc.posAfter
			};
			let prev = mut.previousSibling, next = mut.nextSibling;
			if (ie$1 && ie_version <= 11 && mut.addedNodes.length) for (let i$1 = 0; i$1 < mut.addedNodes.length; i$1++) {
				let { previousSibling, nextSibling } = mut.addedNodes[i$1];
				if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
				if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
			}
			let fromOffset = prev && prev.parentNode == mut.target ? domIndex(prev) + 1 : 0;
			let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
			let toOffset = next && next.parentNode == mut.target ? domIndex(next) : mut.target.childNodes.length;
			return {
				from,
				to: desc.localPosFromDOM(mut.target, toOffset, 1)
			};
		} else if (mut.type == "attributes") return {
			from: desc.posAtStart - desc.border,
			to: desc.posAtEnd + desc.border
		};
		else {
			this.lastChangedTextNode = mut.target;
			return {
				from: desc.posAtStart,
				to: desc.posAtEnd,
				typeOver: mut.target.nodeValue == mut.oldValue
			};
		}
	}
};
var cssChecked = /* @__PURE__ */ new WeakMap();
var cssCheckWarned = false;
function checkCSS(view) {
	if (cssChecked.has(view)) return;
	cssChecked.set(view, null);
	if ([
		"normal",
		"nowrap",
		"pre-line"
	].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
		view.requiresGeckoHackNode = gecko;
		if (cssCheckWarned) return;
		console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
		cssCheckWarned = true;
	}
}
function rangeToSelectionRange(view, range) {
	let anchorNode = range.startContainer, anchorOffset = range.startOffset;
	let focusNode = range.endContainer, focusOffset = range.endOffset;
	let currentAnchor = view.domAtPos(view.state.selection.anchor);
	if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
		focusNode,
		focusOffset,
		anchorNode,
		anchorOffset
	];
	return {
		anchorNode,
		anchorOffset,
		focusNode,
		focusOffset
	};
}
function safariShadowSelectionRange(view, selection) {
	if (selection.getComposedRanges) {
		let range = selection.getComposedRanges(view.root)[0];
		if (range) return rangeToSelectionRange(view, range);
	}
	let found$1;
	function read(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		found$1 = event.getTargetRanges()[0];
	}
	view.dom.addEventListener("beforeinput", read, true);
	document.execCommand("indent");
	view.dom.removeEventListener("beforeinput", read, true);
	return found$1 ? rangeToSelectionRange(view, found$1) : null;
}
function blockParent(view, node) {
	for (let p = node.parentNode; p && p != view.dom; p = p.parentNode) {
		let desc = view.docView.nearestDesc(p, true);
		if (desc && desc.node.isBlock) return p;
	}
	return null;
}
function fixUpBadSafariComposition(view, addedNodes) {
	var _a;
	let { focusNode, focusOffset } = view.domSelectionRange();
	for (let node of addedNodes) if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
		let nextCell$1 = node.nextSibling;
		while (nextCell$1 && nextCell$1.nodeName != "TD" && nextCell$1.nodeName != "TH") nextCell$1 = nextCell$1.nextSibling;
		if (nextCell$1) {
			let parent = nextCell$1;
			for (;;) {
				let first = parent.firstChild;
				if (!first || first.nodeType != 1 || first.contentEditable == "false" || /^(BR|IMG)$/.test(first.nodeName)) break;
				parent = first;
			}
			parent.insertBefore(node, parent.firstChild);
			if (focusNode == node) view.domSelection().collapse(node, focusOffset);
		} else node.parentNode.removeChild(node);
	}
}
function parseBetween(view, from_, to_) {
	let { node: parent, fromOffset, toOffset, from, to } = view.docView.parseRange(from_, to_);
	let domSel = view.domSelectionRange();
	let find;
	let anchor = domSel.anchorNode;
	if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
		find = [{
			node: anchor,
			offset: domSel.anchorOffset
		}];
		if (!selectionCollapsed(domSel)) find.push({
			node: domSel.focusNode,
			offset: domSel.focusOffset
		});
	}
	if (chrome && view.input.lastKeyCode === 8) for (let off = toOffset; off > fromOffset; off--) {
		let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
		if (node.nodeName == "BR" && !desc) {
			toOffset = off;
			break;
		}
		if (!desc || desc.size) break;
	}
	let startDoc = view.state.doc;
	let parser = view.someProp("domParser") || DOMParser$1.fromSchema(view.state.schema);
	let $from = startDoc.resolve(from);
	let sel = null, doc$2 = parser.parse(parent, {
		topNode: $from.parent,
		topMatch: $from.parent.contentMatchAt($from.index()),
		topOpen: true,
		from: fromOffset,
		to: toOffset,
		preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
		findPositions: find,
		ruleFromNode,
		context: $from
	});
	if (find && find[0].pos != null) {
		let anchor$1 = find[0].pos, head = find[1] && find[1].pos;
		if (head == null) head = anchor$1;
		sel = {
			anchor: anchor$1 + from,
			head: head + from
		};
	}
	return {
		doc: doc$2,
		sel,
		from,
		to
	};
}
function ruleFromNode(dom) {
	let desc = dom.pmViewDesc;
	if (desc) return desc.parseRule();
	else if (dom.nodeName == "BR" && dom.parentNode) {
		if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
			let skip = document.createElement("div");
			skip.appendChild(document.createElement("li"));
			return { skip };
		} else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return { ignore: true };
	} else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return { ignore: true };
	return null;
}
var isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from, to, typeOver, addedNodes) {
	let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
	view.input.compositionPendingChanges = 0;
	if (from < 0) {
		let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
		let newSel = selectionFromDOM(view, origin);
		if (newSel && !view.state.selection.eq(newSel)) {
			if (chrome && android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")))) return;
			let tr = view.state.tr.setSelection(newSel);
			if (origin == "pointer") tr.setMeta("pointer", true);
			else if (origin == "key") tr.scrollIntoView();
			if (compositionID) tr.setMeta("composition", compositionID);
			view.dispatch(tr);
		}
		return;
	}
	let $before = view.state.doc.resolve(from);
	let shared = $before.sharedDepth(to);
	from = $before.before(shared + 1);
	to = view.state.doc.resolve(to).after(shared + 1);
	let sel = view.state.selection;
	let parse$1 = parseBetween(view, from, to);
	let doc$2 = view.state.doc, compare = doc$2.slice(parse$1.from, parse$1.to);
	let preferredPos, preferredSide;
	if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
		preferredPos = view.state.selection.to;
		preferredSide = "end";
	} else {
		preferredPos = view.state.selection.from;
		preferredSide = "start";
	}
	view.input.lastKeyCode = null;
	let change = findDiff(compare.content, parse$1.doc.content, parse$1.from, preferredPos, preferredSide);
	if (change) view.input.domChangeCount++;
	if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) && addedNodes.some((n) => n.nodeType == 1 && !isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")))) {
		view.input.lastIOSEnter = 0;
		return;
	}
	if (!change) if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse$1.sel && parse$1.sel.anchor != parse$1.sel.head)) change = {
		start: sel.from,
		endA: sel.to,
		endB: sel.to
	};
	else {
		if (parse$1.sel) {
			let sel$1 = resolveSelection(view, view.state.doc, parse$1.sel);
			if (sel$1 && !sel$1.eq(view.state.selection)) {
				let tr = view.state.tr.setSelection(sel$1);
				if (compositionID) tr.setMeta("composition", compositionID);
				view.dispatch(tr);
			}
		}
		return;
	}
	if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof TextSelection) {
		if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse$1.from) change.start = view.state.selection.from;
		else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse$1.to) {
			change.endB += view.state.selection.to - change.endA;
			change.endA = view.state.selection.to;
		}
	}
	if (ie$1 && ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse$1.from && parse$1.doc.textBetween(change.start - parse$1.from - 1, change.start - parse$1.from + 1) == " \xA0") {
		change.start--;
		change.endA--;
		change.endB--;
	}
	let $from = parse$1.doc.resolveNoCache(change.start - parse$1.from);
	let $to = parse$1.doc.resolveNoCache(change.endB - parse$1.from);
	let $fromA = doc$2.resolve(change.start);
	let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
	if ((ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n) => n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse$1.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse$1.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(13, "Enter")))) {
		view.input.lastIOSEnter = 0;
		return;
	}
	if (view.state.selection.anchor > change.start && looksLikeBackspace(doc$2, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f) => f(view, keyEvent(8, "Backspace")))) {
		if (android && chrome) view.domObserver.suppressSelectionUpdates();
		return;
	}
	if (chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
	if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse$1.sel && parse$1.sel.anchor == parse$1.sel.head && parse$1.sel.head == change.endA) {
		change.endB -= 2;
		$to = parse$1.doc.resolveNoCache(change.endB - parse$1.from);
		setTimeout(() => {
			view.someProp("handleKeyDown", function(f) {
				return f(view, keyEvent(13, "Enter"));
			});
		}, 20);
	}
	let chFrom = change.start, chTo = change.endA;
	let mkTr = (base$1) => {
		let tr = base$1 || view.state.tr.replace(chFrom, chTo, parse$1.doc.slice(change.start - parse$1.from, change.endB - parse$1.from));
		if (parse$1.sel) {
			let sel$1 = resolveSelection(view, tr.doc, parse$1.sel);
			if (sel$1 && !(chrome && view.composing && sel$1.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel$1.head == chFrom || sel$1.head == tr.mapping.map(chTo) - 1) || ie$1 && sel$1.empty && sel$1.head == chFrom)) tr.setSelection(sel$1);
		}
		if (compositionID) tr.setMeta("composition", compositionID);
		return tr.scrollIntoView();
	};
	let markChange;
	if (inlineChange) if ($from.pos == $to.pos) {
		if (ie$1 && ie_version <= 11 && $from.parentOffset == 0) {
			view.domObserver.suppressSelectionUpdates();
			setTimeout(() => selectionToDOM(view), 20);
		}
		let tr = mkTr(view.state.tr.delete(chFrom, chTo));
		let marks = doc$2.resolve(change.start).marksAcross(doc$2.resolve(change.endA));
		if (marks) tr.ensureMarks(marks);
		view.dispatch(tr);
	} else if (change.endA == change.endB && (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
		let tr = mkTr(view.state.tr);
		if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
		else tr.removeMark(chFrom, chTo, markChange.mark);
		view.dispatch(tr);
	} else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
		let text$2 = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
		let deflt = () => mkTr(view.state.tr.insertText(text$2, chFrom, chTo));
		if (!view.someProp("handleTextInput", (f) => f(view, chFrom, chTo, text$2, deflt))) view.dispatch(deflt());
	} else view.dispatch(mkTr());
	else view.dispatch(mkTr());
}
function resolveSelection(view, doc$2, parsedSel) {
	if (Math.max(parsedSel.anchor, parsedSel.head) > doc$2.content.size) return null;
	return selectionBetween(view, doc$2.resolve(parsedSel.anchor), doc$2.resolve(parsedSel.head));
}
function isMarkChange(cur, prev) {
	let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
	let added = curMarks, removed = prevMarks, type, mark, update;
	for (let i$1 = 0; i$1 < prevMarks.length; i$1++) added = prevMarks[i$1].removeFromSet(added);
	for (let i$1 = 0; i$1 < curMarks.length; i$1++) removed = curMarks[i$1].removeFromSet(removed);
	if (added.length == 1 && removed.length == 0) {
		mark = added[0];
		type = "add";
		update = (node) => node.mark(mark.addToSet(node.marks));
	} else if (added.length == 0 && removed.length == 1) {
		mark = removed[0];
		type = "remove";
		update = (node) => node.mark(mark.removeFromSet(node.marks));
	} else return null;
	let updated = [];
	for (let i$1 = 0; i$1 < prev.childCount; i$1++) updated.push(update(prev.child(i$1)));
	if (Fragment.from(updated).eq(cur)) return {
		mark,
		type
	};
}
function looksLikeBackspace(old, start, end, $newStart, $newEnd) {
	if (end - start <= $newEnd.pos - $newStart.pos || skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
	let $start = old.resolve(start);
	if (!$newStart.parent.isTextblock) {
		let after = $start.nodeAfter;
		return after != null && end == start + after.nodeSize;
	}
	if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
	let $next = old.resolve(skipClosingAndOpening($start, true, true));
	if (!$next.parent.isTextblock || $next.pos > end || skipClosingAndOpening($next, true, false) < end) return false;
	return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
	let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
	while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
		depth--;
		end++;
		fromEnd = false;
	}
	if (mayOpen) {
		let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
		while (next && !next.isLeaf) {
			next = next.firstChild;
			end++;
		}
	}
	return end;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
	let start = a.findDiffStart(b, pos);
	if (start == null) return null;
	let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
	if (preferredSide == "end") {
		let adjust = Math.max(0, start - Math.min(endA, endB));
		preferredPos -= endA + adjust - start;
	}
	if (endA < start && a.size < b.size) {
		let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
		start -= move;
		if (start && start < b.size && isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
		endB = start + (endB - endA);
		endA = start;
	} else if (endB < start) {
		let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
		start -= move;
		if (start && start < a.size && isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
		endA = start + (endA - endB);
		endB = start;
	}
	return {
		start,
		endA,
		endB
	};
}
function isSurrogatePair(str) {
	if (str.length != 2) return false;
	let a = str.charCodeAt(0), b = str.charCodeAt(1);
	return a >= 56320 && a <= 57343 && b >= 55296 && b <= 56319;
}
var __endComposition = endComposition;
var EditorView = class {
	constructor(place, props) {
		this._root = null;
		this.focused = false;
		this.trackWrites = null;
		this.mounted = false;
		this.markCursor = null;
		this.cursorWrapper = null;
		this.lastSelectedViewDesc = void 0;
		this.input = new InputState();
		this.prevDirectPlugins = [];
		this.pluginViews = [];
		this.requiresGeckoHackNode = false;
		this.dragging = null;
		this._props = props;
		this.state = props.state;
		this.directPlugins = props.plugins || [];
		this.directPlugins.forEach(checkStateComponent);
		this.dispatch = this.dispatch.bind(this);
		this.dom = place && place.mount || document.createElement("div");
		if (place) {
			if (place.appendChild) place.appendChild(this.dom);
			else if (typeof place == "function") place(this.dom);
			else if (place.mount) this.mounted = true;
		}
		this.editable = getEditable(this);
		updateCursorWrapper(this);
		this.nodeViews = buildNodeViews(this);
		this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
		this.domObserver = new DOMObserver(this, (from, to, typeOver, added) => readDOMChange(this, from, to, typeOver, added));
		this.domObserver.start();
		initInput(this);
		this.updatePluginViews();
	}
	get composing() {
		return this.input.composing;
	}
	get props() {
		if (this._props.state != this.state) {
			let prev = this._props;
			this._props = {};
			for (let name in prev) this._props[name] = prev[name];
			this._props.state = this.state;
		}
		return this._props;
	}
	update(props) {
		if (props.handleDOMEvents != this._props.handleDOMEvents) ensureListeners(this);
		let prevProps = this._props;
		this._props = props;
		if (props.plugins) {
			props.plugins.forEach(checkStateComponent);
			this.directPlugins = props.plugins;
		}
		this.updateStateInner(props.state, prevProps);
	}
	setProps(props) {
		let updated = {};
		for (let name in this._props) updated[name] = this._props[name];
		updated.state = this.state;
		for (let name in props) updated[name] = props[name];
		this.update(updated);
	}
	updateState(state) {
		this.updateStateInner(state, this._props);
	}
	updateStateInner(state, prevProps) {
		var _a;
		let prev = this.state, redraw = false, updateSel = false;
		if (state.storedMarks && this.composing) {
			clearComposition(this);
			updateSel = true;
		}
		this.state = state;
		let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
		if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
			let nodeViews = buildNodeViews(this);
			if (changedNodeViews(nodeViews, this.nodeViews)) {
				this.nodeViews = nodeViews;
				redraw = true;
			}
		}
		if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) ensureListeners(this);
		this.editable = getEditable(this);
		updateCursorWrapper(this);
		let innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
		let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
		let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
		if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
		let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
		if (updateSel) {
			this.domObserver.stop();
			let forceSelUpdate = updateDoc && (ie$1 || chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
			if (updateDoc) {
				let chromeKludge = chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
				if (this.composing) this.input.compositionNode = findCompositionNode(this);
				if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
					this.docView.updateOuterDeco(outerDeco);
					this.docView.destroy();
					this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
				}
				if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites))) forceSelUpdate = true;
			}
			if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && anchorInRightPlace(this))) selectionToDOM(this, forceSelUpdate);
			else {
				syncNodeSelection(this, state.selection);
				this.domObserver.setCurSelection();
			}
			this.domObserver.start();
		}
		this.updatePluginViews(prev);
		if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
		if (scroll == "reset") this.dom.scrollTop = 0;
		else if (scroll == "to selection") this.scrollToSelection();
		else if (oldScrollPos) resetScrollPos(oldScrollPos);
	}
	scrollToSelection() {
		let startDOM = this.domSelectionRange().focusNode;
		if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode));
		else if (this.someProp("handleScrollToSelection", (f) => f(this)));
		else if (this.state.selection instanceof NodeSelection) {
			let target = this.docView.domAfterPos(this.state.selection.from);
			if (target.nodeType == 1) scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
		} else scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
	}
	destroyPluginViews() {
		let view;
		while (view = this.pluginViews.pop()) if (view.destroy) view.destroy();
	}
	updatePluginViews(prevState) {
		if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
			this.prevDirectPlugins = this.directPlugins;
			this.destroyPluginViews();
			for (let i$1 = 0; i$1 < this.directPlugins.length; i$1++) {
				let plugin = this.directPlugins[i$1];
				if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
			}
			for (let i$1 = 0; i$1 < this.state.plugins.length; i$1++) {
				let plugin = this.state.plugins[i$1];
				if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
			}
		} else for (let i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
			let pluginView = this.pluginViews[i$1];
			if (pluginView.update) pluginView.update(this, prevState);
		}
	}
	updateDraggedNode(dragging, prev) {
		let sel = dragging.node, found$1 = -1;
		if (sel.from < this.state.doc.content.size && this.state.doc.nodeAt(sel.from) == sel.node) found$1 = sel.from;
		else {
			let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
			if ((movedPos > 0 && movedPos < this.state.doc.content.size && this.state.doc.nodeAt(movedPos)) == sel.node) found$1 = movedPos;
		}
		this.dragging = new Dragging(dragging.slice, dragging.move, found$1 < 0 ? void 0 : NodeSelection.create(this.state.doc, found$1));
	}
	someProp(propName, f) {
		let prop = this._props && this._props[propName], value;
		if (prop != null && (value = f ? f(prop) : prop)) return value;
		for (let i$1 = 0; i$1 < this.directPlugins.length; i$1++) {
			let prop$1 = this.directPlugins[i$1].props[propName];
			if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) return value;
		}
		let plugins = this.state.plugins;
		if (plugins) for (let i$1 = 0; i$1 < plugins.length; i$1++) {
			let prop$1 = plugins[i$1].props[propName];
			if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) return value;
		}
	}
	hasFocus() {
		if (ie$1) {
			let node = this.root.activeElement;
			if (node == this.dom) return true;
			if (!node || !this.dom.contains(node)) return false;
			while (node && this.dom != node && this.dom.contains(node)) {
				if (node.contentEditable == "false") return false;
				node = node.parentElement;
			}
			return true;
		}
		return this.root.activeElement == this.dom;
	}
	focus() {
		this.domObserver.stop();
		if (this.editable) focusPreventScroll(this.dom);
		selectionToDOM(this);
		this.domObserver.start();
	}
	get root() {
		let cached = this._root;
		if (cached == null) {
			for (let search$1 = this.dom.parentNode; search$1; search$1 = search$1.parentNode) if (search$1.nodeType == 9 || search$1.nodeType == 11 && search$1.host) {
				if (!search$1.getSelection) Object.getPrototypeOf(search$1).getSelection = () => search$1.ownerDocument.getSelection();
				return this._root = search$1;
			}
		}
		return cached || document;
	}
	updateRoot() {
		this._root = null;
	}
	posAtCoords(coords) {
		return posAtCoords(this, coords);
	}
	coordsAtPos(pos, side = 1) {
		return coordsAtPos(this, pos, side);
	}
	domAtPos(pos, side = 0) {
		return this.docView.domFromPos(pos, side);
	}
	nodeDOM(pos) {
		let desc = this.docView.descAt(pos);
		return desc ? desc.nodeDOM : null;
	}
	posAtDOM(node, offset, bias = -1) {
		let pos = this.docView.posFromDOM(node, offset, bias);
		if (pos == null) throw new RangeError("DOM position not inside the editor");
		return pos;
	}
	endOfTextblock(dir, state) {
		return endOfTextblock(this, state || this.state, dir);
	}
	pasteHTML(html, event) {
		return doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
	}
	pasteText(text$2, event) {
		return doPaste(this, text$2, null, true, event || new ClipboardEvent("paste"));
	}
	serializeForClipboard(slice) {
		return serializeForClipboard(this, slice);
	}
	destroy() {
		if (!this.docView) return;
		destroyInput(this);
		this.destroyPluginViews();
		if (this.mounted) {
			this.docView.update(this.state.doc, [], viewDecorations(this), this);
			this.dom.textContent = "";
		} else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
		this.docView.destroy();
		this.docView = null;
		clearReusedRange();
	}
	get isDestroyed() {
		return this.docView == null;
	}
	dispatchEvent(event) {
		return dispatchEvent(this, event);
	}
	domSelectionRange() {
		let sel = this.domSelection();
		if (!sel) return {
			focusNode: null,
			focusOffset: 0,
			anchorNode: null,
			anchorOffset: 0
		};
		return safari && this.root.nodeType === 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
	}
	domSelection() {
		return this.root.getSelection();
	}
};
EditorView.prototype.dispatch = function(tr) {
	let dispatchTransaction = this._props.dispatchTransaction;
	if (dispatchTransaction) dispatchTransaction.call(this, tr);
	else this.updateState(this.state.apply(tr));
};
function computeDocDeco(view) {
	let attrs = Object.create(null);
	attrs.class = "ProseMirror";
	attrs.contenteditable = String(view.editable);
	view.someProp("attributes", (value) => {
		if (typeof value == "function") value = value(view.state);
		if (value) {
			for (let attr in value) if (attr == "class") attrs.class += " " + value[attr];
			else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
			else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
		}
	});
	if (!attrs.translate) attrs.translate = "no";
	return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
	if (view.markCursor) {
		let dom = document.createElement("img");
		dom.className = "ProseMirror-separator";
		dom.setAttribute("mark-placeholder", "true");
		dom.setAttribute("alt", "");
		view.cursorWrapper = {
			dom,
			deco: Decoration.widget(view.state.selection.from, dom, {
				raw: true,
				marks: view.markCursor
			})
		};
	} else view.cursorWrapper = null;
}
function getEditable(view) {
	return !view.someProp("editable", (value) => value(view.state) === false);
}
function selectionContextChanged(sel1, sel2) {
	let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
	return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
	let result = Object.create(null);
	function add(obj) {
		for (let prop in obj) if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
	}
	view.someProp("nodeViews", add);
	view.someProp("markViews", add);
	return result;
}
function changedNodeViews(a, b) {
	let nA = 0, nB = 0;
	for (let prop in a) {
		if (a[prop] != b[prop]) return true;
		nA++;
	}
	for (let _ in b) nB++;
	return nA != nB;
}
function checkStateComponent(plugin) {
	if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var base = {
	8: "Backspace",
	9: "Tab",
	10: "Enter",
	12: "NumLock",
	13: "Enter",
	16: "Shift",
	17: "Control",
	18: "Alt",
	20: "CapsLock",
	27: "Escape",
	32: " ",
	33: "PageUp",
	34: "PageDown",
	35: "End",
	36: "Home",
	37: "ArrowLeft",
	38: "ArrowUp",
	39: "ArrowRight",
	40: "ArrowDown",
	44: "PrintScreen",
	45: "Insert",
	46: "Delete",
	59: ";",
	61: "=",
	91: "Meta",
	92: "Meta",
	106: "*",
	107: "+",
	108: ",",
	109: "-",
	110: ".",
	111: "/",
	144: "NumLock",
	145: "ScrollLock",
	160: "Shift",
	161: "Shift",
	162: "Control",
	163: "Control",
	164: "Alt",
	165: "Alt",
	173: "-",
	186: ";",
	187: "=",
	188: ",",
	189: "-",
	190: ".",
	191: "/",
	192: "`",
	219: "[",
	220: "\\",
	221: "]",
	222: "'"
};
var shift = {
	48: ")",
	49: "!",
	50: "@",
	51: "#",
	52: "$",
	53: "%",
	54: "^",
	55: "&",
	56: "*",
	57: "(",
	59: ":",
	61: "+",
	173: "_",
	186: ":",
	187: "+",
	188: "<",
	189: "_",
	190: ">",
	191: "?",
	192: "~",
	219: "{",
	220: "|",
	221: "}",
	222: "\""
};
var mac$1 = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;
for (var i = 65; i <= 90; i++) {
	base[i] = String.fromCharCode(i + 32);
	shift[i] = String.fromCharCode(i);
}
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];
function keyName(event) {
	var name = !(mac$1 && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified") && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
	if (name == "Esc") name = "Escape";
	if (name == "Del") name = "Delete";
	if (name == "Left") name = "ArrowLeft";
	if (name == "Up") name = "ArrowUp";
	if (name == "Right") name = "ArrowRight";
	if (name == "Down") name = "ArrowDown";
	return name;
}
var mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
var windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function normalizeKeyName(name) {
	let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
	if (result == "Space") result = " ";
	let alt, ctrl, shift$1, meta;
	for (let i$1 = 0; i$1 < parts.length - 1; i$1++) {
		let mod = parts[i$1];
		if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
		else if (/^a(lt)?$/i.test(mod)) alt = true;
		else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
		else if (/^s(hift)?$/i.test(mod)) shift$1 = true;
		else if (/^mod$/i.test(mod)) if (mac) meta = true;
		else ctrl = true;
		else throw new Error("Unrecognized modifier name: " + mod);
	}
	if (alt) result = "Alt-" + result;
	if (ctrl) result = "Ctrl-" + result;
	if (meta) result = "Meta-" + result;
	if (shift$1) result = "Shift-" + result;
	return result;
}
function normalize(map) {
	let copy$1 = Object.create(null);
	for (let prop in map) copy$1[normalizeKeyName(prop)] = map[prop];
	return copy$1;
}
function modifiers(name, event, shift$1 = true) {
	if (event.altKey) name = "Alt-" + name;
	if (event.ctrlKey) name = "Ctrl-" + name;
	if (event.metaKey) name = "Meta-" + name;
	if (shift$1 && event.shiftKey) name = "Shift-" + name;
	return name;
}
function keymap(bindings) {
	return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
function keydownHandler(bindings) {
	let map = normalize(bindings);
	return function(view, event) {
		let name = keyName(event), baseName, direct = map[modifiers(name, event)];
		if (direct && direct(view.state, view.dispatch, view)) return true;
		if (name.length == 1 && name != " ") {
			if (event.shiftKey) {
				let noShift = map[modifiers(name, event, false)];
				if (noShift && noShift(view.state, view.dispatch, view)) return true;
			}
			if ((event.altKey || event.metaKey || event.ctrlKey) && !(windows && event.ctrlKey && event.altKey) && (baseName = base[event.keyCode]) && baseName != name) {
				let fromCode = map[modifiers(baseName, event)];
				if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
			}
		}
		return false;
	};
}
var readFromCache;
var addToCache;
if (typeof WeakMap != "undefined") {
	let cache = /* @__PURE__ */ new WeakMap();
	readFromCache = (key) => cache.get(key);
	addToCache = (key, value) => {
		cache.set(key, value);
		return value;
	};
} else {
	const cache = [];
	const cacheSize = 10;
	let cachePos = 0;
	readFromCache = (key) => {
		for (let i$1 = 0; i$1 < cache.length; i$1 += 2) if (cache[i$1] == key) return cache[i$1 + 1];
	};
	addToCache = (key, value) => {
		if (cachePos == cacheSize) cachePos = 0;
		cache[cachePos++] = key;
		return cache[cachePos++] = value;
	};
}
var TableMap = class {
	constructor(width, height, map, problems) {
		this.width = width;
		this.height = height;
		this.map = map;
		this.problems = problems;
	}
	findCell(pos) {
		for (let i$1 = 0; i$1 < this.map.length; i$1++) {
			const curPos = this.map[i$1];
			if (curPos != pos) continue;
			const left = i$1 % this.width;
			const top = i$1 / this.width | 0;
			let right = left + 1;
			let bottom = top + 1;
			for (let j = 1; right < this.width && this.map[i$1 + j] == curPos; j++) right++;
			for (let j = 1; bottom < this.height && this.map[i$1 + this.width * j] == curPos; j++) bottom++;
			return {
				left,
				top,
				right,
				bottom
			};
		}
		throw new RangeError(`No cell with offset ${pos} found`);
	}
	colCount(pos) {
		for (let i$1 = 0; i$1 < this.map.length; i$1++) if (this.map[i$1] == pos) return i$1 % this.width;
		throw new RangeError(`No cell with offset ${pos} found`);
	}
	nextCell(pos, axis, dir) {
		const { left, right, top, bottom } = this.findCell(pos);
		if (axis == "horiz") {
			if (dir < 0 ? left == 0 : right == this.width) return null;
			return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
		} else {
			if (dir < 0 ? top == 0 : bottom == this.height) return null;
			return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
		}
	}
	rectBetween(a, b) {
		const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
		const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
		return {
			left: Math.min(leftA, leftB),
			top: Math.min(topA, topB),
			right: Math.max(rightA, rightB),
			bottom: Math.max(bottomA, bottomB)
		};
	}
	cellsInRect(rect) {
		const result = [];
		const seen = {};
		for (let row = rect.top; row < rect.bottom; row++) for (let col = rect.left; col < rect.right; col++) {
			const index = row * this.width + col;
			const pos = this.map[index];
			if (seen[pos]) continue;
			seen[pos] = true;
			if (col == rect.left && col && this.map[index - 1] == pos || row == rect.top && row && this.map[index - this.width] == pos) continue;
			result.push(pos);
		}
		return result;
	}
	positionAt(row, col, table) {
		for (let i$1 = 0, rowStart = 0;; i$1++) {
			const rowEnd = rowStart + table.child(i$1).nodeSize;
			if (i$1 == row) {
				let index = col + row * this.width;
				const rowEndIndex = (row + 1) * this.width;
				while (index < rowEndIndex && this.map[index] < rowStart) index++;
				return index == rowEndIndex ? rowEnd - 1 : this.map[index];
			}
			rowStart = rowEnd;
		}
	}
	static get(table) {
		return readFromCache(table) || addToCache(table, computeMap(table));
	}
};
function computeMap(table) {
	if (table.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + table.type.name);
	const width = findWidth(table), height = table.childCount;
	const map = [];
	let mapPos = 0;
	let problems = null;
	const colWidths = [];
	for (let i$1 = 0, e = width * height; i$1 < e; i$1++) map[i$1] = 0;
	for (let row = 0, pos = 0; row < height; row++) {
		const rowNode = table.child(row);
		pos++;
		for (let i$1 = 0;; i$1++) {
			while (mapPos < map.length && map[mapPos] != 0) mapPos++;
			if (i$1 == rowNode.childCount) break;
			const cellNode = rowNode.child(i$1);
			const { colspan, rowspan, colwidth } = cellNode.attrs;
			for (let h = 0; h < rowspan; h++) {
				if (h + row >= height) {
					(problems || (problems = [])).push({
						type: "overlong_rowspan",
						pos,
						n: rowspan - h
					});
					break;
				}
				const start = mapPos + h * width;
				for (let w = 0; w < colspan; w++) {
					if (map[start + w] == 0) map[start + w] = pos;
					else (problems || (problems = [])).push({
						type: "collision",
						row,
						pos,
						n: colspan - w
					});
					const colW = colwidth && colwidth[w];
					if (colW) {
						const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
						if (prev == null || prev != colW && colWidths[widthIndex + 1] == 1) {
							colWidths[widthIndex] = colW;
							colWidths[widthIndex + 1] = 1;
						} else if (prev == colW) colWidths[widthIndex + 1]++;
					}
				}
			}
			mapPos += colspan;
			pos += cellNode.nodeSize;
		}
		const expectedPos = (row + 1) * width;
		let missing = 0;
		while (mapPos < expectedPos) if (map[mapPos++] == 0) missing++;
		if (missing) (problems || (problems = [])).push({
			type: "missing",
			row,
			n: missing
		});
		pos++;
	}
	if (width === 0 || height === 0) (problems || (problems = [])).push({ type: "zero_sized" });
	const tableMap = new TableMap(width, height, map, problems);
	let badWidths = false;
	for (let i$1 = 0; !badWidths && i$1 < colWidths.length; i$1 += 2) if (colWidths[i$1] != null && colWidths[i$1 + 1] < height) badWidths = true;
	if (badWidths) findBadColWidths(tableMap, colWidths, table);
	return tableMap;
}
function findWidth(table) {
	let width = -1;
	let hasRowSpan = false;
	for (let row = 0; row < table.childCount; row++) {
		const rowNode = table.child(row);
		let rowWidth = 0;
		if (hasRowSpan) for (let j = 0; j < row; j++) {
			const prevRow = table.child(j);
			for (let i$1 = 0; i$1 < prevRow.childCount; i$1++) {
				const cell = prevRow.child(i$1);
				if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
			}
		}
		for (let i$1 = 0; i$1 < rowNode.childCount; i$1++) {
			const cell = rowNode.child(i$1);
			rowWidth += cell.attrs.colspan;
			if (cell.attrs.rowspan > 1) hasRowSpan = true;
		}
		if (width == -1) width = rowWidth;
		else if (width != rowWidth) width = Math.max(width, rowWidth);
	}
	return width;
}
function findBadColWidths(map, colWidths, table) {
	if (!map.problems) map.problems = [];
	const seen = {};
	for (let i$1 = 0; i$1 < map.map.length; i$1++) {
		const pos = map.map[i$1];
		if (seen[pos]) continue;
		seen[pos] = true;
		const node = table.nodeAt(pos);
		if (!node) throw new RangeError(`No cell with offset ${pos} found`);
		let updated = null;
		const attrs = node.attrs;
		for (let j = 0; j < attrs.colspan; j++) {
			const colWidth = colWidths[(i$1 + j) % map.width * 2];
			if (colWidth != null && (!attrs.colwidth || attrs.colwidth[j] != colWidth)) (updated || (updated = freshColWidth(attrs)))[j] = colWidth;
		}
		if (updated) map.problems.unshift({
			type: "colwidth mismatch",
			pos,
			colwidth: updated
		});
	}
}
function freshColWidth(attrs) {
	if (attrs.colwidth) return attrs.colwidth.slice();
	const result = [];
	for (let i$1 = 0; i$1 < attrs.colspan; i$1++) result.push(0);
	return result;
}
function tableNodeTypes(schema) {
	let result = schema.cached.tableNodeTypes;
	if (!result) {
		result = schema.cached.tableNodeTypes = {};
		for (const name in schema.nodes) {
			const type = schema.nodes[name], role = type.spec.tableRole;
			if (role) result[role] = type;
		}
	}
	return result;
}
var tableEditingKey = new PluginKey("selectingCells");
function cellAround($pos) {
	for (let d = $pos.depth - 1; d > 0; d--) if ($pos.node(d).type.spec.tableRole == "row") return $pos.node(0).resolve($pos.before(d + 1));
	return null;
}
function cellWrapping($pos) {
	for (let d = $pos.depth; d > 0; d--) {
		const role = $pos.node(d).type.spec.tableRole;
		if (role === "cell" || role === "header_cell") return $pos.node(d);
	}
	return null;
}
function isInTable$1(state) {
	const $head = state.selection.$head;
	for (let d = $head.depth; d > 0; d--) if ($head.node(d).type.spec.tableRole == "row") return true;
	return false;
}
function selectionCell(state) {
	const sel = state.selection;
	if ("$anchorCell" in sel && sel.$anchorCell) return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
	else if ("node" in sel && sel.node && sel.node.type.spec.tableRole == "cell") return sel.$anchor;
	const $cell = cellAround(sel.$head) || cellNear(sel.$head);
	if ($cell) return $cell;
	throw new RangeError(`No cell found around position ${sel.head}`);
}
function cellNear($pos) {
	for (let after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
		const role = after.type.spec.tableRole;
		if (role == "cell" || role == "header_cell") return $pos.doc.resolve(pos);
	}
	for (let before = $pos.nodeBefore, pos = $pos.pos; before; before = before.lastChild, pos--) {
		const role = before.type.spec.tableRole;
		if (role == "cell" || role == "header_cell") return $pos.doc.resolve(pos - before.nodeSize);
	}
}
function pointsAtCell($pos) {
	return $pos.parent.type.spec.tableRole == "row" && !!$pos.nodeAfter;
}
function moveCellForward($pos) {
	return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
}
function inSameTable($cellA, $cellB) {
	return $cellA.depth == $cellB.depth && $cellA.pos >= $cellB.start(-1) && $cellA.pos <= $cellB.end(-1);
}
function nextCell($pos, axis, dir) {
	const table = $pos.node(-1);
	const map = TableMap.get(table);
	const tableStart = $pos.start(-1);
	const moved = map.nextCell($pos.pos - tableStart, axis, dir);
	return moved == null ? null : $pos.node(0).resolve(tableStart + moved);
}
function removeColSpan(attrs, pos, n = 1) {
	const result = {
		...attrs,
		colspan: attrs.colspan - n
	};
	if (result.colwidth) {
		result.colwidth = result.colwidth.slice();
		result.colwidth.splice(pos, n);
		if (!result.colwidth.some((w) => w > 0)) result.colwidth = null;
	}
	return result;
}
function addColSpan(attrs, pos, n = 1) {
	const result = {
		...attrs,
		colspan: attrs.colspan + n
	};
	if (result.colwidth) {
		result.colwidth = result.colwidth.slice();
		for (let i$1 = 0; i$1 < n; i$1++) result.colwidth.splice(pos, 0, 0);
	}
	return result;
}
function columnIsHeader(map, table, col) {
	const headerCell = tableNodeTypes(table.type.schema).header_cell;
	for (let row = 0; row < map.height; row++) if (table.nodeAt(map.map[col + row * map.width]).type != headerCell) return false;
	return true;
}
var CellSelection = class CellSelection$1 extends Selection {
	constructor($anchorCell, $headCell = $anchorCell) {
		const table = $anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = $anchorCell.start(-1);
		const rect = map.rectBetween($anchorCell.pos - tableStart, $headCell.pos - tableStart);
		const doc$2 = $anchorCell.node(0);
		const cells = map.cellsInRect(rect).filter((p) => p != $headCell.pos - tableStart);
		cells.unshift($headCell.pos - tableStart);
		const ranges = cells.map((pos) => {
			const cell = table.nodeAt(pos);
			if (!cell) throw new RangeError(`No cell with offset ${pos} found`);
			const from = tableStart + pos + 1;
			return new SelectionRange(doc$2.resolve(from), doc$2.resolve(from + cell.content.size));
		});
		super(ranges[0].$from, ranges[0].$to, ranges);
		this.$anchorCell = $anchorCell;
		this.$headCell = $headCell;
	}
	map(doc$2, mapping) {
		const $anchorCell = doc$2.resolve(mapping.map(this.$anchorCell.pos));
		const $headCell = doc$2.resolve(mapping.map(this.$headCell.pos));
		if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
			const tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
			if (tableChanged && this.isRowSelection()) return CellSelection$1.rowSelection($anchorCell, $headCell);
			else if (tableChanged && this.isColSelection()) return CellSelection$1.colSelection($anchorCell, $headCell);
			else return new CellSelection$1($anchorCell, $headCell);
		}
		return TextSelection.between($anchorCell, $headCell);
	}
	content() {
		const table = this.$anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = this.$anchorCell.start(-1);
		const rect = map.rectBetween(this.$anchorCell.pos - tableStart, this.$headCell.pos - tableStart);
		const seen = {};
		const rows = [];
		for (let row = rect.top; row < rect.bottom; row++) {
			const rowContent = [];
			for (let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
				const pos = map.map[index];
				if (seen[pos]) continue;
				seen[pos] = true;
				const cellRect = map.findCell(pos);
				let cell = table.nodeAt(pos);
				if (!cell) throw new RangeError(`No cell with offset ${pos} found`);
				const extraLeft = rect.left - cellRect.left;
				const extraRight = cellRect.right - rect.right;
				if (extraLeft > 0 || extraRight > 0) {
					let attrs = cell.attrs;
					if (extraLeft > 0) attrs = removeColSpan(attrs, 0, extraLeft);
					if (extraRight > 0) attrs = removeColSpan(attrs, attrs.colspan - extraRight, extraRight);
					if (cellRect.left < rect.left) {
						cell = cell.type.createAndFill(attrs);
						if (!cell) throw new RangeError(`Could not create cell with attrs ${JSON.stringify(attrs)}`);
					} else cell = cell.type.create(attrs, cell.content);
				}
				if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
					const attrs = {
						...cell.attrs,
						rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
					};
					if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
					else cell = cell.type.create(attrs, cell.content);
				}
				rowContent.push(cell);
			}
			rows.push(table.child(row).copy(Fragment.from(rowContent)));
		}
		const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
		return new Slice(Fragment.from(fragment), 1, 1);
	}
	replace(tr, content$2 = Slice.empty) {
		const mapFrom = tr.steps.length, ranges = this.ranges;
		for (let i$1 = 0; i$1 < ranges.length; i$1++) {
			const { $from, $to } = ranges[i$1], mapping = tr.mapping.slice(mapFrom);
			tr.replace(mapping.map($from.pos), mapping.map($to.pos), i$1 ? Slice.empty : content$2);
		}
		const sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
		if (sel) tr.setSelection(sel);
	}
	replaceWith(tr, node) {
		this.replace(tr, new Slice(Fragment.from(node), 0, 0));
	}
	forEachCell(f) {
		const table = this.$anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = this.$anchorCell.start(-1);
		const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - tableStart, this.$headCell.pos - tableStart));
		for (let i$1 = 0; i$1 < cells.length; i$1++) f(table.nodeAt(cells[i$1]), tableStart + cells[i$1]);
	}
	isColSelection() {
		const anchorTop = this.$anchorCell.index(-1);
		const headTop = this.$headCell.index(-1);
		if (Math.min(anchorTop, headTop) > 0) return false;
		const anchorBottom = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
		const headBottom = headTop + this.$headCell.nodeAfter.attrs.rowspan;
		return Math.max(anchorBottom, headBottom) == this.$headCell.node(-1).childCount;
	}
	static colSelection($anchorCell, $headCell = $anchorCell) {
		const table = $anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = $anchorCell.start(-1);
		const anchorRect = map.findCell($anchorCell.pos - tableStart);
		const headRect = map.findCell($headCell.pos - tableStart);
		const doc$2 = $anchorCell.node(0);
		if (anchorRect.top <= headRect.top) {
			if (anchorRect.top > 0) $anchorCell = doc$2.resolve(tableStart + map.map[anchorRect.left]);
			if (headRect.bottom < map.height) $headCell = doc$2.resolve(tableStart + map.map[map.width * (map.height - 1) + headRect.right - 1]);
		} else {
			if (headRect.top > 0) $headCell = doc$2.resolve(tableStart + map.map[headRect.left]);
			if (anchorRect.bottom < map.height) $anchorCell = doc$2.resolve(tableStart + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
		}
		return new CellSelection$1($anchorCell, $headCell);
	}
	isRowSelection() {
		const table = this.$anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = this.$anchorCell.start(-1);
		const anchorLeft = map.colCount(this.$anchorCell.pos - tableStart);
		const headLeft = map.colCount(this.$headCell.pos - tableStart);
		if (Math.min(anchorLeft, headLeft) > 0) return false;
		const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
		const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
		return Math.max(anchorRight, headRight) == map.width;
	}
	eq(other) {
		return other instanceof CellSelection$1 && other.$anchorCell.pos == this.$anchorCell.pos && other.$headCell.pos == this.$headCell.pos;
	}
	static rowSelection($anchorCell, $headCell = $anchorCell) {
		const table = $anchorCell.node(-1);
		const map = TableMap.get(table);
		const tableStart = $anchorCell.start(-1);
		const anchorRect = map.findCell($anchorCell.pos - tableStart);
		const headRect = map.findCell($headCell.pos - tableStart);
		const doc$2 = $anchorCell.node(0);
		if (anchorRect.left <= headRect.left) {
			if (anchorRect.left > 0) $anchorCell = doc$2.resolve(tableStart + map.map[anchorRect.top * map.width]);
			if (headRect.right < map.width) $headCell = doc$2.resolve(tableStart + map.map[map.width * (headRect.top + 1) - 1]);
		} else {
			if (headRect.left > 0) $headCell = doc$2.resolve(tableStart + map.map[headRect.top * map.width]);
			if (anchorRect.right < map.width) $anchorCell = doc$2.resolve(tableStart + map.map[map.width * (anchorRect.top + 1) - 1]);
		}
		return new CellSelection$1($anchorCell, $headCell);
	}
	toJSON() {
		return {
			type: "cell",
			anchor: this.$anchorCell.pos,
			head: this.$headCell.pos
		};
	}
	static fromJSON(doc$2, json) {
		return new CellSelection$1(doc$2.resolve(json.anchor), doc$2.resolve(json.head));
	}
	static create(doc$2, anchorCell, headCell = anchorCell) {
		return new CellSelection$1(doc$2.resolve(anchorCell), doc$2.resolve(headCell));
	}
	getBookmark() {
		return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
	}
};
CellSelection.prototype.visible = false;
Selection.jsonID("cell", CellSelection);
var CellBookmark = class CellBookmark$1 {
	constructor(anchor, head) {
		this.anchor = anchor;
		this.head = head;
	}
	map(mapping) {
		return new CellBookmark$1(mapping.map(this.anchor), mapping.map(this.head));
	}
	resolve(doc$2) {
		const $anchorCell = doc$2.resolve(this.anchor), $headCell = doc$2.resolve(this.head);
		if ($anchorCell.parent.type.spec.tableRole == "row" && $headCell.parent.type.spec.tableRole == "row" && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) return new CellSelection($anchorCell, $headCell);
		else return Selection.near($headCell, 1);
	}
};
function drawCellSelection(state) {
	if (!(state.selection instanceof CellSelection)) return null;
	const cells = [];
	state.selection.forEachCell((node, pos) => {
		cells.push(Decoration.node(pos, pos + node.nodeSize, { class: "selectedCell" }));
	});
	return DecorationSet.create(state.doc, cells);
}
function isCellBoundarySelection({ $from, $to }) {
	if ($from.pos == $to.pos || $from.pos < $to.pos - 6) return false;
	let afterFrom = $from.pos;
	let beforeTo = $to.pos;
	let depth = $from.depth;
	for (; depth >= 0; depth--, afterFrom++) if ($from.after(depth + 1) < $from.end(depth)) break;
	for (let d = $to.depth; d >= 0; d--, beforeTo--) if ($to.before(d + 1) > $to.start(d)) break;
	return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function isTextSelectionAcrossCells({ $from, $to }) {
	let fromCellBoundaryNode;
	let toCellBoundaryNode;
	for (let i$1 = $from.depth; i$1 > 0; i$1--) {
		const node = $from.node(i$1);
		if (node.type.spec.tableRole === "cell" || node.type.spec.tableRole === "header_cell") {
			fromCellBoundaryNode = node;
			break;
		}
	}
	for (let i$1 = $to.depth; i$1 > 0; i$1--) {
		const node = $to.node(i$1);
		if (node.type.spec.tableRole === "cell" || node.type.spec.tableRole === "header_cell") {
			toCellBoundaryNode = node;
			break;
		}
	}
	return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function normalizeSelection(state, tr, allowTableNodeSelection) {
	const sel = (tr || state).selection;
	const doc$2 = (tr || state).doc;
	let normalize$1;
	let role;
	if (sel instanceof NodeSelection && (role = sel.node.type.spec.tableRole)) {
		if (role == "cell" || role == "header_cell") normalize$1 = CellSelection.create(doc$2, sel.from);
		else if (role == "row") {
			const $cell = doc$2.resolve(sel.from + 1);
			normalize$1 = CellSelection.rowSelection($cell, $cell);
		} else if (!allowTableNodeSelection) {
			const map = TableMap.get(sel.node);
			const start = sel.from + 1;
			const lastCell = start + map.map[map.width * map.height - 1];
			normalize$1 = CellSelection.create(doc$2, start + 1, lastCell);
		}
	} else if (sel instanceof TextSelection && isCellBoundarySelection(sel)) normalize$1 = TextSelection.create(doc$2, sel.from);
	else if (sel instanceof TextSelection && isTextSelectionAcrossCells(sel)) normalize$1 = TextSelection.create(doc$2, sel.$from.start(), sel.$from.end());
	if (normalize$1) (tr || (tr = state.tr)).setSelection(normalize$1);
	return tr;
}
var fixTablesKey = new PluginKey("fix-tables");
function changedDescendants(old, cur, offset, f) {
	const oldSize = old.childCount, curSize = cur.childCount;
	outer: for (let i$1 = 0, j = 0; i$1 < curSize; i$1++) {
		const child = cur.child(i$1);
		for (let scan = j, e = Math.min(oldSize, i$1 + 3); scan < e; scan++) if (old.child(scan) == child) {
			j = scan + 1;
			offset += child.nodeSize;
			continue outer;
		}
		f(child, offset);
		if (j < oldSize && old.child(j).sameMarkup(child)) changedDescendants(old.child(j), child, offset + 1, f);
		else child.nodesBetween(0, child.content.size, f, offset + 1);
		offset += child.nodeSize;
	}
}
function fixTables(state, oldState) {
	let tr;
	const check = (node, pos) => {
		if (node.type.spec.tableRole == "table") tr = fixTable(state, node, pos, tr);
	};
	if (!oldState) state.doc.descendants(check);
	else if (oldState.doc != state.doc) changedDescendants(oldState.doc, state.doc, 0, check);
	return tr;
}
function fixTable(state, table, tablePos, tr) {
	const map = TableMap.get(table);
	if (!map.problems) return tr;
	if (!tr) tr = state.tr;
	const mustAdd = [];
	for (let i$1 = 0; i$1 < map.height; i$1++) mustAdd.push(0);
	for (let i$1 = 0; i$1 < map.problems.length; i$1++) {
		const prob = map.problems[i$1];
		if (prob.type == "collision") {
			const cell = table.nodeAt(prob.pos);
			if (!cell) continue;
			const attrs = cell.attrs;
			for (let j = 0; j < attrs.rowspan; j++) mustAdd[prob.row + j] += prob.n;
			tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, removeColSpan(attrs, attrs.colspan - prob.n, prob.n));
		} else if (prob.type == "missing") mustAdd[prob.row] += prob.n;
		else if (prob.type == "overlong_rowspan") {
			const cell = table.nodeAt(prob.pos);
			if (!cell) continue;
			tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, {
				...cell.attrs,
				rowspan: cell.attrs.rowspan - prob.n
			});
		} else if (prob.type == "colwidth mismatch") {
			const cell = table.nodeAt(prob.pos);
			if (!cell) continue;
			tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, {
				...cell.attrs,
				colwidth: prob.colwidth
			});
		} else if (prob.type == "zero_sized") {
			const pos = tr.mapping.map(tablePos);
			tr.delete(pos, pos + table.nodeSize);
		}
	}
	let first, last;
	for (let i$1 = 0; i$1 < mustAdd.length; i$1++) if (mustAdd[i$1]) {
		if (first == null) first = i$1;
		last = i$1;
	}
	for (let i$1 = 0, pos = tablePos + 1; i$1 < map.height; i$1++) {
		const row = table.child(i$1);
		const end = pos + row.nodeSize;
		const add = mustAdd[i$1];
		if (add > 0) {
			let role = "cell";
			if (row.firstChild) role = row.firstChild.type.spec.tableRole;
			const nodes = [];
			for (let j = 0; j < add; j++) {
				const node = tableNodeTypes(state.schema)[role].createAndFill();
				if (node) nodes.push(node);
			}
			const side = (i$1 == 0 || first == i$1 - 1) && last == i$1 ? pos + 1 : end - 1;
			tr.insert(tr.mapping.map(side), nodes);
		}
		pos = end;
	}
	return tr.setMeta(fixTablesKey, { fixTables: true });
}
function findTable($pos) {
	return findParentNode$1((node) => node.type.spec.tableRole === "table", $pos);
}
function findParentNode$1(predicate, $pos) {
	for (let depth = $pos.depth; depth >= 0; depth -= 1) {
		const node = $pos.node(depth);
		if (predicate(node)) return {
			node,
			pos: depth === 0 ? 0 : $pos.before(depth),
			start: $pos.start(depth),
			depth
		};
	}
	return null;
}
function selectedRect(state) {
	const sel = state.selection;
	const $pos = selectionCell(state);
	const table = $pos.node(-1);
	const tableStart = $pos.start(-1);
	const map = TableMap.get(table);
	return {
		...sel instanceof CellSelection ? map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart) : map.findCell($pos.pos - tableStart),
		tableStart,
		map,
		table
	};
}
function addColumn(tr, { map, tableStart, table }, col) {
	let refColumn = col > 0 ? -1 : 0;
	if (columnIsHeader(map, table, col + refColumn)) refColumn = col == 0 || col == map.width ? null : 0;
	for (let row = 0; row < map.height; row++) {
		const index = row * map.width + col;
		if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
			const pos = map.map[index];
			const cell = table.nodeAt(pos);
			tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, addColSpan(cell.attrs, col - map.colCount(pos)));
			row += cell.attrs.rowspan - 1;
		} else {
			const type = refColumn == null ? tableNodeTypes(table.type.schema).cell : table.nodeAt(map.map[index + refColumn]).type;
			const pos = map.positionAt(row, col, table);
			tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill());
		}
	}
	return tr;
}
function addColumnBefore(state, dispatch) {
	if (!isInTable$1(state)) return false;
	if (dispatch) {
		const rect = selectedRect(state);
		dispatch(addColumn(state.tr, rect, rect.left));
	}
	return true;
}
function addColumnAfter(state, dispatch) {
	if (!isInTable$1(state)) return false;
	if (dispatch) {
		const rect = selectedRect(state);
		dispatch(addColumn(state.tr, rect, rect.right));
	}
	return true;
}
function removeColumn(tr, { map, table, tableStart }, col) {
	const mapStart = tr.mapping.maps.length;
	for (let row = 0; row < map.height;) {
		const index = row * map.width + col;
		const pos = map.map[index];
		const cell = table.nodeAt(pos);
		const attrs = cell.attrs;
		if (col > 0 && map.map[index - 1] == pos || col < map.width - 1 && map.map[index + 1] == pos) tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, removeColSpan(attrs, col - map.colCount(pos)));
		else {
			const start = tr.mapping.slice(mapStart).map(tableStart + pos);
			tr.delete(start, start + cell.nodeSize);
		}
		row += attrs.rowspan;
	}
}
function deleteColumn(state, dispatch) {
	if (!isInTable$1(state)) return false;
	if (dispatch) {
		const rect = selectedRect(state);
		const tr = state.tr;
		if (rect.left == 0 && rect.right == rect.map.width) return false;
		for (let i$1 = rect.right - 1;; i$1--) {
			removeColumn(tr, rect, i$1);
			if (i$1 == rect.left) break;
			const table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
			if (!table) throw new RangeError("No table found");
			rect.table = table;
			rect.map = TableMap.get(table);
		}
		dispatch(tr);
	}
	return true;
}
function removeRow(tr, { map, table, tableStart }, row) {
	let rowPos = 0;
	for (let i$1 = 0; i$1 < row; i$1++) rowPos += table.child(i$1).nodeSize;
	const nextRow = rowPos + table.child(row).nodeSize;
	const mapFrom = tr.mapping.maps.length;
	tr.delete(rowPos + tableStart, nextRow + tableStart);
	const seen = /* @__PURE__ */ new Set();
	for (let col = 0, index = row * map.width; col < map.width; col++, index++) {
		const pos = map.map[index];
		if (seen.has(pos)) continue;
		seen.add(pos);
		if (row > 0 && pos == map.map[index - map.width]) {
			const attrs = table.nodeAt(pos).attrs;
			tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, {
				...attrs,
				rowspan: attrs.rowspan - 1
			});
			col += attrs.colspan - 1;
		} else if (row < map.height && pos == map.map[index + map.width]) {
			const cell = table.nodeAt(pos);
			const attrs = cell.attrs;
			const copy$1 = cell.type.create({
				...attrs,
				rowspan: cell.attrs.rowspan - 1
			}, cell.content);
			const newPos = map.positionAt(row + 1, col, table);
			tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy$1);
			col += attrs.colspan - 1;
		}
	}
}
function deleteRow(state, dispatch) {
	if (!isInTable$1(state)) return false;
	if (dispatch) {
		const rect = selectedRect(state), tr = state.tr;
		if (rect.top == 0 && rect.bottom == rect.map.height) return false;
		for (let i$1 = rect.bottom - 1;; i$1--) {
			removeRow(tr, rect, i$1);
			if (i$1 == rect.top) break;
			const table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
			if (!table) throw new RangeError("No table found");
			rect.table = table;
			rect.map = TableMap.get(rect.table);
		}
		dispatch(tr);
	}
	return true;
}
function isEmpty(cell) {
	const c$1 = cell.content;
	return c$1.childCount == 1 && c$1.child(0).isTextblock && c$1.child(0).childCount == 0;
}
function cellsOverlapRectangle({ width, height, map }, rect) {
	let indexTop = rect.top * width + rect.left, indexLeft = indexTop;
	let indexBottom = (rect.bottom - 1) * width + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
	for (let i$1 = rect.top; i$1 < rect.bottom; i$1++) {
		if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] || rect.right < width && map[indexRight] == map[indexRight + 1]) return true;
		indexLeft += width;
		indexRight += width;
	}
	for (let i$1 = rect.left; i$1 < rect.right; i$1++) {
		if (rect.top > 0 && map[indexTop] == map[indexTop - width] || rect.bottom < height && map[indexBottom] == map[indexBottom + width]) return true;
		indexTop++;
		indexBottom++;
	}
	return false;
}
function mergeCells(state, dispatch) {
	const sel = state.selection;
	if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos) return false;
	const rect = selectedRect(state), { map } = rect;
	if (cellsOverlapRectangle(map, rect)) return false;
	if (dispatch) {
		const tr = state.tr;
		const seen = {};
		let content$2 = Fragment.empty;
		let mergedPos;
		let mergedCell;
		for (let row = rect.top; row < rect.bottom; row++) for (let col = rect.left; col < rect.right; col++) {
			const cellPos = map.map[row * map.width + col];
			const cell = rect.table.nodeAt(cellPos);
			if (seen[cellPos] || !cell) continue;
			seen[cellPos] = true;
			if (mergedPos == null) {
				mergedPos = cellPos;
				mergedCell = cell;
			} else {
				if (!isEmpty(cell)) content$2 = content$2.append(cell.content);
				const mapped = tr.mapping.map(cellPos + rect.tableStart);
				tr.delete(mapped, mapped + cell.nodeSize);
			}
		}
		if (mergedPos == null || mergedCell == null) return true;
		tr.setNodeMarkup(mergedPos + rect.tableStart, null, {
			...addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, rect.right - rect.left - mergedCell.attrs.colspan),
			rowspan: rect.bottom - rect.top
		});
		if (content$2.size > 0) {
			const end = mergedPos + 1 + mergedCell.content.size;
			const start = isEmpty(mergedCell) ? mergedPos + 1 : end;
			tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content$2);
		}
		tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
		dispatch(tr);
	}
	return true;
}
function splitCell(state, dispatch) {
	const nodeTypes = tableNodeTypes(state.schema);
	return splitCellWithType(({ node }) => {
		return nodeTypes[node.type.spec.tableRole];
	})(state, dispatch);
}
function splitCellWithType(getCellType) {
	return (state, dispatch) => {
		const sel = state.selection;
		let cellNode;
		let cellPos;
		if (!(sel instanceof CellSelection)) {
			var _cellAround;
			cellNode = cellWrapping(sel.$from);
			if (!cellNode) return false;
			cellPos = (_cellAround = cellAround(sel.$from)) === null || _cellAround === void 0 ? void 0 : _cellAround.pos;
		} else {
			if (sel.$anchorCell.pos != sel.$headCell.pos) return false;
			cellNode = sel.$anchorCell.nodeAfter;
			cellPos = sel.$anchorCell.pos;
		}
		if (cellNode == null || cellPos == null) return false;
		if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) return false;
		if (dispatch) {
			let baseAttrs = cellNode.attrs;
			const attrs = [];
			const colwidth = baseAttrs.colwidth;
			if (baseAttrs.rowspan > 1) baseAttrs = {
				...baseAttrs,
				rowspan: 1
			};
			if (baseAttrs.colspan > 1) baseAttrs = {
				...baseAttrs,
				colspan: 1
			};
			const rect = selectedRect(state), tr = state.tr;
			for (let i$1 = 0; i$1 < rect.right - rect.left; i$1++) attrs.push(colwidth ? {
				...baseAttrs,
				colwidth: colwidth && colwidth[i$1] ? [colwidth[i$1]] : null
			} : baseAttrs);
			let lastCell;
			for (let row = rect.top; row < rect.bottom; row++) {
				let pos = rect.map.positionAt(row, rect.left, rect.table);
				if (row == rect.top) pos += cellNode.nodeSize;
				for (let col = rect.left, i$1 = 0; col < rect.right; col++, i$1++) {
					if (col == rect.left && row == rect.top) continue;
					tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), getCellType({
						node: cellNode,
						row,
						col
					}).createAndFill(attrs[i$1]));
				}
			}
			tr.setNodeMarkup(cellPos, getCellType({
				node: cellNode,
				row: rect.top,
				col: rect.left
			}), attrs[0]);
			if (sel instanceof CellSelection) tr.setSelection(new CellSelection(tr.doc.resolve(sel.$anchorCell.pos), lastCell ? tr.doc.resolve(lastCell) : void 0));
			dispatch(tr);
		}
		return true;
	};
}
function setCellAttr(name, value) {
	return function(state, dispatch) {
		if (!isInTable$1(state)) return false;
		const $cell = selectionCell(state);
		if ($cell.nodeAfter.attrs[name] === value) return false;
		if (dispatch) {
			const tr = state.tr;
			if (state.selection instanceof CellSelection) state.selection.forEachCell((node, pos) => {
				if (node.attrs[name] !== value) tr.setNodeMarkup(pos, null, {
					...node.attrs,
					[name]: value
				});
			});
			else tr.setNodeMarkup($cell.pos, null, {
				...$cell.nodeAfter.attrs,
				[name]: value
			});
			dispatch(tr);
		}
		return true;
	};
}
function deprecated_toggleHeader(type) {
	return function(state, dispatch) {
		if (!isInTable$1(state)) return false;
		if (dispatch) {
			const types = tableNodeTypes(state.schema);
			const rect = selectedRect(state), tr = state.tr;
			const cells = rect.map.cellsInRect(type == "column" ? {
				left: rect.left,
				top: 0,
				right: rect.right,
				bottom: rect.map.height
			} : type == "row" ? {
				left: 0,
				top: rect.top,
				right: rect.map.width,
				bottom: rect.bottom
			} : rect);
			const nodes = cells.map((pos) => rect.table.nodeAt(pos));
			for (let i$1 = 0; i$1 < cells.length; i$1++) if (nodes[i$1].type == types.header_cell) tr.setNodeMarkup(rect.tableStart + cells[i$1], types.cell, nodes[i$1].attrs);
			if (tr.steps.length === 0) for (let i$1 = 0; i$1 < cells.length; i$1++) tr.setNodeMarkup(rect.tableStart + cells[i$1], types.header_cell, nodes[i$1].attrs);
			dispatch(tr);
		}
		return true;
	};
}
function isHeaderEnabledByType(type, rect, types) {
	const cellPositions = rect.map.cellsInRect({
		left: 0,
		top: 0,
		right: type == "row" ? rect.map.width : 1,
		bottom: type == "column" ? rect.map.height : 1
	});
	for (let i$1 = 0; i$1 < cellPositions.length; i$1++) {
		const cell = rect.table.nodeAt(cellPositions[i$1]);
		if (cell && cell.type !== types.header_cell) return false;
	}
	return true;
}
function toggleHeader(type, options) {
	options = options || { useDeprecatedLogic: false };
	if (options.useDeprecatedLogic) return deprecated_toggleHeader(type);
	return function(state, dispatch) {
		if (!isInTable$1(state)) return false;
		if (dispatch) {
			const types = tableNodeTypes(state.schema);
			const rect = selectedRect(state), tr = state.tr;
			const isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types);
			const isHeaderColumnEnabled = isHeaderEnabledByType("column", rect, types);
			const selectionStartsAt = (type === "column" ? isHeaderRowEnabled : type === "row" ? isHeaderColumnEnabled : false) ? 1 : 0;
			const cellsRect = type == "column" ? {
				left: 0,
				top: selectionStartsAt,
				right: 1,
				bottom: rect.map.height
			} : type == "row" ? {
				left: selectionStartsAt,
				top: 0,
				right: rect.map.width,
				bottom: 1
			} : rect;
			const newType = type == "column" ? isHeaderColumnEnabled ? types.cell : types.header_cell : type == "row" ? isHeaderRowEnabled ? types.cell : types.header_cell : types.cell;
			rect.map.cellsInRect(cellsRect).forEach((relativeCellPos) => {
				const cellPos = relativeCellPos + rect.tableStart;
				const cell = tr.doc.nodeAt(cellPos);
				if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
			});
			dispatch(tr);
		}
		return true;
	};
}
toggleHeader("row", { useDeprecatedLogic: true });
toggleHeader("column", { useDeprecatedLogic: true });
var toggleHeaderCell = toggleHeader("cell", { useDeprecatedLogic: true });
function findNextCell($cell, dir) {
	if (dir < 0) {
		const before = $cell.nodeBefore;
		if (before) return $cell.pos - before.nodeSize;
		for (let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
			const rowNode = $cell.node(-1).child(row);
			const lastChild = rowNode.lastChild;
			if (lastChild) return rowEnd - 1 - lastChild.nodeSize;
			rowEnd -= rowNode.nodeSize;
		}
	} else {
		if ($cell.index() < $cell.parent.childCount - 1) return $cell.pos + $cell.nodeAfter.nodeSize;
		const table = $cell.node(-1);
		for (let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++) {
			const rowNode = table.child(row);
			if (rowNode.childCount) return rowStart + 1;
			rowStart += rowNode.nodeSize;
		}
	}
	return null;
}
function goToNextCell(direction) {
	return function(state, dispatch) {
		if (!isInTable$1(state)) return false;
		const cell = findNextCell(selectionCell(state), direction);
		if (cell == null) return false;
		if (dispatch) {
			const $cell = state.doc.resolve(cell);
			dispatch(state.tr.setSelection(TextSelection.between($cell, moveCellForward($cell))).scrollIntoView());
		}
		return true;
	};
}
function deleteTable(state, dispatch) {
	const $pos = state.selection.$anchor;
	for (let d = $pos.depth; d > 0; d--) if ($pos.node(d).type.spec.tableRole == "table") {
		if (dispatch) dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
		return true;
	}
	return false;
}
function deleteCellSelection(state, dispatch) {
	const sel = state.selection;
	if (!(sel instanceof CellSelection)) return false;
	if (dispatch) {
		const tr = state.tr;
		const baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
		sel.forEachCell((cell, pos) => {
			if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new Slice(baseContent, 0, 0));
		});
		if (tr.docChanged) dispatch(tr);
	}
	return true;
}
function pastedCells(slice) {
	if (slice.size === 0) return null;
	let { content: content$2, openStart, openEnd } = slice;
	while (content$2.childCount == 1 && (openStart > 0 && openEnd > 0 || content$2.child(0).type.spec.tableRole == "table")) {
		openStart--;
		openEnd--;
		content$2 = content$2.child(0).content;
	}
	const first = content$2.child(0);
	const role = first.type.spec.tableRole;
	const schema = first.type.schema, rows = [];
	if (role == "row") for (let i$1 = 0; i$1 < content$2.childCount; i$1++) {
		let cells = content$2.child(i$1).content;
		const left = i$1 ? 0 : Math.max(0, openStart - 1);
		const right = i$1 < content$2.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
		if (left || right) cells = fitSlice(tableNodeTypes(schema).row, new Slice(cells, left, right)).content;
		rows.push(cells);
	}
	else if (role == "cell" || role == "header_cell") rows.push(openStart || openEnd ? fitSlice(tableNodeTypes(schema).row, new Slice(content$2, openStart, openEnd)).content : content$2);
	else return null;
	return ensureRectangular(schema, rows);
}
function ensureRectangular(schema, rows) {
	const widths = [];
	for (let i$1 = 0; i$1 < rows.length; i$1++) {
		const row = rows[i$1];
		for (let j = row.childCount - 1; j >= 0; j--) {
			const { rowspan, colspan } = row.child(j).attrs;
			for (let r = i$1; r < i$1 + rowspan; r++) widths[r] = (widths[r] || 0) + colspan;
		}
	}
	let width = 0;
	for (let r = 0; r < widths.length; r++) width = Math.max(width, widths[r]);
	for (let r = 0; r < widths.length; r++) {
		if (r >= rows.length) rows.push(Fragment.empty);
		if (widths[r] < width) {
			const empty$1 = tableNodeTypes(schema).cell.createAndFill();
			const cells = [];
			for (let i$1 = widths[r]; i$1 < width; i$1++) cells.push(empty$1);
			rows[r] = rows[r].append(Fragment.from(cells));
		}
	}
	return {
		height: rows.length,
		width,
		rows
	};
}
function fitSlice(nodeType, slice) {
	const node = nodeType.createAndFill();
	return new Transform(node).replace(0, node.content.size, slice).doc;
}
function clipCells({ width, height, rows }, newWidth, newHeight) {
	if (width != newWidth) {
		const added = [];
		const newRows = [];
		for (let row = 0; row < rows.length; row++) {
			const frag = rows[row], cells = [];
			for (let col = added[row] || 0, i$1 = 0; col < newWidth; i$1++) {
				let cell = frag.child(i$1 % frag.childCount);
				if (col + cell.attrs.colspan > newWidth) cell = cell.type.createChecked(removeColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
				cells.push(cell);
				col += cell.attrs.colspan;
				for (let j = 1; j < cell.attrs.rowspan; j++) added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
			}
			newRows.push(Fragment.from(cells));
		}
		rows = newRows;
		width = newWidth;
	}
	if (height != newHeight) {
		const newRows = [];
		for (let row = 0, i$1 = 0; row < newHeight; row++, i$1++) {
			const cells = [], source = rows[i$1 % height];
			for (let j = 0; j < source.childCount; j++) {
				let cell = source.child(j);
				if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
					...cell.attrs,
					rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
				}, cell.content);
				cells.push(cell);
			}
			newRows.push(Fragment.from(cells));
		}
		rows = newRows;
		height = newHeight;
	}
	return {
		width,
		height,
		rows
	};
}
function growTable(tr, map, table, start, width, height, mapFrom) {
	const schema = tr.doc.type.schema;
	const types = tableNodeTypes(schema);
	let empty$1;
	let emptyHead;
	if (width > map.width) for (let row = 0, rowEnd = 0; row < map.height; row++) {
		const rowNode = table.child(row);
		rowEnd += rowNode.nodeSize;
		const cells = [];
		let add;
		if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell) add = empty$1 || (empty$1 = types.cell.createAndFill());
		else add = emptyHead || (emptyHead = types.header_cell.createAndFill());
		for (let i$1 = map.width; i$1 < width; i$1++) cells.push(add);
		tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
	}
	if (height > map.height) {
		const cells = [];
		for (let i$1 = 0, start$1 = (map.height - 1) * map.width; i$1 < Math.max(map.width, width); i$1++) {
			const header = i$1 >= map.width ? false : table.nodeAt(map.map[start$1 + i$1]).type == types.header_cell;
			cells.push(header ? emptyHead || (emptyHead = types.header_cell.createAndFill()) : empty$1 || (empty$1 = types.cell.createAndFill()));
		}
		const emptyRow = types.row.create(null, Fragment.from(cells)), rows = [];
		for (let i$1 = map.height; i$1 < height; i$1++) rows.push(emptyRow);
		tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
	}
	return !!(empty$1 || emptyHead);
}
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
	if (top == 0 || top == map.height) return false;
	let found$1 = false;
	for (let col = left; col < right; col++) {
		const index = top * map.width + col, pos = map.map[index];
		if (map.map[index - map.width] == pos) {
			found$1 = true;
			const cell = table.nodeAt(pos);
			const { top: cellTop, left: cellLeft } = map.findCell(pos);
			tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, {
				...cell.attrs,
				rowspan: top - cellTop
			});
			tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), cell.type.createAndFill({
				...cell.attrs,
				rowspan: cellTop + cell.attrs.rowspan - top
			}));
			col += cell.attrs.colspan - 1;
		}
	}
	return found$1;
}
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
	if (left == 0 || left == map.width) return false;
	let found$1 = false;
	for (let row = top; row < bottom; row++) {
		const index = row * map.width + left, pos = map.map[index];
		if (map.map[index - 1] == pos) {
			found$1 = true;
			const cell = table.nodeAt(pos);
			const cellLeft = map.colCount(pos);
			const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
			tr.setNodeMarkup(updatePos, null, removeColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
			tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(removeColSpan(cell.attrs, 0, left - cellLeft)));
			row += cell.attrs.rowspan - 1;
		}
	}
	return found$1;
}
function insertCells(state, dispatch, tableStart, rect, cells) {
	let table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
	if (!table) throw new Error("No table found");
	let map = TableMap.get(table);
	const { top, left } = rect;
	const right = left + cells.width, bottom = top + cells.height;
	const tr = state.tr;
	let mapFrom = 0;
	function recomp() {
		table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
		if (!table) throw new Error("No table found");
		map = TableMap.get(table);
		mapFrom = tr.mapping.maps.length;
	}
	if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
	if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
	if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
	if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
	if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
	for (let row = top; row < bottom; row++) {
		const from = map.positionAt(row, left, table), to = map.positionAt(row, right, table);
		tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new Slice(cells.rows[row - top], 0, 0));
	}
	recomp();
	tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)), tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
	dispatch(tr);
}
var handleKeyDown = keydownHandler({
	ArrowLeft: arrow("horiz", -1),
	ArrowRight: arrow("horiz", 1),
	ArrowUp: arrow("vert", -1),
	ArrowDown: arrow("vert", 1),
	"Shift-ArrowLeft": shiftArrow("horiz", -1),
	"Shift-ArrowRight": shiftArrow("horiz", 1),
	"Shift-ArrowUp": shiftArrow("vert", -1),
	"Shift-ArrowDown": shiftArrow("vert", 1),
	Backspace: deleteCellSelection,
	"Mod-Backspace": deleteCellSelection,
	Delete: deleteCellSelection,
	"Mod-Delete": deleteCellSelection
});
function maybeSetSelection(state, dispatch, selection) {
	if (selection.eq(state.selection)) return false;
	if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
	return true;
}
function arrow(axis, dir) {
	return (state, dispatch, view) => {
		if (!view) return false;
		const sel = state.selection;
		if (sel instanceof CellSelection) return maybeSetSelection(state, dispatch, Selection.near(sel.$headCell, dir));
		if (axis != "horiz" && !sel.empty) return false;
		const end = atEndOfCell(view, axis, dir);
		if (end == null) return false;
		if (axis == "horiz") return maybeSetSelection(state, dispatch, Selection.near(state.doc.resolve(sel.head + dir), dir));
		else {
			const $cell = state.doc.resolve(end);
			const $next = nextCell($cell, axis, dir);
			let newSel;
			if ($next) newSel = Selection.near($next, 1);
			else if (dir < 0) newSel = Selection.near(state.doc.resolve($cell.before(-1)), -1);
			else newSel = Selection.near(state.doc.resolve($cell.after(-1)), 1);
			return maybeSetSelection(state, dispatch, newSel);
		}
	};
}
function shiftArrow(axis, dir) {
	return (state, dispatch, view) => {
		if (!view) return false;
		const sel = state.selection;
		let cellSel;
		if (sel instanceof CellSelection) cellSel = sel;
		else {
			const end = atEndOfCell(view, axis, dir);
			if (end == null) return false;
			cellSel = new CellSelection(state.doc.resolve(end));
		}
		const $head = nextCell(cellSel.$headCell, axis, dir);
		if (!$head) return false;
		return maybeSetSelection(state, dispatch, new CellSelection(cellSel.$anchorCell, $head));
	};
}
function handleTripleClick(view, pos) {
	const doc$2 = view.state.doc, $cell = cellAround(doc$2.resolve(pos));
	if (!$cell) return false;
	view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
	return true;
}
function handlePaste(view, _, slice) {
	if (!isInTable$1(view.state)) return false;
	let cells = pastedCells(slice);
	const sel = view.state.selection;
	if (sel instanceof CellSelection) {
		if (!cells) cells = {
			width: 1,
			height: 1,
			rows: [Fragment.from(fitSlice(tableNodeTypes(view.state.schema).cell, slice))]
		};
		const table = sel.$anchorCell.node(-1);
		const start = sel.$anchorCell.start(-1);
		const rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
		cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
		insertCells(view.state, view.dispatch, start, rect, cells);
		return true;
	} else if (cells) {
		const $cell = selectionCell(view.state);
		const start = $cell.start(-1);
		insertCells(view.state, view.dispatch, start, TableMap.get($cell.node(-1)).findCell($cell.pos - start), cells);
		return true;
	} else return false;
}
function handleMouseDown$1(view, startEvent) {
	var _cellUnderMouse;
	if (startEvent.button != 0) return;
	if (startEvent.ctrlKey || startEvent.metaKey) return;
	const startDOMCell = domInCell(view, startEvent.target);
	let $anchor;
	if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
		setCellSelection(view.state.selection.$anchorCell, startEvent);
		startEvent.preventDefault();
	} else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && ((_cellUnderMouse = cellUnderMouse(view, startEvent)) === null || _cellUnderMouse === void 0 ? void 0 : _cellUnderMouse.pos) != $anchor.pos) {
		setCellSelection($anchor, startEvent);
		startEvent.preventDefault();
	} else if (!startDOMCell) return;
	function setCellSelection($anchor$1, event) {
		let $head = cellUnderMouse(view, event);
		const starting = tableEditingKey.getState(view.state) == null;
		if (!$head || !inSameTable($anchor$1, $head)) if (starting) $head = $anchor$1;
		else return;
		const selection = new CellSelection($anchor$1, $head);
		if (starting || !view.state.selection.eq(selection)) {
			const tr = view.state.tr.setSelection(selection);
			if (starting) tr.setMeta(tableEditingKey, $anchor$1.pos);
			view.dispatch(tr);
		}
	}
	function stop() {
		view.root.removeEventListener("mouseup", stop);
		view.root.removeEventListener("dragstart", stop);
		view.root.removeEventListener("mousemove", move);
		if (tableEditingKey.getState(view.state) != null) view.dispatch(view.state.tr.setMeta(tableEditingKey, -1));
	}
	function move(_event) {
		const event = _event;
		const anchor = tableEditingKey.getState(view.state);
		let $anchor$1;
		if (anchor != null) $anchor$1 = view.state.doc.resolve(anchor);
		else if (domInCell(view, event.target) != startDOMCell) {
			$anchor$1 = cellUnderMouse(view, startEvent);
			if (!$anchor$1) return stop();
		}
		if ($anchor$1) setCellSelection($anchor$1, event);
	}
	view.root.addEventListener("mouseup", stop);
	view.root.addEventListener("dragstart", stop);
	view.root.addEventListener("mousemove", move);
}
function atEndOfCell(view, axis, dir) {
	if (!(view.state.selection instanceof TextSelection)) return null;
	const { $head } = view.state.selection;
	for (let d = $head.depth - 1; d >= 0; d--) {
		const parent = $head.node(d);
		if ((dir < 0 ? $head.index(d) : $head.indexAfter(d)) != (dir < 0 ? 0 : parent.childCount)) return null;
		if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
			const cellPos = $head.before(d);
			const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
			return view.endOfTextblock(dirStr) ? cellPos : null;
		}
	}
	return null;
}
function domInCell(view, dom) {
	for (; dom && dom != view.dom; dom = dom.parentNode) if (dom.nodeName == "TD" || dom.nodeName == "TH") return dom;
	return null;
}
function cellUnderMouse(view, event) {
	const mousePos = view.posAtCoords({
		left: event.clientX,
		top: event.clientY
	});
	if (!mousePos) return null;
	let { inside, pos } = mousePos;
	return inside >= 0 && cellAround(view.state.doc.resolve(inside)) || cellAround(view.state.doc.resolve(pos));
}
var TableView = class {
	constructor(node, defaultCellMinWidth) {
		this.node = node;
		this.defaultCellMinWidth = defaultCellMinWidth;
		this.dom = document.createElement("div");
		this.dom.className = "tableWrapper";
		this.table = this.dom.appendChild(document.createElement("table"));
		this.table.style.setProperty("--default-cell-min-width", `${defaultCellMinWidth}px`);
		this.colgroup = this.table.appendChild(document.createElement("colgroup"));
		updateColumnsOnResize(node, this.colgroup, this.table, defaultCellMinWidth);
		this.contentDOM = this.table.appendChild(document.createElement("tbody"));
	}
	update(node) {
		if (node.type != this.node.type) return false;
		this.node = node;
		updateColumnsOnResize(node, this.colgroup, this.table, this.defaultCellMinWidth);
		return true;
	}
	ignoreMutation(record) {
		return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target));
	}
};
function updateColumnsOnResize(node, colgroup, table, defaultCellMinWidth, overrideCol, overrideValue) {
	let totalWidth = 0;
	let fixedWidth = true;
	let nextDOM = colgroup.firstChild;
	const row = node.firstChild;
	if (!row) return;
	for (let i$1 = 0, col = 0; i$1 < row.childCount; i$1++) {
		const { colspan, colwidth } = row.child(i$1).attrs;
		for (let j = 0; j < colspan; j++, col++) {
			const hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
			const cssWidth = hasWidth ? hasWidth + "px" : "";
			totalWidth += hasWidth || defaultCellMinWidth;
			if (!hasWidth) fixedWidth = false;
			if (!nextDOM) {
				const col$1 = document.createElement("col");
				col$1.style.width = cssWidth;
				colgroup.appendChild(col$1);
			} else {
				if (nextDOM.style.width != cssWidth) nextDOM.style.width = cssWidth;
				nextDOM = nextDOM.nextSibling;
			}
		}
	}
	while (nextDOM) {
		var _nextDOM$parentNode;
		const after = nextDOM.nextSibling;
		(_nextDOM$parentNode = nextDOM.parentNode) === null || _nextDOM$parentNode === void 0 || _nextDOM$parentNode.removeChild(nextDOM);
		nextDOM = after;
	}
	if (fixedWidth) {
		table.style.width = totalWidth + "px";
		table.style.minWidth = "";
	} else {
		table.style.width = "";
		table.style.minWidth = totalWidth + "px";
	}
}
var columnResizingPluginKey = new PluginKey("tableColumnResizing");
function columnResizing({ handleWidth = 5, cellMinWidth: cellMinWidth$1 = 25, defaultCellMinWidth = 100, View = TableView, lastColumnResizable = true } = {}) {
	const plugin = new Plugin({
		key: columnResizingPluginKey,
		state: {
			init(_, state) {
				var _plugin$spec;
				const nodeViews = (_plugin$spec = plugin.spec) === null || _plugin$spec === void 0 || (_plugin$spec = _plugin$spec.props) === null || _plugin$spec === void 0 ? void 0 : _plugin$spec.nodeViews;
				const tableName = tableNodeTypes(state.schema).table.name;
				if (View && nodeViews) nodeViews[tableName] = (node, view) => {
					return new View(node, defaultCellMinWidth, view);
				};
				return new ResizeState(-1, false);
			},
			apply(tr, prev) {
				return prev.apply(tr);
			}
		},
		props: {
			attributes: (state) => {
				const pluginState = columnResizingPluginKey.getState(state);
				return pluginState && pluginState.activeHandle > -1 ? { class: "resize-cursor" } : {};
			},
			handleDOMEvents: {
				mousemove: (view, event) => {
					handleMouseMove(view, event, handleWidth, lastColumnResizable);
				},
				mouseleave: (view) => {
					handleMouseLeave(view);
				},
				mousedown: (view, event) => {
					handleMouseDown(view, event, cellMinWidth$1, defaultCellMinWidth);
				}
			},
			decorations: (state) => {
				const pluginState = columnResizingPluginKey.getState(state);
				if (pluginState && pluginState.activeHandle > -1) return handleDecorations(state, pluginState.activeHandle);
			},
			nodeViews: {}
		}
	});
	return plugin;
}
var ResizeState = class ResizeState$1 {
	constructor(activeHandle, dragging) {
		this.activeHandle = activeHandle;
		this.dragging = dragging;
	}
	apply(tr) {
		const state = this;
		const action = tr.getMeta(columnResizingPluginKey);
		if (action && action.setHandle != null) return new ResizeState$1(action.setHandle, false);
		if (action && action.setDragging !== void 0) return new ResizeState$1(state.activeHandle, action.setDragging);
		if (state.activeHandle > -1 && tr.docChanged) {
			let handle = tr.mapping.map(state.activeHandle, -1);
			if (!pointsAtCell(tr.doc.resolve(handle))) handle = -1;
			return new ResizeState$1(handle, state.dragging);
		}
		return state;
	}
};
function handleMouseMove(view, event, handleWidth, lastColumnResizable) {
	if (!view.editable) return;
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (!pluginState) return;
	if (!pluginState.dragging) {
		const target = domCellAround(event.target);
		let cell = -1;
		if (target) {
			const { left, right } = target.getBoundingClientRect();
			if (event.clientX - left <= handleWidth) cell = edgeCell(view, event, "left", handleWidth);
			else if (right - event.clientX <= handleWidth) cell = edgeCell(view, event, "right", handleWidth);
		}
		if (cell != pluginState.activeHandle) {
			if (!lastColumnResizable && cell !== -1) {
				const $cell = view.state.doc.resolve(cell);
				const table = $cell.node(-1);
				const map = TableMap.get(table);
				const tableStart = $cell.start(-1);
				if (map.colCount($cell.pos - tableStart) + $cell.nodeAfter.attrs.colspan - 1 == map.width - 1) return;
			}
			updateHandle(view, cell);
		}
	}
}
function handleMouseLeave(view) {
	if (!view.editable) return;
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (pluginState && pluginState.activeHandle > -1 && !pluginState.dragging) updateHandle(view, -1);
}
function handleMouseDown(view, event, cellMinWidth$1, defaultCellMinWidth) {
	var _view$dom$ownerDocume;
	if (!view.editable) return false;
	const win = (_view$dom$ownerDocume = view.dom.ownerDocument.defaultView) !== null && _view$dom$ownerDocume !== void 0 ? _view$dom$ownerDocume : window;
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (!pluginState || pluginState.activeHandle == -1 || pluginState.dragging) return false;
	const cell = view.state.doc.nodeAt(pluginState.activeHandle);
	const width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
	view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setDragging: {
		startX: event.clientX,
		startWidth: width
	} }));
	function finish(event$1) {
		win.removeEventListener("mouseup", finish);
		win.removeEventListener("mousemove", move);
		const pluginState$1 = columnResizingPluginKey.getState(view.state);
		if (pluginState$1 === null || pluginState$1 === void 0 ? void 0 : pluginState$1.dragging) {
			updateColumnWidth(view, pluginState$1.activeHandle, draggedWidth(pluginState$1.dragging, event$1, cellMinWidth$1));
			view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setDragging: null }));
		}
	}
	function move(event$1) {
		if (!event$1.which) return finish(event$1);
		const pluginState$1 = columnResizingPluginKey.getState(view.state);
		if (!pluginState$1) return;
		if (pluginState$1.dragging) {
			const dragged = draggedWidth(pluginState$1.dragging, event$1, cellMinWidth$1);
			displayColumnWidth(view, pluginState$1.activeHandle, dragged, defaultCellMinWidth);
		}
	}
	displayColumnWidth(view, pluginState.activeHandle, width, defaultCellMinWidth);
	win.addEventListener("mouseup", finish);
	win.addEventListener("mousemove", move);
	event.preventDefault();
	return true;
}
function currentColWidth(view, cellPos, { colspan, colwidth }) {
	const width = colwidth && colwidth[colwidth.length - 1];
	if (width) return width;
	const dom = view.domAtPos(cellPos);
	let domWidth = dom.node.childNodes[dom.offset].offsetWidth, parts = colspan;
	if (colwidth) {
		for (let i$1 = 0; i$1 < colspan; i$1++) if (colwidth[i$1]) {
			domWidth -= colwidth[i$1];
			parts--;
		}
	}
	return domWidth / parts;
}
function domCellAround(target) {
	while (target && target.nodeName != "TD" && target.nodeName != "TH") target = target.classList && target.classList.contains("ProseMirror") ? null : target.parentNode;
	return target;
}
function edgeCell(view, event, side, handleWidth) {
	const offset = side == "right" ? -handleWidth : handleWidth;
	const found$1 = view.posAtCoords({
		left: event.clientX + offset,
		top: event.clientY
	});
	if (!found$1) return -1;
	const { pos } = found$1;
	const $cell = cellAround(view.state.doc.resolve(pos));
	if (!$cell) return -1;
	if (side == "right") return $cell.pos;
	const map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
	const index = map.map.indexOf($cell.pos - start);
	return index % map.width == 0 ? -1 : start + map.map[index - 1];
}
function draggedWidth(dragging, event, resizeMinWidth) {
	const offset = event.clientX - dragging.startX;
	return Math.max(resizeMinWidth, dragging.startWidth + offset);
}
function updateHandle(view, value) {
	view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setHandle: value }));
}
function updateColumnWidth(view, cell, width) {
	const $cell = view.state.doc.resolve(cell);
	const table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
	const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
	const tr = view.state.tr;
	for (let row = 0; row < map.height; row++) {
		const mapIndex = row * map.width + col;
		if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) continue;
		const pos = map.map[mapIndex];
		const attrs = table.nodeAt(pos).attrs;
		const index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
		if (attrs.colwidth && attrs.colwidth[index] == width) continue;
		const colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
		colwidth[index] = width;
		tr.setNodeMarkup(start + pos, null, {
			...attrs,
			colwidth
		});
	}
	if (tr.docChanged) view.dispatch(tr);
}
function displayColumnWidth(view, cell, width, defaultCellMinWidth) {
	const $cell = view.state.doc.resolve(cell);
	const table = $cell.node(-1), start = $cell.start(-1);
	const col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
	let dom = view.domAtPos($cell.start(-1)).node;
	while (dom && dom.nodeName != "TABLE") dom = dom.parentNode;
	if (!dom) return;
	updateColumnsOnResize(table, dom.firstChild, dom, defaultCellMinWidth, col, width);
}
function zeroes(n) {
	return Array(n).fill(0);
}
function handleDecorations(state, cell) {
	const decorations = [];
	const $cell = state.doc.resolve(cell);
	const table = $cell.node(-1);
	if (!table) return DecorationSet.empty;
	const map = TableMap.get(table);
	const start = $cell.start(-1);
	const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
	for (let row = 0; row < map.height; row++) {
		const index = col + row * map.width;
		if ((col == map.width - 1 || map.map[index] != map.map[index + 1]) && (row == 0 || map.map[index] != map.map[index - map.width])) {
			var _columnResizingPlugin;
			const cellPos = map.map[index];
			const pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
			const dom = document.createElement("div");
			dom.className = "column-resize-handle";
			if ((_columnResizingPlugin = columnResizingPluginKey.getState(state)) === null || _columnResizingPlugin === void 0 ? void 0 : _columnResizingPlugin.dragging) decorations.push(Decoration.node(start + cellPos, start + cellPos + table.nodeAt(cellPos).nodeSize, { class: "column-resize-dragging" }));
			decorations.push(Decoration.widget(pos, dom));
		}
	}
	return DecorationSet.create(state.doc, decorations);
}
function tableEditing({ allowTableNodeSelection = false } = {}) {
	return new Plugin({
		key: tableEditingKey,
		state: {
			init() {
				return null;
			},
			apply(tr, cur) {
				const set = tr.getMeta(tableEditingKey);
				if (set != null) return set == -1 ? null : set;
				if (cur == null || !tr.docChanged) return cur;
				const { deleted, pos } = tr.mapping.mapResult(cur);
				return deleted ? null : pos;
			}
		},
		props: {
			decorations: drawCellSelection,
			handleDOMEvents: { mousedown: handleMouseDown$1 },
			createSelectionBetween(view) {
				return tableEditingKey.getState(view.state) != null ? view.state.selection : null;
			},
			handleTripleClick,
			handleKeyDown,
			handlePaste
		},
		appendTransaction(_, oldState, state) {
			return normalizeSelection(state, fixTables(state, oldState), allowTableNodeSelection);
		}
	});
}
var resolvedParagraphPropertiesCache = /* @__PURE__ */ new WeakMap();
function getResolvedParagraphProperties(node) {
	return resolvedParagraphPropertiesCache.get(node);
}
function calculateResolvedParagraphProperties(editor, node, $pos) {
	if (!editor.converter) return node.attrs.paragraphProperties || {};
	const cached = getResolvedParagraphProperties(node);
	if (cached) return cached;
	const tableStyleId = findParentNodeClosestToPos($pos, (node$1) => node$1.type.name === "table")?.node.attrs.tableStyleId || null;
	const paragraphProperties = resolveParagraphProperties({
		translatedNumbering: editor.converter.translatedNumbering,
		translatedLinkedStyles: editor.converter.translatedLinkedStyles
	}, node.attrs.paragraphProperties || {}, tableStyleId);
	resolvedParagraphPropertiesCache.set(node, paragraphProperties);
	return paragraphProperties;
}
function resolveHypotheticalParagraphProperties(editor, $pos, inlineProps) {
	if (!editor?.converter) return inlineProps;
	const tableStyleId = findParentNodeClosestToPos($pos, (node) => node.type.name === "table")?.node.attrs.tableStyleId || null;
	return resolveParagraphProperties({
		translatedNumbering: editor.converter.translatedNumbering,
		translatedLinkedStyles: editor.converter.translatedLinkedStyles
	}, inlineProps, tableStyleId);
}
const mergeRanges = (ranges, docSize) => {
	if (!ranges.length) return [];
	const sorted = ranges.map(({ from, to }) => ({
		from: Math.max(0, from),
		to: Math.min(docSize, to)
	})).filter(({ from, to }) => from < to).sort((a, b) => a.from - b.from);
	const merged = [];
	for (const range of sorted) {
		const last = merged[merged.length - 1];
		if (last && range.from <= last.to) last.to = Math.max(last.to, range.to);
		else merged.push({ ...range });
	}
	return merged;
};
const mapRangesThroughTransactions = (ranges, transactions, docSize) => {
	let mapped = ranges;
	transactions.forEach((tr) => {
		mapped = mapped.map(({ from, to }) => {
			const mappedFrom = tr.mapping.map(from, -1);
			const mappedTo = tr.mapping.map(to, 1);
			if (mappedFrom >= mappedTo) return null;
			return {
				from: mappedFrom,
				to: mappedTo
			};
		}).filter(Boolean);
	});
	return mergeRanges(mapped, docSize);
};
const collectChangedRangesThroughTransactions = (transactions, docSize, options = {}) => {
	const ranges = [];
	const extraRanges = Array.isArray(options.extraRanges) ? options.extraRanges : [];
	if (extraRanges.length) {
		const mappedExtras = mapRangesThroughTransactions(extraRanges, transactions, docSize);
		ranges.push(...mappedExtras);
	}
	transactions.forEach((tr, index) => {
		if (!tr.docChanged) return;
		const perTransactionRanges = [];
		tr.steps.forEach((step$1) => {
			if (typeof step$1.from !== "number" || typeof step$1.to !== "number") return;
			const from = tr.mapping.map(step$1.from, 1);
			const to = tr.mapping.map(step$1.to, -1);
			if (from >= to) return;
			perTransactionRanges.push({
				from,
				to
			});
		});
		tr.mapping.maps.forEach((map) => {
			map.forEach((oldStart, oldEnd, newStart, newEnd) => {
				if (newStart !== oldStart || oldEnd !== newEnd) perTransactionRanges.push({
					from: newStart,
					to: newEnd
				});
			});
		});
		if (!perTransactionRanges.length) return;
		const mapped = mapRangesThroughTransactions(perTransactionRanges, transactions.slice(index + 1), docSize);
		ranges.push(...mapped);
	});
	return mergeRanges(ranges, docSize);
};
const clampRange = (start, end, docSize) => {
	const safeStart = Math.max(0, Math.min(start, docSize));
	const safeEnd = Math.max(0, Math.min(end, docSize));
	if (safeStart >= safeEnd) return null;
	return {
		start: safeStart,
		end: safeEnd
	};
};
var RUN_PROPERTIES_DERIVED_FROM_MARKS = new Set([
	"strike",
	"italic",
	"bold",
	"underline",
	"highlight",
	"textTransform",
	"color",
	"fontSize",
	"fontSizeCs",
	"letterSpacing",
	"fontFamily",
	"vertAlign",
	"position"
]);
const TRANSIENT_HYPERLINK_STYLE_IDS = new Set(["Hyperlink", "FollowedHyperlink"]);
function mergeFontFamilyPreservingThemeRefs(fromMarks, existing) {
	const merged = { ...fromMarks || {} };
	if (!existing || typeof existing !== "object") return merged;
	for (const [concreteKey, themeKey] of FONT_SLOT_THEME_PAIRS) if (existing[themeKey] != null) {
		merged[themeKey] = existing[themeKey];
		delete merged[concreteKey];
	}
	return merged;
}
function marksMatchExistingFontFamily(markFromMarks, existingFontFamily, encode$82, docx) {
	if (!existingFontFamily || typeof existingFontFamily !== "object") return false;
	if (!markFromMarks?.attrs) return false;
	const markFromExisting = encode$82({ fontFamily: existingFontFamily }, docx)?.[0];
	if (!markFromExisting?.attrs) return false;
	return markFromMarks.attrs.fontFamily === markFromExisting.attrs.fontFamily;
}
var RUN_PROPERTY_PRESERVE_META_KEY = "sdPreserveRunPropertiesKeys";
var COMPANION_INLINE_KEYS = {
	fontSizeCs: "fontSize",
	boldCs: "bold",
	italicCs: "italic"
};
const calculateInlineRunPropertiesPlugin = (editor) => new Plugin({ appendTransaction(transactions, _oldState, newState) {
	const tr = newState.tr;
	if (!transactions.some((t) => t.docChanged)) return null;
	const runType = newState.schema.nodes.run;
	if (!runType) return null;
	const removedKeys = /* @__PURE__ */ new Set();
	transactions.forEach((t) => {
		t.steps.forEach((step$1) => {
			const jsonStep = step$1.toJSON?.();
			if (jsonStep?.stepType !== "removeMark" || !jsonStep.mark?.type) return;
			if (jsonStep.mark.type === "textStyle") Object.entries(jsonStep.mark.attrs || {}).forEach(([key, value]) => {
				if (value != null) removedKeys.add(key);
			});
			else removedKeys.add(jsonStep.mark.type);
		});
	});
	const preservedDerivedKeys = /* @__PURE__ */ new Set();
	const preferExistingKeys = /* @__PURE__ */ new Set();
	transactions.forEach((transaction) => {
		const entries = transaction.getMeta(RUN_PROPERTY_PRESERVE_META_KEY);
		if (!Array.isArray(entries)) return;
		entries.forEach((entry) => {
			if (typeof entry === "string" && entry.length > 0) preservedDerivedKeys.add(entry);
			else if (entry && typeof entry === "object" && typeof entry.key === "string") {
				preservedDerivedKeys.add(entry.key);
				if (entry.preferExisting) preferExistingKeys.add(entry.key);
			}
		});
	});
	const changedRanges = collectChangedRangesThroughTransactions(transactions, newState.doc.content.size);
	const runPositions = /* @__PURE__ */ new Set();
	changedRanges.forEach(({ from, to }) => {
		newState.doc.nodesBetween(from, to, (node, pos) => {
			if (node.type === runType) runPositions.add(pos);
		});
	});
	if (!runPositions.size) return null;
	const selectionPreserver = createSelectionPreserver(tr, newState.selection, newState.storedMarks);
	Array.from(runPositions).sort((a, b) => b - a).forEach((pos) => {
		const mappedPos = tr.mapping.map(pos);
		const runNode = tr.doc.nodeAt(mappedPos);
		if (!runNode || runNode.type !== runType) return;
		const $pos = tr.doc.resolve(mappedPos);
		const { paragraphNode, paragraphPos, tableInfo } = getRunContext($pos);
		if (!paragraphNode || paragraphPos === void 0) return;
		const { segments, firstInlineProps } = segmentRunByInlineProps(runNode, paragraphNode, tableInfo, $pos, editor, removedKeys, preservedDerivedKeys, preferExistingKeys);
		let runProperties = firstInlineProps ?? null;
		const existingInlineKeys = runNode.attrs?.runPropertiesInlineKeys || [];
		const hadInlineKeysMetadata = Array.isArray(runNode.attrs?.runPropertiesInlineKeys);
		const styleKeys = runNode.attrs?.runPropertiesStyleKeys || [];
		const existingStyleComparableProps = resolveRunProperties({
			translatedNumbering: editor.converter?.translatedNumbering ?? {},
			translatedLinkedStyles: editor.converter?.translatedLinkedStyles ?? {}
		}, runNode.attrs?.runProperties?.styleId != null ? { styleId: runNode.attrs.runProperties.styleId } : {}, getResolvedParagraphProperties(paragraphNode) || calculateResolvedParagraphProperties(editor, paragraphNode, $pos), tableInfo, false, Boolean(paragraphNode.attrs.paragraphProperties?.numberingProperties));
		const keysFromMarks = (segment) => {
			const textNode = segment.content?.find((n) => n.isText);
			return Object.keys(decodeRPrFromMarks(textNode?.marks || []));
		};
		const overrideKeysFromInlineProps = (inlineProps) => styleKeys.filter((k) => {
			if (!inlineProps || !(k in inlineProps)) return false;
			if (!existingStyleComparableProps || !(k in existingStyleComparableProps)) return true;
			return JSON.stringify(inlineProps[k]) !== JSON.stringify(existingStyleComparableProps[k]);
		});
		const existingRunPropsKeys = new Set(runNode.attrs?.runProperties ? Object.keys(runNode.attrs.runProperties) : []);
		const computeSegmentKeys = (segmentInlineProps, segment) => {
			const hasNewInlineProps = segmentInlineProps != null && Object.keys(segmentInlineProps).some((k) => {
				if (existingRunPropsKeys.has(k)) return false;
				const baseKey = COMPANION_INLINE_KEYS[k];
				if (baseKey && existingRunPropsKeys.has(baseKey)) return false;
				return true;
			});
			const hasChangedStyleComparableProps = segmentInlineProps != null && Object.keys(segmentInlineProps).some((k) => {
				if (!styleKeys.includes(k)) return false;
				const current = segmentInlineProps[k];
				const fromStyle = existingStyleComparableProps?.[k];
				if (JSON.stringify(current) !== JSON.stringify(fromStyle)) return true;
				const baseKey = COMPANION_INLINE_KEYS[k];
				if (!baseKey) return false;
				const currentBase = segmentInlineProps[baseKey];
				const styleBase = existingStyleComparableProps?.[baseKey];
				return JSON.stringify(currentBase) !== JSON.stringify(styleBase);
			});
			const markKeysToAdd = !hadInlineKeysMetadata || existingInlineKeys.length > 0 || hasNewInlineProps || hasChangedStyleComparableProps ? keysFromMarks(segment) : [];
			const keys$1 = [...new Set([...existingInlineKeys, ...markKeysToAdd])];
			const ok = overrideKeysFromInlineProps(segmentInlineProps);
			return {
				inlineKeys: keys$1.length ? keys$1 : hadInlineKeysMetadata ? [] : null,
				overrideKeys: ok?.length ? ok : null
			};
		};
		if (segments.length === 1) {
			const hadInlineKeys = Array.isArray(runNode.attrs?.runPropertiesInlineKeys) && runNode.attrs.runPropertiesInlineKeys.length > 0;
			if (JSON.stringify(runProperties) === JSON.stringify(runNode.attrs.runProperties) && hadInlineKeys) return;
			if (hadInlineKeys) {
				const computedKeys = new Set(runProperties ? Object.keys(runProperties) : []);
				const lostKeys = existingInlineKeys.filter((k) => !computedKeys.has(k));
				if (lostKeys.length > 0) {
					if (!runProperties) runProperties = {};
					lostKeys.forEach((k) => {
						if (removedKeys.has(k)) return;
						const baseKey = COMPANION_INLINE_KEYS[k];
						if (baseKey && removedKeys.has(baseKey)) return;
						if (runNode.attrs?.runProperties?.[k] !== void 0) runProperties[k] = runNode.attrs.runProperties[k];
					});
					if (runProperties && Object.keys(runProperties).length === 0) runProperties = null;
				}
			}
			const { inlineKeys: newInlineKeys, overrideKeys: newOverrideKeys } = computeSegmentKeys(runProperties, segments[0]);
			tr.setNodeMarkup(mappedPos, runNode.type, {
				...runNode.attrs,
				runProperties,
				runPropertiesInlineKeys: newInlineKeys,
				runPropertiesOverrideKeys: newOverrideKeys
			}, runNode.marks);
		} else {
			const newRuns = segments.map((segment) => {
				const props = segment.inlineProps ?? null;
				const { inlineKeys: segInlineKeys, overrideKeys: segOverrideKeys } = computeSegmentKeys(props, segment);
				return runType.create({
					...runNode.attrs ?? {},
					runProperties: props,
					runPropertiesInlineKeys: segInlineKeys,
					runPropertiesOverrideKeys: segOverrideKeys
				}, Fragment.fromArray(segment.content), runNode.marks);
			});
			const replacement = Fragment.fromArray(newRuns);
			tr.replaceWith(mappedPos, mappedPos + runNode.nodeSize, replacement);
			selectionPreserver?.mapReplacement(mappedPos, runNode.nodeSize, replacement);
		}
	});
	selectionPreserver?.finalize();
	return tr.docChanged ? tr : null;
} });
function getRunContext($pos) {
	let paragraphNode = null;
	let paragraphDepth = -1;
	let tableInfo = null;
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node.type.name === "paragraph") {
			paragraphNode = node;
			paragraphDepth = depth;
		} else if (node.type.name === "tableCell") {
			tableInfo = extractTableInfo($pos, depth);
			break;
		}
	}
	if (!paragraphNode || paragraphDepth < 0) return {};
	const paragraphPos = $pos.before(paragraphDepth);
	return {
		paragraphNode,
		paragraphPos,
		tableInfo
	};
}
function extractTableInfo($pos, depth) {
	const rowNode = $pos.node(depth - 1);
	const tableNode = $pos.node(depth - 2);
	if (rowNode.type.name !== "tableRow" || tableNode.type.name !== "table") return null;
	const fallbackInfo = {
		tableProperties: tableNode.attrs.tableProperties || null,
		rowIndex: $pos.index(depth - 2),
		cellIndex: $pos.index(depth - 1),
		numCells: rowNode.childCount,
		numRows: tableNode.childCount
	};
	try {
		const tableMap = TableMap.get(tableNode);
		const tableStart = $pos.before(depth - 2) + 1;
		const cellStart = $pos.before(depth);
		const cellRect = tableMap.findCell(cellStart - tableStart);
		return {
			tableProperties: tableNode.attrs.tableProperties || null,
			rowIndex: cellRect.top,
			cellIndex: cellRect.left,
			numCells: tableMap.width,
			numRows: tableMap.height
		};
	} catch {
		return fallbackInfo;
	}
}
function segmentRunByInlineProps(runNode, paragraphNode, tableInfo, $pos, editor, removedKeys, preservedDerivedKeys, preferExistingKeys) {
	const segments = [];
	let lastKey = null;
	let boundaryCounter = 0;
	runNode.forEach((child) => {
		if (child.isText) {
			const { inlineProps: inlineProps$1, inlineKey: inlineKey$2 } = computeInlineRunProps(child.marks, runNode.attrs?.runProperties, paragraphNode, tableInfo, $pos, editor, removedKeys, preservedDerivedKeys, preferExistingKeys);
			const last = segments[segments.length - 1];
			if (last && inlineKey$2 === lastKey) last.content.push(child);
			else {
				segments.push({
					inlineProps: inlineProps$1,
					inlineKey: inlineKey$2,
					content: [child]
				});
				lastKey = inlineKey$2;
			}
			return;
		}
		const inlineProps = null;
		const inlineKey$1 = `__boundary__${boundaryCounter++}`;
		segments.push({
			inlineProps,
			inlineKey: inlineKey$1,
			content: [child]
		});
		lastKey = inlineKey$1;
	});
	return {
		segments,
		firstInlineProps: segments[0]?.inlineProps ?? null
	};
}
function computeInlineRunProps(marks, existingRunProperties, paragraphNode, tableInfo, $pos, editor, removedKeys, preservedDerivedKeys, preferExistingKeys) {
	const runPropertiesFromMarks = decodeRPrFromMarks(marks);
	const paragraphProperties = getResolvedParagraphProperties(paragraphNode) || calculateResolvedParagraphProperties(editor, paragraphNode, $pos);
	const inlineRunProperties = getInlineRunProperties(runPropertiesFromMarks, resolveRunProperties({
		translatedNumbering: editor.converter?.translatedNumbering ?? {},
		translatedLinkedStyles: editor.converter?.translatedLinkedStyles ?? {}
	}, existingRunProperties?.styleId != null ? { styleId: existingRunProperties?.styleId } : {}, paragraphProperties, tableInfo, false, Boolean(paragraphNode.attrs.paragraphProperties?.numberingProperties)), existingRunProperties, editor, removedKeys, preservedDerivedKeys, preferExistingKeys);
	const inlineProps = Object.keys(inlineRunProperties).length ? inlineRunProperties : null;
	return {
		inlineProps,
		inlineKey: stableStringifyInlineProps(inlineProps)
	};
}
function getInlineRunProperties(runPropertiesFromMarks, runPropertiesFromStyles, existingRunProperties, editor, removedKeys = /* @__PURE__ */ new Set(), preservedDerivedKeys = /* @__PURE__ */ new Set(), preferExistingKeys = /* @__PURE__ */ new Set()) {
	const inlineRunProperties = {};
	for (const key in runPropertiesFromMarks) {
		if (preservedDerivedKeys.has(key)) {
			const fromMarks = runPropertiesFromMarks[key];
			const existing = existingRunProperties?.[key];
			if (preferExistingKeys.has(key) && existing != null) inlineRunProperties[key] = existing;
			else if (fromMarks != null && existing != null && typeof fromMarks === "object" && typeof existing === "object") inlineRunProperties[key] = {
				...existing,
				...fromMarks
			};
			else if (fromMarks !== void 0) inlineRunProperties[key] = fromMarks;
			continue;
		}
		const valueFromMarks = runPropertiesFromMarks[key];
		const valueFromStyles = runPropertiesFromStyles[key];
		if (JSON.stringify(valueFromMarks) !== JSON.stringify(valueFromStyles)) if (key === "fontFamily") {
			const docx = editor.converter?.convertedXml ?? {};
			const markFromStyles = encodeMarksFromRPr({ [key]: valueFromStyles }, docx)[0];
			const markFromMarks = encodeMarksFromRPr({ [key]: valueFromMarks }, docx)[0];
			if (JSON.stringify(markFromMarks?.attrs) !== JSON.stringify(markFromStyles?.attrs)) {
				const existingFontFamily = existingRunProperties?.[key];
				inlineRunProperties[key] = marksMatchExistingFontFamily(markFromMarks, existingFontFamily, encodeMarksFromRPr, docx) ? mergeFontFamilyPreservingThemeRefs(valueFromMarks, existingFontFamily) : valueFromMarks;
			}
		} else inlineRunProperties[key] = valueFromMarks;
	}
	if (existingRunProperties != null) Object.keys(existingRunProperties).forEach((key) => {
		if (RUN_PROPERTIES_DERIVED_FROM_MARKS.has(key) && !preservedDerivedKeys.has(key)) return;
		const baseKey = COMPANION_INLINE_KEYS[key];
		if (baseKey && removedKeys.has(baseKey)) return;
		if (key === "styleId" && TRANSIENT_HYPERLINK_STYLE_IDS.has(existingRunProperties[key]) && (runPropertiesFromMarks.styleId == null || runPropertiesFromMarks.styleId === "")) return;
		if (key in inlineRunProperties) return;
		if (existingRunProperties[key] === void 0) return;
		inlineRunProperties[key] = existingRunProperties[key];
	});
	return inlineRunProperties;
}
function stableStringifyInlineProps(inlineProps) {
	if (!inlineProps || !Object.keys(inlineProps).length) return "__none__";
	const sortedKeys = Object.keys(inlineProps).sort();
	const sorted = {};
	sortedKeys.forEach((key) => {
		sorted[key] = inlineProps[key];
	});
	return JSON.stringify(sorted);
}
function createSelectionPreserver(tr, originalSelection, originalStoredMarks = null) {
	if (!originalSelection) return null;
	const isTextSelection$1 = originalSelection instanceof TextSelection;
	let preservedAnchor = isTextSelection$1 ? originalSelection.anchor : null;
	let preservedHead = isTextSelection$1 ? originalSelection.head : null;
	const anchorAssoc = preservedAnchor != null && preservedHead != null && preservedAnchor <= preservedHead ? -1 : 1;
	const headAssoc = preservedAnchor != null && preservedHead != null && preservedHead >= preservedAnchor ? 1 : -1;
	function mapOffsetThroughReplacement(startPos, replacement, offset) {
		let currentPos = startPos;
		let remaining = offset;
		let mapped = null;
		replacement.forEach((node) => {
			if (mapped != null) return;
			const contentSize = node.content.size;
			if (remaining <= contentSize) {
				mapped = currentPos + 1 + remaining;
				return;
			}
			remaining -= contentSize;
			currentPos += node.nodeSize;
		});
		return mapped ?? currentPos;
	}
	const mapReplacement = (startPos, nodeSize$1, replacement) => {
		if (!isTextSelection$1 || preservedAnchor == null || preservedHead == null) return;
		const stepMap = tr.mapping.maps[tr.mapping.maps.length - 1];
		const mapSelectionPos = (posToMap, assoc) => {
			if (posToMap == null) return null;
			if (posToMap < startPos || posToMap > startPos + nodeSize$1) return stepMap.map(posToMap, assoc);
			return mapOffsetThroughReplacement(startPos, replacement, posToMap - (startPos + 1));
		};
		preservedAnchor = mapSelectionPos(preservedAnchor, anchorAssoc);
		preservedHead = mapSelectionPos(preservedHead, headAssoc);
	};
	const finalize = () => {
		if (!tr.docChanged) return;
		if (isTextSelection$1 && preservedAnchor != null && preservedHead != null) {
			tr.setSelection(TextSelection.create(tr.doc, preservedAnchor, preservedHead));
			if (preservedAnchor === preservedHead && originalStoredMarks !== null) tr.setStoredMarks(originalStoredMarks);
			return;
		}
		tr.setSelection(originalSelection.map(tr.doc, tr.mapping));
	};
	return {
		mapReplacement,
		finalize
	};
}
function normalizeRunProperties(runProperties) {
	if (!runProperties || typeof runProperties !== "object") return null;
	return Object.keys(runProperties).length > 0 ? runProperties : null;
}
function getMarksFromSelection(state, editor) {
	return getSelectionFormattingState(state, editor).resolvedMarks;
}
function getSelectionFormattingState(state, editor) {
	const { from, to, empty: empty$1 } = state.selection;
	if (empty$1) return getFormattingStateAtPos(state, state.selection.$head.pos, editor, {
		storedMarks: state.storedMarks ?? null,
		includeCursorMarksWithStoredMarks: true
	});
	return getFormattingStateForRange(state, from, to, editor);
}
function getFormattingStateAtPos(state, pos, editor, options = {}) {
	const { storedMarks = null, includeCursorMarksWithStoredMarks = false, preferParagraphRunProperties = false } = options;
	const $pos = state.doc.resolve(pos);
	const context = getParagraphRunContext($pos, editor);
	const currentRunProperties = context?.runProperties || null;
	const cursorMarks = $pos.marks();
	const hasStoredMarks = storedMarks !== null;
	const hasExplicitEmptyStoredMarks = hasStoredMarks && storedMarks.length === 0;
	const resolvedMarks = [];
	const inlineMarks = [];
	let inlineRunProperties = null;
	if (preferParagraphRunProperties) {
		inlineRunProperties = context?.paragraphAttrs?.paragraphProperties?.runProperties || null;
		inlineMarks.push(...createMarksFromRunProperties(state, inlineRunProperties, editor));
	} else if (hasStoredMarks) {
		inlineMarks.push(...storedMarks);
		inlineRunProperties = decodeRPrFromMarks(storedMarks);
	} else if (context?.isEmpty) {
		inlineRunProperties = context?.paragraphAttrs?.paragraphProperties?.runProperties || null;
		inlineMarks.push(...createMarksFromRunProperties(state, inlineRunProperties, editor));
	} else if (currentRunProperties) {
		inlineRunProperties = currentRunProperties;
		inlineMarks.push(...createMarksFromRunProperties(state, inlineRunProperties, editor));
	} else {
		inlineMarks.push(...cursorMarks);
		inlineRunProperties = decodeRPrFromMarks(inlineMarks);
	}
	if (hasExplicitEmptyStoredMarks) return {
		resolvedMarks: [],
		inlineMarks: [],
		resolvedRunProperties: {},
		inlineRunProperties: {},
		styleRunProperties: {}
	};
	const resolvedFromSelection = getInheritedRunProperties($pos, editor, preferParagraphRunProperties || !hasStoredMarks && context?.isEmpty ? context?.paragraphAttrs?.paragraphProperties?.runProperties || null : inlineRunProperties);
	const resolvedRunProperties = resolvedFromSelection?.resolvedRunProperties ?? inlineRunProperties;
	const styleRunProperties = resolvedFromSelection?.styleRunProperties ?? null;
	const resolvedMarksFromProperties = createMarksFromRunProperties(state, resolvedRunProperties, editor);
	resolvedMarks.push(...mergeResolvedMarksWithInlineFallback(resolvedMarksFromProperties, inlineMarks));
	if (hasStoredMarks && includeCursorMarksWithStoredMarks) resolvedMarks.push(...cursorMarks);
	return {
		resolvedMarks,
		inlineMarks,
		resolvedRunProperties,
		inlineRunProperties,
		styleRunProperties
	};
}
function getFormattingStateForRange(state, from, to, editor) {
	const segments = [];
	const seen = /* @__PURE__ */ new Set();
	state.doc.nodesBetween(from, to, (node, pos) => {
		if (!node.isText || node.text?.length === 0) return;
		const segmentPos = pos + 1;
		if (seen.has(segmentPos)) return;
		seen.add(segmentPos);
		segments.push(getFormattingStateAtPos(state, segmentPos, editor));
	});
	if (segments.length === 0) return getFormattingStateAtPos(state, from, editor);
	return aggregateFormattingSegments(state, editor, segments);
}
function aggregateFormattingSegments(state, editor, segments) {
	const resolvedRunProperties = intersectRunProperties(segments.map((segment) => segment.resolvedRunProperties));
	const inlineRunProperties = intersectRunProperties(segments.map((segment) => segment.inlineRunProperties));
	const styleRunProperties = intersectRunProperties(segments.map((segment) => segment.styleRunProperties));
	const resolvedMarks = createMarksFromRunProperties(state, resolvedRunProperties, editor);
	const inlineMarks = createMarksFromRunProperties(state, inlineRunProperties, editor);
	return {
		resolvedMarks: mergeResolvedMarksWithInlineFallback(resolvedMarks, inlineMarks),
		inlineMarks,
		resolvedRunProperties,
		inlineRunProperties,
		styleRunProperties
	};
}
function mergeResolvedMarksWithInlineFallback(resolvedMarks, inlineMarks) {
	if (!resolvedMarks.length) return inlineMarks;
	if (!inlineMarks.length) return resolvedMarks;
	const resolvedMarkNames = new Set(resolvedMarks.map((mark) => mark.type.name));
	const missingInlineMarks = inlineMarks.filter((mark) => !resolvedMarkNames.has(mark.type.name));
	return [...resolvedMarks, ...missingInlineMarks];
}
function intersectRunProperties(runPropertiesList) {
	const filtered = runPropertiesList.filter((props) => props && typeof props === "object");
	if (filtered.length === 0) return null;
	const first = filtered[0];
	const intersection = {};
	Object.keys(first).forEach((key) => {
		const serialized = JSON.stringify(first[key]);
		if (filtered.every((props) => JSON.stringify(props[key]) === serialized)) intersection[key] = first[key];
	});
	return Object.keys(intersection).length ? intersection : null;
}
function getInheritedRunProperties($pos, editor, inlineRunProperties) {
	if (!editor) return {
		resolvedRunProperties: null,
		inlineRunProperties: null,
		styleRunProperties: null
	};
	const context = getParagraphRunContext($pos, editor);
	if (!context) return {
		resolvedRunProperties: null,
		inlineRunProperties: null,
		styleRunProperties: null
	};
	try {
		const { params, resolvedPpr, tableInfo, numberingDefinedInline } = context;
		const styleSeed = inlineRunProperties && inlineRunProperties.styleId != null ? { styleId: inlineRunProperties.styleId } : {};
		return {
			resolvedRunProperties: resolveRunProperties(params, inlineRunProperties, resolvedPpr || {}, tableInfo, false, numberingDefinedInline),
			inlineRunProperties,
			styleRunProperties: resolveRunProperties(params, styleSeed, resolvedPpr || {}, tableInfo, false, numberingDefinedInline)
		};
	} catch {
		return {
			resolvedRunProperties: null,
			inlineRunProperties: null,
			styleRunProperties: null
		};
	}
}
function getParagraphRunContext($pos, editor) {
	let tableInfo = null;
	let runProperties = null;
	let paragraphNode = null;
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node.type.name === "run" && runProperties == null) runProperties = normalizeRunProperties(node.attrs?.runProperties);
		if (node.type.name === "paragraph") paragraphNode = node;
		else if (node.type.name === "tableCell") {
			tableInfo = extractTableInfo($pos, depth);
			if (paragraphNode) break;
		}
	}
	if (runProperties == null) {
		const nodeBefore = $pos.nodeBefore;
		if (nodeBefore?.type.name === "run") runProperties = normalizeRunProperties(nodeBefore.attrs?.runProperties);
		else {
			const nodeAfter = $pos.nodeAfter;
			if (nodeAfter?.type.name === "run") runProperties = normalizeRunProperties(nodeAfter.attrs?.runProperties);
		}
	}
	if (!paragraphNode) return null;
	const paragraphAttrs = paragraphNode.attrs || {};
	const { params, resolvedPpr } = getSafeResolutionContext(editor, paragraphNode, $pos, paragraphAttrs);
	return {
		params,
		isEmpty: paragraphNode.content.size === 0,
		paragraphAttrs,
		runProperties,
		resolvedPpr,
		tableInfo,
		numberingDefinedInline: Boolean(paragraphAttrs.paragraphProperties?.numberingProperties)
	};
}
function getSafeResolutionContext(editor, node, $pos, paragraphAttrs) {
	const fallback = {
		params: {
			docx: {},
			numbering: {},
			translatedNumbering: {},
			translatedLinkedStyles: {}
		},
		resolvedPpr: paragraphAttrs.paragraphProperties || {}
	};
	if (!editor) return fallback;
	try {
		return {
			params: {
				docx: editor?.converter?.convertedXml ?? {},
				numbering: editor?.converter?.numbering ?? {},
				translatedNumbering: editor?.converter?.translatedNumbering ?? {},
				translatedLinkedStyles: editor?.converter?.translatedLinkedStyles ?? {}
			},
			resolvedPpr: calculateResolvedParagraphProperties(editor, node, $pos) || paragraphAttrs.paragraphProperties || {}
		};
	} catch {
		return fallback;
	}
}
function createMarksFromRunProperties(state, runProperties, editor) {
	return encodeMarksFromRPr(runProperties, getSafeConvertedXml(editor)).map((def) => {
		const markType = state.schema.marks[def.type];
		return markType ? markType.create(def.attrs) : null;
	}).filter(Boolean);
}
function getSafeConvertedXml(editor) {
	try {
		return editor?.converter?.convertedXml ?? {};
	} catch {
		return {};
	}
}
const findMark = (state, markType, toArr = false) => {
	const { selection, doc: doc$2 } = state;
	const { $from, $to } = selection;
	const fromMark = $from.marks().find((mark) => mark.type === markType);
	const toMark = $to.marks().find((mark) => mark.type === markType);
	let markFound;
	const marksFound = [];
	doc$2.nodesBetween($from.pos, $to.pos, (node, from) => {
		if (node.marks) {
			const actualMark = node.marks.find((mark) => mark.type === markType);
			if (actualMark) {
				markFound = {
					from,
					to: from + node.nodeSize,
					attrs: actualMark.attrs,
					contained: !fromMark || !toMark || fromMark === toMark
				};
				marksFound.push(markFound);
			}
		}
	});
	if (toArr) return marksFound;
	return markFound;
};
function getActiveFormatting(editor) {
	const { state } = editor;
	const { selection } = state;
	const marks = selection.empty && state.storedMarks != null ? state.storedMarks : getMarksFromSelection(state, editor);
	const markAttrs = selection.$head.parent.attrs.marksAttrs;
	const marksToProcess = marks.filter((mark) => !["textStyle", "link"].includes(mark.type.name)).map((mark) => ({
		name: mark.type.name,
		attrs: mark.attrs
	}));
	const textStyleMarks = marks.filter((mark) => mark.type.name === "textStyle");
	marksToProcess.push(...textStyleMarks.flatMap(unwrapTextMarks));
	if (markAttrs) {
		const marksFromAttrs = markAttrs.filter((mark) => !["textStyle", "link"].includes(mark.type)).map((mark) => ({
			name: mark.type,
			attrs: mark.attrs || {}
		}));
		const textStyleMarksFromAttrs = markAttrs.filter((mark) => mark.type === "textStyle");
		marksToProcess.push(...marksFromAttrs);
		marksToProcess.push(...textStyleMarksFromAttrs.flatMap(unwrapTextMarks));
	}
	const linkMarkType = state.schema.marks["link"];
	const linkMark = findMark(state, linkMarkType);
	if (linkMark) {
		let { from, to, attrs } = linkMark;
		if (selection.from >= from && selection.to <= to) marksToProcess.push({
			name: "link",
			attrs
		});
	}
	const ignoreKeys = ["paragraphSpacing"];
	const attributes = getActiveAttributes(state);
	Object.keys(attributes).forEach((key) => {
		if (ignoreKeys.includes(key)) return;
		const attrs = {};
		attrs[key] = attributes[key];
		marksToProcess.push({
			name: key,
			attrs
		});
	});
	const textColor = marksToProcess.find((i$1) => i$1.name === "textColor");
	const textHightlight = marksToProcess.find((i$1) => i$1.name === "textHighlight");
	if (textColor) marksToProcess.push({
		name: "color",
		attrs: { color: textColor.attrs?.textColor }
	});
	if (textHightlight) marksToProcess.push({
		name: "highlight",
		attrs: { color: textHightlight.attrs?.textHighlight }
	});
	if (!!editor.storage.formatCommands?.storedStyle) marksToProcess.push({
		name: "copyFormat",
		attrs: true
	});
	return marksToProcess;
}
function unwrapTextMarks(textStyleMark) {
	const processedMarks = [];
	const { attrs } = textStyleMark;
	Object.keys(attrs).forEach((key) => {
		if (!attrs[key]) return;
		processedMarks.push({
			name: key,
			attrs: { [key]: attrs[key] }
		});
	});
	return processedMarks;
}
function getActiveAttributes(state) {
	try {
		const { from, to, empty: empty$1 } = state.selection;
		const attributes = {};
		const getAttrs$3 = (node) => {
			Object.keys(node.attrs).forEach((key) => {
				const value = node.attrs[key];
				if (value) attributes[key] = value;
			});
		};
		let start = from;
		let end = to;
		if (empty$1) state.doc.nodesBetween(start, end + 1, (node) => getAttrs$3(node));
		else state.doc.nodesBetween(from, to, (node) => getAttrs$3(node));
		return attributes;
	} catch {
		return {};
	}
}
function findChildren$1(node, predicate) {
	const nodesWithPos = [];
	node.descendants((child, pos) => {
		if (predicate(child)) nodesWithPos.push({
			node: child,
			pos
		});
	});
	return nodesWithPos;
}
function posToDOMRect(view, from, to) {
	const minPos = 0;
	const maxPos = view.state.doc.content.size;
	const resolvedFrom = minMax(from, minPos, maxPos);
	const resolvedEnd = minMax(to, minPos, maxPos);
	const start = view.coordsAtPos(resolvedFrom);
	const end = view.coordsAtPos(resolvedEnd, -1);
	const top = Math.min(start.top, end.top);
	const bottom = Math.max(start.bottom, end.bottom);
	const left = Math.min(start.left, end.left);
	const right = Math.max(start.right, end.right);
	const data = {
		top,
		bottom,
		left,
		right,
		width: right - left,
		height: bottom - top,
		x: left,
		y: top
	};
	return {
		...data,
		toJSON: () => data
	};
}
const isInTable = (state) => {
	const { $head } = state.selection;
	for (let d = $head.depth; d > 0; d -= 1) if ($head.node(d).type?.spec?.tableRole === "row") return true;
	return false;
};
function stripHtmlStyles(html, domDocument) {
	if (!html) return "";
	const DOMParserConstructor = (domDocument?.defaultView ?? (typeof window !== "undefined" ? window : null))?.DOMParser ?? (typeof DOMParser !== "undefined" ? DOMParser : null);
	if (!DOMParserConstructor) throw new Error("[super-editor] HTML import requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
	const doc$2 = new DOMParserConstructor().parseFromString(html, "text/html");
	const SUPPORTED_ATTRS = [
		"href",
		"src",
		"alt",
		"title",
		"colspan",
		"rowspan",
		"headers",
		"scope",
		"lang",
		"dir",
		"cite",
		"start",
		"type",
		"styleid"
	];
	const cleanNode = (node) => {
		if (node.nodeType !== 1) return;
		if (node.nodeName.toLowerCase() === "span" && !node.children.length) node.innerHTML = preserveSpaces(node.innerHTML);
		[...node.attributes].forEach((attr) => {
			const name = attr.name.toLowerCase();
			if (name === "style") {
				const cleanedStyle = cleanStyle(attr.value);
				if (!cleanedStyle) node.removeAttribute(attr.name);
				else node.setAttribute(attr.name, cleanedStyle);
				return;
			}
			if (!(SUPPORTED_ATTRS.includes(name) || name.startsWith("data-"))) node.removeAttribute(attr.name);
		});
		[...node.children].forEach(cleanNode);
	};
	cleanNode(doc$2.body);
	return doc$2.body.innerHTML;
}
function cleanStyle(style) {
	if (!style) return "";
	const textAlign = style.split(";").map((s) => s.trim()).filter(Boolean).find((d) => d.startsWith("text-align"));
	return textAlign ? `${textAlign};` : "";
}
function preserveSpaces(innerHtml) {
	return innerHtml.replace(/^\s+/, "&nbsp;").replace(/\s+$/, "&nbsp;");
}
var CommandService = class CommandService {
	editor;
	rawCommands;
	constructor(props) {
		this.editor = props.editor;
		this.rawCommands = this.editor.extensionService.commands;
	}
	static create(params) {
		return new CommandService(params);
	}
	get state() {
		return this.editor.state;
	}
	get commands() {
		const { editor, state } = this;
		const { view } = editor;
		const { tr } = state;
		const props = this.createProps(tr);
		const entries = Object.entries(this.rawCommands).map(([name, command]) => {
			const method = (...args) => {
				const fn = command(...args)(props);
				if (!tr.getMeta("preventDispatch")) {
					if (!this.#dispatchWithFallback(tr, {
						editor,
						view
					})) return false;
				}
				return fn;
			};
			return [name, method];
		});
		return Object.fromEntries(entries);
	}
	get chain() {
		return () => this.createChain();
	}
	get can() {
		return () => this.createCan();
	}
	createChain(startTr, shouldDispatch = true) {
		const { editor, state, rawCommands } = this;
		const { view } = editor;
		const callbacks = [];
		const hasStartTr = !!startTr;
		const tr = startTr || state.tr;
		const run$1 = () => {
			if (!hasStartTr && shouldDispatch && !tr.getMeta("preventDispatch")) {
				if (!this.#dispatchWithFallback(tr, {
					editor,
					view
				})) return false;
			}
			return callbacks.every((cb) => cb === true);
		};
		const entries = Object.entries(rawCommands).map(([name, command]) => {
			const chainedCommand = (...args) => {
				const props = this.createProps(tr, shouldDispatch);
				const callback = command(...args)(props);
				callbacks.push(callback);
				return chain;
			};
			return [name, chainedCommand];
		});
		const chain = {
			...Object.fromEntries(entries),
			run: run$1
		};
		return chain;
	}
	createCan(startTr) {
		const { rawCommands, state } = this;
		const dispatch = false;
		const tr = startTr || state.tr;
		const props = this.createProps(tr, dispatch);
		return {
			...Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
				return [name, (...args) => command(...args)({
					...props,
					dispatch: void 0
				})];
			})),
			chain: () => this.createChain(tr, dispatch)
		};
	}
	createProps(tr, shouldDispatch = true) {
		const { editor, state, rawCommands } = this;
		const { view } = editor;
		const props = {
			tr,
			editor,
			view,
			state: chainableEditorState(tr, state),
			dispatch: shouldDispatch ? () => void 0 : void 0,
			chain: () => this.createChain(tr, shouldDispatch),
			can: () => this.createCan(tr),
			get commands() {
				return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
					return [name, (...args) => command(...args)(props)];
				}));
			}
		};
		return props;
	}
	#dispatchWithFallback(tr, { editor, view }) {
		if (editor?.isDestroyed) {
			console.warn("[CommandService] Cannot dispatch: editor is destroyed");
			return false;
		}
		try {
			if (view && typeof view.dispatch === "function") view.dispatch(tr);
			else if (typeof editor?.dispatch === "function") editor.dispatch(tr);
			else {
				console.warn("[CommandService] No dispatch method available (editor may not be initialized)");
				return false;
			}
			return true;
		} catch (error) {
			const err$1 = /* @__PURE__ */ new Error(`[CommandService] Dispatch failed: ${error.message}`);
			err$1.cause = error;
			throw err$1;
		}
	}
};
function getHTMLFromFragment(fragment, schema, domDocument) {
	const resolvedDocument = domDocument ?? (typeof document !== "undefined" ? document : null);
	if (!resolvedDocument) throw new Error("[super-editor] getHTMLFromFragment() requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
	const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment, { document: resolvedDocument });
	const container = resolvedDocument.createElement("div");
	container.appendChild(documentFragment);
	return container.innerHTML;
}
const warnNoDOM = (feature = "This feature") => {
	console.warn(`[super-editor] ${feature} requires a DOM document. This environment has no DOM. Provide a DOM (e.g., JSDOM) and set globalThis.document or pass { document } to the editor.`);
};
const getTextContentFromNodes = ($from, maxMatch = 500) => {
	let textBefore = "";
	const sliceEndPos = $from.parentOffset;
	$from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index) => {
		const chunk = node.type.spec.toText?.({
			node,
			pos,
			parent,
			index
		}) || node.textContent || "%leaf%";
		textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
	});
	return textBefore;
};
var GOOD_LEAF_SIZE = 200;
var RopeSequence = function RopeSequence$1() {};
RopeSequence.prototype.append = function append(other) {
	if (!other.length) return this;
	other = RopeSequence.from(other);
	return !this.length && other || other.length < GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
RopeSequence.prototype.prepend = function prepend(other) {
	if (!other.length) return this;
	return RopeSequence.from(other).append(this);
};
RopeSequence.prototype.appendInner = function appendInner(other) {
	return new Append(this, other);
};
RopeSequence.prototype.slice = function slice(from, to) {
	if (from === void 0) from = 0;
	if (to === void 0) to = this.length;
	if (from >= to) return RopeSequence.empty;
	return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
RopeSequence.prototype.get = function get(i$1) {
	if (i$1 < 0 || i$1 >= this.length) return;
	return this.getInner(i$1);
};
RopeSequence.prototype.forEach = function forEach(f, from, to) {
	if (from === void 0) from = 0;
	if (to === void 0) to = this.length;
	if (from <= to) this.forEachInner(f, from, to, 0);
	else this.forEachInvertedInner(f, from, to, 0);
};
RopeSequence.prototype.map = function map(f, from, to) {
	if (from === void 0) from = 0;
	if (to === void 0) to = this.length;
	var result = [];
	this.forEach(function(elt, i$1) {
		return result.push(f(elt, i$1));
	}, from, to);
	return result;
};
RopeSequence.from = function from(values) {
	if (values instanceof RopeSequence) return values;
	return values && values.length ? new Leaf(values) : RopeSequence.empty;
};
var Leaf = /* @__PURE__ */ function(RopeSequence$1) {
	function Leaf$1(values) {
		RopeSequence$1.call(this);
		this.values = values;
	}
	if (RopeSequence$1) Leaf$1.__proto__ = RopeSequence$1;
	Leaf$1.prototype = Object.create(RopeSequence$1 && RopeSequence$1.prototype);
	Leaf$1.prototype.constructor = Leaf$1;
	var prototypeAccessors = {
		length: { configurable: true },
		depth: { configurable: true }
	};
	Leaf$1.prototype.flatten = function flatten$1() {
		return this.values;
	};
	Leaf$1.prototype.sliceInner = function sliceInner(from, to) {
		if (from == 0 && to == this.length) return this;
		return new Leaf$1(this.values.slice(from, to));
	};
	Leaf$1.prototype.getInner = function getInner(i$1) {
		return this.values[i$1];
	};
	Leaf$1.prototype.forEachInner = function forEachInner(f, from, to, start) {
		for (var i$1 = from; i$1 < to; i$1++) if (f(this.values[i$1], start + i$1) === false) return false;
	};
	Leaf$1.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
		for (var i$1 = from - 1; i$1 >= to; i$1--) if (f(this.values[i$1], start + i$1) === false) return false;
	};
	Leaf$1.prototype.leafAppend = function leafAppend(other) {
		if (this.length + other.length <= GOOD_LEAF_SIZE) return new Leaf$1(this.values.concat(other.flatten()));
	};
	Leaf$1.prototype.leafPrepend = function leafPrepend(other) {
		if (this.length + other.length <= GOOD_LEAF_SIZE) return new Leaf$1(other.flatten().concat(this.values));
	};
	prototypeAccessors.length.get = function() {
		return this.values.length;
	};
	prototypeAccessors.depth.get = function() {
		return 0;
	};
	Object.defineProperties(Leaf$1.prototype, prototypeAccessors);
	return Leaf$1;
}(RopeSequence);
RopeSequence.empty = new Leaf([]);
var Append = /* @__PURE__ */ function(RopeSequence$1) {
	function Append$1(left, right) {
		RopeSequence$1.call(this);
		this.left = left;
		this.right = right;
		this.length = left.length + right.length;
		this.depth = Math.max(left.depth, right.depth) + 1;
	}
	if (RopeSequence$1) Append$1.__proto__ = RopeSequence$1;
	Append$1.prototype = Object.create(RopeSequence$1 && RopeSequence$1.prototype);
	Append$1.prototype.constructor = Append$1;
	Append$1.prototype.flatten = function flatten$1() {
		return this.left.flatten().concat(this.right.flatten());
	};
	Append$1.prototype.getInner = function getInner(i$1) {
		return i$1 < this.left.length ? this.left.get(i$1) : this.right.get(i$1 - this.left.length);
	};
	Append$1.prototype.forEachInner = function forEachInner(f, from, to, start) {
		var leftLen = this.left.length;
		if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
		if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
	};
	Append$1.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
		var leftLen = this.left.length;
		if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
		if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
	};
	Append$1.prototype.sliceInner = function sliceInner(from, to) {
		if (from == 0 && to == this.length) return this;
		var leftLen = this.left.length;
		if (to <= leftLen) return this.left.slice(from, to);
		if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
		return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
	};
	Append$1.prototype.leafAppend = function leafAppend(other) {
		var inner = this.right.leafAppend(other);
		if (inner) return new Append$1(this.left, inner);
	};
	Append$1.prototype.leafPrepend = function leafPrepend(other) {
		var inner = this.left.leafPrepend(other);
		if (inner) return new Append$1(inner, this.right);
	};
	Append$1.prototype.appendInner = function appendInner(other) {
		if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append$1(this.left, new Append$1(this.right, other));
		return new Append$1(this, other);
	};
	return Append$1;
}(RopeSequence);
var dist_default = RopeSequence;
var max_empty_items = 500;
var Branch = class Branch {
	constructor(items, eventCount) {
		this.items = items;
		this.eventCount = eventCount;
	}
	popEvent(state, preserveItems) {
		if (this.eventCount == 0) return null;
		let end = this.items.length;
		for (;; end--) if (this.items.get(end - 1).selection) {
			--end;
			break;
		}
		let remap, mapFrom;
		if (preserveItems) {
			remap = this.remapping(end, this.items.length);
			mapFrom = remap.maps.length;
		}
		let transform = state.tr;
		let selection, remaining;
		let addAfter = [], addBefore = [];
		this.items.forEach((item, i$1) => {
			if (!item.step) {
				if (!remap) {
					remap = this.remapping(end, i$1 + 1);
					mapFrom = remap.maps.length;
				}
				mapFrom--;
				addBefore.push(item);
				return;
			}
			if (remap) {
				addBefore.push(new Item$1(item.map));
				let step$1 = item.step.map(remap.slice(mapFrom)), map;
				if (step$1 && transform.maybeStep(step$1).doc) {
					map = transform.mapping.maps[transform.mapping.maps.length - 1];
					addAfter.push(new Item$1(map, void 0, void 0, addAfter.length + addBefore.length));
				}
				mapFrom--;
				if (map) remap.appendMap(map, mapFrom);
			} else transform.maybeStep(item.step);
			if (item.selection) {
				selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
				remaining = new Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
				return false;
			}
		}, this.items.length, 0);
		return {
			remaining,
			transform,
			selection
		};
	}
	addTransform(transform, selection, histOptions, preserveItems) {
		let newItems = [], eventCount = this.eventCount;
		let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
		for (let i$1 = 0; i$1 < transform.steps.length; i$1++) {
			let step$1 = transform.steps[i$1].invert(transform.docs[i$1]);
			let item = new Item$1(transform.mapping.maps[i$1], step$1, selection), merged;
			if (merged = lastItem && lastItem.merge(item)) {
				item = merged;
				if (i$1) newItems.pop();
				else oldItems = oldItems.slice(0, oldItems.length - 1);
			}
			newItems.push(item);
			if (selection) {
				eventCount++;
				selection = void 0;
			}
			if (!preserveItems) lastItem = item;
		}
		let overflow = eventCount - histOptions.depth;
		if (overflow > DEPTH_OVERFLOW) {
			oldItems = cutOffEvents(oldItems, overflow);
			eventCount -= overflow;
		}
		return new Branch(oldItems.append(newItems), eventCount);
	}
	remapping(from, to) {
		let maps = new Mapping();
		this.items.forEach((item, i$1) => {
			let mirrorPos = item.mirrorOffset != null && i$1 - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : void 0;
			maps.appendMap(item.map, mirrorPos);
		}, from, to);
		return maps;
	}
	addMaps(array) {
		if (this.eventCount == 0) return this;
		return new Branch(this.items.append(array.map((map) => new Item$1(map))), this.eventCount);
	}
	rebased(rebasedTransform, rebasedCount) {
		if (!this.eventCount) return this;
		let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
		let mapping = rebasedTransform.mapping;
		let newUntil = rebasedTransform.steps.length;
		let eventCount = this.eventCount;
		this.items.forEach((item) => {
			if (item.selection) eventCount--;
		}, start);
		let iRebased = rebasedCount;
		this.items.forEach((item) => {
			let pos = mapping.getMirror(--iRebased);
			if (pos == null) return;
			newUntil = Math.min(newUntil, pos);
			let map = mapping.maps[pos];
			if (item.step) {
				let step$1 = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
				let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
				if (selection) eventCount++;
				rebasedItems.push(new Item$1(map, step$1, selection));
			} else rebasedItems.push(new Item$1(map));
		}, start);
		let newMaps = [];
		for (let i$1 = rebasedCount; i$1 < newUntil; i$1++) newMaps.push(new Item$1(mapping.maps[i$1]));
		let branch = new Branch(this.items.slice(0, start).append(newMaps).append(rebasedItems), eventCount);
		if (branch.emptyItemCount() > max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
		return branch;
	}
	emptyItemCount() {
		let count = 0;
		this.items.forEach((item) => {
			if (!item.step) count++;
		});
		return count;
	}
	compress(upto = this.items.length) {
		let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
		let items = [], events = 0;
		this.items.forEach((item, i$1) => {
			if (i$1 >= upto) {
				items.push(item);
				if (item.selection) events++;
			} else if (item.step) {
				let step$1 = item.step.map(remap.slice(mapFrom)), map = step$1 && step$1.getMap();
				mapFrom--;
				if (map) remap.appendMap(map, mapFrom);
				if (step$1) {
					let selection = item.selection && item.selection.map(remap.slice(mapFrom));
					if (selection) events++;
					let newItem = new Item$1(map.invert(), step$1, selection), merged, last = items.length - 1;
					if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
					else items.push(newItem);
				}
			} else if (item.map) mapFrom--;
		}, this.items.length, 0);
		return new Branch(dist_default.from(items.reverse()), events);
	}
};
Branch.empty = new Branch(dist_default.empty, 0);
function cutOffEvents(items, n) {
	let cutPoint;
	items.forEach((item, i$1) => {
		if (item.selection && n-- == 0) {
			cutPoint = i$1;
			return false;
		}
	});
	return items.slice(cutPoint);
}
var Item$1 = class Item$1 {
	constructor(map, step$1, selection, mirrorOffset) {
		this.map = map;
		this.step = step$1;
		this.selection = selection;
		this.mirrorOffset = mirrorOffset;
	}
	merge(other) {
		if (this.step && other.step && !other.selection) {
			let step$1 = other.step.merge(this.step);
			if (step$1) return new Item$1(step$1.getMap().invert(), step$1, this.selection);
		}
	}
};
var HistoryState = class {
	constructor(done, undone, prevRanges, prevTime, prevComposition) {
		this.done = done;
		this.undone = undone;
		this.prevRanges = prevRanges;
		this.prevTime = prevTime;
		this.prevComposition = prevComposition;
	}
};
var DEPTH_OVERFLOW = 20;
function applyTransaction(history$1, state, tr, options) {
	let historyTr = tr.getMeta(historyKey), rebased;
	if (historyTr) return historyTr.historyState;
	if (tr.getMeta(closeHistoryKey)) history$1 = new HistoryState(history$1.done, history$1.undone, null, 0, -1);
	let appended = tr.getMeta("appendedTransaction");
	if (tr.steps.length == 0) return history$1;
	else if (appended && appended.getMeta(historyKey)) if (appended.getMeta(historyKey).redo) return new HistoryState(history$1.done.addTransform(tr, void 0, options, mustPreserveItems(state)), history$1.undone, rangesFor(tr.mapping.maps), history$1.prevTime, history$1.prevComposition);
	else return new HistoryState(history$1.done, history$1.undone.addTransform(tr, void 0, options, mustPreserveItems(state)), null, history$1.prevTime, history$1.prevComposition);
	else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
		let composition = tr.getMeta("composition");
		let newGroup = history$1.prevTime == 0 || !appended && history$1.prevComposition != composition && (history$1.prevTime < (tr.time || 0) - options.newGroupDelay || !isAdjacentTo(tr, history$1.prevRanges));
		let prevRanges = appended ? mapRanges(history$1.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps);
		return new HistoryState(history$1.done.addTransform(tr, newGroup ? state.selection.getBookmark() : void 0, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr.time, composition == null ? history$1.prevComposition : composition);
	} else if (rebased = tr.getMeta("rebased")) return new HistoryState(history$1.done.rebased(tr, rebased), history$1.undone.rebased(tr, rebased), mapRanges(history$1.prevRanges, tr.mapping), history$1.prevTime, history$1.prevComposition);
	else return new HistoryState(history$1.done.addMaps(tr.mapping.maps), history$1.undone.addMaps(tr.mapping.maps), mapRanges(history$1.prevRanges, tr.mapping), history$1.prevTime, history$1.prevComposition);
}
function isAdjacentTo(transform, prevRanges) {
	if (!prevRanges) return false;
	if (!transform.docChanged) return true;
	let adjacent = false;
	transform.mapping.maps[0].forEach((start, end) => {
		for (let i$1 = 0; i$1 < prevRanges.length; i$1 += 2) if (start <= prevRanges[i$1 + 1] && end >= prevRanges[i$1]) adjacent = true;
	});
	return adjacent;
}
function rangesFor(maps) {
	let result = [];
	for (let i$1 = maps.length - 1; i$1 >= 0 && result.length == 0; i$1--) maps[i$1].forEach((_from, _to, from, to) => result.push(from, to));
	return result;
}
function mapRanges(ranges, mapping) {
	if (!ranges) return null;
	let result = [];
	for (let i$1 = 0; i$1 < ranges.length; i$1 += 2) {
		let from = mapping.map(ranges[i$1], 1), to = mapping.map(ranges[i$1 + 1], -1);
		if (from <= to) result.push(from, to);
	}
	return result;
}
function histTransaction(history$1, state, redo$1) {
	let preserveItems = mustPreserveItems(state);
	let histOptions = historyKey.get(state).spec.config;
	let pop = (redo$1 ? history$1.undone : history$1.done).popEvent(state, preserveItems);
	if (!pop) return null;
	let selection = pop.selection.resolve(pop.transform.doc);
	let added = (redo$1 ? history$1.done : history$1.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
	let newHist = new HistoryState(redo$1 ? added : pop.remaining, redo$1 ? pop.remaining : added, null, 0, -1);
	return pop.transform.setSelection(selection).setMeta(historyKey, {
		redo: redo$1,
		historyState: newHist
	});
}
var cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
function mustPreserveItems(state) {
	let plugins = state.plugins;
	if (cachedPreserveItemsPlugins != plugins) {
		cachedPreserveItems = false;
		cachedPreserveItemsPlugins = plugins;
		for (let i$1 = 0; i$1 < plugins.length; i$1++) if (plugins[i$1].spec.historyPreserveItems) {
			cachedPreserveItems = true;
			break;
		}
	}
	return cachedPreserveItems;
}
function closeHistory(tr) {
	return tr.setMeta(closeHistoryKey, true);
}
var historyKey = new PluginKey("history");
var closeHistoryKey = new PluginKey("closeHistory");
function history(config$43 = {}) {
	config$43 = {
		depth: config$43.depth || 100,
		newGroupDelay: config$43.newGroupDelay || 500
	};
	return new Plugin({
		key: historyKey,
		state: {
			init() {
				return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
			},
			apply(tr, hist, state) {
				return applyTransaction(hist, state, tr, config$43);
			}
		},
		config: config$43,
		props: { handleDOMEvents: { beforeinput(view, e) {
			let inputType = e.inputType;
			let command = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
			if (!command || !view.editable) return false;
			e.preventDefault();
			return command(view.state, view.dispatch);
		} } }
	});
}
function buildCommand(redo$1, scroll) {
	return (state, dispatch) => {
		let hist = historyKey.getState(state);
		if (!hist || (redo$1 ? hist.undone : hist.done).eventCount == 0) return false;
		if (dispatch) {
			let tr = histTransaction(hist, state, redo$1);
			if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
		}
		return true;
	};
}
var undo = buildCommand(false, true);
var redo = buildCommand(true, true);
buildCommand(false, false);
buildCommand(true, false);
function undoDepth(state) {
	let hist = historyKey.getState(state);
	return hist ? hist.done.eventCount : 0;
}
function redoDepth(state) {
	let hist = historyKey.getState(state);
	return hist ? hist.undone.eventCount : 0;
}
const ySyncPluginKey = new PluginKey("y-sync");
const yUndoPluginKey = new PluginKey("y-undo");
const yCursorPluginKey = new PluginKey("yjs-cursor");
var descriptors = /* @__PURE__ */ new Map();
function registerPartDescriptor(descriptor) {
	descriptors.set(descriptor.id, descriptor);
}
function getPartDescriptor(partId) {
	return descriptors.get(partId);
}
function hasPartDescriptor(partId) {
	return descriptors.has(partId);
}
function getConvertedXml(editor) {
	const converter = editor.converter;
	if (!converter?.convertedXml) throw new Error("PartStore: editor.converter.convertedXml is not available.");
	return converter.convertedXml;
}
function getPart(editor, partId) {
	return getConvertedXml(editor)[partId];
}
function hasPart(editor, partId) {
	const store = getConvertedXml(editor);
	return partId in store && store[partId] !== void 0;
}
function setPart(editor, partId, data) {
	const store = getConvertedXml(editor);
	store[partId] = data;
}
function removePart(editor, partId) {
	const store = getConvertedXml(editor);
	delete store[partId];
}
function clonePart(part) {
	return structuredClone(part);
}
function diffPartPaths(before, after, prefix = "") {
	if (before === after) return [];
	if (before === null || after === null || typeof before !== typeof after) return [prefix || "/"];
	if (Array.isArray(before) || Array.isArray(after)) {
		if (!Array.isArray(before) || !Array.isArray(after)) return [prefix || "/"];
		return diffArrayPaths(before, after, prefix);
	}
	if (typeof before === "object") return diffObjectPaths(before, after, prefix);
	return [prefix || "/"];
}
function diffObjectPaths(before, after, prefix) {
	const paths = [];
	const allKeys = new Set([...Object.keys(before), ...Object.keys(after)]);
	for (const key of allKeys) {
		const childPrefix = `${prefix}/${key.replace(/~/g, "~0").replace(/\//g, "~1")}`;
		if (!(key in before)) paths.push(childPrefix);
		else if (!(key in after)) paths.push(childPrefix);
		else paths.push(...diffPartPaths(before[key], after[key], childPrefix));
	}
	return paths;
}
function diffArrayPaths(before, after, prefix) {
	const paths = [];
	const maxLen = Math.max(before.length, after.length);
	for (let i$1 = 0; i$1 < maxLen; i$1++) {
		const childPrefix = `${prefix}/${i$1}`;
		if (i$1 >= before.length || i$1 >= after.length) paths.push(childPrefix);
		else paths.push(...diffPartPaths(before[i$1], after[i$1], childPrefix));
	}
	return paths;
}
var PlanError = class extends Error {
	constructor(code$1, message, stepId, details) {
		super(message);
		this.name = "PlanError";
		this.code = code$1;
		this.stepId = stepId;
		this.details = details;
	}
};
function planError(code$1, message, stepId, details) {
	return new PlanError(code$1, `${code$1} — ${message}`, stepId, details);
}
var revisionMap = /* @__PURE__ */ new WeakMap();
var subscribedEditors = /* @__PURE__ */ new WeakSet();
function getRevision(editor) {
	const rev = revisionMap.get(editor) ?? 0;
	return String(rev);
}
function incrementRevision(editor) {
	const next = (revisionMap.get(editor) ?? 0) + 1;
	revisionMap.set(editor, next);
	return String(next);
}
function restoreRevision(editor, revision) {
	revisionMap.set(editor, Number(revision));
}
function initRevision(editor) {
	if (!revisionMap.has(editor)) revisionMap.set(editor, 0);
}
function trackRevisions(editor) {
	if (subscribedEditors.has(editor)) return;
	subscribedEditors.add(editor);
	editor.on("transaction", ({ transaction }) => {
		if (transaction.getMeta?.("superdoc/block-identity-repair")) return;
		if (!transaction.docChanged) return;
		incrementRevision(editor);
	});
}
function checkRevision(editor, expectedRevision) {
	if (expectedRevision === void 0) return;
	const current = getRevision(editor);
	if (expectedRevision !== current) throw new PlanError("REVISION_MISMATCH", `REVISION_MISMATCH — expected revision "${expectedRevision}" but document is at "${current}". Re-run query.match to obtain a fresh ref.`, void 0, {
		expectedRevision,
		currentRevision: current,
		refStability: "ephemeral",
		remediation: "Re-run query.match() to obtain a fresh ref valid for the current revision."
	});
}
var handlers = /* @__PURE__ */ new Map();
function registerInvalidationHandler(partId, handler$1) {
	handlers.set(partId, handler$1);
}
function removeInvalidationHandler(partId) {
	handlers.delete(partId);
}
function applyPartInvalidation(editor, event) {
	const invokedHandlers = /* @__PURE__ */ new Set();
	for (const part of event.parts) {
		const handler$1 = handlers.get(part.partId);
		if (handler$1 && !invokedHandlers.has(handler$1)) {
			invokedHandlers.add(handler$1);
			try {
				handler$1(editor, event);
			} catch (err$1) {
				console.error(`[parts] Invalidation handler failed for "${part.partId}":`, err$1);
			}
		}
	}
}
var stalePartIds = /* @__PURE__ */ new WeakMap();
function markPartCacheStale(editor, partId) {
	let set = stalePartIds.get(editor);
	if (!set) {
		set = /* @__PURE__ */ new Set();
		stalePartIds.set(editor, set);
	}
	set.add(partId);
}
function isPartCacheStale(editor, partId) {
	return stalePartIds.get(editor)?.has(partId) ?? false;
}
function clearPartCacheStale(editor, partId) {
	stalePartIds.get(editor)?.delete(partId);
}
function getConverter$9(editor) {
	return editor.converter;
}
function closeUndoGroup(editor) {
	if (editor.options?.collaborationProvider && editor.options?.ydoc) try {
		yUndoPluginKey.getState(editor.state)?.undoManager?.stopCapturing();
	} catch {}
	else try {
		editor.view?.dispatch?.(closeHistory(editor.state.tr));
	} catch {}
}
function executeMutate(op, rollbacks) {
	const { editor, partId, sectionId } = op;
	const descriptor = getPartDescriptor(partId);
	const partExistedBefore = hasPart(editor, partId);
	if (!partExistedBefore) if (descriptor?.ensurePart) setPart(editor, partId, descriptor.ensurePart(editor, sectionId));
	else throw new Error(`mutatePart: part "${partId}" does not exist in the store.`);
	const existing = getPart(editor, partId);
	const snapshot = clonePart(existing);
	rollbacks.push({
		partId,
		operation: partExistedBefore ? "mutate" : "create",
		snapshot: partExistedBefore ? snapshot : void 0
	});
	const callbackResult = op.mutate({
		part: existing,
		dryRun: op.dryRun ?? false
	});
	if (descriptor?.normalizePart) {
		const normalized = descriptor.normalizePart(existing);
		if (normalized !== void 0 && normalized !== existing) setPart(editor, partId, normalized);
	}
	if (descriptor?.validatePart) {
		const validate = descriptor.validatePart;
		validate(getPart(editor, partId));
	}
	const changedPaths = diffPartPaths(snapshot, getPart(editor, partId));
	return {
		partId,
		operation: "mutate",
		changed: changedPaths.length > 0,
		changedPaths,
		callbackResult
	};
}
function executeCreate(op, rollbacks) {
	const { editor, partId } = op;
	if (hasPart(editor, partId)) throw new Error(`mutatePart: part "${partId}" already exists in the store.`);
	rollbacks.push({
		partId,
		operation: "create",
		snapshot: void 0
	});
	let data = clonePart(op.initial);
	const descriptor = getPartDescriptor(partId);
	if (descriptor?.normalizePart) {
		const normalized = descriptor.normalizePart(data);
		if (normalized !== void 0) data = normalized;
	}
	if (descriptor?.validatePart) {
		const validate = descriptor.validatePart;
		validate(data);
	}
	setPart(editor, partId, data);
	return {
		partId,
		operation: "create",
		changed: true,
		changedPaths: []
	};
}
function executeDelete(op, rollbacks) {
	const { editor, partId, sectionId, source } = op;
	if (!hasPart(editor, partId)) throw new Error(`mutatePart: part "${partId}" does not exist in the store.`);
	const existing = getPart(editor, partId);
	const snapshot = clonePart(existing);
	rollbacks.push({
		partId,
		operation: "delete",
		snapshot
	});
	const descriptor = getPartDescriptor(partId);
	if (descriptor?.onDelete) descriptor.onDelete({
		editor,
		partId,
		sectionId,
		part: existing,
		source
	});
	removePart(editor, partId);
	return {
		partId,
		operation: "delete",
		changed: true,
		changedPaths: []
	};
}
function rollback(editor, entries) {
	for (let i$1 = entries.length - 1; i$1 >= 0; i$1--) {
		const entry = entries[i$1];
		if (entry.operation === "create") {
			if (hasPart(editor, entry.partId)) removePart(editor, entry.partId);
		} else setPart(editor, entry.partId, entry.snapshot);
	}
}
function runPostCommitSideEffects(editor, outcomes, operations, source) {
	const converter = getConverter$9(editor);
	if (converter) {
		converter.documentModified = true;
		if (!converter.documentGuid && typeof converter.promoteToGuid === "function") converter.promoteToGuid();
	}
	incrementRevision(editor);
	let degraded = false;
	for (let i$1 = 0; i$1 < outcomes.length; i$1++) {
		const outcome = outcomes[i$1];
		if (!outcome.changed) continue;
		const descriptor = getPartDescriptor(outcome.partId);
		if (!descriptor?.afterCommit || outcome.operation === "delete") continue;
		try {
			descriptor.afterCommit({
				editor,
				partId: outcome.partId,
				sectionId: operations[i$1].sectionId,
				part: getPart(editor, outcome.partId),
				source
			});
		} catch (err$1) {
			degraded = true;
			markPartCacheStale(editor, outcome.partId);
			console.error(`[parts] afterCommit hook failed for "${outcome.partId}":`, err$1);
		}
	}
	return degraded;
}
function emitPartChanged(editor, outcomes, operations, source, degraded) {
	const changedParts = [];
	for (let i$1 = 0; i$1 < outcomes.length; i$1++) {
		if (!outcomes[i$1].changed) continue;
		changedParts.push({
			partId: outcomes[i$1].partId,
			sectionId: operations[i$1].sectionId,
			operation: outcomes[i$1].operation,
			changedPaths: outcomes[i$1].changedPaths
		});
	}
	const event = {
		parts: changedParts,
		source,
		degraded: degraded || void 0
	};
	if (typeof editor.safeEmit === "function") {
		const errors = editor.safeEmit("partChanged", event);
		for (const err$1 of errors) console.error("[parts] partChanged listener threw:", err$1);
	}
	return event;
}
function mutateParts(request) {
	const { editor, source, operations } = request;
	const dryRun = request.dryRun ?? false;
	const expectedRevision = request.expectedRevision;
	if (operations.length === 0) return {
		changed: false,
		parts: [],
		degraded: false
	};
	if (!dryRun) closeUndoGroup(editor);
	checkRevision(editor, expectedRevision);
	const rollbacks = [];
	const outcomes = [];
	try {
		for (const op of operations) {
			const opWithDefaults = {
				...op,
				dryRun
			};
			let outcome;
			switch (opWithDefaults.operation) {
				case "mutate":
					outcome = executeMutate(opWithDefaults, rollbacks);
					break;
				case "create":
					outcome = executeCreate(opWithDefaults, rollbacks);
					break;
				case "delete":
					outcome = executeDelete(opWithDefaults, rollbacks);
					break;
			}
			outcomes.push(outcome);
		}
	} catch (err$1) {
		rollback(editor, rollbacks);
		throw err$1;
	}
	const anyChanged = outcomes.some((o) => o.changed);
	if (dryRun || !anyChanged) rollback(editor, rollbacks);
	let degraded = false;
	if (!dryRun && anyChanged) {
		try {
			degraded = runPostCommitSideEffects(editor, outcomes, operations, source);
		} catch (err$1) {
			applyPartInvalidation(editor, emitPartChanged(editor, outcomes, operations, source, true));
			throw err$1;
		}
		applyPartInvalidation(editor, emitPartChanged(editor, outcomes, operations, source, degraded));
	}
	return {
		changed: anyChanged,
		degraded,
		parts: outcomes.map((o) => ({
			partId: o.partId,
			operation: o.operation,
			changed: o.changed,
			changedPaths: o.changedPaths
		}))
	};
}
function mutatePart(request) {
	let capturedResult;
	let wrappedOp;
	if (request.operation === "mutate") {
		const mutateReq = request;
		wrappedOp = {
			...mutateReq,
			mutate(ctx) {
				capturedResult = mutateReq.mutate(ctx);
				return capturedResult;
			}
		};
	} else wrappedOp = request;
	const multiResult = mutateParts({
		editor: request.editor,
		source: request.source,
		dryRun: request.dryRun,
		expectedRevision: request.expectedRevision,
		operations: [wrappedOp]
	});
	const partResult = multiResult.parts[0];
	return {
		changed: partResult?.changed ?? false,
		changedPaths: partResult?.changedPaths ?? [],
		degraded: multiResult.degraded,
		result: capturedResult
	};
}
const RELATIONSHIP_TYPES = {
	image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
	hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink"
};
const RELS_XMLNS$2 = "http://schemas.openxmlformats.org/package/2006/relationships";
function getRelationshipsRoot(part) {
	if (!part || typeof part !== "object") return void 0;
	if (part.name === "Relationships") return part;
	const children = part.elements;
	if (!Array.isArray(children)) return void 0;
	return children.find((el) => el?.name === "Relationships");
}
function createRelationshipsPart(elements = []) {
	return {
		type: "element",
		name: "Relationships",
		attributes: { xmlns: RELS_XMLNS$2 },
		elements
	};
}
var RELS_PART_ID = "word/_rels/document.xml.rels";
function getRelationshipsTag(part) {
	const tag = getRelationshipsRoot(part);
	if (tag && !tag.elements) tag.elements = [];
	return tag;
}
function normalizeTarget(target) {
	return target.startsWith("word/") ? target.replace("word/", "") : target;
}
function getMaxIdInt(elements) {
	let max = 0;
	for (const rel of elements) {
		const match = rel.attributes?.Id?.match(/^rId(\d+)$/);
		if (match) {
			const n = Number(match[1]);
			if (n > max) max = n;
		}
	}
	return max;
}
function createRelationshipElement(id, mappedType, target, isExternal) {
	const rel = {
		type: "element",
		name: "Relationship",
		attributes: {
			Id: id,
			Type: mappedType,
			Target: target
		}
	};
	if (isExternal) rel.attributes.TargetMode = "External";
	return rel;
}
function findExistingRelationship(elements, target, normalized, mappedType) {
	return elements.find((rel) => (rel.attributes?.Target === normalized || rel.attributes?.Target === target) && rel.attributes?.Type === mappedType);
}
function findOrCreateRelationship(editor, source, options) {
	const { target, type, partId = RELS_PART_ID, dryRun, expectedRevision } = options;
	if (!target || typeof target !== "string") return null;
	if (!type || typeof type !== "string") return null;
	const mappedType = RELATIONSHIP_TYPES[type];
	if (!mappedType) {
		console.warn(`findOrCreateRelationship: unsupported type "${type}"`);
		return null;
	}
	const normalized = normalizeTarget(target);
	const isExternal = type === "hyperlink";
	if (!hasPart(editor, partId)) {
		const newId = "rId1";
		mutatePart({
			editor,
			partId,
			operation: "create",
			source,
			dryRun,
			expectedRevision,
			initial: createRelationshipsPart([createRelationshipElement(newId, mappedType, isExternal ? target : normalized, isExternal)])
		});
		return newId;
	}
	return mutatePart({
		editor,
		partId,
		operation: "mutate",
		source,
		dryRun,
		expectedRevision,
		mutate({ part }) {
			const tag = getRelationshipsTag(part);
			if (!tag) return null;
			const existing = findExistingRelationship(tag.elements, target, normalized, mappedType);
			if (existing) return existing.attributes.Id;
			const newId = `rId${getMaxIdInt(tag.elements) + 1}`;
			const newRel = createRelationshipElement(newId, mappedType, isExternal ? target : normalized, isExternal);
			tag.elements.push(newRel);
			return newId;
		}
	}).result;
}
function maybeAddProtocol(text$2) {
	return /^www\./i.test(text$2) ? `https://${text$2}` : text$2;
}
function detectPasteUrl(text$2, protocols = []) {
	const trimmed = text$2?.trim();
	if (!trimmed) return null;
	if (/\s/.test(trimmed)) return null;
	const result = sanitizeHref(maybeAddProtocol(trimmed), { allowedProtocols: buildAllowedProtocols(protocols) });
	return result ? { href: result.href } : null;
}
function canAllocateRels(editor) {
	return editor.options.mode === "docx" && !editor.options.isChildEditor && !editor.options.isHeaderOrFooter;
}
function handlePlainTextUrlPaste(editor, view, plainText, detected) {
	const { state } = view;
	const { selection } = state;
	if (!(selection instanceof TextSelection)) return false;
	const linkMarkType = editor.schema.marks.link;
	const underlineMarkType = editor.schema.marks.underline;
	if (!linkMarkType) return false;
	const rId = allocateRelationshipId(editor, detected.href);
	let tr = state.tr;
	let from = selection.from;
	let to = selection.to;
	const trimmedText = plainText.trim();
	if (selection.empty) {
		tr = tr.insertText(trimmedText, from);
		to = from + trimmedText.length;
	}
	tr = tr.addMark(from, to, linkMarkType.create({
		href: detected.href,
		rId
	}));
	if (underlineMarkType) tr = tr.addMark(from, to, underlineMarkType.create({ autoAdded: true }));
	view.dispatch(tr.scrollIntoView());
	return true;
}
function getChangedRangesFromTransaction(tr) {
	const maps = tr.mapping?.maps;
	if (!maps?.length) return [];
	const ranges = [];
	maps.forEach((map) => {
		map.forEach((oldStart, oldEnd, newStart, newEnd) => {
			ranges.push({
				from: newStart,
				to: newEnd
			});
		});
	});
	return mergeRanges(ranges, tr.doc.content.size);
}
function normalizePastedLinks(tr, editor, protocols) {
	const changedRanges = getChangedRangesFromTransaction(tr);
	if (!changedRanges.length) return;
	const linkMarkType = editor.schema.marks.link;
	if (!linkMarkType) return;
	const allowedProtocols = buildAllowedProtocols(protocols ?? resolveLinkProtocols(editor));
	for (const { from, to } of changedRanges) normalizeLinkMarksInRange(tr, editor, linkMarkType, from, to, allowedProtocols);
}
function resolveLinkProtocols(editor) {
	return (editor.extensionService?.extensions?.find((e) => e.name === "link"))?.options?.protocols ?? [];
}
function normalizeLinkMarksInRange(tr, editor, linkMarkType, from, to, allowedProtocols) {
	const linkSpans = [];
	tr.doc.nodesBetween(from, to, (node, pos) => {
		if (!node.isInline) return;
		const linkMark = node.marks.find((m) => m.type === linkMarkType);
		if (!linkMark) return;
		linkSpans.push({
			from: pos,
			to: pos + node.nodeSize,
			mark: linkMark
		});
	});
	for (let i$1 = linkSpans.length - 1; i$1 >= 0; i$1--) normalizeOneLinkMark(tr, editor, linkMarkType, linkSpans[i$1], allowedProtocols);
}
function normalizeOneLinkMark(tr, editor, linkMarkType, span, allowedProtocols) {
	const { from, to, mark } = span;
	const attrs = { ...mark.attrs };
	attrs.rId = null;
	const rawHref = attrs.href;
	const hasInternalRef = Boolean(attrs.anchor) || Boolean(attrs.name);
	if (!rawHref && hasInternalRef) {
		tr.removeMark(from, to, linkMarkType);
		tr.addMark(from, to, linkMarkType.create(attrs));
		return;
	}
	if (!rawHref) {
		tr.removeMark(from, to, linkMarkType);
		return;
	}
	const sanitized = sanitizeHref(maybeAddProtocol(rawHref), { allowedProtocols });
	if (!sanitized) {
		tr.removeMark(from, to, linkMarkType);
		return;
	}
	attrs.href = sanitized.href;
	if (canAllocateRels(editor)) attrs.rId = allocateRelationshipId(editor, sanitized.href);
	tr.removeMark(from, to, linkMarkType);
	tr.addMark(from, to, linkMarkType.create(attrs));
}
function allocateRelationshipId(editor, href) {
	if (!canAllocateRels(editor)) return null;
	return findOrCreateRelationship(editor, "paste-link-normalizer:allocateRelationshipId", {
		target: href,
		type: "hyperlink"
	});
}
function buildAllowedProtocols(extras = []) {
	const normalized = normalizeProtocols(extras);
	return Array.from(new Set([...UrlValidationConstants.DEFAULT_ALLOWED_PROTOCOLS, ...normalized]));
}
function normalizeProtocols(protocols = []) {
	const result = [];
	for (const entry of protocols) {
		if (!entry) continue;
		if (typeof entry === "string" && entry.trim()) result.push(entry.trim().toLowerCase());
		else if (typeof entry === "object" && typeof entry.scheme === "string" && entry.scheme.trim()) result.push(entry.scheme.trim().toLowerCase());
	}
	return result;
}
var handleDecimal = (path, lvlText) => generateNumbering(path, lvlText, numberToStringFormatter);
var handleRoman = (path, lvlText) => generateNumbering(path, lvlText, intToRoman);
var handleLowerRoman = (path, lvlText) => {
	const result = handleRoman(path, lvlText);
	return result ? result.toLowerCase() : null;
};
var handleAlpha = (path, lvlText) => generateNumbering(path, lvlText, intToAlpha);
var handleLowerAlpha = (path, lvlText) => {
	const result = handleAlpha(path, lvlText);
	return result ? result.toLowerCase() : null;
};
var handleOrdinal = (path, lvlText) => generateNumbering(path, lvlText, ordinalFormatter);
var handleOrdinalText = (path, lvlText) => generateNumbering(path, lvlText, ordinalTextFormatter);
var handleCardinalText = (path, lvlText) => generateNumbering(path, lvlText, cardinalTextFormatter);
var handleCustom = (path, lvlText, customFormat) => generateFromCustom(path, lvlText, customFormat);
var handleJapaneseCounting = (path, lvlText) => generateNumbering(path, lvlText, intToJapaneseCounting);
var handleDecimalZero = (path, lvlText) => generateNumbering(path, lvlText, decimalZeroFormatter);
var listIndexMap = {
	decimal: handleDecimal,
	decimalZero: handleDecimalZero,
	lowerRoman: handleLowerRoman,
	upperRoman: handleRoman,
	lowerLetter: handleLowerAlpha,
	upperLetter: handleAlpha,
	ordinal: handleOrdinal,
	ordinalText: handleOrdinalText,
	cardinalText: handleCardinalText,
	custom: handleCustom,
	japaneseCounting: handleJapaneseCounting
};
const generateOrderedListIndex = ({ listLevel, lvlText, listNumberingType, customFormat }) => {
	if (typeof lvlText !== "string") return null;
	const handler$1 = listIndexMap[listNumberingType];
	return handler$1 ? handler$1(listLevel, lvlText, customFormat) : null;
};
var createNumbering = (values, lvlText) => {
	if (typeof lvlText !== "string") return "";
	return values.reduce((acc, value, index) => {
		return Number(value) > 9 ? acc.replace(/^0/, "").replace(`%${index + 1}`, value) : acc.replace(`%${index + 1}`, value);
	}, lvlText);
};
var generateNumbering = (path, lvlText, formatter) => {
	return createNumbering(path.map((entry, idx) => formatter(entry, idx)), lvlText);
};
var ordinalFormatter = (value) => {
	const suffixes = [
		"th",
		"st",
		"nd",
		"rd"
	];
	const lastTwo = value % 100;
	return `${value}${suffixes[(lastTwo - 20) % 10] || suffixes[lastTwo] || suffixes[0]}`;
};
var ONES_ORDINAL = [
	"",
	"First",
	"Second",
	"Third",
	"Fourth",
	"Fifth",
	"Sixth",
	"Seventh",
	"Eighth",
	"Ninth",
	"Tenth",
	"Eleventh",
	"Twelfth",
	"Thirteenth",
	"Fourteenth",
	"Fifteenth",
	"Sixteenth",
	"Seventeenth",
	"Eighteenth",
	"Nineteenth"
];
var TENS_ORDINAL = [
	"",
	"",
	"Twentieth",
	"Thirtieth",
	"Fortieth",
	"Fiftieth",
	"Sixtieth",
	"Seventieth",
	"Eightieth",
	"Ninetieth"
];
var ONES_CARDINAL = [
	"",
	"One",
	"Two",
	"Three",
	"Four",
	"Five",
	"Six",
	"Seven",
	"Eight",
	"Nine",
	"Ten",
	"Eleven",
	"Twelve",
	"Thirteen",
	"Fourteen",
	"Fifteen",
	"Sixteen",
	"Seventeen",
	"Eighteen",
	"Nineteen"
];
var TENS_CARDINAL = [
	"",
	"",
	"Twenty",
	"Thirty",
	"Forty",
	"Fifty",
	"Sixty",
	"Seventy",
	"Eighty",
	"Ninety"
];
var ordinalTextFormatter = (value) => {
	if (!Number.isFinite(value) || value < 1) return "";
	if (value < ONES_ORDINAL.length) return ONES_ORDINAL[value];
	if (value < 100) {
		const t = Math.floor(value / 10);
		const o = value % 10;
		if (o === 0) return TENS_ORDINAL[t];
		return `${TENS_CARDINAL[t]}-${ONES_ORDINAL[o]}`;
	}
	return ordinalFormatter(value);
};
var cardinalTextFormatter = (value) => {
	if (!Number.isFinite(value) || value < 1) return "";
	if (value < ONES_CARDINAL.length) return ONES_CARDINAL[value];
	if (value < 100) {
		const t = Math.floor(value / 10);
		const o = value % 10;
		if (o === 0) return TENS_CARDINAL[t];
		return `${TENS_CARDINAL[t]}-${ONES_CARDINAL[o]}`;
	}
	return String(value);
};
var decimalZeroFormatter = (value, idx) => {
	if (value >= 10 || idx === 0) return String(value);
	return `0${value}`;
};
var generateFromCustom = (path, lvlText, customFormat) => {
	if (typeof customFormat !== "string") return generateNumbering(path, lvlText, numberToStringFormatter);
	if (customFormat.match(/(?:[0]+\d,\s){3}\.{3}/) == null) return generateNumbering(path, lvlText, numberToStringFormatter);
	const match = customFormat.match(/(\d+)/);
	if (!match) throw new Error("Invalid format string: no numeric pattern found");
	const digitCount = match[1].length;
	return generateNumbering(path, lvlText, (p) => String(p).padStart(digitCount, "0"));
};
var numberToStringFormatter = (value) => String(value);
var intToRoman = (num) => {
	const romanNumeralMap = [
		{
			value: 1e3,
			numeral: "M"
		},
		{
			value: 900,
			numeral: "CM"
		},
		{
			value: 500,
			numeral: "D"
		},
		{
			value: 400,
			numeral: "CD"
		},
		{
			value: 100,
			numeral: "C"
		},
		{
			value: 90,
			numeral: "XC"
		},
		{
			value: 50,
			numeral: "L"
		},
		{
			value: 40,
			numeral: "XL"
		},
		{
			value: 10,
			numeral: "X"
		},
		{
			value: 9,
			numeral: "IX"
		},
		{
			value: 5,
			numeral: "V"
		},
		{
			value: 4,
			numeral: "IV"
		},
		{
			value: 1,
			numeral: "I"
		}
	];
	let result = "";
	let remaining = num;
	for (const { value, numeral } of romanNumeralMap) while (remaining >= value) {
		result += numeral;
		remaining -= value;
	}
	return result;
};
var intToAlpha = (num) => {
	if (num < 1) return "";
	const letter = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[(num - 1) % 26];
	const repeats = Math.floor((num - 1) / 26) + 1;
	return letter.repeat(repeats);
};
const intToJapaneseCounting = (num) => {
	const digits = [
		"",
		"一",
		"二",
		"三",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九"
	];
	const units = [
		"",
		"十",
		"百",
		"千"
	];
	if (num === 0) return "零";
	if (num < 10) return digits[num];
	let result = "";
	let tempNum = num;
	let unitIndex = 0;
	while (tempNum > 0) {
		const digit = tempNum % 10;
		if (digit !== 0) result = (digit === 1 && unitIndex > 0 ? "" : digits[digit]) + (unitIndex > 0 ? units[unitIndex] : "") + result;
		else if (result && tempNum > 0) {
			if (!result.startsWith("零") && tempNum % 100 !== 0) result = "零" + result;
		}
		tempNum = Math.floor(tempNum / 10);
		unitIndex += 1;
		if (unitIndex > 3) break;
	}
	if (num >= 10 && num < 20) result = result.replace(/^一十/, "十");
	return result;
};
var normalizeChars = new Set([
	"",
	"",
	"○",
	"o",
	"■",
	"□"
]);
const normalizeLvlTextChar = (lvlText) => {
	if (!lvlText || !normalizeChars.has(lvlText)) return lvlText;
	if (lvlText === "") return "•";
	if (lvlText === "○" || lvlText === "o") return "◦";
	if (lvlText === "■" || lvlText === "") return "▪";
	if (lvlText === "□") return "◯";
	return lvlText;
};
var docxNumberingCacheStore = /* @__PURE__ */ new WeakMap();
const NUMBERING_CACHE_KEY = "numbering-cache";
const LEVELS_MAP_KEY = Symbol("superdoc.numbering.levels");
var NUMBERING_CACHE_DOCX_KEY = Symbol("superdoc.numbering.docx");
var clearConverterCache = (converter) => {
	if (!converter) return;
	delete converter[NUMBERING_CACHE_KEY];
	delete converter[NUMBERING_CACHE_DOCX_KEY];
};
var setConverterCache = (converter, cache, docx) => {
	if (!converter) return;
	converter[NUMBERING_CACHE_KEY] = cache;
	if (docx && typeof docx === "object") converter[NUMBERING_CACHE_DOCX_KEY] = docx;
	else delete converter[NUMBERING_CACHE_DOCX_KEY];
};
var createEmptyCache = () => ({
	numToAbstractId: /* @__PURE__ */ new Map(),
	abstractById: /* @__PURE__ */ new Map(),
	templateById: /* @__PURE__ */ new Map(),
	numToDefinition: /* @__PURE__ */ new Map(),
	numNodesById: /* @__PURE__ */ new Map()
});
var ensureElementsArray = (docx) => {
	let numbering = docx?.["word/numbering.xml"];
	if (!numbering || !numbering.elements?.length || !numbering.elements[0].elements?.length) numbering = baseNumbering;
	return numbering?.elements?.[0]?.elements || [];
};
const buildNumberingCache = (docx) => {
	if (!docx || typeof docx !== "object") return createEmptyCache();
	const elements = ensureElementsArray(docx);
	if (!elements.length) return createEmptyCache();
	const numToAbstractId = /* @__PURE__ */ new Map();
	const abstractById = /* @__PURE__ */ new Map();
	const templateById = /* @__PURE__ */ new Map();
	const numToDefinition = /* @__PURE__ */ new Map();
	const numNodesById = /* @__PURE__ */ new Map();
	for (const element of elements) if (element?.name === "w:abstractNum") {
		const abstractIdRaw = element.attributes?.["w:abstractNumId"];
		if (abstractIdRaw == null) continue;
		const abstractId = String(abstractIdRaw);
		abstractById.set(abstractId, element);
		const levelEntries = element.elements?.filter((child) => child.name === "w:lvl") || [];
		const levelsMap = /* @__PURE__ */ new Map();
		for (const lvl of levelEntries) {
			const rawLevel = lvl?.attributes?.["w:ilvl"];
			const parsedLevel = rawLevel == null ? 0 : Number(rawLevel);
			if (!Number.isNaN(parsedLevel) && !levelsMap.has(parsedLevel)) levelsMap.set(parsedLevel, lvl);
		}
		if (!Object.prototype.hasOwnProperty.call(element, LEVELS_MAP_KEY)) Object.defineProperty(element, LEVELS_MAP_KEY, {
			value: levelsMap,
			enumerable: false,
			configurable: false,
			writable: false
		});
		const templateVal = (element.elements?.find((child) => child.name === "w:tmpl"))?.attributes?.["w:val"];
		if (templateVal != null && levelsMap.size) templateById.set(String(templateVal), element);
	} else if (element?.name === "w:num") {
		const numIdRaw = element.attributes?.["w:numId"];
		if (numIdRaw == null) continue;
		const numId = String(numIdRaw);
		numNodesById.set(numId, element);
		const abstractVal = (element.elements?.find((child) => child.name === "w:abstractNumId"))?.attributes?.["w:val"];
		if (abstractVal != null) numToAbstractId.set(numId, String(abstractVal));
	}
	for (const [numId, abstractId] of numToAbstractId.entries()) {
		const abstract = abstractById.get(abstractId);
		if (abstract) numToDefinition.set(numId, abstract);
	}
	return {
		numToAbstractId,
		abstractById,
		templateById,
		numToDefinition,
		numNodesById
	};
};
const ensureNumberingCache = (docx, converter) => {
	if (converter?.["numbering-cache"]) {
		const cachedDocx = converter[NUMBERING_CACHE_DOCX_KEY];
		if (docx && cachedDocx && cachedDocx !== docx) clearConverterCache(converter);
		else return converter[NUMBERING_CACHE_KEY];
	}
	if (!docx || typeof docx !== "object") return createEmptyCache();
	const existingCache = docxNumberingCacheStore.get(docx);
	if (existingCache) {
		setConverterCache(converter, existingCache, docx);
		return existingCache;
	}
	const cache = buildNumberingCache(docx);
	if (converter) setConverterCache(converter, cache, docx);
	else docxNumberingCacheStore.set(docx, cache);
	return cache;
};
var getNumIdFromTag = (tag) => {
	return tag?.elements?.find((el) => el.name === "w:numId")?.attributes["w:val"];
};
function getStyleTagFromStyleId(styleId, docx) {
	const styles = docx["word/styles.xml"];
	if (!styles) return {};
	return styles.elements.find((el) => el.name === "w:styles").elements.filter((style) => style.name === "w:style").find((tag) => tag.attributes["w:styleId"] === styleId);
}
var getListNumIdFromStyleRef = (styleId, docx) => {
	const styles = docx["word/styles.xml"];
	if (!styles) return null;
	const { elements } = styles;
	const styleTags = elements[0].elements.filter((style$1) => style$1.name === "w:style");
	const style = styleTags.find((tag) => tag.attributes["w:styleId"] === styleId) || {};
	const pPr = style?.elements?.find((style$1) => style$1.name === "w:pPr");
	if (!pPr) return null;
	let numPr = pPr?.elements?.find((style$1) => style$1.name === "w:numPr");
	if (!numPr) return null;
	let numIdTag = numPr?.elements?.find((style$1) => style$1.name === "w:numId") || {};
	let numId = getNumIdFromTag(numPr);
	let ilvlTag = numPr?.elements?.find((style$1) => style$1.name === "w:ilvl");
	let ilvl = ilvlTag?.attributes?.["w:val"];
	const basedOnId = (style?.elements?.find((style$1) => style$1.name === "w:basedOn"))?.attributes?.["w:val"];
	let loopCount = 0;
	while (numPr && !numId && loopCount < 10) {
		numPr = ((styleTags.find((tag) => tag.attributes["w:styleId"] === basedOnId) || {})?.elements?.find((style$1) => style$1.name === "w:pPr"))?.elements?.find((style$1) => style$1.name === "w:numPr");
		numIdTag = numPr?.elements?.find((style$1) => style$1.name === "w:numId") || {};
		numId = numIdTag?.attributes?.["w:val"];
		if (!ilvlTag) {
			ilvlTag = numPr?.elements?.find((style$1) => style$1.name === "w:ilvl");
			ilvl = ilvlTag?.attributes?.["w:val"];
		}
		loopCount++;
	}
	return {
		numId,
		ilvl
	};
};
const getAbstractDefinition = (numId, docx, converter) => {
	if (!docx["word/numbering.xml"]) return {};
	if (numId == null) return void 0;
	const cache = ensureNumberingCache(docx, converter);
	const numKey = String(numId);
	let listDefinitionForThisNumId = cache.numToDefinition.get(numKey);
	if (!listDefinitionForThisNumId) {
		const abstractNumId = cache.numToAbstractId.get(numKey);
		if (abstractNumId) {
			listDefinitionForThisNumId = cache.abstractById.get(abstractNumId);
			if (listDefinitionForThisNumId) cache.numToDefinition.set(numKey, listDefinitionForThisNumId);
		}
	}
	const levelMap = listDefinitionForThisNumId ? listDefinitionForThisNumId[LEVELS_MAP_KEY] : null;
	const hasLevels = levelMap && levelMap.size > 0;
	if (!listDefinitionForThisNumId || !hasLevels) {
		const templateId = (listDefinitionForThisNumId?.elements?.find((el) => el.name === "w:tmpl"))?.attributes?.["w:val"];
		if (templateId) {
			const byTemplate = cache.templateById.get(String(templateId));
			if (byTemplate) listDefinitionForThisNumId = byTemplate;
		}
	}
	return listDefinitionForThisNumId;
};
const generateListPath$1 = (level, numId, styleId, levels, docx) => {
	const iLvl = Number(level);
	const path = [];
	if (iLvl > 0) for (let i$1 = iLvl; i$1 >= 0; i$1--) {
		const { start: lvlStart } = getListLevelDefinitionTag(numId, i$1, styleId, docx);
		if (!levels[i$1]) levels[i$1] = Number(lvlStart) || 1;
		path.unshift(levels[i$1]);
	}
	return path;
};
const getListLevelDefinitionTag = (numId, level, pStyleId, docx) => {
	if (pStyleId) {
		const { numId: numIdFromStyles, ilvl: iLvlFromStyles } = getListNumIdFromStyleRef(pStyleId, docx) || {};
		if (!numId && numIdFromStyles) numId = numIdFromStyles;
		if (!level && iLvlFromStyles) level = iLvlFromStyles ? parseInt(iLvlFromStyles) : null;
	}
	const listDefinitionForThisNumId = getAbstractDefinition(numId, docx);
	const currentLevel = getDefinitionForLevel(listDefinitionForThisNumId, level);
	const numStyleLinkId = (listDefinitionForThisNumId?.elements?.find((style) => style.name === "w:numStyleLink"))?.attributes["w:val"];
	if (numStyleLinkId) return getListLevelDefinitionTag(getListNumIdFromStyleRef(numStyleLinkId, docx).numId, level, null, docx);
	const start = currentLevel?.elements?.find((style) => style.name === "w:start")?.attributes["w:val"];
	let numFmtTag = currentLevel?.elements?.find((style) => style.name === "w:numFmt");
	let numFmt = numFmtTag?.attributes["w:val"];
	if (!numFmt) {
		const choiceNumFmtTag = ((currentLevel?.elements.find((style) => style.name === "mc:AlternateContent"))?.elements.find((style) => style.name === "mc:Choice"))?.elements.find((style) => style.name === "w:numFmt");
		const choiceNumFmt = choiceNumFmtTag?.attributes["w:val"];
		if (choiceNumFmt) {
			numFmtTag = choiceNumFmtTag;
			numFmt = choiceNumFmt;
		}
	}
	let lvlText = currentLevel?.elements?.find((style) => style.name === "w:lvlText").attributes["w:val"];
	lvlText = normalizeLvlTextChar(lvlText);
	let customFormat;
	if (numFmt === "custom") customFormat = numFmtTag?.attributes?.["w:format"];
	const lvlJc = currentLevel?.elements?.find((style) => style.name === "w:lvlJc").attributes["w:val"];
	const pPr = currentLevel?.elements?.find((style) => style.name === "w:pPr");
	const rPr = currentLevel?.elements?.find((style) => style.name === "w:rPr");
	return {
		start,
		numFmt,
		lvlText,
		lvlJc,
		pPr,
		rPr,
		customFormat
	};
};
function getDefinitionForLevel(data, level) {
	if (!data) return void 0;
	const parsedLevel = Number(level);
	if (Number.isNaN(parsedLevel)) return void 0;
	const cachedLevels = data[LEVELS_MAP_KEY];
	if (cachedLevels?.has(parsedLevel)) return cachedLevels.get(parsedLevel);
	return data?.elements?.find((item) => Number(item.attributes?.["w:ilvl"]) === parsedLevel);
}
const docxNumberingHelpers = {
	generateListPath: generateListPath$1,
	normalizeLvlTextChar
};
const translator$118 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:nsid"));
const translator$189 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:tmpl"));
const translator$108 = NodeTranslator.from(createSingleAttrPropertyHandler("w:name"));
const translator$147 = NodeTranslator.from(createSingleAttrPropertyHandler("w:styleLink"));
const translator$117 = NodeTranslator.from(createSingleAttrPropertyHandler("w:numStyleLink"));
const translator$104 = NodeTranslator.from(createSingleAttrPropertyHandler("w:multiLevelType"));
const translator$101 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:lvlRestart"));
const translator$100 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:lvlPicBulletId"));
const translator$87 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:isLgl"));
const translator$152 = NodeTranslator.from(createSingleAttrPropertyHandler("w:suff"));
const translator$103 = NodeTranslator.from(createSingleAttrPropertyHandler("w:lvlText"));
const translator$99 = NodeTranslator.from(createSingleAttrPropertyHandler("w:lvlJc"));
const translator$113 = NodeTranslator.from({
	xmlName: "w:numFmt",
	sdNodeOrKeyName: "numFmt",
	attributes: [createAttributeHandler("w:val"), createAttributeHandler("w:format")],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["numFmt"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
var propertyTranslators$6 = [
	translator$102,
	translator$101,
	translator$100,
	translator$87,
	translator$131,
	translator$152,
	translator$103,
	translator$99,
	translator$113,
	NodeTranslator.from({
		xmlName: "w:legacy",
		sdNodeOrKeyName: "legacy",
		attributes: [
			createBooleanAttributeHandler("w:legacy"),
			createIntegerAttributeHandler("w:legacySpace"),
			createIntegerAttributeHandler("w:legacyIndent")
		],
		encode: (_, encodedAttrs) => {
			return encodedAttrs;
		},
		decode: function({ node }) {
			const decodedAttrs = this.decodeAttributes({ node: {
				...node,
				attrs: node.attrs["legacy"] || {}
			} });
			return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
		}
	}),
	translator$129,
	translator$133
];
var attributeHandlers$3 = [
	createIntegerAttributeHandler("w:ilvl"),
	createIntegerAttributeHandler("w:tplc"),
	createBooleanAttributeHandler("w:tentative")
];
const translator$97 = NodeTranslator.from(createNestedPropertiesTranslator("w:lvl", "lvl", propertyTranslators$6, {}, attributeHandlers$3));
var propertyTranslators$5 = [
	translator$118,
	translator$189,
	translator$108,
	translator$147,
	translator$117,
	translator$104
];
var propertyTranslatorsByXmlName$2 = {};
var propertyTranslatorsBySdName$2 = {};
propertyTranslators$5.forEach((translator$220) => {
	propertyTranslatorsByXmlName$2[translator$220.xmlName] = translator$220;
	propertyTranslatorsBySdName$2[translator$220.sdNodeOrKeyName] = translator$220;
});
const translator$39 = NodeTranslator.from({
	xmlName: "w:abstractNum",
	sdNodeOrKeyName: "abstractNum",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [createIntegerAttributeHandler("w:abstractNumId")],
	encode: (params, encodedAttrs) => {
		const { nodes } = params;
		const node = nodes[0];
		return {
			...encodedAttrs,
			...encodeProperties(params, propertyTranslatorsByXmlName$2),
			...encodePropertiesByKey("w:lvl", "levels", translator$97, params, node, "ilvl")
		};
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["abstractNum"];
		if (!currentValue) return;
		return {
			name: "w:abstractNum",
			type: "element",
			attributes: this.decodeAttributes({ node: {
				...params.node,
				attrs: currentValue
			} }),
			elements: [...decodeProperties(params, propertyTranslatorsBySdName$2, currentValue), ...decodePropertiesByKey("w:lvl", "levels", translator$97, params, currentValue)]
		};
	}
});
const translator$40 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:abstractNumId"));
const translator$144 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:startOverride"));
var propertyTranslators$4 = [translator$144, translator$97];
var attributeHandlers$2 = [createIntegerAttributeHandler("w:ilvl")];
const translator$98 = NodeTranslator.from(createNestedPropertiesTranslator("w:lvlOverride", "lvlOverride", propertyTranslators$4, {}, attributeHandlers$2));
const translator$112 = NodeTranslator.from({
	xmlName: "w:num",
	sdNodeOrKeyName: "num",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [createIntegerAttributeHandler("w:numId")],
	encode: (params, encodedAttrs) => {
		const { nodes } = params;
		const node = nodes[0];
		return {
			...encodedAttrs,
			...encodeProperties(params, { "w:abstractNumId": translator$40 }),
			...encodePropertiesByKey("w:lvlOverride", "lvlOverrides", translator$98, params, node, "ilvl")
		};
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["num"];
		if (!currentValue) return;
		return {
			name: "w:num",
			type: "element",
			attributes: this.decodeAttributes({ node: {
				...params.node,
				attrs: currentValue
			} }),
			elements: [...decodeProperties(params, { abstractNumId: translator$40 }, currentValue), ...decodePropertiesByKey("w:lvlOverride", "lvlOverrides", translator$98, params, currentValue)]
		};
	}
});
const baseOrderedListDef = {
	type: "element",
	name: "w:abstractNum",
	attributes: {
		"w:abstractNumId": "1",
		"w15:restartNumberingAfterBreak": "0"
	},
	elements: [
		{
			type: "element",
			name: "w:multiLevelType",
			attributes: { "w:val": "hybridMultilevel" }
		},
		{
			type: "element",
			name: "w:tmpl",
			attributes: { "w:val": "EE6417C4" }
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "0",
				"w:tplc": "0409000F"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "decimal" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%1." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "720",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "1",
				"w:tplc": "04090019",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerLetter" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%2." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "1440",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "2",
				"w:tplc": "0409001B",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerRoman" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%3." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "right" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "2160",
							"w:hanging": "180"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "3",
				"w:tplc": "0409000F",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "decimal" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%4." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "2880",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "4",
				"w:tplc": "04090019",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerLetter" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%5." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "3600",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "5",
				"w:tplc": "0409001B",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerRoman" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%6." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "right" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "4320",
							"w:hanging": "180"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "6",
				"w:tplc": "0409000F",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "decimal" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%7." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "5040",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "7",
				"w:tplc": "04090019",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerLetter" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%8." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "5760",
							"w:hanging": "360"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "8",
				"w:tplc": "0409001B",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "lowerRoman" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "%9." }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "right" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "6480",
							"w:hanging": "180"
						}
					}]
				}
			]
		}
	]
};
const baseBulletList = {
	type: "element",
	name: "w:abstractNum",
	attributes: {
		"w:abstractNumId": "0",
		"w15:restartNumberingAfterBreak": "0"
	},
	elements: [
		{
			type: "element",
			name: "w:nsid",
			attributes: { "w:val": "16126B07" }
		},
		{
			type: "element",
			name: "w:multiLevelType",
			attributes: { "w:val": "hybridMultilevel" }
		},
		{
			type: "element",
			name: "w:tmpl",
			attributes: { "w:val": "51EC4E08" }
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "0",
				"w:tplc": "04090001"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "•" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "720",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Symbol",
							"w:hAnsi": "Symbol",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "1",
				"w:tplc": "04090003",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "◦" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "1440",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Courier New",
							"w:hAnsi": "Courier New",
							"w:cs": "Courier New",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "2",
				"w:tplc": "04090005",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "▪" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "2160",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Wingdings",
							"w:hAnsi": "Wingdings",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "3",
				"w:tplc": "04090001",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "•" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "2880",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Symbol",
							"w:hAnsi": "Symbol",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "4",
				"w:tplc": "04090003",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "◦" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "3600",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Courier New",
							"w:hAnsi": "Courier New",
							"w:cs": "Courier New",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "5",
				"w:tplc": "04090005",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "▪" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "4320",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Wingdings",
							"w:hAnsi": "Wingdings",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "6",
				"w:tplc": "04090001",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "5040",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Symbol",
							"w:hAnsi": "Symbol",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "7",
				"w:tplc": "04090003",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "o" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "5760",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Courier New",
							"w:hAnsi": "Courier New",
							"w:cs": "Courier New",
							"w:hint": "default"
						}
					}]
				}
			]
		},
		{
			type: "element",
			name: "w:lvl",
			attributes: {
				"w:ilvl": "8",
				"w:tplc": "04090005",
				"w:tentative": "1"
			},
			elements: [
				{
					type: "element",
					name: "w:start",
					attributes: { "w:val": "1" }
				},
				{
					type: "element",
					name: "w:numFmt",
					attributes: { "w:val": "bullet" }
				},
				{
					type: "element",
					name: "w:lvlText",
					attributes: { "w:val": "" }
				},
				{
					type: "element",
					name: "w:lvlJc",
					attributes: { "w:val": "left" }
				},
				{
					type: "element",
					name: "w:pPr",
					elements: [{
						type: "element",
						name: "w:ind",
						attributes: {
							"w:left": "6480",
							"w:hanging": "360"
						}
					}]
				},
				{
					type: "element",
					name: "w:rPr",
					elements: [{
						type: "element",
						name: "w:rFonts",
						attributes: {
							"w:ascii": "Wingdings",
							"w:hAnsi": "Wingdings",
							"w:hint": "default"
						}
					}]
				}
			]
		}
	]
};
const isList = (node) => !!node && node.type?.name === "paragraph" && getResolvedParagraphProperties(node)?.numberingProperties && node.attrs?.listRendering;
const changeListLevel = (delta, editor, tr) => {
	const { state } = editor;
	const { selection, doc: stateDoc } = state;
	const listItemsInSelection = [];
	const seenPositions = /* @__PURE__ */ new Set();
	const doc$2 = stateDoc ?? selection?.$from?.node?.(0);
	const collectListItem = (node, pos) => {
		if (isList(node) && !seenPositions.has(pos)) {
			listItemsInSelection.push({
				node,
				pos
			});
			seenPositions.add(pos);
		}
	};
	const addEdgeNode = ($pos) => {
		if (!$pos) return;
		const parentNode$1 = $pos.parent;
		if (parentNode$1.type.name !== "paragraph") return;
		const pos = typeof $pos.before === "function" ? $pos.before() : null;
		if (!parentNode$1 || pos == null) return;
		collectListItem(parentNode$1, pos);
	};
	const ranges = selection?.ranges?.length && Array.isArray(selection.ranges) ? selection.ranges : selection?.$from && selection?.$to ? [{
		$from: selection.$from,
		$to: selection.$to
	}] : [];
	for (const range of ranges) {
		if (!range?.$from || !range?.$to) continue;
		if (doc$2?.nodesBetween) doc$2.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => collectListItem(node, pos));
		addEdgeNode(range.$from);
		addEdgeNode(range.$to);
	}
	if (!listItemsInSelection.length && selection) {
		const currentItem = findParentNode(isList)(selection);
		if (!currentItem) return false;
		listItemsInSelection.push({
			node: currentItem.node,
			pos: currentItem.pos
		});
	}
	const targets = [];
	let encounteredNegativeLevel = false;
	for (const item of listItemsInSelection) {
		const numberingProperties = getResolvedParagraphProperties(item.node)?.numberingProperties;
		if (!numberingProperties) continue;
		const currentLevel = Number.parseInt(numberingProperties.ilvl ?? 0, 10);
		const newLevel = (Number.isNaN(currentLevel) ? 0 : currentLevel) + delta;
		if (newLevel < 0) {
			encounteredNegativeLevel = true;
			continue;
		}
		if (!ListHelpers.hasListDefinition(editor, numberingProperties.numId, newLevel)) return false;
		targets.push({
			node: item.node,
			pos: item.pos,
			numberingProperties: {
				...numberingProperties,
				ilvl: newLevel
			}
		});
	}
	if (!targets.length) return encounteredNegativeLevel ? true : false;
	targets.sort((a, b) => a.pos - b.pos).forEach(({ numberingProperties, node, pos }) => {
		updateNumberingProperties(numberingProperties, node, pos, editor, tr);
	});
	return true;
};
function updateNumberingProperties(newNumberingProperties, paragraphNode, pos, editor, tr) {
	const newProperties = {
		...paragraphNode.attrs.paragraphProperties || {},
		numberingProperties: newNumberingProperties ? { ...newNumberingProperties } : null
	};
	if (!newNumberingProperties && paragraphNode.attrs.paragraphProperties?.styleId === "ListParagraph") newProperties.styleId = null;
	if (newProperties.indent) delete newProperties.indent;
	const newAttrs = {
		...paragraphNode.attrs,
		paragraphProperties: newProperties,
		numberingProperties: newProperties.numberingProperties
	};
	if (!newNumberingProperties) newAttrs.listRendering = null;
	tr.setNodeMarkup(pos, null, newAttrs);
}
var BULLET_STYLE_CHARS = {
	disc: "•",
	circle: "◦",
	square: "▪"
};
var ORDERED_LIST_STYLES = {
	decimal: {
		fmt: "decimal",
		text: "%1."
	},
	"decimal-paren": {
		fmt: "decimal",
		text: "%1)"
	},
	"upper-roman": {
		fmt: "upperRoman",
		text: "%1."
	},
	"lower-roman": {
		fmt: "lowerRoman",
		text: "%1."
	},
	"upper-alpha": {
		fmt: "upperLetter",
		text: "%1."
	},
	"upper-alpha-paren": {
		fmt: "upperLetter",
		text: "%1)"
	},
	"lower-alpha": {
		fmt: "lowerLetter",
		text: "%1."
	},
	"lower-alpha-paren": {
		fmt: "lowerLetter",
		text: "%1)"
	}
};
var DEFAULT_LVL_JC_BY_FMT = {
	decimal: "left",
	upperRoman: "right",
	lowerRoman: "right",
	upperLetter: "left",
	lowerLetter: "left"
};
var DEFAULT_HANGING_BY_FMT = {
	decimal: 360,
	upperRoman: 180,
	lowerRoman: 180,
	upperLetter: 360,
	lowerLetter: 360
};
function getNextId(group) {
	const intKeys = Object.keys(group).map((k) => Number(k)).filter((n) => Number.isInteger(n));
	return intKeys.length ? Math.max(...intKeys) + 1 : 1;
}
function buildNumDef(numId, abstractId) {
	return {
		type: "element",
		name: "w:num",
		attributes: { "w:numId": String(numId) },
		elements: [{
			name: "w:abstractNumId",
			attributes: { "w:val": String(abstractId) }
		}]
	};
}
function generateAbstractIdentityHex() {
	let hex = "";
	for (let i$1 = 0; i$1 < 8; i$1 += 1) hex += Math.floor(Math.random() * 16).toString(16);
	return hex.toUpperCase();
}
function refreshAbstractIdentity(abstractDef) {
	if (!abstractDef?.elements?.length) return;
	for (const el of abstractDef.elements) if (el?.name === "w:nsid" && el.attributes) el.attributes["w:val"] = generateAbstractIdentityHex();
	else if (el?.name === "w:tmpl" && el.attributes) el.attributes["w:val"] = generateAbstractIdentityHex();
}
function generateNewListDefinition(numbering, options) {
	let { listType } = options;
	const { numId, level, start, text: text$2, fmt, markerFontFamily, bulletStyle, bulletStyleLevel, orderedStyle, orderedStyleLevel } = options;
	if (typeof listType !== "string") listType = listType.name;
	const definition$1 = listType === "orderedList" ? baseOrderedListDef : baseBulletList;
	let skipAddingNewAbstract = false;
	let newAbstractId = getNextId(numbering.abstracts);
	let newAbstractDef = JSON.parse(JSON.stringify({
		...definition$1,
		attributes: {
			...definition$1.attributes,
			"w:abstractNumId": String(newAbstractId)
		}
	}));
	refreshAbstractIdentity(newAbstractDef);
	if (bulletStyle && listType !== "orderedList") {
		const char = BULLET_STYLE_CHARS[bulletStyle];
		const targetLevel = String(Math.max(0, Number.isFinite(bulletStyleLevel) ? bulletStyleLevel : 0));
		if (char) {
			const lvl = newAbstractDef.elements.find((el) => el.name === "w:lvl" && el.attributes["w:ilvl"] === targetLevel);
			if (lvl) {
				const lvlText = lvl.elements.find((el) => el.name === "w:lvlText");
				if (lvlText) lvlText.attributes["w:val"] = char;
				const rPr = lvl.elements.find((el) => el.name === "w:rPr");
				if (rPr) rPr.elements = rPr.elements.filter((el) => el.name !== "w:rFonts");
			}
		}
	}
	if (orderedStyle && listType === "orderedList") {
		const styleConfig = ORDERED_LIST_STYLES[orderedStyle];
		if (styleConfig) {
			const targetLevel = Math.max(0, Number.isFinite(orderedStyleLevel) ? orderedStyleLevel : 0);
			const targetLevelStr = String(targetLevel);
			const lvl = newAbstractDef.elements.find((el) => el.name === "w:lvl" && el.attributes["w:ilvl"] === targetLevelStr);
			if (lvl) {
				const numFmt = lvl.elements.find((el) => el.name === "w:numFmt");
				if (numFmt) numFmt.attributes["w:val"] = styleConfig.fmt;
				const lvlText = lvl.elements.find((el) => el.name === "w:lvlText");
				if (lvlText) lvlText.attributes["w:val"] = `%${targetLevel + 1}${styleConfig.text.replace(/^%\d+/, "")}`;
				const defaultLvlJc = DEFAULT_LVL_JC_BY_FMT[styleConfig.fmt];
				if (defaultLvlJc) {
					const lvlJc = lvl.elements.find((el) => el.name === "w:lvlJc");
					if (lvlJc) lvlJc.attributes["w:val"] = defaultLvlJc;
					else lvl.elements.push({
						type: "element",
						name: "w:lvlJc",
						attributes: { "w:val": defaultLvlJc }
					});
				}
				const defaultHanging = DEFAULT_HANGING_BY_FMT[styleConfig.fmt];
				if (defaultHanging != null) {
					let pPr = lvl.elements.find((el) => el.name === "w:pPr");
					if (!pPr) {
						pPr = {
							type: "element",
							name: "w:pPr",
							elements: []
						};
						lvl.elements.push(pPr);
					}
					if (!pPr.elements) pPr.elements = [];
					let ind = pPr.elements.find((el) => el.name === "w:ind");
					if (!ind) {
						ind = {
							type: "element",
							name: "w:ind",
							attributes: { "w:hanging": String(defaultHanging) }
						};
						pPr.elements.push(ind);
					} else ind.attributes = {
						...ind.attributes || {},
						"w:hanging": String(defaultHanging)
					};
				}
			}
		}
	}
	if (level != null && start != null && text$2 != null && fmt != null) {
		if (numbering.definitions[numId]) {
			const abstractId = numbering.definitions[numId]?.elements?.[0]?.attributes?.["w:val"];
			newAbstractId = abstractId;
			newAbstractDef = { ...numbering.abstracts[abstractId] };
			skipAddingNewAbstract = true;
		}
		const levelDefIndex = newAbstractDef.elements.findIndex((el) => el.name === "w:lvl" && el.attributes["w:ilvl"] === level);
		const levelProps = newAbstractDef.elements[levelDefIndex];
		const elToFilter = [
			"w:numFmt",
			"w:lvlText",
			"w:start"
		];
		levelProps.elements = [
			...levelProps.elements.filter((el) => !elToFilter.includes(el.name)),
			{
				type: "element",
				name: "w:start",
				attributes: { "w:val": start }
			},
			{
				type: "element",
				name: "w:numFmt",
				attributes: { "w:val": fmt }
			},
			{
				type: "element",
				name: "w:lvlText",
				attributes: { "w:val": text$2 }
			}
		];
		if (markerFontFamily) {
			const rPrIndex = levelProps.elements.findIndex((el) => el.name === "w:rPr");
			let rPr = levelProps.elements[rPrIndex];
			if (!rPr) {
				rPr = {
					type: "element",
					name: "w:rPr",
					elements: []
				};
				levelProps.elements.push(rPr);
			}
			rPr.elements = rPr.elements.filter((el) => el.name !== "w:rFonts");
			rPr.elements.push({
				type: "element",
				name: "w:rFonts",
				attributes: {
					"w:ascii": markerFontFamily,
					"w:hAnsi": markerFontFamily,
					"w:eastAsia": markerFontFamily,
					"w:cs": markerFontFamily
				}
			});
		}
	}
	if (!skipAddingNewAbstract) numbering.abstracts[newAbstractId] = newAbstractDef;
	const newNumDef = buildNumDef(numId, newAbstractId);
	numbering.definitions[numId] = newNumDef;
	return {
		numId,
		abstractId: newAbstractId,
		abstractDef: newAbstractDef,
		numDef: newNumDef
	};
}
function changeNumIdSameAbstract(numbering, numId, level, listType) {
	const newId = getNextId(numbering.definitions);
	const abstractId = numbering.definitions[numId]?.elements?.find((el) => el.name === "w:abstractNumId")?.attributes?.["w:val"];
	const abstract = abstractId != null ? numbering.abstracts[abstractId] : void 0;
	if (!abstract) {
		generateNewListDefinition(numbering, {
			numId: newId,
			listType
		});
		return {
			newNumId: newId,
			generated: true
		};
	}
	const newAbstractId = getNextId(numbering.abstracts);
	const newAbstractDef = JSON.parse(JSON.stringify({
		...abstract,
		attributes: {
			...abstract.attributes || {},
			"w:abstractNumId": String(newAbstractId)
		}
	}));
	refreshAbstractIdentity(newAbstractDef);
	numbering.abstracts[newAbstractId] = newAbstractDef;
	const newNumDef = buildNumDef(newId, newAbstractId);
	numbering.definitions[newId] = newNumDef;
	return {
		newNumId: newId,
		generated: false
	};
}
function removeListDefinitions(numbering, listId) {
	const def = numbering.definitions[listId];
	if (!def) return;
	const abstractId = def.elements?.[0]?.attributes?.["w:val"];
	delete numbering.definitions[listId];
	if (abstractId != null) delete numbering.abstracts[abstractId];
}
function setLvlOverride(numbering, numId, ilvl, overrides) {
	const numDef = numbering.definitions[numId];
	if (!numDef) return false;
	const ilvlStr = String(ilvl);
	if (!numDef.elements) numDef.elements = [];
	let overrideEl = numDef.elements.find((el) => el.name === "w:lvlOverride" && el.attributes?.["w:ilvl"] === ilvlStr);
	if (!overrideEl) {
		overrideEl = {
			type: "element",
			name: "w:lvlOverride",
			attributes: { "w:ilvl": ilvlStr },
			elements: []
		};
		numDef.elements.push(overrideEl);
	}
	if (!overrideEl.elements) overrideEl.elements = [];
	if (overrides.startOverride != null) {
		const startEl = overrideEl.elements.find((el) => el.name === "w:startOverride");
		if (startEl) startEl.attributes["w:val"] = String(overrides.startOverride);
		else overrideEl.elements.push({
			type: "element",
			name: "w:startOverride",
			attributes: { "w:val": String(overrides.startOverride) }
		});
	}
	if ("lvlRestart" in overrides) {
		let lvlEl = overrideEl.elements.find((el) => el.name === "w:lvl");
		if (!lvlEl) {
			lvlEl = {
				type: "element",
				name: "w:lvl",
				attributes: { "w:ilvl": ilvlStr },
				elements: []
			};
			overrideEl.elements.push(lvlEl);
		}
		if (!lvlEl.elements) lvlEl.elements = [];
		if (overrides.lvlRestart === null) lvlEl.elements = lvlEl.elements.filter((el) => el.name !== "w:lvlRestart");
		else {
			const restartEl = lvlEl.elements.find((el) => el.name === "w:lvlRestart");
			if (restartEl) restartEl.attributes["w:val"] = String(overrides.lvlRestart);
			else lvlEl.elements.push({
				type: "element",
				name: "w:lvlRestart",
				attributes: { "w:val": String(overrides.lvlRestart) }
			});
		}
	}
	return true;
}
function removeLvlOverride(numbering, numId, ilvl) {
	const numDef = numbering.definitions[numId];
	if (!numDef?.elements) return false;
	const ilvlStr = String(ilvl);
	const idx = numDef.elements.findIndex((el) => el.name === "w:lvlOverride" && el.attributes?.["w:ilvl"] === ilvlStr);
	if (idx === -1) return false;
	numDef.elements.splice(idx, 1);
	return true;
}
function createNumDefinition(numbering, abstractNumId, options = {}) {
	const numId = getNextId(numbering.definitions);
	const numDef = buildNumDef(numId, abstractNumId);
	if (options.copyOverridesFrom != null) {
		const sourceNumDef = numbering.definitions[options.copyOverridesFrom];
		if (sourceNumDef?.elements) {
			const overrideEls = sourceNumDef.elements.filter((el) => el.name === "w:lvlOverride");
			if (overrideEls.length > 0) numDef.elements = [...numDef.elements, ...JSON.parse(JSON.stringify(overrideEls))];
		}
	}
	numbering.definitions[numId] = numDef;
	return {
		numId,
		numDef
	};
}
function setLvlRestartOnAbstract(numbering, abstractNumId, ilvl, restartAfterLevel) {
	const abstract = numbering.abstracts[abstractNumId];
	if (!abstract?.elements) return false;
	const ilvlStr = String(ilvl);
	const lvlEl = abstract.elements.find((el) => el.name === "w:lvl" && el.attributes?.["w:ilvl"] === ilvlStr);
	if (!lvlEl) return false;
	if (!lvlEl.elements) lvlEl.elements = [];
	if (restartAfterLevel === null) {
		const before = lvlEl.elements.length;
		lvlEl.elements = lvlEl.elements.filter((el) => el.name !== "w:lvlRestart");
		return lvlEl.elements.length !== before;
	}
	const restartEl = lvlEl.elements.find((el) => el.name === "w:lvlRestart");
	if (restartEl) {
		if (restartEl.attributes["w:val"] === String(restartAfterLevel)) return false;
		restartEl.attributes["w:val"] = String(restartAfterLevel);
	} else lvlEl.elements.push({
		type: "element",
		name: "w:lvlRestart",
		attributes: { "w:val": String(restartAfterLevel) }
	});
	return true;
}
function setLvlStyleOnAbstract(numbering, abstractNumId, ilvl, options) {
	const abstract = numbering.abstracts[abstractNumId];
	if (!abstract?.elements) return false;
	const ilvlStr = String(ilvl);
	const lvlEl = abstract.elements.find((el) => el.name === "w:lvl" && el.attributes?.["w:ilvl"] === ilvlStr);
	if (!lvlEl) return false;
	if (!lvlEl.elements) lvlEl.elements = [];
	const setOrAddChild = (name, value) => {
		const existing = lvlEl.elements.find((el) => el.name === name);
		if (existing) {
			if (existing.attributes?.["w:val"] === value) return false;
			existing.attributes = {
				...existing.attributes || {},
				"w:val": value
			};
			return true;
		}
		lvlEl.elements.push({
			type: "element",
			name,
			attributes: { "w:val": value }
		});
		return true;
	};
	const stripMarkerFont = () => {
		const rPr = lvlEl.elements.find((el) => el.name === "w:rPr");
		if (!rPr?.elements?.some((el) => el.name === "w:rFonts")) return false;
		rPr.elements = rPr.elements.filter((el) => el.name !== "w:rFonts");
		return true;
	};
	let numFmtValue = null;
	let lvlTextValue = null;
	let lvlJcValue = null;
	let hangingValue = null;
	if (options.bulletStyle) {
		const char = BULLET_STYLE_CHARS[options.bulletStyle];
		if (!char) return false;
		numFmtValue = "bullet";
		lvlTextValue = char;
	} else if (options.orderedStyle) {
		const config$43 = ORDERED_LIST_STYLES[options.orderedStyle];
		if (!config$43) return false;
		numFmtValue = config$43.fmt;
		lvlTextValue = `%${ilvl + 1}${config$43.text.replace(/^%\d+/, "")}`;
		lvlJcValue = DEFAULT_LVL_JC_BY_FMT[config$43.fmt] ?? null;
		hangingValue = DEFAULT_HANGING_BY_FMT[config$43.fmt] ?? null;
	} else return false;
	const setHangingOnLevel = (hanging) => {
		let pPr = lvlEl.elements.find((el) => el.name === "w:pPr");
		if (!pPr) {
			pPr = {
				type: "element",
				name: "w:pPr",
				elements: []
			};
			lvlEl.elements.push(pPr);
		}
		if (!pPr.elements) pPr.elements = [];
		let ind = pPr.elements.find((el) => el.name === "w:ind");
		if (!ind) {
			ind = {
				type: "element",
				name: "w:ind",
				attributes: { "w:hanging": String(hanging) }
			};
			pPr.elements.push(ind);
			return true;
		}
		if (ind.attributes?.["w:hanging"] === String(hanging)) return false;
		ind.attributes = {
			...ind.attributes || {},
			"w:hanging": String(hanging)
		};
		return true;
	};
	let changed = false;
	if (setOrAddChild("w:numFmt", numFmtValue)) changed = true;
	if (setOrAddChild("w:lvlText", lvlTextValue)) changed = true;
	if (lvlJcValue != null && setOrAddChild("w:lvlJc", lvlJcValue)) changed = true;
	if (hangingValue != null && setHangingOnLevel(hangingValue)) changed = true;
	if (stripMarkerFont()) changed = true;
	return changed;
}
function cloneListDefinitionWithLevelStyle(numbering, sourceNumId, ilvl, options) {
	const sourceAbstractIdRaw = numbering.definitions[sourceNumId]?.elements?.find((el) => el.name === "w:abstractNumId")?.attributes?.["w:val"];
	const sourceAbstractId = sourceAbstractIdRaw != null ? Number(sourceAbstractIdRaw) : NaN;
	const sourceAbstract = Number.isFinite(sourceAbstractId) ? numbering.abstracts[sourceAbstractId] : void 0;
	if (!sourceAbstract) return null;
	const newAbstractId = getNextId(numbering.abstracts);
	const newAbstractDef = JSON.parse(JSON.stringify(sourceAbstract));
	newAbstractDef.attributes = {
		...newAbstractDef.attributes || {},
		"w:abstractNumId": String(newAbstractId)
	};
	refreshAbstractIdentity(newAbstractDef);
	numbering.abstracts[newAbstractId] = newAbstractDef;
	setLvlStyleOnAbstract(numbering, newAbstractId, ilvl, options);
	const newNumId = getNextId(numbering.definitions);
	numbering.definitions[newNumId] = buildNumDef(newNumId, newAbstractId);
	return {
		newNumId,
		newAbstractId
	};
}
var NUMBERING_PART_ID = "word/numbering.xml";
var NUMBERING_ROOT_ATTRS = {
	"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
	"xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
	"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
	"mc:Ignorable": "w15"
};
function getConverter$8(editor) {
	return editor.converter;
}
function syncNumberingToXmlTree(part, numbering) {
	const numberingEl = part?.elements?.[0];
	if (!numberingEl) return;
	const abstracts = Object.values(numbering.abstracts);
	const definitions = Object.values(numbering.definitions);
	const modelEntries = new Set([...abstracts, ...definitions]);
	numberingEl.elements = [
		...(numberingEl.elements ?? []).filter((el) => !modelEntries.has(el) && el.name !== "w:abstractNum" && el.name !== "w:num"),
		...abstracts,
		...definitions
	];
}
function rebuildTranslatedNumbering(numbering) {
	const translated = {
		abstracts: {},
		definitions: {}
	};
	for (const [id, abstract] of Object.entries(numbering.abstracts)) translated.abstracts[Number(id)] = translator$39.encode({ nodes: [abstract] });
	for (const [id, definition$1] of Object.entries(numbering.definitions)) translated.definitions[Number(id)] = translator$112.encode({ nodes: [definition$1] });
	return translated;
}
function rebuildNumberingIndexFromPart(converter, part) {
	const numberingEl = part?.elements?.[0];
	if (!numberingEl?.elements) return;
	const abstracts = {};
	const definitions = {};
	for (const el of numberingEl.elements) if (el.name === "w:abstractNum") {
		const id = Number(el.attributes?.["w:abstractNumId"] ?? -1);
		if (id >= 0) abstracts[id] = el;
	} else if (el.name === "w:num") {
		const id = Number(el.attributes?.["w:numId"] ?? -1);
		if (id >= 0) definitions[id] = el;
	}
	converter.numbering = {
		abstracts,
		definitions
	};
}
const numberingPartDescriptor = {
	id: NUMBERING_PART_ID,
	ensurePart() {
		return {
			declaration: { attributes: {
				version: "1.0",
				encoding: "UTF-8",
				standalone: "yes"
			} },
			elements: [{
				type: "element",
				name: "w:numbering",
				attributes: { ...NUMBERING_ROOT_ATTRS },
				elements: []
			}]
		};
	},
	normalizePart(part) {
		const numberingEl = part?.elements?.[0];
		if (!numberingEl?.elements) return;
		const abstracts = [];
		const definitions = [];
		const other = [];
		for (const el of numberingEl.elements) if (el.name === "w:abstractNum") abstracts.push(el);
		else if (el.name === "w:num") definitions.push(el);
		else other.push(el);
		abstracts.sort((a, b) => {
			return Number(a.attributes?.["w:abstractNumId"] ?? 0) - Number(b.attributes?.["w:abstractNumId"] ?? 0);
		});
		definitions.sort((a, b) => {
			return Number(a.attributes?.["w:numId"] ?? 0) - Number(b.attributes?.["w:numId"] ?? 0);
		});
		numberingEl.elements = [
			...other,
			...abstracts,
			...definitions
		];
	},
	afterCommit({ editor, part, source }) {
		const converter = getConverter$8(editor);
		if (!converter) return;
		if (source.startsWith("collab:remote:") || source === "templates.apply") rebuildNumberingIndexFromPart(converter, part);
		converter.translatedNumbering = rebuildTranslatedNumbering(converter.numbering);
		clearPartCacheStale(editor, NUMBERING_PART_ID);
		editor.emit("list-definitions-change", {
			editor,
			numbering: converter.numbering
		});
	}
};
function ensureTranslatedNumberingFresh(editor) {
	if (!isPartCacheStale(editor, NUMBERING_PART_ID)) return;
	const converter = getConverter$8(editor);
	if (!converter) return;
	try {
		converter.translatedNumbering = rebuildTranslatedNumbering(converter.numbering);
		clearPartCacheStale(editor, NUMBERING_PART_ID);
		editor.emit("list-definitions-change", {
			editor,
			numbering: converter.numbering
		});
	} catch {}
}
function getNumbering(editor) {
	const converter = editor.converter;
	if (!converter?.numbering) throw new Error("mutateNumbering: editor.converter.numbering is not available.");
	ensureTranslatedNumberingFresh(editor);
	return converter.numbering;
}
function mutateNumbering(editor, source, transform, options) {
	return mutatePart({
		editor,
		partId: "word/numbering.xml",
		operation: "mutate",
		source,
		dryRun: options?.dryRun,
		expectedRevision: options?.expectedRevision,
		mutate({ part }) {
			const numbering = getNumbering(editor);
			const result = transform(numbering);
			syncNumberingToXmlTree(part, numbering);
			return result;
		}
	});
}
function mutateNumberingBatch(editor, source, transforms, options) {
	return mutateParts({
		editor,
		source,
		dryRun: options?.dryRun,
		expectedRevision: options?.expectedRevision,
		operations: [{
			editor,
			partId: "word/numbering.xml",
			operation: "mutate",
			source,
			mutate({ part }) {
				const numbering = getNumbering(editor);
				for (const transform of transforms) transform(numbering);
				syncNumberingToXmlTree(part, numbering);
			}
		}]
	});
}
function markerTextToBulletStyle(markerText) {
	return {
		"•": "disc",
		"◦": "circle",
		"▪": "square"
	}[markerText] ?? null;
}
function numberingInfoToOrderedStyle(numFmt, markerText) {
	const suffix = markerText?.slice(-1);
	return {
		decimal: {
			".": "decimal",
			")": "decimal-paren"
		},
		upperRoman: { ".": "upper-roman" },
		lowerRoman: { ".": "lower-roman" },
		upperLetter: {
			".": "upper-alpha",
			")": "upper-alpha-paren"
		},
		lowerLetter: {
			".": "lower-alpha",
			")": "lower-alpha-paren"
		}
	}[numFmt]?.[suffix] ?? null;
}
const generateNewListDefinition$1 = ({ numId, listType, level, start, text: text$2, fmt, editor, markerFontFamily, bulletStyle, bulletStyleLevel, orderedStyle, orderedStyleLevel }) => {
	let resultDefs;
	mutateNumbering(editor, "list-numbering-helpers:generateNewListDefinition", (numbering) => {
		const result = generateNewListDefinition(numbering, {
			numId,
			listType: typeof listType === "string" ? listType : listType.name,
			level,
			start,
			text: text$2,
			fmt,
			markerFontFamily,
			bulletStyle,
			bulletStyleLevel,
			orderedStyle,
			orderedStyleLevel
		});
		resultDefs = {
			abstractDef: result.abstractDef,
			numDef: result.numDef
		};
	});
	if (!resultDefs) throw new Error("generateNewListDefinition: failed to allocate list definition.");
	return {
		abstract: resultDefs.abstractDef,
		definition: resultDefs.numDef
	};
};
const changeNumIdSameAbstract$1 = (numId, level, listType, editor) => {
	let newNumId;
	mutateNumbering(editor, "list-numbering-helpers:changeNumIdSameAbstract", (numbering) => {
		newNumId = changeNumIdSameAbstract(numbering, numId, level, typeof listType === "string" ? listType : listType.name).newNumId;
	});
	if (newNumId == null) throw new Error("changeNumIdSameAbstract: failed to allocate numId.");
	return newNumId;
};
const getBasicNumIdTag = (numId, abstractId) => {
	return {
		type: "element",
		name: "w:num",
		attributes: { "w:numId": String(numId) },
		elements: [{
			name: "w:abstractNumId",
			attributes: { "w:val": String(abstractId) }
		}]
	};
};
const getNewListId = (editor, grouping = "definitions") => {
	return getNextId(editor.converter?.numbering?.[grouping] || {});
};
const createListIdAllocator = (editor) => {
	const existingIds = new Set(Object.keys(editor?.converter?.numbering?.definitions || {}).map((value) => Number(value)).filter(Number.isFinite));
	let nextId = Number(getNewListId(editor));
	return () => {
		while (!Number.isFinite(nextId) || existingIds.has(nextId)) nextId = Number.isFinite(nextId) ? nextId + 1 : Number(getNewListId(editor));
		const allocatedId = nextId;
		existingIds.add(allocatedId);
		nextId += 1;
		return allocatedId;
	};
};
const getListDefinitionDetails = ({ numId, level, listType = void 0, editor, tries = 0 }) => {
	const { definitions, abstracts } = editor.converter.numbering;
	if (!numId) return {};
	if (!definitions[numId] && listType) ListHelpers.generateNewListDefinition({
		numId,
		listType,
		editor
	});
	const abstractId = definitions[numId]?.elements?.find((item) => item.name === "w:abstractNumId")?.attributes?.["w:val"];
	const abstract = abstracts[abstractId];
	if (!abstract) return null;
	const styleId = (abstract.elements?.find((item) => item.name === "w:numStyleLink"))?.attributes?.["w:val"];
	if (styleId && tries < 1) {
		const linkedNumId = getStyleTagFromStyleId(styleId, editor.converter.convertedXml)?.elements?.find((el) => el.name === "w:pPr")?.elements?.find((el) => el.name === "w:numPr")?.elements?.find((el) => el.name === "w:numId")?.attributes?.["w:val"];
		if (linkedNumId) return getListDefinitionDetails({
			numId: Number(linkedNumId),
			level,
			listType,
			editor,
			tries: tries + 1
		});
	}
	const listDefinition = abstract.elements?.find((item) => item.name === "w:lvl" && item.attributes?.["w:ilvl"] == level);
	if (!listDefinition) return null;
	const findElement = (name) => listDefinition.elements?.find((item) => item.name === name);
	const startElement = findElement("w:start");
	let numFmtElement = findElement("w:numFmt");
	if (!numFmtElement) numFmtElement = ((listDefinition.elements?.find((item) => item.name === "mc:AlternateContent"))?.elements?.find((el) => el.name === "mc:Choice"))?.elements?.find((item) => item.name === "w:numFmt");
	const lvlTextElement = findElement("w:lvlText");
	const suffixElement = findElement("w:suff");
	const lvlJcElement = findElement("w:lvlJc");
	const startVal = startElement?.attributes?.["w:val"];
	const numFmt = numFmtElement?.attributes?.["w:val"];
	return {
		start: startVal,
		numFmt,
		lvlText: lvlTextElement?.attributes?.["w:val"],
		suffix: suffixElement?.attributes?.["w:val"],
		justification: lvlJcElement?.attributes?.["w:val"],
		listNumberingType: numFmt,
		customFormat: numFmt === "custom" ? numFmtElement?.attributes?.["w:format"] : void 0,
		abstract,
		abstractId
	};
};
const hasListDefinition = (editor, numId, ilvl) => {
	const { definitions, abstracts } = editor.converter.numbering;
	const numDef = definitions[numId];
	if (!numDef) return false;
	const abstract = abstracts[numDef.elements?.find((item) => item.name === "w:abstractNumId")?.attributes?.["w:val"]];
	if (!abstract) return false;
	return !!abstract.elements?.find((item) => item.name === "w:lvl" && item.attributes?.["w:ilvl"] == ilvl);
};
const getAllListDefinitions = (editor) => {
	const numbering = editor?.converter?.translatedNumbering;
	if (!numbering) return {};
	const { definitions = {}, abstracts = {} } = numbering;
	return Object.entries(definitions).reduce((acc, [numId, definition$1]) => {
		if (!definition$1) return acc;
		const abstractId = definition$1["abstractNumId"];
		const abstract = abstractId != null ? abstracts?.[abstractId] : void 0;
		const levelDefinitions = abstract?.levels || {};
		if (!acc[numId]) acc[numId] = {};
		Object.values(levelDefinitions).forEach((levelDef) => {
			const ilvl = levelDef.ilvl;
			const customFormat = levelDef.numFmt?.val === "custom" ? levelDef.numFmt.format : null;
			const start = definition$1.lvlOverrides?.[ilvl]?.startOverride ?? levelDef.start;
			acc[numId][ilvl] = {
				start,
				startOverridden: definition$1.lvlOverrides?.[ilvl]?.startOverride != null,
				restart: levelDef.lvlRestart,
				numFmt: levelDef.numFmt?.val,
				lvlText: levelDef.lvlText,
				suffix: levelDef.suff,
				listNumberingType: levelDef.numFmt?.val,
				customFormat,
				abstract: abstract ?? null,
				abstractId
			};
		});
		return acc;
	}, {});
};
const removeListDefinitions$1 = (listId, editor) => {
	mutateNumbering(editor, "list-numbering-helpers:removeListDefinitions", (numbering) => {
		removeListDefinitions(numbering, Number(listId));
	});
};
const createListItemNodeJSON = ({ level, numId, contentNode }) => {
	if (!Array.isArray(contentNode)) contentNode = [contentNode];
	const numberingProperties = {
		numId: Number(numId),
		ilvl: Number(level)
	};
	return {
		type: "paragraph",
		attrs: {
			paragraphProperties: { numberingProperties },
			numberingProperties
		},
		content: [...contentNode || []]
	};
};
const createSchemaOrderedListNode = ({ level, numId, editor, contentNode }) => {
	level = Number(level);
	numId = Number(numId);
	const listNodeJSON = createListItemNodeJSON({
		level,
		numId,
		contentNode
	});
	return editor.schema.nodeFromJSON(listNodeJSON);
};
const createNewList = ({ listType, tr, editor }) => {
	const numId = ListHelpers.getNewListId(editor);
	ListHelpers.generateNewListDefinition({
		numId,
		listType,
		editor
	});
	const paragraphInfo = findParentNode((node) => node?.type?.name === "paragraph")(tr.selection);
	if (!paragraphInfo) return false;
	const { node: paragraph, pos: paragraphPos = 0 } = paragraphInfo;
	updateNumberingProperties({
		numId,
		ilvl: 0
	}, paragraph, paragraphPos, editor, tr);
	return true;
};
const replaceListWithNode = ({ tr, from, to, newNode }) => {
	tr.replaceWith(from, to, newNode);
};
const setLvlOverride$1 = (editor, numId, ilvl, overrides) => {
	mutateNumbering(editor, "list-numbering-helpers:setLvlOverride", (numbering) => {
		setLvlOverride(numbering, numId, ilvl, overrides);
	});
};
const removeLvlOverride$1 = (editor, numId, ilvl) => {
	mutateNumbering(editor, "list-numbering-helpers:removeLvlOverride", (numbering) => {
		removeLvlOverride(numbering, numId, ilvl);
	});
};
const rebuildRawNumberingFromTranslated = (editor) => {
	const converter = editor?.converter;
	if (!converter) return {
		updated: false,
		skipped: 0
	};
	const translated = converter.translatedNumbering || {};
	const translatedAbstracts = translated.abstracts || {};
	const translatedDefinitions = translated.definitions || {};
	const nextAbstracts = {};
	const nextDefinitions = {};
	let skipped = 0;
	Object.entries(translatedAbstracts).forEach(([abstractId, abstractDef]) => {
		if (!abstractDef || typeof abstractDef !== "object") {
			skipped += 1;
			return;
		}
		const decoded = translator$39.decode({ node: { attrs: { abstractNum: abstractDef } } });
		if (!decoded) {
			skipped += 1;
			return;
		}
		nextAbstracts[abstractId] = decoded;
	});
	Object.entries(translatedDefinitions).forEach(([numId, numDef]) => {
		if (!numDef || typeof numDef !== "object") {
			skipped += 1;
			return;
		}
		const decoded = translator$112.decode({ node: { attrs: { num: numDef } } });
		if (!decoded) {
			skipped += 1;
			return;
		}
		nextDefinitions[numId] = decoded;
	});
	converter.numbering = {
		...converter.numbering || {},
		abstracts: nextAbstracts,
		definitions: nextDefinitions
	};
	return {
		updated: true,
		skipped
	};
};
const createNumDefinition$1 = (editor, abstractNumId, options = {}) => {
	let result;
	mutateNumbering(editor, "list-numbering-helpers:createNumDefinition", (numbering) => {
		result = createNumDefinition(numbering, abstractNumId, options);
	});
	if (!result) throw new Error("createNumDefinition: failed to create numbering definition.");
	return result;
};
const setLvlRestartOnAbstract$1 = (editor, abstractNumId, ilvl, restartAfterLevel) => {
	mutateNumbering(editor, "list-numbering-helpers:setLvlRestartOnAbstract", (numbering) => {
		setLvlRestartOnAbstract(numbering, abstractNumId, ilvl, restartAfterLevel);
	});
};
const setListLevelStyles = ({ editor, levels }) => {
	if (!levels?.length) return false;
	const resolved = [];
	for (const level of levels) {
		const abstractIdRaw = getListDefinitionDetails({
			numId: level.numId,
			level: level.ilvl,
			editor
		})?.abstractId;
		const abstractNumId = abstractIdRaw != null ? Number(abstractIdRaw) : NaN;
		if (!Number.isFinite(abstractNumId)) continue;
		resolved.push({
			abstractNumId,
			ilvl: level.ilvl,
			bulletStyle: level.bulletStyle,
			orderedStyle: level.orderedStyle
		});
	}
	if (!resolved.length) return false;
	let anyChanged = false;
	mutateNumberingBatch(editor, "list-numbering-helpers:setListLevelStyles", resolved.map(({ abstractNumId, ilvl, bulletStyle, orderedStyle }) => (numbering) => {
		if (setLvlStyleOnAbstract(numbering, abstractNumId, ilvl, {
			bulletStyle,
			orderedStyle
		})) anyChanged = true;
	}));
	return anyChanged;
};
const cloneListDefinitionWithLevelStyle$1 = ({ editor, sourceNumId, ilvl, bulletStyle, orderedStyle }) => {
	let result = null;
	mutateNumbering(editor, "list-numbering-helpers:cloneListDefinitionWithLevelStyle", (numbering) => {
		result = cloneListDefinitionWithLevelStyle(numbering, sourceNumId, ilvl, {
			bulletStyle,
			orderedStyle
		});
	});
	return result;
};
const ListHelpers = {
	replaceListWithNode,
	getListDefinitionDetails,
	getAllListDefinitions,
	generateNewListDefinition: generateNewListDefinition$1,
	getBasicNumIdTag,
	getNewListId,
	createListIdAllocator,
	hasListDefinition,
	removeListDefinitions: removeListDefinitions$1,
	setLvlOverride: setLvlOverride$1,
	removeLvlOverride: removeLvlOverride$1,
	createNumDefinition: createNumDefinition$1,
	setLvlRestartOnAbstract: setLvlRestartOnAbstract$1,
	setListLevelStyles,
	cloneListDefinitionWithLevelStyle: cloneListDefinitionWithLevelStyle$1,
	rebuildRawNumberingFromTranslated,
	createNewList,
	createSchemaOrderedListNode,
	createListItemNodeJSON,
	changeNumIdSameAbstract: changeNumIdSameAbstract$1,
	baseOrderedListDef,
	baseBulletList
};
function normalizeCssValue(value) {
	if (!value) return value;
	const trimmedValue = value.trim();
	if (trimmedValue.length >= 2 && (trimmedValue.startsWith("\"") && trimmedValue.endsWith("\"") || trimmedValue.startsWith("'") && trimmedValue.endsWith("'"))) return trimmedValue.slice(1, -1);
	return trimmedValue;
}
const extractListLevelStyles = (cssText, listId, level, numId) => {
	const pattern = new RegExp(`@list\\s+l${listId}:level${level}(?:\\s+lfo${numId})?\\s*\\{([^}]+)\\}`, "i");
	const match = cssText.match(pattern);
	if (!match) return null;
	const rawStyles = match[1].split(";").map((line) => line.trim()).filter(Boolean);
	const styleMap = {};
	for (const style of rawStyles) {
		const [key, value] = style.split(":").map((s) => s.trim());
		styleMap[key] = normalizeCssValue(value);
	}
	return styleMap;
};
const extractParagraphStyles = (cssText, selector) => {
	const pattern = new RegExp(`(${selector})\\s*\\{([^}]+)\\}`, "i");
	const match = cssText.match(pattern);
	if (!match) return null;
	const rawStyles = match[2].split(";").map((line) => line.trim()).filter(Boolean);
	const styleMap = {};
	for (const style of rawStyles) {
		const [key, value] = style.split(":").map((s) => s.trim());
		styleMap[key] = normalizeCssValue(value);
	}
	return styleMap;
};
function resolveStyles(extractedStyles, inlineStyles) {
	const inlineStyleMap = {};
	if (inlineStyles) {
		const styles = inlineStyles.split(";").map((s) => s.trim()).filter(Boolean);
		for (const style of styles) {
			const [key, value] = style.split(":").map((s) => s.trim());
			inlineStyleMap[key] = value;
		}
	}
	if (inlineStyleMap["mso-text-indent-alt"]) {
		delete inlineStyleMap["text-indent"];
		inlineStyleMap["text-indent"] = inlineStyleMap["mso-text-indent-alt"];
		delete inlineStyleMap["mso-text-indent-alt"];
	}
	if (inlineStyleMap["mso-bidi-font-family"]) {
		delete inlineStyleMap["font-family"];
		inlineStyleMap["font-family"] = inlineStyleMap["mso-bidi-font-family"];
		delete inlineStyleMap["mso-bidi-font-family"];
	}
	return {
		...extractedStyles,
		...inlineStyleMap
	};
}
const numDefMap = new Map([
	["decimal", "decimal"],
	["alpha-lower", "lowerLetter"],
	["alpha-upper", "upperLetter"],
	["roman-lower", "lowerRoman"],
	["roman-upper", "upperRoman"],
	["bullet", "bullet"]
]);
const numDefByTypeMap = new Map([
	["1", "decimal"],
	["a", "lowerLetter"],
	["A", "upperLetter"],
	["I", "upperRoman"],
	["i", "lowerRoman"]
]);
function getStartNumber(lvlText) {
	const match = lvlText.match(/^(\d+)/);
	if (match) return parseInt(match[1], 10);
	return null;
}
function letterToNumber(letter) {
	return letter.toLowerCase().charCodeAt(0) - "a".charCodeAt(0) + 1;
}
function getStartNumberFromAlpha(lvlText) {
	const match = lvlText.match(/^([a-zA-Z])/);
	if (match) return letterToNumber(match[1]);
	return null;
}
function romanToNumber(roman) {
	const map = {
		I: 1,
		V: 5,
		X: 10,
		L: 50,
		C: 100,
		D: 500,
		M: 1e3
	};
	let num = 0, prev = 0;
	for (let i$1 = roman.length - 1; i$1 >= 0; i$1--) {
		const curr = map[roman[i$1].toUpperCase()] || 0;
		if (curr < prev) num -= curr;
		else num += curr;
		prev = curr;
	}
	return num;
}
function getStartNumberFromRoman(lvlText) {
	const match = lvlText.match(/^([ivxlcdmIVXLCDM]+)/);
	if (match) return romanToNumber(match[1]);
	return null;
}
const startHelperMap = new Map([
	["decimal", getStartNumber],
	["lowerLetter", getStartNumberFromAlpha],
	["upperLetter", getStartNumberFromAlpha],
	["lowerRoman", getStartNumberFromRoman],
	["upperRoman", getStartNumberFromRoman],
	["bullet", () => 1]
]);
const googleNumDefMap = new Map([
	["decimal", "decimal"],
	["decimal-leading-zero", "decimal"],
	["lower-alpha", "lowerLetter"],
	["upper-alpha", "upperLetter"],
	["lower-roman", "lowerRoman"],
	["upper-roman", "upperRoman"],
	["bullet", "bullet"]
]);
const getLvlTextForGoogleList = (fmt, level, editor) => {
	const bulletLvlText = editor.converter.numbering.abstracts[0].elements.find((el) => el.name === "w:lvl" && el.attributes?.["w:ilvl"] === (level - 1).toString()).elements.find((el) => el.name === "w:lvlText")?.attributes?.["w:val"];
	switch (fmt) {
		case "decimal-leading-zero": return `0%${level}.`;
		case "bullet": return bulletLvlText;
		default: return `%${level}.`;
	}
};
const handleDocxPaste = (html, editor, view) => {
	const { converter } = editor;
	if (!converter || !converter.convertedXml) return handleHtmlPaste(html, editor);
	let cleanedHtml = convertEmToPt(html);
	cleanedHtml = cleanHtmlUnnecessaryTags(cleanedHtml);
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = cleanedHtml;
	tempDiv.querySelectorAll("[data-sd-block-id]").forEach((node) => node.removeAttribute("data-sd-block-id"));
	const data = tempDiv.querySelectorAll("p, li, " + [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9
	].map((n) => `h${n}`).join(", "));
	const startMap = {};
	data.forEach((item) => {
		let type;
		if (item.localName === "li") type = "listItem";
		else type = "p";
		const msoListMatch = (item.getAttribute("style") || "").match(/mso-list:\s*l(\d+)\s+level(\d+)\s+lfo(\d+)/);
		const css = tempDiv.querySelector("style").innerHTML;
		const normalStyles = extractParagraphStyles(css, ".MsoNormal");
		let styleId = item.getAttribute("class");
		let charStyles = {};
		if (item.localName.startsWith("h") && !styleId) {
			styleId = item.localName;
			charStyles = extractParagraphStyles(css, `.Heading${styleId.substring(1)}Char`);
		} else if (styleId) styleId = `.${styleId}`;
		const paragraphStyles = extractParagraphStyles(css, styleId);
		let styleChain = {
			...normalStyles,
			...paragraphStyles,
			...charStyles
		};
		const numberingDefinedInline = !paragraphStyles || !paragraphStyles["mso-list"];
		if (msoListMatch) {
			const [, abstractId, level, numId] = msoListMatch;
			const numberingStyles = extractListLevelStyles(css, abstractId, level, numId) || {};
			const markerFontFamily = numberingStyles?.["font-family"] ?? normalStyles?.["font-family"];
			delete numberingStyles["font-family"];
			if (numberingDefinedInline) styleChain = {
				...normalStyles,
				...paragraphStyles,
				...numberingStyles
			};
			else styleChain = {
				...normalStyles,
				...numberingStyles,
				...paragraphStyles
			};
			let start, numFmt, lvlText;
			if (type === "listItem") {
				const listType = item.parentNode.getAttribute("type");
				const startAttr = item.parentNode.getAttribute("start");
				if (!startMap[numId]) startMap[numId] = startAttr;
				start = startMap[numId];
				numFmt = numDefByTypeMap.get(listType);
				lvlText = `%${level}.`;
			} else {
				const msoNumFormat = numberingStyles["mso-level-number-format"] || "decimal";
				numFmt = numDefMap.get(msoNumFormat);
				const punc = item.innerText?.match(/^\s*[a-zA-Z0-9]+([.()])/i)?.[1] || ".";
				lvlText = numFmt === "bullet" ? normalizeLvlTextChar(numberingStyles["mso-level-text"]) : `%${level}${punc}`;
				const startGetter = startHelperMap.get(numFmt);
				if (!startMap[numId]) startMap[numId] = startGetter(item.children[0]?.innerText || "1");
				start = startMap[numId];
			}
			item.setAttribute("data-marker-font-family", markerFontFamily);
			item.setAttribute("data-num-id", numId);
			item.setAttribute("data-list-level", parseInt(level) - 1);
			item.setAttribute("data-start", start);
			item.setAttribute("data-lvl-text", lvlText);
			item.setAttribute("data-num-fmt", numFmt);
		}
		const resolvedStyle = resolveStyles(styleChain, item.getAttribute("style"));
		const left = pointsToTwips$1(parseInt(resolvedStyle["margin-left"] ?? 0));
		const hangingFirstLine = pointsToTwips$1(parseInt(resolvedStyle["text-indent"] ?? 0));
		let hanging, firstLine;
		if (hangingFirstLine < 0) hanging = Math.abs(hangingFirstLine);
		else firstLine = hangingFirstLine;
		if (left || hanging || firstLine) {
			const indent = {};
			if (left != null) indent.left = left;
			if (hanging != null) indent.hanging = hanging;
			if (firstLine != null) indent.firstLine = firstLine;
			item.setAttribute("data-indent", JSON.stringify(indent));
		}
		const after = pointsToTwips$1(parseInt(resolvedStyle["margin-bottom"] ?? 0));
		const before = pointsToTwips$1(parseInt(resolvedStyle["margin-top"] ?? 0));
		if (after || before) {
			const spacing = {};
			if (after != null) spacing.after = after;
			if (before != null) spacing.before = before;
			item.setAttribute("data-spacing", JSON.stringify(spacing));
		}
		const textStyles = {};
		if (resolvedStyle["font-size"]) textStyles["font-size"] = resolvedStyle["font-size"];
		if (resolvedStyle["font-family"]) textStyles["font-family"] = resolvedStyle["font-family"];
		if (resolvedStyle["text-transform"]) textStyles["text-transform"] = resolvedStyle["text-transform"];
		if (Object.keys(textStyles).length) {
			Object.keys(textStyles).forEach((key) => {
				const styleValue = textStyles[key];
				if (styleValue) item.style.setProperty(key, styleValue);
			});
			item.setAttribute("data-text-styles", JSON.stringify(textStyles));
			for (const child of item.children) if (child.style) Object.keys(textStyles).forEach((key) => {
				const styleValue = textStyles[key];
				if (styleValue) child.style.setProperty(key, styleValue);
			});
		}
		if (resolvedStyle["font-weight"] === "bold") {
			item.style.setProperty("font-weight", "bold");
			for (const child of item.children) if (child.style) child.style.setProperty("font-weight", "bold");
		}
		extractAndRemoveConditionalPrefix(item);
	});
	transformWordLists(tempDiv, editor);
	let doc$2 = DOMParser$1.fromSchema(editor.schema).parse(tempDiv);
	doc$2 = wrapTextsInRuns(doc$2);
	tempDiv.remove();
	const { dispatch } = editor.view;
	if (!dispatch) return false;
	const tr = view.state.tr.replaceSelectionWith(doc$2, true);
	normalizePastedLinks(tr, editor);
	dispatch(tr);
	return true;
};
const wrapTextsInRuns = (doc$2) => {
	const runType = doc$2.type?.schema?.nodes?.run;
	if (!runType) return doc$2;
	const wrapNode = (node, parent) => {
		if (node.isText) {
			if (parent?.type?.name === "run") return node;
			const runProperties = decodeRPrFromMarks(node.marks);
			return runType.create({ runProperties }, [node]);
		}
		if (!node.childCount) return node;
		let changed = false;
		const wrappedChildren = [];
		node.forEach((child) => {
			const wrappedChild = wrapNode(child, node);
			if (wrappedChild !== child) changed = true;
			wrappedChildren.push(wrappedChild);
		});
		if (!changed) return node;
		return node.copy(Fragment.fromArray(wrappedChildren));
	};
	return wrapNode(doc$2, null);
};
var transformWordLists = (container, editor) => {
	const listItems = Array.from(container.querySelectorAll("[data-num-id]"));
	const lists = {};
	const mappedLists = {};
	for (const item of listItems) {
		const level = parseInt(item.getAttribute("data-list-level"));
		const numFmt = item.getAttribute("data-num-fmt");
		const start = item.getAttribute("data-start");
		const lvlText = item.getAttribute("data-lvl-text");
		const markerFontFamily = item.getAttribute("data-marker-font-family");
		const importedId = item.getAttribute("data-num-id");
		if (!mappedLists[importedId]) mappedLists[importedId] = ListHelpers.getNewListId(editor);
		const id = mappedLists[importedId];
		const listType = numFmt === "bullet" ? "bulletList" : "orderedList";
		ListHelpers.generateNewListDefinition({
			numId: id,
			listType,
			level: level.toString(),
			start,
			fmt: numFmt,
			text: lvlText,
			editor,
			markerFontFamily
		});
		if (!lists[id]) lists[id] = { levels: {} };
		const currentListByNumId = lists[id];
		if (!currentListByNumId.levels[level]) currentListByNumId.levels[level] = Number(start) || 1;
		else currentListByNumId.levels[level]++;
		Object.keys(currentListByNumId.levels).forEach((key) => {
			const level1 = Number(key);
			if (level1 > level) delete currentListByNumId.levels[level1];
		});
		const path = generateListPath(level, currentListByNumId.levels, start);
		if (!path.length) path.push(currentListByNumId.levels[level]);
		const pElement = document.createElement("p");
		pElement.innerHTML = item.innerHTML;
		pElement.setAttribute("data-num-id", id);
		pElement.setAttribute("data-list-level", JSON.stringify(path));
		pElement.setAttribute("data-level", level);
		pElement.setAttribute("data-lvl-text", lvlText);
		pElement.setAttribute("data-num-fmt", numFmt);
		if (item.hasAttribute("data-indent")) pElement.setAttribute("data-indent", item.getAttribute("data-indent"));
		if (item.hasAttribute("data-spacing")) pElement.setAttribute("data-spacing", item.getAttribute("data-spacing"));
		if (item.hasAttribute("data-sd-sect-pr")) pElement.setAttribute("data-sd-sect-pr", item.getAttribute("data-sd-sect-pr"));
		if (item.hasAttribute("data-sd-page-break-source")) pElement.setAttribute("data-sd-page-break-source", item.getAttribute("data-sd-page-break-source"));
		if (item.hasAttribute("data-text-styles")) {
			const textStyles = JSON.parse(item.getAttribute("data-text-styles"));
			Object.keys(textStyles).forEach((key) => {
				const styleValue = textStyles[key];
				if (styleValue) {
					pElement.style.setProperty(key, styleValue);
					for (const child of pElement.children) if (child.style) child.style.setProperty(key, styleValue);
				}
			});
		}
		const parentNode$1 = item.parentNode;
		parentNode$1.appendChild(pElement);
		let listForLevel;
		const newList = numFmt === "bullet" ? document.createElement("ul") : document.createElement("ol");
		newList.setAttribute("data-list-id", id);
		newList.level = level;
		parentNode$1.insertBefore(newList, item);
		listForLevel = newList;
		listForLevel.appendChild(pElement);
		item.remove();
	}
};
const generateListPath = (level, levels, start) => {
	const iLvl = Number(level);
	const path = [];
	if (iLvl > 0) for (let i$1 = iLvl; i$1 >= 0; i$1--) {
		if (!levels[i$1]) levels[i$1] = Number(start);
		path.unshift(levels[i$1]);
	}
	return path;
};
function extractAndRemoveConditionalPrefix(item) {
	const nodes = Array.from(item.childNodes);
	let fontFamily = null;
	let fontSize = null;
	let start = -1, end = -1;
	nodes.forEach((node, index) => {
		if (node.nodeType === Node.COMMENT_NODE && node.nodeValue.includes("[if !supportLists]")) start = index;
		if (start !== -1 && node.nodeType === Node.COMMENT_NODE && node.nodeValue.includes("[endif]")) end = index;
	});
	if (start !== -1 && end !== -1) {
		for (let i$1 = start + 1; i$1 < end; i$1++) {
			const node = nodes[i$1];
			if (node.nodeType === Node.ELEMENT_NODE && node.style) {
				fontFamily = fontFamily || node.style.fontFamily;
				fontSize = fontSize || node.style.fontSize;
			}
		}
		for (let i$1 = end; i$1 >= start; i$1--) item.removeChild(item.childNodes[i$1]);
		if (fontFamily) item.setAttribute("data-font-family", fontFamily);
		if (fontSize) item.setAttribute("data-font-size", fontSize);
	}
}
var removeWhitespaces = (node) => {
	const children = node.childNodes;
	for (let i$1 = children.length - 1; i$1 >= 0; i$1 -= 1) {
		const child = children[i$1];
		if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
		else if (child.nodeType === 1) removeWhitespaces(child);
	}
	return node;
};
function flattenListsInHtml(html, editor, domDocument) {
	const DOMParserConstructor = ((domDocument ?? editor?.options?.document ?? editor?.options?.mockDocument ?? (typeof document !== "undefined" ? document : null))?.defaultView ?? (typeof window !== "undefined" ? window : null))?.DOMParser ?? (typeof DOMParser !== "undefined" ? DOMParser : null);
	if (!DOMParserConstructor) {
		console.warn("[super-editor] HTML list processing requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment. Skipping list flattening.");
		return html;
	}
	const doc$2 = removeWhitespaces(new DOMParserConstructor().parseFromString(html, "text/html"));
	restoreCopiedListParagraphDefinitions(doc$2.body, editor);
	let foundList;
	while (foundList = findListToFlatten$1(doc$2)) flattenFoundList$1(foundList, editor);
	return doc$2.body.innerHTML;
}
function restoreCopiedListParagraphDefinitions(container, editor) {
	if (!editor?.converter) return;
	const copiedParagraphs = Array.from(container.querySelectorAll("p[data-list-numbering-type], p[data-num-id]"));
	if (copiedParagraphs.length === 0) return;
	const allocateListId = createListIdAllocator(editor);
	const remappedNumIds = /* @__PURE__ */ new Map();
	const generatedLevels = /* @__PURE__ */ new Set();
	copiedParagraphs.forEach((node) => {
		const originalNumId = node.getAttribute("data-num-id") || "__copied-list__";
		let numId = remappedNumIds.get(originalNumId);
		if (numId == null) {
			numId = allocateListId();
			remappedNumIds.set(originalNumId, numId);
		}
		const level = Number.parseInt(node.getAttribute("data-level") || "0", 10) || 0;
		const fmt = node.getAttribute("data-num-fmt") || node.getAttribute("data-list-numbering-type") || "decimal";
		const listType = fmt === "bullet" ? "bulletList" : "orderedList";
		const listLevel = parseListLevelAttribute(node.getAttribute("data-list-level"));
		const start = String(getStartValueForLevel(listLevel, level) || 1);
		const lvlText = node.getAttribute("data-lvl-text") || getDefaultLvlText(fmt, level, node.getAttribute("data-marker-type"));
		const generationKey = `${numId}:${level}`;
		if (!generatedLevels.has(generationKey)) {
			ListHelpers.generateNewListDefinition({
				numId,
				listType,
				level: String(level),
				start,
				text: lvlText,
				fmt,
				editor
			});
			if (Number(start) > 1) ListHelpers.setLvlOverride(editor, numId, level, { startOverride: Number(start) });
			generatedLevels.add(generationKey);
		}
		node.setAttribute("data-num-id", String(numId));
		node.setAttribute("data-level", String(level));
		node.setAttribute("data-num-fmt", fmt);
		node.setAttribute("data-lvl-text", lvlText);
	});
}
function getDefaultLvlText(fmt, level, markerText) {
	if (fmt === "bullet") return markerText || "•";
	return `%${level + 1}.`;
}
function findListToFlatten$1(doc$2) {
	let list$1 = doc$2.querySelector("ol:not([data-list-id]), ul:not([data-list-id])");
	if (list$1) return list$1;
	const allLists = doc$2.querySelectorAll("ol[data-list-id], ul[data-list-id]");
	for (const list$2 of allLists) {
		const liChildren = Array.from(list$2.children).filter((c$1) => c$1.tagName.toLowerCase() === "li");
		if (liChildren.length > 1) return list$2;
		if (list$2.querySelectorAll("ol, ul").length > 0) return list$2;
		if (liChildren.length === 1) return list$2;
	}
	return null;
}
function flattenFoundList$1(listElem, editor) {
	const localDoc = listElem.ownerDocument;
	const tag = listElem.tagName.toLowerCase();
	let rootNumId = listElem.getAttribute("data-list-id");
	if (!rootNumId) {
		rootNumId = ListHelpers.getNewListId(editor);
		ListHelpers.generateNewListDefinition({
			numId: rootNumId,
			listType: tag === "ol" ? "orderedList" : "bulletList",
			editor
		});
	}
	let level = Number(listElem.getAttribute("data-level"));
	if (Number.isNaN(level)) level = 0;
	let ancestor = listElem.parentElement;
	while (ancestor && ancestor !== localDoc.body) {
		if (ancestor.tagName && ancestor.tagName.toLowerCase() === "li") level++;
		ancestor = ancestor.parentElement;
	}
	const items = Array.from(listElem.children).filter((c$1) => c$1.tagName.toLowerCase() === "li");
	const newLists = [];
	items.forEach((li) => {
		const nestedLists = Array.from(li.querySelectorAll("ol, ul"));
		const nestedListsData = nestedLists.map((nl) => ({
			element: nl.cloneNode(true),
			parent: nl.parentNode
		}));
		nestedLists.forEach((nl) => nl.parentNode.removeChild(nl));
		let listNumberingType = tag === "ol" ? "decimal" : "bullet";
		try {
			const details = ListHelpers.getListDefinitionDetails?.({
				numId: rootNumId,
				level,
				editor
			});
			if (details?.listNumberingType) listNumberingType = details.listNumberingType;
		} catch {}
		const newList = createSingleItemList({
			li,
			rootNumId,
			level,
			listNumberingType
		});
		newLists.push(newList);
		nestedListsData.forEach((data) => {
			data.element.setAttribute("data-level", level + 1);
			if (data.element.tagName?.toLowerCase() === tag) data.element.setAttribute("data-list-id", rootNumId);
			newLists.push(data.element);
		});
	});
	const parent = listElem.parentNode;
	const nextSibling = listElem.nextSibling;
	parent.removeChild(listElem);
	newLists.forEach((list$1) => {
		parent.insertBefore(list$1, nextSibling);
	});
}
function createSingleItemList({ li, rootNumId, level, listNumberingType }) {
	const newItem = li.ownerDocument.createElement("p");
	Array.from(li.attributes).forEach((attr) => {
		if (!attr.name.startsWith("data-num-") && !attr.name.startsWith("data-level") && !attr.name.startsWith("data-list-")) newItem.setAttribute(attr.name, attr.value);
	});
	newItem.setAttribute("data-num-id", rootNumId);
	newItem.setAttribute("data-level", String(level));
	if (listNumberingType) newItem.setAttribute("data-list-numbering-type", listNumberingType);
	Array.from(li.childNodes).forEach((node) => {
		if (node.tagName === "P") {
			Array.from(node.childNodes).forEach((childNode) => {
				newItem.appendChild(childNode.cloneNode(true));
			});
			return;
		}
		newItem.appendChild(node.cloneNode(true));
	});
	return newItem;
}
function unflattenListsInHtml(html, domDocument) {
	const DOMParserConstructor = (domDocument?.defaultView ?? (typeof window !== "undefined" ? window : null))?.DOMParser ?? (typeof DOMParser !== "undefined" ? DOMParser : null);
	if (!DOMParserConstructor) {
		console.warn("[super-editor] HTML list processing requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment. Skipping list unflattening.");
		return html;
	}
	const doc$2 = new DOMParserConstructor().parseFromString(html, "text/html");
	const allNodes = [...doc$2.body.children];
	const listSequences = [];
	let currentSequence = null;
	allNodes.forEach((node) => {
		if (node.tagName === "P" && node.hasAttribute("data-num-id")) {
			const listId = node.getAttribute("data-num-id");
			if (currentSequence && currentSequence.id === listId) currentSequence.items.push(node);
			else {
				currentSequence = {
					id: listId,
					items: [node]
				};
				listSequences.push(currentSequence);
			}
		} else currentSequence = null;
	});
	listSequences.reverse().forEach((sequence) => {
		const sequenceItems = sequence.items;
		if (sequenceItems.length === 0) return;
		const items = sequenceItems.map((element) => {
			const level = parseInt(element.getAttribute("data-level") || "0", 10);
			const listNumberingType = element.getAttribute("data-list-numbering-type") || "";
			const listLevel = parseListLevelAttribute(element.getAttribute("data-list-level"));
			return {
				element,
				level,
				numId: element.getAttribute("data-num-id"),
				listNumberingType,
				listLevel
			};
		}).filter(Boolean);
		if (items.length === 0) return;
		const rootList = buildNestedList({ items });
		if (!rootList) return;
		const firstParagraph = sequenceItems[0];
		firstParagraph?.parentNode?.insertBefore(rootList, firstParagraph);
		sequenceItems.forEach((element) => {
			element.parentNode?.removeChild(element);
		});
	});
	return doc$2.body.innerHTML;
}
function buildNestedList({ items }) {
	if (!items.length) return null;
	const [rootItem] = items;
	const doc$2 = rootItem.element.ownerDocument;
	const rootListTag = getListTagForType(rootItem.listNumberingType);
	const rootList = doc$2.createElement(rootListTag);
	if (rootItem.numId) rootList.setAttribute("data-list-id", rootItem.numId);
	rootList.setAttribute("data-level", String(rootItem.level ?? 0));
	applyStartAttribute(rootList, rootItem.listLevel, 0);
	const lastLevelItem = /* @__PURE__ */ new Map();
	items.forEach((item) => {
		const { element: paragraph, level } = item;
		const cleanLi = cleanListItem(createListItemFromParagraph(paragraph));
		if (level === 0) {
			rootList.append(cleanLi);
			lastLevelItem.set(0, cleanLi);
		} else {
			const parentLi = lastLevelItem.get(level - 1);
			if (!parentLi) {
				rootList.append(cleanLi);
				lastLevelItem.set(level, cleanLi);
				return;
			}
			const listTag = getListTagForType(item.listNumberingType);
			let nestedList = findNestedList(parentLi, listTag);
			if (!nestedList) {
				nestedList = doc$2.createElement(listTag);
				if (item.numId) nestedList.setAttribute("data-list-id", item.numId);
				parentLi.append(nestedList);
			}
			nestedList.setAttribute("data-level", String(level));
			applyStartAttribute(nestedList, item.listLevel, level);
			nestedList.append(cleanLi);
			lastLevelItem.set(level, cleanLi);
		}
		[...lastLevelItem.keys()].forEach((storedLevel) => {
			if (storedLevel > level) lastLevelItem.delete(storedLevel);
		});
	});
	return rootList;
}
function createListItemFromParagraph(paragraph) {
	const listItem = paragraph.ownerDocument.createElement("li");
	Array.from(paragraph.childNodes).forEach((node) => {
		listItem.appendChild(node.cloneNode(true));
	});
	Array.from(paragraph.attributes).forEach((attr) => {
		if (!LIST_METADATA_ATTRIBUTES.has(attr.name)) listItem.setAttribute(attr.name, attr.value);
	});
	return listItem;
}
function findNestedList(parentLi, listTag) {
	const lowerTag = listTag.toLowerCase();
	return Array.from(parentLi.children).find((child) => child.tagName && child.tagName.toLowerCase() === lowerTag);
}
function getListTagForType(listNumberingType) {
	const type = listNumberingType?.toLowerCase();
	if (!type || type === "bullet" || type === "image" || type === "none") return "ul";
	return "ol";
}
function applyStartAttribute(listNode, listLevel, level) {
	if (!listNode || listNode.tagName?.toLowerCase() !== "ol") return;
	const startValue = getStartValueForLevel(listLevel, level);
	if (startValue && startValue > 1 && !listNode.hasAttribute("start")) listNode.setAttribute("start", String(startValue));
}
function getStartValueForLevel(listLevel, level) {
	if (!Array.isArray(listLevel)) return null;
	const value = listLevel[level];
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
}
function parseListLevelAttribute(raw) {
	if (!raw) return null;
	try {
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed.map((value) => Number(value)) : null;
	} catch {
		return null;
	}
}
var LIST_METADATA_ATTRIBUTES = new Set([
	"data-num-id",
	"data-level",
	"data-num-fmt",
	"data-lvl-text",
	"data-list-level",
	"data-marker-type",
	"data-list-numbering-type"
]);
function cleanListItem(listItem) {
	[
		"data-num-id",
		"data-level",
		"data-num-fmt",
		"data-lvl-text",
		"data-list-level",
		"data-marker-type",
		"data-list-numbering-type",
		"aria-label"
	].forEach((attr) => {
		listItem.removeAttribute(attr);
	});
	return listItem;
}
const handleGoogleDocsHtml = (html, editor, view) => {
	const cleanedHtml = sanitizeHtml(convertEmToPt(html)).innerHTML;
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = cleanedHtml;
	const flattenHtml = flattenListsInHtml$1(mergeSeparateLists(tempDiv), editor);
	flattenHtml.dataset.superdocImport = "true";
	let doc$2 = DOMParser$1.fromSchema(editor.schema).parse(flattenHtml);
	doc$2 = wrapTextsInRuns(doc$2);
	tempDiv.remove();
	const { dispatch } = editor.view;
	if (!dispatch) return false;
	const tr = view.state.tr.replaceSelectionWith(doc$2, true);
	normalizePastedLinks(tr, editor);
	dispatch(tr);
	return true;
};
function flattenListsInHtml$1(container, editor) {
	let foundList;
	while (foundList = findListToFlatten(container)) flattenFoundList(foundList, editor);
	return container;
}
function findListToFlatten(container) {
	let list$1 = container.querySelector("ol:not([data-list-id]), ul:not([data-list-id])");
	if (list$1) return list$1;
	return null;
}
function flattenFoundList(listElem, editor) {
	const tag = listElem.tagName.toLowerCase();
	const baseLevel = getBaseLevel(listElem);
	const items = Array.from(listElem.children).filter((c$1) => c$1.tagName?.toLowerCase() === "li");
	if (!items.length) return;
	const counters = {};
	const levelStarts = {};
	const rootNumId = ListHelpers.getNewListId(editor);
	const newNodes = [];
	items.forEach((li) => {
		const level = getEffectiveLevel(li, baseLevel);
		const styleType = getListStyleType(li, tag);
		const numFmt = googleNumDefMap.get(styleType) || (tag === "ol" ? "decimal" : "bullet");
		const lvlText = getLvlTextForGoogleList(styleType, level + 1, editor);
		if (levelStarts[level] == null) levelStarts[level] = getInitialStartValue({
			li,
			listElem,
			level,
			baseLevel
		});
		const currentValue = incrementLevelCounter(counters, level, levelStarts[level]);
		const path = buildListPath(level, counters);
		const paragraph = createSingleItemList({
			li: li.childNodes.length && li.childNodes[0].tagName === "P" ? li.childNodes[0] : li,
			rootNumId,
			level,
			listNumberingType: numFmt
		});
		paragraph.setAttribute("data-num-fmt", numFmt);
		paragraph.setAttribute("data-lvl-text", lvlText);
		paragraph.setAttribute("data-list-level", JSON.stringify(path.length ? path : [currentValue]));
		ListHelpers.generateNewListDefinition({
			numId: rootNumId,
			listType: numFmt === "bullet" ? "bulletList" : "orderedList",
			editor,
			fmt: numFmt,
			level: level.toString(),
			start: levelStarts[level],
			text: lvlText
		});
		newNodes.push(paragraph);
		const nestedList = getNestedLists([li.nextSibling])[0];
		if (nestedList) {
			const cloned = nestedList.cloneNode(true);
			cloned.setAttribute("data-level", String(level + 1));
			newNodes.push(cloned);
			if (["OL", "UL"].includes(li.nextSibling?.tagName)) li.nextSibling.remove();
		}
	});
	const parent = listElem.parentNode;
	const nextSibling = listElem.nextSibling;
	parent.removeChild(listElem);
	newNodes.forEach((node) => {
		parent.insertBefore(node, nextSibling);
	});
}
function getNestedLists(nodes) {
	let result = [];
	const nodesArray = Array.from(nodes).filter((n) => n !== null);
	for (let item of nodesArray) if (item.tagName === "OL" || item.tagName === "UL") result.push(item);
	return result;
}
function mergeSeparateLists(container) {
	const tempCont = container.cloneNode(true);
	const rootLevelLists = Array.from(tempCont.querySelectorAll("ol") || []).filter((ol) => !ol.parentElement?.closest("ol, ul"));
	const mainList = rootLevelLists.find((list$1) => !list$1.getAttribute("start")) || rootLevelLists[0];
	if (rootLevelLists.some((list$1) => list$1.getAttribute("start") !== null) && mainList) rootLevelLists.filter((list$1) => list$1 !== mainList && list$1.getAttribute("start") !== null).sort((a, b) => Number(a.getAttribute("start")) - Number(b.getAttribute("start"))).forEach((item) => {
		mainList.append(...item.childNodes);
		item.remove();
	});
	return tempCont;
}
function getBaseLevel(listElem) {
	const explicitLevel = Number(listElem.getAttribute("data-level"));
	if (!Number.isNaN(explicitLevel)) return explicitLevel;
	let level = 0;
	let ancestor = listElem.parentElement;
	while (ancestor && ancestor.tagName) {
		if (ancestor.tagName.toLowerCase() === "li") level++;
		ancestor = ancestor.parentElement;
	}
	return level;
}
function getEffectiveLevel(li, baseLevel) {
	const ariaLevel = Number(li.getAttribute("aria-level"));
	if (Number.isNaN(ariaLevel)) return baseLevel;
	return Math.max(ariaLevel - 1, baseLevel);
}
function getListStyleType(li, fallbackTag) {
	return li.style?.["list-style-type"] || (fallbackTag === "ol" ? "decimal" : "bullet");
}
function getInitialStartValue({ li, listElem, level, baseLevel }) {
	const valueAttr = Number(li.getAttribute("value"));
	if (!Number.isNaN(valueAttr)) return valueAttr;
	if (level === baseLevel) {
		const listStart = Number(listElem.getAttribute("start"));
		if (!Number.isNaN(listStart)) return listStart;
	}
	return 1;
}
function incrementLevelCounter(map, level, start) {
	const numericLevel = Number(level);
	Object.keys(map).forEach((key) => {
		if (Number(key) > numericLevel) delete map[key];
	});
	if (map[numericLevel] == null) map[numericLevel] = Number(start) || 1;
	else map[numericLevel] += 1;
	return map[numericLevel];
}
function buildListPath(level, map) {
	const numericLevel = Number(level);
	if (Number.isNaN(numericLevel)) return [];
	const path = [];
	for (let i$1 = 0; i$1 <= numericLevel; i$1++) if (map[i$1] != null) path.push(map[i$1]);
	return path;
}
function getSectPrColumns(sectPr) {
	if (!sectPr || sectPr.name !== "w:sectPr") return void 0;
	const cols = sectPr.elements?.find((el) => el?.name === "w:cols");
	if (!cols?.attributes) return void 0;
	const a = cols.attributes;
	const result = {};
	if (a["w:num"] != null) {
		const count = Number(a["w:num"]);
		if (Number.isFinite(count) && count > 0) result.count = count;
	}
	if (a["w:space"] != null) result.gap = twipsToInches(a["w:space"]);
	return Object.keys(result).length > 0 ? result : void 0;
}
function getSectPrMargins(sectPr) {
	if (!sectPr || sectPr.name !== "w:sectPr") return {};
	const pgMar = sectPr.elements?.find((el) => el?.name === "w:pgMar");
	if (!pgMar?.attributes) return {};
	const a = pgMar.attributes;
	const result = {};
	if (a["w:top"] != null) result.top = twipsToInches(a["w:top"]);
	if (a["w:right"] != null) result.right = twipsToInches(a["w:right"]);
	if (a["w:bottom"] != null) result.bottom = twipsToInches(a["w:bottom"]);
	if (a["w:left"] != null) result.left = twipsToInches(a["w:left"]);
	if (a["w:header"] != null) result.header = twipsToInches(a["w:header"]);
	if (a["w:footer"] != null) result.footer = twipsToInches(a["w:footer"]);
	if (a["w:gutter"] != null) result.gutter = twipsToInches(a["w:gutter"]);
	return result;
}
function ensurePgMar(sectPr) {
	if (!sectPr || sectPr.name !== "w:sectPr") throw new Error("ensurePgMar: invalid sectPr node");
	if (!Array.isArray(sectPr.elements)) sectPr.elements = [];
	let pgMar = sectPr.elements.find((el) => el?.name === "w:pgMar");
	if (!pgMar) {
		pgMar = {
			type: "element",
			name: "w:pgMar",
			attributes: {}
		};
		sectPr.elements.push(pgMar);
	} else if (!pgMar.attributes) pgMar.attributes = {};
	return pgMar;
}
function updateSectPrMargins(sectPr, updates = {}) {
	if (!sectPr || sectPr.name !== "w:sectPr") throw new Error("updateSectPrMargins: invalid sectPr node");
	const a = ensurePgMar(sectPr).attributes;
	if (updates.topInches != null) a["w:top"] = String(inchesToTwips(updates.topInches));
	if (updates.rightInches != null) a["w:right"] = String(inchesToTwips(updates.rightInches));
	if (updates.bottomInches != null) a["w:bottom"] = String(inchesToTwips(updates.bottomInches));
	if (updates.leftInches != null) a["w:left"] = String(inchesToTwips(updates.leftInches));
	if (updates.headerInches != null) a["w:header"] = String(inchesToTwips(updates.headerInches));
	if (updates.footerInches != null) a["w:footer"] = String(inchesToTwips(updates.footerInches));
	if (updates.gutterInches != null) a["w:gutter"] = String(inchesToTwips(updates.gutterInches));
	return sectPr;
}
function updateSectionMargins(target, updates = {}) {
	if (!target || !target.type) throw new Error("updateSectionMargins: missing or invalid target");
	if (target.type === "body") {
		const { converter } = target;
		if (!converter) throw new Error("updateSectionMargins: body target missing converter");
		if (!converter.pageStyles) converter.pageStyles = {};
		if (!converter.pageStyles.pageMargins) converter.pageStyles.pageMargins = {};
		const m = converter.pageStyles.pageMargins;
		if (updates.topInches != null) m.top = updates.topInches;
		if (updates.rightInches != null) m.right = updates.rightInches;
		if (updates.bottomInches != null) m.bottom = updates.bottomInches;
		if (updates.leftInches != null) m.left = updates.leftInches;
		if (updates.headerInches != null) m.header = updates.headerInches;
		if (updates.footerInches != null) m.footer = updates.footerInches;
		if (updates.gutterInches != null) m.gutter = updates.gutterInches;
		return {
			kind: "body",
			pageMargins: { ...m }
		};
	}
	if (target.type === "sectPr") {
		const { sectPr } = target;
		if (!sectPr || sectPr.name !== "w:sectPr") throw new Error("updateSectionMargins: sectPr target missing/invalid sectPr");
		updateSectPrMargins(sectPr, updates);
		return {
			kind: "sectPr",
			sectPr
		};
	}
	throw new Error(`updateSectionMargins: unsupported target type: ${target.type}`);
}
function binaryStringToBase64(binary) {
	if (typeof globalThis.btoa === "function") return globalThis.btoa(binary);
	if (typeof Buffer !== "undefined") return Buffer.from(binary, "latin1").toString("base64");
	throw new Error("[base64] encode requires btoa (browser) or Buffer (Node)");
}
function base64ToBinaryString(b64) {
	if (typeof globalThis.atob === "function") return globalThis.atob(b64);
	if (typeof Buffer !== "undefined") return Buffer.from(b64, "base64").toString("latin1");
	throw new Error("[base64] decode requires atob (browser) or Buffer (Node)");
}
function encodeUtf8Base64(input) {
	return binaryStringToBase64(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16))));
}
function decodeUtf8Base64(b64) {
	if (!b64) return "";
	try {
		const bin = base64ToBinaryString(b64);
		let pct = "";
		for (let i$1 = 0; i$1 < bin.length; i$1 += 1) pct += `%${bin.charCodeAt(i$1).toString(16).padStart(2, "0")}`;
		return decodeURIComponent(pct);
	} catch {
		return "";
	}
}
const SUPERDOC_SLICE_MIME = "application/x-superdoc-slice";
const SUPERDOC_MEDIA_MIME = "application/x-superdoc-media";
const SUPERDOC_SLICE_ATTR = "data-superdoc-slice";
const SUPERDOC_BODY_SECT_PR_ATTR = "data-sd-body-sect-pr";
const SUPERDOC_MEDIA_ATTR = "data-sd-superdoc-media";
function collectReferencedImageMediaForClipboard(sliceJsonString, editor) {
	if (!sliceJsonString || !editor?.storage?.image?.media) return "";
	let slice;
	try {
		slice = JSON.parse(sliceJsonString);
	} catch {
		return "";
	}
	const source = editor.storage.image.media;
	const out = {};
	const visit = (node) => {
		if (!node || typeof node !== "object") return;
		if (node.type === "image") {
			const src = node.attrs?.src;
			if (typeof src === "string" && src.length > 0) {
				const val = source[src];
				if (typeof val === "string" && val.length > 0) out[src] = val;
			}
		}
		if (node.type === "shapeGroup" && Array.isArray(node.attrs?.shapes)) for (const shape of node.attrs.shapes) {
			const src = shape?.attrs?.src;
			if (typeof src === "string" && src.length > 0) {
				const val = source[src];
				if (typeof val === "string" && val.length > 0) out[src] = val;
			}
		}
		const { content: content$2 } = node;
		if (Array.isArray(content$2)) for (const child of content$2) visit(child);
	};
	if (Array.isArray(slice.content)) for (const node of slice.content) visit(node);
	return Object.keys(out).length > 0 ? JSON.stringify(out) : "";
}
function allocateUniqueMediaPath(originalPath, store, reserved) {
	const extMatch = originalPath.match(/(\.[^./]+)$/);
	const ext = extMatch ? extMatch[1] : "";
	const dirMatch = originalPath.match(/^(.*\/)/);
	const dir = dirMatch ? dirMatch[1] : "word/media/";
	const id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
	let candidate = `${dir}sd-paste-${id}${ext}`;
	let n = 0;
	while (store[candidate] != null && store[candidate] !== "" || reserved.has(candidate)) {
		candidate = `${dir}sd-paste-${id}-${n}${ext}`;
		n += 1;
	}
	reserved.add(candidate);
	return candidate;
}
function rewriteImageSrcsInSliceJsonTree(node, pathRemap) {
	if (!node || typeof node !== "object") return;
	if (node.type === "image" && node.attrs && typeof node.attrs.src === "string") {
		const next = pathRemap.get(node.attrs.src);
		if (next) node.attrs = {
			...node.attrs,
			src: next
		};
	}
	if (node.type === "shapeGroup" && Array.isArray(node.attrs?.shapes)) node.attrs = {
		...node.attrs,
		shapes: node.attrs.shapes.map((shape) => {
			if (!shape || typeof shape !== "object" || !shape.attrs || typeof shape.attrs.src !== "string") return shape;
			const next = pathRemap.get(shape.attrs.src);
			if (!next) return shape;
			return {
				...shape,
				attrs: {
					...shape.attrs,
					src: next
				}
			};
		})
	};
	const { content: content$2 } = node;
	if (Array.isArray(content$2)) for (const child of content$2) rewriteImageSrcsInSliceJsonTree(child, pathRemap);
}
function applySuperdocClipboardMedia(editor, clipboardData, sliceJson = null, mediaJson = "") {
	const raw = clipboardData?.getData?.("application/x-superdoc-media") || mediaJson;
	if (!editor?.storage?.image || !raw || typeof raw !== "string") return sliceJson;
	let map;
	try {
		map = JSON.parse(raw);
	} catch {
		return sliceJson;
	}
	if (!map || typeof map !== "object") return sliceJson;
	const entries = Object.entries(map).filter(([p, d]) => typeof p === "string" && p && typeof d === "string" && d);
	if (entries.length === 0) return sliceJson;
	if (!editor.storage.image.media) editor.storage.image.media = {};
	const store = editor.storage.image.media;
	const yMedia = editor.options?.ydoc?.getMap?.("media");
	const renames = /* @__PURE__ */ new Map();
	const reserved = /* @__PURE__ */ new Set();
	for (const [path, data] of entries) {
		const existing = store[path];
		if (existing != null && existing !== "" && existing !== data) renames.set(path, allocateUniqueMediaPath(path, store, reserved));
	}
	let outSlice = sliceJson;
	if (renames.size > 0 && sliceJson) try {
		const slice = JSON.parse(sliceJson);
		if (Array.isArray(slice.content)) for (const node of slice.content) rewriteImageSrcsInSliceJsonTree(node, renames);
		outSlice = JSON.stringify(slice);
	} catch {
		outSlice = sliceJson;
	}
	for (const [path, data] of entries) {
		const key = renames.get(path) ?? path;
		store[key] = data;
		yMedia?.set?.(key, data);
	}
	return outSlice;
}
function bodySectPrShouldEmbed(bodySectPr) {
	if (!bodySectPr || typeof bodySectPr !== "object") return false;
	const cols = getSectPrColumns(bodySectPr);
	return !!(cols?.count && cols.count > 1);
}
function hiddenClipboardPayload(attr, base64) {
	return `<div ${attr}="${base64}" style="display:none"></div>`;
}
function readClipboardPayload(el, attr) {
	return el.getAttribute(attr)?.trim() || el.textContent?.trim() || "";
}
function embedSliceInHtml(html, sliceJson, bodySectPrJson = "", mediaJson = "") {
	let out = html;
	if (bodySectPrJson) out = `${hiddenClipboardPayload(SUPERDOC_BODY_SECT_PR_ATTR, encodeUtf8Base64(bodySectPrJson))}${out}`;
	if (mediaJson) out = `${hiddenClipboardPayload(SUPERDOC_MEDIA_ATTR, encodeUtf8Base64(mediaJson))}${out}`;
	if (!sliceJson) return out;
	return `${hiddenClipboardPayload(SUPERDOC_SLICE_ATTR, encodeUtf8Base64(sliceJson))}${out}`;
}
function extractSliceFromHtml(html) {
	if (!html || !html.includes("data-superdoc-slice")) return null;
	if (typeof DOMParser === "undefined") return null;
	try {
		const el = new DOMParser().parseFromString(html, "text/html").querySelector(`[${SUPERDOC_SLICE_ATTR}]`);
		if (!el) return null;
		const b64 = readClipboardPayload(el, SUPERDOC_SLICE_ATTR);
		if (!b64) return null;
		return decodeUtf8Base64(b64) || null;
	} catch {
		return null;
	}
}
function stripSliceFromHtml(html) {
	if (!html) return html;
	let out = html;
	if (out.includes("data-superdoc-slice")) out = out.replace(/<div[^>]*data-superdoc-slice[^>]*>[\s\S]*?<\/div>/gi, "");
	if (out.includes("data-sd-body-sect-pr")) out = out.replace(/<div[^>]*data-sd-body-sect-pr[^>]*>[\s\S]*?<\/div>/gi, "");
	if (out.includes("data-sd-superdoc-media")) out = out.replace(/<div[^>]*data-sd-superdoc-media[^>]*>[\s\S]*?<\/div>/gi, "");
	return out;
}
function extractMediaFromHtml(html) {
	if (!html || !html.includes("data-sd-superdoc-media")) return null;
	if (typeof DOMParser === "undefined") return null;
	try {
		const el = new DOMParser().parseFromString(html, "text/html").querySelector(`[${SUPERDOC_MEDIA_ATTR}]`);
		if (!el) return null;
		const b64 = readClipboardPayload(el, SUPERDOC_MEDIA_ATTR);
		if (!b64) return null;
		return decodeUtf8Base64(b64) || null;
	} catch {
		return null;
	}
}
function extractBodySectPrFromHtml(html) {
	if (!html || !html.includes("data-sd-body-sect-pr")) return null;
	if (typeof DOMParser === "undefined") return null;
	try {
		const el = new DOMParser().parseFromString(html, "text/html").querySelector(`[${SUPERDOC_BODY_SECT_PR_ATTR}]`);
		if (!el) return null;
		const b64 = readClipboardPayload(el, SUPERDOC_BODY_SECT_PR_ATTR);
		if (!b64) return null;
		return JSON.parse(decodeUtf8Base64(b64));
	} catch {
		return null;
	}
}
function annotateFragmentDomWithClipboardData(container, fragment, editor) {
	if (!editor) return;
	const domChildren = Array.from(container.children);
	let domIndex$1 = 0;
	fragment.forEach((pmNode) => {
		const domEl = domChildren[domIndex$1++];
		if (!domEl) return;
		annotatePmNodeOnClipboardDom(domEl, pmNode, editor);
	});
}
function mergeSerializedClipboardMetadataIntoDomContainer(container, view, editor) {
	if (!editor || !view || typeof document === "undefined") return;
	const { from, to } = view.state.selection;
	if (from === to) return;
	const fragment = view.state.doc.slice(from, to).content;
	const mirror = document.createElement("div");
	mirror.appendChild(DOMSerializer.fromSchema(view.state.schema).serializeFragment(fragment));
	annotateFragmentDomWithClipboardData(mirror, fragment, editor);
	copyParagraphClipboardAttrsParallel(container, mirror);
}
var PARAGRAPH_CLIPBOARD_ATTRS = [
	"data-num-id",
	"data-level",
	"data-list-numbering-type",
	"data-indent",
	"data-spacing",
	"styleid",
	"data-justification",
	"data-marker-type",
	"data-list-level",
	"data-num-fmt",
	"data-lvl-text"
];
function copyParagraphClipboardAttrsParallel(target, source) {
	const src = source.querySelectorAll("p");
	const dst = target.querySelectorAll("p");
	const n = Math.min(src.length, dst.length);
	for (let i$1 = 0; i$1 < n; i$1 += 1) for (const attr of PARAGRAPH_CLIPBOARD_ATTRS) if (src[i$1].hasAttribute(attr)) dst[i$1].setAttribute(attr, src[i$1].getAttribute(attr) || "");
}
function annotatePmNodeOnClipboardDom(domEl, pmNode, editor) {
	if (pmNode.type.name === "paragraph") {
		const props = pmNode.attrs.paragraphProperties;
		if (props) {
			if (props.numberingProperties?.numId != null) domEl.setAttribute("data-num-id", String(props.numberingProperties.numId));
			if (props.numberingProperties?.ilvl != null) domEl.setAttribute("data-level", String(props.numberingProperties.ilvl));
			if (props.indent && Object.keys(props.indent).length) domEl.setAttribute("data-indent", JSON.stringify(props.indent));
			if (props.spacing && Object.keys(props.spacing).length) domEl.setAttribute("data-spacing", JSON.stringify(props.spacing));
			if (props.styleId) domEl.setAttribute("styleid", props.styleId);
			if (props.justification) domEl.setAttribute("data-justification", props.justification);
		}
		if (!domEl.hasAttribute("data-list-numbering-type") || !domEl.getAttribute("data-list-numbering-type")) {
			const numId = props?.numberingProperties?.numId;
			const level = props?.numberingProperties?.ilvl ?? 0;
			if (numId != null) {
				const lr = pmNode.attrs.listRendering;
				if (lr?.numberingType) domEl.setAttribute("data-list-numbering-type", lr.numberingType);
				else try {
					const details = ListHelpers.getListDefinitionDetails({
						numId,
						level,
						editor
					});
					if (details?.listNumberingType) domEl.setAttribute("data-list-numbering-type", details.listNumberingType);
				} catch {}
			}
		}
		return;
	}
	if (pmNode.type.name === "table") {
		const tbody = domEl.querySelector("tbody");
		const rowElements = tbody ? Array.from(tbody.children).filter((el) => el.tagName.toLowerCase() === "tr") : [];
		let rowIndex = 0;
		pmNode.forEach((row) => {
			if (row.isInline) return;
			const rowDom = rowElements[rowIndex++];
			if (rowDom) annotatePmNodeOnClipboardDom(rowDom, row, editor);
		});
		return;
	}
	if (pmNode.isInline || !pmNode.childCount || !domEl.children.length) return;
	const childDoms = Array.from(domEl.children);
	let childIndex = 0;
	pmNode.forEach((child) => {
		if (child.isInline) return;
		const childDom = childDoms[childIndex++];
		if (childDom) annotatePmNodeOnClipboardDom(childDom, child, editor);
	});
}
function isSuperdocOriginClipboardHtml(html) {
	if (!html || typeof html !== "string") return false;
	if (html.includes("data-superdoc-slice") || html.includes("data-sd-body-sect-pr") || html.includes("data-sd-superdoc-media")) return true;
	if (/data-sd-sect-pr\s*=/i.test(html)) return true;
	if (/data-sd-block-id\s*=/i.test(html)) return true;
	if (/data-num-id\s*=/i.test(html) && (/data-level\s*=/i.test(html) || /data-list-numbering-type\s*=/i.test(html) || /data-list-level\s*=/i.test(html))) return true;
	return false;
}
function applyEmbeddedBodySectPrWhenAllowed(editor, bodySectPr, docForCurrentAttrs, applyClone) {
	if (!bodySectPr || typeof bodySectPr !== "object") return;
	const incomingCols = getSectPrColumns(bodySectPr);
	if (!incomingCols?.count || incomingCols.count <= 1) return;
	const current = docForCurrentAttrs.attrs?.bodySectPr;
	if ((current && getSectPrColumns(current))?.count > 1) return;
	const clone = JSON.parse(JSON.stringify(bodySectPr));
	applyClone(clone);
	if (editor?.converter) editor.converter.bodySectPr = clone;
}
function tryApplyEmbeddedBodySectPr(editor, view, bodySectPr) {
	applyEmbeddedBodySectPrWhenAllowed(editor, bodySectPr, view.state.doc, (clone) => {
		view.dispatch(view.state.tr.setDocAttribute("bodySectPr", clone));
	});
}
function applyEmbeddedBodySectPrToTransaction(editor, tr, bodySectPr, docBeforePaste) {
	applyEmbeddedBodySectPrWhenAllowed(editor, bodySectPr, docBeforePaste, (clone) => {
		tr.setDocAttribute("bodySectPr", clone);
	});
}
var InputRule = class {
	match;
	handler;
	constructor(config$43) {
		this.match = config$43.match;
		this.handler = config$43.handler;
	}
};
var inputRuleMatcherHandler = (text$2, match) => {
	if (isRegExp(match)) return match.exec(text$2);
	const inputRuleMatch = match(text$2);
	if (!inputRuleMatch) return null;
	const result = [inputRuleMatch.text];
	result.index = inputRuleMatch.index;
	result.input = text$2;
	result.data = inputRuleMatch.data;
	if (inputRuleMatch.replaceWith) {
		if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn("[super-editor warn]: \"inputRuleMatch.replaceWith\" must be part of \"inputRuleMatch.text\".");
		result.push(inputRuleMatch.replaceWith);
	}
	return result;
};
var run = (config$43) => {
	const { editor, from, to, text: text$2, rules, plugin } = config$43;
	const { view } = editor;
	if (view.composing) return false;
	const $from = view.state.doc.resolve(from);
	if ($from.parent.type.spec.code || !!($from.nodeBefore || $from.nodeAfter)?.marks.find((mark) => mark.type.spec.code)) return false;
	let matched = false;
	const textBefore = getTextContentFromNodes($from) + text$2;
	rules.forEach((rule) => {
		if (matched) return;
		const match = inputRuleMatcherHandler(textBefore, rule.match);
		if (!match) return;
		const tr = view.state.tr;
		const state = chainableEditorState(tr, view.state);
		const range = {
			from: from - (match[0].length - text$2.length),
			to
		};
		const { commands, chain, can } = new CommandService({
			editor,
			state
		});
		if (rule.handler({
			state,
			range,
			match,
			commands,
			chain,
			can
		}) === null || !tr.steps.length) return;
		tr.setMeta(plugin, {
			transform: tr,
			from,
			to,
			text: text$2
		});
		view.dispatch(tr);
		matched = true;
	});
	return matched;
};
const inputRulesPlugin = ({ editor, rules }) => {
	const plugin = new Plugin({
		key: new PluginKey("inputRulesPlugin"),
		state: {
			init() {
				return null;
			},
			apply(tr, prev, state) {
				const stored = tr.getMeta(plugin);
				if (stored) return stored;
				const simulatedInputMeta = tr.getMeta("applyInputRules");
				if (!!simulatedInputMeta) setTimeout(() => {
					let { text: text$2 } = simulatedInputMeta;
					if (typeof text$2 !== "string") {
						const domDocument = editor?.options?.document ?? editor?.options?.mockDocument ?? (typeof document !== "undefined" ? document : null);
						if (!domDocument) {
							warnNoDOM("HTML conversion for input rules");
							return;
						}
						text$2 = getHTMLFromFragment(Fragment.from(text$2), state.schema, domDocument);
					}
					const { from } = simulatedInputMeta;
					run({
						editor,
						from,
						to: from + text$2.length,
						text: text$2,
						rules,
						plugin
					});
				});
				return tr.selectionSet || tr.docChanged ? null : prev;
			}
		},
		props: {
			handleDOMEvents: { cut: (view, event) => handleCutEvent(view, event, editor) },
			handleTextInput(view, from, to, text$2) {
				return run({
					editor,
					from,
					to,
					text: text$2,
					rules,
					plugin
				});
			},
			handleKeyDown(view, event) {
				if (event.key !== "Enter") return false;
				const { $cursor } = view.state.selection;
				if ($cursor) return run({
					editor,
					from: $cursor.pos,
					to: $cursor.pos,
					text: "\n",
					rules,
					plugin
				});
				return false;
			},
			handlePaste(view, event, slice) {
				const clipboard = event.clipboardData;
				if (slice.content.content.filter((item) => item.type.name === "fieldAnnotation").length) return false;
				const rawHtml = clipboard.getData("text/html");
				const isSuperdocHtml = isSuperdocOriginClipboardHtml(rawHtml);
				const embeddedBodySectPr = isSuperdocHtml ? extractBodySectPrFromHtml(rawHtml) : null;
				const embeddedMedia = isSuperdocHtml ? extractMediaFromHtml(rawHtml) : "";
				let superdocSliceData = clipboard.getData("application/x-superdoc-slice") || extractSliceFromHtml(rawHtml);
				if (isSuperdocHtml || superdocSliceData) superdocSliceData = applySuperdocClipboardMedia(editor, clipboard, superdocSliceData || null, embeddedMedia);
				if (superdocSliceData) try {
					if (handleSuperdocSlicePaste(superdocSliceData, editor, view, embeddedBodySectPr)) return true;
				} catch (err$1) {
					console.warn("Failed to paste SuperDoc slice, falling back to HTML:", err$1);
				}
				const html = stripSliceFromHtml(rawHtml);
				const plainText = clipboard.getData("text/plain");
				if (isSuperdocHtml) {
					const ok = handleHtmlPaste(html, editor);
					if (ok && embeddedBodySectPr) tryApplyEmbeddedBodySectPr(editor, view, embeddedBodySectPr);
					return ok;
				}
				return handleClipboardPaste({
					editor,
					view
				}, html, plainText);
			}
		},
		isInputRules: true
	});
	return plugin;
};
function isWordHtml(html) {
	return /class=["']?Mso|xmlns:o=["']?urn:schemas-microsoft-com|<!--\[if gte mso|<meta[^>]+name=["']?Generator["']?[^>]+Word/i.test(html);
}
function isGoogleDocsHtml(html) {
	return /docs-internal-guid-/.test(html);
}
function findParagraphAncestor($from) {
	for (let d = $from.depth; d >= 0; d--) {
		const node = $from.node(d);
		if (node.type.name === "paragraph") return {
			node,
			depth: d
		};
	}
	return {
		node: null,
		depth: -1
	};
}
function getTableRowSignature(tableRow) {
	const parts = [];
	tableRow.forEach((cell) => {
		parts.push(`${cell.attrs?.colspan ?? 1}:${cell.attrs?.rowspan ?? 1}`);
	});
	return parts.join("|");
}
function mergeAdjacentTableFragments(doc$2) {
	if (!doc$2?.childCount) return doc$2;
	const mergedChildren = [];
	doc$2.forEach((child) => {
		const previous$1 = mergedChildren[mergedChildren.length - 1];
		if (child.type.name !== "table" || previous$1?.type.name !== "table") {
			mergedChildren.push(child);
			return;
		}
		const previousFirstRow = previous$1.firstChild;
		const currentFirstRow = child.firstChild;
		if (!previousFirstRow || !currentFirstRow) {
			mergedChildren.push(child);
			return;
		}
		if (getTableRowSignature(previousFirstRow) !== getTableRowSignature(currentFirstRow)) {
			mergedChildren.push(child);
			return;
		}
		const combinedRows = [];
		previous$1.forEach((row) => combinedRows.push(row));
		child.forEach((row) => combinedRows.push(row));
		mergedChildren[mergedChildren.length - 1] = previous$1.type.create(previous$1.attrs, combinedRows, previous$1.marks);
	});
	return doc$2.copy(Fragment.fromArray(mergedChildren));
}
function handleHtmlPaste(html, editor, source) {
	let cleanedHtml;
	if (source === "google-docs") cleanedHtml = handleGoogleDocsHtml(html, editor);
	else cleanedHtml = htmlHandler(html, editor);
	if (cleanedHtml?.dataset) cleanedHtml.dataset.superdocImport = "true";
	let doc$2 = DOMParser$1.fromSchema(editor.schema).parse(cleanedHtml);
	doc$2 = mergeAdjacentTableFragments(doc$2);
	doc$2 = wrapTextsInRuns(doc$2);
	const { dispatch, state } = editor.view;
	if (!dispatch) return false;
	const { $from } = state.selection;
	const { node: paragraphNode } = findParagraphAncestor($from);
	const isInParagraph = paragraphNode !== null;
	const isSingleParagraph = doc$2.childCount === 1 && doc$2.firstChild.type.name === "paragraph";
	const sourceStyleId = isSingleParagraph ? doc$2.firstChild.attrs?.paragraphProperties?.styleId ?? null : null;
	const sourceIsHeading = typeof sourceStyleId === "string" && /^Heading[1-9]$/i.test(sourceStyleId);
	if (isInParagraph && isSingleParagraph && !sourceIsHeading) {
		const paragraphContent = doc$2.firstChild.content;
		const tr = state.tr.replaceSelectionWith(paragraphContent, false);
		normalizePastedLinks(tr, editor);
		dispatch(tr);
	} else if (isInParagraph) {
		const slice = new Slice(doc$2.content, 0, 0);
		const tr = state.tr.replaceSelection(slice);
		normalizePastedLinks(tr, editor);
		dispatch(tr);
	} else {
		const tr = state.tr.replaceSelectionWith(doc$2, true);
		normalizePastedLinks(tr, editor);
		dispatch(tr);
	}
	return true;
}
function htmlHandler(html, editor, domDocument) {
	const resolvedDocument = domDocument ?? editor?.options?.document ?? editor?.options?.mockDocument ?? (typeof document !== "undefined" ? document : null);
	return sanitizeHtml(convertEmToPt(flattenListsInHtml(html, editor, resolvedDocument)), void 0, resolvedDocument);
}
const convertEmToPt = (html) => {
	return html.replace(/font-size\s*:\s*([\d.]+)em/gi, (_, emValue) => {
		const em = parseFloat(emValue);
		return `font-size: ${Math.round(em * 12 * 100) / 100}pt`;
	});
};
function cleanHtmlUnnecessaryTags(html) {
	return html.replace(/<o:p>.*?<\/o:p>/gi, "").replace(/&nbsp;/gi, " ").replace(/<span[^>]*>\s*<\/span>/gi, "").replace(/<p[^>]*>\s*<\/p>/gi, "").trim();
}
function sanitizeHtml(html, forbiddenTags = [
	"meta",
	"svg",
	"script",
	"style",
	"button"
], domDocument) {
	const resolvedDocument = domDocument ?? (typeof document !== "undefined" ? document : null);
	if (!resolvedDocument) {
		console.warn("[super-editor] HTML sanitization requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment. Skipping sanitization.");
		return null;
	}
	const container = resolvedDocument.createElement("div");
	container.innerHTML = html;
	const domNode = resolvedDocument.defaultView?.Node ?? globalThis.Node;
	const COMMENT_NODE = domNode?.COMMENT_NODE ?? 8;
	const ELEMENT_NODE = domNode?.ELEMENT_NODE ?? 1;
	const stripWordListConditionalPrefixes = (root) => {
		const stripFromNode = (node) => {
			if (!node?.childNodes) return;
			for (let i$1 = 0; i$1 < node.childNodes.length; i$1 += 1) {
				const current = node.childNodes[i$1];
				if (current?.nodeType === COMMENT_NODE && current.nodeValue?.includes("[if !supportLists]")) {
					const nodesToStrip = [];
					let endifComment = null;
					for (let j = i$1 + 1; j < node.childNodes.length; j += 1) {
						const next = node.childNodes[j];
						if (next?.nodeType === COMMENT_NODE && next.nodeValue?.includes("[endif]")) {
							endifComment = next;
							break;
						}
						nodesToStrip.push(next);
					}
					if (!endifComment) {
						node.removeChild(current);
						i$1 -= 1;
						continue;
					}
					for (const n of nodesToStrip) node.removeChild(n);
					node.removeChild(endifComment);
					node.removeChild(current);
					i$1 -= 1;
					continue;
				}
				if (current?.nodeType === ELEMENT_NODE) stripFromNode(current);
			}
		};
		stripFromNode(root);
	};
	stripWordListConditionalPrefixes(container);
	const walkAndClean = (node) => {
		for (const child of [...node.children]) {
			if (forbiddenTags.includes(child.tagName.toLowerCase())) {
				child.remove();
				continue;
			}
			if (child.hasAttribute("linebreaktype")) child.removeAttribute("linebreaktype");
			if (child.hasAttribute("data-sd-block-id")) child.removeAttribute("data-sd-block-id");
			walkAndClean(child);
		}
	};
	walkAndClean(container);
	return container;
}
function handleClipboardPaste({ editor, view }, html, plainText) {
	const rawHtml = html || "";
	const isSuperdocHtml = isSuperdocOriginClipboardHtml(rawHtml);
	const embeddedBodySectPr = isSuperdocHtml ? extractBodySectPrFromHtml(rawHtml) : null;
	const embeddedMedia = isSuperdocHtml ? extractMediaFromHtml(rawHtml) : "";
	let pasteHtml = rawHtml;
	let superdocSliceData = extractSliceFromHtml(rawHtml);
	if (superdocSliceData) {
		superdocSliceData = applySuperdocClipboardMedia(editor, null, superdocSliceData, embeddedMedia);
		try {
			if (handleSuperdocSlicePaste(superdocSliceData, editor, view, embeddedBodySectPr)) return true;
		} catch (err$1) {
			console.warn("Failed to paste SuperDoc slice, falling back to HTML:", err$1);
		}
	}
	if (isSuperdocHtml) pasteHtml = stripSliceFromHtml(rawHtml);
	let source;
	if (!pasteHtml) source = "plain-text";
	else if (isWordHtml(pasteHtml)) source = "word-html";
	else if (isGoogleDocsHtml(pasteHtml)) source = "google-docs";
	else source = "browser-html";
	switch (source) {
		case "plain-text": {
			const detected = detectPasteUrl(plainText, resolveLinkProtocols(editor));
			if (!detected) return false;
			return handlePlainTextUrlPaste(editor, view, plainText, detected);
		}
		case "word-html":
			if (editor.options.mode === "docx" && !isSuperdocHtml) return handleDocxPaste(pasteHtml, editor, view);
			{
				const ok = handleHtmlPaste(pasteHtml, editor);
				if (ok && embeddedBodySectPr) tryApplyEmbeddedBodySectPr(editor, view, embeddedBodySectPr);
				return ok;
			}
		case "google-docs": {
			const ok = handleGoogleDocsHtml(pasteHtml, editor, view);
			if (ok && embeddedBodySectPr) tryApplyEmbeddedBodySectPr(editor, view, embeddedBodySectPr);
			return ok;
		}
		case "browser-html": {
			const ok = handleHtmlPaste(pasteHtml, editor);
			if (ok && embeddedBodySectPr) tryApplyEmbeddedBodySectPr(editor, view, embeddedBodySectPr);
			return ok;
		}
	}
	return false;
}
function handleCutEvent(view, event, editor) {
	const clipboardData = event.clipboardData;
	if (!clipboardData) return false;
	const { from, to } = view.state.selection;
	if (from === to) return false;
	try {
		const slice = view.state.doc.slice(from, to);
		const fragment = slice.content;
		const sliceJson = JSON.stringify(slice.toJSON());
		clipboardData.setData(SUPERDOC_SLICE_MIME, sliceJson);
		const mediaJson = collectReferencedImageMediaForClipboard(sliceJson, editor);
		if (mediaJson) clipboardData.setData(SUPERDOC_MEDIA_MIME, mediaJson);
		const div = document.createElement("div");
		const serializer = DOMSerializer.fromSchema(view.state.schema);
		div.appendChild(serializer.serializeFragment(fragment));
		annotateFragmentDomWithClipboardData(div, fragment, editor);
		const html = unflattenListsInHtml(div.innerHTML);
		const bodySectPr = view.state.doc.attrs?.bodySectPr;
		const bodySectPrJson = bodySectPr && bodySectPrShouldEmbed(bodySectPr) ? JSON.stringify(bodySectPr) : "";
		clipboardData.setData("text/html", embedSliceInHtml(html, sliceJson, bodySectPrJson, mediaJson));
		clipboardData.setData("text/plain", fragment.textBetween(0, fragment.size, "\n\n"));
		event.preventDefault();
		view.dispatch(view.state.tr.deleteSelection().scrollIntoView());
		return true;
	} catch (error) {
		console.warn("Failed to handle cut:", error);
		return false;
	}
}
var BULLET_MARKER_CHARS = new Set([
	"•",
	"◦",
	"▪",
	"•",
	"◦",
	"▪"
]);
function numberingFmtForSliceRemap(lr) {
	if (lr?.numberingType) return lr.numberingType;
	const marker = (lr?.markerText || "").trim();
	if (marker && BULLET_MARKER_CHARS.has(marker)) return "bullet";
	return "decimal";
}
function lvlTextForRemap(fmt, ilvl, lr) {
	if (fmt === "bullet") return lr?.markerText?.trim() || "•";
	const stored = lr?.markerText;
	if (stored?.includes?.("%")) return stored;
	return `%${ilvl + 1}.`;
}
function remapPastedListNumberingInFragment(fragment, editor) {
	if (!editor?.converter || !fragment.size) return fragment;
	const paragraphMeta = [];
	const collect = (node) => {
		if (node.type.name === "paragraph") {
			const np = node.attrs.paragraphProperties?.numberingProperties;
			if (np?.numId != null) {
				const oldId = Number(np.numId);
				if (Number.isFinite(oldId)) {
					const rawIlvl = Number(np.ilvl ?? 0);
					const ilvl = Number.isFinite(rawIlvl) ? rawIlvl : 0;
					const lr = node.attrs.listRendering;
					const fmt = numberingFmtForSliceRemap(lr);
					const path = Array.isArray(lr?.path) ? lr.path.map((n) => Number(n)) : null;
					paragraphMeta.push({
						oldId,
						ilvl,
						fmt,
						lr,
						path
					});
				}
			}
		}
		if (node.content?.size) node.content.forEach((child) => collect(child));
	};
	fragment.forEach((node) => collect(node));
	if (paragraphMeta.length === 0) return fragment;
	const oldToNew = /* @__PURE__ */ new Map();
	const allocateListId = createListIdAllocator(editor);
	for (const { oldId } of paragraphMeta) if (!oldToNew.has(oldId)) oldToNew.set(oldId, allocateListId());
	const generatedLevels = /* @__PURE__ */ new Set();
	for (const { oldId, ilvl, fmt, lr, path } of paragraphMeta) {
		const newId = oldToNew.get(oldId);
		const genKey = `${newId}:${ilvl}`;
		if (generatedLevels.has(genKey)) continue;
		const listType = fmt === "bullet" ? "bulletList" : "orderedList";
		let start = 1;
		if (Array.isArray(path) && path.length) {
			const atLevel = path[ilvl];
			const parsedAt = Number(atLevel);
			if (Number.isFinite(parsedAt)) start = parsedAt;
			else {
				const tail = Number(path[path.length - 1]);
				if (Number.isFinite(tail)) start = tail;
			}
		}
		const lvlText = lvlTextForRemap(fmt, ilvl, lr);
		ListHelpers.generateNewListDefinition({
			numId: newId,
			listType,
			level: String(ilvl),
			start: String(start),
			text: lvlText,
			fmt,
			editor
		});
		if (start > 1) ListHelpers.setLvlOverride(editor, newId, ilvl, { startOverride: start });
		generatedLevels.add(genKey);
	}
	const rewriteFragment = (frag) => {
		const out = [];
		frag.forEach((node) => {
			out.push(rewriteNode(node));
		});
		return Fragment.fromArray(out);
	};
	const rewriteNode = (node) => {
		if (node.type.name === "paragraph") {
			const np = node.attrs.paragraphProperties?.numberingProperties;
			if (np?.numId != null) {
				const oldId = Number(np.numId);
				if (oldToNew.has(oldId)) {
					const nextNp = {
						...np,
						numId: oldToNew.get(oldId)
					};
					const pp = {
						...node.attrs.paragraphProperties,
						numberingProperties: nextNp
					};
					const attrs = {
						...node.attrs,
						paragraphProperties: pp
					};
					return node.type.create(attrs, node.content, node.marks);
				}
			}
			return node;
		}
		if (node.content?.size) {
			const nextContent = rewriteFragment(node.content);
			if (nextContent !== node.content) return node.copy(nextContent);
		}
		return node;
	};
	return rewriteFragment(fragment);
}
function handleSuperdocSlicePaste(sliceData, editor, view, embeddedBodySectPr = null) {
	const sliceJson = JSON.parse(sliceData);
	const slice = Slice.fromJSON(editor.schema, sliceJson);
	if (!slice.content.size) return false;
	const cleanSlice = new Slice(remapPastedListNumberingInFragment(stripSuperdocSliceBlockIdentities(slice.content), editor), slice.openStart, slice.openEnd);
	const { dispatch, state } = view;
	if (!dispatch) return false;
	const tr = state.tr.replaceSelection(cleanSlice);
	tr.setMeta("superdocSlicePaste", true);
	normalizePastedLinks(tr, editor);
	if (embeddedBodySectPr) applyEmbeddedBodySectPrToTransaction(editor, tr, embeddedBodySectPr, state.doc);
	dispatch(tr.scrollIntoView());
	return true;
}
var SUPERDOC_SLICE_PASTE_IDENTITY_RESETS = {
	paragraph: {
		paraId: null,
		sdBlockId: null,
		sdBlockRev: 0
	},
	table: {
		paraId: null,
		sdBlockId: null
	},
	tableRow: {
		paraId: null,
		sdBlockId: null
	},
	tableCell: {
		paraId: null,
		sdBlockId: null
	},
	tableHeader: { sdBlockId: null },
	structuredContentBlock: { id: null },
	documentSection: {
		id: null,
		sdBlockId: null
	},
	documentPartObject: {
		id: null,
		sdBlockId: null
	},
	tableOfContents: { sdBlockId: null }
};
function stripSuperdocSliceBlockIdentities(fragment) {
	const children = [];
	fragment.forEach((node) => {
		const resets = SUPERDOC_SLICE_PASTE_IDENTITY_RESETS[node.type.name];
		let newContent = node.content;
		if (node.childCount) {
			const strippedChildren = stripSuperdocSliceBlockIdentities(node.content);
			if (strippedChildren !== node.content) newContent = strippedChildren;
		}
		let newNode = node;
		if (resets) {
			const cleanAttrs = {
				...node.attrs,
				...resets
			};
			newNode = node.type.create(cleanAttrs, newContent, node.marks);
		} else if (newContent !== node.content) newNode = node.copy(newContent);
		children.push(newNode);
	});
	return Fragment.fromArray(children);
}
var MAX_OUTER_HTML_LENGTH = 200;
function detectUnsupportedContent(element, schema) {
	const itemsByTag = /* @__PURE__ */ new Map();
	scanForUnsupported(element, collectKnownTags(schema), itemsByTag);
	return Array.from(itemsByTag.values());
}
var knownTagsCache = /* @__PURE__ */ new WeakMap();
function collectKnownTags(schema) {
	const cached = knownTagsCache.get(schema);
	if (cached) return cached;
	const tags = /* @__PURE__ */ new Set();
	for (const nodeType of Object.values(schema.nodes)) {
		const raw = nodeType.spec.parseDOM;
		if (!raw) continue;
		const rules = typeof raw === "function" ? raw() : raw;
		for (const rule of rules) if (rule.tag) {
			const match = rule.tag.match(/^([a-zA-Z][a-zA-Z0-9-]*)/);
			if (match) tags.add(match[1].toUpperCase());
		}
	}
	for (const markType of Object.values(schema.marks)) {
		const raw = markType.spec.parseDOM;
		if (!raw) continue;
		const rules = typeof raw === "function" ? raw() : raw;
		for (const rule of rules) if (rule.tag) {
			const match = rule.tag.match(/^([a-zA-Z][a-zA-Z0-9-]*)/);
			if (match) tags.add(match[1].toUpperCase());
		}
	}
	for (const tag of [
		"HTML",
		"HEAD",
		"BODY",
		"DIV",
		"SPAN"
	]) tags.add(tag);
	knownTagsCache.set(schema, tags);
	return tags;
}
function scanForUnsupported(element, knownTags, itemsByTag) {
	for (let i$1 = 0; i$1 < element.children.length; i$1++) {
		const child = element.children[i$1];
		const tag = child.tagName.toUpperCase();
		if (!knownTags.has(tag)) {
			if (hasPreservableContent(child, knownTags)) {
				scanForUnsupported(child, knownTags, itemsByTag);
				continue;
			}
			const existing = itemsByTag.get(tag);
			if (existing) existing.count++;
			else {
				let outerHTML = child.outerHTML;
				if (outerHTML.length > MAX_OUTER_HTML_LENGTH) outerHTML = outerHTML.slice(0, MAX_OUTER_HTML_LENGTH) + "…";
				itemsByTag.set(tag, {
					tagName: tag,
					outerHTML,
					count: 1
				});
			}
		} else scanForUnsupported(child, knownTags, itemsByTag);
	}
}
function hasPreservableContent(element, knownTags) {
	if (element.textContent && element.textContent.trim().length > 0) return true;
	for (let i$1 = 0; i$1 < element.children.length; i$1++) {
		const child = element.children[i$1];
		if (knownTags.has(child.tagName.toUpperCase())) return true;
		if (hasPreservableContent(child, knownTags)) return true;
	}
	return false;
}
function createDocFromHTML(content$2, editor, options = {}) {
	const { isImport = false } = options;
	let parsedContent;
	let domDocument = options.document ?? editor?.options?.document ?? editor?.options?.mockDocument ?? (typeof document !== "undefined" ? document : null);
	if (typeof content$2 === "string") {
		const tempDiv = htmlHandler(stripHtmlStyles(content$2, domDocument), editor, domDocument);
		if (isImport) tempDiv.dataset.superdocImport = "true";
		parsedContent = tempDiv;
	} else parsedContent = content$2;
	const domElement = parsedContent?.ownerDocument?.defaultView?.Element ?? domDocument?.defaultView?.Element ?? globalThis.Element;
	const parsedElement = (options.onUnsupportedContent || options.warnOnUnsupportedContent) && domElement && parsedContent instanceof domElement ? parsedContent : null;
	if (parsedElement) {
		const unsupported = detectUnsupportedContent(parsedElement, editor.schema);
		if (unsupported.length > 0) if (options.onUnsupportedContent) options.onUnsupportedContent(unsupported);
		else console.warn("[super-editor] Unsupported HTML content dropped during import:", unsupported);
	}
	let doc$2 = DOMParser$1.fromSchema(editor.schema).parse(parsedContent);
	doc$2 = wrapTextsInRuns(doc$2);
	return doc$2;
}
const content = { tokenize: initializeContent };
function initializeContent(effects) {
	const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
	let previous$1;
	return contentStart;
	function afterContentStartConstruct(code$1) {
		if (code$1 === null) {
			effects.consume(code$1);
			return;
		}
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return factorySpace(effects, contentStart, "linePrefix");
	}
	function paragraphInitial(code$1) {
		effects.enter("paragraph");
		return lineStart(code$1);
	}
	function lineStart(code$1) {
		const token = effects.enter("chunkText", {
			contentType: "text",
			previous: previous$1
		});
		if (previous$1) previous$1.next = token;
		previous$1 = token;
		return data(code$1);
	}
	function data(code$1) {
		if (code$1 === null) {
			effects.exit("chunkText");
			effects.exit("paragraph");
			effects.consume(code$1);
			return;
		}
		if (markdownLineEnding(code$1)) {
			effects.consume(code$1);
			effects.exit("chunkText");
			return lineStart;
		}
		effects.consume(code$1);
		return data;
	}
}
const document$1 = { tokenize: initializeDocument };
var containerConstruct = { tokenize: tokenizeContainer };
function initializeDocument(effects) {
	const self$1 = this;
	const stack = [];
	let continued = 0;
	let childFlow;
	let childToken;
	let lineStartOffset;
	return start;
	function start(code$1) {
		if (continued < stack.length) {
			const item = stack[continued];
			self$1.containerState = item[1];
			return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code$1);
		}
		return checkNewContainers(code$1);
	}
	function documentContinue(code$1) {
		continued++;
		if (self$1.containerState._closeFlow) {
			self$1.containerState._closeFlow = void 0;
			if (childFlow) closeFlow();
			const indexBeforeExits = self$1.events.length;
			let indexBeforeFlow = indexBeforeExits;
			let point$1;
			while (indexBeforeFlow--) if (self$1.events[indexBeforeFlow][0] === "exit" && self$1.events[indexBeforeFlow][1].type === "chunkFlow") {
				point$1 = self$1.events[indexBeforeFlow][1].end;
				break;
			}
			exitContainers(continued);
			let index = indexBeforeExits;
			while (index < self$1.events.length) {
				self$1.events[index][1].end = { ...point$1 };
				index++;
			}
			splice(self$1.events, indexBeforeFlow + 1, 0, self$1.events.slice(indexBeforeExits));
			self$1.events.length = index;
			return checkNewContainers(code$1);
		}
		return start(code$1);
	}
	function checkNewContainers(code$1) {
		if (continued === stack.length) {
			if (!childFlow) return documentContinued(code$1);
			if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code$1);
			self$1.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
		}
		self$1.containerState = {};
		return effects.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code$1);
	}
	function thereIsANewContainer(code$1) {
		if (childFlow) closeFlow();
		exitContainers(continued);
		return documentContinued(code$1);
	}
	function thereIsNoNewContainer(code$1) {
		self$1.parser.lazy[self$1.now().line] = continued !== stack.length;
		lineStartOffset = self$1.now().offset;
		return flowStart(code$1);
	}
	function documentContinued(code$1) {
		self$1.containerState = {};
		return effects.attempt(containerConstruct, containerContinue, flowStart)(code$1);
	}
	function containerContinue(code$1) {
		continued++;
		stack.push([self$1.currentConstruct, self$1.containerState]);
		return documentContinued(code$1);
	}
	function flowStart(code$1) {
		if (code$1 === null) {
			if (childFlow) closeFlow();
			exitContainers(0);
			effects.consume(code$1);
			return;
		}
		childFlow = childFlow || self$1.parser.flow(self$1.now());
		effects.enter("chunkFlow", {
			_tokenizer: childFlow,
			contentType: "flow",
			previous: childToken
		});
		return flowContinue(code$1);
	}
	function flowContinue(code$1) {
		if (code$1 === null) {
			writeToChild(effects.exit("chunkFlow"), true);
			exitContainers(0);
			effects.consume(code$1);
			return;
		}
		if (markdownLineEnding(code$1)) {
			effects.consume(code$1);
			writeToChild(effects.exit("chunkFlow"));
			continued = 0;
			self$1.interrupt = void 0;
			return start;
		}
		effects.consume(code$1);
		return flowContinue;
	}
	function writeToChild(token, endOfFile) {
		const stream = self$1.sliceStream(token);
		if (endOfFile) stream.push(null);
		token.previous = childToken;
		if (childToken) childToken.next = token;
		childToken = token;
		childFlow.defineSkip(token.start);
		childFlow.write(stream);
		if (self$1.parser.lazy[token.start.line]) {
			let index = childFlow.events.length;
			while (index--) if (childFlow.events[index][1].start.offset < lineStartOffset && (!childFlow.events[index][1].end || childFlow.events[index][1].end.offset > lineStartOffset)) return;
			const indexBeforeExits = self$1.events.length;
			let indexBeforeFlow = indexBeforeExits;
			let seen;
			let point$1;
			while (indexBeforeFlow--) if (self$1.events[indexBeforeFlow][0] === "exit" && self$1.events[indexBeforeFlow][1].type === "chunkFlow") {
				if (seen) {
					point$1 = self$1.events[indexBeforeFlow][1].end;
					break;
				}
				seen = true;
			}
			exitContainers(continued);
			index = indexBeforeExits;
			while (index < self$1.events.length) {
				self$1.events[index][1].end = { ...point$1 };
				index++;
			}
			splice(self$1.events, indexBeforeFlow + 1, 0, self$1.events.slice(indexBeforeExits));
			self$1.events.length = index;
		}
	}
	function exitContainers(size) {
		let index = stack.length;
		while (index-- > size) {
			const entry = stack[index];
			self$1.containerState = entry[1];
			entry[0].exit.call(self$1, effects);
		}
		stack.length = size;
	}
	function closeFlow() {
		childFlow.write([null]);
		childToken = void 0;
		childFlow = void 0;
		self$1.containerState._closeFlow = void 0;
	}
}
function tokenizeContainer(effects, ok, nok) {
	return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
const attention = {
	name: "attention",
	resolveAll: resolveAllAttention,
	tokenize: tokenizeAttention
};
function resolveAllAttention(events, context) {
	let index = -1;
	let open;
	let group;
	let text$2;
	let openingSequence;
	let closingSequence;
	let use;
	let nextEvents;
	let offset;
	while (++index < events.length) if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
		open = index;
		while (open--) if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
			if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
			use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
			const start = { ...events[open][1].end };
			const end = { ...events[index][1].start };
			movePoint(start, -use);
			movePoint(end, use);
			openingSequence = {
				type: use > 1 ? "strongSequence" : "emphasisSequence",
				start,
				end: { ...events[open][1].end }
			};
			closingSequence = {
				type: use > 1 ? "strongSequence" : "emphasisSequence",
				start: { ...events[index][1].start },
				end
			};
			text$2 = {
				type: use > 1 ? "strongText" : "emphasisText",
				start: { ...events[open][1].end },
				end: { ...events[index][1].start }
			};
			group = {
				type: use > 1 ? "strong" : "emphasis",
				start: { ...openingSequence.start },
				end: { ...closingSequence.end }
			};
			events[open][1].end = { ...openingSequence.start };
			events[index][1].start = { ...closingSequence.end };
			nextEvents = [];
			if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = push(nextEvents, [[
				"enter",
				events[open][1],
				context
			], [
				"exit",
				events[open][1],
				context
			]]);
			nextEvents = push(nextEvents, [
				[
					"enter",
					group,
					context
				],
				[
					"enter",
					openingSequence,
					context
				],
				[
					"exit",
					openingSequence,
					context
				],
				[
					"enter",
					text$2,
					context
				]
			]);
			nextEvents = push(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
			nextEvents = push(nextEvents, [
				[
					"exit",
					text$2,
					context
				],
				[
					"enter",
					closingSequence,
					context
				],
				[
					"exit",
					closingSequence,
					context
				],
				[
					"exit",
					group,
					context
				]
			]);
			if (events[index][1].end.offset - events[index][1].start.offset) {
				offset = 2;
				nextEvents = push(nextEvents, [[
					"enter",
					events[index][1],
					context
				], [
					"exit",
					events[index][1],
					context
				]]);
			} else offset = 0;
			splice(events, open - 1, index - open + 3, nextEvents);
			index = open + nextEvents.length - offset - 2;
			break;
		}
	}
	index = -1;
	while (++index < events.length) if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
	return events;
}
function tokenizeAttention(effects, ok) {
	const attentionMarkers$1 = this.parser.constructs.attentionMarkers.null;
	const previous$1 = this.previous;
	const before = classifyCharacter(previous$1);
	let marker;
	return start;
	function start(code$1) {
		marker = code$1;
		effects.enter("attentionSequence");
		return inside(code$1);
	}
	function inside(code$1) {
		if (code$1 === marker) {
			effects.consume(code$1);
			return inside;
		}
		const token = effects.exit("attentionSequence");
		const after = classifyCharacter(code$1);
		const open = !after || after === 2 && before || attentionMarkers$1.includes(code$1);
		const close$1 = !before || before === 2 && after || attentionMarkers$1.includes(previous$1);
		token._open = Boolean(marker === 42 ? open : open && (before || !close$1));
		token._close = Boolean(marker === 42 ? close$1 : close$1 && (after || !open));
		return ok(code$1);
	}
}
function movePoint(point$1, offset) {
	point$1.column += offset;
	point$1.offset += offset;
	point$1._bufferIndex += offset;
}
const autolink = {
	name: "autolink",
	tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok, nok) {
	let size = 0;
	return start;
	function start(code$1) {
		effects.enter("autolink");
		effects.enter("autolinkMarker");
		effects.consume(code$1);
		effects.exit("autolinkMarker");
		effects.enter("autolinkProtocol");
		return open;
	}
	function open(code$1) {
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			return schemeOrEmailAtext;
		}
		if (code$1 === 64) return nok(code$1);
		return emailAtext(code$1);
	}
	function schemeOrEmailAtext(code$1) {
		if (code$1 === 43 || code$1 === 45 || code$1 === 46 || asciiAlphanumeric(code$1)) {
			size = 1;
			return schemeInsideOrEmailAtext(code$1);
		}
		return emailAtext(code$1);
	}
	function schemeInsideOrEmailAtext(code$1) {
		if (code$1 === 58) {
			effects.consume(code$1);
			size = 0;
			return urlInside;
		}
		if ((code$1 === 43 || code$1 === 45 || code$1 === 46 || asciiAlphanumeric(code$1)) && size++ < 32) {
			effects.consume(code$1);
			return schemeInsideOrEmailAtext;
		}
		size = 0;
		return emailAtext(code$1);
	}
	function urlInside(code$1) {
		if (code$1 === 62) {
			effects.exit("autolinkProtocol");
			effects.enter("autolinkMarker");
			effects.consume(code$1);
			effects.exit("autolinkMarker");
			effects.exit("autolink");
			return ok;
		}
		if (code$1 === null || code$1 === 32 || code$1 === 60 || asciiControl(code$1)) return nok(code$1);
		effects.consume(code$1);
		return urlInside;
	}
	function emailAtext(code$1) {
		if (code$1 === 64) {
			effects.consume(code$1);
			return emailAtSignOrDot;
		}
		if (asciiAtext(code$1)) {
			effects.consume(code$1);
			return emailAtext;
		}
		return nok(code$1);
	}
	function emailAtSignOrDot(code$1) {
		return asciiAlphanumeric(code$1) ? emailLabel(code$1) : nok(code$1);
	}
	function emailLabel(code$1) {
		if (code$1 === 46) {
			effects.consume(code$1);
			size = 0;
			return emailAtSignOrDot;
		}
		if (code$1 === 62) {
			effects.exit("autolinkProtocol").type = "autolinkEmail";
			effects.enter("autolinkMarker");
			effects.consume(code$1);
			effects.exit("autolinkMarker");
			effects.exit("autolink");
			return ok;
		}
		return emailValue(code$1);
	}
	function emailValue(code$1) {
		if ((code$1 === 45 || asciiAlphanumeric(code$1)) && size++ < 63) {
			const next = code$1 === 45 ? emailValue : emailLabel;
			effects.consume(code$1);
			return next;
		}
		return nok(code$1);
	}
}
const blockQuote = {
	continuation: { tokenize: tokenizeBlockQuoteContinuation },
	exit,
	name: "blockQuote",
	tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		if (code$1 === 62) {
			const state = self$1.containerState;
			if (!state.open) {
				effects.enter("blockQuote", { _container: true });
				state.open = true;
			}
			effects.enter("blockQuotePrefix");
			effects.enter("blockQuoteMarker");
			effects.consume(code$1);
			effects.exit("blockQuoteMarker");
			return after;
		}
		return nok(code$1);
	}
	function after(code$1) {
		if (markdownSpace(code$1)) {
			effects.enter("blockQuotePrefixWhitespace");
			effects.consume(code$1);
			effects.exit("blockQuotePrefixWhitespace");
			effects.exit("blockQuotePrefix");
			return ok;
		}
		effects.exit("blockQuotePrefix");
		return ok(code$1);
	}
}
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
	const self$1 = this;
	return contStart;
	function contStart(code$1) {
		if (markdownSpace(code$1)) return factorySpace(effects, contBefore, "linePrefix", self$1.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code$1);
		return contBefore(code$1);
	}
	function contBefore(code$1) {
		return effects.attempt(blockQuote, ok, nok)(code$1);
	}
}
function exit(effects) {
	effects.exit("blockQuote");
}
const characterEscape = {
	name: "characterEscape",
	tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok, nok) {
	return start;
	function start(code$1) {
		effects.enter("characterEscape");
		effects.enter("escapeMarker");
		effects.consume(code$1);
		effects.exit("escapeMarker");
		return inside;
	}
	function inside(code$1) {
		if (asciiPunctuation(code$1)) {
			effects.enter("characterEscapeValue");
			effects.consume(code$1);
			effects.exit("characterEscapeValue");
			effects.exit("characterEscape");
			return ok;
		}
		return nok(code$1);
	}
}
const characterReference = {
	name: "characterReference",
	tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok, nok) {
	const self$1 = this;
	let size = 0;
	let max;
	let test;
	return start;
	function start(code$1) {
		effects.enter("characterReference");
		effects.enter("characterReferenceMarker");
		effects.consume(code$1);
		effects.exit("characterReferenceMarker");
		return open;
	}
	function open(code$1) {
		if (code$1 === 35) {
			effects.enter("characterReferenceMarkerNumeric");
			effects.consume(code$1);
			effects.exit("characterReferenceMarkerNumeric");
			return numeric;
		}
		effects.enter("characterReferenceValue");
		max = 31;
		test = asciiAlphanumeric;
		return value(code$1);
	}
	function numeric(code$1) {
		if (code$1 === 88 || code$1 === 120) {
			effects.enter("characterReferenceMarkerHexadecimal");
			effects.consume(code$1);
			effects.exit("characterReferenceMarkerHexadecimal");
			effects.enter("characterReferenceValue");
			max = 6;
			test = asciiHexDigit;
			return value;
		}
		effects.enter("characterReferenceValue");
		max = 7;
		test = asciiDigit;
		return value(code$1);
	}
	function value(code$1) {
		if (code$1 === 59 && size) {
			const token = effects.exit("characterReferenceValue");
			if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self$1.sliceSerialize(token))) return nok(code$1);
			effects.enter("characterReferenceMarker");
			effects.consume(code$1);
			effects.exit("characterReferenceMarker");
			effects.exit("characterReference");
			return ok;
		}
		if (test(code$1) && size++ < max) {
			effects.consume(code$1);
			return value;
		}
		return nok(code$1);
	}
}
var nonLazyContinuation = {
	partial: true,
	tokenize: tokenizeNonLazyContinuation
};
const codeFenced = {
	concrete: true,
	name: "codeFenced",
	tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(effects, ok, nok) {
	const self$1 = this;
	const closeStart = {
		partial: true,
		tokenize: tokenizeCloseStart
	};
	let initialPrefix = 0;
	let sizeOpen = 0;
	let marker;
	return start;
	function start(code$1) {
		return beforeSequenceOpen(code$1);
	}
	function beforeSequenceOpen(code$1) {
		const tail = self$1.events[self$1.events.length - 1];
		initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
		marker = code$1;
		effects.enter("codeFenced");
		effects.enter("codeFencedFence");
		effects.enter("codeFencedFenceSequence");
		return sequenceOpen(code$1);
	}
	function sequenceOpen(code$1) {
		if (code$1 === marker) {
			sizeOpen++;
			effects.consume(code$1);
			return sequenceOpen;
		}
		if (sizeOpen < 3) return nok(code$1);
		effects.exit("codeFencedFenceSequence");
		return markdownSpace(code$1) ? factorySpace(effects, infoBefore, "whitespace")(code$1) : infoBefore(code$1);
	}
	function infoBefore(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("codeFencedFence");
			return self$1.interrupt ? ok(code$1) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code$1);
		}
		effects.enter("codeFencedFenceInfo");
		effects.enter("chunkString", { contentType: "string" });
		return info(code$1);
	}
	function info(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("chunkString");
			effects.exit("codeFencedFenceInfo");
			return infoBefore(code$1);
		}
		if (markdownSpace(code$1)) {
			effects.exit("chunkString");
			effects.exit("codeFencedFenceInfo");
			return factorySpace(effects, metaBefore, "whitespace")(code$1);
		}
		if (code$1 === 96 && code$1 === marker) return nok(code$1);
		effects.consume(code$1);
		return info;
	}
	function metaBefore(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) return infoBefore(code$1);
		effects.enter("codeFencedFenceMeta");
		effects.enter("chunkString", { contentType: "string" });
		return meta(code$1);
	}
	function meta(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("chunkString");
			effects.exit("codeFencedFenceMeta");
			return infoBefore(code$1);
		}
		if (code$1 === 96 && code$1 === marker) return nok(code$1);
		effects.consume(code$1);
		return meta;
	}
	function atNonLazyBreak(code$1) {
		return effects.attempt(closeStart, after, contentBefore)(code$1);
	}
	function contentBefore(code$1) {
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return contentStart;
	}
	function contentStart(code$1) {
		return initialPrefix > 0 && markdownSpace(code$1) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code$1) : beforeContentChunk(code$1);
	}
	function beforeContentChunk(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code$1);
		effects.enter("codeFlowValue");
		return contentChunk(code$1);
	}
	function contentChunk(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("codeFlowValue");
			return beforeContentChunk(code$1);
		}
		effects.consume(code$1);
		return contentChunk;
	}
	function after(code$1) {
		effects.exit("codeFenced");
		return ok(code$1);
	}
	function tokenizeCloseStart(effects$1, ok$1, nok$1) {
		let size = 0;
		return startBefore;
		function startBefore(code$1) {
			effects$1.enter("lineEnding");
			effects$1.consume(code$1);
			effects$1.exit("lineEnding");
			return start$1;
		}
		function start$1(code$1) {
			effects$1.enter("codeFencedFence");
			return markdownSpace(code$1) ? factorySpace(effects$1, beforeSequenceClose, "linePrefix", self$1.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code$1) : beforeSequenceClose(code$1);
		}
		function beforeSequenceClose(code$1) {
			if (code$1 === marker) {
				effects$1.enter("codeFencedFenceSequence");
				return sequenceClose(code$1);
			}
			return nok$1(code$1);
		}
		function sequenceClose(code$1) {
			if (code$1 === marker) {
				size++;
				effects$1.consume(code$1);
				return sequenceClose;
			}
			if (size >= sizeOpen) {
				effects$1.exit("codeFencedFenceSequence");
				return markdownSpace(code$1) ? factorySpace(effects$1, sequenceCloseAfter, "whitespace")(code$1) : sequenceCloseAfter(code$1);
			}
			return nok$1(code$1);
		}
		function sequenceCloseAfter(code$1) {
			if (code$1 === null || markdownLineEnding(code$1)) {
				effects$1.exit("codeFencedFence");
				return ok$1(code$1);
			}
			return nok$1(code$1);
		}
	}
}
function tokenizeNonLazyContinuation(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		if (code$1 === null) return nok(code$1);
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return lineStart;
	}
	function lineStart(code$1) {
		return self$1.parser.lazy[self$1.now().line] ? nok(code$1) : ok(code$1);
	}
}
const codeIndented = {
	name: "codeIndented",
	tokenize: tokenizeCodeIndented
};
var furtherStart = {
	partial: true,
	tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		effects.enter("codeIndented");
		return factorySpace(effects, afterPrefix, "linePrefix", 5)(code$1);
	}
	function afterPrefix(code$1) {
		const tail = self$1.events[self$1.events.length - 1];
		return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code$1) : nok(code$1);
	}
	function atBreak(code$1) {
		if (code$1 === null) return after(code$1);
		if (markdownLineEnding(code$1)) return effects.attempt(furtherStart, atBreak, after)(code$1);
		effects.enter("codeFlowValue");
		return inside(code$1);
	}
	function inside(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("codeFlowValue");
			return atBreak(code$1);
		}
		effects.consume(code$1);
		return inside;
	}
	function after(code$1) {
		effects.exit("codeIndented");
		return ok(code$1);
	}
}
function tokenizeFurtherStart(effects, ok, nok) {
	const self$1 = this;
	return furtherStart$1;
	function furtherStart$1(code$1) {
		if (self$1.parser.lazy[self$1.now().line]) return nok(code$1);
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			return furtherStart$1;
		}
		return factorySpace(effects, afterPrefix, "linePrefix", 5)(code$1);
	}
	function afterPrefix(code$1) {
		const tail = self$1.events[self$1.events.length - 1];
		return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code$1) : markdownLineEnding(code$1) ? furtherStart$1(code$1) : nok(code$1);
	}
}
const codeText = {
	name: "codeText",
	previous,
	resolve: resolveCodeText,
	tokenize: tokenizeCodeText
};
function resolveCodeText(events) {
	let tailExitIndex = events.length - 4;
	let headEnterIndex = 3;
	let index;
	let enter;
	if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
		index = headEnterIndex;
		while (++index < tailExitIndex) if (events[index][1].type === "codeTextData") {
			events[headEnterIndex][1].type = "codeTextPadding";
			events[tailExitIndex][1].type = "codeTextPadding";
			headEnterIndex += 2;
			tailExitIndex -= 2;
			break;
		}
	}
	index = headEnterIndex - 1;
	tailExitIndex++;
	while (++index <= tailExitIndex) if (enter === void 0) {
		if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
	} else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
		events[enter][1].type = "codeTextData";
		if (index !== enter + 2) {
			events[enter][1].end = events[index - 1][1].end;
			events.splice(enter + 2, index - enter - 2);
			tailExitIndex -= index - enter - 2;
			index = enter + 2;
		}
		enter = void 0;
	}
	return events;
}
function previous(code$1) {
	return code$1 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok, nok) {
	let sizeOpen = 0;
	let size;
	let token;
	return start;
	function start(code$1) {
		effects.enter("codeText");
		effects.enter("codeTextSequence");
		return sequenceOpen(code$1);
	}
	function sequenceOpen(code$1) {
		if (code$1 === 96) {
			effects.consume(code$1);
			sizeOpen++;
			return sequenceOpen;
		}
		effects.exit("codeTextSequence");
		return between(code$1);
	}
	function between(code$1) {
		if (code$1 === null) return nok(code$1);
		if (code$1 === 32) {
			effects.enter("space");
			effects.consume(code$1);
			effects.exit("space");
			return between;
		}
		if (code$1 === 96) {
			token = effects.enter("codeTextSequence");
			size = 0;
			return sequenceClose(code$1);
		}
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			return between;
		}
		effects.enter("codeTextData");
		return data(code$1);
	}
	function data(code$1) {
		if (code$1 === null || code$1 === 32 || code$1 === 96 || markdownLineEnding(code$1)) {
			effects.exit("codeTextData");
			return between(code$1);
		}
		effects.consume(code$1);
		return data;
	}
	function sequenceClose(code$1) {
		if (code$1 === 96) {
			effects.consume(code$1);
			size++;
			return sequenceClose;
		}
		if (size === sizeOpen) {
			effects.exit("codeTextSequence");
			effects.exit("codeText");
			return ok(code$1);
		}
		token.type = "codeTextData";
		return data(code$1);
	}
}
var SpliceBuffer = class {
	constructor(initial) {
		this.left = initial ? [...initial] : [];
		this.right = [];
	}
	get(index) {
		if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError("Cannot access index `" + index + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
		if (index < this.left.length) return this.left[index];
		return this.right[this.right.length - index + this.left.length - 1];
	}
	get length() {
		return this.left.length + this.right.length;
	}
	shift() {
		this.setCursor(0);
		return this.right.pop();
	}
	slice(start, end) {
		const stop = end === null || end === void 0 ? Number.POSITIVE_INFINITY : end;
		if (stop < this.left.length) return this.left.slice(start, stop);
		if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
		return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
	}
	splice(start, deleteCount, items) {
		const count = deleteCount || 0;
		this.setCursor(Math.trunc(start));
		const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
		if (items) chunkedPush(this.left, items);
		return removed.reverse();
	}
	pop() {
		this.setCursor(Number.POSITIVE_INFINITY);
		return this.left.pop();
	}
	push(item) {
		this.setCursor(Number.POSITIVE_INFINITY);
		this.left.push(item);
	}
	pushMany(items) {
		this.setCursor(Number.POSITIVE_INFINITY);
		chunkedPush(this.left, items);
	}
	unshift(item) {
		this.setCursor(0);
		this.right.push(item);
	}
	unshiftMany(items) {
		this.setCursor(0);
		chunkedPush(this.right, items.reverse());
	}
	setCursor(n) {
		if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
		if (n < this.left.length) {
			const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
			chunkedPush(this.right, removed.reverse());
		} else {
			const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
			chunkedPush(this.left, removed.reverse());
		}
	}
};
function chunkedPush(list$1, right) {
	let chunkStart = 0;
	if (right.length < 1e4) list$1.push(...right);
	else while (chunkStart < right.length) {
		list$1.push(...right.slice(chunkStart, chunkStart + 1e4));
		chunkStart += 1e4;
	}
}
function subtokenize(eventsArray) {
	const jumps = {};
	let index = -1;
	let event;
	let lineIndex;
	let otherIndex;
	let otherEvent;
	let parameters;
	let subevents;
	let more;
	const events = new SpliceBuffer(eventsArray);
	while (++index < events.length) {
		while (index in jumps) index = jumps[index];
		event = events.get(index);
		if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
			subevents = event[1]._tokenizer.events;
			otherIndex = 0;
			if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
			if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while (++otherIndex < subevents.length) {
				if (subevents[otherIndex][1].type === "content") break;
				if (subevents[otherIndex][1].type === "chunkText") {
					subevents[otherIndex][1]._isInFirstContentOfListItem = true;
					otherIndex++;
				}
			}
		}
		if (event[0] === "enter") {
			if (event[1].contentType) {
				Object.assign(jumps, subcontent(events, index));
				index = jumps[index];
				more = true;
			}
		} else if (event[1]._container) {
			otherIndex = index;
			lineIndex = void 0;
			while (otherIndex--) {
				otherEvent = events.get(otherIndex);
				if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
					if (otherEvent[0] === "enter") {
						if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
						otherEvent[1].type = "lineEnding";
						lineIndex = otherIndex;
					}
				} else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") {} else break;
			}
			if (lineIndex) {
				event[1].end = { ...events.get(lineIndex)[1].start };
				parameters = events.slice(lineIndex, index);
				parameters.unshift(event);
				events.splice(lineIndex, index - lineIndex + 1, parameters);
			}
		}
	}
	splice(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
	return !more;
}
function subcontent(events, eventIndex) {
	const token = events.get(eventIndex)[1];
	const context = events.get(eventIndex)[2];
	let startPosition = eventIndex - 1;
	const startPositions = [];
	let tokenizer = token._tokenizer;
	if (!tokenizer) {
		tokenizer = context.parser[token.contentType](token.start);
		if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
	}
	const childEvents = tokenizer.events;
	const jumps = [];
	const gaps = {};
	let stream;
	let previous$1;
	let index = -1;
	let current = token;
	let adjust = 0;
	let start = 0;
	const breaks = [start];
	while (current) {
		while (events.get(++startPosition)[1] !== current);
		startPositions.push(startPosition);
		if (!current._tokenizer) {
			stream = context.sliceStream(current);
			if (!current.next) stream.push(null);
			if (previous$1) tokenizer.defineSkip(current.start);
			if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
			tokenizer.write(stream);
			if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = void 0;
		}
		previous$1 = current;
		current = current.next;
	}
	current = token;
	while (++index < childEvents.length) if (childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
		start = index + 1;
		breaks.push(start);
		current._tokenizer = void 0;
		current.previous = void 0;
		current = current.next;
	}
	tokenizer.events = [];
	if (current) {
		current._tokenizer = void 0;
		current.previous = void 0;
	} else breaks.pop();
	index = breaks.length;
	while (index--) {
		const slice = childEvents.slice(breaks[index], breaks[index + 1]);
		const start$1 = startPositions.pop();
		jumps.push([start$1, start$1 + slice.length - 1]);
		events.splice(start$1, 2, slice);
	}
	jumps.reverse();
	index = -1;
	while (++index < jumps.length) {
		gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
		adjust += jumps[index][1] - jumps[index][0] - 1;
	}
	return gaps;
}
const content$1 = {
	resolve: resolveContent,
	tokenize: tokenizeContent
};
var continuationConstruct = {
	partial: true,
	tokenize: tokenizeContinuation
};
function resolveContent(events) {
	subtokenize(events);
	return events;
}
function tokenizeContent(effects, ok) {
	let previous$1;
	return chunkStart;
	function chunkStart(code$1) {
		effects.enter("content");
		previous$1 = effects.enter("chunkContent", { contentType: "content" });
		return chunkInside(code$1);
	}
	function chunkInside(code$1) {
		if (code$1 === null) return contentEnd(code$1);
		if (markdownLineEnding(code$1)) return effects.check(continuationConstruct, contentContinue, contentEnd)(code$1);
		effects.consume(code$1);
		return chunkInside;
	}
	function contentEnd(code$1) {
		effects.exit("chunkContent");
		effects.exit("content");
		return ok(code$1);
	}
	function contentContinue(code$1) {
		effects.consume(code$1);
		effects.exit("chunkContent");
		previous$1.next = effects.enter("chunkContent", {
			contentType: "content",
			previous: previous$1
		});
		previous$1 = previous$1.next;
		return chunkInside;
	}
}
function tokenizeContinuation(effects, ok, nok) {
	const self$1 = this;
	return startLookahead;
	function startLookahead(code$1) {
		effects.exit("chunkContent");
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return factorySpace(effects, prefixed, "linePrefix");
	}
	function prefixed(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) return nok(code$1);
		const tail = self$1.events[self$1.events.length - 1];
		if (!self$1.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code$1);
		return effects.interrupt(self$1.parser.constructs.flow, nok, ok)(code$1);
	}
}
function factoryDestination(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
	const limit = max || Number.POSITIVE_INFINITY;
	let balance = 0;
	return start;
	function start(code$1) {
		if (code$1 === 60) {
			effects.enter(type);
			effects.enter(literalType);
			effects.enter(literalMarkerType);
			effects.consume(code$1);
			effects.exit(literalMarkerType);
			return enclosedBefore;
		}
		if (code$1 === null || code$1 === 32 || code$1 === 41 || asciiControl(code$1)) return nok(code$1);
		effects.enter(type);
		effects.enter(rawType);
		effects.enter(stringType);
		effects.enter("chunkString", { contentType: "string" });
		return raw(code$1);
	}
	function enclosedBefore(code$1) {
		if (code$1 === 62) {
			effects.enter(literalMarkerType);
			effects.consume(code$1);
			effects.exit(literalMarkerType);
			effects.exit(literalType);
			effects.exit(type);
			return ok;
		}
		effects.enter(stringType);
		effects.enter("chunkString", { contentType: "string" });
		return enclosed(code$1);
	}
	function enclosed(code$1) {
		if (code$1 === 62) {
			effects.exit("chunkString");
			effects.exit(stringType);
			return enclosedBefore(code$1);
		}
		if (code$1 === null || code$1 === 60 || markdownLineEnding(code$1)) return nok(code$1);
		effects.consume(code$1);
		return code$1 === 92 ? enclosedEscape : enclosed;
	}
	function enclosedEscape(code$1) {
		if (code$1 === 60 || code$1 === 62 || code$1 === 92) {
			effects.consume(code$1);
			return enclosed;
		}
		return enclosed(code$1);
	}
	function raw(code$1) {
		if (!balance && (code$1 === null || code$1 === 41 || markdownLineEndingOrSpace(code$1))) {
			effects.exit("chunkString");
			effects.exit(stringType);
			effects.exit(rawType);
			effects.exit(type);
			return ok(code$1);
		}
		if (balance < limit && code$1 === 40) {
			effects.consume(code$1);
			balance++;
			return raw;
		}
		if (code$1 === 41) {
			effects.consume(code$1);
			balance--;
			return raw;
		}
		if (code$1 === null || code$1 === 32 || code$1 === 40 || asciiControl(code$1)) return nok(code$1);
		effects.consume(code$1);
		return code$1 === 92 ? rawEscape : raw;
	}
	function rawEscape(code$1) {
		if (code$1 === 40 || code$1 === 41 || code$1 === 92) {
			effects.consume(code$1);
			return raw;
		}
		return raw(code$1);
	}
}
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
	const self$1 = this;
	let size = 0;
	let seen;
	return start;
	function start(code$1) {
		effects.enter(type);
		effects.enter(markerType);
		effects.consume(code$1);
		effects.exit(markerType);
		effects.enter(stringType);
		return atBreak;
	}
	function atBreak(code$1) {
		if (size > 999 || code$1 === null || code$1 === 91 || code$1 === 93 && !seen || code$1 === 94 && !size && "_hiddenFootnoteSupport" in self$1.parser.constructs) return nok(code$1);
		if (code$1 === 93) {
			effects.exit(stringType);
			effects.enter(markerType);
			effects.consume(code$1);
			effects.exit(markerType);
			effects.exit(type);
			return ok;
		}
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			return atBreak;
		}
		effects.enter("chunkString", { contentType: "string" });
		return labelInside(code$1);
	}
	function labelInside(code$1) {
		if (code$1 === null || code$1 === 91 || code$1 === 93 || markdownLineEnding(code$1) || size++ > 999) {
			effects.exit("chunkString");
			return atBreak(code$1);
		}
		effects.consume(code$1);
		if (!seen) seen = !markdownSpace(code$1);
		return code$1 === 92 ? labelEscape : labelInside;
	}
	function labelEscape(code$1) {
		if (code$1 === 91 || code$1 === 92 || code$1 === 93) {
			effects.consume(code$1);
			size++;
			return labelInside;
		}
		return labelInside(code$1);
	}
}
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
	let marker;
	return start;
	function start(code$1) {
		if (code$1 === 34 || code$1 === 39 || code$1 === 40) {
			effects.enter(type);
			effects.enter(markerType);
			effects.consume(code$1);
			effects.exit(markerType);
			marker = code$1 === 40 ? 41 : code$1;
			return begin;
		}
		return nok(code$1);
	}
	function begin(code$1) {
		if (code$1 === marker) {
			effects.enter(markerType);
			effects.consume(code$1);
			effects.exit(markerType);
			effects.exit(type);
			return ok;
		}
		effects.enter(stringType);
		return atBreak(code$1);
	}
	function atBreak(code$1) {
		if (code$1 === marker) {
			effects.exit(stringType);
			return begin(marker);
		}
		if (code$1 === null) return nok(code$1);
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			return factorySpace(effects, atBreak, "linePrefix");
		}
		effects.enter("chunkString", { contentType: "string" });
		return inside(code$1);
	}
	function inside(code$1) {
		if (code$1 === marker || code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("chunkString");
			return atBreak(code$1);
		}
		effects.consume(code$1);
		return code$1 === 92 ? escape : inside;
	}
	function escape(code$1) {
		if (code$1 === marker || code$1 === 92) {
			effects.consume(code$1);
			return inside;
		}
		return inside(code$1);
	}
}
function factoryWhitespace(effects, ok) {
	let seen;
	return start;
	function start(code$1) {
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			seen = true;
			return start;
		}
		if (markdownSpace(code$1)) return factorySpace(effects, start, seen ? "linePrefix" : "lineSuffix")(code$1);
		return ok(code$1);
	}
}
const definition = {
	name: "definition",
	tokenize: tokenizeDefinition
};
var titleBefore = {
	partial: true,
	tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(effects, ok, nok) {
	const self$1 = this;
	let identifier;
	return start;
	function start(code$1) {
		effects.enter("definition");
		return before(code$1);
	}
	function before(code$1) {
		return factoryLabel.call(self$1, effects, labelAfter, nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code$1);
	}
	function labelAfter(code$1) {
		identifier = normalizeIdentifier(self$1.sliceSerialize(self$1.events[self$1.events.length - 1][1]).slice(1, -1));
		if (code$1 === 58) {
			effects.enter("definitionMarker");
			effects.consume(code$1);
			effects.exit("definitionMarker");
			return markerAfter;
		}
		return nok(code$1);
	}
	function markerAfter(code$1) {
		return markdownLineEndingOrSpace(code$1) ? factoryWhitespace(effects, destinationBefore)(code$1) : destinationBefore(code$1);
	}
	function destinationBefore(code$1) {
		return factoryDestination(effects, destinationAfter, nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code$1);
	}
	function destinationAfter(code$1) {
		return effects.attempt(titleBefore, after, after)(code$1);
	}
	function after(code$1) {
		return markdownSpace(code$1) ? factorySpace(effects, afterWhitespace, "whitespace")(code$1) : afterWhitespace(code$1);
	}
	function afterWhitespace(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("definition");
			self$1.parser.defined.push(identifier);
			return ok(code$1);
		}
		return nok(code$1);
	}
}
function tokenizeTitleBefore(effects, ok, nok) {
	return titleBefore$1;
	function titleBefore$1(code$1) {
		return markdownLineEndingOrSpace(code$1) ? factoryWhitespace(effects, beforeMarker)(code$1) : nok(code$1);
	}
	function beforeMarker(code$1) {
		return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code$1);
	}
	function titleAfter(code$1) {
		return markdownSpace(code$1) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code$1) : titleAfterOptionalWhitespace(code$1);
	}
	function titleAfterOptionalWhitespace(code$1) {
		return code$1 === null || markdownLineEnding(code$1) ? ok(code$1) : nok(code$1);
	}
}
const hardBreakEscape = {
	name: "hardBreakEscape",
	tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok, nok) {
	return start;
	function start(code$1) {
		effects.enter("hardBreakEscape");
		effects.consume(code$1);
		return after;
	}
	function after(code$1) {
		if (markdownLineEnding(code$1)) {
			effects.exit("hardBreakEscape");
			return ok(code$1);
		}
		return nok(code$1);
	}
}
const headingAtx = {
	name: "headingAtx",
	resolve: resolveHeadingAtx,
	tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(events, context) {
	let contentEnd = events.length - 2;
	let contentStart = 3;
	let content$2;
	let text$2;
	if (events[contentStart][1].type === "whitespace") contentStart += 2;
	if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
	if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
	if (contentEnd > contentStart) {
		content$2 = {
			type: "atxHeadingText",
			start: events[contentStart][1].start,
			end: events[contentEnd][1].end
		};
		text$2 = {
			type: "chunkText",
			start: events[contentStart][1].start,
			end: events[contentEnd][1].end,
			contentType: "text"
		};
		splice(events, contentStart, contentEnd - contentStart + 1, [
			[
				"enter",
				content$2,
				context
			],
			[
				"enter",
				text$2,
				context
			],
			[
				"exit",
				text$2,
				context
			],
			[
				"exit",
				content$2,
				context
			]
		]);
	}
	return events;
}
function tokenizeHeadingAtx(effects, ok, nok) {
	let size = 0;
	return start;
	function start(code$1) {
		effects.enter("atxHeading");
		return before(code$1);
	}
	function before(code$1) {
		effects.enter("atxHeadingSequence");
		return sequenceOpen(code$1);
	}
	function sequenceOpen(code$1) {
		if (code$1 === 35 && size++ < 6) {
			effects.consume(code$1);
			return sequenceOpen;
		}
		if (code$1 === null || markdownLineEndingOrSpace(code$1)) {
			effects.exit("atxHeadingSequence");
			return atBreak(code$1);
		}
		return nok(code$1);
	}
	function atBreak(code$1) {
		if (code$1 === 35) {
			effects.enter("atxHeadingSequence");
			return sequenceFurther(code$1);
		}
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("atxHeading");
			return ok(code$1);
		}
		if (markdownSpace(code$1)) return factorySpace(effects, atBreak, "whitespace")(code$1);
		effects.enter("atxHeadingText");
		return data(code$1);
	}
	function sequenceFurther(code$1) {
		if (code$1 === 35) {
			effects.consume(code$1);
			return sequenceFurther;
		}
		effects.exit("atxHeadingSequence");
		return atBreak(code$1);
	}
	function data(code$1) {
		if (code$1 === null || code$1 === 35 || markdownLineEndingOrSpace(code$1)) {
			effects.exit("atxHeadingText");
			return atBreak(code$1);
		}
		effects.consume(code$1);
		return data;
	}
}
const htmlBlockNames = [
	"address",
	"article",
	"aside",
	"base",
	"basefont",
	"blockquote",
	"body",
	"caption",
	"center",
	"col",
	"colgroup",
	"dd",
	"details",
	"dialog",
	"dir",
	"div",
	"dl",
	"dt",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"frame",
	"frameset",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hr",
	"html",
	"iframe",
	"legend",
	"li",
	"link",
	"main",
	"menu",
	"menuitem",
	"nav",
	"noframes",
	"ol",
	"optgroup",
	"option",
	"p",
	"param",
	"search",
	"section",
	"summary",
	"table",
	"tbody",
	"td",
	"tfoot",
	"th",
	"thead",
	"title",
	"tr",
	"track",
	"ul"
];
const htmlRawNames = [
	"pre",
	"script",
	"style",
	"textarea"
];
const htmlFlow = {
	concrete: true,
	name: "htmlFlow",
	resolveTo: resolveToHtmlFlow,
	tokenize: tokenizeHtmlFlow
};
var blankLineBefore = {
	partial: true,
	tokenize: tokenizeBlankLineBefore
};
var nonLazyContinuationStart = {
	partial: true,
	tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(events) {
	let index = events.length;
	while (index--) if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
	if (index > 1 && events[index - 2][1].type === "linePrefix") {
		events[index][1].start = events[index - 2][1].start;
		events[index + 1][1].start = events[index - 2][1].start;
		events.splice(index - 2, 2);
	}
	return events;
}
function tokenizeHtmlFlow(effects, ok, nok) {
	const self$1 = this;
	let marker;
	let closingTag;
	let buffer;
	let index;
	let markerB;
	return start;
	function start(code$1) {
		return before(code$1);
	}
	function before(code$1) {
		effects.enter("htmlFlow");
		effects.enter("htmlFlowData");
		effects.consume(code$1);
		return open;
	}
	function open(code$1) {
		if (code$1 === 33) {
			effects.consume(code$1);
			return declarationOpen;
		}
		if (code$1 === 47) {
			effects.consume(code$1);
			closingTag = true;
			return tagCloseStart;
		}
		if (code$1 === 63) {
			effects.consume(code$1);
			marker = 3;
			return self$1.interrupt ? ok : continuationDeclarationInside;
		}
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			buffer = String.fromCharCode(code$1);
			return tagName;
		}
		return nok(code$1);
	}
	function declarationOpen(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			marker = 2;
			return commentOpenInside;
		}
		if (code$1 === 91) {
			effects.consume(code$1);
			marker = 5;
			index = 0;
			return cdataOpenInside;
		}
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			marker = 4;
			return self$1.interrupt ? ok : continuationDeclarationInside;
		}
		return nok(code$1);
	}
	function commentOpenInside(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			return self$1.interrupt ? ok : continuationDeclarationInside;
		}
		return nok(code$1);
	}
	function cdataOpenInside(code$1) {
		if (code$1 === "CDATA[".charCodeAt(index++)) {
			effects.consume(code$1);
			if (index === 6) return self$1.interrupt ? ok : continuation;
			return cdataOpenInside;
		}
		return nok(code$1);
	}
	function tagCloseStart(code$1) {
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			buffer = String.fromCharCode(code$1);
			return tagName;
		}
		return nok(code$1);
	}
	function tagName(code$1) {
		if (code$1 === null || code$1 === 47 || code$1 === 62 || markdownLineEndingOrSpace(code$1)) {
			const slash = code$1 === 47;
			const name = buffer.toLowerCase();
			if (!slash && !closingTag && htmlRawNames.includes(name)) {
				marker = 1;
				return self$1.interrupt ? ok(code$1) : continuation(code$1);
			}
			if (htmlBlockNames.includes(buffer.toLowerCase())) {
				marker = 6;
				if (slash) {
					effects.consume(code$1);
					return basicSelfClosing;
				}
				return self$1.interrupt ? ok(code$1) : continuation(code$1);
			}
			marker = 7;
			return self$1.interrupt && !self$1.parser.lazy[self$1.now().line] ? nok(code$1) : closingTag ? completeClosingTagAfter(code$1) : completeAttributeNameBefore(code$1);
		}
		if (code$1 === 45 || asciiAlphanumeric(code$1)) {
			effects.consume(code$1);
			buffer += String.fromCharCode(code$1);
			return tagName;
		}
		return nok(code$1);
	}
	function basicSelfClosing(code$1) {
		if (code$1 === 62) {
			effects.consume(code$1);
			return self$1.interrupt ? ok : continuation;
		}
		return nok(code$1);
	}
	function completeClosingTagAfter(code$1) {
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return completeClosingTagAfter;
		}
		return completeEnd(code$1);
	}
	function completeAttributeNameBefore(code$1) {
		if (code$1 === 47) {
			effects.consume(code$1);
			return completeEnd;
		}
		if (code$1 === 58 || code$1 === 95 || asciiAlpha(code$1)) {
			effects.consume(code$1);
			return completeAttributeName;
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return completeAttributeNameBefore;
		}
		return completeEnd(code$1);
	}
	function completeAttributeName(code$1) {
		if (code$1 === 45 || code$1 === 46 || code$1 === 58 || code$1 === 95 || asciiAlphanumeric(code$1)) {
			effects.consume(code$1);
			return completeAttributeName;
		}
		return completeAttributeNameAfter(code$1);
	}
	function completeAttributeNameAfter(code$1) {
		if (code$1 === 61) {
			effects.consume(code$1);
			return completeAttributeValueBefore;
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return completeAttributeNameAfter;
		}
		return completeAttributeNameBefore(code$1);
	}
	function completeAttributeValueBefore(code$1) {
		if (code$1 === null || code$1 === 60 || code$1 === 61 || code$1 === 62 || code$1 === 96) return nok(code$1);
		if (code$1 === 34 || code$1 === 39) {
			effects.consume(code$1);
			markerB = code$1;
			return completeAttributeValueQuoted;
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return completeAttributeValueBefore;
		}
		return completeAttributeValueUnquoted(code$1);
	}
	function completeAttributeValueQuoted(code$1) {
		if (code$1 === markerB) {
			effects.consume(code$1);
			markerB = null;
			return completeAttributeValueQuotedAfter;
		}
		if (code$1 === null || markdownLineEnding(code$1)) return nok(code$1);
		effects.consume(code$1);
		return completeAttributeValueQuoted;
	}
	function completeAttributeValueUnquoted(code$1) {
		if (code$1 === null || code$1 === 34 || code$1 === 39 || code$1 === 47 || code$1 === 60 || code$1 === 61 || code$1 === 62 || code$1 === 96 || markdownLineEndingOrSpace(code$1)) return completeAttributeNameAfter(code$1);
		effects.consume(code$1);
		return completeAttributeValueUnquoted;
	}
	function completeAttributeValueQuotedAfter(code$1) {
		if (code$1 === 47 || code$1 === 62 || markdownSpace(code$1)) return completeAttributeNameBefore(code$1);
		return nok(code$1);
	}
	function completeEnd(code$1) {
		if (code$1 === 62) {
			effects.consume(code$1);
			return completeAfter;
		}
		return nok(code$1);
	}
	function completeAfter(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) return continuation(code$1);
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return completeAfter;
		}
		return nok(code$1);
	}
	function continuation(code$1) {
		if (code$1 === 45 && marker === 2) {
			effects.consume(code$1);
			return continuationCommentInside;
		}
		if (code$1 === 60 && marker === 1) {
			effects.consume(code$1);
			return continuationRawTagOpen;
		}
		if (code$1 === 62 && marker === 4) {
			effects.consume(code$1);
			return continuationClose;
		}
		if (code$1 === 63 && marker === 3) {
			effects.consume(code$1);
			return continuationDeclarationInside;
		}
		if (code$1 === 93 && marker === 5) {
			effects.consume(code$1);
			return continuationCdataInside;
		}
		if (markdownLineEnding(code$1) && (marker === 6 || marker === 7)) {
			effects.exit("htmlFlowData");
			return effects.check(blankLineBefore, continuationAfter, continuationStart)(code$1);
		}
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("htmlFlowData");
			return continuationStart(code$1);
		}
		effects.consume(code$1);
		return continuation;
	}
	function continuationStart(code$1) {
		return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code$1);
	}
	function continuationStartNonLazy(code$1) {
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return continuationBefore;
	}
	function continuationBefore(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) return continuationStart(code$1);
		effects.enter("htmlFlowData");
		return continuation(code$1);
	}
	function continuationCommentInside(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			return continuationDeclarationInside;
		}
		return continuation(code$1);
	}
	function continuationRawTagOpen(code$1) {
		if (code$1 === 47) {
			effects.consume(code$1);
			buffer = "";
			return continuationRawEndTag;
		}
		return continuation(code$1);
	}
	function continuationRawEndTag(code$1) {
		if (code$1 === 62) {
			const name = buffer.toLowerCase();
			if (htmlRawNames.includes(name)) {
				effects.consume(code$1);
				return continuationClose;
			}
			return continuation(code$1);
		}
		if (asciiAlpha(code$1) && buffer.length < 8) {
			effects.consume(code$1);
			buffer += String.fromCharCode(code$1);
			return continuationRawEndTag;
		}
		return continuation(code$1);
	}
	function continuationCdataInside(code$1) {
		if (code$1 === 93) {
			effects.consume(code$1);
			return continuationDeclarationInside;
		}
		return continuation(code$1);
	}
	function continuationDeclarationInside(code$1) {
		if (code$1 === 62) {
			effects.consume(code$1);
			return continuationClose;
		}
		if (code$1 === 45 && marker === 2) {
			effects.consume(code$1);
			return continuationDeclarationInside;
		}
		return continuation(code$1);
	}
	function continuationClose(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("htmlFlowData");
			return continuationAfter(code$1);
		}
		effects.consume(code$1);
		return continuationClose;
	}
	function continuationAfter(code$1) {
		effects.exit("htmlFlow");
		return ok(code$1);
	}
}
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		if (markdownLineEnding(code$1)) {
			effects.enter("lineEnding");
			effects.consume(code$1);
			effects.exit("lineEnding");
			return after;
		}
		return nok(code$1);
	}
	function after(code$1) {
		return self$1.parser.lazy[self$1.now().line] ? nok(code$1) : ok(code$1);
	}
}
function tokenizeBlankLineBefore(effects, ok, nok) {
	return start;
	function start(code$1) {
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return effects.attempt(blankLine, ok, nok);
	}
}
const htmlText = {
	name: "htmlText",
	tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok, nok) {
	const self$1 = this;
	let marker;
	let index;
	let returnState;
	return start;
	function start(code$1) {
		effects.enter("htmlText");
		effects.enter("htmlTextData");
		effects.consume(code$1);
		return open;
	}
	function open(code$1) {
		if (code$1 === 33) {
			effects.consume(code$1);
			return declarationOpen;
		}
		if (code$1 === 47) {
			effects.consume(code$1);
			return tagCloseStart;
		}
		if (code$1 === 63) {
			effects.consume(code$1);
			return instruction;
		}
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			return tagOpen;
		}
		return nok(code$1);
	}
	function declarationOpen(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			return commentOpenInside;
		}
		if (code$1 === 91) {
			effects.consume(code$1);
			index = 0;
			return cdataOpenInside;
		}
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			return declaration;
		}
		return nok(code$1);
	}
	function commentOpenInside(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			return commentEnd;
		}
		return nok(code$1);
	}
	function comment(code$1) {
		if (code$1 === null) return nok(code$1);
		if (code$1 === 45) {
			effects.consume(code$1);
			return commentClose;
		}
		if (markdownLineEnding(code$1)) {
			returnState = comment;
			return lineEndingBefore(code$1);
		}
		effects.consume(code$1);
		return comment;
	}
	function commentClose(code$1) {
		if (code$1 === 45) {
			effects.consume(code$1);
			return commentEnd;
		}
		return comment(code$1);
	}
	function commentEnd(code$1) {
		return code$1 === 62 ? end(code$1) : code$1 === 45 ? commentClose(code$1) : comment(code$1);
	}
	function cdataOpenInside(code$1) {
		if (code$1 === "CDATA[".charCodeAt(index++)) {
			effects.consume(code$1);
			return index === 6 ? cdata : cdataOpenInside;
		}
		return nok(code$1);
	}
	function cdata(code$1) {
		if (code$1 === null) return nok(code$1);
		if (code$1 === 93) {
			effects.consume(code$1);
			return cdataClose;
		}
		if (markdownLineEnding(code$1)) {
			returnState = cdata;
			return lineEndingBefore(code$1);
		}
		effects.consume(code$1);
		return cdata;
	}
	function cdataClose(code$1) {
		if (code$1 === 93) {
			effects.consume(code$1);
			return cdataEnd;
		}
		return cdata(code$1);
	}
	function cdataEnd(code$1) {
		if (code$1 === 62) return end(code$1);
		if (code$1 === 93) {
			effects.consume(code$1);
			return cdataEnd;
		}
		return cdata(code$1);
	}
	function declaration(code$1) {
		if (code$1 === null || code$1 === 62) return end(code$1);
		if (markdownLineEnding(code$1)) {
			returnState = declaration;
			return lineEndingBefore(code$1);
		}
		effects.consume(code$1);
		return declaration;
	}
	function instruction(code$1) {
		if (code$1 === null) return nok(code$1);
		if (code$1 === 63) {
			effects.consume(code$1);
			return instructionClose;
		}
		if (markdownLineEnding(code$1)) {
			returnState = instruction;
			return lineEndingBefore(code$1);
		}
		effects.consume(code$1);
		return instruction;
	}
	function instructionClose(code$1) {
		return code$1 === 62 ? end(code$1) : instruction(code$1);
	}
	function tagCloseStart(code$1) {
		if (asciiAlpha(code$1)) {
			effects.consume(code$1);
			return tagClose;
		}
		return nok(code$1);
	}
	function tagClose(code$1) {
		if (code$1 === 45 || asciiAlphanumeric(code$1)) {
			effects.consume(code$1);
			return tagClose;
		}
		return tagCloseBetween(code$1);
	}
	function tagCloseBetween(code$1) {
		if (markdownLineEnding(code$1)) {
			returnState = tagCloseBetween;
			return lineEndingBefore(code$1);
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return tagCloseBetween;
		}
		return end(code$1);
	}
	function tagOpen(code$1) {
		if (code$1 === 45 || asciiAlphanumeric(code$1)) {
			effects.consume(code$1);
			return tagOpen;
		}
		if (code$1 === 47 || code$1 === 62 || markdownLineEndingOrSpace(code$1)) return tagOpenBetween(code$1);
		return nok(code$1);
	}
	function tagOpenBetween(code$1) {
		if (code$1 === 47) {
			effects.consume(code$1);
			return end;
		}
		if (code$1 === 58 || code$1 === 95 || asciiAlpha(code$1)) {
			effects.consume(code$1);
			return tagOpenAttributeName;
		}
		if (markdownLineEnding(code$1)) {
			returnState = tagOpenBetween;
			return lineEndingBefore(code$1);
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return tagOpenBetween;
		}
		return end(code$1);
	}
	function tagOpenAttributeName(code$1) {
		if (code$1 === 45 || code$1 === 46 || code$1 === 58 || code$1 === 95 || asciiAlphanumeric(code$1)) {
			effects.consume(code$1);
			return tagOpenAttributeName;
		}
		return tagOpenAttributeNameAfter(code$1);
	}
	function tagOpenAttributeNameAfter(code$1) {
		if (code$1 === 61) {
			effects.consume(code$1);
			return tagOpenAttributeValueBefore;
		}
		if (markdownLineEnding(code$1)) {
			returnState = tagOpenAttributeNameAfter;
			return lineEndingBefore(code$1);
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return tagOpenAttributeNameAfter;
		}
		return tagOpenBetween(code$1);
	}
	function tagOpenAttributeValueBefore(code$1) {
		if (code$1 === null || code$1 === 60 || code$1 === 61 || code$1 === 62 || code$1 === 96) return nok(code$1);
		if (code$1 === 34 || code$1 === 39) {
			effects.consume(code$1);
			marker = code$1;
			return tagOpenAttributeValueQuoted;
		}
		if (markdownLineEnding(code$1)) {
			returnState = tagOpenAttributeValueBefore;
			return lineEndingBefore(code$1);
		}
		if (markdownSpace(code$1)) {
			effects.consume(code$1);
			return tagOpenAttributeValueBefore;
		}
		effects.consume(code$1);
		return tagOpenAttributeValueUnquoted;
	}
	function tagOpenAttributeValueQuoted(code$1) {
		if (code$1 === marker) {
			effects.consume(code$1);
			marker = void 0;
			return tagOpenAttributeValueQuotedAfter;
		}
		if (code$1 === null) return nok(code$1);
		if (markdownLineEnding(code$1)) {
			returnState = tagOpenAttributeValueQuoted;
			return lineEndingBefore(code$1);
		}
		effects.consume(code$1);
		return tagOpenAttributeValueQuoted;
	}
	function tagOpenAttributeValueUnquoted(code$1) {
		if (code$1 === null || code$1 === 34 || code$1 === 39 || code$1 === 60 || code$1 === 61 || code$1 === 96) return nok(code$1);
		if (code$1 === 47 || code$1 === 62 || markdownLineEndingOrSpace(code$1)) return tagOpenBetween(code$1);
		effects.consume(code$1);
		return tagOpenAttributeValueUnquoted;
	}
	function tagOpenAttributeValueQuotedAfter(code$1) {
		if (code$1 === 47 || code$1 === 62 || markdownLineEndingOrSpace(code$1)) return tagOpenBetween(code$1);
		return nok(code$1);
	}
	function end(code$1) {
		if (code$1 === 62) {
			effects.consume(code$1);
			effects.exit("htmlTextData");
			effects.exit("htmlText");
			return ok;
		}
		return nok(code$1);
	}
	function lineEndingBefore(code$1) {
		effects.exit("htmlTextData");
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return lineEndingAfter;
	}
	function lineEndingAfter(code$1) {
		return markdownSpace(code$1) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self$1.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code$1) : lineEndingAfterPrefix(code$1);
	}
	function lineEndingAfterPrefix(code$1) {
		effects.enter("htmlTextData");
		return returnState(code$1);
	}
}
const labelEnd = {
	name: "labelEnd",
	resolveAll: resolveAllLabelEnd,
	resolveTo: resolveToLabelEnd,
	tokenize: tokenizeLabelEnd
};
var resourceConstruct = { tokenize: tokenizeResource };
var referenceFullConstruct = { tokenize: tokenizeReferenceFull };
var referenceCollapsedConstruct = { tokenize: tokenizeReferenceCollapsed };
function resolveAllLabelEnd(events) {
	let index = -1;
	const newEvents = [];
	while (++index < events.length) {
		const token = events[index][1];
		newEvents.push(events[index]);
		if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
			const offset = token.type === "labelImage" ? 4 : 2;
			token.type = "data";
			index += offset;
		}
	}
	if (events.length !== newEvents.length) splice(events, 0, events.length, newEvents);
	return events;
}
function resolveToLabelEnd(events, context) {
	let index = events.length;
	let offset = 0;
	let token;
	let open;
	let close$1;
	let media;
	while (index--) {
		token = events[index][1];
		if (open) {
			if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
			if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
		} else if (close$1) {
			if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
				open = index;
				if (token.type !== "labelLink") {
					offset = 2;
					break;
				}
			}
		} else if (token.type === "labelEnd") close$1 = index;
	}
	const group = {
		type: events[open][1].type === "labelLink" ? "link" : "image",
		start: { ...events[open][1].start },
		end: { ...events[events.length - 1][1].end }
	};
	const label = {
		type: "label",
		start: { ...events[open][1].start },
		end: { ...events[close$1][1].end }
	};
	const text$2 = {
		type: "labelText",
		start: { ...events[open + offset + 2][1].end },
		end: { ...events[close$1 - 2][1].start }
	};
	media = [[
		"enter",
		group,
		context
	], [
		"enter",
		label,
		context
	]];
	media = push(media, events.slice(open + 1, open + offset + 3));
	media = push(media, [[
		"enter",
		text$2,
		context
	]]);
	media = push(media, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close$1 - 3), context));
	media = push(media, [
		[
			"exit",
			text$2,
			context
		],
		events[close$1 - 2],
		events[close$1 - 1],
		[
			"exit",
			label,
			context
		]
	]);
	media = push(media, events.slice(close$1 + 1));
	media = push(media, [[
		"exit",
		group,
		context
	]]);
	splice(events, open, events.length, media);
	return events;
}
function tokenizeLabelEnd(effects, ok, nok) {
	const self$1 = this;
	let index = self$1.events.length;
	let labelStart;
	let defined;
	while (index--) if ((self$1.events[index][1].type === "labelImage" || self$1.events[index][1].type === "labelLink") && !self$1.events[index][1]._balanced) {
		labelStart = self$1.events[index][1];
		break;
	}
	return start;
	function start(code$1) {
		if (!labelStart) return nok(code$1);
		if (labelStart._inactive) return labelEndNok(code$1);
		defined = self$1.parser.defined.includes(normalizeIdentifier(self$1.sliceSerialize({
			start: labelStart.end,
			end: self$1.now()
		})));
		effects.enter("labelEnd");
		effects.enter("labelMarker");
		effects.consume(code$1);
		effects.exit("labelMarker");
		effects.exit("labelEnd");
		return after;
	}
	function after(code$1) {
		if (code$1 === 40) return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code$1);
		if (code$1 === 91) return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code$1);
		return defined ? labelEndOk(code$1) : labelEndNok(code$1);
	}
	function referenceNotFull(code$1) {
		return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code$1);
	}
	function labelEndOk(code$1) {
		return ok(code$1);
	}
	function labelEndNok(code$1) {
		labelStart._balanced = true;
		return nok(code$1);
	}
}
function tokenizeResource(effects, ok, nok) {
	return resourceStart;
	function resourceStart(code$1) {
		effects.enter("resource");
		effects.enter("resourceMarker");
		effects.consume(code$1);
		effects.exit("resourceMarker");
		return resourceBefore;
	}
	function resourceBefore(code$1) {
		return markdownLineEndingOrSpace(code$1) ? factoryWhitespace(effects, resourceOpen)(code$1) : resourceOpen(code$1);
	}
	function resourceOpen(code$1) {
		if (code$1 === 41) return resourceEnd(code$1);
		return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code$1);
	}
	function resourceDestinationAfter(code$1) {
		return markdownLineEndingOrSpace(code$1) ? factoryWhitespace(effects, resourceBetween)(code$1) : resourceEnd(code$1);
	}
	function resourceDestinationMissing(code$1) {
		return nok(code$1);
	}
	function resourceBetween(code$1) {
		if (code$1 === 34 || code$1 === 39 || code$1 === 40) return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code$1);
		return resourceEnd(code$1);
	}
	function resourceTitleAfter(code$1) {
		return markdownLineEndingOrSpace(code$1) ? factoryWhitespace(effects, resourceEnd)(code$1) : resourceEnd(code$1);
	}
	function resourceEnd(code$1) {
		if (code$1 === 41) {
			effects.enter("resourceMarker");
			effects.consume(code$1);
			effects.exit("resourceMarker");
			effects.exit("resource");
			return ok;
		}
		return nok(code$1);
	}
}
function tokenizeReferenceFull(effects, ok, nok) {
	const self$1 = this;
	return referenceFull;
	function referenceFull(code$1) {
		return factoryLabel.call(self$1, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code$1);
	}
	function referenceFullAfter(code$1) {
		return self$1.parser.defined.includes(normalizeIdentifier(self$1.sliceSerialize(self$1.events[self$1.events.length - 1][1]).slice(1, -1))) ? ok(code$1) : nok(code$1);
	}
	function referenceFullMissing(code$1) {
		return nok(code$1);
	}
}
function tokenizeReferenceCollapsed(effects, ok, nok) {
	return referenceCollapsedStart;
	function referenceCollapsedStart(code$1) {
		effects.enter("reference");
		effects.enter("referenceMarker");
		effects.consume(code$1);
		effects.exit("referenceMarker");
		return referenceCollapsedOpen;
	}
	function referenceCollapsedOpen(code$1) {
		if (code$1 === 93) {
			effects.enter("referenceMarker");
			effects.consume(code$1);
			effects.exit("referenceMarker");
			effects.exit("reference");
			return ok;
		}
		return nok(code$1);
	}
}
const labelStartImage = {
	name: "labelStartImage",
	resolveAll: labelEnd.resolveAll,
	tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		effects.enter("labelImage");
		effects.enter("labelImageMarker");
		effects.consume(code$1);
		effects.exit("labelImageMarker");
		return open;
	}
	function open(code$1) {
		if (code$1 === 91) {
			effects.enter("labelMarker");
			effects.consume(code$1);
			effects.exit("labelMarker");
			effects.exit("labelImage");
			return after;
		}
		return nok(code$1);
	}
	function after(code$1) {
		/* c8 ignore next 3 */
		return code$1 === 94 && "_hiddenFootnoteSupport" in self$1.parser.constructs ? nok(code$1) : ok(code$1);
	}
}
const labelStartLink = {
	name: "labelStartLink",
	resolveAll: labelEnd.resolveAll,
	tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(effects, ok, nok) {
	const self$1 = this;
	return start;
	function start(code$1) {
		effects.enter("labelLink");
		effects.enter("labelMarker");
		effects.consume(code$1);
		effects.exit("labelMarker");
		effects.exit("labelLink");
		return after;
	}
	function after(code$1) {
		/* c8 ignore next 3 */
		return code$1 === 94 && "_hiddenFootnoteSupport" in self$1.parser.constructs ? nok(code$1) : ok(code$1);
	}
}
const lineEnding = {
	name: "lineEnding",
	tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok) {
	return start;
	function start(code$1) {
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		return factorySpace(effects, ok, "linePrefix");
	}
}
const thematicBreak = {
	name: "thematicBreak",
	tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok, nok) {
	let size = 0;
	let marker;
	return start;
	function start(code$1) {
		effects.enter("thematicBreak");
		return before(code$1);
	}
	function before(code$1) {
		marker = code$1;
		return atBreak(code$1);
	}
	function atBreak(code$1) {
		if (code$1 === marker) {
			effects.enter("thematicBreakSequence");
			return sequence(code$1);
		}
		if (size >= 3 && (code$1 === null || markdownLineEnding(code$1))) {
			effects.exit("thematicBreak");
			return ok(code$1);
		}
		return nok(code$1);
	}
	function sequence(code$1) {
		if (code$1 === marker) {
			effects.consume(code$1);
			size++;
			return sequence;
		}
		effects.exit("thematicBreakSequence");
		return markdownSpace(code$1) ? factorySpace(effects, atBreak, "whitespace")(code$1) : atBreak(code$1);
	}
}
const list = {
	continuation: { tokenize: tokenizeListContinuation },
	exit: tokenizeListEnd,
	name: "list",
	tokenize: tokenizeListStart
};
var listItemPrefixWhitespaceConstruct = {
	partial: true,
	tokenize: tokenizeListItemPrefixWhitespace
};
var indentConstruct = {
	partial: true,
	tokenize: tokenizeIndent
};
function tokenizeListStart(effects, ok, nok) {
	const self$1 = this;
	const tail = self$1.events[self$1.events.length - 1];
	let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
	let size = 0;
	return start;
	function start(code$1) {
		const kind = self$1.containerState.type || (code$1 === 42 || code$1 === 43 || code$1 === 45 ? "listUnordered" : "listOrdered");
		if (kind === "listUnordered" ? !self$1.containerState.marker || code$1 === self$1.containerState.marker : asciiDigit(code$1)) {
			if (!self$1.containerState.type) {
				self$1.containerState.type = kind;
				effects.enter(kind, { _container: true });
			}
			if (kind === "listUnordered") {
				effects.enter("listItemPrefix");
				return code$1 === 42 || code$1 === 45 ? effects.check(thematicBreak, nok, atMarker)(code$1) : atMarker(code$1);
			}
			if (!self$1.interrupt || code$1 === 49) {
				effects.enter("listItemPrefix");
				effects.enter("listItemValue");
				return inside(code$1);
			}
		}
		return nok(code$1);
	}
	function inside(code$1) {
		if (asciiDigit(code$1) && ++size < 10) {
			effects.consume(code$1);
			return inside;
		}
		if ((!self$1.interrupt || size < 2) && (self$1.containerState.marker ? code$1 === self$1.containerState.marker : code$1 === 41 || code$1 === 46)) {
			effects.exit("listItemValue");
			return atMarker(code$1);
		}
		return nok(code$1);
	}
	function atMarker(code$1) {
		effects.enter("listItemMarker");
		effects.consume(code$1);
		effects.exit("listItemMarker");
		self$1.containerState.marker = self$1.containerState.marker || code$1;
		return effects.check(blankLine, self$1.interrupt ? nok : onBlank, effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
	}
	function onBlank(code$1) {
		self$1.containerState.initialBlankLine = true;
		initialSize++;
		return endOfPrefix(code$1);
	}
	function otherPrefix(code$1) {
		if (markdownSpace(code$1)) {
			effects.enter("listItemPrefixWhitespace");
			effects.consume(code$1);
			effects.exit("listItemPrefixWhitespace");
			return endOfPrefix;
		}
		return nok(code$1);
	}
	function endOfPrefix(code$1) {
		self$1.containerState.size = initialSize + self$1.sliceSerialize(effects.exit("listItemPrefix"), true).length;
		return ok(code$1);
	}
}
function tokenizeListContinuation(effects, ok, nok) {
	const self$1 = this;
	self$1.containerState._closeFlow = void 0;
	return effects.check(blankLine, onBlank, notBlank);
	function onBlank(code$1) {
		self$1.containerState.furtherBlankLines = self$1.containerState.furtherBlankLines || self$1.containerState.initialBlankLine;
		return factorySpace(effects, ok, "listItemIndent", self$1.containerState.size + 1)(code$1);
	}
	function notBlank(code$1) {
		if (self$1.containerState.furtherBlankLines || !markdownSpace(code$1)) {
			self$1.containerState.furtherBlankLines = void 0;
			self$1.containerState.initialBlankLine = void 0;
			return notInCurrentItem(code$1);
		}
		self$1.containerState.furtherBlankLines = void 0;
		self$1.containerState.initialBlankLine = void 0;
		return effects.attempt(indentConstruct, ok, notInCurrentItem)(code$1);
	}
	function notInCurrentItem(code$1) {
		self$1.containerState._closeFlow = true;
		self$1.interrupt = void 0;
		return factorySpace(effects, effects.attempt(list, ok, nok), "linePrefix", self$1.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code$1);
	}
}
function tokenizeIndent(effects, ok, nok) {
	const self$1 = this;
	return factorySpace(effects, afterPrefix, "listItemIndent", self$1.containerState.size + 1);
	function afterPrefix(code$1) {
		const tail = self$1.events[self$1.events.length - 1];
		return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self$1.containerState.size ? ok(code$1) : nok(code$1);
	}
}
function tokenizeListEnd(effects) {
	effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
	const self$1 = this;
	return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self$1.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
	function afterPrefix(code$1) {
		const tail = self$1.events[self$1.events.length - 1];
		return !markdownSpace(code$1) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code$1) : nok(code$1);
	}
}
const setextUnderline = {
	name: "setextUnderline",
	resolveTo: resolveToSetextUnderline,
	tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(events, context) {
	let index = events.length;
	let content$2;
	let text$2;
	let definition$1;
	while (index--) if (events[index][0] === "enter") {
		if (events[index][1].type === "content") {
			content$2 = index;
			break;
		}
		if (events[index][1].type === "paragraph") text$2 = index;
	} else {
		if (events[index][1].type === "content") events.splice(index, 1);
		if (!definition$1 && events[index][1].type === "definition") definition$1 = index;
	}
	const heading = {
		type: "setextHeading",
		start: { ...events[content$2][1].start },
		end: { ...events[events.length - 1][1].end }
	};
	events[text$2][1].type = "setextHeadingText";
	if (definition$1) {
		events.splice(text$2, 0, [
			"enter",
			heading,
			context
		]);
		events.splice(definition$1 + 1, 0, [
			"exit",
			events[content$2][1],
			context
		]);
		events[content$2][1].end = { ...events[definition$1][1].end };
	} else events[content$2][1] = heading;
	events.push([
		"exit",
		heading,
		context
	]);
	return events;
}
function tokenizeSetextUnderline(effects, ok, nok) {
	const self$1 = this;
	let marker;
	return start;
	function start(code$1) {
		let index = self$1.events.length;
		let paragraph;
		while (index--) if (self$1.events[index][1].type !== "lineEnding" && self$1.events[index][1].type !== "linePrefix" && self$1.events[index][1].type !== "content") {
			paragraph = self$1.events[index][1].type === "paragraph";
			break;
		}
		if (!self$1.parser.lazy[self$1.now().line] && (self$1.interrupt || paragraph)) {
			effects.enter("setextHeadingLine");
			marker = code$1;
			return before(code$1);
		}
		return nok(code$1);
	}
	function before(code$1) {
		effects.enter("setextHeadingLineSequence");
		return inside(code$1);
	}
	function inside(code$1) {
		if (code$1 === marker) {
			effects.consume(code$1);
			return inside;
		}
		effects.exit("setextHeadingLineSequence");
		return markdownSpace(code$1) ? factorySpace(effects, after, "lineSuffix")(code$1) : after(code$1);
	}
	function after(code$1) {
		if (code$1 === null || markdownLineEnding(code$1)) {
			effects.exit("setextHeadingLine");
			return ok(code$1);
		}
		return nok(code$1);
	}
}
const flow = { tokenize: initializeFlow };
function initializeFlow(effects) {
	const self$1 = this;
	const initial = effects.attempt(blankLine, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content$1, afterConstruct)), "linePrefix")));
	return initial;
	function atBlankEnding(code$1) {
		if (code$1 === null) {
			effects.consume(code$1);
			return;
		}
		effects.enter("lineEndingBlank");
		effects.consume(code$1);
		effects.exit("lineEndingBlank");
		self$1.currentConstruct = void 0;
		return initial;
	}
	function afterConstruct(code$1) {
		if (code$1 === null) {
			effects.consume(code$1);
			return;
		}
		effects.enter("lineEnding");
		effects.consume(code$1);
		effects.exit("lineEnding");
		self$1.currentConstruct = void 0;
		return initial;
	}
}
const resolver = { resolveAll: createResolver() };
const string = initializeFactory("string");
const text = initializeFactory("text");
function initializeFactory(field) {
	return {
		resolveAll: createResolver(field === "text" ? resolveAllLineSuffixes : void 0),
		tokenize: initializeText
	};
	function initializeText(effects) {
		const self$1 = this;
		const constructs = this.parser.constructs[field];
		const text$2 = effects.attempt(constructs, start, notText);
		return start;
		function start(code$1) {
			return atBreak(code$1) ? text$2(code$1) : notText(code$1);
		}
		function notText(code$1) {
			if (code$1 === null) {
				effects.consume(code$1);
				return;
			}
			effects.enter("data");
			effects.consume(code$1);
			return data;
		}
		function data(code$1) {
			if (atBreak(code$1)) {
				effects.exit("data");
				return text$2(code$1);
			}
			effects.consume(code$1);
			return data;
		}
		function atBreak(code$1) {
			if (code$1 === null) return true;
			const list$1 = constructs[code$1];
			let index = -1;
			if (list$1) while (++index < list$1.length) {
				const item = list$1[index];
				if (!item.previous || item.previous.call(self$1, self$1.previous)) return true;
			}
			return false;
		}
	}
}
function createResolver(extraResolver) {
	return resolveAllText;
	function resolveAllText(events, context) {
		let index = -1;
		let enter;
		while (++index <= events.length) if (enter === void 0) {
			if (events[index] && events[index][1].type === "data") {
				enter = index;
				index++;
			}
		} else if (!events[index] || events[index][1].type !== "data") {
			if (index !== enter + 2) {
				events[enter][1].end = events[index - 1][1].end;
				events.splice(enter + 2, index - enter - 2);
				index = enter + 2;
			}
			enter = void 0;
		}
		return extraResolver ? extraResolver(events, context) : events;
	}
}
function resolveAllLineSuffixes(events, context) {
	let eventIndex = 0;
	while (++eventIndex <= events.length) if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
		const data = events[eventIndex - 1][1];
		const chunks = context.sliceStream(data);
		let index = chunks.length;
		let bufferIndex = -1;
		let size = 0;
		let tabs;
		while (index--) {
			const chunk = chunks[index];
			if (typeof chunk === "string") {
				bufferIndex = chunk.length;
				while (chunk.charCodeAt(bufferIndex - 1) === 32) {
					size++;
					bufferIndex--;
				}
				if (bufferIndex) break;
				bufferIndex = -1;
			} else if (chunk === -2) {
				tabs = true;
				size++;
			} else if (chunk === -1) {} else {
				index++;
				break;
			}
		}
		if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
		if (size) {
			const token = {
				type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
				start: {
					_bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
					_index: data.start._index + index,
					line: data.end.line,
					column: data.end.column - size,
					offset: data.end.offset - size
				},
				end: { ...data.end }
			};
			data.end = { ...token.start };
			if (data.start.offset === data.end.offset) Object.assign(data, token);
			else {
				events.splice(eventIndex, 0, [
					"enter",
					token,
					context
				], [
					"exit",
					token,
					context
				]);
				eventIndex += 2;
			}
		}
		eventIndex++;
	}
	return events;
}
var constructs_exports = /* @__PURE__ */ __export({
	attentionMarkers: () => attentionMarkers,
	contentInitial: () => contentInitial,
	disable: () => disable,
	document: () => document$2,
	flow: () => flow$1,
	flowInitial: () => flowInitial,
	insideSpan: () => insideSpan,
	string: () => string$1,
	text: () => text$1
}, 1);
const document$2 = {
	[42]: list,
	[43]: list,
	[45]: list,
	[48]: list,
	[49]: list,
	[50]: list,
	[51]: list,
	[52]: list,
	[53]: list,
	[54]: list,
	[55]: list,
	[56]: list,
	[57]: list,
	[62]: blockQuote
};
const contentInitial = { [91]: definition };
const flowInitial = {
	[-2]: codeIndented,
	[-1]: codeIndented,
	[32]: codeIndented
};
const flow$1 = {
	[35]: headingAtx,
	[42]: thematicBreak,
	[45]: [setextUnderline, thematicBreak],
	[60]: htmlFlow,
	[61]: setextUnderline,
	[95]: thematicBreak,
	[96]: codeFenced,
	[126]: codeFenced
};
const string$1 = {
	[38]: characterReference,
	[92]: characterEscape
};
const text$1 = {
	[-5]: lineEnding,
	[-4]: lineEnding,
	[-3]: lineEnding,
	[33]: labelStartImage,
	[38]: characterReference,
	[42]: attention,
	[60]: [autolink, htmlText],
	[91]: labelStartLink,
	[92]: [hardBreakEscape, characterEscape],
	[93]: labelEnd,
	[95]: attention,
	[96]: codeText
};
const insideSpan = { null: [attention, resolver] };
const attentionMarkers = { null: [42, 95] };
const disable = { null: [] };
function createTokenizer(parser, initialize, from) {
	let point$1 = {
		_bufferIndex: -1,
		_index: 0,
		line: from && from.line || 1,
		column: from && from.column || 1,
		offset: from && from.offset || 0
	};
	const columnStart = {};
	const resolveAllConstructs = [];
	let chunks = [];
	let stack = [];
	const effects = {
		attempt: constructFactory(onsuccessfulconstruct),
		check: constructFactory(onsuccessfulcheck),
		consume,
		enter,
		exit: exit$1,
		interrupt: constructFactory(onsuccessfulcheck, { interrupt: true })
	};
	const context = {
		code: null,
		containerState: {},
		defineSkip,
		events: [],
		now,
		parser,
		previous: null,
		sliceSerialize,
		sliceStream,
		write
	};
	let state = initialize.tokenize.call(context, effects);
	if (initialize.resolveAll) resolveAllConstructs.push(initialize);
	return context;
	function write(slice) {
		chunks = push(chunks, slice);
		main();
		if (chunks[chunks.length - 1] !== null) return [];
		addResult(initialize, 0);
		context.events = resolveAll(resolveAllConstructs, context.events, context);
		return context.events;
	}
	function sliceSerialize(token, expandTabs) {
		return serializeChunks(sliceStream(token), expandTabs);
	}
	function sliceStream(token) {
		return sliceChunks(chunks, token);
	}
	function now() {
		const { _bufferIndex, _index, line, column, offset } = point$1;
		return {
			_bufferIndex,
			_index,
			line,
			column,
			offset
		};
	}
	function defineSkip(value) {
		columnStart[value.line] = value.column;
		accountForPotentialSkip();
	}
	function main() {
		let chunkIndex;
		while (point$1._index < chunks.length) {
			const chunk = chunks[point$1._index];
			if (typeof chunk === "string") {
				chunkIndex = point$1._index;
				if (point$1._bufferIndex < 0) point$1._bufferIndex = 0;
				while (point$1._index === chunkIndex && point$1._bufferIndex < chunk.length) go(chunk.charCodeAt(point$1._bufferIndex));
			} else go(chunk);
		}
	}
	function go(code$1) {
		state = state(code$1);
	}
	function consume(code$1) {
		if (markdownLineEnding(code$1)) {
			point$1.line++;
			point$1.column = 1;
			point$1.offset += code$1 === -3 ? 2 : 1;
			accountForPotentialSkip();
		} else if (code$1 !== -1) {
			point$1.column++;
			point$1.offset++;
		}
		if (point$1._bufferIndex < 0) point$1._index++;
		else {
			point$1._bufferIndex++;
			if (point$1._bufferIndex === chunks[point$1._index].length) {
				point$1._bufferIndex = -1;
				point$1._index++;
			}
		}
		context.previous = code$1;
	}
	function enter(type, fields) {
		const token = fields || {};
		token.type = type;
		token.start = now();
		context.events.push([
			"enter",
			token,
			context
		]);
		stack.push(token);
		return token;
	}
	function exit$1(type) {
		const token = stack.pop();
		token.end = now();
		context.events.push([
			"exit",
			token,
			context
		]);
		return token;
	}
	function onsuccessfulconstruct(construct, info) {
		addResult(construct, info.from);
	}
	function onsuccessfulcheck(_, info) {
		info.restore();
	}
	function constructFactory(onreturn, fields) {
		return hook;
		function hook(constructs, returnState, bogusState) {
			let listOfConstructs;
			let constructIndex;
			let currentConstruct;
			let info;
			return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([constructs]) : handleMapOfConstructs(constructs);
			function handleMapOfConstructs(map) {
				return start;
				function start(code$1) {
					const left = code$1 !== null && map[code$1];
					const all = code$1 !== null && map.null;
					return handleListOfConstructs([...Array.isArray(left) ? left : left ? [left] : [], ...Array.isArray(all) ? all : all ? [all] : []])(code$1);
				}
			}
			function handleListOfConstructs(list$1) {
				listOfConstructs = list$1;
				constructIndex = 0;
				if (list$1.length === 0) return bogusState;
				return handleConstruct(list$1[constructIndex]);
			}
			function handleConstruct(construct) {
				return start;
				function start(code$1) {
					info = store();
					currentConstruct = construct;
					if (!construct.partial) context.currentConstruct = construct;
					if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code$1);
					return construct.tokenize.call(fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code$1);
				}
			}
			function ok(code$1) {
				onreturn(currentConstruct, info);
				return returnState;
			}
			function nok(code$1) {
				info.restore();
				if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
				return bogusState;
			}
		}
	}
	function addResult(construct, from$1) {
		if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
		if (construct.resolve) splice(context.events, from$1, context.events.length - from$1, construct.resolve(context.events.slice(from$1), context));
		if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
	}
	function store() {
		const startPoint = now();
		const startPrevious = context.previous;
		const startCurrentConstruct = context.currentConstruct;
		const startEventsIndex = context.events.length;
		const startStack = Array.from(stack);
		return {
			from: startEventsIndex,
			restore
		};
		function restore() {
			point$1 = startPoint;
			context.previous = startPrevious;
			context.currentConstruct = startCurrentConstruct;
			context.events.length = startEventsIndex;
			stack = startStack;
			accountForPotentialSkip();
		}
	}
	function accountForPotentialSkip() {
		if (point$1.line in columnStart && point$1.column < 2) {
			point$1.column = columnStart[point$1.line];
			point$1.offset += columnStart[point$1.line] - 1;
		}
	}
}
function sliceChunks(chunks, token) {
	const startIndex = token.start._index;
	const startBufferIndex = token.start._bufferIndex;
	const endIndex = token.end._index;
	const endBufferIndex = token.end._bufferIndex;
	let view;
	if (startIndex === endIndex) view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
	else {
		view = chunks.slice(startIndex, endIndex);
		if (startBufferIndex > -1) {
			const head = view[0];
			if (typeof head === "string") view[0] = head.slice(startBufferIndex);
			else view.shift();
		}
		if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
	}
	return view;
}
function serializeChunks(chunks, expandTabs) {
	let index = -1;
	const result = [];
	let atTab;
	while (++index < chunks.length) {
		const chunk = chunks[index];
		let value;
		if (typeof chunk === "string") value = chunk;
		else switch (chunk) {
			case -5:
				value = "\r";
				break;
			case -4:
				value = "\n";
				break;
			case -3:
				value = "\r\n";
				break;
			case -2:
				value = expandTabs ? " " : "	";
				break;
			case -1:
				if (!expandTabs && atTab) continue;
				value = " ";
				break;
			default: value = String.fromCharCode(chunk);
		}
		atTab = chunk === -2;
		result.push(value);
	}
	return result.join("");
}
function parse(options) {
	const parser = {
		constructs: combineExtensions([constructs_exports, ...(options || {}).extensions || []]),
		content: create(content),
		defined: [],
		document: create(document$1),
		flow: create(flow),
		lazy: {},
		string: create(string),
		text: create(text)
	};
	return parser;
	function create(initial) {
		return creator;
		function creator(from) {
			return createTokenizer(parser, initial, from);
		}
	}
}
function postprocess(events) {
	while (!subtokenize(events));
	return events;
}
var search = /[\0\t\n\r]/g;
function preprocess() {
	let column = 1;
	let buffer = "";
	let start = true;
	let atCarriageReturn;
	return preprocessor;
	function preprocessor(value, encoding, end) {
		const chunks = [];
		let match;
		let next;
		let startPosition;
		let endPosition;
		let code$1;
		value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value));
		startPosition = 0;
		buffer = "";
		if (start) {
			if (value.charCodeAt(0) === 65279) startPosition++;
			start = void 0;
		}
		while (startPosition < value.length) {
			search.lastIndex = startPosition;
			match = search.exec(value);
			endPosition = match && match.index !== void 0 ? match.index : value.length;
			code$1 = value.charCodeAt(endPosition);
			if (!match) {
				buffer = value.slice(startPosition);
				break;
			}
			if (code$1 === 10 && startPosition === endPosition && atCarriageReturn) {
				chunks.push(-3);
				atCarriageReturn = void 0;
			} else {
				if (atCarriageReturn) {
					chunks.push(-5);
					atCarriageReturn = void 0;
				}
				if (startPosition < endPosition) {
					chunks.push(value.slice(startPosition, endPosition));
					column += endPosition - startPosition;
				}
				switch (code$1) {
					case 0:
						chunks.push(65533);
						column++;
						break;
					case 9:
						next = Math.ceil(column / 4) * 4;
						chunks.push(-2);
						while (column++ < next) chunks.push(-1);
						break;
					case 10:
						chunks.push(-4);
						column = 1;
						break;
					default:
						atCarriageReturn = true;
						column = 1;
				}
			}
			startPosition = endPosition + 1;
		}
		if (end) {
			if (atCarriageReturn) chunks.push(-5);
			if (buffer) chunks.push(buffer);
			chunks.push(null);
		}
		return chunks;
	}
}
var own = {}.hasOwnProperty;
function fromMarkdown(value, encoding, options) {
	if (encoding && typeof encoding === "object") {
		options = encoding;
		encoding = void 0;
	}
	return compiler(options)(postprocess(parse(options).document().write(preprocess()(value, encoding, true))));
}
function compiler(options) {
	const config$43 = {
		transforms: [],
		canContainEols: [
			"emphasis",
			"fragment",
			"heading",
			"paragraph",
			"strong"
		],
		enter: {
			autolink: opener(link),
			autolinkProtocol: onenterdata,
			autolinkEmail: onenterdata,
			atxHeading: opener(heading),
			blockQuote: opener(blockQuote$1),
			characterEscape: onenterdata,
			characterReference: onenterdata,
			codeFenced: opener(codeFlow),
			codeFencedFenceInfo: buffer,
			codeFencedFenceMeta: buffer,
			codeIndented: opener(codeFlow, buffer),
			codeText: opener(codeText$1, buffer),
			codeTextData: onenterdata,
			data: onenterdata,
			codeFlowValue: onenterdata,
			definition: opener(definition$1),
			definitionDestinationString: buffer,
			definitionLabelString: buffer,
			definitionTitleString: buffer,
			emphasis: opener(emphasis),
			hardBreakEscape: opener(hardBreak),
			hardBreakTrailing: opener(hardBreak),
			htmlFlow: opener(html, buffer),
			htmlFlowData: onenterdata,
			htmlText: opener(html, buffer),
			htmlTextData: onenterdata,
			image: opener(image),
			label: buffer,
			link: opener(link),
			listItem: opener(listItem),
			listItemValue: onenterlistitemvalue,
			listOrdered: opener(list$1, onenterlistordered),
			listUnordered: opener(list$1),
			paragraph: opener(paragraph),
			reference: onenterreference,
			referenceString: buffer,
			resourceDestinationString: buffer,
			resourceTitleString: buffer,
			setextHeading: opener(heading),
			strong: opener(strong),
			thematicBreak: opener(thematicBreak$1)
		},
		exit: {
			atxHeading: closer(),
			atxHeadingSequence: onexitatxheadingsequence,
			autolink: closer(),
			autolinkEmail: onexitautolinkemail,
			autolinkProtocol: onexitautolinkprotocol,
			blockQuote: closer(),
			characterEscapeValue: onexitdata,
			characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
			characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
			characterReferenceValue: onexitcharacterreferencevalue,
			characterReference: onexitcharacterreference,
			codeFenced: closer(onexitcodefenced),
			codeFencedFence: onexitcodefencedfence,
			codeFencedFenceInfo: onexitcodefencedfenceinfo,
			codeFencedFenceMeta: onexitcodefencedfencemeta,
			codeFlowValue: onexitdata,
			codeIndented: closer(onexitcodeindented),
			codeText: closer(onexitcodetext),
			codeTextData: onexitdata,
			data: onexitdata,
			definition: closer(),
			definitionDestinationString: onexitdefinitiondestinationstring,
			definitionLabelString: onexitdefinitionlabelstring,
			definitionTitleString: onexitdefinitiontitlestring,
			emphasis: closer(),
			hardBreakEscape: closer(onexithardbreak),
			hardBreakTrailing: closer(onexithardbreak),
			htmlFlow: closer(onexithtmlflow),
			htmlFlowData: onexitdata,
			htmlText: closer(onexithtmltext),
			htmlTextData: onexitdata,
			image: closer(onexitimage),
			label: onexitlabel,
			labelText: onexitlabeltext,
			lineEnding: onexitlineending,
			link: closer(onexitlink),
			listItem: closer(),
			listOrdered: closer(),
			listUnordered: closer(),
			paragraph: closer(),
			referenceString: onexitreferencestring,
			resourceDestinationString: onexitresourcedestinationstring,
			resourceTitleString: onexitresourcetitlestring,
			resource: onexitresource,
			setextHeading: closer(onexitsetextheading),
			setextHeadingLineSequence: onexitsetextheadinglinesequence,
			setextHeadingText: onexitsetextheadingtext,
			strong: closer(),
			thematicBreak: closer()
		}
	};
	configure(config$43, (options || {}).mdastExtensions || []);
	const data = {};
	return compile;
	function compile(events) {
		let tree = {
			type: "root",
			children: []
		};
		const context = {
			stack: [tree],
			tokenStack: [],
			config: config$43,
			enter,
			exit: exit$1,
			buffer,
			resume,
			data
		};
		const listStack = [];
		let index = -1;
		while (++index < events.length) if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") if (events[index][0] === "enter") listStack.push(index);
		else index = prepareList(events, listStack.pop(), index);
		index = -1;
		while (++index < events.length) {
			const handler$1 = config$43[events[index][0]];
			if (own.call(handler$1, events[index][1].type)) handler$1[events[index][1].type].call(Object.assign({ sliceSerialize: events[index][2].sliceSerialize }, context), events[index][1]);
		}
		if (context.tokenStack.length > 0) {
			const tail = context.tokenStack[context.tokenStack.length - 1];
			(tail[1] || defaultOnError).call(context, void 0, tail[0]);
		}
		tree.position = {
			start: point(events.length > 0 ? events[0][1].start : {
				line: 1,
				column: 1,
				offset: 0
			}),
			end: point(events.length > 0 ? events[events.length - 2][1].end : {
				line: 1,
				column: 1,
				offset: 0
			})
		};
		index = -1;
		while (++index < config$43.transforms.length) tree = config$43.transforms[index](tree) || tree;
		return tree;
	}
	function prepareList(events, start, length) {
		let index = start - 1;
		let containerBalance = -1;
		let listSpread = false;
		let listItem$1;
		let lineIndex;
		let firstBlankLineIndex;
		let atMarker;
		while (++index <= length) {
			const event = events[index];
			switch (event[1].type) {
				case "listUnordered":
				case "listOrdered":
				case "blockQuote":
					if (event[0] === "enter") containerBalance++;
					else containerBalance--;
					atMarker = void 0;
					break;
				case "lineEndingBlank":
					if (event[0] === "enter") {
						if (listItem$1 && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
						atMarker = void 0;
					}
					break;
				case "linePrefix":
				case "listItemValue":
				case "listItemMarker":
				case "listItemPrefix":
				case "listItemPrefixWhitespace": break;
				default: atMarker = void 0;
			}
			if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
				if (listItem$1) {
					let tailIndex = index;
					lineIndex = void 0;
					while (tailIndex--) {
						const tailEvent = events[tailIndex];
						if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
							if (tailEvent[0] === "exit") continue;
							if (lineIndex) {
								events[lineIndex][1].type = "lineEndingBlank";
								listSpread = true;
							}
							tailEvent[1].type = "lineEnding";
							lineIndex = tailIndex;
						} else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") {} else break;
					}
					if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem$1._spread = true;
					listItem$1.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
					events.splice(lineIndex || index, 0, [
						"exit",
						listItem$1,
						event[2]
					]);
					index++;
					length++;
				}
				if (event[1].type === "listItemPrefix") {
					const item = {
						type: "listItem",
						_spread: false,
						start: Object.assign({}, event[1].start),
						end: void 0
					};
					listItem$1 = item;
					events.splice(index, 0, [
						"enter",
						item,
						event[2]
					]);
					index++;
					length++;
					firstBlankLineIndex = void 0;
					atMarker = true;
				}
			}
		}
		events[start][1]._spread = listSpread;
		return length;
	}
	function opener(create, and) {
		return open;
		function open(token) {
			enter.call(this, create(token), token);
			if (and) and.call(this, token);
		}
	}
	function buffer() {
		this.stack.push({
			type: "fragment",
			children: []
		});
	}
	function enter(node, token, errorHandler) {
		this.stack[this.stack.length - 1].children.push(node);
		this.stack.push(node);
		this.tokenStack.push([token, errorHandler || void 0]);
		node.position = {
			start: point(token.start),
			end: void 0
		};
	}
	function closer(and) {
		return close$1;
		function close$1(token) {
			if (and) and.call(this, token);
			exit$1.call(this, token);
		}
	}
	function exit$1(token, onExitError) {
		const node = this.stack.pop();
		const open = this.tokenStack.pop();
		if (!open) throw new Error("Cannot close `" + token.type + "` (" + stringifyPosition({
			start: token.start,
			end: token.end
		}) + "): it’s not open");
		else if (open[0].type !== token.type) if (onExitError) onExitError.call(this, token, open[0]);
		else (open[1] || defaultOnError).call(this, token, open[0]);
		node.position.end = point(token.end);
	}
	function resume() {
		return toString(this.stack.pop());
	}
	function onenterlistordered() {
		this.data.expectingFirstListItemValue = true;
	}
	function onenterlistitemvalue(token) {
		if (this.data.expectingFirstListItemValue) {
			const ancestor = this.stack[this.stack.length - 2];
			ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
			this.data.expectingFirstListItemValue = void 0;
		}
	}
	function onexitcodefencedfenceinfo() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.lang = data$1;
	}
	function onexitcodefencedfencemeta() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.meta = data$1;
	}
	function onexitcodefencedfence() {
		if (this.data.flowCodeInside) return;
		this.buffer();
		this.data.flowCodeInside = true;
	}
	function onexitcodefenced() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.value = data$1.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
		this.data.flowCodeInside = void 0;
	}
	function onexitcodeindented() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.value = data$1.replace(/(\r?\n|\r)$/g, "");
	}
	function onexitdefinitionlabelstring(token) {
		const label = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.label = label;
		node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
	}
	function onexitdefinitiontitlestring() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.title = data$1;
	}
	function onexitdefinitiondestinationstring() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.url = data$1;
	}
	function onexitatxheadingsequence(token) {
		const node = this.stack[this.stack.length - 1];
		if (!node.depth) node.depth = this.sliceSerialize(token).length;
	}
	function onexitsetextheadingtext() {
		this.data.setextHeadingSlurpLineEnding = true;
	}
	function onexitsetextheadinglinesequence(token) {
		const node = this.stack[this.stack.length - 1];
		node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
	}
	function onexitsetextheading() {
		this.data.setextHeadingSlurpLineEnding = void 0;
	}
	function onenterdata(token) {
		const siblings = this.stack[this.stack.length - 1].children;
		let tail = siblings[siblings.length - 1];
		if (!tail || tail.type !== "text") {
			tail = text$2();
			tail.position = {
				start: point(token.start),
				end: void 0
			};
			siblings.push(tail);
		}
		this.stack.push(tail);
	}
	function onexitdata(token) {
		const tail = this.stack.pop();
		tail.value += this.sliceSerialize(token);
		tail.position.end = point(token.end);
	}
	function onexitlineending(token) {
		const context = this.stack[this.stack.length - 1];
		if (this.data.atHardBreak) {
			const tail = context.children[context.children.length - 1];
			tail.position.end = point(token.end);
			this.data.atHardBreak = void 0;
			return;
		}
		if (!this.data.setextHeadingSlurpLineEnding && config$43.canContainEols.includes(context.type)) {
			onenterdata.call(this, token);
			onexitdata.call(this, token);
		}
	}
	function onexithardbreak() {
		this.data.atHardBreak = true;
	}
	function onexithtmlflow() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.value = data$1;
	}
	function onexithtmltext() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.value = data$1;
	}
	function onexitcodetext() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.value = data$1;
	}
	function onexitlink() {
		const node = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			const referenceType = this.data.referenceType || "shortcut";
			node.type += "Reference";
			node.referenceType = referenceType;
			delete node.url;
			delete node.title;
		} else {
			delete node.identifier;
			delete node.label;
		}
		this.data.referenceType = void 0;
	}
	function onexitimage() {
		const node = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			const referenceType = this.data.referenceType || "shortcut";
			node.type += "Reference";
			node.referenceType = referenceType;
			delete node.url;
			delete node.title;
		} else {
			delete node.identifier;
			delete node.label;
		}
		this.data.referenceType = void 0;
	}
	function onexitlabeltext(token) {
		const string$2 = this.sliceSerialize(token);
		const ancestor = this.stack[this.stack.length - 2];
		ancestor.label = decodeString(string$2);
		ancestor.identifier = normalizeIdentifier(string$2).toLowerCase();
	}
	function onexitlabel() {
		const fragment = this.stack[this.stack.length - 1];
		const value = this.resume();
		const node = this.stack[this.stack.length - 1];
		this.data.inReference = true;
		if (node.type === "link") node.children = fragment.children;
		else node.alt = value;
	}
	function onexitresourcedestinationstring() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.url = data$1;
	}
	function onexitresourcetitlestring() {
		const data$1 = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.title = data$1;
	}
	function onexitresource() {
		this.data.inReference = void 0;
	}
	function onenterreference() {
		this.data.referenceType = "collapsed";
	}
	function onexitreferencestring(token) {
		const label = this.resume();
		const node = this.stack[this.stack.length - 1];
		node.label = label;
		node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
		this.data.referenceType = "full";
	}
	function onexitcharacterreferencemarker(token) {
		this.data.characterReferenceType = token.type;
	}
	function onexitcharacterreferencevalue(token) {
		const data$1 = this.sliceSerialize(token);
		const type = this.data.characterReferenceType;
		let value;
		if (type) {
			value = decodeNumericCharacterReference(data$1, type === "characterReferenceMarkerNumeric" ? 10 : 16);
			this.data.characterReferenceType = void 0;
		} else value = decodeNamedCharacterReference(data$1);
		const tail = this.stack[this.stack.length - 1];
		tail.value += value;
	}
	function onexitcharacterreference(token) {
		const tail = this.stack.pop();
		tail.position.end = point(token.end);
	}
	function onexitautolinkprotocol(token) {
		onexitdata.call(this, token);
		const node = this.stack[this.stack.length - 1];
		node.url = this.sliceSerialize(token);
	}
	function onexitautolinkemail(token) {
		onexitdata.call(this, token);
		const node = this.stack[this.stack.length - 1];
		node.url = "mailto:" + this.sliceSerialize(token);
	}
	function blockQuote$1() {
		return {
			type: "blockquote",
			children: []
		};
	}
	function codeFlow() {
		return {
			type: "code",
			lang: null,
			meta: null,
			value: ""
		};
	}
	function codeText$1() {
		return {
			type: "inlineCode",
			value: ""
		};
	}
	function definition$1() {
		return {
			type: "definition",
			identifier: "",
			label: null,
			title: null,
			url: ""
		};
	}
	function emphasis() {
		return {
			type: "emphasis",
			children: []
		};
	}
	function heading() {
		return {
			type: "heading",
			depth: 0,
			children: []
		};
	}
	function hardBreak() {
		return { type: "break" };
	}
	function html() {
		return {
			type: "html",
			value: ""
		};
	}
	function image() {
		return {
			type: "image",
			title: null,
			url: "",
			alt: null
		};
	}
	function link() {
		return {
			type: "link",
			title: null,
			url: "",
			children: []
		};
	}
	function list$1(token) {
		return {
			type: "list",
			ordered: token.type === "listOrdered",
			start: null,
			spread: token._spread,
			children: []
		};
	}
	function listItem(token) {
		return {
			type: "listItem",
			spread: token._spread,
			checked: null,
			children: []
		};
	}
	function paragraph() {
		return {
			type: "paragraph",
			children: []
		};
	}
	function strong() {
		return {
			type: "strong",
			children: []
		};
	}
	function text$2() {
		return {
			type: "text",
			value: ""
		};
	}
	function thematicBreak$1() {
		return { type: "thematicBreak" };
	}
}
function point(d) {
	return {
		line: d.line,
		column: d.column,
		offset: d.offset
	};
}
function configure(combined, extensions) {
	let index = -1;
	while (++index < extensions.length) {
		const value = extensions[index];
		if (Array.isArray(value)) configure(combined, value);
		else extension(combined, value);
	}
}
function extension(combined, extension$1) {
	let key;
	for (key in extension$1) if (own.call(extension$1, key)) switch (key) {
		case "canContainEols": {
			const right = extension$1[key];
			if (right) combined[key].push(...right);
			break;
		}
		case "transforms": {
			const right = extension$1[key];
			if (right) combined[key].push(...right);
			break;
		}
		case "enter":
		case "exit": {
			const right = extension$1[key];
			if (right) Object.assign(combined[key], right);
			break;
		}
	}
}
function defaultOnError(left, right) {
	if (left) throw new Error("Cannot close `" + left.type + "` (" + stringifyPosition({
		start: left.start,
		end: left.end
	}) + "): a different token (`" + right.type + "`, " + stringifyPosition({
		start: right.start,
		end: right.end
	}) + ") is open");
	else throw new Error("Cannot close document, a token (`" + right.type + "`, " + stringifyPosition({
		start: right.start,
		end: right.end
	}) + ") is still open");
}
function remarkParse(options) {
	const self$1 = this;
	self$1.parser = parser;
	function parser(doc$2) {
		return fromMarkdown(doc$2, {
			...self$1.data("settings"),
			...options,
			extensions: self$1.data("micromarkExtensions") || [],
			mdastExtensions: self$1.data("fromMarkdownExtensions") || []
		});
	}
}
function parseMarkdownToAst(markdown) {
	return unified().use(remarkParse).use(remarkGfm).parse(markdown);
}
function readImageDimensions(bytes) {
	if (!(bytes instanceof Uint8Array) || bytes.length < 12) return null;
	if (bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71) {
		if (bytes.length < 24) return null;
		const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
		const width = view.getInt32(16);
		const height = view.getInt32(20);
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	if (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255) return readJpegDimensions(bytes);
	if (bytes[0] === 71 && bytes[1] === 73 && bytes[2] === 70 && bytes[3] === 56) {
		if (bytes.length < 10) return null;
		const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
		const width = view.getUint16(6, true);
		const height = view.getUint16(8, true);
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	if (bytes[0] === 66 && bytes[1] === 77) {
		if (bytes.length < 26) return null;
		const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
		const width = view.getInt32(18, true);
		const height = Math.abs(view.getInt32(22, true));
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	if (bytes[0] === 82 && bytes[1] === 73 && bytes[2] === 70 && bytes[3] === 70 && bytes[8] === 87 && bytes[9] === 69 && bytes[10] === 66 && bytes[11] === 80) return readWebpDimensions(bytes);
	return null;
}
function readJpegDimensions(bytes) {
	const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	let offset = 2;
	while (offset + 4 < bytes.length) {
		if (bytes[offset] !== 255) return null;
		const marker = bytes[offset + 1];
		if (marker === 192 || marker === 194) {
			if (offset + 9 > bytes.length) return null;
			const height = view.getUint16(offset + 5);
			const width = view.getUint16(offset + 7);
			if (width > 0 && height > 0) return {
				width,
				height
			};
			return null;
		}
		if (marker === 217) return null;
		if (marker === 218) return null;
		const segmentLength = view.getUint16(offset + 2);
		offset += 2 + segmentLength;
	}
	return null;
}
function readWebpDimensions(bytes) {
	if (bytes.length < 16) return null;
	const chunkTag = String.fromCharCode(bytes[12], bytes[13], bytes[14], bytes[15]);
	if (chunkTag === "VP8 ") {
		if (bytes.length < 30) return null;
		const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
		const width = view.getUint16(26, true) & 16383;
		const height = view.getUint16(28, true) & 16383;
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	if (chunkTag === "VP8L") {
		if (bytes.length < 25) return null;
		const b0 = bytes[21];
		const b1 = bytes[22];
		const b2 = bytes[23];
		const b3 = bytes[24];
		const width = ((b1 & 63) << 8 | b0) + 1;
		const height = ((b3 & 15) << 10 | b2 << 2 | b1 >> 6) + 1;
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	if (chunkTag === "VP8X") {
		if (bytes.length < 30) return null;
		const width = (bytes[24] | bytes[25] << 8 | bytes[26] << 16) + 1;
		const height = (bytes[27] | bytes[28] << 8 | bytes[29] << 16) + 1;
		if (width > 0 && height > 0) return {
			width,
			height
		};
		return null;
	}
	return null;
}
function readSvgDimensions(svgText) {
	if (typeof svgText !== "string") return null;
	const svgMatch = svgText.match(/<svg\b[^>]*>/i);
	if (!svgMatch) return null;
	const widthMatch = svgMatch[0].match(/\bwidth=(["']?)([0-9.]+)(?:px)?\1/i);
	const heightMatch = svgMatch[0].match(/\bheight=(["']?)([0-9.]+)(?:px)?\1/i);
	const width = widthMatch ? Number.parseFloat(widthMatch[2]) : NaN;
	const height = heightMatch ? Number.parseFloat(heightMatch[2]) : NaN;
	if (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) return {
		width,
		height
	};
	return null;
}
function readImageDimensionsFromDataUri(dataUri) {
	if (typeof dataUri !== "string" || !dataUri.startsWith("data:")) return null;
	const metadata = getDataUriMetadata(dataUri);
	if (!metadata?.hasPayloadSeparator || !metadata.payload) return null;
	if (metadata.mimeType === "image/svg+xml") try {
		const svgText = metadata.isBase64 ? atob(metadata.payload) : tryDecodeDataUriText(metadata.payload);
		if (svgText == null) return null;
		return readSvgDimensions(svgText);
	} catch {
		return null;
	}
	if (!metadata.isBase64) return null;
	try {
		return readImageDimensions(base64ToUint8Array(metadata.payload));
	} catch {
		return null;
	}
}
function convertMdastToBlocks(root, ctx) {
	return flatMapRootChildrenPreserveBlankLines(root, ctx);
}
var FULL_WIDTH_TABLE_PCT = 5e3;
var imageDocPrIdsByContext = /* @__PURE__ */ new WeakMap();
function flatMapRootChildrenPreserveBlankLines(root, ctx) {
	const children = root.children ?? [];
	const blocks = [];
	for (let i$1 = 0; i$1 < children.length; i$1 += 1) {
		const child = children[i$1];
		blocks.push(...convertBlockNode(child, ctx));
		const next = children[i$1 + 1];
		if (!next) continue;
		const blankLines = countBlankLinesBetweenSiblings(child, next);
		for (let j = 0; j < blankLines; j += 1) blocks.push(makeParagraph([]));
	}
	return blocks;
}
function countBlankLinesBetweenSiblings(previous$1, next) {
	const previousEndLine = previous$1.position?.end?.line;
	const nextStartLine = next.position?.start?.line;
	if (typeof previousEndLine !== "number" || typeof nextStartLine !== "number") return 0;
	return Math.max(0, nextStartLine - previousEndLine - 2);
}
function convertBlockNode(node, ctx) {
	switch (node.type) {
		case "paragraph": return [convertParagraph(node, ctx)];
		case "heading": return [convertHeading(node, ctx)];
		case "list": return convertList(node, ctx, 0);
		case "blockquote": return convertBlockquote(node, ctx);
		case "code": return [convertCodeBlock(node, ctx)];
		case "thematicBreak": return [convertThematicBreak(ctx)];
		case "table": return [convertTable(node, ctx)];
		case "image": return [convertImageBlock(node, ctx)];
		case "html": return convertRawHtml(node, ctx);
		default:
			addDiagnostic$1(ctx, "warning", node.type, `Unsupported mdast block node "${node.type}" — skipped.`, node);
			return [];
	}
}
function convertParagraph(node, ctx) {
	return makeParagraph(convertInlineChildren(node.children, ctx, []));
}
var HEADING_STYLE_MAP = {
	1: "Heading1",
	2: "Heading2",
	3: "Heading3",
	4: "Heading4",
	5: "Heading5",
	6: "Heading6"
};
function convertHeading(node, ctx) {
	const styleId = HEADING_STYLE_MAP[node.depth] ?? "Heading1";
	return makeParagraph(convertInlineChildren(node.children, ctx, []), { styleId });
}
function convertList(node, ctx, depth) {
	const listType = node.ordered ? "orderedList" : "bulletList";
	let numId;
	if (!ctx.options.dryRun) {
		numId = ListHelpers.getNewListId(ctx.editor);
		ListHelpers.generateNewListDefinition({
			numId,
			listType,
			editor: ctx.editor
		});
	} else numId = 0;
	const blocks = [];
	for (let i$1 = 0; i$1 < node.children.length; i$1++) {
		const listItem = node.children[i$1];
		blocks.push(...convertListItem(listItem, ctx, numId, depth, listType));
	}
	return blocks;
}
function convertListItem(item, ctx, numId, depth, listType) {
	const blocks = [];
	let firstParagraphEmitted = false;
	for (const child of item.children) if (child.type === "paragraph") {
		const runs = convertInlineChildren(child.children, ctx, []);
		if (!firstParagraphEmitted) {
			blocks.push(makeListParagraph(runs, numId, depth));
			firstParagraphEmitted = true;
		} else blocks.push(makeParagraph(runs));
	} else if (child.type === "list") blocks.push(...convertList(child, ctx, depth + 1));
	else blocks.push(...convertBlockNode(child, ctx));
	if (blocks.length === 0) blocks.push(makeListParagraph([], numId, depth));
	return blocks;
}
function convertBlockquote(node, ctx) {
	const blocks = [];
	for (const child of node.children) if (child.type === "paragraph") {
		const runs = convertInlineChildren(child.children, ctx, []);
		blocks.push(makeParagraph(runs, { styleId: "Quote" }));
	} else blocks.push(...convertBlockNode(child, ctx));
	return blocks;
}
function convertCodeBlock(node, ctx) {
	const lines = node.value.split("\n");
	const content$2 = [];
	for (let i$1 = 0; i$1 < lines.length; i$1++) {
		if (i$1 > 0) content$2.push({ type: "lineBreak" });
		if (lines[i$1].length > 0) content$2.push(makeRun(lines[i$1], [], { rFonts: {
			ascii: "Courier New",
			hAnsi: "Courier New"
		} }));
	}
	return makeParagraph(content$2);
}
function convertThematicBreak(ctx) {
	if (ctx.schema.nodes.contentBlock != null) return makeParagraph([{
		type: "contentBlock",
		attrs: {
			horizontalRule: true,
			size: {
				width: "100%",
				height: 2
			},
			background: "#e5e7eb"
		}
	}]);
	return makeParagraph([], { pBdr: { bottom: {
		val: "single",
		sz: "6",
		space: "1",
		color: "auto"
	} } });
}
function convertTable(node, ctx) {
	const rows = [];
	for (let rowIndex = 0; rowIndex < node.children.length; rowIndex++) {
		const mdastRow = node.children[rowIndex];
		const isHeaderRow = rowIndex === 0;
		const cells = [];
		for (const mdastCell of mdastRow.children) {
			const cellParagraph = makeParagraph(convertInlineChildren(mdastCell.children, ctx, []));
			const cellType = isHeaderRow ? "tableHeader" : "tableCell";
			cells.push({
				type: cellType,
				attrs: {
					colspan: 1,
					rowspan: 1,
					colwidth: null
				},
				content: [cellParagraph]
			});
		}
		rows.push({
			type: "tableRow",
			content: cells
		});
	}
	return {
		type: "table",
		attrs: {
			tableStyleId: null,
			needsTableStyleNormalization: true,
			tableProperties: { tableWidth: {
				value: FULL_WIDTH_TABLE_PCT,
				type: "pct"
			} }
		},
		content: rows
	};
}
function convertImageBlock(node, ctx) {
	if (!node.url) {
		addDiagnostic$1(ctx, "warning", "image", "Image with empty URL — skipped.", node);
		return makeParagraph([]);
	}
	return {
		type: "paragraph",
		content: [{
			type: "image",
			attrs: buildImageAttrs(node, ctx)
		}]
	};
}
function extractHtmlTagName(html) {
	const match = html.match(/^<\/?([a-zA-Z][a-zA-Z0-9]*)/);
	return match ? match[1].toUpperCase() : "HTML";
}
function convertRawHtml(node, ctx) {
	const tagName = extractHtmlTagName(node.value);
	addDiagnostic$1(ctx, "warning", tagName, `Raw HTML <${tagName.toLowerCase()}> in markdown — converted to plain text.`, node);
	if (node.value.trim().length === 0) return [];
	return [makeParagraph([makeRun(node.value, [])])];
}
function convertInlineChildren(children, ctx, parentMarks) {
	const nodes = [];
	for (const child of children) nodes.push(...convertInlineNode(child, ctx, parentMarks));
	return nodes;
}
function convertInlineNode(node, ctx, parentMarks) {
	switch (node.type) {
		case "text": return [makeRun(node.value, parentMarks)];
		case "strong": return convertInlineChildren(node.children, ctx, [...parentMarks, { type: "bold" }]);
		case "emphasis": return convertInlineChildren(node.children, ctx, [...parentMarks, { type: "italic" }]);
		case "delete": return convertInlineChildren(node.children, ctx, [...parentMarks, { type: "strike" }]);
		case "link": return convertLink(node, ctx, parentMarks);
		case "inlineCode": return [makeRun(node.value, [...parentMarks, {
			type: "textStyle",
			attrs: { fontFamily: "Courier New" }
		}])];
		case "break": return [{ type: "lineBreak" }];
		case "image": return convertInlineImage(node, ctx);
		default:
			addDiagnostic$1(ctx, "warning", node.type === "html" ? extractHtmlTagName(node.value ?? "") : node.type, `Unsupported mdast inline node "${node.type}" — converted to text.`, node);
			if ("value" in node && typeof node.value === "string") return [makeRun(node.value, parentMarks)];
			if ("children" in node && Array.isArray(node.children)) return convertInlineChildren(node.children, ctx, parentMarks);
			return [];
	}
}
function convertLink(node, ctx, parentMarks) {
	const linkMark = {
		type: "link",
		attrs: {
			href: node.url,
			target: "_blank",
			rel: "noopener noreferrer nofollow",
			...node.title ? { tooltip: node.title } : {}
		}
	};
	return convertInlineChildren(node.children, ctx, [...parentMarks, linkMark]);
}
function convertInlineImage(node, ctx) {
	if (!node.url) {
		addDiagnostic$1(ctx, "warning", "image", "Inline image with empty URL — skipped.", node);
		return [];
	}
	return [{
		type: "image",
		attrs: buildImageAttrs(node, ctx)
	}];
}
function buildImageAttrs(node, ctx) {
	const attrs = {
		src: node.url,
		alt: node.alt ?? null,
		title: node.title ?? null,
		sdImageId: v4_default(),
		id: generateUniqueImageDocPrId(ctx)
	};
	const dimensions = readImageDimensionsFromDataUri(node.url);
	if (dimensions) attrs.size = dimensions;
	return attrs;
}
function generateUniqueImageDocPrId(ctx) {
	const existingIds = getOrCreateImageDocPrIdSet(ctx);
	let candidate = "";
	do {
		const hex = generateDocxRandomId();
		candidate = String(parseInt(hex, 16));
	} while (!candidate || existingIds.has(candidate));
	existingIds.add(candidate);
	return candidate;
}
function getOrCreateImageDocPrIdSet(ctx) {
	const cached = imageDocPrIdsByContext.get(ctx);
	if (cached) return cached;
	const existingIds = /* @__PURE__ */ new Set();
	ctx.editor?.state?.doc?.descendants((node) => {
		if (node.type.name !== "image") return true;
		if (node.attrs.id !== void 0 && node.attrs.id !== null) existingIds.add(String(node.attrs.id));
		return true;
	});
	imageDocPrIdsByContext.set(ctx, existingIds);
	return existingIds;
}
function makeParagraph(content$2, extraParagraphProps) {
	const paragraphProperties = extraParagraphProps ? { ...extraParagraphProps } : void 0;
	const attrs = {};
	if (paragraphProperties) attrs.paragraphProperties = paragraphProperties;
	return {
		type: "paragraph",
		...Object.keys(attrs).length > 0 ? { attrs } : {},
		content: content$2.length > 0 ? content$2 : void 0
	};
}
function makeListParagraph(content$2, numId, ilvl) {
	const numberingProperties = {
		numId,
		ilvl
	};
	return {
		type: "paragraph",
		attrs: {
			paragraphProperties: { numberingProperties },
			numberingProperties
		},
		content: content$2.length > 0 ? content$2 : void 0
	};
}
function makeRun(text$2, marks, extraRunProperties) {
	const runNode = {
		type: "run",
		content: [{
			type: "text",
			text: text$2,
			...marks.length > 0 ? { marks } : {}
		}]
	};
	if (extraRunProperties) runNode.attrs = { runProperties: extraRunProperties };
	return runNode;
}
function addDiagnostic$1(ctx, severity, nodeType, message, node) {
	const diagnostic = {
		severity,
		nodeType,
		message
	};
	if (node?.position?.start) diagnostic.position = {
		line: node.position.start.line,
		column: node.position.start.column
	};
	ctx.diagnostics.push(diagnostic);
}
function normalizeFixedWidthTables(markdown) {
	const lines = markdown.split("\n");
	const output = [];
	let i$1 = 0;
	while (i$1 < lines.length) {
		if (isFenceOpener(lines[i$1])) {
			const closeIdx = findFenceClose(lines, i$1);
			for (let j = i$1; j <= closeIdx; j++) output.push(lines[j]);
			i$1 = closeIdx + 1;
			continue;
		}
		if (isIndentedCodeOpener(lines[i$1])) {
			const closeIdx = findIndentedCodeClose(lines, i$1);
			for (let j = i$1; j <= closeIdx; j++) output.push(lines[j]);
			i$1 = closeIdx + 1;
			continue;
		}
		const table = tryParseTableAt(lines, i$1);
		if (table) {
			output.push(...toGfmPipeTable(table));
			i$1 = table.endLine + 1;
			continue;
		}
		output.push(lines[i$1]);
		i$1++;
	}
	return output.join("\n");
}
var FENCE_OPEN_RE = /^( {0,3})(`{3,}|~{3,})/;
var INDENTED_CODE_RE = /^(?: {4,}|\t)/;
function isFenceOpener(line) {
	return FENCE_OPEN_RE.test(line);
}
function isIndentedCodeOpener(line) {
	return INDENTED_CODE_RE.test(line);
}
function findFenceClose(lines, openIdx) {
	const match = lines[openIdx].match(FENCE_OPEN_RE);
	if (!match) return openIdx;
	const char = match[2][0] === "`" ? "`" : "~";
	const minLen = match[2].length;
	const closeRe = /* @__PURE__ */ new RegExp(`^( {0,3})${char}{${minLen},}\\s*$`);
	for (let i$1 = openIdx + 1; i$1 < lines.length; i$1++) if (closeRe.test(lines[i$1])) return i$1;
	return lines.length - 1;
}
function findIndentedCodeClose(lines, openIdx) {
	for (let i$1 = openIdx + 1; i$1 < lines.length; i$1++) {
		if (isBlank(lines[i$1])) continue;
		if (!isIndentedCodeOpener(lines[i$1])) return i$1 - 1;
	}
	return lines.length - 1;
}
function leadingIndent(line) {
	const match = line.match(/^(\s*)/);
	return match ? match[1].length : 0;
}
function parseColumnGuide(line) {
	const trimmed = line.trimEnd();
	if (!trimmed) return null;
	if (!/^[\s-]+$/.test(trimmed)) return null;
	const indent = leadingIndent(trimmed);
	const content$2 = trimmed.slice(indent);
	const spans = [];
	let j = 0;
	while (j < content$2.length) if (content$2[j] === "-") {
		const start = j;
		while (j < content$2.length && content$2[j] === "-") j++;
		if (j - start >= 3) spans.push({
			start,
			end: j - 1
		});
	} else j++;
	return spans.length >= 2 ? {
		spans,
		indent
	} : null;
}
function isSolidBorder(line) {
	const trimmed = line.trim();
	return trimmed.length >= 3 && /^-+$/.test(trimmed);
}
function isBlank(line) {
	return line.trim().length === 0;
}
function extractCells(line, spans, indent) {
	const content$2 = line.length > indent ? line.slice(indent) : "";
	const lastIdx = spans.length - 1;
	return spans.map(({ start, end }, i$1) => {
		if (start >= content$2.length) return "";
		const stop = i$1 === lastIdx ? content$2.length : Math.min(end + 1, content$2.length);
		return content$2.slice(start, stop).trim();
	});
}
function hasAlphanumericContent(cells) {
	return cells.some((cell) => /[a-zA-Z0-9]/.test(cell));
}
function cellsOverflow(line, spans, indent) {
	const content$2 = line.length > indent ? line.slice(indent) : "";
	for (let i$1 = 0; i$1 < spans.length - 1; i$1++) {
		const { start, end } = spans[i$1];
		const afterCol = end + 1;
		if (afterCol >= content$2.length || content$2[afterCol] === " ") continue;
		if (content$2[end] === " ") continue;
		let runStart = end;
		while (runStart > start && content$2[runStart - 1] !== " ") runStart--;
		let gapWidth = 0;
		for (let j = runStart - 1; j >= start; j--) if (content$2[j] === " ") gapWidth++;
		else break;
		if (gapWidth < 2) return true;
	}
	return false;
}
function tryParseTableAt(lines, i$1) {
	if (i$1 + 2 < lines.length && isSolidBorder(lines[i$1])) {
		const guide = parseColumnGuide(lines[i$1 + 2]);
		if (guide && leadingIndent(lines[i$1 + 1]) === guide.indent) {
			if (hasAlphanumericContent(extractCells(lines[i$1 + 1], guide.spans, guide.indent))) return buildTable(lines, guide, {
				topBorderIdx: i$1,
				headerIdx: i$1 + 1,
				guideIdx: i$1 + 2
			});
		}
	}
	if (i$1 + 1 < lines.length) {
		const guide = parseColumnGuide(lines[i$1 + 1]);
		if (guide && leadingIndent(lines[i$1]) === guide.indent) {
			if (hasAlphanumericContent(extractCells(lines[i$1], guide.spans, guide.indent))) return buildTable(lines, guide, {
				headerIdx: i$1,
				guideIdx: i$1 + 1
			});
		}
	}
	return null;
}
var MAX_BORDER_SCAN = 100;
var MIN_BORDER_WIDTH_RATIO = .4;
function buildTable(lines, guide, anchors) {
	const { topBorderIdx, headerIdx, guideIdx } = anchors;
	const { spans, indent } = guide;
	const startLine = topBorderIdx ?? headerIdx;
	const headers = extractCells(lines[headerIdx], spans, indent);
	let bottomBorderIdx = topBorderIdx !== void 0 ? findBottomBorder(lines, guideIdx + 1) : void 0;
	if (bottomBorderIdx !== void 0 && topBorderIdx !== void 0) {
		const borderOk = bordersMatch(lines[topBorderIdx], lines[bottomBorderIdx]);
		const contentOk = intermediateLinesMeetIndent(lines, guideIdx + 1, bottomBorderIdx, indent);
		if (!borderOk || !contentOk) bottomBorderIdx = void 0;
	}
	const { rows, lastConsumedIdx } = parseDataRows(lines, spans, indent, guideIdx + 1, bottomBorderIdx);
	if (rows.length === 0) return null;
	return {
		startLine,
		endLine: bottomBorderIdx ?? lastConsumedIdx,
		headers,
		rows
	};
}
function bordersMatch(topBorder, candidateBottom) {
	const topLen = topBorder.trim().length;
	if (candidateBottom.trim().length < topLen * MIN_BORDER_WIDTH_RATIO) return false;
	if (Math.abs(leadingIndent(topBorder) - leadingIndent(candidateBottom)) > 2) return false;
	return true;
}
function intermediateLinesMeetIndent(lines, fromIdx, toIdx, indent) {
	for (let k = fromIdx; k < toIdx; k++) {
		const line = lines[k];
		if (isBlank(line) || isSolidBorder(line)) continue;
		if (leadingIndent(line) < indent) return false;
	}
	return true;
}
function findBottomBorder(lines, fromIdx) {
	const limit = Math.min(fromIdx + MAX_BORDER_SCAN, lines.length);
	for (let i$1 = fromIdx; i$1 < limit; i$1++) {
		if (isFenceOpener(lines[i$1])) {
			i$1 = findFenceClose(lines, i$1);
			continue;
		}
		if (isIndentedCodeOpener(lines[i$1])) {
			i$1 = findIndentedCodeClose(lines, i$1);
			continue;
		}
		if (isSolidBorder(lines[i$1])) return i$1;
		if (/^#{1,6}\s/.test(lines[i$1].trimStart())) return void 0;
	}
}
function parseDataRows(lines, spans, indent, startIdx, boundaryIdx) {
	const rows = [];
	const bounded = boundaryIdx !== void 0;
	const limit = boundaryIdx ?? lines.length;
	let lastConsumed = startIdx - 1;
	let skippingOverflow = false;
	for (let i$1 = startIdx; i$1 < limit; i$1++) {
		if (isBlank(lines[i$1])) {
			skippingOverflow = false;
			if (bounded) {
				lastConsumed = i$1;
				continue;
			}
			break;
		}
		if (isSolidBorder(lines[i$1])) break;
		if (cellsOverflow(lines[i$1], spans, indent)) {
			if (rows.length === 0) break;
			skippingOverflow = true;
			lastConsumed = i$1;
			continue;
		}
		const cells = extractCells(lines[i$1], spans, indent);
		if (!hasAlphanumericContent(cells) && rows.length === 0) break;
		if (cells[0].length === 0 && rows.length > 0) {
			if (skippingOverflow) {
				lastConsumed = i$1;
				continue;
			}
			const prev = rows[rows.length - 1];
			for (let c$1 = 0; c$1 < spans.length; c$1++) if (cells[c$1]) prev[c$1] = prev[c$1] ? `${prev[c$1]} ${cells[c$1]}` : cells[c$1];
		} else if (hasAlphanumericContent(cells)) {
			skippingOverflow = false;
			rows.push(cells);
		}
		lastConsumed = i$1;
	}
	return {
		rows,
		lastConsumedIdx: lastConsumed
	};
}
function escapePipe(text$2) {
	return text$2.replace(/\|/g, "\\|");
}
function toGfmPipeTable({ headers, rows }) {
	const n = headers.length;
	const cell = (row, i$1) => escapePipe(row[i$1] ?? "");
	return [
		`| ${headers.map(escapePipe).join(" | ")} |`,
		`| ${Array.from({ length: n }, () => "---").join(" | ")} |`,
		...rows.map((row) => `| ${Array.from({ length: n }, (_, i$1) => cell(row, i$1)).join(" | ")} |`)
	];
}
function markdownToPmDoc(markdown, editor, options = {}) {
	const { blocks, diagnostics } = parseAndConvert(markdown, editor, options);
	const docJson = {
		type: "doc",
		content: blocks.length > 0 ? blocks : [{ type: "paragraph" }]
	};
	let doc$2 = editor.schema.nodeFromJSON(docJson);
	doc$2 = wrapTextsInRuns(doc$2);
	return {
		doc: doc$2,
		diagnostics
	};
}
function markdownToPmFragment(markdown, editor, options = {}) {
	const { blocks, diagnostics } = parseAndConvert(markdown, editor, options);
	if (blocks.length === 0) return {
		fragment: Fragment.empty,
		diagnostics
	};
	const wrappedNodes = blocks.map((json) => editor.schema.nodeFromJSON(json)).map((node) => wrapTextsInRuns(node));
	return {
		fragment: Fragment.from(wrappedNodes),
		diagnostics
	};
}
function parseAndConvert(markdown, editor, options) {
	const ast = parseMarkdownToAst(options.normalizeFixedWidthTables === false ? markdown : normalizeFixedWidthTables(markdown));
	const ctx = {
		editor,
		schema: editor.schema,
		diagnostics: [],
		options
	};
	return {
		blocks: convertMdastToBlocks(ast, ctx),
		diagnostics: ctx.diagnostics
	};
}
function createDocFromMarkdown(markdown, editor, options = {}) {
	const { doc: doc$2, diagnostics } = markdownToPmDoc(markdown, editor);
	if (diagnostics.length > 0) {
		const byTag = /* @__PURE__ */ new Map();
		for (const d of diagnostics) {
			const existing = byTag.get(d.nodeType);
			if (existing) existing.count += 1;
			else byTag.set(d.nodeType, {
				tagName: d.nodeType,
				outerHTML: d.message,
				count: 1
			});
		}
		const items = [...byTag.values()];
		if (options.onUnsupportedContent) options.onUnsupportedContent(items);
		else if (options.warnOnUnsupportedContent) console.warn("[super-editor] Unsupported Markdown content during import:", items);
	}
	return doc$2;
}
function processContent({ content: content$2, type, editor, onUnsupportedContent, warnOnUnsupportedContent }) {
	if (!editor) throw new Error("[processContent] Editor instance is required");
	if (!editor.schema) throw new Error("[processContent] Editor schema is not initialized");
	if (content$2 === null || content$2 === void 0) throw new Error("[processContent] Content is required and cannot be null or undefined");
	const domDocument = editor?.options?.document ?? editor?.options?.mockDocument ?? (typeof document !== "undefined" ? document : null);
	let doc$2;
	switch (type) {
		case "html":
			if (!domDocument) throw new Error("[processContent] HTML processing requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
			doc$2 = createDocFromHTML(content$2, editor, {
				isImport: true,
				document: domDocument,
				onUnsupportedContent,
				warnOnUnsupportedContent
			});
			break;
		case "markdown":
			if (!domDocument) throw new Error("[processContent] Markdown processing requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
			doc$2 = createDocFromMarkdown(content$2, editor, {
				isImport: true,
				document: domDocument,
				onUnsupportedContent,
				warnOnUnsupportedContent
			});
			break;
		case "text":
			if (!domDocument) throw new Error("[processContent] Text processing requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
			const wrapper = domDocument.createElement("div");
			wrapper.dataset.superdocImport = "true";
			const para = domDocument.createElement("p");
			para.textContent = content$2;
			wrapper.appendChild(para);
			doc$2 = DOMParser$1.fromSchema(editor.schema).parse(wrapper);
			doc$2 = wrapTextsInRuns(doc$2);
			break;
		case "schema":
			doc$2 = editor.schema.nodeFromJSON(content$2);
			doc$2 = wrapTextsInRuns(doc$2);
			break;
		default: throw new Error(`[processContent] Unknown content type: ${type}. Expected 'html', 'markdown', 'text', or 'schema'.`);
	}
	return doc$2;
}
var defaultBooleans = [
	"required",
	"readonly",
	"disabled",
	"checked",
	"multiple",
	"autofocus"
];
function updateDOMAttributes(dom, attrs = {}, options = {}) {
	const customBooleans = options.customBooleans || [];
	const booleans = [...defaultBooleans, ...customBooleans];
	Object.entries(attrs).forEach(([key, value]) => {
		if (booleans.includes(key)) {
			if (!value) dom.removeAttribute(key);
			else dom.setAttribute(key, "");
			return;
		}
		if (value != null) dom.setAttribute(key, value);
		else dom.removeAttribute(key);
	});
}
var MAX_INLINE_NAVIGATION_ITERATIONS = 8;
var computeChangeRange = (original, suggested) => {
	const origLen = original.length;
	const suggLen = suggested.length;
	let prefix = 0;
	while (prefix < origLen && prefix < suggLen && original[prefix] === suggested[prefix]) prefix++;
	if (prefix === origLen && prefix === suggLen) return {
		prefix,
		suffix: 0,
		hasChange: false
	};
	let suffix = 0;
	while (suffix < origLen - prefix && suffix < suggLen - prefix && original[origLen - 1 - suffix] === suggested[suggLen - 1 - suffix]) suffix++;
	return {
		prefix,
		suffix,
		hasChange: true
	};
};
var resolveInlineTextPosition = (doc$2, position, direction) => {
	const docSize = doc$2.content.size;
	if (position < 0 || position > docSize) return position;
	const step$1 = direction === "forward" ? 1 : -1;
	let current = position;
	let iterations = 0;
	while (iterations < MAX_INLINE_NAVIGATION_ITERATIONS) {
		iterations++;
		const resolved = doc$2.resolve(current);
		const boundaryNode = direction === "forward" ? resolved.nodeAfter : resolved.nodeBefore;
		if (!boundaryNode || boundaryNode.isText) break;
		if (!boundaryNode.isInline || boundaryNode.isAtom || boundaryNode.content.size === 0) break;
		const next = current + step$1;
		if (next < 0 || next > docSize) break;
		current = next;
		const adjacent = doc$2.resolve(current);
		const checkNode = direction === "forward" ? adjacent.nodeAfter : adjacent.nodeBefore;
		if (checkNode && checkNode.isText) break;
	}
	return current;
};
var mapCharOffsetToPosition = (doc$2, from, to, charOffset) => {
	const docSize = doc$2.content.size;
	if (from < 0 || from >= docSize || from >= to) return from;
	const resolvedFrom = resolveInlineTextPosition(doc$2, from, "forward");
	if (charOffset <= 0) return resolvedFrom;
	const totalTextLength = doc$2.textBetween(resolvedFrom, to, "", "").length;
	if (totalTextLength <= 0) return resolvedFrom;
	const targetOffset = Math.min(charOffset, totalTextLength);
	let low = resolvedFrom;
	let high = to;
	while (low < high) {
		const mid = Math.floor((low + high) / 2);
		if (doc$2.textBetween(resolvedFrom, mid, "", "").length < targetOffset) low = mid + 1;
		else high = mid;
	}
	return resolveInlineTextPosition(doc$2, Math.min(low, to), targetOffset === totalTextLength ? "backward" : "forward");
};
var getFirstTextMarks = (doc$2, from, to) => {
	const docSize = doc$2.content.size;
	if (from < 0 || to > docSize || from > to) return null;
	let firstMarks = null;
	doc$2.nodesBetween(from, to, (node) => {
		if (node.isText) {
			firstMarks = node.marks;
			return false;
		}
	});
	return firstMarks;
};
var getMarksAtPosition = (state, position) => {
	if (state.storedMarks?.length) return [...state.storedMarks];
	return [...state.doc.resolve(position).marks()];
};
var buildTextNodes = (state, from, to, suggestedText) => {
	if (!suggestedText) return [];
	const { schema } = state;
	const firstMarks = getFirstTextMarks(state.doc, from, to);
	const marks = firstMarks ? [...firstMarks] : getMarksAtPosition(state, from);
	return [schema.text(suggestedText, marks)];
};
const _testInternals = {
	computeChangeRange,
	resolveInlineTextPosition,
	mapCharOffsetToPosition,
	getFirstTextMarks,
	getMarksAtPosition,
	buildTextNodes
};
const applyPatch = ({ state, tr, from, to, suggestedText }) => {
	if (!state?.doc) return {
		tr,
		changed: false
	};
	const docSize = state.doc.content.size;
	if (from < 0 || to > docSize || from > to) return {
		tr,
		changed: false
	};
	const originalText = state.doc.textBetween(from, to, "", "");
	const { prefix, suffix, hasChange } = computeChangeRange(originalText, suggestedText);
	if (!hasChange) return {
		tr,
		changed: false
	};
	const changeFrom = mapCharOffsetToPosition(state.doc, from, to, prefix);
	const originalTextLength = originalText.length;
	const changeTo = mapCharOffsetToPosition(state.doc, from, to, originalTextLength - suffix);
	const replacementEnd = suggestedText.length - suffix;
	const replacementText = suggestedText.slice(prefix, replacementEnd);
	if (!replacementText) {
		tr.delete(changeFrom, changeTo);
		return {
			tr,
			changed: true
		};
	}
	const nodes = buildTextNodes(state, changeFrom, changeTo, replacementText);
	tr.replaceWith(changeFrom, changeTo, Fragment.fromArray(nodes));
	return {
		tr,
		changed: true
	};
};
const STRUCTURED_CONTENT_NODE_TYPES = new Set(["structuredContent", "structuredContentBlock"]);
function isStructuredContentNodeType(nodeTypeName) {
	return STRUCTURED_CONTENT_NODE_TYPES.has(nodeTypeName);
}
function findEnclosingStructuredContentPosition($pos) {
	for (let depth = $pos.depth; depth > 0; depth--) if (isStructuredContentNodeType($pos.node(depth).type.name)) return $pos.before(depth);
	return null;
}
function getViewModeSelectionWithoutStructuredContent(state) {
	const { selection, doc: doc$2 } = state;
	if (selection instanceof NodeSelection && isStructuredContentNodeType(selection.node.type.name)) {
		const candidate = Selection.near(doc$2.resolve(selection.from), -1);
		if (findEnclosingStructuredContentPosition(candidate.$from) !== null) return null;
		return candidate;
	}
	if (selection.empty) return null;
	const startPos = findEnclosingStructuredContentPosition(selection.$from);
	const endPos = findEnclosingStructuredContentPosition(selection.$to);
	if (startPos === null || endPos === null || startPos !== endPos) return null;
	return Selection.near(doc$2.resolve(startPos), -1);
}
var helpers_exports = /* @__PURE__ */ __export({
	_testInternals: () => _testInternals,
	applyPatch: () => applyPatch,
	chainableEditorState: () => chainableEditorState,
	cleanSchemaItem: () => cleanSchemaItem,
	createDocFromHTML: () => createDocFromHTML,
	createDocFromMarkdown: () => createDocFromMarkdown,
	createDocument: () => createDocument,
	defaultBlockAt: () => defaultBlockAt,
	findChildren: () => findChildren$1,
	findMark: () => findMark,
	findParentNode: () => findParentNode,
	findParentNodeClosestToPos: () => findParentNodeClosestToPos,
	generateDocxListAttributes: () => generateDocxListAttributes,
	generateDocxRandomId: () => generateDocxRandomId,
	generateRandomSigned32BitIntStrId: () => generateRandomSigned32BitIntStrId,
	getActiveFormatting: () => getActiveFormatting,
	getExtensionConfigField: () => getExtensionConfigField,
	getFormattingStateAtPos: () => getFormattingStateAtPos,
	getFormattingStateForRange: () => getFormattingStateForRange,
	getInheritedRunProperties: () => getInheritedRunProperties,
	getMarkRange: () => getMarkRange,
	getMarkType: () => getMarkType,
	getMarksBetween: () => getMarksBetween,
	getMarksFromSelection: () => getMarksFromSelection,
	getNodeType: () => getNodeType,
	getSchemaTypeByName: () => getSchemaTypeByName,
	getSchemaTypeNameByName: () => getSchemaTypeNameByName,
	getSelectionFormattingState: () => getSelectionFormattingState,
	getViewModeSelectionWithoutStructuredContent: () => getViewModeSelectionWithoutStructuredContent,
	isActive: () => isActive,
	isInTable: () => isInTable,
	isList: () => isList$1,
	isMarkActive: () => isMarkActive,
	isNodeActive: () => isNodeActive,
	isTextSelection: () => isTextSelection,
	posToDOMRect: () => posToDOMRect,
	processContent: () => processContent,
	updateDOMAttributes: () => updateDOMAttributes
}, 1);
var DECORATIVE_EXT_URI = "{C183D7F6-B498-43B3-948B-1728B52AA6E4}";
var DECORATIVE_NAMESPACE = "http://schemas.microsoft.com/office/drawing/2017/decorative";
var HYPERLINK_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink";
var IMAGE_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
function createMediaTargetForDataUri(params, src) {
	if (!isValidImageDataUrl(src)) return null;
	const extension$1 = getDataUriMetadata(src).extension;
	if (!extension$1) return null;
	if (!params.media) params.media = {};
	if (!params.dataUriMediaTargets) params.dataUriMediaTargets = /* @__PURE__ */ new Map();
	const cachedPackagePath = params.dataUriMediaTargets.get(src);
	if (cachedPackagePath && params.media[cachedPackagePath] === src) return cachedPackagePath.slice(5);
	const fileBaseName = sanitizeDocxMediaName(`image-${simpleStringHash(src)}`, "image");
	let fileName = `${fileBaseName}.${extension$1}`;
	let packagePath = `word/media/${fileName}`;
	if (params.media[packagePath] === src) {
		params.dataUriMediaTargets.set(src, packagePath);
		return `media/${fileName}`;
	}
	if (params.media[packagePath] && params.media[packagePath] !== src) {
		fileName = `${fileBaseName}_${generateDocxRandomId(8)}.${extension$1}`;
		packagePath = `word/media/${fileName}`;
	}
	const relationshipTarget = `media/${fileName}`;
	params.media[packagePath] = src;
	params.dataUriMediaTargets.set(src, packagePath);
	return relationshipTarget;
}
function getMediaTargetForImageSrc(params, src) {
	return src?.startsWith("data:") ? createMediaTargetForDataUri(params, src) : src?.split("word/")[1];
}
function fallbackForMissingMediaTarget(params) {
	if (params.node.type === "fieldAnnotation") return prepareTextAnnotation(params);
	console.warn("Skipping image export because media target could not be resolved.", {
		nodeType: params.node.type,
		src: params.node.attrs?.src
	});
	return null;
}
function resolveHyperlinkRId(attrs, params) {
	if (!attrs.hyperlink?.url || !params) return null;
	return addHyperlinkRelationship(params, attrs.hyperlink.url);
}
function buildHlinkClickElement(attrs, hlinkRId) {
	if (!hlinkRId) return null;
	const hlinkAttrs = { "r:id": hlinkRId };
	if (attrs.hyperlink?.tooltip) hlinkAttrs.tooltip = attrs.hyperlink.tooltip;
	return {
		name: "a:hlinkClick",
		attributes: hlinkAttrs
	};
}
function buildDocPrElement(attrs, imageName, hlinkRId, drawingId) {
	const docPrAttrs = {
		id: drawingId,
		name: attrs.alt || `Picture ${imageName}`
	};
	if (!attrs.decorative && attrs.title) docPrAttrs.descr = attrs.title;
	const children = [];
	const hlinkEl = buildHlinkClickElement(attrs, hlinkRId);
	if (hlinkEl) children.push(hlinkEl);
	if (attrs.decorative) children.push({
		name: "a:extLst",
		elements: [{
			name: "a:ext",
			attributes: { uri: DECORATIVE_EXT_URI },
			elements: [{
				name: "adec:decorative",
				attributes: {
					"xmlns:adec": DECORATIVE_NAMESPACE,
					val: "1"
				}
			}]
		}]
	});
	return {
		name: "wp:docPr",
		attributes: docPrAttrs,
		...children.length ? { elements: children } : {}
	};
}
function buildNvPicPrElement(attrs, imageName, hlinkRId, drawingId) {
	const cNvPrChildren = [];
	const hlinkEl = buildHlinkClickElement(attrs, hlinkRId);
	if (hlinkEl) cNvPrChildren.push(hlinkEl);
	return {
		name: "pic:nvPicPr",
		elements: [{
			name: "pic:cNvPr",
			attributes: {
				id: drawingId,
				name: attrs.alt || `Picture ${imageName}`
			},
			...cNvPrChildren.length ? { elements: cNvPrChildren } : {}
		}, {
			name: "pic:cNvPicPr",
			elements: [{
				name: "a:picLocks",
				attributes: {
					...attrs.lockAspectRatio ? { noChangeAspect: 1 } : {},
					noChangeArrowheads: 1
				}
			}]
		}]
	};
}
function addHyperlinkRelationship(params, url) {
	const newId = `rId${generateDocxRandomId(8)}`;
	if (!params.relationships || !Array.isArray(params.relationships)) params.relationships = [];
	params.relationships.push({
		type: "element",
		name: "Relationship",
		attributes: {
			Id: newId,
			Type: HYPERLINK_REL_TYPE,
			Target: url,
			TargetMode: "External"
		}
	});
	return newId;
}
const translateImageNode = (params) => {
	const { node: { attrs = {} }, tableCell, imageSize } = params;
	let imageId = attrs.rId;
	const src = attrs.originalSrc || attrs.src || attrs.imageSrc;
	let imageName;
	if (params.node.type === "image") if (src?.startsWith("data:")) imageName = getFallbackImageNameFromDataUri(src);
	else imageName = src?.split("/").pop();
	else imageName = attrs.fieldId;
	imageName = sanitizeDocxMediaName(imageName);
	if (params.node.type === "fieldAnnotation" && !imageId) {
		if (!getDataUriMetadata(src)?.extension) return prepareTextAnnotation(params);
	}
	let size = resolveExportSize(attrs, imageSize, src);
	if (src?.startsWith("data:image/png")) {
		const intrinsicDims = readImageDimensionsFromDataUri(src);
		if (intrinsicDims) {
			const boxWidthPx = emuToPixels(size.w);
			const boxHeightPx = emuToPixels(size.h);
			const { scaledWidth, scaledHeight } = getScaledSize(intrinsicDims.width, intrinsicDims.height, boxWidthPx, boxHeightPx);
			size = {
				w: pixelsToEmu(scaledWidth),
				h: pixelsToEmu(scaledHeight)
			};
		}
	}
	if (tableCell) {
		const maxWidthEmu = pixelsToEmu(tableCell.attrs.colwidth.reduce((acc, curr) => acc + curr, 0) - ((tableCell.attrs.cellMargins?.left || 8) + (tableCell.attrs.cellMargins?.right || 8)));
		const { width: w, height: h } = resizeKeepAspectRatio(size.w, size.h, maxWidthEmu);
		if (w && h) size = {
			w,
			h
		};
	}
	if (imageId || params.node.type === "image") {
		const path = getMediaTargetForImageSrc(params, src);
		if (!path) return fallbackForMissingMediaTarget(params);
		imageId = resolveImageRelationshipId(params, {
			id: imageId,
			path
		});
	} else if (params.node.type === "fieldAnnotation" && !imageId) {
		if (!isValidImageDataUrl(src)) return prepareTextAnnotation(params);
		const type = getDataUriMetadata(src).extension;
		const sanitizedHash = sanitizeDocxMediaName(attrs.hash, generateDocxRandomId(4));
		const relationshipTarget = `media/${`${imageName}_${sanitizedHash}.${type}`}`;
		const packagePath = `word/${relationshipTarget}`;
		imageId = addNewImageRelationship(params, relationshipTarget);
		params.media[packagePath] = src;
	}
	const inlineAttrs = attrs.originalPadding || {
		distT: 0,
		distB: 0,
		distL: 0,
		distR: 0
	};
	const xfrmAttrs = {};
	const effectExtentAttrs = {
		l: 0,
		t: 0,
		r: 0,
		b: 0
	};
	const transformData = attrs.transformData;
	if (transformData) {
		if (transformData.rotation) xfrmAttrs.rot = degreesToRot(transformData.rotation);
		if (transformData.verticalFlip) xfrmAttrs.flipV = "1";
		if (transformData.horizontalFlip) xfrmAttrs.flipH = "1";
		if (transformData.sizeExtension) {
			effectExtentAttrs.l = pixelsToEmu(transformData.sizeExtension.left);
			effectExtentAttrs.t = pixelsToEmu(transformData.sizeExtension.top);
			effectExtentAttrs.r = pixelsToEmu(transformData.sizeExtension.right);
			effectExtentAttrs.b = pixelsToEmu(transformData.sizeExtension.bottom);
		}
	}
	const rawSrcRect = attrs.rawSrcRect;
	const drawingXmlns = "http://schemas.openxmlformats.org/drawingml/2006/main";
	const pictureXmlns = "http://schemas.openxmlformats.org/drawingml/2006/picture";
	const blipEffects = [];
	if (attrs.grayscale) blipEffects.push({ name: "a:grayscl" });
	if (attrs.lum && (Number.isFinite(attrs.lum.bright) || Number.isFinite(attrs.lum.contrast))) blipEffects.push({
		name: "a:lum",
		attributes: {
			...Number.isFinite(attrs.lum.bright) ? { bright: Math.round(attrs.lum.bright) } : {},
			...Number.isFinite(attrs.lum.contrast) ? { contrast: Math.round(attrs.lum.contrast) } : {}
		}
	});
	if (attrs.alphaModFix && Number.isFinite(attrs.alphaModFix.amt)) blipEffects.push({
		name: "a:alphaModFix",
		attributes: { amt: Math.round(attrs.alphaModFix.amt) }
	});
	const hlinkRId = resolveHyperlinkRId(attrs, params);
	const drawingId = attrs.id && Number(attrs.id) > 0 ? attrs.id : Math.max(1, parseInt(generateDocxRandomId(), 16));
	return {
		attributes: inlineAttrs,
		elements: [
			{
				name: "wp:extent",
				attributes: {
					cx: size.w,
					cy: size.h
				}
			},
			{
				name: "wp:effectExtent",
				attributes: effectExtentAttrs
			},
			buildDocPrElement(attrs, imageName, hlinkRId, drawingId),
			{
				name: "wp:cNvGraphicFramePr",
				elements: [{
					name: "a:graphicFrameLocks",
					attributes: {
						"xmlns:a": drawingXmlns,
						...attrs.lockAspectRatio ? { noChangeAspect: 1 } : {}
					}
				}]
			},
			{
				name: "a:graphic",
				attributes: { "xmlns:a": drawingXmlns },
				elements: [{
					name: "a:graphicData",
					attributes: { uri: pictureXmlns },
					elements: [{
						name: "pic:pic",
						attributes: { "xmlns:pic": pictureXmlns },
						elements: [
							buildNvPicPrElement(attrs, imageName, hlinkRId, drawingId),
							{
								name: "pic:blipFill",
								elements: [
									{
										name: "a:blip",
										attributes: { "r:embed": imageId },
										...blipEffects.length ? { elements: blipEffects } : {}
									},
									...rawSrcRect ? [rawSrcRect] : [],
									{
										name: "a:stretch",
										elements: [{ name: "a:fillRect" }]
									}
								]
							},
							{
								name: "pic:spPr",
								attributes: { bwMode: "auto" },
								elements: [
									{
										name: "a:xfrm",
										attributes: xfrmAttrs,
										elements: [{
											name: "a:ext",
											attributes: {
												cx: size.w,
												cy: size.h
											}
										}, {
											name: "a:off",
											attributes: {
												x: 0,
												y: 0
											}
										}]
									},
									{
										name: "a:prstGeom",
										attributes: { prst: "rect" },
										elements: [{ name: "a:avLst" }]
									},
									{ name: "a:noFill" }
								]
							}
						]
					}]
				}]
			}
		]
	};
};
function isFinitePositive(value) {
	return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function resolveExportSize(attrs, imageSize, src) {
	if (isFinitePositive(attrs.size?.width) && isFinitePositive(attrs.size?.height)) return {
		w: pixelsToEmu(attrs.size.width),
		h: pixelsToEmu(attrs.size.height)
	};
	if (isFinitePositive(imageSize?.w) && isFinitePositive(imageSize?.h)) return imageSize;
	if (src?.startsWith("data:")) {
		const dims = readImageDimensionsFromDataUri(src);
		if (dims) return {
			w: pixelsToEmu(dims.width),
			h: pixelsToEmu(dims.height)
		};
	}
	const raw = attrs.size ? {
		w: pixelsToEmu(attrs.size.width),
		h: pixelsToEmu(attrs.size.height)
	} : imageSize || {
		w: 0,
		h: 0
	};
	return {
		w: isFinitePositive(raw.w) ? raw.w : 1,
		h: isFinitePositive(raw.h) ? raw.h : 1
	};
}
function getScaledSize(originalWidth, originalHeight, maxWidth, maxHeight) {
	let scaledWidth = originalWidth;
	let scaledHeight = originalHeight;
	let ratio = Math.min(maxWidth / originalWidth, maxHeight / originalHeight);
	scaledWidth = Math.round(scaledWidth * ratio);
	scaledHeight = Math.round(scaledHeight * ratio);
	return {
		scaledWidth,
		scaledHeight
	};
}
function resizeKeepAspectRatio(width, height, maxWidth) {
	if (width > maxWidth) {
		let scale = maxWidth / width;
		return {
			width: maxWidth,
			height: Math.round(height * scale)
		};
	}
	return {
		width,
		height
	};
}
function addNewImageRelationship(params, imagePath) {
	const newId = "rId" + generateDocxRandomId();
	const newRel = {
		type: "element",
		name: "Relationship",
		attributes: {
			Id: newId,
			Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
			Target: imagePath
		}
	};
	params.relationships.push(newRel);
	return newId;
}
function addImageRelationshipForId(params, id, imagePath) {
	const newRel = {
		type: "element",
		name: "Relationship",
		attributes: {
			Id: id,
			Type: IMAGE_REL_TYPE,
			Target: imagePath
		}
	};
	params.relationships.push(newRel);
	return id;
}
function getDocumentRelationships(params) {
	return (params.converter?.convertedXml || {})["word/_rels/document.xml.rels"]?.elements?.find((el) => el.name === "Relationships")?.elements ?? [];
}
function getImageRelationshipLookup(params) {
	return [...params.relationships || [], ...params.isHeaderFooter ? params.existingRelationships || [] : getDocumentRelationships(params)];
}
function resolveImageRelationshipId(params, { id, path }) {
	const existingRelation = findImageRelationship(getImageRelationshipLookup(params), {
		...id ? { id } : {},
		target: path
	});
	if (existingRelation) return existingRelation.attributes.Id;
	if (id) return addImageRelationshipForId(params, id, path);
	return addNewImageRelationship(params, path);
}
function findImageRelationship(relationships = [], { id, target }) {
	return relationships.find((rel) => {
		if (rel?.attributes?.Type !== IMAGE_REL_TYPE) return false;
		if (id) return rel.attributes.Id === id;
		if (target) return rel.attributes.Target === target;
		return false;
	});
}
function translateVectorShape(params) {
	const { node } = params;
	const { drawingContent } = node.attrs;
	return wrapTextInRun({
		name: "mc:AlternateContent",
		elements: [{
			name: "mc:Choice",
			attributes: { Requires: "wps" },
			elements: [{
				name: "w:drawing",
				elements: [...drawingContent ? [...drawingContent.elements || []] : []]
			}]
		}]
	});
}
function translateShapeGroup(params) {
	const { node } = params;
	const { drawingContent } = node.attrs;
	if (drawingContent) return wrapTextInRun({
		name: "mc:AlternateContent",
		elements: [{
			name: "mc:Choice",
			attributes: { Requires: "wpg" },
			elements: [{
				name: "w:drawing",
				elements: [...drawingContent.elements || []]
			}]
		}]
	});
	return wrapTextInRun({
		name: "w:drawing",
		elements: []
	});
}
function mergeDrawingChildren({ order, generated, original }) {
	const merged = mergeWithOrder(order, groupByName(generated), groupByIndex(original));
	fixZeroDrawingIds(merged, generated);
	return merged;
}
function groupByIndex(entries = []) {
	const map = /* @__PURE__ */ new Map();
	entries.forEach((entry) => {
		if (!entry) return;
		const { index, xml } = entry;
		if (typeof index === "number" && xml && xml.name !== "wp:extent") map.set(index, carbonCopy(xml));
	});
	return map;
}
function mergeWithOrder(order = [], genQueues, originalsByIndex) {
	const out = [];
	const namesInOrder = new Set(order);
	order.forEach((name, idx) => {
		if (name === "wp:extent") {
			const queue$2 = genQueues.get("wp:extent") || [];
			if (queue$2.length) {
				out.push(queue$2.shift());
				if (!queue$2.length) genQueues.delete("wp:extent");
			}
			return;
		}
		if (originalsByIndex.has(idx)) {
			out.push(originalsByIndex.get(idx));
			originalsByIndex.delete(idx);
			if (genQueues.has(name)) genQueues.delete(name);
			return;
		}
		const queue$1 = genQueues.get(name) || [];
		if (queue$1.length) {
			out.push(queue$1.shift());
			if (!queue$1.length) genQueues.delete(name);
		}
	});
	originalsByIndex.forEach((xml) => out.push(xml));
	genQueues.forEach((queue$1, name) => {
		if (namesInOrder.has(name)) return;
		queue$1.forEach((el) => out.push(el));
	});
	return out;
}
function groupByName(nodes = []) {
	const map = /* @__PURE__ */ new Map();
	nodes.forEach((el) => {
		if (!el?.name) return;
		const list$1 = map.get(el.name) || [];
		list$1.push(carbonCopy(el));
		map.set(el.name, list$1);
	});
	return map;
}
function fixZeroDrawingIds(merged, generated) {
	const validId = (generated?.find((el) => el?.name === "wp:docPr"))?.attributes?.id;
	if (!validId || !(Number(validId) > 0)) return;
	const docPr = merged.find((el) => el?.name === "wp:docPr");
	if (docPr?.attributes && !(Number(docPr.attributes.id) > 0)) docPr.attributes.id = validId;
	const cNvPr = ((findChildByLocalName(findChildByLocalName(merged, "graphic")?.elements, "graphicData")?.elements?.find((el) => el?.name === "pic:pic"))?.elements?.find((el) => el?.name === "pic:nvPicPr"))?.elements?.find((el) => el?.name === "pic:cNvPr");
	if (cNvPr?.attributes && !(Number(cNvPr.attributes.id) > 0)) cNvPr.attributes.id = validId;
}
function translateAnchorNode(params) {
	const { attrs } = params.node;
	const anchorElements = [];
	const useOriginalChildren = Array.isArray(attrs.originalDrawingChildren) && attrs.originalDrawingChildren.length > 0;
	const hasSimplePos = attrs.simplePos !== void 0 || attrs.originalAttributes?.simplePos !== void 0;
	if (!useOriginalChildren && hasSimplePos) anchorElements.push({
		name: "wp:simplePos",
		attributes: {
			x: attrs.simplePos?.x ?? 0,
			y: attrs.simplePos?.y ?? 0
		}
	});
	if (!useOriginalChildren && attrs.anchorData) {
		const hElements = [];
		if (attrs.marginOffset.horizontal !== void 0) hElements.push({
			name: "wp:posOffset",
			elements: [{
				type: "text",
				text: pixelsToEmu(attrs.marginOffset.horizontal).toString()
			}]
		});
		if (attrs.anchorData.alignH) hElements.push({
			name: "wp:align",
			elements: [{
				type: "text",
				text: attrs.anchorData.alignH
			}]
		});
		anchorElements.push({
			name: "wp:positionH",
			attributes: { relativeFrom: attrs.anchorData.hRelativeFrom },
			...hElements.length && { elements: hElements }
		});
		const vElements = [];
		if (attrs.marginOffset.top !== void 0) vElements.push({
			name: "wp:posOffset",
			elements: [{
				type: "text",
				text: pixelsToEmu(attrs.marginOffset.top).toString()
			}]
		});
		if (attrs.anchorData.alignV) vElements.push({
			name: "wp:align",
			elements: [{
				type: "text",
				text: attrs.anchorData.alignV
			}]
		});
		anchorElements.push({
			name: "wp:positionV",
			attributes: { relativeFrom: attrs.anchorData.vRelativeFrom },
			...vElements.length && { elements: vElements }
		});
	}
	const nodeElements = translateImageNode(params);
	if (!nodeElements?.elements?.some((el) => el?.name === "wp:extent")) return nodeElements;
	const inlineAttrs = {
		...attrs.originalAttributes || {},
		...nodeElements.attributes || {}
	};
	const liveRelativeHeight = parseRelativeHeight(attrs.relativeHeight);
	const originalRelativeHeight = parseRelativeHeight(inlineAttrs.relativeHeight);
	inlineAttrs.relativeHeight = liveRelativeHeight ?? originalRelativeHeight ?? 1;
	if (attrs.originalAttributes?.simplePos === void 0 && hasSimplePos) inlineAttrs.simplePos = "1";
	const wrapElement = { name: `wp:wrap${attrs.wrap?.type || "None"}` };
	switch (useOriginalChildren ? void 0 : attrs.wrap?.type) {
		case "Square":
			wrapElement.attributes = { wrapText: attrs.wrap.attrs.wrapText };
			if ("distBottom" in (attrs.wrap.attrs || {})) wrapElement.attributes.distB = pixelsToEmu(attrs.wrap.attrs.distBottom);
			if ("distLeft" in (attrs.wrap.attrs || {})) wrapElement.attributes.distL = pixelsToEmu(attrs.wrap.attrs.distLeft);
			if ("distRight" in (attrs.wrap.attrs || {})) wrapElement.attributes.distR = pixelsToEmu(attrs.wrap.attrs.distRight);
			if ("distTop" in (attrs.wrap.attrs || {})) wrapElement.attributes.distT = pixelsToEmu(attrs.wrap.attrs.distTop);
			break;
		case "TopAndBottom": {
			const attributes = {};
			let hasKeys = false;
			if ("distBottom" in (attrs.wrap.attrs || {})) {
				attributes.distB = pixelsToEmu(attrs.wrap.attrs.distBottom);
				hasKeys = true;
			}
			if ("distTop" in (attrs.wrap.attrs || {})) {
				attributes.distT = pixelsToEmu(attrs.wrap.attrs.distTop);
				hasKeys = true;
			}
			if (hasKeys) wrapElement.attributes = attributes;
			break;
		}
		case "Tight": {
			const attributes = {};
			if ("distLeft" in (attrs.wrap.attrs || {})) attributes.distL = pixelsToEmu(attrs.wrap.attrs.distLeft);
			if ("distRight" in (attrs.wrap.attrs || {})) attributes.distR = pixelsToEmu(attrs.wrap.attrs.distRight);
			const wrapText = attrs.wrap.attrs?.wrapText || "bothSides";
			if (wrapText) attributes.wrapText = wrapText;
			if (Object.keys(attributes).length) wrapElement.attributes = attributes;
			if (attrs.wrap.attrs?.polygon) {
				const polygonNode = objToPolygon(attrs.wrap.attrs.polygon);
				if (polygonNode) {
					if (attrs.wrap.attrs?.polygonEdited !== void 0) polygonNode.attributes = {
						...polygonNode.attributes || {},
						edited: String(attrs.wrap.attrs.polygonEdited)
					};
					wrapElement.elements = [polygonNode];
				}
			}
			break;
		}
		case "Through": {
			const attributes = {};
			if ("distBottom" in (attrs.wrap.attrs || {})) attributes.distB = pixelsToEmu(attrs.wrap.attrs.distBottom);
			if ("distLeft" in (attrs.wrap.attrs || {})) attributes.distL = pixelsToEmu(attrs.wrap.attrs.distLeft);
			if ("distRight" in (attrs.wrap.attrs || {})) attributes.distR = pixelsToEmu(attrs.wrap.attrs.distRight);
			if ("distTop" in (attrs.wrap.attrs || {})) attributes.distT = pixelsToEmu(attrs.wrap.attrs.distTop);
			const wrapText = attrs.wrap.attrs?.wrapText || "bothSides";
			if (wrapText) attributes.wrapText = wrapText;
			if (Object.keys(attributes).length) wrapElement.attributes = attributes;
			if (attrs.wrap.attrs?.polygon) {
				const polygonNode = objToPolygon(attrs.wrap.attrs.polygon);
				if (polygonNode) {
					if (attrs.wrap.attrs?.polygonEdited !== void 0) polygonNode.attributes = {
						...polygonNode.attributes || {},
						edited: String(attrs.wrap.attrs.polygonEdited)
					};
					wrapElement.elements = [polygonNode];
				}
			}
			break;
		}
		case "None":
			inlineAttrs.behindDoc = attrs.wrap.attrs?.behindDoc ? "1" : "0";
			break;
		default: break;
	}
	const effectIndex = nodeElements.elements.findIndex((el) => el.name === "wp:effectExtent");
	const elementsWithWrap = [
		...nodeElements.elements.slice(0, effectIndex + 1),
		wrapElement,
		...nodeElements.elements.slice(effectIndex + 1)
	];
	return {
		name: "wp:anchor",
		attributes: inlineAttrs,
		elements: mergeDrawingChildren({
			order: attrs.drawingChildOrder || [],
			original: attrs.originalDrawingChildren || [],
			generated: [...anchorElements, ...elementsWithWrap]
		})
	};
}
var XML_NODE_NAME$29 = "wp:anchor";
var SD_NODE_NAME$28 = [
	"image",
	"shapeGroup",
	"vectorShape",
	"contentBlock"
];
var validXmlAttributes$6 = [
	"distT",
	"distB",
	"distL",
	"distR",
	"allowOverlap",
	"behindDoc",
	"layoutInCell",
	"locked",
	"relativeHeight",
	"simplePos",
	"wp14:anchorId",
	"wp14:editId"
].map((xmlName) => createAttributeHandler(xmlName));
function encode$46(params) {
	const { node } = params.extraParams;
	if (!node || !node.name) return null;
	return handleAnchorNode(params);
}
function decode$48(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	return translateAnchorNode(params);
}
const config$29 = {
	xmlName: XML_NODE_NAME$29,
	sdNodeOrKeyName: SD_NODE_NAME$28,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$46,
	decode: decode$48,
	attributes: validXmlAttributes$6
};
const translator$202 = NodeTranslator.from(config$29);
function handleInlineNode(params) {
	const { node } = params.extraParams;
	if (node.name !== "wp:inline") return null;
	return handleImageNode$1(node, params, false);
}
function translateInlineNode(params) {
	const { attrs } = params.node;
	const nodeElements = translateImageNode(params);
	if (!nodeElements?.elements?.some((el) => el?.name === "wp:extent")) return nodeElements;
	const inlineAttrs = {
		...attrs.originalAttributes || {},
		...nodeElements.attributes || {}
	};
	const generatedElements = nodeElements?.elements || [];
	return {
		name: "wp:inline",
		attributes: inlineAttrs,
		elements: mergeDrawingChildren({
			order: params.node?.attrs?.drawingChildOrder || [],
			original: params.node?.attrs?.originalDrawingChildren || [],
			generated: generatedElements
		})
	};
}
var XML_NODE_NAME$28 = "wp:inline";
var SD_NODE_NAME$27 = [
	"image",
	"shapeGroup",
	"vectorShape",
	"contentBlock"
];
var validXmlAttributes$5 = [
	"distT",
	"distB",
	"distL",
	"distR",
	"wp14:anchorId",
	"wp14:editId"
].map((xmlName) => createAttributeHandler(xmlName));
function encode$45(params) {
	const { node } = params.extraParams;
	if (!node || !node.name) return null;
	return handleInlineNode(params);
}
function decode$47(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	return translateInlineNode(params);
}
const config$28 = {
	xmlName: XML_NODE_NAME$28,
	sdNodeOrKeyName: SD_NODE_NAME$27,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$45,
	decode: decode$47,
	attributes: validXmlAttributes$5
};
const translator$203 = NodeTranslator.from(config$28);
var XML_NODE_NAME$27 = "w:drawing";
var SD_NODE_NAME$26 = [];
var validXmlAttributes$4 = [];
function encode$44(params) {
	const node = params.nodes[0];
	const translatorByChildName = {
		"wp:anchor": translator$202,
		"wp:inline": translator$203
	};
	const result = (node.elements || []).reduce((acc, child) => {
		if (acc) return acc;
		const translator$220 = translatorByChildName[child.name];
		if (!translator$220) return acc;
		return translator$220.encode({
			...params,
			extraParams: { node: child }
		}) || acc;
	}, null);
	if (result) return result;
	return {
		type: "passthroughBlock",
		attrs: {
			originalName: "w:drawing",
			originalXml: carbonCopy(node)
		}
	};
}
function decode$46(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	if (node.attrs.isPict) return null;
	if (node.type === "chart" && node.attrs.originalXml) return wrapTextInRun(carbonCopy(node.attrs.originalXml), []);
	const resultNode = (node.attrs.isAnchor ? translator$202 : translator$203).decode(params);
	if (!resultNode || resultNode.name !== "wp:inline" && resultNode.name !== "wp:anchor") return resultNode;
	return wrapTextInRun({
		name: "w:drawing",
		elements: [resultNode]
	}, []);
}
const config$27 = {
	xmlName: XML_NODE_NAME$27,
	sdNodeOrKeyName: SD_NODE_NAME$26,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$44,
	decode: decode$46,
	attributes: validXmlAttributes$4
};
const translator$12 = NodeTranslator.from(config$27);
function resolveExportPartPath(params = {}) {
	if (typeof params.currentPartPath === "string" && params.currentPartPath.length > 0) return params.currentPartPath;
	if (typeof params.filename === "string" && params.filename.length > 0) return params.filename.startsWith("word/") ? params.filename : `word/${params.filename}`;
	return "word/document.xml";
}
function getTextNodeForExport(text$2, marks, params) {
	const normalizedMarks = Array.isArray(marks) ? marks : [];
	const space = /^\s|\s$/.test(text$2) ? "preserve" : null;
	const nodeAttrs = space ? { "xml:space": space } : null;
	const textNodes = [];
	const textRunProperties = decodeRPrFromMarks(normalizedMarks);
	const combinedRunProperties = combineRunProperties([params.extraParams?.runProperties || {}, textRunProperties]);
	const trackFormatMark = findTrackFormatMark(normalizedMarks);
	let rPrNode = translator$133.decode({ node: { attrs: { runProperties: combinedRunProperties } } });
	if (!rPrNode && trackFormatMark) rPrNode = {
		type: "element",
		name: "w:rPr",
		elements: []
	};
	appendTrackFormatChangeToRunProperties(rPrNode, normalizedMarks, {
		wordIdAllocator: params?.converter?.wordIdAllocator || null,
		partPath: resolveExportPartPath(params)
	});
	const textValue = typeof text$2 === "string" ? text$2 : "";
	const normalizedText = textValue.includes("\r") ? textValue.replace(/\r\n?/g, "\n") : textValue;
	if (normalizedText.includes("\n")) {
		const segments = normalizedText.split("\n");
		segments.forEach((segment, index) => {
			if (segment.length > 0) {
				const segmentNeedsSpace = /^\s|\s$/.test(segment);
				textNodes.push({
					name: "w:t",
					elements: [{
						text: segment,
						type: "text"
					}],
					attributes: segmentNeedsSpace ? { "xml:space": "preserve" } : null
				});
			}
			if (index < segments.length - 1) textNodes.push({ name: "w:br" });
		});
	} else textNodes.push({
		name: "w:t",
		elements: [{
			text: normalizedText,
			type: "text"
		}],
		attributes: nodeAttrs
	});
	if (params?.editor?.extensionService?.extensions) {
		const customMarks = params.editor.extensionService.extensions.filter((extension$1) => extension$1.isExternal === true);
		normalizedMarks.forEach((mark) => {
			const isCustomMark = customMarks.some((customMark) => {
				const customMarkName = customMark.name;
				return mark.type === customMarkName;
			});
			if (!isCustomMark) return;
			let attrsString = "";
			Object.entries(mark.attrs).forEach(([key, value]) => {
				if (value) attrsString += `${key}=${value};`;
			});
			if (isCustomMark) {
				textNodes.unshift({
					type: "element",
					name: "w:bookmarkStart",
					attributes: {
						"w:id": "5000",
						"w:name": mark.type + ";" + attrsString
					}
				});
				textNodes.push({
					type: "element",
					name: "w:bookmarkEnd",
					attributes: { "w:id": "5000" }
				});
			}
		});
	}
	return {
		name: "w:r",
		elements: rPrNode ? [rPrNode, ...textNodes] : textNodes
	};
}
var import_he = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist$1();
	(function(root) {
		var freeExports = typeof exports == "object" && exports;
		var freeModule = typeof module == "object" && module && module.exports == freeExports && module;
		var freeGlobal = typeof global == "object" && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
		var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
		var regexAsciiWhitelist = /[\x01-\x7F]/g;
		var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
		var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
		var encodeMap = {
			"­": "shy",
			"‌": "zwnj",
			"‍": "zwj",
			"‎": "lrm",
			"⁣": "ic",
			"⁢": "it",
			"⁡": "af",
			"‏": "rlm",
			"​": "ZeroWidthSpace",
			"⁠": "NoBreak",
			"̑": "DownBreve",
			"⃛": "tdot",
			"⃜": "DotDot",
			"	": "Tab",
			"\n": "NewLine",
			" ": "puncsp",
			" ": "MediumSpace",
			" ": "thinsp",
			" ": "hairsp",
			" ": "emsp13",
			" ": "ensp",
			" ": "emsp14",
			" ": "emsp",
			" ": "numsp",
			"\xA0": "nbsp",
			"  ": "ThickSpace",
			"‾": "oline",
			"_": "lowbar",
			"‐": "dash",
			"–": "ndash",
			"—": "mdash",
			"―": "horbar",
			",": "comma",
			";": "semi",
			"⁏": "bsemi",
			":": "colon",
			"⩴": "Colone",
			"!": "excl",
			"¡": "iexcl",
			"?": "quest",
			"¿": "iquest",
			".": "period",
			"‥": "nldr",
			"…": "mldr",
			"·": "middot",
			"'": "apos",
			"‘": "lsquo",
			"’": "rsquo",
			"‚": "sbquo",
			"‹": "lsaquo",
			"›": "rsaquo",
			"\"": "quot",
			"“": "ldquo",
			"”": "rdquo",
			"„": "bdquo",
			"«": "laquo",
			"»": "raquo",
			"(": "lpar",
			")": "rpar",
			"[": "lsqb",
			"]": "rsqb",
			"{": "lcub",
			"}": "rcub",
			"⌈": "lceil",
			"⌉": "rceil",
			"⌊": "lfloor",
			"⌋": "rfloor",
			"⦅": "lopar",
			"⦆": "ropar",
			"⦋": "lbrke",
			"⦌": "rbrke",
			"⦍": "lbrkslu",
			"⦎": "rbrksld",
			"⦏": "lbrksld",
			"⦐": "rbrkslu",
			"⦑": "langd",
			"⦒": "rangd",
			"⦓": "lparlt",
			"⦔": "rpargt",
			"⦕": "gtlPar",
			"⦖": "ltrPar",
			"⟦": "lobrk",
			"⟧": "robrk",
			"⟨": "lang",
			"⟩": "rang",
			"⟪": "Lang",
			"⟫": "Rang",
			"⟬": "loang",
			"⟭": "roang",
			"❲": "lbbrk",
			"❳": "rbbrk",
			"‖": "Vert",
			"§": "sect",
			"¶": "para",
			"@": "commat",
			"*": "ast",
			"/": "sol",
			"undefined": null,
			"&": "amp",
			"#": "num",
			"%": "percnt",
			"‰": "permil",
			"‱": "pertenk",
			"†": "dagger",
			"‡": "Dagger",
			"•": "bull",
			"⁃": "hybull",
			"′": "prime",
			"″": "Prime",
			"‴": "tprime",
			"⁗": "qprime",
			"‵": "bprime",
			"⁁": "caret",
			"`": "grave",
			"´": "acute",
			"˜": "tilde",
			"^": "Hat",
			"¯": "macr",
			"˘": "breve",
			"˙": "dot",
			"¨": "die",
			"˚": "ring",
			"˝": "dblac",
			"¸": "cedil",
			"˛": "ogon",
			"ˆ": "circ",
			"ˇ": "caron",
			"°": "deg",
			"©": "copy",
			"®": "reg",
			"℗": "copysr",
			"℘": "wp",
			"℞": "rx",
			"℧": "mho",
			"℩": "iiota",
			"←": "larr",
			"↚": "nlarr",
			"→": "rarr",
			"↛": "nrarr",
			"↑": "uarr",
			"↓": "darr",
			"↔": "harr",
			"↮": "nharr",
			"↕": "varr",
			"↖": "nwarr",
			"↗": "nearr",
			"↘": "searr",
			"↙": "swarr",
			"↝": "rarrw",
			"↝̸": "nrarrw",
			"↞": "Larr",
			"↟": "Uarr",
			"↠": "Rarr",
			"↡": "Darr",
			"↢": "larrtl",
			"↣": "rarrtl",
			"↤": "mapstoleft",
			"↥": "mapstoup",
			"↦": "map",
			"↧": "mapstodown",
			"↩": "larrhk",
			"↪": "rarrhk",
			"↫": "larrlp",
			"↬": "rarrlp",
			"↭": "harrw",
			"↰": "lsh",
			"↱": "rsh",
			"↲": "ldsh",
			"↳": "rdsh",
			"↵": "crarr",
			"↶": "cularr",
			"↷": "curarr",
			"↺": "olarr",
			"↻": "orarr",
			"↼": "lharu",
			"↽": "lhard",
			"↾": "uharr",
			"↿": "uharl",
			"⇀": "rharu",
			"⇁": "rhard",
			"⇂": "dharr",
			"⇃": "dharl",
			"⇄": "rlarr",
			"⇅": "udarr",
			"⇆": "lrarr",
			"⇇": "llarr",
			"⇈": "uuarr",
			"⇉": "rrarr",
			"⇊": "ddarr",
			"⇋": "lrhar",
			"⇌": "rlhar",
			"⇐": "lArr",
			"⇍": "nlArr",
			"⇑": "uArr",
			"⇒": "rArr",
			"⇏": "nrArr",
			"⇓": "dArr",
			"⇔": "iff",
			"⇎": "nhArr",
			"⇕": "vArr",
			"⇖": "nwArr",
			"⇗": "neArr",
			"⇘": "seArr",
			"⇙": "swArr",
			"⇚": "lAarr",
			"⇛": "rAarr",
			"⇝": "zigrarr",
			"⇤": "larrb",
			"⇥": "rarrb",
			"⇵": "duarr",
			"⇽": "loarr",
			"⇾": "roarr",
			"⇿": "hoarr",
			"∀": "forall",
			"∁": "comp",
			"∂": "part",
			"∂̸": "npart",
			"∃": "exist",
			"∄": "nexist",
			"∅": "empty",
			"∇": "Del",
			"∈": "in",
			"∉": "notin",
			"∋": "ni",
			"∌": "notni",
			"϶": "bepsi",
			"∏": "prod",
			"∐": "coprod",
			"∑": "sum",
			"+": "plus",
			"±": "pm",
			"÷": "div",
			"×": "times",
			"<": "lt",
			"≮": "nlt",
			"<⃒": "nvlt",
			"=": "equals",
			"≠": "ne",
			"=⃥": "bne",
			"⩵": "Equal",
			">": "gt",
			"≯": "ngt",
			">⃒": "nvgt",
			"¬": "not",
			"|": "vert",
			"¦": "brvbar",
			"−": "minus",
			"∓": "mp",
			"∔": "plusdo",
			"⁄": "frasl",
			"∖": "setmn",
			"∗": "lowast",
			"∘": "compfn",
			"√": "Sqrt",
			"∝": "prop",
			"∞": "infin",
			"∟": "angrt",
			"∠": "ang",
			"∠⃒": "nang",
			"∡": "angmsd",
			"∢": "angsph",
			"∣": "mid",
			"∤": "nmid",
			"∥": "par",
			"∦": "npar",
			"∧": "and",
			"∨": "or",
			"∩": "cap",
			"∩︀": "caps",
			"∪": "cup",
			"∪︀": "cups",
			"∫": "int",
			"∬": "Int",
			"∭": "tint",
			"⨌": "qint",
			"∮": "oint",
			"∯": "Conint",
			"∰": "Cconint",
			"∱": "cwint",
			"∲": "cwconint",
			"∳": "awconint",
			"∴": "there4",
			"∵": "becaus",
			"∶": "ratio",
			"∷": "Colon",
			"∸": "minusd",
			"∺": "mDDot",
			"∻": "homtht",
			"∼": "sim",
			"≁": "nsim",
			"∼⃒": "nvsim",
			"∽": "bsim",
			"∽̱": "race",
			"∾": "ac",
			"∾̳": "acE",
			"∿": "acd",
			"≀": "wr",
			"≂": "esim",
			"≂̸": "nesim",
			"≃": "sime",
			"≄": "nsime",
			"≅": "cong",
			"≇": "ncong",
			"≆": "simne",
			"≈": "ap",
			"≉": "nap",
			"≊": "ape",
			"≋": "apid",
			"≋̸": "napid",
			"≌": "bcong",
			"≍": "CupCap",
			"≭": "NotCupCap",
			"≍⃒": "nvap",
			"≎": "bump",
			"≎̸": "nbump",
			"≏": "bumpe",
			"≏̸": "nbumpe",
			"≐": "doteq",
			"≐̸": "nedot",
			"≑": "eDot",
			"≒": "efDot",
			"≓": "erDot",
			"≔": "colone",
			"≕": "ecolon",
			"≖": "ecir",
			"≗": "cire",
			"≙": "wedgeq",
			"≚": "veeeq",
			"≜": "trie",
			"≟": "equest",
			"≡": "equiv",
			"≢": "nequiv",
			"≡⃥": "bnequiv",
			"≤": "le",
			"≰": "nle",
			"≤⃒": "nvle",
			"≥": "ge",
			"≱": "nge",
			"≥⃒": "nvge",
			"≦": "lE",
			"≦̸": "nlE",
			"≧": "gE",
			"≧̸": "ngE",
			"≨︀": "lvnE",
			"≨": "lnE",
			"≩": "gnE",
			"≩︀": "gvnE",
			"≪": "ll",
			"≪̸": "nLtv",
			"≪⃒": "nLt",
			"≫": "gg",
			"≫̸": "nGtv",
			"≫⃒": "nGt",
			"≬": "twixt",
			"≲": "lsim",
			"≴": "nlsim",
			"≳": "gsim",
			"≵": "ngsim",
			"≶": "lg",
			"≸": "ntlg",
			"≷": "gl",
			"≹": "ntgl",
			"≺": "pr",
			"⊀": "npr",
			"≻": "sc",
			"⊁": "nsc",
			"≼": "prcue",
			"⋠": "nprcue",
			"≽": "sccue",
			"⋡": "nsccue",
			"≾": "prsim",
			"≿": "scsim",
			"≿̸": "NotSucceedsTilde",
			"⊂": "sub",
			"⊄": "nsub",
			"⊂⃒": "vnsub",
			"⊃": "sup",
			"⊅": "nsup",
			"⊃⃒": "vnsup",
			"⊆": "sube",
			"⊈": "nsube",
			"⊇": "supe",
			"⊉": "nsupe",
			"⊊︀": "vsubne",
			"⊊": "subne",
			"⊋︀": "vsupne",
			"⊋": "supne",
			"⊍": "cupdot",
			"⊎": "uplus",
			"⊏": "sqsub",
			"⊏̸": "NotSquareSubset",
			"⊐": "sqsup",
			"⊐̸": "NotSquareSuperset",
			"⊑": "sqsube",
			"⋢": "nsqsube",
			"⊒": "sqsupe",
			"⋣": "nsqsupe",
			"⊓": "sqcap",
			"⊓︀": "sqcaps",
			"⊔": "sqcup",
			"⊔︀": "sqcups",
			"⊕": "oplus",
			"⊖": "ominus",
			"⊗": "otimes",
			"⊘": "osol",
			"⊙": "odot",
			"⊚": "ocir",
			"⊛": "oast",
			"⊝": "odash",
			"⊞": "plusb",
			"⊟": "minusb",
			"⊠": "timesb",
			"⊡": "sdotb",
			"⊢": "vdash",
			"⊬": "nvdash",
			"⊣": "dashv",
			"⊤": "top",
			"⊥": "bot",
			"⊧": "models",
			"⊨": "vDash",
			"⊭": "nvDash",
			"⊩": "Vdash",
			"⊮": "nVdash",
			"⊪": "Vvdash",
			"⊫": "VDash",
			"⊯": "nVDash",
			"⊰": "prurel",
			"⊲": "vltri",
			"⋪": "nltri",
			"⊳": "vrtri",
			"⋫": "nrtri",
			"⊴": "ltrie",
			"⋬": "nltrie",
			"⊴⃒": "nvltrie",
			"⊵": "rtrie",
			"⋭": "nrtrie",
			"⊵⃒": "nvrtrie",
			"⊶": "origof",
			"⊷": "imof",
			"⊸": "mumap",
			"⊹": "hercon",
			"⊺": "intcal",
			"⊻": "veebar",
			"⊽": "barvee",
			"⊾": "angrtvb",
			"⊿": "lrtri",
			"⋀": "Wedge",
			"⋁": "Vee",
			"⋂": "xcap",
			"⋃": "xcup",
			"⋄": "diam",
			"⋅": "sdot",
			"⋆": "Star",
			"⋇": "divonx",
			"⋈": "bowtie",
			"⋉": "ltimes",
			"⋊": "rtimes",
			"⋋": "lthree",
			"⋌": "rthree",
			"⋍": "bsime",
			"⋎": "cuvee",
			"⋏": "cuwed",
			"⋐": "Sub",
			"⋑": "Sup",
			"⋒": "Cap",
			"⋓": "Cup",
			"⋔": "fork",
			"⋕": "epar",
			"⋖": "ltdot",
			"⋗": "gtdot",
			"⋘": "Ll",
			"⋘̸": "nLl",
			"⋙": "Gg",
			"⋙̸": "nGg",
			"⋚︀": "lesg",
			"⋚": "leg",
			"⋛": "gel",
			"⋛︀": "gesl",
			"⋞": "cuepr",
			"⋟": "cuesc",
			"⋦": "lnsim",
			"⋧": "gnsim",
			"⋨": "prnsim",
			"⋩": "scnsim",
			"⋮": "vellip",
			"⋯": "ctdot",
			"⋰": "utdot",
			"⋱": "dtdot",
			"⋲": "disin",
			"⋳": "isinsv",
			"⋴": "isins",
			"⋵": "isindot",
			"⋵̸": "notindot",
			"⋶": "notinvc",
			"⋷": "notinvb",
			"⋹": "isinE",
			"⋹̸": "notinE",
			"⋺": "nisd",
			"⋻": "xnis",
			"⋼": "nis",
			"⋽": "notnivc",
			"⋾": "notnivb",
			"⌅": "barwed",
			"⌆": "Barwed",
			"⌌": "drcrop",
			"⌍": "dlcrop",
			"⌎": "urcrop",
			"⌏": "ulcrop",
			"⌐": "bnot",
			"⌒": "profline",
			"⌓": "profsurf",
			"⌕": "telrec",
			"⌖": "target",
			"⌜": "ulcorn",
			"⌝": "urcorn",
			"⌞": "dlcorn",
			"⌟": "drcorn",
			"⌢": "frown",
			"⌣": "smile",
			"⌭": "cylcty",
			"⌮": "profalar",
			"⌶": "topbot",
			"⌽": "ovbar",
			"⌿": "solbar",
			"⍼": "angzarr",
			"⎰": "lmoust",
			"⎱": "rmoust",
			"⎴": "tbrk",
			"⎵": "bbrk",
			"⎶": "bbrktbrk",
			"⏜": "OverParenthesis",
			"⏝": "UnderParenthesis",
			"⏞": "OverBrace",
			"⏟": "UnderBrace",
			"⏢": "trpezium",
			"⏧": "elinters",
			"␣": "blank",
			"─": "boxh",
			"│": "boxv",
			"┌": "boxdr",
			"┐": "boxdl",
			"└": "boxur",
			"┘": "boxul",
			"├": "boxvr",
			"┤": "boxvl",
			"┬": "boxhd",
			"┴": "boxhu",
			"┼": "boxvh",
			"═": "boxH",
			"║": "boxV",
			"╒": "boxdR",
			"╓": "boxDr",
			"╔": "boxDR",
			"╕": "boxdL",
			"╖": "boxDl",
			"╗": "boxDL",
			"╘": "boxuR",
			"╙": "boxUr",
			"╚": "boxUR",
			"╛": "boxuL",
			"╜": "boxUl",
			"╝": "boxUL",
			"╞": "boxvR",
			"╟": "boxVr",
			"╠": "boxVR",
			"╡": "boxvL",
			"╢": "boxVl",
			"╣": "boxVL",
			"╤": "boxHd",
			"╥": "boxhD",
			"╦": "boxHD",
			"╧": "boxHu",
			"╨": "boxhU",
			"╩": "boxHU",
			"╪": "boxvH",
			"╫": "boxVh",
			"╬": "boxVH",
			"▀": "uhblk",
			"▄": "lhblk",
			"█": "block",
			"░": "blk14",
			"▒": "blk12",
			"▓": "blk34",
			"□": "squ",
			"▪": "squf",
			"▫": "EmptyVerySmallSquare",
			"▭": "rect",
			"▮": "marker",
			"▱": "fltns",
			"△": "xutri",
			"▴": "utrif",
			"▵": "utri",
			"▸": "rtrif",
			"▹": "rtri",
			"▽": "xdtri",
			"▾": "dtrif",
			"▿": "dtri",
			"◂": "ltrif",
			"◃": "ltri",
			"◊": "loz",
			"○": "cir",
			"◬": "tridot",
			"◯": "xcirc",
			"◸": "ultri",
			"◹": "urtri",
			"◺": "lltri",
			"◻": "EmptySmallSquare",
			"◼": "FilledSmallSquare",
			"★": "starf",
			"☆": "star",
			"☎": "phone",
			"♀": "female",
			"♂": "male",
			"♠": "spades",
			"♣": "clubs",
			"♥": "hearts",
			"♦": "diams",
			"♪": "sung",
			"✓": "check",
			"✗": "cross",
			"✠": "malt",
			"✶": "sext",
			"❘": "VerticalSeparator",
			"⟈": "bsolhsub",
			"⟉": "suphsol",
			"⟵": "xlarr",
			"⟶": "xrarr",
			"⟷": "xharr",
			"⟸": "xlArr",
			"⟹": "xrArr",
			"⟺": "xhArr",
			"⟼": "xmap",
			"⟿": "dzigrarr",
			"⤂": "nvlArr",
			"⤃": "nvrArr",
			"⤄": "nvHarr",
			"⤅": "Map",
			"⤌": "lbarr",
			"⤍": "rbarr",
			"⤎": "lBarr",
			"⤏": "rBarr",
			"⤐": "RBarr",
			"⤑": "DDotrahd",
			"⤒": "UpArrowBar",
			"⤓": "DownArrowBar",
			"⤖": "Rarrtl",
			"⤙": "latail",
			"⤚": "ratail",
			"⤛": "lAtail",
			"⤜": "rAtail",
			"⤝": "larrfs",
			"⤞": "rarrfs",
			"⤟": "larrbfs",
			"⤠": "rarrbfs",
			"⤣": "nwarhk",
			"⤤": "nearhk",
			"⤥": "searhk",
			"⤦": "swarhk",
			"⤧": "nwnear",
			"⤨": "toea",
			"⤩": "tosa",
			"⤪": "swnwar",
			"⤳": "rarrc",
			"⤳̸": "nrarrc",
			"⤵": "cudarrr",
			"⤶": "ldca",
			"⤷": "rdca",
			"⤸": "cudarrl",
			"⤹": "larrpl",
			"⤼": "curarrm",
			"⤽": "cularrp",
			"⥅": "rarrpl",
			"⥈": "harrcir",
			"⥉": "Uarrocir",
			"⥊": "lurdshar",
			"⥋": "ldrushar",
			"⥎": "LeftRightVector",
			"⥏": "RightUpDownVector",
			"⥐": "DownLeftRightVector",
			"⥑": "LeftUpDownVector",
			"⥒": "LeftVectorBar",
			"⥓": "RightVectorBar",
			"⥔": "RightUpVectorBar",
			"⥕": "RightDownVectorBar",
			"⥖": "DownLeftVectorBar",
			"⥗": "DownRightVectorBar",
			"⥘": "LeftUpVectorBar",
			"⥙": "LeftDownVectorBar",
			"⥚": "LeftTeeVector",
			"⥛": "RightTeeVector",
			"⥜": "RightUpTeeVector",
			"⥝": "RightDownTeeVector",
			"⥞": "DownLeftTeeVector",
			"⥟": "DownRightTeeVector",
			"⥠": "LeftUpTeeVector",
			"⥡": "LeftDownTeeVector",
			"⥢": "lHar",
			"⥣": "uHar",
			"⥤": "rHar",
			"⥥": "dHar",
			"⥦": "luruhar",
			"⥧": "ldrdhar",
			"⥨": "ruluhar",
			"⥩": "rdldhar",
			"⥪": "lharul",
			"⥫": "llhard",
			"⥬": "rharul",
			"⥭": "lrhard",
			"⥮": "udhar",
			"⥯": "duhar",
			"⥰": "RoundImplies",
			"⥱": "erarr",
			"⥲": "simrarr",
			"⥳": "larrsim",
			"⥴": "rarrsim",
			"⥵": "rarrap",
			"⥶": "ltlarr",
			"⥸": "gtrarr",
			"⥹": "subrarr",
			"⥻": "suplarr",
			"⥼": "lfisht",
			"⥽": "rfisht",
			"⥾": "ufisht",
			"⥿": "dfisht",
			"⦚": "vzigzag",
			"⦜": "vangrt",
			"⦝": "angrtvbd",
			"⦤": "ange",
			"⦥": "range",
			"⦦": "dwangle",
			"⦧": "uwangle",
			"⦨": "angmsdaa",
			"⦩": "angmsdab",
			"⦪": "angmsdac",
			"⦫": "angmsdad",
			"⦬": "angmsdae",
			"⦭": "angmsdaf",
			"⦮": "angmsdag",
			"⦯": "angmsdah",
			"⦰": "bemptyv",
			"⦱": "demptyv",
			"⦲": "cemptyv",
			"⦳": "raemptyv",
			"⦴": "laemptyv",
			"⦵": "ohbar",
			"⦶": "omid",
			"⦷": "opar",
			"⦹": "operp",
			"⦻": "olcross",
			"⦼": "odsold",
			"⦾": "olcir",
			"⦿": "ofcir",
			"⧀": "olt",
			"⧁": "ogt",
			"⧂": "cirscir",
			"⧃": "cirE",
			"⧄": "solb",
			"⧅": "bsolb",
			"⧉": "boxbox",
			"⧍": "trisb",
			"⧎": "rtriltri",
			"⧏": "LeftTriangleBar",
			"⧏̸": "NotLeftTriangleBar",
			"⧐": "RightTriangleBar",
			"⧐̸": "NotRightTriangleBar",
			"⧜": "iinfin",
			"⧝": "infintie",
			"⧞": "nvinfin",
			"⧣": "eparsl",
			"⧤": "smeparsl",
			"⧥": "eqvparsl",
			"⧫": "lozf",
			"⧴": "RuleDelayed",
			"⧶": "dsol",
			"⨀": "xodot",
			"⨁": "xoplus",
			"⨂": "xotime",
			"⨄": "xuplus",
			"⨆": "xsqcup",
			"⨍": "fpartint",
			"⨐": "cirfnint",
			"⨑": "awint",
			"⨒": "rppolint",
			"⨓": "scpolint",
			"⨔": "npolint",
			"⨕": "pointint",
			"⨖": "quatint",
			"⨗": "intlarhk",
			"⨢": "pluscir",
			"⨣": "plusacir",
			"⨤": "simplus",
			"⨥": "plusdu",
			"⨦": "plussim",
			"⨧": "plustwo",
			"⨩": "mcomma",
			"⨪": "minusdu",
			"⨭": "loplus",
			"⨮": "roplus",
			"⨯": "Cross",
			"⨰": "timesd",
			"⨱": "timesbar",
			"⨳": "smashp",
			"⨴": "lotimes",
			"⨵": "rotimes",
			"⨶": "otimesas",
			"⨷": "Otimes",
			"⨸": "odiv",
			"⨹": "triplus",
			"⨺": "triminus",
			"⨻": "tritime",
			"⨼": "iprod",
			"⨿": "amalg",
			"⩀": "capdot",
			"⩂": "ncup",
			"⩃": "ncap",
			"⩄": "capand",
			"⩅": "cupor",
			"⩆": "cupcap",
			"⩇": "capcup",
			"⩈": "cupbrcap",
			"⩉": "capbrcup",
			"⩊": "cupcup",
			"⩋": "capcap",
			"⩌": "ccups",
			"⩍": "ccaps",
			"⩐": "ccupssm",
			"⩓": "And",
			"⩔": "Or",
			"⩕": "andand",
			"⩖": "oror",
			"⩗": "orslope",
			"⩘": "andslope",
			"⩚": "andv",
			"⩛": "orv",
			"⩜": "andd",
			"⩝": "ord",
			"⩟": "wedbar",
			"⩦": "sdote",
			"⩪": "simdot",
			"⩭": "congdot",
			"⩭̸": "ncongdot",
			"⩮": "easter",
			"⩯": "apacir",
			"⩰": "apE",
			"⩰̸": "napE",
			"⩱": "eplus",
			"⩲": "pluse",
			"⩳": "Esim",
			"⩷": "eDDot",
			"⩸": "equivDD",
			"⩹": "ltcir",
			"⩺": "gtcir",
			"⩻": "ltquest",
			"⩼": "gtquest",
			"⩽": "les",
			"⩽̸": "nles",
			"⩾": "ges",
			"⩾̸": "nges",
			"⩿": "lesdot",
			"⪀": "gesdot",
			"⪁": "lesdoto",
			"⪂": "gesdoto",
			"⪃": "lesdotor",
			"⪄": "gesdotol",
			"⪅": "lap",
			"⪆": "gap",
			"⪇": "lne",
			"⪈": "gne",
			"⪉": "lnap",
			"⪊": "gnap",
			"⪋": "lEg",
			"⪌": "gEl",
			"⪍": "lsime",
			"⪎": "gsime",
			"⪏": "lsimg",
			"⪐": "gsiml",
			"⪑": "lgE",
			"⪒": "glE",
			"⪓": "lesges",
			"⪔": "gesles",
			"⪕": "els",
			"⪖": "egs",
			"⪗": "elsdot",
			"⪘": "egsdot",
			"⪙": "el",
			"⪚": "eg",
			"⪝": "siml",
			"⪞": "simg",
			"⪟": "simlE",
			"⪠": "simgE",
			"⪡": "LessLess",
			"⪡̸": "NotNestedLessLess",
			"⪢": "GreaterGreater",
			"⪢̸": "NotNestedGreaterGreater",
			"⪤": "glj",
			"⪥": "gla",
			"⪦": "ltcc",
			"⪧": "gtcc",
			"⪨": "lescc",
			"⪩": "gescc",
			"⪪": "smt",
			"⪫": "lat",
			"⪬": "smte",
			"⪬︀": "smtes",
			"⪭": "late",
			"⪭︀": "lates",
			"⪮": "bumpE",
			"⪯": "pre",
			"⪯̸": "npre",
			"⪰": "sce",
			"⪰̸": "nsce",
			"⪳": "prE",
			"⪴": "scE",
			"⪵": "prnE",
			"⪶": "scnE",
			"⪷": "prap",
			"⪸": "scap",
			"⪹": "prnap",
			"⪺": "scnap",
			"⪻": "Pr",
			"⪼": "Sc",
			"⪽": "subdot",
			"⪾": "supdot",
			"⪿": "subplus",
			"⫀": "supplus",
			"⫁": "submult",
			"⫂": "supmult",
			"⫃": "subedot",
			"⫄": "supedot",
			"⫅": "subE",
			"⫅̸": "nsubE",
			"⫆": "supE",
			"⫆̸": "nsupE",
			"⫇": "subsim",
			"⫈": "supsim",
			"⫋︀": "vsubnE",
			"⫋": "subnE",
			"⫌︀": "vsupnE",
			"⫌": "supnE",
			"⫏": "csub",
			"⫐": "csup",
			"⫑": "csube",
			"⫒": "csupe",
			"⫓": "subsup",
			"⫔": "supsub",
			"⫕": "subsub",
			"⫖": "supsup",
			"⫗": "suphsub",
			"⫘": "supdsub",
			"⫙": "forkv",
			"⫚": "topfork",
			"⫛": "mlcp",
			"⫤": "Dashv",
			"⫦": "Vdashl",
			"⫧": "Barv",
			"⫨": "vBar",
			"⫩": "vBarv",
			"⫫": "Vbar",
			"⫬": "Not",
			"⫭": "bNot",
			"⫮": "rnmid",
			"⫯": "cirmid",
			"⫰": "midcir",
			"⫱": "topcir",
			"⫲": "nhpar",
			"⫳": "parsim",
			"⫽": "parsl",
			"⫽⃥": "nparsl",
			"♭": "flat",
			"♮": "natur",
			"♯": "sharp",
			"¤": "curren",
			"¢": "cent",
			"$": "dollar",
			"£": "pound",
			"¥": "yen",
			"€": "euro",
			"¹": "sup1",
			"½": "half",
			"⅓": "frac13",
			"¼": "frac14",
			"⅕": "frac15",
			"⅙": "frac16",
			"⅛": "frac18",
			"²": "sup2",
			"⅔": "frac23",
			"⅖": "frac25",
			"³": "sup3",
			"¾": "frac34",
			"⅗": "frac35",
			"⅜": "frac38",
			"⅘": "frac45",
			"⅚": "frac56",
			"⅝": "frac58",
			"⅞": "frac78",
			"𝒶": "ascr",
			"𝕒": "aopf",
			"𝔞": "afr",
			"𝔸": "Aopf",
			"𝔄": "Afr",
			"𝒜": "Ascr",
			"ª": "ordf",
			"á": "aacute",
			"Á": "Aacute",
			"à": "agrave",
			"À": "Agrave",
			"ă": "abreve",
			"Ă": "Abreve",
			"â": "acirc",
			"Â": "Acirc",
			"å": "aring",
			"Å": "angst",
			"ä": "auml",
			"Ä": "Auml",
			"ã": "atilde",
			"Ã": "Atilde",
			"ą": "aogon",
			"Ą": "Aogon",
			"ā": "amacr",
			"Ā": "Amacr",
			"æ": "aelig",
			"Æ": "AElig",
			"𝒷": "bscr",
			"𝕓": "bopf",
			"𝔟": "bfr",
			"𝔹": "Bopf",
			"ℬ": "Bscr",
			"𝔅": "Bfr",
			"𝔠": "cfr",
			"𝒸": "cscr",
			"𝕔": "copf",
			"ℭ": "Cfr",
			"𝒞": "Cscr",
			"ℂ": "Copf",
			"ć": "cacute",
			"Ć": "Cacute",
			"ĉ": "ccirc",
			"Ĉ": "Ccirc",
			"č": "ccaron",
			"Č": "Ccaron",
			"ċ": "cdot",
			"Ċ": "Cdot",
			"ç": "ccedil",
			"Ç": "Ccedil",
			"℅": "incare",
			"𝔡": "dfr",
			"ⅆ": "dd",
			"𝕕": "dopf",
			"𝒹": "dscr",
			"𝒟": "Dscr",
			"𝔇": "Dfr",
			"ⅅ": "DD",
			"𝔻": "Dopf",
			"ď": "dcaron",
			"Ď": "Dcaron",
			"đ": "dstrok",
			"Đ": "Dstrok",
			"ð": "eth",
			"Ð": "ETH",
			"ⅇ": "ee",
			"ℯ": "escr",
			"𝔢": "efr",
			"𝕖": "eopf",
			"ℰ": "Escr",
			"𝔈": "Efr",
			"𝔼": "Eopf",
			"é": "eacute",
			"É": "Eacute",
			"è": "egrave",
			"È": "Egrave",
			"ê": "ecirc",
			"Ê": "Ecirc",
			"ě": "ecaron",
			"Ě": "Ecaron",
			"ë": "euml",
			"Ë": "Euml",
			"ė": "edot",
			"Ė": "Edot",
			"ę": "eogon",
			"Ę": "Eogon",
			"ē": "emacr",
			"Ē": "Emacr",
			"𝔣": "ffr",
			"𝕗": "fopf",
			"𝒻": "fscr",
			"𝔉": "Ffr",
			"𝔽": "Fopf",
			"ℱ": "Fscr",
			"ﬀ": "fflig",
			"ﬃ": "ffilig",
			"ﬄ": "ffllig",
			"ﬁ": "filig",
			"fj": "fjlig",
			"ﬂ": "fllig",
			"ƒ": "fnof",
			"ℊ": "gscr",
			"𝕘": "gopf",
			"𝔤": "gfr",
			"𝒢": "Gscr",
			"𝔾": "Gopf",
			"𝔊": "Gfr",
			"ǵ": "gacute",
			"ğ": "gbreve",
			"Ğ": "Gbreve",
			"ĝ": "gcirc",
			"Ĝ": "Gcirc",
			"ġ": "gdot",
			"Ġ": "Gdot",
			"Ģ": "Gcedil",
			"𝔥": "hfr",
			"ℎ": "planckh",
			"𝒽": "hscr",
			"𝕙": "hopf",
			"ℋ": "Hscr",
			"ℌ": "Hfr",
			"ℍ": "Hopf",
			"ĥ": "hcirc",
			"Ĥ": "Hcirc",
			"ℏ": "hbar",
			"ħ": "hstrok",
			"Ħ": "Hstrok",
			"𝕚": "iopf",
			"𝔦": "ifr",
			"𝒾": "iscr",
			"ⅈ": "ii",
			"𝕀": "Iopf",
			"ℐ": "Iscr",
			"ℑ": "Im",
			"í": "iacute",
			"Í": "Iacute",
			"ì": "igrave",
			"Ì": "Igrave",
			"î": "icirc",
			"Î": "Icirc",
			"ï": "iuml",
			"Ï": "Iuml",
			"ĩ": "itilde",
			"Ĩ": "Itilde",
			"İ": "Idot",
			"į": "iogon",
			"Į": "Iogon",
			"ī": "imacr",
			"Ī": "Imacr",
			"ĳ": "ijlig",
			"Ĳ": "IJlig",
			"ı": "imath",
			"𝒿": "jscr",
			"𝕛": "jopf",
			"𝔧": "jfr",
			"𝒥": "Jscr",
			"𝔍": "Jfr",
			"𝕁": "Jopf",
			"ĵ": "jcirc",
			"Ĵ": "Jcirc",
			"ȷ": "jmath",
			"𝕜": "kopf",
			"𝓀": "kscr",
			"𝔨": "kfr",
			"𝒦": "Kscr",
			"𝕂": "Kopf",
			"𝔎": "Kfr",
			"ķ": "kcedil",
			"Ķ": "Kcedil",
			"𝔩": "lfr",
			"𝓁": "lscr",
			"ℓ": "ell",
			"𝕝": "lopf",
			"ℒ": "Lscr",
			"𝔏": "Lfr",
			"𝕃": "Lopf",
			"ĺ": "lacute",
			"Ĺ": "Lacute",
			"ľ": "lcaron",
			"Ľ": "Lcaron",
			"ļ": "lcedil",
			"Ļ": "Lcedil",
			"ł": "lstrok",
			"Ł": "Lstrok",
			"ŀ": "lmidot",
			"Ŀ": "Lmidot",
			"𝔪": "mfr",
			"𝕞": "mopf",
			"𝓂": "mscr",
			"𝔐": "Mfr",
			"𝕄": "Mopf",
			"ℳ": "Mscr",
			"𝔫": "nfr",
			"𝕟": "nopf",
			"𝓃": "nscr",
			"ℕ": "Nopf",
			"𝒩": "Nscr",
			"𝔑": "Nfr",
			"ń": "nacute",
			"Ń": "Nacute",
			"ň": "ncaron",
			"Ň": "Ncaron",
			"ñ": "ntilde",
			"Ñ": "Ntilde",
			"ņ": "ncedil",
			"Ņ": "Ncedil",
			"№": "numero",
			"ŋ": "eng",
			"Ŋ": "ENG",
			"𝕠": "oopf",
			"𝔬": "ofr",
			"ℴ": "oscr",
			"𝒪": "Oscr",
			"𝔒": "Ofr",
			"𝕆": "Oopf",
			"º": "ordm",
			"ó": "oacute",
			"Ó": "Oacute",
			"ò": "ograve",
			"Ò": "Ograve",
			"ô": "ocirc",
			"Ô": "Ocirc",
			"ö": "ouml",
			"Ö": "Ouml",
			"ő": "odblac",
			"Ő": "Odblac",
			"õ": "otilde",
			"Õ": "Otilde",
			"ø": "oslash",
			"Ø": "Oslash",
			"ō": "omacr",
			"Ō": "Omacr",
			"œ": "oelig",
			"Œ": "OElig",
			"𝔭": "pfr",
			"𝓅": "pscr",
			"𝕡": "popf",
			"ℙ": "Popf",
			"𝔓": "Pfr",
			"𝒫": "Pscr",
			"𝕢": "qopf",
			"𝔮": "qfr",
			"𝓆": "qscr",
			"𝒬": "Qscr",
			"𝔔": "Qfr",
			"ℚ": "Qopf",
			"ĸ": "kgreen",
			"𝔯": "rfr",
			"𝕣": "ropf",
			"𝓇": "rscr",
			"ℛ": "Rscr",
			"ℜ": "Re",
			"ℝ": "Ropf",
			"ŕ": "racute",
			"Ŕ": "Racute",
			"ř": "rcaron",
			"Ř": "Rcaron",
			"ŗ": "rcedil",
			"Ŗ": "Rcedil",
			"𝕤": "sopf",
			"𝓈": "sscr",
			"𝔰": "sfr",
			"𝕊": "Sopf",
			"𝔖": "Sfr",
			"𝒮": "Sscr",
			"Ⓢ": "oS",
			"ś": "sacute",
			"Ś": "Sacute",
			"ŝ": "scirc",
			"Ŝ": "Scirc",
			"š": "scaron",
			"Š": "Scaron",
			"ş": "scedil",
			"Ş": "Scedil",
			"ß": "szlig",
			"𝔱": "tfr",
			"𝓉": "tscr",
			"𝕥": "topf",
			"𝒯": "Tscr",
			"𝔗": "Tfr",
			"𝕋": "Topf",
			"ť": "tcaron",
			"Ť": "Tcaron",
			"ţ": "tcedil",
			"Ţ": "Tcedil",
			"™": "trade",
			"ŧ": "tstrok",
			"Ŧ": "Tstrok",
			"𝓊": "uscr",
			"𝕦": "uopf",
			"𝔲": "ufr",
			"𝕌": "Uopf",
			"𝔘": "Ufr",
			"𝒰": "Uscr",
			"ú": "uacute",
			"Ú": "Uacute",
			"ù": "ugrave",
			"Ù": "Ugrave",
			"ŭ": "ubreve",
			"Ŭ": "Ubreve",
			"û": "ucirc",
			"Û": "Ucirc",
			"ů": "uring",
			"Ů": "Uring",
			"ü": "uuml",
			"Ü": "Uuml",
			"ű": "udblac",
			"Ű": "Udblac",
			"ũ": "utilde",
			"Ũ": "Utilde",
			"ų": "uogon",
			"Ų": "Uogon",
			"ū": "umacr",
			"Ū": "Umacr",
			"𝔳": "vfr",
			"𝕧": "vopf",
			"𝓋": "vscr",
			"𝔙": "Vfr",
			"𝕍": "Vopf",
			"𝒱": "Vscr",
			"𝕨": "wopf",
			"𝓌": "wscr",
			"𝔴": "wfr",
			"𝒲": "Wscr",
			"𝕎": "Wopf",
			"𝔚": "Wfr",
			"ŵ": "wcirc",
			"Ŵ": "Wcirc",
			"𝔵": "xfr",
			"𝓍": "xscr",
			"𝕩": "xopf",
			"𝕏": "Xopf",
			"𝔛": "Xfr",
			"𝒳": "Xscr",
			"𝔶": "yfr",
			"𝓎": "yscr",
			"𝕪": "yopf",
			"𝒴": "Yscr",
			"𝔜": "Yfr",
			"𝕐": "Yopf",
			"ý": "yacute",
			"Ý": "Yacute",
			"ŷ": "ycirc",
			"Ŷ": "Ycirc",
			"ÿ": "yuml",
			"Ÿ": "Yuml",
			"𝓏": "zscr",
			"𝔷": "zfr",
			"𝕫": "zopf",
			"ℨ": "Zfr",
			"ℤ": "Zopf",
			"𝒵": "Zscr",
			"ź": "zacute",
			"Ź": "Zacute",
			"ž": "zcaron",
			"Ž": "Zcaron",
			"ż": "zdot",
			"Ż": "Zdot",
			"Ƶ": "imped",
			"þ": "thorn",
			"Þ": "THORN",
			"ŉ": "napos",
			"α": "alpha",
			"Α": "Alpha",
			"β": "beta",
			"Β": "Beta",
			"γ": "gamma",
			"Γ": "Gamma",
			"δ": "delta",
			"Δ": "Delta",
			"ε": "epsi",
			"ϵ": "epsiv",
			"Ε": "Epsilon",
			"ϝ": "gammad",
			"Ϝ": "Gammad",
			"ζ": "zeta",
			"Ζ": "Zeta",
			"η": "eta",
			"Η": "Eta",
			"θ": "theta",
			"ϑ": "thetav",
			"Θ": "Theta",
			"ι": "iota",
			"Ι": "Iota",
			"κ": "kappa",
			"ϰ": "kappav",
			"Κ": "Kappa",
			"λ": "lambda",
			"Λ": "Lambda",
			"μ": "mu",
			"µ": "micro",
			"Μ": "Mu",
			"ν": "nu",
			"Ν": "Nu",
			"ξ": "xi",
			"Ξ": "Xi",
			"ο": "omicron",
			"Ο": "Omicron",
			"π": "pi",
			"ϖ": "piv",
			"Π": "Pi",
			"ρ": "rho",
			"ϱ": "rhov",
			"Ρ": "Rho",
			"σ": "sigma",
			"Σ": "Sigma",
			"ς": "sigmaf",
			"τ": "tau",
			"Τ": "Tau",
			"υ": "upsi",
			"Υ": "Upsilon",
			"ϒ": "Upsi",
			"φ": "phi",
			"ϕ": "phiv",
			"Φ": "Phi",
			"χ": "chi",
			"Χ": "Chi",
			"ψ": "psi",
			"Ψ": "Psi",
			"ω": "omega",
			"Ω": "ohm",
			"а": "acy",
			"А": "Acy",
			"б": "bcy",
			"Б": "Bcy",
			"в": "vcy",
			"В": "Vcy",
			"г": "gcy",
			"Г": "Gcy",
			"ѓ": "gjcy",
			"Ѓ": "GJcy",
			"д": "dcy",
			"Д": "Dcy",
			"ђ": "djcy",
			"Ђ": "DJcy",
			"е": "iecy",
			"Е": "IEcy",
			"ё": "iocy",
			"Ё": "IOcy",
			"є": "jukcy",
			"Є": "Jukcy",
			"ж": "zhcy",
			"Ж": "ZHcy",
			"з": "zcy",
			"З": "Zcy",
			"ѕ": "dscy",
			"Ѕ": "DScy",
			"и": "icy",
			"И": "Icy",
			"і": "iukcy",
			"І": "Iukcy",
			"ї": "yicy",
			"Ї": "YIcy",
			"й": "jcy",
			"Й": "Jcy",
			"ј": "jsercy",
			"Ј": "Jsercy",
			"к": "kcy",
			"К": "Kcy",
			"ќ": "kjcy",
			"Ќ": "KJcy",
			"л": "lcy",
			"Л": "Lcy",
			"љ": "ljcy",
			"Љ": "LJcy",
			"м": "mcy",
			"М": "Mcy",
			"н": "ncy",
			"Н": "Ncy",
			"њ": "njcy",
			"Њ": "NJcy",
			"о": "ocy",
			"О": "Ocy",
			"п": "pcy",
			"П": "Pcy",
			"р": "rcy",
			"Р": "Rcy",
			"с": "scy",
			"С": "Scy",
			"т": "tcy",
			"Т": "Tcy",
			"ћ": "tshcy",
			"Ћ": "TSHcy",
			"у": "ucy",
			"У": "Ucy",
			"ў": "ubrcy",
			"Ў": "Ubrcy",
			"ф": "fcy",
			"Ф": "Fcy",
			"х": "khcy",
			"Х": "KHcy",
			"ц": "tscy",
			"Ц": "TScy",
			"ч": "chcy",
			"Ч": "CHcy",
			"џ": "dzcy",
			"Џ": "DZcy",
			"ш": "shcy",
			"Ш": "SHcy",
			"щ": "shchcy",
			"Щ": "SHCHcy",
			"ъ": "hardcy",
			"Ъ": "HARDcy",
			"ы": "ycy",
			"Ы": "Ycy",
			"ь": "softcy",
			"Ь": "SOFTcy",
			"э": "ecy",
			"Э": "Ecy",
			"ю": "yucy",
			"Ю": "YUcy",
			"я": "yacy",
			"Я": "YAcy",
			"ℵ": "aleph",
			"ℶ": "beth",
			"ℷ": "gimel",
			"ℸ": "daleth"
		};
		var regexEscape = /["&'<>`]/g;
		var escapeMap = {
			"\"": "&quot;",
			"&": "&amp;",
			"'": "&#x27;",
			"<": "&lt;",
			">": "&gt;",
			"`": "&#x60;"
		};
		var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
		var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
		var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
		var decodeMap = {
			"aacute": "á",
			"Aacute": "Á",
			"abreve": "ă",
			"Abreve": "Ă",
			"ac": "∾",
			"acd": "∿",
			"acE": "∾̳",
			"acirc": "â",
			"Acirc": "Â",
			"acute": "´",
			"acy": "а",
			"Acy": "А",
			"aelig": "æ",
			"AElig": "Æ",
			"af": "⁡",
			"afr": "𝔞",
			"Afr": "𝔄",
			"agrave": "à",
			"Agrave": "À",
			"alefsym": "ℵ",
			"aleph": "ℵ",
			"alpha": "α",
			"Alpha": "Α",
			"amacr": "ā",
			"Amacr": "Ā",
			"amalg": "⨿",
			"amp": "&",
			"AMP": "&",
			"and": "∧",
			"And": "⩓",
			"andand": "⩕",
			"andd": "⩜",
			"andslope": "⩘",
			"andv": "⩚",
			"ang": "∠",
			"ange": "⦤",
			"angle": "∠",
			"angmsd": "∡",
			"angmsdaa": "⦨",
			"angmsdab": "⦩",
			"angmsdac": "⦪",
			"angmsdad": "⦫",
			"angmsdae": "⦬",
			"angmsdaf": "⦭",
			"angmsdag": "⦮",
			"angmsdah": "⦯",
			"angrt": "∟",
			"angrtvb": "⊾",
			"angrtvbd": "⦝",
			"angsph": "∢",
			"angst": "Å",
			"angzarr": "⍼",
			"aogon": "ą",
			"Aogon": "Ą",
			"aopf": "𝕒",
			"Aopf": "𝔸",
			"ap": "≈",
			"apacir": "⩯",
			"ape": "≊",
			"apE": "⩰",
			"apid": "≋",
			"apos": "'",
			"ApplyFunction": "⁡",
			"approx": "≈",
			"approxeq": "≊",
			"aring": "å",
			"Aring": "Å",
			"ascr": "𝒶",
			"Ascr": "𝒜",
			"Assign": "≔",
			"ast": "*",
			"asymp": "≈",
			"asympeq": "≍",
			"atilde": "ã",
			"Atilde": "Ã",
			"auml": "ä",
			"Auml": "Ä",
			"awconint": "∳",
			"awint": "⨑",
			"backcong": "≌",
			"backepsilon": "϶",
			"backprime": "‵",
			"backsim": "∽",
			"backsimeq": "⋍",
			"Backslash": "∖",
			"Barv": "⫧",
			"barvee": "⊽",
			"barwed": "⌅",
			"Barwed": "⌆",
			"barwedge": "⌅",
			"bbrk": "⎵",
			"bbrktbrk": "⎶",
			"bcong": "≌",
			"bcy": "б",
			"Bcy": "Б",
			"bdquo": "„",
			"becaus": "∵",
			"because": "∵",
			"Because": "∵",
			"bemptyv": "⦰",
			"bepsi": "϶",
			"bernou": "ℬ",
			"Bernoullis": "ℬ",
			"beta": "β",
			"Beta": "Β",
			"beth": "ℶ",
			"between": "≬",
			"bfr": "𝔟",
			"Bfr": "𝔅",
			"bigcap": "⋂",
			"bigcirc": "◯",
			"bigcup": "⋃",
			"bigodot": "⨀",
			"bigoplus": "⨁",
			"bigotimes": "⨂",
			"bigsqcup": "⨆",
			"bigstar": "★",
			"bigtriangledown": "▽",
			"bigtriangleup": "△",
			"biguplus": "⨄",
			"bigvee": "⋁",
			"bigwedge": "⋀",
			"bkarow": "⤍",
			"blacklozenge": "⧫",
			"blacksquare": "▪",
			"blacktriangle": "▴",
			"blacktriangledown": "▾",
			"blacktriangleleft": "◂",
			"blacktriangleright": "▸",
			"blank": "␣",
			"blk12": "▒",
			"blk14": "░",
			"blk34": "▓",
			"block": "█",
			"bne": "=⃥",
			"bnequiv": "≡⃥",
			"bnot": "⌐",
			"bNot": "⫭",
			"bopf": "𝕓",
			"Bopf": "𝔹",
			"bot": "⊥",
			"bottom": "⊥",
			"bowtie": "⋈",
			"boxbox": "⧉",
			"boxdl": "┐",
			"boxdL": "╕",
			"boxDl": "╖",
			"boxDL": "╗",
			"boxdr": "┌",
			"boxdR": "╒",
			"boxDr": "╓",
			"boxDR": "╔",
			"boxh": "─",
			"boxH": "═",
			"boxhd": "┬",
			"boxhD": "╥",
			"boxHd": "╤",
			"boxHD": "╦",
			"boxhu": "┴",
			"boxhU": "╨",
			"boxHu": "╧",
			"boxHU": "╩",
			"boxminus": "⊟",
			"boxplus": "⊞",
			"boxtimes": "⊠",
			"boxul": "┘",
			"boxuL": "╛",
			"boxUl": "╜",
			"boxUL": "╝",
			"boxur": "└",
			"boxuR": "╘",
			"boxUr": "╙",
			"boxUR": "╚",
			"boxv": "│",
			"boxV": "║",
			"boxvh": "┼",
			"boxvH": "╪",
			"boxVh": "╫",
			"boxVH": "╬",
			"boxvl": "┤",
			"boxvL": "╡",
			"boxVl": "╢",
			"boxVL": "╣",
			"boxvr": "├",
			"boxvR": "╞",
			"boxVr": "╟",
			"boxVR": "╠",
			"bprime": "‵",
			"breve": "˘",
			"Breve": "˘",
			"brvbar": "¦",
			"bscr": "𝒷",
			"Bscr": "ℬ",
			"bsemi": "⁏",
			"bsim": "∽",
			"bsime": "⋍",
			"bsol": "\\",
			"bsolb": "⧅",
			"bsolhsub": "⟈",
			"bull": "•",
			"bullet": "•",
			"bump": "≎",
			"bumpe": "≏",
			"bumpE": "⪮",
			"bumpeq": "≏",
			"Bumpeq": "≎",
			"cacute": "ć",
			"Cacute": "Ć",
			"cap": "∩",
			"Cap": "⋒",
			"capand": "⩄",
			"capbrcup": "⩉",
			"capcap": "⩋",
			"capcup": "⩇",
			"capdot": "⩀",
			"CapitalDifferentialD": "ⅅ",
			"caps": "∩︀",
			"caret": "⁁",
			"caron": "ˇ",
			"Cayleys": "ℭ",
			"ccaps": "⩍",
			"ccaron": "č",
			"Ccaron": "Č",
			"ccedil": "ç",
			"Ccedil": "Ç",
			"ccirc": "ĉ",
			"Ccirc": "Ĉ",
			"Cconint": "∰",
			"ccups": "⩌",
			"ccupssm": "⩐",
			"cdot": "ċ",
			"Cdot": "Ċ",
			"cedil": "¸",
			"Cedilla": "¸",
			"cemptyv": "⦲",
			"cent": "¢",
			"centerdot": "·",
			"CenterDot": "·",
			"cfr": "𝔠",
			"Cfr": "ℭ",
			"chcy": "ч",
			"CHcy": "Ч",
			"check": "✓",
			"checkmark": "✓",
			"chi": "χ",
			"Chi": "Χ",
			"cir": "○",
			"circ": "ˆ",
			"circeq": "≗",
			"circlearrowleft": "↺",
			"circlearrowright": "↻",
			"circledast": "⊛",
			"circledcirc": "⊚",
			"circleddash": "⊝",
			"CircleDot": "⊙",
			"circledR": "®",
			"circledS": "Ⓢ",
			"CircleMinus": "⊖",
			"CirclePlus": "⊕",
			"CircleTimes": "⊗",
			"cire": "≗",
			"cirE": "⧃",
			"cirfnint": "⨐",
			"cirmid": "⫯",
			"cirscir": "⧂",
			"ClockwiseContourIntegral": "∲",
			"CloseCurlyDoubleQuote": "”",
			"CloseCurlyQuote": "’",
			"clubs": "♣",
			"clubsuit": "♣",
			"colon": ":",
			"Colon": "∷",
			"colone": "≔",
			"Colone": "⩴",
			"coloneq": "≔",
			"comma": ",",
			"commat": "@",
			"comp": "∁",
			"compfn": "∘",
			"complement": "∁",
			"complexes": "ℂ",
			"cong": "≅",
			"congdot": "⩭",
			"Congruent": "≡",
			"conint": "∮",
			"Conint": "∯",
			"ContourIntegral": "∮",
			"copf": "𝕔",
			"Copf": "ℂ",
			"coprod": "∐",
			"Coproduct": "∐",
			"copy": "©",
			"COPY": "©",
			"copysr": "℗",
			"CounterClockwiseContourIntegral": "∳",
			"crarr": "↵",
			"cross": "✗",
			"Cross": "⨯",
			"cscr": "𝒸",
			"Cscr": "𝒞",
			"csub": "⫏",
			"csube": "⫑",
			"csup": "⫐",
			"csupe": "⫒",
			"ctdot": "⋯",
			"cudarrl": "⤸",
			"cudarrr": "⤵",
			"cuepr": "⋞",
			"cuesc": "⋟",
			"cularr": "↶",
			"cularrp": "⤽",
			"cup": "∪",
			"Cup": "⋓",
			"cupbrcap": "⩈",
			"cupcap": "⩆",
			"CupCap": "≍",
			"cupcup": "⩊",
			"cupdot": "⊍",
			"cupor": "⩅",
			"cups": "∪︀",
			"curarr": "↷",
			"curarrm": "⤼",
			"curlyeqprec": "⋞",
			"curlyeqsucc": "⋟",
			"curlyvee": "⋎",
			"curlywedge": "⋏",
			"curren": "¤",
			"curvearrowleft": "↶",
			"curvearrowright": "↷",
			"cuvee": "⋎",
			"cuwed": "⋏",
			"cwconint": "∲",
			"cwint": "∱",
			"cylcty": "⌭",
			"dagger": "†",
			"Dagger": "‡",
			"daleth": "ℸ",
			"darr": "↓",
			"dArr": "⇓",
			"Darr": "↡",
			"dash": "‐",
			"dashv": "⊣",
			"Dashv": "⫤",
			"dbkarow": "⤏",
			"dblac": "˝",
			"dcaron": "ď",
			"Dcaron": "Ď",
			"dcy": "д",
			"Dcy": "Д",
			"dd": "ⅆ",
			"DD": "ⅅ",
			"ddagger": "‡",
			"ddarr": "⇊",
			"DDotrahd": "⤑",
			"ddotseq": "⩷",
			"deg": "°",
			"Del": "∇",
			"delta": "δ",
			"Delta": "Δ",
			"demptyv": "⦱",
			"dfisht": "⥿",
			"dfr": "𝔡",
			"Dfr": "𝔇",
			"dHar": "⥥",
			"dharl": "⇃",
			"dharr": "⇂",
			"DiacriticalAcute": "´",
			"DiacriticalDot": "˙",
			"DiacriticalDoubleAcute": "˝",
			"DiacriticalGrave": "`",
			"DiacriticalTilde": "˜",
			"diam": "⋄",
			"diamond": "⋄",
			"Diamond": "⋄",
			"diamondsuit": "♦",
			"diams": "♦",
			"die": "¨",
			"DifferentialD": "ⅆ",
			"digamma": "ϝ",
			"disin": "⋲",
			"div": "÷",
			"divide": "÷",
			"divideontimes": "⋇",
			"divonx": "⋇",
			"djcy": "ђ",
			"DJcy": "Ђ",
			"dlcorn": "⌞",
			"dlcrop": "⌍",
			"dollar": "$",
			"dopf": "𝕕",
			"Dopf": "𝔻",
			"dot": "˙",
			"Dot": "¨",
			"DotDot": "⃜",
			"doteq": "≐",
			"doteqdot": "≑",
			"DotEqual": "≐",
			"dotminus": "∸",
			"dotplus": "∔",
			"dotsquare": "⊡",
			"doublebarwedge": "⌆",
			"DoubleContourIntegral": "∯",
			"DoubleDot": "¨",
			"DoubleDownArrow": "⇓",
			"DoubleLeftArrow": "⇐",
			"DoubleLeftRightArrow": "⇔",
			"DoubleLeftTee": "⫤",
			"DoubleLongLeftArrow": "⟸",
			"DoubleLongLeftRightArrow": "⟺",
			"DoubleLongRightArrow": "⟹",
			"DoubleRightArrow": "⇒",
			"DoubleRightTee": "⊨",
			"DoubleUpArrow": "⇑",
			"DoubleUpDownArrow": "⇕",
			"DoubleVerticalBar": "∥",
			"downarrow": "↓",
			"Downarrow": "⇓",
			"DownArrow": "↓",
			"DownArrowBar": "⤓",
			"DownArrowUpArrow": "⇵",
			"DownBreve": "̑",
			"downdownarrows": "⇊",
			"downharpoonleft": "⇃",
			"downharpoonright": "⇂",
			"DownLeftRightVector": "⥐",
			"DownLeftTeeVector": "⥞",
			"DownLeftVector": "↽",
			"DownLeftVectorBar": "⥖",
			"DownRightTeeVector": "⥟",
			"DownRightVector": "⇁",
			"DownRightVectorBar": "⥗",
			"DownTee": "⊤",
			"DownTeeArrow": "↧",
			"drbkarow": "⤐",
			"drcorn": "⌟",
			"drcrop": "⌌",
			"dscr": "𝒹",
			"Dscr": "𝒟",
			"dscy": "ѕ",
			"DScy": "Ѕ",
			"dsol": "⧶",
			"dstrok": "đ",
			"Dstrok": "Đ",
			"dtdot": "⋱",
			"dtri": "▿",
			"dtrif": "▾",
			"duarr": "⇵",
			"duhar": "⥯",
			"dwangle": "⦦",
			"dzcy": "џ",
			"DZcy": "Џ",
			"dzigrarr": "⟿",
			"eacute": "é",
			"Eacute": "É",
			"easter": "⩮",
			"ecaron": "ě",
			"Ecaron": "Ě",
			"ecir": "≖",
			"ecirc": "ê",
			"Ecirc": "Ê",
			"ecolon": "≕",
			"ecy": "э",
			"Ecy": "Э",
			"eDDot": "⩷",
			"edot": "ė",
			"eDot": "≑",
			"Edot": "Ė",
			"ee": "ⅇ",
			"efDot": "≒",
			"efr": "𝔢",
			"Efr": "𝔈",
			"eg": "⪚",
			"egrave": "è",
			"Egrave": "È",
			"egs": "⪖",
			"egsdot": "⪘",
			"el": "⪙",
			"Element": "∈",
			"elinters": "⏧",
			"ell": "ℓ",
			"els": "⪕",
			"elsdot": "⪗",
			"emacr": "ē",
			"Emacr": "Ē",
			"empty": "∅",
			"emptyset": "∅",
			"EmptySmallSquare": "◻",
			"emptyv": "∅",
			"EmptyVerySmallSquare": "▫",
			"emsp": " ",
			"emsp13": " ",
			"emsp14": " ",
			"eng": "ŋ",
			"ENG": "Ŋ",
			"ensp": " ",
			"eogon": "ę",
			"Eogon": "Ę",
			"eopf": "𝕖",
			"Eopf": "𝔼",
			"epar": "⋕",
			"eparsl": "⧣",
			"eplus": "⩱",
			"epsi": "ε",
			"epsilon": "ε",
			"Epsilon": "Ε",
			"epsiv": "ϵ",
			"eqcirc": "≖",
			"eqcolon": "≕",
			"eqsim": "≂",
			"eqslantgtr": "⪖",
			"eqslantless": "⪕",
			"Equal": "⩵",
			"equals": "=",
			"EqualTilde": "≂",
			"equest": "≟",
			"Equilibrium": "⇌",
			"equiv": "≡",
			"equivDD": "⩸",
			"eqvparsl": "⧥",
			"erarr": "⥱",
			"erDot": "≓",
			"escr": "ℯ",
			"Escr": "ℰ",
			"esdot": "≐",
			"esim": "≂",
			"Esim": "⩳",
			"eta": "η",
			"Eta": "Η",
			"eth": "ð",
			"ETH": "Ð",
			"euml": "ë",
			"Euml": "Ë",
			"euro": "€",
			"excl": "!",
			"exist": "∃",
			"Exists": "∃",
			"expectation": "ℰ",
			"exponentiale": "ⅇ",
			"ExponentialE": "ⅇ",
			"fallingdotseq": "≒",
			"fcy": "ф",
			"Fcy": "Ф",
			"female": "♀",
			"ffilig": "ﬃ",
			"fflig": "ﬀ",
			"ffllig": "ﬄ",
			"ffr": "𝔣",
			"Ffr": "𝔉",
			"filig": "ﬁ",
			"FilledSmallSquare": "◼",
			"FilledVerySmallSquare": "▪",
			"fjlig": "fj",
			"flat": "♭",
			"fllig": "ﬂ",
			"fltns": "▱",
			"fnof": "ƒ",
			"fopf": "𝕗",
			"Fopf": "𝔽",
			"forall": "∀",
			"ForAll": "∀",
			"fork": "⋔",
			"forkv": "⫙",
			"Fouriertrf": "ℱ",
			"fpartint": "⨍",
			"frac12": "½",
			"frac13": "⅓",
			"frac14": "¼",
			"frac15": "⅕",
			"frac16": "⅙",
			"frac18": "⅛",
			"frac23": "⅔",
			"frac25": "⅖",
			"frac34": "¾",
			"frac35": "⅗",
			"frac38": "⅜",
			"frac45": "⅘",
			"frac56": "⅚",
			"frac58": "⅝",
			"frac78": "⅞",
			"frasl": "⁄",
			"frown": "⌢",
			"fscr": "𝒻",
			"Fscr": "ℱ",
			"gacute": "ǵ",
			"gamma": "γ",
			"Gamma": "Γ",
			"gammad": "ϝ",
			"Gammad": "Ϝ",
			"gap": "⪆",
			"gbreve": "ğ",
			"Gbreve": "Ğ",
			"Gcedil": "Ģ",
			"gcirc": "ĝ",
			"Gcirc": "Ĝ",
			"gcy": "г",
			"Gcy": "Г",
			"gdot": "ġ",
			"Gdot": "Ġ",
			"ge": "≥",
			"gE": "≧",
			"gel": "⋛",
			"gEl": "⪌",
			"geq": "≥",
			"geqq": "≧",
			"geqslant": "⩾",
			"ges": "⩾",
			"gescc": "⪩",
			"gesdot": "⪀",
			"gesdoto": "⪂",
			"gesdotol": "⪄",
			"gesl": "⋛︀",
			"gesles": "⪔",
			"gfr": "𝔤",
			"Gfr": "𝔊",
			"gg": "≫",
			"Gg": "⋙",
			"ggg": "⋙",
			"gimel": "ℷ",
			"gjcy": "ѓ",
			"GJcy": "Ѓ",
			"gl": "≷",
			"gla": "⪥",
			"glE": "⪒",
			"glj": "⪤",
			"gnap": "⪊",
			"gnapprox": "⪊",
			"gne": "⪈",
			"gnE": "≩",
			"gneq": "⪈",
			"gneqq": "≩",
			"gnsim": "⋧",
			"gopf": "𝕘",
			"Gopf": "𝔾",
			"grave": "`",
			"GreaterEqual": "≥",
			"GreaterEqualLess": "⋛",
			"GreaterFullEqual": "≧",
			"GreaterGreater": "⪢",
			"GreaterLess": "≷",
			"GreaterSlantEqual": "⩾",
			"GreaterTilde": "≳",
			"gscr": "ℊ",
			"Gscr": "𝒢",
			"gsim": "≳",
			"gsime": "⪎",
			"gsiml": "⪐",
			"gt": ">",
			"Gt": "≫",
			"GT": ">",
			"gtcc": "⪧",
			"gtcir": "⩺",
			"gtdot": "⋗",
			"gtlPar": "⦕",
			"gtquest": "⩼",
			"gtrapprox": "⪆",
			"gtrarr": "⥸",
			"gtrdot": "⋗",
			"gtreqless": "⋛",
			"gtreqqless": "⪌",
			"gtrless": "≷",
			"gtrsim": "≳",
			"gvertneqq": "≩︀",
			"gvnE": "≩︀",
			"Hacek": "ˇ",
			"hairsp": " ",
			"half": "½",
			"hamilt": "ℋ",
			"hardcy": "ъ",
			"HARDcy": "Ъ",
			"harr": "↔",
			"hArr": "⇔",
			"harrcir": "⥈",
			"harrw": "↭",
			"Hat": "^",
			"hbar": "ℏ",
			"hcirc": "ĥ",
			"Hcirc": "Ĥ",
			"hearts": "♥",
			"heartsuit": "♥",
			"hellip": "…",
			"hercon": "⊹",
			"hfr": "𝔥",
			"Hfr": "ℌ",
			"HilbertSpace": "ℋ",
			"hksearow": "⤥",
			"hkswarow": "⤦",
			"hoarr": "⇿",
			"homtht": "∻",
			"hookleftarrow": "↩",
			"hookrightarrow": "↪",
			"hopf": "𝕙",
			"Hopf": "ℍ",
			"horbar": "―",
			"HorizontalLine": "─",
			"hscr": "𝒽",
			"Hscr": "ℋ",
			"hslash": "ℏ",
			"hstrok": "ħ",
			"Hstrok": "Ħ",
			"HumpDownHump": "≎",
			"HumpEqual": "≏",
			"hybull": "⁃",
			"hyphen": "‐",
			"iacute": "í",
			"Iacute": "Í",
			"ic": "⁣",
			"icirc": "î",
			"Icirc": "Î",
			"icy": "и",
			"Icy": "И",
			"Idot": "İ",
			"iecy": "е",
			"IEcy": "Е",
			"iexcl": "¡",
			"iff": "⇔",
			"ifr": "𝔦",
			"Ifr": "ℑ",
			"igrave": "ì",
			"Igrave": "Ì",
			"ii": "ⅈ",
			"iiiint": "⨌",
			"iiint": "∭",
			"iinfin": "⧜",
			"iiota": "℩",
			"ijlig": "ĳ",
			"IJlig": "Ĳ",
			"Im": "ℑ",
			"imacr": "ī",
			"Imacr": "Ī",
			"image": "ℑ",
			"ImaginaryI": "ⅈ",
			"imagline": "ℐ",
			"imagpart": "ℑ",
			"imath": "ı",
			"imof": "⊷",
			"imped": "Ƶ",
			"Implies": "⇒",
			"in": "∈",
			"incare": "℅",
			"infin": "∞",
			"infintie": "⧝",
			"inodot": "ı",
			"int": "∫",
			"Int": "∬",
			"intcal": "⊺",
			"integers": "ℤ",
			"Integral": "∫",
			"intercal": "⊺",
			"Intersection": "⋂",
			"intlarhk": "⨗",
			"intprod": "⨼",
			"InvisibleComma": "⁣",
			"InvisibleTimes": "⁢",
			"iocy": "ё",
			"IOcy": "Ё",
			"iogon": "į",
			"Iogon": "Į",
			"iopf": "𝕚",
			"Iopf": "𝕀",
			"iota": "ι",
			"Iota": "Ι",
			"iprod": "⨼",
			"iquest": "¿",
			"iscr": "𝒾",
			"Iscr": "ℐ",
			"isin": "∈",
			"isindot": "⋵",
			"isinE": "⋹",
			"isins": "⋴",
			"isinsv": "⋳",
			"isinv": "∈",
			"it": "⁢",
			"itilde": "ĩ",
			"Itilde": "Ĩ",
			"iukcy": "і",
			"Iukcy": "І",
			"iuml": "ï",
			"Iuml": "Ï",
			"jcirc": "ĵ",
			"Jcirc": "Ĵ",
			"jcy": "й",
			"Jcy": "Й",
			"jfr": "𝔧",
			"Jfr": "𝔍",
			"jmath": "ȷ",
			"jopf": "𝕛",
			"Jopf": "𝕁",
			"jscr": "𝒿",
			"Jscr": "𝒥",
			"jsercy": "ј",
			"Jsercy": "Ј",
			"jukcy": "є",
			"Jukcy": "Є",
			"kappa": "κ",
			"Kappa": "Κ",
			"kappav": "ϰ",
			"kcedil": "ķ",
			"Kcedil": "Ķ",
			"kcy": "к",
			"Kcy": "К",
			"kfr": "𝔨",
			"Kfr": "𝔎",
			"kgreen": "ĸ",
			"khcy": "х",
			"KHcy": "Х",
			"kjcy": "ќ",
			"KJcy": "Ќ",
			"kopf": "𝕜",
			"Kopf": "𝕂",
			"kscr": "𝓀",
			"Kscr": "𝒦",
			"lAarr": "⇚",
			"lacute": "ĺ",
			"Lacute": "Ĺ",
			"laemptyv": "⦴",
			"lagran": "ℒ",
			"lambda": "λ",
			"Lambda": "Λ",
			"lang": "⟨",
			"Lang": "⟪",
			"langd": "⦑",
			"langle": "⟨",
			"lap": "⪅",
			"Laplacetrf": "ℒ",
			"laquo": "«",
			"larr": "←",
			"lArr": "⇐",
			"Larr": "↞",
			"larrb": "⇤",
			"larrbfs": "⤟",
			"larrfs": "⤝",
			"larrhk": "↩",
			"larrlp": "↫",
			"larrpl": "⤹",
			"larrsim": "⥳",
			"larrtl": "↢",
			"lat": "⪫",
			"latail": "⤙",
			"lAtail": "⤛",
			"late": "⪭",
			"lates": "⪭︀",
			"lbarr": "⤌",
			"lBarr": "⤎",
			"lbbrk": "❲",
			"lbrace": "{",
			"lbrack": "[",
			"lbrke": "⦋",
			"lbrksld": "⦏",
			"lbrkslu": "⦍",
			"lcaron": "ľ",
			"Lcaron": "Ľ",
			"lcedil": "ļ",
			"Lcedil": "Ļ",
			"lceil": "⌈",
			"lcub": "{",
			"lcy": "л",
			"Lcy": "Л",
			"ldca": "⤶",
			"ldquo": "“",
			"ldquor": "„",
			"ldrdhar": "⥧",
			"ldrushar": "⥋",
			"ldsh": "↲",
			"le": "≤",
			"lE": "≦",
			"LeftAngleBracket": "⟨",
			"leftarrow": "←",
			"Leftarrow": "⇐",
			"LeftArrow": "←",
			"LeftArrowBar": "⇤",
			"LeftArrowRightArrow": "⇆",
			"leftarrowtail": "↢",
			"LeftCeiling": "⌈",
			"LeftDoubleBracket": "⟦",
			"LeftDownTeeVector": "⥡",
			"LeftDownVector": "⇃",
			"LeftDownVectorBar": "⥙",
			"LeftFloor": "⌊",
			"leftharpoondown": "↽",
			"leftharpoonup": "↼",
			"leftleftarrows": "⇇",
			"leftrightarrow": "↔",
			"Leftrightarrow": "⇔",
			"LeftRightArrow": "↔",
			"leftrightarrows": "⇆",
			"leftrightharpoons": "⇋",
			"leftrightsquigarrow": "↭",
			"LeftRightVector": "⥎",
			"LeftTee": "⊣",
			"LeftTeeArrow": "↤",
			"LeftTeeVector": "⥚",
			"leftthreetimes": "⋋",
			"LeftTriangle": "⊲",
			"LeftTriangleBar": "⧏",
			"LeftTriangleEqual": "⊴",
			"LeftUpDownVector": "⥑",
			"LeftUpTeeVector": "⥠",
			"LeftUpVector": "↿",
			"LeftUpVectorBar": "⥘",
			"LeftVector": "↼",
			"LeftVectorBar": "⥒",
			"leg": "⋚",
			"lEg": "⪋",
			"leq": "≤",
			"leqq": "≦",
			"leqslant": "⩽",
			"les": "⩽",
			"lescc": "⪨",
			"lesdot": "⩿",
			"lesdoto": "⪁",
			"lesdotor": "⪃",
			"lesg": "⋚︀",
			"lesges": "⪓",
			"lessapprox": "⪅",
			"lessdot": "⋖",
			"lesseqgtr": "⋚",
			"lesseqqgtr": "⪋",
			"LessEqualGreater": "⋚",
			"LessFullEqual": "≦",
			"LessGreater": "≶",
			"lessgtr": "≶",
			"LessLess": "⪡",
			"lesssim": "≲",
			"LessSlantEqual": "⩽",
			"LessTilde": "≲",
			"lfisht": "⥼",
			"lfloor": "⌊",
			"lfr": "𝔩",
			"Lfr": "𝔏",
			"lg": "≶",
			"lgE": "⪑",
			"lHar": "⥢",
			"lhard": "↽",
			"lharu": "↼",
			"lharul": "⥪",
			"lhblk": "▄",
			"ljcy": "љ",
			"LJcy": "Љ",
			"ll": "≪",
			"Ll": "⋘",
			"llarr": "⇇",
			"llcorner": "⌞",
			"Lleftarrow": "⇚",
			"llhard": "⥫",
			"lltri": "◺",
			"lmidot": "ŀ",
			"Lmidot": "Ŀ",
			"lmoust": "⎰",
			"lmoustache": "⎰",
			"lnap": "⪉",
			"lnapprox": "⪉",
			"lne": "⪇",
			"lnE": "≨",
			"lneq": "⪇",
			"lneqq": "≨",
			"lnsim": "⋦",
			"loang": "⟬",
			"loarr": "⇽",
			"lobrk": "⟦",
			"longleftarrow": "⟵",
			"Longleftarrow": "⟸",
			"LongLeftArrow": "⟵",
			"longleftrightarrow": "⟷",
			"Longleftrightarrow": "⟺",
			"LongLeftRightArrow": "⟷",
			"longmapsto": "⟼",
			"longrightarrow": "⟶",
			"Longrightarrow": "⟹",
			"LongRightArrow": "⟶",
			"looparrowleft": "↫",
			"looparrowright": "↬",
			"lopar": "⦅",
			"lopf": "𝕝",
			"Lopf": "𝕃",
			"loplus": "⨭",
			"lotimes": "⨴",
			"lowast": "∗",
			"lowbar": "_",
			"LowerLeftArrow": "↙",
			"LowerRightArrow": "↘",
			"loz": "◊",
			"lozenge": "◊",
			"lozf": "⧫",
			"lpar": "(",
			"lparlt": "⦓",
			"lrarr": "⇆",
			"lrcorner": "⌟",
			"lrhar": "⇋",
			"lrhard": "⥭",
			"lrm": "‎",
			"lrtri": "⊿",
			"lsaquo": "‹",
			"lscr": "𝓁",
			"Lscr": "ℒ",
			"lsh": "↰",
			"Lsh": "↰",
			"lsim": "≲",
			"lsime": "⪍",
			"lsimg": "⪏",
			"lsqb": "[",
			"lsquo": "‘",
			"lsquor": "‚",
			"lstrok": "ł",
			"Lstrok": "Ł",
			"lt": "<",
			"Lt": "≪",
			"LT": "<",
			"ltcc": "⪦",
			"ltcir": "⩹",
			"ltdot": "⋖",
			"lthree": "⋋",
			"ltimes": "⋉",
			"ltlarr": "⥶",
			"ltquest": "⩻",
			"ltri": "◃",
			"ltrie": "⊴",
			"ltrif": "◂",
			"ltrPar": "⦖",
			"lurdshar": "⥊",
			"luruhar": "⥦",
			"lvertneqq": "≨︀",
			"lvnE": "≨︀",
			"macr": "¯",
			"male": "♂",
			"malt": "✠",
			"maltese": "✠",
			"map": "↦",
			"Map": "⤅",
			"mapsto": "↦",
			"mapstodown": "↧",
			"mapstoleft": "↤",
			"mapstoup": "↥",
			"marker": "▮",
			"mcomma": "⨩",
			"mcy": "м",
			"Mcy": "М",
			"mdash": "—",
			"mDDot": "∺",
			"measuredangle": "∡",
			"MediumSpace": " ",
			"Mellintrf": "ℳ",
			"mfr": "𝔪",
			"Mfr": "𝔐",
			"mho": "℧",
			"micro": "µ",
			"mid": "∣",
			"midast": "*",
			"midcir": "⫰",
			"middot": "·",
			"minus": "−",
			"minusb": "⊟",
			"minusd": "∸",
			"minusdu": "⨪",
			"MinusPlus": "∓",
			"mlcp": "⫛",
			"mldr": "…",
			"mnplus": "∓",
			"models": "⊧",
			"mopf": "𝕞",
			"Mopf": "𝕄",
			"mp": "∓",
			"mscr": "𝓂",
			"Mscr": "ℳ",
			"mstpos": "∾",
			"mu": "μ",
			"Mu": "Μ",
			"multimap": "⊸",
			"mumap": "⊸",
			"nabla": "∇",
			"nacute": "ń",
			"Nacute": "Ń",
			"nang": "∠⃒",
			"nap": "≉",
			"napE": "⩰̸",
			"napid": "≋̸",
			"napos": "ŉ",
			"napprox": "≉",
			"natur": "♮",
			"natural": "♮",
			"naturals": "ℕ",
			"nbsp": "\xA0",
			"nbump": "≎̸",
			"nbumpe": "≏̸",
			"ncap": "⩃",
			"ncaron": "ň",
			"Ncaron": "Ň",
			"ncedil": "ņ",
			"Ncedil": "Ņ",
			"ncong": "≇",
			"ncongdot": "⩭̸",
			"ncup": "⩂",
			"ncy": "н",
			"Ncy": "Н",
			"ndash": "–",
			"ne": "≠",
			"nearhk": "⤤",
			"nearr": "↗",
			"neArr": "⇗",
			"nearrow": "↗",
			"nedot": "≐̸",
			"NegativeMediumSpace": "​",
			"NegativeThickSpace": "​",
			"NegativeThinSpace": "​",
			"NegativeVeryThinSpace": "​",
			"nequiv": "≢",
			"nesear": "⤨",
			"nesim": "≂̸",
			"NestedGreaterGreater": "≫",
			"NestedLessLess": "≪",
			"NewLine": "\n",
			"nexist": "∄",
			"nexists": "∄",
			"nfr": "𝔫",
			"Nfr": "𝔑",
			"nge": "≱",
			"ngE": "≧̸",
			"ngeq": "≱",
			"ngeqq": "≧̸",
			"ngeqslant": "⩾̸",
			"nges": "⩾̸",
			"nGg": "⋙̸",
			"ngsim": "≵",
			"ngt": "≯",
			"nGt": "≫⃒",
			"ngtr": "≯",
			"nGtv": "≫̸",
			"nharr": "↮",
			"nhArr": "⇎",
			"nhpar": "⫲",
			"ni": "∋",
			"nis": "⋼",
			"nisd": "⋺",
			"niv": "∋",
			"njcy": "њ",
			"NJcy": "Њ",
			"nlarr": "↚",
			"nlArr": "⇍",
			"nldr": "‥",
			"nle": "≰",
			"nlE": "≦̸",
			"nleftarrow": "↚",
			"nLeftarrow": "⇍",
			"nleftrightarrow": "↮",
			"nLeftrightarrow": "⇎",
			"nleq": "≰",
			"nleqq": "≦̸",
			"nleqslant": "⩽̸",
			"nles": "⩽̸",
			"nless": "≮",
			"nLl": "⋘̸",
			"nlsim": "≴",
			"nlt": "≮",
			"nLt": "≪⃒",
			"nltri": "⋪",
			"nltrie": "⋬",
			"nLtv": "≪̸",
			"nmid": "∤",
			"NoBreak": "⁠",
			"NonBreakingSpace": "\xA0",
			"nopf": "𝕟",
			"Nopf": "ℕ",
			"not": "¬",
			"Not": "⫬",
			"NotCongruent": "≢",
			"NotCupCap": "≭",
			"NotDoubleVerticalBar": "∦",
			"NotElement": "∉",
			"NotEqual": "≠",
			"NotEqualTilde": "≂̸",
			"NotExists": "∄",
			"NotGreater": "≯",
			"NotGreaterEqual": "≱",
			"NotGreaterFullEqual": "≧̸",
			"NotGreaterGreater": "≫̸",
			"NotGreaterLess": "≹",
			"NotGreaterSlantEqual": "⩾̸",
			"NotGreaterTilde": "≵",
			"NotHumpDownHump": "≎̸",
			"NotHumpEqual": "≏̸",
			"notin": "∉",
			"notindot": "⋵̸",
			"notinE": "⋹̸",
			"notinva": "∉",
			"notinvb": "⋷",
			"notinvc": "⋶",
			"NotLeftTriangle": "⋪",
			"NotLeftTriangleBar": "⧏̸",
			"NotLeftTriangleEqual": "⋬",
			"NotLess": "≮",
			"NotLessEqual": "≰",
			"NotLessGreater": "≸",
			"NotLessLess": "≪̸",
			"NotLessSlantEqual": "⩽̸",
			"NotLessTilde": "≴",
			"NotNestedGreaterGreater": "⪢̸",
			"NotNestedLessLess": "⪡̸",
			"notni": "∌",
			"notniva": "∌",
			"notnivb": "⋾",
			"notnivc": "⋽",
			"NotPrecedes": "⊀",
			"NotPrecedesEqual": "⪯̸",
			"NotPrecedesSlantEqual": "⋠",
			"NotReverseElement": "∌",
			"NotRightTriangle": "⋫",
			"NotRightTriangleBar": "⧐̸",
			"NotRightTriangleEqual": "⋭",
			"NotSquareSubset": "⊏̸",
			"NotSquareSubsetEqual": "⋢",
			"NotSquareSuperset": "⊐̸",
			"NotSquareSupersetEqual": "⋣",
			"NotSubset": "⊂⃒",
			"NotSubsetEqual": "⊈",
			"NotSucceeds": "⊁",
			"NotSucceedsEqual": "⪰̸",
			"NotSucceedsSlantEqual": "⋡",
			"NotSucceedsTilde": "≿̸",
			"NotSuperset": "⊃⃒",
			"NotSupersetEqual": "⊉",
			"NotTilde": "≁",
			"NotTildeEqual": "≄",
			"NotTildeFullEqual": "≇",
			"NotTildeTilde": "≉",
			"NotVerticalBar": "∤",
			"npar": "∦",
			"nparallel": "∦",
			"nparsl": "⫽⃥",
			"npart": "∂̸",
			"npolint": "⨔",
			"npr": "⊀",
			"nprcue": "⋠",
			"npre": "⪯̸",
			"nprec": "⊀",
			"npreceq": "⪯̸",
			"nrarr": "↛",
			"nrArr": "⇏",
			"nrarrc": "⤳̸",
			"nrarrw": "↝̸",
			"nrightarrow": "↛",
			"nRightarrow": "⇏",
			"nrtri": "⋫",
			"nrtrie": "⋭",
			"nsc": "⊁",
			"nsccue": "⋡",
			"nsce": "⪰̸",
			"nscr": "𝓃",
			"Nscr": "𝒩",
			"nshortmid": "∤",
			"nshortparallel": "∦",
			"nsim": "≁",
			"nsime": "≄",
			"nsimeq": "≄",
			"nsmid": "∤",
			"nspar": "∦",
			"nsqsube": "⋢",
			"nsqsupe": "⋣",
			"nsub": "⊄",
			"nsube": "⊈",
			"nsubE": "⫅̸",
			"nsubset": "⊂⃒",
			"nsubseteq": "⊈",
			"nsubseteqq": "⫅̸",
			"nsucc": "⊁",
			"nsucceq": "⪰̸",
			"nsup": "⊅",
			"nsupe": "⊉",
			"nsupE": "⫆̸",
			"nsupset": "⊃⃒",
			"nsupseteq": "⊉",
			"nsupseteqq": "⫆̸",
			"ntgl": "≹",
			"ntilde": "ñ",
			"Ntilde": "Ñ",
			"ntlg": "≸",
			"ntriangleleft": "⋪",
			"ntrianglelefteq": "⋬",
			"ntriangleright": "⋫",
			"ntrianglerighteq": "⋭",
			"nu": "ν",
			"Nu": "Ν",
			"num": "#",
			"numero": "№",
			"numsp": " ",
			"nvap": "≍⃒",
			"nvdash": "⊬",
			"nvDash": "⊭",
			"nVdash": "⊮",
			"nVDash": "⊯",
			"nvge": "≥⃒",
			"nvgt": ">⃒",
			"nvHarr": "⤄",
			"nvinfin": "⧞",
			"nvlArr": "⤂",
			"nvle": "≤⃒",
			"nvlt": "<⃒",
			"nvltrie": "⊴⃒",
			"nvrArr": "⤃",
			"nvrtrie": "⊵⃒",
			"nvsim": "∼⃒",
			"nwarhk": "⤣",
			"nwarr": "↖",
			"nwArr": "⇖",
			"nwarrow": "↖",
			"nwnear": "⤧",
			"oacute": "ó",
			"Oacute": "Ó",
			"oast": "⊛",
			"ocir": "⊚",
			"ocirc": "ô",
			"Ocirc": "Ô",
			"ocy": "о",
			"Ocy": "О",
			"odash": "⊝",
			"odblac": "ő",
			"Odblac": "Ő",
			"odiv": "⨸",
			"odot": "⊙",
			"odsold": "⦼",
			"oelig": "œ",
			"OElig": "Œ",
			"ofcir": "⦿",
			"ofr": "𝔬",
			"Ofr": "𝔒",
			"ogon": "˛",
			"ograve": "ò",
			"Ograve": "Ò",
			"ogt": "⧁",
			"ohbar": "⦵",
			"ohm": "Ω",
			"oint": "∮",
			"olarr": "↺",
			"olcir": "⦾",
			"olcross": "⦻",
			"oline": "‾",
			"olt": "⧀",
			"omacr": "ō",
			"Omacr": "Ō",
			"omega": "ω",
			"Omega": "Ω",
			"omicron": "ο",
			"Omicron": "Ο",
			"omid": "⦶",
			"ominus": "⊖",
			"oopf": "𝕠",
			"Oopf": "𝕆",
			"opar": "⦷",
			"OpenCurlyDoubleQuote": "“",
			"OpenCurlyQuote": "‘",
			"operp": "⦹",
			"oplus": "⊕",
			"or": "∨",
			"Or": "⩔",
			"orarr": "↻",
			"ord": "⩝",
			"order": "ℴ",
			"orderof": "ℴ",
			"ordf": "ª",
			"ordm": "º",
			"origof": "⊶",
			"oror": "⩖",
			"orslope": "⩗",
			"orv": "⩛",
			"oS": "Ⓢ",
			"oscr": "ℴ",
			"Oscr": "𝒪",
			"oslash": "ø",
			"Oslash": "Ø",
			"osol": "⊘",
			"otilde": "õ",
			"Otilde": "Õ",
			"otimes": "⊗",
			"Otimes": "⨷",
			"otimesas": "⨶",
			"ouml": "ö",
			"Ouml": "Ö",
			"ovbar": "⌽",
			"OverBar": "‾",
			"OverBrace": "⏞",
			"OverBracket": "⎴",
			"OverParenthesis": "⏜",
			"par": "∥",
			"para": "¶",
			"parallel": "∥",
			"parsim": "⫳",
			"parsl": "⫽",
			"part": "∂",
			"PartialD": "∂",
			"pcy": "п",
			"Pcy": "П",
			"percnt": "%",
			"period": ".",
			"permil": "‰",
			"perp": "⊥",
			"pertenk": "‱",
			"pfr": "𝔭",
			"Pfr": "𝔓",
			"phi": "φ",
			"Phi": "Φ",
			"phiv": "ϕ",
			"phmmat": "ℳ",
			"phone": "☎",
			"pi": "π",
			"Pi": "Π",
			"pitchfork": "⋔",
			"piv": "ϖ",
			"planck": "ℏ",
			"planckh": "ℎ",
			"plankv": "ℏ",
			"plus": "+",
			"plusacir": "⨣",
			"plusb": "⊞",
			"pluscir": "⨢",
			"plusdo": "∔",
			"plusdu": "⨥",
			"pluse": "⩲",
			"PlusMinus": "±",
			"plusmn": "±",
			"plussim": "⨦",
			"plustwo": "⨧",
			"pm": "±",
			"Poincareplane": "ℌ",
			"pointint": "⨕",
			"popf": "𝕡",
			"Popf": "ℙ",
			"pound": "£",
			"pr": "≺",
			"Pr": "⪻",
			"prap": "⪷",
			"prcue": "≼",
			"pre": "⪯",
			"prE": "⪳",
			"prec": "≺",
			"precapprox": "⪷",
			"preccurlyeq": "≼",
			"Precedes": "≺",
			"PrecedesEqual": "⪯",
			"PrecedesSlantEqual": "≼",
			"PrecedesTilde": "≾",
			"preceq": "⪯",
			"precnapprox": "⪹",
			"precneqq": "⪵",
			"precnsim": "⋨",
			"precsim": "≾",
			"prime": "′",
			"Prime": "″",
			"primes": "ℙ",
			"prnap": "⪹",
			"prnE": "⪵",
			"prnsim": "⋨",
			"prod": "∏",
			"Product": "∏",
			"profalar": "⌮",
			"profline": "⌒",
			"profsurf": "⌓",
			"prop": "∝",
			"Proportion": "∷",
			"Proportional": "∝",
			"propto": "∝",
			"prsim": "≾",
			"prurel": "⊰",
			"pscr": "𝓅",
			"Pscr": "𝒫",
			"psi": "ψ",
			"Psi": "Ψ",
			"puncsp": " ",
			"qfr": "𝔮",
			"Qfr": "𝔔",
			"qint": "⨌",
			"qopf": "𝕢",
			"Qopf": "ℚ",
			"qprime": "⁗",
			"qscr": "𝓆",
			"Qscr": "𝒬",
			"quaternions": "ℍ",
			"quatint": "⨖",
			"quest": "?",
			"questeq": "≟",
			"quot": "\"",
			"QUOT": "\"",
			"rAarr": "⇛",
			"race": "∽̱",
			"racute": "ŕ",
			"Racute": "Ŕ",
			"radic": "√",
			"raemptyv": "⦳",
			"rang": "⟩",
			"Rang": "⟫",
			"rangd": "⦒",
			"range": "⦥",
			"rangle": "⟩",
			"raquo": "»",
			"rarr": "→",
			"rArr": "⇒",
			"Rarr": "↠",
			"rarrap": "⥵",
			"rarrb": "⇥",
			"rarrbfs": "⤠",
			"rarrc": "⤳",
			"rarrfs": "⤞",
			"rarrhk": "↪",
			"rarrlp": "↬",
			"rarrpl": "⥅",
			"rarrsim": "⥴",
			"rarrtl": "↣",
			"Rarrtl": "⤖",
			"rarrw": "↝",
			"ratail": "⤚",
			"rAtail": "⤜",
			"ratio": "∶",
			"rationals": "ℚ",
			"rbarr": "⤍",
			"rBarr": "⤏",
			"RBarr": "⤐",
			"rbbrk": "❳",
			"rbrace": "}",
			"rbrack": "]",
			"rbrke": "⦌",
			"rbrksld": "⦎",
			"rbrkslu": "⦐",
			"rcaron": "ř",
			"Rcaron": "Ř",
			"rcedil": "ŗ",
			"Rcedil": "Ŗ",
			"rceil": "⌉",
			"rcub": "}",
			"rcy": "р",
			"Rcy": "Р",
			"rdca": "⤷",
			"rdldhar": "⥩",
			"rdquo": "”",
			"rdquor": "”",
			"rdsh": "↳",
			"Re": "ℜ",
			"real": "ℜ",
			"realine": "ℛ",
			"realpart": "ℜ",
			"reals": "ℝ",
			"rect": "▭",
			"reg": "®",
			"REG": "®",
			"ReverseElement": "∋",
			"ReverseEquilibrium": "⇋",
			"ReverseUpEquilibrium": "⥯",
			"rfisht": "⥽",
			"rfloor": "⌋",
			"rfr": "𝔯",
			"Rfr": "ℜ",
			"rHar": "⥤",
			"rhard": "⇁",
			"rharu": "⇀",
			"rharul": "⥬",
			"rho": "ρ",
			"Rho": "Ρ",
			"rhov": "ϱ",
			"RightAngleBracket": "⟩",
			"rightarrow": "→",
			"Rightarrow": "⇒",
			"RightArrow": "→",
			"RightArrowBar": "⇥",
			"RightArrowLeftArrow": "⇄",
			"rightarrowtail": "↣",
			"RightCeiling": "⌉",
			"RightDoubleBracket": "⟧",
			"RightDownTeeVector": "⥝",
			"RightDownVector": "⇂",
			"RightDownVectorBar": "⥕",
			"RightFloor": "⌋",
			"rightharpoondown": "⇁",
			"rightharpoonup": "⇀",
			"rightleftarrows": "⇄",
			"rightleftharpoons": "⇌",
			"rightrightarrows": "⇉",
			"rightsquigarrow": "↝",
			"RightTee": "⊢",
			"RightTeeArrow": "↦",
			"RightTeeVector": "⥛",
			"rightthreetimes": "⋌",
			"RightTriangle": "⊳",
			"RightTriangleBar": "⧐",
			"RightTriangleEqual": "⊵",
			"RightUpDownVector": "⥏",
			"RightUpTeeVector": "⥜",
			"RightUpVector": "↾",
			"RightUpVectorBar": "⥔",
			"RightVector": "⇀",
			"RightVectorBar": "⥓",
			"ring": "˚",
			"risingdotseq": "≓",
			"rlarr": "⇄",
			"rlhar": "⇌",
			"rlm": "‏",
			"rmoust": "⎱",
			"rmoustache": "⎱",
			"rnmid": "⫮",
			"roang": "⟭",
			"roarr": "⇾",
			"robrk": "⟧",
			"ropar": "⦆",
			"ropf": "𝕣",
			"Ropf": "ℝ",
			"roplus": "⨮",
			"rotimes": "⨵",
			"RoundImplies": "⥰",
			"rpar": ")",
			"rpargt": "⦔",
			"rppolint": "⨒",
			"rrarr": "⇉",
			"Rrightarrow": "⇛",
			"rsaquo": "›",
			"rscr": "𝓇",
			"Rscr": "ℛ",
			"rsh": "↱",
			"Rsh": "↱",
			"rsqb": "]",
			"rsquo": "’",
			"rsquor": "’",
			"rthree": "⋌",
			"rtimes": "⋊",
			"rtri": "▹",
			"rtrie": "⊵",
			"rtrif": "▸",
			"rtriltri": "⧎",
			"RuleDelayed": "⧴",
			"ruluhar": "⥨",
			"rx": "℞",
			"sacute": "ś",
			"Sacute": "Ś",
			"sbquo": "‚",
			"sc": "≻",
			"Sc": "⪼",
			"scap": "⪸",
			"scaron": "š",
			"Scaron": "Š",
			"sccue": "≽",
			"sce": "⪰",
			"scE": "⪴",
			"scedil": "ş",
			"Scedil": "Ş",
			"scirc": "ŝ",
			"Scirc": "Ŝ",
			"scnap": "⪺",
			"scnE": "⪶",
			"scnsim": "⋩",
			"scpolint": "⨓",
			"scsim": "≿",
			"scy": "с",
			"Scy": "С",
			"sdot": "⋅",
			"sdotb": "⊡",
			"sdote": "⩦",
			"searhk": "⤥",
			"searr": "↘",
			"seArr": "⇘",
			"searrow": "↘",
			"sect": "§",
			"semi": ";",
			"seswar": "⤩",
			"setminus": "∖",
			"setmn": "∖",
			"sext": "✶",
			"sfr": "𝔰",
			"Sfr": "𝔖",
			"sfrown": "⌢",
			"sharp": "♯",
			"shchcy": "щ",
			"SHCHcy": "Щ",
			"shcy": "ш",
			"SHcy": "Ш",
			"ShortDownArrow": "↓",
			"ShortLeftArrow": "←",
			"shortmid": "∣",
			"shortparallel": "∥",
			"ShortRightArrow": "→",
			"ShortUpArrow": "↑",
			"shy": "­",
			"sigma": "σ",
			"Sigma": "Σ",
			"sigmaf": "ς",
			"sigmav": "ς",
			"sim": "∼",
			"simdot": "⩪",
			"sime": "≃",
			"simeq": "≃",
			"simg": "⪞",
			"simgE": "⪠",
			"siml": "⪝",
			"simlE": "⪟",
			"simne": "≆",
			"simplus": "⨤",
			"simrarr": "⥲",
			"slarr": "←",
			"SmallCircle": "∘",
			"smallsetminus": "∖",
			"smashp": "⨳",
			"smeparsl": "⧤",
			"smid": "∣",
			"smile": "⌣",
			"smt": "⪪",
			"smte": "⪬",
			"smtes": "⪬︀",
			"softcy": "ь",
			"SOFTcy": "Ь",
			"sol": "/",
			"solb": "⧄",
			"solbar": "⌿",
			"sopf": "𝕤",
			"Sopf": "𝕊",
			"spades": "♠",
			"spadesuit": "♠",
			"spar": "∥",
			"sqcap": "⊓",
			"sqcaps": "⊓︀",
			"sqcup": "⊔",
			"sqcups": "⊔︀",
			"Sqrt": "√",
			"sqsub": "⊏",
			"sqsube": "⊑",
			"sqsubset": "⊏",
			"sqsubseteq": "⊑",
			"sqsup": "⊐",
			"sqsupe": "⊒",
			"sqsupset": "⊐",
			"sqsupseteq": "⊒",
			"squ": "□",
			"square": "□",
			"Square": "□",
			"SquareIntersection": "⊓",
			"SquareSubset": "⊏",
			"SquareSubsetEqual": "⊑",
			"SquareSuperset": "⊐",
			"SquareSupersetEqual": "⊒",
			"SquareUnion": "⊔",
			"squarf": "▪",
			"squf": "▪",
			"srarr": "→",
			"sscr": "𝓈",
			"Sscr": "𝒮",
			"ssetmn": "∖",
			"ssmile": "⌣",
			"sstarf": "⋆",
			"star": "☆",
			"Star": "⋆",
			"starf": "★",
			"straightepsilon": "ϵ",
			"straightphi": "ϕ",
			"strns": "¯",
			"sub": "⊂",
			"Sub": "⋐",
			"subdot": "⪽",
			"sube": "⊆",
			"subE": "⫅",
			"subedot": "⫃",
			"submult": "⫁",
			"subne": "⊊",
			"subnE": "⫋",
			"subplus": "⪿",
			"subrarr": "⥹",
			"subset": "⊂",
			"Subset": "⋐",
			"subseteq": "⊆",
			"subseteqq": "⫅",
			"SubsetEqual": "⊆",
			"subsetneq": "⊊",
			"subsetneqq": "⫋",
			"subsim": "⫇",
			"subsub": "⫕",
			"subsup": "⫓",
			"succ": "≻",
			"succapprox": "⪸",
			"succcurlyeq": "≽",
			"Succeeds": "≻",
			"SucceedsEqual": "⪰",
			"SucceedsSlantEqual": "≽",
			"SucceedsTilde": "≿",
			"succeq": "⪰",
			"succnapprox": "⪺",
			"succneqq": "⪶",
			"succnsim": "⋩",
			"succsim": "≿",
			"SuchThat": "∋",
			"sum": "∑",
			"Sum": "∑",
			"sung": "♪",
			"sup": "⊃",
			"Sup": "⋑",
			"sup1": "¹",
			"sup2": "²",
			"sup3": "³",
			"supdot": "⪾",
			"supdsub": "⫘",
			"supe": "⊇",
			"supE": "⫆",
			"supedot": "⫄",
			"Superset": "⊃",
			"SupersetEqual": "⊇",
			"suphsol": "⟉",
			"suphsub": "⫗",
			"suplarr": "⥻",
			"supmult": "⫂",
			"supne": "⊋",
			"supnE": "⫌",
			"supplus": "⫀",
			"supset": "⊃",
			"Supset": "⋑",
			"supseteq": "⊇",
			"supseteqq": "⫆",
			"supsetneq": "⊋",
			"supsetneqq": "⫌",
			"supsim": "⫈",
			"supsub": "⫔",
			"supsup": "⫖",
			"swarhk": "⤦",
			"swarr": "↙",
			"swArr": "⇙",
			"swarrow": "↙",
			"swnwar": "⤪",
			"szlig": "ß",
			"Tab": "	",
			"target": "⌖",
			"tau": "τ",
			"Tau": "Τ",
			"tbrk": "⎴",
			"tcaron": "ť",
			"Tcaron": "Ť",
			"tcedil": "ţ",
			"Tcedil": "Ţ",
			"tcy": "т",
			"Tcy": "Т",
			"tdot": "⃛",
			"telrec": "⌕",
			"tfr": "𝔱",
			"Tfr": "𝔗",
			"there4": "∴",
			"therefore": "∴",
			"Therefore": "∴",
			"theta": "θ",
			"Theta": "Θ",
			"thetasym": "ϑ",
			"thetav": "ϑ",
			"thickapprox": "≈",
			"thicksim": "∼",
			"ThickSpace": "  ",
			"thinsp": " ",
			"ThinSpace": " ",
			"thkap": "≈",
			"thksim": "∼",
			"thorn": "þ",
			"THORN": "Þ",
			"tilde": "˜",
			"Tilde": "∼",
			"TildeEqual": "≃",
			"TildeFullEqual": "≅",
			"TildeTilde": "≈",
			"times": "×",
			"timesb": "⊠",
			"timesbar": "⨱",
			"timesd": "⨰",
			"tint": "∭",
			"toea": "⤨",
			"top": "⊤",
			"topbot": "⌶",
			"topcir": "⫱",
			"topf": "𝕥",
			"Topf": "𝕋",
			"topfork": "⫚",
			"tosa": "⤩",
			"tprime": "‴",
			"trade": "™",
			"TRADE": "™",
			"triangle": "▵",
			"triangledown": "▿",
			"triangleleft": "◃",
			"trianglelefteq": "⊴",
			"triangleq": "≜",
			"triangleright": "▹",
			"trianglerighteq": "⊵",
			"tridot": "◬",
			"trie": "≜",
			"triminus": "⨺",
			"TripleDot": "⃛",
			"triplus": "⨹",
			"trisb": "⧍",
			"tritime": "⨻",
			"trpezium": "⏢",
			"tscr": "𝓉",
			"Tscr": "𝒯",
			"tscy": "ц",
			"TScy": "Ц",
			"tshcy": "ћ",
			"TSHcy": "Ћ",
			"tstrok": "ŧ",
			"Tstrok": "Ŧ",
			"twixt": "≬",
			"twoheadleftarrow": "↞",
			"twoheadrightarrow": "↠",
			"uacute": "ú",
			"Uacute": "Ú",
			"uarr": "↑",
			"uArr": "⇑",
			"Uarr": "↟",
			"Uarrocir": "⥉",
			"ubrcy": "ў",
			"Ubrcy": "Ў",
			"ubreve": "ŭ",
			"Ubreve": "Ŭ",
			"ucirc": "û",
			"Ucirc": "Û",
			"ucy": "у",
			"Ucy": "У",
			"udarr": "⇅",
			"udblac": "ű",
			"Udblac": "Ű",
			"udhar": "⥮",
			"ufisht": "⥾",
			"ufr": "𝔲",
			"Ufr": "𝔘",
			"ugrave": "ù",
			"Ugrave": "Ù",
			"uHar": "⥣",
			"uharl": "↿",
			"uharr": "↾",
			"uhblk": "▀",
			"ulcorn": "⌜",
			"ulcorner": "⌜",
			"ulcrop": "⌏",
			"ultri": "◸",
			"umacr": "ū",
			"Umacr": "Ū",
			"uml": "¨",
			"UnderBar": "_",
			"UnderBrace": "⏟",
			"UnderBracket": "⎵",
			"UnderParenthesis": "⏝",
			"Union": "⋃",
			"UnionPlus": "⊎",
			"uogon": "ų",
			"Uogon": "Ų",
			"uopf": "𝕦",
			"Uopf": "𝕌",
			"uparrow": "↑",
			"Uparrow": "⇑",
			"UpArrow": "↑",
			"UpArrowBar": "⤒",
			"UpArrowDownArrow": "⇅",
			"updownarrow": "↕",
			"Updownarrow": "⇕",
			"UpDownArrow": "↕",
			"UpEquilibrium": "⥮",
			"upharpoonleft": "↿",
			"upharpoonright": "↾",
			"uplus": "⊎",
			"UpperLeftArrow": "↖",
			"UpperRightArrow": "↗",
			"upsi": "υ",
			"Upsi": "ϒ",
			"upsih": "ϒ",
			"upsilon": "υ",
			"Upsilon": "Υ",
			"UpTee": "⊥",
			"UpTeeArrow": "↥",
			"upuparrows": "⇈",
			"urcorn": "⌝",
			"urcorner": "⌝",
			"urcrop": "⌎",
			"uring": "ů",
			"Uring": "Ů",
			"urtri": "◹",
			"uscr": "𝓊",
			"Uscr": "𝒰",
			"utdot": "⋰",
			"utilde": "ũ",
			"Utilde": "Ũ",
			"utri": "▵",
			"utrif": "▴",
			"uuarr": "⇈",
			"uuml": "ü",
			"Uuml": "Ü",
			"uwangle": "⦧",
			"vangrt": "⦜",
			"varepsilon": "ϵ",
			"varkappa": "ϰ",
			"varnothing": "∅",
			"varphi": "ϕ",
			"varpi": "ϖ",
			"varpropto": "∝",
			"varr": "↕",
			"vArr": "⇕",
			"varrho": "ϱ",
			"varsigma": "ς",
			"varsubsetneq": "⊊︀",
			"varsubsetneqq": "⫋︀",
			"varsupsetneq": "⊋︀",
			"varsupsetneqq": "⫌︀",
			"vartheta": "ϑ",
			"vartriangleleft": "⊲",
			"vartriangleright": "⊳",
			"vBar": "⫨",
			"Vbar": "⫫",
			"vBarv": "⫩",
			"vcy": "в",
			"Vcy": "В",
			"vdash": "⊢",
			"vDash": "⊨",
			"Vdash": "⊩",
			"VDash": "⊫",
			"Vdashl": "⫦",
			"vee": "∨",
			"Vee": "⋁",
			"veebar": "⊻",
			"veeeq": "≚",
			"vellip": "⋮",
			"verbar": "|",
			"Verbar": "‖",
			"vert": "|",
			"Vert": "‖",
			"VerticalBar": "∣",
			"VerticalLine": "|",
			"VerticalSeparator": "❘",
			"VerticalTilde": "≀",
			"VeryThinSpace": " ",
			"vfr": "𝔳",
			"Vfr": "𝔙",
			"vltri": "⊲",
			"vnsub": "⊂⃒",
			"vnsup": "⊃⃒",
			"vopf": "𝕧",
			"Vopf": "𝕍",
			"vprop": "∝",
			"vrtri": "⊳",
			"vscr": "𝓋",
			"Vscr": "𝒱",
			"vsubne": "⊊︀",
			"vsubnE": "⫋︀",
			"vsupne": "⊋︀",
			"vsupnE": "⫌︀",
			"Vvdash": "⊪",
			"vzigzag": "⦚",
			"wcirc": "ŵ",
			"Wcirc": "Ŵ",
			"wedbar": "⩟",
			"wedge": "∧",
			"Wedge": "⋀",
			"wedgeq": "≙",
			"weierp": "℘",
			"wfr": "𝔴",
			"Wfr": "𝔚",
			"wopf": "𝕨",
			"Wopf": "𝕎",
			"wp": "℘",
			"wr": "≀",
			"wreath": "≀",
			"wscr": "𝓌",
			"Wscr": "𝒲",
			"xcap": "⋂",
			"xcirc": "◯",
			"xcup": "⋃",
			"xdtri": "▽",
			"xfr": "𝔵",
			"Xfr": "𝔛",
			"xharr": "⟷",
			"xhArr": "⟺",
			"xi": "ξ",
			"Xi": "Ξ",
			"xlarr": "⟵",
			"xlArr": "⟸",
			"xmap": "⟼",
			"xnis": "⋻",
			"xodot": "⨀",
			"xopf": "𝕩",
			"Xopf": "𝕏",
			"xoplus": "⨁",
			"xotime": "⨂",
			"xrarr": "⟶",
			"xrArr": "⟹",
			"xscr": "𝓍",
			"Xscr": "𝒳",
			"xsqcup": "⨆",
			"xuplus": "⨄",
			"xutri": "△",
			"xvee": "⋁",
			"xwedge": "⋀",
			"yacute": "ý",
			"Yacute": "Ý",
			"yacy": "я",
			"YAcy": "Я",
			"ycirc": "ŷ",
			"Ycirc": "Ŷ",
			"ycy": "ы",
			"Ycy": "Ы",
			"yen": "¥",
			"yfr": "𝔶",
			"Yfr": "𝔜",
			"yicy": "ї",
			"YIcy": "Ї",
			"yopf": "𝕪",
			"Yopf": "𝕐",
			"yscr": "𝓎",
			"Yscr": "𝒴",
			"yucy": "ю",
			"YUcy": "Ю",
			"yuml": "ÿ",
			"Yuml": "Ÿ",
			"zacute": "ź",
			"Zacute": "Ź",
			"zcaron": "ž",
			"Zcaron": "Ž",
			"zcy": "з",
			"Zcy": "З",
			"zdot": "ż",
			"Zdot": "Ż",
			"zeetrf": "ℨ",
			"ZeroWidthSpace": "​",
			"zeta": "ζ",
			"Zeta": "Ζ",
			"zfr": "𝔷",
			"Zfr": "ℨ",
			"zhcy": "ж",
			"ZHcy": "Ж",
			"zigrarr": "⇝",
			"zopf": "𝕫",
			"Zopf": "ℤ",
			"zscr": "𝓏",
			"Zscr": "𝒵",
			"zwj": "‍",
			"zwnj": "‌"
		};
		var decodeMapLegacy = {
			"aacute": "á",
			"Aacute": "Á",
			"acirc": "â",
			"Acirc": "Â",
			"acute": "´",
			"aelig": "æ",
			"AElig": "Æ",
			"agrave": "à",
			"Agrave": "À",
			"amp": "&",
			"AMP": "&",
			"aring": "å",
			"Aring": "Å",
			"atilde": "ã",
			"Atilde": "Ã",
			"auml": "ä",
			"Auml": "Ä",
			"brvbar": "¦",
			"ccedil": "ç",
			"Ccedil": "Ç",
			"cedil": "¸",
			"cent": "¢",
			"copy": "©",
			"COPY": "©",
			"curren": "¤",
			"deg": "°",
			"divide": "÷",
			"eacute": "é",
			"Eacute": "É",
			"ecirc": "ê",
			"Ecirc": "Ê",
			"egrave": "è",
			"Egrave": "È",
			"eth": "ð",
			"ETH": "Ð",
			"euml": "ë",
			"Euml": "Ë",
			"frac12": "½",
			"frac14": "¼",
			"frac34": "¾",
			"gt": ">",
			"GT": ">",
			"iacute": "í",
			"Iacute": "Í",
			"icirc": "î",
			"Icirc": "Î",
			"iexcl": "¡",
			"igrave": "ì",
			"Igrave": "Ì",
			"iquest": "¿",
			"iuml": "ï",
			"Iuml": "Ï",
			"laquo": "«",
			"lt": "<",
			"LT": "<",
			"macr": "¯",
			"micro": "µ",
			"middot": "·",
			"nbsp": "\xA0",
			"not": "¬",
			"ntilde": "ñ",
			"Ntilde": "Ñ",
			"oacute": "ó",
			"Oacute": "Ó",
			"ocirc": "ô",
			"Ocirc": "Ô",
			"ograve": "ò",
			"Ograve": "Ò",
			"ordf": "ª",
			"ordm": "º",
			"oslash": "ø",
			"Oslash": "Ø",
			"otilde": "õ",
			"Otilde": "Õ",
			"ouml": "ö",
			"Ouml": "Ö",
			"para": "¶",
			"plusmn": "±",
			"pound": "£",
			"quot": "\"",
			"QUOT": "\"",
			"raquo": "»",
			"reg": "®",
			"REG": "®",
			"sect": "§",
			"shy": "­",
			"sup1": "¹",
			"sup2": "²",
			"sup3": "³",
			"szlig": "ß",
			"thorn": "þ",
			"THORN": "Þ",
			"times": "×",
			"uacute": "ú",
			"Uacute": "Ú",
			"ucirc": "û",
			"Ucirc": "Û",
			"ugrave": "ù",
			"Ugrave": "Ù",
			"uml": "¨",
			"uuml": "ü",
			"Uuml": "Ü",
			"yacute": "ý",
			"Yacute": "Ý",
			"yen": "¥",
			"yuml": "ÿ"
		};
		var decodeMapNumeric = {
			"0": "�",
			"128": "€",
			"130": "‚",
			"131": "ƒ",
			"132": "„",
			"133": "…",
			"134": "†",
			"135": "‡",
			"136": "ˆ",
			"137": "‰",
			"138": "Š",
			"139": "‹",
			"140": "Œ",
			"142": "Ž",
			"145": "‘",
			"146": "’",
			"147": "“",
			"148": "”",
			"149": "•",
			"150": "–",
			"151": "—",
			"152": "˜",
			"153": "™",
			"154": "š",
			"155": "›",
			"156": "œ",
			"158": "ž",
			"159": "Ÿ"
		};
		var invalidReferenceCodePoints = [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			11,
			13,
			14,
			15,
			16,
			17,
			18,
			19,
			20,
			21,
			22,
			23,
			24,
			25,
			26,
			27,
			28,
			29,
			30,
			31,
			127,
			128,
			129,
			130,
			131,
			132,
			133,
			134,
			135,
			136,
			137,
			138,
			139,
			140,
			141,
			142,
			143,
			144,
			145,
			146,
			147,
			148,
			149,
			150,
			151,
			152,
			153,
			154,
			155,
			156,
			157,
			158,
			159,
			64976,
			64977,
			64978,
			64979,
			64980,
			64981,
			64982,
			64983,
			64984,
			64985,
			64986,
			64987,
			64988,
			64989,
			64990,
			64991,
			64992,
			64993,
			64994,
			64995,
			64996,
			64997,
			64998,
			64999,
			65e3,
			65001,
			65002,
			65003,
			65004,
			65005,
			65006,
			65007,
			65534,
			65535,
			131070,
			131071,
			196606,
			196607,
			262142,
			262143,
			327678,
			327679,
			393214,
			393215,
			458750,
			458751,
			524286,
			524287,
			589822,
			589823,
			655358,
			655359,
			720894,
			720895,
			786430,
			786431,
			851966,
			851967,
			917502,
			917503,
			983038,
			983039,
			1048574,
			1048575,
			1114110,
			1114111
		];
		var stringFromCharCode = String.fromCharCode;
		var hasOwnProperty = {}.hasOwnProperty;
		var has = function(object, propertyName) {
			return hasOwnProperty.call(object, propertyName);
		};
		var contains = function(array, value) {
			var index = -1;
			var length = array.length;
			while (++index < length) if (array[index] == value) return true;
			return false;
		};
		var merge = function(options, defaults) {
			if (!options) return defaults;
			var result = {};
			var key$1;
			for (key$1 in defaults) result[key$1] = has(options, key$1) ? options[key$1] : defaults[key$1];
			return result;
		};
		var codePointToSymbol = function(codePoint, strict) {
			var output = "";
			if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
				if (strict) parseError("character reference outside the permissible Unicode range");
				return "�";
			}
			if (has(decodeMapNumeric, codePoint)) {
				if (strict) parseError("disallowed character reference");
				return decodeMapNumeric[codePoint];
			}
			if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError("disallowed character reference");
			if (codePoint > 65535) {
				codePoint -= 65536;
				output += stringFromCharCode(codePoint >>> 10 & 1023 | 55296);
				codePoint = 56320 | codePoint & 1023;
			}
			output += stringFromCharCode(codePoint);
			return output;
		};
		var hexEscape = function(codePoint) {
			return "&#x" + codePoint.toString(16).toUpperCase() + ";";
		};
		var decEscape = function(codePoint) {
			return "&#" + codePoint + ";";
		};
		var parseError = function(message) {
			throw Error("Parse error: " + message);
		};
		var encode$82 = function(string$2, options) {
			options = merge(options, encode$82.options);
			if (options.strict && regexInvalidRawCodePoint.test(string$2)) parseError("forbidden code point");
			var encodeEverything = options.encodeEverything;
			var useNamedReferences = options.useNamedReferences;
			var allowUnsafeSymbols = options.allowUnsafeSymbols;
			var escapeCodePoint = options.decimal ? decEscape : hexEscape;
			var escapeBmpSymbol = function(symbol) {
				return escapeCodePoint(symbol.charCodeAt(0));
			};
			if (encodeEverything) {
				string$2 = string$2.replace(regexAsciiWhitelist, function(symbol) {
					if (useNamedReferences && has(encodeMap, symbol)) return "&" + encodeMap[symbol] + ";";
					return escapeBmpSymbol(symbol);
				});
				if (useNamedReferences) string$2 = string$2.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
				if (useNamedReferences) string$2 = string$2.replace(regexEncodeNonAscii, function(string$3) {
					return "&" + encodeMap[string$3] + ";";
				});
			} else if (useNamedReferences) {
				if (!allowUnsafeSymbols) string$2 = string$2.replace(regexEscape, function(string$3) {
					return "&" + encodeMap[string$3] + ";";
				});
				string$2 = string$2.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
				string$2 = string$2.replace(regexEncodeNonAscii, function(string$3) {
					return "&" + encodeMap[string$3] + ";";
				});
			} else if (!allowUnsafeSymbols) string$2 = string$2.replace(regexEscape, escapeBmpSymbol);
			return string$2.replace(regexAstralSymbols, function($0) {
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				return escapeCodePoint((high - 55296) * 1024 + low - 56320 + 65536);
			}).replace(regexBmpWhitelist, escapeBmpSymbol);
		};
		encode$82.options = {
			"allowUnsafeSymbols": false,
			"encodeEverything": false,
			"strict": false,
			"useNamedReferences": false,
			"decimal": false
		};
		var decode$84 = function(html, options) {
			options = merge(options, decode$84.options);
			var strict = options.strict;
			if (strict && regexInvalidEntity.test(html)) parseError("malformed character reference");
			return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
				var codePoint;
				var semicolon;
				var decDigits;
				var hexDigits;
				var reference;
				var next;
				if ($1) {
					reference = $1;
					return decodeMap[reference];
				}
				if ($2) {
					reference = $2;
					next = $3;
					if (next && options.isAttributeValue) {
						if (strict && next == "=") parseError("`&` did not start a character reference");
						return $0;
					} else {
						if (strict) parseError("named character reference was not terminated by a semicolon");
						return decodeMapLegacy[reference] + (next || "");
					}
				}
				if ($4) {
					decDigits = $4;
					semicolon = $5;
					if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
					codePoint = parseInt(decDigits, 10);
					return codePointToSymbol(codePoint, strict);
				}
				if ($6) {
					hexDigits = $6;
					semicolon = $7;
					if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
					codePoint = parseInt(hexDigits, 16);
					return codePointToSymbol(codePoint, strict);
				}
				if (strict) parseError("named character reference was not terminated by a semicolon");
				return $0;
			});
		};
		decode$84.options = {
			"isAttributeValue": false,
			"strict": false
		};
		var escape = function(string$2) {
			return string$2.replace(regexEscape, function($0) {
				return escapeMap[$0];
			});
		};
		var he$1 = {
			"version": "1.2.0",
			"encode": encode$82,
			"decode": decode$84,
			"escape": escape,
			"unescape": decode$84
		};
		if (typeof define == "function" && typeof define.amd == "object" && define.amd) define(function() {
			return he$1;
		});
		else if (freeExports && !freeExports.nodeType) if (freeModule) freeModule.exports = he$1;
		else for (var key in he$1) has(he$1, key) && (freeExports[key] = he$1[key]);
		else root.he = he$1;
	})(exports);
})))(), 1);
function translateFieldAnnotation(params) {
	const { node, isFinalDoc, fieldsHighlightColor } = params;
	const { attrs = {} } = node;
	const annotationHandler = getTranslationByAnnotationType(attrs.type, attrs.fieldType);
	if (!annotationHandler) return {};
	let processedNode;
	let sdtContentElements;
	let id = attrs.sdtId;
	if ((attrs.type === "image" || attrs.type === "signature") && !attrs.hash) attrs.hash = generateDocxRandomId(4);
	if (!attrs.sdtId) id = generateRandomSigned32BitIntStrId();
	if (isFinalDoc) return annotationHandler(params);
	else {
		processedNode = annotationHandler(params);
		sdtContentElements = [processedNode];
		if (attrs.type === "html") sdtContentElements = [...processedNode.elements[0].elements.filter((el) => el.name === "w:r")];
	}
	sdtContentElements = [...sdtContentElements];
	const fieldBackgroundTag = getFieldHighlightJson(fieldsHighlightColor);
	if (fieldBackgroundTag) sdtContentElements.unshift(fieldBackgroundTag);
	const annotationAttrs = {
		displayLabel: attrs.displayLabel,
		defaultDisplayLabel: attrs.defaultDisplayLabel,
		fieldId: attrs.fieldId,
		fieldType: attrs.fieldType,
		fieldTypeShort: attrs.type,
		fieldColor: attrs.fieldColor,
		fieldMultipleImage: attrs.multipleImage,
		fieldFontFamily: attrs.fontFamily,
		fieldFontSize: attrs.fontSize,
		fieldTextColor: attrs.textColor,
		fieldTextHighlight: attrs.textHighlight,
		hash: attrs.hash
	};
	const annotationAttrsJson = JSON.stringify(annotationAttrs);
	const sanitizedDisplayLabel = attrs.displayLabel === "undefined" || attrs.displayLabel === void 0 ? "" : attrs.displayLabel;
	const sdtPrElements = [
		{
			name: "w:alias",
			attributes: { "w:val": sanitizedDisplayLabel }
		},
		{
			name: "w:tag",
			attributes: { "w:val": annotationAttrsJson }
		},
		{
			name: "w:id",
			attributes: { "w:val": id }
		}
	];
	if (attrs.sdtPr?.elements && Array.isArray(attrs.sdtPr.elements)) {
		const elementsToExclude = [
			"w:alias",
			"w:tag",
			"w:id"
		];
		const passthroughElements = attrs.sdtPr.elements.filter((el) => el && el.name && !elementsToExclude.includes(el.name));
		sdtPrElements.push(...passthroughElements);
	}
	return {
		name: "w:sdt",
		elements: [{
			name: "w:sdtPr",
			elements: sdtPrElements
		}, {
			name: "w:sdtContent",
			elements: sdtContentElements
		}]
	};
}
function getTranslationByAnnotationType(annotationType, annotationFieldType) {
	if (annotationType === "text" && annotationFieldType === "FILEUPLOADER") return null;
	const imageEmuSize = {
		w: 4286250,
		h: 4286250
	};
	const signatureEmuSize = {
		w: 99e4,
		h: 495e3
	};
	return {
		text: prepareTextAnnotation,
		image: (params) => prepareImageAnnotation(params, imageEmuSize),
		signature: (params) => prepareImageAnnotation(params, signatureEmuSize),
		checkbox: prepareCheckboxAnnotation,
		html: prepareHtmlAnnotation,
		link: prepareUrlAnnotation
	}[annotationType];
}
function prepareTextAnnotation(params) {
	const { node: { attrs = {}, marks = [] } } = params;
	const marksFromAttrs = translateFieldAttrsToMarks(attrs);
	return getTextNodeForExport(attrs.displayLabel, [...marks, ...marksFromAttrs], params);
}
function prepareImageAnnotation(params, imageSize) {
	return translator$12.decode({
		...params,
		imageSize
	});
}
function prepareCheckboxAnnotation(params) {
	const { node: { attrs = {}, marks = [] } } = params;
	return getTextNodeForExport(import_he.default.decode(attrs.displayLabel), marks, params);
}
function prepareHtmlAnnotation(params) {
	const { node: { attrs = {}, marks = [] }, editorSchema, editor } = params;
	const paragraphHtmlContainer = sanitizeHtml(attrs.rawHtml || attrs.displayLabel, void 0, editor?.options?.document ?? editor?.options?.mockDocument);
	const marksFromAttrs = translateFieldAttrsToMarks(attrs);
	const allMarks = [...marks, ...marksFromAttrs];
	let state = EditorState.create({ doc: DOMParser$1.fromSchema(editorSchema).parse(paragraphHtmlContainer) });
	if (allMarks.length) state = applyMarksToHtmlAnnotation(state, allMarks);
	const htmlAnnotationNode = state.doc.toJSON();
	const listTypes = ["bulletList", "orderedList"];
	const seenLists = /* @__PURE__ */ new Map();
	state.doc.descendants((node) => {
		if (listTypes.includes(node.type.name)) {
			const listItem = node.firstChild;
			const { attrs: attrs$1 } = listItem;
			const { level, numId } = attrs$1;
			if (!seenLists.has(numId)) {
				const newNumId = ListHelpers.changeNumIdSameAbstract(numId, level, node.type.name, editor);
				listItem.attrs.numId = newNumId;
				seenLists.set(numId, newNumId);
			} else {
				const newNumId = seenLists.get(numId);
				listItem.attrs.numId = newNumId;
			}
		}
	});
	return {
		name: "htmlAnnotation",
		elements: translateChildNodes({
			...params,
			node: htmlAnnotationNode
		})
	};
}
function prepareUrlAnnotation(params) {
	const { node: { attrs = {}, marks = [] } } = params;
	if (!attrs.linkUrl) return prepareTextAnnotation(params);
	const linkTextNode = {
		type: "text",
		text: attrs.linkUrl,
		marks: [
			...marks,
			{
				type: "link",
				attrs: {
					href: attrs.linkUrl,
					history: true,
					text: attrs.linkUrl
				}
			},
			{
				type: "textStyle",
				attrs: { color: "#467886" }
			}
		]
	};
	return translator$78.decode({
		...params,
		node: linkTextNode
	});
}
function translateFieldAttrsToMarks(attrs = {}) {
	const { fontFamily, fontSize, bold, underline, italic, textColor, textHighlight } = attrs;
	const marks = [];
	if (fontFamily) marks.push({
		type: "fontFamily",
		attrs: { fontFamily }
	});
	if (fontSize) marks.push({
		type: "fontSize",
		attrs: { fontSize }
	});
	if (bold) marks.push({
		type: "bold",
		attrs: {}
	});
	if (underline) marks.push({
		type: "underline",
		attrs: {}
	});
	if (italic) marks.push({
		type: "italic",
		attrs: {}
	});
	if (textColor) marks.push({
		type: "color",
		attrs: { color: textColor }
	});
	if (textHighlight) marks.push({
		type: "highlight",
		attrs: { color: textHighlight }
	});
	return marks;
}
function applyMarksToHtmlAnnotation(state, marks) {
	const { tr, doc: doc$2, schema } = state;
	const allowedMarks = [
		"fontFamily",
		"fontSize",
		"highlight"
	];
	if (!marks.some((m) => allowedMarks.includes(m.type))) return state;
	const fontFamily = marks.find((m) => m.type === "fontFamily");
	const fontSize = marks.find((m) => m.type === "fontSize");
	const highlight = marks.find((m) => m.type === "highlight");
	const textStyleType = schema.marks.textStyle;
	const highlightType = schema.marks.highlight;
	doc$2.descendants((node, pos) => {
		if (!node.isText) return;
		const foundTextStyle = node.marks.find((m) => m.type.name === "textStyle");
		const foundHighlight = node.marks.find((m) => m.type.name === "highlight");
		if (!foundTextStyle) tr.addMark(pos, pos + node.nodeSize, textStyleType.create({
			...fontFamily?.attrs,
			...fontSize?.attrs
		}));
		else if (!foundTextStyle?.attrs.fontFamily && fontFamily) tr.addMark(pos, pos + node.nodeSize, textStyleType.create({
			...foundTextStyle?.attrs,
			...fontFamily.attrs
		}));
		else if (!foundTextStyle?.attrs.fontSize && fontSize) tr.addMark(pos, pos + node.nodeSize, textStyleType.create({
			...foundTextStyle?.attrs,
			...fontSize.attrs
		}));
		if (!foundHighlight) tr.addMark(pos, pos + node.nodeSize, highlightType.create({ ...highlight?.attrs }));
	});
	return state.apply(tr);
}
function getFieldHighlightJson(fieldsHighlightColor) {
	if (!fieldsHighlightColor) return null;
	let parsedColor = fieldsHighlightColor.trim();
	if (!/^#?([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(parsedColor)) {
		console.warn(`Invalid HEX color provided to fieldsHighlightColor export param: ${fieldsHighlightColor}`);
		return null;
	}
	if (parsedColor.startsWith("#")) parsedColor = parsedColor.slice(1);
	return {
		name: "w:rPr",
		elements: [{
			name: "w:shd",
			attributes: {
				"w:fill": `#${parsedColor}`,
				"w:color": "auto",
				"w:val": "clear"
			}
		}]
	};
}
function translateDocumentSection(params) {
	const { node } = params;
	const { attrs = {} } = node;
	const nodeElements = [{
		name: "w:sdtContent",
		elements: translateChildNodes({
			...params,
			nodes: node.content
		})
	}];
	const exportedTag = JSON.stringify({
		type: "documentSection",
		description: attrs.description
	});
	const sdtPr = generateSdtPrTagForDocumentSection(attrs.id, attrs.title, exportedTag, attrs.sdtPr);
	const { isLocked } = attrs;
	if (isLocked) sdtPr.elements.push({
		name: "w:lock",
		attributes: { "w:val": "sdtContentLocked" }
	});
	nodeElements.unshift(sdtPr);
	return {
		name: "w:sdt",
		elements: nodeElements
	};
}
const generateSdtPrTagForDocumentSection = (id, title, tag, sdtPr) => {
	const coreElements = [
		{
			name: "w:id",
			attributes: { "w:val": id }
		},
		{
			name: "w:alias",
			attributes: { "w:val": title }
		},
		{
			name: "w:tag",
			attributes: { "w:val": tag }
		}
	];
	if (sdtPr?.elements && Array.isArray(sdtPr.elements)) {
		const elementsToExclude = [
			"w:id",
			"w:alias",
			"w:tag",
			"w:lock"
		];
		const passthroughElements = sdtPr.elements.filter((el) => el && el.name && !elementsToExclude.includes(el.name));
		coreElements.push(...passthroughElements);
	}
	return {
		name: "w:sdtPr",
		elements: coreElements
	};
};
function translateDocumentPartObj(params) {
	const { node } = params;
	const { attrs = {} } = node;
	const childContent = translateChildNodes({
		...params,
		nodes: node.content
	});
	const result = {
		name: "w:sdt",
		elements: [generateSdtPrForDocPartObj(attrs), {
			name: "w:sdtContent",
			elements: childContent
		}]
	};
	if (!attrs.wrapperParagraph) return result;
	return wrapDocumentPartInParagraph(result, attrs.wrapperParagraph);
}
function wrapDocumentPartInParagraph(sdtNode, wrapperParagraphAttrs) {
	const elements = [];
	const pPr = generateParagraphProperties({ node: {
		type: "paragraph",
		attrs: wrapperParagraphAttrs
	} });
	if (pPr) elements.push(pPr);
	elements.push(sdtNode);
	const attributes = {
		...extractRawParagraphXmlAttributes(wrapperParagraphAttrs),
		...translator.decodeAttributes({ node: { attrs: wrapperParagraphAttrs } })
	};
	return {
		name: "w:p",
		elements,
		...Object.keys(attributes).length ? { attributes } : {}
	};
}
function extractRawParagraphXmlAttributes(attrs = {}) {
	return Object.fromEntries(Object.entries(attrs).filter(([key]) => key.includes(":")));
}
function sanitizeId(id) {
	if (typeof id === "string" && id.trim() !== "") return id.trim();
}
function generateSdtPrForDocPartObj(attrs) {
	const existingDocPartObj = attrs.sdtPr?.elements?.find((el) => el.name === "w:docPartObj");
	const existingDocPartGallery = existingDocPartObj?.elements?.find((el) => el.name === "w:docPartGallery")?.attributes?.["w:val"];
	const docPartGallery = attrs.docPartGallery ?? existingDocPartGallery ?? null;
	const id = sanitizeId(attrs.id ?? attrs.sdtPr?.elements?.find((el) => el.name === "w:id")?.attributes?.["w:val"]);
	const docPartUnique = attrs.docPartUnique ?? existingDocPartObj?.elements?.some((el) => el.name === "w:docPartUnique") ?? false;
	if (docPartGallery === null) {
		if (attrs.sdtPr) return {
			...attrs.sdtPr,
			elements: Array.isArray(attrs.sdtPr.elements) ? attrs.sdtPr.elements.filter((el) => !(el.name === "w:id" && el.attributes?.["w:val"]?.trim() === "")) : attrs.sdtPr.elements
		};
		const elements = [{
			name: "w:docPartObj",
			elements: []
		}];
		if (id != void 0) elements.unshift({
			name: "w:id",
			attributes: { "w:val": id }
		});
		return {
			name: "w:sdtPr",
			elements
		};
	}
	const docPartObjElements = [{
		name: "w:docPartGallery",
		attributes: { "w:val": docPartGallery }
	}];
	if (docPartUnique) docPartObjElements.push({ name: "w:docPartUnique" });
	const sdtPrElements = [{
		name: "w:docPartObj",
		elements: docPartObjElements
	}];
	if (id != void 0) sdtPrElements.unshift({
		name: "w:id",
		attributes: { "w:val": id }
	});
	if (attrs.sdtPr?.elements && Array.isArray(attrs.sdtPr.elements)) {
		const elementsToExclude = ["w:id", "w:docPartObj"];
		const passthroughElements = attrs.sdtPr.elements.filter((el) => el && el.name && !elementsToExclude.includes(el.name));
		sdtPrElements.push(...passthroughElements);
	}
	return {
		name: "w:sdtPr",
		elements: sdtPrElements
	};
}
var RUN_LEVEL_WRAPPERS = new Set([
	"w:hyperlink",
	"w:ins",
	"w:del",
	"w:smartTag"
]);
function convertSdtContentToRuns(elements) {
	const normalized = Array.isArray(elements) ? elements : [elements];
	const runs = [];
	normalized.forEach((element) => {
		if (!element) return;
		if (element.name === "w:sdtPr") return;
		if (element.name === "w:r") {
			runs.push(element);
			return;
		}
		if (element.name === "w:sdt") {
			const sdtContent = (element.elements || []).find((child) => child?.name === "w:sdtContent");
			if (sdtContent?.elements) runs.push(...convertSdtContentToRuns(sdtContent.elements));
			return;
		}
		if (RUN_LEVEL_WRAPPERS.has(element.name)) {
			const children = element.elements || [];
			const preserved = [];
			const rest = [];
			for (const child of children) if (element.name === "w:smartTag" && child?.name === "w:smartTagPr") preserved.push(child);
			else rest.push(child);
			const wrapperElements = [...preserved, ...convertSdtContentToRuns(rest)];
			if (wrapperElements.length) runs.push({
				...element,
				elements: wrapperElements
			});
			return;
		}
		if (element.name) runs.push({
			name: "w:r",
			type: "element",
			elements: element.elements || [element]
		});
	});
	return runs.filter((run$1) => Array.isArray(run$1.elements) && run$1.elements.length > 0);
}
function translateStructuredContent(params) {
	const { node, isFinalDoc, preserveSdtWrappers } = params;
	const childContent = translateChildNodes({
		...params,
		node
	});
	const childElements = Array.isArray(childContent) ? childContent : [childContent];
	if (isFinalDoc && !preserveSdtWrappers) {
		if (node?.type === "structuredContent") return convertSdtContentToRuns(childElements);
		if (node?.type === "structuredContentBlock") return childElements.length === 1 ? childElements[0] : childElements;
	}
	const sdtContent = {
		name: "w:sdtContent",
		elements: childElements
	};
	return {
		name: "w:sdt",
		elements: [generateSdtPrTagForStructuredContent({ node }), sdtContent]
	};
}
var CONTROL_TYPE_ELEMENT_MAP = {
	text: "w:text",
	richText: "w:richText",
	date: "w:date",
	checkbox: "w14:checkbox",
	comboBox: "w:comboBox",
	dropDownList: "w:dropDownList",
	repeatingSection: "w15:repeatingSection",
	repeatingSectionItem: "w15:repeatingSectionItem",
	group: "w:group"
};
var DEFAULT_CHECKBOX_SYMBOL_FONT = "MS Gothic";
var DEFAULT_CHECKBOX_CHECKED_HEX = "2612";
var DEFAULT_CHECKBOX_UNCHECKED_HEX = "2610";
function buildDefaultTypeElement(controlType) {
	const typeElementName = controlType && CONTROL_TYPE_ELEMENT_MAP[controlType];
	if (!typeElementName) return null;
	if (controlType === "checkbox") return {
		name: typeElementName,
		type: "element",
		elements: [
			{
				name: "w14:checked",
				type: "element",
				attributes: { "w14:val": "0" }
			},
			{
				name: "w14:checkedState",
				type: "element",
				attributes: {
					"w14:font": DEFAULT_CHECKBOX_SYMBOL_FONT,
					"w14:val": DEFAULT_CHECKBOX_CHECKED_HEX
				}
			},
			{
				name: "w14:uncheckedState",
				type: "element",
				attributes: {
					"w14:font": DEFAULT_CHECKBOX_SYMBOL_FONT,
					"w14:val": DEFAULT_CHECKBOX_UNCHECKED_HEX
				}
			}
		]
	};
	if (controlType === "comboBox" || controlType === "dropDownList") return {
		name: typeElementName,
		type: "element",
		elements: []
	};
	if (controlType === "repeatingSection") return {
		name: typeElementName,
		type: "element",
		elements: [{
			name: "w15:allowInsertDeleteSection",
			type: "element",
			attributes: { "w15:val": "1" }
		}]
	};
	if (controlType === "date") return {
		name: typeElementName,
		type: "element",
		elements: [
			{
				name: "w:dateFormat",
				type: "element",
				attributes: { "w:val": "M/d/yyyy" }
			},
			{
				name: "w:lid",
				type: "element",
				attributes: { "w:val": "en-US" }
			},
			{
				name: "w:storeMappedDataAs",
				type: "element",
				attributes: { "w:val": "dateTime" }
			},
			{
				name: "w:calendar",
				type: "element",
				attributes: { "w:val": "gregorian" }
			}
		]
	};
	return {
		name: typeElementName,
		type: "element"
	};
}
function generateSdtPrTagForStructuredContent({ node }) {
	const { attrs = {} } = node;
	const id = {
		name: "w:id",
		type: "element",
		attributes: { "w:val": attrs.id }
	};
	const alias = {
		name: "w:alias",
		type: "element",
		attributes: { "w:val": attrs.alias }
	};
	const tag = {
		name: "w:tag",
		type: "element",
		attributes: { "w:val": attrs.tag }
	};
	const lock = {
		name: "w:lock",
		type: "element",
		attributes: { "w:val": attrs.lockMode }
	};
	const resultElements = [];
	if (attrs.id != null) resultElements.push(id);
	if (attrs.alias) resultElements.push(alias);
	if (attrs.tag) resultElements.push(tag);
	if (attrs.lockMode && attrs.lockMode !== "unlocked") resultElements.push(lock);
	if (attrs.sdtPr) {
		const elements = attrs.sdtPr.elements || [];
		const elementsToExclude = [
			"w:id",
			"w:alias",
			"w:tag",
			"w:lock"
		];
		const restElements = elements.filter((el) => !elementsToExclude.includes(el.name));
		return {
			name: "w:sdtPr",
			type: "element",
			elements: [...resultElements, ...restElements]
		};
	}
	const typeElement = buildDefaultTypeElement(attrs.controlType || attrs.type);
	if (typeElement) resultElements.push(typeElement);
	return {
		name: "w:sdtPr",
		type: "element",
		elements: resultElements
	};
}
var XML_NODE_NAME$26 = "w:sdt";
var SD_NODE_NAME$25 = [
	"fieldAnnotation",
	"structuredContent",
	"structuredContentBlock",
	"documentSection"
];
var validXmlAttributes$3 = [];
function encode$43(params) {
	const node = params.nodes[0];
	const { type: sdtType, handler: handler$1 } = sdtNodeTypeStrategy(node);
	if (!handler$1 || sdtType === "unknown") return;
	return handler$1(params);
}
function decode$45(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	const types = {
		fieldAnnotation: () => translateFieldAnnotation(params),
		structuredContent: () => translateStructuredContent(params),
		structuredContentBlock: () => translateStructuredContent(params),
		documentSection: () => translateDocumentSection(params),
		documentPartObject: () => translateDocumentPartObj(params),
		default: () => null
	};
	return (types[node.type] ?? types.default)();
}
const config$26 = {
	xmlName: XML_NODE_NAME$26,
	sdNodeOrKeyName: SD_NODE_NAME$25,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$43,
	decode: decode$45,
	attributes: validXmlAttributes$3
};
const translator$9 = NodeTranslator.from(config$26);
const translator$51 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:bidiVisual", "rightToLeft"));
const translator$157 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tblCaption", "caption"));
const translator$160 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tblDescription", "description"));
const translator$163 = NodeTranslator.from(createMeasurementPropertyHandler("w:tblInd", "tableIndent"));
const translator$164 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tblLayout", "tableLayout", "w:type"));
var tblLookBitmask = Object.freeze({
	firstRow: 32,
	lastRow: 64,
	firstColumn: 128,
	lastColumn: 256,
	noHBand: 512,
	noVBand: 1024
});
var decodeTblLookVal = (val) => {
	if (!val) return null;
	const raw = typeof val === "string" ? val.trim() : String(val);
	let numeric = Number.parseInt(raw, 16);
	if (!Number.isFinite(numeric)) numeric = Number.parseInt(raw, 10);
	if (!Number.isFinite(numeric)) return null;
	return Object.fromEntries(Object.entries(tblLookBitmask).map(([key, mask]) => [key, (numeric & mask) === mask]));
};
const translator$165 = NodeTranslator.from({
	xmlName: "w:tblLook",
	sdNodeOrKeyName: "tblLook",
	attributes: [
		"w:firstColumn",
		"w:firstRow",
		"w:lastColumn",
		"w:lastRow",
		"w:noHBand",
		"w:noVBand"
	].map((attr) => createAttributeHandler(attr, null, parseBoolean, booleanToString)).concat([createAttributeHandler("w:val")]),
	encode: (params, encodedAttrs) => {
		const decoded = decodeTblLookVal(encodedAttrs.val);
		if (decoded) Object.entries(decoded).forEach(([key, value]) => {
			if (!Object.prototype.hasOwnProperty.call(encodedAttrs, key)) encodedAttrs[key] = value;
		});
		return Object.keys(encodedAttrs).length > 0 ? encodedAttrs : void 0;
	},
	decode: function({ node }, context) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs.tblLook || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
const translator$166 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tblOverlap", "overlap"));
const translator$168 = NodeTranslator.from(createSingleAttrPropertyHandler("w:tblStyle", "tableStyleId"));
const translator$169 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:tblStyleColBandSize", "tableStyleColBandSize"));
const translator$170 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:tblStyleRowBandSize", "tableStyleRowBandSize"));
const translator$171 = NodeTranslator.from(createMeasurementPropertyHandler("w:tblW", "tableWidth"));
const translator$172 = NodeTranslator.from({
	xmlName: "w:tblpPr",
	sdNodeOrKeyName: "floatingTableProperties",
	attributes: [
		"w:leftFromText",
		"w:rightFromText",
		"w:topFromText",
		"w:bottomFromText",
		"w:tblpX",
		"w:tblpY"
	].map((attr) => createAttributeHandler(attr, null, parseInteger$1, integerToString)).concat([
		"w:horzAnchor",
		"w:vertAnchor",
		"w:tblpXSpec",
		"w:tblpYSpec"
	].map((attr) => createAttributeHandler(attr))),
	encode: (params, encodedAttrs) => {
		return Object.keys(encodedAttrs).length > 0 ? encodedAttrs : void 0;
	},
	decode: function({ node }, context) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs.floatingTableProperties || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? { attributes: decodedAttrs } : void 0;
	}
});
var baseConfig = createNestedPropertiesTranslator("w:tblCellMar", "cellMargins", [
	translator$205,
	translator$206,
	translator$207,
	translator$208,
	translator$209,
	translator$210
]);
var orderedConfig = {
	...baseConfig,
	decode: function(params) {
		const result = baseConfig.decode.call(this, params);
		if (!result || !Array.isArray(result.elements)) return result;
		const rank$1 = (name) => {
			const i$1 = CT_TC_MAR_CHILD_ORDER.indexOf(name);
			return i$1 === -1 ? CT_TC_MAR_CHILD_ORDER.length : i$1;
		};
		return {
			...result,
			elements: [...result.elements].sort((a, b) => rank$1(a.name) - rank$1(b.name))
		};
	}
};
const translator$158 = NodeTranslator.from(orderedConfig);
var propertyTranslators$3 = [
	translator$51,
	translator$88,
	translator$140,
	translator$157,
	translator$159,
	translator$160,
	translator$163,
	translator$164,
	translator$165,
	translator$166,
	translator$168,
	translator$169,
	translator$170,
	translator$171,
	translator$172,
	translator$156,
	translator$158
];
const translator$167 = NodeTranslator.from(createNestedPropertiesTranslator("w:tblPr", "tableProperties", propertyTranslators$3));
var propertyTranslators$2 = [
	translator$129,
	translator$133,
	translator$167,
	translator$175,
	translator$193
];
var attributeHandlers$1 = [createAttributeHandler("w:type")];
const translator$204 = NodeTranslator.from(createNestedPropertiesTranslator("w:tblStylePr", "tableStyleProperties", propertyTranslators$2, {}, attributeHandlers$1));
var getColspan = (cell) => {
	const rawColspan = cell?.attrs?.colspan;
	const numericColspan = typeof rawColspan === "string" ? parseInt(rawColspan, 10) : rawColspan;
	return Number.isFinite(numericColspan) && numericColspan > 0 ? numericColspan : 1;
};
var resolveGridBefore = (row) => {
	const rawGridBefore = row?.attrs?.tableRowProperties?.gridBefore ?? row?.attrs?.gridBefore;
	const numericGridBefore = typeof rawGridBefore === "string" ? parseInt(rawGridBefore, 10) : rawGridBefore;
	if (!Number.isFinite(numericGridBefore) || numericGridBefore <= 0) return 0;
	const cells = Array.isArray(row.content) ? row.content : [];
	let leadingGridBefore = 0;
	while (leadingGridBefore < cells.length && cells[leadingGridBefore]?.attrs?.__placeholder === "gridBefore") leadingGridBefore += 1;
	return leadingGridBefore > 0 ? 0 : numericGridBefore;
};
var advanceColumnsForCell = (columnIndex, cell) => columnIndex + getColspan(cell);
var getCellStartColumn = (row, targetCell) => {
	const cells = Array.isArray(row.content) ? row.content : [];
	let columnIndex = resolveGridBefore(row);
	for (const cell of cells) {
		if (cell === targetCell) return columnIndex;
		columnIndex = advanceColumnsForCell(columnIndex, cell);
	}
	return columnIndex;
};
var findCellCoveringColumn = (row, targetColumn) => {
	const cells = Array.isArray(row.content) ? row.content : [];
	let columnIndex = resolveGridBefore(row);
	for (const cell of cells) {
		const colspan = getColspan(cell);
		if (targetColumn >= columnIndex && targetColumn < columnIndex + colspan) return cell;
		columnIndex = advanceColumnsForCell(columnIndex, cell);
	}
	return null;
};
var findInsertionIndexForColumn = (row, targetColumn) => {
	const cells = Array.isArray(row.content) ? row.content : [];
	let columnIndex = resolveGridBefore(row);
	for (let index = 0; index < cells.length; index++) {
		if (columnIndex >= targetColumn) return index;
		columnIndex = advanceColumnsForCell(columnIndex, cells[index]);
	}
	return cells.length;
};
function preProcessVerticalMergeCells(table, { editorSchema }) {
	if (!table || !Array.isArray(table.content)) return table;
	const rows = table.content;
	for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
		const row = rows[rowIndex];
		if (!row) continue;
		if (!Array.isArray(row.content)) row.content = [];
		for (let cellIndex = 0; cellIndex < row.content.length; cellIndex++) {
			const cell = row.content[cellIndex];
			if (!cell) continue;
			const attrs = cell.attrs || {};
			const rawRowspan = typeof attrs.rowspan === "string" ? parseInt(attrs.rowspan, 10) : attrs.rowspan;
			if (!Number.isFinite(rawRowspan) || rawRowspan <= 1) continue;
			const maxRowspan = Math.min(rawRowspan, rows.length - rowIndex);
			const startColumn = getCellStartColumn(row, cell);
			for (let offset = 1; offset < maxRowspan; offset++) {
				const rowToChange = rows[rowIndex + offset];
				if (!rowToChange) continue;
				if (!Array.isArray(rowToChange.content)) rowToChange.content = [];
				if (findCellCoveringColumn(rowToChange, startColumn)?.attrs?.continueMerge) continue;
				const mergedCell = {
					type: cell.type,
					content: [editorSchema.nodes.paragraph.createAndFill().toJSON()],
					attrs: {
						...cell.attrs,
						rowspan: null,
						continueMerge: true
					}
				};
				const insertionIndex = findInsertionIndexForColumn(rowToChange, startColumn);
				rowToChange.content.splice(insertionIndex, 0, mergedCell);
			}
		}
	}
	return table;
}
const normalizeTwipWidth = (value) => {
	if (value == null) return null;
	const numericValue = typeof value === "string" ? parseInt(value, 10) : value;
	if (!Number.isFinite(numericValue) || Number.isNaN(numericValue) || numericValue <= 0) return null;
	return numericValue;
};
const getSchemaDefaultColumnWidthPx = (params) => {
	const defaultValue = params?.editor?.schema?.nodes?.tableCell?.spec?.attrs?.colwidth?.default;
	if (Array.isArray(defaultValue)) {
		const numericWidth = defaultValue.find((width) => typeof width === "number" && Number.isFinite(width) && width > 0);
		if (numericWidth != null) return numericWidth;
	} else if (typeof defaultValue === "number" && Number.isFinite(defaultValue) && defaultValue > 0) return defaultValue;
	return 100;
};
const getTableWidthPx = (params) => {
	const explicitWidth = params?.node?.attrs?.tableWidth?.width;
	if (typeof explicitWidth === "number" && explicitWidth > 0) return explicitWidth;
	const tableWidth = params?.node?.attrs?.tableProperties?.tableWidth;
	if (tableWidth?.value != null && typeof tableWidth.value === "number" && tableWidth.value > 0) {
		const { value, type } = tableWidth;
		if (!type || type === "auto" || type === "dxa") return twipsToPixels$2(value);
	}
	return null;
};
const resolveFallbackColumnWidthTwips = (params, totalColumns, cellMinWidthTwips) => {
	const columnCount = Math.max(totalColumns, 1);
	const defaultColumnWidthPx = getSchemaDefaultColumnWidthPx(params);
	const tableWidthPx = getTableWidthPx(params);
	const safeDefaultPx = Number.isFinite(defaultColumnWidthPx) && defaultColumnWidthPx > 0 ? defaultColumnWidthPx : 100;
	let fallbackWidthPx = safeDefaultPx;
	if (typeof tableWidthPx === "number" && tableWidthPx > 0) fallbackWidthPx = tableWidthPx / columnCount;
	const fallbackWidthTwips = pixelsToTwips$1(fallbackWidthPx);
	if (!Number.isFinite(fallbackWidthTwips) || Number.isNaN(fallbackWidthTwips) || fallbackWidthTwips <= 0) return Math.max(pixelsToTwips$1(safeDefaultPx), cellMinWidthTwips);
	return Math.max(fallbackWidthTwips, cellMinWidthTwips);
};
const DEFAULT_CONTENT_WIDTH_TWIPS = 12240 - 2 * 1440;
const MIN_COLUMN_WIDTH_TWIPS = pixelsToTwips$1(10);
const pctToPercent = (value) => {
	if (value == null) return null;
	return value / 50;
};
const resolveContentWidthTwips = () => DEFAULT_CONTENT_WIDTH_TWIPS;
const resolveMeasurementWidthPx = (measurement) => {
	if (!measurement || typeof measurement.value !== "number" || measurement.value <= 0) return null;
	const { value, type } = measurement;
	if (!type || type === "auto") return null;
	if (type === "dxa") return twipsToPixels$2(value);
	if (type === "pct") {
		const percent = pctToPercent(value);
		if (percent == null || percent <= 0) return null;
		return twipsToPixels$2(resolveContentWidthTwips() * percent / 100);
	}
	return null;
};
const getRawRowGridMetadata = (row) => {
	const trPr = row?.elements?.find((element) => element.name === "w:trPr");
	const getChild = (name) => trPr?.elements?.find((element) => element.name === name);
	const parseCount = (name) => {
		const rawValue = getChild(name)?.attributes?.["w:val"];
		const value = typeof rawValue === "number" ? rawValue : Number.parseInt(rawValue || "0", 10);
		return Number.isFinite(value) && value > 0 ? value : 0;
	};
	const parseMeasurement = (name) => {
		const node = getChild(name);
		if (!node?.attributes) return null;
		const rawValue = node.attributes["w:w"];
		const value = typeof rawValue === "number" ? rawValue : Number.parseInt(rawValue || "", 10);
		if (!Number.isFinite(value) || value <= 0) return null;
		return {
			value,
			type: node.attributes["w:type"] || "dxa"
		};
	};
	return {
		gridBefore: parseCount("w:gridBefore"),
		gridAfter: parseCount("w:gridAfter"),
		wBefore: parseMeasurement("w:wBefore"),
		wAfter: parseMeasurement("w:wAfter")
	};
};
const countColumnsInRow = (row) => {
	if (!row?.elements?.length) return 0;
	const { gridBefore, gridAfter } = getRawRowGridMetadata(row);
	return gridBefore + row.elements.reduce((count, element) => {
		if (element.name !== "w:tc") return count;
		const gridSpan = (element.elements?.find((el) => el.name === "w:tcPr"))?.elements?.find((el) => el.name === "w:gridSpan");
		const spanValue = parseInt(gridSpan?.attributes?.["w:val"] || "1", 10);
		return count + (Number.isFinite(spanValue) && spanValue > 0 ? spanValue : 1);
	}, 0) + gridAfter;
};
var clampColumnWidthTwips = (value) => Math.max(Math.round(value), MIN_COLUMN_WIDTH_TWIPS);
var resolveSkippedColumnSeedWidthsTwips = (measurement, span) => {
	if (!measurement || !Number.isFinite(span) || span <= 0) return [];
	const resolvedPx = resolveMeasurementWidthPx(measurement);
	if (resolvedPx == null || resolvedPx <= 0) return [];
	const totalTwips = clampColumnWidthTwips(pixelsToTwips$1(resolvedPx));
	const baseWidth = Math.floor(totalTwips / span);
	const remainder = totalTwips - baseWidth * span;
	return Array.from({ length: span }, (_, index) => clampColumnWidthTwips(baseWidth + (index < remainder ? 1 : 0)));
};
var buildFallbackColumnWidthTwips = ({ columnCount, totalWidthTwips, rows }) => {
	const seededWidths = new Array(columnCount).fill(null);
	for (const row of rows) {
		const { gridBefore, gridAfter, wBefore, wAfter } = getRawRowGridMetadata(row);
		if (gridBefore > 0) resolveSkippedColumnSeedWidthsTwips(wBefore, gridBefore).forEach((widthTwips, index) => {
			if (index < columnCount) seededWidths[index] = Math.max(seededWidths[index] ?? 0, widthTwips);
		});
		if (gridAfter > 0) resolveSkippedColumnSeedWidthsTwips(wAfter, gridAfter).forEach((widthTwips, index) => {
			const targetIndex = columnCount - gridAfter + index;
			if (targetIndex >= 0 && targetIndex < columnCount) seededWidths[targetIndex] = Math.max(seededWidths[targetIndex] ?? 0, widthTwips);
		});
	}
	const seededTotalTwips = seededWidths.reduce((sum, widthTwips) => sum + (widthTwips ?? 0), 0);
	const remainingColumns = seededWidths.filter((widthTwips) => widthTwips == null).length;
	const minimumRemainingTwips = remainingColumns * MIN_COLUMN_WIDTH_TWIPS;
	const effectiveTotalTwips = Math.max(totalWidthTwips, seededTotalTwips + minimumRemainingTwips);
	const defaultRemainingTwips = remainingColumns > 0 ? clampColumnWidthTwips((effectiveTotalTwips - seededTotalTwips) / remainingColumns) : 0;
	return seededWidths.map((widthTwips) => clampColumnWidthTwips(widthTwips ?? defaultRemainingTwips));
};
const buildFallbackGridForTable = ({ params, rows, tableWidth, tableWidthMeasurement }) => {
	const columnCount = rows.reduce((max, row) => Math.max(max, countColumnsInRow(row)), 0);
	if (!columnCount) return null;
	const schemaDefaultPx = getSchemaDefaultColumnWidthPx(params);
	const minimumColumnWidthPx = Number.isFinite(schemaDefaultPx) && schemaDefaultPx > 0 ? schemaDefaultPx : 100;
	let totalWidthPx;
	if (tableWidthMeasurement) {
		const resolved = resolveMeasurementWidthPx(tableWidthMeasurement);
		if (resolved != null) totalWidthPx = resolved;
	}
	if (totalWidthPx == null && tableWidth?.width && tableWidth.width > 0) totalWidthPx = tableWidth.width;
	if (totalWidthPx == null) totalWidthPx = twipsToPixels$2(DEFAULT_CONTENT_WIDTH_TWIPS);
	const minimumColumnWidthTwips = clampColumnWidthTwips(pixelsToTwips$1(minimumColumnWidthPx));
	const fallbackColumnWidthTwips = buildFallbackColumnWidthTwips({
		columnCount,
		totalWidthTwips: Math.max(clampColumnWidthTwips(pixelsToTwips$1(totalWidthPx)), minimumColumnWidthTwips * columnCount),
		rows
	});
	return {
		grid: fallbackColumnWidthTwips.map((columnWidthTwips) => ({ col: clampColumnWidthTwips(columnWidthTwips) })),
		columnWidths: fallbackColumnWidthTwips.map((columnWidthTwips) => twipsToPixels$2(columnWidthTwips))
	};
};
const translator$72 = NodeTranslator.from(createSingleAttrPropertyHandler("w:gridCol", "col", "w:w", parseInteger$1, integerToString));
var XML_NODE_NAME$25 = "w:tblGrid";
var SD_ATTR_KEY = "grid";
var cellMinWidth = pixelsToTwips$1(10);
var encode$42 = (params) => {
	const { nodes } = params;
	const node = nodes[0];
	return {
		xmlName: XML_NODE_NAME$25,
		sdNodeOrKeyName: SD_ATTR_KEY,
		attributes: encodeProperties({
			...params,
			nodes: [node]
		}, { [translator$72.xmlName]: translator$72 }, true)
	};
};
var decode$44 = (params) => {
	const { grid: rawGrid } = params.node.attrs || {};
	const grid = Array.isArray(rawGrid) ? rawGrid : [];
	const { firstRow = {}, preferTableGrid = false, totalColumns: requestedColumns } = params.extraParams || {};
	let colWidthsFromCellNodes = (firstRow.content?.filter((n) => n.type === "tableCell" || n.type === "tableHeader") ?? []).flatMap((cell) => {
		const spanCount = Math.max(1, cell?.attrs?.colspan ?? 1);
		const colwidth = cell.attrs?.colwidth;
		return Array.from({ length: spanCount }).map((_, span) => Array.isArray(colwidth) ? colwidth[span] : void 0);
	});
	const columnCountFromCells = colWidthsFromCellNodes.length;
	const gridColumnCount = grid.length;
	let totalColumns = Math.max(columnCountFromCells, gridColumnCount);
	if (typeof requestedColumns === "number" && Number.isFinite(requestedColumns) && requestedColumns > 0) totalColumns = requestedColumns;
	else if (preferTableGrid && gridColumnCount > 0) totalColumns = gridColumnCount;
	if (colWidthsFromCellNodes.length > totalColumns) colWidthsFromCellNodes = colWidthsFromCellNodes.slice(0, totalColumns);
	const fallbackColumnWidthTwips = resolveFallbackColumnWidthTwips(params, totalColumns, cellMinWidth);
	const elements = [];
	const pushColumn = (widthTwips, { enforceMinimum = false } = {}) => {
		let numericWidth = typeof widthTwips === "string" ? parseInt(widthTwips, 10) : widthTwips;
		let shouldEnforceMinimum = enforceMinimum;
		if (numericWidth == null || Number.isNaN(numericWidth) || numericWidth <= 0) {
			numericWidth = fallbackColumnWidthTwips;
			shouldEnforceMinimum = true;
		}
		const roundedWidth = Math.round(numericWidth);
		const minimumWidth = shouldEnforceMinimum ? cellMinWidth : 1;
		const safeWidth = Math.max(roundedWidth, minimumWidth);
		const decoded = translator$72.decode({ node: {
			type: translator$72.sdNodeOrKeyName,
			attrs: { col: safeWidth }
		} });
		if (decoded) elements.push(decoded);
	};
	for (let columnIndex = 0; columnIndex < totalColumns; ++columnIndex) {
		const rawWidth = colWidthsFromCellNodes[columnIndex];
		const cellWidthPixels = typeof rawWidth === "number" && Number.isFinite(rawWidth) ? rawWidth : Number(rawWidth);
		const hasCellWidth = Number.isFinite(cellWidthPixels) && cellWidthPixels > 0;
		const gridWidthTwips = normalizeTwipWidth((grid?.[columnIndex] || {}).col);
		const gridWidthPixels = gridWidthTwips != null ? twipsToPixels$2(gridWidthTwips) : null;
		let cellWidthTwips;
		let enforceMinimum = false;
		if (gridWidthTwips != null) cellWidthTwips = gridWidthTwips;
		else if (hasCellWidth) if (gridWidthTwips != null && gridWidthPixels != null && Math.abs(gridWidthPixels - cellWidthPixels) <= .5) cellWidthTwips = gridWidthTwips;
		else cellWidthTwips = pixelsToTwips$1(cellWidthPixels);
		else {
			cellWidthTwips = fallbackColumnWidthTwips;
			enforceMinimum = true;
		}
		pushColumn(cellWidthTwips, { enforceMinimum });
	}
	return {
		name: XML_NODE_NAME$25,
		attributes: {},
		elements
	};
};
var config$25 = {
	xmlName: XML_NODE_NAME$25,
	sdNodeOrKeyName: SD_ATTR_KEY,
	encode: encode$42,
	decode: decode$44
};
const translator$161 = NodeTranslator.from(config$25);
var validXmlAttributes$2 = ["w14:paraId", "w14:textId"].map((xmlName) => createAttributeHandler(xmlName));
var XML_NODE_NAME$24 = "w:tbl";
var SD_NODE_NAME$24 = "table";
var INDENT_TWIPS_TOLERANCE = 5;
var sumColumnTwips = (columns = []) => columns.reduce((sum, col) => {
	const raw = col?.col;
	const value = typeof raw === "number" ? raw : Number.parseInt(raw, 10);
	return Number.isFinite(value) ? sum + value : sum;
}, 0);
var getFirstRowCellWidthSumTwips = (rows = []) => {
	const firstRow = rows.find((row) => row?.elements?.some((el) => el.name === "w:tc"));
	if (!firstRow?.elements) return null;
	const cells = firstRow.elements.filter((el) => el.name === "w:tc");
	if (!cells.length) return null;
	let sum = 0;
	for (const cell of cells) {
		const rawWidth = ((cell.elements?.find((el) => el.name === "w:tcPr"))?.elements?.find((el) => el.name === "w:tcW"))?.attributes?.["w:w"];
		const width = typeof rawWidth === "number" ? rawWidth : Number.parseInt(rawWidth, 10);
		if (!Number.isFinite(width)) return null;
		sum += width;
	}
	return sum;
};
var encode$41 = (params, encodedAttrs) => {
	const { nodes } = params;
	const node = nodes[0];
	const tblPr = node.elements.find((el) => el.name === "w:tblPr");
	if (tblPr) encodedAttrs["tableProperties"] = translator$167.encode({
		...params,
		nodes: [tblPr]
	}) || {};
	else encodedAttrs["tableProperties"] ||= {};
	const tblGrid = node.elements.find((el) => el.name === "w:tblGrid");
	if (tblGrid) encodedAttrs["grid"] = translator$161.encode({
		...params,
		nodes: [tblGrid]
	}).attributes;
	[
		"tableStyleId",
		"justification",
		"tableLayout",
		["tableIndent", ({ value, type }) => ({
			width: twipsToPixels$2(value),
			type
		})],
		["tableCellSpacing", ({ value, type }) => ({
			value: twipsToPixels$2(value),
			type
		})]
	].forEach((prop) => {
		let key;
		let transform;
		if (Array.isArray(prop)) [key, transform] = prop;
		else {
			key = prop;
			transform = (v) => v;
		}
		if (encodedAttrs.tableProperties[key]) encodedAttrs[key] = transform(encodedAttrs.tableProperties[key]);
	});
	if (encodedAttrs.tableCellSpacing) encodedAttrs["borderCollapse"] = "separate";
	if (encodedAttrs.tableProperties.tableWidth) {
		const tableWidthMeasurement = encodedAttrs.tableProperties.tableWidth;
		if (tableWidthMeasurement.type === "pct" && typeof tableWidthMeasurement.value === "number") encodedAttrs.tableWidth = {
			value: tableWidthMeasurement.value,
			type: tableWidthMeasurement.type
		};
		else {
			const widthPx = twipsToPixels$2(tableWidthMeasurement.value);
			if (widthPx != null) encodedAttrs.tableWidth = {
				width: widthPx,
				type: tableWidthMeasurement.type
			};
		}
		if (!encodedAttrs.tableWidth && tableWidthMeasurement.type === "auto") encodedAttrs.tableWidth = {
			width: 0,
			type: tableWidthMeasurement.type
		};
	}
	const borderProps = _processTableBorders(encodedAttrs.tableProperties.borders || {});
	const referencedStyles = _getReferencedTableStyles(encodedAttrs.tableStyleId, params) || {};
	encodedAttrs.borders = {
		...referencedStyles.borders,
		...borderProps
	};
	encodedAttrs.tableProperties.cellMargins = referencedStyles.cellMargins = {
		...referencedStyles.cellMargins,
		...encodedAttrs.tableProperties.cellMargins
	};
	const rows = node.elements.filter((el) => el.name === "w:tr");
	let columnWidths = Array.isArray(encodedAttrs["grid"]) ? encodedAttrs["grid"].map((item) => twipsToPixels$2(item.col)) : [];
	const tableIndentTwips = encodedAttrs.tableProperties?.tableIndent?.value;
	const hasIndent = Number.isFinite(tableIndentTwips) && tableIndentTwips !== 0;
	const hasExplicitGrid = Boolean(tblGrid);
	const gridTwipsTotal = hasExplicitGrid ? sumColumnTwips(encodedAttrs["grid"]) : null;
	const rowTcWTwipsTotal = hasExplicitGrid && hasIndent ? getFirstRowCellWidthSumTwips(rows) : null;
	const indentDiff = rowTcWTwipsTotal != null && gridTwipsTotal != null ? rowTcWTwipsTotal - gridTwipsTotal : null;
	const preferTableGridWidths = hasExplicitGrid && hasIndent && gridTwipsTotal != null && rowTcWTwipsTotal != null && Math.sign(indentDiff) === Math.sign(tableIndentTwips) && Math.abs(indentDiff - tableIndentTwips) <= INDENT_TWIPS_TOLERANCE;
	if (!(columnWidths.length > 0 && columnWidths.some((w) => w > 0))) {
		const fallback = buildFallbackGridForTable({
			params,
			rows,
			tableWidth: encodedAttrs.tableWidth,
			tableWidthMeasurement: encodedAttrs.tableProperties.tableWidth
		});
		if (fallback) {
			encodedAttrs.grid = fallback.grid;
			columnWidths = fallback.columnWidths;
		}
		const tw = encodedAttrs.tableWidth;
		if (!(tw && tw.type !== "auto" && (tw.width > 0 || tw.value > 0))) encodedAttrs.tableWidth = {
			value: 5e3,
			type: "pct"
		};
	}
	const content$2 = [];
	const totalColumns = columnWidths.length;
	const totalRows = rows.length;
	const activeRowSpans = totalColumns > 0 ? new Array(totalColumns).fill(0) : [];
	rows.forEach((row, rowIndex) => {
		const result = translator$8.encode({
			...params,
			path: [...params.path || [], node],
			nodes: [row],
			extraParams: {
				row,
				table: node,
				tableProperties: encodedAttrs.tableProperties,
				columnWidths,
				activeRowSpans: activeRowSpans.slice(),
				rowIndex,
				totalRows,
				totalColumns,
				preferTableGridWidths,
				_referencedStyles: referencedStyles
			}
		});
		if (result) {
			content$2.push(result);
			if (totalColumns > 0) {
				const activeRowSpansForCurrentRow = activeRowSpans.slice();
				for (let col = 0; col < totalColumns; col++) if (activeRowSpans[col] > 0) activeRowSpans[col] -= 1;
				let columnIndex = 0;
				const advanceColumnIndex = () => {
					while (columnIndex < totalColumns && activeRowSpansForCurrentRow[columnIndex] > 0) columnIndex += 1;
				};
				advanceColumnIndex();
				result.content?.forEach((cell) => {
					advanceColumnIndex();
					const colspan = Math.max(1, cell.attrs?.colspan || 1);
					const rowspan = Math.max(1, cell.attrs?.rowspan || 1);
					if (rowspan > 1) for (let offset = 0; offset < colspan && columnIndex + offset < totalColumns; offset++) {
						const targetIndex = columnIndex + offset;
						const remainingRows = rowspan - 1;
						if (remainingRows > 0 && remainingRows > activeRowSpans[targetIndex]) activeRowSpans[targetIndex] = remainingRows;
					}
					columnIndex += colspan;
					advanceColumnIndex();
				});
			}
		}
	});
	return {
		type: "table",
		content: content$2,
		attrs: encodedAttrs
	};
};
var decode$43 = (params, decodedAttrs) => {
	params.node = preProcessVerticalMergeCells(params.node, params);
	const { node } = params;
	const rawGrid = node.attrs?.grid;
	const grid = Array.isArray(rawGrid) ? rawGrid : [];
	const preferTableGrid = node.attrs?.userEdited !== true && grid.length > 0;
	const totalColumns = preferTableGrid ? grid.length : void 0;
	const extraParams = {
		...params.extraParams || {},
		preferTableGrid,
		totalColumns
	};
	const elements = translateChildNodes({
		...params,
		extraParams
	});
	const firstRow = node.content?.find((n) => n.type === "tableRow");
	const element = translator$161.decode({
		...params,
		node: {
			...node,
			attrs: {
				...node.attrs,
				grid
			}
		},
		extraParams: {
			...extraParams,
			firstRow
		}
	});
	if (element) elements.unshift(element);
	if (node.attrs?.tableProperties) {
		const properties = { ...node.attrs.tableProperties };
		const element$1 = translator$167.decode({
			...params,
			node: {
				...node,
				attrs: {
					...node.attrs,
					tableProperties: properties
				}
			}
		});
		if (element$1) elements.unshift(element$1);
	}
	return {
		name: "w:tbl",
		attributes: stripUnsupportedTableIdentityAttributes(decodedAttrs),
		elements
	};
};
function _processTableBorders(rawBorders) {
	const borders = {};
	Object.entries(rawBorders).forEach(([name, attributes]) => {
		const attrs = {};
		const color = attributes.color;
		const size = attributes.size;
		const val = attributes.val;
		if (color && color !== "auto") attrs["color"] = color.startsWith("#") ? color : `#${color}`;
		if (size && size !== "auto") attrs["size"] = eighthPointsToPixels(size);
		if (val) attrs["val"] = val;
		borders[name] = attrs;
	});
	return borders;
}
function _getReferencedTableStyles(tableStyleReference, params) {
	if (!tableStyleReference) return null;
	const stylesToReturn = {};
	const { docx } = params;
	const { elements } = docx["word/styles.xml"].elements[0];
	const styleElements = elements.filter((el) => el.name === "w:style");
	const styleTag = styleElements.find((el) => el.attributes["w:styleId"] === tableStyleReference);
	if (!styleTag) return null;
	stylesToReturn.name = styleTag.elements.find((el) => el.name === "w:name");
	const basedOn = styleTag.elements.find((el) => el.name === "w:basedOn");
	let baseTblPr;
	if (basedOn?.attributes) {
		const baseStyles = styleElements.find((el) => el.attributes["w:styleId"] === basedOn.attributes["w:val"]);
		baseTblPr = baseStyles ? baseStyles.elements.find((el) => el.name === "w:tblPr") : {};
	}
	const pPr = styleTag.elements.find((el) => el.name === "w:pPr");
	if (pPr) {
		const justification = pPr.elements.find((el) => el.name === "w:jc");
		if (justification?.attributes) stylesToReturn.justification = justification.attributes["w:val"];
	}
	const rPr = styleTag?.elements.find((el) => el.name === "w:rPr");
	if (rPr) {
		const fonts = rPr.elements.find((el) => el.name === "w:rFonts");
		if (fonts) {
			const { "w:ascii": ascii, "w:hAnsi": hAnsi, "w:cs": cs } = fonts.attributes;
			stylesToReturn.fonts = {
				ascii,
				hAnsi,
				cs
			};
		}
		const fontSize = rPr.elements.find((el) => el.name === "w:sz");
		if (fontSize?.attributes) stylesToReturn.fontSize = halfPointToPoints(fontSize.attributes["w:val"]) + "pt";
	}
	const tblPr = styleTag.elements.find((el) => el.name === "w:tblPr");
	if (tblPr && tblPr.elements) {
		const mergedTblPr = baseTblPr?.elements?.length > 0 ? {
			name: tblPr.name,
			attributes: tblPr.attributes,
			elements: [...baseTblPr.elements, ...tblPr.elements]
		} : tblPr;
		const tableProperties = translator$167.encode({
			...params,
			nodes: [mergedTblPr]
		});
		if (tableProperties) {
			const borders = _processTableBorders(tableProperties.borders || {});
			if (borders || Object.keys(borders).length) stylesToReturn.borders = borders;
			const cellMargins = {};
			Object.entries(tableProperties.cellMargins || {}).forEach(([key, attrs]) => {
				if (attrs?.value != null) cellMargins[key] = {
					value: attrs.value,
					type: attrs.type || "dxa"
				};
			});
			if (Object.keys(cellMargins).length) stylesToReturn.cellMargins = cellMargins;
			if (tableProperties.tableCellSpacing) stylesToReturn.tableCellSpacing = tableProperties.tableCellSpacing;
		}
	}
	const tblStylePr = styleTag.elements.filter((el) => el.name === "w:tblStylePr");
	let styleProps = {};
	if (tblStylePr) styleProps = tblStylePr.reduce((acc, el) => {
		acc[el.attributes["w:type"]] = translator$204.encode({
			...params,
			nodes: [el]
		});
		return acc;
	}, {});
	return {
		...stylesToReturn,
		...styleProps
	};
}
const config$24 = {
	xmlName: XML_NODE_NAME$24,
	sdNodeOrKeyName: SD_NODE_NAME$24,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$41,
	decode: decode$43,
	attributes: validXmlAttributes$2
};
const translator$10 = NodeTranslator.from(config$24);
const encode$40 = (attributes) => {
	return attributes["w:id"];
};
const decode$42 = (attrs) => {
	return attrs.id;
};
const attrConfig$14 = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$40,
	decode: decode$42
});
const encode$39 = (attributes) => {
	return attributes["w:name"];
};
const decode$41 = (attrs) => {
	return attrs.name;
};
const attrConfig$15 = Object.freeze({
	xmlName: "w:name",
	sdName: "name",
	encode: encode$39,
	decode: decode$41
});
const encode$38 = (attributes) => {
	return attributes["w:colFirst"];
};
const decode$40 = (attrs) => {
	return attrs.colFirst;
};
const attrConfig$16 = Object.freeze({
	xmlName: "w:colFirst",
	sdName: "colFirst",
	encode: encode$38,
	decode: decode$40
});
const encode$37 = (attributes) => {
	return attributes["w:colLast"];
};
const decode$39 = (attrs) => {
	return attrs.colLast;
};
const attrConfig$17 = Object.freeze({
	xmlName: "w:colLast",
	sdName: "colLast",
	encode: encode$37,
	decode: decode$39
});
const encode$36 = (attributes) => {
	return attributes["w:displacedByCustomXml"];
};
const decode$38 = (attrs) => {
	return attrs.displacedByCustomXml;
};
var attributes_default = [
	attrConfig$14,
	attrConfig$15,
	attrConfig$16,
	attrConfig$17,
	Object.freeze({
		xmlName: "w:displacedByCustomXml",
		sdName: "displacedByCustomXml",
		encode: encode$36,
		decode: decode$38
	})
];
var XML_NODE_NAME$23 = "w:bookmarkStart";
var SD_NODE_NAME$23 = "bookmarkStart";
var encode$35 = (params, encodedAttrs = {}) => {
	return {
		type: "bookmarkStart",
		attrs: encodedAttrs
	};
};
var decode$37 = (params, decodedAttrs = {}) => {
	const result = {
		name: "w:bookmarkStart",
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length) result.attributes = decodedAttrs;
	return result;
};
const config$23 = {
	xmlName: XML_NODE_NAME$23,
	sdNodeOrKeyName: SD_NODE_NAME$23,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$35,
	decode: decode$37,
	attributes: attributes_default
};
const translator$13 = NodeTranslator.from(config$23);
const encode$34 = (attributes) => {
	return attributes["w:id"];
};
const decode$36 = (attrs) => {
	return attrs.id;
};
const attrConfig$12 = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$34,
	decode: decode$36
});
const encode$33 = (attributes) => {
	return attributes["w:displacedByCustomXml"];
};
const decode$35 = (attrs) => {
	return attrs.displacedByCustomXml;
};
var attributes_default$1 = [attrConfig$12, Object.freeze({
	xmlName: "w:displacedByCustomXml",
	sdName: "displacedByCustomXml",
	encode: encode$33,
	decode: decode$35
})];
var XML_NODE_NAME$22 = "w:bookmarkEnd";
var SD_NODE_NAME$22 = "bookmarkEnd";
var encode$32 = (params, encodedAttrs = {}) => {
	return {
		type: "bookmarkEnd",
		attrs: encodedAttrs
	};
};
var decode$34 = (params, decodedAttrs = {}) => {
	const result = {
		name: "w:bookmarkEnd",
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length) result.attributes = decodedAttrs;
	return result;
};
const config$22 = {
	xmlName: XML_NODE_NAME$22,
	sdNodeOrKeyName: SD_NODE_NAME$22,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$32,
	decode: decode$34,
	attributes: attributes_default$1
};
const translator$14 = NodeTranslator.from(config$22);
const decode$33 = (attrs) => attrs?.["w:id"];
const attrConfig$11 = Object.freeze({
	xmlName: "w:id",
	sdName: "w:id",
	encode: () => {},
	decode: decode$33
});
var XML_NODE_NAME$21 = "w:commentRange";
var SD_NODE_NAME$21 = "commentRange";
var decode$32 = (params) => {
	const { node, comments, commentsExportType, exportedCommentDefs } = params;
	if (!node) return;
	if (!comments) return;
	if (exportedCommentDefs?.length === 0) return;
	if (commentsExportType === "clean") return;
	const commentNodeId = node.attrs["w:id"];
	const nodeIdStr = String(commentNodeId);
	const originalComment = comments.find((comment) => {
		return String(comment.commentId) === nodeIdStr || String(comment.importedId) === nodeIdStr;
	});
	if (!originalComment) return;
	const parentCommentId = originalComment.parentCommentId;
	const parentComment = comments.find(({ commentId, importedId }) => commentId === parentCommentId || importedId === parentCommentId);
	const isInternal = parentComment?.isInternal || originalComment.isInternal;
	if (commentsExportType === "external" && isInternal) return;
	if (node.type !== "commentRangeStart" && node.type !== "commentRangeEnd") return;
	const { type } = node;
	const commentIndex = comments.findIndex((comment) => comment.commentId === originalComment.commentId);
	let commentSchema = getCommentSchema(type, commentIndex);
	if (type === "commentRangeEnd") commentSchema = [commentSchema, {
		name: "w:r",
		elements: [{
			name: "w:rPr",
			elements: [{
				name: "w:rStyle",
				attributes: { "w:val": "CommentReference" }
			}]
		}, {
			name: "w:commentReference",
			attributes: { "w:id": String(commentIndex) }
		}]
	}];
	if (!(originalComment.threadingStyleOverride === "range-based" || originalComment.threadingMethod === "range-based" || originalComment.originalXmlStructure?.hasCommentsExtended === false)) return commentSchema;
	if (!parentComment?.trackedChange) return commentSchema;
	const trackedChangeType = parentComment.trackedChangeType;
	const wrapperName = type === "commentRangeStart" ? "w:ins" : trackedChangeType === "both" ? "w:del" : trackedChangeType === "trackDelete" ? "w:del" : "w:ins";
	const createdTime = parentComment.createdTime || Date.now();
	const date = new Date(createdTime).toISOString().replace(/\.\d{3}Z$/, "Z");
	return {
		name: wrapperName,
		attributes: {
			"w:id": String(parentComment.commentId),
			...parentComment.creatorName ? { "w:author": parentComment.creatorName } : {},
			...parentComment.creatorEmail ? { "w:authorEmail": parentComment.creatorEmail } : {},
			"w:date": date
		},
		elements: Array.isArray(commentSchema) ? commentSchema : [commentSchema]
	};
};
var getCommentSchema = (type, commentIndex) => {
	return {
		name: `w:${type}`,
		attributes: { "w:id": String(commentIndex) }
	};
};
var getConfig = (type) => {
	const sdName = `${SD_NODE_NAME$21}${type}`;
	const isStart = type === "Start";
	return {
		xmlName: `${XML_NODE_NAME$21}${type}`,
		sdNodeOrKeyName: sdName,
		type: NodeTranslator.translatorTypes.NODE,
		encode: ({ nodes }) => {
			const node = nodes?.[0];
			if (!node) return void 0;
			const attrs = node.attributes ? { ...node.attributes } : {};
			return {
				type: isStart ? "commentRangeStart" : "commentRangeEnd",
				attrs
			};
		},
		decode: decode$32,
		attributes: [attrConfig$11]
	};
};
const commentRangeStartTranslator = NodeTranslator.from(getConfig("Start"));
const commentRangeEndTranslator = NodeTranslator.from(getConfig("End"));
var INLINE_PARENT_NAMES = new Set([
	"w:r",
	"w:hyperlink",
	"w:smartTag",
	"w:fldSimple",
	"w:proofErr",
	"w:del",
	"w:ins",
	"w:p"
]);
var INLINE_NODE_NAMES = new Set([
	"m:oMathPara",
	"m:oMath",
	"m:t",
	"m:r",
	"m:ctrlPr",
	"m:sSupPr",
	"m:e",
	"m:sup",
	"m:sSup"
]);
var BLOCK_BOUNDARY_NAMES = new Set([
	"w:body",
	"w:tbl",
	"w:tc",
	"w:tr"
]);
const isInlineContext = (path = [], currentNodeName) => {
	const immediateName = currentNodeName ?? path[path.length - 1]?.name;
	if (immediateName && INLINE_NODE_NAMES.has(immediateName)) return true;
	if (!Array.isArray(path) || path.length === 0) return false;
	for (let i$1 = path.length - 1; i$1 >= 0; i$1--) {
		const ancestorName = path[i$1]?.name;
		if (!ancestorName) continue;
		if (INLINE_NODE_NAMES.has(ancestorName) || INLINE_PARENT_NAMES.has(ancestorName)) return true;
		if (BLOCK_BOUNDARY_NAMES.has(ancestorName)) return false;
	}
	return false;
};
const encode$31 = (attributes) => {
	return attributes["w:id"];
};
const decode$31 = (attrs) => {
	return attrs.id;
};
const attrConfig$6 = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$31,
	decode: decode$31
});
const encode$30 = (attributes) => {
	return attributes["w:edGrp"];
};
const decode$30 = (attrs) => {
	return attrs.edGrp;
};
const attrConfig$7 = Object.freeze({
	xmlName: "w:edGrp",
	sdName: "edGrp",
	encode: encode$30,
	decode: decode$30
});
const encode$29 = (attributes) => {
	return attributes["w:ed"];
};
const decode$29 = (attrs) => {
	return attrs.ed;
};
const attrConfig$8 = Object.freeze({
	xmlName: "w:ed",
	sdName: "ed",
	encode: encode$29,
	decode: decode$29
});
const encode$28 = (attributes) => {
	return parseInteger$1(attributes["w:colFirst"]);
};
const decode$28 = (attrs) => {
	return integerToString(attrs.colFirst);
};
const attrConfig$9 = Object.freeze({
	xmlName: "w:colFirst",
	sdName: "colFirst",
	encode: encode$28,
	decode: decode$28
});
const encode$27 = (attributes) => {
	return parseInteger$1(attributes["w:colLast"]);
};
const decode$27 = (attrs) => {
	return integerToString(attrs.colLast);
};
var attributes_default$3 = [
	attrConfig$6,
	attrConfig$7,
	attrConfig$8,
	attrConfig$9,
	Object.freeze({
		xmlName: "w:colLast",
		sdName: "colLast",
		encode: encode$27,
		decode: decode$27
	})
];
var XML_NODE_NAME$20 = "w:permStart";
var SD_NODE_NAME$20 = ["permStart", "permStartBlock"];
var encode$26 = (params, encodedAttrs = {}) => {
	const node = params?.nodes?.[0];
	return {
		type: isInlineContext(params?.path || [], node?.name) ? "permStart" : "permStartBlock",
		attrs: encodedAttrs
	};
};
var decode$26 = (params, decodedAttrs = {}) => {
	const result = {
		name: XML_NODE_NAME$20,
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length) result.attributes = decodedAttrs;
	return result;
};
const config$21 = {
	xmlName: XML_NODE_NAME$20,
	sdNodeOrKeyName: SD_NODE_NAME$20,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$26,
	decode: decode$26,
	attributes: attributes_default$3
};
const translator$15 = NodeTranslator.from(config$21);
const encode$25 = (attributes) => {
	return attributes["w:id"];
};
const decode$25 = (attrs) => {
	return attrs.id;
};
const attrConfig$4 = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$25,
	decode: decode$25
});
const encode$24 = (attributes) => {
	return attributes["w:displacedByCustomXml"];
};
const decode$24 = (attrs) => {
	return attrs.displacedByCustomXml;
};
var attributes_default$2 = [attrConfig$4, Object.freeze({
	xmlName: "w:displacedByCustomXml",
	sdName: "displacedByCustomXml",
	encode: encode$24,
	decode: decode$24
})];
var XML_NODE_NAME$19 = "w:permEnd";
var SD_NODE_NAME$19 = ["permEnd", "permEndBlock"];
var encode$23 = (params, encodedAttrs = {}) => {
	const node = params?.nodes?.[0];
	return {
		type: isInlineContext(params?.path || [], node?.name) ? "permEnd" : "permEndBlock",
		attrs: encodedAttrs
	};
};
var decode$23 = (params, decodedAttrs = {}) => {
	const result = {
		name: XML_NODE_NAME$19,
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length) result.attributes = decodedAttrs;
	return result;
};
const config$20 = {
	xmlName: XML_NODE_NAME$19,
	sdNodeOrKeyName: SD_NODE_NAME$19,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$23,
	decode: decode$23,
	attributes: attributes_default$2
};
const translator$16 = NodeTranslator.from(config$20);
const buildInstructionElements = (instruction, instructionTokens) => {
	const tokens = Array.isArray(instructionTokens) ? instructionTokens : [];
	if (tokens.length > 0) return tokens.map((tokenLike) => {
		if (typeof tokenLike === "string") return {
			name: "w:instrText",
			attributes: { "xml:space": "preserve" },
			elements: [{
				type: "text",
				text: tokenLike
			}]
		};
		const token = tokenLike;
		if (token?.type === "tab") return {
			name: "w:tab",
			elements: []
		};
		const text$2 = token?.text ?? "";
		return {
			name: "w:instrText",
			attributes: { "xml:space": "preserve" },
			elements: [{
				type: "text",
				text: text$2
			}]
		};
	});
	return [{
		name: "w:instrText",
		attributes: { "xml:space": "preserve" },
		elements: [{
			type: "text",
			text: instruction ?? ""
		}]
	}];
};
function buildFieldResultRuns(params, outputMarks) {
	const { node } = params;
	const contentNodes = (node.content ?? []).flatMap((child) => exportSchemaToJson({
		...params,
		node: child
	}));
	if (contentNodes.length > 0) return contentNodes;
	const resolvedText = node.attrs?.resolvedText;
	if (typeof resolvedText !== "string" || resolvedText.length === 0) return [];
	const textAttributes = /^\s|\s$/.test(resolvedText) ? { "xml:space": "preserve" } : void 0;
	return [{
		name: "w:r",
		elements: [{
			name: "w:rPr",
			elements: outputMarks
		}, {
			name: "w:t",
			attributes: textAttributes,
			elements: [{
				text: resolvedText,
				type: "text"
			}]
		}]
	}];
}
function wrapParagraphsAsComplexField(contentNodes, instructionElements, wrapperParagraphProperties = null) {
	const beginElements = [
		{
			name: "w:r",
			elements: [{
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" },
				elements: []
			}]
		},
		{
			name: "w:r",
			elements: instructionElements
		},
		{
			name: "w:r",
			elements: [{
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" },
				elements: []
			}]
		}
	];
	if (contentNodes.length > 0) {
		const firstParagraph = contentNodes[0];
		if (wrapperParagraphProperties) {
			const restoredPPr = carbonCopy(wrapperParagraphProperties);
			if (firstParagraph.elements) {
				const pPrIndex = firstParagraph.elements.findIndex((el) => el.name === "w:pPr");
				if (pPrIndex >= 0) firstParagraph.elements.splice(pPrIndex, 1, restoredPPr);
				else firstParagraph.elements.unshift(restoredPPr);
			} else firstParagraph.elements = [restoredPPr];
		}
		let insertIndex = 0;
		if (firstParagraph.elements) {
			const pPrIndex = firstParagraph.elements.findIndex((el) => el.name === "w:pPr");
			insertIndex = pPrIndex >= 0 ? pPrIndex + 1 : 0;
		} else firstParagraph.elements = [];
		firstParagraph.elements.splice(insertIndex, 0, ...beginElements);
	} else contentNodes.push({
		name: "w:p",
		elements: beginElements
	});
	const endElements = [{
		name: "w:r",
		elements: [{
			name: "w:fldChar",
			attributes: { "w:fldCharType": "end" },
			elements: []
		}]
	}];
	const lastParagraph = contentNodes[contentNodes.length - 1];
	if (lastParagraph.elements) lastParagraph.elements.push(...endElements);
	else lastParagraph.elements = [...endElements];
	return contentNodes;
}
var XML_NODE_NAME$18 = "sd:pageReference";
var SD_NODE_NAME$18 = "pageReference";
var encode$22 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements
	});
	return {
		type: "pageReference",
		attrs: {
			instruction: node.attributes?.instruction || "",
			marksAsAttrs: node.marks || [],
			...node.attributes?.instructionTokens ? { instructionTokens: node.attributes.instructionTokens } : {},
			...node.attributes?.bookmarkId ? { bookmarkId: node.attributes.bookmarkId } : {},
			...node.attributes?.hasHyperlinkSwitch ? { hasHyperlinkSwitch: true } : {},
			...node.attributes?.hasRelativePositionSwitch ? { hasRelativePositionSwitch: true } : {},
			...node.attributes?.pageNumberFieldFormat ? { pageNumberFieldFormat: node.attributes.pageNumberFieldFormat } : {},
			...node.attributes?.numericPictureFormat ? { numericPictureFormat: node.attributes.numericPictureFormat } : {},
			...node.attributes?.fieldResultFormat ? { fieldResultFormat: node.attributes.fieldResultFormat } : {},
			...node.attributes?.fieldRunProperties ? { fieldRunProperties: node.attributes.fieldRunProperties } : {}
		},
		content: processedText
	};
};
var decode$22 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = (node.content ?? []).flatMap((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	const instructionRunProperties = resolveInstructionRunProperties(params, outputMarks);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: instructionRunProperties
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
var resolveInstructionRunProperties = (params, outputMarks) => {
	const { node } = params;
	const fieldRunProperties = node.attrs?.fieldRunProperties;
	if (!(node.attrs?.fieldResultFormat === "charformat" && fieldRunProperties && typeof fieldRunProperties === "object" && !Array.isArray(fieldRunProperties) && Object.keys(fieldRunProperties).length > 0)) return outputMarks;
	const fieldRunPropertiesNode = translator$133.decode({
		...params,
		node: { attrs: { runProperties: fieldRunProperties } }
	});
	return Array.isArray(fieldRunPropertiesNode?.elements) ? fieldRunPropertiesNode.elements : outputMarks;
};
const config$19 = {
	xmlName: XML_NODE_NAME$18,
	sdNodeOrKeyName: SD_NODE_NAME$18,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$22,
	decode: decode$22
};
const translator$17 = NodeTranslator.from(config$19);
var XML_NODE_NAME$17 = "sd:crossReference";
var SD_NODE_NAME$17 = "crossReference";
var encode$21 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	return {
		type: SD_NODE_NAME$17,
		attrs: {
			instruction: node.attributes?.instruction || "",
			fieldType: node.attributes?.fieldType || "REF",
			target: parseTarget(node.attributes?.instruction),
			display: parseDisplay(node.attributes?.instruction),
			resolvedText: extractResolvedText$2(processedText),
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$21 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = buildFieldResultRuns(params, outputMarks);
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
function parseTarget(instruction) {
	if (!instruction) return "";
	const parts = instruction.trim().split(/\s+/);
	if (parts.length < 2) return "";
	return parts[1].replace(/^"(.*)"$/, "$1");
}
function parseDisplay(instruction) {
	if (!instruction) return "content";
	if (instruction.includes("\\n")) return "numberOnly";
	if (instruction.includes("\\w")) return "numberFullContext";
	if (instruction.includes("\\p")) return "aboveBelow";
	if (instruction.includes("\\r")) return "paragraphNumber";
	return "content";
}
function extractResolvedText$2(content$2) {
	if (!Array.isArray(content$2)) return "";
	let out = "";
	const walk = (nodes) => {
		for (const node of nodes) {
			if (!node) continue;
			if (node.type === "text") out += node.text || "";
			else if (Array.isArray(node.content)) walk(node.content);
		}
	};
	walk(content$2);
	return out;
}
const config$18 = {
	xmlName: XML_NODE_NAME$17,
	sdNodeOrKeyName: SD_NODE_NAME$17,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$21,
	decode: decode$21
};
const translator$18 = NodeTranslator.from(config$18);
var XML_NODE_NAME$16 = "sd:citation";
var SD_NODE_NAME$16 = "citation";
var encode$20 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	const instruction = node.attributes?.instruction || "";
	const sourceIds = parseCitationSourceIds(instruction);
	return {
		type: SD_NODE_NAME$16,
		attrs: {
			instruction,
			instructionTokens: node.attributes?.instructionTokens || null,
			sourceIds,
			resolvedText: extractResolvedText$1(processedText),
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$20 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = buildFieldResultRuns(params, outputMarks);
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
function parseCitationSourceIds(instruction) {
	const parts = instruction.trim().split(/\s+/);
	const ids = [];
	if (parts.length >= 2) ids.push(parts[1]);
	for (let i$1 = 2; i$1 < parts.length; i$1++) if (parts[i$1] === "\\m" && parts[i$1 + 1]) {
		ids.push(parts[i$1 + 1]);
		i$1++;
	}
	return ids;
}
function extractResolvedText$1(content$2) {
	if (!Array.isArray(content$2)) return "";
	let out = "";
	const walk = (nodes) => {
		for (const node of nodes) {
			if (!node) continue;
			if (node.type === "text") out += node.text || "";
			else if (Array.isArray(node.content)) walk(node.content);
		}
	};
	walk(content$2);
	return out;
}
const config$17 = {
	xmlName: XML_NODE_NAME$16,
	sdNodeOrKeyName: SD_NODE_NAME$16,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$20,
	decode: decode$20
};
const translator$19 = NodeTranslator.from(config$17);
var XML_NODE_NAME$15 = "sd:bibliography";
var SD_NODE_NAME$15 = "bibliography";
var encode$19 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedContent = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	return {
		type: SD_NODE_NAME$15,
		attrs: {
			instruction: node.attributes?.instruction || "",
			instructionTokens: node.attributes?.instructionTokens || null,
			wrapperParagraphProperties: node.attributes?.wrapperParagraphProperties || null
		},
		content: processedContent
	};
};
var decode$19 = (params) => {
	const { node } = params;
	return wrapParagraphsAsComplexField((node.content ?? []).map((n) => exportSchemaToJson({
		...params,
		node: n
	})), buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens ?? null), node.attrs?.wrapperParagraphProperties ?? null);
};
const config$16 = {
	xmlName: XML_NODE_NAME$15,
	sdNodeOrKeyName: SD_NODE_NAME$15,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$19,
	decode: decode$19
};
const translator$20 = NodeTranslator.from(config$16);
var XML_NODE_NAME$14 = "sd:authorityEntry";
var SD_NODE_NAME$14 = "authorityEntry";
var encode$18 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	const instruction = node.attributes?.instruction || "";
	const { longCitation, shortCitation, category, bold, italic } = parseTaInstruction(instruction);
	return {
		type: SD_NODE_NAME$14,
		attrs: {
			instruction,
			instructionTokens: node.attributes?.instructionTokens || null,
			longCitation,
			shortCitation,
			category,
			bold,
			italic,
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$18 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = (node.content ?? []).flatMap((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
function parseTaInstruction(instruction) {
	let longCitation = "";
	let shortCitation = "";
	let category = 0;
	let bold = false;
	let italic = false;
	const longMatch = instruction.match(/\\l\s+"([^"]*)"/);
	if (longMatch) longCitation = longMatch[1];
	const shortMatch = instruction.match(/\\s\s+"([^"]*)"/);
	if (shortMatch) shortCitation = shortMatch[1];
	const categoryMatch = instruction.match(/\\c\s+(\d+)/);
	if (categoryMatch) category = parseInt(categoryMatch[1], 10);
	bold = /\\b(?:\s|$)/.test(instruction);
	italic = /\\i(?:\s|$)/.test(instruction);
	return {
		longCitation,
		shortCitation,
		category,
		bold,
		italic
	};
}
const config$15 = {
	xmlName: XML_NODE_NAME$14,
	sdNodeOrKeyName: SD_NODE_NAME$14,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$18,
	decode: decode$18
};
const translator$21 = NodeTranslator.from(config$15);
var XML_NODE_NAME$13 = "sd:tableOfAuthorities";
var SD_NODE_NAME$13 = "tableOfAuthorities";
var encode$17 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedContent = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	return {
		type: SD_NODE_NAME$13,
		attrs: {
			instruction: node.attributes?.instruction || "",
			instructionTokens: node.attributes?.instructionTokens || null,
			wrapperParagraphProperties: node.attributes?.wrapperParagraphProperties || null
		},
		content: processedContent
	};
};
var decode$17 = (params) => {
	const { node } = params;
	return wrapParagraphsAsComplexField((node.content ?? []).map((n) => exportSchemaToJson({
		...params,
		node: n
	})), buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens), node.attrs?.wrapperParagraphProperties ?? null);
};
const config$14 = {
	xmlName: XML_NODE_NAME$13,
	sdNodeOrKeyName: SD_NODE_NAME$13,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$17,
	decode: decode$17
};
const translator$22 = NodeTranslator.from(config$14);
var TOKEN_PATTERN = /"((?:[^"\\]|\\.)*)"|\\[#*](?=\s|$)|\\[^\s]+|[^\s]+/g;
function parseSeqInstruction(instruction) {
	const rawInstruction = typeof instruction === "string" ? instruction : "";
	const tokens = tokenizeInstruction(rawInstruction);
	const result = createEmptyParse(rawInstruction, tokens[0]?.value ?? "");
	if (extractFieldKeyword(rawInstruction) !== "SEQ") return result;
	let sawSwitch = false;
	for (let index = 1; index < tokens.length; index += 1) {
		const token = tokens[index].value;
		if (!token) continue;
		if (token.startsWith("\\")) {
			sawSwitch = true;
			const attachedValueSwitch = parseAttachedNumericSwitch(token);
			const normalized = (attachedValueSwitch?.switchToken ?? token).toLowerCase();
			if (normalized === "\\n") {
				result.sequenceMode = "next";
				continue;
			}
			if (normalized === "\\c") {
				result.sequenceMode = "current";
				continue;
			}
			if (normalized === "\\h") {
				result.hideResult = true;
				continue;
			}
			if (normalized === "\\r") {
				const value$1 = attachedValueSwitch?.value ?? tokens[index + 1]?.value;
				if (value$1 != null && (attachedValueSwitch || !value$1.startsWith("\\"))) {
					const parsed = parseInteger(value$1);
					if (parsed != null) result.restartNumber = parsed;
					if (!attachedValueSwitch) index += 1;
				}
				continue;
			}
			if (normalized === "\\s") {
				const value$1 = attachedValueSwitch?.value ?? tokens[index + 1]?.value;
				if (value$1 != null && (attachedValueSwitch || !value$1.startsWith("\\"))) {
					const parsed = parseInteger(value$1);
					if (parsed != null && parsed >= 1 && parsed <= 9) result.restartLevel = parsed;
					if (!attachedValueSwitch) index += 1;
				}
				continue;
			}
			const attachedGeneralFormat = parseAttachedGeneralFormatSwitch(token);
			if (normalized === "\\*" || attachedGeneralFormat != null) {
				const value$1 = attachedGeneralFormat ?? tokens[index + 1]?.value;
				if (value$1 != null && (attachedGeneralFormat != null || !value$1.startsWith("\\"))) {
					result.format = value$1;
					result.hasGeneralFormat = true;
					applyGeneralFormat(result, value$1);
					if (attachedGeneralFormat == null) index += 1;
				} else result.unknownSwitches.push(token);
				continue;
			}
			const attachedNumericPicture = parseAttachedNumericPictureSwitch(token);
			if (normalized === "\\#" || attachedNumericPicture != null) {
				const value$1 = attachedNumericPicture ?? tokens[index + 1]?.value;
				if (value$1 != null && (attachedNumericPicture != null || !value$1.startsWith("\\"))) {
					if (result.numericPictureFormat == null) result.numericPictureFormat = { picture: value$1 };
					else result.unknownSwitches.push(token, value$1);
					if (attachedNumericPicture == null) index += 1;
				} else result.unknownSwitches.push(token);
				continue;
			}
			result.unknownSwitches.push(token);
			const value = tokens[index + 1]?.value;
			if (value != null && !value.startsWith("\\")) {
				result.unknownSwitches.push(value);
				index += 1;
			}
			continue;
		}
		if (!result.identifier) {
			result.identifier = normalizeSeqIdentifier(token);
			continue;
		}
		if (!sawSwitch && !result.fieldArgument) result.fieldArgument = token;
	}
	return result;
}
function isSeqInstruction(instruction) {
	return extractFieldKeyword(instruction) === "SEQ";
}
function normalizeSeqIdentifier(identifier) {
	return typeof identifier === "string" ? identifier.trim() : "";
}
function sequenceFieldAttrsFromParsed(parsed) {
	return {
		identifier: parsed.identifier,
		fieldArgument: parsed.fieldArgument,
		sequenceMode: parsed.sequenceMode,
		hideResult: parsed.hideResult,
		restartNumber: parsed.restartNumber,
		restartLevel: parsed.restartLevel,
		format: parsed.hasGeneralFormat ? parsed.format : "ARABIC",
		hasGeneralFormat: parsed.hasGeneralFormat,
		pageNumberFieldFormat: parsed.pageNumberFieldFormat ?? null,
		numericPictureFormat: parsed.numericPictureFormat
	};
}
function tokenizeInstruction(instruction) {
	const tokens = [];
	for (const match of instruction.matchAll(TOKEN_PATTERN)) tokens.push({ value: match[1] !== void 0 ? unescapeQuotedToken(match[1]) : match[0] });
	return tokens;
}
function createEmptyParse(instruction, keyword) {
	return {
		instruction,
		keyword,
		identifier: "",
		fieldArgument: "",
		sequenceMode: "next",
		hideResult: false,
		restartNumber: null,
		restartLevel: null,
		format: "Arabic",
		numericPictureFormat: null,
		hasGeneralFormat: false,
		unknownSwitches: []
	};
}
function parseInteger(value) {
	const number = Number(value);
	if (!Number.isFinite(number) || !Number.isInteger(number)) return null;
	return Math.trunc(number);
}
function parseAttachedNumericSwitch(token) {
	const match = /^\\([rRsS])([+-]?\d+(?:\.\d+)?)$/.exec(token);
	if (!match) return null;
	return {
		switchToken: `\\${match[1]}`,
		value: match[2]
	};
}
function parseAttachedGeneralFormatSwitch(token) {
	return normalizeAttachedSwitchValue(/^\\\*(\S+)$/.exec(token)?.[1]);
}
function parseAttachedNumericPictureSwitch(token) {
	return normalizeAttachedSwitchValue(/^\\#(\S+)$/.exec(token)?.[1]);
}
function normalizeAttachedSwitchValue(value) {
	if (value == null) return null;
	if (value.startsWith("\"") && value.endsWith("\"")) return unescapeQuotedToken(value.slice(1, -1));
	return value;
}
function applyGeneralFormat(result, value) {
	const mapped = GENERAL_FORMATS.get(value) ?? CASE_INSENSITIVE_GENERAL_FORMATS.get(value.toLowerCase());
	if (mapped) result.pageNumberFieldFormat = { format: mapped };
}
function unescapeQuotedToken(value) {
	return value.replace(/\\(["\\])/g, "$1");
}
var XML_NODE_NAME$12 = "sd:sequenceField";
var SD_NODE_NAME$12 = "sequenceField";
var encode$16 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	const instruction = node.attributes?.instruction || "";
	const parsedAttrs = sequenceFieldAttrsFromParsed(parseSeqInstruction(instruction));
	return {
		type: SD_NODE_NAME$12,
		attrs: {
			instruction,
			instructionTokens: node.attributes?.instructionTokens || null,
			...parsedAttrs,
			resolvedNumber: extractResolvedText(processedText),
			resolvedNumberIsCurrent: false,
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$16 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = buildResultContentNodes(params, outputMarks);
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
function buildResultContentNodes(params, outputMarks) {
	const { node } = params;
	const resolvedNumber = node.attrs?.resolvedNumber;
	if (node.attrs?.resolvedNumberIsCurrent === true) return typeof resolvedNumber === "string" && resolvedNumber.length > 0 ? [buildResolvedNumberRun(resolvedNumber, outputMarks)] : [];
	if (Array.isArray(node.content) && node.content.length > 0) return node.content.flatMap((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	return typeof resolvedNumber === "string" && resolvedNumber.length > 0 ? [buildResolvedNumberRun(resolvedNumber, outputMarks)] : [];
}
function buildResolvedNumberRun(text$2, outputMarks) {
	return {
		name: "w:r",
		elements: [{
			name: "w:rPr",
			elements: outputMarks
		}, {
			name: "w:t",
			elements: [{
				type: "text",
				text: text$2
			}]
		}]
	};
}
function extractResolvedText(content$2) {
	if (!Array.isArray(content$2)) return "";
	let text$2 = "";
	for (const node of content$2) {
		if (!node) continue;
		if (node.type === "text") text$2 += node.text || "";
		if (Array.isArray(node.content)) text$2 += extractResolvedText(node.content);
	}
	return text$2;
}
const config$13 = {
	xmlName: XML_NODE_NAME$12,
	sdNodeOrKeyName: SD_NODE_NAME$12,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$16,
	decode: decode$16
};
const translator$23 = NodeTranslator.from(config$13);
var XML_NODE_NAME$11 = "sd:tableOfContents";
var SD_NODE_NAME$11 = "tableOfContents";
function deriveRightAlignPageNumbers(content$2) {
	for (const para of content$2) {
		const tabStops = para?.attrs?.paragraphProperties?.tabStops;
		if (!Array.isArray(tabStops) || tabStops.length === 0) continue;
		return tabStops.some((ts) => ts?.tab?.tabType === "right");
	}
	return true;
}
var encode$15 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const normalizedContent = (nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	}) || []).reduce((acc, child) => {
		if (!child || !child.type) return acc;
		if (child.type === "paragraph") acc.push(child);
		else acc.push({
			type: "paragraph",
			content: [child]
		});
		return acc;
	}, []);
	return {
		type: "tableOfContents",
		attrs: {
			instruction: node.attributes?.instruction || "",
			rightAlignPageNumbers: deriveRightAlignPageNumbers(normalizedContent)
		},
		content: normalizedContent
	};
};
var decode$15 = (params) => {
	const { node } = params;
	const contentNodes = (Array.isArray(node.content) ? node.content : []).map((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	const tocBeginElements = [
		{
			name: "w:r",
			elements: [{
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" },
				elements: []
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:instrText",
				attributes: { "xml:space": "preserve" },
				elements: [{
					text: node.attrs?.instruction || "",
					type: "text",
					name: "#text",
					elements: []
				}]
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" },
				elements: []
			}]
		}
	];
	if (contentNodes.length > 0) {
		const firstParagraph = contentNodes[0];
		let insertIndex = 0;
		if (firstParagraph.elements) {
			const pPrIndex = firstParagraph.elements.findIndex((el) => el.name === "w:pPr");
			insertIndex = pPrIndex >= 0 ? pPrIndex + 1 : 0;
		} else firstParagraph.elements = [];
		firstParagraph.elements.splice(insertIndex, 0, ...tocBeginElements);
	} else contentNodes.push({
		name: "w:p",
		elements: tocBeginElements
	});
	const tocEndElements = [{
		name: "w:r",
		elements: [{
			name: "w:fldChar",
			attributes: { "w:fldCharType": "end" },
			elements: []
		}]
	}];
	const lastParagraph = contentNodes[contentNodes.length - 1];
	if (lastParagraph.elements) lastParagraph.elements.push(...tocEndElements);
	else lastParagraph.elements = [...tocEndElements];
	return contentNodes;
};
const config$12 = {
	xmlName: XML_NODE_NAME$11,
	sdNodeOrKeyName: SD_NODE_NAME$11,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$15,
	decode: decode$15
};
const translator$24 = NodeTranslator.from(config$12);
var XML_NODE_NAME$10 = "sd:index";
var SD_NODE_NAME$10 = "index";
var encode$14 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedContent = nodeListHandler.handler({
		...params,
		nodes: node.elements || []
	});
	return {
		type: "index",
		attrs: {
			instruction: node.attributes?.instruction || "",
			instructionTokens: node.attributes?.instructionTokens || null,
			wrapperParagraphProperties: node.attributes?.wrapperParagraphProperties || null
		},
		content: processedContent
	};
};
var decode$14 = (params) => {
	const { node } = params;
	return wrapParagraphsAsComplexField((node.content ?? []).map((n) => exportSchemaToJson({
		...params,
		node: n
	})), buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens), node.attrs?.wrapperParagraphProperties ?? null);
};
const config$11 = {
	xmlName: XML_NODE_NAME$10,
	sdNodeOrKeyName: SD_NODE_NAME$10,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$14,
	decode: decode$14
};
const translator$25 = NodeTranslator.from(config$11);
var XML_NODE_NAME$9 = "sd:indexEntry";
var SD_NODE_NAME$9 = "indexEntry";
var encode$13 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements
	});
	return {
		type: "indexEntry",
		attrs: {
			instruction: node.attributes?.instruction || "",
			instructionTokens: node.attributes?.instructionTokens || null,
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$13 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = (node.content ?? []).flatMap((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
const config$10 = {
	xmlName: XML_NODE_NAME$9,
	sdNodeOrKeyName: SD_NODE_NAME$9,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$13,
	decode: decode$13
};
const translator$26 = NodeTranslator.from(config$10);
var PAGE_VALUE_FORMAT_SWITCHES = {
	Arabic: "decimal",
	Roman: "upperRoman",
	ROMAN: "upperRoman",
	roman: "lowerRoman",
	ALPHABETIC: "upperLetter",
	alphabetic: "lowerLetter",
	ArabicDash: "numberInDash"
};
function pageNumberFormatToInstructionSwitch(pageNumberFormat) {
	for (const [switchName, format] of Object.entries(PAGE_VALUE_FORMAT_SWITCHES)) if (format === pageNumberFormat) return switchName;
}
var XML_NODE_NAME$8 = "sd:autoPageNumber";
var SD_NODE_NAME$8 = "page-number";
var encode$12 = (params) => {
	const { nodes = [] } = params || {};
	const node = nodes[0];
	const rPr = node.elements?.find((el) => el.name === "w:rPr");
	const processedNode = {
		type: "page-number",
		attrs: {
			marksAsAttrs: parseMarks(rPr || { elements: [] }),
			...getPageNumberFieldAttrs$1(node)
		}
	};
	if (typeof node.attributes?.instruction === "string") processedNode.attrs.instruction = node.attributes.instruction;
	if (typeof node.attributes?.pageNumberFormat === "string") processedNode.attrs.pageNumberFormat = node.attributes.pageNumberFormat;
	return processedNode;
};
var decode$12 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const instruction = getPageInstructionText(node.attrs);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:instrText",
				attributes: { "xml:space": "preserve" },
				elements: [{
					type: "text",
					text: ` ${instruction}`
				}]
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
function getPageNumberFieldAttrs$1(node) {
	const attrs = {};
	if (node.attributes?.instruction) attrs.instruction = node.attributes.instruction;
	if (node.attributes?.pageNumberFormat) attrs.pageNumberFormat = node.attributes.pageNumberFormat;
	if (node.attributes?.pageNumberZeroPadding != null) attrs.pageNumberZeroPadding = Number(node.attributes.pageNumberZeroPadding);
	return attrs;
}
function getPageInstructionText(attrs = {}) {
	if (typeof attrs.instruction === "string" && attrs.instruction.trim()) return attrs.instruction.trim();
	if (typeof attrs.pageNumberFormat === "string") {
		const instructionSwitch = pageNumberFormatToInstructionSwitch(attrs.pageNumberFormat);
		if (instructionSwitch) return `PAGE \\* ${instructionSwitch}${typeof attrs.pageNumberZeroPadding === "number" && attrs.pageNumberZeroPadding > 0 ? ` \\# ${"0".repeat(attrs.pageNumberZeroPadding)}` : ""}`;
	}
	if (typeof attrs.pageNumberZeroPadding === "number" && attrs.pageNumberZeroPadding > 0) return `PAGE \\# ${"0".repeat(attrs.pageNumberZeroPadding)}`;
	return "PAGE";
}
const config$9 = {
	xmlName: XML_NODE_NAME$8,
	sdNodeOrKeyName: SD_NODE_NAME$8,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$12,
	decode: decode$12
};
const translator$27 = NodeTranslator.from(config$9);
function buildComplexFieldRuns({ instruction, cachedText, outputMarks, dirty }) {
	const beginAttrs = { "w:fldCharType": "begin" };
	if (dirty) beginAttrs["w:dirty"] = "true";
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: beginAttrs
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:instrText",
				attributes: { "xml:space": "preserve" },
				elements: [{
					type: "text",
					text: ` ${instruction}`
				}]
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:t",
				attributes: { "xml:space": "preserve" },
				elements: [{
					type: "text",
					text: cachedText
				}]
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
}
var XML_NODE_NAME$7 = "sd:totalPageNumber";
var SD_NODE_NAME$7 = "total-page-number";
var encode$11 = (params) => {
	const { nodes = [] } = params || {};
	const node = nodes[0];
	const rPr = node.elements?.find((el) => el.name === "w:rPr");
	return {
		type: "total-page-number",
		attrs: {
			marksAsAttrs: parseMarks(rPr || { elements: [] }),
			importedCachedText: node.attributes?.importedCachedText || null,
			...getPageNumberFieldAttrs(node)
		}
	};
};
var decode$11 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const cachedText = resolveCachedPageCount(params, node);
	const dirty = !params.statFieldCacheMap?.has?.("NUMPAGES");
	return buildComplexFieldRuns({
		instruction: node.attrs?.instruction || "NUMPAGES",
		cachedText,
		outputMarks,
		dirty
	});
};
function getPageNumberFieldAttrs(node) {
	const attrs = {};
	if (node.attributes?.instruction) attrs.instruction = node.attributes.instruction;
	if (node.attributes?.pageNumberFormat) attrs.pageNumberFormat = node.attributes.pageNumberFormat;
	if (node.attributes?.pageNumberZeroPadding != null) attrs.pageNumberZeroPadding = Number(node.attributes.pageNumberZeroPadding);
	if (node.attributes?.pageNumberNumericPicture) attrs.pageNumberNumericPicture = node.attributes.pageNumberNumericPicture;
	return attrs;
}
function resolveCachedPageCount(params, node) {
	const cacheMap = params.statFieldCacheMap;
	if (cacheMap?.has?.("NUMPAGES")) {
		const pageCount = Number(cacheMap.get("NUMPAGES"));
		if (node.attrs?.pageNumberFormat || node.attrs?.pageNumberZeroPadding || node.attrs?.pageNumberNumericPicture) return formatPageNumberFieldValue$1(pageCount, node.attrs);
		return String(cacheMap.get("NUMPAGES"));
	}
	if (node.attrs?.resolvedText) return String(node.attrs.resolvedText);
	if (node.attrs?.importedCachedText) return String(node.attrs.importedCachedText);
	return node.content?.filter((n) => n.type === "text").map((n) => n.text || "").join("") || "";
}
const config$8 = {
	xmlName: XML_NODE_NAME$7,
	sdNodeOrKeyName: SD_NODE_NAME$7,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$11,
	decode: decode$11
};
const translator$28 = NodeTranslator.from(config$8);
var XML_NODE_NAME$6 = "sd:sectionPageCount";
var SD_NODE_NAME$6 = "section-page-count";
var encode$10 = (params) => {
	const { nodes = [] } = params || {};
	const node = nodes[0];
	const rPr = node.elements?.find((el) => el.name === "w:rPr");
	const processedNode = {
		type: "section-page-count",
		attrs: { marksAsAttrs: parseMarks(rPr || { elements: [] }) }
	};
	if (typeof node.attributes?.instruction === "string") processedNode.attrs.instruction = node.attributes.instruction;
	if (typeof node.attributes?.pageNumberFormat === "string") processedNode.attrs.pageNumberFormat = node.attributes.pageNumberFormat;
	if (node.attributes?.pageNumberZeroPadding != null) processedNode.attrs.pageNumberZeroPadding = Number(node.attributes.pageNumberZeroPadding);
	if (node.attributes?.importedCachedText) processedNode.attrs.importedCachedText = node.attributes.importedCachedText;
	return processedNode;
};
var decode$10 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	return buildComplexFieldRuns({
		instruction: getSectionPagesInstructionText(node.attrs),
		cachedText: resolveCachedSectionPageCount(node),
		outputMarks,
		dirty: true
	});
};
function getSectionPagesInstructionText(attrs = {}) {
	if (typeof attrs.instruction === "string" && attrs.instruction.trim()) return attrs.instruction.trim();
	if (typeof attrs.pageNumberFormat === "string") {
		const instructionSwitch = pageNumberFormatToInstructionSwitch(attrs.pageNumberFormat);
		if (instructionSwitch) return `SECTIONPAGES \\* ${instructionSwitch}${typeof attrs.pageNumberZeroPadding === "number" && attrs.pageNumberZeroPadding > 0 ? ` \\# ${"0".repeat(attrs.pageNumberZeroPadding)}` : ""}`;
	}
	if (typeof attrs.pageNumberZeroPadding === "number" && attrs.pageNumberZeroPadding > 0) return `SECTIONPAGES \\# ${"0".repeat(attrs.pageNumberZeroPadding)}`;
	return "SECTIONPAGES";
}
function resolveCachedSectionPageCount(node) {
	if (node.attrs?.resolvedText) return String(node.attrs.resolvedText);
	if (node.attrs?.importedCachedText) return String(node.attrs.importedCachedText);
	return node.content?.filter((n) => n.type === "text").map((n) => n.text || "").join("") || "";
}
const config$7 = {
	xmlName: XML_NODE_NAME$6,
	sdNodeOrKeyName: SD_NODE_NAME$6,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$10,
	decode: decode$10
};
const translator$29 = NodeTranslator.from(config$7);
var XML_NODE_NAME$5 = "sd:documentStatField";
var SD_NODE_NAME$5 = "documentStatField";
var encode$9 = (params) => {
	const { nodes = [] } = params || {};
	const node = nodes[0];
	const instruction = node.attributes?.instruction || "";
	const resolvedText = extractCachedText(node.elements || []);
	const rPr = node.elements?.find((el) => el.name === "w:rPr");
	return {
		type: SD_NODE_NAME$5,
		attrs: {
			instruction,
			resolvedText,
			marksAsAttrs: parseMarks(rPr || { elements: [] })
		}
	};
};
var decode$9 = (params) => {
	const { node } = params;
	const instruction = node.attrs?.instruction || "";
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	return buildComplexFieldRuns({
		instruction,
		cachedText: resolveCachedText(params.statFieldCacheMap, node),
		outputMarks,
		dirty: hasUninterpretedSwitches(instruction)
	});
};
function extractCachedText(elements) {
	const texts = [];
	for (const el of elements) {
		if (el.name === "w:rPr") continue;
		const textNode = el.elements?.find((child) => child.name === "w:t");
		if (textNode) {
			const text$2 = textNode.elements?.[0]?.text ?? "";
			texts.push(text$2);
		}
	}
	return texts.join("");
}
function resolveCachedText(cacheMap, node) {
	if (cacheMap) {
		const fieldType = (node.attrs?.instruction || "").trim().split(/\s+/)[0]?.toUpperCase();
		if (fieldType && cacheMap.has?.(fieldType)) return cacheMap.get(fieldType);
	}
	return node.attrs?.resolvedText ?? "";
}
function hasUninterpretedSwitches(instruction) {
	return /\\[*#@]/.test(instruction);
}
const config$6 = {
	xmlName: XML_NODE_NAME$5,
	sdNodeOrKeyName: SD_NODE_NAME$5,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$9,
	decode: decode$9
};
const translator$30 = NodeTranslator.from(config$6);
function parseInlineStyles(styleString) {
	if (!styleString) return {};
	return styleString.split(";").filter((style) => !!style.trim()).reduce((acc, style) => {
		const [prop, value] = style.split(":").map((str) => str.trim());
		if (prop && value) acc[prop] = value;
		return acc;
	}, {});
}
function handleVRectImport({ pict }) {
	const rect = pict.elements?.find((el) => el.name === "v:rect");
	if (!rect) return null;
	const schemaAttrs = {};
	const rectAttrs = rect.attributes || {};
	schemaAttrs.attributes = rectAttrs;
	if (rectAttrs.style) {
		const parsedStyle = parseInlineStyles(rectAttrs.style);
		const rectStyle = buildVRectStyles(parsedStyle);
		if (rectStyle) schemaAttrs.style = rectStyle;
		const size = {};
		const isFullWidthHR = rectAttrs["o:hr"] === "t" || rectAttrs["o:hrstd"] === "t";
		if (parsedStyle.width !== void 0) if (isFullWidthHR) size.width = "100%";
		else size.width = parsePointsToPixels(parsedStyle.width);
		if (parsedStyle.height !== void 0) size.height = parsePointsToPixels(parsedStyle.height);
		if (Object.keys(size).length > 0) schemaAttrs.size = size;
	}
	if (rectAttrs.fillcolor) schemaAttrs.background = rectAttrs.fillcolor;
	const vmlAttrs = {};
	if (rectAttrs["o:hralign"]) vmlAttrs.hralign = rectAttrs["o:hralign"];
	if (rectAttrs["o:hrstd"]) vmlAttrs.hrstd = rectAttrs["o:hrstd"];
	if (rectAttrs["o:hr"]) vmlAttrs.hr = rectAttrs["o:hr"];
	if (rectAttrs.stroked) vmlAttrs.stroked = rectAttrs.stroked;
	if (Object.keys(vmlAttrs).length > 0) schemaAttrs.vmlAttributes = vmlAttrs;
	if (rectAttrs["o:hr"] === "t" || rectAttrs["o:hrstd"] === "t") schemaAttrs.horizontalRule = true;
	return [{
		type: "contentBlock",
		attrs: schemaAttrs
	}];
}
function parsePointsToPixels(value) {
	if (typeof value !== "string") return value;
	if (value.endsWith("pt")) {
		const val = value.replace("pt", "");
		if (isNaN(Number(val))) return 0;
		const points = parseFloat(val);
		return Math.ceil(points * 1.33);
	}
	if (value.endsWith("px")) {
		const val = value.replace("px", "");
		if (isNaN(Number(val))) return 0;
		return parseInt(val, 10);
	}
	const numValue = parseFloat(value);
	return isNaN(numValue) ? 0 : numValue;
}
function buildVRectStyles(styleObject) {
	let style = "";
	for (const [prop, value] of Object.entries(styleObject)) style += `${prop}: ${value};`;
	return style;
}
var import_lib$1 = /* @__PURE__ */ __toESM(require_lib(), 1);
var defaultInitialXml = `<w:document xmlns:wpc="http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas" xmlns:cx="http://schemas.microsoft.com/office/drawing/2014/chartex" xmlns:cx1="http://schemas.microsoft.com/office/drawing/2015/9/8/chartex" xmlns:cx2="http://schemas.microsoft.com/office/drawing/2015/10/21/chartex" xmlns:cx3="http://schemas.microsoft.com/office/drawing/2016/5/9/chartex" xmlns:cx4="http://schemas.microsoft.com/office/drawing/2016/5/10/chartex" xmlns:cx5="http://schemas.microsoft.com/office/drawing/2016/5/11/chartex" xmlns:cx6="http://schemas.microsoft.com/office/drawing/2016/5/12/chartex" xmlns:cx7="http://schemas.microsoft.com/office/drawing/2016/5/13/chartex" xmlns:cx8="http://schemas.microsoft.com/office/drawing/2016/5/14/chartex" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:aink="http://schemas.microsoft.com/office/drawing/2016/ink" xmlns:am3d="http://schemas.microsoft.com/office/drawing/2017/model3d" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:oel="http://schemas.microsoft.com/office/2019/extlst" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:wp14="http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" xmlns:wpg="http://schemas.microsoft.com/office/word/2010/wordprocessingGroup" xmlns:wpi="http://schemas.microsoft.com/office/word/2010/wordprocessingInk" xmlns:wne="http://schemas.microsoft.com/office/word/2006/wordml" xmlns:wps="http://schemas.microsoft.com/office/word/2010/wordprocessingShape" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh wp14"><w:body></w:body></w:document>`;
const parseXmlToJson = (xml) => {
	return JSON.parse(import_lib$1.xml2json(xml, null, 2));
};
const getInitialJSON = (parsedDocx, fallbackXml = defaultInitialXml) => {
	return parsedDocx["word/document.xml"] || parseXmlToJson(fallbackXml);
};
const handleDrawingNode = (params) => {
	const { nodes } = params;
	if (nodes.length === 0 || !["w:drawing", "w:p"].includes(nodes[0].name)) return {
		nodes: [],
		consumed: 0
	};
	const mainNode = nodes[0];
	let node;
	if (mainNode.name === "w:drawing") node = mainNode;
	else node = mainNode.elements.find((el) => el.name === "w:drawing");
	if (!node) return {
		nodes: [],
		consumed: 0
	};
	const translatorParams = {
		...params,
		nodes: [node]
	};
	const schemaNode = translator$12.encode(translatorParams);
	return {
		nodes: schemaNode ? [schemaNode] : [],
		consumed: 1
	};
};
const drawingNodeHandlerEntity = {
	handlerName: "drawingNodeHandler",
	handler: handleDrawingNode
};
var unwrapTrackChangeNode = (node) => {
	if (!node) return null;
	if (isTranslatedTrackChangeElement(node)) return node;
	if (node.name === "w:sdt") {
		const content$2 = node.elements?.find((element) => element.name === "w:sdtContent");
		if (!content$2?.elements?.length) return null;
		for (const child of content$2.elements) {
			const trackChange = unwrapTrackChangeNode(child);
			if (trackChange) return trackChange;
		}
	}
	return null;
};
const handleTrackChangeNode = (params) => {
	const { nodes } = params;
	if (nodes.length === 0) return {
		nodes: [],
		consumed: 0
	};
	const mainNode = unwrapTrackChangeNode(nodes[0]);
	if (!mainNode) return {
		nodes: [],
		consumed: 0
	};
	let result;
	const translatorParams = {
		...params,
		nodes: [mainNode]
	};
	switch (mainNode.name) {
		case "w:del":
			result = translator$59.encode({
				...translatorParams,
				extraParams: {
					...translatorParams.extraParams,
					node: mainNode
				}
			});
			break;
		case "w:ins":
			result = translator$84.encode({
				...translatorParams,
				extraParams: {
					...translatorParams.extraParams,
					node: mainNode
				}
			});
			break;
	}
	return {
		nodes: result,
		consumed: 1
	};
};
const trackChangeNodeHandlerEntity = {
	handlerName: "trackChangeNodeHandler",
	handler: handleTrackChangeNode
};
const hyperlinkNodeHandlerEntity = generateV2HandlerEntity("hyperlinkNodeHandler", translator$78);
const runNodeHandlerEntity = generateV2HandlerEntity("runNodeHandler", translator$6);
var XML_NODE_NAME$4 = "w:t";
var SD_NODE_NAME$4 = "text";
var validXmlAttributes$1 = [createAttributeHandler("xml:space", "xmlSpace")];
var encode$8 = (params, encodedAttrs = {}) => {
	const { node } = params.extraParams;
	const { elements, type, attributes } = node;
	let text$2;
	if (!elements) return null;
	if (elements.length === 1) {
		text$2 = elements[0].text;
		const docXmlSpace = params.converter?.documentAttributes?.["xml:space"];
		const xmlSpace = encodedAttrs.xmlSpace ?? attributes?.["xml:space"] ?? elements[0]?.attributes?.["xml:space"] ?? docXmlSpace;
		if (xmlSpace !== "preserve" && typeof text$2 === "string") text$2 = text$2.replace(/^[ \t\n\r]+/, "").replace(/[ \t\n\r]+$/, "");
		text$2 = text$2.replace(/\[\[sdspace\]\]/g, "");
		const isWhitespaceOnly = /^[ \t\n\r]*$/.test(text$2);
		if (xmlSpace !== "preserve" && isWhitespaceOnly) return null;
	} else if (!elements.length && encodedAttrs.xmlSpace === "preserve") text$2 = " ";
	else return null;
	return {
		type: "text",
		text: text$2,
		attrs: {
			type,
			attributes: attributes || {}
		},
		marks: []
	};
};
var decode$8 = (params) => {
	const { node, extraParams } = params;
	if (!node || !node.type) return null;
	const trackedMarks = ["trackDelete", "trackInsert"];
	const trackedMark = node.marks?.find((m) => trackedMarks.includes(m.type));
	if (trackedMark) switch (trackedMark.type) {
		case "trackDelete": return translator$59.decode(params);
		case "trackInsert": return translator$84.decode(params);
	}
	if (node.marks?.some((m) => m.type === "link") && !extraParams?.linkProcessed) return translator$78.decode(params);
	const { text: text$2, marks = [] } = node;
	return getTextNodeForExport(text$2, marks, params);
};
const config$5 = {
	xmlName: XML_NODE_NAME$4,
	sdNodeOrKeyName: SD_NODE_NAME$4,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$8,
	decode: decode$8,
	attributes: validXmlAttributes$1
};
const translator$32 = NodeTranslator.from(config$5);
const handleTextNode = (params) => {
	const { nodes, insideTrackChange } = params;
	if (nodes.length === 0 || !(nodes[0].name === "w:t" || insideTrackChange && nodes[0].name === "w:delText")) return {
		nodes: [],
		consumed: 0
	};
	const node = nodes[0];
	const resultNode = translator$32.encode({
		...params,
		extraParams: {
			...params.extraParams || {},
			node
		}
	});
	if (!resultNode) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [resultNode],
		consumed: 1
	};
};
const textNodeHandlerEntity = {
	handlerName: "textNodeHandler",
	handler: handleTextNode
};
const handleSdtNode = (params) => {
	const { nodes } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:sdt") return {
		nodes: [],
		consumed: 0
	};
	const result = translator$9.encode(params);
	if (!result) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: Array.isArray(result) ? result : [result],
		consumed: 1
	};
};
const sdtNodeHandlerEntity = {
	handlerName: "sdtNodeHandler",
	handler: handleSdtNode
};
var XML_NODE_NAME$3 = "sd:tableOfContentsEntry";
var SD_NODE_NAME$3 = "tableOfContentsEntry";
var encode$7 = (params) => {
	const { nodes = [], nodeListHandler } = params || {};
	const node = nodes[0];
	const processedText = nodeListHandler.handler({
		...params,
		nodes: node.elements
	});
	return {
		type: "tableOfContentsEntry",
		attrs: {
			instruction: node.attributes?.instruction || "",
			instructionTokens: node.attributes?.instructionTokens || null,
			marksAsAttrs: node.marks || []
		},
		content: processedText
	};
};
var decode$7 = (params) => {
	const { node } = params;
	const outputMarks = processOutputMarks(node.attrs?.marksAsAttrs || []);
	const contentNodes = (node.content ?? []).flatMap((n) => exportSchemaToJson({
		...params,
		node: n
	}));
	const instructionElements = buildInstructionElements(node.attrs?.instruction, node.attrs?.instructionTokens);
	return [
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "begin" }
			}]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, ...instructionElements]
		},
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "separate" }
			}]
		},
		...contentNodes,
		{
			name: "w:r",
			elements: [{
				name: "w:rPr",
				elements: outputMarks
			}, {
				name: "w:fldChar",
				attributes: { "w:fldCharType": "end" }
			}]
		}
	];
};
const config$4 = {
	xmlName: XML_NODE_NAME$3,
	sdNodeOrKeyName: SD_NODE_NAME$3,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$7,
	decode: decode$7
};
const translator$38 = NodeTranslator.from(config$4);
const translator$42 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:autoRedefine"));
const translator$45 = NodeTranslator.from(createSingleAttrPropertyHandler("w:aliases"));
const translator$47 = NodeTranslator.from(createSingleAttrPropertyHandler("w:basedOn"));
const encode$6 = (attributes) => {
	return attributes?.["w:id"];
};
const decode$6 = (attrs) => {
	return attrs?.id;
};
const attrConfig$2 = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$6,
	decode: decode$6
});
const encode$5 = (attributes) => {
	const val = attributes?.["w:customMarkFollows"];
	return val === "1" || val === "true" || val === true ? true : void 0;
};
const decode$5 = (attrs) => {
	return attrs?.customMarkFollows ? "1" : void 0;
};
const attrConfig$3 = Object.freeze({
	xmlName: "w:customMarkFollows",
	sdName: "customMarkFollows",
	encode: encode$5,
	decode: decode$5
});
var XML_NODE_NAME$2 = "w:footnoteReference";
var SD_NODE_NAME$2 = "footnoteReference";
var encode$4 = (_, encodedAttrs) => {
	const translated = { type: SD_NODE_NAME$2 };
	if (encodedAttrs && Object.keys(encodedAttrs).length > 0) translated.attrs = { ...encodedAttrs };
	return translated;
};
var decode$4 = (_params, decodedAttrs) => {
	const ref$1 = {
		name: XML_NODE_NAME$2,
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length > 0) ref$1.attributes = { ...decodedAttrs };
	return ref$1;
};
const config$3 = {
	xmlName: XML_NODE_NAME$2,
	sdNodeOrKeyName: SD_NODE_NAME$2,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$4,
	decode: decode$4,
	attributes: [attrConfig$2, attrConfig$3]
};
const translator$33 = NodeTranslator.from(config$3);
const encode$3 = (attributes) => {
	return attributes?.["w:id"];
};
const decode$3 = (attrs) => {
	return attrs?.id;
};
const attrConfig = Object.freeze({
	xmlName: "w:id",
	sdName: "id",
	encode: encode$3,
	decode: decode$3
});
const encode$2 = (attributes) => {
	const val = attributes?.["w:customMarkFollows"];
	return val === "1" || val === "true" || val === true ? true : void 0;
};
const decode$2 = (attrs) => {
	return attrs?.customMarkFollows ? "1" : void 0;
};
const attrConfig$1 = Object.freeze({
	xmlName: "w:customMarkFollows",
	sdName: "customMarkFollows",
	encode: encode$2,
	decode: decode$2
});
var XML_NODE_NAME$1 = "w:endnoteReference";
var SD_NODE_NAME$1 = "endnoteReference";
var encode$1 = (_, encodedAttrs) => {
	const translated = { type: SD_NODE_NAME$1 };
	if (encodedAttrs && Object.keys(encodedAttrs).length > 0) translated.attrs = { ...encodedAttrs };
	return translated;
};
var decode$1 = (_params, decodedAttrs) => {
	const ref$1 = {
		name: XML_NODE_NAME$1,
		elements: []
	};
	if (decodedAttrs && Object.keys(decodedAttrs).length > 0) ref$1.attributes = { ...decodedAttrs };
	return ref$1;
};
const config$2 = {
	xmlName: XML_NODE_NAME$1,
	sdNodeOrKeyName: SD_NODE_NAME$1,
	type: NodeTranslator.translatorTypes.NODE,
	encode: encode$1,
	decode: decode$1,
	attributes: [attrConfig, attrConfig$1]
};
const translator$37 = NodeTranslator.from(config$2);
const translator$61 = NodeTranslator.from({
	xmlName: "w:docDefaults",
	sdNodeOrKeyName: "docDefaults",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [],
	encode: (params) => {
		const { nodes } = params;
		const node = nodes[0];
		const result = {};
		[{
			wrapperName: "w:rPrDefault",
			propertyName: "runProperties",
			translator: translator$133
		}, {
			wrapperName: "w:pPrDefault",
			propertyName: "paragraphProperties",
			translator: translator$129
		}].forEach(({ wrapperName, propertyName, translator: translator$220 }) => {
			const propertyElement = (node.elements?.find((el) => el.name === wrapperName))?.elements?.find((el) => el.name === wrapperName.replace("Default", ""));
			if (propertyElement) {
				const props = translator$220.encode({
					...params,
					nodes: [propertyElement]
				});
				if (props) result[propertyName] = props;
			}
		});
		return Object.keys(result).length > 0 ? result : void 0;
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["docDefaults"];
		if (!currentValue) return;
		const elements = [];
		[{
			wrapperName: "w:rPrDefault",
			propertyName: "runProperties",
			translator: translator$133
		}, {
			wrapperName: "w:pPrDefault",
			propertyName: "paragraphProperties",
			translator: translator$129
		}].forEach(({ wrapperName, propertyName, translator: translator$220 }) => {
			const propertyValue = currentValue[propertyName];
			if (propertyValue) {
				const decodedProperty = translator$220.decode({
					...params,
					node: { attrs: { [propertyName]: propertyValue } }
				});
				if (decodedProperty) elements.push({
					name: wrapperName,
					type: "element",
					elements: [decodedProperty]
				});
			}
		});
		if (elements.length === 0) return;
		return {
			name: "w:docDefaults",
			type: "element",
			attributes: {},
			elements
		};
	}
});
const translator$107 = NodeTranslator.from({
	xmlName: "w:lsdException",
	sdNodeOrKeyName: "lsdException",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [
		createAttributeHandler("w:name"),
		createBooleanAttributeHandler("w:locked"),
		createBooleanAttributeHandler("w:qFormat"),
		createBooleanAttributeHandler("w:semiHidden"),
		createBooleanAttributeHandler("w:unhideWhenUsed"),
		createIntegerAttributeHandler("w:uiPriority")
	],
	encode: (_, encodedAttrs) => {
		return encodedAttrs;
	},
	decode: function({ node }) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...node,
			attrs: node.attrs["lsdException"] || {}
		} });
		return Object.keys(decodedAttrs).length > 0 ? {
			name: "w:lsdException",
			attributes: decodedAttrs
		} : void 0;
	}
});
const translator$94 = NodeTranslator.from({
	xmlName: "w:latentStyles",
	sdNodeOrKeyName: "latentStyles",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [
		createBooleanAttributeHandler("w:defLockedState"),
		createBooleanAttributeHandler("w:defUIPriority"),
		createBooleanAttributeHandler("w:defSemiHidden"),
		createBooleanAttributeHandler("w:defUnhideWhenUsed"),
		createBooleanAttributeHandler("w:defQFormat")
	],
	encode: (params, encodedAttrs) => {
		const { nodes } = params;
		const node = nodes[0];
		return {
			...encodePropertiesByKey("w:lsdException", "lsdExceptions", translator$107, params, node, "name"),
			...encodedAttrs
		};
	},
	decode: function(params) {
		const decodedAttrs = this.decodeAttributes({ node: {
			...params.node,
			attrs: params.node.attrs.latentStyles || {}
		} });
		const currentValue = params.node.attrs?.latentStyles;
		if (!currentValue) return;
		return {
			name: "w:latentStyles",
			attributes: decodedAttrs,
			elements: decodePropertiesByKey("w:lsdException", "lsdExceptions", translator$107, params, currentValue)
		};
	}
});
const translator$95 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:locked"));
const translator$96 = NodeTranslator.from(createSingleAttrPropertyHandler("w:link"));
const translator$109 = NodeTranslator.from(createSingleAttrPropertyHandler("w:next"));
const translator$115 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:numIdMacAtCleanup"));
var propertyTranslators$1 = [
	translator$118,
	translator$189,
	translator$108,
	translator$147,
	translator$117,
	translator$104,
	translator$115
];
var propertyTranslatorsByXmlName$1 = {};
var propertyTranslatorsBySdName$1 = {};
propertyTranslators$1.forEach((translator$220) => {
	propertyTranslatorsByXmlName$1[translator$220.xmlName] = translator$220;
	propertyTranslatorsBySdName$1[translator$220.sdNodeOrKeyName] = translator$220;
});
const translator$36 = NodeTranslator.from({
	xmlName: "w:numbering",
	sdNodeOrKeyName: "numbering",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [],
	encode: (params, encodedAttrs) => {
		const { nodes } = params;
		const node = nodes[0];
		const props = encodeProperties(params, propertyTranslatorsByXmlName$1);
		return {
			...encodedAttrs,
			...props,
			...encodePropertiesByKey("w:abstractNum", "abstracts", translator$39, params, node, "abstractNumId"),
			...encodePropertiesByKey("w:num", "definitions", translator$112, params, node, "numId")
		};
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["abstractNum"];
		if (!currentValue) return;
		return {
			name: "w:numbering",
			type: "element",
			attributes: this.decodeAttributes({ node: {
				...params.node,
				attrs: currentValue
			} }),
			elements: [
				...decodeProperties(params, propertyTranslatorsBySdName$1, currentValue),
				...decodePropertiesByKey("w:abstractNum", "abstracts", translator$39, params, currentValue),
				...decodePropertiesByKey("w:num", "definitions", translator$112, params, currentValue)
			]
		};
	}
});
const translator$125 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:personal"));
const translator$126 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:personalCompose"));
const translator$127 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:personalReply"));
const translator$135 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:rsid"));
const translator$138 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:semiHidden"));
const translator$177 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:unhideWhenUsed"));
const translator$201 = NodeTranslator.from(createSingleBooleanPropertyHandler("w:qFormat"));
const translator$176 = NodeTranslator.from(createSingleIntegerPropertyHandler("w:uiPriority"));
var propertyTranslators = [
	translator$108,
	translator$45,
	translator$47,
	translator$109,
	translator$96,
	translator$42,
	translator$76,
	translator$138,
	translator$177,
	translator$201,
	translator$95,
	translator$125,
	translator$126,
	translator$127,
	translator$176,
	translator$135,
	translator$129,
	translator$133,
	translator$167,
	translator$175,
	translator$193,
	translator$204
];
var attributeHandlers = [
	createAttributeHandler("w:type"),
	createAttributeHandler("w:styleId"),
	createBooleanAttributeHandler("w:default"),
	createBooleanAttributeHandler("w:customStyle")
];
var propertyTranslatorsByXmlName = {};
var propertyTranslatorsBySdName = {};
propertyTranslators.forEach((translator$220) => {
	if (!translator$220) return;
	propertyTranslatorsByXmlName[translator$220.xmlName] = translator$220;
	propertyTranslatorsBySdName[translator$220.sdNodeOrKeyName] = translator$220;
});
const translator$146 = NodeTranslator.from({
	xmlName: "w:style",
	sdNodeOrKeyName: "style",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: attributeHandlers,
	encode: (params, encodedAttrs) => {
		const { nodes } = params;
		const node = nodes[0];
		return {
			...encodedAttrs,
			...encodeProperties(params, propertyTranslatorsByXmlName),
			...encodePropertiesByKey(translator$204.xmlName, "tableStyleProperties", translator$204, params, node, "type")
		};
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["style"];
		if (!currentValue) return;
		return {
			name: "w:style",
			type: "element",
			attributes: this.decodeAttributes({ node: {
				...params.node,
				attrs: currentValue
			} }),
			elements: [...decodeProperties(params, propertyTranslatorsBySdName, currentValue), ...decodePropertiesByKey(translator$204.xmlName, "tableStyleProperties", translator$204, params, currentValue)]
		};
	}
});
const translator$35 = NodeTranslator.from({
	xmlName: "w:styles",
	sdNodeOrKeyName: "styles",
	type: NodeTranslator.translatorTypes.NODE,
	attributes: [],
	encode: (params) => {
		const { nodes } = params;
		const node = nodes[0];
		return {
			...encodeProperties(params, {
				"w:docDefaults": translator$61,
				"w:latentStyles": translator$94
			}),
			...encodePropertiesByKey("w:style", "styles", translator$146, params, node, "styleId")
		};
	},
	decode: function(params) {
		const currentValue = params.node.attrs?.["styles"];
		if (!currentValue) return;
		return {
			name: "w:styles",
			type: "element",
			attributes: {},
			elements: [...decodeProperties(params, {
				docDefaults: translator$61,
				latentStyles: translator$94
			}, currentValue), ...decodePropertiesByKey("w:style", "styles", translator$146, params, currentValue)]
		};
	}
});
var translatorList = Array.from(new Set([
	translator$34,
	translator$17,
	translator$24,
	translator$25,
	translator$26,
	translator$38,
	translator$18,
	translator$23,
	translator$19,
	translator$20,
	translator$21,
	translator$22,
	translator$27,
	translator$28,
	translator$29,
	translator$30,
	translator$39,
	translator$40,
	translator$41,
	translator$42,
	translator$43,
	translator$44,
	translator$45,
	translator$46,
	translator$49,
	translator$50,
	translator$47,
	translator$48,
	translator$51,
	translator$14,
	translator$13,
	translator$52,
	translator$1,
	translator$53,
	translator$54,
	translator$55,
	translator$56,
	translator$57,
	translator$58,
	translator$59,
	translator$60,
	translator$61,
	translator$12,
	translator$62,
	translator$63,
	translator$64,
	translator$65,
	translator$66,
	translator$67,
	translator$33,
	translator$37,
	translator$69,
	translator$68,
	translator$70,
	translator$71,
	translator$72,
	translator$73,
	translator$74,
	translator$75,
	translator$76,
	translator$77,
	translator$2,
	translator$78,
	translator$79,
	translator$80,
	translator$81,
	translator$83,
	translator$82,
	translator$84,
	translator$85,
	translator$86,
	translator$87,
	translator$88,
	translator$89,
	translator$90,
	translator$91,
	translator$92,
	translator$93,
	translator$94,
	translator$106,
	translator$107,
	translator$96,
	translator$97,
	translator$98,
	translator$99,
	translator$100,
	translator$101,
	translator$102,
	translator$103,
	translator$104,
	translator$95,
	translator$105,
	translator$108,
	translator$109,
	translator$110,
	translator$111,
	translator$112,
	translator$36,
	translator$113,
	translator$114,
	translator$115,
	translator$116,
	translator$117,
	translator$118,
	translator$120,
	translator$121,
	translator$122,
	translator$119,
	translator,
	translator$123,
	translator$124,
	translator$125,
	translator$126,
	translator$127,
	translator$128,
	translator$129,
	translator$130,
	translator$131,
	translator$15,
	translator$16,
	translator$6,
	translator$132,
	translator$133,
	translator$134,
	translator$135,
	translator$136,
	translator$137,
	translator$9,
	translator$138,
	translator$139,
	translator$140,
	translator$141,
	translator$142,
	translator$148,
	translator$149,
	translator$150,
	translator$151,
	translator$152,
	translator$184,
	translator$143,
	translator$144,
	translator$145,
	translator$146,
	translator$147,
	translator$35,
	translator$153,
	translator$154,
	translator$32,
	translator$3,
	translator$4,
	translator$5,
	translator$155,
	translator$10,
	translator$156,
	translator$157,
	translator$158,
	translator$159,
	translator$160,
	translator$161,
	translator$162,
	translator$163,
	translator$164,
	translator$165,
	translator$166,
	translator$167,
	translator$168,
	translator$169,
	translator$170,
	translator$171,
	translator$172,
	translator$7,
	translator$191,
	translator$185,
	translator$192,
	translator$193,
	translator$186,
	translator$187,
	translator$188,
	translator$189,
	translator$8,
	translator$190,
	translator$174,
	translator$175,
	translator$194,
	translator$195,
	translator$196,
	translator$173,
	translator$11,
	translator$176,
	translator$177,
	translator$182,
	translator$197,
	translator$183,
	translator$181,
	translator$178,
	translator$179,
	translator$180,
	translator$198,
	translator$199,
	translator$200,
	translator$201,
	translator$202,
	translator$203,
	commentRangeStartTranslator,
	commentRangeEndTranslator
]));
var baseHandlers = { ...Object.freeze(translatorList.reduce((acc, translator$220) => {
	if (typeof translator$220 === "function") return acc;
	const key = translator$220?.xmlName;
	if (!key) return acc;
	acc[key] = translator$220;
	return acc;
}, {})) };
const registeredHandlers = Object.freeze(baseHandlers);
const handlePassthroughNode = (params) => {
	const { nodes = [] } = params;
	const node = nodes[0];
	if (!node) return {
		nodes: [],
		consumed: 0
	};
	if (registeredHandlers[node.name] || node.name === "w:commentReference") return {
		nodes: [],
		consumed: 0
	};
	const originalXml = carbonCopy(node) || {};
	const originalElementsSource = originalXml.elements;
	const originalElements = originalElementsSource ? carbonCopy(originalElementsSource) : [];
	const childElements = Array.isArray(node.elements) ? node.elements : [];
	let childContent = [];
	if (childElements.length && params.nodeListHandler?.handler) {
		const childParams = {
			...params,
			nodes: childElements,
			path: [...params.path || [], node]
		};
		childContent = params.nodeListHandler.handler(childParams) || [];
	}
	if (originalElements?.length) originalXml.elements = originalElements;
	return {
		nodes: [{
			type: isInlineContext(params.path, node.name) ? "passthroughInline" : "passthroughBlock",
			attrs: {
				originalName: node.name,
				originalXml
			},
			marks: [],
			content: childContent
		}],
		consumed: 1
	};
};
const passthroughNodeHandlerEntity = {
	handlerName: "passthroughNodeHandler",
	handler: handlePassthroughNode
};
const handler = (params) => {
	const { nodes } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:br") return {
		nodes: [],
		consumed: 0
	};
	const result = translator$1.encode(params);
	if (!result) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [result],
		consumed: 1
	};
};
const lineBreakNodeHandlerEntity = {
	handlerName: "lineBreakNodeHandler",
	handler
};
const handleBookmarkNode = (params) => {
	const { nodes, nodeListHandler, editor } = params;
	if (nodes.length === 0 || nodes[0].name !== "w:bookmarkStart") return {
		nodes: [],
		consumed: 0
	};
	const node = nodes[0];
	const customMarks = editor?.extensionService?.extensions?.filter((e) => e.isExternal === true) || [];
	const bookmarkName = node.attributes["w:name"]?.split(";")[0];
	const customMark = customMarks.find((mark) => mark.name === bookmarkName);
	if (customMark) {
		const bookmarkEndIndex = nodes.findIndex((n) => n.name === "w:bookmarkEnd" && n.attributes["w:id"] === node.attributes["w:id"]);
		const textNodes = nodes.slice(1, bookmarkEndIndex);
		const attrs = {};
		node.attributes["w:name"].split(";").forEach((name) => {
			const [key, value] = name.split("=");
			if (key && value) attrs[key] = value;
		});
		const translatedText = nodeListHandler.handler({
			...params,
			nodes: textNodes,
			path: [...params.path || [], node]
		});
		translatedText.forEach((n) => {
			n.marks.push({
				type: customMark.name,
				attrs
			});
		});
		return {
			nodes: translatedText,
			consumed: translatedText.length + 2
		};
	}
	const encoded = translator$13.encode({
		...params,
		nodes: [node]
	});
	if (!encoded) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [encoded],
		consumed: 1
	};
};
const handleBookmarkStartNode = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "w:bookmarkStart") return {
		nodes: [],
		consumed: 0
	};
	if (isCustomMarkBookmark(nodes[0], params.editor)) return handleBookmarkNode(params);
	const node = translator$13.encode(params);
	if (!node) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [node],
		consumed: 1
	};
};
var isCustomMarkBookmark = (bookmarkStartNode, editor) => {
	if (!bookmarkStartNode?.attributes || !editor?.extensionService?.extensions) return false;
	const rawBookmarkName = bookmarkStartNode.attributes["w:name"];
	if (!rawBookmarkName || typeof rawBookmarkName !== "string") return false;
	const [bookmarkName, ...bookmarkPayloadParts] = rawBookmarkName.split(";");
	if (!bookmarkName) return false;
	if (!editor.extensionService.extensions.filter((extension$1) => extension$1.isExternal === true).some((mark) => mark.name === bookmarkName)) return false;
	return bookmarkPayloadParts.some((part) => part && part.includes("="));
};
const bookmarkStartNodeHandlerEntity = {
	handlerName: "w:bookmarkStartTranslator",
	handler: handleBookmarkStartNode
};
const handleBookmarkEndNode = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "w:bookmarkEnd") return {
		nodes: [],
		consumed: 0
	};
	const node = translator$14.encode(params);
	if (!node) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [node],
		consumed: 1
	};
};
const bookmarkEndNodeHandlerEntity = {
	handlerName: "w:bookmarkEndTranslator",
	handler: handleBookmarkEndNode
};
var ALTERNATE_CONTENT_NODE = "mc:AlternateContent";
var skipHandlerResponse = {
	nodes: [],
	consumed: 0
};
var isAlternateContentNode = (node) => node?.name === ALTERNATE_CONTENT_NODE;
var resolveAlternateContentElements = (alternateContent) => {
	const { elements } = selectAlternateContentElements(alternateContent);
	if (!elements) return null;
	return elements;
};
var buildNodeWithoutAlternateContent = (node) => {
	const { elements } = node || {};
	if (!elements?.length) return null;
	let replaced = false;
	const updatedElements = [];
	elements.forEach((element) => {
		if (isAlternateContentNode(element)) {
			const resolved = resolveAlternateContentElements(element);
			if (resolved) {
				updatedElements.push(...resolved);
				replaced = true;
				return;
			}
			updatedElements.push(carbonCopy(element));
			return;
		}
		updatedElements.push(carbonCopy(element));
	});
	if (!replaced) return null;
	const clone = carbonCopy(node);
	clone.elements = updatedElements;
	return clone;
};
var handleAlternateChoice = (params) => {
	const { nodes, nodeListHandler } = params;
	if (!nodes?.length) return skipHandlerResponse;
	const [currentNode] = nodes;
	if (isAlternateContentNode(currentNode)) {
		const nodeForTranslator = currentNode?.type ? currentNode : {
			...currentNode,
			type: "element"
		};
		const translated = translator$34.encode({
			...params,
			nodes: [nodeForTranslator],
			extraParams: {
				...params.extraParams || {},
				node: nodeForTranslator
			}
		});
		if (!translated) return skipHandlerResponse;
		return {
			nodes: Array.isArray(translated) ? translated : [translated],
			consumed: 1
		};
	}
	const sanitizedNode = buildNodeWithoutAlternateContent(currentNode);
	if (!sanitizedNode) return skipHandlerResponse;
	return {
		nodes: nodeListHandler.handler({
			...params,
			nodes: [sanitizedNode],
			path: [...params.path || [], sanitizedNode]
		}),
		consumed: 1
	};
};
const alternateChoiceHandler = {
	handlerName: "alternateChoiceHandler",
	handler: handleAlternateChoice
};
const autoPageHandlerEntity = generateV2HandlerEntity("autoPageNumberHandler", translator$27);
const autoTotalPageCountEntity = generateV2HandlerEntity("autoTotalPageCountEntity", translator$28);
const sectionPageCountEntity = generateV2HandlerEntity("sectionPageCountEntity", translator$29);
const documentStatFieldHandlerEntity = generateV2HandlerEntity("documentStatFieldHandler", translator$30);
const pageReferenceEntity = generateV2HandlerEntity("pageReferenceNodeHandler", translator$17);
const crossReferenceEntity = generateV2HandlerEntity("crossReferenceNodeHandler", translator$18);
const sequenceFieldEntity = generateV2HandlerEntity("sequenceFieldNodeHandler", translator$23);
const handlePictNode = (params) => {
	const { nodes } = params;
	if (!Array.isArray(nodes) || nodes.length === 0 || nodes[0]?.name !== "w:pict") return {
		nodes: [],
		consumed: 0
	};
	const pict = nodes[0];
	const { type: pictType, handler: handler$1 } = pictNodeTypeStrategy(pict);
	if (!handler$1 || pictType === "unknown") return {
		nodes: [],
		consumed: 0
	};
	const result = handler$1({
		params,
		pict
	});
	if (!result) return {
		nodes: [],
		consumed: 0
	};
	const resultNodes = Array.isArray(result) ? result : [result];
	const BLOCK_TYPES = new Set(["shapeContainer", "shapeTextbox"]);
	if (resultNodes.some((n) => BLOCK_TYPES.has(n.type))) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: resultNodes,
		consumed: 1
	};
};
const pictNodeHandlerEntity = {
	handlerName: "handlePictNode",
	handler: handlePictNode
};
function importCommentData({ docx, editor, converter }) {
	const nodeListHandler = defaultNodeListHandler();
	const comments = docx["word/comments.xml"];
	if (!comments) return;
	const commentThreadingProfile = converter?.commentThreadingProfile || {
		defaultStyle: docx["word/commentsExtended.xml"] ? "commentsExtended" : "range-based",
		mixed: false,
		fileSet: {
			hasCommentsExtended: !!docx["word/commentsExtended.xml"],
			hasCommentsExtensible: !!docx["word/commentsExtensible.xml"],
			hasCommentsIds: !!docx["word/commentsIds.xml"]
		}
	};
	const { elements } = comments;
	if (!elements || !elements.length) return;
	const { elements: allComments = [] } = elements[0];
	const extendedComments = generateCommentsWithExtendedData({
		docx,
		comments: allComments.map((el) => {
			const { attributes } = el;
			const importedId = attributes["w:id"];
			const authorName = readCommentAttribute(attributes, "w:author", "custom:author");
			const authorEmail = readCommentAttribute(attributes, "w:email", "custom:email");
			const initials = readCommentAttribute(attributes, "w:initials", "custom:initials");
			const createdDate = attributes["w:date"];
			const internalId = attributes["custom:internalId"];
			const trackedChange = attributes["custom:trackedChange"] === "true";
			const trackedChangeType = attributes["custom:trackedChangeType"];
			const trackedChangeText = attributes["custom:trackedChangeText"] !== "null" ? attributes["custom:trackedChangeText"] : null;
			const trackedChangeDisplayType = attributes["custom:trackedChangeDisplayType"] !== "null" ? attributes["custom:trackedChangeDisplayType"] : null;
			const trackedDeletedText = attributes["custom:trackedDeletedText"] !== "null" ? attributes["custom:trackedDeletedText"] : null;
			const unixTimestampMs = new Date(createdDate).getTime();
			const parsedElements = nodeListHandler.handler({
				nodes: el.elements,
				nodeListHandler,
				docx,
				editor,
				converter,
				path: [el]
			});
			const textElements = Array.isArray(parsedElements) ? parsedElements : parsedElements ? [parsedElements] : [];
			const paraId = textElements[textElements.length - 1]?.attrs?.["w14:paraId"];
			const threadingMethod = commentThreadingProfile.defaultStyle;
			return {
				commentId: getCommentId(internalId, importedId, unixTimestampMs),
				importedId,
				creatorName: authorName,
				creatorEmail: authorEmail,
				createdTime: unixTimestampMs,
				elements: textElements,
				initials,
				paraId,
				trackedChange,
				trackedChangeText,
				trackedChangeType,
				trackedChangeDisplayType,
				trackedDeletedText,
				isDone: false,
				origin: converter?.documentOrigin || "word",
				threadingMethod,
				threadingStyleOverride: void 0,
				originalXmlStructure: { ...commentThreadingProfile.fileSet }
			};
		}),
		converter,
		threadingProfile: commentThreadingProfile
	});
	if (converter) {
		const hasOverride = extendedComments.some((comment) => comment.threadingStyleOverride && comment.threadingStyleOverride !== commentThreadingProfile.defaultStyle);
		converter.commentThreadingProfile = {
			...commentThreadingProfile,
			mixed: hasOverride || commentThreadingProfile.mixed
		};
	}
	return extendedComments;
}
var readCommentAttribute = (attributes, primaryName, fallbackName) => {
	if (!attributes) return void 0;
	return attributes[primaryName] ?? attributes[fallbackName];
};
var generateCommentsWithExtendedData = ({ docx, comments, converter, threadingProfile }) => {
	if (!comments?.length) return [];
	const rangeData = extractCommentRangesFromDocument(docx, converter);
	const { commentsInTrackedChanges } = rangeData;
	const trackedChangeParentMap = detectThreadingFromTrackedChanges(comments, commentsInTrackedChanges);
	const rangeThreadedComments = detectThreadingFromRanges(comments, {
		...rangeData,
		commentsInTrackedChanges: /* @__PURE__ */ new Map()
	});
	const commentIdSet = new Set(comments.map((comment) => comment.commentId));
	const rangeParentMap = /* @__PURE__ */ new Map();
	rangeThreadedComments.forEach((comment) => {
		if (comment.parentCommentId && commentIdSet.has(comment.parentCommentId)) rangeParentMap.set(comment.commentId, comment.parentCommentId);
	});
	const commentsExtended = docx["word/commentsExtended.xml"];
	if (!commentsExtended) return detectThreadingFromRanges(comments, rangeData).map((comment) => ({
		...comment,
		isDone: comment.isDone ?? false
	}));
	const { elements: initialElements = [] } = commentsExtended;
	if (!initialElements?.length) return comments.map((comment) => ({
		...comment,
		isDone: comment.isDone ?? false
	}));
	const { elements = [] } = initialElements[0] ?? {};
	const commentEx = elements.filter((el) => el.name === "w15:commentEx");
	return comments.map((comment) => {
		const extendedDef = commentEx.find((ce) => {
			return comment.elements?.some((el) => el.attrs?.["w14:paraId"] === ce.attributes["w15:paraId"]);
		});
		let isDone = comment.isDone ?? false;
		let parentCommentId = void 0;
		let threadingParentCommentId = void 0;
		let threadingStyleOverride = void 0;
		const trackedChangeParent = trackedChangeParentMap.get(comment.importedId);
		const isInsideTrackedChange = trackedChangeParent?.isTrackedChangeParent;
		const hasExtendedEntry = !!extendedDef;
		if (extendedDef) {
			const details = getExtendedDetails(extendedDef);
			isDone = details.isDone ?? false;
			if (details.paraIdParent) {
				const parentComment = comments.find((c$1) => c$1.paraId === details.paraIdParent || c$1.elements?.some((el) => el.attrs?.["w14:paraId"] === details.paraIdParent));
				const rangeParent = rangeParentMap.get(comment.commentId);
				if (parentComment?.trackedChange) {
					if (rangeParent) {
						threadingParentCommentId = rangeParent;
						parentCommentId = threadingParentCommentId;
					}
				} else {
					threadingParentCommentId = parentComment?.commentId;
					parentCommentId = threadingParentCommentId;
				}
			}
		}
		const trackedChangeParentId = isInsideTrackedChange ? trackedChangeParent.trackedChangeId : void 0;
		if (!parentCommentId && !hasExtendedEntry && rangeParentMap.has(comment.commentId)) {
			parentCommentId = rangeParentMap.get(comment.commentId);
			if (threadingProfile?.defaultStyle === "commentsExtended") threadingStyleOverride = "range-based";
		}
		return {
			...comment,
			isDone,
			parentCommentId,
			threadingStyleOverride,
			threadingParentCommentId,
			trackedChangeParentId
		};
	});
};
var getExtendedDetails = (commentEx) => {
	const { attributes } = commentEx;
	return {
		paraId: attributes["w15:paraId"],
		isDone: attributes["w15:done"] === "1" ? true : false,
		paraIdParent: attributes["w15:paraIdParent"]
	};
};
var extractCommentRangesFromDocument = (docx, converter) => {
	const documentXml = docx["word/document.xml"];
	if (!documentXml) return {
		rangeEvents: [],
		rangePositions: /* @__PURE__ */ new Map(),
		commentsInTrackedChanges: /* @__PURE__ */ new Map()
	};
	const rangeEvents = [];
	const rangePositions = /* @__PURE__ */ new Map();
	const commentsInTrackedChanges = /* @__PURE__ */ new Map();
	let positionIndex = 0;
	let lastElementWasCommentMarker = false;
	const recentlyClosedComments = /* @__PURE__ */ new Set();
	const walkElements$1 = (elements, currentTrackedChangeId = null) => {
		if (!elements || !Array.isArray(elements)) return;
		elements.forEach((element) => {
			const isCommentStart = element.name === "w:commentRangeStart";
			const isCommentEnd = element.name === "w:commentRangeEnd";
			const isTrackedChange = element.name === "w:ins" || element.name === "w:del";
			if (isCommentStart) {
				const commentId = element.attributes?.["w:id"];
				if (commentId !== void 0) {
					const id = String(commentId);
					rangeEvents.push({
						type: "start",
						commentId: id
					});
					if (!rangePositions.has(id)) rangePositions.set(id, {
						startIndex: positionIndex,
						endIndex: -1
					});
					else rangePositions.get(id).startIndex = positionIndex;
					if (currentTrackedChangeId !== null) commentsInTrackedChanges.set(id, currentTrackedChangeId);
				}
				lastElementWasCommentMarker = true;
				recentlyClosedComments.clear();
			} else if (isCommentEnd) {
				const commentId = element.attributes?.["w:id"];
				if (commentId !== void 0) {
					const id = String(commentId);
					rangeEvents.push({
						type: "end",
						commentId: id
					});
					if (!rangePositions.has(id)) rangePositions.set(id, {
						startIndex: -1,
						endIndex: positionIndex
					});
					else rangePositions.get(id).endIndex = positionIndex;
					recentlyClosedComments.add(id);
				}
				lastElementWasCommentMarker = true;
			} else if (isTrackedChange) {
				const wordId = element.attributes?.["w:id"];
				const mappedId = wordId != null ? converter?.trackedChangeIdMap?.get(String(wordId)) ?? String(wordId) : currentTrackedChangeId;
				if (mappedId && recentlyClosedComments.size > 0) recentlyClosedComments.forEach((commentId) => {
					if (!commentsInTrackedChanges.has(commentId)) commentsInTrackedChanges.set(commentId, mappedId);
				});
				recentlyClosedComments.clear();
				if (element.elements && Array.isArray(element.elements)) walkElements$1(element.elements, mappedId);
			} else {
				if (lastElementWasCommentMarker) {
					positionIndex++;
					lastElementWasCommentMarker = false;
				}
				if (element.name === "w:p") recentlyClosedComments.clear();
				if (element.elements && Array.isArray(element.elements)) walkElements$1(element.elements, currentTrackedChangeId);
			}
		});
	};
	if (documentXml.elements && documentXml.elements.length > 0) {
		const body = documentXml.elements[0];
		if (body.elements) walkElements$1(body.elements);
	}
	return {
		rangeEvents,
		rangePositions,
		commentsInTrackedChanges
	};
};
var detectThreadingFromNestedRanges = (comments, rangeEvents, skipComments = /* @__PURE__ */ new Set()) => {
	const openRanges = [];
	const parentMap = /* @__PURE__ */ new Map();
	rangeEvents.forEach((event) => {
		if (event.type === "start") {
			if (!skipComments.has(event.commentId) && openRanges.length > 0) {
				for (let i$1 = openRanges.length - 1; i$1 >= 0; i$1--) if (!skipComments.has(openRanges[i$1])) {
					parentMap.set(event.commentId, openRanges[i$1]);
					break;
				}
			}
			openRanges.push(event.commentId);
		} else if (event.type === "end") {
			const index = openRanges.lastIndexOf(event.commentId);
			if (index !== -1) openRanges.splice(index, 1);
		}
	});
	return parentMap;
};
var detectThreadingFromSharedPosition = (comments, rangePositions) => {
	const parentMap = /* @__PURE__ */ new Map();
	const commentsByStartPosition = /* @__PURE__ */ new Map();
	comments.forEach((comment) => {
		const position = rangePositions.get(comment.importedId);
		if (position && position.startIndex >= 0) {
			const startKey = position.startIndex;
			if (!commentsByStartPosition.has(startKey)) commentsByStartPosition.set(startKey, []);
			commentsByStartPosition.get(startKey).push(comment);
		}
	});
	commentsByStartPosition.forEach((commentsAtPosition) => {
		if (commentsAtPosition.length <= 1) return;
		const sorted = [...commentsAtPosition].sort((a, b) => a.createdTime - b.createdTime);
		const parentComment = sorted[0];
		for (let i$1 = 1; i$1 < sorted.length; i$1++) parentMap.set(sorted[i$1].importedId, parentComment.importedId);
	});
	return parentMap;
};
var detectThreadingFromMissingRanges = (comments, rangePositions) => {
	const parentMap = /* @__PURE__ */ new Map();
	const commentsWithRanges = [];
	const commentsWithoutRanges = [];
	comments.forEach((comment) => {
		const position = rangePositions.get(comment.importedId);
		if (position && position.startIndex >= 0) commentsWithRanges.push(comment);
		else commentsWithoutRanges.push(comment);
	});
	commentsWithoutRanges.forEach((comment) => {
		const potentialParents = commentsWithRanges.filter((c$1) => c$1.createdTime < comment.createdTime).sort((a, b) => b.createdTime - a.createdTime);
		if (potentialParents.length > 0) parentMap.set(comment.importedId, potentialParents[0].importedId);
	});
	return parentMap;
};
var detectThreadingFromTrackedChanges = (comments, commentsInTrackedChanges) => {
	const parentMap = /* @__PURE__ */ new Map();
	if (!commentsInTrackedChanges || commentsInTrackedChanges.size === 0) return parentMap;
	comments.forEach((comment) => {
		const trackedChangeId = commentsInTrackedChanges.get(comment.importedId);
		if (trackedChangeId !== void 0) parentMap.set(comment.importedId, {
			trackedChangeId,
			isTrackedChangeParent: true
		});
	});
	return parentMap;
};
var detectThreadingFromRanges = (comments, rangeData) => {
	const { rangeEvents, rangePositions, commentsInTrackedChanges } = Array.isArray(rangeData) ? {
		rangeEvents: rangeData,
		rangePositions: /* @__PURE__ */ new Map(),
		commentsInTrackedChanges: /* @__PURE__ */ new Map()
	} : rangeData;
	if (!rangeEvents || rangeEvents.length === 0) {
		if (comments.length > 1) return applyParentRelationships(comments, detectThreadingFromMissingRanges(comments, rangePositions));
		return comments;
	}
	const nestedParentMap = detectThreadingFromNestedRanges(comments, rangeEvents, findCommentsWithSharedStartPosition(comments, rangePositions));
	const sharedPositionParentMap = detectThreadingFromSharedPosition(comments, rangePositions);
	const missingRangeParentMap = detectThreadingFromMissingRanges(comments, rangePositions);
	const trackedChangeParentMap = detectThreadingFromTrackedChanges(comments, commentsInTrackedChanges);
	return applyParentRelationships(comments, new Map([
		...missingRangeParentMap,
		...nestedParentMap,
		...sharedPositionParentMap
	]), trackedChangeParentMap);
};
var findCommentsWithSharedStartPosition = (comments, rangePositions) => {
	const sharedPositionComments = /* @__PURE__ */ new Set();
	const commentsByStartPosition = /* @__PURE__ */ new Map();
	comments.forEach((comment) => {
		const position = rangePositions.get(comment.importedId);
		if (position && position.startIndex >= 0) {
			const startKey = position.startIndex;
			if (!commentsByStartPosition.has(startKey)) commentsByStartPosition.set(startKey, []);
			commentsByStartPosition.get(startKey).push(comment.importedId);
		}
	});
	commentsByStartPosition.forEach((commentIds) => {
		if (commentIds.length > 1) commentIds.forEach((id) => sharedPositionComments.add(id));
	});
	return sharedPositionComments;
};
var applyParentRelationships = (comments, parentMap, trackedChangeParentMap = /* @__PURE__ */ new Map()) => {
	return comments.map((comment) => {
		const trackedChangeParent = trackedChangeParentMap.get(comment.importedId);
		const updatedComment = trackedChangeParent && trackedChangeParent.isTrackedChangeParent ? {
			...comment,
			trackedChangeParentId: trackedChangeParent.trackedChangeId
		} : comment;
		const parentImportedId = parentMap.get(comment.importedId);
		if (parentImportedId) {
			const parentComment = comments.find((c$1) => c$1.importedId === parentImportedId);
			if (parentComment) return {
				...updatedComment,
				parentCommentId: parentComment.commentId
			};
		}
		return updatedComment;
	});
};
var getCommentId = (internalId, importedId, createdTime) => {
	if (internalId != null) return internalId;
	if (importedId == null || !Number.isFinite(createdTime)) return v4_default();
	return `imported-${stableHexHash(`${importedId}-${createdTime}`)}`;
};
var TRACKED_CHANGE_NAMES = new Set(["w:ins", "w:del"]);
var PAIRING_TRANSPARENT_NAMES = new Set([
	"w:commentRangeStart",
	"w:commentRangeEnd",
	"w:bookmarkStart",
	"w:bookmarkEnd",
	"w:proofErr",
	"w:permStart",
	"w:permEnd",
	"w:moveFromRangeStart",
	"w:moveFromRangeEnd",
	"w:moveToRangeStart",
	"w:moveToRangeEnd"
]);
function isReplacementPair(previous$1, current) {
	return previous$1.type !== current.type && previous$1.author === current.author && previous$1.date === current.date;
}
function trackedChangeEntryFromElement(element) {
	return {
		type: element.name,
		author: element.attributes?.["w:author"] ?? "",
		date: element.attributes?.["w:date"] ?? ""
	};
}
function findNextSiblingTrackedChange(elements, startIndex) {
	if (!Array.isArray(elements)) return null;
	for (let i$1 = startIndex; i$1 < elements.length; i$1 += 1) {
		const element = elements[i$1];
		if (TRACKED_CHANGE_NAMES.has(element?.name)) return trackedChangeEntryFromElement(element);
		if (!PAIRING_TRANSPARENT_NAMES.has(element?.name)) return null;
	}
	return null;
}
function isChildReplacementInsideDeletion(beforePrevious, previous$1, current, next) {
	if (!isReplacementPair(previous$1, current)) return false;
	const touchesDifferentAuthorDeletionBefore = beforePrevious?.type === "w:del" && beforePrevious.author !== previous$1.author;
	const touchesDifferentAuthorDeletionAfter = next?.type === "w:del" && next.author !== previous$1.author;
	return touchesDifferentAuthorDeletionBefore || touchesDifferentAuthorDeletionAfter;
}
function assignInternalId(element, idMap, context, insideTrackedChange, nextTrackedChange = null) {
	const wordId = String(element.attributes?.["w:id"] ?? "");
	if (!wordId) return;
	if (insideTrackedChange) {
		if (!idMap.has(wordId)) idMap.set(wordId, v4_default());
		return;
	}
	const current = trackedChangeEntryFromElement(element);
	const shouldPair = context.replacements === "paired";
	const shouldKeepChildSides = context.lastTrackedChange && isChildReplacementInsideDeletion(context.beforeLastTrackedChange, context.lastTrackedChange, current, nextTrackedChange);
	if (shouldPair && context.lastTrackedChange && !shouldKeepChildSides && isReplacementPair(context.lastTrackedChange, current)) {
		if (!idMap.has(wordId)) idMap.set(wordId, context.lastTrackedChange.internalId);
		context.lastTrackedChange = null;
		context.beforeLastTrackedChange = null;
	} else {
		const internalId = idMap.get(wordId) ?? v4_default();
		idMap.set(wordId, internalId);
		context.beforeLastTrackedChange = context.lastTrackedChange;
		context.lastTrackedChange = {
			...current,
			internalId
		};
	}
}
function walkElements(elements, idMap, context, insideTrackedChange = false) {
	if (!Array.isArray(elements)) return;
	for (let index = 0; index < elements.length; index += 1) {
		const element = elements[index];
		if (TRACKED_CHANGE_NAMES.has(element.name)) {
			assignInternalId(element, idMap, context, insideTrackedChange, findNextSiblingTrackedChange(elements, index + 1));
			if (element.elements) walkElements(element.elements, idMap, {
				beforeLastTrackedChange: null,
				lastTrackedChange: null,
				replacements: context.replacements
			}, true);
		} else {
			if (!PAIRING_TRANSPARENT_NAMES.has(element.name)) {
				context.lastTrackedChange = null;
				context.beforeLastTrackedChange = null;
			}
			if (element.elements) walkElements(element.elements, idMap, context, insideTrackedChange);
		}
	}
}
function buildTrackedChangeIdMapForPart(part, options = {}) {
	const root = part?.elements?.[0];
	if (!root?.elements) return /* @__PURE__ */ new Map();
	const replacements = options.replacements === "independent" ? "independent" : "paired";
	const idMap = /* @__PURE__ */ new Map();
	walkElements(root.elements, idMap, {
		beforeLastTrackedChange: null,
		lastTrackedChange: null,
		replacements
	});
	return idMap;
}
function buildTrackedChangeIdMap(docx, options = {}) {
	return buildTrackedChangeIdMapForPart(docx?.["word/document.xml"], options);
}
function buildTrackedChangeIdMapsByPart(docx, options = {}) {
	const mapsByPart = /* @__PURE__ */ new Map();
	if (!docx || typeof docx !== "object") return mapsByPart;
	const parts = docx;
	mapsByPart.set("word/document.xml", buildTrackedChangeIdMapForPart(parts["word/document.xml"], options));
	for (const partPath of Object.keys(parts)) {
		if (!/^word\/(?:header|footer)\d+\.xml$/.test(partPath)) continue;
		mapsByPart.set(partPath, buildTrackedChangeIdMapForPart(parts[partPath], options));
	}
	if (parts["word/footnotes.xml"]) mapsByPart.set("word/footnotes.xml", buildTrackedChangeIdMapForPart(parts["word/footnotes.xml"], options));
	if (parts["word/endnotes.xml"]) mapsByPart.set("word/endnotes.xml", buildTrackedChangeIdMapForPart(parts["word/endnotes.xml"], options));
	return mapsByPart;
}
var stripNoteMarkerNodes = (nodes) => {
	if (!Array.isArray(nodes) || nodes.length === 0) return nodes;
	const walk = (list$1) => {
		if (!Array.isArray(list$1) || list$1.length === 0) return;
		for (let i$1 = list$1.length - 1; i$1 >= 0; i$1--) {
			const node = list$1[i$1];
			if (!node) continue;
			if (node.type === "passthroughInline" && (node.attrs?.originalName === "w:footnoteRef" || node.attrs?.originalName === "w:endnoteRef")) {
				list$1.splice(i$1, 1);
				continue;
			}
			if (Array.isArray(node.content)) walk(node.content);
		}
	};
	const copy$1 = JSON.parse(JSON.stringify(nodes));
	walk(copy$1);
	return copy$1;
};
function importNoteEntries({ partXml, childElementName, filename, docx, editor, converter, nodeListHandler, numbering }) {
	const handler$1 = nodeListHandler || defaultNodeListHandler();
	if (!partXml?.elements?.length) return [];
	const root = partXml.elements[0];
	const noteElements = (Array.isArray(root?.elements) ? root.elements : []).filter((el) => el?.name === childElementName);
	if (noteElements.length === 0) return [];
	const results = [];
	const lists = {};
	const inlineDocumentFonts = [];
	noteElements.forEach((el) => {
		const idRaw = el?.attributes?.["w:id"];
		if (idRaw === void 0 || idRaw === null) return;
		const id = String(idRaw);
		const idNumber = Number(id);
		const originalXml = carbonCopy(el);
		const type = el?.attributes?.["w:type"] || null;
		if (type === "separator" || type === "continuationSeparator" || type === "continuationNotice") {
			results.push({
				id,
				type,
				originalXml,
				content: []
			});
			return;
		}
		if (!Number.isFinite(idNumber) || idNumber < 0) return;
		const childElements = Array.isArray(el.elements) ? el.elements : [];
		const stripped = stripNoteMarkerNodes(handler$1.handler({
			nodes: childElements,
			nodeListHandler: handler$1,
			docx,
			editor,
			converter,
			numbering,
			lists,
			inlineDocumentFonts,
			filename,
			path: [el]
		}));
		results.push({
			id,
			type,
			originalXml,
			content: stripped
		});
	});
	return results;
}
function importFootnoteData({ docx, editor, converter, nodeListHandler, numbering } = {}) {
	return importNoteEntries({
		partXml: docx?.["word/footnotes.xml"],
		childElementName: "w:footnote",
		filename: "footnotes.xml",
		docx,
		editor,
		converter,
		nodeListHandler,
		numbering
	});
}
function importEndnoteData({ docx, editor, converter, nodeListHandler, numbering } = {}) {
	return importNoteEntries({
		partXml: docx?.["word/endnotes.xml"],
		childElementName: "w:endnote",
		filename: "endnotes.xml",
		docx,
		editor,
		converter,
		nodeListHandler,
		numbering
	});
}
const getDocumentRelationshipElements = (editor) => {
	const docx = editor.converter?.convertedXml;
	if (!docx) return [];
	const elements = docx["word/_rels/document.xml.rels"]?.elements;
	if (!Array.isArray(elements)) return [];
	return elements.find((el) => el.name === "Relationships")?.elements || [];
};
const getMaxRelationshipIdInt = (relationships) => {
	const ids = [];
	relationships.forEach((rel) => {
		const splitId = rel.attributes.Id.split("rId");
		const parsedInt = parseInt(splitId[1], 10);
		if (Number.isInteger(parsedInt)) ids.push(parsedInt);
	});
	if (ids.length === 0) return 0;
	return Math.max(...ids);
};
const findRelationshipIdFromTarget = (target, editor) => {
	if (!target) return null;
	if (target.startsWith("word/")) target = target.replace("word/", "");
	const existingLinkRel = getDocumentRelationshipElements(editor)?.find((rel) => rel.attributes.Target === target);
	if (existingLinkRel) return existingLinkRel.attributes.Id;
};
const insertNewRelationship = (target, type, editor) => {
	if (!target || typeof target !== "string") throw new Error("Target must be a non-empty string");
	if (!type || typeof type !== "string") throw new Error("Type must be a non-empty string");
	if (!editor) throw new Error("Editor instance is required");
	const mappedType = RELATIONSHIP_TYPES[type];
	if (!mappedType) {
		console.warn(`Unsupported relationship type: ${type}. Available types: ${Object.keys(RELATIONSHIP_TYPES).join(", ")}`);
		return null;
	}
	const existingRelId = findRelationshipIdFromTarget(target, editor);
	if (existingRelId) {
		console.info(`Reusing existing relationship for target: ${target} (ID: ${existingRelId})`);
		return existingRelId;
	}
	const docx = editor.converter?.convertedXml;
	if (!docx) {
		console.error("No converted XML found in editor");
		return null;
	}
	const documentRels = docx["word/_rels/document.xml.rels"];
	if (!documentRels) {
		console.error("No document relationships found in the docx");
		return null;
	}
	const relationshipsTag = documentRels.elements?.find((el) => el.name === "Relationships");
	if (!relationshipsTag) {
		console.error("No Relationships tag found in document relationships");
		return null;
	}
	if (!relationshipsTag.elements) relationshipsTag.elements = [];
	const newId = getNewRelationshipId(editor);
	if (!newId) {
		console.error("Failed to generate new relationship ID");
		return null;
	}
	const newRel = {
		type: "element",
		name: "Relationship",
		attributes: {
			Id: newId,
			Type: mappedType,
			Target: target
		}
	};
	if (type === "hyperlink") newRel.attributes.TargetMode = "External";
	relationshipsTag.elements.push(newRel);
	return newId;
};
const getNewRelationshipId = (editor) => {
	return `rId${getMaxRelationshipIdInt(getDocumentRelationshipElements(editor)) + 1}`;
};
const DocxHelpers = {
	findRelationshipIdFromTarget,
	insertNewRelationship,
	getNewRelationshipId
};
const kebabCase = (str) => str.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
var toFiniteNumber$2 = (value) => {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	if (typeof value === "string" && value.trim().length > 0) {
		const parsed = Number(value);
		if (Number.isFinite(parsed)) return parsed;
	}
};
const getListOrdinalFromPath = (path) => {
	if (!Array.isArray(path) || path.length === 0) return void 0;
	const ordinal = toFiniteNumber$2(path[path.length - 1]);
	return ordinal != null && ordinal > 0 ? ordinal : void 0;
};
const getListRendering = (value) => {
	if (!value || typeof value !== "object") return;
	const attrs = value;
	const markerText = typeof attrs.markerText === "string" ? attrs.markerText : void 0;
	const numberingType = typeof attrs.numberingType === "string" ? attrs.numberingType : void 0;
	const customFormat = typeof attrs.customFormat === "string" ? attrs.customFormat : void 0;
	const path = Array.isArray(attrs.path) ? attrs.path.map(toFiniteNumber$2).filter((entry) => entry != null) : void 0;
	if (!markerText && !numberingType && (!path || path.length === 0)) return;
	return {
		markerText,
		numberingType,
		...path && path.length > 0 ? { path } : {},
		...customFormat ? { customFormat } : {}
	};
};
const getDefaultStyleDefinition = (defaultStyleId, docx) => {
	const result = {
		lineSpaceBefore: null,
		lineSpaceAfter: null
	};
	if (!defaultStyleId) return result;
	const styles = docx["word/styles.xml"];
	if (!styles) return result;
	const { elements } = styles.elements[0];
	const elementsWithId = elements.filter((el) => {
		const { attributes } = el;
		return attributes && attributes["w:styleId"] === defaultStyleId;
	});
	const firstMatch = elementsWithId[0];
	if (!firstMatch) return result;
	if (!firstMatch.elements) return result;
	const qFormat = elementsWithId.find((el) => {
		return el.elements.find((innerEl) => innerEl.name === "w:qFormat");
	});
	const name = elementsWithId.find((el) => el.elements.some((inner) => inner.name === "w:name"))?.elements.find((inner) => inner.name === "w:name")?.attributes["w:val"];
	const pPr = firstMatch.elements.find((el) => el.name === "w:pPr");
	const spacing = pPr?.elements?.find((el) => el.name === "w:spacing");
	const justify = pPr?.elements?.find((el) => el.name === "w:jc");
	const indent = pPr?.elements?.find((el) => el.name === "w:ind");
	const tabs = pPr?.elements?.find((el) => el.name === "w:tabs");
	let lineSpaceBefore, lineSpaceAfter, line;
	if (spacing?.attributes) {
		lineSpaceBefore = twipsToPixels$2(spacing.attributes["w:before"]);
		lineSpaceAfter = twipsToPixels$2(spacing.attributes["w:after"]);
		line = twipsToLines(spacing.attributes["w:line"]);
	}
	let textAlign, leftIndent, rightIndent, firstLine;
	if (indent?.attributes) {
		textAlign = justify?.attributes?.["w:val"];
		leftIndent = twipsToPixels$2(indent.attributes["w:left"]);
		rightIndent = twipsToPixels$2(indent.attributes["w:right"]);
		firstLine = twipsToPixels$2(indent.attributes["w:firstLine"]);
	}
	let tabStops = [];
	if (tabs) tabStops = (tabs.elements || []).filter((el) => el.name === "w:tab").map((tab) => {
		let val = tab.attributes["w:val"];
		if (val == "left") val = "start";
		else if (val == "right") val = "end";
		return {
			val,
			pos: twipsToPixels$2(tab.attributes["w:pos"]),
			leader: tab.attributes["w:leader"]
		};
	});
	const keepNext = pPr?.elements?.find((el) => el.name === "w:keepNext");
	const keepLines = pPr?.elements?.find((el) => el.name === "w:keepLines");
	const outlineLevel = pPr?.elements?.find((el) => el.name === "w:outlineLvl");
	const outlineLvlValue = outlineLevel?.attributes["w:val"];
	const pageBreakBefore = pPr?.elements?.find((el) => el.name === "w:pageBreakBefore");
	let pageBreakBeforeVal = 0;
	if (pageBreakBefore) if (!pageBreakBefore.attributes?.["w:val"]) pageBreakBeforeVal = 1;
	else pageBreakBeforeVal = Number(pageBreakBefore?.attributes?.["w:val"]);
	const pageBreakAfter = pPr?.elements?.find((el) => el.name === "w:pageBreakAfter");
	let pageBreakAfterVal;
	if (pageBreakAfter) if (!pageBreakAfter.attributes?.["w:val"]) pageBreakAfterVal = 1;
	else pageBreakAfterVal = Number(pageBreakAfter?.attributes?.["w:val"]);
	const basedOn = elementsWithId.find((el) => el.elements.some((inner) => inner.name === "w:basedOn"))?.elements.find((inner) => inner.name === "w:basedOn")?.attributes["w:val"];
	const linkToCharacterStyle = firstMatch.elements.find((el) => el.name === "w:link")?.attributes?.["w:val"] ?? null;
	const parsedAttrs = {
		name,
		qFormat: qFormat ? true : false,
		keepNext: keepNext ? true : false,
		keepLines: keepLines ? true : false,
		outlineLevel: outlineLevel ? parseInt(outlineLvlValue) : null,
		pageBreakBefore: pageBreakBeforeVal ? true : false,
		pageBreakAfter: pageBreakAfterVal ? true : false,
		basedOn: basedOn ?? null,
		link: linkToCharacterStyle
	};
	const parsedMarks = parseMarks(firstMatch.elements.find((el) => el.name === "w:rPr"), [], docx) || [];
	const parsedStyles = {
		spacing: {
			lineSpaceAfter,
			lineSpaceBefore,
			line
		},
		textAlign,
		indent: {
			leftIndent,
			rightIndent,
			firstLine
		},
		tabStops: tabStops.length > 0 ? tabStops : null
	};
	parsedMarks.forEach((mark) => {
		const { type, attrs } = mark;
		if (type === "textStyle") {
			Object.entries(attrs).forEach(([key, value]) => {
				parsedStyles[kebabCase(key)] = value;
			});
			return;
		}
		parsedStyles[type] = attrs;
	});
	return {
		attrs: parsedAttrs,
		styles: parsedStyles
	};
};
const IGNORED_NODE_NAMES = ["w:proofErr", "w:lastRenderedPageBreak"];
const pruneIgnoredNodes = (nodes = []) => nodes.filter((node) => !IGNORED_NODE_NAMES.includes(node.name)).map((node) => node.elements ? {
	...node,
	elements: pruneIgnoredNodes(node.elements)
} : node);
var handleTabNode = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "w:tab") return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [translator$3.encode(params)],
		consumed: 1
	};
};
const tabNodeEntityHandler = {
	handlerName: "w:tabTranslator",
	handler: handleTabNode
};
var handleNoBreakHyphenNode = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "w:noBreakHyphen") return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: [translator$4.encode(params)],
		consumed: 1
	};
};
const noBreakHyphenNodeEntityHandler = {
	handlerName: "w:noBreakHyphenTranslator",
	handler: handleNoBreakHyphenNode
};
var handleSmartTagNode = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "w:smartTag") return {
		nodes: [],
		consumed: 0
	};
	const result = translator$5.encode(params);
	if (!result) return {
		nodes: [],
		consumed: 0
	};
	return {
		nodes: Array.isArray(result) ? result : [result],
		consumed: 1
	};
};
const smartTagNodeEntityHandler = {
	handlerName: "w:smartTagTranslator",
	handler: handleSmartTagNode
};
const footnoteReferenceHandlerEntity = generateV2HandlerEntity("footnoteReferenceHandler", translator$33);
const endnoteReferenceHandlerEntity = generateV2HandlerEntity("endnoteReferenceHandler", translator$37);
const tableNodeHandlerEntity = generateV2HandlerEntity("tableNodeHandler", translator$10);
const tableOfContentsHandlerEntity = generateV2HandlerEntity("tableOfContentsHandler", translator$24);
const indexHandlerEntity = generateV2HandlerEntity("indexHandler", translator$25);
const indexEntryHandlerEntity = generateV2HandlerEntity("indexEntryHandler", translator$26);
const bibliographyHandlerEntity = generateV2HandlerEntity("bibliographyHandler", translator$20);
const tableOfAuthoritiesHandlerEntity = generateV2HandlerEntity("tableOfAuthoritiesHandler", translator$22);
const commentRangeStartHandlerEntity = generateV2HandlerEntity("commentRangeStartHandler", commentRangeStartTranslator);
const commentRangeEndHandlerEntity = generateV2HandlerEntity("commentRangeEndHandler", commentRangeEndTranslator);
const permStartHandlerEntity = generateV2HandlerEntity("permStartHandler", translator$15);
const permEndHandlerEntity = generateV2HandlerEntity("permEndHandler", translator$16);
function extractMathText(node) {
	if (!node) return "";
	if (node.type === "text" && typeof node.text === "string") return node.text;
	if (node.name === "m:t" && Array.isArray(node.elements)) return node.elements.map((child) => extractMathText(child)).join("");
	if (Array.isArray(node.elements)) return node.elements.map((child) => extractMathText(child)).join("");
	return "";
}
function extractJustification(oMathParaNode) {
	const paraPr = (oMathParaNode.elements || []).find((el) => el.name === "m:oMathParaPr");
	if (!paraPr || !Array.isArray(paraPr.elements)) return "centerGroup";
	const jc = paraPr.elements.find((el) => el.name === "m:jc");
	if (!jc || !jc.attributes) return "centerGroup";
	return jc.attributes["m:val"] || "center";
}
var handleMathPara = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "m:oMathPara") return {
		nodes: [],
		consumed: 0
	};
	const xmlNode = nodes[0];
	return {
		nodes: [{
			type: "mathBlock",
			attrs: {
				originalXml: carbonCopy(xmlNode),
				textContent: extractMathText(xmlNode),
				justification: extractJustification(xmlNode),
				paragraphProperties: params.extraParams?.inlineParagraphProperties ?? null
			},
			marks: []
		}],
		consumed: 1
	};
};
var handleMathInline = (params) => {
	const { nodes } = params;
	if (!nodes.length || nodes[0].name !== "m:oMath") return {
		nodes: [],
		consumed: 0
	};
	const xmlNode = nodes[0];
	return {
		nodes: [{
			type: "mathInline",
			attrs: {
				originalXml: carbonCopy(xmlNode),
				textContent: extractMathText(xmlNode)
			},
			marks: []
		}],
		consumed: 1
	};
};
var handleMathNode = (params) => {
	const result = handleMathPara(params);
	if (result.consumed > 0) return result;
	return handleMathInline(params);
};
const mathNodeHandlerEntity = {
	handlerName: "mathNodeHandler",
	handler: handleMathNode
};
var PARAGRAPH_IDENTITY_ATTRS = ["sdBlockId", "paraId"];
var TABLE_IDENTITY_ATTRS = [
	"sdBlockId",
	"paraId",
	"blockId"
];
var DEFAULT_BLOCK_IDENTITY_ATTRS = [
	"sdBlockId",
	"blockId",
	"paraId"
];
var SYNTHETIC_PARA_ID_TYPES = new Set(["paragraph", "tableRow"]);
var DOCX_ID_LENGTH = 8;
var MAX_DOCX_ID = 4294967295;
var BLOCK_IDENTITY_ATTRS = {
	paragraph: PARAGRAPH_IDENTITY_ATTRS,
	heading: DEFAULT_BLOCK_IDENTITY_ATTRS,
	listItem: DEFAULT_BLOCK_IDENTITY_ATTRS,
	table: TABLE_IDENTITY_ATTRS,
	tableRow: TABLE_IDENTITY_ATTRS,
	tableCell: TABLE_IDENTITY_ATTRS,
	tableHeader: TABLE_IDENTITY_ATTRS,
	sdt: DEFAULT_BLOCK_IDENTITY_ATTRS,
	structuredContentBlock: DEFAULT_BLOCK_IDENTITY_ATTRS
};
function toIdentityValue(value) {
	if (typeof value === "string" && value.length > 0) return value;
	if (typeof value === "number" && Number.isFinite(value)) return String(value);
}
function getBlockIdentityAttrsForType(typeName) {
	if (!typeName) return [];
	return BLOCK_IDENTITY_ATTRS[typeName] ?? [];
}
function shouldSynthesizeParaIdForType(typeName) {
	return Boolean(typeName && SYNTHETIC_PARA_ID_TYPES.has(typeName));
}
function getExplicitIdentityEntries(attrs, typeName) {
	const attrPriority = getBlockIdentityAttrsForType(typeName);
	if (attrPriority.length === 0) return [];
	const safeAttrs = attrs && typeof attrs === "object" ? attrs : {};
	const identityEntries = [];
	for (const attr of attrPriority) {
		const value = toIdentityValue(safeAttrs[attr]);
		if (value) identityEntries.push({
			attr,
			value
		});
	}
	return identityEntries;
}
function groupIdentityEntriesByValue(identityEntries) {
	const groupsByValue = /* @__PURE__ */ new Map();
	for (const entry of identityEntries) {
		const existingGroup = groupsByValue.get(entry.value);
		if (existingGroup) {
			existingGroup.attrs.push(entry.attr);
			continue;
		}
		groupsByValue.set(entry.value, {
			value: entry.value,
			attrs: [entry.attr]
		});
	}
	return [...groupsByValue.values()];
}
function createDeterministicDocxIdAllocator(reservedIds) {
	let nextValue = 1;
	return () => {
		while (nextValue <= MAX_DOCX_ID) {
			const id = nextValue.toString(16).toUpperCase().padStart(DOCX_ID_LENGTH, "0");
			nextValue += 1;
			if (reservedIds.has(id)) continue;
			reservedIds.add(id);
			return id;
		}
		throw new Error("Unable to allocate a unique synthetic DOCX block id.");
	};
}
function collectExplicitBlockIdentities(node, reservedIds) {
	if (!node || typeof node !== "object") return;
	const identityEntries = getExplicitIdentityEntries(node.attrs, node?.type);
	for (const { value } of groupIdentityEntriesByValue(identityEntries)) reservedIds.add(value);
	if (Array.isArray(node.content)) node.content.forEach((child) => collectExplicitBlockIdentities(child, reservedIds));
}
function setBlockIdentity(node, attrName, value) {
	node.attrs = {
		...node.attrs ?? {},
		[attrName]: value
	};
}
function normalizeBlockIdentitiesInNode(node, seenIds, allocateDocxId) {
	if (!node || typeof node !== "object") return;
	const groupedIdentities = groupIdentityEntriesByValue(getExplicitIdentityEntries(node.attrs, node?.type));
	if (groupedIdentities.length > 0) for (const identityGroup of groupedIdentities) if (seenIds.has(identityGroup.value)) {
		const replacementId = allocateDocxId();
		for (const attr of identityGroup.attrs) setBlockIdentity(node, attr, replacementId);
		seenIds.add(replacementId);
	} else seenIds.add(identityGroup.value);
	else if (shouldSynthesizeParaIdForType(node?.type)) {
		const syntheticParaId = allocateDocxId();
		setBlockIdentity(node, "paraId", syntheticParaId);
		seenIds.add(syntheticParaId);
	}
	if (Array.isArray(node.content)) node.content.forEach((child) => normalizeBlockIdentitiesInNode(child, seenIds, allocateDocxId));
}
function normalizeDuplicateBlockIdentitiesInContent(content$2 = []) {
	if (!Array.isArray(content$2) || content$2.length === 0) return content$2;
	const reservedIds = /* @__PURE__ */ new Set();
	content$2.forEach((node) => collectExplicitBlockIdentities(node, reservedIds));
	const allocateDocxId = createDeterministicDocxIdAllocator(reservedIds);
	const seenIds = /* @__PURE__ */ new Set();
	content$2.forEach((node) => normalizeBlockIdentitiesInNode(node, seenIds, allocateDocxId));
	return content$2;
}
var WORD_2012_NAMESPACE = "http://schemas.microsoft.com/office/word/2012/wordml";
function patchNumberingDefinitions(docx) {
	const numberingXml = docx?.["word/numbering.xml"];
	if (!numberingXml) return;
	const numberingRoot = getNumberingRoot(numberingXml);
	if (!numberingRoot?.elements?.length) return;
	const numberingElements = numberingRoot.elements;
	const existingAbstractIds = /* @__PURE__ */ new Set();
	for (const el of numberingElements) {
		if (el?.name !== "w:abstractNum") continue;
		const abstractId = getAbstractIdFromAbstractNode(el);
		if (abstractId) existingAbstractIds.add(abstractId);
	}
	const missingAbstractIds = /* @__PURE__ */ new Set();
	for (const el of numberingElements) {
		if (el?.name !== "w:num") continue;
		const abstractId = getAbstractIdFromNum(el);
		if (!abstractId) continue;
		if (!existingAbstractIds.has(abstractId)) missingAbstractIds.add(abstractId);
	}
	if (!missingAbstractIds.size) return;
	numberingRoot.attributes = numberingRoot.attributes || {};
	if (!numberingRoot.attributes["xmlns:w15"]) numberingRoot.attributes["xmlns:w15"] = WORD_2012_NAMESPACE;
	const firstNumIndex = numberingElements.findIndex((el) => el?.name === "w:num");
	let insertIndex = firstNumIndex === -1 ? numberingElements.length : firstNumIndex;
	const sortedMissingIds = Array.from(missingAbstractIds).sort((a, b) => {
		const aNum = Number(a);
		const bNum = Number(b);
		const aIsNum = !Number.isNaN(aNum);
		const bIsNum = !Number.isNaN(bNum);
		if (aIsNum && bIsNum) return aNum - bNum;
		if (aIsNum) return -1;
		if (bIsNum) return 1;
		return a.localeCompare(b);
	});
	for (const abstractId of sortedMissingIds) {
		if (existingAbstractIds.has(abstractId)) continue;
		const newAbstract = deepClone$1(baseOrderedListDef);
		newAbstract.attributes = {
			...newAbstract.attributes || {},
			"w:abstractNumId": String(abstractId)
		};
		numberingElements.splice(insertIndex, 0, newAbstract);
		insertIndex += 1;
		existingAbstractIds.add(abstractId);
	}
}
var deepClone$1 = (value) => JSON.parse(JSON.stringify(value));
var getNumberingRoot = (numberingXml) => {
	if (!numberingXml?.elements?.length) return null;
	return numberingXml.elements.find((el) => el?.name === "w:numbering") || numberingXml.elements[0] || null;
};
var getAbstractIdFromNum = (numNode) => {
	const abstractVal = (numNode?.elements?.find((child) => child?.name === "w:abstractNumId"))?.attributes?.["w:val"];
	return abstractVal == null ? null : String(abstractVal);
};
var getAbstractIdFromAbstractNode = (abstractNode) => {
	const raw = abstractNode?.attributes?.["w:abstractNumId"];
	return raw == null ? null : String(raw);
};
var DECIMAL = /^\d+$/;
const TRACKED_CHANGE_SOURCE_ID_MAP_PROPERTY = "SuperdocTrackedChangeSourceIds";
function isDecimalWordId(value) {
	if (value == null) return false;
	const str = String(value).trim();
	if (!str) return false;
	return DECIMAL.test(str);
}
function createWordIdAllocator() {
	const stateByPart = /* @__PURE__ */ new Map();
	const ensureState = (partPath) => {
		const key = typeof partPath === "string" && partPath.length > 0 ? partPath : "word/document.xml";
		let state = stateByPart.get(key);
		if (!state) {
			state = {
				reservedDecimal: /* @__PURE__ */ new Set(),
				nextDecimal: 1,
				assignedByLogicalId: /* @__PURE__ */ new Map(),
				sourceIdByWordId: /* @__PURE__ */ new Map()
			};
			stateByPart.set(key, state);
		}
		return state;
	};
	const recordSourceIdRewrite = (state, sourceId, wordId) => {
		if (sourceId == null) return;
		const source = String(sourceId).trim();
		if (!source || isDecimalWordId(source)) return;
		state.sourceIdByWordId.set(String(wordId), source);
	};
	const reserve = (partPath, sourceId) => {
		if (!isDecimalWordId(sourceId)) return;
		const state = ensureState(partPath);
		const n = Number(String(sourceId).trim());
		if (!Number.isFinite(n) || n < 0) return;
		state.reservedDecimal.add(n);
	};
	const reserveAll = (entries) => {
		if (!entries) return;
		for (const entry of entries) reserve(entry?.partPath, entry?.sourceId);
	};
	const allocate = ({ partPath, sourceId, logicalId }) => {
		const state = ensureState(partPath);
		if (isDecimalWordId(sourceId)) {
			const asString$1 = String(sourceId).trim();
			const n$1 = Number(asString$1);
			state.reservedDecimal.add(n$1);
			if (logicalId) state.assignedByLogicalId.set(logicalId, n$1);
			return asString$1;
		}
		if (logicalId && state.assignedByLogicalId.has(logicalId)) {
			const assigned = state.assignedByLogicalId.get(logicalId);
			if (typeof assigned === "number") {
				recordSourceIdRewrite(state, sourceId, assigned);
				return String(assigned);
			}
		}
		let n = state.nextDecimal;
		while (state.reservedDecimal.has(n)) n++;
		state.reservedDecimal.add(n);
		state.nextDecimal = n + 1;
		if (logicalId) state.assignedByLogicalId.set(logicalId, n);
		recordSourceIdRewrite(state, sourceId, n);
		return String(n);
	};
	const getSourceIdMap = () => {
		const out = {};
		for (const [part, state] of stateByPart.entries()) {
			if (state.sourceIdByWordId.size === 0) continue;
			out[part] = Object.fromEntries([...state.sourceIdByWordId.entries()].sort(([a], [b]) => a.localeCompare(b)));
		}
		return out;
	};
	const __snapshot = () => {
		const out = {};
		for (const [part, state] of stateByPart.entries()) out[part] = {
			reservedDecimal: [...state.reservedDecimal].sort((a, b) => a - b),
			nextDecimal: state.nextDecimal
		};
		return out;
	};
	return {
		reserve,
		reserveAll,
		allocate,
		isDecimal: isDecimalWordId,
		getSourceIdMap,
		__snapshot
	};
}
var OFFICE_DOCUMENT_RELATIONSHIP = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument";
var SUPERDOC_DOCUMENT_ORIGIN_PROPERTY$1 = "SuperdocDocumentOrigin";
var STORED_DOCUMENT_ORIGINS$1 = new Set([
	"word",
	"google-docs",
	"unknown",
	"superdoc"
]);
var listPackageRelationships = (docx) => {
	try {
		const relationships = docx?.["_rels/.rels"]?.elements?.find((el) => matchesElementName(el?.name, "Relationships"));
		return Array.isArray(relationships?.elements) ? relationships.elements.filter((el) => matchesElementName(el?.name, "Relationship")) : [];
	} catch {
		return [];
	}
};
var looksLikeGoogleDocsMinimalPackage = (docx) => {
	const packageRelationships = listPackageRelationships(docx);
	if (packageRelationships.length !== 1) return false;
	if (packageRelationships[0]?.attributes?.Type !== OFFICE_DOCUMENT_RELATIONSHIP) return false;
	return !docx?.["docProps/app.xml"] && !docx?.["docProps/core.xml"] && !docx?.["word/webSettings.xml"];
};
var detectDocumentOrigin = (docx) => {
	const storedOrigin = readCustomProperty(docx, SUPERDOC_DOCUMENT_ORIGIN_PROPERTY$1);
	if (storedOrigin && STORED_DOCUMENT_ORIGINS$1.has(storedOrigin)) return storedOrigin;
	if (readCustomProperty(docx, "SuperdocVersion") || readCustomProperty(docx, "SuperdocTrackedChangeSourceIds")) return "superdoc";
	const commentsExtended = docx["word/commentsExtended.xml"];
	if (commentsExtended) {
		const { elements: initialElements = [] } = commentsExtended;
		if (initialElements?.length > 0) {
			const { elements = [] } = initialElements[0] ?? {};
			if (elements.filter((el) => el.name === "w15:commentEx").length > 0) return "word";
		}
	}
	if (docx["word/comments.xml"] && !commentsExtended) return "google-docs";
	if (looksLikeGoogleDocsMinimalPackage(docx)) return "google-docs";
	return "unknown";
};
var matchesElementName = (name, localName) => {
	if (typeof name !== "string") return false;
	return name === localName || name.endsWith(`:${localName}`);
};
function readCustomProperty(docx, propertyName) {
	try {
		const value = (((docx?.["docProps/custom.xml"])?.elements?.find((el) => matchesElementName(el?.name, "Properties")))?.elements?.find((el) => matchesElementName(el?.name, "property") && el?.attributes?.name === propertyName))?.elements?.[0]?.elements?.[0]?.text;
		return typeof value === "string" && value.length > 0 ? value : null;
	} catch {
		return null;
	}
}
var parseTrackedChangeSourceIdMap = (raw) => {
	if (typeof raw !== "string" || raw.length === 0) return /* @__PURE__ */ new Map();
	try {
		const parsed = JSON.parse(raw);
		const parts = parsed && typeof parsed === "object" ? parsed.parts : null;
		if (!parts || typeof parts !== "object") return /* @__PURE__ */ new Map();
		const byPart = /* @__PURE__ */ new Map();
		for (const [partPath, entries] of Object.entries(parts)) {
			if (!partPath || !entries || typeof entries !== "object") continue;
			const byWordId = /* @__PURE__ */ new Map();
			for (const [wordId, sourceId] of Object.entries(entries)) if (typeof sourceId === "string" && sourceId.length > 0) byWordId.set(wordId, sourceId);
			if (byWordId.size > 0) byPart.set(partPath, byWordId);
		}
		return byPart;
	} catch {
		return /* @__PURE__ */ new Map();
	}
};
var readTrackedChangeSourceIdMap = (docx) => parseTrackedChangeSourceIdMap(readCustomProperty(docx, TRACKED_CHANGE_SOURCE_ID_MAP_PROPERTY));
var normalizeDocumentBackgroundColor = (value) => {
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	if (!/^[0-9a-fA-F]{6}$/.test(trimmed)) return null;
	return `#${trimmed.toUpperCase()}`;
};
var getDocumentBackground = (documentNode) => {
	const background = documentNode?.elements?.find((el) => el?.name === "w:background");
	const color = normalizeDocumentBackgroundColor(background?.attributes?.["w:color"] ?? background?.attributes?.color);
	if (!background || !color) return null;
	return {
		color,
		originalXml: carbonCopy(background)
	};
};
var detectCommentThreadingProfile = (docx) => {
	const hasCommentsExtended = !!docx["word/commentsExtended.xml"];
	const hasCommentsExtensible = !!docx["word/commentsExtensible.xml"];
	const hasCommentsIds = !!docx["word/commentsIds.xml"];
	return {
		defaultStyle: hasCommentsExtended ? "commentsExtended" : "range-based",
		mixed: false,
		fileSet: {
			hasCommentsExtended,
			hasCommentsExtensible,
			hasCommentsIds
		}
	};
};
const createDocumentJson = (docx, converter, editor) => {
	const json = carbonCopy(getInitialJSON(docx));
	if (!json) return null;
	const documentBackground = getDocumentBackground(json.elements?.[0]);
	if (converter) {
		importFootnotePropertiesFromSettings(docx, converter);
		importViewSettingFromSettings(docx, converter);
		converter.documentOrigin = detectDocumentOrigin(docx);
		converter.commentThreadingProfile = detectCommentThreadingProfile(docx);
		converter.trackedChangeSourceIdMapByPart = readTrackedChangeSourceIdMap(docx);
	}
	const nodeListHandler = defaultNodeListHandler();
	const bodyNode = json.elements[0].elements.find((el) => el.name === "w:body");
	if (bodyNode) {
		ensureSectionProperties(bodyNode);
		const node = bodyNode;
		const { processedNodes } = preProcessNodesForFldChar(node.elements ?? [], docx);
		node.elements = processedNodes;
		const bodySectPr = node.elements?.find((n) => n.name === "w:sectPr");
		const bodySectPrElements = bodySectPr?.elements ?? [];
		if (converter) {
			converter.importedBodyHasHeaderRef = bodySectPrElements.some((el) => el?.name === "w:headerReference");
			converter.importedBodyHasFooterRef = bodySectPrElements.some((el) => el?.name === "w:footerReference");
		}
		const content$2 = pruneIgnoredNodes(node.elements?.filter((n) => n.name !== "w:sectPr") ?? []);
		const lists = {};
		const inlineDocumentFonts = [];
		patchNumberingDefinitions(docx);
		const numbering = getNumberingDefinitions(docx);
		const trackedChangeIdMapOptions = { replacements: converter.trackedChangesOptions?.replacements ?? "paired" };
		converter.trackedChangeIdMapsByPart = buildTrackedChangeIdMapsByPart(docx, trackedChangeIdMapOptions);
		converter.trackedChangeIdMap = converter.trackedChangeIdMapsByPart.get("word/document.xml") ?? buildTrackedChangeIdMap(docx, trackedChangeIdMapOptions);
		const comments = importCommentData({
			docx,
			nodeListHandler,
			converter,
			editor
		});
		const footnotes = importFootnoteData({
			docx,
			nodeListHandler,
			converter,
			editor,
			numbering
		});
		const endnotes = importEndnoteData({
			docx,
			nodeListHandler,
			converter,
			editor,
			numbering
		});
		const translatedLinkedStyles = translateStyleDefinitions(docx);
		const translatedNumbering = translateNumberingDefinitions(docx);
		const importDiagnosticsCollectionId = startCollection();
		let parsedContent = nodeListHandler.handler({
			nodes: content$2,
			nodeListHandler,
			docx,
			converter,
			numbering,
			translatedNumbering,
			translatedLinkedStyles,
			editor,
			inlineDocumentFonts,
			lists,
			path: [],
			extraParams: { importDiagnosticsCollectionId }
		});
		const importDiagnostics = drainDiagnostics(importDiagnosticsCollectionId);
		parsedContent = filterOutRootInlineNodes(parsedContent);
		parsedContent = normalizeTableBookmarksInContent(parsedContent, editor);
		collapseWhitespaceNextToInlinePassthrough(parsedContent);
		parsedContent = normalizeDuplicateBlockIdentitiesInContent(parsedContent);
		const result = {
			type: "doc",
			content: parsedContent,
			attrs: {
				attributes: json.elements[0].attributes,
				...bodySectPr ? { bodySectPr } : {},
				...documentBackground ? { documentBackground } : {}
			}
		};
		const pageStyles = getDocumentStyles(node, docx, converter, editor, numbering, translatedNumbering, translatedLinkedStyles);
		if (documentBackground) pageStyles.documentBackground = { color: documentBackground.color };
		return {
			pmDoc: result,
			savedTagsToRestore: node,
			pageStyles,
			comments,
			footnotes,
			endnotes,
			inlineDocumentFonts,
			linkedStyles: getStyleDefinitions(docx, converter, editor),
			translatedLinkedStyles,
			numbering: getNumberingDefinitions(docx, converter),
			translatedNumbering,
			themeColors: getThemeColorPalette(docx),
			importDiagnostics
		};
	}
	return null;
};
const defaultNodeListHandler = () => {
	const entities = [
		alternateChoiceHandler,
		runNodeHandlerEntity,
		pictNodeHandlerEntity,
		paragraphNodeHandlerEntity,
		textNodeHandlerEntity,
		lineBreakNodeHandlerEntity,
		sdtNodeHandlerEntity,
		bookmarkStartNodeHandlerEntity,
		bookmarkEndNodeHandlerEntity,
		hyperlinkNodeHandlerEntity,
		commentRangeStartHandlerEntity,
		commentRangeEndHandlerEntity,
		drawingNodeHandlerEntity,
		trackChangeNodeHandlerEntity,
		tableNodeHandlerEntity,
		footnoteReferenceHandlerEntity,
		endnoteReferenceHandlerEntity,
		tabNodeEntityHandler,
		noBreakHyphenNodeEntityHandler,
		smartTagNodeEntityHandler,
		tableOfContentsHandlerEntity,
		indexHandlerEntity,
		bibliographyHandlerEntity,
		tableOfAuthoritiesHandlerEntity,
		indexEntryHandlerEntity,
		autoPageHandlerEntity,
		autoTotalPageCountEntity,
		sectionPageCountEntity,
		documentStatFieldHandlerEntity,
		pageReferenceEntity,
		crossReferenceEntity,
		sequenceFieldEntity,
		permStartHandlerEntity,
		permEndHandlerEntity,
		mathNodeHandlerEntity,
		passthroughNodeHandlerEntity
	];
	return {
		handler: createNodeListHandler(entities),
		handlerEntities: entities
	};
};
var createNodeListHandler = (nodeHandlers$1) => {
	const getSafeElementContext = (elements, index, processedNode, path) => {
		if (!elements || index < 0 || index >= elements.length) return {
			elementIndex: index,
			error: "index_out_of_bounds",
			arrayLength: elements?.length
		};
		return {
			elementName: elements[index]?.name,
			attributes: processedNode?.attrs,
			marks: processedNode?.marks,
			elementPath: path,
			type: processedNode?.type,
			content: processedNode?.content
		};
	};
	const nodeListHandlerFn = ({ nodes: elements, docx, insideTrackChange, converter, numbering, translatedNumbering, translatedLinkedStyles, editor, filename, parentStyleId, lists, inlineDocumentFonts, importTrackingContext, path = [], extraParams = {} }) => {
		if (!elements || !elements.length) return [];
		const filteredElements = pruneIgnoredNodes(elements);
		if (!filteredElements.length) return [];
		const processedElements = [];
		try {
			for (let index = 0; index < filteredElements.length; index++) try {
				const nodesToHandle = filteredElements.slice(index);
				if (!nodesToHandle || nodesToHandle.length === 0) continue;
				const { nodes, consumed, unhandled } = nodeHandlers$1.reduce((res, handler$1) => {
					if (res.consumed > 0) return res;
					return handler$1.handler({
						nodes: nodesToHandle,
						docx,
						nodeListHandler: {
							handler: nodeListHandlerFn,
							handlerEntities: nodeHandlers$1
						},
						insideTrackChange,
						converter,
						numbering,
						translatedNumbering,
						translatedLinkedStyles,
						editor,
						filename,
						parentStyleId,
						lists,
						inlineDocumentFonts,
						importTrackingContext,
						path,
						extraParams
					});
				}, {
					nodes: [],
					consumed: 0
				});
				const context = getSafeElementContext(filteredElements, index, nodes[0], `/word/${filename || "document.xml"}`);
				if (unhandled) {
					if (!context.elementName) continue;
					continue;
				} else {
					const hasHighlightMark = nodes[0]?.marks?.find((mark) => mark.type === "highlight");
					if (hasHighlightMark) converter?.docHiglightColors.add(hasHighlightMark.attrs.color.toUpperCase());
				}
				if (consumed > 0) index += consumed - 1;
				if (nodes) nodes.forEach((node) => {
					if (node?.type && !["runProperties"].includes(node.type)) {
						if (node.type === "text" && Array.isArray(node.content) && !node.content.length) return;
						processedElements.push(node);
					}
				});
			} catch (error) {
				console.debug("Import error", error);
				editor?.emit("exception", {
					error,
					editor
				});
			}
			return processedElements;
		} catch (error) {
			console.debug("Error during import", error);
			editor?.emit("exception", {
				error,
				editor
			});
			throw error;
		}
	};
	return nodeListHandlerFn;
};
function parseFootnoteProperties(footnotePrElement, source) {
	if (!footnotePrElement) return null;
	const props = { source };
	(Array.isArray(footnotePrElement.elements) ? footnotePrElement.elements : []).forEach((el) => {
		const val = el?.attributes?.["w:val"];
		switch (el.name) {
			case "w:numFmt":
				if (val) props.numFmt = val;
				break;
			case "w:numStart":
				if (val) props.numStart = val;
				break;
			case "w:numRestart":
				if (val) props.numRestart = val;
				break;
			case "w:pos":
				if (val) props.pos = val;
				break;
		}
	});
	props.originalXml = carbonCopy(footnotePrElement);
	return props;
}
function importFootnotePropertiesFromSettings(docx, converter) {
	if (!docx || !converter || converter.footnoteProperties) return;
	const settingsRoot = docx["word/settings.xml"]?.elements?.[0];
	const footnotePr = (Array.isArray(settingsRoot?.elements) ? settingsRoot.elements : []).find((el) => el?.name === "w:footnotePr");
	if (!footnotePr) return;
	converter.footnoteProperties = parseFootnoteProperties(footnotePr, "settings");
}
function importViewSettingFromSettings(docx, converter) {
	if (!docx || !converter) return;
	converter.viewSetting = null;
	const settingsRoot = docx["word/settings.xml"]?.elements?.[0];
	const viewEl = (Array.isArray(settingsRoot?.elements) ? settingsRoot.elements : []).find((el) => el?.name === "w:view");
	if (!viewEl) return;
	converter.viewSetting = {
		val: viewEl.attributes?.["w:val"] ?? null,
		originalXml: carbonCopy(viewEl)
	};
}
function getDocumentStyles(node, docx, converter, editor, numbering, translatedNumbering, translatedLinkedStyles) {
	const sectPr = node.elements?.find((n) => n.name === "w:sectPr");
	const styles = {};
	sectPr?.elements?.forEach((el) => {
		const { name, attributes } = el;
		switch (name) {
			case "w:pgSz":
				styles["pageSize"] = {
					width: twipsToInches(attributes["w:w"]),
					height: twipsToInches(attributes["w:h"])
				};
				break;
			case "w:pgMar":
				styles["pageMargins"] = {
					top: twipsToInches(attributes["w:top"]),
					right: twipsToInches(attributes["w:right"]),
					bottom: twipsToInches(attributes["w:bottom"]),
					left: twipsToInches(attributes["w:left"]),
					header: twipsToInches(attributes["w:header"]),
					footer: twipsToInches(attributes["w:footer"]),
					gutter: twipsToInches(attributes["w:gutter"])
				};
				break;
			case "w:cols":
				styles["columns"] = {
					space: twipsToInches(attributes["w:space"]),
					num: attributes["w:num"],
					equalWidth: attributes["w:equalWidth"]
				};
				break;
			case "w:docGrid":
				styles["docGrid"] = {
					linePitch: twipsToInches(attributes["w:linePitch"]),
					type: attributes["w:type"]
				};
				break;
			case "w:titlePg":
				converter.headerIds.titlePg = true;
				break;
			case "w:footnotePr":
				if (!converter.footnoteProperties) converter.footnoteProperties = parseFootnoteProperties(el, "sectPr");
				break;
		}
	});
	importHeadersFooters(docx, converter, editor, numbering, translatedNumbering, translatedLinkedStyles);
	styles.alternateHeaders = isAlternatingHeadersOddEven(docx);
	return styles;
}
var DEFAULT_SECTION_PROPS = Object.freeze({
	pageSize: Object.freeze({
		width: "12240",
		height: "15840"
	}),
	pageMargins: Object.freeze({
		top: "1440",
		right: "1440",
		bottom: "1440",
		left: "1440",
		header: "720",
		footer: "720",
		gutter: "0"
	})
});
function ensureSectionProperties(bodyNode) {
	if (!bodyNode.elements) bodyNode.elements = [];
	let sectPr = bodyNode.elements.find((el) => el.name === "w:sectPr");
	if (!sectPr) {
		sectPr = {
			type: "element",
			name: "w:sectPr",
			elements: []
		};
		bodyNode.elements.push(sectPr);
	} else if (!sectPr.elements) sectPr.elements = [];
	const ensureChild$1 = (name, factory) => {
		let child = sectPr.elements.find((el) => el.name === name);
		if (!child) {
			child = factory();
			sectPr.elements.push(child);
		} else if (!child.attributes) child.attributes = {};
		return child;
	};
	const pgSz = ensureChild$1("w:pgSz", () => ({
		type: "element",
		name: "w:pgSz",
		attributes: {}
	}));
	pgSz.attributes["w:w"] = pgSz.attributes["w:w"] ?? DEFAULT_SECTION_PROPS.pageSize.width;
	pgSz.attributes["w:h"] = pgSz.attributes["w:h"] ?? DEFAULT_SECTION_PROPS.pageSize.height;
	const pgMar = ensureChild$1("w:pgMar", () => ({
		type: "element",
		name: "w:pgMar",
		attributes: {}
	}));
	Object.entries(DEFAULT_SECTION_PROPS.pageMargins).forEach(([key, value]) => {
		const attrKey = `w:${key}`;
		if (pgMar.attributes[attrKey] == null) pgMar.attributes[attrKey] = value;
	});
	return sectPr;
}
function getStyleDefinitions(docx) {
	const styles = docx["word/styles.xml"];
	if (!styles) return [];
	const elements = styles.elements?.[0]?.elements ?? [];
	const styleDefinitions = elements.filter((el) => el.name === "w:style");
	const latentStyles = elements.find((el) => el.name === "w:latentStyles");
	const matchedLatentStyles = [];
	(latentStyles?.elements ?? []).forEach((el) => {
		const { attributes } = el;
		if (styleDefinitions.find((style) => style.attributes["w:styleId"] === attributes["w:name"])) matchedLatentStyles.push(el);
	});
	const allParsedStyles = [];
	styleDefinitions.forEach((style) => {
		const id = style.attributes["w:styleId"];
		const parsedStyle = getDefaultStyleDefinition(id, docx);
		const importedStyle = {
			id: style.attributes["w:styleId"],
			type: style.attributes["w:type"],
			definition: parsedStyle,
			attributes: {}
		};
		allParsedStyles.push(importedStyle);
	});
	return allParsedStyles;
}
function translateStyleDefinitions(docx) {
	const styles = docx["word/styles.xml"];
	if (!styles) return [];
	const stylesElement = styles.elements[0];
	return translator$35.encode({ nodes: [stylesElement] });
}
function translateNumberingDefinitions(docx) {
	const numberingElement = (docx["word/numbering.xml"] ?? baseNumbering).elements[0];
	return translator$36.encode({ nodes: [numberingElement] });
}
function addDefaultStylesIfMissing(styles) {
	if (!styles) return null;
	const updatedStyles = carbonCopy(styles);
	const { elements } = updatedStyles.elements[0];
	Object.keys(DEFAULT_LINKED_STYLES).forEach((styleId) => {
		if (!elements.some((el) => el.attributes?.["w:styleId"] === styleId)) {
			const missingStyle = DEFAULT_LINKED_STYLES[styleId];
			updatedStyles.elements[0].elements.push(missingStyle);
		}
	});
	return updatedStyles;
}
var importHeadersFooters = (docx, converter, mainEditor, numbering, translatedNumbering, translatedLinkedStyles) => {
	const elements = (docx["word/_rels/document.xml.rels"]?.elements?.find((el) => el.name === "Relationships"))?.elements ?? [];
	const headerType = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
	const footerType = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
	const headers = elements.filter((el) => el.attributes?.["Type"] === headerType);
	const footers = elements.filter((el) => el.attributes?.["Type"] === footerType);
	const allSectPrElements = (findSectPr(docx["word/document.xml"]) || []).flatMap((el) => el.elements);
	if (!mainEditor) return;
	const editor = { ...mainEditor };
	editor.options.annotations = true;
	headers.forEach((header) => {
		const { rId, referenceFile, currentFileName } = getHeaderFooterSectionData(header, docx);
		const { processedNodes: headerProcessedNodes } = preProcessPageFieldsOnly(carbonCopy(referenceFile.elements[0].elements ?? []));
		let sectionType = allSectPrElements.find((el) => el.name === "w:headerReference" && el.attributes["r:id"] === rId)?.attributes["w:type"];
		if (converter.headerIds[sectionType]) sectionType = null;
		const nodeListHandler = defaultNodeListHandler();
		let schema = nodeListHandler.handler({
			nodes: headerProcessedNodes,
			nodeListHandler,
			docx,
			converter,
			numbering,
			translatedNumbering,
			translatedLinkedStyles,
			editor,
			filename: currentFileName,
			path: []
		});
		schema = filterOutRootInlineNodes(schema);
		schema = normalizeDuplicateBlockIdentitiesInContent(schema);
		if (!converter.headerIds.ids) converter.headerIds.ids = [];
		converter.headerIds.ids.push(rId);
		converter.headers[rId] = {
			type: "doc",
			content: [...schema]
		};
		if (sectionType) converter.headerIds[sectionType] = rId;
	});
	if (allSectPrElements?.find((el) => el.name === "w:titlePg")) converter.headerIds.titlePg = true;
	footers.forEach((footer) => {
		const { rId, referenceFile, currentFileName } = getHeaderFooterSectionData(footer, docx);
		const { processedNodes: footerProcessedNodes } = preProcessPageFieldsOnly(carbonCopy(referenceFile.elements[0].elements ?? []));
		const sectionType = allSectPrElements.find((el) => el.name === "w:footerReference" && el.attributes["r:id"] === rId)?.attributes["w:type"];
		const nodeListHandler = defaultNodeListHandler();
		let schema = nodeListHandler.handler({
			nodes: footerProcessedNodes,
			nodeListHandler,
			docx,
			converter,
			numbering,
			editor,
			filename: currentFileName,
			path: []
		});
		schema = filterOutRootInlineNodes(schema);
		schema = normalizeDuplicateBlockIdentitiesInContent(schema);
		if (!converter.footerIds.ids) converter.footerIds.ids = [];
		converter.footerIds.ids.push(rId);
		converter.footers[rId] = {
			type: "doc",
			content: [...schema]
		};
		if (sectionType) converter.footerIds[sectionType] = rId;
	});
};
var findSectPr = (obj, result = []) => {
	if (obj && obj.name === "w:sectPr") result.push(obj);
	if (obj && obj.elements) obj.elements.forEach((el) => findSectPr(el, result));
	return result;
};
var getHeaderFooterSectionData = (sectionData, docx) => {
	const rId = sectionData.attributes.Id;
	const target = sectionData.attributes.Target;
	const filePath = resolveOpcTargetPath(target, "word");
	return {
		rId,
		referenceFile: filePath ? docx[filePath] : void 0,
		currentFileName: filePath ? filePath.split("/").pop() : target.split("/").pop()
	};
};
function filterOutRootInlineNodes(content$2 = []) {
	if (!Array.isArray(content$2) || content$2.length === 0) return content$2;
	const INLINE_TYPES = new Set([
		"text",
		"bookmarkStart",
		"bookmarkEnd",
		"lineBreak",
		"hardBreak",
		"pageNumber",
		"totalPageCount",
		"section-page-count",
		"runItem",
		"image",
		"tab",
		"fieldAnnotation",
		"mention",
		"contentBlock",
		"aiLoaderNode",
		"commentRangeStart",
		"commentRangeEnd",
		"commentReference",
		"footnoteReference",
		"structuredContent",
		"permStart",
		"permEnd"
	]);
	const PRESERVABLE_INLINE_XML_NAMES = {
		bookmarkStart: "w:bookmarkStart",
		bookmarkEnd: "w:bookmarkEnd"
	};
	const result = [];
	content$2.forEach((node) => {
		if (!node || typeof node.type !== "string") return;
		const type = node.type;
		const preservableNodeName = PRESERVABLE_INLINE_XML_NAMES[type];
		if (type === "image" && node.attrs?.isAnchor) {
			result.push({
				type: "paragraph",
				content: [node],
				attrs: {},
				marks: []
			});
			return;
		}
		if (type === "permStart" || type === "permEnd") {
			result.push({
				...node,
				type: type === "permStart" ? "permStartBlock" : "permEndBlock"
			});
			return;
		}
		if (!INLINE_TYPES.has(type)) result.push(node);
		else if (preservableNodeName) {
			const originalXml = buildOriginalXml(type, node.attrs, PRESERVABLE_INLINE_XML_NAMES);
			result.push({
				type: "passthroughBlock",
				attrs: {
					originalName: preservableNodeName,
					...originalXml ? { originalXml } : {}
				}
			});
		}
	});
	return result;
}
function normalizeTableBookmarksInContent(content$2 = [], editor) {
	if (!Array.isArray(content$2) || content$2.length === 0) return content$2;
	return content$2.map((node) => normalizeTableBookmarksInNode(node, editor));
}
function normalizeTableBookmarksInNode(node, editor) {
	if (!node || typeof node !== "object") return node;
	if (node.type === "table") node = normalizeTableBookmarksInTable(node, editor);
	if (Array.isArray(node.content)) node = {
		...node,
		content: normalizeTableBookmarksInContent(node.content, editor)
	};
	return node;
}
function parseColIndex(val) {
	if (val == null || val === "") return null;
	const n = parseInt(String(val), 10);
	return Number.isNaN(n) ? null : Math.max(0, n);
}
function getCellIndexForBookmark(bookmarkNode, position, rowCellCount) {
	if (!rowCellCount) return 0;
	if (bookmarkNode?.type === "bookmarkEnd") return position === "start" ? 0 : rowCellCount - 1;
	const attrs = bookmarkNode?.attrs ?? {};
	const col = parseColIndex(position === "start" ? attrs.colFirst : attrs.colLast);
	if (col == null) return position === "start" ? 0 : rowCellCount - 1;
	return Math.min(col, rowCellCount - 1);
}
function addBookmarkToRowCellInlines(rowCellInlines, rowIndex, position, bookmarkNode, rowCellCount) {
	const cellIndex = getCellIndexForBookmark(bookmarkNode, position, rowCellCount);
	const bucket = rowCellInlines[rowIndex][position];
	if (!bucket[cellIndex]) bucket[cellIndex] = [];
	bucket[cellIndex].push(bookmarkNode);
}
function applyBookmarksToRow(rowNode, { start: startByCell, end: endByCell }, editor) {
	const cellIndices = [...new Set([...Object.keys(startByCell).map(Number), ...Object.keys(endByCell).map(Number)])].sort((a, b) => a - b);
	let row = rowNode;
	for (const cellIndex of cellIndices) {
		const startNodes = startByCell[cellIndex];
		const endNodes = endByCell[cellIndex];
		if (startNodes?.length) row = insertInlineIntoRow(row, startNodes, editor, "start", cellIndex);
		if (endNodes?.length) row = insertInlineIntoRow(row, endNodes, editor, "end", cellIndex);
	}
	return row;
}
function normalizeTableBookmarksInTable(tableNode, editor) {
	if (!tableNode || tableNode.type !== "table" || !Array.isArray(tableNode.content)) return tableNode;
	const rows = tableNode.content.filter((child) => child?.type === "tableRow");
	if (!rows.length) return tableNode;
	const rowCellInlines = rows.map(() => ({
		start: {},
		end: {}
	}));
	let rowCursor = 0;
	for (const child of tableNode.content) {
		if (child?.type === "tableRow") {
			rowCursor += 1;
			continue;
		}
		if (isBookmarkNode(child)) {
			const prevRowIndex = rowCursor > 0 ? rowCursor - 1 : null;
			const nextRowIndex = rowCursor < rows.length ? rowCursor : null;
			const rowCellCount = ((nextRowIndex ?? prevRowIndex) != null ? rows[nextRowIndex ?? prevRowIndex] : null)?.content?.length ?? 0;
			if (child.type === "bookmarkStart") {
				if (nextRowIndex != null) addBookmarkToRowCellInlines(rowCellInlines, nextRowIndex, "start", child, rowCellCount);
				else if (prevRowIndex != null) addBookmarkToRowCellInlines(rowCellInlines, prevRowIndex, "end", child, rowCellCount);
			} else if (prevRowIndex != null) addBookmarkToRowCellInlines(rowCellInlines, prevRowIndex, "end", child, rowCellCount);
			else if (nextRowIndex != null) addBookmarkToRowCellInlines(rowCellInlines, nextRowIndex, "start", child, rowCellCount);
		}
	}
	const updatedRows = rows.map((row, index) => applyBookmarksToRow(row, rowCellInlines[index], editor));
	rowCursor = 0;
	const content$2 = [];
	for (const child of tableNode.content) if (child?.type === "tableRow") {
		content$2.push(updatedRows[rowCursor] ?? child);
		rowCursor += 1;
	} else if (!isBookmarkNode(child)) content$2.push(child);
	return {
		...tableNode,
		content: content$2
	};
}
function insertInlineIntoRow(rowNode, inlineNodes, editor, position, cellIndex) {
	if (!rowNode || !inlineNodes?.length) return rowNode;
	if (!Array.isArray(rowNode.content) || rowNode.content.length === 0) {
		const newCell = {
			type: "tableCell",
			content: [{
				type: "paragraph",
				content: inlineNodes
			}],
			attrs: {},
			marks: []
		};
		return {
			...rowNode,
			content: [newCell]
		};
	}
	const lastCellIndex = rowNode.content.length - 1;
	const targetIndex = cellIndex != null ? Math.min(Math.max(0, cellIndex), lastCellIndex) : position === "end" ? lastCellIndex : 0;
	const targetCell = rowNode.content[targetIndex];
	const updatedCell = insertInlineIntoCell(targetCell, inlineNodes, editor, position);
	if (updatedCell === targetCell) return rowNode;
	const nextContent = rowNode.content.slice();
	nextContent[targetIndex] = updatedCell;
	return {
		...rowNode,
		content: nextContent
	};
}
function findTextblockIndex(content$2, editor, fromEnd) {
	const start = fromEnd ? content$2.length - 1 : 0;
	const end = fromEnd ? -1 : content$2.length;
	const step$1 = fromEnd ? -1 : 1;
	for (let i$1 = start; fromEnd ? i$1 > end : i$1 < end; i$1 += step$1) if (isTextblockNode(content$2[i$1], editor)) return i$1;
	return -1;
}
function insertInlineIntoCell(cellNode, inlineNodes, editor, position) {
	if (!cellNode || !inlineNodes?.length) return cellNode;
	const content$2 = Array.isArray(cellNode.content) ? cellNode.content.slice() : [];
	const targetIndex = findTextblockIndex(content$2, editor, position === "end");
	if (targetIndex === -1) {
		const paragraph = {
			type: "paragraph",
			content: inlineNodes
		};
		if (position === "end") content$2.push(paragraph);
		else content$2.unshift(paragraph);
		return {
			...cellNode,
			content: content$2
		};
	}
	const targetBlock = content$2[targetIndex] || {
		type: "paragraph",
		content: []
	};
	const blockContent = Array.isArray(targetBlock.content) ? targetBlock.content.slice() : [];
	const nextBlockContent = position === "end" ? blockContent.concat(inlineNodes) : inlineNodes.concat(blockContent);
	content$2[targetIndex] = {
		...targetBlock,
		content: nextBlockContent
	};
	return {
		...cellNode,
		content: content$2
	};
}
function isBookmarkNode(node) {
	const typeName = node?.type;
	return typeName === "bookmarkStart" || typeName === "bookmarkEnd";
}
function isTextblockNode(node, editor) {
	const typeName = node?.type;
	if (!typeName) return false;
	const nodeType = editor?.schema?.nodes?.[typeName];
	if (nodeType && typeof nodeType.isTextblock === "boolean") return nodeType.isTextblock;
	return typeName === "paragraph";
}
var buildOriginalXml = (type, attrs, preservableTags) => {
	const configs = {
		bookmarkStart: attributes_default,
		bookmarkEnd: attributes_default$1
	}[type];
	if (!configs) return null;
	const xmlAttrs = {};
	configs.forEach((cfg) => {
		const val = cfg.decode(attrs || {});
		if (val !== void 0) xmlAttrs[cfg.xmlName] = val;
	});
	const attributes = Object.keys(xmlAttrs).length ? xmlAttrs : void 0;
	return {
		name: preservableTags[type],
		...attributes ? { attributes } : {},
		elements: []
	};
};
function collapseWhitespaceNextToInlinePassthrough(content$2 = []) {
	if (!Array.isArray(content$2) || content$2.length === 0) return;
	const sequence = collectInlineSequence(content$2);
	sequence.forEach((entry, index) => {
		if (entry.kind !== "passthrough") return;
		const prev = findNeighborText(sequence, index, -1);
		const next = findNeighborText(sequence, index, 1);
		if (!prev || !next) return;
		if (!prev.node.text.endsWith(" ") || !next.node.text.startsWith(" ")) return;
		prev.node.text = prev.node.text.replace(/ +$/, " ");
		next.node.text = next.node.text.replace(/^ +/, "");
		if (next.node.text.length === 0) next.parent.splice(next.index, 1);
	});
}
function collectInlineSequence(nodes, result = [], insidePassthrough = false) {
	if (!Array.isArray(nodes) || nodes.length === 0) return result;
	nodes.forEach((node, index) => {
		if (!node) return;
		const isPassthrough = node.type === "passthroughInline";
		if (isPassthrough && !insidePassthrough) result.push({
			kind: "passthrough",
			parent: nodes,
			index
		});
		if (node.type === "text" && typeof node.text === "string" && !insidePassthrough) result.push({
			kind: "text",
			node,
			parent: nodes,
			index
		});
		if (Array.isArray(node.content) && node.content.length) {
			const nextInside = insidePassthrough || isPassthrough;
			collectInlineSequence(node.content, result, nextInside);
		}
	});
	return result;
}
function findNeighborText(sequence, startIndex, direction) {
	let cursor = startIndex + direction;
	while (cursor >= 0 && cursor < sequence.length) {
		const entry = sequence[cursor];
		if (entry.kind === "text") return entry;
		cursor += direction;
	}
	return null;
}
function getThemeColorPalette(docx) {
	const themePart = docx?.["word/theme/theme1.xml"];
	if (!themePart || !Array.isArray(themePart.elements)) return void 0;
	const clrScheme = (themePart.elements.find((el) => el.name === "a:theme")?.elements?.find((el) => el.name === "a:themeElements"))?.elements?.find((el) => el.name === "a:clrScheme");
	if (!clrScheme || !Array.isArray(clrScheme.elements)) return void 0;
	const palette = {};
	clrScheme.elements.forEach((colorNode) => {
		const rawName = colorNode?.name;
		if (!rawName) return;
		const colorName = rawName.replace(/^a:/, "");
		if (!colorName) return;
		const valueNode = Array.isArray(colorNode.elements) ? colorNode.elements.find((el) => el.attributes && (el.attributes.val || el.attributes.lastClr)) : void 0;
		const colorValue = valueNode?.attributes?.val || valueNode?.attributes?.lastClr;
		if (!colorValue) return;
		const normalized = String(colorValue).trim();
		if (!normalized) return;
		palette[colorName] = `#${normalized.toUpperCase()}`;
	});
	return Object.keys(palette).length ? palette : void 0;
}
function getNumberingDefinitions(docx, converter) {
	const cache = ensureNumberingCache(docx, converter);
	const abstractDefinitions = {};
	cache.abstractById.forEach((value, key) => {
		const numericKey = Number(key);
		if (!Number.isNaN(numericKey)) abstractDefinitions[numericKey] = value;
	});
	let importListDefs = {};
	cache.numNodesById.forEach((value, key) => {
		const numericKey = Number(key);
		if (Number.isInteger(numericKey)) importListDefs[numericKey] = value;
	});
	return {
		abstracts: abstractDefinitions,
		definitions: importListDefs
	};
}
var ST_ON_OFF_TRUE_VALUES = new Set([
	"1",
	"true",
	"on"
]);
var isStOnOffEnabled = (element) => {
	if (!element) return false;
	const rawValue = element.attributes?.["w:val"];
	if (rawValue == null) return true;
	return ST_ON_OFF_TRUE_VALUES.has(String(rawValue).trim().toLowerCase());
};
const resolveEvenAndOddHeadersFromSettingsPart = (settingsPart) => {
	if (!settingsPart || typeof settingsPart !== "object") return null;
	const part = settingsPart;
	const settingsRoot = part.name === "w:settings" ? part : part.elements?.find((entry) => entry?.name === "w:settings");
	if (!settingsRoot?.elements?.length) return null;
	const evenOdd = settingsRoot.elements.find((el) => el?.name === "w:evenAndOddHeaders");
	if (!evenOdd) return null;
	return isStOnOffEnabled(evenOdd);
};
const isAlternatingHeadersOddEven = (docx) => {
	const settings = docx["word/settings.xml"];
	if (!settings) return false;
	return resolveEvenAndOddHeadersFromSettingsPart(settings) ?? false;
};
function handleShapeTextboxImport({ params, pict }) {
	const shape = pict.elements?.find((el) => el.name === "v:shape");
	const schemaAttrs = {};
	const schemaTextboxAttrs = {};
	const shapeAttrs = shape.attributes || {};
	schemaAttrs.attributes = shapeAttrs;
	if (shapeAttrs.fillcolor) schemaAttrs.fillcolor = shapeAttrs.fillcolor;
	const parsedStyle = parseInlineStyles(shapeAttrs.style);
	const shapeStyle = buildStyles(parsedStyle);
	const positionData = extractPositionData(parsedStyle);
	if (shapeStyle) schemaAttrs.style = shapeStyle;
	if (positionData.anchorData) schemaAttrs.anchorData = positionData.anchorData;
	if (positionData.marginOffset) schemaAttrs.marginOffset = positionData.marginOffset;
	const textbox = shape.elements?.find((el) => el.name === "v:textbox");
	const wrap$1 = shape.elements?.find((el) => el.name === "w10:wrap");
	if (wrap$1?.attributes) schemaAttrs.wrapAttributes = wrap$1.attributes;
	if (textbox?.attributes) schemaTextboxAttrs.attributes = textbox.attributes;
	const textboxContent = textbox?.elements?.find((el) => el.name === "w:txbxContent");
	return {
		type: "shapeContainer",
		attrs: schemaAttrs,
		content: [{
			type: "shapeTextbox",
			attrs: schemaTextboxAttrs,
			content: collectTextBoxParagraphs(preProcessTextBoxContent(textboxContent, params)?.elements || []).map((elem) => handleParagraphNode$1({
				nodes: [elem],
				docx: params.docx,
				nodeListHandler: defaultNodeListHandler()
			})).reduce((acc, current) => [...acc, ...current.nodes], [])
		}]
	};
}
function buildStyles(styleObject) {
	const allowed = ["width", "height"];
	let style = "";
	for (const [prop, value] of Object.entries(styleObject)) if (allowed.includes(prop)) style += `${prop}: ${value};`;
	return style;
}
function extractPositionData(styleObject) {
	const anchorData = {};
	const marginOffset = {};
	if (styleObject["mso-position-horizontal"]) anchorData.alignH = styleObject["mso-position-horizontal"];
	if (styleObject["mso-position-horizontal-relative"]) anchorData.hRelativeFrom = styleObject["mso-position-horizontal-relative"];
	if (styleObject["mso-position-vertical"]) anchorData.alignV = styleObject["mso-position-vertical"];
	if (styleObject["mso-position-vertical-relative"]) anchorData.vRelativeFrom = styleObject["mso-position-vertical-relative"];
	if (styleObject["margin-left"] != null) marginOffset.horizontal = convertToPixels$2(styleObject["margin-left"]);
	if (styleObject["margin-top"] != null) marginOffset.top = convertToPixels$2(styleObject["margin-top"]);
	return {
		...Object.keys(anchorData).length > 0 ? { anchorData } : {},
		...Object.keys(marginOffset).length > 0 ? { marginOffset } : {}
	};
}
function convertToPixels$2(value) {
	const num = parseFloat(value);
	if (Number.isNaN(num)) return 0;
	if (value.endsWith("pt")) return num * 96 / 72;
	if (value.endsWith("in")) return num * 96;
	if (value.endsWith("px")) return num;
	return num;
}
function handleShapeImageWatermarkImport({ params, pict }) {
	const shape = pict.elements?.find((el) => el.name === "v:shape");
	if (!shape) return null;
	const imagedata = shape.elements?.find((el) => el.name === "v:imagedata");
	if (!imagedata) return null;
	const { docx, filename } = params;
	const shapeAttrs = shape.attributes || {};
	const imagedataAttrs = imagedata.attributes || {};
	const rId = imagedataAttrs["r:id"];
	if (!rId) {
		console.warn("v:imagedata missing r:id attribute");
		return null;
	}
	let rels = docx[`word/_rels/${filename || "document.xml"}.rels`];
	if (!rels) rels = docx[`word/_rels/document.xml.rels`];
	const { elements } = rels?.elements?.find((el) => el.name === "Relationships") || [];
	const rel = elements?.find((el) => el.attributes["Id"] === rId);
	if (!rel) {
		console.warn(`Relationship not found for r:id="${rId}"`);
		return null;
	}
	const targetPath = rel.attributes["Target"];
	const normalizedPath = normalizeTargetPath(targetPath);
	const style = shapeAttrs.style || "";
	const styleObj = parseVmlStyle$1(style);
	const width = styleObj.width || "100px";
	const height = styleObj.height || "100px";
	const position = {
		type: styleObj.position || "absolute",
		marginLeft: styleObj["margin-left"] || "0",
		marginTop: styleObj["margin-top"] || "0"
	};
	const zIndex = styleObj["z-index"] ? parseInt(styleObj["z-index"], 10) : void 0;
	const hPosition = styleObj["mso-position-horizontal"] || "center";
	const vPosition = styleObj["mso-position-vertical"] || "center";
	const hRelativeTo = styleObj["mso-position-horizontal-relative"] || "margin";
	const vRelativeTo = styleObj["mso-position-vertical-relative"] || "margin";
	const gain = imagedataAttrs["gain"];
	const blacklevel = imagedataAttrs["blacklevel"];
	const title = imagedataAttrs["o:title"] || "Watermark";
	const passthroughElements = pict.elements.filter((el) => el !== shape);
	const imageNode = {
		type: "image",
		attrs: {
			isPict: true,
			src: normalizedPath,
			alt: title,
			extension: normalizedPath.substring(normalizedPath.lastIndexOf(".") + 1),
			title,
			rId,
			vmlWatermark: true,
			vmlStyle: style,
			vmlAttributes: shapeAttrs,
			vmlImagedata: imagedataAttrs,
			isAnchor: true,
			inline: false,
			wrap: {
				type: "None",
				attrs: { behindDoc: Number.isFinite(zIndex) ? zIndex < 0 : true }
			},
			anchorData: {
				hRelativeFrom: hRelativeTo,
				vRelativeFrom: vRelativeTo,
				alignH: hPosition,
				alignV: vPosition
			},
			size: {
				width: convertToPixels$1(width),
				height: convertToPixels$1(height)
			},
			marginOffset: {
				horizontal: convertToPixels$1(position.marginLeft),
				top: convertToPixels$1(position.marginTop)
			},
			...gain && { gain },
			...blacklevel && { blacklevel }
		}
	};
	if (passthroughElements.length > 0) imageNode.attrs.passthroughSiblings = passthroughElements.map((node) => carbonCopy(node));
	return imageNode;
}
function normalizeTargetPath(targetPath = "") {
	if (!targetPath) return targetPath;
	const trimmed = targetPath.replace(/^\/+/, "");
	if (trimmed.startsWith("word/")) return trimmed;
	if (trimmed.startsWith("media/")) return `word/${trimmed}`;
	return `word/${trimmed}`;
}
function parseVmlStyle$1(style) {
	const result = {};
	if (!style) return result;
	const declarations = style.split(";").filter((s) => s.trim());
	for (const decl of declarations) {
		const [prop, value] = decl.split(":").map((s) => s.trim());
		if (prop && value) result[prop] = value;
	}
	return result;
}
function convertToPixels$1(value) {
	if (typeof value === "number") return value;
	if (!value || typeof value !== "string") return 0;
	const match = value.match(/^([\d.]+)([a-z%]+)?$/i);
	if (!match) return 0;
	const num = parseFloat(match[1]);
	switch ((match[2] || "px").toLowerCase()) {
		case "px": return num;
		case "pt": return num * (96 / 72);
		case "in": return num * 96;
		case "cm": return num * (96 / 2.54);
		case "mm": return num * (96 / 25.4);
		case "pc": return num * 16;
		default: return num;
	}
}
var ROTATED_CENTERED_WATERMARK_TOP_OFFSET_RATIO = .25;
var MAX_ROTATED_CENTERED_WATERMARK_OFFSET_HEIGHT_PX = 1e4;
var DEFAULT_VML_TEXT_WATERMARK_OPACITY = 1;
var DEFAULT_VML_TEXT_WATERMARK_ALIGNMENT = "center";
function handleShapeTextWatermarkImport({ pict }) {
	const shape = pict.elements?.find((el) => el.name === "v:shape");
	if (!shape) return null;
	const textpath = shape.elements?.find((el) => el.name === "v:textpath");
	if (!textpath) return null;
	const shapeAttrs = shape.attributes || {};
	const textpathAttrs = textpath.attributes || {};
	const watermarkText = textpathAttrs["string"] || "";
	if (!watermarkText) {
		console.warn("v:textpath missing string attribute");
		return null;
	}
	const style = shapeAttrs.style || "";
	const styleObj = parseVmlStyle(style);
	const width = styleObj.width || "481.8pt";
	const height = styleObj.height || "82.8pt";
	const position = {
		type: styleObj.position || "absolute",
		marginLeft: styleObj["margin-left"] || "0",
		marginTop: styleObj["margin-top"] || "0"
	};
	const rotation = parseFloat(styleObj.rotation) || 0;
	const explicitHPosition = styleObj["mso-position-horizontal"];
	const explicitVPosition = styleObj["mso-position-vertical"];
	const hasExplicitMarginLeft = styleObj["margin-left"] != null;
	const hasExplicitMarginTop = styleObj["margin-top"] != null;
	const hPosition = explicitHPosition || (hasExplicitMarginLeft ? void 0 : DEFAULT_VML_TEXT_WATERMARK_ALIGNMENT);
	const vPosition = explicitVPosition || (hasExplicitMarginTop ? void 0 : DEFAULT_VML_TEXT_WATERMARK_ALIGNMENT);
	const hRelativeTo = styleObj["mso-position-horizontal-relative"] || "margin";
	const vRelativeTo = styleObj["mso-position-vertical-relative"] || "margin";
	const textAnchor = styleObj["v-text-anchor"] || "middle";
	const fillAttrs = (shape.elements?.find((el) => el.name === "v:fill"))?.attributes || {};
	const rawFillColor = shapeAttrs.fillcolor || fillAttrs.color || "silver";
	const rawFillColor2 = fillAttrs.color2 || "#3f3f3f";
	const fillColor = sanitizeColor(rawFillColor, "silver");
	const fillColor2 = sanitizeColor(rawFillColor2, "#3f3f3f");
	const opacity = fillAttrs.opacity ?? String(DEFAULT_VML_TEXT_WATERMARK_OPACITY);
	const fillType = fillAttrs.type || "solid";
	const strokeAttrs = (shape.elements?.find((el) => el.name === "v:stroke"))?.attributes || {};
	const stroked = shapeAttrs.stroked || "f";
	const strokeColor = strokeAttrs.color || "#3465a4";
	const strokeJoinstyle = strokeAttrs.joinstyle || "round";
	const strokeEndcap = strokeAttrs.endcap || "flat";
	const textStyleObj = parseVmlStyle(textpathAttrs.style || "");
	const fontFamily = sanitizeFontFamily$1(decodeXmlEntities(textStyleObj["font-family"] || "").replace(/['"]/g, ""));
	const fontSize = textStyleObj["font-size"] || "1pt";
	const shouldFitShape = (textpathAttrs.fitshape || "t") === "t";
	const trim = textpathAttrs.trim || "t";
	const textpathOn = textpathAttrs.on || "t";
	const pathAttrs = (shape.elements?.find((el) => el.name === "v:path"))?.attributes || {};
	const textpathok = pathAttrs.textpathok || "t";
	const wrapAttrs = (shape.elements?.find((el) => el.name === "w10:wrap"))?.attributes || {};
	const wrapType = wrapAttrs.type || "none";
	const widthPx = convertToPixels(width);
	const heightPx = convertToPixels(height);
	const sanitizedOpacity = sanitizeNumeric(parseVmlOpacity(opacity), DEFAULT_VML_TEXT_WATERMARK_OPACITY, 0, 1);
	const sanitizedRotation = sanitizeNumeric(rotation, 0, -360, 360);
	const svgResult = generateTextWatermarkSVG({
		text: watermarkText,
		width: widthPx,
		height: heightPx,
		rotation: sanitizedRotation,
		fill: {
			color: fillColor,
			opacity: sanitizedOpacity
		},
		textStyle: {
			fontFamily,
			fontSize
		},
		fitShape: shouldFitShape
	});
	const svgDataUri = svgResult.dataUri;
	const centerOffsetTop = getTextWatermarkCenterOffset({
		hPosition,
		vPosition,
		hRelativeTo,
		vRelativeTo,
		height: heightPx,
		rotation: sanitizedRotation
	});
	const marginOffset = resolveTextWatermarkMarginOffset({
		hPosition,
		vPosition,
		hRelativeTo,
		vRelativeTo,
		marginLeft: convertToPixels(position.marginLeft),
		marginTop: convertToPixels(position.marginTop),
		width: widthPx,
		height: heightPx,
		svgWidth: svgResult.svgWidth,
		svgHeight: svgResult.svgHeight,
		centerOffsetTop,
		rotation: sanitizedRotation
	});
	const anchorData = {
		hRelativeFrom: hRelativeTo,
		vRelativeFrom: vRelativeTo
	};
	if (hPosition) anchorData.alignH = hPosition;
	if (vPosition) anchorData.alignV = vPosition;
	return {
		type: "image",
		attrs: {
			src: svgDataUri,
			alt: watermarkText,
			title: watermarkText,
			extension: "svg",
			vmlWatermark: true,
			vmlTextWatermark: true,
			vmlStyle: style,
			vmlAttributes: shapeAttrs,
			vmlTextpathAttributes: textpathAttrs,
			vmlPathAttributes: pathAttrs,
			vmlFillAttributes: fillAttrs,
			vmlStrokeAttributes: strokeAttrs,
			vmlWrapAttributes: wrapAttrs,
			isAnchor: true,
			inline: false,
			wrap: {
				type: wrapType === "none" ? "None" : wrapType,
				attrs: { behindDoc: true }
			},
			anchorData,
			size: {
				width: svgResult.svgWidth,
				height: svgResult.svgHeight
			},
			marginOffset,
			textWatermarkData: {
				text: watermarkText,
				rotation: sanitizedRotation,
				textStyle: {
					fontFamily,
					fontSize,
					textAnchor
				},
				fill: {
					color: fillColor,
					color2: fillColor2,
					opacity: sanitizedOpacity,
					type: fillType
				},
				stroke: {
					enabled: stroked !== "f",
					color: strokeColor,
					joinstyle: strokeJoinstyle,
					endcap: strokeEndcap
				},
				textpath: {
					on: textpathOn === "t",
					fitshape: shouldFitShape,
					trim: trim === "t",
					textpathok: textpathok === "t"
				}
			}
		}
	};
}
function sanitizeFontFamily$1(fontFamily) {
	if (!fontFamily || typeof fontFamily !== "string") return "Arial";
	return fontFamily.replace(/[^a-zA-Z0-9\s,-]/g, "").trim() || "Arial";
}
function sanitizeColor(color, defaultColor = "silver") {
	if (!color || typeof color !== "string") return defaultColor;
	return color.replace(/[^a-zA-Z0-9#%(),.]/g, "").trim() || defaultColor;
}
function normalizeVmlColor(color) {
	return {
		black: "#000000",
		blue: "#0000FF",
		gray: "#808080",
		green: "#008000",
		lime: "#00FF00",
		red: "#FF0000",
		silver: "#C0C0C0",
		white: "#FFFFFF",
		yellow: "#FFFF00"
	}[typeof color === "string" ? color.trim().toLowerCase() : ""] || color;
}
function decodeXmlEntities(value) {
	return value.replace(/&quot;/g, "\"").replace(/&apos;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&#(\d+);/g, (_, code$1) => decodeCodePoint(Number(code$1))).replace(/&#x([0-9a-fA-F]+);/g, (_, code$1) => decodeCodePoint(Number.parseInt(code$1, 16)));
}
function decodeCodePoint(codePoint) {
	if (!Number.isInteger(codePoint) || codePoint < 0 || codePoint > 1114111) return "";
	return String.fromCodePoint(codePoint);
}
function sanitizeNumeric(value, defaultValue, min = -Infinity, max = Infinity) {
	const num = typeof value === "number" ? value : parseFloat(value);
	if (isNaN(num) || !isFinite(num)) return defaultValue;
	return Math.max(min, Math.min(max, num));
}
function parseVmlOpacity(value) {
	if (typeof value === "number") return value;
	if (!value || typeof value !== "string") return NaN;
	const normalized = value.trim().toLowerCase();
	if (normalized.endsWith("%")) return Number.parseFloat(normalized.slice(0, -1)) / 100;
	if (normalized.endsWith("f")) return Number.parseInt(normalized.slice(0, -1), 10) / 65536;
	return Number.parseFloat(normalized);
}
function getTextWatermarkCenterOffset({ hPosition, vPosition, hRelativeTo, vRelativeTo, height, rotation }) {
	if (!(hPosition === "center" && vPosition === "center" && hRelativeTo === "margin" && vRelativeTo === "margin") || rotation === 0) return 0;
	return sanitizeNumeric(height, 0, 0, MAX_ROTATED_CENTERED_WATERMARK_OFFSET_HEIGHT_PX) * ROTATED_CENTERED_WATERMARK_TOP_OFFSET_RATIO;
}
function resolveTextWatermarkMarginOffset({ hPosition, vPosition, hRelativeTo, vRelativeTo, marginLeft, marginTop, width, height, svgWidth, svgHeight, centerOffsetTop, rotation }) {
	const isCenteredHorizontally = hPosition === "center" && hRelativeTo === "margin";
	const isCenteredVertically = vPosition === "center" && vRelativeTo === "margin";
	return {
		horizontal: isCenteredHorizontally ? 0 : getAbsoluteShapeOffset({
			position: hPosition,
			margin: marginLeft,
			shapeSize: width,
			svgSize: svgWidth,
			rotation
		}),
		top: isCenteredVertically ? centerOffsetTop : getAbsoluteShapeOffset({
			position: vPosition,
			margin: marginTop,
			shapeSize: height,
			svgSize: svgHeight,
			rotation
		})
	};
}
function getAbsoluteShapeOffset({ position, margin, shapeSize, svgSize, rotation }) {
	if (position || rotation === 0) return margin;
	return margin + shapeSize / 2 - svgSize / 2;
}
function generateTextWatermarkSVG({ text: text$2, width, height, rotation, fill, textStyle, fitShape }) {
	let fontSize = height * 1.12;
	if (textStyle?.fontSize && textStyle.fontSize.trim() !== "1pt") {
		const match = textStyle.fontSize.match(/^([\d.]+)(pt|px)?$/);
		if (match) {
			const value = parseFloat(match[1]);
			fontSize = ((match[2] || "pt") === "pt" ? value * (96 / 72) : value) * 50;
		}
	}
	fontSize = Math.max(fontSize, 48);
	const color = normalizeVmlColor(sanitizeColor(fill?.color, "silver"));
	const opacity = sanitizeNumeric(fill?.opacity, DEFAULT_VML_TEXT_WATERMARK_OPACITY, 0, 1);
	const fontFamily = resolveSvgFontFamily(sanitizeFontFamily$1(textStyle?.fontFamily));
	const sanitizedRotation = sanitizeNumeric(rotation, 0, -360, 360);
	const sanitizedWidth = sanitizeNumeric(width, 100, 1, 1e4);
	const sanitizedHeight = sanitizeNumeric(height, 100, 1, 1e4);
	const sanitizedFontSize = sanitizeNumeric(fontSize, 48, 1, 1e3);
	const radians = sanitizedRotation * Math.PI / 180;
	const cos = Math.abs(Math.cos(radians));
	const sin = Math.abs(Math.sin(radians));
	const rotatedWidth = sanitizedWidth * cos + sanitizedHeight * sin;
	const rotatedHeight = sanitizedWidth * sin + sanitizedHeight * cos;
	const svgWidth = Math.max(sanitizedWidth, rotatedWidth) * 1.1;
	const svgHeight = Math.max(sanitizedHeight, rotatedHeight) * 1.1;
	const centerX = svgWidth / 2;
	const centerY = svgHeight / 2;
	return {
		dataUri: `data:image/svg+xml;base64,${encodeUtf8Base64(`<svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" style="overflow: visible;">
    <text ${[
			`x="${centerX}"`,
			`y="${centerY}"`,
			"text-anchor=\"middle\"",
			"dominant-baseline=\"middle\"",
			`font-family="${fontFamily}"`,
			`font-size="${sanitizedFontSize}px"`,
			...fitShape ? [`textLength="${sanitizedWidth}"`, "lengthAdjust=\"spacingAndGlyphs\""] : [],
			`fill="${color}"`,
			`fill-opacity="${opacity}"`,
			`transform="rotate(${sanitizedRotation} ${centerX} ${centerY})"`
		].map((attribute) => `    ${attribute}`).join("\n")}>${escapeXml(text$2)}</text>
  </svg>`)}`,
		svgWidth,
		svgHeight
	};
}
function resolveSvgFontFamily(fontFamily) {
	if (!fontFamily || typeof fontFamily !== "string") return "Arial, sans-serif";
	const normalized = fontFamily.trim();
	if (normalized.includes(",")) return normalized;
	return `${normalized}, ${new Set([
		"cambria",
		"constantia",
		"georgia",
		"times new roman",
		"times"
	]).has(normalized.toLowerCase()) ? "serif" : "Arial, sans-serif"}`;
}
function escapeXml(text$2) {
	return text$2.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function parseVmlStyle(style) {
	const result = {};
	if (!style) return result;
	const declarations = decodeXmlEntities(style).split(";").filter((s) => s.trim());
	for (const decl of declarations) {
		const colonIndex = decl.indexOf(":");
		if (colonIndex === -1) continue;
		const prop = decl.substring(0, colonIndex).trim();
		const value = decl.substring(colonIndex + 1).trim();
		if (prop && value) result[prop] = value;
	}
	return result;
}
function convertToPixels(value) {
	if (typeof value === "number") return value;
	if (!value || typeof value !== "string") return 0;
	const match = value.match(/^([\d.]+)([a-z%]+)?$/i);
	if (!match) return 0;
	const num = parseFloat(match[1]);
	switch ((match[2] || "px").toLowerCase()) {
		case "px": return num;
		case "pt": return num * (96 / 72);
		case "in": return num * 96;
		case "cm": return num * (96 / 2.54);
		case "mm": return num * (96 / 25.4);
		case "pc": return num * 16;
		default: return num;
	}
}
function pictNodeTypeStrategy(node) {
	const shape = node.elements?.find((el) => el.name === "v:shape");
	const group = node.elements?.find((el) => el.name === "v:group");
	if (node.elements?.find((el) => el.name === "v:rect")) return {
		type: "contentBlock",
		handler: handleVRectImport
	};
	if (!shape && !group) return {
		type: "unknown",
		handler: null
	};
	if (group && !shape) return {
		type: "unknown",
		handler: null
	};
	else {
		if (shape.elements?.find((el) => el.name === "v:textbox")) return {
			type: "shapeContainer",
			handler: handleShapeTextboxImport
		};
		if (shape.elements?.find((el) => el.name === "v:textpath")) return {
			type: "image",
			handler: handleShapeTextWatermarkImport
		};
		if (shape.elements?.find((el) => el.name === "v:imagedata")) return {
			type: "image",
			handler: handleShapeImageWatermarkImport
		};
	}
	return {
		type: "unknown",
		handler: null
	};
}
function translateDrawingMLTextbox(params) {
	const { node } = params;
	const drawingContent = node?.attrs?.drawingContent;
	const shapeTextbox = node?.content?.find((child) => child?.type === "shapeTextbox");
	if (!drawingContent || !shapeTextbox) return null;
	const drawing = carbonCopy(drawingContent);
	const liveParagraphs = translateChildNodes({
		...params,
		node: shapeTextbox
	});
	const txbxContent = findTextboxContentNode(drawing);
	if (!txbxContent) return null;
	txbxContent.elements = liveParagraphs;
	return wrapTextInRun({
		name: "mc:AlternateContent",
		elements: [{
			name: "mc:Choice",
			attributes: { Requires: "wps" },
			elements: [drawing]
		}]
	});
}
function findTextboxContentNode(node) {
	if (!node || typeof node !== "object") return null;
	if (node.name === "w:txbxContent") return node;
	if (!Array.isArray(node.elements)) return null;
	for (const child of node.elements) {
		const found$1 = findTextboxContentNode(child);
		if (found$1) return found$1;
	}
	return null;
}
function translateShapeContainer(params) {
	const { node } = params;
	if (node?.attrs?.drawingContent) {
		const run$1 = translateDrawingMLTextbox(params);
		if (run$1) return {
			name: "w:p",
			elements: [run$1]
		};
		return {
			name: "w:p",
			elements: [wrapTextInRun(node.attrs.drawingContent)]
		};
	}
	const elements = translateChildNodes(params);
	const shapeAttributes = {
		...node.attrs.attributes,
		fillcolor: node.attrs.fillcolor
	};
	const style = buildShapeStyle(node.attrs);
	if (style) shapeAttributes.style = style;
	const shape = {
		name: "v:shape",
		attributes: shapeAttributes,
		elements: [...elements, ...node.attrs.wrapAttributes ? [{
			name: "w10:wrap",
			attributes: { ...node.attrs.wrapAttributes }
		}] : []]
	};
	return {
		name: "w:p",
		elements: [wrapTextInRun({
			name: "w:pict",
			attributes: { "w14:anchorId": generateRandomSigned32BitIntStrId() },
			elements: [shape]
		})]
	};
}
function buildShapeStyle(attrs) {
	const originalStyle = parseInlineStyles(attrs.attributes?.style);
	const managedStyle = parseInlineStyles(attrs.style);
	const style = {
		...originalStyle,
		...managedStyle
	};
	if (attrs.marginOffset?.horizontal !== void 0) style["margin-left"] = `${convertToPt$2(attrs.marginOffset.horizontal)}pt`;
	if (attrs.marginOffset?.top !== void 0) style["margin-top"] = `${convertToPt$2(attrs.marginOffset.top)}pt`;
	if (attrs.anchorData?.alignH) style["mso-position-horizontal"] = attrs.anchorData.alignH;
	if (attrs.anchorData?.hRelativeFrom) style["mso-position-horizontal-relative"] = attrs.anchorData.hRelativeFrom;
	if (attrs.anchorData?.alignV) style["mso-position-vertical"] = attrs.anchorData.alignV;
	if (attrs.anchorData?.vRelativeFrom) style["mso-position-vertical-relative"] = attrs.anchorData.vRelativeFrom;
	const entries = Object.entries(style);
	if (entries.length === 0) return void 0;
	return entries.map(([prop, value]) => `${prop}:${value}`).join(";");
}
function convertToPt$2(pixels) {
	return pixels * 72 / 96;
}
function translateShapeTextbox(params) {
	const { node } = params;
	const textboxContent = {
		name: "w:txbxContent",
		elements: translateChildNodes(params)
	};
	return {
		name: "v:textbox",
		attributes: { ...node.attrs.attributes },
		elements: [textboxContent]
	};
}
function translateContentBlock(params) {
	const { node } = params;
	const { vmlAttributes, horizontalRule, attributes, style } = node.attrs;
	const hasLegacyVmlMarkers = detectLegacyVmlRectMarkers(attributes, style);
	if (vmlAttributes || horizontalRule || hasLegacyVmlMarkers) return translateVRectContentBlock(params);
	const alternateContent = translator$34.decode(params);
	if (!alternateContent) return null;
	return wrapTextInRun(alternateContent);
}
function detectLegacyVmlRectMarkers(rawAttributes, style) {
	if (style) return true;
	if (!rawAttributes || typeof rawAttributes !== "object") return false;
	const attrs = rawAttributes;
	if (typeof attrs.style === "string" && attrs.style.trim().length > 0) return true;
	if (attrs.fillcolor != null) return true;
	if (attrs.stroked != null) return true;
	return Object.keys(attrs).some((key) => key.startsWith("o:"));
}
var FULL_WIDTH_PT = "468pt";
var FULL_WIDTH_PT_VALUE = 468;
var PX_PER_PT$1 = 1.33;
function pxToPt(px) {
	return `${Math.round(px / PX_PER_PT$1 * 10) / 10}pt`;
}
function sizeToPt(value, options = {}) {
	const { allowPercent = false } = options;
	if (typeof value === "number") return Number.isFinite(value) ? pxToPt(value) : null;
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	if (!trimmed) return null;
	if (allowPercent && trimmed.endsWith("%")) {
		const percent = Number.parseFloat(trimmed.slice(0, -1));
		if (!Number.isFinite(percent) || percent <= 0) return null;
		if (percent >= 100) return FULL_WIDTH_PT;
		return `${Math.round(FULL_WIDTH_PT_VALUE * percent / 100 * 10) / 10}pt`;
	}
	const normalized = trimmed.endsWith("px") ? trimmed.slice(0, -2) : trimmed;
	const px = Number.parseFloat(normalized);
	if (!Number.isFinite(px)) return null;
	return pxToPt(px);
}
function synthesizeVmlStyle(size) {
	const parts = [];
	if (size.width != null) {
		const widthPt = sizeToPt(size.width, { allowPercent: true });
		if (widthPt) parts.push(`width:${widthPt}`);
	}
	if (size.height != null) {
		const heightPt = sizeToPt(size.height);
		if (heightPt) parts.push(`height:${heightPt}`);
	}
	return parts.join(";");
}
function translateVRectContentBlock(params) {
	const { node } = params;
	const { horizontalRule, vmlAttributes, background, attributes, style, size } = node.attrs;
	const rectAttrs = { id: attributes?.id || `_x0000_i${Math.floor(Math.random() * 1e4)}` };
	if (style) rectAttrs.style = style;
	if (background) rectAttrs.fillcolor = background;
	if (vmlAttributes) {
		if (vmlAttributes.hralign) rectAttrs["o:hralign"] = vmlAttributes.hralign;
		if (vmlAttributes.hrstd) rectAttrs["o:hrstd"] = vmlAttributes.hrstd;
		if (vmlAttributes.hr) rectAttrs["o:hr"] = vmlAttributes.hr;
		if (vmlAttributes.stroked) rectAttrs.stroked = vmlAttributes.stroked;
	}
	if (attributes) Object.entries(attributes).forEach(([key, value]) => {
		if (!rectAttrs[key] && value !== void 0) rectAttrs[key] = value;
	});
	if (!rectAttrs.style && horizontalRule && size) {
		const synthesized = synthesizeVmlStyle(size);
		if (synthesized) rectAttrs.style = synthesized;
	}
	if (horizontalRule) {
		if (rectAttrs["o:hr"] == null) rectAttrs["o:hr"] = "t";
		if (rectAttrs["o:hrstd"] == null) rectAttrs["o:hrstd"] = "t";
		if (rectAttrs["o:hralign"] == null) rectAttrs["o:hralign"] = "center";
		if (rectAttrs.stroked == null) rectAttrs.stroked = "f";
	}
	const rect = {
		name: "v:rect",
		attributes: rectAttrs
	};
	return wrapTextInRun({
		name: "w:pict",
		attributes: { "w14:anchorId": generateRandomSigned32BitIntStrId() },
		elements: [rect]
	});
}
function translateImageWatermark(params) {
	const { node } = params;
	const { attrs } = node;
	if (attrs.vmlAttributes && attrs.vmlImagedata) {
		const shape$1 = {
			name: "v:shape",
			attributes: attrs.vmlAttributes,
			elements: [{
				name: "v:imagedata",
				attributes: {
					...attrs.vmlImagedata,
					"r:id": attrs.rId
				}
			}]
		};
		return {
			name: "w:pict",
			attributes: { "w14:anchorId": generateRandomSigned32BitIntStrId() },
			elements: [shape$1]
		};
	}
	const style = buildVmlStyle$1(attrs);
	const shape = {
		name: "v:shape",
		attributes: {
			id: `WordPictureWatermark${generateRandomSigned32BitIntStrId().replace("-", "")}`,
			"o:spid": `_x0000_s${Math.floor(Math.random() * 1e4)}`,
			type: "#_x0000_t75",
			style,
			"o:allowincell": "f"
		},
		elements: [{
			name: "v:imagedata",
			attributes: {
				"r:id": attrs.rId,
				"o:title": attrs.title || attrs.alt || "Watermark",
				...attrs.gain && { gain: attrs.gain },
				...attrs.blacklevel && { blacklevel: attrs.blacklevel }
			}
		}]
	};
	return {
		name: "w:pict",
		attributes: { "w14:anchorId": generateRandomSigned32BitIntStrId() },
		elements: [shape]
	};
}
function buildVmlStyle$1(attrs) {
	const styles = [];
	styles.push("position:absolute");
	if (attrs.size) {
		if (attrs.size.width) styles.push(`width:${convertToPt$1(attrs.size.width)}pt`);
		if (attrs.size.height) styles.push(`height:${convertToPt$1(attrs.size.height)}pt`);
	}
	if (attrs.marginOffset) {
		if (attrs.marginOffset.horizontal !== void 0) styles.push(`margin-left:${convertToPt$1(attrs.marginOffset.horizontal)}pt`);
		if (attrs.marginOffset.top !== void 0) styles.push(`margin-top:${convertToPt$1(attrs.marginOffset.top)}pt`);
	}
	if (attrs.wrap?.attrs?.behindDoc) styles.push("z-index:-251653120");
	if (attrs.anchorData) {
		if (attrs.anchorData.alignH) styles.push(`mso-position-horizontal:${attrs.anchorData.alignH}`);
		if (attrs.anchorData.alignV) styles.push(`mso-position-vertical:${attrs.anchorData.alignV}`);
		if (attrs.anchorData.hRelativeFrom) styles.push(`mso-position-horizontal-relative:${attrs.anchorData.hRelativeFrom}`);
		if (attrs.anchorData.vRelativeFrom) styles.push(`mso-position-vertical-relative:${attrs.anchorData.vRelativeFrom}`);
	}
	styles.push("mso-width-percent:0");
	styles.push("mso-height-percent:0");
	return styles.join(";");
}
function convertToPt$1(pixels) {
	return pixels * 72 / 96;
}
function translateTextWatermark(params) {
	const { node } = params;
	const { attrs } = node;
	const text$2 = attrs.textWatermarkData?.text || attrs.vmlTextpathAttributes?.string || "";
	if (attrs.vmlAttributes && attrs.vmlTextpathAttributes) {
		const shapeElements$1 = [];
		if (attrs.vmlPathAttributes) shapeElements$1.push({
			name: "v:path",
			attributes: attrs.vmlPathAttributes
		});
		shapeElements$1.push({
			name: "v:textpath",
			attributes: {
				...attrs.vmlTextpathAttributes,
				string: text$2
			}
		});
		if (attrs.vmlFillAttributes && Object.keys(attrs.vmlFillAttributes).length > 0) shapeElements$1.push({
			name: "v:fill",
			attributes: attrs.vmlFillAttributes
		});
		if (attrs.vmlStrokeAttributes && Object.keys(attrs.vmlStrokeAttributes).length > 0) shapeElements$1.push({
			name: "v:stroke",
			attributes: attrs.vmlStrokeAttributes
		});
		if (attrs.vmlWrapAttributes) shapeElements$1.push({
			name: "w10:wrap",
			attributes: attrs.vmlWrapAttributes
		});
		return {
			name: "w:pict",
			elements: [{
				name: "v:shape",
				attributes: attrs.vmlAttributes,
				elements: shapeElements$1
			}]
		};
	}
	const wmData = attrs.textWatermarkData || {};
	const style = buildVmlStyle(attrs, wmData);
	const textpathStyle = buildTextpathStyle(wmData);
	const shapeElements = [];
	shapeElements.push({
		name: "v:path",
		attributes: { textpathok: "t" }
	});
	shapeElements.push({
		name: "v:textpath",
		attributes: {
			on: "t",
			fitshape: "t",
			string: text$2,
			style: textpathStyle,
			...wmData.textpath?.trim !== void 0 && { trim: wmData.textpath.trim ? "t" : "f" }
		}
	});
	const fillAttrs = {};
	const fill = wmData.fill || attrs.fill;
	if (fill) {
		if (fill.type) fillAttrs.type = fill.type;
		if (fill.color2) fillAttrs.color2 = fill.color2;
		if (fill.opacity !== void 0) fillAttrs.opacity = fill.opacity.toString();
		if (fill.detectmouseclick !== void 0) fillAttrs["o:detectmouseclick"] = fill.detectmouseclick ? "t" : "f";
	}
	if (Object.keys(fillAttrs).length > 0) shapeElements.push({
		name: "v:fill",
		attributes: fillAttrs
	});
	const stroke = wmData.stroke || attrs.stroke;
	if (stroke && stroke.enabled !== false) {
		const strokeAttrs = {};
		if (stroke.color) strokeAttrs.color = stroke.color;
		if (stroke.joinstyle) strokeAttrs.joinstyle = stroke.joinstyle;
		if (stroke.endcap) strokeAttrs.endcap = stroke.endcap;
		if (Object.keys(strokeAttrs).length > 0) shapeElements.push({
			name: "v:stroke",
			attributes: strokeAttrs
		});
	}
	shapeElements.push({
		name: "w10:wrap",
		attributes: { type: attrs.wrap?.type?.toLowerCase() || "none" }
	});
	return {
		name: "w:pict",
		elements: [{
			name: "v:shape",
			attributes: {
				id: `PowerPlusWaterMarkObject${generateRandomSigned32BitIntStrId().replace("-", "")}`,
				"o:spid": `shape_${Math.floor(Math.random() * 1e4)}`,
				type: "#_x0000_t136",
				style,
				fillcolor: fill?.color || "silver",
				stroked: stroke?.enabled !== false ? "t" : "f",
				"o:allowincell": "f",
				...attrs.vmlAttributes?.adj && { adj: attrs.vmlAttributes.adj }
			},
			elements: shapeElements
		}]
	};
}
function buildVmlStyle(attrs, wmData) {
	const styles = [];
	styles.push("position:absolute");
	if (attrs.marginOffset) {
		if (attrs.marginOffset.horizontal !== void 0) styles.push(`margin-left:${convertToPt(attrs.marginOffset.horizontal)}pt`);
		if (attrs.marginOffset.top !== void 0) styles.push(`margin-top:${convertToPt(attrs.marginOffset.top)}pt`);
	} else {
		styles.push("margin-left:0.05pt");
		styles.push("margin-top:315.7pt");
	}
	if (attrs.size) {
		if (attrs.size.width) styles.push(`width:${convertToPt(attrs.size.width)}pt`);
		if (attrs.size.height) styles.push(`height:${convertToPt(attrs.size.height)}pt`);
	}
	const wrapType = attrs.wrap?.type;
	let msoWrapStyle = "none";
	if (wrapType) {
		const wrapTypeLower = wrapType.toLowerCase();
		if (wrapTypeLower === "topandbottom") msoWrapStyle = "top-and-bottom";
		else if ([
			"square",
			"tight",
			"through"
		].includes(wrapTypeLower)) msoWrapStyle = wrapTypeLower;
	}
	styles.push(`mso-wrap-style:${msoWrapStyle}`);
	const textAnchor = wmData.textStyle?.textAnchor || attrs.textStyle?.textAnchor;
	if (textAnchor) styles.push(`v-text-anchor:${textAnchor}`);
	const rotation = wmData.rotation || attrs.rotation;
	if (rotation !== void 0 && rotation !== 0) styles.push(`rotation:${rotation}`);
	if (attrs.anchorData) {
		if (attrs.anchorData.alignH) styles.push(`mso-position-horizontal:${attrs.anchorData.alignH}`);
		if (attrs.anchorData.alignV) styles.push(`mso-position-vertical:${attrs.anchorData.alignV}`);
		if (attrs.anchorData.hRelativeFrom) styles.push(`mso-position-horizontal-relative:${attrs.anchorData.hRelativeFrom}`);
		if (attrs.anchorData.vRelativeFrom) styles.push(`mso-position-vertical-relative:${attrs.anchorData.vRelativeFrom}`);
	}
	return styles.join(";");
}
function buildTextpathStyle(wmData) {
	const styles = [];
	if (wmData.textStyle) {
		if (wmData.textStyle.fontFamily) styles.push(`font-family:"${wmData.textStyle.fontFamily}"`);
		if (wmData.textStyle.fontSize) styles.push(`font-size:${wmData.textStyle.fontSize}`);
	}
	return styles.join(";");
}
function convertToPt(pixels) {
	if (typeof pixels === "number") return pixels * 72 / 96;
	return parseFloat(pixels) || 0;
}
var XML_NODE_NAME = "w:pict";
var SD_NODE_NAME = [
	"shapeContainer",
	"contentBlock",
	"image"
];
var validXmlAttributes = [];
function encode({ nodes, ...params }) {
	const [node] = nodes;
	if (!node) return;
	const { type: pictType, handler: handler$1 } = pictNodeTypeStrategy(node);
	if (!handler$1 || pictType === "unknown") return;
	return handler$1({
		params,
		pict: node
	});
}
function decode(params) {
	const { node } = params;
	if (!node || !node.type) return null;
	const types = {
		shapeContainer: () => translateShapeContainer(params),
		shapeTextbox: () => translateShapeTextbox(params),
		contentBlock: () => translateContentBlock(params),
		image: () => {
			if (node.attrs?.vmlWatermark) {
				if (node.attrs?.vmlTextWatermark) return translateTextWatermark(params);
				return translateImageWatermark(params);
			}
			return null;
		},
		default: () => null
	};
	const result = (types[node.type] ?? types.default)();
	if (result) {
		const siblings = node.attrs?.passthroughSiblings;
		if (Array.isArray(siblings) && siblings.length > 0) {
			result.elements ??= [];
			result.elements.push(...siblings.map((xml) => carbonCopy(xml)));
		}
	}
	return result;
}
const config = {
	xmlName: XML_NODE_NAME,
	sdNodeOrKeyName: SD_NODE_NAME,
	type: NodeTranslator.translatorTypes.NODE,
	encode,
	decode,
	attributes: validXmlAttributes
};
const translator$31 = NodeTranslator.from(config);
var DEFAULT_SECTION_PROPS_TWIPS = Object.freeze({
	pageSize: Object.freeze({
		width: "12240",
		height: "15840"
	}),
	pageMargins: Object.freeze({
		top: "1440",
		right: "1440",
		bottom: "1440",
		left: "1440",
		header: "720",
		footer: "720",
		gutter: "0"
	})
});
const ensureSectionLayoutDefaults = (sectPr, converter) => {
	if (!sectPr) return {
		type: "element",
		name: "w:sectPr",
		elements: []
	};
	if (!sectPr.elements) sectPr.elements = [];
	const ensureChild$1 = (name) => {
		let child = sectPr.elements.find((n) => n.name === name);
		if (!child) {
			child = {
				type: "element",
				name,
				elements: [],
				attributes: {}
			};
			sectPr.elements.push(child);
		} else {
			if (!child.elements) child.elements = [];
			if (!child.attributes) child.attributes = {};
		}
		return child;
	};
	const pageSize = converter?.pageStyles?.pageSize;
	const pgSz = ensureChild$1("w:pgSz");
	if (pageSize?.width != null) pgSz.attributes["w:w"] = String(inchesToTwips(pageSize.width));
	if (pageSize?.height != null) pgSz.attributes["w:h"] = String(inchesToTwips(pageSize.height));
	if (pgSz.attributes["w:w"] == null) pgSz.attributes["w:w"] = DEFAULT_SECTION_PROPS_TWIPS.pageSize.width;
	if (pgSz.attributes["w:h"] == null) pgSz.attributes["w:h"] = DEFAULT_SECTION_PROPS_TWIPS.pageSize.height;
	const pageMargins = converter?.pageStyles?.pageMargins;
	const pgMar = ensureChild$1("w:pgMar");
	if (pageMargins) Object.entries(pageMargins).forEach(([key, value]) => {
		const converted = inchesToTwips(value);
		if (converted != null) pgMar.attributes[`w:${key}`] = String(converted);
	});
	Object.entries(DEFAULT_SECTION_PROPS_TWIPS.pageMargins).forEach(([key, value]) => {
		const attrKey = `w:${key}`;
		if (pgMar.attributes[attrKey] == null) pgMar.attributes[attrKey] = value;
	});
	return sectPr;
};
const normalizePgMarTwipsInTree = (node) => {
	if (!node || typeof node !== "object") return;
	if (node.name === "w:pgMar" && node.attributes && typeof node.attributes === "object") for (const key of Object.keys(node.attributes)) {
		const value = node.attributes[key];
		if (value == null) continue;
		const serialized = String(value).trim();
		if (!serialized) continue;
		const num = Number(serialized);
		if (Number.isFinite(num) && !/^-?\d+$/.test(serialized)) node.attributes[key] = String(Math.round(num));
	}
	if (Array.isArray(node.elements)) for (const child of node.elements) normalizePgMarTwipsInTree(child);
};
function exportSchemaToJson(params) {
	const { type } = params.node || {};
	const entry = {
		doc: translateDocumentNode,
		body: translateBodyNode,
		heading: translateHeadingNode,
		paragraph: translator,
		run: translator$6,
		text: translator$32,
		lineBreak: translator$1,
		table: translator$10,
		tableRow: translator$8,
		tableCell: translator$7,
		tableHeader: translator$7,
		bookmarkStart: translator$13,
		bookmarkEnd: translator$14,
		fieldAnnotation: translator$9,
		tab: translator$3,
		noBreakHyphen: translator$4,
		smartTag: translator$5,
		image: [translator$12, translator$31],
		hardBreak: translator$1,
		commentRangeStart: commentRangeStartTranslator,
		commentRangeEnd: commentRangeEndTranslator,
		permStart: translator$15,
		permEnd: translator$16,
		permStartBlock: translator$15,
		permEndBlock: translator$16,
		commentReference: [],
		footnoteReference: translator$33,
		shapeContainer: translator$31,
		shapeTextbox: translator$31,
		contentBlock: translator$31,
		vectorShape: translateVectorShape,
		shapeGroup: translateShapeGroup,
		chart: translator$12,
		structuredContent: translator$9,
		structuredContentBlock: translator$9,
		documentPartObject: translator$9,
		documentSection: translator$9,
		"page-number": translator$27,
		"total-page-number": translator$28,
		"section-page-count": translator$29,
		pageReference: translator$17,
		crossReference: translator$18,
		citation: translator$19,
		bibliography: translator$20,
		authorityEntry: translator$21,
		tableOfAuthorities: translator$22,
		sequenceField: translator$23,
		documentStatField: translator$30,
		tableOfContents: translator$24,
		index: translator$25,
		indexEntry: translator$26,
		mathBlock: translatePassthroughNode,
		mathInline: translatePassthroughNode,
		passthroughBlock: translatePassthroughNode,
		passthroughInline: translatePassthroughNode
	}[type];
	if (!entry) {
		console.error("No translation function found for node type:", type);
		return null;
	}
	const handlers$2 = Array.isArray(entry) ? entry : [entry];
	for (const handler$1 of handlers$2) {
		let result;
		if (handler$1 && "decode" in handler$1 && typeof handler$1.decode === "function") result = handler$1.decode(params);
		else if (typeof handler$1 === "function") result = handler$1(params);
		if (result) return result;
	}
	return null;
}
function translatePassthroughNode(params) {
	const original = params?.node?.attrs?.originalXml;
	if (!original) return null;
	return carbonCopy(original);
}
function translateBodyNode(params) {
	const liveSectPr = params.converter?.bodySectPr;
	let sectPr = (liveSectPr && typeof liveSectPr === "object" ? carbonCopy(liveSectPr) : null) || params.bodyNode?.elements?.find((n) => n.name === "w:sectPr");
	if (!sectPr) sectPr = {
		type: "element",
		name: "w:sectPr",
		elements: []
	};
	else if (!sectPr.elements) sectPr = {
		...sectPr,
		elements: []
	};
	sectPr = ensureSectionLayoutDefaults(sectPr, params.converter);
	if (params.converter) {
		const canExportHeaderRef = params.converter.importedBodyHasHeaderRef || params.converter.headerFooterModified;
		const canExportFooterRef = params.converter.importedBodyHasFooterRef || params.converter.headerFooterModified;
		const hasHeader = sectPr.elements?.some((n) => n.name === "w:headerReference");
		const hasDefaultHeader = params.converter.headerIds?.default;
		if (!hasHeader && hasDefaultHeader && !params.editor.options.isHeaderOrFooter && canExportHeaderRef) {
			const defaultHeader = generateDefaultHeaderFooter("header", params.converter.headerIds?.default);
			sectPr.elements.push(defaultHeader);
		}
		const hasFooter = sectPr.elements?.some((n) => n.name === "w:footerReference");
		const hasDefaultFooter = params.converter.footerIds?.default;
		if (!hasFooter && hasDefaultFooter && !params.editor.options.isHeaderOrFooter && canExportFooterRef) {
			const defaultFooter = generateDefaultHeaderFooter("footer", params.converter.footerIds?.default);
			sectPr.elements.push(defaultFooter);
		}
		const hasFootnotePr = sectPr.elements?.some((n) => n.name === "w:footnotePr");
		const footnoteProperties = params.converter.footnoteProperties;
		if (!hasFootnotePr && footnoteProperties?.source === "sectPr" && footnoteProperties.originalXml) sectPr.elements.push(carbonCopy(footnoteProperties.originalXml));
	}
	const elements = translateChildNodes(params);
	if (params.isHeaderFooter) return {
		name: "w:body",
		elements: [...elements]
	};
	return {
		name: "w:body",
		elements: [...elements, sectPr]
	};
}
var generateDefaultHeaderFooter = (type, id) => {
	return {
		type: "element",
		name: `w:${type}Reference`,
		attributes: {
			"w:type": "default",
			"r:id": id
		}
	};
};
function translateHeadingNode(params) {
	const { node } = params;
	const { level = 1, ...otherAttrs } = node.attrs;
	const paragraphNode = {
		type: "paragraph",
		content: node.content,
		attrs: {
			...otherAttrs,
			styleId: `Heading${level}`
		}
	};
	return translator.decode({
		...params,
		node: paragraphNode
	});
}
function mergeMcIgnorable(defaultIgnorable = "", originalIgnorable = "") {
	return [...new Set([...defaultIgnorable.split(/\s+/).filter(Boolean), ...originalIgnorable.split(/\s+/).filter(Boolean)])].join(" ");
}
function normalizeDocumentBackgroundColorForExport(value) {
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	const hex = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
	if (!/^[0-9a-fA-F]{6}$/.test(hex)) return null;
	return hex.toUpperCase();
}
function translateDocumentBackgroundNode(params) {
	const background = params?.node?.attrs?.documentBackground;
	if (!background || typeof background !== "object") return null;
	if (background.originalXml && typeof background.originalXml === "object") return carbonCopy(background.originalXml);
	const color = normalizeDocumentBackgroundColorForExport(background.color);
	if (!color) return null;
	return {
		type: "element",
		name: "w:background",
		attributes: { "w:color": color },
		elements: []
	};
}
function translateDocumentNode(params) {
	const bodyNode = {
		type: "body",
		content: params.node.content
	};
	const translatedBackgroundNode = translateDocumentBackgroundNode(params);
	const translatedBodyNode = exportSchemaToJson({
		...params,
		node: bodyNode
	});
	const originalAttrs = params.converter?.documentAttributes || {};
	const attributes = {
		...DEFAULT_DOCX_DEFS,
		...originalAttrs
	};
	const mergedIgnorable = mergeMcIgnorable(DEFAULT_DOCX_DEFS["mc:Ignorable"], originalAttrs["mc:Ignorable"]);
	if (mergedIgnorable) attributes["mc:Ignorable"] = mergedIgnorable;
	const node = {
		name: "w:document",
		elements: translatedBackgroundNode ? [translatedBackgroundNode, translatedBodyNode] : [translatedBodyNode],
		attributes
	};
	normalizePgMarTwipsInTree(node);
	return [node, params];
}
function wrapTextInRun(nodeOrNodes, marks) {
	let elements = [];
	if (Array.isArray(nodeOrNodes)) elements = nodeOrNodes;
	else elements = [nodeOrNodes];
	if (marks && marks.length) elements.unshift(generateRunProps(marks));
	return {
		name: "w:r",
		elements
	};
}
function generateRunProps(marks = []) {
	return {
		name: "w:rPr",
		elements: marks.filter((mark) => !!Object.keys(mark).length)
	};
}
function processOutputMarks(marks = []) {
	return marks.flatMap((mark) => {
		if (mark.type === "textStyle") return Object.entries(mark.attrs).filter(([, value]) => value).map(([key]) => {
			return translateMark({
				type: key,
				attrs: mark.attrs
			});
		});
		else return translateMark(mark);
	});
}
function translateMark(mark) {
	const xmlMark = SuperConverter.markTypes.find((m) => m.type === mark.type);
	if (!xmlMark) return {};
	const markElement = {
		name: xmlMark.name,
		attributes: {}
	};
	const { attrs } = mark;
	let value;
	switch (mark.type) {
		case "bold":
			if (attrs?.value) markElement.attributes["w:val"] = attrs.value;
			else delete markElement.attributes;
			markElement.type = "element";
			break;
		case "italic":
			if (attrs?.value && attrs.value !== "1" && attrs.value !== true) markElement.attributes["w:val"] = attrs.value;
			else delete markElement.attributes;
			markElement.type = "element";
			break;
		case "underline": return translator$11.decode({ node: { attrs: {
			underlineType: attrs.underlineType ?? attrs.underline ?? null,
			underlineColor: attrs.underlineColor ?? attrs.color ?? null,
			underlineThemeColor: attrs.underlineThemeColor ?? attrs.themeColor ?? null,
			underlineThemeTint: attrs.underlineThemeTint ?? attrs.themeTint ?? null,
			underlineThemeShade: attrs.underlineThemeShade ?? attrs.themeShade ?? null
		} } }) || {};
		case "fontSize":
			value = attrs.fontSize;
			markElement.attributes["w:val"] = value.slice(0, -2) * 2;
			break;
		case "fontFamily":
			value = attrs.fontFamily;
			[
				"w:ascii",
				"w:eastAsia",
				"w:hAnsi",
				"w:cs"
			].forEach((attr) => {
				const parsedValue = value.split(", ");
				markElement.attributes[attr] = parsedValue[0] ? parsedValue[0] : value;
			});
			break;
		case "styleId":
			markElement.name = "w:rStyle";
			markElement.attributes["w:val"] = attrs.styleId;
			break;
		case "color": {
			const rawColor = attrs.color;
			if (!rawColor) break;
			if (String(rawColor).trim().toLowerCase() === "inherit") {
				markElement.attributes["w:val"] = "auto";
				break;
			}
			let processedColor = String(rawColor).replace(/^#/, "").replace(/;$/, "");
			if (processedColor.startsWith("rgb")) processedColor = rgbToHex$1(processedColor);
			markElement.attributes["w:val"] = processedColor;
			break;
		}
		case "textAlign":
			markElement.attributes["w:val"] = attrs.textAlign;
			break;
		case "textIndent":
			markElement.attributes["w:firstline"] = inchesToTwips(attrs.textIndent);
			break;
		case "textTransform":
			if (attrs?.textTransform === "none") markElement.attributes["w:val"] = "0";
			else delete markElement.attributes;
			markElement.type = "element";
			break;
		case "lineHeight":
			markElement.attributes["w:line"] = linesToTwips(attrs.lineHeight);
			break;
		case "highlight": {
			const highlightValue = attrs.color ?? attrs.highlight ?? null;
			if (String(highlightValue).trim().toLowerCase() === "transparent" && !attrs.ooxmlHighlightClear) return {};
			return translator$2.decode({ node: { attrs: { highlight: highlightValue } } }) || {};
		}
		case "strike":
			if (attrs?.value === "0") markElement.attributes["w:val"] = attrs.value;
			break;
		case "link": return {};
	}
	return markElement;
}
var DocxExporter = class {
	constructor(converter) {
		this.converter = converter;
	}
	schemaToXml(data, debug = false) {
		return this.#generate_xml_as_list(data, debug).join("");
	}
	#generate_xml_as_list(data, debug = false) {
		const json = JSON.parse(JSON.stringify(data));
		const declaration = this.converter.declaration?.attributes ?? DEFAULT_XML_DECLARATION.attributes;
		return [`<?xml${Object.entries(declaration).map(([key, value]) => ` ${key}="${value}"`).join("")}?>`, ...this.#generateXml(json, debug)];
	}
	#replaceSpecialCharacters(text$2) {
		if (text$2 === void 0 || text$2 === null) return text$2;
		return String(text$2).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
	}
	#generateXml(node, insideDeletion = false) {
		if (!node) return null;
		let { name } = node;
		const { elements, attributes } = node;
		if (name === "w:delInstrText" && !insideDeletion) name = "w:instrText";
		let tag = `<${name}`;
		for (let attr in attributes) {
			const parsedAttrName = typeof attributes[attr] === "string" ? this.#replaceSpecialCharacters(attributes[attr]) : attributes[attr];
			tag += ` ${attr}="${parsedAttrName}"`;
		}
		const selfClosing = name && (!elements || !elements.length);
		if (selfClosing) tag += " />";
		else tag += ">";
		let tags = [tag];
		if (!name && node.type === "text") return this.#replaceSpecialCharacters(node.text ?? "");
		const nextInsideDeletion = insideDeletion || name === "w:del";
		if (elements) {
			if (name === "w:instrText" || name === "w:delInstrText") {
				const textContent = (elements || []).map((child) => typeof child?.text === "string" ? child.text : "").join("");
				tags.push(this.#replaceSpecialCharacters(textContent));
			} else if (name === "w:t" || name === "w:delText" || name === "wp:posOffset") if (elements.length === 0) console.error(`${name} element has no child elements. Expected text node. Element will be self-closing.`);
			else if (elements[0] == null || typeof elements[0].text !== "string") {
				console.error(`${name} element's first child is missing or does not have a valid text property. Received: ${JSON.stringify(elements[0])}. Pushing empty string to maintain XML structure.`);
				tags.push("");
			} else {
				let text$2 = elements[0].text.replace(/\[\[sdspace\]\]/g, "");
				text$2 = this.#replaceSpecialCharacters(text$2);
				tags.push(text$2);
			}
			else if (elements) for (let child of elements) {
				const newElements = this.#generateXml(child, nextInsideDeletion);
				if (!newElements) continue;
				if (typeof newElements === "string") {
					tags.push(newElements);
					continue;
				}
				const removeUndefined = newElements.filter((el) => {
					return !(el === "<undefined>" || el === "</undefined>");
				});
				for (const element of removeUndefined) tags.push(element);
			}
		}
		if (!selfClosing) tags.push(`</${name}>`);
		return tags;
	}
};
const SETTLED_STATUSES = [
	"loaded",
	"failed",
	"timed_out",
	"fallback_used"
];
function isSettled(status) {
	return SETTLED_STATUSES.includes(status);
}
const SUBSTITUTION_EVIDENCE$1 = [
	{
		"evidenceId": "calibri",
		"generic": "sans-serif",
		"logicalFamily": "Calibri",
		"physicalFamily": "Carlito",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "pass",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": ["calibri__carlito#analytic_advance#2026-06-03", "calibri__carlito#face_aggregate#2026-06-03"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "cambria",
		"generic": "serif",
		"logicalFamily": "Cambria",
		"physicalFamily": "Caladea",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"cambria_regular__caladea#regular#w400#d2f6cad3#analytic_advance#2026-06-04",
			"cambria_bold__caladea#bold#w700#74eda4fc#analytic_advance#2026-06-04",
			"cambria_italic__caladea#italic#w400#9c968bf6#analytic_advance#2026-06-04",
			"cambria_boldItalic__caladea#boldItalic#w700#f47a35ad#analytic_advance#2026-06-04"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 2378e-7,
			"maxDelta": .2310758
		},
		"candidateLicense": "Apache-2.0",
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "metric_safe",
			"italic": "metric_safe",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [{
			"slot": "boldItalic",
			"codepoint": 96,
			"advanceDelta": .231,
			"note": "Caladea Bold Italic grave accent (U+0060) advance diverges ~23% from Cambria; lines containing it reflow. All other glyphs, and the regular/bold/italic faces, are within the direct metric threshold."
		}]
	},
	{
		"evidenceId": "arial",
		"generic": "sans-serif",
		"logicalFamily": "Arial",
		"physicalFamily": "Liberation Sans",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": ["arial__liberation-sans#analytic_advance#2026-06-03"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "arial-mt",
		"generic": "sans-serif",
		"logicalFamily": "Arial MT",
		"physicalFamily": "Liberation Sans",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"arial-mt_regular__liberation-sans#regular#w400#analytic_advance#2026-06-10",
			"arial-mt_bold__liberation-sans#bold#w700#analytic_advance#2026-06-10",
			"arial-mt_italic__liberation-sans#italic#w400#analytic_advance#2026-06-10",
			"arial-mt_boldItalic__liberation-sans#boldItalic#w700#analytic_advance#2026-06-10"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_text",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "arial-unicode-ms",
		"generic": "sans-serif",
		"logicalFamily": "Arial Unicode MS",
		"physicalFamily": null,
		"verdict": "customer_supplied",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "not_run",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "customer_supplied",
		"measurementRefs": ["arial-unicode-ms#broad_unicode_no_open_substitute#2026-06-10"],
		"exportRule": "preserve_original_name",
		"candidateLicense": null
	},
	{
		"evidenceId": "times-new-roman",
		"generic": "serif",
		"logicalFamily": "Times New Roman",
		"physicalFamily": "Liberation Serif",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": ["times-new-roman__liberation-serif#analytic_advance#2026-06-03"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "times",
		"generic": "serif",
		"logicalFamily": "Times",
		"physicalFamily": "Liberation Serif",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"times_regular__liberation-serif#regular#w400#analytic_advance#2026-06-10",
			"times_bold__liberation-serif#bold#w700#analytic_advance#2026-06-10",
			"times_italic__liberation-serif#italic#w400#analytic_advance#2026-06-10",
			"times_boldItalic__liberation-serif#boldItalic#w700#analytic_advance#2026-06-10"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_text",
			"meanDelta": 98877e-8,
			"maxDelta": .1171875
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "metric_safe",
			"italic": "metric_safe",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [{
			"slot": "boldItalic",
			"codepoint": 239,
			"advanceDelta": .1172,
			"note": "Times Bold Italic vs Liberation Serif Bold Italic: small i diaeresis (U+00EF) advance differs ~11.7%; lines containing it can reflow. Regular, bold, and italic faces are metric_safe on the text sample."
		}]
	},
	{
		"evidenceId": "courier-new",
		"generic": "monospace",
		"logicalFamily": "Courier New",
		"physicalFamily": "Liberation Mono",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": ["courier-new__liberation-mono#analytic_advance#2026-06-03"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "courier",
		"generic": "monospace",
		"logicalFamily": "Courier",
		"physicalFamily": "Liberation Mono",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["courier__liberation-mono#monospace_cell#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "monospace_cell",
			"meanDelta": .0016,
			"maxDelta": .2002
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [
			{
				"slot": "regular",
				"codepoint": 176,
				"advanceDelta": .2002,
				"note": "Courier Regular vs Liberation Mono Regular: degree sign (U+00B0) advance differs ~20%; plus-minus (U+00B1) and division sign (U+00F7) also exceed the direct threshold."
			},
			{
				"slot": "bold",
				"codepoint": 176,
				"advanceDelta": .2002,
				"note": "Courier Bold vs Liberation Mono Bold: degree sign (U+00B0) advance differs ~20%; plus-minus (U+00B1) and division sign (U+00F7) also exceed the direct threshold."
			},
			{
				"slot": "italic",
				"codepoint": 176,
				"advanceDelta": .2002,
				"note": "Courier Italic vs Liberation Mono Italic: degree sign (U+00B0) advance differs ~20%; plus-minus (U+00B1) and division sign (U+00F7) also exceed the direct threshold."
			},
			{
				"slot": "boldItalic",
				"codepoint": 176,
				"advanceDelta": .2002,
				"note": "Courier Bold Italic vs Liberation Mono Bold Italic: degree sign (U+00B0) advance differs ~20%; plus-minus (U+00B1) and division sign (U+00F7) also exceed the direct threshold."
			}
		]
	},
	{
		"evidenceId": "georgia",
		"generic": "serif",
		"logicalFamily": "Georgia",
		"physicalFamily": "Gelasio",
		"verdict": "near_metric",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "pass",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"georgia_regular__gelasio#regular#w400#1543f04d#analytic_advance#2026-06-04",
			"georgia_bold__gelasio#bold#w700#5a1b9bd7#analytic_advance#2026-06-04",
			"georgia_italic__gelasio#italic#w400#be1243a9#analytic_advance#2026-06-04",
			"georgia_boldItalic__gelasio#boldItalic#w700#6f3b3f7a#analytic_advance#2026-06-04",
			"georgia_regular__gelasio#regular#w400#1543f04d#live_layout#2026-06-03",
			"georgia_bold__gelasio#bold#w700#5a1b9bd7#live_layout#2026-06-03",
			"georgia_italic__gelasio#italic#w400#be1243a9#live_layout#2026-06-03",
			"georgia_boldItalic__gelasio#boldItalic#w700#6f3b3f7a#live_layout#2026-06-03"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 197e-7,
			"maxDelta": .0183727
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "metric_safe",
			"italic": "near_metric",
			"boldItalic": "near_metric"
		},
		"glyphExceptions": [{
			"slot": "italic",
			"codepoint": 210,
			"advanceDelta": .0184,
			"note": "Georgia Italic vs Gelasio Italic: accented capital O (U+00D2-D8: O-grave/acute/circumflex/diaeresis/stroke) advance differs ~1.84%. 5 rare glyphs; all other glyphs exact, mean 0%."
		}, {
			"slot": "boldItalic",
			"codepoint": 204,
			"advanceDelta": .011,
			"note": "Georgia Bold Italic vs Gelasio Bold Italic: accented capital I (U+00CC-CE: I-grave/acute/circumflex) advance differs ~1.10%. 3 rare glyphs; all other glyphs exact, mean ~0%."
		}]
	},
	{
		"evidenceId": "arial-narrow",
		"generic": "sans-serif",
		"logicalFamily": "Arial Narrow",
		"physicalFamily": "Liberation Sans Narrow",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"arial-narrow_regular__liberation-sans-narrow#regular#w400#546e8957#analytic_advance#2026-06-04",
			"arial-narrow_bold__liberation-sans-narrow#bold#w700#8e5eb509#analytic_advance#2026-06-04",
			"arial-narrow_italic__liberation-sans-narrow#italic#w400#c5de4127#analytic_advance#2026-06-04",
			"arial-narrow_boldItalic__liberation-sans-narrow#boldItalic#w700#57fe1513#analytic_advance#2026-06-04"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": .5
		},
		"candidateLicense": "GPL-2.0-only WITH Font-exception-2.0",
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "visual_only",
			"italic": "metric_safe",
			"boldItalic": "metric_safe"
		},
		"glyphExceptions": [{
			"slot": "bold",
			"codepoint": 160,
			"advanceDelta": .5,
			"note": "Arial Narrow Bold no-break space (U+00A0) is double-width (2x the regular space); Liberation Sans Narrow Bold matches the regular space, so lines containing a non-breaking space reflow. All other glyphs, and the regular/italic/boldItalic faces, match within the direct metric threshold."
		}]
	},
	{
		"evidenceId": "aptos",
		"generic": "sans-serif",
		"logicalFamily": "Aptos",
		"physicalFamily": null,
		"verdict": "no_substitute",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "fail",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "customer_supplied",
		"measurementRefs": ["aptos#top_candidates#2026-06-03"],
		"exportRule": "preserve_original_name",
		"candidateLicense": null
	},
	{
		"evidenceId": "arial-black",
		"generic": "sans-serif",
		"logicalFamily": "Arial Black",
		"physicalFamily": "Archivo Black",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": { "italic": {
			"kind": "synthetic",
			"from": "regular"
		} },
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": ["arial-black__archivo-black#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": { "italic": "visual_only" }
	},
	{
		"evidenceId": "arial-rounded-mt-bold",
		"generic": "sans-serif",
		"logicalFamily": "Arial Rounded MT Bold",
		"physicalFamily": "Ubuntu",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["arial-rounded-mt-bold__ubuntu#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "Ubuntu-font-1.0"
	},
	{
		"evidenceId": "bookman-old-style",
		"generic": "serif",
		"logicalFamily": "Bookman Old Style",
		"physicalFamily": "TeX Gyre Bonum",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": ["bookman-old-style__tex-gyre-bonum#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "LicenseRef-GUST-Font-License-1.0"
	},
	{
		"evidenceId": "itc-bookman",
		"generic": "serif",
		"logicalFamily": "ITC Bookman",
		"physicalFamily": "TeX Gyre Bonum",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": ["itc-bookman__tex-gyre-bonum#alias_of_bookman-old-style#2026-06-10"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "LicenseRef-GUST-Font-License-1.0"
	},
	{
		"evidenceId": "century",
		"generic": "serif",
		"logicalFamily": "Century",
		"physicalFamily": "C059",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": ["century_regular__c059#regular#w400#analytic_advance#2026-06-10", "century__c059#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "AGPL-3.0-only WITH PS-or-PDF-font-exception-20170817",
		"advance": {
			"basis": "latin_full",
			"meanDelta": .00293647,
			"maxDelta": .167
		},
		"faceVerdicts": { "regular": "metric_safe" },
		"glyphExceptions": [{
			"slot": "regular",
			"codepoint": 175,
			"advanceDelta": .167,
			"note": "Century Regular vs C059 Roman: macron (U+00AF) advance differs ~16.7%; yen (U+00A5), plus-minus (U+00B1), division sign (U+00F7), and middle dot (U+00B7) also exceed the direct threshold. Body-text Latin sample is metric_safe."
		}]
	},
	{
		"evidenceId": "century-schoolbook",
		"generic": "serif",
		"logicalFamily": "Century Schoolbook",
		"physicalFamily": "C059",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "substitute",
		"measurementRefs": [
			"century-schoolbook_regular__c059#regular#w400#analytic_advance#2026-06-10",
			"century-schoolbook_bold__c059#bold#w700#analytic_advance#2026-06-10",
			"century-schoolbook_italic__c059#italic#w400#analytic_advance#2026-06-10",
			"century-schoolbook_boldItalic__c059#boldItalic#w700#analytic_advance#2026-06-10",
			"century-schoolbook__c059#visual_review#2026-06-09"
		],
		"exportRule": "preserve_original_name",
		"candidateLicense": "AGPL-3.0-only WITH PS-or-PDF-font-exception-20170817",
		"advance": {
			"basis": "latin_full",
			"meanDelta": .00337127,
			"maxDelta": .167
		},
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "metric_safe",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [{
			"slot": "regular",
			"codepoint": 175,
			"advanceDelta": .167,
			"note": "Century Schoolbook Regular vs C059 Roman: macron (U+00AF) advance differs ~16.7%; yen (U+00A5), plus-minus (U+00B1), division sign (U+00F7), and middle dot (U+00B7) also exceed the direct threshold. Body-text Latin sample is metric_safe."
		}, {
			"slot": "bold",
			"codepoint": 175,
			"advanceDelta": .167,
			"note": "Century Schoolbook Bold vs C059 Bold: macron (U+00AF) advance differs ~16.7%; yen (U+00A5), micro sign (U+00B5), plus-minus (U+00B1), and division sign (U+00F7) also exceed the direct threshold. Body-text Latin sample is metric_safe."
		}]
	},
	{
		"evidenceId": "century-gothic",
		"generic": "sans-serif",
		"logicalFamily": "Century Gothic",
		"physicalFamily": "URW Gothic",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": [
			"century-gothic_regular__urw-gothic#regular#w400#analytic_advance#2026-06-10",
			"century-gothic_bold__urw-gothic#bold#w700#analytic_advance#2026-06-10",
			"century-gothic_italic__urw-gothic#italic#w400#analytic_advance#2026-06-10",
			"century-gothic_boldItalic__urw-gothic#boldItalic#w700#analytic_advance#2026-06-10",
			"century-gothic__urw-gothic#visual_review#2026-06-10"
		],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_text",
			"meanDelta": .0013,
			"maxDelta": .1662
		},
		"candidateLicense": "AGPL-3.0-only WITH PS-or-PDF-font-exception-20170817",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [{
			"slot": "regular",
			"codepoint": 35,
			"advanceDelta": .1662,
			"note": "Century Gothic Regular vs URW Gothic Book: number sign (U+0023) advance differs ~16.6%; caret (U+005E) and plus-minus (U+00B1) also exceed the direct threshold. Body text is close, but not line-break safe."
		}]
	},
	{
		"evidenceId": "garamond",
		"generic": "serif",
		"logicalFamily": "Garamond",
		"physicalFamily": "Cardo",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": false
		},
		"faceSources": { "boldItalic": {
			"kind": "synthetic",
			"from": "bold"
		} },
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["garamond__cardo#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": { "boldItalic": "visual_only" }
	},
	{
		"evidenceId": "consolas",
		"generic": "monospace",
		"logicalFamily": "Consolas",
		"physicalFamily": "Inconsolata SemiExpanded",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["consolas__inconsolata-semiexpanded#monospace_cell#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "monospace_cell",
			"meanDelta": 19531e-8,
			"maxDelta": 19531e-8
		},
		"candidateLicense": "OFL-1.1",
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"faceVerdicts": {
			"regular": "cell_width_only",
			"bold": "cell_width_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "verdana",
		"generic": "sans-serif",
		"logicalFamily": "Verdana",
		"physicalFamily": "Noto Sans",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["verdana__noto-sans#visual_review#2026-06-10"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "tahoma",
		"generic": "sans-serif",
		"logicalFamily": "Tahoma",
		"physicalFamily": "Noto Sans",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["tahoma__noto-sans#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "segoe-ui",
		"generic": "sans-serif",
		"logicalFamily": "Segoe UI",
		"physicalFamily": "Selawik",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["segoe-ui__selawik#coverage_limited_advance_probe#2026-06-10"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "trebuchet-ms",
		"generic": "sans-serif",
		"logicalFamily": "Trebuchet MS",
		"physicalFamily": "PT Sans",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["trebuchet-ms__pt-sans#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "comic-sans-ms",
		"generic": "sans-serif",
		"logicalFamily": "Comic Sans MS",
		"physicalFamily": "Comic Relief",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["comic-sans-ms__comic-relief#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "candara",
		"generic": "sans-serif",
		"logicalFamily": "Candara",
		"physicalFamily": null,
		"verdict": "visual_only",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "fail",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["candara#top_candidates#2026-06-03"],
		"exportRule": "preserve_original_name",
		"candidateLicense": null
	},
	{
		"evidenceId": "constantia",
		"generic": "serif",
		"logicalFamily": "Constantia",
		"physicalFamily": null,
		"verdict": "visual_only",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "fail",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["constantia#top_candidates#2026-06-03"],
		"exportRule": "preserve_original_name",
		"candidateLicense": null
	},
	{
		"evidenceId": "corbel",
		"generic": "sans-serif",
		"logicalFamily": "Corbel",
		"physicalFamily": null,
		"verdict": "visual_only",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "fail",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["corbel#top_candidates#2026-06-03"],
		"exportRule": "preserve_original_name",
		"candidateLicense": null
	},
	{
		"evidenceId": "lucida-console",
		"generic": "monospace",
		"logicalFamily": "Lucida Console",
		"physicalFamily": "Noto Sans Mono",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["lucida-console__noto-sans-mono#monospace_cell#analytic_advance#2026-06-09", "lucida-console__noto-sans-mono#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "monospace_cell",
			"meanDelta": .00254,
			"maxDelta": .00303
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "cell_width_only",
			"bold": "cell_width_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "gill-sans-mt-condensed",
		"generic": "sans-serif",
		"logicalFamily": "Gill Sans MT Condensed",
		"physicalFamily": "PT Sans Narrow",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["gill-sans-mt-condensed__pt-sans-narrow#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "yu-mincho",
		"generic": "serif",
		"logicalFamily": "Yu Mincho",
		"physicalFamily": "BIZ UDMincho",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["yu-mincho_regular__biz-udmincho#regular#w400#cjk_jp_text#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "cjk_jp_text",
			"meanDelta": .0425,
			"maxDelta": .4829
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "ms-mincho",
		"generic": "serif",
		"logicalFamily": "MS Mincho",
		"physicalFamily": "BIZ UDMincho",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["ms-mincho_regular__biz-udmincho#regular#w400#cjk_jp_text#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "cjk_jp_text",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "cell_width_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "ms-gothic",
		"generic": "sans-serif",
		"logicalFamily": "MS Gothic",
		"physicalFamily": "BIZ UDGothic",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["ms-gothic_regular__biz-udgothic#regular#w400#cjk_jp_text#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "cjk_jp_text",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "cell_width_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "yu-gothic",
		"generic": "sans-serif",
		"logicalFamily": "Yu Gothic",
		"physicalFamily": "BIZ UDGothic",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "bold"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["yu-gothic_regular__biz-udgothic#regular#w400#cjk_jp_text#analytic_advance#2026-06-10", "yu-gothic_bold__biz-udgothic#bold#w700#cjk_jp_text#analytic_advance#2026-06-10"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "cjk_jp_text",
			"meanDelta": .0415,
			"maxDelta": .4521
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	},
	{
		"evidenceId": "aptos-display",
		"generic": "sans-serif",
		"logicalFamily": "Aptos Display",
		"physicalFamily": null,
		"verdict": "customer_supplied",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "not_run",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "customer_supplied",
		"measurementRefs": [],
		"exportRule": "preserve_original_name"
	},
	{
		"evidenceId": "cambria-math",
		"generic": "serif",
		"logicalFamily": "Cambria Math",
		"physicalFamily": null,
		"verdict": "preserve_only",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "not_run",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "preserve_only",
		"measurementRefs": [],
		"exportRule": "preserve_original_name"
	},
	{
		"evidenceId": "helvetica",
		"generic": "sans-serif",
		"logicalFamily": "Helvetica",
		"physicalFamily": "Liberation Sans",
		"verdict": "metric_safe",
		"faces": {
			"regular": true,
			"bold": true,
			"italic": true,
			"boldItalic": true
		},
		"gates": {
			"static": "not_run",
			"metric": "pass",
			"layout": "not_run",
			"ship": "pass"
		},
		"policyAction": "substitute",
		"measurementRefs": ["helvetica__liberation-sans#analytic_advance#2026-06-03"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "calibri-light",
		"generic": "sans-serif",
		"logicalFamily": "Calibri Light",
		"physicalFamily": "Carlito",
		"verdict": "visual_only",
		"faces": {
			"regular": false,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"gates": {
			"static": "not_run",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["calibri-light__carlito#analytic_advance#2026-06-05"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": .0148,
			"maxDelta": .066
		},
		"candidateLicense": "OFL-1.1"
	},
	{
		"evidenceId": "baskerville-old-face",
		"generic": "serif",
		"logicalFamily": "Baskerville Old Face",
		"physicalFamily": "Bacasime Antique",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"bold": {
				"kind": "synthetic",
				"from": "regular"
			},
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "regular"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "substitute",
		"measurementRefs": ["baskerville-old-face_regular__bacasime-antique#regular#w400#7dac1e5f#analytic_advance#2026-06-05", "baskerville-old-face__bacasime-antique#synthetic_faces#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": .4915590863952334
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		},
		"glyphExceptions": [{
			"slot": "regular",
			"codepoint": 160,
			"advanceDelta": .4916,
			"note": "Bacasime Antique Regular's no-break space (U+00A0) advance diverges ~49% from Baskerville Old Face; lines containing NBSP reflow. Every other Latin-core glyph is advance-identical, which is why this is visual_only with a single named exception, not near_metric."
		}]
	},
	{
		"evidenceId": "brush-script-mt",
		"generic": "serif",
		"logicalFamily": "Brush Script MT",
		"physicalFamily": "Oregano Italic",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": { "bold": {
			"kind": "synthetic",
			"from": "regular"
		} },
		"gates": {
			"static": "pass",
			"metric": "fail",
			"layout": "not_run",
			"ship": "fail"
		},
		"policyAction": "category_fallback",
		"measurementRefs": ["brush-script-mt__oregano-italic#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "visual_only",
			"bold": "visual_only"
		}
	},
	{
		"evidenceId": "cooper-black",
		"generic": "serif",
		"logicalFamily": "Cooper Black",
		"physicalFamily": "Caprasimo",
		"verdict": "visual_only",
		"faces": {
			"regular": true,
			"bold": false,
			"italic": false,
			"boldItalic": false
		},
		"faceSources": {
			"bold": {
				"kind": "synthetic",
				"from": "regular"
			},
			"italic": {
				"kind": "synthetic",
				"from": "regular"
			},
			"boldItalic": {
				"kind": "synthetic",
				"from": "regular"
			}
		},
		"gates": {
			"static": "pass",
			"metric": "pass",
			"layout": "not_run",
			"ship": "not_run"
		},
		"policyAction": "substitute",
		"measurementRefs": ["cooper-black_regular__caprasimo#regular#w400#786ab84e#analytic_advance#2026-06-05", "cooper-black__caprasimo#synthetic_faces#visual_review#2026-06-09"],
		"exportRule": "preserve_original_name",
		"advance": {
			"basis": "latin_full",
			"meanDelta": 0,
			"maxDelta": 0
		},
		"candidateLicense": "OFL-1.1",
		"faceVerdicts": {
			"regular": "metric_safe",
			"bold": "visual_only",
			"italic": "visual_only",
			"boldItalic": "visual_only"
		}
	}
];
var LINE_BREAK_SAFE_VERDICTS = new Set([
	"metric_safe",
	"near_metric",
	"cell_width_only"
]);
function normalizeFamilyName(name) {
	return name.trim().replace(/^['"]+|['"]+$/g, "").trim().toLowerCase();
}
var BY_LOGICAL = new Map(SUBSTITUTION_EVIDENCE$1.map((row) => [normalizeFamilyName(row.logicalFamily), row]));
function buildFallback(row, physicalFamily, verdict, faceSlot, faceSource) {
	const glyphExceptions = faceSlot ? row.glyphExceptions?.filter((g) => g.slot === faceSlot) : row.glyphExceptions ? [...row.glyphExceptions] : void 0;
	return {
		substituteFamily: physicalFamily,
		policyAction: row.policyAction,
		verdict,
		lineBreakSafe: LINE_BREAK_SAFE_VERDICTS.has(verdict),
		faces: row.faces,
		evidenceId: row.evidenceId,
		generic: row.generic,
		...faceSource ? { faceSource: { ...faceSource } } : {},
		...glyphExceptions && glyphExceptions.length > 0 ? { glyphExceptions } : {}
	};
}
function decideRow(row, canRenderFamily$1) {
	const { policyAction, physicalFamily, verdict, evidenceId, generic } = row;
	if (policyAction === "preserve_only") return {
		kind: "preserve_only",
		evidenceId,
		generic
	};
	if (policyAction === "customer_supplied") return {
		kind: "customer_supplied",
		evidenceId,
		generic
	};
	if (physicalFamily === null) return {
		kind: "no_recommended_fallback",
		evidenceId,
		generic
	};
	if (canRenderFamily$1 && !canRenderFamily$1(physicalFamily)) return {
		kind: "asset_missing",
		substituteFamily: physicalFamily,
		verdict,
		evidenceId,
		generic
	};
	return {
		kind: "fallback",
		fallback: buildFallback(row, physicalFamily, verdict)
	};
}
function isFaceScoped(row) {
	const f = row.faces;
	return f.regular || f.bold || f.italic || f.boldItalic;
}
function faceSourceFor(row, face) {
	const explicit = row.faceSources?.[face];
	if (explicit) return explicit;
	return isFaceScoped(row) && row.faces[face] ? { kind: "real" } : void 0;
}
function decideRowForFace(row, face, canRenderFamily$1) {
	const base$1 = decideRow(row, canRenderFamily$1);
	if (base$1.kind !== "fallback") return base$1;
	const faceSource = faceSourceFor(row, face);
	if (isFaceScoped(row) && !faceSource) return {
		kind: "face_missing",
		substituteFamily: base$1.fallback.substituteFamily,
		evidenceId: row.evidenceId,
		generic: row.generic
	};
	const faceVerdict = row.faceVerdicts?.[face] ?? row.verdict;
	const projectedFaceSource = faceSource?.kind === "synthetic" ? faceSource : void 0;
	return {
		kind: "fallback",
		fallback: buildFallback(row, base$1.fallback.substituteFamily, faceVerdict, face, projectedFaceSource)
	};
}
function getFallbackDecision(family$1, options = {}) {
	const row = BY_LOGICAL.get(normalizeFamilyName(family$1));
	return row ? decideRow(row, options.canRenderFamily) : { kind: "unknown" };
}
function getRenderableFallback(family$1, options) {
	const decision = getFallbackDecision(family$1, options);
	return decision.kind === "fallback" ? decision.fallback : null;
}
function getFallbackDecisionForFace(family$1, face, options = {}) {
	const row = BY_LOGICAL.get(normalizeFamilyName(family$1));
	return row ? decideRowForFace(row, face, options.canRenderFamily) : { kind: "unknown" };
}
function getRenderableFallbackForFace(family$1, face, options) {
	const decision = getFallbackDecisionForFace(family$1, face, options);
	return decision.kind === "fallback" ? decision.fallback : null;
}
function fourFaces(filePrefix) {
	return [
		{
			weight: "normal",
			style: "normal",
			file: `${filePrefix}-Regular.woff2`
		},
		{
			weight: "bold",
			style: "normal",
			file: `${filePrefix}-Bold.woff2`
		},
		{
			weight: "normal",
			style: "italic",
			file: `${filePrefix}-Italic.woff2`
		},
		{
			weight: "bold",
			style: "italic",
			file: `${filePrefix}-BoldItalic.woff2`
		}
	];
}
function family(name, filePrefix, license) {
	return {
		family: name,
		license,
		faces: fourFaces(filePrefix)
	};
}
function familyWithFaces(name, license, faces) {
	return {
		family: name,
		license,
		faces
	};
}
const BUNDLED_MANIFEST = Object.freeze([
	family("Carlito", "Carlito", "OFL-1.1"),
	family("Caladea", "Caladea", "Apache-2.0"),
	family("Liberation Sans", "LiberationSans", "OFL-1.1"),
	family("Liberation Sans Narrow", "LiberationSansNarrow", "GPL-2.0-only WITH Font-exception-2.0"),
	family("Liberation Serif", "LiberationSerif", "OFL-1.1"),
	family("Liberation Mono", "LiberationMono", "OFL-1.1"),
	familyWithFaces("Caprasimo", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "Caprasimo-Regular.woff2"
	}]),
	familyWithFaces("Archivo Black", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "ArchivoBlack-Regular.woff2"
	}]),
	familyWithFaces("C059", "AGPL-3.0-only WITH PS-or-PDF-font-exception-20170817", [
		{
			weight: "normal",
			style: "normal",
			file: "C059-Roman.woff2"
		},
		{
			weight: "bold",
			style: "normal",
			file: "C059-Bold.woff2"
		},
		{
			weight: "normal",
			style: "italic",
			file: "C059-Italic.woff2"
		},
		{
			weight: "bold",
			style: "italic",
			file: "C059-BdIta.woff2"
		}
	]),
	familyWithFaces("URW Gothic", "AGPL-3.0-only WITH PS-or-PDF-font-exception-20170817", [
		{
			weight: "normal",
			style: "normal",
			file: "URWGothic-Book.woff2"
		},
		{
			weight: "bold",
			style: "normal",
			file: "URWGothic-Demi.woff2"
		},
		{
			weight: "normal",
			style: "italic",
			file: "URWGothic-BookOblique.woff2"
		},
		{
			weight: "bold",
			style: "italic",
			file: "URWGothic-DemiOblique.woff2"
		}
	]),
	familyWithFaces("Bacasime Antique", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "BacasimeAntique-Regular.woff2"
	}]),
	familyWithFaces("Oregano Italic", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "OreganoItalic-Regular.woff2"
	}]),
	family("Gelasio", "Gelasio", "OFL-1.1"),
	familyWithFaces("Cardo", "OFL-1.1", [
		{
			weight: "normal",
			style: "normal",
			file: "Cardo-Regular.woff2"
		},
		{
			weight: "bold",
			style: "normal",
			file: "Cardo-Bold.woff2"
		},
		{
			weight: "normal",
			style: "italic",
			file: "Cardo-Italic.woff2"
		}
	]),
	familyWithFaces("Comic Relief", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "ComicRelief-Regular.woff2"
	}, {
		weight: "bold",
		style: "normal",
		file: "ComicRelief-Bold.woff2"
	}]),
	family("Noto Sans", "NotoSans", "OFL-1.1"),
	familyWithFaces("Selawik", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "Selawik-Regular.woff2"
	}, {
		weight: "bold",
		style: "normal",
		file: "Selawik-Bold.woff2"
	}]),
	familyWithFaces("Noto Sans Mono", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "NotoSansMono-Regular.woff2"
	}, {
		weight: "bold",
		style: "normal",
		file: "NotoSansMono-Bold.woff2"
	}]),
	familyWithFaces("Inconsolata SemiExpanded", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "InconsolataSemiExpanded-Regular.woff2"
	}, {
		weight: "bold",
		style: "normal",
		file: "InconsolataSemiExpanded-Bold.woff2"
	}]),
	family("PT Sans", "PTSans", "OFL-1.1"),
	familyWithFaces("PT Sans Narrow", "OFL-1.1", [{
		weight: "normal",
		style: "normal",
		file: "PTSansNarrow-Regular.woff2"
	}, {
		weight: "bold",
		style: "normal",
		file: "PTSansNarrow-Bold.woff2"
	}]),
	family("TeX Gyre Bonum", "TeXGyreBonum", "LicenseRef-GUST-Font-License-1.0")
]);
const SUBSTITUTION_EVIDENCE = SUBSTITUTION_EVIDENCE$1;
function normalizeFamilyKey$1(family$1) {
	return family$1.trim().replace(/^["']|["']$/g, "").toLowerCase();
}
function sortPairs(pairs) {
	return pairs.sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0);
}
var bundledFamilies = new Set(BUNDLED_MANIFEST.map((f) => f.family));
var canRenderFamily = (family$1) => bundledFamilies.has(family$1);
function faceSlotFor$1({ weight, style }) {
	const bold = weight === "700";
	const italic = style === "italic";
	if (bold && italic) return "boldItalic";
	if (bold) return "bold";
	if (italic) return "italic";
	return "regular";
}
function faceKeyForSlot(slot) {
	switch (slot) {
		case "bold": return {
			weight: "700",
			style: "normal"
		};
		case "italic": return {
			weight: "400",
			style: "italic"
		};
		case "boldItalic": return {
			weight: "700",
			style: "italic"
		};
		case "regular": return {
			weight: "400",
			style: "normal"
		};
	}
}
function reasonForFallback(policyAction) {
	return policyAction === "category_fallback" ? "category_fallback" : "bundled_substitute";
}
function resolveDocfontsFace(primary, face, hasFace) {
	const decision = getFallbackDecisionForFace(primary, faceSlotFor$1(face), { canRenderFamily });
	if (decision.kind === "face_missing") return {
		physical: primary,
		reason: "fallback_face_absent"
	};
	if (decision.kind !== "fallback") return null;
	const fallback = decision.fallback;
	if (fallback.policyAction !== "substitute" && fallback.policyAction !== "category_fallback") return null;
	if (hasFace(fallback.substituteFamily, face.weight, face.style)) return {
		physical: fallback.substituteFamily,
		reason: reasonForFallback(fallback.policyAction)
	};
	const sourceFace = fallback.faceSource?.kind === "synthetic" ? faceKeyForSlot(fallback.faceSource.from) : face;
	if (!hasFace(fallback.substituteFamily, sourceFace.weight, sourceFace.style)) return fallback.policyAction === "substitute" ? {
		physical: primary,
		reason: "fallback_face_absent"
	} : null;
	const sourceDiffers = sourceFace.weight !== face.weight || sourceFace.style !== face.style;
	return {
		physical: fallback.substituteFamily,
		reason: reasonForFallback(fallback.policyAction),
		...sourceDiffers ? { sourceFace } : {}
	};
}
function deriveBundledSubstitutes() {
	const substitutes = {};
	for (const row of SUBSTITUTION_EVIDENCE) {
		const fallback = getRenderableFallback(row.logicalFamily, { canRenderFamily });
		if (fallback?.policyAction === "substitute") substitutes[normalizeFamilyKey$1(row.logicalFamily)] = fallback.substituteFamily;
	}
	return Object.freeze(substitutes);
}
var BUNDLED_SUBSTITUTES = deriveBundledSubstitutes();
function deriveCategoryFallbacks() {
	const fallbacks = {};
	for (const row of SUBSTITUTION_EVIDENCE) {
		const fallback = getRenderableFallback(row.logicalFamily, { canRenderFamily });
		if (fallback?.policyAction === "category_fallback") fallbacks[normalizeFamilyKey$1(row.logicalFamily)] = fallback.substituteFamily;
	}
	return Object.freeze(fallbacks);
}
var CATEGORY_FALLBACKS = deriveCategoryFallbacks();
function stripFamilyQuotes(family$1) {
	return family$1.trim().replace(/^["']|["']$/g, "");
}
function splitStack(cssFontFamily) {
	return cssFontFamily.split(",").map((part) => part.trim()).filter(Boolean);
}
var FontResolver = class {
	#overrides = /* @__PURE__ */ new Map();
	#embedded = /* @__PURE__ */ new Map();
	#version = 0;
	#cachedSignature = null;
	map(logicalFamily, physicalFamily) {
		const key = normalizeFamilyKey$1(logicalFamily);
		const physical = physicalFamily?.trim();
		if (!key || !physical) return;
		if (this.#overrides.get(key) === physical) return;
		if (key === normalizeFamilyKey$1(physical)) {
			if (this.#overrides.delete(key)) {
				this.#version += 1;
				this.#cachedSignature = null;
			}
			return;
		}
		this.#overrides.set(key, physical);
		this.#version += 1;
		this.#cachedSignature = null;
	}
	unmap(logicalFamily) {
		if (this.#overrides.delete(normalizeFamilyKey$1(logicalFamily))) {
			this.#version += 1;
			this.#cachedSignature = null;
		}
	}
	mapEmbedded(logicalFamily, physicalFamily) {
		const key = normalizeFamilyKey$1(logicalFamily);
		const physical = physicalFamily?.trim();
		if (!key || !physical) return;
		if (this.#embedded.get(key) === physical) return;
		this.#embedded.set(key, physical);
		this.#version += 1;
		this.#cachedSignature = null;
	}
	clearEmbedded() {
		if (this.#embedded.size === 0) return;
		this.#embedded.clear();
		this.#version += 1;
		this.#cachedSignature = null;
	}
	reset() {
		if (this.#overrides.size === 0 && this.#embedded.size === 0) return;
		this.#overrides.clear();
		this.#embedded.clear();
		this.#version += 1;
		this.#cachedSignature = null;
	}
	get version() {
		return this.#version;
	}
	get signature() {
		if (this.#cachedSignature !== null) return this.#cachedSignature;
		if (this.#overrides.size === 0 && this.#embedded.size === 0) this.#cachedSignature = "";
		else {
			const overridePairs = sortPairs([...this.#overrides.entries()]);
			this.#cachedSignature = this.#embedded.size === 0 ? JSON.stringify(overridePairs) : JSON.stringify({
				o: overridePairs,
				e: sortPairs([...this.#embedded.entries()])
			});
		}
		return this.#cachedSignature;
	}
	#physicalFor(bareFamily) {
		const key = normalizeFamilyKey$1(bareFamily);
		const override = this.#overrides.get(key);
		if (override) return {
			physical: override,
			reason: "custom_mapping"
		};
		const bundled = BUNDLED_SUBSTITUTES[key];
		if (bundled) return {
			physical: bundled,
			reason: "bundled_substitute"
		};
		const category = CATEGORY_FALLBACKS[key];
		if (category) return {
			physical: category,
			reason: "category_fallback"
		};
		return {
			physical: bareFamily,
			reason: "as_requested"
		};
	}
	#resolveFaceLadder(primary, face, hasFace) {
		const key = normalizeFamilyKey$1(primary);
		const override = this.#overrides.get(key);
		if (override && hasFace(override, face.weight, face.style)) return {
			physical: override,
			reason: "custom_mapping"
		};
		const embedded = this.#embedded.get(key);
		if (embedded && hasFace(embedded, face.weight, face.style)) return {
			physical: embedded,
			reason: "registered_face"
		};
		if (hasFace(primary, face.weight, face.style)) return {
			physical: primary,
			reason: "registered_face"
		};
		const docfonts = resolveDocfontsFace(primary, face, hasFace);
		if (docfonts) return docfonts;
		const bundled = BUNDLED_SUBSTITUTES[key];
		if (override || bundled) return {
			physical: primary,
			reason: "fallback_face_absent"
		};
		return {
			physical: primary,
			reason: "as_requested"
		};
	}
	resolveFontFamily(logicalFamily) {
		const primary = splitStack(logicalFamily)[0] ?? logicalFamily;
		const { physical, reason } = this.#physicalFor(primary);
		return {
			logicalFamily,
			physicalFamily: stripFamilyQuotes(physical),
			reason
		};
	}
	resolvePhysicalFamily(cssFontFamily) {
		if (!cssFontFamily) return cssFontFamily;
		const parts = splitStack(cssFontFamily);
		if (parts.length === 0) return cssFontFamily;
		const { physical, reason } = this.#physicalFor(parts[0]);
		if (reason === "as_requested") return cssFontFamily;
		return [physical, ...parts.slice(1)].join(", ");
	}
	resolveFace(logicalFamily, face, hasFace) {
		const primary = splitStack(logicalFamily)[0] ?? logicalFamily;
		const { physical, reason, sourceFace } = this.#resolveFaceLadder(primary, face, hasFace);
		return {
			logicalFamily,
			physicalFamily: stripFamilyQuotes(physical),
			reason,
			...sourceFace ? { sourceFace } : {}
		};
	}
	resolvePhysicalFamilyForFace(cssFontFamily, face, hasFace) {
		if (!cssFontFamily) return cssFontFamily;
		const parts = splitStack(cssFontFamily);
		if (parts.length === 0) return cssFontFamily;
		const { physical } = this.#resolveFaceLadder(parts[0], face, hasFace);
		if (normalizeFamilyKey$1(physical) !== normalizeFamilyKey$1(parts[0])) return [physical, ...parts.slice(1)].join(", ");
		return cssFontFamily;
	}
	resolvePrimaryPhysicalFamily(family$1) {
		const primary = splitStack(family$1)[0] ?? family$1;
		return this.#physicalFor(primary).physical;
	}
	resolvePhysicalFamilies(families) {
		const out = /* @__PURE__ */ new Set();
		for (const family$1 of families) if (family$1) out.add(this.resolvePrimaryPhysicalFamily(family$1));
		return [...out];
	}
};
function createFontResolver() {
	return new FontResolver();
}
var defaultResolver = new FontResolver();
function resolveFontFamily(logicalFamily) {
	return defaultResolver.resolveFontFamily(logicalFamily);
}
function resolvePhysicalFamily(cssFontFamily) {
	return defaultResolver.resolvePhysicalFamily(cssFontFamily);
}
function resolveFace(logicalFamily, face, hasFace) {
	return defaultResolver.resolveFace(logicalFamily, face, hasFace);
}
const DEFAULT_FONT_MEASURE_CONTEXT = Object.freeze({
	resolvePhysical: (cssFontFamily, _face) => resolvePhysicalFamily(cssFontFamily),
	fontSignature: ""
});
var fontConfigVersion = 0;
function getFontConfigVersion() {
	return fontConfigVersion;
}
function bumpFontConfigVersion() {
	return fontConfigVersion += 1;
}
var defaultAssetBase = "/fonts/";
function withTrailingSlash(base$1) {
	return base$1.endsWith("/") ? base$1 : `${base$1}/`;
}
function joinUrl(base$1, file) {
	return `${withTrailingSlash(base$1)}${file}`;
}
function weightToken(weight) {
	return weight === "bold" ? "700" : "400";
}
var installedRegistries = /* @__PURE__ */ new WeakMap();
function bundledAssetSignature(resolve) {
	const family$1 = BUNDLED_MANIFEST[0];
	const face = family$1?.faces[0];
	if (!family$1 || !face) return "";
	return resolve({
		file: face.file,
		family: family$1.family,
		weight: weightToken(face.weight),
		style: face.style,
		source: "bundled-substitute"
	});
}
function installBundledSubstitutes(registry, options = {}) {
	const resolve = options.resolveAssetUrl ?? ((context) => joinUrl(options.assetBaseUrl ?? defaultAssetBase, context.file));
	const signature = bundledAssetSignature(resolve);
	const installed = installedRegistries.get(registry);
	if (installed !== void 0) {
		if (installed !== signature) console.warn(`[superdoc] bundled fonts are already registered for this document from "${installed}"; a later fonts config resolving to "${signature}" is ignored. Use one fonts.assetBaseUrl / fonts.resolveAssetUrl per document.`);
		return;
	}
	installedRegistries.set(registry, signature);
	for (const family$1 of BUNDLED_MANIFEST) for (const face of family$1.faces) {
		const context = {
			file: face.file,
			family: family$1.family,
			weight: weightToken(face.weight),
			style: face.style,
			source: "bundled-substitute"
		};
		registry.register({
			family: family$1.family,
			source: `url(${resolve(context)})`,
			descriptors: {
				weight: face.weight,
				style: face.style
			}
		});
	}
}
var faceSlotFor = ({ weight, style }) => {
	const bold = weight === "700";
	const italic = style === "italic";
	if (bold && italic) return "boldItalic";
	if (bold) return "bold";
	if (italic) return "italic";
	return "regular";
};
var isRenderedSubstitute = (reason) => reason === "bundled_substitute" || reason === "category_fallback";
var RENDER_ALL = { canRenderFamily: () => true };
function toEvidence(fallback) {
	if (!fallback) return void 0;
	return {
		evidenceId: fallback.evidenceId,
		policyAction: fallback.policyAction,
		verdict: fallback.verdict,
		lineBreakSafe: fallback.lineBreakSafe,
		...fallback.glyphExceptions ? { glyphExceptions: fallback.glyphExceptions } : {}
	};
}
function buildFontReport(logicalFamilies, registry, resolver$1) {
	const seen = /* @__PURE__ */ new Set();
	const report = [];
	for (const logical of logicalFamilies) {
		if (!logical || seen.has(logical)) continue;
		seen.add(logical);
		const { physicalFamily, reason } = resolver$1 ? resolver$1.resolveFontFamily(logical) : resolveFontFamily(logical);
		const loadStatus = registry.getStatus(physicalFamily);
		const evidence = isRenderedSubstitute(reason) ? toEvidence(getRenderableFallback(logical, RENDER_ALL)) : void 0;
		report.push({
			logicalFamily: logical,
			physicalFamily,
			reason,
			loadStatus,
			exportFamily: logical,
			missing: reason === "category_fallback" || isSettled(loadStatus) && loadStatus !== "loaded",
			...evidence ? { evidence } : {}
		});
	}
	return report;
}
function buildFaceReport(usedFaces, registry, resolver$1) {
	const hasFace = (family$1, weight, style) => registry.hasFace(family$1, weight, style);
	const seen = /* @__PURE__ */ new Set();
	const report = [];
	for (const { logicalFamily, weight, style } of usedFaces) {
		if (!logicalFamily) continue;
		const key = `${logicalFamily.toLowerCase()}|${weight}|${style}`;
		if (seen.has(key)) continue;
		seen.add(key);
		const face = {
			weight,
			style
		};
		const resolution = resolver$1 ? resolver$1.resolveFace(logicalFamily, face, hasFace) : resolveFace(logicalFamily, face, hasFace);
		const { physicalFamily, reason } = resolution;
		const statusFace = resolution.sourceFace ?? face;
		const loadStatus = registry.getFaceStatus({
			family: physicalFamily,
			weight: statusFace.weight,
			style: statusFace.style
		});
		const missing = reason === "fallback_face_absent" || reason === "category_fallback" || isSettled(loadStatus) && loadStatus !== "loaded";
		const evidence = isRenderedSubstitute(reason) ? toEvidence(getRenderableFallbackForFace(logicalFamily, faceSlotFor(face), RENDER_ALL)) : void 0;
		report.push({
			logicalFamily,
			physicalFamily: reason === "registered_face" ? logicalFamily : physicalFamily,
			reason,
			loadStatus,
			exportFamily: logicalFamily,
			missing,
			face,
			...evidence ? { evidence } : {}
		});
	}
	return report;
}
var FS_TYPE_RESTRICTED = 2;
var FS_SELECTION_ITALIC = 1;
var BOLD_WEIGHT_THRESHOLD = 600;
var SFNT_TABLE_DIR_OFFSET = 12;
var SFNT_TABLE_RECORD_SIZE = 16;
var OS2_USWEIGHTCLASS = 4;
var OS2_FSTYPE = 8;
var OS2_FSSELECTION = 62;
var OS2_MIN_LENGTH = OS2_FSSELECTION + 2;
function parseEmbeddingPolicy(bytes) {
	const view = bytes instanceof ArrayBuffer ? new DataView(bytes) : new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	if (view.byteLength < SFNT_TABLE_DIR_OFFSET) return null;
	const numTables = view.getUint16(4);
	let os2Offset = -1;
	for (let i$1 = 0; i$1 < numTables; i$1 += 1) {
		const record = SFNT_TABLE_DIR_OFFSET + i$1 * SFNT_TABLE_RECORD_SIZE;
		if (record + SFNT_TABLE_RECORD_SIZE > view.byteLength) return null;
		if (String.fromCharCode(view.getUint8(record), view.getUint8(record + 1), view.getUint8(record + 2), view.getUint8(record + 3)) === "OS/2") {
			os2Offset = view.getUint32(record + 8);
			break;
		}
	}
	if (os2Offset < 0 || os2Offset + OS2_MIN_LENGTH > view.byteLength) return null;
	const usWeightClass = view.getUint16(os2Offset + OS2_USWEIGHTCLASS);
	const fsType = view.getUint16(os2Offset + OS2_FSTYPE);
	const fsSelection = view.getUint16(os2Offset + OS2_FSSELECTION);
	return {
		fsType,
		face: {
			weight: usWeightClass >= BOLD_WEIGHT_THRESHOLD ? "700" : "400",
			style: (fsSelection & FS_SELECTION_ITALIC) !== 0 ? "italic" : "normal"
		},
		embeddable: (fsType & FS_TYPE_RESTRICTED) === 0
	};
}
const DEFAULT_FONT_LOAD_TIMEOUT_MS = 3e3;
var DEFAULT_PROBE_SIZE = "16px";
function quoteFamily(family$1) {
	return `"${family$1.replace(/\\/g, "\\\\").replace(/"/g, "\\\"")}"`;
}
function canonicalizeFontSource(source) {
	const match = /^\s*url\(\s*([\s\S]*?)\s*\)\s*$/i.exec(source);
	if (!match) return source;
	let inner = match[1].trim();
	if (inner.startsWith("\"") && inner.endsWith("\"") || inner.startsWith("'") && inner.endsWith("'")) inner = inner.slice(1, -1);
	return `url(${JSON.stringify(inner)})`;
}
function normalizeFamilyKey(family$1) {
	return family$1.trim().replace(/^["']|["']$/g, "").toLowerCase();
}
function normalizeWeight(weight) {
	if (weight === void 0) return "400";
	const w = String(weight).trim().toLowerCase();
	if (w === "bold" || w === "bolder") return "700";
	const n = Number(w);
	return Number.isFinite(n) && n >= 600 ? "700" : "400";
}
function normalizeStyle(style) {
	if (!style) return "normal";
	const s = style.trim().toLowerCase();
	return s.startsWith("italic") || s.startsWith("oblique") ? "italic" : "normal";
}
function faceKeyOf(family$1, weight, style) {
	return `${normalizeFamilyKey(family$1)}|${weight}|${style}`;
}
function faceProbe(family$1, weight, style, size) {
	return `${style === "italic" ? "italic " : ""}${weight} ${size} ${quoteFamily(family$1)}`;
}
var FontRegistry = class {
	#fontSet;
	#FontFaceCtor;
	#probeSize;
	#scheduleTimeout;
	#cancelTimeout;
	#managed = /* @__PURE__ */ new Map();
	#facesByKey = /* @__PURE__ */ new Map();
	#status = /* @__PURE__ */ new Map();
	#sources = /* @__PURE__ */ new Map();
	#warnedFailures = /* @__PURE__ */ new Set();
	#inflight = /* @__PURE__ */ new Map();
	#faceStatus = /* @__PURE__ */ new Map();
	#faceInflight = /* @__PURE__ */ new Map();
	#faceSources = /* @__PURE__ */ new Map();
	#facesByFamily = /* @__PURE__ */ new Map();
	#providerFaceKeys = /* @__PURE__ */ new Set();
	#warnedFaceFailures = /* @__PURE__ */ new Set();
	constructor(options = {}) {
		this.#fontSet = options.fontSet ?? null;
		this.#FontFaceCtor = options.FontFaceCtor ?? null;
		this.#probeSize = options.probeSize ?? DEFAULT_PROBE_SIZE;
		this.#scheduleTimeout = options.scheduleTimeout ?? ((cb, ms) => globalThis.setTimeout(cb, ms));
		this.#cancelTimeout = options.cancelTimeout ?? ((handle) => globalThis.clearTimeout(handle));
	}
	register(descriptor) {
		const { family: family$1, source, descriptors: descriptors$1 } = descriptor;
		const identitySource = typeof source === "string" ? canonicalizeFontSource(source) : source;
		const weight = normalizeWeight(descriptors$1?.weight);
		const style = normalizeStyle(descriptors$1?.style);
		const key = faceKeyOf(family$1, weight, style);
		if (typeof identitySource === "string") {
			const existingSource = this.#faceSources.get(key);
			if (existingSource === identitySource) return {
				family: family$1,
				status: this.getStatus(family$1),
				changed: false
			};
			if (existingSource !== void 0) throw new Error(`[superdoc] font face "${key}" is already registered from a different source ("${existingSource}"); a registered face's source cannot be replaced`);
		}
		if (this.#FontFaceCtor && this.#fontSet) {
			const face = new this.#FontFaceCtor(family$1, source, {
				...descriptors$1,
				weight,
				style
			});
			this.#fontSet.add(face);
			this.#addManagedFace(family$1, key, face);
		}
		if (typeof source === "string") {
			const list$1 = this.#sources.get(family$1) ?? [];
			if (!list$1.includes(source)) list$1.push(source);
			this.#sources.set(family$1, list$1);
		}
		if (!this.#status.has(family$1)) this.#status.set(family$1, "unloaded");
		this.#providerFaceKeys.add(key);
		this.#trackFace(family$1, key);
		if (!this.#faceStatus.has(key)) this.#faceStatus.set(key, "unloaded");
		if (typeof identitySource === "string" && !this.#faceSources.has(key)) this.#faceSources.set(key, identitySource);
		return {
			family: family$1,
			status: this.getStatus(family$1),
			changed: true
		};
	}
	#trackFace(family$1, key) {
		const fam = normalizeFamilyKey(family$1);
		const set = this.#facesByFamily.get(fam) ?? /* @__PURE__ */ new Set();
		set.add(key);
		this.#facesByFamily.set(fam, set);
	}
	isManaged(family$1) {
		return this.#managed.has(family$1);
	}
	registerOwnedFace(descriptor) {
		const { family: family$1, source, weight, style } = descriptor;
		if (!this.#FontFaceCtor || !this.#fontSet) return null;
		const key = faceKeyOf(family$1, weight, style);
		const face = new this.#FontFaceCtor(family$1, source, {
			weight,
			style
		});
		this.#fontSet.add(face);
		this.#addManagedFace(family$1, key, face);
		this.#providerFaceKeys.add(key);
		if (!this.#status.has(family$1)) this.#status.set(family$1, "unloaded");
		this.#trackFace(family$1, key);
		if (!this.#faceStatus.has(key)) this.#faceStatus.set(key, "unloaded");
		let released = false;
		return () => {
			if (released) return false;
			released = true;
			return this.#removeManagedFace(family$1, key, face);
		};
	}
	#addManagedFace(family$1, key, face) {
		this.#managed.set(family$1, face);
		let set = this.#facesByKey.get(key);
		if (!set) {
			set = /* @__PURE__ */ new Set();
			this.#facesByKey.set(key, set);
		}
		set.add(face);
	}
	#removeManagedFace(family$1, key, face) {
		const set = this.#facesByKey.get(key);
		if (!set || !set.delete(face)) return false;
		if (typeof this.#fontSet?.delete === "function") this.#fontSet.delete(face);
		if (set.size > 0) return true;
		this.#facesByKey.delete(key);
		this.#providerFaceKeys.delete(key);
		this.#faceStatus.delete(key);
		this.#faceSources.delete(key);
		const fam = normalizeFamilyKey(family$1);
		const keys$1 = this.#facesByFamily.get(fam);
		if (keys$1) {
			keys$1.delete(key);
			if (keys$1.size === 0) {
				this.#facesByFamily.delete(fam);
				this.#managed.delete(family$1);
				this.#status.delete(family$1);
				this.#sources.delete(family$1);
			}
		}
		return true;
	}
	getStatus(family$1) {
		const statuses = [];
		const faceKeys = this.#facesByFamily.get(normalizeFamilyKey(family$1));
		if (faceKeys) for (const k of faceKeys) statuses.push(this.#faceStatus.get(k) ?? "unloaded");
		const legacy = this.#status.get(family$1);
		if (legacy) statuses.push(legacy);
		if (statuses.length === 0) return "unloaded";
		for (const s of [
			"failed",
			"timed_out",
			"fallback_used",
			"loaded",
			"loading",
			"unloaded"
		]) if (statuses.includes(s)) return s;
		return "unloaded";
	}
	hasFace(family$1, weight, style) {
		const key = faceKeyOf(family$1, weight, style);
		return this.#providerFaceKeys.has(key) && this.#faceStatus.get(key) !== "failed";
	}
	isAvailable(family$1) {
		if (!this.#fontSet) return false;
		try {
			return this.#fontSet.check(`${this.#probeSize} ${quoteFamily(family$1)}`);
		} catch {
			return false;
		}
	}
	awaitFace(family$1, timeoutMs = DEFAULT_FONT_LOAD_TIMEOUT_MS) {
		if (this.#status.get(family$1) === "loaded") return Promise.resolve({
			family: family$1,
			status: "loaded"
		});
		const existing = this.#inflight.get(family$1);
		if (existing) return existing;
		const probe = this.#loadOne(family$1, timeoutMs).finally(() => {
			this.#inflight.delete(family$1);
		});
		this.#inflight.set(family$1, probe);
		return probe;
	}
	async awaitFaces(families, options = {}) {
		const unique = [...new Set(families)];
		const timeoutMs = options.timeoutMs ?? 3e3;
		return Promise.all(unique.map((family$1) => this.awaitFace(family$1, timeoutMs)));
	}
	getRequiredFaces(families, timeoutMs = DEFAULT_FONT_LOAD_TIMEOUT_MS) {
		return [...new Set(families)].map((family$1) => ({
			family: family$1,
			status: this.getStatus(family$1),
			ready: this.awaitFace(family$1, timeoutMs)
		}));
	}
	getStates() {
		return [...this.#status.entries()].map(([family$1, status]) => ({
			family: family$1,
			status
		}));
	}
	getFaceStatus(request) {
		return this.#faceStatus.get(faceKeyOf(request.family, request.weight, request.style)) ?? "unloaded";
	}
	awaitFaceRequest(request, timeoutMs = DEFAULT_FONT_LOAD_TIMEOUT_MS) {
		const key = faceKeyOf(request.family, request.weight, request.style);
		if (this.#faceStatus.get(key) === "loaded") return Promise.resolve({
			request,
			status: "loaded"
		});
		const existing = this.#faceInflight.get(key);
		if (existing) return existing;
		const probe = this.#loadOneFace(request, key, timeoutMs).finally(() => {
			this.#faceInflight.delete(key);
		});
		this.#faceInflight.set(key, probe);
		return probe;
	}
	async awaitFaceRequests(requests, options = {}) {
		const timeoutMs = options.timeoutMs ?? 3e3;
		const seen = /* @__PURE__ */ new Set();
		const unique = [];
		for (const r of requests) {
			const key = faceKeyOf(r.family, r.weight, r.style);
			if (seen.has(key)) continue;
			seen.add(key);
			unique.push(r);
		}
		return Promise.all(unique.map((r) => this.awaitFaceRequest(r, timeoutMs)));
	}
	async #loadOneFace(request, key, timeoutMs) {
		this.#trackFace(request.family, key);
		const fontSet = this.#fontSet;
		if (!fontSet) {
			this.#faceStatus.set(key, "fallback_used");
			return {
				request,
				status: "fallback_used"
			};
		}
		this.#faceStatus.set(key, "loading");
		const probe = faceProbe(request.family, request.weight, request.style, this.#probeSize);
		const TIMEOUT = Symbol("timeout");
		let handle;
		const timeout = new Promise((resolve) => {
			handle = this.#scheduleTimeout(() => resolve(TIMEOUT), timeoutMs);
		});
		try {
			const settled = await Promise.race([fontSet.load(probe), timeout]);
			if (settled === TIMEOUT) {
				this.#faceStatus.set(key, "timed_out");
				return {
					request,
					status: "timed_out"
				};
			}
			const status = settled.length > 0 ? "loaded" : "fallback_used";
			this.#faceStatus.set(key, status);
			return {
				request,
				status
			};
		} catch {
			this.#faceStatus.set(key, "failed");
			this.#warnFaceFailureOnce(request, key);
			return {
				request,
				status: "failed"
			};
		} finally {
			this.#cancelTimeout(handle);
		}
	}
	#warnFaceFailureOnce(request, key) {
		if (this.#warnedFaceFailures.has(key)) return;
		this.#warnedFaceFailures.add(key);
		const src = this.#faceSources.get(key);
		const detail = src ? ` from ${src}` : "";
		console.warn(`[superdoc] font face failed to load: "${request.family}" ${request.weight} ${request.style}${detail}. Check fonts.assetBaseUrl / fonts.resolveAssetUrl so the bundled .woff2 are served.`);
	}
	async #loadOne(family$1, timeoutMs) {
		const fontSet = this.#fontSet;
		if (!fontSet) {
			this.#status.set(family$1, "fallback_used");
			return {
				family: family$1,
				status: "fallback_used"
			};
		}
		this.#status.set(family$1, "loading");
		const probe = `${this.#probeSize} ${quoteFamily(family$1)}`;
		const TIMEOUT = Symbol("timeout");
		let handle;
		const timeout = new Promise((resolve) => {
			handle = this.#scheduleTimeout(() => resolve(TIMEOUT), timeoutMs);
		});
		try {
			const settled = await Promise.race([fontSet.load(probe), timeout]);
			if (settled === TIMEOUT) {
				this.#status.set(family$1, "timed_out");
				return {
					family: family$1,
					status: "timed_out"
				};
			}
			const status = settled.length > 0 ? "loaded" : "fallback_used";
			this.#status.set(family$1, status);
			return {
				family: family$1,
				status
			};
		} catch {
			this.#status.set(family$1, "failed");
			this.#warnLoadFailureOnce(family$1);
			return {
				family: family$1,
				status: "failed"
			};
		} finally {
			this.#cancelTimeout(handle);
		}
	}
	#warnLoadFailureOnce(family$1) {
		if (this.#warnedFailures.has(family$1)) return;
		this.#warnedFailures.add(family$1);
		const sources = this.#sources.get(family$1);
		const detail = sources && sources.length ? ` from ${sources.join(", ")}` : "";
		console.warn(`[superdoc] font asset failed to load for "${family$1}"${detail}. Check fonts.assetBaseUrl / fonts.resolveAssetUrl so the bundled .woff2 are served.`);
	}
};
var registriesByFontSet = /* @__PURE__ */ new WeakMap();
var domlessRegistry = null;
function getFontRegistryFor(fontSet, FontFaceCtor) {
	if (!fontSet) {
		if (!domlessRegistry) domlessRegistry = new FontRegistry({});
		return domlessRegistry;
	}
	let registry = registriesByFontSet.get(fontSet);
	if (!registry) {
		registry = new FontRegistry({
			fontSet,
			FontFaceCtor
		});
		registriesByFontSet.set(fontSet, registry);
	}
	return registry;
}
var BUNDLED_FAMILIES = new Set(BUNDLED_MANIFEST.map((f) => f.family));
var SUPPORTED_ALIAS_FAMILIES = new Set([
	"Arial MT",
	"Courier",
	"Times"
]);
var ADVERTISED_BUILT_IN_TOOLBAR_FAMILIES = new Set([
	"Arial Black",
	"Arial Narrow",
	"Baskerville Old Face",
	"Bookman Old Style",
	"Brush Script MT",
	"Century",
	"Century Gothic",
	"Cooper Black",
	"Comic Sans MS",
	"Garamond",
	"Georgia",
	"Gill Sans MT Condensed",
	"Lucida Console",
	"Segoe UI",
	"Tahoma",
	"Trebuchet MS",
	"Verdana"
]);
function classifyOffering(logicalFamily, policyAction, verdict, physicalFamily, bundled) {
	if (policyAction === "preserve_only") return "preserve_only";
	if (policyAction === "customer_supplied" || physicalFamily == null) return "customer_supplied";
	if (bundled && SUPPORTED_ALIAS_FAMILIES.has(logicalFamily)) return "supported_alias";
	if (policyAction === "category_fallback") return "category_fallback";
	if (!bundled) return "requires_asset";
	return verdict === "metric_safe" ? "default" : "qualified";
}
function deriveOfferings() {
	const offerings = SUBSTITUTION_EVIDENCE.map((row) => {
		const bundled = row.physicalFamily != null && BUNDLED_FAMILIES.has(row.physicalFamily);
		return {
			logicalFamily: row.logicalFamily,
			physicalFamily: row.physicalFamily,
			generic: row.generic,
			offering: classifyOffering(row.logicalFamily, row.policyAction, row.verdict, row.physicalFamily, bundled),
			bundled,
			verdict: row.verdict,
			evidenceId: row.evidenceId
		};
	});
	return Object.freeze(offerings);
}
const FONT_OFFERINGS = deriveOfferings();
function compareLogicalFamily(a, b) {
	return a.logicalFamily.localeCompare(b.logicalFamily, "en", { sensitivity: "base" });
}
function getBuiltInToolbarFontOfferings() {
	return FONT_OFFERINGS.filter((o) => o.offering === "default" || o.bundled && ADVERTISED_BUILT_IN_TOOLBAR_FAMILIES.has(o.logicalFamily) && (o.offering === "qualified" || o.offering === "category_fallback")).sort(compareLogicalFamily);
}
function fontOfferingStack(offering) {
	return `${offering.logicalFamily}, ${offering.generic}`;
}
function fontOfferingRenderStack(offering) {
	return offering.physicalFamily ? `${offering.physicalFamily}, ${offering.generic}` : fontOfferingStack(offering);
}
function getDefaultFontFamilyOptions() {
	return getBuiltInToolbarFontOfferings().map((offering) => ({
		label: offering.logicalFamily,
		value: fontOfferingStack(offering)
	}));
}
function normalizeKey(family$1) {
	return family$1.trim().replace(/^["']|["']$/g, "").toLowerCase();
}
function isRegularFace(rec) {
	return rec.face?.weight === "400" && rec.face?.style === "normal";
}
function buildDocumentFontOptions(usedFaces, registry, resolver$1) {
	const faceRecords = buildFaceReport(usedFaces, registry, resolver$1);
	const agg = /* @__PURE__ */ new Map();
	for (const rec of faceRecords) {
		const key = normalizeKey(rec.logicalFamily);
		const existing = agg.get(key);
		if (!existing) {
			agg.set(key, rec);
			continue;
		}
		if (isRegularFace(rec) && !isRegularFace(existing)) agg.set(key, rec);
	}
	const options = [];
	for (const rep of agg.values()) options.push({
		logicalFamily: rep.logicalFamily,
		previewFamily: rep.physicalFamily
	});
	return options;
}
function compareByLabel(a, b) {
	return a.label.localeCompare(b.label, "en", { sensitivity: "base" });
}
function buildFontFamilyOptions(documentOptions) {
	const seen = /* @__PURE__ */ new Set();
	const options = [];
	for (const offering of getBuiltInToolbarFontOfferings()) {
		const key = normalizeKey(offering.logicalFamily);
		if (seen.has(key)) continue;
		seen.add(key);
		options.push({
			label: offering.logicalFamily,
			value: offering.logicalFamily,
			previewFamily: offering.physicalFamily || offering.logicalFamily
		});
	}
	for (const option of documentOptions) {
		const key = normalizeKey(option.logicalFamily);
		if (seen.has(key)) continue;
		seen.add(key);
		options.push({
			label: option.logicalFamily,
			value: option.logicalFamily,
			previewFamily: option.previewFamily || option.logicalFamily
		});
	}
	return options.sort(compareByLabel);
}
const prepareCommentParaIds = (comment) => {
	return {
		...comment,
		commentParaId: generateDocxRandomId()
	};
};
var getCommentIds = (comment) => {
	if (!comment) return [];
	return [
		comment.commentId,
		comment.importedId,
		comment.internalId
	].filter((id) => id != null).map((id) => String(id));
};
var buildCommentLookup = (comments = []) => {
	const byId = /* @__PURE__ */ new Map();
	for (const comment of comments) getCommentIds(comment).forEach((id) => byId.set(id, comment));
	return byId;
};
var findCommentById = (comments = [], id) => {
	if (id == null) return null;
	return buildCommentLookup(comments).get(String(id)) || null;
};
const isCommentResolvedInThread = (comment, allComments = []) => {
	const isDone = (c$1) => Boolean(c$1?.resolvedTime || c$1?.isDone);
	if (isDone(comment)) return true;
	const byId = buildCommentLookup(allComments);
	const seen = /* @__PURE__ */ new Set();
	let current = comment;
	while (current) {
		const parentId = current.threadingParentCommentId || current.parentCommentId;
		const parentKey = parentId != null ? String(parentId) : null;
		if (parentKey == null || seen.has(parentKey)) break;
		seen.add(parentKey);
		const parent = byId.get(parentKey);
		if (!parent) break;
		if (isDone(parent)) return true;
		current = parent;
	}
	return false;
};
const getCommentDefinition = (comment, commentId, allComments, editor) => {
	const translatedParagraphs = (Array.isArray(comment.commentJSON) ? comment.commentJSON : comment.commentJSON ? [comment.commentJSON] : []).map((node) => translator.decode({
		editor,
		node
	})).filter(Boolean);
	const attributes = {
		"w:id": String(commentId),
		"w:author": comment.creatorName || comment.importedAuthor?.name,
		"w:date": toIsoNoFractional(comment.createdTime),
		"w:initials": getInitials(comment.creatorName),
		"w:done": isCommentResolvedInThread(comment, allComments) ? "1" : "0",
		"w15:paraId": comment.commentParaId,
		"custom:internalId": comment.commentId || comment.internalId,
		"custom:trackedChange": comment.trackedChange,
		"custom:trackedChangeText": comment.trackedChangeText || null,
		"custom:trackedChangeType": comment.trackedChangeType,
		"custom:trackedChangeDisplayType": comment.trackedChangeDisplayType || null,
		"custom:trackedDeletedText": comment.deletedText || null,
		"custom:email": comment.creatorEmail || comment.importedAuthor?.email
	};
	if (comment?.parentCommentId) {
		const parentComment = findCommentById(allComments, comment.parentCommentId);
		if (parentComment && !parentComment.trackedChange) attributes["w15:paraIdParent"] = parentComment.commentParaId;
	}
	return {
		type: "element",
		name: "w:comment",
		attributes,
		elements: translatedParagraphs
	};
};
const getInitials = (name) => {
	if (!name) return null;
	return name.replace("(imported)", "").trim().split(" ").map((word) => word[0]).join("");
};
const toIsoNoFractional = (unixMillis) => {
	return new Date(unixMillis || Date.now()).toISOString().replace(/\.\d{3}Z$/, "Z");
};
const updateCommentsXml = (commentDefs = [], commentsXml) => {
	const newCommentsXml = carbonCopy(commentsXml);
	commentDefs.forEach((commentDef) => {
		const paragraphs = commentDef.elements || [];
		if (!paragraphs.length) return;
		const firstParagraph = paragraphs.find((node) => node?.name === "w:p") ?? paragraphs[0];
		const lastParagraph = paragraphs.slice().reverse().find((node) => node?.name === "w:p") ?? paragraphs[paragraphs.length - 1];
		if (!firstParagraph?.attributes) firstParagraph.attributes = {};
		if (!lastParagraph?.attributes) lastParagraph.attributes = {};
		const elements = firstParagraph.elements || [];
		firstParagraph.elements = elements;
		elements.unshift(COMMENT_REF);
		const paraId = commentDef.attributes["w15:paraId"];
		lastParagraph.attributes["w14:paraId"] = paraId;
		commentDef.attributes = {
			"w:id": commentDef.attributes["w:id"],
			"w:author": commentDef.attributes["w:author"],
			"w:date": commentDef.attributes["w:date"],
			"w:initials": commentDef.attributes["w:initials"],
			"custom:internalId": commentDef.attributes["custom:internalId"],
			"custom:trackedChange": commentDef.attributes["custom:trackedChange"],
			"custom:trackedChangeText": commentDef.attributes["custom:trackedChangeText"],
			"custom:trackedChangeType": commentDef.attributes["custom:trackedChangeType"],
			"custom:trackedChangeDisplayType": commentDef.attributes["custom:trackedChangeDisplayType"],
			"custom:trackedDeletedText": commentDef.attributes["custom:trackedDeletedText"],
			"custom:email": commentDef.attributes["custom:email"],
			"xmlns:custom": "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
		};
	});
	newCommentsXml.elements[0].elements = commentDefs;
	return newCommentsXml;
};
const determineExportStrategy = (comments) => {
	if (!comments || comments.length === 0) return "word";
	const origins = new Set(comments.map((c$1) => c$1.origin || "word"));
	if (origins.size === 1) return origins.values().next().value === "google-docs" ? "google-docs" : "word";
	return "word";
};
var resolveThreadingStyle = (comment, threadingProfile) => {
	if (comment?.threadingStyleOverride) return comment.threadingStyleOverride;
	if (threadingProfile?.defaultStyle) return threadingProfile.defaultStyle;
	return comment?.originalXmlStructure?.hasCommentsExtended ? "commentsExtended" : "range-based";
};
const updateCommentsExtendedXml = (comments = [], commentsExtendedXml, threadingProfile = null) => {
	if (!commentsExtendedXml) return null;
	const exportStrategy = typeof threadingProfile === "string" ? threadingProfile : "word";
	const profile = typeof threadingProfile === "string" ? null : threadingProfile;
	const hasThreadedComments = comments.some((comment) => comment.threadingParentCommentId || comment.parentCommentId);
	const hasResolvedComments = comments.some((comment) => comment.resolvedTime || comment.isDone);
	const shouldGenerateCommentsExtended = profile ? profile.defaultStyle === "commentsExtended" || profile.mixed || comments.some((comment) => resolveThreadingStyle(comment, profile) === "commentsExtended") : exportStrategy !== "google-docs";
	const shouldIncludeForThreads = hasThreadedComments;
	if (!shouldGenerateCommentsExtended && !shouldIncludeForThreads && !hasResolvedComments) return null;
	const xmlCopy = carbonCopy(commentsExtendedXml);
	const commentsEx = comments.map((comment) => {
		const isResolved = isCommentResolvedInThread(comment, comments);
		const attributes = {
			"w15:paraId": comment.commentParaId,
			"w15:done": isResolved ? "1" : "0"
		};
		const parentId = comment.threadingParentCommentId || comment.parentCommentId;
		const threadingStyle = resolveThreadingStyle(comment, profile);
		if (parentId && (threadingStyle === "commentsExtended" || shouldIncludeForThreads)) {
			const parentComment = findCommentById(comments, parentId);
			const allowTrackedParent = profile?.defaultStyle === "commentsExtended";
			if (parentComment && (allowTrackedParent || !parentComment.trackedChange)) attributes["w15:paraIdParent"] = parentComment.commentParaId;
		}
		return {
			type: "element",
			name: "w15:commentEx",
			attributes
		};
	});
	xmlCopy.elements[0].elements = commentsEx;
	return xmlCopy;
};
const updateCommentsIdsAndExtensible = (comments = [], commentsIds, extensible) => {
	const documentIdsUpdated = commentsIds ? carbonCopy(commentsIds) : null;
	const extensibleUpdated = extensible ? carbonCopy(extensible) : null;
	if (documentIdsUpdated) documentIdsUpdated.elements[0].elements = [];
	if (extensibleUpdated) extensibleUpdated.elements[0].elements = [];
	comments.forEach((comment) => {
		const newDurableId = generateDocxRandomId();
		if (documentIdsUpdated) documentIdsUpdated.elements[0].elements.push({
			type: "element",
			name: "w16cid:commentId",
			attributes: {
				"w16cid:paraId": comment.commentParaId,
				"w16cid:durableId": newDurableId
			}
		});
		if (extensibleUpdated) extensibleUpdated.elements[0].elements.push({
			type: "element",
			name: "w16cex:commentExtensible",
			attributes: {
				"w16cex:durableId": newDurableId,
				"w16cex:dateUtc": toIsoNoFractional(comment.createdTime)
			}
		});
	});
	return {
		documentIdsUpdated,
		extensibleUpdated
	};
};
const generateConvertedXmlWithCommentFiles = (convertedXml, fileSet = null) => {
	const newXml = carbonCopy(convertedXml);
	newXml["word/comments.xml"] = COMMENTS_XML_DEFINITIONS.COMMENTS_XML_DEF;
	const includeExtensible = fileSet ? fileSet.hasCommentsExtensible : true;
	const includeIds = fileSet ? fileSet.hasCommentsIds : true;
	newXml["word/commentsExtended.xml"] = COMMENTS_XML_DEFINITIONS.COMMENTS_EXTENDED_XML_DEF;
	if (includeExtensible) newXml["word/commentsExtensible.xml"] = COMMENTS_XML_DEFINITIONS.COMMENTS_EXTENSIBLE_XML_DEF;
	if (includeIds) newXml["word/commentsIds.xml"] = COMMENTS_XML_DEFINITIONS.COMMENTS_IDS_XML_DEF;
	return newXml;
};
const removeCommentsFilesFromConvertedXml = (convertedXml) => {
	const updatedXml = carbonCopy(convertedXml);
	delete updatedXml["word/comments.xml"];
	delete updatedXml["word/commentsExtended.xml"];
	delete updatedXml["word/commentsExtensible.xml"];
	delete updatedXml["word/commentsIds.xml"];
	return updatedXml;
};
const generateRelationship = (target) => {
	return { ...COMMENTS_XML_DEFINITIONS.DOCUMENT_RELS_XML_DEF.elements[0].elements.find((rel) => rel.attributes.Target === target) };
};
var ALL_COMMENT_TARGETS = COMMENT_FILE_BASENAMES;
const prepareCommentsXmlFilesForExport = ({ convertedXml, defs, commentsWithParaIds, exportType, threadingProfile }) => {
	const relationships = [];
	const warnings = [];
	if (exportType === "clean") return {
		documentXml: removeCommentsFilesFromConvertedXml(convertedXml),
		relationships,
		removedTargets: ALL_COMMENT_TARGETS,
		warnings
	};
	const hasComments = commentsWithParaIds && commentsWithParaIds.length > 0;
	if (!hasComments) {
		const documentXml = removeCommentsFilesFromConvertedXml(convertedXml);
		const removedTargets = [...ALL_COMMENT_TARGETS];
		if (threadingProfile?.fileSet) warnings.push("All comments removed — cleaning up imported comment support files");
		return {
			documentXml,
			relationships,
			removedTargets,
			warnings
		};
	}
	const emittedTargets = /* @__PURE__ */ new Set();
	const exportStrategy = determineExportStrategy(commentsWithParaIds);
	const updatedXml = generateConvertedXmlWithCommentFiles(convertedXml, threadingProfile?.fileSet);
	updatedXml["word/comments.xml"] = updateCommentsXml(defs, updatedXml["word/comments.xml"]);
	relationships.push(generateRelationship("comments.xml"));
	emittedTargets.add("comments.xml");
	const effectiveThreadingProfile = threadingProfile?.defaultStyle === "range-based" && threadingProfile?.fileSet?.hasCommentsExtended === false ? "word" : threadingProfile || exportStrategy;
	const commentsExtendedXml = updateCommentsExtendedXml(commentsWithParaIds, updatedXml["word/commentsExtended.xml"], effectiveThreadingProfile);
	if (commentsExtendedXml !== null) {
		updatedXml["word/commentsExtended.xml"] = commentsExtendedXml;
		relationships.push(generateRelationship("commentsExtended.xml"));
		emittedTargets.add("commentsExtended.xml");
	} else {
		delete updatedXml["word/commentsExtended.xml"];
		if (threadingProfile?.fileSet?.hasCommentsExtended) warnings.push("commentsExtended.xml removed — export strategy does not require it");
	}
	const hasIds = !!updatedXml["word/commentsIds.xml"];
	const hasExtensible = !!updatedXml["word/commentsExtensible.xml"];
	if (hasIds !== hasExtensible) {
		const present = hasIds ? "commentsIds.xml" : "commentsExtensible.xml";
		const absent = hasIds ? "commentsExtensible.xml" : "commentsIds.xml";
		warnings.push(`Partial comment file-set: ${present} present without ${absent}`);
	}
	if (hasIds || hasExtensible) {
		const { documentIdsUpdated, extensibleUpdated } = updateCommentsIdsAndExtensible(commentsWithParaIds, hasIds ? updatedXml["word/commentsIds.xml"] : null, hasExtensible ? updatedXml["word/commentsExtensible.xml"] : null);
		if (documentIdsUpdated) {
			updatedXml["word/commentsIds.xml"] = documentIdsUpdated;
			relationships.push(generateRelationship("commentsIds.xml"));
			emittedTargets.add("commentsIds.xml");
		}
		if (extensibleUpdated) {
			updatedXml["word/commentsExtensible.xml"] = extensibleUpdated;
			relationships.push(generateRelationship("commentsExtensible.xml"));
			emittedTargets.add("commentsExtensible.xml");
		}
	}
	if (!threadingProfile && hasComments) warnings.push("Comments exist but no threading profile detected — using default export shape");
	return {
		relationships,
		documentXml: updatedXml,
		removedTargets: ALL_COMMENT_TARGETS.filter((target) => !emittedTargets.has(target)),
		warnings
	};
};
var REL_ID_NUMERIC_PATTERN = /rId|mi/g;
const getLargestRelationshipId = (relationships = []) => {
	const numericIds = relationships.map((rel) => Number(String(rel?.attributes?.Id ?? "").replace(REL_ID_NUMERIC_PATTERN, ""))).filter((value) => Number.isFinite(value));
	return numericIds.length ? Math.max(...numericIds) : 0;
};
const mergeRelationshipElements = (existingRelationships = [], newRelationships = []) => {
	if (!newRelationships?.length) return existingRelationships;
	let largestId = getLargestRelationshipId(existingRelationships);
	const seenIds = new Set(existingRelationships.map((rel) => rel?.attributes?.Id).filter(Boolean));
	for (const rel of newRelationships) {
		const id = rel?.attributes?.Id;
		if (!id || seenIds.has(id)) continue;
		const numeric = Number(String(id).replace(REL_ID_NUMERIC_PATTERN, ""));
		if (Number.isFinite(numeric) && numeric > largestId) largestId = numeric;
	}
	const additions = [];
	newRelationships.forEach((rel) => {
		if (!rel?.attributes) return;
		const attributes = rel.attributes;
		const currentId = attributes.Id || "";
		const existingTarget = existingRelationships.find((el) => el.attributes.Target === attributes.Target);
		const isNewHyperlink = attributes.Type === "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" && currentId.length > 6;
		const isNewHeadFoot = (attributes.Type === "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header" || attributes.Type === "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer") && currentId.length > 6;
		const hasSeenId = currentId && seenIds.has(currentId);
		if (!isNewHyperlink && !isNewHeadFoot && existingTarget) return;
		if (!currentId || hasSeenId) {
			let candidate = Math.max(largestId, 1);
			while (seenIds.has(`rId${candidate}`)) candidate += 1;
			attributes.Id = `rId${candidate}`;
			largestId = candidate;
		} else {
			const numeric = Number(String(currentId).replace(REL_ID_NUMERIC_PATTERN, ""));
			if (Number.isFinite(numeric) && numeric > largestId) largestId = numeric;
		}
		seenIds.add(attributes.Id);
		additions.push(rel);
	});
	return additions.length ? [...existingRelationships, ...additions] : existingRelationships;
};
var RELS_XMLNS$1 = "http://schemas.openxmlformats.org/package/2006/relationships";
var FOOTNOTES_RELS_PATH = "word/_rels/footnotes.xml.rels";
var ENDNOTES_RELS_PATH = "word/_rels/endnotes.xml.rels";
var FOOTNOTES_CONFIG$1 = {
	notesPath: "word/footnotes.xml",
	relsPath: FOOTNOTES_RELS_PATH,
	rootName: "w:footnotes",
	noteName: "w:footnote",
	refName: "w:footnoteRef",
	refStyle: "FootnoteReference",
	relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes",
	relationshipTarget: "footnotes.xml",
	applySettingsSideEffects: true
};
var ENDNOTES_CONFIG$1 = {
	notesPath: "word/endnotes.xml",
	relsPath: ENDNOTES_RELS_PATH,
	rootName: "w:endnotes",
	noteName: "w:endnote",
	refName: "w:endnoteRef",
	refStyle: "EndnoteReference",
	relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes",
	relationshipTarget: "endnotes.xml",
	applySettingsSideEffects: false
};
var paragraphHasFootnoteRef = (node) => {
	if (!node) return false;
	if (node.name === "w:footnoteRef" || node.name === "w:endnoteRef") return true;
	return (Array.isArray(node.elements) ? node.elements : []).some((child) => paragraphHasFootnoteRef(child));
};
var insertFootnoteRefIntoParagraph = (paragraph, config$43) => {
	if (!paragraph || paragraph.name !== "w:p") return;
	if (!Array.isArray(paragraph.elements)) paragraph.elements = [];
	if (paragraphHasFootnoteRef(paragraph)) return;
	const footnoteRef = {
		type: "element",
		name: config$43.refName,
		elements: []
	};
	const footnoteRefRun = {
		type: "element",
		name: "w:r",
		elements: [{
			type: "element",
			name: "w:rPr",
			elements: [{
				type: "element",
				name: "w:rStyle",
				attributes: { "w:val": config$43.refStyle }
			}, {
				type: "element",
				name: "w:vertAlign",
				attributes: { "w:val": "superscript" }
			}]
		}, footnoteRef]
	};
	const pPrIndex = paragraph.elements.findIndex((el) => el?.name === "w:pPr");
	const insertAt = pPrIndex >= 0 ? pPrIndex + 1 : 0;
	paragraph.elements.splice(insertAt, 0, footnoteRefRun);
};
var ensureFootnoteRefMarker = (elements, config$43) => {
	if (!Array.isArray(elements)) return;
	const firstParagraphIndex = elements.findIndex((el) => el?.name === "w:p");
	if (firstParagraphIndex >= 0) {
		insertFootnoteRefIntoParagraph(elements[firstParagraphIndex], config$43);
		return;
	}
	const paragraph = {
		type: "element",
		name: "w:p",
		elements: []
	};
	insertFootnoteRefIntoParagraph(paragraph, config$43);
	elements.unshift(paragraph);
};
var translateFootnoteContent = (content$2, exportContext) => {
	if (!Array.isArray(content$2) || content$2.length === 0) return [];
	const translated = [];
	content$2.forEach((node) => {
		if (!node) return;
		const result = exportSchemaToJson({
			...exportContext,
			node
		});
		if (Array.isArray(result)) {
			result.filter(Boolean).forEach((entry) => translated.push(entry));
			return;
		}
		if (result) translated.push(result);
	});
	return translated;
};
const createFootnoteElement = (footnote, exportContext, config$43 = FOOTNOTES_CONFIG$1) => {
	if (!footnote) return null;
	const { id, content: content$2, type, originalXml } = footnote;
	if ((type === "separator" || type === "continuationSeparator") && originalXml) return carbonCopy(originalXml);
	const attributes = { "w:id": String(id) };
	if (type) attributes["w:type"] = type;
	const translatedContent = translateFootnoteContent(content$2, exportContext);
	if (originalXml ? paragraphHasFootnoteRef(originalXml) : true) ensureFootnoteRefMarker(translatedContent, config$43);
	const base$1 = originalXml ? carbonCopy(originalXml) : {
		type: "element",
		name: config$43.noteName,
		attributes: {},
		elements: []
	};
	base$1.attributes = {
		...base$1.attributes || {},
		...attributes
	};
	base$1.elements = translatedContent;
	return base$1;
};
var applyFootnotePropertiesToSettings = (converter, convertedXml) => {
	const props = converter?.footnoteProperties;
	if (!props || props.source !== "settings" || !props.originalXml) return convertedXml;
	const settingsXml = convertedXml["word/settings.xml"];
	if (!settingsXml?.elements?.[0]) return convertedXml;
	const updatedSettings = carbonCopy(settingsXml);
	const updatedRoot = updatedSettings.elements?.[0];
	if (!updatedRoot) return convertedXml;
	const nextElements = (Array.isArray(updatedRoot.elements) ? updatedRoot.elements : []).filter((el) => el?.name !== "w:footnotePr");
	nextElements.push(carbonCopy(props.originalXml));
	updatedRoot.elements = nextElements;
	return {
		...convertedXml,
		"word/settings.xml": updatedSettings
	};
};
var applyViewSettingToSettings = (converter, convertedXml) => {
	const viewSetting = converter?.viewSetting;
	if (!viewSetting?.originalXml) return convertedXml;
	const settingsXml = convertedXml["word/settings.xml"];
	if (!settingsXml?.elements?.[0]) return convertedXml;
	const updatedSettings = carbonCopy(settingsXml);
	const updatedRoot = updatedSettings.elements?.[0];
	if (!updatedRoot) return convertedXml;
	const elements = Array.isArray(updatedRoot.elements) ? updatedRoot.elements : [];
	const idx = elements.findIndex((el) => el?.name === "w:view");
	elements.splice(idx !== -1 ? idx : 0, idx !== -1 ? 1 : 0, carbonCopy(viewSetting.originalXml));
	updatedRoot.elements = elements;
	return {
		...convertedXml,
		"word/settings.xml": updatedSettings
	};
};
var buildFootnotesRelsXml = (converter, convertedXml, relationships, relsPath = FOOTNOTES_RELS_PATH) => {
	if (!relationships.length) return null;
	const existingRels = convertedXml[relsPath];
	const existingRoot = existingRels?.elements?.find((el) => el.name === "Relationships");
	const merged = mergeRelationshipElements(Array.isArray(existingRoot?.elements) ? existingRoot.elements : [], relationships);
	const declaration = existingRels?.declaration ?? converter?.initialJSON?.declaration;
	return {
		...declaration ? { declaration } : {},
		elements: [{
			name: "Relationships",
			attributes: { xmlns: RELS_XMLNS$1 },
			elements: merged
		}]
	};
};
var createNotesXmlDefinition = (config$43) => {
	const base$1 = carbonCopy(FOOTNOTES_XML_DEF);
	if (base$1.elements?.[0]) base$1.elements[0].name = config$43.rootName;
	return base$1;
};
var prepareNotesXmlForExport = ({ notes, editor, converter, convertedXml, config: config$43 }) => {
	let updatedXml = convertedXml;
	if (config$43.applySettingsSideEffects) {
		updatedXml = applyFootnotePropertiesToSettings(converter, updatedXml);
		updatedXml = applyViewSettingToSettings(converter, updatedXml);
	}
	if (!notes || !Array.isArray(notes) || notes.length === 0) return {
		updatedXml,
		relationships: [],
		media: {}
	};
	const footnoteRelationships = [];
	const footnoteMedia = {};
	const exportContext = {
		editor,
		editorSchema: editor?.schema,
		converter,
		relationships: footnoteRelationships,
		media: footnoteMedia,
		currentPartPath: config$43.notesPath
	};
	const footnoteElements = notes.map((fn) => createFootnoteElement(fn, exportContext, config$43)).filter(Boolean);
	if (footnoteElements.length === 0) return {
		updatedXml,
		relationships: [],
		media: footnoteMedia
	};
	let footnotesXml = updatedXml[config$43.notesPath];
	if (!footnotesXml) footnotesXml = createNotesXmlDefinition(config$43);
	else footnotesXml = carbonCopy(footnotesXml);
	if (footnotesXml.elements && footnotesXml.elements[0]) footnotesXml.elements[0].elements = footnoteElements;
	updatedXml = {
		...updatedXml,
		[config$43.notesPath]: footnotesXml
	};
	if (footnoteRelationships.length > 0) {
		const footnotesRelsXml = buildFootnotesRelsXml(converter, updatedXml, footnoteRelationships, config$43.relsPath);
		if (footnotesRelsXml) updatedXml = {
			...updatedXml,
			[config$43.relsPath]: footnotesRelsXml
		};
	}
	const relationships = [{
		type: "element",
		name: "Relationship",
		attributes: {
			Type: config$43.relationshipType,
			Target: config$43.relationshipTarget
		}
	}];
	return {
		updatedXml,
		relationships,
		media: footnoteMedia
	};
};
const prepareFootnotesXmlForExport = ({ footnotes, editor, converter, convertedXml }) => prepareNotesXmlForExport({
	notes: footnotes,
	editor,
	converter,
	convertedXml,
	config: FOOTNOTES_CONFIG$1
});
const prepareEndnotesXmlForExport = ({ endnotes, editor, converter, convertedXml }) => prepareNotesXmlForExport({
	notes: endnotes,
	editor,
	converter,
	convertedXml,
	config: ENDNOTES_CONFIG$1
});
var APP_XML_PATH = "docProps/app.xml";
var EP_NAMESPACE = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
function writeAppStatistics(convertedXml, stats) {
	const elements = ensureElements$1(ensureAppPropertiesRoot(convertedXml));
	upsertSimpleElement(elements, "Words", String(stats.words));
	upsertSimpleElement(elements, "Characters", String(stats.characters));
	upsertSimpleElement(elements, "CharactersWithSpaces", String(stats.charactersWithSpaces));
	if (stats.pages != null) upsertSimpleElement(elements, "Pages", String(stats.pages));
}
function findPropertiesRoot(part) {
	if (part.name === "Properties") return part;
	if (!Array.isArray(part.elements)) return null;
	return part.elements.find((e) => e.name === "Properties") ?? null;
}
function ensureAppPropertiesRoot(convertedXml) {
	let part = convertedXml[APP_XML_PATH];
	if (!part) {
		part = { elements: [{
			type: "element",
			name: "Properties",
			attributes: { xmlns: EP_NAMESPACE },
			elements: []
		}] };
		convertedXml[APP_XML_PATH] = part;
	}
	const root = findPropertiesRoot(part);
	if (root) return root;
	const newRoot = {
		type: "element",
		name: "Properties",
		attributes: { xmlns: EP_NAMESPACE },
		elements: []
	};
	if (!Array.isArray(part.elements)) part.elements = [];
	part.elements.push(newRoot);
	return newRoot;
}
function ensureElements$1(root) {
	if (!Array.isArray(root.elements)) root.elements = [];
	return root.elements;
}
function upsertSimpleElement(elements, tagName, value) {
	const idx = elements.findIndex((e) => e.name === tagName);
	const newEl = {
		type: "element",
		name: tagName,
		elements: [{
			type: "text",
			text: value
		}]
	};
	if (idx !== -1) elements[idx] = newEl;
	else elements.push(newEl);
}
const BODY_STORY_KEY = "body";
function buildStoryKey(locator) {
	switch (locator.storyType) {
		case "body": return BODY_STORY_KEY;
		case "headerFooterSlot": return [
			"hf:slot",
			locator.section.sectionId,
			locator.headerFooterKind,
			locator.variant,
			getStoryHeaderFooterResolution(locator),
			getStoryHeaderFooterOnWrite(locator)
		].join(":");
		case "headerFooterPart": return `hf:part:${locator.refId}`;
		case "footnote": return `fn:${locator.noteId}`;
		case "endnote": return `en:${locator.noteId}`;
	}
}
function parseStoryKey(storyKey) {
	if (storyKey === "body") return {
		kind: "story",
		storyType: "body"
	};
	if (storyKey.startsWith("hf:slot:")) return parseHeaderFooterSlotKey(storyKey);
	if (storyKey.startsWith("hf:part:")) return parseHeaderFooterPartKey(storyKey);
	if (storyKey.startsWith("fn:")) return parseNoteKey(storyKey, "footnote");
	if (storyKey.startsWith("en:")) return parseNoteKey(storyKey, "endnote");
	throw new Error(`Unrecognized story key: "${storyKey}"`);
}
function parseHeaderFooterSlotKey(storyKey) {
	const segments = storyKey.split(":");
	if (segments.length !== 5 && segments.length !== 7) throw new Error(`Malformed header/footer slot story key "${storyKey}". Expected 5 or 7 segments, got ${segments.length}.`);
	const [, , sectionId, headerFooterKind, variant] = segments;
	const resolution = segments[5] ?? "effective";
	const onWrite = segments[6] ?? "materializeIfInherited";
	if (!isNonEmptyString(sectionId)) throw new Error(`Malformed header/footer slot story key "${storyKey}": missing section id.`);
	if (!isEnumMember(headerFooterKind, STORY_HEADER_FOOTER_KINDS)) throw new Error(`Malformed header/footer slot story key "${storyKey}": invalid kind "${headerFooterKind}".`);
	if (!isEnumMember(variant, STORY_HEADER_FOOTER_VARIANTS)) throw new Error(`Malformed header/footer slot story key "${storyKey}": invalid variant "${variant}".`);
	if (!isEnumMember(resolution, STORY_HEADER_FOOTER_RESOLUTIONS)) throw new Error(`Malformed header/footer slot story key "${storyKey}": invalid resolution "${resolution}".`);
	if (!isEnumMember(onWrite, STORY_HEADER_FOOTER_ON_WRITE_VALUES)) throw new Error(`Malformed header/footer slot story key "${storyKey}": invalid onWrite "${onWrite}".`);
	return {
		kind: "story",
		storyType: "headerFooterSlot",
		section: {
			kind: "section",
			sectionId
		},
		headerFooterKind,
		variant,
		resolution,
		onWrite
	};
}
function parseHeaderFooterPartKey(storyKey) {
	const refId = storyKey.slice(8);
	if (!isNonEmptyString(refId)) throw new Error(`Malformed header/footer part story key "${storyKey}": missing refId.`);
	return {
		kind: "story",
		storyType: "headerFooterPart",
		refId
	};
}
function parseNoteKey(storyKey, storyType) {
	const prefix = storyType === "footnote" ? "fn:" : "en:";
	const noteId = storyKey.slice(prefix.length);
	if (!isNonEmptyString(noteId)) throw new Error(`Malformed ${storyType} story key "${storyKey}": missing noteId.`);
	return {
		kind: "story",
		storyType,
		noteId
	};
}
function isNonEmptyString(value) {
	return typeof value === "string" && value.length > 0;
}
function isEnumMember(value, allowed) {
	return typeof value === "string" && allowed.includes(value);
}
var DEFAULT_CAPACITY = 10;
var StoryRuntimeCache = class {
	constructor(capacity = DEFAULT_CAPACITY) {
		this.map = /* @__PURE__ */ new Map();
		this.capacity = Math.max(1, capacity);
		this.head = {
			key: "",
			runtime: null,
			prev: null,
			next: null
		};
		this.tail = {
			key: "",
			runtime: null,
			prev: null,
			next: null
		};
		this.head.next = this.tail;
		this.tail.prev = this.head;
	}
	get(storyKey) {
		const node = this.map.get(storyKey);
		if (!node) return void 0;
		this.detach(node);
		this.attachAfterHead(node);
		return node.runtime;
	}
	set(storyKey, runtime) {
		const existing = this.map.get(storyKey);
		if (existing) {
			existing.runtime = runtime;
			this.detach(existing);
			this.attachAfterHead(existing);
			return;
		}
		if (this.map.size >= this.capacity) this.evictLru();
		const node = {
			key: storyKey,
			runtime,
			prev: null,
			next: null
		};
		this.map.set(storyKey, node);
		this.attachAfterHead(node);
	}
	delete(storyKey) {
		const node = this.map.get(storyKey);
		if (!node) return false;
		this.detach(node);
		this.map.delete(storyKey);
		return true;
	}
	clear() {
		for (const node of this.map.values()) node.runtime.dispose?.();
		this.map.clear();
		this.head.next = this.tail;
		this.tail.prev = this.head;
	}
	invalidate(storyKey) {
		const node = this.map.get(storyKey);
		if (!node) return false;
		this.detach(node);
		this.map.delete(storyKey);
		node.runtime.dispose?.();
		return true;
	}
	invalidateByPrefix(prefix) {
		let count = 0;
		for (const [key, node] of this.map) if (key.startsWith(prefix)) {
			this.detach(node);
			this.map.delete(key);
			node.runtime.dispose?.();
			count++;
		}
		return count;
	}
	has(storyKey) {
		return this.map.has(storyKey);
	}
	get size() {
		return this.map.size;
	}
	detach(node) {
		const prev = node.prev;
		const next = node.next;
		if (prev) prev.next = next;
		if (next) next.prev = prev;
		node.prev = null;
		node.next = null;
	}
	attachAfterHead(node) {
		const afterHead = this.head.next;
		node.prev = this.head;
		node.next = afterHead;
		this.head.next = node;
		afterHead.prev = node;
	}
	evictLru() {
		let candidate = this.tail.prev;
		while (candidate && candidate !== this.head) {
			if (candidate.key !== "body") {
				this.detach(candidate);
				this.map.delete(candidate.key);
				candidate.runtime.dispose?.();
				return;
			}
			candidate = candidate.prev;
		}
	}
};
var DocumentApiAdapterError = class DocumentApiAdapterError extends Error {
	constructor(code$1, message, details) {
		super(message);
		this.name = "DocumentApiAdapterError";
		this.code = code$1;
		this.details = details;
		Object.setPrototypeOf(this, DocumentApiAdapterError.prototype);
	}
};
function createStoryEditor(parentEditor, content$2, options = {}) {
	if (!parentEditor) throw new TypeError("parentEditor is required");
	if (!content$2) throw new TypeError("content is required");
	const { documentId = "story", isHeaderOrFooter = true, headless, currentPageNumber = 1, currentPageNumberText, currentPageDisplayNumber, currentPageChapterNumberText, currentPageChapterSeparator, totalPageCount = 1, sectionPageCount, element = null, editorOptions = {} } = options;
	const isHeadless = headless ?? parentEditor.options.isHeadless ?? false;
	const media = (parentEditor.storage?.image)?.media ?? parentEditor.options.media ?? {};
	const inheritedExtensions = parentEditor.options.extensions?.length ? [...parentEditor.options.extensions] : void 0;
	const inheritedTrackedChanges = parentEditor.options.trackedChanges ? { ...parentEditor.options.trackedChanges } : void 0;
	const StoryEditorClass = parentEditor.constructor;
	const storyEditor = new StoryEditorClass({
		role: parentEditor.options.role,
		loadFromSchema: true,
		mode: "docx",
		content: content$2,
		extensions: inheritedExtensions,
		documentId,
		media,
		mediaFiles: media,
		fonts: parentEditor.options.fonts,
		user: parentEditor.options.user,
		trackedChanges: inheritedTrackedChanges,
		isHeaderOrFooter,
		isHeadless,
		pagination: false,
		annotations: true,
		currentPageNumber,
		currentPageNumberText,
		currentPageDisplayNumber,
		currentPageChapterNumberText,
		currentPageChapterSeparator,
		totalPageCount,
		sectionPageCount,
		editable: false,
		documentMode: "viewing",
		...isHeadless ? {} : { element },
		ydoc: null,
		collaborationProvider: null,
		isCommentsEnabled: false,
		fragment: null,
		...editorOptions,
		telemetry: { enabled: false }
	});
	const inheritedPresentationEditor = parentEditor.presentationEditor ?? parentEditor._presentationEditor ?? null;
	if (inheritedPresentationEditor) {
		storyEditor.presentationEditor = inheritedPresentationEditor;
		storyEditor._presentationEditor = inheritedPresentationEditor;
	}
	if (storyEditor.options && typeof storyEditor.options === "object") Object.defineProperty(storyEditor.options, "parentEditor", {
		enumerable: false,
		configurable: true,
		get() {
			return parentEditor;
		}
	});
	if (typeof storyEditor.setEditable === "function") storyEditor.setEditable(false, false);
	return storyEditor;
}
let SectionType = /* @__PURE__ */ function(SectionType$1) {
	SectionType$1["CONTINUOUS"] = "continuous";
	SectionType$1["NEXT_PAGE"] = "nextPage";
	SectionType$1["EVEN_PAGE"] = "evenPage";
	SectionType$1["ODD_PAGE"] = "oddPage";
	return SectionType$1;
}({});
const DEFAULT_PARAGRAPH_SECTION_TYPE = SectionType.NEXT_PAGE;
const DEFAULT_BODY_SECTION_TYPE = SectionType.CONTINUOUS;
var TWIPS_PER_INCH$2 = 1440;
var PX_PER_INCH$1 = 96;
var DEFAULT_COLUMN_GAP_INCHES = .5;
function twipsToPixels$1(twips) {
	const n = Number(twips);
	return Number.isFinite(n) ? n / TWIPS_PER_INCH$2 * PX_PER_INCH$1 : void 0;
}
function parseColumnCount(rawValue) {
	if (rawValue == null) return 1;
	const count = Number(rawValue);
	return Number.isFinite(count) && count > 0 ? count : 1;
}
function parseColumnGap(gapTwips) {
	if (gapTwips == null) return DEFAULT_COLUMN_GAP_INCHES;
	const gap = Number(gapTwips);
	return Number.isFinite(gap) ? gap / TWIPS_PER_INCH$2 : DEFAULT_COLUMN_GAP_INCHES;
}
function parseColumnSeparator(rawValue) {
	return rawValue === "1" || rawValue === "true" || rawValue === "on" || rawValue === 1;
}
function parsePositiveInteger(rawValue) {
	const value = Number(rawValue);
	return Number.isInteger(value) && value > 0 ? value : void 0;
}
function isKnownChapterSeparator(value) {
	return typeof value === "string" && CHAPTER_SEPARATOR_VALUES.includes(value);
}
var CHAPTER_SEPARATOR_VALUES = [
	"hyphen",
	"period",
	"colon",
	"emDash",
	"enDash"
];
function extractNormalizedMargins(attrs) {
	const sectionMargins = attrs.sectionMargins;
	return {
		headerPx: typeof sectionMargins?.header === "number" ? sectionMargins.header * 96 : void 0,
		footerPx: typeof sectionMargins?.footer === "number" ? sectionMargins.footer * 96 : void 0
	};
}
function extractSectionType(elements) {
	const val = elements.find((el) => el?.name === "w:type")?.attributes?.["w:val"];
	if (val === "continuous" || val === "nextPage" || val === "evenPage" || val === "oddPage") return val;
	return "nextPage";
}
function extractSectionTypeIsExplicit(elements) {
	return elements.some((el) => el?.name === "w:type");
}
function extractPageSizeAndOrientation(elements) {
	const pgSz = elements.find((el) => el?.name === "w:pgSz");
	if (!pgSz?.attributes) return {
		pageSizePx: void 0,
		orientation: void 0
	};
	const a = pgSz.attributes;
	const widthPx = a["w:w"] != null ? twipsToPixels$1(a["w:w"]) : void 0;
	const heightPx = a["w:h"] != null ? twipsToPixels$1(a["w:h"]) : void 0;
	let pageSizePx;
	if (widthPx != null && heightPx != null) pageSizePx = {
		w: widthPx,
		h: heightPx
	};
	let orientation;
	const orient = a["w:orient"];
	if (orient === "portrait" || orient === "landscape") orientation = orient;
	else if (widthPx != null && heightPx != null) orientation = heightPx > widthPx ? "portrait" : "landscape";
	return {
		pageSizePx,
		orientation
	};
}
function extractFallbackMargins(elements, currentHeader, currentFooter) {
	const a = elements.find((el) => el?.name === "w:pgMar")?.attributes || {};
	return {
		headerPx: currentHeader ?? (a["w:header"] != null ? twipsToPixels$1(a["w:header"]) : void 0),
		footerPx: currentFooter ?? (a["w:footer"] != null ? twipsToPixels$1(a["w:footer"]) : void 0),
		topPx: a["w:top"] != null ? twipsToPixels$1(a["w:top"]) : void 0,
		rightPx: a["w:right"] != null ? twipsToPixels$1(a["w:right"]) : void 0,
		bottomPx: a["w:bottom"] != null ? twipsToPixels$1(a["w:bottom"]) : void 0,
		leftPx: a["w:left"] != null ? twipsToPixels$1(a["w:left"]) : void 0
	};
}
function extractHeaderFooterRefs(elements, refName) {
	const refs = elements.filter((el) => el?.name === refName);
	if (!refs.length) return void 0;
	const out = {};
	refs.forEach((ref$1) => {
		const refType = ref$1?.attributes?.["w:type"];
		const typeKey = refType === "first" || refType === "even" || refType === "odd" || refType === "default" ? refType : "default";
		const id = ref$1?.attributes?.["r:id"];
		if (typeof id === "string" || typeof id === "number") out[typeKey] = String(id);
	});
	return Object.keys(out).length ? out : void 0;
}
function extractPageNumbering(elements) {
	const pgNumType = elements.find((el) => el?.name === "w:pgNumType");
	if (!pgNumType?.attributes) return void 0;
	const fmtRaw = pgNumType.attributes["w:fmt"];
	const fmt = [
		"decimal",
		"lowerLetter",
		"upperLetter",
		"lowerRoman",
		"upperRoman",
		"numberInDash"
	].includes(fmtRaw) ? fmtRaw : void 0;
	const startRaw = pgNumType.attributes["w:start"];
	const startNum = startRaw != null ? Number(startRaw) : void 0;
	const hasStart = Number.isFinite(startNum);
	const chapterStyle = parsePositiveInteger(pgNumType.attributes["w:chapStyle"]);
	const chapterSeparatorRaw = pgNumType.attributes["w:chapSep"];
	const chapterSeparator = isKnownChapterSeparator(chapterSeparatorRaw) ? chapterSeparatorRaw : void 0;
	const effectiveFormat = fmt ?? (hasStart ? "decimal" : void 0);
	if (effectiveFormat === void 0 && !hasStart && chapterStyle === void 0 && chapterSeparator === void 0) return;
	return {
		format: effectiveFormat,
		...hasStart ? { start: Number(startNum) } : {},
		...chapterStyle !== void 0 ? { chapterStyle } : {},
		...chapterSeparator !== void 0 ? { chapterSeparator } : {}
	};
}
function extractColumns(elements) {
	const cols = elements.find((el) => el?.name === "w:cols");
	if (!cols?.attributes) return void 0;
	let count = parseColumnCount(cols.attributes["w:num"]);
	const withSeparator = parseColumnSeparator(cols.attributes["w:sep"]);
	const equalWidthRaw = cols.attributes["w:equalWidth"];
	const equalWidth = equalWidthRaw === "0" || equalWidthRaw === 0 || equalWidthRaw === false ? false : equalWidthRaw === "1" || equalWidthRaw === 1 || equalWidthRaw === true ? true : void 0;
	const columnChildren = Array.isArray(cols.elements) ? cols.elements.filter((child) => child?.name === "w:col") : [];
	const isExplicit = equalWidth === false;
	const toPx = (twips) => twips / TWIPS_PER_INCH$2 * PX_PER_INCH$1;
	const columnRecords = columnChildren.map((child) => {
		const widthTwips = Number(child.attributes?.["w:w"]);
		const spaceTwips = Number(child.attributes?.["w:space"]);
		return {
			widthTwips,
			spaceTwips: Number.isFinite(spaceTwips) && spaceTwips > 0 ? spaceTwips : 0
		};
	}).filter((record) => Number.isFinite(record.widthTwips) && record.widthTwips > 0);
	if (isExplicit && columnRecords.length > 0) count = Math.min(count, columnRecords.length);
	const widths = columnRecords.slice(0, count).map((record) => toPx(record.widthTwips));
	const gaps = columnRecords.slice(0, Math.max(0, count - 1)).map((record) => toPx(record.spaceTwips));
	const gapPx = isExplicit ? toPx(columnRecords[0]?.spaceTwips ?? 0) : parseColumnGap(cols.attributes["w:space"]) * PX_PER_INCH$1;
	return {
		count,
		gap: gapPx,
		withSeparator,
		...isExplicit && widths.length > 0 ? { widths } : {},
		...isExplicit && gaps.length > 0 ? { gaps } : {},
		...equalWidth !== void 0 ? { equalWidth } : {}
	};
}
function extractVerticalAlign(elements) {
	const vAlign = elements.find((el) => el?.name === "w:vAlign");
	if (!vAlign?.attributes) return void 0;
	const val = vAlign.attributes["w:val"];
	if (val === "top" || val === "center" || val === "bottom" || val === "both") return val;
}
function extractSectionData(para) {
	const attrs = para.attrs ?? {};
	let { headerPx, footerPx } = extractNormalizedMargins(attrs);
	const paragraphProperties = typeof attrs.paragraphProperties === "object" && attrs.paragraphProperties !== null ? attrs.paragraphProperties : void 0;
	const sectPrElements = paragraphProperties?.sectPr && typeof paragraphProperties.sectPr === "object" && "elements" in paragraphProperties.sectPr && Array.isArray(paragraphProperties.sectPr.elements) ? paragraphProperties.sectPr.elements : void 0;
	if (!sectPrElements) return headerPx == null && footerPx == null ? null : {
		headerPx,
		footerPx
	};
	const type = extractSectionType(sectPrElements);
	const typeIsExplicit = extractSectionTypeIsExplicit(sectPrElements);
	const { pageSizePx, orientation } = extractPageSizeAndOrientation(sectPrElements);
	const titlePg = sectPrElements.some((el) => el?.name === "w:titlePg");
	const fallbackMargins = extractFallbackMargins(sectPrElements, headerPx, footerPx);
	headerPx = fallbackMargins.headerPx;
	footerPx = fallbackMargins.footerPx;
	const { topPx, rightPx, bottomPx, leftPx } = fallbackMargins;
	const headerRefs = extractHeaderFooterRefs(sectPrElements, "w:headerReference");
	const footerRefs = extractHeaderFooterRefs(sectPrElements, "w:footerReference");
	const numbering = extractPageNumbering(sectPrElements);
	const columnsPx = extractColumns(sectPrElements);
	const vAlign = extractVerticalAlign(sectPrElements);
	return {
		headerPx,
		footerPx,
		topPx,
		rightPx,
		bottomPx,
		leftPx,
		type,
		typeIsExplicit,
		pageSizePx,
		orientation,
		columnsPx,
		titlePg,
		headerRefs,
		footerRefs,
		numbering,
		vAlign
	};
}
function isSectPrElement$1(value) {
	return typeof value === "object" && value !== null && value.type === "element" && value.name === "w:sectPr";
}
function hasSectPr(node) {
	if (node.type !== "paragraph" || !node.attrs) return false;
	const paragraphProperties = node.attrs.paragraphProperties;
	if (!paragraphProperties || typeof paragraphProperties !== "object") return false;
	const sectPr = paragraphProperties.sectPr;
	return isSectPrElement$1(sectPr) || typeof sectPr === "object" && sectPr !== null && "elements" in sectPr && Array.isArray(sectPr.elements);
}
function getSectPrFromNode(node) {
	if (!node.attrs) return null;
	const paragraphProperties = node.attrs.paragraphProperties;
	if (!paragraphProperties || typeof paragraphProperties !== "object") return null;
	const sectPr = paragraphProperties.sectPr;
	return isSectPrElement$1(sectPr) ? sectPr : null;
}
function createSectionBreakBlock(section, blockIdGen, extraAttrs) {
	return {
		kind: "sectionBreak",
		id: blockIdGen("sectionBreak"),
		margins: section.margins ?? {
			header: 0,
			footer: 0
		},
		type: section.type,
		attrs: {
			source: "sectPr",
			sectionIndex: section.sectionIndex,
			...section.typeIsExplicit ? { typeIsExplicit: true } : {},
			...extraAttrs
		},
		...section.pageSize && { pageSize: section.pageSize },
		...section.orientation && { orientation: section.orientation },
		...section.columns && { columns: section.columns },
		...section.numbering ? { numbering: section.numbering } : {},
		...section.headerRefs && { headerRefs: section.headerRefs },
		...section.footerRefs && { footerRefs: section.footerRefs },
		...section.vAlign && { vAlign: section.vAlign }
	};
}
function shouldRequirePageBoundary(current, next) {
	if (!next) return false;
	if (current.orientation && next.orientation && current.orientation !== next.orientation) return true;
	if (current.pageSize && next.pageSize) {
		if (current.pageSize.w !== next.pageSize.w || current.pageSize.h !== next.pageSize.h) return true;
	}
	return false;
}
function hasIntrinsicBoundarySignals(_) {
	return false;
}
function maybeEmitNextSectionBreakForNode(args) {
	const { sectionState, nextBlockId, pushBlock } = args;
	if (sectionState.ranges.length === 0) return;
	if (sectionState.currentSectionIndex >= sectionState.ranges.length - 1) return;
	const nextSection = sectionState.ranges[sectionState.currentSectionIndex + 1];
	if (!nextSection) return;
	if (sectionState.currentNodeIndex !== nextSection.startNodeIndex) return;
	const currentSection = sectionState.ranges[sectionState.currentSectionIndex];
	pushBlock(createSectionBreakBlock(nextSection, nextBlockId, shouldRequirePageBoundary(currentSection, nextSection) || hasIntrinsicBoundarySignals(nextSection) ? { requirePageBoundary: true } : void 0));
	sectionState.currentSectionIndex++;
}
function emitPendingSectionBreakForParagraph(args) {
	const { sectionState, nextBlockId, blocks, recordBlockKind } = args;
	if (!sectionState || sectionState.ranges.length === 0) return;
	const nextSection = sectionState.ranges[sectionState.currentSectionIndex + 1];
	if (!nextSection || sectionState.currentParagraphIndex !== nextSection.startParagraphIndex) return;
	const currentSection = sectionState.ranges[sectionState.currentSectionIndex];
	const sectionBreak = createSectionBreakBlock(nextSection, nextBlockId, shouldRequirePageBoundary(currentSection, nextSection) || hasIntrinsicBoundarySignals(nextSection) ? { requirePageBoundary: true } : void 0);
	blocks.push(sectionBreak);
	recordBlockKind?.(sectionBreak.kind);
	sectionState.currentSectionIndex++;
}
var DEFAULT_HEADER_FOOTER_MARGIN_PX = 0;
function shouldIgnoreSectionBreak(paragraph, index, total, hasBodySectPr) {
	const paragraphAttrs = paragraph.attrs ?? {};
	const sectPr = (paragraphAttrs?.paragraphProperties)?.sectPr;
	if (!sectPr) return true;
	const hasElements = Array.isArray(sectPr.elements) && sectPr.elements.length > 0;
	const hasNormalizedMargins = (() => {
		const normalizedMargins = paragraphAttrs.sectionMargins;
		if (!normalizedMargins) return false;
		return normalizedMargins.header != null || normalizedMargins.footer != null;
	})();
	const isLastParagraphBreak = index === total - 1 && !hasBodySectPr;
	if (!hasElements && !hasNormalizedMargins && !isLastParagraphBreak) return true;
	return false;
}
function findParagraphsWithSectPr(doc$2) {
	const paragraphs = [];
	let paragraphIndex = 0;
	let nodeIndex = 0;
	const getNodeChildren = (node) => {
		if (Array.isArray(node.content)) return node.content;
		const content$2 = node.content;
		if (content$2 && typeof content$2.forEach === "function") {
			const children = [];
			content$2.forEach((child) => {
				children.push(child);
			});
			return children;
		}
		return [];
	};
	const visitNode = (node, outerNodeIndex) => {
		if (node.type === "paragraph") {
			if (hasSectPr(node)) paragraphs.push({
				index: paragraphIndex,
				nodeIndex: outerNodeIndex,
				node
			});
			paragraphIndex++;
			return;
		}
		if (node.type === "index" || node.type === "bibliography" || node.type === "tableOfAuthorities" || node.type === "documentPartObject" || node.type === "tableOfContents") getNodeChildren(node).forEach((child) => visitNode(child, outerNodeIndex));
	};
	if (doc$2.content) for (const node of doc$2.content) {
		visitNode(node, nodeIndex);
		nodeIndex++;
	}
	return {
		paragraphs,
		totalCount: paragraphIndex,
		totalNodeCount: nodeIndex
	};
}
function buildSectionRangesFromParagraphs(paragraphs, hasBodySectPr) {
	const ranges = [];
	let currentStart = 0;
	let currentStartNode = 0;
	paragraphs.forEach((item, idx) => {
		if (shouldIgnoreSectionBreak(item.node, idx, paragraphs.length, hasBodySectPr)) return;
		const sectionData = extractSectionData(item.node);
		if (!sectionData) return;
		const sectPr = getSectPrFromNode(item.node);
		const hasAnyMargin = sectionData.headerPx != null || sectionData.footerPx != null || sectionData.topPx != null || sectionData.rightPx != null || sectionData.bottomPx != null || sectionData.leftPx != null;
		const range = {
			sectionIndex: idx,
			startNodeIndex: currentStartNode,
			endNodeIndex: item.nodeIndex,
			startParagraphIndex: currentStart,
			endParagraphIndex: item.index,
			sectPr,
			margins: hasAnyMargin ? {
				header: sectionData.headerPx ?? DEFAULT_HEADER_FOOTER_MARGIN_PX,
				footer: sectionData.footerPx ?? DEFAULT_HEADER_FOOTER_MARGIN_PX,
				top: sectionData.topPx,
				right: sectionData.rightPx,
				bottom: sectionData.bottomPx,
				left: sectionData.leftPx
			} : null,
			pageSize: sectionData.pageSizePx ?? null,
			orientation: sectionData.orientation ?? null,
			columns: sectionData.columnsPx ?? null,
			type: sectionData.type ?? DEFAULT_PARAGRAPH_SECTION_TYPE,
			typeIsExplicit: sectionData.typeIsExplicit ?? false,
			titlePg: sectionData.titlePg ?? false,
			headerRefs: sectionData.headerRefs,
			footerRefs: sectionData.footerRefs,
			numbering: sectionData.numbering,
			vAlign: sectionData.vAlign
		};
		ranges.push(range);
		currentStart = item.index + 1;
		currentStartNode = item.nodeIndex + 1;
	});
	return ranges;
}
function publishSectionMetadata(sectionRanges, options) {
	if (!options?.sectionMetadata) return;
	options.sectionMetadata.length = 0;
	sectionRanges.forEach((section) => {
		options.sectionMetadata?.push({
			sectionIndex: section.sectionIndex,
			headerRefs: section.headerRefs,
			footerRefs: section.footerRefs,
			numbering: section.numbering,
			titlePg: section.titlePg,
			vAlign: section.vAlign,
			margins: section.margins,
			pageSize: section.pageSize
		});
	});
}
function createFinalSectionFromBodySectPr(bodySectPr, currentStart, totalParagraphs, sectionIndex, nodeBounds) {
	const clampedStart = Math.max(0, Math.min(currentStart, Math.max(totalParagraphs - 1, 0)));
	const bodySectionData = extractSectionData({
		type: "paragraph",
		attrs: { paragraphProperties: { sectPr: bodySectPr } }
	});
	if (!bodySectionData) return null;
	const hasAnyMargin = bodySectionData.headerPx != null || bodySectionData.footerPx != null || bodySectionData.topPx != null || bodySectionData.rightPx != null || bodySectionData.bottomPx != null || bodySectionData.leftPx != null;
	const totalNodes = nodeBounds?.totalNodeCount ?? totalParagraphs;
	const startNodeIndex = nodeBounds ? Math.max(0, Math.min(nodeBounds.startNodeIndex, Math.max(totalNodes - 1, 0))) : clampedStart;
	return {
		sectionIndex,
		startNodeIndex,
		endNodeIndex: Math.max(startNodeIndex, totalNodes - 1),
		startParagraphIndex: clampedStart,
		endParagraphIndex: totalParagraphs - 1,
		sectPr: bodySectPr,
		margins: hasAnyMargin ? {
			header: bodySectionData.headerPx ?? DEFAULT_HEADER_FOOTER_MARGIN_PX,
			footer: bodySectionData.footerPx ?? DEFAULT_HEADER_FOOTER_MARGIN_PX,
			top: bodySectionData.topPx,
			right: bodySectionData.rightPx,
			bottom: bodySectionData.bottomPx,
			left: bodySectionData.leftPx
		} : null,
		pageSize: bodySectionData.pageSizePx ?? null,
		orientation: bodySectionData.orientation ?? null,
		columns: bodySectionData.columnsPx ?? null,
		type: bodySectionData.type ?? DEFAULT_BODY_SECTION_TYPE,
		typeIsExplicit: bodySectionData.typeIsExplicit ?? false,
		titlePg: bodySectionData.titlePg ?? false,
		headerRefs: bodySectionData.headerRefs,
		footerRefs: bodySectionData.footerRefs,
		numbering: bodySectionData.numbering,
		vAlign: bodySectionData.vAlign
	};
}
function createDefaultFinalSection(currentStart, totalParagraphs, sectionIndex, nodeBounds) {
	const totalNodes = nodeBounds?.totalNodeCount ?? totalParagraphs;
	const startNodeIndex = nodeBounds?.startNodeIndex ?? currentStart;
	return {
		sectionIndex,
		startNodeIndex,
		endNodeIndex: Math.max(startNodeIndex, totalNodes - 1),
		startParagraphIndex: currentStart,
		endParagraphIndex: totalParagraphs - 1,
		sectPr: null,
		margins: null,
		pageSize: null,
		orientation: null,
		columns: null,
		type: DEFAULT_BODY_SECTION_TYPE,
		typeIsExplicit: false,
		titlePg: false,
		headerRefs: void 0,
		footerRefs: void 0
	};
}
function analyzeSectionRanges(doc$2, bodySectPr) {
	const { paragraphs, totalCount, totalNodeCount } = findParagraphsWithSectPr(doc$2);
	const ranges = buildSectionRangesFromParagraphs(paragraphs, Boolean(bodySectPr));
	const last = ranges[ranges.length - 1];
	const currentStart = last ? last.endParagraphIndex + 1 : 0;
	const currentStartNode = last ? last.endNodeIndex + 1 : 0;
	if (isSectPrElement$1(bodySectPr)) {
		const finalSection = createFinalSectionFromBodySectPr(bodySectPr, Math.min(currentStart, totalCount), totalCount, ranges.length, {
			startNodeIndex: Math.min(currentStartNode, totalNodeCount),
			totalNodeCount
		});
		if (finalSection) ranges.push(finalSection);
	} else if (ranges.length > 0) {
		const fallbackFinal = createDefaultFinalSection(Math.min(currentStart, totalCount), totalCount, ranges.length, {
			startNodeIndex: Math.min(currentStartNode, totalNodeCount),
			totalNodeCount
		});
		if (fallbackFinal) {
			fallbackFinal.type = DEFAULT_PARAGRAPH_SECTION_TYPE;
			ranges.push(fallbackFinal);
		}
	}
	return ranges;
}
var DEFAULT_PAGE_DIRECTION = "ltr";
var DEFAULT_WRITING_MODE = "horizontal-tb";
var isToggleOn = (val) => {
	if (val === void 0 || val === null) return true;
	if (val === "0" || val === 0 || val === false) return false;
	if (val === "false" || val === "off") return false;
	return true;
};
var writingModeFromTextDirection$1 = (val) => {
	if (typeof val !== "string") return void 0;
	switch (val) {
		case "lrTb":
		case "lrTbV":
		case "tb":
		case "tbV": return "horizontal-tb";
		case "tbRl":
		case "tbRlV":
		case "rl":
		case "rlV": return "vertical-rl";
		case "btLr":
		case "lr":
		case "lrV":
		case "tbLrV": return "vertical-lr";
		default: return;
	}
};
const resolveSectionDirection = (sectPr) => {
	let pageDirection = DEFAULT_PAGE_DIRECTION;
	let writingMode = DEFAULT_WRITING_MODE;
	let rtlGutter = false;
	if (sectPr && typeof sectPr === "object") {
		const elements = sectPr.elements;
		if (Array.isArray(elements)) for (const el of elements) {
			if (!el?.name) continue;
			const val = el.attributes?.["w:val"] ?? el.attributes?.val;
			if (el.name === "w:bidi" && isToggleOn(val)) {
				pageDirection = "rtl";
				continue;
			}
			if (el.name === "w:textDirection") {
				const mode = writingModeFromTextDirection$1(val);
				if (mode) writingMode = mode;
				continue;
			}
			if (el.name === "w:rtlGutter" && isToggleOn(val)) {
				rtlGutter = true;
				continue;
			}
		}
	}
	return {
		pageDirection,
		writingMode,
		rtlGutter
	};
};
function getDefaultExportFromCjs(x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = { exports: {} };
var process = browser.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
	throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
	throw new Error("clearTimeout has not been defined");
}
(function() {
	try {
		if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
		else cachedSetTimeout = defaultSetTimout;
	} catch (e) {
		cachedSetTimeout = defaultSetTimout;
	}
	try {
		if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
		else cachedClearTimeout = defaultClearTimeout;
	} catch (e) {
		cachedClearTimeout = defaultClearTimeout;
	}
})();
function runTimeout(fun) {
	if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
	if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		cachedSetTimeout = setTimeout;
		return setTimeout(fun, 0);
	}
	try {
		return cachedSetTimeout(fun, 0);
	} catch (e) {
		try {
			return cachedSetTimeout.call(null, fun, 0);
		} catch (e$1) {
			return cachedSetTimeout.call(this, fun, 0);
		}
	}
}
function runClearTimeout(marker) {
	if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
	if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		cachedClearTimeout = clearTimeout;
		return clearTimeout(marker);
	}
	try {
		return cachedClearTimeout(marker);
	} catch (e) {
		try {
			return cachedClearTimeout.call(null, marker);
		} catch (e$1) {
			return cachedClearTimeout.call(this, marker);
		}
	}
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
	if (!draining || !currentQueue) return;
	draining = false;
	if (currentQueue.length) queue = currentQueue.concat(queue);
	else queueIndex = -1;
	if (queue.length) drainQueue();
}
function drainQueue() {
	if (draining) return;
	var timeout = runTimeout(cleanUpNextTick);
	draining = true;
	var len = queue.length;
	while (len) {
		currentQueue = queue;
		queue = [];
		while (++queueIndex < len) if (currentQueue) currentQueue[queueIndex].run();
		queueIndex = -1;
		len = queue.length;
	}
	currentQueue = null;
	draining = false;
	runClearTimeout(timeout);
}
process.nextTick = function(fun) {
	var args = new Array(arguments.length - 1);
	if (arguments.length > 1) for (var i$1 = 1; i$1 < arguments.length; i$1++) args[i$1 - 1] = arguments[i$1];
	queue.push(new Item(fun, args));
	if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
function Item(fun, array) {
	this.fun = fun;
	this.array = array;
}
Item.prototype.run = function() {
	this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
	return [];
};
process.binding = function(name) {
	throw new Error("process.binding is not supported");
};
process.cwd = function() {
	return "/";
};
process.chdir = function(dir) {
	throw new Error("process.chdir is not supported");
};
process.umask = function() {
	return 0;
};
var browserExports = browser.exports;
var process$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
const TWIPS_PER_INCH$1 = 1440;
const PX_PER_PT = 96 / 72;
const VALID_TRACKED_MODES = [
	"review",
	"original",
	"final",
	"off"
];
const DEFAULT_HYPERLINK_CONFIG = { enableRichHyperlinks: false };
const ATOMIC_INLINE_TYPES = new Set([
	"image",
	"hardBreak",
	"lineBreak",
	"page-number",
	"total-page-number",
	"section-page-count",
	"indexEntry",
	"tab",
	"noBreakHyphen",
	"footnoteReference",
	"mathInline",
	"passthroughInline",
	"bookmarkEnd",
	"fieldAnnotation",
	"documentStatField"
]);
const TOKEN_INLINE_TYPES = new Map([
	["page-number", "pageNumber"],
	["total-page-number", "totalPageCount"],
	["section-page-count", "sectionPageCount"]
]);
var RANDOM_ID_LENGTH$1 = 9;
var generateRandomBase36Id$1 = (length) => {
	let randomId = "";
	while (randomId.length < length) randomId += Math.random().toString(36).slice(2);
	return randomId.slice(0, length);
};
const isValidTrackedMode = (value) => {
	return typeof value === "string" && VALID_TRACKED_MODES.includes(value);
};
const isTextRun$2 = (run$1) => {
	return "text" in run$1 && run$1.kind !== "tab";
};
const stripTrackedChangeFromRun = (run$1) => {
	if ("trackedChange" in run$1 && run$1.trackedChange) delete run$1.trackedChange;
	if ("trackedChanges" in run$1 && run$1.trackedChanges) delete run$1.trackedChanges;
};
const deriveTrackedChangeId$1 = (kind, attrs) => {
	if (attrs && typeof attrs.id === "string" && attrs.id.trim()) return attrs.id;
	return `${kind}-${attrs && typeof attrs.authorEmail === "string" ? attrs.authorEmail : "unknown"}-${attrs && typeof attrs.date === "string" ? attrs.date : "unknown"}-${`${Date.now()}-${generateRandomBase36Id$1(RANDOM_ID_LENGTH$1)}`}`;
};
var normalizeTrackedChangeLayers$1 = (run$1) => {
	if (Array.isArray(run$1.trackedChanges) && run$1.trackedChanges.length > 0) return run$1.trackedChanges;
	return run$1.trackedChange ? [run$1.trackedChange] : [];
};
var isTrackedChangeRun = (run$1) => {
	return isTextRun$2(run$1) || run$1.kind === "break";
};
var runHasTrackedChangeKind = (run$1, kind) => {
	if (!isTrackedChangeRun(run$1)) return false;
	return normalizeTrackedChangeLayers$1(run$1).some((layer) => layer.kind === kind);
};
var stripTrackedChangeKindsFromRun = (run$1, kinds) => {
	if (!isTrackedChangeRun(run$1)) return;
	const hiddenKinds = new Set(kinds);
	const remainingLayers = normalizeTrackedChangeLayers$1(run$1).filter((layer) => !hiddenKinds.has(layer.kind));
	if (remainingLayers.length === 0) {
		stripTrackedChangeFromRun(run$1);
		return;
	}
	run$1.trackedChange = remainingLayers[0];
	if (remainingLayers.length > 1) run$1.trackedChanges = remainingLayers;
	else delete run$1.trackedChanges;
};
const shouldHideTrackedNode = (meta, config$43) => {
	if (!meta || !config$43 || !config$43.enabled) return false;
	if (config$43.mode === "original" && meta.kind === "insert") return true;
	if (config$43.mode === "final" && meta.kind === "delete") return true;
	return false;
};
const annotateBlockWithTrackedChange = (block, meta, config$43) => {
	if (!meta) return;
	if (!config$43 || !config$43.enabled || config$43.mode === "off") return;
	block.attrs = {
		...block.attrs ?? {},
		trackedChange: meta
	};
};
const resetRunFormatting = (run$1) => {
	delete run$1.bold;
	delete run$1.italic;
	delete run$1.color;
	delete run$1.underline;
	delete run$1.strike;
	delete run$1.highlight;
	delete run$1.link;
	delete run$1.letterSpacing;
	delete run$1.vertAlign;
	delete run$1.baselineShift;
};
const applyFormatChangeMarks = (run$1, config$43, hyperlinkConfig, applyMarksToRun$1, themeColors, enableComments = true, storyKey) => {
	const tracked = run$1.trackedChange;
	if (!tracked || tracked.kind !== "format") return;
	if (config$43.mode !== "original") return;
	const beforeMarks = tracked.before;
	if (!beforeMarks || beforeMarks.length === 0) {
		resetRunFormatting(run$1);
		return;
	}
	if (!beforeMarks.every((mark) => mark !== null && typeof mark === "object" && "type" in mark && typeof mark.type === "string")) {
		if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Invalid before marks in tracked change, resetting formatting");
		resetRunFormatting(run$1);
		return;
	}
	resetRunFormatting(run$1);
	try {
		applyMarksToRun$1(run$1, beforeMarks, hyperlinkConfig, themeColors, void 0, enableComments, storyKey);
	} catch (error) {
		if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Error applying format change marks, resetting formatting:", error);
		resetRunFormatting(run$1);
	}
};
const applyTrackedChangesModeToRuns = (runs, config$43, hyperlinkConfig, applyMarksToRun$1, themeColors, enableComments = true, storyKey) => {
	if (!config$43) return runs;
	const metadataDisabled = !config$43.enabled || config$43.mode === "off";
	const hideInsertions = config$43.enabled && config$43.mode === "original";
	const hideDeletions = config$43.enabled && config$43.mode === "final";
	if (!hideInsertions && !hideDeletions) {
		if (metadataDisabled) runs.forEach((run$1) => stripTrackedChangeFromRun(run$1));
		else runs.forEach((run$1) => {
			if (isTextRun$2(run$1)) applyFormatChangeMarks(run$1, config$43, hyperlinkConfig, applyMarksToRun$1, themeColors, enableComments, storyKey);
		});
		return runs;
	}
	const filtered = [];
	runs.forEach((run$1) => {
		if (!isTextRun$2(run$1) && run$1.kind !== "break") {
			filtered.push(run$1);
			return;
		}
		if (!isTrackedChangeRun(run$1) || normalizeTrackedChangeLayers$1(run$1).length === 0) {
			filtered.push(run$1);
			return;
		}
		if (hideInsertions && runHasTrackedChangeKind(run$1, "insert")) return;
		if (hideDeletions && runHasTrackedChangeKind(run$1, "delete")) return;
		filtered.push(run$1);
	});
	if (metadataDisabled) filtered.forEach((run$1) => stripTrackedChangeFromRun(run$1));
	else {
		filtered.forEach((run$1) => {
			if (isTextRun$2(run$1)) applyFormatChangeMarks(run$1, config$43, hyperlinkConfig || DEFAULT_HYPERLINK_CONFIG, applyMarksToRun$1, themeColors, enableComments, storyKey);
		});
		if ((config$43.mode === "original" || config$43.mode === "final") && config$43.enabled) filtered.forEach((run$1) => {
			if (runHasTrackedChangeKind(run$1, "insert") || runHasTrackedChangeKind(run$1, "delete")) stripTrackedChangeKindsFromRun(run$1, ["insert", "delete"]);
		});
	}
	return filtered;
};
const twipsToPx = (value) => value / TWIPS_PER_INCH$1 * 96;
const ptToPx = (pt) => {
	if (pt == null || !Number.isFinite(pt)) return void 0;
	return pt * PX_PER_PT;
};
const isFiniteNumber = (value) => typeof value === "number" && Number.isFinite(value);
const isPlainObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const normalizePrefix = (value) => {
	if (!value) return "";
	return String(value);
};
const pickNumber = (value) => {
	if (isFiniteNumber(value)) return value;
	if (typeof value === "string") {
		const parsed = parseFloat(value);
		return Number.isFinite(parsed) ? parsed : void 0;
	}
};
const mergeWrapDistancesFromPadding = (wrap$1, padding) => {
	if (!padding || wrap$1.type === "None" || wrap$1.type === "Inline") return;
	const mergeVertical = wrap$1.type === "Square" || wrap$1.type === "TopAndBottom";
	const mergeHorizontal = wrap$1.type === "Square" || wrap$1.type === "Tight" || wrap$1.type === "Through";
	if (mergeVertical && wrap$1.distTop == null && padding.top != null) wrap$1.distTop = padding.top;
	if (mergeVertical && wrap$1.distBottom == null && padding.bottom != null) wrap$1.distBottom = padding.bottom;
	if (mergeHorizontal && wrap$1.distLeft == null && padding.left != null) wrap$1.distLeft = padding.left;
	if (mergeHorizontal && wrap$1.distRight == null && padding.right != null) wrap$1.distRight = padding.right;
};
const normalizeColor = (value) => {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	if (!trimmed || trimmed === "auto" || trimmed === "none") return void 0;
	return trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
};
const normalizeString$1 = (value) => {
	if (typeof value !== "string") return void 0;
	return value.trim() || void 0;
};
const readImageHyperlink = (value) => {
	const hyperlink = isPlainObject(value) ? value : void 0;
	const url = normalizeString$1(hyperlink?.url);
	if (!url) return;
	const tooltip = normalizeString$1(hyperlink?.tooltip);
	return tooltip ? {
		url,
		tooltip
	} : { url };
};
function coerceNumber(value) {
	if (isFiniteNumber(value)) return Number(value);
	if (typeof value === "string" && value.trim() !== "") {
		const parsed = Number(value);
		return Number.isFinite(parsed) ? parsed : void 0;
	}
}
function coercePositiveNumber(value, fallback) {
	if (!isFiniteNumber(fallback) || fallback <= 0) throw new Error(`coercePositiveNumber: fallback must be a positive number, got ${fallback}`);
	const numeric = coerceNumber(value);
	if (numeric != null && numeric > 0) return numeric;
	return fallback;
}
function coerceBoolean(value) {
	if (typeof value === "boolean") return value;
	if (typeof value === "number") {
		if (value === 1) return true;
		if (value === 0) return false;
		return;
	}
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if ([
			"true",
			"1",
			"yes",
			"on"
		].includes(normalized)) return true;
		if ([
			"false",
			"0",
			"no",
			"off"
		].includes(normalized)) return false;
	}
}
const toBoolean = (value) => {
	if (typeof value === "boolean") return value;
	if (typeof value === "string") {
		const v = value.trim().toLowerCase();
		if (v === "true" || v === "1") return true;
		if (v === "false" || v === "0") return false;
	}
	if (typeof value === "number") {
		if (value === 1) return true;
		if (value === 0) return false;
	}
};
function toBoxSpacing(spacing) {
	if (!spacing) return;
	const result = {};
	[
		"top",
		"right",
		"bottom",
		"left"
	].forEach((side) => {
		const value = spacing[side];
		if (isFiniteNumber(value)) result[side] = Number(value);
	});
	return Object.keys(result).length > 0 ? result : void 0;
}
var MIN_TOP_BOTTOM_CELL_PADDING_PX = 2;
function normalizeCellPaddingTopBottom(padding) {
	const out = { ...padding };
	if (typeof out.top === "number" && out.top > 0 && out.top < MIN_TOP_BOTTOM_CELL_PADDING_PX) out.top = MIN_TOP_BOTTOM_CELL_PADDING_PX;
	if (typeof out.bottom === "number" && out.bottom > 0 && out.bottom < MIN_TOP_BOTTOM_CELL_PADDING_PX) out.bottom = MIN_TOP_BOTTOM_CELL_PADDING_PX;
	return out;
}
const buildPositionMap = (root, options) => {
	const map = /* @__PURE__ */ new WeakMap();
	const atomNodeTypes = new Set(ATOMIC_INLINE_TYPES);
	if (options?.atomNodeTypes) {
		for (const nodeType of options.atomNodeTypes) if (typeof nodeType === "string" && nodeType.length > 0) atomNodeTypes.add(nodeType);
	}
	const visit = (node, pos) => {
		if (node.type === "text") {
			const end$1 = pos + (node.text?.length ?? 0);
			map.set(node, {
				start: pos,
				end: end$1
			});
			return end$1;
		}
		if (atomNodeTypes.has(node.type)) {
			const end$1 = pos + 1;
			map.set(node, {
				start: pos,
				end: end$1
			});
			return end$1;
		}
		const open = node.type === "doc" ? 0 : 1;
		const close$1 = node.type === "doc" ? 0 : 1;
		let nextPos = pos + open;
		const content$2 = Array.isArray(node.content) ? node.content : [];
		map.set(node, {
			start: pos,
			end: pos
		});
		content$2.forEach((child) => {
			nextPos = visit(child, nextPos);
		});
		const end = nextPos + close$1;
		map.set(node, {
			start: pos,
			end
		});
		return end;
	};
	visit(root, 0);
	return map;
};
const createBlockIdGenerator = (prefix = "") => {
	let counter = 0;
	return (kind) => `${prefix}${counter++}-${kind}`;
};
function toDrawingContentSnapshot(value) {
	if (!value || typeof value !== "object") return void 0;
	const raw = value;
	const name = raw.name;
	if (typeof name !== "string") return void 0;
	const snapshot = { name };
	if (raw.attributes && typeof raw.attributes === "object" && !Array.isArray(raw.attributes)) snapshot.attributes = { ...raw.attributes };
	if (Array.isArray(raw.elements)) {
		const validElements = raw.elements.filter((el) => el != null && typeof el === "object");
		if (validElements.length > 0) snapshot.elements = validElements;
	}
	return snapshot;
}
function isShapeGroupTransform(value) {
	if (!value || typeof value !== "object") return false;
	const maybe = value;
	return isFiniteNumber(maybe.x) || isFiniteNumber(maybe.y) || isFiniteNumber(maybe.width) || isFiniteNumber(maybe.height) || isFiniteNumber(maybe.childWidth) || isFiniteNumber(maybe.childHeight) || isFiniteNumber(maybe.childX) || isFiniteNumber(maybe.childY);
}
function normalizeShapeSize(value) {
	if (!value || typeof value !== "object") return void 0;
	const maybe = value;
	const width = coerceNumber(maybe.width);
	const height = coerceNumber(maybe.height);
	if (width == null && height == null) return;
	const result = {};
	if (width != null) result.width = width;
	if (height != null) result.height = height;
	return result;
}
var LINE_END_SIZES = new Set([
	"sm",
	"med",
	"lg"
]);
var normalizeLineEnd = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const maybe = value;
	const type = typeof maybe.type === "string" ? maybe.type : void 0;
	if (!type || type === "none") return void 0;
	return {
		type,
		width: typeof maybe.width === "string" && LINE_END_SIZES.has(maybe.width) ? maybe.width : void 0,
		length: typeof maybe.length === "string" && LINE_END_SIZES.has(maybe.length) ? maybe.length : void 0
	};
};
function normalizeLineEnds(value) {
	if (!value || typeof value !== "object") return void 0;
	const maybe = value;
	const head = normalizeLineEnd(maybe.head);
	const tail = normalizeLineEnd(maybe.tail);
	if (!head && !tail) return void 0;
	return {
		head,
		tail
	};
}
function normalizeEffectExtent(value) {
	if (!value || typeof value !== "object") return void 0;
	const maybe = value;
	const left = coerceNumber(maybe.left);
	const top = coerceNumber(maybe.top);
	const right = coerceNumber(maybe.right);
	const bottom = coerceNumber(maybe.bottom);
	if (left == null && top == null && right == null && bottom == null) return;
	const clamp = (val) => val != null && val > 0 ? val : 0;
	return {
		left: clamp(left),
		top: clamp(top),
		right: clamp(right),
		bottom: clamp(bottom)
	};
}
function normalizeShapeGroupChildren(value) {
	if (!Array.isArray(value)) return [];
	return value.filter((child) => {
		if (!child || typeof child !== "object") return false;
		return typeof child.shapeType === "string";
	});
}
function normalizeMediaKey(value) {
	if (!value) return void 0;
	return value.replace(/\\/g, "/").replace(/^(\.\/|\/)+/, "");
}
function inferExtensionFromPath(value) {
	if (!value) return void 0;
	const fileName = value.split("/").pop()?.split("\\").pop();
	if (!fileName || fileName.startsWith(".")) return void 0;
	const parts = fileName.split(".");
	if (parts.length < 2) return void 0;
	const ext = parts.at(-1);
	if (!ext || ext.length === 0) return void 0;
	return ext.toLowerCase();
}
function hydrateImageBlocks(blocks, mediaFiles) {
	if (!mediaFiles || Object.keys(mediaFiles).length === 0) return blocks;
	const normalizedMedia = /* @__PURE__ */ new Map();
	Object.entries(mediaFiles).forEach(([key, value]) => {
		const normalized = normalizeMediaKey(key);
		if (normalized) {
			const stringValue = value instanceof Uint8Array ? new TextDecoder().decode(value) : value;
			normalizedMedia.set(normalized, stringValue);
		}
	});
	if (normalizedMedia.size === 0) return blocks;
	const resolveImageSrc = (src, relId, attrSrc, extension$1) => {
		if (!src || src.startsWith("data:")) return;
		const addPathCandidates = (value) => {
			if (!value) return [];
			const normalized = normalizeMediaKey(value);
			if (!normalized) return [value];
			return [
				value,
				normalized,
				normalized.startsWith("word/") ? normalized.slice(5) : normalized,
				normalized.startsWith("word/") ? normalized : `word/${normalized}`
			];
		};
		const candidates = /* @__PURE__ */ new Set();
		addPathCandidates(src).forEach((candidate) => candidates.add(candidate));
		if (attrSrc) addPathCandidates(attrSrc).forEach((candidate) => candidates.add(candidate));
		if (relId) {
			const inferredExt = extension$1 ?? inferExtensionFromPath(src) ?? "jpeg";
			candidates.add(`word/media/${relId}.${inferredExt}`);
			candidates.add(`media/${relId}.${inferredExt}`);
		}
		for (const candidate of candidates) {
			const normalized = normalizeMediaKey(candidate);
			if (!normalized) continue;
			const base64 = normalizedMedia.get(normalized);
			if (!base64) continue;
			const finalExt = extension$1 ?? inferExtensionFromPath(normalized) ?? "jpeg";
			return base64.startsWith("data:") ? base64 : `data:image/${finalExt};base64,${base64}`;
		}
	};
	const hydrateRuns = (runs) => {
		let hasChanges = false;
		const hydratedRuns = runs.map((run$1) => {
			if (run$1.kind !== "image") return run$1;
			const imageRun = run$1;
			if (!imageRun.src || imageRun.src.startsWith("data:")) return run$1;
			const resolvedSrc = resolveImageSrc(imageRun.src);
			if (resolvedSrc) {
				hasChanges = true;
				return {
					...imageRun,
					src: resolvedSrc
				};
			}
			return run$1;
		});
		return hasChanges ? hydratedRuns : runs;
	};
	return blocks.map((block) => {
		const hydrateBlock = (blk) => {
			if (blk.kind === "image") {
				if (!blk.src || blk.src.startsWith("data:")) return blk;
				const attrs = blk.attrs ?? {};
				const relId = typeof attrs.rId === "string" ? attrs.rId : void 0;
				const attrSrc = typeof attrs.src === "string" ? attrs.src : void 0;
				const extension$1 = typeof attrs.extension === "string" ? attrs.extension.toLowerCase() : void 0;
				const resolvedSrc = resolveImageSrc(blk.src, relId, attrSrc, extension$1);
				if (resolvedSrc) return {
					...blk,
					src: resolvedSrc
				};
				return blk;
			}
			if (blk.kind === "paragraph") {
				const paragraphBlock = blk;
				if (!paragraphBlock.runs || paragraphBlock.runs.length === 0) return blk;
				const hydratedRuns = hydrateRuns(paragraphBlock.runs);
				if (hydratedRuns !== paragraphBlock.runs) return {
					...paragraphBlock,
					runs: hydratedRuns
				};
				return blk;
			}
			if (blk.kind === "table") {
				let rowsChanged = false;
				const newRows = blk.rows.map((row) => {
					let cellsChanged = false;
					const newCells = row.cells.map((cell) => {
						let cellChanged = false;
						const hydratedBlocks = (cell.blocks ?? (cell.paragraph ? [cell.paragraph] : [])).map((cb) => hydrateBlock(cb));
						if (cell.blocks && hydratedBlocks !== cell.blocks) cellChanged = true;
						let hydratedParagraph = cell.paragraph;
						if (!cell.blocks && cell.paragraph && cell.paragraph.kind === "paragraph") {
							const hydratedPara = hydrateBlock(cell.paragraph);
							if (hydratedPara !== cell.paragraph) {
								hydratedParagraph = hydratedPara;
								cellChanged = true;
							}
						}
						if (cellChanged) return {
							...cell,
							blocks: hydratedBlocks.length > 0 ? hydratedBlocks : cell.blocks,
							paragraph: hydratedParagraph
						};
						return cell;
					});
					if (newCells.some((c$1, idx) => c$1 !== row.cells[idx])) cellsChanged = true;
					if (cellsChanged) {
						rowsChanged = true;
						return {
							...row,
							cells: newCells
						};
					}
					return row;
				});
				if (rowsChanged) return {
					...blk,
					rows: newRows
				};
				return blk;
			}
			if (blk.kind === "drawing") {
				const drawingBlock = blk;
				if (drawingBlock.drawingKind === "vectorShape" || drawingBlock.drawingKind === "textboxShape") {
					const parts = drawingBlock.textContent?.parts;
					if (!parts || parts.length === 0) return blk;
					let partsChanged = false;
					const hydratedParts = parts.map((part) => {
						if (part?.kind !== "image" || !part.src || part.src.startsWith("data:")) return part;
						const resolvedSrc = resolveImageSrc(part.src, part.rId, void 0, part.extension);
						if (resolvedSrc) {
							partsChanged = true;
							return {
								...part,
								src: resolvedSrc
							};
						}
						return part;
					});
					if (partsChanged) {
						const vectorShapeBlock = drawingBlock;
						return {
							...vectorShapeBlock,
							textContent: {
								...vectorShapeBlock.textContent,
								parts: hydratedParts
							}
						};
					}
					return blk;
				}
				if (drawingBlock.drawingKind !== "shapeGroup") return blk;
				const shapeGroupBlock = drawingBlock;
				if (!shapeGroupBlock.shapes || shapeGroupBlock.shapes.length === 0) return blk;
				let shapesChanged = false;
				const hydratedShapes = shapeGroupBlock.shapes.map((shape) => {
					if (shape.shapeType !== "image") return shape;
					const imageChild = shape;
					const src = imageChild.attrs?.src;
					if (!src || src.startsWith("data:")) return shape;
					const resolvedSrc = resolveImageSrc(src);
					if (resolvedSrc) {
						shapesChanged = true;
						return {
							...imageChild,
							attrs: {
								...imageChild.attrs,
								src: resolvedSrc
							}
						};
					}
					return shape;
				});
				if (shapesChanged) return {
					...shapeGroupBlock,
					shapes: hydratedShapes
				};
				return blk;
			}
			return blk;
		};
		return hydrateBlock(block);
	});
}
function isGradientFill(value) {
	if (!isPlainObject(value)) return false;
	if (value.type !== "gradient") return false;
	const gradientType = value.gradientType;
	if (gradientType !== "linear" && gradientType !== "radial") return false;
	if (gradientType === "linear") {
		if (typeof value.angle !== "number" || !Number.isFinite(value.angle)) return false;
	}
	if (!Array.isArray(value.stops) || value.stops.length === 0) return false;
	return value.stops.every((stop) => {
		if (!isPlainObject(stop)) return false;
		return typeof stop.position === "number" && Number.isFinite(stop.position) && typeof stop.color === "string" && (stop.alpha === void 0 || typeof stop.alpha === "number" && Number.isFinite(stop.alpha));
	});
}
function isSolidFillWithAlpha(value) {
	return isPlainObject(value) && value.type === "solidWithAlpha" && typeof value.color === "string" && typeof value.alpha === "number";
}
function normalizeFillColor(value) {
	if (value === null) return null;
	if (typeof value === "string") return value;
	if (isGradientFill(value)) return value;
	if (isSolidFillWithAlpha(value)) return value;
}
function normalizeStrokeColor(value) {
	if (value === null) return null;
	if (typeof value === "string") return value;
}
function normalizeTextContent(value) {
	if (!isPlainObject(value)) return void 0;
	if (!Array.isArray(value.parts)) return void 0;
	if (value.parts.length === 0) return void 0;
	const validParts = value.parts.filter((p) => isPlainObject(p) && typeof p.text === "string");
	if (validParts.length === 0) return void 0;
	const result = { parts: validParts };
	if ([
		"left",
		"center",
		"right"
	].includes(value.horizontalAlign)) result.horizontalAlign = value.horizontalAlign;
	return result;
}
function normalizeTextVerticalAlign(value) {
	if (typeof value !== "string") return void 0;
	if (value === "top" || value === "center" || value === "bottom") return value;
}
function normalizeTextInsets(value) {
	if (!isPlainObject(value)) return void 0;
	const top = pickNumber(value.top);
	const right = pickNumber(value.right);
	const bottom = pickNumber(value.bottom);
	const left = pickNumber(value.left);
	if (top == null || right == null || bottom == null || left == null) return;
	return {
		top,
		right,
		bottom,
		left
	};
}
var SequenceFieldEvaluator = class {
	constructor(options = {}) {
		this.counters = new Map(options.initialCounters ?? []);
		this.headingSerialsByLevel = /* @__PURE__ */ new Map();
		this.lastResetSerialByIdentifierLevel = /* @__PURE__ */ new Map();
	}
	enterParagraph(context = {}) {
		const level = context.paragraphHeadingLevel;
		if (!isValidHeadingLevel(level)) return;
		this.headingSerialsByLevel.set(level, (this.headingSerialsByLevel.get(level) ?? 0) + 1);
		for (let deeperLevel = level + 1; deeperLevel <= 9; deeperLevel += 1) this.headingSerialsByLevel.delete(deeperLevel);
	}
	evaluateField(field) {
		const identifier = normalizeSeqIdentifier(field?.identifier);
		const cachedText = typeof field?.cachedText === "string" ? field.cachedText : "";
		if (!identifier) return {
			value: null,
			text: cachedText,
			hidden: false
		};
		if (hasFieldArgument(field)) {
			if (cachedText) return {
				value: null,
				text: cachedText,
				hidden: false
			};
			if (!this.counters.has(identifier)) return {
				value: null,
				text: "",
				hidden: false
			};
			const value$1 = this.counters.get(identifier);
			return {
				value: value$1,
				text: formatSeqValue(value$1, field),
				hidden: false
			};
		}
		const restartLevel = normalizeRestartLevel(field?.restartLevel);
		if (restartLevel != null) {
			const key = `${identifier}|${restartLevel}`;
			const serial = this.headingSerialsByLevel.get(restartLevel) ?? 0;
			const previousSerial = this.lastResetSerialByIdentifierLevel.get(key);
			if (previousSerial === void 0 || serial !== previousSerial) {
				this.counters.set(identifier, 0);
				this.lastResetSerialByIdentifierLevel.set(key, serial);
			}
		}
		const restartNumber = normalizeRestartNumber(field?.restartNumber);
		let value;
		if (restartNumber != null) {
			this.counters.set(identifier, restartNumber);
			value = restartNumber;
		} else if (field?.sequenceMode === "current") {
			if (!this.counters.has(identifier)) return {
				value: 0,
				text: cachedText,
				hidden: false
			};
			value = this.counters.get(identifier);
		} else {
			value = (this.counters.get(identifier) ?? 0) + 1;
			this.counters.set(identifier, value);
		}
		const hidden = Boolean(field?.hideResult && !field.hasGeneralFormat && !field.numericPictureFormat);
		return {
			value,
			text: hidden ? "" : formatSeqValue(value, field),
			hidden
		};
	}
};
function isValidHeadingLevel(value) {
	return Number.isInteger(value) && value >= 1 && value <= 9;
}
function normalizeRestartLevel(value) {
	return isValidHeadingLevel(value) ? value : null;
}
function normalizeRestartNumber(value) {
	return Number.isFinite(value) && Number.isInteger(value) ? Math.trunc(value) : null;
}
function hasFieldArgument(field) {
	return typeof field?.fieldArgument === "string" && field.fieldArgument.trim().length > 0;
}
function formatSeqValue(value, field) {
	const picture = field?.numericPictureFormat?.picture;
	if (picture) return formatIntegerWithNumericPicture(value, picture);
	if (field?.pageNumberFieldFormat) return formatPageNumberFieldValue(value, field.pageNumberFieldFormat);
	return String(value);
}
function resolveSequenceFieldTokens(blocks) {
	const evaluator = new SequenceFieldEvaluator();
	for (const block of blocks) resolveBlock$1(block, evaluator);
}
function resolveBlock$1(block, evaluator) {
	if (block.kind === "paragraph") {
		resolveParagraph(block, evaluator);
		return;
	}
	if (block.kind === "table") {
		resolveTable(block, evaluator);
		return;
	}
	if (block.kind === "list") resolveList(block, evaluator);
}
function resolveParagraph(block, evaluator) {
	evaluator.enterParagraph({ paragraphHeadingLevel: block.attrs?.headingLevel });
	for (const run$1 of block.runs) resolveRun(run$1, evaluator);
}
function resolveTable(block, evaluator) {
	for (const row of block.rows) for (const cell of row.cells) {
		const childBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
		for (const childBlock of childBlocks) resolveBlock$1(childBlock, evaluator);
	}
}
function resolveList(block, evaluator) {
	for (const item of block.items) resolveParagraph(item.paragraph, evaluator);
}
function resolveRun(run$1, evaluator) {
	if ("token" in run$1 && run$1.token === "seq" && run$1.seqMetadata) run$1.text = evaluator.evaluateField(run$1.seqMetadata).text;
}
var getNodeRevision = (node) => {
	const attrs = node?.attrs;
	if (!attrs) return null;
	const raw = attrs.sdBlockRev;
	if (typeof raw === "number" && Number.isFinite(raw)) return raw;
	if (typeof raw === "string" && raw.trim() !== "") {
		const parsed = Number.parseInt(raw, 10);
		if (Number.isFinite(parsed)) return parsed;
	}
	return null;
};
var FlowBlockCache = class {
	#previous = /* @__PURE__ */ new Map();
	#next = /* @__PURE__ */ new Map();
	#hits = 0;
	#misses = 0;
	#hasExternalChanges = false;
	begin() {
		this.#next.clear();
		this.#hits = 0;
		this.#misses = 0;
	}
	setHasExternalChanges(value) {
		this.#hasExternalChanges = value;
	}
	get(id, node) {
		const nodeRev = getNodeRevision(node);
		const cached = this.#previous.get(id);
		if (!cached) {
			this.#misses++;
			return {
				entry: null,
				nodeJson: JSON.stringify(node),
				nodeRev
			};
		}
		if (nodeRev != null && cached.nodeRev != null) {
			if (cached.nodeRev !== nodeRev) {
				this.#misses++;
				return {
					entry: null,
					nodeRev
				};
			}
			if (!this.#hasExternalChanges) {
				this.#hits++;
				return {
					entry: cached,
					nodeRev,
					nodeJson: cached.nodeJson
				};
			}
		}
		const nodeJson = JSON.stringify(node);
		if (cached.nodeJson !== nodeJson) {
			this.#misses++;
			return {
				entry: null,
				nodeJson,
				nodeRev
			};
		}
		this.#hits++;
		return {
			entry: cached,
			nodeJson,
			nodeRev
		};
	}
	set(id, nodeJson, nodeRev, blocks, pmStart) {
		this.#next.set(id, {
			nodeJson,
			nodeRev,
			blocks,
			pmStart
		});
	}
	commit() {
		this.#previous = this.#next;
		this.#next = /* @__PURE__ */ new Map();
		this.#hasExternalChanges = false;
	}
	clear() {
		this.#previous.clear();
		this.#next.clear();
	}
	get stats() {
		return {
			hits: this.#hits,
			misses: this.#misses
		};
	}
};
function shiftBlockPositions(block, delta) {
	if (block.kind === "paragraph") {
		const paragraphBlock = block;
		return {
			...paragraphBlock,
			runs: paragraphBlock.runs.map((run$1) => ({
				...run$1,
				pmStart: run$1.pmStart == null ? run$1.pmStart : run$1.pmStart + delta,
				pmEnd: run$1.pmEnd == null ? run$1.pmEnd : run$1.pmEnd + delta
			}))
		};
	}
	if (block.kind === "image" || block.kind === "drawing") {
		const blockWithAttrs = block;
		if (blockWithAttrs.attrs) {
			const attrsPmStart = blockWithAttrs.attrs.pmStart;
			const attrsPmEnd = blockWithAttrs.attrs.pmEnd;
			if (typeof attrsPmStart === "number" && Number.isFinite(attrsPmStart) || typeof attrsPmEnd === "number" && Number.isFinite(attrsPmEnd)) return {
				...block,
				attrs: {
					...blockWithAttrs.attrs,
					pmStart: typeof attrsPmStart === "number" && Number.isFinite(attrsPmStart) ? attrsPmStart + delta : attrsPmStart,
					pmEnd: typeof attrsPmEnd === "number" && Number.isFinite(attrsPmEnd) ? attrsPmEnd + delta : attrsPmEnd
				}
			};
		}
	}
	const blockWithPos = block;
	if (blockWithPos.pmStart != null || blockWithPos.pmEnd != null) return {
		...block,
		pmStart: blockWithPos.pmStart == null ? blockWithPos.pmStart : blockWithPos.pmStart + delta,
		pmEnd: blockWithPos.pmEnd == null ? blockWithPos.pmEnd : blockWithPos.pmEnd + delta
	};
	return { ...block };
}
function shiftCachedBlocks(blocks, delta) {
	return blocks.map((block) => shiftBlockPositions(block, delta));
}
function getStableParagraphId(node) {
	const attrs = node.attrs;
	if (!attrs) return null;
	const id = attrs.sdBlockId ?? attrs.paraId;
	if (id == null) return null;
	return String(id);
}
var MIN_BORDER_SIZE_PX = .5;
var MAX_BORDER_SIZE_PX = 100;
const borderSizeToPx = (size) => {
	if (!isFiniteNumber(size)) return void 0;
	if (size <= 0) return 0;
	const width = eighthPointsToPixels(size);
	if (width == null) return void 0;
	return clampPixelBorderWidth(width);
};
var clampPixelBorderWidth = (width) => Math.min(MAX_BORDER_SIZE_PX, Math.max(MIN_BORDER_SIZE_PX, width));
var resolveBorderWidth = (size, unit) => {
	if (unit === "eighthPoints") return borderSizeToPx(size);
	return clampPixelBorderWidth(size);
};
var normalizeColorWithDefault = (color) => {
	if (!color || color === "auto") return "#000000";
	return color.startsWith("#") ? color : `#${color}`;
};
function convertBorderSpec(ooxmlBorder, options) {
	if (!ooxmlBorder || typeof ooxmlBorder !== "object" || ooxmlBorder === null) return;
	const border = ooxmlBorder;
	if (!(Object.keys(border).length > 0)) return void 0;
	const { val, size, color } = border;
	if (size !== void 0 && typeof size !== "number") return void 0;
	if (color !== void 0 && typeof color !== "string") return void 0;
	if (val !== void 0 && typeof val !== "string") return void 0;
	const sizeNumber = typeof size === "number" ? size : void 0;
	const colorString = typeof color === "string" ? color : void 0;
	if (val === "nil" || val === "none" || sizeNumber === 0) return {
		style: "none",
		width: 0
	};
	if (!isFiniteNumber(sizeNumber)) return void 0;
	const numericSize = sizeNumber;
	if (numericSize <= 0) return {
		style: "none",
		width: 0
	};
	const normalizedColor = normalizeColorWithDefault(colorString);
	const width = resolveBorderWidth(numericSize, options?.unit ?? "px");
	if (width == null) return void 0;
	return {
		style: val || "single",
		width,
		color: normalizedColor
	};
}
function convertTableBorderValue(ooxmlBorder, options) {
	if (!ooxmlBorder || typeof ooxmlBorder !== "object") return void 0;
	const border = ooxmlBorder;
	if (Object.keys(border).length === 0) return;
	const { val, size, color } = border;
	if (val === "nil" || val === "none" || size === 0) return { none: true };
	if (!isFiniteNumber(size)) return void 0;
	const numericSize = size;
	if (numericSize <= 0) return { none: true };
	const normalizedColor = normalizeColorWithDefault(color);
	const width = resolveBorderWidth(numericSize, options?.unit ?? "px");
	if (width == null) return void 0;
	return {
		style: val || "single",
		width,
		color: normalizedColor
	};
}
var BORDER_STYLES = new Set([
	"none",
	"single",
	"double",
	"dashed",
	"dotted",
	"thick",
	"triple",
	"dotDash",
	"dotDotDash",
	"wave",
	"doubleWave"
]);
function isBorderStyle(value) {
	return typeof value === "string" && BORDER_STYLES.has(value);
}
function isTableBorderValue(value) {
	if (value === null) return true;
	if (typeof value !== "object") return false;
	const obj = value;
	if (obj.none === true) return true;
	if ("val" in obj || "size" in obj) return false;
	return ("style" in obj || "width" in obj || "color" in obj || "space" in obj) && (!("style" in obj) || obj.style == null || isBorderStyle(obj.style));
}
function extractTableBorders(bordersInput, options) {
	if (!bordersInput || typeof bordersInput !== "object") return;
	const borders = {};
	const assignConverted = (side, raw) => {
		if (raw == null) return;
		if (isTableBorderValue(raw)) {
			borders[side] = raw;
			return;
		}
		const converted = convertTableBorderValue(raw, options);
		if (converted !== void 0) borders[side] = converted;
	};
	for (const side of [
		"top",
		"right",
		"bottom",
		"left",
		"insideH",
		"insideV"
	]) assignConverted(side, bordersInput[side]);
	if (borders.left == null) assignConverted("left", bordersInput.start);
	if (borders.right == null) assignConverted("right", bordersInput.end);
	return Object.keys(borders).length > 0 ? borders : void 0;
}
function extractCellBorders(cellAttrs, _options) {
	if (!cellAttrs?.borders) return void 0;
	const bordersData = cellAttrs.borders;
	const borders = {};
	for (const side of [
		"top",
		"right",
		"bottom",
		"left"
	]) {
		const spec = convertBorderSpec(bordersData[side]);
		if (spec) borders[side] = spec;
	}
	if (borders.left == null) {
		const spec = convertBorderSpec(bordersData.start);
		if (spec) borders.left = spec;
	}
	if (borders.right == null) {
		const spec = convertBorderSpec(bordersData.end);
		if (spec) borders.right = spec;
	}
	return Object.keys(borders).length > 0 ? borders : void 0;
}
function extractCellPadding(cellAttrs, _options) {
	const cellMargins = cellAttrs?.cellMargins;
	if (!cellMargins || typeof cellMargins !== "object") return void 0;
	const padding = {};
	const margins = cellMargins;
	if (typeof margins.top === "number") padding.top = margins.top;
	if (typeof margins.right === "number") padding.right = margins.right;
	if (typeof margins.bottom === "number") padding.bottom = margins.bottom;
	if (typeof margins.left === "number") padding.left = margins.left;
	const marginStart = margins.marginStart;
	const marginEnd = margins.marginEnd;
	if (typeof marginStart === "number" && padding.left == null) padding.left = marginStart;
	if (typeof marginEnd === "number" && padding.right == null) padding.right = marginEnd;
	if (Object.keys(padding).length === 0) return void 0;
	return normalizeCellPaddingTopBottom(padding);
}
const normalizeParagraphBorders = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const source = value;
	const sides = [
		"top",
		"right",
		"bottom",
		"left",
		"between"
	];
	const borders = {};
	sides.forEach((side) => {
		const normalized = normalizeBorderSide(source[side]);
		if (normalized) borders[side] = normalized;
	});
	if (!borders.between && source.between) {
		if (mapBorderStyle(source.between.val) === "none") borders.between = { style: "none" };
	}
	return Object.keys(borders).length > 0 ? borders : void 0;
};
const normalizeBorderSide = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const raw = value;
	const style = mapBorderStyle(raw.val);
	if (style === "none") return void 0;
	const widthPx = borderSizeToPx(pickNumber(raw.size));
	const color = normalizeColor(raw.color);
	const space = pickNumber(raw.space);
	if (!style && widthPx == null && space == null && !color) return;
	const border = {};
	if (style) border.style = style;
	if (widthPx != null) border.width = Math.max(0, widthPx);
	if (color) border.color = color;
	if (space != null) border.space = Math.max(0, space);
	return border;
};
const mapBorderStyle = (value) => {
	if (typeof value !== "string") return void 0;
	const normalized = value.toLowerCase();
	if (normalized === "nil" || normalized === "none") return "none";
	if (normalized === "double") return "double";
	if (normalized === "dashed" || normalized === "dashsmallgap" || normalized === "dashlargegap") return "dashed";
	if (normalized === "dotted" || normalized === "dot") return "dotted";
	return "solid";
};
const normalizeParagraphShading = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const source = value;
	const shading = {};
	const fill = normalizeShadingColor(source.fill);
	if (fill) shading.fill = fill;
	const color = normalizeShadingColor(source.color);
	if (color) shading.color = color;
	const val = normalizeString(source.val);
	if (val) shading.val = val;
	const themeColor = normalizeString(source.themeColor);
	if (themeColor) shading.themeColor = themeColor;
	const themeFill = normalizeString(source.themeFill);
	if (themeFill) shading.themeFill = themeFill;
	const themeFillShade = normalizeString(source.themeFillShade);
	if (themeFillShade) shading.themeFillShade = themeFillShade;
	const themeFillTint = normalizeString(source.themeFillTint);
	if (themeFillTint) shading.themeFillTint = themeFillTint;
	const themeShade = normalizeString(source.themeShade);
	if (themeShade) shading.themeShade = themeShade;
	const themeTint = normalizeString(source.themeTint);
	if (themeTint) shading.themeTint = themeTint;
	return Object.keys(shading).length > 0 ? shading : void 0;
};
const normalizeShadingColor = (value) => {
	const normalized = normalizeColor(value);
	if (!normalized) return void 0;
	if (normalized.toLowerCase() === "#auto") return;
	return normalized;
};
var normalizeString = (value) => {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	return trimmed ? trimmed : void 0;
};
var AUTO_SPACING_DEFAULT_MULTIPLIER = 1.15;
var AUTO_SPACING_LINE_DEFAULT = 240;
const normalizeAlignment = (value, isRtl = false) => {
	switch (value) {
		case "center":
		case "justify": return value;
		case "left": return isRtl ? "right" : "left";
		case "right": return isRtl ? "left" : "right";
		case "both":
		case "distribute":
		case "numTab":
		case "thaiDistribute":
		case "lowKashida":
		case "mediumKashida":
		case "highKashida": return "justify";
		case "end": return isRtl ? "left" : "right";
		case "start": return isRtl ? "right" : "left";
		default: return;
	}
};
const normalizeParagraphSpacing = (value, isList$2) => {
	if (!value || typeof value !== "object") return void 0;
	const spacing = {};
	let before = pickNumber(value.before);
	let after = pickNumber(value.after);
	const lineRaw = pickNumber(value.line);
	const lineRule = normalizeLineRule(value.lineRule);
	const beforeAutospacing = value.beforeAutospacing;
	const afterAutospacing = value.afterAutospacing;
	const { value: line, unit: lineUnit } = normalizeLineValue(lineRaw, lineRule);
	if (beforeAutospacing) if (isList$2) before = void 0;
	else before = (lineRaw ?? AUTO_SPACING_LINE_DEFAULT) * AUTO_SPACING_DEFAULT_MULTIPLIER;
	if (afterAutospacing) if (isList$2) after = void 0;
	else after = (lineRaw ?? AUTO_SPACING_LINE_DEFAULT) * AUTO_SPACING_DEFAULT_MULTIPLIER;
	if (before != null) spacing.before = twipsToPx(before);
	if (after != null) spacing.after = twipsToPx(after);
	spacing.line = line;
	spacing.lineUnit = lineUnit;
	if (lineRule != null) spacing.lineRule = lineRule;
	if (beforeAutospacing != null) spacing.beforeAutospacing = beforeAutospacing;
	if (afterAutospacing != null) spacing.afterAutospacing = afterAutospacing;
	return Object.keys(spacing).length > 0 ? spacing : void 0;
};
const normalizeLineValue = (value, lineRule) => {
	if (value == null) return {
		value: AUTO_SPACING_DEFAULT_MULTIPLIER,
		unit: "multiplier"
	};
	if (lineRule == "exact" || lineRule == "atLeast") return {
		value: twipsToPx(value),
		unit: "px"
	};
	if (lineRule === "auto") return {
		value: value * AUTO_SPACING_DEFAULT_MULTIPLIER / AUTO_SPACING_LINE_DEFAULT,
		unit: "multiplier"
	};
	return {
		value: value / AUTO_SPACING_LINE_DEFAULT,
		unit: "multiplier"
	};
};
const normalizeLineRule = (value) => {
	if (value === "auto" || value === "exact" || value === "atLeast") return value;
};
var PX_TO_TWIPS = 15;
var TWIPS_THRESHOLD = 1e3;
const normalizeOoxmlTabs = (tabs) => {
	if (!Array.isArray(tabs)) return void 0;
	const normalized = [];
	for (const entry of tabs) {
		if (!entry || typeof entry !== "object") continue;
		const rawEntry = entry;
		const isNestedTab = Boolean(rawEntry.tab && typeof rawEntry.tab === "object");
		const source = isNestedTab ? rawEntry.tab : rawEntry;
		const posTwips = resolveTabPosition(source, isNestedTab);
		if (posTwips == null) continue;
		const val = normalizeTabVal(source.val ?? source.align ?? source.alignment ?? source.type ?? source.tabType);
		if (!val) continue;
		const tab = {
			val,
			pos: posTwips
		};
		const leader = normalizeTabLeader(source.leader);
		if (leader) tab.leader = leader;
		normalized.push(tab);
	}
	return normalized.length > 0 ? normalized : void 0;
};
var resolveTabPosition = (source, treatPosAsTwips = false) => {
	const originalPos = pickNumber(source.originalPos);
	if (originalPos != null) return originalPos;
	const posValue = pickNumber(source.pos ?? source.position ?? source.offset);
	if (posValue == null) return;
	if (treatPosAsTwips) return posValue;
	if (posValue > TWIPS_THRESHOLD) return posValue;
	else return Math.round(posValue * PX_TO_TWIPS);
};
const normalizeTabVal = (value) => {
	switch (value) {
		case "start":
		case "center":
		case "end":
		case "decimal":
		case "bar":
		case "clear": return value;
		case "left":
		case "num": return "start";
		case "right": return "end";
		case "dec": return "decimal";
		default: return;
	}
};
const normalizeTabLeader = (value) => {
	switch (value) {
		case "none":
		case "dot":
		case "hyphen":
		case "heavy":
		case "underscore":
		case "middleDot": return value;
		case "thick": return "heavy";
		default: return;
	}
};
const mirrorIndentForRtl = (indent) => {
	const mirrored = {};
	let mutated = false;
	if (indent.right != null) {
		mirrored.left = indent.right;
		mutated = true;
	}
	if (indent.left != null) {
		mirrored.right = indent.left;
		mutated = true;
	}
	if (indent.firstLine != null) {
		mirrored.firstLine = -indent.firstLine;
		mutated = true;
	}
	if (indent.hanging != null) {
		mirrored.hanging = -indent.hanging;
		mutated = true;
	}
	return mutated ? mirrored : indent;
};
const FONT_FAMILY_FALLBACKS$1 = Object.freeze({
	swiss: "Arial, sans-serif",
	roman: "Times New Roman, serif",
	modern: "Courier New, monospace",
	script: "cursive",
	decorative: "fantasy",
	system: "system-ui",
	auto: "sans-serif"
});
const DEFAULT_GENERIC_FALLBACK$1 = "sans-serif";
var SERIF_LIKE_FONTS = new Set([
	"cambria",
	"cambria math",
	"times",
	"times new roman",
	"georgia",
	"garamond",
	"palatino",
	"palatino linotype",
	"book antiqua",
	"baskerville",
	"cochin",
	"hoefler text",
	"minion pro",
	"didot",
	"bodoni mt",
	"constantia"
]);
var normalizeFontNameForLookup = (fontName) => {
	if (!fontName || typeof fontName !== "string") return "";
	return fontName.trim().replace(/^["']|["']$/g, "").toLowerCase();
};
var inferGenericFallbackFromFontName = (fontName) => SERIF_LIKE_FONTS.has(normalizeFontNameForLookup(fontName)) ? "serif" : DEFAULT_GENERIC_FALLBACK$1;
var normalizeParts = (value) => (value || "").split(",").map((part) => part.trim()).filter(Boolean);
var splitOutsideQuotes = (str, delimiter) => {
	if (!str.includes("\"") && !str.includes("'")) return str.split(delimiter).map((p) => p.trim()).filter(Boolean);
	const parts = [];
	let current = "";
	let inQuote = false;
	let quoteChar = null;
	for (const char of str) if (!inQuote && (char === "\"" || char === "'")) {
		inQuote = true;
		quoteChar = char;
		current += char;
	} else if (inQuote && char === quoteChar) {
		inQuote = false;
		quoteChar = null;
		current += char;
	} else if (!inQuote && char === delimiter) {
		if (current.trim()) parts.push(current.trim());
		current = "";
	} else current += char;
	if (current.trim()) parts.push(current.trim());
	return parts;
};
function mapWordFamilyFallback(wordFamily) {
	if (!wordFamily) return DEFAULT_GENERIC_FALLBACK$1;
	return FONT_FAMILY_FALLBACKS$1[wordFamily.toLowerCase()] || "sans-serif";
}
function toCssFontFamily(fontName, options = {}) {
	if (!fontName || typeof fontName !== "string") return fontName;
	let trimmed = fontName.trim();
	if (!trimmed || trimmed.includes(",")) return trimmed;
	if (trimmed.includes(";")) trimmed = splitOutsideQuotes(trimmed, ";").join(", ");
	const { fallback, wordFamily } = options;
	const fallbackParts = normalizeParts(fallback ?? (wordFamily ? mapWordFamilyFallback(wordFamily) : void 0) ?? inferGenericFallbackFromFontName(trimmed));
	if (fallbackParts.length === 0) return trimmed;
	const normalizedName = trimmed.toLowerCase();
	if (fallbackParts.some((part) => part.toLowerCase() === normalizedName)) return fallbackParts.join(", ");
	return [trimmed, ...fallbackParts].join(", ");
}
const PIXELS_PER_TWIP = 1 / Math.round(1440 / 96);
var toFiniteNumber$1 = (value) => {
	if (value == null) return null;
	const numeric = Number(value);
	return Number.isFinite(numeric) ? numeric : null;
};
const twipsToPixels = (twips) => {
	const numeric = toFiniteNumber$1(twips);
	if (numeric == null) return 0;
	return numeric * PIXELS_PER_TWIP;
};
function computeWordParagraphLayout(input) {
	const { paragraph, markerRun, listRenderingAttrs } = input;
	const layout = {
		indentLeftPx: paragraph.indent?.left ?? 0,
		hangingPx: paragraph.indent?.hanging ?? 0,
		firstLinePx: paragraph.indent?.firstLine,
		tabsPx: paragraph.tabs?.filter((tab) => tab.val !== "clear" && tab.val !== "bar").map((tab) => twipsToPixels(tab.pos)).sort((a, b) => a - b) ?? [],
		textStartPx: paragraph.indent?.left ?? 0,
		marker: void 0,
		defaultTabIntervalPx: paragraph.tabIntervalTwips
	};
	const hasFirstLineIndent = paragraph.indent?.firstLine != null && Number.isFinite(paragraph.indent.firstLine) && paragraph.indent.firstLine > 0 && !paragraph.indent.hanging;
	let markerBoxWidthPx;
	let markerX;
	if (hasFirstLineIndent) {
		markerBoxWidthPx = 18;
		markerX = layout.indentLeftPx + (layout.firstLinePx ?? 0);
		layout.textStartPx = markerX + markerBoxWidthPx;
		layout.hangingPx = 0;
		layout.firstLineIndentMode = true;
	} else {
		if (layout.hangingPx === 0) markerBoxWidthPx = 18;
		else markerBoxWidthPx = layout.hangingPx;
		markerX = layout.indentLeftPx - markerBoxWidthPx;
		layout.hangingPx = markerBoxWidthPx;
	}
	layout.marker = {
		markerText: listRenderingAttrs.markerText,
		markerBoxWidthPx,
		markerX,
		textStartX: layout.textStartPx,
		gutterWidthPx: 8,
		justification: listRenderingAttrs.justification ?? "left",
		suffix: normalizeSuffix(listRenderingAttrs.suffix),
		run: markerRun
	};
	return layout;
}
var normalizeSuffix = (suffix) => {
	if (suffix === "tab" || suffix === "space" || suffix === "nothing") return suffix;
	return "tab";
};
const resolveTableDirection = (tableProperties, parentSection) => {
	let visualDirection;
	if (tableProperties?.rightToLeft === true || tableProperties?.bidiVisual === true) visualDirection = "rtl";
	else if (tableProperties?.rightToLeft === false || tableProperties?.bidiVisual === false) visualDirection = "ltr";
	return {
		visualDirection,
		parentSection
	};
};
var writingModeFromTextDirection = (val) => {
	switch (val) {
		case "lrTb":
		case "lrTbV":
		case "tb":
		case "tbV": return "horizontal-tb";
		case "tbRl":
		case "tbRlV":
		case "rl":
		case "rlV": return "vertical-rl";
		case "btLr":
		case "lr":
		case "lrV":
		case "tbLrV": return "vertical-lr";
		default: return;
	}
};
const resolveParagraphDirection = (paragraphProperties, parentSection, parentCell) => {
	let inlineDirection;
	if (paragraphProperties?.rightToLeft === true) inlineDirection = "rtl";
	else if (paragraphProperties?.rightToLeft === false) inlineDirection = "ltr";
	const writingMode = writingModeFromTextDirection(paragraphProperties?.textDirection) ?? parentCell?.writingMode ?? parentSection.writingMode;
	return {
		inlineDirection,
		writingMode
	};
};
const numberingDefinesMarkerFontFamily = (numberingProperties, converterContext) => {
	const numId = numberingProperties?.numId;
	if (numId == null || numId === 0 || !converterContext) return false;
	return getNumberingProperties$1("runProperties", converterContext, numberingProperties?.ilvl ?? 0, numId).fontFamily != null;
};
var DEFAULT_DECIMAL_SEPARATOR = ".";
var DEFAULT_TAB_INTERVAL_TWIPS = 720;
var BUILT_IN_HEADING_NAME_RE = /^heading\s+([1-9])$/i;
var normalizeColor$1 = (value) => {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	if (!trimmed || trimmed.toLowerCase() === "auto") return void 0;
	return `#${(trimmed.startsWith("#") ? trimmed.slice(1) : trimmed).toUpperCase()}`;
};
const deepClone = (obj) => {
	if (obj === null || typeof obj !== "object") return obj;
	if (Array.isArray(obj)) return obj.map((item) => deepClone(item));
	const clone = {};
	for (const key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) clone[key] = deepClone(obj[key]);
	return clone;
};
var normalizeIndentTwipsToPx = (indent) => {
	if (!indent) return void 0;
	const result = {};
	const toNum = (v) => {
		if (typeof v === "string" && v.trim() !== "" && isFinite(Number(v))) return Number(v);
		if (isFiniteNumber(v)) return Number(v);
	};
	const left = toNum(indent.left);
	const right = toNum(indent.right);
	const firstLine = toNum(indent.firstLine);
	const hanging = toNum(indent.hanging);
	if (left != null) result.left = twipsToPx(left);
	if (right != null) result.right = twipsToPx(right);
	if (firstLine != null) result.firstLine = twipsToPx(firstLine);
	if (hanging != null) result.hanging = twipsToPx(hanging);
	return Object.keys(result).length > 0 ? result : void 0;
};
var resolveLogicalIndentToPhysical = (indent, _direction) => {
	if (!indent) return void 0;
	const resolved = { ...indent };
	const source = indent;
	if (source.start != null) resolved.left = source.start;
	if (source.end != null) resolved.right = source.end;
	delete resolved.start;
	delete resolved.end;
	return resolved;
};
const normalizeFramePr = (value) => {
	if (!value) return void 0;
	const frame = {};
	if (value.wrap) frame.wrap = value.wrap;
	if (value.x != null) frame.x = twipsToPx(value.x);
	if (value.y != null) frame.y = twipsToPx(value.y);
	if (value.xAlign) frame.xAlign = value.xAlign;
	if (value.yAlign) frame.yAlign = value.yAlign;
	if (value.hAnchor) frame.hAnchor = value.hAnchor;
	if (value.vAnchor) frame.vAnchor = value.vAnchor;
	return Object.keys(frame).length > 0 ? frame : void 0;
};
const normalizeNumberingProperties = (value) => {
	if (value?.numId === 0) return;
	return value;
};
var normalizeHeadingLevel = (value) => {
	if (typeof value !== "number" || !Number.isInteger(value) || value < 1 || value > 9) return;
	return value;
};
var resolveHeadingLevel = (styleId, resolvedParagraphProperties, converterContext) => {
	const directOutlineLevel = resolvedParagraphProperties.outlineLvl;
	if (typeof directOutlineLevel === "number" && Number.isInteger(directOutlineLevel)) return normalizeHeadingLevel(directOutlineLevel + 1);
	const styleDefinition = styleId ? converterContext?.translatedLinkedStyles?.styles?.[styleId] : void 0;
	const styleNameLevel = typeof styleDefinition?.name === "string" ? BUILT_IN_HEADING_NAME_RE.exec(styleDefinition.name.trim()) : null;
	if (styleNameLevel?.[1]) return normalizeHeadingLevel(Number(styleNameLevel[1]));
	const styleOutlineLevel = styleDefinition?.paragraphProperties?.outlineLvl;
	if (typeof styleOutlineLevel === "number" && Number.isInteger(styleOutlineLevel)) return normalizeHeadingLevel(styleOutlineLevel + 1);
};
const resolveParagraphHeadingLevel = (paragraphProperties, converterContext) => {
	const properties = paragraphProperties ?? {};
	const resolvedParagraphProperties = converterContext ? resolveParagraphProperties(converterContext, properties, converterContext.tableInfo) : properties;
	return resolveHeadingLevel(resolvedParagraphProperties.styleId, resolvedParagraphProperties, converterContext);
};
var TRACKED_CHANGE_KEYS = new Set(["trackInsert", "trackDelete"]);
const hasExplicitParagraphRunProperties = (paragraphProperties) => {
	if (paragraphProperties?.runProperties == null) return false;
	return Object.keys(paragraphProperties.runProperties).some((key) => !TRACKED_CHANGE_KEYS.has(key));
};
var applyParagraphFontFallback = (runAttrs, previousParagraphFont) => {
	if (!previousParagraphFont) return runAttrs;
	return {
		...runAttrs,
		fontFamily: previousParagraphFont.fontFamily ?? runAttrs.fontFamily,
		fontSize: previousParagraphFont.fontSize ?? runAttrs.fontSize
	};
};
const normalizeDropCap = (framePr, para, converterContext) => {
	if (!framePr || !framePr.dropCap || framePr.dropCap === "none") return void 0;
	const dropCap = framePr.dropCap;
	const dropCapMode = typeof dropCap === "string" ? dropCap.toLowerCase() : "drop";
	const linesValue = pickNumber(framePr.lines);
	const dropCapRunInfo = extractDropCapRunFromParagraph(para, converterContext);
	if (dropCapRunInfo) {
		const descriptor = {
			mode: dropCapMode === "margin" ? "margin" : "drop",
			lines: linesValue != null && linesValue > 0 ? linesValue : 3,
			run: dropCapRunInfo
		};
		if (framePr.wrap) descriptor.wrap = framePr.wrap === "auto" ? void 0 : framePr.wrap;
		return descriptor;
	}
};
var DEFAULT_DROP_CAP_FONT_SIZE_PX = 64;
var DEFAULT_DROP_CAP_FONT_FAMILY = "Times New Roman";
var extractDropCapRunFromParagraph = (para, converterContext) => {
	const content$2 = para.content;
	if (!Array.isArray(content$2) || content$2.length === 0) return null;
	const firstRun = content$2.find((node) => node?.type === "run");
	if (!firstRun || !Array.isArray(firstRun.content)) return null;
	const textNode = firstRun.content.find((node) => node?.type === "text" && typeof node.text === "string" && node.text.length > 0);
	if (!textNode || !textNode.text) return null;
	const text$2 = textNode.text;
	const runProperties = firstRun.attrs?.runProperties ?? {};
	let resolvedRunProperties;
	if (converterContext) resolvedRunProperties = resolveRunProperties(converterContext, runProperties, {}, null, false, false);
	else resolvedRunProperties = runProperties;
	const runAttrs = computeRunAttrs(resolvedRunProperties, converterContext, DEFAULT_DROP_CAP_FONT_SIZE_PX, DEFAULT_DROP_CAP_FONT_FAMILY);
	return {
		text: text$2,
		fontFamily: runAttrs.fontFamily,
		fontSize: runAttrs.fontSize,
		bold: runAttrs.bold,
		italic: runAttrs.italic,
		color: runAttrs.color,
		position: resolvedRunProperties.position != null ? ptToPx(resolvedRunProperties.position / 2) : void 0
	};
};
const computeParagraphAttrs = (para, converterContext, previousParagraphFont) => {
	const attrs = para.attrs ?? {};
	const paragraphProperties = attrs.paragraphProperties ?? {};
	let resolvedParagraphProperties;
	if (!converterContext) resolvedParagraphProperties = paragraphProperties;
	else resolvedParagraphProperties = resolveParagraphProperties(converterContext, paragraphProperties, converterContext.tableInfo);
	const sectionContext = converterContext?.sectionDirectionContext ?? resolveSectionDirection(void 0);
	const directionContext = resolveParagraphDirection(resolvedParagraphProperties, sectionContext);
	const normalizedDirection = directionContext.inlineDirection;
	const isRtl = normalizedDirection === "rtl";
	const normalizedSpacing = normalizeParagraphSpacing(resolvedParagraphProperties.spacing, Boolean(resolvedParagraphProperties.numberingProperties));
	const normalizedIndentBase = normalizeIndentTwipsToPx(resolveLogicalIndentToPhysical(resolvedParagraphProperties.indent, normalizedDirection));
	const normalizedIndent = isRtl && normalizedIndentBase ? mirrorIndentForRtl(normalizedIndentBase) : normalizedIndentBase;
	const normalizedTabStops = normalizeOoxmlTabs(resolvedParagraphProperties.tabStops);
	const normalizedAlignment = normalizeAlignment(resolvedParagraphProperties.justification, isRtl);
	const normalizedBorders = normalizeParagraphBorders(resolvedParagraphProperties.borders);
	const normalizedShading = normalizeParagraphShading(resolvedParagraphProperties.shading);
	const paragraphDecimalSeparator = DEFAULT_DECIMAL_SEPARATOR;
	const tabIntervalTwips = DEFAULT_TAB_INTERVAL_TWIPS;
	const normalizedFramePr = normalizeFramePr(resolvedParagraphProperties.framePr);
	const floatAlignment = normalizedFramePr?.xAlign;
	const normalizedNumberingProperties = normalizeNumberingProperties(resolvedParagraphProperties.numberingProperties);
	const dropCapDescriptor = normalizeDropCap(resolvedParagraphProperties.framePr, para, converterContext);
	const normalizedListRendering = attrs.listRendering;
	const paragraphAttrs = {
		styleId: resolvedParagraphProperties.styleId,
		alignment: normalizedAlignment,
		spacing: normalizedSpacing,
		contextualSpacing: resolvedParagraphProperties.contextualSpacing,
		indent: normalizedIndent,
		dropCapDescriptor,
		frame: normalizedFramePr,
		numberingProperties: normalizedNumberingProperties,
		headingLevel: resolveHeadingLevel(resolvedParagraphProperties.styleId, resolvedParagraphProperties, converterContext),
		borders: normalizedBorders,
		shading: normalizedShading,
		tabs: normalizedTabStops,
		decimalSeparator: paragraphDecimalSeparator,
		tabIntervalTwips,
		keepNext: resolvedParagraphProperties.keepNext,
		keepLines: resolvedParagraphProperties.keepLines,
		floatAlignment,
		pageBreakBefore: resolvedParagraphProperties.pageBreakBefore,
		directionContext
	};
	const listLevelOrdinal = getListOrdinalFromPath(normalizedListRendering?.path);
	if (listLevelOrdinal != null) paragraphAttrs.listLevelOrdinal = listLevelOrdinal;
	if (resolvedParagraphProperties.runProperties?.vanish === true || paragraphProperties.runProperties?.vanish === true) paragraphAttrs.suppressParagraphBreak = true;
	if (normalizedNumberingProperties && normalizedListRendering) {
		const markerRunAttrs = computeRunAttrs(resolveRunProperties(converterContext, resolvedParagraphProperties.runProperties, resolvedParagraphProperties, converterContext.tableInfo, true, Boolean(paragraphProperties.numberingProperties)), converterContext);
		let markerFontFallback;
		if (!hasExplicitParagraphRunProperties(paragraphProperties) && previousParagraphFont) markerFontFallback = {
			fontFamily: numberingDefinesMarkerFontFamily(paragraphProperties.numberingProperties, converterContext) ? void 0 : previousParagraphFont.fontFamily,
			fontSize: previousParagraphFont.fontSize
		};
		paragraphAttrs.wordLayout = computeWordParagraphLayout({
			paragraph: paragraphAttrs,
			listRenderingAttrs: normalizedListRendering,
			markerRun: applyParagraphFontFallback(markerRunAttrs, markerFontFallback)
		});
	}
	return {
		paragraphAttrs,
		resolvedParagraphProperties
	};
};
const computeRunAttrs = (runProps, converterContext, defaultFontSizePx = 12, defaultFontFamily = "Times New Roman") => {
	let fontFamily;
	if (converterContext) fontFamily = resolveDocxFontFamily(runProps.fontFamily, converterContext.docx) || defaultFontFamily;
	else fontFamily = runProps.fontFamily?.ascii || runProps.fontFamily?.hAnsi || runProps.fontFamily?.eastAsia || defaultFontFamily;
	const vertAlign = runProps.vertAlign;
	const baselineShift = normalizeBaselineShift(runProps.position != null && Number.isFinite(runProps.position) ? runProps.position / 2 : void 0);
	const fontSize = scaleFontSizeForVerticalText(runProps.fontSize ? ptToPx(runProps.fontSize / 2) : defaultFontSizePx, {
		vertAlign,
		baselineShift
	});
	return {
		fontFamily: toCssFontFamily(fontFamily),
		fontSize,
		bold: runProps.bold,
		italic: runProps.italic,
		underline: runProps.underline && runProps.underline["w:val"] && runProps.underline["w:val"] !== "none" ? {
			style: runProps.underline["w:val"] || "single",
			color: runProps.underline["w:color"] || void 0
		} : null,
		strike: runProps.strike,
		color: normalizeColor$1(runProps.color?.val),
		highlight: runProps.highlight?.["w:val"] || void 0,
		smallCaps: runProps.smallCaps,
		allCaps: runProps?.textTransform === "uppercase",
		letterSpacing: runProps.letterSpacing ? twipsToPx(runProps.letterSpacing) : void 0,
		lang: runProps.lang?.val || void 0,
		vanish: runProps.vanish,
		vertAlign,
		baselineShift
	};
};
const VALID_LINK_TARGETS = new Set([
	"_blank",
	"_self",
	"_parent",
	"_top"
]);
const toTrimmedString = (value) => {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	return trimmed ? trimmed : void 0;
};
const toOptionalBoolean = (value) => {
	if (typeof value === "boolean") return value;
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (!normalized) return void 0;
		if (normalized === "true" || normalized === "1" || normalized === "yes" || normalized === "on") return true;
		if (normalized === "false" || normalized === "0" || normalized === "no" || normalized === "off") return false;
	}
};
const migrateLegacyLink = (link) => {
	if (link.version === 2) return link;
	return {
		version: 2,
		href: link.href,
		title: link.title
	};
};
const buildFlowRunLink = (attrs) => {
	const sanitizedHref = typeof attrs.href === "string" && attrs.href.trim() ? sanitizeHref(attrs.href) : null;
	const anchor = toTrimmedString(attrs.anchor);
	const legacyName = toTrimmedString(attrs.name);
	const docLocation = toTrimmedString(attrs.docLocation);
	const rId = toTrimmedString(attrs.rId);
	if (!sanitizedHref && !anchor && !legacyName && !docLocation && !rId) return null;
	const link = { version: 2 };
	if (sanitizedHref) link.href = sanitizedHref.href;
	const title = toTrimmedString(attrs.title);
	if (title) link.title = title;
	const tooltip = toTrimmedString(attrs.tooltip);
	if (tooltip) link.tooltip = tooltip;
	const target = toTrimmedString(attrs.target);
	if (target && VALID_LINK_TARGETS.has(target)) link.target = target;
	const rel = toTrimmedString(attrs.rel);
	if (rel) link.rel = rel;
	if (anchor) link.anchor = anchor;
	if (legacyName) link.name = legacyName;
	if (docLocation) link.docLocation = docLocation;
	if (rId) link.rId = rId;
	const history$1 = toOptionalBoolean(attrs.history);
	if (history$1 != null) link.history = history$1;
	return link;
};
const parseThemePercentage = (value) => {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	if (!trimmed) return void 0;
	const parsed = Number.parseInt(trimmed, 16);
	if (Number.isNaN(parsed)) return void 0;
	return Math.max(0, Math.min(parsed / 255, 1));
};
var expandHex$1 = (hex) => {
	const normalized = hex.replace("#", "");
	if (normalized.length === 3) return normalized.split("").map((char) => char + char).join("");
	return normalized;
};
var hexToRgb$1 = (hex) => {
	const cleaned = expandHex$1(hex);
	if (cleaned.length !== 6) return null;
	const r = Number.parseInt(cleaned.slice(0, 2), 16);
	const g = Number.parseInt(cleaned.slice(2, 4), 16);
	const b = Number.parseInt(cleaned.slice(4, 6), 16);
	if ([
		r,
		g,
		b
	].some((channel) => Number.isNaN(channel))) return null;
	return {
		r,
		g,
		b
	};
};
var rgbToHex = (value) => {
	const toHex = (channel) => {
		return Math.max(0, Math.min(255, channel)).toString(16).padStart(2, "0").toUpperCase();
	};
	return `#${toHex(value.r)}${toHex(value.g)}${toHex(value.b)}`;
};
const applyThemeTint = (baseHex, ratio) => {
	const rgb = hexToRgb$1(baseHex);
	if (!rgb) return baseHex;
	return rgbToHex({
		r: Math.round(rgb.r + (255 - rgb.r) * ratio),
		g: Math.round(rgb.g + (255 - rgb.g) * ratio),
		b: Math.round(rgb.b + (255 - rgb.b) * ratio)
	});
};
const applyThemeShade = (baseHex, ratio) => {
	const rgb = hexToRgb$1(baseHex);
	if (!rgb) return baseHex;
	return rgbToHex({
		r: Math.round(rgb.r * ratio),
		g: Math.round(rgb.g * ratio),
		b: Math.round(rgb.b * ratio)
	});
};
const resolveThemeColorValue = (themeKey, tint, shade, themeColors) => {
	const key = themeKey.trim();
	if (!key) return void 0;
	const base$1 = themeColors[key];
	if (!base$1) return void 0;
	let computed = base$1;
	const tintRatio = parseThemePercentage(tint);
	const shadeRatio = parseThemePercentage(shade);
	if (tintRatio != null) computed = applyThemeTint(computed, tintRatio);
	if (shadeRatio != null) computed = applyThemeShade(computed, shadeRatio);
	return computed;
};
const TRACK_INSERT_MARK = "trackInsert";
const TRACK_DELETE_MARK = "trackDelete";
const TRACK_FORMAT_MARK = "trackFormat";
var TRACK_CHANGE_KIND_MAP = {
	[TRACK_INSERT_MARK]: "insert",
	[TRACK_DELETE_MARK]: "delete",
	[TRACK_FORMAT_MARK]: "format"
};
var MAX_RUN_MARK_JSON_LENGTH = 1e4;
var MAX_RUN_MARK_ARRAY_LENGTH = 100;
var MAX_RUN_MARK_DEPTH = 5;
var RANDOM_ID_LENGTH = 9;
var generateRandomBase36Id = (length) => {
	let randomId = "";
	while (randomId.length < length) randomId += Math.random().toString(36).slice(2);
	return randomId.slice(0, length);
};
var validateDepth = (obj, currentDepth = 0) => {
	if (currentDepth > MAX_RUN_MARK_DEPTH) return false;
	if (obj && typeof obj === "object") {
		const values = Array.isArray(obj) ? obj : Object.values(obj);
		for (const value of values) if (!validateDepth(value, currentDepth + 1)) return false;
	}
	return true;
};
var expandHex = (hex) => {
	const normalized = hex.replace("#", "");
	if (normalized.length === 3) return normalized.split("").map((char) => char + char).join("");
	return normalized;
};
var hexToRgb = (hex) => {
	const cleaned = expandHex(hex);
	if (cleaned.length !== 6) return null;
	const r = Number.parseInt(cleaned.slice(0, 2), 16);
	const g = Number.parseInt(cleaned.slice(2, 4), 16);
	const b = Number.parseInt(cleaned.slice(4, 6), 16);
	if ([
		r,
		g,
		b
	].some((channel) => Number.isNaN(channel))) return null;
	return {
		r,
		g,
		b
	};
};
const getLuminance = (hexColor) => {
	const rgb = hexToRgb(hexColor);
	if (!rgb) return 1;
	const toLinear = (channel) => {
		const c$1 = channel / 255;
		return c$1 <= .03928 ? c$1 / 12.92 : Math.pow((c$1 + .055) / 1.055, 2.4);
	};
	const R = toLinear(rgb.r);
	const G = toLinear(rgb.g);
	const B = toLinear(rgb.b);
	return .2126 * R + .7152 * G + .0722 * B;
};
var WCAG_AA_LUMINANCE_THRESHOLD = .18;
const resolveAutoColor = (backgroundColor) => {
	return getLuminance(backgroundColor) < WCAG_AA_LUMINANCE_THRESHOLD ? "#FFFFFF" : "#000000";
};
var resolveThemeColor = (attrs, themeColors) => {
	if (!attrs || !themeColors) return void 0;
	const rawKey = attrs.themeColor;
	if (typeof rawKey !== "string") return void 0;
	return resolveThemeColorValue(rawKey, attrs.themeTint, attrs.themeShade, themeColors);
};
var resolveColorFromAttributes = (attrs, themeColors) => {
	if (!attrs) return void 0;
	if (typeof attrs.color === "string") {
		const normalized = normalizeColor(attrs.color);
		if (normalized) return normalized;
	}
	const theme = resolveThemeColor(attrs, themeColors);
	if (theme) return normalizeColor(theme);
};
var MAX_DATA_ATTR_COUNT = 50;
var MAX_DATA_ATTR_VALUE_LENGTH = 1e3;
var MAX_DATA_ATTR_NAME_LENGTH = 100;
var pushCommentAnnotation = (run$1, attrs) => {
	const commentId = typeof attrs?.commentId === "string" ? attrs.commentId : void 0;
	const importedId = typeof attrs?.importedId === "string" ? attrs.importedId : void 0;
	const internal = attrs?.internal === true;
	const trackedChange = attrs?.trackedChange === true;
	if (!commentId && !importedId) return;
	const annotations = run$1.comments ? [...run$1.comments] : [];
	const key = `${commentId ?? ""}::${importedId ?? ""}`;
	if (!annotations.some((c$1) => `${c$1.commentId ?? ""}::${c$1.importedId ?? ""}` === key)) annotations.push({
		commentId: commentId ?? importedId,
		importedId,
		internal,
		trackedChange
	});
	run$1.comments = annotations;
};
const extractDataAttributes = (attrs) => {
	if (!attrs) return void 0;
	const result = {};
	let attrCount = 0;
	for (const [key, value] of Object.entries(attrs)) {
		if (typeof key !== "string" || !key.toLowerCase().startsWith("data-")) continue;
		if (attrCount >= MAX_DATA_ATTR_COUNT) {
			if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting data attributes exceeding ${MAX_DATA_ATTR_COUNT} limit`);
			break;
		}
		if (key.length > MAX_DATA_ATTR_NAME_LENGTH) {
			if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting data attribute name exceeding ${MAX_DATA_ATTR_NAME_LENGTH} chars: ${key.substring(0, 50)}...`);
			continue;
		}
		if (value == null) continue;
		if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
			const stringValue = String(value);
			if (stringValue.length > MAX_DATA_ATTR_VALUE_LENGTH) {
				if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting data attribute value exceeding ${MAX_DATA_ATTR_VALUE_LENGTH} chars for key: ${key}`);
				continue;
			}
			result[key] = stringValue;
			attrCount++;
		}
	}
	return Object.keys(result).length > 0 ? result : void 0;
};
const normalizeRunMarkList = (value) => {
	if (!value) return void 0;
	let entries = value;
	if (typeof value === "string") {
		if (value.length > MAX_RUN_MARK_JSON_LENGTH) {
			if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting run mark JSON payload exceeding ${MAX_RUN_MARK_JSON_LENGTH} chars`);
			return;
		}
		try {
			entries = JSON.parse(value);
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Failed to parse run mark JSON:", error);
			return;
		}
	}
	if (!Array.isArray(entries)) return;
	if (entries.length > MAX_RUN_MARK_ARRAY_LENGTH) {
		if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting run mark array exceeding ${MAX_RUN_MARK_ARRAY_LENGTH} entries`);
		return;
	}
	if (!validateDepth(entries)) {
		if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Rejecting run mark array exceeding depth ${MAX_RUN_MARK_DEPTH}`);
		return;
	}
	const normalized = entries.map((entry) => {
		if (!entry || typeof entry !== "object") return null;
		const record = entry;
		const type = typeof record.type === "string" ? record.type : void 0;
		if (!type) return null;
		return {
			type,
			attrs: record.attrs && typeof record.attrs === "object" ? record.attrs : void 0
		};
	}).filter(Boolean);
	return normalized.length ? normalized : void 0;
};
const pickTrackedChangeKind = (markType) => {
	return TRACK_CHANGE_KIND_MAP[markType];
};
var deriveTrackedChangeId$2 = (kind, attrs) => {
	if (attrs && typeof attrs.id === "string" && attrs.id.trim()) return attrs.id;
	return `${kind}-${attrs && typeof attrs.authorEmail === "string" ? attrs.authorEmail : "unknown"}-${attrs && typeof attrs.date === "string" ? attrs.date : "unknown"}-${`${Date.now()}-${generateRandomBase36Id(RANDOM_ID_LENGTH)}`}`;
};
const buildTrackedChangeMetaFromMark = (mark, storyKey) => {
	const kind = pickTrackedChangeKind(mark.type);
	if (!kind) return void 0;
	const attrs = mark.attrs ?? {};
	const meta = {
		kind,
		id: deriveTrackedChangeId$2(kind, attrs)
	};
	if (typeof attrs.overlapParentId === "string" && attrs.overlapParentId) {
		meta.overlapParentId = attrs.overlapParentId;
		meta.relationship = "child";
	}
	if (typeof attrs.author === "string" && attrs.author) meta.author = attrs.author;
	if (typeof attrs.authorEmail === "string" && attrs.authorEmail) meta.authorEmail = attrs.authorEmail;
	if (typeof attrs.authorImage === "string" && attrs.authorImage) meta.authorImage = attrs.authorImage;
	if (typeof attrs.date === "string" && attrs.date) meta.date = attrs.date;
	if (kind === "format") {
		meta.before = normalizeRunMarkList(attrs.before);
		meta.after = normalizeRunMarkList(attrs.after);
	}
	if (typeof storyKey === "string" && storyKey.length > 0) meta.storyKey = storyKey;
	return meta;
};
var trackedChangeLayerKey = (meta) => `${meta.kind}:${meta.id}`;
var trackedChangeLayerIdentity = (meta) => [
	meta.kind,
	meta.id,
	meta.overlapParentId ?? ""
].join(":");
var compareTrackedChangeLayerStrings = (a, b) => {
	if (a < b) return -1;
	if (a > b) return 1;
	return 0;
};
var trackedChangeContentRank = (meta) => meta.kind === "format" ? 1 : 0;
var trackedChangeRelationshipRank = (meta) => {
	if (meta.relationship === "parent") return 0;
	if (meta.relationship === "child") return 2;
	return 1;
};
var compareTrackedChangeLayers = (a, b) => {
	const aIsParentOfB = a.id === b.overlapParentId;
	const bIsParentOfA = b.id === a.overlapParentId;
	if (aIsParentOfB && !bIsParentOfA) return -1;
	if (bIsParentOfA && !aIsParentOfB) return 1;
	const contentRank = trackedChangeContentRank(a) - trackedChangeContentRank(b);
	if (contentRank !== 0) return contentRank;
	const relationshipRank = trackedChangeRelationshipRank(a) - trackedChangeRelationshipRank(b);
	if (relationshipRank !== 0) return relationshipRank;
	const idOrder = compareTrackedChangeLayerStrings(a.id, b.id);
	if (idOrder !== 0) return idOrder;
	const kindOrder = compareTrackedChangeLayerStrings(a.kind, b.kind);
	if (kindOrder !== 0) return kindOrder;
	const parentOrder = compareTrackedChangeLayerStrings(a.overlapParentId ?? "", b.overlapParentId ?? "");
	if (parentOrder !== 0) return parentOrder;
	return compareTrackedChangeLayerStrings(a.storyKey ?? "", b.storyKey ?? "");
};
var normalizeTrackedChangeLayerList = (layers) => {
	if (layers.length === 0) return [];
	const uniqueLayers = /* @__PURE__ */ new Map();
	layers.forEach((layer) => {
		const key = trackedChangeLayerKey(layer);
		if (!uniqueLayers.has(key)) uniqueLayers.set(key, { ...layer });
	});
	const parentIds = /* @__PURE__ */ new Set();
	uniqueLayers.forEach((layer) => {
		if (layer.overlapParentId) parentIds.add(layer.overlapParentId);
	});
	return Array.from(uniqueLayers.values()).map((layer) => {
		const normalized = { ...layer };
		if (normalized.overlapParentId) normalized.relationship = "child";
		else if (parentIds.has(normalized.id)) normalized.relationship = "parent";
		else delete normalized.relationship;
		return normalized;
	}).sort(compareTrackedChangeLayers);
};
var normalizeTrackedChangeLayers = (run$1) => {
	if (Array.isArray(run$1.trackedChanges) && run$1.trackedChanges.length > 0) return normalizeTrackedChangeLayerList(run$1.trackedChanges);
	return run$1.trackedChange ? normalizeTrackedChangeLayerList([run$1.trackedChange]) : [];
};
var appendTrackedChangeLayer = (run$1, meta) => {
	const layers = normalizeTrackedChangeLayers(run$1);
	const key = trackedChangeLayerKey(meta);
	if (!layers.some((layer) => trackedChangeLayerKey(layer) === key)) layers.push(meta);
	const normalizedLayers = normalizeTrackedChangeLayerList(layers);
	run$1.trackedChanges = normalizedLayers;
	run$1.trackedChange = normalizedLayers[0];
};
const trackedChangesCompatible = (a, b) => {
	const aLayers = normalizeTrackedChangeLayers(a);
	const bLayers = normalizeTrackedChangeLayers(b);
	if (aLayers.length !== bLayers.length) return false;
	return aLayers.every((aMeta, index) => {
		const bMeta = bLayers[index];
		return Boolean(bMeta && trackedChangeLayerIdentity(aMeta) === trackedChangeLayerIdentity(bMeta));
	});
};
const collectTrackedChangesFromMarks = (marks, storyKey) => {
	if (!marks || !marks.length) return [];
	const seen = /* @__PURE__ */ new Set();
	const trackedChanges = [];
	marks.forEach((mark) => {
		const meta = buildTrackedChangeMetaFromMark(mark, storyKey);
		if (!meta) return;
		const key = trackedChangeLayerKey(meta);
		if (seen.has(key)) return;
		seen.add(key);
		trackedChanges.push(meta);
	});
	return normalizeTrackedChangeLayerList(trackedChanges);
};
const collectTrackedChangeFromMarks = (marks, storyKey) => {
	return collectTrackedChangesFromMarks(marks, storyKey)[0];
};
const normalizeUnderlineStyle = (value) => {
	if (value === "none") return;
	if (value === void 0 || value === null) return "single";
	if (typeof value === "boolean") return value ? "single" : void 0;
	if (typeof value === "number") return value === 0 ? void 0 : "single";
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (!normalized) return "single";
		if (normalized === "none" || normalized === "0" || normalized === "false" || normalized === "off") return;
		if (normalized === "double" || normalized === "dotted" || normalized === "dashed" || normalized === "wavy") return normalized;
		return "single";
	}
	return "single";
};
var normalizeBooleanMarkValue = (value) => {
	if (value === void 0 || value === null) return;
	if (typeof value === "boolean") return value;
	if (typeof value === "number") return value !== 0;
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (normalized === "0" || normalized === "false" || normalized === "off" || normalized === "none") return false;
		if (normalized === "1" || normalized === "true" || normalized === "on") return true;
	}
	return Boolean(value);
};
var MAX_FONT_FAMILY_LENGTH = 200;
var sanitizeFontFamily = (fontFamily) => {
	if (!fontFamily || typeof fontFamily !== "string") return;
	let sanitized = fontFamily.trim();
	if (sanitized.length > MAX_FONT_FAMILY_LENGTH) {
		if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Font family name exceeds ${MAX_FONT_FAMILY_LENGTH} character limit`);
		return;
	}
	const lowerCased = sanitized.toLowerCase();
	if ([
		"javascript:",
		"data:",
		"vbscript:"
	].some((scheme) => lowerCased.includes(scheme))) {
		if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Rejected font family containing dangerous URI scheme");
		return;
	}
	sanitized = sanitized.replace(/["']/g, "");
	if (/[;{}()@<>]/.test(sanitized)) {
		if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Rejected font family containing CSS injection characters");
		return;
	}
	sanitized = sanitized.replace(/[\r\n\t\f\v]/g, " ");
	sanitized = sanitized.replace(/\s+/g, " ").trim();
	if (!sanitized) return;
	return sanitized;
};
var normalizeLengthPx = (value) => {
	if (isFiniteNumber(value)) return value;
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	if (!trimmed) return void 0;
	const numeric = Number.parseFloat(trimmed);
	if (!Number.isFinite(numeric)) return void 0;
	if (trimmed.match(/[a-zA-Z%]+$/)?.[0]?.toLowerCase() === "pt") return ptToPx(numeric);
	return numeric;
};
const applyTextStyleMark = (run$1, attrs, themeColors) => {
	const resolvedColor = resolveColorFromAttributes(attrs, themeColors);
	if (resolvedColor) run$1.color = resolvedColor;
	if (typeof attrs.fontFamily === "string" && attrs.fontFamily.trim()) {
		const sanitized = sanitizeFontFamily(attrs.fontFamily);
		if (sanitized) run$1.fontFamily = sanitized;
	}
	const fontSizePx = normalizeLengthPx(attrs.fontSize);
	if (fontSizePx !== void 0 && fontSizePx >= 1 && fontSizePx <= 1e3) run$1.fontSize = fontSizePx;
	else if (attrs.fontSize !== void 0) {}
	const letterSpacingPx = normalizeLengthPx(attrs.letterSpacing);
	if (letterSpacingPx !== void 0) {
		if (letterSpacingPx >= -100 && letterSpacingPx <= 100) run$1.letterSpacing = letterSpacingPx;
	}
	if (typeof attrs.textTransform === "string") {
		const transform = attrs.textTransform;
		if (transform === "uppercase" || transform === "lowercase" || transform === "capitalize" || transform === "none") run$1.textTransform = transform;
	}
	if (typeof attrs.vertAlign === "string") {
		const va = attrs.vertAlign;
		if (va === "superscript" || va === "subscript" || va === "baseline") run$1.vertAlign = va;
	}
	if (attrs.position != null && typeof attrs.position === "string") {
		const parsed = parseFloat(attrs.position);
		if (Number.isFinite(parsed)) {
			const normalizedBaselineShift = normalizeBaselineShift(parsed);
			if (normalizedBaselineShift == null) delete run$1.baselineShift;
			else run$1.baselineShift = normalizedBaselineShift;
		}
	}
	run$1.fontSize = scaleFontSizeForVerticalText(run$1.fontSize, run$1);
};
var DEFAULT_HYPERLINK_CONFIG$1 = { enableRichHyperlinks: false };
const applyMarksToRun = (run$1, marks, hyperlinkConfig = DEFAULT_HYPERLINK_CONFIG$1, themeColors, backgroundColor, enableComments = true, storyKey) => {
	if (!enableComments && "comments" in run$1 && run$1.comments) delete run$1.comments;
	const isTabRun = run$1.kind === "tab";
	let markSetColor = false;
	marks.forEach((mark) => {
		const forwardedDataAttrs = extractDataAttributes(mark.attrs);
		try {
			switch (mark.type) {
				case TRACK_INSERT_MARK:
				case TRACK_DELETE_MARK:
				case TRACK_FORMAT_MARK:
					if (!isTabRun) {
						const tracked = buildTrackedChangeMetaFromMark(mark, storyKey);
						if (tracked) appendTrackedChangeLayer(run$1, tracked);
					}
					break;
				case "bold":
					if (normalizeBooleanMarkValue(mark.attrs?.value) === false) delete run$1.bold;
					else run$1.bold = true;
					break;
				case "italic":
					if (normalizeBooleanMarkValue(mark.attrs?.value) === false) delete run$1.italic;
					else run$1.italic = true;
					break;
				case "textStyle":
					if (!isTabRun) {
						const colorBefore = run$1.color;
						applyTextStyleMark(run$1, mark.attrs ?? {}, themeColors);
						if (run$1.color !== colorBefore && run$1.color !== void 0) markSetColor = true;
					}
					break;
				case "commentMark":
				case "comment":
					if (!isTabRun && enableComments) pushCommentAnnotation(run$1, mark.attrs ?? {});
					break;
				case "underline": {
					const underlineValue = mark.attrs?.underlineType ?? mark.attrs?.value ?? mark.attrs?.underline ?? mark.attrs?.style;
					const style = normalizeUnderlineStyle(underlineValue);
					if (style) run$1.underline = {
						style,
						color: resolveColorFromAttributes(mark.attrs ?? {}, themeColors) ?? run$1.underline?.color
					};
					else if (underlineValue !== void 0 && underlineValue !== null) delete run$1.underline;
					break;
				}
				case "strike":
					if (normalizeBooleanMarkValue(mark.attrs?.value) === false) delete run$1.strike;
					else run$1.strike = true;
					break;
				case "highlight":
					run$1.highlight = resolveColorFromAttributes(mark.attrs ?? {}, themeColors);
					break;
				case "link":
					if (!isTabRun) {
						const attrs = mark.attrs ?? {};
						if (hyperlinkConfig.enableRichHyperlinks) try {
							const link = buildFlowRunLink(attrs);
							if (link) run$1.link = link;
						} catch (error) {
							if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Failed to build rich hyperlink:", error);
						}
						else if (typeof attrs.href === "string" && attrs.href.trim()) try {
							const sanitized = sanitizeHref(attrs.href);
							if (sanitized && sanitized.href) run$1.link = migrateLegacyLink({
								href: sanitized.href,
								title: typeof attrs.title === "string" ? attrs.title : void 0
							});
						} catch (error) {
							if (process$1.env.NODE_ENV === "development") console.warn("[PM-Adapter] Failed to sanitize link href:", error);
						}
					}
					break;
				default: break;
			}
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn(`[PM-Adapter] Failed to apply mark ${mark.type}:`, error);
		}
		if (forwardedDataAttrs && !isTabRun) run$1.dataAttrs = {
			...run$1.dataAttrs ?? {},
			...forwardedDataAttrs
		};
	});
	if (!isTabRun && !markSetColor && backgroundColor) {
		const normalizedExisting = normalizeColor(run$1.color);
		const normalizedUpper = normalizedExisting?.toUpperCase();
		const isDefaultBlack = normalizedUpper === "#000000" || normalizedUpper === "#000";
		const isAutoColorValue = typeof run$1.color === "string" && ["auto", "none"].includes(run$1.color.trim().replace(/^#/, "").toLowerCase());
		if (!normalizedExisting || isAutoColorValue || isDefaultBlack) run$1.color = resolveAutoColor(backgroundColor);
	}
};
var HiddenByVanishError = class extends Error {
	constructor() {
		super("Node is hidden by vanish property");
		this.name = "HiddenByVanishError";
	}
};
var NotInlineNodeError = class extends Error {
	constructor() {
		super("Node is not an inline node");
		this.name = "NotInlineNodeError";
	}
};
var buildBidiContext = (runProperties) => {
	if (runProperties.rtl == null) return void 0;
	return { rtl: runProperties.rtl === true };
};
var buildScriptContext = (runProperties) => {
	const cs = runProperties.cs;
	const lang = runProperties.lang;
	const hasLang = lang != null && (lang.val != null || lang.bidi != null || lang.eastAsia != null);
	if (cs == null && !hasLang) return void 0;
	const ctx = {};
	if (cs != null) ctx.complexScript = cs === true;
	if (hasLang) {
		const language = {};
		if (lang.val != null) language.default = lang.val;
		if (lang.bidi != null) language.complexScript = lang.bidi;
		if (lang.eastAsia != null) language.eastAsian = lang.eastAsia;
		ctx.language = language;
	}
	return ctx;
};
const applyInlineRunProperties = (run$1, runProperties, converterContext, inlineRunProperties) => {
	if (!runProperties) return run$1;
	const runAttrs = computeRunAttrs(runProperties, converterContext);
	const merged = { ...run$1 };
	for (const key of Object.keys(runAttrs)) if (runAttrs[key] !== void 0) merged[key] = runAttrs[key];
	if (inlineRunProperties) {
		const bidi = buildBidiContext(inlineRunProperties);
		if (bidi) merged.bidi = bidi;
		const script = buildScriptContext(inlineRunProperties);
		if (script) merged.script = script;
	}
	return merged;
};
function getPageNumberFieldFormat(attrs) {
	if (!attrs) return void 0;
	const format = typeof attrs.pageNumberFormat === "string" ? attrs.pageNumberFormat : void 0;
	const zeroPadding = typeof attrs.pageNumberZeroPadding === "number" && Number.isFinite(attrs.pageNumberZeroPadding) ? attrs.pageNumberZeroPadding : void 0;
	const numericPicture = typeof attrs.pageNumberNumericPicture === "string" && attrs.pageNumberNumericPicture.length > 0 ? attrs.pageNumberNumericPicture : void 0;
	if (!format && !zeroPadding && !numericPicture) return void 0;
	return {
		...format ? { format } : {},
		...zeroPadding != null ? { zeroPadding } : {},
		...numericPicture ? { numericPicture } : {}
	};
}
function textNodeToRun({ node, positions, storyKey, defaultFont, defaultSize, inheritedMarks = [], sdtMetadata, hyperlinkConfig = DEFAULT_HYPERLINK_CONFIG, themeColors, enableComments, runProperties, inlineRunProperties, converterContext }) {
	let run$1 = {
		text: node.text || "",
		fontFamily: defaultFont,
		fontSize: defaultSize
	};
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	applyMarksToRun(run$1, [...node.marks ?? [], ...inheritedMarks ?? []], hyperlinkConfig, themeColors, converterContext?.backgroundColor, enableComments, storyKey);
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	run$1 = applyInlineRunProperties(run$1, runProperties, converterContext, inlineRunProperties);
	return run$1;
}
var isTextRun$1 = (run$1) => "text" in run$1;
var pickFontPartial = (fontFamily, fontSize) => {
	const partial = {};
	if (typeof fontFamily === "string" && fontFamily.trim().length > 0) partial.fontFamily = fontFamily.trim();
	if (typeof fontSize === "number" && Number.isFinite(fontSize) && fontSize > 0) partial.fontSize = fontSize;
	return Object.keys(partial).length > 0 ? partial : void 0;
};
var getFontFromRuns = (runs) => {
	for (const run$1 of runs) {
		if (!isTextRun$1(run$1)) continue;
		if (typeof run$1.text === "string" && run$1.text.length === 0) continue;
		const partial = pickFontPartial(run$1.fontFamily, run$1.fontSize);
		if (partial) return partial;
	}
};
var getFontFromTextStyleMark = (attrs) => {
	const probe = {
		text: "",
		fontFamily: "",
		fontSize: 0
	};
	applyTextStyleMark(probe, attrs);
	return pickFontPartial(probe.fontFamily, probe.fontSize);
};
var getFontFromParagraphContent = (node) => {
	let found$1;
	const visit = (current) => {
		if (found$1 || current == null || typeof current !== "object") return;
		const candidate = current;
		if ((candidate.isText === true || typeof candidate.text === "string") && candidate.marks?.length) for (const mark of candidate.marks) {
			if ((typeof mark.type === "string" ? mark.type : mark.type?.name) !== "textStyle") continue;
			const partial = getFontFromTextStyleMark(mark.attrs ?? {});
			if (partial) {
				found$1 = partial;
				return;
			}
		}
		candidate.content?.forEach?.(visit);
	};
	visit(node);
	return found$1;
};
var resolveContentFont = (block, para, source, previousParagraphFont) => {
	const fromRuns = getFontFromRuns(block.runs);
	const fromPara = para ? getFontFromParagraphContent(para) : void 0;
	if (source === "paragraph") {
		if (fromPara) return fromPara;
		return fromRuns ?? previousParagraphFont;
	}
	return fromRuns ?? fromPara;
};
const syncListMarkerFontFromParagraphRuns = ({ block, converterContext, para, contentFontSource = "runs", previousParagraphFont }) => {
	const markerRun = block.attrs?.wordLayout?.marker?.run;
	if (!markerRun) return;
	const contentFont = resolveContentFont(block, para, contentFontSource, previousParagraphFont);
	if (!contentFont) return;
	const paragraphProperties = para?.attrs?.paragraphProperties != null && typeof para.attrs.paragraphProperties === "object" ? para.attrs.paragraphProperties : void 0;
	const hasLiveTextStyleFont = para ? getFontFromParagraphContent(para) != null : false;
	const allowBodyFontSync = !hasExplicitParagraphRunProperties(paragraphProperties) || hasLiveTextStyleFont;
	if (contentFontSource === "paragraph") {
		const firstRun = block.runs[0];
		if (firstRun && isTextRun$1(firstRun) && firstRun.text.length === 0) {
			if (contentFont.fontFamily) firstRun.fontFamily = contentFont.fontFamily;
			if (contentFont.fontSize) firstRun.fontSize = contentFont.fontSize;
		}
	}
	const preserveNumberingFontFamily = numberingDefinesMarkerFontFamily(block.attrs?.numberingProperties, converterContext);
	if (allowBodyFontSync && !preserveNumberingFontFamily && contentFont.fontFamily) markerRun.fontFamily = contentFont.fontFamily;
	if (allowBodyFontSync && contentFont.fontSize) markerRun.fontSize = contentFont.fontSize;
};
var buildSyntheticTextNode = (displayText, marks) => ({
	type: "text",
	text: displayText,
	marks: [...marks ?? []]
});
var isTextStyleMark = (mark) => mark.type === "textStyle";
var stripVerticalPositioningFromMark = (mark) => {
	if (!isTextStyleMark(mark) || !mark.attrs) return mark;
	const sanitizedAttrs = { ...mark.attrs };
	delete sanitizedAttrs.vertAlign;
	delete sanitizedAttrs.position;
	if (Object.keys(sanitizedAttrs).length === 0) return null;
	return {
		...mark,
		attrs: sanitizedAttrs
	};
};
var stripVerticalPositioningFromMarks = (marks) => (marks ?? []).flatMap((mark) => {
	const sanitizedMark = stripVerticalPositioningFromMark(mark);
	return sanitizedMark ? [sanitizedMark] : [];
});
var stripVerticalPositioningFromRunProperties = (runProperties) => {
	if (!runProperties) return;
	const sanitizedRunProperties = { ...runProperties };
	delete sanitizedRunProperties.vertAlign;
	delete sanitizedRunProperties.position;
	return sanitizedRunProperties;
};
var copyReferencePmPositions = (run$1, params) => {
	const refPos = params.positions.get(params.node);
	if (!refPos) return run$1;
	return {
		...run$1,
		pmStart: refPos.start,
		pmEnd: refPos.end
	};
};
var resolveReferenceBaseFontSize = (runWithoutVerticalPositioning, originalRun, fallbackFontSize) => {
	if (typeof runWithoutVerticalPositioning.fontSize === "number" && Number.isFinite(runWithoutVerticalPositioning.fontSize)) return runWithoutVerticalPositioning.fontSize;
	if (typeof originalRun.fontSize === "number" && Number.isFinite(originalRun.fontSize)) return originalRun.fontSize;
	return fallbackFontSize;
};
var buildOriginalReferenceRun = (displayText, params) => textNodeToRun({
	...params,
	node: buildSyntheticTextNode(displayText, params.node.marks)
});
var buildReferenceRunWithoutVerticalPositioning = (displayText, params) => textNodeToRun({
	...params,
	inheritedMarks: stripVerticalPositioningFromMarks(params.inheritedMarks),
	runProperties: stripVerticalPositioningFromRunProperties(params.runProperties),
	node: buildSyntheticTextNode(displayText, stripVerticalPositioningFromMarks(params.node.marks))
});
function buildReferenceMarkerRun(displayText, params) {
	const originalRun = buildOriginalReferenceRun(displayText, params);
	if (hasExplicitBaselineShift(originalRun.baselineShift)) return copyReferencePmPositions(originalRun, params);
	const baseFontSize = resolveReferenceBaseFontSize(buildReferenceRunWithoutVerticalPositioning(displayText, params), originalRun, params.defaultSize);
	return copyReferencePmPositions({
		...originalRun,
		vertAlign: "superscript",
		baselineShift: void 0,
		fontSize: baseFontSize * SUBSCRIPT_SUPERSCRIPT_SCALE
	}, params);
}
var SUPPORTED_FORMATS = new Set([
	"decimal",
	"upperRoman",
	"lowerRoman",
	"upperLetter",
	"lowerLetter",
	"numberInDash"
]);
function toUpperRoman(num) {
	if (num < 1 || num > 3999) return String(num);
	const values = [
		1e3,
		900,
		500,
		400,
		100,
		90,
		50,
		40,
		10,
		9,
		5,
		4,
		1
	];
	const numerals = [
		"M",
		"CM",
		"D",
		"CD",
		"C",
		"XC",
		"L",
		"XL",
		"X",
		"IX",
		"V",
		"IV",
		"I"
	];
	let result = "";
	let remaining = num;
	for (let i$1 = 0; i$1 < values.length; i$1 += 1) while (remaining >= values[i$1]) {
		result += numerals[i$1];
		remaining -= values[i$1];
	}
	return result;
}
function toUpperLetter(num) {
	if (num < 1) return "A";
	let result = "";
	let n = num;
	while (n > 0) {
		const remainder = (n - 1) % 26;
		result = String.fromCharCode(65 + remainder) + result;
		n = Math.floor((n - 1) / 26);
	}
	return result;
}
const formatFootnoteCardinal = (cardinal, numFmt) => {
	const fmt = numFmt && SUPPORTED_FORMATS.has(numFmt) ? numFmt : "decimal";
	const num = Math.max(1, cardinal);
	switch (fmt) {
		case "decimal": return String(num);
		case "upperRoman": return toUpperRoman(num);
		case "lowerRoman": return toUpperRoman(num).toLowerCase();
		case "upperLetter": return toUpperLetter(num);
		case "lowerLetter": return toUpperLetter(num).toLowerCase();
		case "numberInDash": return `-${num}-`;
		default: return String(num);
	}
};
function footnoteReferenceToBlock(params) {
	const { node, converterContext } = params;
	const attrs = node.attrs;
	const id = attrs?.id;
	if (isCustomMarkFollows(attrs?.customMarkFollows)) return buildReferenceMarkerRun("", params);
	const cardinal = resolveFootnoteDisplayNumber(id, converterContext.footnoteNumberById);
	const key = id == null ? null : String(id);
	const numFmt = key && converterContext.footnoteFormatById?.[key] || converterContext.footnoteNumberFormat;
	return buildReferenceMarkerRun(cardinal != null ? formatFootnoteCardinal(cardinal, numFmt) : id != null ? String(id) : "*", params);
}
var isCustomMarkFollows = (value) => {
	if (value === true || value === 1) return true;
	if (typeof value !== "string") return false;
	const v = value.trim().toLowerCase();
	return v === "1" || v === "true" || v === "on";
};
var resolveFootnoteDisplayNumber = (id, footnoteNumberById) => {
	const key = id == null ? null : String(id);
	if (!key) return null;
	const mapped = footnoteNumberById?.[key];
	return typeof mapped === "number" && Number.isFinite(mapped) && mapped > 0 ? mapped : null;
};
function endnoteReferenceToBlock(params) {
	const { node, converterContext } = params;
	const id = node.attrs?.id;
	const cardinal = resolveEndnoteDisplayNumber(id, converterContext.endnoteNumberById);
	const key = id == null ? null : String(id);
	const numFmt = key && converterContext.endnoteFormatById?.[key] || converterContext.endnoteNumberFormat;
	return buildReferenceMarkerRun(cardinal != null ? formatFootnoteCardinal(cardinal, numFmt) : id != null ? String(id) : "*", params);
}
var resolveEndnoteDisplayNumber = (id, endnoteNumberById) => {
	const key = id == null ? null : String(id);
	if (!key) return null;
	const mapped = endnoteNumberById?.[key];
	return typeof mapped === "number" && Number.isFinite(mapped) && mapped > 0 ? mapped : null;
};
function runNodeChildrenToRuns({ node, inheritedMarks, sdtMetadata, converterContext, paragraphProperties, visitNode }) {
	const mergedMarks = [...node.marks ?? [], ...inheritedMarks ?? []];
	const runProperties = node.attrs?.runProperties ?? {};
	if (runProperties.vanish) throw new HiddenByVanishError();
	const resolvedRunProperties = resolveRunProperties(converterContext, runProperties, paragraphProperties, converterContext.tableInfo, false, false);
	node.content?.forEach((child) => visitNode(child, mergedMarks, sdtMetadata, resolvedRunProperties, false, runProperties));
}
var sdtMetadataCache = /* @__PURE__ */ new Map();
function resolveSdtMetadata(input) {
	if (!input) return void 0;
	const { nodeType, attrs, cacheKey: explicitKey } = input;
	if (!nodeType) return void 0;
	const normalizedAttrs = isPlainObject$2(attrs) ? attrs : {};
	const cacheKey = buildSdtCacheKey(nodeType, normalizedAttrs, explicitKey);
	if (cacheKey && sdtMetadataCache.has(cacheKey)) return sdtMetadataCache.get(cacheKey);
	let metadata;
	switch (nodeType) {
		case "fieldAnnotation":
			metadata = normalizeFieldAnnotationMetadata(normalizedAttrs);
			break;
		case "structuredContent":
		case "structuredContentBlock":
			metadata = normalizeStructuredContentMetadata(nodeType, normalizedAttrs);
			break;
		case "documentSection":
			metadata = normalizeDocumentSectionMetadata(normalizedAttrs);
			break;
		case "docPartObject":
			metadata = normalizeDocPartMetadata(normalizedAttrs);
			break;
	}
	if (metadata && cacheKey) sdtMetadataCache.set(cacheKey, metadata);
	return metadata;
}
function normalizeFieldAnnotationMetadata(attrs) {
	const fieldId = toOptionalString(attrs.fieldId) ?? "";
	const formatting = extractFormatting(attrs);
	const size = normalizeSize(attrs.size);
	const extras = isPlainObject$2(attrs.extras) ? attrs.extras : null;
	const marks = isPlainObject$2(attrs.marks) ? attrs.marks : void 0;
	return {
		type: "fieldAnnotation",
		fieldId,
		variant: normalizeFieldAnnotationVariant(attrs.type),
		fieldType: toOptionalString(attrs.fieldType),
		displayLabel: toOptionalString(attrs.displayLabel),
		defaultDisplayLabel: toOptionalString(attrs.defaultDisplayLabel),
		alias: toOptionalString(attrs.alias),
		fieldColor: normalizeColorValue(attrs.fieldColor),
		borderColor: normalizeColorValue(attrs.borderColor),
		highlighted: toBoolean$2(attrs.highlighted, true),
		fontFamily: toNullableString(attrs.fontFamily),
		fontSize: normalizeFontSize(attrs.fontSize),
		textColor: normalizeColorValue(attrs.textColor) ?? null,
		textHighlight: normalizeColorValue(attrs.textHighlight) ?? null,
		linkUrl: toNullableString(attrs.linkUrl),
		imageSrc: toNullableString(attrs.imageSrc),
		rawHtml: attrs.rawHtml ?? void 0,
		size: size ?? null,
		extras,
		multipleImage: toBoolean$2(attrs.multipleImage, false),
		hash: toOptionalString(attrs.hash) ?? null,
		generatorIndex: toNumber$1(attrs.generatorIndex),
		sdtId: toOptionalString(attrs.sdtId) ?? null,
		hidden: toBoolean$2(attrs.hidden, false),
		visibility: normalizeVisibility(attrs.visibility),
		isLocked: toBoolean$2(attrs.isLocked, false),
		formatting,
		marks
	};
}
function normalizeStructuredContentMetadata(nodeType, attrs) {
	const metadata = {
		type: "structuredContent",
		scope: nodeType === "structuredContentBlock" ? "block" : "inline",
		id: toNullableString(attrs.id),
		tag: toOptionalString(attrs.tag),
		alias: toOptionalString(attrs.alias),
		lockMode: attrs.lockMode,
		sdtPr: attrs.sdtPr
	};
	const rawAppearance = toOptionalString(attrs.appearance);
	if (rawAppearance === "boundingBox" || rawAppearance === "tags" || rawAppearance === "hidden") metadata.appearance = rawAppearance;
	return metadata;
}
function normalizeDocumentSectionMetadata(attrs) {
	return {
		type: "documentSection",
		id: toNullableString(attrs.id),
		title: toOptionalString(attrs.title) ?? null,
		description: toOptionalString(attrs.description) ?? null,
		sectionType: toOptionalString(attrs.sectionType) ?? null,
		isLocked: toBoolean$2(attrs.isLocked, false),
		sdBlockId: toNullableString(attrs.sdBlockId)
	};
}
function normalizeDocPartMetadata(attrs) {
	return {
		type: "docPartObject",
		gallery: toOptionalString(attrs.docPartGallery ?? attrs.gallery) ?? null,
		uniqueId: toOptionalString(attrs.id ?? attrs.uniqueId) ?? null,
		alias: toOptionalString(attrs.alias) ?? null,
		instruction: toOptionalString(attrs.instruction) ?? null
	};
}
function isPlainObject$2(value) {
	return !!value && typeof value === "object" && !Array.isArray(value);
}
function toOptionalString(value) {
	if (value == null) return void 0;
	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed.length ? trimmed : void 0;
	}
	return String(value);
}
function toNullableString(value) {
	return toOptionalString(value) ?? null;
}
function toBoolean$2(value, fallback) {
	if (typeof value === "boolean") return value;
	if (typeof value === "string") {
		const lower = value.toLowerCase();
		if (lower === "true") return true;
		if (lower === "false") return false;
	}
	if (value == null) return fallback;
	return Boolean(value);
}
function normalizeVisibility(value) {
	if (typeof value !== "string") return void 0;
	const normalized = value.toLowerCase();
	if (normalized === "visible" || normalized === "hidden") return normalized;
}
function normalizeColorValue(value) {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	if (!trimmed || trimmed.toLowerCase() === "none") return void 0;
	return trimmed;
}
function normalizeFontSize(value) {
	if (value == null) return null;
	if (typeof value === "number") return Number.isFinite(value) ? value : null;
	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed.length ? trimmed : null;
	}
	return null;
}
function toNumber$1(value) {
	if (typeof value === "number") return Number.isFinite(value) ? value : null;
	if (typeof value === "string") {
		const parsed = parseFloat(value);
		return Number.isFinite(parsed) ? parsed : null;
	}
	return null;
}
function normalizeSize(value) {
	if (!isPlainObject$2(value)) return null;
	const obj = value;
	const width = toNumber$1(obj.width);
	const height = toNumber$1(obj.height);
	if (width == null && height == null) return null;
	const result = {};
	if (width != null) result.width = width;
	if (height != null) result.height = height;
	return result;
}
function normalizeFieldAnnotationVariant(value) {
	if (typeof value !== "string") return void 0;
	const normalized = value.toLowerCase();
	if (normalized === "text" || normalized === "image" || normalized === "signature" || normalized === "checkbox" || normalized === "html" || normalized === "link") return normalized;
}
function extractFormatting(attrs) {
	const bold = toBoolean$2(attrs.bold, false);
	const italic = toBoolean$2(attrs.italic, false);
	const underline = toBoolean$2(attrs.underline, false);
	const formatting = {};
	if (bold) formatting.bold = true;
	if (italic) formatting.italic = true;
	if (underline) formatting.underline = true;
	return Object.keys(formatting).length ? formatting : void 0;
}
function buildSdtCacheKey(nodeType, attrs, explicitKey) {
	const provided = toOptionalString(explicitKey);
	if (provided) return `${nodeType}:${provided}`;
	const hash = toOptionalString(attrs.hash);
	if (hash) return `${nodeType}:${hash}`;
	const id = toOptionalString(attrs.id);
	if (id) return `${nodeType}:${id}`;
}
function getNodeInstruction(node) {
	if (typeof node.attrs !== "object" || node.attrs === null) return void 0;
	const attrs = node.attrs;
	return typeof attrs.instruction === "string" ? attrs.instruction : void 0;
}
function getDocPartGallery(node) {
	if (typeof node.attrs !== "object" || node.attrs === null) return void 0;
	const attrs = node.attrs;
	return typeof attrs.docPartGallery === "string" ? attrs.docPartGallery : void 0;
}
function getDocPartObjectId(node) {
	if (typeof node.attrs !== "object" || node.attrs === null) return void 0;
	const attrs = node.attrs;
	return typeof attrs.id === "string" ? attrs.id : void 0;
}
function resolveNodeSdtMetadata(node, overrideType) {
	const attrs = node.attrs;
	if (!attrs) return void 0;
	const nodeType = overrideType ?? node.type;
	if (!nodeType) return void 0;
	return resolveSdtMetadata({
		nodeType,
		attrs,
		cacheKey: typeof attrs.hash === "string" ? attrs.hash : typeof attrs.id === "string" ? attrs.id : typeof attrs.fieldId === "string" ? attrs.fieldId : void 0
	});
}
function applySdtMetadataToParagraphBlocks(blocks, metadata) {
	if (!metadata) return;
	blocks.forEach((block) => {
		if (block.kind !== "paragraph") return;
		if (!block.attrs) block.attrs = {};
		block.attrs.sdt = metadata;
	});
}
function applySdtMetadataToTableBlock(tableBlock, metadata) {
	if (!metadata || !tableBlock || tableBlock.kind !== "table") return;
	const table = tableBlock;
	if (!table.attrs) table.attrs = {};
	table.attrs.sdt = metadata;
	table.rows?.forEach((row) => {
		row.cells?.forEach((cell) => {
			const cellBlocks = cell.blocks;
			if (cellBlocks && cellBlocks.length > 0) {
				applySdtMetadataToParagraphBlocks(cellBlocks, metadata);
				cellBlocks.forEach((block) => {
					if (block.kind === "table") applySdtMetadataToTableBlock(block, metadata);
				});
				return;
			}
			if (cell.paragraph) applySdtMetadataToParagraphBlocks([cell.paragraph], metadata);
		});
	});
}
function applyTocMetadata(blocks, metadata) {
	blocks.forEach((block) => {
		if (block.kind === "paragraph") {
			if (!block.attrs) block.attrs = {};
			block.attrs.isTocEntry = true;
			if (!block.attrs.sdt && metadata.gallery) block.attrs.sdt = {
				type: "docPartObject",
				gallery: metadata.gallery,
				uniqueId: metadata.uniqueId,
				instruction: metadata.instruction
			};
			if (metadata.instruction) block.attrs.tocInstruction = metadata.instruction;
			if (metadata.tocId) block.attrs.tocId = metadata.tocId;
		}
	});
}
function processTocChildren(children, metadata, context, outputArrays) {
	const paragraphConverter = context.converters.paragraphToFlowBlocks;
	const { docPartGallery, docPartObjectId, tocInstruction, tocId } = metadata;
	const { blocks, recordBlockKind } = outputArrays;
	children.forEach((child) => {
		if (child.type === "paragraph") {
			emitPendingSectionBreakForParagraph({
				sectionState: context.sectionState,
				nextBlockId: context.nextBlockId,
				blocks,
				recordBlockKind
			});
			const paragraphBlocks = paragraphConverter({
				para: child,
				nextBlockId: context.nextBlockId,
				positions: context.positions,
				trackedChangesConfig: context.trackedChangesConfig,
				bookmarks: context.bookmarks,
				hyperlinkConfig: context.hyperlinkConfig,
				themeColors: context.themeColors,
				converters: context.converters,
				enableComments: context.enableComments,
				converterContext: context.converterContext
			});
			applyTocMetadata(paragraphBlocks, {
				gallery: docPartGallery,
				uniqueId: docPartObjectId,
				instruction: tocInstruction,
				tocId
			});
			applySdtMetadataToParagraphBlocks(paragraphBlocks.filter((b) => b.kind === "paragraph"), metadata.sdtMetadata);
			paragraphBlocks.forEach((block) => {
				blocks.push(block);
				recordBlockKind?.(block.kind);
			});
			if (context.sectionState) context.sectionState.currentParagraphIndex++;
		} else if (child.type === "tableOfContents" && Array.isArray(child.content)) {
			const finalInstruction = getNodeInstruction(child) ?? tocInstruction;
			processTocChildren(child.content, {
				docPartGallery,
				docPartObjectId,
				tocInstruction: finalInstruction,
				sdtMetadata: metadata.sdtMetadata,
				tocId
			}, context, outputArrays);
		}
	});
}
function handleTableOfContentsNode(node, context) {
	if (!Array.isArray(node.content)) return;
	const sdBlockId = node.attrs?.sdBlockId;
	processTocChildren(node.content, {
		tocInstruction: getNodeInstruction(node),
		tocId: typeof sdBlockId === "string" ? sdBlockId : void 0
	}, {
		nextBlockId: context.nextBlockId,
		positions: context.positions,
		bookmarks: context.bookmarks,
		trackedChangesConfig: context.trackedChangesConfig,
		hyperlinkConfig: context.hyperlinkConfig,
		enableComments: context.enableComments,
		themeColors: context.themeColors,
		converters: context.converters,
		converterContext: context.converterContext,
		sectionState: context.sectionState
	}, {
		blocks: context.blocks,
		recordBlockKind: context.recordBlockKind
	});
}
const getParagraphContainerChildren = (node) => {
	if (Array.isArray(node.content)) return node.content;
	const content$2 = node.content;
	if (content$2 && typeof content$2.forEach === "function") {
		const children = [];
		content$2.forEach((child) => children.push(child));
		return children;
	}
	return [];
};
function handleParagraphContainerNode(node, context) {
	const children = getParagraphContainerChildren(node);
	if (children.length === 0) return;
	const { blocks, recordBlockKind, nextBlockId, positions, trackedChangesConfig, bookmarks, hyperlinkConfig, sectionState, converters: converters$1, themeColors, enableComments } = context;
	const paragraphToFlowBlocks$1 = converters$1.paragraphToFlowBlocks;
	children.forEach((child) => {
		if (child.type !== "paragraph") return;
		if ((sectionState?.ranges?.length ?? 0) > 0) {
			const nextSection = sectionState.ranges[sectionState.currentSectionIndex + 1];
			if (nextSection && sectionState.currentParagraphIndex === nextSection.startParagraphIndex) {
				const currentSection = sectionState.ranges[sectionState.currentSectionIndex];
				const sectionBreak = createSectionBreakBlock(nextSection, nextBlockId, shouldRequirePageBoundary(currentSection, nextSection) || hasIntrinsicBoundarySignals(nextSection) ? { requirePageBoundary: true } : void 0);
				blocks.push(sectionBreak);
				recordBlockKind?.(sectionBreak.kind);
				sectionState.currentSectionIndex++;
			}
		}
		paragraphToFlowBlocks$1({
			para: child,
			nextBlockId,
			positions,
			trackedChangesConfig,
			bookmarks,
			hyperlinkConfig,
			themeColors,
			converterContext: context.converterContext,
			enableComments,
			converters: converters$1
		}).forEach((block) => {
			blocks.push(block);
			recordBlockKind?.(block.kind);
		});
		sectionState.currentParagraphIndex++;
	});
}
var NON_RENDERED_STRUCTURAL_INLINE_TYPES = new Set([
	"bookmarkEnd",
	"commentRangeStart",
	"commentRangeEnd",
	"permStart",
	"permEnd"
]);
function isVisuallyEmptyInlineNode(node) {
	if (node.type === "text") return (node.text ?? "").length === 0;
	if (node.type === "run" || node.type === "bookmarkStart") return !Array.isArray(node.content) || node.content.every(isVisuallyEmptyInlineNode);
	return NON_RENDERED_STRUCTURAL_INLINE_TYPES.has(node.type);
}
function isEmptyParagraphNode(node) {
	if (node.type !== "paragraph") return false;
	if (!Array.isArray(node.content) || node.content.length === 0) return true;
	return node.content.every(isVisuallyEmptyInlineNode);
}
function isVanishedParagraphNode(node) {
	const paragraphProperties = node.attrs?.paragraphProperties;
	if (!paragraphProperties || typeof paragraphProperties !== "object") return false;
	const runProperties = paragraphProperties.runProperties;
	if (!runProperties || typeof runProperties !== "object") return false;
	return runProperties.vanish === true;
}
function asEmptyTextRun(run$1) {
	if (!run$1 || typeof run$1 !== "object") return void 0;
	const candidate = run$1;
	if (!("text" in candidate) || candidate.text !== "") return void 0;
	const kind = candidate.kind;
	return kind == null || kind === "text" ? candidate : void 0;
}
function applyPlaceholderToEmptyParagraphBlocks(paragraphBlocks, metadata, contentPos) {
	let applied = false;
	paragraphBlocks.forEach((block) => {
		if (block.kind !== "paragraph") return;
		const run$1 = block.runs.map(asEmptyTextRun).find(Boolean);
		if (!run$1) return;
		run$1.kind = "text";
		run$1.text = "";
		run$1.sdt = metadata;
		run$1.visualPlaceholder = "emptyBlockSdt";
		if (contentPos != null) {
			run$1.pmStart = contentPos;
			run$1.pmEnd = contentPos;
		}
		applied = true;
	});
	return applied;
}
function handleStructuredContentBlockNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions, defaultFont, defaultSize, trackedChangesConfig, bookmarks, hyperlinkConfig, converters: converters$1, converterContext, enableComments, themeColors } = context;
	const structuredContentMetadata = resolveNodeSdtMetadata(node, "structuredContentBlock");
	const paragraphToFlowBlocks$1 = converters$1?.paragraphToFlowBlocks;
	const emitPlaceholderBlock = (contentPos) => {
		if (!structuredContentMetadata) return;
		const placeholderRun = {
			kind: "text",
			text: "",
			fontFamily: defaultFont,
			fontSize: defaultSize,
			sdt: structuredContentMetadata,
			visualPlaceholder: "emptyBlockSdt",
			...contentPos != null ? {
				pmStart: contentPos,
				pmEnd: contentPos
			} : {}
		};
		const placeholderBlock = {
			kind: "paragraph",
			id: nextBlockId("paragraph"),
			runs: [placeholderRun],
			attrs: { sdt: structuredContentMetadata }
		};
		blocks.push(placeholderBlock);
		recordBlockKind?.(placeholderBlock.kind);
	};
	if (!Array.isArray(node.content) || node.content.length === 0) {
		const pos = positions.get(node);
		emitPlaceholderBlock(pos ? pos.start + 1 : void 0);
		return;
	}
	if (node.content.length === 1 && isEmptyParagraphNode(node.content[0])) {
		const isVanishedParagraph = isVanishedParagraphNode(node.content[0]);
		const paragraphPos = positions.get(node.content[0]);
		const blockPos = positions.get(node);
		const contentPos = paragraphPos ? paragraphPos.start + 1 : blockPos ? blockPos.start + 1 : void 0;
		if (paragraphToFlowBlocks$1) {
			const convertedBlocks = paragraphToFlowBlocks$1({
				para: node.content[0],
				nextBlockId,
				positions,
				trackedChangesConfig,
				bookmarks,
				hyperlinkConfig,
				themeColors,
				enableComments,
				converters: converters$1,
				converterContext
			});
			const paragraphBlocks = Array.isArray(convertedBlocks) ? convertedBlocks : [];
			applySdtMetadataToParagraphBlocks(paragraphBlocks.filter((b) => b.kind === "paragraph"), structuredContentMetadata);
			if (applyPlaceholderToEmptyParagraphBlocks(paragraphBlocks, structuredContentMetadata, contentPos)) {
				paragraphBlocks.forEach((block) => {
					blocks.push(block);
					recordBlockKind?.(block.kind);
				});
				return;
			}
			paragraphBlocks.forEach((block) => {
				blocks.push(block);
				recordBlockKind?.(block.kind);
			});
			return;
		}
		if (isVanishedParagraph) return;
		emitPlaceholderBlock(contentPos);
		return;
	}
	const visitChild = (child) => {
		if (child.type === "paragraph") {
			if (!paragraphToFlowBlocks$1) throw new Error("paragraphToFlowBlocks converter is required for structuredContentBlock paragraphs");
			const paragraphBlocks = paragraphToFlowBlocks$1({
				para: child,
				nextBlockId,
				positions,
				trackedChangesConfig,
				bookmarks,
				hyperlinkConfig,
				themeColors,
				enableComments,
				converters: converters$1,
				converterContext
			});
			applySdtMetadataToParagraphBlocks(paragraphBlocks.filter((b) => b.kind === "paragraph"), structuredContentMetadata);
			paragraphBlocks.forEach((block) => {
				blocks.push(block);
				recordBlockKind?.(block.kind);
			});
			return;
		}
		if (child.type === "table") {
			const tableNodeToBlock$1 = converters$1?.tableNodeToBlock;
			if (tableNodeToBlock$1) {
				const tableBlock = tableNodeToBlock$1(child, {
					nextBlockId,
					positions,
					trackedChangesConfig,
					bookmarks,
					hyperlinkConfig,
					themeColors,
					enableComments,
					converters: converters$1,
					converterContext
				});
				if (tableBlock) {
					applySdtMetadataToTableBlock(tableBlock, structuredContentMetadata);
					blocks.push(tableBlock);
					recordBlockKind?.(tableBlock.kind);
				}
			}
			return;
		}
		if (Array.isArray(child.content) && (child.type === "documentPartObject" || child.type === "bibliography" || child.type === "index" || child.type === "tableOfAuthorities")) child.content.forEach(visitChild);
	};
	node.content.forEach(visitChild);
}
function processParagraphChild(child, sectionMetadata, context, output, converters$1) {
	const paragraphBlocks = converters$1.paragraphToFlowBlocks({
		para: child,
		nextBlockId: context.nextBlockId,
		positions: context.positions,
		trackedChangesConfig: context.trackedChangesConfig,
		bookmarks: context.bookmarks,
		hyperlinkConfig: context.hyperlinkConfig,
		converters: converters$1,
		enableComments: context.enableComments,
		converterContext: context.converterContext
	});
	applySdtMetadataToParagraphBlocks(paragraphBlocks.filter((b) => b.kind === "paragraph"), sectionMetadata);
	paragraphBlocks.forEach((block) => {
		output.blocks.push(block);
		output.recordBlockKind?.(block.kind);
	});
}
function processTableChild(child, sectionMetadata, context, output, converters$1) {
	const tableBlock = converters$1.tableNodeToBlock(child, {
		nextBlockId: context.nextBlockId,
		positions: context.positions,
		trackedChangesConfig: context.trackedChangesConfig,
		bookmarks: context.bookmarks,
		hyperlinkConfig: context.hyperlinkConfig,
		enableComments: context.enableComments,
		converters: converters$1,
		converterContext: context.converterContext
	});
	if (tableBlock) {
		applySdtMetadataToTableBlock(tableBlock, sectionMetadata);
		output.blocks.push(tableBlock);
		output.recordBlockKind?.(tableBlock.kind);
	}
}
function processImageChild(child, sectionMetadata, context, output, converters$1) {
	const imageBlock = converters$1.imageNodeToBlock(child, context.nextBlockId, context.positions);
	if (imageBlock && imageBlock.kind === "image") {
		if (sectionMetadata) {
			if (!imageBlock.attrs) imageBlock.attrs = {};
			imageBlock.attrs.sdt = sectionMetadata;
		}
		output.blocks.push(imageBlock);
		output.recordBlockKind?.(imageBlock.kind);
	}
}
function processNestedStructuredContent(child, sectionMetadata, context, output, converters$1) {
	const nestedMetadata = resolveNodeSdtMetadata(child, "structuredContentBlock");
	child.content?.forEach((grandchild) => {
		if (grandchild.type === "paragraph") {
			const paragraphBlocks = converters$1.paragraphToFlowBlocks({
				para: grandchild,
				nextBlockId: context.nextBlockId,
				positions: context.positions,
				trackedChangesConfig: context.trackedChangesConfig,
				bookmarks: context.bookmarks,
				hyperlinkConfig: context.hyperlinkConfig,
				converters: converters$1,
				enableComments: context.enableComments,
				converterContext: context.converterContext,
				themeColors: context.themeColors
			});
			const paraOnly = paragraphBlocks.filter((b) => b.kind === "paragraph");
			applySdtMetadataToParagraphBlocks(paraOnly, nestedMetadata);
			applySdtMetadataToParagraphBlocks(paraOnly, sectionMetadata);
			paragraphBlocks.forEach((block) => {
				output.blocks.push(block);
				output.recordBlockKind?.(block.kind);
			});
		} else if (grandchild.type === "table") {
			const tableBlock = converters$1.tableNodeToBlock(grandchild, {
				nextBlockId: context.nextBlockId,
				positions: context.positions,
				trackedChangesConfig: context.trackedChangesConfig,
				bookmarks: context.bookmarks,
				hyperlinkConfig: context.hyperlinkConfig,
				enableComments: context.enableComments,
				themeColors: context.themeColors,
				converters: converters$1,
				converterContext: context.converterContext
			});
			if (tableBlock) {
				if (nestedMetadata) applySdtMetadataToTableBlock(tableBlock, nestedMetadata);
				applySdtMetadataToTableBlock(tableBlock, sectionMetadata);
				output.blocks.push(tableBlock);
				output.recordBlockKind?.(tableBlock.kind);
			}
		}
	});
}
function processDocumentPartObject(child, sectionMetadata, context, output, converters$1) {
	const docPartGallery = getDocPartGallery(child);
	const docPartObjectId = getDocPartObjectId(child);
	const tocInstruction = getNodeInstruction(child);
	const docPartSdtMetadata = resolveNodeSdtMetadata(child, "docPartObject");
	if (docPartGallery === "Table of Contents") {
		const blocksBeforeToc = output.blocks.length;
		processTocChildren(Array.from(child.content ?? []), {
			docPartGallery,
			docPartObjectId,
			tocInstruction,
			sdtMetadata: docPartSdtMetadata,
			tocId: docPartObjectId ?? void 0
		}, {
			nextBlockId: context.nextBlockId,
			positions: context.positions,
			bookmarks: context.bookmarks,
			hyperlinkConfig: context.hyperlinkConfig,
			enableComments: context.enableComments,
			themeColors: context.themeColors,
			converters: converters$1,
			converterContext: context.converterContext,
			trackedChangesConfig: context.trackedChangesConfig
		}, {
			blocks: output.blocks,
			recordBlockKind: output.recordBlockKind
		});
		for (let i$1 = blocksBeforeToc; i$1 < output.blocks.length; i$1++) {
			const block = output.blocks[i$1];
			if (block.kind === "paragraph") if ((block.attrs?.sdt)?.type === "docPartObject") {
				if (sectionMetadata) {
					if (!block.attrs) block.attrs = {};
					block.attrs.containerSdt = sectionMetadata;
				}
			} else applySdtMetadataToParagraphBlocks([block], sectionMetadata);
		}
	}
}
function processDocumentSectionChildren(children, sectionMetadata, context, output, converters$1) {
	children.forEach((child) => {
		if (child.type === "paragraph") processParagraphChild(child, sectionMetadata, context, output, converters$1);
		else if (child.type === "table") processTableChild(child, sectionMetadata, context, output, converters$1);
		else if (child.type === "image") processImageChild(child, sectionMetadata, context, output, converters$1);
		else if (child.type === "structuredContentBlock" && Array.isArray(child.content)) processNestedStructuredContent(child, sectionMetadata, context, output, converters$1);
		else if (child.type === "documentPartObject" && Array.isArray(child.content)) processDocumentPartObject(child, sectionMetadata, context, output, converters$1);
	});
}
function handleDocumentSectionNode(node, context) {
	if (!Array.isArray(node.content)) return;
	const { blocks, recordBlockKind, nextBlockId, positions, bookmarks, hyperlinkConfig, converters: converters$1, enableComments, converterContext, trackedChangesConfig, themeColors } = context;
	const sectionMetadata = resolveNodeSdtMetadata(node, "documentSection");
	processDocumentSectionChildren(node.content, sectionMetadata, {
		nextBlockId,
		positions,
		bookmarks,
		trackedChangesConfig,
		hyperlinkConfig,
		themeColors,
		enableComments,
		converterContext
	}, {
		blocks,
		recordBlockKind
	}, converters$1);
}
var PARAGRAPH_CONTAINER_TYPES = new Set([
	"bibliography",
	"index",
	"tableOfAuthorities"
]);
function handleDocumentPartObjectNode(node, context) {
	if (!Array.isArray(node.content)) return;
	const { blocks, recordBlockKind, nextBlockId, positions, bookmarks, hyperlinkConfig, sectionState, converters: converters$1, converterContext, enableComments, trackedChangesConfig, themeColors } = context;
	const docPartGallery = getDocPartGallery(node);
	const docPartObjectId = getDocPartObjectId(node);
	const tocInstruction = getNodeInstruction(node);
	const docPartSdtMetadata = resolveNodeSdtMetadata(node, "docPartObject");
	const paragraphToFlowBlocks$1 = converters$1.paragraphToFlowBlocks;
	const sdBlockId = node.attrs?.sdBlockId;
	const tocId = docPartObjectId && docPartObjectId.length > 0 ? docPartObjectId : typeof sdBlockId === "string" && sdBlockId.length > 0 ? sdBlockId : void 0;
	if (docPartGallery === "Table of Contents") processTocChildren(Array.from(node.content), {
		docPartGallery,
		docPartObjectId,
		tocInstruction,
		sdtMetadata: docPartSdtMetadata,
		tocId
	}, {
		nextBlockId,
		positions,
		bookmarks,
		hyperlinkConfig,
		enableComments,
		trackedChangesConfig,
		themeColors,
		converters: converters$1,
		converterContext,
		sectionState
	}, {
		blocks,
		recordBlockKind
	});
	else if (paragraphToFlowBlocks$1) {
		for (const child of node.content) if (child.type === "paragraph") {
			emitPendingSectionBreakForParagraph({
				sectionState,
				nextBlockId,
				blocks,
				recordBlockKind
			});
			const childBlocks = paragraphToFlowBlocks$1({
				para: child,
				nextBlockId,
				positions,
				trackedChangesConfig,
				bookmarks,
				hyperlinkConfig,
				converters: converters$1,
				themeColors,
				enableComments,
				converterContext
			});
			for (const block of childBlocks) {
				blocks.push(block);
				recordBlockKind?.(block.kind);
			}
			if (sectionState) sectionState.currentParagraphIndex++;
		} else if (child.type === "tableOfContents" && Array.isArray(child.content)) {
			const metadata = {
				docPartGallery: docPartGallery ?? "",
				docPartObjectId,
				tocInstruction: getNodeInstruction(child) ?? tocInstruction,
				sdtMetadata: docPartSdtMetadata,
				tocId
			};
			const tocContext = {
				nextBlockId,
				positions,
				bookmarks,
				hyperlinkConfig,
				enableComments,
				trackedChangesConfig,
				themeColors,
				converters: converters$1,
				converterContext,
				sectionState
			};
			const output = {
				blocks,
				recordBlockKind
			};
			processTocChildren(child.content, metadata, tocContext, output);
		} else if (PARAGRAPH_CONTAINER_TYPES.has(child.type)) handleParagraphContainerNode(child, context);
		else if (child.type === "structuredContentBlock") handleStructuredContentBlockNode(child, context);
	}
}
function structuredContentNodeToBlocks({ node, positions, defaultFont, defaultSize, inheritedMarks, sdtMetadata, visitNode, runProperties, inlineRunProperties, converterContext }) {
	const inlineMetadata = resolveNodeSdtMetadata(node, "structuredContent");
	const nextSdt = inlineMetadata ?? sdtMetadata;
	if (inlineMetadata?.scope === "inline" && (!node.content || node.content.length === 0)) {
		const pos = positions.get(node);
		const contentPos = pos ? pos.start + 1 : void 0;
		return applyInlineRunProperties({
			kind: "text",
			text: "",
			fontFamily: defaultFont,
			fontSize: defaultSize,
			sdt: inlineMetadata,
			visualPlaceholder: "emptyInlineSdt",
			...contentPos != null ? {
				pmStart: contentPos,
				pmEnd: contentPos
			} : {}
		}, runProperties, converterContext, inlineRunProperties);
	}
	node.content?.forEach((child) => visitNode(child, inheritedMarks, nextSdt, runProperties, false, inlineRunProperties));
}
function smartTagNodeToBlocks({ node, inheritedMarks, sdtMetadata, visitNode, runProperties, inlineRunProperties }) {
	node.content?.forEach((child) => visitNode(child, inheritedMarks, sdtMetadata, runProperties, false, inlineRunProperties));
}
function pageReferenceNodeToBlock(params) {
	const { node, inheritedMarks, visitNode, sdtMetadata, positions, converterContext, paragraphProperties, inlineRunProperties: parentInlineRunProperties } = params;
	const instruction = getNodeInstruction(node) || "";
	const nodeAttrs = typeof node.attrs === "object" && node.attrs !== null ? node.attrs : {};
	const mergedMarks = [...Array.isArray(nodeAttrs.marksAsAttrs) ? nodeAttrs.marksAsAttrs : [], ...inheritedMarks ?? []];
	const parsed = parsePageRefInstruction(instruction);
	const bookmarkId = readStringAttr(nodeAttrs.bookmarkId) || parsed.bookmarkId;
	const hasHyperlinkSwitch = readBooleanAttr(nodeAttrs.hasHyperlinkSwitch) || parsed.hasHyperlinkSwitch;
	const hasRelativePositionSwitch = readBooleanAttr(nodeAttrs.hasRelativePositionSwitch) || parsed.hasRelativePositionSwitch;
	const pageNumberFieldFormat = readObjectAttr$1(nodeAttrs.pageNumberFieldFormat) ?? parsed.pageNumberFieldFormat;
	const numericPictureFormat = readObjectAttr$1(nodeAttrs.numericPictureFormat) ?? parsed.numericPictureFormat;
	const attrFieldResultFormat = readStringAttr(nodeAttrs.fieldResultFormat);
	const fieldResultFormat = attrFieldResultFormat === "charformat" || attrFieldResultFormat === "mergeformat" ? attrFieldResultFormat : parsed.fieldResultFormat;
	let runProperties = {};
	if (bookmarkId) {
		const fieldRunProperties = readObjectAttr$1(nodeAttrs.fieldRunProperties);
		let fallbackText = "??";
		if (Array.isArray(node.content) && node.content.length > 0) {
			const extractText = (n) => {
				if (n.type === "run") runProperties = n.attrs?.runProperties ?? {};
				if (n.type === "text" && n.text) return n.text;
				if (Array.isArray(n.content)) return n.content.map(extractText).join("");
				return "";
			};
			fallbackText = node.content.map(extractText).join("").trim() || "??";
		}
		if (fieldResultFormat === "charformat" && fieldRunProperties) runProperties = fieldRunProperties;
		else if (Object.keys(runProperties).length === 0 && fieldRunProperties) runProperties = fieldRunProperties;
		const pageRefPos = positions.get(node);
		const resolvedRunProperties = resolveRunProperties(converterContext, runProperties, paragraphProperties, null, false, false);
		const tokenRun = textNodeToRun({
			...params,
			node: {
				type: "text",
				text: fallbackText
			},
			inheritedMarks: mergedMarks,
			runProperties: resolvedRunProperties,
			inlineRunProperties: runProperties
		});
		if (pageRefPos) {
			tokenRun.pmStart = pageRefPos.start;
			tokenRun.pmEnd = pageRefPos.end;
		}
		tokenRun.token = "pageReference";
		tokenRun.pageRefMetadata = {
			bookmarkId,
			instruction,
			...hasRelativePositionSwitch ? { relativePosition: true } : {},
			...pageNumberFieldFormat ? { pageNumberFieldFormat } : {},
			...numericPictureFormat ? { numericPictureFormat } : {},
			...fieldResultFormat ? { fieldResultFormat } : {}
		};
		if (hasHyperlinkSwitch) {
			const synthesized = buildFlowRunLink({ anchor: bookmarkId });
			if (synthesized) tokenRun.link = tokenRun.link ? {
				...tokenRun.link,
				...synthesized,
				anchor: bookmarkId
			} : synthesized;
		}
		if (sdtMetadata) tokenRun.sdt = sdtMetadata;
		return tokenRun;
	} else if (Array.isArray(node.content)) node.content.forEach((child) => visitNode(child, mergedMarks, sdtMetadata, runProperties, false, parentInlineRunProperties));
}
function readStringAttr(value) {
	return typeof value === "string" ? value : "";
}
function readBooleanAttr(value) {
	return typeof value === "boolean" ? value : void 0;
}
function readObjectAttr$1(value) {
	return value && typeof value === "object" && !Array.isArray(value) ? value : void 0;
}
function fieldAnnotationNodeToRun({ node, positions }) {
	const fieldMetadata = resolveNodeSdtMetadata(node, "fieldAnnotation");
	let contentText;
	if (Array.isArray(node.content) && node.content.length > 0) {
		const extractText = (n) => {
			if (n.type === "text" && typeof n.text === "string") return n.text;
			if (Array.isArray(n.content)) return n.content.map(extractText).join("");
			return "";
		};
		contentText = node.content.map(extractText).join("");
	}
	const attrs = (contentText && contentText.length > 0 ? {
		...node,
		attrs: {
			...node.attrs ?? {},
			displayLabel: contentText
		}
	} : node).attrs ?? {};
	const rawVariant = attrs.type ?? fieldMetadata?.variant ?? "text";
	const run$1 = {
		kind: "fieldAnnotation",
		variant: [
			"text",
			"image",
			"signature",
			"checkbox",
			"html",
			"link"
		].includes(rawVariant) ? rawVariant : "text",
		displayLabel: (typeof attrs.displayLabel === "string" ? attrs.displayLabel : void 0) || (typeof attrs.defaultDisplayLabel === "string" ? attrs.defaultDisplayLabel : void 0) || (typeof fieldMetadata?.displayLabel === "string" ? fieldMetadata.displayLabel : void 0) || (typeof fieldMetadata?.defaultDisplayLabel === "string" ? fieldMetadata.defaultDisplayLabel : void 0) || (typeof attrs.alias === "string" ? attrs.alias : void 0) || (typeof fieldMetadata?.alias === "string" ? fieldMetadata.alias : void 0) || ""
	};
	const fieldId = typeof attrs.fieldId === "string" ? attrs.fieldId : fieldMetadata?.fieldId;
	if (fieldId) run$1.fieldId = fieldId;
	const fieldType = typeof attrs.fieldType === "string" ? attrs.fieldType : fieldMetadata?.fieldType;
	if (fieldType) run$1.fieldType = fieldType;
	const fieldColor = typeof attrs.fieldColor === "string" ? attrs.fieldColor : fieldMetadata?.fieldColor;
	if (fieldColor) run$1.fieldColor = fieldColor;
	const borderColor = typeof attrs.borderColor === "string" ? attrs.borderColor : fieldMetadata?.borderColor;
	if (borderColor) run$1.borderColor = borderColor;
	if ((attrs.highlighted ?? fieldMetadata?.highlighted) === false) run$1.highlighted = false;
	if (attrs.hidden === true || fieldMetadata?.hidden === true) run$1.hidden = true;
	if ((attrs.visibility ?? fieldMetadata?.visibility) === "hidden") run$1.visibility = "hidden";
	const imageSrc = typeof attrs.imageSrc === "string" ? attrs.imageSrc : fieldMetadata?.imageSrc;
	if (imageSrc) run$1.imageSrc = imageSrc;
	const linkUrl = typeof attrs.linkUrl === "string" ? attrs.linkUrl : fieldMetadata?.linkUrl;
	if (linkUrl) run$1.linkUrl = linkUrl;
	const rawHtml = attrs.rawHtml ?? fieldMetadata?.rawHtml;
	if (typeof rawHtml === "string") run$1.rawHtml = rawHtml;
	const size = attrs.size ?? fieldMetadata?.size;
	if (size && (typeof size.width === "number" || typeof size.height === "number")) run$1.size = {
		width: typeof size.width === "number" ? size.width : void 0,
		height: typeof size.height === "number" ? size.height : void 0
	};
	const fontFamily = attrs.fontFamily ?? fieldMetadata?.fontFamily;
	if (typeof fontFamily === "string") run$1.fontFamily = fontFamily;
	const fontSize = attrs.fontSize ?? fieldMetadata?.fontSize;
	if (typeof fontSize === "string" || typeof fontSize === "number") run$1.fontSize = fontSize;
	const textColor = attrs.textColor ?? fieldMetadata?.textColor;
	if (typeof textColor === "string") run$1.textColor = textColor;
	const textHighlight = attrs.textHighlight ?? fieldMetadata?.textHighlight;
	if (typeof textHighlight === "string") run$1.textHighlight = textHighlight;
	const formatting = fieldMetadata?.formatting;
	if (attrs.bold === true) run$1.bold = true;
	else if (attrs.bold !== false && formatting?.bold === true) run$1.bold = true;
	if (attrs.italic === true) run$1.italic = true;
	else if (attrs.italic !== false && formatting?.italic === true) run$1.italic = true;
	if (attrs.underline === true) run$1.underline = true;
	else if (attrs.underline !== false && formatting?.underline === true) run$1.underline = true;
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (fieldMetadata) run$1.sdt = fieldMetadata;
	return run$1;
}
function bookmarkStartNodeToBlocks(params) {
	const { node, positions, bookmarks, visitNode, inheritedMarks, sdtMetadata, runProperties, inlineRunProperties, converterContext } = params;
	const nodeAttrs = typeof node.attrs === "object" && node.attrs !== null ? node.attrs : {};
	const bookmarkName = typeof nodeAttrs.name === "string" ? nodeAttrs.name : void 0;
	if (bookmarkName && bookmarks) {
		const nodePos = positions.get(node);
		if (nodePos) bookmarks.set(bookmarkName, nodePos.start);
	}
	const shouldRender = converterContext?.showBookmarks === true && typeof bookmarkName === "string" && !bookmarkName.startsWith("_");
	let run$1;
	if (shouldRender) {
		run$1 = textNodeToRun({
			...params,
			node: {
				type: "text",
				text: "[",
				marks: [...node.marks ?? []]
			}
		});
		run$1.dataAttrs = {
			...run$1.dataAttrs ?? {},
			"data-bookmark-name": bookmarkName,
			"data-bookmark-marker": "start"
		};
		const bookmarkIdRaw = nodeAttrs.id;
		const bookmarkId = typeof bookmarkIdRaw === "string" || typeof bookmarkIdRaw === "number" ? String(bookmarkIdRaw) : "";
		if (bookmarkId && converterContext?.renderedBookmarkIds) converterContext.renderedBookmarkIds.add(bookmarkId);
	}
	if (Array.isArray(node.content)) node.content.forEach((child) => visitNode(child, inheritedMarks, sdtMetadata, runProperties, false, inlineRunProperties));
	return run$1;
}
function bookmarkEndNodeToRun(params) {
	const { node, converterContext } = params;
	if (converterContext?.showBookmarks !== true) return;
	const nodeAttrs = typeof node.attrs === "object" && node.attrs !== null ? node.attrs : {};
	const bookmarkId = typeof nodeAttrs.id === "string" || typeof nodeAttrs.id === "number" ? String(nodeAttrs.id) : "";
	const rendered = converterContext?.renderedBookmarkIds;
	if (rendered && bookmarkId && !rendered.has(bookmarkId)) return;
	const run$1 = textNodeToRun({
		...params,
		node: {
			type: "text",
			text: "]",
			marks: [...node.marks ?? []]
		}
	});
	run$1.dataAttrs = {
		...run$1.dataAttrs ?? {},
		"data-bookmark-marker": "end",
		...bookmarkId ? { "data-bookmark-id": bookmarkId } : {}
	};
	return run$1;
}
function tabNodeToRun({ node, positions, storyKey, tabOrdinal, paragraphAttrs, inheritedMarks, sdtMetadata, runProperties, converterContext, inlineRunProperties }) {
	const pos = positions.get(node);
	if (!pos) return null;
	const tabStops = paragraphAttrs.tabs;
	const indent = paragraphAttrs.indent;
	let run$1 = {
		kind: "tab",
		text: "	",
		pmStart: pos.start,
		pmEnd: pos.end,
		tabIndex: tabOrdinal,
		tabStops,
		indent,
		leader: node.attrs?.leader ?? null
	};
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	if (runProperties) run$1 = applyInlineRunProperties(run$1, runProperties, converterContext, inlineRunProperties);
	const marks = [...node.marks ?? [], ...inheritedMarks ?? []];
	if (marks.length > 0) applyMarksToRun(run$1, marks, void 0, void 0, void 0, true, storyKey);
	return run$1;
}
var NON_BREAKING_HYPHEN = "‑";
function noBreakHyphenNodeToRun({ node, positions, storyKey, defaultFont, defaultSize, inheritedMarks = [], sdtMetadata, hyperlinkConfig = DEFAULT_HYPERLINK_CONFIG, themeColors, enableComments, runProperties, inlineRunProperties, converterContext }) {
	let run$1 = {
		text: NON_BREAKING_HYPHEN,
		fontFamily: defaultFont,
		fontSize: defaultSize
	};
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	applyMarksToRun(run$1, [...node.marks ?? [], ...inheritedMarks ?? []], hyperlinkConfig, themeColors, converterContext?.backgroundColor, enableComments, storyKey);
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	run$1 = applyInlineRunProperties(run$1, runProperties, converterContext, inlineRunProperties);
	return run$1;
}
function tokenNodeToRun({ node, positions, storyKey, defaultFont, defaultSize, inheritedMarks, hyperlinkConfig, themeColors, sdtMetadata, runProperties, inlineRunProperties, converterContext }) {
	const token = TOKEN_INLINE_TYPES.get(node.type);
	if (!token) return null;
	let run$1 = {
		text: "0",
		token,
		fontFamily: defaultFont,
		fontSize: defaultSize
	};
	const pageNumberFieldFormat = getPageNumberFieldFormat(node.attrs);
	if (pageNumberFieldFormat) run$1.pageNumberFieldFormat = pageNumberFieldFormat;
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	const nodeMarks = node.marks ?? [];
	const marksAsAttrs = Array.isArray(node.attrs?.marksAsAttrs) ? node.attrs.marksAsAttrs : [];
	const marks = [...nodeMarks.length > 0 ? nodeMarks : marksAsAttrs, ...inheritedMarks ?? []];
	applyMarksToRun(run$1, marks, hyperlinkConfig, themeColors, void 0, true, storyKey);
	run$1 = applyInlineRunProperties(run$1, runProperties, converterContext, inlineRunProperties);
	if (marksAsAttrs.length > 0) run$1._explicitFont = true;
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
var DEFAULT_IMAGE_DIMENSION_PX = 100;
function imageNodeToRun({ node, positions, sdtMetadata }) {
	if (isNodeHidden(node)) return null;
	if (!isInlineImage(node)) throw new NotInlineNodeError();
	const attrs = node.attrs ?? {};
	const src = typeof attrs.src === "string" ? attrs.src : "";
	if (!src) return null;
	const size = attrs.size ?? {};
	const width = typeof size.width === "number" && Number.isFinite(size.width) && size.width > 0 ? size.width : DEFAULT_IMAGE_DIMENSION_PX;
	const height = typeof size.height === "number" && Number.isFinite(size.height) && size.height > 0 ? size.height : DEFAULT_IMAGE_DIMENSION_PX;
	const wrap$1 = isPlainObject(attrs.wrap) ? attrs.wrap : {};
	const wrapAttrs = isPlainObject(wrap$1.attrs) ? wrap$1.attrs : {};
	const run$1 = {
		kind: "image",
		src,
		width,
		height
	};
	if (typeof attrs.alt === "string") run$1.alt = attrs.alt;
	if (typeof attrs.title === "string") run$1.title = attrs.title;
	if (typeof attrs.clipPath === "string") run$1.clipPath = attrs.clipPath;
	const distTop = pickNumber(wrapAttrs.distTop ?? wrapAttrs.distT);
	if (distTop != null) run$1.distTop = distTop;
	const distBottom = pickNumber(wrapAttrs.distBottom ?? wrapAttrs.distB);
	if (distBottom != null) run$1.distBottom = distBottom;
	const distLeft = pickNumber(wrapAttrs.distLeft ?? wrapAttrs.distL);
	if (distLeft != null) run$1.distLeft = distLeft;
	const distRight = pickNumber(wrapAttrs.distRight ?? wrapAttrs.distR);
	if (distRight != null) run$1.distRight = distRight;
	run$1.verticalAlign = "top";
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	const transformData = isPlainObject(attrs.transformData) ? attrs.transformData : void 0;
	if (transformData) {
		const rotation = typeof transformData.rotation === "number" ? transformData.rotation : void 0;
		if (rotation !== void 0) run$1.rotation = rotation;
		const flipH = typeof transformData.horizontalFlip === "boolean" ? transformData.horizontalFlip : void 0;
		if (flipH !== void 0) run$1.flipH = flipH;
		const flipV = typeof transformData.verticalFlip === "boolean" ? transformData.verticalFlip : void 0;
		if (flipV !== void 0) run$1.flipV = flipV;
	}
	if (typeof attrs.gain === "string" || typeof attrs.gain === "number") run$1.gain = attrs.gain;
	if (typeof attrs.blacklevel === "string" || typeof attrs.blacklevel === "number") run$1.blacklevel = attrs.blacklevel;
	if (typeof attrs.grayscale === "boolean") run$1.grayscale = attrs.grayscale;
	const lum = isPlainObject(attrs.lum) ? attrs.lum : void 0;
	const bright = pickNumber(lum?.bright);
	const contrast = pickNumber(lum?.contrast);
	if (bright != null || contrast != null) run$1.lum = {
		...bright != null ? { bright } : {},
		...contrast != null ? { contrast } : {}
	};
	const alphaModFixAmt = pickNumber((isPlainObject(attrs.alphaModFix) ? attrs.alphaModFix : void 0)?.amt);
	if (alphaModFixAmt != null) run$1.alphaModFix = { amt: alphaModFixAmt };
	const hyperlink = readImageHyperlink(attrs.hyperlink);
	if (hyperlink) run$1.hyperlink = hyperlink;
	return run$1;
}
var isNodeHidden = (node) => {
	const attrs = node.attrs ?? {};
	if (attrs.hidden === true) return true;
	return typeof attrs.visibility === "string" && attrs.visibility.toLowerCase() === "hidden";
};
function isInlineImage(node) {
	const attrs = node.attrs ?? {};
	const rawWrapType = attrs.wrap?.type;
	if (rawWrapType === "Inline") return true;
	if (rawWrapType && rawWrapType !== "Inline") return false;
	if (attrs.inline === true) return true;
	if (attrs.display === "inline") return true;
	return false;
}
function crossReferenceNodeToRun(params) {
	const { node, positions, sdtMetadata } = params;
	const attrs = node.attrs ?? {};
	const resolvedText = typeof attrs.resolvedText === "string" ? attrs.resolvedText : "";
	const target = typeof attrs.target === "string" ? attrs.target : "";
	const instruction = typeof attrs.instruction === "string" ? attrs.instruction : "";
	const run$1 = textNodeToRun({
		...params,
		node: {
			type: "text",
			text: resolvedText,
			marks: [...node.marks ?? []]
		}
	});
	if (target && /\\h\b/i.test(instruction)) {
		const synthesized = buildFlowRunLink({ anchor: target });
		if (synthesized) run$1.link = run$1.link ? {
			...run$1.link,
			...synthesized,
			anchor: target
		} : synthesized;
	}
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
function sequenceFieldNodeToRun(params) {
	const { node, positions, sdtMetadata } = params;
	const attrs = node.attrs ?? {};
	const cachedText = typeof attrs.resolvedNumber === "string" ? attrs.resolvedNumber : "";
	const run$1 = textNodeToRun({
		...params,
		node: {
			type: "text",
			text: cachedText || "1",
			marks: [...node.marks ?? []]
		}
	});
	run$1.token = "seq";
	run$1.seqMetadata = {
		identifier: String(attrs.identifier ?? ""),
		instruction: String(attrs.instruction ?? ""),
		fieldArgument: String(attrs.fieldArgument ?? ""),
		sequenceMode: attrs.sequenceMode === "current" ? "current" : "next",
		hideResult: attrs.hideResult === true,
		restartNumber: typeof attrs.restartNumber === "number" ? attrs.restartNumber : null,
		restartLevel: typeof attrs.restartLevel === "number" ? attrs.restartLevel : null,
		format: typeof attrs.format === "string" ? attrs.format : void 0,
		hasGeneralFormat: attrs.hasGeneralFormat === true,
		pageNumberFieldFormat: readObjectAttr(attrs.pageNumberFieldFormat),
		numericPictureFormat: readObjectAttr(attrs.numericPictureFormat),
		cachedText
	};
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
function readObjectAttr(value) {
	return value && typeof value === "object" && !Array.isArray(value) ? value : null;
}
function documentStatFieldNodeToRun(params) {
	const { node, positions, sdtMetadata } = params;
	const attrs = node.attrs ?? {};
	const resolvedText = attrs.resolvedText || "0";
	const marksAsAttrs = Array.isArray(attrs.marksAsAttrs) ? attrs.marksAsAttrs : void 0;
	const run$1 = textNodeToRun({
		...params,
		node: {
			type: "text",
			text: resolvedText,
			marks: [...node.marks ?? []],
			...marksAsAttrs ? { attrs: { marksAsAttrs } } : {}
		}
	});
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
function citationNodeToRun(params) {
	const { node, positions, sdtMetadata } = params;
	const resolvedText = (node.attrs ?? {}).resolvedText || "[Citation]";
	const run$1 = textNodeToRun({
		...params,
		node: {
			type: "text",
			text: resolvedText,
			marks: [...node.marks ?? []]
		}
	});
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
function authorityEntryNodeToRun(_params) {
	return null;
}
var VERTICAL_ELEMENTS = {
	"m:f": .6,
	"m:bar": .25,
	"m:limLow": .35,
	"m:limUpp": .35,
	"m:nary": .4,
	"m:rad": .2,
	"m:sSub": .1,
	"m:sSup": .1,
	"m:sSubSup": .2,
	"m:sPre": .2,
	"m:groupChr": .35
};
function countEqArrayRows(node) {
	if (!Array.isArray(node.elements)) return 1;
	return node.elements.filter((el) => el && typeof el === "object" && el.name === "m:e").length;
}
function estimateHeightMultiplier(node) {
	if (!node || typeof node !== "object") return 0;
	const n = node;
	if (n.name === "m:eqArr") {
		const rows = countEqArrayRows(n);
		const rowMultiplier = Math.max(0, rows - 1);
		let maxRowContent = 0;
		if (Array.isArray(n.elements)) for (const child of n.elements) maxRowContent = Math.max(maxRowContent, estimateHeightMultiplier(child));
		return rowMultiplier + maxRowContent;
	}
	const selfMultiplier = n.name ? VERTICAL_ELEMENTS[n.name] ?? 0 : 0;
	let maxChild = 0;
	if (Array.isArray(n.elements)) for (const child of n.elements) maxChild = Math.max(maxChild, estimateHeightMultiplier(child));
	return selfMultiplier + maxChild;
}
function estimateMathDimensions(textContent, ommlJson) {
	const multiplier = ommlJson ? estimateHeightMultiplier(ommlJson) : 0;
	return {
		width: Math.max(textContent.length * 10, 20),
		height: Math.round(24 * (1 + multiplier))
	};
}
function mathInlineNodeToRun({ node, positions, sdtMetadata }) {
	const textContent = String(node.attrs?.textContent ?? "");
	const { width, height } = estimateMathDimensions(textContent, node.attrs?.originalXml ?? null);
	const run$1 = {
		kind: "math",
		ommlJson: node.attrs?.originalXml ?? null,
		textContent,
		width,
		height
	};
	const pos = positions.get(node);
	if (pos) {
		run$1.pmStart = pos.start;
		run$1.pmEnd = pos.end;
	}
	if (sdtMetadata) run$1.sdt = sdtMetadata;
	return run$1;
}
function lineBreakNodeToRun({ node, positions, sdtMetadata }) {
	const attrs = node.attrs ?? {};
	const breakType = attrs.pageBreakType ?? attrs.lineBreakType ?? "line";
	if (breakType === "page" || breakType === "column") throw new NotInlineNodeError();
	const lineBreakRun = {
		kind: "lineBreak",
		attrs: {}
	};
	const lbAttrs = {};
	if (attrs.lineBreakType) lbAttrs.lineBreakType = String(attrs.lineBreakType);
	if (attrs.clear) lbAttrs.clear = String(attrs.clear);
	if (Object.keys(lbAttrs).length > 0) lineBreakRun.attrs = lbAttrs;
	else delete lineBreakRun.attrs;
	const pos = positions.get(node);
	if (pos) {
		lineBreakRun.pmStart = pos.start;
		lineBreakRun.pmEnd = pos.end;
	}
	if (sdtMetadata) lineBreakRun.sdt = sdtMetadata;
	return lineBreakRun;
}
const lineBreakNodeToBreakBlock = (node, { nextBlockId }) => {
	const breakType = node.attrs?.pageBreakType ?? node.attrs?.lineBreakType ?? "line";
	const kind = breakType === "page" ? "pageBreak" : breakType === "column" ? "columnBreak" : null;
	if (!kind) return null;
	return {
		kind,
		id: nextBlockId(kind),
		attrs: node.attrs || {}
	};
};
var WRAP_TYPES$2 = new Set([
	"None",
	"Square",
	"Tight",
	"Through",
	"TopAndBottom",
	"Inline"
]);
var WRAP_TEXT_VALUES$2 = new Set([
	"bothSides",
	"left",
	"right",
	"largest"
]);
var H_RELATIVE_VALUES$2 = new Set([
	"column",
	"page",
	"margin"
]);
var V_RELATIVE_VALUES$2 = new Set([
	"paragraph",
	"page",
	"margin"
]);
var H_ALIGN_VALUES$1 = new Set([
	"left",
	"center",
	"right"
]);
var V_ALIGN_VALUES$1 = new Set([
	"top",
	"center",
	"bottom"
]);
var getAttrs$2 = (node) => {
	return isPlainObject(node.attrs) ? node.attrs : {};
};
var isHiddenDrawing$1 = (attrs) => {
	if (toBoolean(attrs.hidden) === true) return true;
	return typeof attrs.visibility === "string" && attrs.visibility.toLowerCase() === "hidden";
};
var TEXTBOX_CONTAINER_TYPES = new Set([
	"run",
	"link",
	"hyperlink",
	"structuredContent",
	"fieldAnnotation",
	"smartTag"
]);
var resolveTextFormattingFromMarks = (marks) => {
	if (!Array.isArray(marks) || marks.length === 0) return void 0;
	const formatting = {};
	marks.forEach((mark) => {
		if (!mark || typeof mark.type !== "string") return;
		const attrs = isPlainObject(mark.attrs) ? mark.attrs : {};
		if (mark.type === "bold") formatting.bold = true;
		if (mark.type === "italic") formatting.italic = true;
		const color = typeof attrs.color === "string" ? attrs.color.replace(/^#/, "") : void 0;
		if (color) formatting.color = color;
		const fontFamily = typeof attrs.fontFamily === "string" ? attrs.fontFamily : void 0;
		if (fontFamily) formatting.fontFamily = fontFamily;
		const fontSize = pickNumber(attrs.fontSize);
		if (fontSize != null) formatting.fontSize = fontSize;
	});
	return Object.keys(formatting).length > 0 ? formatting : void 0;
};
var pushTextPart = (parts, part) => {
	if (!part.text && !part.fieldType && !part.isLineBreak) return;
	parts.push(part);
};
var extractTextPartsFromTextboxInline = (node, parts) => {
	if (!node) return;
	const formatting = resolveTextFormattingFromMarks(node.marks);
	if (typeof node.text === "string") {
		pushTextPart(parts, {
			text: node.text,
			...formatting ? { formatting } : {}
		});
		return;
	}
	switch (node.type) {
		case "text":
			pushTextPart(parts, {
				text: "",
				...formatting ? { formatting } : {}
			});
			return;
		case "tab":
			pushTextPart(parts, {
				text: "	",
				...formatting ? { formatting } : {}
			});
			return;
		case "lineBreak":
			pushTextPart(parts, {
				text: "\n",
				isLineBreak: true,
				...formatting ? { formatting } : {}
			});
			return;
		case "page-number":
			pushTextPart(parts, {
				text: "",
				fieldType: "PAGE",
				pageNumberFormat: typeof node.attrs?.pageNumberFormat === "string" ? node.attrs.pageNumberFormat : void 0,
				...formatting ? { formatting } : {}
			});
			return;
		case "total-page-number":
			pushTextPart(parts, {
				text: typeof node.attrs?.resolvedText === "string" ? node.attrs.resolvedText : typeof node.attrs?.importedCachedText === "string" ? node.attrs.importedCachedText : "",
				fieldType: "NUMPAGES",
				pageNumberFormat: typeof node.attrs?.pageNumberFormat === "string" ? node.attrs.pageNumberFormat : void 0,
				...formatting ? { formatting } : {}
			});
			return;
		default: break;
	}
	if (Array.isArray(node.content) && (TEXTBOX_CONTAINER_TYPES.has(node.type) || node.content.length > 0)) node.content.forEach((child) => extractTextPartsFromTextboxInline(child, parts));
};
var extractTextboxTextContent = (node) => {
	if (!Array.isArray(node.content) || node.content.length === 0) return void 0;
	const parts = [];
	let horizontalAlign;
	const paragraphs = node.content.filter((child) => child?.type === "paragraph");
	const paragraphHasRenderableContent = (paragraph) => Array.isArray(paragraph.content) && paragraph.content.length > 0;
	paragraphs.forEach((paragraph, paragraphIndex) => {
		const justification = paragraph.attrs?.paragraphProperties;
		if (!horizontalAlign && isPlainObject(justification)) {
			const value = justification.justification;
			if (value === "left" || value === "center" || value === "right") horizontalAlign = value;
		}
		paragraph.content?.forEach((child) => extractTextPartsFromTextboxInline(child, parts));
		if (paragraphIndex < paragraphs.length - 1) {
			const nextParagraph = paragraphs[paragraphIndex + 1];
			parts.push({
				text: "\n",
				isLineBreak: true,
				isEmptyParagraph: !paragraphHasRenderableContent(paragraph) || !paragraphHasRenderableContent(nextParagraph)
			});
		}
	});
	return parts.length > 0 ? {
		parts,
		...horizontalAlign ? { horizontalAlign } : {}
	} : void 0;
};
var isParagraphNode = (node) => node?.type === "paragraph";
var toTextboxParagraphBlocks = (node, context) => {
	const shapeTextboxNode = node.type === "shapeTextbox" ? node : resolveNestedShapeTextboxNode(node);
	const paragraphToFlowBlocks$1 = context.converters?.paragraphToFlowBlocks;
	if (!shapeTextboxNode || !paragraphToFlowBlocks$1 || !Array.isArray(shapeTextboxNode.content)) return [];
	const textboxBlocks = [];
	for (const child of shapeTextboxNode.content) {
		if (!isParagraphNode(child)) continue;
		const convertedBlocks = paragraphToFlowBlocks$1({
			para: child,
			nextBlockId: context.nextBlockId,
			positions: context.positions,
			storyKey: context.storyKey,
			trackedChangesConfig: context.trackedChangesConfig,
			bookmarks: context.bookmarks,
			hyperlinkConfig: context.hyperlinkConfig,
			themeColors: context.themeColors,
			converters: context.converters,
			converterContext: context.converterContext,
			enableComments: context.enableComments,
			previousParagraphFont: getLastParagraphFont(textboxBlocks)
		});
		textboxBlocks.push(...convertedBlocks);
	}
	return textboxBlocks.filter((block) => block.kind === "paragraph");
};
function hydrateTextboxDrawingContent(node, drawingBlock, context) {
	if (drawingBlock.drawingKind !== "textboxShape") return drawingBlock;
	return {
		...drawingBlock,
		contentBlocks: toTextboxParagraphBlocks(node, context)
	};
}
var parseTextboxInsetValue = (value) => {
	const trimmed = value.trim();
	if (!trimmed) return void 0;
	if (trimmed.endsWith("pt")) return ptToPx(parseFloat(trimmed.slice(0, -2)));
	if (trimmed.endsWith("px")) return pickNumber(trimmed.slice(0, -2));
	if (trimmed.endsWith("in")) {
		const inches = parseFloat(trimmed.slice(0, -2));
		return Number.isFinite(inches) ? inches * 96 : void 0;
	}
	return pickNumber(trimmed);
};
var resolveTextboxInsetsFromAttrs = (attrs) => {
	const explicitInsets = normalizeTextInsets(attrs.textInsets);
	if (explicitInsets) return explicitInsets;
	const textboxAttrs = isPlainObject(attrs.attributes) ? attrs.attributes : void 0;
	const inset = typeof textboxAttrs?.inset === "string" ? textboxAttrs.inset : void 0;
	if (!inset) return void 0;
	const values = inset.split(",").map((entry) => parseTextboxInsetValue(entry));
	if (values.length !== 4 || values.some((entry) => entry == null)) return void 0;
	return {
		top: values[1],
		right: values[2],
		bottom: values[3],
		left: values[0]
	};
};
var resolveTextboxVerticalAlignFromAttrs = (attrs) => {
	const explicitAlign = normalizeTextVerticalAlign(attrs.textVerticalAlign);
	if (explicitAlign) return explicitAlign;
	const textboxAttrs = isPlainObject(attrs.attributes) ? attrs.attributes : void 0;
	const style = typeof textboxAttrs?.style === "string" ? textboxAttrs.style : void 0;
	if (!style) return void 0;
	const match = style.match(/v-text-anchor\s*:\s*(top|middle|bottom)/i);
	if (!match) return void 0;
	if (match[1].toLowerCase() === "middle") return "center";
	return match[1].toLowerCase();
};
var resolveNestedShapeTextboxNode = (node) => Array.isArray(node.content) ? node.content.find((child) => child?.type === "shapeTextbox") : void 0;
var normalizeWrapType$1 = (value) => {
	if (typeof value !== "string") return void 0;
	return WRAP_TYPES$2.has(value) ? value : void 0;
};
var normalizeWrapText$1 = (value) => {
	if (typeof value !== "string") return void 0;
	return WRAP_TEXT_VALUES$2.has(value) ? value : void 0;
};
var normalizePolygon$1 = (value) => {
	if (!Array.isArray(value)) return void 0;
	const polygon = [];
	value.forEach((point$1) => {
		if (!Array.isArray(point$1) || point$1.length < 2) return;
		const x = pickNumber(point$1[0]);
		const y = pickNumber(point$1[1]);
		if (x == null || y == null) return;
		polygon.push([x, y]);
	});
	return polygon.length > 0 ? polygon : void 0;
};
var normalizeWrap$2 = (value) => {
	if (!isPlainObject(value)) return;
	const type = normalizeWrapType$1(value.type);
	if (!type || type === "Inline") return;
	const wrap$1 = { type };
	const attrs = isPlainObject(value.attrs) ? value.attrs : {};
	const wrapText = normalizeWrapText$1(attrs.wrapText);
	if (wrapText) wrap$1.wrapText = wrapText;
	const distTop = pickNumber(attrs.distTop ?? attrs.distT);
	if (distTop != null) wrap$1.distTop = distTop;
	const distBottom = pickNumber(attrs.distBottom ?? attrs.distB);
	if (distBottom != null) wrap$1.distBottom = distBottom;
	const distLeft = pickNumber(attrs.distLeft ?? attrs.distL);
	if (distLeft != null) wrap$1.distLeft = distLeft;
	const distRight = pickNumber(attrs.distRight ?? attrs.distR);
	if (distRight != null) wrap$1.distRight = distRight;
	const polygon = normalizePolygon$1(attrs.polygon);
	if (polygon) wrap$1.polygon = polygon;
	const behindDoc = toBoolean(attrs.behindDoc);
	if (behindDoc != null) wrap$1.behindDoc = behindDoc;
	return wrap$1;
};
var normalizeAnchorRelative$1 = (value, allowed) => {
	if (typeof value !== "string") return void 0;
	return allowed.has(value) ? value : void 0;
};
var normalizeAnchorAlign$1 = (value, allowed) => {
	if (typeof value !== "string") return void 0;
	return allowed.has(value) ? value : void 0;
};
var normalizeAnchorData$1 = (value, attrs, wrapBehindDoc) => {
	const raw = isPlainObject(value) ? value : void 0;
	const marginOffset = isPlainObject(attrs.marginOffset) ? attrs.marginOffset : void 0;
	const simplePos = isPlainObject(attrs.simplePos) ? attrs.simplePos : void 0;
	const originalAttrs = isPlainObject(attrs.originalAttributes) ? attrs.originalAttributes : void 0;
	const isAnchored = attrs.isAnchor === true || Boolean(raw);
	const anchor = {};
	if (isAnchored) anchor.isAnchored = true;
	const hRelative = normalizeAnchorRelative$1(raw?.hRelativeFrom, H_RELATIVE_VALUES$2);
	if (hRelative) anchor.hRelativeFrom = hRelative;
	const vRelative = normalizeAnchorRelative$1(raw?.vRelativeFrom, V_RELATIVE_VALUES$2);
	if (vRelative) anchor.vRelativeFrom = vRelative;
	const alignH = normalizeAnchorAlign$1(raw?.alignH, H_ALIGN_VALUES$1);
	if (alignH) anchor.alignH = alignH;
	const alignV = normalizeAnchorAlign$1(raw?.alignV, V_ALIGN_VALUES$1);
	if (alignV) anchor.alignV = alignV;
	const offsetH = pickNumber(marginOffset?.horizontal ?? marginOffset?.left ?? raw?.offsetH ?? simplePos?.x);
	if (offsetH != null) anchor.offsetH = offsetH;
	const offsetV = pickNumber(marginOffset?.top ?? marginOffset?.vertical ?? raw?.offsetV ?? simplePos?.y);
	if (offsetV != null) anchor.offsetV = offsetV;
	const behindDoc = toBoolean(raw?.behindDoc ?? wrapBehindDoc ?? originalAttrs?.behindDoc);
	if (behindDoc != null) anchor.behindDoc = behindDoc;
	return anchor.isAnchored || anchor.hRelativeFrom != null || anchor.vRelativeFrom != null || anchor.alignH != null || anchor.alignV != null || anchor.offsetH != null || anchor.offsetV != null || anchor.behindDoc != null ? anchor : void 0;
};
const buildDrawingBlock = (rawAttrs, nextBlockId, positions, node, geometry, drawingKind, extraProps) => {
	const normalizedWrap = normalizeWrap$2(rawAttrs.wrap);
	if (normalizedWrap) mergeWrapDistancesFromPadding(normalizedWrap, toBoxSpacing(rawAttrs.padding));
	const sourceAnchor = isPlainObject(rawAttrs.sourceAnchor) ? rawAttrs.sourceAnchor : void 0;
	const baseAnchor = normalizeAnchorData$1(rawAttrs.anchorData, rawAttrs, normalizedWrap?.behindDoc);
	const pos = positions.get(node);
	const attrsWithPm = { ...rawAttrs };
	if (pos) {
		attrsWithPm.pmStart = pos.start;
		attrsWithPm.pmEnd = pos.end;
	}
	const resolvedZIndex = resolveFloatingZIndex(baseAnchor?.behindDoc === true || normalizedWrap?.behindDoc === true, normalizeZIndex(rawAttrs.originalAttributes), coerceNumber(rawAttrs.zIndex) ?? 1);
	return {
		kind: "drawing",
		id: nextBlockId("drawing"),
		drawingKind,
		padding: toBoxSpacing(rawAttrs.padding),
		margin: toBoxSpacing(rawAttrs.marginOffset) ?? toBoxSpacing(rawAttrs.margin),
		anchor: baseAnchor,
		wrap: normalizedWrap,
		zIndex: resolvedZIndex,
		drawingContentId: typeof rawAttrs.drawingContentId === "string" ? rawAttrs.drawingContentId : void 0,
		drawingContent: toDrawingContentSnapshot(rawAttrs.drawingContent),
		attrs: attrsWithPm,
		geometry,
		shapeKind: typeof rawAttrs.kind === "string" ? rawAttrs.kind : void 0,
		customGeometry: rawAttrs.customGeometry != null ? rawAttrs.customGeometry : void 0,
		fillColor: normalizeFillColor(rawAttrs.fillColor),
		strokeColor: normalizeStrokeColor(rawAttrs.strokeColor),
		strokeWidth: coerceNumber(rawAttrs.strokeWidth),
		textContent: normalizeTextContent(rawAttrs.textContent),
		textAlign: typeof rawAttrs.textAlign === "string" ? rawAttrs.textAlign : void 0,
		textVerticalAlign: normalizeTextVerticalAlign(rawAttrs.textVerticalAlign),
		textInsets: normalizeTextInsets(rawAttrs.textInsets),
		sourceAnchor,
		...extraProps
	};
};
function vectorShapeNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs$2(node);
	if (isHiddenDrawing$1(rawAttrs)) return null;
	const effectExtent = normalizeEffectExtent(rawAttrs.effectExtent);
	const baseWidth = coercePositiveNumber(rawAttrs.width, 1);
	const baseHeight = coercePositiveNumber(rawAttrs.height, 1);
	const extraWidth = (effectExtent?.left ?? 0) + (effectExtent?.right ?? 0);
	const extraHeight = (effectExtent?.top ?? 0) + (effectExtent?.bottom ?? 0);
	return buildDrawingBlock(rawAttrs, nextBlockId, positions, node, {
		width: coercePositiveNumber(baseWidth + extraWidth, 1),
		height: coercePositiveNumber(baseHeight + extraHeight, 1),
		rotation: coerceNumber(rawAttrs.rotation) ?? 0,
		flipH: coerceBoolean(rawAttrs.flipH) ?? false,
		flipV: coerceBoolean(rawAttrs.flipV) ?? false
	}, "vectorShape", {
		lineEnds: normalizeLineEnds(rawAttrs.lineEnds),
		effectExtent
	});
}
function shapeGroupNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs$2(node);
	if (isHiddenDrawing$1(rawAttrs)) return null;
	const groupTransform = isShapeGroupTransform(rawAttrs.groupTransform) ? { ...rawAttrs.groupTransform } : void 0;
	const size = normalizeShapeSize(rawAttrs.size);
	const width = size?.width ?? groupTransform?.width ?? 1;
	const height = size?.height ?? groupTransform?.height ?? 1;
	return buildDrawingBlock(rawAttrs, nextBlockId, positions, node, {
		width: coercePositiveNumber(width, 1),
		height: coercePositiveNumber(height, 1),
		rotation: coerceNumber(rawAttrs.rotation) ?? 0,
		flipH: coerceBoolean(rawAttrs.flipH) ?? false,
		flipV: coerceBoolean(rawAttrs.flipV) ?? false
	}, "shapeGroup", {
		groupTransform,
		shapes: normalizeShapeGroupChildren(rawAttrs.shapes),
		size
	});
}
function shapeContainerNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs$2(node);
	if (isHiddenDrawing$1(rawAttrs)) return null;
	const geometry = {
		width: coercePositiveNumber(rawAttrs.width, 1),
		height: coercePositiveNumber(rawAttrs.height, 1),
		rotation: coerceNumber(rawAttrs.rotation) ?? 0,
		flipH: coerceBoolean(rawAttrs.flipH) ?? false,
		flipV: coerceBoolean(rawAttrs.flipV) ?? false
	};
	const shapeTextboxNode = resolveNestedShapeTextboxNode(node);
	const textboxAttrs = shapeTextboxNode ? getAttrs$2(shapeTextboxNode) : {};
	const textContent = shapeTextboxNode ? extractTextboxTextContent(shapeTextboxNode) : void 0;
	return buildDrawingBlock({
		...rawAttrs,
		...textContent ? { textContent } : {},
		...rawAttrs.textAlign == null && textContent?.horizontalAlign ? { textAlign: textContent.horizontalAlign } : {},
		...rawAttrs.textInsets == null ? { textInsets: resolveTextboxInsetsFromAttrs(textboxAttrs) } : {},
		...rawAttrs.textVerticalAlign == null ? { textVerticalAlign: resolveTextboxVerticalAlignFromAttrs(textboxAttrs) } : {}
	}, nextBlockId, positions, node, geometry, "textboxShape", { contentBlocks: [] });
}
function shapeTextboxNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs$2(node);
	if (isHiddenDrawing$1(rawAttrs)) return null;
	const geometry = {
		width: coercePositiveNumber(rawAttrs.width, 1),
		height: coercePositiveNumber(rawAttrs.height, 1),
		rotation: coerceNumber(rawAttrs.rotation) ?? 0,
		flipH: coerceBoolean(rawAttrs.flipH) ?? false,
		flipV: coerceBoolean(rawAttrs.flipV) ?? false
	};
	const textContent = extractTextboxTextContent(node);
	return buildDrawingBlock({
		...rawAttrs,
		...textContent ? { textContent } : {},
		...rawAttrs.textAlign == null && textContent?.horizontalAlign ? { textAlign: textContent.horizontalAlign } : {},
		...rawAttrs.textInsets == null ? { textInsets: resolveTextboxInsetsFromAttrs(rawAttrs) } : {},
		...rawAttrs.textVerticalAlign == null ? { textVerticalAlign: resolveTextboxVerticalAlignFromAttrs(rawAttrs) } : {}
	}, nextBlockId, positions, node, geometry, "textboxShape", { contentBlocks: [] });
}
function handleVectorShapeNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const drawingBlock = vectorShapeNodeToDrawingBlock(node, nextBlockId, positions);
	if (drawingBlock) {
		blocks.push(drawingBlock);
		recordBlockKind?.(drawingBlock.kind);
	}
}
function handleShapeGroupNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const drawingBlock = shapeGroupNodeToDrawingBlock(node, nextBlockId, positions);
	if (drawingBlock) {
		blocks.push(drawingBlock);
		recordBlockKind?.(drawingBlock.kind);
	}
}
function handleShapeContainerNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const drawingBlock = shapeContainerNodeToDrawingBlock(node, nextBlockId, positions);
	if (drawingBlock) {
		blocks.push(hydrateTextboxDrawingContent(node, drawingBlock, context));
		recordBlockKind?.(drawingBlock.kind);
	}
}
function handleShapeTextboxNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const drawingBlock = shapeTextboxNodeToDrawingBlock(node, nextBlockId, positions);
	if (drawingBlock) {
		blocks.push(hydrateTextboxDrawingContent(node, drawingBlock, context));
		recordBlockKind?.(drawingBlock.kind);
	}
}
var getAttrs$1 = (node) => {
	return isPlainObject(node.attrs) ? { ...node.attrs } : {};
};
var parseFullWidth = (value) => {
	if (typeof value === "string") {
		const trimmed = value.trim();
		if (trimmed.endsWith("%")) return {
			width: trimmed === "100%" ? 1 : null,
			isFullWidth: trimmed === "100%"
		};
		return {
			width: pickNumber(trimmed) ?? null,
			isFullWidth: false
		};
	}
	return {
		width: pickNumber(value) ?? null,
		isFullWidth: false
	};
};
function contentBlockNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs$1(node);
	const indentLeft = pickNumber(rawAttrs.hrIndentLeft);
	const indentRight = pickNumber(rawAttrs.hrIndentRight);
	if (rawAttrs.horizontalRule !== true) return null;
	const size = isPlainObject(rawAttrs.size) ? rawAttrs.size : void 0;
	const { width, isFullWidth } = parseFullWidth(size?.width);
	const height = pickNumber(size?.height);
	if (!height || height <= 0) return null;
	if (!isFullWidth && (!width || width <= 0)) return null;
	if (isFullWidth) rawAttrs.isFullWidth = true;
	if (indentLeft != null || indentRight != null) {
		rawAttrs.hrIndentLeft = indentLeft;
		rawAttrs.hrIndentRight = indentRight;
	}
	if (typeof rawAttrs.background === "string" && rawAttrs.background.trim()) rawAttrs.fillColor = rawAttrs.background;
	return buildDrawingBlock(rawAttrs, nextBlockId, positions, node, {
		width: isFullWidth ? 1 : width ?? 1,
		height,
		rotation: 0,
		flipH: false,
		flipV: false
	}, "vectorShape", { strokeColor: null });
}
function inlineContentBlockConverter(node, { positions, nextBlockId, paragraphAttrs }) {
	const attrs = node.attrs ?? {};
	if (!attrs.horizontalRule) return null;
	const indent = paragraphAttrs?.indent;
	const hrIndentLeft = typeof indent?.left === "number" ? indent.left : void 0;
	const hrIndentRight = typeof indent?.right === "number" ? indent.right : void 0;
	return contentBlockNodeToDrawingBlock(typeof hrIndentLeft === "number" && hrIndentLeft !== 0 || typeof hrIndentRight === "number" && hrIndentRight !== 0 ? {
		...node,
		attrs: {
			...attrs,
			hrIndentLeft,
			hrIndentRight
		}
	} : node, nextBlockId, positions);
}
var WRAP_TYPES$1 = new Set([
	"None",
	"Square",
	"Tight",
	"Through",
	"TopAndBottom",
	"Inline"
]);
var WRAP_TEXT_VALUES$1 = new Set([
	"bothSides",
	"left",
	"right",
	"largest"
]);
var H_RELATIVE_VALUES$1 = new Set([
	"column",
	"page",
	"margin"
]);
var V_RELATIVE_VALUES$1 = new Set([
	"paragraph",
	"page",
	"margin"
]);
var H_ALIGN_VALUES = new Set([
	"left",
	"center",
	"right"
]);
var V_ALIGN_VALUES = new Set([
	"top",
	"center",
	"bottom"
]);
var isPlainObject$1 = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
var sourceAnchorFromAttrs = (attrs) => {
	const sourceAnchor = attrs.sourceAnchor;
	return isPlainObject$1(sourceAnchor) ? sourceAnchor : void 0;
};
var isAllowedObjectFit = (value) => {
	return value === "contain" || value === "cover" || value === "fill" || value === "scale-down";
};
var isHiddenDrawing = (attrs) => {
	if (toBoolean$1(attrs.hidden) === true) return true;
	return typeof attrs.visibility === "string" && attrs.visibility.toLowerCase() === "hidden";
};
function toBoxSpacing$1(spacing) {
	if (!spacing) return;
	const result = {};
	[
		"top",
		"right",
		"bottom",
		"left"
	].forEach((side) => {
		const value = spacing[side];
		if (isFiniteNumber(value)) result[side] = Number(value);
	});
	return Object.keys(result).length > 0 ? result : void 0;
}
var normalizeWrapType = (value) => {
	if (typeof value !== "string") return void 0;
	return WRAP_TYPES$1.has(value) ? value : void 0;
};
var normalizeWrapText = (value) => {
	if (typeof value !== "string") return void 0;
	return WRAP_TEXT_VALUES$1.has(value) ? value : void 0;
};
var normalizePolygon = (value) => {
	if (!Array.isArray(value)) return void 0;
	const polygon = [];
	value.forEach((point$1) => {
		if (!Array.isArray(point$1) || point$1.length < 2) return;
		const x = pickNumber(point$1[0]);
		const y = pickNumber(point$1[1]);
		if (x == null || y == null) return;
		polygon.push([x, y]);
	});
	return polygon.length > 0 ? polygon : void 0;
};
var toBoolean$1 = (value) => {
	if (value === void 0 || value === null) return void 0;
	if (typeof value === "boolean") return value;
	if (typeof value === "number") {
		if (value === 1) return true;
		if (value === 0) return false;
	}
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (normalized === "1" || normalized === "true") return true;
		if (normalized === "0" || normalized === "false") return false;
	}
};
var normalizeWrap$1 = (value) => {
	if (!isPlainObject$1(value)) return;
	const type = normalizeWrapType(value.type);
	if (!type) return;
	const wrap$1 = { type };
	const attrs = isPlainObject$1(value.attrs) ? value.attrs : {};
	const wrapText = normalizeWrapText(attrs.wrapText);
	if (wrapText) wrap$1.wrapText = wrapText;
	const distTop = pickNumber(attrs.distTop ?? attrs.distT);
	if (distTop != null) wrap$1.distTop = distTop;
	const distBottom = pickNumber(attrs.distBottom ?? attrs.distB);
	if (distBottom != null) wrap$1.distBottom = distBottom;
	const distLeft = pickNumber(attrs.distLeft ?? attrs.distL);
	if (distLeft != null) wrap$1.distLeft = distLeft;
	const distRight = pickNumber(attrs.distRight ?? attrs.distR);
	if (distRight != null) wrap$1.distRight = distRight;
	const polygon = normalizePolygon(attrs.polygon);
	if (polygon) wrap$1.polygon = polygon;
	const behindDoc = toBoolean$1(attrs.behindDoc);
	if (behindDoc != null) wrap$1.behindDoc = behindDoc;
	return wrap$1;
};
var normalizeAnchorRelative = (value, allowed) => {
	if (typeof value !== "string") return void 0;
	return allowed.has(value) ? value : void 0;
};
var normalizeAnchorAlign = (value, allowed) => {
	if (typeof value !== "string") return void 0;
	return allowed.has(value) ? value : void 0;
};
var normalizeAnchorData = (value, attrs, wrapBehindDoc) => {
	const raw = isPlainObject$1(value) ? value : void 0;
	const marginOffset = isPlainObject$1(attrs.marginOffset) ? attrs.marginOffset : void 0;
	const simplePos = isPlainObject$1(attrs.simplePos) ? attrs.simplePos : void 0;
	const originalAttrs = isPlainObject$1(attrs.originalAttributes) ? attrs.originalAttributes : void 0;
	const isAnchored = attrs.isAnchor === true || Boolean(raw);
	const anchor = {};
	if (isAnchored) anchor.isAnchored = true;
	const hRelative = normalizeAnchorRelative(raw?.hRelativeFrom, H_RELATIVE_VALUES$1);
	if (hRelative) anchor.hRelativeFrom = hRelative;
	const vRelative = normalizeAnchorRelative(raw?.vRelativeFrom, V_RELATIVE_VALUES$1);
	if (vRelative) anchor.vRelativeFrom = vRelative;
	const alignH = normalizeAnchorAlign(raw?.alignH, H_ALIGN_VALUES);
	if (alignH) anchor.alignH = alignH;
	const alignV = normalizeAnchorAlign(raw?.alignV, V_ALIGN_VALUES);
	if (alignV) anchor.alignV = alignV;
	const offsetH = pickNumber(marginOffset?.horizontal ?? marginOffset?.left ?? raw?.offsetH ?? simplePos?.x);
	if (offsetH != null) anchor.offsetH = offsetH;
	const offsetV = pickNumber(marginOffset?.top ?? marginOffset?.vertical ?? raw?.offsetV ?? simplePos?.y);
	if (offsetV != null) anchor.offsetV = offsetV;
	const behindDoc = toBoolean$1(raw?.behindDoc ?? wrapBehindDoc ?? originalAttrs?.behindDoc);
	if (behindDoc != null) anchor.behindDoc = behindDoc;
	return anchor.isAnchored || anchor.hRelativeFrom != null || anchor.vRelativeFrom != null || anchor.alignH != null || anchor.alignV != null || anchor.offsetH != null || anchor.offsetV != null || anchor.behindDoc != null ? anchor : void 0;
};
function imageNodeToBlock(node, nextBlockId, positions, _trackedMeta, _trackedChanges) {
	const attrs = node.attrs ?? {};
	if (isHiddenDrawing(attrs)) return null;
	if (!attrs.src || typeof attrs.src !== "string") return null;
	const pos = positions.get(node);
	const attrsWithPm = { ...attrs };
	if (pos) {
		attrsWithPm.pmStart = pos.start;
		attrsWithPm.pmEnd = pos.end;
	}
	const size = attrs.size ?? {};
	const width = typeof size.width === "number" && Number.isFinite(size.width) ? size.width : void 0;
	const height = typeof size.height === "number" && Number.isFinite(size.height) ? size.height : void 0;
	const explicitDisplay = typeof attrs.display === "string" ? attrs.display : void 0;
	const normalizedWrap = normalizeWrap$1(attrs.wrap);
	if (normalizedWrap) mergeWrapDistancesFromPadding(normalizedWrap, toBoxSpacing$1(attrs.padding));
	let anchor = normalizeAnchorData(attrs.anchorData, attrs, normalizedWrap?.behindDoc);
	if (!anchor && normalizedWrap) {
		anchor = { isAnchored: true };
		if (normalizedWrap.behindDoc != null) anchor.behindDoc = normalizedWrap.behindDoc;
	}
	const isInline$1 = normalizedWrap?.type === "Inline" || typeof attrs.inline === "boolean" && attrs.inline;
	const display = explicitDisplay === "inline" || explicitDisplay === "block" ? explicitDisplay : isInline$1 ? "inline" : "block";
	const explicitObjectFit = typeof attrs.objectFit === "string" ? attrs.objectFit : void 0;
	const shouldCover = attrs.shouldCover === true;
	const isAnchor = anchor?.isAnchored ?? (typeof attrs.isAnchor === "boolean" ? attrs.isAnchor : false);
	const lum = isPlainObject$1(attrs.lum) ? attrs.lum : void 0;
	const lumBright = pickNumber(lum?.bright);
	const lumContrast = pickNumber(lum?.contrast);
	const alphaModFixAmt = pickNumber((isPlainObject$1(attrs.alphaModFix) ? attrs.alphaModFix : void 0)?.amt);
	const objectFit = isAllowedObjectFit(explicitObjectFit) ? explicitObjectFit : shouldCover ? "cover" : display === "inline" ? "scale-down" : isAnchor ? "contain" : "contain";
	const zIndexFromRelativeHeight = normalizeZIndex(attrs.originalAttributes);
	const zIndex = resolveFloatingZIndex(anchor?.behindDoc === true, zIndexFromRelativeHeight);
	const transformData = isPlainObject$1(attrs.transformData) ? attrs.transformData : void 0;
	const rotation = typeof transformData?.rotation === "number" ? transformData.rotation : void 0;
	const flipH = typeof transformData?.horizontalFlip === "boolean" ? transformData.horizontalFlip : void 0;
	const flipV = typeof transformData?.verticalFlip === "boolean" ? transformData.verticalFlip : void 0;
	const hyperlink = readImageHyperlink(attrs.hyperlink);
	return {
		kind: "image",
		id: nextBlockId("image"),
		src: attrs.src,
		width,
		height,
		alt: typeof attrs.alt === "string" ? attrs.alt : void 0,
		title: typeof attrs.title === "string" ? attrs.title : void 0,
		objectFit,
		display,
		padding: toBoxSpacing$1(attrs.padding),
		margin: toBoxSpacing$1(attrs.marginOffset),
		anchor,
		wrap: normalizedWrap,
		...zIndex !== void 0 && { zIndex },
		attrs: attrsWithPm,
		gain: typeof attrs.gain === "string" || typeof attrs.gain === "number" ? attrs.gain : void 0,
		blacklevel: typeof attrs.blacklevel === "string" || typeof attrs.blacklevel === "number" ? attrs.blacklevel : void 0,
		grayscale: typeof attrs.grayscale === "boolean" ? attrs.grayscale : void 0,
		lum: lumBright != null || lumContrast != null ? {
			...lumBright != null ? { bright: lumBright } : {},
			...lumContrast != null ? { contrast: lumContrast } : {}
		} : void 0,
		alphaModFix: alphaModFixAmt != null ? { amt: alphaModFixAmt } : void 0,
		...rotation !== void 0 && { rotation },
		...flipH !== void 0 && { flipH },
		...flipV !== void 0 && { flipV },
		...hyperlink ? { hyperlink } : {},
		sourceAnchor: sourceAnchorFromAttrs(attrs)
	};
}
function handleImageNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions, trackedChangesConfig } = context;
	const trackedMeta = trackedChangesConfig.enabled ? collectTrackedChangeFromMarks(node.marks ?? [], context.storyKey) : void 0;
	if (shouldHideTrackedNode(trackedMeta, trackedChangesConfig)) return;
	const imageBlock = imageNodeToBlock(node, nextBlockId, positions, trackedMeta, trackedChangesConfig);
	if (imageBlock && imageBlock.kind === "image") {
		annotateBlockWithTrackedChange(imageBlock, trackedMeta, trackedChangesConfig);
		blocks.push(imageBlock);
		recordBlockKind?.(imageBlock.kind);
		return imageBlock;
	}
}
var WRAP_TYPES = new Set([
	"None",
	"Square",
	"Tight",
	"Through",
	"TopAndBottom",
	"Inline"
]);
var WRAP_TEXT_VALUES = new Set([
	"bothSides",
	"left",
	"right",
	"largest"
]);
var H_RELATIVE_VALUES = new Set([
	"column",
	"page",
	"margin"
]);
var V_RELATIVE_VALUES = new Set([
	"paragraph",
	"page",
	"margin"
]);
var getAttrs = (node) => {
	return isPlainObject(node.attrs) ? node.attrs : {};
};
var normalizeWrap = (value) => {
	if (!isPlainObject(value)) return void 0;
	const type = typeof value.type === "string" && WRAP_TYPES.has(value.type) ? value.type : void 0;
	if (!type || type === "Inline") return void 0;
	const wrap$1 = { type };
	const attrs = isPlainObject(value.attrs) ? value.attrs : {};
	const wrapText = typeof attrs.wrapText === "string" && WRAP_TEXT_VALUES.has(attrs.wrapText) ? attrs.wrapText : void 0;
	if (wrapText) wrap$1.wrapText = wrapText;
	const distTop = pickNumber(attrs.distTop ?? attrs.distT);
	if (distTop != null) wrap$1.distTop = distTop;
	const distBottom = pickNumber(attrs.distBottom ?? attrs.distB);
	if (distBottom != null) wrap$1.distBottom = distBottom;
	const distLeft = pickNumber(attrs.distLeft ?? attrs.distL);
	if (distLeft != null) wrap$1.distLeft = distLeft;
	const distRight = pickNumber(attrs.distRight ?? attrs.distR);
	if (distRight != null) wrap$1.distRight = distRight;
	const behindDoc = toBoolean(attrs.behindDoc);
	if (behindDoc != null) wrap$1.behindDoc = behindDoc;
	return wrap$1;
};
var normalizeAnchor = (value, attrs, wrapBehindDoc) => {
	const raw = isPlainObject(value) ? value : void 0;
	const marginOffset = isPlainObject(attrs.marginOffset) ? attrs.marginOffset : void 0;
	const simplePos = isPlainObject(attrs.simplePos) ? attrs.simplePos : void 0;
	const isAnchored = attrs.isAnchor === true || Boolean(raw);
	const anchor = {};
	if (isAnchored) anchor.isAnchored = true;
	const hRelative = typeof raw?.hRelativeFrom === "string" && H_RELATIVE_VALUES.has(raw.hRelativeFrom) ? raw.hRelativeFrom : void 0;
	if (hRelative) anchor.hRelativeFrom = hRelative;
	const vRelative = typeof raw?.vRelativeFrom === "string" && V_RELATIVE_VALUES.has(raw.vRelativeFrom) ? raw.vRelativeFrom : void 0;
	if (vRelative) anchor.vRelativeFrom = vRelative;
	const offsetH = pickNumber(marginOffset?.horizontal ?? marginOffset?.left ?? raw?.offsetH ?? simplePos?.x);
	if (offsetH != null) anchor.offsetH = offsetH;
	const offsetV = pickNumber(marginOffset?.top ?? marginOffset?.vertical ?? raw?.offsetV ?? simplePos?.y);
	if (offsetV != null) anchor.offsetV = offsetV;
	const behindDoc = toBoolean(raw?.behindDoc ?? wrapBehindDoc);
	if (behindDoc != null) anchor.behindDoc = behindDoc;
	return anchor.isAnchored || anchor.hRelativeFrom != null || anchor.vRelativeFrom != null || anchor.offsetH != null || anchor.offsetV != null || anchor.behindDoc != null ? anchor : void 0;
};
var EMPTY_CHART_DATA = {
	chartType: "unknown",
	series: []
};
function chartNodeToDrawingBlock(node, nextBlockId, positions) {
	const rawAttrs = getAttrs(node);
	const chartData = rawAttrs.chartData && typeof rawAttrs.chartData === "object" ? rawAttrs.chartData : EMPTY_CHART_DATA;
	const geometry = {
		width: coercePositiveNumber(rawAttrs.width, 400),
		height: coercePositiveNumber(rawAttrs.height, 300),
		rotation: 0,
		flipH: false,
		flipV: false
	};
	const normalizedWrap = normalizeWrap(rawAttrs.wrap);
	const sourceAnchor = isPlainObject(rawAttrs.sourceAnchor) ? rawAttrs.sourceAnchor : void 0;
	const anchor = normalizeAnchor(rawAttrs.anchorData, rawAttrs, normalizedWrap?.behindDoc);
	const pos = positions.get(node);
	const attrsWithPm = { ...rawAttrs };
	if (pos) {
		attrsWithPm.pmStart = pos.start;
		attrsWithPm.pmEnd = pos.end;
	}
	const resolvedZIndex = resolveFloatingZIndex(anchor?.behindDoc === true || normalizedWrap?.behindDoc === true, normalizeZIndex(rawAttrs.originalAttributes), 1);
	return {
		kind: "drawing",
		id: nextBlockId("drawing"),
		drawingKind: "chart",
		geometry,
		chartData,
		chartRelId: typeof rawAttrs.chartRelId === "string" ? rawAttrs.chartRelId : void 0,
		chartPartPath: typeof rawAttrs.chartPartPath === "string" ? rawAttrs.chartPartPath : void 0,
		padding: toBoxSpacing(rawAttrs.padding),
		margin: toBoxSpacing(rawAttrs.marginOffset),
		anchor,
		wrap: normalizedWrap,
		zIndex: resolvedZIndex,
		drawingContentId: typeof rawAttrs.drawingContentId === "string" ? rawAttrs.drawingContentId : void 0,
		drawingContent: toDrawingContentSnapshot(rawAttrs.drawingContent),
		attrs: attrsWithPm,
		sourceAnchor
	};
}
function handleChartNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const drawingBlock = chartNodeToDrawingBlock(node, nextBlockId, positions);
	blocks.push(drawingBlock);
	recordBlockKind?.(drawingBlock.kind);
}
const hydrateTableStyleAttrs = (tableNode, context, effectiveStyleId) => {
	const hydration = {};
	const tableProps = tableNode.attrs?.tableProperties ?? null;
	let inlineBorders;
	let inlinePadding;
	if (tableProps) {
		const padding = convertCellMarginsToPx(tableProps.cellMargins);
		if (padding) inlinePadding = normalizeCellPaddingTopBottom(padding);
		if (tableProps.borders && typeof tableProps.borders === "object") inlineBorders = normalizeTableBorders(tableProps.borders);
		if (typeof tableProps.justification === "string") hydration.justification = tableProps.justification;
		const tableIndent = normalizeTableIndent(tableProps.tableIndent);
		if (tableIndent) hydration.tableIndent = tableIndent;
		if (typeof tableProps.tableLayout === "string") hydration.tableLayout = tableProps.tableLayout;
		const tableWidth = normalizeTableWidth(tableProps.tableWidth);
		if (tableWidth) hydration.tableWidth = tableWidth;
		const tableCellSpacing = normalizeTableSpacing(tableProps.tableCellSpacing);
		if (tableCellSpacing) hydration.tableCellSpacing = tableCellSpacing;
	}
	const styleId = effectiveStyleId === null ? void 0 : effectiveStyleId ?? (typeof tableNode.attrs?.tableStyleId === "string" ? tableNode.attrs.tableStyleId : void 0);
	if (styleId && context?.translatedLinkedStyles) {
		const resolved = resolveTableProperties(styleId, context.translatedLinkedStyles);
		if (resolved.borders) {
			const styleBorders = normalizeTableBorders(resolved.borders);
			hydration.borders = inlineBorders && styleBorders ? {
				...styleBorders,
				...inlineBorders
			} : inlineBorders ?? styleBorders;
		} else if (inlineBorders) hydration.borders = inlineBorders;
		if (resolved.cellMargins) {
			const stylePadding = convertCellMarginsToPx(resolved.cellMargins);
			if (stylePadding) {
				const normalizedStylePadding = normalizeCellPaddingTopBottom(stylePadding);
				hydration.cellPadding = inlinePadding ? {
					...normalizedStylePadding,
					...inlinePadding
				} : normalizedStylePadding;
			} else if (inlinePadding) hydration.cellPadding = inlinePadding;
		} else if (inlinePadding) hydration.cellPadding = inlinePadding;
		if (!hydration.justification && resolved.justification) hydration.justification = resolved.justification;
		if (!hydration.tableIndent && resolved.tableIndent) {
			const tableIndent = normalizeTableIndent(resolved.tableIndent);
			if (tableIndent) hydration.tableIndent = tableIndent;
		}
		if (!hydration.tableLayout && resolved.tableLayout) hydration.tableLayout = resolved.tableLayout;
		if (!hydration.tableCellSpacing && resolved.tableCellSpacing) {
			const tableCellSpacing = normalizeTableSpacing(resolved.tableCellSpacing);
			if (tableCellSpacing) hydration.tableCellSpacing = tableCellSpacing;
		}
		if (!hydration.tableWidth && resolved.tableWidth) {
			const tableWidth = normalizeTableWidth(resolved.tableWidth);
			if (tableWidth) hydration.tableWidth = tableWidth;
		}
	} else {
		if (inlineBorders) hydration.borders = inlineBorders;
		if (inlinePadding) hydration.cellPadding = inlinePadding;
	}
	return Object.keys(hydration).length > 0 ? hydration : null;
};
var normalizeTableBorders = (value) => {
	if (!value) return void 0;
	const sides = [
		"top",
		"bottom",
		"left",
		"right",
		"insideH",
		"insideV",
		"start",
		"end"
	];
	const result = {};
	for (const side of sides) {
		const border = value[side];
		if (!border || typeof border !== "object") continue;
		const converted = convertTableBorderValue(adjustBorderSize(border));
		if (converted) result[side] = converted;
	}
	return Object.keys(result).length > 0 ? result : void 0;
};
var adjustBorderSize = (border) => {
	const size = typeof border.size === "number" ? borderSizeToPx(border.size) : void 0;
	return size != null ? {
		...border,
		size
	} : border;
};
var convertCellMarginsToPx = (margins) => {
	if (!margins || typeof margins !== "object") return void 0;
	const spacing = {};
	const keyMap = {
		top: "top",
		bottom: "bottom",
		left: "left",
		right: "right",
		marginTop: "top",
		marginBottom: "bottom",
		marginLeft: "left",
		marginRight: "right",
		marginStart: "left",
		marginEnd: "right"
	};
	Object.entries(margins).forEach(([key, value]) => {
		const side = keyMap[key];
		if (!side) return;
		const px = measurementToPx(value);
		if (px != null) spacing[side] = px;
	});
	return Object.keys(spacing).length ? spacing : void 0;
};
var measurementToPx = (value) => {
	if (typeof value === "number") return value;
	if (!value || typeof value !== "object") return void 0;
	const entry = value;
	if (typeof entry.value !== "number") return void 0;
	if (!entry.type || entry.type === "px" || entry.type === "pixel") return entry.value;
	if (entry.type === "dxa") return twipsToPx(entry.value);
};
var normalizeTableWidth = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const measurement = value;
	const raw = typeof measurement.width === "number" ? measurement.width : measurement.value;
	if (typeof raw !== "number") return void 0;
	if (!measurement.type || measurement.type === "px" || measurement.type === "pixel") return {
		width: raw,
		type: measurement.type ?? "px"
	};
	if (measurement.type === "dxa") return {
		width: twipsToPx(raw),
		type: "px"
	};
	return {
		width: raw,
		type: measurement.type
	};
};
var normalizeTableIndent = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const measurement = value;
	const raw = typeof measurement.width === "number" ? measurement.width : measurement.value;
	if (typeof raw !== "number") return void 0;
	if (!measurement.type || measurement.type === "px" || measurement.type === "pixel") return {
		width: raw,
		type: measurement.type ?? "px"
	};
	if (measurement.type === "dxa") return {
		width: twipsToPx(raw),
		type: "dxa"
	};
	return {
		width: raw,
		type: measurement.type
	};
};
var normalizeTableSpacing = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const measurement = value;
	if (typeof measurement.value !== "number") return void 0;
	return {
		value: measurement.value,
		type: measurement.type ?? "px"
	};
};
function normalizeCellSpacing(raw) {
	if (raw == null) return {
		value: 0,
		type: "px"
	};
	if (typeof raw === "number") return {
		value: Math.max(0, raw),
		type: "px"
	};
	return {
		value: typeof raw.value === "number" ? Math.max(0, raw.value) : 0,
		type: (raw.type ?? "px").toLowerCase() === "dxa" ? "dxa" : "px"
	};
}
function sourceAnchorFromNode$1(node) {
	const sourceAnchor = node.attrs?.sourceAnchor;
	return sourceAnchor && typeof sourceAnchor === "object" && !Array.isArray(sourceAnchor) ? sourceAnchor : void 0;
}
var isTableRowNode = (node) => node.type === "tableRow" || node.type === "table_row";
var isTableCellNode = (node) => node.type === "tableCell" || node.type === "table_cell" || node.type === "tableHeader" || node.type === "table_header";
var isTableSkipPlaceholderCell = (node) => {
	const placeholder = node.attrs?.__placeholder;
	return placeholder === "gridBefore" || placeholder === "gridAfter";
};
function normalizeLegacyBorderStyle(value) {
	switch ((value ?? "").trim().toLowerCase()) {
		case "none":
		case "nil": return "none";
		case "double": return "double";
		case "dashed": return "dashed";
		case "dotted":
		case "dot": return "dotted";
		case "thick": return "thick";
		case "triple": return "triple";
		case "dotdash": return "dotDash";
		case "dotdotdash": return "dotDotDash";
		case "wave": return "wave";
		case "doublewave": return "doubleWave";
		case "single":
		default: return "single";
	}
}
var convertResolvedCellBorder = (value) => {
	if (!value || typeof value !== "object") return void 0;
	const border = value;
	const size = typeof border.size === "number" ? borderSizeToPx(border.size) : void 0;
	return convertBorderSpec(size != null ? {
		...border,
		size
	} : border);
};
var normalizeRowHeight = (rowProps) => {
	if (!rowProps || typeof rowProps !== "object") return void 0;
	const rawRowHeight = rowProps.rowHeight;
	if (!rawRowHeight || typeof rawRowHeight !== "object") return void 0;
	const heightObj = rawRowHeight;
	const rawValue = pickNumber(heightObj.value ?? heightObj.val);
	if (rawValue == null) return void 0;
	const rawRule = heightObj.rule ?? heightObj.hRule;
	const rule = rawRule === "exact" || rawRule === "atLeast" || rawRule === "auto" ? rawRule : "atLeast";
	return {
		value: twipsToPx(rawValue),
		rule
	};
};
var parseTableCell = (args) => {
	const { cellNode, rowIndex, cellIndex, numCells, numRows, context, defaultCellPadding, tableProperties } = args;
	if (!isTableCellNode(cellNode) || !Array.isArray(cellNode.content)) return null;
	const blocks = [];
	const rowCnfStyle = args.rowCnfStyle ?? null;
	const cellCnfStyle = (cellNode.attrs?.tableCellProperties)?.cnfStyle ?? null;
	const tableInfo = tableProperties ? {
		tableProperties,
		rowIndex,
		cellIndex,
		numCells,
		numRows,
		rowCnfStyle,
		cellCnfStyle
	} : void 0;
	const inlineTcProps = cellNode.attrs?.tableCellProperties;
	const resolvedTcProps = resolveTableCellProperties(inlineTcProps, tableInfo, context.converterContext?.translatedLinkedStyles);
	const cellBackground = cellNode.attrs?.background;
	let cellBackgroundColor;
	if (cellBackground && typeof cellBackground.color === "string") {
		const rawColor = cellBackground.color.trim();
		if (rawColor) {
			const normalized = rawColor.startsWith("#") ? rawColor : `#${rawColor}`;
			if (/^#[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(normalized)) cellBackgroundColor = normalized;
		}
	}
	if (!cellBackgroundColor && resolvedTcProps?.shading) {
		const { fill, color, val, themeFill, themeFillTint, themeFillShade } = resolvedTcProps.shading;
		let fillBase = normalizeShadingColor(fill);
		if (!fillBase && themeFill && context.themeColors) fillBase = normalizeShadingColor(resolveThemeColorValue(themeFill, themeFillTint, themeFillShade, context.themeColors));
		const resolved = resolveShadingFillColor({
			val,
			color,
			fill: fillBase ?? fill
		});
		if (resolved) cellBackgroundColor = resolved.startsWith("#") ? resolved : `#${resolved}`;
	}
	const cellConverterContext = tableInfo || cellBackgroundColor ? {
		...context.converterContext,
		...tableInfo && { tableInfo },
		...cellBackgroundColor && { backgroundColor: cellBackgroundColor }
	} : context.converterContext;
	const paragraphToFlowBlocks$1 = context.converters.paragraphToFlowBlocks;
	const tableNodeToBlock$1 = context.converters?.tableNodeToBlock;
	const appendParagraphBlocks = (paragraphBlocks, sdtMetadata) => {
		applySdtMetadataToParagraphBlocks(paragraphBlocks.filter((block) => block.kind === "paragraph"), sdtMetadata);
		paragraphBlocks.forEach((block) => {
			if (block.kind === "paragraph" || block.kind === "image" || block.kind === "drawing") blocks.push(block);
		});
	};
	const flattenSdtWrappersIntoCell = (wrapperNode, inheritedSdtMetadata) => {
		if (!Array.isArray(wrapperNode.content)) return;
		for (const nestedNode of wrapperNode.content) {
			if (nestedNode.type === "paragraph") {
				if (!paragraphToFlowBlocks$1) continue;
				appendParagraphBlocks(paragraphToFlowBlocks$1({
					para: nestedNode,
					nextBlockId: context.nextBlockId,
					positions: context.positions,
					storyKey: context.storyKey,
					trackedChangesConfig: context.trackedChangesConfig,
					bookmarks: context.bookmarks,
					hyperlinkConfig: context.hyperlinkConfig,
					themeColors: context.themeColors,
					converterContext: cellConverterContext,
					converters: context.converters,
					enableComments: context.enableComments
				}), inheritedSdtMetadata);
				continue;
			}
			if (nestedNode.type === "table" && tableNodeToBlock$1) {
				const tableBlock = tableNodeToBlock$1(nestedNode, {
					nextBlockId: context.nextBlockId,
					positions: context.positions,
					storyKey: context.storyKey,
					trackedChangesConfig: context.trackedChangesConfig,
					bookmarks: context.bookmarks,
					hyperlinkConfig: context.hyperlinkConfig,
					themeColors: context.themeColors,
					converterContext: context.converterContext,
					converters: context.converters,
					enableComments: context.enableComments
				});
				if (tableBlock && tableBlock.kind === "table") {
					if (inheritedSdtMetadata) applySdtMetadataToTableBlock(tableBlock, inheritedSdtMetadata);
					blocks.push(tableBlock);
				}
				continue;
			}
			if (nestedNode.type === "documentPartObject") {
				flattenSdtWrappersIntoCell(nestedNode, inheritedSdtMetadata);
				continue;
			}
			if (nestedNode.type === "structuredContentBlock") {
				flattenSdtWrappersIntoCell(nestedNode, inheritedSdtMetadata ?? resolveNodeSdtMetadata(nestedNode, "structuredContentBlock"));
				continue;
			}
		}
	};
	for (const childNode of cellNode.content) {
		if (childNode.type === "paragraph") {
			if (!paragraphToFlowBlocks$1) continue;
			appendParagraphBlocks(paragraphToFlowBlocks$1({
				para: childNode,
				nextBlockId: context.nextBlockId,
				positions: context.positions,
				storyKey: context.storyKey,
				trackedChangesConfig: context.trackedChangesConfig,
				bookmarks: context.bookmarks,
				hyperlinkConfig: context.hyperlinkConfig,
				themeColors: context.themeColors,
				converterContext: cellConverterContext,
				converters: context.converters,
				enableComments: context.enableComments
			}));
			continue;
		}
		if (childNode.type === "structuredContentBlock" && Array.isArray(childNode.content)) {
			flattenSdtWrappersIntoCell(childNode, resolveNodeSdtMetadata(childNode, "structuredContentBlock"));
			continue;
		}
		if (childNode.type === "table" && tableNodeToBlock$1) {
			const tableBlock = tableNodeToBlock$1(childNode, {
				nextBlockId: context.nextBlockId,
				positions: context.positions,
				storyKey: context.storyKey,
				trackedChangesConfig: context.trackedChangesConfig,
				bookmarks: context.bookmarks,
				hyperlinkConfig: context.hyperlinkConfig,
				themeColors: context.themeColors,
				converterContext: context.converterContext,
				converters: context.converters,
				enableComments: context.enableComments
			});
			if (tableBlock && tableBlock.kind === "table") blocks.push(tableBlock);
			continue;
		}
		if (childNode.type === "documentPartObject" && Array.isArray(childNode.content)) {
			flattenSdtWrappersIntoCell(childNode, void 0);
			continue;
		}
		if (childNode.type === "image" && context.converters?.imageNodeToBlock) {
			const mergedMarks = [...childNode.marks ?? []];
			const trackedMeta = context.trackedChangesConfig ? collectTrackedChangeFromMarks(mergedMarks, context.storyKey) : void 0;
			if (shouldHideTrackedNode(trackedMeta, context.trackedChangesConfig)) continue;
			const imageBlock = context.converters.imageNodeToBlock(childNode, context.nextBlockId, context.positions, trackedMeta, context.trackedChangesConfig);
			if (imageBlock && imageBlock.kind === "image") {
				annotateBlockWithTrackedChange(imageBlock, trackedMeta, context.trackedChangesConfig);
				blocks.push(imageBlock);
			}
			continue;
		}
		if (childNode.type === "vectorShape" && context.converters?.vectorShapeNodeToDrawingBlock) {
			const drawingBlock = context.converters.vectorShapeNodeToDrawingBlock(childNode, context.nextBlockId, context.positions);
			if (drawingBlock && drawingBlock.kind === "drawing") blocks.push(drawingBlock);
			continue;
		}
		if (childNode.type === "shapeGroup" && context.converters?.shapeGroupNodeToDrawingBlock) {
			const drawingBlock = context.converters.shapeGroupNodeToDrawingBlock(childNode, context.nextBlockId, context.positions);
			if (drawingBlock && drawingBlock.kind === "drawing") blocks.push(drawingBlock);
			continue;
		}
		if (childNode.type === "shapeContainer" && context.converters?.shapeContainerNodeToDrawingBlock) {
			const drawingBlock = context.converters.shapeContainerNodeToDrawingBlock(childNode, context.nextBlockId, context.positions);
			if (drawingBlock && drawingBlock.kind === "drawing") blocks.push(hydrateTextboxDrawingContent(childNode, drawingBlock, context));
			continue;
		}
		if (childNode.type === "shapeTextbox" && context.converters?.shapeTextboxNodeToDrawingBlock) {
			const drawingBlock = context.converters.shapeTextboxNodeToDrawingBlock(childNode, context.nextBlockId, context.positions);
			if (drawingBlock && drawingBlock.kind === "drawing") blocks.push(hydrateTextboxDrawingContent(childNode, drawingBlock, context));
			continue;
		}
	}
	if (blocks.length === 0) return null;
	const cellAttrs = {};
	if (resolvedTcProps?.borders && typeof resolvedTcProps.borders === "object") {
		const resolvedBordersData = resolvedTcProps.borders;
		const resolvedBorders = {};
		for (const side of [
			"top",
			"right",
			"bottom",
			"left"
		]) {
			const spec = convertResolvedCellBorder(resolvedBordersData[side]);
			if (spec) resolvedBorders[side] = spec;
		}
		if (resolvedBorders.left == null) {
			const spec = convertResolvedCellBorder(resolvedBordersData.start);
			if (spec) resolvedBorders.left = spec;
		}
		if (resolvedBorders.right == null) {
			const spec = convertResolvedCellBorder(resolvedBordersData.end);
			if (spec) resolvedBorders.right = spec;
		}
		if (Object.keys(resolvedBorders).length > 0) cellAttrs.borders = resolvedBorders;
	}
	if (!cellAttrs.borders && cellNode.attrs?.borders && typeof cellNode.attrs.borders === "object") {
		const legacy = cellNode.attrs.borders;
		const filteredLegacyBorders = {};
		for (const side of [
			"top",
			"right",
			"bottom",
			"left",
			"start",
			"end"
		]) {
			const b = legacy[side];
			if (b && b.val && typeof b.size === "number" && b.size > 0) filteredLegacyBorders[side] = {
				...b,
				val: normalizeLegacyBorderStyle(b.val)
			};
		}
		const fallback = extractCellBorders({ borders: filteredLegacyBorders });
		if (fallback) cellAttrs.borders = fallback;
	}
	const padding = extractCellPadding(cellNode.attrs ?? {}) ?? (defaultCellPadding ? { ...defaultCellPadding } : void 0);
	if (padding) cellAttrs.padding = padding;
	const verticalAlign = cellNode.attrs?.verticalAlign;
	const normalizedVerticalAlign = verticalAlign === "middle" ? "center" : verticalAlign === "center" ? "center" : verticalAlign;
	if (normalizedVerticalAlign === "top" || normalizedVerticalAlign === "center" || normalizedVerticalAlign === "bottom") cellAttrs.verticalAlign = normalizedVerticalAlign;
	const background = cellNode.attrs?.background;
	if (background && typeof background.color === "string") {
		const bgColor = background.color;
		cellAttrs.background = bgColor.startsWith("#") ? bgColor : `#${bgColor}`;
	} else if (cellBackgroundColor) cellAttrs.background = cellBackgroundColor;
	const tableCellProperties = cellNode.attrs?.tableCellProperties;
	if (tableCellProperties && typeof tableCellProperties === "object") cellAttrs.tableCellProperties = tableCellProperties;
	const rowSpan = pickNumber(cellNode.attrs?.rowspan);
	const colSpan = pickNumber(cellNode.attrs?.colspan);
	return {
		id: context.nextBlockId(`cell-${rowIndex}-${cellIndex}`),
		blocks,
		paragraph: blocks[0]?.kind === "paragraph" ? blocks[0] : void 0,
		rowSpan: rowSpan ?? void 0,
		colSpan: colSpan ?? void 0,
		attrs: Object.keys(cellAttrs).length > 0 ? cellAttrs : void 0,
		sourceAnchor: sourceAnchorFromNode$1(cellNode)
	};
};
var buildRowTrackedChangeMeta = (rowNode, storyKey) => {
	const trackChange = rowNode.attrs?.trackChange;
	if (!trackChange || typeof trackChange !== "object") return void 0;
	const rawType = trackChange.type;
	if (rawType !== "rowInsert" && rawType !== "rowDelete") return void 0;
	const kind = rawType === "rowInsert" ? "insert" : "delete";
	const meta = {
		kind,
		id: deriveTrackedChangeId$1(kind, trackChange)
	};
	if (typeof trackChange.author === "string" && trackChange.author) meta.author = trackChange.author;
	if (typeof trackChange.authorEmail === "string" && trackChange.authorEmail) meta.authorEmail = trackChange.authorEmail;
	if (typeof trackChange.date === "string" && trackChange.date) meta.date = trackChange.date;
	if (typeof storyKey === "string" && storyKey.length > 0) meta.storyKey = storyKey;
	return meta;
};
var parseTableRow = (args) => {
	const { rowNode, rowIndex, context, defaultCellPadding, tableProperties, numRows } = args;
	if (!isTableRowNode(rowNode) || !Array.isArray(rowNode.content)) return null;
	const cells = [];
	const rowCnfStyle = (rowNode.attrs?.tableRowProperties)?.cnfStyle;
	rowNode.content.forEach((cellNode, cellIndex) => {
		if (isTableCellNode(cellNode) && isTableSkipPlaceholderCell(cellNode)) return;
		const parsedCell = parseTableCell({
			cellNode,
			rowIndex,
			cellIndex,
			context,
			defaultCellPadding,
			tableProperties,
			numCells: rowNode?.content?.length || 1,
			numRows,
			rowCnfStyle
		});
		if (parsedCell) cells.push(parsedCell);
	});
	if (cells.length === 0) return null;
	const rowProps = rowNode.attrs?.tableRowProperties;
	const rowHeight = normalizeRowHeight(rowProps);
	const trackedChangesConfig = context.trackedChangesConfig;
	const rowTrackedChange = trackedChangesConfig?.enabled && trackedChangesConfig.mode !== "off" ? buildRowTrackedChangeMeta(rowNode, context.storyKey) : void 0;
	const tblPrExBordersRaw = rowProps?.tblPrExBorders;
	const rowBorders = tblPrExBordersRaw && typeof tblPrExBordersRaw === "object" ? extractTableBorders(tblPrExBordersRaw, { unit: "eighthPoints" }) : void 0;
	const attrs = rowProps && typeof rowProps === "object" ? {
		tableRowProperties: rowProps,
		...rowHeight ? { rowHeight } : {},
		...rowTrackedChange ? { trackedChange: rowTrackedChange } : {},
		...rowBorders ? { borders: rowBorders } : {}
	} : rowHeight || rowTrackedChange ? {
		...rowHeight ? { rowHeight } : {},
		...rowTrackedChange ? { trackedChange: rowTrackedChange } : {}
	} : void 0;
	return {
		id: context.nextBlockId(`row-${rowIndex}`),
		cells,
		attrs,
		sourceAnchor: sourceAnchorFromNode$1(rowNode)
	};
};
function countFloatingTableContentColumns(node) {
	const grid = node.attrs?.grid;
	if (Array.isArray(grid) && grid.length > 0) return grid.length;
	const firstRow = node.content?.[0];
	if (!firstRow || !isTableRowNode(firstRow) || !Array.isArray(firstRow.content)) return 0;
	let columns = 0;
	for (const cellNode of firstRow.content) {
		if (!cellNode || !isTableCellNode(cellNode)) continue;
		const colSpan = typeof cellNode.attrs?.colspan === "number" ? cellNode.attrs.colspan : 1;
		columns += colSpan > 0 ? colSpan : 1;
	}
	return columns;
}
function extractFloatingTableAnchorWrap(node) {
	const floatingProps = (node.attrs?.tableProperties)?.floatingTableProperties;
	if (!floatingProps) return {};
	if (!(floatingProps.tblpX !== void 0 || floatingProps.tblpY !== void 0 || floatingProps.tblpXSpec !== void 0 || floatingProps.tblpYSpec !== void 0 || floatingProps.horzAnchor !== void 0 || floatingProps.vertAnchor !== void 0)) return {};
	const mapHorzAnchor = (val) => {
		switch (val) {
			case "page": return "page";
			case "margin": return "margin";
			case "text":
			default: return "column";
		}
	};
	const mapVertAnchor = (val) => {
		switch (val) {
			case "page": return "page";
			case "margin": return "margin";
			case "text":
			default: return "paragraph";
		}
	};
	const anchor = {
		isAnchored: true,
		hRelativeFrom: mapHorzAnchor(floatingProps.horzAnchor),
		vRelativeFrom: mapVertAnchor(floatingProps.vertAnchor)
	};
	if (floatingProps.tblpXSpec) anchor.alignH = floatingProps.tblpXSpec;
	if (floatingProps.tblpYSpec) anchor.alignV = floatingProps.tblpYSpec;
	if (floatingProps.tblpX !== void 0) anchor.offsetH = twipsToPx(floatingProps.tblpX);
	if (floatingProps.tblpY !== void 0) anchor.offsetV = twipsToPx(floatingProps.tblpY);
	const hasHorizontalDistances = floatingProps.leftFromText !== void 0 || floatingProps.rightFromText !== void 0;
	const hasVerticalDistances = floatingProps.topFromText !== void 0 || floatingProps.bottomFromText !== void 0;
	const hasDistances = hasHorizontalDistances || hasVerticalDistances;
	const wrap$1 = {
		type: countFloatingTableContentColumns(node) <= 1 && hasHorizontalDistances && !hasVerticalDistances ? "None" : "Square",
		wrapText: "bothSides"
	};
	if (hasDistances) {
		if (floatingProps.topFromText !== void 0) wrap$1.distTop = twipsToPx(floatingProps.topFromText);
		if (floatingProps.bottomFromText !== void 0) wrap$1.distBottom = twipsToPx(floatingProps.bottomFromText);
		if (floatingProps.leftFromText !== void 0) wrap$1.distLeft = twipsToPx(floatingProps.leftFromText);
		if (floatingProps.rightFromText !== void 0) wrap$1.distRight = twipsToPx(floatingProps.rightFromText);
	}
	return {
		anchor,
		wrap: wrap$1
	};
}
function tableNodeToBlock(node, { nextBlockId, positions, storyKey, trackedChangesConfig, bookmarks, hyperlinkConfig, themeColors, converterContext, converters: converters$1, enableComments }) {
	if (!Array.isArray(node.content) || node.content.length === 0) return null;
	if (!converters$1.paragraphToFlowBlocks) return null;
	const parserDeps = {
		nextBlockId,
		positions,
		storyKey,
		trackedChangesConfig,
		bookmarks,
		hyperlinkConfig,
		themeColors,
		converterContext,
		converters: converters$1,
		enableComments
	};
	const effectiveStyleId = resolveExistingTableEffectiveStyleId(typeof node.attrs?.tableStyleId === "string" ? node.attrs.tableStyleId : null, converterContext?.translatedLinkedStyles).styleId;
	const hydratedTableStyle = hydrateTableStyleAttrs(node, converterContext, effectiveStyleId);
	const defaultCellPadding = hydratedTableStyle?.cellPadding;
	const rawTableProperties = node.attrs?.tableProperties;
	const tablePropertiesForCascade = effectiveStyleId || rawTableProperties ? {
		...rawTableProperties,
		tableStyleId: effectiveStyleId ?? void 0
	} : void 0;
	const rows = [];
	node.content.forEach((rowNode, rowIndex) => {
		const parsedRow = parseTableRow({
			rowNode,
			rowIndex,
			numRows: node?.content?.length ?? 1,
			context: parserDeps,
			defaultCellPadding,
			tableProperties: tablePropertiesForCascade
		});
		if (parsedRow) {
			if (!shouldHideTrackedNode(parsedRow.attrs?.trackedChange, parserDeps.trackedChangesConfig)) rows.push(parsedRow);
		}
	});
	if (rows.length === 0) return null;
	const tableAttrs = {};
	const getBorderSource = () => {
		if (node.attrs?.borders && typeof node.attrs.borders === "object" && node.attrs.borders !== null && Object.keys(node.attrs.borders).length > 0) return {
			borders: node.attrs.borders,
			unit: "px"
		};
		if (hydratedTableStyle?.borders && typeof hydratedTableStyle.borders === "object" && hydratedTableStyle.borders !== null) return {
			borders: hydratedTableStyle.borders,
			unit: "eighthPoints"
		};
	};
	const borderSource = getBorderSource();
	const tableBorders = borderSource ? extractTableBorders(borderSource.borders, { unit: borderSource.unit }) : void 0;
	if (tableBorders) tableAttrs.borders = tableBorders;
	if (node.attrs?.borderCollapse) tableAttrs.borderCollapse = node.attrs.borderCollapse;
	if (node.attrs?.tableCellSpacing !== void 0 && node.attrs?.tableCellSpacing !== null) tableAttrs.cellSpacing = normalizeCellSpacing(node.attrs.tableCellSpacing);
	else if (hydratedTableStyle?.tableCellSpacing) {
		tableAttrs.cellSpacing = normalizeCellSpacing(hydratedTableStyle.tableCellSpacing);
		if (!tableAttrs.borderCollapse) tableAttrs.borderCollapse = "separate";
	}
	if (node.attrs?.justification) tableAttrs.justification = node.attrs.justification;
	else if (hydratedTableStyle?.justification) tableAttrs.justification = hydratedTableStyle.justification;
	if (node.attrs?.tableWidth) tableAttrs.tableWidth = node.attrs.tableWidth;
	else if (hydratedTableStyle?.tableWidth) tableAttrs.tableWidth = hydratedTableStyle.tableWidth;
	if (node.attrs?.tableIndent && typeof node.attrs.tableIndent === "object") tableAttrs.tableIndent = { ...node.attrs.tableIndent };
	else if (hydratedTableStyle?.tableIndent) tableAttrs.tableIndent = { ...hydratedTableStyle.tableIndent };
	if (defaultCellPadding && typeof defaultCellPadding === "object") tableAttrs.defaultCellPadding = { ...defaultCellPadding };
	const tableLayout = node.attrs?.tableLayout;
	if (tableLayout) tableAttrs.tableLayout = tableLayout;
	else if (hydratedTableStyle?.tableLayout) tableAttrs.tableLayout = hydratedTableStyle.tableLayout;
	const tableProperties = node.attrs?.tableProperties;
	if (tableProperties && typeof tableProperties === "object") tableAttrs.tableProperties = tableProperties;
	const inlineProps = rawTableProperties;
	tableAttrs.tableDirectionContext = resolveTableDirection({ rightToLeft: inlineProps?.rightToLeft ?? inlineProps?.bidiVisual }, converterContext?.sectionDirectionContext ?? resolveSectionDirection(void 0));
	let columnWidths = void 0;
	const twipsToPixels$3 = (twips) => {
		return twips / 1440 * 96;
	};
	if (node.attrs?.userEdited === true && Array.isArray(node.attrs?.grid) && node.attrs.grid.length > 0) {
		columnWidths = node.attrs.grid.filter((col) => col != null && typeof col === "object").map((col) => {
			const twips = typeof col.col === "number" ? col.col : 0;
			return twips > 0 ? twipsToPixels$3(twips) : 0;
		}).filter((width) => width > 0);
		if (columnWidths.length === 0) columnWidths = void 0;
	}
	if (!columnWidths && Array.isArray(node.attrs?.grid) && node.attrs.grid.length > 0) {
		columnWidths = node.attrs.grid.filter((col) => col != null && typeof col === "object").map((col) => {
			const twips = typeof col.col === "number" ? col.col : 0;
			return twips > 0 ? twipsToPixels$3(twips) : 0;
		}).filter((width) => width > 0);
		if (columnWidths.length === 0) columnWidths = void 0;
	}
	if (!columnWidths && Array.isArray(node.content) && node.content.length > 0) {
		const firstRow = node.content[0];
		if (firstRow && isTableRowNode(firstRow) && Array.isArray(firstRow.content) && firstRow.content.length > 0) {
			const tempWidths = [];
			for (const cellNode of firstRow.content) if (cellNode && isTableCellNode(cellNode) && cellNode.attrs?.colwidth !== void 0) {
				const colwidth = cellNode.attrs.colwidth;
				if (Array.isArray(colwidth)) tempWidths.push(...colwidth.filter((w) => typeof w === "number" && w > 0));
				else if (typeof colwidth === "number" && colwidth > 0) tempWidths.push(colwidth);
			}
			if (tempWidths.length > 0) columnWidths = tempWidths;
		}
	}
	const { anchor, wrap: wrap$1 } = extractFloatingTableAnchorWrap(node);
	return {
		kind: "table",
		id: nextBlockId("table"),
		rows,
		attrs: Object.keys(tableAttrs).length > 0 ? tableAttrs : void 0,
		columnWidths,
		...anchor ? { anchor } : {},
		...wrap$1 ? { wrap: wrap$1 } : {},
		sourceAnchor: sourceAnchorFromNode$1(node)
	};
}
function handleTableNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions, trackedChangesConfig, bookmarks, hyperlinkConfig, converters: converters$1, converterContext, enableComments } = context;
	const tableBlock = tableNodeToBlock(node, {
		nextBlockId,
		positions,
		storyKey: context.storyKey,
		trackedChangesConfig,
		bookmarks,
		hyperlinkConfig,
		themeColors: void 0,
		converterContext,
		converters: converters$1,
		enableComments
	});
	if (tableBlock) {
		blocks.push(tableBlock);
		recordBlockKind?.(tableBlock.kind);
	}
}
function resolveSectionDirectionFromSectPr$1(sectPr) {
	if (!sectPr || typeof sectPr !== "object") return void 0;
	const elements = sectPr.elements;
	if (!Array.isArray(elements)) return void 0;
	const bidi = elements.find((element) => element?.name === "w:bidi");
	if (!bidi) return void 0;
	const val = bidi.attributes?.["w:val"] ?? bidi.attributes?.val;
	if (val === "0" || val === 0 || val === false || val === "false" || val === "off") return "ltr";
	return "rtl";
}
function sourceAnchorFromNode(node) {
	const sourceAnchor = node.attrs?.sourceAnchor;
	return sourceAnchor && typeof sourceAnchor === "object" && !Array.isArray(sourceAnchor) ? sourceAnchor : void 0;
}
var isHiddenShape = (node) => {
	if (!node.type.toLowerCase().includes("shape")) return false;
	const attrs = node.attrs ?? {};
	if (attrs.hidden === true) return true;
	return typeof attrs.visibility === "string" && attrs.visibility.toLowerCase() === "hidden";
};
const isTextRun = (run$1) => {
	const kind = run$1.kind;
	return (kind === void 0 || kind === "text") && "text" in run$1;
};
const dataAttrsCompatible = (a, b) => {
	const aAttrs = a.dataAttrs;
	const bAttrs = b.dataAttrs;
	if (!aAttrs && !bAttrs) return true;
	if (!aAttrs || !bAttrs) return false;
	const aKeys = Object.keys(aAttrs).sort();
	const bKeys = Object.keys(bAttrs).sort();
	if (aKeys.length !== bKeys.length) return false;
	for (let i$1 = 0; i$1 < aKeys.length; i$1++) {
		const key = aKeys[i$1];
		if (key !== bKeys[i$1] || aAttrs[key] !== bAttrs[key]) return false;
	}
	return true;
};
const commentsCompatible = (a, b) => {
	const aComments = a.comments ?? [];
	const bComments = b.comments ?? [];
	if (aComments.length === 0 && bComments.length === 0) return true;
	if (aComments.length !== bComments.length) return false;
	const normalize$1 = (c$1) => `${c$1.commentId ?? ""}::${c$1.importedId ?? ""}::${c$1.internal ? "1" : "0"}`;
	const aKeys = aComments.map(normalize$1).sort();
	const bKeys = bComments.map(normalize$1).sort();
	for (let i$1 = 0; i$1 < aKeys.length; i$1++) if (aKeys[i$1] !== bKeys[i$1]) return false;
	return true;
};
var bidiCompatible = (a, b) => {
	const aBidi = a.bidi;
	const bBidi = b.bidi;
	if (!aBidi && !bBidi) return true;
	if (!aBidi || !bBidi) return false;
	return aBidi.rtl === bBidi.rtl && aBidi.embedding === bBidi.embedding && aBidi.override === bBidi.override;
};
function mergeAdjacentRuns(runs) {
	if (runs.length <= 1) return runs;
	const merged = [];
	let current = runs[0];
	for (let i$1 = 1; i$1 < runs.length; i$1++) {
		const next = runs[i$1];
		if (isTextRun(current) && isTextRun(next) && !current.token && !next.token && !isEmptyInlineSdtPlaceholderRun(current) && !isEmptyInlineSdtPlaceholderRun(next) && current.pmStart != null && current.pmEnd != null && next.pmStart != null && next.pmEnd != null && current.pmEnd === next.pmStart && current.fontFamily === next.fontFamily && current.fontSize === next.fontSize && current.bold === next.bold && current.italic === next.italic && current.underline === next.underline && current.strike === next.strike && current.color === next.color && current.highlight === next.highlight && (current.letterSpacing ?? 0) === (next.letterSpacing ?? 0) && trackedChangesCompatible(current, next) && dataAttrsCompatible(current, next) && commentsCompatible(current, next) && bidiCompatible(current, next)) {
			const currText = current.text ?? "";
			const nextText = next.text ?? "";
			current = {
				...current,
				text: currText + nextText,
				pmEnd: next.pmEnd
			};
		} else {
			merged.push(current);
			current = next;
		}
	}
	merged.push(current);
	return merged;
}
function extractDefaultFontProperties(converterContext, paragraphProperties) {
	const defaultRunAttrs = computeRunAttrs(resolveRunProperties(converterContext, paragraphProperties.runProperties, paragraphProperties, converterContext.tableInfo, false, false), converterContext);
	return {
		defaultFont: defaultRunAttrs.fontFamily,
		defaultSize: defaultRunAttrs.fontSize
	};
}
var toTrackChangeAttrs = (value) => {
	if (!value || typeof value !== "object") return;
	return value;
};
var getParagraphMarkTrackedChange = (paragraphProperties, storyKey) => {
	const runProperties = paragraphProperties?.runProperties && typeof paragraphProperties.runProperties === "object" ? paragraphProperties.runProperties : void 0;
	if (!runProperties) return;
	const trackInsertAttrs = toTrackChangeAttrs(runProperties.trackInsert);
	const trackDeleteAttrs = toTrackChangeAttrs(runProperties.trackDelete);
	if (!trackInsertAttrs && !trackDeleteAttrs) return;
	const marks = [];
	if (trackInsertAttrs) marks.push({
		type: "trackInsert",
		attrs: trackInsertAttrs
	});
	if (trackDeleteAttrs) marks.push({
		type: "trackDelete",
		attrs: trackDeleteAttrs
	});
	return collectTrackedChangeFromMarks(marks, storyKey);
};
var isEmptyTextRun = (run$1) => {
	if (!isTextRun(run$1)) return false;
	return run$1.text.length === 0;
};
var getBlockMarker = (block) => {
	if (!("attrs" in block) || !block.attrs || typeof block.attrs !== "object") return void 0;
	const wordLayout = block.attrs.wordLayout;
	if (!wordLayout || typeof wordLayout !== "object") return void 0;
	const marker = wordLayout.marker;
	if (!marker || typeof marker !== "object") return void 0;
	return marker;
};
var getOriginalMarkerText = (marker) => {
	if (typeof marker.pmAdapterOriginalMarkerText === "string") return marker.pmAdapterOriginalMarkerText;
	return typeof marker.markerText === "string" ? marker.markerText : void 0;
};
var isGhostSuppressionMode = (mode) => mode !== "off" && mode !== "final" && mode !== "original";
var getListKey = (numId, ilvl) => {
	if (typeof numId !== "number" && typeof numId !== "string" || typeof ilvl !== "number") return;
	const normalizedNumId = String(numId).trim();
	if (!normalizedNumId) return;
	return `${normalizedNumId}:${ilvl}`;
};
var getParagraphListKeyFromAttrs = (attrs) => {
	if (!attrs || typeof attrs !== "object") return;
	const numberingProperties = attrs.numberingProperties;
	if (!numberingProperties) return;
	return getListKey(numberingProperties.numId, numberingProperties.ilvl);
};
var TRAILING_MARKER_TOKEN_RE = /^(.*?)([\p{L}\p{N}]+)([^\p{L}\p{N}]*)$/u;
var getNodeListOrdinal = (node) => {
	const listRendering = getListRendering(node.attrs?.listRendering);
	if (!listRendering || listRendering.numberingType === "bullet") return;
	return getListOrdinalFromPath(listRendering.path);
};
var formatListOrdinalToken = (numberingType, ordinal, customFormat) => {
	if (!Number.isFinite(ordinal) || ordinal < 1 || numberingType === "bullet") return;
	return generateOrderedListIndex({
		listLevel: [Math.trunc(ordinal)],
		lvlText: "%1",
		listNumberingType: numberingType,
		customFormat
	}) ?? void 0;
};
var replaceTrailingMarkerToken = (markerText, replacementToken) => {
	const match = TRAILING_MARKER_TOKEN_RE.exec(markerText);
	if (!match) return;
	return `${match[1] ?? ""}${replacementToken}${match[3] ?? ""}`;
};
var updateGhostListMarkerOffsets = (node, paragraphBlocks, context) => {
	if (!context.trackedChangesConfig.enabled) return;
	if (paragraphBlocks.some((block) => block.kind === "paragraph")) return;
	if (Array.isArray(node.content) && node.content.length > 0) return;
	if (!getParagraphMarkTrackedChange(typeof node.attrs?.paragraphProperties === "object" && node.attrs.paragraphProperties !== null ? node.attrs.paragraphProperties : {})) return;
	const { paragraphAttrs } = computeParagraphAttrs(node, context.converterContext);
	const key = getParagraphListKeyFromAttrs(paragraphAttrs);
	if (!key) return;
	const offsets = context.trackedListMarkerOffsets;
	if (!offsets) return;
	offsets.set(key, (offsets.get(key) ?? 0) + 1);
};
var getNodeListKey = (node, context) => {
	const { paragraphAttrs } = computeParagraphAttrs(node, context.converterContext);
	return getParagraphListKeyFromAttrs(paragraphAttrs);
};
var applyGhostListMarkerOffsets = (node, paragraphBlocks, context) => {
	const offsets = context.trackedListMarkerOffsets;
	const lastOrdinals = context.trackedListLastOrdinals;
	if (!offsets || offsets.size === 0 || !context.trackedChangesConfig.enabled) return;
	const listRendering = getListRendering(node.attrs?.listRendering);
	const numberingType = listRendering?.numberingType;
	if (!numberingType || numberingType === "bullet") return;
	const sourceOrdinal = getNodeListOrdinal(node);
	if (!sourceOrdinal) return;
	const nodeListKey = getNodeListKey(node, context);
	if (!nodeListKey) return;
	const previousOrdinal = lastOrdinals?.get(nodeListKey);
	if (previousOrdinal != null && sourceOrdinal <= previousOrdinal) offsets.delete(nodeListKey);
	lastOrdinals?.set(nodeListKey, sourceOrdinal);
	const offset = offsets.get(nodeListKey) ?? 0;
	if (offset <= 0) return;
	const adjustedOrdinal = sourceOrdinal - offset;
	if (adjustedOrdinal < 1) {
		offsets.delete(nodeListKey);
		paragraphBlocks.forEach((block) => {
			if (block.kind !== "paragraph" || getParagraphListKeyFromAttrs(block.attrs) !== nodeListKey) return;
			const marker = getBlockMarker(block);
			if (!marker) return;
			const sourceMarkerText = getOriginalMarkerText(marker);
			if (sourceMarkerText) marker.markerText = sourceMarkerText;
		});
		return;
	}
	const replacementToken = formatListOrdinalToken(numberingType, adjustedOrdinal, listRendering.customFormat);
	if (!replacementToken) return;
	paragraphBlocks.forEach((block) => {
		if (block.kind !== "paragraph" || getParagraphListKeyFromAttrs(block.attrs) !== nodeListKey) return;
		const marker = getBlockMarker(block);
		if (!marker) return;
		const sourceMarkerText = getOriginalMarkerText(marker);
		if (!sourceMarkerText) return;
		const adjustedText = replaceTrailingMarkerToken(sourceMarkerText, replacementToken);
		if (!adjustedText || adjustedText === sourceMarkerText) return;
		marker.pmAdapterOriginalMarkerText = sourceMarkerText;
		marker.markerText = adjustedText;
	});
};
var applyTrackedGhostListAdjustments = (node, paragraphBlocks, context) => {
	if (!context.trackedChangesConfig.enabled) return;
	updateGhostListMarkerOffsets(node, paragraphBlocks, context);
	applyGhostListMarkerOffsets(node, paragraphBlocks, context);
};
function paragraphToFlowBlocks({ para, nextBlockId, positions, storyKey, trackedChangesConfig, bookmarks, hyperlinkConfig = DEFAULT_HYPERLINK_CONFIG, themeColors, converters: converters$1, converterContext, enableComments = true, stableBlockId, previousParagraphFont }) {
	const baseBlockId = stableBlockId ?? nextBlockId("paragraph");
	let inlineBlockCounter = 0;
	const stableNextBlockId = stableBlockId ? (prefix) => `${stableBlockId}-${prefix}-${inlineBlockCounter++}` : nextBlockId;
	const paragraphProps = typeof para.attrs?.paragraphProperties === "object" && para.attrs.paragraphProperties !== null ? para.attrs.paragraphProperties : {};
	const { paragraphAttrs, resolvedParagraphProperties } = computeParagraphAttrs(para, converterContext, previousParagraphFont);
	const blocks = [];
	const paraAttrs = para.attrs ?? {};
	const sourceAnchor = sourceAnchorFromNode(para);
	const rawParagraphProps = typeof paraAttrs.paragraphProperties === "object" && paraAttrs.paragraphProperties !== null ? paraAttrs.paragraphProperties : void 0;
	const isSectPrMarker = Boolean(rawParagraphProps?.sectPr) || paraAttrs.pageBreakSource === "sectPr";
	const extracted = extractDefaultFontProperties(converterContext, resolvedParagraphProperties);
	const usePreviousFont = previousParagraphFont != null && resolvedParagraphProperties.numberingProperties != null && !hasExplicitParagraphRunProperties(paragraphProps);
	const defaultFont = usePreviousFont && previousParagraphFont.fontFamily ? previousParagraphFont.fontFamily : extracted.defaultFont;
	const defaultSize = usePreviousFont && previousParagraphFont.fontSize ? previousParagraphFont.fontSize : extracted.defaultSize;
	const finalizeParagraphBlocks = (outputBlocks) => {
		outputBlocks.forEach((block) => {
			if (block.kind === "paragraph") syncListMarkerFontFromParagraphRuns({
				block,
				converterContext,
				para
			});
		});
		return outputBlocks;
	};
	if (paragraphAttrs.pageBreakBefore) blocks.push({
		kind: "pageBreak",
		id: stableBlockId ? `${stableBlockId}-pageBreak` : nextBlockId("pageBreak"),
		attrs: { source: "pageBreakBefore" }
	});
	if (!para.content || para.content.length === 0) {
		if (paragraphProps.runProperties?.vanish) return finalizeParagraphBlocks(blocks);
		const paragraphMarkTrackedChange = getParagraphMarkTrackedChange(paragraphProps, storyKey);
		const paraPos = positions.get(para);
		const emptyRun = {
			text: "",
			fontFamily: defaultFont,
			fontSize: defaultSize
		};
		if (paragraphMarkTrackedChange) emptyRun.trackedChange = paragraphMarkTrackedChange;
		if (paraPos) {
			emptyRun.pmStart = paraPos.start + 1;
			emptyRun.pmEnd = paraPos.start + 1;
		}
		let emptyParagraphAttrs = deepClone(paragraphAttrs);
		if (isSectPrMarker) if (emptyParagraphAttrs) emptyParagraphAttrs.sectPrMarker = true;
		else emptyParagraphAttrs = { sectPrMarker: true };
		blocks.push({
			kind: "paragraph",
			id: baseBlockId,
			runs: [emptyRun],
			attrs: emptyParagraphAttrs,
			sourceAnchor
		});
		if (!trackedChangesConfig) return finalizeParagraphBlocks(blocks);
		const paragraphBlock = blocks[blocks.length - 1];
		if (paragraphBlock?.kind !== "paragraph") return finalizeParagraphBlocks(blocks);
		const filteredRuns = applyTrackedChangesModeToRuns(paragraphBlock.runs, trackedChangesConfig, hyperlinkConfig, applyMarksToRun, themeColors, enableComments, storyKey);
		const isGhostTrackedListArtifact = trackedChangesConfig.enabled && isGhostSuppressionMode(trackedChangesConfig.mode) && Boolean(paragraphAttrs.numberingProperties) && Boolean(paragraphMarkTrackedChange) && filteredRuns.length > 0 && filteredRuns.every(isEmptyTextRun);
		if (trackedChangesConfig.enabled && (filteredRuns.length === 0 || isGhostTrackedListArtifact)) {
			blocks.pop();
			return finalizeParagraphBlocks(blocks);
		}
		paragraphBlock.runs = filteredRuns;
		paragraphBlock.attrs = {
			...paragraphBlock.attrs ?? {},
			trackedChangesMode: trackedChangesConfig.mode,
			trackedChangesEnabled: trackedChangesConfig.enabled
		};
		return finalizeParagraphBlocks(blocks);
	}
	let currentRuns = [];
	let partIndex = 0;
	let tabOrdinal = 0;
	let suppressedByVanish = false;
	const nextId = () => partIndex === 0 ? baseBlockId : `${baseBlockId}-${partIndex}`;
	const attachAnchorParagraphId = (block, anchorParagraphId) => {
		if (!new Set([
			"drawing",
			"image",
			"table"
		]).has(block.kind)) return block;
		const blockWithAttrs = block;
		if (!blockWithAttrs.attrs) blockWithAttrs.attrs = {};
		blockWithAttrs.attrs.anchorParagraphId = anchorParagraphId;
		return blockWithAttrs;
	};
	const attachInlineShapeGroupAlignment = (block) => {
		if (block.kind !== "drawing") return block;
		const drawingBlock = block;
		const rawWrap = drawingBlock.attrs?.wrap;
		if (drawingBlock.drawingKind !== "shapeGroup" || rawWrap?.type !== "Inline") return block;
		const effectiveAlignment = resolvedParagraphProperties.justification === "distribute" ? "center" : paragraphAttrs.alignment;
		if (effectiveAlignment === "center" || effectiveAlignment === "right") {
			if (!drawingBlock.attrs) drawingBlock.attrs = {};
			drawingBlock.attrs.inlineParagraphAlignment = effectiveAlignment;
			const indent = paragraphAttrs.indent;
			if (typeof indent?.left === "number") drawingBlock.attrs.paragraphIndentLeft = indent.left;
			if (typeof indent?.right === "number") drawingBlock.attrs.paragraphIndentRight = indent.right;
		}
		return block;
	};
	const flushParagraph = () => {
		if (currentRuns.length === 0) return;
		const runs = currentRuns;
		currentRuns = [];
		blocks.push({
			kind: "paragraph",
			id: nextId(),
			runs,
			attrs: deepClone(paragraphAttrs),
			sourceAnchor
		});
		partIndex += 1;
	};
	const visitNode = (node, inheritedMarks = [], activeSdt, activeRunProperties, activeHidden = false, activeInlineRunProperties) => {
		if (activeHidden && node.type !== "run") {
			suppressedByVanish = true;
			return;
		}
		if (isHiddenShape(node)) return;
		const inlineConverterParams = {
			node,
			positions,
			storyKey,
			defaultFont,
			defaultSize,
			inheritedMarks: inheritedMarks ?? [],
			sdtMetadata: activeSdt,
			hyperlinkConfig,
			themeColors,
			enableComments,
			runProperties: activeRunProperties,
			inlineRunProperties: activeInlineRunProperties,
			paragraphProperties: resolvedParagraphProperties,
			converterContext,
			visitNode,
			bookmarks,
			tabOrdinal,
			paragraphAttrs,
			nextBlockId: stableNextBlockId
		};
		const blockOptions = {
			blocks,
			nextBlockId: stableNextBlockId,
			nextId,
			positions,
			storyKey,
			trackedChangesConfig,
			defaultFont,
			defaultSize,
			converterContext,
			hyperlinkConfig,
			enableComments,
			bookmarks,
			converters: converters$1,
			paragraphAttrs
		};
		if (INLINE_CONVERTERS_REGISTRY[node.type]) {
			const { inlineConverter, extraCheck, blockConverter } = INLINE_CONVERTERS_REGISTRY[node.type];
			if (!extraCheck || extraCheck(node)) try {
				if (!inlineConverter) throw new NotInlineNodeError();
				else {
					const run$1 = inlineConverter(inlineConverterParams);
					if (run$1) {
						if (node.type === "tab") {
							const tabRun = run$1;
							if (tabRun.fontSize == null) tabRun.fontSize = defaultSize;
							if (tabRun.fontFamily == null) tabRun.fontFamily = defaultFont;
							tabOrdinal += 1;
						}
						currentRuns.push(run$1);
					}
				}
			} catch (error) {
				if (error instanceof HiddenByVanishError) suppressedByVanish = true;
				else if (error instanceof NotInlineNodeError && blockConverter) {
					const anchorParagraphId = nextId();
					flushParagraph();
					const newBlocks = [];
					const block = blockConverter(node, {
						...blockOptions,
						blocks: newBlocks
					});
					if (block) {
						attachAnchorParagraphId(block, anchorParagraphId);
						attachInlineShapeGroupAlignment(block);
						blocks.push(block);
					} else if (newBlocks.length > 0) newBlocks.forEach((b) => {
						attachAnchorParagraphId(b, anchorParagraphId);
						attachInlineShapeGroupAlignment(b);
						blocks.push(b);
					});
				} else throw error;
			}
			return;
		}
		if (SHAPE_CONVERTERS_REGISTRY[node.type]) {
			const anchorParagraphId = nextId();
			flushParagraph();
			const converter = SHAPE_CONVERTERS_REGISTRY[node.type];
			const drawingBlock = converter(node, stableNextBlockId, positions);
			if (drawingBlock) {
				const hydratedBlock = hydrateTextboxDrawingContent(node, drawingBlock, {
					converterContext,
					converters: converters$1,
					nextBlockId: stableNextBlockId,
					positions
				});
				attachInlineShapeGroupAlignment(hydratedBlock);
				blocks.push(attachAnchorParagraphId(hydratedBlock, anchorParagraphId));
			}
			return;
		}
	};
	para.content.forEach((child) => {
		visitNode(child, [], void 0, void 0);
	});
	flushParagraph();
	if (!blocks.some((block) => block.kind === "paragraph") && !suppressedByVanish && !paragraphProps.runProperties?.vanish) blocks.push({
		kind: "paragraph",
		id: baseBlockId,
		runs: [{
			text: "",
			fontFamily: defaultFont,
			fontSize: defaultSize
		}],
		attrs: deepClone(paragraphAttrs),
		sourceAnchor
	});
	blocks.forEach((block) => {
		if (block.kind === "paragraph" && block.runs.length > 1) block.runs = mergeAdjacentRuns(block.runs);
	});
	blocks.forEach((block) => {
		if (block.kind === "paragraph" && block.runs.some((r) => "text" in r && typeof r.text === "string" && r.text.includes("\n"))) block.runs = expandRunsForInlineNewlines(block.runs);
	});
	if (!trackedChangesConfig) return finalizeParagraphBlocks(blocks);
	const processedBlocks = [];
	blocks.forEach((block) => {
		if (block.kind !== "paragraph") {
			processedBlocks.push(block);
			return;
		}
		const filteredRuns = applyTrackedChangesModeToRuns(block.runs, trackedChangesConfig, hyperlinkConfig, applyMarksToRun, themeColors, enableComments, storyKey);
		if (trackedChangesConfig.enabled && filteredRuns.length === 0) return;
		block.runs = filteredRuns;
		block.attrs = {
			...block.attrs ?? {},
			trackedChangesMode: trackedChangesConfig.mode,
			trackedChangesEnabled: trackedChangesConfig.enabled
		};
		processedBlocks.push(block);
	});
	return finalizeParagraphBlocks(processedBlocks);
}
var INLINE_CONVERTERS_REGISTRY = {
	footnoteReference: { inlineConverter: footnoteReferenceToBlock },
	endnoteReference: { inlineConverter: endnoteReferenceToBlock },
	text: {
		inlineConverter: textNodeToRun,
		extraCheck: (node) => Boolean(node.text)
	},
	run: {
		inlineConverter: runNodeChildrenToRuns,
		extraCheck: (node) => Array.isArray(node.content)
	},
	structuredContent: { inlineConverter: structuredContentNodeToBlocks },
	smartTag: {
		inlineConverter: smartTagNodeToBlocks,
		extraCheck: (node) => Array.isArray(node.content)
	},
	fieldAnnotation: { inlineConverter: fieldAnnotationNodeToRun },
	pageReference: { inlineConverter: pageReferenceNodeToBlock },
	crossReference: { inlineConverter: crossReferenceNodeToRun },
	sequenceField: { inlineConverter: sequenceFieldNodeToRun },
	documentStatField: { inlineConverter: documentStatFieldNodeToRun },
	citation: { inlineConverter: citationNodeToRun },
	authorityEntry: { inlineConverter: authorityEntryNodeToRun },
	bookmarkStart: { inlineConverter: bookmarkStartNodeToBlocks },
	bookmarkEnd: { inlineConverter: bookmarkEndNodeToRun },
	tab: { inlineConverter: tabNodeToRun },
	noBreakHyphen: { inlineConverter: noBreakHyphenNodeToRun },
	image: {
		inlineConverter: imageNodeToRun,
		blockConverter: handleImageNode
	},
	contentBlock: { blockConverter: inlineContentBlockConverter },
	hardBreak: {
		inlineConverter: lineBreakNodeToRun,
		blockConverter: lineBreakNodeToBreakBlock
	},
	lineBreak: {
		inlineConverter: lineBreakNodeToRun,
		blockConverter: lineBreakNodeToBreakBlock
	},
	table: { blockConverter: tableNodeToBlock },
	mathInline: { inlineConverter: mathInlineNodeToRun }
};
for (const type of TOKEN_INLINE_TYPES.keys()) INLINE_CONVERTERS_REGISTRY[type] = { inlineConverter: tokenNodeToRun };
var SHAPE_CONVERTERS_REGISTRY = {
	vectorShape: vectorShapeNodeToDrawingBlock,
	shapeGroup: shapeGroupNodeToDrawingBlock,
	shapeContainer: shapeContainerNodeToDrawingBlock,
	shapeTextbox: shapeTextboxNodeToDrawingBlock,
	chart: chartNodeToDrawingBlock
};
function getLastParagraphFont(blocks) {
	for (let i$1 = blocks.length - 1; i$1 >= 0; i$1--) {
		const block = blocks[i$1];
		if (block.kind === "paragraph") {
			const firstRun = block.runs?.[0];
			if (!firstRun) continue;
			const run$1 = firstRun;
			if (typeof run$1.text === "string" && run$1.text.length === 0) continue;
			const fontFamily = typeof run$1.fontFamily === "string" ? run$1.fontFamily.trim() : "";
			const fontSize = typeof run$1.fontSize === "number" && Number.isFinite(run$1.fontSize) ? run$1.fontSize : NaN;
			if (fontFamily.length > 0 && fontSize > 0) return {
				fontFamily,
				fontSize
			};
		}
	}
}
function handleParagraphNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, blockIdPrefix = "", positions, trackedChangesConfig, bookmarks, hyperlinkConfig, sectionState, converters: converters$1, converterContext, themeColors, flowBlockCache, enableComments } = context;
	const { ranges: sectionRanges, currentSectionIndex, currentParagraphIndex } = sectionState;
	if (sectionRanges.length > 0) {
		const nextSection = sectionRanges[currentSectionIndex + 1];
		if (nextSection && currentParagraphIndex === nextSection.startParagraphIndex) {
			const currentSection = sectionRanges[currentSectionIndex];
			const sectionBreak = createSectionBreakBlock(nextSection, nextBlockId, shouldRequirePageBoundary(currentSection, nextSection) || hasIntrinsicBoundarySignals(nextSection) ? { requirePageBoundary: true } : void 0);
			blocks.push(sectionBreak);
			recordBlockKind?.(sectionBreak.kind);
			sectionState.currentSectionIndex++;
			converterContext.sectionDirection = resolveSectionDirectionFromSectPr$1(nextSection.sectPr);
		}
	}
	const paragraphToFlowBlocks$1 = converters$1.paragraphToFlowBlocks;
	const stableId = getStableParagraphId(node);
	const prefixedStableId = stableId ? `${blockIdPrefix}${stableId}` : null;
	const pmStart = positions.get(node)?.start ?? 0;
	if (prefixedStableId && flowBlockCache) {
		const { entry: cached, nodeJson, nodeRev } = flowBlockCache.get(prefixedStableId, node);
		if (cached) {
			const delta = pmStart - cached.pmStart;
			const reusedBlocks = shiftCachedBlocks(cached.blocks, delta);
			const paragraphProps = node.attrs?.paragraphProperties;
			const previousParagraphFont$2 = !hasExplicitParagraphRunProperties(paragraphProps) ? getLastParagraphFont(blocks) : void 0;
			reusedBlocks.forEach((block) => {
				if (block.kind === "paragraph") syncListMarkerFontFromParagraphRuns({
					block,
					converterContext,
					para: node,
					contentFontSource: "paragraph",
					previousParagraphFont: previousParagraphFont$2
				});
			});
			applyTrackedGhostListAdjustments(node, reusedBlocks, context);
			reusedBlocks.forEach((block) => {
				blocks.push(block);
				recordBlockKind?.(block.kind);
			});
			flowBlockCache.set(prefixedStableId, nodeJson, nodeRev, reusedBlocks, pmStart);
			sectionState.currentParagraphIndex++;
			return;
		}
		const previousParagraphFont$1 = getLastParagraphFont(blocks);
		const paragraphBlocks$1 = paragraphToFlowBlocks$1({
			para: node,
			nextBlockId,
			positions,
			storyKey: context.storyKey,
			trackedChangesConfig,
			bookmarks,
			hyperlinkConfig,
			themeColors,
			converters: converters$1,
			converterContext,
			enableComments,
			stableBlockId: prefixedStableId,
			previousParagraphFont: previousParagraphFont$1
		});
		applyTrackedGhostListAdjustments(node, paragraphBlocks$1, context);
		paragraphBlocks$1.forEach((block) => {
			blocks.push(block);
			recordBlockKind?.(block.kind);
		});
		flowBlockCache.set(prefixedStableId, nodeJson, nodeRev, paragraphBlocks$1, pmStart);
		sectionState.currentParagraphIndex++;
		return;
	}
	const previousParagraphFont = getLastParagraphFont(blocks);
	const paragraphBlocks = paragraphToFlowBlocks$1({
		para: node,
		nextBlockId,
		positions,
		storyKey: context.storyKey,
		trackedChangesConfig,
		bookmarks,
		hyperlinkConfig,
		themeColors,
		converters: converters$1,
		converterContext,
		enableComments,
		stableBlockId: prefixedStableId ?? void 0,
		previousParagraphFont
	});
	applyTrackedGhostListAdjustments(node, paragraphBlocks, context);
	paragraphBlocks.forEach((block) => {
		blocks.push(block);
		recordBlockKind?.(block.kind);
	});
	sectionState.currentParagraphIndex++;
}
var JUSTIFICATION_TO_ALIGN = {
	center: "center",
	centerGroup: "center",
	left: "left",
	right: "right"
};
function handleMathBlockNode(node, context) {
	const { blocks, recordBlockKind, nextBlockId, positions } = context;
	const textContent = String(node.attrs?.textContent ?? "");
	const justification = String(node.attrs?.justification ?? "centerGroup");
	const { width, height } = estimateMathDimensions(textContent, node.attrs?.originalXml ?? null);
	const pos = positions.get(node);
	const mathRun = {
		kind: "math",
		ommlJson: node.attrs?.originalXml ?? null,
		textContent,
		width,
		height,
		pmStart: pos?.start,
		pmEnd: pos?.end
	};
	const { paragraphAttrs } = computeParagraphAttrs(node, context.converterContext);
	const block = {
		kind: "paragraph",
		id: nextBlockId("paragraph"),
		runs: [mathRun],
		attrs: {
			...paragraphAttrs,
			alignment: JUSTIFICATION_TO_ALIGN[justification] ?? paragraphAttrs.alignment ?? "center"
		}
	};
	blocks.push(block);
	recordBlockKind?.(block.kind);
}
var DEFAULT_FONT = "Times New Roman";
var DEFAULT_SIZE = 10 / .75;
function resolveSectionDirectionFromSectPr(sectPr) {
	if (!sectPr || typeof sectPr !== "object") return void 0;
	const elements = sectPr.elements;
	if (!Array.isArray(elements)) return void 0;
	const bidi = elements.find((element) => element?.name === "w:bidi");
	if (!bidi) return void 0;
	const val = bidi.attributes?.["w:val"] ?? bidi.attributes?.val;
	if (val === "0" || val === 0 || val === false || val === "false" || val === "off") return "ltr";
	return "rtl";
}
const nodeHandlers = {
	paragraph: handleParagraphNode,
	tableOfContents: handleTableOfContentsNode,
	index: handleParagraphContainerNode,
	structuredContentBlock: handleStructuredContentBlockNode,
	documentSection: handleDocumentSectionNode,
	table: handleTableNode,
	documentPartObject: handleDocumentPartObjectNode,
	bibliography: handleParagraphContainerNode,
	tableOfAuthorities: handleParagraphContainerNode,
	image: handleImageNode,
	vectorShape: handleVectorShapeNode,
	shapeGroup: handleShapeGroupNode,
	shapeContainer: handleShapeContainerNode,
	shapeTextbox: handleShapeTextboxNode,
	chart: handleChartNode,
	mathBlock: handleMathBlockNode
};
var converters = {
	contentBlockNodeToDrawingBlock,
	imageNodeToBlock,
	vectorShapeNodeToDrawingBlock,
	shapeGroupNodeToDrawingBlock,
	shapeContainerNodeToDrawingBlock,
	shapeTextboxNodeToDrawingBlock,
	chartNodeToDrawingBlock,
	tableNodeToBlock,
	paragraphToFlowBlocks
};
function toFlowBlocks(pmDoc, options) {
	const defaultFont = options?.defaultFont ?? DEFAULT_FONT;
	const defaultSize = options?.defaultSize ?? DEFAULT_SIZE;
	const instrumentation = options?.instrumentation;
	const idPrefix = normalizePrefix(options?.blockIdPrefix);
	const doc$2 = pmDoc;
	const flowBlockCache = options?.flowBlockCache;
	flowBlockCache?.begin();
	if (!doc$2.content) {
		flowBlockCache?.commit();
		return {
			blocks: [],
			bookmarks: /* @__PURE__ */ new Map()
		};
	}
	const trackedChangesConfig = {
		mode: isValidTrackedMode(options?.trackedChangesMode) ? options.trackedChangesMode : "review",
		enabled: options?.enableTrackedChanges ?? true
	};
	const hyperlinkConfig = { enableRichHyperlinks: options?.enableRichHyperlinks ?? false };
	const enableComments = options?.enableComments ?? true;
	const themeColors = options?.themeColors;
	const converterContext = normalizeConverterContext(options?.converterContext, defaultFont, defaultSize);
	if (options?.showBookmarks !== void 0) converterContext.showBookmarks = options.showBookmarks;
	if (converterContext.showBookmarks) converterContext.renderedBookmarkIds = /* @__PURE__ */ new Set();
	const blocks = [];
	const bookmarks = /* @__PURE__ */ new Map();
	const positions = options?.positions ?? (options?.atomNodeTypes ? buildPositionMap(doc$2, { atomNodeTypes: options.atomNodeTypes }) : buildPositionMap(doc$2));
	const nextBlockId = createBlockIdGenerator(idPrefix);
	const blockCounts = {};
	const recordBlockKind = (kind) => {
		blockCounts[kind] = (blockCounts[kind] ?? 0) + 1;
	};
	const bodySectionProps = doc$2.attrs?.bodySectPr ?? doc$2.attrs?.sectPr;
	const sectionRanges = options?.emitSectionBreaks ? analyzeSectionRanges(doc$2, bodySectionProps) : [];
	const firstSectPr = sectionRanges[0]?.sectPr ?? bodySectionProps;
	converterContext.sectionDirection = converterContext.sectionDirection ?? resolveSectionDirectionFromSectPr(firstSectPr);
	converterContext.sectionDirectionContext = resolveSectionDirection(firstSectPr);
	publishSectionMetadata(sectionRanges, options);
	if (sectionRanges.length > 0 && sectionRanges[0]) {
		const sectionBreak = createSectionBreakBlock(sectionRanges[0], nextBlockId, { isFirstSection: true });
		blocks.push(sectionBreak);
		recordBlockKind(sectionBreak.kind);
	}
	const handlerContext = {
		blocks,
		recordBlockKind,
		nextBlockId,
		blockIdPrefix: idPrefix,
		storyKey: options?.storyKey,
		positions,
		defaultFont,
		defaultSize,
		converterContext,
		trackedChangesConfig,
		hyperlinkConfig,
		enableComments,
		bookmarks,
		sectionState: {
			ranges: sectionRanges,
			currentSectionIndex: 0,
			currentParagraphIndex: 0,
			currentNodeIndex: 0
		},
		converters,
		themeColors,
		flowBlockCache,
		trackedListMarkerOffsets: /* @__PURE__ */ new Map(),
		trackedListLastOrdinals: /* @__PURE__ */ new Map()
	};
	doc$2.content.forEach((node) => {
		maybeEmitNextSectionBreakForNode({
			sectionState: handlerContext.sectionState,
			nextBlockId,
			pushBlock: (block) => {
				blocks.push(block);
				recordBlockKind(block.kind);
			}
		});
		const handler$1 = nodeHandlers[node.type];
		if (handler$1) handler$1(node, handlerContext);
		handlerContext.sectionState.currentNodeIndex++;
	});
	if (sectionRanges.length > 0) {
		const lastSectionIndex = sectionRanges.length - 1;
		const lastSection = sectionRanges[lastSectionIndex];
		if (handlerContext.sectionState.currentSectionIndex < lastSectionIndex) {
			const sectionBreak = createSectionBreakBlock(lastSection, nextBlockId);
			blocks.push(sectionBreak);
			recordBlockKind(sectionBreak.kind);
		}
	}
	instrumentation?.log?.({
		totalBlocks: blocks.length,
		blockCounts,
		bookmarks: bookmarks.size
	});
	const mergedBlocks = mergeFusedParagraphs(mergeDropCapParagraphs(hydrateImageBlocks(blocks, options?.mediaFiles)));
	stampTrackedChangeColors(mergedBlocks, options?.resolveTrackedChangeColor);
	resolveSequenceFieldTokens(mergedBlocks);
	flowBlockCache?.commit();
	return {
		blocks: mergedBlocks,
		bookmarks
	};
}
function mergeDropCapParagraphs(blocks) {
	const result = [];
	let i$1 = 0;
	while (i$1 < blocks.length) {
		const block = blocks[i$1];
		if (block.kind === "paragraph" && block.attrs?.dropCapDescriptor && i$1 + 1 < blocks.length) {
			const dropCapBlock = block;
			const nextBlock = blocks[i$1 + 1];
			if (nextBlock.kind === "paragraph") {
				const textBlock = nextBlock;
				const mergedBlock = {
					kind: "paragraph",
					id: textBlock.id,
					runs: textBlock.runs,
					attrs: {
						...textBlock.attrs,
						dropCapDescriptor: dropCapBlock.attrs?.dropCapDescriptor,
						dropCap: void 0
					}
				};
				result.push(mergedBlock);
				i$1 += 2;
				continue;
			}
		}
		result.push(block);
		i$1 += 1;
	}
	return result;
}
function mergeFusedParagraphs(blocks) {
	const result = [];
	for (const block of blocks) {
		const prev = result.length > 0 ? result[result.length - 1] : void 0;
		if (block.kind === "paragraph" && prev?.kind === "paragraph" && prev.attrs?.suppressParagraphBreak) {
			const head = prev;
			const tail = block;
			const mergedAttrs = { ...head.attrs };
			if (tail.attrs?.suppressParagraphBreak) mergedAttrs.suppressParagraphBreak = true;
			else delete mergedAttrs.suppressParagraphBreak;
			const merged = {
				kind: "paragraph",
				id: head.id,
				runs: [...head.runs, ...tail.runs],
				attrs: mergedAttrs,
				...head.sourceAnchor ? { sourceAnchor: head.sourceAnchor } : {}
			};
			result[result.length - 1] = merged;
			continue;
		}
		result.push(block);
	}
	return result;
}
function normalizeConverterContext(context, defaultFont, defaultSize) {
	if (!context) context = {
		translatedNumbering: {},
		translatedLinkedStyles: {
			docDefaults: {},
			latentStyles: {},
			styles: {}
		}
	};
	if (!context.translatedLinkedStyles.docDefaults) context.translatedLinkedStyles.docDefaults = {};
	if (!context.translatedLinkedStyles.docDefaults.runProperties) context.translatedLinkedStyles.docDefaults.runProperties = {};
	if (!context.translatedLinkedStyles.docDefaults.runProperties.fontFamily) context.translatedLinkedStyles.docDefaults.runProperties.fontFamily = {};
	if (!context.translatedLinkedStyles.docDefaults.runProperties.fontFamily.ascii) context.translatedLinkedStyles.docDefaults.runProperties.fontFamily.ascii = defaultFont;
	if (!context.translatedLinkedStyles.docDefaults.runProperties.fontSize) context.translatedLinkedStyles.docDefaults.runProperties.fontSize = defaultSize * .75 * 2;
	return context;
}
const CommentMarkName = "commentMark";
var LINK_MARK_NAME = "link";
var COMMENT_MARK_NAME = CommentMarkName;
var SUPPORTED_INLINE_TYPES = new Set([
	"run",
	"bookmark",
	"comment",
	"hyperlink",
	"sdt",
	"image",
	"footnoteRef",
	"endnoteRef",
	"crossRef",
	"indexEntry",
	"citation",
	"authorityEntry",
	"sequenceField",
	"tab",
	"lineBreak"
]);
function isInlineQueryType(nodeType) {
	return SUPPORTED_INLINE_TYPES.has(nodeType);
}
function stableStringify(value) {
	if (value == null) return "";
	if (typeof value !== "object") return String(value);
	if (Array.isArray(value)) return `[${value.map(stableStringify).join(",")}]`;
	return `{${Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, val]) => `${key}:${stableStringify(val)}`).join(",")}}`;
}
function markKey(mark) {
	return `${mark.type.name}:${stableStringify(mark.attrs ?? {})}`;
}
function mapInlineNodeType(node) {
	switch (node.type.name) {
		case "run": return "run";
		case "image": return "image";
		case "tab": return "tab";
		case "lineBreak":
		case "hardBreak":
		case "hard_break": return "lineBreak";
		case "footnoteReference": return "footnoteRef";
		case "endnoteReference": return "endnoteRef";
		case "crossReference": return "crossRef";
		case "indexEntry": return "indexEntry";
		case "citation": return "citation";
		case "authorityEntry": return "authorityEntry";
		case "sequenceField": return "sequenceField";
		case "structuredContent": return "sdt";
		default: return;
	}
}
function makeAnchor(blockId, start, end) {
	return {
		start: {
			blockId,
			offset: start
		},
		end: {
			blockId,
			offset: end
		}
	};
}
function inlineKey(nodeType, anchor) {
	return `${nodeType}:${anchor.start.blockId}:${anchor.start.offset}:${anchor.end.offset}`;
}
function createBlockWalkState(blockId, candidates) {
	return {
		blockId,
		offset: 0,
		candidates,
		activeMarks: /* @__PURE__ */ new Map(),
		bookmarkStarts: /* @__PURE__ */ new Map(),
		commentRangeStarts: /* @__PURE__ */ new Map(),
		commentIdsWithMarks: /* @__PURE__ */ new Set()
	};
}
function isInlineHost(node) {
	return Boolean(node.inlineContent) || Boolean(node.isTextblock);
}
function relevantMarks(marks) {
	if (!marks?.length) return [];
	return marks.filter((mark) => mark.type?.name === LINK_MARK_NAME || mark.type?.name === COMMENT_MARK_NAME);
}
function closeMarkSpan(state, key, endOffset, endPos) {
	const active = state.activeMarks.get(key);
	if (!active) return;
	state.activeMarks.delete(key);
	if (endOffset <= active.startOffset) return;
	const markType = active.mark.type?.name;
	const nodeType = markType === LINK_MARK_NAME ? "hyperlink" : markType === COMMENT_MARK_NAME ? "comment" : void 0;
	if (!nodeType) return;
	const attrs = active.mark.attrs ?? {};
	if (nodeType === "comment") {
		const commentId = typeof attrs.commentId === "string" ? attrs.commentId : typeof attrs.importedId === "string" ? attrs.importedId : void 0;
		if (commentId) state.commentIdsWithMarks.add(commentId);
	}
	state.candidates.push({
		nodeType,
		anchor: makeAnchor(state.blockId, active.startOffset, endOffset),
		blockId: state.blockId,
		pos: active.startPos,
		end: endPos,
		mark: active.mark,
		attrs
	});
}
function closeAllMarks(state, endPos) {
	for (const key of Array.from(state.activeMarks.keys())) closeMarkSpan(state, key, state.offset, endPos);
}
function syncMarks(state, marks, docPos) {
	const marksOfInterest = relevantMarks(marks);
	const nextKeys = /* @__PURE__ */ new Set();
	for (const mark of marksOfInterest) {
		const key = markKey(mark);
		nextKeys.add(key);
		if (!state.activeMarks.has(key)) state.activeMarks.set(key, {
			mark,
			startOffset: state.offset,
			startPos: docPos
		});
	}
	for (const [key] of state.activeMarks.entries()) if (!nextKeys.has(key)) closeMarkSpan(state, key, state.offset, docPos);
}
function handleBookmarkStart(state, node, docPos) {
	const attrs = node.attrs ?? {};
	const id = typeof attrs.id === "string" ? attrs.id : typeof attrs.name === "string" ? attrs.name : void 0;
	if (!id) return;
	state.bookmarkStarts.set(id, {
		offset: state.offset,
		pos: docPos,
		attrs
	});
}
function handleBookmarkEnd(state, node, docPos) {
	const attrs = node.attrs ?? {};
	const id = typeof attrs.id === "string" ? attrs.id : void 0;
	if (!id) return;
	const start = state.bookmarkStarts.get(id);
	if (!start) return;
	state.bookmarkStarts.delete(id);
	if (state.offset < start.offset) return;
	state.candidates.push({
		nodeType: "bookmark",
		anchor: makeAnchor(state.blockId, start.offset, state.offset),
		blockId: state.blockId,
		pos: start.pos,
		end: docPos,
		attrs: start.attrs
	});
}
function handleCommentRangeStart(state, node, docPos) {
	const attrs = node.attrs ?? {};
	const id = typeof attrs["w:id"] === "string" ? attrs["w:id"] : void 0;
	if (!id) return;
	state.commentRangeStarts.set(id, {
		offset: state.offset,
		pos: docPos,
		attrs
	});
}
function handleCommentRangeEnd(state, node, docPos) {
	const attrs = node.attrs ?? {};
	const id = typeof attrs["w:id"] === "string" ? attrs["w:id"] : void 0;
	if (!id) return;
	if (state.commentIdsWithMarks.has(id)) return;
	const start = state.commentRangeStarts.get(id);
	if (!start) return;
	state.commentRangeStarts.delete(id);
	if (state.offset < start.offset) return;
	state.candidates.push({
		nodeType: "comment",
		anchor: makeAnchor(state.blockId, start.offset, state.offset),
		blockId: state.blockId,
		pos: start.pos,
		end: docPos,
		attrs: {
			...start.attrs,
			...attrs
		}
	});
}
function walkNodeContent(state, node, contentStart) {
	let firstChild = true;
	node.forEach((child, childOffset) => {
		const childDocPos = contentStart + childOffset;
		if (child.isBlock && !firstChild) {
			closeAllMarks(state, childDocPos);
			state.offset += 1;
		}
		walkNode(state, child, childDocPos);
		firstChild = false;
	});
}
function walkNode(state, node, docPos) {
	const isBookmarkStart = node.type?.name === "bookmarkStart";
	if (isBookmarkStart) handleBookmarkStart(state, node, docPos);
	if (node.isText) {
		const text$2 = node.text ?? "";
		syncMarks(state, node.marks, docPos);
		state.offset += text$2.length;
		return;
	}
	if (node.isLeaf) {
		syncMarks(state, node.marks, docPos);
		if (node.type?.name === "bookmarkEnd") {
			handleBookmarkEnd(state, node, docPos);
			return;
		} else if (node.type?.name === "commentRangeStart") {
			handleCommentRangeStart(state, node, docPos);
			return;
		} else if (node.type?.name === "commentRangeEnd") {
			handleCommentRangeEnd(state, node, docPos);
			return;
		} else if (!isBookmarkStart) {
			const nodeType = mapInlineNodeType(node);
			if (nodeType) state.candidates.push({
				nodeType,
				anchor: makeAnchor(state.blockId, state.offset, state.offset + 1),
				blockId: state.blockId,
				pos: docPos,
				end: docPos + node.nodeSize,
				node
			});
		}
		state.offset += 1;
		return;
	}
	if (node.isInline) {
		const nodeType = mapInlineNodeType(node);
		const startOffset = state.offset;
		const startPos = docPos;
		walkNodeContent(state, node, docPos + 1);
		const endOffset = state.offset;
		const endPos = docPos + node.nodeSize;
		if (nodeType) state.candidates.push({
			nodeType,
			anchor: makeAnchor(state.blockId, startOffset, endOffset),
			blockId: state.blockId,
			pos: startPos,
			end: endPos,
			node
		});
		return;
	}
	walkNodeContent(state, node, docPos + 1);
}
function buildIndexMaps(candidates) {
	const byType = /* @__PURE__ */ new Map();
	const byKey = /* @__PURE__ */ new Map();
	for (const candidate of candidates) {
		if (!byType.has(candidate.nodeType)) byType.set(candidate.nodeType, []);
		byType.get(candidate.nodeType).push(candidate);
		byKey.set(inlineKey(candidate.nodeType, candidate.anchor), candidate);
	}
	return {
		candidates,
		byType,
		byKey
	};
}
function buildInlineIndex(editor, blockIndex) {
	const candidates = [];
	for (const block of blockIndex.candidates) {
		if (!isInlineHost(block.node)) continue;
		const state = createBlockWalkState(block.nodeId, candidates);
		walkNodeContent(state, block.node, block.pos + 1);
		closeAllMarks(state, block.pos + block.node.nodeSize);
	}
	candidates.sort((a, b) => a.pos === b.pos ? a.end - b.end : a.pos - b.pos);
	return buildIndexMaps(candidates);
}
function findInlineByAnchor(index, address) {
	if (address.kind !== "inline") return void 0;
	if (address.anchor.start.blockId !== address.anchor.end.blockId) return void 0;
	const nodeType = address.nodeType;
	return index.byKey.get(inlineKey(nodeType, address.anchor));
}
function findInlineByType(index, nodeType) {
	if (!nodeType) return index.candidates;
	return index.byType.get(nodeType) ?? [];
}
function toNonEmptyString(value) {
	return typeof value === "string" && value.length > 0 ? value : void 0;
}
function toFiniteNumber(value) {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	if (typeof value === "string" && value.trim().length > 0) {
		const parsed = Number(value);
		if (Number.isFinite(parsed)) return parsed;
	}
}
function toId(value) {
	if (typeof value === "string" && value.length > 0) return value;
	if (typeof value === "number" && Number.isFinite(value)) return String(value);
}
function resolveCommentIdFromAttrs(attrs) {
	return toNonEmptyString(attrs.commentId) ?? toNonEmptyString(attrs.importedId) ?? toNonEmptyString(attrs["w:id"]);
}
function normalizeExcerpt(text$2) {
	const trimmed = text$2.replace(/\s+/g, " ").trim();
	return trimmed.length ? trimmed : void 0;
}
function stableHash$1(input) {
	let hash = 2166136261;
	for (let index = 0; index < input.length; index += 1) {
		hash ^= input.charCodeAt(index);
		hash = Math.imul(hash, 16777619);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}
function buildFallbackTocNodeId(node, pos) {
	return `toc-auto-${stableHash$1(`${pos}:${typeof node.attrs?.instruction === "string" ? node.attrs.instruction : ""}`)}`;
}
function resolvePublicTocNodeId(node, pos) {
	return buildFallbackTocNodeId(node, pos);
}
var FALLBACK_PREFIX = {
	table: "table-auto",
	tableCell: "cell-auto",
	paragraph: "para-auto",
	heading: "heading-auto",
	listItem: "list-auto"
};
var UUID_LIKE_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function stableHash(input) {
	let hash = 2166136261;
	for (let index = 0; index < input.length; index += 1) {
		hash ^= input.charCodeAt(index);
		hash = Math.imul(hash, 16777619);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}
function toFallbackEligibleBlockNodeType(nodeType) {
	if (nodeType === "table") return "table";
	if (nodeType === "tableCell") return "tableCell";
	if (nodeType === "paragraph") return "paragraph";
	if (nodeType === "heading") return "heading";
	if (nodeType === "listItem") return "listItem";
}
function serializeTraversalPath(path, pos) {
	if (Array.isArray(path) && path.length > 0) return `path:${path.join(".")}`;
	return `pos:${pos}`;
}
function isVolatileRuntimeBlockId(id) {
	return typeof id === "string" && UUID_LIKE_PATTERN.test(id);
}
function buildFallbackBlockNodeId(nodeType, pos, path) {
	const eligibleType = toFallbackEligibleBlockNodeType(nodeType);
	if (!eligibleType) return void 0;
	return `${FALLBACK_PREFIX[eligibleType]}-${stableHash(`${eligibleType}:${serializeTraversalPath(path, pos)}`)}`;
}
function isListItem(attrs) {
	const numbering = attrs?.paragraphProperties?.numberingProperties;
	if (numbering && (numbering.numId != null || numbering.ilvl != null)) return true;
	const listRendering = attrs?.listRendering;
	if (listRendering?.markerText) return true;
	if (Array.isArray(listRendering?.path) && listRendering.path.length > 0) return true;
	return false;
}
function getHeadingLevel(styleId) {
	if (!styleId) return void 0;
	const match = /heading\s*([1-6])/i.exec(styleId);
	if (!match) return void 0;
	return Number(match[1]);
}
function mapBlockNodeType(node) {
	if (!node.isBlock) return void 0;
	switch (node.type.name) {
		case "paragraph": {
			const attrs = node.attrs;
			if (getHeadingLevel(attrs?.paragraphProperties?.styleId ?? void 0) != null) return "heading";
			if (isListItem(attrs)) return "listItem";
			return "paragraph";
		}
		case "table": return "table";
		case "tableRow": return "tableRow";
		case "tableCell":
		case "tableHeader": return "tableCell";
		case "image": return "image";
		case "tableOfContents": return "tableOfContents";
		case "structuredContentBlock":
		case "sdt": return "sdt";
		default: return;
	}
}
function resolveLegacyTableIdentity(attrs) {
	return toId(attrs.paraId) ?? toId(attrs.blockId) ?? toId(attrs.id) ?? toId(attrs.uuid);
}
function resolveTableRuntimeIdentity(nodeType, attrs, pos, path) {
	const sdBlockId = toId(attrs.sdBlockId);
	if (sdBlockId && !isVolatileRuntimeBlockId(sdBlockId)) return sdBlockId;
	return buildFallbackBlockNodeId(nodeType, pos, path);
}
function resolveParagraphRuntimeIdentity(nodeType, attrs, pos, path) {
	return toId(attrs.sdBlockId) ?? buildFallbackBlockNodeId(nodeType, pos, path);
}
function resolveBlockNodeId(node, pos, nodeType, path) {
	if (node.type.name === "paragraph") {
		const attrs$1 = node.attrs;
		return toId(attrs$1?.paraId) ?? resolveParagraphRuntimeIdentity(nodeType, attrs$1 ?? {}, pos, path);
	}
	if (nodeType === "tableOfContents") return resolvePublicTocNodeId(node, pos);
	const attrs = node.attrs ?? {};
	const typeName = node.type.name;
	if (typeName === "tableRow") return toId(attrs.paraId) ?? toId(attrs.sdBlockId) ?? toId(attrs.blockId) ?? toId(attrs.id) ?? toId(attrs.uuid);
	if (typeName === "table" || typeName === "tableCell" || typeName === "tableHeader") return resolveLegacyTableIdentity(attrs) ?? resolveTableRuntimeIdentity(nodeType, attrs, pos, path);
	return toId(attrs.blockId) ?? toId(attrs.id) ?? toId(attrs.paraId) ?? toId(attrs.uuid) ?? toId(attrs.sdBlockId);
}
function toBlockAddress(candidate) {
	return {
		kind: "block",
		nodeType: candidate.nodeType,
		nodeId: candidate.nodeId
	};
}
var ALIAS_ELIGIBLE_TYPES = new Set([
	"paragraph",
	"heading",
	"listItem",
	"table",
	"tableRow",
	"tableCell"
]);
function resolveBlockAliasId(node, nodeType, primaryId) {
	if (!ALIAS_ELIGIBLE_TYPES.has(nodeType)) return void 0;
	const sdBlockId = toId((node.attrs ?? {}).sdBlockId);
	if (sdBlockId && sdBlockId !== primaryId) return sdBlockId;
}
function buildBlockIndex(editor) {
	const candidates = [];
	const byId = /* @__PURE__ */ new Map();
	const ambiguous = /* @__PURE__ */ new Set();
	const pathByNode = /* @__PURE__ */ new WeakMap();
	const explicitIdentities = /* @__PURE__ */ new Map();
	pathByNode.set(editor.state.doc, []);
	function registerKey(key, candidate) {
		if (byId.has(key)) {
			ambiguous.add(key);
			byId.delete(key);
		} else if (!ambiguous.has(key)) byId.set(key, candidate);
	}
	function recordExplicitIdentities(node, pos) {
		const attrPriority = getBlockIdentityAttrsForType(node.type?.name);
		if (attrPriority.length === 0) return;
		const attrs = node.attrs ?? {};
		let nodeGroups;
		for (const attr of attrPriority) {
			const value = toIdentityValue(attrs[attr]);
			if (!value) continue;
			if (!nodeGroups) nodeGroups = /* @__PURE__ */ new Map();
			const existing = nodeGroups.get(value);
			if (existing) existing.push(attr);
			else nodeGroups.set(value, [attr]);
		}
		if (!nodeGroups) return;
		for (const [value, attrsForValue] of nodeGroups) {
			const observations = explicitIdentities.get(value);
			const observation = {
				pos,
				attrs: attrsForValue
			};
			if (observations) observations.push(observation);
			else explicitIdentities.set(value, [observation]);
		}
	}
	editor.state.doc.descendants((node, pos, parent, index) => {
		const parentPath = parent ? pathByNode.get(parent) ?? [] : [];
		const path = typeof index === "number" && Number.isInteger(index) && index >= 0 ? [...parentPath, index] : void 0;
		if (path) pathByNode.set(node, path);
		recordExplicitIdentities(node, pos);
		const nodeType = mapBlockNodeType(node);
		if (!nodeType) return;
		const nodeId = resolveBlockNodeId(node, pos, nodeType, path);
		if (!nodeId) return;
		const candidate = {
			node,
			pos,
			end: pos + node.nodeSize,
			nodeType,
			nodeId
		};
		candidates.push(candidate);
		registerKey(`${nodeType}:${nodeId}`, candidate);
		const aliasId = resolveBlockAliasId(node, nodeType, nodeId);
		if (aliasId) registerKey(`${nodeType}:${aliasId}`, candidate);
	});
	return {
		candidates,
		byId,
		ambiguous,
		explicitIdentities
	};
}
function findBlockById(index, address) {
	if (address.kind !== "block") return void 0;
	return index.byId.get(`${address.nodeType}:${address.nodeId}`);
}
function findBlockByIdStrict(index, address) {
	const key = `${address.nodeType}:${address.nodeId}`;
	if (index.ambiguous.has(key)) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share key "${key}".`, { target: address });
	const candidate = index.byId.get(key);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block "${key}" was not found.`, { target: address });
	return candidate;
}
function resolveBlockAlias(index, nodeId) {
	if (!index.byId) return void 0;
	const aliasMatches = /* @__PURE__ */ new Map();
	for (const [key, candidate] of index.byId) {
		if (!key.endsWith(`:${nodeId}`)) continue;
		aliasMatches.set(`${candidate.nodeType}:${candidate.nodeId}`, candidate);
	}
	if (aliasMatches.size > 1) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share nodeId "${nodeId}" via aliases.`, {
		nodeId,
		count: aliasMatches.size,
		matches: Array.from(aliasMatches.values()).map((candidate) => ({
			nodeType: candidate.nodeType,
			nodeId: candidate.nodeId
		}))
	});
	return aliasMatches.size === 1 ? Array.from(aliasMatches.values())[0] : void 0;
}
function findBlockByNodeIdOnly(index, nodeId) {
	const matches$1 = index.candidates.filter((candidate) => candidate.nodeId === nodeId);
	if (matches$1.length === 1) return matches$1[0];
	if (matches$1.length > 1) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share nodeId "${nodeId}".`, {
		nodeId,
		count: matches$1.length
	});
	const alias = resolveBlockAlias(index, nodeId);
	if (alias) return alias;
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block with nodeId "${nodeId}" was not found.`, { nodeId });
}
function isTextBlockCandidate(candidate) {
	const node = candidate.node;
	return Boolean(node?.inlineContent || node?.isTextblock);
}
function findBlockByPos(index, pos) {
	const candidates = index.candidates;
	let low = 0;
	let high = candidates.length - 1;
	while (low <= high) {
		const mid = low + high >> 1;
		const candidate = candidates[mid];
		if (pos < candidate.pos) {
			high = mid - 1;
			continue;
		}
		if (pos > candidate.end) {
			low = mid + 1;
			continue;
		}
		return candidate;
	}
}
var cacheByEditor = /* @__PURE__ */ new WeakMap();
function createCacheEntry(editor) {
	return {
		doc: editor.state.doc,
		blockIndex: buildBlockIndex(editor),
		inlineIndex: null
	};
}
function getCacheEntry(editor) {
	const doc$2 = editor.state.doc;
	const existing = cacheByEditor.get(editor);
	if (existing && existing.doc === doc$2) return existing;
	const next = createCacheEntry(editor);
	cacheByEditor.set(editor, next);
	return next;
}
function getBlockIndex(editor) {
	return getCacheEntry(editor).blockIndex;
}
function getInlineIndex(editor) {
	const entry = getCacheEntry(editor);
	if (!entry.inlineIndex) entry.inlineIndex = buildInlineIndex(editor, entry.blockIndex);
	return entry.inlineIndex;
}
function clearIndexCache(editor) {
	cacheByEditor.delete(editor);
}
function isVisibleTextModel(options) {
	return options?.textModel === "visible";
}
function hasTrackDeleteMark(node) {
	return node.marks?.some((mark) => mark.type.name === "trackDelete") ?? false;
}
function shouldSkipTextNode(node, options) {
	return isVisibleTextModel(options) && hasTrackDeleteMark(node);
}
function shouldSkipLeafNode(node, options) {
	return isVisibleTextModel(options) && hasTrackDeleteMark(node);
}
function resolveSegmentPosition(targetOffset, segmentStart, segmentLength, docFrom, docTo) {
	if (segmentLength <= 1) return targetOffset <= segmentStart ? docFrom : docTo;
	return docFrom + (targetOffset - segmentStart);
}
function pmPositionToTextOffset(blockNode, blockPos, pmPos, options) {
	const contentStart = blockPos + 1;
	if (pmPos <= contentStart) return 0;
	let offset = 0;
	let done = false;
	const visit = (node, docPos) => {
		if (done) return;
		if (node.isText) {
			const text$2 = node.text ?? "";
			const endPos = docPos + text$2.length;
			if (shouldSkipTextNode(node, options)) {
				if (pmPos < endPos) done = true;
				return;
			}
			if (pmPos >= endPos) offset += text$2.length;
			else {
				offset += Math.max(0, pmPos - docPos);
				done = true;
			}
			return;
		}
		if (node.isLeaf) {
			const endPos = docPos + node.nodeSize;
			if (shouldSkipLeafNode(node, options)) {
				if (pmPos < endPos) done = true;
				return;
			}
			if (pmPos >= endPos) offset += 1;
			else done = true;
			return;
		}
		visitContent(node, docPos + 1);
	};
	const visitContent = (node, contentPos) => {
		let isFirst = true;
		let childOffset = 0;
		for (let i$1 = 0; i$1 < node.childCount; i$1 += 1) {
			if (done) return;
			const child = node.child(i$1);
			const childPos = contentPos + childOffset;
			if (child.isBlock && !isFirst) if (pmPos >= childPos + 1) offset += 1;
			else {
				done = true;
				return;
			}
			visit(child, childPos);
			childOffset += child.nodeSize;
			isFirst = false;
		}
	};
	visitContent(blockNode, contentStart);
	return offset;
}
function computeTextContentLength(blockNode, options) {
	let length = 0;
	const walk = (node) => {
		if (node.isText) {
			if (shouldSkipTextNode(node, options)) return;
			length += (node.text ?? "").length;
			return;
		}
		if (node.isLeaf) {
			if (shouldSkipLeafNode(node, options)) return;
			length += 1;
			return;
		}
		let first$1 = true;
		for (let i$1 = 0; i$1 < node.childCount; i$1++) {
			const child = node.child(i$1);
			if (child.isBlock && !first$1) length += 1;
			walk(child);
			first$1 = false;
		}
	};
	let first = true;
	for (let i$1 = 0; i$1 < blockNode.childCount; i$1++) {
		const child = blockNode.child(i$1);
		if (child.isBlock && !first) length += 1;
		walk(child);
		first = false;
	}
	return length;
}
function resolveTextRangeInBlock(blockNode, blockPos, range, options) {
	if (range.start < 0 || range.end < range.start) return null;
	let offset = 0;
	let fromPos;
	let toPos;
	const advanceSegment = (segmentLength, docFrom, docTo) => {
		const segmentStart = offset;
		const segmentEnd = offset + segmentLength;
		const collapsed = range.start === range.end;
		if (fromPos == null && (range.start < segmentEnd || collapsed && range.start <= segmentEnd)) fromPos = resolveSegmentPosition(range.start, segmentStart, segmentLength, docFrom, docTo);
		if (toPos == null && range.end <= segmentEnd) toPos = resolveSegmentPosition(range.end, segmentStart, segmentLength, docFrom, docTo);
		offset = segmentEnd;
	};
	const walkNodeContent$1 = (node, contentStart) => {
		let isFirstChild = true;
		let childOffset = 0;
		for (let i$1 = 0; i$1 < node.childCount; i$1 += 1) {
			const child = node.child(i$1);
			const childPos = contentStart + childOffset;
			if (child.isBlock && !isFirstChild) advanceSegment(1, childPos, childPos + 1);
			walkNode$1(child, childPos);
			childOffset += child.nodeSize;
			isFirstChild = false;
		}
	};
	const walkNode$1 = (node, docPos) => {
		if (node.isText) {
			const text$2 = node.text ?? "";
			if (text$2.length > 0 && !shouldSkipTextNode(node, options)) advanceSegment(text$2.length, docPos, docPos + text$2.length);
			return;
		}
		if (node.isLeaf) {
			if (shouldSkipLeafNode(node, options)) return;
			advanceSegment(1, docPos, docPos + node.nodeSize);
			return;
		}
		walkNodeContent$1(node, docPos + 1);
	};
	walkNodeContent$1(blockNode, blockPos + 1);
	if (offset === 0 && range.start === 0 && range.end === 0) {
		const anchor = blockPos + 1;
		return {
			from: anchor,
			to: anchor
		};
	}
	if (range.end > offset) return null;
	if (fromPos == null || toPos == null) return null;
	return {
		from: fromPos,
		to: toPos
	};
}
function textContentInBlock(blockNode, options) {
	let text$2 = "";
	const walkNode$1 = (node) => {
		if (node.isText) {
			if (!shouldSkipTextNode(node, options)) text$2 += node.text ?? "";
			return;
		}
		if (node.isLeaf) {
			if (shouldSkipLeafNode(node, options)) return;
			const leafText = (node.type?.spec)?.leafText;
			text$2 += typeof leafText === "function" ? leafText(node) : "￼";
			return;
		}
		let isFirstChild$1 = true;
		for (let i$1 = 0; i$1 < node.childCount; i$1++) {
			const child = node.child(i$1);
			if (child.isBlock && !isFirstChild$1) text$2 += "\n";
			walkNode$1(child);
			isFirstChild$1 = false;
		}
	};
	let isFirstChild = true;
	for (let i$1 = 0; i$1 < blockNode.childCount; i$1++) {
		const child = blockNode.child(i$1);
		if (child.isBlock && !isFirstChild) text$2 += "\n";
		walkNode$1(child);
		isFirstChild = false;
	}
	return text$2;
}
function buildTextWithTabs(schema, text$2, marks, opts = {}) {
	const normalized = text$2.includes("\r") ? text$2.replace(/\r\n?/g, "\n") : text$2;
	const hasTab = normalized.includes("	");
	const hasNewline = normalized.includes("\n");
	if (!hasTab && !hasNewline) return schema.text(normalized, marks);
	const tabNodeType = hasTab && opts.parentAllowsTab !== false ? schema.nodes?.tab : void 0;
	const lineBreakNodeType = hasNewline && opts.parentAllowsLineBreak !== false ? schema.nodes?.lineBreak : void 0;
	if (!tabNodeType && !lineBreakNodeType) return schema.text(normalized, marks);
	const tabMarks = marks ?? void 0;
	const splitPattern = [tabNodeType ? "\\t" : null, lineBreakNodeType ? "\\n" : null].filter(Boolean).join("|");
	const parts = normalized.split(/* @__PURE__ */ new RegExp(`(${splitPattern})`));
	const nodes = [];
	for (const part of parts) {
		if (part === "") continue;
		if (part === "	" && tabNodeType) nodes.push(tabNodeType.create(null, null, tabMarks));
		else if (part === "\n" && lineBreakNodeType) nodes.push(lineBreakNodeType.create());
		else nodes.push(schema.text(part, marks));
	}
	return Fragment.from(nodes);
}
function parentAllowsNodeAt(tr, absPos, nodeType) {
	const contentMatch = tr.doc.resolve(absPos)?.parent?.type?.contentMatch;
	if (!contentMatch || typeof contentMatch.matchType !== "function") return true;
	return contentMatch.matchType(nodeType) != null;
}
function textBetweenWithTabs(doc$2, from, to, blockSeparator, leafFallback, options = {}) {
	const anyDoc = doc$2;
	if (typeof anyDoc.nodesBetween !== "function") {
		if (typeof anyDoc.textBetween === "function") return anyDoc.textBetween(from, to, blockSeparator, leafFallback);
		return "";
	}
	let out = "";
	let emitted = false;
	const seenBlocks = /* @__PURE__ */ new Set();
	doc$2.nodesBetween(from, to, (node, pos) => {
		if (pos >= to) return false;
		if (!node) return false;
		if (node.type?.name === "tab") {
			out += "	";
			emitted = true;
			return false;
		}
		if (node.isText) {
			if (options.textModel === "visible" && node.marks?.some((mark) => mark.type.name === "trackDelete")) return false;
			const start = Math.max(from, pos) - pos;
			const end = Math.min(to, pos + node.nodeSize) - pos;
			const text$2 = typeof node.text === "string" ? node.text : "￼".repeat(node.nodeSize);
			out += text$2.slice(start, end);
			emitted = true;
			return false;
		}
		if (node.isLeaf) {
			if (node.isInline) {
				if (options.textModel === "visible" && node.marks?.some((mark) => mark.type.name === "trackDelete")) return false;
				const leafTextFn = node.type?.spec?.leafText;
				if (typeof leafTextFn === "function") out += leafTextFn(node);
				else out += leafFallback;
				emitted = true;
			}
			return false;
		}
		if (node.isBlock && emitted && !seenBlocks.has(pos) && pos > from) {
			out += blockSeparator;
			seenBlocks.add(pos);
		}
		return true;
	});
	return out;
}
var OBJECT_REPLACEMENT_CHAR = "￼";
function readTextAtResolvedRange(editor, range) {
	return textBetweenWithTabs(editor.state.doc, range.from, range.to, "\n", OBJECT_REPLACEMENT_CHAR);
}
function buildTextMutationResolution(input) {
	return {
		...input.requestedTarget ? { requestedTarget: input.requestedTarget } : {},
		target: input.target,
		range: {
			from: input.range.from,
			to: input.range.to
		},
		text: input.text
	};
}
function findTextBlockCandidates(index, blockId) {
	const primary = index.candidates.filter((c$1) => c$1.nodeId === blockId && isTextBlockCandidate(c$1));
	if (primary.length > 0) return primary;
	try {
		const resolved = findBlockByNodeIdOnly(index, blockId);
		if (isTextBlockCandidate(resolved)) return [resolved];
	} catch (e) {
		if (e instanceof DocumentApiAdapterError && e.code === "AMBIGUOUS_TARGET") throw e;
	}
	return [];
}
function assertUnambiguous(matches$1, blockId) {
	if (matches$1.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", `Block ID "${blockId}" is ambiguous: matched ${matches$1.length} text blocks.`, {
		blockId,
		matchCount: matches$1.length
	});
}
function resolveTextTarget(editor, target) {
	const matches$1 = findTextBlockCandidates(getBlockIndex(editor), target.blockId);
	assertUnambiguous(matches$1, target.blockId);
	const block = matches$1[0];
	if (!block) return null;
	return resolveTextRangeInBlock(block.node, block.pos, target.range, { textModel: "visible" });
}
function resolveInlineInsertPosition(editor, at, operationName) {
	const firstSegment = at.segments[0];
	const resolved = resolveTextTarget(editor, {
		kind: "text",
		blockId: firstSegment.blockId,
		range: firstSegment.range
	});
	if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: target block not found.`, { target: at });
	return resolved;
}
function resolveBlockCreatePosition(editor, at) {
	if (at.kind === "documentStart") return 0;
	if (at.kind === "documentEnd") return editor.state.doc.content.size;
	const candidate = findBlockById(getBlockIndex(editor), at.target);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block "${at.target.nodeId}" not found.`, { target: at.target });
	return at.kind === "before" ? candidate.pos : candidate.end;
}
function collectTopLevelPositions(doc$2) {
	const positions = /* @__PURE__ */ new Set();
	let offset = 0;
	for (let i$1 = 0; i$1 < doc$2.childCount; i$1++) {
		positions.add(offset);
		offset += doc$2.child(i$1).nodeSize;
	}
	return positions;
}
function resolveDefaultInsertTarget(editor) {
	const index = getBlockIndex(editor);
	const doc$2 = editor.state.doc;
	const topLevelPositions = collectTopLevelPositions(doc$2);
	for (let i$1 = index.candidates.length - 1; i$1 >= 0; i$1--) {
		const candidate = index.candidates[i$1];
		if (topLevelPositions.has(candidate.pos) && isTextBlockCandidate(candidate)) {
			const textLength = computeTextContentLength(candidate.node, { textModel: "visible" });
			const range = resolveTextRangeInBlock(candidate.node, candidate.pos, {
				start: textLength,
				end: textLength
			}, { textModel: "visible" });
			if (!range) continue;
			return {
				kind: "text-block",
				target: {
					kind: "text",
					blockId: candidate.nodeId,
					range: {
						start: textLength,
						end: textLength
					}
				},
				range
			};
		}
	}
	if (doc$2.content.size > 0) return {
		kind: "structural-end",
		insertPos: doc$2.content.size
	};
	return null;
}
function insertParagraphAtEnd(editor, pos, text$2, applyMeta) {
	const schema = editor.state.schema;
	const content$2 = buildTextWithTabs(schema, text$2, void 0);
	const paragraph = schema.nodes.paragraph.create(null, content$2);
	const tr = editor.state.tr;
	tr.insert(pos, paragraph);
	if (applyMeta) applyMeta(tr);
	editor.dispatch(tr);
}
function resolveWriteTarget(editor, request) {
	const fallback = resolveDefaultInsertTarget(editor);
	if (!fallback) return null;
	if (fallback.kind === "structural-end") {
		const pos = fallback.insertPos;
		const syntheticRange = {
			from: pos,
			to: pos
		};
		const syntheticTarget = {
			kind: "text",
			blockId: "",
			range: {
				start: 0,
				end: 0
			}
		};
		return {
			requestedTarget: void 0,
			effectiveTarget: syntheticTarget,
			range: syntheticRange,
			resolution: buildTextMutationResolution({
				requestedTarget: void 0,
				target: syntheticTarget,
				range: syntheticRange,
				text: ""
			}),
			structuralEnd: true
		};
	}
	const text$2 = readTextAtResolvedRange(editor, fallback.range);
	return {
		requestedTarget: void 0,
		effectiveTarget: fallback.target,
		range: fallback.range,
		resolution: buildTextMutationResolution({
			requestedTarget: void 0,
			target: fallback.target,
			range: fallback.range,
			text: text$2
		})
	};
}
function addDiagnostic(diagnostics, message) {
	diagnostics.push({ message });
}
function validatePaginationInput(offset, limit) {
	if (offset != null && offset < 0) throw new DocumentApiValidationError("INVALID_INPUT", `offset must be >= 0, got ${offset}`, { offset });
	if (limit != null && limit <= 0) throw new DocumentApiValidationError("INVALID_INPUT", `limit must be > 0, got ${limit}`, { limit });
}
function paginate(items, offset = 0, limit) {
	validatePaginationInput(offset, limit);
	const total = items.length;
	const effectiveLimit = limit ?? total;
	return {
		total,
		items: items.slice(offset, offset + effectiveLimit)
	};
}
function dedupeDiagnostics(diagnostics) {
	const seen = /* @__PURE__ */ new Set();
	const unique = [];
	for (const diagnostic of diagnostics) {
		const key = `${diagnostic.message}|${diagnostic.hint ?? ""}|${diagnostic.address ? JSON.stringify(diagnostic.address) : ""}`;
		if (seen.has(key)) continue;
		seen.add(key);
		unique.push(diagnostic);
	}
	return unique;
}
function resolveWithinScope(index, query, diagnostics) {
	if (!query.within) return {
		ok: true,
		range: void 0
	};
	let within = findBlockById(index, query.within);
	if (!within && query.within.kind === "block") try {
		within = findBlockByNodeIdOnly(index, query.within.nodeId);
	} catch {}
	if (!within) {
		addDiagnostic(diagnostics, `Within block "${query.within.nodeType}" with id "${query.within.nodeId}" was not found in the document.`);
		return { ok: false };
	}
	return {
		ok: true,
		range: {
			start: within.pos,
			end: within.end
		}
	};
}
function scopeByRange(candidates, range) {
	if (!range) return candidates;
	return candidates.filter((candidate) => candidate.pos >= range.start && candidate.end <= range.end);
}
function findCandidateByPos(candidates, pos) {
	let low = 0;
	let high = candidates.length - 1;
	while (low <= high) {
		const mid = low + high >> 1;
		const candidate = candidates[mid];
		if (pos < candidate.pos) {
			high = mid - 1;
			continue;
		}
		if (pos >= candidate.end) {
			low = mid + 1;
			continue;
		}
		return candidate;
	}
}
var LINE_NUMBER_RESTART_VALUES = [
	"continuous",
	"newPage",
	"newSection"
];
var PAGE_NUMBER_FORMAT_VALUES = [
	"decimal",
	"lowerLetter",
	"upperLetter",
	"lowerRoman",
	"upperRoman",
	"numberInDash"
];
var PAGE_NUMBER_CHAPTER_SEPARATOR_VALUES = [
	"hyphen",
	"period",
	"colon",
	"emDash",
	"enDash"
];
var SECTION_ORIENTATION_VALUES = ["portrait", "landscape"];
var SECTION_VERTICAL_ALIGN_VALUES = [
	"top",
	"center",
	"bottom",
	"both"
];
function toNumber(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : void 0;
}
function toPositiveInteger(value) {
	const parsed = toNumber(value);
	if (parsed == null || !Number.isInteger(parsed) || parsed <= 0) return void 0;
	return parsed;
}
function toNonNegativeNumber(value) {
	const parsed = toNumber(value);
	if (parsed == null || parsed < 0) return void 0;
	return parsed;
}
function toInchesFromTwips(value) {
	const twips = toNumber(value);
	if (twips == null) return void 0;
	return twipsToInches(twips);
}
function toTwipsString(valueInches) {
	return String(inchesToTwips(valueInches));
}
function asString(value) {
	return typeof value === "string" ? value : void 0;
}
function setStringAttr(element, key, value) {
	if (!element.attributes) element.attributes = {};
	if (value === void 0 || value === null) {
		delete element.attributes[key];
		return;
	}
	element.attributes[key] = String(value);
}
function setBooleanAttr(element, key, value) {
	if (value === void 0) return;
	setStringAttr(element, key, value ? "1" : "0");
}
function toBooleanAttr(value) {
	if (value === void 0) return void 0;
	const normalized = String(value).toLowerCase();
	if (normalized === "1" || normalized === "true" || normalized === "on") return true;
	if (normalized === "0" || normalized === "false" || normalized === "off") return false;
}
function isKnownValue(value, allowed) {
	return typeof value === "string" && allowed.includes(value);
}
function ensureElements(element) {
	if (!Array.isArray(element.elements)) element.elements = [];
	return element.elements;
}
function cloneXmlElement(value) {
	return JSON.parse(JSON.stringify(value));
}
function isSectPrElement(value) {
	return Boolean(value && typeof value === "object" && value.name === "w:sectPr");
}
function createSectPrElement() {
	return {
		type: "element",
		name: "w:sectPr",
		elements: []
	};
}
function ensureSectPrElement(current) {
	if (isSectPrElement(current)) return cloneXmlElement(current);
	return createSectPrElement();
}
function findChild(element, childName) {
	return element.elements?.find((entry) => entry?.name === childName);
}
function ensureChild(element, childName) {
	const existing = findChild(element, childName);
	if (existing) return existing;
	const created = {
		type: "element",
		name: childName,
		attributes: {},
		elements: []
	};
	ensureElements(element).push(created);
	return created;
}
function removeChildren(element, predicate) {
	if (!Array.isArray(element.elements) || element.elements.length === 0) return {
		removed: false,
		element
	};
	const kept = element.elements.filter((entry) => !predicate(entry));
	const removed = kept.length !== element.elements.length;
	element.elements = kept;
	return {
		removed,
		element
	};
}
function sectionRefElementName(kind) {
	return kind === "header" ? "w:headerReference" : "w:footerReference";
}
function toRefVariant(value) {
	return isKnownValue(value, [
		"default",
		"first",
		"even"
	]) ? value : void 0;
}
function toPageBorderDisplay(value) {
	return isKnownValue(value, [
		"allPages",
		"firstPage",
		"notFirstPage"
	]) ? value : void 0;
}
function toPageBorderOffsetFrom(value) {
	return isKnownValue(value, ["page", "text"]) ? value : void 0;
}
function toPageBorderZOrder(value) {
	return isKnownValue(value, ["front", "back"]) ? value : void 0;
}
function writeSectPrBreakType(sectPr, breakType) {
	setStringAttr(ensureChild(sectPr, "w:type"), "w:val", breakType);
}
function readSectPrMargins(sectPr) {
	const pgMar = findChild(sectPr, "w:pgMar");
	if (!pgMar) return {};
	return {
		top: toInchesFromTwips(pgMar.attributes?.["w:top"]),
		right: toInchesFromTwips(pgMar.attributes?.["w:right"]),
		bottom: toInchesFromTwips(pgMar.attributes?.["w:bottom"]),
		left: toInchesFromTwips(pgMar.attributes?.["w:left"]),
		gutter: toInchesFromTwips(pgMar.attributes?.["w:gutter"]),
		header: toInchesFromTwips(pgMar.attributes?.["w:header"]),
		footer: toInchesFromTwips(pgMar.attributes?.["w:footer"])
	};
}
function writeSectPrPageMargins(sectPr, margins) {
	const pgMar = ensureChild(sectPr, "w:pgMar");
	if (margins.top !== void 0) setStringAttr(pgMar, "w:top", toTwipsString(margins.top));
	if (margins.right !== void 0) setStringAttr(pgMar, "w:right", toTwipsString(margins.right));
	if (margins.bottom !== void 0) setStringAttr(pgMar, "w:bottom", toTwipsString(margins.bottom));
	if (margins.left !== void 0) setStringAttr(pgMar, "w:left", toTwipsString(margins.left));
	if (margins.gutter !== void 0) setStringAttr(pgMar, "w:gutter", toTwipsString(margins.gutter));
}
function writeSectPrHeaderFooterMargins(sectPr, margins) {
	const pgMar = ensureChild(sectPr, "w:pgMar");
	if (margins.header !== void 0) setStringAttr(pgMar, "w:header", toTwipsString(margins.header));
	if (margins.footer !== void 0) setStringAttr(pgMar, "w:footer", toTwipsString(margins.footer));
}
function readSectPrPageSetup(sectPr) {
	const pgSz = findChild(sectPr, "w:pgSz");
	if (!pgSz) return void 0;
	const width = toInchesFromTwips(pgSz.attributes?.["w:w"]);
	const height = toInchesFromTwips(pgSz.attributes?.["w:h"]);
	const orientationRaw = asString(pgSz.attributes?.["w:orient"]);
	const orientation = isKnownValue(orientationRaw, SECTION_ORIENTATION_VALUES) ? orientationRaw : void 0;
	const paperSize = asString(pgSz.attributes?.["w:code"]);
	if (width == null && height == null && orientation == null && paperSize == null) return void 0;
	return {
		width,
		height,
		orientation,
		paperSize
	};
}
function writeSectPrPageSetup(sectPr, setup) {
	const pgSz = ensureChild(sectPr, "w:pgSz");
	if (setup.width !== void 0) setStringAttr(pgSz, "w:w", toTwipsString(setup.width));
	if (setup.height !== void 0) setStringAttr(pgSz, "w:h", toTwipsString(setup.height));
	if (setup.orientation !== void 0) setStringAttr(pgSz, "w:orient", setup.orientation);
	if (setup.paperSize !== void 0) setStringAttr(pgSz, "w:code", setup.paperSize);
	if (setup.orientation !== void 0) {
		const widthTwips = toNumber(pgSz.attributes?.["w:w"]);
		const heightTwips = toNumber(pgSz.attributes?.["w:h"]);
		if (widthTwips == null || heightTwips == null) return;
		if (widthTwips > heightTwips === (setup.orientation === "landscape")) return;
		setStringAttr(pgSz, "w:w", String(heightTwips));
		setStringAttr(pgSz, "w:h", String(widthTwips));
	}
}
function readSectPrColumns(sectPr) {
	const cols = findChild(sectPr, "w:cols");
	if (!cols) return void 0;
	const count = toPositiveInteger(cols.attributes?.["w:num"]);
	const gap = toInchesFromTwips(cols.attributes?.["w:space"]);
	const equalWidth = toBooleanAttr(cols.attributes?.["w:equalWidth"]);
	if (count == null && gap == null && equalWidth == null) return void 0;
	return {
		count,
		gap,
		equalWidth
	};
}
function writeSectPrColumns(sectPr, columns) {
	const cols = ensureChild(sectPr, "w:cols");
	if (columns.count !== void 0) setStringAttr(cols, "w:num", columns.count);
	if (columns.gap !== void 0) setStringAttr(cols, "w:space", toTwipsString(columns.gap));
	if (columns.equalWidth !== void 0) setBooleanAttr(cols, "w:equalWidth", columns.equalWidth);
}
function readSectPrLineNumbering(sectPr) {
	const lnNumType = findChild(sectPr, "w:lnNumType");
	if (!lnNumType) return void 0;
	const restartRaw = asString(lnNumType.attributes?.["w:restart"]);
	const restart = isKnownValue(restartRaw, LINE_NUMBER_RESTART_VALUES) ? restartRaw : void 0;
	return {
		enabled: true,
		countBy: toPositiveInteger(lnNumType.attributes?.["w:countBy"]),
		start: toPositiveInteger(lnNumType.attributes?.["w:start"]),
		distance: toInchesFromTwips(lnNumType.attributes?.["w:distance"]),
		restart
	};
}
function writeSectPrLineNumbering(sectPr, numbering) {
	if (!numbering.enabled) {
		removeChildren(sectPr, (entry) => entry.name === "w:lnNumType");
		return;
	}
	const lnNumType = ensureChild(sectPr, "w:lnNumType");
	if (numbering.countBy !== void 0) setStringAttr(lnNumType, "w:countBy", numbering.countBy);
	if (numbering.start !== void 0) setStringAttr(lnNumType, "w:start", numbering.start);
	if (numbering.distance !== void 0) setStringAttr(lnNumType, "w:distance", toTwipsString(numbering.distance));
	if (numbering.restart !== void 0) setStringAttr(lnNumType, "w:restart", numbering.restart);
}
function readSectPrPageNumbering(sectPr) {
	const pgNumType = findChild(sectPr, "w:pgNumType");
	if (!pgNumType) return void 0;
	const formatRaw = asString(pgNumType.attributes?.["w:fmt"]);
	const format = isKnownValue(formatRaw, PAGE_NUMBER_FORMAT_VALUES) ? formatRaw : void 0;
	const start = toPositiveInteger(pgNumType.attributes?.["w:start"]);
	const chapterStyle = toPositiveInteger(pgNumType.attributes?.["w:chapStyle"]);
	const chapterSeparatorRaw = asString(pgNumType.attributes?.["w:chapSep"]);
	const chapterSeparator = isKnownValue(chapterSeparatorRaw, PAGE_NUMBER_CHAPTER_SEPARATOR_VALUES) ? chapterSeparatorRaw : void 0;
	if (format == null && start == null && chapterStyle == null && chapterSeparator == null) return void 0;
	return {
		format,
		start,
		chapterStyle,
		chapterSeparator
	};
}
function writeSectPrPageNumbering(sectPr, numbering) {
	if (numbering.start === void 0 && numbering.format === void 0 && numbering.chapterStyle === void 0 && numbering.chapterSeparator === void 0) return;
	const pgNumType = ensureChild(sectPr, "w:pgNumType");
	if (numbering.start !== void 0) setStringAttr(pgNumType, "w:start", numbering.start);
	if (numbering.format !== void 0) setStringAttr(pgNumType, "w:fmt", numbering.format);
	if (numbering.chapterStyle !== void 0) setStringAttr(pgNumType, "w:chapStyle", numbering.chapterStyle);
	if (numbering.chapterSeparator !== void 0) setStringAttr(pgNumType, "w:chapSep", numbering.chapterSeparator);
}
function readSectPrTitlePage(sectPr) {
	return Boolean(findChild(sectPr, "w:titlePg"));
}
function writeSectPrTitlePage(sectPr, enabled) {
	if (enabled) {
		ensureChild(sectPr, "w:titlePg");
		return;
	}
	removeChildren(sectPr, (entry) => entry.name === "w:titlePg");
}
function readSectPrVerticalAlign(sectPr) {
	const raw = asString(findChild(sectPr, "w:vAlign")?.attributes?.["w:val"]);
	return isKnownValue(raw, SECTION_VERTICAL_ALIGN_VALUES) ? raw : void 0;
}
function writeSectPrVerticalAlign(sectPr, value) {
	setStringAttr(ensureChild(sectPr, "w:vAlign"), "w:val", value);
}
function readSectPrDirection(sectPr) {
	const bidi = findChild(sectPr, "w:bidi");
	if (!bidi) return void 0;
	return toBooleanAttr(bidi.attributes?.["w:val"]) === false ? "ltr" : "rtl";
}
function writeSectPrDirection(sectPr, direction) {
	if (direction === "ltr") {
		removeChildren(sectPr, (entry) => entry.name === "w:bidi");
		return;
	}
	setStringAttr(ensureChild(sectPr, "w:bidi"), "w:val", "1");
}
function readSectPrRefByVariant(sectPr, kind, variant) {
	const elementName = sectionRefElementName(kind);
	const refNode = sectPr.elements?.find((entry) => entry.name === elementName && toRefVariant(entry.attributes?.["w:type"]) === variant);
	return asString(refNode?.attributes?.["r:id"]);
}
function readSectPrRefsByKind(sectPr, kind) {
	const refs = {
		default: readSectPrRefByVariant(sectPr, kind, "default"),
		first: readSectPrRefByVariant(sectPr, kind, "first"),
		even: readSectPrRefByVariant(sectPr, kind, "even")
	};
	if (refs.default == null && refs.first == null && refs.even == null) return void 0;
	return refs;
}
const readSectPrHeaderFooterRefs = readSectPrRefsByKind;
function setSectPrHeaderFooterRef(sectPr, kind, variant, refId) {
	const elementName = sectionRefElementName(kind);
	removeChildren(sectPr, (entry) => entry.name === elementName && toRefVariant(entry.attributes?.["w:type"]) === variant);
	ensureElements(sectPr).push({
		type: "element",
		name: elementName,
		attributes: {
			"w:type": variant,
			"r:id": refId
		},
		elements: []
	});
}
function clearSectPrHeaderFooterRef(sectPr, kind, variant) {
	const elementName = sectionRefElementName(kind);
	const { removed } = removeChildren(sectPr, (entry) => entry.name === elementName && toRefVariant(entry.attributes?.["w:type"]) === variant);
	return removed;
}
function getSectPrHeaderFooterRef(sectPr, kind, variant) {
	return readSectPrRefByVariant(sectPr, kind, variant);
}
function readBorderSpec(element) {
	if (!element?.attributes) return void 0;
	const attributes = element.attributes;
	const style = asString(attributes["w:val"]);
	const size = toNonNegativeNumber(attributes["w:sz"]);
	const space = toNonNegativeNumber(attributes["w:space"]);
	const color = asString(attributes["w:color"]);
	const shadow = toBooleanAttr(attributes["w:shadow"]);
	const frame = toBooleanAttr(attributes["w:frame"]);
	if (style == null && size == null && space == null && color == null && shadow == null && frame == null) return void 0;
	return {
		style,
		size,
		space,
		color,
		shadow,
		frame
	};
}
function writeBorderSpec(parent, edge, border) {
	if (border.style === void 0 && border.size === void 0 && border.space === void 0 && border.color === void 0 && border.shadow === void 0 && border.frame === void 0) return;
	const edgeElement = ensureChild(parent, `w:${edge}`);
	if (border.style !== void 0) setStringAttr(edgeElement, "w:val", border.style);
	if (border.size !== void 0) setStringAttr(edgeElement, "w:sz", border.size);
	if (border.space !== void 0) setStringAttr(edgeElement, "w:space", border.space);
	if (border.color !== void 0) setStringAttr(edgeElement, "w:color", border.color);
	if (border.shadow !== void 0) setBooleanAttr(edgeElement, "w:shadow", border.shadow);
	if (border.frame !== void 0) setBooleanAttr(edgeElement, "w:frame", border.frame);
}
function readSectPrPageBorders(sectPr) {
	const pgBorders = findChild(sectPr, "w:pgBorders");
	if (!pgBorders) return void 0;
	const top = readBorderSpec(findChild(pgBorders, "w:top"));
	const right = readBorderSpec(findChild(pgBorders, "w:right"));
	const bottom = readBorderSpec(findChild(pgBorders, "w:bottom"));
	const left = readBorderSpec(findChild(pgBorders, "w:left"));
	const display = toPageBorderDisplay(pgBorders.attributes?.["w:display"]);
	const offsetFrom = toPageBorderOffsetFrom(pgBorders.attributes?.["w:offsetFrom"]);
	const zOrder = toPageBorderZOrder(pgBorders.attributes?.["w:zOrder"]);
	if (display == null && offsetFrom == null && zOrder == null && !top && !right && !bottom && !left) return void 0;
	return {
		display,
		offsetFrom,
		zOrder,
		top,
		right,
		bottom,
		left
	};
}
function writeSectPrPageBorders(sectPr, borders) {
	const hasRootAttributes = borders.display !== void 0 || borders.offsetFrom !== void 0 || borders.zOrder !== void 0;
	const hasTop = Boolean(borders.top && (borders.top.style !== void 0 || borders.top.size !== void 0 || borders.top.space !== void 0 || borders.top.color !== void 0 || borders.top.shadow !== void 0 || borders.top.frame !== void 0));
	const hasRight = Boolean(borders.right && (borders.right.style !== void 0 || borders.right.size !== void 0 || borders.right.space !== void 0 || borders.right.color !== void 0 || borders.right.shadow !== void 0 || borders.right.frame !== void 0));
	const hasBottom = Boolean(borders.bottom && (borders.bottom.style !== void 0 || borders.bottom.size !== void 0 || borders.bottom.space !== void 0 || borders.bottom.color !== void 0 || borders.bottom.shadow !== void 0 || borders.bottom.frame !== void 0));
	const hasLeft = Boolean(borders.left && (borders.left.style !== void 0 || borders.left.size !== void 0 || borders.left.space !== void 0 || borders.left.color !== void 0 || borders.left.shadow !== void 0 || borders.left.frame !== void 0));
	if (!hasRootAttributes && !hasTop && !hasRight && !hasBottom && !hasLeft) return;
	const pgBorders = ensureChild(sectPr, "w:pgBorders");
	if (borders.display !== void 0) setStringAttr(pgBorders, "w:display", borders.display);
	if (borders.offsetFrom !== void 0) setStringAttr(pgBorders, "w:offsetFrom", borders.offsetFrom);
	if (borders.zOrder !== void 0) setStringAttr(pgBorders, "w:zOrder", borders.zOrder);
	if (hasTop && borders.top) writeBorderSpec(pgBorders, "top", borders.top);
	if (hasRight && borders.right) writeBorderSpec(pgBorders, "right", borders.right);
	if (hasBottom && borders.bottom) writeBorderSpec(pgBorders, "bottom", borders.bottom);
	if (hasLeft && borders.left) writeBorderSpec(pgBorders, "left", borders.left);
}
function clearSectPrPageBorders(sectPr) {
	const { removed } = removeChildren(sectPr, (entry) => entry.name === "w:pgBorders");
	return removed;
}
var PIXELS_PER_INCH = 96;
var SECTION_PAGE_NUMBER_FORMATS = [
	"decimal",
	"lowerLetter",
	"upperLetter",
	"lowerRoman",
	"upperRoman",
	"numberInDash"
];
function pxToInches(value) {
	if (typeof value !== "number" || !Number.isFinite(value)) return void 0;
	return value / PIXELS_PER_INCH;
}
function toSectionPageNumbering(numbering) {
	if (!numbering) return void 0;
	const format = SECTION_PAGE_NUMBER_FORMATS.includes(numbering.format) ? numbering.format : void 0;
	const result = {
		start: numbering.start,
		format,
		chapterStyle: numbering.chapterStyle,
		chapterSeparator: numbering.chapterSeparator
	};
	if (result.start === void 0 && result.format === void 0 && result.chapterStyle === void 0 && result.chapterSeparator === void 0) return;
	return result;
}
function buildSectionId(index) {
	return `section-${index}`;
}
function getConverter$7(editor) {
	return editor.converter;
}
function getBodySectPrFromEditor(editor) {
	const converter = getConverter$7(editor);
	if (isSectPrElement(converter?.bodySectPr)) return cloneXmlElement(converter.bodySectPr);
	const docAttrs = editor.state.doc.attrs ?? {};
	if (isSectPrElement(docAttrs.bodySectPr)) return cloneXmlElement(docAttrs.bodySectPr);
	return null;
}
function resolveParagraphNodeId(node) {
	const attrs = node.attrs ?? {};
	return toId(attrs.paraId) ?? toId(attrs.sdBlockId) ?? toId(attrs.blockId) ?? toId(attrs.id);
}
function collectParagraphSnapshots(editor) {
	const snapshots = [];
	let paragraphIndex = 0;
	editor.state.doc.descendants((node, pos) => {
		if (node.type.name !== "paragraph") return;
		const nodeId = resolveParagraphNodeId(node);
		if (!nodeId) {
			paragraphIndex += 1;
			return;
		}
		snapshots.push({
			index: paragraphIndex,
			pos,
			node,
			nodeId
		});
		paragraphIndex += 1;
	});
	return snapshots;
}
function buildAnalysisDocFromParagraphs(paragraphs) {
	return {
		type: "doc",
		content: paragraphs.map((paragraph) => ({
			type: "paragraph",
			attrs: paragraph.node.attrs ?? {}
		}))
	};
}
function resolveAnalysisDoc(editor, paragraphs) {
	const maybeJsonDoc = editor.state.doc.toJSON?.();
	if (maybeJsonDoc && typeof maybeJsonDoc === "object" && typeof maybeJsonDoc.type === "string" && Array.isArray(maybeJsonDoc.content)) return maybeJsonDoc;
	return buildAnalysisDocFromParagraphs(paragraphs);
}
function getSettingsRoot(editor) {
	const settingsPart = getConverter$7(editor)?.convertedXml?.["word/settings.xml"];
	if (!settingsPart) return null;
	if (settingsPart.name === "w:settings") return settingsPart;
	if (!Array.isArray(settingsPart.elements)) return null;
	return settingsPart.elements.find((entry) => entry.name === "w:settings") ?? null;
}
function readOddEvenHeadersFlag(editor) {
	const converter = getConverter$7(editor);
	if (converter?.pageStyles?.alternateHeaders != null) return converter.pageStyles.alternateHeaders === true;
	const settingsRoot = getSettingsRoot(editor);
	if (!settingsRoot?.elements) return false;
	return settingsRoot.elements.some((entry) => entry.name === "w:evenAndOddHeaders");
}
function createSyntheticRange(bodySectPr, paragraphCount) {
	const lastIndex = Math.max(paragraphCount - 1, 0);
	return {
		sectionIndex: 0,
		startNodeIndex: 0,
		endNodeIndex: lastIndex,
		startParagraphIndex: 0,
		endParagraphIndex: lastIndex,
		sectPr: bodySectPr ?? null,
		margins: null,
		pageSize: null,
		orientation: null,
		columns: null,
		type: SectionType.CONTINUOUS,
		typeIsExplicit: false,
		titlePg: false,
		headerRefs: void 0,
		footerRefs: void 0,
		numbering: void 0,
		vAlign: void 0
	};
}
function projectSectionTarget(range, rangeIndex, totalRanges, hasBodySectPr, paragraphs) {
	const paragraph = paragraphs.find((entry) => entry.index === range.endParagraphIndex);
	const isFinalRange = rangeIndex === totalRanges - 1;
	if (paragraph && (!isFinalRange || !hasBodySectPr) && range.sectPr) return {
		kind: "paragraph",
		paragraphIndex: paragraph.index,
		pos: paragraph.pos,
		node: paragraph.node,
		nodeId: paragraph.nodeId
	};
	return { kind: "body" };
}
function toPageMargins(range, sectPr) {
	const parsed = sectPr ? readSectPrMargins(sectPr) : {};
	const margins = {
		top: pxToInches(range.margins?.top) ?? parsed.top,
		right: pxToInches(range.margins?.right) ?? parsed.right,
		bottom: pxToInches(range.margins?.bottom) ?? parsed.bottom,
		left: pxToInches(range.margins?.left) ?? parsed.left,
		gutter: parsed.gutter
	};
	if (margins.top == null && margins.right == null && margins.bottom == null && margins.left == null && margins.gutter == null) return;
	return margins;
}
function sectionRangeToSectionDomain(range, address, oddEvenHeadersFooters) {
	const sectPr = isSectPrElement(range.sectPr) ? range.sectPr : null;
	const parsedSetup = sectPr ? readSectPrPageSetup(sectPr) : void 0;
	const parsedColumns = sectPr ? readSectPrColumns(sectPr) : void 0;
	const parsedLineNumbering = sectPr ? readSectPrLineNumbering(sectPr) : void 0;
	const parsedPageNumbering = sectPr ? readSectPrPageNumbering(sectPr) : void 0;
	const parsedDirection = sectPr ? readSectPrDirection(sectPr) : void 0;
	const parsedVerticalAlign = sectPr ? readSectPrVerticalAlign(sectPr) : void 0;
	const parsedBorders = sectPr ? readSectPrPageBorders(sectPr) : void 0;
	const parsedMargins = sectPr ? readSectPrMargins(sectPr) : {};
	const pageSetup = {
		width: pxToInches(range.pageSize?.w) ?? parsedSetup?.width,
		height: pxToInches(range.pageSize?.h) ?? parsedSetup?.height,
		orientation: range.orientation ?? parsedSetup?.orientation,
		paperSize: parsedSetup?.paperSize
	};
	const margins = toPageMargins(range, sectPr);
	const headerFooterMargins = {
		header: pxToInches(range.margins?.header) ?? parsedMargins.header,
		footer: pxToInches(range.margins?.footer) ?? parsedMargins.footer
	};
	const columns = {
		count: range.columns?.count ?? parsedColumns?.count,
		gap: pxToInches(range.columns?.gap) ?? parsedColumns?.gap,
		equalWidth: parsedColumns?.equalWidth
	};
	const toRefs = (refs) => {
		if (!refs) return void 0;
		const mapped = {
			default: refs.default ?? refs.odd,
			first: refs.first,
			even: refs.even
		};
		if (mapped.default == null && mapped.first == null && mapped.even == null) return void 0;
		return mapped;
	};
	const hasPageSetup = pageSetup.width != null || pageSetup.height != null || pageSetup.orientation != null || pageSetup.paperSize != null;
	const hasHeaderFooterMargins = headerFooterMargins.header != null || headerFooterMargins.footer != null;
	const hasColumns = columns.count != null || columns.gap != null || columns.equalWidth != null;
	return {
		address,
		index: range.sectionIndex,
		range: {
			startParagraphIndex: range.startParagraphIndex,
			endParagraphIndex: range.endParagraphIndex
		},
		breakType: range.type,
		pageSetup: hasPageSetup ? pageSetup : void 0,
		margins,
		headerFooterMargins: hasHeaderFooterMargins ? headerFooterMargins : void 0,
		columns: hasColumns ? columns : void 0,
		lineNumbering: parsedLineNumbering,
		pageNumbering: toSectionPageNumbering(range.numbering) ?? parsedPageNumbering,
		titlePage: range.titlePg,
		oddEvenHeadersFooters,
		verticalAlign: range.vAlign ?? parsedVerticalAlign,
		sectionDirection: parsedDirection,
		headerRefs: toRefs(range.headerRefs),
		footerRefs: toRefs(range.footerRefs),
		pageBorders: parsedBorders
	};
}
function resolveSectionProjections(editor) {
	const paragraphs = collectParagraphSnapshots(editor);
	const bodySectPr = getBodySectPrFromEditor(editor);
	const oddEvenHeadersFooters = readOddEvenHeadersFlag(editor);
	const analyzed = analyzeSectionRanges(resolveAnalysisDoc(editor, paragraphs), bodySectPr ?? void 0);
	const ranges = analyzed.length > 0 ? analyzed : [createSyntheticRange(bodySectPr, paragraphs.length)];
	return ranges.map((range, index) => {
		const sectionId = buildSectionId(index);
		const address = {
			kind: "section",
			sectionId
		};
		return {
			sectionId,
			address,
			range,
			target: projectSectionTarget(range, index, ranges.length, bodySectPr != null, paragraphs),
			domain: sectionRangeToSectionDomain(range, address, oddEvenHeadersFooters)
		};
	});
}
function resolveSectionProjectionByAddress(editor, address) {
	const match = resolveSectionProjections(editor).find((projection) => projection.sectionId === address.sectionId);
	if (!match) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Section address was not found.", { target: address });
	return match;
}
function getDefaultSectionAddress(editor) {
	return resolveSectionProjections(editor)[0]?.address ?? {
		kind: "section",
		sectionId: buildSectionId(0)
	};
}
function sectionsListAdapter(editor, query) {
	validatePaginationInput(query?.offset, query?.limit);
	const projections = resolveSectionProjections(editor);
	const offset = query?.offset ?? 0;
	const { total, items: paged } = paginate(projections, offset, query?.limit);
	const evaluatedRevision = getRevision(editor);
	const items = paged.map((projection) => {
		const handle = buildResolvedHandle(projection.sectionId, "ephemeral", "section");
		return buildDiscoveryItem(projection.sectionId, handle, projection.domain);
	});
	return buildDiscoveryResult({
		evaluatedRevision,
		total,
		items,
		page: {
			limit: query?.limit ?? total,
			offset,
			returned: items.length
		}
	});
}
function sectionsGetAdapter(editor, address) {
	return resolveSectionProjectionByAddress(editor, address).domain;
}
function readParagraphSectPr(node) {
	const sectPr = (node.attrs ?? {}).paragraphProperties?.sectPr;
	return sectPr && typeof sectPr === "object" ? sectPr : null;
}
function readTargetSectPr(editor, projection) {
	if (projection.target.kind === "paragraph") return readParagraphSectPr(projection.target.node);
	return getBodySectPrFromEditor(editor);
}
function getConverter$6(editor) {
	return editor.converter;
}
function takeSnapshot(editor, partIds) {
	const converter = getConverter$6(editor);
	const partEntries = /* @__PURE__ */ new Map();
	if (converter?.convertedXml) for (const partId of partIds) {
		const id = partId;
		const existed = hasPart(editor, id);
		partEntries.set(partId, {
			existed,
			data: existed ? clonePart(getPart(editor, id)) : void 0
		});
	}
	return {
		partEntries,
		numbering: converter?.numbering ? clonePart(converter.numbering) : void 0,
		translatedNumbering: converter?.translatedNumbering ? clonePart(converter.translatedNumbering) : void 0,
		footnotes: converter?.footnotes ? clonePart(converter.footnotes) : void 0,
		endnotes: converter?.endnotes ? clonePart(converter.endnotes) : void 0,
		footnoteProperties: converter?.footnoteProperties ? clonePart(converter.footnoteProperties) : void 0,
		revision: getRevision(editor),
		documentModified: converter?.documentModified ?? false,
		documentGuid: converter?.documentGuid ?? null,
		headers: converter?.headers ? { ...converter.headers } : void 0,
		footers: converter?.footers ? { ...converter.footers } : void 0,
		headerIds: converter?.headerIds ? {
			...converter.headerIds,
			ids: [...converter.headerIds.ids ?? []]
		} : void 0,
		footerIds: converter?.footerIds ? {
			...converter.footerIds,
			ids: [...converter.footerIds.ids ?? []]
		} : void 0,
		headerFooterModified: converter?.headerFooterModified ?? false
	};
}
function restoreFromSnapshot(editor, snapshot) {
	const converter = getConverter$6(editor);
	if (!converter) return;
	if (converter.convertedXml) for (const [partId, entry] of snapshot.partEntries) {
		const id = partId;
		if (entry.existed) setPart(editor, id, entry.data);
		else removePart(editor, id);
	}
	if (snapshot.numbering !== void 0) converter.numbering = snapshot.numbering;
	if (snapshot.translatedNumbering !== void 0) converter.translatedNumbering = snapshot.translatedNumbering;
	if (snapshot.footnotes !== void 0) converter.footnotes = snapshot.footnotes;
	if (snapshot.endnotes !== void 0) converter.endnotes = snapshot.endnotes;
	if (snapshot.footnoteProperties !== void 0) converter.footnoteProperties = snapshot.footnoteProperties;
	converter.documentModified = snapshot.documentModified;
	converter.documentGuid = snapshot.documentGuid;
	restoreRevision(editor, snapshot.revision);
	if (snapshot.headers !== void 0) converter.headers = snapshot.headers;
	if (snapshot.footers !== void 0) converter.footers = snapshot.footers;
	if (snapshot.headerIds !== void 0) converter.headerIds = snapshot.headerIds;
	if (snapshot.footerIds !== void 0) converter.footerIds = snapshot.footerIds;
	converter.headerFooterModified = snapshot.headerFooterModified;
}
function getCompoundState(editor) {
	return editor;
}
function compoundMutation(request) {
	const { editor, execute, affectedParts = [] } = request;
	const state = getCompoundState(editor);
	state._compoundDepth = (state._compoundDepth ?? 0) + 1;
	const snapshot = takeSnapshot(editor, new Set(affectedParts));
	let success;
	try {
		success = execute();
	} catch (err$1) {
		state._compoundDepth = (state._compoundDepth ?? 1) - 1;
		restoreFromSnapshot(editor, snapshot);
		if (state._compoundDepth === 0) state._partPublisher?.drop();
		throw err$1;
	}
	state._compoundDepth = (state._compoundDepth ?? 1) - 1;
	if (!success) {
		restoreFromSnapshot(editor, snapshot);
		if (state._compoundDepth === 0) state._partPublisher?.drop();
	} else if (state._compoundDepth === 0) state._partPublisher?.flush();
	return { success };
}
const SETTINGS_PART_PATH = "word/settings.xml";
function findSettingsRoot(part) {
	if (part.name === "w:settings") return part;
	if (!Array.isArray(part.elements)) return null;
	return part.elements.find((entry) => entry.name === "w:settings") ?? null;
}
function ensureSettingsRootElements(settingsRoot) {
	if (!Array.isArray(settingsRoot.elements)) settingsRoot.elements = [];
	return settingsRoot.elements;
}
function readSettingsRoot(converter) {
	const part = converter.convertedXml?.[SETTINGS_PART_PATH];
	if (!part) return null;
	return findSettingsRoot(part);
}
function ensureSettingsRoot(part) {
	const settingsRoot = findSettingsRoot(part);
	if (settingsRoot) return settingsRoot;
	const fallbackRoot = {
		type: "element",
		name: "w:settings",
		elements: []
	};
	if (!Array.isArray(part.elements)) part.elements = [];
	part.elements.push(fallbackRoot);
	return fallbackRoot;
}
function readDefaultTableStyle(settingsRoot) {
	const el = settingsRoot.elements?.find((entry) => entry.name === "w:defaultTableStyle");
	if (!el) return null;
	const val = el.attributes?.["w:val"];
	return typeof val === "string" && val.length > 0 ? val : null;
}
function setDefaultTableStyle(settingsRoot, styleId) {
	const elements = ensureSettingsRootElements(settingsRoot);
	const idx = elements.findIndex((entry) => entry.name === "w:defaultTableStyle");
	const newEl = {
		type: "element",
		name: "w:defaultTableStyle",
		attributes: { "w:val": styleId },
		elements: []
	};
	if (idx !== -1) elements[idx] = newEl;
	else elements.push(newEl);
}
function removeDefaultTableStyle(settingsRoot) {
	settingsRoot.elements = ensureSettingsRootElements(settingsRoot).filter((entry) => entry.name !== "w:defaultTableStyle");
}
function readFootnoteNumberFormat(settingsRoot) {
	return readNoteNumberFormat(settingsRoot, "w:footnotePr");
}
function readEndnoteNumberFormat(settingsRoot) {
	return readNoteNumberFormat(settingsRoot, "w:endnotePr");
}
function readNoteNumberFormat(settingsRoot, containerName) {
	const container = settingsRoot.elements?.find((entry) => entry.name === containerName);
	if (!container || !Array.isArray(container.elements)) return null;
	const numFmt = container.elements.find((entry) => entry.name === "w:numFmt");
	if (!numFmt) return null;
	const val = numFmt.attributes?.["w:val"];
	return typeof val === "string" && val.length > 0 ? val : null;
}
function readFootnoteNumberStart(settingsRoot) {
	return readNoteNumberStart(settingsRoot, "w:footnotePr");
}
function readEndnoteNumberStart(settingsRoot) {
	return readNoteNumberStart(settingsRoot, "w:endnotePr");
}
function readNoteNumberStart(settingsRoot, containerName) {
	const container = settingsRoot.elements?.find((entry) => entry.name === containerName);
	if (!container || !Array.isArray(container.elements)) return null;
	const numStart = container.elements.find((entry) => entry.name === "w:numStart");
	if (!numStart) return null;
	const val = numStart.attributes?.["w:val"];
	if (typeof val !== "string" && typeof val !== "number") return null;
	const n = Number(val);
	return Number.isFinite(n) && n >= 1 ? Math.floor(n) : null;
}
function readFootnotePosition(settingsRoot) {
	return readNotePosition(settingsRoot, "w:footnotePr");
}
function readEndnotePosition(settingsRoot) {
	return readNotePosition(settingsRoot, "w:endnotePr");
}
function readNotePosition(settingsRoot, containerName) {
	const container = settingsRoot.elements?.find((entry) => entry.name === containerName);
	if (!container || !Array.isArray(container.elements)) return null;
	const el = container.elements.find((entry) => entry.name === "w:pos");
	if (!el) return null;
	const val = el.attributes?.["w:val"];
	if (val === "pageBottom" || val === "beneathText" || val === "sectEnd" || val === "docEnd") return val;
	return null;
}
function readFootnoteNumberRestart(settingsRoot) {
	return readNoteNumberRestart(settingsRoot, "w:footnotePr");
}
function readEndnoteNumberRestart(settingsRoot) {
	return readNoteNumberRestart(settingsRoot, "w:endnotePr");
}
function readNoteNumberRestart(settingsRoot, containerName) {
	const container = settingsRoot.elements?.find((entry) => entry.name === containerName);
	if (!container || !Array.isArray(container.elements)) return null;
	const el = container.elements.find((entry) => entry.name === "w:numRestart");
	if (!el) return null;
	const val = el.attributes?.["w:val"];
	if (val === "continuous" || val === "eachPage" || val === "eachSect") return val;
	return null;
}
function readSectionNoteConfigs(documentRoot, containerName) {
	const result = /* @__PURE__ */ new Map();
	if (!documentRoot) return result;
	const bodyEl = findBody(documentRoot);
	if (!bodyEl) return result;
	let sectionIndex = 0;
	for (const child of bodyEl.elements ?? []) if (child.name === "w:sectPr") {
		const config$43 = extractSectionNoteConfig(child, containerName);
		if (config$43) result.set(sectionIndex, config$43);
		sectionIndex += 1;
	} else if (child.name === "w:p") {
		const sectPr = findChildByName(findChildByName(child, "w:pPr"), "w:sectPr");
		if (sectPr) {
			const config$43 = extractSectionNoteConfig(sectPr, containerName);
			if (config$43) result.set(sectionIndex, config$43);
			sectionIndex += 1;
		}
	}
	return result;
}
function findBody(root) {
	if (root.name === "w:body") return root;
	if (!Array.isArray(root.elements)) return null;
	for (const child of root.elements) {
		if (child.name === "w:body") return child;
		const inner = child.elements?.find((g) => g.name === "w:body");
		if (inner) return inner;
	}
	return null;
}
function findChildByName(parent, name) {
	if (!parent) return null;
	return parent.elements?.find((entry) => entry.name === name) ?? null;
}
function extractSectionNoteConfig(sectPr, containerName) {
	const container = findChildByName(sectPr, containerName);
	if (!container) return null;
	const config$43 = {};
	const numFmt = findChildByName(container, "w:numFmt");
	if (numFmt) {
		const val = numFmt.attributes?.["w:val"];
		if (typeof val === "string" && val.length > 0) config$43.numFmt = val;
	}
	const numStart = findChildByName(container, "w:numStart");
	if (numStart) {
		const val = numStart.attributes?.["w:val"];
		const n = typeof val === "string" || typeof val === "number" ? Number(val) : NaN;
		if (Number.isFinite(n) && n >= 1) config$43.numStart = Math.floor(n);
	}
	const numRestart = findChildByName(container, "w:numRestart");
	if (numRestart) {
		const val = numRestart.attributes?.["w:val"];
		if (val === "continuous" || val === "eachPage" || val === "eachSect") config$43.numRestart = val;
	}
	return Object.keys(config$43).length > 0 ? config$43 : null;
}
function hasOddEvenHeadersFooters(settingsRoot) {
	return settingsRoot.elements?.some((entry) => entry.name === "w:evenAndOddHeaders") === true;
}
function setOddEvenHeadersFooters(settingsRoot, enabled) {
	const elements = ensureSettingsRootElements(settingsRoot);
	const hadFlag = hasOddEvenHeadersFooters(settingsRoot);
	if (enabled) {
		if (!hadFlag) elements.push({
			type: "element",
			name: "w:evenAndOddHeaders",
			elements: []
		});
	} else settingsRoot.elements = elements.filter((entry) => entry.name !== "w:evenAndOddHeaders");
	return hadFlag !== hasOddEvenHeadersFooters(settingsRoot);
}
function hasUpdateFields(settingsRoot) {
	const el = settingsRoot.elements?.find((entry) => entry.name === "w:updateFields");
	if (!el) return false;
	const val = el.attributes?.["w:val"];
	return val === "true" || val === "1" || val === true;
}
function setUpdateFields(settingsRoot, enabled) {
	const elements = ensureSettingsRootElements(settingsRoot);
	const idx = elements.findIndex((entry) => entry.name === "w:updateFields");
	if (enabled) {
		const newEl = {
			type: "element",
			name: "w:updateFields",
			attributes: { "w:val": "true" },
			elements: []
		};
		if (idx !== -1) elements[idx] = newEl;
		else elements.push(newEl);
	} else if (idx !== -1) elements.splice(idx, 1);
}
var VALID_EDIT_MODES = new Set([
	"readOnly",
	"comments",
	"trackedChanges",
	"forms"
]);
function isXmlTrue(value) {
	return value === "1" || value === 1 || value === "true" || value === "on" || value === true;
}
function hasVerifierFields(attrs) {
	return !!(attrs["w:cryptAlgorithmSid"] || attrs["w:hash"] || attrs["w:salt"] || attrs["w:cryptProviderType"] || attrs["w:cryptAlgorithmType"] || attrs["w:cryptAlgorithmClass"] || attrs["w:cryptSpinCount"]);
}
function parseProtectionState(settingsRoot) {
	if (!settingsRoot) return { ...DEFAULT_PROTECTION_STATE };
	const elements = settingsRoot.elements ?? [];
	const docProtEl = elements.find((el) => el.name === "w:documentProtection");
	const dpAttrs = docProtEl?.attributes ?? {};
	const rawMode = dpAttrs["w:edit"];
	const mode = rawMode && VALID_EDIT_MODES.has(rawMode) ? rawMode : "none";
	const enforced = isXmlTrue(dpAttrs["w:enforcement"]);
	const formattingRestricted = isXmlTrue(dpAttrs["w:formatting"]);
	const passwordProtected = docProtEl ? hasVerifierFields(dpAttrs) : false;
	const runtimeEnforced = mode === "readOnly" && enforced;
	const writeProt = elements.find((el) => el.name === "w:writeProtection");
	const wpAttrs = writeProt?.attributes ?? {};
	const writeEnabled = !!writeProt;
	const writePasswordProtected = writeProt ? hasVerifierFields(wpAttrs) : false;
	const readOnlyRecommended = isXmlTrue(wpAttrs["w:recommended"]);
	return {
		editingRestriction: {
			mode,
			enforced,
			runtimeEnforced,
			passwordProtected,
			formattingRestricted
		},
		writeProtection: {
			enabled: writeEnabled,
			passwordProtected: writePasswordProtected
		},
		readOnlyRecommended
	};
}
function setDocumentProtection(settingsRoot, opts) {
	const elements = ensureSettingsRootElements(settingsRoot);
	const idx = elements.findIndex((el) => el.name === "w:documentProtection");
	const attrs = {
		...idx !== -1 ? { ...elements[idx].attributes ?? {} } : {},
		"w:edit": opts.mode,
		"w:enforcement": opts.enforced ? "1" : "0"
	};
	if (opts.formattingRestricted !== void 0) attrs["w:formatting"] = opts.formattingRestricted ? "1" : "0";
	const newEl = {
		type: "element",
		name: "w:documentProtection",
		attributes: attrs,
		elements: []
	};
	if (idx !== -1) elements[idx] = newEl;
	else elements.push(newEl);
}
function clearDocumentProtectionEnforcement(settingsRoot) {
	const el = (settingsRoot.elements ?? []).find((e) => e.name === "w:documentProtection");
	if (!el) return;
	if (!el.attributes) el.attributes = {};
	el.attributes["w:enforcement"] = "0";
}
function getProtectionStorage(editor) {
	return editor?.storage?.protection;
}
function isReadOnlyProtectionRuntimeEnforced(editor) {
	const storage = getProtectionStorage(editor);
	if (!storage?.initialized) return false;
	return storage.state?.editingRestriction?.runtimeEnforced === true;
}
function applyEffectiveEditability(editor, opts = {}) {
	if (!editor || editor.isDestroyed) return;
	if (opts.refilterRanges !== false) refilterAllowedRanges(editor);
	const protectionEnforced = isReadOnlyProtectionRuntimeEnforced(editor);
	const hasAllowedRanges = editor.storage?.permissionRanges?.hasAllowedRanges === true;
	const documentMode = editor.options?.documentMode;
	const storage = getProtectionStorage(editor);
	if (protectionEnforced) {
		if (storage && storage.editableBaseline === null) storage.editableBaseline = editor.isEditable;
		const shouldBeEditable = hasAllowedRanges;
		if (editor.isEditable !== shouldBeEditable) editor.setEditable(shouldBeEditable, false);
	} else {
		const baseline = storage?.editableBaseline ?? null;
		if (storage) storage.editableBaseline = null;
		if (documentMode === "viewing") {
			if (editor.isEditable !== false) editor.setEditable(false, false);
		} else if (baseline !== null && editor.isEditable !== baseline) editor.setEditable(baseline, false);
	}
}
function refilterAllowedRanges(editor) {
	const storage = editor?.storage?.permissionRanges;
	if (!storage) return;
	const allRanges = storage.allRanges;
	if (!Array.isArray(allRanges)) return;
	if (!isReadOnlyProtectionRuntimeEnforced(editor)) {
		storage.allowedRanges = [];
		storage.hasAllowedRanges = false;
		storage.ranges = [];
		return;
	}
	const allowedIdentifiers = buildAllowedIdentifierSetFromEditor(editor);
	const filtered = allRanges.filter((entry) => isRangeAllowedForPrincipal(entry, allowedIdentifiers));
	storage.allowedRanges = filtered;
	storage.hasAllowedRanges = filtered.length > 0;
	storage.ranges = filtered;
}
function buildAllowedIdentifierSetFromEditor(editor) {
	const user = editor?.options?.user;
	if (!user) return /* @__PURE__ */ new Set();
	const principals = user.permissionPrincipals;
	if (Array.isArray(principals)) return new Set(principals.map((p) => typeof p === "string" ? p.trim().toLowerCase() : "").filter(Boolean));
	const identifiers = /* @__PURE__ */ new Set();
	const actorId = typeof user.id === "string" ? user.id.trim().toLowerCase() : "";
	if (actorId) identifiers.add(actorId);
	const email = typeof user.email === "string" ? user.email.trim().toLowerCase() : "";
	if (email) {
		const [localPart, domain] = email.split("@");
		if (localPart && domain) identifiers.add(`${domain}\\${localPart}`);
	}
	return identifiers;
}
function isRangeAllowedForPrincipal(entry, allowedIdentifiers) {
	if (entry.principal) {
		if (entry.principal.kind === "everyone") return true;
		if (entry.principal.kind === "editor") {
			const id = typeof entry.principal.id === "string" ? entry.principal.id.trim().toLowerCase() : "";
			return id ? allowedIdentifiers.has(id) : false;
		}
	}
	if ((typeof entry.edGrp === "string" ? entry.edGrp.trim().toLowerCase() : "") === "everyone") return true;
	const ed = typeof entry.ed === "string" ? entry.ed.trim().toLowerCase() : "";
	return ed ? allowedIdentifiers.has(ed) : false;
}
function handleNumberingInvalidation(editor, _event) {
	try {
		editor.view?.dispatch?.(editor.state.tr);
	} catch {}
}
function handleRelationshipsInvalidation(_editor, _event) {}
function handleHeaderFooterInvalidation(editor, _event) {
	try {
		const tr = editor.state.tr;
		tr.setMeta("forceUpdatePagination", true);
		editor.view?.dispatch?.(tr);
	} catch {}
}
function handleNotesInvalidation(editor, _event) {
	try {
		const tr = editor.state.tr;
		tr.setMeta("forceUpdatePagination", true);
		editor.view?.dispatch?.(tr);
	} catch {}
}
function handleSettingsInvalidation(editor, event) {
	if (event.source.startsWith("protection.")) return;
	const converter = editor.converter;
	if (!converter) return;
	const newState = parseProtectionState(readSettingsRoot(converter));
	const protStorage = getProtectionStorage(editor);
	if (protStorage) protStorage.state = newState;
	applyEffectiveEditability(editor);
	editor.emit("protectionChanged", {
		editor,
		state: newState,
		source: "remote-part-sync"
	});
}
function registerStaticInvalidationHandlers() {
	registerInvalidationHandler("word/numbering.xml", handleNumberingInvalidation);
	registerInvalidationHandler("word/_rels/document.xml.rels", handleRelationshipsInvalidation);
	registerInvalidationHandler("word/footnotes.xml", handleNotesInvalidation);
	registerInvalidationHandler("word/endnotes.xml", handleNotesInvalidation);
	registerInvalidationHandler("word/settings.xml", handleSettingsInvalidation);
}
function registerHeaderFooterInvalidation(partId) {
	registerInvalidationHandler(partId, handleHeaderFooterInvalidation);
}
function normalizeWordPartPath(target = "") {
	return `word/${String(target).replace(/\\/g, "/").replace(/^(\.\/|\/)+/, "").replace(/^word\//, "")}`;
}
function getWordPartRelsPath(partPath = "") {
	const normalized = String(partPath).replace(/\\/g, "/");
	const lastSlash = normalized.lastIndexOf("/");
	if (lastSlash < 0 || lastSlash === normalized.length - 1) return `word/_rels/${lastSlash < 0 ? normalized : normalized.slice(lastSlash + 1)}.rels`;
	return `${normalized.slice(0, lastSlash)}/_rels/${normalized.slice(lastSlash + 1)}.rels`;
}
var DOCUMENT_RELS_PATH = "word/_rels/document.xml.rels";
var RELS_XMLNS = "http://schemas.openxmlformats.org/package/2006/relationships";
var HEADER_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
var WORDPROCESSINGML_XMLNS = "http://schemas.openxmlformats.org/wordprocessingml/2006/main";
var OFFICE_DOCUMENT_RELS_XMLNS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
var RELATIONSHIP_ID_PATTERN = /^rId(\d+)$/;
var HEADER_FILE_PATTERN = /^word\/header(\d+)\.xml$/;
var FOOTER_FILE_PATTERN = /^word\/footer(\d+)\.xml$/;
function getConverterForHeaderFooter(editor) {
	return editor.converter;
}
function cloneValue(value) {
	return JSON.parse(JSON.stringify(value));
}
function toRelationshipType(kind) {
	return kind === "header" ? HEADER_RELATIONSHIP_TYPE : FOOTER_RELATIONSHIP_TYPE;
}
function toFilePattern(kind) {
	return kind === "header" ? HEADER_FILE_PATTERN : FOOTER_FILE_PATTERN;
}
function normalizeRelationshipTarget(target) {
	let normalized = target.replace(/^\.\//, "");
	if (normalized.startsWith("../")) normalized = normalized.slice(3);
	if (normalized.startsWith("/")) normalized = normalized.slice(1);
	if (!normalized.startsWith("word/")) normalized = `word/${normalized}`;
	return normalized;
}
function toRelsPathForPart(partPath) {
	return getWordPartRelsPath(normalizeRelationshipTarget(partPath));
}
function ensureConvertedXml(converter) {
	if (!converter.convertedXml || typeof converter.convertedXml !== "object") converter.convertedXml = {};
	return converter.convertedXml;
}
function readRelationshipsRoot(converter) {
	const relsPart = converter.convertedXml?.[DOCUMENT_RELS_PATH];
	if (!relsPart || typeof relsPart !== "object" || !Array.isArray(relsPart.elements)) return null;
	const relationshipsRoot = relsPart.elements.find((entry) => entry.name === "Relationships");
	if (!relationshipsRoot || !Array.isArray(relationshipsRoot.elements)) return null;
	return relationshipsRoot;
}
function getRelationshipElements$1(root) {
	if (!Array.isArray(root.elements)) return [];
	return root.elements.filter((entry) => entry.name === "Relationship");
}
function findRelationshipById(relationships, refId, relationshipType) {
	return relationships.find((entry) => String(entry.attributes?.Id ?? "") === refId && String(entry.attributes?.Type ?? "") === relationshipType);
}
function hasHeaderFooterRelationship(converter, input) {
	const relationshipsRoot = readRelationshipsRoot(converter);
	if (!relationshipsRoot) return false;
	return findRelationshipById(getRelationshipElements$1(relationshipsRoot), input.refId, toRelationshipType(input.kind)) !== void 0;
}
function nextRelationshipId(relationships) {
	const usedIds = new Set(relationships.map((entry) => String(entry.attributes?.Id ?? "")).filter((value) => value.length > 0));
	let largestNumericId = 0;
	for (const id of usedIds) {
		const match = id.match(RELATIONSHIP_ID_PATTERN);
		if (!match) continue;
		const numericId = Number(match[1]);
		if (Number.isFinite(numericId) && numericId > largestNumericId) largestNumericId = numericId;
	}
	let candidate = largestNumericId + 1;
	while (usedIds.has(`rId${candidate}`)) candidate += 1;
	return `rId${candidate}`;
}
function nextHeaderFooterFilename(kind, relationships, convertedXml) {
	const relationshipType = toRelationshipType(kind);
	const filePattern = toFilePattern(kind);
	let largestIndex = 0;
	const candidatePaths = [...relationships.filter((entry) => String(entry.attributes?.Type ?? "") === relationshipType).map((entry) => normalizeRelationshipTarget(String(entry.attributes?.Target ?? ""))), ...Object.keys(convertedXml)];
	for (const path of candidatePaths) {
		const match = path.match(filePattern);
		if (!match) continue;
		const numericIndex = Number(match[1]);
		if (Number.isFinite(numericIndex) && numericIndex > largestIndex) largestIndex = numericIndex;
	}
	let nextIndex = largestIndex + 1;
	while (convertedXml[`word/${kind}${nextIndex}.xml`]) nextIndex += 1;
	return `${kind}${nextIndex}.xml`;
}
function createEmptyXmlPart(kind) {
	return { elements: [{
		type: "element",
		name: kind === "header" ? "w:hdr" : "w:ftr",
		attributes: {
			"xmlns:w": WORDPROCESSINGML_XMLNS,
			"xmlns:r": OFFICE_DOCUMENT_RELS_XMLNS
		},
		elements: [{
			type: "element",
			name: "w:p",
			elements: []
		}]
	}] };
}
function createEmptyHeaderFooterJsonPart() {
	return {
		type: "doc",
		content: [{
			type: "paragraph",
			content: []
		}]
	};
}
function getCollection(converter, kind) {
	if (kind === "header") {
		if (!converter.headers || typeof converter.headers !== "object") converter.headers = {};
		return converter.headers;
	}
	if (!converter.footers || typeof converter.footers !== "object") converter.footers = {};
	return converter.footers;
}
function readSourceSnapshot(converter, kind, sourceRefId, relationships) {
	const convertedXml = ensureConvertedXml(converter);
	const collection = getCollection(converter, kind);
	const relationshipType = toRelationshipType(kind);
	const sourceJsonPart = sourceRefId && typeof collection[sourceRefId] === "object" ? cloneValue(collection[sourceRefId]) : null;
	if (!sourceRefId) return {
		xmlPart: null,
		xmlPartPath: null,
		relsPart: null,
		relsPartPath: null,
		jsonPart: sourceJsonPart
	};
	const sourceRelationship = findRelationshipById(relationships, sourceRefId, relationshipType);
	const sourceTarget = sourceRelationship ? String(sourceRelationship.attributes?.Target ?? "") : "";
	if (!sourceTarget) return {
		xmlPart: null,
		xmlPartPath: null,
		relsPart: null,
		relsPartPath: null,
		jsonPart: sourceJsonPart
	};
	const sourcePartPath = normalizeRelationshipTarget(sourceTarget);
	const sourcePart = convertedXml[sourcePartPath];
	const sourceRelsPath = toRelsPathForPart(sourcePartPath);
	const sourceRelsPart = convertedXml[sourceRelsPath];
	return {
		xmlPart: sourcePart && typeof sourcePart === "object" ? cloneValue(sourcePart) : null,
		xmlPartPath: sourcePartPath,
		relsPart: sourceRelsPart && typeof sourceRelsPart === "object" ? cloneValue(sourceRelsPart) : null,
		relsPartPath: sourceRelsPart ? sourceRelsPath : null,
		jsonPart: sourceJsonPart
	};
}
function createHeaderFooterPart(editor, input) {
	const converter = getConverterForHeaderFooter(editor);
	ensureConvertedXml(converter);
	const convertedXml = converter.convertedXml;
	const relationshipsRoot = readRelationshipsRoot(converter);
	const relationships = relationshipsRoot ? getRelationshipElements$1(relationshipsRoot) : [];
	const newRefId = nextRelationshipId(relationships);
	const relationshipType = toRelationshipType(input.kind);
	const newFilename = nextHeaderFooterFilename(input.kind, relationships, convertedXml);
	const newPartPath = `word/${newFilename}`;
	const sourceSnapshot = readSourceSnapshot(converter, input.kind, input.sourceRefId, relationships);
	const operations = [{
		editor,
		partId: newPartPath,
		operation: "create",
		source: "createHeaderFooterPart",
		initial: sourceSnapshot.xmlPart ?? createEmptyXmlPart(input.kind)
	}];
	if (sourceSnapshot.relsPart) operations.push({
		editor,
		partId: toRelsPathForPart(newPartPath),
		operation: "create",
		source: "createHeaderFooterPart",
		initial: sourceSnapshot.relsPart
	});
	operations.push({
		editor,
		partId: DOCUMENT_RELS_PATH,
		operation: "mutate",
		source: "createHeaderFooterPart",
		mutate({ part }) {
			const root = part;
			if (!root.elements) root.elements = [];
			let relsRoot = root.elements.find((el) => el.name === "Relationships");
			if (!relsRoot) {
				relsRoot = {
					type: "element",
					name: "Relationships",
					attributes: { xmlns: RELS_XMLNS },
					elements: []
				};
				root.elements.push(relsRoot);
			}
			if (!relsRoot.elements) relsRoot.elements = [];
			relsRoot.elements.push({
				type: "element",
				name: "Relationship",
				attributes: {
					Id: newRefId,
					Type: relationshipType,
					Target: newFilename
				}
			});
			return true;
		}
	});
	let finalResult = null;
	if (!compoundMutation({
		editor,
		source: "createHeaderFooterPart",
		affectedParts: [DOCUMENT_RELS_PATH],
		execute: () => {
			if (mutateParts({
				editor,
				source: "createHeaderFooterPart",
				operations
			}).degraded) {
				if (hasPart(editor, newPartPath)) removePart(editor, newPartPath);
				const newRelsPath = toRelsPathForPart(newPartPath);
				if (hasPart(editor, newRelsPath)) removePart(editor, newRelsPath);
				return false;
			}
			registerHeaderFooterInvalidation(newPartPath);
			if (sourceSnapshot.jsonPart) {
				const collection = getCollection(converter, input.kind);
				collection[newRefId] = sourceSnapshot.jsonPart;
			}
			finalResult = {
				refId: newRefId,
				relationshipTarget: newPartPath
			};
			return true;
		}
	}).success || !finalResult) throw new Error(`[createHeaderFooterPart] Failed to create ${newPartPath}: mutation rolled back (possible afterCommit degradation).`);
	return finalResult;
}
function resolveEffectiveRef(sections, startSectionIndex, kind, variant) {
	const refsFor = (section, refKind) => refKind === "header" ? section.range.headerRefs ?? section.domain.headerRefs : section.range.footerRefs ?? section.domain.footerRefs;
	const resolved = resolveEffectiveHeaderFooterRef({
		sections: sections.map((section) => ({
			sectionIndex: section.range.sectionIndex,
			titlePg: section.range.titlePg,
			headerRefs: refsFor(section, "header"),
			footerRefs: refsFor(section, "footer")
		})),
		sectionIndex: startSectionIndex - 1,
		kind,
		variant
	});
	if (!resolved) return null;
	const resolvedSection = sections.find((section) => section.range.sectionIndex === resolved.matchedSectionIndex);
	if (!resolvedSection) return null;
	return {
		refId: resolved.refId,
		resolvedFromSection: resolvedSection.address,
		resolvedVariant: resolved.matchedVariant
	};
}
function getConverter$5(editor) {
	return editor.converter;
}
function setHeaderFooterRefMutation(sectPr, kind, variant, refId, converter, operationName, dryRun = false) {
	if (!converter) return {
		success: false,
		failure: {
			code: "CAPABILITY_UNAVAILABLE",
			message: `${operationName} requires an active document converter to validate relationship references.`
		}
	};
	if (!hasHeaderFooterRelationship(converter, {
		kind,
		refId
	})) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: `${operationName} could not find ${kind} relationship "${refId}" in word/_rels/document.xml.rels.`
		}
	};
	if (getSectPrHeaderFooterRef(sectPr, kind, variant) === refId) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: `${operationName} already matches the requested reference.`
		}
	};
	setSectPrHeaderFooterRef(sectPr, kind, variant, refId);
	if (!dryRun) reconcileVariantPointerOnSet(converter, kind, variant, refId);
}
function clearHeaderFooterRefMutation(sectPr, kind, variant, converter, dryRun = false) {
	const currentRef = getSectPrHeaderFooterRef(sectPr, kind, variant);
	clearSectPrHeaderFooterRef(sectPr, kind, variant);
	if (!dryRun && currentRef && converter) reconcileVariantPointerOnClear(converter, kind, currentRef);
}
function setLinkedToPreviousMutation(sectPr, projection, sections, kind, variant, linked, editor, dryRun, operationName) {
	if (projection.range.sectionIndex === 0) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: `${operationName} cannot target the first section.`
		}
	};
	if (linked) {
		const clearedRef = getSectPrHeaderFooterRef(sectPr, kind, variant);
		if (!clearSectPrHeaderFooterRef(sectPr, kind, variant)) return {
			success: false,
			failure: {
				code: "NO_OP",
				message: `${operationName} found no explicit reference to remove.`
			}
		};
		if (!dryRun && clearedRef) {
			const converter$1 = getConverter$5(editor);
			if (converter$1) reconcileVariantPointerOnClear(converter$1, kind, clearedRef);
		}
		return;
	}
	if (getSectPrHeaderFooterRef(sectPr, kind, variant)) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: `${operationName} already has an explicit reference.`
		}
	};
	const resolved = resolveEffectiveRef(sections, projection.range.sectionIndex, kind, variant);
	if (dryRun) {
		setSectPrHeaderFooterRef(sectPr, kind, variant, "(dry-run)");
		return;
	}
	const explicitRefId = createExplicitHeaderFooterReference(editor, {
		kind,
		sourceRefId: resolved?.refId
	});
	if (!explicitRefId) {
		if (resolved?.refId) {
			setSectPrHeaderFooterRef(sectPr, kind, variant, resolved.refId);
			return;
		}
		return {
			success: false,
			failure: {
				code: "CAPABILITY_UNAVAILABLE",
				message: `${operationName} could not allocate an explicit header/footer reference for this section.`
			}
		};
	}
	setSectPrHeaderFooterRef(sectPr, kind, variant, explicitRefId);
	const converter = getConverter$5(editor);
	if (converter) reconcileVariantPointerOnSet(converter, kind, variant, explicitRefId);
}
function createExplicitHeaderFooterReference(editor, input) {
	if (!getConverter$5(editor)) return null;
	try {
		const { refId } = createHeaderFooterPart(editor, {
			kind: input.kind,
			variant: "default",
			sourceRefId: input.sourceRefId
		});
		return refId;
	} catch {
		return null;
	}
}
function getVariantIds(converter, kind) {
	if (kind === "header") {
		if (!converter.headerIds || typeof converter.headerIds !== "object") converter.headerIds = {};
		return converter.headerIds;
	}
	if (!converter.footerIds || typeof converter.footerIds !== "object") converter.footerIds = {};
	return converter.footerIds;
}
function reconcileVariantPointerOnSet(converter, kind, variant, refId) {
	const variantIds = getVariantIds(converter, kind);
	variantIds[variant] = refId;
}
function reconcileVariantPointerOnClear(converter, kind, clearedRefId) {
	const variantIds = getVariantIds(converter, kind);
	for (const key of [
		"default",
		"first",
		"even",
		"odd"
	]) if (variantIds[key] === clearedRefId) variantIds[key] = null;
}
function getConverter$4(editor) {
	return editor.converter;
}
const SOURCE_HEADER_FOOTER_LOCAL = "header-footer-sync:local";
var HEADER_PATTERN = /^word\/header\d+\.xml$/;
var FOOTER_PATTERN = /^word\/footer\d+\.xml$/;
function isHeaderPartId(partId) {
	return HEADER_PATTERN.test(partId);
}
function isFooterPartId(partId) {
	return FOOTER_PATTERN.test(partId);
}
function isHeaderFooterPartId(partId) {
	return isHeaderPartId(partId) || isFooterPartId(partId);
}
function getHeaderFooterType(partId) {
	return isHeaderPartId(partId) ? "header" : "footer";
}
var DEFAULT_HDR_FTR_ATTRS = {
	"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
	"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
	"xmlns:o": "urn:schemas-microsoft-com:office:office",
	"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
	"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
	"xmlns:v": "urn:schemas-microsoft-com:vml",
	"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
	"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
	"xmlns:w10": "urn:schemas-microsoft-com:office:word",
	"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
	"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
	"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
	"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
	"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
	"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
};
function ensureHeaderFooterDescriptor(partId, sectionId) {
	if (hasPartDescriptor(partId)) return;
	const type = getHeaderFooterType(partId);
	const rootElementName = type === "header" ? "w:hdr" : "w:ftr";
	registerPartDescriptor({
		id: partId,
		ensurePart() {
			return {
				type: "element",
				name: "document",
				elements: [{
					type: "element",
					name: rootElementName,
					attributes: { ...DEFAULT_HDR_FTR_ATTRS },
					elements: []
				}]
			};
		},
		afterCommit(ctx) {
			const converter = getConverter$4(ctx.editor);
			if (!converter) return;
			const resolvedSectionId = ctx.sectionId ?? sectionId;
			const isLocalSync = ctx.source === SOURCE_HEADER_FOOTER_LOCAL;
			if (typeof converter.reimportHeaderFooterPart === "function") try {
				const pmJson = converter.reimportHeaderFooterPart(ctx.partId);
				if (pmJson) {
					const collection = type === "header" ? converter.headers ??= {} : converter.footers ??= {};
					collection[resolvedSectionId] = pmJson;
				}
			} catch (err$1) {
				console.warn(`[parts] Failed to re-import ${ctx.partId}:`, err$1);
			}
			converter.headerFooterModified = true;
			if (!isLocalSync) refreshActiveSubEditors(converter, type, resolvedSectionId);
		},
		onDelete(ctx) {
			const converter = getConverter$4(ctx.editor);
			if (!converter) return;
			const resolvedSectionId = ctx.sectionId ?? sectionId;
			destroySubEditors(converter, type, resolvedSectionId);
			const collection = type === "header" ? converter.headers : converter.footers;
			if (collection) delete collection[resolvedSectionId];
			converter.headerFooterModified = true;
		}
	});
	registerHeaderFooterInvalidationHandler(partId);
}
function refreshActiveSubEditors(converter, type, sectionId) {
	const editors = type === "header" ? converter.headerEditors : converter.footerEditors;
	const pmJson = (type === "header" ? converter.headers : converter.footers)?.[sectionId];
	if (!editors || !pmJson) return;
	for (const entry of editors) if (entry.id === sectionId && entry.editor && !entry.editor.isDestroyed) try {
		entry.editor.replaceContent(pmJson);
	} catch (err$1) {
		console.warn(`[parts] Failed to refresh sub-editor for ${type}:${sectionId}:`, err$1);
	}
}
function destroySubEditors(converter, type, sectionId) {
	const editors = type === "header" ? converter.headerEditors : converter.footerEditors;
	if (!editors) return;
	for (let i$1 = editors.length - 1; i$1 >= 0; i$1--) if (editors[i$1].id === sectionId) {
		try {
			editors[i$1].editor.destroy?.();
		} catch {}
		editors.splice(i$1, 1);
	}
}
function registerHeaderFooterInvalidationHandler(partId) {
	registerInvalidationHandler(partId, (editor) => {
		const view = editor.view;
		if (!view?.dispatch) return;
		try {
			const tr = editor.state.tr;
			tr.setMeta.call(tr, "forceUpdatePagination", true);
			view.dispatch(tr);
		} catch {}
	});
}
function getConverter$3(editor) {
	return editor.converter;
}
var HEADER_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
function normalizeHeaderFooterPartPath(target = "") {
	return normalizeWordPartPath(target);
}
function getHeaderFooterRelsPartId(partId) {
	return getWordPartRelsPath(partId);
}
function getRelationshipElements(part) {
	return getRelationshipsRoot(part)?.elements ?? [];
}
function resolvePartIdFromRefId(editor, headerFooterRefId) {
	const relsRoot = (getConverter$3(editor)?.convertedXml?.["word/_rels/document.xml.rels"])?.elements?.find((el) => el.name === "Relationships");
	if (!relsRoot?.elements) return null;
	for (const el of relsRoot.elements) {
		if (el.name !== "Relationship") continue;
		if (el.attributes?.Id !== headerFooterRefId) continue;
		const type = el.attributes?.Type;
		if (type !== HEADER_REL_TYPE && type !== FOOTER_REL_TYPE) continue;
		const target = el.attributes?.Target;
		if (!target) continue;
		return normalizeHeaderFooterPartPath(target);
	}
	return null;
}
function resolveHeaderFooterRelsPartIdFromRefId(editor, headerFooterRefId) {
	const partId = resolvePartIdFromRefId(editor, headerFooterRefId);
	return partId ? getHeaderFooterRelsPartId(partId) : null;
}
function resolveRIdFromRelsData(relsData, partId) {
	const target = partId.replace(/^word\//, "");
	const relsRoot = relsData?.elements?.find((el) => el.name === "Relationships");
	if (!relsRoot?.elements) return null;
	for (const el of relsRoot.elements) {
		if (el.name !== "Relationship") continue;
		if (el.attributes?.Target !== target) continue;
		const type = el.attributes?.Type;
		if (type !== HEADER_REL_TYPE && type !== FOOTER_REL_TYPE) continue;
		return el.attributes?.Id ?? null;
	}
	return null;
}
function resolveHeaderFooterRId(partId, relsData, editor) {
	if (relsData) {
		const rId = resolveRIdFromRelsData(relsData, partId);
		if (rId) return rId;
	}
	if (editor) {
		const localRels = getConverter$3(editor)?.convertedXml?.["word/_rels/document.xml.rels"];
		if (localRels) return resolveRIdFromRelsData(localRels, partId);
	}
	return null;
}
function exportSubEditorToPart(mainEditor, subEditor, headerFooterRefId, type) {
	const converter = getConverter$3(mainEditor);
	if (!converter?.exportToXmlJson) return false;
	const partId = resolvePartIdFromRefId(mainEditor, headerFooterRefId);
	if (!partId) return false;
	ensureHeaderFooterDescriptor(partId, headerFooterRefId);
	const relsPartId = getHeaderFooterRelsPartId(partId);
	const existingRelationships = getRelationshipElements(converter.convertedXml?.[relsPartId]);
	const pmJson = typeof subEditor.getUpdatedJson === "function" ? subEditor.getUpdatedJson() : converter[`${type}s`]?.[headerFooterRefId];
	if (!pmJson) return false;
	let bodyContent;
	try {
		const { result } = converter.exportToXmlJson({
			data: pmJson,
			editor: subEditor,
			editorSchema: subEditor.schema,
			isHeaderFooter: true,
			comments: [],
			commentDefinitions: [],
			existingRelationships
		});
		bodyContent = result?.elements?.[0]?.elements ?? [];
	} catch (err$1) {
		console.warn(`[header-footer-sync] Export failed for ${partId}:`, err$1);
		return false;
	}
	try {
		if ((hasPart(mainEditor, partId) ? "mutate" : "create") === "mutate") mutatePart({
			editor: mainEditor,
			partId,
			sectionId: headerFooterRefId,
			operation: "mutate",
			source: SOURCE_HEADER_FOOTER_LOCAL,
			mutate: ({ part }) => {
				const p = part;
				if (p?.elements?.[0]) p.elements[0].elements = bodyContent;
			}
		});
		else mutatePart({
			editor: mainEditor,
			partId,
			sectionId: headerFooterRefId,
			operation: "create",
			source: SOURCE_HEADER_FOOTER_LOCAL,
			initial: {
				type: "element",
				name: "document",
				elements: [{
					type: "element",
					name: type === "header" ? "w:hdr" : "w:ftr",
					elements: bodyContent
				}]
			}
		});
		return true;
	} catch (err$1) {
		console.warn(`[header-footer-sync] mutatePart failed for ${partId}:`, err$1);
		return false;
	}
}
function registerExistingHeaderFooterDescriptors(editor) {
	const converter = getConverter$3(editor);
	if (!converter?.convertedXml) return;
	const relsRoot = converter.convertedXml["word/_rels/document.xml.rels"]?.elements?.find((el) => el.name === "Relationships");
	if (!relsRoot?.elements) return;
	for (const el of relsRoot.elements) {
		if (el.name !== "Relationship") continue;
		const type = el.attributes?.Type;
		if (type !== HEADER_REL_TYPE && type !== FOOTER_REL_TYPE) continue;
		const target = el.attributes?.Target;
		const id = el.attributes?.Id;
		if (!target || !id) continue;
		const partId = normalizeHeaderFooterPartPath(target);
		if (isHeaderFooterPartId(partId)) ensureHeaderFooterDescriptor(partId, id);
	}
}
function applyDirectMutationMeta(tr) {
	tr.setMeta("inputType", "programmatic");
	tr.setMeta("skipTrackChanges", true);
	return tr;
}
function applyTrackedMutationMeta(tr) {
	tr.setMeta("inputType", "programmatic");
	tr.setMeta("forceTrackChanges", true);
	return tr;
}
function requireEditorCommand(command, operationName) {
	if (typeof command === "function") return command;
	throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${operationName} command is not available.`, { reason: "missing_command" });
}
function ensureTrackedCapability(editor, config$43) {
	if (typeof editor.commands?.insertTrackedChange !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${config$43.operation} requires the insertTrackedChange command.`, { reason: "missing_command" });
	if (config$43.requireMarks) {
		for (const markName of config$43.requireMarks) if (!editor.schema?.marks?.[markName]) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${config$43.operation} requires the "${markName}" mark in the schema.`, {
			reason: "missing_mark",
			markName
		});
	}
	if (!editor.options.user) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${config$43.operation} requires a user to be configured on the editor instance.`, { reason: "missing_user" });
}
function rejectTrackedMode(operation, options) {
	if ((options?.changeMode ?? "direct") === "direct") return;
	throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${operation} does not support tracked mode.`, { reason: "tracked_mode_unsupported" });
}
function toSectionFailure(code$1, message) {
	return {
		success: false,
		failure: {
			code: code$1,
			message
		}
	};
}
function toSectionSuccess(section) {
	return {
		success: true,
		section
	};
}
function buildSectionMarginsForAttrs(sectPr) {
	const margins = readSectPrMargins(sectPr);
	return {
		top: margins.top ?? null,
		right: margins.right ?? null,
		bottom: margins.bottom ?? null,
		left: margins.left ?? null,
		header: margins.header ?? null,
		footer: margins.footer ?? null
	};
}
function syncConverterBodySection(editor, sectPr) {
	const converter = getConverter$2(editor);
	if (!converter) return;
	converter.bodySectPr = cloneXmlElement(sectPr);
	const savedBodyNode = converter.savedTagsToRestore?.find((entry) => entry?.name === "w:body");
	if (savedBodyNode && Array.isArray(savedBodyNode.elements)) {
		const preservedChildren = savedBodyNode.elements.filter((entry) => entry?.name !== "w:sectPr");
		preservedChildren.push(cloneXmlElement(sectPr));
		savedBodyNode.elements = preservedChildren;
	}
	const margins = readSectPrMargins(sectPr);
	const pageSetup = readSectPrPageSetup(sectPr);
	if (!converter.pageStyles) converter.pageStyles = {};
	if (!converter.pageStyles.pageSize) converter.pageStyles.pageSize = {};
	if (pageSetup?.width !== void 0) converter.pageStyles.pageSize.width = pageSetup.width;
	if (pageSetup?.height !== void 0) converter.pageStyles.pageSize.height = pageSetup.height;
	if (!converter.pageStyles.pageMargins) converter.pageStyles.pageMargins = {};
	const pageMargins = converter.pageStyles.pageMargins;
	if (margins.top !== void 0) pageMargins.top = margins.top;
	if (margins.right !== void 0) pageMargins.right = margins.right;
	if (margins.bottom !== void 0) pageMargins.bottom = margins.bottom;
	if (margins.left !== void 0) pageMargins.left = margins.left;
	if (margins.header !== void 0) pageMargins.header = margins.header;
	if (margins.footer !== void 0) pageMargins.footer = margins.footer;
	if (margins.gutter !== void 0) pageMargins.gutter = margins.gutter;
}
function getConverter$2(editor) {
	return editor.converter;
}
function applySectPrToProjection(editor, projection, sectPr, options) {
	const addToHistory = options?.addToHistory ?? true;
	if (projection.target.kind === "paragraph") {
		const paragraph = projection.target.node;
		const attrs = paragraph.attrs ?? {};
		const paragraphProperties = {
			...attrs.paragraphProperties ?? {},
			sectPr
		};
		const nextAttrs = {
			...attrs,
			paragraphProperties,
			pageBreakSource: "sectPr",
			sectionMargins: buildSectionMarginsForAttrs(sectPr)
		};
		const tr$1 = applyDirectMutationMeta(editor.state.tr);
		if (!addToHistory) tr$1.setMeta("addToHistory", false);
		tr$1.setNodeMarkup(projection.target.pos, void 0, nextAttrs, paragraph.marks);
		tr$1.setMeta("forceUpdatePagination", true);
		editor.dispatch(tr$1);
		return;
	}
	const tr = applyDirectMutationMeta(editor.state.tr);
	if (!addToHistory) tr.setMeta("addToHistory", false);
	tr.setDocAttribute("bodySectPr", sectPr);
	tr.setMeta("forceUpdatePagination", true);
	editor.dispatch(tr);
	syncConverterBodySection(editor, sectPr);
}
function sectionMutationBySectPr(editor, input, options, operationName, mutate) {
	rejectTrackedMode(operationName, options);
	checkRevision(editor, options?.expectedRevision);
	const sections = resolveSectionProjections(editor);
	const projection = sections.find((entry) => entry.sectionId === input.target.sectionId);
	if (!projection) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Section target was not found.", { target: input.target });
	const dryRun = options?.dryRun === true;
	const nextSectPr = ensureSectPrElement(readTargetSectPr(editor, projection));
	const before = JSON.stringify(nextSectPr);
	const earlyResult = mutate(nextSectPr, projection, sections, dryRun);
	if (earlyResult) return earlyResult;
	if (!(before !== JSON.stringify(nextSectPr))) return toSectionFailure("NO_OP", `${operationName} did not produce a section change.`);
	if (options?.dryRun) return toSectionSuccess(projection.address);
	applySectPrToProjection(editor, projection, nextSectPr);
	clearIndexCache(editor);
	return toSectionSuccess(projection.address);
}
var VALID_VARIANTS = new Set([
	"default",
	"first",
	"even"
]);
function normalizeVariant(sectionType) {
	if (sectionType === "odd") return "default";
	if (!VALID_VARIANTS.has(sectionType)) throw new Error(`Unrecognized header/footer variant: "${sectionType}". Expected default, first, or even.`);
	return sectionType;
}
function cleanupCreatedPart(editor, partPath) {
	const partId = partPath;
	if (hasPart(editor, partId)) removePart(editor, partId);
	removeInvalidationHandler(partId);
	const relsPath = getWordPartRelsPath(partPath);
	if (hasPart(editor, relsPath)) removePart(editor, relsPath);
}
function ensureExplicitHeaderFooterSlot(editor, input) {
	const { sectionId, kind, variant, sourceRefId, addToHistory = true } = input;
	const sections = resolveSectionProjections(editor);
	const projection = sections.find((s) => s.sectionId === sectionId);
	if (!projection) {
		console.warn(`[header-footer-slot-materialization] Section "${sectionId}" not found.`);
		return null;
	}
	const currentSectPr = readTargetSectPr(editor, projection);
	if (currentSectPr) {
		const existingRefId = readSectPrHeaderFooterRefs(currentSectPr, kind)?.[variant];
		if (existingRefId) return {
			refId: existingRefId,
			createdPartPath: "",
			sectionId,
			kind,
			variant,
			materializedFromRefId: null,
			created: false
		};
	}
	const inheritedRef = resolveEffectiveRef(sections, sections.indexOf(projection), kind, variant);
	const effectiveSourceRefId = sourceRefId ?? inheritedRef?.refId ?? void 0;
	let result = null;
	if (!compoundMutation({
		editor,
		source: "ensureExplicitHeaderFooterSlot",
		affectedParts: ["word/_rels/document.xml.rels"],
		execute: () => {
			let created;
			try {
				created = createHeaderFooterPart(editor, {
					kind,
					variant,
					sourceRefId: effectiveSourceRefId
				});
			} catch {
				return false;
			}
			try {
				const nextSectPr = ensureSectPrElement(currentSectPr);
				setSectPrHeaderFooterRef(nextSectPr, kind, variant, created.refId);
				applySectPrToProjection(editor, projection, nextSectPr, { addToHistory });
			} catch {
				cleanupCreatedPart(editor, created.relationshipTarget);
				return false;
			}
			result = {
				refId: created.refId,
				createdPartPath: created.relationshipTarget,
				sectionId,
				kind,
				variant,
				materializedFromRefId: effectiveSourceRefId ?? null,
				created: true
			};
			return true;
		}
	}).success) {
		console.warn("[header-footer-slot-materialization] Materialization failed, state rolled back.");
		return null;
	}
	return result;
}
function getConverter$1(editor) {
	return editor.converter;
}
function resolveHeaderFooterSlotRuntime(hostEditor, locator, options = {}) {
	const storyKey = buildStoryKey(locator);
	const converter = getConverter$1(hostEditor);
	if (!converter) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `Cannot resolve header/footer slot: no converter available on the editor.`, { storyKey });
	const resolution = locator.resolution ?? "effective";
	const intent = options.intent ?? "read";
	const { headerFooterKind, variant } = locator;
	const sections = resolveSectionProjections(hostEditor);
	const projection = sections.find((s) => s.sectionId === locator.section.sectionId);
	if (!projection) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `Section "${locator.section.sectionId}" not found.`, { storyKey });
	const sectPr = readTargetSectPr(hostEditor, projection) ?? void 0;
	const explicitRefId = (sectPr ? readSectPrHeaderFooterRefs(sectPr, headerFooterKind) : void 0)?.[variant] ?? null;
	let effectiveRefId = explicitRefId;
	if (!explicitRefId) {
		if (resolution === "explicit") throw new DocumentApiAdapterError("STORY_NOT_FOUND", `No explicit ${headerFooterKind} (${variant}) defined for section "${locator.section.sectionId}".`, {
			storyKey,
			resolution
		});
		effectiveRefId = resolveEffectiveRef(sections, projection.range.sectionIndex, headerFooterKind, variant)?.refId ?? null;
	}
	const isInherited = explicitRefId === null;
	const onWrite = locator.onWrite ?? "materializeIfInherited";
	if (!effectiveRefId) {
		if (intent === "write" && resolution !== "explicit" && onWrite === "materializeIfInherited") return createMissingSlotWriteRuntime(hostEditor, locator, storyKey);
		throw new DocumentApiAdapterError("STORY_NOT_FOUND", `No ${headerFooterKind} (${variant}) found for section "${locator.section.sectionId}".`, { storyKey });
	}
	if (isInherited && onWrite === "error") throw new DocumentApiAdapterError("PRECONDITION_FAILED", `Slot is inherited and onWrite is 'error'. Section "${locator.section.sectionId}" has no explicit ${headerFooterKind} (${variant}).`, { storyKey });
	const collection = headerFooterKind === "header" ? "headers" : "footers";
	if (isInherited && onWrite === "materializeIfInherited") {
		const isolatedEditor = createHeadlessHeaderFooterEditor(hostEditor, readCachedHeaderFooterContent(converter, collection, effectiveRefId, storyKey, headerFooterKind), `${effectiveRefId}:materialization-pending`);
		return createOwnedHeaderFooterRuntime(locator, storyKey, isolatedEditor, {
			commit: buildSlotCommit(locator, isolatedEditor, effectiveRefId, true),
			commitEditor: (hostEditor$1, sessionEditor) => buildSlotCommit(locator, sessionEditor, effectiveRefId, true)(hostEditor$1)
		});
	}
	const liveEditor = findLiveSubEditor(converter, collection, effectiveRefId);
	if (liveEditor) return {
		locator,
		storyKey,
		editor: liveEditor,
		kind: "headerFooter",
		commit: buildSlotCommit(locator, liveEditor, effectiveRefId, false),
		commitEditor: (hostEditor$1, sessionEditor) => buildSlotCommit(locator, sessionEditor, effectiveRefId, false)(hostEditor$1)
	};
	const storyEditor = createHeadlessHeaderFooterEditor(hostEditor, readCachedHeaderFooterContent(converter, collection, effectiveRefId, storyKey, headerFooterKind), effectiveRefId);
	return createOwnedHeaderFooterRuntime(locator, storyKey, storyEditor, {
		commit: buildSlotCommit(locator, storyEditor, effectiveRefId, false),
		commitEditor: (hostEditor$1, sessionEditor) => buildSlotCommit(locator, sessionEditor, effectiveRefId, false)(hostEditor$1)
	});
}
function buildSlotCommit(locator, storyEditor, sourceRefId, requiresLocalMaterialization) {
	const { headerFooterKind, variant, section } = locator;
	return (hostEditor) => {
		let targetRefId = sourceRefId;
		if (requiresLocalMaterialization) {
			const result = ensureExplicitHeaderFooterSlot(hostEditor, {
				sectionId: section.sectionId,
				kind: headerFooterKind,
				variant,
				sourceRefId: sourceRefId ?? void 0
			});
			if (!result) throw new DocumentApiAdapterError("MATERIALIZATION_FAILED", `Failed to materialize ${headerFooterKind} slot for section "${section.sectionId}".`, { sectionId: section.sectionId });
			targetRefId = result.refId;
		}
		if (!targetRefId) throw new DocumentApiAdapterError("MATERIALIZATION_FAILED", `No target ${headerFooterKind} part available for section "${section.sectionId}".`, { sectionId: section.sectionId });
		exportAndSyncCache(hostEditor, storyEditor, targetRefId, headerFooterKind);
	};
}
function resolveHeaderFooterPartRuntime(hostEditor, locator) {
	const storyKey = buildStoryKey(locator);
	const converter = getConverter$1(hostEditor);
	if (!converter) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `Cannot resolve header/footer part: no converter available.`, { storyKey });
	const pmJson = findPmJsonByRefId(converter, locator.refId);
	if (!pmJson) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `No header/footer part found for refId "${locator.refId}".`, {
		storyKey,
		refId: locator.refId
	});
	const hfType = converter.headers?.[locator.refId] ? "header" : "footer";
	const liveEditor = findLiveSubEditor(converter, "headers", locator.refId) ?? findLiveSubEditor(converter, "footers", locator.refId);
	if (liveEditor) return {
		locator,
		storyKey,
		editor: liveEditor,
		kind: "headerFooter",
		commit: (hostEditor$1) => {
			exportAndSyncCache(hostEditor$1, liveEditor, locator.refId, hfType);
		},
		commitEditor: (hostEditor$1, sessionEditor) => {
			exportAndSyncCache(hostEditor$1, sessionEditor, locator.refId, hfType);
		}
	};
	const storyEditor = createHeadlessHeaderFooterEditor(hostEditor, pmJson, locator.refId);
	return createOwnedHeaderFooterRuntime(locator, storyKey, storyEditor, {
		commit: (hostEditor$1) => {
			exportAndSyncCache(hostEditor$1, storyEditor, locator.refId, hfType);
		},
		commitEditor: (hostEditor$1, sessionEditor) => {
			exportAndSyncCache(hostEditor$1, sessionEditor, locator.refId, hfType);
		}
	});
}
function exportAndSyncCache(hostEditor, subEditor, refId, hfType) {
	exportSubEditorToPart(hostEditor, subEditor, refId, hfType);
	const conv = getConverter$1(hostEditor);
	if (!conv) return;
	const pmJson = typeof subEditor.getUpdatedJson === "function" ? subEditor.getUpdatedJson() : subEditor.getJSON?.();
	if (!pmJson) return;
	const cacheKey = hfType === "header" ? "headers" : "footers";
	if (conv[cacheKey]) conv[cacheKey][refId] = pmJson;
}
function createHeadlessHeaderFooterEditor(hostEditor, pmJson, documentId) {
	return createStoryEditor(hostEditor, pmJson, {
		documentId,
		isHeaderOrFooter: true,
		headless: true
	});
}
function createOwnedHeaderFooterRuntime(locator, storyKey, editor, options) {
	return {
		locator,
		storyKey,
		editor,
		kind: "headerFooter",
		cacheable: false,
		dispose: () => editor.destroy(),
		commit: options.commit,
		commitEditor: options.commitEditor
	};
}
function readCachedHeaderFooterContent(converter, collection, refId, storyKey, headerFooterKind) {
	const pmJson = converter[collection]?.[refId];
	if (pmJson && typeof pmJson === "object") return pmJson;
	throw new DocumentApiAdapterError("STORY_NOT_FOUND", `No cached content for ${headerFooterKind} "${refId}".`, {
		storyKey,
		refId
	});
}
function createMissingSlotWriteRuntime(hostEditor, locator, storyKey) {
	const pendingEditor = createHeadlessHeaderFooterEditor(hostEditor, createEmptyHeaderFooterJsonPart(), `${storyKey}:materialization-pending`);
	return createOwnedHeaderFooterRuntime(locator, storyKey, pendingEditor, {
		commit: buildSlotCommit(locator, pendingEditor, null, true),
		commitEditor: (hostEditor$1, sessionEditor) => buildSlotCommit(locator, sessionEditor, null, true)(hostEditor$1)
	});
}
function findLiveSubEditor(converter, collection, refId) {
	const editorsList = collection === "headers" ? converter.headerEditors : converter.footerEditors;
	if (!Array.isArray(editorsList)) return null;
	return editorsList.find((item) => item.id === refId)?.editor ?? null;
}
function findPmJsonByRefId(converter, refId) {
	if (converter.headers) {
		const pmJson = converter.headers[refId];
		if (pmJson && typeof pmJson === "object") return pmJson;
	}
	if (converter.footers) {
		const pmJson = converter.footers[refId];
		if (pmJson && typeof pmJson === "object") return pmJson;
	}
	return null;
}
const FOOTNOTES_PART_ID = "word/footnotes.xml";
const ENDNOTES_PART_ID = "word/endnotes.xml";
var FOOTNOTES_CONFIG = {
	partId: FOOTNOTES_PART_ID,
	rootElementName: "w:footnotes",
	childElementName: "w:footnote",
	converterKey: "footnotes"
};
var ENDNOTES_CONFIG = {
	partId: ENDNOTES_PART_ID,
	rootElementName: "w:endnotes",
	childElementName: "w:endnote",
	converterKey: "endnotes"
};
var NOTES_XMLNS = {
	"xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
	"xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
	"xmlns:o": "urn:schemas-microsoft-com:office:office",
	"xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
	"xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
	"xmlns:v": "urn:schemas-microsoft-com:vml",
	"xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
	"xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
	"xmlns:w10": "urn:schemas-microsoft-com:office:word",
	"xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
	"xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
	"xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
	"xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
	"xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
	"xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
};
function getConverter(editor) {
	return editor.converter;
}
function getRootElement(part) {
	return part?.elements?.[0];
}
function getNoteElements(part, childElementName) {
	const root = getRootElement(part);
	if (!root?.elements) return [];
	return root.elements.filter((el) => el.name === childElementName);
}
function textToNoteOoxmlParagraphs(text$2) {
	return text$2.split(/\r?\n/).map((line) => ({
		type: "element",
		name: "w:p",
		elements: line.length > 0 ? [{
			type: "element",
			name: "w:r",
			elements: [{
				type: "element",
				name: "w:t",
				attributes: { "xml:space": "preserve" },
				elements: [{
					type: "text",
					text: line
				}]
			}]
		}] : []
	}));
}
function ensureFootnoteRefRun(elements, childElementName) {
	if (elements.length === 0) return;
	const firstParagraph = elements.find((el) => el.name === "w:p");
	if (!firstParagraph) return;
	if (!firstParagraph.elements) firstParagraph.elements = [];
	const refName = childElementName === "w:footnote" ? "w:footnoteRef" : "w:endnoteRef";
	const styleName = childElementName === "w:footnote" ? "FootnoteReference" : "EndnoteReference";
	if (firstParagraph.elements.some((el) => el.name === "w:r" && el.elements?.some((child) => child.name === refName))) return;
	const refRun = {
		type: "element",
		name: "w:r",
		elements: [{
			type: "element",
			name: "w:rPr",
			elements: [{
				type: "element",
				name: "w:rStyle",
				attributes: { "w:val": styleName }
			}, {
				type: "element",
				name: "w:vertAlign",
				attributes: { "w:val": "superscript" }
			}]
		}, {
			type: "element",
			name: refName,
			elements: []
		}]
	};
	const pPrIndex = firstParagraph.elements.findIndex((el) => el?.name === "w:pPr");
	firstParagraph.elements.splice(pPrIndex >= 0 ? pPrIndex + 1 : 0, 0, refRun);
}
function addNoteElement(part, config$43, noteId, text$2) {
	const root = getRootElement(part);
	if (!root) throw new Error(`addNoteElement: missing root element in ${config$43.partId}`);
	if (!root.elements) root.elements = [];
	if (root.elements.find((el) => el.name === config$43.childElementName && el.attributes?.["w:id"] === noteId)) throw new Error(`addNoteElement: note id "${noteId}" already exists in ${config$43.partId}`);
	const paragraphs = textToNoteOoxmlParagraphs(text$2);
	ensureFootnoteRefRun(paragraphs, config$43.childElementName);
	const noteElement = {
		type: "element",
		name: config$43.childElementName,
		attributes: { "w:id": noteId },
		elements: paragraphs
	};
	root.elements.push(noteElement);
	return noteElement;
}
function updateNoteElement(part, config$43, noteId, text$2) {
	const target = getNoteElements(part, config$43.childElementName).find((el) => el.attributes?.["w:id"] === noteId);
	if (!target) return false;
	const paragraphs = textToNoteOoxmlParagraphs(text$2);
	ensureFootnoteRefRun(paragraphs, config$43.childElementName);
	target.elements = paragraphs;
	return true;
}
function removeNoteElement(part, config$43, noteId) {
	const root = getRootElement(part);
	if (!root?.elements) return false;
	const index = root.elements.findIndex((el) => el.name === config$43.childElementName && el.attributes?.["w:id"] === noteId);
	if (index < 0) return false;
	root.elements.splice(index, 1);
	return true;
}
function rebuildDerivedCache(editor, config$43, part) {
	const converter = getConverter(editor);
	if (!converter) return;
	if (typeof converter.reimportNotePart === "function") try {
		converter[config$43.converterKey] = converter.reimportNotePart(config$43.partId);
		return;
	} catch (err$1) {
		console.warn(`[parts] reimportNotePart failed for ${config$43.partId}, using fallback:`, err$1);
	}
	const entries = getNoteElements(part, config$43.childElementName).map((el) => ({
		id: String(el.attributes?.["w:id"] ?? ""),
		type: el.attributes?.["w:type"] ?? null,
		content: [],
		originalXml: structuredClone(el)
	}));
	converter[config$43.converterKey] = entries;
}
function createInitialNotesPart(config$43) {
	return {
		declaration: { attributes: {
			version: "1.0",
			encoding: "UTF-8",
			standalone: "yes"
		} },
		elements: [{
			type: "element",
			name: config$43.rootElementName,
			attributes: { ...NOTES_XMLNS },
			elements: [{
				type: "element",
				name: config$43.childElementName,
				attributes: {
					"w:type": "separator",
					"w:id": "-1"
				},
				elements: [{
					type: "element",
					name: "w:p",
					elements: [{
						type: "element",
						name: "w:r",
						elements: [{
							type: "element",
							name: "w:separator",
							elements: []
						}]
					}]
				}]
			}, {
				type: "element",
				name: config$43.childElementName,
				attributes: {
					"w:type": "continuationSeparator",
					"w:id": "0"
				},
				elements: [{
					type: "element",
					name: "w:p",
					elements: [{
						type: "element",
						name: "w:r",
						elements: [{
							type: "element",
							name: "w:continuationSeparator",
							elements: []
						}]
					}]
				}]
			}]
		}]
	};
}
function createNotePartDescriptor(config$43) {
	return {
		id: config$43.partId,
		ensurePart() {
			return createInitialNotesPart(config$43);
		},
		normalizePart(part) {
			const root = getRootElement(part);
			if (!root?.elements) return;
			root.elements.sort((a, b) => {
				const aType = a.attributes?.["w:type"];
				const bType = b.attributes?.["w:type"];
				const aIsSpecial = aType === "separator" || aType === "continuationSeparator";
				if (aIsSpecial !== (bType === "separator" || bType === "continuationSeparator")) return aIsSpecial ? -1 : 1;
				return Number(a.attributes?.["w:id"] ?? 0) - Number(b.attributes?.["w:id"] ?? 0);
			});
		},
		afterCommit({ editor, part, source }) {
			rebuildDerivedCache(editor, config$43, part);
			clearPartCacheStale(editor, config$43.partId);
			editor.emit("notes-part-changed", {
				partId: config$43.partId,
				source
			});
		}
	};
}
const footnotesPartDescriptor = createNotePartDescriptor(FOOTNOTES_CONFIG);
const endnotesPartDescriptor = createNotePartDescriptor(ENDNOTES_CONFIG);
function getNotesConfig(type) {
	return type === "endnote" ? ENDNOTES_CONFIG : FOOTNOTES_CONFIG;
}
function bootstrapNotesPart(editor, type) {
	const converter = editor.converter;
	if (!converter?.convertedXml) return;
	const config$43 = getNotesConfig(type);
	if (converter.convertedXml[config$43.partId] !== void 0) return;
	converter.convertedXml[config$43.partId] = createInitialNotesPart(config$43);
}
function isPmJsonNode(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isEmptyRunNode(value) {
	if (!isPmJsonNode(value) || value.type !== "run") return false;
	return !Array.isArray(value.content) || value.content.length === 0;
}
function isLeadingNoteReferenceRun(value) {
	if (!isEmptyRunNode(value)) return false;
	const styleId = value.attrs?.runProperties?.styleId;
	return styleId === "FootnoteReference" || styleId === "EndnoteReference";
}
function isWhitespaceOnlyTextNode(value) {
	return isPmJsonNode(value) && value.type === "text" && typeof value.text === "string" && /^\s*$/.test(value.text);
}
function isInvisibleNotePassthroughNode(value) {
	return isPmJsonNode(value) && value.type === "passthroughInline";
}
function stripLeadingWhitespaceFromTextNode(value) {
	if (!isPmJsonNode(value) || value.type !== "text" || typeof value.text !== "string") return value;
	const trimmed = value.text.replace(/^\s+/, "");
	if (trimmed.length === 0) return null;
	return trimmed === value.text ? value : {
		...value,
		text: trimmed
	};
}
function stripLeadingNoteSeparatorFromRun(value) {
	if (!isPmJsonNode(value) || value.type !== "run" || !Array.isArray(value.content)) return value;
	const remainingContent = [...value.content];
	while (remainingContent.length > 0) {
		const firstChild = remainingContent[0];
		if (isPmJsonNode(firstChild) && firstChild.type === "tab") {
			remainingContent.shift();
			continue;
		}
		if (isWhitespaceOnlyTextNode(firstChild)) {
			remainingContent.shift();
			continue;
		}
		const normalizedFirstChild = stripLeadingWhitespaceFromTextNode(firstChild);
		if (normalizedFirstChild == null) {
			remainingContent.shift();
			continue;
		}
		remainingContent[0] = normalizedFirstChild;
		break;
	}
	if (remainingContent.length === 0) return null;
	return {
		...value,
		content: remainingContent
	};
}
function stripLeadingNoteSeparatorChildren(children) {
	const remainingChildren = [...children];
	while (remainingChildren.length > 0) {
		const firstChild = remainingChildren[0];
		if (!isPmJsonNode(firstChild)) break;
		if (firstChild.type === "run") {
			const normalizedRun = stripLeadingNoteSeparatorFromRun(firstChild);
			if (normalizedRun == null) {
				remainingChildren.shift();
				continue;
			}
			remainingChildren[0] = normalizedRun;
			break;
		}
		if (firstChild.type === "tab" || isWhitespaceOnlyTextNode(firstChild)) {
			remainingChildren.shift();
			continue;
		}
		const normalizedText = stripLeadingWhitespaceFromTextNode(firstChild);
		if (normalizedText == null) {
			remainingChildren.shift();
			continue;
		}
		remainingChildren[0] = normalizedText;
		break;
	}
	return remainingChildren;
}
function normalizeNotePmNode(value) {
	if (!isPmJsonNode(value)) return value;
	const normalized = { ...value };
	if (!Array.isArray(value.content)) return normalized;
	const originalChildren = value.content;
	const normalizedChildren = originalChildren.map((child) => normalizeNotePmNode(child)).filter((child) => !isInvisibleNotePassthroughNode(child)).filter((child) => !(value.type === "paragraph" && isEmptyRunNode(child)));
	if (value.type === "paragraph" && originalChildren[0] && isLeadingNoteReferenceRun(originalChildren[0])) {
		normalized.content = stripLeadingNoteSeparatorChildren(normalizedChildren);
		return normalized;
	}
	normalized.content = normalizedChildren;
	return normalized;
}
function normalizeNotePmJson(docJson) {
	const normalized = normalizeNotePmNode(docJson);
	return isPmJsonNode(normalized) ? normalized : docJson;
}
function resolveNoteRuntime(hostEditor, locator) {
	const storyKey = buildStoryKey(locator);
	const converter = hostEditor.converter;
	if (!converter) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `Cannot resolve ${locator.storyType} story: no converter available.`, { storyKey });
	const isFootnote = locator.storyType === "footnote";
	const noteId = locator.noteId;
	const pmJson = extractNotePmJson(converter, isFootnote, noteId);
	if (!pmJson) throw new DocumentApiAdapterError("STORY_NOT_FOUND", `${isFootnote ? "Footnote" : "Endnote"} "${noteId}" not found.`, {
		storyKey,
		noteId
	});
	const storyEditor = createStoryEditor(hostEditor, pmJson, {
		documentId: `${locator.storyType}:${noteId}`,
		isHeaderOrFooter: false,
		headless: true
	});
	return {
		locator,
		storyKey,
		editor: storyEditor,
		kind: "note",
		dispose: () => storyEditor.destroy(),
		commit: (hostEditor$1) => {
			commitNoteRuntime(hostEditor$1, storyEditor, locator, isFootnote);
		},
		commitEditor: (hostEditor$1, sessionEditor) => {
			commitNoteRuntime(hostEditor$1, sessionEditor, locator, isFootnote);
		}
	};
}
function commitNoteRuntime(hostEditor, storyEditor, locator, isFootnote) {
	const notesConfig = getNotesConfig(isFootnote ? "footnote" : "endnote");
	const conv = hostEditor.converter;
	const pmJson = typeof storyEditor.getUpdatedJson === "function" ? storyEditor.getUpdatedJson() : storyEditor.getJSON();
	if (conv?.exportToXmlJson && pmJson) {
		let ooxmlElements = null;
		try {
			const { result } = conv.exportToXmlJson({
				data: pmJson,
				editor: storyEditor,
				editorSchema: storyEditor.schema,
				isHeaderFooter: true,
				comments: [],
				commentDefinitions: []
			});
			ooxmlElements = (result?.elements?.[0])?.elements ?? null;
		} catch {}
		if (ooxmlElements && ooxmlElements.length > 0) {
			mutatePart({
				editor: hostEditor,
				partId: notesConfig.partId,
				operation: "mutate",
				source: `story-runtime:commit:${locator.storyType}`,
				mutate({ part }) {
					updateNoteContentFromOoxml(part, notesConfig, locator.noteId, ooxmlElements);
				}
			});
			return;
		}
	}
	const doc$2 = storyEditor.state.doc;
	const text$2 = doc$2.textBetween(0, doc$2.content.size, "\n", "\n");
	mutatePart({
		editor: hostEditor,
		partId: notesConfig.partId,
		operation: "mutate",
		source: `story-runtime:commit:${locator.storyType}`,
		mutate({ part }) {
			updateNoteElement(part, notesConfig, locator.noteId, text$2);
		}
	});
}
function extractNotePmJson(converter, isFootnote, noteId) {
	const collection = isFootnote ? converter.footnotes : converter.endnotes;
	if (!Array.isArray(collection)) return null;
	const note = collection.find((item) => String(item.id) === String(noteId));
	if (!note) return null;
	if (Array.isArray(note.content)) return normalizeNotePmJson({
		type: "doc",
		content: note.content.length > 0 ? note.content : [{ type: "paragraph" }]
	});
	if (note.doc && typeof note.doc === "object") return normalizeNotePmJson(note.doc);
	if (note.type === "doc" || note.type === "footnoteBody" || note.type === "endnoteBody") return normalizeNotePmJson(note);
	return null;
}
function updateNoteContentFromOoxml(part, config$43, noteId, contentElements) {
	const target = getNoteElements(part, config$43.childElementName).find((el) => el.attributes?.["w:id"] === noteId);
	if (!target) return false;
	const elements = contentElements;
	ensureFootnoteRefRun(elements, config$43.childElementName);
	target.elements = elements;
	return true;
}
var storeByEditor = /* @__PURE__ */ new WeakMap();
function initStoryRevisionStore(editor) {
	const existing = storeByEditor.get(editor);
	if (existing) return existing;
	const store = { counters: /* @__PURE__ */ new Map() };
	storeByEditor.set(editor, store);
	return store;
}
function getStoryRevisionStore(editor) {
	return storeByEditor.get(editor);
}
function getStoryRevision(store, storyKey) {
	const rev = store.counters.get(storyKey) ?? 0;
	return String(rev);
}
function incrementStoryRevision(store, storyKey) {
	const next = (store.counters.get(storyKey) ?? 0) + 1;
	store.counters.set(storyKey, next);
	return String(next);
}
var liveSessionsByHost = /* @__PURE__ */ new WeakMap();
function getOrCreateLiveSessionMap(hostEditor) {
	let sessions = liveSessionsByHost.get(hostEditor);
	if (!sessions) {
		sessions = /* @__PURE__ */ new Map();
		liveSessionsByHost.set(hostEditor, sessions);
	}
	return sessions;
}
function buildLiveSessionRuntime(registration) {
	const { runtime, editor } = registration;
	return {
		...runtime,
		editor,
		cacheable: false,
		commit: runtime.commitEditor == null ? runtime.commit : (hostEditor) => {
			runtime.commitEditor?.(hostEditor, editor);
		}
	};
}
function registerLiveStorySessionRuntime(hostEditor, runtime, editor) {
	const sessions = getOrCreateLiveSessionMap(hostEditor);
	const storyKey = runtime.storyKey;
	sessions.set(storyKey, {
		storyKey,
		editor,
		runtime
	});
	return () => {
		unregisterLiveStorySessionRuntime(hostEditor, storyKey, editor);
	};
}
function resolveLiveStorySessionRuntime(hostEditor, storyKey) {
	const registration = liveSessionsByHost.get(hostEditor)?.get(storyKey);
	if (!registration) return null;
	return buildLiveSessionRuntime(registration);
}
function commitLiveStorySessionRuntimes(hostEditor) {
	const sessions = liveSessionsByHost.get(hostEditor);
	if (!sessions || sessions.size === 0) return 0;
	let committedCount = 0;
	for (const registration of [...sessions.values()]) {
		buildLiveSessionRuntime(registration).commit?.(hostEditor);
		committedCount += 1;
	}
	return committedCount;
}
function unregisterLiveStorySessionRuntime(hostEditor, storyKey, editor) {
	const sessions = liveSessionsByHost.get(hostEditor);
	if (!sessions) return;
	const registration = sessions.get(storyKey);
	if (!registration) return;
	if (editor && registration.editor !== editor) return;
	sessions.delete(storyKey);
	if (sessions.size === 0) liveSessionsByHost.delete(hostEditor);
}
var cacheByHost = /* @__PURE__ */ new WeakMap();
var hostStoreSyncedKeys = /* @__PURE__ */ new WeakMap();
function hasHostStoreSyncListener(editor, storyKey) {
	return hostStoreSyncedKeys.get(editor)?.has(storyKey) ?? false;
}
function markHostStoreSyncListener(editor, storyKey) {
	let keys$1 = hostStoreSyncedKeys.get(editor);
	if (!keys$1) {
		keys$1 = /* @__PURE__ */ new Set();
		hostStoreSyncedKeys.set(editor, keys$1);
	}
	keys$1.add(storyKey);
}
function getOrCreateCache(hostEditor) {
	let cache = cacheByHost.get(hostEditor);
	if (!cache) {
		cache = new StoryRuntimeCache();
		cacheByHost.set(hostEditor, cache);
		subscribeToPartChanges(hostEditor);
	}
	return cache;
}
function subscribeToPartChanges(hostEditor) {
	if (typeof hostEditor.on !== "function") return;
	hostEditor.on("notes-part-changed", () => {
		const cache = cacheByHost.get(hostEditor);
		if (!cache) return;
		cache.invalidateByPrefix("fn:");
		cache.invalidateByPrefix("en:");
	});
	hostEditor.on("partChanged", (event) => {
		const cache = cacheByHost.get(hostEditor);
		if (!cache) return;
		if (event.parts.some((p) => isHeaderFooterPartId(p.partId))) cache.invalidateByPrefix("hf:");
	});
}
var BODY_LOCATOR = {
	kind: "story",
	storyType: "body"
};
function createBodyRuntime(hostEditor) {
	return {
		locator: BODY_LOCATOR,
		storyKey: BODY_STORY_KEY,
		editor: hostEditor,
		kind: "body"
	};
}
function resolveStoryRuntime(hostEditor, locator, options = {}) {
	if (locator === void 0 || locator.storyType === "body") return resolveBodyRuntime(hostEditor);
	const storyKey = buildStoryKey(locator);
	const liveSessionRuntime = resolveLiveStorySessionRuntime(hostEditor, storyKey);
	if (liveSessionRuntime) return liveSessionRuntime;
	const cache = getOrCreateCache(hostEditor);
	const cached = cache.get(storyKey);
	if (cached) return cached;
	let runtime;
	switch (locator.storyType) {
		case "headerFooterSlot":
			runtime = resolveHeaderFooterSlotRuntime(hostEditor, locator, options);
			break;
		case "headerFooterPart":
			runtime = resolveHeaderFooterPartRuntime(hostEditor, locator);
			break;
		case "footnote":
		case "endnote":
			runtime = resolveNoteRuntime(hostEditor, locator);
			break;
		default: {
			const _exhaustive = locator;
			throw new DocumentApiAdapterError("INVALID_INPUT", `Unknown story type on locator: ${JSON.stringify(_exhaustive)}`);
		}
	}
	initRevision(runtime.editor);
	const store = getStoryRevisionStore(hostEditor);
	if (store) {
		const currentStoreRevision = getStoryRevision(store, storyKey);
		restoreRevision(runtime.editor, currentStoreRevision);
	}
	trackRevisions(runtime.editor);
	if (store && !hasHostStoreSyncListener(runtime.editor, storyKey)) {
		markHostStoreSyncListener(runtime.editor, storyKey);
		runtime.editor.on("transaction", ({ transaction }) => {
			if (transaction.getMeta?.("superdoc/block-identity-repair")) return;
			if (transaction.docChanged) incrementStoryRevision(store, storyKey);
		});
	}
	if (runtime.cacheable !== false) cache.set(storyKey, runtime);
	return runtime;
}
function resolveBodyRuntime(hostEditor) {
	const cache = getOrCreateCache(hostEditor);
	const cached = cache.get(BODY_STORY_KEY);
	if (cached) return cached;
	const runtime = createBodyRuntime(hostEditor);
	cache.set(BODY_STORY_KEY, runtime);
	return runtime;
}
function getStoryRuntimeCache(hostEditor) {
	return cacheByHost.get(hostEditor);
}
function getTextAdapter(editor, input) {
	const doc$2 = resolveStoryRuntime(editor, input.in).editor.state.doc;
	return textBetweenWithTabs(doc$2, 0, doc$2.content.size, "\n", "\n", { textModel: "visible" });
}
var documentHelpers_exports = /* @__PURE__ */ __export({
	findChildren: () => findChildren,
	findInlineNodes: () => findInlineNodes,
	findMarkPosition: () => findMarkPosition,
	flatten: () => flatten
}, 1);
const findMarkPosition = (doc$2, pos, markName) => {
	const $pos = doc$2.resolve(pos);
	const parent = $pos.parent;
	const start = parent.childAfter($pos.parentOffset);
	if (!start.node) return null;
	const actualMark = start.node.marks.find((mark) => mark.type.name === markName);
	if (!actualMark) return null;
	let startIndex = $pos.index();
	let startPos = $pos.start() + start.offset;
	while (startIndex > 0 && actualMark.isInSet(parent.child(startIndex - 1).marks)) startPos -= parent.child(--startIndex).nodeSize;
	let endIndex = $pos.index() + 1;
	let endPos = $pos.start() + start.offset + start.node.nodeSize;
	while (endIndex < parent.childCount && actualMark.isInSet(parent.child(endIndex).marks)) endPos += parent.child(endIndex++).nodeSize;
	return {
		from: startPos,
		to: endPos,
		attrs: actualMark.attrs
	};
};
const flatten = (node, descend = true) => {
	if (!node) throw new Error("Invalid \"node\" parameter");
	const result = [];
	node.descendants((child, pos) => {
		result.push({
			node: child,
			pos
		});
		if (!descend) return false;
	});
	return result;
};
const findChildren = (node, predicate, descend) => {
	if (!node) throw new Error("Invalid \"node\" parameter");
	else if (!predicate) throw new Error("Invalid \"predicate\" parameter");
	return flatten(node, descend).filter((child) => predicate(child.node));
};
const findInlineNodes = (node, descend) => {
	return findChildren(node, (child) => child.isInline, descend);
};
const getTrackChanges = (state, id = null) => {
	const trackedChanges = [];
	if (!state?.doc) return trackedChanges;
	const allInlineNodes = findInlineNodes(state.doc);
	if (!allInlineNodes.length) return trackedChanges;
	allInlineNodes.forEach(({ node, pos }) => {
		const { marks } = node;
		const trackedMarks = [
			TrackInsertMarkName,
			TrackDeleteMarkName,
			TrackFormatMarkName
		];
		if (marks.length > 0) marks.forEach((mark) => {
			if (trackedMarks.includes(mark.type.name)) trackedChanges.push({
				mark,
				node,
				from: pos,
				to: pos + node.nodeSize
			});
		});
	});
	if (id) return trackedChanges.filter(({ mark }) => mark.attrs.id === id);
	return trackedChanges;
};
const enumerateStructuralRowChanges = (state) => {
	const doc$2 = state?.doc;
	if (!doc$2) return [];
	const out = [];
	try {
		doc$2.descendants((node, pos) => {
			if (node.type?.name !== "table") return void 0;
			collectTableStructuralChanges({
				table: node,
				tablePos: pos,
				out
			});
			return true;
		});
	} catch {
		return out;
	}
	return out;
};
var collectTableStructuralChanges = ({ table, tablePos, out }) => {
	const tableFrom = tablePos;
	const tableTo = tablePos + table.nodeSize;
	const trackedRows = [];
	let totalRows = 0;
	let offset = 1;
	table.forEach((child) => {
		const childFrom = tablePos + offset;
		offset += child.nodeSize;
		if (child.type?.name !== "tableRow") return;
		totalRows += 1;
		const tc = child.attrs?.trackChange;
		if (!tc || tc.type !== "rowInsert" && tc.type !== "rowDelete") return;
		const side$1 = tc.type === "rowInsert" ? "insertion" : "deletion";
		trackedRows.push({
			ref: {
				pos: childFrom,
				from: childFrom,
				to: childFrom + child.nodeSize,
				node: child
			},
			side: side$1,
			tc
		});
	});
	if (trackedRows.length === 0) return;
	const sides = new Set(trackedRows.map((r) => r.side));
	const everyRowTracked = trackedRows.length === totalRows && totalRows > 0;
	const singleSide = sides.size === 1;
	if (everyRowTracked && singleSide) {
		const side$1 = trackedRows[0].side;
		const primary$1 = trackedRows[0].tc;
		const representativeRevisionId$1 = stringOf(primary$1.id) || stringOf(primary$1.sourceId);
		const publicId = stringOf(primary$1.sourceId) || representativeRevisionId$1 || `table:${tableFrom}:${side$1}`;
		out.push({
			id: publicId,
			revisionId: representativeRevisionId$1,
			side: side$1,
			subtype: side$1 === "insertion" ? "table-insert" : "table-delete",
			tableFrom,
			tableTo,
			tablePos,
			wholeTable: true,
			decidable: true,
			rows: trackedRows.map((r) => r.ref),
			author: stringOf(primary$1.author),
			authorEmail: stringOf(primary$1.authorEmail),
			authorImage: stringOf(primary$1.authorImage),
			date: stringOf(primary$1.date),
			importedAuthor: stringOf(primary$1.importedAuthor),
			sourceId: stringOf(primary$1.sourceId),
			revisionGroupId: stringOf(primary$1.revisionGroupId) || representativeRevisionId$1 || publicId
		});
		return;
	}
	const side = trackedRows[0].side;
	const primary = trackedRows[0].tc;
	const representativeRevisionId = stringOf(primary.id) || stringOf(primary.sourceId);
	const reason = !everyRowTracked ? "partial-rows" : "mixed-sides";
	out.push({
		id: stringOf(primary.sourceId) || representativeRevisionId || `table:${tableFrom}:${side}`,
		revisionId: representativeRevisionId,
		side,
		subtype: side === "insertion" ? "table-insert" : "table-delete",
		tableFrom,
		tableTo,
		tablePos,
		wholeTable: false,
		decidable: false,
		undecidableReason: reason,
		rows: trackedRows.map((r) => r.ref),
		author: stringOf(primary.author),
		authorEmail: stringOf(primary.authorEmail),
		authorImage: stringOf(primary.authorImage),
		date: stringOf(primary.date),
		importedAuthor: stringOf(primary.importedAuthor),
		sourceId: stringOf(primary.sourceId),
		revisionGroupId: stringOf(primary.revisionGroupId) || representativeRevisionId
	});
};
var stringOf = (value) => typeof value === "string" ? value : value == null ? "" : String(value);
function projectInternalTrackChangeType(type, structural) {
	if (type !== "structural") return type;
	if (structural?.subtype === "table-delete" || structural?.side === "deletion") return "delete";
	return "insert";
}
function rangesOverlap(a, b) {
	return a[0] < b[1] && b[0] < a[1];
}
function getRawTrackedMarks(editor) {
	try {
		const marks = getTrackChanges(editor.state);
		return Array.isArray(marks) ? marks : [];
	} catch {
		return [];
	}
}
function deriveTrackedChangeId(change) {
	return change.rawId;
}
function resolveTrackedChangeType(change) {
	if (change.structural) return "structural";
	if (change.hasFormat) return "format";
	if (change.hasInsert && change.hasDelete) return "replacement";
	if (change.hasDelete) return "delete";
	return "insert";
}
var groupedCache = /* @__PURE__ */ new WeakMap();
function readReplacementsMode(editor) {
	return editor?.options?.trackedChanges?.replacements === "independent" ? "independent" : "paired";
}
function mergeWordRevisionId(target, key, value) {
	if (!value) return target;
	if (!target) return { [key]: value };
	if (!target[key]) target[key] = value;
	return target;
}
function getWordRevisionIdKey(markType) {
	if (markType === "trackInsert") return "insert";
	if (markType === "trackDelete") return "delete";
	if (markType === "trackFormat") return "format";
	return null;
}
function getTrackedChangeGroupKey(attrs, markType, fallbackId) {
	const sourceId = toNonEmptyString(attrs.sourceId);
	return sourceId ? `word:${markType}:${sourceId}` : fallbackId;
}
function isTrackedMarkName(markType) {
	return markType === "trackInsert" || markType === "trackDelete" || markType === "trackFormat";
}
function getTrackedChangeAliasCandidates(change) {
	const candidates = [
		change.rawId,
		change.commandRawId,
		change.id,
		toNonEmptyString(change.attrs.id),
		toNonEmptyString(change.attrs.replacementGroupId),
		toNonEmptyString(change.attrs.sourceId)
	];
	return Array.from(new Set(candidates.filter((value) => Boolean(value))));
}
function replacementPairKey(change) {
	if (change.hasInsert === change.hasDelete) return null;
	const replacementGroupId = toNonEmptyString(change.attrs.replacementGroupId);
	if (replacementGroupId) return `group:${replacementGroupId}`;
	if (change.commandRawId) return `command:${change.commandRawId}`;
	return null;
}
function buildPublicTrackedChangeIdMap(grouped, replacements) {
	const publicIdByChange = /* @__PURE__ */ new Map();
	if (replacements === "paired") {
		const byPairKey = /* @__PURE__ */ new Map();
		for (const change of grouped) {
			if (change.hasInsert && change.hasDelete) continue;
			const key = replacementPairKey(change);
			if (!key) continue;
			const bucket = byPairKey.get(key) ?? [];
			bucket.push(change);
			byPairKey.set(key, bucket);
		}
		for (const group of byPairKey.values()) {
			const inserted = group.find((change) => change.hasInsert && !change.hasDelete);
			const deleted = group.find((change) => change.hasDelete && !change.hasInsert);
			if (!inserted || !deleted) continue;
			publicIdByChange.set(inserted, inserted.id);
			publicIdByChange.set(deleted, inserted.id);
		}
	}
	for (const change of grouped) if (!publicIdByChange.has(change)) publicIdByChange.set(change, change.id);
	return publicIdByChange;
}
function layerFromChange(change, relationship) {
	const type = resolveTrackedChangeType(change);
	return {
		id: change.id,
		rawId: change.rawId,
		commandRawId: change.commandRawId,
		type: projectInternalTrackChangeType(type, change.structural),
		relationship
	};
}
function compareOverlapChildren(a, b) {
	const aType = projectInternalTrackChangeType(resolveTrackedChangeType(a), a.structural);
	const bType = projectInternalTrackChangeType(resolveTrackedChangeType(b), b.structural);
	if (aType !== bType) {
		if (aType === "delete") return -1;
		if (bType === "delete") return 1;
	}
	if (a.from !== b.from) return a.from - b.from;
	return a.id.localeCompare(b.id);
}
function attachOverlapMetadata(grouped) {
	if (grouped.length < 2) return;
	const byAlias = /* @__PURE__ */ new Map();
	for (const change of grouped) for (const alias of getTrackedChangeAliasCandidates(change)) if (!byAlias.has(alias)) byAlias.set(alias, change);
	const childrenByParent = /* @__PURE__ */ new Map();
	for (const child of grouped) {
		const parentRef = toNonEmptyString(child.attrs.overlapParentId);
		if (!parentRef) continue;
		const parent = byAlias.get(parentRef);
		if (!parent || parent === child) continue;
		const children = childrenByParent.get(parent) ?? [];
		children.push(child);
		childrenByParent.set(parent, children);
	}
	for (const [parent, children] of childrenByParent.entries()) {
		const orderedChildren = children.slice().sort(compareOverlapChildren);
		const visualLayers = [layerFromChange(parent, "parent"), ...orderedChildren.map((child) => layerFromChange(child, "child"))];
		const preferredContextTarget = visualLayers.find((layer) => layer.relationship === "child" && layer.type === "delete") ?? visualLayers.find((layer) => layer.relationship === "child");
		parent.overlap = {
			visualLayers,
			...preferredContextTarget ? {
				preferredContextTargetId: preferredContextTarget.id,
				preferredContextTarget
			} : {}
		};
	}
}
function getTrackedChangeMarkAlias(mark) {
	const markType = mark.type.name;
	if (!isTrackedMarkName(markType)) return null;
	const attrs = mark.attrs ?? {};
	const id = toNonEmptyString(attrs.id);
	if (!id) return null;
	return getTrackedChangeGroupKey(attrs, markType, id);
}
function hasChildTrackedMarkOnNode(item, parentId) {
	if (!parentId) return false;
	return (Array.isArray(item.node?.marks) ? item.node.marks : []).some((mark) => {
		const markType = mark?.type?.name;
		if (!isTrackedMarkName(markType)) return false;
		return toNonEmptyString(mark?.attrs?.overlapParentId) === parentId;
	});
}
function getTrackedMarkText(editor, item) {
	const nodeText = item.node?.text;
	if (typeof nodeText === "string") return nodeText;
	return editor.state.doc.textBetween(item.from, item.to, " ", "￼");
}
function groupTrackedChanges(editor) {
	const currentDoc = editor.state.doc;
	const cached = groupedCache.get(editor);
	if (cached && cached.doc === currentDoc) return cached.grouped;
	const marks = getRawTrackedMarks(editor);
	const byRawId = /* @__PURE__ */ new Map();
	const segmentsByRawId = /* @__PURE__ */ new Map();
	for (const item of marks) {
		const attrs = item.mark?.attrs ?? {};
		const id = toNonEmptyString(attrs.id);
		if (!id) continue;
		const markType = item.mark.type.name;
		const groupKey = getTrackedChangeGroupKey(attrs, markType, id);
		const existing = byRawId.get(groupKey);
		const nextHasInsert = markType === TrackInsertMarkName;
		const nextHasDelete = markType === TrackDeleteMarkName;
		const nextHasFormat = markType === TrackFormatMarkName;
		const wordRevisionId = toNonEmptyString(attrs.sourceId);
		const wordRevisionIdKey = getWordRevisionIdKey(markType);
		const excerptText = !wordRevisionId || !hasChildTrackedMarkOnNode(item, id) ? getTrackedMarkText(editor, item) : "";
		const range = [item.from, item.to];
		const priorSegments = segmentsByRawId.get(groupKey);
		if (priorSegments) priorSegments.push({
			from: item.from,
			to: item.to
		});
		else segmentsByRawId.set(groupKey, [{
			from: item.from,
			to: item.to
		}]);
		if (!existing) {
			byRawId.set(groupKey, {
				rawId: groupKey,
				commandRawId: id,
				from: item.from,
				to: item.to,
				hasInsert: nextHasInsert,
				hasDelete: nextHasDelete,
				hasFormat: nextHasFormat,
				attrs: { ...attrs },
				excerptParts: excerptText ? [excerptText] : [],
				excerptRanges: excerptText ? [range] : [],
				wordRevisionIds: wordRevisionIdKey ? mergeWordRevisionId(void 0, wordRevisionIdKey, wordRevisionId ?? void 0) : void 0
			});
			continue;
		}
		existing.from = Math.min(existing.from, item.from);
		existing.to = Math.max(existing.to, item.to);
		existing.hasInsert = existing.hasInsert || nextHasInsert;
		existing.hasDelete = existing.hasDelete || nextHasDelete;
		existing.hasFormat = existing.hasFormat || nextHasFormat;
		if (Object.keys(existing.attrs).length === 0 && Object.keys(attrs).length > 0) existing.attrs = { ...attrs };
		if (excerptText && !existing.excerptRanges.some((counted) => rangesOverlap(counted, range))) {
			existing.excerptRanges.push(range);
			existing.excerptParts.push(excerptText);
		}
		if (wordRevisionIdKey) existing.wordRevisionIds = mergeWordRevisionId(existing.wordRevisionIds, wordRevisionIdKey, wordRevisionId ?? void 0);
	}
	const grouped = Array.from(byRawId.values()).map(({ excerptParts, excerptRanges: _excerptRanges, ...change }) => {
		const hasWordSourceId = Boolean(toNonEmptyString(change.attrs.sourceId));
		const rawExcerpt = excerptParts.join("");
		const withExcerpt = {
			...change,
			excerpt: excerptParts.length > 0 ? rawExcerpt : hasWordSourceId ? "" : void 0
		};
		return {
			...withExcerpt,
			id: deriveTrackedChangeId(withExcerpt)
		};
	}).sort((a, b) => {
		if (a.from !== b.from) return a.from - b.from;
		return a.id.localeCompare(b.id);
	});
	attachOverlapMetadata(grouped);
	const structuralChanges = enumerateStructuralRowChanges(editor.state);
	const wholeTableRanges = structuralChanges.filter((structural) => structural.decidable && structural.wholeTable).map((structural) => ({
		from: structural.tableFrom,
		to: structural.tableTo
	}));
	if (wholeTableRanges.length > 0) {
		const segmentInsideSomeTable = (segment) => wholeTableRanges.some((range) => segment.from >= range.from && segment.to <= range.to);
		for (let i$1 = grouped.length - 1; i$1 >= 0; i$1 -= 1) {
			const change = grouped[i$1];
			if ((segmentsByRawId.get(change.rawId) ?? [{
				from: change.from,
				to: change.to
			}]).every(segmentInsideSomeTable)) grouped.splice(i$1, 1);
		}
	}
	for (const structural of structuralChanges) {
		const excerpt = normalizeExcerpt(editor.state.doc.textBetween(structural.tableFrom, structural.tableTo, " ", "￼"));
		const stableRawId = structural.sourceId ? `word:structural:${structural.sourceId}` : structural.id;
		grouped.push({
			rawId: stableRawId,
			commandRawId: structural.id,
			id: stableRawId,
			from: structural.tableFrom,
			to: structural.tableTo,
			hasInsert: false,
			hasDelete: false,
			hasFormat: false,
			structural: {
				side: structural.side,
				subtype: structural.subtype
			},
			attrs: {
				id: structural.id,
				sourceId: structural.sourceId || void 0,
				author: structural.author || void 0,
				authorEmail: structural.authorEmail || void 0,
				authorImage: structural.authorImage || void 0,
				date: structural.date || void 0,
				importedAuthor: structural.importedAuthor || void 0,
				origin: structural.sourceId ? "word" : void 0,
				revisionGroupId: structural.revisionGroupId || void 0
			},
			excerpt,
			wordRevisionIds: structural.sourceId ? structural.side === "insertion" ? { insert: structural.sourceId } : { delete: structural.sourceId } : void 0
		});
	}
	grouped.sort((a, b) => {
		if (a.from !== b.from) return a.from - b.from;
		return a.id.localeCompare(b.id);
	});
	groupedCache.set(editor, {
		doc: currentDoc,
		grouped
	});
	return grouped;
}
function resolveTrackedChange(editor, id) {
	const { baseId } = splitProjectedTrackedChangeId(id);
	return groupTrackedChanges(editor).find((item) => item.id === baseId) ?? null;
}
function buildTrackedChangeCanonicalIdMap(editor) {
	const grouped = groupTrackedChanges(editor);
	const publicIdByChange = buildPublicTrackedChangeIdMap(grouped, readReplacementsMode(editor));
	const map = /* @__PURE__ */ new Map();
	for (const change of grouped) {
		const publicId = publicIdByChange.get(change) ?? change.id;
		map.set(change.rawId, publicId);
		map.set(change.id, publicId);
		if (change.commandRawId) map.set(change.commandRawId, publicId);
		const replacementGroupId = toNonEmptyString(change.attrs.replacementGroupId);
		if (replacementGroupId) map.set(replacementGroupId, publicId);
		map.set(publicId, publicId);
		map.set(`${publicId}#inserted`, publicId);
		map.set(`${publicId}#deleted`, publicId);
	}
	return map;
}
function splitProjectedTrackedChangeId(value) {
	if (value.endsWith("#inserted")) return {
		baseId: value.slice(0, -9),
		side: "inserted"
	};
	if (value.endsWith("#deleted")) return {
		baseId: value.slice(0, -8),
		side: "deleted"
	};
	return {
		baseId: value,
		side: null
	};
}
function toAddress(input) {
	if (typeof input === "string") return {
		kind: "entity",
		entityType: "trackedChange",
		entityId: input
	};
	return input;
}
function resolveTrackedChangeInStory(hostEditor, input) {
	const address = toAddress(input);
	const entityId = address.entityId;
	const story = address.story ?? {
		kind: "story",
		storyType: "body"
	};
	if ((address.story ? buildStoryKey(address.story) : "body") === "body") {
		const match$1 = findMatchingChange(hostEditor, entityId);
		if (!match$1) return null;
		return {
			editor: hostEditor,
			story,
			runtimeRef: {
				storyKey: BODY_STORY_KEY,
				rawId: match$1.rawId
			},
			change: match$1
		};
	}
	let runtime;
	try {
		runtime = resolveStoryRuntime(hostEditor, story);
	} catch {
		return null;
	}
	const match = findMatchingChange(runtime.editor, entityId);
	if (!match) return null;
	return {
		editor: runtime.editor,
		story: runtime.locator,
		runtimeRef: {
			storyKey: runtime.storyKey,
			rawId: match.rawId
		},
		change: match,
		commit: runtime.commit
	};
}
function findMatchingChange(editor, id) {
	const { baseId } = splitProjectedTrackedChangeId(id);
	return groupTrackedChanges(editor).find((item) => item.id === baseId || item.rawId === baseId || item.commandRawId === baseId) ?? null;
}
const SDT_NODE_NAMES = ["structuredContent", "structuredContentBlock"];
const SDT_BLOCK_NAME = "structuredContentBlock";
const SDT_INLINE_NAME = "structuredContent";
function isSdtNode(node) {
	return SDT_NODE_NAMES.includes(node.type.name);
}
function findAllSdtNodes(doc$2) {
	const results = [];
	doc$2.descendants((node, pos) => {
		if (isSdtNode(node)) results.push({
			node,
			pos,
			kind: node.type.name === "structuredContentBlock" ? "block" : "inline"
		});
		return true;
	});
	return results;
}
function resolveSdtByTarget(doc$2, target) {
	const nodeId = target.nodeId;
	const matches$1 = findAllSdtNodes(doc$2).filter((sdt) => String(sdt.node.attrs.id) === nodeId);
	if (matches$1.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Content control with id "${nodeId}" not found.`, { target });
	if (matches$1.length > 1) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple content controls found with id "${nodeId}".`, {
		target,
		count: matches$1.length
	});
	return matches$1[0];
}
function findSdtPrChild(sdtPr, childName) {
	return sdtPr?.elements?.find((el) => el.name === childName);
}
function getSdtPrChildAttrs(sdtPr, childName) {
	return findSdtPrChild(sdtPr, childName)?.attributes;
}
function upsertSdtPrChild(sdtPr, childName, replacement) {
	const elements = sdtPr.elements ? [...sdtPr.elements] : [];
	const idx = elements.findIndex((el) => el.name === childName);
	if (idx >= 0) elements[idx] = replacement;
	else elements.push(replacement);
	return {
		...sdtPr,
		elements
	};
}
function removeSdtPrChild(sdtPr, childName) {
	if (!sdtPr.elements) return sdtPr;
	return {
		...sdtPr,
		elements: sdtPr.elements.filter((el) => el.name !== childName)
	};
}
var SDT_NODE_TYPES = new Set(SDT_NODE_NAMES);
function applyAttrsUpdate(editor, nodeId, attrsPatch) {
	if (!editor?.state) return false;
	let foundPos = null;
	editor.state.doc.descendants((node, pos) => {
		if (foundPos !== null) return false;
		if (SDT_NODE_TYPES.has(node.type.name) && String(node.attrs.id) === String(nodeId)) {
			foundPos = pos;
			return false;
		}
		return true;
	});
	if (foundPos === null) return false;
	const tr = editor.state.tr;
	for (const [key, value] of Object.entries(attrsPatch)) tr.setNodeAttribute(foundPos, key, value);
	if (tr.steps.length === 0) return true;
	if (editor.view?.dispatch) editor.view.dispatch(tr);
	else if (typeof editor.dispatch === "function") editor.dispatch(tr);
	else return false;
	return true;
}
function updateSdtPrChild(editor, target, childName, updater) {
	const currentSdtPr = resolveSdtByTarget(editor.state.doc, target).node.attrs.sdtPr ?? {
		name: "w:sdtPr",
		elements: []
	};
	const replacement = updater(findSdtPrChild(currentSdtPr, childName));
	let newSdtPr;
	if (replacement === null) newSdtPr = removeSdtPrChild(currentSdtPr, childName);
	else newSdtPr = upsertSdtPrChild(currentSdtPr, childName, replacement);
	return applyAttrsUpdate(editor, target.nodeId, { sdtPr: newSdtPr });
}
function updateSdtPrSubElementAttr(editor, target, childName, subName, attrName, value) {
	return updateSdtPrChild(editor, target, childName, (existing) => {
		const el = existing ?? {
			name: childName,
			type: "element",
			elements: []
		};
		const elements = el.elements ? [...el.elements] : [];
		const idx = elements.findIndex((e) => e.name === subName);
		const subEl = {
			name: subName,
			type: "element",
			attributes: { [attrName]: value }
		};
		if (idx >= 0) elements[idx] = {
			...elements[idx],
			attributes: {
				...elements[idx].attributes ?? {},
				[attrName]: value
			}
		};
		else elements.push(subEl);
		return {
			...el,
			elements
		};
	});
}
function replaceSdtPrSubElements(editor, target, childName, elements) {
	return updateSdtPrChild(editor, target, childName, (existing) => ({
		name: childName,
		type: "element",
		...existing,
		elements
	}));
}
var VALID_CONTROL_TYPES = [
	"text",
	"richText",
	"date",
	"checkbox",
	"comboBox",
	"dropDownList",
	"repeatingSection",
	"repeatingSectionItem",
	"group"
];
var VALID_LOCK_MODES = [
	"unlocked",
	"sdtLocked",
	"contentLocked",
	"sdtContentLocked"
];
var VALID_APPEARANCES = [
	"boundingBox",
	"tags",
	"hidden"
];
function resolveControlType(attrs) {
	const rawType = attrs.controlType ?? attrs.type;
	if (typeof rawType === "string" && VALID_CONTROL_TYPES.includes(rawType)) return rawType;
	return "unknown";
}
function resolveLockMode(attrs) {
	const raw = attrs.lockMode;
	if (typeof raw === "string" && VALID_LOCK_MODES.includes(raw)) return raw;
	return "unlocked";
}
function resolveAppearance(attrs) {
	const raw = attrs.appearance;
	if (typeof raw === "string" && VALID_APPEARANCES.includes(raw)) return raw;
}
function resolveBinding(attrs) {
	const sdtPr = attrs.sdtPr;
	if (!sdtPr) return void 0;
	const bindingAttrs = getSdtPrChildAttrs(sdtPr, "w:dataBinding");
	if (!bindingAttrs) return void 0;
	const storeItemId = bindingAttrs["w:storeItemID"];
	const xpath = bindingAttrs["w:xpath"];
	if (!storeItemId || !xpath) return void 0;
	return {
		storeItemId,
		xpath,
		prefixMappings: bindingAttrs["w:prefixMappings"]
	};
}
function buildTarget(sdt) {
	return {
		kind: sdt.kind,
		nodeType: "sdt",
		nodeId: String(sdt.node.attrs.id ?? "")
	};
}
function readCheckboxChecked(sdtPr) {
	const checkedEl = (findSdtPrChild(sdtPr, "w14:checkbox") ?? findSdtPrChild(sdtPr, "w:checkbox"))?.elements?.find((e) => e.name === "w14:checked" || e.name === "w:checked");
	const checkedVal = checkedEl?.attributes?.["w14:val"] ?? checkedEl?.attributes?.["w:val"];
	return checkedVal === "1" || checkedVal === "true" || checkedVal === true;
}
function readChoiceListData(sdtPr, controlType) {
	const listEl = findSdtPrChild(sdtPr, `w:${controlType}`);
	return {
		items: (listEl?.elements?.filter((e) => e.name === "w:listItem") ?? []).map((item) => ({
			displayText: String(item.attributes?.["w:displayText"] ?? ""),
			value: String(item.attributes?.["w:value"] ?? "")
		})),
		selectedValue: listEl?.attributes?.["w:lastValue"]
	};
}
function resolveSubtypeProperties(controlType, sdtPr) {
	if (!sdtPr) return {};
	switch (controlType) {
		case "text": {
			const textAttrs = getSdtPrChildAttrs(sdtPr, "w:text");
			if (!textAttrs) return {};
			const multiline = textAttrs["w:multiLine"];
			return { multiline: multiline === "1" || multiline === "true" || multiline === true };
		}
		case "date": {
			const dateEl = findSdtPrChild(sdtPr, "w:date");
			if (!dateEl) return {};
			const fmtEl = findSdtPrChild(dateEl, "w:dateFormat");
			const lidEl = findSdtPrChild(dateEl, "w:lid");
			const storageEl = findSdtPrChild(dateEl, "w:storeMappedDataAs");
			const calendarEl = findSdtPrChild(dateEl, "w:calendar");
			return {
				dateFormat: fmtEl?.attributes?.["w:val"],
				dateLocale: lidEl?.attributes?.["w:val"],
				storageFormat: storageEl?.attributes?.["w:val"],
				calendar: calendarEl?.attributes?.["w:val"]
			};
		}
		case "checkbox": {
			const cbEl = findSdtPrChild(sdtPr, "w14:checkbox") ?? findSdtPrChild(sdtPr, "w:checkbox");
			if (!cbEl) return {};
			const checkedState = cbEl.elements?.find((e) => e.name === "w14:checkedState");
			const uncheckedState = cbEl.elements?.find((e) => e.name === "w14:uncheckedState");
			return {
				checked: readCheckboxChecked(sdtPr),
				checkedSymbol: checkedState ? {
					font: String(checkedState.attributes?.["w14:font"] ?? ""),
					char: String(checkedState.attributes?.["w14:val"] ?? "")
				} : void 0,
				uncheckedSymbol: uncheckedState ? {
					font: String(uncheckedState.attributes?.["w14:font"] ?? ""),
					char: String(uncheckedState.attributes?.["w14:val"] ?? "")
				} : void 0
			};
		}
		case "comboBox":
		case "dropDownList": return readChoiceListData(sdtPr, controlType);
		case "repeatingSection": {
			const rsEl = findSdtPrChild(sdtPr, "w15:repeatingSection") ?? findSdtPrChild(sdtPr, "w:repeatingSection");
			if (!rsEl) return {};
			const allowEl = rsEl.elements?.find((e) => e.name === "w15:allowInsertDeleteSection" || e.name === "w:allowInsertDeleteSection");
			const allow = allowEl?.attributes?.["w15:val"] ?? allowEl?.attributes?.["w:val"];
			return { allowInsertDelete: allow === "1" || allow === "true" || allow === true };
		}
		default: return {};
	}
}
function buildContentControlInfoFromNode(sdt) {
	const attrs = sdt.node.attrs;
	const id = String(attrs.id ?? "");
	const controlType = resolveControlType(attrs);
	const lockMode = resolveLockMode(attrs);
	const sdtPr = typeof attrs.sdtPr === "object" && attrs.sdtPr !== null ? attrs.sdtPr : void 0;
	let text$2;
	try {
		text$2 = sdt.node.textContent || void 0;
	} catch {
		text$2 = void 0;
	}
	const subtypeProps = resolveSubtypeProperties(controlType, sdtPr);
	return {
		nodeType: "sdt",
		kind: sdt.kind,
		id,
		controlType,
		lockMode,
		properties: {
			tag: typeof attrs.tag === "string" ? attrs.tag : void 0,
			alias: typeof attrs.alias === "string" ? attrs.alias : void 0,
			appearance: resolveAppearance(attrs),
			placeholder: typeof attrs.placeholder === "string" ? attrs.placeholder : void 0,
			color: typeof attrs.color === "string" ? attrs.color : void 0,
			showingPlaceholder: typeof attrs.showingPlaceholder === "boolean" ? attrs.showingPlaceholder : void 0,
			temporary: typeof attrs.temporary === "boolean" ? attrs.temporary : void 0,
			tabIndex: typeof attrs.tabIndex === "number" ? attrs.tabIndex : void 0,
			...subtypeProps
		},
		binding: resolveBinding(attrs),
		raw: sdtPr,
		target: {
			kind: sdt.kind,
			nodeType: "sdt",
			nodeId: id
		},
		text: text$2
	};
}
function buildContentControlInfoFromAttrs(attrs, kind) {
	const safeAttrs = attrs ?? {};
	const id = String(safeAttrs.id ?? "");
	return {
		nodeType: "sdt",
		kind,
		id,
		controlType: resolveControlType(safeAttrs),
		lockMode: resolveLockMode(safeAttrs),
		properties: {
			tag: typeof safeAttrs.tag === "string" ? safeAttrs.tag : void 0,
			alias: typeof safeAttrs.alias === "string" ? safeAttrs.alias : void 0,
			appearance: resolveAppearance(safeAttrs),
			placeholder: typeof safeAttrs.placeholder === "string" ? safeAttrs.placeholder : void 0,
			color: typeof safeAttrs.color === "string" ? safeAttrs.color : void 0,
			showingPlaceholder: typeof safeAttrs.showingPlaceholder === "boolean" ? safeAttrs.showingPlaceholder : void 0,
			temporary: typeof safeAttrs.temporary === "boolean" ? safeAttrs.temporary : void 0,
			tabIndex: typeof safeAttrs.tabIndex === "number" ? safeAttrs.tabIndex : void 0
		},
		target: {
			kind,
			nodeType: "sdt",
			nodeId: id
		}
	};
}
function assertNotSdtLocked(sdt, operation) {
	const mode = resolveLockMode(sdt.node.attrs);
	if (mode === "sdtLocked" || mode === "sdtContentLocked") throw new DocumentApiAdapterError("LOCK_VIOLATION", `Content control "${sdt.node.attrs.id}" has lock mode "${mode}" which prevents ${operation}.`, {
		lockMode: mode,
		operation
	});
}
function assertNotContentLocked(sdt, operation) {
	const mode = resolveLockMode(sdt.node.attrs);
	if (mode === "contentLocked" || mode === "sdtContentLocked") throw new DocumentApiAdapterError("LOCK_VIOLATION", `Content control "${sdt.node.attrs.id}" has lock mode "${mode}" which prevents ${operation}.`, {
		lockMode: mode,
		operation
	});
}
function assertControlType(sdt, expected, operation) {
	const actual = resolveControlType(sdt.node.attrs);
	const allowed = Array.isArray(expected) ? expected : [expected];
	if (!allowed.includes(actual)) throw new DocumentApiAdapterError("TYPE_MISMATCH", `Operation "${operation}" requires control type ${allowed.join(" or ")}, but found "${actual}".`, {
		expected: allowed,
		actual,
		operation
	});
}
function buildMutationSuccess(target, updatedRef) {
	const result = {
		success: true,
		contentControl: target
	};
	if (updatedRef) result.updatedRef = updatedRef;
	return result;
}
function buildMutationFailure(code$1, message) {
	return {
		success: false,
		failure: {
			code: code$1,
			message
		}
	};
}
function applyPagination(items, opts) {
	const total = items.length;
	const offset = opts?.offset ?? 0;
	const limit = opts?.limit ?? total;
	return {
		items: items.slice(offset, offset + limit),
		total
	};
}
function resolveBlock(editor, nodeId) {
	const matches$1 = getBlockIndex(editor).candidates.filter((c$1) => c$1.nodeId === nodeId && (c$1.nodeType === "paragraph" || c$1.nodeType === "listItem"));
	if (matches$1.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Block target was not found.", { nodeId });
	if (matches$1.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", "Block target id is ambiguous.", {
		nodeId,
		count: matches$1.length
	});
	return matches$1[0];
}
function resolveBlocksInRange(editor, fromId, toId$1) {
	const from = resolveBlock(editor, fromId);
	const to = resolveBlock(editor, toId$1);
	if (from.pos > to.pos) throw new DocumentApiAdapterError("INVALID_TARGET", "Block range \"from\" must precede \"to\" in document order.", {
		from: fromId,
		to: toId$1
	});
	return getBlockIndex(editor).candidates.filter((c$1) => (c$1.nodeType === "paragraph" || c$1.nodeType === "listItem") && c$1.pos >= from.pos && c$1.pos <= to.pos);
}
function getAbstractNumId(editor, numId) {
	const definitions = editor.converter?.numbering?.definitions;
	if (!definitions) return void 0;
	const numDef = definitions[numId];
	if (!numDef?.elements) return void 0;
	const val = numDef.elements.find((el) => el.name === "w:abstractNumId")?.attributes?.["w:val"];
	return val != null ? Number(val) : void 0;
}
function getAllListItemProjections(editor) {
	return getBlockIndex(editor).candidates.filter((c$1) => c$1.nodeType === "listItem").map((c$1) => projectListItemCandidate(editor, c$1));
}
function getContiguousSequence(editor, target) {
	if (target.numId == null) return [target];
	const allItems = getAllListItemProjections(editor);
	const targetIdx = allItems.findIndex((item) => item.address.nodeId === target.address.nodeId);
	if (targetIdx === -1) return [target];
	const numId = target.numId;
	let startIdx = targetIdx;
	for (let i$1 = targetIdx - 1; i$1 >= 0; i$1--) {
		if (allItems[i$1].numId !== numId) break;
		startIdx = i$1;
	}
	let endIdx = targetIdx;
	for (let i$1 = targetIdx + 1; i$1 < allItems.length; i$1++) {
		if (allItems[i$1].numId !== numId) break;
		endIdx = i$1;
	}
	return allItems.slice(startIdx, endIdx + 1);
}
function getSequenceFromTarget(editor, target) {
	const sequence = getContiguousSequence(editor, target);
	const targetIdx = sequence.findIndex((item) => item.address.nodeId === target.address.nodeId);
	return sequence.slice(targetIdx);
}
function isFirstInSequence(editor, target) {
	const sequence = getContiguousSequence(editor, target);
	return sequence.length > 0 && sequence[0].address.nodeId === target.address.nodeId;
}
function computeSequenceId(editor, projection) {
	if (projection.numId == null) return "";
	const anchor = getContiguousSequence(editor, projection)[0]?.address.nodeId ?? projection.address.nodeId;
	return `${projection.numId}:${anchor}`;
}
function computeSequenceIdMap(items) {
	const map = /* @__PURE__ */ new Map();
	let currentNumId;
	let currentAnchor;
	for (const item of items) {
		if (item.numId == null) {
			map.set(item.address.nodeId, "");
			currentNumId = void 0;
			currentAnchor = void 0;
			continue;
		}
		if (item.numId !== currentNumId) {
			currentNumId = item.numId;
			currentAnchor = item.address.nodeId;
		}
		map.set(item.address.nodeId, `${currentNumId}:${currentAnchor}`);
	}
	return map;
}
function findAdjacentSequence(editor, target, direction) {
	if (target.numId == null) return null;
	const allItems = getAllListItemProjections(editor);
	const sequence = getContiguousSequence(editor, target);
	if (direction === "withNext") {
		const lastInSequence = sequence[sequence.length - 1];
		const lastIdx = allItems.findIndex((item) => item.address.nodeId === lastInSequence.address.nodeId);
		for (let i$1 = lastIdx + 1; i$1 < allItems.length; i$1++) {
			const item = allItems[i$1];
			if (item.numId != null) return {
				sequence: getContiguousSequence(editor, item),
				numId: item.numId,
				abstractNumId: getAbstractNumId(editor, item.numId)
			};
		}
	} else {
		const firstInSequence = sequence[0];
		const firstIdx = allItems.findIndex((item) => item.address.nodeId === firstInSequence.address.nodeId);
		for (let i$1 = firstIdx - 1; i$1 >= 0; i$1--) {
			const item = allItems[i$1];
			if (item.numId != null) return {
				sequence: getContiguousSequence(editor, item),
				numId: item.numId,
				abstractNumId: getAbstractNumId(editor, item.numId)
			};
		}
	}
	return null;
}
function findPreviousCompatibleSequence(editor, target) {
	if (target.numId == null) return null;
	const targetAbstractId = getAbstractNumId(editor, target.numId);
	if (targetAbstractId == null) return null;
	const allItems = getAllListItemProjections(editor);
	const firstInSequence = getContiguousSequence(editor, target)[0];
	const firstIdx = allItems.findIndex((item) => item.address.nodeId === firstInSequence.address.nodeId);
	for (let i$1 = firstIdx - 1; i$1 >= 0; i$1--) {
		const item = allItems[i$1];
		if (item.numId == null) continue;
		if (getAbstractNumId(editor, item.numId) === targetAbstractId && item.numId !== target.numId) return {
			sequence: getContiguousSequence(editor, item),
			numId: item.numId
		};
	}
	return null;
}
function evaluateCanJoin(editor, target, direction) {
	const adjacent = findAdjacentSequence(editor, target, direction);
	if (!adjacent) return {
		canJoin: false,
		reason: "NO_ADJACENT_SEQUENCE"
	};
	if (adjacent.numId === target.numId) return {
		canJoin: false,
		reason: "ALREADY_SAME_SEQUENCE"
	};
	const targetAbstractId = target.numId != null ? getAbstractNumId(editor, target.numId) : void 0;
	if (targetAbstractId == null || adjacent.abstractNumId == null || targetAbstractId !== adjacent.abstractNumId) return {
		canJoin: false,
		reason: "INCOMPATIBLE_DEFINITIONS"
	};
	const adjacentAnchor = adjacent.sequence[0]?.address.nodeId ?? "";
	return {
		canJoin: true,
		adjacentListId: `${adjacent.numId}:${adjacentAnchor}`
	};
}
function evaluateCanContinuePrevious(editor, target) {
	if (target.numId == null) return {
		canContinue: false,
		reason: "NO_PREVIOUS_LIST"
	};
	const targetAbstractId = getAbstractNumId(editor, target.numId);
	if (targetAbstractId == null) return {
		canContinue: false,
		reason: "NO_PREVIOUS_LIST"
	};
	const allItems = getAllListItemProjections(editor);
	const firstInSequence = getContiguousSequence(editor, target)[0];
	const firstIdx = allItems.findIndex((item) => item.address.nodeId === firstInSequence.address.nodeId);
	let foundAnyPrevious = false;
	for (let i$1 = firstIdx - 1; i$1 >= 0; i$1--) {
		const item = allItems[i$1];
		if (item.numId == null) continue;
		foundAnyPrevious = true;
		if (getAbstractNumId(editor, item.numId) !== targetAbstractId) continue;
		if (item.numId === target.numId) return {
			canContinue: false,
			reason: "ALREADY_CONTINUOUS"
		};
		const prevAnchor = getContiguousSequence(editor, item)[0]?.address.nodeId ?? item.address.nodeId;
		return {
			canContinue: true,
			previousListId: `${item.numId}:${prevAnchor}`
		};
	}
	if (!foundAnyPrevious) return {
		canContinue: false,
		reason: "NO_PREVIOUS_LIST"
	};
	return {
		canContinue: false,
		reason: "INCOMPATIBLE_DEFINITIONS"
	};
}
function getNumberingProperties(node) {
	const attrs = node.attrs ?? {};
	const paragraphNumbering = attrs.paragraphProperties?.numberingProperties ?? void 0;
	const fallbackNumbering = attrs.numberingProperties ?? void 0;
	return {
		numId: toFiniteNumber(paragraphNumbering?.numId ?? fallbackNumbering?.numId),
		level: toFiniteNumber(paragraphNumbering?.ilvl ?? fallbackNumbering?.ilvl)
	};
}
function deriveListKindFromDefinitions(editor, numId, level) {
	if (numId == null || level == null || !editor.converter) return void 0;
	try {
		const details = ListHelpers.getListDefinitionDetails({
			numId,
			level,
			listType: void 0,
			editor
		});
		const numberingType = typeof details?.listNumberingType === "string" ? details.listNumberingType : void 0;
		if (numberingType === "bullet") return "bullet";
		if (typeof numberingType === "string" && numberingType.length > 0) return "ordered";
		return;
	} catch {
		return;
	}
}
function deriveListKind(editor, candidate, numId, level) {
	const numberingType = (candidate.node.attrs ?? {}).listRendering?.numberingType;
	if (numberingType === "bullet") return "bullet";
	if (typeof numberingType === "string" && numberingType.length > 0) return "ordered";
	return deriveListKindFromDefinitions(editor, numId, level);
}
function getListText(candidate) {
	const text$2 = candidate.node.textContent;
	return typeof text$2 === "string" ? text$2 : void 0;
}
function projectListItemCandidate(editor, candidate) {
	const attrs = candidate.node.attrs ?? {};
	const { numId, level } = getNumberingProperties(candidate.node);
	const listRendering = getListRendering(attrs.listRendering);
	const path = listRendering?.path;
	const ordinal = getListOrdinalFromPath(path);
	const marker = listRendering?.markerText;
	return {
		candidate,
		address: {
			kind: "block",
			nodeType: "listItem",
			nodeId: candidate.nodeId
		},
		numId,
		level,
		kind: deriveListKind(editor, candidate, numId, level),
		marker,
		path,
		ordinal,
		text: getListText(candidate)
	};
}
function listItemProjectionToInfo(projection, listId) {
	return {
		address: projection.address,
		listId,
		marker: projection.marker,
		ordinal: projection.ordinal,
		path: projection.path,
		level: projection.level,
		kind: projection.kind,
		text: projection.text
	};
}
function matchesListQuery(projection, query) {
	if (!query) return true;
	if (query.kind && projection.kind !== query.kind) return false;
	if (query.level != null && projection.level !== query.level) return false;
	if (query.ordinal != null && projection.ordinal !== query.ordinal) return false;
	return true;
}
function resolveBlockScopeRange(index, within) {
	if (!within) return void 0;
	const matches$1 = index.candidates.filter((candidate) => candidate.nodeType === within.nodeType && candidate.nodeId === within.nodeId);
	if (matches$1.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "List scope block was not found.", { within });
	if (matches$1.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", "List scope block id is ambiguous.", {
		within,
		count: matches$1.length
	});
	return {
		start: matches$1[0].pos,
		end: matches$1[0].end
	};
}
function isWithinScope(candidate, scope) {
	if (!scope) return true;
	return candidate.pos >= scope.start && candidate.end <= scope.end;
}
function listListItems(editor, query) {
	if (query?.within && query.within.kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "lists.list only supports block within scopes.", { within: query.within });
	validatePaginationInput(query?.offset, query?.limit);
	const index = getBlockIndex(editor);
	const scope = resolveBlockScopeRange(index, query?.within);
	const allProjections = index.candidates.filter((candidate) => candidate.nodeType === "listItem").map((candidate) => projectListItemCandidate(editor, candidate));
	const projections = allProjections.filter((projection) => isWithinScope(projection.candidate, scope));
	const safeOffset = query?.offset ?? 0;
	const pageEnd = safeOffset + (query?.limit ?? Number.POSITIVE_INFINITY);
	const evaluatedRevision = getRevision(editor);
	const sequenceIds = computeSequenceIdMap(allProjections);
	let total = 0;
	const items = [];
	for (const projection of projections) {
		if (!matchesListQuery(projection, query)) continue;
		const currentIndex = total;
		total += 1;
		if (currentIndex < safeOffset || currentIndex >= pageEnd) continue;
		const listId = sequenceIds.get(projection.address.nodeId) ?? "";
		const info = listItemProjectionToInfo(projection, listId);
		const handle = buildResolvedHandle(info.address.nodeId, "stable", "list");
		const { address, marker, ordinal, path, level, kind, text: text$2 } = info;
		items.push(buildDiscoveryItem(info.address.nodeId, handle, {
			address,
			listId,
			marker,
			ordinal,
			path,
			level,
			kind,
			text: text$2
		}));
	}
	return buildDiscoveryResult({
		evaluatedRevision,
		total,
		items,
		page: {
			limit: query?.limit ?? total,
			offset: safeOffset,
			returned: items.length
		}
	});
}
function resolveListItem(editor, address) {
	const matches$1 = getBlockIndex(editor).candidates.filter((candidate) => candidate.nodeType === "listItem" && candidate.nodeId === address.nodeId);
	if (matches$1.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "List item target was not found.", { target: address });
	if (matches$1.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", "List item target id is ambiguous.", {
		target: address,
		count: matches$1.length
	});
	return projectListItemCandidate(editor, matches$1[0]);
}
var FIELD_LIKE_SDT_TYPES = new Set([
	"text",
	"date",
	"checkbox",
	"comboBox",
	"dropDownList"
]);
var liveDocumentCountsCache = /* @__PURE__ */ new WeakMap();
function getLiveDocumentCounts(editor) {
	const currentDoc = editor.state.doc;
	const cached = liveDocumentCountsCache.get(editor);
	const pages = countPages(editor);
	if (cached && cached.doc === currentDoc) return cloneLiveDocumentCounts(cached.counts, pages);
	const counts = computeLiveDocumentCounts(editor);
	liveDocumentCountsCache.set(editor, {
		doc: currentDoc,
		counts
	});
	return cloneLiveDocumentCounts(counts, pages);
}
function computeLiveDocumentCounts(editor) {
	const text$2 = getTextAdapter(editor, {});
	const blockIndex = getBlockIndex(editor);
	const inlineIndex = getInlineIndex(editor);
	const blockCounts = countBlockNodeTypes(blockIndex);
	const inlineImages = countInlineImages(inlineIndex);
	return {
		words: countWordsFromText(text$2),
		characters: text$2.length,
		paragraphs: blockCounts.paragraphs,
		headings: blockCounts.headings,
		tables: blockCounts.tables,
		images: blockCounts.blockImages + inlineImages,
		comments: countUniqueCommentIds(inlineIndex),
		trackedChanges: countTrackedChanges(editor),
		sdtFields: countSdtFields(editor),
		lists: countLists(editor, blockIndex)
	};
}
function cloneLiveDocumentCounts(counts, pages) {
	return pages != null ? {
		...counts,
		pages
	} : { ...counts };
}
function countWordsFromText(text$2) {
	const matches$1 = text$2.trim().match(/\S+/g);
	return matches$1 ? matches$1.length : 0;
}
function countBlockNodeTypes(blockIndex) {
	let paragraphs = 0;
	let headings = 0;
	let tables = 0;
	let blockImages = 0;
	for (const candidate of blockIndex.candidates) switch (candidate.nodeType) {
		case "paragraph":
			paragraphs++;
			break;
		case "heading":
			headings++;
			break;
		case "table":
			tables++;
			break;
		case "image":
			blockImages++;
			break;
	}
	return {
		paragraphs,
		headings,
		tables,
		blockImages
	};
}
function countInlineImages(inlineIndex) {
	return inlineIndex.byType.get("image")?.length ?? 0;
}
function countUniqueCommentIds(inlineIndex) {
	const commentCandidates = inlineIndex.byType.get("comment") ?? [];
	const uniqueIds = /* @__PURE__ */ new Set();
	for (const candidate of commentCandidates) {
		const commentId = resolveCommentIdFromAttrs(candidate.attrs ?? {});
		if (commentId) uniqueIds.add(commentId);
	}
	return uniqueIds.size;
}
function countTrackedChanges(editor) {
	return groupTrackedChanges(editor).length;
}
function countSdtFields(editor) {
	return findAllSdtNodes(editor.state.doc).filter((sdt) => FIELD_LIKE_SDT_TYPES.has(resolveControlType(sdt.node.attrs ?? {}))).length;
}
function countLists(editor, blockIndex) {
	const listItems = getListItemProjections(editor, blockIndex);
	if (listItems.length === 0) return 0;
	const sequenceIds = computeSequenceIdMap(listItems);
	let listCount = 0;
	let previousSequenceId;
	let previousFallbackItem;
	for (const item of listItems) {
		const sequenceId = sequenceIds.get(item.address.nodeId) ?? "";
		if (sequenceId) {
			if (sequenceId !== previousSequenceId) listCount += 1;
			previousSequenceId = sequenceId;
			previousFallbackItem = void 0;
			continue;
		}
		previousSequenceId = void 0;
		if (!previousFallbackItem || startsNewFallbackListSequence(previousFallbackItem, item)) listCount += 1;
		previousFallbackItem = item;
	}
	return listCount;
}
function getListItemProjections(editor, blockIndex) {
	return blockIndex.candidates.filter((candidate) => candidate.nodeType === "listItem").map((candidate) => projectListItemCandidate(editor, candidate));
}
function startsNewFallbackListSequence(previous$1, current) {
	if (hasKnownListKindChange(previous$1, current)) return true;
	return hasOrdinalRestartAtSameVisibleLevel(previous$1, current);
}
function hasKnownListKindChange(previous$1, current) {
	return previous$1.kind != null && current.kind != null && previous$1.kind !== current.kind;
}
function hasOrdinalRestartAtSameVisibleLevel(previous$1, current) {
	const previousLevel = resolveVisibleListLevel(previous$1);
	const currentLevel = resolveVisibleListLevel(current);
	if (previousLevel == null || currentLevel == null || previousLevel !== currentLevel) return false;
	if (previous$1.ordinal == null || current.ordinal == null) return false;
	return current.ordinal <= previous$1.ordinal;
}
function resolveVisibleListLevel(item) {
	if (item.level != null) return item.level;
	return item.path && item.path.length > 0 ? item.path.length - 1 : void 0;
}
function countPages(editor) {
	return editor.currentTotalPages;
}
function getWordStatistics(editor) {
	const text$2 = getTextAdapter(editor, {});
	return {
		words: countWordsFromText(text$2),
		characters: countCharactersExcludingSpaces(text$2),
		charactersWithSpaces: countCharactersWithSpaces(text$2),
		pages: countPages(editor)
	};
}
function resolveDocumentStatFieldValue(fieldType, stats) {
	switch (fieldType) {
		case "NUMWORDS": return String(stats.words);
		case "NUMCHARS": return String(stats.characters);
		case "NUMPAGES": return stats.pages != null ? String(stats.pages) : null;
		default: return null;
	}
}
function resolveMainBodyEditor(editor) {
	return editor.options?.parentEditor ?? editor;
}
function countCharactersExcludingSpaces(text$2) {
	return text$2.replace(/\s/g, "").length;
}
function countCharactersWithSpaces(text$2) {
	return text$2.replace(/\n/g, "").length;
}
function refreshAllStatFields(editor) {
	const cacheMap = /* @__PURE__ */ new Map();
	const stats = getWordStatistics(resolveMainBodyEditor(editor));
	for (const fieldType of [
		"NUMWORDS",
		"NUMCHARS",
		"NUMPAGES"
	]) {
		const freshValue = resolveDocumentStatFieldValue(fieldType, stats);
		if (freshValue != null) cacheMap.set(fieldType, freshValue);
	}
	return cacheMap;
}
const BIBLIOGRAPHY_NAMESPACE_URI = "http://schemas.openxmlformats.org/officeDocument/2006/bibliography";
const CUSTOM_XML_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml";
const CUSTOM_XML_PROPS_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps";
var DEFAULT_SELECTED_STYLE = "/APA.XSL";
var DEFAULT_STYLE_NAME = "APA";
var DEFAULT_VERSION = "6";
var API_TO_OOXML_SOURCE_TYPE = Object.freeze({
	book: "Book",
	journalArticle: "JournalArticle",
	conferenceProceedings: "ConferenceProceedings",
	report: "Report",
	website: "InternetSite",
	patent: "Patent",
	case: "Case",
	statute: "Case",
	thesis: "Report",
	film: "Film",
	interview: "Interview",
	misc: "Misc"
});
var OOXML_TO_API_SOURCE_TYPE = Object.freeze({
	book: "book",
	journalarticle: "journalArticle",
	conferenceproceedings: "conferenceProceedings",
	report: "report",
	internetsite: "website",
	documentfrominternetsite: "website",
	articleinaperiodical: "journalArticle",
	patent: "patent",
	case: "case",
	statute: "statute",
	thesis: "thesis",
	film: "film",
	interview: "interview",
	misc: "misc"
});
var SIMPLE_FIELD_TO_XML_TAG = Object.freeze({
	title: "Title",
	year: "Year",
	publisher: "Publisher",
	city: "City",
	journalName: "JournalName",
	volume: "Volume",
	issue: "Issue",
	pages: "Pages",
	url: "URL",
	doi: "DOI",
	edition: "Edition",
	medium: "Medium",
	shortTitle: "ShortTitle",
	standardNumber: "StandardNumber"
});
var XML_TAG_TO_SIMPLE_FIELD = Object.freeze(Object.fromEntries(Object.entries(SIMPLE_FIELD_TO_XML_TAG).map(([field, tag]) => [tag, field])));
function getLocalName(name) {
	if (!name || typeof name !== "string") return "";
	const separatorIndex = name.indexOf(":");
	return separatorIndex >= 0 ? name.slice(separatorIndex + 1) : name;
}
function readTextNode(node) {
	if (!node?.elements?.length) return "";
	const textNode = node.elements.find((element) => element?.type === "text");
	return typeof textNode?.text === "string" ? textNode.text.trim() : "";
}
function createTextElement(name, text$2) {
	return {
		type: "element",
		name,
		elements: [{
			type: "text",
			text: String(text$2)
		}]
	};
}
function createXmlDocument(rootElement, declaration) {
	const nextDeclaration = declaration ?? DEFAULT_XML_DECLARATION;
	return {
		declaration: {
			...nextDeclaration,
			attributes: { ...nextDeclaration.attributes }
		},
		elements: [rootElement]
	};
}
function collectPersonNodes(node, output) {
	if (!node?.elements?.length) return;
	for (const child of node.elements) {
		if (!child || child.type !== "element") continue;
		if (getLocalName(child.name) === "Person") {
			output.push(child);
			continue;
		}
		collectPersonNodes(child, output);
	}
}
function parsePersonNode(personNode) {
	const person = {};
	for (const child of personNode?.elements ?? []) {
		if (!child || child.type !== "element") continue;
		const localName = getLocalName(child.name);
		const value = readTextNode(child);
		if (!value) continue;
		if (localName === "First") person.first = value;
		if (localName === "Middle") person.middle = value;
		if (localName === "Last") person.last = value;
	}
	return typeof person.last === "string" && person.last.length > 0 ? person : null;
}
function parseContributorPeople(sourceElement, contributorTag) {
	const contributorNode = (sourceElement?.elements ?? []).find((child) => child?.type === "element" && getLocalName(child.name) === contributorTag);
	if (!contributorNode) return [];
	const peopleNodes = [];
	collectPersonNodes(contributorNode, peopleNodes);
	return peopleNodes.map(parsePersonNode).filter(Boolean);
}
function serializePersonNode(person) {
	if (!person || typeof person.last !== "string" || person.last.trim().length === 0) return null;
	const elements = [];
	const last = person.last.trim();
	const first = typeof person.first === "string" ? person.first.trim() : "";
	const middle = typeof person.middle === "string" ? person.middle.trim() : "";
	if (last) elements.push(createTextElement("b:Last", last));
	if (first) elements.push(createTextElement("b:First", first));
	if (middle) elements.push(createTextElement("b:Middle", middle));
	return {
		type: "element",
		name: "b:Person",
		elements
	};
}
function serializeNameList(people) {
	const personElements = (people ?? []).map(serializePersonNode).filter(Boolean);
	if (personElements.length === 0) return null;
	return {
		type: "element",
		name: "b:NameList",
		elements: personElements
	};
}
function serializeContributorNode(tagName, people) {
	const nameList = serializeNameList(people);
	if (!nameList) return null;
	if (tagName === "Author") return {
		type: "element",
		name: "b:Author",
		elements: [{
			type: "element",
			name: "b:Author",
			elements: [nameList]
		}]
	};
	return {
		type: "element",
		name: `b:${tagName}`,
		elements: [nameList]
	};
}
function mapApiTypeToOoxml(type) {
	return API_TO_OOXML_SOURCE_TYPE[typeof type === "string" ? type.trim() : ""] ?? API_TO_OOXML_SOURCE_TYPE.misc;
}
function mapOoxmlTypeToApi(type) {
	return OOXML_TO_API_SOURCE_TYPE[typeof type === "string" ? type.trim().toLowerCase() : ""] ?? "misc";
}
function normalizeSourceRecord(record) {
	if (!record || typeof record !== "object") return null;
	const tagRaw = record.tag ?? record.sourceId;
	const tag = typeof tagRaw === "string" ? tagRaw.trim() : "";
	if (!tag) return null;
	const type = typeof record.type === "string" ? record.type : "misc";
	const fieldsInput = record.fields && typeof record.fields === "object" ? record.fields : {};
	const fields = {};
	for (const fieldName of Object.keys(SIMPLE_FIELD_TO_XML_TAG)) {
		const value = fieldsInput[fieldName];
		if (typeof value === "string" && value.trim().length > 0) fields[fieldName] = value.trim();
	}
	for (const contributorField of [
		"authors",
		"editor",
		"translator"
	]) {
		const value = fieldsInput[contributorField];
		if (!Array.isArray(value)) continue;
		const people = value.map((person) => {
			if (!person || typeof person !== "object") return null;
			const normalizedPerson = {
				first: typeof person.first === "string" ? person.first.trim() : void 0,
				middle: typeof person.middle === "string" ? person.middle.trim() : void 0,
				last: typeof person.last === "string" ? person.last.trim() : void 0
			};
			return normalizedPerson.last ? normalizedPerson : null;
		}).filter(Boolean);
		if (people.length > 0) fields[contributorField] = people;
	}
	return {
		tag,
		type,
		fields
	};
}
function parseSourceNode(sourceNode) {
	const fields = {};
	let tag = "";
	let sourceType = "misc";
	for (const child of sourceNode?.elements ?? []) {
		if (!child || child.type !== "element") continue;
		const localName = getLocalName(child.name);
		if (localName === "Tag") {
			tag = readTextNode(child);
			continue;
		}
		if (localName === "SourceType") {
			sourceType = mapOoxmlTypeToApi(readTextNode(child));
			continue;
		}
		const fieldName = XML_TAG_TO_SIMPLE_FIELD[localName];
		if (!fieldName) continue;
		const value = readTextNode(child);
		if (value) fields[fieldName] = value;
	}
	const authors = parseContributorPeople(sourceNode, "Author");
	if (authors.length > 0) fields.authors = authors;
	const editors = parseContributorPeople(sourceNode, "Editor");
	if (editors.length > 0) fields.editor = editors;
	const translators = parseContributorPeople(sourceNode, "Translator");
	if (translators.length > 0) fields.translator = translators;
	return normalizeSourceRecord({
		tag,
		type: sourceType,
		fields
	});
}
function buildSourceNode(sourceRecord) {
	const normalized = normalizeSourceRecord(sourceRecord);
	if (!normalized) return null;
	const elements = [createTextElement("b:Tag", normalized.tag), createTextElement("b:SourceType", mapApiTypeToOoxml(normalized.type))];
	for (const [fieldName, xmlTagName] of Object.entries(SIMPLE_FIELD_TO_XML_TAG)) {
		const value = normalized.fields?.[fieldName];
		if (typeof value !== "string" || value.length === 0) continue;
		elements.push(createTextElement(`b:${xmlTagName}`, value));
	}
	const authorsNode = serializeContributorNode("Author", normalized.fields?.authors);
	if (authorsNode) elements.push(authorsNode);
	const editorNode = serializeContributorNode("Editor", normalized.fields?.editor);
	if (editorNode) elements.push(editorNode);
	const translatorNode = serializeContributorNode("Translator", normalized.fields?.translator);
	if (translatorNode) elements.push(translatorNode);
	return {
		type: "element",
		name: "b:Source",
		elements
	};
}
function isBibliographySourcesRoot(rootNode) {
	if (!rootNode || rootNode.type !== "element") return false;
	if (getLocalName(rootNode.name) !== "Sources") return false;
	const rootNamespace = rootNode.attributes?.xmlns;
	const prefixedNamespace = rootNode.attributes?.["xmlns:b"];
	return rootNamespace === "http://schemas.openxmlformats.org/officeDocument/2006/bibliography" || prefixedNamespace === "http://schemas.openxmlformats.org/officeDocument/2006/bibliography";
}
function parseItemIndex(path) {
	const match = /customXml\/item(\d+)\.xml$/i.exec(path || "");
	return match ? Number.parseInt(match[1], 10) : null;
}
function buildDocumentRelationshipTarget(partPath) {
	return partPath.startsWith("customXml/") ? `../${partPath}` : partPath;
}
function getExistingDocumentRelationshipsRoot(convertedXml) {
	const relsData = convertedXml?.["word/_rels/document.xml.rels"];
	if (!relsData?.elements?.length) return null;
	return relsData.elements.find((element) => getLocalName(element.name) === "Relationships") || null;
}
function ensureDocumentRelationshipsRoot(convertedXml) {
	if (!convertedXml["word/_rels/document.xml.rels"]) convertedXml["word/_rels/document.xml.rels"] = createXmlDocument({
		type: "element",
		name: "Relationships",
		attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
		elements: []
	});
	const relsData = convertedXml["word/_rels/document.xml.rels"];
	relsData.elements ??= [];
	let relationshipsRoot = relsData.elements.find((element) => getLocalName(element.name) === "Relationships");
	if (!relationshipsRoot) {
		relationshipsRoot = {
			type: "element",
			name: "Relationships",
			attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
			elements: []
		};
		relsData.elements.push(relationshipsRoot);
	}
	relationshipsRoot.elements ??= [];
	return relationshipsRoot;
}
function getNextRelationshipId(relationshipsRoot) {
	const existingNumericIds = (relationshipsRoot?.elements ?? []).map((relationship) => {
		const id = relationship?.attributes?.Id;
		if (typeof id !== "string") return NaN;
		const match = /^rId(\d+)$/.exec(id);
		return match ? Number.parseInt(match[1], 10) : NaN;
	}).filter((value) => Number.isFinite(value));
	return `rId${(existingNumericIds.length > 0 ? Math.max(...existingNumericIds) : 0) + 1}`;
}
function getNextCustomXmlItemIndex(convertedXml) {
	const usedIndexes = /* @__PURE__ */ new Set();
	for (const path of Object.keys(convertedXml ?? {})) {
		const itemMatch = /customXml\/item(\d+)\.xml$/i.exec(path);
		if (itemMatch) usedIndexes.add(Number.parseInt(itemMatch[1], 10));
		const itemPropsMatch = /customXml\/itemProps(\d+)\.xml$/i.exec(path);
		if (itemPropsMatch) usedIndexes.add(Number.parseInt(itemPropsMatch[1], 10));
	}
	let candidate = 1;
	while (usedIndexes.has(candidate)) candidate += 1;
	return candidate;
}
function buildSourcesRootElement(sources, styleMetadata) {
	const sourceElements = sources.map(buildSourceNode).filter(Boolean);
	const selectedStyle = styleMetadata.selectedStyle || DEFAULT_SELECTED_STYLE;
	const styleName = styleMetadata.styleName || DEFAULT_STYLE_NAME;
	const version = styleMetadata.version || DEFAULT_VERSION;
	return {
		type: "element",
		name: "b:Sources",
		attributes: {
			"xmlns:b": BIBLIOGRAPHY_NAMESPACE_URI,
			xmlns: BIBLIOGRAPHY_NAMESPACE_URI,
			SelectedStyle: selectedStyle,
			StyleName: styleName,
			Version: version
		},
		elements: sourceElements
	};
}
function extractExistingDataStoreItemId(itemPropsDoc) {
	const existingId = (itemPropsDoc?.elements?.[0])?.attributes?.["ds:itemID"];
	return typeof existingId === "string" && existingId.length > 0 ? existingId : null;
}
function buildItemPropsRootElement(dataStoreItemId) {
	return {
		type: "element",
		name: "ds:datastoreItem",
		attributes: {
			"ds:itemID": dataStoreItemId,
			"xmlns:ds": "http://schemas.openxmlformats.org/officeDocument/2006/customXml"
		},
		elements: [{
			type: "element",
			name: "ds:schemaRefs",
			elements: [{
				type: "element",
				name: "ds:schemaRef",
				attributes: { "ds:uri": BIBLIOGRAPHY_NAMESPACE_URI }
			}]
		}]
	};
}
function buildCustomXmlItemRelationshipsRoot(itemPropsFileName) {
	return {
		type: "element",
		name: "Relationships",
		attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
		elements: [{
			type: "element",
			name: "Relationship",
			attributes: {
				Id: "rId1",
				Type: CUSTOM_XML_PROPS_RELATIONSHIP_TYPE,
				Target: itemPropsFileName
			}
		}]
	};
}
function dedupeSourcesByTag(sourceRecords) {
	const byTag = /* @__PURE__ */ new Map();
	for (const source of sourceRecords) {
		const normalized = normalizeSourceRecord(source);
		if (!normalized) continue;
		byTag.set(normalized.tag, normalized);
	}
	return Array.from(byTag.values());
}
function createEmptyBibliographyPart() {
	return {
		sources: [],
		partPath: null,
		itemPropsPath: null,
		itemRelsPath: null,
		selectedStyle: null,
		styleName: null,
		version: null
	};
}
function loadBibliographyPartFromPackage(convertedXml) {
	const bibliographyPart = createEmptyBibliographyPart();
	const relationshipsRoot = getExistingDocumentRelationshipsRoot(convertedXml);
	if (!relationshipsRoot?.elements?.length) return bibliographyPart;
	const discoveredSources = [];
	for (const relationship of relationshipsRoot.elements) {
		if (relationship?.attributes?.Type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml") continue;
		const target = relationship?.attributes?.Target;
		const resolvedPath = resolveOpcTargetPath(target, "word");
		if (!resolvedPath) continue;
		const rootElement = (convertedXml?.[resolvedPath])?.elements?.[0];
		if (!isBibliographySourcesRoot(rootElement)) continue;
		if (!bibliographyPart.partPath) {
			bibliographyPart.partPath = resolvedPath;
			bibliographyPart.selectedStyle = rootElement.attributes?.SelectedStyle ?? null;
			bibliographyPart.styleName = rootElement.attributes?.StyleName ?? null;
			bibliographyPart.version = rootElement.attributes?.Version ?? null;
			const itemIndex = parseItemIndex(resolvedPath);
			if (itemIndex != null) {
				const itemPropsPath = `customXml/itemProps${itemIndex}.xml`;
				const itemRelsPath = `customXml/_rels/item${itemIndex}.xml.rels`;
				bibliographyPart.itemPropsPath = convertedXml[itemPropsPath] ? itemPropsPath : null;
				bibliographyPart.itemRelsPath = convertedXml[itemRelsPath] ? itemRelsPath : null;
			}
		}
		for (const child of rootElement.elements ?? []) {
			if (!child || child.type !== "element" || getLocalName(child.name) !== "Source") continue;
			const source = parseSourceNode(child);
			if (source) discoveredSources.push(source);
		}
	}
	bibliographyPart.sources = dedupeSourcesByTag(discoveredSources);
	return bibliographyPart;
}
function syncBibliographyPartToPackage(convertedXml, bibliographyPart) {
	const currentPackageState = loadBibliographyPartFromPackage(convertedXml);
	const normalizedSources = dedupeSourcesByTag(Array.isArray(bibliographyPart?.sources) ? bibliographyPart.sources : []);
	if (normalizedSources.length === 0 && !currentPackageState.partPath) return {
		...createEmptyBibliographyPart(),
		sources: []
	};
	const preferredPartPath = bibliographyPart?.partPath || currentPackageState.partPath;
	const preferredItemIndex = parseItemIndex(preferredPartPath);
	const itemIndex = preferredItemIndex ?? getNextCustomXmlItemIndex(convertedXml);
	const partPath = preferredItemIndex ? preferredPartPath : `customXml/item${itemIndex}.xml`;
	const itemPropsPath = `customXml/itemProps${itemIndex}.xml`;
	const itemRelsPath = `customXml/_rels/item${itemIndex}.xml.rels`;
	const selectedStyle = bibliographyPart?.selectedStyle ?? currentPackageState.selectedStyle ?? DEFAULT_SELECTED_STYLE;
	const styleName = bibliographyPart?.styleName ?? currentPackageState.styleName ?? DEFAULT_STYLE_NAME;
	const version = bibliographyPart?.version ?? currentPackageState.version ?? DEFAULT_VERSION;
	const existingPartDeclaration = convertedXml[partPath]?.declaration;
	convertedXml[partPath] = createXmlDocument(buildSourcesRootElement(normalizedSources, {
		selectedStyle,
		styleName,
		version
	}), existingPartDeclaration);
	const relationshipsRoot = ensureDocumentRelationshipsRoot(convertedXml);
	const expectedTarget = buildDocumentRelationshipTarget(partPath);
	if (!relationshipsRoot.elements.some((relationship) => {
		if (relationship?.attributes?.Type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml") return false;
		return resolveOpcTargetPath(relationship?.attributes?.Target, "word") === partPath;
	})) relationshipsRoot.elements.push({
		type: "element",
		name: "Relationship",
		attributes: {
			Id: getNextRelationshipId(relationshipsRoot),
			Type: CUSTOM_XML_RELATIONSHIP_TYPE,
			Target: expectedTarget
		}
	});
	const existingItemProps = convertedXml[itemPropsPath];
	const existingItemPropsDeclaration = existingItemProps?.declaration;
	convertedXml[itemPropsPath] = createXmlDocument(buildItemPropsRootElement(extractExistingDataStoreItemId(existingItemProps) || `{${v4_default().toUpperCase()}}`), existingItemPropsDeclaration);
	const existingItemRelsDeclaration = convertedXml[itemRelsPath]?.declaration;
	convertedXml[itemRelsPath] = createXmlDocument(buildCustomXmlItemRelationshipsRoot(`itemProps${itemIndex}.xml`), existingItemRelsDeclaration);
	return {
		sources: normalizedSources,
		partPath,
		itemPropsPath,
		itemRelsPath,
		selectedStyle,
		styleName,
		version
	};
}
function getBibliographyPartExportPaths(bibliographyPart) {
	return [
		bibliographyPart?.partPath,
		bibliographyPart?.itemPropsPath,
		bibliographyPart?.itemRelsPath
	].filter((path) => typeof path === "string" && path.length > 0);
}
var import_lib = /* @__PURE__ */ __toESM(require_lib(), 1);
var FONT_FAMILY_FALLBACKS = Object.freeze({
	swiss: "Arial, sans-serif",
	roman: "Times New Roman, serif",
	modern: "Courier New, monospace",
	script: "cursive",
	decorative: "fantasy",
	system: "system-ui",
	auto: "sans-serif"
});
var DEFAULT_GENERIC_FALLBACK = "sans-serif";
var DEFAULT_FONT_SIZE_PT = 10;
var CURRENT_APP_VERSION = "1.40.0";
var SUPERDOC_DOCUMENT_ORIGIN_PROPERTY = "SuperdocDocumentOrigin";
var STORED_DOCUMENT_ORIGINS = new Set([
	"word",
	"google-docs",
	"unknown",
	"superdoc"
]);
var collectRunDefaultProperties = (runProps, { allowOverrideTypeface = true, allowOverrideSize = true, themeResolver, state }) => {
	if (!runProps?.elements?.length || !state) return;
	const fontsNode = runProps.elements.find((el) => el.name === "w:rFonts");
	if (fontsNode?.attributes) {
		const themeName = fontsNode.attributes["w:asciiTheme"];
		if (themeName) {
			const themeInfo = themeResolver?.(themeName) || {};
			if ((allowOverrideTypeface || !state.typeface) && themeInfo.typeface) state.typeface = themeInfo.typeface;
			if ((allowOverrideTypeface || !state.panose) && themeInfo.panose) state.panose = themeInfo.panose;
		}
		const ascii = fontsNode.attributes["w:ascii"];
		if ((allowOverrideTypeface || !state.typeface) && ascii) state.typeface = ascii;
	}
	const sizeNode = runProps.elements.find((el) => el.name === "w:sz");
	if (sizeNode?.attributes?.["w:val"]) {
		const sizeTwips = Number(sizeNode.attributes["w:val"]);
		if (Number.isFinite(sizeTwips)) {
			if (state.fallbackSzTwips === void 0) state.fallbackSzTwips = sizeTwips;
			const sizePt = sizeTwips / 2;
			if (allowOverrideSize || state.fontSizePt === void 0) state.fontSizePt = sizePt;
		}
	}
	const kernNode = runProps.elements.find((el) => el.name === "w:kern");
	if (kernNode?.attributes?.["w:val"]) {
		if (allowOverrideSize || state.kern === void 0) state.kern = kernNode.attributes["w:val"];
	}
};
var SuperConverter = class SuperConverter {
	static allowedElements = Object.freeze({
		"w:document": "doc",
		"w:body": "body",
		"w:p": "paragraph",
		"w:r": "run",
		"w:t": "text",
		"w:delText": "text",
		"w:br": "lineBreak",
		"w:tbl": "table",
		"w:tr": "tableRow",
		"w:tc": "tableCell",
		"w:drawing": "drawing",
		"w:bookmarkStart": "bookmarkStart",
		"w:sectPr": "sectionProperties",
		"w:rPr": "runProperties",
		"w:commentRangeStart": "commentRangeStart",
		"w:commentRangeEnd": "commentRangeEnd",
		"w:commentReference": "commentReference"
	});
	static markTypes = [
		{
			name: "w:b",
			type: "bold",
			property: "value"
		},
		{
			name: "w:i",
			type: "italic"
		},
		{
			name: "w:u",
			type: "underline",
			mark: "underline",
			property: "underlineType"
		},
		{
			name: "w:strike",
			type: "strike",
			mark: "strike",
			property: "value"
		},
		{
			name: "w:color",
			type: "color",
			mark: "textStyle",
			property: "color"
		},
		{
			name: "w:sz",
			type: "fontSize",
			mark: "textStyle",
			property: "fontSize"
		},
		{
			name: "w:rFonts",
			type: "fontFamily",
			mark: "textStyle",
			property: "fontFamily"
		},
		{
			name: "w:rStyle",
			type: "styleId",
			mark: "textStyle",
			property: "styleId"
		},
		{
			name: "w:jc",
			type: "textAlign",
			mark: "textStyle",
			property: "textAlign"
		},
		{
			name: "w:ind",
			type: "textIndent",
			mark: "textStyle",
			property: "textIndent"
		},
		{
			name: "w:spacing",
			type: "lineHeight",
			mark: "textStyle",
			property: "lineHeight"
		},
		{
			name: "w:spacing",
			type: "letterSpacing",
			mark: "textStyle",
			property: "letterSpacing"
		},
		{
			name: "link",
			type: "link",
			mark: "link",
			property: "href"
		},
		{
			name: "w:highlight",
			type: "highlight",
			mark: "highlight",
			property: "color"
		},
		{
			name: "w:shd",
			type: "highlight",
			mark: "highlight",
			property: "color"
		},
		{
			name: "w:caps",
			type: "textTransform",
			mark: "textStyle",
			property: "textTransform"
		}
	];
	static propertyTypes = Object.freeze({
		"w:pPr": "paragraphProperties",
		"w:rPr": "runProperties",
		"w:sectPr": "sectionProperties",
		"w:numPr": "numberingProperties",
		"w:tcPr": "tableCellProperties"
	});
	static elements = new Set([
		"w:document",
		"w:body",
		"w:p",
		"w:r",
		"w:t",
		"w:delText"
	]);
	static getFontTableEntry(docx, fontName) {
		if (!docx || !fontName) return null;
		const fontTable = docx["word/fontTable.xml"];
		if (!fontTable?.elements?.length) return null;
		const fontsNode = fontTable.elements.find((el) => el.name === "w:fonts");
		if (!fontsNode?.elements?.length) return null;
		return fontsNode.elements.find((el) => el?.attributes?.["w:name"] === fontName) || null;
	}
	static getFallbackFromFontTable(docx, fontName) {
		const family$1 = SuperConverter.getFontTableEntry(docx, fontName)?.elements?.find((child) => child.name === "w:family")?.attributes?.["w:val"];
		if (!family$1) return null;
		return FONT_FAMILY_FALLBACKS[family$1.toLowerCase()] || DEFAULT_GENERIC_FALLBACK;
	}
	static toCssFontFamily(fontName, docx) {
		if (!fontName) return fontName;
		if (fontName.includes(",")) return fontName;
		const fallback = SuperConverter.getFallbackFromFontTable(docx, fontName) || DEFAULT_GENERIC_FALLBACK;
		if (fallback.split(",").map((part) => part.trim().toLowerCase()).filter(Boolean).includes(fontName.trim().toLowerCase())) return fallback;
		return `${fontName}, ${fallback}`;
	}
	constructor(params = null) {
		this.debug = params?.debug || false;
		this.domEnvironment = {
			mockWindow: params?.mockWindow || null,
			mockDocument: params?.mockDocument || null
		};
		this.declaration = null;
		this.documentAttributes = null;
		this.convertedXml = {};
		this.docx = params?.docx || [];
		this.media = params?.media || {};
		this.fonts = params?.fonts || {};
		this.trackedChangesOptions = params?.trackedChangesOptions || null;
		this.wordIdAllocator = null;
		this.addedMedia = {};
		this.comments = [];
		this.footnotes = [];
		this.footnoteProperties = null;
		this.bibliographyPart = createEmptyBibliographyPart();
		this.viewSetting = null;
		this.inlineDocumentFonts = [];
		this.commentThreadingProfile = null;
		this.exportWarnings = [];
		this.docHiglightColors = /* @__PURE__ */ new Set([]);
		this.xml = params?.xml;
		this.declaration = null;
		this.numbering = {};
		this.translatedNumbering = {};
		this.numbering = null;
		this.pageStyles = null;
		this.themeColors = null;
		this.initialJSON = null;
		this.headers = {};
		this.headerIds = {
			default: null,
			even: null,
			odd: null,
			first: null
		};
		this.headerEditors = [];
		this.footers = {};
		this.footerIds = {
			default: null,
			even: null,
			odd: null,
			first: null
		};
		this.footerEditors = [];
		this.importedBodyHasHeaderRef = false;
		this.importedBodyHasFooterRef = false;
		this.headerFooterModified = false;
		this.linkedStyles = [];
		this.translatedLinkedStyles = {};
		this.json = params?.json;
		this.tagsNotInSchema = ["w:body"];
		this.savedTagsToRestore = [];
		this.documentInternalId = null;
		this.fileSource = params?.fileSource || null;
		this.documentId = params?.documentId || null;
		this.documentGuid = null;
		this.documentUniqueIdentifier = null;
		this.documentModified = false;
		this.isBlankDoc = params?.isNewFile || false;
		if (this.docx.length || this.xml) this.parseFromXml();
	}
	get docxHelpers() {
		return DocxHelpers;
	}
	parseFromXml() {
		this.docx?.forEach((file) => {
			this.convertedXml[file.name] = this.parseXmlToJson(file.content);
			if (file.name === "word/document.xml") this.documentAttributes = this.convertedXml[file.name].elements[0]?.attributes;
			if (file.name === "word/styles.xml") this.convertedXml[file.name] = addDefaultStylesIfMissing(this.convertedXml[file.name]);
		});
		if (!this.convertedXml["word/styles.xml"]) {
			for (let i$1 = 1; i$1 <= 5; i$1 += 1) if (this.convertedXml[`word/styles${i$1}.xml`] != null) {
				this.convertedXml["word/styles.xml"] = addDefaultStylesIfMissing(this.convertedXml[`word/styles${i$1}.xml`]);
				break;
			}
		}
		this.initialJSON = this.convertedXml["word/document.xml"];
		if (!this.initialJSON) this.initialJSON = this.parseXmlToJson(this.xml);
		this.declaration = this.initialJSON?.declaration;
		this.resolveDocumentGuid();
	}
	parseXmlToJson(xml) {
		const newXml = xml.replace(/(<w:(?:t|delText)(?:\s[^>]*)?>)(\s+)(<\/w:(?:t|delText)>)/g, "$1[[sdspace]]$2[[sdspace]]$3");
		return JSON.parse(import_lib.xml2json(newXml, null, 2));
	}
	static _matchesElementName(elementName, expectedLocalName) {
		if (!elementName || typeof elementName !== "string") return false;
		if (!expectedLocalName) return false;
		if (elementName === expectedLocalName) return true;
		if (elementName.endsWith(`:${expectedLocalName}`)) return elementName.slice(0, -(expectedLocalName.length + 1)).length > 0;
		return false;
	}
	static _extractNamespacePrefix(elementName) {
		if (!elementName || typeof elementName !== "string") return "";
		const colonIndex = elementName.indexOf(":");
		return colonIndex > 0 ? elementName.slice(0, colonIndex) : "";
	}
	static getStoredCustomProperty(docx, propertyName) {
		try {
			const customXml = docx.find((doc$2) => doc$2.name === "docProps/custom.xml");
			if (!customXml) return null;
			const converter = new SuperConverter();
			const content$2 = customXml.content;
			const properties = converter.parseXmlToJson(content$2)?.elements?.find((el) => SuperConverter._matchesElementName(el.name, "Properties"));
			if (!properties?.elements) return null;
			const property = properties.elements.find((el) => SuperConverter._matchesElementName(el.name, "property") && el.attributes?.name === propertyName);
			if (!property) return null;
			if (!property.elements?.[0]?.elements?.[0]?.text) {
				console.warn(`Malformed property structure for "${propertyName}"`);
				return null;
			}
			return property.elements[0].elements[0].text;
		} catch (e) {
			console.warn(`Error getting custom property ${propertyName}:`, e);
			return null;
		}
	}
	static setStoredCustomProperty(docx, propertyName, value, preserveExisting = false) {
		try {
			const customLocation = "docProps/custom.xml";
			if (!docx[customLocation]) docx[customLocation] = generateCustomXml();
			const properties = docx[customLocation].elements?.find((el) => SuperConverter._matchesElementName(el.name, "Properties"));
			if (!properties) return null;
			if (!properties.elements) properties.elements = [];
			const namespacePrefix = SuperConverter._extractNamespacePrefix(properties.name);
			const propertyElementName = namespacePrefix ? `${namespacePrefix}:property` : "property";
			let property = properties.elements.find((el) => SuperConverter._matchesElementName(el.name, "property") && el.attributes?.name === propertyName);
			if (property && preserveExisting) {
				if (!property.elements?.[0]?.elements?.[0]?.text) {
					console.warn(`Malformed existing property structure for "${propertyName}"`);
					return null;
				}
				return property.elements[0].elements[0].text;
			}
			const finalValue = typeof value === "function" ? value() : value;
			if (!property) {
				const existingPids = properties.elements.filter((el) => el.attributes?.pid).map((el) => parseInt(el.attributes.pid, 10)).filter(Number.isInteger);
				property = {
					type: "element",
					name: propertyElementName,
					attributes: {
						name: propertyName,
						fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
						pid: existingPids.length > 0 ? Math.max(...existingPids) + 1 : 2
					},
					elements: [{
						type: "element",
						name: "vt:lpwstr",
						elements: [{
							type: "text",
							text: finalValue
						}]
					}]
				};
				properties.elements.push(property);
			} else {
				if (SuperConverter._extractNamespacePrefix(property.name) !== namespacePrefix) property.name = propertyElementName;
				if (!property.elements?.[0]?.elements?.[0]) {
					console.warn(`Malformed property structure for "${propertyName}", recreating structure`);
					property.elements = [{
						type: "element",
						name: "vt:lpwstr",
						elements: [{
							type: "text",
							text: finalValue
						}]
					}];
				} else property.elements[0].elements[0].text = finalValue;
			}
			return finalValue;
		} catch (e) {
			console.warn(`Error setting custom property ${propertyName}:`, e);
			return null;
		}
	}
	static getStoredSuperdocVersion(docx) {
		return SuperConverter.getStoredCustomProperty(docx, "SuperdocVersion");
	}
	static setStoredSuperdocVersion(docx = this.convertedXml, version = CURRENT_APP_VERSION) {
		return SuperConverter.setStoredCustomProperty(docx, "SuperdocVersion", version, false);
	}
	static generateWordTimestamp() {
		const date = /* @__PURE__ */ new Date();
		date.setSeconds(0, 0);
		return date.toISOString().split(".")[0] + "Z";
	}
	getDocumentCreatedTimestamp() {
		const coreXml = this.convertedXml["docProps/core.xml"];
		if (!coreXml) return null;
		const coreProps = coreXml.elements?.find((el) => el.name === "cp:coreProperties" || SuperConverter._matchesElementName(el.name, "coreProperties"));
		if (!coreProps?.elements) return null;
		return coreProps.elements.find((el) => el.name === "dcterms:created" || SuperConverter._matchesElementName(el.name, "created"))?.elements?.[0]?.text || null;
	}
	setDocumentCreatedTimestamp(timestamp) {
		const coreXml = this.convertedXml["docProps/core.xml"];
		if (!coreXml) return;
		const coreProps = coreXml.elements?.find((el) => el.name === "cp:coreProperties" || SuperConverter._matchesElementName(el.name, "coreProperties"));
		if (!coreProps) return;
		if (!coreProps.elements) coreProps.elements = [];
		let createdElement = coreProps.elements.find((el) => el.name === "dcterms:created" || SuperConverter._matchesElementName(el.name, "created"));
		if (createdElement?.elements?.[0]) createdElement.elements[0].text = timestamp;
		else {
			createdElement = {
				type: "element",
				name: "dcterms:created",
				attributes: { "xsi:type": "dcterms:W3CDTF" },
				elements: [{
					type: "text",
					text: timestamp
				}]
			};
			coreProps.elements.push(createdElement);
		}
	}
	static extractDocumentGuid(docx) {
		try {
			const settingsXml = docx.find((doc$2) => doc$2.name === "word/settings.xml");
			if (!settingsXml) return null;
			const settings = new SuperConverter().parseXmlToJson(settingsXml.content).elements?.[0];
			if (!settings) return null;
			const docIdElement = settings.elements?.find((el) => el.name === "w15:docId");
			if (docIdElement?.attributes?.["w15:val"]) return docIdElement.attributes["w15:val"].replace(/[{}]/g, "");
		} catch {}
		return SuperConverter.getStoredCustomProperty(docx, "DocumentGuid");
	}
	getDocumentGuid() {
		return this.documentGuid;
	}
	getSuperdocVersion() {
		if (this.docx) return SuperConverter.getStoredSuperdocVersion(this.docx);
		return null;
	}
	resolveDocumentGuid() {
		const microsoftGuid = this.getMicrosoftDocId();
		if (microsoftGuid) this.documentGuid = microsoftGuid;
		else {
			const customGuid = SuperConverter.getStoredCustomProperty(this.docx, "DocumentGuid");
			if (customGuid) this.documentGuid = customGuid;
		}
		if (this.isBlankDoc) this.setDocumentCreatedTimestamp(SuperConverter.generateWordTimestamp());
	}
	getMicrosoftDocId() {
		this.getDocumentInternalId();
		if (this.documentInternalId) return this.documentInternalId.replace(/[{}]/g, "");
		return null;
	}
	#generateIdentifierHash() {
		const combined = `${this.documentGuid}|${this.getDocumentCreatedTimestamp()}`;
		return `HASH-${computeCrc32Hex(new TextEncoder().encode(combined)).toUpperCase()}`;
	}
	async #generateContentHash() {
		if (!this.fileSource) return `HASH-${v4_default().replace(/-/g, "").substring(0, 8).toUpperCase()}`;
		try {
			let data;
			if (ArrayBuffer.isView(this.fileSource)) {
				const view = this.fileSource;
				data = new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
			} else if (this.fileSource instanceof ArrayBuffer) data = new Uint8Array(this.fileSource);
			else if (this.fileSource instanceof Blob || this.fileSource instanceof File) {
				const arrayBuffer = await this.fileSource.arrayBuffer();
				data = new Uint8Array(arrayBuffer);
			} else return `HASH-${v4_default().replace(/-/g, "").substring(0, 8).toUpperCase()}`;
			return `HASH-${computeCrc32Hex(data).toUpperCase()}`;
		} catch (e) {
			console.warn("[super-converter] Could not generate content hash:", e);
			return `HASH-${v4_default().replace(/-/g, "").substring(0, 8).toUpperCase()}`;
		}
	}
	async getDocumentIdentifier() {
		if (this.documentUniqueIdentifier) return this.documentUniqueIdentifier;
		const hasGuid = Boolean(this.documentGuid);
		const hasTimestamp = Boolean(this.getDocumentCreatedTimestamp());
		if (hasGuid && hasTimestamp) this.documentUniqueIdentifier = this.#generateIdentifierHash();
		else {
			if (!hasGuid) this.documentGuid = v4_default();
			if (!hasTimestamp) this.setDocumentCreatedTimestamp(SuperConverter.generateWordTimestamp());
			this.documentModified = true;
			this.documentUniqueIdentifier = await this.#generateContentHash();
		}
		return this.documentUniqueIdentifier;
	}
	promoteToGuid() {
		if (this.documentGuid) return this.documentGuid;
		this.documentGuid = this.getMicrosoftDocId() || v4_default();
		this.documentModified = true;
		this.documentUniqueIdentifier = null;
		return this.documentGuid;
	}
	getDocumentDefaultStyles() {
		const styleElements = (this.convertedXml["word/styles.xml"]?.elements?.[0])?.elements || [];
		if (!styleElements.length) return {};
		const defaults = styleElements.find((el) => el.name === "w:docDefaults");
		const normalStyle = styleElements.find((el) => el.name === "w:style" && el.attributes?.["w:styleId"] === "Normal");
		const defaultsState = {
			typeface: void 0,
			panose: void 0,
			fontSizePt: void 0,
			kern: void 0,
			fallbackSzTwips: void 0
		};
		const docDefaultRun = defaults?.elements?.find((el) => el.name === "w:rPrDefault");
		collectRunDefaultProperties(docDefaultRun?.elements?.find((el) => el.name === "w:rPr") ?? docDefaultRun, {
			allowOverrideTypeface: true,
			allowOverrideSize: true,
			themeResolver: (theme) => this.getThemeInfo(theme),
			state: defaultsState
		});
		collectRunDefaultProperties(normalStyle?.elements?.find((el) => el.name === "w:rPr") ?? null, {
			allowOverrideTypeface: true,
			allowOverrideSize: true,
			themeResolver: (theme) => this.getThemeInfo(theme),
			state: defaultsState
		});
		if (defaultsState.fontSizePt === void 0) if (Number.isFinite(defaultsState.fallbackSzTwips)) defaultsState.fontSizePt = defaultsState.fallbackSzTwips / 2;
		else defaultsState.fontSizePt = DEFAULT_FONT_SIZE_PT;
		const fontFamilyCss = defaultsState.typeface ? SuperConverter.toCssFontFamily(defaultsState.typeface, this.convertedXml) : void 0;
		const result = {};
		if (defaultsState.fontSizePt !== void 0) result.fontSizePt = defaultsState.fontSizePt;
		if (defaultsState.kern !== void 0) result.kern = defaultsState.kern;
		if (defaultsState.typeface) result.typeface = defaultsState.typeface;
		if (defaultsState.panose) result.panose = defaultsState.panose;
		if (fontFamilyCss) result.fontFamilyCss = fontFamilyCss;
		return result;
	}
	getDocumentFonts() {
		const inlineDocumentFonts = [...new Set(this.inlineDocumentFonts || [])];
		const defaults = this.getDocumentDefaultStyles?.() || {};
		const defaultTypeface = typeof defaults.typeface === "string" ? defaults.typeface : null;
		const defaultFontFamilyCss = typeof defaults.fontFamilyCss === "string" ? defaults.fontFamilyCss : null;
		const fallbackFont = defaultTypeface || (defaultFontFamilyCss ? defaultFontFamilyCss.split(",")[0]?.replace(/["']/g, "").trim() : null);
		const withDefaultFont = (fonts) => {
			const result = [...fonts];
			if (fallbackFont && !result.includes(fallbackFont)) result.push(fallbackFont);
			return result;
		};
		const fontTable = this.convertedXml["word/fontTable.xml"];
		if (!fontTable) return withDefaultFont(inlineDocumentFonts);
		const wFonts = fontTable.elements?.find((element) => element.name === "w:fonts");
		if (!wFonts) return withDefaultFont(inlineDocumentFonts);
		if (!wFonts.elements) return withDefaultFont(inlineDocumentFonts);
		const fontsInFontTable = wFonts.elements.filter((element) => element.name === "w:font").map((element) => element.attributes["w:name"]);
		const allFonts = [...inlineDocumentFonts, ...fontsInFontTable];
		return withDefaultFont([...new Set(allFonts)]);
	}
	getFontFaceImportString() {
		const fontTable = this.convertedXml["word/fontTable.xml"];
		if (!fontTable || !Object.keys(this.fonts).length) return;
		const fontsToInclude = (fontTable.elements.find((el) => el.name === "w:fonts")?.elements.filter((el) => el.elements?.some((nested) => nested?.attributes && nested.attributes["r:id"] && nested.attributes["w:fontKey"])))?.reduce((acc, cur) => {
			const embedElements = cur.elements.filter((el) => el.name.startsWith("w:embed"))?.map((el) => ({
				...el,
				fontFamily: cur.attributes["w:name"]
			}));
			return [...acc, ...embedElements];
		}, []);
		const { elements } = this.convertedXml["word/_rels/fontTable.xml.rels"]?.elements.find((el) => el.name === "Relationships") || {};
		const fontsImported = [];
		let styleString = "";
		for (const font of fontsToInclude) {
			const filePath = elements.find((el) => el.attributes.Id === font.attributes["r:id"])?.attributes?.Target;
			if (!filePath) continue;
			const fontUint8Array = this.fonts[`word/${filePath}`];
			if (!fontUint8Array?.buffer) continue;
			const ttfBuffer = deobfuscateFont(fontUint8Array.buffer.slice(fontUint8Array.byteOffset, fontUint8Array.byteOffset + fontUint8Array.byteLength), font.attributes["w:fontKey"]);
			if (!ttfBuffer) continue;
			const policy = parseEmbeddingPolicy(ttfBuffer);
			if (!(policy ? policy.embeddable : false)) continue;
			const blob = new Blob([ttfBuffer], { type: "font/ttf" });
			const fontUrl = URL.createObjectURL(blob);
			const isNormal = font.name.includes("Regular");
			const isBold = font.name.includes("Bold");
			const isItalic = font.name.includes("Italic");
			const isLight = font.name.includes("Light");
			const fontWeight = isNormal ? "normal" : isBold ? "bold" : isLight ? "200" : "normal";
			if (!fontsImported.includes(font.fontFamily)) fontsImported.push(font.fontFamily);
			styleString += `
        @font-face {
          font-style: ${isItalic ? "italic" : "normal"};
          font-weight: ${fontWeight};
          font-display: swap;
          font-family: ${font.fontFamily};
          src: url(${fontUrl}) format('truetype');
        }
      `;
		}
		return {
			styleString,
			fontsImported
		};
	}
	getEmbeddedFontFaces() {
		const fontTable = this.convertedXml["word/fontTable.xml"];
		if (!fontTable || !Object.keys(this.fonts).length) return [];
		const embedElements = ((fontTable.elements?.find((el) => el.name === "w:fonts"))?.elements?.filter((el) => el.elements?.some((nested) => nested?.attributes?.["r:id"] && nested?.attributes?.["w:fontKey"])) ?? []).flatMap((entry) => (entry.elements ?? []).filter((el) => el.name?.startsWith("w:embed")).map((el) => ({
			embed: el,
			family: entry.attributes?.["w:name"]
		})));
		const relElements = this.convertedXml["word/_rels/fontTable.xml.rels"]?.elements?.find((el) => el.name === "Relationships")?.elements ?? [];
		const faceFromEmbedName = (name = "") => ({
			weight: /bold/i.test(name) ? "700" : "400",
			style: /italic/i.test(name) ? "italic" : "normal"
		});
		const faces = [];
		for (const { embed, family: family$1 } of embedElements) {
			const relationshipId = embed.attributes?.["r:id"];
			const fontKey = embed.attributes?.["w:fontKey"];
			if (!family$1 || !relationshipId || !fontKey) continue;
			const filePath = relElements.find((el) => el.attributes?.Id === relationshipId)?.attributes?.Target;
			if (!filePath) continue;
			const fontUint8Array = this.fonts[`word/${filePath}`];
			if (!fontUint8Array?.buffer) continue;
			const ttf = deobfuscateFont(fontUint8Array.buffer.slice(fontUint8Array.byteOffset, fontUint8Array.byteOffset + fontUint8Array.byteLength), fontKey);
			if (!ttf) continue;
			const policy = parseEmbeddingPolicy(ttf);
			const fallback = faceFromEmbedName(embed.name);
			faces.push({
				family: family$1,
				source: ttf,
				weight: policy?.face.weight ?? fallback.weight,
				style: policy?.face.style ?? fallback.style,
				fsType: policy?.fsType ?? null,
				embeddable: policy ? policy.embeddable : false,
				relationshipId
			});
		}
		return faces;
	}
	getDocumentInternalId() {
		const settingsLocation = "word/settings.xml";
		if (!this.convertedXml[settingsLocation]) return;
		const settings = this.convertedXml[settingsLocation];
		if (!settings.elements?.[0]?.elements?.length) return;
		this.documentInternalId = settings.elements[0].elements.find((el) => el.name === "w15:docId")?.attributes?.["w15:val"];
	}
	createDocumentIdElement() {
		const docId = v4_default().toUpperCase();
		this.documentInternalId = docId;
		return {
			type: "element",
			name: "w15:docId",
			attributes: { "w15:val": `{${docId}}` }
		};
	}
	getThemeInfo(themeName) {
		themeName = themeName.toLowerCase();
		const theme1 = this.convertedXml["word/theme/theme1.xml"];
		if (!theme1) return {};
		const fontScheme = theme1.elements.find((el) => el.name === "a:theme").elements.find((el) => el.name === "a:themeElements").elements.find((el) => el.name === "a:fontScheme");
		let fonts;
		if (themeName.startsWith("major")) fonts = fontScheme.elements.find((el) => el.name === "a:majorFont").elements[0];
		else if (themeName.startsWith("minor")) fonts = fontScheme.elements.find((el) => el.name === "a:minorFont").elements[0];
		const { typeface, panose } = fonts.attributes;
		return {
			typeface,
			panose
		};
	}
	getSchema(editor) {
		let result;
		try {
			this.getDocumentInternalId();
			if (!this.convertedXml.media) this.convertedXml.media = this.media;
			result = createDocumentJson(this.convertedXml, this, editor);
		} catch (error) {
			editor?.emit("exception", {
				error,
				editor
			});
		}
		if (result) {
			this.savedTagsToRestore.push({ ...result.savedTagsToRestore });
			this.pageStyles = result.pageStyles;
			this.numbering = result.numbering;
			this.comments = result.comments;
			this.footnotes = result.footnotes;
			this.endnotes = result.endnotes ?? [];
			this.linkedStyles = result.linkedStyles;
			this.translatedLinkedStyles = result.translatedLinkedStyles;
			this.translatedNumbering = result.translatedNumbering;
			this.inlineDocumentFonts = result.inlineDocumentFonts;
			this.themeColors = result.themeColors ?? null;
			this.importDiagnostics = result.importDiagnostics ?? [];
			this.bibliographyPart = loadBibliographyPartFromPackage(this.convertedXml);
			return result.pmDoc;
		} else return null;
	}
	schemaToXml(data, debug = false) {
		return new DocxExporter(this).schemaToXml(data, debug);
	}
	async exportToDocx(jsonData, editorSchema, documentMedia, isFinalDoc = false, commentsExportType, comments = [], editor, exportJsonOnly = false, fieldsHighlightColor, preserveSdtWrappers = false) {
		this.exportWarnings = [];
		const exportableComments = comments.filter((c$1) => !c$1.trackedChange);
		const commentsWithParaIds = exportableComments.map((c$1) => prepareCommentParaIds(c$1));
		const commentDefinitions = commentsWithParaIds.map((c$1, index) => getCommentDefinition(c$1, index, commentsWithParaIds, editor));
		let statFieldCacheMap;
		try {
			if (editor) statFieldCacheMap = refreshAllStatFields(editor);
		} catch {}
		this._currentStatFieldCacheMap = statFieldCacheMap;
		const { result, params } = this.exportToXmlJson({
			data: jsonData,
			editorSchema,
			comments: exportableComments,
			commentDefinitions,
			commentsExportType,
			isFinalDoc,
			editor,
			fieldsHighlightColor,
			preserveSdtWrappers,
			statFieldCacheMap
		});
		const currentDocument = this.convertedXml["word/document.xml"] || {};
		this.convertedXml["word/document.xml"] = {
			...currentDocument,
			...result,
			declaration: result?.declaration ?? currentDocument.declaration
		};
		if (exportJsonOnly) return result;
		const xml = new DocxExporter(this).schemaToXml(result);
		const { updatedXml: footnotesUpdatedXml, relationships: footnotesRels, media: footnotesMedia } = prepareFootnotesXmlForExport({
			footnotes: this.footnotes,
			editor,
			converter: this,
			convertedXml: this.convertedXml
		});
		this.convertedXml = {
			...this.convertedXml,
			...footnotesUpdatedXml
		};
		const { updatedXml: endnotesUpdatedXml, relationships: endnotesRels, media: endnotesMedia } = prepareEndnotesXmlForExport({
			endnotes: this.endnotes,
			editor,
			converter: this,
			convertedXml: this.convertedXml
		});
		this.convertedXml = {
			...this.convertedXml,
			...endnotesUpdatedXml
		};
		await this.#exportProcessMediaFiles({
			...documentMedia,
			...params.media,
			...footnotesMedia,
			...endnotesMedia,
			...this.media
		}, editor);
		const { documentXml, relationships: commentsRels, removedTargets } = this.#prepareCommentsXmlFilesForExport({
			defs: params.exportedCommentDefs,
			exportType: commentsExportType,
			commentsWithParaIds
		});
		const updatedXml = { ...documentXml };
		this.convertedXml = {
			...this.convertedXml,
			...updatedXml
		};
		if (removedTargets?.length) for (const target of removedTargets) {
			const key = target.startsWith("word/") ? target : `word/${target}`;
			delete this.convertedXml[key];
		}
		const headFootRels = this.#exportProcessHeadersFooters({ isFinalDoc });
		this._currentStatFieldCacheMap = void 0;
		this.#exportProcessNewRelationships([
			...params.relationships,
			...commentsRels,
			...footnotesRels,
			...endnotesRels,
			...headFootRels
		]);
		if (removedTargets?.length) this.#pruneCommentRelationships(removedTargets);
		this.bibliographyPart = syncBibliographyPartToPackage(this.convertedXml, this.bibliographyPart);
		SuperConverter.setStoredSuperdocVersion(this.convertedXml);
		const storedDocumentOrigin = STORED_DOCUMENT_ORIGINS.has(this.documentOrigin) ? this.documentOrigin : "superdoc";
		SuperConverter.setStoredCustomProperty(this.convertedXml, SUPERDOC_DOCUMENT_ORIGIN_PROPERTY, storedDocumentOrigin, false);
		if (this.documentModified || this.documentGuid) {
			if (!this.documentGuid) this.documentGuid = this.getMicrosoftDocId() || v4_default();
			SuperConverter.setStoredCustomProperty(this.convertedXml, "DocumentGuid", this.documentGuid, true);
		}
		this.#exportStatFieldMetadata(editor);
		this.#exportNumberingFile(params);
		return xml;
	}
	exportToXmlJson({ data, editorSchema, comments, commentDefinitions, commentsExportType = "clean", isFinalDoc = false, editor, isHeaderFooter = false, fieldsHighlightColor = null, preserveSdtWrappers = false, statFieldCacheMap = void 0, existingRelationships = [], partPath = "word/document.xml" }) {
		const bodyNode = this.savedTagsToRestore.find((el) => el.name === "w:body");
		let resolvedCacheMap = statFieldCacheMap ?? this._currentStatFieldCacheMap;
		if (!resolvedCacheMap) try {
			if (editor) resolvedCacheMap = refreshAllStatFields(editor);
		} catch {}
		const [result, params] = exportSchemaToJson({
			node: data,
			bodyNode,
			relationships: [],
			documentMedia: {},
			media: {},
			isFinalDoc,
			editorSchema,
			converter: this,
			pageStyles: this.pageStyles,
			comments,
			commentsExportType,
			exportedCommentDefs: commentDefinitions,
			editor,
			isHeaderFooter,
			fieldsHighlightColor,
			preserveSdtWrappers,
			statFieldCacheMap: resolvedCacheMap,
			existingRelationships,
			currentPartPath: partPath
		});
		return {
			result,
			params
		};
	}
	getBibliographyPartExportPaths() {
		return getBibliographyPartExportPaths(this.bibliographyPart);
	}
	#exportStatFieldMetadata(editor) {
		if (!editor) return;
		try {
			const stats = getWordStatistics(resolveMainBodyEditor(editor));
			writeAppStatistics(this.convertedXml, stats);
			const settingsPart = this.convertedXml["word/settings.xml"];
			if (settingsPart && stats.pages == null) {
				if (this.#anyPartContainsNodeType("total-page-number", editor)) {
					const settingsRoot = ensureSettingsRoot(settingsPart);
					if (!hasUpdateFields(settingsRoot)) setUpdateFields(settingsRoot, true);
				}
			}
		} catch {}
	}
	#anyPartContainsNodeType(typeName, mainEditor) {
		if (mainEditor && this.#docContainsNodeType(mainEditor.state.doc, typeName)) return true;
		for (const entry of this.headerEditors ?? []) if (entry?.editor && this.#docContainsNodeType(entry.editor.state.doc, typeName)) return true;
		for (const entry of this.footerEditors ?? []) if (entry?.editor && this.#docContainsNodeType(entry.editor.state.doc, typeName)) return true;
		return false;
	}
	#docContainsNodeType(doc$2, typeName) {
		let found$1 = false;
		doc$2.descendants((node) => {
			if (found$1) return false;
			if (node.type.name === typeName) {
				found$1 = true;
				return false;
			}
			return true;
		});
		return found$1;
	}
	#exportNumberingFile() {
		const numberingPath = "word/numbering.xml";
		const sourceHadNumberingXml = Boolean(this.convertedXml[numberingPath]);
		let numberingXml = this.convertedXml[numberingPath];
		if (!numberingXml) numberingXml = baseNumbering;
		const currentNumberingXml = numberingXml.elements[0];
		if (!sourceHadNumberingXml && !hasBodyNumberingReferences(this.convertedXml["word/document.xml"])) return;
		if (this.numbering?.definitions && this.numbering?.abstracts) {
			const abstracts = Object.values(this.numbering.abstracts);
			const definitions = Object.values(this.numbering.definitions);
			currentNumberingXml.elements = [...abstracts, ...definitions];
		} else currentNumberingXml.elements = [];
		this.convertedXml[numberingPath] = numberingXml;
	}
	#prepareCommentsXmlFilesForExport({ defs, exportType, commentsWithParaIds }) {
		const { documentXml, relationships, removedTargets = [], warnings = [] } = prepareCommentsXmlFilesForExport({
			exportType,
			convertedXml: this.convertedXml,
			defs,
			commentsWithParaIds,
			threadingProfile: this.commentThreadingProfile
		});
		if (warnings.length) this.exportWarnings.push(...warnings);
		return {
			documentXml,
			relationships,
			removedTargets
		};
	}
	#exportProcessHeadersFooters({ isFinalDoc = false }) {
		const relationships = this.convertedXml["word/_rels/document.xml.rels"].elements.find((x) => x.name === "Relationships");
		const newDocRels = [];
		Object.entries(this.headers).forEach(([id, header], index) => {
			const partPath = normalizeWordPartPath(relationships.elements.find((el) => el.attributes.Id === id)?.attributes.Target || `header${index + 1}.xml`);
			const relsPath = getWordPartRelsPath(partPath);
			const headerEditor = this.headerEditors.find((item) => item.id === id);
			const existingRelationships = this.convertedXml[relsPath]?.elements?.find((x) => x.name === "Relationships")?.elements || [];
			if (!headerEditor) return;
			const { result, params } = this.exportToXmlJson({
				data: header,
				editor: headerEditor.editor,
				editorSchema: headerEditor.editor.schema,
				comments: [],
				commentDefinitions: [],
				isHeaderFooter: true,
				isFinalDoc,
				existingRelationships,
				partPath
			});
			const bodyContent = result.elements[0].elements;
			if (!this.convertedXml[partPath]) {
				this.convertedXml[partPath] = {
					declaration: this.initialJSON?.declaration,
					elements: [{
						attributes: DEFAULT_DOCX_DEFS,
						name: "w:hdr",
						type: "element",
						elements: []
					}]
				};
				newDocRels.push({
					type: "element",
					name: "Relationship",
					attributes: {
						Id: id,
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header",
						Target: partPath.replace(/^word\//, "")
					}
				});
			}
			this.convertedXml[partPath].elements[0].elements = bodyContent;
			if (params.relationships.length) this.convertedXml[relsPath] = {
				declaration: this.initialJSON?.declaration,
				elements: [{
					name: "Relationships",
					attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
					elements: mergeRelationshipElements(existingRelationships, params.relationships)
				}]
			};
		});
		Object.entries(this.footers).forEach(([id, footer], index) => {
			const partPath = normalizeWordPartPath(relationships.elements.find((el) => el.attributes.Id === id)?.attributes.Target || `footer${index + 1}.xml`);
			const relsPath = getWordPartRelsPath(partPath);
			const footerEditor = this.footerEditors.find((item) => item.id === id);
			const existingRelationships = this.convertedXml[relsPath]?.elements?.find((x) => x.name === "Relationships")?.elements || [];
			if (!footerEditor) return;
			const { result, params } = this.exportToXmlJson({
				data: footer,
				editor: footerEditor.editor,
				editorSchema: footerEditor.editor.schema,
				comments: [],
				commentDefinitions: [],
				isHeaderFooter: true,
				isFinalDoc,
				existingRelationships,
				partPath
			});
			const bodyContent = result.elements[0].elements;
			if (!this.convertedXml[partPath]) {
				this.convertedXml[partPath] = {
					declaration: this.initialJSON?.declaration,
					elements: [{
						attributes: DEFAULT_DOCX_DEFS,
						name: "w:ftr",
						type: "element",
						elements: []
					}]
				};
				newDocRels.push({
					type: "element",
					name: "Relationship",
					attributes: {
						Id: id,
						Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer",
						Target: partPath.replace(/^word\//, "")
					}
				});
			}
			this.convertedXml[partPath].elements[0].elements = bodyContent;
			if (params.relationships.length) this.convertedXml[relsPath] = {
				declaration: this.initialJSON?.declaration,
				elements: [{
					name: "Relationships",
					attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
					elements: mergeRelationshipElements(existingRelationships, params.relationships)
				}]
			};
		});
		return newDocRels;
	}
	#exportProcessNewRelationships(rels = []) {
		const relationships = this.convertedXml["word/_rels/document.xml.rels"].elements.find((x) => x.name === "Relationships");
		relationships.elements = mergeRelationshipElements(relationships.elements, rels);
	}
	#pruneCommentRelationships(removedTargets) {
		const relationships = this.convertedXml["word/_rels/document.xml.rels"].elements.find((x) => x.name === "Relationships");
		if (!relationships?.elements) return;
		const normalizeTarget$1 = (target) => {
			if (!target) return "";
			return target.replace(/^\.\//, "").replace(/^\//, "").replace(/^word\//, "");
		};
		const removedSet = new Set(removedTargets.map(normalizeTarget$1));
		relationships.elements = relationships.elements.filter((rel) => {
			const type = rel.attributes?.Type;
			const target = normalizeTarget$1(rel.attributes?.Target);
			if (COMMENT_RELATIONSHIP_TYPES.has(type) && removedSet.has(target)) return false;
			return true;
		});
	}
	async #exportProcessMediaFiles(media = {}) {
		const processedData = { ...this.convertedXml.media || {} };
		for (const [filePath, value] of Object.entries(media)) {
			if (value == null) continue;
			processedData[filePath] = await getArrayBufferFromUrl(value);
		}
		this.convertedXml.media = processedData;
		this.media = this.convertedXml.media;
		this.addedMedia = { ...processedData };
	}
	reimportHeaderFooterPart(partId) {
		const xmlJson = this.convertedXml?.[partId];
		if (!xmlJson?.elements?.[0]?.elements) return null;
		const { processedNodes } = preProcessPageFieldsOnly(carbonCopy(xmlJson.elements[0].elements));
		const nodeListHandler = defaultNodeListHandler();
		let schema = nodeListHandler.handler({
			nodes: processedNodes,
			nodeListHandler,
			docx: this.convertedXml,
			converter: this,
			numbering: this.numbering,
			translatedNumbering: this.translatedNumbering,
			translatedLinkedStyles: this.translatedLinkedStyles,
			editor: {},
			filename: partId.split("/").pop(),
			path: []
		});
		schema = filterOutRootInlineNodes(schema);
		schema = normalizeDuplicateBlockIdentitiesInContent(schema);
		return {
			type: "doc",
			content: [...schema]
		};
	}
	reimportNotePart(partId) {
		if (!this.convertedXml?.[partId]) return [];
		return (partId === "word/endnotes.xml" ? importEndnoteData : importFootnoteData)({
			docx: this.convertedXml,
			editor: {},
			converter: this,
			numbering: this.numbering
		});
	}
	static getStoredSuperdocId(docx) {
		console.warn("getStoredSuperdocId is deprecated, use getDocumentGuid instead");
		return SuperConverter.extractDocumentGuid(docx);
	}
	static updateDocumentVersion(docx, version) {
		console.warn("updateDocumentVersion is deprecated, use setStoredSuperdocVersion instead");
		return SuperConverter.setStoredSuperdocVersion(docx, version);
	}
};
function generateCustomXml() {
	return DEFAULT_CUSTOM_XML;
}
function hasBodyNumberingReferences(documentXml) {
	if (!documentXml || typeof documentXml !== "object") return false;
	const stack = Array.isArray(documentXml.elements) ? [...documentXml.elements] : [];
	while (stack.length) {
		const node = stack.pop();
		if (!node || typeof node !== "object") continue;
		if (node.name === "w:numPr") return true;
		if (Array.isArray(node.elements)) stack.push(...node.elements);
	}
	return false;
}
export { splitProjectedTrackedChangeId as $, extractTableInfo as $a, storyLocatorToKey as $c, bodySectPrShouldEmbed as $i, resolveTextTarget as $n, Selection as $o, buildDocumentFontOptions as $r, resolveColumnMode as $s, hasOddEvenHeadersFooters as $t, buildTarget as A, hasPart as Aa, TrackDeleteMarkName as Ac, translator$61 as Ai, readSectPrMargins as An, DecorationSet as Ao, resolveCommentIdFromAttrs as Ar, formatPageNumber as As, applyTrackedMutationMeta as At, updateSdtPrSubElementAttr as B, undoDepth as Ba, buildStructuralReceipt as Bc, processContent as Bi, writeSectPrPageMargins as Bn, findParentNodeClosestToPos as Bo, formatFootnoteCardinal as Br, namedStoryLocator as Bs, resolveEffectiveRef as Bt, buildMutationFailure as C, getRevision as Ca, OOXML_PCT_DIVISOR as Cc, groupIdentityEntriesByValue as Ci, clearSectPrHeaderFooterRef as Cn, tableEditing as Co, mapBlockNodeType as Cr, isKnownTableStyleId as Cs, normalizeVariant as Ct, assertNotSdtLocked as D, PlanError as Da, calculateTabWidth as Dc, registeredHandlers as Di, ensureSectPrElement as Dn, keydownHandler as Do, buildFallbackBlockNodeId as Dr, buildPageRefAnchorMap as Ds, rejectTrackedMode as Dt, assertNotContentLocked as E, trackRevisions as Ea, getTableVisualDirection as Ec, kebabCase as Ei, createSectPrElement as En, toggleHeaderCell as Eo, toBlockAddress as Er, engines_exports as Es, ensureTrackedCapability as Et, applyAttrsUpdate as F, closeHistory as Fa, generateRandomSigned32BitIntStrId as Fc, sequenceFieldAttrsFromParsed as Fi, writeSectPrColumns as Fn, getSchemaTypeNameByName as Fo, findInlineByAnchor as Fr, getSdtContainerMetadata as Fs, resolveRIdFromRelsData as Ft, isSdtNode as G, getActiveFormatting as Ga, isPublicMutationStepOp as Gc, createDocFromHTML as Gi, addDiagnostic as Gn, getSchemaTypeByName as Go, FlowBlockCache as Gr, getColumnAtX as Gs, registerStaticInvalidationHandlers as Gt, SDT_BLOCK_NAME as H, isInTable as Ha, derivePropertyStateFromDirect as Hc, markdownToPmDoc as Hi, writeSectPrPageSetup as Hn, getMarkType as Ho, resolveParagraphHeadingLevel as Hr, resolveAnchoredGraphicY as Hs, setLinkedToPreviousMutation as Ht, findSdtPrChild as I, history as Ia, createDocumentApi as Ic, helpers_exports as Ii, writeSectPrDirection as In, isMarkActive as Io, findInlineByType as Ir, hasExplicitSdtContainerKey as Is, SOURCE_HEADER_FOOTER_LOCAL as It, getTrackedChangeMarkAlias as J, getMarksFromSelection as Ja, OPERATION_IDS as Jc, htmlHandler as Ji, insertParagraphAtEnd as Jn, AllSelection as Jo, createStoryEditor as Jr, getColumnWidth as Js, getProtectionStorage as Jt, resolveSdtByTarget as K, findMark as Ka, PROPERTY_REGISTRY as Kc, InputRule as Ki, dedupeDiagnostics as Kn, createDocument as Ko, SequenceFieldEvaluator as Kr, getColumnGeometry as Ks, applyEffectiveEditability as Kt, removeSdtPrChild as L, redo as La, DEFAULT_PROTECTION_STATE as Lc, getViewModeSelectionWithoutStructuredContent as Li, writeSectPrHeaderFooterMargins as Ln, getMarkRange as Lo, isInlineQueryType as Lr, composeAuthorColorResolver as Ls, ensureHeaderFooterDescriptor as Lt, readChoiceListData as M, yCursorPluginKey as Ma, TrackInsertMarkName as Mc, isSeqInstruction as Mi, readSectPrTitlePage as Mn, __endComposition as Mo, toId as Mr, formatSectionPageNumberText as Ms, registerExistingHeaderFooterDescriptors as Mt, resolveBinding as N, ySyncPluginKey as Na, TrackedFormatMarkNames as Nc, normalizeSeqIdentifier as Ni, setSectPrHeaderFooterRef as Nn, isActive as No, toNonEmptyString as Nr, getSdtContainerKey as Ns, resolveHeaderFooterRId as Nt, buildContentControlInfoFromAttrs as O, planError as Oa, computeTabStops as Oc, translator$146 as Oi, getSectPrHeaderFooterRef as On, keymap as Oo, resolvePublicTocNodeId as Or, formatChapterPageNumberText as Os, requireEditorCommand as Ot, resolveControlType as P, yUndoPluginKey as Pa, generateDocxRandomId as Pc, parseSeqInstruction as Pi, writeSectPrBreakType as Pn, isNodeActive as Po, buildInlineIndex as Pr, getSdtContainerKeyForBlock as Ps, resolveHeaderFooterRelsPartIdFromRefId as Pt, resolveTrackedChangeType as Q, calculateInlineRunPropertiesPlugin as Qa, isStoryLocator as Qc, SUPERDOC_MEDIA_MIME as Qi, resolveInlineInsertPosition as Qn, PluginKey as Qo, parseStoryKey as Qr, resolveColumnLayout as Qs, ensureSettingsRoot as Qt, replaceSdtPrSubElements as R, redoDepth as Ra, isStructuralReplaceInput as Rc, isStructuredContentNodeType as Ri, writeSectPrLineNumbering as Rn, isTextSelection as Ro, CommentMarkName as Rr, LAYOUT_BOUNDARY_SCHEMA as Rs, isHeaderFooterPartId as Rt, applyPagination as S, checkRevision as Sa, effectiveTableCellSpacing as Sc, getExplicitIdentityEntries as Si, getExtensionConfigField as Sl, sectionsListAdapter as Sn, splitCell as So, isTextBlockCandidate as Sr, TABLE_FALLBACK_CELL_PADDING as Ss, ensureExplicitHeaderFooterSlot as St, assertControlType as T, initRevision as Ta, getParagraphInlineDirection as Tc, getListRendering as Ti, cloneXmlElement as Tn, toggleHeader as To, resolveBlockNodeId as Tr, EMPTY_SDT_PLACEHOLDER_TEXT as Ts, sectionMutationBySectPr as Tt, SDT_INLINE_NAME as U, posToDOMRect as Ua, CAPABILITY_REASON_CODES as Uc, markdownToPmFragment as Ui, writeSectPrTitlePage as Un, getNodeType as Uo, twipsToPixels as Ur, cloneColumnLayout as Us, createHeaderFooterPart as Ut, upsertSdtPrChild as V, CommandService as Va, textReceiptToSDReceipt as Vc, createDocFromMarkdown as Vi, writeSectPrPageNumbering as Vn, defaultBlockAt as Vo, getPageNumberFieldFormat as Vr, resolveAnchoredGraphicX as Vs, setHeaderFooterRefMutation as Vt, findAllSdtNodes as W, findChildren$1 as Wa, PUBLIC_MUTATION_STEP_OP_IDS as Wc, readImageDimensionsFromDataUri as Wi, writeSectPrVerticalAlign as Wn, cleanSchemaItem as Wo, toCssFontFamily as Wr, columnRenderLayoutsEqual as Ws, getWordPartRelsPath as Wt, resolveTrackedChange as X, normalizeRunProperties as Xa, INLINE_PROPERTY_KEY_SET as Xc, annotateFragmentDomWithClipboardData as Xi, resolveBlockCreatePosition as Xn, NodeSelection as Xo, BODY_STORY_KEY as Xr, normalizeColumnLayout as Xs, SETTINGS_PART_PATH as Xt, groupTrackedChanges as Y, getSelectionFormattingState as Ya, INLINE_PROPERTY_BY_KEY as Yc, inputRulesPlugin as Yi, paginate as Yn, EditorState as Yo, DocumentApiAdapterError as Yr, getColumnX as Ys, isReadOnlyProtectionRuntimeEnforced as Yt, resolveTrackedChangeInStory as Z, TRANSIENT_HYPERLINK_STYLE_IDS as Za, INLINE_PROPERTY_REGISTRY as Zc, mergeSerializedClipboardMetadataIntoDomContainer as Zi, resolveDefaultInsertTarget as Zn, Plugin as Zo, buildStoryKey as Zr, resolveColumnCount as Zs, clearDocumentProtectionEnforcement as Zt, getContiguousSequence as _, findOrCreateRelationship as _a, normalizeZIndex as _c, translateStyleDefinitions as _i, Fragment as _l, readTargetSectPr as _n, goToNextCell as _o, findBlockById as _r, encodeCSSFromRPr as _s, footnotesPartDescriptor as _t, resolveMainBodyEditor as a, ListHelpers as aa, sliceRunsForLine as ac, DEFAULT_FONT_LOAD_TIMEOUT_MS as ai, SNIPPET_CONTEXT_CHARS as al, readEndnotePosition as an, resolveHypotheticalParagraphProperties as ao, readTextAtResolvedRange as ar, ReplaceStep as as, findMarkPosition as at, resolveBlock as b, mutatePart as ba, resolveEffectiveHeaderFooterRef as bc, isDecimalWordId as bi, minMax as bl, resolveSectionProjections as bn, selectedRect as bo, findBlockByPos as br, resolveRunProperties as bs, removeNoteElement as bt, listListItems as c, rebuildRawNumberingFromTranslated as ca, resolveBaseFontSizeForVerticalText as cc, buildFontReport as ci, MAX_PLAN_STEPS as cl, readFootnoteNumberStart as cn, addColumnAfter as co, textBetweenWithTabs as cr, canSplit as cs, resolveStoryRuntime as ct, evaluateCanContinuePrevious as d, removeLvlOverride as da, SPACE_CHARS as dc, getFontConfigVersion as di, DELETABLE_BLOCK_NODE_TYPES as dl, readSettingsRoot as dn, columnResizing as do, resolveTextRangeInBlock as dr, liftTarget as ds, resolveLiveStorySessionRuntime as dt, collectReferencedImageMediaForClipboard as ea, computeFragmentPmRange as ec, buildFontFamilyOptions as ei, DEFAULT_NESTING_POLICY as el, parseProtectionState as en, clampRange as eo, resolveWithinScope as er, TextSelection as es, projectInternalTrackChangeType as et, evaluateCanJoin as f, changeListLevel as fa, adjustAvailableWidthForTextIndent as fc, DEFAULT_FONT_MEASURE_CONTEXT as fi, DocumentApiValidationError as fl, removeDefaultTableStyle as fn, deleteColumn as fo, textContentInBlock as fr, replaceStep as fs, initStoryRevisionStore as ft, getAllListItemProjections as g, generateOrderedListIndex as ga, getFragmentZIndex as gc, resolveEvenAndOddHeadersFromSettingsPart as gi, DOMSerializer as gl, compoundMutation as gn, fixTables as go, buildBlockIndex as gr, encodeCSSFromPPr as gs, endnotesPartDescriptor as gt, getAbstractNumId as h, docxNumberingHelpers as ha, shouldApplyJustify as hc, resolvePhysicalFamily as hi, DOMParser$1 as hl, setOddEvenHeadersFooters as hn, findTable as ho, getInlineIndex as hr, decodeRPrFromMarks as hs, bootstrapNotesPart as ht, resolveDocumentStatFieldValue as i, unflattenListsInHtml as ia, isEmptySdtPlaceholderRun as ic, getDefaultFontFamilyOptions as ii, buildResolvedHandle as il, readEndnoteNumberStart as in, getResolvedParagraphProperties as io, buildTextMutationResolution as ir, ReplaceAroundStep as is, findInlineNodes as it, readCheckboxChecked as j, registerPartDescriptor as ja, TrackFormatMarkName as jc, parseXmlToJson as ji, readSectPrPageSetup as jn, EditorView as jo, toFiniteNumber as jr, formatPageNumberFieldValue as js, exportSubEditorToPart as jt, buildContentControlInfoFromNode as k, getPart as ka, getUnderlineCssString as kc, translator$94 as ki, readSectPrHeaderFooterRefs as kn, Decoration as ko, normalizeExcerpt as kr, formatIntegerWithNumericPicture as ks, applyDirectMutationMeta as kt, resolveListItem as l, numberingPartDescriptor as la, formatInsetClipPathTransform as lc, installBundledSubstitutes as li, MARK_KEYS as ll, readFootnotePosition as ln, addColumnBefore as lo, computeTextContentLength as lr, dropPoint as ls, commitLiveStorySessionRuntimes as lt, findPreviousCompatibleSequence as m, isList as ma, getFirstLineIndentOffset as mc, resolveFontFamily as mi, simpleStringHash as ml, setDocumentProtection as mn, deleteTable as mo, getBlockIndex as mr, isLegacySchemaDefaultBorders as ms, addNoteElement as mt, hasBodyNumberingReferences as n, getSectPrMargins as na, expandRunsForInlineNewlines as nc, fontOfferingStack as ni, buildDiscoveryItem as nl, readEndnoteNumberFormat as nn, mergeRanges as no, scopeByRange as nr, Mapping as ns, getTrackChanges as nt, getLiveDocumentCounts as o, markerTextToBulletStyle as oa, SUBSCRIPT_SUPERSCRIPT_SCALE as oc, getFontRegistryFor as oi, SNIPPET_MAX_LENGTH as ol, readFootnoteNumberFormat as on, CellSelection as oo, buildTextWithTabs as or, Transform as os, getTextAdapter as ot, findAdjacentSequence as p, updateNumberingProperties as pa, calculateJustifySpacing as pc, createFontResolver as pi, DEFAULT_DOCX_DEFS as pl, setDefaultTableStyle as pn, deleteRow as po, clearIndexCache as pr, convertBordersToOoxmlFormat as ps, normalizeNotePmJson as pt, buildTrackedChangeCanonicalIdMap as q, getFormattingStateAtPos as qa, COMMAND_CATALOG as qc, handleClipboardPaste as qi, findCandidateByPos as qn, parsePageNumberFieldSwitches as qo, process$1 as qr, getColumnSeparatorPositions as qs, buildAllowedIdentifierSetFromEditor as qt, getWordStatistics as r, updateSectionMargins as ra, isEmptyInlineSdtPlaceholderRun as rc, getBuiltInToolbarFontOfferings as ri, buildDiscoveryResult as rl, readEndnoteNumberRestart as rn, calculateResolvedParagraphProperties as ro, validatePaginationInput as rr, RemoveMarkStep as rs, documentHelpers_exports as rt, listItemProjectionToInfo as s, numberingInfoToOrderedStyle as sa, normalizeBaselineShift as sc, buildFaceReport as si, MAX_PLAN_RESOLVED_TARGETS as sl, readFootnoteNumberRestart as sn, TableMap as so, parentAllowsNodeAt as sr, canJoin as ss, getStoryRuntimeCache as st, SuperConverter as t, embedSliceInHtml as ta, computeLinePmRange as tc, fontOfferingRenderStack as ti, DEFAULT_PLACEMENT as tl, readDefaultTableStyle as tn, collectChangedRangesThroughTransactions as to, resolveWriteTarget as tr, AddMarkStep as ts, enumerateStructuralRowChanges as tt, computeSequenceId as u, syncNumberingToXmlTree as ua, parseInsetClipPathForScale as uc, bumpFontConfigVersion as ui, SELECTION_EDGE_NODE_TYPES as ul, readSectionNoteConfigs as un, cellAround as uo, pmPositionToTextOffset as ur, joinPoint as us, registerLiveStorySessionRuntime as ut, getSequenceFromTarget as v, createRelationshipsPart as va, getCellSpacingPx as vc, TRACKED_CHANGE_SOURCE_ID_MAP_PROPERTY as vi, Schema as vl, getBodySectPrFromEditor as vn, inSameTable as vo, findBlockByIdStrict as vr, encodeMarksFromRPr as vs, getNoteElements as vt, buildMutationSuccess as w, incrementRevision as wa, resolveTableWidthAttr as wc, getListOrdinalFromPath as wi, clearSectPrPageBorders as wn, tableNodeTypes as wo, resolveBlockAlias as wr, resolvePreferredNewTableStyleId as ws, applySectPrToProjection as wt, resolveBlocksInRange as x, mutateParts as xa, selectHeaderFooterVariantForPage as xc, createDeterministicDocxIdAllocator as xi, callOrGet as xl, sectionsGetAdapter as xn, setCellAttr as xo, getHeadingLevel as xr, TABLE_FALLBACK_BORDERS as xs, updateNoteElement as xt, isFirstInSequence as y, getRelationshipsRoot as ya, rescaleColumnWidths as yc, createWordIdAllocator as yi, Slice as yl, getDefaultSectionAddress as yn, mergeCells as yo, findBlockByNodeIdOnly as yr, DEFAULT_TBL_LOOK as ys, getNotesConfig as yt, updateSdtPrChild as z, undo as za, isStructuralInsertInput as zc, updateDOMAttributes as zi, writeSectPrPageBorders as zn, findParentNode as zo, toFlowBlocks as zr, buildLayoutSourceIdentityForFragment as zs, clearHeaderFooterRefMutation as zt };
